/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 618);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
//! version : 2.18.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    var k;
    for (k in obj) {
        // even if its not own property I'd still call it non-empty
        return false;
    }
    return true;
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

var some$1 = some;

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var keys$1 = keys;

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid()) {
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

var indexOf$1 = indexOf;

function daysInMonth(year, month) {
    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf$1.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            __webpack_require__(924)("./" + name);
            // because defineLocale currently also sets the global locale, we
            // want to undo that for lazy loaded locales
            getSetGlobalLocale(oldLocale);
        } catch (e) { }
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, parentConfig = baseConfig;
        // MERGE
        if (locales[name] != null) {
            parentConfig = locales[name]._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys$1(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var basicRfcRegex = /^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d?\d\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(?:\d\d)?\d\d\s)(\d\d:\d\d)(\:\d\d)?(\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\d{4}))$/;

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var string, match, dayFormat,
        dateFormat, timeFormat, tzFormat;
    var timezones = {
        ' GMT': ' +0000',
        ' EDT': ' -0400',
        ' EST': ' -0500',
        ' CDT': ' -0500',
        ' CST': ' -0600',
        ' MDT': ' -0600',
        ' MST': ' -0700',
        ' PDT': ' -0700',
        ' PST': ' -0800'
    };
    var military = 'YXWVUTSRQPONZABCDEFGHIKLM';
    var timezone, timezoneIndex;

    string = config._i
        .replace(/\([^\)]*\)|[\n\t]/g, ' ') // Remove comments and folding whitespace
        .replace(/(\s\s+)/g, ' ') // Replace multiple-spaces with a single space
        .replace(/^\s|\s$/g, ''); // Remove leading and trailing spaces
    match = basicRfcRegex.exec(string);

    if (match) {
        dayFormat = match[1] ? 'ddd' + ((match[1].length === 5) ? ', ' : ' ') : '';
        dateFormat = 'D MMM ' + ((match[2].length > 10) ? 'YYYY ' : 'YY ');
        timeFormat = 'HH:mm' + (match[4] ? ':ss' : '');

        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        if (match[1]) { // day of week given
            var momentDate = new Date(match[2]);
            var momentDay = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][momentDate.getDay()];

            if (match[1].substr(0,3) !== momentDay) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return;
            }
        }

        switch (match[5].length) {
            case 2: // military
                if (timezoneIndex === 0) {
                    timezone = ' +0000';
                } else {
                    timezoneIndex = military.indexOf(match[5][1].toUpperCase()) - 12;
                    timezone = ((timezoneIndex < 0) ? ' -' : ' +') +
                        (('' + timezoneIndex).replace(/^-?/, '0')).match(/..$/)[0] + '00';
                }
                break;
            case 4: // Zone
                timezone = timezones[match[5]];
                break;
            default: // UT or +/-9999
                timezone = timezones[' GMT'];
        }
        match[5] = timezone;
        config._i = match.splice(1).join('');
        tzFormat = ' ZZ';
        config._f = dayFormat + dateFormat + timeFormat + tzFormat;
        configFromStringAndFormat(config);
        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(ordering.indexOf(key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    if (units === 'year' || units === 'month' || units === 'quarter') {
        output = monthDiff(this, that);
        if (units === 'quarter') {
            output = output / 3;
        } else if (units === 'year') {
            output = output / 12;
        }
    } else {
        delta = this - that;
        output = units === 'second' ? delta / 1e3 : // 1000
            units === 'minute' ? delta / 6e4 : // 1000 * 60
            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
            delta;
    }
    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString() {
    if (!this.isValid()) {
        return null;
    }
    var m = this.clone().utc();
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        return this.toDate().toISOString();
    }
    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0], 10);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds;
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    return (total < 0 ? '-' : '') +
        'P' +
        (Y ? Y + 'Y' : '') +
        (M ? M + 'M' : '') +
        (D ? D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? h + 'H' : '') +
        (m ? m + 'M' : '') +
        (s ? s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.18.1';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(281)(module)))

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var core = __webpack_require__(45);
var hide = __webpack_require__(33);
var redefine = __webpack_require__(34);
var ctx = __webpack_require__(46);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(822);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate (y) {
        var date;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            var args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays (ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays :
            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
            : (m) ? weekdays[m.day()] : weekdays;
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                __webpack_require__(953)("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    var MS_PER_SECOND = 1000;
    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':   return months;
                case 'quarter': return months / 3;
                case 'year':    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asQuarters     = makeAs('Q');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asQuarters     = asQuarters;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.24.0';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(281)(module)))

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Trans__ = __webpack_require__(844);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Trans", function() { return __WEBPACK_IMPORTED_MODULE_0__Trans__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__useTranslation__ = __webpack_require__(188);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useTranslation", function() { return __WEBPACK_IMPORTED_MODULE_1__useTranslation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__withTranslation__ = __webpack_require__(857);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withTranslation", function() { return __WEBPACK_IMPORTED_MODULE_2__withTranslation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Translation__ = __webpack_require__(858);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Translation", function() { return __WEBPACK_IMPORTED_MODULE_3__Translation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__I18nextProvider__ = __webpack_require__(859);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I18nextProvider", function() { return __WEBPACK_IMPORTED_MODULE_4__I18nextProvider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__withSSR__ = __webpack_require__(860);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withSSR", function() { return __WEBPACK_IMPORTED_MODULE_5__withSSR__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__useSSR__ = __webpack_require__(264);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useSSR", function() { return __WEBPACK_IMPORTED_MODULE_6__useSSR__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__context__ = __webpack_require__(95);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I18nContext", function() { return __WEBPACK_IMPORTED_MODULE_7__context__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "initReactI18next", function() { return __WEBPACK_IMPORTED_MODULE_7__context__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setDefaults", function() { return __WEBPACK_IMPORTED_MODULE_7__context__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getDefaults", function() { return __WEBPACK_IMPORTED_MODULE_7__context__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setI18n", function() { return __WEBPACK_IMPORTED_MODULE_7__context__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getI18n", function() { return __WEBPACK_IMPORTED_MODULE_7__context__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "composeInitialProps", function() { return __WEBPACK_IMPORTED_MODULE_7__context__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getInitialProps", function() { return __WEBPACK_IMPORTED_MODULE_7__context__["g"]; });









/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(874);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(870)();
}


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 8 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contattiFirma = exports.ditta = exports.indirizzoOggetto = exports.nomeCompleto = exports.indirizzoCompleto = exports.formattaData = exports.generaToken = exports.riordinaImmagini = exports.visualizzaDecimaleConVirgola = exports.formattaPrezzo = exports.trasformaInNumero = undefined;

var _numeral = __webpack_require__(147);

var _numeral2 = _interopRequireDefault(_numeral);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _axios = __webpack_require__(67);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_moment2.default.locale('de');

// load a locale
_numeral2.default.register('locale', 'de', {
  delimiters: {
    thousands: '.',
    decimal: ','
  },
  abbreviations: {
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't'
  },
  ordinal: function ordinal(number) {
    return number === 1 ? 'er' : '°';
  },
  currency: {
    symbol: '€'
  }
});
// switch between locales
_numeral2.default.locale('de');

var trasformaInNumero = exports.trasformaInNumero = function trasformaInNumero(valore, nonMoltiplicarePerCento) {
  var perCento = nonMoltiplicarePerCento ? 1 : 100;
  return valore ? parseFloat(valore.replace(/,/, '.'), 10) * perCento : 0;
};

var formattaPrezzo = exports.formattaPrezzo = function formattaPrezzo(valore, isEuro, nonDividerePerCento, isPercent) {
  var risultato = '';
  valore = nonDividerePerCento ? valore : valore / 100;
  if (isEuro) {
    risultato = (0, _numeral2.default)(valore).format('0,0[.]00 $');
  } else if (isPercent) {
    risultato = (0, _numeral2.default)(valore).format('0.00%');
  } else {
    risultato = (0, _numeral2.default)(valore).format('0,0[.]00');
  }
  return risultato;
};

var visualizzaDecimaleConVirgola = exports.visualizzaDecimaleConVirgola = function visualizzaDecimaleConVirgola(valore) {
  return (valore / 100).toString().replace(/\./, ',');
};

var riordinaImmagini = exports.riordinaImmagini = function riordinaImmagini(array, from, to) {
  return array.splice(to, 0, array.splice(from, 1)[0]);
};

var generaToken = exports.generaToken = function generaToken() {
  _axios2.default.post("https://www.m2square.eu" + '/wp-json/jwt-auth/v1/token', {
    username: '' + "Ralph2",
    password: '' + "m3cUBem33!"
  }).then(function (res) {
    return localStorage.setItem('token', res.data.token);
  });
};

var formattaData = exports.formattaData = function formattaData(data) {
  return (0, _moment2.default)(data).format('DD.MM.YYYY');
};

var indirizzoCompleto = exports.indirizzoCompleto = function indirizzoCompleto(contatto) {
  return contatto && contatto.indirizzo + ', ' + contatto.cap + ' ' + contatto.comune + (contatto.nazione && ', ' + contatto.nazione);
};
var nomeCompleto = exports.nomeCompleto = function nomeCompleto(contatto) {
  return contatto && contatto.titolo + ' ' + contatto.nome + ' ' + contatto.cognome;
};

var indirizzoOggetto = exports.indirizzoOggetto = function indirizzoOggetto(oggetto) {
  return oggetto.via + ' ' + oggetto.numeroCivico + (oggetto.numeroAppartamento && ', ' + (oggetto.tipologia ? oggetto.tipologia === 'Eigentumswohnung' || oggetto.tipologia === 'property_apt' ? 'WE' : 'TE' : 'WE') + ' ' + oggetto.numeroAppartamento) + ', ' + oggetto.cap + ' ' + oggetto.citta;
};

var ditta = exports.ditta = function ditta(contatto) {
  return contatto && '' + (contatto.ditta && '' + contatto.ditta);
};

var contattiFirma = exports.contattiFirma = function contattiFirma(firma) {
  return firma.name + ' ' + (firma.name2 && ' - ' + firma.name2) + '\n' + firma.adresse + ', ' + firma.plz + ' ' + firma.stadt;
};

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = {
  DISPLAY_FORMAT: 'L',
  ISO_FORMAT: 'YYYY-MM-DD',
  ISO_MONTH_FORMAT: 'YYYY-MM',

  START_DATE: 'startDate',
  END_DATE: 'endDate',

  HORIZONTAL_ORIENTATION: 'horizontal',
  VERTICAL_ORIENTATION: 'vertical',
  VERTICAL_SCROLLABLE: 'verticalScrollable',

  ICON_BEFORE_POSITION: 'before',
  ICON_AFTER_POSITION: 'after',

  ANCHOR_LEFT: 'left',
  ANCHOR_RIGHT: 'right',

  OPEN_DOWN: 'down',
  OPEN_UP: 'up',

  DAY_SIZE: 39,
  BLOCKED_MODIFIER: 'blocked',
  WEEKDAYS: [0, 1, 2, 3, 4, 5, 6],
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(104)('wks');
var uid = __webpack_require__(75);
var Symbol = __webpack_require__(8).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.storeSections = exports.storeActions = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _redux = __webpack_require__(268);

var _reduxThunk = __webpack_require__(992);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _filters = __webpack_require__(993);

var _filters2 = _interopRequireDefault(_filters);

var _auth = __webpack_require__(994);

var _auth2 = _interopRequireDefault(_auth);

var _storeSection = __webpack_require__(995);

var _storeSection2 = _interopRequireDefault(_storeSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// action and reducer creation
var storeReducers = {};
var storeActions = exports.storeActions = [];
var storeSections = exports.storeSections = ['clienti', 'deals', 'evaluations', 'fatture', 'firma', 'leads', 'newsletters', 'offers', 'oggetti', 'utenti'];
storeSections.forEach(function (section) {
  var newSection = new _storeSection2.default(section);
  storeReducers[newSection.label] = newSection.actionReducer;
  storeActions.push(newSection.getActions());
});

// Store creation
var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
  trace: true,
  traceLimit: 25
}) || _redux.compose;

exports.default = function () {
  var store = (0, _redux.createStore)((0, _redux.combineReducers)(_extends({
    auth: _auth2.default,
    filters: _filters2.default
  }, storeReducers)), composeEnhancers((0, _redux.applyMiddleware)(_reduxThunk2.default)));
  return store;
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(48);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(10)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(7);
var IE8_DOM_DEFINE = __webpack_require__(225);
var toPrimitive = __webpack_require__(52);
var dP = Object.defineProperty;

exports.f = __webpack_require__(16) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imageView = exports.linkButton = exports.editButton = exports.contactDetailsButton = exports.folderButton = exports.addButton = undefined;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// FOR ELECTRON PLEASE UPDATE FUNCTIONS
var addButton = exports.addButton = function addButton(destinazione) {
  return _react2.default.createElement(
    'div',
    { className: 'fixed-action-btn' },
    _react2.default.createElement(
      _reactRouterDom.Link,
      { className: 'btn-floating green btn-large', to: destinazione },
      _react2.default.createElement(
        'i',
        { className: 'material-icons' },
        'add'
      )
    )
  );
};

var folderButton = exports.folderButton = function folderButton(_ref, iconInPicture) {
  var cloudURL = _ref.cloudURL;

  return cloudURL ? _react2.default.createElement(
    'a',
    {
      href: cloudURL,
      target: '_blank',
      className: 'btn-floating light-blue accent-3 ' + (iconInPicture ? 'icon-in-picture' : 'btn-floating-margin right')
    },
    _react2.default.createElement(
      'i',
      { className: 'material-icons' },
      'cloud'
    )
  ) : '';
};

var contactDetailsButton = exports.contactDetailsButton = function contactDetailsButton(cliente) {
  return _react2.default.createElement(
    'div',
    null,
    cliente.email && _react2.default.createElement(
      'a',
      {
        href: 'mailto:' + cliente.email,
        className: 'btn-floating blue right btn-floating-margin'
      },
      _react2.default.createElement(
        'i',
        { className: 'material-icons' },
        'email'
      )
    ),
    cliente.telefono1 && _react2.default.createElement(
      'a',
      {
        href: 'tel:' + cliente.telefono1,
        className: 'btn-floating light-green accent-3 right btn-floating-margin'
      },
      _react2.default.createElement(
        'i',
        { className: 'material-icons' },
        'phone'
      )
    ),
    cliente.cellulare && _react2.default.createElement(
      'a',
      {
        href: 'tel:' + cliente.cellulare,
        className: 'btn-floating light-green accent-3 right btn-floating-margin'
      },
      _react2.default.createElement(
        'i',
        { className: 'material-icons' },
        'phone_iphone'
      )
    ),
    cliente.cloudURL && folderButton(cliente)
  );
};

var editButton = exports.editButton = function editButton(path) {
  return _react2.default.createElement(
    _reactRouterDom.Link,
    { className: 'btn-floating orange right btn-floating-margin', to: path },
    _react2.default.createElement(
      'i',
      { className: 'material-icons' },
      'edit'
    )
  );
};

var linkButton = exports.linkButton = function linkButton(url, label) {
  return _react2.default.createElement(
    'a',
    {
      href: url,
      target: '_blank',
      rel: 'noopener noreferrer',
      className: 'btn blue btn-margin'
    },
    label
  );
};

var imageView = exports.imageView = function imageView(imgArray, sectionTitle) {
  return _react2.default.createElement(
    'div',
    { className: 'container' },
    imgArray && imgArray.length > 0 && _react2.default.createElement(
      'div',
      { className: 'grey lighten-4' },
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h1',
          null,
          sectionTitle
        )
      ),
      ' ',
      imgArray.map(function (imgSource, i) {
        return _react2.default.createElement('img', { className: 'foto', key: i, src: imgSource });
      })
    )
  );
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(53);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Intestazione = function Intestazione(_ref) {
  var intestazione = _ref.intestazione;

  return _react2.default.createElement(
    'div',
    { className: 'grey lighten-4' },
    _react2.default.createElement(
      'div',
      { className: 'container' },
      _react2.default.createElement(
        'h1',
        null,
        intestazione
      )
    )
  );
};
exports.default = Intestazione;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _reactDates = __webpack_require__(407);

var _reactVirtualizedSelect = __webpack_require__(997);

var _reactVirtualizedSelect2 = _interopRequireDefault(_reactVirtualizedSelect);

var _OptionModal = __webpack_require__(58);

var _OptionModal2 = _interopRequireDefault(_OptionModal);

var _axios = __webpack_require__(67);

var _axios2 = _interopRequireDefault(_axios);

var _reactDropzone = __webpack_require__(1086);

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _utils = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function withForm(Component) {
  return function (_React$Component) {
    _inherits(WithForm, _React$Component);

    _createClass(WithForm, [{
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (prevProps.oggetto !== this.props.oggetto) {
          this.setState({
            oggetti: this.props.oggetto
          });
        }
      }
    }]);

    function WithForm(props) {
      var _this2 = this;

      _classCallCheck(this, WithForm);

      var _this = _possibleConstructorReturn(this, (WithForm.__proto__ || Object.getPrototypeOf(WithForm)).call(this, props));

      _this.renderModal = function (contentLabel) {
        var handleOpenModal = function handleOpenModal() {
          _this.setState(function () {
            return {
              isOpen: true,
              contentLabel: contentLabel
            };
          });
        };

        var handleCloseModal = function handleCloseModal() {
          _this.setState({ isOpen: false });
        };

        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'button',
            { className: 'btn green', onClick: handleOpenModal },
            contentLabel
          ),
          _react2.default.createElement(_OptionModal2.default, {
            isOpen: _this.state.isOpen,
            contentLabel: _this.state.contentLabel,
            modalContent: _this.state.modalContent,
            onCancel: handleCloseModal
          })
        );
      };

      _this.renderError = function () {
        var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

        _this.setState({ error: error });
      };

      _this.renderInput = function (object, property, label) {
        var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'text';
        var handler = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _this.changeHandler;
        var args = arguments[5];
        var placeholder = arguments[6];
        var required = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';

        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'label',
            { htmlFor: property },
            label,
            required
          ),
          _react2.default.createElement('input', {
            type: type,
            name: property,
            value: _this.state[object][property],
            id: property,
            className: 'text-input',
            placeholder: placeholder,
            onChange: function onChange(e) {
              return handler(e, object, args);
            }
          })
        );
      };

      _this.renderSelect = function (object, selectName, options, label) {
        var required = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';

        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'label',
            null,
            label,
            required
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_reactVirtualizedSelect2.default, {
              name: selectName,
              value: _this.state[object][selectName],
              options: options,
              onChange: function onChange(e) {
                return _this.changeHandlerSelect(selectName, e ? e.value : '', object);
              }
            })
          )
        );
      };

      _this.renderTextArea = function (object, textAreaName) {
        var placeholder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Note';

        return _react2.default.createElement('textarea', {
          name: textAreaName,
          className: 'textarea text-input',
          placeholder: placeholder,
          value: _this.state[object][textAreaName],
          onChange: function onChange(e) {
            return _this.changeHandler(e, object);
          }
        });
      };

      _this.renderCheckbox = function (object, checkboxName, label) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'label',
            null,
            _react2.default.createElement('input', {
              type: 'checkbox',
              name: checkboxName,
              checked: _this.state[object][checkboxName],
              onChange: function onChange(e) {
                return _this.changeCheckbox(e, object);
              }
            }),
            _react2.default.createElement(
              'span',
              null,
              label
            )
          )
        );
      };

      _this.renderSingleDate = function (object, dataName, focusName, label) {
        var required = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';

        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'label',
            null,
            label,
            required
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_reactDates.SingleDatePicker, {
              date: _this.state[object][dataName],
              onDateChange: function onDateChange(e) {
                return _this.onDataChange(dataName, e, object);
              },
              focused: _this.state[object][focusName],
              onFocusChange: function onFocusChange(e) {
                return _this.onFocusChange(focusName, e, object);
              },
              numberOfMonths: 1,
              isOutsideRange: function isOutsideRange() {
                return false;
              },
              showClearDate: true
            })
          )
        );
      };

      _this.renderDateRange = function (object, focusName, label) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'label',
            null,
            label
          ),
          _react2.default.createElement(
            'div',
            { className: 'input-group__item' },
            _react2.default.createElement(_reactDates.DateRangePicker, {
              startDate: _this.state[object]['startDate'],
              endDate: _this.state[object]['endDate'],
              onDatesChange: function onDatesChange(e) {
                return _this.onDatesChange(e, object);
              },
              focusedInput: _this.state[object][focusName],
              onFocusChange: function onFocusChange(e) {
                return _this.onFocusChange2(e, object, focusName);
              },
              showClearDates: true,
              numberOfMonths: 1,
              isOutsideRange: function isOutsideRange() {
                return false;
              },
              displayFormat: 'DD.MM.YYYY'
            })
          )
        );
      };

      _this.renderUploadImage = function (object, property, label) {
        return _react2.default.createElement(
          'li',
          { className: 'collection-item' },
          _react2.default.createElement(
            'label',
            { htmlFor: property },
            label
          ),
          _react2.default.createElement(
            _reactDropzone2.default,
            {
              onDrop: function onDrop(accepted, rejected) {
                _this.handleOnDrop(accepted, rejected, property, object);
              }
            },
            function (_ref) {
              var getRootProps = _ref.getRootProps,
                  getInputProps = _ref.getInputProps;
              return _react2.default.createElement(
                'section',
                null,
                _react2.default.createElement(
                  'div',
                  getRootProps({ className: 'dropzone' }),
                  _react2.default.createElement('input', getInputProps()),
                  _react2.default.createElement(
                    'div',
                    { className: 'file-upload-box' },
                    'Drag \'n\' drop some files here, or click to select files'
                  )
                )
              );
            }
          ),
          _this.state.spinner ? _react2.default.createElement(
            'div',
            { className: 'progress' },
            _react2.default.createElement('div', { className: 'indeterminate' })
          ) : _react2.default.createElement(
            'div',
            null,
            property === 'downloadURLs' ? // visualizzo solo uno degli array, gli altri sono duplicati
            Array.isArray(_this.state.oggetti.downloadURLs[0]) ? _this.state.oggetti.downloadURLs[0].map(function (url, i) {
              return _react2.default.createElement(
                'div',
                { key: i, className: 'foto-container' },
                _react2.default.createElement('img', { className: 'foto', src: url }),
                i > 0 && _react2.default.createElement(
                  'button',
                  {
                    className: 'sposta-sinistra',
                    onClick: function onClick(e) {
                      return _this.sposta(e, i, true);
                    }
                  },
                  _react2.default.createElement(
                    'i',
                    { className: 'material-icons' },
                    'navigate_before'
                  )
                ),
                i < _this.state.oggetti.downloadURLs[0].length - 1 && _react2.default.createElement(
                  'button',
                  {
                    className: 'sposta-destra',
                    onClick: function onClick(e) {
                      return _this.sposta(e, i, false);
                    }
                  },
                  _react2.default.createElement(
                    'i',
                    { className: 'material-icons' },
                    'navigate_next'
                  )
                ),
                _react2.default.createElement(
                  'button',
                  {
                    className: 'cancella',
                    onClick: function onClick(e) {
                      return _this.handleRemovePicture(e, i, property, object);
                    }
                  },
                  _react2.default.createElement(
                    'i',
                    { className: 'material-icons' },
                    'delete'
                  )
                )
              );
            }) : _this.state.oggetti.downloadURLs && _this.state.oggetti.downloadURLs.map(function (url, i) {
              return _react2.default.createElement(
                'div',
                { key: i, className: 'foto-container' },
                _react2.default.createElement('img', { className: 'foto', src: url }),
                _react2.default.createElement(
                  'button',
                  {
                    className: 'cancella',
                    onClick: function onClick(e) {
                      return _this.handleRemovePicture(e, i, property, object);
                    }
                  },
                  _react2.default.createElement(
                    'i',
                    { className: 'material-icons' },
                    'delete'
                  )
                )
              );
            }) : _this.state[object][property] && _this.state[object][property].map(function (url, i) {
              return _react2.default.createElement(
                'div',
                { key: i, className: 'foto-container' },
                _react2.default.createElement('img', { className: 'foto', src: url }),
                _react2.default.createElement(
                  'button',
                  {
                    className: 'cancella',
                    onClick: function onClick(e) {
                      return _this.handleRemovePicture(e, i, property, object);
                    }
                  },
                  _react2.default.createElement(
                    'i',
                    { className: 'material-icons' },
                    'delete'
                  )
                )
              );
            })
          )
        );
      };

      _this.changeHandler = function (e, object) {
        return _this.setState(_defineProperty({}, object, _extends({}, _this.state[object], _defineProperty({}, e.target.name, e.target.value))));
      };

      _this.handleOnDrop = function (accepted, rejected, property, object) {
        console.log(accepted, rejected, property, object);

        var urlArray = [[], [], []];
        var idArray = [[], [], []];

        if (property === 'downloadURLs') {
          urlArray[0] = [].concat(_toConsumableArray(accepted));
          urlArray[1] = [].concat(_toConsumableArray(accepted));
          urlArray[2] = [].concat(_toConsumableArray(accepted));

          idArray[0] = [].concat(_toConsumableArray(accepted));
          idArray[1] = [].concat(_toConsumableArray(accepted));
          idArray[2] = [].concat(_toConsumableArray(accepted));
        } else {
          urlArray = [].concat(_toConsumableArray(_this.state[object][property]));
          idArray = [].concat(_toConsumableArray(_this.state[object][property + 'Id']));
        }

        var promiseArray = [];
        accepted.forEach(function (file, index) {
          // devo triplicare ogni immagine del post per le traduzioni
          // ma non grundriss o cover
          if (property === 'downloadURLs') {
            var _loop = function _loop(i) {
              promiseArray.push(new Promise(function (resolve, reject) {
                var carica = function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                    var response;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return _this.fileUpload(file);

                          case 2:
                            response = _context.sent;

                            response && urlArray[i].splice(index, 1, response.data.source_url);
                            response && idArray[i].splice(index, 1, response.data.id);
                            resolve(index);

                          case 6:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this2);
                  }));

                  return function carica() {
                    return _ref2.apply(this, arguments);
                  };
                }();
                carica();
              }));
            };

            for (var i = 0; i < 3; i++) {
              _loop(i);
            }
          } else {
            promiseArray.push(new Promise(function (resolve, reject) {
              var carica = function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                  var response;
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return _this.fileUpload(file);

                        case 2:
                          response = _context2.sent;

                          response && urlArray.push(response.data.source_url);
                          response && idArray.push(response.data.id);
                          resolve(true);

                        case 6:
                        case 'end':
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this2);
                }));

                return function carica() {
                  return _ref3.apply(this, arguments);
                };
              }();
              carica();
            }));
          }
        });

        Promise.allSettled(promiseArray).then(function () {
          if (property === 'downloadURLs') {
            //elimino i placeholder (oggetti) di dropzone accepted che non sono stati sostituiti perché l'ivio
            //dell'immagine è fallito
            var sanitazeURL = urlArray[0].filter(function (e) {
              return (typeof e === 'undefined' ? 'undefined' : _typeof(e)) !== 'object';
            });
            var sanitazeURL1 = urlArray[1].filter(function (e) {
              return (typeof e === 'undefined' ? 'undefined' : _typeof(e)) !== 'object';
            });
            var sanitazeURL2 = urlArray[2].filter(function (e) {
              return (typeof e === 'undefined' ? 'undefined' : _typeof(e)) !== 'object';
            });
            var sanitazeID = idArray[0].filter(function (e) {
              return (typeof e === 'undefined' ? 'undefined' : _typeof(e)) !== 'object';
            });
            var sanitazeID1 = idArray[1].filter(function (e) {
              return (typeof e === 'undefined' ? 'undefined' : _typeof(e)) !== 'object';
            });
            var sanitazeID2 = idArray[2].filter(function (e) {
              return (typeof e === 'undefined' ? 'undefined' : _typeof(e)) !== 'object';
            });
            sanitazeURL.unshift.apply(sanitazeURL, _toConsumableArray(_this.state.oggetti.downloadURLs[0]));
            sanitazeURL1.unshift.apply(sanitazeURL1, _toConsumableArray(_this.state.oggetti.downloadURLs[1]));
            sanitazeURL2.unshift.apply(sanitazeURL2, _toConsumableArray(_this.state.oggetti.downloadURLs[2]));
            sanitazeID.unshift.apply(sanitazeID, _toConsumableArray(_this.state.oggetti.downloadURLsId[0]));
            sanitazeID1.unshift.apply(sanitazeID1, _toConsumableArray(_this.state.oggetti.downloadURLsId[1]));
            sanitazeID2.unshift.apply(sanitazeID2, _toConsumableArray(_this.state.oggetti.downloadURLsId[2]));

            _this.setState({
              oggetti: _extends({}, _this.state.oggetti, {
                downloadURLs: [sanitazeURL, sanitazeURL1, sanitazeURL2],
                downloadURLsId: [sanitazeID, sanitazeID1, sanitazeID2]
              }),
              spinner: false
            });
          } else {
            var _extends3, _this$setState2;

            _this.setState((_this$setState2 = {}, _defineProperty(_this$setState2, object, _extends({}, _this.state[object], (_extends3 = {}, _defineProperty(_extends3, property, urlArray), _defineProperty(_extends3, property + 'Id', idArray), _extends3))), _defineProperty(_this$setState2, 'spinner', false), _this$setState2));
          }
        });
      };

      _this.fileUpload = function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(file) {
          var url, formData, config, response;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _this.setState({
                    spinner: true
                  });
                  // Get Token
                  // generaToken();

                  url = "https://www.m2square.eu" + '/wp-json/wp/v2/media';
                  formData = new FormData();

                  formData.append('file', file);
                  config = {
                    headers: {
                      'content-type': 'multipart/form-data',
                      Authorization: 'Bearer ' + localStorage.getItem('token')
                    }
                  };
                  _context3.prev = 5;
                  _context3.next = 8;
                  return (0, _axios.post)(url, formData, config);

                case 8:
                  response = _context3.sent;

                  console.log(response);
                  return _context3.abrupt('return', response);

                case 13:
                  _context3.prev = 13;
                  _context3.t0 = _context3['catch'](5);

                  console.log(_context3.t0);
                  _this.setState({
                    spinner: false
                  });

                case 17:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, _this2, [[5, 13]]);
        }));

        return function (_x8) {
          return _ref4.apply(this, arguments);
        };
      }();

      _this.sposta = function (e, i, avanti) {
        e.preventDefault();
        var urlArray = [].concat(_toConsumableArray(_this.state.oggetti.downloadURLs));
        var idArray = [].concat(_toConsumableArray(_this.state.oggetti.downloadURLsId));

        var direzione = i;
        avanti ? direzione-- : direzione++;

        (0, _utils.riordinaImmagini)(urlArray[0], i, direzione);
        (0, _utils.riordinaImmagini)(urlArray[1], i, direzione);
        (0, _utils.riordinaImmagini)(urlArray[2], i, direzione);

        (0, _utils.riordinaImmagini)(idArray[0], i, direzione);
        (0, _utils.riordinaImmagini)(idArray[1], i, direzione);
        (0, _utils.riordinaImmagini)(idArray[2], i, direzione);

        _this.setState(function (prevState) {
          return {
            oggetti: _extends({}, prevState.oggetti, {
              downloadURLs: urlArray,
              downloadURLsId: idArray
            })
          };
        });
      };

      _this.handleRemovePicture = function (e, picture, property, object) {
        e.preventDefault();
        _this.setState({ spinner: true });
        var idDe = false;
        var idEn = false;
        var idIt = false;
        var idGrundriss = false;

        if (property === 'downloadURLs') {
          var urlArray = [].concat(_toConsumableArray(_this.state.oggetti.downloadURLs));

          urlArray[0].splice(picture, 1);
          urlArray[1].splice(picture, 1);
          urlArray[2].splice(picture, 1);

          var idArray = [].concat(_toConsumableArray(_this.state.oggetti.downloadURLsId));

          idDe = idArray[0].splice(picture, 1);
          idEn = idArray[1].splice(picture, 1);
          idIt = idArray[2].splice(picture, 1);

          _this.setState(function (prevState) {
            return {
              oggetti: _extends({}, prevState.oggetti, {
                downloadURLs: urlArray,
                downloadURLsId: idArray
              })
            };
          });
        } else {
          var _urlArray = [].concat(_toConsumableArray(_this.state[object][property]));
          console.log(_urlArray);
          _urlArray.splice(picture, 1);
          console.log(_urlArray);

          if (_urlArray === undefined || _urlArray.length < 1) {
            _urlArray = [];
          }

          var _idArray = [].concat(_toConsumableArray(_this.state[object][property + 'Id']));
          console.log(_idArray);
          // se cancello grundriss passo l'id del media alla variabile idGrundriss
          // altrimenti sto cancellando cover e basta togliere l'id feature_media da post
          if (property === 'downloadURLsGrundriss') {
            idGrundriss = _idArray.splice(picture, 1);
          } else {
            _idArray.splice(picture, 1);
          }
          console.log(_idArray);

          if (_idArray === undefined || _idArray.length < 1) {
            _idArray = [];
          }
          _this.setState(function (prevState) {
            var _extends4;

            return _defineProperty({}, object, _extends({}, prevState[object], (_extends4 = {}, _defineProperty(_extends4, property, _urlArray), _defineProperty(_extends4, property + 'Id', _idArray), _extends4)));
          });
        }

        // se cancello l'immagine di copertina devo cancellare il campo featured_media dal post
        if (property === 'downloadURLsCover') {
          _axios2.default.put("https://www.m2square.eu" + '/wp-json/wp/v2/estate_property/' + _this.state.oggetti.postId, { featured_media: 0 }, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + localStorage.getItem('token')
            }
          }).catch(function (err) {
            console.log(err);
          }).finally(function () {
            _this.setState({
              spinner: false
            });
          });
        } else if (property === 'downloadURLsGrundriss') {
          // se cancello altre immagini devo cancellare il campo post da ogni singolo media
          _axios2.default.put("https://www.m2square.eu" + '/wp-json/wp/v2/media/' + idGrundriss, { post: 0 }, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + localStorage.getItem('token')
            }
          }).catch(function (err) {
            console.log(err);
          }).finally(function () {
            _this.setState({
              spinner: false
            });
          });
        } else if (property === 'downloadURLs') {
          _axios2.default.put("https://www.m2square.eu" + '/wp-json/wp/v2/media/' + idDe, { post: 0 }, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + localStorage.getItem('token')
            }
          }).catch(function (err) {
            console.log(err);
          }).finally(function () {
            _this.setState({
              spinner: false
            });
          });
          _axios2.default.put("https://www.m2square.eu" + '/wp-json/wp/v2/media/' + idEn, { post: 0 }, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + localStorage.getItem('token')
            }
          }).catch(function (err) {
            console.log(err);
          }).finally(function () {
            _this.setState({
              spinner: false
            });
          });
          _axios2.default.put("https://www.m2square.eu" + '/wp-json/wp/v2/media/' + idIt, { post: 0 }, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + localStorage.getItem('token')
            }
          }).catch(function (err) {
            console.log(err);
          }).finally(function () {
            _this.setState({
              spinner: false
            });
          });
        } else {
          _this.setState({
            spinner: false
          });
        }
      };

      _this.changeHandlerValuta = function (e, object) {
        var name = e.target.name;
        var value = e.target.value;
        if (!value || value.match(/^\d{1,}(,\d{0,2})?$/)) {
          _this.setState(function () {
            return _defineProperty({}, object, _extends({}, _this.state[object], _defineProperty({}, name, value)));
          });
        }
      };

      _this.changeHandlerValidate = function (e, object, clienti) {
        _this.setState(_defineProperty({}, object, _extends({}, _this.state[object], _defineProperty({}, e.target.name, e.target.value))));
        if (e.target.value.length > 3) {
          var match = clienti.filter(function (ilcliente) {
            var emailMatch = ilcliente.email.toLowerCase().includes(e.target.value.toLowerCase());
            var cognomeMatch = ilcliente.cognome.toLowerCase().includes(e.target.value.toLowerCase());
            var dittaMatch = ilcliente.ditta.toLowerCase().includes(e.target.value.toLowerCase());
            return emailMatch || cognomeMatch || dittaMatch;
          });
          if (match.length > 0) {
            _this.setState(function () {
              return {
                error: 'customer_already_registered',
                modalContent: match
              };
            });
          } else {
            _this.setState(function () {
              return { error: '' };
            });
          }
        }
      };

      _this.changeHandlerSelect = function (name, value, object) {
        return _this.setState(_defineProperty({}, object, _extends({}, _this.state[object], _defineProperty({}, name, value))));
      };

      _this.onDataChange = function (name, dataValue, object) {
        if (dataValue) {
          _this.setState(function (prevState) {
            return _defineProperty({}, object, _extends({}, prevState[object], _defineProperty({}, name, dataValue)));
          });
        } else {
          _this.setState(function () {
            return _defineProperty({}, object, _extends({}, _this.state[object], _defineProperty({}, name, null)));
          });
        }
      };

      _this.onFocusChange = function (name, _ref9, object) {
        var focused = _ref9.focused;

        _this.setState(function (prevState) {
          return _defineProperty({}, object, _extends({}, prevState[object], _defineProperty({}, name, focused)));
        });
      };

      _this.onDatesChange = function (_ref11, object) {
        var startDate = _ref11.startDate,
            endDate = _ref11.endDate;

        _this.setState(function (prevState) {
          return _defineProperty({}, object, _extends({}, prevState[object], { startDate: startDate }));
        });
        _this.setState(function (prevState) {
          return _defineProperty({}, object, _extends({}, prevState[object], { endDate: endDate }));
        });
      };

      _this.onFocusChange2 = function (e, object, focusName) {
        _this.setState(function (prevState) {
          return _defineProperty({}, object, _extends({}, prevState[object], _defineProperty({}, focusName, e)));
        });
      };

      _this.changeCheckbox = function (e, object) {
        return _this.setState(_defineProperty({}, object, _extends({}, _this.state[object], _defineProperty({}, e.target.name, !_this.state[object][e.target.name]))));
      };

      _this.state = {
        clienti: {
          //CLIENTI
          cloudURL: props.customer ? props.customer.cloudURL ? props.customer.cloudURL : '' : '',
          nome: props.customer ? props.customer.nome : '',
          cognome: props.customer ? props.customer.cognome : '',
          titolo: props.customer ? props.customer.titolo : '',
          dataDiNascita: props.customer ? props.customer.dataDiNascita && (0, _moment2.default)(props.customer.dataDiNascita) : null,
          ditta: props.customer ? props.customer.ditta : '',
          indirizzo: props.customer ? props.customer.indirizzo : '',
          indirizzo2: props.customer ? props.customer.indirizzo2 : '',
          cap: props.customer ? props.customer.cap : '',
          comune: props.customer ? props.customer.comune : '',
          nazione: props.customer ? props.customer.nazione : '',
          lingua: props.customer ? props.customer.lingua : '',
          email: props.customer ? props.customer.email : '',
          consulenteVenditaId: props.customer ? props.customer.consulenteVenditaId : '',
          telefono1: props.customer ? props.customer.telefono1 : '',
          fax: props.customer ? props.customer.fax : '',
          cellulare: props.customer ? props.customer.cellulare : '',
          codiceFiscale: props.customer ? props.customer.codiceFiscale : '',
          handelsRegisterNummer: props.customer ? props.customer.handelsRegisterNummer : '',
          bank: props.customer ? props.customer.bank : '',
          iban: props.customer ? props.customer.iban : '',
          bic: props.customer ? props.customer.bic : '',
          note: props.customer ? props.customer.note : '',
          visible: props.customer ? props.customer.visible : true,
          www: props.customer ? props.customer.www || '' : '',
          dataRegistrazione: props.customer ? props.customer.dataRegistrazione ? (0, _moment2.default)(props.customer.dataRegistrazione) : null : null,
          calendarDataRegistrazioneFocused: false,
          consensoDSGVO: props.customer ? props.customer.consensoDSGVO ? props.customer.consensoDSGVO : false : false,
          dataConsensoDSGVO: props.customer ? props.customer.dataConsensoDSGVO ? (0, _moment2.default)(props.customer.dataConsensoDSGVO) : null : null,
          calendarDataConsensoDSGVOFocused: false
        },
        deals: {
          //DEAL
          feePayed: props.deal ? props.deal.feePayed ? props.deal.feePayed : false : false,
          note: props.deal ? props.deal.note : '',
          oggettoId: props.deal ? props.deal.oggettoId : '',
          prezzoDiVendita: props.deal ? (0, _utils.visualizzaDecimaleConVirgola)(props.deal.prezzoDiVendita) : '0',
          amount: props.deal ? (0, _utils.visualizzaDecimaleConVirgola)(props.deal.amount) : '',
          consulenteVendita: props.deal ? props.deal.consulenteVendita : '',
          provvM2square: props.deal ? (0, _utils.visualizzaDecimaleConVirgola)(props.deal.provvM2square) : '',
          dealType: props.deal ? props.deal.dealType : '',
          provvStefano: props.deal ? (0, _utils.visualizzaDecimaleConVirgola)(props.deal.provvStefano) : '',
          payedStefano: props.deal ? props.deal.payedStefano : false,
          payedAtStefano: props.deal ? props.deal.payedAtStefano && (0, _moment2.default)(props.deal.payedAtStefano) : null,
          calendarPayedAtStefanoFocused: false,
          agenziaPartnerId: props.deal ? props.deal.agenziaPartnerId : '',
          provvAgenziaPartner: props.deal ? (0, _utils.visualizzaDecimaleConVirgola)(props.deal.provvAgenziaPartner) : '0',
          payedAgenziaPartner: props.deal ? props.deal.payedAgenziaPartner : false,
          createdAt: props.deal ? props.deal.createdAt && (0, _moment2.default)(props.deal.createdAt) : null,
          calendarFocused: false,
          venditoreId: props.deal ? props.deal.venditoreId : '',
          venditoreId2: props.deal ? props.deal.venditoreId2 : '',
          acquirenteId: props.deal ? props.deal.acquirenteId : '',
          acquirenteId2: props.deal ? props.deal.acquirenteId2 : '',
          notaioId: props.deal ? props.deal.notaioId : '',
          dataRogito: props.deal ? props.deal.dataRogito && (0, _moment2.default)(props.deal.dataRogito) : null,
          calendarDataRogitoFocused: false,
          dataConsegna: props.deal ? props.deal.dataConsegna && (0, _moment2.default)(props.deal.dataConsegna) : null,
          calendarDataConsegnaFocused: false,
          linguaRogito: props.deal ? props.deal.linguaRogito : '',
          belastungsVollmacht: props.deal ? props.deal.belastungsVollmacht : false,
          modificato: '',
          provvSum: 0
        },
        fatture: {
          //FATTURE
          dealId: props.fattura ? props.fattura.dealId : '',
          clienteId: props.fattura ? props.fattura.clienteId : '',
          clienteId2: props.fattura ? props.fattura.clienteId2 : '',
          numeroFattura: props.fattura ? props.fattura.numeroFattura : '',
          dataFattura: props.fattura ? props.fattura.dataFattura && (0, _moment2.default)(props.fattura.dataFattura) : null,
          calendarDataFatturaFocused: false,
          dataZahlungserinnerung: props.fattura ? props.fattura.dataZahlungserinnerung && (0, _moment2.default)(props.fattura.dataZahlungserinnerung) : null,
          calendarDataZahlungserinnerungFocused: false,
          dataMahnung: props.fattura ? props.fattura.dataMahnung && (0, _moment2.default)(props.fattura.dataMahnung) : null,
          calendarDataMahnungFocused: false,
          dataMahnung2: props.fattura ? props.fattura.dataMahnung2 && (0, _moment2.default)(props.fattura.dataMahnung2) : null,
          calendarDataMahnung2Focused: false,
          mahngebuehren: props.fattura && props.fattura.mahngebuehren ? (0, _utils.visualizzaDecimaleConVirgola)(props.fattura.mahngebuehren) : '0',
          mahngebuehren2: props.fattura && props.fattura.mahngebuehren2 ? (0, _utils.visualizzaDecimaleConVirgola)(props.fattura.mahngebuehren2) : '0',
          payed: props.fattura ? props.fattura.payed : false,
          payedAt: props.fattura ? props.fattura.payedAt && (0, _moment2.default)(props.fattura.payedAt) : null,
          descrizioneProdotto: props.fattura ? props.fattura.descrizioneProdotto ? props.fattura.descrizioneProdotto : '' : '',
          importoNetto: props.fattura ? props.fattura.importoNetto ? (0, _utils.visualizzaDecimaleConVirgola)(props.fattura.importoNetto) : '0' : '0',

          dataPrestazione: props.fattura ? props.fattura.dataPrestazione ? props.fattura.dataPrestazione && (0, _moment2.default)(props.fattura.dataPrestazione) : null : null,
          calendarDataPrestazioneFocus: false
        },
        firma: {
          //FIRMA
          bic: props.firma ? props.firma.bic : '',
          iban: props.firma ? props.firma.iban : '',
          bank: props.firma ? props.firma.bank : '',
          fax: props.firma ? props.firma.fax : '',
          email: props.firma ? props.firma.email : '',
          name: props.firma ? props.firma.name : '',
          name2: props.firma ? props.firma.name2 : '',
          adresse: props.firma ? props.firma.adresse : '',
          plz: props.firma ? props.firma.plz : '',
          stadt: props.firma ? props.firma.stadt : '',
          staat: props.firma ? props.firma.staat : '',
          telefon: props.firma ? props.firma.telefon : '',
          website: props.firma ? props.firma.website : '',
          steuerNr: props.firma ? props.firma.steuerNr : '',
          ustIdNr: props.firma ? props.firma.ustIdNr : '',
          motto: props.firma ? props.firma.motto : '',
          open: props.firma ? props.firma.open : '',
          kontoInhaber: props.firma ? props.firma.kontoInhaber : '',
          ivaApplicata: props.firma ? props.firma.ivaApplicata ? props.firma.ivaApplicata : '' : ''
        },
        leads: {
          //LEADS
          leadCreatedAt: props.lead ? (0, _moment2.default)(props.lead.leadCreatedAt) : (0, _moment2.default)(),
          leadId: props.lead ? props.lead.leadId : '',
          leadBudget: props.lead ? (props.lead.leadBudget / 100).toString() : '',
          leadCity: props.lead ? props.lead.leadCity ? props.lead.leadCity : 'Berlin' : 'Berlin',
          leadOggettoStato: props.lead ? props.lead.leadOggettoStato : '',
          leadNote: props.lead ? props.lead.leadNote : ''
        },
        offers: {
          calendarFocused: false,
          consulenteId: props.offer ? props.offer.consulenteId : '',
          feedback: props.offer ? props.offer.feedback : '',
          leadId: props.offer ? props.offer.leadId : props.leadId,
          offerCreatedAt: props.offer ? props.offer.offerCreatedAt && (0, _moment2.default)(props.offer.offerCreatedAt) : null,
          offerNote: props.offer ? props.offer.offerNote : '',
          offertoTramite: props.offer ? props.offer.offertoTramite : '',
          oggettoId: props.offer ? props.offer.oggettoId : props.oggettoId
        },
        moduli: {
          //MODULI
          prezzoDiVendita: '',
          prezzoDiVendita2: '',
          startDate: null,
          endDate: null,
          calendarFocusedMAA: null,
          maklerProvision: '',
          provvPercentuale: '',
          belastungsVollmacht: false,
          sonstige: '',
          seller: false
        },
        oggetti: {
          //OGGETTO
          affittoNetto: props.oggetto ? (0, _utils.visualizzaDecimaleConVirgola)(props.oggetto.affittoNetto) : '0',
          amtsgericht: props.oggetto ? props.oggetto.amtsgericht : '',
          ascensore: props.oggetto ? props.oggetto.ascensore : false,
          baujahr: props.oggetto ? props.oggetto.baujahr : '',
          bagni: props.oggetto ? props.oggetto.bagni : '',
          balcone: props.oggetto ? props.oggetto.balcone : false,
          cantina: props.oggetto ? props.oggetto.cantina : false,
          cap: props.oggetto ? props.oggetto.cap : '',
          citta: props.oggetto ? props.oggetto.citta : '',
          cloudURL: props.oggetto ? props.oggetto.cloudURL ? props.oggetto.cloudURL : '' : '',
          condizioni: props.oggetto ? props.oggetto.condizioni : '',
          //se non c'è una data, inserisco quella attuale
          dataInserimentoOggetto: props.oggetto ? props.oggetto.dataInserimentoOggetto ? (0, _moment2.default)(props.oggetto.dataInserimentoOggetto) : (0, _moment2.default)() : (0, _moment2.default)(),
          dataModificaOggetto: props.oggetto ? (0, _moment2.default)() : null,
          descrizione: props.oggetto ? props.oggetto.descrizione : '',
          descrizioneDe: props.oggetto ? props.oggetto.descrizioneDe : '',
          descrizioneEn: props.oggetto ? props.oggetto.descrizioneEn : '',
          downloadURLs: props.oggetto ? props.oggetto.downloadURLs ? props.oggetto.downloadURLs : [[], [], []] : [[], [], []],
          downloadURLsId: props.oggetto ? props.oggetto.downloadURLsId ? props.oggetto.downloadURLsId : [[], [], []] : [[], [], []],
          downloadURLsCover: props.oggetto ? props.oggetto.downloadURLsCover ? props.oggetto.downloadURLsCover : [] : [],
          downloadURLsCoverId: props.oggetto ? props.oggetto.downloadURLsCoverId ? props.oggetto.downloadURLsCoverId : [] : [],
          downloadURLsGrundriss: props.oggetto ? props.oggetto.downloadURLsGrundriss ? props.oggetto.downloadURLsGrundriss : [] : [],
          downloadURLsGrundrissId: props.oggetto ? props.oggetto.downloadURLsGrundrissId ? props.oggetto.downloadURLsGrundrissId : [] : [],
          energieAusweisTyp: props.oggetto ? props.oggetto.energieAusweisTyp : '',
          energieAusweisBis: props.oggetto ? props.oggetto.energieAusweisBis : '',
          energieTraeger: props.oggetto ? props.oggetto.energieTraeger : '',
          energieBedarf: props.oggetto ? props.oggetto.energieBedarf : '',
          featuredProperty: props.oggetto ? props.oggetto.featuredProperty ? props.oggetto.featuredProperty : 0 : 0,
          filenames: props.oggetto ? props.oggetto.filenames : '',
          filenamesCover: props.oggetto ? props.oggetto.filenamesCover : '',
          filenamesGrundriss: props.oggetto ? props.oggetto.filenamesGrundriss : '',
          giardino: props.oggetto ? props.oggetto.giardino : false,
          grundbuch: props.oggetto ? props.oggetto.grundbuch : '',
          grundbuchBlatt: props.oggetto ? props.oggetto.grundbuchBlatt : '',
          heizungsart: props.oggetto ? props.oggetto.heizungsart : '',
          immaginiInviate: props.oggetto ? props.oggetto.immaginiInviate ? props.oggetto.immaginiInviate : [] : [],
          inquilinoId: props.oggetto ? props.oggetto.inquilinoId : '',
          isUploading: false,
          kaufpreis: props.oggetto ? (0, _utils.visualizzaDecimaleConVirgola)(props.oggetto.kaufpreis) : '0',
          latitude: props.oggetto ? props.oggetto.latitude ? props.oggetto.latitude : '' : '',
          longitude: props.oggetto ? props.oggetto.longitude ? props.oggetto.longitude : '' : '',
          m2: props.oggetto ? props.oggetto.m2 : '',
          mobilio: props.oggetto ? props.oggetto.mobilio : '',
          nazione: props.oggetto ? props.oggetto.nazione : '',
          note: props.oggetto ? props.oggetto.note : '',
          numeroCivico: props.oggetto ? props.oggetto.numeroCivico : '',
          numeroAppartamento: props.oggetto ? props.oggetto.numeroAppartamento : '',
          piano: props.oggetto ? props.oggetto.piano : '',
          // postId: props.oggetto
          //   ? props.oggetto.postId
          //     ? props.oggetto.postId
          //     : ''
          //   : '',
          prenotato: props.oggetto ? props.oggetto.prenotato ? props.oggetto.prenotato : false : false,

          proprietarioId: props.oggetto ? props.oggetto.proprietarioId : '',
          proprietarioId2: props.oggetto ? props.oggetto.proprietarioId2 : '',
          provvigione: props.oggetto ? props.oggetto.provvigione ? (0, _utils.visualizzaDecimaleConVirgola)(props.oggetto.provvigione) : '0' : '0',
          quartiere: props.oggetto ? props.oggetto.quartiere : '',
          rifId: props.oggetto ? props.oggetto.rifId : '',
          ruecklage: props.oggetto ? props.oggetto.ruecklage : '',
          stato: props.oggetto ? props.oggetto.stato : '',
          status: props.oggetto ? props.oggetto.status ? props.oggetto.status : false : false,
          themeSlider: props.oggetto ? props.oggetto.themeSlider ? props.oggetto.themeSlider : 0 : 0,
          tipologia: props.oggetto ? props.oggetto.tipologia ? props.oggetto.tipologia : '' : '',
          titoloDe: props.oggetto ? props.oggetto.titoloDe : '',
          titoloEn: props.oggetto ? props.oggetto.titoloEn : '',
          titolo: props.oggetto ? props.oggetto.titolo : '',
          uploadProgress: 0,
          vani: props.oggetto ? props.oggetto.vani : '',
          venduto: props.oggetto ? props.oggetto.venduto : false,
          verwalter: props.oggetto ? props.oggetto.verwalter : '',
          via: props.oggetto ? props.oggetto.via : '',
          videoId: props.oggetto ? props.oggetto.videoId ? props.oggetto.videoId : '' : '',
          visible: props.oggetto ? props.oggetto.visible : true,
          wohngeld: props.oggetto ? (0, _utils.visualizzaDecimaleConVirgola)(props.oggetto.wohngeld) : '0'
        },
        users: {
          //USERS
          telefon: props.user ? props.user.telefon : '',
          name: props.user ? props.user.name : '',
          email: props.user ? props.user.email : '',
          role: props.user ? props.user.role : '',
          qualifica: props.user ? props.user.qualifica : '',
          firebaseAuthId: props.user ? props.user.firebaseAuthId : ''
        },
        evaluations: {
          wohnlageSnippet: props.evaluation ? props.evaluation.wohnlageSnippet ? props.evaluation.wohnlageSnippet : [] : [],
          wohnlageSnippetId: props.evaluation ? props.evaluation.wohnlageSnippetId ? props.evaluation.wohnlageSnippetId : [] : [],
          bodenrichtwertSnippet: props.evaluation ? props.evaluation.bodenrichtwertSnippet ? props.evaluation.bodenrichtwertSnippet : [] : [],
          bodenrichtwertSnippetId: props.evaluation ? props.evaluation.bodenrichtwertSnippetId ? props.evaluation.bodenrichtwertSnippetId : [] : [],
          immobilienPreisSnippet: props.evaluation ? props.evaluation.immobilienPreisSnippet ? props.evaluation.immobilienPreisSnippet : [] : [],
          immobilienPreisSnippetId: props.evaluation ? props.evaluation.immobilienPreisSnippetId ? props.evaluation.immobilienPreisSnippetId : [] : [],
          is24Snippet: props.evaluation ? props.evaluation.is24Snippet ? props.evaluation.is24Snippet : [] : [],
          is24SnippetId: props.evaluation ? props.evaluation.is24SnippetId ? props.evaluation.is24SnippetId : [] : [],
          mietspiegelSnippet: props.evaluation ? props.evaluation.mietspiegelSnippet ? props.evaluation.mietspiegelSnippet : [] : [],
          mietspiegelSnippetId: props.evaluation ? props.evaluation.mietspiegelSnippetId ? props.evaluation.mietspiegelSnippetId : [] : [],

          cloudURL: props.evaluation ? props.evaluation.cloudURL ? props.evaluation.cloudURL : '' : '',
          affittoNetto: props.evaluation ? (0, _utils.visualizzaDecimaleConVirgola)(props.evaluation.affittoNetto) : '0',
          m2: props.evaluation ? (0, _utils.visualizzaDecimaleConVirgola)(props.evaluation.m2) : '0',
          rendite: props.evaluation ? (0, _utils.visualizzaDecimaleConVirgola)(props.evaluation.rendite) : '0',
          wohnlage: props.evaluation ? props.evaluation.wohnlage : '',
          bodenRichtwert: props.evaluation ? (0, _utils.visualizzaDecimaleConVirgola)(props.evaluation.bodenRichtwert) : '0',
          bodenRichtwert2: props.evaluation ? (0, _utils.visualizzaDecimaleConVirgola)(props.evaluation.bodenRichtwert2) : '0',
          bodenRichtwert3: props.evaluation ? (0, _utils.visualizzaDecimaleConVirgola)(props.evaluation.bodenRichtwert3) : '0',
          dataEvaluation: (0, _moment2.default)(),
          mietspiegel: props.evaluation ? (0, _utils.visualizzaDecimaleConVirgola)(props.evaluation.mietspiegel) : '0',
          mietendeckel: props.evaluation ? (0, _utils.visualizzaDecimaleConVirgola)(props.evaluation.mietendeckel) : '0',
          note: props.evaluation ? props.evaluation.note : '',
          immobilienpreisMin: props.evaluation ? (0, _utils.visualizzaDecimaleConVirgola)(props.evaluation.immobilienpreisMin) : '0',
          immobilienpreisMax: props.evaluation ? (0, _utils.visualizzaDecimaleConVirgola)(props.evaluation.immobilienpreisMax) : '0',
          immobilienpreisAverage: props.evaluation ? (0, _utils.visualizzaDecimaleConVirgola)(props.evaluation.immobilienpreisAverage) : '0',
          is24Evaluation: props.evaluation ? (0, _utils.visualizzaDecimaleConVirgola)(props.evaluation.is24Evaluation) : '0',
          result: props.evaluation ? (0, _utils.visualizzaDecimaleConVirgola)(props.evaluation.result) : '0',
          titolo: props.evaluation ? props.evaluation.titolo : '',
          oggettoId: props.evaluation ? props.evaluation.oggettoId : '',
          visible: props.evaluation ? props.evaluation.visible : true,
          testoIntroduttivoDe: props.evaluation ? props.evaluation.testoIntroduttivoDe ? props.evaluation.testoIntroduttivoDe : '' : '',
          testoFinaleDe: props.evaluation ? props.evaluation.testoFinaleDe ? props.evaluation.testoFinaleDe : '' : '',
          testoIntroduttivoEn: props.evaluation ? props.evaluation.testoIntroduttivoEn ? props.evaluation.testoIntroduttivoEn : '' : '',
          testoFinaleEn: props.evaluation ? props.evaluation.testoFinaleEn ? props.evaluation.testoFinaleEn : '' : '',
          testoIntroduttivoIt: props.evaluation ? props.evaluation.testoIntroduttivoIt ? props.evaluation.testoIntroduttivoIt : '' : '',
          testoFinaleIt: props.evaluation ? props.evaluation.testoFinaleIt ? props.evaluation.testoFinaleIt : '' : ''
        },
        newsletters: {
          dataNewsletter: props.newsletter ? props.newsletter.dataNewsletter && (0, _moment2.default)(props.newsletter.dataNewsletter) : (0, _moment2.default)(),
          dataSentNewsletter: props.newsletter ? props.newsletter.dataSentNewsletter && (0, _moment2.default)(props.newsletter.dataSentNewsletter) : null,
          oggetto1: props.newsletter ? props.newsletter.oggetto1 : null,
          oggetto2: props.newsletter ? props.newsletter.oggetto2 : null,
          oggetto3: props.newsletter ? props.newsletter.oggetto3 : null,
          oggetto4: props.newsletter ? props.newsletter.oggetto4 : null,
          oggetto5: props.newsletter ? props.newsletter.oggetto5 : null,
          oggetto6: props.newsletter ? props.newsletter.oggetto6 : null,
          newsletterText: props.newsletter ? props.newsletterText : '',
          mailchimpId: props.newsletter ? props.newsletter.mailchimpId : null,
          visible: props.newsletter ? props.newsletter.visible : true,
          sent: props.newsletter ? props.newsletter.sent : false
        },

        // ERROR
        error: '',

        // MODAL
        isOpen: false,
        contentLabel: '',
        modalContent: null,

        // SPINNER
        spinner: false
      };
      return _this;
    }

    //RENDER

    // HANDLER


    // le due funzioni partono insieme quindi uso un prevState per modificare lo state altrimenti si sovrascrivono


    _createClass(WithForm, [{
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Component, _extends({
          renderModal: this.renderModal,
          renderError: this.renderError,
          renderInput: this.renderInput,
          renderSingleDate: this.renderSingleDate,
          renderDateRange: this.renderDateRange,
          renderTextArea: this.renderTextArea,
          renderCheckbox: this.renderCheckbox,
          renderSelect: this.renderSelect,
          renderUploadImage: this.renderUploadImage,
          changeHandler: this.changeHandler,
          changeHandlerSelect: this.changeHandlerSelect,
          changeHandlerSelectEvaluation: this.changeHandlerSelectEvaluation,
          changeHandlerValuta: this.changeHandlerValuta,
          changeHandlerValidate: this.changeHandlerValidate,
          onDataChange: this.onDataChange,
          onFocusChange: this.onFocusChange,
          onFocusChange2: this.onFocusChange2,
          onDatesChange: this.onDatesChange,
          changeCheckbox: this.changeCheckbox,
          fileUpload: this.fileUpload
        }, this.props, {
          data: this.state
        }));
      }
    }]);

    return WithForm;
  }(_react2.default.Component);
}

exports.default = withForm;

/***/ }),
/* 22 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserRouter", function() { return BrowserRouter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HashRouter", function() { return HashRouter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return Link; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavLink", function() { return NavLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(276);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "MemoryRouter", function() { return __WEBPACK_IMPORTED_MODULE_2_react_router__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Prompt", function() { return __WEBPACK_IMPORTED_MODULE_2_react_router__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_2_react_router__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_2_react_router__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_2_react_router__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "StaticRouter", function() { return __WEBPACK_IMPORTED_MODULE_2_react_router__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_2_react_router__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "generatePath", function() { return __WEBPACK_IMPORTED_MODULE_2_react_router__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "matchPath", function() { return __WEBPACK_IMPORTED_MODULE_2_react_router__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_2_react_router__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "__RouterContext", function() { return __WEBPACK_IMPORTED_MODULE_2_react_router__["h"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tiny_warning__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tiny_invariant__ = __webpack_require__(146);











/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */](BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = __WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */](_this.props);
    return _this;
  }

  var _proto = BrowserRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  BrowserRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    forceRefresh: PropTypes.bool,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number
  };

  BrowserRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */](HashRouter, _React$Component);

  function HashRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = __WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */](_this.props);
    return _this;
  }

  var _proto = HashRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  HashRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    getUserConfirmation: PropTypes.func,
    hashType: PropTypes.oneOf(["hashbang", "noslash", "slash"])
  };

  HashRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.") : void 0;
  };
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
/**
 * The public API for rendering a history-aware <a>.
 */


var Link =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */](Link, _React$Component);

  function Link() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Link.prototype;

  _proto.handleClick = function handleClick(event, history) {
    if (this.props.onClick) this.props.onClick(event);

    if (!event.defaultPrevented && // onClick prevented default
    event.button === 0 && ( // ignore everything but left clicks
    !this.props.target || this.props.target === "_self") && // let browser handle "target=_blank" etc.
    !isModifiedEvent(event) // ignore clicks with modifier keys
    ) {
        event.preventDefault();
        var method = this.props.replace ? history.replace : history.push;
        method(this.props.to);
      }
  };

  _proto.render = function render() {
    var _this = this;

    var _this$props = this.props,
        innerRef = _this$props.innerRef,
        replace = _this$props.replace,
        to = _this$props.to,
        rest = __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */](_this$props, ["innerRef", "replace", "to"]); // eslint-disable-line no-unused-vars


    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["h" /* __RouterContext */].Consumer, null, function (context) {
      !context ?  false ? invariant(false, "You should not use <Link> outside a <Router>") : __WEBPACK_IMPORTED_MODULE_8_tiny_invariant__["a" /* default */](false) : void 0;
      var location = typeof to === "string" ? __WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */](to, null, null, context.location) : to;
      var href = location ? context.history.createHref(location) : "";
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */]({}, rest, {
        onClick: function onClick(event) {
          return _this.handleClick(event, context.history);
        },
        href: href,
        ref: innerRef
      }));
    });
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  var toType = PropTypes.oneOfType([PropTypes.string, PropTypes.object]);
  var innerRefType = PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]);
  Link.propTypes = {
    innerRef: innerRefType,
    onClick: PropTypes.func,
    replace: PropTypes.bool,
    target: PropTypes.string,
    to: toType.isRequired
  };
}

function joinClassnames() {
  for (var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++) {
    classnames[_key] = arguments[_key];
  }

  return classnames.filter(function (i) {
    return i;
  }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */


function NavLink(_ref) {
  var _ref$ariaCurrent = _ref["aria-current"],
      ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent,
      _ref$activeClassName = _ref.activeClassName,
      activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName,
      activeStyle = _ref.activeStyle,
      classNameProp = _ref.className,
      exact = _ref.exact,
      isActiveProp = _ref.isActive,
      location = _ref.location,
      strict = _ref.strict,
      styleProp = _ref.style,
      to = _ref.to,
      rest = __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */](_ref, ["aria-current", "activeClassName", "activeStyle", "className", "exact", "isActive", "location", "strict", "style", "to"]);

  var path = typeof to === "object" ? to.pathname : to; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202

  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["d" /* Route */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;
      var isActive = !!(isActiveProp ? isActiveProp(match, location) : match);
      var className = isActive ? joinClassnames(classNameProp, activeClassName) : classNameProp;
      var style = isActive ? __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */]({}, styleProp, activeStyle) : styleProp;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Link, __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */]({
        "aria-current": isActive && ariaCurrent || null,
        className: className,
        style: style,
        to: to
      }, rest));
    }
  });
}

if (false) {
  var ariaCurrentType = PropTypes.oneOf(["page", "step", "location", "date", "time", "true"]);
  NavLink.propTypes = _extends({}, Link.propTypes, {
    "aria-current": ariaCurrentType,
    activeClassName: PropTypes.string,
    activeStyle: PropTypes.object,
    className: PropTypes.string,
    exact: Route.propTypes.exact,
    isActive: PropTypes.func,
    location: PropTypes.object,
    strict: Route.propTypes.strict,
    style: PropTypes.object
  });
}




/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =  true ? __webpack_require__(946) : require('./build');

//# sourceMappingURL=index.js.map

/***/ }),
/* 25 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 27 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var calendarLabel = 'Calendar';
var closeDatePicker = 'Close';
var focusStartDate = 'Interact with the calendar and add the check-in date for your trip.';
var clearDate = 'Clear Date';
var clearDates = 'Clear Dates';
var jumpToPrevMonth = 'Move backward to switch to the previous month';
var jumpToNextMonth = 'Move forward to switch to the next month';
var keyboardShortcuts = 'Keyboard Shortcuts';
var showKeyboardShortcutsPanel = 'Open the keyboard shortcuts panel';
var hideKeyboardShortcutsPanel = 'Close the shortcuts panel';
var openThisPanel = 'Open this panel';
var enterKey = 'Enter key';
var leftArrowRightArrow = 'Right and left arrow keys';
var upArrowDownArrow = 'up and down arrow keys';
var pageUpPageDown = 'page up and page down keys';
var homeEnd = 'Home and end keys';
var escape = 'Escape key';
var questionMark = 'Question mark';
var selectFocusedDate = 'Select the date in focus';
var moveFocusByOneDay = 'Move backward (left) and forward (right) by one day';
var moveFocusByOneWeek = 'Move backward (up) and forward (down) by one week';
var moveFocusByOneMonth = 'Switch months';
var moveFocustoStartAndEndOfWeek = 'Go to the first or last day of a week';
var returnFocusToInput = 'Return to the date input field';
var keyboardNavigationInstructions = 'Press the down arrow key to interact with the calendar and\n  select a date. Press the question mark key to get the keyboard shortcuts for changing dates.';

// eslint-disable-next-line camelcase
var chooseAvailableStartDate = function chooseAvailableStartDate(_ref) {
  var date = _ref.date;
  return 'Choose ' + String(date) + ' as your check-in date. It\'s available.';
};

// eslint-disable-next-line camelcase
var chooseAvailableEndDate = function chooseAvailableEndDate(_ref2) {
  var date = _ref2.date;
  return 'Choose ' + String(date) + ' as your check-out date. It\'s available.';
};
var chooseAvailableDate = function chooseAvailableDate(_ref3) {
  var date = _ref3.date;
  return date;
};
var dateIsUnavailable = function dateIsUnavailable(_ref4) {
  var date = _ref4.date;
  return 'Not available. ' + String(date);
};

exports['default'] = {
  calendarLabel: calendarLabel,
  closeDatePicker: closeDatePicker,
  focusStartDate: focusStartDate,
  clearDate: clearDate,
  clearDates: clearDates,
  jumpToPrevMonth: jumpToPrevMonth,
  jumpToNextMonth: jumpToNextMonth,
  keyboardShortcuts: keyboardShortcuts,
  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
  openThisPanel: openThisPanel,
  enterKey: enterKey,
  leftArrowRightArrow: leftArrowRightArrow,
  upArrowDownArrow: upArrowDownArrow,
  pageUpPageDown: pageUpPageDown,
  homeEnd: homeEnd,
  escape: escape,
  questionMark: questionMark,
  selectFocusedDate: selectFocusedDate,
  moveFocusByOneDay: moveFocusByOneDay,
  moveFocusByOneWeek: moveFocusByOneWeek,
  moveFocusByOneMonth: moveFocusByOneMonth,
  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
  returnFocusToInput: returnFocusToInput,
  keyboardNavigationInstructions: keyboardNavigationInstructions,

  chooseAvailableStartDate: chooseAvailableStartDate,
  chooseAvailableEndDate: chooseAvailableEndDate,
  dateIsUnavailable: dateIsUnavailable
};
var DateRangePickerPhrases = exports.DateRangePickerPhrases = {
  calendarLabel: calendarLabel,
  closeDatePicker: closeDatePicker,
  clearDates: clearDates,
  focusStartDate: focusStartDate,
  jumpToPrevMonth: jumpToPrevMonth,
  jumpToNextMonth: jumpToNextMonth,
  keyboardShortcuts: keyboardShortcuts,
  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
  openThisPanel: openThisPanel,
  enterKey: enterKey,
  leftArrowRightArrow: leftArrowRightArrow,
  upArrowDownArrow: upArrowDownArrow,
  pageUpPageDown: pageUpPageDown,
  homeEnd: homeEnd,
  escape: escape,
  questionMark: questionMark,
  selectFocusedDate: selectFocusedDate,
  moveFocusByOneDay: moveFocusByOneDay,
  moveFocusByOneWeek: moveFocusByOneWeek,
  moveFocusByOneMonth: moveFocusByOneMonth,
  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
  returnFocusToInput: returnFocusToInput,
  keyboardNavigationInstructions: keyboardNavigationInstructions,
  chooseAvailableStartDate: chooseAvailableStartDate,
  chooseAvailableEndDate: chooseAvailableEndDate,
  dateIsUnavailable: dateIsUnavailable
};

var DateRangePickerInputPhrases = exports.DateRangePickerInputPhrases = {
  focusStartDate: focusStartDate,
  clearDates: clearDates,
  keyboardNavigationInstructions: keyboardNavigationInstructions
};

var SingleDatePickerPhrases = exports.SingleDatePickerPhrases = {
  calendarLabel: calendarLabel,
  closeDatePicker: closeDatePicker,
  clearDate: clearDate,
  jumpToPrevMonth: jumpToPrevMonth,
  jumpToNextMonth: jumpToNextMonth,
  keyboardShortcuts: keyboardShortcuts,
  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
  openThisPanel: openThisPanel,
  enterKey: enterKey,
  leftArrowRightArrow: leftArrowRightArrow,
  upArrowDownArrow: upArrowDownArrow,
  pageUpPageDown: pageUpPageDown,
  homeEnd: homeEnd,
  escape: escape,
  questionMark: questionMark,
  selectFocusedDate: selectFocusedDate,
  moveFocusByOneDay: moveFocusByOneDay,
  moveFocusByOneWeek: moveFocusByOneWeek,
  moveFocusByOneMonth: moveFocusByOneMonth,
  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
  returnFocusToInput: returnFocusToInput,
  keyboardNavigationInstructions: keyboardNavigationInstructions,
  chooseAvailableDate: chooseAvailableDate,
  dateIsUnavailable: dateIsUnavailable
};

var SingleDatePickerInputPhrases = exports.SingleDatePickerInputPhrases = {
  clearDate: clearDate,
  keyboardNavigationInstructions: keyboardNavigationInstructions
};

var DayPickerPhrases = exports.DayPickerPhrases = {
  calendarLabel: calendarLabel,
  jumpToPrevMonth: jumpToPrevMonth,
  jumpToNextMonth: jumpToNextMonth,
  keyboardShortcuts: keyboardShortcuts,
  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
  openThisPanel: openThisPanel,
  enterKey: enterKey,
  leftArrowRightArrow: leftArrowRightArrow,
  upArrowDownArrow: upArrowDownArrow,
  pageUpPageDown: pageUpPageDown,
  homeEnd: homeEnd,
  escape: escape,
  questionMark: questionMark,
  selectFocusedDate: selectFocusedDate,
  moveFocusByOneDay: moveFocusByOneDay,
  moveFocusByOneWeek: moveFocusByOneWeek,
  moveFocusByOneMonth: moveFocusByOneMonth,
  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
  returnFocusToInput: returnFocusToInput,
  chooseAvailableStartDate: chooseAvailableStartDate,
  chooseAvailableEndDate: chooseAvailableEndDate,
  chooseAvailableDate: chooseAvailableDate,
  dateIsUnavailable: dateIsUnavailable
};

var DayPickerKeyboardShortcutsPhrases = exports.DayPickerKeyboardShortcutsPhrases = {
  keyboardShortcuts: keyboardShortcuts,
  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
  openThisPanel: openThisPanel,
  enterKey: enterKey,
  leftArrowRightArrow: leftArrowRightArrow,
  upArrowDownArrow: upArrowDownArrow,
  pageUpPageDown: pageUpPageDown,
  homeEnd: homeEnd,
  escape: escape,
  questionMark: questionMark,
  selectFocusedDate: selectFocusedDate,
  moveFocusByOneDay: moveFocusByOneDay,
  moveFocusByOneWeek: moveFocusByOneWeek,
  moveFocusByOneMonth: moveFocusByOneMonth,
  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
  returnFocusToInput: returnFocusToInput
};

var DayPickerNavigationPhrases = exports.DayPickerNavigationPhrases = {
  jumpToPrevMonth: jumpToPrevMonth,
  jumpToNextMonth: jumpToNextMonth
};

var CalendarDayPhrases = exports.CalendarDayPhrases = {
  chooseAvailableDate: chooseAvailableDate,
  dateIsUnavailable: dateIsUnavailable
};

/***/ }),
/* 28 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 29 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_RESULT__;!function(t){ true?!(__WEBPACK_AMD_DEFINE_FACTORY__ = (t),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):t()}(function(){"use strict";
/** @license
   * jsPDF - PDF Document creation from JavaScript
   * Version 1.5.3 Built on 2018-12-27T14:11:42.696Z
   *                      CommitID d93d28db14
   *
   * Copyright (c) 2010-2016 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
   *               2010 Aaron Spike, https://github.com/acspike
   *               2012 Willow Systems Corporation, willow-systems.com
   *               2012 Pablo Hess, https://github.com/pablohess
   *               2012 Florian Jenett, https://github.com/fjenett
   *               2013 Warren Weckesser, https://github.com/warrenweckesser
   *               2013 Youssef Beddad, https://github.com/lifof
   *               2013 Lee Driscoll, https://github.com/lsdriscoll
   *               2013 Stefan Slonevskiy, https://github.com/stefslon
   *               2013 Jeremy Morel, https://github.com/jmorel
   *               2013 Christoph Hartmann, https://github.com/chris-rock
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 James Makes, https://github.com/dollaruw
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 Steven Spungin, https://github.com/Flamenco
   *               2014 Kenneth Glassey, https://github.com/Gavvers
   *
   * Licensed under the MIT License
   *
   * Contributor(s):
   *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
   *    kim3er, mfo, alnorth, Flamenco
   */function se(t){return(se="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}!function(t){if("object"!==se(t.console)){t.console={};for(var e,n,r=t.console,i=function(){},o=["memory"],a="assert,clear,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn".split(",");e=o.pop();)r[e]||(r[e]={});for(;n=a.pop();)r[n]||(r[n]=i)}var s,l,h,u,c="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";void 0===t.btoa&&(t.btoa=function(t){var e,n,r,i,o,a=0,s=0,l="",h=[];if(!t)return t;for(;e=(o=t.charCodeAt(a++)<<16|t.charCodeAt(a++)<<8|t.charCodeAt(a++))>>18&63,n=o>>12&63,r=o>>6&63,i=63&o,h[s++]=c.charAt(e)+c.charAt(n)+c.charAt(r)+c.charAt(i),a<t.length;);l=h.join("");var u=t.length%3;return(u?l.slice(0,u-3):l)+"===".slice(u||3)}),void 0===t.atob&&(t.atob=function(t){var e,n,r,i,o,a,s=0,l=0,h=[];if(!t)return t;for(t+="";e=(a=c.indexOf(t.charAt(s++))<<18|c.indexOf(t.charAt(s++))<<12|(i=c.indexOf(t.charAt(s++)))<<6|(o=c.indexOf(t.charAt(s++))))>>16&255,n=a>>8&255,r=255&a,h[l++]=64==i?String.fromCharCode(e):64==o?String.fromCharCode(e,n):String.fromCharCode(e,n,r),s<t.length;);return h.join("")}),Array.prototype.map||(Array.prototype.map=function(t){if(null==this||"function"!=typeof t)throw new TypeError;for(var e=Object(this),n=e.length>>>0,r=new Array(n),i=1<arguments.length?arguments[1]:void 0,o=0;o<n;o++)o in e&&(r[o]=t.call(i,e[o],o,e));return r}),Array.isArray||(Array.isArray=function(t){return"[object Array]"===Object.prototype.toString.call(t)}),Array.prototype.forEach||(Array.prototype.forEach=function(t,e){if(null==this||"function"!=typeof t)throw new TypeError;for(var n=Object(this),r=n.length>>>0,i=0;i<r;i++)i in n&&t.call(e,n[i],i,n)}),Array.prototype.find||Object.defineProperty(Array.prototype,"find",{value:function(t){if(null==this)throw new TypeError('"this" is null or not defined');var e=Object(this),n=e.length>>>0;if("function"!=typeof t)throw new TypeError("predicate must be a function");for(var r=arguments[1],i=0;i<n;){var o=e[i];if(t.call(r,o,i,e))return o;i++}},configurable:!0,writable:!0}),Object.keys||(Object.keys=(s=Object.prototype.hasOwnProperty,l=!{toString:null}.propertyIsEnumerable("toString"),u=(h=["toString","toLocaleString","valueOf","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","constructor"]).length,function(t){if("object"!==se(t)&&("function"!=typeof t||null===t))throw new TypeError;var e,n,r=[];for(e in t)s.call(t,e)&&r.push(e);if(l)for(n=0;n<u;n++)s.call(t,h[n])&&r.push(h[n]);return r})),"function"!=typeof Object.assign&&(Object.assign=function(t){if(null==t)throw new TypeError("Cannot convert undefined or null to object");t=Object(t);for(var e=1;e<arguments.length;e++){var n=arguments[e];if(null!=n)for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t[r]=n[r])}return t}),String.prototype.trim||(String.prototype.trim=function(){return this.replace(/^\s+|\s+$/g,"")}),String.prototype.trimLeft||(String.prototype.trimLeft=function(){return this.replace(/^\s+/g,"")}),String.prototype.trimRight||(String.prototype.trimRight=function(){return this.replace(/\s+$/g,"")}),Number.isInteger=Number.isInteger||function(t){return"number"==typeof t&&isFinite(t)&&Math.floor(t)===t}}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")());var t,e,n,_,l,F,P,p,d,k,a,o,s,h,u,c,r,i,f,g,m,y,v,w,b,x,I,C,B,N,L,A,S,j,E,M,O,q,T,R,D,U,z,H,W,V,G,Y,J,X,K,Z,Q,$,tt,et,nt,rt,it,ot,at,st,lt=function(ie){function oe(o){if("object"!==se(o))throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");var a={};this.subscribe=function(t,e,n){if(n=n||!1,"string"!=typeof t||"function"!=typeof e||"boolean"!=typeof n)throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");a.hasOwnProperty(t)||(a[t]={});var r=Math.random().toString(35);return a[t][r]=[e,!!n],r},this.unsubscribe=function(t){for(var e in a)if(a[e][t])return delete a[e][t],0===Object.keys(a[e]).length&&delete a[e],!0;return!1},this.publish=function(t){if(a.hasOwnProperty(t)){var e=Array.prototype.slice.call(arguments,1),n=[];for(var r in a[t]){var i=a[t][r];try{i[0].apply(o,e)}catch(t){ie.console&&console.error("jsPDF PubSub Error",t.message,t)}i[1]&&n.push(r)}n.length&&n.forEach(this.unsubscribe)}},this.getTopics=function(){return a}}function ae(t,e,i,n){var r={},o=[],a=1;"object"===se(t)&&(t=(r=t).orientation,e=r.unit||e,i=r.format||i,n=r.compress||r.compressPdf||n,o=r.filters||(!0===n?["FlateEncode"]:o),a="number"==typeof r.userUnit?Math.abs(r.userUnit):1),e=e||"mm",t=(""+(t||"P")).toLowerCase();var s=r.putOnlyUsedFonts||!0,K={},l={internal:{},__private__:{}};l.__private__.PubSub=oe;var h="1.3",u=l.__private__.getPdfVersion=function(){return h},c=(l.__private__.setPdfVersion=function(t){h=t},{a0:[2383.94,3370.39],a1:[1683.78,2383.94],a2:[1190.55,1683.78],a3:[841.89,1190.55],a4:[595.28,841.89],a5:[419.53,595.28],a6:[297.64,419.53],a7:[209.76,297.64],a8:[147.4,209.76],a9:[104.88,147.4],a10:[73.7,104.88],b0:[2834.65,4008.19],b1:[2004.09,2834.65],b2:[1417.32,2004.09],b3:[1000.63,1417.32],b4:[708.66,1000.63],b5:[498.9,708.66],b6:[354.33,498.9],b7:[249.45,354.33],b8:[175.75,249.45],b9:[124.72,175.75],b10:[87.87,124.72],c0:[2599.37,3676.54],c1:[1836.85,2599.37],c2:[1298.27,1836.85],c3:[918.43,1298.27],c4:[649.13,918.43],c5:[459.21,649.13],c6:[323.15,459.21],c7:[229.61,323.15],c8:[161.57,229.61],c9:[113.39,161.57],c10:[79.37,113.39],dl:[311.81,623.62],letter:[612,792],"government-letter":[576,756],legal:[612,1008],"junior-legal":[576,360],ledger:[1224,792],tabloid:[792,1224],"credit-card":[153,243]}),f=(l.__private__.getPageFormats=function(){return c},l.__private__.getPageFormat=function(t){return c[t]});"string"==typeof i&&(i=f(i)),i=i||f("a4");var p,Z=l.f2=l.__private__.f2=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f2");return t.toFixed(2)},Q=l.__private__.f3=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f3");return t.toFixed(3)},d="00000000000000000000000000000000",g=l.__private__.getFileId=function(){return d},m=l.__private__.setFileId=function(t){return t=t||"12345678901234567890123456789012".split("").map(function(){return"ABCDEF0123456789".charAt(Math.floor(16*Math.random()))}).join(""),d=t};l.setFileId=function(t){return m(t),this},l.getFileId=function(){return g()};var y=l.__private__.convertDateToPDFDate=function(t){var e=t.getTimezoneOffset(),n=e<0?"+":"-",r=Math.floor(Math.abs(e/60)),i=Math.abs(e%60),o=[n,P(r),"'",P(i),"'"].join("");return["D:",t.getFullYear(),P(t.getMonth()+1),P(t.getDate()),P(t.getHours()),P(t.getMinutes()),P(t.getSeconds()),o].join("")},v=l.__private__.convertPDFDateToDate=function(t){var e=parseInt(t.substr(2,4),10),n=parseInt(t.substr(6,2),10)-1,r=parseInt(t.substr(8,2),10),i=parseInt(t.substr(10,2),10),o=parseInt(t.substr(12,2),10),a=parseInt(t.substr(14,2),10);parseInt(t.substr(16,2),10),parseInt(t.substr(20,2),10);return new Date(e,n,r,i,o,a,0)},w=l.__private__.setCreationDate=function(t){var e;if(void 0===t&&(t=new Date),"object"===se(t)&&"[object Date]"===Object.prototype.toString.call(t))e=y(t);else{if(!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|\-0[0-9]|\-1[0-1])\'(0[0-9]|[1-5][0-9])\'?$/.test(t))throw new Error("Invalid argument passed to jsPDF.setCreationDate");e=t}return p=e},b=l.__private__.getCreationDate=function(t){var e=p;return"jsDate"===t&&(e=v(p)),e};l.setCreationDate=function(t){return w(t),this},l.getCreationDate=function(t){return b(t)};var x,N,L,A,S,$,_,F,P=l.__private__.padd2=function(t){return("0"+parseInt(t)).slice(-2)},k=!1,I=[],C=[],B=0,tt=(l.__private__.setCustomOutputDestination=function(t){N=t},l.__private__.resetCustomOutputDestination=function(t){N=void 0},l.__private__.out=function(t){var e;return t="string"==typeof t?t:t.toString(),(e=void 0===N?k?I[x]:C:N).push(t),k||(B+=t.length+1),e}),j=l.__private__.write=function(t){return tt(1===arguments.length?t.toString():Array.prototype.join.call(arguments," "))},E=l.__private__.getArrayBuffer=function(t){for(var e=t.length,n=new ArrayBuffer(e),r=new Uint8Array(n);e--;)r[e]=t.charCodeAt(e);return n},M=[["Helvetica","helvetica","normal","WinAnsiEncoding"],["Helvetica-Bold","helvetica","bold","WinAnsiEncoding"],["Helvetica-Oblique","helvetica","italic","WinAnsiEncoding"],["Helvetica-BoldOblique","helvetica","bolditalic","WinAnsiEncoding"],["Courier","courier","normal","WinAnsiEncoding"],["Courier-Bold","courier","bold","WinAnsiEncoding"],["Courier-Oblique","courier","italic","WinAnsiEncoding"],["Courier-BoldOblique","courier","bolditalic","WinAnsiEncoding"],["Times-Roman","times","normal","WinAnsiEncoding"],["Times-Bold","times","bold","WinAnsiEncoding"],["Times-Italic","times","italic","WinAnsiEncoding"],["Times-BoldItalic","times","bolditalic","WinAnsiEncoding"],["ZapfDingbats","zapfdingbats","normal",null],["Symbol","symbol","normal",null]],et=(l.__private__.getStandardFonts=function(t){return M},r.fontSize||16),O=(l.__private__.setFontSize=l.setFontSize=function(t){return et=t,this},l.__private__.getFontSize=l.getFontSize=function(){return et}),nt=r.R2L||!1,q=(l.__private__.setR2L=l.setR2L=function(t){return nt=t,this},l.__private__.getR2L=l.getR2L=function(t){return nt},l.__private__.setZoomMode=function(t){var e=[void 0,null,"fullwidth","fullheight","fullpage","original"];if(/^\d*\.?\d*\%$/.test(t))L=t;else if(isNaN(t)){if(-1===e.indexOf(t))throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "'+t+'" is not recognized.');L=t}else L=parseInt(t,10)}),T=(l.__private__.getZoomMode=function(){return L},l.__private__.setPageMode=function(t){if(-1==[void 0,null,"UseNone","UseOutlines","UseThumbs","FullScreen"].indexOf(t))throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "'+t+'" is not recognized.');A=t}),R=(l.__private__.getPageMode=function(){return A},l.__private__.setLayoutMode=function(t){if(-1==[void 0,null,"continuous","single","twoleft","tworight","two"].indexOf(t))throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "'+t+'" is not recognized.');S=t}),D=(l.__private__.getLayoutMode=function(){return S},l.__private__.setDisplayMode=l.setDisplayMode=function(t,e,n){return q(t),R(e),T(n),this},{title:"",subject:"",author:"",keywords:"",creator:""}),U=(l.__private__.getDocumentProperty=function(t){if(-1===Object.keys(D).indexOf(t))throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");return D[t]},l.__private__.getDocumentProperties=function(t){return D},l.__private__.setDocumentProperties=l.setProperties=l.setDocumentProperties=function(t){for(var e in D)D.hasOwnProperty(e)&&t[e]&&(D[e]=t[e]);return this},l.__private__.setDocumentProperty=function(t,e){if(-1===Object.keys(D).indexOf(t))throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");return D[t]=e},0),z=[],rt={},H={},W=0,V=[],G=[],it=new oe(l),Y=r.hotfixes||[],J=l.__private__.newObject=function(){var t=X();return ot(t,!0),t},X=l.__private__.newObjectDeferred=function(){return z[++U]=function(){return B},U},ot=function(t,e){return e="boolean"==typeof e&&e,z[t]=B,e&&tt(t+" 0 obj"),t},at=l.__private__.newAdditionalObject=function(){var t={objId:X(),content:""};return G.push(t),t},st=X(),lt=X(),ht=l.__private__.decodeColorString=function(t){var e=t.split(" ");if(2===e.length&&("g"===e[1]||"G"===e[1])){var n=parseFloat(e[0]);e=[n,n,n,"r"]}for(var r="#",i=0;i<3;i++)r+=("0"+Math.floor(255*parseFloat(e[i])).toString(16)).slice(-2);return r},ut=l.__private__.encodeColorString=function(t){var e;"string"==typeof t&&(t={ch1:t});var n=t.ch1,r=t.ch2,i=t.ch3,o=t.ch4,a=(t.precision,"draw"===t.pdfColorType?["G","RG","K"]:["g","rg","k"]);if("string"==typeof n&&"#"!==n.charAt(0)){var s=new RGBColor(n);if(s.ok)n=s.toHex();else if(!/^\d*\.?\d*$/.test(n))throw new Error('Invalid color "'+n+'" passed to jsPDF.encodeColorString.')}if("string"==typeof n&&/^#[0-9A-Fa-f]{3}$/.test(n)&&(n="#"+n[1]+n[1]+n[2]+n[2]+n[3]+n[3]),"string"==typeof n&&/^#[0-9A-Fa-f]{6}$/.test(n)){var l=parseInt(n.substr(1),16);n=l>>16&255,r=l>>8&255,i=255&l}if(void 0===r||void 0===o&&n===r&&r===i)if("string"==typeof n)e=n+" "+a[0];else switch(t.precision){case 2:e=Z(n/255)+" "+a[0];break;case 3:default:e=Q(n/255)+" "+a[0]}else if(void 0===o||"object"===se(o)){if(o&&!isNaN(o.a)&&0===o.a)return e=["1.000","1.000","1.000",a[1]].join(" ");if("string"==typeof n)e=[n,r,i,a[1]].join(" ");else switch(t.precision){case 2:e=[Z(n/255),Z(r/255),Z(i/255),a[1]].join(" ");break;default:case 3:e=[Q(n/255),Q(r/255),Q(i/255),a[1]].join(" ")}}else if("string"==typeof n)e=[n,r,i,o,a[2]].join(" ");else switch(t.precision){case 2:e=[Z(n/255),Z(r/255),Z(i/255),Z(o/255),a[2]].join(" ");break;case 3:default:e=[Q(n/255),Q(r/255),Q(i/255),Q(o/255),a[2]].join(" ")}return e},ct=l.__private__.getFilters=function(){return o},ft=l.__private__.putStream=function(t){var e=(t=t||{}).data||"",n=t.filters||ct(),r=t.alreadyAppliedFilters||[],i=t.addLength1||!1,o=e.length,a={};!0===n&&(n=["FlateEncode"]);var s=t.additionalKeyValues||[],l=(a=void 0!==ae.API.processDataByFilters?ae.API.processDataByFilters(e,n):{data:e,reverseChain:[]}).reverseChain+(Array.isArray(r)?r.join(" "):r.toString());0!==a.data.length&&(s.push({key:"Length",value:a.data.length}),!0===i&&s.push({key:"Length1",value:o})),0!=l.length&&(l.split("/").length-1==1?s.push({key:"Filter",value:l}):s.push({key:"Filter",value:"["+l+"]"})),tt("<<");for(var h=0;h<s.length;h++)tt("/"+s[h].key+" "+s[h].value);tt(">>"),0!==a.data.length&&(tt("stream"),tt(a.data),tt("endstream"))},pt=l.__private__.putPage=function(t){t.mediaBox;var e=t.number,n=t.data,r=t.objId,i=t.contentsObjId;ot(r,!0);V[x].mediaBox.topRightX,V[x].mediaBox.bottomLeftX,V[x].mediaBox.topRightY,V[x].mediaBox.bottomLeftY;tt("<</Type /Page"),tt("/Parent "+t.rootDictionaryObjId+" 0 R"),tt("/Resources "+t.resourceDictionaryObjId+" 0 R"),tt("/MediaBox ["+parseFloat(Z(t.mediaBox.bottomLeftX))+" "+parseFloat(Z(t.mediaBox.bottomLeftY))+" "+Z(t.mediaBox.topRightX)+" "+Z(t.mediaBox.topRightY)+"]"),null!==t.cropBox&&tt("/CropBox ["+Z(t.cropBox.bottomLeftX)+" "+Z(t.cropBox.bottomLeftY)+" "+Z(t.cropBox.topRightX)+" "+Z(t.cropBox.topRightY)+"]"),null!==t.bleedBox&&tt("/BleedBox ["+Z(t.bleedBox.bottomLeftX)+" "+Z(t.bleedBox.bottomLeftY)+" "+Z(t.bleedBox.topRightX)+" "+Z(t.bleedBox.topRightY)+"]"),null!==t.trimBox&&tt("/TrimBox ["+Z(t.trimBox.bottomLeftX)+" "+Z(t.trimBox.bottomLeftY)+" "+Z(t.trimBox.topRightX)+" "+Z(t.trimBox.topRightY)+"]"),null!==t.artBox&&tt("/ArtBox ["+Z(t.artBox.bottomLeftX)+" "+Z(t.artBox.bottomLeftY)+" "+Z(t.artBox.topRightX)+" "+Z(t.artBox.topRightY)+"]"),"number"==typeof t.userUnit&&1!==t.userUnit&&tt("/UserUnit "+t.userUnit),it.publish("putPage",{objId:r,pageContext:V[e],pageNumber:e,page:n}),tt("/Contents "+i+" 0 R"),tt(">>"),tt("endobj");var o=n.join("\n");return ot(i,!0),ft({data:o,filters:ct()}),tt("endobj"),r},dt=l.__private__.putPages=function(){var t,e,n=[];for(t=1;t<=W;t++)V[t].objId=X(),V[t].contentsObjId=X();for(t=1;t<=W;t++)n.push(pt({number:t,data:I[t],objId:V[t].objId,contentsObjId:V[t].contentsObjId,mediaBox:V[t].mediaBox,cropBox:V[t].cropBox,bleedBox:V[t].bleedBox,trimBox:V[t].trimBox,artBox:V[t].artBox,userUnit:V[t].userUnit,rootDictionaryObjId:st,resourceDictionaryObjId:lt}));ot(st,!0),tt("<</Type /Pages");var r="/Kids [";for(e=0;e<W;e++)r+=n[e]+" 0 R ";tt(r+"]"),tt("/Count "+W),tt(">>"),tt("endobj"),it.publish("postPutPages")},gt=function(){!function(){for(var t in rt)rt.hasOwnProperty(t)&&(!1===s||!0===s&&K.hasOwnProperty(t))&&(e=rt[t],it.publish("putFont",{font:e,out:tt,newObject:J,putStream:ft}),!0!==e.isAlreadyPutted&&(e.objectNumber=J(),tt("<<"),tt("/Type /Font"),tt("/BaseFont /"+e.postScriptName),tt("/Subtype /Type1"),"string"==typeof e.encoding&&tt("/Encoding /"+e.encoding),tt("/FirstChar 32"),tt("/LastChar 255"),tt(">>"),tt("endobj")));var e}(),it.publish("putResources"),ot(lt,!0),tt("<<"),function(){for(var t in tt("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"),tt("/Font <<"),rt)rt.hasOwnProperty(t)&&(!1===s||!0===s&&K.hasOwnProperty(t))&&tt("/"+t+" "+rt[t].objectNumber+" 0 R");tt(">>"),tt("/XObject <<"),it.publish("putXobjectDict"),tt(">>")}(),tt(">>"),tt("endobj"),it.publish("postPutResources")},mt=function(t,e,n){H.hasOwnProperty(e)||(H[e]={}),H[e][n]=t},yt=function(t,e,n,r,i){i=i||!1;var o="F"+(Object.keys(rt).length+1).toString(10),a={id:o,postScriptName:t,fontName:e,fontStyle:n,encoding:r,isStandardFont:i,metadata:{}};return it.publish("addFont",{font:a,instance:this}),void 0!==o&&(rt[o]=a,mt(o,e,n)),o},vt=l.__private__.pdfEscape=l.pdfEscape=function(t,e){return function(t,e){var n,r,i,o,a,s,l,h,u;if(i=(e=e||{}).sourceEncoding||"Unicode",a=e.outputEncoding,(e.autoencode||a)&&rt[$].metadata&&rt[$].metadata[i]&&rt[$].metadata[i].encoding&&(o=rt[$].metadata[i].encoding,!a&&rt[$].encoding&&(a=rt[$].encoding),!a&&o.codePages&&(a=o.codePages[0]),"string"==typeof a&&(a=o[a]),a)){for(l=!1,s=[],n=0,r=t.length;n<r;n++)(h=a[t.charCodeAt(n)])?s.push(String.fromCharCode(h)):s.push(t[n]),s[n].charCodeAt(0)>>8&&(l=!0);t=s.join("")}for(n=t.length;void 0===l&&0!==n;)t.charCodeAt(n-1)>>8&&(l=!0),n--;if(!l)return t;for(s=e.noBOM?[]:[254,255],n=0,r=t.length;n<r;n++){if((u=(h=t.charCodeAt(n))>>8)>>8)throw new Error("Character at position "+n+" of string '"+t+"' exceeds 16bits. Cannot be encoded into UCS-2 BE");s.push(u),s.push(h-(u<<8))}return String.fromCharCode.apply(void 0,s)}(t,e).replace(/\\/g,"\\\\").replace(/\(/g,"\\(").replace(/\)/g,"\\)")},wt=l.__private__.beginPage=function(t,e){var n,r="string"==typeof e&&e.toLowerCase();if("string"==typeof t&&(n=f(t.toLowerCase()))&&(t=n[0],e=n[1]),Array.isArray(t)&&(e=t[1],t=t[0]),(isNaN(t)||isNaN(e))&&(t=i[0],e=i[1]),r){switch(r.substr(0,1)){case"l":t<e&&(r="s");break;case"p":e<t&&(r="s")}"s"===r&&(n=t,t=e,e=n)}(14400<t||14400<e)&&(console.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"),t=Math.min(14400,t),e=Math.min(14400,e)),i=[t,e],k=!0,I[++W]=[],V[W]={objId:0,contentsObjId:0,userUnit:Number(a),artBox:null,bleedBox:null,cropBox:null,trimBox:null,mediaBox:{bottomLeftX:0,bottomLeftY:0,topRightX:Number(t),topRightY:Number(e)}},xt(W)},bt=function(){wt.apply(this,arguments),Dt(Rt),tt(Jt),0!==te&&tt(te+" J"),0!==ne&&tt(ne+" j"),it.publish("addPage",{pageNumber:W})},xt=function(t){0<t&&t<=W&&(x=t)},Nt=l.__private__.getNumberOfPages=l.getNumberOfPages=function(){return I.length-1},Lt=function(t,e,n){var r,i=void 0;return n=n||{},t=void 0!==t?t:rt[$].fontName,e=void 0!==e?e:rt[$].fontStyle,r=t.toLowerCase(),void 0!==H[r]&&void 0!==H[r][e]?i=H[r][e]:void 0!==H[t]&&void 0!==H[t][e]?i=H[t][e]:!1===n.disableWarning&&console.warn("Unable to look up font label for font '"+t+"', '"+e+"'. Refer to getFontList() for available fonts."),i||n.noFallback||null==(i=H.times[e])&&(i=H.times.normal),i},At=l.__private__.putInfo=function(){for(var t in J(),tt("<<"),tt("/Producer (jsPDF "+ae.version+")"),D)D.hasOwnProperty(t)&&D[t]&&tt("/"+t.substr(0,1).toUpperCase()+t.substr(1)+" ("+vt(D[t])+")");tt("/CreationDate ("+p+")"),tt(">>"),tt("endobj")},St=l.__private__.putCatalog=function(t){var e=(t=t||{}).rootDictionaryObjId||st;switch(J(),tt("<<"),tt("/Type /Catalog"),tt("/Pages "+e+" 0 R"),L||(L="fullwidth"),L){case"fullwidth":tt("/OpenAction [3 0 R /FitH null]");break;case"fullheight":tt("/OpenAction [3 0 R /FitV null]");break;case"fullpage":tt("/OpenAction [3 0 R /Fit]");break;case"original":tt("/OpenAction [3 0 R /XYZ null null 1]");break;default:var n=""+L;"%"===n.substr(n.length-1)&&(L=parseInt(L)/100),"number"==typeof L&&tt("/OpenAction [3 0 R /XYZ null null "+Z(L)+"]")}switch(S||(S="continuous"),S){case"continuous":tt("/PageLayout /OneColumn");break;case"single":tt("/PageLayout /SinglePage");break;case"two":case"twoleft":tt("/PageLayout /TwoColumnLeft");break;case"tworight":tt("/PageLayout /TwoColumnRight")}A&&tt("/PageMode /"+A),it.publish("putCatalog"),tt(">>"),tt("endobj")},_t=l.__private__.putTrailer=function(){tt("trailer"),tt("<<"),tt("/Size "+(U+1)),tt("/Root "+U+" 0 R"),tt("/Info "+(U-1)+" 0 R"),tt("/ID [ <"+d+"> <"+d+"> ]"),tt(">>")},Ft=l.__private__.putHeader=function(){tt("%PDF-"+h),tt("%ºß¬à")},Pt=l.__private__.putXRef=function(){var t=1,e="0000000000";for(tt("xref"),tt("0 "+(U+1)),tt("0000000000 65535 f "),t=1;t<=U;t++){"function"==typeof z[t]?tt((e+z[t]()).slice(-10)+" 00000 n "):void 0!==z[t]?tt((e+z[t]).slice(-10)+" 00000 n "):tt("0000000000 00000 n ")}},kt=l.__private__.buildDocument=function(){k=!1,B=U=0,C=[],z=[],G=[],st=X(),lt=X(),it.publish("buildDocument"),Ft(),dt(),function(){it.publish("putAdditionalObjects");for(var t=0;t<G.length;t++){var e=G[t];ot(e.objId,!0),tt(e.content),tt("endobj")}it.publish("postPutAdditionalObjects")}(),gt(),At(),St();var t=B;return Pt(),_t(),tt("startxref"),tt(""+t),tt("%%EOF"),k=!0,C.join("\n")},It=l.__private__.getBlob=function(t){return new Blob([E(t)],{type:"application/pdf"})},Ct=l.output=l.__private__.output=((F=function(t,e){e=e||{};var n=kt();switch("string"==typeof e?e={filename:e}:e.filename=e.filename||"generated.pdf",t){case void 0:return n;case"save":l.save(e.filename);break;case"arraybuffer":return E(n);case"blob":return It(n);case"bloburi":case"bloburl":if(void 0!==ie.URL&&"function"==typeof ie.URL.createObjectURL)return ie.URL&&ie.URL.createObjectURL(It(n))||void 0;console.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");break;case"datauristring":case"dataurlstring":return"data:application/pdf;filename="+e.filename+";base64,"+btoa(n);case"dataurlnewwindow":var r='<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe src="'+this.output("datauristring")+'"></iframe></body></html>',i=ie.open();if(null!==i&&i.document.write(r),i||"undefined"==typeof safari)return i;case"datauri":case"dataurl":return ie.document.location.href="data:application/pdf;filename="+e.filename+";base64,"+btoa(n);default:return null}}).foo=function(){try{return F.apply(this,arguments)}catch(t){var e=t.stack||"";~e.indexOf(" at ")&&(e=e.split(" at ")[1]);var n="Error in function "+e.split("\n")[0].split("<")[0]+": "+t.message;if(!ie.console)throw new Error(n);ie.console.error(n,t),ie.alert&&alert(n)}},(F.foo.bar=F).foo),Bt=function(t){return!0===Array.isArray(Y)&&-1<Y.indexOf(t)};switch(e){case"pt":_=1;break;case"mm":_=72/25.4;break;case"cm":_=72/2.54;break;case"in":_=72;break;case"px":_=1==Bt("px_scaling")?.75:96/72;break;case"pc":case"em":_=12;break;case"ex":_=6;break;default:throw new Error("Invalid unit: "+e)}w(),m();var jt=l.__private__.getPageInfo=function(t){if(isNaN(t)||t%1!=0)throw new Error("Invalid argument passed to jsPDF.getPageInfo");return{objId:V[t].objId,pageNumber:t,pageContext:V[t]}},Et=l.__private__.getPageInfoByObjId=function(t){for(var e in V)if(V[e].objId===t)break;if(isNaN(t)||t%1!=0)throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");return jt(e)},Mt=l.__private__.getCurrentPageInfo=function(){return{objId:V[x].objId,pageNumber:x,pageContext:V[x]}};l.addPage=function(){return bt.apply(this,arguments),this},l.setPage=function(){return xt.apply(this,arguments),this},l.insertPage=function(t){return this.addPage(),this.movePage(x,t),this},l.movePage=function(t,e){if(e<t){for(var n=I[t],r=V[t],i=t;e<i;i--)I[i]=I[i-1],V[i]=V[i-1];I[e]=n,V[e]=r,this.setPage(e)}else if(t<e){for(n=I[t],r=V[t],i=t;i<e;i++)I[i]=I[i+1],V[i]=V[i+1];I[e]=n,V[e]=r,this.setPage(e)}return this},l.deletePage=function(){return function(t){0<t&&t<=W&&(I.splice(t,1),--W<x&&(x=W),this.setPage(x))}.apply(this,arguments),this};l.__private__.text=l.text=function(t,e,n,i){var r;"number"!=typeof t||"number"!=typeof e||"string"!=typeof n&&!Array.isArray(n)||(r=n,n=e,e=t,t=r);var o=arguments[3],a=arguments[4],s=arguments[5];if("object"===se(o)&&null!==o||("string"==typeof a&&(s=a,a=null),"string"==typeof o&&(s=o,o=null),"number"==typeof o&&(a=o,o=null),i={flags:o,angle:a,align:s}),(o=o||{}).noBOM=o.noBOM||!0,o.autoencode=o.autoencode||!0,isNaN(e)||isNaN(n)||null==t)throw new Error("Invalid arguments passed to jsPDF.text");if(0===t.length)return c;var l,h="",u="number"==typeof i.lineHeightFactor?i.lineHeightFactor:Tt,c=i.scope||this;function f(t){for(var e,n=t.concat(),r=[],i=n.length;i--;)"string"==typeof(e=n.shift())?r.push(e):Array.isArray(t)&&1===e.length?r.push(e[0]):r.push([e[0],e[1],e[2]]);return r}function p(t,e){var n;if("string"==typeof t)n=e(t)[0];else if(Array.isArray(t)){for(var r,i,o=t.concat(),a=[],s=o.length;s--;)"string"==typeof(r=o.shift())?a.push(e(r)[0]):Array.isArray(r)&&"string"===r[0]&&(i=e(r[0],r[1],r[2]),a.push([i[0],i[1],i[2]]));n=a}return n}var d=!1,g=!0;if("string"==typeof t)d=!0;else if(Array.isArray(t)){for(var m,y=t.concat(),v=[],w=y.length;w--;)("string"!=typeof(m=y.shift())||Array.isArray(m)&&"string"!=typeof m[0])&&(g=!1);d=g}if(!1===d)throw new Error('Type of text must be string or Array. "'+t+'" is not recognized.');var b=rt[$].encoding;"WinAnsiEncoding"!==b&&"StandardEncoding"!==b||(t=p(t,function(t,e,n){return[(r=t,r=r.split("\t").join(Array(i.TabLen||9).join(" ")),vt(r,o)),e,n];var r})),"string"==typeof t&&(t=t.match(/[\r?\n]/)?t.split(/\r\n|\r|\n/g):[t]);var x=et/c.internal.scaleFactor,N=x*(Tt-1);switch(i.baseline){case"bottom":n-=N;break;case"top":n+=x-N;break;case"hanging":n+=x-2*N;break;case"middle":n+=x/2-N}0<(O=i.maxWidth||0)&&("string"==typeof t?t=c.splitTextToSize(t,O):"[object Array]"===Object.prototype.toString.call(t)&&(t=c.splitTextToSize(t.join(" "),O)));var L={text:t,x:e,y:n,options:i,mutex:{pdfEscape:vt,activeFontKey:$,fonts:rt,activeFontSize:et}};it.publish("preProcessText",L),t=L.text;a=(i=L.options).angle;var A=c.internal.scaleFactor,S=[];if(a){a*=Math.PI/180;var _=Math.cos(a),F=Math.sin(a);S=[Z(_),Z(F),Z(-1*F),Z(_)]}void 0!==(M=i.charSpace)&&(h+=Q(M*A)+" Tc\n");i.lang;var P=-1,k=void 0!==i.renderingMode?i.renderingMode:i.stroke,I=c.internal.getCurrentPageInfo().pageContext;switch(k){case 0:case!1:case"fill":P=0;break;case 1:case!0:case"stroke":P=1;break;case 2:case"fillThenStroke":P=2;break;case 3:case"invisible":P=3;break;case 4:case"fillAndAddForClipping":P=4;break;case 5:case"strokeAndAddPathForClipping":P=5;break;case 6:case"fillThenStrokeAndAddToPathForClipping":P=6;break;case 7:case"addToPathForClipping":P=7}var C=void 0!==I.usedRenderingMode?I.usedRenderingMode:-1;-1!==P?h+=P+" Tr\n":-1!==C&&(h+="0 Tr\n"),-1!==P&&(I.usedRenderingMode=P);s=i.align||"left";var B=et*u,j=c.internal.pageSize.getWidth(),E=(A=c.internal.scaleFactor,rt[$]),M=i.charSpace||Qt,O=i.maxWidth||0,q=(o={},[]);if("[object Array]"===Object.prototype.toString.call(t)){var T,R;v=f(t);"left"!==s&&(R=v.map(function(t){return c.getStringUnitWidth(t,{font:E,charSpace:M,fontSize:et})*et/A}));var D,U=Math.max.apply(Math,R),z=0;if("right"===s){e-=R[0],t=[];var H=0;for(w=v.length;H<w;H++)U-R[H],T=0===H?(D=Wt(e),Vt(n)):(D=(z-R[H])*A,-B),t.push([v[H],D,T]),z=R[H]}else if("center"===s){e-=R[0]/2,t=[];for(H=0,w=v.length;H<w;H++)(U-R[H])/2,T=0===H?(D=Wt(e),Vt(n)):(D=(z-R[H])/2*A,-B),t.push([v[H],D,T]),z=R[H]}else if("left"===s){t=[];for(H=0,w=v.length;H<w;H++)T=0===H?Vt(n):-B,D=0===H?Wt(e):0,t.push(v[H])}else{if("justify"!==s)throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');t=[];for(O=0!==O?O:j,H=0,w=v.length;H<w;H++)T=0===H?Vt(n):-B,D=0===H?Wt(e):0,H<w-1&&q.push(((O-R[H])/(v[H].split(" ").length-1)*A).toFixed(2)),t.push([v[H],D,T])}}!0===("boolean"==typeof i.R2L?i.R2L:nt)&&(t=p(t,function(t,e,n){return[t.split("").reverse().join(""),e,n]}));L={text:t,x:e,y:n,options:i,mutex:{pdfEscape:vt,activeFontKey:$,fonts:rt,activeFontSize:et}};it.publish("postProcessText",L),t=L.text,l=L.mutex.isHex;v=f(t);t=[];var W,V,G,Y=0,J=(w=v.length,"");for(H=0;H<w;H++)J="",Array.isArray(v[H])?(W=parseFloat(v[H][1]),V=parseFloat(v[H][2]),G=(l?"<":"(")+v[H][0]+(l?">":")"),Y=1):(W=Wt(e),V=Vt(n),G=(l?"<":"(")+v[H]+(l?">":")")),void 0!==q&&void 0!==q[H]&&(J=q[H]+" Tw\n"),0!==S.length&&0===H?t.push(J+S.join(" ")+" "+W.toFixed(2)+" "+V.toFixed(2)+" Tm\n"+G):1===Y||0===Y&&0===H?t.push(J+W.toFixed(2)+" "+V.toFixed(2)+" Td\n"+G):t.push(J+G);t=0===Y?t.join(" Tj\nT* "):t.join(" Tj\n"),t+=" Tj\n";var X="BT\n/"+$+" "+et+" Tf\n"+(et*u).toFixed(2)+" TL\n"+Kt+"\n";return X+=h,X+=t,tt(X+="ET"),K[$]=!0,c},l.__private__.lstext=l.lstext=function(t,e,n,r){return console.warn("jsPDF.lstext is deprecated"),this.text(t,e,n,{charSpace:r})},l.__private__.clip=l.clip=function(t){tt("evenodd"===t?"W*":"W"),tt("n")},l.__private__.clip_fixed=l.clip_fixed=function(t){console.log("clip_fixed is deprecated"),l.clip(t)};var Ot=l.__private__.isValidStyle=function(t){var e=!1;return-1!==[void 0,null,"S","F","DF","FD","f","f*","B","B*"].indexOf(t)&&(e=!0),e},qt=l.__private__.getStyle=function(t){var e="S";return"F"===t?e="f":"FD"===t||"DF"===t?e="B":"f"!==t&&"f*"!==t&&"B"!==t&&"B*"!==t||(e=t),e};l.__private__.line=l.line=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw new Error("Invalid arguments passed to jsPDF.line");return this.lines([[n-t,r-e]],t,e)},l.__private__.lines=l.lines=function(t,e,n,r,i,o){var a,s,l,h,u,c,f,p,d,g,m,y;if("number"==typeof t&&(y=n,n=e,e=t,t=y),r=r||[1,1],o=o||!1,isNaN(e)||isNaN(n)||!Array.isArray(t)||!Array.isArray(r)||!Ot(i)||"boolean"!=typeof o)throw new Error("Invalid arguments passed to jsPDF.lines");for(tt(Q(Wt(e))+" "+Q(Vt(n))+" m "),a=r[0],s=r[1],h=t.length,g=e,m=n,l=0;l<h;l++)2===(u=t[l]).length?(g=u[0]*a+g,m=u[1]*s+m,tt(Q(Wt(g))+" "+Q(Vt(m))+" l")):(c=u[0]*a+g,f=u[1]*s+m,p=u[2]*a+g,d=u[3]*s+m,g=u[4]*a+g,m=u[5]*s+m,tt(Q(Wt(c))+" "+Q(Vt(f))+" "+Q(Wt(p))+" "+Q(Vt(d))+" "+Q(Wt(g))+" "+Q(Vt(m))+" c"));return o&&tt(" h"),null!==i&&tt(qt(i)),this},l.__private__.rect=l.rect=function(t,e,n,r,i){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||!Ot(i))throw new Error("Invalid arguments passed to jsPDF.rect");return tt([Z(Wt(t)),Z(Vt(e)),Z(n*_),Z(-r*_),"re"].join(" ")),null!==i&&tt(qt(i)),this},l.__private__.triangle=l.triangle=function(t,e,n,r,i,o,a){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||isNaN(i)||isNaN(o)||!Ot(a))throw new Error("Invalid arguments passed to jsPDF.triangle");return this.lines([[n-t,r-e],[i-n,o-r],[t-i,e-o]],t,e,[1,1],a,!0),this},l.__private__.roundedRect=l.roundedRect=function(t,e,n,r,i,o,a){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||isNaN(i)||isNaN(o)||!Ot(a))throw new Error("Invalid arguments passed to jsPDF.roundedRect");var s=4/3*(Math.SQRT2-1);return this.lines([[n-2*i,0],[i*s,0,i,o-o*s,i,o],[0,r-2*o],[0,o*s,-i*s,o,-i,o],[2*i-n,0],[-i*s,0,-i,-o*s,-i,-o],[0,2*o-r],[0,-o*s,i*s,-o,i,-o]],t+i,e,[1,1],a),this},l.__private__.ellipse=l.ellipse=function(t,e,n,r,i){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||!Ot(i))throw new Error("Invalid arguments passed to jsPDF.ellipse");var o=4/3*(Math.SQRT2-1)*n,a=4/3*(Math.SQRT2-1)*r;return tt([Z(Wt(t+n)),Z(Vt(e)),"m",Z(Wt(t+n)),Z(Vt(e-a)),Z(Wt(t+o)),Z(Vt(e-r)),Z(Wt(t)),Z(Vt(e-r)),"c"].join(" ")),tt([Z(Wt(t-o)),Z(Vt(e-r)),Z(Wt(t-n)),Z(Vt(e-a)),Z(Wt(t-n)),Z(Vt(e)),"c"].join(" ")),tt([Z(Wt(t-n)),Z(Vt(e+a)),Z(Wt(t-o)),Z(Vt(e+r)),Z(Wt(t)),Z(Vt(e+r)),"c"].join(" ")),tt([Z(Wt(t+o)),Z(Vt(e+r)),Z(Wt(t+n)),Z(Vt(e+a)),Z(Wt(t+n)),Z(Vt(e)),"c"].join(" ")),null!==i&&tt(qt(i)),this},l.__private__.circle=l.circle=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||!Ot(r))throw new Error("Invalid arguments passed to jsPDF.circle");return this.ellipse(t,e,n,n,r)};l.setFont=function(t,e){return $=Lt(t,e,{disableWarning:!1}),this},l.setFontStyle=l.setFontType=function(t){return $=Lt(void 0,t),this};l.__private__.getFontList=l.getFontList=function(){var t,e,n,r={};for(t in H)if(H.hasOwnProperty(t))for(e in r[t]=n=[],H[t])H[t].hasOwnProperty(e)&&n.push(e);return r};l.addFont=function(t,e,n,r){yt.call(this,t,e,n,r=r||"Identity-H")};var Tt,Rt=r.lineWidth||.200025,Dt=l.__private__.setLineWidth=l.setLineWidth=function(t){return tt((t*_).toFixed(2)+" w"),this},Ut=(l.__private__.setLineDash=ae.API.setLineDash=function(t,e){if(t=t||[],e=e||0,isNaN(e)||!Array.isArray(t))throw new Error("Invalid arguments passed to jsPDF.setLineDash");return t=t.map(function(t){return(t*_).toFixed(3)}).join(" "),e=parseFloat((e*_).toFixed(3)),tt("["+t+"] "+e+" d"),this},l.__private__.getLineHeight=l.getLineHeight=function(){return et*Tt}),zt=(Ut=l.__private__.getLineHeight=l.getLineHeight=function(){return et*Tt},l.__private__.setLineHeightFactor=l.setLineHeightFactor=function(t){return"number"==typeof(t=t||1.15)&&(Tt=t),this}),Ht=l.__private__.getLineHeightFactor=l.getLineHeightFactor=function(){return Tt};zt(r.lineHeight);var Wt=l.__private__.getHorizontalCoordinate=function(t){return t*_},Vt=l.__private__.getVerticalCoordinate=function(t){return V[x].mediaBox.topRightY-V[x].mediaBox.bottomLeftY-t*_},Gt=l.__private__.getHorizontalCoordinateString=function(t){return Z(t*_)},Yt=l.__private__.getVerticalCoordinateString=function(t){return Z(V[x].mediaBox.topRightY-V[x].mediaBox.bottomLeftY-t*_)},Jt=r.strokeColor||"0 G",Xt=(l.__private__.getStrokeColor=l.getDrawColor=function(){return ht(Jt)},l.__private__.setStrokeColor=l.setDrawColor=function(t,e,n,r){return Jt=ut({ch1:t,ch2:e,ch3:n,ch4:r,pdfColorType:"draw",precision:2}),tt(Jt),this},r.fillColor||"0 g"),Kt=(l.__private__.getFillColor=l.getFillColor=function(){return ht(Xt)},l.__private__.setFillColor=l.setFillColor=function(t,e,n,r){return Xt=ut({ch1:t,ch2:e,ch3:n,ch4:r,pdfColorType:"fill",precision:2}),tt(Xt),this},r.textColor||"0 g"),Zt=l.__private__.getTextColor=l.getTextColor=function(){return ht(Kt)},Qt=(l.__private__.setTextColor=l.setTextColor=function(t,e,n,r){return Kt=ut({ch1:t,ch2:e,ch3:n,ch4:r,pdfColorType:"text",precision:3}),this},r.charSpace||0),$t=l.__private__.getCharSpace=l.getCharSpace=function(){return Qt},te=(l.__private__.setCharSpace=l.setCharSpace=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.setCharSpace");return Qt=t,this},0);l.CapJoinStyles={0:0,butt:0,but:0,miter:0,1:1,round:1,rounded:1,circle:1,2:2,projecting:2,project:2,square:2,bevel:2};l.__private__.setLineCap=l.setLineCap=function(t){var e=l.CapJoinStyles[t];if(void 0===e)throw new Error("Line cap style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return tt((te=e)+" J"),this};var ee,ne=0;l.__private__.setLineJoin=l.setLineJoin=function(t){var e=l.CapJoinStyles[t];if(void 0===e)throw new Error("Line join style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return tt((ne=e)+" j"),this},l.__private__.setMiterLimit=l.setMiterLimit=function(t){if(t=t||0,isNaN(t))throw new Error("Invalid argument passed to jsPDF.setMiterLimit");return ee=parseFloat(Z(t*_)),tt(ee+" M"),this};for(var re in l.save=function(r,t){if(r=r||"generated.pdf",(t=t||{}).returnPromise=t.returnPromise||!1,!1!==t.returnPromise)return new Promise(function(t,e){try{var n=le(It(kt()),r);"function"==typeof le.unload&&ie.setTimeout&&setTimeout(le.unload,911),t(n)}catch(t){e(t.message)}});le(It(kt()),r),"function"==typeof le.unload&&ie.setTimeout&&setTimeout(le.unload,911)},ae.API)ae.API.hasOwnProperty(re)&&("events"===re&&ae.API.events.length?function(t,e){var n,r,i;for(i=e.length-1;-1!==i;i--)n=e[i][0],r=e[i][1],t.subscribe.apply(t,[n].concat("function"==typeof r?[r]:r))}(it,ae.API.events):l[re]=ae.API[re]);return l.internal={pdfEscape:vt,getStyle:qt,getFont:function(){return rt[Lt.apply(l,arguments)]},getFontSize:O,getCharSpace:$t,getTextColor:Zt,getLineHeight:Ut,getLineHeightFactor:Ht,write:j,getHorizontalCoordinate:Wt,getVerticalCoordinate:Vt,getCoordinateString:Gt,getVerticalCoordinateString:Yt,collections:{},newObject:J,newAdditionalObject:at,newObjectDeferred:X,newObjectDeferredBegin:ot,getFilters:ct,putStream:ft,events:it,scaleFactor:_,pageSize:{getWidth:function(){return(V[x].mediaBox.topRightX-V[x].mediaBox.bottomLeftX)/_},setWidth:function(t){V[x].mediaBox.topRightX=t*_+V[x].mediaBox.bottomLeftX},getHeight:function(){return(V[x].mediaBox.topRightY-V[x].mediaBox.bottomLeftY)/_},setHeight:function(t){V[x].mediaBox.topRightY=t*_+V[x].mediaBox.bottomLeftY}},output:Ct,getNumberOfPages:Nt,pages:I,out:tt,f2:Z,f3:Q,getPageInfo:jt,getPageInfoByObjId:Et,getCurrentPageInfo:Mt,getPDFVersion:u,hasHotfix:Bt},Object.defineProperty(l.internal.pageSize,"width",{get:function(){return(V[x].mediaBox.topRightX-V[x].mediaBox.bottomLeftX)/_},set:function(t){V[x].mediaBox.topRightX=t*_+V[x].mediaBox.bottomLeftX},enumerable:!0,configurable:!0}),Object.defineProperty(l.internal.pageSize,"height",{get:function(){return(V[x].mediaBox.topRightY-V[x].mediaBox.bottomLeftY)/_},set:function(t){V[x].mediaBox.topRightY=t*_+V[x].mediaBox.bottomLeftY},enumerable:!0,configurable:!0}),function(t){for(var e=0,n=M.length;e<n;e++){var r=yt(t[e][0],t[e][1],t[e][2],M[e][3],!0);K[r]=!0;var i=t[e][0].split("-");mt(r,i[0],i[1]||"")}it.publish("addFonts",{fonts:rt,dictionary:H})}(M),$="F1",bt(i,t),it.publish("initialized"),l}return ae.API={events:[]},ae.version="1.5.3", true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return ae}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!=typeof module&&module.exports?(module.exports=ae,module.exports.jsPDF=ae):ie.jsPDF=ae,ae}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")());
/**
   * @license
   * Copyright (c) 2016 Alexander Weidt,
   * https://github.com/BiggA94
   * 
   * Licensed under the MIT License. http://opensource.org/licenses/mit-license
   */
(function(t,e){var A,n=1,S=function(t){return t.replace(/\\/g,"\\\\").replace(/\(/g,"\\(").replace(/\)/g,"\\)")},y=function(t){return t.replace(/\\\\/g,"\\").replace(/\\\(/g,"(").replace(/\\\)/g,")")},_=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f2");return t.toFixed(2)},s=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f2");return t.toFixed(5)};t.__acroform__={};var r=function(t,e){t.prototype=Object.create(e.prototype),t.prototype.constructor=t},v=function(t){return t*n},w=function(t){return t/n},l=function(t){var e=new j,n=Y.internal.getHeight(t)||0,r=Y.internal.getWidth(t)||0;return e.BBox=[0,0,Number(_(r)),Number(_(n))],e},i=t.__acroform__.setBit=function(t,e){if(t=t||0,e=e||0,isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");return t|=1<<e},o=t.__acroform__.clearBit=function(t,e){if(t=t||0,e=e||0,isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");return t&=~(1<<e)},a=t.__acroform__.getBit=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");return 0==(t&1<<e)?0:1},b=t.__acroform__.getBitForPdf=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");return a(t,e-1)},x=t.__acroform__.setBitForPdf=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");return i(t,e-1)},N=t.__acroform__.clearBitForPdf=function(t,e,n){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");return o(t,e-1)},c=t.__acroform__.calculateCoordinates=function(t){var e=this.internal.getHorizontalCoordinate,n=this.internal.getVerticalCoordinate,r=t[0],i=t[1],o=t[2],a=t[3],s={};return s.lowerLeft_X=e(r)||0,s.lowerLeft_Y=n(i+a)||0,s.upperRight_X=e(r+o)||0,s.upperRight_Y=n(i)||0,[Number(_(s.lowerLeft_X)),Number(_(s.lowerLeft_Y)),Number(_(s.upperRight_X)),Number(_(s.upperRight_Y))]},f=function(t){if(t.appearanceStreamContent)return t.appearanceStreamContent;if(t.V||t.DV){var e=[],n=t.V||t.DV,r=h(t,n),i=A.internal.getFont(t.fontName,t.fontStyle).id;e.push("/Tx BMC"),e.push("q"),e.push("BT"),e.push(A.__private__.encodeColorString(t.color)),e.push("/"+i+" "+_(r.fontSize)+" Tf"),e.push("1 0 0 1 0 0 Tm"),e.push(r.text),e.push("ET"),e.push("Q"),e.push("EMC");var o=new l(t);return o.stream=e.join("\n"),o}},h=function(i,t){var e=i.maxFontSize||12,n=(i.fontName,{text:"",fontSize:""}),o=(t=")"==(t="("==t.substr(0,1)?t.substr(1):t).substr(t.length-1)?t.substr(0,t.length-1):t).split(" "),r=(A.__private__.encodeColorString(i.color),e),a=Y.internal.getHeight(i)||0;a=a<0?-a:a;var s=Y.internal.getWidth(i)||0;s=s<0?-s:s;var l=function(t,e,n){if(t+1<o.length){var r=e+" "+o[t+1];return F(r,i,n).width<=s-4}return!1};r++;t:for(;;){t="";var h=F("3",i,--r).height,u=i.multiline?a-r:(a-h)/2,c=-2,f=u+=2,p=0,d=0,g=0;if(r<=0){t="(...) Tj\n",t+="% Width of Text: "+F(t,i,r=12).width+", FieldWidth:"+s+"\n";break}g=F(o[0]+" ",i,r).width;var m="",y=0;for(var v in o)if(o.hasOwnProperty(v)){m=" "==(m+=o[v]+" ").substr(m.length-1)?m.substr(0,m.length-1):m;var w=parseInt(v);g=F(m+" ",i,r).width;var b=l(w,m,r),x=v>=o.length-1;if(b&&!x){m+=" ";continue}if(b||x){if(x)d=w;else if(i.multiline&&a<(h+2)*(y+2)+2)continue t}else{if(!i.multiline)continue t;if(a<(h+2)*(y+2)+2)continue t;d=w}for(var N="",L=p;L<=d;L++)N+=o[L]+" ";switch(N=" "==N.substr(N.length-1)?N.substr(0,N.length-1):N,g=F(N,i,r).width,i.textAlign){case"right":c=s-g-2;break;case"center":c=(s-g)/2;break;case"left":default:c=2}t+=_(c)+" "+_(f)+" Td\n",t+="("+S(N)+") Tj\n",t+=-_(c)+" 0 Td\n",f=-(r+2),g=0,p=d+1,y++,m=""}else;break}return n.text=t,n.fontSize=r,n},F=function(t,e,n){var r=A.internal.getFont(e.fontName,e.fontStyle),i=A.getStringUnitWidth(t,{font:r,fontSize:parseFloat(n),charSpace:0})*parseFloat(n);return{height:A.getStringUnitWidth("3",{font:r,fontSize:parseFloat(n),charSpace:0})*parseFloat(n)*1.5,width:i}},u={fields:[],xForms:[],acroFormDictionaryRoot:null,printedOut:!1,internal:null,isInitialized:!1},p=function(){A.internal.acroformPlugin.acroFormDictionaryRoot.objId=void 0;var t=A.internal.acroformPlugin.acroFormDictionaryRoot.Fields;for(var e in t)if(t.hasOwnProperty(e)){var n=t[e];n.objId=void 0,n.hasAnnotation&&d.call(A,n)}},d=function(t){var e={type:"reference",object:t};void 0===A.internal.getPageInfo(t.page).pageContext.annotations.find(function(t){return t.type===e.type&&t.object===e.object})&&A.internal.getPageInfo(t.page).pageContext.annotations.push(e)},g=function(){if(void 0===A.internal.acroformPlugin.acroFormDictionaryRoot)throw new Error("putCatalogCallback: Root missing.");A.internal.write("/AcroForm "+A.internal.acroformPlugin.acroFormDictionaryRoot.objId+" 0 R")},m=function(){A.internal.events.unsubscribe(A.internal.acroformPlugin.acroFormDictionaryRoot._eventID),delete A.internal.acroformPlugin.acroFormDictionaryRoot._eventID,A.internal.acroformPlugin.printedOut=!0},L=function(t){var e=!t;t||(A.internal.newObjectDeferredBegin(A.internal.acroformPlugin.acroFormDictionaryRoot.objId,!0),A.internal.acroformPlugin.acroFormDictionaryRoot.putStream());t=t||A.internal.acroformPlugin.acroFormDictionaryRoot.Kids;for(var n in t)if(t.hasOwnProperty(n)){var r=t[n],i=[],o=r.Rect;if(r.Rect&&(r.Rect=c.call(this,r.Rect)),A.internal.newObjectDeferredBegin(r.objId,!0),r.DA=Y.createDefaultAppearanceStream(r),"object"===se(r)&&"function"==typeof r.getKeyValueListForStream&&(i=r.getKeyValueListForStream()),r.Rect=o,r.hasAppearanceStream&&!r.appearanceStreamContent){var a=f.call(this,r);i.push({key:"AP",value:"<</N "+a+">>"}),A.internal.acroformPlugin.xForms.push(a)}if(r.appearanceStreamContent){var s="";for(var l in r.appearanceStreamContent)if(r.appearanceStreamContent.hasOwnProperty(l)){var h=r.appearanceStreamContent[l];if(s+="/"+l+" ",s+="<<",1<=Object.keys(h).length||Array.isArray(h))for(var n in h){var u;if(h.hasOwnProperty(n))"function"==typeof(u=h[n])&&(u=u.call(this,r)),s+="/"+n+" "+u+" ",0<=A.internal.acroformPlugin.xForms.indexOf(u)||A.internal.acroformPlugin.xForms.push(u)}else"function"==typeof(u=h)&&(u=u.call(this,r)),s+="/"+n+" "+u,0<=A.internal.acroformPlugin.xForms.indexOf(u)||A.internal.acroformPlugin.xForms.push(u);s+=">>"}i.push({key:"AP",value:"<<\n"+s+">>"})}A.internal.putStream({additionalKeyValues:i}),A.internal.out("endobj")}e&&P.call(this,A.internal.acroformPlugin.xForms)},P=function(t){for(var e in t)if(t.hasOwnProperty(e)){var n=e,r=t[e];A.internal.newObjectDeferredBegin(r&&r.objId,!0),"object"===se(r)&&"function"==typeof r.putStream&&r.putStream(),delete t[n]}},k=function(){if(void 0!==this.internal&&(void 0===this.internal.acroformPlugin||!1===this.internal.acroformPlugin.isInitialized)){if(A=this,M.FieldNum=0,this.internal.acroformPlugin=JSON.parse(JSON.stringify(u)),this.internal.acroformPlugin.acroFormDictionaryRoot)throw new Error("Exception while creating AcroformDictionary");n=A.internal.scaleFactor,A.internal.acroformPlugin.acroFormDictionaryRoot=new E,A.internal.acroformPlugin.acroFormDictionaryRoot._eventID=A.internal.events.subscribe("postPutResources",m),A.internal.events.subscribe("buildDocument",p),A.internal.events.subscribe("putCatalog",g),A.internal.events.subscribe("postPutPages",L),A.internal.acroformPlugin.isInitialized=!0}},I=t.__acroform__.arrayToPdfArray=function(t){if(Array.isArray(t)){for(var e="[",n=0;n<t.length;n++)switch(0!==n&&(e+=" "),se(t[n])){case"boolean":case"number":case"object":e+=t[n].toString();break;case"string":"/"!==t[n].substr(0,1)?e+="("+S(t[n].toString())+")":e+=t[n].toString()}return e+="]"}throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray")};var C=function(t){return(t=t||"").toString(),t="("+S(t)+")"},B=function(){var e;Object.defineProperty(this,"objId",{configurable:!0,get:function(){if(e||(e=A.internal.newObjectDeferred()),!e)throw new Error("AcroFormPDFObject: Couldn't create Object ID");return e},set:function(t){e=t}})};B.prototype.toString=function(){return this.objId+" 0 R"},B.prototype.putStream=function(){var t=this.getKeyValueListForStream();A.internal.putStream({data:this.stream,additionalKeyValues:t}),A.internal.out("endobj")},B.prototype.getKeyValueListForStream=function(){return function(t){var e=[],n=Object.getOwnPropertyNames(t).filter(function(t){return"content"!=t&&"appearanceStreamContent"!=t&&"_"!=t.substring(0,1)});for(var r in n)if(!1===Object.getOwnPropertyDescriptor(t,n[r]).configurable){var i=n[r],o=t[i];o&&(Array.isArray(o)?e.push({key:i,value:I(o)}):o instanceof B?e.push({key:i,value:o.objId+" 0 R"}):"function"!=typeof o&&e.push({key:i,value:o}))}return e}(this)};var j=function(){B.call(this),Object.defineProperty(this,"Type",{value:"/XObject",configurable:!1,writeable:!0}),Object.defineProperty(this,"Subtype",{value:"/Form",configurable:!1,writeable:!0}),Object.defineProperty(this,"FormType",{value:1,configurable:!1,writeable:!0});var e,n=[];Object.defineProperty(this,"BBox",{configurable:!1,writeable:!0,get:function(){return n},set:function(t){n=t}}),Object.defineProperty(this,"Resources",{value:"2 0 R",configurable:!1,writeable:!0}),Object.defineProperty(this,"stream",{enumerable:!1,configurable:!0,set:function(t){e=t.trim()},get:function(){return e||null}})};r(j,B);var E=function(){B.call(this);var e,t=[];Object.defineProperty(this,"Kids",{enumerable:!1,configurable:!0,get:function(){return 0<t.length?t:void 0}}),Object.defineProperty(this,"Fields",{enumerable:!1,configurable:!1,get:function(){return t}}),Object.defineProperty(this,"DA",{enumerable:!1,configurable:!1,get:function(){if(e)return"("+e+")"},set:function(t){e=t}})};r(E,B);var M=function t(){B.call(this);var e=4;Object.defineProperty(this,"F",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){if(isNaN(t))throw new Error('Invalid value "'+t+'" for attribute F supplied.');e=t}}),Object.defineProperty(this,"showWhenPrinted",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(e,3))},set:function(t){!0===Boolean(t)?this.F=x(e,3):this.F=N(e,3)}});var n=0;Object.defineProperty(this,"Ff",{enumerable:!1,configurable:!1,get:function(){return n},set:function(t){if(isNaN(t))throw new Error('Invalid value "'+t+'" for attribute Ff supplied.');n=t}});var r=[];Object.defineProperty(this,"Rect",{enumerable:!1,configurable:!1,get:function(){if(0!==r.length)return r},set:function(t){r=void 0!==t?t:[]}}),Object.defineProperty(this,"x",{enumerable:!0,configurable:!0,get:function(){return!r||isNaN(r[0])?0:w(r[0])},set:function(t){r[0]=v(t)}}),Object.defineProperty(this,"y",{enumerable:!0,configurable:!0,get:function(){return!r||isNaN(r[1])?0:w(r[1])},set:function(t){r[1]=v(t)}}),Object.defineProperty(this,"width",{enumerable:!0,configurable:!0,get:function(){return!r||isNaN(r[2])?0:w(r[2])},set:function(t){r[2]=v(t)}}),Object.defineProperty(this,"height",{enumerable:!0,configurable:!0,get:function(){return!r||isNaN(r[3])?0:w(r[3])},set:function(t){r[3]=v(t)}});var i="";Object.defineProperty(this,"FT",{enumerable:!0,configurable:!1,get:function(){return i},set:function(t){switch(t){case"/Btn":case"/Tx":case"/Ch":case"/Sig":i=t;break;default:throw new Error('Invalid value "'+t+'" for attribute FT supplied.')}}});var o=null;Object.defineProperty(this,"T",{enumerable:!0,configurable:!1,get:function(){if(!o||o.length<1){if(this instanceof H)return;o="FieldObject"+t.FieldNum++}return"("+S(o)+")"},set:function(t){o=t.toString()}}),Object.defineProperty(this,"fieldName",{configurable:!0,enumerable:!0,get:function(){return o},set:function(t){o=t}});var a="helvetica";Object.defineProperty(this,"fontName",{enumerable:!0,configurable:!0,get:function(){return a},set:function(t){a=t}});var s="normal";Object.defineProperty(this,"fontStyle",{enumerable:!0,configurable:!0,get:function(){return s},set:function(t){s=t}});var l=0;Object.defineProperty(this,"fontSize",{enumerable:!0,configurable:!0,get:function(){return w(l)},set:function(t){l=v(t)}});var h=50;Object.defineProperty(this,"maxFontSize",{enumerable:!0,configurable:!0,get:function(){return w(h)},set:function(t){h=v(t)}});var u="black";Object.defineProperty(this,"color",{enumerable:!0,configurable:!0,get:function(){return u},set:function(t){u=t}});var c="/F1 0 Tf 0 g";Object.defineProperty(this,"DA",{enumerable:!0,configurable:!1,get:function(){if(!(!c||this instanceof H||this instanceof V))return C(c)},set:function(t){t=t.toString(),c=t}});var f=null;Object.defineProperty(this,"DV",{enumerable:!1,configurable:!1,get:function(){if(f)return this instanceof D==!1?C(f):f},set:function(t){t=t.toString(),f=this instanceof D==!1?"("===t.substr(0,1)?y(t.substr(1,t.length-2)):y(t):t}}),Object.defineProperty(this,"defaultValue",{enumerable:!0,configurable:!0,get:function(){return this instanceof D==!0?y(f.substr(1,f.length-1)):f},set:function(t){t=t.toString(),f=this instanceof D==!0?"/"+t:t}});var p=null;Object.defineProperty(this,"V",{enumerable:!1,configurable:!1,get:function(){if(p)return this instanceof D==!1?C(p):p},set:function(t){t=t.toString(),p=this instanceof D==!1?"("===t.substr(0,1)?y(t.substr(1,t.length-2)):y(t):t}}),Object.defineProperty(this,"value",{enumerable:!0,configurable:!0,get:function(){return this instanceof D==!0?y(p.substr(1,p.length-1)):p},set:function(t){t=t.toString(),p=this instanceof D==!0?"/"+t:t}}),Object.defineProperty(this,"hasAnnotation",{enumerable:!0,configurable:!0,get:function(){return this.Rect}}),Object.defineProperty(this,"Type",{enumerable:!0,configurable:!1,get:function(){return this.hasAnnotation?"/Annot":null}}),Object.defineProperty(this,"Subtype",{enumerable:!0,configurable:!1,get:function(){return this.hasAnnotation?"/Widget":null}});var d,g=!1;Object.defineProperty(this,"hasAppearanceStream",{enumerable:!0,configurable:!0,writeable:!0,get:function(){return g},set:function(t){t=Boolean(t),g=t}}),Object.defineProperty(this,"page",{enumerable:!0,configurable:!0,writeable:!0,get:function(){if(d)return d},set:function(t){d=t}}),Object.defineProperty(this,"readOnly",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,1))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,1):this.Ff=N(this.Ff,1)}}),Object.defineProperty(this,"required",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,2))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,2):this.Ff=N(this.Ff,2)}}),Object.defineProperty(this,"noExport",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,3))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,3):this.Ff=N(this.Ff,3)}});var m=null;Object.defineProperty(this,"Q",{enumerable:!0,configurable:!1,get:function(){if(null!==m)return m},set:function(t){if(-1===[0,1,2].indexOf(t))throw new Error('Invalid value "'+t+'" for attribute Q supplied.');m=t}}),Object.defineProperty(this,"textAlign",{get:function(){var t="left";switch(m){case 0:default:t="left";break;case 1:t="center";break;case 2:t="right"}return t},configurable:!0,enumerable:!0,set:function(t){switch(t){case"right":case 2:m=2;break;case"center":case 1:m=1;break;case"left":case 0:default:m=0}}})};r(M,B);var O=function(){M.call(this),this.FT="/Ch",this.V="()",this.fontName="zapfdingbats";var e=0;Object.defineProperty(this,"TI",{enumerable:!0,configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"topIndex",{enumerable:!0,configurable:!0,get:function(){return e},set:function(t){e=t}});var r=[];Object.defineProperty(this,"Opt",{enumerable:!0,configurable:!1,get:function(){return I(r)},set:function(t){var e,n;n=[],"string"==typeof(e=t)&&(n=function(t,e,n){n||(n=1);for(var r,i=[];r=e.exec(t);)i.push(r[n]);return i}(e,/\((.*?)\)/g)),r=n}}),this.getOptions=function(){return r},this.setOptions=function(t){r=t,this.sort&&r.sort()},this.addOption=function(t){t=(t=t||"").toString(),r.push(t),this.sort&&r.sort()},this.removeOption=function(t,e){for(e=e||!1,t=(t=t||"").toString();-1!==r.indexOf(t)&&(r.splice(r.indexOf(t),1),!1!==e););},Object.defineProperty(this,"combo",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,18))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,18):this.Ff=N(this.Ff,18)}}),Object.defineProperty(this,"edit",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,19))},set:function(t){!0===this.combo&&(!0===Boolean(t)?this.Ff=x(this.Ff,19):this.Ff=N(this.Ff,19))}}),Object.defineProperty(this,"sort",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,20))},set:function(t){!0===Boolean(t)?(this.Ff=x(this.Ff,20),r.sort()):this.Ff=N(this.Ff,20)}}),Object.defineProperty(this,"multiSelect",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,22))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,22):this.Ff=N(this.Ff,22)}}),Object.defineProperty(this,"doNotSpellCheck",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,23))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,23):this.Ff=N(this.Ff,23)}}),Object.defineProperty(this,"commitOnSelChange",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,27))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,27):this.Ff=N(this.Ff,27)}}),this.hasAppearanceStream=!1};r(O,M);var q=function(){O.call(this),this.fontName="helvetica",this.combo=!1};r(q,O);var T=function(){q.call(this),this.combo=!0};r(T,q);var R=function(){T.call(this),this.edit=!0};r(R,T);var D=function(){M.call(this),this.FT="/Btn",Object.defineProperty(this,"noToggleToOff",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,15))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,15):this.Ff=N(this.Ff,15)}}),Object.defineProperty(this,"radio",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,16))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,16):this.Ff=N(this.Ff,16)}}),Object.defineProperty(this,"pushButton",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,17))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,17):this.Ff=N(this.Ff,17)}}),Object.defineProperty(this,"radioIsUnison",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,26))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,26):this.Ff=N(this.Ff,26)}});var e,n={};Object.defineProperty(this,"MK",{enumerable:!1,configurable:!1,get:function(){if(0!==Object.keys(n).length){var t,e=[];for(t in e.push("<<"),n)e.push("/"+t+" ("+n[t]+")");return e.push(">>"),e.join("\n")}},set:function(t){"object"===se(t)&&(n=t)}}),Object.defineProperty(this,"caption",{enumerable:!0,configurable:!0,get:function(){return n.CA||""},set:function(t){"string"==typeof t&&(n.CA=t)}}),Object.defineProperty(this,"AS",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"appearanceState",{enumerable:!0,configurable:!0,get:function(){return e.substr(1,e.length-1)},set:function(t){e="/"+t}})};r(D,M);var U=function(){D.call(this),this.pushButton=!0};r(U,D);var z=function(){D.call(this),this.radio=!0,this.pushButton=!1;var e=[];Object.defineProperty(this,"Kids",{enumerable:!0,configurable:!1,get:function(){return e},set:function(t){e=void 0!==t?t:[]}})};r(z,D);var H=function(){var e,n;M.call(this),Object.defineProperty(this,"Parent",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"optionName",{enumerable:!1,configurable:!0,get:function(){return n},set:function(t){n=t}});var r,i={};Object.defineProperty(this,"MK",{enumerable:!1,configurable:!1,get:function(){var t,e=[];for(t in e.push("<<"),i)e.push("/"+t+" ("+i[t]+")");return e.push(">>"),e.join("\n")},set:function(t){"object"===se(t)&&(i=t)}}),Object.defineProperty(this,"caption",{enumerable:!0,configurable:!0,get:function(){return i.CA||""},set:function(t){"string"==typeof t&&(i.CA=t)}}),Object.defineProperty(this,"AS",{enumerable:!1,configurable:!1,get:function(){return r},set:function(t){r=t}}),Object.defineProperty(this,"appearanceState",{enumerable:!0,configurable:!0,get:function(){return r.substr(1,r.length-1)},set:function(t){r="/"+t}}),this.optionName=name,this.caption="l",this.appearanceState="Off",this._AppearanceType=Y.RadioButton.Circle,this.appearanceStreamContent=this._AppearanceType.createAppearanceStream(name)};r(H,M),z.prototype.setAppearance=function(t){if(!("createAppearanceStream"in t&&"getCA"in t))throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");for(var e in this.Kids)if(this.Kids.hasOwnProperty(e)){var n=this.Kids[e];n.appearanceStreamContent=t.createAppearanceStream(n.optionName),n.caption=t.getCA()}},z.prototype.createOption=function(t){this.Kids.length;var e=new H;return e.Parent=this,e.optionName=t,this.Kids.push(e),J.call(this,e),e};var W=function(){D.call(this),this.fontName="zapfdingbats",this.caption="3",this.appearanceState="On",this.value="On",this.textAlign="center",this.appearanceStreamContent=Y.CheckBox.createAppearanceStream()};r(W,D);var V=function(){M.call(this),this.FT="/Tx",Object.defineProperty(this,"multiline",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,13))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,13):this.Ff=N(this.Ff,13)}}),Object.defineProperty(this,"fileSelect",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,21))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,21):this.Ff=N(this.Ff,21)}}),Object.defineProperty(this,"doNotSpellCheck",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,23))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,23):this.Ff=N(this.Ff,23)}}),Object.defineProperty(this,"doNotScroll",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,24))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,24):this.Ff=N(this.Ff,24)}}),Object.defineProperty(this,"comb",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,25))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,25):this.Ff=N(this.Ff,25)}}),Object.defineProperty(this,"richText",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,26))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,26):this.Ff=N(this.Ff,26)}});var e=null;Object.defineProperty(this,"MaxLen",{enumerable:!0,configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"maxLength",{enumerable:!0,configurable:!0,get:function(){return e},set:function(t){Number.isInteger(t)&&(e=t)}}),Object.defineProperty(this,"hasAppearanceStream",{enumerable:!0,configurable:!0,get:function(){return this.V||this.DV}})};r(V,M);var G=function(){V.call(this),Object.defineProperty(this,"password",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,14))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,14):this.Ff=N(this.Ff,14)}}),this.password=!0};r(G,V);var Y={CheckBox:{createAppearanceStream:function(){return{N:{On:Y.CheckBox.YesNormal},D:{On:Y.CheckBox.YesPushDown,Off:Y.CheckBox.OffPushDown}}},YesPushDown:function(t){var e=l(t),n=[],r=A.internal.getFont(t.fontName,t.fontStyle).id,i=A.__private__.encodeColorString(t.color),o=h(t,t.caption);return n.push("0.749023 g"),n.push("0 0 "+_(Y.internal.getWidth(t))+" "+_(Y.internal.getHeight(t))+" re"),n.push("f"),n.push("BMC"),n.push("q"),n.push("0 0 1 rg"),n.push("/"+r+" "+_(o.fontSize)+" Tf "+i),n.push("BT"),n.push(o.text),n.push("ET"),n.push("Q"),n.push("EMC"),e.stream=n.join("\n"),e},YesNormal:function(t){var e=l(t),n=A.internal.getFont(t.fontName,t.fontStyle).id,r=A.__private__.encodeColorString(t.color),i=[],o=Y.internal.getHeight(t),a=Y.internal.getWidth(t),s=h(t,t.caption);return i.push("1 g"),i.push("0 0 "+_(a)+" "+_(o)+" re"),i.push("f"),i.push("q"),i.push("0 0 1 rg"),i.push("0 0 "+_(a-1)+" "+_(o-1)+" re"),i.push("W"),i.push("n"),i.push("0 g"),i.push("BT"),i.push("/"+n+" "+_(s.fontSize)+" Tf "+r),i.push(s.text),i.push("ET"),i.push("Q"),e.stream=i.join("\n"),e},OffPushDown:function(t){var e=l(t),n=[];return n.push("0.749023 g"),n.push("0 0 "+_(Y.internal.getWidth(t))+" "+_(Y.internal.getHeight(t))+" re"),n.push("f"),e.stream=n.join("\n"),e}},RadioButton:{Circle:{createAppearanceStream:function(t){var e={D:{Off:Y.RadioButton.Circle.OffPushDown},N:{}};return e.N[t]=Y.RadioButton.Circle.YesNormal,e.D[t]=Y.RadioButton.Circle.YesPushDown,e},getCA:function(){return"l"},YesNormal:function(t){var e=l(t),n=[],r=Y.internal.getWidth(t)<=Y.internal.getHeight(t)?Y.internal.getWidth(t)/4:Y.internal.getHeight(t)/4;r=Number((.9*r).toFixed(5));var i=Y.internal.Bezier_C,o=Number((r*i).toFixed(5));return n.push("q"),n.push("1 0 0 1 "+s(Y.internal.getWidth(t)/2)+" "+s(Y.internal.getHeight(t)/2)+" cm"),n.push(r+" 0 m"),n.push(r+" "+o+" "+o+" "+r+" 0 "+r+" c"),n.push("-"+o+" "+r+" -"+r+" "+o+" -"+r+" 0 c"),n.push("-"+r+" -"+o+" -"+o+" -"+r+" 0 -"+r+" c"),n.push(o+" -"+r+" "+r+" -"+o+" "+r+" 0 c"),n.push("f"),n.push("Q"),e.stream=n.join("\n"),e},YesPushDown:function(t){var e=l(t),n=[],r=Y.internal.getWidth(t)<=Y.internal.getHeight(t)?Y.internal.getWidth(t)/4:Y.internal.getHeight(t)/4,i=(r=Number((.9*r).toFixed(5)),Number((2*r).toFixed(5))),o=Number((i*Y.internal.Bezier_C).toFixed(5)),a=Number((r*Y.internal.Bezier_C).toFixed(5));return n.push("0.749023 g"),n.push("q"),n.push("1 0 0 1 "+s(Y.internal.getWidth(t)/2)+" "+s(Y.internal.getHeight(t)/2)+" cm"),n.push(i+" 0 m"),n.push(i+" "+o+" "+o+" "+i+" 0 "+i+" c"),n.push("-"+o+" "+i+" -"+i+" "+o+" -"+i+" 0 c"),n.push("-"+i+" -"+o+" -"+o+" -"+i+" 0 -"+i+" c"),n.push(o+" -"+i+" "+i+" -"+o+" "+i+" 0 c"),n.push("f"),n.push("Q"),n.push("0 g"),n.push("q"),n.push("1 0 0 1 "+s(Y.internal.getWidth(t)/2)+" "+s(Y.internal.getHeight(t)/2)+" cm"),n.push(r+" 0 m"),n.push(r+" "+a+" "+a+" "+r+" 0 "+r+" c"),n.push("-"+a+" "+r+" -"+r+" "+a+" -"+r+" 0 c"),n.push("-"+r+" -"+a+" -"+a+" -"+r+" 0 -"+r+" c"),n.push(a+" -"+r+" "+r+" -"+a+" "+r+" 0 c"),n.push("f"),n.push("Q"),e.stream=n.join("\n"),e},OffPushDown:function(t){var e=l(t),n=[],r=Y.internal.getWidth(t)<=Y.internal.getHeight(t)?Y.internal.getWidth(t)/4:Y.internal.getHeight(t)/4,i=(r=Number((.9*r).toFixed(5)),Number((2*r).toFixed(5))),o=Number((i*Y.internal.Bezier_C).toFixed(5));return n.push("0.749023 g"),n.push("q"),n.push("1 0 0 1 "+s(Y.internal.getWidth(t)/2)+" "+s(Y.internal.getHeight(t)/2)+" cm"),n.push(i+" 0 m"),n.push(i+" "+o+" "+o+" "+i+" 0 "+i+" c"),n.push("-"+o+" "+i+" -"+i+" "+o+" -"+i+" 0 c"),n.push("-"+i+" -"+o+" -"+o+" -"+i+" 0 -"+i+" c"),n.push(o+" -"+i+" "+i+" -"+o+" "+i+" 0 c"),n.push("f"),n.push("Q"),e.stream=n.join("\n"),e}},Cross:{createAppearanceStream:function(t){var e={D:{Off:Y.RadioButton.Cross.OffPushDown},N:{}};return e.N[t]=Y.RadioButton.Cross.YesNormal,e.D[t]=Y.RadioButton.Cross.YesPushDown,e},getCA:function(){return"8"},YesNormal:function(t){var e=l(t),n=[],r=Y.internal.calculateCross(t);return n.push("q"),n.push("1 1 "+_(Y.internal.getWidth(t)-2)+" "+_(Y.internal.getHeight(t)-2)+" re"),n.push("W"),n.push("n"),n.push(_(r.x1.x)+" "+_(r.x1.y)+" m"),n.push(_(r.x2.x)+" "+_(r.x2.y)+" l"),n.push(_(r.x4.x)+" "+_(r.x4.y)+" m"),n.push(_(r.x3.x)+" "+_(r.x3.y)+" l"),n.push("s"),n.push("Q"),e.stream=n.join("\n"),e},YesPushDown:function(t){var e=l(t),n=Y.internal.calculateCross(t),r=[];return r.push("0.749023 g"),r.push("0 0 "+_(Y.internal.getWidth(t))+" "+_(Y.internal.getHeight(t))+" re"),r.push("f"),r.push("q"),r.push("1 1 "+_(Y.internal.getWidth(t)-2)+" "+_(Y.internal.getHeight(t)-2)+" re"),r.push("W"),r.push("n"),r.push(_(n.x1.x)+" "+_(n.x1.y)+" m"),r.push(_(n.x2.x)+" "+_(n.x2.y)+" l"),r.push(_(n.x4.x)+" "+_(n.x4.y)+" m"),r.push(_(n.x3.x)+" "+_(n.x3.y)+" l"),r.push("s"),r.push("Q"),e.stream=r.join("\n"),e},OffPushDown:function(t){var e=l(t),n=[];return n.push("0.749023 g"),n.push("0 0 "+_(Y.internal.getWidth(t))+" "+_(Y.internal.getHeight(t))+" re"),n.push("f"),e.stream=n.join("\n"),e}}},createDefaultAppearanceStream:function(t){var e=A.internal.getFont(t.fontName,t.fontStyle).id,n=A.__private__.encodeColorString(t.color);return"/"+e+" "+t.fontSize+" Tf "+n}};Y.internal={Bezier_C:.551915024494,calculateCross:function(t){var e=Y.internal.getWidth(t),n=Y.internal.getHeight(t),r=Math.min(e,n);return{x1:{x:(e-r)/2,y:(n-r)/2+r},x2:{x:(e-r)/2+r,y:(n-r)/2},x3:{x:(e-r)/2,y:(n-r)/2},x4:{x:(e-r)/2+r,y:(n-r)/2+r}}}},Y.internal.getWidth=function(t){var e=0;return"object"===se(t)&&(e=v(t.Rect[2])),e},Y.internal.getHeight=function(t){var e=0;return"object"===se(t)&&(e=v(t.Rect[3])),e};var J=t.addField=function(t){if(k.call(this),!(t instanceof M))throw new Error("Invalid argument passed to jsPDF.addField.");return function(t){A.internal.acroformPlugin.printedOut&&(A.internal.acroformPlugin.printedOut=!1,A.internal.acroformPlugin.acroFormDictionaryRoot=null),A.internal.acroformPlugin.acroFormDictionaryRoot||k.call(A),A.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(t)}.call(this,t),t.page=A.internal.getCurrentPageInfo().pageNumber,this};t.addButton=function(t){if(t instanceof D==!1)throw new Error("Invalid argument passed to jsPDF.addButton.");return J.call(this,t)},t.addTextField=function(t){if(t instanceof V==!1)throw new Error("Invalid argument passed to jsPDF.addTextField.");return J.call(this,t)},t.addChoiceField=function(t){if(t instanceof O==!1)throw new Error("Invalid argument passed to jsPDF.addChoiceField.");return J.call(this,t)};"object"==se(e)&&void 0===e.ChoiceField&&void 0===e.ListBox&&void 0===e.ComboBox&&void 0===e.EditBox&&void 0===e.Button&&void 0===e.PushButton&&void 0===e.RadioButton&&void 0===e.CheckBox&&void 0===e.TextField&&void 0===e.PasswordField?(e.ChoiceField=O,e.ListBox=q,e.ComboBox=T,e.EditBox=R,e.Button=D,e.PushButton=U,e.RadioButton=z,e.CheckBox=W,e.TextField=V,e.PasswordField=G,e.AcroForm={Appearance:Y}):console.warn("AcroForm-Classes are not populated into global-namespace, because the class-Names exist already."),t.AcroFormChoiceField=O,t.AcroFormListBox=q,t.AcroFormComboBox=T,t.AcroFormEditBox=R,t.AcroFormButton=D,t.AcroFormPushButton=U,t.AcroFormRadioButton=z,t.AcroFormCheckBox=W,t.AcroFormTextField=V,t.AcroFormPasswordField=G,t.AcroFormAppearance=Y,t.AcroForm={ChoiceField:O,ListBox:q,ComboBox:T,EditBox:R,Button:D,PushButton:U,RadioButton:z,CheckBox:W,TextField:V,PasswordField:G,Appearance:Y}})((window.tmp=lt).API,"undefined"!=typeof window&&window||"undefined"!=typeof global&&global),
/** @license
   * jsPDF addImage plugin
   * Copyright (c) 2012 Jason Siefken, https://github.com/siefkenj/
   *               2013 Chris Dowling, https://github.com/gingerchris
   *               2013 Trinh Ho, https://github.com/ineedfat
   *               2013 Edwin Alejandro Perez, https://github.com/eaparango
   *               2013 Norah Smith, https://github.com/burnburnrocket
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 James Robb, https://github.com/jamesbrobb
   *
   * 
   */
function(x){var N="addImage_",l={PNG:[[137,80,78,71]],TIFF:[[77,77,0,42],[73,73,42,0]],JPEG:[[255,216,255,224,void 0,void 0,74,70,73,70,0],[255,216,255,225,void 0,void 0,69,120,105,102,0,0]],JPEG2000:[[0,0,0,12,106,80,32,32]],GIF87a:[[71,73,70,56,55,97]],GIF89a:[[71,73,70,56,57,97]],BMP:[[66,77],[66,65],[67,73],[67,80],[73,67],[80,84]]},h=x.getImageFileTypeByImageData=function(t,e){var n,r;e=e||"UNKNOWN";var i,o,a,s="UNKNOWN";for(a in x.isArrayBufferView(t)&&(t=x.arrayBufferToBinaryString(t)),l)for(i=l[a],n=0;n<i.length;n+=1){for(o=!0,r=0;r<i[n].length;r+=1)if(void 0!==i[n][r]&&i[n][r]!==t.charCodeAt(r)){o=!1;break}if(!0===o){s=a;break}}return"UNKNOWN"===s&&"UNKNOWN"!==e&&(console.warn('FileType of Image not recognized. Processing image as "'+e+'".'),s=e),s},n=function t(e){for(var n=this.internal.newObject(),r=this.internal.write,i=this.internal.putStream,o=(0,this.internal.getFilters)();-1!==o.indexOf("FlateEncode");)o.splice(o.indexOf("FlateEncode"),1);e.n=n;var a=[];if(a.push({key:"Type",value:"/XObject"}),a.push({key:"Subtype",value:"/Image"}),a.push({key:"Width",value:e.w}),a.push({key:"Height",value:e.h}),e.cs===this.color_spaces.INDEXED?a.push({key:"ColorSpace",value:"[/Indexed /DeviceRGB "+(e.pal.length/3-1)+" "+("smask"in e?n+2:n+1)+" 0 R]"}):(a.push({key:"ColorSpace",value:"/"+e.cs}),e.cs===this.color_spaces.DEVICE_CMYK&&a.push({key:"Decode",value:"[1 0 1 0 1 0 1 0]"})),a.push({key:"BitsPerComponent",value:e.bpc}),"dp"in e&&a.push({key:"DecodeParms",value:"<<"+e.dp+">>"}),"trns"in e&&e.trns.constructor==Array){for(var s="",l=0,h=e.trns.length;l<h;l++)s+=e.trns[l]+" "+e.trns[l]+" ";a.push({key:"Mask",value:"["+s+"]"})}"smask"in e&&a.push({key:"SMask",value:n+1+" 0 R"});var u=void 0!==e.f?["/"+e.f]:void 0;if(i({data:e.data,additionalKeyValues:a,alreadyAppliedFilters:u}),r("endobj"),"smask"in e){var c="/Predictor "+e.p+" /Colors 1 /BitsPerComponent "+e.bpc+" /Columns "+e.w,f={w:e.w,h:e.h,cs:"DeviceGray",bpc:e.bpc,dp:c,data:e.smask};"f"in e&&(f.f=e.f),t.call(this,f)}e.cs===this.color_spaces.INDEXED&&(this.internal.newObject(),i({data:this.arrayBufferToBinaryString(new Uint8Array(e.pal))}),r("endobj"))},L=function(){var t=this.internal.collections[N+"images"];for(var e in t)n.call(this,t[e])},A=function(){var t,e=this.internal.collections[N+"images"],n=this.internal.write;for(var r in e)n("/I"+(t=e[r]).i,t.n,"0","R")},S=function(t){return"function"==typeof x["process"+t.toUpperCase()]},_=function(t){return"object"===se(t)&&1===t.nodeType},F=function(t,e){if("IMG"===t.nodeName&&t.hasAttribute("src")){var n=""+t.getAttribute("src");if(0===n.indexOf("data:image/"))return unescape(n);var r=x.loadFile(n);if(void 0!==r)return btoa(r)}if("CANVAS"===t.nodeName){var i=t;return t.toDataURL("image/jpeg",1)}(i=document.createElement("canvas")).width=t.clientWidth||t.width,i.height=t.clientHeight||t.height;var o=i.getContext("2d");if(!o)throw"addImage requires canvas to be supported by browser.";return o.drawImage(t,0,0,i.width,i.height),i.toDataURL("png"==(""+e).toLowerCase()?"image/png":"image/jpeg")},P=function(t,e){var n;if(e)for(var r in e)if(t===e[r].alias){n=e[r];break}return n};x.color_spaces={DEVICE_RGB:"DeviceRGB",DEVICE_GRAY:"DeviceGray",DEVICE_CMYK:"DeviceCMYK",CAL_GREY:"CalGray",CAL_RGB:"CalRGB",LAB:"Lab",ICC_BASED:"ICCBased",INDEXED:"Indexed",PATTERN:"Pattern",SEPARATION:"Separation",DEVICE_N:"DeviceN"},x.decode={DCT_DECODE:"DCTDecode",FLATE_DECODE:"FlateDecode",LZW_DECODE:"LZWDecode",JPX_DECODE:"JPXDecode",JBIG2_DECODE:"JBIG2Decode",ASCII85_DECODE:"ASCII85Decode",ASCII_HEX_DECODE:"ASCIIHexDecode",RUN_LENGTH_DECODE:"RunLengthDecode",CCITT_FAX_DECODE:"CCITTFaxDecode"},x.image_compression={NONE:"NONE",FAST:"FAST",MEDIUM:"MEDIUM",SLOW:"SLOW"},x.sHashCode=function(t){var e,n=0;if(0===(t=t||"").length)return n;for(e=0;e<t.length;e++)n=(n<<5)-n+t.charCodeAt(e),n|=0;return n},x.isString=function(t){return"string"==typeof t},x.validateStringAsBase64=function(t){(t=t||"").toString().trim();var e=!0;return 0===t.length&&(e=!1),t.length%4!=0&&(e=!1),!1===/^[A-Za-z0-9+\/]+$/.test(t.substr(0,t.length-2))&&(e=!1),!1===/^[A-Za-z0-9\/][A-Za-z0-9+\/]|[A-Za-z0-9+\/]=|==$/.test(t.substr(-2))&&(e=!1),e},x.extractInfoFromBase64DataURI=function(t){return/^data:([\w]+?\/([\w]+?));\S*;*base64,(.+)$/g.exec(t)},x.extractImageFromDataUrl=function(t){var e=(t=t||"").split("base64,"),n=null;if(2===e.length){var r=/^data:(\w*\/\w*);*(charset=[\w=-]*)*;*$/.exec(e[0]);Array.isArray(r)&&(n={mimeType:r[1],charset:r[2],data:e[1]})}return n},x.supportsArrayBuffer=function(){return"undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array},x.isArrayBuffer=function(t){return!!this.supportsArrayBuffer()&&t instanceof ArrayBuffer},x.isArrayBufferView=function(t){return!!this.supportsArrayBuffer()&&("undefined"!=typeof Uint32Array&&(t instanceof Int8Array||t instanceof Uint8Array||"undefined"!=typeof Uint8ClampedArray&&t instanceof Uint8ClampedArray||t instanceof Int16Array||t instanceof Uint16Array||t instanceof Int32Array||t instanceof Uint32Array||t instanceof Float32Array||t instanceof Float64Array))},x.binaryStringToUint8Array=function(t){for(var e=t.length,n=new Uint8Array(e),r=0;r<e;r++)n[r]=t.charCodeAt(r);return n},x.arrayBufferToBinaryString=function(t){if("function"==typeof atob)return atob(this.arrayBufferToBase64(t))},x.arrayBufferToBase64=function(t){for(var e,n="",r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",i=new Uint8Array(t),o=i.byteLength,a=o%3,s=o-a,l=0;l<s;l+=3)n+=r[(16515072&(e=i[l]<<16|i[l+1]<<8|i[l+2]))>>18]+r[(258048&e)>>12]+r[(4032&e)>>6]+r[63&e];return 1==a?n+=r[(252&(e=i[s]))>>2]+r[(3&e)<<4]+"==":2==a&&(n+=r[(64512&(e=i[s]<<8|i[s+1]))>>10]+r[(1008&e)>>4]+r[(15&e)<<2]+"="),n},x.createImageInfo=function(t,e,n,r,i,o,a,s,l,h,u,c,f){var p={alias:s,w:e,h:n,cs:r,bpc:i,i:a,data:t};return o&&(p.f=o),l&&(p.dp=l),h&&(p.trns=h),u&&(p.pal=u),c&&(p.smask=c),f&&(p.p=f),p},x.addImage=function(t,e,n,r,i,o,a,s,l){var h="";if("string"!=typeof e){var u=o;o=i,i=r,r=n,n=e,e=u}if("object"===se(t)&&!_(t)&&"imageData"in t){var c=t;t=c.imageData,e=c.format||e||"UNKNOWN",n=c.x||n||0,r=c.y||r||0,i=c.w||i,o=c.h||o,a=c.alias||a,s=c.compression||s,l=c.rotation||c.angle||l}var f=this.internal.getFilters();if(void 0===s&&-1!==f.indexOf("FlateEncode")&&(s="SLOW"),"string"==typeof t&&(t=unescape(t)),isNaN(n)||isNaN(r))throw console.error("jsPDF.addImage: Invalid coordinates",arguments),new Error("Invalid coordinates passed to jsPDF.addImage");var p,d,g,m,y,v,w,b=function(){var t=this.internal.collections[N+"images"];return t||(this.internal.collections[N+"images"]=t={},this.internal.events.subscribe("putResources",L),this.internal.events.subscribe("putXobjectDict",A)),t}.call(this);if(!((p=P(t,b))||(_(t)&&(t=F(t,e)),(null==(w=a)||0===w.length)&&(a="string"==typeof(v=t)?x.sHashCode(v):x.isArrayBufferView(v)?x.sHashCode(x.arrayBufferToBinaryString(v)):null),p=P(a,b)))){if(this.isString(t)&&(""!==(h=this.convertStringToImageData(t))?t=h:void 0!==(h=x.loadFile(t))&&(t=h)),e=this.getImageFileTypeByImageData(t,e),!S(e))throw new Error("addImage does not support files of type '"+e+"', please ensure that a plugin for '"+e+"' support is added.");if(this.supportsArrayBuffer()&&(t instanceof Uint8Array||(d=t,t=this.binaryStringToUint8Array(t))),!(p=this["process"+e.toUpperCase()](t,(y=0,(m=b)&&(y=Object.keys?Object.keys(m).length:function(t){var e=0;for(var n in t)t.hasOwnProperty(n)&&e++;return e}(m)),y),a,((g=s)&&"string"==typeof g&&(g=g.toUpperCase()),g in x.image_compression?g:x.image_compression.NONE),d)))throw new Error("An unknown error occurred whilst processing the image")}return function(t,e,n,r,i,o,a,s){var l=function(t,e,n){return t||e||(e=t=-96),t<0&&(t=-1*n.w*72/t/this.internal.scaleFactor),e<0&&(e=-1*n.h*72/e/this.internal.scaleFactor),0===t&&(t=e*n.w/n.h),0===e&&(e=t*n.h/n.w),[t,e]}.call(this,n,r,i),h=this.internal.getCoordinateString,u=this.internal.getVerticalCoordinateString;if(n=l[0],r=l[1],a[o]=i,s){s*=Math.PI/180;var c=Math.cos(s),f=Math.sin(s),p=function(t){return t.toFixed(4)},d=[p(c),p(f),p(-1*f),p(c),0,0,"cm"]}this.internal.write("q"),s?(this.internal.write([1,"0","0",1,h(t),u(e+r),"cm"].join(" ")),this.internal.write(d.join(" ")),this.internal.write([h(n),"0","0",h(r),"0","0","cm"].join(" "))):this.internal.write([h(n),"0","0",h(r),h(t),u(e+r),"cm"].join(" ")),this.internal.write("/I"+i.i+" Do"),this.internal.write("Q")}.call(this,n,r,i,o,p,p.i,b,l),this},x.convertStringToImageData=function(t){var e,n="";if(this.isString(t)){var r;e=null!==(r=this.extractImageFromDataUrl(t))?r.data:t;try{n=atob(e)}catch(t){throw x.validateStringAsBase64(e)?new Error("atob-Error in jsPDF.convertStringToImageData "+t.message):new Error("Supplied Data is not a valid base64-String jsPDF.convertStringToImageData ")}}return n};var u=function(t,e){return t.subarray(e,e+5)};x.processJPEG=function(t,e,n,r,i,o){var a,s=this.decode.DCT_DECODE;if(!this.isString(t)&&!this.isArrayBuffer(t)&&!this.isArrayBufferView(t))return null;if(this.isString(t)&&(a=function(t){var e;if("JPEG"!==h(t))throw new Error("getJpegSize requires a binary string jpeg file");for(var n=256*t.charCodeAt(4)+t.charCodeAt(5),r=4,i=t.length;r<i;){if(r+=n,255!==t.charCodeAt(r))throw new Error("getJpegSize could not find the size of the image");if(192===t.charCodeAt(r+1)||193===t.charCodeAt(r+1)||194===t.charCodeAt(r+1)||195===t.charCodeAt(r+1)||196===t.charCodeAt(r+1)||197===t.charCodeAt(r+1)||198===t.charCodeAt(r+1)||199===t.charCodeAt(r+1))return e=256*t.charCodeAt(r+5)+t.charCodeAt(r+6),[256*t.charCodeAt(r+7)+t.charCodeAt(r+8),e,t.charCodeAt(r+9)];r+=2,n=256*t.charCodeAt(r)+t.charCodeAt(r+1)}}(t)),this.isArrayBuffer(t)&&(t=new Uint8Array(t)),this.isArrayBufferView(t)&&(a=function(t){if(65496!=(t[0]<<8|t[1]))throw new Error("Supplied data is not a JPEG");for(var e,n=t.length,r=(t[4]<<8)+t[5],i=4;i<n;){if(r=((e=u(t,i+=r))[2]<<8)+e[3],(192===e[1]||194===e[1])&&255===e[0]&&7<r)return{width:((e=u(t,i+5))[2]<<8)+e[3],height:(e[0]<<8)+e[1],numcomponents:e[4]};i+=2}throw new Error("getJpegSizeFromBytes could not find the size of the image")}(t),t=i||this.arrayBufferToBinaryString(t)),void 0===o)switch(a.numcomponents){case 1:o=this.color_spaces.DEVICE_GRAY;break;case 4:o=this.color_spaces.DEVICE_CMYK;break;default:case 3:o=this.color_spaces.DEVICE_RGB}return this.createImageInfo(t,a.width,a.height,o,8,s,e,n)},x.processJPG=function(){return this.processJPEG.apply(this,arguments)},x.getImageProperties=function(t){var e,n,r="";if(_(t)&&(t=F(t)),this.isString(t)&&(""!==(r=this.convertStringToImageData(t))?t=r:void 0!==(r=x.loadFile(t))&&(t=r)),n=this.getImageFileTypeByImageData(t),!S(n))throw new Error("addImage does not support files of type '"+n+"', please ensure that a plugin for '"+n+"' support is added.");if(this.supportsArrayBuffer()&&(t instanceof Uint8Array||(t=this.binaryStringToUint8Array(t))),!(e=this["process"+n.toUpperCase()](t)))throw new Error("An unknown error occurred whilst processing the image");return{fileType:n,width:e.w,height:e.h,colorSpace:e.cs,compressionMode:e.f,bitsPerComponent:e.bpc}}}(lt.API),
/**
   * @license
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
t=lt.API,lt.API.events.push(["addPage",function(t){this.internal.getPageInfo(t.pageNumber).pageContext.annotations=[]}]),t.events.push(["putPage",function(t){for(var e=this.internal.getPageInfoByObjId(t.objId),n=t.pageContext.annotations,r=function(t){if(void 0!==t&&""!=t)return!0},i=!1,o=0;o<n.length&&!i;o++)switch((l=n[o]).type){case"link":if(r(l.options.url)||r(l.options.pageNumber)){i=!0;break}case"reference":case"text":case"freetext":i=!0}if(0!=i){this.internal.write("/Annots ["),this.internal.pageSize.height;var a=this.internal.getCoordinateString,s=this.internal.getVerticalCoordinateString;for(o=0;o<n.length;o++){var l;switch((l=n[o]).type){case"reference":this.internal.write(" "+l.object.objId+" 0 R ");break;case"text":var h=this.internal.newAdditionalObject(),u=this.internal.newAdditionalObject(),c=l.title||"Note";m="<</Type /Annot /Subtype /Text "+(p="/Rect ["+a(l.bounds.x)+" "+s(l.bounds.y+l.bounds.h)+" "+a(l.bounds.x+l.bounds.w)+" "+s(l.bounds.y)+"] ")+"/Contents ("+l.contents+")",m+=" /Popup "+u.objId+" 0 R",m+=" /P "+e.objId+" 0 R",m+=" /T ("+c+") >>",h.content=m;var f=h.objId+" 0 R";m="<</Type /Annot /Subtype /Popup "+(p="/Rect ["+a(l.bounds.x+30)+" "+s(l.bounds.y+l.bounds.h)+" "+a(l.bounds.x+l.bounds.w+30)+" "+s(l.bounds.y)+"] ")+" /Parent "+f,l.open&&(m+=" /Open true"),m+=" >>",u.content=m,this.internal.write(h.objId,"0 R",u.objId,"0 R");break;case"freetext":var p="/Rect ["+a(l.bounds.x)+" "+s(l.bounds.y)+" "+a(l.bounds.x+l.bounds.w)+" "+s(l.bounds.y+l.bounds.h)+"] ",d=l.color||"#000000";m="<</Type /Annot /Subtype /FreeText "+p+"/Contents ("+l.contents+")",m+=" /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#"+d+")",m+=" /Border [0 0 0]",m+=" >>",this.internal.write(m);break;case"link":if(l.options.name){var g=this.annotations._nameMap[l.options.name];l.options.pageNumber=g.page,l.options.top=g.y}else l.options.top||(l.options.top=0);p="/Rect ["+a(l.x)+" "+s(l.y)+" "+a(l.x+l.w)+" "+s(l.y+l.h)+"] ";var m="";if(l.options.url)m="<</Type /Annot /Subtype /Link "+p+"/Border [0 0 0] /A <</S /URI /URI ("+l.options.url+") >>";else if(l.options.pageNumber)switch(m="<</Type /Annot /Subtype /Link "+p+"/Border [0 0 0] /Dest ["+this.internal.getPageInfo(l.options.pageNumber).objId+" 0 R",l.options.magFactor=l.options.magFactor||"XYZ",l.options.magFactor){case"Fit":m+=" /Fit]";break;case"FitH":m+=" /FitH "+l.options.top+"]";break;case"FitV":l.options.left=l.options.left||0,m+=" /FitV "+l.options.left+"]";break;case"XYZ":default:var y=s(l.options.top);l.options.left=l.options.left||0,void 0===l.options.zoom&&(l.options.zoom=0),m+=" /XYZ "+l.options.left+" "+y+" "+l.options.zoom+"]"}""!=m&&(m+=" >>",this.internal.write(m))}}this.internal.write("]")}}]),t.createAnnotation=function(t){var e=this.internal.getCurrentPageInfo();switch(t.type){case"link":this.link(t.bounds.x,t.bounds.y,t.bounds.w,t.bounds.h,t);break;case"text":case"freetext":e.pageContext.annotations.push(t)}},t.link=function(t,e,n,r,i){this.internal.getCurrentPageInfo().pageContext.annotations.push({x:t,y:e,w:n,h:r,options:i,type:"link"})},t.textWithLink=function(t,e,n,r){var i=this.getTextWidth(t),o=this.internal.getLineHeight()/this.internal.scaleFactor;return this.text(t,e,n),n+=.2*o,this.link(e,n-o,i,o,r),i},t.getTextWidth=function(t){var e=this.internal.getFontSize();return this.getStringUnitWidth(t)*e/this.internal.scaleFactor},
/**
   * @license
   * Copyright (c) 2017 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
function(t){var h={1569:[65152],1570:[65153,65154],1571:[65155,65156],1572:[65157,65158],1573:[65159,65160],1574:[65161,65162,65163,65164],1575:[65165,65166],1576:[65167,65168,65169,65170],1577:[65171,65172],1578:[65173,65174,65175,65176],1579:[65177,65178,65179,65180],1580:[65181,65182,65183,65184],1581:[65185,65186,65187,65188],1582:[65189,65190,65191,65192],1583:[65193,65194],1584:[65195,65196],1585:[65197,65198],1586:[65199,65200],1587:[65201,65202,65203,65204],1588:[65205,65206,65207,65208],1589:[65209,65210,65211,65212],1590:[65213,65214,65215,65216],1591:[65217,65218,65219,65220],1592:[65221,65222,65223,65224],1593:[65225,65226,65227,65228],1594:[65229,65230,65231,65232],1601:[65233,65234,65235,65236],1602:[65237,65238,65239,65240],1603:[65241,65242,65243,65244],1604:[65245,65246,65247,65248],1605:[65249,65250,65251,65252],1606:[65253,65254,65255,65256],1607:[65257,65258,65259,65260],1608:[65261,65262],1609:[65263,65264,64488,64489],1610:[65265,65266,65267,65268],1649:[64336,64337],1655:[64477],1657:[64358,64359,64360,64361],1658:[64350,64351,64352,64353],1659:[64338,64339,64340,64341],1662:[64342,64343,64344,64345],1663:[64354,64355,64356,64357],1664:[64346,64347,64348,64349],1667:[64374,64375,64376,64377],1668:[64370,64371,64372,64373],1670:[64378,64379,64380,64381],1671:[64382,64383,64384,64385],1672:[64392,64393],1676:[64388,64389],1677:[64386,64387],1678:[64390,64391],1681:[64396,64397],1688:[64394,64395],1700:[64362,64363,64364,64365],1702:[64366,64367,64368,64369],1705:[64398,64399,64400,64401],1709:[64467,64468,64469,64470],1711:[64402,64403,64404,64405],1713:[64410,64411,64412,64413],1715:[64406,64407,64408,64409],1722:[64414,64415],1723:[64416,64417,64418,64419],1726:[64426,64427,64428,64429],1728:[64420,64421],1729:[64422,64423,64424,64425],1733:[64480,64481],1734:[64473,64474],1735:[64471,64472],1736:[64475,64476],1737:[64482,64483],1739:[64478,64479],1740:[64508,64509,64510,64511],1744:[64484,64485,64486,64487],1746:[64430,64431],1747:[64432,64433]},a={65247:{65154:65269,65156:65271,65160:65273,65166:65275},65248:{65154:65270,65156:65272,65160:65274,65166:65276},65165:{65247:{65248:{65258:65010}}},1617:{1612:64606,1613:64607,1614:64608,1615:64609,1616:64610}},e={1612:64606,1613:64607,1614:64608,1615:64609,1616:64610},n=[1570,1571,1573,1575];t.__arabicParser__={};var r=t.__arabicParser__.isInArabicSubstitutionA=function(t){return void 0!==h[t.charCodeAt(0)]},u=t.__arabicParser__.isArabicLetter=function(t){return"string"==typeof t&&/^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(t)},i=t.__arabicParser__.isArabicEndLetter=function(t){return u(t)&&r(t)&&h[t.charCodeAt(0)].length<=2},o=t.__arabicParser__.isArabicAlfLetter=function(t){return u(t)&&0<=n.indexOf(t.charCodeAt(0))},s=(t.__arabicParser__.arabicLetterHasIsolatedForm=function(t){return u(t)&&r(t)&&1<=h[t.charCodeAt(0)].length},t.__arabicParser__.arabicLetterHasFinalForm=function(t){return u(t)&&r(t)&&2<=h[t.charCodeAt(0)].length}),l=(t.__arabicParser__.arabicLetterHasInitialForm=function(t){return u(t)&&r(t)&&3<=h[t.charCodeAt(0)].length},t.__arabicParser__.arabicLetterHasMedialForm=function(t){return u(t)&&r(t)&&4==h[t.charCodeAt(0)].length}),c=t.__arabicParser__.resolveLigatures=function(t){var e=0,n=a,r=0,i="",o=0;for(e=0;e<t.length;e+=1)void 0!==n[t.charCodeAt(e)]?(o++,"number"==typeof(n=n[t.charCodeAt(e)])&&(r=-1!==(r=f(t.charAt(e),t.charAt(e-o),t.charAt(e+1)))?r:0,i+=String.fromCharCode(n),n=a,o=0),e===t.length-1&&(n=a,i+=t.charAt(e-(o-1)),e-=o-1,o=0)):(n=a,i+=t.charAt(e-o),e-=o,o=0);return i},f=(t.__arabicParser__.isArabicDiacritic=function(t){return void 0!==t&&void 0!==e[t.charCodeAt(0)]},t.__arabicParser__.getCorrectForm=function(t,e,n){return u(t)?!1===r(t)?-1:!s(t)||!u(e)&&!u(n)||!u(n)&&i(e)||i(t)&&!u(e)||i(t)&&o(e)||i(t)&&i(e)?0:l(t)&&u(e)&&!i(e)&&u(n)&&s(n)?3:i(t)||!u(n)?1:2:-1}),p=t.__arabicParser__.processArabic=t.processArabic=function(t){var e=0,n=0,r=0,i="",o="",a="",s=(t=t||"").split("\\s+"),l=[];for(e=0;e<s.length;e+=1){for(l.push(""),n=0;n<s[e].length;n+=1)i=s[e][n],o=s[e][n-1],a=s[e][n+1],u(i)?(r=f(i,o,a),l[e]+=-1!==r?String.fromCharCode(h[i.charCodeAt(0)][r]):i):l[e]+=i;l[e]=c(l[e])}return l.join(" ")};t.events.push(["preProcessText",function(t){var e=t.text,n=(t.x,t.y,t.options||{}),r=(t.mutex,n.lang,[]);if("[object Array]"===Object.prototype.toString.call(e)){var i=0;for(r=[],i=0;i<e.length;i+=1)"[object Array]"===Object.prototype.toString.call(e[i])?r.push([p(e[i][0]),e[i][1],e[i][2]]):r.push([p(e[i])]);t.text=r}else t.text=p(e)}])}(lt.API),lt.API.autoPrint=function(t){var e;switch((t=t||{}).variant=t.variant||"non-conform",t.variant){case"javascript":this.addJS("print({});");break;case"non-conform":default:this.internal.events.subscribe("postPutResources",function(){e=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/S /Named"),this.internal.out("/Type /Action"),this.internal.out("/N /Print"),this.internal.out(">>"),this.internal.out("endobj")}),this.internal.events.subscribe("putCatalog",function(){this.internal.out("/OpenAction "+e+" 0 R")})}return this},
/**
   * @license
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
e=lt.API,(n=function(){var e=void 0;Object.defineProperty(this,"pdf",{get:function(){return e},set:function(t){e=t}});var n=150;Object.defineProperty(this,"width",{get:function(){return n},set:function(t){n=isNaN(t)||!1===Number.isInteger(t)||t<0?150:t,this.getContext("2d").pageWrapXEnabled&&(this.getContext("2d").pageWrapX=n+1)}});var r=300;Object.defineProperty(this,"height",{get:function(){return r},set:function(t){r=isNaN(t)||!1===Number.isInteger(t)||t<0?300:t,this.getContext("2d").pageWrapYEnabled&&(this.getContext("2d").pageWrapY=r+1)}});var i=[];Object.defineProperty(this,"childNodes",{get:function(){return i},set:function(t){i=t}});var o={};Object.defineProperty(this,"style",{get:function(){return o},set:function(t){o=t}}),Object.defineProperty(this,"parentNode",{get:function(){return!1}})}).prototype.getContext=function(t,e){var n;if("2d"!==(t=t||"2d"))return null;for(n in e)this.pdf.context2d.hasOwnProperty(n)&&(this.pdf.context2d[n]=e[n]);return(this.pdf.context2d._canvas=this).pdf.context2d},n.prototype.toDataURL=function(){throw new Error("toDataURL is not implemented.")},e.events.push(["initialized",function(){this.canvas=new n,this.canvas.pdf=this}]),
/** 
   * @license
   * ====================================================================
   * Copyright (c) 2013 Youssef Beddad, youssef.beddad@gmail.com
   *               2013 Eduardo Menezes de Morais, eduardo.morais@usp.br
   *               2013 Lee Driscoll, https://github.com/lsdriscoll
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 James Hall, james@parall.ax
   *               2014 Diego Casorran, https://github.com/diegocr
   *
   * 
   * ====================================================================
   */
_=lt.API,F={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},P=1,p=function(t,e,n,r,i){F={x:t,y:e,w:n,h:r,ln:i}},d=function(){return F},k={left:0,top:0,bottom:0},_.setHeaderFunction=function(t){l=t},_.getTextDimensions=function(t,e){var n=this.table_font_size||this.internal.getFontSize(),r=(this.internal.getFont().fontStyle,(e=e||{}).scaleFactor||this.internal.scaleFactor),i=0,o=0,a=0;if("string"==typeof t)0!=(i=this.getStringUnitWidth(t)*n)&&(o=1);else{if("[object Array]"!==Object.prototype.toString.call(t))throw new Error("getTextDimensions expects text-parameter to be of type String or an Array of Strings.");for(var s=0;s<t.length;s++)i<(a=this.getStringUnitWidth(t[s])*n)&&(i=a);0!==i&&(o=t.length)}return{w:i/=r,h:Math.max((o*n*this.getLineHeightFactor()-n*(this.getLineHeightFactor()-1))/r,0)}},_.cellAddPage=function(){var t=this.margins||k;this.addPage(),p(t.left,t.top,void 0,void 0),P+=1},_.cellInitialize=function(){F={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},P=1},_.cell=function(t,e,n,r,i,o,a){var s=d(),l=!1;if(void 0!==s.ln)if(s.ln===o)t=s.x+s.w,e=s.y;else{var h=this.margins||k;s.y+s.h+r+13>=this.internal.pageSize.getHeight()-h.bottom&&(this.cellAddPage(),l=!0,this.printHeaders&&this.tableHeaderRow&&this.printHeaderRow(o,!0)),e=d().y+d().h,l&&(e=23)}if(void 0!==i[0])if(this.printingHeaderRow?this.rect(t,e,n,r,"FD"):this.rect(t,e,n,r),"right"===a){i instanceof Array||(i=[i]);for(var u=0;u<i.length;u++){var c=i[u],f=this.getStringUnitWidth(c)*this.internal.getFontSize()/this.internal.scaleFactor;this.text(c,t+n-f-3,e+this.internal.getLineHeight()*(u+1))}}else this.text(i,t+3,e+this.internal.getLineHeight());return p(t,e,n,r,o),this},_.arrayMax=function(t,e){var n,r,i,o=t[0];for(n=0,r=t.length;n<r;n+=1)i=t[n],e?-1===e(o,i)&&(o=i):o<i&&(o=i);return o},_.table=function(t,e,n,r,i){if(!n)throw"No data for PDF table";var o,a,s,l,h,u,c,f,p,d,g=[],m=[],y={},v={},w=[],b=[],x=!1,N=!0,L=12,A=k;if(A.width=this.internal.pageSize.getWidth(),i&&(!0===i.autoSize&&(x=!0),!1===i.printHeaders&&(N=!1),i.fontSize&&(L=i.fontSize),i.css&&void 0!==i.css["font-size"]&&(L=16*i.css["font-size"]),i.margins&&(A=i.margins)),this.lnMod=0,F={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},P=1,this.printHeaders=N,this.margins=A,this.setFontSize(L),this.table_font_size=L,null==r)g=Object.keys(n[0]);else if(r[0]&&"string"!=typeof r[0])for(a=0,s=r.length;a<s;a+=1)o=r[a],g.push(o.name),m.push(o.prompt),v[o.name]=o.width*(19.049976/25.4);else g=r;if(x)for(d=function(t){return t[o]},a=0,s=g.length;a<s;a+=1){for(y[o=g[a]]=n.map(d),w.push(this.getTextDimensions(m[a]||o,{scaleFactor:1}).w),c=0,l=(u=y[o]).length;c<l;c+=1)h=u[c],w.push(this.getTextDimensions(h,{scaleFactor:1}).w);v[o]=_.arrayMax(w),w=[]}if(N){var S=this.calculateLineHeight(g,v,m.length?m:g);for(a=0,s=g.length;a<s;a+=1)o=g[a],b.push([t,e,v[o],S,String(m.length?m[a]:o)]);this.setTableHeaderRow(b),this.printHeaderRow(1,!1)}for(a=0,s=n.length;a<s;a+=1)for(f=n[a],S=this.calculateLineHeight(g,v,f),c=0,p=g.length;c<p;c+=1)o=g[c],this.cell(t,e,v[o],S,f[o],a+2,o.align);return this.lastCellPos=F,this.table_x=t,this.table_y=e,this},_.calculateLineHeight=function(t,e,n){for(var r,i=0,o=0;o<t.length;o++){n[r=t[o]]=this.splitTextToSize(String(n[r]),e[r]-3);var a=this.internal.getLineHeight()*n[r].length+3;i<a&&(i=a)}return i},_.setTableHeaderRow=function(t){this.tableHeaderRow=t},_.printHeaderRow=function(t,e){if(!this.tableHeaderRow)throw"Property tableHeaderRow does not exist.";var n,r,i,o;if(this.printingHeaderRow=!0,void 0!==l){var a=l(this,P);p(a[0],a[1],a[2],a[3],-1)}this.setFontStyle("bold");var s=[];for(i=0,o=this.tableHeaderRow.length;i<o;i+=1)this.setFillColor(200,200,200),n=this.tableHeaderRow[i],e&&(this.margins.top=13,n[1]=this.margins&&this.margins.top||0,s.push(n)),r=[].concat(n),this.cell.apply(this,r.concat(t));0<s.length&&this.setTableHeaderRow(s),this.setFontStyle("normal"),this.printingHeaderRow=!1},
/**
   * jsPDF Context2D PlugIn Copyright (c) 2014 Steven Spungin (TwelveTone LLC) steven@twelvetone.tv
   *
   * Licensed under the MIT License. http://opensource.org/licenses/mit-license
   */
function(t,e){var l,i,o,h,u,c=function(t){return t=t||{},this.isStrokeTransparent=t.isStrokeTransparent||!1,this.strokeOpacity=t.strokeOpacity||1,this.strokeStyle=t.strokeStyle||"#000000",this.fillStyle=t.fillStyle||"#000000",this.isFillTransparent=t.isFillTransparent||!1,this.fillOpacity=t.fillOpacity||1,this.font=t.font||"10px sans-serif",this.textBaseline=t.textBaseline||"alphabetic",this.textAlign=t.textAlign||"left",this.lineWidth=t.lineWidth||1,this.lineJoin=t.lineJoin||"miter",this.lineCap=t.lineCap||"butt",this.path=t.path||[],this.transform=void 0!==t.transform?t.transform.clone():new M,this.globalCompositeOperation=t.globalCompositeOperation||"normal",this.globalAlpha=t.globalAlpha||1,this.clip_path=t.clip_path||[],this.currentPoint=t.currentPoint||new j,this.miterLimit=t.miterLimit||10,this.lastPoint=t.lastPoint||new j,this.ignoreClearRect="boolean"!=typeof t.ignoreClearRect||t.ignoreClearRect,this};t.events.push(["initialized",function(){this.context2d=new n(this),l=this.internal.f2,this.internal.f3,i=this.internal.getCoordinateString,o=this.internal.getVerticalCoordinateString,h=this.internal.getHorizontalCoordinate,u=this.internal.getVerticalCoordinate}]);var n=function(t){Object.defineProperty(this,"canvas",{get:function(){return{parentNode:!1,style:!1}}}),Object.defineProperty(this,"pdf",{get:function(){return t}});var e=!1;Object.defineProperty(this,"pageWrapXEnabled",{get:function(){return e},set:function(t){e=Boolean(t)}});var n=!1;Object.defineProperty(this,"pageWrapYEnabled",{get:function(){return n},set:function(t){n=Boolean(t)}});var r=0;Object.defineProperty(this,"posX",{get:function(){return r},set:function(t){isNaN(t)||(r=t)}});var i=0;Object.defineProperty(this,"posY",{get:function(){return i},set:function(t){isNaN(t)||(i=t)}});var o=!1;Object.defineProperty(this,"autoPaging",{get:function(){return o},set:function(t){o=Boolean(t)}});var a=0;Object.defineProperty(this,"lastBreak",{get:function(){return a},set:function(t){a=t}});var s=[];Object.defineProperty(this,"pageBreaks",{get:function(){return s},set:function(t){s=t}});var l=new c;Object.defineProperty(this,"ctx",{get:function(){return l},set:function(t){t instanceof c&&(l=t)}}),Object.defineProperty(this,"path",{get:function(){return l.path},set:function(t){l.path=t}});var h=[];Object.defineProperty(this,"ctxStack",{get:function(){return h},set:function(t){h=t}}),Object.defineProperty(this,"fillStyle",{get:function(){return this.ctx.fillStyle},set:function(t){var e;e=f(t),this.ctx.fillStyle=e.style,this.ctx.isFillTransparent=0===e.a,this.ctx.fillOpacity=e.a,this.pdf.setFillColor(e.r,e.g,e.b,{a:e.a}),this.pdf.setTextColor(e.r,e.g,e.b,{a:e.a})}}),Object.defineProperty(this,"strokeStyle",{get:function(){return this.ctx.strokeStyle},set:function(t){var e=f(t);this.ctx.strokeStyle=e.style,this.ctx.isStrokeTransparent=0===e.a,this.ctx.strokeOpacity=e.a,0===e.a?this.pdf.setDrawColor(255,255,255):(e.a,this.pdf.setDrawColor(e.r,e.g,e.b))}}),Object.defineProperty(this,"lineCap",{get:function(){return this.ctx.lineCap},set:function(t){-1!==["butt","round","square"].indexOf(t)&&(this.ctx.lineCap=t,this.pdf.setLineCap(t))}}),Object.defineProperty(this,"lineWidth",{get:function(){return this.ctx.lineWidth},set:function(t){isNaN(t)||(this.ctx.lineWidth=t,this.pdf.setLineWidth(t))}}),Object.defineProperty(this,"lineJoin",{get:function(){return this.ctx.lineJoin},set:function(t){-1!==["bevel","round","miter"].indexOf(t)&&(this.ctx.lineJoin=t,this.pdf.setLineJoin(t))}}),Object.defineProperty(this,"miterLimit",{get:function(){return this.ctx.miterLimit},set:function(t){isNaN(t)||(this.ctx.miterLimit=t,this.pdf.setMiterLimit(t))}}),Object.defineProperty(this,"textBaseline",{get:function(){return this.ctx.textBaseline},set:function(t){this.ctx.textBaseline=t}}),Object.defineProperty(this,"textAlign",{get:function(){return this.ctx.textAlign},set:function(t){-1!==["right","end","center","left","start"].indexOf(t)&&(this.ctx.textAlign=t)}}),Object.defineProperty(this,"font",{get:function(){return this.ctx.font},set:function(t){var e;if(this.ctx.font=t,null!==(e=/^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z]+?)\s*$/i.exec(t))){var n=e[1],r=(e[2],e[3]),i=e[4],o=e[5],a=e[6];i="px"===o?Math.floor(parseFloat(i)):"em"===o?Math.floor(parseFloat(i)*this.pdf.getFontSize()):Math.floor(parseFloat(i)),this.pdf.setFontSize(i);var s="";("bold"===r||700<=parseInt(r,10)||"bold"===n)&&(s="bold"),"italic"===n&&(s+="italic"),0===s.length&&(s="normal");for(var l="",h=a.toLowerCase().replace(/"|'/g,"").split(/\s*,\s*/),u={arial:"Helvetica",verdana:"Helvetica",helvetica:"Helvetica","sans-serif":"Helvetica",fixed:"Courier",monospace:"Courier",terminal:"Courier",courier:"Courier",times:"Times",cursive:"Times",fantasy:"Times",serif:"Times"},c=0;c<h.length;c++){if(void 0!==this.pdf.internal.getFont(h[c],s,{noFallback:!0,disableWarning:!0})){l=h[c];break}if("bolditalic"===s&&void 0!==this.pdf.internal.getFont(h[c],"bold",{noFallback:!0,disableWarning:!0}))l=h[c],s="bold";else if(void 0!==this.pdf.internal.getFont(h[c],"normal",{noFallback:!0,disableWarning:!0})){l=h[c],s="normal";break}}if(""===l)for(c=0;c<h.length;c++)if(u[h[c]]){l=u[h[c]];break}l=""===l?"Times":l,this.pdf.setFont(l,s)}}}),Object.defineProperty(this,"globalCompositeOperation",{get:function(){return this.ctx.globalCompositeOperation},set:function(t){this.ctx.globalCompositeOperation=t}}),Object.defineProperty(this,"globalAlpha",{get:function(){return this.ctx.globalAlpha},set:function(t){this.ctx.globalAlpha=t}}),Object.defineProperty(this,"ignoreClearRect",{get:function(){return this.ctx.ignoreClearRect},set:function(t){this.ctx.ignoreClearRect=Boolean(t)}})};n.prototype.fill=function(){r.call(this,"fill",!1)},n.prototype.stroke=function(){r.call(this,"stroke",!1)},n.prototype.beginPath=function(){this.path=[{type:"begin"}]},n.prototype.moveTo=function(t,e){if(isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.moveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.moveTo");var n=this.ctx.transform.applyToPoint(new j(t,e));this.path.push({type:"mt",x:n.x,y:n.y}),this.ctx.lastPoint=new j(t,e)},n.prototype.closePath=function(){var t=new j(0,0),e=0;for(e=this.path.length-1;-1!==e;e--)if("begin"===this.path[e].type&&"object"===se(this.path[e+1])&&"number"==typeof this.path[e+1].x){t=new j(this.path[e+1].x,this.path[e+1].y),this.path.push({type:"lt",x:t.x,y:t.y});break}"object"===se(this.path[e+2])&&"number"==typeof this.path[e+2].x&&this.path.push(JSON.parse(JSON.stringify(this.path[e+2]))),this.path.push({type:"close"}),this.ctx.lastPoint=new j(t.x,t.y)},n.prototype.lineTo=function(t,e){if(isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.lineTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.lineTo");var n=this.ctx.transform.applyToPoint(new j(t,e));this.path.push({type:"lt",x:n.x,y:n.y}),this.ctx.lastPoint=new j(n.x,n.y)},n.prototype.clip=function(){this.ctx.clip_path=JSON.parse(JSON.stringify(this.path)),r.call(this,null,!0)},n.prototype.quadraticCurveTo=function(t,e,n,r){if(isNaN(n)||isNaN(r)||isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");var i=this.ctx.transform.applyToPoint(new j(n,r)),o=this.ctx.transform.applyToPoint(new j(t,e));this.path.push({type:"qct",x1:o.x,y1:o.y,x:i.x,y:i.y}),this.ctx.lastPoint=new j(i.x,i.y)},n.prototype.bezierCurveTo=function(t,e,n,r,i,o){if(isNaN(i)||isNaN(o)||isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.bezierCurveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");var a=this.ctx.transform.applyToPoint(new j(i,o)),s=this.ctx.transform.applyToPoint(new j(t,e)),l=this.ctx.transform.applyToPoint(new j(n,r));this.path.push({type:"bct",x1:s.x,y1:s.y,x2:l.x,y2:l.y,x:a.x,y:a.y}),this.ctx.lastPoint=new j(a.x,a.y)},n.prototype.arc=function(t,e,n,r,i,o){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||isNaN(i))throw console.error("jsPDF.context2d.arc: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.arc");if(o=Boolean(o),!this.ctx.transform.isIdentity){var a=this.ctx.transform.applyToPoint(new j(t,e));t=a.x,e=a.y;var s=this.ctx.transform.applyToPoint(new j(0,n)),l=this.ctx.transform.applyToPoint(new j(0,0));n=Math.sqrt(Math.pow(s.x-l.x,2)+Math.pow(s.y-l.y,2))}Math.abs(i-r)>=2*Math.PI&&(r=0,i=2*Math.PI),this.path.push({type:"arc",x:t,y:e,radius:n,startAngle:r,endAngle:i,counterclockwise:o})},n.prototype.arcTo=function(t,e,n,r,i){throw new Error("arcTo not implemented.")},n.prototype.rect=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.rect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.rect");this.moveTo(t,e),this.lineTo(t+n,e),this.lineTo(t+n,e+r),this.lineTo(t,e+r),this.lineTo(t,e),this.lineTo(t+n,e),this.lineTo(t,e)},n.prototype.fillRect=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.fillRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.fillRect");if(!N.call(this)){var i={};"butt"!==this.lineCap&&(i.lineCap=this.lineCap,this.lineCap="butt"),"miter"!==this.lineJoin&&(i.lineJoin=this.lineJoin,this.lineJoin="miter"),this.beginPath(),this.rect(t,e,n,r),this.fill(),i.hasOwnProperty("lineCap")&&(this.lineCap=i.lineCap),i.hasOwnProperty("lineJoin")&&(this.lineJoin=i.lineJoin)}},n.prototype.strokeRect=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.strokeRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");L.call(this)||(this.beginPath(),this.rect(t,e,n,r),this.stroke())},n.prototype.clearRect=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.clearRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.clearRect");this.ignoreClearRect||(this.fillStyle="#ffffff",this.fillRect(t,e,n,r))},n.prototype.save=function(t){t="boolean"!=typeof t||t;for(var e=this.pdf.internal.getCurrentPageInfo().pageNumber,n=0;n<this.pdf.internal.getNumberOfPages();n++)this.pdf.setPage(n+1),this.pdf.internal.out("q");if(this.pdf.setPage(e),t){this.ctx.fontSize=this.pdf.internal.getFontSize();var r=new c(this.ctx);this.ctxStack.push(this.ctx),this.ctx=r}},n.prototype.restore=function(t){t="boolean"!=typeof t||t;for(var e=this.pdf.internal.getCurrentPageInfo().pageNumber,n=0;n<this.pdf.internal.getNumberOfPages();n++)this.pdf.setPage(n+1),this.pdf.internal.out("Q");this.pdf.setPage(e),t&&0!==this.ctxStack.length&&(this.ctx=this.ctxStack.pop(),this.fillStyle=this.ctx.fillStyle,this.strokeStyle=this.ctx.strokeStyle,this.font=this.ctx.font,this.lineCap=this.ctx.lineCap,this.lineWidth=this.ctx.lineWidth,this.lineJoin=this.ctx.lineJoin)},n.prototype.toDataURL=function(){throw new Error("toDataUrl not implemented.")};var f=function(t){var e,n,r,i;if(!0===t.isCanvasGradient&&(t=t.getColor()),!t)return{r:0,g:0,b:0,a:0,style:t};if(/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(t))i=r=n=e=0;else{var o=/rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(t);if(null!==o)e=parseInt(o[1]),n=parseInt(o[2]),r=parseInt(o[3]),i=1;else if(null!==(o=/rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d\.]+)\s*\)/.exec(t)))e=parseInt(o[1]),n=parseInt(o[2]),r=parseInt(o[3]),i=parseFloat(o[4]);else{if(i=1,"string"==typeof t&&"#"!==t.charAt(0)){var a=new RGBColor(t);t=a.ok?a.toHex():"#000000"}4===t.length?(e=t.substring(1,2),e+=e,n=t.substring(2,3),n+=n,r=t.substring(3,4),r+=r):(e=t.substring(1,3),n=t.substring(3,5),r=t.substring(5,7)),e=parseInt(e,16),n=parseInt(n,16),r=parseInt(r,16)}}return{r:e,g:n,b:r,a:i,style:t}},N=function(){return this.ctx.isFillTransparent||0==this.globalAlpha},L=function(){return Boolean(this.ctx.isStrokeTransparent||0==this.globalAlpha)};n.prototype.fillText=function(t,e,n,r){if(isNaN(e)||isNaN(n)||"string"!=typeof t)throw console.error("jsPDF.context2d.fillText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.fillText");if(r=isNaN(r)?void 0:r,!N.call(this)){n=a.call(this,n);var i=B(this.ctx.transform.rotation),o=this.ctx.transform.scaleX;s.call(this,{text:t,x:e,y:n,scale:o,angle:i,align:this.textAlign,maxWidth:r})}},n.prototype.strokeText=function(t,e,n,r){if(isNaN(e)||isNaN(n)||"string"!=typeof t)throw console.error("jsPDF.context2d.strokeText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.strokeText");if(!L.call(this)){r=isNaN(r)?void 0:r,n=a.call(this,n);var i=B(this.ctx.transform.rotation),o=this.ctx.transform.scaleX;s.call(this,{text:t,x:e,y:n,scale:o,renderingMode:"stroke",angle:i,align:this.textAlign,maxWidth:r})}},n.prototype.measureText=function(t){if("string"!=typeof t)throw console.error("jsPDF.context2d.measureText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.measureText");var e=this.pdf,n=this.pdf.internal.scaleFactor,r=e.internal.getFontSize(),i=e.getStringUnitWidth(t)*r/e.internal.scaleFactor;return new function(t){var e=(t=t||{}).width||0;return Object.defineProperty(this,"width",{get:function(){return e}}),this}({width:i*=Math.round(96*n/72*1e4)/1e4})},n.prototype.scale=function(t,e){if(isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.scale: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.scale");var n=new M(t,0,0,e,0,0);this.ctx.transform=this.ctx.transform.multiply(n)},n.prototype.rotate=function(t){if(isNaN(t))throw console.error("jsPDF.context2d.rotate: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.rotate");var e=new M(Math.cos(t),Math.sin(t),-Math.sin(t),Math.cos(t),0,0);this.ctx.transform=this.ctx.transform.multiply(e)},n.prototype.translate=function(t,e){if(isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.translate: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.translate");var n=new M(1,0,0,1,t,e);this.ctx.transform=this.ctx.transform.multiply(n)},n.prototype.transform=function(t,e,n,r,i,o){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||isNaN(i)||isNaN(o))throw console.error("jsPDF.context2d.transform: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.transform");var a=new M(t,e,n,r,i,o);this.ctx.transform=this.ctx.transform.multiply(a)},n.prototype.setTransform=function(t,e,n,r,i,o){t=isNaN(t)?1:t,e=isNaN(e)?0:e,n=isNaN(n)?0:n,r=isNaN(r)?1:r,i=isNaN(i)?0:i,o=isNaN(o)?0:o,this.ctx.transform=new M(t,e,n,r,i,o)},n.prototype.drawImage=function(t,e,n,r,i,o,a,s,l){var h=this.pdf.getImageProperties(t),u=1,c=1,f=1,p=1;void 0!==r&&void 0!==s&&(f=s/r,p=l/i,u=h.width/r*s/r,c=h.height/i*l/i),void 0===o&&(o=e,a=n,n=e=0),void 0!==r&&void 0===s&&(s=r,l=i),void 0===r&&void 0===s&&(s=h.width,l=h.height);var d=this.ctx.transform.decompose(),g=B(d.rotate.shx);d.scale.sx,d.scale.sy;for(var m,y=new M,v=((y=(y=(y=y.multiply(d.translate)).multiply(d.skew)).multiply(d.scale)).applyToPoint(new j(s,l)),y.applyToRectangle(new E(o-e*f,a-n*p,r*u,i*c))),w=F.call(this,v),b=[],x=0;x<w.length;x+=1)-1===b.indexOf(w[x])&&b.push(w[x]);if(b.sort(),this.autoPaging)for(var N=b[0],L=b[b.length-1],A=N;A<L+1;A++){if(this.pdf.setPage(A),0!==this.ctx.clip_path.length){var S=this.path;m=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=P(m,this.posX,-1*this.pdf.internal.pageSize.height*(A-1)+this.posY),k.call(this,"fill",!0),this.path=S}var _=JSON.parse(JSON.stringify(v));_=P([_],this.posX,-1*this.pdf.internal.pageSize.height*(A-1)+this.posY)[0],this.pdf.addImage(t,"jpg",_.x,_.y,_.w,_.h,null,null,g)}else this.pdf.addImage(t,"jpg",v.x,v.y,v.w,v.h,null,null,g)};var F=function(t,e,n){var r=[];switch(e=e||this.pdf.internal.pageSize.width,n=n||this.pdf.internal.pageSize.height,t.type){default:case"mt":case"lt":r.push(Math.floor((t.y+this.posY)/n)+1);break;case"arc":r.push(Math.floor((t.y+this.posY-t.radius)/n)+1),r.push(Math.floor((t.y+this.posY+t.radius)/n)+1);break;case"qct":var i=w(this.ctx.lastPoint.x,this.ctx.lastPoint.y,t.x1,t.y1,t.x,t.y);r.push(Math.floor(i.y/n)+1),r.push(Math.floor((i.y+i.h)/n)+1);break;case"bct":var o=b(this.ctx.lastPoint.x,this.ctx.lastPoint.y,t.x1,t.y1,t.x2,t.y2,t.x,t.y);r.push(Math.floor(o.y/n)+1),r.push(Math.floor((o.y+o.h)/n)+1);break;case"rect":r.push(Math.floor((t.y+this.posY)/n)+1),r.push(Math.floor((t.y+t.h+this.posY)/n)+1)}for(var a=0;a<r.length;a+=1)for(;this.pdf.internal.getNumberOfPages()<r[a];)v.call(this);return r},v=function(){var t=this.fillStyle,e=this.strokeStyle,n=this.font,r=this.lineCap,i=this.lineWidth,o=this.lineJoin;this.pdf.addPage(),this.fillStyle=t,this.strokeStyle=e,this.font=n,this.lineCap=r,this.lineWidth=i,this.lineJoin=o},P=function(t,e,n){for(var r=0;r<t.length;r++)switch(t[r].type){case"bct":t[r].x2+=e,t[r].y2+=n;case"qct":t[r].x1+=e,t[r].y1+=n;case"mt":case"lt":case"arc":default:t[r].x+=e,t[r].y+=n}return t},r=function(t,e){for(var n,r,i=this.fillStyle,o=this.strokeStyle,a=(this.font,this.lineCap),s=this.lineWidth,l=this.lineJoin,h=JSON.parse(JSON.stringify(this.path)),u=JSON.parse(JSON.stringify(this.path)),c=[],f=0;f<u.length;f++)if(void 0!==u[f].x)for(var p=F.call(this,u[f]),d=0;d<p.length;d+=1)-1===c.indexOf(p[d])&&c.push(p[d]);for(f=0;f<c.length;f++)for(;this.pdf.internal.getNumberOfPages()<c[f];)v.call(this);if(c.sort(),this.autoPaging){var g=c[0],m=c[c.length-1];for(f=g;f<m+1;f++){if(this.pdf.setPage(f),this.fillStyle=i,this.strokeStyle=o,this.lineCap=a,this.lineWidth=s,this.lineJoin=l,0!==this.ctx.clip_path.length){var y=this.path;n=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=P(n,this.posX,-1*this.pdf.internal.pageSize.height*(f-1)+this.posY),k.call(this,t,!0),this.path=y}r=JSON.parse(JSON.stringify(h)),this.path=P(r,this.posX,-1*this.pdf.internal.pageSize.height*(f-1)+this.posY),!1!==e&&0!==f||k.call(this,t,e)}}else k.call(this,t,e);this.path=h},k=function(t,e){if(("stroke"!==t||e||!L.call(this))&&("stroke"===t||e||!N.call(this))){var n=[];this.ctx.globalAlpha;this.ctx.fillOpacity<1&&this.ctx.fillOpacity;for(var r,i=this.path,o=0;o<i.length;o++){var a=i[o];switch(a.type){case"begin":n.push({begin:!0});break;case"close":n.push({close:!0});break;case"mt":n.push({start:a,deltas:[],abs:[]});break;case"lt":var s=n.length;if(!isNaN(i[o-1].x)){var l=[a.x-i[o-1].x,a.y-i[o-1].y];if(0<s)for(;0<=s;s--)if(!0!==n[s-1].close&&!0!==n[s-1].begin){n[s-1].deltas.push(l),n[s-1].abs.push(a);break}}break;case"bct":l=[a.x1-i[o-1].x,a.y1-i[o-1].y,a.x2-i[o-1].x,a.y2-i[o-1].y,a.x-i[o-1].x,a.y-i[o-1].y];n[n.length-1].deltas.push(l);break;case"qct":var h=i[o-1].x+2/3*(a.x1-i[o-1].x),u=i[o-1].y+2/3*(a.y1-i[o-1].y),c=a.x+2/3*(a.x1-a.x),f=a.y+2/3*(a.y1-a.y),p=a.x,d=a.y;l=[h-i[o-1].x,u-i[o-1].y,c-i[o-1].x,f-i[o-1].y,p-i[o-1].x,d-i[o-1].y];n[n.length-1].deltas.push(l);break;case"arc":n.push({deltas:[],abs:[],arc:!0}),Array.isArray(n[n.length-1].abs)&&n[n.length-1].abs.push(a)}}r=e?null:"stroke"===t?"stroke":"fill";for(o=0;o<n.length;o++){if(n[o].arc)for(var g=n[o].abs,m=0;m<g.length;m++){var y=g[m];if(void 0!==y.startAngle){var v=B(y.startAngle),w=B(y.endAngle),b=y.x,x=y.y;A.call(this,b,x,y.radius,v,w,y.counterclockwise,r,e)}else I.call(this,y.x,y.y)}if(!n[o].arc&&!0!==n[o].close&&!0!==n[o].begin){b=n[o].start.x,x=n[o].start.y;C.call(this,n[o].deltas,b,x,null,null)}}r&&S.call(this,r),e&&_.call(this)}},a=function(t){var e=this.pdf.internal.getFontSize()/this.pdf.internal.scaleFactor,n=e*(this.pdf.internal.getLineHeightFactor()-1);switch(this.ctx.textBaseline){case"bottom":return t-n;case"top":return t+e-n;case"hanging":return t+e-2*n;case"middle":return t+e/2-n;case"ideographic":return t;case"alphabetic":default:return t}};n.prototype.createLinearGradient=function(){var t=function(){};return t.colorStops=[],t.addColorStop=function(t,e){this.colorStops.push([t,e])},t.getColor=function(){return 0===this.colorStops.length?"#000000":this.colorStops[0][1]},t.isCanvasGradient=!0,t},n.prototype.createPattern=function(){return this.createLinearGradient()},n.prototype.createRadialGradient=function(){return this.createLinearGradient()};var A=function(t,e,n,r,i,o,a,s){this.pdf.internal.scaleFactor;for(var l=y(r),h=y(i),u=g.call(this,n,l,h,o),c=0;c<u.length;c++){var f=u[c];0===c&&p.call(this,f.x1+t,f.y1+e),d.call(this,t,e,f.x2,f.y2,f.x3,f.y3,f.x4,f.y4)}s?_.call(this):S.call(this,a)},S=function(t){switch(t){case"stroke":this.pdf.internal.out("S");break;case"fill":this.pdf.internal.out("f")}},_=function(){this.pdf.clip()},p=function(t,e){this.pdf.internal.out(i(t)+" "+o(e)+" m")},s=function(t){var e;switch(t.align){case"right":case"end":e="right";break;case"center":e="center";break;case"left":case"start":default:e="left"}var n=this.ctx.transform.applyToPoint(new j(t.x,t.y)),r=this.ctx.transform.decompose(),i=new M;i=(i=(i=i.multiply(r.translate)).multiply(r.skew)).multiply(r.scale);for(var o,a=this.pdf.getTextDimensions(t.text),s=this.ctx.transform.applyToRectangle(new E(t.x,t.y,a.w,a.h)),l=i.applyToRectangle(new E(t.x,t.y-a.h,a.w,a.h)),h=F.call(this,l),u=[],c=0;c<h.length;c+=1)-1===u.indexOf(h[c])&&u.push(h[c]);if(u.sort(),!0===this.autoPaging)for(var f=u[0],p=u[u.length-1],d=f;d<p+1;d++){if(this.pdf.setPage(d),0!==this.ctx.clip_path.length){var g=this.path;o=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=P(o,this.posX,-1*this.pdf.internal.pageSize.height*(d-1)+this.posY),k.call(this,"fill",!0),this.path=g}var m=JSON.parse(JSON.stringify(s));if(m=P([m],this.posX,-1*this.pdf.internal.pageSize.height*(d-1)+this.posY)[0],.01<=t.scale){var y=this.pdf.internal.getFontSize();this.pdf.setFontSize(y*t.scale)}this.pdf.text(t.text,m.x,m.y,{angle:t.angle,align:e,renderingMode:t.renderingMode,maxWidth:t.maxWidth}),.01<=t.scale&&this.pdf.setFontSize(y)}else{if(.01<=t.scale){y=this.pdf.internal.getFontSize();this.pdf.setFontSize(y*t.scale)}this.pdf.text(t.text,n.x+this.posX,n.y+this.posY,{angle:t.angle,align:e,renderingMode:t.renderingMode,maxWidth:t.maxWidth}),.01<=t.scale&&this.pdf.setFontSize(y)}},I=function(t,e,n,r){n=n||0,r=r||0,this.pdf.internal.out(i(t+n)+" "+o(e+r)+" l")},C=function(t,e,n){return this.pdf.lines(t,e,n,null,null)},d=function(t,e,n,r,i,o,a,s){this.pdf.internal.out([l(h(n+t)),l(u(r+e)),l(h(i+t)),l(u(o+e)),l(h(a+t)),l(u(s+e)),"c"].join(" "))},g=function(t,e,n,r){var i=2*Math.PI,o=e;(o<i||i<o)&&(o%=i);var a=n;(a<i||i<a)&&(a%=i);for(var s=[],l=Math.PI/2,h=r?-1:1,u=e,c=Math.min(i,Math.abs(a-o));1e-5<c;){var f=u+h*Math.min(c,l);s.push(m.call(this,t,u,f)),c-=Math.abs(f-u),u=f}return s},m=function(t,e,n){var r=(n-e)/2,i=t*Math.cos(r),o=t*Math.sin(r),a=i,s=-o,l=a*a+s*s,h=l+a*i+s*o,u=4/3*(Math.sqrt(2*l*h)-h)/(a*o-s*i),c=a-u*s,f=s+u*a,p=c,d=-f,g=r+e,m=Math.cos(g),y=Math.sin(g);return{x1:t*Math.cos(e),y1:t*Math.sin(e),x2:c*m-f*y,y2:c*y+f*m,x3:p*m-d*y,y3:p*y+d*m,x4:t*Math.cos(n),y4:t*Math.sin(n)}},B=function(t){return 180*t/Math.PI},y=function(t){return t*Math.PI/180},w=function(t,e,n,r,i,o){var a=t+.5*(n-t),s=e+.5*(r-e),l=i+.5*(n-i),h=o+.5*(r-o),u=Math.min(t,i,a,l),c=Math.max(t,i,a,l),f=Math.min(e,o,s,h),p=Math.max(e,o,s,h);return new E(u,f,c-u,p-f)},b=function(t,e,n,r,i,o,a,s){for(var l,h,u,c,f,p,d,g,m,y,v,w,b,x=n-t,N=r-e,L=i-n,A=o-r,S=a-i,_=s-o,F=0;F<41;F++)g=(p=(h=t+(l=F/40)*x)+l*((c=n+l*L)-h))+l*(c+l*(i+l*S-c)-p),m=(d=(u=e+l*N)+l*((f=r+l*A)-u))+l*(f+l*(o+l*_-f)-d),b=0==F?(w=y=g,v=m):(y=Math.min(y,g),v=Math.min(v,m),w=Math.max(w,g),Math.max(b,m));return new E(Math.round(y),Math.round(v),Math.round(w-y),Math.round(b-v))},j=function(t,e){var n=t||0;Object.defineProperty(this,"x",{enumerable:!0,get:function(){return n},set:function(t){isNaN(t)||(n=parseFloat(t))}});var r=e||0;Object.defineProperty(this,"y",{enumerable:!0,get:function(){return r},set:function(t){isNaN(t)||(r=parseFloat(t))}});var i="pt";return Object.defineProperty(this,"type",{enumerable:!0,get:function(){return i},set:function(t){i=t.toString()}}),this},E=function(t,e,n,r){j.call(this,t,e),this.type="rect";var i=n||0;Object.defineProperty(this,"w",{enumerable:!0,get:function(){return i},set:function(t){isNaN(t)||(i=parseFloat(t))}});var o=r||0;return Object.defineProperty(this,"h",{enumerable:!0,get:function(){return o},set:function(t){isNaN(t)||(o=parseFloat(t))}}),this},M=function(t,e,n,r,i,o){var a=[];return Object.defineProperty(this,"sx",{get:function(){return a[0]},set:function(t){a[0]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"shy",{get:function(){return a[1]},set:function(t){a[1]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"shx",{get:function(){return a[2]},set:function(t){a[2]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"sy",{get:function(){return a[3]},set:function(t){a[3]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"tx",{get:function(){return a[4]},set:function(t){a[4]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"ty",{get:function(){return a[5]},set:function(t){a[5]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"rotation",{get:function(){return Math.atan2(this.shx,this.sx)}}),Object.defineProperty(this,"scaleX",{get:function(){return this.decompose().scale.sx}}),Object.defineProperty(this,"scaleY",{get:function(){return this.decompose().scale.sy}}),Object.defineProperty(this,"isIdentity",{get:function(){return 1===this.sx&&(0===this.shy&&(0===this.shx&&(1===this.sy&&(0===this.tx&&0===this.ty))))}}),this.sx=isNaN(t)?1:t,this.shy=isNaN(e)?0:e,this.shx=isNaN(n)?0:n,this.sy=isNaN(r)?1:r,this.tx=isNaN(i)?0:i,this.ty=isNaN(o)?0:o,this};M.prototype.multiply=function(t){var e=t.sx*this.sx+t.shy*this.shx,n=t.sx*this.shy+t.shy*this.sy,r=t.shx*this.sx+t.sy*this.shx,i=t.shx*this.shy+t.sy*this.sy,o=t.tx*this.sx+t.ty*this.shx+this.tx,a=t.tx*this.shy+t.ty*this.sy+this.ty;return new M(e,n,r,i,o,a)},M.prototype.decompose=function(){var t=this.sx,e=this.shy,n=this.shx,r=this.sy,i=this.tx,o=this.ty,a=Math.sqrt(t*t+e*e),s=(t/=a)*n+(e/=a)*r;n-=t*s,r-=e*s;var l=Math.sqrt(n*n+r*r);return s/=l,t*(r/=l)<e*(n/=l)&&(t=-t,e=-e,s=-s,a=-a),{scale:new M(a,0,0,l,0,0),translate:new M(1,0,0,1,i,o),rotate:new M(t,e,-e,t,0,0),skew:new M(1,0,s,1,0,0)}},M.prototype.applyToPoint=function(t){var e=t.x*this.sx+t.y*this.shx+this.tx,n=t.x*this.shy+t.y*this.sy+this.ty;return new j(e,n)},M.prototype.applyToRectangle=function(t){var e=this.applyToPoint(t),n=this.applyToPoint(new j(t.x+t.w,t.y+t.h));return new E(e.x,e.y,n.x-e.x,n.y-e.y)},M.prototype.clone=function(){var t=this.sx,e=this.shy,n=this.shx,r=this.sy,i=this.tx,o=this.ty;return new M(t,e,n,r,i,o)}}(lt.API,"undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()),
/**
   * jsPDF filters PlugIn
   * Copyright (c) 2014 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
a=lt.API,o=function(t){var r,e,n,i,o,a,s,l,h,u;for(/[^\x00-\xFF]/.test(t),e=[],n=0,i=(t+=r="\0\0\0\0".slice(t.length%4||4)).length;n<i;n+=4)0!==(o=(t.charCodeAt(n)<<24)+(t.charCodeAt(n+1)<<16)+(t.charCodeAt(n+2)<<8)+t.charCodeAt(n+3))?(a=(o=((o=((o=((o=(o-(u=o%85))/85)-(h=o%85))/85)-(l=o%85))/85)-(s=o%85))/85)%85,e.push(a+33,s+33,l+33,h+33,u+33)):e.push(122);return function(t,e){for(var n=r.length;0<n;n--)t.pop()}(e),String.fromCharCode.apply(String,e)+"~>"},s=function(t){var r,e,n,i,o,a=String,s="length",l="charCodeAt",h="slice",u="replace";for(t[h](-2),t=t[h](0,-2)[u](/\s/g,"")[u]("z","!!!!!"),n=[],i=0,o=(t+=r="uuuuu"[h](t[s]%5||5))[s];i<o;i+=5)e=52200625*(t[l](i)-33)+614125*(t[l](i+1)-33)+7225*(t[l](i+2)-33)+85*(t[l](i+3)-33)+(t[l](i+4)-33),n.push(255&e>>24,255&e>>16,255&e>>8,255&e);return function(t,e){for(var n=r[s];0<n;n--)t.pop()}(n),a.fromCharCode.apply(a,n)},h=function(t){for(var e="",n=0;n<t.length;n+=1)e+=("0"+t.charCodeAt(n).toString(16)).slice(-2);return e+=">"},u=function(t){var e=new RegExp(/^([0-9A-Fa-f]{2})+$/);if(-1!==(t=t.replace(/\s/g,"")).indexOf(">")&&(t=t.substr(0,t.indexOf(">"))),t.length%2&&(t+="0"),!1===e.test(t))return"";for(var n="",r=0;r<t.length;r+=2)n+=String.fromCharCode("0x"+(t[r]+t[r+1]));return n},c=function(t,e){e=Object.assign({predictor:1,colors:1,bitsPerComponent:8,columns:1},e);for(var n,r,i=[],o=t.length;o--;)i[o]=t.charCodeAt(o);return n=a.adler32cs.from(t),(r=new Deflater(6)).append(new Uint8Array(i)),t=r.flush(),(i=new Uint8Array(t.length+6)).set(new Uint8Array([120,156])),i.set(t,2),i.set(new Uint8Array([255&n,n>>8&255,n>>16&255,n>>24&255]),t.length+2),t=String.fromCharCode.apply(null,i)},a.processDataByFilters=function(t,e){var n=0,r=t||"",i=[];for("string"==typeof(e=e||[])&&(e=[e]),n=0;n<e.length;n+=1)switch(e[n]){case"ASCII85Decode":case"/ASCII85Decode":r=s(r),i.push("/ASCII85Encode");break;case"ASCII85Encode":case"/ASCII85Encode":r=o(r),i.push("/ASCII85Decode");break;case"ASCIIHexDecode":case"/ASCIIHexDecode":r=u(r),i.push("/ASCIIHexEncode");break;case"ASCIIHexEncode":case"/ASCIIHexEncode":r=h(r),i.push("/ASCIIHexDecode");break;case"FlateEncode":case"/FlateEncode":r=c(r),i.push("/FlateDecode");break;default:throw'The filter: "'+e[n]+'" is not implemented'}return{data:r,reverseChain:i.reverse().join(" ")}},(
/**
   * jsPDF fileloading PlugIn
   * Copyright (c) 2018 Aras Abbasi (aras.abbasi@gmail.com)
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
r=lt.API).loadFile=function(t,e,n){var r;e=e||!0,n=n||function(){};try{r=function(t,e,n){var r=new XMLHttpRequest,i=[],o=0,a=function(t){var e=t.length,n=String.fromCharCode;for(o=0;o<e;o+=1)i.push(n(255&t.charCodeAt(o)));return i.join("")};if(r.open("GET",t,!e),r.overrideMimeType("text/plain; charset=x-user-defined"),!1===e&&(r.onload=function(){return a(this.responseText)}),r.send(null),200===r.status)return e?a(r.responseText):void 0;console.warn('Unable to load file "'+t+'"')}(t,e)}catch(t){r=void 0}return r},r.loadImageFile=r.loadFile,
/**
   * Copyright (c) 2018 Erik Koopmans
   * Released under the MIT License.
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
i=lt.API,f="undefined"!=typeof window&&window||"undefined"!=typeof global&&global,g=function(t){var e=se(t);return"undefined"===e?"undefined":"string"===e||t instanceof String?"string":"number"===e||t instanceof Number?"number":"function"===e||t instanceof Function?"function":t&&t.constructor===Array?"array":t&&1===t.nodeType?"element":"object"===e?"object":"unknown"},m=function(t,e){var n=document.createElement(t);if(e.className&&(n.className=e.className),e.innerHTML){n.innerHTML=e.innerHTML;for(var r=n.getElementsByTagName("script"),i=r.length;0<i--;null)r[i].parentNode.removeChild(r[i])}for(var o in e.style)n.style[o]=e.style[o];return n},(((y=function t(e){var n=Object.assign(t.convert(Promise.resolve()),JSON.parse(JSON.stringify(t.template))),r=t.convert(Promise.resolve(),n);return r=(r=r.setProgress(1,t,1,[t])).set(e)}).prototype=Object.create(Promise.prototype)).constructor=y).convert=function(t,e){return t.__proto__=e||y.prototype,t},y.template={prop:{src:null,container:null,overlay:null,canvas:null,img:null,pdf:null,pageSize:null,callback:function(){}},progress:{val:0,state:null,n:0,stack:[]},opt:{filename:"file.pdf",margin:[0,0,0,0],enableLinks:!0,x:0,y:0,html2canvas:{},jsPDF:{}}},y.prototype.from=function(t,e){return this.then(function(){switch(e=e||function(t){switch(g(t)){case"string":return"string";case"element":return"canvas"===t.nodeName.toLowerCase?"canvas":"element";default:return"unknown"}}(t)){case"string":return this.set({src:m("div",{innerHTML:t})});case"element":return this.set({src:t});case"canvas":return this.set({canvas:t});case"img":return this.set({img:t});default:return this.error("Unknown source type.")}})},y.prototype.to=function(t){switch(t){case"container":return this.toContainer();case"canvas":return this.toCanvas();case"img":return this.toImg();case"pdf":return this.toPdf();default:return this.error("Invalid target.")}},y.prototype.toContainer=function(){return this.thenList([function(){return this.prop.src||this.error("Cannot duplicate - no source HTML.")},function(){return this.prop.pageSize||this.setPageSize()}]).then(function(){var t={position:"relative",display:"inline-block",width:Math.max(this.prop.src.clientWidth,this.prop.src.scrollWidth,this.prop.src.offsetWidth)+"px",left:0,right:0,top:0,margin:"auto",backgroundColor:"white"},e=function t(e,n){for(var r=3===e.nodeType?document.createTextNode(e.nodeValue):e.cloneNode(!1),i=e.firstChild;i;i=i.nextSibling)!0!==n&&1===i.nodeType&&"SCRIPT"===i.nodeName||r.appendChild(t(i,n));return 1===e.nodeType&&("CANVAS"===e.nodeName?(r.width=e.width,r.height=e.height,r.getContext("2d").drawImage(e,0,0)):"TEXTAREA"!==e.nodeName&&"SELECT"!==e.nodeName||(r.value=e.value),r.addEventListener("load",function(){r.scrollTop=e.scrollTop,r.scrollLeft=e.scrollLeft},!0)),r}(this.prop.src,this.opt.html2canvas.javascriptEnabled);"BODY"===e.tagName&&(t.height=Math.max(document.body.scrollHeight,document.body.offsetHeight,document.documentElement.clientHeight,document.documentElement.scrollHeight,document.documentElement.offsetHeight)+"px"),this.prop.overlay=m("div",{className:"html2pdf__overlay",style:{position:"fixed",overflow:"hidden",zIndex:1e3,left:"-100000px",right:0,bottom:0,top:0}}),this.prop.container=m("div",{className:"html2pdf__container",style:t}),this.prop.container.appendChild(e),this.prop.container.firstChild.appendChild(m("div",{style:{clear:"both",border:"0 none transparent",margin:0,padding:0,height:0}})),this.prop.container.style.float="none",this.prop.overlay.appendChild(this.prop.container),document.body.appendChild(this.prop.overlay),this.prop.container.firstChild.style.position="relative",this.prop.container.height=Math.max(this.prop.container.firstChild.clientHeight,this.prop.container.firstChild.scrollHeight,this.prop.container.firstChild.offsetHeight)+"px"})},y.prototype.toCanvas=function(){var t=[function(){return document.body.contains(this.prop.container)||this.toContainer()}];return this.thenList(t).then(function(){var t=Object.assign({},this.opt.html2canvas);if(delete t.onrendered,this.isHtml2CanvasLoaded())return html2canvas(this.prop.container,t)}).then(function(t){(this.opt.html2canvas.onrendered||function(){})(t),this.prop.canvas=t,document.body.removeChild(this.prop.overlay)})},y.prototype.toContext2d=function(){var t=[function(){return document.body.contains(this.prop.container)||this.toContainer()}];return this.thenList(t).then(function(){var t=this.opt.jsPDF,e=Object.assign({async:!0,allowTaint:!0,backgroundColor:"#ffffff",imageTimeout:15e3,logging:!0,proxy:null,removeContainer:!0,foreignObjectRendering:!1,useCORS:!1},this.opt.html2canvas);if(delete e.onrendered,t.context2d.autoPaging=!0,t.context2d.posX=this.opt.x,t.context2d.posY=this.opt.y,e.windowHeight=e.windowHeight||0,e.windowHeight=0==e.windowHeight?Math.max(this.prop.container.clientHeight,this.prop.container.scrollHeight,this.prop.container.offsetHeight):e.windowHeight,this.isHtml2CanvasLoaded())return html2canvas(this.prop.container,e)}).then(function(t){(this.opt.html2canvas.onrendered||function(){})(t),this.prop.canvas=t,document.body.removeChild(this.prop.overlay)})},y.prototype.toImg=function(){return this.thenList([function(){return this.prop.canvas||this.toCanvas()}]).then(function(){var t=this.prop.canvas.toDataURL("image/"+this.opt.image.type,this.opt.image.quality);this.prop.img=document.createElement("img"),this.prop.img.src=t})},y.prototype.toPdf=function(){return this.thenList([function(){return this.toContext2d()}]).then(function(){this.prop.pdf=this.prop.pdf||this.opt.jsPDF})},y.prototype.output=function(t,e,n){return"img"===(n=n||"pdf").toLowerCase()||"image"===n.toLowerCase()?this.outputImg(t,e):this.outputPdf(t,e)},y.prototype.outputPdf=function(t,e){return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).then(function(){return this.prop.pdf.output(t,e)})},y.prototype.outputImg=function(t,e){return this.thenList([function(){return this.prop.img||this.toImg()}]).then(function(){switch(t){case void 0:case"img":return this.prop.img;case"datauristring":case"dataurlstring":return this.prop.img.src;case"datauri":case"dataurl":return document.location.href=this.prop.img.src;default:throw'Image output type "'+t+'" is not supported.'}})},y.prototype.isHtml2CanvasLoaded=function(){var t=void 0!==f.html2canvas;return t||console.error("html2canvas not loaded."),t},y.prototype.save=function(t){if(this.isHtml2CanvasLoaded())return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).set(t?{filename:t}:null).then(function(){this.prop.pdf.save(this.opt.filename)})},y.prototype.doCallback=function(t){if(this.isHtml2CanvasLoaded())return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).then(function(){this.prop.callback(this.prop.pdf)})},y.prototype.set=function(e){if("object"!==g(e))return this;var t=Object.keys(e||{}).map(function(t){if(t in y.template.prop)return function(){this.prop[t]=e[t]};switch(t){case"margin":return this.setMargin.bind(this,e.margin);case"jsPDF":return function(){return this.opt.jsPDF=e.jsPDF,this.setPageSize()};case"pageSize":return this.setPageSize.bind(this,e.pageSize);default:return function(){this.opt[t]=e[t]}}},this);return this.then(function(){return this.thenList(t)})},y.prototype.get=function(e,n){return this.then(function(){var t=e in y.template.prop?this.prop[e]:this.opt[e];return n?n(t):t})},y.prototype.setMargin=function(t){return this.then(function(){switch(g(t)){case"number":t=[t,t,t,t];case"array":if(2===t.length&&(t=[t[0],t[1],t[0],t[1]]),4===t.length)break;default:return this.error("Invalid margin array.")}this.opt.margin=t}).then(this.setPageSize)},y.prototype.setPageSize=function(t){function e(t,e){return Math.floor(t*e/72*96)}return this.then(function(){(t=t||lt.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner")||(t.inner={width:t.width-this.opt.margin[1]-this.opt.margin[3],height:t.height-this.opt.margin[0]-this.opt.margin[2]},t.inner.px={width:e(t.inner.width,t.k),height:e(t.inner.height,t.k)},t.inner.ratio=t.inner.height/t.inner.width),this.prop.pageSize=t})},y.prototype.setProgress=function(t,e,n,r){return null!=t&&(this.progress.val=t),null!=e&&(this.progress.state=e),null!=n&&(this.progress.n=n),null!=r&&(this.progress.stack=r),this.progress.ratio=this.progress.val/this.progress.state,this},y.prototype.updateProgress=function(t,e,n,r){return this.setProgress(t?this.progress.val+t:null,e||null,n?this.progress.n+n:null,r?this.progress.stack.concat(r):null)},y.prototype.then=function(t,e){var n=this;return this.thenCore(t,e,function(e,t){return n.updateProgress(null,null,1,[e]),Promise.prototype.then.call(this,function(t){return n.updateProgress(null,e),t}).then(e,t).then(function(t){return n.updateProgress(1),t})})},y.prototype.thenCore=function(t,e,n){n=n||Promise.prototype.then;var r=this;t&&(t=t.bind(r)),e&&(e=e.bind(r));var i=-1!==Promise.toString().indexOf("[native code]")&&"Promise"===Promise.name?r:y.convert(Object.assign({},r),Promise.prototype),o=n.call(i,t,e);return y.convert(o,r.__proto__)},y.prototype.thenExternal=function(t,e){return Promise.prototype.then.call(this,t,e)},y.prototype.thenList=function(t){var e=this;return t.forEach(function(t){e=e.thenCore(t)}),e},y.prototype.catch=function(t){t&&(t=t.bind(this));var e=Promise.prototype.catch.call(this,t);return y.convert(e,this)},y.prototype.catchExternal=function(t){return Promise.prototype.catch.call(this,t)},y.prototype.error=function(t){return this.then(function(){throw new Error(t)})},y.prototype.using=y.prototype.set,y.prototype.saveAs=y.prototype.save,y.prototype.export=y.prototype.output,y.prototype.run=y.prototype.then,lt.getPageSize=function(t,e,n){if("object"===se(t)){var r=t;t=r.orientation,e=r.unit||e,n=r.format||n}e=e||"mm",n=n||"a4",t=(""+(t||"P")).toLowerCase();var i=(""+n).toLowerCase(),o={a0:[2383.94,3370.39],a1:[1683.78,2383.94],a2:[1190.55,1683.78],a3:[841.89,1190.55],a4:[595.28,841.89],a5:[419.53,595.28],a6:[297.64,419.53],a7:[209.76,297.64],a8:[147.4,209.76],a9:[104.88,147.4],a10:[73.7,104.88],b0:[2834.65,4008.19],b1:[2004.09,2834.65],b2:[1417.32,2004.09],b3:[1000.63,1417.32],b4:[708.66,1000.63],b5:[498.9,708.66],b6:[354.33,498.9],b7:[249.45,354.33],b8:[175.75,249.45],b9:[124.72,175.75],b10:[87.87,124.72],c0:[2599.37,3676.54],c1:[1836.85,2599.37],c2:[1298.27,1836.85],c3:[918.43,1298.27],c4:[649.13,918.43],c5:[459.21,649.13],c6:[323.15,459.21],c7:[229.61,323.15],c8:[161.57,229.61],c9:[113.39,161.57],c10:[79.37,113.39],dl:[311.81,623.62],letter:[612,792],"government-letter":[576,756],legal:[612,1008],"junior-legal":[576,360],ledger:[1224,792],tabloid:[792,1224],"credit-card":[153,243]};switch(e){case"pt":var a=1;break;case"mm":a=72/25.4;break;case"cm":a=72/2.54;break;case"in":a=72;break;case"px":a=.75;break;case"pc":case"em":a=12;break;case"ex":a=6;break;default:throw"Invalid unit: "+e}if(o.hasOwnProperty(i))var s=o[i][1]/a,l=o[i][0]/a;else try{s=n[1],l=n[0]}catch(t){throw new Error("Invalid format: "+n)}if("p"===t||"portrait"===t){if(t="p",s<l){var h=l;l=s,s=h}}else{if("l"!==t&&"landscape"!==t)throw"Invalid orientation: "+t;t="l",l<s&&(h=l,l=s,s=h)}return{width:l,height:s,unit:e,k:a}},i.html=function(t,e){(e=e||{}).callback=e.callback||function(){},e.html2canvas=e.html2canvas||{},e.html2canvas.canvas=e.html2canvas.canvas||this.canvas,e.jsPDF=e.jsPDF||this,e.jsPDF;var n=new y(e);return e.worker?n:n.from(t).doCallback()},lt.API.addJS=function(t){return b=t,this.internal.events.subscribe("postPutResources",function(t){v=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/Names [(EmbeddedJS) "+(v+1)+" 0 R]"),this.internal.out(">>"),this.internal.out("endobj"),w=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/S /JavaScript"),this.internal.out("/JS ("+b+")"),this.internal.out(">>"),this.internal.out("endobj")}),this.internal.events.subscribe("putCatalog",function(){void 0!==v&&void 0!==w&&this.internal.out("/Names <</JavaScript "+v+" 0 R>>")}),this},(
/**
   * @license
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
x=lt.API).events.push(["postPutResources",function(){var t=this,e=/^(\d+) 0 obj$/;if(0<this.outline.root.children.length)for(var n=t.outline.render().split(/\r\n/),r=0;r<n.length;r++){var i=n[r],o=e.exec(i);if(null!=o){var a=o[1];t.internal.newObjectDeferredBegin(a,!1)}t.internal.write(i)}if(this.outline.createNamedDestinations){var s=this.internal.pages.length,l=[];for(r=0;r<s;r++){var h=t.internal.newObject();l.push(h);var u=t.internal.getPageInfo(r+1);t.internal.write("<< /D["+u.objId+" 0 R /XYZ null null null]>> endobj")}var c=t.internal.newObject();for(t.internal.write("<< /Names [ "),r=0;r<l.length;r++)t.internal.write("(page_"+(r+1)+")"+l[r]+" 0 R");t.internal.write(" ] >>","endobj"),t.internal.newObject(),t.internal.write("<< /Dests "+c+" 0 R"),t.internal.write(">>","endobj")}}]),x.events.push(["putCatalog",function(){0<this.outline.root.children.length&&(this.internal.write("/Outlines",this.outline.makeRef(this.outline.root)),this.outline.createNamedDestinations&&this.internal.write("/Names "+namesOid+" 0 R"))}]),x.events.push(["initialized",function(){var a=this;a.outline={createNamedDestinations:!1,root:{children:[]}},a.outline.add=function(t,e,n){var r={title:e,options:n,children:[]};return null==t&&(t=this.root),t.children.push(r),r},a.outline.render=function(){return this.ctx={},this.ctx.val="",this.ctx.pdf=a,this.genIds_r(this.root),this.renderRoot(this.root),this.renderItems(this.root),this.ctx.val},a.outline.genIds_r=function(t){t.id=a.internal.newObjectDeferred();for(var e=0;e<t.children.length;e++)this.genIds_r(t.children[e])},a.outline.renderRoot=function(t){this.objStart(t),this.line("/Type /Outlines"),0<t.children.length&&(this.line("/First "+this.makeRef(t.children[0])),this.line("/Last "+this.makeRef(t.children[t.children.length-1]))),this.line("/Count "+this.count_r({count:0},t)),this.objEnd()},a.outline.renderItems=function(t){this.ctx.pdf.internal.getCoordinateString;for(var e=this.ctx.pdf.internal.getVerticalCoordinateString,n=0;n<t.children.length;n++){var r=t.children[n];this.objStart(r),this.line("/Title "+this.makeString(r.title)),this.line("/Parent "+this.makeRef(t)),0<n&&this.line("/Prev "+this.makeRef(t.children[n-1])),n<t.children.length-1&&this.line("/Next "+this.makeRef(t.children[n+1])),0<r.children.length&&(this.line("/First "+this.makeRef(r.children[0])),this.line("/Last "+this.makeRef(r.children[r.children.length-1])));var i=this.count=this.count_r({count:0},r);if(0<i&&this.line("/Count "+i),r.options&&r.options.pageNumber){var o=a.internal.getPageInfo(r.options.pageNumber);this.line("/Dest ["+o.objId+" 0 R /XYZ 0 "+e(0)+" 0]")}this.objEnd()}for(n=0;n<t.children.length;n++)r=t.children[n],this.renderItems(r)},a.outline.line=function(t){this.ctx.val+=t+"\r\n"},a.outline.makeRef=function(t){return t.id+" 0 R"},a.outline.makeString=function(t){return"("+a.internal.pdfEscape(t)+")"},a.outline.objStart=function(t){this.ctx.val+="\r\n"+t.id+" 0 obj\r\n<<\r\n"},a.outline.objEnd=function(t){this.ctx.val+=">> \r\nendobj\r\n"},a.outline.count_r=function(t,e){for(var n=0;n<e.children.length;n++)t.count++,this.count_r(t,e.children[n]);return t.count}}]),
/**
   * @license
   * 
   * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
   *
   * 
   * ====================================================================
   */
I=lt.API,C=function(){var t="function"==typeof Deflater;if(!t)throw new Error("requires deflate.js for compression");return t},B=function(t,e,n,r){var i=5,o=E;switch(r){case I.image_compression.FAST:i=3,o=j;break;case I.image_compression.MEDIUM:i=6,o=M;break;case I.image_compression.SLOW:i=9,o=O}t=A(t,e,n,o);var a=new Uint8Array(N(i)),s=L(t),l=new Deflater(i),h=l.append(t),u=l.flush(),c=a.length+h.length+u.length,f=new Uint8Array(c+4);return f.set(a),f.set(h,a.length),f.set(u,a.length+h.length),f[c++]=s>>>24&255,f[c++]=s>>>16&255,f[c++]=s>>>8&255,f[c++]=255&s,I.arrayBufferToBinaryString(f)},N=function(t,e){var n=Math.LOG2E*Math.log(32768)-8<<4|8,r=n<<8;return r|=Math.min(3,(e-1&255)>>1)<<6,r|=0,[n,255&(r+=31-r%31)]},L=function(t,e){for(var n,r=1,i=0,o=t.length,a=0;0<o;){for(o-=n=e<o?e:o;i+=r+=t[a++],--n;);r%=65521,i%=65521}return(i<<16|r)>>>0},A=function(t,e,n,r){for(var i,o,a,s=t.length/e,l=new Uint8Array(t.length+s),h=T(),u=0;u<s;u++){if(a=u*e,i=t.subarray(a,a+e),r)l.set(r(i,n,o),a+u);else{for(var c=0,f=h.length,p=[];c<f;c++)p[c]=h[c](i,n,o);var d=R(p.concat());l.set(p[d],a+u)}o=i}return l},S=function(t,e,n){var r=Array.apply([],t);return r.unshift(0),r},j=function(t,e,n){var r,i=[],o=0,a=t.length;for(i[0]=1;o<a;o++)r=t[o-e]||0,i[o+1]=t[o]-r+256&255;return i},E=function(t,e,n){var r,i=[],o=0,a=t.length;for(i[0]=2;o<a;o++)r=n&&n[o]||0,i[o+1]=t[o]-r+256&255;return i},M=function(t,e,n){var r,i,o=[],a=0,s=t.length;for(o[0]=3;a<s;a++)r=t[a-e]||0,i=n&&n[a]||0,o[a+1]=t[a]+256-(r+i>>>1)&255;return o},O=function(t,e,n){var r,i,o,a,s=[],l=0,h=t.length;for(s[0]=4;l<h;l++)r=t[l-e]||0,i=n&&n[l]||0,o=n&&n[l-e]||0,a=q(r,i,o),s[l+1]=t[l]-a+256&255;return s},q=function(t,e,n){var r=t+e-n,i=Math.abs(r-t),o=Math.abs(r-e),a=Math.abs(r-n);return i<=o&&i<=a?t:o<=a?e:n},T=function(){return[S,j,E,M,O]},R=function(t){for(var e,n,r,i=0,o=t.length;i<o;)((e=D(t[i].slice(1)))<n||!n)&&(n=e,r=i),i++;return r},D=function(t){for(var e=0,n=t.length,r=0;e<n;)r+=Math.abs(t[e++]);return r},I.processPNG=function(t,e,n,r,i){var o,a,s,l,h,u,c=this.color_spaces.DEVICE_RGB,f=this.decode.FLATE_DECODE,p=8;if(this.isArrayBuffer(t)&&(t=new Uint8Array(t)),this.isArrayBufferView(t)){if("function"!=typeof PNG||"function"!=typeof kt)throw new Error("PNG support requires png.js and zlib.js");if(t=(o=new PNG(t)).imgData,p=o.bits,c=o.colorSpace,l=o.colors,-1!==[4,6].indexOf(o.colorType)){if(8===o.bits)for(var d,g=(_=32==o.pixelBitlength?new Uint32Array(o.decodePixels().buffer):16==o.pixelBitlength?new Uint16Array(o.decodePixels().buffer):new Uint8Array(o.decodePixels().buffer)).length,m=new Uint8Array(g*o.colors),y=new Uint8Array(g),v=o.pixelBitlength-o.bits,w=0,b=0;w<g;w++){for(x=_[w],d=0;d<v;)m[b++]=x>>>d&255,d+=o.bits;y[w]=x>>>d&255}if(16===o.bits){g=(_=new Uint32Array(o.decodePixels().buffer)).length,m=new Uint8Array(g*(32/o.pixelBitlength)*o.colors),y=new Uint8Array(g*(32/o.pixelBitlength));for(var x,N=1<o.colors,L=b=w=0;w<g;)x=_[w++],m[b++]=x>>>0&255,N&&(m[b++]=x>>>16&255,x=_[w++],m[b++]=x>>>0&255),y[L++]=x>>>16&255;p=8}r!==I.image_compression.NONE&&C()?(t=B(m,o.width*o.colors,o.colors,r),u=B(y,o.width,1,r)):(t=m,u=y,f=null)}if(3===o.colorType&&(c=this.color_spaces.INDEXED,h=o.palette,o.transparency.indexed)){var A=o.transparency.indexed,S=0;for(w=0,g=A.length;w<g;++w)S+=A[w];if((S/=255)==g-1&&-1!==A.indexOf(0))s=[A.indexOf(0)];else if(S!==g){var _=o.decodePixels();for(y=new Uint8Array(_.length),w=0,g=_.length;w<g;w++)y[w]=A[_[w]];u=B(y,o.width,1)}}var F=function(t){var e;switch(t){case I.image_compression.FAST:e=11;break;case I.image_compression.MEDIUM:e=13;break;case I.image_compression.SLOW:e=14;break;default:e=12}return e}(r);return a=f===this.decode.FLATE_DECODE?"/Predictor "+F+" /Colors "+l+" /BitsPerComponent "+p+" /Columns "+o.width:"/Colors "+l+" /BitsPerComponent "+p+" /Columns "+o.width,(this.isArrayBuffer(t)||this.isArrayBufferView(t))&&(t=this.arrayBufferToBinaryString(t)),(u&&this.isArrayBuffer(u)||this.isArrayBufferView(u))&&(u=this.arrayBufferToBinaryString(u)),this.createImageInfo(t,o.width,o.height,c,p,f,e,n,a,s,h,u,F)}throw new Error("Unsupported PNG image data, try using JPEG instead.")},(
/**
   * @license
   * Copyright (c) 2017 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
U=lt.API).processGIF89A=function(t,e,n,r,i){var o=new At(t),a=o.width,s=o.height,l=[];o.decodeAndBlitFrameRGBA(0,l);var h={data:l,width:a,height:s},u=new _t(100).encode(h,100);return U.processJPEG.call(this,u,e,n,r)},U.processGIF87A=U.processGIF89A,(
/**
   * Copyright (c) 2018 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
z=lt.API).processBMP=function(t,e,n,r,i){var o=new Ft(t,!1),a=o.width,s=o.height,l={data:o.getData(),width:a,height:s},h=new _t(100).encode(l,100);return z.processJPEG.call(this,h,e,n,r)},lt.API.setLanguage=function(t){return void 0===this.internal.languageSettings&&(this.internal.languageSettings={},this.internal.languageSettings.isSubscribed=!1),void 0!=={af:"Afrikaans",sq:"Albanian",ar:"Arabic (Standard)","ar-DZ":"Arabic (Algeria)","ar-BH":"Arabic (Bahrain)","ar-EG":"Arabic (Egypt)","ar-IQ":"Arabic (Iraq)","ar-JO":"Arabic (Jordan)","ar-KW":"Arabic (Kuwait)","ar-LB":"Arabic (Lebanon)","ar-LY":"Arabic (Libya)","ar-MA":"Arabic (Morocco)","ar-OM":"Arabic (Oman)","ar-QA":"Arabic (Qatar)","ar-SA":"Arabic (Saudi Arabia)","ar-SY":"Arabic (Syria)","ar-TN":"Arabic (Tunisia)","ar-AE":"Arabic (U.A.E.)","ar-YE":"Arabic (Yemen)",an:"Aragonese",hy:"Armenian",as:"Assamese",ast:"Asturian",az:"Azerbaijani",eu:"Basque",be:"Belarusian",bn:"Bengali",bs:"Bosnian",br:"Breton",bg:"Bulgarian",my:"Burmese",ca:"Catalan",ch:"Chamorro",ce:"Chechen",zh:"Chinese","zh-HK":"Chinese (Hong Kong)","zh-CN":"Chinese (PRC)","zh-SG":"Chinese (Singapore)","zh-TW":"Chinese (Taiwan)",cv:"Chuvash",co:"Corsican",cr:"Cree",hr:"Croatian",cs:"Czech",da:"Danish",nl:"Dutch (Standard)","nl-BE":"Dutch (Belgian)",en:"English","en-AU":"English (Australia)","en-BZ":"English (Belize)","en-CA":"English (Canada)","en-IE":"English (Ireland)","en-JM":"English (Jamaica)","en-NZ":"English (New Zealand)","en-PH":"English (Philippines)","en-ZA":"English (South Africa)","en-TT":"English (Trinidad & Tobago)","en-GB":"English (United Kingdom)","en-US":"English (United States)","en-ZW":"English (Zimbabwe)",eo:"Esperanto",et:"Estonian",fo:"Faeroese",fj:"Fijian",fi:"Finnish",fr:"French (Standard)","fr-BE":"French (Belgium)","fr-CA":"French (Canada)","fr-FR":"French (France)","fr-LU":"French (Luxembourg)","fr-MC":"French (Monaco)","fr-CH":"French (Switzerland)",fy:"Frisian",fur:"Friulian",gd:"Gaelic (Scots)","gd-IE":"Gaelic (Irish)",gl:"Galacian",ka:"Georgian",de:"German (Standard)","de-AT":"German (Austria)","de-DE":"German (Germany)","de-LI":"German (Liechtenstein)","de-LU":"German (Luxembourg)","de-CH":"German (Switzerland)",el:"Greek",gu:"Gujurati",ht:"Haitian",he:"Hebrew",hi:"Hindi",hu:"Hungarian",is:"Icelandic",id:"Indonesian",iu:"Inuktitut",ga:"Irish",it:"Italian (Standard)","it-CH":"Italian (Switzerland)",ja:"Japanese",kn:"Kannada",ks:"Kashmiri",kk:"Kazakh",km:"Khmer",ky:"Kirghiz",tlh:"Klingon",ko:"Korean","ko-KP":"Korean (North Korea)","ko-KR":"Korean (South Korea)",la:"Latin",lv:"Latvian",lt:"Lithuanian",lb:"Luxembourgish",mk:"FYRO Macedonian",ms:"Malay",ml:"Malayalam",mt:"Maltese",mi:"Maori",mr:"Marathi",mo:"Moldavian",nv:"Navajo",ng:"Ndonga",ne:"Nepali",no:"Norwegian",nb:"Norwegian (Bokmal)",nn:"Norwegian (Nynorsk)",oc:"Occitan",or:"Oriya",om:"Oromo",fa:"Persian","fa-IR":"Persian/Iran",pl:"Polish",pt:"Portuguese","pt-BR":"Portuguese (Brazil)",pa:"Punjabi","pa-IN":"Punjabi (India)","pa-PK":"Punjabi (Pakistan)",qu:"Quechua",rm:"Rhaeto-Romanic",ro:"Romanian","ro-MO":"Romanian (Moldavia)",ru:"Russian","ru-MO":"Russian (Moldavia)",sz:"Sami (Lappish)",sg:"Sango",sa:"Sanskrit",sc:"Sardinian",sd:"Sindhi",si:"Singhalese",sr:"Serbian",sk:"Slovak",sl:"Slovenian",so:"Somani",sb:"Sorbian",es:"Spanish","es-AR":"Spanish (Argentina)","es-BO":"Spanish (Bolivia)","es-CL":"Spanish (Chile)","es-CO":"Spanish (Colombia)","es-CR":"Spanish (Costa Rica)","es-DO":"Spanish (Dominican Republic)","es-EC":"Spanish (Ecuador)","es-SV":"Spanish (El Salvador)","es-GT":"Spanish (Guatemala)","es-HN":"Spanish (Honduras)","es-MX":"Spanish (Mexico)","es-NI":"Spanish (Nicaragua)","es-PA":"Spanish (Panama)","es-PY":"Spanish (Paraguay)","es-PE":"Spanish (Peru)","es-PR":"Spanish (Puerto Rico)","es-ES":"Spanish (Spain)","es-UY":"Spanish (Uruguay)","es-VE":"Spanish (Venezuela)",sx:"Sutu",sw:"Swahili",sv:"Swedish","sv-FI":"Swedish (Finland)","sv-SV":"Swedish (Sweden)",ta:"Tamil",tt:"Tatar",te:"Teluga",th:"Thai",tig:"Tigre",ts:"Tsonga",tn:"Tswana",tr:"Turkish",tk:"Turkmen",uk:"Ukrainian",hsb:"Upper Sorbian",ur:"Urdu",ve:"Venda",vi:"Vietnamese",vo:"Volapuk",wa:"Walloon",cy:"Welsh",xh:"Xhosa",ji:"Yiddish",zu:"Zulu"}[t]&&(this.internal.languageSettings.languageCode=t,!1===this.internal.languageSettings.isSubscribed&&(this.internal.events.subscribe("putCatalog",function(){this.internal.write("/Lang ("+this.internal.languageSettings.languageCode+")")}),this.internal.languageSettings.isSubscribed=!0)),this},
/** @license
   * MIT license.
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   *               2014 Diego Casorran, https://github.com/diegocr
   *
   * 
   * ====================================================================
   */
H=lt.API,W=H.getCharWidthsArray=function(t,e){var n,r,i,o=(e=e||{}).font||this.internal.getFont(),a=e.fontSize||this.internal.getFontSize(),s=e.charSpace||this.internal.getCharSpace(),l=e.widths?e.widths:o.metadata.Unicode.widths,h=l.fof?l.fof:1,u=e.kerning?e.kerning:o.metadata.Unicode.kerning,c=u.fof?u.fof:1,f=0,p=l[0]||h,d=[];for(n=0,r=t.length;n<r;n++)i=t.charCodeAt(n),"function"==typeof o.metadata.widthOfString?d.push((o.metadata.widthOfGlyph(o.metadata.characterToGlyph(i))+s*(1e3/a)||0)/1e3):d.push((l[i]||p)/h+(u[i]&&u[i][f]||0)/c),f=i;return d},V=H.getArraySum=function(t){for(var e=t.length,n=0;e;)n+=t[--e];return n},G=H.getStringUnitWidth=function(t,e){var n=(e=e||{}).fontSize||this.internal.getFontSize(),r=e.font||this.internal.getFont(),i=e.charSpace||this.internal.getCharSpace();return"function"==typeof r.metadata.widthOfString?r.metadata.widthOfString(t,n,i)/n:V(W.apply(this,arguments))},Y=function(t,e,n,r){for(var i=[],o=0,a=t.length,s=0;o!==a&&s+e[o]<n;)s+=e[o],o++;i.push(t.slice(0,o));var l=o;for(s=0;o!==a;)s+e[o]>r&&(i.push(t.slice(l,o)),s=0,l=o),s+=e[o],o++;return l!==o&&i.push(t.slice(l,o)),i},J=function(t,e,n){n||(n={});var r,i,o,a,s,l,h=[],u=[h],c=n.textIndent||0,f=0,p=0,d=t.split(" "),g=W.apply(this,[" ",n])[0];if(l=-1===n.lineIndent?d[0].length+2:n.lineIndent||0){var m=Array(l).join(" "),y=[];d.map(function(t){1<(t=t.split(/\s*\n/)).length?y=y.concat(t.map(function(t,e){return(e&&t.length?"\n":"")+t})):y.push(t[0])}),d=y,l=G.apply(this,[m,n])}for(o=0,a=d.length;o<a;o++){var v=0;if(r=d[o],l&&"\n"==r[0]&&(r=r.substr(1),v=1),i=W.apply(this,[r,n]),e<c+f+(p=V(i))||v){if(e<p){for(s=Y.apply(this,[r,i,e-(c+f),e]),h.push(s.shift()),h=[s.pop()];s.length;)u.push([s.shift()]);p=V(i.slice(r.length-(h[0]?h[0].length:0)))}else h=[r];u.push(h),c=p+l,f=g}else h.push(r),c+=f+p,f=g}if(l)var w=function(t,e){return(e?m:"")+t.join(" ")};else w=function(t){return t.join(" ")};return u.map(w)},H.splitTextToSize=function(t,e,n){var r,i=(n=n||{}).fontSize||this.internal.getFontSize(),o=function(t){var e={0:1},n={};if(t.widths&&t.kerning)return{widths:t.widths,kerning:t.kerning};var r=this.internal.getFont(t.fontName,t.fontStyle),i="Unicode";return r.metadata[i]?{widths:r.metadata[i].widths||e,kerning:r.metadata[i].kerning||n}:{font:r.metadata,fontSize:this.internal.getFontSize(),charSpace:this.internal.getCharSpace()}}.call(this,n);r=Array.isArray(t)?t:t.split(/\r?\n/);var a=1*this.internal.scaleFactor*e/i;o.textIndent=n.textIndent?1*n.textIndent*this.internal.scaleFactor/i:0,o.lineIndent=n.lineIndent;var s,l,h=[];for(s=0,l=r.length;s<l;s++)h=h.concat(J.apply(this,[r[s],a,o]));return h},
/** @license
   jsPDF standard_fonts_metrics plugin
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   * MIT license.
   * 
   * ====================================================================
   */
X=lt.API,Z={codePages:["WinAnsiEncoding"],WinAnsiEncoding:(K=function(t){for(var e="klmnopqrstuvwxyz",n={},r=0;r<e.length;r++)n[e[r]]="0123456789abcdef"[r];var i,o,a,s,l,h={},u=1,c=h,f=[],p="",d="",g=t.length-1;for(r=1;r!=g;)l=t[r],r+=1,"'"==l?o=o?(s=o.join(""),i):[]:o?o.push(l):"{"==l?(f.push([c,s]),c={},s=i):"}"==l?((a=f.pop())[0][a[1]]=c,s=i,c=a[0]):"-"==l?u=-1:s===i?n.hasOwnProperty(l)?(p+=n[l],s=parseInt(p,16)*u,u=1,p=""):p+=l:n.hasOwnProperty(l)?(d+=n[l],c[s]=parseInt(d,16)*u,u=1,s=i,d=""):d+=l;return h})("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")},Q={Unicode:{Courier:Z,"Courier-Bold":Z,"Courier-BoldOblique":Z,"Courier-Oblique":Z,Helvetica:Z,"Helvetica-Bold":Z,"Helvetica-BoldOblique":Z,"Helvetica-Oblique":Z,"Times-Roman":Z,"Times-Bold":Z,"Times-BoldItalic":Z,"Times-Italic":Z}},$={Unicode:{"Courier-Oblique":K("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-BoldItalic":K("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),"Helvetica-Bold":K("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),Courier:K("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-BoldOblique":K("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Bold":K("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),Symbol:K("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"),Helvetica:K("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),"Helvetica-BoldOblique":K("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),ZapfDingbats:K("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-Bold":K("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Italic":K("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),"Times-Roman":K("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),"Helvetica-Oblique":K("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")}},X.events.push(["addFont",function(t){var e,n,r,i=t.font,o="Unicode";(e=$[o][i.postScriptName])&&((n=i.metadata[o]?i.metadata[o]:i.metadata[o]={}).widths=e.widths,n.kerning=e.kerning),(r=Q[o][i.postScriptName])&&((n=i.metadata[o]?i.metadata[o]:i.metadata[o]={}).encoding=r).codePages&&r.codePages.length&&(i.encoding=r.codePages[0])}]),
/**
   * @license
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
tt=lt,"undefined"!=typeof self&&self||"undefined"!=typeof global&&global||"undefined"!=typeof window&&window||Function("return this")(),tt.API.events.push(["addFont",function(t){var e=t.font,n=t.instance;if(void 0!==n&&n.existsFileInVFS(e.postScriptName)){var r=n.getFileFromVFS(e.postScriptName);if("string"!=typeof r)throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('"+e.postScriptName+"').");e.metadata=tt.API.TTFFont.open(e.postScriptName,e.fontName,r,e.encoding),e.metadata.Unicode=e.metadata.Unicode||{encoding:{},kerning:{},widths:[]},e.metadata.glyIdsUsed=[0]}else if(!1===e.isStandardFont)throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('"+e.postScriptName+"').")}]),(
/** @license
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   * 
   * 
   * ====================================================================
   */
et=lt.API).addSvg=function(t,e,n,r,i){if(void 0===e||void 0===n)throw new Error("addSVG needs values for 'x' and 'y'");function o(t){for(var e=parseFloat(t[1]),n=parseFloat(t[2]),r=[],i=3,o=t.length;i<o;)"c"===t[i]?(r.push([parseFloat(t[i+1]),parseFloat(t[i+2]),parseFloat(t[i+3]),parseFloat(t[i+4]),parseFloat(t[i+5]),parseFloat(t[i+6])]),i+=7):"l"===t[i]?(r.push([parseFloat(t[i+1]),parseFloat(t[i+2])]),i+=3):i+=1;return[e,n,r]}var a,s,l,h,u,c,f,p,d=(h=document,p=h.createElement("iframe"),u=".jsPDF_sillysvg_iframe {display:none;position:absolute;}",(f=(c=h).createElement("style")).type="text/css",f.styleSheet?f.styleSheet.cssText=u:f.appendChild(c.createTextNode(u)),c.getElementsByTagName("head")[0].appendChild(f),p.name="childframe",p.setAttribute("width",0),p.setAttribute("height",0),p.setAttribute("frameborder","0"),p.setAttribute("scrolling","no"),p.setAttribute("seamless","seamless"),p.setAttribute("class","jsPDF_sillysvg_iframe"),h.body.appendChild(p),p),g=(a=t,(l=((s=d).contentWindow||s.contentDocument).document).write(a),l.close(),l.getElementsByTagName("svg")[0]),m=[1,1],y=parseFloat(g.getAttribute("width")),v=parseFloat(g.getAttribute("height"));y&&v&&(r&&i?m=[r/y,i/v]:r?m=[r/y,r/y]:i&&(m=[i/v,i/v]));var w,b,x,N,L=g.childNodes;for(w=0,b=L.length;w<b;w++)(x=L[w]).tagName&&"PATH"===x.tagName.toUpperCase()&&((N=o(x.getAttribute("d").split(" ")))[0]=N[0]*m[0]+e,N[1]=N[1]*m[1]+n,this.lines.call(this,N[2],N[0],N[1],m));return this},et.addSVG=et.addSvg,et.addSvgAsImage=function(t,e,n,r,i,o,a,s){if(isNaN(e)||isNaN(n))throw console.error("jsPDF.addSvgAsImage: Invalid coordinates",arguments),new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");if(isNaN(r)||isNaN(i))throw console.error("jsPDF.addSvgAsImage: Invalid measurements",arguments),new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");var l=document.createElement("canvas");l.width=r,l.height=i;var h=l.getContext("2d");return h.fillStyle="#fff",h.fillRect(0,0,l.width,l.height),canvg(l,t,{ignoreMouse:!0,ignoreAnimation:!0,ignoreDimensions:!0,ignoreClear:!0}),this.addImage(l.toDataURL("image/jpeg",1),e,n,r,i,a,s),this},lt.API.putTotalPages=function(t){var e,n=0;n=parseInt(this.internal.getFont().id.substr(1),10)<15?(e=new RegExp(t,"g"),this.internal.getNumberOfPages()):(e=new RegExp(this.pdfEscape16(t,this.internal.getFont()),"g"),this.pdfEscape16(this.internal.getNumberOfPages()+"",this.internal.getFont()));for(var r=1;r<=this.internal.getNumberOfPages();r++)for(var i=0;i<this.internal.pages[r].length;i++)this.internal.pages[r][i]=this.internal.pages[r][i].replace(e,n);return this},lt.API.viewerPreferences=function(t,e){var n;t=t||{},e=e||!1;var r,i,o={HideToolbar:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},HideMenubar:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},HideWindowUI:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},FitWindow:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},CenterWindow:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},DisplayDocTitle:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.4},NonFullScreenPageMode:{defaultValue:"UseNone",value:"UseNone",type:"name",explicitSet:!1,valueSet:["UseNone","UseOutlines","UseThumbs","UseOC"],pdfVersion:1.3},Direction:{defaultValue:"L2R",value:"L2R",type:"name",explicitSet:!1,valueSet:["L2R","R2L"],pdfVersion:1.3},ViewArea:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},ViewClip:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintArea:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintClip:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintScaling:{defaultValue:"AppDefault",value:"AppDefault",type:"name",explicitSet:!1,valueSet:["AppDefault","None"],pdfVersion:1.6},Duplex:{defaultValue:"",value:"none",type:"name",explicitSet:!1,valueSet:["Simplex","DuplexFlipShortEdge","DuplexFlipLongEdge","none"],pdfVersion:1.7},PickTrayByPDFSize:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.7},PrintPageRange:{defaultValue:"",value:"",type:"array",explicitSet:!1,valueSet:null,pdfVersion:1.7},NumCopies:{defaultValue:1,value:1,type:"integer",explicitSet:!1,valueSet:null,pdfVersion:1.7}},a=Object.keys(o),s=[],l=0,h=0,u=0,c=!0;function f(t,e){var n,r=!1;for(n=0;n<t.length;n+=1)t[n]===e&&(r=!0);return r}if(void 0===this.internal.viewerpreferences&&(this.internal.viewerpreferences={},this.internal.viewerpreferences.configuration=JSON.parse(JSON.stringify(o)),this.internal.viewerpreferences.isSubscribed=!1),n=this.internal.viewerpreferences.configuration,"reset"===t||!0===e){var p=a.length;for(u=0;u<p;u+=1)n[a[u]].value=n[a[u]].defaultValue,n[a[u]].explicitSet=!1}if("object"===se(t))for(r in t)if(i=t[r],f(a,r)&&void 0!==i){if("boolean"===n[r].type&&"boolean"==typeof i)n[r].value=i;else if("name"===n[r].type&&f(n[r].valueSet,i))n[r].value=i;else if("integer"===n[r].type&&Number.isInteger(i))n[r].value=i;else if("array"===n[r].type){for(l=0;l<i.length;l+=1)if(c=!0,1===i[l].length&&"number"==typeof i[l][0])s.push(String(i[l]-1));else if(1<i[l].length){for(h=0;h<i[l].length;h+=1)"number"!=typeof i[l][h]&&(c=!1);!0===c&&s.push([i[l][0]-1,i[l][1]-1].join(" "))}n[r].value="["+s.join(" ")+"]"}else n[r].value=n[r].defaultValue;n[r].explicitSet=!0}return!1===this.internal.viewerpreferences.isSubscribed&&(this.internal.events.subscribe("putCatalog",function(){var t,e=[];for(t in n)!0===n[t].explicitSet&&("name"===n[t].type?e.push("/"+t+" /"+n[t].value):e.push("/"+t+" "+n[t].value));0!==e.length&&this.internal.write("/ViewerPreferences\n<<\n"+e.join("\n")+"\n>>")}),this.internal.viewerpreferences.isSubscribed=!0),this.internal.viewerpreferences.configuration=n,this},
/** ==================================================================== 
   * jsPDF XMP metadata plugin
   * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
   * 
   * 
   * ====================================================================
   */
nt=lt.API,ot=it=rt="",nt.addMetadata=function(t,e){return it=e||"http://jspdf.default.namespaceuri/",rt=t,this.internal.events.subscribe("postPutResources",function(){if(rt){var t='<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="'+it+'"><jspdf:metadata>',e=unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')),n=unescape(encodeURIComponent(t)),r=unescape(encodeURIComponent(rt)),i=unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")),o=unescape(encodeURIComponent("</x:xmpmeta>")),a=n.length+r.length+i.length+e.length+o.length;ot=this.internal.newObject(),this.internal.write("<< /Type /Metadata /Subtype /XML /Length "+a+" >>"),this.internal.write("stream"),this.internal.write(e+n+r+i+o),this.internal.write("endstream"),this.internal.write("endobj")}else ot=""}),this.internal.events.subscribe("putCatalog",function(){ot&&this.internal.write("/Metadata "+ot+" 0 R")}),this},function(f,t){var e=f.API;var m=e.pdfEscape16=function(t,e){for(var n,r=e.metadata.Unicode.widths,i=["","0","00","000","0000"],o=[""],a=0,s=t.length;a<s;++a){if(n=e.metadata.characterToGlyph(t.charCodeAt(a)),e.metadata.glyIdsUsed.push(n),e.metadata.toUnicode[n]=t.charCodeAt(a),-1==r.indexOf(n)&&(r.push(n),r.push([parseInt(e.metadata.widthOfGlyph(n),10)])),"0"==n)return o.join("");n=n.toString(16),o.push(i[4-n.length],n)}return o.join("")},p=function(t){var e,n,r,i,o,a,s;for(o="/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange",r=[],a=0,s=(n=Object.keys(t).sort(function(t,e){return t-e})).length;a<s;a++)e=n[a],100<=r.length&&(o+="\n"+r.length+" beginbfchar\n"+r.join("\n")+"\nendbfchar",r=[]),i=("0000"+t[e].toString(16)).slice(-4),e=("0000"+(+e).toString(16)).slice(-4),r.push("<"+e+"><"+i+">");return r.length&&(o+="\n"+r.length+" beginbfchar\n"+r.join("\n")+"\nendbfchar\n"),o+="endcmap\nCMapName currentdict /CMap defineresource pop\nend\nend"};e.events.push(["putFont",function(t){!function(t,e,n,r){if(t.metadata instanceof f.API.TTFFont&&"Identity-H"===t.encoding){for(var i=t.metadata.Unicode.widths,o=t.metadata.subset.encode(t.metadata.glyIdsUsed,1),a="",s=0;s<o.length;s++)a+=String.fromCharCode(o[s]);var l=n();r({data:a,addLength1:!0}),e("endobj");var h=n();r({data:p(t.metadata.toUnicode),addLength1:!0}),e("endobj");var u=n();e("<<"),e("/Type /FontDescriptor"),e("/FontName /"+t.fontName),e("/FontFile2 "+l+" 0 R"),e("/FontBBox "+f.API.PDFObject.convert(t.metadata.bbox)),e("/Flags "+t.metadata.flags),e("/StemV "+t.metadata.stemV),e("/ItalicAngle "+t.metadata.italicAngle),e("/Ascent "+t.metadata.ascender),e("/Descent "+t.metadata.decender),e("/CapHeight "+t.metadata.capHeight),e(">>"),e("endobj");var c=n();e("<<"),e("/Type /Font"),e("/BaseFont /"+t.fontName),e("/FontDescriptor "+u+" 0 R"),e("/W "+f.API.PDFObject.convert(i)),e("/CIDToGIDMap /Identity"),e("/DW 1000"),e("/Subtype /CIDFontType2"),e("/CIDSystemInfo"),e("<<"),e("/Supplement 0"),e("/Registry (Adobe)"),e("/Ordering ("+t.encoding+")"),e(">>"),e(">>"),e("endobj"),t.objectNumber=n(),e("<<"),e("/Type /Font"),e("/Subtype /Type0"),e("/ToUnicode "+h+" 0 R"),e("/BaseFont /"+t.fontName),e("/Encoding /"+t.encoding),e("/DescendantFonts ["+c+" 0 R]"),e(">>"),e("endobj"),t.isAlreadyPutted=!0}}(t.font,t.out,t.newObject,t.putStream)}]);e.events.push(["putFont",function(t){!function(t,e,n,r){if(t.metadata instanceof f.API.TTFFont&&"WinAnsiEncoding"===t.encoding){t.metadata.Unicode.widths;for(var i=t.metadata.rawData,o="",a=0;a<i.length;a++)o+=String.fromCharCode(i[a]);var s=n();r({data:o,addLength1:!0}),e("endobj");var l=n();r({data:p(t.metadata.toUnicode),addLength1:!0}),e("endobj");var h=n();for(e("<<"),e("/Descent "+t.metadata.decender),e("/CapHeight "+t.metadata.capHeight),e("/StemV "+t.metadata.stemV),e("/Type /FontDescriptor"),e("/FontFile2 "+s+" 0 R"),e("/Flags 96"),e("/FontBBox "+f.API.PDFObject.convert(t.metadata.bbox)),e("/FontName /"+t.fontName),e("/ItalicAngle "+t.metadata.italicAngle),e("/Ascent "+t.metadata.ascender),e(">>"),e("endobj"),t.objectNumber=n(),a=0;a<t.metadata.hmtx.widths.length;a++)t.metadata.hmtx.widths[a]=parseInt(t.metadata.hmtx.widths[a]*(1e3/t.metadata.head.unitsPerEm));e("<</Subtype/TrueType/Type/Font/ToUnicode "+l+" 0 R/BaseFont/"+t.fontName+"/FontDescriptor "+h+" 0 R/Encoding/"+t.encoding+" /FirstChar 29 /LastChar 255 /Widths "+f.API.PDFObject.convert(t.metadata.hmtx.widths)+">>"),e("endobj"),t.isAlreadyPutted=!0}}(t.font,t.out,t.newObject,t.putStream)}]);var h=function(t){var e,n,r=t.text||"",i=t.x,o=t.y,a=t.options||{},s=t.mutex||{},l=s.pdfEscape,h=s.activeFontKey,u=s.fonts,c=(s.activeFontSize,""),f=0,p="",d=u[n=h].encoding;if("Identity-H"!==u[n].encoding)return{text:r,x:i,y:o,options:a,mutex:s};for(p=r,n=h,"[object Array]"===Object.prototype.toString.call(r)&&(p=r[0]),f=0;f<p.length;f+=1)u[n].metadata.hasOwnProperty("cmap")&&(e=u[n].metadata.cmap.unicode.codeMap[p[f].charCodeAt(0)]),e?c+=p[f]:p[f].charCodeAt(0)<256&&u[n].metadata.hasOwnProperty("Unicode")?c+=p[f]:c+="";var g="";return parseInt(n.slice(1))<14||"WinAnsiEncoding"===d?g=function(t){for(var e="",n=0;n<t.length;n++)e+=""+t.charCodeAt(n).toString(16);return e}(l(c,n)):"Identity-H"===d&&(g=m(c,u[n])),s.isHex=!0,{text:g,x:i,y:o,options:a,mutex:s}};e.events.push(["postProcessText",function(t){var e=t.text||"",n=t.x,r=t.y,i=t.options,o=t.mutex,a=(i.lang,[]),s={text:e,x:n,y:r,options:i,mutex:o};if("[object Array]"===Object.prototype.toString.call(e)){var l=0;for(l=0;l<e.length;l+=1)"[object Array]"===Object.prototype.toString.call(e[l])&&3===e[l].length?a.push([h(Object.assign({},s,{text:e[l][0]})).text,e[l][1],e[l][2]]):a.push(h(Object.assign({},s,{text:e[l]})).text);t.text=a}else t.text=h(Object.assign({},s,{text:e})).text}])}(lt,"undefined"!=typeof self&&self||"undefined"!=typeof global&&global||"undefined"!=typeof window&&window||Function("return this")()),at=lt.API,st=function(t){return void 0!==t&&(void 0===t.vFS&&(t.vFS={}),!0)},at.existsFileInVFS=function(t){return!!st(this.internal)&&void 0!==this.internal.vFS[t]},at.addFileToVFS=function(t,e){return st(this.internal),this.internal.vFS[t]=e,this},at.getFileFromVFS=function(t){return st(this.internal),void 0!==this.internal.vFS[t]?this.internal.vFS[t]:null},lt.API.addHTML=function(t,d,g,s,m){if("undefined"==typeof html2canvas&&"undefined"==typeof rasterizeHTML)throw new Error("You need either https://github.com/niklasvh/html2canvas or https://github.com/cburgmer/rasterizeHTML.js");"number"!=typeof d&&(s=d,m=g),"function"==typeof s&&(m=s,s=null),"function"!=typeof m&&(m=function(){});var e=this.internal,y=e.scaleFactor,v=e.pageSize.getWidth(),w=e.pageSize.getHeight();if((s=s||{}).onrendered=function(l){d=parseInt(d)||0,g=parseInt(g)||0;var t=s.dim||{},h=Object.assign({top:0,right:0,bottom:0,left:0,useFor:"content"},s.margin),e=t.h||Math.min(w,l.height/y),u=t.w||Math.min(v,l.width/y)-d,c=s.format||"JPEG",f=s.imageCompression||"SLOW";if(l.height>w-h.top-h.bottom&&s.pagesplit){var p=function(t,e,n,r,i){var o=document.createElement("canvas");o.height=i,o.width=r;var a=o.getContext("2d");return a.mozImageSmoothingEnabled=!1,a.webkitImageSmoothingEnabled=!1,a.msImageSmoothingEnabled=!1,a.imageSmoothingEnabled=!1,a.fillStyle=s.backgroundColor||"#ffffff",a.fillRect(0,0,r,i),a.drawImage(t,e,n,r,i,0,0,r,i),o},n=function(){for(var t,e,n=0,r=0,i={},o=!1;;){var a;if(r=0,i.top=0!==n?h.top:g,i.left=0!==n?h.left:d,o=(v-h.left-h.right)*y<l.width,"content"===h.useFor?0===n?(t=Math.min((v-h.left)*y,l.width),e=Math.min((w-h.top)*y,l.height-n)):(t=Math.min(v*y,l.width),e=Math.min(w*y,l.height-n),i.top=0):(t=Math.min((v-h.left-h.right)*y,l.width),e=Math.min((w-h.bottom-h.top)*y,l.height-n)),o)for(;;){"content"===h.useFor&&(0===r?t=Math.min((v-h.left)*y,l.width):(t=Math.min(v*y,l.width-r),i.left=0));var s=[a=p(l,r,n,t,e),i.left,i.top,a.width/y,a.height/y,c,null,f];if(this.addImage.apply(this,s),(r+=t)>=l.width)break;this.addPage()}else s=[a=p(l,0,n,t,e),i.left,i.top,a.width/y,a.height/y,c,null,f],this.addImage.apply(this,s);if((n+=e)>=l.height)break;this.addPage()}m(u,n,null,s)}.bind(this);if("CANVAS"===l.nodeName){var r=new Image;r.onload=n,r.src=l.toDataURL("image/png"),l=r}else n()}else{var i=Math.random().toString(35),o=[l,d,g,u,e,c,i,f];this.addImage.apply(this,o),m(u,e,i,o)}}.bind(this),"undefined"!=typeof html2canvas&&!s.rstz)return html2canvas(t,s);if("undefined"==typeof rasterizeHTML)return null;var n="drawDocument";return"string"==typeof t&&(n=/^http/.test(t)?"drawURL":"drawHTML"),s.width=s.width||v*y,rasterizeHTML[n](t,void 0,s).then(function(t){s.onrendered(t.image)},function(t){m(null,t)})},
/**
   * jsPDF fromHTML plugin. BETA stage. API subject to change. Needs browser
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 Daniel Husar, https://github.com/danielhusar
   *               2014 Wolfgang Gassler, https://github.com/woolfg
   *               2014 Steven Spungin, https://github.com/flamenco
   *
   * @license
   * 
   * ====================================================================
   */
function(t){var P,k,i,a,s,l,h,u,I,w,f,c,p,n,C,B,d,g,m,j;P=function(){return function(t){return e.prototype=t,new e};function e(){}}(),w=function(t){var e,n,r,i,o,a,s;for(n=0,r=t.length,e=void 0,a=i=!1;!i&&n!==r;)(e=t[n]=t[n].trimLeft())&&(i=!0),n++;for(n=r-1;r&&!a&&-1!==n;)(e=t[n]=t[n].trimRight())&&(a=!0),n--;for(o=/\s+$/g,s=!0,n=0;n!==r;)"\u2028"!=t[n]&&(e=t[n].replace(/\s+/g," "),s&&(e=e.trimLeft()),e&&(s=o.test(e)),t[n]=e),n++;return t},c=function(t){var e,n,r;for(e=void 0,n=(r=t.split(",")).shift();!e&&n;)e=i[n.trim().toLowerCase()],n=r.shift();return e},p=function(t){var e;return-1<(t="auto"===t?"0px":t).indexOf("em")&&!isNaN(Number(t.replace("em","")))&&(t=18.719*Number(t.replace("em",""))+"px"),-1<t.indexOf("pt")&&!isNaN(Number(t.replace("pt","")))&&(t=1.333*Number(t.replace("pt",""))+"px"),void 0,16,(e=n[t])?e:void 0!==(e={"xx-small":9,"x-small":11,small:13,medium:16,large:19,"x-large":23,"xx-large":28,auto:0}[t])?n[t]=e/16:(e=parseFloat(t))?n[t]=e/16:(e=t.match(/([\d\.]+)(px)/),Array.isArray(e)&&3===e.length?n[t]=parseFloat(e[1])/16:n[t]=1)},I=function(t){var e,n,r,i,o;return o=t,i=document.defaultView&&document.defaultView.getComputedStyle?document.defaultView.getComputedStyle(o,null):o.currentStyle?o.currentStyle:o.style,n=void 0,(e={})["font-family"]=c((r=function(t){return t=t.replace(/-\D/g,function(t){return t.charAt(1).toUpperCase()}),i[t]})("font-family"))||"times",e["font-style"]=a[r("font-style")]||"normal",e["text-align"]=s[r("text-align")]||"left","bold"===(n=l[r("font-weight")]||"normal")&&("normal"===e["font-style"]?e["font-style"]=n:e["font-style"]=n+e["font-style"]),e["font-size"]=p(r("font-size"))||1,e["line-height"]=p(r("line-height"))||1,e.display="inline"===r("display")?"inline":"block",n="block"===e.display,e["margin-top"]=n&&p(r("margin-top"))||0,e["margin-bottom"]=n&&p(r("margin-bottom"))||0,e["padding-top"]=n&&p(r("padding-top"))||0,e["padding-bottom"]=n&&p(r("padding-bottom"))||0,e["margin-left"]=n&&p(r("margin-left"))||0,e["margin-right"]=n&&p(r("margin-right"))||0,e["padding-left"]=n&&p(r("padding-left"))||0,e["padding-right"]=n&&p(r("padding-right"))||0,e["page-break-before"]=r("page-break-before")||"auto",e.float=h[r("cssFloat")]||"none",e.clear=u[r("clear")]||"none",e.color=r("color"),e},C=function(t,e,n){var r,i,o,a,s;if(o=!1,a=i=void 0,r=n["#"+t.id])if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;if(r=n[t.nodeName],!o&&r)if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;for(s="string"==typeof t.className?t.className.split(" "):[],i=0;i<s.length;i++)if(r=n["."+s[i]],!o&&r)if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;return o},j=function(t,e){var n,r,i,o,a,s,l,h,u;for(n=[],r=[],i=0,u=t.rows[0].cells.length,l=t.clientWidth;i<u;)h=t.rows[0].cells[i],r[i]={name:h.textContent.toLowerCase().replace(/\s+/g,""),prompt:h.textContent.replace(/\r?\n/g,""),width:h.clientWidth/l*e.pdf.internal.pageSize.getWidth()},i++;for(i=1;i<t.rows.length;){for(s=t.rows[i],a={},o=0;o<s.cells.length;)a[r[o].name]=s.cells[o].textContent.replace(/\r?\n/g,""),o++;n.push(a),i++}return{rows:n,headers:r}};var E={SCRIPT:1,STYLE:1,NOSCRIPT:1,OBJECT:1,EMBED:1,SELECT:1},M=1;k=function(t,i,e){var n,r,o,a,s,l,h,u;for(r=t.childNodes,n=void 0,(s="block"===(o=I(t)).display)&&(i.setBlockBoundary(),i.setBlockStyle(o)),a=0,l=r.length;a<l;){if("object"===se(n=r[a])){if(i.executeWatchFunctions(n),1===n.nodeType&&"HEADER"===n.nodeName){var c=n,f=i.pdf.margins_doc.top;i.pdf.internal.events.subscribe("addPage",function(t){i.y=f,k(c,i,e),i.pdf.margins_doc.top=i.y+10,i.y+=10},!1)}if(8===n.nodeType&&"#comment"===n.nodeName)~n.textContent.indexOf("ADD_PAGE")&&(i.pdf.addPage(),i.y=i.pdf.margins_doc.top);else if(1!==n.nodeType||E[n.nodeName])if(3===n.nodeType){var p=n.nodeValue;if(n.nodeValue&&"LI"===n.parentNode.nodeName)if("OL"===n.parentNode.parentNode.nodeName)p=M+++". "+p;else{var d=o["font-size"],g=(3-.75*d)*i.pdf.internal.scaleFactor,m=.75*d*i.pdf.internal.scaleFactor,y=1.74*d/i.pdf.internal.scaleFactor;u=function(t,e){this.pdf.circle(t+g,e+m,y,"FD")}}16&n.ownerDocument.body.compareDocumentPosition(n)&&i.addText(p,o)}else"string"==typeof n&&i.addText(n,o);else{var v;if("IMG"===n.nodeName){var w=n.getAttribute("src");v=B[i.pdf.sHashCode(w)||w]}if(v){i.pdf.internal.pageSize.getHeight()-i.pdf.margins_doc.bottom<i.y+n.height&&i.y>i.pdf.margins_doc.top&&(i.pdf.addPage(),i.y=i.pdf.margins_doc.top,i.executeWatchFunctions(n));var b=I(n),x=i.x,N=12/i.pdf.internal.scaleFactor,L=(b["margin-left"]+b["padding-left"])*N,A=(b["margin-right"]+b["padding-right"])*N,S=(b["margin-top"]+b["padding-top"])*N,_=(b["margin-bottom"]+b["padding-bottom"])*N;void 0!==b.float&&"right"===b.float?x+=i.settings.width-n.width-A:x+=L,i.pdf.addImage(v,x,i.y+S,n.width,n.height),v=void 0,"right"===b.float||"left"===b.float?(i.watchFunctions.push(function(t,e,n,r){return i.y>=e?(i.x+=t,i.settings.width+=n,!0):!!(r&&1===r.nodeType&&!E[r.nodeName]&&i.x+r.width>i.pdf.margins_doc.left+i.pdf.margins_doc.width)&&(i.x+=t,i.y=e,i.settings.width+=n,!0)}.bind(this,"left"===b.float?-n.width-L-A:0,i.y+n.height+S+_,n.width)),i.watchFunctions.push(function(t,e,n){return!(i.y<t&&e===i.pdf.internal.getNumberOfPages())||1===n.nodeType&&"both"===I(n).clear&&(i.y=t,!0)}.bind(this,i.y+n.height,i.pdf.internal.getNumberOfPages())),i.settings.width-=n.width+L+A,"left"===b.float&&(i.x+=n.width+L+A)):i.y+=n.height+S+_}else if("TABLE"===n.nodeName)h=j(n,i),i.y+=10,i.pdf.table(i.x,i.y,h.rows,h.headers,{autoSize:!1,printHeaders:e.printHeaders,margins:i.pdf.margins_doc,css:I(n)}),i.y=i.pdf.lastCellPos.y+i.pdf.lastCellPos.h+20;else if("OL"===n.nodeName||"UL"===n.nodeName)M=1,C(n,i,e)||k(n,i,e),i.y+=10;else if("LI"===n.nodeName){var F=i.x;i.x+=20/i.pdf.internal.scaleFactor,i.y+=3,C(n,i,e)||k(n,i,e),i.x=F}else"BR"===n.nodeName?(i.y+=o["font-size"]*i.pdf.internal.scaleFactor,i.addText("\u2028",P(o))):C(n,i,e)||k(n,i,e)}}a++}if(e.outY=i.y,s)return i.setBlockBoundary(u)},B={},d=function(t,o,e,n){var a,r=t.getElementsByTagName("img"),i=r.length,s=0;function l(){o.pdf.internal.events.publish("imagesLoaded"),n(a)}function h(e,n,r){if(e){var i=new Image;a=++s,i.crossOrigin="",i.onerror=i.onload=function(){if(i.complete&&(0===i.src.indexOf("data:image/")&&(i.width=n||i.width||0,i.height=r||i.height||0),i.width+i.height)){var t=o.pdf.sHashCode(e)||e;B[t]=B[t]||i}--s||l()},i.src=e}}for(;i--;)h(r[i].getAttribute("src"),r[i].width,r[i].height);return s||l()},g=function(t,o,a){var s=t.getElementsByTagName("footer");if(0<s.length){s=s[0];var e=o.pdf.internal.write,n=o.y;o.pdf.internal.write=function(){},k(s,o,a);var l=Math.ceil(o.y-n)+5;o.y=n,o.pdf.internal.write=e,o.pdf.margins_doc.bottom+=l;for(var r=function(t){var e=void 0!==t?t.pageNumber:1,n=o.y;o.y=o.pdf.internal.pageSize.getHeight()-o.pdf.margins_doc.bottom,o.pdf.margins_doc.bottom-=l;for(var r=s.getElementsByTagName("span"),i=0;i<r.length;++i)-1<(" "+r[i].className+" ").replace(/[\n\t]/g," ").indexOf(" pageCounter ")&&(r[i].innerHTML=e),-1<(" "+r[i].className+" ").replace(/[\n\t]/g," ").indexOf(" totalPages ")&&(r[i].innerHTML="###jsPDFVarTotalPages###");k(s,o,a),o.pdf.margins_doc.bottom+=l,o.y=n},i=s.getElementsByTagName("span"),h=0;h<i.length;++h)-1<(" "+i[h].className+" ").replace(/[\n\t]/g," ").indexOf(" totalPages ")&&o.pdf.internal.events.subscribe("htmlRenderingFinished",o.pdf.putTotalPages.bind(o.pdf,"###jsPDFVarTotalPages###"),!0);o.pdf.internal.events.subscribe("addPage",r,!1),r(),E.FOOTER=1}},m=function(t,e,n,r,i,o){if(!e)return!1;var a,s,l,h;"string"==typeof e||e.parentNode||(e=""+e.innerHTML),"string"==typeof e&&(a=e.replace(/<\/?script[^>]*?>/gi,""),h="jsPDFhtmlText"+Date.now().toString()+(1e3*Math.random()).toFixed(0),(l=document.createElement("div")).style.cssText="position: absolute !important;clip: rect(1px 1px 1px 1px); /* IE6, IE7 */clip: rect(1px, 1px, 1px, 1px);padding:0 !important;border:0 !important;height: 1px !important;width: 1px !important; top:auto;left:-100px;overflow: hidden;",l.innerHTML='<iframe style="height:1px;width:1px" name="'+h+'" />',document.body.appendChild(l),(s=window.frames[h]).document.open(),s.document.writeln(a),s.document.close(),e=s.document.body);var u,c=new f(t,n,r,i);return d.call(this,e,c,i.elementHandlers,function(t){g(e,c,i.elementHandlers),k(e,c,i.elementHandlers),c.pdf.internal.events.publish("htmlRenderingFinished"),u=c.dispose(),"function"==typeof o?o(u):t&&console.error("jsPDF Warning: rendering issues? provide a callback to fromHTML!")}),u||{x:c.x,y:c.y}},(f=function(t,e,n,r){return this.pdf=t,this.x=e,this.y=n,this.settings=r,this.watchFunctions=[],this.init(),this}).prototype.init=function(){return this.paragraph={text:[],style:[]},this.pdf.internal.write("q")},f.prototype.dispose=function(){return this.pdf.internal.write("Q"),{x:this.x,y:this.y,ready:!0}},f.prototype.executeWatchFunctions=function(t){var e=!1,n=[];if(0<this.watchFunctions.length){for(var r=0;r<this.watchFunctions.length;++r)!0===this.watchFunctions[r](t)?e=!0:n.push(this.watchFunctions[r]);this.watchFunctions=n}return e},f.prototype.splitFragmentsIntoLines=function(t,e){var n,r,i,o,a,s,l,h,u,c,f,p,d,g;for(12,c=this.pdf.internal.scaleFactor,o={},s=l=h=g=a=i=u=r=void 0,p=[f=[]],n=0,d=this.settings.width;t.length;)if(a=t.shift(),g=e.shift(),a)if((i=o[(r=g["font-family"])+(u=g["font-style"])])||(i=this.pdf.internal.getFont(r,u).metadata.Unicode,o[r+u]=i),h={widths:i.widths,kerning:i.kerning,fontSize:12*g["font-size"],textIndent:n},l=this.pdf.getStringUnitWidth(a,h)*h.fontSize/c,"\u2028"==a)f=[],p.push(f);else if(d<n+l){for(s=this.pdf.splitTextToSize(a,d,h),f.push([s.shift(),g]);s.length;)f=[[s.shift(),g]],p.push(f);n=this.pdf.getStringUnitWidth(f[0][0],h)*h.fontSize/c}else f.push([a,g]),n+=l;if(void 0!==g["text-align"]&&("center"===g["text-align"]||"right"===g["text-align"]||"justify"===g["text-align"]))for(var m=0;m<p.length;++m){var y=this.pdf.getStringUnitWidth(p[m][0][0],h)*h.fontSize/c;0<m&&(p[m][0][1]=P(p[m][0][1]));var v=d-y;if("right"===g["text-align"])p[m][0][1]["margin-left"]=v;else if("center"===g["text-align"])p[m][0][1]["margin-left"]=v/2;else if("justify"===g["text-align"]){var w=p[m][0][0].split(" ").length-1;p[m][0][1]["word-spacing"]=v/w,m===p.length-1&&(p[m][0][1]["word-spacing"]=0)}}return p},f.prototype.RenderTextFragment=function(t,e){var n,r;r=0,this.pdf.internal.pageSize.getHeight()-this.pdf.margins_doc.bottom<this.y+this.pdf.internal.getFontSize()&&(this.pdf.internal.write("ET","Q"),this.pdf.addPage(),this.y=this.pdf.margins_doc.top,this.pdf.internal.write("q","BT",this.getPdfColor(e.color),this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td"),r=Math.max(r,e["line-height"],e["font-size"]),this.pdf.internal.write(0,(-12*r).toFixed(2),"Td")),n=this.pdf.internal.getFont(e["font-family"],e["font-style"]);var i=this.getPdfColor(e.color);i!==this.lastTextColor&&(this.pdf.internal.write(i),this.lastTextColor=i),void 0!==e["word-spacing"]&&0<e["word-spacing"]&&this.pdf.internal.write(e["word-spacing"].toFixed(2),"Tw"),this.pdf.internal.write("/"+n.id,(12*e["font-size"]).toFixed(2),"Tf","("+this.pdf.internal.pdfEscape(t)+") Tj"),void 0!==e["word-spacing"]&&this.pdf.internal.write(0,"Tw")},f.prototype.getPdfColor=function(t){var e,n,r,i=/rgb\s*\(\s*(\d+),\s*(\d+),\s*(\d+\s*)\)/.exec(t);if(null!=i)e=parseInt(i[1]),n=parseInt(i[2]),r=parseInt(i[3]);else{if("string"==typeof t&&"#"!=t.charAt(0)){var o=new RGBColor(t);t=o.ok?o.toHex():"#000000"}e=t.substring(1,3),e=parseInt(e,16),n=t.substring(3,5),n=parseInt(n,16),r=t.substring(5,7),r=parseInt(r,16)}if("string"==typeof e&&/^#[0-9A-Fa-f]{6}$/.test(e)){var a=parseInt(e.substr(1),16);e=a>>16&255,n=a>>8&255,r=255&a}var s=this.f3;return 0===e&&0===n&&0===r||void 0===n?s(e/255)+" g":[s(e/255),s(n/255),s(r/255),"rg"].join(" ")},f.prototype.f3=function(t){return t.toFixed(3)},f.prototype.renderParagraph=function(t){var e,n,r,i,o,a,s,l,h,u,c,f,p;if(r=w(this.paragraph.text),f=this.paragraph.style,e=this.paragraph.blockstyle,this.paragraph.priorblockstyle||{},this.paragraph={text:[],style:[],blockstyle:{},priorblockstyle:e},r.join("").trim()){s=this.splitFragmentsIntoLines(r,f),l=a=void 0,n=12/this.pdf.internal.scaleFactor,this.priorMarginBottom=this.priorMarginBottom||0,c=(Math.max((e["margin-top"]||0)-this.priorMarginBottom,0)+(e["padding-top"]||0))*n,u=((e["margin-bottom"]||0)+(e["padding-bottom"]||0))*n,this.priorMarginBottom=e["margin-bottom"]||0,"always"===e["page-break-before"]&&(this.pdf.addPage(),this.y=0,c=((e["margin-top"]||0)+(e["padding-top"]||0))*n),h=this.pdf.internal.write,o=i=void 0,this.y+=c,h("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td");for(var d=0;s.length;){for(i=l=0,o=(a=s.shift()).length;i!==o;)a[i][0].trim()&&(l=Math.max(l,a[i][1]["line-height"],a[i][1]["font-size"]),p=7*a[i][1]["font-size"]),i++;var g=0,m=0;for(void 0!==a[0][1]["margin-left"]&&0<a[0][1]["margin-left"]&&(g=(m=this.pdf.internal.getCoordinateString(a[0][1]["margin-left"]))-d,d=m),h(g+Math.max(e["margin-left"]||0,0)*n,(-12*l).toFixed(2),"Td"),i=0,o=a.length;i!==o;)a[i][0]&&this.RenderTextFragment(a[i][0],a[i][1]),i++;if(this.y+=l*n,this.executeWatchFunctions(a[0][1])&&0<s.length){var y=[],v=[];s.forEach(function(t){for(var e=0,n=t.length;e!==n;)t[e][0]&&(y.push(t[e][0]+" "),v.push(t[e][1])),++e}),s=this.splitFragmentsIntoLines(w(y),v),h("ET","Q"),h("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td")}}return t&&"function"==typeof t&&t.call(this,this.x-9,this.y-p/2),h("ET","Q"),this.y+=u}},f.prototype.setBlockBoundary=function(t){return this.renderParagraph(t)},f.prototype.setBlockStyle=function(t){return this.paragraph.blockstyle=t},f.prototype.addText=function(t,e){return this.paragraph.text.push(t),this.paragraph.style.push(e)},i={helvetica:"helvetica","sans-serif":"helvetica","times new roman":"times",serif:"times",times:"times",monospace:"courier",courier:"courier"},l={100:"normal",200:"normal",300:"normal",400:"normal",500:"bold",600:"bold",700:"bold",800:"bold",900:"bold",normal:"normal",bold:"bold",bolder:"bold",lighter:"normal"},a={normal:"normal",italic:"italic",oblique:"italic"},s={left:"left",right:"right",center:"center",justify:"justify"},h={none:"none",right:"right",left:"left"},u={none:"none",both:"both"},n={normal:1},t.fromHTML=function(t,e,n,r,i,o){return this.margins_doc=o||{top:0,bottom:0},r||(r={}),r.elementHandlers||(r.elementHandlers={}),m(this,t,isNaN(e)?4:e,isNaN(n)?4:n,r,i)}}(lt.API),lt.API,("undefined"!=typeof window&&window||"undefined"!=typeof global&&global).html2pdf=function(t,a,e){var n=a.canvas;if(n){var r,i;if((n.pdf=a).annotations={_nameMap:[],createAnnotation:function(t,e){var n,r=a.context2d._wrapX(e.left),i=a.context2d._wrapY(e.top),o=(a.context2d._page(e.top),t.indexOf("#"));n=0<=o?{name:t.substring(o+1)}:{url:t},a.link(r,i,e.right-e.left,e.bottom-e.top,n)},setName:function(t,e){var n=a.context2d._wrapX(e.left),r=a.context2d._wrapY(e.top),i=a.context2d._page(e.top);this._nameMap[t]={page:i,x:n,y:r}}},n.annotations=a.annotations,a.context2d._pageBreakAt=function(t){this.pageBreaks.push(t)},a.context2d._gotoPage=function(t){for(;a.internal.getNumberOfPages()<t;)a.addPage();a.setPage(t)},"string"==typeof t){t=t.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,"");var o,s,l=document.createElement("iframe");document.body.appendChild(l),null!=(o=l.contentDocument)&&null!=o||(o=l.contentWindow.document),o.open(),o.write(t),o.close(),r=o.body,s=o.body||{},t=o.documentElement||{},i=Math.max(s.scrollHeight,s.offsetHeight,t.clientHeight,t.scrollHeight,t.offsetHeight)}else s=(r=t).body||{},i=Math.max(s.scrollHeight,s.offsetHeight,t.clientHeight,t.scrollHeight,t.offsetHeight);var h={async:!0,allowTaint:!0,backgroundColor:"#ffffff",canvas:n,imageTimeout:15e3,logging:!0,proxy:null,removeContainer:!0,foreignObjectRendering:!1,useCORS:!1,windowHeight:i=a.internal.pageSize.getHeight(),scrollY:i};a.context2d.pageWrapYEnabled=!0,a.context2d.pageWrapY=a.internal.pageSize.getHeight(),html2canvas(r,h).then(function(t){e&&(l&&l.parentElement.removeChild(l),e(a))})}else alert("jsPDF canvas plugin not installed")},window.tmp=html2pdf,function(f){var r=f.BlobBuilder||f.WebKitBlobBuilder||f.MSBlobBuilder||f.MozBlobBuilder;f.URL=f.URL||f.webkitURL||function(t,e){return(e=document.createElement("a")).href=t,e};var n=f.Blob,p=URL.createObjectURL,d=URL.revokeObjectURL,o=f.Symbol&&f.Symbol.toStringTag,t=!1,e=!1,g=!!f.ArrayBuffer,i=r&&r.prototype.append&&r.prototype.getBlob;try{t=2===new Blob(["ä"]).size,e=2===new Blob([new Uint8Array([1,2])]).size}catch(t){}function a(t){return t.map(function(t){if(t.buffer instanceof ArrayBuffer){var e=t.buffer;if(t.byteLength!==e.byteLength){var n=new Uint8Array(t.byteLength);n.set(new Uint8Array(e,t.byteOffset,t.byteLength)),e=n.buffer}return e}return t})}function s(t,e){e=e||{};var n=new r;return a(t).forEach(function(t){n.append(t)}),e.type?n.getBlob(e.type):n.getBlob()}function l(t,e){return new n(a(t),e||{})}if(f.Blob&&(s.prototype=Blob.prototype,l.prototype=Blob.prototype),o)try{File.prototype[o]="File",Blob.prototype[o]="Blob",FileReader.prototype[o]="FileReader"}catch(t){}function h(){var t=!!f.ActiveXObject||"-ms-scroll-limit"in document.documentElement.style&&"-ms-ime-align"in document.documentElement.style,e=f.XMLHttpRequest&&f.XMLHttpRequest.prototype.send;t&&e&&(XMLHttpRequest.prototype.send=function(t){t instanceof Blob&&this.setRequestHeader("Content-Type",t.type),e.call(this,t)});try{new File([],"")}catch(t){try{var n=new Function('class File extends Blob {constructor(chunks, name, opts) {opts = opts || {};super(chunks, opts || {});this.name = name;this.lastModifiedDate = opts.lastModified ? new Date(opts.lastModified) : new Date;this.lastModified = +this.lastModifiedDate;}};return new File([], ""), File')();f.File=n}catch(t){n=function(t,e,n){var r=new Blob(t,n),i=n&&void 0!==n.lastModified?new Date(n.lastModified):new Date;return r.name=e,r.lastModifiedDate=i,r.lastModified=+i,r.toString=function(){return"[object File]"},o&&(r[o]="File"),r};f.File=n}}}t?(h(),f.Blob=e?f.Blob:l):i?(h(),f.Blob=s):function(){function a(t){for(var e=[],n=0;n<t.length;n++){var r=t.charCodeAt(n);r<128?e.push(r):r<2048?e.push(192|r>>6,128|63&r):r<55296||57344<=r?e.push(224|r>>12,128|r>>6&63,128|63&r):(n++,r=65536+((1023&r)<<10|1023&t.charCodeAt(n)),e.push(240|r>>18,128|r>>12&63,128|r>>6&63,128|63&r))}return e}function e(t){var e,n,r,i,o,a;for(e="",r=t.length,n=0;n<r;)switch((i=t[n++])>>4){case 0:case 1:case 2:case 3:case 4:case 5:case 6:case 7:e+=String.fromCharCode(i);break;case 12:case 13:o=t[n++],e+=String.fromCharCode((31&i)<<6|63&o);break;case 14:o=t[n++],a=t[n++],e+=String.fromCharCode((15&i)<<12|(63&o)<<6|(63&a)<<0)}return e}function s(t){for(var e=new Array(t.byteLength),n=new Uint8Array(t),r=e.length;r--;)e[r]=n[r];return e}function n(t){for(var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",n=[],r=0;r<t.length;r+=3){var i=t[r],o=r+1<t.length,a=o?t[r+1]:0,s=r+2<t.length,l=s?t[r+2]:0,h=i>>2,u=(3&i)<<4|a>>4,c=(15&a)<<2|l>>6,f=63&l;s||(f=64,o||(c=64)),n.push(e[h],e[u],e[c],e[f])}return n.join("")}var t=Object.create||function(t){function e(){}return e.prototype=t,new e};if(g)var r=["[object Int8Array]","[object Uint8Array]","[object Uint8ClampedArray]","[object Int16Array]","[object Uint16Array]","[object Int32Array]","[object Uint32Array]","[object Float32Array]","[object Float64Array]"],l=ArrayBuffer.isView||function(t){return t&&-1<r.indexOf(Object.prototype.toString.call(t))};function h(t,e){for(var n=0,r=(t=t||[]).length;n<r;n++){var i=t[n];i instanceof h?t[n]=i._buffer:"string"==typeof i?t[n]=a(i):g&&(ArrayBuffer.prototype.isPrototypeOf(i)||l(i))?t[n]=s(i):g&&(o=i)&&DataView.prototype.isPrototypeOf(o)?t[n]=s(i.buffer):t[n]=a(String(i))}var o;this._buffer=[].concat.apply([],t),this.size=this._buffer.length,this.type=e&&e.type||""}function i(t,e,n){var r=h.call(this,t,n=n||{})||this;return r.name=e,r.lastModifiedDate=n.lastModified?new Date(n.lastModified):new Date,r.lastModified=+r.lastModifiedDate,r}if(h.prototype.slice=function(t,e,n){return new h([this._buffer.slice(t||0,e||this._buffer.length)],{type:n})},h.prototype.toString=function(){return"[object Blob]"},(i.prototype=t(h.prototype)).constructor=i,Object.setPrototypeOf)Object.setPrototypeOf(i,h);else try{i.__proto__=h}catch(t){}function o(){if(!(this instanceof o))throw new TypeError("Failed to construct 'FileReader': Please use the 'new' operator, this DOM object constructor cannot be called as a function.");var n=document.createDocumentFragment();this.addEventListener=n.addEventListener,this.dispatchEvent=function(t){var e=this["on"+t.type];"function"==typeof e&&e(t),n.dispatchEvent(t)},this.removeEventListener=n.removeEventListener}function u(t,e,n){if(!(e instanceof h))throw new TypeError("Failed to execute '"+n+"' on 'FileReader': parameter 1 is not of type 'Blob'.");t.result="",setTimeout(function(){this.readyState=o.LOADING,t.dispatchEvent(new Event("load")),t.dispatchEvent(new Event("loadend"))})}i.prototype.toString=function(){return"[object File]"},o.EMPTY=0,o.LOADING=1,o.DONE=2,o.prototype.error=null,o.prototype.onabort=null,o.prototype.onerror=null,o.prototype.onload=null,o.prototype.onloadend=null,o.prototype.onloadstart=null,o.prototype.onprogress=null,o.prototype.readAsDataURL=function(t){u(this,t,"readAsDataURL"),this.result="data:"+t.type+";base64,"+n(t._buffer)},o.prototype.readAsText=function(t){u(this,t,"readAsText"),this.result=e(t._buffer)},o.prototype.readAsArrayBuffer=function(t){u(this,t,"readAsText"),this.result=t._buffer.slice()},o.prototype.abort=function(){},URL.createObjectURL=function(t){return t instanceof h?"data:"+t.type+";base64,"+n(t._buffer):p.call(URL,t)},URL.revokeObjectURL=function(t){d&&d.call(URL,t)};var c=f.XMLHttpRequest&&f.XMLHttpRequest.prototype.send;c&&(XMLHttpRequest.prototype.send=function(t){t instanceof h?(this.setRequestHeader("Content-Type",t.type),c.call(this,e(t._buffer))):c.call(this,t)}),f.FileReader=o,f.File=i,f.Blob=h}()}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")());var ht,ut,ct,ft,pt,dt,gt,mt,yt,vt,wt,bt,xt,Nt,Lt,le=le||function(s){if(!(void 0===s||"undefined"!=typeof navigator&&/MSIE [1-9]\./.test(navigator.userAgent))){var t=s.document,l=function(){return s.URL||s.webkitURL||s},h=t.createElementNS("http://www.w3.org/1999/xhtml","a"),u="download"in h,c=/constructor/i.test(s.HTMLElement)||s.safari,f=/CriOS\/[\d]+/.test(navigator.userAgent),p=s.setImmediate||s.setTimeout,d=function(t){p(function(){throw t},0)},g=function(t){setTimeout(function(){"string"==typeof t?l().revokeObjectURL(t):t.remove()},4e4)},m=function(t){return/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(t.type)?new Blob([String.fromCharCode(65279),t],{type:t.type}):t},r=function(t,n,e){e||(t=m(t));var r,i=this,o="application/octet-stream"===t.type,a=function(){!function(t,e,n){for(var r=(e=[].concat(e)).length;r--;){var i=t["on"+e[r]];if("function"==typeof i)try{i.call(t,n||t)}catch(t){d(t)}}}(i,"writestart progress write writeend".split(" "))};if(i.readyState=i.INIT,u)return r=l().createObjectURL(t),void p(function(){var t,e;h.href=r,h.download=n,t=h,e=new MouseEvent("click"),t.dispatchEvent(e),a(),g(r),i.readyState=i.DONE},0);!function(){if((f||o&&c)&&s.FileReader){var e=new FileReader;return e.onloadend=function(){var t=f?e.result:e.result.replace(/^data:[^;]*;/,"data:attachment/file;");s.open(t,"_blank")||(s.location.href=t),t=void 0,i.readyState=i.DONE,a()},e.readAsDataURL(t),i.readyState=i.INIT}r||(r=l().createObjectURL(t)),o?s.location.href=r:s.open(r,"_blank")||(s.location.href=r);i.readyState=i.DONE,a(),g(r)}()},e=r.prototype;return"undefined"!=typeof navigator&&navigator.msSaveOrOpenBlob?function(t,e,n){return e=e||t.name||"download",n||(t=m(t)),navigator.msSaveOrOpenBlob(t,e)}:(e.abort=function(){},e.readyState=e.INIT=0,e.WRITING=1,e.DONE=2,e.error=e.onwritestart=e.onprogress=e.onwrite=e.onabort=e.onerror=e.onwriteend=null,function(t,e,n){return new r(t,e||t.name||"download",n)})}}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||void 0);function At(x){var t=0;if(71!==x[t++]||73!==x[t++]||70!==x[t++]||56!==x[t++]||56!=(x[t++]+1&253)||97!==x[t++])throw"Invalid GIF 87a/89a header.";var N=x[t++]|x[t++]<<8,e=x[t++]|x[t++]<<8,n=x[t++],r=n>>7,i=1<<(7&n)+1;x[t++];x[t++];var o=null;r&&(o=t,t+=3*i);var a=!0,s=[],l=0,h=null,u=0,c=null;for(this.width=N,this.height=e;a&&t<x.length;)switch(x[t++]){case 33:switch(x[t++]){case 255:if(11!==x[t]||78==x[t+1]&&69==x[t+2]&&84==x[t+3]&&83==x[t+4]&&67==x[t+5]&&65==x[t+6]&&80==x[t+7]&&69==x[t+8]&&50==x[t+9]&&46==x[t+10]&&48==x[t+11]&&3==x[t+12]&&1==x[t+13]&&0==x[t+16])t+=14,c=x[t++]|x[t++]<<8,t++;else for(t+=12;;){if(0===(A=x[t++]))break;t+=A}break;case 249:if(4!==x[t++]||0!==x[t+4])throw"Invalid graphics extension block.";var f=x[t++];l=x[t++]|x[t++]<<8,h=x[t++],0==(1&f)&&(h=null),u=f>>2&7,t++;break;case 254:for(;;){if(0===(A=x[t++]))break;t+=A}break;default:throw"Unknown graphic control label: 0x"+x[t-1].toString(16)}break;case 44:var p=x[t++]|x[t++]<<8,d=x[t++]|x[t++]<<8,g=x[t++]|x[t++]<<8,m=x[t++]|x[t++]<<8,y=x[t++],v=y>>6&1,w=o,b=!1;if(y>>7){b=!0;w=t,t+=3*(1<<(7&y)+1)}var L=t;for(t++;;){var A;if(0===(A=x[t++]))break;t+=A}s.push({x:p,y:d,width:g,height:m,has_local_palette:b,palette_offset:w,data_offset:L,data_length:t-L,transparent_index:h,interlaced:!!v,delay:l,disposal:u});break;case 59:a=!1;break;default:throw"Unknown gif block: 0x"+x[t-1].toString(16)}this.numFrames=function(){return s.length},this.loopCount=function(){return c},this.frameInfo=function(t){if(t<0||t>=s.length)throw"Frame index out of range.";return s[t]},this.decodeAndBlitFrameBGRA=function(t,e){var n=this.frameInfo(t),r=n.width*n.height,i=new Uint8Array(r);St(x,n.data_offset,i,r);var o=n.palette_offset,a=n.transparent_index;null===a&&(a=256);var s=n.width,l=N-s,h=s,u=4*(n.y*N+n.x),c=4*((n.y+n.height)*N+n.x),f=u,p=4*l;!0===n.interlaced&&(p+=4*(s+l)*7);for(var d=8,g=0,m=i.length;g<m;++g){var y=i[g];if(0===h&&(h=s,c<=(f+=p)&&(p=l+4*(s+l)*(d-1),f=u+(s+l)*(d<<1),d>>=1)),y===a)f+=4;else{var v=x[o+3*y],w=x[o+3*y+1],b=x[o+3*y+2];e[f++]=b,e[f++]=w,e[f++]=v,e[f++]=255}--h}},this.decodeAndBlitFrameRGBA=function(t,e){var n=this.frameInfo(t),r=n.width*n.height,i=new Uint8Array(r);St(x,n.data_offset,i,r);var o=n.palette_offset,a=n.transparent_index;null===a&&(a=256);var s=n.width,l=N-s,h=s,u=4*(n.y*N+n.x),c=4*((n.y+n.height)*N+n.x),f=u,p=4*l;!0===n.interlaced&&(p+=4*(s+l)*7);for(var d=8,g=0,m=i.length;g<m;++g){var y=i[g];if(0===h&&(h=s,c<=(f+=p)&&(p=l+4*(s+l)*(d-1),f=u+(s+l)*(d<<1),d>>=1)),y===a)f+=4;else{var v=x[o+3*y],w=x[o+3*y+1],b=x[o+3*y+2];e[f++]=v,e[f++]=w,e[f++]=b,e[f++]=255}--h}}}function St(t,e,n,r){for(var i=t[e++],o=1<<i,a=o+1,s=a+1,l=i+1,h=(1<<l)-1,u=0,c=0,f=0,p=t[e++],d=new Int32Array(4096),g=null;;){for(;u<16&&0!==p;)c|=t[e++]<<u,u+=8,1===p?p=t[e++]:--p;if(u<l)break;var m=c&h;if(c>>=l,u-=l,m!==o){if(m===a)break;for(var y=m<s?m:g,v=0,w=y;o<w;)w=d[w]>>8,++v;var b=w;if(r<f+v+(y!==m?1:0))return void console.log("Warning, gif stream longer than expected.");n[f++]=b;var x=f+=v;for(y!==m&&(n[f++]=b),w=y;v--;)w=d[w],n[--x]=255&w,w>>=8;null!==g&&s<4096&&(d[s++]=g<<8|b,h+1<=s&&l<12&&(++l,h=h<<1|1)),g=m}else s=a+1,h=(1<<(l=i+1))-1,g=null}return f!==r&&console.log("Warning, gif stream shorter than expected."),n}try{exports.GifWriter=function(y,t,e,n){var v=0,r=void 0===(n=void 0===n?{}:n).loop?null:n.loop,w=void 0===n.palette?null:n.palette;if(t<=0||e<=0||65535<t||65535<e)throw"Width/Height invalid.";function b(t){var e=t.length;if(e<2||256<e||e&e-1)throw"Invalid code/color length, must be power of 2 and 2 .. 256.";return e}y[v++]=71,y[v++]=73,y[v++]=70,y[v++]=56,y[v++]=57,y[v++]=97;var i=0,o=0;if(null!==w){for(var a=b(w);a>>=1;)++i;if(a=1<<i,--i,void 0!==n.background){if(a<=(o=n.background))throw"Background index out of range.";if(0===o)throw"Background index explicitly passed as 0."}}if(y[v++]=255&t,y[v++]=t>>8&255,y[v++]=255&e,y[v++]=e>>8&255,y[v++]=(null!==w?128:0)|i,y[v++]=o,y[v++]=0,null!==w)for(var s=0,l=w.length;s<l;++s){var h=w[s];y[v++]=h>>16&255,y[v++]=h>>8&255,y[v++]=255&h}if(null!==r){if(r<0||65535<r)throw"Loop count invalid.";y[v++]=33,y[v++]=255,y[v++]=11,y[v++]=78,y[v++]=69,y[v++]=84,y[v++]=83,y[v++]=67,y[v++]=65,y[v++]=80,y[v++]=69,y[v++]=50,y[v++]=46,y[v++]=48,y[v++]=3,y[v++]=1,y[v++]=255&r,y[v++]=r>>8&255,y[v++]=0}var x=!1;this.addFrame=function(t,e,n,r,i,o){if(!0===x&&(--v,x=!1),o=void 0===o?{}:o,t<0||e<0||65535<t||65535<e)throw"x/y invalid.";if(n<=0||r<=0||65535<n||65535<r)throw"Width/Height invalid.";if(i.length<n*r)throw"Not enough pixels for the frame size.";var a=!0,s=o.palette;if(null==s&&(a=!1,s=w),null==s)throw"Must supply either a local or global palette.";for(var l=b(s),h=0;l>>=1;)++h;l=1<<h;var u=void 0===o.delay?0:o.delay,c=void 0===o.disposal?0:o.disposal;if(c<0||3<c)throw"Disposal out of range.";var f=!1,p=0;if(void 0!==o.transparent&&null!==o.transparent&&(f=!0,(p=o.transparent)<0||l<=p))throw"Transparent color index.";if((0!==c||f||0!==u)&&(y[v++]=33,y[v++]=249,y[v++]=4,y[v++]=c<<2|(!0===f?1:0),y[v++]=255&u,y[v++]=u>>8&255,y[v++]=p,y[v++]=0),y[v++]=44,y[v++]=255&t,y[v++]=t>>8&255,y[v++]=255&e,y[v++]=e>>8&255,y[v++]=255&n,y[v++]=n>>8&255,y[v++]=255&r,y[v++]=r>>8&255,y[v++]=!0===a?128|h-1:0,!0===a)for(var d=0,g=s.length;d<g;++d){var m=s[d];y[v++]=m>>16&255,y[v++]=m>>8&255,y[v++]=255&m}v=function(e,n,t,r){e[n++]=t;var i=n++,o=1<<t,a=o-1,s=o+1,l=s+1,h=t+1,u=0,c=0;function f(t){for(;t<=u;)e[n++]=255&c,c>>=8,u-=8,n===i+256&&(e[i]=255,i=n++)}function p(t){c|=t<<u,u+=h,f(8)}var d=r[0]&a,g={};p(o);for(var m=1,y=r.length;m<y;++m){var v=r[m]&a,w=d<<8|v,b=g[w];if(void 0===b){for(c|=d<<u,u+=h;8<=u;)e[n++]=255&c,c>>=8,u-=8,n===i+256&&(e[i]=255,i=n++);4096===l?(p(o),l=s+1,h=t+1,g={}):(1<<h<=l&&++h,g[w]=l++),d=v}else d=b}return p(d),p(s),f(1),i+1===n?e[i]=0:(e[i]=n-i-1,e[n++]=0),n}(y,v,h<2?2:h,i)},this.end=function(){return!1===x&&(y[v++]=59,x=!0),v}},exports.GifReader=At}catch(t){}
/*
    Copyright (c) 2008, Adobe Systems Incorporated
    All rights reserved.

    Redistribution and use in source and binary forms, with or without 
    modification, are permitted provided that the following conditions are
    met:

    * Redistributions of source code must retain the above copyright notice, 
      this list of conditions and the following disclaimer.
    
    * Redistributions in binary form must reproduce the above copyright
      notice, this list of conditions and the following disclaimer in the 
      documentation and/or other materials provided with the distribution.
    
    * Neither the name of Adobe Systems Incorporated nor the names of its 
      contributors may be used to endorse or promote products derived from 
      this software without specific prior written permission.

    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
    IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
    THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
    PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
    CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
    EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
    PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
    PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
    LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
    NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
    SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
  */
function _t(t){var N,L,A,S,e,c=Math.floor,_=new Array(64),F=new Array(64),P=new Array(64),k=new Array(64),y=new Array(65535),v=new Array(65535),Z=new Array(64),w=new Array(64),I=[],C=0,B=7,j=new Array(64),E=new Array(64),M=new Array(64),n=new Array(256),O=new Array(2048),b=[0,1,5,6,14,15,27,28,2,4,7,13,16,26,29,42,3,8,12,17,25,30,41,43,9,11,18,24,31,40,44,53,10,19,23,32,39,45,52,54,20,22,33,38,46,51,55,60,21,34,37,47,50,56,59,61,35,36,48,49,57,58,62,63],q=[0,0,1,5,1,1,1,1,1,1,0,0,0,0,0,0,0],T=[0,1,2,3,4,5,6,7,8,9,10,11],R=[0,0,2,1,3,3,2,4,3,5,5,4,4,0,0,1,125],D=[1,2,3,0,4,17,5,18,33,49,65,6,19,81,97,7,34,113,20,50,129,145,161,8,35,66,177,193,21,82,209,240,36,51,98,114,130,9,10,22,23,24,25,26,37,38,39,40,41,42,52,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,116,117,118,119,120,121,122,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,225,226,227,228,229,230,231,232,233,234,241,242,243,244,245,246,247,248,249,250],U=[0,0,3,1,1,1,1,1,1,1,1,1,0,0,0,0,0],z=[0,1,2,3,4,5,6,7,8,9,10,11],H=[0,0,2,1,2,4,4,3,4,7,5,4,4,0,1,2,119],W=[0,1,2,3,17,4,5,33,49,6,18,65,81,7,97,113,19,34,50,129,8,20,66,145,161,177,193,9,35,51,82,240,21,98,114,209,10,22,36,52,225,37,241,23,24,25,26,38,39,40,41,42,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,116,117,118,119,120,121,122,130,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,226,227,228,229,230,231,232,233,234,242,243,244,245,246,247,248,249,250];function r(t,e){for(var n=0,r=0,i=new Array,o=1;o<=16;o++){for(var a=1;a<=t[o];a++)i[e[r]]=[],i[e[r]][0]=n,i[e[r]][1]=o,r++,n++;n*=2}return i}function V(t){for(var e=t[0],n=t[1]-1;0<=n;)e&1<<n&&(C|=1<<B),n--,--B<0&&(255==C?(G(255),G(0)):G(C),B=7,C=0)}function G(t){I.push(t)}function Y(t){G(t>>8&255),G(255&t)}function J(t,e,n,r,i){for(var o,a=i[0],s=i[240],l=function(t,e){var n,r,i,o,a,s,l,h,u,c,f=0;for(u=0;u<8;++u){n=t[f],r=t[f+1],i=t[f+2],o=t[f+3],a=t[f+4],s=t[f+5],l=t[f+6];var p=n+(h=t[f+7]),d=n-h,g=r+l,m=r-l,y=i+s,v=i-s,w=o+a,b=o-a,x=p+w,N=p-w,L=g+y,A=g-y;t[f]=x+L,t[f+4]=x-L;var S=.707106781*(A+N);t[f+2]=N+S,t[f+6]=N-S;var _=.382683433*((x=b+v)-(A=m+d)),F=.5411961*x+_,P=1.306562965*A+_,k=.707106781*(L=v+m),I=d+k,C=d-k;t[f+5]=C+F,t[f+3]=C-F,t[f+1]=I+P,t[f+7]=I-P,f+=8}for(u=f=0;u<8;++u){n=t[f],r=t[f+8],i=t[f+16],o=t[f+24],a=t[f+32],s=t[f+40],l=t[f+48];var B=n+(h=t[f+56]),j=n-h,E=r+l,M=r-l,O=i+s,q=i-s,T=o+a,R=o-a,D=B+T,U=B-T,z=E+O,H=E-O;t[f]=D+z,t[f+32]=D-z;var W=.707106781*(H+U);t[f+16]=U+W,t[f+48]=U-W;var V=.382683433*((D=R+q)-(H=M+j)),G=.5411961*D+V,Y=1.306562965*H+V,J=.707106781*(z=q+M),X=j+J,K=j-J;t[f+40]=K+G,t[f+24]=K-G,t[f+8]=X+Y,t[f+56]=X-Y,f++}for(u=0;u<64;++u)c=t[u]*e[u],Z[u]=0<c?c+.5|0:c-.5|0;return Z}(t,e),h=0;h<64;++h)w[b[h]]=l[h];var u=w[0]-n;n=w[0],0==u?V(r[0]):(V(r[v[o=32767+u]]),V(y[o]));for(var c=63;0<c&&0==w[c];c--);if(0==c)return V(a),n;for(var f,p=1;p<=c;){for(var d=p;0==w[p]&&p<=c;++p);var g=p-d;if(16<=g){f=g>>4;for(var m=1;m<=f;++m)V(s);g&=15}o=32767+w[p],V(i[(g<<4)+v[o]]),V(y[o]),p++}return 63!=c&&V(a),n}function X(t){if(t<=0&&(t=1),100<t&&(t=100),e!=t){(function(t){for(var e=[16,11,10,16,24,40,51,61,12,12,14,19,26,58,60,55,14,13,16,24,40,57,69,56,14,17,22,29,51,87,80,62,18,22,37,56,68,109,103,77,24,35,55,64,81,104,113,92,49,64,78,87,103,121,120,101,72,92,95,98,112,100,103,99],n=0;n<64;n++){var r=c((e[n]*t+50)/100);r<1?r=1:255<r&&(r=255),_[b[n]]=r}for(var i=[17,18,24,47,99,99,99,99,18,21,26,66,99,99,99,99,24,26,56,99,99,99,99,99,47,66,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99],o=0;o<64;o++){var a=c((i[o]*t+50)/100);a<1?a=1:255<a&&(a=255),F[b[o]]=a}for(var s=[1,1.387039845,1.306562965,1.175875602,1,.785694958,.5411961,.275899379],l=0,h=0;h<8;h++)for(var u=0;u<8;u++)P[l]=1/(_[b[l]]*s[h]*s[u]*8),k[l]=1/(F[b[l]]*s[h]*s[u]*8),l++})(t<50?Math.floor(5e3/t):Math.floor(200-2*t)),e=t}}this.encode=function(t,e){var n,r;(new Date).getTime();e&&X(e),I=new Array,C=0,B=7,Y(65496),Y(65504),Y(16),G(74),G(70),G(73),G(70),G(0),G(1),G(1),G(0),Y(1),Y(1),G(0),G(0),function(){Y(65499),Y(132),G(0);for(var t=0;t<64;t++)G(_[t]);G(1);for(var e=0;e<64;e++)G(F[e])}(),n=t.width,r=t.height,Y(65472),Y(17),G(8),Y(r),Y(n),G(3),G(1),G(17),G(0),G(2),G(17),G(1),G(3),G(17),G(1),function(){Y(65476),Y(418),G(0);for(var t=0;t<16;t++)G(q[t+1]);for(var e=0;e<=11;e++)G(T[e]);G(16);for(var n=0;n<16;n++)G(R[n+1]);for(var r=0;r<=161;r++)G(D[r]);G(1);for(var i=0;i<16;i++)G(U[i+1]);for(var o=0;o<=11;o++)G(z[o]);G(17);for(var a=0;a<16;a++)G(H[a+1]);for(var s=0;s<=161;s++)G(W[s])}(),Y(65498),Y(12),G(3),G(1),G(0),G(2),G(17),G(3),G(17),G(0),G(63),G(0);var i=0,o=0,a=0;C=0,B=7,this.encode.displayName="_encode_";for(var s,l,h,u,c,f,p,d,g,m=t.data,y=t.width,v=t.height,w=4*y,b=0;b<v;){for(s=0;s<w;){for(f=c=w*b+s,p=-1,g=d=0;g<64;g++)f=c+(d=g>>3)*w+(p=4*(7&g)),v<=b+d&&(f-=w*(b+1+d-v)),w<=s+p&&(f-=s+p-w+4),l=m[f++],h=m[f++],u=m[f++],j[g]=(O[l]+O[h+256>>0]+O[u+512>>0]>>16)-128,E[g]=(O[l+768>>0]+O[h+1024>>0]+O[u+1280>>0]>>16)-128,M[g]=(O[l+1280>>0]+O[h+1536>>0]+O[u+1792>>0]>>16)-128;i=J(j,P,i,N,A),o=J(E,k,o,L,S),a=J(M,k,a,L,S),s+=32}b+=8}if(0<=B){var x=[];x[1]=B+1,x[0]=(1<<B+1)-1,V(x)}return Y(65497),new Uint8Array(I)},function(){(new Date).getTime();t||(t=50),function(){for(var t=String.fromCharCode,e=0;e<256;e++)n[e]=t(e)}(),N=r(q,T),L=r(U,z),A=r(R,D),S=r(H,W),function(){for(var t=1,e=2,n=1;n<=15;n++){for(var r=t;r<e;r++)v[32767+r]=n,y[32767+r]=[],y[32767+r][1]=n,y[32767+r][0]=r;for(var i=-(e-1);i<=-t;i++)v[32767+i]=n,y[32767+i]=[],y[32767+i][1]=n,y[32767+i][0]=e-1+i;t<<=1,e<<=1}}(),function(){for(var t=0;t<256;t++)O[t]=19595*t,O[t+256>>0]=38470*t,O[t+512>>0]=7471*t+32768,O[t+768>>0]=-11059*t,O[t+1024>>0]=-21709*t,O[t+1280>>0]=32768*t+8421375,O[t+1536>>0]=-27439*t,O[t+1792>>0]=-5329*t}(),X(t),(new Date).getTime()}()}function Ft(t,e){if(this.pos=0,this.buffer=t,this.datav=new DataView(t.buffer),this.is_with_alpha=!!e,this.bottom_up=!0,this.flag=String.fromCharCode(this.buffer[0])+String.fromCharCode(this.buffer[1]),this.pos+=2,-1===["BM","BA","CI","CP","IC","PT"].indexOf(this.flag))throw new Error("Invalid BMP File");this.parseHeader(),this.parseBGR()}window.tmp=At,lt.API.adler32cs=(dt="function"==typeof ArrayBuffer&&"function"==typeof Uint8Array,gt=null,mt=function(){if(!dt)return function(){return!1};try{var t={};"function"==typeof t.Buffer&&(gt=t.Buffer)}catch(t){}return function(t){return t instanceof ArrayBuffer||null!==gt&&t instanceof gt}}(),yt=null!==gt?function(t){return new gt(t,"utf8").toString("binary")}:function(t){return unescape(encodeURIComponent(t))},vt=function(t,e){for(var n=65535&t,r=t>>>16,i=0,o=e.length;i<o;i++)n=(n+(255&e.charCodeAt(i)))%65521,r=(r+n)%65521;return(r<<16|n)>>>0},wt=function(t,e){for(var n=65535&t,r=t>>>16,i=0,o=e.length;i<o;i++)n=(n+e[i])%65521,r=(r+n)%65521;return(r<<16|n)>>>0},xt=(bt={}).Adler32=(((pt=(ft=function(t){if(!(this instanceof ft))throw new TypeError("Constructor cannot called be as a function.");if(!isFinite(t=null==t?1:+t))throw new Error("First arguments needs to be a finite number.");this.checksum=t>>>0}).prototype={}).constructor=ft).from=((ht=function(t){if(!(this instanceof ft))throw new TypeError("Constructor cannot called be as a function.");if(null==t)throw new Error("First argument needs to be a string.");this.checksum=vt(1,t.toString())}).prototype=pt,ht),ft.fromUtf8=((ut=function(t){if(!(this instanceof ft))throw new TypeError("Constructor cannot called be as a function.");if(null==t)throw new Error("First argument needs to be a string.");var e=yt(t.toString());this.checksum=vt(1,e)}).prototype=pt,ut),dt&&(ft.fromBuffer=((ct=function(t){if(!(this instanceof ft))throw new TypeError("Constructor cannot called be as a function.");if(!mt(t))throw new Error("First argument needs to be ArrayBuffer.");var e=new Uint8Array(t);return this.checksum=wt(1,e)}).prototype=pt,ct)),pt.update=function(t){if(null==t)throw new Error("First argument needs to be a string.");return t=t.toString(),this.checksum=vt(this.checksum,t)},pt.updateUtf8=function(t){if(null==t)throw new Error("First argument needs to be a string.");var e=yt(t.toString());return this.checksum=vt(this.checksum,e)},dt&&(pt.updateBuffer=function(t){if(!mt(t))throw new Error("First argument needs to be ArrayBuffer.");var e=new Uint8Array(t);return this.checksum=wt(this.checksum,e)}),pt.clone=function(){return new xt(this.checksum)},ft),bt.from=function(t){if(null==t)throw new Error("First argument needs to be a string.");return vt(1,t.toString())},bt.fromUtf8=function(t){if(null==t)throw new Error("First argument needs to be a string.");var e=yt(t.toString());return vt(1,e)},dt&&(bt.fromBuffer=function(t){if(!mt(t))throw new Error("First argument need to be ArrayBuffer.");var e=new Uint8Array(t);return wt(1,e)}),bt),function(t){t.__bidiEngine__=t.prototype.__bidiEngine__=function(t){var d,g,c,f,i,o,a,s=e,m=[[0,3,0,1,0,0,0],[0,3,0,1,2,2,0],[0,3,0,17,2,0,1],[0,3,5,5,4,1,0],[0,3,21,21,4,0,1],[0,3,5,5,4,2,0]],y=[[2,0,1,1,0,1,0],[2,0,1,1,0,2,0],[2,0,2,1,3,2,0],[2,0,2,33,3,1,1]],v={L:0,R:1,EN:2,AN:3,N:4,B:5,S:6},l={0:0,5:1,6:2,7:3,32:4,251:5,254:6,255:7},h=["(",")","(","<",">","<","[","]","[","{","}","{","«","»","«","‹","›","‹","⁅","⁆","⁅","⁽","⁾","⁽","₍","₎","₍","≤","≥","≤","〈","〉","〈","﹙","﹚","﹙","﹛","﹜","﹛","﹝","﹞","﹝","﹤","﹥","﹤"],u=new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/),w=!1,b=0;this.__bidiEngine__={};var x=function(t){var e=t.charCodeAt(),n=e>>8,r=l[n];return void 0!==r?s[256*r+(255&e)]:252===n||253===n?"AL":u.test(n)?"L":8===n?"R":"N"},p=function(t){for(var e,n=0;n<t.length;n++){if("L"===(e=x(t.charAt(n))))return!1;if("R"===e)return!0}return!1},N=function(t,e,n,r){var i,o,a,s,l=e[r];switch(l){case"L":case"R":w=!1;break;case"N":case"AN":break;case"EN":w&&(l="AN");break;case"AL":w=!0,l="R";break;case"WS":l="N";break;case"CS":r<1||r+1>=e.length||"EN"!==(i=n[r-1])&&"AN"!==i||"EN"!==(o=e[r+1])&&"AN"!==o?l="N":w&&(o="AN"),l=o===i?o:"N";break;case"ES":l="EN"===(i=0<r?n[r-1]:"B")&&r+1<e.length&&"EN"===e[r+1]?"EN":"N";break;case"ET":if(0<r&&"EN"===n[r-1]){l="EN";break}if(w){l="N";break}for(a=r+1,s=e.length;a<s&&"ET"===e[a];)a++;l=a<s&&"EN"===e[a]?"EN":"N";break;case"NSM":if(c&&!f){for(s=e.length,a=r+1;a<s&&"NSM"===e[a];)a++;if(a<s){var h=t[r],u=1425<=h&&h<=2303||64286===h;if(i=e[a],u&&("R"===i||"AL"===i)){l="R";break}}}l=r<1||"B"===(i=e[r-1])?"N":n[r-1];break;case"B":d=!(w=!1),l=b;break;case"S":g=!0,l="N";break;case"LRE":case"RLE":case"LRO":case"RLO":case"PDF":w=!1;break;case"BN":l="N"}return l},L=function(t,e,n){var r=t.split("");return n&&A(r,n,{hiLevel:b}),r.reverse(),e&&e.reverse(),r.join("")},A=function(t,e,n){var r,i,o,a,s,l=-1,h=t.length,u=0,c=[],f=b?y:m,p=[];for(g=d=w=!1,i=0;i<h;i++)p[i]=x(t[i]);for(o=0;o<h;o++){if(s=u,c[o]=N(t,p,c,o),r=240&(u=f[s][v[c[o]]]),u&=15,e[o]=a=f[u][5],0<r)if(16===r){for(i=l;i<o;i++)e[i]=1;l=-1}else l=-1;if(f[u][6])-1===l&&(l=o);else if(-1<l){for(i=l;i<o;i++)e[i]=a;l=-1}"B"===p[o]&&(e[o]=0),n.hiLevel|=a}g&&function(t,e,n){for(var r=0;r<n;r++)if("S"===t[r]){e[r]=b;for(var i=r-1;0<=i&&"WS"===t[i];i--)e[i]=b}}(p,e,h)},S=function(t,e,n,r,i){if(!(i.hiLevel<t)){if(1===t&&1===b&&!d)return e.reverse(),void(n&&n.reverse());for(var o,a,s,l,h=e.length,u=0;u<h;){if(r[u]>=t){for(s=u+1;s<h&&r[s]>=t;)s++;for(l=u,a=s-1;l<a;l++,a--)o=e[l],e[l]=e[a],e[a]=o,n&&(o=n[l],n[l]=n[a],n[a]=o);u=s}u++}}},_=function(t,e,n){var r=t.split(""),i={hiLevel:b};return n||(n=[]),A(r,n,i),function(t,e,n){if(0!==n.hiLevel&&a)for(var r,i=0;i<t.length;i++)1===e[i]&&0<=(r=h.indexOf(t[i]))&&(t[i]=h[r+1])}(r,n,i),S(2,r,e,n,i),S(1,r,e,n,i),r.join("")};return this.__bidiEngine__.doBidiReorder=function(t,e,n){if(function(t,e){if(e)for(var n=0;n<t.length;n++)e[n]=n;void 0===f&&(f=p(t)),void 0===o&&(o=p(t))}(t,e),c||!i||o)if(c&&i&&f^o)b=f?1:0,t=L(t,e,n);else if(!c&&i&&o)b=f?1:0,t=_(t,e,n),t=L(t,e);else if(!c||f||i||o){if(c&&!i&&f^o)t=L(t,e),t=f?(b=0,_(t,e,n)):(b=1,t=_(t,e,n),L(t,e));else if(c&&f&&!i&&o)b=1,t=_(t,e,n),t=L(t,e);else if(!c&&!i&&f^o){var r=a;f?(b=1,t=_(t,e,n),b=0,a=!1,t=_(t,e,n),a=r):(b=0,t=_(t,e,n),t=L(t,e),a=!(b=1),t=_(t,e,n),a=r,t=L(t,e))}}else b=0,t=_(t,e,n);else b=f?1:0,t=_(t,e,n);return t},this.__bidiEngine__.setOptions=function(t){t&&(c=t.isInputVisual,i=t.isOutputVisual,f=t.isInputRtl,o=t.isOutputRtl,a=t.isSymmetricSwapping)},this.__bidiEngine__.setOptions(t),this.__bidiEngine__};var e=["BN","BN","BN","BN","BN","BN","BN","BN","BN","S","B","S","WS","B","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","B","B","B","S","WS","N","N","ET","ET","ET","N","N","N","N","N","ES","CS","ES","CS","CS","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","CS","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","BN","BN","BN","BN","BN","BN","B","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","CS","N","ET","ET","ET","ET","N","N","N","N","L","N","N","BN","N","N","ET","ET","EN","EN","N","L","N","N","N","EN","L","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","N","N","N","N","N","ET","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","R","NSM","R","NSM","NSM","R","NSM","NSM","R","NSM","N","N","N","N","N","N","N","N","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","N","N","N","N","N","R","R","R","R","R","N","N","N","N","N","N","N","N","N","N","N","AN","AN","AN","AN","AN","AN","N","N","AL","ET","ET","AL","CS","AL","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AL","AL","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AN","AN","AN","AN","AN","AN","AN","AN","AN","AN","ET","AN","AN","AL","AL","AL","NSM","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AN","N","NSM","NSM","NSM","NSM","NSM","NSM","AL","AL","NSM","NSM","N","NSM","NSM","NSM","NSM","AL","AL","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","AL","AL","NSM","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AL","N","N","N","N","N","N","N","N","N","N","N","N","N","N","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","R","R","N","N","N","N","R","N","N","N","N","N","WS","WS","WS","WS","WS","WS","WS","WS","WS","WS","WS","BN","BN","BN","L","R","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","WS","B","LRE","RLE","PDF","LRO","RLO","CS","ET","ET","ET","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","CS","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","WS","BN","BN","BN","BN","BN","N","LRI","RLI","FSI","PDI","BN","BN","BN","BN","BN","BN","EN","L","N","N","EN","EN","EN","EN","EN","EN","ES","ES","N","N","N","L","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","ES","ES","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","L","L","N","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","N","N","N","N","N","R","NSM","R","R","R","R","R","R","R","R","R","R","ES","R","R","R","R","R","R","R","R","R","R","R","R","R","N","R","R","R","R","R","N","R","N","R","R","N","R","R","N","R","R","R","R","R","R","R","R","R","R","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","CS","N","CS","N","N","CS","N","N","N","N","N","N","N","N","N","ET","N","N","ES","ES","N","N","N","N","N","ET","ET","N","N","N","N","N","AL","AL","AL","AL","AL","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","N","BN","N","N","N","ET","ET","ET","N","N","N","N","N","ES","CS","ES","CS","CS","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","CS","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","L","L","L","L","L","L","N","N","L","L","L","L","L","L","N","N","L","L","L","L","L","L","N","N","L","L","L","N","N","N","ET","ET","N","N","N","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N"],o=new t.__bidiEngine__({isInputVisual:!0});t.API.events.push(["postProcessText",function(t){var e=t.text,n=(t.x,t.y,t.options||{}),r=(t.mutex,n.lang,[]);if("[object Array]"===Object.prototype.toString.call(e)){var i=0;for(r=[],i=0;i<e.length;i+=1)"[object Array]"===Object.prototype.toString.call(e[i])?r.push([o.doBidiReorder(e[i][0]),e[i][1],e[i][2]]):r.push([o.doBidiReorder(e[i])]);t.text=r}else t.text=o.doBidiReorder(e)}])}(lt),window.tmp=_t,Ft.prototype.parseHeader=function(){if(this.fileSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.reserved=this.datav.getUint32(this.pos,!0),this.pos+=4,this.offset=this.datav.getUint32(this.pos,!0),this.pos+=4,this.headerSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.width=this.datav.getUint32(this.pos,!0),this.pos+=4,this.height=this.datav.getInt32(this.pos,!0),this.pos+=4,this.planes=this.datav.getUint16(this.pos,!0),this.pos+=2,this.bitPP=this.datav.getUint16(this.pos,!0),this.pos+=2,this.compress=this.datav.getUint32(this.pos,!0),this.pos+=4,this.rawSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.hr=this.datav.getUint32(this.pos,!0),this.pos+=4,this.vr=this.datav.getUint32(this.pos,!0),this.pos+=4,this.colors=this.datav.getUint32(this.pos,!0),this.pos+=4,this.importantColors=this.datav.getUint32(this.pos,!0),this.pos+=4,16===this.bitPP&&this.is_with_alpha&&(this.bitPP=15),this.bitPP<15){var t=0===this.colors?1<<this.bitPP:this.colors;this.palette=new Array(t);for(var e=0;e<t;e++){var n=this.datav.getUint8(this.pos++,!0),r=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),o=this.datav.getUint8(this.pos++,!0);this.palette[e]={red:i,green:r,blue:n,quad:o}}}this.height<0&&(this.height*=-1,this.bottom_up=!1)},Ft.prototype.parseBGR=function(){this.pos=this.offset;try{var t="bit"+this.bitPP,e=this.width*this.height*4;this.data=new Uint8Array(e),this[t]()}catch(t){console.log("bit decode error:"+t)}},Ft.prototype.bit1=function(){var t=Math.ceil(this.width/8),e=t%4,n=0<=this.height?this.height-1:-this.height;for(n=this.height-1;0<=n;n--){for(var r=this.bottom_up?n:this.height-1-n,i=0;i<t;i++)for(var o=this.datav.getUint8(this.pos++,!0),a=r*this.width*4+8*i*4,s=0;s<8&&8*i+s<this.width;s++){var l=this.palette[o>>7-s&1];this.data[a+4*s]=l.blue,this.data[a+4*s+1]=l.green,this.data[a+4*s+2]=l.red,this.data[a+4*s+3]=255}0!=e&&(this.pos+=4-e)}},Ft.prototype.bit4=function(){for(var t=Math.ceil(this.width/2),e=t%4,n=this.height-1;0<=n;n--){for(var r=this.bottom_up?n:this.height-1-n,i=0;i<t;i++){var o=this.datav.getUint8(this.pos++,!0),a=r*this.width*4+2*i*4,s=o>>4,l=15&o,h=this.palette[s];if(this.data[a]=h.blue,this.data[a+1]=h.green,this.data[a+2]=h.red,this.data[a+3]=255,2*i+1>=this.width)break;h=this.palette[l],this.data[a+4]=h.blue,this.data[a+4+1]=h.green,this.data[a+4+2]=h.red,this.data[a+4+3]=255}0!=e&&(this.pos+=4-e)}},Ft.prototype.bit8=function(){for(var t=this.width%4,e=this.height-1;0<=e;e--){for(var n=this.bottom_up?e:this.height-1-e,r=0;r<this.width;r++){var i=this.datav.getUint8(this.pos++,!0),o=n*this.width*4+4*r;if(i<this.palette.length){var a=this.palette[i];this.data[o]=a.red,this.data[o+1]=a.green,this.data[o+2]=a.blue,this.data[o+3]=255}else this.data[o]=255,this.data[o+1]=255,this.data[o+2]=255,this.data[o+3]=255}0!=t&&(this.pos+=4-t)}},Ft.prototype.bit15=function(){for(var t=this.width%3,e=parseInt("11111",2),n=this.height-1;0<=n;n--){for(var r=this.bottom_up?n:this.height-1-n,i=0;i<this.width;i++){var o=this.datav.getUint16(this.pos,!0);this.pos+=2;var a=(o&e)/e*255|0,s=(o>>5&e)/e*255|0,l=(o>>10&e)/e*255|0,h=o>>15?255:0,u=r*this.width*4+4*i;this.data[u]=l,this.data[u+1]=s,this.data[u+2]=a,this.data[u+3]=h}this.pos+=t}},Ft.prototype.bit16=function(){for(var t=this.width%3,e=parseInt("11111",2),n=parseInt("111111",2),r=this.height-1;0<=r;r--){for(var i=this.bottom_up?r:this.height-1-r,o=0;o<this.width;o++){var a=this.datav.getUint16(this.pos,!0);this.pos+=2;var s=(a&e)/e*255|0,l=(a>>5&n)/n*255|0,h=(a>>11)/e*255|0,u=i*this.width*4+4*o;this.data[u]=h,this.data[u+1]=l,this.data[u+2]=s,this.data[u+3]=255}this.pos+=t}},Ft.prototype.bit24=function(){for(var t=this.height-1;0<=t;t--){for(var e=this.bottom_up?t:this.height-1-t,n=0;n<this.width;n++){var r=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),o=this.datav.getUint8(this.pos++,!0),a=e*this.width*4+4*n;this.data[a]=o,this.data[a+1]=i,this.data[a+2]=r,this.data[a+3]=255}this.pos+=this.width%4}},Ft.prototype.bit32=function(){for(var t=this.height-1;0<=t;t--)for(var e=this.bottom_up?t:this.height-1-t,n=0;n<this.width;n++){var r=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),o=this.datav.getUint8(this.pos++,!0),a=this.datav.getUint8(this.pos++,!0),s=e*this.width*4+4*n;this.data[s]=o,this.data[s+1]=i,this.data[s+2]=r,this.data[s+3]=a}},Ft.prototype.getData=function(){return this.data},window.tmp=Ft,
/*
   Copyright (c) 2013 Gildas Lormeau. All rights reserved.

   Redistribution and use in source and binary forms, with or without
   modification, are permitted provided that the following conditions are met:

   1. Redistributions of source code must retain the above copyright notice,
   this list of conditions and the following disclaimer.

   2. Redistributions in binary form must reproduce the above copyright 
   notice, this list of conditions and the following disclaimer in 
   the documentation and/or other materials provided with the distribution.

   3. The names of the authors may not be used to endorse or promote products
   derived from this software without specific prior written permission.

   THIS SOFTWARE IS PROVIDED ``AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
   INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
   FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
   INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
   INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
   LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
   OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
   EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
   */
function(t){var d=15,g=573,e=[0,1,2,3,4,4,5,5,6,6,6,6,7,7,7,7,8,8,8,8,8,8,8,8,9,9,9,9,9,9,9,9,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,0,0,16,17,18,18,19,19,20,20,20,20,21,21,21,21,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29];function ct(){var p=this;function l(t,e){for(var n=0;n|=1&t,t>>>=1,n<<=1,0<--e;);return n>>>1}p.build_tree=function(t){var e,n,r,i=p.dyn_tree,o=p.stat_desc.static_tree,a=p.stat_desc.elems,s=-1;for(t.heap_len=0,t.heap_max=g,e=0;e<a;e++)0!==i[2*e]?(t.heap[++t.heap_len]=s=e,t.depth[e]=0):i[2*e+1]=0;for(;t.heap_len<2;)i[2*(r=t.heap[++t.heap_len]=s<2?++s:0)]=1,t.depth[r]=0,t.opt_len--,o&&(t.static_len-=o[2*r+1]);for(p.max_code=s,e=Math.floor(t.heap_len/2);1<=e;e--)t.pqdownheap(i,e);for(r=a;e=t.heap[1],t.heap[1]=t.heap[t.heap_len--],t.pqdownheap(i,1),n=t.heap[1],t.heap[--t.heap_max]=e,t.heap[--t.heap_max]=n,i[2*r]=i[2*e]+i[2*n],t.depth[r]=Math.max(t.depth[e],t.depth[n])+1,i[2*e+1]=i[2*n+1]=r,t.heap[1]=r++,t.pqdownheap(i,1),2<=t.heap_len;);t.heap[--t.heap_max]=t.heap[1],function(t){var e,n,r,i,o,a,s=p.dyn_tree,l=p.stat_desc.static_tree,h=p.stat_desc.extra_bits,u=p.stat_desc.extra_base,c=p.stat_desc.max_length,f=0;for(i=0;i<=d;i++)t.bl_count[i]=0;for(s[2*t.heap[t.heap_max]+1]=0,e=t.heap_max+1;e<g;e++)c<(i=s[2*s[2*(n=t.heap[e])+1]+1]+1)&&(i=c,f++),s[2*n+1]=i,n>p.max_code||(t.bl_count[i]++,o=0,u<=n&&(o=h[n-u]),a=s[2*n],t.opt_len+=a*(i+o),l&&(t.static_len+=a*(l[2*n+1]+o)));if(0!==f){do{for(i=c-1;0===t.bl_count[i];)i--;t.bl_count[i]--,t.bl_count[i+1]+=2,t.bl_count[c]--,f-=2}while(0<f);for(i=c;0!==i;i--)for(n=t.bl_count[i];0!==n;)(r=t.heap[--e])>p.max_code||(s[2*r+1]!=i&&(t.opt_len+=(i-s[2*r+1])*s[2*r],s[2*r+1]=i),n--)}}(t),function(t,e,n){var r,i,o,a=[],s=0;for(r=1;r<=d;r++)a[r]=s=s+n[r-1]<<1;for(i=0;i<=e;i++)0!==(o=t[2*i+1])&&(t[2*i]=l(a[o]++,o))}(i,p.max_code,t.bl_count)}}function ft(t,e,n,r,i){this.static_tree=t,this.extra_bits=e,this.extra_base=n,this.elems=r,this.max_length=i}ct._length_code=[0,1,2,3,4,5,6,7,8,8,9,9,10,10,11,11,12,12,12,12,13,13,13,13,14,14,14,14,15,15,15,15,16,16,16,16,16,16,16,16,17,17,17,17,17,17,17,17,18,18,18,18,18,18,18,18,19,19,19,19,19,19,19,19,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28],ct.base_length=[0,1,2,3,4,5,6,7,8,10,12,14,16,20,24,28,32,40,48,56,64,80,96,112,128,160,192,224,0],ct.base_dist=[0,1,2,3,4,6,8,12,16,24,32,48,64,96,128,192,256,384,512,768,1024,1536,2048,3072,4096,6144,8192,12288,16384,24576],ct.d_code=function(t){return t<256?e[t]:e[256+(t>>>7)]},ct.extra_lbits=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],ct.extra_dbits=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],ct.extra_blbits=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],ct.bl_order=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],ft.static_ltree=[12,8,140,8,76,8,204,8,44,8,172,8,108,8,236,8,28,8,156,8,92,8,220,8,60,8,188,8,124,8,252,8,2,8,130,8,66,8,194,8,34,8,162,8,98,8,226,8,18,8,146,8,82,8,210,8,50,8,178,8,114,8,242,8,10,8,138,8,74,8,202,8,42,8,170,8,106,8,234,8,26,8,154,8,90,8,218,8,58,8,186,8,122,8,250,8,6,8,134,8,70,8,198,8,38,8,166,8,102,8,230,8,22,8,150,8,86,8,214,8,54,8,182,8,118,8,246,8,14,8,142,8,78,8,206,8,46,8,174,8,110,8,238,8,30,8,158,8,94,8,222,8,62,8,190,8,126,8,254,8,1,8,129,8,65,8,193,8,33,8,161,8,97,8,225,8,17,8,145,8,81,8,209,8,49,8,177,8,113,8,241,8,9,8,137,8,73,8,201,8,41,8,169,8,105,8,233,8,25,8,153,8,89,8,217,8,57,8,185,8,121,8,249,8,5,8,133,8,69,8,197,8,37,8,165,8,101,8,229,8,21,8,149,8,85,8,213,8,53,8,181,8,117,8,245,8,13,8,141,8,77,8,205,8,45,8,173,8,109,8,237,8,29,8,157,8,93,8,221,8,61,8,189,8,125,8,253,8,19,9,275,9,147,9,403,9,83,9,339,9,211,9,467,9,51,9,307,9,179,9,435,9,115,9,371,9,243,9,499,9,11,9,267,9,139,9,395,9,75,9,331,9,203,9,459,9,43,9,299,9,171,9,427,9,107,9,363,9,235,9,491,9,27,9,283,9,155,9,411,9,91,9,347,9,219,9,475,9,59,9,315,9,187,9,443,9,123,9,379,9,251,9,507,9,7,9,263,9,135,9,391,9,71,9,327,9,199,9,455,9,39,9,295,9,167,9,423,9,103,9,359,9,231,9,487,9,23,9,279,9,151,9,407,9,87,9,343,9,215,9,471,9,55,9,311,9,183,9,439,9,119,9,375,9,247,9,503,9,15,9,271,9,143,9,399,9,79,9,335,9,207,9,463,9,47,9,303,9,175,9,431,9,111,9,367,9,239,9,495,9,31,9,287,9,159,9,415,9,95,9,351,9,223,9,479,9,63,9,319,9,191,9,447,9,127,9,383,9,255,9,511,9,0,7,64,7,32,7,96,7,16,7,80,7,48,7,112,7,8,7,72,7,40,7,104,7,24,7,88,7,56,7,120,7,4,7,68,7,36,7,100,7,20,7,84,7,52,7,116,7,3,8,131,8,67,8,195,8,35,8,163,8,99,8,227,8],ft.static_dtree=[0,5,16,5,8,5,24,5,4,5,20,5,12,5,28,5,2,5,18,5,10,5,26,5,6,5,22,5,14,5,30,5,1,5,17,5,9,5,25,5,5,5,21,5,13,5,29,5,3,5,19,5,11,5,27,5,7,5,23,5],ft.static_l_desc=new ft(ft.static_ltree,ct.extra_lbits,257,286,d),ft.static_d_desc=new ft(ft.static_dtree,ct.extra_dbits,0,30,d),ft.static_bl_desc=new ft(null,ct.extra_blbits,0,19,7);function n(t,e,n,r,i){this.good_length=t,this.max_lazy=e,this.nice_length=n,this.max_chain=r,this.func=i}var pt=[new n(0,0,0,0,0),new n(4,4,8,4,1),new n(4,5,16,8,1),new n(4,6,32,32,1),new n(4,4,16,16,2),new n(8,16,32,32,2),new n(8,16,128,128,2),new n(8,32,128,256,2),new n(32,128,258,1024,2),new n(32,258,258,4096,2)],dt=["need dictionary","stream end","","","stream error","data error","","buffer error","",""];function gt(t,e,n,r){var i=t[2*e],o=t[2*n];return i<o||i==o&&r[e]<=r[n]}function r(){var l,h,u,c,f,p,d,g,i,m,y,v,w,a,b,x,N,L,A,S,_,F,P,k,I,C,B,j,E,M,s,O,q,T,R,D,U,o,z,H,W,V=this,G=new ct,Y=new ct,J=new ct;function X(){var t;for(t=0;t<286;t++)s[2*t]=0;for(t=0;t<30;t++)O[2*t]=0;for(t=0;t<19;t++)q[2*t]=0;s[512]=1,V.opt_len=V.static_len=0,D=o=0}function K(t,e){var n,r,i=-1,o=t[1],a=0,s=7,l=4;for(0===o&&(s=138,l=3),t[2*(e+1)+1]=65535,n=0;n<=e;n++)r=o,o=t[2*(n+1)+1],++a<s&&r==o||(a<l?q[2*r]+=a:0!==r?(r!=i&&q[2*r]++,q[32]++):a<=10?q[34]++:q[36]++,i=r,l=(a=0)===o?(s=138,3):r==o?(s=6,3):(s=7,4))}function Z(t){V.pending_buf[V.pending++]=t}function Q(t){Z(255&t),Z(t>>>8&255)}function $(t,e){var n,r=e;16-r<W?(Q(H|=(n=t)<<W&65535),H=n>>>16-W,W+=r-16):(H|=t<<W&65535,W+=r)}function tt(t,e){var n=2*t;$(65535&e[n],65535&e[n+1])}function et(t,e){var n,r,i=-1,o=t[1],a=0,s=7,l=4;for(0===o&&(s=138,l=3),n=0;n<=e;n++)if(r=o,o=t[2*(n+1)+1],!(++a<s&&r==o)){if(a<l)for(;tt(r,q),0!=--a;);else 0!==r?(r!=i&&(tt(r,q),a--),tt(16,q),$(a-3,2)):a<=10?(tt(17,q),$(a-3,3)):(tt(18,q),$(a-11,7));i=r,l=(a=0)===o?(s=138,3):r==o?(s=6,3):(s=7,4)}}function nt(){16==W?(Q(H),W=H=0):8<=W&&(Z(255&H),H>>>=8,W-=8)}function rt(t,e){var n,r,i;if(V.pending_buf[U+2*D]=t>>>8&255,V.pending_buf[U+2*D+1]=255&t,V.pending_buf[T+D]=255&e,D++,0===t?s[2*e]++:(o++,t--,s[2*(ct._length_code[e]+256+1)]++,O[2*ct.d_code(t)]++),0==(8191&D)&&2<B){for(n=8*D,r=_-N,i=0;i<30;i++)n+=O[2*i]*(5+ct.extra_dbits[i]);if(n>>>=3,o<Math.floor(D/2)&&n<Math.floor(r/2))return!0}return D==R-1}function it(t,e){var n,r,i,o,a=0;if(0!==D)for(;n=V.pending_buf[U+2*a]<<8&65280|255&V.pending_buf[U+2*a+1],r=255&V.pending_buf[T+a],a++,0===n?tt(r,t):(tt((i=ct._length_code[r])+256+1,t),0!==(o=ct.extra_lbits[i])&&$(r-=ct.base_length[i],o),tt(i=ct.d_code(--n),e),0!==(o=ct.extra_dbits[i])&&$(n-=ct.base_dist[i],o)),a<D;);tt(256,t),z=t[513]}function ot(){8<W?Q(H):0<W&&Z(255&H),W=H=0}function at(t,e,n){var r,i,o;$(0+(n?1:0),3),r=t,i=e,o=!0,ot(),z=8,o&&(Q(i),Q(~i)),V.pending_buf.set(g.subarray(r,r+i),V.pending),V.pending+=i}function e(t,e,n){var r,i,o=0;0<B?(G.build_tree(V),Y.build_tree(V),o=function(){var t;for(K(s,G.max_code),K(O,Y.max_code),J.build_tree(V),t=18;3<=t&&0===q[2*ct.bl_order[t]+1];t--);return V.opt_len+=3*(t+1)+5+5+4,t}(),r=V.opt_len+3+7>>>3,(i=V.static_len+3+7>>>3)<=r&&(r=i)):r=i=e+5,e+4<=r&&-1!=t?at(t,e,n):i==r?($(2+(n?1:0),3),it(ft.static_ltree,ft.static_dtree)):($(4+(n?1:0),3),function(t,e,n){var r;for($(t-257,5),$(e-1,5),$(n-4,4),r=0;r<n;r++)$(q[2*ct.bl_order[r]+1],3);et(s,t-1),et(O,e-1)}(G.max_code+1,Y.max_code+1,o+1),it(s,O)),X(),n&&ot()}function st(t){e(0<=N?N:-1,_-N,t),N=_,l.flush_pending()}function lt(){var t,e,n,r;do{if(0===(r=i-P-_)&&0===_&&0===P)r=f;else if(-1==r)r--;else if(f+f-262<=_){for(g.set(g.subarray(f,f+f),0),F-=f,_-=f,N-=f,n=t=w;e=65535&y[--n],y[n]=f<=e?e-f:0,0!=--t;);for(n=t=f;e=65535&m[--n],m[n]=f<=e?e-f:0,0!=--t;);r+=f}if(0===l.avail_in)return;t=l.read_buf(g,_+P,r),3<=(P+=t)&&(v=((v=255&g[_])<<x^255&g[_+1])&b)}while(P<262&&0!==l.avail_in)}function ht(t){var e,n,r=I,i=_,o=k,a=f-262<_?_-(f-262):0,s=M,l=d,h=_+258,u=g[i+o-1],c=g[i+o];E<=k&&(r>>=2),P<s&&(s=P);do{if(g[(e=t)+o]==c&&g[e+o-1]==u&&g[e]==g[i]&&g[++e]==g[i+1]){i+=2,e++;do{}while(g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&i<h);if(n=258-(h-i),i=h-258,o<n){if(F=t,s<=(o=n))break;u=g[i+o-1],c=g[i+o]}}}while((t=65535&m[t&l])>a&&0!=--r);return o<=P?o:P}function ut(t){return t.total_in=t.total_out=0,t.msg=null,V.pending=0,V.pending_out=0,h=113,c=0,G.dyn_tree=s,G.stat_desc=ft.static_l_desc,Y.dyn_tree=O,Y.stat_desc=ft.static_d_desc,J.dyn_tree=q,J.stat_desc=ft.static_bl_desc,W=H=0,z=8,X(),function(){var t;for(i=2*f,t=y[w-1]=0;t<w-1;t++)y[t]=0;C=pt[B].max_lazy,E=pt[B].good_length,M=pt[B].nice_length,I=pt[B].max_chain,L=k=2,v=S=P=N=_=0}(),0}V.depth=[],V.bl_count=[],V.heap=[],s=[],O=[],q=[],V.pqdownheap=function(t,e){for(var n=V.heap,r=n[e],i=e<<1;i<=V.heap_len&&(i<V.heap_len&&gt(t,n[i+1],n[i],V.depth)&&i++,!gt(t,r,n[i],V.depth));)n[e]=n[i],e=i,i<<=1;n[e]=r},V.deflateInit=function(t,e,n,r,i,o){return r||(r=8),i||(i=8),o||(o=0),t.msg=null,-1==e&&(e=6),i<1||9<i||8!=r||n<9||15<n||e<0||9<e||o<0||2<o?-2:(t.dstate=V,d=(f=1<<(p=n))-1,b=(w=1<<(a=i+7))-1,x=Math.floor((a+3-1)/3),g=new Uint8Array(2*f),m=[],y=[],R=1<<i+6,V.pending_buf=new Uint8Array(4*R),u=4*R,U=Math.floor(R/2),T=3*R,B=e,j=o,ut(t))},V.deflateEnd=function(){return 42!=h&&113!=h&&666!=h?-2:(V.pending_buf=null,g=m=y=null,V.dstate=null,113==h?-3:0)},V.deflateParams=function(t,e,n){var r=0;return-1==e&&(e=6),e<0||9<e||n<0||2<n?-2:(pt[B].func!=pt[e].func&&0!==t.total_in&&(r=t.deflate(1)),B!=e&&(C=pt[B=e].max_lazy,E=pt[B].good_length,M=pt[B].nice_length,I=pt[B].max_chain),j=n,r)},V.deflateSetDictionary=function(t,e,n){var r,i=n,o=0;if(!e||42!=h)return-2;if(i<3)return 0;for(f-262<i&&(o=n-(i=f-262)),g.set(e.subarray(o,o+i),0),N=_=i,v=((v=255&g[0])<<x^255&g[1])&b,r=0;r<=i-3;r++)v=(v<<x^255&g[r+2])&b,m[r&d]=y[v],y[v]=r;return 0},V.deflate=function(t,e){var n,r,i,o,a,s;if(4<e||e<0)return-2;if(!t.next_out||!t.next_in&&0!==t.avail_in||666==h&&4!=e)return t.msg=dt[4],-2;if(0===t.avail_out)return t.msg=dt[7],-5;if(l=t,o=c,c=e,42==h&&(r=8+(p-8<<4)<<8,3<(i=(B-1&255)>>1)&&(i=3),r|=i<<6,0!==_&&(r|=32),h=113,Z((s=r+=31-r%31)>>8&255),Z(255&s)),0!==V.pending){if(l.flush_pending(),0===l.avail_out)return c=-1,0}else if(0===l.avail_in&&e<=o&&4!=e)return l.msg=dt[7],-5;if(666==h&&0!==l.avail_in)return t.msg=dt[7],-5;if(0!==l.avail_in||0!==P||0!=e&&666!=h){switch(a=-1,pt[B].func){case 0:a=function(t){var e,n=65535;for(u-5<n&&(n=u-5);;){if(P<=1){if(lt(),0===P&&0==t)return 0;if(0===P)break}if(_+=P,e=N+n,((P=0)===_||e<=_)&&(P=_-e,_=e,st(!1),0===l.avail_out))return 0;if(f-262<=_-N&&(st(!1),0===l.avail_out))return 0}return st(4==t),0===l.avail_out?4==t?2:0:4==t?3:1}(e);break;case 1:a=function(t){for(var e,n=0;;){if(P<262){if(lt(),P<262&&0==t)return 0;if(0===P)break}if(3<=P&&(v=(v<<x^255&g[_+2])&b,n=65535&y[v],m[_&d]=y[v],y[v]=_),0!==n&&(_-n&65535)<=f-262&&2!=j&&(L=ht(n)),3<=L)if(e=rt(_-F,L-3),P-=L,L<=C&&3<=P){for(L--;v=(v<<x^255&g[++_+2])&b,n=65535&y[v],m[_&d]=y[v],y[v]=_,0!=--L;);_++}else _+=L,L=0,v=((v=255&g[_])<<x^255&g[_+1])&b;else e=rt(0,255&g[_]),P--,_++;if(e&&(st(!1),0===l.avail_out))return 0}return st(4==t),0===l.avail_out?4==t?2:0:4==t?3:1}(e);break;case 2:a=function(t){for(var e,n,r=0;;){if(P<262){if(lt(),P<262&&0==t)return 0;if(0===P)break}if(3<=P&&(v=(v<<x^255&g[_+2])&b,r=65535&y[v],m[_&d]=y[v],y[v]=_),k=L,A=F,L=2,0!==r&&k<C&&(_-r&65535)<=f-262&&(2!=j&&(L=ht(r)),L<=5&&(1==j||3==L&&4096<_-F)&&(L=2)),3<=k&&L<=k){for(n=_+P-3,e=rt(_-1-A,k-3),P-=k-1,k-=2;++_<=n&&(v=(v<<x^255&g[_+2])&b,r=65535&y[v],m[_&d]=y[v],y[v]=_),0!=--k;);if(S=0,L=2,_++,e&&(st(!1),0===l.avail_out))return 0}else if(0!==S){if((e=rt(0,255&g[_-1]))&&st(!1),_++,P--,0===l.avail_out)return 0}else S=1,_++,P--}return 0!==S&&(e=rt(0,255&g[_-1]),S=0),st(4==t),0===l.avail_out?4==t?2:0:4==t?3:1}(e)}if(2!=a&&3!=a||(h=666),0==a||2==a)return 0===l.avail_out&&(c=-1),0;if(1==a){if(1==e)$(2,3),tt(256,ft.static_ltree),nt(),1+z+10-W<9&&($(2,3),tt(256,ft.static_ltree),nt()),z=7;else if(at(0,0,!1),3==e)for(n=0;n<w;n++)y[n]=0;if(l.flush_pending(),0===l.avail_out)return c=-1,0}}return 4!=e?0:1}}function i(){this.next_in_index=0,this.next_out_index=0,this.avail_in=0,this.total_in=0,this.avail_out=0,this.total_out=0}i.prototype={deflateInit:function(t,e){return this.dstate=new r,e||(e=d),this.dstate.deflateInit(this,t,e)},deflate:function(t){return this.dstate?this.dstate.deflate(this,t):-2},deflateEnd:function(){if(!this.dstate)return-2;var t=this.dstate.deflateEnd();return this.dstate=null,t},deflateParams:function(t,e){return this.dstate?this.dstate.deflateParams(this,t,e):-2},deflateSetDictionary:function(t,e){return this.dstate?this.dstate.deflateSetDictionary(this,t,e):-2},read_buf:function(t,e,n){var r=this.avail_in;return n<r&&(r=n),0===r?0:(this.avail_in-=r,t.set(this.next_in.subarray(this.next_in_index,this.next_in_index+r),e),this.next_in_index+=r,this.total_in+=r,r)},flush_pending:function(){var t=this,e=t.dstate.pending;e>t.avail_out&&(e=t.avail_out),0!==e&&(t.next_out.set(t.dstate.pending_buf.subarray(t.dstate.pending_out,t.dstate.pending_out+e),t.next_out_index),t.next_out_index+=e,t.dstate.pending_out+=e,t.total_out+=e,t.avail_out-=e,t.dstate.pending-=e,0===t.dstate.pending&&(t.dstate.pending_out=0))}};var o=t.zip||t;o.Deflater=o._jzlib_Deflater=function(t){var s=new i,l=new Uint8Array(512),e=t?t.level:-1;void 0===e&&(e=-1),s.deflateInit(e),s.next_out=l,this.append=function(t,e){var n,r=[],i=0,o=0,a=0;if(t.length){s.next_in_index=0,s.next_in=t,s.avail_in=t.length;do{if(s.next_out_index=0,s.avail_out=512,0!=s.deflate(0))throw new Error("deflating: "+s.msg);s.next_out_index&&(512==s.next_out_index?r.push(new Uint8Array(l)):r.push(new Uint8Array(l.subarray(0,s.next_out_index)))),a+=s.next_out_index,e&&0<s.next_in_index&&s.next_in_index!=i&&(e(s.next_in_index),i=s.next_in_index)}while(0<s.avail_in||0===s.avail_out);return n=new Uint8Array(a),r.forEach(function(t){n.set(t,o),o+=t.length}),n}},this.flush=function(){var t,e,n=[],r=0,i=0;do{if(s.next_out_index=0,s.avail_out=512,1!=(t=s.deflate(4))&&0!=t)throw new Error("deflating: "+s.msg);0<512-s.avail_out&&n.push(new Uint8Array(l.subarray(0,s.next_out_index))),i+=s.next_out_index}while(0<s.avail_in||0===s.avail_out);return s.deflateEnd(),e=new Uint8Array(i),n.forEach(function(t){e.set(t,r),r+=t.length}),e}}}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()),("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()).RGBColor=function(t){var e;t=t||"",this.ok=!1,"#"==t.charAt(0)&&(t=t.substr(1,6)),t=(t=t.replace(/ /g,"")).toLowerCase();var n={aliceblue:"f0f8ff",antiquewhite:"faebd7",aqua:"00ffff",aquamarine:"7fffd4",azure:"f0ffff",beige:"f5f5dc",bisque:"ffe4c4",black:"000000",blanchedalmond:"ffebcd",blue:"0000ff",blueviolet:"8a2be2",brown:"a52a2a",burlywood:"deb887",cadetblue:"5f9ea0",chartreuse:"7fff00",chocolate:"d2691e",coral:"ff7f50",cornflowerblue:"6495ed",cornsilk:"fff8dc",crimson:"dc143c",cyan:"00ffff",darkblue:"00008b",darkcyan:"008b8b",darkgoldenrod:"b8860b",darkgray:"a9a9a9",darkgreen:"006400",darkkhaki:"bdb76b",darkmagenta:"8b008b",darkolivegreen:"556b2f",darkorange:"ff8c00",darkorchid:"9932cc",darkred:"8b0000",darksalmon:"e9967a",darkseagreen:"8fbc8f",darkslateblue:"483d8b",darkslategray:"2f4f4f",darkturquoise:"00ced1",darkviolet:"9400d3",deeppink:"ff1493",deepskyblue:"00bfff",dimgray:"696969",dodgerblue:"1e90ff",feldspar:"d19275",firebrick:"b22222",floralwhite:"fffaf0",forestgreen:"228b22",fuchsia:"ff00ff",gainsboro:"dcdcdc",ghostwhite:"f8f8ff",gold:"ffd700",goldenrod:"daa520",gray:"808080",green:"008000",greenyellow:"adff2f",honeydew:"f0fff0",hotpink:"ff69b4",indianred:"cd5c5c",indigo:"4b0082",ivory:"fffff0",khaki:"f0e68c",lavender:"e6e6fa",lavenderblush:"fff0f5",lawngreen:"7cfc00",lemonchiffon:"fffacd",lightblue:"add8e6",lightcoral:"f08080",lightcyan:"e0ffff",lightgoldenrodyellow:"fafad2",lightgrey:"d3d3d3",lightgreen:"90ee90",lightpink:"ffb6c1",lightsalmon:"ffa07a",lightseagreen:"20b2aa",lightskyblue:"87cefa",lightslateblue:"8470ff",lightslategray:"778899",lightsteelblue:"b0c4de",lightyellow:"ffffe0",lime:"00ff00",limegreen:"32cd32",linen:"faf0e6",magenta:"ff00ff",maroon:"800000",mediumaquamarine:"66cdaa",mediumblue:"0000cd",mediumorchid:"ba55d3",mediumpurple:"9370d8",mediumseagreen:"3cb371",mediumslateblue:"7b68ee",mediumspringgreen:"00fa9a",mediumturquoise:"48d1cc",mediumvioletred:"c71585",midnightblue:"191970",mintcream:"f5fffa",mistyrose:"ffe4e1",moccasin:"ffe4b5",navajowhite:"ffdead",navy:"000080",oldlace:"fdf5e6",olive:"808000",olivedrab:"6b8e23",orange:"ffa500",orangered:"ff4500",orchid:"da70d6",palegoldenrod:"eee8aa",palegreen:"98fb98",paleturquoise:"afeeee",palevioletred:"d87093",papayawhip:"ffefd5",peachpuff:"ffdab9",peru:"cd853f",pink:"ffc0cb",plum:"dda0dd",powderblue:"b0e0e6",purple:"800080",red:"ff0000",rosybrown:"bc8f8f",royalblue:"4169e1",saddlebrown:"8b4513",salmon:"fa8072",sandybrown:"f4a460",seagreen:"2e8b57",seashell:"fff5ee",sienna:"a0522d",silver:"c0c0c0",skyblue:"87ceeb",slateblue:"6a5acd",slategray:"708090",snow:"fffafa",springgreen:"00ff7f",steelblue:"4682b4",tan:"d2b48c",teal:"008080",thistle:"d8bfd8",tomato:"ff6347",turquoise:"40e0d0",violet:"ee82ee",violetred:"d02090",wheat:"f5deb3",white:"ffffff",whitesmoke:"f5f5f5",yellow:"ffff00",yellowgreen:"9acd32"};for(var r in n)t==r&&(t=n[r]);for(var i=[{re:/^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,example:["rgb(123, 234, 45)","rgb(255,234,245)"],process:function(t){return[parseInt(t[1]),parseInt(t[2]),parseInt(t[3])]}},{re:/^(\w{2})(\w{2})(\w{2})$/,example:["#00ff00","336699"],process:function(t){return[parseInt(t[1],16),parseInt(t[2],16),parseInt(t[3],16)]}},{re:/^(\w{1})(\w{1})(\w{1})$/,example:["#fb0","f0f"],process:function(t){return[parseInt(t[1]+t[1],16),parseInt(t[2]+t[2],16),parseInt(t[3]+t[3],16)]}}],o=0;o<i.length;o++){var a=i[o].re,s=i[o].process,l=a.exec(t);l&&(e=s(l),this.r=e[0],this.g=e[1],this.b=e[2],this.ok=!0)}this.r=this.r<0||isNaN(this.r)?0:255<this.r?255:this.r,this.g=this.g<0||isNaN(this.g)?0:255<this.g?255:this.g,this.b=this.b<0||isNaN(this.b)?0:255<this.b?255:this.b,this.toRGB=function(){return"rgb("+this.r+", "+this.g+", "+this.b+")"},this.toHex=function(){var t=this.r.toString(16),e=this.g.toString(16),n=this.b.toString(16);return 1==t.length&&(t="0"+t),1==e.length&&(e="0"+e),1==n.length&&(n="0"+n),"#"+t+e+n}},function(t){var n="+".charCodeAt(0),r="/".charCodeAt(0),i="0".charCodeAt(0),o="a".charCodeAt(0),a="A".charCodeAt(0),s="-".charCodeAt(0),l="_".charCodeAt(0),u=function(t){var e=t.charCodeAt(0);return e===n||e===s?62:e===r||e===l?63:e<i?-1:e<i+10?e-i+26+26:e<a+26?e-a:e<o+26?e-o+26:void 0};t.API.TTFFont=function(){function i(t,e,n){var r;if(this.rawData=t,r=this.contents=new J(t),this.contents.pos=4,"ttcf"===r.readString(4)){if(!e)throw new Error("Must specify a font name for TTC files.");throw new Error("Font "+e+" not found in TTC file.")}r.pos=0,this.parse(),this.subset=new P(this),this.registerTTF()}return i.open=function(t,e,n,r){if("string"!=typeof n)throw new Error("Invalid argument supplied in TTFFont.open");return new i(function(t){var e,n,r,i,o,a;if(0<t.length%4)throw new Error("Invalid string. Length must be a multiple of 4");var s=t.length;o="="===t.charAt(s-2)?2:"="===t.charAt(s-1)?1:0,a=new Uint8Array(3*t.length/4-o),r=0<o?t.length-4:t.length;var l=0;function h(t){a[l++]=t}for(n=e=0;e<r;e+=4,n+=3)h((16711680&(i=u(t.charAt(e))<<18|u(t.charAt(e+1))<<12|u(t.charAt(e+2))<<6|u(t.charAt(e+3))))>>16),h((65280&i)>>8),h(255&i);return 2===o?h(255&(i=u(t.charAt(e))<<2|u(t.charAt(e+1))>>4)):1===o&&(h((i=u(t.charAt(e))<<10|u(t.charAt(e+1))<<4|u(t.charAt(e+2))>>2)>>8&255),h(255&i)),a}(n),e,r)},i.prototype.parse=function(){return this.directory=new e(this.contents),this.head=new p(this),this.name=new b(this),this.cmap=new y(this),this.toUnicode=new Map,this.hhea=new g(this),this.maxp=new x(this),this.hmtx=new N(this),this.post=new v(this),this.os2=new m(this),this.loca=new F(this),this.glyf=new A(this),this.ascender=this.os2.exists&&this.os2.ascender||this.hhea.ascender,this.decender=this.os2.exists&&this.os2.decender||this.hhea.decender,this.lineGap=this.os2.exists&&this.os2.lineGap||this.hhea.lineGap,this.bbox=[this.head.xMin,this.head.yMin,this.head.xMax,this.head.yMax]},i.prototype.registerTTF=function(){var i,t,e,n,r;if(this.scaleFactor=1e3/this.head.unitsPerEm,this.bbox=function(){var t,e,n,r;for(r=[],t=0,e=(n=this.bbox).length;t<e;t++)i=n[t],r.push(Math.round(i*this.scaleFactor));return r}.call(this),this.stemV=0,this.post.exists?(e=255&(n=this.post.italic_angle),!0&(t=n>>16)&&(t=-(1+(65535^t))),this.italicAngle=+(t+"."+e)):this.italicAngle=0,this.ascender=Math.round(this.ascender*this.scaleFactor),this.decender=Math.round(this.decender*this.scaleFactor),this.lineGap=Math.round(this.lineGap*this.scaleFactor),this.capHeight=this.os2.exists&&this.os2.capHeight||this.ascender,this.xHeight=this.os2.exists&&this.os2.xHeight||0,this.familyClass=(this.os2.exists&&this.os2.familyClass||0)>>8,this.isSerif=1===(r=this.familyClass)||2===r||3===r||4===r||5===r||7===r,this.isScript=10===this.familyClass,this.flags=0,this.post.isFixedPitch&&(this.flags|=1),this.isSerif&&(this.flags|=2),this.isScript&&(this.flags|=8),0!==this.italicAngle&&(this.flags|=64),this.flags|=32,!this.cmap.unicode)throw new Error("No unicode cmap for font")},i.prototype.characterToGlyph=function(t){var e;return(null!=(e=this.cmap.unicode)?e.codeMap[t]:void 0)||0},i.prototype.widthOfGlyph=function(t){var e;return e=1e3/this.head.unitsPerEm,this.hmtx.forGlyph(t).advance*e},i.prototype.widthOfString=function(t,e,n){var r,i,o,a,s;for(i=a=o=0,s=(t=""+t).length;0<=s?a<s:s<a;i=0<=s?++a:--a)r=t.charCodeAt(i),o+=this.widthOfGlyph(this.characterToGlyph(r))+n*(1e3/e)||0;return o*(e/1e3)},i.prototype.lineHeight=function(t,e){var n;return null==e&&(e=!1),n=e?this.lineGap:0,(this.ascender+n-this.decender)/1e3*t},i}();var h,J=function(){function t(t){this.data=null!=t?t:[],this.pos=0,this.length=this.data.length}return t.prototype.readByte=function(){return this.data[this.pos++]},t.prototype.writeByte=function(t){return this.data[this.pos++]=t},t.prototype.readUInt32=function(){return 16777216*this.readByte()+(this.readByte()<<16)+(this.readByte()<<8)+this.readByte()},t.prototype.writeUInt32=function(t){return this.writeByte(t>>>24&255),this.writeByte(t>>16&255),this.writeByte(t>>8&255),this.writeByte(255&t)},t.prototype.readInt32=function(){var t;return 2147483648<=(t=this.readUInt32())?t-4294967296:t},t.prototype.writeInt32=function(t){return t<0&&(t+=4294967296),this.writeUInt32(t)},t.prototype.readUInt16=function(){return this.readByte()<<8|this.readByte()},t.prototype.writeUInt16=function(t){return this.writeByte(t>>8&255),this.writeByte(255&t)},t.prototype.readInt16=function(){var t;return 32768<=(t=this.readUInt16())?t-65536:t},t.prototype.writeInt16=function(t){return t<0&&(t+=65536),this.writeUInt16(t)},t.prototype.readString=function(t){var e,n,r;for(n=[],e=r=0;0<=t?r<t:t<r;e=0<=t?++r:--r)n[e]=String.fromCharCode(this.readByte());return n.join("")},t.prototype.writeString=function(t){var e,n,r,i;for(i=[],e=n=0,r=t.length;0<=r?n<r:r<n;e=0<=r?++n:--n)i.push(this.writeByte(t.charCodeAt(e)));return i},t.prototype.readShort=function(){return this.readInt16()},t.prototype.writeShort=function(t){return this.writeInt16(t)},t.prototype.readLongLong=function(){var t,e,n,r,i,o,a,s;return t=this.readByte(),e=this.readByte(),n=this.readByte(),r=this.readByte(),i=this.readByte(),o=this.readByte(),a=this.readByte(),s=this.readByte(),128&t?-1*(72057594037927940*(255^t)+281474976710656*(255^e)+1099511627776*(255^n)+4294967296*(255^r)+16777216*(255^i)+65536*(255^o)+256*(255^a)+(255^s)+1):72057594037927940*t+281474976710656*e+1099511627776*n+4294967296*r+16777216*i+65536*o+256*a+s},t.prototype.writeLongLong=function(t){var e,n;return e=Math.floor(t/4294967296),n=4294967295&t,this.writeByte(e>>24&255),this.writeByte(e>>16&255),this.writeByte(e>>8&255),this.writeByte(255&e),this.writeByte(n>>24&255),this.writeByte(n>>16&255),this.writeByte(n>>8&255),this.writeByte(255&n)},t.prototype.readInt=function(){return this.readInt32()},t.prototype.writeInt=function(t){return this.writeInt32(t)},t.prototype.read=function(t){var e,n;for(e=[],n=0;0<=t?n<t:t<n;0<=t?++n:--n)e.push(this.readByte());return e},t.prototype.write=function(t){var e,n,r,i;for(i=[],n=0,r=t.length;n<r;n++)e=t[n],i.push(this.writeByte(e));return i},t}(),e=function(){var d;function t(t){var e,n,r;for(this.scalarType=t.readInt(),this.tableCount=t.readShort(),this.searchRange=t.readShort(),this.entrySelector=t.readShort(),this.rangeShift=t.readShort(),this.tables={},n=0,r=this.tableCount;0<=r?n<r:r<n;0<=r?++n:--n)e={tag:t.readString(4),checksum:t.readInt(),offset:t.readInt(),length:t.readInt()},this.tables[e.tag]=e}return t.prototype.encode=function(t){var e,n,r,i,o,a,s,l,h,u,c,f,p;for(p in c=Object.keys(t).length,a=Math.log(2),h=16*Math.floor(Math.log(c)/a),i=Math.floor(h/a),l=16*c-h,(n=new J).writeInt(this.scalarType),n.writeShort(c),n.writeShort(h),n.writeShort(i),n.writeShort(l),r=16*c,s=n.pos+r,o=null,f=[],t)for(u=t[p],n.writeString(p),n.writeInt(d(u)),n.writeInt(s),n.writeInt(u.length),f=f.concat(u),"head"===p&&(o=s),s+=u.length;s%4;)f.push(0),s++;return n.write(f),e=2981146554-d(n.data),n.pos=o+8,n.writeUInt32(e),n.data},d=function(t){var e,n,r,i;for(t=L.call(t);t.length%4;)t.push(0);for(n=new J(t),r=e=0,i=t.length;r<i;r+=4)e+=n.readUInt32();return 4294967295&e},t}(),c={}.hasOwnProperty,f=function(t,e){for(var n in e)c.call(e,n)&&(t[n]=e[n]);function r(){this.constructor=t}return r.prototype=e.prototype,t.prototype=new r,t.__super__=e.prototype,t};h=function(){function t(t){var e;this.file=t,e=this.file.directory.tables[this.tag],this.exists=!!e,e&&(this.offset=e.offset,this.length=e.length,this.parse(this.file.contents))}return t.prototype.parse=function(){},t.prototype.encode=function(){},t.prototype.raw=function(){return this.exists?(this.file.contents.pos=this.offset,this.file.contents.read(this.length)):null},t}();var p=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="head",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.revision=t.readInt(),this.checkSumAdjustment=t.readInt(),this.magicNumber=t.readInt(),this.flags=t.readShort(),this.unitsPerEm=t.readShort(),this.created=t.readLongLong(),this.modified=t.readLongLong(),this.xMin=t.readShort(),this.yMin=t.readShort(),this.xMax=t.readShort(),this.yMax=t.readShort(),this.macStyle=t.readShort(),this.lowestRecPPEM=t.readShort(),this.fontDirectionHint=t.readShort(),this.indexToLocFormat=t.readShort(),this.glyphDataFormat=t.readShort()},e.prototype.encode=function(t){var e;return(e=new J).writeInt(this.version),e.writeInt(this.revision),e.writeInt(this.checkSumAdjustment),e.writeInt(this.magicNumber),e.writeShort(this.flags),e.writeShort(this.unitsPerEm),e.writeLongLong(this.created),e.writeLongLong(this.modified),e.writeShort(this.xMin),e.writeShort(this.yMin),e.writeShort(this.xMax),e.writeShort(this.yMax),e.writeShort(this.macStyle),e.writeShort(this.lowestRecPPEM),e.writeShort(this.fontDirectionHint),e.writeShort(t),e.writeShort(this.glyphDataFormat),e.data},e}(),d=function(){function t(n,t){var e,r,i,o,a,s,l,h,u,c,f,p,d,g,m,y,v,w;switch(this.platformID=n.readUInt16(),this.encodingID=n.readShort(),this.offset=t+n.readInt(),u=n.pos,n.pos=this.offset,this.format=n.readUInt16(),this.length=n.readUInt16(),this.language=n.readUInt16(),this.isUnicode=3===this.platformID&&1===this.encodingID&&4===this.format||0===this.platformID&&4===this.format,this.codeMap={},this.format){case 0:for(s=m=0;m<256;s=++m)this.codeMap[s]=n.readByte();break;case 4:for(f=n.readUInt16(),c=f/2,n.pos+=6,i=function(){var t,e;for(e=[],s=t=0;0<=c?t<c:c<t;s=0<=c?++t:--t)e.push(n.readUInt16());return e}(),n.pos+=2,d=function(){var t,e;for(e=[],s=t=0;0<=c?t<c:c<t;s=0<=c?++t:--t)e.push(n.readUInt16());return e}(),l=function(){var t,e;for(e=[],s=t=0;0<=c?t<c:c<t;s=0<=c?++t:--t)e.push(n.readUInt16());return e}(),h=function(){var t,e;for(e=[],s=t=0;0<=c?t<c:c<t;s=0<=c?++t:--t)e.push(n.readUInt16());return e}(),r=(this.length-n.pos+this.offset)/2,a=function(){var t,e;for(e=[],s=t=0;0<=r?t<r:r<t;s=0<=r?++t:--t)e.push(n.readUInt16());return e}(),s=y=0,w=i.length;y<w;s=++y)for(g=i[s],e=v=p=d[s];p<=g?v<=g:g<=v;e=p<=g?++v:--v)0===h[s]?o=e+l[s]:0!==(o=a[h[s]/2+(e-p)-(c-s)]||0)&&(o+=l[s]),this.codeMap[e]=65535&o}n.pos=u}return t.encode=function(t,e){var n,r,i,o,a,s,l,h,u,c,f,p,d,g,m,y,v,w,b,x,N,L,A,S,_,F,P,k,I,C,B,j,E,M,O,q,T,R,D,U,z,H,W,V,G,Y;switch(k=new J,o=Object.keys(t).sort(function(t,e){return t-e}),e){case"macroman":for(d=0,g=function(){var t,e;for(e=[],p=t=0;t<256;p=++t)e.push(0);return e}(),y={0:0},i={},I=0,E=o.length;I<E;I++)null==y[W=t[r=o[I]]]&&(y[W]=++d),i[r]={old:t[r],new:y[t[r]]},g[r]=y[t[r]];return k.writeUInt16(1),k.writeUInt16(0),k.writeUInt32(12),k.writeUInt16(0),k.writeUInt16(262),k.writeUInt16(0),k.write(g),{charMap:i,subtable:k.data,maxGlyphID:d+1};case"unicode":for(F=[],u=[],y={},n={},m=l=null,C=v=0,M=o.length;C<M;C++)null==y[b=t[r=o[C]]]&&(y[b]=++v),n[r]={old:b,new:y[b]},a=y[b]-r,null!=m&&a===l||(m&&u.push(m),F.push(r),l=a),m=r;for(m&&u.push(m),u.push(65535),F.push(65535),S=2*(A=F.length),L=2*Math.pow(Math.log(A)/Math.LN2,2),c=Math.log(L/2)/Math.LN2,N=2*A-L,s=[],x=[],f=[],p=B=0,O=F.length;B<O;p=++B){if(_=F[p],h=u[p],65535===_){s.push(0),x.push(0);break}if(32768<=_-(P=n[_].new))for(s.push(0),x.push(2*(f.length+A-p)),r=j=_;_<=h?j<=h:h<=j;r=_<=h?++j:--j)f.push(n[r].new);else s.push(P-_),x.push(0)}for(k.writeUInt16(3),k.writeUInt16(1),k.writeUInt32(12),k.writeUInt16(4),k.writeUInt16(16+8*A+2*f.length),k.writeUInt16(0),k.writeUInt16(S),k.writeUInt16(L),k.writeUInt16(c),k.writeUInt16(N),z=0,q=u.length;z<q;z++)r=u[z],k.writeUInt16(r);for(k.writeUInt16(0),H=0,T=F.length;H<T;H++)r=F[H],k.writeUInt16(r);for(V=0,R=s.length;V<R;V++)a=s[V],k.writeUInt16(a);for(G=0,D=x.length;G<D;G++)w=x[G],k.writeUInt16(w);for(Y=0,U=f.length;Y<U;Y++)d=f[Y],k.writeUInt16(d);return{charMap:n,subtable:k.data,maxGlyphID:v+1}}},t}(),y=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="cmap",e.prototype.parse=function(t){var e,n,r;for(t.pos=this.offset,this.version=t.readUInt16(),n=t.readUInt16(),this.tables=[],this.unicode=null,r=0;0<=n?r<n:n<r;0<=n?++r:--r)e=new d(t,this.offset),this.tables.push(e),e.isUnicode&&null==this.unicode&&(this.unicode=e);return!0},e.encode=function(t,e){var n,r;return null==e&&(e="macroman"),n=d.encode(t,e),(r=new J).writeUInt16(0),r.writeUInt16(1),n.table=r.data.concat(n.subtable),n},e}(),g=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="hhea",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.ascender=t.readShort(),this.decender=t.readShort(),this.lineGap=t.readShort(),this.advanceWidthMax=t.readShort(),this.minLeftSideBearing=t.readShort(),this.minRightSideBearing=t.readShort(),this.xMaxExtent=t.readShort(),this.caretSlopeRise=t.readShort(),this.caretSlopeRun=t.readShort(),this.caretOffset=t.readShort(),t.pos+=8,this.metricDataFormat=t.readShort(),this.numberOfMetrics=t.readUInt16()},e}(),m=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="OS/2",e.prototype.parse=function(n){if(n.pos=this.offset,this.version=n.readUInt16(),this.averageCharWidth=n.readShort(),this.weightClass=n.readUInt16(),this.widthClass=n.readUInt16(),this.type=n.readShort(),this.ySubscriptXSize=n.readShort(),this.ySubscriptYSize=n.readShort(),this.ySubscriptXOffset=n.readShort(),this.ySubscriptYOffset=n.readShort(),this.ySuperscriptXSize=n.readShort(),this.ySuperscriptYSize=n.readShort(),this.ySuperscriptXOffset=n.readShort(),this.ySuperscriptYOffset=n.readShort(),this.yStrikeoutSize=n.readShort(),this.yStrikeoutPosition=n.readShort(),this.familyClass=n.readShort(),this.panose=function(){var t,e;for(e=[],t=0;t<10;++t)e.push(n.readByte());return e}(),this.charRange=function(){var t,e;for(e=[],t=0;t<4;++t)e.push(n.readInt());return e}(),this.vendorID=n.readString(4),this.selection=n.readShort(),this.firstCharIndex=n.readShort(),this.lastCharIndex=n.readShort(),0<this.version&&(this.ascent=n.readShort(),this.descent=n.readShort(),this.lineGap=n.readShort(),this.winAscent=n.readShort(),this.winDescent=n.readShort(),this.codePageRange=function(){var t,e;for(e=[],t=0;t<2;++t)e.push(n.readInt());return e}(),1<this.version))return this.xHeight=n.readShort(),this.capHeight=n.readShort(),this.defaultChar=n.readShort(),this.breakChar=n.readShort(),this.maxContext=n.readShort()},e}(),v=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="post",e.prototype.parse=function(r){var t,e,n,i;switch(r.pos=this.offset,this.format=r.readInt(),this.italicAngle=r.readInt(),this.underlinePosition=r.readShort(),this.underlineThickness=r.readShort(),this.isFixedPitch=r.readInt(),this.minMemType42=r.readInt(),this.maxMemType42=r.readInt(),this.minMemType1=r.readInt(),this.maxMemType1=r.readInt(),this.format){case 65536:break;case 131072:for(e=r.readUInt16(),this.glyphNameIndex=[],n=0;0<=e?n<e:e<n;0<=e?++n:--n)this.glyphNameIndex.push(r.readUInt16());for(this.names=[],i=[];r.pos<this.offset+this.length;)t=r.readByte(),i.push(this.names.push(r.readString(t)));return i;case 151552:return e=r.readUInt16(),this.offsets=r.read(e);case 196608:break;case 262144:return this.map=function(){var t,e,n;for(n=[],t=0,e=this.file.maxp.numGlyphs;0<=e?t<e:e<t;0<=e?++t:--t)n.push(r.readUInt32());return n}.call(this)}},e}(),w=function(t,e){this.raw=t,this.length=t.length,this.platformID=e.platformID,this.encodingID=e.encodingID,this.languageID=e.languageID},b=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="name",e.prototype.parse=function(t){var e,n,r,i,o,a,s,l,h,u,c,f;for(t.pos=this.offset,t.readShort(),e=t.readShort(),a=t.readShort(),n=[],i=h=0;0<=e?h<e:e<h;i=0<=e?++h:--h)n.push({platformID:t.readShort(),encodingID:t.readShort(),languageID:t.readShort(),nameID:t.readShort(),length:t.readShort(),offset:this.offset+a+t.readShort()});for(s={},i=u=0,c=n.length;u<c;i=++u)r=n[i],t.pos=r.offset,l=t.readString(r.length),o=new w(l,r),null==s[f=r.nameID]&&(s[f]=[]),s[r.nameID].push(o);this.strings=s,this.copyright=s[0],this.fontFamily=s[1],this.fontSubfamily=s[2],this.uniqueSubfamily=s[3],this.fontName=s[4],this.version=s[5];try{this.postscriptName=s[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g,"")}catch(t){this.postscriptName=s[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g,"")}return this.trademark=s[7],this.manufacturer=s[8],this.designer=s[9],this.description=s[10],this.vendorUrl=s[11],this.designerUrl=s[12],this.license=s[13],this.licenseUrl=s[14],this.preferredFamily=s[15],this.preferredSubfamily=s[17],this.compatibleFull=s[18],this.sampleText=s[19]},e}(),x=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="maxp",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.numGlyphs=t.readUInt16(),this.maxPoints=t.readUInt16(),this.maxContours=t.readUInt16(),this.maxCompositePoints=t.readUInt16(),this.maxComponentContours=t.readUInt16(),this.maxZones=t.readUInt16(),this.maxTwilightPoints=t.readUInt16(),this.maxStorage=t.readUInt16(),this.maxFunctionDefs=t.readUInt16(),this.maxInstructionDefs=t.readUInt16(),this.maxStackElements=t.readUInt16(),this.maxSizeOfInstructions=t.readUInt16(),this.maxComponentElements=t.readUInt16(),this.maxComponentDepth=t.readUInt16()},e}(),N=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="hmtx",e.prototype.parse=function(n){var t,r,i,e,o,a,s;for(n.pos=this.offset,this.metrics=[],e=0,a=this.file.hhea.numberOfMetrics;0<=a?e<a:a<e;0<=a?++e:--e)this.metrics.push({advance:n.readUInt16(),lsb:n.readInt16()});for(r=this.file.maxp.numGlyphs-this.file.hhea.numberOfMetrics,this.leftSideBearings=function(){var t,e;for(e=[],t=0;0<=r?t<r:r<t;0<=r?++t:--t)e.push(n.readInt16());return e}(),this.widths=function(){var t,e,n,r;for(r=[],t=0,e=(n=this.metrics).length;t<e;t++)i=n[t],r.push(i.advance);return r}.call(this),t=this.widths[this.widths.length-1],s=[],o=0;0<=r?o<r:r<o;0<=r?++o:--o)s.push(this.widths.push(t));return s},e.prototype.forGlyph=function(t){return t in this.metrics?this.metrics[t]:{advance:this.metrics[this.metrics.length-1].advance,lsb:this.leftSideBearings[t-this.metrics.length]}},e}(),L=[].slice,A=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="glyf",e.prototype.parse=function(t){return this.cache={}},e.prototype.glyphFor=function(t){var e,n,r,i,o,a,s,l,h,u;return(t=t)in this.cache?this.cache[t]:(i=this.file.loca,e=this.file.contents,n=i.indexOf(t),0===(r=i.lengthOf(t))?this.cache[t]=null:(e.pos=this.offset+n,o=(a=new J(e.read(r))).readShort(),l=a.readShort(),u=a.readShort(),s=a.readShort(),h=a.readShort(),this.cache[t]=-1===o?new _(a,l,u,s,h):new S(a,o,l,u,s,h),this.cache[t]))},e.prototype.encode=function(t,e,n){var r,i,o,a,s;for(o=[],i=[],a=0,s=e.length;a<s;a++)r=t[e[a]],i.push(o.length),r&&(o=o.concat(r.encode(n)));return i.push(o.length),{table:o,offsets:i}},e}(),S=function(){function t(t,e,n,r,i,o){this.raw=t,this.numberOfContours=e,this.xMin=n,this.yMin=r,this.xMax=i,this.yMax=o,this.compound=!1}return t.prototype.encode=function(){return this.raw.data},t}(),_=function(){function t(t,e,n,r,i){var o,a;for(this.raw=t,this.xMin=e,this.yMin=n,this.xMax=r,this.yMax=i,this.compound=!0,this.glyphIDs=[],this.glyphOffsets=[],o=this.raw;a=o.readShort(),this.glyphOffsets.push(o.pos),this.glyphIDs.push(o.readShort()),32&a;)o.pos+=1&a?4:2,128&a?o.pos+=8:64&a?o.pos+=4:8&a&&(o.pos+=2)}return 1,8,32,64,128,t.prototype.encode=function(t){var e,n,r,i,o;for(n=new J(L.call(this.raw.data)),e=r=0,i=(o=this.glyphIDs).length;r<i;e=++r)o[e],n.pos=this.glyphOffsets[e];return n.data},t}(),F=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="loca",e.prototype.parse=function(r){var t;return r.pos=this.offset,t=this.file.head.indexToLocFormat,this.offsets=0===t?function(){var t,e,n;for(n=[],t=0,e=this.length;t<e;t+=2)n.push(2*r.readUInt16());return n}.call(this):function(){var t,e,n;for(n=[],t=0,e=this.length;t<e;t+=4)n.push(r.readUInt32());return n}.call(this)},e.prototype.indexOf=function(t){return this.offsets[t]},e.prototype.lengthOf=function(t){return this.offsets[t+1]-this.offsets[t]},e.prototype.encode=function(t,e){for(var n=new Uint32Array(this.offsets.length),r=0,i=0,o=0;o<n.length;++o)if(n[o]=r,i<e.length&&e[i]==o){++i,n[o]=r;var a=this.offsets[o],s=this.offsets[o+1]-a;0<s&&(r+=s)}for(var l=new Array(4*n.length),h=0;h<n.length;++h)l[4*h+3]=255&n[h],l[4*h+2]=(65280&n[h])>>8,l[4*h+1]=(16711680&n[h])>>16,l[4*h]=(4278190080&n[h])>>24;return l},e}(),P=function(){function t(t){this.font=t,this.subset={},this.unicodes={},this.next=33}return t.prototype.generateCmap=function(){var t,e,n,r,i;for(e in r=this.font.cmap.tables[0].codeMap,t={},i=this.subset)n=i[e],t[e]=r[n];return t},t.prototype.glyphsFor=function(t){var e,n,r,i,o,a,s;for(r={},o=0,a=t.length;o<a;o++)r[i=t[o]]=this.font.glyf.glyphFor(i);for(i in e=[],r)(null!=(n=r[i])?n.compound:void 0)&&e.push.apply(e,n.glyphIDs);if(0<e.length)for(i in s=this.glyphsFor(e))n=s[i],r[i]=n;return r},t.prototype.encode=function(t,e){var n,r,i,o,a,s,l,h,u,c,f,p,d,g,m;for(r in n=y.encode(this.generateCmap(),"unicode"),o=this.glyphsFor(t),f={0:0},m=n.charMap)f[(s=m[r]).old]=s.new;for(p in c=n.maxGlyphID,o)p in f||(f[p]=c++);return h=function(t){var e,n;for(e in n={},t)n[t[e]]=e;return n}(f),u=Object.keys(h).sort(function(t,e){return t-e}),d=function(){var t,e,n;for(n=[],t=0,e=u.length;t<e;t++)a=u[t],n.push(h[a]);return n}(),i=this.font.glyf.encode(o,d,f),l=this.font.loca.encode(i.offsets,d),g={cmap:this.font.cmap.raw(),glyf:i.table,loca:l,hmtx:this.font.hmtx.raw(),hhea:this.font.hhea.raw(),maxp:this.font.maxp.raw(),post:this.font.post.raw(),name:this.font.name.raw(),head:this.font.head.encode(e)},this.font.os2.exists&&(g["OS/2"]=this.font.os2.raw()),this.font.directory.encode(g)},t}();t.API.PDFObject=function(){var o;function a(){}return o=function(t,e){return(Array(e+1).join("0")+t).slice(-e)},a.convert=function(r){var i,t,e,n;if(Array.isArray(r))return"["+function(){var t,e,n;for(n=[],t=0,e=r.length;t<e;t++)i=r[t],n.push(a.convert(i));return n}().join(" ")+"]";if("string"==typeof r)return"/"+r;if(null!=r?r.isString:void 0)return"("+r+")";if(r instanceof Date)return"(D:"+o(r.getUTCFullYear(),4)+o(r.getUTCMonth(),2)+o(r.getUTCDate(),2)+o(r.getUTCHours(),2)+o(r.getUTCMinutes(),2)+o(r.getUTCSeconds(),2)+"Z)";if("[object Object]"!=={}.toString.call(r))return""+r;for(t in e=["<<"],r)n=r[t],e.push("/"+t+" "+a.convert(n));return e.push(">>"),e.join("\n")},a}()}(lt),
/*
  # PNG.js
  # Copyright (c) 2011 Devon Govett
  # MIT LICENSE
  # 
  # 
  */
Nt="undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")(),Lt=function(){var h,n,r;function i(t){var e,n,r,i,o,a,s,l,h,u,c,f,p,d;for(this.data=t,this.pos=8,this.palette=[],this.imgData=[],this.transparency={},this.animation=null,this.text={},a=null;;){switch(e=this.readUInt32(),h=function(){var t,e;for(e=[],t=0;t<4;++t)e.push(String.fromCharCode(this.data[this.pos++]));return e}.call(this).join("")){case"IHDR":this.width=this.readUInt32(),this.height=this.readUInt32(),this.bits=this.data[this.pos++],this.colorType=this.data[this.pos++],this.compressionMethod=this.data[this.pos++],this.filterMethod=this.data[this.pos++],this.interlaceMethod=this.data[this.pos++];break;case"acTL":this.animation={numFrames:this.readUInt32(),numPlays:this.readUInt32()||1/0,frames:[]};break;case"PLTE":this.palette=this.read(e);break;case"fcTL":a&&this.animation.frames.push(a),this.pos+=4,a={width:this.readUInt32(),height:this.readUInt32(),xOffset:this.readUInt32(),yOffset:this.readUInt32()},o=this.readUInt16(),i=this.readUInt16()||100,a.delay=1e3*o/i,a.disposeOp=this.data[this.pos++],a.blendOp=this.data[this.pos++],a.data=[];break;case"IDAT":case"fdAT":for("fdAT"===h&&(this.pos+=4,e-=4),t=(null!=a?a.data:void 0)||this.imgData,f=0;0<=e?f<e:e<f;0<=e?++f:--f)t.push(this.data[this.pos++]);break;case"tRNS":switch(this.transparency={},this.colorType){case 3:if(r=this.palette.length/3,this.transparency.indexed=this.read(e),this.transparency.indexed.length>r)throw new Error("More transparent colors than palette size");if(0<(u=r-this.transparency.indexed.length))for(p=0;0<=u?p<u:u<p;0<=u?++p:--p)this.transparency.indexed.push(255);break;case 0:this.transparency.grayscale=this.read(e)[0];break;case 2:this.transparency.rgb=this.read(e)}break;case"tEXt":s=(c=this.read(e)).indexOf(0),l=String.fromCharCode.apply(String,c.slice(0,s)),this.text[l]=String.fromCharCode.apply(String,c.slice(s+1));break;case"IEND":return a&&this.animation.frames.push(a),this.colors=function(){switch(this.colorType){case 0:case 3:case 4:return 1;case 2:case 6:return 3}}.call(this),this.hasAlphaChannel=4===(d=this.colorType)||6===d,n=this.colors+(this.hasAlphaChannel?1:0),this.pixelBitlength=this.bits*n,this.colorSpace=function(){switch(this.colors){case 1:return"DeviceGray";case 3:return"DeviceRGB"}}.call(this),void(this.imgData=new Uint8Array(this.imgData));default:this.pos+=e}if(this.pos+=4,this.pos>this.data.length)throw new Error("Incomplete or corrupt PNG file")}}i.load=function(t,e,n){var r;return"function"==typeof e&&(n=e),(r=new XMLHttpRequest).open("GET",t,!0),r.responseType="arraybuffer",r.onload=function(){var t;return t=new i(new Uint8Array(r.response||r.mozResponseArrayBuffer)),"function"==typeof(null!=e?e.getContext:void 0)&&t.render(e),"function"==typeof n?n(t):void 0},r.send(null)},i.prototype.read=function(t){var e,n;for(n=[],e=0;0<=t?e<t:t<e;0<=t?++e:--e)n.push(this.data[this.pos++]);return n},i.prototype.readUInt32=function(){return this.data[this.pos++]<<24|this.data[this.pos++]<<16|this.data[this.pos++]<<8|this.data[this.pos++]},i.prototype.readUInt16=function(){return this.data[this.pos++]<<8|this.data[this.pos++]},i.prototype.decodePixels=function(C){var B=this.pixelBitlength/8,j=new Uint8Array(this.width*this.height*B),E=0,M=this;if(null==C&&(C=this.imgData),0===C.length)return new Uint8Array(0);function t(t,e,n,r){var i,o,a,s,l,h,u,c,f,p,d,g,m,y,v,w,b,x,N,L,A,S=Math.ceil((M.width-t)/n),_=Math.ceil((M.height-e)/r),F=M.width==S&&M.height==_;for(y=B*S,g=F?j:new Uint8Array(y*_),h=C.length,o=m=0;m<_&&E<h;){switch(C[E++]){case 0:for(s=b=0;b<y;s=b+=1)g[o++]=C[E++];break;case 1:for(s=x=0;x<y;s=x+=1)i=C[E++],l=s<B?0:g[o-B],g[o++]=(i+l)%256;break;case 2:for(s=N=0;N<y;s=N+=1)i=C[E++],a=(s-s%B)/B,v=m&&g[(m-1)*y+a*B+s%B],g[o++]=(v+i)%256;break;case 3:for(s=L=0;L<y;s=L+=1)i=C[E++],a=(s-s%B)/B,l=s<B?0:g[o-B],v=m&&g[(m-1)*y+a*B+s%B],g[o++]=(i+Math.floor((l+v)/2))%256;break;case 4:for(s=A=0;A<y;s=A+=1)i=C[E++],a=(s-s%B)/B,l=s<B?0:g[o-B],0===m?v=w=0:(v=g[(m-1)*y+a*B+s%B],w=a&&g[(m-1)*y+(a-1)*B+s%B]),u=l+v-w,c=Math.abs(u-l),p=Math.abs(u-v),d=Math.abs(u-w),f=c<=p&&c<=d?l:p<=d?v:w,g[o++]=(i+f)%256;break;default:throw new Error("Invalid filter algorithm: "+C[E-1])}if(!F){var P=((e+m*r)*M.width+t)*B,k=m*y;for(s=0;s<S;s+=1){for(var I=0;I<B;I+=1)j[P++]=g[k++];P+=(n-1)*B}}m++}}return C=(C=new kt(C)).getBytes(),1==M.interlaceMethod?(t(0,0,8,8),t(4,0,8,8),t(0,4,4,8),t(2,0,4,4),t(0,2,2,4),t(1,0,2,2),t(0,1,1,2)):t(0,0,1,1),j},i.prototype.decodePalette=function(){var t,e,n,r,i,o,a,s,l;for(n=this.palette,o=this.transparency.indexed||[],i=new Uint8Array((o.length||0)+n.length),r=0,n.length,e=a=t=0,s=n.length;a<s;e=a+=3)i[r++]=n[e],i[r++]=n[e+1],i[r++]=n[e+2],i[r++]=null!=(l=o[t++])?l:255;return i},i.prototype.copyToImageData=function(t,e){var n,r,i,o,a,s,l,h,u,c,f;if(r=this.colors,u=null,n=this.hasAlphaChannel,this.palette.length&&(u=null!=(f=this._decodedPalette)?f:this._decodedPalette=this.decodePalette(),r=4,n=!0),h=(i=t.data||t).length,a=u||e,o=s=0,1===r)for(;o<h;)l=u?4*e[o/4]:s,c=a[l++],i[o++]=c,i[o++]=c,i[o++]=c,i[o++]=n?a[l++]:255,s=l;else for(;o<h;)l=u?4*e[o/4]:s,i[o++]=a[l++],i[o++]=a[l++],i[o++]=a[l++],i[o++]=n?a[l++]:255,s=l},i.prototype.decode=function(){var t;return t=new Uint8Array(this.width*this.height*4),this.copyToImageData(t,this.decodePixels()),t};try{n=Nt.document.createElement("canvas"),r=n.getContext("2d")}catch(t){return-1}return h=function(t){var e;return r.width=t.width,r.height=t.height,r.clearRect(0,0,t.width,t.height),r.putImageData(t,0,0),(e=new Image).src=n.toDataURL(),e},i.prototype.decodeFrames=function(t){var e,n,r,i,o,a,s,l;if(this.animation){for(l=[],n=o=0,a=(s=this.animation.frames).length;o<a;n=++o)e=s[n],r=t.createImageData(e.width,e.height),i=this.decodePixels(new Uint8Array(e.data)),this.copyToImageData(r,i),e.imageData=r,l.push(e.image=h(r));return l}},i.prototype.renderFrame=function(t,e){var n,r,i;return n=(r=this.animation.frames)[e],i=r[e-1],0===e&&t.clearRect(0,0,this.width,this.height),1===(null!=i?i.disposeOp:void 0)?t.clearRect(i.xOffset,i.yOffset,i.width,i.height):2===(null!=i?i.disposeOp:void 0)&&t.putImageData(i.imageData,i.xOffset,i.yOffset),0===n.blendOp&&t.clearRect(n.xOffset,n.yOffset,n.width,n.height),t.drawImage(n.image,n.xOffset,n.yOffset)},i.prototype.animate=function(n){var r,i,o,a,s,t,l=this;return i=0,t=this.animation,a=t.numFrames,o=t.frames,s=t.numPlays,(r=function(){var t,e;if(t=i++%a,e=o[t],l.renderFrame(n,t),1<a&&i/a<s)return l.animation._timeout=setTimeout(r,e.delay)})()},i.prototype.stopAnimation=function(){var t;return clearTimeout(null!=(t=this.animation)?t._timeout:void 0)},i.prototype.render=function(t){var e,n;return t._png&&t._png.stopAnimation(),t._png=this,t.width=this.width,t.height=this.height,e=t.getContext("2d"),this.animation?(this.decodeFrames(e),this.animate(e)):(n=e.createImageData(this.width,this.height),this.copyToImageData(n,this.decodePixels()),e.putImageData(n,0,0))},i}(),Nt.PNG=Lt;
/*
   * Extracted from pdf.js
   * https://github.com/andreasgal/pdf.js
   *
   * Copyright (c) 2011 Mozilla Foundation
   *
   * Contributors: Andreas Gal <gal@mozilla.com>
   *               Chris G Jones <cjones@mozilla.com>
   *               Shaon Barman <shaon.barman@gmail.com>
   *               Vivien Nicolas <21@vingtetun.org>
   *               Justin D'Arcangelo <justindarc@gmail.com>
   *               Yury Delendik
   *
   * 
   */
var Pt=function(){function t(){this.pos=0,this.bufferLength=0,this.eof=!1,this.buffer=null}return t.prototype={ensureBuffer:function(t){var e=this.buffer,n=e?e.byteLength:0;if(t<n)return e;for(var r=512;r<t;)r<<=1;for(var i=new Uint8Array(r),o=0;o<n;++o)i[o]=e[o];return this.buffer=i},getByte:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return this.buffer[this.pos++]},getBytes:function(t){var e=this.pos;if(t){this.ensureBuffer(e+t);for(var n=e+t;!this.eof&&this.bufferLength<n;)this.readBlock();var r=this.bufferLength;r<n&&(n=r)}else{for(;!this.eof;)this.readBlock();n=this.bufferLength}return this.pos=n,this.buffer.subarray(e,n)},lookChar:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return String.fromCharCode(this.buffer[this.pos])},getChar:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return String.fromCharCode(this.buffer[this.pos++])},makeSubStream:function(t,e,n){for(var r=t+e;this.bufferLength<=r&&!this.eof;)this.readBlock();return new Stream(this.buffer,t,e,n)},skip:function(t){t||(t=1),this.pos+=t},reset:function(){this.pos=0}},t}(),kt=function(){if("undefined"!=typeof Uint32Array){var k=new Uint32Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),I=new Uint32Array([3,4,5,6,7,8,9,10,65547,65549,65551,65553,131091,131095,131099,131103,196643,196651,196659,196667,262211,262227,262243,262259,327811,327843,327875,327907,258,258,258]),C=new Uint32Array([1,2,3,4,65541,65543,131081,131085,196625,196633,262177,262193,327745,327777,393345,393409,459009,459137,524801,525057,590849,591361,657409,658433,724993,727041,794625,798721,868353,876545]),B=[new Uint32Array([459008,524368,524304,524568,459024,524400,524336,590016,459016,524384,524320,589984,524288,524416,524352,590048,459012,524376,524312,589968,459028,524408,524344,590032,459020,524392,524328,59e4,524296,524424,524360,590064,459010,524372,524308,524572,459026,524404,524340,590024,459018,524388,524324,589992,524292,524420,524356,590056,459014,524380,524316,589976,459030,524412,524348,590040,459022,524396,524332,590008,524300,524428,524364,590072,459009,524370,524306,524570,459025,524402,524338,590020,459017,524386,524322,589988,524290,524418,524354,590052,459013,524378,524314,589972,459029,524410,524346,590036,459021,524394,524330,590004,524298,524426,524362,590068,459011,524374,524310,524574,459027,524406,524342,590028,459019,524390,524326,589996,524294,524422,524358,590060,459015,524382,524318,589980,459031,524414,524350,590044,459023,524398,524334,590012,524302,524430,524366,590076,459008,524369,524305,524569,459024,524401,524337,590018,459016,524385,524321,589986,524289,524417,524353,590050,459012,524377,524313,589970,459028,524409,524345,590034,459020,524393,524329,590002,524297,524425,524361,590066,459010,524373,524309,524573,459026,524405,524341,590026,459018,524389,524325,589994,524293,524421,524357,590058,459014,524381,524317,589978,459030,524413,524349,590042,459022,524397,524333,590010,524301,524429,524365,590074,459009,524371,524307,524571,459025,524403,524339,590022,459017,524387,524323,589990,524291,524419,524355,590054,459013,524379,524315,589974,459029,524411,524347,590038,459021,524395,524331,590006,524299,524427,524363,590070,459011,524375,524311,524575,459027,524407,524343,590030,459019,524391,524327,589998,524295,524423,524359,590062,459015,524383,524319,589982,459031,524415,524351,590046,459023,524399,524335,590014,524303,524431,524367,590078,459008,524368,524304,524568,459024,524400,524336,590017,459016,524384,524320,589985,524288,524416,524352,590049,459012,524376,524312,589969,459028,524408,524344,590033,459020,524392,524328,590001,524296,524424,524360,590065,459010,524372,524308,524572,459026,524404,524340,590025,459018,524388,524324,589993,524292,524420,524356,590057,459014,524380,524316,589977,459030,524412,524348,590041,459022,524396,524332,590009,524300,524428,524364,590073,459009,524370,524306,524570,459025,524402,524338,590021,459017,524386,524322,589989,524290,524418,524354,590053,459013,524378,524314,589973,459029,524410,524346,590037,459021,524394,524330,590005,524298,524426,524362,590069,459011,524374,524310,524574,459027,524406,524342,590029,459019,524390,524326,589997,524294,524422,524358,590061,459015,524382,524318,589981,459031,524414,524350,590045,459023,524398,524334,590013,524302,524430,524366,590077,459008,524369,524305,524569,459024,524401,524337,590019,459016,524385,524321,589987,524289,524417,524353,590051,459012,524377,524313,589971,459028,524409,524345,590035,459020,524393,524329,590003,524297,524425,524361,590067,459010,524373,524309,524573,459026,524405,524341,590027,459018,524389,524325,589995,524293,524421,524357,590059,459014,524381,524317,589979,459030,524413,524349,590043,459022,524397,524333,590011,524301,524429,524365,590075,459009,524371,524307,524571,459025,524403,524339,590023,459017,524387,524323,589991,524291,524419,524355,590055,459013,524379,524315,589975,459029,524411,524347,590039,459021,524395,524331,590007,524299,524427,524363,590071,459011,524375,524311,524575,459027,524407,524343,590031,459019,524391,524327,589999,524295,524423,524359,590063,459015,524383,524319,589983,459031,524415,524351,590047,459023,524399,524335,590015,524303,524431,524367,590079]),9],j=[new Uint32Array([327680,327696,327688,327704,327684,327700,327692,327708,327682,327698,327690,327706,327686,327702,327694,0,327681,327697,327689,327705,327685,327701,327693,327709,327683,327699,327691,327707,327687,327703,327695,0]),5];return(t.prototype=Object.create(Pt.prototype)).getBits=function(t){for(var e,n=this.codeSize,r=this.codeBuf,i=this.bytes,o=this.bytesPos;n<t;)void 0===(e=i[o++])&&E("Bad encoding in flate stream"),r|=e<<n,n+=8;return e=r&(1<<t)-1,this.codeBuf=r>>t,this.codeSize=n-=t,this.bytesPos=o,e},t.prototype.getCode=function(t){for(var e=t[0],n=t[1],r=this.codeSize,i=this.codeBuf,o=this.bytes,a=this.bytesPos;r<n;){var s;void 0===(s=o[a++])&&E("Bad encoding in flate stream"),i|=s<<r,r+=8}var l=e[i&(1<<n)-1],h=l>>16,u=65535&l;return(0==r||r<h||0==h)&&E("Bad encoding in flate stream"),this.codeBuf=i>>h,this.codeSize=r-h,this.bytesPos=a,u},t.prototype.generateHuffmanTable=function(t){for(var e=t.length,n=0,r=0;r<e;++r)t[r]>n&&(n=t[r]);for(var i=1<<n,o=new Uint32Array(i),a=1,s=0,l=2;a<=n;++a,s<<=1,l<<=1)for(var h=0;h<e;++h)if(t[h]==a){var u=0,c=s;for(r=0;r<a;++r)u=u<<1|1&c,c>>=1;for(r=u;r<i;r+=l)o[r]=a<<16|h;++s}return[o,n]},t.prototype.readBlock=function(){function t(t,e,n,r,i){for(var o=t.getBits(n)+r;0<o--;)e[l++]=i}var e=this.getBits(3);if(1&e&&(this.eof=!0),0!=(e>>=1)){var n,r;if(1==e)n=B,r=j;else if(2==e){for(var i=this.getBits(5)+257,o=this.getBits(5)+1,a=this.getBits(4)+4,s=Array(k.length),l=0;l<a;)s[k[l++]]=this.getBits(3);for(var h=this.generateHuffmanTable(s),u=0,c=(l=0,i+o),f=new Array(c);l<c;){var p=this.getCode(h);16==p?t(this,f,2,3,u):17==p?t(this,f,3,3,u=0):18==p?t(this,f,7,11,u=0):f[l++]=u=p}n=this.generateHuffmanTable(f.slice(0,i)),r=this.generateHuffmanTable(f.slice(i,c))}else E("Unknown block type in flate stream");for(var d=(_=this.buffer)?_.length:0,g=this.bufferLength;;){var m=this.getCode(n);if(m<256)d<=g+1&&(d=(_=this.ensureBuffer(g+1)).length),_[g++]=m;else{if(256==m)return void(this.bufferLength=g);var y=(m=I[m-=257])>>16;0<y&&(y=this.getBits(y));u=(65535&m)+y;m=this.getCode(r),0<(y=(m=C[m])>>16)&&(y=this.getBits(y));var v=(65535&m)+y;d<=g+u&&(d=(_=this.ensureBuffer(g+u)).length);for(var w=0;w<u;++w,++g)_[g]=_[g-v]}}}else{var b,x=this.bytes,N=this.bytesPos;void 0===(b=x[N++])&&E("Bad block header in flate stream");var L=b;void 0===(b=x[N++])&&E("Bad block header in flate stream"),L|=b<<8,void 0===(b=x[N++])&&E("Bad block header in flate stream");var A=b;void 0===(b=x[N++])&&E("Bad block header in flate stream"),(A|=b<<8)!=(65535&~L)&&E("Bad uncompressed block length in flate stream"),this.codeBuf=0,this.codeSize=0;var S=this.bufferLength,_=this.ensureBuffer(S+L),F=S+L;this.bufferLength=F;for(var P=S;P<F;++P){if(void 0===(b=x[N++])){this.eof=!0;break}_[P]=b}this.bytesPos=N}},t}function E(t){throw new Error(t)}function t(t){var e=0,n=t[e++],r=t[e++];-1!=n&&-1!=r||E("Invalid header in flate stream"),8!=(15&n)&&E("Unknown compression method in flate stream"),((n<<8)+r)%31!=0&&E("Bad FCHECK in flate stream"),32&r&&E("FDICT bit set in flate stream"),this.bytes=t,this.bytesPos=2,this.codeSize=0,this.codeBuf=0,Pt.call(this)}}();window.tmp=kt});try{module.exports=jsPDF}catch(t){}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(17);
var createDesc = __webpack_require__(74);
module.exports = __webpack_require__(16) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var hide = __webpack_require__(33);
var has = __webpack_require__(40);
var SRC = __webpack_require__(75)('src');
var $toString = __webpack_require__(622);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(45).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var fails = __webpack_require__(10);
var defined = __webpack_require__(53);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(399);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = getPhrasePropTypes;

var _object = __webpack_require__(150);

var _object2 = _interopRequireDefault(_object);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getPhrasePropTypes(defaultPhrases) {
  return Object.keys(defaultPhrases).reduce(function (phrases, key) {
    return (0, _object2['default'])({}, phrases, _defineProperty({}, key, _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].func, _propTypes2['default'].node])));
  }, {});
}

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(209)('wks');
var uid = __webpack_require__(155);
var Symbol = __webpack_require__(28).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var imgLogo = exports.imgLogo = "data:image/jpeg;base64,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";

/***/ }),
/* 40 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(105);
var defined = __webpack_require__(53);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(106);
var createDesc = __webpack_require__(74);
var toIObject = __webpack_require__(41);
var toPrimitive = __webpack_require__(52);
var has = __webpack_require__(40);
var IE8_DOM_DEFINE = __webpack_require__(225);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(16) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(40);
var toObject = __webpack_require__(19);
var IE_PROTO = __webpack_require__(163)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 45 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.8' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(26);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 47 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 48 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(10);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var tslib = __webpack_require__(51);
var util = __webpack_require__(66);
var logger$1 = __webpack_require__(110);

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a;
var ERRORS = (_a = {},
    _a["no-app" /* NO_APP */] = "No Firebase App '{$appName}' has been created - " +
        'call Firebase App.initializeApp()',
    _a["bad-app-name" /* BAD_APP_NAME */] = "Illegal App name: '{$appName}",
    _a["duplicate-app" /* DUPLICATE_APP */] = "Firebase App named '{$appName}' already exists",
    _a["app-deleted" /* APP_DELETED */] = "Firebase App named '{$appName}' already deleted",
    _a["invalid-app-argument" /* INVALID_APP_ARGUMENT */] = 'firebase.{$appName}() takes either no argument or a ' +
        'Firebase App instance.',
    _a);
var ERROR_FACTORY = new util.ErrorFactory('app', 'Firebase', ERRORS);

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DEFAULT_ENTRY_NAME = '[DEFAULT]';

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Global context object for a collection of services using
 * a shared authentication state.
 */
var FirebaseAppImpl = /** @class */ (function () {
    function FirebaseAppImpl(options, config, firebase_) {
        var _this = this;
        this.firebase_ = firebase_;
        this.isDeleted_ = false;
        this.services_ = {};
        // An array to capture listeners before the true auth functions exist
        this.tokenListeners_ = [];
        // An array to capture requests to send events before analytics component loads. Use type any to make using function.apply easier
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.analyticsEventRequests_ = [];
        this.name_ = config.name;
        this.automaticDataCollectionEnabled_ =
            config.automaticDataCollectionEnabled || false;
        this.options_ = util.deepCopy(options);
        var self = this;
        this.INTERNAL = {
            getUid: function () { return null; },
            getToken: function () { return Promise.resolve(null); },
            addAuthTokenListener: function (callback) {
                _this.tokenListeners_.push(callback);
                // Make sure callback is called, asynchronously, in the absence of the auth module
                setTimeout(function () { return callback(null); }, 0);
            },
            removeAuthTokenListener: function (callback) {
                _this.tokenListeners_ = _this.tokenListeners_.filter(function (listener) { return listener !== callback; });
            },
            analytics: {
                logEvent: function () {
                    self.analyticsEventRequests_.push(arguments);
                }
            }
        };
    }
    Object.defineProperty(FirebaseAppImpl.prototype, "automaticDataCollectionEnabled", {
        get: function () {
            this.checkDestroyed_();
            return this.automaticDataCollectionEnabled_;
        },
        set: function (val) {
            this.checkDestroyed_();
            this.automaticDataCollectionEnabled_ = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "name", {
        get: function () {
            this.checkDestroyed_();
            return this.name_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "options", {
        get: function () {
            this.checkDestroyed_();
            return this.options_;
        },
        enumerable: true,
        configurable: true
    });
    FirebaseAppImpl.prototype.delete = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.checkDestroyed_();
            resolve();
        })
            .then(function () {
            _this.firebase_.INTERNAL.removeApp(_this.name_);
            var services = [];
            for (var _i = 0, _a = Object.keys(_this.services_); _i < _a.length; _i++) {
                var serviceKey = _a[_i];
                for (var _b = 0, _c = Object.keys(_this.services_[serviceKey]); _b < _c.length; _b++) {
                    var instanceKey = _c[_b];
                    services.push(_this.services_[serviceKey][instanceKey]);
                }
            }
            return Promise.all(services
                .filter(function (service) { return 'INTERNAL' in service; })
                .map(function (service) { return service.INTERNAL.delete(); }));
        })
            .then(function () {
            _this.isDeleted_ = true;
            _this.services_ = {};
        });
    };
    /**
     * Return a service instance associated with this app (creating it
     * on demand), identified by the passed instanceIdentifier.
     *
     * NOTE: Currently storage and functions are the only ones that are leveraging this
     * functionality. They invoke it by calling:
     *
     * ```javascript
     * firebase.app().storage('STORAGE BUCKET ID')
     * ```
     *
     * The service name is passed to this already
     * @internal
     */
    FirebaseAppImpl.prototype._getService = function (name, instanceIdentifier) {
        if (instanceIdentifier === void 0) { instanceIdentifier = DEFAULT_ENTRY_NAME; }
        this.checkDestroyed_();
        if (!this.services_[name]) {
            this.services_[name] = {};
        }
        if (!this.services_[name][instanceIdentifier]) {
            /**
             * If a custom instance has been defined (i.e. not '[DEFAULT]')
             * then we will pass that instance on, otherwise we pass `null`
             */
            var instanceSpecifier = instanceIdentifier !== DEFAULT_ENTRY_NAME
                ? instanceIdentifier
                : undefined;
            var service = this.firebase_.INTERNAL.factories[name](this, this.extendApp.bind(this), instanceSpecifier);
            this.services_[name][instanceIdentifier] = service;
        }
        return this.services_[name][instanceIdentifier];
    };
    /**
     * Remove a service instance from the cache, so we will create a new instance for this service
     * when people try to get this service again.
     *
     * NOTE: currently only firestore is using this functionality to support firestore shutdown.
     *
     * @param name The service name
     * @param instanceIdentifier instance identifier in case multiple instances are allowed
     * @internal
     */
    FirebaseAppImpl.prototype._removeServiceInstance = function (name, instanceIdentifier) {
        if (instanceIdentifier === void 0) { instanceIdentifier = DEFAULT_ENTRY_NAME; }
        if (this.services_[name] && this.services_[name][instanceIdentifier]) {
            delete this.services_[name][instanceIdentifier];
        }
    };
    /**
     * Callback function used to extend an App instance at the time
     * of service instance creation.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    FirebaseAppImpl.prototype.extendApp = function (props) {
        // Copy the object onto the FirebaseAppImpl prototype
        util.deepExtend(this, props);
        if (props.INTERNAL) {
            /**
             * If the app has overwritten the addAuthTokenListener stub, forward
             * the active token listeners on to the true fxn.
             *
             * TODO: This function is required due to our current module
             * structure. Once we are able to rely strictly upon a single module
             * implementation, this code should be refactored and Auth should
             * provide these stubs and the upgrade logic
             */
            if (props.INTERNAL.addAuthTokenListener) {
                for (var _i = 0, _a = this.tokenListeners_; _i < _a.length; _i++) {
                    var listener = _a[_i];
                    this.INTERNAL.addAuthTokenListener(listener);
                }
                this.tokenListeners_ = [];
            }
            if (props.INTERNAL.analytics) {
                for (var _b = 0, _c = this.analyticsEventRequests_; _b < _c.length; _b++) {
                    var request = _c[_b];
                    // logEvent is the actual implementation at this point.
                    // We forward the queued events to it.
                    this.INTERNAL.analytics.logEvent.apply(undefined, request);
                }
                this.analyticsEventRequests_ = [];
            }
        }
    };
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */
    FirebaseAppImpl.prototype.checkDestroyed_ = function () {
        if (this.isDeleted_) {
            throw ERROR_FACTORY.create("app-deleted" /* APP_DELETED */, { appName: this.name_ });
        }
    };
    return FirebaseAppImpl;
}());
// Prevent dead-code elimination of these methods w/o invalid property
// copying.
(FirebaseAppImpl.prototype.name && FirebaseAppImpl.prototype.options) ||
    FirebaseAppImpl.prototype.delete ||
    console.log('dc');

var version = "7.4.0";

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var logger = new logger$1.Logger('@firebase/app');

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Because auth can't share code with other components, we attach the utility functions
 * in an internal namespace to share code.
 * This function return a firebase namespace object without
 * any utility functions, so it can be shared between the regular firebaseNamespace and
 * the lite version.
 */
function createFirebaseNamespaceCore(firebaseAppImpl) {
    var apps = {};
    var factories = {};
    var appHooks = {};
    // A namespace is a plain JavaScript Object.
    var namespace = {
        // Hack to prevent Babel from modifying the object returned
        // as the firebase namespace.
        // @ts-ignore
        __esModule: true,
        initializeApp: initializeApp,
        // @ts-ignore
        app: app,
        // @ts-ignore
        apps: null,
        SDK_VERSION: version,
        INTERNAL: {
            registerService: registerService,
            removeApp: removeApp,
            factories: factories,
            useAsService: useAsService
        }
    };
    // Inject a circular default export to allow Babel users who were previously
    // using:
    //
    //   import firebase from 'firebase';
    //   which becomes: var firebase = require('firebase').default;
    //
    // instead of
    //
    //   import * as firebase from 'firebase';
    //   which becomes: var firebase = require('firebase');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    namespace['default'] = namespace;
    // firebase.apps is a read-only getter.
    Object.defineProperty(namespace, 'apps', {
        get: getApps
    });
    /**
     * Called by App.delete() - but before any services associated with the App
     * are deleted.
     */
    function removeApp(name) {
        var app = apps[name];
        callAppHooks(app, 'delete');
        delete apps[name];
    }
    /**
     * Get the App object for a given name (or DEFAULT).
     */
    function app(name) {
        name = name || DEFAULT_ENTRY_NAME;
        if (!util.contains(apps, name)) {
            throw ERROR_FACTORY.create("no-app" /* NO_APP */, { appName: name });
        }
        return apps[name];
    }
    // @ts-ignore
    app['App'] = firebaseAppImpl;
    function initializeApp(options, rawConfig) {
        if (rawConfig === void 0) { rawConfig = {}; }
        if (typeof rawConfig !== 'object' || rawConfig === null) {
            var name_1 = rawConfig;
            rawConfig = { name: name_1 };
        }
        var config = rawConfig;
        if (config.name === undefined) {
            config.name = DEFAULT_ENTRY_NAME;
        }
        var name = config.name;
        if (typeof name !== 'string' || !name) {
            throw ERROR_FACTORY.create("bad-app-name" /* BAD_APP_NAME */, {
                appName: String(name)
            });
        }
        if (util.contains(apps, name)) {
            throw ERROR_FACTORY.create("duplicate-app" /* DUPLICATE_APP */, { appName: name });
        }
        var app = new firebaseAppImpl(options, config, namespace);
        apps[name] = app;
        callAppHooks(app, 'create');
        return app;
    }
    /*
     * Return an array of all the non-deleted FirebaseApps.
     */
    function getApps() {
        // Make a copy so caller cannot mutate the apps list.
        return Object.keys(apps).map(function (name) { return apps[name]; });
    }
    /*
     * Register a Firebase Service.
     *
     * firebase.INTERNAL.registerService()
     *
     * TODO: Implement serviceProperties.
     */
    function registerService(name, createService, serviceProperties, appHook, allowMultipleInstances) {
        if (allowMultipleInstances === void 0) { allowMultipleInstances = false; }
        // If re-registering a service that already exists, return existing service
        if (factories[name]) {
            logger.debug("There were multiple attempts to register service " + name + ".");
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return namespace[name];
        }
        // Capture the service factory for later service instantiation
        factories[name] = createService;
        // Capture the appHook, if passed
        if (appHook) {
            appHooks[name] = appHook;
            // Run the **new** app hook on all existing apps
            getApps().forEach(function (app) {
                appHook('create', app);
            });
        }
        // The Service namespace is an accessor function ...
        function serviceNamespace(appArg) {
            if (appArg === void 0) { appArg = app(); }
            // @ts-ignore
            if (typeof appArg[name] !== 'function') {
                // Invalid argument.
                // This happens in the following case: firebase.storage('gs:/')
                throw ERROR_FACTORY.create("invalid-app-argument" /* INVALID_APP_ARGUMENT */, {
                    appName: name
                });
            }
            // Forward service instance lookup to the FirebaseApp.
            // @ts-ignore
            return appArg[name]();
        }
        // ... and a container for service-level properties.
        if (serviceProperties !== undefined) {
            util.deepExtend(serviceNamespace, serviceProperties);
        }
        // Monkey-patch the serviceNamespace onto the firebase namespace
        // @ts-ignore
        namespace[name] = serviceNamespace;
        // Patch the FirebaseAppImpl prototype
        // @ts-ignore
        firebaseAppImpl.prototype[name] =
            // TODO: The eslint disable can be removed and the 'ignoreRestArgs'
            // option added to the no-explicit-any rule when ESlint releases it.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var serviceFxn = this._getService.bind(this, name);
                return serviceFxn.apply(this, allowMultipleInstances ? args : []);
            };
        return serviceNamespace;
    }
    function callAppHooks(app, eventName) {
        for (var _i = 0, _a = Object.keys(factories); _i < _a.length; _i++) {
            var serviceName = _a[_i];
            // Ignore virtual services
            var factoryName = useAsService(app, serviceName);
            if (factoryName === null) {
                return;
            }
            if (appHooks[factoryName]) {
                appHooks[factoryName](eventName, app);
            }
        }
    }
    // Map the requested service to a registered service name
    // (used to map auth to serverAuth service when needed).
    function useAsService(app, name) {
        if (name === 'serverAuth') {
            return null;
        }
        var useService = name;
        return useService;
    }
    return namespace;
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Return a firebase namespace object.
 *
 * In production, this will be called exactly once and the result
 * assigned to the 'firebase' global.  It may be called multiple times
 * in unit tests.
 */
function createFirebaseNamespace() {
    var namespace = createFirebaseNamespaceCore(FirebaseAppImpl);
    namespace.INTERNAL = tslib.__assign(tslib.__assign({}, namespace.INTERNAL), { createFirebaseNamespace: createFirebaseNamespace,
        extendNamespace: extendNamespace,
        createSubscribe: util.createSubscribe,
        ErrorFactory: util.ErrorFactory,
        deepExtend: util.deepExtend });
    /**
     * Patch the top-level firebase namespace with additional properties.
     *
     * firebase.INTERNAL.extendNamespace()
     */
    function extendNamespace(props) {
        util.deepExtend(namespace, props);
    }
    return namespace;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Firebase Lite detection
// eslint-disable-next-line @typescript-eslint/no-explicit-any
if (util.isBrowser() && self.firebase !== undefined) {
    logger.warn("\n    Warning: Firebase is already defined in the global scope. Please make sure\n    Firebase library is only loaded once.\n  ");
    // eslint-disable-next-line
    var sdkVersion = self.firebase.SDK_VERSION;
    if (sdkVersion && sdkVersion.indexOf('LITE') >= 0) {
        logger.warn("\n    Warning: You are trying to load Firebase while using Firebase Performance standalone script.\n    You should load Firebase Performance with this instance of Firebase to avoid loading duplicate code.\n    ");
    }
}
var firebaseNamespace = createFirebaseNamespace();
var initializeApp = firebaseNamespace.initializeApp;
// TODO: This disable can be removed and the 'ignoreRestArgs' option added to
// the no-explicit-any rule when ESlint releases it.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
firebaseNamespace.initializeApp = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    // Environment check before initializing app
    // Do the check in initializeApp, so people have a chance to disable it by setting logLevel
    // in @firebase/logger
    if (util.isNode()) {
        logger.warn("\n      Warning: This is a browser-targeted Firebase bundle but it appears it is being\n      run in a Node environment.  If running in a Node environment, make sure you\n      are using the bundle specified by the \"main\" field in package.json.\n      \n      If you are using Webpack, you can specify \"main\" as the first item in\n      \"resolve.mainFields\":\n      https://webpack.js.org/configuration/resolve/#resolvemainfields\n      \n      If using Rollup, use the rollup-plugin-node-resolve plugin and specify \"main\"\n      as the first item in \"mainFields\", e.g. ['main', 'module'].\n      https://github.com/rollup/rollup-plugin-node-resolve\n      ");
    }
    return initializeApp.apply(undefined, args);
};
var firebase = firebaseNamespace;

exports.default = firebase;
exports.firebase = firebase;
//# sourceMappingURL=index.cjs.js.map


/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["__extends"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["__rest"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["__decorate"] = __decorate;
/* harmony export (immutable) */ __webpack_exports__["__param"] = __param;
/* harmony export (immutable) */ __webpack_exports__["__metadata"] = __metadata;
/* harmony export (immutable) */ __webpack_exports__["__awaiter"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["__generator"] = __generator;
/* harmony export (immutable) */ __webpack_exports__["__exportStar"] = __exportStar;
/* harmony export (immutable) */ __webpack_exports__["__values"] = __values;
/* harmony export (immutable) */ __webpack_exports__["__read"] = __read;
/* harmony export (immutable) */ __webpack_exports__["__spread"] = __spread;
/* harmony export (immutable) */ __webpack_exports__["__spreadArrays"] = __spreadArrays;
/* harmony export (immutable) */ __webpack_exports__["__await"] = __await;
/* harmony export (immutable) */ __webpack_exports__["__asyncGenerator"] = __asyncGenerator;
/* harmony export (immutable) */ __webpack_exports__["__asyncDelegator"] = __asyncDelegator;
/* harmony export (immutable) */ __webpack_exports__["__asyncValues"] = __asyncValues;
/* harmony export (immutable) */ __webpack_exports__["__makeTemplateObject"] = __makeTemplateObject;
/* harmony export (immutable) */ __webpack_exports__["__importStar"] = __importStar;
/* harmony export (immutable) */ __webpack_exports__["__importDefault"] = __importDefault;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(11);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 53 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(1);
var core = __webpack_require__(45);
var fails = __webpack_require__(10);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(46);
var IObject = __webpack_require__(105);
var toObject = __webpack_require__(19);
var toLength = __webpack_require__(15);
var asc = __webpack_require__(179);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = undefined;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactRouterDom = __webpack_require__(23);

var _uuid = __webpack_require__(925);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// installare uuid

var Card = exports.Card = function Card(_ref) {
  var titolo = _ref.titolo,
      titoloDestra = _ref.titoloDestra,
      sottotitolo = _ref.sottotitolo,
      corpo = _ref.corpo,
      lineaNote = _ref.lineaNote,
      progressBar = _ref.progressBar,
      visible = _ref.visible,
      link = _ref.link,
      utente = _ref.utente,
      verkauft = _ref.verkauft;

  if (visible || utente.role === 'Admin') {
    return _react2.default.createElement(
      'div',
      { className: 'row' },
      _react2.default.createElement(
        'div',
        { className: 'col s12' },
        _react2.default.createElement(
          'div',
          { className: 'card' },
          _react2.default.createElement(
            'div',
            { className: 'card-content' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col s12 m8' },
                _react2.default.createElement(
                  'div',
                  { className: visible ? '' : 'disabled' },
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      _reactRouterDom.Link,
                      { to: link },
                      _react2.default.createElement(
                        'span',
                        { className: 'card-title' },
                        titolo
                      )
                    ),
                    _react2.default.createElement(
                      'h6',
                      null,
                      sottotitolo
                    ),
                    corpo.map(function (linea) {
                      return _react2.default.createElement(
                        'div',
                        { key: (0, _uuid.v4)() },
                        linea
                      );
                    }),
                    _react2.default.createElement(
                      'div',
                      null,
                      lineaNote
                    ),
                    progressBar,
                    verkauft
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'span',
                  { className: 'right' },
                  titoloDestra,
                  ' '
                )
              )
            )
          )
        )
      )
    );
  } else {
    return _react2.default.createElement('div', null);
  }
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    utente: state.utenti.find(function (utente) {
      return utente.firebaseAuthId === state.auth.uid;
    })
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Card);

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(28);
var core = __webpack_require__(22);
var ctx = __webpack_require__(118);
var hide = __webpack_require__(87);
var has = __webpack_require__(88);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactModal = __webpack_require__(1079);

var _reactModal2 = _interopRequireDefault(_reactModal);

var _ClientiList = __webpack_require__(125);

var _ClientiList2 = _interopRequireDefault(_ClientiList);

var _reactI18next = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OptionModal = function OptionModal(_ref) {
  var modalContent = _ref.modalContent,
      isOpen = _ref.isOpen,
      contentLabel = _ref.contentLabel,
      onCancel = _ref.onCancel,
      onConfirm = _ref.onConfirm,
      btnEnabled = _ref.btnEnabled,
      t = _ref.t;
  return _react2.default.createElement(
    _reactModal2.default,
    {
      isOpen: !!isOpen,
      contentLabel: contentLabel,
      onRequestClose: onCancel,
      closeTimeoutMS: 100,
      className: 'confirmation-modal',
      ariaHideApp: false
    },
    _react2.default.createElement(
      'div',
      null,
      modalContent instanceof Array ? _react2.default.createElement(_ClientiList2.default, { cliente: modalContent }) : _react2.default.createElement(
        'h5',
        null,
        modalContent
      ),
      _react2.default.createElement(
        'div',
        { className: 'confirmation-modal__btn-wrapper' },
        btnEnabled && _react2.default.createElement(
          'button',
          {
            className: 'btn green btn-margin',
            onClick: function onClick() {
              onConfirm();
            }
          },
          t('btn_label_confirm')
        ),
        _react2.default.createElement(
          'button',
          {
            className: 'btn blue btn-margin',
            onClick: function onClick() {
              onCancel();
            }
          },
          t('btn_label_close')
        )
      )
    )
  );
};

exports.default = (0, _reactI18next.withTranslation)()(OptionModal);

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(16)) {
  var LIBRARY = __webpack_require__(63);
  var global = __webpack_require__(8);
  var fails = __webpack_require__(10);
  var $export = __webpack_require__(1);
  var $typed = __webpack_require__(136);
  var $buffer = __webpack_require__(187);
  var ctx = __webpack_require__(46);
  var anInstance = __webpack_require__(81);
  var propertyDesc = __webpack_require__(74);
  var hide = __webpack_require__(33);
  var redefineAll = __webpack_require__(83);
  var toInteger = __webpack_require__(48);
  var toLength = __webpack_require__(15);
  var toIndex = __webpack_require__(253);
  var toAbsoluteIndex = __webpack_require__(77);
  var toPrimitive = __webpack_require__(52);
  var has = __webpack_require__(40);
  var classof = __webpack_require__(91);
  var isObject = __webpack_require__(11);
  var toObject = __webpack_require__(19);
  var isArrayIter = __webpack_require__(176);
  var create = __webpack_require__(78);
  var getPrototypeOf = __webpack_require__(43);
  var gOPN = __webpack_require__(79).f;
  var getIterFn = __webpack_require__(178);
  var uid = __webpack_require__(75);
  var wks = __webpack_require__(13);
  var createArrayMethod = __webpack_require__(55);
  var createArrayIncludes = __webpack_require__(126);
  var speciesConstructor = __webpack_require__(108);
  var ArrayIterators = __webpack_require__(181);
  var Iterators = __webpack_require__(93);
  var $iterDetect = __webpack_require__(131);
  var setSpecies = __webpack_require__(80);
  var arrayFill = __webpack_require__(180);
  var arrayCopyWithin = __webpack_require__(242);
  var $DP = __webpack_require__(17);
  var $GOPD = __webpack_require__(42);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(248);
var $export = __webpack_require__(1);
var shared = __webpack_require__(104)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(251))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Materialize v1.0.0-rc.2 (http://materializecss.com)
 * Copyright 2014-2017 Materialize
 * MIT License (https://raw.githubusercontent.com/Dogfalo/materialize/master/LICENSE)
 */
var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*! cash-dom 1.3.5, https://github.com/kenwheeler/cash @license MIT */
(function (factory) {
  window.cash = factory();
})(function () {
  var doc = document,
      win = window,
      ArrayProto = Array.prototype,
      slice = ArrayProto.slice,
      filter = ArrayProto.filter,
      push = ArrayProto.push;

  var noop = function () {},
      isFunction = function (item) {
    // @see https://crbug.com/568448
    return typeof item === typeof noop && item.call;
  },
      isString = function (item) {
    return typeof item === typeof "";
  };

  var idMatch = /^#[\w-]*$/,
      classMatch = /^\.[\w-]*$/,
      htmlMatch = /<.+>/,
      singlet = /^\w+$/;

  function find(selector, context) {
    context = context || doc;
    var elems = classMatch.test(selector) ? context.getElementsByClassName(selector.slice(1)) : singlet.test(selector) ? context.getElementsByTagName(selector) : context.querySelectorAll(selector);
    return elems;
  }

  var frag;
  function parseHTML(str) {
    if (!frag) {
      frag = doc.implementation.createHTMLDocument(null);
      var base = frag.createElement("base");
      base.href = doc.location.href;
      frag.head.appendChild(base);
    }

    frag.body.innerHTML = str;

    return frag.body.childNodes;
  }

  function onReady(fn) {
    if (doc.readyState !== "loading") {
      fn();
    } else {
      doc.addEventListener("DOMContentLoaded", fn);
    }
  }

  function Init(selector, context) {
    if (!selector) {
      return this;
    }

    // If already a cash collection, don't do any further processing
    if (selector.cash && selector !== win) {
      return selector;
    }

    var elems = selector,
        i = 0,
        length;

    if (isString(selector)) {
      elems = idMatch.test(selector) ?
      // If an ID use the faster getElementById check
      doc.getElementById(selector.slice(1)) : htmlMatch.test(selector) ?
      // If HTML, parse it into real elements
      parseHTML(selector) :
      // else use `find`
      find(selector, context);

      // If function, use as shortcut for DOM ready
    } else if (isFunction(selector)) {
      onReady(selector);return this;
    }

    if (!elems) {
      return this;
    }

    // If a single DOM element is passed in or received via ID, return the single element
    if (elems.nodeType || elems === win) {
      this[0] = elems;
      this.length = 1;
    } else {
      // Treat like an array and loop through each item.
      length = this.length = elems.length;
      for (; i < length; i++) {
        this[i] = elems[i];
      }
    }

    return this;
  }

  function cash(selector, context) {
    return new Init(selector, context);
  }

  var fn = cash.fn = cash.prototype = Init.prototype = { // jshint ignore:line
    cash: true,
    length: 0,
    push: push,
    splice: ArrayProto.splice,
    map: ArrayProto.map,
    init: Init
  };

  Object.defineProperty(fn, "constructor", { value: cash });

  cash.parseHTML = parseHTML;
  cash.noop = noop;
  cash.isFunction = isFunction;
  cash.isString = isString;

  cash.extend = fn.extend = function (target) {
    target = target || {};

    var args = slice.call(arguments),
        length = args.length,
        i = 1;

    if (args.length === 1) {
      target = this;
      i = 0;
    }

    for (; i < length; i++) {
      if (!args[i]) {
        continue;
      }
      for (var key in args[i]) {
        if (args[i].hasOwnProperty(key)) {
          target[key] = args[i][key];
        }
      }
    }

    return target;
  };

  function each(collection, callback) {
    var l = collection.length,
        i = 0;

    for (; i < l; i++) {
      if (callback.call(collection[i], collection[i], i, collection) === false) {
        break;
      }
    }
  }

  function matches(el, selector) {
    var m = el && (el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector || el.oMatchesSelector);
    return !!m && m.call(el, selector);
  }

  function getCompareFunction(selector) {
    return (
      /* Use browser's `matches` function if string */
      isString(selector) ? matches :
      /* Match a cash element */
      selector.cash ? function (el) {
        return selector.is(el);
      } :
      /* Direct comparison */
      function (el, selector) {
        return el === selector;
      }
    );
  }

  function unique(collection) {
    return cash(slice.call(collection).filter(function (item, index, self) {
      return self.indexOf(item) === index;
    }));
  }

  cash.extend({
    merge: function (first, second) {
      var len = +second.length,
          i = first.length,
          j = 0;

      for (; j < len; i++, j++) {
        first[i] = second[j];
      }

      first.length = i;
      return first;
    },

    each: each,
    matches: matches,
    unique: unique,
    isArray: Array.isArray,
    isNumeric: function (n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }

  });

  var uid = cash.uid = "_cash" + Date.now();

  function getDataCache(node) {
    return node[uid] = node[uid] || {};
  }

  function setData(node, key, value) {
    return getDataCache(node)[key] = value;
  }

  function getData(node, key) {
    var c = getDataCache(node);
    if (c[key] === undefined) {
      c[key] = node.dataset ? node.dataset[key] : cash(node).attr("data-" + key);
    }
    return c[key];
  }

  function removeData(node, key) {
    var c = getDataCache(node);
    if (c) {
      delete c[key];
    } else if (node.dataset) {
      delete node.dataset[key];
    } else {
      cash(node).removeAttr("data-" + name);
    }
  }

  fn.extend({
    data: function (name, value) {
      if (isString(name)) {
        return value === undefined ? getData(this[0], name) : this.each(function (v) {
          return setData(v, name, value);
        });
      }

      for (var key in name) {
        this.data(key, name[key]);
      }

      return this;
    },

    removeData: function (key) {
      return this.each(function (v) {
        return removeData(v, key);
      });
    }

  });

  var notWhiteMatch = /\S+/g;

  function getClasses(c) {
    return isString(c) && c.match(notWhiteMatch);
  }

  function hasClass(v, c) {
    return v.classList ? v.classList.contains(c) : new RegExp("(^| )" + c + "( |$)", "gi").test(v.className);
  }

  function addClass(v, c, spacedName) {
    if (v.classList) {
      v.classList.add(c);
    } else if (spacedName.indexOf(" " + c + " ")) {
      v.className += " " + c;
    }
  }

  function removeClass(v, c) {
    if (v.classList) {
      v.classList.remove(c);
    } else {
      v.className = v.className.replace(c, "");
    }
  }

  fn.extend({
    addClass: function (c) {
      var classes = getClasses(c);

      return classes ? this.each(function (v) {
        var spacedName = " " + v.className + " ";
        each(classes, function (c) {
          addClass(v, c, spacedName);
        });
      }) : this;
    },

    attr: function (name, value) {
      if (!name) {
        return undefined;
      }

      if (isString(name)) {
        if (value === undefined) {
          return this[0] ? this[0].getAttribute ? this[0].getAttribute(name) : this[0][name] : undefined;
        }

        return this.each(function (v) {
          if (v.setAttribute) {
            v.setAttribute(name, value);
          } else {
            v[name] = value;
          }
        });
      }

      for (var key in name) {
        this.attr(key, name[key]);
      }

      return this;
    },

    hasClass: function (c) {
      var check = false,
          classes = getClasses(c);
      if (classes && classes.length) {
        this.each(function (v) {
          check = hasClass(v, classes[0]);
          return !check;
        });
      }
      return check;
    },

    prop: function (name, value) {
      if (isString(name)) {
        return value === undefined ? this[0][name] : this.each(function (v) {
          v[name] = value;
        });
      }

      for (var key in name) {
        this.prop(key, name[key]);
      }

      return this;
    },

    removeAttr: function (name) {
      return this.each(function (v) {
        if (v.removeAttribute) {
          v.removeAttribute(name);
        } else {
          delete v[name];
        }
      });
    },

    removeClass: function (c) {
      if (!arguments.length) {
        return this.attr("class", "");
      }
      var classes = getClasses(c);
      return classes ? this.each(function (v) {
        each(classes, function (c) {
          removeClass(v, c);
        });
      }) : this;
    },

    removeProp: function (name) {
      return this.each(function (v) {
        delete v[name];
      });
    },

    toggleClass: function (c, state) {
      if (state !== undefined) {
        return this[state ? "addClass" : "removeClass"](c);
      }
      var classes = getClasses(c);
      return classes ? this.each(function (v) {
        var spacedName = " " + v.className + " ";
        each(classes, function (c) {
          if (hasClass(v, c)) {
            removeClass(v, c);
          } else {
            addClass(v, c, spacedName);
          }
        });
      }) : this;
    } });

  fn.extend({
    add: function (selector, context) {
      return unique(cash.merge(this, cash(selector, context)));
    },

    each: function (callback) {
      each(this, callback);
      return this;
    },

    eq: function (index) {
      return cash(this.get(index));
    },

    filter: function (selector) {
      if (!selector) {
        return this;
      }

      var comparator = isFunction(selector) ? selector : getCompareFunction(selector);

      return cash(filter.call(this, function (e) {
        return comparator(e, selector);
      }));
    },

    first: function () {
      return this.eq(0);
    },

    get: function (index) {
      if (index === undefined) {
        return slice.call(this);
      }
      return index < 0 ? this[index + this.length] : this[index];
    },

    index: function (elem) {
      var child = elem ? cash(elem)[0] : this[0],
          collection = elem ? this : cash(child).parent().children();
      return slice.call(collection).indexOf(child);
    },

    last: function () {
      return this.eq(-1);
    }

  });

  var camelCase = function () {
    var camelRegex = /(?:^\w|[A-Z]|\b\w)/g,
        whiteSpace = /[\s-_]+/g;
    return function (str) {
      return str.replace(camelRegex, function (letter, index) {
        return letter[index === 0 ? "toLowerCase" : "toUpperCase"]();
      }).replace(whiteSpace, "");
    };
  }();

  var getPrefixedProp = function () {
    var cache = {},
        doc = document,
        div = doc.createElement("div"),
        style = div.style;

    return function (prop) {
      prop = camelCase(prop);
      if (cache[prop]) {
        return cache[prop];
      }

      var ucProp = prop.charAt(0).toUpperCase() + prop.slice(1),
          prefixes = ["webkit", "moz", "ms", "o"],
          props = (prop + " " + prefixes.join(ucProp + " ") + ucProp).split(" ");

      each(props, function (p) {
        if (p in style) {
          cache[p] = prop = cache[prop] = p;
          return false;
        }
      });

      return cache[prop];
    };
  }();

  cash.prefixedProp = getPrefixedProp;
  cash.camelCase = camelCase;

  fn.extend({
    css: function (prop, value) {
      if (isString(prop)) {
        prop = getPrefixedProp(prop);
        return arguments.length > 1 ? this.each(function (v) {
          return v.style[prop] = value;
        }) : win.getComputedStyle(this[0])[prop];
      }

      for (var key in prop) {
        this.css(key, prop[key]);
      }

      return this;
    }

  });

  function compute(el, prop) {
    return parseInt(win.getComputedStyle(el[0], null)[prop], 10) || 0;
  }

  each(["Width", "Height"], function (v) {
    var lower = v.toLowerCase();

    fn[lower] = function () {
      return this[0].getBoundingClientRect()[lower];
    };

    fn["inner" + v] = function () {
      return this[0]["client" + v];
    };

    fn["outer" + v] = function (margins) {
      return this[0]["offset" + v] + (margins ? compute(this, "margin" + (v === "Width" ? "Left" : "Top")) + compute(this, "margin" + (v === "Width" ? "Right" : "Bottom")) : 0);
    };
  });

  function registerEvent(node, eventName, callback) {
    var eventCache = getData(node, "_cashEvents") || setData(node, "_cashEvents", {});
    eventCache[eventName] = eventCache[eventName] || [];
    eventCache[eventName].push(callback);
    node.addEventListener(eventName, callback);
  }

  function removeEvent(node, eventName, callback) {
    var events = getData(node, "_cashEvents"),
        eventCache = events && events[eventName],
        index;

    if (!eventCache) {
      return;
    }

    if (callback) {
      node.removeEventListener(eventName, callback);
      index = eventCache.indexOf(callback);
      if (index >= 0) {
        eventCache.splice(index, 1);
      }
    } else {
      each(eventCache, function (event) {
        node.removeEventListener(eventName, event);
      });
      eventCache = [];
    }
  }

  fn.extend({
    off: function (eventName, callback) {
      return this.each(function (v) {
        return removeEvent(v, eventName, callback);
      });
    },

    on: function (eventName, delegate, callback, runOnce) {
      // jshint ignore:line
      var originalCallback;
      if (!isString(eventName)) {
        for (var key in eventName) {
          this.on(key, delegate, eventName[key]);
        }
        return this;
      }

      if (isFunction(delegate)) {
        callback = delegate;
        delegate = null;
      }

      if (eventName === "ready") {
        onReady(callback);
        return this;
      }

      if (delegate) {
        originalCallback = callback;
        callback = function (e) {
          var t = e.target;
          while (!matches(t, delegate)) {
            if (t === this || t === null) {
              return t = false;
            }

            t = t.parentNode;
          }

          if (t) {
            originalCallback.call(t, e);
          }
        };
      }

      return this.each(function (v) {
        var finalCallback = callback;
        if (runOnce) {
          finalCallback = function () {
            callback.apply(this, arguments);
            removeEvent(v, eventName, finalCallback);
          };
        }
        registerEvent(v, eventName, finalCallback);
      });
    },

    one: function (eventName, delegate, callback) {
      return this.on(eventName, delegate, callback, true);
    },

    ready: onReady,

    /**
     * Modified
     * Triggers browser event
     * @param String eventName
     * @param Object data - Add properties to event object
     */
    trigger: function (eventName, data) {
      if (document.createEvent) {
        var evt = document.createEvent('HTMLEvents');
        evt.initEvent(eventName, true, false);
        evt = this.extend(evt, data);
        return this.each(function (v) {
          return v.dispatchEvent(evt);
        });
      }
    }

  });

  function encode(name, value) {
    return "&" + encodeURIComponent(name) + "=" + encodeURIComponent(value).replace(/%20/g, "+");
  }

  function getSelectMultiple_(el) {
    var values = [];
    each(el.options, function (o) {
      if (o.selected) {
        values.push(o.value);
      }
    });
    return values.length ? values : null;
  }

  function getSelectSingle_(el) {
    var selectedIndex = el.selectedIndex;
    return selectedIndex >= 0 ? el.options[selectedIndex].value : null;
  }

  function getValue(el) {
    var type = el.type;
    if (!type) {
      return null;
    }
    switch (type.toLowerCase()) {
      case "select-one":
        return getSelectSingle_(el);
      case "select-multiple":
        return getSelectMultiple_(el);
      case "radio":
        return el.checked ? el.value : null;
      case "checkbox":
        return el.checked ? el.value : null;
      default:
        return el.value ? el.value : null;
    }
  }

  fn.extend({
    serialize: function () {
      var query = "";

      each(this[0].elements || this, function (el) {
        if (el.disabled || el.tagName === "FIELDSET") {
          return;
        }
        var name = el.name;
        switch (el.type.toLowerCase()) {
          case "file":
          case "reset":
          case "submit":
          case "button":
            break;
          case "select-multiple":
            var values = getValue(el);
            if (values !== null) {
              each(values, function (value) {
                query += encode(name, value);
              });
            }
            break;
          default:
            var value = getValue(el);
            if (value !== null) {
              query += encode(name, value);
            }
        }
      });

      return query.substr(1);
    },

    val: function (value) {
      if (value === undefined) {
        return getValue(this[0]);
      }

      return this.each(function (v) {
        return v.value = value;
      });
    }

  });

  function insertElement(el, child, prepend) {
    if (prepend) {
      var first = el.childNodes[0];
      el.insertBefore(child, first);
    } else {
      el.appendChild(child);
    }
  }

  function insertContent(parent, child, prepend) {
    var str = isString(child);

    if (!str && child.length) {
      each(child, function (v) {
        return insertContent(parent, v, prepend);
      });
      return;
    }

    each(parent, str ? function (v) {
      return v.insertAdjacentHTML(prepend ? "afterbegin" : "beforeend", child);
    } : function (v, i) {
      return insertElement(v, i === 0 ? child : child.cloneNode(true), prepend);
    });
  }

  fn.extend({
    after: function (selector) {
      cash(selector).insertAfter(this);
      return this;
    },

    append: function (content) {
      insertContent(this, content);
      return this;
    },

    appendTo: function (parent) {
      insertContent(cash(parent), this);
      return this;
    },

    before: function (selector) {
      cash(selector).insertBefore(this);
      return this;
    },

    clone: function () {
      return cash(this.map(function (v) {
        return v.cloneNode(true);
      }));
    },

    empty: function () {
      this.html("");
      return this;
    },

    html: function (content) {
      if (content === undefined) {
        return this[0].innerHTML;
      }
      var source = content.nodeType ? content[0].outerHTML : content;
      return this.each(function (v) {
        return v.innerHTML = source;
      });
    },

    insertAfter: function (selector) {
      var _this = this;

      cash(selector).each(function (el, i) {
        var parent = el.parentNode,
            sibling = el.nextSibling;
        _this.each(function (v) {
          parent.insertBefore(i === 0 ? v : v.cloneNode(true), sibling);
        });
      });

      return this;
    },

    insertBefore: function (selector) {
      var _this2 = this;
      cash(selector).each(function (el, i) {
        var parent = el.parentNode;
        _this2.each(function (v) {
          parent.insertBefore(i === 0 ? v : v.cloneNode(true), el);
        });
      });
      return this;
    },

    prepend: function (content) {
      insertContent(this, content, true);
      return this;
    },

    prependTo: function (parent) {
      insertContent(cash(parent), this, true);
      return this;
    },

    remove: function () {
      return this.each(function (v) {
        if (!!v.parentNode) {
          return v.parentNode.removeChild(v);
        }
      });
    },

    text: function (content) {
      if (content === undefined) {
        return this[0].textContent;
      }
      return this.each(function (v) {
        return v.textContent = content;
      });
    }

  });

  var docEl = doc.documentElement;

  fn.extend({
    position: function () {
      var el = this[0];
      return {
        left: el.offsetLeft,
        top: el.offsetTop
      };
    },

    offset: function () {
      var rect = this[0].getBoundingClientRect();
      return {
        top: rect.top + win.pageYOffset - docEl.clientTop,
        left: rect.left + win.pageXOffset - docEl.clientLeft
      };
    },

    offsetParent: function () {
      return cash(this[0].offsetParent);
    }

  });

  fn.extend({
    children: function (selector) {
      var elems = [];
      this.each(function (el) {
        push.apply(elems, el.children);
      });
      elems = unique(elems);

      return !selector ? elems : elems.filter(function (v) {
        return matches(v, selector);
      });
    },

    closest: function (selector) {
      if (!selector || this.length < 1) {
        return cash();
      }
      if (this.is(selector)) {
        return this.filter(selector);
      }
      return this.parent().closest(selector);
    },

    is: function (selector) {
      if (!selector) {
        return false;
      }

      var match = false,
          comparator = getCompareFunction(selector);

      this.each(function (el) {
        match = comparator(el, selector);
        return !match;
      });

      return match;
    },

    find: function (selector) {
      if (!selector || selector.nodeType) {
        return cash(selector && this.has(selector).length ? selector : null);
      }

      var elems = [];
      this.each(function (el) {
        push.apply(elems, find(selector, el));
      });

      return unique(elems);
    },

    has: function (selector) {
      var comparator = isString(selector) ? function (el) {
        return find(selector, el).length !== 0;
      } : function (el) {
        return el.contains(selector);
      };

      return this.filter(comparator);
    },

    next: function () {
      return cash(this[0].nextElementSibling);
    },

    not: function (selector) {
      if (!selector) {
        return this;
      }

      var comparator = getCompareFunction(selector);

      return this.filter(function (el) {
        return !comparator(el, selector);
      });
    },

    parent: function () {
      var result = [];

      this.each(function (item) {
        if (item && item.parentNode) {
          result.push(item.parentNode);
        }
      });

      return unique(result);
    },

    parents: function (selector) {
      var last,
          result = [];

      this.each(function (item) {
        last = item;

        while (last && last.parentNode && last !== doc.body.parentNode) {
          last = last.parentNode;

          if (!selector || selector && matches(last, selector)) {
            result.push(last);
          }
        }
      });

      return unique(result);
    },

    prev: function () {
      return cash(this[0].previousElementSibling);
    },

    siblings: function (selector) {
      var collection = this.parent().children(selector),
          el = this[0];

      return collection.filter(function (i) {
        return i !== el;
      });
    }

  });

  return cash;
});
;
var Component = function () {
  /**
   * Generic constructor for all components
   * @constructor
   * @param {Element} el
   * @param {Object} options
   */
  function Component(classDef, el, options) {
    _classCallCheck(this, Component);

    // Display error if el is valid HTML Element
    if (!(el instanceof Element)) {
      console.error(Error(el + ' is not an HTML Element'));
    }

    // If exists, destroy and reinitialize in child
    var ins = classDef.getInstance(el);
    if (!!ins) {
      ins.destroy();
    }

    this.el = el;
    this.$el = cash(el);
  }

  /**
   * Initializes components
   * @param {class} classDef
   * @param {Element | NodeList | jQuery} els
   * @param {Object} options
   */


  _createClass(Component, null, [{
    key: "init",
    value: function init(classDef, els, options) {
      var instances = null;
      if (els instanceof Element) {
        instances = new classDef(els, options);
      } else if (!!els && (els.jquery || els.cash || els instanceof NodeList)) {
        var instancesArr = [];
        for (var i = 0; i < els.length; i++) {
          instancesArr.push(new classDef(els[i], options));
        }
        instances = instancesArr;
      }

      return instances;
    }
  }]);

  return Component;
}();

; // Required for Meteor package, the use of window prevents export by Meteor
(function (window) {
  if (window.Package) {
    M = {};
  } else {
    window.M = {};
  }

  // Check for jQuery
  M.jQueryLoaded = !!window.jQuery;
})(window);

// AMD
if (true) {
  !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
    return M;
  }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

  // Common JS
} else if (typeof exports !== 'undefined' && !exports.nodeType) {
  if (typeof module !== 'undefined' && !module.nodeType && module.exports) {
    exports = module.exports = M;
  }
  exports.default = M;
}

M.keys = {
  TAB: 9,
  ENTER: 13,
  ESC: 27,
  ARROW_UP: 38,
  ARROW_DOWN: 40
};

/**
 * TabPress Keydown handler
 */
M.tabPressed = false;
M.keyDown = false;
var docHandleKeydown = function (e) {
  M.keyDown = true;
  if (e.which === M.keys.TAB || e.which === M.keys.ARROW_DOWN || e.which === M.keys.ARROW_UP) {
    M.tabPressed = true;
  }
};
var docHandleKeyup = function (e) {
  M.keyDown = false;
  if (e.which === M.keys.TAB || e.which === M.keys.ARROW_DOWN || e.which === M.keys.ARROW_UP) {
    M.tabPressed = false;
  }
};
var docHandleFocus = function (e) {
  if (M.keyDown) {
    document.body.classList.add('keyboard-focused');
  }
};
var docHandleBlur = function (e) {
  document.body.classList.remove('keyboard-focused');
};
document.addEventListener('keydown', docHandleKeydown, true);
document.addEventListener('keyup', docHandleKeyup, true);
document.addEventListener('focus', docHandleFocus, true);
document.addEventListener('blur', docHandleBlur, true);

/**
 * Initialize jQuery wrapper for plugin
 * @param {Class} plugin  javascript class
 * @param {string} pluginName  jQuery plugin name
 * @param {string} classRef  Class reference name
 */
M.initializeJqueryWrapper = function (plugin, pluginName, classRef) {
  jQuery.fn[pluginName] = function (methodOrOptions) {
    // Call plugin method if valid method name is passed in
    if (plugin.prototype[methodOrOptions]) {
      var params = Array.prototype.slice.call(arguments, 1);

      // Getter methods
      if (methodOrOptions.slice(0, 3) === 'get') {
        var instance = this.first()[0][classRef];
        return instance[methodOrOptions].apply(instance, params);
      }

      // Void methods
      return this.each(function () {
        var instance = this[classRef];
        instance[methodOrOptions].apply(instance, params);
      });

      // Initialize plugin if options or no argument is passed in
    } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
      plugin.init(this, arguments[0]);
      return this;
    }

    // Return error if an unrecognized  method name is passed in
    jQuery.error("Method " + methodOrOptions + " does not exist on jQuery." + pluginName);
  };
};

/**
 * Automatically initialize components
 * @param {Element} context  DOM Element to search within for components
 */
M.AutoInit = function (context) {
  // Use document.body if no context is given
  var root = !!context ? context : document.body;

  var registry = {
    Autocomplete: root.querySelectorAll('.autocomplete:not(.no-autoinit)'),
    Carousel: root.querySelectorAll('.carousel:not(.no-autoinit)'),
    Chips: root.querySelectorAll('.chips:not(.no-autoinit)'),
    Collapsible: root.querySelectorAll('.collapsible:not(.no-autoinit)'),
    Datepicker: root.querySelectorAll('.datepicker:not(.no-autoinit)'),
    Dropdown: root.querySelectorAll('.dropdown-trigger:not(.no-autoinit)'),
    Materialbox: root.querySelectorAll('.materialboxed:not(.no-autoinit)'),
    Modal: root.querySelectorAll('.modal:not(.no-autoinit)'),
    Parallax: root.querySelectorAll('.parallax:not(.no-autoinit)'),
    Pushpin: root.querySelectorAll('.pushpin:not(.no-autoinit)'),
    ScrollSpy: root.querySelectorAll('.scrollspy:not(.no-autoinit)'),
    FormSelect: root.querySelectorAll('select:not(.no-autoinit)'),
    Sidenav: root.querySelectorAll('.sidenav:not(.no-autoinit)'),
    Tabs: root.querySelectorAll('.tabs:not(.no-autoinit)'),
    TapTarget: root.querySelectorAll('.tap-target:not(.no-autoinit)'),
    Timepicker: root.querySelectorAll('.timepicker:not(.no-autoinit)'),
    Tooltip: root.querySelectorAll('.tooltipped:not(.no-autoinit)'),
    FloatingActionButton: root.querySelectorAll('.fixed-action-btn:not(.no-autoinit)')
  };

  for (var pluginName in registry) {
    var plugin = M[pluginName];
    plugin.init(registry[pluginName]);
  }
};

/**
 * Generate approximated selector string for a jQuery object
 * @param {jQuery} obj  jQuery object to be parsed
 * @returns {string}
 */
M.objectSelectorString = function (obj) {
  var tagStr = obj.prop('tagName') || '';
  var idStr = obj.attr('id') || '';
  var classStr = obj.attr('class') || '';
  return (tagStr + idStr + classStr).replace(/\s/g, '');
};

// Unique Random ID
M.guid = function () {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }
  return function () {
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  };
}();

/**
 * Escapes hash from special characters
 * @param {string} hash  String returned from this.hash
 * @returns {string}
 */
M.escapeHash = function (hash) {
  return hash.replace(/(:|\.|\[|\]|,|=|\/)/g, '\\$1');
};

M.elementOrParentIsFixed = function (element) {
  var $element = $(element);
  var $checkElements = $element.add($element.parents());
  var isFixed = false;
  $checkElements.each(function () {
    if ($(this).css('position') === 'fixed') {
      isFixed = true;
      return false;
    }
  });
  return isFixed;
};

/**
 * @typedef {Object} Edges
 * @property {Boolean} top  If the top edge was exceeded
 * @property {Boolean} right  If the right edge was exceeded
 * @property {Boolean} bottom  If the bottom edge was exceeded
 * @property {Boolean} left  If the left edge was exceeded
 */

/**
 * @typedef {Object} Bounding
 * @property {Number} left  left offset coordinate
 * @property {Number} top  top offset coordinate
 * @property {Number} width
 * @property {Number} height
 */

/**
 * Escapes hash from special characters
 * @param {Element} container  Container element that acts as the boundary
 * @param {Bounding} bounding  element bounding that is being checked
 * @param {Number} offset  offset from edge that counts as exceeding
 * @returns {Edges}
 */
M.checkWithinContainer = function (container, bounding, offset) {
  var edges = {
    top: false,
    right: false,
    bottom: false,
    left: false
  };

  var containerRect = container.getBoundingClientRect();
  // If body element is smaller than viewport, use viewport height instead.
  var containerBottom = container === document.body ? Math.max(containerRect.bottom, window.innerHeight) : containerRect.bottom;

  var scrollLeft = container.scrollLeft;
  var scrollTop = container.scrollTop;

  var scrolledX = bounding.left - scrollLeft;
  var scrolledY = bounding.top - scrollTop;

  // Check for container and viewport for each edge
  if (scrolledX < containerRect.left + offset || scrolledX < offset) {
    edges.left = true;
  }

  if (scrolledX + bounding.width > containerRect.right - offset || scrolledX + bounding.width > window.innerWidth - offset) {
    edges.right = true;
  }

  if (scrolledY < containerRect.top + offset || scrolledY < offset) {
    edges.top = true;
  }

  if (scrolledY + bounding.height > containerBottom - offset || scrolledY + bounding.height > window.innerHeight - offset) {
    edges.bottom = true;
  }

  return edges;
};

M.checkPossibleAlignments = function (el, container, bounding, offset) {
  var canAlign = {
    top: true,
    right: true,
    bottom: true,
    left: true,
    spaceOnTop: null,
    spaceOnRight: null,
    spaceOnBottom: null,
    spaceOnLeft: null
  };

  var containerAllowsOverflow = getComputedStyle(container).overflow === 'visible';
  var containerRect = container.getBoundingClientRect();
  var containerHeight = Math.min(containerRect.height, window.innerHeight);
  var containerWidth = Math.min(containerRect.width, window.innerWidth);
  var elOffsetRect = el.getBoundingClientRect();

  var scrollLeft = container.scrollLeft;
  var scrollTop = container.scrollTop;

  var scrolledX = bounding.left - scrollLeft;
  var scrolledYTopEdge = bounding.top - scrollTop;
  var scrolledYBottomEdge = bounding.top + elOffsetRect.height - scrollTop;

  // Check for container and viewport for left
  canAlign.spaceOnRight = !containerAllowsOverflow ? containerWidth - (scrolledX + bounding.width) : window.innerWidth - (elOffsetRect.left + bounding.width);
  if (canAlign.spaceOnRight < 0) {
    canAlign.left = false;
  }

  // Check for container and viewport for Right
  canAlign.spaceOnLeft = !containerAllowsOverflow ? scrolledX - bounding.width + elOffsetRect.width : elOffsetRect.right - bounding.width;
  if (canAlign.spaceOnLeft < 0) {
    canAlign.right = false;
  }

  // Check for container and viewport for Top
  canAlign.spaceOnBottom = !containerAllowsOverflow ? containerHeight - (scrolledYTopEdge + bounding.height + offset) : window.innerHeight - (elOffsetRect.top + bounding.height + offset);
  if (canAlign.spaceOnBottom < 0) {
    canAlign.top = false;
  }

  // Check for container and viewport for Bottom
  canAlign.spaceOnTop = !containerAllowsOverflow ? scrolledYBottomEdge - (bounding.height - offset) : elOffsetRect.bottom - (bounding.height + offset);
  if (canAlign.spaceOnTop < 0) {
    canAlign.bottom = false;
  }

  return canAlign;
};

M.getOverflowParent = function (element) {
  if (element == null) {
    return null;
  }

  if (element === document.body || getComputedStyle(element).overflow !== 'visible') {
    return element;
  }

  return M.getOverflowParent(element.parentElement);
};

/**
 * Gets id of component from a trigger
 * @param {Element} trigger  trigger
 * @returns {string}
 */
M.getIdFromTrigger = function (trigger) {
  var id = trigger.getAttribute('data-target');
  if (!id) {
    id = trigger.getAttribute('href');
    if (id) {
      id = id.slice(1);
    } else {
      id = '';
    }
  }
  return id;
};

/**
 * Multi browser support for document scroll top
 * @returns {Number}
 */
M.getDocumentScrollTop = function () {
  return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
};

/**
 * Multi browser support for document scroll left
 * @returns {Number}
 */
M.getDocumentScrollLeft = function () {
  return window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
};

/**
 * @typedef {Object} Edges
 * @property {Boolean} top  If the top edge was exceeded
 * @property {Boolean} right  If the right edge was exceeded
 * @property {Boolean} bottom  If the bottom edge was exceeded
 * @property {Boolean} left  If the left edge was exceeded
 */

/**
 * @typedef {Object} Bounding
 * @property {Number} left  left offset coordinate
 * @property {Number} top  top offset coordinate
 * @property {Number} width
 * @property {Number} height
 */

/**
 * Get time in ms
 * @license https://raw.github.com/jashkenas/underscore/master/LICENSE
 * @type {function}
 * @return {number}
 */
var getTime = Date.now || function () {
  return new Date().getTime();
};

/**
 * Returns a function, that, when invoked, will only be triggered at most once
 * during a given window of time. Normally, the throttled function will run
 * as much as it can, without ever going more than once per `wait` duration;
 * but if you'd like to disable the execution on the leading edge, pass
 * `{leading: false}`. To disable execution on the trailing edge, ditto.
 * @license https://raw.github.com/jashkenas/underscore/master/LICENSE
 * @param {function} func
 * @param {number} wait
 * @param {Object=} options
 * @returns {Function}
 */
M.throttle = function (func, wait, options) {
  var context = void 0,
      args = void 0,
      result = void 0;
  var timeout = null;
  var previous = 0;
  options || (options = {});
  var later = function () {
    previous = options.leading === false ? 0 : getTime();
    timeout = null;
    result = func.apply(context, args);
    context = args = null;
  };
  return function () {
    var now = getTime();
    if (!previous && options.leading === false) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0) {
      clearTimeout(timeout);
      timeout = null;
      previous = now;
      result = func.apply(context, args);
      context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
};
; /*
  v2.2.0
  2017 Julian Garnier
  Released under the MIT license
  */
var $jscomp = { scope: {} };$jscomp.defineProperty = "function" == typeof Object.defineProperties ? Object.defineProperty : function (e, r, p) {
  if (p.get || p.set) throw new TypeError("ES3 does not support getters and setters.");e != Array.prototype && e != Object.prototype && (e[r] = p.value);
};$jscomp.getGlobal = function (e) {
  return "undefined" != typeof window && window === e ? e : "undefined" != typeof global && null != global ? global : e;
};$jscomp.global = $jscomp.getGlobal(this);$jscomp.SYMBOL_PREFIX = "jscomp_symbol_";
$jscomp.initSymbol = function () {
  $jscomp.initSymbol = function () {};$jscomp.global.Symbol || ($jscomp.global.Symbol = $jscomp.Symbol);
};$jscomp.symbolCounter_ = 0;$jscomp.Symbol = function (e) {
  return $jscomp.SYMBOL_PREFIX + (e || "") + $jscomp.symbolCounter_++;
};
$jscomp.initSymbolIterator = function () {
  $jscomp.initSymbol();var e = $jscomp.global.Symbol.iterator;e || (e = $jscomp.global.Symbol.iterator = $jscomp.global.Symbol("iterator"));"function" != typeof Array.prototype[e] && $jscomp.defineProperty(Array.prototype, e, { configurable: !0, writable: !0, value: function () {
      return $jscomp.arrayIterator(this);
    } });$jscomp.initSymbolIterator = function () {};
};$jscomp.arrayIterator = function (e) {
  var r = 0;return $jscomp.iteratorPrototype(function () {
    return r < e.length ? { done: !1, value: e[r++] } : { done: !0 };
  });
};
$jscomp.iteratorPrototype = function (e) {
  $jscomp.initSymbolIterator();e = { next: e };e[$jscomp.global.Symbol.iterator] = function () {
    return this;
  };return e;
};$jscomp.array = $jscomp.array || {};$jscomp.iteratorFromArray = function (e, r) {
  $jscomp.initSymbolIterator();e instanceof String && (e += "");var p = 0,
      m = { next: function () {
      if (p < e.length) {
        var u = p++;return { value: r(u, e[u]), done: !1 };
      }m.next = function () {
        return { done: !0, value: void 0 };
      };return m.next();
    } };m[Symbol.iterator] = function () {
    return m;
  };return m;
};
$jscomp.polyfill = function (e, r, p, m) {
  if (r) {
    p = $jscomp.global;e = e.split(".");for (m = 0; m < e.length - 1; m++) {
      var u = e[m];u in p || (p[u] = {});p = p[u];
    }e = e[e.length - 1];m = p[e];r = r(m);r != m && null != r && $jscomp.defineProperty(p, e, { configurable: !0, writable: !0, value: r });
  }
};$jscomp.polyfill("Array.prototype.keys", function (e) {
  return e ? e : function () {
    return $jscomp.iteratorFromArray(this, function (e) {
      return e;
    });
  };
}, "es6-impl", "es3");var $jscomp$this = this;
(function (r) {
  M.anime = r();
})(function () {
  function e(a) {
    if (!h.col(a)) try {
      return document.querySelectorAll(a);
    } catch (c) {}
  }function r(a, c) {
    for (var d = a.length, b = 2 <= arguments.length ? arguments[1] : void 0, f = [], n = 0; n < d; n++) {
      if (n in a) {
        var k = a[n];c.call(b, k, n, a) && f.push(k);
      }
    }return f;
  }function p(a) {
    return a.reduce(function (a, d) {
      return a.concat(h.arr(d) ? p(d) : d);
    }, []);
  }function m(a) {
    if (h.arr(a)) return a;
    h.str(a) && (a = e(a) || a);return a instanceof NodeList || a instanceof HTMLCollection ? [].slice.call(a) : [a];
  }function u(a, c) {
    return a.some(function (a) {
      return a === c;
    });
  }function C(a) {
    var c = {},
        d;for (d in a) {
      c[d] = a[d];
    }return c;
  }function D(a, c) {
    var d = C(a),
        b;for (b in a) {
      d[b] = c.hasOwnProperty(b) ? c[b] : a[b];
    }return d;
  }function z(a, c) {
    var d = C(a),
        b;for (b in c) {
      d[b] = h.und(a[b]) ? c[b] : a[b];
    }return d;
  }function T(a) {
    a = a.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function (a, c, d, k) {
      return c + c + d + d + k + k;
    });var c = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(a);
    a = parseInt(c[1], 16);var d = parseInt(c[2], 16),
        c = parseInt(c[3], 16);return "rgba(" + a + "," + d + "," + c + ",1)";
  }function U(a) {
    function c(a, c, b) {
      0 > b && (b += 1);1 < b && --b;return b < 1 / 6 ? a + 6 * (c - a) * b : .5 > b ? c : b < 2 / 3 ? a + (c - a) * (2 / 3 - b) * 6 : a;
    }var d = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(a) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(a);a = parseInt(d[1]) / 360;var b = parseInt(d[2]) / 100,
        f = parseInt(d[3]) / 100,
        d = d[4] || 1;if (0 == b) f = b = a = f;else {
      var n = .5 > f ? f * (1 + b) : f + b - f * b,
          k = 2 * f - n,
          f = c(k, n, a + 1 / 3),
          b = c(k, n, a);a = c(k, n, a - 1 / 3);
    }return "rgba(" + 255 * f + "," + 255 * b + "," + 255 * a + "," + d + ")";
  }function y(a) {
    if (a = /([\+\-]?[0-9#\.]+)(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(a)) return a[2];
  }function V(a) {
    if (-1 < a.indexOf("translate") || "perspective" === a) return "px";if (-1 < a.indexOf("rotate") || -1 < a.indexOf("skew")) return "deg";
  }function I(a, c) {
    return h.fnc(a) ? a(c.target, c.id, c.total) : a;
  }function E(a, c) {
    if (c in a.style) return getComputedStyle(a).getPropertyValue(c.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()) || "0";
  }function J(a, c) {
    if (h.dom(a) && u(W, c)) return "transform";if (h.dom(a) && (a.getAttribute(c) || h.svg(a) && a[c])) return "attribute";if (h.dom(a) && "transform" !== c && E(a, c)) return "css";if (null != a[c]) return "object";
  }function X(a, c) {
    var d = V(c),
        d = -1 < c.indexOf("scale") ? 1 : 0 + d;a = a.style.transform;if (!a) return d;for (var b = [], f = [], n = [], k = /(\w+)\((.+?)\)/g; b = k.exec(a);) {
      f.push(b[1]), n.push(b[2]);
    }a = r(n, function (a, b) {
      return f[b] === c;
    });return a.length ? a[0] : d;
  }function K(a, c) {
    switch (J(a, c)) {case "transform":
        return X(a, c);case "css":
        return E(a, c);case "attribute":
        return a.getAttribute(c);}return a[c] || 0;
  }function L(a, c) {
    var d = /^(\*=|\+=|-=)/.exec(a);if (!d) return a;var b = y(a) || 0;c = parseFloat(c);a = parseFloat(a.replace(d[0], ""));switch (d[0][0]) {case "+":
        return c + a + b;case "-":
        return c - a + b;case "*":
        return c * a + b;}
  }function F(a, c) {
    return Math.sqrt(Math.pow(c.x - a.x, 2) + Math.pow(c.y - a.y, 2));
  }function M(a) {
    a = a.points;for (var c = 0, d, b = 0; b < a.numberOfItems; b++) {
      var f = a.getItem(b);0 < b && (c += F(d, f));d = f;
    }return c;
  }function N(a) {
    if (a.getTotalLength) return a.getTotalLength();switch (a.tagName.toLowerCase()) {case "circle":
        return 2 * Math.PI * a.getAttribute("r");case "rect":
        return 2 * a.getAttribute("width") + 2 * a.getAttribute("height");case "line":
        return F({ x: a.getAttribute("x1"), y: a.getAttribute("y1") }, { x: a.getAttribute("x2"), y: a.getAttribute("y2") });case "polyline":
        return M(a);case "polygon":
        var c = a.points;return M(a) + F(c.getItem(c.numberOfItems - 1), c.getItem(0));}
  }function Y(a, c) {
    function d(b) {
      b = void 0 === b ? 0 : b;return a.el.getPointAtLength(1 <= c + b ? c + b : 0);
    }var b = d(),
        f = d(-1),
        n = d(1);switch (a.property) {case "x":
        return b.x;case "y":
        return b.y;
      case "angle":
        return 180 * Math.atan2(n.y - f.y, n.x - f.x) / Math.PI;}
  }function O(a, c) {
    var d = /-?\d*\.?\d+/g,
        b;b = h.pth(a) ? a.totalLength : a;if (h.col(b)) {
      if (h.rgb(b)) {
        var f = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(b);b = f ? "rgba(" + f[1] + ",1)" : b;
      } else b = h.hex(b) ? T(b) : h.hsl(b) ? U(b) : void 0;
    } else f = (f = y(b)) ? b.substr(0, b.length - f.length) : b, b = c && !/\s/g.test(b) ? f + c : f;b += "";return { original: b, numbers: b.match(d) ? b.match(d).map(Number) : [0], strings: h.str(a) || c ? b.split(d) : [] };
  }function P(a) {
    a = a ? p(h.arr(a) ? a.map(m) : m(a)) : [];return r(a, function (a, d, b) {
      return b.indexOf(a) === d;
    });
  }function Z(a) {
    var c = P(a);return c.map(function (a, b) {
      return { target: a, id: b, total: c.length };
    });
  }function aa(a, c) {
    var d = C(c);if (h.arr(a)) {
      var b = a.length;2 !== b || h.obj(a[0]) ? h.fnc(c.duration) || (d.duration = c.duration / b) : a = { value: a };
    }return m(a).map(function (a, b) {
      b = b ? 0 : c.delay;a = h.obj(a) && !h.pth(a) ? a : { value: a };h.und(a.delay) && (a.delay = b);return a;
    }).map(function (a) {
      return z(a, d);
    });
  }function ba(a, c) {
    var d = {},
        b;for (b in a) {
      var f = I(a[b], c);h.arr(f) && (f = f.map(function (a) {
        return I(a, c);
      }), 1 === f.length && (f = f[0]));d[b] = f;
    }d.duration = parseFloat(d.duration);d.delay = parseFloat(d.delay);return d;
  }function ca(a) {
    return h.arr(a) ? A.apply(this, a) : Q[a];
  }function da(a, c) {
    var d;return a.tweens.map(function (b) {
      b = ba(b, c);var f = b.value,
          e = K(c.target, a.name),
          k = d ? d.to.original : e,
          k = h.arr(f) ? f[0] : k,
          w = L(h.arr(f) ? f[1] : f, k),
          e = y(w) || y(k) || y(e);b.from = O(k, e);b.to = O(w, e);b.start = d ? d.end : a.offset;b.end = b.start + b.delay + b.duration;b.easing = ca(b.easing);b.elasticity = (1E3 - Math.min(Math.max(b.elasticity, 1), 999)) / 1E3;b.isPath = h.pth(f);b.isColor = h.col(b.from.original);b.isColor && (b.round = 1);return d = b;
    });
  }function ea(a, c) {
    return r(p(a.map(function (a) {
      return c.map(function (b) {
        var c = J(a.target, b.name);if (c) {
          var d = da(b, a);b = { type: c, property: b.name, animatable: a, tweens: d, duration: d[d.length - 1].end, delay: d[0].delay };
        } else b = void 0;return b;
      });
    })), function (a) {
      return !h.und(a);
    });
  }function R(a, c, d, b) {
    var f = "delay" === a;return c.length ? (f ? Math.min : Math.max).apply(Math, c.map(function (b) {
      return b[a];
    })) : f ? b.delay : d.offset + b.delay + b.duration;
  }function fa(a) {
    var c = D(ga, a),
        d = D(S, a),
        b = Z(a.targets),
        f = [],
        e = z(c, d),
        k;for (k in a) {
      e.hasOwnProperty(k) || "targets" === k || f.push({ name: k, offset: e.offset, tweens: aa(a[k], d) });
    }a = ea(b, f);return z(c, { children: [], animatables: b, animations: a, duration: R("duration", a, c, d), delay: R("delay", a, c, d) });
  }function q(a) {
    function c() {
      return window.Promise && new Promise(function (a) {
        return p = a;
      });
    }function d(a) {
      return g.reversed ? g.duration - a : a;
    }function b(a) {
      for (var b = 0, c = {}, d = g.animations, f = d.length; b < f;) {
        var e = d[b],
            k = e.animatable,
            h = e.tweens,
            n = h.length - 1,
            l = h[n];n && (l = r(h, function (b) {
          return a < b.end;
        })[0] || l);for (var h = Math.min(Math.max(a - l.start - l.delay, 0), l.duration) / l.duration, w = isNaN(h) ? 1 : l.easing(h, l.elasticity), h = l.to.strings, p = l.round, n = [], m = void 0, m = l.to.numbers.length, t = 0; t < m; t++) {
          var x = void 0,
              x = l.to.numbers[t],
              q = l.from.numbers[t],
              x = l.isPath ? Y(l.value, w * x) : q + w * (x - q);p && (l.isColor && 2 < t || (x = Math.round(x * p) / p));n.push(x);
        }if (l = h.length) for (m = h[0], w = 0; w < l; w++) {
          p = h[w + 1], t = n[w], isNaN(t) || (m = p ? m + (t + p) : m + (t + " "));
        } else m = n[0];ha[e.type](k.target, e.property, m, c, k.id);e.currentValue = m;b++;
      }if (b = Object.keys(c).length) for (d = 0; d < b; d++) {
        H || (H = E(document.body, "transform") ? "transform" : "-webkit-transform"), g.animatables[d].target.style[H] = c[d].join(" ");
      }g.currentTime = a;g.progress = a / g.duration * 100;
    }function f(a) {
      if (g[a]) g[a](g);
    }function e() {
      g.remaining && !0 !== g.remaining && g.remaining--;
    }function k(a) {
      var k = g.duration,
          n = g.offset,
          w = n + g.delay,
          r = g.currentTime,
          x = g.reversed,
          q = d(a);if (g.children.length) {
        var u = g.children,
            v = u.length;
        if (q >= g.currentTime) for (var G = 0; G < v; G++) {
          u[G].seek(q);
        } else for (; v--;) {
          u[v].seek(q);
        }
      }if (q >= w || !k) g.began || (g.began = !0, f("begin")), f("run");if (q > n && q < k) b(q);else if (q <= n && 0 !== r && (b(0), x && e()), q >= k && r !== k || !k) b(k), x || e();f("update");a >= k && (g.remaining ? (t = h, "alternate" === g.direction && (g.reversed = !g.reversed)) : (g.pause(), g.completed || (g.completed = !0, f("complete"), "Promise" in window && (p(), m = c()))), l = 0);
    }a = void 0 === a ? {} : a;var h,
        t,
        l = 0,
        p = null,
        m = c(),
        g = fa(a);g.reset = function () {
      var a = g.direction,
          c = g.loop;g.currentTime = 0;g.progress = 0;g.paused = !0;g.began = !1;g.completed = !1;g.reversed = "reverse" === a;g.remaining = "alternate" === a && 1 === c ? 2 : c;b(0);for (a = g.children.length; a--;) {
        g.children[a].reset();
      }
    };g.tick = function (a) {
      h = a;t || (t = h);k((l + h - t) * q.speed);
    };g.seek = function (a) {
      k(d(a));
    };g.pause = function () {
      var a = v.indexOf(g);-1 < a && v.splice(a, 1);g.paused = !0;
    };g.play = function () {
      g.paused && (g.paused = !1, t = 0, l = d(g.currentTime), v.push(g), B || ia());
    };g.reverse = function () {
      g.reversed = !g.reversed;t = 0;l = d(g.currentTime);
    };g.restart = function () {
      g.pause();
      g.reset();g.play();
    };g.finished = m;g.reset();g.autoplay && g.play();return g;
  }var ga = { update: void 0, begin: void 0, run: void 0, complete: void 0, loop: 1, direction: "normal", autoplay: !0, offset: 0 },
      S = { duration: 1E3, delay: 0, easing: "easeOutElastic", elasticity: 500, round: 0 },
      W = "translateX translateY translateZ rotate rotateX rotateY rotateZ scale scaleX scaleY scaleZ skewX skewY perspective".split(" "),
      H,
      h = { arr: function (a) {
      return Array.isArray(a);
    }, obj: function (a) {
      return -1 < Object.prototype.toString.call(a).indexOf("Object");
    },
    pth: function (a) {
      return h.obj(a) && a.hasOwnProperty("totalLength");
    }, svg: function (a) {
      return a instanceof SVGElement;
    }, dom: function (a) {
      return a.nodeType || h.svg(a);
    }, str: function (a) {
      return "string" === typeof a;
    }, fnc: function (a) {
      return "function" === typeof a;
    }, und: function (a) {
      return "undefined" === typeof a;
    }, hex: function (a) {
      return (/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(a)
      );
    }, rgb: function (a) {
      return (/^rgb/.test(a)
      );
    }, hsl: function (a) {
      return (/^hsl/.test(a)
      );
    }, col: function (a) {
      return h.hex(a) || h.rgb(a) || h.hsl(a);
    } },
      A = function () {
    function a(a, d, b) {
      return (((1 - 3 * b + 3 * d) * a + (3 * b - 6 * d)) * a + 3 * d) * a;
    }return function (c, d, b, f) {
      if (0 <= c && 1 >= c && 0 <= b && 1 >= b) {
        var e = new Float32Array(11);if (c !== d || b !== f) for (var k = 0; 11 > k; ++k) {
          e[k] = a(.1 * k, c, b);
        }return function (k) {
          if (c === d && b === f) return k;if (0 === k) return 0;if (1 === k) return 1;for (var h = 0, l = 1; 10 !== l && e[l] <= k; ++l) {
            h += .1;
          }--l;var l = h + (k - e[l]) / (e[l + 1] - e[l]) * .1,
              n = 3 * (1 - 3 * b + 3 * c) * l * l + 2 * (3 * b - 6 * c) * l + 3 * c;if (.001 <= n) {
            for (h = 0; 4 > h; ++h) {
              n = 3 * (1 - 3 * b + 3 * c) * l * l + 2 * (3 * b - 6 * c) * l + 3 * c;if (0 === n) break;var m = a(l, c, b) - k,
                  l = l - m / n;
            }k = l;
          } else if (0 === n) k = l;else {
            var l = h,
                h = h + .1,
                g = 0;do {
              m = l + (h - l) / 2, n = a(m, c, b) - k, 0 < n ? h = m : l = m;
            } while (1e-7 < Math.abs(n) && 10 > ++g);k = m;
          }return a(k, d, f);
        };
      }
    };
  }(),
      Q = function () {
    function a(a, b) {
      return 0 === a || 1 === a ? a : -Math.pow(2, 10 * (a - 1)) * Math.sin(2 * (a - 1 - b / (2 * Math.PI) * Math.asin(1)) * Math.PI / b);
    }var c = "Quad Cubic Quart Quint Sine Expo Circ Back Elastic".split(" "),
        d = { In: [[.55, .085, .68, .53], [.55, .055, .675, .19], [.895, .03, .685, .22], [.755, .05, .855, .06], [.47, 0, .745, .715], [.95, .05, .795, .035], [.6, .04, .98, .335], [.6, -.28, .735, .045], a], Out: [[.25, .46, .45, .94], [.215, .61, .355, 1], [.165, .84, .44, 1], [.23, 1, .32, 1], [.39, .575, .565, 1], [.19, 1, .22, 1], [.075, .82, .165, 1], [.175, .885, .32, 1.275], function (b, c) {
        return 1 - a(1 - b, c);
      }], InOut: [[.455, .03, .515, .955], [.645, .045, .355, 1], [.77, 0, .175, 1], [.86, 0, .07, 1], [.445, .05, .55, .95], [1, 0, 0, 1], [.785, .135, .15, .86], [.68, -.55, .265, 1.55], function (b, c) {
        return .5 > b ? a(2 * b, c) / 2 : 1 - a(-2 * b + 2, c) / 2;
      }] },
        b = { linear: A(.25, .25, .75, .75) },
        f = {},
        e;for (e in d) {
      f.type = e, d[f.type].forEach(function (a) {
        return function (d, f) {
          b["ease" + a.type + c[f]] = h.fnc(d) ? d : A.apply($jscomp$this, d);
        };
      }(f)), f = { type: f.type };
    }return b;
  }(),
      ha = { css: function (a, c, d) {
      return a.style[c] = d;
    }, attribute: function (a, c, d) {
      return a.setAttribute(c, d);
    }, object: function (a, c, d) {
      return a[c] = d;
    }, transform: function (a, c, d, b, f) {
      b[f] || (b[f] = []);b[f].push(c + "(" + d + ")");
    } },
      v = [],
      B = 0,
      ia = function () {
    function a() {
      B = requestAnimationFrame(c);
    }function c(c) {
      var b = v.length;if (b) {
        for (var d = 0; d < b;) {
          v[d] && v[d].tick(c), d++;
        }a();
      } else cancelAnimationFrame(B), B = 0;
    }return a;
  }();q.version = "2.2.0";q.speed = 1;q.running = v;q.remove = function (a) {
    a = P(a);for (var c = v.length; c--;) {
      for (var d = v[c], b = d.animations, f = b.length; f--;) {
        u(a, b[f].animatable.target) && (b.splice(f, 1), b.length || d.pause());
      }
    }
  };q.getValue = K;q.path = function (a, c) {
    var d = h.str(a) ? e(a)[0] : a,
        b = c || 100;return function (a) {
      return { el: d, property: a, totalLength: N(d) * (b / 100) };
    };
  };q.setDashoffset = function (a) {
    var c = N(a);a.setAttribute("stroke-dasharray", c);return c;
  };q.bezier = A;q.easings = Q;q.timeline = function (a) {
    var c = q(a);c.pause();c.duration = 0;c.add = function (d) {
      c.children.forEach(function (a) {
        a.began = !0;a.completed = !0;
      });m(d).forEach(function (b) {
        var d = z(b, D(S, a || {}));d.targets = d.targets || a.targets;b = c.duration;var e = d.offset;d.autoplay = !1;d.direction = c.direction;d.offset = h.und(e) ? b : L(e, b);c.began = !0;c.completed = !0;c.seek(d.offset);d = q(d);d.began = !0;d.completed = !0;d.duration > b && (c.duration = d.duration);c.children.push(d);
      });c.seek(0);c.reset();c.autoplay && c.restart();return c;
    };return c;
  };q.random = function (a, c) {
    return Math.floor(Math.random() * (c - a + 1)) + a;
  };return q;
});
;(function ($, anim) {
  'use strict';

  var _defaults = {
    accordion: true,
    onOpenStart: undefined,
    onOpenEnd: undefined,
    onCloseStart: undefined,
    onCloseEnd: undefined,
    inDuration: 300,
    outDuration: 300
  };

  /**
   * @class
   *
   */

  var Collapsible = function (_Component) {
    _inherits(Collapsible, _Component);

    /**
     * Construct Collapsible instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Collapsible(el, options) {
      _classCallCheck(this, Collapsible);

      var _this3 = _possibleConstructorReturn(this, (Collapsible.__proto__ || Object.getPrototypeOf(Collapsible)).call(this, Collapsible, el, options));

      _this3.el.M_Collapsible = _this3;

      /**
       * Options for the collapsible
       * @member Collapsible#options
       * @prop {Boolean} [accordion=false] - Type of the collapsible
       * @prop {Function} onOpenStart - Callback function called before collapsible is opened
       * @prop {Function} onOpenEnd - Callback function called after collapsible is opened
       * @prop {Function} onCloseStart - Callback function called before collapsible is closed
       * @prop {Function} onCloseEnd - Callback function called after collapsible is closed
       * @prop {Number} inDuration - Transition in duration in milliseconds.
       * @prop {Number} outDuration - Transition duration in milliseconds.
       */
      _this3.options = $.extend({}, Collapsible.defaults, options);

      // Setup tab indices
      _this3.$headers = _this3.$el.children('li').children('.collapsible-header');
      _this3.$headers.attr('tabindex', 0);

      _this3._setupEventHandlers();

      // Open first active
      var $activeBodies = _this3.$el.children('li.active').children('.collapsible-body');
      if (_this3.options.accordion) {
        // Handle Accordion
        $activeBodies.first().css('display', 'block');
      } else {
        // Handle Expandables
        $activeBodies.css('display', 'block');
      }
      return _this3;
    }

    _createClass(Collapsible, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this.el.M_Collapsible = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        var _this4 = this;

        this._handleCollapsibleClickBound = this._handleCollapsibleClick.bind(this);
        this._handleCollapsibleKeydownBound = this._handleCollapsibleKeydown.bind(this);
        this.el.addEventListener('click', this._handleCollapsibleClickBound);
        this.$headers.each(function (header) {
          header.addEventListener('keydown', _this4._handleCollapsibleKeydownBound);
        });
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        var _this5 = this;

        this.el.removeEventListener('click', this._handleCollapsibleClickBound);
        this.$headers.each(function (header) {
          header.removeEventListener('keydown', _this5._handleCollapsibleKeydownBound);
        });
      }

      /**
       * Handle Collapsible Click
       * @param {Event} e
       */

    }, {
      key: "_handleCollapsibleClick",
      value: function _handleCollapsibleClick(e) {
        var $header = $(e.target).closest('.collapsible-header');
        if (e.target && $header.length) {
          var $collapsible = $header.closest('.collapsible');
          if ($collapsible[0] === this.el) {
            var $collapsibleLi = $header.closest('li');
            var $collapsibleLis = $collapsible.children('li');
            var isActive = $collapsibleLi[0].classList.contains('active');
            var index = $collapsibleLis.index($collapsibleLi);

            if (isActive) {
              this.close(index);
            } else {
              this.open(index);
            }
          }
        }
      }

      /**
       * Handle Collapsible Keydown
       * @param {Event} e
       */

    }, {
      key: "_handleCollapsibleKeydown",
      value: function _handleCollapsibleKeydown(e) {
        if (e.keyCode === 13) {
          this._handleCollapsibleClickBound(e);
        }
      }

      /**
       * Animate in collapsible slide
       * @param {Number} index - 0th index of slide
       */

    }, {
      key: "_animateIn",
      value: function _animateIn(index) {
        var _this6 = this;

        var $collapsibleLi = this.$el.children('li').eq(index);
        if ($collapsibleLi.length) {
          var $body = $collapsibleLi.children('.collapsible-body');

          anim.remove($body[0]);
          $body.css({
            display: 'block',
            overflow: 'hidden',
            height: 0,
            paddingTop: '',
            paddingBottom: ''
          });

          var pTop = $body.css('padding-top');
          var pBottom = $body.css('padding-bottom');
          var finalHeight = $body[0].scrollHeight;
          $body.css({
            paddingTop: 0,
            paddingBottom: 0
          });

          anim({
            targets: $body[0],
            height: finalHeight,
            paddingTop: pTop,
            paddingBottom: pBottom,
            duration: this.options.inDuration,
            easing: 'easeInOutCubic',
            complete: function (anim) {
              $body.css({
                overflow: '',
                paddingTop: '',
                paddingBottom: '',
                height: ''
              });

              // onOpenEnd callback
              if (typeof _this6.options.onOpenEnd === 'function') {
                _this6.options.onOpenEnd.call(_this6, $collapsibleLi[0]);
              }
            }
          });
        }
      }

      /**
       * Animate out collapsible slide
       * @param {Number} index - 0th index of slide to open
       */

    }, {
      key: "_animateOut",
      value: function _animateOut(index) {
        var _this7 = this;

        var $collapsibleLi = this.$el.children('li').eq(index);
        if ($collapsibleLi.length) {
          var $body = $collapsibleLi.children('.collapsible-body');
          anim.remove($body[0]);
          $body.css('overflow', 'hidden');
          anim({
            targets: $body[0],
            height: 0,
            paddingTop: 0,
            paddingBottom: 0,
            duration: this.options.outDuration,
            easing: 'easeInOutCubic',
            complete: function () {
              $body.css({
                height: '',
                overflow: '',
                padding: '',
                display: ''
              });

              // onCloseEnd callback
              if (typeof _this7.options.onCloseEnd === 'function') {
                _this7.options.onCloseEnd.call(_this7, $collapsibleLi[0]);
              }
            }
          });
        }
      }

      /**
       * Open Collapsible
       * @param {Number} index - 0th index of slide
       */

    }, {
      key: "open",
      value: function open(index) {
        var _this8 = this;

        var $collapsibleLi = this.$el.children('li').eq(index);
        if ($collapsibleLi.length && !$collapsibleLi[0].classList.contains('active')) {
          // onOpenStart callback
          if (typeof this.options.onOpenStart === 'function') {
            this.options.onOpenStart.call(this, $collapsibleLi[0]);
          }

          // Handle accordion behavior
          if (this.options.accordion) {
            var $collapsibleLis = this.$el.children('li');
            var $activeLis = this.$el.children('li.active');
            $activeLis.each(function (el) {
              var index = $collapsibleLis.index($(el));
              _this8.close(index);
            });
          }

          // Animate in
          $collapsibleLi[0].classList.add('active');
          this._animateIn(index);
        }
      }

      /**
       * Close Collapsible
       * @param {Number} index - 0th index of slide
       */

    }, {
      key: "close",
      value: function close(index) {
        var $collapsibleLi = this.$el.children('li').eq(index);
        if ($collapsibleLi.length && $collapsibleLi[0].classList.contains('active')) {
          // onCloseStart callback
          if (typeof this.options.onCloseStart === 'function') {
            this.options.onCloseStart.call(this, $collapsibleLi[0]);
          }

          // Animate out
          $collapsibleLi[0].classList.remove('active');
          this._animateOut(index);
        }
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Collapsible.__proto__ || Object.getPrototypeOf(Collapsible), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Collapsible;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Collapsible;
  }(Component);

  M.Collapsible = Collapsible;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Collapsible, 'collapsible', 'M_Collapsible');
  }
})(cash, M.anime);
;(function ($, anim) {
  'use strict';

  var _defaults = {
    alignment: 'left',
    autoFocus: true,
    constrainWidth: true,
    container: null,
    coverTrigger: true,
    closeOnClick: true,
    hover: false,
    inDuration: 150,
    outDuration: 250,
    onOpenStart: null,
    onOpenEnd: null,
    onCloseStart: null,
    onCloseEnd: null,
    onItemClick: null
  };

  /**
   * @class
   */

  var Dropdown = function (_Component2) {
    _inherits(Dropdown, _Component2);

    function Dropdown(el, options) {
      _classCallCheck(this, Dropdown);

      var _this9 = _possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, Dropdown, el, options));

      _this9.el.M_Dropdown = _this9;
      Dropdown._dropdowns.push(_this9);

      _this9.id = M.getIdFromTrigger(el);
      _this9.dropdownEl = document.getElementById(_this9.id);
      _this9.$dropdownEl = $(_this9.dropdownEl);

      /**
       * Options for the dropdown
       * @member Dropdown#options
       * @prop {String} [alignment='left'] - Edge which the dropdown is aligned to
       * @prop {Boolean} [autoFocus=true] - Automatically focus dropdown el for keyboard
       * @prop {Boolean} [constrainWidth=true] - Constrain width to width of the button
       * @prop {Element} container - Container element to attach dropdown to (optional)
       * @prop {Boolean} [coverTrigger=true] - Place dropdown over trigger
       * @prop {Boolean} [closeOnClick=true] - Close on click of dropdown item
       * @prop {Boolean} [hover=false] - Open dropdown on hover
       * @prop {Number} [inDuration=150] - Duration of open animation in ms
       * @prop {Number} [outDuration=250] - Duration of close animation in ms
       * @prop {Function} onOpenStart - Function called when dropdown starts opening
       * @prop {Function} onOpenEnd - Function called when dropdown finishes opening
       * @prop {Function} onCloseStart - Function called when dropdown starts closing
       * @prop {Function} onCloseEnd - Function called when dropdown finishes closing
       */
      _this9.options = $.extend({}, Dropdown.defaults, options);

      /**
       * Describes open/close state of dropdown
       * @type {Boolean}
       */
      _this9.isOpen = false;

      /**
       * Describes if dropdown content is scrollable
       * @type {Boolean}
       */
      _this9.isScrollable = false;

      /**
       * Describes if touch moving on dropdown content
       * @type {Boolean}
       */
      _this9.isTouchMoving = false;

      _this9.focusedIndex = -1;
      _this9.filterQuery = [];

      // Move dropdown-content after dropdown-trigger
      if (!!_this9.options.container) {
        $(_this9.options.container).append(_this9.dropdownEl);
      } else {
        _this9.$el.after(_this9.dropdownEl);
      }

      _this9._makeDropdownFocusable();
      _this9._resetFilterQueryBound = _this9._resetFilterQuery.bind(_this9);
      _this9._handleDocumentClickBound = _this9._handleDocumentClick.bind(_this9);
      _this9._handleDocumentTouchmoveBound = _this9._handleDocumentTouchmove.bind(_this9);
      _this9._handleDropdownClickBound = _this9._handleDropdownClick.bind(_this9);
      _this9._handleDropdownKeydownBound = _this9._handleDropdownKeydown.bind(_this9);
      _this9._handleTriggerKeydownBound = _this9._handleTriggerKeydown.bind(_this9);
      _this9._setupEventHandlers();
      return _this9;
    }

    _createClass(Dropdown, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._resetDropdownStyles();
        this._removeEventHandlers();
        Dropdown._dropdowns.splice(Dropdown._dropdowns.indexOf(this), 1);
        this.el.M_Dropdown = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        // Trigger keydown handler
        this.el.addEventListener('keydown', this._handleTriggerKeydownBound);

        // Item click handler
        this.dropdownEl.addEventListener('click', this._handleDropdownClickBound);

        // Hover event handlers
        if (this.options.hover) {
          this._handleMouseEnterBound = this._handleMouseEnter.bind(this);
          this.el.addEventListener('mouseenter', this._handleMouseEnterBound);
          this._handleMouseLeaveBound = this._handleMouseLeave.bind(this);
          this.el.addEventListener('mouseleave', this._handleMouseLeaveBound);
          this.dropdownEl.addEventListener('mouseleave', this._handleMouseLeaveBound);

          // Click event handlers
        } else {
          this._handleClickBound = this._handleClick.bind(this);
          this.el.addEventListener('click', this._handleClickBound);
        }
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('keydown', this._handleTriggerKeydownBound);
        this.dropdownEl.removeEventListener('click', this._handleDropdownClickBound);

        if (this.options.hover) {
          this.el.removeEventListener('mouseenter', this._handleMouseEnterBound);
          this.el.removeEventListener('mouseleave', this._handleMouseLeaveBound);
          this.dropdownEl.removeEventListener('mouseleave', this._handleMouseLeaveBound);
        } else {
          this.el.removeEventListener('click', this._handleClickBound);
        }
      }
    }, {
      key: "_setupTemporaryEventHandlers",
      value: function _setupTemporaryEventHandlers() {
        // Use capture phase event handler to prevent click
        document.body.addEventListener('click', this._handleDocumentClickBound, true);
        document.body.addEventListener('touchend', this._handleDocumentClickBound);
        document.body.addEventListener('touchmove', this._handleDocumentTouchmoveBound);
        this.dropdownEl.addEventListener('keydown', this._handleDropdownKeydownBound);
      }
    }, {
      key: "_removeTemporaryEventHandlers",
      value: function _removeTemporaryEventHandlers() {
        // Use capture phase event handler to prevent click
        document.body.removeEventListener('click', this._handleDocumentClickBound, true);
        document.body.removeEventListener('touchend', this._handleDocumentClickBound);
        document.body.removeEventListener('touchmove', this._handleDocumentTouchmoveBound);
        this.dropdownEl.removeEventListener('keydown', this._handleDropdownKeydownBound);
      }
    }, {
      key: "_handleClick",
      value: function _handleClick(e) {
        e.preventDefault();
        this.open();
      }
    }, {
      key: "_handleMouseEnter",
      value: function _handleMouseEnter() {
        this.open();
      }
    }, {
      key: "_handleMouseLeave",
      value: function _handleMouseLeave(e) {
        var toEl = e.toElement || e.relatedTarget;
        var leaveToDropdownContent = !!$(toEl).closest('.dropdown-content').length;
        var leaveToActiveDropdownTrigger = false;

        var $closestTrigger = $(toEl).closest('.dropdown-trigger');
        if ($closestTrigger.length && !!$closestTrigger[0].M_Dropdown && $closestTrigger[0].M_Dropdown.isOpen) {
          leaveToActiveDropdownTrigger = true;
        }

        // Close hover dropdown if mouse did not leave to either active dropdown-trigger or dropdown-content
        if (!leaveToActiveDropdownTrigger && !leaveToDropdownContent) {
          this.close();
        }
      }
    }, {
      key: "_handleDocumentClick",
      value: function _handleDocumentClick(e) {
        var _this10 = this;

        var $target = $(e.target);
        if (this.options.closeOnClick && $target.closest('.dropdown-content').length && !this.isTouchMoving) {
          // isTouchMoving to check if scrolling on mobile.
          setTimeout(function () {
            _this10.close();
          }, 0);
        } else if ($target.closest('.dropdown-trigger').length || !$target.closest('.dropdown-content').length) {
          setTimeout(function () {
            _this10.close();
          }, 0);
        }
        this.isTouchMoving = false;
      }
    }, {
      key: "_handleTriggerKeydown",
      value: function _handleTriggerKeydown(e) {
        // ARROW DOWN OR ENTER WHEN SELECT IS CLOSED - open Dropdown
        if ((e.which === M.keys.ARROW_DOWN || e.which === M.keys.ENTER) && !this.isOpen) {
          e.preventDefault();
          this.open();
        }
      }

      /**
       * Handle Document Touchmove
       * @param {Event} e
       */

    }, {
      key: "_handleDocumentTouchmove",
      value: function _handleDocumentTouchmove(e) {
        var $target = $(e.target);
        if ($target.closest('.dropdown-content').length) {
          this.isTouchMoving = true;
        }
      }

      /**
       * Handle Dropdown Click
       * @param {Event} e
       */

    }, {
      key: "_handleDropdownClick",
      value: function _handleDropdownClick(e) {
        // onItemClick callback
        if (typeof this.options.onItemClick === 'function') {
          var itemEl = $(e.target).closest('li')[0];
          this.options.onItemClick.call(this, itemEl);
        }
      }

      /**
       * Handle Dropdown Keydown
       * @param {Event} e
       */

    }, {
      key: "_handleDropdownKeydown",
      value: function _handleDropdownKeydown(e) {
        if (e.which === M.keys.TAB) {
          e.preventDefault();
          this.close();

          // Navigate down dropdown list
        } else if ((e.which === M.keys.ARROW_DOWN || e.which === M.keys.ARROW_UP) && this.isOpen) {
          e.preventDefault();
          var direction = e.which === M.keys.ARROW_DOWN ? 1 : -1;
          var newFocusedIndex = this.focusedIndex;
          var foundNewIndex = false;
          do {
            newFocusedIndex = newFocusedIndex + direction;

            if (!!this.dropdownEl.children[newFocusedIndex] && this.dropdownEl.children[newFocusedIndex].tabIndex !== -1) {
              foundNewIndex = true;
              break;
            }
          } while (newFocusedIndex < this.dropdownEl.children.length && newFocusedIndex >= 0);

          if (foundNewIndex) {
            this.focusedIndex = newFocusedIndex;
            this._focusFocusedItem();
          }

          // ENTER selects choice on focused item
        } else if (e.which === M.keys.ENTER && this.isOpen) {
          // Search for <a> and <button>
          var focusedElement = this.dropdownEl.children[this.focusedIndex];
          var $activatableElement = $(focusedElement).find('a, button').first();

          // Click a or button tag if exists, otherwise click li tag
          !!$activatableElement.length ? $activatableElement[0].click() : focusedElement.click();

          // Close dropdown on ESC
        } else if (e.which === M.keys.ESC && this.isOpen) {
          e.preventDefault();
          this.close();
        }

        // CASE WHEN USER TYPE LETTERS
        var letter = String.fromCharCode(e.which).toLowerCase(),
            nonLetters = [9, 13, 27, 38, 40];
        if (letter && nonLetters.indexOf(e.which) === -1) {
          this.filterQuery.push(letter);

          var string = this.filterQuery.join(''),
              newOptionEl = $(this.dropdownEl).find('li').filter(function (el) {
            return $(el).text().toLowerCase().indexOf(string) === 0;
          })[0];

          if (newOptionEl) {
            this.focusedIndex = $(newOptionEl).index();
            this._focusFocusedItem();
          }
        }

        this.filterTimeout = setTimeout(this._resetFilterQueryBound, 1000);
      }

      /**
       * Setup dropdown
       */

    }, {
      key: "_resetFilterQuery",
      value: function _resetFilterQuery() {
        this.filterQuery = [];
      }
    }, {
      key: "_resetDropdownStyles",
      value: function _resetDropdownStyles() {
        this.$dropdownEl.css({
          display: '',
          width: '',
          height: '',
          left: '',
          top: '',
          'transform-origin': '',
          transform: '',
          opacity: ''
        });
      }
    }, {
      key: "_makeDropdownFocusable",
      value: function _makeDropdownFocusable() {
        // Needed for arrow key navigation
        this.dropdownEl.tabIndex = 0;

        // Only set tabindex if it hasn't been set by user
        $(this.dropdownEl).children().each(function (el) {
          if (!el.getAttribute('tabindex')) {
            el.setAttribute('tabindex', 0);
          }
        });
      }
    }, {
      key: "_focusFocusedItem",
      value: function _focusFocusedItem() {
        if (this.focusedIndex >= 0 && this.focusedIndex < this.dropdownEl.children.length && this.options.autoFocus) {
          this.dropdownEl.children[this.focusedIndex].focus();
        }
      }
    }, {
      key: "_getDropdownPosition",
      value: function _getDropdownPosition() {
        var offsetParentBRect = this.el.offsetParent.getBoundingClientRect();
        var triggerBRect = this.el.getBoundingClientRect();
        var dropdownBRect = this.dropdownEl.getBoundingClientRect();

        var idealHeight = dropdownBRect.height;
        var idealWidth = dropdownBRect.width;
        var idealXPos = triggerBRect.left - dropdownBRect.left;
        var idealYPos = triggerBRect.top - dropdownBRect.top;

        var dropdownBounds = {
          left: idealXPos,
          top: idealYPos,
          height: idealHeight,
          width: idealWidth
        };

        // Countainer here will be closest ancestor with overflow: hidden
        var closestOverflowParent = !!this.dropdownEl.offsetParent ? this.dropdownEl.offsetParent : this.dropdownEl.parentNode;

        var alignments = M.checkPossibleAlignments(this.el, closestOverflowParent, dropdownBounds, this.options.coverTrigger ? 0 : triggerBRect.height);

        var verticalAlignment = 'top';
        var horizontalAlignment = this.options.alignment;
        idealYPos += this.options.coverTrigger ? 0 : triggerBRect.height;

        // Reset isScrollable
        this.isScrollable = false;

        if (!alignments.top) {
          if (alignments.bottom) {
            verticalAlignment = 'bottom';
          } else {
            this.isScrollable = true;

            // Determine which side has most space and cutoff at correct height
            if (alignments.spaceOnTop > alignments.spaceOnBottom) {
              verticalAlignment = 'bottom';
              idealHeight += alignments.spaceOnTop;
              idealYPos -= alignments.spaceOnTop;
            } else {
              idealHeight += alignments.spaceOnBottom;
            }
          }
        }

        // If preferred horizontal alignment is possible
        if (!alignments[horizontalAlignment]) {
          var oppositeAlignment = horizontalAlignment === 'left' ? 'right' : 'left';
          if (alignments[oppositeAlignment]) {
            horizontalAlignment = oppositeAlignment;
          } else {
            // Determine which side has most space and cutoff at correct height
            if (alignments.spaceOnLeft > alignments.spaceOnRight) {
              horizontalAlignment = 'right';
              idealWidth += alignments.spaceOnLeft;
              idealXPos -= alignments.spaceOnLeft;
            } else {
              horizontalAlignment = 'left';
              idealWidth += alignments.spaceOnRight;
            }
          }
        }

        if (verticalAlignment === 'bottom') {
          idealYPos = idealYPos - dropdownBRect.height + (this.options.coverTrigger ? triggerBRect.height : 0);
        }
        if (horizontalAlignment === 'right') {
          idealXPos = idealXPos - dropdownBRect.width + triggerBRect.width;
        }
        return {
          x: idealXPos,
          y: idealYPos,
          verticalAlignment: verticalAlignment,
          horizontalAlignment: horizontalAlignment,
          height: idealHeight,
          width: idealWidth
        };
      }

      /**
       * Animate in dropdown
       */

    }, {
      key: "_animateIn",
      value: function _animateIn() {
        var _this11 = this;

        anim.remove(this.dropdownEl);
        anim({
          targets: this.dropdownEl,
          opacity: {
            value: [0, 1],
            easing: 'easeOutQuad'
          },
          scaleX: [0.3, 1],
          scaleY: [0.3, 1],
          duration: this.options.inDuration,
          easing: 'easeOutQuint',
          complete: function (anim) {
            if (_this11.options.autoFocus) {
              _this11.dropdownEl.focus();
            }

            // onOpenEnd callback
            if (typeof _this11.options.onOpenEnd === 'function') {
              var elem = anim.animatables[0].target;
              _this11.options.onOpenEnd.call(elem, _this11.el);
            }
          }
        });
      }

      /**
       * Animate out dropdown
       */

    }, {
      key: "_animateOut",
      value: function _animateOut() {
        var _this12 = this;

        anim.remove(this.dropdownEl);
        anim({
          targets: this.dropdownEl,
          opacity: {
            value: 0,
            easing: 'easeOutQuint'
          },
          scaleX: 0.3,
          scaleY: 0.3,
          duration: this.options.outDuration,
          easing: 'easeOutQuint',
          complete: function (anim) {
            _this12._resetDropdownStyles();

            // onCloseEnd callback
            if (typeof _this12.options.onCloseEnd === 'function') {
              var elem = anim.animatables[0].target;
              _this12.options.onCloseEnd.call(_this12, _this12.el);
            }
          }
        });
      }

      /**
       * Place dropdown
       */

    }, {
      key: "_placeDropdown",
      value: function _placeDropdown() {
        // Set width before calculating positionInfo
        var idealWidth = this.options.constrainWidth ? this.el.getBoundingClientRect().width : this.dropdownEl.getBoundingClientRect().width;
        this.dropdownEl.style.width = idealWidth + 'px';

        var positionInfo = this._getDropdownPosition();
        this.dropdownEl.style.left = positionInfo.x + 'px';
        this.dropdownEl.style.top = positionInfo.y + 'px';
        this.dropdownEl.style.height = positionInfo.height + 'px';
        this.dropdownEl.style.width = positionInfo.width + 'px';
        this.dropdownEl.style.transformOrigin = (positionInfo.horizontalAlignment === 'left' ? '0' : '100%') + " " + (positionInfo.verticalAlignment === 'top' ? '0' : '100%');
      }

      /**
       * Open Dropdown
       */

    }, {
      key: "open",
      value: function open() {
        if (this.isOpen) {
          return;
        }
        this.isOpen = true;

        // onOpenStart callback
        if (typeof this.options.onOpenStart === 'function') {
          this.options.onOpenStart.call(this, this.el);
        }

        // Reset styles
        this._resetDropdownStyles();
        this.dropdownEl.style.display = 'block';

        this._placeDropdown();
        this._animateIn();
        this._setupTemporaryEventHandlers();
      }

      /**
       * Close Dropdown
       */

    }, {
      key: "close",
      value: function close() {
        if (!this.isOpen) {
          return;
        }
        this.isOpen = false;
        this.focusedIndex = -1;

        // onCloseStart callback
        if (typeof this.options.onCloseStart === 'function') {
          this.options.onCloseStart.call(this, this.el);
        }

        this._animateOut();
        this._removeTemporaryEventHandlers();

        if (this.options.autoFocus) {
          this.el.focus();
        }
      }

      /**
       * Recalculate dimensions
       */

    }, {
      key: "recalculateDimensions",
      value: function recalculateDimensions() {
        if (this.isOpen) {
          this.$dropdownEl.css({
            width: '',
            height: '',
            left: '',
            top: '',
            'transform-origin': ''
          });
          this._placeDropdown();
        }
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Dropdown.__proto__ || Object.getPrototypeOf(Dropdown), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Dropdown;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Dropdown;
  }(Component);

  /**
   * @static
   * @memberof Dropdown
   */


  Dropdown._dropdowns = [];

  window.M.Dropdown = Dropdown;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Dropdown, 'dropdown', 'M_Dropdown');
  }
})(cash, M.anime);
;(function ($, anim) {
  'use strict';

  var _defaults = {
    opacity: 0.5,
    inDuration: 250,
    outDuration: 250,
    onOpenStart: null,
    onOpenEnd: null,
    onCloseStart: null,
    onCloseEnd: null,
    preventScrolling: true,
    dismissible: true,
    startingTop: '4%',
    endingTop: '10%'
  };

  /**
   * @class
   *
   */

  var Modal = function (_Component3) {
    _inherits(Modal, _Component3);

    /**
     * Construct Modal instance and set up overlay
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Modal(el, options) {
      _classCallCheck(this, Modal);

      var _this13 = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, Modal, el, options));

      _this13.el.M_Modal = _this13;

      /**
       * Options for the modal
       * @member Modal#options
       * @prop {Number} [opacity=0.5] - Opacity of the modal overlay
       * @prop {Number} [inDuration=250] - Length in ms of enter transition
       * @prop {Number} [outDuration=250] - Length in ms of exit transition
       * @prop {Function} onOpenStart - Callback function called before modal is opened
       * @prop {Function} onOpenEnd - Callback function called after modal is opened
       * @prop {Function} onCloseStart - Callback function called before modal is closed
       * @prop {Function} onCloseEnd - Callback function called after modal is closed
       * @prop {Boolean} [dismissible=true] - Allow modal to be dismissed by keyboard or overlay click
       * @prop {String} [startingTop='4%'] - startingTop
       * @prop {String} [endingTop='10%'] - endingTop
       */
      _this13.options = $.extend({}, Modal.defaults, options);

      /**
       * Describes open/close state of modal
       * @type {Boolean}
       */
      _this13.isOpen = false;

      _this13.id = _this13.$el.attr('id');
      _this13._openingTrigger = undefined;
      _this13.$overlay = $('<div class="modal-overlay"></div>');
      _this13.el.tabIndex = 0;
      _this13._nthModalOpened = 0;

      Modal._count++;
      _this13._setupEventHandlers();
      return _this13;
    }

    _createClass(Modal, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        Modal._count--;
        this._removeEventHandlers();
        this.el.removeAttribute('style');
        this.$overlay.remove();
        this.el.M_Modal = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleOverlayClickBound = this._handleOverlayClick.bind(this);
        this._handleModalCloseClickBound = this._handleModalCloseClick.bind(this);

        if (Modal._count === 1) {
          document.body.addEventListener('click', this._handleTriggerClick);
        }
        this.$overlay[0].addEventListener('click', this._handleOverlayClickBound);
        this.el.addEventListener('click', this._handleModalCloseClickBound);
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        if (Modal._count === 0) {
          document.body.removeEventListener('click', this._handleTriggerClick);
        }
        this.$overlay[0].removeEventListener('click', this._handleOverlayClickBound);
        this.el.removeEventListener('click', this._handleModalCloseClickBound);
      }

      /**
       * Handle Trigger Click
       * @param {Event} e
       */

    }, {
      key: "_handleTriggerClick",
      value: function _handleTriggerClick(e) {
        var $trigger = $(e.target).closest('.modal-trigger');
        if ($trigger.length) {
          var modalId = M.getIdFromTrigger($trigger[0]);
          var modalInstance = document.getElementById(modalId).M_Modal;
          if (modalInstance) {
            modalInstance.open($trigger);
          }
          e.preventDefault();
        }
      }

      /**
       * Handle Overlay Click
       */

    }, {
      key: "_handleOverlayClick",
      value: function _handleOverlayClick() {
        if (this.options.dismissible) {
          this.close();
        }
      }

      /**
       * Handle Modal Close Click
       * @param {Event} e
       */

    }, {
      key: "_handleModalCloseClick",
      value: function _handleModalCloseClick(e) {
        var $closeTrigger = $(e.target).closest('.modal-close');
        if ($closeTrigger.length) {
          this.close();
        }
      }

      /**
       * Handle Keydown
       * @param {Event} e
       */

    }, {
      key: "_handleKeydown",
      value: function _handleKeydown(e) {
        // ESC key
        if (e.keyCode === 27 && this.options.dismissible) {
          this.close();
        }
      }

      /**
       * Handle Focus
       * @param {Event} e
       */

    }, {
      key: "_handleFocus",
      value: function _handleFocus(e) {
        // Only trap focus if this modal is the last model opened (prevents loops in nested modals).
        if (!this.el.contains(e.target) && this._nthModalOpened === Modal._modalsOpen) {
          this.el.focus();
        }
      }

      /**
       * Animate in modal
       */

    }, {
      key: "_animateIn",
      value: function _animateIn() {
        var _this14 = this;

        // Set initial styles
        $.extend(this.el.style, {
          display: 'block',
          opacity: 0
        });
        $.extend(this.$overlay[0].style, {
          display: 'block',
          opacity: 0
        });

        // Animate overlay
        anim({
          targets: this.$overlay[0],
          opacity: this.options.opacity,
          duration: this.options.inDuration,
          easing: 'easeOutQuad'
        });

        // Define modal animation options
        var enterAnimOptions = {
          targets: this.el,
          duration: this.options.inDuration,
          easing: 'easeOutCubic',
          // Handle modal onOpenEnd callback
          complete: function () {
            if (typeof _this14.options.onOpenEnd === 'function') {
              _this14.options.onOpenEnd.call(_this14, _this14.el, _this14._openingTrigger);
            }
          }
        };

        // Bottom sheet animation
        if (this.el.classList.contains('bottom-sheet')) {
          $.extend(enterAnimOptions, {
            bottom: 0,
            opacity: 1
          });
          anim(enterAnimOptions);

          // Normal modal animation
        } else {
          $.extend(enterAnimOptions, {
            top: [this.options.startingTop, this.options.endingTop],
            opacity: 1,
            scaleX: [0.8, 1],
            scaleY: [0.8, 1]
          });
          anim(enterAnimOptions);
        }
      }

      /**
       * Animate out modal
       */

    }, {
      key: "_animateOut",
      value: function _animateOut() {
        var _this15 = this;

        // Animate overlay
        anim({
          targets: this.$overlay[0],
          opacity: 0,
          duration: this.options.outDuration,
          easing: 'easeOutQuart'
        });

        // Define modal animation options
        var exitAnimOptions = {
          targets: this.el,
          duration: this.options.outDuration,
          easing: 'easeOutCubic',
          // Handle modal ready callback
          complete: function () {
            _this15.el.style.display = 'none';
            _this15.$overlay.remove();

            // Call onCloseEnd callback
            if (typeof _this15.options.onCloseEnd === 'function') {
              _this15.options.onCloseEnd.call(_this15, _this15.el);
            }
          }
        };

        // Bottom sheet animation
        if (this.el.classList.contains('bottom-sheet')) {
          $.extend(exitAnimOptions, {
            bottom: '-100%',
            opacity: 0
          });
          anim(exitAnimOptions);

          // Normal modal animation
        } else {
          $.extend(exitAnimOptions, {
            top: [this.options.endingTop, this.options.startingTop],
            opacity: 0,
            scaleX: 0.8,
            scaleY: 0.8
          });
          anim(exitAnimOptions);
        }
      }

      /**
       * Open Modal
       * @param {cash} [$trigger]
       */

    }, {
      key: "open",
      value: function open($trigger) {
        if (this.isOpen) {
          return;
        }

        this.isOpen = true;
        Modal._modalsOpen++;
        this._nthModalOpened = Modal._modalsOpen;

        // Set Z-Index based on number of currently open modals
        this.$overlay[0].style.zIndex = 1000 + Modal._modalsOpen * 2;
        this.el.style.zIndex = 1000 + Modal._modalsOpen * 2 + 1;

        // Set opening trigger, undefined indicates modal was opened by javascript
        this._openingTrigger = !!$trigger ? $trigger[0] : undefined;

        // onOpenStart callback
        if (typeof this.options.onOpenStart === 'function') {
          this.options.onOpenStart.call(this, this.el, this._openingTrigger);
        }

        if (this.options.preventScrolling) {
          document.body.style.overflow = 'hidden';
        }

        this.el.classList.add('open');
        this.el.insertAdjacentElement('afterend', this.$overlay[0]);

        if (this.options.dismissible) {
          this._handleKeydownBound = this._handleKeydown.bind(this);
          this._handleFocusBound = this._handleFocus.bind(this);
          document.addEventListener('keydown', this._handleKeydownBound);
          document.addEventListener('focus', this._handleFocusBound, true);
        }

        anim.remove(this.el);
        anim.remove(this.$overlay[0]);
        this._animateIn();

        // Focus modal
        this.el.focus();

        return this;
      }

      /**
       * Close Modal
       */

    }, {
      key: "close",
      value: function close() {
        if (!this.isOpen) {
          return;
        }

        this.isOpen = false;
        Modal._modalsOpen--;
        this._nthModalOpened = 0;

        // Call onCloseStart callback
        if (typeof this.options.onCloseStart === 'function') {
          this.options.onCloseStart.call(this, this.el);
        }

        this.el.classList.remove('open');

        // Enable body scrolling only if there are no more modals open.
        if (Modal._modalsOpen === 0) {
          document.body.style.overflow = '';
        }

        if (this.options.dismissible) {
          document.removeEventListener('keydown', this._handleKeydownBound);
          document.removeEventListener('focus', this._handleFocusBound, true);
        }

        anim.remove(this.el);
        anim.remove(this.$overlay[0]);
        this._animateOut();
        return this;
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Modal.__proto__ || Object.getPrototypeOf(Modal), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Modal;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Modal;
  }(Component);

  /**
   * @static
   * @memberof Modal
   */


  Modal._modalsOpen = 0;

  /**
   * @static
   * @memberof Modal
   */
  Modal._count = 0;

  M.Modal = Modal;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Modal, 'modal', 'M_Modal');
  }
})(cash, M.anime);
;(function ($, anim) {
  'use strict';

  var _defaults = {
    inDuration: 275,
    outDuration: 200,
    onOpenStart: null,
    onOpenEnd: null,
    onCloseStart: null,
    onCloseEnd: null
  };

  /**
   * @class
   *
   */

  var Materialbox = function (_Component4) {
    _inherits(Materialbox, _Component4);

    /**
     * Construct Materialbox instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Materialbox(el, options) {
      _classCallCheck(this, Materialbox);

      var _this16 = _possibleConstructorReturn(this, (Materialbox.__proto__ || Object.getPrototypeOf(Materialbox)).call(this, Materialbox, el, options));

      _this16.el.M_Materialbox = _this16;

      /**
       * Options for the modal
       * @member Materialbox#options
       * @prop {Number} [inDuration=275] - Length in ms of enter transition
       * @prop {Number} [outDuration=200] - Length in ms of exit transition
       * @prop {Function} onOpenStart - Callback function called before materialbox is opened
       * @prop {Function} onOpenEnd - Callback function called after materialbox is opened
       * @prop {Function} onCloseStart - Callback function called before materialbox is closed
       * @prop {Function} onCloseEnd - Callback function called after materialbox is closed
       */
      _this16.options = $.extend({}, Materialbox.defaults, options);

      _this16.overlayActive = false;
      _this16.doneAnimating = true;
      _this16.placeholder = $('<div></div>').addClass('material-placeholder');
      _this16.originalWidth = 0;
      _this16.originalHeight = 0;
      _this16.originInlineStyles = _this16.$el.attr('style');
      _this16.caption = _this16.el.getAttribute('data-caption') || '';

      // Wrap
      _this16.$el.before(_this16.placeholder);
      _this16.placeholder.append(_this16.$el);

      _this16._setupEventHandlers();
      return _this16;
    }

    _createClass(Materialbox, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this.el.M_Materialbox = undefined;

        // Unwrap image
        $(this.placeholder).after(this.el).remove();

        this.$el.removeAttr('style');
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleMaterialboxClickBound = this._handleMaterialboxClick.bind(this);
        this.el.addEventListener('click', this._handleMaterialboxClickBound);
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('click', this._handleMaterialboxClickBound);
      }

      /**
       * Handle Materialbox Click
       * @param {Event} e
       */

    }, {
      key: "_handleMaterialboxClick",
      value: function _handleMaterialboxClick(e) {
        // If already modal, return to original
        if (this.doneAnimating === false || this.overlayActive && this.doneAnimating) {
          this.close();
        } else {
          this.open();
        }
      }

      /**
       * Handle Window Scroll
       */

    }, {
      key: "_handleWindowScroll",
      value: function _handleWindowScroll() {
        if (this.overlayActive) {
          this.close();
        }
      }

      /**
       * Handle Window Resize
       */

    }, {
      key: "_handleWindowResize",
      value: function _handleWindowResize() {
        if (this.overlayActive) {
          this.close();
        }
      }

      /**
       * Handle Window Resize
       * @param {Event} e
       */

    }, {
      key: "_handleWindowEscape",
      value: function _handleWindowEscape(e) {
        // ESC key
        if (e.keyCode === 27 && this.doneAnimating && this.overlayActive) {
          this.close();
        }
      }

      /**
       * Find ancestors with overflow: hidden; and make visible
       */

    }, {
      key: "_makeAncestorsOverflowVisible",
      value: function _makeAncestorsOverflowVisible() {
        this.ancestorsChanged = $();
        var ancestor = this.placeholder[0].parentNode;
        while (ancestor !== null && !$(ancestor).is(document)) {
          var curr = $(ancestor);
          if (curr.css('overflow') !== 'visible') {
            curr.css('overflow', 'visible');
            if (this.ancestorsChanged === undefined) {
              this.ancestorsChanged = curr;
            } else {
              this.ancestorsChanged = this.ancestorsChanged.add(curr);
            }
          }
          ancestor = ancestor.parentNode;
        }
      }

      /**
       * Animate image in
       */

    }, {
      key: "_animateImageIn",
      value: function _animateImageIn() {
        var _this17 = this;

        var animOptions = {
          targets: this.el,
          height: [this.originalHeight, this.newHeight],
          width: [this.originalWidth, this.newWidth],
          left: M.getDocumentScrollLeft() + this.windowWidth / 2 - this.placeholder.offset().left - this.newWidth / 2,
          top: M.getDocumentScrollTop() + this.windowHeight / 2 - this.placeholder.offset().top - this.newHeight / 2,
          duration: this.options.inDuration,
          easing: 'easeOutQuad',
          complete: function () {
            _this17.doneAnimating = true;

            // onOpenEnd callback
            if (typeof _this17.options.onOpenEnd === 'function') {
              _this17.options.onOpenEnd.call(_this17, _this17.el);
            }
          }
        };

        // Override max-width or max-height if needed
        this.maxWidth = this.$el.css('max-width');
        this.maxHeight = this.$el.css('max-height');
        if (this.maxWidth !== 'none') {
          animOptions.maxWidth = this.newWidth;
        }
        if (this.maxHeight !== 'none') {
          animOptions.maxHeight = this.newHeight;
        }

        anim(animOptions);
      }

      /**
       * Animate image out
       */

    }, {
      key: "_animateImageOut",
      value: function _animateImageOut() {
        var _this18 = this;

        var animOptions = {
          targets: this.el,
          width: this.originalWidth,
          height: this.originalHeight,
          left: 0,
          top: 0,
          duration: this.options.outDuration,
          easing: 'easeOutQuad',
          complete: function () {
            _this18.placeholder.css({
              height: '',
              width: '',
              position: '',
              top: '',
              left: ''
            });

            // Revert to width or height attribute
            if (_this18.attrWidth) {
              _this18.$el.attr('width', _this18.attrWidth);
            }
            if (_this18.attrHeight) {
              _this18.$el.attr('height', _this18.attrHeight);
            }

            _this18.$el.removeAttr('style');
            _this18.originInlineStyles && _this18.$el.attr('style', _this18.originInlineStyles);

            // Remove class
            _this18.$el.removeClass('active');
            _this18.doneAnimating = true;

            // Remove overflow overrides on ancestors
            if (_this18.ancestorsChanged.length) {
              _this18.ancestorsChanged.css('overflow', '');
            }

            // onCloseEnd callback
            if (typeof _this18.options.onCloseEnd === 'function') {
              _this18.options.onCloseEnd.call(_this18, _this18.el);
            }
          }
        };

        anim(animOptions);
      }

      /**
       * Update open and close vars
       */

    }, {
      key: "_updateVars",
      value: function _updateVars() {
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
        this.caption = this.el.getAttribute('data-caption') || '';
      }

      /**
       * Open Materialbox
       */

    }, {
      key: "open",
      value: function open() {
        var _this19 = this;

        this._updateVars();
        this.originalWidth = this.el.getBoundingClientRect().width;
        this.originalHeight = this.el.getBoundingClientRect().height;

        // Set states
        this.doneAnimating = false;
        this.$el.addClass('active');
        this.overlayActive = true;

        // onOpenStart callback
        if (typeof this.options.onOpenStart === 'function') {
          this.options.onOpenStart.call(this, this.el);
        }

        // Set positioning for placeholder
        this.placeholder.css({
          width: this.placeholder[0].getBoundingClientRect().width + 'px',
          height: this.placeholder[0].getBoundingClientRect().height + 'px',
          position: 'relative',
          top: 0,
          left: 0
        });

        this._makeAncestorsOverflowVisible();

        // Set css on origin
        this.$el.css({
          position: 'absolute',
          'z-index': 1000,
          'will-change': 'left, top, width, height'
        });

        // Change from width or height attribute to css
        this.attrWidth = this.$el.attr('width');
        this.attrHeight = this.$el.attr('height');
        if (this.attrWidth) {
          this.$el.css('width', this.attrWidth + 'px');
          this.$el.removeAttr('width');
        }
        if (this.attrHeight) {
          this.$el.css('width', this.attrHeight + 'px');
          this.$el.removeAttr('height');
        }

        // Add overlay
        this.$overlay = $('<div id="materialbox-overlay"></div>').css({
          opacity: 0
        }).one('click', function () {
          if (_this19.doneAnimating) {
            _this19.close();
          }
        });

        // Put before in origin image to preserve z-index layering.
        this.$el.before(this.$overlay);

        // Set dimensions if needed
        var overlayOffset = this.$overlay[0].getBoundingClientRect();
        this.$overlay.css({
          width: this.windowWidth + 'px',
          height: this.windowHeight + 'px',
          left: -1 * overlayOffset.left + 'px',
          top: -1 * overlayOffset.top + 'px'
        });

        anim.remove(this.el);
        anim.remove(this.$overlay[0]);

        // Animate Overlay
        anim({
          targets: this.$overlay[0],
          opacity: 1,
          duration: this.options.inDuration,
          easing: 'easeOutQuad'
        });

        // Add and animate caption if it exists
        if (this.caption !== '') {
          if (this.$photocaption) {
            anim.remove(this.$photoCaption[0]);
          }
          this.$photoCaption = $('<div class="materialbox-caption"></div>');
          this.$photoCaption.text(this.caption);
          $('body').append(this.$photoCaption);
          this.$photoCaption.css({ display: 'inline' });

          anim({
            targets: this.$photoCaption[0],
            opacity: 1,
            duration: this.options.inDuration,
            easing: 'easeOutQuad'
          });
        }

        // Resize Image
        var ratio = 0;
        var widthPercent = this.originalWidth / this.windowWidth;
        var heightPercent = this.originalHeight / this.windowHeight;
        this.newWidth = 0;
        this.newHeight = 0;

        if (widthPercent > heightPercent) {
          ratio = this.originalHeight / this.originalWidth;
          this.newWidth = this.windowWidth * 0.9;
          this.newHeight = this.windowWidth * 0.9 * ratio;
        } else {
          ratio = this.originalWidth / this.originalHeight;
          this.newWidth = this.windowHeight * 0.9 * ratio;
          this.newHeight = this.windowHeight * 0.9;
        }

        this._animateImageIn();

        // Handle Exit triggers
        this._handleWindowScrollBound = this._handleWindowScroll.bind(this);
        this._handleWindowResizeBound = this._handleWindowResize.bind(this);
        this._handleWindowEscapeBound = this._handleWindowEscape.bind(this);

        window.addEventListener('scroll', this._handleWindowScrollBound);
        window.addEventListener('resize', this._handleWindowResizeBound);
        window.addEventListener('keyup', this._handleWindowEscapeBound);
      }

      /**
       * Close Materialbox
       */

    }, {
      key: "close",
      value: function close() {
        var _this20 = this;

        this._updateVars();
        this.doneAnimating = false;

        // onCloseStart callback
        if (typeof this.options.onCloseStart === 'function') {
          this.options.onCloseStart.call(this, this.el);
        }

        anim.remove(this.el);
        anim.remove(this.$overlay[0]);

        if (this.caption !== '') {
          anim.remove(this.$photoCaption[0]);
        }

        // disable exit handlers
        window.removeEventListener('scroll', this._handleWindowScrollBound);
        window.removeEventListener('resize', this._handleWindowResizeBound);
        window.removeEventListener('keyup', this._handleWindowEscapeBound);

        anim({
          targets: this.$overlay[0],
          opacity: 0,
          duration: this.options.outDuration,
          easing: 'easeOutQuad',
          complete: function () {
            _this20.overlayActive = false;
            _this20.$overlay.remove();
          }
        });

        this._animateImageOut();

        // Remove Caption + reset css settings on image
        if (this.caption !== '') {
          anim({
            targets: this.$photoCaption[0],
            opacity: 0,
            duration: this.options.outDuration,
            easing: 'easeOutQuad',
            complete: function () {
              _this20.$photoCaption.remove();
            }
          });
        }
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Materialbox.__proto__ || Object.getPrototypeOf(Materialbox), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Materialbox;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Materialbox;
  }(Component);

  M.Materialbox = Materialbox;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Materialbox, 'materialbox', 'M_Materialbox');
  }
})(cash, M.anime);
;(function ($) {
  'use strict';

  var _defaults = {
    responsiveThreshold: 0 // breakpoint for swipeable
  };

  var Parallax = function (_Component5) {
    _inherits(Parallax, _Component5);

    function Parallax(el, options) {
      _classCallCheck(this, Parallax);

      var _this21 = _possibleConstructorReturn(this, (Parallax.__proto__ || Object.getPrototypeOf(Parallax)).call(this, Parallax, el, options));

      _this21.el.M_Parallax = _this21;

      /**
       * Options for the Parallax
       * @member Parallax#options
       * @prop {Number} responsiveThreshold
       */
      _this21.options = $.extend({}, Parallax.defaults, options);
      _this21._enabled = window.innerWidth > _this21.options.responsiveThreshold;

      _this21.$img = _this21.$el.find('img').first();
      _this21.$img.each(function () {
        var el = this;
        if (el.complete) $(el).trigger('load');
      });

      _this21._updateParallax();
      _this21._setupEventHandlers();
      _this21._setupStyles();

      Parallax._parallaxes.push(_this21);
      return _this21;
    }

    _createClass(Parallax, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        Parallax._parallaxes.splice(Parallax._parallaxes.indexOf(this), 1);
        this.$img[0].style.transform = '';
        this._removeEventHandlers();

        this.$el[0].M_Parallax = undefined;
      }
    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleImageLoadBound = this._handleImageLoad.bind(this);
        this.$img[0].addEventListener('load', this._handleImageLoadBound);

        if (Parallax._parallaxes.length === 0) {
          Parallax._handleScrollThrottled = M.throttle(Parallax._handleScroll, 5);
          window.addEventListener('scroll', Parallax._handleScrollThrottled);

          Parallax._handleWindowResizeThrottled = M.throttle(Parallax._handleWindowResize, 5);
          window.addEventListener('resize', Parallax._handleWindowResizeThrottled);
        }
      }
    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.$img[0].removeEventListener('load', this._handleImageLoadBound);

        if (Parallax._parallaxes.length === 0) {
          window.removeEventListener('scroll', Parallax._handleScrollThrottled);
          window.removeEventListener('resize', Parallax._handleWindowResizeThrottled);
        }
      }
    }, {
      key: "_setupStyles",
      value: function _setupStyles() {
        this.$img[0].style.opacity = 1;
      }
    }, {
      key: "_handleImageLoad",
      value: function _handleImageLoad() {
        this._updateParallax();
      }
    }, {
      key: "_updateParallax",
      value: function _updateParallax() {
        var containerHeight = this.$el.height() > 0 ? this.el.parentNode.offsetHeight : 500;
        var imgHeight = this.$img[0].offsetHeight;
        var parallaxDist = imgHeight - containerHeight;
        var bottom = this.$el.offset().top + containerHeight;
        var top = this.$el.offset().top;
        var scrollTop = M.getDocumentScrollTop();
        var windowHeight = window.innerHeight;
        var windowBottom = scrollTop + windowHeight;
        var percentScrolled = (windowBottom - top) / (containerHeight + windowHeight);
        var parallax = parallaxDist * percentScrolled;

        if (!this._enabled) {
          this.$img[0].style.transform = '';
        } else if (bottom > scrollTop && top < scrollTop + windowHeight) {
          this.$img[0].style.transform = "translate3D(-50%, " + parallax + "px, 0)";
        }
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Parallax.__proto__ || Object.getPrototypeOf(Parallax), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Parallax;
      }
    }, {
      key: "_handleScroll",
      value: function _handleScroll() {
        for (var i = 0; i < Parallax._parallaxes.length; i++) {
          var parallaxInstance = Parallax._parallaxes[i];
          parallaxInstance._updateParallax.call(parallaxInstance);
        }
      }
    }, {
      key: "_handleWindowResize",
      value: function _handleWindowResize() {
        for (var i = 0; i < Parallax._parallaxes.length; i++) {
          var parallaxInstance = Parallax._parallaxes[i];
          parallaxInstance._enabled = window.innerWidth > parallaxInstance.options.responsiveThreshold;
        }
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Parallax;
  }(Component);

  /**
   * @static
   * @memberof Parallax
   */


  Parallax._parallaxes = [];

  M.Parallax = Parallax;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Parallax, 'parallax', 'M_Parallax');
  }
})(cash);
;(function ($, anim) {
  'use strict';

  var _defaults = {
    duration: 300,
    onShow: null,
    swipeable: false,
    responsiveThreshold: Infinity // breakpoint for swipeable
  };

  /**
   * @class
   *
   */

  var Tabs = function (_Component6) {
    _inherits(Tabs, _Component6);

    /**
     * Construct Tabs instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Tabs(el, options) {
      _classCallCheck(this, Tabs);

      var _this22 = _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, Tabs, el, options));

      _this22.el.M_Tabs = _this22;

      /**
       * Options for the Tabs
       * @member Tabs#options
       * @prop {Number} duration
       * @prop {Function} onShow
       * @prop {Boolean} swipeable
       * @prop {Number} responsiveThreshold
       */
      _this22.options = $.extend({}, Tabs.defaults, options);

      // Setup
      _this22.$tabLinks = _this22.$el.children('li.tab').children('a');
      _this22.index = 0;
      _this22._setupActiveTabLink();

      // Setup tabs content
      if (_this22.options.swipeable) {
        _this22._setupSwipeableTabs();
      } else {
        _this22._setupNormalTabs();
      }

      // Setup tabs indicator after content to ensure accurate widths
      _this22._setTabsAndTabWidth();
      _this22._createIndicator();

      _this22._setupEventHandlers();
      return _this22;
    }

    _createClass(Tabs, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this._indicator.parentNode.removeChild(this._indicator);

        if (this.options.swipeable) {
          this._teardownSwipeableTabs();
        } else {
          this._teardownNormalTabs();
        }

        this.$el[0].M_Tabs = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleWindowResizeBound = this._handleWindowResize.bind(this);
        window.addEventListener('resize', this._handleWindowResizeBound);

        this._handleTabClickBound = this._handleTabClick.bind(this);
        this.el.addEventListener('click', this._handleTabClickBound);
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        window.removeEventListener('resize', this._handleWindowResizeBound);
        this.el.removeEventListener('click', this._handleTabClickBound);
      }

      /**
       * Handle window Resize
       */

    }, {
      key: "_handleWindowResize",
      value: function _handleWindowResize() {
        this._setTabsAndTabWidth();

        if (this.tabWidth !== 0 && this.tabsWidth !== 0) {
          this._indicator.style.left = this._calcLeftPos(this.$activeTabLink) + 'px';
          this._indicator.style.right = this._calcRightPos(this.$activeTabLink) + 'px';
        }
      }

      /**
       * Handle tab click
       * @param {Event} e
       */

    }, {
      key: "_handleTabClick",
      value: function _handleTabClick(e) {
        var _this23 = this;

        var tab = $(e.target).closest('li.tab');
        var tabLink = $(e.target).closest('a');

        // Handle click on tab link only
        if (!tabLink.length || !tabLink.parent().hasClass('tab')) {
          return;
        }

        if (tab.hasClass('disabled')) {
          e.preventDefault();
          return;
        }

        // Act as regular link if target attribute is specified.
        if (!!tabLink.attr('target')) {
          return;
        }

        // Make the old tab inactive.
        this.$activeTabLink.removeClass('active');
        var $oldContent = this.$content;

        // Update the variables with the new link and content
        this.$activeTabLink = tabLink;
        this.$content = $(M.escapeHash(tabLink[0].hash));
        this.$tabLinks = this.$el.children('li.tab').children('a');

        // Make the tab active.
        this.$activeTabLink.addClass('active');
        var prevIndex = this.index;
        this.index = Math.max(this.$tabLinks.index(tabLink), 0);

        // Swap content
        if (this.options.swipeable) {
          if (this._tabsCarousel) {
            this._tabsCarousel.set(this.index, function () {
              if (typeof _this23.options.onShow === 'function') {
                _this23.options.onShow.call(_this23, _this23.$content[0]);
              }
            });
          }
        } else {
          if (this.$content.length) {
            this.$content[0].style.display = 'block';
            this.$content.addClass('active');
            if (typeof this.options.onShow === 'function') {
              this.options.onShow.call(this, this.$content[0]);
            }

            if ($oldContent.length && !$oldContent.is(this.$content)) {
              $oldContent[0].style.display = 'none';
              $oldContent.removeClass('active');
            }
          }
        }

        // Update widths after content is swapped (scrollbar bugfix)
        this._setTabsAndTabWidth();

        // Update indicator
        this._animateIndicator(prevIndex);

        // Prevent the anchor's default click action
        e.preventDefault();
      }

      /**
       * Generate elements for tab indicator.
       */

    }, {
      key: "_createIndicator",
      value: function _createIndicator() {
        var _this24 = this;

        var indicator = document.createElement('li');
        indicator.classList.add('indicator');

        this.el.appendChild(indicator);
        this._indicator = indicator;

        setTimeout(function () {
          _this24._indicator.style.left = _this24._calcLeftPos(_this24.$activeTabLink) + 'px';
          _this24._indicator.style.right = _this24._calcRightPos(_this24.$activeTabLink) + 'px';
        }, 0);
      }

      /**
       * Setup first active tab link.
       */

    }, {
      key: "_setupActiveTabLink",
      value: function _setupActiveTabLink() {
        // If the location.hash matches one of the links, use that as the active tab.
        this.$activeTabLink = $(this.$tabLinks.filter('[href="' + location.hash + '"]'));

        // If no match is found, use the first link or any with class 'active' as the initial active tab.
        if (this.$activeTabLink.length === 0) {
          this.$activeTabLink = this.$el.children('li.tab').children('a.active').first();
        }
        if (this.$activeTabLink.length === 0) {
          this.$activeTabLink = this.$el.children('li.tab').children('a').first();
        }

        this.$tabLinks.removeClass('active');
        this.$activeTabLink[0].classList.add('active');

        this.index = Math.max(this.$tabLinks.index(this.$activeTabLink), 0);

        if (this.$activeTabLink.length) {
          this.$content = $(M.escapeHash(this.$activeTabLink[0].hash));
          this.$content.addClass('active');
        }
      }

      /**
       * Setup swipeable tabs
       */

    }, {
      key: "_setupSwipeableTabs",
      value: function _setupSwipeableTabs() {
        var _this25 = this;

        // Change swipeable according to responsive threshold
        if (window.innerWidth > this.options.responsiveThreshold) {
          this.options.swipeable = false;
        }

        var $tabsContent = $();
        this.$tabLinks.each(function (link) {
          var $currContent = $(M.escapeHash(link.hash));
          $currContent.addClass('carousel-item');
          $tabsContent = $tabsContent.add($currContent);
        });

        var $tabsWrapper = $('<div class="tabs-content carousel carousel-slider"></div>');
        $tabsContent.first().before($tabsWrapper);
        $tabsWrapper.append($tabsContent);
        $tabsContent[0].style.display = '';

        // Keep active tab index to set initial carousel slide
        var activeTabIndex = this.$activeTabLink.closest('.tab').index();

        this._tabsCarousel = M.Carousel.init($tabsWrapper[0], {
          fullWidth: true,
          noWrap: true,
          onCycleTo: function (item) {
            var prevIndex = _this25.index;
            _this25.index = $(item).index();
            _this25.$activeTabLink.removeClass('active');
            _this25.$activeTabLink = _this25.$tabLinks.eq(_this25.index);
            _this25.$activeTabLink.addClass('active');
            _this25._animateIndicator(prevIndex);
            if (typeof _this25.options.onShow === 'function') {
              _this25.options.onShow.call(_this25, _this25.$content[0]);
            }
          }
        });

        // Set initial carousel slide to active tab
        this._tabsCarousel.set(activeTabIndex);
      }

      /**
       * Teardown normal tabs.
       */

    }, {
      key: "_teardownSwipeableTabs",
      value: function _teardownSwipeableTabs() {
        var $tabsWrapper = this._tabsCarousel.$el;
        this._tabsCarousel.destroy();

        // Unwrap
        $tabsWrapper.after($tabsWrapper.children());
        $tabsWrapper.remove();
      }

      /**
       * Setup normal tabs.
       */

    }, {
      key: "_setupNormalTabs",
      value: function _setupNormalTabs() {
        // Hide Tabs Content
        this.$tabLinks.not(this.$activeTabLink).each(function (link) {
          if (!!link.hash) {
            var $currContent = $(M.escapeHash(link.hash));
            if ($currContent.length) {
              $currContent[0].style.display = 'none';
            }
          }
        });
      }

      /**
       * Teardown normal tabs.
       */

    }, {
      key: "_teardownNormalTabs",
      value: function _teardownNormalTabs() {
        // show Tabs Content
        this.$tabLinks.each(function (link) {
          if (!!link.hash) {
            var $currContent = $(M.escapeHash(link.hash));
            if ($currContent.length) {
              $currContent[0].style.display = '';
            }
          }
        });
      }

      /**
       * set tabs and tab width
       */

    }, {
      key: "_setTabsAndTabWidth",
      value: function _setTabsAndTabWidth() {
        this.tabsWidth = this.$el.width();
        this.tabWidth = Math.max(this.tabsWidth, this.el.scrollWidth) / this.$tabLinks.length;
      }

      /**
       * Finds right attribute for indicator based on active tab.
       * @param {cash} el
       */

    }, {
      key: "_calcRightPos",
      value: function _calcRightPos(el) {
        return Math.ceil(this.tabsWidth - el.position().left - el[0].getBoundingClientRect().width);
      }

      /**
       * Finds left attribute for indicator based on active tab.
       * @param {cash} el
       */

    }, {
      key: "_calcLeftPos",
      value: function _calcLeftPos(el) {
        return Math.floor(el.position().left);
      }
    }, {
      key: "updateTabIndicator",
      value: function updateTabIndicator() {
        this._setTabsAndTabWidth();
        this._animateIndicator(this.index);
      }

      /**
       * Animates Indicator to active tab.
       * @param {Number} prevIndex
       */

    }, {
      key: "_animateIndicator",
      value: function _animateIndicator(prevIndex) {
        var leftDelay = 0,
            rightDelay = 0;

        if (this.index - prevIndex >= 0) {
          leftDelay = 90;
        } else {
          rightDelay = 90;
        }

        // Animate
        var animOptions = {
          targets: this._indicator,
          left: {
            value: this._calcLeftPos(this.$activeTabLink),
            delay: leftDelay
          },
          right: {
            value: this._calcRightPos(this.$activeTabLink),
            delay: rightDelay
          },
          duration: this.options.duration,
          easing: 'easeOutQuad'
        };
        anim.remove(this._indicator);
        anim(animOptions);
      }

      /**
       * Select tab.
       * @param {String} tabId
       */

    }, {
      key: "select",
      value: function select(tabId) {
        var tab = this.$tabLinks.filter('[href="#' + tabId + '"]');
        if (tab.length) {
          tab.trigger('click');
        }
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Tabs.__proto__ || Object.getPrototypeOf(Tabs), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Tabs;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Tabs;
  }(Component);

  window.M.Tabs = Tabs;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Tabs, 'tabs', 'M_Tabs');
  }
})(cash, M.anime);
;(function ($, anim) {
  'use strict';

  var _defaults = {
    exitDelay: 200,
    enterDelay: 0,
    html: null,
    margin: 5,
    inDuration: 250,
    outDuration: 200,
    position: 'bottom',
    transitionMovement: 10
  };

  /**
   * @class
   *
   */

  var Tooltip = function (_Component7) {
    _inherits(Tooltip, _Component7);

    /**
     * Construct Tooltip instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Tooltip(el, options) {
      _classCallCheck(this, Tooltip);

      var _this26 = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, Tooltip, el, options));

      _this26.el.M_Tooltip = _this26;
      _this26.options = $.extend({}, Tooltip.defaults, options);

      _this26.isOpen = false;
      _this26.isHovered = false;
      _this26.isFocused = false;
      _this26._appendTooltipEl();
      _this26._setupEventHandlers();
      return _this26;
    }

    _createClass(Tooltip, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        $(this.tooltipEl).remove();
        this._removeEventHandlers();
        this.el.M_Tooltip = undefined;
      }
    }, {
      key: "_appendTooltipEl",
      value: function _appendTooltipEl() {
        var tooltipEl = document.createElement('div');
        tooltipEl.classList.add('material-tooltip');
        this.tooltipEl = tooltipEl;

        var tooltipContentEl = document.createElement('div');
        tooltipContentEl.classList.add('tooltip-content');
        tooltipContentEl.innerHTML = this.options.html;
        tooltipEl.appendChild(tooltipContentEl);
        document.body.appendChild(tooltipEl);
      }
    }, {
      key: "_updateTooltipContent",
      value: function _updateTooltipContent() {
        this.tooltipEl.querySelector('.tooltip-content').innerHTML = this.options.html;
      }
    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleMouseEnterBound = this._handleMouseEnter.bind(this);
        this._handleMouseLeaveBound = this._handleMouseLeave.bind(this);
        this._handleFocusBound = this._handleFocus.bind(this);
        this._handleBlurBound = this._handleBlur.bind(this);
        this.el.addEventListener('mouseenter', this._handleMouseEnterBound);
        this.el.addEventListener('mouseleave', this._handleMouseLeaveBound);
        this.el.addEventListener('focus', this._handleFocusBound, true);
        this.el.addEventListener('blur', this._handleBlurBound, true);
      }
    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('mouseenter', this._handleMouseEnterBound);
        this.el.removeEventListener('mouseleave', this._handleMouseLeaveBound);
        this.el.removeEventListener('focus', this._handleFocusBound, true);
        this.el.removeEventListener('blur', this._handleBlurBound, true);
      }
    }, {
      key: "open",
      value: function open(isManual) {
        if (this.isOpen) {
          return;
        }
        isManual = isManual === undefined ? true : undefined; // Default value true
        this.isOpen = true;
        // Update tooltip content with HTML attribute options
        this.options = $.extend({}, this.options, this._getAttributeOptions());
        this._updateTooltipContent();
        this._setEnterDelayTimeout(isManual);
      }
    }, {
      key: "close",
      value: function close() {
        if (!this.isOpen) {
          return;
        }

        this.isHovered = false;
        this.isFocused = false;
        this.isOpen = false;
        this._setExitDelayTimeout();
      }

      /**
       * Create timeout which delays when the tooltip closes
       */

    }, {
      key: "_setExitDelayTimeout",
      value: function _setExitDelayTimeout() {
        var _this27 = this;

        clearTimeout(this._exitDelayTimeout);

        this._exitDelayTimeout = setTimeout(function () {
          if (_this27.isHovered || _this27.isFocused) {
            return;
          }

          _this27._animateOut();
        }, this.options.exitDelay);
      }

      /**
       * Create timeout which delays when the toast closes
       */

    }, {
      key: "_setEnterDelayTimeout",
      value: function _setEnterDelayTimeout(isManual) {
        var _this28 = this;

        clearTimeout(this._enterDelayTimeout);

        this._enterDelayTimeout = setTimeout(function () {
          if (!_this28.isHovered && !_this28.isFocused && !isManual) {
            return;
          }

          _this28._animateIn();
        }, this.options.enterDelay);
      }
    }, {
      key: "_positionTooltip",
      value: function _positionTooltip() {
        var origin = this.el,
            tooltip = this.tooltipEl,
            originHeight = origin.offsetHeight,
            originWidth = origin.offsetWidth,
            tooltipHeight = tooltip.offsetHeight,
            tooltipWidth = tooltip.offsetWidth,
            newCoordinates = void 0,
            margin = this.options.margin,
            targetTop = void 0,
            targetLeft = void 0;

        this.xMovement = 0, this.yMovement = 0;

        targetTop = origin.getBoundingClientRect().top + M.getDocumentScrollTop();
        targetLeft = origin.getBoundingClientRect().left + M.getDocumentScrollLeft();

        if (this.options.position === 'top') {
          targetTop += -tooltipHeight - margin;
          targetLeft += originWidth / 2 - tooltipWidth / 2;
          this.yMovement = -this.options.transitionMovement;
        } else if (this.options.position === 'right') {
          targetTop += originHeight / 2 - tooltipHeight / 2;
          targetLeft += originWidth + margin;
          this.xMovement = this.options.transitionMovement;
        } else if (this.options.position === 'left') {
          targetTop += originHeight / 2 - tooltipHeight / 2;
          targetLeft += -tooltipWidth - margin;
          this.xMovement = -this.options.transitionMovement;
        } else {
          targetTop += originHeight + margin;
          targetLeft += originWidth / 2 - tooltipWidth / 2;
          this.yMovement = this.options.transitionMovement;
        }

        newCoordinates = this._repositionWithinScreen(targetLeft, targetTop, tooltipWidth, tooltipHeight);
        $(tooltip).css({
          top: newCoordinates.y + 'px',
          left: newCoordinates.x + 'px'
        });
      }
    }, {
      key: "_repositionWithinScreen",
      value: function _repositionWithinScreen(x, y, width, height) {
        var scrollLeft = M.getDocumentScrollLeft();
        var scrollTop = M.getDocumentScrollTop();
        var newX = x - scrollLeft;
        var newY = y - scrollTop;

        var bounding = {
          left: newX,
          top: newY,
          width: width,
          height: height
        };

        var offset = this.options.margin + this.options.transitionMovement;
        var edges = M.checkWithinContainer(document.body, bounding, offset);

        if (edges.left) {
          newX = offset;
        } else if (edges.right) {
          newX -= newX + width - window.innerWidth;
        }

        if (edges.top) {
          newY = offset;
        } else if (edges.bottom) {
          newY -= newY + height - window.innerHeight;
        }

        return {
          x: newX + scrollLeft,
          y: newY + scrollTop
        };
      }
    }, {
      key: "_animateIn",
      value: function _animateIn() {
        this._positionTooltip();
        this.tooltipEl.style.visibility = 'visible';
        anim.remove(this.tooltipEl);
        anim({
          targets: this.tooltipEl,
          opacity: 1,
          translateX: this.xMovement,
          translateY: this.yMovement,
          duration: this.options.inDuration,
          easing: 'easeOutCubic'
        });
      }
    }, {
      key: "_animateOut",
      value: function _animateOut() {
        anim.remove(this.tooltipEl);
        anim({
          targets: this.tooltipEl,
          opacity: 0,
          translateX: 0,
          translateY: 0,
          duration: this.options.outDuration,
          easing: 'easeOutCubic'
        });
      }
    }, {
      key: "_handleMouseEnter",
      value: function _handleMouseEnter() {
        this.isHovered = true;
        this.isFocused = false; // Allows close of tooltip when opened by focus.
        this.open(false);
      }
    }, {
      key: "_handleMouseLeave",
      value: function _handleMouseLeave() {
        this.isHovered = false;
        this.isFocused = false; // Allows close of tooltip when opened by focus.
        this.close();
      }
    }, {
      key: "_handleFocus",
      value: function _handleFocus() {
        if (M.tabPressed) {
          this.isFocused = true;
          this.open(false);
        }
      }
    }, {
      key: "_handleBlur",
      value: function _handleBlur() {
        this.isFocused = false;
        this.close();
      }
    }, {
      key: "_getAttributeOptions",
      value: function _getAttributeOptions() {
        var attributeOptions = {};
        var tooltipTextOption = this.el.getAttribute('data-tooltip');
        var positionOption = this.el.getAttribute('data-position');

        if (tooltipTextOption) {
          attributeOptions.html = tooltipTextOption;
        }

        if (positionOption) {
          attributeOptions.position = positionOption;
        }
        return attributeOptions;
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Tooltip.__proto__ || Object.getPrototypeOf(Tooltip), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Tooltip;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Tooltip;
  }(Component);

  M.Tooltip = Tooltip;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Tooltip, 'tooltip', 'M_Tooltip');
  }
})(cash, M.anime);
; /*!
  * Waves v0.6.4
  * http://fian.my.id/Waves
  *
  * Copyright 2014 Alfiana E. Sibuea and other contributors
  * Released under the MIT license
  * https://github.com/fians/Waves/blob/master/LICENSE
  */

;(function (window) {
  'use strict';

  var Waves = Waves || {};
  var $$ = document.querySelectorAll.bind(document);

  // Find exact position of element
  function isWindow(obj) {
    return obj !== null && obj === obj.window;
  }

  function getWindow(elem) {
    return isWindow(elem) ? elem : elem.nodeType === 9 && elem.defaultView;
  }

  function offset(elem) {
    var docElem,
        win,
        box = { top: 0, left: 0 },
        doc = elem && elem.ownerDocument;

    docElem = doc.documentElement;

    if (typeof elem.getBoundingClientRect !== typeof undefined) {
      box = elem.getBoundingClientRect();
    }
    win = getWindow(doc);
    return {
      top: box.top + win.pageYOffset - docElem.clientTop,
      left: box.left + win.pageXOffset - docElem.clientLeft
    };
  }

  function convertStyle(obj) {
    var style = '';

    for (var a in obj) {
      if (obj.hasOwnProperty(a)) {
        style += a + ':' + obj[a] + ';';
      }
    }

    return style;
  }

  var Effect = {

    // Effect delay
    duration: 750,

    show: function (e, element) {

      // Disable right click
      if (e.button === 2) {
        return false;
      }

      var el = element || this;

      // Create ripple
      var ripple = document.createElement('div');
      ripple.className = 'waves-ripple';
      el.appendChild(ripple);

      // Get click coordinate and element witdh
      var pos = offset(el);
      var relativeY = e.pageY - pos.top;
      var relativeX = e.pageX - pos.left;
      var scale = 'scale(' + el.clientWidth / 100 * 10 + ')';

      // Support for touch devices
      if ('touches' in e) {
        relativeY = e.touches[0].pageY - pos.top;
        relativeX = e.touches[0].pageX - pos.left;
      }

      // Attach data to element
      ripple.setAttribute('data-hold', Date.now());
      ripple.setAttribute('data-scale', scale);
      ripple.setAttribute('data-x', relativeX);
      ripple.setAttribute('data-y', relativeY);

      // Set ripple position
      var rippleStyle = {
        'top': relativeY + 'px',
        'left': relativeX + 'px'
      };

      ripple.className = ripple.className + ' waves-notransition';
      ripple.setAttribute('style', convertStyle(rippleStyle));
      ripple.className = ripple.className.replace('waves-notransition', '');

      // Scale the ripple
      rippleStyle['-webkit-transform'] = scale;
      rippleStyle['-moz-transform'] = scale;
      rippleStyle['-ms-transform'] = scale;
      rippleStyle['-o-transform'] = scale;
      rippleStyle.transform = scale;
      rippleStyle.opacity = '1';

      rippleStyle['-webkit-transition-duration'] = Effect.duration + 'ms';
      rippleStyle['-moz-transition-duration'] = Effect.duration + 'ms';
      rippleStyle['-o-transition-duration'] = Effect.duration + 'ms';
      rippleStyle['transition-duration'] = Effect.duration + 'ms';

      rippleStyle['-webkit-transition-timing-function'] = 'cubic-bezier(0.250, 0.460, 0.450, 0.940)';
      rippleStyle['-moz-transition-timing-function'] = 'cubic-bezier(0.250, 0.460, 0.450, 0.940)';
      rippleStyle['-o-transition-timing-function'] = 'cubic-bezier(0.250, 0.460, 0.450, 0.940)';
      rippleStyle['transition-timing-function'] = 'cubic-bezier(0.250, 0.460, 0.450, 0.940)';

      ripple.setAttribute('style', convertStyle(rippleStyle));
    },

    hide: function (e) {
      TouchHandler.touchup(e);

      var el = this;
      var width = el.clientWidth * 1.4;

      // Get first ripple
      var ripple = null;
      var ripples = el.getElementsByClassName('waves-ripple');
      if (ripples.length > 0) {
        ripple = ripples[ripples.length - 1];
      } else {
        return false;
      }

      var relativeX = ripple.getAttribute('data-x');
      var relativeY = ripple.getAttribute('data-y');
      var scale = ripple.getAttribute('data-scale');

      // Get delay beetween mousedown and mouse leave
      var diff = Date.now() - Number(ripple.getAttribute('data-hold'));
      var delay = 350 - diff;

      if (delay < 0) {
        delay = 0;
      }

      // Fade out ripple after delay
      setTimeout(function () {
        var style = {
          'top': relativeY + 'px',
          'left': relativeX + 'px',
          'opacity': '0',

          // Duration
          '-webkit-transition-duration': Effect.duration + 'ms',
          '-moz-transition-duration': Effect.duration + 'ms',
          '-o-transition-duration': Effect.duration + 'ms',
          'transition-duration': Effect.duration + 'ms',
          '-webkit-transform': scale,
          '-moz-transform': scale,
          '-ms-transform': scale,
          '-o-transform': scale,
          'transform': scale
        };

        ripple.setAttribute('style', convertStyle(style));

        setTimeout(function () {
          try {
            el.removeChild(ripple);
          } catch (e) {
            return false;
          }
        }, Effect.duration);
      }, delay);
    },

    // Little hack to make <input> can perform waves effect
    wrapInput: function (elements) {
      for (var a = 0; a < elements.length; a++) {
        var el = elements[a];

        if (el.tagName.toLowerCase() === 'input') {
          var parent = el.parentNode;

          // If input already have parent just pass through
          if (parent.tagName.toLowerCase() === 'i' && parent.className.indexOf('waves-effect') !== -1) {
            continue;
          }

          // Put element class and style to the specified parent
          var wrapper = document.createElement('i');
          wrapper.className = el.className + ' waves-input-wrapper';

          var elementStyle = el.getAttribute('style');

          if (!elementStyle) {
            elementStyle = '';
          }

          wrapper.setAttribute('style', elementStyle);

          el.className = 'waves-button-input';
          el.removeAttribute('style');

          // Put element as child
          parent.replaceChild(wrapper, el);
          wrapper.appendChild(el);
        }
      }
    }
  };

  /**
   * Disable mousedown event for 500ms during and after touch
   */
  var TouchHandler = {
    /* uses an integer rather than bool so there's no issues with
     * needing to clear timeouts if another touch event occurred
     * within the 500ms. Cannot mouseup between touchstart and
     * touchend, nor in the 500ms after touchend. */
    touches: 0,
    allowEvent: function (e) {
      var allow = true;

      if (e.type === 'touchstart') {
        TouchHandler.touches += 1; //push
      } else if (e.type === 'touchend' || e.type === 'touchcancel') {
        setTimeout(function () {
          if (TouchHandler.touches > 0) {
            TouchHandler.touches -= 1; //pop after 500ms
          }
        }, 500);
      } else if (e.type === 'mousedown' && TouchHandler.touches > 0) {
        allow = false;
      }

      return allow;
    },
    touchup: function (e) {
      TouchHandler.allowEvent(e);
    }
  };

  /**
   * Delegated click handler for .waves-effect element.
   * returns null when .waves-effect element not in "click tree"
   */
  function getWavesEffectElement(e) {
    if (TouchHandler.allowEvent(e) === false) {
      return null;
    }

    var element = null;
    var target = e.target || e.srcElement;

    while (target.parentNode !== null) {
      if (!(target instanceof SVGElement) && target.className.indexOf('waves-effect') !== -1) {
        element = target;
        break;
      }
      target = target.parentNode;
    }
    return element;
  }

  /**
   * Bubble the click and show effect if .waves-effect elem was found
   */
  function showEffect(e) {
    var element = getWavesEffectElement(e);

    if (element !== null) {
      Effect.show(e, element);

      if ('ontouchstart' in window) {
        element.addEventListener('touchend', Effect.hide, false);
        element.addEventListener('touchcancel', Effect.hide, false);
      }

      element.addEventListener('mouseup', Effect.hide, false);
      element.addEventListener('mouseleave', Effect.hide, false);
      element.addEventListener('dragend', Effect.hide, false);
    }
  }

  Waves.displayEffect = function (options) {
    options = options || {};

    if ('duration' in options) {
      Effect.duration = options.duration;
    }

    //Wrap input inside <i> tag
    Effect.wrapInput($$('.waves-effect'));

    if ('ontouchstart' in window) {
      document.body.addEventListener('touchstart', showEffect, false);
    }

    document.body.addEventListener('mousedown', showEffect, false);
  };

  /**
   * Attach Waves to an input element (or any element which doesn't
   * bubble mouseup/mousedown events).
   *   Intended to be used with dynamically loaded forms/inputs, or
   * where the user doesn't want a delegated click handler.
   */
  Waves.attach = function (element) {
    //FUTURE: automatically add waves classes and allow users
    // to specify them with an options param? Eg. light/classic/button
    if (element.tagName.toLowerCase() === 'input') {
      Effect.wrapInput([element]);
      element = element.parentNode;
    }

    if ('ontouchstart' in window) {
      element.addEventListener('touchstart', showEffect, false);
    }

    element.addEventListener('mousedown', showEffect, false);
  };

  window.Waves = Waves;

  document.addEventListener('DOMContentLoaded', function () {
    Waves.displayEffect();
  }, false);
})(window);
;(function ($, anim) {
  'use strict';

  var _defaults = {
    html: '',
    displayLength: 4000,
    inDuration: 300,
    outDuration: 375,
    classes: '',
    completeCallback: null,
    activationPercent: 0.8
  };

  var Toast = function () {
    function Toast(options) {
      _classCallCheck(this, Toast);

      /**
       * Options for the toast
       * @member Toast#options
       */
      this.options = $.extend({}, Toast.defaults, options);
      this.message = this.options.html;

      /**
       * Describes current pan state toast
       * @type {Boolean}
       */
      this.panning = false;

      /**
       * Time remaining until toast is removed
       */
      this.timeRemaining = this.options.displayLength;

      if (Toast._toasts.length === 0) {
        Toast._createContainer();
      }

      // Create new toast
      Toast._toasts.push(this);
      var toastElement = this._createToast();
      toastElement.M_Toast = this;
      this.el = toastElement;
      this.$el = $(toastElement);
      this._animateIn();
      this._setTimer();
    }

    _createClass(Toast, [{
      key: "_createToast",


      /**
       * Create toast and append it to toast container
       */
      value: function _createToast() {
        var toast = document.createElement('div');
        toast.classList.add('toast');

        // Add custom classes onto toast
        if (!!this.options.classes.length) {
          $(toast).addClass(this.options.classes);
        }

        // Set content
        if (typeof HTMLElement === 'object' ? this.message instanceof HTMLElement : this.message && typeof this.message === 'object' && this.message !== null && this.message.nodeType === 1 && typeof this.message.nodeName === 'string') {
          toast.appendChild(this.message);

          // Check if it is jQuery object
        } else if (!!this.message.jquery) {
          $(toast).append(this.message[0]);

          // Insert as html;
        } else {
          toast.innerHTML = this.message;
        }

        // Append toasft
        Toast._container.appendChild(toast);
        return toast;
      }

      /**
       * Animate in toast
       */

    }, {
      key: "_animateIn",
      value: function _animateIn() {
        // Animate toast in
        anim({
          targets: this.el,
          top: 0,
          opacity: 1,
          duration: this.options.inDuration,
          easing: 'easeOutCubic'
        });
      }

      /**
       * Create setInterval which automatically removes toast when timeRemaining >= 0
       * has been reached
       */

    }, {
      key: "_setTimer",
      value: function _setTimer() {
        var _this29 = this;

        if (this.timeRemaining !== Infinity) {
          this.counterInterval = setInterval(function () {
            // If toast is not being dragged, decrease its time remaining
            if (!_this29.panning) {
              _this29.timeRemaining -= 20;
            }

            // Animate toast out
            if (_this29.timeRemaining <= 0) {
              _this29.dismiss();
            }
          }, 20);
        }
      }

      /**
       * Dismiss toast with animation
       */

    }, {
      key: "dismiss",
      value: function dismiss() {
        var _this30 = this;

        window.clearInterval(this.counterInterval);
        var activationDistance = this.el.offsetWidth * this.options.activationPercent;

        if (this.wasSwiped) {
          this.el.style.transition = 'transform .05s, opacity .05s';
          this.el.style.transform = "translateX(" + activationDistance + "px)";
          this.el.style.opacity = 0;
        }

        anim({
          targets: this.el,
          opacity: 0,
          marginTop: -40,
          duration: this.options.outDuration,
          easing: 'easeOutExpo',
          complete: function () {
            // Call the optional callback
            if (typeof _this30.options.completeCallback === 'function') {
              _this30.options.completeCallback();
            }
            // Remove toast from DOM
            _this30.$el.remove();
            Toast._toasts.splice(Toast._toasts.indexOf(_this30), 1);
            if (Toast._toasts.length === 0) {
              Toast._removeContainer();
            }
          }
        });
      }
    }], [{
      key: "getInstance",


      /**
       * Get Instance
       */
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Toast;
      }

      /**
       * Append toast container and add event handlers
       */

    }, {
      key: "_createContainer",
      value: function _createContainer() {
        var container = document.createElement('div');
        container.setAttribute('id', 'toast-container');

        // Add event handler
        container.addEventListener('touchstart', Toast._onDragStart);
        container.addEventListener('touchmove', Toast._onDragMove);
        container.addEventListener('touchend', Toast._onDragEnd);

        container.addEventListener('mousedown', Toast._onDragStart);
        document.addEventListener('mousemove', Toast._onDragMove);
        document.addEventListener('mouseup', Toast._onDragEnd);

        document.body.appendChild(container);
        Toast._container = container;
      }

      /**
       * Remove toast container and event handlers
       */

    }, {
      key: "_removeContainer",
      value: function _removeContainer() {
        // Add event handler
        document.removeEventListener('mousemove', Toast._onDragMove);
        document.removeEventListener('mouseup', Toast._onDragEnd);

        $(Toast._container).remove();
        Toast._container = null;
      }

      /**
       * Begin drag handler
       * @param {Event} e
       */

    }, {
      key: "_onDragStart",
      value: function _onDragStart(e) {
        if (e.target && $(e.target).closest('.toast').length) {
          var $toast = $(e.target).closest('.toast');
          var toast = $toast[0].M_Toast;
          toast.panning = true;
          Toast._draggedToast = toast;
          toast.el.classList.add('panning');
          toast.el.style.transition = '';
          toast.startingXPos = Toast._xPos(e);
          toast.time = Date.now();
          toast.xPos = Toast._xPos(e);
        }
      }

      /**
       * Drag move handler
       * @param {Event} e
       */

    }, {
      key: "_onDragMove",
      value: function _onDragMove(e) {
        if (!!Toast._draggedToast) {
          e.preventDefault();
          var toast = Toast._draggedToast;
          toast.deltaX = Math.abs(toast.xPos - Toast._xPos(e));
          toast.xPos = Toast._xPos(e);
          toast.velocityX = toast.deltaX / (Date.now() - toast.time);
          toast.time = Date.now();

          var totalDeltaX = toast.xPos - toast.startingXPos;
          var activationDistance = toast.el.offsetWidth * toast.options.activationPercent;
          toast.el.style.transform = "translateX(" + totalDeltaX + "px)";
          toast.el.style.opacity = 1 - Math.abs(totalDeltaX / activationDistance);
        }
      }

      /**
       * End drag handler
       */

    }, {
      key: "_onDragEnd",
      value: function _onDragEnd() {
        if (!!Toast._draggedToast) {
          var toast = Toast._draggedToast;
          toast.panning = false;
          toast.el.classList.remove('panning');

          var totalDeltaX = toast.xPos - toast.startingXPos;
          var activationDistance = toast.el.offsetWidth * toast.options.activationPercent;
          var shouldBeDismissed = Math.abs(totalDeltaX) > activationDistance || toast.velocityX > 1;

          // Remove toast
          if (shouldBeDismissed) {
            toast.wasSwiped = true;
            toast.dismiss();

            // Animate toast back to original position
          } else {
            toast.el.style.transition = 'transform .2s, opacity .2s';
            toast.el.style.transform = '';
            toast.el.style.opacity = '';
          }
          Toast._draggedToast = null;
        }
      }

      /**
       * Get x position of mouse or touch event
       * @param {Event} e
       */

    }, {
      key: "_xPos",
      value: function _xPos(e) {
        if (e.targetTouches && e.targetTouches.length >= 1) {
          return e.targetTouches[0].clientX;
        }
        // mouse event
        return e.clientX;
      }

      /**
       * Remove all toasts
       */

    }, {
      key: "dismissAll",
      value: function dismissAll() {
        for (var toastIndex in Toast._toasts) {
          Toast._toasts[toastIndex].dismiss();
        }
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Toast;
  }();

  /**
   * @static
   * @memberof Toast
   * @type {Array.<Toast>}
   */


  Toast._toasts = [];

  /**
   * @static
   * @memberof Toast
   */
  Toast._container = null;

  /**
   * @static
   * @memberof Toast
   * @type {Toast}
   */
  Toast._draggedToast = null;

  M.Toast = Toast;
  M.toast = function (options) {
    return new Toast(options);
  };
})(cash, M.anime);
;(function ($, anim) {
  'use strict';

  var _defaults = {
    edge: 'left',
    draggable: true,
    inDuration: 250,
    outDuration: 200,
    onOpenStart: null,
    onOpenEnd: null,
    onCloseStart: null,
    onCloseEnd: null,
    preventScrolling: true
  };

  /**
   * @class
   */

  var Sidenav = function (_Component8) {
    _inherits(Sidenav, _Component8);

    /**
     * Construct Sidenav instance and set up overlay
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Sidenav(el, options) {
      _classCallCheck(this, Sidenav);

      var _this31 = _possibleConstructorReturn(this, (Sidenav.__proto__ || Object.getPrototypeOf(Sidenav)).call(this, Sidenav, el, options));

      _this31.el.M_Sidenav = _this31;
      _this31.id = _this31.$el.attr('id');

      /**
       * Options for the Sidenav
       * @member Sidenav#options
       * @prop {String} [edge='left'] - Side of screen on which Sidenav appears
       * @prop {Boolean} [draggable=true] - Allow swipe gestures to open/close Sidenav
       * @prop {Number} [inDuration=250] - Length in ms of enter transition
       * @prop {Number} [outDuration=200] - Length in ms of exit transition
       * @prop {Function} onOpenStart - Function called when sidenav starts entering
       * @prop {Function} onOpenEnd - Function called when sidenav finishes entering
       * @prop {Function} onCloseStart - Function called when sidenav starts exiting
       * @prop {Function} onCloseEnd - Function called when sidenav finishes exiting
       */
      _this31.options = $.extend({}, Sidenav.defaults, options);

      /**
       * Describes open/close state of Sidenav
       * @type {Boolean}
       */
      _this31.isOpen = false;

      /**
       * Describes if Sidenav is fixed
       * @type {Boolean}
       */
      _this31.isFixed = _this31.el.classList.contains('sidenav-fixed');

      /**
       * Describes if Sidenav is being draggeed
       * @type {Boolean}
       */
      _this31.isDragged = false;

      // Window size variables for window resize checks
      _this31.lastWindowWidth = window.innerWidth;
      _this31.lastWindowHeight = window.innerHeight;

      _this31._createOverlay();
      _this31._createDragTarget();
      _this31._setupEventHandlers();
      _this31._setupClasses();
      _this31._setupFixed();

      Sidenav._sidenavs.push(_this31);
      return _this31;
    }

    _createClass(Sidenav, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this._enableBodyScrolling();
        this._overlay.parentNode.removeChild(this._overlay);
        this.dragTarget.parentNode.removeChild(this.dragTarget);
        this.el.M_Sidenav = undefined;
        this.el.style.transform = '';

        var index = Sidenav._sidenavs.indexOf(this);
        if (index >= 0) {
          Sidenav._sidenavs.splice(index, 1);
        }
      }
    }, {
      key: "_createOverlay",
      value: function _createOverlay() {
        var overlay = document.createElement('div');
        this._closeBound = this.close.bind(this);
        overlay.classList.add('sidenav-overlay');

        overlay.addEventListener('click', this._closeBound);

        document.body.appendChild(overlay);
        this._overlay = overlay;
      }
    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        if (Sidenav._sidenavs.length === 0) {
          document.body.addEventListener('click', this._handleTriggerClick);
        }

        this._handleDragTargetDragBound = this._handleDragTargetDrag.bind(this);
        this._handleDragTargetReleaseBound = this._handleDragTargetRelease.bind(this);
        this._handleCloseDragBound = this._handleCloseDrag.bind(this);
        this._handleCloseReleaseBound = this._handleCloseRelease.bind(this);
        this._handleCloseTriggerClickBound = this._handleCloseTriggerClick.bind(this);

        this.dragTarget.addEventListener('touchmove', this._handleDragTargetDragBound);
        this.dragTarget.addEventListener('touchend', this._handleDragTargetReleaseBound);
        this._overlay.addEventListener('touchmove', this._handleCloseDragBound);
        this._overlay.addEventListener('touchend', this._handleCloseReleaseBound);
        this.el.addEventListener('touchmove', this._handleCloseDragBound);
        this.el.addEventListener('touchend', this._handleCloseReleaseBound);
        this.el.addEventListener('click', this._handleCloseTriggerClickBound);

        // Add resize for side nav fixed
        if (this.isFixed) {
          this._handleWindowResizeBound = this._handleWindowResize.bind(this);
          window.addEventListener('resize', this._handleWindowResizeBound);
        }
      }
    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        if (Sidenav._sidenavs.length === 1) {
          document.body.removeEventListener('click', this._handleTriggerClick);
        }

        this.dragTarget.removeEventListener('touchmove', this._handleDragTargetDragBound);
        this.dragTarget.removeEventListener('touchend', this._handleDragTargetReleaseBound);
        this._overlay.removeEventListener('touchmove', this._handleCloseDragBound);
        this._overlay.removeEventListener('touchend', this._handleCloseReleaseBound);
        this.el.removeEventListener('touchmove', this._handleCloseDragBound);
        this.el.removeEventListener('touchend', this._handleCloseReleaseBound);
        this.el.removeEventListener('click', this._handleCloseTriggerClickBound);

        // Remove resize for side nav fixed
        if (this.isFixed) {
          window.removeEventListener('resize', this._handleWindowResizeBound);
        }
      }

      /**
       * Handle Trigger Click
       * @param {Event} e
       */

    }, {
      key: "_handleTriggerClick",
      value: function _handleTriggerClick(e) {
        var $trigger = $(e.target).closest('.sidenav-trigger');
        if (e.target && $trigger.length) {
          var sidenavId = M.getIdFromTrigger($trigger[0]);

          var sidenavInstance = document.getElementById(sidenavId).M_Sidenav;
          if (sidenavInstance) {
            sidenavInstance.open($trigger);
          }
          e.preventDefault();
        }
      }

      /**
       * Set variables needed at the beggining of drag
       * and stop any current transition.
       * @param {Event} e
       */

    }, {
      key: "_startDrag",
      value: function _startDrag(e) {
        var clientX = e.targetTouches[0].clientX;
        this.isDragged = true;
        this._startingXpos = clientX;
        this._xPos = this._startingXpos;
        this._time = Date.now();
        this._width = this.el.getBoundingClientRect().width;
        this._overlay.style.display = 'block';
        this._initialScrollTop = this.isOpen ? this.el.scrollTop : M.getDocumentScrollTop();
        this._verticallyScrolling = false;
        anim.remove(this.el);
        anim.remove(this._overlay);
      }

      /**
       * Set variables needed at each drag move update tick
       * @param {Event} e
       */

    }, {
      key: "_dragMoveUpdate",
      value: function _dragMoveUpdate(e) {
        var clientX = e.targetTouches[0].clientX;
        var currentScrollTop = this.isOpen ? this.el.scrollTop : M.getDocumentScrollTop();
        this.deltaX = Math.abs(this._xPos - clientX);
        this._xPos = clientX;
        this.velocityX = this.deltaX / (Date.now() - this._time);
        this._time = Date.now();
        if (this._initialScrollTop !== currentScrollTop) {
          this._verticallyScrolling = true;
        }
      }

      /**
       * Handles Dragging of Sidenav
       * @param {Event} e
       */

    }, {
      key: "_handleDragTargetDrag",
      value: function _handleDragTargetDrag(e) {
        // Check if draggable
        if (!this.options.draggable || this._isCurrentlyFixed() || this._verticallyScrolling) {
          return;
        }

        // If not being dragged, set initial drag start variables
        if (!this.isDragged) {
          this._startDrag(e);
        }

        // Run touchmove updates
        this._dragMoveUpdate(e);

        // Calculate raw deltaX
        var totalDeltaX = this._xPos - this._startingXpos;

        // dragDirection is the attempted user drag direction
        var dragDirection = totalDeltaX > 0 ? 'right' : 'left';

        // Don't allow totalDeltaX to exceed Sidenav width or be dragged in the opposite direction
        totalDeltaX = Math.min(this._width, Math.abs(totalDeltaX));
        if (this.options.edge === dragDirection) {
          totalDeltaX = 0;
        }

        /**
         * transformX is the drag displacement
         * transformPrefix is the initial transform placement
         * Invert values if Sidenav is right edge
         */
        var transformX = totalDeltaX;
        var transformPrefix = 'translateX(-100%)';
        if (this.options.edge === 'right') {
          transformPrefix = 'translateX(100%)';
          transformX = -transformX;
        }

        // Calculate open/close percentage of sidenav, with open = 1 and close = 0
        this.percentOpen = Math.min(1, totalDeltaX / this._width);

        // Set transform and opacity styles
        this.el.style.transform = transformPrefix + " translateX(" + transformX + "px)";
        this._overlay.style.opacity = this.percentOpen;
      }

      /**
       * Handle Drag Target Release
       */

    }, {
      key: "_handleDragTargetRelease",
      value: function _handleDragTargetRelease() {
        if (this.isDragged) {
          if (this.percentOpen > 0.2) {
            this.open();
          } else {
            this._animateOut();
          }

          this.isDragged = false;
          this._verticallyScrolling = false;
        }
      }

      /**
       * Handle Close Drag
       * @param {Event} e
       */

    }, {
      key: "_handleCloseDrag",
      value: function _handleCloseDrag(e) {
        if (this.isOpen) {
          // Check if draggable
          if (!this.options.draggable || this._isCurrentlyFixed() || this._verticallyScrolling) {
            return;
          }

          // If not being dragged, set initial drag start variables
          if (!this.isDragged) {
            this._startDrag(e);
          }

          // Run touchmove updates
          this._dragMoveUpdate(e);

          // Calculate raw deltaX
          var totalDeltaX = this._xPos - this._startingXpos;

          // dragDirection is the attempted user drag direction
          var dragDirection = totalDeltaX > 0 ? 'right' : 'left';

          // Don't allow totalDeltaX to exceed Sidenav width or be dragged in the opposite direction
          totalDeltaX = Math.min(this._width, Math.abs(totalDeltaX));
          if (this.options.edge !== dragDirection) {
            totalDeltaX = 0;
          }

          var transformX = -totalDeltaX;
          if (this.options.edge === 'right') {
            transformX = -transformX;
          }

          // Calculate open/close percentage of sidenav, with open = 1 and close = 0
          this.percentOpen = Math.min(1, 1 - totalDeltaX / this._width);

          // Set transform and opacity styles
          this.el.style.transform = "translateX(" + transformX + "px)";
          this._overlay.style.opacity = this.percentOpen;
        }
      }

      /**
       * Handle Close Release
       */

    }, {
      key: "_handleCloseRelease",
      value: function _handleCloseRelease() {
        if (this.isOpen && this.isDragged) {
          if (this.percentOpen > 0.8) {
            this._animateIn();
          } else {
            this.close();
          }

          this.isDragged = false;
          this._verticallyScrolling = false;
        }
      }

      /**
       * Handles closing of Sidenav when element with class .sidenav-close
       */

    }, {
      key: "_handleCloseTriggerClick",
      value: function _handleCloseTriggerClick(e) {
        var $closeTrigger = $(e.target).closest('.sidenav-close');
        if ($closeTrigger.length && !this._isCurrentlyFixed()) {
          this.close();
        }
      }

      /**
       * Handle Window Resize
       */

    }, {
      key: "_handleWindowResize",
      value: function _handleWindowResize() {
        // Only handle horizontal resizes
        if (this.lastWindowWidth !== window.innerWidth) {
          if (window.innerWidth > 992) {
            this.open();
          } else {
            this.close();
          }
        }

        this.lastWindowWidth = window.innerWidth;
        this.lastWindowHeight = window.innerHeight;
      }
    }, {
      key: "_setupClasses",
      value: function _setupClasses() {
        if (this.options.edge === 'right') {
          this.el.classList.add('right-aligned');
          this.dragTarget.classList.add('right-aligned');
        }
      }
    }, {
      key: "_removeClasses",
      value: function _removeClasses() {
        this.el.classList.remove('right-aligned');
        this.dragTarget.classList.remove('right-aligned');
      }
    }, {
      key: "_setupFixed",
      value: function _setupFixed() {
        if (this._isCurrentlyFixed()) {
          this.open();
        }
      }
    }, {
      key: "_isCurrentlyFixed",
      value: function _isCurrentlyFixed() {
        return this.isFixed && window.innerWidth > 992;
      }
    }, {
      key: "_createDragTarget",
      value: function _createDragTarget() {
        var dragTarget = document.createElement('div');
        dragTarget.classList.add('drag-target');
        document.body.appendChild(dragTarget);
        this.dragTarget = dragTarget;
      }
    }, {
      key: "_preventBodyScrolling",
      value: function _preventBodyScrolling() {
        var body = document.body;
        body.style.overflow = 'hidden';
      }
    }, {
      key: "_enableBodyScrolling",
      value: function _enableBodyScrolling() {
        var body = document.body;
        body.style.overflow = '';
      }
    }, {
      key: "open",
      value: function open() {
        if (this.isOpen === true) {
          return;
        }

        this.isOpen = true;

        // Run onOpenStart callback
        if (typeof this.options.onOpenStart === 'function') {
          this.options.onOpenStart.call(this, this.el);
        }

        // Handle fixed Sidenav
        if (this._isCurrentlyFixed()) {
          anim.remove(this.el);
          anim({
            targets: this.el,
            translateX: 0,
            duration: 0,
            easing: 'easeOutQuad'
          });
          this._enableBodyScrolling();
          this._overlay.style.display = 'none';

          // Handle non-fixed Sidenav
        } else {
          if (this.options.preventScrolling) {
            this._preventBodyScrolling();
          }

          if (!this.isDragged || this.percentOpen != 1) {
            this._animateIn();
          }
        }
      }
    }, {
      key: "close",
      value: function close() {
        if (this.isOpen === false) {
          return;
        }

        this.isOpen = false;

        // Run onCloseStart callback
        if (typeof this.options.onCloseStart === 'function') {
          this.options.onCloseStart.call(this, this.el);
        }

        // Handle fixed Sidenav
        if (this._isCurrentlyFixed()) {
          var transformX = this.options.edge === 'left' ? '-105%' : '105%';
          this.el.style.transform = "translateX(" + transformX + ")";

          // Handle non-fixed Sidenav
        } else {
          this._enableBodyScrolling();

          if (!this.isDragged || this.percentOpen != 0) {
            this._animateOut();
          } else {
            this._overlay.style.display = 'none';
          }
        }
      }
    }, {
      key: "_animateIn",
      value: function _animateIn() {
        this._animateSidenavIn();
        this._animateOverlayIn();
      }
    }, {
      key: "_animateSidenavIn",
      value: function _animateSidenavIn() {
        var _this32 = this;

        var slideOutPercent = this.options.edge === 'left' ? -1 : 1;
        if (this.isDragged) {
          slideOutPercent = this.options.edge === 'left' ? slideOutPercent + this.percentOpen : slideOutPercent - this.percentOpen;
        }

        anim.remove(this.el);
        anim({
          targets: this.el,
          translateX: [slideOutPercent * 100 + "%", 0],
          duration: this.options.inDuration,
          easing: 'easeOutQuad',
          complete: function () {
            // Run onOpenEnd callback
            if (typeof _this32.options.onOpenEnd === 'function') {
              _this32.options.onOpenEnd.call(_this32, _this32.el);
            }
          }
        });
      }
    }, {
      key: "_animateOverlayIn",
      value: function _animateOverlayIn() {
        var start = 0;
        if (this.isDragged) {
          start = this.percentOpen;
        } else {
          $(this._overlay).css({
            display: 'block'
          });
        }

        anim.remove(this._overlay);
        anim({
          targets: this._overlay,
          opacity: [start, 1],
          duration: this.options.inDuration,
          easing: 'easeOutQuad'
        });
      }
    }, {
      key: "_animateOut",
      value: function _animateOut() {
        this._animateSidenavOut();
        this._animateOverlayOut();
      }
    }, {
      key: "_animateSidenavOut",
      value: function _animateSidenavOut() {
        var _this33 = this;

        var endPercent = this.options.edge === 'left' ? -1 : 1;
        var slideOutPercent = 0;
        if (this.isDragged) {
          slideOutPercent = this.options.edge === 'left' ? endPercent + this.percentOpen : endPercent - this.percentOpen;
        }

        anim.remove(this.el);
        anim({
          targets: this.el,
          translateX: [slideOutPercent * 100 + "%", endPercent * 105 + "%"],
          duration: this.options.outDuration,
          easing: 'easeOutQuad',
          complete: function () {
            // Run onOpenEnd callback
            if (typeof _this33.options.onCloseEnd === 'function') {
              _this33.options.onCloseEnd.call(_this33, _this33.el);
            }
          }
        });
      }
    }, {
      key: "_animateOverlayOut",
      value: function _animateOverlayOut() {
        var _this34 = this;

        anim.remove(this._overlay);
        anim({
          targets: this._overlay,
          opacity: 0,
          duration: this.options.outDuration,
          easing: 'easeOutQuad',
          complete: function () {
            $(_this34._overlay).css('display', 'none');
          }
        });
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Sidenav.__proto__ || Object.getPrototypeOf(Sidenav), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Sidenav;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Sidenav;
  }(Component);

  /**
   * @static
   * @memberof Sidenav
   * @type {Array.<Sidenav>}
   */


  Sidenav._sidenavs = [];

  window.M.Sidenav = Sidenav;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Sidenav, 'sidenav', 'M_Sidenav');
  }
})(cash, M.anime);
;(function ($, anim) {
  'use strict';

  var _defaults = {
    throttle: 100,
    scrollOffset: 200, // offset - 200 allows elements near bottom of page to scroll
    activeClass: 'active',
    getActiveElement: function (id) {
      return 'a[href="#' + id + '"]';
    }
  };

  /**
   * @class
   *
   */

  var ScrollSpy = function (_Component9) {
    _inherits(ScrollSpy, _Component9);

    /**
     * Construct ScrollSpy instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function ScrollSpy(el, options) {
      _classCallCheck(this, ScrollSpy);

      var _this35 = _possibleConstructorReturn(this, (ScrollSpy.__proto__ || Object.getPrototypeOf(ScrollSpy)).call(this, ScrollSpy, el, options));

      _this35.el.M_ScrollSpy = _this35;

      /**
       * Options for the modal
       * @member Modal#options
       * @prop {Number} [throttle=100] - Throttle of scroll handler
       * @prop {Number} [scrollOffset=200] - Offset for centering element when scrolled to
       * @prop {String} [activeClass='active'] - Class applied to active elements
       * @prop {Function} [getActiveElement] - Used to find active element
       */
      _this35.options = $.extend({}, ScrollSpy.defaults, options);

      // setup
      ScrollSpy._elements.push(_this35);
      ScrollSpy._count++;
      ScrollSpy._increment++;
      _this35.tickId = -1;
      _this35.id = ScrollSpy._increment;
      _this35._setupEventHandlers();
      _this35._handleWindowScroll();
      return _this35;
    }

    _createClass(ScrollSpy, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        ScrollSpy._elements.splice(ScrollSpy._elements.indexOf(this), 1);
        ScrollSpy._elementsInView.splice(ScrollSpy._elementsInView.indexOf(this), 1);
        ScrollSpy._visibleElements.splice(ScrollSpy._visibleElements.indexOf(this.$el), 1);
        ScrollSpy._count--;
        this._removeEventHandlers();
        $(this.options.getActiveElement(this.$el.attr('id'))).removeClass(this.options.activeClass);
        this.el.M_ScrollSpy = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        var throttledResize = M.throttle(this._handleWindowScroll, 200);
        this._handleThrottledResizeBound = throttledResize.bind(this);
        this._handleWindowScrollBound = this._handleWindowScroll.bind(this);
        if (ScrollSpy._count === 1) {
          window.addEventListener('scroll', this._handleWindowScrollBound);
          window.addEventListener('resize', this._handleThrottledResizeBound);
          document.body.addEventListener('click', this._handleTriggerClick);
        }
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        if (ScrollSpy._count === 0) {
          window.removeEventListener('scroll', this._handleWindowScrollBound);
          window.removeEventListener('resize', this._handleThrottledResizeBound);
          document.body.removeEventListener('click', this._handleTriggerClick);
        }
      }

      /**
       * Handle Trigger Click
       * @param {Event} e
       */

    }, {
      key: "_handleTriggerClick",
      value: function _handleTriggerClick(e) {
        var $trigger = $(e.target);
        for (var i = ScrollSpy._elements.length - 1; i >= 0; i--) {
          var scrollspy = ScrollSpy._elements[i];
          if ($trigger.is('a[href="#' + scrollspy.$el.attr('id') + '"]')) {
            e.preventDefault();
            var offset = scrollspy.$el.offset().top + 1;

            anim({
              targets: [document.documentElement, document.body],
              scrollTop: offset - scrollspy.options.scrollOffset,
              duration: 400,
              easing: 'easeOutCubic'
            });
            break;
          }
        }
      }

      /**
       * Handle Window Scroll
       */

    }, {
      key: "_handleWindowScroll",
      value: function _handleWindowScroll() {
        // unique tick id
        ScrollSpy._ticks++;

        // viewport rectangle
        var top = M.getDocumentScrollTop(),
            left = M.getDocumentScrollLeft(),
            right = left + window.innerWidth,
            bottom = top + window.innerHeight;

        // determine which elements are in view
        var intersections = ScrollSpy._findElements(top, right, bottom, left);
        for (var i = 0; i < intersections.length; i++) {
          var scrollspy = intersections[i];
          var lastTick = scrollspy.tickId;
          if (lastTick < 0) {
            // entered into view
            scrollspy._enter();
          }

          // update tick id
          scrollspy.tickId = ScrollSpy._ticks;
        }

        for (var _i = 0; _i < ScrollSpy._elementsInView.length; _i++) {
          var _scrollspy = ScrollSpy._elementsInView[_i];
          var _lastTick = _scrollspy.tickId;
          if (_lastTick >= 0 && _lastTick !== ScrollSpy._ticks) {
            // exited from view
            _scrollspy._exit();
            _scrollspy.tickId = -1;
          }
        }

        // remember elements in view for next tick
        ScrollSpy._elementsInView = intersections;
      }

      /**
       * Find elements that are within the boundary
       * @param {number} top
       * @param {number} right
       * @param {number} bottom
       * @param {number} left
       * @return {Array.<ScrollSpy>}   A collection of elements
       */

    }, {
      key: "_enter",
      value: function _enter() {
        ScrollSpy._visibleElements = ScrollSpy._visibleElements.filter(function (value) {
          return value.height() != 0;
        });

        if (ScrollSpy._visibleElements[0]) {
          $(this.options.getActiveElement(ScrollSpy._visibleElements[0].attr('id'))).removeClass(this.options.activeClass);
          if (ScrollSpy._visibleElements[0][0].M_ScrollSpy && this.id < ScrollSpy._visibleElements[0][0].M_ScrollSpy.id) {
            ScrollSpy._visibleElements.unshift(this.$el);
          } else {
            ScrollSpy._visibleElements.push(this.$el);
          }
        } else {
          ScrollSpy._visibleElements.push(this.$el);
        }

        $(this.options.getActiveElement(ScrollSpy._visibleElements[0].attr('id'))).addClass(this.options.activeClass);
      }
    }, {
      key: "_exit",
      value: function _exit() {
        var _this36 = this;

        ScrollSpy._visibleElements = ScrollSpy._visibleElements.filter(function (value) {
          return value.height() != 0;
        });

        if (ScrollSpy._visibleElements[0]) {
          $(this.options.getActiveElement(ScrollSpy._visibleElements[0].attr('id'))).removeClass(this.options.activeClass);

          ScrollSpy._visibleElements = ScrollSpy._visibleElements.filter(function (el) {
            return el.attr('id') != _this36.$el.attr('id');
          });
          if (ScrollSpy._visibleElements[0]) {
            // Check if empty
            $(this.options.getActiveElement(ScrollSpy._visibleElements[0].attr('id'))).addClass(this.options.activeClass);
          }
        }
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(ScrollSpy.__proto__ || Object.getPrototypeOf(ScrollSpy), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_ScrollSpy;
      }
    }, {
      key: "_findElements",
      value: function _findElements(top, right, bottom, left) {
        var hits = [];
        for (var i = 0; i < ScrollSpy._elements.length; i++) {
          var scrollspy = ScrollSpy._elements[i];
          var currTop = top + scrollspy.options.scrollOffset || 200;

          if (scrollspy.$el.height() > 0) {
            var elTop = scrollspy.$el.offset().top,
                elLeft = scrollspy.$el.offset().left,
                elRight = elLeft + scrollspy.$el.width(),
                elBottom = elTop + scrollspy.$el.height();

            var isIntersect = !(elLeft > right || elRight < left || elTop > bottom || elBottom < currTop);

            if (isIntersect) {
              hits.push(scrollspy);
            }
          }
        }
        return hits;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return ScrollSpy;
  }(Component);

  /**
   * @static
   * @memberof ScrollSpy
   * @type {Array.<ScrollSpy>}
   */


  ScrollSpy._elements = [];

  /**
   * @static
   * @memberof ScrollSpy
   * @type {Array.<ScrollSpy>}
   */
  ScrollSpy._elementsInView = [];

  /**
   * @static
   * @memberof ScrollSpy
   * @type {Array.<cash>}
   */
  ScrollSpy._visibleElements = [];

  /**
   * @static
   * @memberof ScrollSpy
   */
  ScrollSpy._count = 0;

  /**
   * @static
   * @memberof ScrollSpy
   */
  ScrollSpy._increment = 0;

  /**
   * @static
   * @memberof ScrollSpy
   */
  ScrollSpy._ticks = 0;

  M.ScrollSpy = ScrollSpy;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(ScrollSpy, 'scrollSpy', 'M_ScrollSpy');
  }
})(cash, M.anime);
;(function ($) {
  'use strict';

  var _defaults = {
    data: {}, // Autocomplete data set
    limit: Infinity, // Limit of results the autocomplete shows
    onAutocomplete: null, // Callback for when autocompleted
    minLength: 1, // Min characters before autocomplete starts
    sortFunction: function (a, b, inputString) {
      // Sort function for sorting autocomplete results
      return a.indexOf(inputString) - b.indexOf(inputString);
    }
  };

  /**
   * @class
   *
   */

  var Autocomplete = function (_Component10) {
    _inherits(Autocomplete, _Component10);

    /**
     * Construct Autocomplete instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Autocomplete(el, options) {
      _classCallCheck(this, Autocomplete);

      var _this37 = _possibleConstructorReturn(this, (Autocomplete.__proto__ || Object.getPrototypeOf(Autocomplete)).call(this, Autocomplete, el, options));

      _this37.el.M_Autocomplete = _this37;

      /**
       * Options for the autocomplete
       * @member Autocomplete#options
       * @prop {Number} duration
       * @prop {Number} dist
       * @prop {number} shift
       * @prop {number} padding
       * @prop {Boolean} fullWidth
       * @prop {Boolean} indicators
       * @prop {Boolean} noWrap
       * @prop {Function} onCycleTo
       */
      _this37.options = $.extend({}, Autocomplete.defaults, options);

      // Setup
      _this37.isOpen = false;
      _this37.count = 0;
      _this37.activeIndex = -1;
      _this37.oldVal;
      _this37.$inputField = _this37.$el.closest('.input-field');
      _this37.$active = $();
      _this37._mousedown = false;
      _this37._setupDropdown();

      _this37._setupEventHandlers();
      return _this37;
    }

    _createClass(Autocomplete, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this._removeDropdown();
        this.el.M_Autocomplete = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleInputBlurBound = this._handleInputBlur.bind(this);
        this._handleInputKeyupAndFocusBound = this._handleInputKeyupAndFocus.bind(this);
        this._handleInputKeydownBound = this._handleInputKeydown.bind(this);
        this._handleInputClickBound = this._handleInputClick.bind(this);
        this._handleContainerMousedownAndTouchstartBound = this._handleContainerMousedownAndTouchstart.bind(this);
        this._handleContainerMouseupAndTouchendBound = this._handleContainerMouseupAndTouchend.bind(this);

        this.el.addEventListener('blur', this._handleInputBlurBound);
        this.el.addEventListener('keyup', this._handleInputKeyupAndFocusBound);
        this.el.addEventListener('focus', this._handleInputKeyupAndFocusBound);
        this.el.addEventListener('keydown', this._handleInputKeydownBound);
        this.el.addEventListener('click', this._handleInputClickBound);
        this.container.addEventListener('mousedown', this._handleContainerMousedownAndTouchstartBound);
        this.container.addEventListener('mouseup', this._handleContainerMouseupAndTouchendBound);

        if (typeof window.ontouchstart !== 'undefined') {
          this.container.addEventListener('touchstart', this._handleContainerMousedownAndTouchstartBound);
          this.container.addEventListener('touchend', this._handleContainerMouseupAndTouchendBound);
        }
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('blur', this._handleInputBlurBound);
        this.el.removeEventListener('keyup', this._handleInputKeyupAndFocusBound);
        this.el.removeEventListener('focus', this._handleInputKeyupAndFocusBound);
        this.el.removeEventListener('keydown', this._handleInputKeydownBound);
        this.el.removeEventListener('click', this._handleInputClickBound);
        this.container.removeEventListener('mousedown', this._handleContainerMousedownAndTouchstartBound);
        this.container.removeEventListener('mouseup', this._handleContainerMouseupAndTouchendBound);

        if (typeof window.ontouchstart !== 'undefined') {
          this.container.removeEventListener('touchstart', this._handleContainerMousedownAndTouchstartBound);
          this.container.removeEventListener('touchend', this._handleContainerMouseupAndTouchendBound);
        }
      }

      /**
       * Setup dropdown
       */

    }, {
      key: "_setupDropdown",
      value: function _setupDropdown() {
        var _this38 = this;

        this.container = document.createElement('ul');
        this.container.id = "autocomplete-options-" + M.guid();
        $(this.container).addClass('autocomplete-content dropdown-content');
        this.$inputField.append(this.container);
        this.el.setAttribute('data-target', this.container.id);

        this.dropdown = M.Dropdown.init(this.el, {
          autoFocus: false,
          closeOnClick: false,
          coverTrigger: false,
          onItemClick: function (itemEl) {
            _this38.selectOption($(itemEl));
          }
        });

        // Sketchy removal of dropdown click handler
        this.el.removeEventListener('click', this.dropdown._handleClickBound);
      }

      /**
       * Remove dropdown
       */

    }, {
      key: "_removeDropdown",
      value: function _removeDropdown() {
        this.container.parentNode.removeChild(this.container);
      }

      /**
       * Handle Input Blur
       */

    }, {
      key: "_handleInputBlur",
      value: function _handleInputBlur() {
        if (!this._mousedown) {
          this.close();
          this._resetAutocomplete();
        }
      }

      /**
       * Handle Input Keyup and Focus
       * @param {Event} e
       */

    }, {
      key: "_handleInputKeyupAndFocus",
      value: function _handleInputKeyupAndFocus(e) {
        if (e.type === 'keyup') {
          Autocomplete._keydown = false;
        }

        this.count = 0;
        var val = this.el.value.toLowerCase();

        // Don't capture enter or arrow key usage.
        if (e.keyCode === 13 || e.keyCode === 38 || e.keyCode === 40) {
          return;
        }

        // Check if the input isn't empty
        // Check if focus triggered by tab
        if (this.oldVal !== val && (M.tabPressed || e.type !== 'focus')) {
          this.open();
        }

        // Update oldVal
        this.oldVal = val;
      }

      /**
       * Handle Input Keydown
       * @param {Event} e
       */

    }, {
      key: "_handleInputKeydown",
      value: function _handleInputKeydown(e) {
        Autocomplete._keydown = true;

        // Arrow keys and enter key usage
        var keyCode = e.keyCode,
            liElement = void 0,
            numItems = $(this.container).children('li').length;

        // select element on Enter
        if (keyCode === M.keys.ENTER && this.activeIndex >= 0) {
          liElement = $(this.container).children('li').eq(this.activeIndex);
          if (liElement.length) {
            this.selectOption(liElement);
            e.preventDefault();
          }
          return;
        }

        // Capture up and down key
        if (keyCode === M.keys.ARROW_UP || keyCode === M.keys.ARROW_DOWN) {
          e.preventDefault();

          if (keyCode === M.keys.ARROW_UP && this.activeIndex > 0) {
            this.activeIndex--;
          }

          if (keyCode === M.keys.ARROW_DOWN && this.activeIndex < numItems - 1) {
            this.activeIndex++;
          }

          this.$active.removeClass('active');
          if (this.activeIndex >= 0) {
            this.$active = $(this.container).children('li').eq(this.activeIndex);
            this.$active.addClass('active');
          }
        }
      }

      /**
       * Handle Input Click
       * @param {Event} e
       */

    }, {
      key: "_handleInputClick",
      value: function _handleInputClick(e) {
        this.open();
      }

      /**
       * Handle Container Mousedown and Touchstart
       * @param {Event} e
       */

    }, {
      key: "_handleContainerMousedownAndTouchstart",
      value: function _handleContainerMousedownAndTouchstart(e) {
        this._mousedown = true;
      }

      /**
       * Handle Container Mouseup and Touchend
       * @param {Event} e
       */

    }, {
      key: "_handleContainerMouseupAndTouchend",
      value: function _handleContainerMouseupAndTouchend(e) {
        this._mousedown = false;
      }

      /**
       * Highlight partial match
       */

    }, {
      key: "_highlight",
      value: function _highlight(string, $el) {
        var img = $el.find('img');
        var matchStart = $el.text().toLowerCase().indexOf('' + string.toLowerCase() + ''),
            matchEnd = matchStart + string.length - 1,
            beforeMatch = $el.text().slice(0, matchStart),
            matchText = $el.text().slice(matchStart, matchEnd + 1),
            afterMatch = $el.text().slice(matchEnd + 1);
        $el.html("<span>" + beforeMatch + "<span class='highlight'>" + matchText + "</span>" + afterMatch + "</span>");
        if (img.length) {
          $el.prepend(img);
        }
      }

      /**
       * Reset current element position
       */

    }, {
      key: "_resetCurrentElement",
      value: function _resetCurrentElement() {
        this.activeIndex = -1;
        this.$active.removeClass('active');
      }

      /**
       * Reset autocomplete elements
       */

    }, {
      key: "_resetAutocomplete",
      value: function _resetAutocomplete() {
        $(this.container).empty();
        this._resetCurrentElement();
        this.oldVal = null;
        this.isOpen = false;
        this._mousedown = false;
      }

      /**
       * Select autocomplete option
       * @param {Element} el  Autocomplete option list item element
       */

    }, {
      key: "selectOption",
      value: function selectOption(el) {
        var text = el.text().trim();
        this.el.value = text;
        this.$el.trigger('change');
        this._resetAutocomplete();
        this.close();

        // Handle onAutocomplete callback.
        if (typeof this.options.onAutocomplete === 'function') {
          this.options.onAutocomplete.call(this, text);
        }
      }

      /**
       * Render dropdown content
       * @param {Object} data  data set
       * @param {String} val  current input value
       */

    }, {
      key: "_renderDropdown",
      value: function _renderDropdown(data, val) {
        var _this39 = this;

        this._resetAutocomplete();

        var matchingData = [];

        // Gather all matching data
        for (var key in data) {
          if (data.hasOwnProperty(key) && key.toLowerCase().indexOf(val) !== -1) {
            // Break if past limit
            if (this.count >= this.options.limit) {
              break;
            }

            var entry = {
              data: data[key],
              key: key
            };
            matchingData.push(entry);

            this.count++;
          }
        }

        // Sort
        if (this.options.sortFunction) {
          var sortFunctionBound = function (a, b) {
            return _this39.options.sortFunction(a.key.toLowerCase(), b.key.toLowerCase(), val.toLowerCase());
          };
          matchingData.sort(sortFunctionBound);
        }

        // Render
        for (var i = 0; i < matchingData.length; i++) {
          var _entry = matchingData[i];
          var $autocompleteOption = $('<li></li>');
          if (!!_entry.data) {
            $autocompleteOption.append("<img src=\"" + _entry.data + "\" class=\"right circle\"><span>" + _entry.key + "</span>");
          } else {
            $autocompleteOption.append('<span>' + _entry.key + '</span>');
          }

          $(this.container).append($autocompleteOption);
          this._highlight(val, $autocompleteOption);
        }
      }

      /**
       * Open Autocomplete Dropdown
       */

    }, {
      key: "open",
      value: function open() {
        var val = this.el.value.toLowerCase();

        this._resetAutocomplete();

        if (val.length >= this.options.minLength) {
          this.isOpen = true;
          this._renderDropdown(this.options.data, val);
        }

        // Open dropdown
        if (!this.dropdown.isOpen) {
          this.dropdown.open();
        } else {
          // Recalculate dropdown when its already open
          this.dropdown.recalculateDimensions();
        }
      }

      /**
       * Close Autocomplete Dropdown
       */

    }, {
      key: "close",
      value: function close() {
        this.dropdown.close();
      }

      /**
       * Update Data
       * @param {Object} data
       */

    }, {
      key: "updateData",
      value: function updateData(data) {
        var val = this.el.value.toLowerCase();
        this.options.data = data;

        if (this.isOpen) {
          this._renderDropdown(data, val);
        }
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Autocomplete.__proto__ || Object.getPrototypeOf(Autocomplete), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Autocomplete;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Autocomplete;
  }(Component);

  /**
   * @static
   * @memberof Autocomplete
   */


  Autocomplete._keydown = false;

  M.Autocomplete = Autocomplete;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Autocomplete, 'autocomplete', 'M_Autocomplete');
  }
})(cash);
;(function ($) {
  // Function to update labels of text fields
  M.updateTextFields = function () {
    var input_selector = 'input[type=text], input[type=password], input[type=email], input[type=url], input[type=tel], input[type=number], input[type=search], input[type=date], input[type=time], textarea';
    $(input_selector).each(function (element, index) {
      var $this = $(this);
      if (element.value.length > 0 || $(element).is(':focus') || element.autofocus || $this.attr('placeholder') !== null) {
        $this.siblings('label').addClass('active');
      } else if (element.validity) {
        $this.siblings('label').toggleClass('active', element.validity.badInput === true);
      } else {
        $this.siblings('label').removeClass('active');
      }
    });
  };

  M.validate_field = function (object) {
    var hasLength = object.attr('data-length') !== null;
    var lenAttr = parseInt(object.attr('data-length'));
    var len = object[0].value.length;

    if (len === 0 && object[0].validity.badInput === false && !object.is(':required')) {
      if (object.hasClass('validate')) {
        object.removeClass('valid');
        object.removeClass('invalid');
      }
    } else {
      if (object.hasClass('validate')) {
        // Check for character counter attributes
        if (object.is(':valid') && hasLength && len <= lenAttr || object.is(':valid') && !hasLength) {
          object.removeClass('invalid');
          object.addClass('valid');
        } else {
          object.removeClass('valid');
          object.addClass('invalid');
        }
      }
    }
  };

  M.textareaAutoResize = function ($textarea) {
    // Wrap if native element
    if ($textarea instanceof Element) {
      $textarea = $($textarea);
    }

    if (!$textarea.length) {
      console.error('No textarea element found');
      return;
    }

    // Textarea Auto Resize
    var hiddenDiv = $('.hiddendiv').first();
    if (!hiddenDiv.length) {
      hiddenDiv = $('<div class="hiddendiv common"></div>');
      $('body').append(hiddenDiv);
    }

    // Set font properties of hiddenDiv
    var fontFamily = $textarea.css('font-family');
    var fontSize = $textarea.css('font-size');
    var lineHeight = $textarea.css('line-height');

    // Firefox can't handle padding shorthand.
    var paddingTop = $textarea.css('padding-top');
    var paddingRight = $textarea.css('padding-right');
    var paddingBottom = $textarea.css('padding-bottom');
    var paddingLeft = $textarea.css('padding-left');

    if (fontSize) {
      hiddenDiv.css('font-size', fontSize);
    }
    if (fontFamily) {
      hiddenDiv.css('font-family', fontFamily);
    }
    if (lineHeight) {
      hiddenDiv.css('line-height', lineHeight);
    }
    if (paddingTop) {
      hiddenDiv.css('padding-top', paddingTop);
    }
    if (paddingRight) {
      hiddenDiv.css('padding-right', paddingRight);
    }
    if (paddingBottom) {
      hiddenDiv.css('padding-bottom', paddingBottom);
    }
    if (paddingLeft) {
      hiddenDiv.css('padding-left', paddingLeft);
    }

    // Set original-height, if none
    if (!$textarea.data('original-height')) {
      $textarea.data('original-height', $textarea.height());
    }

    if ($textarea.attr('wrap') === 'off') {
      hiddenDiv.css('overflow-wrap', 'normal').css('white-space', 'pre');
    }

    hiddenDiv.text($textarea[0].value + '\n');
    var content = hiddenDiv.html().replace(/\n/g, '<br>');
    hiddenDiv.html(content);

    // When textarea is hidden, width goes crazy.
    // Approximate with half of window size

    if ($textarea[0].offsetWidth > 0 && $textarea[0].offsetHeight > 0) {
      hiddenDiv.css('width', $textarea.width() + 'px');
    } else {
      hiddenDiv.css('width', window.innerWidth / 2 + 'px');
    }

    /**
     * Resize if the new height is greater than the
     * original height of the textarea
     */
    if ($textarea.data('original-height') <= hiddenDiv.innerHeight()) {
      $textarea.css('height', hiddenDiv.innerHeight() + 'px');
    } else if ($textarea[0].value.length < $textarea.data('previous-length')) {
      /**
       * In case the new height is less than original height, it
       * means the textarea has less text than before
       * So we set the height to the original one
       */
      $textarea.css('height', $textarea.data('original-height') + 'px');
    }
    $textarea.data('previous-length', $textarea[0].value.length);
  };

  $(document).ready(function () {
    // Text based inputs
    var input_selector = 'input[type=text], input[type=password], input[type=email], input[type=url], input[type=tel], input[type=number], input[type=search], input[type=date], input[type=time], textarea';

    // Add active if form auto complete
    $(document).on('change', input_selector, function () {
      if (this.value.length !== 0 || $(this).attr('placeholder') !== null) {
        $(this).siblings('label').addClass('active');
      }
      M.validate_field($(this));
    });

    // Add active if input element has been pre-populated on document ready
    $(document).ready(function () {
      M.updateTextFields();
    });

    // HTML DOM FORM RESET handling
    $(document).on('reset', function (e) {
      var formReset = $(e.target);
      if (formReset.is('form')) {
        formReset.find(input_selector).removeClass('valid').removeClass('invalid');
        formReset.find(input_selector).each(function (e) {
          if (this.value.length) {
            $(this).siblings('label').removeClass('active');
          }
        });

        // Reset select (after native reset)
        setTimeout(function () {
          formReset.find('select').each(function () {
            // check if initialized
            if (this.M_FormSelect) {
              $(this).trigger('change');
            }
          });
        }, 0);
      }
    });

    /**
     * Add active when element has focus
     * @param {Event} e
     */
    document.addEventListener('focus', function (e) {
      if ($(e.target).is(input_selector)) {
        $(e.target).siblings('label, .prefix').addClass('active');
      }
    }, true);

    /**
     * Remove active when element is blurred
     * @param {Event} e
     */
    document.addEventListener('blur', function (e) {
      var $inputElement = $(e.target);
      if ($inputElement.is(input_selector)) {
        var selector = '.prefix';

        if ($inputElement[0].value.length === 0 && $inputElement[0].validity.badInput !== true && $inputElement.attr('placeholder') === null) {
          selector += ', label';
        }
        $inputElement.siblings(selector).removeClass('active');
        M.validate_field($inputElement);
      }
    }, true);

    // Radio and Checkbox focus class
    var radio_checkbox = 'input[type=radio], input[type=checkbox]';
    $(document).on('keyup', radio_checkbox, function (e) {
      // TAB, check if tabbing to radio or checkbox.
      if (e.which === M.keys.TAB) {
        $(this).addClass('tabbed');
        var $this = $(this);
        $this.one('blur', function (e) {
          $(this).removeClass('tabbed');
        });
        return;
      }
    });

    var text_area_selector = '.materialize-textarea';
    $(text_area_selector).each(function () {
      var $textarea = $(this);
      /**
       * Resize textarea on document load after storing
       * the original height and the original length
       */
      $textarea.data('original-height', $textarea.height());
      $textarea.data('previous-length', this.value.length);
      M.textareaAutoResize($textarea);
    });

    $(document).on('keyup', text_area_selector, function () {
      M.textareaAutoResize($(this));
    });
    $(document).on('keydown', text_area_selector, function () {
      M.textareaAutoResize($(this));
    });

    // File Input Path
    $(document).on('change', '.file-field input[type="file"]', function () {
      var file_field = $(this).closest('.file-field');
      var path_input = file_field.find('input.file-path');
      var files = $(this)[0].files;
      var file_names = [];
      for (var i = 0; i < files.length; i++) {
        file_names.push(files[i].name);
      }
      path_input[0].value = file_names.join(', ');
      path_input.trigger('change');
    });
  }); // End of $(document).ready
})(cash);
;(function ($, anim) {
  'use strict';

  var _defaults = {
    indicators: true,
    height: 400,
    duration: 500,
    interval: 6000
  };

  /**
   * @class
   *
   */

  var Slider = function (_Component11) {
    _inherits(Slider, _Component11);

    /**
     * Construct Slider instance and set up overlay
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Slider(el, options) {
      _classCallCheck(this, Slider);

      var _this40 = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, Slider, el, options));

      _this40.el.M_Slider = _this40;

      /**
       * Options for the modal
       * @member Slider#options
       * @prop {Boolean} [indicators=true] - Show indicators
       * @prop {Number} [height=400] - height of slider
       * @prop {Number} [duration=500] - Length in ms of slide transition
       * @prop {Number} [interval=6000] - Length in ms of slide interval
       */
      _this40.options = $.extend({}, Slider.defaults, options);

      // setup
      _this40.$slider = _this40.$el.find('.slides');
      _this40.$slides = _this40.$slider.children('li');
      _this40.activeIndex = _this40.$slides.filter(function (item) {
        return $(item).hasClass('active');
      }).first().index();
      if (_this40.activeIndex != -1) {
        _this40.$active = _this40.$slides.eq(_this40.activeIndex);
      }

      _this40._setSliderHeight();

      // Set initial positions of captions
      _this40.$slides.find('.caption').each(function (el) {
        _this40._animateCaptionIn(el, 0);
      });

      // Move img src into background-image
      _this40.$slides.find('img').each(function (el) {
        var placeholderBase64 = 'data:image/gif;base64,R0lGODlhAQABAIABAP///wAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
        if ($(el).attr('src') !== placeholderBase64) {
          $(el).css('background-image', 'url("' + $(el).attr('src') + '")');
          $(el).attr('src', placeholderBase64);
        }
      });

      _this40._setupIndicators();

      // Show active slide
      if (_this40.$active) {
        _this40.$active.css('display', 'block');
      } else {
        _this40.$slides.first().addClass('active');
        anim({
          targets: _this40.$slides.first()[0],
          opacity: 1,
          duration: _this40.options.duration,
          easing: 'easeOutQuad'
        });

        _this40.activeIndex = 0;
        _this40.$active = _this40.$slides.eq(_this40.activeIndex);

        // Update indicators
        if (_this40.options.indicators) {
          _this40.$indicators.eq(_this40.activeIndex).addClass('active');
        }
      }

      // Adjust height to current slide
      _this40.$active.find('img').each(function (el) {
        anim({
          targets: _this40.$active.find('.caption')[0],
          opacity: 1,
          translateX: 0,
          translateY: 0,
          duration: _this40.options.duration,
          easing: 'easeOutQuad'
        });
      });

      _this40._setupEventHandlers();

      // auto scroll
      _this40.start();
      return _this40;
    }

    _createClass(Slider, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this.pause();
        this._removeIndicators();
        this._removeEventHandlers();
        this.el.M_Slider = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        var _this41 = this;

        this._handleIntervalBound = this._handleInterval.bind(this);
        this._handleIndicatorClickBound = this._handleIndicatorClick.bind(this);

        if (this.options.indicators) {
          this.$indicators.each(function (el) {
            el.addEventListener('click', _this41._handleIndicatorClickBound);
          });
        }
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        var _this42 = this;

        if (this.options.indicators) {
          this.$indicators.each(function (el) {
            el.removeEventListener('click', _this42._handleIndicatorClickBound);
          });
        }
      }

      /**
       * Handle indicator click
       * @param {Event} e
       */

    }, {
      key: "_handleIndicatorClick",
      value: function _handleIndicatorClick(e) {
        var currIndex = $(e.target).index();
        this.set(currIndex);
      }

      /**
       * Handle Interval
       */

    }, {
      key: "_handleInterval",
      value: function _handleInterval() {
        var newActiveIndex = this.$slider.find('.active').index();
        if (this.$slides.length === newActiveIndex + 1) newActiveIndex = 0;
        // loop to start
        else newActiveIndex += 1;

        this.set(newActiveIndex);
      }

      /**
       * Animate in caption
       * @param {Element} caption
       * @param {Number} duration
       */

    }, {
      key: "_animateCaptionIn",
      value: function _animateCaptionIn(caption, duration) {
        var animOptions = {
          targets: caption,
          opacity: 0,
          duration: duration,
          easing: 'easeOutQuad'
        };

        if ($(caption).hasClass('center-align')) {
          animOptions.translateY = -100;
        } else if ($(caption).hasClass('right-align')) {
          animOptions.translateX = 100;
        } else if ($(caption).hasClass('left-align')) {
          animOptions.translateX = -100;
        }

        anim(animOptions);
      }

      /**
       * Set height of slider
       */

    }, {
      key: "_setSliderHeight",
      value: function _setSliderHeight() {
        // If fullscreen, do nothing
        if (!this.$el.hasClass('fullscreen')) {
          if (this.options.indicators) {
            // Add height if indicators are present
            this.$el.css('height', this.options.height + 40 + 'px');
          } else {
            this.$el.css('height', this.options.height + 'px');
          }
          this.$slider.css('height', this.options.height + 'px');
        }
      }

      /**
       * Setup indicators
       */

    }, {
      key: "_setupIndicators",
      value: function _setupIndicators() {
        var _this43 = this;

        if (this.options.indicators) {
          this.$indicators = $('<ul class="indicators"></ul>');
          this.$slides.each(function (el, index) {
            var $indicator = $('<li class="indicator-item"></li>');
            _this43.$indicators.append($indicator[0]);
          });
          this.$el.append(this.$indicators[0]);
          this.$indicators = this.$indicators.children('li.indicator-item');
        }
      }

      /**
       * Remove indicators
       */

    }, {
      key: "_removeIndicators",
      value: function _removeIndicators() {
        this.$el.find('ul.indicators').remove();
      }

      /**
       * Cycle to nth item
       * @param {Number} index
       */

    }, {
      key: "set",
      value: function set(index) {
        var _this44 = this;

        // Wrap around indices.
        if (index >= this.$slides.length) index = 0;else if (index < 0) index = this.$slides.length - 1;

        // Only do if index changes
        if (this.activeIndex != index) {
          this.$active = this.$slides.eq(this.activeIndex);
          var $caption = this.$active.find('.caption');
          this.$active.removeClass('active');

          anim({
            targets: this.$active[0],
            opacity: 0,
            duration: this.options.duration,
            easing: 'easeOutQuad',
            complete: function () {
              _this44.$slides.not('.active').each(function (el) {
                anim({
                  targets: el,
                  opacity: 0,
                  translateX: 0,
                  translateY: 0,
                  duration: 0,
                  easing: 'easeOutQuad'
                });
              });
            }
          });

          this._animateCaptionIn($caption[0], this.options.duration);

          // Update indicators
          if (this.options.indicators) {
            this.$indicators.eq(this.activeIndex).removeClass('active');
            this.$indicators.eq(index).addClass('active');
          }

          anim({
            targets: this.$slides.eq(index)[0],
            opacity: 1,
            duration: this.options.duration,
            easing: 'easeOutQuad'
          });

          anim({
            targets: this.$slides.eq(index).find('.caption')[0],
            opacity: 1,
            translateX: 0,
            translateY: 0,
            duration: this.options.duration,
            delay: this.options.duration,
            easing: 'easeOutQuad'
          });

          this.$slides.eq(index).addClass('active');
          this.activeIndex = index;

          // Reset interval
          this.start();
        }
      }

      /**
       * Pause slider interval
       */

    }, {
      key: "pause",
      value: function pause() {
        clearInterval(this.interval);
      }

      /**
       * Start slider interval
       */

    }, {
      key: "start",
      value: function start() {
        clearInterval(this.interval);
        this.interval = setInterval(this._handleIntervalBound, this.options.duration + this.options.interval);
      }

      /**
       * Move to next slide
       */

    }, {
      key: "next",
      value: function next() {
        var newIndex = this.activeIndex + 1;

        // Wrap around indices.
        if (newIndex >= this.$slides.length) newIndex = 0;else if (newIndex < 0) newIndex = this.$slides.length - 1;

        this.set(newIndex);
      }

      /**
       * Move to previous slide
       */

    }, {
      key: "prev",
      value: function prev() {
        var newIndex = this.activeIndex - 1;

        // Wrap around indices.
        if (newIndex >= this.$slides.length) newIndex = 0;else if (newIndex < 0) newIndex = this.$slides.length - 1;

        this.set(newIndex);
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Slider.__proto__ || Object.getPrototypeOf(Slider), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Slider;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Slider;
  }(Component);

  M.Slider = Slider;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Slider, 'slider', 'M_Slider');
  }
})(cash, M.anime);
;(function ($, anim) {
  $(document).on('click', '.card', function (e) {
    if ($(this).children('.card-reveal').length) {
      var $card = $(e.target).closest('.card');
      if ($card.data('initialOverflow') === undefined) {
        $card.data('initialOverflow', $card.css('overflow') === undefined ? '' : $card.css('overflow'));
      }
      var $cardReveal = $(this).find('.card-reveal');
      if ($(e.target).is($('.card-reveal .card-title')) || $(e.target).is($('.card-reveal .card-title i'))) {
        // Make Reveal animate down and display none
        anim({
          targets: $cardReveal[0],
          translateY: 0,
          duration: 225,
          easing: 'easeInOutQuad',
          complete: function (anim) {
            var el = anim.animatables[0].target;
            $(el).css({ display: 'none' });
            $card.css('overflow', $card.data('initialOverflow'));
          }
        });
      } else if ($(e.target).is($('.card .activator')) || $(e.target).is($('.card .activator i'))) {
        $card.css('overflow', 'hidden');
        $cardReveal.css({ display: 'block' });
        anim({
          targets: $cardReveal[0],
          translateY: '-100%',
          duration: 300,
          easing: 'easeInOutQuad'
        });
      }
    }
  });
})(cash, M.anime);
;(function ($) {
  'use strict';

  var _defaults = {
    data: [],
    placeholder: '',
    secondaryPlaceholder: '',
    autocompleteOptions: {},
    limit: Infinity,
    onChipAdd: null,
    onChipSelect: null,
    onChipDelete: null
  };

  /**
   * @typedef {Object} chip
   * @property {String} tag  chip tag string
   * @property {String} [image]  chip avatar image string
   */

  /**
   * @class
   *
   */

  var Chips = function (_Component12) {
    _inherits(Chips, _Component12);

    /**
     * Construct Chips instance and set up overlay
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Chips(el, options) {
      _classCallCheck(this, Chips);

      var _this45 = _possibleConstructorReturn(this, (Chips.__proto__ || Object.getPrototypeOf(Chips)).call(this, Chips, el, options));

      _this45.el.M_Chips = _this45;

      /**
       * Options for the modal
       * @member Chips#options
       * @prop {Array} data
       * @prop {String} placeholder
       * @prop {String} secondaryPlaceholder
       * @prop {Object} autocompleteOptions
       */
      _this45.options = $.extend({}, Chips.defaults, options);

      _this45.$el.addClass('chips input-field');
      _this45.chipsData = [];
      _this45.$chips = $();
      _this45._setupInput();
      _this45.hasAutocomplete = Object.keys(_this45.options.autocompleteOptions).length > 0;

      // Set input id
      if (!_this45.$input.attr('id')) {
        _this45.$input.attr('id', M.guid());
      }

      // Render initial chips
      if (_this45.options.data.length) {
        _this45.chipsData = _this45.options.data;
        _this45._renderChips(_this45.chipsData);
      }

      // Setup autocomplete if needed
      if (_this45.hasAutocomplete) {
        _this45._setupAutocomplete();
      }

      _this45._setPlaceholder();
      _this45._setupLabel();
      _this45._setupEventHandlers();
      return _this45;
    }

    _createClass(Chips, [{
      key: "getData",


      /**
       * Get Chips Data
       */
      value: function getData() {
        return this.chipsData;
      }

      /**
       * Teardown component
       */

    }, {
      key: "destroy",
      value: function destroy() {
        this._removeEventHandlers();
        this.$chips.remove();
        this.el.M_Chips = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleChipClickBound = this._handleChipClick.bind(this);
        this._handleInputKeydownBound = this._handleInputKeydown.bind(this);
        this._handleInputFocusBound = this._handleInputFocus.bind(this);
        this._handleInputBlurBound = this._handleInputBlur.bind(this);

        this.el.addEventListener('click', this._handleChipClickBound);
        document.addEventListener('keydown', Chips._handleChipsKeydown);
        document.addEventListener('keyup', Chips._handleChipsKeyup);
        this.el.addEventListener('blur', Chips._handleChipsBlur, true);
        this.$input[0].addEventListener('focus', this._handleInputFocusBound);
        this.$input[0].addEventListener('blur', this._handleInputBlurBound);
        this.$input[0].addEventListener('keydown', this._handleInputKeydownBound);
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('click', this._handleChipClickBound);
        document.removeEventListener('keydown', Chips._handleChipsKeydown);
        document.removeEventListener('keyup', Chips._handleChipsKeyup);
        this.el.removeEventListener('blur', Chips._handleChipsBlur, true);
        this.$input[0].removeEventListener('focus', this._handleInputFocusBound);
        this.$input[0].removeEventListener('blur', this._handleInputBlurBound);
        this.$input[0].removeEventListener('keydown', this._handleInputKeydownBound);
      }

      /**
       * Handle Chip Click
       * @param {Event} e
       */

    }, {
      key: "_handleChipClick",
      value: function _handleChipClick(e) {
        var $chip = $(e.target).closest('.chip');
        var clickedClose = $(e.target).is('.close');
        if ($chip.length) {
          var index = $chip.index();
          if (clickedClose) {
            // delete chip
            this.deleteChip(index);
            this.$input[0].focus();
          } else {
            // select chip
            this.selectChip(index);
          }

          // Default handle click to focus on input
        } else {
          this.$input[0].focus();
        }
      }

      /**
       * Handle Chips Keydown
       * @param {Event} e
       */

    }, {
      key: "_handleInputFocus",


      /**
       * Handle Input Focus
       */
      value: function _handleInputFocus() {
        this.$el.addClass('focus');
      }

      /**
       * Handle Input Blur
       */

    }, {
      key: "_handleInputBlur",
      value: function _handleInputBlur() {
        this.$el.removeClass('focus');
      }

      /**
       * Handle Input Keydown
       * @param {Event} e
       */

    }, {
      key: "_handleInputKeydown",
      value: function _handleInputKeydown(e) {
        Chips._keydown = true;

        // enter
        if (e.keyCode === 13) {
          // Override enter if autocompleting.
          if (this.hasAutocomplete && this.autocomplete && this.autocomplete.isOpen) {
            return;
          }

          e.preventDefault();
          this.addChip({
            tag: this.$input[0].value
          });
          this.$input[0].value = '';

          // delete or left
        } else if ((e.keyCode === 8 || e.keyCode === 37) && this.$input[0].value === '' && this.chipsData.length) {
          e.preventDefault();
          this.selectChip(this.chipsData.length - 1);
        }
      }

      /**
       * Render Chip
       * @param {chip} chip
       * @return {Element}
       */

    }, {
      key: "_renderChip",
      value: function _renderChip(chip) {
        if (!chip.tag) {
          return;
        }

        var renderedChip = document.createElement('div');
        var closeIcon = document.createElement('i');
        renderedChip.classList.add('chip');
        renderedChip.textContent = chip.tag;
        renderedChip.setAttribute('tabindex', 0);
        $(closeIcon).addClass('material-icons close');
        closeIcon.textContent = 'close';

        // attach image if needed
        if (chip.image) {
          var img = document.createElement('img');
          img.setAttribute('src', chip.image);
          renderedChip.insertBefore(img, renderedChip.firstChild);
        }

        renderedChip.appendChild(closeIcon);
        return renderedChip;
      }

      /**
       * Render Chips
       */

    }, {
      key: "_renderChips",
      value: function _renderChips() {
        this.$chips.remove();
        for (var i = 0; i < this.chipsData.length; i++) {
          var chipEl = this._renderChip(this.chipsData[i]);
          this.$el.append(chipEl);
          this.$chips.add(chipEl);
        }

        // move input to end
        this.$el.append(this.$input[0]);
      }

      /**
       * Setup Autocomplete
       */

    }, {
      key: "_setupAutocomplete",
      value: function _setupAutocomplete() {
        var _this46 = this;

        this.options.autocompleteOptions.onAutocomplete = function (val) {
          _this46.addChip({
            tag: val
          });
          _this46.$input[0].value = '';
          _this46.$input[0].focus();
        };

        this.autocomplete = M.Autocomplete.init(this.$input[0], this.options.autocompleteOptions);
      }

      /**
       * Setup Input
       */

    }, {
      key: "_setupInput",
      value: function _setupInput() {
        this.$input = this.$el.find('input');
        if (!this.$input.length) {
          this.$input = $('<input></input>');
          this.$el.append(this.$input);
        }

        this.$input.addClass('input');
      }

      /**
       * Setup Label
       */

    }, {
      key: "_setupLabel",
      value: function _setupLabel() {
        this.$label = this.$el.find('label');
        if (this.$label.length) {
          this.$label.setAttribute('for', this.$input.attr('id'));
        }
      }

      /**
       * Set placeholder
       */

    }, {
      key: "_setPlaceholder",
      value: function _setPlaceholder() {
        if (this.chipsData !== undefined && !this.chipsData.length && this.options.placeholder) {
          $(this.$input).prop('placeholder', this.options.placeholder);
        } else if ((this.chipsData === undefined || !!this.chipsData.length) && this.options.secondaryPlaceholder) {
          $(this.$input).prop('placeholder', this.options.secondaryPlaceholder);
        }
      }

      /**
       * Check if chip is valid
       * @param {chip} chip
       */

    }, {
      key: "_isValid",
      value: function _isValid(chip) {
        if (chip.hasOwnProperty('tag') && chip.tag !== '') {
          var exists = false;
          for (var i = 0; i < this.chipsData.length; i++) {
            if (this.chipsData[i].tag === chip.tag) {
              exists = true;
              break;
            }
          }
          return !exists;
        }

        return false;
      }

      /**
       * Add chip
       * @param {chip} chip
       */

    }, {
      key: "addChip",
      value: function addChip(chip) {
        if (!this._isValid(chip) || this.chipsData.length >= this.options.limit) {
          return;
        }

        var renderedChip = this._renderChip(chip);
        this.$chips.add(renderedChip);
        this.chipsData.push(chip);
        $(this.$input).before(renderedChip);
        this._setPlaceholder();

        // fire chipAdd callback
        if (typeof this.options.onChipAdd === 'function') {
          this.options.onChipAdd.call(this, this.$el, renderedChip);
        }
      }

      /**
       * Delete chip
       * @param {Number} chip
       */

    }, {
      key: "deleteChip",
      value: function deleteChip(chipIndex) {
        var $chip = this.$chips.eq(chipIndex);
        this.$chips.eq(chipIndex).remove();
        this.$chips = this.$chips.filter(function (el) {
          return $(el).index() >= 0;
        });
        this.chipsData.splice(chipIndex, 1);
        this._setPlaceholder();

        // fire chipDelete callback
        if (typeof this.options.onChipDelete === 'function') {
          this.options.onChipDelete.call(this, this.$el, $chip[0]);
        }
      }

      /**
       * Select chip
       * @param {Number} chip
       */

    }, {
      key: "selectChip",
      value: function selectChip(chipIndex) {
        var $chip = this.$chips.eq(chipIndex);
        this._selectedChip = $chip;
        $chip[0].focus();

        // fire chipSelect callback
        if (typeof this.options.onChipSelect === 'function') {
          this.options.onChipSelect.call(this, this.$el, $chip[0]);
        }
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Chips.__proto__ || Object.getPrototypeOf(Chips), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Chips;
      }
    }, {
      key: "_handleChipsKeydown",
      value: function _handleChipsKeydown(e) {
        Chips._keydown = true;

        var $chips = $(e.target).closest('.chips');
        var chipsKeydown = e.target && $chips.length;

        // Don't handle keydown inputs on input and textarea
        if ($(e.target).is('input, textarea') || !chipsKeydown) {
          return;
        }

        var currChips = $chips[0].M_Chips;

        // backspace and delete
        if (e.keyCode === 8 || e.keyCode === 46) {
          e.preventDefault();

          var selectIndex = currChips.chipsData.length;
          if (currChips._selectedChip) {
            var index = currChips._selectedChip.index();
            currChips.deleteChip(index);
            currChips._selectedChip = null;

            // Make sure selectIndex doesn't go negative
            selectIndex = Math.max(index - 1, 0);
          }

          if (currChips.chipsData.length) {
            currChips.selectChip(selectIndex);
          }

          // left arrow key
        } else if (e.keyCode === 37) {
          if (currChips._selectedChip) {
            var _selectIndex = currChips._selectedChip.index() - 1;
            if (_selectIndex < 0) {
              return;
            }
            currChips.selectChip(_selectIndex);
          }

          // right arrow key
        } else if (e.keyCode === 39) {
          if (currChips._selectedChip) {
            var _selectIndex2 = currChips._selectedChip.index() + 1;

            if (_selectIndex2 >= currChips.chipsData.length) {
              currChips.$input[0].focus();
            } else {
              currChips.selectChip(_selectIndex2);
            }
          }
        }
      }

      /**
       * Handle Chips Keyup
       * @param {Event} e
       */

    }, {
      key: "_handleChipsKeyup",
      value: function _handleChipsKeyup(e) {
        Chips._keydown = false;
      }

      /**
       * Handle Chips Blur
       * @param {Event} e
       */

    }, {
      key: "_handleChipsBlur",
      value: function _handleChipsBlur(e) {
        if (!Chips._keydown) {
          var $chips = $(e.target).closest('.chips');
          var currChips = $chips[0].M_Chips;

          currChips._selectedChip = null;
        }
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Chips;
  }(Component);

  /**
   * @static
   * @memberof Chips
   */


  Chips._keydown = false;

  M.Chips = Chips;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Chips, 'chips', 'M_Chips');
  }

  $(document).ready(function () {
    // Handle removal of static chips.
    $(document.body).on('click', '.chip .close', function () {
      var $chips = $(this).closest('.chips');
      if ($chips.length && $chips[0].M_Chips) {
        return;
      }
      $(this).closest('.chip').remove();
    });
  });
})(cash);
;(function ($) {
  'use strict';

  var _defaults = {
    top: 0,
    bottom: Infinity,
    offset: 0,
    onPositionChange: null
  };

  /**
   * @class
   *
   */

  var Pushpin = function (_Component13) {
    _inherits(Pushpin, _Component13);

    /**
     * Construct Pushpin instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Pushpin(el, options) {
      _classCallCheck(this, Pushpin);

      var _this47 = _possibleConstructorReturn(this, (Pushpin.__proto__ || Object.getPrototypeOf(Pushpin)).call(this, Pushpin, el, options));

      _this47.el.M_Pushpin = _this47;

      /**
       * Options for the modal
       * @member Pushpin#options
       */
      _this47.options = $.extend({}, Pushpin.defaults, options);

      _this47.originalOffset = _this47.el.offsetTop;
      Pushpin._pushpins.push(_this47);
      _this47._setupEventHandlers();
      _this47._updatePosition();
      return _this47;
    }

    _createClass(Pushpin, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this.el.style.top = null;
        this._removePinClasses();
        this._removeEventHandlers();

        // Remove pushpin Inst
        var index = Pushpin._pushpins.indexOf(this);
        Pushpin._pushpins.splice(index, 1);
      }
    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        document.addEventListener('scroll', Pushpin._updateElements);
      }
    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        document.removeEventListener('scroll', Pushpin._updateElements);
      }
    }, {
      key: "_updatePosition",
      value: function _updatePosition() {
        var scrolled = M.getDocumentScrollTop() + this.options.offset;

        if (this.options.top <= scrolled && this.options.bottom >= scrolled && !this.el.classList.contains('pinned')) {
          this._removePinClasses();
          this.el.style.top = this.options.offset + "px";
          this.el.classList.add('pinned');

          // onPositionChange callback
          if (typeof this.options.onPositionChange === 'function') {
            this.options.onPositionChange.call(this, 'pinned');
          }
        }

        // Add pin-top (when scrolled position is above top)
        if (scrolled < this.options.top && !this.el.classList.contains('pin-top')) {
          this._removePinClasses();
          this.el.style.top = 0;
          this.el.classList.add('pin-top');

          // onPositionChange callback
          if (typeof this.options.onPositionChange === 'function') {
            this.options.onPositionChange.call(this, 'pin-top');
          }
        }

        // Add pin-bottom (when scrolled position is below bottom)
        if (scrolled > this.options.bottom && !this.el.classList.contains('pin-bottom')) {
          this._removePinClasses();
          this.el.classList.add('pin-bottom');
          this.el.style.top = this.options.bottom - this.originalOffset + "px";

          // onPositionChange callback
          if (typeof this.options.onPositionChange === 'function') {
            this.options.onPositionChange.call(this, 'pin-bottom');
          }
        }
      }
    }, {
      key: "_removePinClasses",
      value: function _removePinClasses() {
        // IE 11 bug (can't remove multiple classes in one line)
        this.el.classList.remove('pin-top');
        this.el.classList.remove('pinned');
        this.el.classList.remove('pin-bottom');
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Pushpin.__proto__ || Object.getPrototypeOf(Pushpin), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Pushpin;
      }
    }, {
      key: "_updateElements",
      value: function _updateElements() {
        for (var elIndex in Pushpin._pushpins) {
          var pInstance = Pushpin._pushpins[elIndex];
          pInstance._updatePosition();
        }
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Pushpin;
  }(Component);

  /**
   * @static
   * @memberof Pushpin
   */


  Pushpin._pushpins = [];

  M.Pushpin = Pushpin;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Pushpin, 'pushpin', 'M_Pushpin');
  }
})(cash);
;(function ($, anim) {
  'use strict';

  var _defaults = {
    direction: 'top',
    hoverEnabled: true,
    toolbarEnabled: false
  };

  $.fn.reverse = [].reverse;

  /**
   * @class
   *
   */

  var FloatingActionButton = function (_Component14) {
    _inherits(FloatingActionButton, _Component14);

    /**
     * Construct FloatingActionButton instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function FloatingActionButton(el, options) {
      _classCallCheck(this, FloatingActionButton);

      var _this48 = _possibleConstructorReturn(this, (FloatingActionButton.__proto__ || Object.getPrototypeOf(FloatingActionButton)).call(this, FloatingActionButton, el, options));

      _this48.el.M_FloatingActionButton = _this48;

      /**
       * Options for the fab
       * @member FloatingActionButton#options
       * @prop {Boolean} [direction] - Direction fab menu opens
       * @prop {Boolean} [hoverEnabled=true] - Enable hover vs click
       * @prop {Boolean} [toolbarEnabled=false] - Enable toolbar transition
       */
      _this48.options = $.extend({}, FloatingActionButton.defaults, options);

      _this48.isOpen = false;
      _this48.$anchor = _this48.$el.children('a').first();
      _this48.$menu = _this48.$el.children('ul').first();
      _this48.$floatingBtns = _this48.$el.find('ul .btn-floating');
      _this48.$floatingBtnsReverse = _this48.$el.find('ul .btn-floating').reverse();
      _this48.offsetY = 0;
      _this48.offsetX = 0;

      _this48.$el.addClass("direction-" + _this48.options.direction);
      if (_this48.options.direction === 'top') {
        _this48.offsetY = 40;
      } else if (_this48.options.direction === 'right') {
        _this48.offsetX = -40;
      } else if (_this48.options.direction === 'bottom') {
        _this48.offsetY = -40;
      } else {
        _this48.offsetX = 40;
      }
      _this48._setupEventHandlers();
      return _this48;
    }

    _createClass(FloatingActionButton, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this.el.M_FloatingActionButton = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleFABClickBound = this._handleFABClick.bind(this);
        this._handleOpenBound = this.open.bind(this);
        this._handleCloseBound = this.close.bind(this);

        if (this.options.hoverEnabled && !this.options.toolbarEnabled) {
          this.el.addEventListener('mouseenter', this._handleOpenBound);
          this.el.addEventListener('mouseleave', this._handleCloseBound);
        } else {
          this.el.addEventListener('click', this._handleFABClickBound);
        }
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        if (this.options.hoverEnabled && !this.options.toolbarEnabled) {
          this.el.removeEventListener('mouseenter', this._handleOpenBound);
          this.el.removeEventListener('mouseleave', this._handleCloseBound);
        } else {
          this.el.removeEventListener('click', this._handleFABClickBound);
        }
      }

      /**
       * Handle FAB Click
       */

    }, {
      key: "_handleFABClick",
      value: function _handleFABClick() {
        if (this.isOpen) {
          this.close();
        } else {
          this.open();
        }
      }

      /**
       * Handle Document Click
       * @param {Event} e
       */

    }, {
      key: "_handleDocumentClick",
      value: function _handleDocumentClick(e) {
        if (!$(e.target).closest(this.$menu).length) {
          this.close();
        }
      }

      /**
       * Open FAB
       */

    }, {
      key: "open",
      value: function open() {
        if (this.isOpen) {
          return;
        }

        if (this.options.toolbarEnabled) {
          this._animateInToolbar();
        } else {
          this._animateInFAB();
        }
        this.isOpen = true;
      }

      /**
       * Close FAB
       */

    }, {
      key: "close",
      value: function close() {
        if (!this.isOpen) {
          return;
        }

        if (this.options.toolbarEnabled) {
          window.removeEventListener('scroll', this._handleCloseBound, true);
          document.body.removeEventListener('click', this._handleDocumentClickBound, true);
          this._animateOutToolbar();
        } else {
          this._animateOutFAB();
        }
        this.isOpen = false;
      }

      /**
       * Classic FAB Menu open
       */

    }, {
      key: "_animateInFAB",
      value: function _animateInFAB() {
        var _this49 = this;

        this.$el.addClass('active');

        var time = 0;
        this.$floatingBtnsReverse.each(function (el) {
          anim({
            targets: el,
            opacity: 1,
            scale: [0.4, 1],
            translateY: [_this49.offsetY, 0],
            translateX: [_this49.offsetX, 0],
            duration: 275,
            delay: time,
            easing: 'easeInOutQuad'
          });
          time += 40;
        });
      }

      /**
       * Classic FAB Menu close
       */

    }, {
      key: "_animateOutFAB",
      value: function _animateOutFAB() {
        var _this50 = this;

        this.$floatingBtnsReverse.each(function (el) {
          anim.remove(el);
          anim({
            targets: el,
            opacity: 0,
            scale: 0.4,
            translateY: _this50.offsetY,
            translateX: _this50.offsetX,
            duration: 175,
            easing: 'easeOutQuad',
            complete: function () {
              _this50.$el.removeClass('active');
            }
          });
        });
      }

      /**
       * Toolbar transition Menu open
       */

    }, {
      key: "_animateInToolbar",
      value: function _animateInToolbar() {
        var _this51 = this;

        var scaleFactor = void 0;
        var windowWidth = window.innerWidth;
        var windowHeight = window.innerHeight;
        var btnRect = this.el.getBoundingClientRect();
        var backdrop = $('<div class="fab-backdrop"></div>');
        var fabColor = this.$anchor.css('background-color');
        this.$anchor.append(backdrop);

        this.offsetX = btnRect.left - windowWidth / 2 + btnRect.width / 2;
        this.offsetY = windowHeight - btnRect.bottom;
        scaleFactor = windowWidth / backdrop[0].clientWidth;
        this.btnBottom = btnRect.bottom;
        this.btnLeft = btnRect.left;
        this.btnWidth = btnRect.width;

        // Set initial state
        this.$el.addClass('active');
        this.$el.css({
          'text-align': 'center',
          width: '100%',
          bottom: 0,
          left: 0,
          transform: 'translateX(' + this.offsetX + 'px)',
          transition: 'none'
        });
        this.$anchor.css({
          transform: 'translateY(' + -this.offsetY + 'px)',
          transition: 'none'
        });
        backdrop.css({
          'background-color': fabColor
        });

        setTimeout(function () {
          _this51.$el.css({
            transform: '',
            transition: 'transform .2s cubic-bezier(0.550, 0.085, 0.680, 0.530), background-color 0s linear .2s'
          });
          _this51.$anchor.css({
            overflow: 'visible',
            transform: '',
            transition: 'transform .2s'
          });

          setTimeout(function () {
            _this51.$el.css({
              overflow: 'hidden',
              'background-color': fabColor
            });
            backdrop.css({
              transform: 'scale(' + scaleFactor + ')',
              transition: 'transform .2s cubic-bezier(0.550, 0.055, 0.675, 0.190)'
            });
            _this51.$menu.children('li').children('a').css({
              opacity: 1
            });

            // Scroll to close.
            _this51._handleDocumentClickBound = _this51._handleDocumentClick.bind(_this51);
            window.addEventListener('scroll', _this51._handleCloseBound, true);
            document.body.addEventListener('click', _this51._handleDocumentClickBound, true);
          }, 100);
        }, 0);
      }

      /**
       * Toolbar transition Menu close
       */

    }, {
      key: "_animateOutToolbar",
      value: function _animateOutToolbar() {
        var _this52 = this;

        var windowWidth = window.innerWidth;
        var windowHeight = window.innerHeight;
        var backdrop = this.$el.find('.fab-backdrop');
        var fabColor = this.$anchor.css('background-color');

        this.offsetX = this.btnLeft - windowWidth / 2 + this.btnWidth / 2;
        this.offsetY = windowHeight - this.btnBottom;

        // Hide backdrop
        this.$el.removeClass('active');
        this.$el.css({
          'background-color': 'transparent',
          transition: 'none'
        });
        this.$anchor.css({
          transition: 'none'
        });
        backdrop.css({
          transform: 'scale(0)',
          'background-color': fabColor
        });
        this.$menu.children('li').children('a').css({
          opacity: ''
        });

        setTimeout(function () {
          backdrop.remove();

          // Set initial state.
          _this52.$el.css({
            'text-align': '',
            width: '',
            bottom: '',
            left: '',
            overflow: '',
            'background-color': '',
            transform: 'translate3d(' + -_this52.offsetX + 'px,0,0)'
          });
          _this52.$anchor.css({
            overflow: '',
            transform: 'translate3d(0,' + _this52.offsetY + 'px,0)'
          });

          setTimeout(function () {
            _this52.$el.css({
              transform: 'translate3d(0,0,0)',
              transition: 'transform .2s'
            });
            _this52.$anchor.css({
              transform: 'translate3d(0,0,0)',
              transition: 'transform .2s cubic-bezier(0.550, 0.055, 0.675, 0.190)'
            });
          }, 20);
        }, 200);
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(FloatingActionButton.__proto__ || Object.getPrototypeOf(FloatingActionButton), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_FloatingActionButton;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return FloatingActionButton;
  }(Component);

  M.FloatingActionButton = FloatingActionButton;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(FloatingActionButton, 'floatingActionButton', 'M_FloatingActionButton');
  }
})(cash, M.anime);
;(function ($) {
  'use strict';

  var _defaults = {
    // Close when date is selected
    autoClose: false,

    // the default output format for the input field value
    format: 'mmm dd, yyyy',

    // Used to create date object from current input string
    parse: null,

    // The initial date to view when first opened
    defaultDate: null,

    // Make the `defaultDate` the initial selected value
    setDefaultDate: false,

    disableWeekends: false,

    disableDayFn: null,

    // First day of week (0: Sunday, 1: Monday etc)
    firstDay: 0,

    // The earliest date that can be selected
    minDate: null,
    // Thelatest date that can be selected
    maxDate: null,

    // Number of years either side, or array of upper/lower range
    yearRange: 10,

    // used internally (don't config outside)
    minYear: 0,
    maxYear: 9999,
    minMonth: undefined,
    maxMonth: undefined,

    startRange: null,
    endRange: null,

    isRTL: false,

    // Render the month after year in the calendar title
    showMonthAfterYear: false,

    // Render days of the calendar grid that fall in the next or previous month
    showDaysInNextAndPreviousMonths: false,

    // Specify a DOM element to render the calendar in
    container: null,

    // Show clear button
    showClearBtn: false,

    // internationalization
    i18n: {
      cancel: 'Cancel',
      clear: 'Clear',
      done: 'Ok',
      previousMonth: '‹',
      nextMonth: '›',
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      weekdaysAbbrev: ['S', 'M', 'T', 'W', 'T', 'F', 'S']
    },

    // events array
    events: [],

    // callback function
    onSelect: null,
    onOpen: null,
    onClose: null,
    onDraw: null
  };

  /**
   * @class
   *
   */

  var Datepicker = function (_Component15) {
    _inherits(Datepicker, _Component15);

    /**
     * Construct Datepicker instance and set up overlay
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Datepicker(el, options) {
      _classCallCheck(this, Datepicker);

      var _this53 = _possibleConstructorReturn(this, (Datepicker.__proto__ || Object.getPrototypeOf(Datepicker)).call(this, Datepicker, el, options));

      _this53.el.M_Datepicker = _this53;

      _this53.options = $.extend({}, Datepicker.defaults, options);

      // make sure i18n defaults are not lost when only few i18n option properties are passed
      if (!!options && options.hasOwnProperty('i18n') && typeof options.i18n === 'object') {
        _this53.options.i18n = $.extend({}, Datepicker.defaults.i18n, options.i18n);
      }

      // Remove time component from minDate and maxDate options
      if (_this53.options.minDate) _this53.options.minDate.setHours(0, 0, 0, 0);
      if (_this53.options.maxDate) _this53.options.maxDate.setHours(0, 0, 0, 0);

      _this53.id = M.guid();

      _this53._setupVariables();
      _this53._insertHTMLIntoDOM();
      _this53._setupModal();

      _this53._setupEventHandlers();

      if (!_this53.options.defaultDate) {
        _this53.options.defaultDate = new Date(Date.parse(_this53.el.value));
      }

      var defDate = _this53.options.defaultDate;
      if (Datepicker._isDate(defDate)) {
        if (_this53.options.setDefaultDate) {
          _this53.setDate(defDate, true);
          _this53.setInputValue();
        } else {
          _this53.gotoDate(defDate);
        }
      } else {
        _this53.gotoDate(new Date());
      }

      /**
       * Describes open/close state of datepicker
       * @type {Boolean}
       */
      _this53.isOpen = false;
      return _this53;
    }

    _createClass(Datepicker, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this.modal.destroy();
        $(this.modalEl).remove();
        this.destroySelects();
        this.el.M_Datepicker = undefined;
      }
    }, {
      key: "destroySelects",
      value: function destroySelects() {
        var oldYearSelect = this.calendarEl.querySelector('.orig-select-year');
        if (oldYearSelect) {
          M.FormSelect.getInstance(oldYearSelect).destroy();
        }
        var oldMonthSelect = this.calendarEl.querySelector('.orig-select-month');
        if (oldMonthSelect) {
          M.FormSelect.getInstance(oldMonthSelect).destroy();
        }
      }
    }, {
      key: "_insertHTMLIntoDOM",
      value: function _insertHTMLIntoDOM() {
        if (this.options.showClearBtn) {
          $(this.clearBtn).css({ visibility: '' });
          this.clearBtn.innerHTML = this.options.i18n.clear;
        }

        this.doneBtn.innerHTML = this.options.i18n.done;
        this.cancelBtn.innerHTML = this.options.i18n.cancel;

        if (this.options.container) {
          this.$modalEl.appendTo(this.options.container);
        } else {
          this.$modalEl.insertBefore(this.el);
        }
      }
    }, {
      key: "_setupModal",
      value: function _setupModal() {
        var _this54 = this;

        this.modalEl.id = 'modal-' + this.id;
        this.modal = M.Modal.init(this.modalEl, {
          onCloseEnd: function () {
            _this54.isOpen = false;
          }
        });
      }
    }, {
      key: "toString",
      value: function toString(format) {
        var _this55 = this;

        format = format || this.options.format;
        if (!Datepicker._isDate(this.date)) {
          return '';
        }

        var formatArray = format.split(/(d{1,4}|m{1,4}|y{4}|yy|!.)/g);
        var formattedDate = formatArray.map(function (label) {
          if (_this55.formats[label]) {
            return _this55.formats[label]();
          }

          return label;
        }).join('');
        return formattedDate;
      }
    }, {
      key: "setDate",
      value: function setDate(date, preventOnSelect) {
        if (!date) {
          this.date = null;
          this._renderDateDisplay();
          return this.draw();
        }
        if (typeof date === 'string') {
          date = new Date(Date.parse(date));
        }
        if (!Datepicker._isDate(date)) {
          return;
        }

        var min = this.options.minDate,
            max = this.options.maxDate;

        if (Datepicker._isDate(min) && date < min) {
          date = min;
        } else if (Datepicker._isDate(max) && date > max) {
          date = max;
        }

        this.date = new Date(date.getTime());

        this._renderDateDisplay();

        Datepicker._setToStartOfDay(this.date);
        this.gotoDate(this.date);

        if (!preventOnSelect && typeof this.options.onSelect === 'function') {
          this.options.onSelect.call(this, this.date);
        }
      }
    }, {
      key: "setInputValue",
      value: function setInputValue() {
        this.el.value = this.toString();
        this.$el.trigger('change', { firedBy: this });
      }
    }, {
      key: "_renderDateDisplay",
      value: function _renderDateDisplay() {
        var displayDate = Datepicker._isDate(this.date) ? this.date : new Date();
        var i18n = this.options.i18n;
        var day = i18n.weekdaysShort[displayDate.getDay()];
        var month = i18n.monthsShort[displayDate.getMonth()];
        var date = displayDate.getDate();
        this.yearTextEl.innerHTML = displayDate.getFullYear();
        this.dateTextEl.innerHTML = day + ", " + month + " " + date;
      }

      /**
       * change view to a specific date
       */

    }, {
      key: "gotoDate",
      value: function gotoDate(date) {
        var newCalendar = true;

        if (!Datepicker._isDate(date)) {
          return;
        }

        if (this.calendars) {
          var firstVisibleDate = new Date(this.calendars[0].year, this.calendars[0].month, 1),
              lastVisibleDate = new Date(this.calendars[this.calendars.length - 1].year, this.calendars[this.calendars.length - 1].month, 1),
              visibleDate = date.getTime();
          // get the end of the month
          lastVisibleDate.setMonth(lastVisibleDate.getMonth() + 1);
          lastVisibleDate.setDate(lastVisibleDate.getDate() - 1);
          newCalendar = visibleDate < firstVisibleDate.getTime() || lastVisibleDate.getTime() < visibleDate;
        }

        if (newCalendar) {
          this.calendars = [{
            month: date.getMonth(),
            year: date.getFullYear()
          }];
        }

        this.adjustCalendars();
      }
    }, {
      key: "adjustCalendars",
      value: function adjustCalendars() {
        this.calendars[0] = this.adjustCalendar(this.calendars[0]);
        this.draw();
      }
    }, {
      key: "adjustCalendar",
      value: function adjustCalendar(calendar) {
        if (calendar.month < 0) {
          calendar.year -= Math.ceil(Math.abs(calendar.month) / 12);
          calendar.month += 12;
        }
        if (calendar.month > 11) {
          calendar.year += Math.floor(Math.abs(calendar.month) / 12);
          calendar.month -= 12;
        }
        return calendar;
      }
    }, {
      key: "nextMonth",
      value: function nextMonth() {
        this.calendars[0].month++;
        this.adjustCalendars();
      }
    }, {
      key: "prevMonth",
      value: function prevMonth() {
        this.calendars[0].month--;
        this.adjustCalendars();
      }
    }, {
      key: "render",
      value: function render(year, month, randId) {
        var opts = this.options,
            now = new Date(),
            days = Datepicker._getDaysInMonth(year, month),
            before = new Date(year, month, 1).getDay(),
            data = [],
            row = [];
        Datepicker._setToStartOfDay(now);
        if (opts.firstDay > 0) {
          before -= opts.firstDay;
          if (before < 0) {
            before += 7;
          }
        }
        var previousMonth = month === 0 ? 11 : month - 1,
            nextMonth = month === 11 ? 0 : month + 1,
            yearOfPreviousMonth = month === 0 ? year - 1 : year,
            yearOfNextMonth = month === 11 ? year + 1 : year,
            daysInPreviousMonth = Datepicker._getDaysInMonth(yearOfPreviousMonth, previousMonth);
        var cells = days + before,
            after = cells;
        while (after > 7) {
          after -= 7;
        }
        cells += 7 - after;
        var isWeekSelected = false;
        for (var i = 0, r = 0; i < cells; i++) {
          var day = new Date(year, month, 1 + (i - before)),
              isSelected = Datepicker._isDate(this.date) ? Datepicker._compareDates(day, this.date) : false,
              isToday = Datepicker._compareDates(day, now),
              hasEvent = opts.events.indexOf(day.toDateString()) !== -1 ? true : false,
              isEmpty = i < before || i >= days + before,
              dayNumber = 1 + (i - before),
              monthNumber = month,
              yearNumber = year,
              isStartRange = opts.startRange && Datepicker._compareDates(opts.startRange, day),
              isEndRange = opts.endRange && Datepicker._compareDates(opts.endRange, day),
              isInRange = opts.startRange && opts.endRange && opts.startRange < day && day < opts.endRange,
              isDisabled = opts.minDate && day < opts.minDate || opts.maxDate && day > opts.maxDate || opts.disableWeekends && Datepicker._isWeekend(day) || opts.disableDayFn && opts.disableDayFn(day);

          if (isEmpty) {
            if (i < before) {
              dayNumber = daysInPreviousMonth + dayNumber;
              monthNumber = previousMonth;
              yearNumber = yearOfPreviousMonth;
            } else {
              dayNumber = dayNumber - days;
              monthNumber = nextMonth;
              yearNumber = yearOfNextMonth;
            }
          }

          var dayConfig = {
            day: dayNumber,
            month: monthNumber,
            year: yearNumber,
            hasEvent: hasEvent,
            isSelected: isSelected,
            isToday: isToday,
            isDisabled: isDisabled,
            isEmpty: isEmpty,
            isStartRange: isStartRange,
            isEndRange: isEndRange,
            isInRange: isInRange,
            showDaysInNextAndPreviousMonths: opts.showDaysInNextAndPreviousMonths
          };

          row.push(this.renderDay(dayConfig));

          if (++r === 7) {
            data.push(this.renderRow(row, opts.isRTL, isWeekSelected));
            row = [];
            r = 0;
            isWeekSelected = false;
          }
        }
        return this.renderTable(opts, data, randId);
      }
    }, {
      key: "renderDay",
      value: function renderDay(opts) {
        var arr = [];
        var ariaSelected = 'false';
        if (opts.isEmpty) {
          if (opts.showDaysInNextAndPreviousMonths) {
            arr.push('is-outside-current-month');
            arr.push('is-selection-disabled');
          } else {
            return '<td class="is-empty"></td>';
          }
        }
        if (opts.isDisabled) {
          arr.push('is-disabled');
        }

        if (opts.isToday) {
          arr.push('is-today');
        }
        if (opts.isSelected) {
          arr.push('is-selected');
          ariaSelected = 'true';
        }
        if (opts.hasEvent) {
          arr.push('has-event');
        }
        if (opts.isInRange) {
          arr.push('is-inrange');
        }
        if (opts.isStartRange) {
          arr.push('is-startrange');
        }
        if (opts.isEndRange) {
          arr.push('is-endrange');
        }
        return "<td data-day=\"" + opts.day + "\" class=\"" + arr.join(' ') + "\" aria-selected=\"" + ariaSelected + "\">" + ("<button class=\"datepicker-day-button\" type=\"button\" data-year=\"" + opts.year + "\" data-month=\"" + opts.month + "\" data-day=\"" + opts.day + "\">" + opts.day + "</button>") + '</td>';
      }
    }, {
      key: "renderRow",
      value: function renderRow(days, isRTL, isRowSelected) {
        return '<tr class="datepicker-row' + (isRowSelected ? ' is-selected' : '') + '">' + (isRTL ? days.reverse() : days).join('') + '</tr>';
      }
    }, {
      key: "renderTable",
      value: function renderTable(opts, data, randId) {
        return '<div class="datepicker-table-wrapper"><table cellpadding="0" cellspacing="0" class="datepicker-table" role="grid" aria-labelledby="' + randId + '">' + this.renderHead(opts) + this.renderBody(data) + '</table></div>';
      }
    }, {
      key: "renderHead",
      value: function renderHead(opts) {
        var i = void 0,
            arr = [];
        for (i = 0; i < 7; i++) {
          arr.push("<th scope=\"col\"><abbr title=\"" + this.renderDayName(opts, i) + "\">" + this.renderDayName(opts, i, true) + "</abbr></th>");
        }
        return '<thead><tr>' + (opts.isRTL ? arr.reverse() : arr).join('') + '</tr></thead>';
      }
    }, {
      key: "renderBody",
      value: function renderBody(rows) {
        return '<tbody>' + rows.join('') + '</tbody>';
      }
    }, {
      key: "renderTitle",
      value: function renderTitle(instance, c, year, month, refYear, randId) {
        var i = void 0,
            j = void 0,
            arr = void 0,
            opts = this.options,
            isMinYear = year === opts.minYear,
            isMaxYear = year === opts.maxYear,
            html = '<div id="' + randId + '" class="datepicker-controls" role="heading" aria-live="assertive">',
            monthHtml = void 0,
            yearHtml = void 0,
            prev = true,
            next = true;

        for (arr = [], i = 0; i < 12; i++) {
          arr.push('<option value="' + (year === refYear ? i - c : 12 + i - c) + '"' + (i === month ? ' selected="selected"' : '') + (isMinYear && i < opts.minMonth || isMaxYear && i > opts.maxMonth ? 'disabled="disabled"' : '') + '>' + opts.i18n.months[i] + '</option>');
        }

        monthHtml = '<select class="datepicker-select orig-select-month" tabindex="-1">' + arr.join('') + '</select>';

        if ($.isArray(opts.yearRange)) {
          i = opts.yearRange[0];
          j = opts.yearRange[1] + 1;
        } else {
          i = year - opts.yearRange;
          j = 1 + year + opts.yearRange;
        }

        for (arr = []; i < j && i <= opts.maxYear; i++) {
          if (i >= opts.minYear) {
            arr.push("<option value=\"" + i + "\" " + (i === year ? 'selected="selected"' : '') + ">" + i + "</option>");
          }
        }

        yearHtml = "<select class=\"datepicker-select orig-select-year\" tabindex=\"-1\">" + arr.join('') + "</select>";

        var leftArrow = '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"/><path d="M0-.5h24v24H0z" fill="none"/></svg>';
        html += "<button class=\"month-prev" + (prev ? '' : ' is-disabled') + "\" type=\"button\">" + leftArrow + "</button>";

        html += '<div class="selects-container">';
        if (opts.showMonthAfterYear) {
          html += yearHtml + monthHtml;
        } else {
          html += monthHtml + yearHtml;
        }
        html += '</div>';

        if (isMinYear && (month === 0 || opts.minMonth >= month)) {
          prev = false;
        }

        if (isMaxYear && (month === 11 || opts.maxMonth <= month)) {
          next = false;
        }

        var rightArrow = '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"/><path d="M0-.25h24v24H0z" fill="none"/></svg>';
        html += "<button class=\"month-next" + (next ? '' : ' is-disabled') + "\" type=\"button\">" + rightArrow + "</button>";

        return html += '</div>';
      }

      /**
       * refresh the HTML
       */

    }, {
      key: "draw",
      value: function draw(force) {
        if (!this.isOpen && !force) {
          return;
        }
        var opts = this.options,
            minYear = opts.minYear,
            maxYear = opts.maxYear,
            minMonth = opts.minMonth,
            maxMonth = opts.maxMonth,
            html = '',
            randId = void 0;

        if (this._y <= minYear) {
          this._y = minYear;
          if (!isNaN(minMonth) && this._m < minMonth) {
            this._m = minMonth;
          }
        }
        if (this._y >= maxYear) {
          this._y = maxYear;
          if (!isNaN(maxMonth) && this._m > maxMonth) {
            this._m = maxMonth;
          }
        }

        randId = 'datepicker-title-' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 2);

        for (var c = 0; c < 1; c++) {
          this._renderDateDisplay();
          html += this.renderTitle(this, c, this.calendars[c].year, this.calendars[c].month, this.calendars[0].year, randId) + this.render(this.calendars[c].year, this.calendars[c].month, randId);
        }

        this.destroySelects();

        this.calendarEl.innerHTML = html;

        // Init Materialize Select
        var yearSelect = this.calendarEl.querySelector('.orig-select-year');
        var monthSelect = this.calendarEl.querySelector('.orig-select-month');
        M.FormSelect.init(yearSelect, {
          classes: 'select-year',
          dropdownOptions: { container: document.body, constrainWidth: false }
        });
        M.FormSelect.init(monthSelect, {
          classes: 'select-month',
          dropdownOptions: { container: document.body, constrainWidth: false }
        });

        // Add change handlers for select
        yearSelect.addEventListener('change', this._handleYearChange.bind(this));
        monthSelect.addEventListener('change', this._handleMonthChange.bind(this));

        if (typeof this.options.onDraw === 'function') {
          this.options.onDraw(this);
        }
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleInputKeydownBound = this._handleInputKeydown.bind(this);
        this._handleInputClickBound = this._handleInputClick.bind(this);
        this._handleInputChangeBound = this._handleInputChange.bind(this);
        this._handleCalendarClickBound = this._handleCalendarClick.bind(this);
        this._finishSelectionBound = this._finishSelection.bind(this);
        this._handleMonthChange = this._handleMonthChange.bind(this);
        this._closeBound = this.close.bind(this);

        this.el.addEventListener('click', this._handleInputClickBound);
        this.el.addEventListener('keydown', this._handleInputKeydownBound);
        this.el.addEventListener('change', this._handleInputChangeBound);
        this.calendarEl.addEventListener('click', this._handleCalendarClickBound);
        this.doneBtn.addEventListener('click', this._finishSelectionBound);
        this.cancelBtn.addEventListener('click', this._closeBound);

        if (this.options.showClearBtn) {
          this._handleClearClickBound = this._handleClearClick.bind(this);
          this.clearBtn.addEventListener('click', this._handleClearClickBound);
        }
      }
    }, {
      key: "_setupVariables",
      value: function _setupVariables() {
        var _this56 = this;

        this.$modalEl = $(Datepicker._template);
        this.modalEl = this.$modalEl[0];

        this.calendarEl = this.modalEl.querySelector('.datepicker-calendar');

        this.yearTextEl = this.modalEl.querySelector('.year-text');
        this.dateTextEl = this.modalEl.querySelector('.date-text');
        if (this.options.showClearBtn) {
          this.clearBtn = this.modalEl.querySelector('.datepicker-clear');
        }
        this.doneBtn = this.modalEl.querySelector('.datepicker-done');
        this.cancelBtn = this.modalEl.querySelector('.datepicker-cancel');

        this.formats = {
          d: function () {
            return _this56.date.getDate();
          },
          dd: function () {
            var d = _this56.date.getDate();
            return (d < 10 ? '0' : '') + d;
          },
          ddd: function () {
            return _this56.options.i18n.weekdaysShort[_this56.date.getDay()];
          },
          dddd: function () {
            return _this56.options.i18n.weekdays[_this56.date.getDay()];
          },
          m: function () {
            return _this56.date.getMonth() + 1;
          },
          mm: function () {
            var m = _this56.date.getMonth() + 1;
            return (m < 10 ? '0' : '') + m;
          },
          mmm: function () {
            return _this56.options.i18n.monthsShort[_this56.date.getMonth()];
          },
          mmmm: function () {
            return _this56.options.i18n.months[_this56.date.getMonth()];
          },
          yy: function () {
            return ('' + _this56.date.getFullYear()).slice(2);
          },
          yyyy: function () {
            return _this56.date.getFullYear();
          }
        };
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('click', this._handleInputClickBound);
        this.el.removeEventListener('keydown', this._handleInputKeydownBound);
        this.el.removeEventListener('change', this._handleInputChangeBound);
        this.calendarEl.removeEventListener('click', this._handleCalendarClickBound);
      }
    }, {
      key: "_handleInputClick",
      value: function _handleInputClick() {
        this.open();
      }
    }, {
      key: "_handleInputKeydown",
      value: function _handleInputKeydown(e) {
        if (e.which === M.keys.ENTER) {
          e.preventDefault();
          this.open();
        }
      }
    }, {
      key: "_handleCalendarClick",
      value: function _handleCalendarClick(e) {
        if (!this.isOpen) {
          return;
        }

        var $target = $(e.target);
        if (!$target.hasClass('is-disabled')) {
          if ($target.hasClass('datepicker-day-button') && !$target.hasClass('is-empty') && !$target.parent().hasClass('is-disabled')) {
            this.setDate(new Date(e.target.getAttribute('data-year'), e.target.getAttribute('data-month'), e.target.getAttribute('data-day')));
            if (this.options.autoClose) {
              this._finishSelection();
            }
          } else if ($target.closest('.month-prev').length) {
            this.prevMonth();
          } else if ($target.closest('.month-next').length) {
            this.nextMonth();
          }
        }
      }
    }, {
      key: "_handleClearClick",
      value: function _handleClearClick() {
        this.date = null;
        this.setInputValue();
        this.close();
      }
    }, {
      key: "_handleMonthChange",
      value: function _handleMonthChange(e) {
        this.gotoMonth(e.target.value);
      }
    }, {
      key: "_handleYearChange",
      value: function _handleYearChange(e) {
        this.gotoYear(e.target.value);
      }

      /**
       * change view to a specific month (zero-index, e.g. 0: January)
       */

    }, {
      key: "gotoMonth",
      value: function gotoMonth(month) {
        if (!isNaN(month)) {
          this.calendars[0].month = parseInt(month, 10);
          this.adjustCalendars();
        }
      }

      /**
       * change view to a specific full year (e.g. "2012")
       */

    }, {
      key: "gotoYear",
      value: function gotoYear(year) {
        if (!isNaN(year)) {
          this.calendars[0].year = parseInt(year, 10);
          this.adjustCalendars();
        }
      }
    }, {
      key: "_handleInputChange",
      value: function _handleInputChange(e) {
        var date = void 0;

        // Prevent change event from being fired when triggered by the plugin
        if (e.firedBy === this) {
          return;
        }
        if (this.options.parse) {
          date = this.options.parse(this.el.value, this.options.format);
        } else {
          date = new Date(Date.parse(this.el.value));
        }

        if (Datepicker._isDate(date)) {
          this.setDate(date);
        }
      }
    }, {
      key: "renderDayName",
      value: function renderDayName(opts, day, abbr) {
        day += opts.firstDay;
        while (day >= 7) {
          day -= 7;
        }
        return abbr ? opts.i18n.weekdaysAbbrev[day] : opts.i18n.weekdays[day];
      }

      /**
       * Set input value to the selected date and close Datepicker
       */

    }, {
      key: "_finishSelection",
      value: function _finishSelection() {
        this.setInputValue();
        this.close();
      }

      /**
       * Open Datepicker
       */

    }, {
      key: "open",
      value: function open() {
        if (this.isOpen) {
          return;
        }

        this.isOpen = true;
        if (typeof this.options.onOpen === 'function') {
          this.options.onOpen.call(this);
        }
        this.draw();
        this.modal.open();
        return this;
      }

      /**
       * Close Datepicker
       */

    }, {
      key: "close",
      value: function close() {
        if (!this.isOpen) {
          return;
        }

        this.isOpen = false;
        if (typeof this.options.onClose === 'function') {
          this.options.onClose.call(this);
        }
        this.modal.close();
        return this;
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Datepicker.__proto__ || Object.getPrototypeOf(Datepicker), "init", this).call(this, this, els, options);
      }
    }, {
      key: "_isDate",
      value: function _isDate(obj) {
        return (/Date/.test(Object.prototype.toString.call(obj)) && !isNaN(obj.getTime())
        );
      }
    }, {
      key: "_isWeekend",
      value: function _isWeekend(date) {
        var day = date.getDay();
        return day === 0 || day === 6;
      }
    }, {
      key: "_setToStartOfDay",
      value: function _setToStartOfDay(date) {
        if (Datepicker._isDate(date)) date.setHours(0, 0, 0, 0);
      }
    }, {
      key: "_getDaysInMonth",
      value: function _getDaysInMonth(year, month) {
        return [31, Datepicker._isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
      }
    }, {
      key: "_isLeapYear",
      value: function _isLeapYear(year) {
        // solution by Matti Virkkunen: http://stackoverflow.com/a/4881951
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
      }
    }, {
      key: "_compareDates",
      value: function _compareDates(a, b) {
        // weak date comparison (use setToStartOfDay(date) to ensure correct result)
        return a.getTime() === b.getTime();
      }
    }, {
      key: "_setToStartOfDay",
      value: function _setToStartOfDay(date) {
        if (Datepicker._isDate(date)) date.setHours(0, 0, 0, 0);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Datepicker;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Datepicker;
  }(Component);

  Datepicker._template = ['<div class= "modal datepicker-modal">', '<div class="modal-content datepicker-container">', '<div class="datepicker-date-display">', '<span class="year-text"></span>', '<span class="date-text"></span>', '</div>', '<div class="datepicker-calendar-container">', '<div class="datepicker-calendar"></div>', '<div class="datepicker-footer">', '<button class="btn-flat datepicker-clear waves-effect" style="visibility: hidden;" type="button"></button>', '<div class="confirmation-btns">', '<button class="btn-flat datepicker-cancel waves-effect" type="button"></button>', '<button class="btn-flat datepicker-done waves-effect" type="button"></button>', '</div>', '</div>', '</div>', '</div>', '</div>'].join('');

  M.Datepicker = Datepicker;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Datepicker, 'datepicker', 'M_Datepicker');
  }
})(cash);
;(function ($) {
  'use strict';

  var _defaults = {
    dialRadius: 135,
    outerRadius: 105,
    innerRadius: 70,
    tickRadius: 20,
    duration: 350,
    container: null,
    defaultTime: 'now', // default time, 'now' or '13:14' e.g.
    fromNow: 0, // Millisecond offset from the defaultTime
    showClearBtn: false,

    // internationalization
    i18n: {
      cancel: 'Cancel',
      clear: 'Clear',
      done: 'Ok'
    },

    autoClose: false, // auto close when minute is selected
    twelveHour: true, // change to 12 hour AM/PM clock from 24 hour
    vibrate: true, // vibrate the device when dragging clock hand

    // Callbacks
    onOpenStart: null,
    onOpenEnd: null,
    onCloseStart: null,
    onCloseEnd: null,
    onSelect: null
  };

  /**
   * @class
   *
   */

  var Timepicker = function (_Component16) {
    _inherits(Timepicker, _Component16);

    function Timepicker(el, options) {
      _classCallCheck(this, Timepicker);

      var _this57 = _possibleConstructorReturn(this, (Timepicker.__proto__ || Object.getPrototypeOf(Timepicker)).call(this, Timepicker, el, options));

      _this57.el.M_Timepicker = _this57;

      _this57.options = $.extend({}, Timepicker.defaults, options);

      _this57.id = M.guid();
      _this57._insertHTMLIntoDOM();
      _this57._setupModal();
      _this57._setupVariables();
      _this57._setupEventHandlers();

      _this57._clockSetup();
      _this57._pickerSetup();
      return _this57;
    }

    _createClass(Timepicker, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this.modal.destroy();
        $(this.modalEl).remove();
        this.el.M_Timepicker = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleInputKeydownBound = this._handleInputKeydown.bind(this);
        this._handleInputClickBound = this._handleInputClick.bind(this);
        this._handleClockClickStartBound = this._handleClockClickStart.bind(this);
        this._handleDocumentClickMoveBound = this._handleDocumentClickMove.bind(this);
        this._handleDocumentClickEndBound = this._handleDocumentClickEnd.bind(this);

        this.el.addEventListener('click', this._handleInputClickBound);
        this.el.addEventListener('keydown', this._handleInputKeydownBound);
        this.plate.addEventListener('mousedown', this._handleClockClickStartBound);
        this.plate.addEventListener('touchstart', this._handleClockClickStartBound);

        $(this.spanHours).on('click', this.showView.bind(this, 'hours'));
        $(this.spanMinutes).on('click', this.showView.bind(this, 'minutes'));
      }
    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('click', this._handleInputClickBound);
        this.el.removeEventListener('keydown', this._handleInputKeydownBound);
      }
    }, {
      key: "_handleInputClick",
      value: function _handleInputClick() {
        this.open();
      }
    }, {
      key: "_handleInputKeydown",
      value: function _handleInputKeydown(e) {
        if (e.which === M.keys.ENTER) {
          e.preventDefault();
          this.open();
        }
      }
    }, {
      key: "_handleClockClickStart",
      value: function _handleClockClickStart(e) {
        e.preventDefault();
        var clockPlateBR = this.plate.getBoundingClientRect();
        var offset = { x: clockPlateBR.left, y: clockPlateBR.top };

        this.x0 = offset.x + this.options.dialRadius;
        this.y0 = offset.y + this.options.dialRadius;
        this.moved = false;
        var clickPos = Timepicker._Pos(e);
        this.dx = clickPos.x - this.x0;
        this.dy = clickPos.y - this.y0;

        // Set clock hands
        this.setHand(this.dx, this.dy, false);

        // Mousemove on document
        document.addEventListener('mousemove', this._handleDocumentClickMoveBound);
        document.addEventListener('touchmove', this._handleDocumentClickMoveBound);

        // Mouseup on document
        document.addEventListener('mouseup', this._handleDocumentClickEndBound);
        document.addEventListener('touchend', this._handleDocumentClickEndBound);
      }
    }, {
      key: "_handleDocumentClickMove",
      value: function _handleDocumentClickMove(e) {
        e.preventDefault();
        var clickPos = Timepicker._Pos(e);
        var x = clickPos.x - this.x0;
        var y = clickPos.y - this.y0;
        this.moved = true;
        this.setHand(x, y, false, true);
      }
    }, {
      key: "_handleDocumentClickEnd",
      value: function _handleDocumentClickEnd(e) {
        var _this58 = this;

        e.preventDefault();
        document.removeEventListener('mouseup', this._handleDocumentClickEndBound);
        document.removeEventListener('touchend', this._handleDocumentClickEndBound);
        var clickPos = Timepicker._Pos(e);
        var x = clickPos.x - this.x0;
        var y = clickPos.y - this.y0;
        if (this.moved && x === this.dx && y === this.dy) {
          this.setHand(x, y);
        }

        if (this.currentView === 'hours') {
          this.showView('minutes', this.options.duration / 2);
        } else if (this.options.autoClose) {
          $(this.minutesView).addClass('timepicker-dial-out');
          setTimeout(function () {
            _this58.done();
          }, this.options.duration / 2);
        }

        if (typeof this.options.onSelect === 'function') {
          this.options.onSelect.call(this, this.hours, this.minutes);
        }

        // Unbind mousemove event
        document.removeEventListener('mousemove', this._handleDocumentClickMoveBound);
        document.removeEventListener('touchmove', this._handleDocumentClickMoveBound);
      }
    }, {
      key: "_insertHTMLIntoDOM",
      value: function _insertHTMLIntoDOM() {
        this.$modalEl = $(Timepicker._template);
        this.modalEl = this.$modalEl[0];
        this.modalEl.id = 'modal-' + this.id;

        // Append popover to input by default
        var containerEl = document.querySelector(this.options.container);
        if (this.options.container && !!containerEl) {
          this.$modalEl.appendTo(containerEl);
        } else {
          this.$modalEl.insertBefore(this.el);
        }
      }
    }, {
      key: "_setupModal",
      value: function _setupModal() {
        var _this59 = this;

        this.modal = M.Modal.init(this.modalEl, {
          onOpenStart: this.options.onOpenStart,
          onOpenEnd: this.options.onOpenEnd,
          onCloseStart: this.options.onCloseStart,
          onCloseEnd: function () {
            if (typeof _this59.options.onCloseEnd === 'function') {
              _this59.options.onCloseEnd.call(_this59);
            }
            _this59.isOpen = false;
          }
        });
      }
    }, {
      key: "_setupVariables",
      value: function _setupVariables() {
        this.currentView = 'hours';
        this.vibrate = navigator.vibrate ? 'vibrate' : navigator.webkitVibrate ? 'webkitVibrate' : null;

        this._canvas = this.modalEl.querySelector('.timepicker-canvas');
        this.plate = this.modalEl.querySelector('.timepicker-plate');

        this.hoursView = this.modalEl.querySelector('.timepicker-hours');
        this.minutesView = this.modalEl.querySelector('.timepicker-minutes');
        this.spanHours = this.modalEl.querySelector('.timepicker-span-hours');
        this.spanMinutes = this.modalEl.querySelector('.timepicker-span-minutes');
        this.spanAmPm = this.modalEl.querySelector('.timepicker-span-am-pm');
        this.footer = this.modalEl.querySelector('.timepicker-footer');
        this.amOrPm = 'PM';
      }
    }, {
      key: "_pickerSetup",
      value: function _pickerSetup() {
        var $clearBtn = $("<button class=\"btn-flat timepicker-clear waves-effect\" style=\"visibility: hidden;\" type=\"button\" tabindex=\"" + (this.options.twelveHour ? '3' : '1') + "\">" + this.options.i18n.clear + "</button>").appendTo(this.footer).on('click', this.clear.bind(this));
        if (this.options.showClearBtn) {
          $clearBtn.css({ visibility: '' });
        }

        var confirmationBtnsContainer = $('<div class="confirmation-btns"></div>');
        $('<button class="btn-flat timepicker-close waves-effect" type="button" tabindex="' + (this.options.twelveHour ? '3' : '1') + '">' + this.options.i18n.cancel + '</button>').appendTo(confirmationBtnsContainer).on('click', this.close.bind(this));
        $('<button class="btn-flat timepicker-close waves-effect" type="button" tabindex="' + (this.options.twelveHour ? '3' : '1') + '">' + this.options.i18n.done + '</button>').appendTo(confirmationBtnsContainer).on('click', this.done.bind(this));
        confirmationBtnsContainer.appendTo(this.footer);
      }
    }, {
      key: "_clockSetup",
      value: function _clockSetup() {
        if (this.options.twelveHour) {
          this.$amBtn = $('<div class="am-btn">AM</div>');
          this.$pmBtn = $('<div class="pm-btn">PM</div>');
          this.$amBtn.on('click', this._handleAmPmClick.bind(this)).appendTo(this.spanAmPm);
          this.$pmBtn.on('click', this._handleAmPmClick.bind(this)).appendTo(this.spanAmPm);
        }

        this._buildHoursView();
        this._buildMinutesView();
        this._buildSVGClock();
      }
    }, {
      key: "_buildSVGClock",
      value: function _buildSVGClock() {
        // Draw clock hands and others
        var dialRadius = this.options.dialRadius;
        var tickRadius = this.options.tickRadius;
        var diameter = dialRadius * 2;

        var svg = Timepicker._createSVGEl('svg');
        svg.setAttribute('class', 'timepicker-svg');
        svg.setAttribute('width', diameter);
        svg.setAttribute('height', diameter);
        var g = Timepicker._createSVGEl('g');
        g.setAttribute('transform', 'translate(' + dialRadius + ',' + dialRadius + ')');
        var bearing = Timepicker._createSVGEl('circle');
        bearing.setAttribute('class', 'timepicker-canvas-bearing');
        bearing.setAttribute('cx', 0);
        bearing.setAttribute('cy', 0);
        bearing.setAttribute('r', 4);
        var hand = Timepicker._createSVGEl('line');
        hand.setAttribute('x1', 0);
        hand.setAttribute('y1', 0);
        var bg = Timepicker._createSVGEl('circle');
        bg.setAttribute('class', 'timepicker-canvas-bg');
        bg.setAttribute('r', tickRadius);
        g.appendChild(hand);
        g.appendChild(bg);
        g.appendChild(bearing);
        svg.appendChild(g);
        this._canvas.appendChild(svg);

        this.hand = hand;
        this.bg = bg;
        this.bearing = bearing;
        this.g = g;
      }
    }, {
      key: "_buildHoursView",
      value: function _buildHoursView() {
        var $tick = $('<div class="timepicker-tick"></div>');
        // Hours view
        if (this.options.twelveHour) {
          for (var i = 1; i < 13; i += 1) {
            var tick = $tick.clone();
            var radian = i / 6 * Math.PI;
            var radius = this.options.outerRadius;
            tick.css({
              left: this.options.dialRadius + Math.sin(radian) * radius - this.options.tickRadius + 'px',
              top: this.options.dialRadius - Math.cos(radian) * radius - this.options.tickRadius + 'px'
            });
            tick.html(i === 0 ? '00' : i);
            this.hoursView.appendChild(tick[0]);
            // tick.on(mousedownEvent, mousedown);
          }
        } else {
          for (var _i2 = 0; _i2 < 24; _i2 += 1) {
            var _tick = $tick.clone();
            var _radian = _i2 / 6 * Math.PI;
            var inner = _i2 > 0 && _i2 < 13;
            var _radius = inner ? this.options.innerRadius : this.options.outerRadius;
            _tick.css({
              left: this.options.dialRadius + Math.sin(_radian) * _radius - this.options.tickRadius + 'px',
              top: this.options.dialRadius - Math.cos(_radian) * _radius - this.options.tickRadius + 'px'
            });
            _tick.html(_i2 === 0 ? '00' : _i2);
            this.hoursView.appendChild(_tick[0]);
            // tick.on(mousedownEvent, mousedown);
          }
        }
      }
    }, {
      key: "_buildMinutesView",
      value: function _buildMinutesView() {
        var $tick = $('<div class="timepicker-tick"></div>');
        // Minutes view
        for (var i = 0; i < 60; i += 5) {
          var tick = $tick.clone();
          var radian = i / 30 * Math.PI;
          tick.css({
            left: this.options.dialRadius + Math.sin(radian) * this.options.outerRadius - this.options.tickRadius + 'px',
            top: this.options.dialRadius - Math.cos(radian) * this.options.outerRadius - this.options.tickRadius + 'px'
          });
          tick.html(Timepicker._addLeadingZero(i));
          this.minutesView.appendChild(tick[0]);
        }
      }
    }, {
      key: "_handleAmPmClick",
      value: function _handleAmPmClick(e) {
        var $btnClicked = $(e.target);
        this.amOrPm = $btnClicked.hasClass('am-btn') ? 'AM' : 'PM';
        this._updateAmPmView();
      }
    }, {
      key: "_updateAmPmView",
      value: function _updateAmPmView() {
        if (this.options.twelveHour) {
          this.$amBtn.toggleClass('text-primary', this.amOrPm === 'AM');
          this.$pmBtn.toggleClass('text-primary', this.amOrPm === 'PM');
        }
      }
    }, {
      key: "_updateTimeFromInput",
      value: function _updateTimeFromInput() {
        // Get the time
        var value = ((this.el.value || this.options.defaultTime || '') + '').split(':');
        if (this.options.twelveHour && !(typeof value[1] === 'undefined')) {
          if (value[1].toUpperCase().indexOf('AM') > 0) {
            this.amOrPm = 'AM';
          } else {
            this.amOrPm = 'PM';
          }
          value[1] = value[1].replace('AM', '').replace('PM', '');
        }
        if (value[0] === 'now') {
          var now = new Date(+new Date() + this.options.fromNow);
          value = [now.getHours(), now.getMinutes()];
          if (this.options.twelveHour) {
            this.amOrPm = value[0] >= 12 && value[0] < 24 ? 'PM' : 'AM';
          }
        }
        this.hours = +value[0] || 0;
        this.minutes = +value[1] || 0;
        this.spanHours.innerHTML = this.hours;
        this.spanMinutes.innerHTML = Timepicker._addLeadingZero(this.minutes);

        this._updateAmPmView();
      }
    }, {
      key: "showView",
      value: function showView(view, delay) {
        if (view === 'minutes' && $(this.hoursView).css('visibility') === 'visible') {
          // raiseCallback(this.options.beforeHourSelect);
        }
        var isHours = view === 'hours',
            nextView = isHours ? this.hoursView : this.minutesView,
            hideView = isHours ? this.minutesView : this.hoursView;
        this.currentView = view;

        $(this.spanHours).toggleClass('text-primary', isHours);
        $(this.spanMinutes).toggleClass('text-primary', !isHours);

        // Transition view
        hideView.classList.add('timepicker-dial-out');
        $(nextView).css('visibility', 'visible').removeClass('timepicker-dial-out');

        // Reset clock hand
        this.resetClock(delay);

        // After transitions ended
        clearTimeout(this.toggleViewTimer);
        this.toggleViewTimer = setTimeout(function () {
          $(hideView).css('visibility', 'hidden');
        }, this.options.duration);
      }
    }, {
      key: "resetClock",
      value: function resetClock(delay) {
        var view = this.currentView,
            value = this[view],
            isHours = view === 'hours',
            unit = Math.PI / (isHours ? 6 : 30),
            radian = value * unit,
            radius = isHours && value > 0 && value < 13 ? this.options.innerRadius : this.options.outerRadius,
            x = Math.sin(radian) * radius,
            y = -Math.cos(radian) * radius,
            self = this;

        if (delay) {
          $(this.canvas).addClass('timepicker-canvas-out');
          setTimeout(function () {
            $(self.canvas).removeClass('timepicker-canvas-out');
            self.setHand(x, y);
          }, delay);
        } else {
          this.setHand(x, y);
        }
      }
    }, {
      key: "setHand",
      value: function setHand(x, y, roundBy5) {
        var _this60 = this;

        var radian = Math.atan2(x, -y),
            isHours = this.currentView === 'hours',
            unit = Math.PI / (isHours || roundBy5 ? 6 : 30),
            z = Math.sqrt(x * x + y * y),
            inner = isHours && z < (this.options.outerRadius + this.options.innerRadius) / 2,
            radius = inner ? this.options.innerRadius : this.options.outerRadius;

        if (this.options.twelveHour) {
          radius = this.options.outerRadius;
        }

        // Radian should in range [0, 2PI]
        if (radian < 0) {
          radian = Math.PI * 2 + radian;
        }

        // Get the round value
        var value = Math.round(radian / unit);

        // Get the round radian
        radian = value * unit;

        // Correct the hours or minutes
        if (this.options.twelveHour) {
          if (isHours) {
            if (value === 0) value = 12;
          } else {
            if (roundBy5) value *= 5;
            if (value === 60) value = 0;
          }
        } else {
          if (isHours) {
            if (value === 12) {
              value = 0;
            }
            value = inner ? value === 0 ? 12 : value : value === 0 ? 0 : value + 12;
          } else {
            if (roundBy5) {
              value *= 5;
            }
            if (value === 60) {
              value = 0;
            }
          }
        }

        // Once hours or minutes changed, vibrate the device
        if (this[this.currentView] !== value) {
          if (this.vibrate && this.options.vibrate) {
            // Do not vibrate too frequently
            if (!this.vibrateTimer) {
              navigator[this.vibrate](10);
              this.vibrateTimer = setTimeout(function () {
                _this60.vibrateTimer = null;
              }, 100);
            }
          }
        }

        this[this.currentView] = value;
        if (isHours) {
          this['spanHours'].innerHTML = value;
        } else {
          this['spanMinutes'].innerHTML = Timepicker._addLeadingZero(value);
        }

        // Set clock hand and others' position
        var cx1 = Math.sin(radian) * (radius - this.options.tickRadius),
            cy1 = -Math.cos(radian) * (radius - this.options.tickRadius),
            cx2 = Math.sin(radian) * radius,
            cy2 = -Math.cos(radian) * radius;
        this.hand.setAttribute('x2', cx1);
        this.hand.setAttribute('y2', cy1);
        this.bg.setAttribute('cx', cx2);
        this.bg.setAttribute('cy', cy2);
      }
    }, {
      key: "open",
      value: function open() {
        if (this.isOpen) {
          return;
        }

        this.isOpen = true;
        this._updateTimeFromInput();
        this.showView('hours');

        this.modal.open();
      }
    }, {
      key: "close",
      value: function close() {
        if (!this.isOpen) {
          return;
        }

        this.isOpen = false;
        this.modal.close();
      }

      /**
       * Finish timepicker selection.
       */

    }, {
      key: "done",
      value: function done(e, clearValue) {
        // Set input value
        var last = this.el.value;
        var value = clearValue ? '' : Timepicker._addLeadingZero(this.hours) + ':' + Timepicker._addLeadingZero(this.minutes);
        this.time = value;
        if (!clearValue && this.options.twelveHour) {
          value = value + " " + this.amOrPm;
        }
        this.el.value = value;

        // Trigger change event
        if (value !== last) {
          this.$el.trigger('change');
        }

        this.close();
        this.el.focus();
      }
    }, {
      key: "clear",
      value: function clear() {
        this.done(null, true);
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Timepicker.__proto__ || Object.getPrototypeOf(Timepicker), "init", this).call(this, this, els, options);
      }
    }, {
      key: "_addLeadingZero",
      value: function _addLeadingZero(num) {
        return (num < 10 ? '0' : '') + num;
      }
    }, {
      key: "_createSVGEl",
      value: function _createSVGEl(name) {
        var svgNS = 'http://www.w3.org/2000/svg';
        return document.createElementNS(svgNS, name);
      }

      /**
       * @typedef {Object} Point
       * @property {number} x The X Coordinate
       * @property {number} y The Y Coordinate
       */

      /**
       * Get x position of mouse or touch event
       * @param {Event} e
       * @return {Point} x and y location
       */

    }, {
      key: "_Pos",
      value: function _Pos(e) {
        if (e.targetTouches && e.targetTouches.length >= 1) {
          return { x: e.targetTouches[0].clientX, y: e.targetTouches[0].clientY };
        }
        // mouse event
        return { x: e.clientX, y: e.clientY };
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Timepicker;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Timepicker;
  }(Component);

  Timepicker._template = ['<div class= "modal timepicker-modal">', '<div class="modal-content timepicker-container">', '<div class="timepicker-digital-display">', '<div class="timepicker-text-container">', '<div class="timepicker-display-column">', '<span class="timepicker-span-hours text-primary"></span>', ':', '<span class="timepicker-span-minutes"></span>', '</div>', '<div class="timepicker-display-column timepicker-display-am-pm">', '<div class="timepicker-span-am-pm"></div>', '</div>', '</div>', '</div>', '<div class="timepicker-analog-display">', '<div class="timepicker-plate">', '<div class="timepicker-canvas"></div>', '<div class="timepicker-dial timepicker-hours"></div>', '<div class="timepicker-dial timepicker-minutes timepicker-dial-out"></div>', '</div>', '<div class="timepicker-footer"></div>', '</div>', '</div>', '</div>'].join('');

  M.Timepicker = Timepicker;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Timepicker, 'timepicker', 'M_Timepicker');
  }
})(cash);
;(function ($) {
  'use strict';

  var _defaults = {};

  /**
   * @class
   *
   */

  var CharacterCounter = function (_Component17) {
    _inherits(CharacterCounter, _Component17);

    /**
     * Construct CharacterCounter instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function CharacterCounter(el, options) {
      _classCallCheck(this, CharacterCounter);

      var _this61 = _possibleConstructorReturn(this, (CharacterCounter.__proto__ || Object.getPrototypeOf(CharacterCounter)).call(this, CharacterCounter, el, options));

      _this61.el.M_CharacterCounter = _this61;

      /**
       * Options for the character counter
       */
      _this61.options = $.extend({}, CharacterCounter.defaults, options);

      _this61.isInvalid = false;
      _this61.isValidLength = false;
      _this61._setupCounter();
      _this61._setupEventHandlers();
      return _this61;
    }

    _createClass(CharacterCounter, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this.el.CharacterCounter = undefined;
        this._removeCounter();
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleUpdateCounterBound = this.updateCounter.bind(this);

        this.el.addEventListener('focus', this._handleUpdateCounterBound, true);
        this.el.addEventListener('input', this._handleUpdateCounterBound, true);
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('focus', this._handleUpdateCounterBound, true);
        this.el.removeEventListener('input', this._handleUpdateCounterBound, true);
      }

      /**
       * Setup counter element
       */

    }, {
      key: "_setupCounter",
      value: function _setupCounter() {
        this.counterEl = document.createElement('span');
        $(this.counterEl).addClass('character-counter').css({
          float: 'right',
          'font-size': '12px',
          height: 1
        });

        this.$el.parent().append(this.counterEl);
      }

      /**
       * Remove counter element
       */

    }, {
      key: "_removeCounter",
      value: function _removeCounter() {
        $(this.counterEl).remove();
      }

      /**
       * Update counter
       */

    }, {
      key: "updateCounter",
      value: function updateCounter() {
        var maxLength = +this.$el.attr('data-length'),
            actualLength = this.el.value.length;
        this.isValidLength = actualLength <= maxLength;
        var counterString = actualLength;

        if (maxLength) {
          counterString += '/' + maxLength;
          this._validateInput();
        }

        $(this.counterEl).html(counterString);
      }

      /**
       * Add validation classes
       */

    }, {
      key: "_validateInput",
      value: function _validateInput() {
        if (this.isValidLength && this.isInvalid) {
          this.isInvalid = false;
          this.$el.removeClass('invalid');
        } else if (!this.isValidLength && !this.isInvalid) {
          this.isInvalid = true;
          this.$el.removeClass('valid');
          this.$el.addClass('invalid');
        }
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(CharacterCounter.__proto__ || Object.getPrototypeOf(CharacterCounter), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_CharacterCounter;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return CharacterCounter;
  }(Component);

  M.CharacterCounter = CharacterCounter;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(CharacterCounter, 'characterCounter', 'M_CharacterCounter');
  }
})(cash);
;(function ($) {
  'use strict';

  var _defaults = {
    duration: 200, // ms
    dist: -100, // zoom scale TODO: make this more intuitive as an option
    shift: 0, // spacing for center image
    padding: 0, // Padding between non center items
    numVisible: 5, // Number of visible items in carousel
    fullWidth: false, // Change to full width styles
    indicators: false, // Toggle indicators
    noWrap: false, // Don't wrap around and cycle through items.
    onCycleTo: null // Callback for when a new slide is cycled to.
  };

  /**
   * @class
   *
   */

  var Carousel = function (_Component18) {
    _inherits(Carousel, _Component18);

    /**
     * Construct Carousel instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Carousel(el, options) {
      _classCallCheck(this, Carousel);

      var _this62 = _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, Carousel, el, options));

      _this62.el.M_Carousel = _this62;

      /**
       * Options for the carousel
       * @member Carousel#options
       * @prop {Number} duration
       * @prop {Number} dist
       * @prop {Number} shift
       * @prop {Number} padding
       * @prop {Number} numVisible
       * @prop {Boolean} fullWidth
       * @prop {Boolean} indicators
       * @prop {Boolean} noWrap
       * @prop {Function} onCycleTo
       */
      _this62.options = $.extend({}, Carousel.defaults, options);

      // Setup
      _this62.hasMultipleSlides = _this62.$el.find('.carousel-item').length > 1;
      _this62.showIndicators = _this62.options.indicators && _this62.hasMultipleSlides;
      _this62.noWrap = _this62.options.noWrap || !_this62.hasMultipleSlides;
      _this62.pressed = false;
      _this62.dragged = false;
      _this62.offset = _this62.target = 0;
      _this62.images = [];
      _this62.itemWidth = _this62.$el.find('.carousel-item').first().innerWidth();
      _this62.itemHeight = _this62.$el.find('.carousel-item').first().innerHeight();
      _this62.dim = _this62.itemWidth * 2 + _this62.options.padding || 1; // Make sure dim is non zero for divisions.
      _this62._autoScrollBound = _this62._autoScroll.bind(_this62);
      _this62._trackBound = _this62._track.bind(_this62);

      // Full Width carousel setup
      if (_this62.options.fullWidth) {
        _this62.options.dist = 0;
        _this62._setCarouselHeight();

        // Offset fixed items when indicators.
        if (_this62.showIndicators) {
          _this62.$el.find('.carousel-fixed-item').addClass('with-indicators');
        }
      }

      // Iterate through slides
      _this62.$indicators = $('<ul class="indicators"></ul>');
      _this62.$el.find('.carousel-item').each(function (el, i) {
        _this62.images.push(el);
        if (_this62.showIndicators) {
          var $indicator = $('<li class="indicator-item"></li>');

          // Add active to first by default.
          if (i === 0) {
            $indicator[0].classList.add('active');
          }

          _this62.$indicators.append($indicator);
        }
      });
      if (_this62.showIndicators) {
        _this62.$el.append(_this62.$indicators);
      }
      _this62.count = _this62.images.length;

      // Cap numVisible at count
      _this62.options.numVisible = Math.min(_this62.count, _this62.options.numVisible);

      // Setup cross browser string
      _this62.xform = 'transform';
      ['webkit', 'Moz', 'O', 'ms'].every(function (prefix) {
        var e = prefix + 'Transform';
        if (typeof document.body.style[e] !== 'undefined') {
          _this62.xform = e;
          return false;
        }
        return true;
      });

      _this62._setupEventHandlers();
      _this62._scroll(_this62.offset);
      return _this62;
    }

    _createClass(Carousel, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this.el.M_Carousel = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        var _this63 = this;

        this._handleCarouselTapBound = this._handleCarouselTap.bind(this);
        this._handleCarouselDragBound = this._handleCarouselDrag.bind(this);
        this._handleCarouselReleaseBound = this._handleCarouselRelease.bind(this);
        this._handleCarouselClickBound = this._handleCarouselClick.bind(this);

        if (typeof window.ontouchstart !== 'undefined') {
          this.el.addEventListener('touchstart', this._handleCarouselTapBound);
          this.el.addEventListener('touchmove', this._handleCarouselDragBound);
          this.el.addEventListener('touchend', this._handleCarouselReleaseBound);
        }

        this.el.addEventListener('mousedown', this._handleCarouselTapBound);
        this.el.addEventListener('mousemove', this._handleCarouselDragBound);
        this.el.addEventListener('mouseup', this._handleCarouselReleaseBound);
        this.el.addEventListener('mouseleave', this._handleCarouselReleaseBound);
        this.el.addEventListener('click', this._handleCarouselClickBound);

        if (this.showIndicators && this.$indicators) {
          this._handleIndicatorClickBound = this._handleIndicatorClick.bind(this);
          this.$indicators.find('.indicator-item').each(function (el, i) {
            el.addEventListener('click', _this63._handleIndicatorClickBound);
          });
        }

        // Resize
        var throttledResize = M.throttle(this._handleResize, 200);
        this._handleThrottledResizeBound = throttledResize.bind(this);

        window.addEventListener('resize', this._handleThrottledResizeBound);
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        var _this64 = this;

        if (typeof window.ontouchstart !== 'undefined') {
          this.el.removeEventListener('touchstart', this._handleCarouselTapBound);
          this.el.removeEventListener('touchmove', this._handleCarouselDragBound);
          this.el.removeEventListener('touchend', this._handleCarouselReleaseBound);
        }
        this.el.removeEventListener('mousedown', this._handleCarouselTapBound);
        this.el.removeEventListener('mousemove', this._handleCarouselDragBound);
        this.el.removeEventListener('mouseup', this._handleCarouselReleaseBound);
        this.el.removeEventListener('mouseleave', this._handleCarouselReleaseBound);
        this.el.removeEventListener('click', this._handleCarouselClickBound);

        if (this.showIndicators && this.$indicators) {
          this.$indicators.find('.indicator-item').each(function (el, i) {
            el.removeEventListener('click', _this64._handleIndicatorClickBound);
          });
        }

        window.removeEventListener('resize', this._handleThrottledResizeBound);
      }

      /**
       * Handle Carousel Tap
       * @param {Event} e
       */

    }, {
      key: "_handleCarouselTap",
      value: function _handleCarouselTap(e) {
        // Fixes firefox draggable image bug
        if (e.type === 'mousedown' && $(e.target).is('img')) {
          e.preventDefault();
        }
        this.pressed = true;
        this.dragged = false;
        this.verticalDragged = false;
        this.reference = this._xpos(e);
        this.referenceY = this._ypos(e);

        this.velocity = this.amplitude = 0;
        this.frame = this.offset;
        this.timestamp = Date.now();
        clearInterval(this.ticker);
        this.ticker = setInterval(this._trackBound, 100);
      }

      /**
       * Handle Carousel Drag
       * @param {Event} e
       */

    }, {
      key: "_handleCarouselDrag",
      value: function _handleCarouselDrag(e) {
        var x = void 0,
            y = void 0,
            delta = void 0,
            deltaY = void 0;
        if (this.pressed) {
          x = this._xpos(e);
          y = this._ypos(e);
          delta = this.reference - x;
          deltaY = Math.abs(this.referenceY - y);
          if (deltaY < 30 && !this.verticalDragged) {
            // If vertical scrolling don't allow dragging.
            if (delta > 2 || delta < -2) {
              this.dragged = true;
              this.reference = x;
              this._scroll(this.offset + delta);
            }
          } else if (this.dragged) {
            // If dragging don't allow vertical scroll.
            e.preventDefault();
            e.stopPropagation();
            return false;
          } else {
            // Vertical scrolling.
            this.verticalDragged = true;
          }
        }

        if (this.dragged) {
          // If dragging don't allow vertical scroll.
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      }

      /**
       * Handle Carousel Release
       * @param {Event} e
       */

    }, {
      key: "_handleCarouselRelease",
      value: function _handleCarouselRelease(e) {
        if (this.pressed) {
          this.pressed = false;
        } else {
          return;
        }

        clearInterval(this.ticker);
        this.target = this.offset;
        if (this.velocity > 10 || this.velocity < -10) {
          this.amplitude = 0.9 * this.velocity;
          this.target = this.offset + this.amplitude;
        }
        this.target = Math.round(this.target / this.dim) * this.dim;

        // No wrap of items.
        if (this.noWrap) {
          if (this.target >= this.dim * (this.count - 1)) {
            this.target = this.dim * (this.count - 1);
          } else if (this.target < 0) {
            this.target = 0;
          }
        }
        this.amplitude = this.target - this.offset;
        this.timestamp = Date.now();
        requestAnimationFrame(this._autoScrollBound);

        if (this.dragged) {
          e.preventDefault();
          e.stopPropagation();
        }
        return false;
      }

      /**
       * Handle Carousel CLick
       * @param {Event} e
       */

    }, {
      key: "_handleCarouselClick",
      value: function _handleCarouselClick(e) {
        // Disable clicks if carousel was dragged.
        if (this.dragged) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        } else if (!this.options.fullWidth) {
          var clickedIndex = $(e.target).closest('.carousel-item').index();
          var diff = this._wrap(this.center) - clickedIndex;

          // Disable clicks if carousel was shifted by click
          if (diff !== 0) {
            e.preventDefault();
            e.stopPropagation();
          }
          this._cycleTo(clickedIndex);
        }
      }

      /**
       * Handle Indicator CLick
       * @param {Event} e
       */

    }, {
      key: "_handleIndicatorClick",
      value: function _handleIndicatorClick(e) {
        e.stopPropagation();

        var indicator = $(e.target).closest('.indicator-item');
        if (indicator.length) {
          this._cycleTo(indicator.index());
        }
      }

      /**
       * Handle Throttle Resize
       * @param {Event} e
       */

    }, {
      key: "_handleResize",
      value: function _handleResize(e) {
        if (this.options.fullWidth) {
          this.itemWidth = this.$el.find('.carousel-item').first().innerWidth();
          this.imageHeight = this.$el.find('.carousel-item.active').height();
          this.dim = this.itemWidth * 2 + this.options.padding;
          this.offset = this.center * 2 * this.itemWidth;
          this.target = this.offset;
          this._setCarouselHeight(true);
        } else {
          this._scroll();
        }
      }

      /**
       * Set carousel height based on first slide
       * @param {Booleam} imageOnly - true for image slides
       */

    }, {
      key: "_setCarouselHeight",
      value: function _setCarouselHeight(imageOnly) {
        var _this65 = this;

        var firstSlide = this.$el.find('.carousel-item.active').length ? this.$el.find('.carousel-item.active').first() : this.$el.find('.carousel-item').first();
        var firstImage = firstSlide.find('img').first();
        if (firstImage.length) {
          if (firstImage[0].complete) {
            // If image won't trigger the load event
            var imageHeight = firstImage.height();
            if (imageHeight > 0) {
              this.$el.css('height', imageHeight + 'px');
            } else {
              // If image still has no height, use the natural dimensions to calculate
              var naturalWidth = firstImage[0].naturalWidth;
              var naturalHeight = firstImage[0].naturalHeight;
              var adjustedHeight = this.$el.width() / naturalWidth * naturalHeight;
              this.$el.css('height', adjustedHeight + 'px');
            }
          } else {
            // Get height when image is loaded normally
            firstImage.one('load', function (el, i) {
              _this65.$el.css('height', el.offsetHeight + 'px');
            });
          }
        } else if (!imageOnly) {
          var slideHeight = firstSlide.height();
          this.$el.css('height', slideHeight + 'px');
        }
      }

      /**
       * Get x position from event
       * @param {Event} e
       */

    }, {
      key: "_xpos",
      value: function _xpos(e) {
        // touch event
        if (e.targetTouches && e.targetTouches.length >= 1) {
          return e.targetTouches[0].clientX;
        }

        // mouse event
        return e.clientX;
      }

      /**
       * Get y position from event
       * @param {Event} e
       */

    }, {
      key: "_ypos",
      value: function _ypos(e) {
        // touch event
        if (e.targetTouches && e.targetTouches.length >= 1) {
          return e.targetTouches[0].clientY;
        }

        // mouse event
        return e.clientY;
      }

      /**
       * Wrap index
       * @param {Number} x
       */

    }, {
      key: "_wrap",
      value: function _wrap(x) {
        return x >= this.count ? x % this.count : x < 0 ? this._wrap(this.count + x % this.count) : x;
      }

      /**
       * Tracks scrolling information
       */

    }, {
      key: "_track",
      value: function _track() {
        var now = void 0,
            elapsed = void 0,
            delta = void 0,
            v = void 0;

        now = Date.now();
        elapsed = now - this.timestamp;
        this.timestamp = now;
        delta = this.offset - this.frame;
        this.frame = this.offset;

        v = 1000 * delta / (1 + elapsed);
        this.velocity = 0.8 * v + 0.2 * this.velocity;
      }

      /**
       * Auto scrolls to nearest carousel item.
       */

    }, {
      key: "_autoScroll",
      value: function _autoScroll() {
        var elapsed = void 0,
            delta = void 0;

        if (this.amplitude) {
          elapsed = Date.now() - this.timestamp;
          delta = this.amplitude * Math.exp(-elapsed / this.options.duration);
          if (delta > 2 || delta < -2) {
            this._scroll(this.target - delta);
            requestAnimationFrame(this._autoScrollBound);
          } else {
            this._scroll(this.target);
          }
        }
      }

      /**
       * Scroll to target
       * @param {Number} x
       */

    }, {
      key: "_scroll",
      value: function _scroll(x) {
        var _this66 = this;

        // Track scrolling state
        if (!this.$el.hasClass('scrolling')) {
          this.el.classList.add('scrolling');
        }
        if (this.scrollingTimeout != null) {
          window.clearTimeout(this.scrollingTimeout);
        }
        this.scrollingTimeout = window.setTimeout(function () {
          _this66.$el.removeClass('scrolling');
        }, this.options.duration);

        // Start actual scroll
        var i = void 0,
            half = void 0,
            delta = void 0,
            dir = void 0,
            tween = void 0,
            el = void 0,
            alignment = void 0,
            zTranslation = void 0,
            tweenedOpacity = void 0,
            centerTweenedOpacity = void 0;
        var lastCenter = this.center;
        var numVisibleOffset = 1 / this.options.numVisible;

        this.offset = typeof x === 'number' ? x : this.offset;
        this.center = Math.floor((this.offset + this.dim / 2) / this.dim);
        delta = this.offset - this.center * this.dim;
        dir = delta < 0 ? 1 : -1;
        tween = -dir * delta * 2 / this.dim;
        half = this.count >> 1;

        if (this.options.fullWidth) {
          alignment = 'translateX(0)';
          centerTweenedOpacity = 1;
        } else {
          alignment = 'translateX(' + (this.el.clientWidth - this.itemWidth) / 2 + 'px) ';
          alignment += 'translateY(' + (this.el.clientHeight - this.itemHeight) / 2 + 'px)';
          centerTweenedOpacity = 1 - numVisibleOffset * tween;
        }

        // Set indicator active
        if (this.showIndicators) {
          var diff = this.center % this.count;
          var activeIndicator = this.$indicators.find('.indicator-item.active');
          if (activeIndicator.index() !== diff) {
            activeIndicator.removeClass('active');
            this.$indicators.find('.indicator-item').eq(diff)[0].classList.add('active');
          }
        }

        // center
        // Don't show wrapped items.
        if (!this.noWrap || this.center >= 0 && this.center < this.count) {
          el = this.images[this._wrap(this.center)];

          // Add active class to center item.
          if (!$(el).hasClass('active')) {
            this.$el.find('.carousel-item').removeClass('active');
            el.classList.add('active');
          }
          var transformString = alignment + " translateX(" + -delta / 2 + "px) translateX(" + dir * this.options.shift * tween * i + "px) translateZ(" + this.options.dist * tween + "px)";
          this._updateItemStyle(el, centerTweenedOpacity, 0, transformString);
        }

        for (i = 1; i <= half; ++i) {
          // right side
          if (this.options.fullWidth) {
            zTranslation = this.options.dist;
            tweenedOpacity = i === half && delta < 0 ? 1 - tween : 1;
          } else {
            zTranslation = this.options.dist * (i * 2 + tween * dir);
            tweenedOpacity = 1 - numVisibleOffset * (i * 2 + tween * dir);
          }
          // Don't show wrapped items.
          if (!this.noWrap || this.center + i < this.count) {
            el = this.images[this._wrap(this.center + i)];
            var _transformString = alignment + " translateX(" + (this.options.shift + (this.dim * i - delta) / 2) + "px) translateZ(" + zTranslation + "px)";
            this._updateItemStyle(el, tweenedOpacity, -i, _transformString);
          }

          // left side
          if (this.options.fullWidth) {
            zTranslation = this.options.dist;
            tweenedOpacity = i === half && delta > 0 ? 1 - tween : 1;
          } else {
            zTranslation = this.options.dist * (i * 2 - tween * dir);
            tweenedOpacity = 1 - numVisibleOffset * (i * 2 - tween * dir);
          }
          // Don't show wrapped items.
          if (!this.noWrap || this.center - i >= 0) {
            el = this.images[this._wrap(this.center - i)];
            var _transformString2 = alignment + " translateX(" + (-this.options.shift + (-this.dim * i - delta) / 2) + "px) translateZ(" + zTranslation + "px)";
            this._updateItemStyle(el, tweenedOpacity, -i, _transformString2);
          }
        }

        // center
        // Don't show wrapped items.
        if (!this.noWrap || this.center >= 0 && this.center < this.count) {
          el = this.images[this._wrap(this.center)];
          var _transformString3 = alignment + " translateX(" + -delta / 2 + "px) translateX(" + dir * this.options.shift * tween + "px) translateZ(" + this.options.dist * tween + "px)";
          this._updateItemStyle(el, centerTweenedOpacity, 0, _transformString3);
        }

        // onCycleTo callback
        var $currItem = this.$el.find('.carousel-item').eq(this._wrap(this.center));
        if (lastCenter !== this.center && typeof this.options.onCycleTo === 'function') {
          this.options.onCycleTo.call(this, $currItem[0], this.dragged);
        }

        // One time callback
        if (typeof this.oneTimeCallback === 'function') {
          this.oneTimeCallback.call(this, $currItem[0], this.dragged);
          this.oneTimeCallback = null;
        }
      }

      /**
       * Cycle to target
       * @param {Element} el
       * @param {Number} opacity
       * @param {Number} zIndex
       * @param {String} transform
       */

    }, {
      key: "_updateItemStyle",
      value: function _updateItemStyle(el, opacity, zIndex, transform) {
        el.style[this.xform] = transform;
        el.style.zIndex = zIndex;
        el.style.opacity = opacity;
        el.style.visibility = 'visible';
      }

      /**
       * Cycle to target
       * @param {Number} n
       * @param {Function} callback
       */

    }, {
      key: "_cycleTo",
      value: function _cycleTo(n, callback) {
        var diff = this.center % this.count - n;

        // Account for wraparound.
        if (!this.noWrap) {
          if (diff < 0) {
            if (Math.abs(diff + this.count) < Math.abs(diff)) {
              diff += this.count;
            }
          } else if (diff > 0) {
            if (Math.abs(diff - this.count) < diff) {
              diff -= this.count;
            }
          }
        }

        this.target = this.dim * Math.round(this.offset / this.dim);
        // Next
        if (diff < 0) {
          this.target += this.dim * Math.abs(diff);

          // Prev
        } else if (diff > 0) {
          this.target -= this.dim * diff;
        }

        // Set one time callback
        if (typeof callback === 'function') {
          this.oneTimeCallback = callback;
        }

        // Scroll
        if (this.offset !== this.target) {
          this.amplitude = this.target - this.offset;
          this.timestamp = Date.now();
          requestAnimationFrame(this._autoScrollBound);
        }
      }

      /**
       * Cycle to next item
       * @param {Number} [n]
       */

    }, {
      key: "next",
      value: function next(n) {
        if (n === undefined || isNaN(n)) {
          n = 1;
        }

        var index = this.center + n;
        if (index >= this.count || index < 0) {
          if (this.noWrap) {
            return;
          }

          index = this._wrap(index);
        }
        this._cycleTo(index);
      }

      /**
       * Cycle to previous item
       * @param {Number} [n]
       */

    }, {
      key: "prev",
      value: function prev(n) {
        if (n === undefined || isNaN(n)) {
          n = 1;
        }

        var index = this.center - n;
        if (index >= this.count || index < 0) {
          if (this.noWrap) {
            return;
          }

          index = this._wrap(index);
        }

        this._cycleTo(index);
      }

      /**
       * Cycle to nth item
       * @param {Number} [n]
       * @param {Function} callback
       */

    }, {
      key: "set",
      value: function set(n, callback) {
        if (n === undefined || isNaN(n)) {
          n = 0;
        }

        if (n > this.count || n < 0) {
          if (this.noWrap) {
            return;
          }

          n = this._wrap(n);
        }

        this._cycleTo(n, callback);
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Carousel.__proto__ || Object.getPrototypeOf(Carousel), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Carousel;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Carousel;
  }(Component);

  M.Carousel = Carousel;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Carousel, 'carousel', 'M_Carousel');
  }
})(cash);
;(function ($) {
  'use strict';

  var _defaults = {
    onOpen: undefined,
    onClose: undefined
  };

  /**
   * @class
   *
   */

  var TapTarget = function (_Component19) {
    _inherits(TapTarget, _Component19);

    /**
     * Construct TapTarget instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function TapTarget(el, options) {
      _classCallCheck(this, TapTarget);

      var _this67 = _possibleConstructorReturn(this, (TapTarget.__proto__ || Object.getPrototypeOf(TapTarget)).call(this, TapTarget, el, options));

      _this67.el.M_TapTarget = _this67;

      /**
       * Options for the select
       * @member TapTarget#options
       * @prop {Function} onOpen - Callback function called when feature discovery is opened
       * @prop {Function} onClose - Callback function called when feature discovery is closed
       */
      _this67.options = $.extend({}, TapTarget.defaults, options);

      _this67.isOpen = false;

      // setup
      _this67.$origin = $('#' + _this67.$el.attr('data-target'));
      _this67._setup();

      _this67._calculatePositioning();
      _this67._setupEventHandlers();
      return _this67;
    }

    _createClass(TapTarget, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this.el.TapTarget = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleDocumentClickBound = this._handleDocumentClick.bind(this);
        this._handleTargetClickBound = this._handleTargetClick.bind(this);
        this._handleOriginClickBound = this._handleOriginClick.bind(this);

        this.el.addEventListener('click', this._handleTargetClickBound);
        this.originEl.addEventListener('click', this._handleOriginClickBound);

        // Resize
        var throttledResize = M.throttle(this._handleResize, 200);
        this._handleThrottledResizeBound = throttledResize.bind(this);

        window.addEventListener('resize', this._handleThrottledResizeBound);
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('click', this._handleTargetClickBound);
        this.originEl.removeEventListener('click', this._handleOriginClickBound);
        window.removeEventListener('resize', this._handleThrottledResizeBound);
      }

      /**
       * Handle Target Click
       * @param {Event} e
       */

    }, {
      key: "_handleTargetClick",
      value: function _handleTargetClick(e) {
        this.open();
      }

      /**
       * Handle Origin Click
       * @param {Event} e
       */

    }, {
      key: "_handleOriginClick",
      value: function _handleOriginClick(e) {
        this.close();
      }

      /**
       * Handle Resize
       * @param {Event} e
       */

    }, {
      key: "_handleResize",
      value: function _handleResize(e) {
        this._calculatePositioning();
      }

      /**
       * Handle Resize
       * @param {Event} e
       */

    }, {
      key: "_handleDocumentClick",
      value: function _handleDocumentClick(e) {
        if (!$(e.target).closest('.tap-target-wrapper').length) {
          this.close();
          e.preventDefault();
          e.stopPropagation();
        }
      }

      /**
       * Setup Tap Target
       */

    }, {
      key: "_setup",
      value: function _setup() {
        // Creating tap target
        this.wrapper = this.$el.parent()[0];
        this.waveEl = $(this.wrapper).find('.tap-target-wave')[0];
        this.originEl = $(this.wrapper).find('.tap-target-origin')[0];
        this.contentEl = this.$el.find('.tap-target-content')[0];

        // Creating wrapper
        if (!$(this.wrapper).hasClass('.tap-target-wrapper')) {
          this.wrapper = document.createElement('div');
          this.wrapper.classList.add('tap-target-wrapper');
          this.$el.before($(this.wrapper));
          this.wrapper.append(this.el);
        }

        // Creating content
        if (!this.contentEl) {
          this.contentEl = document.createElement('div');
          this.contentEl.classList.add('tap-target-content');
          this.$el.append(this.contentEl);
        }

        // Creating foreground wave
        if (!this.waveEl) {
          this.waveEl = document.createElement('div');
          this.waveEl.classList.add('tap-target-wave');

          // Creating origin
          if (!this.originEl) {
            this.originEl = this.$origin.clone(true, true);
            this.originEl.addClass('tap-target-origin');
            this.originEl.removeAttr('id');
            this.originEl.removeAttr('style');
            this.originEl = this.originEl[0];
            this.waveEl.append(this.originEl);
          }

          this.wrapper.append(this.waveEl);
        }
      }

      /**
       * Calculate positioning
       */

    }, {
      key: "_calculatePositioning",
      value: function _calculatePositioning() {
        // Element or parent is fixed position?
        var isFixed = this.$origin.css('position') === 'fixed';
        if (!isFixed) {
          var parents = this.$origin.parents();
          for (var i = 0; i < parents.length; i++) {
            isFixed = $(parents[i]).css('position') == 'fixed';
            if (isFixed) {
              break;
            }
          }
        }

        // Calculating origin
        var originWidth = this.$origin.outerWidth();
        var originHeight = this.$origin.outerHeight();
        var originTop = isFixed ? this.$origin.offset().top - M.getDocumentScrollTop() : this.$origin.offset().top;
        var originLeft = isFixed ? this.$origin.offset().left - M.getDocumentScrollLeft() : this.$origin.offset().left;

        // Calculating screen
        var windowWidth = window.innerWidth;
        var windowHeight = window.innerHeight;
        var centerX = windowWidth / 2;
        var centerY = windowHeight / 2;
        var isLeft = originLeft <= centerX;
        var isRight = originLeft > centerX;
        var isTop = originTop <= centerY;
        var isBottom = originTop > centerY;
        var isCenterX = originLeft >= windowWidth * 0.25 && originLeft <= windowWidth * 0.75;

        // Calculating tap target
        var tapTargetWidth = this.$el.outerWidth();
        var tapTargetHeight = this.$el.outerHeight();
        var tapTargetTop = originTop + originHeight / 2 - tapTargetHeight / 2;
        var tapTargetLeft = originLeft + originWidth / 2 - tapTargetWidth / 2;
        var tapTargetPosition = isFixed ? 'fixed' : 'absolute';

        // Calculating content
        var tapTargetTextWidth = isCenterX ? tapTargetWidth : tapTargetWidth / 2 + originWidth;
        var tapTargetTextHeight = tapTargetHeight / 2;
        var tapTargetTextTop = isTop ? tapTargetHeight / 2 : 0;
        var tapTargetTextBottom = 0;
        var tapTargetTextLeft = isLeft && !isCenterX ? tapTargetWidth / 2 - originWidth : 0;
        var tapTargetTextRight = 0;
        var tapTargetTextPadding = originWidth;
        var tapTargetTextAlign = isBottom ? 'bottom' : 'top';

        // Calculating wave
        var tapTargetWaveWidth = originWidth > originHeight ? originWidth * 2 : originWidth * 2;
        var tapTargetWaveHeight = tapTargetWaveWidth;
        var tapTargetWaveTop = tapTargetHeight / 2 - tapTargetWaveHeight / 2;
        var tapTargetWaveLeft = tapTargetWidth / 2 - tapTargetWaveWidth / 2;

        // Setting tap target
        var tapTargetWrapperCssObj = {};
        tapTargetWrapperCssObj.top = isTop ? tapTargetTop + 'px' : '';
        tapTargetWrapperCssObj.right = isRight ? windowWidth - tapTargetLeft - tapTargetWidth + 'px' : '';
        tapTargetWrapperCssObj.bottom = isBottom ? windowHeight - tapTargetTop - tapTargetHeight + 'px' : '';
        tapTargetWrapperCssObj.left = isLeft ? tapTargetLeft + 'px' : '';
        tapTargetWrapperCssObj.position = tapTargetPosition;
        $(this.wrapper).css(tapTargetWrapperCssObj);

        // Setting content
        $(this.contentEl).css({
          width: tapTargetTextWidth + 'px',
          height: tapTargetTextHeight + 'px',
          top: tapTargetTextTop + 'px',
          right: tapTargetTextRight + 'px',
          bottom: tapTargetTextBottom + 'px',
          left: tapTargetTextLeft + 'px',
          padding: tapTargetTextPadding + 'px',
          verticalAlign: tapTargetTextAlign
        });

        // Setting wave
        $(this.waveEl).css({
          top: tapTargetWaveTop + 'px',
          left: tapTargetWaveLeft + 'px',
          width: tapTargetWaveWidth + 'px',
          height: tapTargetWaveHeight + 'px'
        });
      }

      /**
       * Open TapTarget
       */

    }, {
      key: "open",
      value: function open() {
        if (this.isOpen) {
          return;
        }

        // onOpen callback
        if (typeof this.options.onOpen === 'function') {
          this.options.onOpen.call(this, this.$origin[0]);
        }

        this.isOpen = true;
        this.wrapper.classList.add('open');

        document.body.addEventListener('click', this._handleDocumentClickBound, true);
        document.body.addEventListener('touchend', this._handleDocumentClickBound);
      }

      /**
       * Close Tap Target
       */

    }, {
      key: "close",
      value: function close() {
        if (!this.isOpen) {
          return;
        }

        // onClose callback
        if (typeof this.options.onClose === 'function') {
          this.options.onClose.call(this, this.$origin[0]);
        }

        this.isOpen = false;
        this.wrapper.classList.remove('open');

        document.body.removeEventListener('click', this._handleDocumentClickBound, true);
        document.body.removeEventListener('touchend', this._handleDocumentClickBound);
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(TapTarget.__proto__ || Object.getPrototypeOf(TapTarget), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_TapTarget;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return TapTarget;
  }(Component);

  M.TapTarget = TapTarget;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(TapTarget, 'tapTarget', 'M_TapTarget');
  }
})(cash);
;(function ($) {
  'use strict';

  var _defaults = {
    classes: '',
    dropdownOptions: {}
  };

  /**
   * @class
   *
   */

  var FormSelect = function (_Component20) {
    _inherits(FormSelect, _Component20);

    /**
     * Construct FormSelect instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function FormSelect(el, options) {
      _classCallCheck(this, FormSelect);

      // Don't init if browser default version
      var _this68 = _possibleConstructorReturn(this, (FormSelect.__proto__ || Object.getPrototypeOf(FormSelect)).call(this, FormSelect, el, options));

      if (_this68.$el.hasClass('browser-default')) {
        return _possibleConstructorReturn(_this68);
      }

      _this68.el.M_FormSelect = _this68;

      /**
       * Options for the select
       * @member FormSelect#options
       */
      _this68.options = $.extend({}, FormSelect.defaults, options);

      _this68.isMultiple = _this68.$el.prop('multiple');

      // Setup
      _this68.el.tabIndex = -1;
      _this68._keysSelected = {};
      _this68._valueDict = {}; // Maps key to original and generated option element.
      _this68._setupDropdown();

      _this68._setupEventHandlers();
      return _this68;
    }

    _createClass(FormSelect, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this._removeDropdown();
        this.el.M_FormSelect = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        var _this69 = this;

        this._handleSelectChangeBound = this._handleSelectChange.bind(this);
        this._handleOptionClickBound = this._handleOptionClick.bind(this);
        this._handleInputClickBound = this._handleInputClick.bind(this);

        $(this.dropdownOptions).find('li:not(.optgroup)').each(function (el) {
          el.addEventListener('click', _this69._handleOptionClickBound);
        });
        this.el.addEventListener('change', this._handleSelectChangeBound);
        this.input.addEventListener('click', this._handleInputClickBound);
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        var _this70 = this;

        $(this.dropdownOptions).find('li:not(.optgroup)').each(function (el) {
          el.removeEventListener('click', _this70._handleOptionClickBound);
        });
        this.el.removeEventListener('change', this._handleSelectChangeBound);
        this.input.removeEventListener('click', this._handleInputClickBound);
      }

      /**
       * Handle Select Change
       * @param {Event} e
       */

    }, {
      key: "_handleSelectChange",
      value: function _handleSelectChange(e) {
        this._setValueToInput();
      }

      /**
       * Handle Option Click
       * @param {Event} e
       */

    }, {
      key: "_handleOptionClick",
      value: function _handleOptionClick(e) {
        e.preventDefault();
        var option = $(e.target).closest('li')[0];
        var key = option.id;
        if (!$(option).hasClass('disabled') && !$(option).hasClass('optgroup') && key.length) {
          var selected = true;

          if (this.isMultiple) {
            // Deselect placeholder option if still selected.
            var placeholderOption = $(this.dropdownOptions).find('li.disabled.selected');
            if (placeholderOption.length) {
              placeholderOption.removeClass('selected');
              placeholderOption.find('input[type="checkbox"]').prop('checked', false);
              this._toggleEntryFromArray(placeholderOption[0].id);
            }
            selected = this._toggleEntryFromArray(key);
          } else {
            $(this.dropdownOptions).find('li').removeClass('selected');
            $(option).toggleClass('selected', selected);
          }

          // Set selected on original select option
          // Only trigger if selected state changed
          var prevSelected = $(this._valueDict[key].el).prop('selected');
          if (prevSelected !== selected) {
            $(this._valueDict[key].el).prop('selected', selected);
            this.$el.trigger('change');
          }
        }

        e.stopPropagation();
      }

      /**
       * Handle Input Click
       */

    }, {
      key: "_handleInputClick",
      value: function _handleInputClick() {
        if (this.dropdown && this.dropdown.isOpen) {
          this._setValueToInput();
          this._setSelectedStates();
        }
      }

      /**
       * Setup dropdown
       */

    }, {
      key: "_setupDropdown",
      value: function _setupDropdown() {
        var _this71 = this;

        this.wrapper = document.createElement('div');
        $(this.wrapper).addClass('select-wrapper ' + this.options.classes);
        this.$el.before($(this.wrapper));
        this.wrapper.appendChild(this.el);

        if (this.el.disabled) {
          this.wrapper.classList.add('disabled');
        }

        // Create dropdown
        this.$selectOptions = this.$el.children('option, optgroup');
        this.dropdownOptions = document.createElement('ul');
        this.dropdownOptions.id = "select-options-" + M.guid();
        $(this.dropdownOptions).addClass('dropdown-content select-dropdown ' + (this.isMultiple ? 'multiple-select-dropdown' : ''));

        // Create dropdown structure.
        if (this.$selectOptions.length) {
          this.$selectOptions.each(function (el) {
            if ($(el).is('option')) {
              // Direct descendant option.
              var optionEl = void 0;
              if (_this71.isMultiple) {
                optionEl = _this71._appendOptionWithIcon(_this71.$el, el, 'multiple');
              } else {
                optionEl = _this71._appendOptionWithIcon(_this71.$el, el);
              }

              _this71._addOptionToValueDict(el, optionEl);
            } else if ($(el).is('optgroup')) {
              // Optgroup.
              var selectOptions = $(el).children('option');
              $(_this71.dropdownOptions).append($('<li class="optgroup"><span>' + el.getAttribute('label') + '</span></li>')[0]);

              selectOptions.each(function (el) {
                var optionEl = _this71._appendOptionWithIcon(_this71.$el, el, 'optgroup-option');
                _this71._addOptionToValueDict(el, optionEl);
              });
            }
          });
        }

        this.$el.after(this.dropdownOptions);

        // Add input dropdown
        this.input = document.createElement('input');
        $(this.input).addClass('select-dropdown dropdown-trigger');
        this.input.setAttribute('type', 'text');
        this.input.setAttribute('readonly', 'true');
        this.input.setAttribute('data-target', this.dropdownOptions.id);
        if (this.el.disabled) {
          $(this.input).prop('disabled', 'true');
        }

        this.$el.before(this.input);
        this._setValueToInput();

        // Add caret
        var dropdownIcon = $('<svg class="caret" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/><path d="M0 0h24v24H0z" fill="none"/></svg>');
        this.$el.before(dropdownIcon[0]);

        // Initialize dropdown
        if (!this.el.disabled) {
          var dropdownOptions = $.extend({}, this.options.dropdownOptions);

          // Add callback for centering selected option when dropdown content is scrollable
          dropdownOptions.onOpenEnd = function (el) {
            var selectedOption = $(_this71.dropdownOptions).find('.selected').first();
            if (_this71.dropdown.isScrollable && selectedOption.length) {
              var scrollOffset = selectedOption[0].getBoundingClientRect().top - _this71.dropdownOptions.getBoundingClientRect().top; // scroll to selected option
              scrollOffset -= _this71.dropdownOptions.clientHeight / 2; // center in dropdown
              _this71.dropdownOptions.scrollTop = scrollOffset;
            }
          };

          if (this.isMultiple) {
            dropdownOptions.closeOnClick = false;
          }
          this.dropdown = M.Dropdown.init(this.input, dropdownOptions);
        }

        // Add initial selections
        this._setSelectedStates();
      }

      /**
       * Add option to value dict
       * @param {Element} el  original option element
       * @param {Element} optionEl  generated option element
       */

    }, {
      key: "_addOptionToValueDict",
      value: function _addOptionToValueDict(el, optionEl) {
        var index = Object.keys(this._valueDict).length;
        var key = this.dropdownOptions.id + index;
        var obj = {};
        optionEl.id = key;

        obj.el = el;
        obj.optionEl = optionEl;
        this._valueDict[key] = obj;
      }

      /**
       * Remove dropdown
       */

    }, {
      key: "_removeDropdown",
      value: function _removeDropdown() {
        $(this.wrapper).find('.caret').remove();
        $(this.input).remove();
        $(this.dropdownOptions).remove();
        $(this.wrapper).before(this.$el);
        $(this.wrapper).remove();
      }

      /**
       * Setup dropdown
       * @param {Element} select  select element
       * @param {Element} option  option element from select
       * @param {String} type
       * @return {Element}  option element added
       */

    }, {
      key: "_appendOptionWithIcon",
      value: function _appendOptionWithIcon(select, option, type) {
        // Add disabled attr if disabled
        var disabledClass = option.disabled ? 'disabled ' : '';
        var optgroupClass = type === 'optgroup-option' ? 'optgroup-option ' : '';
        var multipleCheckbox = this.isMultiple ? "<label><input type=\"checkbox\"" + disabledClass + "\"/><span>" + option.innerHTML + "</span></label>" : option.innerHTML;
        var liEl = $('<li></li>');
        var spanEl = $('<span></span>');
        spanEl.html(multipleCheckbox);
        liEl.addClass(disabledClass + " " + optgroupClass);
        liEl.append(spanEl);

        // add icons
        var iconUrl = option.getAttribute('data-icon');
        if (!!iconUrl) {
          var imgEl = $("<img alt=\"\" src=\"" + iconUrl + "\">");
          liEl.prepend(imgEl);
        }

        // Check for multiple type.
        $(this.dropdownOptions).append(liEl[0]);
        return liEl[0];
      }

      /**
       * Toggle entry from option
       * @param {String} key  Option key
       * @return {Boolean}  if entry was added or removed
       */

    }, {
      key: "_toggleEntryFromArray",
      value: function _toggleEntryFromArray(key) {
        var notAdded = !this._keysSelected.hasOwnProperty(key);
        var $optionLi = $(this._valueDict[key].optionEl);

        if (notAdded) {
          this._keysSelected[key] = true;
        } else {
          delete this._keysSelected[key];
        }

        $optionLi.toggleClass('selected', notAdded);

        // Set checkbox checked value
        $optionLi.find('input[type="checkbox"]').prop('checked', notAdded);

        // use notAdded instead of true (to detect if the option is selected or not)
        $optionLi.prop('selected', notAdded);

        return notAdded;
      }

      /**
       * Set text value to input
       */

    }, {
      key: "_setValueToInput",
      value: function _setValueToInput() {
        var values = [];
        var options = this.$el.find('option');

        options.each(function (el) {
          if ($(el).prop('selected')) {
            var text = $(el).text();
            values.push(text);
          }
        });

        if (!values.length) {
          var firstDisabled = this.$el.find('option:disabled').eq(0);
          if (firstDisabled.length && firstDisabled[0].value === '') {
            values.push(firstDisabled.text());
          }
        }

        this.input.value = values.join(', ');
      }

      /**
       * Set selected state of dropdown to match actual select element
       */

    }, {
      key: "_setSelectedStates",
      value: function _setSelectedStates() {
        this._keysSelected = {};

        for (var key in this._valueDict) {
          var option = this._valueDict[key];
          var optionIsSelected = $(option.el).prop('selected');
          $(option.optionEl).find('input[type="checkbox"]').prop('checked', optionIsSelected);
          if (optionIsSelected) {
            this._activateOption($(this.dropdownOptions), $(option.optionEl));
            this._keysSelected[key] = true;
          } else {
            $(option.optionEl).removeClass('selected');
          }
        }
      }

      /**
       * Make option as selected and scroll to selected position
       * @param {jQuery} collection  Select options jQuery element
       * @param {Element} newOption  element of the new option
       */

    }, {
      key: "_activateOption",
      value: function _activateOption(collection, newOption) {
        if (newOption) {
          if (!this.isMultiple) {
            collection.find('li.selected').removeClass('selected');
          }
          var option = $(newOption);
          option.addClass('selected');
        }
      }

      /**
       * Get Selected Values
       * @return {Array}  Array of selected values
       */

    }, {
      key: "getSelectedValues",
      value: function getSelectedValues() {
        var selectedValues = [];
        for (var key in this._keysSelected) {
          selectedValues.push(this._valueDict[key].el.value);
        }
        return selectedValues;
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(FormSelect.__proto__ || Object.getPrototypeOf(FormSelect), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_FormSelect;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return FormSelect;
  }(Component);

  M.FormSelect = FormSelect;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(FormSelect, 'formSelect', 'M_FormSelect');
  }
})(cash);
;(function ($, anim) {
  'use strict';

  var _defaults = {};

  /**
   * @class
   *
   */

  var Range = function (_Component21) {
    _inherits(Range, _Component21);

    /**
     * Construct Range instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */
    function Range(el, options) {
      _classCallCheck(this, Range);

      var _this72 = _possibleConstructorReturn(this, (Range.__proto__ || Object.getPrototypeOf(Range)).call(this, Range, el, options));

      _this72.el.M_Range = _this72;

      /**
       * Options for the range
       * @member Range#options
       */
      _this72.options = $.extend({}, Range.defaults, options);

      _this72._mousedown = false;

      // Setup
      _this72._setupThumb();

      _this72._setupEventHandlers();
      return _this72;
    }

    _createClass(Range, [{
      key: "destroy",


      /**
       * Teardown component
       */
      value: function destroy() {
        this._removeEventHandlers();
        this._removeThumb();
        this.el.M_Range = undefined;
      }

      /**
       * Setup Event Handlers
       */

    }, {
      key: "_setupEventHandlers",
      value: function _setupEventHandlers() {
        this._handleRangeChangeBound = this._handleRangeChange.bind(this);
        this._handleRangeMousedownTouchstartBound = this._handleRangeMousedownTouchstart.bind(this);
        this._handleRangeInputMousemoveTouchmoveBound = this._handleRangeInputMousemoveTouchmove.bind(this);
        this._handleRangeMouseupTouchendBound = this._handleRangeMouseupTouchend.bind(this);
        this._handleRangeBlurMouseoutTouchleaveBound = this._handleRangeBlurMouseoutTouchleave.bind(this);

        this.el.addEventListener('change', this._handleRangeChangeBound);

        this.el.addEventListener('mousedown', this._handleRangeMousedownTouchstartBound);
        this.el.addEventListener('touchstart', this._handleRangeMousedownTouchstartBound);

        this.el.addEventListener('input', this._handleRangeInputMousemoveTouchmoveBound);
        this.el.addEventListener('mousemove', this._handleRangeInputMousemoveTouchmoveBound);
        this.el.addEventListener('touchmove', this._handleRangeInputMousemoveTouchmoveBound);

        this.el.addEventListener('mouseup', this._handleRangeMouseupTouchendBound);
        this.el.addEventListener('touchend', this._handleRangeMouseupTouchendBound);

        this.el.addEventListener('blur', this._handleRangeBlurMouseoutTouchleaveBound);
        this.el.addEventListener('mouseout', this._handleRangeBlurMouseoutTouchleaveBound);
        this.el.addEventListener('touchleave', this._handleRangeBlurMouseoutTouchleaveBound);
      }

      /**
       * Remove Event Handlers
       */

    }, {
      key: "_removeEventHandlers",
      value: function _removeEventHandlers() {
        this.el.removeEventListener('change', this._handleRangeChangeBound);

        this.el.removeEventListener('mousedown', this._handleRangeMousedownTouchstartBound);
        this.el.removeEventListener('touchstart', this._handleRangeMousedownTouchstartBound);

        this.el.removeEventListener('input', this._handleRangeInputMousemoveTouchmoveBound);
        this.el.removeEventListener('mousemove', this._handleRangeInputMousemoveTouchmoveBound);
        this.el.removeEventListener('touchmove', this._handleRangeInputMousemoveTouchmoveBound);

        this.el.removeEventListener('mouseup', this._handleRangeMouseupTouchendBound);
        this.el.removeEventListener('touchend', this._handleRangeMouseupTouchendBound);

        this.el.removeEventListener('blur', this._handleRangeBlurMouseoutTouchleaveBound);
        this.el.removeEventListener('mouseout', this._handleRangeBlurMouseoutTouchleaveBound);
        this.el.removeEventListener('touchleave', this._handleRangeBlurMouseoutTouchleaveBound);
      }

      /**
       * Handle Range Change
       * @param {Event} e
       */

    }, {
      key: "_handleRangeChange",
      value: function _handleRangeChange() {
        $(this.value).html(this.$el.val());

        if (!$(this.thumb).hasClass('active')) {
          this._showRangeBubble();
        }

        var offsetLeft = this._calcRangeOffset();
        $(this.thumb).addClass('active').css('left', offsetLeft + 'px');
      }

      /**
       * Handle Range Mousedown and Touchstart
       * @param {Event} e
       */

    }, {
      key: "_handleRangeMousedownTouchstart",
      value: function _handleRangeMousedownTouchstart(e) {
        // Set indicator value
        $(this.value).html(this.$el.val());

        this._mousedown = true;
        this.$el.addClass('active');

        if (!$(this.thumb).hasClass('active')) {
          this._showRangeBubble();
        }

        if (e.type !== 'input') {
          var offsetLeft = this._calcRangeOffset();
          $(this.thumb).addClass('active').css('left', offsetLeft + 'px');
        }
      }

      /**
       * Handle Range Input, Mousemove and Touchmove
       */

    }, {
      key: "_handleRangeInputMousemoveTouchmove",
      value: function _handleRangeInputMousemoveTouchmove() {
        if (this._mousedown) {
          if (!$(this.thumb).hasClass('active')) {
            this._showRangeBubble();
          }

          var offsetLeft = this._calcRangeOffset();
          $(this.thumb).addClass('active').css('left', offsetLeft + 'px');
          $(this.value).html(this.$el.val());
        }
      }

      /**
       * Handle Range Mouseup and Touchend
       */

    }, {
      key: "_handleRangeMouseupTouchend",
      value: function _handleRangeMouseupTouchend() {
        this._mousedown = false;
        this.$el.removeClass('active');
      }

      /**
       * Handle Range Blur, Mouseout and Touchleave
       */

    }, {
      key: "_handleRangeBlurMouseoutTouchleave",
      value: function _handleRangeBlurMouseoutTouchleave() {
        if (!this._mousedown) {
          var paddingLeft = parseInt(this.$el.css('padding-left'));
          var marginLeft = 7 + paddingLeft + 'px';

          if ($(this.thumb).hasClass('active')) {
            anim.remove(this.thumb);
            anim({
              targets: this.thumb,
              height: 0,
              width: 0,
              top: 10,
              easing: 'easeOutQuad',
              marginLeft: marginLeft,
              duration: 100
            });
          }
          $(this.thumb).removeClass('active');
        }
      }

      /**
       * Setup dropdown
       */

    }, {
      key: "_setupThumb",
      value: function _setupThumb() {
        this.thumb = document.createElement('span');
        this.value = document.createElement('span');
        $(this.thumb).addClass('thumb');
        $(this.value).addClass('value');
        $(this.thumb).append(this.value);
        this.$el.after(this.thumb);
      }

      /**
       * Remove dropdown
       */

    }, {
      key: "_removeThumb",
      value: function _removeThumb() {
        $(this.thumb).remove();
      }

      /**
       * morph thumb into bubble
       */

    }, {
      key: "_showRangeBubble",
      value: function _showRangeBubble() {
        var paddingLeft = parseInt($(this.thumb).parent().css('padding-left'));
        var marginLeft = -7 + paddingLeft + 'px'; // TODO: fix magic number?
        anim.remove(this.thumb);
        anim({
          targets: this.thumb,
          height: 30,
          width: 30,
          top: -30,
          marginLeft: marginLeft,
          duration: 300,
          easing: 'easeOutQuint'
        });
      }

      /**
       * Calculate the offset of the thumb
       * @return {Number}  offset in pixels
       */

    }, {
      key: "_calcRangeOffset",
      value: function _calcRangeOffset() {
        var width = this.$el.width() - 15;
        var max = parseFloat(this.$el.attr('max')) || 100; // Range default max
        var min = parseFloat(this.$el.attr('min')) || 0; // Range default min
        var percent = (parseFloat(this.$el.val()) - min) / (max - min);
        return percent * width;
      }
    }], [{
      key: "init",
      value: function init(els, options) {
        return _get(Range.__proto__ || Object.getPrototypeOf(Range), "init", this).call(this, this, els, options);
      }

      /**
       * Get Instance
       */

    }, {
      key: "getInstance",
      value: function getInstance(el) {
        var domElem = !!el.jquery ? el[0] : el;
        return domElem.M_Range;
      }
    }, {
      key: "defaults",
      get: function () {
        return _defaults;
      }
    }]);

    return Range;
  }(Component);

  M.Range = Range;

  if (M.jQueryLoaded) {
    M.initializeJqueryWrapper(Range, 'range', 'M_Range');
  }

  Range.init($('input[type=range]'));
})(cash, M.anime);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(70);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(75)('meta');
var isObject = __webpack_require__(11);
var has = __webpack_require__(40);
var setDesc = __webpack_require__(17).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(10)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(13)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(33)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = __webpack_require__(51);

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */
var CONSTANTS = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */
    NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */
    NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */
    SDK_VERSION: '${JSCORE_VERSION}'
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Throws an error if the provided assertion is falsy
 */
var assert = function (assertion, message) {
    if (!assertion) {
        throw assertionError(message);
    }
};
/**
 * Returns an Error object suitable for throwing.
 */
var assertionError = function (message) {
    return new Error('Firebase Database (' +
        CONSTANTS.SDK_VERSION +
        ') INTERNAL ASSERT FAILED: ' +
        message);
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var stringToByteArray = function (str) {
    // TODO(user): Use native implementations if/when available
    var out = [];
    var p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if ((c & 0xfc00) === 0xd800 &&
            i + 1 < str.length &&
            (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */
var byteArrayToString = function (bytes) {
    // TODO(user): Use native implementations if/when available
    var out = [];
    var pos = 0, c = 0;
    while (pos < bytes.length) {
        var c1 = bytes[pos++];
        if (c1 < 128) {
            out[c++] = String.fromCharCode(c1);
        }
        else if (c1 > 191 && c1 < 224) {
            var c2 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 31) << 6) | (c2 & 63));
        }
        else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            var c4 = bytes[pos++];
            var u = (((c1 & 7) << 18) | ((c2 & 63) << 12) | ((c3 & 63) << 6) | (c4 & 63)) -
                0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        }
        else {
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
var base64 = {
    /**
     * Maps bytes to characters.
     */
    byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */
    charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */
    byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */
    charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */
    ENCODED_VALS_BASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789',
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */
    get ENCODED_VALS() {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */
    get ENCODED_VALS_WEBSAFE() {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */
    HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */
    encodeByteArray: function (input, webSafe) {
        if (!Array.isArray(input)) {
            throw Error('encodeByteArray takes an array as a parameter');
        }
        this.init_();
        var byteToCharMap = webSafe
            ? this.byteToCharMapWebSafe_
            : this.byteToCharMap_;
        var output = [];
        for (var i = 0; i < input.length; i += 3) {
            var byte1 = input[i];
            var haveByte2 = i + 1 < input.length;
            var byte2 = haveByte2 ? input[i + 1] : 0;
            var haveByte3 = i + 2 < input.length;
            var byte3 = haveByte3 ? input[i + 2] : 0;
            var outByte1 = byte1 >> 2;
            var outByte2 = ((byte1 & 0x03) << 4) | (byte2 >> 4);
            var outByte3 = ((byte2 & 0x0f) << 2) | (byte3 >> 6);
            var outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) {
                    outByte3 = 64;
                }
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */
    encodeString: function (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
            return btoa(input);
        }
        return this.encodeByteArray(stringToByteArray(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */
    decodeString: function (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
            return atob(input);
        }
        return byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */
    decodeStringToByteArray: function (input, webSafe) {
        this.init_();
        var charToByteMap = webSafe
            ? this.charToByteMapWebSafe_
            : this.charToByteMap_;
        var output = [];
        for (var i = 0; i < input.length;) {
            var byte1 = charToByteMap[input.charAt(i++)];
            var haveByte2 = i < input.length;
            var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            var haveByte3 = i < input.length;
            var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            var haveByte4 = i < input.length;
            var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
                throw Error();
            }
            var outByte1 = (byte1 << 2) | (byte2 >> 4);
            output.push(outByte1);
            if (byte3 !== 64) {
                var outByte2 = ((byte2 << 4) & 0xf0) | (byte3 >> 2);
                output.push(outByte2);
                if (byte4 !== 64) {
                    var outByte3 = ((byte3 << 6) & 0xc0) | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */
    init_: function () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for (var i = 0; i < this.ENCODED_VALS.length; i++) {
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * URL-safe base64 encoding
 */
var base64Encode = function (str) {
    var utf8Bytes = stringToByteArray(str);
    return base64.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */
var base64Decode = function (str) {
    try {
        return base64.decodeString(str, true);
    }
    catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */
function deepCopy(value) {
    return deepExtend(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 */
function deepExtend(target, source) {
    if (!(source instanceof Object)) {
        return source;
    }
    switch (source.constructor) {
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            var dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) {
                target = {};
            }
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for (var prop in source) {
        if (!source.hasOwnProperty(prop)) {
            continue;
        }
        target[prop] = deepExtend(target[prop], source[prop]);
    }
    return target;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Deferred = /** @class */ (function () {
    function Deferred() {
        var _this = this;
        this.reject = function () { };
        this.resolve = function () { };
        this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */
    Deferred.prototype.wrapCallback = function (callback) {
        var _this = this;
        return function (error, value) {
            if (error) {
                _this.reject(error);
            }
            else {
                _this.resolve(value);
            }
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                _this.promise.catch(function () { });
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) {
                    callback(error);
                }
                else {
                    callback(error, value);
                }
            }
        };
    };
    return Deferred;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */
function getUA() {
    if (typeof navigator !== 'undefined' &&
        typeof navigator['userAgent'] === 'string') {
        return navigator['userAgent'];
    }
    else {
        return '';
    }
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */
function isMobileCordova() {
    return (typeof window !== 'undefined' &&
        // @ts-ignore Setting up an broadly applicable index signature for Window
        // just to deal with this case would probably be a bad idea.
        !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) &&
        /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(getUA()));
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected.
 */
// Node detection logic from: https://github.com/iliakan/detect-node/
function isNode() {
    try {
        return (Object.prototype.toString.call(global.process) === '[object process]');
    }
    catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */
function isBrowser() {
    return typeof self === 'object' && self.self === self;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */
function isReactNative() {
    return (typeof navigator === 'object' && navigator['product'] === 'ReactNative');
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */
function isNodeSdk() {
    return CONSTANTS.NODE_CLIENT === true || CONSTANTS.NODE_ADMIN === true;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
var FirebaseError = /** @class */ (function (_super) {
    tslib.__extends(FirebaseError, _super);
    function FirebaseError(code, message) {
        var _this = _super.call(this, message) || this;
        _this.code = code;
        _this.name = ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, FirebaseError.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, ErrorFactory.prototype.create);
        }
        return _this;
    }
    return FirebaseError;
}(Error));
var ErrorFactory = /** @class */ (function () {
    function ErrorFactory(service, serviceName, errors) {
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    ErrorFactory.prototype.create = function (code) {
        var data = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            data[_i - 1] = arguments[_i];
        }
        var customData = data[0] || {};
        var fullCode = this.service + "/" + code;
        var template = this.errors[code];
        var message = template ? replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        var fullMessage = this.serviceName + ": " + message + " (" + fullCode + ").";
        var error = new FirebaseError(fullCode, fullMessage);
        // Keys with an underscore at the end of their name are not included in
        // error.data for some reason.
        // TODO: Replace with Object.entries when lib is updated to es2017.
        for (var _a = 0, _b = Object.keys(customData); _a < _b.length; _a++) {
            var key = _b[_a];
            if (key.slice(-1) !== '_') {
                if (key in error) {
                    console.warn("Overwriting FirebaseError base field \"" + key + "\" can cause unexpected behavior.");
                }
                error[key] = customData[key];
            }
        }
        return error;
    };
    return ErrorFactory;
}());
function replaceTemplate(template, data) {
    return template.replace(PATTERN, function (_, key) {
        var value = data[key];
        return value != null ? value.toString() : "<" + key + "?>";
    });
}
var PATTERN = /\{\$([^}]+)}/g;

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */
function jsonEval(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */
function stringify(data) {
    return JSON.stringify(data);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var decode = function (token) {
    var header = {}, claims = {}, data = {}, signature = '';
    try {
        var parts = token.split('.');
        header = jsonEval(base64Decode(parts[0]) || '');
        claims = jsonEval(base64Decode(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    }
    catch (e) { }
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var isValidTimestamp = function (token) {
    var claims = decode(token).claims;
    var now = Math.floor(new Date().getTime() / 1000);
    var validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) {
            validSince = claims['nbf'];
        }
        else if (claims.hasOwnProperty('iat')) {
            validSince = claims['iat'];
        }
        if (claims.hasOwnProperty('exp')) {
            validUntil = claims['exp'];
        }
        else {
            // token will expire after 24h by default
            validUntil = validSince + 86400;
        }
    }
    return (!!now &&
        !!validSince &&
        !!validUntil &&
        now >= validSince &&
        now <= validUntil);
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var issuedAtTime = function (token) {
    var claims = decode(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) {
        return claims['iat'];
    }
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var isValidFormat = function (token) {
    var decoded = decode(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var isAdmin = function (token) {
    var claims = decode(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function contains(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function safeGet(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
        return obj[key];
    }
    else {
        return undefined;
    }
}
function isEmpty(obj) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            return false;
        }
    }
    return true;
}
function map(obj, fn, contextObj) {
    var res = {};
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            res[key] = fn.call(contextObj, obj[key], key, obj);
        }
    }
    return res;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */
function querystring(querystringParams) {
    var params = [];
    var _loop_1 = function (key, value) {
        if (Array.isArray(value)) {
            value.forEach(function (arrayVal) {
                params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
            });
        }
        else {
            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        }
    };
    for (var _i = 0, _a = Object.entries(querystringParams); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        _loop_1(key, value);
    }
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */
function querystringDecode(querystring) {
    var obj = {};
    var tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach(function (token) {
        if (token) {
            var key = token.split('=');
            obj[key[0]] = key[1];
        }
    });
    return obj;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */
/**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */
var Sha1 = /** @class */ (function () {
    function Sha1() {
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */
        this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */
        this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */
        this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */
        this.pad_ = [];
        /**
         * @private {number}
         */
        this.inbuf_ = 0;
        /**
         * @private {number}
         */
        this.total_ = 0;
        this.blockSize = 512 / 8;
        this.pad_[0] = 128;
        for (var i = 1; i < this.blockSize; ++i) {
            this.pad_[i] = 0;
        }
        this.reset();
    }
    Sha1.prototype.reset = function () {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    };
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */
    Sha1.prototype.compress_ = function (buf, offset) {
        if (!offset) {
            offset = 0;
        }
        var W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') {
            for (var i = 0; i < 16; i++) {
                // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
                // have a bug that turns the post-increment ++ operator into pre-increment
                // during JIT compilation.  We have code that depends heavily on SHA-1 for
                // correctness and which is affected by this bug, so I've removed all uses
                // of post-increment ++ in which the result value is used.  We can revert
                // this change once the Safari bug
                // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
                // most clients have been updated.
                W[i] =
                    (buf.charCodeAt(offset) << 24) |
                        (buf.charCodeAt(offset + 1) << 16) |
                        (buf.charCodeAt(offset + 2) << 8) |
                        buf.charCodeAt(offset + 3);
                offset += 4;
            }
        }
        else {
            for (var i = 0; i < 16; i++) {
                W[i] =
                    (buf[offset] << 24) |
                        (buf[offset + 1] << 16) |
                        (buf[offset + 2] << 8) |
                        buf[offset + 3];
                offset += 4;
            }
        }
        // expand to 80 words
        for (var i = 16; i < 80; i++) {
            var t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = ((t << 1) | (t >>> 31)) & 0xffffffff;
        }
        var a = this.chain_[0];
        var b = this.chain_[1];
        var c = this.chain_[2];
        var d = this.chain_[3];
        var e = this.chain_[4];
        var f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for (var i = 0; i < 80; i++) {
            if (i < 40) {
                if (i < 20) {
                    f = d ^ (b & (c ^ d));
                    k = 0x5a827999;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            }
            else {
                if (i < 60) {
                    f = (b & c) | (d & (b | c));
                    k = 0x8f1bbcdc;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0xca62c1d6;
                }
            }
            var t = (((a << 5) | (a >>> 27)) + f + e + k + W[i]) & 0xffffffff;
            e = d;
            d = c;
            c = ((b << 30) | (b >>> 2)) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = (this.chain_[0] + a) & 0xffffffff;
        this.chain_[1] = (this.chain_[1] + b) & 0xffffffff;
        this.chain_[2] = (this.chain_[2] + c) & 0xffffffff;
        this.chain_[3] = (this.chain_[3] + d) & 0xffffffff;
        this.chain_[4] = (this.chain_[4] + e) & 0xffffffff;
    };
    Sha1.prototype.update = function (bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) {
            return;
        }
        if (length === undefined) {
            length = bytes.length;
        }
        var lengthMinusBlock = length - this.blockSize;
        var n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        var buf = this.buf_;
        var inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while (n < length) {
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) {
                while (n <= lengthMinusBlock) {
                    this.compress_(bytes, n);
                    n += this.blockSize;
                }
            }
            if (typeof bytes === 'string') {
                while (n < length) {
                    buf[inbuf] = bytes.charCodeAt(n);
                    ++inbuf;
                    ++n;
                    if (inbuf === this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
            else {
                while (n < length) {
                    buf[inbuf] = bytes[n];
                    ++inbuf;
                    ++n;
                    if (inbuf === this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    };
    /** @override */
    Sha1.prototype.digest = function () {
        var digest = [];
        var totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) {
            this.update(this.pad_, 56 - this.inbuf_);
        }
        else {
            this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        }
        // Add # bits.
        for (var i = this.blockSize - 1; i >= 56; i--) {
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        var n = 0;
        for (var i = 0; i < 5; i++) {
            for (var j = 24; j >= 0; j -= 8) {
                digest[n] = (this.chain_[i] >> j) & 255;
                ++n;
            }
        }
        return digest;
    };
    return Sha1;
}());

/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */
function createSubscribe(executor, onNoObservers) {
    var proxy = new ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */
var ObserverProxy = /** @class */ (function () {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */
    function ObserverProxy(executor, onNoObservers) {
        var _this = this;
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task
            .then(function () {
            executor(_this);
        })
            .catch(function (e) {
            _this.error(e);
        });
    }
    ObserverProxy.prototype.next = function (value) {
        this.forEachObserver(function (observer) {
            observer.next(value);
        });
    };
    ObserverProxy.prototype.error = function (error) {
        this.forEachObserver(function (observer) {
            observer.error(error);
        });
        this.close(error);
    };
    ObserverProxy.prototype.complete = function () {
        this.forEachObserver(function (observer) {
            observer.complete();
        });
        this.close();
    };
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */
    ObserverProxy.prototype.subscribe = function (nextOrObserver, error, complete) {
        var _this = this;
        var observer;
        if (nextOrObserver === undefined &&
            error === undefined &&
            complete === undefined) {
            throw new Error('Missing Observer.');
        }
        // Assemble an Observer object when passed as callback functions.
        if (implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) {
            observer = nextOrObserver;
        }
        else {
            observer = {
                next: nextOrObserver,
                error: error,
                complete: complete
            };
        }
        if (observer.next === undefined) {
            observer.next = noop;
        }
        if (observer.error === undefined) {
            observer.error = noop;
        }
        if (observer.complete === undefined) {
            observer.complete = noop;
        }
        var unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.task.then(function () {
                try {
                    if (_this.finalError) {
                        observer.error(_this.finalError);
                    }
                    else {
                        observer.complete();
                    }
                }
                catch (e) {
                    // nothing
                }
                return;
            });
        }
        this.observers.push(observer);
        return unsub;
    };
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    ObserverProxy.prototype.unsubscribeOne = function (i) {
        if (this.observers === undefined || this.observers[i] === undefined) {
            return;
        }
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) {
            this.onNoObservers(this);
        }
    };
    ObserverProxy.prototype.forEachObserver = function (fn) {
        if (this.finalized) {
            // Already closed by previous event....just eat the additional values.
            return;
        }
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for (var i = 0; i < this.observers.length; i++) {
            this.sendOne(i, fn);
        }
    };
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    ObserverProxy.prototype.sendOne = function (i, fn) {
        var _this = this;
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(function () {
            if (_this.observers !== undefined && _this.observers[i] !== undefined) {
                try {
                    fn(_this.observers[i]);
                }
                catch (e) {
                    // Ignore exceptions raised in Observers or missing methods of an
                    // Observer.
                    // Log error to console. b/31404806
                    if (typeof console !== 'undefined' && console.error) {
                        console.error(e);
                    }
                }
            }
        });
    };
    ObserverProxy.prototype.close = function (err) {
        var _this = this;
        if (this.finalized) {
            return;
        }
        this.finalized = true;
        if (err !== undefined) {
            this.finalError = err;
        }
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(function () {
            _this.observers = undefined;
            _this.onNoObservers = undefined;
        });
    };
    return ObserverProxy;
}());
/** Turn synchronous function into one called asynchronously. */
function async(fn, onError) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        Promise.resolve(true)
            .then(function () {
            fn.apply(void 0, args);
        })
            .catch(function (error) {
            if (onError) {
                onError(error);
            }
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */
function implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }
    for (var _i = 0, methods_1 = methods; _i < methods_1.length; _i++) {
        var method = methods_1[_i];
        if (method in obj && typeof obj[method] === 'function') {
            return true;
        }
    }
    return false;
}
function noop() {
    // do nothing
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */
var validateArgCount = function (fnName, minCount, maxCount, argCount) {
    var argError;
    if (argCount < minCount) {
        argError = 'at least ' + minCount;
    }
    else if (argCount > maxCount) {
        argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    }
    if (argError) {
        var error = fnName +
            ' failed: Was called with ' +
            argCount +
            (argCount === 1 ? ' argument.' : ' arguments.') +
            ' Expects ' +
            argError +
            '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argumentNumber The index of the argument
 * @param optional Whether or not the argument is optional
 * @return The prefix to add to the error thrown for validation.
 */
function errorPrefix(fnName, argumentNumber, optional) {
    var argName = '';
    switch (argumentNumber) {
        case 1:
            argName = optional ? 'first' : 'First';
            break;
        case 2:
            argName = optional ? 'second' : 'Second';
            break;
        case 3:
            argName = optional ? 'third' : 'Third';
            break;
        case 4:
            argName = optional ? 'fourth' : 'Fourth';
            break;
        default:
            throw new Error('errorPrefix called with argumentNumber > 4.  Need to update it?');
    }
    var error = fnName + ' failed: ';
    error += argName + ' argument ';
    return error;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */
function validateNamespace(fnName, argumentNumber, namespace, optional) {
    if (optional && !namespace) {
        return;
    }
    if (typeof namespace !== 'string') {
        //TODO: I should do more validation here. We only allow certain chars in namespaces.
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid firebase namespace.');
    }
}
function validateCallback(fnName, argumentNumber, callback, optional) {
    if (optional && !callback) {
        return;
    }
    if (typeof callback !== 'function') {
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid function.');
    }
}
function validateContextObject(fnName, argumentNumber, context, optional) {
    if (optional && !context) {
        return;
    }
    if (typeof context !== 'object' || context === null) {
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid context object.');
    }
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */
var stringToByteArray$1 = function (str) {
    var out = [];
    var p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            var high = c - 0xd800; // the high 10 bits.
            i++;
            assert(i < str.length, 'Surrogate pair missing trail surrogate.');
            var low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if (c < 65536) {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */
var stringLength = function (str) {
    var p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
            p++;
        }
        else if (c < 2048) {
            p += 2;
        }
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        }
        else {
            p += 3;
        }
    }
    return p;
};

exports.CONSTANTS = CONSTANTS;
exports.Deferred = Deferred;
exports.ErrorFactory = ErrorFactory;
exports.FirebaseError = FirebaseError;
exports.Sha1 = Sha1;
exports.assert = assert;
exports.assertionError = assertionError;
exports.async = async;
exports.base64 = base64;
exports.base64Decode = base64Decode;
exports.base64Encode = base64Encode;
exports.contains = contains;
exports.createSubscribe = createSubscribe;
exports.decode = decode;
exports.deepCopy = deepCopy;
exports.deepExtend = deepExtend;
exports.errorPrefix = errorPrefix;
exports.getUA = getUA;
exports.isAdmin = isAdmin;
exports.isBrowser = isBrowser;
exports.isEmpty = isEmpty;
exports.isMobileCordova = isMobileCordova;
exports.isNode = isNode;
exports.isNodeSdk = isNodeSdk;
exports.isReactNative = isReactNative;
exports.isValidFormat = isValidFormat;
exports.isValidTimestamp = isValidTimestamp;
exports.issuedAtTime = issuedAtTime;
exports.jsonEval = jsonEval;
exports.map = map;
exports.querystring = querystring;
exports.querystringDecode = querystringDecode;
exports.safeGet = safeGet;
exports.stringLength = stringLength;
exports.stringToByteArray = stringToByteArray$1;
exports.stringify = stringify;
exports.validateArgCount = validateArgCount;
exports.validateCallback = validateCallback;
exports.validateContextObject = validateContextObject;
exports.validateNamespace = validateNamespace;
//# sourceMappingURL=index.cjs.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(929);

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var moment = __webpack_require__(3);
var momentValidationWrapper = __webpack_require__(954);
var core = __webpack_require__(955);

module.exports = {

  momentObj : core.createMomentChecker(
    'object',
    function(obj) {
      return typeof obj === 'object';
    },
    function isValid(value) {
      return momentValidationWrapper.isValidMoment(value);
    },
    'Moment'
  ),

  momentString : core.createMomentChecker(
    'string',
    function(str) {
      return typeof str === 'string';
    },
    function isValid(value) {
      return momentValidationWrapper.isValidMoment(moment(value));
    },
    'Moment'
  ),

  momentDurationObj : core.createMomentChecker(
    'object',
    function(obj) {
      return typeof obj === 'object';
    },
    function isValid(value) {
      return moment.isDuration(value);
    },
    'Duration'
  ),

};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(62);
var IE8_DOM_DEFINE = __webpack_require__(575);
var toPrimitive = __webpack_require__(205);
var dP = Object.defineProperty;

exports.f = __webpack_require__(71) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 70 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(103)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bpfrpt_proptype_VisibleCellRange = exports.bpfrpt_proptype_Alignment = exports.bpfrpt_proptype_OverscanIndicesGetter = exports.bpfrpt_proptype_OverscanIndices = exports.bpfrpt_proptype_OverscanIndicesGetterParams = exports.bpfrpt_proptype_RenderedSection = exports.bpfrpt_proptype_ScrollbarPresenceChange = exports.bpfrpt_proptype_Scroll = exports.bpfrpt_proptype_NoContentRenderer = exports.bpfrpt_proptype_CellSize = exports.bpfrpt_proptype_CellSizeGetter = exports.bpfrpt_proptype_CellRangeRenderer = exports.bpfrpt_proptype_CellRangeRendererParams = exports.bpfrpt_proptype_StyleCache = exports.bpfrpt_proptype_CellCache = exports.bpfrpt_proptype_CellRenderer = exports.bpfrpt_proptype_CellRendererParams = exports.bpfrpt_proptype_CellPosition = undefined;

var _react = __webpack_require__(2);

var React = _interopRequireWildcard(_react);

var _ScalingCellSizeAndPositionManager = __webpack_require__(220);

var _ScalingCellSizeAndPositionManager2 = _interopRequireDefault(_ScalingCellSizeAndPositionManager);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var bpfrpt_proptype_CellPosition =  true ? null : {
  columnIndex: _propTypes2.default.number.isRequired,
  rowIndex: _propTypes2.default.number.isRequired
};
var bpfrpt_proptype_CellRendererParams =  true ? null : {
  columnIndex: _propTypes2.default.number.isRequired,
  isScrolling: _propTypes2.default.bool.isRequired,
  isVisible: _propTypes2.default.bool.isRequired,
  key: _propTypes2.default.string.isRequired,
  parent: _propTypes2.default.object.isRequired,
  rowIndex: _propTypes2.default.number.isRequired,
  style: _propTypes2.default.object.isRequired
};
var bpfrpt_proptype_CellRenderer =  true ? null : _propTypes2.default.func;
var bpfrpt_proptype_CellCache =  true ? null : _propTypes2.default.objectOf(_propTypes2.default.node.isRequired);
var bpfrpt_proptype_StyleCache =  true ? null : _propTypes2.default.objectOf(_propTypes2.default.object.isRequired);
var bpfrpt_proptype_CellRangeRendererParams =  true ? null : {
  cellCache: _propTypes2.default.objectOf(_propTypes2.default.node.isRequired).isRequired,
  cellRenderer: _propTypes2.default.func.isRequired,
  columnSizeAndPositionManager: function columnSizeAndPositionManager() {
    return (typeof _ScalingCellSizeAndPositionManager2.default === 'function' ? _propTypes2.default.instanceOf(_ScalingCellSizeAndPositionManager2.default).isRequired : _propTypes2.default.any.isRequired).apply(this, arguments);
  },
  columnStartIndex: _propTypes2.default.number.isRequired,
  columnStopIndex: _propTypes2.default.number.isRequired,
  deferredMeasurementCache: _propTypes2.default.object,
  horizontalOffsetAdjustment: _propTypes2.default.number.isRequired,
  isScrolling: _propTypes2.default.bool.isRequired,
  isScrollingOptOut: _propTypes2.default.bool.isRequired,
  parent: _propTypes2.default.object.isRequired,
  rowSizeAndPositionManager: function rowSizeAndPositionManager() {
    return (typeof _ScalingCellSizeAndPositionManager2.default === 'function' ? _propTypes2.default.instanceOf(_ScalingCellSizeAndPositionManager2.default).isRequired : _propTypes2.default.any.isRequired).apply(this, arguments);
  },
  rowStartIndex: _propTypes2.default.number.isRequired,
  rowStopIndex: _propTypes2.default.number.isRequired,
  scrollLeft: _propTypes2.default.number.isRequired,
  scrollTop: _propTypes2.default.number.isRequired,
  styleCache: _propTypes2.default.objectOf(_propTypes2.default.object.isRequired).isRequired,
  verticalOffsetAdjustment: _propTypes2.default.number.isRequired,
  visibleColumnIndices: _propTypes2.default.object.isRequired,
  visibleRowIndices: _propTypes2.default.object.isRequired
};
var bpfrpt_proptype_CellRangeRenderer =  true ? null : _propTypes2.default.func;
var bpfrpt_proptype_CellSizeGetter =  true ? null : _propTypes2.default.func;
var bpfrpt_proptype_CellSize =  true ? null : _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.number]);
var bpfrpt_proptype_NoContentRenderer =  true ? null : _propTypes2.default.func;
var bpfrpt_proptype_Scroll =  true ? null : {
  clientHeight: _propTypes2.default.number.isRequired,
  clientWidth: _propTypes2.default.number.isRequired,
  scrollHeight: _propTypes2.default.number.isRequired,
  scrollLeft: _propTypes2.default.number.isRequired,
  scrollTop: _propTypes2.default.number.isRequired,
  scrollWidth: _propTypes2.default.number.isRequired
};
var bpfrpt_proptype_ScrollbarPresenceChange =  true ? null : {
  horizontal: _propTypes2.default.bool.isRequired,
  vertical: _propTypes2.default.bool.isRequired,
  size: _propTypes2.default.number.isRequired
};
var bpfrpt_proptype_RenderedSection =  true ? null : {
  columnOverscanStartIndex: _propTypes2.default.number.isRequired,
  columnOverscanStopIndex: _propTypes2.default.number.isRequired,
  columnStartIndex: _propTypes2.default.number.isRequired,
  columnStopIndex: _propTypes2.default.number.isRequired,
  rowOverscanStartIndex: _propTypes2.default.number.isRequired,
  rowOverscanStopIndex: _propTypes2.default.number.isRequired,
  rowStartIndex: _propTypes2.default.number.isRequired,
  rowStopIndex: _propTypes2.default.number.isRequired
};
var bpfrpt_proptype_OverscanIndicesGetterParams =  true ? null : {
  // One of SCROLL_DIRECTION_HORIZONTAL or SCROLL_DIRECTION_VERTICAL
  direction: _propTypes2.default.oneOf(['horizontal', 'vertical']).isRequired,


  // One of SCROLL_DIRECTION_BACKWARD or SCROLL_DIRECTION_FORWARD
  scrollDirection: _propTypes2.default.oneOf([-1, 1]).isRequired,


  // Number of rows or columns in the current axis
  cellCount: _propTypes2.default.number.isRequired,


  // Maximum number of cells to over-render in either direction
  overscanCellsCount: _propTypes2.default.number.isRequired,


  // Begin of range of visible cells
  startIndex: _propTypes2.default.number.isRequired,


  // End of range of visible cells
  stopIndex: _propTypes2.default.number.isRequired
};
var bpfrpt_proptype_OverscanIndices =  true ? null : {
  overscanStartIndex: _propTypes2.default.number.isRequired,
  overscanStopIndex: _propTypes2.default.number.isRequired
};
var bpfrpt_proptype_OverscanIndicesGetter =  true ? null : _propTypes2.default.func;
var bpfrpt_proptype_Alignment =  true ? null : _propTypes2.default.oneOf(['auto', 'end', 'start', 'center']);
var bpfrpt_proptype_VisibleCellRange =  true ? null : {
  start: _propTypes2.default.number,
  stop: _propTypes2.default.number
};
exports.bpfrpt_proptype_CellPosition = bpfrpt_proptype_CellPosition;
exports.bpfrpt_proptype_CellRendererParams = bpfrpt_proptype_CellRendererParams;
exports.bpfrpt_proptype_CellRenderer = bpfrpt_proptype_CellRenderer;
exports.bpfrpt_proptype_CellCache = bpfrpt_proptype_CellCache;
exports.bpfrpt_proptype_StyleCache = bpfrpt_proptype_StyleCache;
exports.bpfrpt_proptype_CellRangeRendererParams = bpfrpt_proptype_CellRangeRendererParams;
exports.bpfrpt_proptype_CellRangeRenderer = bpfrpt_proptype_CellRangeRenderer;
exports.bpfrpt_proptype_CellSizeGetter = bpfrpt_proptype_CellSizeGetter;
exports.bpfrpt_proptype_CellSize = bpfrpt_proptype_CellSize;
exports.bpfrpt_proptype_NoContentRenderer = bpfrpt_proptype_NoContentRenderer;
exports.bpfrpt_proptype_Scroll = bpfrpt_proptype_Scroll;
exports.bpfrpt_proptype_ScrollbarPresenceChange = bpfrpt_proptype_ScrollbarPresenceChange;
exports.bpfrpt_proptype_RenderedSection = bpfrpt_proptype_RenderedSection;
exports.bpfrpt_proptype_OverscanIndicesGetterParams = bpfrpt_proptype_OverscanIndicesGetterParams;
exports.bpfrpt_proptype_OverscanIndices = bpfrpt_proptype_OverscanIndices;
exports.bpfrpt_proptype_OverscanIndicesGetter = bpfrpt_proptype_OverscanIndicesGetter;
exports.bpfrpt_proptype_Alignment = bpfrpt_proptype_Alignment;
exports.bpfrpt_proptype_VisibleCellRange = bpfrpt_proptype_VisibleCellRange;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OggettiList = undefined;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _deals = __webpack_require__(85);

var _deals2 = _interopRequireDefault(_deals);

var _Card = __webpack_require__(56);

var _Card2 = _interopRequireDefault(_Card);

var _utils = __webpack_require__(9);

var _elements = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OggettiList = exports.OggettiList = function OggettiList(props) {
  //controllo se arrivo da view deal o dalla dashboard oggetti
  var oggettiPayload = props.oggetto || props.oggetti;

  return _react2.default.createElement(
    'div',
    { className: 'container' },
    _react2.default.createElement(
      'div',
      { className: 'list-body' },
      oggettiPayload.length > 0 && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h5',
          null,
          props.ruolo || ''
        ),
        oggettiPayload.sort(function (a, b) {
          return a.visible < b.visible ? -1 : 1;
        }).map(function (oggetto) {
          var verkauft = oggetto.venduto ? _react2.default.createElement(
            'h5',
            { className: 'red-text' },
            props.t('Venduto'),
            '!'
          ) : oggetto.prenotato ? _react2.default.createElement(
            'h5',
            { className: 'orange-text' },
            props.t('reserved'),
            '!'
          ) : '';

          var prezzoDiVendita = props.t('Prezzo di vendita') + ': ' + (0, _utils.formattaPrezzo)(oggetto.kaufpreis, true);

          var dataOggetto = oggetto.dataModificaOggetto ? (0, _utils.formattaData)(oggetto.dataModificaOggetto) : oggetto.dataInserimentoOggetto ? (0, _utils.formattaData)(oggetto.dataModificaOggetto) : 'n/a';

          return _react2.default.createElement(_Card2.default, {
            key: oggetto.id,
            titolo: '' + (0, _utils.indirizzoOggetto)(oggetto),
            titoloDestra: _react2.default.createElement(
              'div',
              { className: 'foto-container' },
              oggetto.downloadURLsCover && _react2.default.createElement('img', {
                className: 'foto',
                src: oggetto.downloadURLsCover[0] || ''
              }),
              (0, _elements.folderButton)(oggetto, oggetto.downloadURLsCover && true, 'Exposé', oggetto.rifId)
            ),
            sottotitolo: props.t('Rif') + '. ID ' + oggetto.rifId,
            visible: oggetto.visible,
            link: '/oggettoview/' + oggetto.id,
            corpo: [props.t(oggetto.tipologia), prezzoDiVendita, dataOggetto, oggetto.status && _react2.default.createElement(
              'p',
              { className: 'green-text' },
              props.t('property_status')
            )],
            verkauft: verkauft
          });
        })
      )
    )
  );
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    oggetti: (0, _deals2.default)('oggetti', state.oggetti, state.filters, state.utenti.find(function (utente) {
      return utente.firebaseAuthId === state.auth.uid;
    }))
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    startSetOggetti: function (_startSetOggetti) {
      function startSetOggetti() {
        return _startSetOggetti.apply(this, arguments);
      }

      startSetOggetti.toString = function () {
        return _startSetOggetti.toString();
      };

      return startSetOggetti;
    }(function () {
      return dispatch(startSetOggetti());
    })
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactI18next.withTranslation)()(OggettiList));

/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 75 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(227);
var enumBugKeys = __webpack_require__(164);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(48);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(7);
var dPs = __webpack_require__(228);
var enumBugKeys = __webpack_require__(164);
var IE_PROTO = __webpack_require__(163)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(161)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(165).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(227);
var hiddenKeys = __webpack_require__(164).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(8);
var dP = __webpack_require__(17);
var DESCRIPTORS = __webpack_require__(16);
var SPECIES = __webpack_require__(13)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(46);
var call = __webpack_require__(240);
var isArrayIter = __webpack_require__(176);
var anObject = __webpack_require__(7);
var toLength = __webpack_require__(15);
var getIterFn = __webpack_require__(178);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(34);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Get visible deals
// per i deals viene chiamato due volte da DealsSummary e da DealList!

exports.default = function (nomeLista, payload, _ref, utente, oggetti, clienti, fatture, deals) {
  var text = _ref.text,
      sortBy = _ref.sortBy,
      startDate = _ref.startDate,
      endDate = _ref.endDate;

  return payload.filter(function (item) {
    var findCliente = function findCliente(customerId) {
      return clienti.find(function (cliente) {
        return cliente.id === customerId;
      });
    };
    var findOggetto = function findOggetto(oggettoId) {
      return oggetti.find(function (ogg) {
        return ogg.id === oggettoId;
      });
    };

    var searchString = '';

    var createdAtMoment = (0, _moment2.default)();

    if (nomeLista === 'deals') {
      // il match delle date lo faccio sulla data di emissione della fattura anche per avere un'idea concreta degli incassi dell'anno.
      // I deals che non sono ancora fatturati appaiono come primi
      var dealFatture = fatture && fatture.find(function (fattura) {
        return fattura.dealId === item.id;
      });

      createdAtMoment = dealFatture ? (0, _moment2.default)(dealFatture.dataFattura) : createdAtMoment;

      createdAtMoment = item.feePayed ? item.dataRogito ? (0, _moment2.default)(item.dataRogito) : (0, _moment2.default)(item.createdAt) : createdAtMoment;
      console.log(createdAtMoment);

      var oggetto = oggetti.find(function (ogg) {
        return ogg.id === item.oggettoId;
      }) || {
        rifId: 'n/a',
        via: 'n/a',
        numeroCivico: 'n/a',
        numeroAppartamento: 'n/a',
        cap: 'n/a',
        citta: 'n/a'
      };
      var acquirente = findCliente(item.acquirenteId);
      var acquirente2 = findCliente(item.acquirenteId2);
      var venditore = findCliente(item.venditoreId);
      var venditore2 = findCliente(item.venditoreId2);

      oggetto && (searchString += ' ' + oggetto.rifId + ' ' + oggetto.via + ' ' + oggetto.numeroCivico + ' ' + oggetto.numeroAppartamento + ' ' + oggetto.cap + ' ' + oggetto.citta);

      acquirente && (searchString += acquirente.nome + ' ' + acquirente.cognome + ' ' + acquirente.ditta);

      acquirente2 && (searchString += acquirente2.nome + ' ' + acquirente2.cognome + ' ' + acquirente2.ditta);

      venditore && (searchString += venditore.nome + ' ' + venditore.cognome + ' ' + venditore.ditta);

      venditore2 && (searchString += venditore2.nome + ' ' + venditore2.cognome + ' ' + venditore2.ditta);
    }

    if (nomeLista === 'oggetti') {
      createdAtMoment = (0, _moment2.default)(item.dataModificaOggetto);
      searchString = item.citta + ' ' + item.cap + ' ' + item.nazione + ' ' + item.numeroCivico + ' ' + item.numeroAppartamento + ' ' + item.quartiere + ' ' + item.rifId + ' ' + item.via;
    }

    if (nomeLista === 'clienti') {
      createdAtMoment = (0, _moment2.default)(item.dataRegistrazione);
      searchString = item.nome + ' ' + item.cognome + ' ' + item.ditta + ' ' + item.email + ' ' + item.telefono1 + ' ' + item.cellulare;
    }

    if (nomeLista === 'fatture') {
      createdAtMoment = (0, _moment2.default)(item.dataFattura);

      var deal = deals.find(function (deal) {
        return deal.id === item.dealId;
      });
      var _oggetto = deal ? oggetti.find(function (ogg) {
        return ogg.id === deal.oggettoId;
      }) : '';
      var cliente = findCliente(item.clienteId);
      var cliente2 = findCliente(item.clienteId2);

      cliente && (searchString += cliente.nome + ' ' + cliente.cognome + ' ' + cliente.ditta);

      cliente2 && (searchString += cliente2.nome + ' ' + cliente2.cognome + ' ' + cliente2.ditta);

      _oggetto && (searchString += _oggetto.rifId + ' ' + _oggetto.via + ' ' + _oggetto.numeroCivico + ' ' + _oggetto.numeroAppartamento + ' ' + _oggetto.cap + ' ' + _oggetto.citta);

      item.numeroFattura && (searchString += '' + item.numeroFattura);
    }

    if (nomeLista === 'evaluations') {
      createdAtMoment = (0, _moment2.default)(item.dataEvaluation);

      var oggettoDellaValutazione = item.oggettoId ? oggetti.find(function (ogg) {
        return ogg.id === item.oggettoId;
      }) : '';
      searchString += '' + item.titolo;
      searchString += '' + (oggettoDellaValutazione.rifId + ' ' + oggettoDellaValutazione.via + ' ' + oggettoDellaValutazione.numeroAppartamento + ', ' + oggettoDellaValutazione.cap + ' ' + oggettoDellaValutazione.citta);
    }

    if (nomeLista === 'newsletters') {
      createdAtMoment = (0, _moment2.default)(item.dataNewsletter);
      var oggetto1 = item.oggetto1 ? findOggetto(item.oggetto1).rifId : '';
      var oggetto2 = item.oggetto2 ? findOggetto(item.oggetto2).rifId : '';
      var oggetto3 = item.oggetto3 ? findOggetto(item.oggetto3).rifId : '';
      var oggetto4 = item.oggetto4 ? findOggetto(item.oggetto4).rifId : '';
      var oggetto5 = item.oggetto5 ? findOggetto(item.oggetto5).rifId : '';
      var oggetto6 = item.oggetto6 ? findOggetto(item.oggetto6).rifId : '';

      searchString += '' + oggetto1 + oggetto2 + oggetto3 + oggetto4 + oggetto5 + oggetto6;
    }
    var startDateMatch = startDate && createdAtMoment ? startDate.isSameOrBefore(createdAtMoment, 'day') : true;

    var endDateMatch = endDate && createdAtMoment ? endDate.isSameOrAfter(createdAtMoment, 'day') : true;

    var textMatch = searchString.toLowerCase().includes(text.toLowerCase());

    var sellerMatch = item.provvStefano > 0;

    // if (utente.role === 'Mitarbeiter') {
    //   return startDateMatch && endDateMatch && textMatch && sellerMatch;
    // } else {
    //   return startDateMatch && endDateMatch && textMatch;
    // }
    return startDateMatch && endDateMatch && textMatch;
  }).sort(function (a, b) {
    if (sortBy === 'date') {
      return a.createdAt < b.createdAt || a.dataModificaOggetto < b.dataModificaOggetto || a.dataRegistrazione < b.dataRegistrazione || a.dataFattura < b.dataFattura ? 1 : -1;
    } else if (sortBy === 'amount') {
      return a.provvStefano < b.provvStefano ? 1 : -1;
    } else if (sortBy === 'paid') {
      return a.payedStefano > b.payedStefano ? 1 : -1;
    } else if (sortBy === 'published') {
      return a.status < b.status ? 1 : -1;
    } else if (sortBy === 'name') {
      return a.via > b.via || a.cognome > b.cognome || a.numeroFattura > b.numeroFattura ? 1 : -1;
    }
  });
};

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _propTypes2['default'].oneOf(_constants.WEEKDAYS);

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(69);
var createDesc = __webpack_require__(154);
module.exports = __webpack_require__(71) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 88 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(577);
var defined = __webpack_require__(206);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(17).f;
var has = __webpack_require__(40);
var TAG = __webpack_require__(13)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(47);
var TAG = __webpack_require__(13)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var defined = __webpack_require__(53);
var fails = __webpack_require__(10);
var spaces = __webpack_require__(167);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(823);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return I18nContext; });
/* harmony export (immutable) */ __webpack_exports__["k"] = usedI18nextProvider;
/* harmony export (immutable) */ __webpack_exports__["e"] = getHasUsedI18nextProvider;
/* harmony export (immutable) */ __webpack_exports__["i"] = setDefaults;
/* harmony export (immutable) */ __webpack_exports__["d"] = getDefaults;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ReportNamespaces; });
/* harmony export (immutable) */ __webpack_exports__["j"] = setI18n;
/* harmony export (immutable) */ __webpack_exports__["f"] = getI18n;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return initReactI18next; });
/* harmony export (immutable) */ __webpack_exports__["c"] = composeInitialProps;
/* harmony export (immutable) */ __webpack_exports__["g"] = getInitialProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default.a(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


var defaultOptions = {
  bindI18n: 'languageChanged',
  bindI18nStore: '',
  // nsMode: 'fallback' // loop through all namespaces given to hook, HOC, render prop for key lookup
  transEmptyNodeValue: '',
  transSupportBasicHtmlNodes: true,
  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  // hashTransKey: key => key // calculate a key for Trans component based on defaultValue
  useSuspense: true
};
var i18nInstance;
var hasUsedI18nextProvider;
var I18nContext = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createContext();
function usedI18nextProvider(used) {
  hasUsedI18nextProvider = used;
}
function getHasUsedI18nextProvider() {
  return hasUsedI18nextProvider;
}
function setDefaults() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  defaultOptions = _objectSpread({}, defaultOptions, {}, options);
}
function getDefaults() {
  return defaultOptions;
}
var ReportNamespaces =
/*#__PURE__*/
function () {
  function ReportNamespaces() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default.a(this, ReportNamespaces);

    this.usedNamespaces = {};
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default.a(ReportNamespaces, [{
    key: "addUsedNamespaces",
    value: function addUsedNamespaces(namespaces) {
      var _this = this;

      namespaces.forEach(function (ns) {
        if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function getUsedNamespaces() {
      return Object.keys(this.usedNamespaces);
    }
  }]);

  return ReportNamespaces;
}();
function setI18n(instance) {
  i18nInstance = instance;
}
function getI18n() {
  return i18nInstance;
}
var initReactI18next = {
  type: '3rdParty',
  init: function init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};
function composeInitialProps(ForComponent) {
  return function (ctx) {
    return new Promise(function (resolve) {
      var i18nInitialProps = getInitialProps();

      if (ForComponent.getInitialProps) {
        ForComponent.getInitialProps(ctx).then(function (componentsInitialProps) {
          resolve(_objectSpread({}, componentsInitialProps, {}, i18nInitialProps));
        });
      } else {
        resolve(i18nInitialProps);
      }
    });
  }; // Avoid async for now - so we do not need to pull in regenerator
  // return async ctx => {
  //   const componentsInitialProps = ForComponent.getInitialProps
  //     ? await ForComponent.getInitialProps(ctx)
  //     : {};
  //   const i18nInitialProps = getInitialProps();
  //   return {
  //     ...componentsInitialProps,
  //     ...i18nInitialProps,
  //   };
  // };
}
function getInitialProps() {
  var i18n = getI18n();
  var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
  var ret = {};
  var initialI18nStore = {};
  i18n.languages.forEach(function (l) {
    initialI18nStore[l] = {};
    namespaces.forEach(function (ns) {
      initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
    });
  });
  ret.initialI18nStore = initialI18nStore;
  ret.initialLanguage = i18n.language;
  return ret;
}

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListFilters = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _reactDates = __webpack_require__(407);

var _filters = __webpack_require__(572);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _materializeCss = __webpack_require__(61);

var _materializeCss2 = _interopRequireDefault(_materializeCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListFilters = exports.ListFilters = function (_React$Component) {
  _inherits(ListFilters, _React$Component);

  function ListFilters() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ListFilters);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ListFilters.__proto__ || Object.getPrototypeOf(ListFilters)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      calendarFocused: null
    }, _this.onDatesChange = function (_ref2) {
      var startDate = _ref2.startDate,
          endDate = _ref2.endDate;

      _this.props.setStartDate(startDate);
      _this.props.setEndDate(endDate);
    }, _this.onFocusChange = function (calendarFocused) {
      _this.setState(function () {
        return { calendarFocused: calendarFocused };
      });
    }, _this.onTextChange = function (e) {
      _this.props.setTextFilter(e.target.value);
    }, _this.onSortChange = function (e) {
      if (e.target.value === 'date') {
        _this.props.sortByDate();
      } else if (e.target.value === 'amount') {
        _this.props.sortByAmount();
      } else if (e.target.value === 'paid') {
        _this.props.sortByPaid();
      } else if (e.target.value === 'published') {
        _this.props.sortByPublished();
      } else {
        _this.props.sortByName();
      }
    }, _this.renderDatePresets = function () {
      var startYear = 2018;
      var diff = (0, _moment2.default)().year() - startYear;
      var presets = [];
      for (var i = 0; i <= diff; i++) {
        var anno = startYear + i;
        presets.push({
          text: anno,
          start: (0, _moment2.default)([anno]),
          end: (0, _moment2.default)(anno + '-12-31')
        });
      }
      return _react2.default.createElement(
        'div',
        { className: 'container' },
        presets.map(function (_ref3) {
          var text = _ref3.text,
              start = _ref3.start,
              end = _ref3.end;

          return _react2.default.createElement(
            'button',
            {
              className: 'btn-floating margine-basso',
              key: text,
              type: 'button',
              onClick: function onClick() {
                return _this.onDatesChange({ startDate: start, endDate: end });
              }
            },
            text
          );
        })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ListFilters, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      _materializeCss2.default.AutoInit();
    }

    //Questo metodo visualizza gli anni nel datepicker

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          filters = _props.filters,
          options = _props.options;

      return _react2.default.createElement(
        'div',
        { className: 'container' },
        _react2.default.createElement(
          'div',
          { className: 'input-group' },
          _react2.default.createElement(
            'div',
            { className: 'input-field' },
            _react2.default.createElement('input', {
              id: 'deals-suche',
              type: 'text',
              className: 'input-field',
              value: filters.text,
              onChange: this.onTextChange
            }),
            _react2.default.createElement(
              'label',
              { className: 'active', htmlFor: 'deals-suche' },
              t('Cerca')
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'input-field ' },
            _react2.default.createElement(
              'select',
              { value: filters.sortBy, onChange: this.onSortChange },
              options.map(function (option) {
                return _react2.default.createElement(
                  'option',
                  { key: option.value, value: option.value },
                  t(option.label)
                );
              })
            ),
            _react2.default.createElement(
              'label',
              null,
              t('Ordina per')
            )
          ),
          _react2.default.createElement(
            'div',
            { className: '' },
            _react2.default.createElement(_reactDates.DateRangePicker, {
              startDate: filters.startDate,
              endDate: filters.endDate,
              onDatesChange: this.onDatesChange,
              focusedInput: this.state.calendarFocused,
              onFocusChange: this.onFocusChange,
              showClearDates: true,
              numberOfMonths: 1,
              isOutsideRange: function isOutsideRange() {
                return false;
              },
              displayFormat: 'DD.MM.YYYY',
              renderCalendarInfo: this.renderDatePresets
            })
          )
        )
      );
    }
  }]);

  return ListFilters;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    filters: state.filters
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setTextFilter: function setTextFilter(text) {
      return dispatch((0, _filters.setTextFilter)(text));
    },
    sortByDate: function sortByDate() {
      return dispatch((0, _filters.sortByDate)());
    },
    sortByAmount: function sortByAmount() {
      return dispatch((0, _filters.sortByAmount)());
    },
    sortByPaid: function sortByPaid() {
      return dispatch((0, _filters.sortByPaid)());
    },
    sortByPublished: function sortByPublished() {
      return dispatch((0, _filters.sortByPublished)());
    },
    sortByName: function sortByName() {
      return dispatch((0, _filters.sortByName)());
    },
    setStartDate: function setStartDate(startDate) {
      return dispatch((0, _filters.setStartDate)(startDate));
    },
    setEndDate: function setEndDate(endDate) {
      return dispatch((0, _filters.setEndDate)(endDate));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactI18next.withTranslation)()(ListFilters));

/***/ }),
/* 97 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = isTouchDevice;
function isTouchDevice() {
  return !!(typeof window !== 'undefined' && ('ontouchstart' in window || window.DocumentTouch && typeof document !== 'undefined' && document instanceof window.DocumentTouch)) || !!(typeof navigator !== 'undefined' && (navigator.maxTouchPoints || navigator.msMaxTouchPoints));
}
module.exports = exports['default'];

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _propTypes2['default'].oneOf([_constants.OPEN_DOWN, _constants.OPEN_UP]);

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toISODateString;

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _toMomentObject = __webpack_require__(100);

var _toMomentObject2 = _interopRequireDefault(_toMomentObject);

var _constants = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function toISODateString(date, currentFormat) {
  var dateObj = _moment2['default'].isMoment(date) ? date : (0, _toMomentObject2['default'])(date, currentFormat);
  if (!dateObj) return null;

  return dateObj.format(_constants.ISO_FORMAT);
}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toMomentObject;

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _constants = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function toMomentObject(dateString, customFormat) {
  var dateFormats = customFormat ? [customFormat, _constants.DISPLAY_FORMAT, _constants.ISO_FORMAT] : [_constants.DISPLAY_FORMAT, _constants.ISO_FORMAT];

  var date = (0, _moment2['default'])(dateString, dateFormats, true);
  return date.isValid() ? date.hour(12) : null;
}

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _propTypes2['default'].oneOf([_constants.HORIZONTAL_ORIENTATION, _constants.VERTICAL_ORIENTATION, _constants.VERTICAL_SCROLLABLE]);

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = isSameDay;

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function isSameDay(a, b) {
  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
  // Compare least significant, most likely to change units first
  // Moment's isSame clones moment inputs and is a tad slow
  return a.date() === b.date() && a.month() === b.month() && a.year() === b.year();
}

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(45);
var global = __webpack_require__(8);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(63) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(47);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 106 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(7);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(7);
var aFunction = __webpack_require__(26);
var SPECIES = __webpack_require__(13)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 109 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LogLevel", function() { return LogLevel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Logger", function() { return Logger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLogLevel", function() { return setLogLevel; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A container for all of the Logger instances
 */
var instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})(LogLevel || (LogLevel = {}));
/**
 * The default log level
 */
var defaultLogLevel = LogLevel.INFO;
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */
var defaultLogHandler = function (instance, logType) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    if (logType < instance.logLevel) {
        return;
    }
    var now = new Date().toISOString();
    switch (logType) {
        /**
         * By default, `console.debug` is not displayed in the developer console (in
         * chrome). To avoid forcing users to have to opt-in to these logs twice
         * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
         * logs to the `console.log` function.
         */
        case LogLevel.DEBUG:
            console.log.apply(console, __spreadArrays(["[" + now + "]  " + instance.name + ":"], args));
            break;
        case LogLevel.VERBOSE:
            console.log.apply(console, __spreadArrays(["[" + now + "]  " + instance.name + ":"], args));
            break;
        case LogLevel.INFO:
            console.info.apply(console, __spreadArrays(["[" + now + "]  " + instance.name + ":"], args));
            break;
        case LogLevel.WARN:
            console.warn.apply(console, __spreadArrays(["[" + now + "]  " + instance.name + ":"], args));
            break;
        case LogLevel.ERROR:
            console.error.apply(console, __spreadArrays(["[" + now + "]  " + instance.name + ":"], args));
            break;
        default:
            throw new Error("Attempted to log a message with an invalid logType (value: " + logType + ")");
    }
};
var Logger = /** @class */ (function () {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */
    function Logger(name) {
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */
        this._logLevel = defaultLogLevel;
        /**
         * The log handler for the Logger instance.
         */
        this._logHandler = defaultLogHandler;
        /**
         * Capture the current instance for later use
         */
        instances.push(this);
    }
    Object.defineProperty(Logger.prototype, "logLevel", {
        get: function () {
            return this._logLevel;
        },
        set: function (val) {
            if (!(val in LogLevel)) {
                throw new TypeError('Invalid value assigned to `logLevel`');
            }
            this._logLevel = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logger.prototype, "logHandler", {
        get: function () {
            return this._logHandler;
        },
        set: function (val) {
            if (typeof val !== 'function') {
                throw new TypeError('Value assigned to `logHandler` must be a function');
            }
            this._logHandler = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * The functions below are all based on the `console` interface
     */
    Logger.prototype.debug = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, __spreadArrays([this, LogLevel.DEBUG], args));
    };
    Logger.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, __spreadArrays([this, LogLevel.VERBOSE], args));
    };
    Logger.prototype.info = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, __spreadArrays([this, LogLevel.INFO], args));
    };
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, __spreadArrays([this, LogLevel.WARN], args));
    };
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, __spreadArrays([this, LogLevel.ERROR], args));
    };
    return Logger;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function setLogLevel(level) {
    instances.forEach(function (inst) {
        inst.logLevel = level;
    });
}


//# sourceMappingURL=index.esm.js.map


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule shallowCompare
 */



var shallowEqual = __webpack_require__(947);

/**
 * Does a shallow comparison for props and state.
 * See ReactComponentWithPureRenderMixin
 * See also https://facebook.github.io/react/docs/shallow-compare.html
 */
function shallowCompare(instance, nextProps, nextState) {
  return (
    !shallowEqual(instance.props, nextProps) ||
    !shallowEqual(instance.state, nextState)
  );
}

module.exports = shallowCompare;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = isInclusivelyAfterDay;

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _isBeforeDay = __webpack_require__(113);

var _isBeforeDay2 = _interopRequireDefault(_isBeforeDay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function isInclusivelyAfterDay(a, b) {
  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
  return !(0, _isBeforeDay2['default'])(a, b);
}

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = isBeforeDay;

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function isBeforeDay(a, b) {
  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;

  var aYear = a.year();
  var aMonth = a.month();

  var bYear = b.year();
  var bMonth = b.month();

  var isSameYear = aYear === bYear;
  var isSameMonth = aMonth === bMonth;

  if (isSameYear && isSameMonth) return a.date() < b.date();
  if (isSameYear) return aMonth < bMonth;
  return aYear < bYear;
}

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(957);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _propTypes2['default'].oneOf([_constants.ICON_BEFORE_POSITION, _constants.ICON_AFTER_POSITION]);

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = isAfterDay;

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _isBeforeDay = __webpack_require__(113);

var _isBeforeDay2 = _interopRequireDefault(_isBeforeDay);

var _isSameDay = __webpack_require__(102);

var _isSameDay2 = _interopRequireDefault(_isSameDay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function isAfterDay(a, b) {
  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
  return !(0, _isBeforeDay2['default'])(a, b) && !(0, _isSameDay2['default'])(a, b);
}

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(114);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(153);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(576);
var enumBugKeys = __webpack_require__(210);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 120 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(1011);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClientiList = undefined;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _configureStore = __webpack_require__(14);

var _deals = __webpack_require__(85);

var _deals2 = _interopRequireDefault(_deals);

var _Card = __webpack_require__(56);

var _Card2 = _interopRequireDefault(_Card);

var _elements = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClientiList = exports.ClientiList = function ClientiList(_ref) {
  var cliente = _ref.cliente,
      clienti = _ref.clienti,
      ruolo = _ref.ruolo,
      t = _ref.t;

  //controllo se i dati vengono dal deal page o se sono passati via props.
  var clientiPayload = cliente || clienti;

  return _react2.default.createElement(
    'div',
    { className: 'container' },
    _react2.default.createElement(
      'div',
      { className: 'list-body' },
      clientiPayload.length > 0 && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h5',
          null,
          ruolo || ''
        ),
        clientiPayload.sort(function (a, b) {
          return a.visible < b.visible ? -1 : 1;
        }).map(function (cliente) {
          var dsgvo = cliente.consensoDSGVO ? t('Consenso al trattamento dei dati personali') + ':' + ' ' + t('sì') : '';

          return _react2.default.createElement(_Card2.default, {
            key: cliente.id,
            link: '/clientiview/' + cliente.id,
            titolo: cliente.nome + ' ' + (cliente.cognome ? cliente.cognome : cliente.ditta),
            sottotitolo: cliente.ditta,
            corpo: [cliente.email, cliente.telefono1, cliente.cellulare, dsgvo],
            titoloDestra: (0, _elements.contactDetailsButton)(cliente),
            visible: cliente.visible
          });
        })
      )
    )
  );
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    clienti: (0, _deals2.default)('clienti', state.clienti, state.filters, state.utenti.find(function (utente) {
      return utente.firebaseAuthId === state.auth.uid;
    }))
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    startSetCustomers: function startSetCustomers() {
      return dispatch(_configureStore.storeActions.find(function (action) {
        return action.label === 'clienti';
      }).startSetAction());
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactI18next.withTranslation)()(ClientiList));

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(41);
var toLength = __webpack_require__(15);
var toAbsoluteIndex = __webpack_require__(77);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 127 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(47);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(48);
var defined = __webpack_require__(53);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(11);
var cof = __webpack_require__(47);
var MATCH = __webpack_require__(13)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(13)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(91);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(244);
var redefine = __webpack_require__(34);
var hide = __webpack_require__(33);
var fails = __webpack_require__(10);
var defined = __webpack_require__(53);
var wks = __webpack_require__(13);
var regexpExec = __webpack_require__(182);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(8);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(34);
var redefineAll = __webpack_require__(83);
var meta = __webpack_require__(64);
var forOf = __webpack_require__(82);
var anInstance = __webpack_require__(81);
var isObject = __webpack_require__(11);
var fails = __webpack_require__(10);
var $iterDetect = __webpack_require__(131);
var setToStringTag = __webpack_require__(90);
var inheritIfRequired = __webpack_require__(168);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var hide = __webpack_require__(33);
var uid = __webpack_require__(75);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(63) || !__webpack_require__(10)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(8)[K];
});


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(1);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(1);
var aFunction = __webpack_require__(26);
var ctx = __webpack_require__(46);
var forOf = __webpack_require__(82);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(845);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = warn;
/* harmony export (immutable) */ __webpack_exports__["e"] = warnOnce;
/* harmony export (immutable) */ __webpack_exports__["c"] = loadNamespaces;
/* harmony export (immutable) */ __webpack_exports__["b"] = hasLoadedNamespace;
/* harmony export (immutable) */ __webpack_exports__["a"] = getDisplayName;
function warn() {
  if (console && console.warn) {
    var _console;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);

    (_console = console).warn.apply(_console, args);
  }
}
var alreadyWarned = {};
function warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
  warn.apply(void 0, args);
} // not needed right now
//
// export function deprecated(...args) {
//   if (process && process.env && (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')) {
//     if (typeof args[0] === 'string') args[0] = `deprecation warning -> ${args[0]}`;
//     warnOnce(...args);
//   }
// }

function loadNamespaces(i18n, ns, cb) {
  i18n.loadNamespaces(ns, function () {
    // delay ready if not yet initialized i18n instance
    if (i18n.isInitialized) {
      cb();
    } else {
      var initialized = function initialized() {
        // due to emitter removing issue in i18next we need to delay remove
        setTimeout(function () {
          i18n.off('initialized', initialized);
        }, 0);
        cb();
      };

      i18n.on('initialized', initialized);
    }
  });
}
function hasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!i18n.languages || !i18n.languages.length) {
    warnOnce('i18n.languages were undefined or empty', i18n.languages);
    return true;
  }

  var lng = i18n.languages[0];
  var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  var lastLng = i18n.languages[i18n.languages.length - 1]; // we're in cimode so this shall pass

  if (lng.toLowerCase() === 'cimode') return true;

  var loadNotPending = function loadNotPending(l, n) {
    var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
    return loadState === -1 || loadState === 2;
  }; // bound to trigger on event languageChanging
  // so set ready to false while we are changing the language
  // and namespace pending (depends on having a backend)


  if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false; // loaded -> SUCCESS

  if (i18n.hasResourceBundle(lng, ns)) return true; // were not loading at all -> SEMI SUCCESS

  if (!i18n.services.backendConnector.backend) return true; // failed loading ns - but at least fallback is not pending -> SEMI SUCCESS

  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
  return false;
}
function getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}

/***/ }),
/* 142 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerInstallations", function() { return registerInstallations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tslib__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_util__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__firebase_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_idb__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_idb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_idb__);





var version = "0.3.5";

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var PENDING_TIMEOUT_MS = 10000;
var PACKAGE_VERSION = "w:" + version;
var INTERNAL_AUTH_VERSION = 'FIS_v2';
var INSTALLATIONS_API_URL = 'https://firebaseinstallations.googleapis.com/v1';
var TOKEN_EXPIRATION_BUFFER = 60 * 60 * 1000; // One hour
var SERVICE = 'installations';
var SERVICE_NAME = 'Installations';

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a;
var ERROR_DESCRIPTION_MAP = (_a = {},
    _a["missing-app-config-values" /* MISSING_APP_CONFIG_VALUES */] = 'Missing App configuration value: "{$valueName}"',
    _a["not-registered" /* NOT_REGISTERED */] = 'Firebase Installation is not registered.',
    _a["installation-not-found" /* INSTALLATION_NOT_FOUND */] = 'Firebase Installation not found.',
    _a["request-failed" /* REQUEST_FAILED */] = '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
    _a["app-offline" /* APP_OFFLINE */] = 'Could not process request. Application offline.',
    _a["delete-pending-registration" /* DELETE_PENDING_REGISTRATION */] = "Can't delete installation while there is a pending registration request.",
    _a);
var ERROR_FACTORY = new __WEBPACK_IMPORTED_MODULE_2__firebase_util__["ErrorFactory"](SERVICE, SERVICE_NAME, ERROR_DESCRIPTION_MAP);
/** Returns true if error is a FirebaseError that is based on an error from the server. */
function isServerError(error) {
    return (error instanceof __WEBPACK_IMPORTED_MODULE_2__firebase_util__["FirebaseError"] &&
        error.code.includes("request-failed" /* REQUEST_FAILED */));
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function extractAppConfig(app) {
    var e_1, _a;
    if (!app || !app.options) {
        throw getMissingValueError('App Configuration');
    }
    if (!app.name) {
        throw getMissingValueError('App Name');
    }
    // Required app config keys
    var configKeys = [
        'projectId',
        'apiKey',
        'appId'
    ];
    try {
        for (var configKeys_1 = __WEBPACK_IMPORTED_MODULE_1_tslib__["__values"](configKeys), configKeys_1_1 = configKeys_1.next(); !configKeys_1_1.done; configKeys_1_1 = configKeys_1.next()) {
            var keyName = configKeys_1_1.value;
            if (!app.options[keyName]) {
                throw getMissingValueError(keyName);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (configKeys_1_1 && !configKeys_1_1.done && (_a = configKeys_1.return)) _a.call(configKeys_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return {
        appName: app.name,
        projectId: app.options.projectId,
        apiKey: app.options.apiKey,
        appId: app.options.appId
    };
}
function getMissingValueError(valueName) {
    return ERROR_FACTORY.create("missing-app-config-values" /* MISSING_APP_CONFIG_VALUES */, {
        valueName: valueName
    });
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getInstallationsEndpoint(_a) {
    var projectId = _a.projectId;
    return INSTALLATIONS_API_URL + "/projects/" + projectId + "/installations";
}
function extractAuthTokenInfoFromResponse(response) {
    return {
        token: response.token,
        requestStatus: 2 /* COMPLETED */,
        expiresIn: getExpiresInFromResponseExpiresIn(response.expiresIn),
        creationTime: Date.now()
    };
}
function getErrorFromResponse(requestName, response) {
    return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
        var responseJson, errorData;
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, response.json()];
                case 1:
                    responseJson = _a.sent();
                    errorData = responseJson.error;
                    return [2 /*return*/, ERROR_FACTORY.create("request-failed" /* REQUEST_FAILED */, {
                            requestName: requestName,
                            serverCode: errorData.code,
                            serverMessage: errorData.message,
                            serverStatus: errorData.status
                        })];
            }
        });
    });
}
function getHeaders(_a) {
    var apiKey = _a.apiKey;
    return new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'x-goog-api-key': apiKey
    });
}
function getHeadersWithAuth(appConfig, _a) {
    var refreshToken = _a.refreshToken;
    var headers = getHeaders(appConfig);
    headers.append('Authorization', getAuthorizationHeader(refreshToken));
    return headers;
}
/**
 * Calls the passed in fetch wrapper and returns the response.
 * If the returned response has a status of 5xx, re-runs the function once and
 * returns the response.
 */
function retryIfServerError(fn) {
    return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fn()];
                case 1:
                    result = _a.sent();
                    if (result.status >= 500 && result.status < 600) {
                        // Internal Server Error. Retry request.
                        return [2 /*return*/, fn()];
                    }
                    return [2 /*return*/, result];
            }
        });
    });
}
function getExpiresInFromResponseExpiresIn(responseExpiresIn) {
    // This works because the server will never respond with fractions of a second.
    return Number(responseExpiresIn.replace('s', '000'));
}
function getAuthorizationHeader(refreshToken) {
    return INTERNAL_AUTH_VERSION + " " + refreshToken;
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function createInstallation(appConfig, _a) {
    var fid = _a.fid;
    return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
        var endpoint, headers, body, request, response, responseValue, registeredInstallationEntry;
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_b) {
            switch (_b.label) {
                case 0:
                    endpoint = getInstallationsEndpoint(appConfig);
                    headers = getHeaders(appConfig);
                    body = {
                        fid: fid,
                        authVersion: INTERNAL_AUTH_VERSION,
                        appId: appConfig.appId,
                        sdkVersion: PACKAGE_VERSION
                    };
                    request = {
                        method: 'POST',
                        headers: headers,
                        body: JSON.stringify(body)
                    };
                    return [4 /*yield*/, retryIfServerError(function () { return fetch(endpoint, request); })];
                case 1:
                    response = _b.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    responseValue = _b.sent();
                    registeredInstallationEntry = {
                        fid: responseValue.fid || fid,
                        registrationStatus: 2 /* COMPLETED */,
                        refreshToken: responseValue.refreshToken,
                        authToken: extractAuthTokenInfoFromResponse(responseValue.authToken)
                    };
                    return [2 /*return*/, registeredInstallationEntry];
                case 3: return [4 /*yield*/, getErrorFromResponse('Create Installation', response)];
                case 4: throw _b.sent();
            }
        });
    });
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Returns a promise that resolves after given time passes. */
function sleep(ms) {
    return new Promise(function (resolve) {
        setTimeout(resolve, ms);
    });
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function bufferToBase64UrlSafe(array) {
    var b64 = btoa(String.fromCharCode.apply(String, __WEBPACK_IMPORTED_MODULE_1_tslib__["__spread"](array)));
    return b64.replace(/\+/g, '-').replace(/\//g, '_');
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
var INVALID_FID = '';
/**
 * Generates a new FID using random values from Web Crypto API.
 * Returns an empty string if FID generation fails for any reason.
 */
function generateFid() {
    try {
        // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
        // bytes. our implementation generates a 17 byte array instead.
        var fidByteArray = new Uint8Array(17);
        var crypto_1 = self.crypto || self.msCrypto;
        crypto_1.getRandomValues(fidByteArray);
        // Replace the first 4 random bits with the constant FID header of 0b0111.
        fidByteArray[0] = 112 + (fidByteArray[0] % 16);
        var fid = encode(fidByteArray);
        return VALID_FID_PATTERN.test(fid) ? fid : INVALID_FID;
    }
    catch (_a) {
        // FID generation errored
        return INVALID_FID;
    }
}
/** Converts a FID Uint8Array to a base64 string representation. */
function encode(fidByteArray) {
    var b64String = bufferToBase64UrlSafe(fidByteArray);
    // Remove the 23rd character that was added because of the extra 4 bits at the
    // end of our 17 byte array, and the '=' padding.
    return b64String.substr(0, 22);
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DATABASE_NAME = 'firebase-installations-database';
var DATABASE_VERSION = 1;
var OBJECT_STORE_NAME = 'firebase-installations-store';
var dbPromise = null;
function getDbPromise() {
    if (!dbPromise) {
        dbPromise = __WEBPACK_IMPORTED_MODULE_3_idb__["openDb"](DATABASE_NAME, DATABASE_VERSION, function (upgradeDB) {
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch (upgradeDB.oldVersion) {
                case 0:
                    upgradeDB.createObjectStore(OBJECT_STORE_NAME);
            }
        });
    }
    return dbPromise;
}
/** Assigns or overwrites the record for the given key with the given value. */
function set(appConfig, value) {
    return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
        var key, db, tx;
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
            switch (_a.label) {
                case 0:
                    key = getKey(appConfig);
                    return [4 /*yield*/, getDbPromise()];
                case 1:
                    db = _a.sent();
                    tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
                    return [4 /*yield*/, tx.objectStore(OBJECT_STORE_NAME).put(value, key)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, tx.complete];
                case 3:
                    _a.sent();
                    return [2 /*return*/, value];
            }
        });
    });
}
/** Removes record(s) from the objectStore that match the given key. */
function remove(appConfig) {
    return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
        var key, db, tx;
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
            switch (_a.label) {
                case 0:
                    key = getKey(appConfig);
                    return [4 /*yield*/, getDbPromise()];
                case 1:
                    db = _a.sent();
                    tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
                    return [4 /*yield*/, tx.objectStore(OBJECT_STORE_NAME).delete(key)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, tx.complete];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
/**
 * Atomically updates a record with the result of updateFn, which gets
 * called with the current value. If newValue is undefined, the record is
 * deleted instead.
 * @return Updated value
 */
function update(appConfig, updateFn) {
    return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
        var key, db, tx, store, oldValue, newValue;
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
            switch (_a.label) {
                case 0:
                    key = getKey(appConfig);
                    return [4 /*yield*/, getDbPromise()];
                case 1:
                    db = _a.sent();
                    tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
                    store = tx.objectStore(OBJECT_STORE_NAME);
                    return [4 /*yield*/, store.get(key)];
                case 2:
                    oldValue = _a.sent();
                    newValue = updateFn(oldValue);
                    if (!(newValue === undefined)) return [3 /*break*/, 4];
                    return [4 /*yield*/, store.delete(key)];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 4: return [4 /*yield*/, store.put(newValue, key)];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6: return [4 /*yield*/, tx.complete];
                case 7:
                    _a.sent();
                    return [2 /*return*/, newValue];
            }
        });
    });
}
function getKey(appConfig) {
    return appConfig.appName + "!" + appConfig.appId;
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Updates and returns the InstallationEntry from the database.
 * Also triggers a registration request if it is necessary and possible.
 */
function getInstallationEntry(appConfig) {
    return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
        var registrationPromise, installationEntry, _a;
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, update(appConfig, function (oldEntry) {
                        var installationEntry = updateOrCreateInstallationEntry(oldEntry);
                        var entryWithPromise = triggerRegistrationIfNecessary(appConfig, installationEntry);
                        registrationPromise = entryWithPromise.registrationPromise;
                        return entryWithPromise.installationEntry;
                    })];
                case 1:
                    installationEntry = _b.sent();
                    if (!(installationEntry.fid === INVALID_FID)) return [3 /*break*/, 3];
                    _a = {};
                    return [4 /*yield*/, registrationPromise];
                case 2: 
                // FID generation failed. Waiting for the FID from the server.
                return [2 /*return*/, (_a.installationEntry = _b.sent(), _a)];
                case 3: return [2 /*return*/, {
                        installationEntry: installationEntry,
                        registrationPromise: registrationPromise
                    }];
            }
        });
    });
}
/**
 * Creates a new Installation Entry if one does not exist.
 * Also clears timed out pending requests.
 */
function updateOrCreateInstallationEntry(oldEntry) {
    var entry = oldEntry || {
        fid: generateFid(),
        registrationStatus: 0 /* NOT_STARTED */
    };
    return clearTimedOutRequest(entry);
}
/**
 * If the Firebase Installation is not registered yet, this will trigger the
 * registration and return an InProgressInstallationEntry.
 *
 * If registrationPromise does not exist, the installationEntry is guaranteed
 * to be registered.
 */
function triggerRegistrationIfNecessary(appConfig, installationEntry) {
    if (installationEntry.registrationStatus === 0 /* NOT_STARTED */) {
        if (!navigator.onLine) {
            // Registration required but app is offline.
            var registrationPromiseWithError = Promise.reject(ERROR_FACTORY.create("app-offline" /* APP_OFFLINE */));
            return {
                installationEntry: installationEntry,
                registrationPromise: registrationPromiseWithError
            };
        }
        // Try registering. Change status to IN_PROGRESS.
        var inProgressEntry = {
            fid: installationEntry.fid,
            registrationStatus: 1 /* IN_PROGRESS */,
            registrationTime: Date.now()
        };
        var registrationPromise = registerInstallation(appConfig, inProgressEntry);
        return { installationEntry: inProgressEntry, registrationPromise: registrationPromise };
    }
    else if (installationEntry.registrationStatus === 1 /* IN_PROGRESS */) {
        return {
            installationEntry: installationEntry,
            registrationPromise: waitUntilFidRegistration(appConfig)
        };
    }
    else {
        return { installationEntry: installationEntry };
    }
}
/** This will be executed only once for each new Firebase Installation. */
function registerInstallation(appConfig, installationEntry) {
    return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
        var registeredInstallationEntry, e_1;
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 7]);
                    return [4 /*yield*/, createInstallation(appConfig, installationEntry)];
                case 1:
                    registeredInstallationEntry = _a.sent();
                    return [2 /*return*/, set(appConfig, registeredInstallationEntry)];
                case 2:
                    e_1 = _a.sent();
                    if (!(isServerError(e_1) && e_1.serverCode === 409)) return [3 /*break*/, 4];
                    // Server returned a "FID can not be used" error.
                    // Generate a new ID next time.
                    return [4 /*yield*/, remove(appConfig)];
                case 3:
                    // Server returned a "FID can not be used" error.
                    // Generate a new ID next time.
                    _a.sent();
                    return [3 /*break*/, 6];
                case 4: 
                // Registration failed. Set FID as not registered.
                return [4 /*yield*/, set(appConfig, {
                        fid: installationEntry.fid,
                        registrationStatus: 0 /* NOT_STARTED */
                    })];
                case 5:
                    // Registration failed. Set FID as not registered.
                    _a.sent();
                    _a.label = 6;
                case 6: throw e_1;
                case 7: return [2 /*return*/];
            }
        });
    });
}
/** Call if FID registration is pending in another request. */
function waitUntilFidRegistration(appConfig) {
    return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
        var entry, _a, installationEntry, registrationPromise;
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, updateInstallationRequest(appConfig)];
                case 1:
                    entry = _b.sent();
                    _b.label = 2;
                case 2:
                    if (!(entry.registrationStatus === 1 /* IN_PROGRESS */)) return [3 /*break*/, 5];
                    // createInstallation request still in progress.
                    return [4 /*yield*/, sleep(100)];
                case 3:
                    // createInstallation request still in progress.
                    _b.sent();
                    return [4 /*yield*/, updateInstallationRequest(appConfig)];
                case 4:
                    entry = _b.sent();
                    return [3 /*break*/, 2];
                case 5:
                    if (!(entry.registrationStatus === 0 /* NOT_STARTED */)) return [3 /*break*/, 7];
                    return [4 /*yield*/, getInstallationEntry(appConfig)];
                case 6:
                    _a = _b.sent(), installationEntry = _a.installationEntry, registrationPromise = _a.registrationPromise;
                    if (registrationPromise) {
                        return [2 /*return*/, registrationPromise];
                    }
                    else {
                        // if there is no registrationPromise, entry is registered.
                        return [2 /*return*/, installationEntry];
                    }
                case 7: return [2 /*return*/, entry];
            }
        });
    });
}
/**
 * Called only if there is a CreateInstallation request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * CreateInstallation request.
 *
 * Returns the updated InstallationEntry.
 */
function updateInstallationRequest(appConfig) {
    return update(appConfig, function (oldEntry) {
        if (!oldEntry) {
            throw ERROR_FACTORY.create("installation-not-found" /* INSTALLATION_NOT_FOUND */);
        }
        return clearTimedOutRequest(oldEntry);
    });
}
function clearTimedOutRequest(entry) {
    if (hasInstallationRequestTimedOut(entry)) {
        return {
            fid: entry.fid,
            registrationStatus: 0 /* NOT_STARTED */
        };
    }
    return entry;
}
function hasInstallationRequestTimedOut(installationEntry) {
    return (installationEntry.registrationStatus === 1 /* IN_PROGRESS */ &&
        installationEntry.registrationTime + PENDING_TIMEOUT_MS < Date.now());
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function generateAuthToken(appConfig, installationEntry) {
    return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
        var endpoint, headers, body, request, response, responseValue, completedAuthToken;
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
            switch (_a.label) {
                case 0:
                    endpoint = getGenerateAuthTokenEndpoint(appConfig, installationEntry);
                    headers = getHeadersWithAuth(appConfig, installationEntry);
                    body = {
                        installation: {
                            sdkVersion: PACKAGE_VERSION
                        }
                    };
                    request = {
                        method: 'POST',
                        headers: headers,
                        body: JSON.stringify(body)
                    };
                    return [4 /*yield*/, retryIfServerError(function () { return fetch(endpoint, request); })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    responseValue = _a.sent();
                    completedAuthToken = extractAuthTokenInfoFromResponse(responseValue);
                    return [2 /*return*/, completedAuthToken];
                case 3: return [4 /*yield*/, getErrorFromResponse('Generate Auth Token', response)];
                case 4: throw _a.sent();
            }
        });
    });
}
function getGenerateAuthTokenEndpoint(appConfig, _a) {
    var fid = _a.fid;
    return getInstallationsEndpoint(appConfig) + "/" + fid + "/authTokens:generate";
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a valid authentication token for the installation. Generates a new
 * token if one doesn't exist, is expired or about to expire.
 *
 * Should only be called if the Firebase Installation is registered.
 */
function refreshAuthToken(appConfig, forceRefresh) {
    if (forceRefresh === void 0) { forceRefresh = false; }
    return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
        var tokenPromise, entry, authToken, _a;
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, update(appConfig, function (oldEntry) {
                        if (!isEntryRegistered(oldEntry)) {
                            throw ERROR_FACTORY.create("not-registered" /* NOT_REGISTERED */);
                        }
                        var oldAuthToken = oldEntry.authToken;
                        if (!forceRefresh && isAuthTokenValid(oldAuthToken)) {
                            // There is a valid token in the DB.
                            return oldEntry;
                        }
                        else if (oldAuthToken.requestStatus === 1 /* IN_PROGRESS */) {
                            // There already is a token request in progress.
                            tokenPromise = waitUntilAuthTokenRequest(appConfig, forceRefresh);
                            return oldEntry;
                        }
                        else {
                            // No token or token expired.
                            if (!navigator.onLine) {
                                throw ERROR_FACTORY.create("app-offline" /* APP_OFFLINE */);
                            }
                            var inProgressEntry = makeAuthTokenRequestInProgressEntry(oldEntry);
                            tokenPromise = fetchAuthTokenFromServer(appConfig, inProgressEntry);
                            return inProgressEntry;
                        }
                    })];
                case 1:
                    entry = _b.sent();
                    if (!tokenPromise) return [3 /*break*/, 3];
                    return [4 /*yield*/, tokenPromise];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = entry.authToken;
                    _b.label = 4;
                case 4:
                    authToken = _a;
                    return [2 /*return*/, authToken];
            }
        });
    });
}
/**
 * Call only if FID is registered and Auth Token request is in progress.
 */
function waitUntilAuthTokenRequest(appConfig, forceRefresh) {
    return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
        var entry, authToken;
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, updateAuthTokenRequest(appConfig)];
                case 1:
                    entry = _a.sent();
                    _a.label = 2;
                case 2:
                    if (!(entry.authToken.requestStatus === 1 /* IN_PROGRESS */)) return [3 /*break*/, 5];
                    // generateAuthToken still in progress.
                    return [4 /*yield*/, sleep(100)];
                case 3:
                    // generateAuthToken still in progress.
                    _a.sent();
                    return [4 /*yield*/, updateAuthTokenRequest(appConfig)];
                case 4:
                    entry = _a.sent();
                    return [3 /*break*/, 2];
                case 5:
                    authToken = entry.authToken;
                    if (authToken.requestStatus === 0 /* NOT_STARTED */) {
                        // The request timed out or failed in a different call. Try again.
                        return [2 /*return*/, refreshAuthToken(appConfig, forceRefresh)];
                    }
                    else {
                        return [2 /*return*/, authToken];
                    }
            }
        });
    });
}
/**
 * Called only if there is a GenerateAuthToken request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * GenerateAuthToken request.
 *
 * Returns the updated InstallationEntry.
 */
function updateAuthTokenRequest(appConfig) {
    return update(appConfig, function (oldEntry) {
        if (!isEntryRegistered(oldEntry)) {
            throw ERROR_FACTORY.create("not-registered" /* NOT_REGISTERED */);
        }
        var oldAuthToken = oldEntry.authToken;
        if (hasAuthTokenRequestTimedOut(oldAuthToken)) {
            return __WEBPACK_IMPORTED_MODULE_1_tslib__["__assign"](__WEBPACK_IMPORTED_MODULE_1_tslib__["__assign"]({}, oldEntry), { authToken: { requestStatus: 0 /* NOT_STARTED */ } });
        }
        return oldEntry;
    });
}
function fetchAuthTokenFromServer(appConfig, installationEntry) {
    return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
        var authToken, updatedInstallationEntry, e_1, updatedInstallationEntry;
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 8]);
                    return [4 /*yield*/, generateAuthToken(appConfig, installationEntry)];
                case 1:
                    authToken = _a.sent();
                    updatedInstallationEntry = __WEBPACK_IMPORTED_MODULE_1_tslib__["__assign"](__WEBPACK_IMPORTED_MODULE_1_tslib__["__assign"]({}, installationEntry), { authToken: authToken });
                    return [4 /*yield*/, set(appConfig, updatedInstallationEntry)];
                case 2:
                    _a.sent();
                    return [2 /*return*/, authToken];
                case 3:
                    e_1 = _a.sent();
                    if (!(isServerError(e_1) && (e_1.serverCode === 401 || e_1.serverCode === 404))) return [3 /*break*/, 5];
                    // Server returned a "FID not found" or a "Invalid authentication" error.
                    // Generate a new ID next time.
                    return [4 /*yield*/, remove(appConfig)];
                case 4:
                    // Server returned a "FID not found" or a "Invalid authentication" error.
                    // Generate a new ID next time.
                    _a.sent();
                    return [3 /*break*/, 7];
                case 5:
                    updatedInstallationEntry = __WEBPACK_IMPORTED_MODULE_1_tslib__["__assign"](__WEBPACK_IMPORTED_MODULE_1_tslib__["__assign"]({}, installationEntry), { authToken: { requestStatus: 0 /* NOT_STARTED */ } });
                    return [4 /*yield*/, set(appConfig, updatedInstallationEntry)];
                case 6:
                    _a.sent();
                    _a.label = 7;
                case 7: throw e_1;
                case 8: return [2 /*return*/];
            }
        });
    });
}
function isEntryRegistered(installationEntry) {
    return (installationEntry !== undefined &&
        installationEntry.registrationStatus === 2 /* COMPLETED */);
}
function isAuthTokenValid(authToken) {
    return (authToken.requestStatus === 2 /* COMPLETED */ &&
        !isAuthTokenExpired(authToken));
}
function isAuthTokenExpired(authToken) {
    var now = Date.now();
    return (now < authToken.creationTime ||
        authToken.creationTime + authToken.expiresIn < now + TOKEN_EXPIRATION_BUFFER);
}
/** Returns an updated InstallationEntry with an InProgressAuthToken. */
function makeAuthTokenRequestInProgressEntry(oldEntry) {
    var inProgressAuthToken = {
        requestStatus: 1 /* IN_PROGRESS */,
        requestTime: Date.now()
    };
    return __WEBPACK_IMPORTED_MODULE_1_tslib__["__assign"](__WEBPACK_IMPORTED_MODULE_1_tslib__["__assign"]({}, oldEntry), { authToken: inProgressAuthToken });
}
function hasAuthTokenRequestTimedOut(authToken) {
    return (authToken.requestStatus === 1 /* IN_PROGRESS */ &&
        authToken.requestTime + PENDING_TIMEOUT_MS < Date.now());
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getId(app) {
    return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
        var appConfig, _a, installationEntry, registrationPromise;
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_b) {
            switch (_b.label) {
                case 0:
                    appConfig = extractAppConfig(app);
                    return [4 /*yield*/, getInstallationEntry(appConfig)];
                case 1:
                    _a = _b.sent(), installationEntry = _a.installationEntry, registrationPromise = _a.registrationPromise;
                    if (registrationPromise) {
                        registrationPromise.catch(console.error);
                    }
                    else {
                        // If the installation is already registered, update the authentication
                        // token if needed.
                        refreshAuthToken(appConfig).catch(console.error);
                    }
                    return [2 /*return*/, installationEntry.fid];
            }
        });
    });
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getToken(app, forceRefresh) {
    if (forceRefresh === void 0) { forceRefresh = false; }
    return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
        var appConfig, authToken;
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
            switch (_a.label) {
                case 0:
                    appConfig = extractAppConfig(app);
                    return [4 /*yield*/, completeInstallationRegistration(appConfig)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, refreshAuthToken(appConfig, forceRefresh)];
                case 2:
                    authToken = _a.sent();
                    return [2 /*return*/, authToken.token];
            }
        });
    });
}
function completeInstallationRegistration(appConfig) {
    return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
        var registrationPromise;
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getInstallationEntry(appConfig)];
                case 1:
                    registrationPromise = (_a.sent()).registrationPromise;
                    if (!registrationPromise) return [3 /*break*/, 3];
                    // A createInstallation request is in progress. Wait until it finishes.
                    return [4 /*yield*/, registrationPromise];
                case 2:
                    // A createInstallation request is in progress. Wait until it finishes.
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function deleteInstallation(appConfig, installationEntry) {
    return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
        var endpoint, headers, request, response;
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
            switch (_a.label) {
                case 0:
                    endpoint = getDeleteEndpoint(appConfig, installationEntry);
                    headers = getHeadersWithAuth(appConfig, installationEntry);
                    request = {
                        method: 'DELETE',
                        headers: headers
                    };
                    return [4 /*yield*/, retryIfServerError(function () { return fetch(endpoint, request); })];
                case 1:
                    response = _a.sent();
                    if (!!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, getErrorFromResponse('Delete Installation', response)];
                case 2: throw _a.sent();
                case 3: return [2 /*return*/];
            }
        });
    });
}
function getDeleteEndpoint(appConfig, _a) {
    var fid = _a.fid;
    return getInstallationsEndpoint(appConfig) + "/" + fid;
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function deleteInstallation$1(app) {
    return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
        var appConfig, entry;
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
            switch (_a.label) {
                case 0:
                    appConfig = extractAppConfig(app);
                    return [4 /*yield*/, update(appConfig, function (oldEntry) {
                            if (oldEntry && oldEntry.registrationStatus === 0 /* NOT_STARTED */) {
                                // Delete the unregistered entry without sending a deleteInstallation request.
                                return undefined;
                            }
                            return oldEntry;
                        })];
                case 1:
                    entry = _a.sent();
                    if (!entry) return [3 /*break*/, 6];
                    if (!(entry.registrationStatus === 1 /* IN_PROGRESS */)) return [3 /*break*/, 2];
                    // Can't delete while trying to register.
                    throw ERROR_FACTORY.create("delete-pending-registration" /* DELETE_PENDING_REGISTRATION */);
                case 2:
                    if (!(entry.registrationStatus === 2 /* COMPLETED */)) return [3 /*break*/, 6];
                    if (!!navigator.onLine) return [3 /*break*/, 3];
                    throw ERROR_FACTORY.create("app-offline" /* APP_OFFLINE */);
                case 3: return [4 /*yield*/, deleteInstallation(appConfig, entry)];
                case 4:
                    _a.sent();
                    return [4 /*yield*/, remove(appConfig)];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    });
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function registerInstallations(instance) {
    var installationsName = 'installations';
    var factoryMethod = function (app) {
        // Throws if app isn't configured properly.
        extractAppConfig(app);
        return {
            app: app,
            getId: function () { return getId(app); },
            getToken: function (forceRefresh) { return getToken(app, forceRefresh); },
            delete: function () { return deleteInstallation$1(app); }
        };
    };
    instance.INTERNAL.registerService(installationsName, factoryMethod);
}
registerInstallations(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a);


//# sourceMappingURL=index.esm.js.map


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction) {
    throw new Error(prefix);
  } else {
    throw new Error(prefix + ": " + (message || ''));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (invariant);


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        module.exports = factory();
    } else {
        global.numeral = factory();
    }
}(this, function () {
    /************************************
        Variables
    ************************************/

    var numeral,
        _,
        VERSION = '2.0.6',
        formats = {},
        locales = {},
        defaults = {
            currentLocale: 'en',
            zeroFormat: null,
            nullFormat: null,
            defaultFormat: '0,0',
            scalePercentBy100: true
        },
        options = {
            currentLocale: defaults.currentLocale,
            zeroFormat: defaults.zeroFormat,
            nullFormat: defaults.nullFormat,
            defaultFormat: defaults.defaultFormat,
            scalePercentBy100: defaults.scalePercentBy100
        };


    /************************************
        Constructors
    ************************************/

    // Numeral prototype object
    function Numeral(input, number) {
        this._input = input;

        this._value = number;
    }

    numeral = function(input) {
        var value,
            kind,
            unformatFunction,
            regexp;

        if (numeral.isNumeral(input)) {
            value = input.value();
        } else if (input === 0 || typeof input === 'undefined') {
            value = 0;
        } else if (input === null || _.isNaN(input)) {
            value = null;
        } else if (typeof input === 'string') {
            if (options.zeroFormat && input === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                for (kind in formats) {
                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;

                    if (regexp && input.match(regexp)) {
                        unformatFunction = formats[kind].unformat;

                        break;
                    }
                }

                unformatFunction = unformatFunction || numeral._.stringToNumber;

                value = unformatFunction(input);
            }
        } else {
            value = Number(input)|| null;
        }

        return new Numeral(input, value);
    };

    // version number
    numeral.version = VERSION;

    // compare numeral object
    numeral.isNumeral = function(obj) {
        return obj instanceof Numeral;
    };

    // helper functions
    numeral._ = _ = {
        // formats numbers separators, decimals places, signs, abbreviations
        numberToFormat: function(value, format, roundingFunction) {
            var locale = locales[numeral.options.currentLocale],
                negP = false,
                optDec = false,
                leadingCount = 0,
                abbr = '',
                trillion = 1000000000000,
                billion = 1000000000,
                million = 1000000,
                thousand = 1000,
                decimal = '',
                neg = false,
                abbrForce, // force abbreviation
                abs,
                min,
                max,
                power,
                int,
                precision,
                signed,
                thousands,
                output;

            // make sure we never format a null value
            value = value || 0;

            abs = Math.abs(value);

            // see if we should use parentheses for negative number or if we should prefix with a sign
            // if both are present we default to parentheses
            if (numeral._.includes(format, '(')) {
                negP = true;
                format = format.replace(/[\(|\)]/g, '');
            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
                format = format.replace(/[\+|\-]/g, '');
            }

            // see if abbreviation is wanted
            if (numeral._.includes(format, 'a')) {
                abbrForce = format.match(/a(k|m|b|t)?/);

                abbrForce = abbrForce ? abbrForce[1] : false;

                // check for space before abbreviation
                if (numeral._.includes(format, ' a')) {
                    abbr = ' ';
                }

                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');

                if (abs >= trillion && !abbrForce || abbrForce === 't') {
                    // trillion
                    abbr += locale.abbreviations.trillion;
                    value = value / trillion;
                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
                    // billion
                    abbr += locale.abbreviations.billion;
                    value = value / billion;
                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
                    // million
                    abbr += locale.abbreviations.million;
                    value = value / million;
                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
                    // thousand
                    abbr += locale.abbreviations.thousand;
                    value = value / thousand;
                }
            }

            // check for optional decimals
            if (numeral._.includes(format, '[.]')) {
                optDec = true;
                format = format.replace('[.]', '.');
            }

            // break number and format
            int = value.toString().split('.')[0];
            precision = format.split('.')[1];
            thousands = format.indexOf(',');
            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;

            if (precision) {
                if (numeral._.includes(precision, '[')) {
                    precision = precision.replace(']', '');
                    precision = precision.split('[');
                    decimal = numeral._.toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
                } else {
                    decimal = numeral._.toFixed(value, precision.length, roundingFunction);
                }

                int = decimal.split('.')[0];

                if (numeral._.includes(decimal, '.')) {
                    decimal = locale.delimiters.decimal + decimal.split('.')[1];
                } else {
                    decimal = '';
                }

                if (optDec && Number(decimal.slice(1)) === 0) {
                    decimal = '';
                }
            } else {
                int = numeral._.toFixed(value, 0, roundingFunction);
            }

            // check abbreviation again after rounding
            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
                int = String(Number(int) / 1000);

                switch (abbr) {
                    case locale.abbreviations.thousand:
                        abbr = locale.abbreviations.million;
                        break;
                    case locale.abbreviations.million:
                        abbr = locale.abbreviations.billion;
                        break;
                    case locale.abbreviations.billion:
                        abbr = locale.abbreviations.trillion;
                        break;
                }
            }


            // format number
            if (numeral._.includes(int, '-')) {
                int = int.slice(1);
                neg = true;
            }

            if (int.length < leadingCount) {
                for (var i = leadingCount - int.length; i > 0; i--) {
                    int = '0' + int;
                }
            }

            if (thousands > -1) {
                int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
            }

            if (format.indexOf('.') === 0) {
                int = '';
            }

            output = int + decimal + (abbr ? abbr : '');

            if (negP) {
                output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
            } else {
                if (signed >= 0) {
                    output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
                } else if (neg) {
                    output = '-' + output;
                }
            }

            return output;
        },
        // unformats numbers separators, decimals places, signs, abbreviations
        stringToNumber: function(string) {
            var locale = locales[options.currentLocale],
                stringOriginal = string,
                abbreviations = {
                    thousand: 3,
                    million: 6,
                    billion: 9,
                    trillion: 12
                },
                abbreviation,
                value,
                i,
                regexp;

            if (options.zeroFormat && string === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                value = 1;

                if (locale.delimiters.decimal !== '.') {
                    string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
                }

                for (abbreviation in abbreviations) {
                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');

                    if (stringOriginal.match(regexp)) {
                        value *= Math.pow(10, abbreviations[abbreviation]);
                        break;
                    }
                }

                // check for negative number
                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;

                // remove non numbers
                string = string.replace(/[^0-9\.]+/g, '');

                value *= Number(string);
            }

            return value;
        },
        isNaN: function(value) {
            return typeof value === 'number' && isNaN(value);
        },
        includes: function(string, search) {
            return string.indexOf(search) !== -1;
        },
        insert: function(string, subString, start) {
            return string.slice(0, start) + subString + string.slice(start);
        },
        reduce: function(array, callback /*, initialValue*/) {
            if (this === null) {
                throw new TypeError('Array.prototype.reduce called on null or undefined');
            }

            if (typeof callback !== 'function') {
                throw new TypeError(callback + ' is not a function');
            }

            var t = Object(array),
                len = t.length >>> 0,
                k = 0,
                value;

            if (arguments.length === 3) {
                value = arguments[2];
            } else {
                while (k < len && !(k in t)) {
                    k++;
                }

                if (k >= len) {
                    throw new TypeError('Reduce of empty array with no initial value');
                }

                value = t[k++];
            }
            for (; k < len; k++) {
                if (k in t) {
                    value = callback(value, t[k], k, t);
                }
            }
            return value;
        },
        /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */
        multiplier: function (x) {
            var parts = x.toString().split('.');

            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
        },
        /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */
        correctionFactor: function () {
            var args = Array.prototype.slice.call(arguments);

            return args.reduce(function(accum, next) {
                var mn = _.multiplier(next);
                return accum > mn ? accum : mn;
            }, 1);
        },
        /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */
        toFixed: function(value, maxDecimals, roundingFunction, optionals) {
            var splitValue = value.toString().split('.'),
                minDecimals = maxDecimals - (optionals || 0),
                boundedPrecision,
                optionalsRegExp,
                power,
                output;

            // Use the smallest precision value possible to avoid errors from floating point representation
            if (splitValue.length === 2) {
              boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
            } else {
              boundedPrecision = minDecimals;
            }

            power = Math.pow(10, boundedPrecision);

            // Multiply up by precision, round accurately, then divide and use native toFixed():
            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);

            if (optionals > maxDecimals - boundedPrecision) {
                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
                output = output.replace(optionalsRegExp, '');
            }

            return output;
        }
    };

    // avaliable options
    numeral.options = options;

    // avaliable formats
    numeral.formats = formats;

    // avaliable formats
    numeral.locales = locales;

    // This function sets the current locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    numeral.locale = function(key) {
        if (key) {
            options.currentLocale = key.toLowerCase();
        }

        return options.currentLocale;
    };

    // This function provides access to the loaded locale data.  If
    // no arguments are passed in, it will simply return the current
    // global locale object.
    numeral.localeData = function(key) {
        if (!key) {
            return locales[options.currentLocale];
        }

        key = key.toLowerCase();

        if (!locales[key]) {
            throw new Error('Unknown locale : ' + key);
        }

        return locales[key];
    };

    numeral.reset = function() {
        for (var property in defaults) {
            options[property] = defaults[property];
        }
    };

    numeral.zeroFormat = function(format) {
        options.zeroFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.nullFormat = function (format) {
        options.nullFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.defaultFormat = function(format) {
        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
    };

    numeral.register = function(type, name, format) {
        name = name.toLowerCase();

        if (this[type + 's'][name]) {
            throw new TypeError(name + ' ' + type + ' already registered.');
        }

        this[type + 's'][name] = format;

        return format;
    };


    numeral.validate = function(val, culture) {
        var _decimalSep,
            _thousandSep,
            _currSymbol,
            _valArray,
            _abbrObj,
            _thousandRegEx,
            localeData,
            temp;

        //coerce val to string
        if (typeof val !== 'string') {
            val += '';

            if (console.warn) {
                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
            }
        }

        //trim whitespaces from either sides
        val = val.trim();

        //if val is just digits return true
        if (!!val.match(/^\d+$/)) {
            return true;
        }

        //if val is empty return false
        if (val === '') {
            return false;
        }

        //get the decimal and thousands separator from numeral.localeData
        try {
            //check if the culture is understood by numeral. if not, default it to current locale
            localeData = numeral.localeData(culture);
        } catch (e) {
            localeData = numeral.localeData(numeral.locale());
        }

        //setup the delimiters and currency symbol based on culture/locale
        _currSymbol = localeData.currency.symbol;
        _abbrObj = localeData.abbreviations;
        _decimalSep = localeData.delimiters.decimal;
        if (localeData.delimiters.thousands === '.') {
            _thousandSep = '\\.';
        } else {
            _thousandSep = localeData.delimiters.thousands;
        }

        // validating currency symbol
        temp = val.match(/^[^\d]+/);
        if (temp !== null) {
            val = val.substr(1);
            if (temp[0] !== _currSymbol) {
                return false;
            }
        }

        //validating abbreviation symbol
        temp = val.match(/[^\d]+$/);
        if (temp !== null) {
            val = val.slice(0, -1);
            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
                return false;
            }
        }

        _thousandRegEx = new RegExp(_thousandSep + '{2}');

        if (!val.match(/[^\d.,]/g)) {
            _valArray = val.split(_decimalSep);
            if (_valArray.length > 2) {
                return false;
            } else {
                if (_valArray.length < 2) {
                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
                } else {
                    if (_valArray[0].length === 1) {
                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    } else {
                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    }
                }
            }
        }

        return false;
    };


    /************************************
        Numeral Prototype
    ************************************/

    numeral.fn = Numeral.prototype = {
        clone: function() {
            return numeral(this);
        },
        format: function(inputString, roundingFunction) {
            var value = this._value,
                format = inputString || options.defaultFormat,
                kind,
                output,
                formatFunction;

            // make sure we have a roundingFunction
            roundingFunction = roundingFunction || Math.round;

            // format based on value
            if (value === 0 && options.zeroFormat !== null) {
                output = options.zeroFormat;
            } else if (value === null && options.nullFormat !== null) {
                output = options.nullFormat;
            } else {
                for (kind in formats) {
                    if (format.match(formats[kind].regexps.format)) {
                        formatFunction = formats[kind].format;

                        break;
                    }
                }

                formatFunction = formatFunction || numeral._.numberToFormat;

                output = formatFunction(value, format, roundingFunction);
            }

            return output;
        },
        value: function() {
            return this._value;
        },
        input: function() {
            return this._input;
        },
        set: function(value) {
            this._value = Number(value);

            return this;
        },
        add: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum + Math.round(corrFactor * curr);
            }

            this._value = _.reduce([this._value, value], cback, 0) / corrFactor;

            return this;
        },
        subtract: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum - Math.round(corrFactor * curr);
            }

            this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;

            return this;
        },
        multiply: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback, 1);

            return this;
        },
        divide: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback);

            return this;
        },
        difference: function(value) {
            return Math.abs(numeral(this._value).subtract(value).value());
        }
    };

    /************************************
        Default Locale && Format
    ************************************/

    numeral.register('locale', 'en', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function(number) {
            var b = number % 10;
            return (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: '$'
        }
    });

    

(function() {
        numeral.register('format', 'bps', {
            regexps: {
                format: /(BPS)/,
                unformat: /(BPS)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, ' BPS') ? ' ' : '',
                    output;

                value = value * 10000;

                // check for space before BPS
                format = format.replace(/\s?BPS/, '');

                output = numeral._.numberToFormat(value, format, roundingFunction);

                if (numeral._.includes(output, ')')) {
                    output = output.split('');

                    output.splice(-1, 0, space + 'BPS');

                    output = output.join('');
                } else {
                    output = output + space + 'BPS';
                }

                return output;
            },
            unformat: function(string) {
                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
            }
        });
})();


(function() {
        var decimal = {
            base: 1000,
            suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        },
        binary = {
            base: 1024,
            suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
        };

    var allSuffixes =  decimal.suffixes.concat(binary.suffixes.filter(function (item) {
            return decimal.suffixes.indexOf(item) < 0;
        }));
        var unformatRegex = allSuffixes.join('|');
        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';

    numeral.register('format', 'bytes', {
        regexps: {
            format: /([0\s]i?b)/,
            unformat: new RegExp(unformatRegex)
        },
        format: function(value, format, roundingFunction) {
            var output,
                bytes = numeral._.includes(format, 'ib') ? binary : decimal,
                suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
                power,
                min,
                max;

            // check for space before
            format = format.replace(/\s?i?b/, '');

            for (power = 0; power <= bytes.suffixes.length; power++) {
                min = Math.pow(bytes.base, power);
                max = Math.pow(bytes.base, power + 1);

                if (value === null || value === 0 || value >= min && value < max) {
                    suffix += bytes.suffixes[power];

                    if (min > 0) {
                        value = value / min;
                    }

                    break;
                }
            }

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + suffix;
        },
        unformat: function(string) {
            var value = numeral._.stringToNumber(string),
                power,
                bytesMultiplier;

            if (value) {
                for (power = decimal.suffixes.length - 1; power >= 0; power--) {
                    if (numeral._.includes(string, decimal.suffixes[power])) {
                        bytesMultiplier = Math.pow(decimal.base, power);

                        break;
                    }

                    if (numeral._.includes(string, binary.suffixes[power])) {
                        bytesMultiplier = Math.pow(binary.base, power);

                        break;
                    }
                }

                value *= (bytesMultiplier || 1);
            }

            return value;
        }
    });
})();


(function() {
        numeral.register('format', 'currency', {
        regexps: {
            format: /(\$)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                symbols = {
                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
                },
                output,
                symbol,
                i;

            // strip format of spaces and $
            format = format.replace(/\s?\$\s?/, '');

            // format the number
            output = numeral._.numberToFormat(value, format, roundingFunction);

            // update the before and after based on value
            if (value >= 0) {
                symbols.before = symbols.before.replace(/[\-\(]/, '');
                symbols.after = symbols.after.replace(/[\-\)]/, '');
            } else if (value < 0 && (!numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '('))) {
                symbols.before = '-' + symbols.before;
            }

            // loop through each before symbol
            for (i = 0; i < symbols.before.length; i++) {
                symbol = symbols.before[i];

                switch (symbol) {
                    case '$':
                        output = numeral._.insert(output, locale.currency.symbol, i);
                        break;
                    case ' ':
                        output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
                        break;
                }
            }

            // loop through each after symbol
            for (i = symbols.after.length - 1; i >= 0; i--) {
                symbol = symbols.after[i];

                switch (symbol) {
                    case '$':
                        output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
                        break;
                    case ' ':
                        output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
                        break;
                }
            }


            return output;
        }
    });
})();


(function() {
        numeral.register('format', 'exponential', {
        regexps: {
            format: /(e\+|e-)/,
            unformat: /(e\+|e-)/
        },
        format: function(value, format, roundingFunction) {
            var output,
                exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
                parts = exponential.split('e');

            format = format.replace(/e[\+|\-]{1}0/, '');

            output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);

            return output + 'e' + parts[1];
        },
        unformat: function(string) {
            var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
                value = Number(parts[0]),
                power = Number(parts[1]);

            power = numeral._.includes(string, 'e-') ? power *= -1 : power;

            function cback(accum, curr, currI, O) {
                var corrFactor = numeral._.correctionFactor(accum, curr),
                    num = (accum * corrFactor) * (curr * corrFactor) / (corrFactor * corrFactor);
                return num;
            }

            return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
        }
    });
})();


(function() {
        numeral.register('format', 'ordinal', {
        regexps: {
            format: /(o)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                output,
                ordinal = numeral._.includes(format, ' o') ? ' ' : '';

            // check for space before
            format = format.replace(/\s?o/, '');

            ordinal += locale.ordinal(value);

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + ordinal;
        }
    });
})();


(function() {
        numeral.register('format', 'percentage', {
        regexps: {
            format: /(%)/,
            unformat: /(%)/
        },
        format: function(value, format, roundingFunction) {
            var space = numeral._.includes(format, ' %') ? ' ' : '',
                output;

            if (numeral.options.scalePercentBy100) {
                value = value * 100;
            }

            // check for space before %
            format = format.replace(/\s?\%/, '');

            output = numeral._.numberToFormat(value, format, roundingFunction);

            if (numeral._.includes(output, ')')) {
                output = output.split('');

                output.splice(-1, 0, space + '%');

                output = output.join('');
            } else {
                output = output + space + '%';
            }

            return output;
        },
        unformat: function(string) {
            var number = numeral._.stringToNumber(string);
            if (numeral.options.scalePercentBy100) {
                return number * 0.01;
            }
            return number;
        }
    });
})();


(function() {
        numeral.register('format', 'time', {
        regexps: {
            format: /(:)/,
            unformat: /(:)/
        },
        format: function(value, format, roundingFunction) {
            var hours = Math.floor(value / 60 / 60),
                minutes = Math.floor((value - (hours * 60 * 60)) / 60),
                seconds = Math.round(value - (hours * 60 * 60) - (minutes * 60));

            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
        },
        unformat: function(string) {
            var timeArray = string.split(':'),
                seconds = 0;

            // turn hours and minutes into seconds and add them all up
            if (timeArray.length === 3) {
                // hours
                seconds = seconds + (Number(timeArray[0]) * 60 * 60);
                // minutes
                seconds = seconds + (Number(timeArray[1]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[2]);
            } else if (timeArray.length === 2) {
                // minutes
                seconds = seconds + (Number(timeArray[0]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[1]);
            }
            return Number(seconds);
        }
    });
})();

return numeral;
}));


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 73);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __webpack_require__(2);

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

module.exports = __webpack_require__(149);

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __webpack_require__(6);

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _consolidatedEvents = __webpack_require__(18);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

// import { forbidExtraProps } from 'airbnb-prop-types'; // TODO: add to propTypes; semver-major


var propTypes = {
  children: _propTypes2['default'].node,
  onOutsideClick: _propTypes2['default'].func
};

var defaultProps = {
  children: _react2['default'].createElement('span', null),
  onOutsideClick: function () {
    function onOutsideClick() {}

    return onOutsideClick;
  }()
};

var OutsideClickHandler = function (_React$Component) {
  _inherits(OutsideClickHandler, _React$Component);

  function OutsideClickHandler() {
    var _ref;

    _classCallCheck(this, OutsideClickHandler);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = OutsideClickHandler.__proto__ || Object.getPrototypeOf(OutsideClickHandler)).call.apply(_ref, [this].concat(args)));

    _this.onOutsideClick = _this.onOutsideClick.bind(_this);
    _this.setChildNodeRef = _this.setChildNodeRef.bind(_this);
    return _this;
  }

  _createClass(OutsideClickHandler, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        // `capture` flag is set to true so that a `stopPropagation` in the children
        // will not prevent all outside click handlers from firing - maja
        this.clickHandle = (0, _consolidatedEvents.addEventListener)(document, 'click', this.onOutsideClick, { capture: true });
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        if (this.clickHandle) {
          (0, _consolidatedEvents.removeEventListener)(this.clickHandle);
        }
      }

      return componentWillUnmount;
    }()
  }, {
    key: 'onOutsideClick',
    value: function () {
      function onOutsideClick(e) {
        var onOutsideClick = this.props.onOutsideClick;
        var childNode = this.childNode;

        var isDescendantOfRoot = childNode && childNode.contains(e.target);
        if (!isDescendantOfRoot) {
          onOutsideClick(e);
        }
      }

      return onOutsideClick;
    }()
  }, {
    key: 'setChildNodeRef',
    value: function () {
      function setChildNodeRef(ref) {
        this.childNode = ref;
      }

      return setChildNodeRef;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement('div', { ref: this.setChildNodeRef }, this.props.children);
      }

      return render;
    }()
  }]);

  return OutsideClickHandler;
}(_react2['default'].Component);

exports['default'] = OutsideClickHandler;

OutsideClickHandler.propTypes = propTypes;
OutsideClickHandler.defaultProps = defaultProps;

/***/ })

/******/ });

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EVENT_HANDLERS_KEY = undefined;
exports.addEventListener = addEventListener;
exports.removeEventListener = removeEventListener;

var _normalizeEventOptions = __webpack_require__(948);

var _normalizeEventOptions2 = _interopRequireDefault(_normalizeEventOptions);

var _TargetEventHandlers = __webpack_require__(951);

var _TargetEventHandlers2 = _interopRequireDefault(_TargetEventHandlers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Export to make testing possible.
var EVENT_HANDLERS_KEY = exports.EVENT_HANDLERS_KEY = '__consolidated_events_handlers__';

function addEventListener(target, eventName, listener, options) {
  if (!target[EVENT_HANDLERS_KEY]) {
    // eslint-disable-next-line no-param-reassign
    target[EVENT_HANDLERS_KEY] = new _TargetEventHandlers2['default'](target);
  }
  var normalizedEventOptions = (0, _normalizeEventOptions2['default'])(options);
  return target[EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
}

// Deprecated
function removeEventListener(unsubscribeFn) {
  unsubscribeFn();
}

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defineProperties = __webpack_require__(151);

var implementation = __webpack_require__(539);
var getPolyfill = __webpack_require__(541);
var shim = __webpack_require__(958);

var polyfill = getPolyfill();

defineProperties(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(196);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function () {
	var obj = {};
	try {
		origDefineProperty(obj, 'x', { enumerable: false, value: obj });
		// eslint-disable-next-line no-unused-vars, no-restricted-syntax
		for (var _ in obj) { // jscs:ignore disallowUnusedVariables
			return false;
		}
		return obj.x === obj;
	} catch (e) { /* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toISOMonthString;

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _toMomentObject = __webpack_require__(100);

var _toMomentObject2 = _interopRequireDefault(_toMomentObject);

var _constants = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function toISOMonthString(date, currentFormat) {
  var dateObj = _moment2['default'].isMoment(date) ? date : (0, _toMomentObject2['default'])(date, currentFormat);
  if (!dateObj) return null;

  return dateObj.format(_constants.ISO_MONTH_FORMAT);
}

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 154 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 155 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 156 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(206);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(69).f;
var has = __webpack_require__(88);
var TAG = __webpack_require__(38)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LeadsList = undefined;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _leads = __webpack_require__(1108);

var _leads2 = _interopRequireDefault(_leads);

var _reactRouterDom = __webpack_require__(23);

var _Card = __webpack_require__(56);

var _Card2 = _interopRequireDefault(_Card);

var _utils = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var findImmobile = function findImmobile(lead) {
  var immobile = '';
  if (lead.leadOggettoStato === 'commerciale') {
    immobile = 'Locale ' + lead.leadOggettoStato;
  } else if (lead.leadOggettoStato === 'aph') {
    immobile = 'Casa di cura';
  } else if (lead.leadOggettoStato === 'libero' || lead.leadOggettoStato === 'affittato' || lead.leadOggettoStato === 'libero o affittato') {
    immobile = 'Appartamento ' + lead.leadOggettoStato;
  }
  return immobile;
};

var findCliente = function findCliente(lead, clienti) {
  return clienti.find(function (cliente) {
    return cliente.id === lead.leadId;
  });
};

var findConsulenteVendita = function findConsulenteVendita(clienteNomeCognome, utenti) {
  return utenti.find(function (utente) {
    return utente.id === clienteNomeCognome.consulenteVenditaId;
  });
};

var LeadsList = exports.LeadsList = function LeadsList(props) {
  //controllo se la i dati vengono dalla scheda clienti e sono passati via props
  var leadsPayload = props.userLeads || props.leads;
  var oggettoId = props.oggettoId || '';

  return _react2.default.createElement(
    'div',
    { className: 'container' },
    _react2.default.createElement(
      'div',
      { className: 'list-body' },
      leadsPayload.length > 0 && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h5',
          null,
          props.ruolo || ''
        ),
        leadsPayload.length > 0 && leadsPayload.map(function (lead) {
          var clienteNomeCognome = findCliente(lead, props.clienti);
          var consulenteVendita = findConsulenteVendita(clienteNomeCognome, props.utenti);
          var immobile = findImmobile(lead);
          var pulsanti = _react2.default.createElement(
            'div',
            null,
            clienteNomeCognome.email && _react2.default.createElement(
              'a',
              {
                className: 'btn-floating blue right btn-floating-margin',
                href: 'mailto:' + clienteNomeCognome.email
              },
              _react2.default.createElement(
                'i',
                { className: 'material-icons' },
                'email'
              )
            ),
            lead.leadOggettoStato === 'libero' || lead.leadOggettoStato === 'affittato' || lead.leadOggettoStato === 'libero o affittato' || lead.leadOggettoStato === '' ? _react2.default.createElement(
              _reactRouterDom.Link,
              {
                className: 'btn-floating green right accent-3 btn-floating-margin',
                to: '/leadmatchview/' + lead.id
              },
              _react2.default.createElement(
                'i',
                { className: 'material-icons' },
                'search'
              )
            ) : '',
            _react2.default.createElement(
              _reactRouterDom.Link,
              {
                className: 'btn-floating ' + props.feedbackButton + ' blue-grey right',
                to: {
                  pathname: '/createoffer',
                  state: { leadId: lead.id, oggettoId: oggettoId }
                }
              },
              _react2.default.createElement(
                'i',
                { className: 'material-icons' },
                'sentiment_satisfied_alt'
              )
            )
          );
          var consulente = consulenteVendita ? consulenteVendita.name : null;
          var creatoIl = (0, _utils.formattaData)(lead.leadCreatedAt);

          var offerte = props.offers.filter(function (offer) {
            return offer.leadId === lead.id;
          }).map(function (offer) {
            var oggetto = props.oggetti.find(function (oggetto) {
              return oggetto.id === offer.oggettoId;
            });
            var feedback = function feedback() {
              switch (offer.feedback) {
                case 'positivo':
                  return _react2.default.createElement(
                    'i',
                    {
                      key: offer.id,
                      className: 'material-icons small green-text'
                    },
                    'sentiment_satisfied_alt'
                  );
                case 'negativo':
                  return _react2.default.createElement(
                    'i',
                    {
                      key: offer.id,
                      className: 'material-icons small red-text'
                    },
                    'sentiment_very_dissatisfied'
                  );
                case 'neutro':
                  return _react2.default.createElement(
                    'i',
                    {
                      key: offer.id,
                      className: 'material-icons small amber-text'
                    },
                    'sentiment_dissatisfied'
                  );
                case 'sconosciuto':
                  return _react2.default.createElement(
                    'i',
                    { key: offer.id, className: 'material-icons small' },
                    'help_outline'
                  );
                case 'not_relevant':
                  return _react2.default.createElement(
                    'i',
                    {
                      key: offer.id,
                      className: 'material-icons small brown-text'
                    },
                    'highlight_off'
                  );

                default:
                  return _react2.default.createElement(
                    'i',
                    { className: 'material-icons small' },
                    'more_horiz'
                  );
              }
            };

            return _react2.default.createElement(
              'div',
              { key: oggetto.id, className: 'feedback-emojis-item' },
              feedback(),
              ' ',
              oggetto.via,
              ' ',
              oggetto.numeroCivico
            );
          });

          return _react2.default.createElement(_Card2.default, {
            key: lead.id,
            visible: true,
            link: '/leadview/' + lead.id,
            titolo: clienteNomeCognome.nome + ' ' + clienteNomeCognome.cognome,
            sottotitolo: 'Budget: ' + (0, _utils.formattaPrezzo)(lead.leadBudget, true),
            corpo: [consulente, creatoIl, immobile, props.t('city') + ': ' + lead.leadCity],
            lineaNote: '' + (lead.leadNote && 'Note: ' + lead.leadNote),
            progressBar: _react2.default.createElement(
              'div',
              { className: 'feedback-emojis' },
              offerte
            ),
            titoloDestra: pulsanti
          });
        })
      )
    )
  );
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    leads: (0, _leads2.default)(state.leads, state.filters),
    clienti: state.clienti,
    utenti: state.utenti,
    offers: state.offers,
    oggetti: state.oggetti
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()(LeadsList));

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CollectionItem = function CollectionItem(_ref) {
  var label = _ref.label,
      action = _ref.action,
      icon = _ref.icon,
      btnColor = _ref.btnColor;
  return _react2.default.createElement(
    'li',
    { className: 'collection-item' },
    _react2.default.createElement(
      'div',
      null,
      label,
      _react2.default.createElement(
        'a',
        {
          href: '#!',
          className: 'secondary-content ' + btnColor + '-text margine-sinistro'
        },
        _react2.default.createElement(
          'i',
          { className: 'material-icons', onClick: action },
          icon
        )
      )
    )
  );
};

exports.default = CollectionItem;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11);
var document = __webpack_require__(8).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var core = __webpack_require__(45);
var LIBRARY = __webpack_require__(63);
var wksExt = __webpack_require__(226);
var defineProperty = __webpack_require__(17).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(104)('keys');
var uid = __webpack_require__(75);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 164 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(8).document;
module.exports = document && document.documentElement;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(11);
var anObject = __webpack_require__(7);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(46)(Function.call, __webpack_require__(42).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11);
var setPrototypeOf = __webpack_require__(166).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(48);
var defined = __webpack_require__(53);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 170 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 171 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(63);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(34);
var hide = __webpack_require__(33);
var Iterators = __webpack_require__(93);
var $iterCreate = __webpack_require__(173);
var setToStringTag = __webpack_require__(90);
var getPrototypeOf = __webpack_require__(43);
var ITERATOR = __webpack_require__(13)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(78);
var descriptor = __webpack_require__(74);
var setToStringTag = __webpack_require__(90);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(33)(IteratorPrototype, __webpack_require__(13)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(130);
var defined = __webpack_require__(53);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(13)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(93);
var ITERATOR = __webpack_require__(13)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(17);
var createDesc = __webpack_require__(74);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(91);
var ITERATOR = __webpack_require__(13)('iterator');
var Iterators = __webpack_require__(93);
module.exports = __webpack_require__(45).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(711);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(19);
var toAbsoluteIndex = __webpack_require__(77);
var toLength = __webpack_require__(15);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(65);
var step = __webpack_require__(243);
var Iterators = __webpack_require__(93);
var toIObject = __webpack_require__(41);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(172)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(107);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(129)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(46);
var invoke = __webpack_require__(233);
var html = __webpack_require__(165);
var cel = __webpack_require__(161);
var global = __webpack_require__(8);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(47)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var macrotask = __webpack_require__(184).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(47)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(26);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(8);
var DESCRIPTORS = __webpack_require__(16);
var LIBRARY = __webpack_require__(63);
var $typed = __webpack_require__(136);
var hide = __webpack_require__(33);
var redefineAll = __webpack_require__(83);
var fails = __webpack_require__(10);
var anInstance = __webpack_require__(81);
var toInteger = __webpack_require__(48);
var toLength = __webpack_require__(15);
var toIndex = __webpack_require__(253);
var gOPN = __webpack_require__(79).f;
var dP = __webpack_require__(17).f;
var arrayFill = __webpack_require__(180);
var setToStringTag = __webpack_require__(90);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useTranslation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__context__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(141);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default.a(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function useTranslation(ns) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // assert we have the needed i18nInstance
  var i18nFromProps = props.i18n;
  var ReactI18nContext = __WEBPACK_IMPORTED_MODULE_2_react__["useContext"](__WEBPACK_IMPORTED_MODULE_3__context__["a" /* I18nContext */]);

  var _ref = __WEBPACK_IMPORTED_MODULE_3__context__["e" /* getHasUsedI18nextProvider */]() ? ReactI18nContext || {} : {},
      i18nFromContext = _ref.i18n,
      defaultNSFromContext = _ref.defaultNS;

  var i18n = i18nFromProps || i18nFromContext || __WEBPACK_IMPORTED_MODULE_3__context__["f" /* getI18n */]();
  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new __WEBPACK_IMPORTED_MODULE_3__context__["b" /* ReportNamespaces */]();

  if (!i18n) {
    __WEBPACK_IMPORTED_MODULE_4__utils__["e" /* warnOnce */]('You will need pass in an i18next instance by using initReactI18next');

    var notReadyT = function notReadyT(k) {
      return Array.isArray(k) ? k[k.length - 1] : k;
    };

    var retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }

  var i18nOptions = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_3__context__["d" /* getDefaults */](), {}, i18n.options.react, {}, props);

  var useSuspense = i18nOptions.useSuspense; // prepare having a namespace

  var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation']; // report namespaces as used

  if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces); // are we ready? yes if all namespaces in first language are loaded already (either with data or empty object on failed load)

  var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function (n) {
    return __WEBPACK_IMPORTED_MODULE_4__utils__["b" /* hasLoadedNamespace */](n, i18n, i18nOptions);
  }); // binding t function to namespace (acts also as rerender trigger)

  function getT() {
    return {
      t: i18n.getFixedT(null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0])
    };
  }

  var _useState = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](getT()),
      _useState2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default.a(_useState, 2),
      t = _useState2[0],
      setT = _useState2[1]; // seems we can't have functions as value -> wrap it in obj


  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    var isMounted = true;
    var bindI18n = i18nOptions.bindI18n,
        bindI18nStore = i18nOptions.bindI18nStore; // if not ready and not using suspense load the namespaces
    // in side effect and do not call resetT if unmounted

    if (!ready && !useSuspense) {
      __WEBPACK_IMPORTED_MODULE_4__utils__["c" /* loadNamespaces */](i18n, namespaces, function () {
        if (isMounted) setT(getT());
      });
    }

    function boundReset() {
      if (isMounted) setT(getT());
    } // bind events to trigger change, like languageChanged


    if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset); // unbinding on unmount

    return function () {
      isMounted = false;
      if (bindI18n && i18n) bindI18n.split(' ').forEach(function (e) {
        return i18n.off(e, boundReset);
      });
      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function (e) {
        return i18n.store.off(e, boundReset);
      });
    };
  }, [namespaces.join()]); // re-run effect whenever list of namespaces changes

  var ret = [t.t, i18n, ready];
  ret.t = t.t;
  ret.i18n = i18n;
  ret.ready = ready; // return hook stuff if ready

  if (ready) return ret; // not yet loaded namespaces -> load them -> and return if useSuspense option set false

  if (!ready && !useSuspense) return ret; // not yet loaded namespaces -> load them -> and trigger suspense

  throw new Promise(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_4__utils__["c" /* loadNamespaces */](i18n, namespaces, function () {
      setT(getT());
      resolve();
    });
  });
}

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(854);

var iterableToArrayLimit = __webpack_require__(855);

var nonIterableRest = __webpack_require__(856);

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(884);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */](value) || __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */](value) != objectTag) {
    return false;
  }
  var proto = __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */](value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.firebase = undefined;

var _firebase = __webpack_require__(895);

var firebase = _interopRequireWildcard(_firebase);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var firebaseConfig = {
  apiKey: "AIzaSyCrzOL1tmNzM2a0aKb3Y5KHdwKHAwY35j0",
  authDomain: "expensify-5ccf2.firebaseapp.com",
  databaseURL: "https://expensify-5ccf2.firebaseio.com",
  projectId: "expensify-5ccf2",
  storageBucket: "expensify-5ccf2.appspot.com",
  messagingSenderId: "144709598098",
  appId: "1:144709598098:web:f99feef0435bc68d"
};

firebase.initializeApp(firebaseConfig);

var database = firebase.database();
// const googleAuthProvider = new firebase.auth.GoogleAuthProvider();

exports.firebase = firebase;
exports.default = database;

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DealList = undefined;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _deals = __webpack_require__(85);

var _deals2 = _interopRequireDefault(_deals);

var _Card = __webpack_require__(56);

var _Card2 = _interopRequireDefault(_Card);

var _TodoProgressBar = __webpack_require__(928);

var _TodoProgressBar2 = _interopRequireDefault(_TodoProgressBar);

var _utils = __webpack_require__(9);

var _elements = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DealList = exports.DealList = function DealList(_ref) {
  var clienteDeals = _ref.clienteDeals,
      oggetti = _ref.oggetti,
      clienti = _ref.clienti,
      fatture = _ref.fatture,
      utente = _ref.utente,
      deals = _ref.deals,
      t = _ref.t,
      ruolo = _ref.ruolo;

  //controllo se i dati vengono dal clienti page o sono passati via props

  var dealsPayload = clienteDeals || deals;

  return _react2.default.createElement(
    'div',
    { className: 'container' },
    _react2.default.createElement(
      'div',
      { className: 'list-body' },
      dealsPayload.length > 0 && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h5',
          null,
          ruolo || ''
        ),
        dealsPayload.map(function (deal) {
          var oggetto = oggetti.find(function (ogg) {
            return ogg.id === deal.oggettoId;
          });

          var acquirente = clienti.find(function (cliente) {
            return cliente.id === deal.acquirenteId;
          });
          var acquirente2 = clienti.find(function (cliente) {
            return cliente.id === deal.acquirenteId2;
          });
          var gliAcquirenti = (acquirente ? t('Acquirente') + ': ' + acquirente.nome + ' ' + acquirente.cognome + ' ' + acquirente.ditta : '') + ' ' + (acquirente2 ? '- ' + acquirente2.nome + ' ' + acquirente2.cognome + ' ' + acquirente2.ditta : '');

          var venditore = clienti.find(function (cliente) {
            return cliente.id === deal.venditoreId;
          });
          var venditore2 = clienti.find(function (cliente) {
            return cliente.id === deal.venditoreId2;
          });
          var iVenditori = (venditore ? t('Venditore') + ': ' + venditore.nome + ' ' + venditore.cognome + ' ' + venditore.ditta : '') + ' ' + (venditore2 ? '- ' + venditore2.nome + ' ' + venditore2.cognome + ' ' + venditore2.ditta : '');
          var datiPrenotazione = deal.createdAt ? t('Prenotazione del') + ' ' + (0, _utils.formattaData)(deal.createdAt) : null;

          var prezzoDiVendita = deal.prezzoDiVendita ? t('Prezzo di vendita') + ' ' + (0, _utils.formattaPrezzo)(deal.prezzoDiVendita, true) : null;

          // Determino quante fatture sono state pagate per mostrare i colori adatti. Da dealFature mi arriva un array
          var dealFatture = fatture.filter(function (fattura) {
            return fattura.dealId === deal.id;
          });
          var payed = 0;
          if (deal.feePayed) {
            payed = 2;
          } else {
            dealFatture.map(function (fattura) {
              return fattura.payed && payed++;
            });
            if (payed > 0) {
              if (payed === dealFatture.length) {
                payed = 2;
              } else {
                payed = 1;
              }
            }
          }
          return _react2.default.createElement(_Card2.default, {
            key: deal.id,
            visible: true,
            link: '/view/' + deal.id,
            utente: utente,
            titolo: oggetto && 'Rif. Id: ' + oggetto.rifId + ' - ' + (0, _utils.indirizzoOggetto)(oggetto),
            sottotitolo: utente.role === 'Mitarbeiter' ? _react2.default.createElement(
              'span',
              {
                className: '' + (deal.payedStefano && 'list-item--paid')
              },
              (0, _utils.formattaPrezzo)(deal.provvStefano, true)
            ) : _react2.default.createElement(
              'span',
              { className: 'list-item--paid' + payed },
              (0, _utils.formattaPrezzo)(deal.provvM2square, true)
            ),
            titoloDestra: _react2.default.createElement(
              'div',
              { className: 'foto-container' },
              oggetto.downloadURLsCover && _react2.default.createElement('img', {
                className: 'foto',
                src: oggetto.downloadURLsCover[0] || ''
              }),
              (0, _elements.folderButton)(oggetto, oggetto.downloadURLsCover && true, 'Exposé', oggetto.rifId)
            ),
            corpo: [prezzoDiVendita, datiPrenotazione, gliAcquirenti, iVenditori],
            progressBar: _react2.default.createElement(_TodoProgressBar2.default, deal)
          });
        })
      )
    )
  );
};

var mapStateToProps = function mapStateToProps(state) {
  //lo chiami anche da dealsSummary
  return {
    deals: (0, _deals2.default)('deals', state.deals, state.filters, state.utenti.find(function (utente) {
      return utente.firebaseAuthId === state.auth.uid;
    }), state.oggetti, state.clienti, state.fatture),
    oggetti: state.oggetti,
    clienti: state.clienti,
    fatture: state.fatture,
    utente: state.utenti.find(function (utente) {
      return utente.firebaseAuthId === state.auth.uid;
    })
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()(DealList));

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(538);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(956);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toLocalizedDateString;

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _toMomentObject = __webpack_require__(100);

var _toMomentObject2 = _interopRequireDefault(_toMomentObject);

var _constants = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function toLocalizedDateString(date, currentFormat) {
  var dateObj = _moment2['default'].isMoment(date) ? date : (0, _toMomentObject2['default'])(date, currentFormat);
  if (!dateObj) return null;

  return dateObj.format(_constants.DISPLAY_FORMAT);
}

/***/ }),
/* 198 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = isDayVisible;

var _isBeforeDay = __webpack_require__(113);

var _isBeforeDay2 = _interopRequireDefault(_isBeforeDay);

var _isAfterDay = __webpack_require__(116);

var _isAfterDay2 = _interopRequireDefault(_isAfterDay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function isDayVisible(day, month, numberOfMonths, enableOutsideDays) {
  var firstDayOfFirstMonth = month.clone().startOf('month');
  if (enableOutsideDays) firstDayOfFirstMonth = firstDayOfFirstMonth.startOf('week');
  if ((0, _isBeforeDay2['default'])(day, firstDayOfFirstMonth)) return false;

  var lastDayOfLastMonth = month.clone().add(numberOfMonths - 1, 'months').endOf('month');
  if (enableOutsideDays) lastDayOfLastMonth = lastDayOfLastMonth.endOf('week');
  return !(0, _isAfterDay2['default'])(day, lastDayOfLastMonth);
}

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 68);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(2);

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(24);

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(12);

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(27);

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(6);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(37);

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(44);

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(0);

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(101);

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(97);

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(86);

/***/ }),
/* 13 */,
/* 14 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(111);

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(148);

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(199);

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(553);

/***/ }),
/* 29 */,
/* 30 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(554);

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(548);

/***/ }),
/* 38 */,
/* 39 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(94);

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(968);

/***/ }),
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(555);

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(972);

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(973);

/***/ }),
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

exports.calculateDimension = calculateDimension;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactAddonsShallowCompare = __webpack_require__(14);

var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);

var _reactDom = __webpack_require__(39);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _airbnbPropTypes = __webpack_require__(1);

var _moment = __webpack_require__(7);

var _moment2 = _interopRequireDefault(_moment);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _throttle = __webpack_require__(37);

var _throttle2 = _interopRequireDefault(_throttle);

var _isTouchDevice = __webpack_require__(9);

var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);

var _defaultPhrases = __webpack_require__(3);

var _getPhrasePropTypes = __webpack_require__(5);

var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);

var _OutsideClickHandler = __webpack_require__(17);

var _OutsideClickHandler2 = _interopRequireDefault(_OutsideClickHandler);

var _CalendarMonthGrid = __webpack_require__(53);

var _CalendarMonthGrid2 = _interopRequireDefault(_CalendarMonthGrid);

var _DayPickerNavigation = __webpack_require__(57);

var _DayPickerNavigation2 = _interopRequireDefault(_DayPickerNavigation);

var _DayPickerKeyboardShortcuts = __webpack_require__(56);

var _DayPickerKeyboardShortcuts2 = _interopRequireDefault(_DayPickerKeyboardShortcuts);

var _getTransformStyles = __webpack_require__(30);

var _getTransformStyles2 = _interopRequireDefault(_getTransformStyles);

var _getCalendarMonthWidth = __webpack_require__(28);

var _getCalendarMonthWidth2 = _interopRequireDefault(_getCalendarMonthWidth);

var _getActiveElement = __webpack_require__(46);

var _getActiveElement2 = _interopRequireDefault(_getActiveElement);

var _isDayVisible = __webpack_require__(21);

var _isDayVisible2 = _interopRequireDefault(_isDayVisible);

var _ScrollableOrientationShape = __webpack_require__(8);

var _ScrollableOrientationShape2 = _interopRequireDefault(_ScrollableOrientationShape);

var _DayOfWeekShape = __webpack_require__(12);

var _DayOfWeekShape2 = _interopRequireDefault(_DayOfWeekShape);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var MONTH_PADDING = 23;
var DAY_PICKER_PADDING = 9;
var PREV_TRANSITION = 'prev';
var NEXT_TRANSITION = 'next';

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
  // calendar presentation props
  enableOutsideDays: _propTypes2['default'].bool,
  numberOfMonths: _propTypes2['default'].number,
  orientation: _ScrollableOrientationShape2['default'],
  withPortal: _propTypes2['default'].bool,
  onOutsideClick: _propTypes2['default'].func,
  hidden: _propTypes2['default'].bool,
  initialVisibleMonth: _propTypes2['default'].func,
  firstDayOfWeek: _DayOfWeekShape2['default'],
  renderCalendarInfo: _propTypes2['default'].func,
  hideKeyboardShortcutsPanel: _propTypes2['default'].bool,
  daySize: _airbnbPropTypes.nonNegativeInteger,
  isRTL: _propTypes2['default'].bool,

  // navigation props
  navPrev: _propTypes2['default'].node,
  navNext: _propTypes2['default'].node,
  onPrevMonthClick: _propTypes2['default'].func,
  onNextMonthClick: _propTypes2['default'].func,
  onMultiplyScrollableMonths: _propTypes2['default'].func, // VERTICAL_SCROLLABLE daypickers only

  // month props
  renderMonth: _propTypes2['default'].func,

  // day props
  modifiers: _propTypes2['default'].object,
  renderDay: _propTypes2['default'].func,
  onDayClick: _propTypes2['default'].func,
  onDayMouseEnter: _propTypes2['default'].func,
  onDayMouseLeave: _propTypes2['default'].func,

  // accessibility props
  isFocused: _propTypes2['default'].bool,
  getFirstFocusableDay: _propTypes2['default'].func,
  onBlur: _propTypes2['default'].func,
  showKeyboardShortcuts: _propTypes2['default'].bool,

  // internationalization
  monthFormat: _propTypes2['default'].string,
  weekDayFormat: _propTypes2['default'].string,
  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DayPickerPhrases))
});

var defaultProps = exports.defaultProps = {
  // calendar presentation props
  enableOutsideDays: false,
  numberOfMonths: 2,
  orientation: _constants.HORIZONTAL_ORIENTATION,
  withPortal: false,
  onOutsideClick: function () {
    function onOutsideClick() {}

    return onOutsideClick;
  }(),

  hidden: false,
  initialVisibleMonth: function () {
    function initialVisibleMonth() {
      return (0, _moment2['default'])();
    }

    return initialVisibleMonth;
  }(),
  firstDayOfWeek: null,
  renderCalendarInfo: null,
  hideKeyboardShortcutsPanel: false,
  daySize: _constants.DAY_SIZE,
  isRTL: false,

  // navigation props
  navPrev: null,
  navNext: null,
  onPrevMonthClick: function () {
    function onPrevMonthClick() {}

    return onPrevMonthClick;
  }(),
  onNextMonthClick: function () {
    function onNextMonthClick() {}

    return onNextMonthClick;
  }(),
  onMultiplyScrollableMonths: function () {
    function onMultiplyScrollableMonths() {}

    return onMultiplyScrollableMonths;
  }(),

  // month props
  renderMonth: null,

  // day props
  modifiers: {},
  renderDay: null,
  onDayClick: function () {
    function onDayClick() {}

    return onDayClick;
  }(),
  onDayMouseEnter: function () {
    function onDayMouseEnter() {}

    return onDayMouseEnter;
  }(),
  onDayMouseLeave: function () {
    function onDayMouseLeave() {}

    return onDayMouseLeave;
  }(),

  // accessibility props
  isFocused: false,
  getFirstFocusableDay: null,
  onBlur: function () {
    function onBlur() {}

    return onBlur;
  }(),

  showKeyboardShortcuts: false,

  // internationalization
  monthFormat: 'MMMM YYYY',
  weekDayFormat: 'dd',
  phrases: _defaultPhrases.DayPickerPhrases
};

function applyTransformStyles(el, transform) {
  var opacity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  var transformStyles = (0, _getTransformStyles2['default'])(transform);
  transformStyles.opacity = opacity;

  Object.keys(transformStyles).forEach(function (styleKey) {
    // eslint-disable-next-line no-param-reassign
    el.style[styleKey] = transformStyles[styleKey];
  });
}

function calculateDimension(el, axis) {
  var borderBox = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var withMargin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (!el) {
    return 0;
  }

  var axisStart = axis === 'width' ? 'Left' : 'Top';
  var axisEnd = axis === 'width' ? 'Right' : 'Bottom';

  // Only read styles if we need to
  var style = !borderBox || withMargin ? window.getComputedStyle(el) : null;

  // Offset includes border and padding
  var offsetWidth = el.offsetWidth,
      offsetHeight = el.offsetHeight;

  var size = axis === 'width' ? offsetWidth : offsetHeight;

  // Get the inner size
  if (!borderBox) {
    size -= parseFloat(style['padding' + axisStart]) + parseFloat(style['padding' + axisEnd]) + parseFloat(style['border' + axisStart + 'Width']) + parseFloat(style['border' + axisEnd + 'Width']);
  }

  // Apply margin
  if (withMargin) {
    size += parseFloat(style['margin' + axisStart]) + parseFloat(style['margin' + axisEnd]);
  }

  return size;
}

function getMonthHeight(el) {
  var caption = el.querySelector('.js-CalendarMonth__caption');
  var grid = el.querySelector('.js-CalendarMonth__grid');

  // Need to separate out table children for FF
  // Add an additional +1 for the border
  return calculateDimension(caption, 'height', true, true) + calculateDimension(grid, 'height') + 1;
}

var DayPicker = function (_React$Component) {
  _inherits(DayPicker, _React$Component);

  function DayPicker(props) {
    _classCallCheck(this, DayPicker);

    var _this = _possibleConstructorReturn(this, (DayPicker.__proto__ || Object.getPrototypeOf(DayPicker)).call(this, props));

    var currentMonth = props.hidden ? (0, _moment2['default'])() : props.initialVisibleMonth();

    var focusedDate = currentMonth.clone().startOf('month');
    if (props.getFirstFocusableDay) {
      focusedDate = props.getFirstFocusableDay(currentMonth);
    }

    var translationValue = props.isRTL && _this.isHorizontal() ? -(0, _getCalendarMonthWidth2['default'])(props.daySize) : 0;

    _this.hasSetInitialVisibleMonth = !props.hidden;
    _this.state = {
      currentMonth: currentMonth,
      monthTransition: null,
      translationValue: translationValue,
      scrollableMonthMultiple: 1,
      calendarMonthWidth: (0, _getCalendarMonthWidth2['default'])(props.daySize),
      focusedDate: !props.hidden || props.isFocused ? focusedDate : null,
      nextFocusedDate: null,
      showKeyboardShortcuts: props.showKeyboardShortcuts,
      onKeyboardShortcutsPanelClose: function () {
        function onKeyboardShortcutsPanelClose() {}

        return onKeyboardShortcutsPanelClose;
      }(),

      isTouchDevice: (0, _isTouchDevice2['default'])(),
      withMouseInteractions: true
    };

    _this.onKeyDown = _this.onKeyDown.bind(_this);
    _this.onPrevMonthClick = _this.onPrevMonthClick.bind(_this);
    _this.onNextMonthClick = _this.onNextMonthClick.bind(_this);
    _this.setCalendarMonthGridRef = _this.setCalendarMonthGridRef.bind(_this);
    _this.multiplyScrollableMonths = _this.multiplyScrollableMonths.bind(_this);
    _this.updateStateAfterMonthTransition = _this.updateStateAfterMonthTransition.bind(_this);

    _this.openKeyboardShortcutsPanel = _this.openKeyboardShortcutsPanel.bind(_this);
    _this.closeKeyboardShortcutsPanel = _this.closeKeyboardShortcutsPanel.bind(_this);

    _this.setContainerRef = _this.setContainerRef.bind(_this);
    _this.setTransitionContainerRef = _this.setTransitionContainerRef.bind(_this);
    return _this;
  }

  _createClass(DayPicker, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        this.setState({ isTouchDevice: (0, _isTouchDevice2['default'])() });

        if (this.isHorizontal()) {
          this.adjustDayPickerHeight();
          this.initializeDayPickerWidth();
        }
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(nextProps) {
        var hidden = nextProps.hidden,
            isFocused = nextProps.isFocused,
            showKeyboardShortcuts = nextProps.showKeyboardShortcuts,
            onBlur = nextProps.onBlur;
        var currentMonth = this.state.currentMonth;

        if (!hidden) {
          if (!this.hasSetInitialVisibleMonth) {
            this.hasSetInitialVisibleMonth = true;
            this.setState({
              currentMonth: nextProps.initialVisibleMonth()
            });
          }

          if (!this.dayPickerWidth && this.isHorizontal()) {
            this.initializeDayPickerWidth();
            this.adjustDayPickerHeight();
          }
        }

        if (nextProps.daySize !== this.props.daySize) {
          this.setState({
            calendarMonthWidth: (0, _getCalendarMonthWidth2['default'])(nextProps.daySize)
          });
        }

        if (isFocused !== this.props.isFocused) {
          if (isFocused) {
            var focusedDate = this.getFocusedDay(currentMonth);

            var onKeyboardShortcutsPanelClose = this.state.onKeyboardShortcutsPanelClose;
            if (nextProps.showKeyboardShortcuts) {
              // the ? shortcut came from the input and we should return input there once it is close
              onKeyboardShortcutsPanelClose = onBlur;
            }

            this.setState({
              showKeyboardShortcuts: showKeyboardShortcuts,
              onKeyboardShortcutsPanelClose: onKeyboardShortcutsPanelClose,
              focusedDate: focusedDate,
              withMouseInteractions: false
            });
          } else {
            this.setState({ focusedDate: null });
          }
        }
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'shouldComponentUpdate',
    value: function () {
      function shouldComponentUpdate(nextProps, nextState) {
        return (0, _reactAddonsShallowCompare2['default'])(this, nextProps, nextState);
      }

      return shouldComponentUpdate;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate(prevProps, prevState) {
        var numberOfMonths = this.props.numberOfMonths;
        var _state = this.state,
            monthTransition = _state.monthTransition,
            currentMonth = _state.currentMonth,
            focusedDate = _state.focusedDate;

        if (monthTransition || !currentMonth.isSame(prevState.currentMonth) || numberOfMonths !== prevProps.numberOfMonths) {
          if (this.isHorizontal()) {
            this.adjustDayPickerHeight();
          }
        }

        if (!prevProps.isFocused && this.props.isFocused && !focusedDate || !prevProps.showKeyboardShortcuts && this.props.showKeyboardShortcuts) {
          this.container.focus();
        }
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'onKeyDown',
    value: function () {
      function onKeyDown(e) {
        e.stopPropagation();

        this.setState({ withMouseInteractions: false });

        var onBlur = this.props.onBlur;
        var _state2 = this.state,
            focusedDate = _state2.focusedDate,
            showKeyboardShortcuts = _state2.showKeyboardShortcuts;

        if (!focusedDate) return;

        var newFocusedDate = focusedDate.clone();

        var didTransitionMonth = false;

        // focus might be anywhere when the keyboard shortcuts panel is opened so we want to
        // return it to wherever it was before when the panel was opened
        var activeElement = (0, _getActiveElement2['default'])();
        var onKeyboardShortcutsPanelClose = function () {
          function onKeyboardShortcutsPanelClose() {
            if (activeElement) activeElement.focus();
          }

          return onKeyboardShortcutsPanelClose;
        }();

        switch (e.key) {
          case 'ArrowUp':
            e.preventDefault();
            newFocusedDate.subtract(1, 'week');
            didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
            break;
          case 'ArrowLeft':
            e.preventDefault();
            newFocusedDate.subtract(1, 'day');
            didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
            break;
          case 'Home':
            e.preventDefault();
            newFocusedDate.startOf('week');
            didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
            break;
          case 'PageUp':
            e.preventDefault();
            newFocusedDate.subtract(1, 'month');
            didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
            break;

          case 'ArrowDown':
            e.preventDefault();
            newFocusedDate.add(1, 'week');
            didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
            break;
          case 'ArrowRight':
            e.preventDefault();
            newFocusedDate.add(1, 'day');
            didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
            break;
          case 'End':
            e.preventDefault();
            newFocusedDate.endOf('week');
            didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
            break;
          case 'PageDown':
            e.preventDefault();
            newFocusedDate.add(1, 'month');
            didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
            break;

          case '?':
            this.openKeyboardShortcutsPanel(onKeyboardShortcutsPanelClose);
            break;

          case 'Escape':
            if (showKeyboardShortcuts) {
              this.closeKeyboardShortcutsPanel();
            } else {
              onBlur();
            }
            break;

          default:
            break;
        }

        // If there was a month transition, do not update the focused date until the transition has
        // completed. Otherwise, attempting to focus on a DOM node may interrupt the CSS animation. If
        // didTransitionMonth is true, the focusedDate gets updated in #updateStateAfterMonthTransition
        if (!didTransitionMonth) {
          this.setState({
            focusedDate: newFocusedDate
          });
        }
      }

      return onKeyDown;
    }()
  }, {
    key: 'onPrevMonthClick',
    value: function () {
      function onPrevMonthClick(nextFocusedDate, e) {
        var isRTL = this.props.isRTL;

        if (e) e.preventDefault();

        var translationValue = this.isVertical() ? this.getMonthHeightByIndex(0) : this.dayPickerWidth;

        if (isRTL && this.isHorizontal()) {
          translationValue = -2 * this.dayPickerWidth;
        }

        // The first CalendarMonth is always positioned absolute at top: 0 or left: 0
        // so we need to transform it to the appropriate location before the animation.
        // This behavior is because we would otherwise need a double-render in order to
        // adjust the container position once we had the height the first calendar
        // (ie first draw all the calendar, then in a second render, use the first calendar's
        // height to position the container). Variable calendar heights, amirite? <3 Maja
        this.translateFirstDayPickerForAnimation(translationValue);

        this.setState({
          monthTransition: PREV_TRANSITION,
          translationValue: translationValue,
          focusedDate: null,
          nextFocusedDate: nextFocusedDate
        });
      }

      return onPrevMonthClick;
    }()
  }, {
    key: 'onNextMonthClick',
    value: function () {
      function onNextMonthClick(nextFocusedDate, e) {
        var isRTL = this.props.isRTL;

        if (e) e.preventDefault();

        var translationValue = this.isVertical() ? -this.getMonthHeightByIndex(1) : -this.dayPickerWidth;

        if (isRTL && this.isHorizontal()) {
          translationValue = 0;
        }

        this.setState({
          monthTransition: NEXT_TRANSITION,
          translationValue: translationValue,
          focusedDate: null,
          nextFocusedDate: nextFocusedDate
        });
      }

      return onNextMonthClick;
    }()
  }, {
    key: 'getFocusedDay',
    value: function () {
      function getFocusedDay(newMonth) {
        var _props = this.props,
            getFirstFocusableDay = _props.getFirstFocusableDay,
            numberOfMonths = _props.numberOfMonths;

        var focusedDate = void 0;
        if (getFirstFocusableDay) {
          focusedDate = getFirstFocusableDay(newMonth);
        }

        if (newMonth && (!focusedDate || !(0, _isDayVisible2['default'])(focusedDate, newMonth, numberOfMonths))) {
          focusedDate = newMonth.clone().startOf('month');
        }

        return focusedDate;
      }

      return getFocusedDay;
    }()
  }, {
    key: 'getMonthHeightByIndex',
    value: function () {
      function getMonthHeightByIndex(i) {
        return getMonthHeight(this.transitionContainer.querySelectorAll('.CalendarMonth')[i]);
      }

      return getMonthHeightByIndex;
    }()
  }, {
    key: 'setCalendarMonthGridRef',
    value: function () {
      function setCalendarMonthGridRef(ref) {
        this.calendarMonthGrid = ref;
      }

      return setCalendarMonthGridRef;
    }()
  }, {
    key: 'setContainerRef',
    value: function () {
      function setContainerRef(ref) {
        this.container = ref;
      }

      return setContainerRef;
    }()
  }, {
    key: 'setTransitionContainerRef',
    value: function () {
      function setTransitionContainerRef(ref) {
        this.transitionContainer = ref;
      }

      return setTransitionContainerRef;
    }()
  }, {
    key: 'maybeTransitionNextMonth',
    value: function () {
      function maybeTransitionNextMonth(newFocusedDate) {
        var numberOfMonths = this.props.numberOfMonths;
        var _state3 = this.state,
            currentMonth = _state3.currentMonth,
            focusedDate = _state3.focusedDate;

        var newFocusedDateMonth = newFocusedDate.month();
        var focusedDateMonth = focusedDate.month();
        var isNewFocusedDateVisible = (0, _isDayVisible2['default'])(newFocusedDate, currentMonth, numberOfMonths);
        if (newFocusedDateMonth !== focusedDateMonth && !isNewFocusedDateVisible) {
          this.onNextMonthClick(newFocusedDate);
          return true;
        }

        return false;
      }

      return maybeTransitionNextMonth;
    }()
  }, {
    key: 'maybeTransitionPrevMonth',
    value: function () {
      function maybeTransitionPrevMonth(newFocusedDate) {
        var numberOfMonths = this.props.numberOfMonths;
        var _state4 = this.state,
            currentMonth = _state4.currentMonth,
            focusedDate = _state4.focusedDate;

        var newFocusedDateMonth = newFocusedDate.month();
        var focusedDateMonth = focusedDate.month();
        var isNewFocusedDateVisible = (0, _isDayVisible2['default'])(newFocusedDate, currentMonth, numberOfMonths);
        if (newFocusedDateMonth !== focusedDateMonth && !isNewFocusedDateVisible) {
          this.onPrevMonthClick(newFocusedDate);
          return true;
        }

        return false;
      }

      return maybeTransitionPrevMonth;
    }()
  }, {
    key: 'multiplyScrollableMonths',
    value: function () {
      function multiplyScrollableMonths(e) {
        var onMultiplyScrollableMonths = this.props.onMultiplyScrollableMonths;

        if (e) e.preventDefault();

        if (onMultiplyScrollableMonths) onMultiplyScrollableMonths(e);

        this.setState({
          scrollableMonthMultiple: this.state.scrollableMonthMultiple + 1
        });
      }

      return multiplyScrollableMonths;
    }()
  }, {
    key: 'isHorizontal',
    value: function () {
      function isHorizontal() {
        return this.props.orientation === _constants.HORIZONTAL_ORIENTATION;
      }

      return isHorizontal;
    }()
  }, {
    key: 'isVertical',
    value: function () {
      function isVertical() {
        return this.props.orientation === _constants.VERTICAL_ORIENTATION || this.props.orientation === _constants.VERTICAL_SCROLLABLE;
      }

      return isVertical;
    }()
  }, {
    key: 'initializeDayPickerWidth',
    value: function () {
      function initializeDayPickerWidth() {
        if (this.calendarMonthGrid) {
          // eslint-disable-next-line react/no-find-dom-node
          var calendarMonthGridDOMNode = _reactDom2['default'].findDOMNode(this.calendarMonthGrid);
          if (calendarMonthGridDOMNode) {
            this.dayPickerWidth = calculateDimension(calendarMonthGridDOMNode.querySelector('.CalendarMonth'), 'width', true);
          }
        }
      }

      return initializeDayPickerWidth;
    }()
  }, {
    key: 'updateStateAfterMonthTransition',
    value: function () {
      function updateStateAfterMonthTransition() {
        var _props2 = this.props,
            onPrevMonthClick = _props2.onPrevMonthClick,
            onNextMonthClick = _props2.onNextMonthClick;
        var _state5 = this.state,
            currentMonth = _state5.currentMonth,
            monthTransition = _state5.monthTransition,
            focusedDate = _state5.focusedDate,
            nextFocusedDate = _state5.nextFocusedDate,
            withMouseInteractions = _state5.withMouseInteractions;

        if (!monthTransition) return;

        var newMonth = currentMonth.clone();
        if (monthTransition === PREV_TRANSITION) {
          if (onPrevMonthClick) onPrevMonthClick();
          newMonth.subtract(1, 'month');
        } else if (monthTransition === NEXT_TRANSITION) {
          if (onNextMonthClick) onNextMonthClick();
          newMonth.add(1, 'month');
        }

        var newFocusedDate = null;
        if (nextFocusedDate) {
          newFocusedDate = nextFocusedDate;
        } else if (!focusedDate && !withMouseInteractions) {
          newFocusedDate = this.getFocusedDay(newMonth);
        }

        if (this.calendarMonthGrid) {
          // eslint-disable-next-line react/no-find-dom-node
          var calendarMonthGridDOMNode = _reactDom2['default'].findDOMNode(this.calendarMonthGrid);
          if (calendarMonthGridDOMNode) {
            // clear the previous transforms
            applyTransformStyles(calendarMonthGridDOMNode.querySelector('.CalendarMonth'), 'none');
          }
        }

        this.setState({
          currentMonth: newMonth,
          monthTransition: null,
          translationValue: this.props.isRTL && this.isHorizontal() ? -this.dayPickerWidth : 0,
          nextFocusedDate: null,
          focusedDate: newFocusedDate
        }, function () {
          // we don't want to focus on the relevant calendar day after a month transition
          // if the user is navigating around using a mouse
          if (withMouseInteractions) {
            var activeElement = (0, _getActiveElement2['default'])();
            if (activeElement && activeElement !== document.body) {
              activeElement.blur();
            }
          }
        });
      }

      return updateStateAfterMonthTransition;
    }()
  }, {
    key: 'adjustDayPickerHeight',
    value: function () {
      function adjustDayPickerHeight() {
        var heights = [];

        Array.prototype.forEach.call(this.transitionContainer.querySelectorAll('.CalendarMonth'), function (el) {
          if (el.getAttribute('data-visible') === 'true') {
            heights.push(getMonthHeight(el));
          }
        });

        var newMonthHeight = Math.max.apply(Math, heights) + MONTH_PADDING;

        if (newMonthHeight !== calculateDimension(this.transitionContainer, 'height')) {
          this.monthHeight = newMonthHeight;
          this.transitionContainer.style.height = String(newMonthHeight) + 'px';
        }
      }

      return adjustDayPickerHeight;
    }()
  }, {
    key: 'translateFirstDayPickerForAnimation',
    value: function () {
      function translateFirstDayPickerForAnimation(translationValue) {
        var isRTL = this.props.isRTL;

        var convertedTranslationValue = -translationValue;
        if (isRTL && this.isHorizontal()) {
          var positiveTranslationValue = Math.abs(translationValue + this.dayPickerWidth);
          convertedTranslationValue = positiveTranslationValue;
        }
        var transformType = this.isVertical() ? 'translateY' : 'translateX';
        var transformValue = transformType + '(' + String(convertedTranslationValue) + 'px)';

        applyTransformStyles(this.transitionContainer.querySelector('.CalendarMonth'), transformValue, 1);
      }

      return translateFirstDayPickerForAnimation;
    }()
  }, {
    key: 'openKeyboardShortcutsPanel',
    value: function () {
      function openKeyboardShortcutsPanel(onCloseCallBack) {
        this.setState({
          showKeyboardShortcuts: true,
          onKeyboardShortcutsPanelClose: onCloseCallBack
        });
      }

      return openKeyboardShortcutsPanel;
    }()
  }, {
    key: 'closeKeyboardShortcutsPanel',
    value: function () {
      function closeKeyboardShortcutsPanel() {
        var onKeyboardShortcutsPanelClose = this.state.onKeyboardShortcutsPanelClose;

        if (onKeyboardShortcutsPanelClose) {
          onKeyboardShortcutsPanelClose();
        }

        this.setState({
          onKeyboardShortcutsPanelClose: null,
          showKeyboardShortcuts: false
        });
      }

      return closeKeyboardShortcutsPanel;
    }()
  }, {
    key: 'renderNavigation',
    value: function () {
      function renderNavigation() {
        var _this2 = this;

        var _props3 = this.props,
            navPrev = _props3.navPrev,
            navNext = _props3.navNext,
            orientation = _props3.orientation,
            phrases = _props3.phrases,
            isRTL = _props3.isRTL;

        var onNextMonthClick = void 0;
        if (orientation === _constants.VERTICAL_SCROLLABLE) {
          onNextMonthClick = this.multiplyScrollableMonths;
        } else {
          onNextMonthClick = function () {
            function onNextMonthClick(e) {
              _this2.onNextMonthClick(null, e);
            }

            return onNextMonthClick;
          }();
        }

        return _react2['default'].createElement(_DayPickerNavigation2['default'], {
          onPrevMonthClick: function () {
            function onPrevMonthClick(e) {
              _this2.onPrevMonthClick(null, e);
            }

            return onPrevMonthClick;
          }(),
          onNextMonthClick: onNextMonthClick,
          navPrev: navPrev,
          navNext: navNext,
          orientation: orientation,
          phrases: phrases,
          isRTL: isRTL
        });
      }

      return renderNavigation;
    }()
  }, {
    key: 'renderWeekHeader',
    value: function () {
      function renderWeekHeader(index) {
        var _props4 = this.props,
            daySize = _props4.daySize,
            orientation = _props4.orientation,
            weekDayFormat = _props4.weekDayFormat;
        var calendarMonthWidth = this.state.calendarMonthWidth;

        var verticalScrollable = orientation === _constants.VERTICAL_SCROLLABLE;
        var horizontalStyle = {
          left: index * calendarMonthWidth
        };
        var verticalStyle = {
          marginLeft: -calendarMonthWidth / 2
        };

        var style = {}; // no styles applied to the vertical-scrollable orientation
        if (this.isHorizontal()) {
          style = horizontalStyle;
        } else if (this.isVertical() && !verticalScrollable) {
          style = verticalStyle;
        }

        var firstDayOfWeek = this.props.firstDayOfWeek;

        if (firstDayOfWeek == null) {
          firstDayOfWeek = _moment2['default'].localeData().firstDayOfWeek();
        }

        var header = [];
        for (var i = 0; i < 7; i += 1) {
          header.push(_react2['default'].createElement('li', { key: i, style: { width: daySize } }, _react2['default'].createElement('small', null, (0, _moment2['default'])().day((i + firstDayOfWeek) % 7).format(weekDayFormat))));
        }

        return _react2['default'].createElement('div', {
          className: 'DayPicker__week-header',
          key: 'week-' + String(index),
          style: style
        }, _react2['default'].createElement('ul', null, header));
      }

      return renderWeekHeader;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this3 = this;

        var _state6 = this.state,
            calendarMonthWidth = _state6.calendarMonthWidth,
            currentMonth = _state6.currentMonth,
            monthTransition = _state6.monthTransition,
            translationValue = _state6.translationValue,
            scrollableMonthMultiple = _state6.scrollableMonthMultiple,
            focusedDate = _state6.focusedDate,
            showKeyboardShortcuts = _state6.showKeyboardShortcuts,
            isTouch = _state6.isTouchDevice;
        var _props5 = this.props,
            enableOutsideDays = _props5.enableOutsideDays,
            numberOfMonths = _props5.numberOfMonths,
            orientation = _props5.orientation,
            modifiers = _props5.modifiers,
            withPortal = _props5.withPortal,
            onDayClick = _props5.onDayClick,
            onDayMouseEnter = _props5.onDayMouseEnter,
            onDayMouseLeave = _props5.onDayMouseLeave,
            firstDayOfWeek = _props5.firstDayOfWeek,
            renderMonth = _props5.renderMonth,
            renderDay = _props5.renderDay,
            renderCalendarInfo = _props5.renderCalendarInfo,
            hideKeyboardShortcutsPanel = _props5.hideKeyboardShortcutsPanel,
            onOutsideClick = _props5.onOutsideClick,
            monthFormat = _props5.monthFormat,
            daySize = _props5.daySize,
            isFocused = _props5.isFocused,
            phrases = _props5.phrases;

        var numOfWeekHeaders = this.isVertical() ? 1 : numberOfMonths;
        var weekHeaders = [];
        for (var i = 0; i < numOfWeekHeaders; i += 1) {
          weekHeaders.push(this.renderWeekHeader(i));
        }

        var firstVisibleMonthIndex = 1;
        if (monthTransition === PREV_TRANSITION) {
          firstVisibleMonthIndex -= 1;
        } else if (monthTransition === NEXT_TRANSITION) {
          firstVisibleMonthIndex += 1;
        }

        var verticalScrollable = this.props.orientation === _constants.VERTICAL_SCROLLABLE;
        if (verticalScrollable) firstVisibleMonthIndex = 0;

        var dayPickerClassNames = (0, _classnames2['default'])('DayPicker', {
          'DayPicker--horizontal': this.isHorizontal(),
          'DayPicker--vertical': this.isVertical(),
          'DayPicker--vertical-scrollable': verticalScrollable,
          'DayPicker--portal': withPortal
        });

        var transitionContainerClasses = (0, _classnames2['default'])('transition-container', {
          'transition-container--horizontal': this.isHorizontal(),
          'transition-container--vertical': this.isVertical()
        });

        var horizontalWidth = calendarMonthWidth * numberOfMonths + 2 * DAY_PICKER_PADDING;

        // this is a kind of made-up value that generally looks good. we'll
        // probably want to let the user set this explicitly.
        var verticalHeight = 1.75 * calendarMonthWidth;

        var dayPickerStyle = {
          width: this.isHorizontal() && horizontalWidth,

          // These values are to center the datepicker (approximately) on the page
          marginLeft: this.isHorizontal() && withPortal && -horizontalWidth / 2,
          marginTop: this.isHorizontal() && withPortal && -calendarMonthWidth / 2
        };

        var transitionContainerStyle = {
          width: this.isHorizontal() && horizontalWidth,
          height: this.isVertical() && !verticalScrollable && !withPortal && verticalHeight
        };

        var isCalendarMonthGridAnimating = monthTransition !== null;
        var transformType = this.isVertical() ? 'translateY' : 'translateX';
        var transformValue = transformType + '(' + String(translationValue) + 'px)';

        var shouldFocusDate = !isCalendarMonthGridAnimating && isFocused;

        var keyboardShortcutButtonLocation = _DayPickerKeyboardShortcuts.BOTTOM_RIGHT;
        if (this.isVertical()) {
          keyboardShortcutButtonLocation = withPortal ? _DayPickerKeyboardShortcuts.TOP_LEFT : _DayPickerKeyboardShortcuts.TOP_RIGHT;
        }

        return _react2['default'].createElement('div', {
          className: dayPickerClassNames,
          style: dayPickerStyle,
          role: 'application',
          'aria-label': phrases.calendarLabel
        }, _react2['default'].createElement(_OutsideClickHandler2['default'], { onOutsideClick: onOutsideClick }, _react2['default'].createElement('div', {
          className: 'DayPicker__week-headers',
          'aria-hidden': 'true',
          role: 'presentation'
        }, weekHeaders), _react2['default'].createElement('div', { // eslint-disable-line jsx-a11y/no-noninteractive-element-interactions
          className: 'DayPicker__focus-region',
          ref: this.setContainerRef,
          onClick: function () {
            function onClick(e) {
              e.stopPropagation();
            }

            return onClick;
          }(),
          onKeyDown: (0, _throttle2['default'])(this.onKeyDown, 300),
          onMouseUp: function () {
            function onMouseUp() {
              _this3.setState({ withMouseInteractions: true });
            }

            return onMouseUp;
          }(),
          role: 'region',
          tabIndex: -1
        }, !verticalScrollable && this.renderNavigation(), _react2['default'].createElement('div', {
          className: transitionContainerClasses,
          ref: this.setTransitionContainerRef,
          style: transitionContainerStyle
        }, _react2['default'].createElement(_CalendarMonthGrid2['default'], {
          ref: this.setCalendarMonthGridRef,
          transformValue: transformValue,
          enableOutsideDays: enableOutsideDays,
          firstVisibleMonthIndex: firstVisibleMonthIndex,
          initialMonth: currentMonth,
          isAnimating: isCalendarMonthGridAnimating,
          modifiers: modifiers,
          orientation: orientation,
          numberOfMonths: numberOfMonths * scrollableMonthMultiple,
          onDayClick: onDayClick,
          onDayMouseEnter: onDayMouseEnter,
          onDayMouseLeave: onDayMouseLeave,
          renderMonth: renderMonth,
          renderDay: renderDay,
          onMonthTransitionEnd: this.updateStateAfterMonthTransition,
          monthFormat: monthFormat,
          daySize: daySize,
          firstDayOfWeek: firstDayOfWeek,
          isFocused: shouldFocusDate,
          focusedDate: focusedDate,
          phrases: phrases
        }), verticalScrollable && this.renderNavigation()), !isTouch && !hideKeyboardShortcutsPanel && _react2['default'].createElement(_DayPickerKeyboardShortcuts2['default'], {
          block: this.isVertical() && !withPortal,
          buttonLocation: keyboardShortcutButtonLocation,
          showKeyboardShortcutsPanel: showKeyboardShortcuts,
          openKeyboardShortcutsPanel: this.openKeyboardShortcutsPanel,
          closeKeyboardShortcutsPanel: this.closeKeyboardShortcutsPanel,
          phrases: phrases
        })), renderCalendarInfo && renderCalendarInfo()));
      }

      return render;
    }()
  }]);

  return DayPicker;
}(_react2['default'].Component);

exports['default'] = DayPicker;

DayPicker.propTypes = propTypes;
DayPicker.defaultProps = defaultProps;

/***/ })
/******/ ]);

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fnToStr = Function.prototype.toString;

var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
	try {
		var fnStr = fnToStr.call(value);
		return constructorRegex.test(fnStr);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionToStr(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isCallable(value) {
	if (!value) { return false; }
	if (typeof value !== 'function' && typeof value !== 'object') { return false; }
	if (typeof value === 'function' && !value.prototype) { return true; }
	if (hasToStringTag) { return tryFunctionObject(value); }
	if (isES6ClassFn(value)) { return false; }
	var strClass = toStr.call(value);
	return strClass === fnClass || strClass === genClass;
};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* globals
	Set,
	Map,
	WeakSet,
	WeakMap,

	Promise,

	Symbol,
	Proxy,

	Atomics,
	SharedArrayBuffer,

	ArrayBuffer,
	DataView,
	Uint8Array,
	Float32Array,
	Float64Array,
	Int8Array,
	Int16Array,
	Int32Array,
	Uint8ClampedArray,
	Uint16Array,
	Uint32Array,
*/

var undefined; // eslint-disable-line no-shadow-restricted-names

var ThrowTypeError = Object.getOwnPropertyDescriptor
	? (function () { return Object.getOwnPropertyDescriptor(arguments, 'callee').get; }())
	: function () { throw new TypeError(); };

var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var generator; // = function * () {};
var generatorFunction = generator ? getProto(generator) : undefined;
var asyncFn; // async function() {};
var asyncFunction = asyncFn ? asyncFn.constructor : undefined;
var asyncGen; // async function * () {};
var asyncGenFunction = asyncGen ? getProto(asyncGen) : undefined;
var asyncGenIterator = asyncGen ? asyncGen() : undefined;

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'$ %Array%': Array,
	'$ %ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'$ %ArrayBufferPrototype%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer.prototype,
	'$ %ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'$ %ArrayPrototype%': Array.prototype,
	'$ %ArrayProto_entries%': Array.prototype.entries,
	'$ %ArrayProto_forEach%': Array.prototype.forEach,
	'$ %ArrayProto_keys%': Array.prototype.keys,
	'$ %ArrayProto_values%': Array.prototype.values,
	'$ %AsyncFromSyncIteratorPrototype%': undefined,
	'$ %AsyncFunction%': asyncFunction,
	'$ %AsyncFunctionPrototype%': asyncFunction ? asyncFunction.prototype : undefined,
	'$ %AsyncGenerator%': asyncGen ? getProto(asyncGenIterator) : undefined,
	'$ %AsyncGeneratorFunction%': asyncGenFunction,
	'$ %AsyncGeneratorPrototype%': asyncGenFunction ? asyncGenFunction.prototype : undefined,
	'$ %AsyncIteratorPrototype%': asyncGenIterator && hasSymbols && Symbol.asyncIterator ? asyncGenIterator[Symbol.asyncIterator]() : undefined,
	'$ %Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'$ %Boolean%': Boolean,
	'$ %BooleanPrototype%': Boolean.prototype,
	'$ %DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'$ %DataViewPrototype%': typeof DataView === 'undefined' ? undefined : DataView.prototype,
	'$ %Date%': Date,
	'$ %DatePrototype%': Date.prototype,
	'$ %decodeURI%': decodeURI,
	'$ %decodeURIComponent%': decodeURIComponent,
	'$ %encodeURI%': encodeURI,
	'$ %encodeURIComponent%': encodeURIComponent,
	'$ %Error%': Error,
	'$ %ErrorPrototype%': Error.prototype,
	'$ %eval%': eval, // eslint-disable-line no-eval
	'$ %EvalError%': EvalError,
	'$ %EvalErrorPrototype%': EvalError.prototype,
	'$ %Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'$ %Float32ArrayPrototype%': typeof Float32Array === 'undefined' ? undefined : Float32Array.prototype,
	'$ %Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'$ %Float64ArrayPrototype%': typeof Float64Array === 'undefined' ? undefined : Float64Array.prototype,
	'$ %Function%': Function,
	'$ %FunctionPrototype%': Function.prototype,
	'$ %Generator%': generator ? getProto(generator()) : undefined,
	'$ %GeneratorFunction%': generatorFunction,
	'$ %GeneratorPrototype%': generatorFunction ? generatorFunction.prototype : undefined,
	'$ %Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'$ %Int8ArrayPrototype%': typeof Int8Array === 'undefined' ? undefined : Int8Array.prototype,
	'$ %Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'$ %Int16ArrayPrototype%': typeof Int16Array === 'undefined' ? undefined : Int8Array.prototype,
	'$ %Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'$ %Int32ArrayPrototype%': typeof Int32Array === 'undefined' ? undefined : Int32Array.prototype,
	'$ %isFinite%': isFinite,
	'$ %isNaN%': isNaN,
	'$ %IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'$ %JSON%': JSON,
	'$ %JSONParse%': JSON.parse,
	'$ %Map%': typeof Map === 'undefined' ? undefined : Map,
	'$ %MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'$ %MapPrototype%': typeof Map === 'undefined' ? undefined : Map.prototype,
	'$ %Math%': Math,
	'$ %Number%': Number,
	'$ %NumberPrototype%': Number.prototype,
	'$ %Object%': Object,
	'$ %ObjectPrototype%': Object.prototype,
	'$ %ObjProto_toString%': Object.prototype.toString,
	'$ %ObjProto_valueOf%': Object.prototype.valueOf,
	'$ %parseFloat%': parseFloat,
	'$ %parseInt%': parseInt,
	'$ %Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'$ %PromisePrototype%': typeof Promise === 'undefined' ? undefined : Promise.prototype,
	'$ %PromiseProto_then%': typeof Promise === 'undefined' ? undefined : Promise.prototype.then,
	'$ %Promise_all%': typeof Promise === 'undefined' ? undefined : Promise.all,
	'$ %Promise_reject%': typeof Promise === 'undefined' ? undefined : Promise.reject,
	'$ %Promise_resolve%': typeof Promise === 'undefined' ? undefined : Promise.resolve,
	'$ %Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'$ %RangeError%': RangeError,
	'$ %RangeErrorPrototype%': RangeError.prototype,
	'$ %ReferenceError%': ReferenceError,
	'$ %ReferenceErrorPrototype%': ReferenceError.prototype,
	'$ %Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'$ %RegExp%': RegExp,
	'$ %RegExpPrototype%': RegExp.prototype,
	'$ %Set%': typeof Set === 'undefined' ? undefined : Set,
	'$ %SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'$ %SetPrototype%': typeof Set === 'undefined' ? undefined : Set.prototype,
	'$ %SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'$ %SharedArrayBufferPrototype%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer.prototype,
	'$ %String%': String,
	'$ %StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'$ %StringPrototype%': String.prototype,
	'$ %Symbol%': hasSymbols ? Symbol : undefined,
	'$ %SymbolPrototype%': hasSymbols ? Symbol.prototype : undefined,
	'$ %SyntaxError%': SyntaxError,
	'$ %SyntaxErrorPrototype%': SyntaxError.prototype,
	'$ %ThrowTypeError%': ThrowTypeError,
	'$ %TypedArray%': TypedArray,
	'$ %TypedArrayPrototype%': TypedArray ? TypedArray.prototype : undefined,
	'$ %TypeError%': TypeError,
	'$ %TypeErrorPrototype%': TypeError.prototype,
	'$ %Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'$ %Uint8ArrayPrototype%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array.prototype,
	'$ %Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'$ %Uint8ClampedArrayPrototype%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray.prototype,
	'$ %Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'$ %Uint16ArrayPrototype%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array.prototype,
	'$ %Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'$ %Uint32ArrayPrototype%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array.prototype,
	'$ %URIError%': URIError,
	'$ %URIErrorPrototype%': URIError.prototype,
	'$ %WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'$ %WeakMapPrototype%': typeof WeakMap === 'undefined' ? undefined : WeakMap.prototype,
	'$ %WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
	'$ %WeakSetPrototype%': typeof WeakSet === 'undefined' ? undefined : WeakSet.prototype
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new TypeError('"allowMissing" argument must be a boolean');
	}

	var key = '$ ' + name;
	if (!(key in INTRINSICS)) {
		throw new SyntaxError('intrinsic ' + name + ' does not exist!');
	}

	// istanbul ignore if // hopefully this is impossible to test :-)
	if (typeof INTRINSICS[key] === 'undefined' && !allowMissing) {
		throw new TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
	}
	return INTRINSICS[key];
};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(574);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(70);
var document = __webpack_require__(28).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(70);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 206 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 207 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(209)('keys');
var uid = __webpack_require__(155);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(22);
var global = __webpack_require__(28);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(121) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 210 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 211 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1009), __esModule: true };

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(57);
var core = __webpack_require__(22);
var fails = __webpack_require__(103);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(580);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(62);
var dPs = __webpack_require__(1018);
var enumBugKeys = __webpack_require__(210);
var IE_PROTO = __webpack_require__(208)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(204)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(584).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(38);


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(28);
var core = __webpack_require__(22);
var LIBRARY = __webpack_require__(121);
var wksExt = __webpack_require__(216);
var defineProperty = __webpack_require__(69).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(156);
var createDesc = __webpack_require__(154);
var toIObject = __webpack_require__(89);
var toPrimitive = __webpack_require__(205);
var has = __webpack_require__(88);
var IE8_DOM_DEFINE = __webpack_require__(575);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(71) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1031);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1035);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(580);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(1047);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(122);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(123);

var _createClass3 = _interopRequireDefault(_createClass2);

var _CellSizeAndPositionManager = __webpack_require__(1048);

var _CellSizeAndPositionManager2 = _interopRequireDefault(_CellSizeAndPositionManager);

var _maxElementSize = __webpack_require__(1050);

var _types = __webpack_require__(72);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
 */


/**
 * Browsers have scroll offset limitations (eg Chrome stops scrolling at ~33.5M pixels where as Edge tops out at ~1.5M pixels).
 * After a certain position, the browser won't allow the user to scroll further (even via JavaScript scroll offset adjustments).
 * This util picks a lower ceiling for max size and artificially adjusts positions within to make it transparent for users.
 */

var ScalingCellSizeAndPositionManager = function () {
  function ScalingCellSizeAndPositionManager(_ref) {
    var _ref$maxScrollSize = _ref.maxScrollSize,
        maxScrollSize = _ref$maxScrollSize === undefined ? (0, _maxElementSize.getMaxElementSize)() : _ref$maxScrollSize,
        params = (0, _objectWithoutProperties3.default)(_ref, ['maxScrollSize']);
    (0, _classCallCheck3.default)(this, ScalingCellSizeAndPositionManager);

    // Favor composition over inheritance to simplify IE10 support
    this._cellSizeAndPositionManager = new _CellSizeAndPositionManager2.default(params);
    this._maxScrollSize = maxScrollSize;
  }

  (0, _createClass3.default)(ScalingCellSizeAndPositionManager, [{
    key: 'areOffsetsAdjusted',
    value: function areOffsetsAdjusted() {
      return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
    }
  }, {
    key: 'configure',
    value: function configure(params) {
      this._cellSizeAndPositionManager.configure(params);
    }
  }, {
    key: 'getCellCount',
    value: function getCellCount() {
      return this._cellSizeAndPositionManager.getCellCount();
    }
  }, {
    key: 'getEstimatedCellSize',
    value: function getEstimatedCellSize() {
      return this._cellSizeAndPositionManager.getEstimatedCellSize();
    }
  }, {
    key: 'getLastMeasuredIndex',
    value: function getLastMeasuredIndex() {
      return this._cellSizeAndPositionManager.getLastMeasuredIndex();
    }

    /**
     * Number of pixels a cell at the given position (offset) should be shifted in order to fit within the scaled container.
     * The offset passed to this function is scaled (safe) as well.
     */

  }, {
    key: 'getOffsetAdjustment',
    value: function getOffsetAdjustment(_ref2) {
      var containerSize = _ref2.containerSize,
          offset = _ref2.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();
      var offsetPercentage = this._getOffsetPercentage({
        containerSize: containerSize,
        offset: offset,
        totalSize: safeTotalSize
      });

      return Math.round(offsetPercentage * (safeTotalSize - totalSize));
    }
  }, {
    key: 'getSizeAndPositionOfCell',
    value: function getSizeAndPositionOfCell(index) {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
    }
  }, {
    key: 'getSizeAndPositionOfLastMeasuredCell',
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
    }

    /** See CellSizeAndPositionManager#getTotalSize */

  }, {
    key: 'getTotalSize',
    value: function getTotalSize() {
      return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
    }

    /** See CellSizeAndPositionManager#getUpdatedOffsetForIndex */

  }, {
    key: 'getUpdatedOffsetForIndex',
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align,
          align = _ref3$align === undefined ? 'auto' : _ref3$align,
          containerSize = _ref3.containerSize,
          currentOffset = _ref3.currentOffset,
          targetIndex = _ref3.targetIndex;

      currentOffset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: currentOffset
      });

      var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
        align: align,
        containerSize: containerSize,
        currentOffset: currentOffset,
        targetIndex: targetIndex
      });

      return this._offsetToSafeOffset({
        containerSize: containerSize,
        offset: offset
      });
    }

    /** See CellSizeAndPositionManager#getVisibleCellRange */

  }, {
    key: 'getVisibleCellRange',
    value: function getVisibleCellRange(_ref4) {
      var containerSize = _ref4.containerSize,
          offset = _ref4.offset;

      offset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: offset
      });

      return this._cellSizeAndPositionManager.getVisibleCellRange({
        containerSize: containerSize,
        offset: offset
      });
    }
  }, {
    key: 'resetCell',
    value: function resetCell(index) {
      this._cellSizeAndPositionManager.resetCell(index);
    }
  }, {
    key: '_getOffsetPercentage',
    value: function _getOffsetPercentage(_ref5) {
      var containerSize = _ref5.containerSize,
          offset = _ref5.offset,
          totalSize = _ref5.totalSize;

      return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
    }
  }, {
    key: '_offsetToSafeOffset',
    value: function _offsetToSafeOffset(_ref6) {
      var containerSize = _ref6.containerSize,
          offset = _ref6.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: totalSize
        });

        return Math.round(offsetPercentage * (safeTotalSize - containerSize));
      }
    }
  }, {
    key: '_safeOffsetToOffset',
    value: function _safeOffsetToOffset(_ref7) {
      var containerSize = _ref7.containerSize,
          offset = _ref7.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: safeTotalSize
        });

        return Math.round(offsetPercentage * (totalSize - containerSize));
      }
    }
  }]);
  return ScalingCellSizeAndPositionManager;
}();

exports.default = ScalingCellSizeAndPositionManager;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(153);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ivdLogo = exports.ivdLogo = 'data:image/png;base64,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';

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FattureList = undefined;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _deals = __webpack_require__(85);

var _deals2 = _interopRequireDefault(_deals);

var _Card = __webpack_require__(56);

var _Card2 = _interopRequireDefault(_Card);

var _utils = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FattureList = exports.FattureList = function FattureList(props) {
  //controllo se i dati vengono dalla view deal page o se sono passati via props
  var fatturePayload = props.dealFatture || props.fatture;

  return _react2.default.createElement(
    'div',
    { className: 'container' },
    fatturePayload.length > 0 && _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'h5',
        null,
        props.ruolo || ''
      ),
      fatturePayload.sort(function (a, b) {
        return a.dataFattura > b.dataFattura ? -1 : 1;
      }).map(function (fattura) {
        var deal = props.deals.find(function (deal) {
          return deal.id === fattura.dealId;
        });
        var oggetto = deal ? props.oggetti.find(function (ogg) {
          return ogg.id === deal.oggettoId;
        }) : '';
        var cliente = props.clienti.find(function (ilcliente) {
          return ilcliente.id === fattura.clienteId;
        });
        var cliente2 = props.clienti.find(function (ilcliente) {
          return ilcliente.id === fattura.clienteId2;
        });
        var iClienti = (cliente ? props.t('Cliente') + ': ' + cliente.nome + ' ' + cliente.cognome + ' ' + cliente.ditta : props.t('Nessuno')) + ' ' + (cliente2 ? '- ' + cliente2.nome + ' ' + cliente2.cognome + ' ' + cliente2.ditta : '');
        var dataFattura = (0, _utils.formattaData)(fattura.dataFattura);
        return _react2.default.createElement(_Card2.default, {
          key: fattura.id,
          visible: true,
          link: '/fatturaview/' + fattura.id,
          titolo: oggetto ? 'Rif. Id: ' + oggetto.rifId + ' - ' + oggetto.via + ' ' + oggetto.numeroCivico + ', WE ' + oggetto.numeroAppartamento : fattura.descrizioneProdotto,
          sottotitolo: oggetto ? oggetto.cap + ' ' + oggetto.citta : '',
          titoloDestra: _react2.default.createElement(
            'span',
            {
              className: 'card-title ' + (fattura.payed && 'list-item--paid')
            },
            '' + fattura.numeroFattura
          ),
          corpo: [iClienti, dataFattura]
        });
      })
    )
  );
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    fatture: (0, _deals2.default)('fatture', state.fatture, state.filters, state.utenti.find(function (utente) {
      return utente.firebaseAuthId === state.auth.uid;
    }), state.oggetti, state.clienti, undefined, state.deals),
    deals: state.deals,
    oggetti: state.oggetti,
    clienti: state.clienti
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()(FattureList));

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startLogout = exports.logout = exports.startLogin = exports.login = undefined;

var _firebase = __webpack_require__(192);

var login = exports.login = function login(uid) {
  return {
    type: 'LOGIN',
    uid: uid
  };
};

var startLogin = exports.startLogin = function startLogin() {
  return function () {
    var email = document.getElementById('email').value;
    var password = document.getElementById('password').value;
    // return firebase.auth().signInWithPopup(googleAuthProvider)
    return _firebase.firebase.auth().signInWithEmailAndPassword(email, password).catch(function (error) {
      var errorCode = error.code;
      var errorMessage = error.message;
      // [START_EXCLUDE]
      if (errorCode === 'auth/wrong-password') {
        alert('Wrong password.');
      } else {
        alert(errorMessage);
      }
      console.log(error);
    });
  };
};

var logout = exports.logout = function logout() {
  return {
    type: 'LOGOUT'
  };
};

var startLogout = exports.startLogout = function startLogout() {
  return function () {
    return _firebase.firebase.auth().signOut();
  };
};

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(16) && !__webpack_require__(10)(function () {
  return Object.defineProperty(__webpack_require__(161)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(13);


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(40);
var toIObject = __webpack_require__(41);
var arrayIndexOf = __webpack_require__(126)(false);
var IE_PROTO = __webpack_require__(163)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(17);
var anObject = __webpack_require__(7);
var getKeys = __webpack_require__(76);

module.exports = __webpack_require__(16) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(41);
var gOPN = __webpack_require__(79).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(16);
var getKeys = __webpack_require__(76);
var gOPS = __webpack_require__(127);
var pIE = __webpack_require__(106);
var toObject = __webpack_require__(19);
var IObject = __webpack_require__(105);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(10)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 231 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(26);
var isObject = __webpack_require__(11);
var invoke = __webpack_require__(233);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 233 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(8).parseInt;
var $trim = __webpack_require__(92).trim;
var ws = __webpack_require__(167);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(8).parseFloat;
var $trim = __webpack_require__(92).trim;

module.exports = 1 / $parseFloat(__webpack_require__(167) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(47);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(11);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 238 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(170);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(7);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(26);
var toObject = __webpack_require__(19);
var IObject = __webpack_require__(105);
var toLength = __webpack_require__(15);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(19);
var toAbsoluteIndex = __webpack_require__(77);
var toLength = __webpack_require__(15);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 243 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(182);
__webpack_require__(1)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(16) && /./g.flags != 'g') __webpack_require__(17).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(107)
});


/***/ }),
/* 246 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(7);
var isObject = __webpack_require__(11);
var newPromiseCapability = __webpack_require__(186);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(249);
var validate = __webpack_require__(84);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(135)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(17).f;
var create = __webpack_require__(78);
var redefineAll = __webpack_require__(83);
var ctx = __webpack_require__(46);
var anInstance = __webpack_require__(81);
var forOf = __webpack_require__(82);
var $iterDefine = __webpack_require__(172);
var step = __webpack_require__(243);
var setSpecies = __webpack_require__(80);
var DESCRIPTORS = __webpack_require__(16);
var fastKey = __webpack_require__(64).fastKey;
var validate = __webpack_require__(84);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(249);
var validate = __webpack_require__(84);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(135)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(8);
var each = __webpack_require__(55)(0);
var redefine = __webpack_require__(34);
var meta = __webpack_require__(64);
var assign = __webpack_require__(230);
var weak = __webpack_require__(252);
var isObject = __webpack_require__(11);
var validate = __webpack_require__(84);
var NATIVE_WEAK_MAP = __webpack_require__(84);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(135)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(83);
var getWeak = __webpack_require__(64).getWeak;
var anObject = __webpack_require__(7);
var isObject = __webpack_require__(11);
var anInstance = __webpack_require__(81);
var forOf = __webpack_require__(82);
var createArrayMethod = __webpack_require__(55);
var $has = __webpack_require__(40);
var validate = __webpack_require__(84);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(48);
var toLength = __webpack_require__(15);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(79);
var gOPS = __webpack_require__(127);
var anObject = __webpack_require__(7);
var Reflect = __webpack_require__(8).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(128);
var isObject = __webpack_require__(11);
var toLength = __webpack_require__(15);
var ctx = __webpack_require__(46);
var IS_CONCAT_SPREADABLE = __webpack_require__(13)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(15);
var repeat = __webpack_require__(169);
var defined = __webpack_require__(53);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(16);
var getKeys = __webpack_require__(76);
var toIObject = __webpack_require__(41);
var isEnum = __webpack_require__(106).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(91);
var from = __webpack_require__(259);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(82);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 260 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useSSR;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__context__ = __webpack_require__(95);


function useSSR(initialI18nStore, initialLanguage) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var i18nFromProps = props.i18n;
  var ReactI18nContext = __WEBPACK_IMPORTED_MODULE_0_react__["useContext"](__WEBPACK_IMPORTED_MODULE_1__context__["a" /* I18nContext */]);

  var _ref = __WEBPACK_IMPORTED_MODULE_1__context__["e" /* getHasUsedI18nextProvider */]() ? ReactI18nContext || {} : {},
      i18nFromContext = _ref.i18n;

  var i18n = i18nFromProps || i18nFromContext || __WEBPACK_IMPORTED_MODULE_1__context__["f" /* getI18n */](); // opt out if is a cloned instance, eg. created by i18next-express-middleware on request
  // -> do not set initial stuff on server side

  if (i18n.options && i18n.options.isClone) return; // nextjs / SSR: getting data from next.js or other ssr stack

  if (initialI18nStore && !i18n.initializedStoreOnce) {
    i18n.services.resourceStore.data = initialI18nStore; // add namespaces to the config - so a languageChange call loads all namespaces needed

    i18n.options.ns = Object.values(initialI18nStore).reduce(function (mem, lngResources) {
      Object.keys(lngResources).forEach(function (ns) {
        if (mem.indexOf(ns) < 0) mem.push(ns);
      });
      return mem;
    }, i18n.options.ns);
    i18n.initializedStoreOnce = true;
    i18n.isInitialized = true;
  }

  if (initialLanguage && !i18n.initializedLanguageOnce) {
    i18n.changeLanguage(initialLanguage);
    i18n.initializedLanguageOnce = true;
  }
}

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(265);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default.a(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default.a(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default.a(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidMount` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          if (this.subscription) this.subscription.tryUnsubscribe();
          this.initSubscription();
          if (shouldHandleStateChanges) this.subscription.trySubscribe();
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default.a(Connect, WrappedComponent);
  };
}

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(271);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(885);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */](action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(878);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(274);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(190);



function verifyPlainObject(value, displayName, methodName) {
  if (!__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */](value)) {
    __WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */](methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MemoryRouter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Prompt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Redirect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Router; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return StaticRouter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Switch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return generatePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return matchPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return withRouter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return context; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_context__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_context__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_warning__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_history__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tiny_invariant__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_path_to_regexp__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_path_to_regexp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__);













// TODO: Replace with React.createContext once we can assume React 16+

var createNamedContext = function createNamedContext(name) {
  var context = __WEBPACK_IMPORTED_MODULE_0_create_react_context___default.a();
  context.Provider.displayName = name + ".Provider";
  context.Consumer.displayName = name + ".Consumer";
  return context;
};

var context =
/*#__PURE__*/
createNamedContext('Router');

/**
 * The public API for putting history on context.
 */

var Router =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */](Router, _React$Component);

  Router.computeRootMatch = function computeRootMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  function Router(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      location: props.history.location
    }; // This is a bit of a hack. We have to start listening for location
    // changes here in the constructor in case there are any <Redirect>s
    // on the initial render. If there are, they will replace/push when
    // they mount and since cDM fires in children before parents, we may
    // get a new location before the <Router> is mounted.

    _this._isMounted = false;
    _this._pendingLocation = null;

    if (!props.staticContext) {
      _this.unlisten = props.history.listen(function (location) {
        if (_this._isMounted) {
          _this.setState({
            location: location
          });
        } else {
          _this._pendingLocation = location;
        }
      });
    }

    return _this;
  }

  var _proto = Router.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._isMounted = true;

    if (this._pendingLocation) {
      this.setState({
        location: this._pendingLocation
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.unlisten) this.unlisten();
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Provider, {
      children: this.props.children || null,
      value: {
        history: this.props.history,
        location: this.state.location,
        match: Router.computeRootMatch(this.state.location.pathname),
        staticContext: this.props.staticContext
      }
    });
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  Router.propTypes = {
    children: PropTypes.node,
    history: PropTypes.object.isRequired,
    staticContext: PropTypes.object
  };

  Router.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(prevProps.history === this.props.history, "You cannot change <Router history>") : void 0;
  };
}

/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */](MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = __WEBPACK_IMPORTED_MODULE_5_history__["b" /* createMemoryHistory */](_this.props);
    return _this;
  }

  var _proto = MemoryRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Router, {
      history: this.history,
      children: this.props.children
    });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  MemoryRouter.propTypes = {
    initialEntries: PropTypes.array,
    initialIndex: PropTypes.number,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number,
    children: PropTypes.node
  };

  MemoryRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.") : void 0;
  };
}

var Lifecycle =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */](Lifecycle, _React$Component);

  function Lifecycle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Lifecycle.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.onMount) this.props.onMount.call(this, this);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.onUnmount) this.props.onUnmount.call(this, this);
  };

  _proto.render = function render() {
    return null;
  };

  return Lifecycle;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

/**
 * The public API for prompting the user before navigating away from a screen.
 */

function Prompt(_ref) {
  var message = _ref.message,
      _ref$when = _ref.when,
      when = _ref$when === void 0 ? true : _ref$when;
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Consumer, null, function (context$$1) {
    !context$$1 ?  false ? invariant(false, "You should not use <Prompt> outside a <Router>") : __WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */](false) : void 0;
    if (!when || context$$1.staticContext) return null;
    var method = context$$1.history.block;
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Lifecycle, {
      onMount: function onMount(self) {
        self.release = method(message);
      },
      onUpdate: function onUpdate(self, prevProps) {
        if (prevProps.message !== message) {
          self.release();
          self.release = method(message);
        }
      },
      onUnmount: function onUnmount(self) {
        self.release();
      },
      message: message
    });
  });
}

if (false) {
  var messageType = PropTypes.oneOfType([PropTypes.func, PropTypes.string]);
  Prompt.propTypes = {
    when: PropTypes.bool,
    message: messageType.isRequired
  };
}

var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;

function compilePath(path) {
  if (cache[path]) return cache[path];
  var generator = __WEBPACK_IMPORTED_MODULE_7_path_to_regexp___default.a.compile(path);

  if (cacheCount < cacheLimit) {
    cache[path] = generator;
    cacheCount++;
  }

  return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */


function generatePath(path, params) {
  if (path === void 0) {
    path = "/";
  }

  if (params === void 0) {
    params = {};
  }

  return path === "/" ? path : compilePath(path)(params, {
    pretty: true
  });
}

/**
 * The public API for navigating programmatically with a component.
 */

function Redirect(_ref) {
  var computedMatch = _ref.computedMatch,
      to = _ref.to,
      _ref$push = _ref.push,
      push = _ref$push === void 0 ? false : _ref$push;
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Consumer, null, function (context$$1) {
    !context$$1 ?  false ? invariant(false, "You should not use <Redirect> outside a <Router>") : __WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */](false) : void 0;
    var history = context$$1.history,
        staticContext = context$$1.staticContext;
    var method = push ? history.push : history.replace;
    var location = __WEBPACK_IMPORTED_MODULE_5_history__["a" /* createLocation */](computedMatch ? typeof to === "string" ? generatePath(to, computedMatch.params) : __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */]({}, to, {
      pathname: generatePath(to.pathname, computedMatch.params)
    }) : to); // When rendering in a static context,
    // set the new location immediately.

    if (staticContext) {
      method(location);
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Lifecycle, {
      onMount: function onMount() {
        method(location);
      },
      onUpdate: function onUpdate(self, prevProps) {
        if (!__WEBPACK_IMPORTED_MODULE_5_history__["d" /* locationsAreEqual */](prevProps.to, location)) {
          method(location);
        }
      },
      to: to
    });
  });
}

if (false) {
  Redirect.propTypes = {
    push: PropTypes.bool,
    from: PropTypes.string,
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
  };
}

var cache$1 = {};
var cacheLimit$1 = 10000;
var cacheCount$1 = 0;

function compilePath$1(path, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var pathCache = cache$1[cacheKey] || (cache$1[cacheKey] = {});
  if (pathCache[path]) return pathCache[path];
  var keys = [];
  var regexp = __WEBPACK_IMPORTED_MODULE_7_path_to_regexp___default.a(path, keys, options);
  var result = {
    regexp: regexp,
    keys: keys
  };

  if (cacheCount$1 < cacheLimit$1) {
    pathCache[path] = result;
    cacheCount$1++;
  }

  return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */


function matchPath(pathname, options) {
  if (options === void 0) {
    options = {};
  }

  if (typeof options === "string") options = {
    path: options
  };
  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === void 0 ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === void 0 ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
  var paths = [].concat(path);
  return paths.reduce(function (matched, path) {
    if (matched) return matched;

    var _compilePath = compilePath$1(path, {
      end: exact,
      strict: strict,
      sensitive: sensitive
    }),
        regexp = _compilePath.regexp,
        keys = _compilePath.keys;

    var match = regexp.exec(pathname);
    if (!match) return null;
    var url = match[0],
        values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
      path: path,
      // the path used to match
      url: path === "/" && url === "" ? "/" : url,
      // the matched portion of the URL
      isExact: isExact,
      // whether or not we matched exactly
      params: keys.reduce(function (memo, key, index) {
        memo[key.name] = values[index];
        return memo;
      }, {})
    };
  }, null);
}

function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
}
/**
 * The public API for matching a single path and rendering.
 */


var Route =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */](Route, _React$Component);

  function Route() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Route.prototype;

  _proto.render = function render() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Consumer, null, function (context$$1) {
      !context$$1 ?  false ? invariant(false, "You should not use <Route> outside a <Router>") : __WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */](false) : void 0;
      var location = _this.props.location || context$$1.location;
      var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
      : _this.props.path ? matchPath(location.pathname, _this.props) : context$$1.match;

      var props = __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */]({}, context$$1, {
        location: location,
        match: match
      });

      var _this$props = _this.props,
          children = _this$props.children,
          component = _this$props.component,
          render = _this$props.render; // Preact uses an empty array as children by
      // default, so use null if that's the case.

      if (Array.isArray(children) && children.length === 0) {
        children = null;
      }

      if (typeof children === "function") {
        children = children(props);

        if (children === undefined) {
          if (false) {
            var path = _this.props.path;
            process.env.NODE_ENV !== "production" ? warning(false, "You returned `undefined` from the `children` function of " + ("<Route" + (path ? " path=\"" + path + "\"" : "") + ">, but you ") + "should have returned a React element or `null`") : void 0;
          }

          children = null;
        }
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Provider, {
        value: props
      }, children && !isEmptyChildren(children) ? children : props.match ? component ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : render ? render(props) : null : null);
    });
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  Route.propTypes = {
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
    component: function component(props, propName) {
      if (props[propName] && !isValidElementType(props[propName])) {
        return new Error("Invalid prop 'component' supplied to 'Route': the prop is not a valid React component");
      }
    },
    exact: PropTypes.bool,
    location: PropTypes.object,
    path: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    render: PropTypes.func,
    sensitive: PropTypes.bool,
    strict: PropTypes.bool
  };

  Route.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.component), "You should not use <Route component> and <Route children> in the same route; <Route component> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.render), "You should not use <Route render> and <Route children> in the same route; <Route render> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored") : void 0;
  };

  Route.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
}

function addBasename(basename, location) {
  if (!basename) return location;
  return __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */]({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
}

function stripBasename(basename, location) {
  if (!basename) return location;
  var base = addLeadingSlash(basename);
  if (location.pathname.indexOf(base) !== 0) return location;
  return __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */]({}, location, {
    pathname: location.pathname.substr(base.length)
  });
}

function createURL(location) {
  return typeof location === "string" ? location : __WEBPACK_IMPORTED_MODULE_5_history__["c" /* createPath */](location);
}

function staticHandler(methodName) {
  return function () {
     false ? invariant(false, "You cannot %s with <StaticRouter>", methodName) : __WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */](false);
  };
}

function noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */


var StaticRouter =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */](StaticRouter, _React$Component);

  function StaticRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handlePush = function (location) {
      return _this.navigateTo(location, "PUSH");
    };

    _this.handleReplace = function (location) {
      return _this.navigateTo(location, "REPLACE");
    };

    _this.handleListen = function () {
      return noop;
    };

    _this.handleBlock = function () {
      return noop;
    };

    return _this;
  }

  var _proto = StaticRouter.prototype;

  _proto.navigateTo = function navigateTo(location, action) {
    var _this$props = this.props,
        _this$props$basename = _this$props.basename,
        basename = _this$props$basename === void 0 ? "" : _this$props$basename,
        context = _this$props.context;
    context.action = action;
    context.location = addBasename(basename, __WEBPACK_IMPORTED_MODULE_5_history__["a" /* createLocation */](location));
    context.url = createURL(context.location);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        _this$props2$basename = _this$props2.basename,
        basename = _this$props2$basename === void 0 ? "" : _this$props2$basename,
        _this$props2$context = _this$props2.context,
        context = _this$props2$context === void 0 ? {} : _this$props2$context,
        _this$props2$location = _this$props2.location,
        location = _this$props2$location === void 0 ? "/" : _this$props2$location,
        rest = __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */](_this$props2, ["basename", "context", "location"]);

    var history = {
      createHref: function createHref(path) {
        return addLeadingSlash(basename + createURL(path));
      },
      action: "POP",
      location: stripBasename(basename, __WEBPACK_IMPORTED_MODULE_5_history__["a" /* createLocation */](location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Router, __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */]({}, rest, {
      history: history,
      staticContext: context
    }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  StaticRouter.propTypes = {
    basename: PropTypes.string,
    context: PropTypes.object,
    location: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  };

  StaticRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */](Switch, _React$Component);

  function Switch() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Switch.prototype;

  _proto.render = function render() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Consumer, null, function (context$$1) {
      !context$$1 ?  false ? invariant(false, "You should not use <Switch> outside a <Router>") : __WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */](false) : void 0;
      var location = _this.props.location || context$$1.location;
      var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
      // here because toArray adds keys to all child elements and we do not want
      // to trigger an unmount/remount for two <Route>s that render the same
      // component at different URLs.

      __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.forEach(_this.props.children, function (child) {
        if (match == null && __WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(child)) {
          element = child;
          var path = child.props.path || child.props.from;
          match = path ? matchPath(location.pathname, __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */]({}, child.props, {
            path: path
          })) : context$$1.match;
        }
      });
      return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(element, {
        location: location,
        computedMatch: match
      }) : null;
    });
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  Switch.propTypes = {
    children: PropTypes.node,
    location: PropTypes.object
  };

  Switch.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

/**
 * A public higher-order component to access the imperative API
 */

function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */](props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Route, {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */]({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;

  if (false) {
    C.propTypes = {
      wrappedComponentRef: PropTypes.func
    };
  }

  return __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default.a(C, Component);
}

if (false) {
  if (typeof window !== "undefined") {
    var global = window;
    var key = "__react_router_build__";
    var buildNames = {
      cjs: "CommonJS",
      esm: "ES modules",
      umd: "UMD"
    };

    if (global[key] && global[key] !== "esm") {
      var initialBuildName = buildNames[global[key]];
      var secondaryBuildName = buildNames["esm"]; // TODO: Add link to article that explains in detail how to avoid
      // loading 2 different builds.

      throw new Error("You are loading the " + secondaryBuildName + " build of React Router " + ("on a page that is already running the " + initialBuildName + " ") + "build, so things won't work right.");
    }

    global[key] = "esm";
  }
}




/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(916);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 281 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var af = moment.defineLocale('af', {
    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
    meridiemParse: /vm|nm/i,
    isPM : function (input) {
        return /^nm$/i.test(input);
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower ? 'vm' : 'VM';
        } else {
            return isLower ? 'nm' : 'NM';
        }
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Vandag om] LT',
        nextDay : '[Môre om] LT',
        nextWeek : 'dddd [om] LT',
        lastDay : '[Gister om] LT',
        lastWeek : '[Laas] dddd [om] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'oor %s',
        past : '%s gelede',
        s : '\'n paar sekondes',
        m : '\'n minuut',
        mm : '%d minute',
        h : '\'n uur',
        hh : '%d ure',
        d : '\'n dag',
        dd : '%d dae',
        M : '\'n maand',
        MM : '%d maande',
        y : '\'n jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
    },
    week : {
        dow : 1, // Maandag is die eerste dag van die week.
        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
    }
});

return af;

})));


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '١',
    '2': '٢',
    '3': '٣',
    '4': '٤',
    '5': '٥',
    '6': '٦',
    '7': '٧',
    '8': '٨',
    '9': '٩',
    '0': '٠'
};
var numberMap = {
    '١': '1',
    '٢': '2',
    '٣': '3',
    '٤': '4',
    '٥': '5',
    '٦': '6',
    '٧': '7',
    '٨': '8',
    '٩': '9',
    '٠': '0'
};
var pluralForm = function (n) {
    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
};
var plurals = {
    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
};
var pluralize = function (u) {
    return function (number, withoutSuffix, string, isFuture) {
        var f = pluralForm(number),
            str = plurals[u][pluralForm(number)];
        if (f === 2) {
            str = str[withoutSuffix ? 0 : 1];
        }
        return str.replace(/%d/i, number);
    };
};
var months = [
    'كانون الثاني يناير',
    'شباط فبراير',
    'آذار مارس',
    'نيسان أبريل',
    'أيار مايو',
    'حزيران يونيو',
    'تموز يوليو',
    'آب أغسطس',
    'أيلول سبتمبر',
    'تشرين الأول أكتوبر',
    'تشرين الثاني نوفمبر',
    'كانون الأول ديسمبر'
];

var ar = moment.defineLocale('ar', {
    months : months,
    monthsShort : months,
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/\u200FM/\u200FYYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم عند الساعة] LT',
        nextDay: '[غدًا عند الساعة] LT',
        nextWeek: 'dddd [عند الساعة] LT',
        lastDay: '[أمس عند الساعة] LT',
        lastWeek: 'dddd [عند الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'بعد %s',
        past : 'منذ %s',
        s : pluralize('s'),
        m : pluralize('m'),
        mm : pluralize('m'),
        h : pluralize('h'),
        hh : pluralize('h'),
        d : pluralize('d'),
        dd : pluralize('d'),
        M : pluralize('M'),
        MM : pluralize('M'),
        y : pluralize('y'),
        yy : pluralize('y')
    },
    preparse: function (string) {
        return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return ar;

})));


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arDz = moment.defineLocale('ar-dz', {
    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 4  // The week that contains Jan 1st is the first week of the year.
    }
});

return arDz;

})));


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arKw = moment.defineLocale('ar-kw', {
    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arKw;

})));


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Lybia) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    '0': '0'
};
var pluralForm = function (n) {
    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
};
var plurals = {
    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
};
var pluralize = function (u) {
    return function (number, withoutSuffix, string, isFuture) {
        var f = pluralForm(number),
            str = plurals[u][pluralForm(number)];
        if (f === 2) {
            str = str[withoutSuffix ? 0 : 1];
        }
        return str.replace(/%d/i, number);
    };
};
var months = [
    'يناير',
    'فبراير',
    'مارس',
    'أبريل',
    'مايو',
    'يونيو',
    'يوليو',
    'أغسطس',
    'سبتمبر',
    'أكتوبر',
    'نوفمبر',
    'ديسمبر'
];

var arLy = moment.defineLocale('ar-ly', {
    months : months,
    monthsShort : months,
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/\u200FM/\u200FYYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم عند الساعة] LT',
        nextDay: '[غدًا عند الساعة] LT',
        nextWeek: 'dddd [عند الساعة] LT',
        lastDay: '[أمس عند الساعة] LT',
        lastWeek: 'dddd [عند الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'بعد %s',
        past : 'منذ %s',
        s : pluralize('s'),
        m : pluralize('m'),
        mm : pluralize('m'),
        h : pluralize('h'),
        hh : pluralize('h'),
        d : pluralize('d'),
        dd : pluralize('d'),
        M : pluralize('M'),
        MM : pluralize('M'),
        y : pluralize('y'),
        yy : pluralize('y')
    },
    preparse: function (string) {
        return string.replace(/\u200f/g, '').replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arLy;

})));


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arMa = moment.defineLocale('ar-ma', {
    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arMa;

})));


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '١',
    '2': '٢',
    '3': '٣',
    '4': '٤',
    '5': '٥',
    '6': '٦',
    '7': '٧',
    '8': '٨',
    '9': '٩',
    '0': '٠'
};
var numberMap = {
    '١': '1',
    '٢': '2',
    '٣': '3',
    '٤': '4',
    '٥': '5',
    '٦': '6',
    '٧': '7',
    '٨': '8',
    '٩': '9',
    '٠': '0'
};

var arSa = moment.defineLocale('ar-sa', {
    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    preparse: function (string) {
        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return arSa;

})));


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arTn = moment.defineLocale('ar-tn', {
    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'في %s',
        past: 'منذ %s',
        s: 'ثوان',
        m: 'دقيقة',
        mm: '%d دقائق',
        h: 'ساعة',
        hh: '%d ساعات',
        d: 'يوم',
        dd: '%d أيام',
        M: 'شهر',
        MM: '%d أشهر',
        y: 'سنة',
        yy: '%d سنوات'
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return arTn;

})));


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    1: '-inci',
    5: '-inci',
    8: '-inci',
    70: '-inci',
    80: '-inci',
    2: '-nci',
    7: '-nci',
    20: '-nci',
    50: '-nci',
    3: '-üncü',
    4: '-üncü',
    100: '-üncü',
    6: '-ncı',
    9: '-uncu',
    10: '-uncu',
    30: '-uncu',
    60: '-ıncı',
    90: '-ıncı'
};

var az = moment.defineLocale('az', {
    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[bugün saat] LT',
        nextDay : '[sabah saat] LT',
        nextWeek : '[gələn həftə] dddd [saat] LT',
        lastDay : '[dünən] LT',
        lastWeek : '[keçən həftə] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s sonra',
        past : '%s əvvəl',
        s : 'birneçə saniyyə',
        m : 'bir dəqiqə',
        mm : '%d dəqiqə',
        h : 'bir saat',
        hh : '%d saat',
        d : 'bir gün',
        dd : '%d gün',
        M : 'bir ay',
        MM : '%d ay',
        y : 'bir il',
        yy : '%d il'
    },
    meridiemParse: /gecə|səhər|gündüz|axşam/,
    isPM : function (input) {
        return /^(gündüz|axşam)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'gecə';
        } else if (hour < 12) {
            return 'səhər';
        } else if (hour < 17) {
            return 'gündüz';
        } else {
            return 'axşam';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
    ordinal : function (number) {
        if (number === 0) {  // special case for zero
            return number + '-ıncı';
        }
        var a = number % 10,
            b = number % 100 - a,
            c = number >= 100 ? 100 : null;
        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return az;

})));


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
        'dd': 'дзень_дні_дзён',
        'MM': 'месяц_месяцы_месяцаў',
        'yy': 'год_гады_гадоў'
    };
    if (key === 'm') {
        return withoutSuffix ? 'хвіліна' : 'хвіліну';
    }
    else if (key === 'h') {
        return withoutSuffix ? 'гадзіна' : 'гадзіну';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}

var be = moment.defineLocale('be', {
    months : {
        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
    },
    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
    weekdays : {
        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
    },
    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY г.',
        LLL : 'D MMMM YYYY г., HH:mm',
        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
    },
    calendar : {
        sameDay: '[Сёння ў] LT',
        nextDay: '[Заўтра ў] LT',
        lastDay: '[Учора ў] LT',
        nextWeek: function () {
            return '[У] dddd [ў] LT';
        },
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                    return '[У мінулую] dddd [ў] LT';
                case 1:
                case 2:
                case 4:
                    return '[У мінулы] dddd [ў] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'праз %s',
        past : '%s таму',
        s : 'некалькі секунд',
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : relativeTimeWithPlural,
        hh : relativeTimeWithPlural,
        d : 'дзень',
        dd : relativeTimeWithPlural,
        M : 'месяц',
        MM : relativeTimeWithPlural,
        y : 'год',
        yy : relativeTimeWithPlural
    },
    meridiemParse: /ночы|раніцы|дня|вечара/,
    isPM : function (input) {
        return /^(дня|вечара)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночы';
        } else if (hour < 12) {
            return 'раніцы';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечара';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
            case 'w':
            case 'W':
                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
            case 'D':
                return number + '-га';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return be;

})));


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var bg = moment.defineLocale('bg', {
    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'D.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay : '[Днес в] LT',
        nextDay : '[Утре в] LT',
        nextWeek : 'dddd [в] LT',
        lastDay : '[Вчера в] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 6:
                    return '[В изминалата] dddd [в] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[В изминалия] dddd [в] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'след %s',
        past : 'преди %s',
        s : 'няколко секунди',
        m : 'минута',
        mm : '%d минути',
        h : 'час',
        hh : '%d часа',
        d : 'ден',
        dd : '%d дни',
        M : 'месец',
        MM : '%d месеца',
        y : 'година',
        yy : '%d години'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
    ordinal : function (number) {
        var lastDigit = number % 10,
            last2Digits = number % 100;
        if (number === 0) {
            return number + '-ев';
        } else if (last2Digits === 0) {
            return number + '-ен';
        } else if (last2Digits > 10 && last2Digits < 20) {
            return number + '-ти';
        } else if (lastDigit === 1) {
            return number + '-ви';
        } else if (lastDigit === 2) {
            return number + '-ри';
        } else if (lastDigit === 7 || lastDigit === 8) {
            return number + '-ми';
        } else {
            return number + '-ти';
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return bg;

})));


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '১',
    '2': '২',
    '3': '৩',
    '4': '৪',
    '5': '৫',
    '6': '৬',
    '7': '৭',
    '8': '৮',
    '9': '৯',
    '0': '০'
};
var numberMap = {
    '১': '1',
    '২': '2',
    '৩': '3',
    '৪': '4',
    '৫': '5',
    '৬': '6',
    '৭': '7',
    '৮': '8',
    '৯': '9',
    '০': '0'
};

var bn = moment.defineLocale('bn', {
    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
    longDateFormat : {
        LT : 'A h:mm সময়',
        LTS : 'A h:mm:ss সময়',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm সময়',
        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
    },
    calendar : {
        sameDay : '[আজ] LT',
        nextDay : '[আগামীকাল] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[গতকাল] LT',
        lastWeek : '[গত] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s পরে',
        past : '%s আগে',
        s : 'কয়েক সেকেন্ড',
        m : 'এক মিনিট',
        mm : '%d মিনিট',
        h : 'এক ঘন্টা',
        hh : '%d ঘন্টা',
        d : 'এক দিন',
        dd : '%d দিন',
        M : 'এক মাস',
        MM : '%d মাস',
        y : 'এক বছর',
        yy : '%d বছর'
    },
    preparse: function (string) {
        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'রাত';
        } else if (hour < 10) {
            return 'সকাল';
        } else if (hour < 17) {
            return 'দুপুর';
        } else if (hour < 20) {
            return 'বিকাল';
        } else {
            return 'রাত';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return bn;

})));


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '༡',
    '2': '༢',
    '3': '༣',
    '4': '༤',
    '5': '༥',
    '6': '༦',
    '7': '༧',
    '8': '༨',
    '9': '༩',
    '0': '༠'
};
var numberMap = {
    '༡': '1',
    '༢': '2',
    '༣': '3',
    '༤': '4',
    '༥': '5',
    '༦': '6',
    '༧': '7',
    '༨': '8',
    '༩': '9',
    '༠': '0'
};

var bo = moment.defineLocale('bo', {
    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[དི་རིང] LT',
        nextDay : '[སང་ཉིན] LT',
        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
        lastDay : '[ཁ་སང] LT',
        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ལ་',
        past : '%s སྔན་ལ',
        s : 'ལམ་སང',
        m : 'སྐར་མ་གཅིག',
        mm : '%d སྐར་མ',
        h : 'ཆུ་ཚོད་གཅིག',
        hh : '%d ཆུ་ཚོད',
        d : 'ཉིན་གཅིག',
        dd : '%d ཉིན་',
        M : 'ཟླ་བ་གཅིག',
        MM : '%d ཟླ་བ',
        y : 'ལོ་གཅིག',
        yy : '%d ལོ'
    },
    preparse: function (string) {
        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'མཚན་མོ';
        } else if (hour < 10) {
            return 'ཞོགས་ཀས';
        } else if (hour < 17) {
            return 'ཉིན་གུང';
        } else if (hour < 20) {
            return 'དགོང་དག';
        } else {
            return 'མཚན་མོ';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return bo;

})));


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function relativeTimeWithMutation(number, withoutSuffix, key) {
    var format = {
        'mm': 'munutenn',
        'MM': 'miz',
        'dd': 'devezh'
    };
    return number + ' ' + mutation(format[key], number);
}
function specialMutationForYears(number) {
    switch (lastNumber(number)) {
        case 1:
        case 3:
        case 4:
        case 5:
        case 9:
            return number + ' bloaz';
        default:
            return number + ' vloaz';
    }
}
function lastNumber(number) {
    if (number > 9) {
        return lastNumber(number % 10);
    }
    return number;
}
function mutation(text, number) {
    if (number === 2) {
        return softMutation(text);
    }
    return text;
}
function softMutation(text) {
    var mutationTable = {
        'm': 'v',
        'b': 'v',
        'd': 'z'
    };
    if (mutationTable[text.charAt(0)] === undefined) {
        return text;
    }
    return mutationTable[text.charAt(0)] + text.substring(1);
}

var br = moment.defineLocale('br', {
    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h[e]mm A',
        LTS : 'h[e]mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D [a viz] MMMM YYYY',
        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
    },
    calendar : {
        sameDay : '[Hiziv da] LT',
        nextDay : '[Warc\'hoazh da] LT',
        nextWeek : 'dddd [da] LT',
        lastDay : '[Dec\'h da] LT',
        lastWeek : 'dddd [paset da] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'a-benn %s',
        past : '%s \'zo',
        s : 'un nebeud segondennoù',
        m : 'ur vunutenn',
        mm : relativeTimeWithMutation,
        h : 'un eur',
        hh : '%d eur',
        d : 'un devezh',
        dd : relativeTimeWithMutation,
        M : 'ur miz',
        MM : relativeTimeWithMutation,
        y : 'ur bloaz',
        yy : specialMutationForYears
    },
    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
    ordinal : function (number) {
        var output = (number === 1) ? 'añ' : 'vet';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return br;

})));


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'm':
            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minuta';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'jedan sat' : 'jednog sata';
        case 'hh':
            if (number === 1) {
                result += 'sat';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
            } else {
                result += 'sati';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dana';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mjesec';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
            } else {
                result += 'mjeseci';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'godina';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
            } else {
                result += 'godina';
            }
            return result;
    }
}

var bs = moment.defineLocale('bs', {
    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danas u] LT',
        nextDay  : '[sutra u] LT',
        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[jučer u] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                    return '[prošlu] dddd [u] LT';
                case 6:
                    return '[prošle] [subote] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prošli] dddd [u] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'par sekundi',
        m      : translate,
        mm     : translate,
        h      : translate,
        hh     : translate,
        d      : 'dan',
        dd     : translate,
        M      : 'mjesec',
        MM     : translate,
        y      : 'godinu',
        yy     : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return bs;

})));


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ca = moment.defineLocale('ca', {
    months : {
        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
        isFormat: /D[oD]?(\s)+MMMM/
    },
    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
    monthsParseExact : true,
    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
    weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : '[el] D MMMM [de] YYYY',
        ll : 'D MMM YYYY',
        LLL : '[el] D MMMM [de] YYYY [a les] H:mm',
        lll : 'D MMM YYYY, H:mm',
        LLLL : '[el] dddd D MMMM [de] YYYY [a les] H:mm',
        llll : 'ddd D MMM YYYY, H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        nextDay : function () {
            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        lastDay : function () {
            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'd\'aquí %s',
        past : 'fa %s',
        s : 'uns segons',
        m : 'un minut',
        mm : '%d minuts',
        h : 'una hora',
        hh : '%d hores',
        d : 'un dia',
        dd : '%d dies',
        M : 'un mes',
        MM : '%d mesos',
        y : 'un any',
        yy : '%d anys'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
    ordinal : function (number, period) {
        var output = (number === 1) ? 'r' :
            (number === 2) ? 'n' :
            (number === 3) ? 'r' :
            (number === 4) ? 't' : 'è';
        if (period === 'w' || period === 'W') {
            output = 'a';
        }
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ca;

})));


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
function plural(n) {
    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':  // a few seconds / in a few seconds / a few seconds ago
            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
        case 'm':  // a minute / in a minute / a minute ago
            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minuty' : 'minut');
            } else {
                return result + 'minutami';
            }
            break;
        case 'h':  // an hour / in an hour / an hour ago
            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
        case 'hh': // 9 hours / in 9 hours / 9 hours ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodin');
            } else {
                return result + 'hodinami';
            }
            break;
        case 'd':  // a day / in a day / a day ago
            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
        case 'dd': // 9 days / in 9 days / 9 days ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dny' : 'dní');
            } else {
                return result + 'dny';
            }
            break;
        case 'M':  // a month / in a month / a month ago
            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
        case 'MM': // 9 months / in 9 months / 9 months ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'měsíce' : 'měsíců');
            } else {
                return result + 'měsíci';
            }
            break;
        case 'y':  // a year / in a year / a year ago
            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
        case 'yy': // 9 years / in 9 years / 9 years ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'let');
            } else {
                return result + 'lety';
            }
            break;
    }
}

var cs = moment.defineLocale('cs', {
    months : months,
    monthsShort : monthsShort,
    monthsParse : (function (months, monthsShort) {
        var i, _monthsParse = [];
        for (i = 0; i < 12; i++) {
            // use custom parser to solve problem with July (červenec)
            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
        }
        return _monthsParse;
    }(months, monthsShort)),
    shortMonthsParse : (function (monthsShort) {
        var i, _shortMonthsParse = [];
        for (i = 0; i < 12; i++) {
            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
        }
        return _shortMonthsParse;
    }(monthsShort)),
    longMonthsParse : (function (months) {
        var i, _longMonthsParse = [];
        for (i = 0; i < 12; i++) {
            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
        }
        return _longMonthsParse;
    }(months)),
    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
    longDateFormat : {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd D. MMMM YYYY H:mm',
        l : 'D. M. YYYY'
    },
    calendar : {
        sameDay: '[dnes v] LT',
        nextDay: '[zítra v] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[v neděli v] LT';
                case 1:
                case 2:
                    return '[v] dddd [v] LT';
                case 3:
                    return '[ve středu v] LT';
                case 4:
                    return '[ve čtvrtek v] LT';
                case 5:
                    return '[v pátek v] LT';
                case 6:
                    return '[v sobotu v] LT';
            }
        },
        lastDay: '[včera v] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[minulou neděli v] LT';
                case 1:
                case 2:
                    return '[minulé] dddd [v] LT';
                case 3:
                    return '[minulou středu v] LT';
                case 4:
                case 5:
                    return '[minulý] dddd [v] LT';
                case 6:
                    return '[minulou sobotu v] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : 'před %s',
        s : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse : /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return cs;

})));


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var cv = moment.defineLocale('cv', {
    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
    },
    calendar : {
        sameDay: '[Паян] LT [сехетре]',
        nextDay: '[Ыран] LT [сехетре]',
        lastDay: '[Ӗнер] LT [сехетре]',
        nextWeek: '[Ҫитес] dddd LT [сехетре]',
        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
        sameElse: 'L'
    },
    relativeTime : {
        future : function (output) {
            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
            return output + affix;
        },
        past : '%s каялла',
        s : 'пӗр-ик ҫеккунт',
        m : 'пӗр минут',
        mm : '%d минут',
        h : 'пӗр сехет',
        hh : '%d сехет',
        d : 'пӗр кун',
        dd : '%d кун',
        M : 'пӗр уйӑх',
        MM : '%d уйӑх',
        y : 'пӗр ҫул',
        yy : '%d ҫул'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
    ordinal : '%d-мӗш',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return cv;

})));


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var cy = moment.defineLocale('cy', {
    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
    weekdaysParseExact : true,
    // time formats are the same as en-gb
    longDateFormat: {
        LT: 'HH:mm',
        LTS : 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[Heddiw am] LT',
        nextDay: '[Yfory am] LT',
        nextWeek: 'dddd [am] LT',
        lastDay: '[Ddoe am] LT',
        lastWeek: 'dddd [diwethaf am] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'mewn %s',
        past: '%s yn ôl',
        s: 'ychydig eiliadau',
        m: 'munud',
        mm: '%d munud',
        h: 'awr',
        hh: '%d awr',
        d: 'diwrnod',
        dd: '%d diwrnod',
        M: 'mis',
        MM: '%d mis',
        y: 'blwyddyn',
        yy: '%d flynedd'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
    ordinal: function (number) {
        var b = number,
            output = '',
            lookup = [
                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
            ];
        if (b > 20) {
            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                output = 'fed'; // not 30ain, 70ain or 90ain
            } else {
                output = 'ain';
            }
        } else if (b > 0) {
            output = lookup[b];
        }
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return cy;

})));


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var da = moment.defineLocale('da', {
    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay : '[i dag kl.] LT',
        nextDay : '[i morgen kl.] LT',
        nextWeek : 'på dddd [kl.] LT',
        lastDay : '[i går kl.] LT',
        lastWeek : '[i] dddd[s kl.] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s siden',
        s : 'få sekunder',
        m : 'et minut',
        mm : '%d minutter',
        h : 'en time',
        hh : '%d timer',
        d : 'en dag',
        dd : '%d dage',
        M : 'en måned',
        MM : '%d måneder',
        y : 'et år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return da;

})));


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var de = moment.defineLocale('de', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return de;

})));


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var deAt = moment.defineLocale('de-at', {
    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return deAt;

})));


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#

function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var deCh = moment.defineLocale('de-ch', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jan._Febr._März_April_Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH.mm',
        LTS: 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH.mm',
        LLLL : 'dddd, D. MMMM YYYY HH.mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return deCh;

})));


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'ޖެނުއަރީ',
    'ފެބްރުއަރީ',
    'މާރިޗު',
    'އޭޕްރީލު',
    'މޭ',
    'ޖޫން',
    'ޖުލައި',
    'އޯގަސްޓު',
    'ސެޕްޓެމްބަރު',
    'އޮކްޓޯބަރު',
    'ނޮވެމްބަރު',
    'ޑިސެމްބަރު'
];
var weekdays = [
    'އާދިއްތަ',
    'ހޯމަ',
    'އަންގާރަ',
    'ބުދަ',
    'ބުރާސްފަތި',
    'ހުކުރު',
    'ހޮނިހިރު'
];

var dv = moment.defineLocale('dv', {
    months : months,
    monthsShort : months,
    weekdays : weekdays,
    weekdaysShort : weekdays,
    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
    longDateFormat : {

        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/M/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /މކ|މފ/,
    isPM : function (input) {
        return 'މފ' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'މކ';
        } else {
            return 'މފ';
        }
    },
    calendar : {
        sameDay : '[މިއަދު] LT',
        nextDay : '[މާދަމާ] LT',
        nextWeek : 'dddd LT',
        lastDay : '[އިއްޔެ] LT',
        lastWeek : '[ފާއިތުވި] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ތެރޭގައި %s',
        past : 'ކުރިން %s',
        s : 'ސިކުންތުކޮޅެއް',
        m : 'މިނިޓެއް',
        mm : 'މިނިޓު %d',
        h : 'ގަޑިއިރެއް',
        hh : 'ގަޑިއިރު %d',
        d : 'ދުވަހެއް',
        dd : 'ދުވަސް %d',
        M : 'މަހެއް',
        MM : 'މަސް %d',
        y : 'އަހަރެއް',
        yy : 'އަހަރު %d'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 7,  // Sunday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return dv;

})));


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}


var el = moment.defineLocale('el', {
    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
    months : function (momentToFormat, format) {
        if (!momentToFormat) {
            return this._monthsNominativeEl;
        } else if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
            return this._monthsGenitiveEl[momentToFormat.month()];
        } else {
            return this._monthsNominativeEl[momentToFormat.month()];
        }
    },
    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'μμ' : 'ΜΜ';
        } else {
            return isLower ? 'πμ' : 'ΠΜ';
        }
    },
    isPM : function (input) {
        return ((input + '').toLowerCase()[0] === 'μ');
    },
    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendarEl : {
        sameDay : '[Σήμερα {}] LT',
        nextDay : '[Αύριο {}] LT',
        nextWeek : 'dddd [{}] LT',
        lastDay : '[Χθες {}] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 6:
                    return '[το προηγούμενο] dddd [{}] LT';
                default:
                    return '[την προηγούμενη] dddd [{}] LT';
            }
        },
        sameElse : 'L'
    },
    calendar : function (key, mom) {
        var output = this._calendarEl[key],
            hours = mom && mom.hours();
        if (isFunction(output)) {
            output = output.apply(mom);
        }
        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
    },
    relativeTime : {
        future : 'σε %s',
        past : '%s πριν',
        s : 'λίγα δευτερόλεπτα',
        m : 'ένα λεπτό',
        mm : '%d λεπτά',
        h : 'μία ώρα',
        hh : '%d ώρες',
        d : 'μία μέρα',
        dd : '%d μέρες',
        M : 'ένας μήνας',
        MM : '%d μήνες',
        y : 'ένας χρόνος',
        yy : '%d χρόνια'
    },
    dayOfMonthOrdinalParse: /\d{1,2}η/,
    ordinal: '%dη',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4st is the first week of the year.
    }
});

return el;

})));


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enAu = moment.defineLocale('en-au', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enAu;

})));


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enCa = moment.defineLocale('en-ca', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'YYYY-MM-DD',
        LL : 'MMMM D, YYYY',
        LLL : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

return enCa;

})));


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enGb = moment.defineLocale('en-gb', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enGb;

})));


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enIe = moment.defineLocale('en-ie', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enIe;

})));


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enNz = moment.defineLocale('en-nz', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enNz;

})));


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var eo = moment.defineLocale('eo', {
    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D[-a de] MMMM, YYYY',
        LLL : 'D[-a de] MMMM, YYYY HH:mm',
        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
    },
    meridiemParse: /[ap]\.t\.m/i,
    isPM: function (input) {
        return input.charAt(0).toLowerCase() === 'p';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'p.t.m.' : 'P.T.M.';
        } else {
            return isLower ? 'a.t.m.' : 'A.T.M.';
        }
    },
    calendar : {
        sameDay : '[Hodiaŭ je] LT',
        nextDay : '[Morgaŭ je] LT',
        nextWeek : 'dddd [je] LT',
        lastDay : '[Hieraŭ je] LT',
        lastWeek : '[pasinta] dddd [je] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'post %s',
        past : 'antaŭ %s',
        s : 'sekundoj',
        m : 'minuto',
        mm : '%d minutoj',
        h : 'horo',
        hh : '%d horoj',
        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
        dd : '%d tagoj',
        M : 'monato',
        MM : '%d monatoj',
        y : 'jaro',
        yy : '%d jaroj'
    },
    dayOfMonthOrdinalParse: /\d{1,2}a/,
    ordinal : '%da',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return eo;

})));


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var es = moment.defineLocale('es', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY H:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return es;

})));


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var esDo = moment.defineLocale('es-do', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY h:mm A',
        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return esDo;

})));


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
        'm' : ['ühe minuti', 'üks minut'],
        'mm': [number + ' minuti', number + ' minutit'],
        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
        'hh': [number + ' tunni', number + ' tundi'],
        'd' : ['ühe päeva', 'üks päev'],
        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
        'MM': [number + ' kuu', number + ' kuud'],
        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
        'yy': [number + ' aasta', number + ' aastat']
    };
    if (withoutSuffix) {
        return format[key][2] ? format[key][2] : format[key][1];
    }
    return isFuture ? format[key][0] : format[key][1];
}

var et = moment.defineLocale('et', {
    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
    longDateFormat : {
        LT   : 'H:mm',
        LTS : 'H:mm:ss',
        L    : 'DD.MM.YYYY',
        LL   : 'D. MMMM YYYY',
        LLL  : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[Täna,] LT',
        nextDay  : '[Homme,] LT',
        nextWeek : '[Järgmine] dddd LT',
        lastDay  : '[Eile,] LT',
        lastWeek : '[Eelmine] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s pärast',
        past   : '%s tagasi',
        s      : processRelativeTime,
        m      : processRelativeTime,
        mm     : processRelativeTime,
        h      : processRelativeTime,
        hh     : processRelativeTime,
        d      : processRelativeTime,
        dd     : '%d päeva',
        M      : processRelativeTime,
        MM     : processRelativeTime,
        y      : processRelativeTime,
        yy     : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return et;

})));


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var eu = moment.defineLocale('eu', {
    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
    monthsParseExact : true,
    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'YYYY[ko] MMMM[ren] D[a]',
        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
        l : 'YYYY-M-D',
        ll : 'YYYY[ko] MMM D[a]',
        lll : 'YYYY[ko] MMM D[a] HH:mm',
        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
    },
    calendar : {
        sameDay : '[gaur] LT[etan]',
        nextDay : '[bihar] LT[etan]',
        nextWeek : 'dddd LT[etan]',
        lastDay : '[atzo] LT[etan]',
        lastWeek : '[aurreko] dddd LT[etan]',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s barru',
        past : 'duela %s',
        s : 'segundo batzuk',
        m : 'minutu bat',
        mm : '%d minutu',
        h : 'ordu bat',
        hh : '%d ordu',
        d : 'egun bat',
        dd : '%d egun',
        M : 'hilabete bat',
        MM : '%d hilabete',
        y : 'urte bat',
        yy : '%d urte'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return eu;

})));


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '۱',
    '2': '۲',
    '3': '۳',
    '4': '۴',
    '5': '۵',
    '6': '۶',
    '7': '۷',
    '8': '۸',
    '9': '۹',
    '0': '۰'
};
var numberMap = {
    '۱': '1',
    '۲': '2',
    '۳': '3',
    '۴': '4',
    '۵': '5',
    '۶': '6',
    '۷': '7',
    '۸': '8',
    '۹': '9',
    '۰': '0'
};

var fa = moment.defineLocale('fa', {
    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    meridiemParse: /قبل از ظهر|بعد از ظهر/,
    isPM: function (input) {
        return /بعد از ظهر/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'قبل از ظهر';
        } else {
            return 'بعد از ظهر';
        }
    },
    calendar : {
        sameDay : '[امروز ساعت] LT',
        nextDay : '[فردا ساعت] LT',
        nextWeek : 'dddd [ساعت] LT',
        lastDay : '[دیروز ساعت] LT',
        lastWeek : 'dddd [پیش] [ساعت] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'در %s',
        past : '%s پیش',
        s : 'چند ثانیه',
        m : 'یک دقیقه',
        mm : '%d دقیقه',
        h : 'یک ساعت',
        hh : '%d ساعت',
        d : 'یک روز',
        dd : '%d روز',
        M : 'یک ماه',
        MM : '%d ماه',
        y : 'یک سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/[۰-۹]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    dayOfMonthOrdinalParse: /\d{1,2}م/,
    ordinal : '%dم',
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12 // The week that contains Jan 1st is the first week of the year.
    }
});

return fa;

})));


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
var numbersFuture = [
        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
        numbersPast[7], numbersPast[8], numbersPast[9]
    ];
function translate(number, withoutSuffix, key, isFuture) {
    var result = '';
    switch (key) {
        case 's':
            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
        case 'm':
            return isFuture ? 'minuutin' : 'minuutti';
        case 'mm':
            result = isFuture ? 'minuutin' : 'minuuttia';
            break;
        case 'h':
            return isFuture ? 'tunnin' : 'tunti';
        case 'hh':
            result = isFuture ? 'tunnin' : 'tuntia';
            break;
        case 'd':
            return isFuture ? 'päivän' : 'päivä';
        case 'dd':
            result = isFuture ? 'päivän' : 'päivää';
            break;
        case 'M':
            return isFuture ? 'kuukauden' : 'kuukausi';
        case 'MM':
            result = isFuture ? 'kuukauden' : 'kuukautta';
            break;
        case 'y':
            return isFuture ? 'vuoden' : 'vuosi';
        case 'yy':
            result = isFuture ? 'vuoden' : 'vuotta';
            break;
    }
    result = verbalNumber(number, isFuture) + ' ' + result;
    return result;
}
function verbalNumber(number, isFuture) {
    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
}

var fi = moment.defineLocale('fi', {
    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'Do MMMM[ta] YYYY',
        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
        l : 'D.M.YYYY',
        ll : 'Do MMM YYYY',
        lll : 'Do MMM YYYY, [klo] HH.mm',
        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
    },
    calendar : {
        sameDay : '[tänään] [klo] LT',
        nextDay : '[huomenna] [klo] LT',
        nextWeek : 'dddd [klo] LT',
        lastDay : '[eilen] [klo] LT',
        lastWeek : '[viime] dddd[na] [klo] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s päästä',
        past : '%s sitten',
        s : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fi;

})));


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var fo = moment.defineLocale('fo', {
    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D. MMMM, YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Í dag kl.] LT',
        nextDay : '[Í morgin kl.] LT',
        nextWeek : 'dddd [kl.] LT',
        lastDay : '[Í gjár kl.] LT',
        lastWeek : '[síðstu] dddd [kl] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'um %s',
        past : '%s síðani',
        s : 'fá sekund',
        m : 'ein minutt',
        mm : '%d minuttir',
        h : 'ein tími',
        hh : '%d tímar',
        d : 'ein dagur',
        dd : '%d dagar',
        M : 'ein mánaði',
        MM : '%d mánaðir',
        y : 'eitt ár',
        yy : '%d ár'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fo;

})));


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var fr = moment.defineLocale('fr', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
    ordinal : function (number, period) {
        switch (period) {
            // TODO: Return 'e' when day of month > 1. Move this case inside
            // block for masculine words below.
            // See https://github.com/moment/moment/issues/3375
            case 'D':
                return number + (number === 1 ? 'er' : '');

            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fr;

})));


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var frCa = moment.defineLocale('fr-ca', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal : function (number, period) {
        switch (period) {
            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'D':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    }
});

return frCa;

})));


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var frCh = moment.defineLocale('fr-ch', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal : function (number, period) {
        switch (period) {
            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'D':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return frCh;

})));


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

var fy = moment.defineLocale('fy', {
    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[hjoed om] LT',
        nextDay: '[moarn om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[juster om] LT',
        lastWeek: '[ôfrûne] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'oer %s',
        past : '%s lyn',
        s : 'in pear sekonden',
        m : 'ien minút',
        mm : '%d minuten',
        h : 'ien oere',
        hh : '%d oeren',
        d : 'ien dei',
        dd : '%d dagen',
        M : 'ien moanne',
        MM : '%d moannen',
        y : 'ien jier',
        yy : '%d jierren'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fy;

})));


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
];

var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];

var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];

var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];

var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

var gd = moment.defineLocale('gd', {
    months : months,
    monthsShort : monthsShort,
    monthsParseExact : true,
    weekdays : weekdays,
    weekdaysShort : weekdaysShort,
    weekdaysMin : weekdaysMin,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[An-diugh aig] LT',
        nextDay : '[A-màireach aig] LT',
        nextWeek : 'dddd [aig] LT',
        lastDay : '[An-dè aig] LT',
        lastWeek : 'dddd [seo chaidh] [aig] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ann an %s',
        past : 'bho chionn %s',
        s : 'beagan diogan',
        m : 'mionaid',
        mm : '%d mionaidean',
        h : 'uair',
        hh : '%d uairean',
        d : 'latha',
        dd : '%d latha',
        M : 'mìos',
        MM : '%d mìosan',
        y : 'bliadhna',
        yy : '%d bliadhna'
    },
    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
    ordinal : function (number) {
        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return gd;

})));


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var gl = moment.defineLocale('gl', {
    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY H:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
        },
        nextDay : function () {
            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
        },
        lastDay : function () {
            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
        },
        lastWeek : function () {
            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : function (str) {
            if (str.indexOf('un') === 0) {
                return 'n' + str;
            }
            return 'en ' + str;
        },
        past : 'hai %s',
        s : 'uns segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'unha hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return gl;

})));


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's': ['thodde secondanim', 'thodde second'],
        'm': ['eka mintan', 'ek minute'],
        'mm': [number + ' mintanim', number + ' mintam'],
        'h': ['eka horan', 'ek hor'],
        'hh': [number + ' horanim', number + ' hor'],
        'd': ['eka disan', 'ek dis'],
        'dd': [number + ' disanim', number + ' dis'],
        'M': ['eka mhoinean', 'ek mhoino'],
        'MM': [number + ' mhoineanim', number + ' mhoine'],
        'y': ['eka vorsan', 'ek voros'],
        'yy': [number + ' vorsanim', number + ' vorsam']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var gomLatn = moment.defineLocale('gom-latn', {
    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'A h:mm [vazta]',
        LTS : 'A h:mm:ss [vazta]',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY A h:mm [vazta]',
        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
    },
    calendar : {
        sameDay: '[Aiz] LT',
        nextDay: '[Faleam] LT',
        nextWeek: '[Ieta to] dddd[,] LT',
        lastDay: '[Kal] LT',
        lastWeek: '[Fatlo] dddd[,] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s',
        past : '%s adim',
        s : processRelativeTime,
        m : processRelativeTime,
        mm : processRelativeTime,
        h : processRelativeTime,
        hh : processRelativeTime,
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
    ordinal : function (number, period) {
        switch (period) {
            // the ordinal 'er' only applies to day of the month
            case 'D':
                return number + 'er';
            default:
            case 'M':
            case 'Q':
            case 'DDD':
            case 'd':
            case 'w':
            case 'W':
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    },
    meridiemParse: /rati|sokalli|donparam|sanje/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'rati') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'sokalli') {
            return hour;
        } else if (meridiem === 'donparam') {
            return hour > 12 ? hour : hour + 12;
        } else if (meridiem === 'sanje') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'rati';
        } else if (hour < 12) {
            return 'sokalli';
        } else if (hour < 16) {
            return 'donparam';
        } else if (hour < 20) {
            return 'sanje';
        } else {
            return 'rati';
        }
    }
});

return gomLatn;

})));


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var he = moment.defineLocale('he', {
    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [ב]MMMM YYYY',
        LLL : 'D [ב]MMMM YYYY HH:mm',
        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
        l : 'D/M/YYYY',
        ll : 'D MMM YYYY',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd, D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[היום ב־]LT',
        nextDay : '[מחר ב־]LT',
        nextWeek : 'dddd [בשעה] LT',
        lastDay : '[אתמול ב־]LT',
        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'בעוד %s',
        past : 'לפני %s',
        s : 'מספר שניות',
        m : 'דקה',
        mm : '%d דקות',
        h : 'שעה',
        hh : function (number) {
            if (number === 2) {
                return 'שעתיים';
            }
            return number + ' שעות';
        },
        d : 'יום',
        dd : function (number) {
            if (number === 2) {
                return 'יומיים';
            }
            return number + ' ימים';
        },
        M : 'חודש',
        MM : function (number) {
            if (number === 2) {
                return 'חודשיים';
            }
            return number + ' חודשים';
        },
        y : 'שנה',
        yy : function (number) {
            if (number === 2) {
                return 'שנתיים';
            } else if (number % 10 === 0 && number !== 10) {
                return number + ' שנה';
            }
            return number + ' שנים';
        }
    },
    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
    isPM : function (input) {
        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 5) {
            return 'לפנות בוקר';
        } else if (hour < 10) {
            return 'בבוקר';
        } else if (hour < 12) {
            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
        } else if (hour < 18) {
            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
        } else {
            return 'בערב';
        }
    }
});

return he;

})));


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

var hi = moment.defineLocale('hi', {
    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
    monthsParseExact: true,
    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
    longDateFormat : {
        LT : 'A h:mm बजे',
        LTS : 'A h:mm:ss बजे',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm बजे',
        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[कल] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[कल] LT',
        lastWeek : '[पिछले] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s में',
        past : '%s पहले',
        s : 'कुछ ही क्षण',
        m : 'एक मिनट',
        mm : '%d मिनट',
        h : 'एक घंटा',
        hh : '%d घंटे',
        d : 'एक दिन',
        dd : '%d दिन',
        M : 'एक महीने',
        MM : '%d महीने',
        y : 'एक वर्ष',
        yy : '%d वर्ष'
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
    meridiemParse: /रात|सुबह|दोपहर|शाम/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'रात') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'सुबह') {
            return hour;
        } else if (meridiem === 'दोपहर') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'शाम') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'रात';
        } else if (hour < 10) {
            return 'सुबह';
        } else if (hour < 17) {
            return 'दोपहर';
        } else if (hour < 20) {
            return 'शाम';
        } else {
            return 'रात';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return hi;

})));


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'm':
            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minuta';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'jedan sat' : 'jednog sata';
        case 'hh':
            if (number === 1) {
                result += 'sat';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
            } else {
                result += 'sati';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dana';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mjesec';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
            } else {
                result += 'mjeseci';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'godina';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
            } else {
                result += 'godina';
            }
            return result;
    }
}

var hr = moment.defineLocale('hr', {
    months : {
        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
    },
    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danas u] LT',
        nextDay  : '[sutra u] LT',
        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[jučer u] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                    return '[prošlu] dddd [u] LT';
                case 6:
                    return '[prošle] [subote] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prošli] dddd [u] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'par sekundi',
        m      : translate,
        mm     : translate,
        h      : translate,
        hh     : translate,
        d      : 'dan',
        dd     : translate,
        M      : 'mjesec',
        MM     : translate,
        y      : 'godinu',
        yy     : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return hr;

})));


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
function translate(number, withoutSuffix, key, isFuture) {
    var num = number,
        suffix;
    switch (key) {
        case 's':
            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
        case 'm':
            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
        case 'mm':
            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
        case 'h':
            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
        case 'hh':
            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
        case 'd':
            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
        case 'dd':
            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
        case 'M':
            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
        case 'MM':
            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
        case 'y':
            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
        case 'yy':
            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
    }
    return '';
}
function week(isFuture) {
    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
}

var hu = moment.defineLocale('hu', {
    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'YYYY.MM.DD.',
        LL : 'YYYY. MMMM D.',
        LLL : 'YYYY. MMMM D. H:mm',
        LLLL : 'YYYY. MMMM D., dddd H:mm'
    },
    meridiemParse: /de|du/i,
    isPM: function (input) {
        return input.charAt(1).toLowerCase() === 'u';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower === true ? 'de' : 'DE';
        } else {
            return isLower === true ? 'du' : 'DU';
        }
    },
    calendar : {
        sameDay : '[ma] LT[-kor]',
        nextDay : '[holnap] LT[-kor]',
        nextWeek : function () {
            return week.call(this, true);
        },
        lastDay : '[tegnap] LT[-kor]',
        lastWeek : function () {
            return week.call(this, false);
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s múlva',
        past : '%s',
        s : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return hu;

})));


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var hyAm = moment.defineLocale('hy-am', {
    months : {
        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
    },
    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY թ.',
        LLL : 'D MMMM YYYY թ., HH:mm',
        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
    },
    calendar : {
        sameDay: '[այսօր] LT',
        nextDay: '[վաղը] LT',
        lastDay: '[երեկ] LT',
        nextWeek: function () {
            return 'dddd [օրը ժամը] LT';
        },
        lastWeek: function () {
            return '[անցած] dddd [օրը ժամը] LT';
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s հետո',
        past : '%s առաջ',
        s : 'մի քանի վայրկյան',
        m : 'րոպե',
        mm : '%d րոպե',
        h : 'ժամ',
        hh : '%d ժամ',
        d : 'օր',
        dd : '%d օր',
        M : 'ամիս',
        MM : '%d ամիս',
        y : 'տարի',
        yy : '%d տարի'
    },
    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
    isPM: function (input) {
        return /^(ցերեկվա|երեկոյան)$/.test(input);
    },
    meridiem : function (hour) {
        if (hour < 4) {
            return 'գիշերվա';
        } else if (hour < 12) {
            return 'առավոտվա';
        } else if (hour < 17) {
            return 'ցերեկվա';
        } else {
            return 'երեկոյան';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'DDD':
            case 'w':
            case 'W':
            case 'DDDo':
                if (number === 1) {
                    return number + '-ին';
                }
                return number + '-րդ';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return hyAm;

})));


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var id = moment.defineLocale('id', {
    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|siang|sore|malam/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'siang') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'sore' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'siang';
        } else if (hours < 19) {
            return 'sore';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Besok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kemarin pukul] LT',
        lastWeek : 'dddd [lalu pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lalu',
        s : 'beberapa detik',
        m : 'semenit',
        mm : '%d menit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return id;

})));


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(n) {
    if (n % 100 === 11) {
        return true;
    } else if (n % 10 === 1) {
        return false;
    }
    return true;
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':
            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
        case 'm':
            return withoutSuffix ? 'mínúta' : 'mínútu';
        case 'mm':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
            } else if (withoutSuffix) {
                return result + 'mínúta';
            }
            return result + 'mínútu';
        case 'hh':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
            }
            return result + 'klukkustund';
        case 'd':
            if (withoutSuffix) {
                return 'dagur';
            }
            return isFuture ? 'dag' : 'degi';
        case 'dd':
            if (plural(number)) {
                if (withoutSuffix) {
                    return result + 'dagar';
                }
                return result + (isFuture ? 'daga' : 'dögum');
            } else if (withoutSuffix) {
                return result + 'dagur';
            }
            return result + (isFuture ? 'dag' : 'degi');
        case 'M':
            if (withoutSuffix) {
                return 'mánuður';
            }
            return isFuture ? 'mánuð' : 'mánuði';
        case 'MM':
            if (plural(number)) {
                if (withoutSuffix) {
                    return result + 'mánuðir';
                }
                return result + (isFuture ? 'mánuði' : 'mánuðum');
            } else if (withoutSuffix) {
                return result + 'mánuður';
            }
            return result + (isFuture ? 'mánuð' : 'mánuði');
        case 'y':
            return withoutSuffix || isFuture ? 'ár' : 'ári';
        case 'yy':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
            }
            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
    }
}

var is = moment.defineLocale('is', {
    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] H:mm',
        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
    },
    calendar : {
        sameDay : '[í dag kl.] LT',
        nextDay : '[á morgun kl.] LT',
        nextWeek : 'dddd [kl.] LT',
        lastDay : '[í gær kl.] LT',
        lastWeek : '[síðasta] dddd [kl.] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'eftir %s',
        past : 'fyrir %s síðan',
        s : translate,
        m : translate,
        mm : translate,
        h : 'klukkustund',
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return is;

})));


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var it = moment.defineLocale('it', {
    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Oggi alle] LT',
        nextDay: '[Domani alle] LT',
        nextWeek: 'dddd [alle] LT',
        lastDay: '[Ieri alle] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[la scorsa] dddd [alle] LT';
                default:
                    return '[lo scorso] dddd [alle] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : function (s) {
            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
        },
        past : '%s fa',
        s : 'alcuni secondi',
        m : 'un minuto',
        mm : '%d minuti',
        h : 'un\'ora',
        hh : '%d ore',
        d : 'un giorno',
        dd : '%d giorni',
        M : 'un mese',
        MM : '%d mesi',
        y : 'un anno',
        yy : '%d anni'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return it;

})));


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ja = moment.defineLocale('ja', {
    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日 HH:mm',
        LLLL : 'YYYY年M月D日 HH:mm dddd',
        l : 'YYYY/MM/DD',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日 HH:mm dddd'
    },
    meridiemParse: /午前|午後/i,
    isPM : function (input) {
        return input === '午後';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return '午前';
        } else {
            return '午後';
        }
    },
    calendar : {
        sameDay : '[今日] LT',
        nextDay : '[明日] LT',
        nextWeek : '[来週]dddd LT',
        lastDay : '[昨日] LT',
        lastWeek : '[前週]dddd LT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse : /\d{1,2}日/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            default:
                return number;
        }
    },
    relativeTime : {
        future : '%s後',
        past : '%s前',
        s : '数秒',
        m : '1分',
        mm : '%d分',
        h : '1時間',
        hh : '%d時間',
        d : '1日',
        dd : '%d日',
        M : '1ヶ月',
        MM : '%dヶ月',
        y : '1年',
        yy : '%d年'
    }
});

return ja;

})));


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var jv = moment.defineLocale('jv', {
    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /enjing|siyang|sonten|ndalu/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'enjing') {
            return hour;
        } else if (meridiem === 'siyang') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'enjing';
        } else if (hours < 15) {
            return 'siyang';
        } else if (hours < 19) {
            return 'sonten';
        } else {
            return 'ndalu';
        }
    },
    calendar : {
        sameDay : '[Dinten puniko pukul] LT',
        nextDay : '[Mbenjang pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kala wingi pukul] LT',
        lastWeek : 'dddd [kepengker pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'wonten ing %s',
        past : '%s ingkang kepengker',
        s : 'sawetawis detik',
        m : 'setunggal menit',
        mm : '%d menit',
        h : 'setunggal jam',
        hh : '%d jam',
        d : 'sedinten',
        dd : '%d dinten',
        M : 'sewulan',
        MM : '%d wulan',
        y : 'setaun',
        yy : '%d taun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return jv;

})));


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ka = moment.defineLocale('ka', {
    months : {
        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
    },
    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
    weekdays : {
        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
        isFormat: /(წინა|შემდეგ)/
    },
    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[დღეს] LT[-ზე]',
        nextDay : '[ხვალ] LT[-ზე]',
        lastDay : '[გუშინ] LT[-ზე]',
        nextWeek : '[შემდეგ] dddd LT[-ზე]',
        lastWeek : '[წინა] dddd LT-ზე',
        sameElse : 'L'
    },
    relativeTime : {
        future : function (s) {
            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
                s.replace(/ი$/, 'ში') :
                s + 'ში';
        },
        past : function (s) {
            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
                return s.replace(/(ი|ე)$/, 'ის უკან');
            }
            if ((/წელი/).test(s)) {
                return s.replace(/წელი$/, 'წლის უკან');
            }
        },
        s : 'რამდენიმე წამი',
        m : 'წუთი',
        mm : '%d წუთი',
        h : 'საათი',
        hh : '%d საათი',
        d : 'დღე',
        dd : '%d დღე',
        M : 'თვე',
        MM : '%d თვე',
        y : 'წელი',
        yy : '%d წელი'
    },
    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
    ordinal : function (number) {
        if (number === 0) {
            return number;
        }
        if (number === 1) {
            return number + '-ლი';
        }
        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
            return 'მე-' + number;
        }
        return number + '-ე';
    },
    week : {
        dow : 1,
        doy : 7
    }
});

return ka;

})));


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    0: '-ші',
    1: '-ші',
    2: '-ші',
    3: '-ші',
    4: '-ші',
    5: '-ші',
    6: '-шы',
    7: '-ші',
    8: '-ші',
    9: '-шы',
    10: '-шы',
    20: '-шы',
    30: '-шы',
    40: '-шы',
    50: '-ші',
    60: '-шы',
    70: '-ші',
    80: '-ші',
    90: '-шы',
    100: '-ші'
};

var kk = moment.defineLocale('kk', {
    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Бүгін сағат] LT',
        nextDay : '[Ертең сағат] LT',
        nextWeek : 'dddd [сағат] LT',
        lastDay : '[Кеше сағат] LT',
        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ішінде',
        past : '%s бұрын',
        s : 'бірнеше секунд',
        m : 'бір минут',
        mm : '%d минут',
        h : 'бір сағат',
        hh : '%d сағат',
        d : 'бір күн',
        dd : '%d күн',
        M : 'бір ай',
        MM : '%d ай',
        y : 'бір жыл',
        yy : '%d жыл'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
    ordinal : function (number) {
        var a = number % 10,
            b = number >= 100 ? 100 : null;
        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return kk;

})));


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var km = moment.defineLocale('km', {
    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS : 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
        nextDay: '[ស្អែក ម៉ោង] LT',
        nextWeek: 'dddd [ម៉ោង] LT',
        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: '%sទៀត',
        past: '%sមុន',
        s: 'ប៉ុន្មានវិនាទី',
        m: 'មួយនាទី',
        mm: '%d នាទី',
        h: 'មួយម៉ោង',
        hh: '%d ម៉ោង',
        d: 'មួយថ្ងៃ',
        dd: '%d ថ្ងៃ',
        M: 'មួយខែ',
        MM: '%d ខែ',
        y: 'មួយឆ្នាំ',
        yy: '%d ឆ្នាំ'
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return km;

})));


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '೧',
    '2': '೨',
    '3': '೩',
    '4': '೪',
    '5': '೫',
    '6': '೬',
    '7': '೭',
    '8': '೮',
    '9': '೯',
    '0': '೦'
};
var numberMap = {
    '೧': '1',
    '೨': '2',
    '೩': '3',
    '೪': '4',
    '೫': '5',
    '೬': '6',
    '೭': '7',
    '೮': '8',
    '೯': '9',
    '೦': '0'
};

var kn = moment.defineLocale('kn', {
    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
    monthsParseExact: true,
    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[ಇಂದು] LT',
        nextDay : '[ನಾಳೆ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ನಿನ್ನೆ] LT',
        lastWeek : '[ಕೊನೆಯ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ನಂತರ',
        past : '%s ಹಿಂದೆ',
        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
        m : 'ಒಂದು ನಿಮಿಷ',
        mm : '%d ನಿಮಿಷ',
        h : 'ಒಂದು ಗಂಟೆ',
        hh : '%d ಗಂಟೆ',
        d : 'ಒಂದು ದಿನ',
        dd : '%d ದಿನ',
        M : 'ಒಂದು ತಿಂಗಳು',
        MM : '%d ತಿಂಗಳು',
        y : 'ಒಂದು ವರ್ಷ',
        yy : '%d ವರ್ಷ'
    },
    preparse: function (string) {
        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ರಾತ್ರಿ') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
            return hour;
        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'ಸಂಜೆ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ರಾತ್ರಿ';
        } else if (hour < 10) {
            return 'ಬೆಳಿಗ್ಗೆ';
        } else if (hour < 17) {
            return 'ಮಧ್ಯಾಹ್ನ';
        } else if (hour < 20) {
            return 'ಸಂಜೆ';
        } else {
            return 'ರಾತ್ರಿ';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
    ordinal : function (number) {
        return number + 'ನೇ';
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return kn;

})));


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ko = moment.defineLocale('ko', {
    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'YYYY.MM.DD',
        LL : 'YYYY년 MMMM D일',
        LLL : 'YYYY년 MMMM D일 A h:mm',
        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
        l : 'YYYY.MM.DD',
        ll : 'YYYY년 MMMM D일',
        lll : 'YYYY년 MMMM D일 A h:mm',
        llll : 'YYYY년 MMMM D일 dddd A h:mm'
    },
    calendar : {
        sameDay : '오늘 LT',
        nextDay : '내일 LT',
        nextWeek : 'dddd LT',
        lastDay : '어제 LT',
        lastWeek : '지난주 dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s 후',
        past : '%s 전',
        s : '몇 초',
        ss : '%d초',
        m : '1분',
        mm : '%d분',
        h : '한 시간',
        hh : '%d시간',
        d : '하루',
        dd : '%d일',
        M : '한 달',
        MM : '%d달',
        y : '일 년',
        yy : '%d년'
    },
    dayOfMonthOrdinalParse : /\d{1,2}일/,
    ordinal : '%d일',
    meridiemParse : /오전|오후/,
    isPM : function (token) {
        return token === '오후';
    },
    meridiem : function (hour, minute, isUpper) {
        return hour < 12 ? '오전' : '오후';
    }
});

return ko;

})));


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var suffixes = {
    0: '-чү',
    1: '-чи',
    2: '-чи',
    3: '-чү',
    4: '-чү',
    5: '-чи',
    6: '-чы',
    7: '-чи',
    8: '-чи',
    9: '-чу',
    10: '-чу',
    20: '-чы',
    30: '-чу',
    40: '-чы',
    50: '-чү',
    60: '-чы',
    70: '-чи',
    80: '-чи',
    90: '-чу',
    100: '-чү'
};

var ky = moment.defineLocale('ky', {
    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Бүгүн саат] LT',
        nextDay : '[Эртең саат] LT',
        nextWeek : 'dddd [саат] LT',
        lastDay : '[Кече саат] LT',
        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ичинде',
        past : '%s мурун',
        s : 'бирнече секунд',
        m : 'бир мүнөт',
        mm : '%d мүнөт',
        h : 'бир саат',
        hh : '%d саат',
        d : 'бир күн',
        dd : '%d күн',
        M : 'бир ай',
        MM : '%d ай',
        y : 'бир жыл',
        yy : '%d жыл'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
    ordinal : function (number) {
        var a = number % 10,
            b = number >= 100 ? 100 : null;
        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ky;

})));


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eng Minutt', 'enger Minutt'],
        'h': ['eng Stonn', 'enger Stonn'],
        'd': ['een Dag', 'engem Dag'],
        'M': ['ee Mount', 'engem Mount'],
        'y': ['ee Joer', 'engem Joer']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}
function processFutureTime(string) {
    var number = string.substr(0, string.indexOf(' '));
    if (eifelerRegelAppliesToNumber(number)) {
        return 'a ' + string;
    }
    return 'an ' + string;
}
function processPastTime(string) {
    var number = string.substr(0, string.indexOf(' '));
    if (eifelerRegelAppliesToNumber(number)) {
        return 'viru ' + string;
    }
    return 'virun ' + string;
}
/**
 * Returns true if the word before the given number loses the '-n' ending.
 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
 *
 * @param number {integer}
 * @returns {boolean}
 */
function eifelerRegelAppliesToNumber(number) {
    number = parseInt(number, 10);
    if (isNaN(number)) {
        return false;
    }
    if (number < 0) {
        // Negative Number --> always true
        return true;
    } else if (number < 10) {
        // Only 1 digit
        if (4 <= number && number <= 7) {
            return true;
        }
        return false;
    } else if (number < 100) {
        // 2 digits
        var lastDigit = number % 10, firstDigit = number / 10;
        if (lastDigit === 0) {
            return eifelerRegelAppliesToNumber(firstDigit);
        }
        return eifelerRegelAppliesToNumber(lastDigit);
    } else if (number < 10000) {
        // 3 or 4 digits --> recursively check first digit
        while (number >= 10) {
            number = number / 10;
        }
        return eifelerRegelAppliesToNumber(number);
    } else {
        // Anything larger than 4 digits: recursively check first n-3 digits
        number = number / 1000;
        return eifelerRegelAppliesToNumber(number);
    }
}

var lb = moment.defineLocale('lb', {
    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm [Auer]',
        LTS: 'H:mm:ss [Auer]',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm [Auer]',
        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
    },
    calendar: {
        sameDay: '[Haut um] LT',
        sameElse: 'L',
        nextDay: '[Muer um] LT',
        nextWeek: 'dddd [um] LT',
        lastDay: '[Gëschter um] LT',
        lastWeek: function () {
            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
            switch (this.day()) {
                case 2:
                case 4:
                    return '[Leschten] dddd [um] LT';
                default:
                    return '[Leschte] dddd [um] LT';
            }
        }
    },
    relativeTime : {
        future : processFutureTime,
        past : processPastTime,
        s : 'e puer Sekonnen',
        m : processRelativeTime,
        mm : '%d Minutten',
        h : processRelativeTime,
        hh : '%d Stonnen',
        d : processRelativeTime,
        dd : '%d Deeg',
        M : processRelativeTime,
        MM : '%d Méint',
        y : processRelativeTime,
        yy : '%d Joer'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: '%d.',
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lb;

})));


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var lo = moment.defineLocale('lo', {
    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
    isPM: function (input) {
        return input === 'ຕອນແລງ';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ຕອນເຊົ້າ';
        } else {
            return 'ຕອນແລງ';
        }
    },
    calendar : {
        sameDay : '[ມື້ນີ້ເວລາ] LT',
        nextDay : '[ມື້ອື່ນເວລາ] LT',
        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ອີກ %s',
        past : '%sຜ່ານມາ',
        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
        m : '1 ນາທີ',
        mm : '%d ນາທີ',
        h : '1 ຊົ່ວໂມງ',
        hh : '%d ຊົ່ວໂມງ',
        d : '1 ມື້',
        dd : '%d ມື້',
        M : '1 ເດືອນ',
        MM : '%d ເດືອນ',
        y : '1 ປີ',
        yy : '%d ປີ'
    },
    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
    ordinal : function (number) {
        return 'ທີ່' + number;
    }
});

return lo;

})));


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var units = {
    'm' : 'minutė_minutės_minutę',
    'mm': 'minutės_minučių_minutes',
    'h' : 'valanda_valandos_valandą',
    'hh': 'valandos_valandų_valandas',
    'd' : 'diena_dienos_dieną',
    'dd': 'dienos_dienų_dienas',
    'M' : 'mėnuo_mėnesio_mėnesį',
    'MM': 'mėnesiai_mėnesių_mėnesius',
    'y' : 'metai_metų_metus',
    'yy': 'metai_metų_metus'
};
function translateSeconds(number, withoutSuffix, key, isFuture) {
    if (withoutSuffix) {
        return 'kelios sekundės';
    } else {
        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
    }
}
function translateSingular(number, withoutSuffix, key, isFuture) {
    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
}
function special(number) {
    return number % 10 === 0 || (number > 10 && number < 20);
}
function forms(key) {
    return units[key].split('_');
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    if (number === 1) {
        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
    } else if (withoutSuffix) {
        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
    } else {
        if (isFuture) {
            return result + forms(key)[1];
        } else {
            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
        }
    }
}
var lt = moment.defineLocale('lt', {
    months : {
        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
    },
    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
    weekdays : {
        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
        isFormat: /dddd HH:mm/
    },
    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'YYYY [m.] MMMM D [d.]',
        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
        l : 'YYYY-MM-DD',
        ll : 'YYYY [m.] MMMM D [d.]',
        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
    },
    calendar : {
        sameDay : '[Šiandien] LT',
        nextDay : '[Rytoj] LT',
        nextWeek : 'dddd LT',
        lastDay : '[Vakar] LT',
        lastWeek : '[Praėjusį] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'po %s',
        past : 'prieš %s',
        s : translateSeconds,
        m : translateSingular,
        mm : translate,
        h : translateSingular,
        hh : translate,
        d : translateSingular,
        dd : translate,
        M : translateSingular,
        MM : translate,
        y : translateSingular,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
    ordinal : function (number) {
        return number + '-oji';
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lt;

})));


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var units = {
    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
    'h': 'stundas_stundām_stunda_stundas'.split('_'),
    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
    'd': 'dienas_dienām_diena_dienas'.split('_'),
    'dd': 'dienas_dienām_diena_dienas'.split('_'),
    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
    'y': 'gada_gadiem_gads_gadi'.split('_'),
    'yy': 'gada_gadiem_gads_gadi'.split('_')
};
/**
 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
 */
function format(forms, number, withoutSuffix) {
    if (withoutSuffix) {
        // E.g. "21 minūte", "3 minūtes".
        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
    } else {
        // E.g. "21 minūtes" as in "pēc 21 minūtes".
        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
    }
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    return number + ' ' + format(units[key], number, withoutSuffix);
}
function relativeTimeWithSingular(number, withoutSuffix, key) {
    return format(units[key], number, withoutSuffix);
}
function relativeSeconds(number, withoutSuffix) {
    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
}

var lv = moment.defineLocale('lv', {
    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY.',
        LL : 'YYYY. [gada] D. MMMM',
        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
    },
    calendar : {
        sameDay : '[Šodien pulksten] LT',
        nextDay : '[Rīt pulksten] LT',
        nextWeek : 'dddd [pulksten] LT',
        lastDay : '[Vakar pulksten] LT',
        lastWeek : '[Pagājušā] dddd [pulksten] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'pēc %s',
        past : 'pirms %s',
        s : relativeSeconds,
        m : relativeTimeWithSingular,
        mm : relativeTimeWithPlural,
        h : relativeTimeWithSingular,
        hh : relativeTimeWithPlural,
        d : relativeTimeWithSingular,
        dd : relativeTimeWithPlural,
        M : relativeTimeWithSingular,
        MM : relativeTimeWithPlural,
        y : relativeTimeWithSingular,
        yy : relativeTimeWithPlural
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lv;

})));


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        m: ['jedan minut', 'jednog minuta'],
        mm: ['minut', 'minuta', 'minuta'],
        h: ['jedan sat', 'jednog sata'],
        hh: ['sat', 'sata', 'sati'],
        dd: ['dan', 'dana', 'dana'],
        MM: ['mjesec', 'mjeseca', 'mjeseci'],
        yy: ['godina', 'godine', 'godina']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var me = moment.defineLocale('me', {
    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact : true,
    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sjutra u] LT',

        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[juče u] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[prošle] [nedjelje] [u] LT',
                '[prošlog] [ponedjeljka] [u] LT',
                '[prošlog] [utorka] [u] LT',
                '[prošle] [srijede] [u] LT',
                '[prošlog] [četvrtka] [u] LT',
                '[prošlog] [petka] [u] LT',
                '[prošle] [subote] [u] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'nekoliko sekundi',
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'dan',
        dd     : translator.translate,
        M      : 'mjesec',
        MM     : translator.translate,
        y      : 'godinu',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return me;

})));


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mi = moment.defineLocale('mi', {
    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY [i] HH:mm',
        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
    },
    calendar: {
        sameDay: '[i teie mahana, i] LT',
        nextDay: '[apopo i] LT',
        nextWeek: 'dddd [i] LT',
        lastDay: '[inanahi i] LT',
        lastWeek: 'dddd [whakamutunga i] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'i roto i %s',
        past: '%s i mua',
        s: 'te hēkona ruarua',
        m: 'he meneti',
        mm: '%d meneti',
        h: 'te haora',
        hh: '%d haora',
        d: 'he ra',
        dd: '%d ra',
        M: 'he marama',
        MM: '%d marama',
        y: 'he tau',
        yy: '%d tau'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return mi;

})));


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mk = moment.defineLocale('mk', {
    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'D.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay : '[Денес во] LT',
        nextDay : '[Утре во] LT',
        nextWeek : '[Во] dddd [во] LT',
        lastDay : '[Вчера во] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 6:
                    return '[Изминатата] dddd [во] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[Изминатиот] dddd [во] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'после %s',
        past : 'пред %s',
        s : 'неколку секунди',
        m : 'минута',
        mm : '%d минути',
        h : 'час',
        hh : '%d часа',
        d : 'ден',
        dd : '%d дена',
        M : 'месец',
        MM : '%d месеци',
        y : 'година',
        yy : '%d години'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
    ordinal : function (number) {
        var lastDigit = number % 10,
            last2Digits = number % 100;
        if (number === 0) {
            return number + '-ев';
        } else if (last2Digits === 0) {
            return number + '-ен';
        } else if (last2Digits > 10 && last2Digits < 20) {
            return number + '-ти';
        } else if (lastDigit === 1) {
            return number + '-ви';
        } else if (lastDigit === 2) {
            return number + '-ри';
        } else if (lastDigit === 7 || lastDigit === 8) {
            return number + '-ми';
        } else {
            return number + '-ти';
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return mk;

})));


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ml = moment.defineLocale('ml', {
    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
    monthsParseExact : true,
    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm -നു',
        LTS : 'A h:mm:ss -നു',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm -നു',
        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
    },
    calendar : {
        sameDay : '[ഇന്ന്] LT',
        nextDay : '[നാളെ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ഇന്നലെ] LT',
        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s കഴിഞ്ഞ്',
        past : '%s മുൻപ്',
        s : 'അൽപ നിമിഷങ്ങൾ',
        m : 'ഒരു മിനിറ്റ്',
        mm : '%d മിനിറ്റ്',
        h : 'ഒരു മണിക്കൂർ',
        hh : '%d മണിക്കൂർ',
        d : 'ഒരു ദിവസം',
        dd : '%d ദിവസം',
        M : 'ഒരു മാസം',
        MM : '%d മാസം',
        y : 'ഒരു വർഷം',
        yy : '%d വർഷം'
    },
    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'രാത്രി';
        } else if (hour < 12) {
            return 'രാവിലെ';
        } else if (hour < 17) {
            return 'ഉച്ച കഴിഞ്ഞ്';
        } else if (hour < 20) {
            return 'വൈകുന്നേരം';
        } else {
            return 'രാത്രി';
        }
    }
});

return ml;

})));


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

function relativeTimeMr(number, withoutSuffix, string, isFuture)
{
    var output = '';
    if (withoutSuffix) {
        switch (string) {
            case 's': output = 'काही सेकंद'; break;
            case 'm': output = 'एक मिनिट'; break;
            case 'mm': output = '%d मिनिटे'; break;
            case 'h': output = 'एक तास'; break;
            case 'hh': output = '%d तास'; break;
            case 'd': output = 'एक दिवस'; break;
            case 'dd': output = '%d दिवस'; break;
            case 'M': output = 'एक महिना'; break;
            case 'MM': output = '%d महिने'; break;
            case 'y': output = 'एक वर्ष'; break;
            case 'yy': output = '%d वर्षे'; break;
        }
    }
    else {
        switch (string) {
            case 's': output = 'काही सेकंदां'; break;
            case 'm': output = 'एका मिनिटा'; break;
            case 'mm': output = '%d मिनिटां'; break;
            case 'h': output = 'एका तासा'; break;
            case 'hh': output = '%d तासां'; break;
            case 'd': output = 'एका दिवसा'; break;
            case 'dd': output = '%d दिवसां'; break;
            case 'M': output = 'एका महिन्या'; break;
            case 'MM': output = '%d महिन्यां'; break;
            case 'y': output = 'एका वर्षा'; break;
            case 'yy': output = '%d वर्षां'; break;
        }
    }
    return output.replace(/%d/i, number);
}

var mr = moment.defineLocale('mr', {
    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
    monthsParseExact : true,
    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
    longDateFormat : {
        LT : 'A h:mm वाजता',
        LTS : 'A h:mm:ss वाजता',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm वाजता',
        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[उद्या] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[काल] LT',
        lastWeek: '[मागील] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future: '%sमध्ये',
        past: '%sपूर्वी',
        s: relativeTimeMr,
        m: relativeTimeMr,
        mm: relativeTimeMr,
        h: relativeTimeMr,
        hh: relativeTimeMr,
        d: relativeTimeMr,
        dd: relativeTimeMr,
        M: relativeTimeMr,
        MM: relativeTimeMr,
        y: relativeTimeMr,
        yy: relativeTimeMr
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'रात्री') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'सकाळी') {
            return hour;
        } else if (meridiem === 'दुपारी') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'सायंकाळी') {
            return hour + 12;
        }
    },
    meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
            return 'रात्री';
        } else if (hour < 10) {
            return 'सकाळी';
        } else if (hour < 17) {
            return 'दुपारी';
        } else if (hour < 20) {
            return 'सायंकाळी';
        } else {
            return 'रात्री';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return mr;

})));


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ms = moment.defineLocale('ms', {
    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|tengahari|petang|malam/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'tengahari') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'petang' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'tengahari';
        } else if (hours < 19) {
            return 'petang';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Esok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kelmarin pukul] LT',
        lastWeek : 'dddd [lepas pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lepas',
        s : 'beberapa saat',
        m : 'seminit',
        mm : '%d minit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ms;

})));


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var msMy = moment.defineLocale('ms-my', {
    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|tengahari|petang|malam/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'tengahari') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'petang' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'tengahari';
        } else if (hours < 19) {
            return 'petang';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Esok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kelmarin pukul] LT',
        lastWeek : 'dddd [lepas pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lepas',
        s : 'beberapa saat',
        m : 'seminit',
        mm : '%d minit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return msMy;

})));


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '၁',
    '2': '၂',
    '3': '၃',
    '4': '၄',
    '5': '၅',
    '6': '၆',
    '7': '၇',
    '8': '၈',
    '9': '၉',
    '0': '၀'
};
var numberMap = {
    '၁': '1',
    '၂': '2',
    '၃': '3',
    '၄': '4',
    '၅': '5',
    '၆': '6',
    '၇': '7',
    '၈': '8',
    '၉': '9',
    '၀': '0'
};

var my = moment.defineLocale('my', {
    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[ယနေ.] LT [မှာ]',
        nextDay: '[မနက်ဖြန်] LT [မှာ]',
        nextWeek: 'dddd LT [မှာ]',
        lastDay: '[မနေ.က] LT [မှာ]',
        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'လာမည့် %s မှာ',
        past: 'လွန်ခဲ့သော %s က',
        s: 'စက္ကန်.အနည်းငယ်',
        m: 'တစ်မိနစ်',
        mm: '%d မိနစ်',
        h: 'တစ်နာရီ',
        hh: '%d နာရီ',
        d: 'တစ်ရက်',
        dd: '%d ရက်',
        M: 'တစ်လ',
        MM: '%d လ',
        y: 'တစ်နှစ်',
        yy: '%d နှစ်'
    },
    preparse: function (string) {
        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 1st is the first week of the year.
    }
});

return my;

})));


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var nb = moment.defineLocale('nb', {
    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
    monthsParseExact : true,
    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] HH:mm',
        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay: '[i dag kl.] LT',
        nextDay: '[i morgen kl.] LT',
        nextWeek: 'dddd [kl.] LT',
        lastDay: '[i går kl.] LT',
        lastWeek: '[forrige] dddd [kl.] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s siden',
        s : 'noen sekunder',
        m : 'ett minutt',
        mm : '%d minutter',
        h : 'en time',
        hh : '%d timer',
        d : 'en dag',
        dd : '%d dager',
        M : 'en måned',
        MM : '%d måneder',
        y : 'ett år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nb;

})));


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

var ne = moment.defineLocale('ne', {
    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
    monthsParseExact : true,
    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'Aको h:mm बजे',
        LTS : 'Aको h:mm:ss बजे',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, Aको h:mm बजे',
        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'राति') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'बिहान') {
            return hour;
        } else if (meridiem === 'दिउँसो') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'साँझ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 3) {
            return 'राति';
        } else if (hour < 12) {
            return 'बिहान';
        } else if (hour < 16) {
            return 'दिउँसो';
        } else if (hour < 20) {
            return 'साँझ';
        } else {
            return 'राति';
        }
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[भोलि] LT',
        nextWeek : '[आउँदो] dddd[,] LT',
        lastDay : '[हिजो] LT',
        lastWeek : '[गएको] dddd[,] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%sमा',
        past : '%s अगाडि',
        s : 'केही क्षण',
        m : 'एक मिनेट',
        mm : '%d मिनेट',
        h : 'एक घण्टा',
        hh : '%d घण्टा',
        d : 'एक दिन',
        dd : '%d दिन',
        M : 'एक महिना',
        MM : '%d महिना',
        y : 'एक बर्ष',
        yy : '%d बर्ष'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return ne;

})));


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

var nl = moment.defineLocale('nl', {
    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },

    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[vandaag om] LT',
        nextDay: '[morgen om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[gisteren om] LT',
        lastWeek: '[afgelopen] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'over %s',
        past : '%s geleden',
        s : 'een paar seconden',
        m : 'één minuut',
        mm : '%d minuten',
        h : 'één uur',
        hh : '%d uur',
        d : 'één dag',
        dd : '%d dagen',
        M : 'één maand',
        MM : '%d maanden',
        y : 'één jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nl;

})));


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

var nlBe = moment.defineLocale('nl-be', {
    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },

    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[vandaag om] LT',
        nextDay: '[morgen om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[gisteren om] LT',
        lastWeek: '[afgelopen] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'over %s',
        past : '%s geleden',
        s : 'een paar seconden',
        m : 'één minuut',
        mm : '%d minuten',
        h : 'één uur',
        hh : '%d uur',
        d : 'één dag',
        dd : '%d dagen',
        M : 'één maand',
        MM : '%d maanden',
        y : 'één jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nlBe;

})));


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! author : https://github.com/mechuwind

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var nn = moment.defineLocale('nn', {
    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] H:mm',
        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay: '[I dag klokka] LT',
        nextDay: '[I morgon klokka] LT',
        nextWeek: 'dddd [klokka] LT',
        lastDay: '[I går klokka] LT',
        lastWeek: '[Føregåande] dddd [klokka] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s sidan',
        s : 'nokre sekund',
        m : 'eit minutt',
        mm : '%d minutt',
        h : 'ein time',
        hh : '%d timar',
        d : 'ein dag',
        dd : '%d dagar',
        M : 'ein månad',
        MM : '%d månader',
        y : 'eit år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nn;

})));


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '੧',
    '2': '੨',
    '3': '੩',
    '4': '੪',
    '5': '੫',
    '6': '੬',
    '7': '੭',
    '8': '੮',
    '9': '੯',
    '0': '੦'
};
var numberMap = {
    '੧': '1',
    '੨': '2',
    '੩': '3',
    '੪': '4',
    '੫': '5',
    '੬': '6',
    '੭': '7',
    '੮': '8',
    '੯': '9',
    '੦': '0'
};

var paIn = moment.defineLocale('pa-in', {
    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm ਵਜੇ',
        LTS : 'A h:mm:ss ਵਜੇ',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
    },
    calendar : {
        sameDay : '[ਅਜ] LT',
        nextDay : '[ਕਲ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ਕਲ] LT',
        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ਵਿੱਚ',
        past : '%s ਪਿਛਲੇ',
        s : 'ਕੁਝ ਸਕਿੰਟ',
        m : 'ਇਕ ਮਿੰਟ',
        mm : '%d ਮਿੰਟ',
        h : 'ਇੱਕ ਘੰਟਾ',
        hh : '%d ਘੰਟੇ',
        d : 'ਇੱਕ ਦਿਨ',
        dd : '%d ਦਿਨ',
        M : 'ਇੱਕ ਮਹੀਨਾ',
        MM : '%d ਮਹੀਨੇ',
        y : 'ਇੱਕ ਸਾਲ',
        yy : '%d ਸਾਲ'
    },
    preparse: function (string) {
        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ਰਾਤ') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ਸਵੇਰ') {
            return hour;
        } else if (meridiem === 'ਦੁਪਹਿਰ') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'ਸ਼ਾਮ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ਰਾਤ';
        } else if (hour < 10) {
            return 'ਸਵੇਰ';
        } else if (hour < 17) {
            return 'ਦੁਪਹਿਰ';
        } else if (hour < 20) {
            return 'ਸ਼ਾਮ';
        } else {
            return 'ਰਾਤ';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return paIn;

})));


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
function plural(n) {
    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
}
function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'm':
            return withoutSuffix ? 'minuta' : 'minutę';
        case 'mm':
            return result + (plural(number) ? 'minuty' : 'minut');
        case 'h':
            return withoutSuffix  ? 'godzina'  : 'godzinę';
        case 'hh':
            return result + (plural(number) ? 'godziny' : 'godzin');
        case 'MM':
            return result + (plural(number) ? 'miesiące' : 'miesięcy');
        case 'yy':
            return result + (plural(number) ? 'lata' : 'lat');
    }
}

var pl = moment.defineLocale('pl', {
    months : function (momentToFormat, format) {
        if (!momentToFormat) {
            return monthsNominative;
        } else if (format === '') {
            // Hack: if format empty we know this is used to generate
            // RegExp by moment. Give then back both valid forms of months
            // in RegExp ready format.
            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
        } else if (/D MMMM/.test(format)) {
            return monthsSubjective[momentToFormat.month()];
        } else {
            return monthsNominative[momentToFormat.month()];
        }
    },
    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Dziś o] LT',
        nextDay: '[Jutro o] LT',
        nextWeek: '[W] dddd [o] LT',
        lastDay: '[Wczoraj o] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[W zeszłą niedzielę o] LT';
                case 3:
                    return '[W zeszłą środę o] LT';
                case 6:
                    return '[W zeszłą sobotę o] LT';
                default:
                    return '[W zeszły] dddd [o] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : '%s temu',
        s : 'kilka sekund',
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : '1 dzień',
        dd : '%d dni',
        M : 'miesiąc',
        MM : translate,
        y : 'rok',
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return pl;

})));


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var pt = moment.defineLocale('pt', {
    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
    weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY HH:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
                '[Último] dddd [às] LT' : // Saturday + Sunday
                '[Última] dddd [às] LT'; // Monday - Friday
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'em %s',
        past : 'há %s',
        s : 'segundos',
        m : 'um minuto',
        mm : '%d minutos',
        h : 'uma hora',
        hh : '%d horas',
        d : 'um dia',
        dd : '%d dias',
        M : 'um mês',
        MM : '%d meses',
        y : 'um ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return pt;

})));


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ptBr = moment.defineLocale('pt-br', {
    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
    },
    calendar : {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
                '[Último] dddd [às] LT' : // Saturday + Sunday
                '[Última] dddd [às] LT'; // Monday - Friday
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'em %s',
        past : '%s atrás',
        s : 'poucos segundos',
        m : 'um minuto',
        mm : '%d minutos',
        h : 'uma hora',
        hh : '%d horas',
        d : 'um dia',
        dd : '%d dias',
        M : 'um mês',
        MM : '%d meses',
        y : 'um ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal : '%dº'
});

return ptBr;

})));


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
            'mm': 'minute',
            'hh': 'ore',
            'dd': 'zile',
            'MM': 'luni',
            'yy': 'ani'
        },
        separator = ' ';
    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
        separator = ' de ';
    }
    return number + separator + format[key];
}

var ro = moment.defineLocale('ro', {
    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay: '[azi la] LT',
        nextDay: '[mâine la] LT',
        nextWeek: 'dddd [la] LT',
        lastDay: '[ieri la] LT',
        lastWeek: '[fosta] dddd [la] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'peste %s',
        past : '%s în urmă',
        s : 'câteva secunde',
        m : 'un minut',
        mm : relativeTimeWithPlural,
        h : 'o oră',
        hh : relativeTimeWithPlural,
        d : 'o zi',
        dd : relativeTimeWithPlural,
        M : 'o lună',
        MM : relativeTimeWithPlural,
        y : 'un an',
        yy : relativeTimeWithPlural
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ro;

})));


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! Author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
        'hh': 'час_часа_часов',
        'dd': 'день_дня_дней',
        'MM': 'месяц_месяца_месяцев',
        'yy': 'год_года_лет'
    };
    if (key === 'm') {
        return withoutSuffix ? 'минута' : 'минуту';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}
var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

// http://new.gramota.ru/spravka/rules/139-prop : § 103
// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
var ru = moment.defineLocale('ru', {
    months : {
        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
    },
    monthsShort : {
        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
    },
    weekdays : {
        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
    },
    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

    // копия предыдущего
    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

    // полные названия с падежами
    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

    // Выражение, которое соотвествует только сокращённым формам
    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY г.',
        LLL : 'D MMMM YYYY г., HH:mm',
        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
    },
    calendar : {
        sameDay: '[Сегодня в] LT',
        nextDay: '[Завтра в] LT',
        lastDay: '[Вчера в] LT',
        nextWeek: function (now) {
            if (now.week() !== this.week()) {
                switch (this.day()) {
                    case 0:
                        return '[В следующее] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[В следующий] dddd [в] LT';
                    case 3:
                    case 5:
                    case 6:
                        return '[В следующую] dddd [в] LT';
                }
            } else {
                if (this.day() === 2) {
                    return '[Во] dddd [в] LT';
                } else {
                    return '[В] dddd [в] LT';
                }
            }
        },
        lastWeek: function (now) {
            if (now.week() !== this.week()) {
                switch (this.day()) {
                    case 0:
                        return '[В прошлое] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[В прошлый] dddd [в] LT';
                    case 3:
                    case 5:
                    case 6:
                        return '[В прошлую] dddd [в] LT';
                }
            } else {
                if (this.day() === 2) {
                    return '[Во] dddd [в] LT';
                } else {
                    return '[В] dddd [в] LT';
                }
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'через %s',
        past : '%s назад',
        s : 'несколько секунд',
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : 'час',
        hh : relativeTimeWithPlural,
        d : 'день',
        dd : relativeTimeWithPlural,
        M : 'месяц',
        MM : relativeTimeWithPlural,
        y : 'год',
        yy : relativeTimeWithPlural
    },
    meridiemParse: /ночи|утра|дня|вечера/i,
    isPM : function (input) {
        return /^(дня|вечера)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночи';
        } else if (hour < 12) {
            return 'утра';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечера';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
                return number + '-й';
            case 'D':
                return number + '-го';
            case 'w':
            case 'W':
                return number + '-я';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ru;

})));


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'جنوري',
    'فيبروري',
    'مارچ',
    'اپريل',
    'مئي',
    'جون',
    'جولاءِ',
    'آگسٽ',
    'سيپٽمبر',
    'آڪٽوبر',
    'نومبر',
    'ڊسمبر'
];
var days = [
    'آچر',
    'سومر',
    'اڱارو',
    'اربع',
    'خميس',
    'جمع',
    'ڇنڇر'
];

var sd = moment.defineLocale('sd', {
    months : months,
    monthsShort : months,
    weekdays : days,
    weekdaysShort : days,
    weekdaysMin : days,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd، D MMMM YYYY HH:mm'
    },
    meridiemParse: /صبح|شام/,
    isPM : function (input) {
        return 'شام' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'صبح';
        }
        return 'شام';
    },
    calendar : {
        sameDay : '[اڄ] LT',
        nextDay : '[سڀاڻي] LT',
        nextWeek : 'dddd [اڳين هفتي تي] LT',
        lastDay : '[ڪالهه] LT',
        lastWeek : '[گزريل هفتي] dddd [تي] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s پوء',
        past : '%s اڳ',
        s : 'چند سيڪنڊ',
        m : 'هڪ منٽ',
        mm : '%d منٽ',
        h : 'هڪ ڪلاڪ',
        hh : '%d ڪلاڪ',
        d : 'هڪ ڏينهن',
        dd : '%d ڏينهن',
        M : 'هڪ مهينو',
        MM : '%d مهينا',
        y : 'هڪ سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sd;

})));


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var se = moment.defineLocale('se', {
    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'MMMM D. [b.] YYYY',
        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
    },
    calendar : {
        sameDay: '[otne ti] LT',
        nextDay: '[ihttin ti] LT',
        nextWeek: 'dddd [ti] LT',
        lastDay: '[ikte ti] LT',
        lastWeek: '[ovddit] dddd [ti] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s geažes',
        past : 'maŋit %s',
        s : 'moadde sekunddat',
        m : 'okta minuhta',
        mm : '%d minuhtat',
        h : 'okta diimmu',
        hh : '%d diimmut',
        d : 'okta beaivi',
        dd : '%d beaivvit',
        M : 'okta mánnu',
        MM : '%d mánut',
        y : 'okta jahki',
        yy : '%d jagit'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return se;

})));


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


/*jshint -W100*/
var si = moment.defineLocale('si', {
    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'a h:mm',
        LTS : 'a h:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY MMMM D',
        LLL : 'YYYY MMMM D, a h:mm',
        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
    },
    calendar : {
        sameDay : '[අද] LT[ට]',
        nextDay : '[හෙට] LT[ට]',
        nextWeek : 'dddd LT[ට]',
        lastDay : '[ඊයේ] LT[ට]',
        lastWeek : '[පසුගිය] dddd LT[ට]',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%sකින්',
        past : '%sකට පෙර',
        s : 'තත්පර කිහිපය',
        m : 'මිනිත්තුව',
        mm : 'මිනිත්තු %d',
        h : 'පැය',
        hh : 'පැය %d',
        d : 'දිනය',
        dd : 'දින %d',
        M : 'මාසය',
        MM : 'මාස %d',
        y : 'වසර',
        yy : 'වසර %d'
    },
    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
    ordinal : function (number) {
        return number + ' වැනි';
    },
    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
    isPM : function (input) {
        return input === 'ප.ව.' || input === 'පස් වරු';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'ප.ව.' : 'පස් වරු';
        } else {
            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
        }
    }
});

return si;

})));


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
function plural(n) {
    return (n > 1) && (n < 5);
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':  // a few seconds / in a few seconds / a few seconds ago
            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
        case 'm':  // a minute / in a minute / a minute ago
            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minúty' : 'minút');
            } else {
                return result + 'minútami';
            }
            break;
        case 'h':  // an hour / in an hour / an hour ago
            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
        case 'hh': // 9 hours / in 9 hours / 9 hours ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodín');
            } else {
                return result + 'hodinami';
            }
            break;
        case 'd':  // a day / in a day / a day ago
            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
        case 'dd': // 9 days / in 9 days / 9 days ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dni' : 'dní');
            } else {
                return result + 'dňami';
            }
            break;
        case 'M':  // a month / in a month / a month ago
            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
        case 'MM': // 9 months / in 9 months / 9 months ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'mesiace' : 'mesiacov');
            } else {
                return result + 'mesiacmi';
            }
            break;
        case 'y':  // a year / in a year / a year ago
            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
        case 'yy': // 9 years / in 9 years / 9 years ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'rokov');
            } else {
                return result + 'rokmi';
            }
            break;
    }
}

var sk = moment.defineLocale('sk', {
    months : months,
    monthsShort : monthsShort,
    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
    longDateFormat : {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay: '[dnes o] LT',
        nextDay: '[zajtra o] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[v nedeľu o] LT';
                case 1:
                case 2:
                    return '[v] dddd [o] LT';
                case 3:
                    return '[v stredu o] LT';
                case 4:
                    return '[vo štvrtok o] LT';
                case 5:
                    return '[v piatok o] LT';
                case 6:
                    return '[v sobotu o] LT';
            }
        },
        lastDay: '[včera o] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[minulú nedeľu o] LT';
                case 1:
                case 2:
                    return '[minulý] dddd [o] LT';
                case 3:
                    return '[minulú stredu o] LT';
                case 4:
                case 5:
                    return '[minulý] dddd [o] LT';
                case 6:
                    return '[minulú sobotu o] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : 'pred %s',
        s : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sk;

})));


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':
            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
        case 'm':
            return withoutSuffix ? 'ena minuta' : 'eno minuto';
        case 'mm':
            if (number === 1) {
                result += withoutSuffix ? 'minuta' : 'minuto';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
            } else {
                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'ena ura' : 'eno uro';
        case 'hh':
            if (number === 1) {
                result += withoutSuffix ? 'ura' : 'uro';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'uri' : 'urama';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'ure' : 'urami';
            } else {
                result += withoutSuffix || isFuture ? 'ur' : 'urami';
            }
            return result;
        case 'd':
            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
        case 'dd':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
            } else {
                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
            }
            return result;
        case 'M':
            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
        case 'MM':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
            } else {
                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
            }
            return result;
        case 'y':
            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
        case 'yy':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'leto' : 'letom';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'leta' : 'leti';
            } else {
                result += withoutSuffix || isFuture ? 'let' : 'leti';
            }
            return result;
    }
}

var sl = moment.defineLocale('sl', {
    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danes ob] LT',
        nextDay  : '[jutri ob] LT',

        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[v] [nedeljo] [ob] LT';
                case 3:
                    return '[v] [sredo] [ob] LT';
                case 6:
                    return '[v] [soboto] [ob] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[v] dddd [ob] LT';
            }
        },
        lastDay  : '[včeraj ob] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[prejšnjo] [nedeljo] [ob] LT';
                case 3:
                    return '[prejšnjo] [sredo] [ob] LT';
                case 6:
                    return '[prejšnjo] [soboto] [ob] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prejšnji] dddd [ob] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'čez %s',
        past   : 'pred %s',
        s      : processRelativeTime,
        m      : processRelativeTime,
        mm     : processRelativeTime,
        h      : processRelativeTime,
        hh     : processRelativeTime,
        d      : processRelativeTime,
        dd     : processRelativeTime,
        M      : processRelativeTime,
        MM     : processRelativeTime,
        y      : processRelativeTime,
        yy     : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sl;

})));


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sq = moment.defineLocale('sq', {
    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
    weekdaysParseExact : true,
    meridiemParse: /PD|MD/,
    isPM: function (input) {
        return input.charAt(0) === 'M';
    },
    meridiem : function (hours, minutes, isLower) {
        return hours < 12 ? 'PD' : 'MD';
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Sot në] LT',
        nextDay : '[Nesër në] LT',
        nextWeek : 'dddd [në] LT',
        lastDay : '[Dje në] LT',
        lastWeek : 'dddd [e kaluar në] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'në %s',
        past : '%s më parë',
        s : 'disa sekonda',
        m : 'një minutë',
        mm : '%d minuta',
        h : 'një orë',
        hh : '%d orë',
        d : 'një ditë',
        dd : '%d ditë',
        M : 'një muaj',
        MM : '%d muaj',
        y : 'një vit',
        yy : '%d vite'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sq;

})));


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        m: ['jedan minut', 'jedne minute'],
        mm: ['minut', 'minute', 'minuta'],
        h: ['jedan sat', 'jednog sata'],
        hh: ['sat', 'sata', 'sati'],
        dd: ['dan', 'dana', 'dana'],
        MM: ['mesec', 'meseca', 'meseci'],
        yy: ['godina', 'godine', 'godina']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var sr = moment.defineLocale('sr', {
    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sutra u] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedelju] [u] LT';
                case 3:
                    return '[u] [sredu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[juče u] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[prošle] [nedelje] [u] LT',
                '[prošlog] [ponedeljka] [u] LT',
                '[prošlog] [utorka] [u] LT',
                '[prošle] [srede] [u] LT',
                '[prošlog] [četvrtka] [u] LT',
                '[prošlog] [petka] [u] LT',
                '[prošle] [subote] [u] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'pre %s',
        s      : 'nekoliko sekundi',
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'dan',
        dd     : translator.translate,
        M      : 'mesec',
        MM     : translator.translate,
        y      : 'godinu',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sr;

})));


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        m: ['један минут', 'једне минуте'],
        mm: ['минут', 'минуте', 'минута'],
        h: ['један сат', 'једног сата'],
        hh: ['сат', 'сата', 'сати'],
        dd: ['дан', 'дана', 'дана'],
        MM: ['месец', 'месеца', 'месеци'],
        yy: ['година', 'године', 'година']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var srCyrl = moment.defineLocale('sr-cyrl', {
    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
    monthsParseExact: true,
    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[данас у] LT',
        nextDay: '[сутра у] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[у] [недељу] [у] LT';
                case 3:
                    return '[у] [среду] [у] LT';
                case 6:
                    return '[у] [суботу] [у] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[у] dddd [у] LT';
            }
        },
        lastDay  : '[јуче у] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[прошле] [недеље] [у] LT',
                '[прошлог] [понедељка] [у] LT',
                '[прошлог] [уторка] [у] LT',
                '[прошле] [среде] [у] LT',
                '[прошлог] [четвртка] [у] LT',
                '[прошлог] [петка] [у] LT',
                '[прошле] [суботе] [у] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'за %s',
        past   : 'пре %s',
        s      : 'неколико секунди',
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'дан',
        dd     : translator.translate,
        M      : 'месец',
        MM     : translator.translate,
        y      : 'годину',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return srCyrl;

})));


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var ss = moment.defineLocale('ss', {
    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Namuhla nga] LT',
        nextDay : '[Kusasa nga] LT',
        nextWeek : 'dddd [nga] LT',
        lastDay : '[Itolo nga] LT',
        lastWeek : 'dddd [leliphelile] [nga] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'nga %s',
        past : 'wenteka nga %s',
        s : 'emizuzwana lomcane',
        m : 'umzuzu',
        mm : '%d emizuzu',
        h : 'lihora',
        hh : '%d emahora',
        d : 'lilanga',
        dd : '%d emalanga',
        M : 'inyanga',
        MM : '%d tinyanga',
        y : 'umnyaka',
        yy : '%d iminyaka'
    },
    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'ekuseni';
        } else if (hours < 15) {
            return 'emini';
        } else if (hours < 19) {
            return 'entsambama';
        } else {
            return 'ebusuku';
        }
    },
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ekuseni') {
            return hour;
        } else if (meridiem === 'emini') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
            if (hour === 0) {
                return 0;
            }
            return hour + 12;
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : '%d',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ss;

})));


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sv = moment.defineLocale('sv', {
    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [kl.] HH:mm',
        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Idag] LT',
        nextDay: '[Imorgon] LT',
        lastDay: '[Igår] LT',
        nextWeek: '[På] dddd LT',
        lastWeek: '[I] dddd[s] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : 'för %s sedan',
        s : 'några sekunder',
        m : 'en minut',
        mm : '%d minuter',
        h : 'en timme',
        hh : '%d timmar',
        d : 'en dag',
        dd : '%d dagar',
        M : 'en månad',
        MM : '%d månader',
        y : 'ett år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'e' :
            (b === 1) ? 'a' :
            (b === 2) ? 'a' :
            (b === 3) ? 'e' : 'e';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sv;

})));


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sw = moment.defineLocale('sw', {
    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[leo saa] LT',
        nextDay : '[kesho saa] LT',
        nextWeek : '[wiki ijayo] dddd [saat] LT',
        lastDay : '[jana] LT',
        lastWeek : '[wiki iliyopita] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s baadaye',
        past : 'tokea %s',
        s : 'hivi punde',
        m : 'dakika moja',
        mm : 'dakika %d',
        h : 'saa limoja',
        hh : 'masaa %d',
        d : 'siku moja',
        dd : 'masiku %d',
        M : 'mwezi mmoja',
        MM : 'miezi %d',
        y : 'mwaka mmoja',
        yy : 'miaka %d'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sw;

})));


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '௧',
    '2': '௨',
    '3': '௩',
    '4': '௪',
    '5': '௫',
    '6': '௬',
    '7': '௭',
    '8': '௮',
    '9': '௯',
    '0': '௦'
};
var numberMap = {
    '௧': '1',
    '௨': '2',
    '௩': '3',
    '௪': '4',
    '௫': '5',
    '௬': '6',
    '௭': '7',
    '௮': '8',
    '௯': '9',
    '௦': '0'
};

var ta = moment.defineLocale('ta', {
    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, HH:mm',
        LLLL : 'dddd, D MMMM YYYY, HH:mm'
    },
    calendar : {
        sameDay : '[இன்று] LT',
        nextDay : '[நாளை] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[நேற்று] LT',
        lastWeek : '[கடந்த வாரம்] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s இல்',
        past : '%s முன்',
        s : 'ஒரு சில விநாடிகள்',
        m : 'ஒரு நிமிடம்',
        mm : '%d நிமிடங்கள்',
        h : 'ஒரு மணி நேரம்',
        hh : '%d மணி நேரம்',
        d : 'ஒரு நாள்',
        dd : '%d நாட்கள்',
        M : 'ஒரு மாதம்',
        MM : '%d மாதங்கள்',
        y : 'ஒரு வருடம்',
        yy : '%d ஆண்டுகள்'
    },
    dayOfMonthOrdinalParse: /\d{1,2}வது/,
    ordinal : function (number) {
        return number + 'வது';
    },
    preparse: function (string) {
        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // refer http://ta.wikipedia.org/s/1er1
    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
    meridiem : function (hour, minute, isLower) {
        if (hour < 2) {
            return ' யாமம்';
        } else if (hour < 6) {
            return ' வைகறை';  // வைகறை
        } else if (hour < 10) {
            return ' காலை'; // காலை
        } else if (hour < 14) {
            return ' நண்பகல்'; // நண்பகல்
        } else if (hour < 18) {
            return ' எற்பாடு'; // எற்பாடு
        } else if (hour < 22) {
            return ' மாலை'; // மாலை
        } else {
            return ' யாமம்';
        }
    },
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'யாமம்') {
            return hour < 2 ? hour : hour + 12;
        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
            return hour;
        } else if (meridiem === 'நண்பகல்') {
            return hour >= 10 ? hour : hour + 12;
        } else {
            return hour + 12;
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return ta;

})));


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var te = moment.defineLocale('te', {
    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
    monthsParseExact : true,
    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[నేడు] LT',
        nextDay : '[రేపు] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[నిన్న] LT',
        lastWeek : '[గత] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s లో',
        past : '%s క్రితం',
        s : 'కొన్ని క్షణాలు',
        m : 'ఒక నిమిషం',
        mm : '%d నిమిషాలు',
        h : 'ఒక గంట',
        hh : '%d గంటలు',
        d : 'ఒక రోజు',
        dd : '%d రోజులు',
        M : 'ఒక నెల',
        MM : '%d నెలలు',
        y : 'ఒక సంవత్సరం',
        yy : '%d సంవత్సరాలు'
    },
    dayOfMonthOrdinalParse : /\d{1,2}వ/,
    ordinal : '%dవ',
    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'రాత్రి') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ఉదయం') {
            return hour;
        } else if (meridiem === 'మధ్యాహ్నం') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'సాయంత్రం') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'రాత్రి';
        } else if (hour < 10) {
            return 'ఉదయం';
        } else if (hour < 17) {
            return 'మధ్యాహ్నం';
        } else if (hour < 20) {
            return 'సాయంత్రం';
        } else {
            return 'రాత్రి';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return te;

})));


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tet = moment.defineLocale('tet', {
    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Ohin iha] LT',
        nextDay: '[Aban iha] LT',
        nextWeek: 'dddd [iha] LT',
        lastDay: '[Horiseik iha] LT',
        lastWeek: 'dddd [semana kotuk] [iha] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'iha %s',
        past : '%s liuba',
        s : 'minutu balun',
        m : 'minutu ida',
        mm : 'minutus %d',
        h : 'horas ida',
        hh : 'horas %d',
        d : 'loron ida',
        dd : 'loron %d',
        M : 'fulan ida',
        MM : 'fulan %d',
        y : 'tinan ida',
        yy : 'tinan %d'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tet;

})));


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var th = moment.defineLocale('th', {
    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
    monthsParseExact: true,
    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY เวลา H:mm',
        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
    },
    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
    isPM: function (input) {
        return input === 'หลังเที่ยง';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ก่อนเที่ยง';
        } else {
            return 'หลังเที่ยง';
        }
    },
    calendar : {
        sameDay : '[วันนี้ เวลา] LT',
        nextDay : '[พรุ่งนี้ เวลา] LT',
        nextWeek : 'dddd[หน้า เวลา] LT',
        lastDay : '[เมื่อวานนี้ เวลา] LT',
        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'อีก %s',
        past : '%sที่แล้ว',
        s : 'ไม่กี่วินาที',
        m : '1 นาที',
        mm : '%d นาที',
        h : '1 ชั่วโมง',
        hh : '%d ชั่วโมง',
        d : '1 วัน',
        dd : '%d วัน',
        M : '1 เดือน',
        MM : '%d เดือน',
        y : '1 ปี',
        yy : '%d ปี'
    }
});

return th;

})));


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tlPh = moment.defineLocale('tl-ph', {
    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'MM/D/YYYY',
        LL : 'MMMM D, YYYY',
        LLL : 'MMMM D, YYYY HH:mm',
        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
    },
    calendar : {
        sameDay: 'LT [ngayong araw]',
        nextDay: '[Bukas ng] LT',
        nextWeek: 'LT [sa susunod na] dddd',
        lastDay: 'LT [kahapon]',
        lastWeek: 'LT [noong nakaraang] dddd',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'sa loob ng %s',
        past : '%s ang nakalipas',
        s : 'ilang segundo',
        m : 'isang minuto',
        mm : '%d minuto',
        h : 'isang oras',
        hh : '%d oras',
        d : 'isang araw',
        dd : '%d araw',
        M : 'isang buwan',
        MM : '%d buwan',
        y : 'isang taon',
        yy : '%d taon'
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : function (number) {
        return number;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tlPh;

})));


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

function translateFuture(output) {
    var time = output;
    time = (output.indexOf('jaj') !== -1) ?
    time.slice(0, -3) + 'leS' :
    (output.indexOf('jar') !== -1) ?
    time.slice(0, -3) + 'waQ' :
    (output.indexOf('DIS') !== -1) ?
    time.slice(0, -3) + 'nem' :
    time + ' pIq';
    return time;
}

function translatePast(output) {
    var time = output;
    time = (output.indexOf('jaj') !== -1) ?
    time.slice(0, -3) + 'Hu’' :
    (output.indexOf('jar') !== -1) ?
    time.slice(0, -3) + 'wen' :
    (output.indexOf('DIS') !== -1) ?
    time.slice(0, -3) + 'ben' :
    time + ' ret';
    return time;
}

function translate(number, withoutSuffix, string, isFuture) {
    var numberNoun = numberAsNoun(number);
    switch (string) {
        case 'mm':
            return numberNoun + ' tup';
        case 'hh':
            return numberNoun + ' rep';
        case 'dd':
            return numberNoun + ' jaj';
        case 'MM':
            return numberNoun + ' jar';
        case 'yy':
            return numberNoun + ' DIS';
    }
}

function numberAsNoun(number) {
    var hundred = Math.floor((number % 1000) / 100),
    ten = Math.floor((number % 100) / 10),
    one = number % 10,
    word = '';
    if (hundred > 0) {
        word += numbersNouns[hundred] + 'vatlh';
    }
    if (ten > 0) {
        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
    }
    if (one > 0) {
        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
    }
    return (word === '') ? 'pagh' : word;
}

var tlh = moment.defineLocale('tlh', {
    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
    monthsParseExact : true,
    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[DaHjaj] LT',
        nextDay: '[wa’leS] LT',
        nextWeek: 'LLL',
        lastDay: '[wa’Hu’] LT',
        lastWeek: 'LLL',
        sameElse: 'L'
    },
    relativeTime : {
        future : translateFuture,
        past : translatePast,
        s : 'puS lup',
        m : 'wa’ tup',
        mm : translate,
        h : 'wa’ rep',
        hh : translate,
        d : 'wa’ jaj',
        dd : translate,
        M : 'wa’ jar',
        MM : translate,
        y : 'wa’ DIS',
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tlh;

})));


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    1: '\'inci',
    5: '\'inci',
    8: '\'inci',
    70: '\'inci',
    80: '\'inci',
    2: '\'nci',
    7: '\'nci',
    20: '\'nci',
    50: '\'nci',
    3: '\'üncü',
    4: '\'üncü',
    100: '\'üncü',
    6: '\'ncı',
    9: '\'uncu',
    10: '\'uncu',
    30: '\'uncu',
    60: '\'ıncı',
    90: '\'ıncı'
};

var tr = moment.defineLocale('tr', {
    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[bugün saat] LT',
        nextDay : '[yarın saat] LT',
        nextWeek : '[haftaya] dddd [saat] LT',
        lastDay : '[dün] LT',
        lastWeek : '[geçen hafta] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s sonra',
        past : '%s önce',
        s : 'birkaç saniye',
        m : 'bir dakika',
        mm : '%d dakika',
        h : 'bir saat',
        hh : '%d saat',
        d : 'bir gün',
        dd : '%d gün',
        M : 'bir ay',
        MM : '%d ay',
        y : 'bir yıl',
        yy : '%d yıl'
    },
    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
    ordinal : function (number) {
        if (number === 0) {  // special case for zero
            return number + '\'ıncı';
        }
        var a = number % 10,
            b = number % 100 - a,
            c = number >= 100 ? 100 : null;
        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return tr;

})));


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
// This is currently too difficult (maybe even impossible) to add.
var tzl = moment.defineLocale('tzl', {
    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM [dallas] YYYY',
        LLL : 'D. MMMM [dallas] YYYY HH.mm',
        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
    },
    meridiemParse: /d\'o|d\'a/i,
    isPM : function (input) {
        return 'd\'o' === input.toLowerCase();
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'd\'o' : 'D\'O';
        } else {
            return isLower ? 'd\'a' : 'D\'A';
        }
    },
    calendar : {
        sameDay : '[oxhi à] LT',
        nextDay : '[demà à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[ieiri à] LT',
        lastWeek : '[sür el] dddd [lasteu à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'osprei %s',
        past : 'ja%s',
        s : processRelativeTime,
        m : processRelativeTime,
        mm : processRelativeTime,
        h : processRelativeTime,
        hh : processRelativeTime,
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's': ['viensas secunds', '\'iensas secunds'],
        'm': ['\'n míut', '\'iens míut'],
        'mm': [number + ' míuts', '' + number + ' míuts'],
        'h': ['\'n þora', '\'iensa þora'],
        'hh': [number + ' þoras', '' + number + ' þoras'],
        'd': ['\'n ziua', '\'iensa ziua'],
        'dd': [number + ' ziuas', '' + number + ' ziuas'],
        'M': ['\'n mes', '\'iens mes'],
        'MM': [number + ' mesen', '' + number + ' mesen'],
        'y': ['\'n ar', '\'iens ar'],
        'yy': [number + ' ars', '' + number + ' ars']
    };
    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
}

return tzl;

})));


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tzm = moment.defineLocale('tzm', {
    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
        nextWeek: 'dddd [ⴴ] LT',
        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
        lastWeek: 'dddd [ⴴ] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
        past : 'ⵢⴰⵏ %s',
        s : 'ⵉⵎⵉⴽ',
        m : 'ⵎⵉⵏⵓⴺ',
        mm : '%d ⵎⵉⵏⵓⴺ',
        h : 'ⵙⴰⵄⴰ',
        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
        d : 'ⴰⵙⵙ',
        dd : '%d oⵙⵙⴰⵏ',
        M : 'ⴰⵢoⵓⵔ',
        MM : '%d ⵉⵢⵢⵉⵔⵏ',
        y : 'ⴰⵙⴳⴰⵙ',
        yy : '%d ⵉⵙⴳⴰⵙⵏ'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return tzm;

})));


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tzmLatn = moment.defineLocale('tzm-latn', {
    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[asdkh g] LT',
        nextDay: '[aska g] LT',
        nextWeek: 'dddd [g] LT',
        lastDay: '[assant g] LT',
        lastWeek: 'dddd [g] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'dadkh s yan %s',
        past : 'yan %s',
        s : 'imik',
        m : 'minuḍ',
        mm : '%d minuḍ',
        h : 'saɛa',
        hh : '%d tassaɛin',
        d : 'ass',
        dd : '%d ossan',
        M : 'ayowr',
        MM : '%d iyyirn',
        y : 'asgas',
        yy : '%d isgasn'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return tzmLatn;

})));


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
        'dd': 'день_дні_днів',
        'MM': 'місяць_місяці_місяців',
        'yy': 'рік_роки_років'
    };
    if (key === 'm') {
        return withoutSuffix ? 'хвилина' : 'хвилину';
    }
    else if (key === 'h') {
        return withoutSuffix ? 'година' : 'годину';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}
function weekdaysCaseReplace(m, format) {
    var weekdays = {
        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
    };

    if (!m) {
        return weekdays['nominative'];
    }

    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
        'accusative' :
        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
            'genitive' :
            'nominative');
    return weekdays[nounCase][m.day()];
}
function processHoursFunction(str) {
    return function () {
        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
    };
}

var uk = moment.defineLocale('uk', {
    months : {
        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
    },
    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
    weekdays : weekdaysCaseReplace,
    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY р.',
        LLL : 'D MMMM YYYY р., HH:mm',
        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
    },
    calendar : {
        sameDay: processHoursFunction('[Сьогодні '),
        nextDay: processHoursFunction('[Завтра '),
        lastDay: processHoursFunction('[Вчора '),
        nextWeek: processHoursFunction('[У] dddd ['),
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                    return processHoursFunction('[Минулої] dddd [').call(this);
                case 1:
                case 2:
                case 4:
                    return processHoursFunction('[Минулого] dddd [').call(this);
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'за %s',
        past : '%s тому',
        s : 'декілька секунд',
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : 'годину',
        hh : relativeTimeWithPlural,
        d : 'день',
        dd : relativeTimeWithPlural,
        M : 'місяць',
        MM : relativeTimeWithPlural,
        y : 'рік',
        yy : relativeTimeWithPlural
    },
    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
    meridiemParse: /ночі|ранку|дня|вечора/,
    isPM: function (input) {
        return /^(дня|вечора)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночі';
        } else if (hour < 12) {
            return 'ранку';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечора';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
            case 'w':
            case 'W':
                return number + '-й';
            case 'D':
                return number + '-го';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return uk;

})));


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'جنوری',
    'فروری',
    'مارچ',
    'اپریل',
    'مئی',
    'جون',
    'جولائی',
    'اگست',
    'ستمبر',
    'اکتوبر',
    'نومبر',
    'دسمبر'
];
var days = [
    'اتوار',
    'پیر',
    'منگل',
    'بدھ',
    'جمعرات',
    'جمعہ',
    'ہفتہ'
];

var ur = moment.defineLocale('ur', {
    months : months,
    monthsShort : months,
    weekdays : days,
    weekdaysShort : days,
    weekdaysMin : days,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd، D MMMM YYYY HH:mm'
    },
    meridiemParse: /صبح|شام/,
    isPM : function (input) {
        return 'شام' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'صبح';
        }
        return 'شام';
    },
    calendar : {
        sameDay : '[آج بوقت] LT',
        nextDay : '[کل بوقت] LT',
        nextWeek : 'dddd [بوقت] LT',
        lastDay : '[گذشتہ روز بوقت] LT',
        lastWeek : '[گذشتہ] dddd [بوقت] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s بعد',
        past : '%s قبل',
        s : 'چند سیکنڈ',
        m : 'ایک منٹ',
        mm : '%d منٹ',
        h : 'ایک گھنٹہ',
        hh : '%d گھنٹے',
        d : 'ایک دن',
        dd : '%d دن',
        M : 'ایک ماہ',
        MM : '%d ماہ',
        y : 'ایک سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ur;

})));


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var uz = moment.defineLocale('uz', {
    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'D MMMM YYYY, dddd HH:mm'
    },
    calendar : {
        sameDay : '[Бугун соат] LT [да]',
        nextDay : '[Эртага] LT [да]',
        nextWeek : 'dddd [куни соат] LT [да]',
        lastDay : '[Кеча соат] LT [да]',
        lastWeek : '[Утган] dddd [куни соат] LT [да]',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'Якин %s ичида',
        past : 'Бир неча %s олдин',
        s : 'фурсат',
        m : 'бир дакика',
        mm : '%d дакика',
        h : 'бир соат',
        hh : '%d соат',
        d : 'бир кун',
        dd : '%d кун',
        M : 'бир ой',
        MM : '%d ой',
        y : 'бир йил',
        yy : '%d йил'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 4th is the first week of the year.
    }
});

return uz;

})));


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var uzLatn = moment.defineLocale('uz-latn', {
    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'D MMMM YYYY, dddd HH:mm'
    },
    calendar : {
        sameDay : '[Bugun soat] LT [da]',
        nextDay : '[Ertaga] LT [da]',
        nextWeek : 'dddd [kuni soat] LT [da]',
        lastDay : '[Kecha soat] LT [da]',
        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'Yaqin %s ichida',
        past : 'Bir necha %s oldin',
        s : 'soniya',
        m : 'bir daqiqa',
        mm : '%d daqiqa',
        h : 'bir soat',
        hh : '%d soat',
        d : 'bir kun',
        dd : '%d kun',
        M : 'bir oy',
        MM : '%d oy',
        y : 'bir yil',
        yy : '%d yil'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return uzLatn;

})));


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var vi = moment.defineLocale('vi', {
    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
    monthsParseExact : true,
    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    weekdaysParseExact : true,
    meridiemParse: /sa|ch/i,
    isPM : function (input) {
        return /^ch$/i.test(input);
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower ? 'sa' : 'SA';
        } else {
            return isLower ? 'ch' : 'CH';
        }
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM [năm] YYYY',
        LLL : 'D MMMM [năm] YYYY HH:mm',
        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
        l : 'DD/M/YYYY',
        ll : 'D MMM YYYY',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd, D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Hôm nay lúc] LT',
        nextDay: '[Ngày mai lúc] LT',
        nextWeek: 'dddd [tuần tới lúc] LT',
        lastDay: '[Hôm qua lúc] LT',
        lastWeek: 'dddd [tuần rồi lúc] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s tới',
        past : '%s trước',
        s : 'vài giây',
        m : 'một phút',
        mm : '%d phút',
        h : 'một giờ',
        hh : '%d giờ',
        d : 'một ngày',
        dd : '%d ngày',
        M : 'một tháng',
        MM : '%d tháng',
        y : 'một năm',
        yy : '%d năm'
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : function (number) {
        return number;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return vi;

})));


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var xPseudo = moment.defineLocale('x-pseudo', {
    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
    monthsParseExact : true,
    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[T~ódá~ý át] LT',
        nextDay : '[T~ómó~rró~w át] LT',
        nextWeek : 'dddd [át] LT',
        lastDay : '[Ý~ést~érdá~ý át] LT',
        lastWeek : '[L~ást] dddd [át] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'í~ñ %s',
        past : '%s á~gó',
        s : 'á ~féw ~sécó~ñds',
        m : 'á ~míñ~úté',
        mm : '%d m~íñú~tés',
        h : 'á~ñ hó~úr',
        hh : '%d h~óúrs',
        d : 'á ~dáý',
        dd : '%d d~áýs',
        M : 'á ~móñ~th',
        MM : '%d m~óñt~hs',
        y : 'á ~ýéár',
        yy : '%d ý~éárs'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return xPseudo;

})));


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var yo = moment.defineLocale('yo', {
    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Ònì ni] LT',
        nextDay : '[Ọ̀la ni] LT',
        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
        lastDay : '[Àna ni] LT',
        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ní %s',
        past : '%s kọjá',
        s : 'ìsẹjú aayá die',
        m : 'ìsẹjú kan',
        mm : 'ìsẹjú %d',
        h : 'wákati kan',
        hh : 'wákati %d',
        d : 'ọjọ́ kan',
        dd : 'ọjọ́ %d',
        M : 'osù kan',
        MM : 'osù %d',
        y : 'ọdún kan',
        yy : 'ọdún %d'
    },
    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
    ordinal : 'ọjọ́ %d',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return yo;

})));


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhCn = moment.defineLocale('zh-cn', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY年MMMD日',
        LL : 'YYYY年MMMD日',
        LLL : 'YYYY年MMMD日Ah点mm分',
        LLLL : 'YYYY年MMMD日ddddAh点mm分',
        l : 'YYYY年MMMD日',
        ll : 'YYYY年MMMD日',
        lll : 'YYYY年MMMD日 HH:mm',
        llll : 'YYYY年MMMD日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' ||
                meridiem === '上午') {
            return hour;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        } else {
            // '中午'
            return hour >= 11 ? hour : hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            case 'M':
                return number + '月';
            case 'w':
            case 'W':
                return number + '周';
            default:
                return number;
        }
    },
    relativeTime : {
        future : '%s内',
        past : '%s前',
        s : '几秒',
        m : '1 分钟',
        mm : '%d 分钟',
        h : '1 小时',
        hh : '%d 小时',
        d : '1 天',
        dd : '%d 天',
        M : '1 个月',
        MM : '%d 个月',
        y : '1 年',
        yy : '%d 年'
    },
    week : {
        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return zhCn;

})));


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhHk = moment.defineLocale('zh-hk', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY年MMMD日',
        LL : 'YYYY年MMMD日',
        LLL : 'YYYY年MMMD日 HH:mm',
        LLLL : 'YYYY年MMMD日dddd HH:mm',
        l : 'YYYY年MMMD日',
        ll : 'YYYY年MMMD日',
        lll : 'YYYY年MMMD日 HH:mm',
        llll : 'YYYY年MMMD日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
            return hour;
        } else if (meridiem === '中午') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd' :
            case 'D' :
            case 'DDD' :
                return number + '日';
            case 'M' :
                return number + '月';
            case 'w' :
            case 'W' :
                return number + '週';
            default :
                return number;
        }
    },
    relativeTime : {
        future : '%s內',
        past : '%s前',
        s : '幾秒',
        m : '1 分鐘',
        mm : '%d 分鐘',
        h : '1 小時',
        hh : '%d 小時',
        d : '1 天',
        dd : '%d 天',
        M : '1 個月',
        MM : '%d 個月',
        y : '1 年',
        yy : '%d 年'
    }
});

return zhHk;

})));


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhTw = moment.defineLocale('zh-tw', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY年MMMD日',
        LL : 'YYYY年MMMD日',
        LLL : 'YYYY年MMMD日 HH:mm',
        LLLL : 'YYYY年MMMD日dddd HH:mm',
        l : 'YYYY年MMMD日',
        ll : 'YYYY年MMMD日',
        lll : 'YYYY年MMMD日 HH:mm',
        llll : 'YYYY年MMMD日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
            return hour;
        } else if (meridiem === '中午') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd' :
            case 'D' :
            case 'DDD' :
                return number + '日';
            case 'M' :
                return number + '月';
            case 'w' :
            case 'W' :
                return number + '週';
            default :
                return number;
        }
    },
    relativeTime : {
        future : '%s內',
        past : '%s前',
        s : '幾秒',
        m : '1 分鐘',
        mm : '%d 分鐘',
        h : '1 小時',
        hh : '%d 小時',
        d : '1 天',
        dd : '%d 天',
        M : '1 個月',
        MM : '%d 個月',
        y : '1 年',
        yy : '%d 年'
    }
});

return zhTw;

})));


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
var rng;

var crypto = global.crypto || global.msCrypto; // for IE 11
if (crypto && crypto.getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
  rng = function whatwgRNG() {
    crypto.getRandomValues(rnds8);
    return rnds8;
  };
}

if (!rng) {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);
  rng = function() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}

module.exports = rng;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 398 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  return bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]];
}

module.exports = bytesToUuid;


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(36);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(36);
var normalizeHeaderName = __webpack_require__(934);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(403);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(403);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(142)))

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(36);
var settle = __webpack_require__(935);
var buildURL = __webpack_require__(400);
var buildFullPath = __webpack_require__(937);
var parseHeaders = __webpack_require__(940);
var isURLSameOrigin = __webpack_require__(941);
var createError = __webpack_require__(404);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(942);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(936);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(36);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var DateRangePicker = __webpack_require__(945).default;
var DateRangePickerInput = __webpack_require__(546).default;
var DateRangePickerInputController = __webpack_require__(545).default;
var SingleDatePicker = __webpack_require__(987).default;
var SingleDatePickerInput = __webpack_require__(571).default;
var DayPicker = __webpack_require__(200).default;
var DayPickerRangeController = __webpack_require__(551).default;
var DayPickerSingleDateController = __webpack_require__(570).default;
var CalendarMonthGrid = __webpack_require__(555).default;
var CalendarMonth = __webpack_require__(556).default;
var CalendarDay = __webpack_require__(557).default;

var DateRangePickerShape = __webpack_require__(410).default;
var SingleDatePickerShape = __webpack_require__(569).default;

var isInclusivelyAfterDay = __webpack_require__(112).default;
var isInclusivelyBeforeDay = __webpack_require__(988).default;
var isNextDay = __webpack_require__(568).default;
var isSameDay = __webpack_require__(102).default;

var toISODateString = __webpack_require__(99).default;
var toLocalizedDateString = __webpack_require__(197).default;
var toMomentObject = __webpack_require__(100).default;


module.exports = {
  DateRangePicker: DateRangePicker,
  SingleDatePicker: SingleDatePicker,

  DateRangePickerInputController: DateRangePickerInputController,
  DateRangePickerInput: DateRangePickerInput,
  SingleDatePickerInput: SingleDatePickerInput,
  DayPicker: DayPicker,
  DayPickerRangeController: DayPickerRangeController,
  DayPickerSingleDateController: DayPickerSingleDateController,
  CalendarMonthGrid: CalendarMonthGrid,
  CalendarMonth: CalendarMonth,
  CalendarDay: CalendarDay,

  DateRangePickerShape: DateRangePickerShape,
  SingleDatePickerShape: SingleDatePickerShape,

  isInclusivelyAfterDay: isInclusivelyAfterDay,
  isInclusivelyBeforeDay: isInclusivelyBeforeDay,
  isNextDay: isNextDay,
  isSameDay: isSameDay,

  toISODateString: toISODateString,
  toLocalizedDateString: toLocalizedDateString,
  toMomentObject: toMomentObject,
};


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = getResponsiveContainerStyles;

var _constants = __webpack_require__(12);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getResponsiveContainerStyles(anchorDirection, currentOffset, containerEdge, margin) {
  var windowWidth = typeof window !== 'undefined' ? window.innerWidth : 0;
  var calculatedOffset = anchorDirection === _constants.ANCHOR_LEFT ? windowWidth - containerEdge : containerEdge;
  var calculatedMargin = margin || 0;

  return _defineProperty({}, anchorDirection, Math.min(currentOffset + calculatedOffset - calculatedMargin, 0));
}

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(94);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KEYCODES = {
  ESCAPE: 27
};

var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    _classCallCheck(this, Portal);

    var _this = _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this));

    _this.state = { active: false };
    _this.handleWrapperClick = _this.handleWrapperClick.bind(_this);
    _this.closePortal = _this.closePortal.bind(_this);
    _this.handleOutsideMouseClick = _this.handleOutsideMouseClick.bind(_this);
    _this.handleKeydown = _this.handleKeydown.bind(_this);
    _this.portal = null;
    _this.node = null;
    return _this;
  }

  _createClass(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.closeOnEsc) {
        document.addEventListener('keydown', this.handleKeydown);
      }

      if (this.props.closeOnOutsideClick) {
        document.addEventListener('mouseup', this.handleOutsideMouseClick);
        document.addEventListener('touchstart', this.handleOutsideMouseClick);
      }

      if (this.props.isOpened) {
        this.openPortal();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      // portal's 'is open' state is handled through the prop isOpened
      if (typeof newProps.isOpened !== 'undefined') {
        if (newProps.isOpened) {
          if (this.state.active) {
            this.renderPortal(newProps);
          } else {
            this.openPortal(newProps);
          }
        }
        if (!newProps.isOpened && this.state.active) {
          this.closePortal();
        }
      }

      // portal handles its own 'is open' state
      if (typeof newProps.isOpened === 'undefined' && this.state.active) {
        this.renderPortal(newProps);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.closeOnEsc) {
        document.removeEventListener('keydown', this.handleKeydown);
      }

      if (this.props.closeOnOutsideClick) {
        document.removeEventListener('mouseup', this.handleOutsideMouseClick);
        document.removeEventListener('touchstart', this.handleOutsideMouseClick);
      }

      this.closePortal(true);
    }
  }, {
    key: 'handleWrapperClick',
    value: function handleWrapperClick(e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.state.active) {
        return;
      }
      this.openPortal();
    }
  }, {
    key: 'openPortal',
    value: function openPortal() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      this.setState({ active: true });
      this.renderPortal(props);
      this.props.onOpen(this.node);
    }
  }, {
    key: 'closePortal',
    value: function closePortal() {
      var _this2 = this;

      var isUnmounted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var resetPortalState = function resetPortalState(overrideIsUnmounted) {
        if (_this2.node) {
          _reactDom2.default.unmountComponentAtNode(_this2.node);
          document.body.removeChild(_this2.node);
        }
        _this2.portal = null;
        _this2.node = null;

        var finalIsUnmounted = overrideIsUnmounted === undefined ? isUnmounted : overrideIsUnmounted;

        if (finalIsUnmounted !== true) {
          _this2.setState({ active: false });
        }
      };

      if (this.state.active) {
        if (this.props.beforeClose) {
          this.props.beforeClose(this.node, resetPortalState);
        } else {
          resetPortalState();
        }

        this.props.onClose();
      }
    }
  }, {
    key: 'handleOutsideMouseClick',
    value: function handleOutsideMouseClick(e) {
      if (!this.state.active) {
        return;
      }

      var root = (0, _reactDom.findDOMNode)(this.portal);
      if (root.contains(e.target) || e.button && e.button !== 0) {
        return;
      }

      e.stopPropagation();
      this.closePortal();
    }
  }, {
    key: 'handleKeydown',
    value: function handleKeydown(e) {
      if (e.keyCode === KEYCODES.ESCAPE && this.state.active) {
        this.closePortal();
      }
    }
  }, {
    key: 'renderPortal',
    value: function renderPortal(props) {
      if (!this.node) {
        this.node = document.createElement('div');
        document.body.appendChild(this.node);
      }

      var children = props.children;
      // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
      if (typeof props.children.type === 'function') {
        children = _react2.default.cloneElement(props.children, { closePortal: this.closePortal });
      }

      this.portal = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, children, this.node, this.props.onUpdate);
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.openByClickOn) {
        return _react2.default.cloneElement(this.props.openByClickOn, { onClick: this.handleWrapperClick });
      }
      return null;
    }
  }]);

  return Portal;
}(_react2.default.Component);

exports.default = Portal;


Portal.propTypes = {
  children: _propTypes2.default.element.isRequired,
  openByClickOn: _propTypes2.default.element,
  closeOnEsc: _propTypes2.default.bool,
  closeOnOutsideClick: _propTypes2.default.bool,
  isOpened: _propTypes2.default.bool,
  onOpen: _propTypes2.default.func,
  onClose: _propTypes2.default.func,
  beforeClose: _propTypes2.default.func,
  onUpdate: _propTypes2.default.func
};

Portal.defaultProps = {
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  onUpdate: function onUpdate() {}
};
module.exports = exports['default'];


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMomentProptypes = __webpack_require__(68);

var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);

var _airbnbPropTypes = __webpack_require__(24);

var _defaultPhrases = __webpack_require__(27);

var _getPhrasePropTypes = __webpack_require__(37);

var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);

var _FocusedInputShape = __webpack_require__(542);

var _FocusedInputShape2 = _interopRequireDefault(_FocusedInputShape);

var _IconPositionShape = __webpack_require__(115);

var _IconPositionShape2 = _interopRequireDefault(_IconPositionShape);

var _OrientationShape = __webpack_require__(543);

var _OrientationShape2 = _interopRequireDefault(_OrientationShape);

var _AnchorDirectionShape = __webpack_require__(544);

var _AnchorDirectionShape2 = _interopRequireDefault(_AnchorDirectionShape);

var _OpenDirectionShape = __webpack_require__(98);

var _OpenDirectionShape2 = _interopRequireDefault(_OpenDirectionShape);

var _DayOfWeekShape = __webpack_require__(86);

var _DayOfWeekShape2 = _interopRequireDefault(_DayOfWeekShape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  // required props for a functional interactive DateRangePicker
  startDate: _reactMomentProptypes2['default'].momentObj,
  endDate: _reactMomentProptypes2['default'].momentObj,
  onDatesChange: _propTypes2['default'].func.isRequired,

  focusedInput: _FocusedInputShape2['default'],
  onFocusChange: _propTypes2['default'].func.isRequired,

  onClose: _propTypes2['default'].func,

  // input related props
  startDateId: _propTypes2['default'].string.isRequired,
  startDatePlaceholderText: _propTypes2['default'].string,
  endDateId: _propTypes2['default'].string.isRequired,
  endDatePlaceholderText: _propTypes2['default'].string,
  disabled: _propTypes2['default'].bool,
  required: _propTypes2['default'].bool,
  readOnly: _propTypes2['default'].bool,
  screenReaderInputMessage: _propTypes2['default'].string,
  showClearDates: _propTypes2['default'].bool,
  showDefaultInputIcon: _propTypes2['default'].bool,
  inputIconPosition: _IconPositionShape2['default'],
  customInputIcon: _propTypes2['default'].node,
  customArrowIcon: _propTypes2['default'].node,
  customCloseIcon: _propTypes2['default'].node,

  // calendar presentation and interaction related props
  renderMonth: _propTypes2['default'].func,
  orientation: _OrientationShape2['default'],
  anchorDirection: _AnchorDirectionShape2['default'],
  openDirection: _OpenDirectionShape2['default'],
  horizontalMargin: _propTypes2['default'].number,
  withPortal: _propTypes2['default'].bool,
  withFullScreenPortal: _propTypes2['default'].bool,
  daySize: _airbnbPropTypes.nonNegativeInteger,
  isRTL: _propTypes2['default'].bool,
  firstDayOfWeek: _DayOfWeekShape2['default'],
  initialVisibleMonth: _propTypes2['default'].func,
  numberOfMonths: _propTypes2['default'].number,
  keepOpenOnDateSelect: _propTypes2['default'].bool,
  reopenPickerOnClearDates: _propTypes2['default'].bool,
  renderCalendarInfo: _propTypes2['default'].func,
  hideKeyboardShortcutsPanel: _propTypes2['default'].bool,

  // navigation related props
  navPrev: _propTypes2['default'].node,
  navNext: _propTypes2['default'].node,
  onPrevMonthClick: _propTypes2['default'].func,
  onNextMonthClick: _propTypes2['default'].func,

  // day presentation and interaction related props
  renderDay: _propTypes2['default'].func,
  minimumNights: _propTypes2['default'].number,
  enableOutsideDays: _propTypes2['default'].bool,
  isDayBlocked: _propTypes2['default'].func,
  isOutsideRange: _propTypes2['default'].func,
  isDayHighlighted: _propTypes2['default'].func,

  // internationalization props
  displayFormat: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].func]),
  monthFormat: _propTypes2['default'].string,
  weekDayFormat: _propTypes2['default'].string,
  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DateRangePickerPhrases))
};

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var af = moment.defineLocale('af', {
        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM : function (input) {
            return /^nm$/i.test(input);
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Vandag om] LT',
            nextDay : '[Môre om] LT',
            nextWeek : 'dddd [om] LT',
            lastDay : '[Gister om] LT',
            lastWeek : '[Laas] dddd [om] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'oor %s',
            past : '%s gelede',
            s : '\'n paar sekondes',
            ss : '%d sekondes',
            m : '\'n minuut',
            mm : '%d minute',
            h : '\'n uur',
            hh : '%d ure',
            d : '\'n dag',
            dd : '%d dae',
            M : '\'n maand',
            MM : '%d maande',
            y : '\'n jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week : {
            dow : 1, // Maandag is die eerste dag van die week.
            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        }
    });

    return af;

})));


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    }, numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    }, pluralForm = function (n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    }, plurals = {
        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
    }, pluralize = function (u) {
        return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];
            if (f === 2) {
                str = str[withoutSuffix ? 0 : 1];
            }
            return str.replace(/%d/i, number);
        };
    }, months = [
        'يناير',
        'فبراير',
        'مارس',
        'أبريل',
        'مايو',
        'يونيو',
        'يوليو',
        'أغسطس',
        'سبتمبر',
        'أكتوبر',
        'نوفمبر',
        'ديسمبر'
    ];

    var ar = moment.defineLocale('ar', {
        months : months,
        monthsShort : months,
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/\u200FM/\u200FYYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'بعد %s',
            past : 'منذ %s',
            s : pluralize('s'),
            ss : pluralize('s'),
            m : pluralize('m'),
            mm : pluralize('m'),
            h : pluralize('h'),
            hh : pluralize('h'),
            d : pluralize('d'),
            dd : pluralize('d'),
            M : pluralize('M'),
            MM : pluralize('M'),
            y : pluralize('y'),
            yy : pluralize('y')
        },
        preparse: function (string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return ar;

})));


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arDz = moment.defineLocale('ar-dz', {
        months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return arDz;

})));


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arKw = moment.defineLocale('ar-kw', {
        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return arKw;

})));


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0'
    }, pluralForm = function (n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    }, plurals = {
        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
    }, pluralize = function (u) {
        return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];
            if (f === 2) {
                str = str[withoutSuffix ? 0 : 1];
            }
            return str.replace(/%d/i, number);
        };
    }, months = [
        'يناير',
        'فبراير',
        'مارس',
        'أبريل',
        'مايو',
        'يونيو',
        'يوليو',
        'أغسطس',
        'سبتمبر',
        'أكتوبر',
        'نوفمبر',
        'ديسمبر'
    ];

    var arLy = moment.defineLocale('ar-ly', {
        months : months,
        monthsShort : months,
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/\u200FM/\u200FYYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'بعد %s',
            past : 'منذ %s',
            s : pluralize('s'),
            ss : pluralize('s'),
            m : pluralize('m'),
            mm : pluralize('m'),
            h : pluralize('h'),
            hh : pluralize('h'),
            d : pluralize('d'),
            dd : pluralize('d'),
            M : pluralize('M'),
            MM : pluralize('M'),
            y : pluralize('y'),
            yy : pluralize('y')
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return arLy;

})));


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arMa = moment.defineLocale('ar-ma', {
        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return arMa;

})));


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    }, numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    };

    var arSa = moment.defineLocale('ar-sa', {
        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        preparse: function (string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return arSa;

})));


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arTn = moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss : '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return arTn;

})));


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı'
    };

    var az = moment.defineLocale('az', {
        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[bugün saat] LT',
            nextDay : '[sabah saat] LT',
            nextWeek : '[gələn həftə] dddd [saat] LT',
            lastDay : '[dünən] LT',
            lastWeek : '[keçən həftə] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s sonra',
            past : '%s əvvəl',
            s : 'birneçə saniyə',
            ss : '%d saniyə',
            m : 'bir dəqiqə',
            mm : '%d dəqiqə',
            h : 'bir saat',
            hh : '%d saat',
            d : 'bir gün',
            dd : '%d gün',
            M : 'bir ay',
            MM : '%d ay',
            y : 'bir il',
            yy : '%d il'
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM : function (input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal : function (number) {
            if (number === 0) {  // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = number % 100 - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return az;

})));


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            'dd': 'дзень_дні_дзён',
            'MM': 'месяц_месяцы_месяцаў',
            'yy': 'год_гады_гадоў'
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        }
        else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    var be = moment.defineLocale('be', {
        months : {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
        },
        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
        weekdays : {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
        },
        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY г.',
            LLL : 'D MMMM YYYY г., HH:mm',
            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
        },
        calendar : {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function () {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'праз %s',
            past : '%s таму',
            s : 'некалькі секунд',
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : relativeTimeWithPlural,
            hh : relativeTimeWithPlural,
            d : 'дзень',
            dd : relativeTimeWithPlural,
            M : 'месяц',
            MM : relativeTimeWithPlural,
            y : 'год',
            yy : relativeTimeWithPlural
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM : function (input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return be;

})));


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var bg = moment.defineLocale('bg', {
        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'D.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay : '[Днес в] LT',
            nextDay : '[Утре в] LT',
            nextWeek : 'dddd [в] LT',
            lastDay : '[Вчера в] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[В изминалата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[В изминалия] dddd [в] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'след %s',
            past : 'преди %s',
            s : 'няколко секунди',
            ss : '%d секунди',
            m : 'минута',
            mm : '%d минути',
            h : 'час',
            hh : '%d часа',
            d : 'ден',
            dd : '%d дни',
            M : 'месец',
            MM : '%d месеца',
            y : 'година',
            yy : '%d години'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal : function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return bg;

})));


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var bm = moment.defineLocale('bm', {
        months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
        monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'MMMM [tile] D [san] YYYY',
            LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
        },
        calendar : {
            sameDay : '[Bi lɛrɛ] LT',
            nextDay : '[Sini lɛrɛ] LT',
            nextWeek : 'dddd [don lɛrɛ] LT',
            lastDay : '[Kunu lɛrɛ] LT',
            lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s kɔnɔ',
            past : 'a bɛ %s bɔ',
            s : 'sanga dama dama',
            ss : 'sekondi %d',
            m : 'miniti kelen',
            mm : 'miniti %d',
            h : 'lɛrɛ kelen',
            hh : 'lɛrɛ %d',
            d : 'tile kelen',
            dd : 'tile %d',
            M : 'kalo kelen',
            MM : 'kalo %d',
            y : 'san kelen',
            yy : 'san %d'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return bm;

})));


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '১',
        '2': '২',
        '3': '৩',
        '4': '৪',
        '5': '৫',
        '6': '৬',
        '7': '৭',
        '8': '৮',
        '9': '৯',
        '0': '০'
    },
    numberMap = {
        '১': '1',
        '২': '2',
        '৩': '3',
        '৪': '4',
        '৫': '5',
        '৬': '6',
        '৭': '7',
        '৮': '8',
        '৯': '9',
        '০': '0'
    };

    var bn = moment.defineLocale('bn', {
        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
        longDateFormat : {
            LT : 'A h:mm সময়',
            LTS : 'A h:mm:ss সময়',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm সময়',
            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
        },
        calendar : {
            sameDay : '[আজ] LT',
            nextDay : '[আগামীকাল] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[গতকাল] LT',
            lastWeek : '[গত] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s পরে',
            past : '%s আগে',
            s : 'কয়েক সেকেন্ড',
            ss : '%d সেকেন্ড',
            m : 'এক মিনিট',
            mm : '%d মিনিট',
            h : 'এক ঘন্টা',
            hh : '%d ঘন্টা',
            d : 'এক দিন',
            dd : '%d দিন',
            M : 'এক মাস',
            MM : '%d মাস',
            y : 'এক বছর',
            yy : '%d বছর'
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'রাত' && hour >= 4) ||
                    (meridiem === 'দুপুর' && hour < 5) ||
                    meridiem === 'বিকাল') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return bn;

})));


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '༡',
        '2': '༢',
        '3': '༣',
        '4': '༤',
        '5': '༥',
        '6': '༦',
        '7': '༧',
        '8': '༨',
        '9': '༩',
        '0': '༠'
    },
    numberMap = {
        '༡': '1',
        '༢': '2',
        '༣': '3',
        '༤': '4',
        '༥': '5',
        '༦': '6',
        '༧': '7',
        '༨': '8',
        '༩': '9',
        '༠': '0'
    };

    var bo = moment.defineLocale('bo', {
        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[དི་རིང] LT',
            nextDay : '[སང་ཉིན] LT',
            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay : '[ཁ་སང] LT',
            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ལ་',
            past : '%s སྔན་ལ',
            s : 'ལམ་སང',
            ss : '%d སྐར་ཆ།',
            m : 'སྐར་མ་གཅིག',
            mm : '%d སྐར་མ',
            h : 'ཆུ་ཚོད་གཅིག',
            hh : '%d ཆུ་ཚོད',
            d : 'ཉིན་གཅིག',
            dd : '%d ཉིན་',
            M : 'ཟླ་བ་གཅིག',
            MM : '%d ཟླ་བ',
            y : 'ལོ་གཅིག',
            yy : '%d ལོ'
        },
        preparse: function (string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
                    meridiem === 'དགོང་དག') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return bo;

})));


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            'mm': 'munutenn',
            'MM': 'miz',
            'dd': 'devezh'
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            'm': 'v',
            'b': 'v',
            'd': 'z'
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var br = moment.defineLocale('br', {
        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h[e]mm A',
            LTS : 'h[e]mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D [a viz] MMMM YYYY',
            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
        },
        calendar : {
            sameDay : '[Hiziv da] LT',
            nextDay : '[Warc\'hoazh da] LT',
            nextWeek : 'dddd [da] LT',
            lastDay : '[Dec\'h da] LT',
            lastWeek : 'dddd [paset da] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'a-benn %s',
            past : '%s \'zo',
            s : 'un nebeud segondennoù',
            ss : '%d eilenn',
            m : 'ur vunutenn',
            mm : relativeTimeWithMutation,
            h : 'un eur',
            hh : '%d eur',
            d : 'un devezh',
            dd : relativeTimeWithMutation,
            M : 'ur miz',
            MM : relativeTimeWithMutation,
            y : 'ur bloaz',
            yy : specialMutationForYears
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal : function (number) {
            var output = (number === 1) ? 'añ' : 'vet';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return br;

})));


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var bs = moment.defineLocale('bs', {
        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danas u] LT',
            nextDay  : '[sutra u] LT',
            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[jučer u] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'par sekundi',
            ss     : translate,
            m      : translate,
            mm     : translate,
            h      : translate,
            hh     : translate,
            d      : 'dan',
            dd     : translate,
            M      : 'mjesec',
            MM     : translate,
            y      : 'godinu',
            yy     : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return bs;

})));


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ca = moment.defineLocale('ca', {
        months : {
            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
            isFormat: /D[oD]?(\s)+MMMM/
        },
        monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
        monthsParseExact : true,
        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM [de] YYYY',
            ll : 'D MMM YYYY',
            LLL : 'D MMMM [de] YYYY [a les] H:mm',
            lll : 'D MMM YYYY, H:mm',
            LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll : 'ddd D MMM YYYY, H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            nextDay : function () {
                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            lastDay : function () {
                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'd\'aquí %s',
            past : 'fa %s',
            s : 'uns segons',
            ss : '%d segons',
            m : 'un minut',
            mm : '%d minuts',
            h : 'una hora',
            hh : '%d hores',
            d : 'un dia',
            dd : '%d dies',
            M : 'un mes',
            MM : '%d mesos',
            y : 'un any',
            yy : '%d anys'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal : function (number, period) {
            var output = (number === 1) ? 'r' :
                (number === 2) ? 'n' :
                (number === 3) ? 'r' :
                (number === 4) ? 't' : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ca;

})));


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');

    var monthsParse = [/^led/i, /^úno/i, /^bře/i, /^dub/i, /^kvě/i, /^(čvn|červen$|června)/i, /^(čvc|červenec|července)/i, /^srp/i, /^zář/i, /^říj/i, /^lis/i, /^pro/i];
    // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
    // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
    var monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

    function plural(n) {
        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':  // a few seconds / in a few seconds / a few seconds ago
                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
                break;
            case 'm':  // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
                break;
            case 'h':  // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
                break;
            case 'd':  // a day / in a day / a day ago
                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
                break;
            case 'M':  // a month / in a month / a month ago
                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
                break;
            case 'y':  // a year / in a year / a year ago
                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
                break;
        }
    }

    var cs = moment.defineLocale('cs', {
        months : months,
        monthsShort : monthsShort,
        monthsRegex : monthsRegex,
        monthsShortRegex : monthsRegex,
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsStrictRegex : /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex : /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,
        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat : {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd D. MMMM YYYY H:mm',
            l : 'D. M. YYYY'
        },
        calendar : {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : 'před %s',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse : /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return cs;

})));


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var cv = moment.defineLocale('cv', {
        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
        },
        calendar : {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L'
        },
        relativeTime : {
            future : function (output) {
                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
                return output + affix;
            },
            past : '%s каялла',
            s : 'пӗр-ик ҫеккунт',
            ss : '%d ҫеккунт',
            m : 'пӗр минут',
            mm : '%d минут',
            h : 'пӗр сехет',
            hh : '%d сехет',
            d : 'пӗр кун',
            dd : '%d кун',
            M : 'пӗр уйӑх',
            MM : '%d уйӑх',
            y : 'пӗр ҫул',
            yy : '%d ҫул'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal : '%d-мӗш',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return cv;

})));


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var cy = moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact : true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS : 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
                ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return cy;

})));


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var da = moment.defineLocale('da', {
        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay : '[i dag kl.] LT',
            nextDay : '[i morgen kl.] LT',
            nextWeek : 'på dddd [kl.] LT',
            lastDay : '[i går kl.] LT',
            lastWeek : '[i] dddd[s kl.] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s siden',
            s : 'få sekunder',
            ss : '%d sekunder',
            m : 'et minut',
            mm : '%d minutter',
            h : 'en time',
            hh : '%d timer',
            d : 'en dag',
            dd : '%d dage',
            M : 'en måned',
            MM : '%d måneder',
            y : 'et år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return da;

})));


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return de;

})));


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deAt = moment.defineLocale('de-at', {
        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return deAt;

})));


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deCh = moment.defineLocale('de-ch', {
        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return deCh;

})));


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'ޖެނުއަރީ',
        'ފެބްރުއަރީ',
        'މާރިޗު',
        'އޭޕްރީލު',
        'މޭ',
        'ޖޫން',
        'ޖުލައި',
        'އޯގަސްޓު',
        'ސެޕްޓެމްބަރު',
        'އޮކްޓޯބަރު',
        'ނޮވެމްބަރު',
        'ޑިސެމްބަރު'
    ], weekdays = [
        'އާދިއްތަ',
        'ހޯމަ',
        'އަންގާރަ',
        'ބުދަ',
        'ބުރާސްފަތި',
        'ހުކުރު',
        'ހޮނިހިރު'
    ];

    var dv = moment.defineLocale('dv', {
        months : months,
        monthsShort : months,
        weekdays : weekdays,
        weekdaysShort : weekdays,
        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat : {

            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/M/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /މކ|މފ/,
        isPM : function (input) {
            return 'މފ' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar : {
            sameDay : '[މިއަދު] LT',
            nextDay : '[މާދަމާ] LT',
            nextWeek : 'dddd LT',
            lastDay : '[އިއްޔެ] LT',
            lastWeek : '[ފާއިތުވި] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ތެރޭގައި %s',
            past : 'ކުރިން %s',
            s : 'ސިކުންތުކޮޅެއް',
            ss : 'd% ސިކުންތު',
            m : 'މިނިޓެއް',
            mm : 'މިނިޓު %d',
            h : 'ގަޑިއިރެއް',
            hh : 'ގަޑިއިރު %d',
            d : 'ދުވަހެއް',
            dd : 'ދުވަސް %d',
            M : 'މަހެއް',
            MM : 'މަސް %d',
            y : 'އަހަރެއް',
            yy : 'އަހަރު %d'
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week : {
            dow : 7,  // Sunday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return dv;

})));


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }


    var el = moment.defineLocale('el', {
        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
        months : function (momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM : function (input) {
            return ((input + '').toLowerCase()[0] === 'μ');
        },
        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendarEl : {
            sameDay : '[Σήμερα {}] LT',
            nextDay : '[Αύριο {}] LT',
            nextWeek : 'dddd [{}] LT',
            lastDay : '[Χθες {}] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse : 'L'
        },
        calendar : function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
        },
        relativeTime : {
            future : 'σε %s',
            past : '%s πριν',
            s : 'λίγα δευτερόλεπτα',
            ss : '%d δευτερόλεπτα',
            m : 'ένα λεπτό',
            mm : '%d λεπτά',
            h : 'μία ώρα',
            hh : '%d ώρες',
            d : 'μία μέρα',
            dd : '%d μέρες',
            M : 'ένας μήνας',
            MM : '%d μήνες',
            y : 'ένας χρόνος',
            yy : '%d χρόνια'
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4st is the first week of the year.
        }
    });

    return el;

})));


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enSG = moment.defineLocale('en-SG', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enSG;

})));


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enAu = moment.defineLocale('en-au', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enAu;

})));


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enCa = moment.defineLocale('en-ca', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'YYYY-MM-DD',
            LL : 'MMMM D, YYYY',
            LLL : 'MMMM D, YYYY h:mm A',
            LLLL : 'dddd, MMMM D, YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    return enCa;

})));


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enGb = moment.defineLocale('en-gb', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enGb;

})));


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enIe = moment.defineLocale('en-ie', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enIe;

})));


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enIl = moment.defineLocale('en-il', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    return enIl;

})));


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enNz = moment.defineLocale('en-nz', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enNz;

})));


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var eo = moment.defineLocale('eo', {
        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
        weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D[-a de] MMMM, YYYY',
            LLL : 'D[-a de] MMMM, YYYY HH:mm',
            LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function (input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar : {
            sameDay : '[Hodiaŭ je] LT',
            nextDay : '[Morgaŭ je] LT',
            nextWeek : 'dddd [je] LT',
            lastDay : '[Hieraŭ je] LT',
            lastWeek : '[pasinta] dddd [je] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'post %s',
            past : 'antaŭ %s',
            s : 'sekundoj',
            ss : '%d sekundoj',
            m : 'minuto',
            mm : '%d minutoj',
            h : 'horo',
            hh : '%d horoj',
            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
            dd : '%d tagoj',
            M : 'monato',
            MM : '%d monatoj',
            y : 'jaro',
            yy : '%d jaroj'
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal : '%da',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return eo;

})));


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex : monthsRegex,
        monthsShortRegex : monthsRegex,
        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY H:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return es;

})));


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esDo = moment.defineLocale('es-do', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY h:mm A',
            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return esDo;

})));


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esUs = moment.defineLocale('es-us', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'MM/DD/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY h:mm A',
            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return esUs;

})));


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            'ss': [number + 'sekundi', number + 'sekundit'],
            'm' : ['ühe minuti', 'üks minut'],
            'mm': [number + ' minuti', number + ' minutit'],
            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
            'hh': [number + ' tunni', number + ' tundi'],
            'd' : ['ühe päeva', 'üks päev'],
            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
            'MM': [number + ' kuu', number + ' kuud'],
            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
            'yy': [number + ' aasta', number + ' aastat']
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    var et = moment.defineLocale('et', {
        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat : {
            LT   : 'H:mm',
            LTS : 'H:mm:ss',
            L    : 'DD.MM.YYYY',
            LL   : 'D. MMMM YYYY',
            LLL  : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[Täna,] LT',
            nextDay  : '[Homme,] LT',
            nextWeek : '[Järgmine] dddd LT',
            lastDay  : '[Eile,] LT',
            lastWeek : '[Eelmine] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s pärast',
            past   : '%s tagasi',
            s      : processRelativeTime,
            ss     : processRelativeTime,
            m      : processRelativeTime,
            mm     : processRelativeTime,
            h      : processRelativeTime,
            hh     : processRelativeTime,
            d      : processRelativeTime,
            dd     : '%d päeva',
            M      : processRelativeTime,
            MM     : processRelativeTime,
            y      : processRelativeTime,
            yy     : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return et;

})));


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var eu = moment.defineLocale('eu', {
        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
        monthsParseExact : true,
        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY[ko] MMMM[ren] D[a]',
            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l : 'YYYY-M-D',
            ll : 'YYYY[ko] MMM D[a]',
            lll : 'YYYY[ko] MMM D[a] HH:mm',
            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
        },
        calendar : {
            sameDay : '[gaur] LT[etan]',
            nextDay : '[bihar] LT[etan]',
            nextWeek : 'dddd LT[etan]',
            lastDay : '[atzo] LT[etan]',
            lastWeek : '[aurreko] dddd LT[etan]',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s barru',
            past : 'duela %s',
            s : 'segundo batzuk',
            ss : '%d segundo',
            m : 'minutu bat',
            mm : '%d minutu',
            h : 'ordu bat',
            hh : '%d ordu',
            d : 'egun bat',
            dd : '%d egun',
            M : 'hilabete bat',
            MM : '%d hilabete',
            y : 'urte bat',
            yy : '%d urte'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return eu;

})));


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '۱',
        '2': '۲',
        '3': '۳',
        '4': '۴',
        '5': '۵',
        '6': '۶',
        '7': '۷',
        '8': '۸',
        '9': '۹',
        '0': '۰'
    }, numberMap = {
        '۱': '1',
        '۲': '2',
        '۳': '3',
        '۴': '4',
        '۵': '5',
        '۶': '6',
        '۷': '7',
        '۸': '8',
        '۹': '9',
        '۰': '0'
    };

    var fa = moment.defineLocale('fa', {
        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function (input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar : {
            sameDay : '[امروز ساعت] LT',
            nextDay : '[فردا ساعت] LT',
            nextWeek : 'dddd [ساعت] LT',
            lastDay : '[دیروز ساعت] LT',
            lastWeek : 'dddd [پیش] [ساعت] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'در %s',
            past : '%s پیش',
            s : 'چند ثانیه',
            ss : 'ثانیه d%',
            m : 'یک دقیقه',
            mm : '%d دقیقه',
            h : 'یک ساعت',
            hh : '%d ساعت',
            d : 'یک روز',
            dd : '%d روز',
            M : 'یک ماه',
            MM : '%d ماه',
            y : 'یک سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/[۰-۹]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal : '%dم',
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12 // The week that contains Jan 12th is the first week of the year.
        }
    });

    return fa;

})));


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
        numbersFuture = [
            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
            numbersPast[7], numbersPast[8], numbersPast[9]
        ];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                return isFuture ? 'sekunnin' : 'sekuntia';
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
    }

    var fi = moment.defineLocale('fi', {
        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD.MM.YYYY',
            LL : 'Do MMMM[ta] YYYY',
            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l : 'D.M.YYYY',
            ll : 'Do MMM YYYY',
            lll : 'Do MMM YYYY, [klo] HH.mm',
            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
        },
        calendar : {
            sameDay : '[tänään] [klo] LT',
            nextDay : '[huomenna] [klo] LT',
            nextWeek : 'dddd [klo] LT',
            lastDay : '[eilen] [klo] LT',
            lastWeek : '[viime] dddd[na] [klo] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s päästä',
            past : '%s sitten',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fi;

})));


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var fo = moment.defineLocale('fo', {
        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D. MMMM, YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Í dag kl.] LT',
            nextDay : '[Í morgin kl.] LT',
            nextWeek : 'dddd [kl.] LT',
            lastDay : '[Í gjár kl.] LT',
            lastWeek : '[síðstu] dddd [kl] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'um %s',
            past : '%s síðani',
            s : 'fá sekund',
            ss : '%d sekundir',
            m : 'ein minuttur',
            mm : '%d minuttir',
            h : 'ein tími',
            hh : '%d tímar',
            d : 'ein dagur',
            dd : '%d dagar',
            M : 'ein mánaður',
            MM : '%d mánaðir',
            y : 'eitt ár',
            yy : '%d ár'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fo;

})));


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var fr = moment.defineLocale('fr', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal : function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fr;

})));


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var frCa = moment.defineLocale('fr-ca', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal : function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        }
    });

    return frCa;

})));


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var frCh = moment.defineLocale('fr-ch', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal : function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return frCh;

})));


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

    var fy = moment.defineLocale('fy', {
        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact : true,
        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'oer %s',
            past : '%s lyn',
            s : 'in pear sekonden',
            ss : '%d sekonden',
            m : 'ien minút',
            mm : '%d minuten',
            h : 'ien oere',
            hh : '%d oeren',
            d : 'ien dei',
            dd : '%d dagen',
            M : 'ien moanne',
            MM : '%d moannen',
            y : 'ien jier',
            yy : '%d jierren'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fy;

})));


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



    var months = [
        'Eanáir', 'Feabhra', 'Márta', 'Aibreán', 'Bealtaine', 'Méitheamh', 'Iúil', 'Lúnasa', 'Meán Fómhair', 'Deaireadh Fómhair', 'Samhain', 'Nollaig'
    ];

    var monthsShort = ['Eaná', 'Feab', 'Márt', 'Aibr', 'Beal', 'Méit', 'Iúil', 'Lúna', 'Meán', 'Deai', 'Samh', 'Noll'];

    var weekdays = ['Dé Domhnaigh', 'Dé Luain', 'Dé Máirt', 'Dé Céadaoin', 'Déardaoin', 'Dé hAoine', 'Dé Satharn'];

    var weekdaysShort = ['Dom', 'Lua', 'Mái', 'Céa', 'Déa', 'hAo', 'Sat'];

    var weekdaysMin = ['Do', 'Lu', 'Má', 'Ce', 'Dé', 'hA', 'Sa'];

    var ga = moment.defineLocale('ga', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Inniu ag] LT',
            nextDay: '[Amárach ag] LT',
            nextWeek: 'dddd [ag] LT',
            lastDay: '[Inné aig] LT',
            lastWeek: 'dddd [seo caite] [ag] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'i %s',
            past: '%s ó shin',
            s: 'cúpla soicind',
            ss: '%d soicind',
            m: 'nóiméad',
            mm: '%d nóiméad',
            h: 'uair an chloig',
            hh: '%d uair an chloig',
            d: 'lá',
            dd: '%d lá',
            M: 'mí',
            MM: '%d mí',
            y: 'bliain',
            yy: '%d bliain'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ga;

})));


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
    ];

    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];

    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];

    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];

    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    var gd = moment.defineLocale('gd', {
        months : months,
        monthsShort : monthsShort,
        monthsParseExact : true,
        weekdays : weekdays,
        weekdaysShort : weekdaysShort,
        weekdaysMin : weekdaysMin,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[An-diugh aig] LT',
            nextDay : '[A-màireach aig] LT',
            nextWeek : 'dddd [aig] LT',
            lastDay : '[An-dè aig] LT',
            lastWeek : 'dddd [seo chaidh] [aig] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ann an %s',
            past : 'bho chionn %s',
            s : 'beagan diogan',
            ss : '%d diogan',
            m : 'mionaid',
            mm : '%d mionaidean',
            h : 'uair',
            hh : '%d uairean',
            d : 'latha',
            dd : '%d latha',
            M : 'mìos',
            MM : '%d mìosan',
            y : 'bliadhna',
            yy : '%d bliadhna'
        },
        dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
        ordinal : function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return gd;

})));


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var gl = moment.defineLocale('gl', {
        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY H:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
            },
            nextDay : function () {
                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
            },
            lastDay : function () {
                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
            },
            lastWeek : function () {
                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : function (str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past : 'hai %s',
            s : 'uns segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'unha hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return gl;

})));


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's': ['thodde secondanim', 'thodde second'],
            'ss': [number + ' secondanim', number + ' second'],
            'm': ['eka mintan', 'ek minute'],
            'mm': [number + ' mintanim', number + ' mintam'],
            'h': ['eka voran', 'ek vor'],
            'hh': [number + ' voranim', number + ' voram'],
            'd': ['eka disan', 'ek dis'],
            'dd': [number + ' disanim', number + ' dis'],
            'M': ['eka mhoinean', 'ek mhoino'],
            'MM': [number + ' mhoineanim', number + ' mhoine'],
            'y': ['eka vorsan', 'ek voros'],
            'yy': [number + ' vorsanim', number + ' vorsam']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var gomLatn = moment.defineLocale('gom-latn', {
        months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
        monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
        weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'A h:mm [vazta]',
            LTS : 'A h:mm:ss [vazta]',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY A h:mm [vazta]',
            LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
        },
        calendar : {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Ieta to] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fatlo] dddd[,] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s',
            past : '%s adim',
            s : processRelativeTime,
            ss : processRelativeTime,
            m : processRelativeTime,
            mm : processRelativeTime,
            h : processRelativeTime,
            hh : processRelativeTime,
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse : /\d{1,2}(er)/,
        ordinal : function (number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /rati|sokalli|donparam|sanje/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokalli') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokalli';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        }
    });

    return gomLatn;

})));


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
            '1': '૧',
            '2': '૨',
            '3': '૩',
            '4': '૪',
            '5': '૫',
            '6': '૬',
            '7': '૭',
            '8': '૮',
            '9': '૯',
            '0': '૦'
        },
        numberMap = {
            '૧': '1',
            '૨': '2',
            '૩': '3',
            '૪': '4',
            '૫': '5',
            '૬': '6',
            '૭': '7',
            '૮': '8',
            '૯': '9',
            '૦': '0'
        };

    var gu = moment.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પેહલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ'
        },
        preparse: function (string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.
        }
    });

    return gu;

})));


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var he = moment.defineLocale('he', {
        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [ב]MMMM YYYY',
            LLL : 'D [ב]MMMM YYYY HH:mm',
            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
            l : 'D/M/YYYY',
            ll : 'D MMM YYYY',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd, D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[היום ב־]LT',
            nextDay : '[מחר ב־]LT',
            nextWeek : 'dddd [בשעה] LT',
            lastDay : '[אתמול ב־]LT',
            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'בעוד %s',
            past : 'לפני %s',
            s : 'מספר שניות',
            ss : '%d שניות',
            m : 'דקה',
            mm : '%d דקות',
            h : 'שעה',
            hh : function (number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d : 'יום',
            dd : function (number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M : 'חודש',
            MM : function (number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y : 'שנה',
            yy : function (number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            }
        },
        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM : function (input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        }
    });

    return he;

})));


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    var hi = moment.defineLocale('hi', {
        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
        monthsParseExact: true,
        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat : {
            LT : 'A h:mm बजे',
            LTS : 'A h:mm:ss बजे',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm बजे',
            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[कल] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[कल] LT',
            lastWeek : '[पिछले] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s में',
            past : '%s पहले',
            s : 'कुछ ही क्षण',
            ss : '%d सेकंड',
            m : 'एक मिनट',
            mm : '%d मिनट',
            h : 'एक घंटा',
            hh : '%d घंटे',
            d : 'एक दिन',
            dd : '%d दिन',
            M : 'एक महीने',
            MM : '%d महीने',
            y : 'एक वर्ष',
            yy : '%d वर्ष'
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return hi;

})));


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months : {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
        },
        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danas u] LT',
            nextDay  : '[sutra u] LT',
            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[jučer u] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'par sekundi',
            ss     : translate,
            m      : translate,
            mm     : translate,
            h      : translate,
            hh     : translate,
            d      : 'dan',
            dd     : translate,
            M      : 'mjesec',
            MM     : translate,
            y      : 'godinu',
            yy     : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return hr;

})));


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
    }

    var hu = moment.defineLocale('hu', {
        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'YYYY.MM.DD.',
            LL : 'YYYY. MMMM D.',
            LLL : 'YYYY. MMMM D. H:mm',
            LLLL : 'YYYY. MMMM D., dddd H:mm'
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar : {
            sameDay : '[ma] LT[-kor]',
            nextDay : '[holnap] LT[-kor]',
            nextWeek : function () {
                return week.call(this, true);
            },
            lastDay : '[tegnap] LT[-kor]',
            lastWeek : function () {
                return week.call(this, false);
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s múlva',
            past : '%s',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return hu;

})));


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var hyAm = moment.defineLocale('hy-am', {
        months : {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
        },
        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY թ.',
            LLL : 'D MMMM YYYY թ., HH:mm',
            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
        },
        calendar : {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s հետո',
            past : '%s առաջ',
            s : 'մի քանի վայրկյան',
            ss : '%d վայրկյան',
            m : 'րոպե',
            mm : '%d րոպե',
            h : 'ժամ',
            hh : '%d ժամ',
            d : 'օր',
            dd : '%d օր',
            M : 'ամիս',
            MM : '%d ամիս',
            y : 'տարի',
            yy : '%d տարի'
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function (input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem : function (hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return hyAm;

})));


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var id = moment.defineLocale('id', {
        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Besok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kemarin pukul] LT',
            lastWeek : 'dddd [lalu pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lalu',
            s : 'beberapa detik',
            ss : '%d detik',
            m : 'semenit',
            mm : '%d menit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return id;

})));


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
            case 'ss':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    var is = moment.defineLocale('is', {
        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] H:mm',
            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
        },
        calendar : {
            sameDay : '[í dag kl.] LT',
            nextDay : '[á morgun kl.] LT',
            nextWeek : 'dddd [kl.] LT',
            lastDay : '[í gær kl.] LT',
            lastWeek : '[síðasta] dddd [kl.] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'eftir %s',
            past : 'fyrir %s síðan',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : 'klukkustund',
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return is;

})));


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var it = moment.defineLocale('it', {
        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : function (s) {
                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past : '%s fa',
            s : 'alcuni secondi',
            ss : '%d secondi',
            m : 'un minuto',
            mm : '%d minuti',
            h : 'un\'ora',
            hh : '%d ore',
            d : 'un giorno',
            dd : '%d giorni',
            M : 'un mese',
            MM : '%d mesi',
            y : 'un anno',
            yy : '%d anni'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return it;

})));


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var itCh = moment.defineLocale('it-ch', {
        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : function (s) {
                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past : '%s fa',
            s : 'alcuni secondi',
            ss : '%d secondi',
            m : 'un minuto',
            mm : '%d minuti',
            h : 'un\'ora',
            hh : '%d ore',
            d : 'un giorno',
            dd : '%d giorni',
            M : 'un mese',
            MM : '%d mesi',
            y : 'un anno',
            yy : '%d anni'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return itCh;

})));


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ja = moment.defineLocale('ja', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日 dddd HH:mm',
            l : 'YYYY/MM/DD',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日(ddd) HH:mm'
        },
        meridiemParse: /午前|午後/i,
        isPM : function (input) {
            return input === '午後';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar : {
            sameDay : '[今日] LT',
            nextDay : '[明日] LT',
            nextWeek : function (now) {
                if (now.week() < this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay : '[昨日] LT',
            lastWeek : function (now) {
                if (this.week() < now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse : /\d{1,2}日/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime : {
            future : '%s後',
            past : '%s前',
            s : '数秒',
            ss : '%d秒',
            m : '1分',
            mm : '%d分',
            h : '1時間',
            hh : '%d時間',
            d : '1日',
            dd : '%d日',
            M : '1ヶ月',
            MM : '%dヶ月',
            y : '1年',
            yy : '%d年'
        }
    });

    return ja;

})));


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var jv = moment.defineLocale('jv', {
        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar : {
            sameDay : '[Dinten puniko pukul] LT',
            nextDay : '[Mbenjang pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kala wingi pukul] LT',
            lastWeek : 'dddd [kepengker pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'wonten ing %s',
            past : '%s ingkang kepengker',
            s : 'sawetawis detik',
            ss : '%d detik',
            m : 'setunggal menit',
            mm : '%d menit',
            h : 'setunggal jam',
            hh : '%d jam',
            d : 'sedinten',
            dd : '%d dinten',
            M : 'sewulan',
            MM : '%d wulan',
            y : 'setaun',
            yy : '%d taun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return jv;

})));


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ka = moment.defineLocale('ka', {
        months : {
            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
        },
        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays : {
            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
            isFormat: /(წინა|შემდეგ)/
        },
        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[დღეს] LT[-ზე]',
            nextDay : '[ხვალ] LT[-ზე]',
            lastDay : '[გუშინ] LT[-ზე]',
            nextWeek : '[შემდეგ] dddd LT[-ზე]',
            lastWeek : '[წინა] dddd LT-ზე',
            sameElse : 'L'
        },
        relativeTime : {
            future : function (s) {
                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
                    s.replace(/ი$/, 'ში') :
                    s + 'ში';
            },
            past : function (s) {
                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if ((/წელი/).test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
            },
            s : 'რამდენიმე წამი',
            ss : '%d წამი',
            m : 'წუთი',
            mm : '%d წუთი',
            h : 'საათი',
            hh : '%d საათი',
            d : 'დღე',
            dd : '%d დღე',
            M : 'თვე',
            MM : '%d თვე',
            y : 'წელი',
            yy : '%d წელი'
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal : function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week : {
            dow : 1,
            doy : 7
        }
    });

    return ka;

})));


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші'
    };

    var kk = moment.defineLocale('kk', {
        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Бүгін сағат] LT',
            nextDay : '[Ертең сағат] LT',
            nextWeek : 'dddd [сағат] LT',
            lastDay : '[Кеше сағат] LT',
            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ішінде',
            past : '%s бұрын',
            s : 'бірнеше секунд',
            ss : '%d секунд',
            m : 'бір минут',
            mm : '%d минут',
            h : 'бір сағат',
            hh : '%d сағат',
            d : 'бір күн',
            dd : '%d күн',
            M : 'бір ай',
            MM : '%d ай',
            y : 'бір жыл',
            yy : '%d жыл'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal : function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return kk;

})));


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '១',
        '2': '២',
        '3': '៣',
        '4': '៤',
        '5': '៥',
        '6': '៦',
        '7': '៧',
        '8': '៨',
        '9': '៩',
        '0': '០'
    }, numberMap = {
        '១': '1',
        '២': '2',
        '៣': '3',
        '៤': '4',
        '៥': '5',
        '៦': '6',
        '៧': '7',
        '៨': '8',
        '៩': '9',
        '០': '0'
    };

    var km = moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function (input) {
            return input === 'ល្ងាច';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ'
        },
        dayOfMonthOrdinalParse : /ទី\d{1,2}/,
        ordinal : 'ទី%d',
        preparse: function (string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return km;

})));


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '೧',
        '2': '೨',
        '3': '೩',
        '4': '೪',
        '5': '೫',
        '6': '೬',
        '7': '೭',
        '8': '೮',
        '9': '೯',
        '0': '೦'
    },
    numberMap = {
        '೧': '1',
        '೨': '2',
        '೩': '3',
        '೪': '4',
        '೫': '5',
        '೬': '6',
        '೭': '7',
        '೮': '8',
        '೯': '9',
        '೦': '0'
    };

    var kn = moment.defineLocale('kn', {
        months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
        monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
        monthsParseExact: true,
        weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
        weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[ಇಂದು] LT',
            nextDay : '[ನಾಳೆ] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[ನಿನ್ನೆ] LT',
            lastWeek : '[ಕೊನೆಯ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ನಂತರ',
            past : '%s ಹಿಂದೆ',
            s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss : '%d ಸೆಕೆಂಡುಗಳು',
            m : 'ಒಂದು ನಿಮಿಷ',
            mm : '%d ನಿಮಿಷ',
            h : 'ಒಂದು ಗಂಟೆ',
            hh : '%d ಗಂಟೆ',
            d : 'ಒಂದು ದಿನ',
            dd : '%d ದಿನ',
            M : 'ಒಂದು ತಿಂಗಳು',
            MM : '%d ತಿಂಗಳು',
            y : 'ಒಂದು ವರ್ಷ',
            yy : '%d ವರ್ಷ'
        },
        preparse: function (string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal : function (number) {
            return number + 'ನೇ';
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return kn;

})));


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ko = moment.defineLocale('ko', {
        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'YYYY.MM.DD.',
            LL : 'YYYY년 MMMM D일',
            LLL : 'YYYY년 MMMM D일 A h:mm',
            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
            l : 'YYYY.MM.DD.',
            ll : 'YYYY년 MMMM D일',
            lll : 'YYYY년 MMMM D일 A h:mm',
            llll : 'YYYY년 MMMM D일 dddd A h:mm'
        },
        calendar : {
            sameDay : '오늘 LT',
            nextDay : '내일 LT',
            nextWeek : 'dddd LT',
            lastDay : '어제 LT',
            lastWeek : '지난주 dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s 후',
            past : '%s 전',
            s : '몇 초',
            ss : '%d초',
            m : '1분',
            mm : '%d분',
            h : '한 시간',
            hh : '%d시간',
            d : '하루',
            dd : '%d일',
            M : '한 달',
            MM : '%d달',
            y : '일 년',
            yy : '%d년'
        },
        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse : /오전|오후/,
        isPM : function (token) {
            return token === '오후';
        },
        meridiem : function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        }
    });

    return ko;

})));


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    }, numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    },
    months = [
        'کانونی دووەم',
        'شوبات',
        'ئازار',
        'نیسان',
        'ئایار',
        'حوزەیران',
        'تەمموز',
        'ئاب',
        'ئەیلوول',
        'تشرینی یەكەم',
        'تشرینی دووەم',
        'كانونی یەکەم'
    ];


    var ku = moment.defineLocale('ku', {
        months : months,
        monthsShort : months,
        weekdays : 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split('_'),
        weekdaysShort : 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
        weekdaysMin : 'ی_د_س_چ_پ_ه_ش'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /ئێواره‌|به‌یانی/,
        isPM: function (input) {
            return /ئێواره‌/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'به‌یانی';
            } else {
                return 'ئێواره‌';
            }
        },
        calendar : {
            sameDay : '[ئه‌مرۆ كاتژمێر] LT',
            nextDay : '[به‌یانی كاتژمێر] LT',
            nextWeek : 'dddd [كاتژمێر] LT',
            lastDay : '[دوێنێ كاتژمێر] LT',
            lastWeek : 'dddd [كاتژمێر] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'له‌ %s',
            past : '%s',
            s : 'چه‌ند چركه‌یه‌ك',
            ss : 'چركه‌ %d',
            m : 'یه‌ك خوله‌ك',
            mm : '%d خوله‌ك',
            h : 'یه‌ك كاتژمێر',
            hh : '%d كاتژمێر',
            d : 'یه‌ك ڕۆژ',
            dd : '%d ڕۆژ',
            M : 'یه‌ك مانگ',
            MM : '%d مانگ',
            y : 'یه‌ك ساڵ',
            yy : '%d ساڵ'
        },
        preparse: function (string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12 // The week that contains Jan 12th is the first week of the year.
        }
    });

    return ku;

})));


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү'
    };

    var ky = moment.defineLocale('ky', {
        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Бүгүн саат] LT',
            nextDay : '[Эртең саат] LT',
            nextWeek : 'dddd [саат] LT',
            lastDay : '[Кечээ саат] LT',
            lastWeek : '[Өткөн аптанын] dddd [күнү] [саат] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ичинде',
            past : '%s мурун',
            s : 'бирнече секунд',
            ss : '%d секунд',
            m : 'бир мүнөт',
            mm : '%d мүнөт',
            h : 'бир саат',
            hh : '%d саат',
            d : 'бир күн',
            dd : '%d күн',
            M : 'бир ай',
            MM : '%d ай',
            y : 'бир жыл',
            yy : '%d жыл'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal : function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return ky;

})));


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eng Minutt', 'enger Minutt'],
            'h': ['eng Stonn', 'enger Stonn'],
            'd': ['een Dag', 'engem Dag'],
            'M': ['ee Mount', 'engem Mount'],
            'y': ['ee Joer', 'engem Joer']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10, firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    var lb = moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function () {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            }
        },
        relativeTime : {
            future : processFutureTime,
            past : processPastTime,
            s : 'e puer Sekonnen',
            ss : '%d Sekonnen',
            m : processRelativeTime,
            mm : '%d Minutten',
            h : processRelativeTime,
            hh : '%d Stonnen',
            d : processRelativeTime,
            dd : '%d Deeg',
            M : processRelativeTime,
            MM : '%d Méint',
            y : processRelativeTime,
            yy : '%d Joer'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lb;

})));


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var lo = moment.defineLocale('lo', {
        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function (input) {
            return input === 'ຕອນແລງ';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar : {
            sameDay : '[ມື້ນີ້ເວລາ] LT',
            nextDay : '[ມື້ອື່ນເວລາ] LT',
            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ອີກ %s',
            past : '%sຜ່ານມາ',
            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss : '%d ວິນາທີ' ,
            m : '1 ນາທີ',
            mm : '%d ນາທີ',
            h : '1 ຊົ່ວໂມງ',
            hh : '%d ຊົ່ວໂມງ',
            d : '1 ມື້',
            dd : '%d ມື້',
            M : '1 ເດືອນ',
            MM : '%d ເດືອນ',
            y : '1 ປີ',
            yy : '%d ປີ'
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal : function (number) {
            return 'ທີ່' + number;
        }
    });

    return lo;

})));


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var units = {
        'ss' : 'sekundė_sekundžių_sekundes',
        'm' : 'minutė_minutės_minutę',
        'mm': 'minutės_minučių_minutes',
        'h' : 'valanda_valandos_valandą',
        'hh': 'valandos_valandų_valandas',
        'd' : 'diena_dienos_dieną',
        'dd': 'dienos_dienų_dienas',
        'M' : 'mėnuo_mėnesio_mėnesį',
        'MM': 'mėnesiai_mėnesių_mėnesius',
        'y' : 'metai_metų_metus',
        'yy': 'metai_metų_metus'
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
    }
    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    var lt = moment.defineLocale('lt', {
        months : {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
        },
        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays : {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
            isFormat: /dddd HH:mm/
        },
        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY [m.] MMMM D [d.]',
            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l : 'YYYY-MM-DD',
            ll : 'YYYY [m.] MMMM D [d.]',
            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
        },
        calendar : {
            sameDay : '[Šiandien] LT',
            nextDay : '[Rytoj] LT',
            nextWeek : 'dddd LT',
            lastDay : '[Vakar] LT',
            lastWeek : '[Praėjusį] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'po %s',
            past : 'prieš %s',
            s : translateSeconds,
            ss : translate,
            m : translateSingular,
            mm : translate,
            h : translateSingular,
            hh : translate,
            d : translateSingular,
            dd : translate,
            M : translateSingular,
            MM : translate,
            y : translateSingular,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal : function (number) {
            return number + '-oji';
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lt;

})));


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var units = {
        'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        'h': 'stundas_stundām_stunda_stundas'.split('_'),
        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
        'd': 'dienas_dienām_diena_dienas'.split('_'),
        'dd': 'dienas_dienām_diena_dienas'.split('_'),
        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        'y': 'gada_gadiem_gads_gadi'.split('_'),
        'yy': 'gada_gadiem_gads_gadi'.split('_')
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    var lv = moment.defineLocale('lv', {
        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY.',
            LL : 'YYYY. [gada] D. MMMM',
            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
        },
        calendar : {
            sameDay : '[Šodien pulksten] LT',
            nextDay : '[Rīt pulksten] LT',
            nextWeek : 'dddd [pulksten] LT',
            lastDay : '[Vakar pulksten] LT',
            lastWeek : '[Pagājušā] dddd [pulksten] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'pēc %s',
            past : 'pirms %s',
            s : relativeSeconds,
            ss : relativeTimeWithPlural,
            m : relativeTimeWithSingular,
            mm : relativeTimeWithPlural,
            h : relativeTimeWithSingular,
            hh : relativeTimeWithPlural,
            d : relativeTimeWithSingular,
            dd : relativeTimeWithPlural,
            M : relativeTimeWithSingular,
            MM : relativeTimeWithPlural,
            y : relativeTimeWithSingular,
            yy : relativeTimeWithPlural
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lv;

})));


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var translator = {
        words: { //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var me = moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact : true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[juče u] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[prošle] [nedjelje] [u] LT',
                    '[prošlog] [ponedjeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srijede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'nekoliko sekundi',
            ss     : translator.translate,
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'dan',
            dd     : translator.translate,
            M      : 'mjesec',
            MM     : translator.translate,
            y      : 'godinu',
            yy     : translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return me;

})));


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var mi = moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return mi;

})));


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var mk = moment.defineLocale('mk', {
        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'D.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay : '[Денес во] LT',
            nextDay : '[Утре во] LT',
            nextWeek : '[Во] dddd [во] LT',
            lastDay : '[Вчера во] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'после %s',
            past : 'пред %s',
            s : 'неколку секунди',
            ss : '%d секунди',
            m : 'минута',
            mm : '%d минути',
            h : 'час',
            hh : '%d часа',
            d : 'ден',
            dd : '%d дена',
            M : 'месец',
            MM : '%d месеци',
            y : 'година',
            yy : '%d години'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal : function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return mk;

})));


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ml = moment.defineLocale('ml', {
        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
        monthsParseExact : true,
        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm -നു',
            LTS : 'A h:mm:ss -നു',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm -നു',
            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
        },
        calendar : {
            sameDay : '[ഇന്ന്] LT',
            nextDay : '[നാളെ] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[ഇന്നലെ] LT',
            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s കഴിഞ്ഞ്',
            past : '%s മുൻപ്',
            s : 'അൽപ നിമിഷങ്ങൾ',
            ss : '%d സെക്കൻഡ്',
            m : 'ഒരു മിനിറ്റ്',
            mm : '%d മിനിറ്റ്',
            h : 'ഒരു മണിക്കൂർ',
            hh : '%d മണിക്കൂർ',
            d : 'ഒരു ദിവസം',
            dd : '%d ദിവസം',
            M : 'ഒരു മാസം',
            MM : '%d മാസം',
            y : 'ഒരു വർഷം',
            yy : '%d വർഷം'
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'രാത്രി' && hour >= 4) ||
                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                    meridiem === 'വൈകുന്നേരം') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        }
    });

    return ml;

})));


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function translate(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    var mn = moment.defineLocale('mn', {
        months : 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
        monthsShort : '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
        monthsParseExact : true,
        weekdays : 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort : 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin : 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY оны MMMMын D',
            LLL : 'YYYY оны MMMMын D HH:mm',
            LLLL : 'dddd, YYYY оны MMMMын D HH:mm'
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM : function (input) {
            return input === 'ҮХ';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar : {
            sameDay : '[Өнөөдөр] LT',
            nextDay : '[Маргааш] LT',
            nextWeek : '[Ирэх] dddd LT',
            lastDay : '[Өчигдөр] LT',
            lastWeek : '[Өнгөрсөн] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s дараа',
            past : '%s өмнө',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        }
    });

    return mn;

})));


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    function relativeTimeMr(number, withoutSuffix, string, isFuture)
    {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's': output = 'काही सेकंद'; break;
                case 'ss': output = '%d सेकंद'; break;
                case 'm': output = 'एक मिनिट'; break;
                case 'mm': output = '%d मिनिटे'; break;
                case 'h': output = 'एक तास'; break;
                case 'hh': output = '%d तास'; break;
                case 'd': output = 'एक दिवस'; break;
                case 'dd': output = '%d दिवस'; break;
                case 'M': output = 'एक महिना'; break;
                case 'MM': output = '%d महिने'; break;
                case 'y': output = 'एक वर्ष'; break;
                case 'yy': output = '%d वर्षे'; break;
            }
        }
        else {
            switch (string) {
                case 's': output = 'काही सेकंदां'; break;
                case 'ss': output = '%d सेकंदां'; break;
                case 'm': output = 'एका मिनिटा'; break;
                case 'mm': output = '%d मिनिटां'; break;
                case 'h': output = 'एका तासा'; break;
                case 'hh': output = '%d तासां'; break;
                case 'd': output = 'एका दिवसा'; break;
                case 'dd': output = '%d दिवसां'; break;
                case 'M': output = 'एका महिन्या'; break;
                case 'MM': output = '%d महिन्यां'; break;
                case 'y': output = 'एका वर्षा'; break;
                case 'yy': output = '%d वर्षां'; break;
            }
        }
        return output.replace(/%d/i, number);
    }

    var mr = moment.defineLocale('mr', {
        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
        monthsParseExact : true,
        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat : {
            LT : 'A h:mm वाजता',
            LTS : 'A h:mm:ss वाजता',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm वाजता',
            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[उद्या] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात्री') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळी') {
                return hour;
            } else if (meridiem === 'दुपारी') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'सायंकाळी') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात्री';
            } else if (hour < 10) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return mr;

})));


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ms = moment.defineLocale('ms', {
        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Esok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kelmarin pukul] LT',
            lastWeek : 'dddd [lepas pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lepas',
            s : 'beberapa saat',
            ss : '%d saat',
            m : 'seminit',
            mm : '%d minit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return ms;

})));


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var msMy = moment.defineLocale('ms-my', {
        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Esok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kelmarin pukul] LT',
            lastWeek : 'dddd [lepas pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lepas',
            s : 'beberapa saat',
            ss : '%d saat',
            m : 'seminit',
            mm : '%d minit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return msMy;

})));


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var mt = moment.defineLocale('mt', {
        months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
        monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
        weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Illum fil-]LT',
            nextDay : '[Għada fil-]LT',
            nextWeek : 'dddd [fil-]LT',
            lastDay : '[Il-bieraħ fil-]LT',
            lastWeek : 'dddd [li għadda] [fil-]LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'f’ %s',
            past : '%s ilu',
            s : 'ftit sekondi',
            ss : '%d sekondi',
            m : 'minuta',
            mm : '%d minuti',
            h : 'siegħa',
            hh : '%d siegħat',
            d : 'ġurnata',
            dd : '%d ġranet',
            M : 'xahar',
            MM : '%d xhur',
            y : 'sena',
            yy : '%d sni'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return mt;

})));


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '၁',
        '2': '၂',
        '3': '၃',
        '4': '၄',
        '5': '၅',
        '6': '၆',
        '7': '၇',
        '8': '၈',
        '9': '၉',
        '0': '၀'
    }, numberMap = {
        '၁': '1',
        '၂': '2',
        '၃': '3',
        '၄': '4',
        '၅': '5',
        '၆': '6',
        '၇': '7',
        '၈': '8',
        '၉': '9',
        '၀': '0'
    };

    var my = moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss : '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်'
        },
        preparse: function (string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return my;

})));


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var nb = moment.defineLocale('nb', {
        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact : true,
        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] HH:mm',
            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s siden',
            s : 'noen sekunder',
            ss : '%d sekunder',
            m : 'ett minutt',
            mm : '%d minutter',
            h : 'en time',
            hh : '%d timer',
            d : 'en dag',
            dd : '%d dager',
            M : 'en måned',
            MM : '%d måneder',
            y : 'ett år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nb;

})));


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    var ne = moment.defineLocale('ne', {
        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
        monthsParseExact : true,
        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'Aको h:mm बजे',
            LTS : 'Aको h:mm:ss बजे',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, Aको h:mm बजे',
            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[भोलि] LT',
            nextWeek : '[आउँदो] dddd[,] LT',
            lastDay : '[हिजो] LT',
            lastWeek : '[गएको] dddd[,] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%sमा',
            past : '%s अगाडि',
            s : 'केही क्षण',
            ss : '%d सेकेण्ड',
            m : 'एक मिनेट',
            mm : '%d मिनेट',
            h : 'एक घण्टा',
            hh : '%d घण्टा',
            d : 'एक दिन',
            dd : '%d दिन',
            M : 'एक महिना',
            MM : '%d महिना',
            y : 'एक बर्ष',
            yy : '%d बर्ष'
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return ne;

})));


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'over %s',
            past : '%s geleden',
            s : 'een paar seconden',
            ss : '%d seconden',
            m : 'één minuut',
            mm : '%d minuten',
            h : 'één uur',
            hh : '%d uur',
            d : 'één dag',
            dd : '%d dagen',
            M : 'één maand',
            MM : '%d maanden',
            y : 'één jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nl;

})));


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'over %s',
            past : '%s geleden',
            s : 'een paar seconden',
            ss : '%d seconden',
            m : 'één minuut',
            mm : '%d minuten',
            h : 'één uur',
            hh : '%d uur',
            d : 'één dag',
            dd : '%d dagen',
            M : 'één maand',
            MM : '%d maanden',
            y : 'één jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nlBe;

})));


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var nn = moment.defineLocale('nn', {
        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] H:mm',
            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s sidan',
            s : 'nokre sekund',
            ss : '%d sekund',
            m : 'eit minutt',
            mm : '%d minutt',
            h : 'ein time',
            hh : '%d timar',
            d : 'ein dag',
            dd : '%d dagar',
            M : 'ein månad',
            MM : '%d månader',
            y : 'eit år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nn;

})));


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '੧',
        '2': '੨',
        '3': '੩',
        '4': '੪',
        '5': '੫',
        '6': '੬',
        '7': '੭',
        '8': '੮',
        '9': '੯',
        '0': '੦'
    },
    numberMap = {
        '੧': '1',
        '੨': '2',
        '੩': '3',
        '੪': '4',
        '੫': '5',
        '੬': '6',
        '੭': '7',
        '੮': '8',
        '੯': '9',
        '੦': '0'
    };

    var paIn = moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm ਵਜੇ',
            LTS : 'A h:mm:ss ਵਜੇ',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
        },
        calendar : {
            sameDay : '[ਅਜ] LT',
            nextDay : '[ਕਲ] LT',
            nextWeek : '[ਅਗਲਾ] dddd, LT',
            lastDay : '[ਕਲ] LT',
            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ਵਿੱਚ',
            past : '%s ਪਿਛਲੇ',
            s : 'ਕੁਝ ਸਕਿੰਟ',
            ss : '%d ਸਕਿੰਟ',
            m : 'ਇਕ ਮਿੰਟ',
            mm : '%d ਮਿੰਟ',
            h : 'ਇੱਕ ਘੰਟਾ',
            hh : '%d ਘੰਟੇ',
            d : 'ਇੱਕ ਦਿਨ',
            dd : '%d ਦਿਨ',
            M : 'ਇੱਕ ਮਹੀਨਾ',
            MM : '%d ਮਹੀਨੇ',
            y : 'ਇੱਕ ਸਾਲ',
            yy : '%d ਸਾਲ'
        },
        preparse: function (string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return paIn;

})));


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
    function plural(n) {
        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix  ? 'godzina'  : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months : function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (format === '') {
                // Hack: if format empty we know this is used to generate
                // RegExp by moment. Give then back both valid forms of months
                // in RegExp ready format.
                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
        weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : '%s temu',
            s : 'kilka sekund',
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : '1 dzień',
            dd : '%d dni',
            M : 'miesiąc',
            MM : translate,
            y : 'rok',
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return pl;

})));


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var pt = moment.defineLocale('pt', {
        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY HH:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return (this.day() === 0 || this.day() === 6) ?
                    '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'em %s',
            past : 'há %s',
            s : 'segundos',
            ss : '%d segundos',
            m : 'um minuto',
            mm : '%d minutos',
            h : 'uma hora',
            hh : '%d horas',
            d : 'um dia',
            dd : '%d dias',
            M : 'um mês',
            MM : '%d meses',
            y : 'um ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return pt;

})));


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ptBr = moment.defineLocale('pt-br', {
        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
        },
        calendar : {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return (this.day() === 0 || this.day() === 6) ?
                    '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'em %s',
            past : 'há %s',
            s : 'poucos segundos',
            ss : '%d segundos',
            m : 'um minuto',
            mm : '%d minutos',
            h : 'uma hora',
            hh : '%d horas',
            d : 'um dia',
            dd : '%d dias',
            M : 'um mês',
            MM : '%d meses',
            y : 'um ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal : '%dº'
    });

    return ptBr;

})));


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
                'ss': 'secunde',
                'mm': 'minute',
                'hh': 'ore',
                'dd': 'zile',
                'MM': 'luni',
                'yy': 'ani'
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'peste %s',
            past : '%s în urmă',
            s : 'câteva secunde',
            ss : relativeTimeWithPlural,
            m : 'un minut',
            mm : relativeTimeWithPlural,
            h : 'o oră',
            hh : relativeTimeWithPlural,
            d : 'o zi',
            dd : relativeTimeWithPlural,
            M : 'o lună',
            MM : relativeTimeWithPlural,
            y : 'un an',
            yy : relativeTimeWithPlural
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return ro;

})));


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            'hh': 'час_часа_часов',
            'dd': 'день_дня_дней',
            'MM': 'месяц_месяца_месяцев',
            'yy': 'год_года_лет'
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months : {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
        },
        monthsShort : {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
        },
        weekdays : {
            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
        },
        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соотвествует только сокращённым формам
        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY г.',
            LLL : 'D MMMM YYYY г., H:mm',
            LLLL : 'dddd, D MMMM YYYY г., H:mm'
        },
        calendar : {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'через %s',
            past : '%s назад',
            s : 'несколько секунд',
            ss : relativeTimeWithPlural,
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : 'час',
            hh : relativeTimeWithPlural,
            d : 'день',
            dd : relativeTimeWithPlural,
            M : 'месяц',
            MM : relativeTimeWithPlural,
            y : 'год',
            yy : relativeTimeWithPlural
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM : function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ru;

})));


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'جنوري',
        'فيبروري',
        'مارچ',
        'اپريل',
        'مئي',
        'جون',
        'جولاءِ',
        'آگسٽ',
        'سيپٽمبر',
        'آڪٽوبر',
        'نومبر',
        'ڊسمبر'
    ];
    var days = [
        'آچر',
        'سومر',
        'اڱارو',
        'اربع',
        'خميس',
        'جمع',
        'ڇنڇر'
    ];

    var sd = moment.defineLocale('sd', {
        months : months,
        monthsShort : months,
        weekdays : days,
        weekdaysShort : days,
        weekdaysMin : days,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd، D MMMM YYYY HH:mm'
        },
        meridiemParse: /صبح|شام/,
        isPM : function (input) {
            return 'شام' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar : {
            sameDay : '[اڄ] LT',
            nextDay : '[سڀاڻي] LT',
            nextWeek : 'dddd [اڳين هفتي تي] LT',
            lastDay : '[ڪالهه] LT',
            lastWeek : '[گزريل هفتي] dddd [تي] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s پوء',
            past : '%s اڳ',
            s : 'چند سيڪنڊ',
            ss : '%d سيڪنڊ',
            m : 'هڪ منٽ',
            mm : '%d منٽ',
            h : 'هڪ ڪلاڪ',
            hh : '%d ڪلاڪ',
            d : 'هڪ ڏينهن',
            dd : '%d ڏينهن',
            M : 'هڪ مهينو',
            MM : '%d مهينا',
            y : 'هڪ سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sd;

})));


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var se = moment.defineLocale('se', {
        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'MMMM D. [b.] YYYY',
            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
        },
        calendar : {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s geažes',
            past : 'maŋit %s',
            s : 'moadde sekunddat',
            ss: '%d sekunddat',
            m : 'okta minuhta',
            mm : '%d minuhtat',
            h : 'okta diimmu',
            hh : '%d diimmut',
            d : 'okta beaivi',
            dd : '%d beaivvit',
            M : 'okta mánnu',
            MM : '%d mánut',
            y : 'okta jahki',
            yy : '%d jagit'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return se;

})));


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    /*jshint -W100*/
    var si = moment.defineLocale('si', {
        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'a h:mm',
            LTS : 'a h:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY MMMM D',
            LLL : 'YYYY MMMM D, a h:mm',
            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
        },
        calendar : {
            sameDay : '[අද] LT[ට]',
            nextDay : '[හෙට] LT[ට]',
            nextWeek : 'dddd LT[ට]',
            lastDay : '[ඊයේ] LT[ට]',
            lastWeek : '[පසුගිය] dddd LT[ට]',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%sකින්',
            past : '%sකට පෙර',
            s : 'තත්පර කිහිපය',
            ss : 'තත්පර %d',
            m : 'මිනිත්තුව',
            mm : 'මිනිත්තු %d',
            h : 'පැය',
            hh : 'පැය %d',
            d : 'දිනය',
            dd : 'දින %d',
            M : 'මාසය',
            MM : 'මාස %d',
            y : 'වසර',
            yy : 'වසර %d'
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal : function (number) {
            return number + ' වැනි';
        },
        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM : function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        }
    });

    return si;

})));


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural(n) {
        return (n > 1) && (n < 5);
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':  // a few seconds / in a few seconds / a few seconds ago
                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
                break;
            case 'm':  // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
                break;
            case 'h':  // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
                break;
            case 'd':  // a day / in a day / a day ago
                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
                break;
            case 'M':  // a month / in a month / a month ago
                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
                break;
            case 'y':  // a year / in a year / a year ago
                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
                break;
        }
    }

    var sk = moment.defineLocale('sk', {
        months : months,
        monthsShort : monthsShort,
        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat : {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : 'pred %s',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sk;

})));


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danes ob] LT',
            nextDay  : '[jutri ob] LT',

            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay  : '[včeraj ob] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'čez %s',
            past   : 'pred %s',
            s      : processRelativeTime,
            ss     : processRelativeTime,
            m      : processRelativeTime,
            mm     : processRelativeTime,
            h      : processRelativeTime,
            hh     : processRelativeTime,
            d      : processRelativeTime,
            dd     : processRelativeTime,
            M      : processRelativeTime,
            MM     : processRelativeTime,
            y      : processRelativeTime,
            yy     : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return sl;

})));


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var sq = moment.defineLocale('sq', {
        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact : true,
        meridiemParse: /PD|MD/,
        isPM: function (input) {
            return input.charAt(0) === 'M';
        },
        meridiem : function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Sot në] LT',
            nextDay : '[Nesër në] LT',
            nextWeek : 'dddd [në] LT',
            lastDay : '[Dje në] LT',
            lastWeek : 'dddd [e kaluar në] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'në %s',
            past : '%s më parë',
            s : 'disa sekonda',
            ss : '%d sekonda',
            m : 'një minutë',
            mm : '%d minuta',
            h : 'një orë',
            hh : '%d orë',
            d : 'një ditë',
            dd : '%d ditë',
            M : 'një muaj',
            MM : '%d muaj',
            y : 'një vit',
            yy : '%d vite'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sq;

})));


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var translator = {
        words: { //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jedne minute'],
            mm: ['minut', 'minute', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mesec', 'meseca', 'meseci'],
            yy: ['godina', 'godine', 'godina']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var sr = moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[juče u] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'pre %s',
            s      : 'nekoliko sekundi',
            ss     : translator.translate,
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'dan',
            dd     : translator.translate,
            M      : 'mesec',
            MM     : translator.translate,
            y      : 'godinu',
            yy     : translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return sr;

})));


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var translator = {
        words: { //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једне минуте'],
            mm: ['минут', 'минуте', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            dd: ['дан', 'дана', 'дана'],
            MM: ['месец', 'месеца', 'месеци'],
            yy: ['година', 'године', 'година']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var srCyrl = moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay  : '[јуче у] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'за %s',
            past   : 'пре %s',
            s      : 'неколико секунди',
            ss     : translator.translate,
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'дан',
            dd     : translator.translate,
            M      : 'месец',
            MM     : translator.translate,
            y      : 'годину',
            yy     : translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return srCyrl;

})));


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ss = moment.defineLocale('ss', {
        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Namuhla nga] LT',
            nextDay : '[Kusasa nga] LT',
            nextWeek : 'dddd [nga] LT',
            lastDay : '[Itolo nga] LT',
            lastWeek : 'dddd [leliphelile] [nga] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'nga %s',
            past : 'wenteka nga %s',
            s : 'emizuzwana lomcane',
            ss : '%d mzuzwana',
            m : 'umzuzu',
            mm : '%d emizuzu',
            h : 'lihora',
            hh : '%d emahora',
            d : 'lilanga',
            dd : '%d emalanga',
            M : 'inyanga',
            MM : '%d tinyanga',
            y : 'umnyaka',
            yy : '%d iminyaka'
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal : '%d',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ss;

})));


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var sv = moment.defineLocale('sv', {
        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [kl.] HH:mm',
            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : 'för %s sedan',
            s : 'några sekunder',
            ss : '%d sekunder',
            m : 'en minut',
            mm : '%d minuter',
            h : 'en timme',
            hh : '%d timmar',
            d : 'en dag',
            dd : '%d dagar',
            M : 'en månad',
            MM : '%d månader',
            y : 'ett år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'e' :
                (b === 1) ? 'a' :
                (b === 2) ? 'a' :
                (b === 3) ? 'e' : 'e';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sv;

})));


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var sw = moment.defineLocale('sw', {
        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[leo saa] LT',
            nextDay : '[kesho saa] LT',
            nextWeek : '[wiki ijayo] dddd [saat] LT',
            lastDay : '[jana] LT',
            lastWeek : '[wiki iliyopita] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s baadaye',
            past : 'tokea %s',
            s : 'hivi punde',
            ss : 'sekunde %d',
            m : 'dakika moja',
            mm : 'dakika %d',
            h : 'saa limoja',
            hh : 'masaa %d',
            d : 'siku moja',
            dd : 'masiku %d',
            M : 'mwezi mmoja',
            MM : 'miezi %d',
            y : 'mwaka mmoja',
            yy : 'miaka %d'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return sw;

})));


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '௧',
        '2': '௨',
        '3': '௩',
        '4': '௪',
        '5': '௫',
        '6': '௬',
        '7': '௭',
        '8': '௮',
        '9': '௯',
        '0': '௦'
    }, numberMap = {
        '௧': '1',
        '௨': '2',
        '௩': '3',
        '௪': '4',
        '௫': '5',
        '௬': '6',
        '௭': '7',
        '௮': '8',
        '௯': '9',
        '௦': '0'
    };

    var ta = moment.defineLocale('ta', {
        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, HH:mm',
            LLLL : 'dddd, D MMMM YYYY, HH:mm'
        },
        calendar : {
            sameDay : '[இன்று] LT',
            nextDay : '[நாளை] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[நேற்று] LT',
            lastWeek : '[கடந்த வாரம்] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s இல்',
            past : '%s முன்',
            s : 'ஒரு சில விநாடிகள்',
            ss : '%d விநாடிகள்',
            m : 'ஒரு நிமிடம்',
            mm : '%d நிமிடங்கள்',
            h : 'ஒரு மணி நேரம்',
            hh : '%d மணி நேரம்',
            d : 'ஒரு நாள்',
            dd : '%d நாட்கள்',
            M : 'ஒரு மாதம்',
            MM : '%d மாதங்கள்',
            y : 'ஒரு வருடம்',
            yy : '%d ஆண்டுகள்'
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal : function (number) {
            return number + 'வது';
        },
        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem : function (hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை';  // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return ta;

})));


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var te = moment.defineLocale('te', {
        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
        monthsParseExact : true,
        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[నేడు] LT',
            nextDay : '[రేపు] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[నిన్న] LT',
            lastWeek : '[గత] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s లో',
            past : '%s క్రితం',
            s : 'కొన్ని క్షణాలు',
            ss : '%d సెకన్లు',
            m : 'ఒక నిమిషం',
            mm : '%d నిమిషాలు',
            h : 'ఒక గంట',
            hh : '%d గంటలు',
            d : 'ఒక రోజు',
            dd : '%d రోజులు',
            M : 'ఒక నెల',
            MM : '%d నెలలు',
            y : 'ఒక సంవత్సరం',
            yy : '%d సంవత్సరాలు'
        },
        dayOfMonthOrdinalParse : /\d{1,2}వ/,
        ordinal : '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return te;

})));


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tet = moment.defineLocale('tet', {
        months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin : 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'iha %s',
            past : '%s liuba',
            s : 'minutu balun',
            ss : 'minutu %d',
            m : 'minutu ida',
            mm : 'minutu %d',
            h : 'oras ida',
            hh : 'oras %d',
            d : 'loron ida',
            dd : 'loron %d',
            M : 'fulan ida',
            MM : 'fulan %d',
            y : 'tinan ida',
            yy : 'tinan %d'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tet;

})));


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум'
    };

    var tg = moment.defineLocale('tg', {
        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
        weekdaysShort : 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin : 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Имрӯз соати] LT',
            nextDay : '[Пагоҳ соати] LT',
            lastDay : '[Дирӯз соати] LT',
            nextWeek : 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek : 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'баъди %s',
            past : '%s пеш',
            s : 'якчанд сония',
            m : 'як дақиқа',
            mm : '%d дақиқа',
            h : 'як соат',
            hh : '%d соат',
            d : 'як рӯз',
            dd : '%d рӯз',
            M : 'як моҳ',
            MM : '%d моҳ',
            y : 'як сол',
            yy : '%d сол'
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1th is the first week of the year.
        }
    });

    return tg;

})));


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var th = moment.defineLocale('th', {
        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
        monthsParseExact: true,
        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY เวลา H:mm',
            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar : {
            sameDay : '[วันนี้ เวลา] LT',
            nextDay : '[พรุ่งนี้ เวลา] LT',
            nextWeek : 'dddd[หน้า เวลา] LT',
            lastDay : '[เมื่อวานนี้ เวลา] LT',
            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'อีก %s',
            past : '%sที่แล้ว',
            s : 'ไม่กี่วินาที',
            ss : '%d วินาที',
            m : '1 นาที',
            mm : '%d นาที',
            h : '1 ชั่วโมง',
            hh : '%d ชั่วโมง',
            d : '1 วัน',
            dd : '%d วัน',
            M : '1 เดือน',
            MM : '%d เดือน',
            y : '1 ปี',
            yy : '%d ปี'
        }
    });

    return th;

})));


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tlPh = moment.defineLocale('tl-ph', {
        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'MM/D/YYYY',
            LL : 'MMMM D, YYYY',
            LLL : 'MMMM D, YYYY HH:mm',
            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
        },
        calendar : {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'sa loob ng %s',
            past : '%s ang nakalipas',
            s : 'ilang segundo',
            ss : '%d segundo',
            m : 'isang minuto',
            mm : '%d minuto',
            h : 'isang oras',
            hh : '%d oras',
            d : 'isang araw',
            dd : '%d araw',
            M : 'isang buwan',
            MM : '%d buwan',
            y : 'isang taon',
            yy : '%d taon'
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal : function (number) {
            return number;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tlPh;

})));


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time = (output.indexOf('jaj') !== -1) ?
        time.slice(0, -3) + 'leS' :
        (output.indexOf('jar') !== -1) ?
        time.slice(0, -3) + 'waQ' :
        (output.indexOf('DIS') !== -1) ?
        time.slice(0, -3) + 'nem' :
        time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time = (output.indexOf('jaj') !== -1) ?
        time.slice(0, -3) + 'Hu’' :
        (output.indexOf('jar') !== -1) ?
        time.slice(0, -3) + 'wen' :
        (output.indexOf('DIS') !== -1) ?
        time.slice(0, -3) + 'ben' :
        time + ' ret';
        return time;
    }

    function translate(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor((number % 1000) / 100),
        ten = Math.floor((number % 100) / 10),
        one = number % 10,
        word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
        }
        return (word === '') ? 'pagh' : word;
    }

    var tlh = moment.defineLocale('tlh', {
        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
        monthsParseExact : true,
        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L'
        },
        relativeTime : {
            future : translateFuture,
            past : translatePast,
            s : 'puS lup',
            ss : translate,
            m : 'wa’ tup',
            mm : translate,
            h : 'wa’ rep',
            hh : translate,
            d : 'wa’ jaj',
            dd : translate,
            M : 'wa’ jar',
            MM : translate,
            y : 'wa’ DIS',
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tlh;

})));


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {


;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    var suffixes = {
        1: '\'inci',
        5: '\'inci',
        8: '\'inci',
        70: '\'inci',
        80: '\'inci',
        2: '\'nci',
        7: '\'nci',
        20: '\'nci',
        50: '\'nci',
        3: '\'üncü',
        4: '\'üncü',
        100: '\'üncü',
        6: '\'ncı',
        9: '\'uncu',
        10: '\'uncu',
        30: '\'uncu',
        60: '\'ıncı',
        90: '\'ıncı'
    };

    var tr = moment.defineLocale('tr', {
        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[bugün saat] LT',
            nextDay : '[yarın saat] LT',
            nextWeek : '[gelecek] dddd [saat] LT',
            lastDay : '[dün] LT',
            lastWeek : '[geçen] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s sonra',
            past : '%s önce',
            s : 'birkaç saniye',
            ss : '%d saniye',
            m : 'bir dakika',
            mm : '%d dakika',
            h : 'bir saat',
            hh : '%d saat',
            d : 'bir gün',
            dd : '%d gün',
            M : 'bir ay',
            MM : '%d ay',
            y : 'bir yıl',
            yy : '%d yıl'
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {  // special case for zero
                        return number + '\'ıncı';
                    }
                    var a = number % 10,
                        b = number % 100 - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return tr;

})));


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    var tzl = moment.defineLocale('tzl', {
        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM [dallas] YYYY',
            LLL : 'D. MMMM [dallas] YYYY HH.mm',
            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM : function (input) {
            return 'd\'o' === input.toLowerCase();
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'd\'o' : 'D\'O';
            } else {
                return isLower ? 'd\'a' : 'D\'A';
            }
        },
        calendar : {
            sameDay : '[oxhi à] LT',
            nextDay : '[demà à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[ieiri à] LT',
            lastWeek : '[sür el] dddd [lasteu à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'osprei %s',
            past : 'ja%s',
            s : processRelativeTime,
            ss : processRelativeTime,
            m : processRelativeTime,
            mm : processRelativeTime,
            h : processRelativeTime,
            hh : processRelativeTime,
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's': ['viensas secunds', '\'iensas secunds'],
            'ss': [number + ' secunds', '' + number + ' secunds'],
            'm': ['\'n míut', '\'iens míut'],
            'mm': [number + ' míuts', '' + number + ' míuts'],
            'h': ['\'n þora', '\'iensa þora'],
            'hh': [number + ' þoras', '' + number + ' þoras'],
            'd': ['\'n ziua', '\'iensa ziua'],
            'dd': [number + ' ziuas', '' + number + ' ziuas'],
            'M': ['\'n mes', '\'iens mes'],
            'MM': [number + ' mesen', '' + number + ' mesen'],
            'y': ['\'n ar', '\'iens ar'],
            'yy': [number + ' ars', '' + number + ' ars']
        };
        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
    }

    return tzl;

})));


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tzm = moment.defineLocale('tzm', {
        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past : 'ⵢⴰⵏ %s',
            s : 'ⵉⵎⵉⴽ',
            ss : '%d ⵉⵎⵉⴽ',
            m : 'ⵎⵉⵏⵓⴺ',
            mm : '%d ⵎⵉⵏⵓⴺ',
            h : 'ⵙⴰⵄⴰ',
            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d : 'ⴰⵙⵙ',
            dd : '%d oⵙⵙⴰⵏ',
            M : 'ⴰⵢoⵓⵔ',
            MM : '%d ⵉⵢⵢⵉⵔⵏ',
            y : 'ⴰⵙⴳⴰⵙ',
            yy : '%d ⵉⵙⴳⴰⵙⵏ'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return tzm;

})));


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tzmLatn = moment.defineLocale('tzm-latn', {
        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'dadkh s yan %s',
            past : 'yan %s',
            s : 'imik',
            ss : '%d imik',
            m : 'minuḍ',
            mm : '%d minuḍ',
            h : 'saɛa',
            hh : '%d tassaɛin',
            d : 'ass',
            dd : '%d ossan',
            M : 'ayowr',
            MM : '%d iyyirn',
            y : 'asgas',
            yy : '%d isgasn'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return tzmLatn;

})));


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js language configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ugCn = moment.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
            '_'
        ),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                meridiem === 'يېرىم كېچە' ||
                meridiem === 'سەھەر' ||
                meridiem === 'چۈشتىن بۇرۇن'
            ) {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل'
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ugCn;

})));


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            'dd': 'день_дні_днів',
            'MM': 'місяць_місяці_місяців',
            'yy': 'рік_роки_років'
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        }
        else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
        };

        if (m === true) {
            return weekdays['nominative'].slice(1, 7).concat(weekdays['nominative'].slice(0, 1));
        }
        if (!m) {
            return weekdays['nominative'];
        }

        var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
            'accusative' :
            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
                'genitive' :
                'nominative');
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months : {
            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
        },
        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
        weekdays : weekdaysCaseReplace,
        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY р.',
            LLL : 'D MMMM YYYY р., HH:mm',
            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
        },
        calendar : {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'за %s',
            past : '%s тому',
            s : 'декілька секунд',
            ss : relativeTimeWithPlural,
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : 'годину',
            hh : relativeTimeWithPlural,
            d : 'день',
            dd : relativeTimeWithPlural,
            M : 'місяць',
            MM : relativeTimeWithPlural,
            y : 'рік',
            yy : relativeTimeWithPlural
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return uk;

})));


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'جنوری',
        'فروری',
        'مارچ',
        'اپریل',
        'مئی',
        'جون',
        'جولائی',
        'اگست',
        'ستمبر',
        'اکتوبر',
        'نومبر',
        'دسمبر'
    ];
    var days = [
        'اتوار',
        'پیر',
        'منگل',
        'بدھ',
        'جمعرات',
        'جمعہ',
        'ہفتہ'
    ];

    var ur = moment.defineLocale('ur', {
        months : months,
        monthsShort : months,
        weekdays : days,
        weekdaysShort : days,
        weekdaysMin : days,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd، D MMMM YYYY HH:mm'
        },
        meridiemParse: /صبح|شام/,
        isPM : function (input) {
            return 'شام' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar : {
            sameDay : '[آج بوقت] LT',
            nextDay : '[کل بوقت] LT',
            nextWeek : 'dddd [بوقت] LT',
            lastDay : '[گذشتہ روز بوقت] LT',
            lastWeek : '[گذشتہ] dddd [بوقت] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s بعد',
            past : '%s قبل',
            s : 'چند سیکنڈ',
            ss : '%d سیکنڈ',
            m : 'ایک منٹ',
            mm : '%d منٹ',
            h : 'ایک گھنٹہ',
            hh : '%d گھنٹے',
            d : 'ایک دن',
            dd : '%d دن',
            M : 'ایک ماہ',
            MM : '%d ماہ',
            y : 'ایک سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ur;

})));


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var uz = moment.defineLocale('uz', {
        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'D MMMM YYYY, dddd HH:mm'
        },
        calendar : {
            sameDay : '[Бугун соат] LT [да]',
            nextDay : '[Эртага] LT [да]',
            nextWeek : 'dddd [куни соат] LT [да]',
            lastDay : '[Кеча соат] LT [да]',
            lastWeek : '[Утган] dddd [куни соат] LT [да]',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'Якин %s ичида',
            past : 'Бир неча %s олдин',
            s : 'фурсат',
            ss : '%d фурсат',
            m : 'бир дакика',
            mm : '%d дакика',
            h : 'бир соат',
            hh : '%d соат',
            d : 'бир кун',
            dd : '%d кун',
            M : 'бир ой',
            MM : '%d ой',
            y : 'бир йил',
            yy : '%d йил'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return uz;

})));


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var uzLatn = moment.defineLocale('uz-latn', {
        months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
        monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
        weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'D MMMM YYYY, dddd HH:mm'
        },
        calendar : {
            sameDay : '[Bugun soat] LT [da]',
            nextDay : '[Ertaga] LT [da]',
            nextWeek : 'dddd [kuni soat] LT [da]',
            lastDay : '[Kecha soat] LT [da]',
            lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'Yaqin %s ichida',
            past : 'Bir necha %s oldin',
            s : 'soniya',
            ss : '%d soniya',
            m : 'bir daqiqa',
            mm : '%d daqiqa',
            h : 'bir soat',
            hh : '%d soat',
            d : 'bir kun',
            dd : '%d kun',
            M : 'bir oy',
            MM : '%d oy',
            y : 'bir yil',
            yy : '%d yil'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return uzLatn;

})));


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var vi = moment.defineLocale('vi', {
        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
        monthsParseExact : true,
        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact : true,
        meridiemParse: /sa|ch/i,
        isPM : function (input) {
            return /^ch$/i.test(input);
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM [năm] YYYY',
            LLL : 'D MMMM [năm] YYYY HH:mm',
            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
            l : 'DD/M/YYYY',
            ll : 'D MMM YYYY',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd, D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần rồi lúc] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s tới',
            past : '%s trước',
            s : 'vài giây',
            ss : '%d giây' ,
            m : 'một phút',
            mm : '%d phút',
            h : 'một giờ',
            hh : '%d giờ',
            d : 'một ngày',
            dd : '%d ngày',
            M : 'một tháng',
            MM : '%d tháng',
            y : 'một năm',
            yy : '%d năm'
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal : function (number) {
            return number;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return vi;

})));


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var xPseudo = moment.defineLocale('x-pseudo', {
        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
        monthsParseExact : true,
        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[T~ódá~ý át] LT',
            nextDay : '[T~ómó~rró~w át] LT',
            nextWeek : 'dddd [át] LT',
            lastDay : '[Ý~ést~érdá~ý át] LT',
            lastWeek : '[L~ást] dddd [át] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'í~ñ %s',
            past : '%s á~gó',
            s : 'á ~féw ~sécó~ñds',
            ss : '%d s~écóñ~ds',
            m : 'á ~míñ~úté',
            mm : '%d m~íñú~tés',
            h : 'á~ñ hó~úr',
            hh : '%d h~óúrs',
            d : 'á ~dáý',
            dd : '%d d~áýs',
            M : 'á ~móñ~th',
            MM : '%d m~óñt~hs',
            y : 'á ~ýéár',
            yy : '%d ý~éárs'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return xPseudo;

})));


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var yo = moment.defineLocale('yo', {
        months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
        monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Ònì ni] LT',
            nextDay : '[Ọ̀la ni] LT',
            nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
            lastDay : '[Àna ni] LT',
            lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ní %s',
            past : '%s kọjá',
            s : 'ìsẹjú aayá die',
            ss :'aayá %d',
            m : 'ìsẹjú kan',
            mm : 'ìsẹjú %d',
            h : 'wákati kan',
            hh : 'wákati %d',
            d : 'ọjọ́ kan',
            dd : 'ọjọ́ %d',
            M : 'osù kan',
            MM : 'osù %d',
            y : 'ọdún kan',
            yy : 'ọdún %d'
        },
        dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
        ordinal : 'ọjọ́ %d',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return yo;

})));


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var zhCn = moment.defineLocale('zh-cn', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日Ah点mm分',
            LLLL : 'YYYY年M月D日ddddAh点mm分',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' ||
                    meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天]LT',
            nextDay : '[明天]LT',
            nextWeek : '[下]ddddLT',
            lastDay : '[昨天]LT',
            lastWeek : '[上]ddddLT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime : {
            future : '%s内',
            past : '%s前',
            s : '几秒',
            ss : '%d 秒',
            m : '1 分钟',
            mm : '%d 分钟',
            h : '1 小时',
            hh : '%d 小时',
            d : '1 天',
            dd : '%d 天',
            M : '1 个月',
            MM : '%d 个月',
            y : '1 年',
            yy : '%d 年'
        },
        week : {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return zhCn;

})));


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var zhHk = moment.defineLocale('zh-hk', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日dddd HH:mm',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天]LT',
            nextDay : '[明天]LT',
            nextWeek : '[下]ddddLT',
            lastDay : '[昨天]LT',
            lastWeek : '[上]ddddLT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd' :
                case 'D' :
                case 'DDD' :
                    return number + '日';
                case 'M' :
                    return number + '月';
                case 'w' :
                case 'W' :
                    return number + '週';
                default :
                    return number;
            }
        },
        relativeTime : {
            future : '%s內',
            past : '%s前',
            s : '幾秒',
            ss : '%d 秒',
            m : '1 分鐘',
            mm : '%d 分鐘',
            h : '1 小時',
            hh : '%d 小時',
            d : '1 天',
            dd : '%d 天',
            M : '1 個月',
            MM : '%d 個月',
            y : '1 年',
            yy : '%d 年'
        }
    });

    return zhHk;

})));


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(3)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var zhTw = moment.defineLocale('zh-tw', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日dddd HH:mm',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天] LT',
            nextDay : '[明天] LT',
            nextWeek : '[下]dddd LT',
            lastDay : '[昨天] LT',
            lastWeek : '[上]dddd LT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd' :
                case 'D' :
                case 'DDD' :
                    return number + '日';
                case 'M' :
                    return number + '月';
                case 'w' :
                case 'W' :
                    return number + '週';
                default :
                    return number;
            }
        },
        relativeTime : {
            future : '%s內',
            past : '%s前',
            s : '幾秒',
            ss : '%d 秒',
            m : '1 分鐘',
            mm : '%d 分鐘',
            h : '1 小時',
            hh : '%d 小時',
            d : '1 天',
            dd : '%d 天',
            M : '1 個月',
            MM : '%d 個月',
            y : '1 年',
            yy : '%d 年'
        }
    });

    return zhTw;

})));


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// modified from https://github.com/es-shims/es6-shim
var keys = __webpack_require__(196);
var bind = __webpack_require__(114);
var canBeObject = function (obj) {
	return typeof obj !== 'undefined' && obj !== null;
};
var hasSymbols = __webpack_require__(540)();
var toObject = Object;
var push = bind.call(Function.call, Array.prototype.push);
var propIsEnumerable = bind.call(Function.call, Object.prototype.propertyIsEnumerable);
var originalGetSymbols = hasSymbols ? Object.getOwnPropertySymbols : null;

module.exports = function assign(target, source1) {
	if (!canBeObject(target)) { throw new TypeError('target must be an object'); }
	var objTarget = toObject(target);
	var s, source, i, props, syms, value, key;
	for (s = 1; s < arguments.length; ++s) {
		source = toObject(arguments[s]);
		props = keys(source);
		var getSymbols = hasSymbols && (Object.getOwnPropertySymbols || originalGetSymbols);
		if (getSymbols) {
			syms = getSymbols(source);
			for (i = 0; i < syms.length; ++i) {
				key = syms[i];
				if (propIsEnumerable(source, key)) {
					push(props, key);
				}
			}
		}
		for (i = 0; i < props.length; ++i) {
			key = props[i];
			value = source[key];
			if (propIsEnumerable(source, key)) {
				objTarget[key] = value;
			}
		}
	}
	return objTarget;
};


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 17], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(539);

var lacksProperEnumerationOrder = function () {
	if (!Object.assign) {
		return false;
	}
	// v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	// note: this does not detect the bug unless there's 20 characters
	var str = 'abcdefghijklmnopqrst';
	var letters = str.split('');
	var map = {};
	for (var i = 0; i < letters.length; ++i) {
		map[letters[i]] = letters[i];
	}
	var obj = Object.assign({}, map);
	var actual = '';
	for (var k in obj) {
		actual += k;
	}
	return str !== actual;
};

var assignHasPendingExceptions = function () {
	if (!Object.assign || !Object.preventExtensions) {
		return false;
	}
	// Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	// which is 72% slower than our shim, and Firefox 40's native implementation.
	var thrower = Object.preventExtensions({ 1: 2 });
	try {
		Object.assign(thrower, 'xy');
	} catch (e) {
		return thrower[1] === 'y';
	}
	return false;
};

module.exports = function getPolyfill() {
	if (!Object.assign) {
		return implementation;
	}
	if (lacksProperEnumerationOrder()) {
		return implementation;
	}
	if (assignHasPendingExceptions()) {
		return implementation;
	}
	return Object.assign;
};


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _propTypes2['default'].oneOf([_constants.START_DATE, _constants.END_DATE]);

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _propTypes2['default'].oneOf([_constants.HORIZONTAL_ORIENTATION, _constants.VERTICAL_ORIENTATION]);

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _propTypes2['default'].oneOf([_constants.ANCHOR_LEFT, _constants.ANCHOR_RIGHT]);

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 67);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __webpack_require__(2);

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __webpack_require__(24);

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = __webpack_require__(68);

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = __webpack_require__(99);

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

module.exports = __webpack_require__(98);

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = __webpack_require__(112);

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

module.exports = __webpack_require__(115);

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __webpack_require__(12);

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __webpack_require__(27);

/***/ }),

/***/ 32:
/***/ (function(module, exports) {

module.exports = __webpack_require__(113);

/***/ }),

/***/ 33:
/***/ (function(module, exports) {

module.exports = __webpack_require__(197);

/***/ }),

/***/ 34:
/***/ (function(module, exports) {

module.exports = __webpack_require__(100);

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __webpack_require__(6);

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __webpack_require__(37);

/***/ }),

/***/ 54:
/***/ (function(module, exports) {

module.exports = __webpack_require__(546);

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(7);

var _moment2 = _interopRequireDefault(_moment);

var _reactMomentProptypes = __webpack_require__(10);

var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);

var _airbnbPropTypes = __webpack_require__(1);

var _OpenDirectionShape = __webpack_require__(15);

var _OpenDirectionShape2 = _interopRequireDefault(_OpenDirectionShape);

var _defaultPhrases = __webpack_require__(3);

var _getPhrasePropTypes = __webpack_require__(5);

var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);

var _DateRangePickerInput = __webpack_require__(54);

var _DateRangePickerInput2 = _interopRequireDefault(_DateRangePickerInput);

var _IconPositionShape = __webpack_require__(19);

var _IconPositionShape2 = _interopRequireDefault(_IconPositionShape);

var _toMomentObject = __webpack_require__(34);

var _toMomentObject2 = _interopRequireDefault(_toMomentObject);

var _toLocalizedDateString = __webpack_require__(33);

var _toLocalizedDateString2 = _interopRequireDefault(_toLocalizedDateString);

var _toISODateString = __webpack_require__(13);

var _toISODateString2 = _interopRequireDefault(_toISODateString);

var _isInclusivelyAfterDay = __webpack_require__(16);

var _isInclusivelyAfterDay2 = _interopRequireDefault(_isInclusivelyAfterDay);

var _isBeforeDay = __webpack_require__(32);

var _isBeforeDay2 = _interopRequireDefault(_isBeforeDay);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
  startDate: _reactMomentProptypes2['default'].momentObj,
  startDateId: _propTypes2['default'].string,
  startDatePlaceholderText: _propTypes2['default'].string,
  isStartDateFocused: _propTypes2['default'].bool,

  endDate: _reactMomentProptypes2['default'].momentObj,
  endDateId: _propTypes2['default'].string,
  endDatePlaceholderText: _propTypes2['default'].string,
  isEndDateFocused: _propTypes2['default'].bool,

  screenReaderMessage: _propTypes2['default'].string,
  showClearDates: _propTypes2['default'].bool,
  showCaret: _propTypes2['default'].bool,
  showDefaultInputIcon: _propTypes2['default'].bool,
  inputIconPosition: _IconPositionShape2['default'],
  disabled: _propTypes2['default'].bool,
  required: _propTypes2['default'].bool,
  readOnly: _propTypes2['default'].bool,
  openDirection: _OpenDirectionShape2['default'],

  keepOpenOnDateSelect: _propTypes2['default'].bool,
  reopenPickerOnClearDates: _propTypes2['default'].bool,
  withFullScreenPortal: _propTypes2['default'].bool,
  minimumNights: _airbnbPropTypes.nonNegativeInteger,
  isOutsideRange: _propTypes2['default'].func,
  displayFormat: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].func]),

  onFocusChange: _propTypes2['default'].func,
  onClose: _propTypes2['default'].func,
  onDatesChange: _propTypes2['default'].func,
  onArrowDown: _propTypes2['default'].func,
  onQuestionMark: _propTypes2['default'].func,

  customInputIcon: _propTypes2['default'].node,
  customArrowIcon: _propTypes2['default'].node,
  customCloseIcon: _propTypes2['default'].node,

  // accessibility
  isFocused: _propTypes2['default'].bool,

  // i18n
  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DateRangePickerInputPhrases)),

  isRTL: _propTypes2['default'].bool
});

var defaultProps = {
  startDate: null,
  startDateId: _constants.START_DATE,
  startDatePlaceholderText: 'Start Date',
  isStartDateFocused: false,

  endDate: null,
  endDateId: _constants.END_DATE,
  endDatePlaceholderText: 'End Date',
  isEndDateFocused: false,

  screenReaderMessage: '',
  showClearDates: false,
  showCaret: false,
  showDefaultInputIcon: false,
  inputIconPosition: _constants.ICON_BEFORE_POSITION,
  disabled: false,
  required: false,
  readOnly: false,
  openDirection: _constants.OPEN_DOWN,

  keepOpenOnDateSelect: false,
  reopenPickerOnClearDates: false,
  withFullScreenPortal: false,
  minimumNights: 1,
  isOutsideRange: function () {
    function isOutsideRange(day) {
      return !(0, _isInclusivelyAfterDay2['default'])(day, (0, _moment2['default'])());
    }

    return isOutsideRange;
  }(),
  displayFormat: function () {
    function displayFormat() {
      return _moment2['default'].localeData().longDateFormat('L');
    }

    return displayFormat;
  }(),

  onFocusChange: function () {
    function onFocusChange() {}

    return onFocusChange;
  }(),
  onClose: function () {
    function onClose() {}

    return onClose;
  }(),
  onDatesChange: function () {
    function onDatesChange() {}

    return onDatesChange;
  }(),
  onArrowDown: function () {
    function onArrowDown() {}

    return onArrowDown;
  }(),
  onQuestionMark: function () {
    function onQuestionMark() {}

    return onQuestionMark;
  }(),

  customInputIcon: null,
  customArrowIcon: null,
  customCloseIcon: null,

  // accessibility
  isFocused: false,

  // i18n
  phrases: _defaultPhrases.DateRangePickerInputPhrases,

  isRTL: false
};

var DateRangePickerInputController = function (_React$Component) {
  _inherits(DateRangePickerInputController, _React$Component);

  function DateRangePickerInputController(props) {
    _classCallCheck(this, DateRangePickerInputController);

    var _this = _possibleConstructorReturn(this, (DateRangePickerInputController.__proto__ || Object.getPrototypeOf(DateRangePickerInputController)).call(this, props));

    _this.onClearFocus = _this.onClearFocus.bind(_this);
    _this.onStartDateChange = _this.onStartDateChange.bind(_this);
    _this.onStartDateFocus = _this.onStartDateFocus.bind(_this);
    _this.onEndDateChange = _this.onEndDateChange.bind(_this);
    _this.onEndDateFocus = _this.onEndDateFocus.bind(_this);
    _this.clearDates = _this.clearDates.bind(_this);
    return _this;
  }

  _createClass(DateRangePickerInputController, [{
    key: 'onClearFocus',
    value: function () {
      function onClearFocus() {
        var _props = this.props,
            onFocusChange = _props.onFocusChange,
            onClose = _props.onClose,
            startDate = _props.startDate,
            endDate = _props.endDate;

        onFocusChange(null);
        onClose({ startDate: startDate, endDate: endDate });
      }

      return onClearFocus;
    }()
  }, {
    key: 'onEndDateChange',
    value: function () {
      function onEndDateChange(endDateString) {
        var _props2 = this.props,
            startDate = _props2.startDate,
            isOutsideRange = _props2.isOutsideRange,
            minimumNights = _props2.minimumNights,
            keepOpenOnDateSelect = _props2.keepOpenOnDateSelect,
            onDatesChange = _props2.onDatesChange;

        var endDate = (0, _toMomentObject2['default'])(endDateString, this.getDisplayFormat());

        var isEndDateValid = endDate && !isOutsideRange(endDate) && !(startDate && (0, _isBeforeDay2['default'])(endDate, startDate.clone().add(minimumNights, 'days')));
        if (isEndDateValid) {
          onDatesChange({ startDate: startDate, endDate: endDate });
          if (!keepOpenOnDateSelect) this.onClearFocus();
        } else {
          onDatesChange({
            startDate: startDate,
            endDate: null
          });
        }
      }

      return onEndDateChange;
    }()
  }, {
    key: 'onEndDateFocus',
    value: function () {
      function onEndDateFocus() {
        var _props3 = this.props,
            startDate = _props3.startDate,
            onFocusChange = _props3.onFocusChange,
            withFullScreenPortal = _props3.withFullScreenPortal,
            disabled = _props3.disabled;

        if (!startDate && withFullScreenPortal && !disabled) {
          // When the datepicker is full screen, we never want to focus the end date first
          // because there's no indication that that is the case once the datepicker is open and it
          // might confuse the user
          onFocusChange(_constants.START_DATE);
        } else if (!disabled) {
          onFocusChange(_constants.END_DATE);
        }
      }

      return onEndDateFocus;
    }()
  }, {
    key: 'onStartDateChange',
    value: function () {
      function onStartDateChange(startDateString) {
        var startDate = (0, _toMomentObject2['default'])(startDateString, this.getDisplayFormat());

        var endDate = this.props.endDate;
        var _props4 = this.props,
            isOutsideRange = _props4.isOutsideRange,
            minimumNights = _props4.minimumNights,
            onDatesChange = _props4.onDatesChange,
            onFocusChange = _props4.onFocusChange;

        var isStartDateValid = startDate && !isOutsideRange(startDate);
        if (isStartDateValid) {
          if (startDate && (0, _isBeforeDay2['default'])(endDate, startDate.clone().add(minimumNights, 'days'))) {
            endDate = null;
          }

          onDatesChange({ startDate: startDate, endDate: endDate });
          onFocusChange(_constants.END_DATE);
        } else {
          onDatesChange({
            startDate: null,
            endDate: endDate
          });
        }
      }

      return onStartDateChange;
    }()
  }, {
    key: 'onStartDateFocus',
    value: function () {
      function onStartDateFocus() {
        if (!this.props.disabled) {
          this.props.onFocusChange(_constants.START_DATE);
        }
      }

      return onStartDateFocus;
    }()
  }, {
    key: 'getDisplayFormat',
    value: function () {
      function getDisplayFormat() {
        var displayFormat = this.props.displayFormat;

        return typeof displayFormat === 'string' ? displayFormat : displayFormat();
      }

      return getDisplayFormat;
    }()
  }, {
    key: 'getDateString',
    value: function () {
      function getDateString(date) {
        var displayFormat = this.getDisplayFormat();
        if (date && displayFormat) {
          return date && date.format(displayFormat);
        }
        return (0, _toLocalizedDateString2['default'])(date);
      }

      return getDateString;
    }()
  }, {
    key: 'clearDates',
    value: function () {
      function clearDates() {
        var _props5 = this.props,
            onDatesChange = _props5.onDatesChange,
            reopenPickerOnClearDates = _props5.reopenPickerOnClearDates,
            onFocusChange = _props5.onFocusChange;

        onDatesChange({ startDate: null, endDate: null });
        if (reopenPickerOnClearDates) {
          onFocusChange(_constants.START_DATE);
        }
      }

      return clearDates;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props6 = this.props,
            startDate = _props6.startDate,
            startDateId = _props6.startDateId,
            startDatePlaceholderText = _props6.startDatePlaceholderText,
            isStartDateFocused = _props6.isStartDateFocused,
            endDate = _props6.endDate,
            endDateId = _props6.endDateId,
            endDatePlaceholderText = _props6.endDatePlaceholderText,
            isEndDateFocused = _props6.isEndDateFocused,
            screenReaderMessage = _props6.screenReaderMessage,
            showClearDates = _props6.showClearDates,
            showCaret = _props6.showCaret,
            showDefaultInputIcon = _props6.showDefaultInputIcon,
            inputIconPosition = _props6.inputIconPosition,
            customInputIcon = _props6.customInputIcon,
            customArrowIcon = _props6.customArrowIcon,
            customCloseIcon = _props6.customCloseIcon,
            disabled = _props6.disabled,
            required = _props6.required,
            readOnly = _props6.readOnly,
            openDirection = _props6.openDirection,
            isFocused = _props6.isFocused,
            phrases = _props6.phrases,
            onArrowDown = _props6.onArrowDown,
            onQuestionMark = _props6.onQuestionMark,
            isRTL = _props6.isRTL;

        var startDateString = this.getDateString(startDate);
        var startDateValue = (0, _toISODateString2['default'])(startDate);
        var endDateString = this.getDateString(endDate);
        var endDateValue = (0, _toISODateString2['default'])(endDate);

        return _react2['default'].createElement(_DateRangePickerInput2['default'], {
          startDate: startDateString,
          startDateValue: startDateValue,
          startDateId: startDateId,
          startDatePlaceholderText: startDatePlaceholderText,
          isStartDateFocused: isStartDateFocused,
          endDate: endDateString,
          endDateValue: endDateValue,
          endDateId: endDateId,
          endDatePlaceholderText: endDatePlaceholderText,
          isEndDateFocused: isEndDateFocused,
          isFocused: isFocused,
          disabled: disabled,
          required: required,
          readOnly: readOnly,
          openDirection: openDirection,
          showCaret: showCaret,
          showDefaultInputIcon: showDefaultInputIcon,
          inputIconPosition: inputIconPosition,
          customInputIcon: customInputIcon,
          customArrowIcon: customArrowIcon,
          customCloseIcon: customCloseIcon,
          phrases: phrases,
          onStartDateChange: this.onStartDateChange,
          onStartDateFocus: this.onStartDateFocus,
          onStartDateShiftTab: this.onClearFocus,
          onEndDateChange: this.onEndDateChange,
          onEndDateFocus: this.onEndDateFocus,
          onEndDateTab: this.onClearFocus,
          showClearDates: showClearDates,
          onClearDates: this.clearDates,
          screenReaderMessage: screenReaderMessage,
          onArrowDown: onArrowDown,
          onQuestionMark: onQuestionMark,
          isRTL: isRTL
        });
      }

      return render;
    }()
  }]);

  return DateRangePickerInputController;
}(_react2['default'].Component);

exports['default'] = DateRangePickerInputController;

DateRangePickerInputController.propTypes = propTypes;
DateRangePickerInputController.defaultProps = defaultProps;

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __webpack_require__(0);

/***/ })

/******/ });

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 66);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __webpack_require__(2);

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __webpack_require__(24);

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function () {
      function render() {
        return _react2["default"].createElement(
          "svg",
          _extends({ viewBox: "0 0 12 12" }, this.props),
          _react2["default"].createElement("path", { fillRule: "evenodd", d: "M11.53.47a.75.75 0 0 0-1.061 0l-4.47 4.47L1.529.47A.75.75 0 1 0 .468 1.531l4.47 4.47-4.47 4.47a.75.75 0 1 0 1.061 1.061l4.47-4.47 4.47 4.47a.75.75 0 1 0 1.061-1.061l-4.47-4.47 4.47-4.47a.75.75 0 0 0 0-1.061z" })
        );
      }

      return render;
    }()
  }]);

  return SVG;
}(_react2["default"].Component);

exports["default"] = SVG;

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

module.exports = __webpack_require__(98);

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

module.exports = __webpack_require__(115);

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __webpack_require__(12);

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function () {
      function render() {
        return _react2["default"].createElement(
          "svg",
          _extends({ viewBox: "0 0 1000 1000" }, this.props),
          _react2["default"].createElement("path", { d: "M336.2 274.5l-210.1 210h805.4c13 0 23 10 23 23s-10 23-23 23H126.1l210.1 210.1c11 11 11 21 0 32-5 5-10 7-16 7s-11-2-16-7l-249.1-249c-11-11-11-21 0-32l249.1-249.1c21-21.1 53 10.9 32 32z" })
        );
      }

      return render;
    }()
  }]);

  return SVG;
}(_react2["default"].Component);

exports["default"] = SVG;

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function () {
      function render() {
        return _react2["default"].createElement(
          "svg",
          _extends({ viewBox: "0 0 1000 1000" }, this.props),
          _react2["default"].createElement("path", { d: "M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z" })
        );
      }

      return render;
    }()
  }]);

  return SVG;
}(_react2["default"].Component);

exports["default"] = SVG;

/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function () {
      function render() {
        return _react2["default"].createElement(
          "svg",
          _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1393.1 1500" }, this.props),
          _react2["default"].createElement("path", { d: "M107.2 1392.9h241.1v-241.1H107.2v241.1zm294.7 0h267.9v-241.1H401.9v241.1zm-294.7-294.7h241.1V830.4H107.2v267.8zm294.7 0h267.9V830.4H401.9v267.8zM107.2 776.8h241.1V535.7H107.2v241.1zm616.2 616.1h267.9v-241.1H723.4v241.1zM401.9 776.8h267.9V535.7H401.9v241.1zm642.9 616.1H1286v-241.1h-241.1v241.1zm-321.4-294.7h267.9V830.4H723.4v267.8zM428.7 375V133.9c0-7.3-2.7-13.5-8-18.8-5.3-5.3-11.6-8-18.8-8h-53.6c-7.3 0-13.5 2.7-18.8 8-5.3 5.3-8 11.6-8 18.8V375c0 7.3 2.7 13.5 8 18.8 5.3 5.3 11.6 8 18.8 8h53.6c7.3 0 13.5-2.7 18.8-8 5.3-5.3 8-11.5 8-18.8zm616.1 723.2H1286V830.4h-241.1v267.8zM723.4 776.8h267.9V535.7H723.4v241.1zm321.4 0H1286V535.7h-241.1v241.1zm26.8-401.8V133.9c0-7.3-2.7-13.5-8-18.8-5.3-5.3-11.6-8-18.8-8h-53.6c-7.3 0-13.5 2.7-18.8 8-5.3 5.3-8 11.6-8 18.8V375c0 7.3 2.7 13.5 8 18.8 5.3 5.3 11.6 8 18.8 8h53.6c7.3 0 13.5-2.7 18.8-8 5.4-5.3 8-11.5 8-18.8zm321.5-53.6v1071.4c0 29-10.6 54.1-31.8 75.3-21.2 21.2-46.3 31.8-75.3 31.8H107.2c-29 0-54.1-10.6-75.3-31.8C10.6 1447 0 1421.9 0 1392.9V321.4c0-29 10.6-54.1 31.8-75.3s46.3-31.8 75.3-31.8h107.2v-80.4c0-36.8 13.1-68.4 39.3-94.6S311.4 0 348.3 0h53.6c36.8 0 68.4 13.1 94.6 39.3 26.2 26.2 39.3 57.8 39.3 94.6v80.4h321.5v-80.4c0-36.8 13.1-68.4 39.3-94.6C922.9 13.1 954.4 0 991.3 0h53.6c36.8 0 68.4 13.1 94.6 39.3s39.3 57.8 39.3 94.6v80.4H1286c29 0 54.1 10.6 75.3 31.8 21.2 21.2 31.8 46.3 31.8 75.3z" })
        );
      }

      return render;
    }()
  }]);

  return SVG;
}(_react2["default"].Component);

exports["default"] = SVG;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __webpack_require__(27);

/***/ }),

/***/ 35:
/***/ (function(module, exports) {

module.exports = __webpack_require__(547);

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __webpack_require__(6);

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __webpack_require__(37);

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = __webpack_require__(44);

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _airbnbPropTypes = __webpack_require__(1);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _defaultPhrases = __webpack_require__(3);

var _getPhrasePropTypes = __webpack_require__(5);

var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);

var _OpenDirectionShape = __webpack_require__(15);

var _OpenDirectionShape2 = _interopRequireDefault(_OpenDirectionShape);

var _DateInput = __webpack_require__(35);

var _DateInput2 = _interopRequireDefault(_DateInput);

var _IconPositionShape = __webpack_require__(19);

var _IconPositionShape2 = _interopRequireDefault(_IconPositionShape);

var _arrowRight = __webpack_require__(26);

var _arrowRight2 = _interopRequireDefault(_arrowRight);

var _arrowLeft = __webpack_require__(25);

var _arrowLeft2 = _interopRequireDefault(_arrowLeft);

var _close = __webpack_require__(11);

var _close2 = _interopRequireDefault(_close);

var _calendar = __webpack_require__(27);

var _calendar2 = _interopRequireDefault(_calendar);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
  startDateId: _propTypes2['default'].string,
  startDatePlaceholderText: _propTypes2['default'].string,
  screenReaderMessage: _propTypes2['default'].string,

  endDateId: _propTypes2['default'].string,
  endDatePlaceholderText: _propTypes2['default'].string,

  onStartDateFocus: _propTypes2['default'].func,
  onEndDateFocus: _propTypes2['default'].func,
  onStartDateChange: _propTypes2['default'].func,
  onEndDateChange: _propTypes2['default'].func,
  onStartDateShiftTab: _propTypes2['default'].func,
  onEndDateTab: _propTypes2['default'].func,
  onClearDates: _propTypes2['default'].func,
  onArrowDown: _propTypes2['default'].func,
  onQuestionMark: _propTypes2['default'].func,

  startDate: _propTypes2['default'].string,
  startDateValue: _propTypes2['default'].string,
  endDate: _propTypes2['default'].string,
  endDateValue: _propTypes2['default'].string,

  isStartDateFocused: _propTypes2['default'].bool,
  isEndDateFocused: _propTypes2['default'].bool,
  showClearDates: _propTypes2['default'].bool,
  disabled: _propTypes2['default'].bool,
  required: _propTypes2['default'].bool,
  readOnly: _propTypes2['default'].bool,
  openDirection: _OpenDirectionShape2['default'],
  showCaret: _propTypes2['default'].bool,
  showDefaultInputIcon: _propTypes2['default'].bool,
  inputIconPosition: _IconPositionShape2['default'],
  customInputIcon: _propTypes2['default'].node,
  customArrowIcon: _propTypes2['default'].node,
  customCloseIcon: _propTypes2['default'].node,

  // accessibility
  isFocused: _propTypes2['default'].bool, // describes actual DOM focus

  // i18n
  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DateRangePickerInputPhrases)),

  isRTL: _propTypes2['default'].bool
});

var defaultProps = {
  startDateId: _constants.START_DATE,
  endDateId: _constants.END_DATE,
  startDatePlaceholderText: 'Start Date',
  endDatePlaceholderText: 'End Date',
  screenReaderMessage: '',
  onStartDateFocus: function () {
    function onStartDateFocus() {}

    return onStartDateFocus;
  }(),
  onEndDateFocus: function () {
    function onEndDateFocus() {}

    return onEndDateFocus;
  }(),
  onStartDateChange: function () {
    function onStartDateChange() {}

    return onStartDateChange;
  }(),
  onEndDateChange: function () {
    function onEndDateChange() {}

    return onEndDateChange;
  }(),
  onStartDateShiftTab: function () {
    function onStartDateShiftTab() {}

    return onStartDateShiftTab;
  }(),
  onEndDateTab: function () {
    function onEndDateTab() {}

    return onEndDateTab;
  }(),
  onClearDates: function () {
    function onClearDates() {}

    return onClearDates;
  }(),
  onArrowDown: function () {
    function onArrowDown() {}

    return onArrowDown;
  }(),
  onQuestionMark: function () {
    function onQuestionMark() {}

    return onQuestionMark;
  }(),

  startDate: '',
  startDateValue: '',
  endDate: '',
  endDateValue: '',

  isStartDateFocused: false,
  isEndDateFocused: false,
  showClearDates: false,
  disabled: false,
  required: false,
  readOnly: false,
  openDirection: _constants.OPEN_DOWN,
  showCaret: false,
  showDefaultInputIcon: false,
  inputIconPosition: _constants.ICON_BEFORE_POSITION,
  customInputIcon: null,
  customArrowIcon: null,
  customCloseIcon: null,

  // accessibility
  isFocused: false,

  // i18n
  phrases: _defaultPhrases.DateRangePickerInputPhrases,

  isRTL: false
};

var DateRangePickerInput = function (_React$Component) {
  _inherits(DateRangePickerInput, _React$Component);

  function DateRangePickerInput(props) {
    _classCallCheck(this, DateRangePickerInput);

    var _this = _possibleConstructorReturn(this, (DateRangePickerInput.__proto__ || Object.getPrototypeOf(DateRangePickerInput)).call(this, props));

    _this.state = {
      isClearDatesHovered: false
    };

    _this.onClearDatesMouseEnter = _this.onClearDatesMouseEnter.bind(_this);
    _this.onClearDatesMouseLeave = _this.onClearDatesMouseLeave.bind(_this);
    return _this;
  }

  _createClass(DateRangePickerInput, [{
    key: 'onClearDatesMouseEnter',
    value: function () {
      function onClearDatesMouseEnter() {
        this.setState({
          isClearDatesHovered: true
        });
      }

      return onClearDatesMouseEnter;
    }()
  }, {
    key: 'onClearDatesMouseLeave',
    value: function () {
      function onClearDatesMouseLeave() {
        this.setState({
          isClearDatesHovered: false
        });
      }

      return onClearDatesMouseLeave;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var isClearDatesHovered = this.state.isClearDatesHovered;
        var _props = this.props,
            startDate = _props.startDate,
            startDateValue = _props.startDateValue,
            startDateId = _props.startDateId,
            startDatePlaceholderText = _props.startDatePlaceholderText,
            screenReaderMessage = _props.screenReaderMessage,
            isStartDateFocused = _props.isStartDateFocused,
            onStartDateChange = _props.onStartDateChange,
            onStartDateFocus = _props.onStartDateFocus,
            onStartDateShiftTab = _props.onStartDateShiftTab,
            endDate = _props.endDate,
            endDateValue = _props.endDateValue,
            endDateId = _props.endDateId,
            endDatePlaceholderText = _props.endDatePlaceholderText,
            isEndDateFocused = _props.isEndDateFocused,
            onEndDateChange = _props.onEndDateChange,
            onEndDateFocus = _props.onEndDateFocus,
            onEndDateTab = _props.onEndDateTab,
            onArrowDown = _props.onArrowDown,
            onQuestionMark = _props.onQuestionMark,
            onClearDates = _props.onClearDates,
            showClearDates = _props.showClearDates,
            disabled = _props.disabled,
            required = _props.required,
            readOnly = _props.readOnly,
            openDirection = _props.openDirection,
            showCaret = _props.showCaret,
            showDefaultInputIcon = _props.showDefaultInputIcon,
            inputIconPosition = _props.inputIconPosition,
            customInputIcon = _props.customInputIcon,
            customArrowIcon = _props.customArrowIcon,
            customCloseIcon = _props.customCloseIcon,
            isFocused = _props.isFocused,
            phrases = _props.phrases,
            isRTL = _props.isRTL;

        var calendarIcon = customInputIcon || _react2['default'].createElement(_calendar2['default'], null);
        var arrowIcon = customArrowIcon || (isRTL ? _react2['default'].createElement(_arrowLeft2['default'], null) : _react2['default'].createElement(_arrowRight2['default'], null));
        var closeIcon = customCloseIcon || _react2['default'].createElement(_close2['default'], null);
        var screenReaderText = screenReaderMessage || phrases.keyboardNavigationInstructions;
        var inputIcon = (showDefaultInputIcon || customInputIcon !== null) && _react2['default'].createElement('button', {
          type: 'button',
          className: 'DateRangePickerInput__calendar-icon',
          disabled: disabled,
          'aria-label': phrases.focusStartDate,
          onClick: onArrowDown
        }, calendarIcon);

        return _react2['default'].createElement('div', {
          className: (0, _classnames2['default'])('DateRangePickerInput', {
            'DateRangePickerInput--disabled': disabled,
            'DateRangePickerInput--rtl': isRTL
          })
        }, inputIconPosition === _constants.ICON_BEFORE_POSITION && inputIcon, _react2['default'].createElement(_DateInput2['default'], {
          id: startDateId,
          placeholder: startDatePlaceholderText,
          displayValue: startDate,
          inputValue: startDateValue,
          screenReaderMessage: screenReaderText,
          focused: isStartDateFocused,
          isFocused: isFocused,
          disabled: disabled,
          required: required,
          readOnly: readOnly,
          openDirection: openDirection,
          showCaret: showCaret,

          onChange: onStartDateChange,
          onFocus: onStartDateFocus,
          onKeyDownShiftTab: onStartDateShiftTab,
          onKeyDownArrowDown: onArrowDown,
          onKeyDownQuestionMark: onQuestionMark
        }), _react2['default'].createElement('div', {
          className: 'DateRangePickerInput__arrow',
          'aria-hidden': 'true',
          role: 'presentation'
        }, arrowIcon), _react2['default'].createElement(_DateInput2['default'], {
          id: endDateId,
          placeholder: endDatePlaceholderText,
          displayValue: endDate,
          inputValue: endDateValue,
          screenReaderMessage: screenReaderText,
          focused: isEndDateFocused,
          isFocused: isFocused,
          disabled: disabled,
          required: required,
          readOnly: readOnly,
          openDirection: openDirection,
          showCaret: showCaret,

          onChange: onEndDateChange,
          onFocus: onEndDateFocus,
          onKeyDownTab: onEndDateTab,
          onKeyDownArrowDown: onArrowDown,
          onKeyDownQuestionMark: onQuestionMark
        }), showClearDates && _react2['default'].createElement('button', {
          type: 'button',
          'aria-label': phrases.clearDates,
          className: (0, _classnames2['default'])('DateRangePickerInput__clear-dates', {
            'DateRangePickerInput__clear-dates--hide': !(startDate || endDate),
            'DateRangePickerInput__clear-dates--hover': isClearDatesHovered
          }),
          disabled: disabled,
          onMouseEnter: this.onClearDatesMouseEnter,
          onMouseLeave: this.onClearDatesMouseLeave,
          onClick: onClearDates
        }, _react2['default'].createElement('div', { className: 'DateRangePickerInput__close-icon' }, closeIcon)), inputIconPosition === _constants.ICON_AFTER_POSITION && inputIcon);
      }

      return render;
    }()
  }]);

  return DateRangePickerInput;
}(_react2['default'].Component);

exports['default'] = DateRangePickerInput;

DateRangePickerInput.propTypes = propTypes;
DateRangePickerInput.defaultProps = defaultProps;

/***/ })

/******/ });

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 64);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __webpack_require__(2);

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __webpack_require__(24);

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

module.exports = __webpack_require__(98);

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __webpack_require__(12);

/***/ }),

/***/ 37:
/***/ (function(module, exports) {

module.exports = __webpack_require__(548);

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __webpack_require__(6);

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = __webpack_require__(44);

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _airbnbPropTypes = __webpack_require__(1);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _throttle = __webpack_require__(37);

var _throttle2 = _interopRequireDefault(_throttle);

var _isTouchDevice = __webpack_require__(9);

var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);

var _OpenDirectionShape = __webpack_require__(15);

var _OpenDirectionShape2 = _interopRequireDefault(_OpenDirectionShape);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
  id: _propTypes2['default'].string.isRequired,
  placeholder: _propTypes2['default'].string, // also used as label
  displayValue: _propTypes2['default'].string,
  inputValue: _propTypes2['default'].string,
  screenReaderMessage: _propTypes2['default'].string,
  focused: _propTypes2['default'].bool,
  disabled: _propTypes2['default'].bool,
  required: _propTypes2['default'].bool,
  readOnly: _propTypes2['default'].bool,
  openDirection: _OpenDirectionShape2['default'],
  showCaret: _propTypes2['default'].bool,

  onChange: _propTypes2['default'].func,
  onFocus: _propTypes2['default'].func,
  onKeyDownShiftTab: _propTypes2['default'].func,
  onKeyDownTab: _propTypes2['default'].func,

  onKeyDownArrowDown: _propTypes2['default'].func,
  onKeyDownQuestionMark: _propTypes2['default'].func,

  // accessibility
  isFocused: _propTypes2['default'].bool // describes actual DOM focus
});

var defaultProps = {
  placeholder: 'Select Date',
  displayValue: '',
  inputValue: '',
  screenReaderMessage: '',
  focused: false,
  disabled: false,
  required: false,
  readOnly: null,
  openDirection: _constants.OPEN_DOWN,
  showCaret: false,

  onChange: function () {
    function onChange() {}

    return onChange;
  }(),
  onFocus: function () {
    function onFocus() {}

    return onFocus;
  }(),
  onKeyDownShiftTab: function () {
    function onKeyDownShiftTab() {}

    return onKeyDownShiftTab;
  }(),
  onKeyDownTab: function () {
    function onKeyDownTab() {}

    return onKeyDownTab;
  }(),
  onKeyDownArrowDown: function () {
    function onKeyDownArrowDown() {}

    return onKeyDownArrowDown;
  }(),
  onKeyDownQuestionMark: function () {
    function onKeyDownQuestionMark() {}

    return onKeyDownQuestionMark;
  }(),

  // accessibility
  isFocused: false
};

var DateInput = function (_React$Component) {
  _inherits(DateInput, _React$Component);

  function DateInput(props) {
    _classCallCheck(this, DateInput);

    var _this = _possibleConstructorReturn(this, (DateInput.__proto__ || Object.getPrototypeOf(DateInput)).call(this, props));

    _this.state = {
      dateString: '',
      isTouchDevice: false
    };

    _this.onChange = _this.onChange.bind(_this);
    _this.onKeyDown = _this.onKeyDown.bind(_this);
    _this.setInputRef = _this.setInputRef.bind(_this);
    return _this;
  }

  _createClass(DateInput, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        this.setState({ isTouchDevice: (0, _isTouchDevice2['default'])() });
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(nextProps) {
        if (!this.props.displayValue && nextProps.displayValue) {
          this.setState({
            dateString: ''
          });
        }
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate(prevProps) {
        var _props = this.props,
            focused = _props.focused,
            isFocused = _props.isFocused;

        if (prevProps.focused === focused && prevProps.isFocused === isFocused) return;

        if (focused && isFocused) {
          this.inputRef.focus();
          this.inputRef.select();
        } else {
          this.inputRef.blur();
        }
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'onChange',
    value: function () {
      function onChange(e) {
        var _props2 = this.props,
            onChange = _props2.onChange,
            onKeyDownQuestionMark = _props2.onKeyDownQuestionMark;

        var dateString = e.target.value;

        // In Safari, onKeyDown does not consistently fire ahead of onChange. As a result, we need to
        // special case the `?` key so that it always triggers the appropriate callback, instead of
        // modifying the input value
        if (dateString[dateString.length - 1] === '?') {
          onKeyDownQuestionMark(e);
        } else {
          this.setState({ dateString: dateString });
          onChange(dateString);
        }
      }

      return onChange;
    }()
  }, {
    key: 'onKeyDown',
    value: function () {
      function onKeyDown(e) {
        e.stopPropagation();

        var _props3 = this.props,
            onKeyDownShiftTab = _props3.onKeyDownShiftTab,
            onKeyDownTab = _props3.onKeyDownTab,
            onKeyDownArrowDown = _props3.onKeyDownArrowDown,
            onKeyDownQuestionMark = _props3.onKeyDownQuestionMark;
        var key = e.key;

        if (key === 'Tab') {
          if (e.shiftKey) {
            onKeyDownShiftTab(e);
          } else {
            onKeyDownTab(e);
          }
        } else if (key === 'ArrowDown') {
          onKeyDownArrowDown(e);
        } else if (key === '?') {
          e.preventDefault();
          onKeyDownQuestionMark(e);
        }
      }

      return onKeyDown;
    }()
  }, {
    key: 'setInputRef',
    value: function () {
      function setInputRef(ref) {
        this.inputRef = ref;
      }

      return setInputRef;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _state = this.state,
            dateString = _state.dateString,
            isTouch = _state.isTouchDevice;
        var _props4 = this.props,
            id = _props4.id,
            placeholder = _props4.placeholder,
            displayValue = _props4.displayValue,
            inputValue = _props4.inputValue,
            screenReaderMessage = _props4.screenReaderMessage,
            focused = _props4.focused,
            showCaret = _props4.showCaret,
            onFocus = _props4.onFocus,
            disabled = _props4.disabled,
            required = _props4.required,
            readOnly = _props4.readOnly,
            openDirection = _props4.openDirection;

        var displayText = displayValue || inputValue || dateString || placeholder || '';
        var value = inputValue || displayValue || dateString || '';
        var screenReaderMessageId = 'DateInput__screen-reader-message-' + String(id);

        return _react2['default'].createElement('div', {
          className: (0, _classnames2['default'])('DateInput', {
            'DateInput--with-caret': showCaret && focused,
            'DateInput--disabled': disabled,
            'DateInput--open-down': openDirection === _constants.OPEN_DOWN,
            'DateInput--open-up': openDirection === _constants.OPEN_UP
          })
        }, _react2['default'].createElement('input', {
          'aria-label': placeholder,
          className: 'DateInput__input needsclick',
          type: 'text',
          id: id,
          name: id,
          ref: this.setInputRef,
          value: value,
          onChange: this.onChange,
          onKeyDown: (0, _throttle2['default'])(this.onKeyDown, 300),
          onFocus: onFocus,
          placeholder: placeholder,
          autoComplete: 'off',
          disabled: disabled,
          readOnly: typeof readOnly === 'boolean' ? readOnly : isTouch,
          required: required,
          'aria-describedby': screenReaderMessage && screenReaderMessageId
        }), screenReaderMessage && _react2['default'].createElement('p', { id: screenReaderMessageId, className: 'screen-reader-only' }, screenReaderMessage), _react2['default'].createElement('div', {
          className: (0, _classnames2['default'])('DateInput__display-text', {
            'DateInput__display-text--has-input': !!value,
            'DateInput__display-text--focused': focused,
            'DateInput__display-text--disabled': disabled
          })
        }, displayText));
      }

      return render;
    }()
  }]);

  return DateInput;
}(_react2['default'].Component);

exports['default'] = DateInput;

DateInput.propTypes = propTypes;
DateInput.defaultProps = defaultProps;

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = __webpack_require__(97);

/***/ })

/******/ });

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__(959),
    isObject = __webpack_require__(198);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(961);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(549);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 71);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(2);

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(24);

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(12);

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(27);

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(6);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(37);

/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(0);

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(101);

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(97);

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(68);

/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(86);

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(99);

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(112);

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(116);

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(199);

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(102);

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(152);

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(150);

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(552);

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(113);

/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(200);

/***/ }),
/* 37 */,
/* 38 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(558);

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(542);

/***/ }),
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(568);

/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _object3 = __webpack_require__(24);

var _object4 = _interopRequireDefault(_object3);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMomentProptypes = __webpack_require__(10);

var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);

var _airbnbPropTypes = __webpack_require__(1);

var _moment = __webpack_require__(7);

var _moment2 = _interopRequireDefault(_moment);

var _object = __webpack_require__(38);

var _object2 = _interopRequireDefault(_object);

var _isTouchDevice = __webpack_require__(9);

var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);

var _defaultPhrases = __webpack_require__(3);

var _getPhrasePropTypes = __webpack_require__(5);

var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);

var _isInclusivelyAfterDay = __webpack_require__(16);

var _isInclusivelyAfterDay2 = _interopRequireDefault(_isInclusivelyAfterDay);

var _isNextDay = __webpack_require__(49);

var _isNextDay2 = _interopRequireDefault(_isNextDay);

var _isSameDay = __webpack_require__(22);

var _isSameDay2 = _interopRequireDefault(_isSameDay);

var _isAfterDay = __webpack_require__(20);

var _isAfterDay2 = _interopRequireDefault(_isAfterDay);

var _isBeforeDay = __webpack_require__(32);

var _isBeforeDay2 = _interopRequireDefault(_isBeforeDay);

var _getVisibleDays = __webpack_require__(31);

var _getVisibleDays2 = _interopRequireDefault(_getVisibleDays);

var _isDayVisible = __webpack_require__(21);

var _isDayVisible2 = _interopRequireDefault(_isDayVisible);

var _toISODateString = __webpack_require__(13);

var _toISODateString2 = _interopRequireDefault(_toISODateString);

var _toISOMonthString = __webpack_require__(23);

var _toISOMonthString2 = _interopRequireDefault(_toISOMonthString);

var _FocusedInputShape = __webpack_require__(44);

var _FocusedInputShape2 = _interopRequireDefault(_FocusedInputShape);

var _ScrollableOrientationShape = __webpack_require__(8);

var _ScrollableOrientationShape2 = _interopRequireDefault(_ScrollableOrientationShape);

var _DayOfWeekShape = __webpack_require__(12);

var _DayOfWeekShape2 = _interopRequireDefault(_DayOfWeekShape);

var _constants = __webpack_require__(2);

var _DayPicker = __webpack_require__(36);

var _DayPicker2 = _interopRequireDefault(_DayPicker);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
  startDate: _reactMomentProptypes2['default'].momentObj,
  endDate: _reactMomentProptypes2['default'].momentObj,
  onDatesChange: _propTypes2['default'].func,

  focusedInput: _FocusedInputShape2['default'],
  onFocusChange: _propTypes2['default'].func,
  onClose: _propTypes2['default'].func,

  keepOpenOnDateSelect: _propTypes2['default'].bool,
  minimumNights: _propTypes2['default'].number,
  isOutsideRange: _propTypes2['default'].func,
  isDayBlocked: _propTypes2['default'].func,
  isDayHighlighted: _propTypes2['default'].func,

  // DayPicker props
  renderMonth: _propTypes2['default'].func,
  enableOutsideDays: _propTypes2['default'].bool,
  numberOfMonths: _propTypes2['default'].number,
  orientation: _ScrollableOrientationShape2['default'],
  withPortal: _propTypes2['default'].bool,
  initialVisibleMonth: _propTypes2['default'].func,
  hideKeyboardShortcutsPanel: _propTypes2['default'].bool,
  daySize: _airbnbPropTypes.nonNegativeInteger,

  navPrev: _propTypes2['default'].node,
  navNext: _propTypes2['default'].node,

  onPrevMonthClick: _propTypes2['default'].func,
  onNextMonthClick: _propTypes2['default'].func,
  onOutsideClick: _propTypes2['default'].func,
  renderDay: _propTypes2['default'].func,
  renderCalendarInfo: _propTypes2['default'].func,
  firstDayOfWeek: _DayOfWeekShape2['default'],

  // accessibility
  onBlur: _propTypes2['default'].func,
  isFocused: _propTypes2['default'].bool,
  showKeyboardShortcuts: _propTypes2['default'].bool,

  // i18n
  monthFormat: _propTypes2['default'].string,
  weekDayFormat: _propTypes2['default'].string,
  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DayPickerPhrases)),

  isRTL: _propTypes2['default'].bool
});

var defaultProps = {
  startDate: undefined, // TODO: use null
  endDate: undefined, // TODO: use null
  onDatesChange: function () {
    function onDatesChange() {}

    return onDatesChange;
  }(),

  focusedInput: null,
  onFocusChange: function () {
    function onFocusChange() {}

    return onFocusChange;
  }(),
  onClose: function () {
    function onClose() {}

    return onClose;
  }(),

  keepOpenOnDateSelect: false,
  minimumNights: 1,
  isOutsideRange: function () {
    function isOutsideRange() {}

    return isOutsideRange;
  }(),
  isDayBlocked: function () {
    function isDayBlocked() {}

    return isDayBlocked;
  }(),
  isDayHighlighted: function () {
    function isDayHighlighted() {}

    return isDayHighlighted;
  }(),

  // DayPicker props
  renderMonth: null,
  enableOutsideDays: false,
  numberOfMonths: 1,
  orientation: _constants.HORIZONTAL_ORIENTATION,
  withPortal: false,
  hideKeyboardShortcutsPanel: false,
  initialVisibleMonth: null,
  daySize: _constants.DAY_SIZE,

  navPrev: null,
  navNext: null,

  onPrevMonthClick: function () {
    function onPrevMonthClick() {}

    return onPrevMonthClick;
  }(),
  onNextMonthClick: function () {
    function onNextMonthClick() {}

    return onNextMonthClick;
  }(),
  onOutsideClick: function () {
    function onOutsideClick() {}

    return onOutsideClick;
  }(),

  renderDay: null,
  renderCalendarInfo: null,
  firstDayOfWeek: null,

  // accessibility
  onBlur: function () {
    function onBlur() {}

    return onBlur;
  }(),

  isFocused: false,
  showKeyboardShortcuts: false,

  // i18n
  monthFormat: 'MMMM YYYY',
  weekDayFormat: 'dd',
  phrases: _defaultPhrases.DayPickerPhrases,

  isRTL: false
};

var getChooseAvailableDatePhrase = function () {
  function getChooseAvailableDatePhrase(phrases, focusedInput) {
    if (focusedInput === _constants.START_DATE) {
      return phrases.chooseAvailableStartDate;
    } else if (focusedInput === _constants.END_DATE) {
      return phrases.chooseAvailableEndDate;
    }
    return phrases.chooseAvailableDate;
  }

  return getChooseAvailableDatePhrase;
}();

var DayPickerRangeController = function (_React$Component) {
  _inherits(DayPickerRangeController, _React$Component);

  function DayPickerRangeController(props) {
    _classCallCheck(this, DayPickerRangeController);

    var _this = _possibleConstructorReturn(this, (DayPickerRangeController.__proto__ || Object.getPrototypeOf(DayPickerRangeController)).call(this, props));

    _this.isTouchDevice = (0, _isTouchDevice2['default'])();
    _this.today = (0, _moment2['default'])();
    _this.modifiers = {
      today: function () {
        function today(day) {
          return _this.isToday(day);
        }

        return today;
      }(),
      blocked: function () {
        function blocked(day) {
          return _this.isBlocked(day);
        }

        return blocked;
      }(),
      'blocked-calendar': function () {
        function blockedCalendar(day) {
          return props.isDayBlocked(day);
        }

        return blockedCalendar;
      }(),
      'blocked-out-of-range': function () {
        function blockedOutOfRange(day) {
          return props.isOutsideRange(day);
        }

        return blockedOutOfRange;
      }(),
      'highlighted-calendar': function () {
        function highlightedCalendar(day) {
          return props.isDayHighlighted(day);
        }

        return highlightedCalendar;
      }(),
      valid: function () {
        function valid(day) {
          return !_this.isBlocked(day);
        }

        return valid;
      }(),
      'selected-start': function () {
        function selectedStart(day) {
          return _this.isStartDate(day);
        }

        return selectedStart;
      }(),
      'selected-end': function () {
        function selectedEnd(day) {
          return _this.isEndDate(day);
        }

        return selectedEnd;
      }(),
      'blocked-minimum-nights': function () {
        function blockedMinimumNights(day) {
          return _this.doesNotMeetMinimumNights(day);
        }

        return blockedMinimumNights;
      }(),
      'selected-span': function () {
        function selectedSpan(day) {
          return _this.isInSelectedSpan(day);
        }

        return selectedSpan;
      }(),
      'last-in-range': function () {
        function lastInRange(day) {
          return _this.isLastInRange(day);
        }

        return lastInRange;
      }(),
      hovered: function () {
        function hovered(day) {
          return _this.isHovered(day);
        }

        return hovered;
      }(),
      'hovered-span': function () {
        function hoveredSpan(day) {
          return _this.isInHoveredSpan(day);
        }

        return hoveredSpan;
      }(),
      'after-hovered-start': function () {
        function afterHoveredStart(day) {
          return _this.isDayAfterHoveredStartDate(day);
        }

        return afterHoveredStart;
      }()
    };

    var _this$getStateForNewM = _this.getStateForNewMonth(props),
        currentMonth = _this$getStateForNewM.currentMonth,
        visibleDays = _this$getStateForNewM.visibleDays;

    // initialize phrases
    // set the appropriate CalendarDay phrase based on focusedInput


    var chooseAvailableDate = getChooseAvailableDatePhrase(props.phrases, props.focusedInput);

    _this.state = {
      hoverDate: null,
      currentMonth: currentMonth,
      phrases: (0, _object4['default'])({}, props.phrases, {
        chooseAvailableDate: chooseAvailableDate
      }),
      visibleDays: visibleDays
    };

    _this.onDayClick = _this.onDayClick.bind(_this);
    _this.onDayMouseEnter = _this.onDayMouseEnter.bind(_this);
    _this.onDayMouseLeave = _this.onDayMouseLeave.bind(_this);
    _this.onPrevMonthClick = _this.onPrevMonthClick.bind(_this);
    _this.onNextMonthClick = _this.onNextMonthClick.bind(_this);
    _this.onMultiplyScrollableMonths = _this.onMultiplyScrollableMonths.bind(_this);
    _this.getFirstFocusableDay = _this.getFirstFocusableDay.bind(_this);
    _this.setDayPickerRef = _this.setDayPickerRef.bind(_this);
    return _this;
  }

  _createClass(DayPickerRangeController, [{
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(nextProps) {
        var _this2 = this;

        var startDate = nextProps.startDate,
            endDate = nextProps.endDate,
            focusedInput = nextProps.focusedInput,
            minimumNights = nextProps.minimumNights,
            isOutsideRange = nextProps.isOutsideRange,
            isDayBlocked = nextProps.isDayBlocked,
            isDayHighlighted = nextProps.isDayHighlighted,
            phrases = nextProps.phrases,
            initialVisibleMonth = nextProps.initialVisibleMonth,
            numberOfMonths = nextProps.numberOfMonths,
            enableOutsideDays = nextProps.enableOutsideDays;
        var visibleDays = this.state.visibleDays;

        var recomputeOutsideRange = false;
        var recomputeDayBlocked = false;
        var recomputeDayHighlighted = false;

        if (isOutsideRange !== this.props.isOutsideRange) {
          this.modifiers['blocked-out-of-range'] = function (day) {
            return isOutsideRange(day);
          };
          recomputeOutsideRange = true;
        }

        if (isDayBlocked !== this.props.isDayBlocked) {
          this.modifiers['blocked-calendar'] = function (day) {
            return isDayBlocked(day);
          };
          recomputeDayBlocked = true;
        }

        if (isDayHighlighted !== this.props.isDayHighlighted) {
          this.modifiers['highlighted-calendar'] = function (day) {
            return isDayHighlighted(day);
          };
          recomputeDayHighlighted = true;
        }

        var recomputePropModifiers = recomputeOutsideRange || recomputeDayBlocked || recomputeDayHighlighted;

        var didStartDateChange = startDate !== this.props.startDate;
        var didEndDateChange = endDate !== this.props.endDate;
        var didFocusChange = focusedInput !== this.props.focusedInput;

        if (numberOfMonths !== this.props.numberOfMonths || enableOutsideDays !== this.props.enableOutsideDays || initialVisibleMonth !== this.props.initialVisibleMonth && !this.props.focusedInput && didFocusChange) {
          var newMonthState = this.getStateForNewMonth(nextProps);
          var currentMonth = newMonthState.currentMonth;
          visibleDays = newMonthState.visibleDays;
          this.setState({
            currentMonth: currentMonth,
            visibleDays: visibleDays
          });
        }

        var modifiers = {};

        if (didStartDateChange) {
          modifiers = this.deleteModifier(modifiers, this.props.startDate, 'selected-start');
          modifiers = this.addModifier(modifiers, startDate, 'selected-start');
        }

        if (didEndDateChange) {
          modifiers = this.deleteModifier(modifiers, this.props.endDate, 'selected-end');
          modifiers = this.addModifier(modifiers, endDate, 'selected-end');
        }

        if (didStartDateChange || didEndDateChange) {
          if (this.props.startDate && this.props.endDate) {
            modifiers = this.deleteModifierFromRange(modifiers, this.props.startDate, this.props.endDate.clone().add(1, 'day'), 'selected-span');
          }

          if (startDate && endDate) {
            modifiers = this.deleteModifierFromRange(modifiers, startDate, endDate.clone().add(1, 'day'), 'hovered-span');

            modifiers = this.addModifierToRange(modifiers, startDate.clone().add(1, 'day'), endDate, 'selected-span');
          }
        }

        if (!this.isTouchDevice && didStartDateChange && startDate && !endDate) {
          var startSpan = startDate.clone().add(1, 'day');
          var endSpan = startDate.clone().add(minimumNights + 1, 'days');
          modifiers = this.addModifierToRange(modifiers, startSpan, endSpan, 'after-hovered-start');
        }

        if (minimumNights > 0 || minimumNights !== this.props.minimumNights) {
          if (didFocusChange || didStartDateChange) {
            var _startSpan = this.props.startDate ? this.props.startDate : this.today;
            modifiers = this.deleteModifierFromRange(modifiers, _startSpan, _startSpan.clone().add(minimumNights, 'days'), 'blocked-minimum-nights');
          }

          if (startDate && focusedInput === _constants.END_DATE) {
            modifiers = this.addModifierToRange(modifiers, startDate, startDate.clone().add(minimumNights, 'days'), 'blocked-minimum-nights');
          }
        }

        if (didFocusChange || recomputePropModifiers) {
          (0, _object2['default'])(visibleDays).forEach(function (days) {
            Object.keys(days).forEach(function (day) {
              var momentObj = (0, _moment2['default'])(day);

              if (_this2.isBlocked(momentObj)) {
                modifiers = _this2.addModifier(modifiers, momentObj, 'blocked');
              } else {
                modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked');
              }

              if (didFocusChange || recomputeOutsideRange) {
                if (isOutsideRange(momentObj)) {
                  modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-out-of-range');
                } else {
                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-out-of-range');
                }
              }

              if (didFocusChange || recomputeDayBlocked) {
                if (isDayBlocked(momentObj)) {
                  modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-calendar');
                } else {
                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-calendar');
                }
              }

              if (didFocusChange || recomputeDayHighlighted) {
                if (isDayHighlighted(momentObj)) {
                  modifiers = _this2.addModifier(modifiers, momentObj, 'highlighted-calendar');
                } else {
                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'highlighted-calendar');
                }
              }
            });
          });
        }

        var today = (0, _moment2['default'])();
        if (!(0, _isSameDay2['default'])(this.today, today)) {
          modifiers = this.deleteModifier(modifiers, this.today, 'today');
          modifiers = this.addModifier(modifiers, today, 'today');
          this.today = today;
        }

        if (Object.keys(modifiers).length > 0) {
          this.setState({
            visibleDays: (0, _object4['default'])({}, visibleDays, modifiers)
          });
        }

        if (didFocusChange || phrases !== this.props.phrases) {
          // set the appropriate CalendarDay phrase based on focusedInput
          var chooseAvailableDate = getChooseAvailableDatePhrase(phrases, focusedInput);

          this.setState({
            phrases: (0, _object4['default'])({}, phrases, {
              chooseAvailableDate: chooseAvailableDate
            })
          });
        }
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'onDayClick',
    value: function () {
      function onDayClick(day, e) {
        var _props = this.props,
            keepOpenOnDateSelect = _props.keepOpenOnDateSelect,
            minimumNights = _props.minimumNights,
            onBlur = _props.onBlur;

        if (e) e.preventDefault();
        if (this.isBlocked(day)) return;

        var _props2 = this.props,
            focusedInput = _props2.focusedInput,
            onFocusChange = _props2.onFocusChange,
            onClose = _props2.onClose;
        var _props3 = this.props,
            startDate = _props3.startDate,
            endDate = _props3.endDate;

        if (focusedInput === _constants.START_DATE) {
          onFocusChange(_constants.END_DATE);

          startDate = day;

          if ((0, _isInclusivelyAfterDay2['default'])(day, endDate)) {
            endDate = null;
          }
        } else if (focusedInput === _constants.END_DATE) {
          var firstAllowedEndDate = startDate && startDate.clone().add(minimumNights, 'days');

          if (!startDate) {
            endDate = day;
            onFocusChange(_constants.START_DATE);
          } else if ((0, _isInclusivelyAfterDay2['default'])(day, firstAllowedEndDate)) {
            endDate = day;
            if (!keepOpenOnDateSelect) {
              onFocusChange(null);
              onClose({ startDate: startDate, endDate: endDate });
            }
          } else {
            startDate = day;
            endDate = null;
          }
        }

        this.props.onDatesChange({ startDate: startDate, endDate: endDate });
        onBlur();
      }

      return onDayClick;
    }()
  }, {
    key: 'onDayMouseEnter',
    value: function () {
      function onDayMouseEnter(day) {
        if (this.isTouchDevice) return;
        var _props4 = this.props,
            startDate = _props4.startDate,
            endDate = _props4.endDate,
            focusedInput = _props4.focusedInput,
            minimumNights = _props4.minimumNights;
        var _state = this.state,
            hoverDate = _state.hoverDate,
            visibleDays = _state.visibleDays;

        if (focusedInput) {
          var modifiers = {};
          modifiers = this.deleteModifier(modifiers, hoverDate, 'hovered');
          modifiers = this.addModifier(modifiers, day, 'hovered');

          if (startDate && !endDate && focusedInput === _constants.END_DATE) {
            if ((0, _isAfterDay2['default'])(hoverDate, startDate)) {
              var endSpan = hoverDate.clone().add(1, 'day');
              modifiers = this.deleteModifierFromRange(modifiers, startDate, endSpan, 'hovered-span');
            }

            if (!this.isBlocked(day) && (0, _isAfterDay2['default'])(day, startDate)) {
              var _endSpan = day.clone().add(1, 'day');
              modifiers = this.addModifierToRange(modifiers, startDate, _endSpan, 'hovered-span');
            }
          }

          if (!startDate && endDate && focusedInput === _constants.START_DATE) {
            if ((0, _isBeforeDay2['default'])(hoverDate, endDate)) {
              modifiers = this.deleteModifierFromRange(modifiers, hoverDate, endDate, 'hovered-span');
            }

            if (!this.isBlocked(day) && (0, _isBeforeDay2['default'])(day, endDate)) {
              modifiers = this.addModifierToRange(modifiers, day, endDate, 'hovered-span');
            }
          }

          if (startDate) {
            var startSpan = startDate.clone().add(1, 'day');
            var _endSpan2 = startDate.clone().add(minimumNights + 1, 'days');
            modifiers = this.deleteModifierFromRange(modifiers, startSpan, _endSpan2, 'after-hovered-start');

            if ((0, _isSameDay2['default'])(day, startDate)) {
              var newStartSpan = startDate.clone().add(1, 'day');
              var newEndSpan = startDate.clone().add(minimumNights + 1, 'days');
              modifiers = this.addModifierToRange(modifiers, newStartSpan, newEndSpan, 'after-hovered-start');
            }
          }

          this.setState({
            hoverDate: day,
            visibleDays: (0, _object4['default'])({}, visibleDays, modifiers)
          });
        }
      }

      return onDayMouseEnter;
    }()
  }, {
    key: 'onDayMouseLeave',
    value: function () {
      function onDayMouseLeave(day) {
        var _props5 = this.props,
            startDate = _props5.startDate,
            endDate = _props5.endDate,
            minimumNights = _props5.minimumNights;
        var _state2 = this.state,
            hoverDate = _state2.hoverDate,
            visibleDays = _state2.visibleDays;

        if (this.isTouchDevice || !hoverDate) return;

        var modifiers = {};
        modifiers = this.deleteModifier(modifiers, hoverDate, 'hovered');

        if (startDate && !endDate && (0, _isAfterDay2['default'])(hoverDate, startDate)) {
          var endSpan = hoverDate.clone().add(1, 'day');
          modifiers = this.deleteModifierFromRange(modifiers, startDate, endSpan, 'hovered-span');
        }

        if (!startDate && endDate && (0, _isAfterDay2['default'])(endDate, hoverDate)) {
          modifiers = this.deleteModifierFromRange(modifiers, hoverDate, endDate, 'hovered-span');
        }

        if (startDate && (0, _isSameDay2['default'])(day, startDate)) {
          var startSpan = startDate.clone().add(1, 'day');
          var _endSpan3 = startDate.clone().add(minimumNights + 1, 'days');
          modifiers = this.deleteModifierFromRange(modifiers, startSpan, _endSpan3, 'after-hovered-start');
        }

        this.setState({
          hoverDate: null,
          visibleDays: (0, _object4['default'])({}, visibleDays, modifiers)
        });
      }

      return onDayMouseLeave;
    }()
  }, {
    key: 'onPrevMonthClick',
    value: function () {
      function onPrevMonthClick() {
        var _props6 = this.props,
            onPrevMonthClick = _props6.onPrevMonthClick,
            numberOfMonths = _props6.numberOfMonths,
            enableOutsideDays = _props6.enableOutsideDays;
        var _state3 = this.state,
            currentMonth = _state3.currentMonth,
            visibleDays = _state3.visibleDays;

        var newVisibleDays = {};
        Object.keys(visibleDays).sort().slice(0, numberOfMonths + 1).forEach(function (month) {
          newVisibleDays[month] = visibleDays[month];
        });

        var prevMonth = currentMonth.clone().subtract(2, 'months');
        var prevMonthVisibleDays = (0, _getVisibleDays2['default'])(prevMonth, 1, enableOutsideDays, true);

        var newCurrentMonth = currentMonth.clone().subtract(1, 'month');
        this.setState({
          currentMonth: newCurrentMonth,
          visibleDays: (0, _object4['default'])({}, newVisibleDays, this.getModifiers(prevMonthVisibleDays))
        });

        onPrevMonthClick(newCurrentMonth.clone());
      }

      return onPrevMonthClick;
    }()
  }, {
    key: 'onNextMonthClick',
    value: function () {
      function onNextMonthClick() {
        var _props7 = this.props,
            onNextMonthClick = _props7.onNextMonthClick,
            numberOfMonths = _props7.numberOfMonths,
            enableOutsideDays = _props7.enableOutsideDays;
        var _state4 = this.state,
            currentMonth = _state4.currentMonth,
            visibleDays = _state4.visibleDays;

        var newVisibleDays = {};
        Object.keys(visibleDays).sort().slice(1).forEach(function (month) {
          newVisibleDays[month] = visibleDays[month];
        });

        var nextMonth = currentMonth.clone().add(numberOfMonths + 1, 'month');
        var nextMonthVisibleDays = (0, _getVisibleDays2['default'])(nextMonth, 1, enableOutsideDays, true);

        var newCurrentMonth = currentMonth.clone().add(1, 'month');
        this.setState({
          currentMonth: newCurrentMonth,
          visibleDays: (0, _object4['default'])({}, newVisibleDays, this.getModifiers(nextMonthVisibleDays))
        });

        onNextMonthClick(newCurrentMonth.clone());
      }

      return onNextMonthClick;
    }()
  }, {
    key: 'onMultiplyScrollableMonths',
    value: function () {
      function onMultiplyScrollableMonths() {
        var _props8 = this.props,
            numberOfMonths = _props8.numberOfMonths,
            enableOutsideDays = _props8.enableOutsideDays;
        var _state5 = this.state,
            currentMonth = _state5.currentMonth,
            visibleDays = _state5.visibleDays;

        var numberOfVisibleMonths = Object.keys(visibleDays).length;
        var nextMonth = currentMonth.clone().add(numberOfVisibleMonths, 'month');
        var newVisibleDays = (0, _getVisibleDays2['default'])(nextMonth, numberOfMonths, enableOutsideDays, true);

        this.setState({
          visibleDays: (0, _object4['default'])({}, visibleDays, this.getModifiers(newVisibleDays))
        });
      }

      return onMultiplyScrollableMonths;
    }()
  }, {
    key: 'getFirstFocusableDay',
    value: function () {
      function getFirstFocusableDay(newMonth) {
        var _this3 = this;

        var _props9 = this.props,
            startDate = _props9.startDate,
            endDate = _props9.endDate,
            focusedInput = _props9.focusedInput,
            minimumNights = _props9.minimumNights,
            numberOfMonths = _props9.numberOfMonths;

        var focusedDate = newMonth.clone().startOf('month');
        if (focusedInput === _constants.START_DATE && startDate) {
          focusedDate = startDate.clone();
        } else if (focusedInput === _constants.END_DATE && !endDate && startDate) {
          focusedDate = startDate.clone().add(minimumNights, 'days');
        } else if (focusedInput === _constants.END_DATE && endDate) {
          focusedDate = endDate.clone();
        }

        if (this.isBlocked(focusedDate)) {
          var days = [];
          var lastVisibleDay = newMonth.clone().add(numberOfMonths - 1, 'months').endOf('month');
          var currentDay = focusedDate.clone();
          while (!(0, _isAfterDay2['default'])(currentDay, lastVisibleDay)) {
            currentDay = currentDay.clone().add(1, 'day');
            days.push(currentDay);
          }

          var viableDays = days.filter(function (day) {
            return !_this3.isBlocked(day);
          });

          if (viableDays.length > 0) focusedDate = viableDays[0];
        }

        return focusedDate;
      }

      return getFirstFocusableDay;
    }()
  }, {
    key: 'getModifiers',
    value: function () {
      function getModifiers(visibleDays) {
        var _this4 = this;

        var modifiers = {};
        Object.keys(visibleDays).forEach(function (month) {
          modifiers[month] = {};
          visibleDays[month].forEach(function (day) {
            modifiers[month][(0, _toISODateString2['default'])(day)] = _this4.getModifiersForDay(day);
          });
        });

        return modifiers;
      }

      return getModifiers;
    }()
  }, {
    key: 'getModifiersForDay',
    value: function () {
      function getModifiersForDay(day) {
        var _this5 = this;

        return new Set(Object.keys(this.modifiers).filter(function (modifier) {
          return _this5.modifiers[modifier](day);
        }));
      }

      return getModifiersForDay;
    }()
  }, {
    key: 'getStateForNewMonth',
    value: function () {
      function getStateForNewMonth(nextProps) {
        var _this6 = this;

        var initialVisibleMonth = nextProps.initialVisibleMonth,
            numberOfMonths = nextProps.numberOfMonths,
            enableOutsideDays = nextProps.enableOutsideDays,
            orientation = nextProps.orientation,
            startDate = nextProps.startDate;

        var initialVisibleMonthThunk = initialVisibleMonth || (startDate ? function () {
          return startDate;
        } : function () {
          return _this6.today;
        });
        var currentMonth = initialVisibleMonthThunk();
        var withoutTransitionMonths = orientation === _constants.VERTICAL_SCROLLABLE;
        var visibleDays = this.getModifiers((0, _getVisibleDays2['default'])(currentMonth, numberOfMonths, enableOutsideDays, withoutTransitionMonths));
        return { currentMonth: currentMonth, visibleDays: visibleDays };
      }

      return getStateForNewMonth;
    }()
  }, {
    key: 'setDayPickerRef',
    value: function () {
      function setDayPickerRef(ref) {
        this.dayPicker = ref;
      }

      return setDayPickerRef;
    }()
  }, {
    key: 'addModifier',
    value: function () {
      function addModifier(updatedDays, day, modifier) {
        var _props10 = this.props,
            numberOfVisibleMonths = _props10.numberOfMonths,
            enableOutsideDays = _props10.enableOutsideDays,
            orientation = _props10.orientation;
        var _state6 = this.state,
            firstVisibleMonth = _state6.currentMonth,
            visibleDays = _state6.visibleDays;

        var currentMonth = firstVisibleMonth;
        var numberOfMonths = numberOfVisibleMonths;
        if (orientation !== _constants.VERTICAL_SCROLLABLE) {
          currentMonth = currentMonth.clone().subtract(1, 'month');
          numberOfMonths += 2;
        }
        if (!day || !(0, _isDayVisible2['default'])(day, currentMonth, numberOfMonths, enableOutsideDays)) {
          return updatedDays;
        }

        var iso = (0, _toISODateString2['default'])(day);

        var updatedDaysAfterAddition = (0, _object4['default'])({}, updatedDays);
        if (enableOutsideDays) {
          var monthsToUpdate = Object.keys(visibleDays).filter(function (monthKey) {
            return Object.keys(visibleDays[monthKey]).indexOf(iso) > -1;
          });

          updatedDaysAfterAddition = monthsToUpdate.reduce(function (days, monthIso) {
            var month = updatedDays[monthIso] || visibleDays[monthIso];
            var modifiers = new Set(month[iso]);
            modifiers.add(modifier);
            return (0, _object4['default'])({}, days, _defineProperty({}, monthIso, (0, _object4['default'])({}, month, _defineProperty({}, iso, modifiers))));
          }, updatedDaysAfterAddition);
        } else {
          var monthIso = (0, _toISOMonthString2['default'])(day);
          var month = updatedDays[monthIso] || visibleDays[monthIso];

          var modifiers = new Set(month[iso]);
          modifiers.add(modifier);
          updatedDaysAfterAddition = (0, _object4['default'])({}, updatedDaysAfterAddition, _defineProperty({}, monthIso, (0, _object4['default'])({}, month, _defineProperty({}, iso, modifiers))));
        }

        return updatedDaysAfterAddition;
      }

      return addModifier;
    }()
  }, {
    key: 'addModifierToRange',
    value: function () {
      function addModifierToRange(updatedDays, start, end, modifier) {
        var days = updatedDays;

        var spanStart = start.clone();
        while ((0, _isBeforeDay2['default'])(spanStart, end)) {
          days = this.addModifier(days, spanStart, modifier);
          spanStart = spanStart.clone().add(1, 'day');
        }

        return days;
      }

      return addModifierToRange;
    }()
  }, {
    key: 'deleteModifier',
    value: function () {
      function deleteModifier(updatedDays, day, modifier) {
        var _props11 = this.props,
            numberOfVisibleMonths = _props11.numberOfMonths,
            enableOutsideDays = _props11.enableOutsideDays,
            orientation = _props11.orientation;
        var _state7 = this.state,
            firstVisibleMonth = _state7.currentMonth,
            visibleDays = _state7.visibleDays;

        var currentMonth = firstVisibleMonth;
        var numberOfMonths = numberOfVisibleMonths;
        if (orientation !== _constants.VERTICAL_SCROLLABLE) {
          currentMonth = currentMonth.clone().subtract(1, 'month');
          numberOfMonths += 2;
        }
        if (!day || !(0, _isDayVisible2['default'])(day, currentMonth, numberOfMonths, enableOutsideDays)) {
          return updatedDays;
        }

        var iso = (0, _toISODateString2['default'])(day);

        var updatedDaysAfterDeletion = (0, _object4['default'])({}, updatedDays);
        if (enableOutsideDays) {
          var monthsToUpdate = Object.keys(visibleDays).filter(function (monthKey) {
            return Object.keys(visibleDays[monthKey]).indexOf(iso) > -1;
          });

          updatedDaysAfterDeletion = monthsToUpdate.reduce(function (days, monthIso) {
            var month = updatedDays[monthIso] || visibleDays[monthIso];
            var modifiers = new Set(month[iso]);
            modifiers['delete'](modifier);
            return (0, _object4['default'])({}, days, _defineProperty({}, monthIso, (0, _object4['default'])({}, month, _defineProperty({}, iso, modifiers))));
          }, updatedDaysAfterDeletion);
        } else {
          var monthIso = (0, _toISOMonthString2['default'])(day);
          var month = updatedDays[monthIso] || visibleDays[monthIso];

          var modifiers = new Set(month[iso]);
          modifiers['delete'](modifier);
          updatedDaysAfterDeletion = (0, _object4['default'])({}, updatedDaysAfterDeletion, _defineProperty({}, monthIso, (0, _object4['default'])({}, month, _defineProperty({}, iso, modifiers))));
        }

        return updatedDaysAfterDeletion;
      }

      return deleteModifier;
    }()
  }, {
    key: 'deleteModifierFromRange',
    value: function () {
      function deleteModifierFromRange(updatedDays, start, end, modifier) {
        var days = updatedDays;

        var spanStart = start.clone();
        while ((0, _isBeforeDay2['default'])(spanStart, end)) {
          days = this.deleteModifier(days, spanStart, modifier);
          spanStart = spanStart.clone().add(1, 'day');
        }

        return days;
      }

      return deleteModifierFromRange;
    }()
  }, {
    key: 'doesNotMeetMinimumNights',
    value: function () {
      function doesNotMeetMinimumNights(day) {
        var _props12 = this.props,
            startDate = _props12.startDate,
            isOutsideRange = _props12.isOutsideRange,
            focusedInput = _props12.focusedInput,
            minimumNights = _props12.minimumNights;

        if (focusedInput !== _constants.END_DATE) return false;

        if (startDate) {
          var dayDiff = day.diff(startDate.clone().startOf('day').hour(12), 'days');
          return dayDiff < minimumNights && dayDiff >= 0;
        }
        return isOutsideRange((0, _moment2['default'])(day).subtract(minimumNights, 'days'));
      }

      return doesNotMeetMinimumNights;
    }()
  }, {
    key: 'isDayAfterHoveredStartDate',
    value: function () {
      function isDayAfterHoveredStartDate(day) {
        var _props13 = this.props,
            startDate = _props13.startDate,
            endDate = _props13.endDate,
            minimumNights = _props13.minimumNights;

        var _ref = this.state || {},
            hoverDate = _ref.hoverDate;

        return !!startDate && !endDate && !this.isBlocked(day) && (0, _isNextDay2['default'])(hoverDate, day) && minimumNights > 0 && (0, _isSameDay2['default'])(hoverDate, startDate);
      }

      return isDayAfterHoveredStartDate;
    }()
  }, {
    key: 'isEndDate',
    value: function () {
      function isEndDate(day) {
        return (0, _isSameDay2['default'])(day, this.props.endDate);
      }

      return isEndDate;
    }()
  }, {
    key: 'isHovered',
    value: function () {
      function isHovered(day) {
        var _ref2 = this.state || {},
            hoverDate = _ref2.hoverDate;

        var focusedInput = this.props.focusedInput;

        return !!focusedInput && (0, _isSameDay2['default'])(day, hoverDate);
      }

      return isHovered;
    }()
  }, {
    key: 'isInHoveredSpan',
    value: function () {
      function isInHoveredSpan(day) {
        var _props14 = this.props,
            startDate = _props14.startDate,
            endDate = _props14.endDate;

        var _ref3 = this.state || {},
            hoverDate = _ref3.hoverDate;

        var isForwardRange = !!startDate && !endDate && (day.isBetween(startDate, hoverDate) || (0, _isSameDay2['default'])(hoverDate, day));
        var isBackwardRange = !!endDate && !startDate && (day.isBetween(hoverDate, endDate) || (0, _isSameDay2['default'])(hoverDate, day));

        var isValidDayHovered = hoverDate && !this.isBlocked(hoverDate);

        return (isForwardRange || isBackwardRange) && isValidDayHovered;
      }

      return isInHoveredSpan;
    }()
  }, {
    key: 'isInSelectedSpan',
    value: function () {
      function isInSelectedSpan(day) {
        var _props15 = this.props,
            startDate = _props15.startDate,
            endDate = _props15.endDate;

        return day.isBetween(startDate, endDate);
      }

      return isInSelectedSpan;
    }()
  }, {
    key: 'isLastInRange',
    value: function () {
      function isLastInRange(day) {
        return this.isInSelectedSpan(day) && (0, _isNextDay2['default'])(day, this.props.endDate);
      }

      return isLastInRange;
    }()
  }, {
    key: 'isStartDate',
    value: function () {
      function isStartDate(day) {
        return (0, _isSameDay2['default'])(day, this.props.startDate);
      }

      return isStartDate;
    }()
  }, {
    key: 'isBlocked',
    value: function () {
      function isBlocked(day) {
        var _props16 = this.props,
            isDayBlocked = _props16.isDayBlocked,
            isOutsideRange = _props16.isOutsideRange;

        return isDayBlocked(day) || isOutsideRange(day) || this.doesNotMeetMinimumNights(day);
      }

      return isBlocked;
    }()
  }, {
    key: 'isToday',
    value: function () {
      function isToday(day) {
        return (0, _isSameDay2['default'])(day, this.today);
      }

      return isToday;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props17 = this.props,
            numberOfMonths = _props17.numberOfMonths,
            orientation = _props17.orientation,
            monthFormat = _props17.monthFormat,
            renderMonth = _props17.renderMonth,
            navPrev = _props17.navPrev,
            navNext = _props17.navNext,
            onOutsideClick = _props17.onOutsideClick,
            withPortal = _props17.withPortal,
            enableOutsideDays = _props17.enableOutsideDays,
            firstDayOfWeek = _props17.firstDayOfWeek,
            hideKeyboardShortcutsPanel = _props17.hideKeyboardShortcutsPanel,
            daySize = _props17.daySize,
            focusedInput = _props17.focusedInput,
            renderDay = _props17.renderDay,
            renderCalendarInfo = _props17.renderCalendarInfo,
            onBlur = _props17.onBlur,
            isFocused = _props17.isFocused,
            showKeyboardShortcuts = _props17.showKeyboardShortcuts,
            isRTL = _props17.isRTL,
            weekDayFormat = _props17.weekDayFormat;
        var _state8 = this.state,
            currentMonth = _state8.currentMonth,
            phrases = _state8.phrases,
            visibleDays = _state8.visibleDays;

        return _react2['default'].createElement(_DayPicker2['default'], {
          ref: this.setDayPickerRef,
          orientation: orientation,
          enableOutsideDays: enableOutsideDays,
          modifiers: visibleDays,
          numberOfMonths: numberOfMonths,
          onDayClick: this.onDayClick,
          onDayMouseEnter: this.onDayMouseEnter,
          onDayMouseLeave: this.onDayMouseLeave,
          onPrevMonthClick: this.onPrevMonthClick,
          onNextMonthClick: this.onNextMonthClick,
          onMultiplyScrollableMonths: this.onMultiplyScrollableMonths,
          monthFormat: monthFormat,
          renderMonth: renderMonth,
          withPortal: withPortal,
          hidden: !focusedInput,
          initialVisibleMonth: function () {
            function initialVisibleMonth() {
              return currentMonth;
            }

            return initialVisibleMonth;
          }(),
          daySize: daySize,
          onOutsideClick: onOutsideClick,
          navPrev: navPrev,
          navNext: navNext,
          renderDay: renderDay,
          renderCalendarInfo: renderCalendarInfo,
          firstDayOfWeek: firstDayOfWeek,
          hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
          isFocused: isFocused,
          getFirstFocusableDay: this.getFirstFocusableDay,
          onBlur: onBlur,
          showKeyboardShortcuts: showKeyboardShortcuts,
          phrases: phrases,
          isRTL: isRTL,
          weekDayFormat: weekDayFormat
        });
      }

      return render;
    }()
  }]);

  return DayPickerRangeController;
}(_react2['default'].Component);

exports['default'] = DayPickerRangeController;

DayPickerRangeController.propTypes = propTypes;
DayPickerRangeController.defaultProps = defaultProps;

/***/ })
/******/ ]);

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = getVisibleDays;

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _toISOMonthString = __webpack_require__(152);

var _toISOMonthString2 = _interopRequireDefault(_toISOMonthString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function getVisibleDays(month, numberOfMonths, enableOutsideDays, withoutTransitionMonths) {
  if (!_moment2['default'].isMoment(month)) return {};

  var visibleDaysByMonth = {};
  var currentMonth = withoutTransitionMonths ? month.clone() : month.clone().subtract(1, 'month');
  for (var i = 0; i < (withoutTransitionMonths ? numberOfMonths : numberOfMonths + 2); i += 1) {
    var visibleDays = [];

    // set utc offset to get correct dates in future (when timezone changes)
    var baseDate = currentMonth.clone();
    var firstOfMonth = baseDate.clone().startOf('month').hour(12);
    var lastOfMonth = baseDate.clone().endOf('month').hour(12);

    var currentDay = firstOfMonth.clone();

    // days belonging to the previous month
    if (enableOutsideDays) {
      for (var j = 0; j < currentDay.weekday(); j += 1) {
        var prevDay = currentDay.clone().subtract(j + 1, 'day');
        visibleDays.unshift(prevDay);
      }
    }

    while (currentDay < lastOfMonth) {
      visibleDays.push(currentDay.clone());
      currentDay.add(1, 'day');
    }

    if (enableOutsideDays) {
      // weekday() returns the index of the day of the week according to the locale
      // this means if the week starts on Monday, weekday() will return 0 for a Monday date, not 1
      if (currentDay.weekday() !== 0) {
        // days belonging to the next month
        for (var k = currentDay.weekday(), count = 0; k < 7; k += 1, count += 1) {
          var nextDay = currentDay.clone().add(count, 'day');
          visibleDays.push(nextDay);
        }
      }
    }

    visibleDaysByMonth[(0, _toISOMonthString2['default'])(currentMonth)] = visibleDays;
    currentMonth = currentMonth.clone().add(1, 'month');
  }

  return visibleDaysByMonth;
}

/***/ }),
/* 553 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getCalendarMonthWidth;
var CALENDAR_MONTH_PADDING = 9;

function getCalendarMonthWidth(daySize) {
  return 7 * (daySize + 1) + 2 * (CALENDAR_MONTH_PADDING + 1);
}

/***/ }),
/* 554 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getTransformStyles;
function getTransformStyles(transformValue) {
  return {
    transform: transformValue,
    msTransform: transformValue,
    MozTransform: transformValue,
    WebkitTransform: transformValue
  };
}

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 63);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(2);

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(24);

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(12);

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(27);

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(6);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(37);

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(44);

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(0);

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(101);

/***/ }),
/* 9 */,
/* 10 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(68);

/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(86);

/***/ }),
/* 13 */,
/* 14 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(111);

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(149);

/***/ }),
/* 19 */,
/* 20 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(116);

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(152);

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(150);

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(553);

/***/ }),
/* 29 */,
/* 30 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(554);

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(969);

/***/ }),
/* 51 */,
/* 52 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(556);

/***/ }),
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _object = __webpack_require__(24);

var _object2 = _interopRequireDefault(_object);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactAddonsShallowCompare = __webpack_require__(14);

var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);

var _reactMomentProptypes = __webpack_require__(10);

var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);

var _airbnbPropTypes = __webpack_require__(1);

var _moment = __webpack_require__(7);

var _moment2 = _interopRequireDefault(_moment);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _consolidatedEvents = __webpack_require__(18);

var _defaultPhrases = __webpack_require__(3);

var _getPhrasePropTypes = __webpack_require__(5);

var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);

var _CalendarMonth = __webpack_require__(52);

var _CalendarMonth2 = _interopRequireDefault(_CalendarMonth);

var _isTransitionEndSupported = __webpack_require__(50);

var _isTransitionEndSupported2 = _interopRequireDefault(_isTransitionEndSupported);

var _getTransformStyles = __webpack_require__(30);

var _getTransformStyles2 = _interopRequireDefault(_getTransformStyles);

var _getCalendarMonthWidth = __webpack_require__(28);

var _getCalendarMonthWidth2 = _interopRequireDefault(_getCalendarMonthWidth);

var _toISOMonthString = __webpack_require__(23);

var _toISOMonthString2 = _interopRequireDefault(_toISOMonthString);

var _isAfterDay = __webpack_require__(20);

var _isAfterDay2 = _interopRequireDefault(_isAfterDay);

var _ScrollableOrientationShape = __webpack_require__(8);

var _ScrollableOrientationShape2 = _interopRequireDefault(_ScrollableOrientationShape);

var _DayOfWeekShape = __webpack_require__(12);

var _DayOfWeekShape2 = _interopRequireDefault(_DayOfWeekShape);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
  enableOutsideDays: _propTypes2['default'].bool,
  firstVisibleMonthIndex: _propTypes2['default'].number,
  initialMonth: _reactMomentProptypes2['default'].momentObj,
  isAnimating: _propTypes2['default'].bool,
  numberOfMonths: _propTypes2['default'].number,
  modifiers: _propTypes2['default'].object,
  orientation: _ScrollableOrientationShape2['default'],
  onDayClick: _propTypes2['default'].func,
  onDayMouseEnter: _propTypes2['default'].func,
  onDayMouseLeave: _propTypes2['default'].func,
  onMonthTransitionEnd: _propTypes2['default'].func,
  renderMonth: _propTypes2['default'].func,
  renderDay: _propTypes2['default'].func,
  transformValue: _propTypes2['default'].string,
  daySize: _airbnbPropTypes.nonNegativeInteger,
  focusedDate: _reactMomentProptypes2['default'].momentObj, // indicates focusable day
  isFocused: _propTypes2['default'].bool, // indicates whether or not to move focus to focusable day
  firstDayOfWeek: _DayOfWeekShape2['default'],

  // i18n
  monthFormat: _propTypes2['default'].string,
  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.CalendarDayPhrases))
});

var defaultProps = {
  enableOutsideDays: false,
  firstVisibleMonthIndex: 0,
  initialMonth: (0, _moment2['default'])(),
  isAnimating: false,
  numberOfMonths: 1,
  modifiers: {},
  orientation: _constants.HORIZONTAL_ORIENTATION,
  onDayClick: function () {
    function onDayClick() {}

    return onDayClick;
  }(),
  onDayMouseEnter: function () {
    function onDayMouseEnter() {}

    return onDayMouseEnter;
  }(),
  onDayMouseLeave: function () {
    function onDayMouseLeave() {}

    return onDayMouseLeave;
  }(),
  onMonthTransitionEnd: function () {
    function onMonthTransitionEnd() {}

    return onMonthTransitionEnd;
  }(),

  renderMonth: null,
  renderDay: null,
  transformValue: 'none',
  daySize: _constants.DAY_SIZE,
  focusedDate: null,
  isFocused: false,
  firstDayOfWeek: null,

  // i18n
  monthFormat: 'MMMM YYYY', // english locale
  phrases: _defaultPhrases.CalendarDayPhrases
};

function getMonths(initialMonth, numberOfMonths, withoutTransitionMonths) {
  var month = initialMonth.clone();
  if (!withoutTransitionMonths) month = month.subtract(1, 'month');

  var months = [];
  for (var i = 0; i < (withoutTransitionMonths ? numberOfMonths : numberOfMonths + 2); i += 1) {
    months.push(month);
    month = month.clone().add(1, 'month');
  }

  return months;
}

var CalendarMonthGrid = function (_React$Component) {
  _inherits(CalendarMonthGrid, _React$Component);

  function CalendarMonthGrid(props) {
    _classCallCheck(this, CalendarMonthGrid);

    var _this = _possibleConstructorReturn(this, (CalendarMonthGrid.__proto__ || Object.getPrototypeOf(CalendarMonthGrid)).call(this, props));

    var withoutTransitionMonths = props.orientation === _constants.VERTICAL_SCROLLABLE;
    _this.state = {
      months: getMonths(props.initialMonth, props.numberOfMonths, withoutTransitionMonths)
    };

    _this.isTransitionEndSupported = (0, _isTransitionEndSupported2['default'])();
    _this.onTransitionEnd = _this.onTransitionEnd.bind(_this);
    _this.setContainerRef = _this.setContainerRef.bind(_this);
    return _this;
  }

  _createClass(CalendarMonthGrid, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        this.eventHandle = (0, _consolidatedEvents.addEventListener)(this.container, 'transitionend', this.onTransitionEnd);
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(nextProps) {
        var initialMonth = nextProps.initialMonth,
            numberOfMonths = nextProps.numberOfMonths,
            orientation = nextProps.orientation;
        var months = this.state.months;

        var hasMonthChanged = !this.props.initialMonth.isSame(initialMonth, 'month');
        var hasNumberOfMonthsChanged = this.props.numberOfMonths !== numberOfMonths;
        var newMonths = months;

        if (hasMonthChanged && !hasNumberOfMonthsChanged) {
          if ((0, _isAfterDay2['default'])(initialMonth, this.props.initialMonth)) {
            newMonths = months.slice(1);
            newMonths.push(months[months.length - 1].clone().add(1, 'month'));
          } else {
            newMonths = months.slice(0, months.length - 1);
            newMonths.unshift(months[0].clone().subtract(1, 'month'));
          }
        }

        if (hasNumberOfMonthsChanged) {
          var withoutTransitionMonths = orientation === _constants.VERTICAL_SCROLLABLE;
          newMonths = getMonths(initialMonth, numberOfMonths, withoutTransitionMonths);
        }

        this.setState({
          months: newMonths
        });
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'shouldComponentUpdate',
    value: function () {
      function shouldComponentUpdate(nextProps, nextState) {
        return (0, _reactAddonsShallowCompare2['default'])(this, nextProps, nextState);
      }

      return shouldComponentUpdate;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate() {
        var _props = this.props,
            isAnimating = _props.isAnimating,
            onMonthTransitionEnd = _props.onMonthTransitionEnd;

        // For IE9, immediately call onMonthTransitionEnd instead of
        // waiting for the animation to complete

        if (!this.isTransitionEndSupported && isAnimating) {
          onMonthTransitionEnd();
        }
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        (0, _consolidatedEvents.removeEventListener)(this.eventHandle);
      }

      return componentWillUnmount;
    }()
  }, {
    key: 'onTransitionEnd',
    value: function () {
      function onTransitionEnd() {
        this.props.onMonthTransitionEnd();
      }

      return onTransitionEnd;
    }()
  }, {
    key: 'setContainerRef',
    value: function () {
      function setContainerRef(ref) {
        this.container = ref;
      }

      return setContainerRef;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props2 = this.props,
            enableOutsideDays = _props2.enableOutsideDays,
            firstVisibleMonthIndex = _props2.firstVisibleMonthIndex,
            isAnimating = _props2.isAnimating,
            modifiers = _props2.modifiers,
            numberOfMonths = _props2.numberOfMonths,
            monthFormat = _props2.monthFormat,
            orientation = _props2.orientation,
            transformValue = _props2.transformValue,
            daySize = _props2.daySize,
            onDayMouseEnter = _props2.onDayMouseEnter,
            onDayMouseLeave = _props2.onDayMouseLeave,
            onDayClick = _props2.onDayClick,
            renderMonth = _props2.renderMonth,
            renderDay = _props2.renderDay,
            onMonthTransitionEnd = _props2.onMonthTransitionEnd,
            firstDayOfWeek = _props2.firstDayOfWeek,
            focusedDate = _props2.focusedDate,
            isFocused = _props2.isFocused,
            phrases = _props2.phrases;
        var months = this.state.months;

        var isVertical = orientation === _constants.VERTICAL_ORIENTATION;
        var isVerticalScrollable = orientation === _constants.VERTICAL_SCROLLABLE;
        var isHorizontal = orientation === _constants.HORIZONTAL_ORIENTATION;

        var className = (0, _classnames2['default'])('CalendarMonthGrid', {
          'CalendarMonthGrid--horizontal': isHorizontal,
          'CalendarMonthGrid--vertical': isVertical,
          'CalendarMonthGrid--vertical-scrollable': isVerticalScrollable,
          'CalendarMonthGrid--animating': isAnimating
        });

        var calendarMonthWidth = (0, _getCalendarMonthWidth2['default'])(daySize);

        var width = isVertical || isVerticalScrollable ? calendarMonthWidth : (numberOfMonths + 2) * calendarMonthWidth;

        var style = (0, _object2['default'])({}, (0, _getTransformStyles2['default'])(transformValue), {
          width: width
        });

        return _react2['default'].createElement('div', {
          ref: this.setContainerRef,
          className: className,
          style: style,
          onTransitionEnd: onMonthTransitionEnd
        }, months.map(function (month, i) {
          var isVisible = i >= firstVisibleMonthIndex && i < firstVisibleMonthIndex + numberOfMonths;
          var monthString = (0, _toISOMonthString2['default'])(month);
          return _react2['default'].createElement(_CalendarMonth2['default'], {
            key: monthString,
            month: month,
            isVisible: isVisible,
            enableOutsideDays: enableOutsideDays,
            modifiers: modifiers[monthString],
            monthFormat: monthFormat,
            orientation: orientation,
            onDayMouseEnter: onDayMouseEnter,
            onDayMouseLeave: onDayMouseLeave,
            onDayClick: onDayClick,
            renderMonth: renderMonth,
            renderDay: renderDay,
            firstDayOfWeek: firstDayOfWeek,
            daySize: daySize,
            focusedDate: isVisible ? focusedDate : null,
            isFocused: isFocused,
            phrases: phrases
          });
        }));
      }

      return render;
    }()
  }]);

  return CalendarMonthGrid;
}(_react2['default'].Component);

exports['default'] = CalendarMonthGrid;

CalendarMonthGrid.propTypes = propTypes;
CalendarMonthGrid.defaultProps = defaultProps;

/***/ })
/******/ ]);

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 62);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __webpack_require__(2);

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __webpack_require__(24);

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = __webpack_require__(68);

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = __webpack_require__(86);

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = __webpack_require__(99);

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = __webpack_require__(111);

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __webpack_require__(12);

/***/ }),

/***/ 22:
/***/ (function(module, exports) {

module.exports = __webpack_require__(102);

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __webpack_require__(27);

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __webpack_require__(6);

/***/ }),

/***/ 47:
/***/ (function(module, exports) {

module.exports = __webpack_require__(970);

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __webpack_require__(37);

/***/ }),

/***/ 51:
/***/ (function(module, exports) {

module.exports = __webpack_require__(557);

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = __webpack_require__(44);

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactAddonsShallowCompare = __webpack_require__(14);

var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);

var _reactMomentProptypes = __webpack_require__(10);

var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);

var _airbnbPropTypes = __webpack_require__(1);

var _moment = __webpack_require__(7);

var _moment2 = _interopRequireDefault(_moment);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _defaultPhrases = __webpack_require__(3);

var _getPhrasePropTypes = __webpack_require__(5);

var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);

var _CalendarDay = __webpack_require__(51);

var _CalendarDay2 = _interopRequireDefault(_CalendarDay);

var _getCalendarMonthWeeks = __webpack_require__(47);

var _getCalendarMonthWeeks2 = _interopRequireDefault(_getCalendarMonthWeeks);

var _isSameDay = __webpack_require__(22);

var _isSameDay2 = _interopRequireDefault(_isSameDay);

var _toISODateString = __webpack_require__(13);

var _toISODateString2 = _interopRequireDefault(_toISODateString);

var _ScrollableOrientationShape = __webpack_require__(8);

var _ScrollableOrientationShape2 = _interopRequireDefault(_ScrollableOrientationShape);

var _DayOfWeekShape = __webpack_require__(12);

var _DayOfWeekShape2 = _interopRequireDefault(_DayOfWeekShape);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint react/no-array-index-key: 0 */

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
  month: _reactMomentProptypes2['default'].momentObj,
  isVisible: _propTypes2['default'].bool,
  enableOutsideDays: _propTypes2['default'].bool,
  modifiers: _propTypes2['default'].object,
  orientation: _ScrollableOrientationShape2['default'],
  daySize: _airbnbPropTypes.nonNegativeInteger,
  onDayClick: _propTypes2['default'].func,
  onDayMouseEnter: _propTypes2['default'].func,
  onDayMouseLeave: _propTypes2['default'].func,
  renderMonth: _propTypes2['default'].func,
  renderDay: _propTypes2['default'].func,
  firstDayOfWeek: _DayOfWeekShape2['default'],

  focusedDate: _reactMomentProptypes2['default'].momentObj, // indicates focusable day
  isFocused: _propTypes2['default'].bool, // indicates whether or not to move focus to focusable day

  // i18n
  monthFormat: _propTypes2['default'].string,
  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.CalendarDayPhrases))
});

var defaultProps = {
  month: (0, _moment2['default'])(),
  isVisible: true,
  enableOutsideDays: false,
  modifiers: {},
  orientation: _constants.HORIZONTAL_ORIENTATION,
  daySize: _constants.DAY_SIZE,
  onDayClick: function () {
    function onDayClick() {}

    return onDayClick;
  }(),
  onDayMouseEnter: function () {
    function onDayMouseEnter() {}

    return onDayMouseEnter;
  }(),
  onDayMouseLeave: function () {
    function onDayMouseLeave() {}

    return onDayMouseLeave;
  }(),

  renderMonth: null,
  renderDay: null,
  firstDayOfWeek: null,

  focusedDate: null,
  isFocused: false,

  // i18n
  monthFormat: 'MMMM YYYY', // english locale
  phrases: _defaultPhrases.CalendarDayPhrases
};

var CalendarMonth = function (_React$Component) {
  _inherits(CalendarMonth, _React$Component);

  function CalendarMonth(props) {
    _classCallCheck(this, CalendarMonth);

    var _this = _possibleConstructorReturn(this, (CalendarMonth.__proto__ || Object.getPrototypeOf(CalendarMonth)).call(this, props));

    _this.state = {
      weeks: (0, _getCalendarMonthWeeks2['default'])(props.month, props.enableOutsideDays, props.firstDayOfWeek == null ? _moment2['default'].localeData().firstDayOfWeek() : props.firstDayOfWeek)
    };
    return _this;
  }

  _createClass(CalendarMonth, [{
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(nextProps) {
        var month = nextProps.month,
            enableOutsideDays = nextProps.enableOutsideDays,
            firstDayOfWeek = nextProps.firstDayOfWeek;

        if (!month.isSame(this.props.month) || enableOutsideDays !== this.props.enableOutsideDays || firstDayOfWeek !== this.props.firstDayOfWeek) {
          this.setState({
            weeks: (0, _getCalendarMonthWeeks2['default'])(month, enableOutsideDays, firstDayOfWeek == null ? _moment2['default'].localeData().firstDayOfWeek() : firstDayOfWeek)
          });
        }
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'shouldComponentUpdate',
    value: function () {
      function shouldComponentUpdate(nextProps, nextState) {
        return (0, _reactAddonsShallowCompare2['default'])(this, nextProps, nextState);
      }

      return shouldComponentUpdate;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            month = _props.month,
            monthFormat = _props.monthFormat,
            orientation = _props.orientation,
            isVisible = _props.isVisible,
            modifiers = _props.modifiers,
            onDayClick = _props.onDayClick,
            onDayMouseEnter = _props.onDayMouseEnter,
            onDayMouseLeave = _props.onDayMouseLeave,
            renderMonth = _props.renderMonth,
            renderDay = _props.renderDay,
            daySize = _props.daySize,
            focusedDate = _props.focusedDate,
            isFocused = _props.isFocused,
            phrases = _props.phrases;
        var weeks = this.state.weeks;

        var monthTitle = renderMonth ? renderMonth(month) : month.format(monthFormat);

        var calendarMonthClasses = (0, _classnames2['default'])('CalendarMonth', {
          'CalendarMonth--horizontal': orientation === _constants.HORIZONTAL_ORIENTATION,
          'CalendarMonth--vertical': orientation === _constants.VERTICAL_ORIENTATION,
          'CalendarMonth--vertical-scrollable': orientation === _constants.VERTICAL_SCROLLABLE
        });

        return _react2['default'].createElement('div', { className: calendarMonthClasses, 'data-visible': isVisible }, _react2['default'].createElement('div', {
          id: 'CalendarMonth__caption',
          className: 'CalendarMonth__caption js-CalendarMonth__caption'
        }, _react2['default'].createElement('strong', null, monthTitle)), _react2['default'].createElement('table', { role: 'presentation' }, _react2['default'].createElement('tbody', { className: 'js-CalendarMonth__grid' }, weeks.map(function (week, i) {
          return _react2['default'].createElement('tr', { key: i }, week.map(function (day, dayOfWeek) {
            return _react2['default'].createElement(_CalendarDay2['default'], {
              day: day,
              daySize: daySize,
              isOutsideDay: !day || day.month() !== month.month(),
              tabIndex: isVisible && (0, _isSameDay2['default'])(day, focusedDate) ? 0 : -1,
              isFocused: isFocused,
              key: dayOfWeek,
              onDayMouseEnter: onDayMouseEnter,
              onDayMouseLeave: onDayMouseLeave,
              onDayClick: onDayClick,
              renderDay: renderDay,
              phrases: phrases,
              modifiers: modifiers[(0, _toISODateString2['default'])(day)]
            });
          }));
        }))));
      }

      return render;
    }()
  }]);

  return CalendarMonth;
}(_react2['default'].Component);

exports['default'] = CalendarMonth;

CalendarMonth.propTypes = propTypes;
CalendarMonth.defaultProps = defaultProps;

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __webpack_require__(0);

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = __webpack_require__(101);

/***/ })

/******/ });

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 61);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __webpack_require__(2);

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __webpack_require__(24);

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = __webpack_require__(68);

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = __webpack_require__(111);

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __webpack_require__(12);

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __webpack_require__(27);

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __webpack_require__(6);

/***/ }),

/***/ 48:
/***/ (function(module, exports) {

module.exports = __webpack_require__(971);

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __webpack_require__(37);

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = __webpack_require__(44);

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactAddonsShallowCompare = __webpack_require__(14);

var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);

var _reactMomentProptypes = __webpack_require__(10);

var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);

var _airbnbPropTypes = __webpack_require__(1);

var _moment = __webpack_require__(7);

var _moment2 = _interopRequireDefault(_moment);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _defaultPhrases = __webpack_require__(3);

var _getPhrasePropTypes = __webpack_require__(5);

var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);

var _getPhrase = __webpack_require__(48);

var _getPhrase2 = _interopRequireDefault(_getPhrase);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
  day: _reactMomentProptypes2['default'].momentObj,
  daySize: _airbnbPropTypes.nonNegativeInteger,
  isOutsideDay: _propTypes2['default'].bool,
  modifiers: _propTypes2['default'].instanceOf(Set),
  isFocused: _propTypes2['default'].bool,
  tabIndex: _propTypes2['default'].oneOf([0, -1]),
  onDayClick: _propTypes2['default'].func,
  onDayMouseEnter: _propTypes2['default'].func,
  onDayMouseLeave: _propTypes2['default'].func,
  renderDay: _propTypes2['default'].func,

  // internationalization
  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.CalendarDayPhrases))
});

var defaultProps = {
  day: (0, _moment2['default'])(),
  daySize: _constants.DAY_SIZE,
  isOutsideDay: false,
  modifiers: new Set(),
  isFocused: false,
  tabIndex: -1,
  onDayClick: function () {
    function onDayClick() {}

    return onDayClick;
  }(),
  onDayMouseEnter: function () {
    function onDayMouseEnter() {}

    return onDayMouseEnter;
  }(),
  onDayMouseLeave: function () {
    function onDayMouseLeave() {}

    return onDayMouseLeave;
  }(),

  renderDay: null,

  // internationalization
  phrases: _defaultPhrases.CalendarDayPhrases
};

var CalendarDay = function (_React$Component) {
  _inherits(CalendarDay, _React$Component);

  function CalendarDay() {
    var _ref;

    _classCallCheck(this, CalendarDay);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = CalendarDay.__proto__ || Object.getPrototypeOf(CalendarDay)).call.apply(_ref, [this].concat(args)));

    _this.setButtonRef = _this.setButtonRef.bind(_this);
    return _this;
  }

  _createClass(CalendarDay, [{
    key: 'shouldComponentUpdate',
    value: function () {
      function shouldComponentUpdate(nextProps, nextState) {
        return (0, _reactAddonsShallowCompare2['default'])(this, nextProps, nextState);
      }

      return shouldComponentUpdate;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate(prevProps) {
        var _props = this.props,
            isFocused = _props.isFocused,
            tabIndex = _props.tabIndex;

        if (tabIndex === 0) {
          if (isFocused || tabIndex !== prevProps.tabIndex) {
            this.buttonRef.focus();
          }
        }
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'onDayClick',
    value: function () {
      function onDayClick(day, e) {
        var onDayClick = this.props.onDayClick;

        onDayClick(day, e);
      }

      return onDayClick;
    }()
  }, {
    key: 'onDayMouseEnter',
    value: function () {
      function onDayMouseEnter(day, e) {
        var onDayMouseEnter = this.props.onDayMouseEnter;

        onDayMouseEnter(day, e);
      }

      return onDayMouseEnter;
    }()
  }, {
    key: 'onDayMouseLeave',
    value: function () {
      function onDayMouseLeave(day, e) {
        var onDayMouseLeave = this.props.onDayMouseLeave;

        onDayMouseLeave(day, e);
      }

      return onDayMouseLeave;
    }()
  }, {
    key: 'setButtonRef',
    value: function () {
      function setButtonRef(ref) {
        this.buttonRef = ref;
      }

      return setButtonRef;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;

        var _props2 = this.props,
            day = _props2.day,
            daySize = _props2.daySize,
            isOutsideDay = _props2.isOutsideDay,
            modifiers = _props2.modifiers,
            renderDay = _props2.renderDay,
            tabIndex = _props2.tabIndex,
            _props2$phrases = _props2.phrases,
            chooseAvailableDate = _props2$phrases.chooseAvailableDate,
            dateIsUnavailable = _props2$phrases.dateIsUnavailable;

        if (!day) return _react2['default'].createElement('td', null);

        var className = (0, _classnames2['default'])('CalendarDay', {
          'CalendarDay--outside': isOutsideDay
        }, Array.from(modifiers, function (mod) {
          return 'CalendarDay--' + String(mod);
        }));

        var formattedDate = String(day.format('dddd')) + ', ' + String(day.format('LL'));

        var ariaLabel = (0, _getPhrase2['default'])(chooseAvailableDate, {
          date: formattedDate
        });

        if (_constants.BLOCKED_MODIFIER in modifiers && modifiers[_constants.BLOCKED_MODIFIER](day)) {
          ariaLabel = (0, _getPhrase2['default'])(dateIsUnavailable, { date: formattedDate });
        }

        var daySizeStyles = {
          width: daySize,
          height: daySize - 1
        };

        return _react2['default'].createElement('td', { className: className, style: daySizeStyles }, _react2['default'].createElement('button', {
          type: 'button',
          ref: this.setButtonRef,
          className: 'CalendarDay__button',
          'aria-label': ariaLabel,
          onMouseEnter: function () {
            function onMouseEnter(e) {
              _this2.onDayMouseEnter(day, e);
            }

            return onMouseEnter;
          }(),
          onMouseLeave: function () {
            function onMouseLeave(e) {
              _this2.onDayMouseLeave(day, e);
            }

            return onMouseLeave;
          }(),
          onMouseUp: function () {
            function onMouseUp(e) {
              e.currentTarget.blur();
            }

            return onMouseUp;
          }(),
          onClick: function () {
            function onClick(e) {
              _this2.onDayClick(day, e);
            }

            return onClick;
          }(),
          tabIndex: tabIndex
        }, renderDay ? renderDay(day) : day.format('D')));
      }

      return render;
    }()
  }]);

  return CalendarDay;
}(_react2['default'].Component);

exports['default'] = CalendarDay;

CalendarDay.propTypes = propTypes;
CalendarDay.defaultProps = defaultProps;

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __webpack_require__(0);

/***/ })

/******/ });

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(151);

var implementation = __webpack_require__(559);
var getPolyfill = __webpack_require__(567);
var shim = __webpack_require__(986);

var polyfill = getPolyfill();

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ES = __webpack_require__(974);
var has = __webpack_require__(117);
var bind = __webpack_require__(114);
var isEnumerable = bind.call(Function.call, Object.prototype.propertyIsEnumerable);

module.exports = function values(O) {
	var obj = ES.RequireObjectCoercible(O);
	var vals = [];
	for (var key in obj) {
		if (has(obj, key) && isEnumerable(obj, key)) {
			vals.push(obj[key]);
		}
	}
	return vals;
};


/***/ }),
/* 560 */
/***/ (function(module, exports) {

module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(202);

var $TypeError = GetIntrinsic('%TypeError%');
var $SyntaxError = GetIntrinsic('%SyntaxError%');

var has = __webpack_require__(117);

var predicates = {
  // https://ecma-international.org/ecma-262/6.0/#sec-property-descriptor-specification-type
  'Property Descriptor': function isPropertyDescriptor(ES, Desc) {
    if (ES.Type(Desc) !== 'Object') {
      return false;
    }
    var allowed = {
      '[[Configurable]]': true,
      '[[Enumerable]]': true,
      '[[Get]]': true,
      '[[Set]]': true,
      '[[Value]]': true,
      '[[Writable]]': true
    };

    for (var key in Desc) { // eslint-disable-line
      if (has(Desc, key) && !allowed[key]) {
        return false;
      }
    }

    var isData = has(Desc, '[[Value]]');
    var IsAccessor = has(Desc, '[[Get]]') || has(Desc, '[[Set]]');
    if (isData && IsAccessor) {
      throw new $TypeError('Property Descriptors may not be both accessor and data descriptors');
    }
    return true;
  }
};

module.exports = function assertRecord(ES, recordType, argumentName, value) {
  var predicate = predicates[recordType];
  if (typeof predicate !== 'function') {
    throw new $SyntaxError('unknown record type: ' + recordType);
  }
  if (!predicate(ES, value)) {
    throw new $TypeError(argumentName + ' must be a ' + recordType);
  }
  console.log(predicate(ES, value), value);
};


/***/ }),
/* 562 */
/***/ (function(module, exports) {

module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};


/***/ }),
/* 563 */
/***/ (function(module, exports) {

var $isNaN = Number.isNaN || function (a) { return a !== a; };

module.exports = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity; };


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__(114);
var has = bind.call(Function.call, Object.prototype.hasOwnProperty);

var $assign = Object.assign;

module.exports = function assign(target, source) {
	if ($assign) {
		return $assign(target, source);
	}

	for (var key in source) {
		if (has(source, key)) {
			target[key] = source[key];
		}
	}
	return target;
};


/***/ }),
/* 565 */
/***/ (function(module, exports) {

module.exports = function sign(number) {
	return number >= 0 ? 1 : -1;
};


/***/ }),
/* 566 */
/***/ (function(module, exports) {

module.exports = function mod(number, modulo) {
	var remain = number % modulo;
	return Math.floor(remain >= 0 ? remain : remain + modulo);
};


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(559);

module.exports = function getPolyfill() {
	return typeof Object.values === 'function' ? Object.values : implementation;
};


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = isNextDay;

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _isSameDay = __webpack_require__(102);

var _isSameDay2 = _interopRequireDefault(_isSameDay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function isNextDay(a, b) {
  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
  var nextDay = (0, _moment2['default'])(a).add(1, 'day');
  return (0, _isSameDay2['default'])(nextDay, b);
}

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMomentProptypes = __webpack_require__(68);

var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);

var _airbnbPropTypes = __webpack_require__(24);

var _defaultPhrases = __webpack_require__(27);

var _getPhrasePropTypes = __webpack_require__(37);

var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);

var _IconPositionShape = __webpack_require__(115);

var _IconPositionShape2 = _interopRequireDefault(_IconPositionShape);

var _OrientationShape = __webpack_require__(543);

var _OrientationShape2 = _interopRequireDefault(_OrientationShape);

var _AnchorDirectionShape = __webpack_require__(544);

var _AnchorDirectionShape2 = _interopRequireDefault(_AnchorDirectionShape);

var _OpenDirectionShape = __webpack_require__(98);

var _OpenDirectionShape2 = _interopRequireDefault(_OpenDirectionShape);

var _DayOfWeekShape = __webpack_require__(86);

var _DayOfWeekShape2 = _interopRequireDefault(_DayOfWeekShape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  // required props for a functional interactive SingleDatePicker
  date: _reactMomentProptypes2['default'].momentObj,
  onDateChange: _propTypes2['default'].func.isRequired,

  focused: _propTypes2['default'].bool,
  onFocusChange: _propTypes2['default'].func.isRequired,

  // input related props
  id: _propTypes2['default'].string.isRequired,
  placeholder: _propTypes2['default'].string,
  disabled: _propTypes2['default'].bool,
  required: _propTypes2['default'].bool,
  readOnly: _propTypes2['default'].bool,
  screenReaderInputMessage: _propTypes2['default'].string,
  showClearDate: _propTypes2['default'].bool,
  customCloseIcon: _propTypes2['default'].node,
  showDefaultInputIcon: _propTypes2['default'].bool,
  inputIconPosition: _IconPositionShape2['default'],
  customInputIcon: _propTypes2['default'].node,

  // calendar presentation and interaction related props
  renderMonth: _propTypes2['default'].func,
  orientation: _OrientationShape2['default'],
  anchorDirection: _AnchorDirectionShape2['default'],
  openDirection: _OpenDirectionShape2['default'],
  horizontalMargin: _propTypes2['default'].number,
  withPortal: _propTypes2['default'].bool,
  withFullScreenPortal: _propTypes2['default'].bool,
  initialVisibleMonth: _propTypes2['default'].func,
  firstDayOfWeek: _DayOfWeekShape2['default'],
  numberOfMonths: _propTypes2['default'].number,
  keepOpenOnDateSelect: _propTypes2['default'].bool,
  reopenPickerOnClearDate: _propTypes2['default'].bool,
  renderCalendarInfo: _propTypes2['default'].func,
  hideKeyboardShortcutsPanel: _propTypes2['default'].bool,
  daySize: _airbnbPropTypes.nonNegativeInteger,
  isRTL: _propTypes2['default'].bool,

  // navigation related props
  navPrev: _propTypes2['default'].node,
  navNext: _propTypes2['default'].node,

  onPrevMonthClick: _propTypes2['default'].func,
  onNextMonthClick: _propTypes2['default'].func,
  onClose: _propTypes2['default'].func,

  // day presentation and interaction related props
  renderDay: _propTypes2['default'].func,
  enableOutsideDays: _propTypes2['default'].bool,
  isDayBlocked: _propTypes2['default'].func,
  isOutsideRange: _propTypes2['default'].func,
  isDayHighlighted: _propTypes2['default'].func,

  // internationalization props
  displayFormat: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].func]),
  monthFormat: _propTypes2['default'].string,
  weekDayFormat: _propTypes2['default'].string,
  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.SingleDatePickerPhrases))
};

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 72);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(2);

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(24);

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(12);

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(27);

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(6);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(37);

/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(0);

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(101);

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(97);

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(68);

/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(86);

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(99);

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(148);

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(116);

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(199);

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(102);

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(152);

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(150);

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(552);

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(200);

/***/ }),
/* 37 */,
/* 38 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(558);

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _object3 = __webpack_require__(24);

var _object4 = _interopRequireDefault(_object3);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMomentProptypes = __webpack_require__(10);

var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);

var _airbnbPropTypes = __webpack_require__(1);

var _moment = __webpack_require__(7);

var _moment2 = _interopRequireDefault(_moment);

var _object = __webpack_require__(38);

var _object2 = _interopRequireDefault(_object);

var _isTouchDevice = __webpack_require__(9);

var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);

var _defaultPhrases = __webpack_require__(3);

var _getPhrasePropTypes = __webpack_require__(5);

var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);

var _isSameDay = __webpack_require__(22);

var _isSameDay2 = _interopRequireDefault(_isSameDay);

var _isAfterDay = __webpack_require__(20);

var _isAfterDay2 = _interopRequireDefault(_isAfterDay);

var _getVisibleDays = __webpack_require__(31);

var _getVisibleDays2 = _interopRequireDefault(_getVisibleDays);

var _isDayVisible = __webpack_require__(21);

var _isDayVisible2 = _interopRequireDefault(_isDayVisible);

var _toISODateString = __webpack_require__(13);

var _toISODateString2 = _interopRequireDefault(_toISODateString);

var _toISOMonthString = __webpack_require__(23);

var _toISOMonthString2 = _interopRequireDefault(_toISOMonthString);

var _ScrollableOrientationShape = __webpack_require__(8);

var _ScrollableOrientationShape2 = _interopRequireDefault(_ScrollableOrientationShape);

var _DayOfWeekShape = __webpack_require__(12);

var _DayOfWeekShape2 = _interopRequireDefault(_DayOfWeekShape);

var _constants = __webpack_require__(2);

var _DayPicker = __webpack_require__(36);

var _DayPicker2 = _interopRequireDefault(_DayPicker);

var _OutsideClickHandler = __webpack_require__(17);

var _OutsideClickHandler2 = _interopRequireDefault(_OutsideClickHandler);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
  date: _reactMomentProptypes2['default'].momentObj,
  onDateChange: _propTypes2['default'].func,

  focused: _propTypes2['default'].bool,
  onFocusChange: _propTypes2['default'].func,
  onClose: _propTypes2['default'].func,

  keepOpenOnDateSelect: _propTypes2['default'].bool,
  isOutsideRange: _propTypes2['default'].func,
  isDayBlocked: _propTypes2['default'].func,
  isDayHighlighted: _propTypes2['default'].func,

  // DayPicker props
  renderMonth: _propTypes2['default'].func,
  enableOutsideDays: _propTypes2['default'].bool,
  numberOfMonths: _propTypes2['default'].number,
  orientation: _ScrollableOrientationShape2['default'],
  withPortal: _propTypes2['default'].bool,
  initialVisibleMonth: _propTypes2['default'].func,
  firstDayOfWeek: _DayOfWeekShape2['default'],
  hideKeyboardShortcutsPanel: _propTypes2['default'].bool,
  daySize: _airbnbPropTypes.nonNegativeInteger,

  navPrev: _propTypes2['default'].node,
  navNext: _propTypes2['default'].node,

  onPrevMonthClick: _propTypes2['default'].func,
  onNextMonthClick: _propTypes2['default'].func,
  onOutsideClick: _propTypes2['default'].func,
  renderDay: _propTypes2['default'].func,
  renderCalendarInfo: _propTypes2['default'].func,

  // accessibility
  onBlur: _propTypes2['default'].func,
  isFocused: _propTypes2['default'].bool,
  showKeyboardShortcuts: _propTypes2['default'].bool,

  // i18n
  monthFormat: _propTypes2['default'].string,
  weekDayFormat: _propTypes2['default'].string,
  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DayPickerPhrases)),

  isRTL: _propTypes2['default'].bool
});

var defaultProps = {
  date: undefined, // TODO: use null
  onDateChange: function () {
    function onDateChange() {}

    return onDateChange;
  }(),

  focused: false,
  onFocusChange: function () {
    function onFocusChange() {}

    return onFocusChange;
  }(),
  onClose: function () {
    function onClose() {}

    return onClose;
  }(),

  keepOpenOnDateSelect: false,
  isOutsideRange: function () {
    function isOutsideRange() {}

    return isOutsideRange;
  }(),
  isDayBlocked: function () {
    function isDayBlocked() {}

    return isDayBlocked;
  }(),
  isDayHighlighted: function () {
    function isDayHighlighted() {}

    return isDayHighlighted;
  }(),

  // DayPicker props
  renderMonth: null,
  enableOutsideDays: false,
  numberOfMonths: 1,
  orientation: _constants.HORIZONTAL_ORIENTATION,
  withPortal: false,
  hideKeyboardShortcutsPanel: false,
  initialVisibleMonth: null,
  firstDayOfWeek: null,
  daySize: _constants.DAY_SIZE,

  navPrev: null,
  navNext: null,

  onPrevMonthClick: function () {
    function onPrevMonthClick() {}

    return onPrevMonthClick;
  }(),
  onNextMonthClick: function () {
    function onNextMonthClick() {}

    return onNextMonthClick;
  }(),

  onOutsideClick: null,

  renderDay: null,
  renderCalendarInfo: null,

  // accessibility
  onBlur: function () {
    function onBlur() {}

    return onBlur;
  }(),

  isFocused: false,
  showKeyboardShortcuts: false,

  // i18n
  monthFormat: 'MMMM YYYY',
  weekDayFormat: 'dd',
  phrases: _defaultPhrases.DayPickerPhrases,

  isRTL: false
};

var DayPickerSingleDateController = function (_React$Component) {
  _inherits(DayPickerSingleDateController, _React$Component);

  function DayPickerSingleDateController(props) {
    _classCallCheck(this, DayPickerSingleDateController);

    var _this = _possibleConstructorReturn(this, (DayPickerSingleDateController.__proto__ || Object.getPrototypeOf(DayPickerSingleDateController)).call(this, props));

    _this.isTouchDevice = false;
    _this.today = (0, _moment2['default'])();

    _this.modifiers = {
      today: function () {
        function today(day) {
          return _this.isToday(day);
        }

        return today;
      }(),
      blocked: function () {
        function blocked(day) {
          return _this.isBlocked(day);
        }

        return blocked;
      }(),
      'blocked-calendar': function () {
        function blockedCalendar(day) {
          return props.isDayBlocked(day);
        }

        return blockedCalendar;
      }(),
      'blocked-out-of-range': function () {
        function blockedOutOfRange(day) {
          return props.isOutsideRange(day);
        }

        return blockedOutOfRange;
      }(),
      'highlighted-calendar': function () {
        function highlightedCalendar(day) {
          return props.isDayHighlighted(day);
        }

        return highlightedCalendar;
      }(),
      valid: function () {
        function valid(day) {
          return !_this.isBlocked(day);
        }

        return valid;
      }(),
      hovered: function () {
        function hovered(day) {
          return _this.isHovered(day);
        }

        return hovered;
      }(),
      selected: function () {
        function selected(day) {
          return _this.isSelected(day);
        }

        return selected;
      }()
    };

    var _this$getStateForNewM = _this.getStateForNewMonth(props),
        currentMonth = _this$getStateForNewM.currentMonth,
        visibleDays = _this$getStateForNewM.visibleDays;

    _this.state = {
      hoverDate: null,
      currentMonth: currentMonth,
      visibleDays: visibleDays
    };

    _this.onDayMouseEnter = _this.onDayMouseEnter.bind(_this);
    _this.onDayMouseLeave = _this.onDayMouseLeave.bind(_this);
    _this.onDayClick = _this.onDayClick.bind(_this);

    _this.onPrevMonthClick = _this.onPrevMonthClick.bind(_this);
    _this.onNextMonthClick = _this.onNextMonthClick.bind(_this);

    _this.getFirstFocusableDay = _this.getFirstFocusableDay.bind(_this);
    return _this;
  }

  _createClass(DayPickerSingleDateController, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        this.isTouchDevice = (0, _isTouchDevice2['default'])();
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(nextProps) {
        var _this2 = this;

        var date = nextProps.date,
            focused = nextProps.focused,
            isOutsideRange = nextProps.isOutsideRange,
            isDayBlocked = nextProps.isDayBlocked,
            isDayHighlighted = nextProps.isDayHighlighted,
            initialVisibleMonth = nextProps.initialVisibleMonth,
            numberOfMonths = nextProps.numberOfMonths,
            enableOutsideDays = nextProps.enableOutsideDays;
        var visibleDays = this.state.visibleDays;

        var recomputeOutsideRange = false;
        var recomputeDayBlocked = false;
        var recomputeDayHighlighted = false;

        if (isOutsideRange !== this.props.isOutsideRange) {
          this.modifiers['blocked-out-of-range'] = function (day) {
            return isOutsideRange(day);
          };
          recomputeOutsideRange = true;
        }

        if (isDayBlocked !== this.props.isDayBlocked) {
          this.modifiers['blocked-calendar'] = function (day) {
            return isDayBlocked(day);
          };
          recomputeDayBlocked = true;
        }

        if (isDayHighlighted !== this.props.isDayHighlighted) {
          this.modifiers['highlighted-calendar'] = function (day) {
            return isDayHighlighted(day);
          };
          recomputeDayHighlighted = true;
        }

        var recomputePropModifiers = recomputeOutsideRange || recomputeDayBlocked || recomputeDayHighlighted;

        if (numberOfMonths !== this.props.numberOfMonths || enableOutsideDays !== this.props.enableOutsideDays || initialVisibleMonth !== this.props.initialVisibleMonth && !this.props.focused && focused) {
          var newMonthState = this.getStateForNewMonth(nextProps);
          var currentMonth = newMonthState.currentMonth;
          visibleDays = newMonthState.visibleDays;
          this.setState({
            currentMonth: currentMonth,
            visibleDays: visibleDays
          });
        }

        var didDateChange = date !== this.props.date;
        var didFocusChange = focused !== this.props.focused;

        var modifiers = {};

        if (didDateChange) {
          modifiers = this.deleteModifier(modifiers, this.props.date, 'selected');
          modifiers = this.addModifier(modifiers, date, 'selected');
        }

        if (didFocusChange || recomputePropModifiers) {
          (0, _object2['default'])(visibleDays).forEach(function (days) {
            Object.keys(days).forEach(function (day) {
              var momentObj = (0, _moment2['default'])(day);
              if (_this2.isBlocked(momentObj)) {
                modifiers = _this2.addModifier(modifiers, momentObj, 'blocked');
              } else {
                modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked');
              }

              if (didFocusChange || recomputeOutsideRange) {
                if (isOutsideRange(momentObj)) {
                  modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-out-of-range');
                } else {
                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-out-of-range');
                }
              }

              if (didFocusChange || recomputeDayBlocked) {
                if (isDayBlocked(momentObj)) {
                  modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-calendar');
                } else {
                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-calendar');
                }
              }

              if (didFocusChange || recomputeDayHighlighted) {
                if (isDayHighlighted(momentObj)) {
                  modifiers = _this2.addModifier(modifiers, momentObj, 'highlighted-calendar');
                } else {
                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'highlighted-calendar');
                }
              }
            });
          });
        }

        var today = (0, _moment2['default'])();
        if (!(0, _isSameDay2['default'])(this.today, today)) {
          modifiers = this.deleteModifier(modifiers, this.today, 'today');
          modifiers = this.addModifier(modifiers, today, 'today');
          this.today = today;
        }

        if (Object.keys(modifiers).length > 0) {
          this.setState({
            visibleDays: (0, _object4['default'])({}, visibleDays, modifiers)
          });
        }
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'componentWillUpdate',
    value: function () {
      function componentWillUpdate() {
        this.today = (0, _moment2['default'])();
      }

      return componentWillUpdate;
    }()
  }, {
    key: 'onDayClick',
    value: function () {
      function onDayClick(day, e) {
        if (e) e.preventDefault();
        if (this.isBlocked(day)) return;
        var _props = this.props,
            onDateChange = _props.onDateChange,
            keepOpenOnDateSelect = _props.keepOpenOnDateSelect,
            onFocusChange = _props.onFocusChange,
            onClose = _props.onClose;

        onDateChange(day);
        if (!keepOpenOnDateSelect) {
          onFocusChange({ focused: null });
          onClose({ date: day });
        }
      }

      return onDayClick;
    }()
  }, {
    key: 'onDayMouseEnter',
    value: function () {
      function onDayMouseEnter(day) {
        if (this.isTouchDevice) return;
        var _state = this.state,
            hoverDate = _state.hoverDate,
            visibleDays = _state.visibleDays;

        var modifiers = this.deleteModifier({}, hoverDate, 'hovered');
        modifiers = this.addModifier(modifiers, day, 'hovered');

        this.setState({
          hoverDate: day,
          visibleDays: (0, _object4['default'])({}, visibleDays, modifiers)
        });
      }

      return onDayMouseEnter;
    }()
  }, {
    key: 'onDayMouseLeave',
    value: function () {
      function onDayMouseLeave() {
        var _state2 = this.state,
            hoverDate = _state2.hoverDate,
            visibleDays = _state2.visibleDays;

        if (this.isTouchDevice || !hoverDate) return;

        var modifiers = this.deleteModifier({}, hoverDate, 'hovered');

        this.setState({
          hoverDate: null,
          visibleDays: (0, _object4['default'])({}, visibleDays, modifiers)
        });
      }

      return onDayMouseLeave;
    }()
  }, {
    key: 'onPrevMonthClick',
    value: function () {
      function onPrevMonthClick() {
        var _props2 = this.props,
            onPrevMonthClick = _props2.onPrevMonthClick,
            numberOfMonths = _props2.numberOfMonths,
            enableOutsideDays = _props2.enableOutsideDays;
        var _state3 = this.state,
            currentMonth = _state3.currentMonth,
            visibleDays = _state3.visibleDays;

        var newVisibleDays = {};
        Object.keys(visibleDays).sort().slice(0, numberOfMonths + 1).forEach(function (month) {
          newVisibleDays[month] = visibleDays[month];
        });

        var prevMonth = currentMonth.clone().subtract(1, 'month');
        var prevMonthVisibleDays = (0, _getVisibleDays2['default'])(prevMonth, 1, enableOutsideDays);

        this.setState({
          currentMonth: prevMonth,
          visibleDays: (0, _object4['default'])({}, newVisibleDays, this.getModifiers(prevMonthVisibleDays))
        });

        onPrevMonthClick(prevMonth.clone());
      }

      return onPrevMonthClick;
    }()
  }, {
    key: 'onNextMonthClick',
    value: function () {
      function onNextMonthClick() {
        var _props3 = this.props,
            onNextMonthClick = _props3.onNextMonthClick,
            numberOfMonths = _props3.numberOfMonths,
            enableOutsideDays = _props3.enableOutsideDays;
        var _state4 = this.state,
            currentMonth = _state4.currentMonth,
            visibleDays = _state4.visibleDays;

        var newVisibleDays = {};
        Object.keys(visibleDays).sort().slice(1).forEach(function (month) {
          newVisibleDays[month] = visibleDays[month];
        });

        var nextMonth = currentMonth.clone().add(numberOfMonths, 'month');
        var nextMonthVisibleDays = (0, _getVisibleDays2['default'])(nextMonth, 1, enableOutsideDays);

        var newCurrentMonth = currentMonth.clone().add(1, 'month');
        this.setState({
          currentMonth: newCurrentMonth,
          visibleDays: (0, _object4['default'])({}, newVisibleDays, this.getModifiers(nextMonthVisibleDays))
        });

        onNextMonthClick(newCurrentMonth.clone());
      }

      return onNextMonthClick;
    }()
  }, {
    key: 'getFirstFocusableDay',
    value: function () {
      function getFirstFocusableDay(newMonth) {
        var _this3 = this;

        var _props4 = this.props,
            date = _props4.date,
            numberOfMonths = _props4.numberOfMonths;

        var focusedDate = newMonth.clone().startOf('month');
        if (date) {
          focusedDate = date.clone();
        }

        if (this.isBlocked(focusedDate)) {
          var days = [];
          var lastVisibleDay = newMonth.clone().add(numberOfMonths - 1, 'months').endOf('month');
          var currentDay = focusedDate.clone();
          while (!(0, _isAfterDay2['default'])(currentDay, lastVisibleDay)) {
            currentDay = currentDay.clone().add(1, 'day');
            days.push(currentDay);
          }

          var viableDays = days.filter(function (day) {
            return !_this3.isBlocked(day) && (0, _isAfterDay2['default'])(day, focusedDate);
          });
          if (viableDays.length > 0) focusedDate = viableDays[0];
        }

        return focusedDate;
      }

      return getFirstFocusableDay;
    }()
  }, {
    key: 'getModifiers',
    value: function () {
      function getModifiers(visibleDays) {
        var _this4 = this;

        var modifiers = {};
        Object.keys(visibleDays).forEach(function (month) {
          modifiers[month] = {};
          visibleDays[month].forEach(function (day) {
            modifiers[month][(0, _toISODateString2['default'])(day)] = _this4.getModifiersForDay(day);
          });
        });

        return modifiers;
      }

      return getModifiers;
    }()
  }, {
    key: 'getModifiersForDay',
    value: function () {
      function getModifiersForDay(day) {
        var _this5 = this;

        return new Set(Object.keys(this.modifiers).filter(function (modifier) {
          return _this5.modifiers[modifier](day);
        }));
      }

      return getModifiersForDay;
    }()
  }, {
    key: 'getStateForNewMonth',
    value: function () {
      function getStateForNewMonth(nextProps) {
        var _this6 = this;

        var initialVisibleMonth = nextProps.initialVisibleMonth,
            date = nextProps.date,
            numberOfMonths = nextProps.numberOfMonths,
            enableOutsideDays = nextProps.enableOutsideDays;

        var initialVisibleMonthThunk = initialVisibleMonth || (date ? function () {
          return date;
        } : function () {
          return _this6.today;
        });
        var currentMonth = initialVisibleMonthThunk();
        var visibleDays = this.getModifiers((0, _getVisibleDays2['default'])(currentMonth, numberOfMonths, enableOutsideDays));
        return { currentMonth: currentMonth, visibleDays: visibleDays };
      }

      return getStateForNewMonth;
    }()
  }, {
    key: 'addModifier',
    value: function () {
      function addModifier(updatedDays, day, modifier) {
        var _props5 = this.props,
            numberOfVisibleMonths = _props5.numberOfMonths,
            enableOutsideDays = _props5.enableOutsideDays,
            orientation = _props5.orientation;
        var _state5 = this.state,
            firstVisibleMonth = _state5.currentMonth,
            visibleDays = _state5.visibleDays;

        var currentMonth = firstVisibleMonth;
        var numberOfMonths = numberOfVisibleMonths;
        if (orientation !== _constants.VERTICAL_SCROLLABLE) {
          currentMonth = currentMonth.clone().subtract(1, 'month');
          numberOfMonths += 2;
        }
        if (!day || !(0, _isDayVisible2['default'])(day, currentMonth, numberOfMonths, enableOutsideDays)) {
          return updatedDays;
        }

        var iso = (0, _toISODateString2['default'])(day);

        var updatedDaysAfterAddition = (0, _object4['default'])({}, updatedDays);
        if (enableOutsideDays) {
          var monthsToUpdate = Object.keys(visibleDays).filter(function (monthKey) {
            return Object.keys(visibleDays[monthKey]).indexOf(iso) > -1;
          });

          updatedDaysAfterAddition = monthsToUpdate.reduce(function (days, monthIso) {
            var month = updatedDays[monthIso] || visibleDays[monthIso];
            var modifiers = new Set(month[iso]);
            modifiers.add(modifier);
            return (0, _object4['default'])({}, days, _defineProperty({}, monthIso, (0, _object4['default'])({}, month, _defineProperty({}, iso, modifiers))));
          }, updatedDaysAfterAddition);
        } else {
          var monthIso = (0, _toISOMonthString2['default'])(day);
          var month = updatedDays[monthIso] || visibleDays[monthIso];

          var modifiers = new Set(month[iso]);
          modifiers.add(modifier);
          updatedDaysAfterAddition = (0, _object4['default'])({}, updatedDaysAfterAddition, _defineProperty({}, monthIso, (0, _object4['default'])({}, month, _defineProperty({}, iso, modifiers))));
        }

        return updatedDaysAfterAddition;
      }

      return addModifier;
    }()
  }, {
    key: 'deleteModifier',
    value: function () {
      function deleteModifier(updatedDays, day, modifier) {
        var _props6 = this.props,
            numberOfVisibleMonths = _props6.numberOfMonths,
            enableOutsideDays = _props6.enableOutsideDays,
            orientation = _props6.orientation;
        var _state6 = this.state,
            firstVisibleMonth = _state6.currentMonth,
            visibleDays = _state6.visibleDays;

        var currentMonth = firstVisibleMonth;
        var numberOfMonths = numberOfVisibleMonths;
        if (orientation !== _constants.VERTICAL_SCROLLABLE) {
          currentMonth = currentMonth.clone().subtract(1, 'month');
          numberOfMonths += 2;
        }
        if (!day || !(0, _isDayVisible2['default'])(day, currentMonth, numberOfMonths, enableOutsideDays)) {
          return updatedDays;
        }

        var iso = (0, _toISODateString2['default'])(day);

        var updatedDaysAfterDeletion = (0, _object4['default'])({}, updatedDays);
        if (enableOutsideDays) {
          var monthsToUpdate = Object.keys(visibleDays).filter(function (monthKey) {
            return Object.keys(visibleDays[monthKey]).indexOf(iso) > -1;
          });

          updatedDaysAfterDeletion = monthsToUpdate.reduce(function (days, monthIso) {
            var month = updatedDays[monthIso] || visibleDays[monthIso];
            var modifiers = new Set(month[iso]);
            modifiers['delete'](modifier);
            return (0, _object4['default'])({}, days, _defineProperty({}, monthIso, (0, _object4['default'])({}, month, _defineProperty({}, iso, modifiers))));
          }, updatedDaysAfterDeletion);
        } else {
          var monthIso = (0, _toISOMonthString2['default'])(day);
          var month = updatedDays[monthIso] || visibleDays[monthIso];

          var modifiers = new Set(month[iso]);
          modifiers['delete'](modifier);
          updatedDaysAfterDeletion = (0, _object4['default'])({}, updatedDaysAfterDeletion, _defineProperty({}, monthIso, (0, _object4['default'])({}, month, _defineProperty({}, iso, modifiers))));
        }

        return updatedDaysAfterDeletion;
      }

      return deleteModifier;
    }()
  }, {
    key: 'isBlocked',
    value: function () {
      function isBlocked(day) {
        var _props7 = this.props,
            isDayBlocked = _props7.isDayBlocked,
            isOutsideRange = _props7.isOutsideRange;

        return isDayBlocked(day) || isOutsideRange(day);
      }

      return isBlocked;
    }()
  }, {
    key: 'isHovered',
    value: function () {
      function isHovered(day) {
        var _ref = this.state || {},
            hoverDate = _ref.hoverDate;

        return (0, _isSameDay2['default'])(day, hoverDate);
      }

      return isHovered;
    }()
  }, {
    key: 'isSelected',
    value: function () {
      function isSelected(day) {
        return (0, _isSameDay2['default'])(day, this.props.date);
      }

      return isSelected;
    }()
  }, {
    key: 'isToday',
    value: function () {
      function isToday(day) {
        return (0, _isSameDay2['default'])(day, this.today);
      }

      return isToday;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props8 = this.props,
            numberOfMonths = _props8.numberOfMonths,
            orientation = _props8.orientation,
            monthFormat = _props8.monthFormat,
            renderMonth = _props8.renderMonth,
            navPrev = _props8.navPrev,
            navNext = _props8.navNext,
            withPortal = _props8.withPortal,
            focused = _props8.focused,
            enableOutsideDays = _props8.enableOutsideDays,
            hideKeyboardShortcutsPanel = _props8.hideKeyboardShortcutsPanel,
            daySize = _props8.daySize,
            firstDayOfWeek = _props8.firstDayOfWeek,
            renderDay = _props8.renderDay,
            renderCalendarInfo = _props8.renderCalendarInfo,
            isFocused = _props8.isFocused,
            isRTL = _props8.isRTL,
            phrases = _props8.phrases,
            onOutsideClick = _props8.onOutsideClick,
            onBlur = _props8.onBlur,
            showKeyboardShortcuts = _props8.showKeyboardShortcuts,
            weekDayFormat = _props8.weekDayFormat;
        var _state7 = this.state,
            currentMonth = _state7.currentMonth,
            visibleDays = _state7.visibleDays;

        var dayPickerComponent = _react2['default'].createElement(_DayPicker2['default'], {
          orientation: orientation,
          enableOutsideDays: enableOutsideDays,
          modifiers: visibleDays,
          numberOfMonths: numberOfMonths,
          onDayClick: this.onDayClick,
          onDayMouseEnter: this.onDayMouseEnter,
          onDayMouseLeave: this.onDayMouseLeave,
          onPrevMonthClick: this.onPrevMonthClick,
          onNextMonthClick: this.onNextMonthClick,
          monthFormat: monthFormat,
          withPortal: withPortal,
          hidden: !focused,
          hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
          initialVisibleMonth: function () {
            function initialVisibleMonth() {
              return currentMonth;
            }

            return initialVisibleMonth;
          }(),
          firstDayOfWeek: firstDayOfWeek,
          navPrev: navPrev,
          navNext: navNext,
          renderMonth: renderMonth,
          renderDay: renderDay,
          renderCalendarInfo: renderCalendarInfo,
          isFocused: isFocused,
          getFirstFocusableDay: this.getFirstFocusableDay,
          onBlur: onBlur,
          phrases: phrases,
          daySize: daySize,
          isRTL: isRTL,
          showKeyboardShortcuts: showKeyboardShortcuts,
          weekDayFormat: weekDayFormat
        });

        if (onOutsideClick) {
          return _react2['default'].createElement(_OutsideClickHandler2['default'], {
            onOutsideClick: onOutsideClick
          }, dayPickerComponent);
        }

        return dayPickerComponent;
      }

      return render;
    }()
  }]);

  return DayPickerSingleDateController;
}(_react2['default'].Component);

exports['default'] = DayPickerSingleDateController;

DayPickerSingleDateController.propTypes = propTypes;
DayPickerSingleDateController.defaultProps = defaultProps;

/***/ })
/******/ ]);

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 75);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __webpack_require__(2);

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __webpack_require__(24);

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function () {
      function render() {
        return _react2["default"].createElement(
          "svg",
          _extends({ viewBox: "0 0 12 12" }, this.props),
          _react2["default"].createElement("path", { fillRule: "evenodd", d: "M11.53.47a.75.75 0 0 0-1.061 0l-4.47 4.47L1.529.47A.75.75 0 1 0 .468 1.531l4.47 4.47-4.47 4.47a.75.75 0 1 0 1.061 1.061l4.47-4.47 4.47 4.47a.75.75 0 1 0 1.061-1.061l-4.47-4.47 4.47-4.47a.75.75 0 0 0 0-1.061z" })
        );
      }

      return render;
    }()
  }]);

  return SVG;
}(_react2["default"].Component);

exports["default"] = SVG;

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

module.exports = __webpack_require__(98);

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

module.exports = __webpack_require__(115);

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __webpack_require__(12);

/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function () {
      function render() {
        return _react2["default"].createElement(
          "svg",
          _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1393.1 1500" }, this.props),
          _react2["default"].createElement("path", { d: "M107.2 1392.9h241.1v-241.1H107.2v241.1zm294.7 0h267.9v-241.1H401.9v241.1zm-294.7-294.7h241.1V830.4H107.2v267.8zm294.7 0h267.9V830.4H401.9v267.8zM107.2 776.8h241.1V535.7H107.2v241.1zm616.2 616.1h267.9v-241.1H723.4v241.1zM401.9 776.8h267.9V535.7H401.9v241.1zm642.9 616.1H1286v-241.1h-241.1v241.1zm-321.4-294.7h267.9V830.4H723.4v267.8zM428.7 375V133.9c0-7.3-2.7-13.5-8-18.8-5.3-5.3-11.6-8-18.8-8h-53.6c-7.3 0-13.5 2.7-18.8 8-5.3 5.3-8 11.6-8 18.8V375c0 7.3 2.7 13.5 8 18.8 5.3 5.3 11.6 8 18.8 8h53.6c7.3 0 13.5-2.7 18.8-8 5.3-5.3 8-11.5 8-18.8zm616.1 723.2H1286V830.4h-241.1v267.8zM723.4 776.8h267.9V535.7H723.4v241.1zm321.4 0H1286V535.7h-241.1v241.1zm26.8-401.8V133.9c0-7.3-2.7-13.5-8-18.8-5.3-5.3-11.6-8-18.8-8h-53.6c-7.3 0-13.5 2.7-18.8 8-5.3 5.3-8 11.6-8 18.8V375c0 7.3 2.7 13.5 8 18.8 5.3 5.3 11.6 8 18.8 8h53.6c7.3 0 13.5-2.7 18.8-8 5.4-5.3 8-11.5 8-18.8zm321.5-53.6v1071.4c0 29-10.6 54.1-31.8 75.3-21.2 21.2-46.3 31.8-75.3 31.8H107.2c-29 0-54.1-10.6-75.3-31.8C10.6 1447 0 1421.9 0 1392.9V321.4c0-29 10.6-54.1 31.8-75.3s46.3-31.8 75.3-31.8h107.2v-80.4c0-36.8 13.1-68.4 39.3-94.6S311.4 0 348.3 0h53.6c36.8 0 68.4 13.1 94.6 39.3 26.2 26.2 39.3 57.8 39.3 94.6v80.4h321.5v-80.4c0-36.8 13.1-68.4 39.3-94.6C922.9 13.1 954.4 0 991.3 0h53.6c36.8 0 68.4 13.1 94.6 39.3s39.3 57.8 39.3 94.6v80.4H1286c29 0 54.1 10.6 75.3 31.8 21.2 21.2 31.8 46.3 31.8 75.3z" })
        );
      }

      return render;
    }()
  }]);

  return SVG;
}(_react2["default"].Component);

exports["default"] = SVG;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __webpack_require__(27);

/***/ }),

/***/ 35:
/***/ (function(module, exports) {

module.exports = __webpack_require__(547);

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __webpack_require__(6);

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __webpack_require__(37);

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = __webpack_require__(44);

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _airbnbPropTypes = __webpack_require__(1);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _defaultPhrases = __webpack_require__(3);

var _getPhrasePropTypes = __webpack_require__(5);

var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);

var _DateInput = __webpack_require__(35);

var _DateInput2 = _interopRequireDefault(_DateInput);

var _IconPositionShape = __webpack_require__(19);

var _IconPositionShape2 = _interopRequireDefault(_IconPositionShape);

var _close = __webpack_require__(11);

var _close2 = _interopRequireDefault(_close);

var _calendar = __webpack_require__(27);

var _calendar2 = _interopRequireDefault(_calendar);

var _OpenDirectionShape = __webpack_require__(15);

var _OpenDirectionShape2 = _interopRequireDefault(_OpenDirectionShape);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
  id: _propTypes2['default'].string.isRequired,
  placeholder: _propTypes2['default'].string, // also used as label
  displayValue: _propTypes2['default'].string,
  inputValue: _propTypes2['default'].string,
  screenReaderMessage: _propTypes2['default'].string,
  focused: _propTypes2['default'].bool,
  isFocused: _propTypes2['default'].bool, // describes actual DOM focus
  disabled: _propTypes2['default'].bool,
  required: _propTypes2['default'].bool,
  readOnly: _propTypes2['default'].bool,
  openDirection: _OpenDirectionShape2['default'],
  showCaret: _propTypes2['default'].bool,
  showClearDate: _propTypes2['default'].bool,
  customCloseIcon: _propTypes2['default'].node,
  showDefaultInputIcon: _propTypes2['default'].bool,
  inputIconPosition: _IconPositionShape2['default'],
  customInputIcon: _propTypes2['default'].node,
  isRTL: _propTypes2['default'].bool,
  onChange: _propTypes2['default'].func,
  onClearDate: _propTypes2['default'].func,
  onFocus: _propTypes2['default'].func,
  onKeyDownShiftTab: _propTypes2['default'].func,
  onKeyDownTab: _propTypes2['default'].func,
  onKeyDownArrowDown: _propTypes2['default'].func,

  // i18n
  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.SingleDatePickerInputPhrases))
});

var defaultProps = {
  placeholder: 'Select Date',
  displayValue: '',
  inputValue: '',
  screenReaderMessage: '',
  focused: false,
  isFocused: false,
  disabled: false,
  required: false,
  readOnly: false,
  openDirection: _constants.OPEN_DOWN,
  showCaret: false,
  showClearDate: false,
  showDefaultInputIcon: false,
  inputIconPosition: _constants.ICON_BEFORE_POSITION,
  customCloseIcon: null,
  customInputIcon: null,
  isRTL: false,

  onChange: function () {
    function onChange() {}

    return onChange;
  }(),
  onClearDate: function () {
    function onClearDate() {}

    return onClearDate;
  }(),
  onFocus: function () {
    function onFocus() {}

    return onFocus;
  }(),
  onKeyDownShiftTab: function () {
    function onKeyDownShiftTab() {}

    return onKeyDownShiftTab;
  }(),
  onKeyDownTab: function () {
    function onKeyDownTab() {}

    return onKeyDownTab;
  }(),
  onKeyDownArrowDown: function () {
    function onKeyDownArrowDown() {}

    return onKeyDownArrowDown;
  }(),

  // i18n
  phrases: _defaultPhrases.SingleDatePickerInputPhrases
};

var SingleDatePickerInput = function (_React$Component) {
  _inherits(SingleDatePickerInput, _React$Component);

  function SingleDatePickerInput(props) {
    _classCallCheck(this, SingleDatePickerInput);

    var _this = _possibleConstructorReturn(this, (SingleDatePickerInput.__proto__ || Object.getPrototypeOf(SingleDatePickerInput)).call(this, props));

    _this.state = {
      isClearDateHovered: false
    };

    _this.onClearDateMouseEnter = _this.onClearDateMouseEnter.bind(_this);
    _this.onClearDateMouseLeave = _this.onClearDateMouseLeave.bind(_this);
    return _this;
  }

  _createClass(SingleDatePickerInput, [{
    key: 'onClearDateMouseEnter',
    value: function () {
      function onClearDateMouseEnter() {
        this.setState({
          isClearDateHovered: true
        });
      }

      return onClearDateMouseEnter;
    }()
  }, {
    key: 'onClearDateMouseLeave',
    value: function () {
      function onClearDateMouseLeave() {
        this.setState({
          isClearDateHovered: false
        });
      }

      return onClearDateMouseLeave;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var isClearDateHovered = this.state.isClearDateHovered;
        var _props = this.props,
            id = _props.id,
            placeholder = _props.placeholder,
            displayValue = _props.displayValue,
            inputValue = _props.inputValue,
            focused = _props.focused,
            isFocused = _props.isFocused,
            disabled = _props.disabled,
            required = _props.required,
            readOnly = _props.readOnly,
            openDirection = _props.openDirection,
            showCaret = _props.showCaret,
            showClearDate = _props.showClearDate,
            showDefaultInputIcon = _props.showDefaultInputIcon,
            inputIconPosition = _props.inputIconPosition,
            phrases = _props.phrases,
            onClearDate = _props.onClearDate,
            onChange = _props.onChange,
            onFocus = _props.onFocus,
            onKeyDownShiftTab = _props.onKeyDownShiftTab,
            onKeyDownTab = _props.onKeyDownTab,
            onKeyDownArrowDown = _props.onKeyDownArrowDown,
            screenReaderMessage = _props.screenReaderMessage,
            customCloseIcon = _props.customCloseIcon,
            customInputIcon = _props.customInputIcon,
            isRTL = _props.isRTL;

        var calendarIcon = customInputIcon || _react2['default'].createElement(_calendar2['default'], null);
        var closeIcon = customCloseIcon || _react2['default'].createElement(_close2['default'], null);
        var screenReaderText = screenReaderMessage || phrases.keyboardNavigationInstructions;
        var inputIcon = (showDefaultInputIcon || customInputIcon !== null) && _react2['default'].createElement('button', {
          type: 'button',
          className: 'SingleDatePickerInput__calendar-icon',
          disabled: disabled,
          'aria-label': phrases.focusStartDate,
          onClick: onFocus
        }, calendarIcon);

        return _react2['default'].createElement('div', {
          className: (0, _classnames2['default'])('SingleDatePickerInput', {
            'SingleDatePickerInput--disabled': disabled,
            'SingleDatePickerInput--rtl': isRTL
          })
        }, inputIconPosition === _constants.ICON_BEFORE_POSITION && inputIcon, _react2['default'].createElement(_DateInput2['default'], {
          id: id,
          placeholder: placeholder // also used as label
          , displayValue: displayValue,
          inputValue: inputValue,
          screenReaderMessage: screenReaderText,
          focused: focused,
          isFocused: isFocused,
          disabled: disabled,
          required: required,
          readOnly: readOnly,
          openDirection: openDirection,
          showCaret: showCaret,
          onChange: onChange,
          onFocus: onFocus,
          onKeyDownShiftTab: onKeyDownShiftTab,
          onKeyDownTab: onKeyDownTab,
          onKeyDownArrowDown: onKeyDownArrowDown
        }), showClearDate && _react2['default'].createElement('button', {
          type: 'button',
          className: (0, _classnames2['default'])('SingleDatePickerInput__clear-date', {
            'SingleDatePickerInput__clear-date--hide': !displayValue,
            'SingleDatePickerInput__clear-date--hover': isClearDateHovered
          }),
          disabled: disabled,
          'aria-label': phrases.clearDate,
          onMouseEnter: this.onClearDateMouseEnter,
          onMouseLeave: this.onClearDateMouseLeave,
          onClick: onClearDate
        }, _react2['default'].createElement('div', { className: 'DateRangePickerInput__close' }, closeIcon)), inputIconPosition === _constants.ICON_AFTER_POSITION && inputIcon);
      }

      return render;
    }()
  }]);

  return SingleDatePickerInput;
}(_react2['default'].Component);

exports['default'] = SingleDatePickerInput;

SingleDatePickerInput.propTypes = propTypes;
SingleDatePickerInput.defaultProps = defaultProps;

/***/ })

/******/ });

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// SET_TEXT_FILTER
var setTextFilter = exports.setTextFilter = function setTextFilter() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return {
    type: 'SET_TEXT_FILTER',
    text: text
  };
};

//SET_FATTURA_FILTER
var setFatturaFilter = exports.setFatturaFilter = function setFatturaFilter() {
  var fattura = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return {
    type: 'SET_FATTURA_FILTER',
    fattura: fattura
  };
};
//SET_OGGETTO_FILTER
var setOggettoFilter = exports.setOggettoFilter = function setOggettoFilter() {
  var oggetto = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return {
    type: 'SET_OGGETTO_FILTER',
    oggetto: oggetto
  };
};
// SORT_BY_DATE
var sortByDate = exports.sortByDate = function sortByDate() {
  return {
    type: 'SORT_BY_DATE'
  };
};

// SORT_BY_AMOUNT
var sortByAmount = exports.sortByAmount = function sortByAmount() {
  return {
    type: 'SORT_BY_AMOUNT'
  };
};

//SORT_BY_PAID
var sortByPaid = exports.sortByPaid = function sortByPaid() {
  return {
    type: 'SORT_BY_PAID'
  };
};

//SORT_BY_PUBLISHED
var sortByPublished = exports.sortByPublished = function sortByPublished() {
  return {
    type: 'SORT_BY_PUBLISHED'
  };
};

//SORT_BY_NAME
var sortByName = exports.sortByName = function sortByName() {
  return {
    type: 'SORT_BY_NAME'
  };
};

//SET_START_DATE
var setStartDate = exports.setStartDate = function setStartDate(startDate) {
  return {
    type: 'SET_START_DATE',
    startDate: startDate
  };
};

//SET_END_DATE
var setEndDate = exports.setEndDate = function setEndDate(endDate) {
  return {
    type: 'SET_END_DATE',
    endDate: endDate
  };
};
//SET_CLIENTE_FILTER
var setClienteFilter = exports.setClienteFilter = function setClienteFilter() {
  var cliente = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return {
    type: 'SET_CLIENTE_FILTER',
    cliente: cliente
  };
};
//SET_START_DATE_CLIENTI
var setStartDateClienti = exports.setStartDateClienti = function setStartDateClienti(startDateClienti) {
  return {
    type: 'SET_START_DATE_CLIENTI',
    startDateClienti: startDateClienti
  };
};

//SET_END_DATE_CLIENTI
var setEndDateClienti = exports.setEndDateClienti = function setEndDateClienti(endDateClienti) {
  return {
    type: 'SET_END_DATE_CLIENTI',
    endDateClienti: endDateClienti
  };
};
//SORT_CLIENTI_BY_DSGVO
var sortClientiByDSGVO = exports.sortClientiByDSGVO = function sortClientiByDSGVO() {
  return {
    type: 'SORT_CLIENTI_BY_DSGVO'
  };
};
//SORT_CLIENTI_BY_NAME
var sortClientiByName = exports.sortClientiByName = function sortClientiByName() {
  return {
    type: 'SORT_CLIENTI_BY_NAME'
  };
};
//SORT_CLIENTI_BY_REGISTRATION
var sortClientiByRegistration = exports.sortClientiByRegistration = function sortClientiByRegistration() {
  return {
    type: 'SORT_CLIENTI_BY_REGISTRATION'
  };
};
// SET_LEAD_FILTER
var setLeadsFilter = exports.setLeadsFilter = function setLeadsFilter() {
  var lead = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return {
    type: 'SET_LEAD_FILTER',
    lead: lead
  };
};

// SET_LEADSTATO_FILTER
var setLeadsStatoFilter = exports.setLeadsStatoFilter = function setLeadsStatoFilter(leadStato) {
  return {
    type: 'SET_LEADSTATO_FILTER',
    leadStato: leadStato
  };
};

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DealForm = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _withForm = __webpack_require__(21);

var _withForm2 = _interopRequireDefault(_withForm);

__webpack_require__(29);

__webpack_require__(30);

__webpack_require__(31);

var _utils = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DealForm = exports.DealForm = function (_React$Component) {
  _inherits(DealForm, _React$Component);

  function DealForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DealForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DealForm.__proto__ || Object.getPrototypeOf(DealForm)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (e) {
      e.preventDefault();

      var deals = _this.props.data.deals;


      var prezzoDiVendita = (0, _utils.trasformaInNumero)(deals.prezzoDiVendita);
      var amount = (0, _utils.trasformaInNumero)(deals.amount);
      var provvM2square = (0, _utils.trasformaInNumero)(deals.provvM2square);
      var provvStefano = (0, _utils.trasformaInNumero)(deals.provvStefano);
      var provvAgenziaPartner = (0, _utils.trasformaInNumero)(deals.provvAgenziaPartner);
      var provvSum = provvM2square + provvStefano + provvAgenziaPartner;

      if (!deals.oggettoId || !deals.amount || !deals.acquirenteId || !deals.venditoreId) {
        _this.props.renderError(_this.props.t('Inserisci oggetto, provvigione totale, venditore e acquirente'));
      } else if (amount !== provvSum) {
        var differenza = (provvSum - amount) / 100;
        _this.props.renderError(_this.props.t('La somma delle provvigioni non corrisponde alla provvigione totale') + '. ' + _this.props.t('Differenza di') + ' ' + differenza);
      } else {
        _this.props.renderError('');

        _this.props.onSubmit({
          feePayed: deals.feePayed,
          oggettoId: deals.oggettoId,
          prezzoDiVendita: prezzoDiVendita,
          amount: amount,
          consulenteVendita: deals.consulenteVendita,
          provvM2square: provvM2square,
          dealType: deals.dealType,
          provvStefano: provvStefano,
          payedStefano: deals.payedStefano,
          payedAtStefano: deals.payedAtStefano ? deals.payedAtStefano.valueOf() : null,
          agenziaPartnerId: deals.agenziaPartnerId,
          provvAgenziaPartner: provvAgenziaPartner,
          payedAgenziaPartner: deals.payedAgenziaPartner,
          createdAt: deals.createdAt ? deals.createdAt.valueOf() : null,
          venditoreId: deals.venditoreId,
          venditoreId2: deals.venditoreId2,
          acquirenteId: deals.acquirenteId,
          acquirenteId2: deals.acquirenteId2,
          notaioId: deals.notaioId,
          dataRogito: deals.dataRogito ? deals.dataRogito.valueOf() : null,
          dataConsegna: deals.dataConsegna ? deals.dataConsegna.valueOf() : null,
          linguaRogito: deals.linguaRogito,
          belastungsVollmacht: deals.belastungsVollmacht,
          calendarDataFatturaFocused: false,
          note: deals.note
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DealForm, [{
    key: 'render',
    value: function render() {
      var deals = this.props.data.deals;
      var _props = this.props,
          t = _props.t,
          renderSelect = _props.renderSelect,
          renderCheckbox = _props.renderCheckbox,
          renderInput = _props.renderInput,
          renderSingleDate = _props.renderSingleDate,
          renderTextArea = _props.renderTextArea,
          changeHandlerValuta = _props.changeHandlerValuta;


      var options = this.props.clienti.map(function (cliente) {
        return {
          value: cliente.id,
          label: cliente.nome + ' ' + cliente.cognome + ' ' + (cliente.ditta && '- Firma ' + cliente.ditta)
        };
      });

      var oggettiOptions = this.props.oggetti.map(function (oggetto) {
        return {
          value: oggetto.id,
          label: 'Rif.Id: ' + oggetto.rifId + ' - ' + oggetto.via + ' ' + oggetto.numeroCivico + ', WE ' + oggetto.numeroAppartamento + ', ' + oggetto.cap + ' ' + oggetto.citta
        };
      });

      var dealTypeOptions = ['Kauf Eigentumswohnung', 'Miete Eigentumswohnung', 'Kauf Gewerbe', 'Miete Gewerbe', 'APH', 'Sonstiges'].map(function (dealType) {
        return {
          value: dealType,
          label: t(dealType)
        };
      });

      var consulenteVenditaOptions = this.props.utenti.map(function (consulente) {
        return {
          value: consulente.id,
          label: consulente.name
        };
      });

      var linguaRogitoOptions = ['Englisch', 'Italienisch', 'Spanisch', 'Französisch', 'Englisch-Italienisch', 'Englisch-Französisch', 'Englisch-Spanisch'].map(function (linguaRogito) {
        return {
          value: linguaRogito,
          label: t(linguaRogito)
        };
      });

      return _react2.default.createElement(
        'form',
        { className: 'form', onSubmit: this.onSubmit },
        this.props.data.error && _react2.default.createElement(
          'p',
          { className: 'form__error' },
          this.props.data.error
        ),
        _react2.default.createElement(
          'div',
          { className: 'fixed-action-btn' },
          _react2.default.createElement(
            'button',
            { className: 'btn-floating blue btn-large' },
            _react2.default.createElement(
              'i',
              { className: 'material-icons' },
              'save'
            )
          )
        ),
        renderSelect('deals', 'dealType', dealTypeOptions, t('Tipo di vendita')),
        renderSelect('deals', 'oggettoId', oggettiOptions, t('Oggetto'), '*'),
        renderSingleDate('deals', 'createdAt', 'calendarFocused', t('Data prenotazione')),
        renderInput('deals', 'prezzoDiVendita', t('Prezzo di vendita'), undefined, changeHandlerValuta),
        renderInput('deals', 'amount', t('Provvigione totale'), undefined, changeHandlerValuta, undefined, '6%: ' + (0, _utils.trasformaInNumero)(deals.prezzoDiVendita, true) * 0.06, '*'),
        renderCheckbox('deals', 'feePayed', t('Pagato (Gutschrift)')),
        renderSelect('deals', 'consulenteVendita', consulenteVenditaOptions, t('sales_rep_name')),
        renderInput('deals', 'provvM2square', t('Provvigione') + ' m2Square', undefined, changeHandlerValuta, undefined, '80%: ' + parseFloat(deals.amount.replace(/,/, '.') - deals.provvAgenziaPartner.replace(/,/, '.'), 10) * 0.8),
        renderInput('deals', 'provvStefano', t('Provvigione') + ' ' + t('sales_rep_name'), undefined, changeHandlerValuta, undefined, '20%: ' + parseFloat(deals.amount.replace(/,/, '.') - deals.provvAgenziaPartner.replace(/,/, '.'), 10) * 0.2),
        renderCheckbox('deals', 'payedStefano', t('Pagato')),
        _react2.default.createElement(
          'div',
          { className: 'visible-' + deals.payedStefano + ' form' },
          renderSingleDate('deals', 'payedAtStefano', 'calendarPayedAtStefanoFocused', t('Pagato il'))
        ),
        renderSelect('deals', 'agenziaPartnerId', options, t('Partner commerciale')),
        renderInput('deals', 'provvAgenziaPartner', t('Provvigione') + ' ' + t('Partner commerciale'), undefined, changeHandlerValuta),
        renderCheckbox('deals', 'payedAgenziaPartner', t('Pagato')),
        renderSelect('deals', 'venditoreId', options, t('Venditore'), '*'),
        renderSelect('deals', 'venditoreId2', options, '2. ' + t('Venditore')),
        renderSelect('deals', 'acquirenteId', options, t('Acquirente'), '*'),
        renderSelect('deals', 'acquirenteId2', options, '2. ' + t('Acquirente')),
        renderSelect('deals', 'notaioId', options, t('Notaio')),
        renderSingleDate('deals', 'dataRogito', 'calendarDataRogitoFocused', t('Data del rogito')),
        renderSelect('deals', 'linguaRogito', linguaRogitoOptions, t('Lingua del rogito')),
        renderCheckbox('deals', 'belastungsVollmacht', t('Delega per gravami')),
        renderSingleDate('deals', 'dataConsegna', 'calendarDataConsegnaFocused', t('Data consegna immobile')),
        renderTextArea('deals', 'note', t('Note (opzionale)'))
      );
    }
  }]);

  return DealForm;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    utenti: state.utenti,
    clienti: state.clienti,
    oggetti: state.oggetti
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()((0, _withForm2.default)(DealForm)));

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1004), __esModule: true };

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(71) && !__webpack_require__(103)(function () {
  return Object.defineProperty(__webpack_require__(204)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(88);
var toIObject = __webpack_require__(89);
var arrayIndexOf = __webpack_require__(1007)(false);
var IE_PROTO = __webpack_require__(208)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(120);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(207);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(88);
var toObject = __webpack_require__(157);
var IE_PROTO = __webpack_require__(208)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1014);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1022);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(1016)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(582)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(121);
var $export = __webpack_require__(57);
var redefine = __webpack_require__(583);
var hide = __webpack_require__(87);
var Iterators = __webpack_require__(124);
var $iterCreate = __webpack_require__(1017);
var setToStringTag = __webpack_require__(158);
var getPrototypeOf = __webpack_require__(579);
var ITERATOR = __webpack_require__(38)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(87);


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(28).document;
module.exports = document && document.documentElement;


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1019);
var global = __webpack_require__(28);
var hide = __webpack_require__(87);
var Iterators = __webpack_require__(124);
var TO_STRING_TAG = __webpack_require__(38)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(576);
var hiddenKeys = __webpack_require__(210).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 587 */
/***/ (function(module, exports) {



/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function toVal(mix) {
	var k, y, str='';
	if (mix) {
		if (typeof mix === 'object') {
			if (!!mix.push) {
				for (k=0; k < mix.length; k++) {
					if (mix[k] && (y = toVal(mix[k]))) {
						str && (str += ' ');
						str += y;
					}
				}
			} else {
				for (k in mix) {
					if (mix[k] && (y = toVal(k))) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else if (typeof mix !== 'boolean' && !mix.call) {
			str && (str += ' ');
			str += mix;
		}
	}
	return str;
}

/* harmony default export */ __webpack_exports__["default"] = (function () {
	var i=0, x, str='';
	while (i < arguments.length) {
		if (x = toVal(arguments[i++])) {
			str && (str += ' ');
			str += x
		}
	}
	return str;
});


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SCROLL_DIRECTION_VERTICAL = exports.SCROLL_DIRECTION_HORIZONTAL = exports.SCROLL_DIRECTION_FORWARD = exports.SCROLL_DIRECTION_BACKWARD = undefined;
exports.default = defaultOverscanIndicesGetter;

var _types = __webpack_require__(72);

var SCROLL_DIRECTION_BACKWARD = exports.SCROLL_DIRECTION_BACKWARD = -1;

var SCROLL_DIRECTION_FORWARD = exports.SCROLL_DIRECTION_FORWARD = 1;

var SCROLL_DIRECTION_HORIZONTAL = exports.SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var SCROLL_DIRECTION_VERTICAL = exports.SCROLL_DIRECTION_VERTICAL = 'vertical';

/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */

function defaultOverscanIndicesGetter(_ref) {
  var cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;

  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
    return {
      overscanStartIndex: Math.max(0, startIndex),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex)
    };
  }
}

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defaultCellRangeRenderer;

var _types = __webpack_require__(72);

/**
 * Default implementation of cellRangeRenderer used by Grid.
 * This renderer supports cell-caching while the user is scrolling.
 */

function defaultCellRangeRenderer(_ref) {
  var cellCache = _ref.cellCache,
      cellRenderer = _ref.cellRenderer,
      columnSizeAndPositionManager = _ref.columnSizeAndPositionManager,
      columnStartIndex = _ref.columnStartIndex,
      columnStopIndex = _ref.columnStopIndex,
      deferredMeasurementCache = _ref.deferredMeasurementCache,
      horizontalOffsetAdjustment = _ref.horizontalOffsetAdjustment,
      isScrolling = _ref.isScrolling,
      isScrollingOptOut = _ref.isScrollingOptOut,
      parent = _ref.parent,
      rowSizeAndPositionManager = _ref.rowSizeAndPositionManager,
      rowStartIndex = _ref.rowStartIndex,
      rowStopIndex = _ref.rowStopIndex,
      styleCache = _ref.styleCache,
      verticalOffsetAdjustment = _ref.verticalOffsetAdjustment,
      visibleColumnIndices = _ref.visibleColumnIndices,
      visibleRowIndices = _ref.visibleRowIndices;

  var renderedCells = [];

  // Browsers have native size limits for elements (eg Chrome 33M pixels, IE 1.5M pixes).
  // User cannot scroll beyond these size limitations.
  // In order to work around this, ScalingCellSizeAndPositionManager compresses offsets.
  // We should never cache styles for compressed offsets though as this can lead to bugs.
  // See issue #576 for more.
  var areOffsetsAdjusted = columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();

  var canCacheStyle = !isScrolling && !areOffsetsAdjusted;

  for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
    var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);

    for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
      var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
      var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
      var key = rowIndex + '-' + columnIndex;
      var style = void 0;

      // Cache style objects so shallow-compare doesn't re-render unnecessarily.
      if (canCacheStyle && styleCache[key]) {
        style = styleCache[key];
      } else {
        // In deferred mode, cells will be initially rendered before we know their size.
        // Don't interfere with CellMeasurer's measurements by setting an invalid size.
        if (deferredMeasurementCache && !deferredMeasurementCache.has(rowIndex, columnIndex)) {
          // Position not-yet-measured cells at top/left 0,0,
          // And give them width/height of 'auto' so they can grow larger than the parent Grid if necessary.
          // Positioning them further to the right/bottom influences their measured size.
          style = {
            height: 'auto',
            left: 0,
            position: 'absolute',
            top: 0,
            width: 'auto'
          };
        } else {
          style = {
            height: rowDatum.size,
            left: columnDatum.offset + horizontalOffsetAdjustment,
            position: 'absolute',
            top: rowDatum.offset + verticalOffsetAdjustment,
            width: columnDatum.size
          };

          styleCache[key] = style;
        }
      }

      var cellRendererParams = {
        columnIndex: columnIndex,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent,
        rowIndex: rowIndex,
        style: style
      };

      var renderedCell = void 0;

      // Avoid re-creating cells while scrolling.
      // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
      // If a scroll is in progress- cache and reuse cells.
      // This cache will be thrown away once scrolling completes.
      // However if we are scaling scroll positions and sizes, we should also avoid caching.
      // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
      // For more info refer to issue #395
      //
      // If isScrollingOptOut is specified, we always cache cells.
      // For more info refer to issue #1028
      if ((isScrollingOptOut || isScrolling) && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
        if (!cellCache[key]) {
          cellCache[key] = cellRenderer(cellRendererParams);
        }

        renderedCell = cellCache[key];

        // If the user is no longer scrolling, don't cache cells.
        // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
      } else {
        renderedCell = cellRenderer(cellRendererParams);
      }

      if (renderedCell == null || renderedCell === false) {
        continue;
      }

      if (false) {
        warnAboutMissingStyle(parent, renderedCell);
      }

      renderedCells.push(renderedCell);
    }
  }

  return renderedCells;
}

function warnAboutMissingStyle(parent, renderedCell) {
  if (false) {
    if (renderedCell) {
      // If the direct child is a CellMeasurer, then we should check its child
      // See issue #611
      if (renderedCell.type && renderedCell.type.__internalCellMeasurerFlag) {
        renderedCell = renderedCell.props.children;
      }

      if (renderedCell && renderedCell.props && renderedCell.props.style === undefined && parent.__warnedAboutMissingStyle !== true) {
        parent.__warnedAboutMissingStyle = true;

        console.warn('Rendered cell should include style property for positioning.');
      }
    }
  }
}

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(120);
var TAG = __webpack_require__(38)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(62);
var aFunction = __webpack_require__(153);
var SPECIES = __webpack_require__(38)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(118);
var invoke = __webpack_require__(1069);
var html = __webpack_require__(584);
var cel = __webpack_require__(204);
var global = __webpack_require__(28);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(120)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 594 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(62);
var isObject = __webpack_require__(70);
var newPromiseCapability = __webpack_require__(221);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bpfrpt_proptype_Scroll = exports.bpfrpt_proptype_RenderedRows = exports.bpfrpt_proptype_RowRenderer = exports.bpfrpt_proptype_RowRendererParams = undefined;

var _react = __webpack_require__(2);

var React = _interopRequireWildcard(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var bpfrpt_proptype_RowRendererParams =  true ? null : {
  index: _propTypes2.default.number.isRequired,
  isScrolling: _propTypes2.default.bool.isRequired,
  isVisible: _propTypes2.default.bool.isRequired,
  key: _propTypes2.default.string.isRequired,
  parent: _propTypes2.default.object.isRequired,
  style: _propTypes2.default.object.isRequired
};
var bpfrpt_proptype_RowRenderer =  true ? null : _propTypes2.default.func;
var bpfrpt_proptype_RenderedRows =  true ? null : {
  overscanStartIndex: _propTypes2.default.number.isRequired,
  overscanStopIndex: _propTypes2.default.number.isRequired,
  startIndex: _propTypes2.default.number.isRequired,
  stopIndex: _propTypes2.default.number.isRequired
};
var bpfrpt_proptype_Scroll =  true ? null : {
  clientHeight: _propTypes2.default.number.isRequired,
  scrollHeight: _propTypes2.default.number.isRequired,
  scrollTop: _propTypes2.default.number.isRequired
};
exports.bpfrpt_proptype_RowRendererParams = bpfrpt_proptype_RowRendererParams;
exports.bpfrpt_proptype_RowRenderer = bpfrpt_proptype_RowRenderer;
exports.bpfrpt_proptype_RenderedRows = bpfrpt_proptype_RenderedRows;
exports.bpfrpt_proptype_Scroll = bpfrpt_proptype_Scroll;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var tabbableNode = /input|select|textarea|button|object/;

function hidden(el) {
  return el.offsetWidth <= 0 && el.offsetHeight <= 0 || el.style.display === 'none';
}

function visible(element) {
  var parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) break;
    if (hidden(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute('tabindex');
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll('*'), 0).filter(tabbable);
}
module.exports = exports['default'];

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.tryForceFallback = tryForceFallback;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
exports.resetForTesting = resetForTesting;
var globalElement = null;

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error('react-modal: No elements were found for selector ' + selector + '.');
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === 'string') {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = 'length' in el ? el[0] : el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function tryForceFallback() {
  if (document && document.body) {
    // force fallback to document.body
    setElement(document.body);
    return true;
  }
  return false;
}

function validateElement(appElement) {
  if (!appElement && !globalElement && !tryForceFallback()) {
    throw new Error(['react-modal: Cannot fallback to `document.body`, because it\'s not ready or available.', 'If you are doing server-side rendering, use this function to defined an element.', '`Modal.setAppElement(el)` to make this accessible']);
  }
}

function hide(appElement) {
  validateElement(appElement);
  (appElement || globalElement).setAttribute('aria-hidden', 'true');
}

function show(appElement) {
  validateElement(appElement);
  (appElement || globalElement).removeAttribute('aria-hidden');
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

function resetForTesting() {
  globalElement = document.body;
}

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.get = get;
exports.add = add;
exports.remove = remove;
exports.totalCount = totalCount;
var classListMap = {};

function get() {
  return classListMap;
}

function add(bodyClass) {
  // Set variable and default if none
  if (!classListMap[bodyClass]) {
    classListMap[bodyClass] = 0;
  }
  classListMap[bodyClass] += 1;
  return bodyClass;
}

function remove(bodyClass) {
  if (classListMap[bodyClass]) {
    classListMap[bodyClass] -= 1;
  }
  return bodyClass;
}

function totalCount() {
  return Object.keys(classListMap).reduce(function (acc, curr) {
    return acc + classListMap[curr];
  }, 0);
}

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _exenv = __webpack_require__(1085);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

exports.default = SafeHTMLElement;
module.exports = exports['default'];

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.creaPrenotazione = undefined;

var _jspdf = __webpack_require__(32);

var _jspdf2 = _interopRequireDefault(_jspdf);

var _ImageLogo = __webpack_require__(39);

var _provisionsbestaetigungBG = __webpack_require__(1094);

var _utils = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { ivdLogo } from './img/IvdLogo';
var creaPrenotazione = exports.creaPrenotazione = function creaPrenotazione(acquirente, acquirente2, venditore, venditore2, oggetto, provvPercentuale, prezzoDiVendita, firma) {
  var doc = new _jspdf2.default();

  var dittaAcquirente = (0, _utils.ditta)(acquirente);
  var nomeCompletoAcquirente = (0, _utils.nomeCompleto)(acquirente);
  var indirizzoCompletoAcquirente = (0, _utils.indirizzoCompleto)(acquirente);
  var nomeCompletoAcquirente2 = (0, _utils.nomeCompleto)(acquirente2);
  var indirizzoCompletoAcquirente2 = (0, _utils.indirizzoCompleto)(acquirente2);
  var nomeCompletoVenditore = (0, _utils.nomeCompleto)(venditore);
  var indirizzoCompletoVenditore = (0, _utils.indirizzoCompleto)(venditore);

  var dittaVenditore = (0, _utils.ditta)(venditore);

  doc.addImage(_provisionsbestaetigungBG.imgData, 'JPEG', 0, 0, 210, 297);
  doc.addImage(_ImageLogo.imgLogo, 'JPEG', 28, 11, 35, 8);
  //Logo IVD
  // doc.addImage(ivdLogo, 'JPEG', 165, 10, 30, 12, undefined, 'SLOW');

  //cancello frase che dice che gli abbiamo mandato exposé oggi. Metto una riga bianca sopra

  doc.setDrawColor(255, 255, 255);
  doc.setLineWidth(7);
  doc.line(20, 250, 200, 250);

  doc.setFontSize(10);
  // nuovo
  if (!acquirente2) {
    if (dittaAcquirente.length > 0) {
      doc.text(dittaAcquirente, 61, 30);
      doc.text(nomeCompletoAcquirente, 61, 35);
      doc.text(indirizzoCompletoAcquirente, 61, 40);
    } else {
      doc.text(nomeCompletoAcquirente, 61, 30);
      doc.text(indirizzoCompletoAcquirente, 61, 35);
    }
  } else {
    if (dittaAcquirente.length > 0) {
      doc.text(dittaAcquirente, 61, 30);
      doc.text('1. ' + nomeCompletoAcquirente + ', ' + indirizzoCompletoAcquirente, 61, 35);
      doc.text('2. ' + nomeCompletoAcquirente2 + ', ' + indirizzoCompletoAcquirente2, 61, 40);
    } else {
      doc.text('1. ' + nomeCompletoAcquirente + ', ' + indirizzoCompletoAcquirente, 61, 30);
      doc.text('2. ' + nomeCompletoAcquirente2 + ', ' + indirizzoCompletoAcquirente2, 61, 35);
    }
  }

  doc.text((0, _utils.contattiFirma)(firma), 61, 52);
  doc.text(provvPercentuale, 93, 86);

  //Oggetto
  doc.setFontSize(10);
  doc.text(oggetto.rifId, 25, 136);

  doc.text('' + (oggetto.tipologia ? oggetto.tipologia === 'property_apt' ? 'Eigentumswohnung' : 'Gewerbe' : 'Eigentumswohnung'), 41, 136);
  doc.text('' + (oggetto.stato ? oggetto.stato === 'vacant' || oggetto.stato === 'leerstehend' ? 'leerstehend' : 'vermietet' : ''), 41, 141);
  doc.text('Etage: ' + oggetto.piano, 41, 146);
  doc.text('m2: ' + oggetto.m2, 41, 151);
  doc.text('Kaufpreis: ' + (0, _utils.formattaPrezzo)(prezzoDiVendita, true), 41, 156);

  doc.text(oggetto.via + ' ' + oggetto.numeroCivico, 95, 136);
  doc.text((oggetto.tipologia ? oggetto.tipologia === 'Eigentumswohnung' || oggetto.tipologia === 'property_apt' ? 'WE' : 'TE' : 'WE') + ' ' + oggetto.numeroAppartamento, 95, 141);
  doc.text(oggetto.cap + ' ' + oggetto.citta, 95, 146);

  if (dittaVenditore.length > 25 || indirizzoCompletoVenditore.length > 25 || nomeCompletoVenditore.length > 25) {
    doc.setFontSize(10);
  } else if (dittaVenditore.length > 50 || indirizzoCompletoVenditore.length > 50 || nomeCompletoVenditore.length > 50) doc.setFontSize(8);else {
    doc.setFontSize(12);
  }
  if (dittaVenditore.length > 0) {
    var venditoreAddress = dittaVenditore + ' \n' + nomeCompletoVenditore + ' \n' + venditore.indirizzo + ' ' + (venditore.indirizzo2 && venditore.indirizzo2) + '\n' + venditore.cap + ' ' + venditore.comune + '\n' + venditore.nazione;
    var lines = doc.splitTextToSize(venditoreAddress, 50);
    doc.text(148, 136, lines);
  } else {
    var _venditoreAddress = nomeCompletoVenditore + ' \n' + venditore.indirizzo + ' ' + (venditore.indirizzo2 && venditore.indirizzo2) + '\n' + venditore.cap + ' ' + venditore.comune + '\n' + venditore.nazione;
    var _lines = doc.splitTextToSize(_venditoreAddress, 50);
    doc.text(148, 136, _lines);
  }

  if (venditore2) {
    doc.text((0, _utils.ditta)(venditore2), 148, 161);
    doc.text((0, _utils.nomeCompleto)(venditore2), 148, 166);
    doc.text(venditore2.indirizzo, 148, 171);
    venditore2.indirizzo2 && doc.text(venditore2.indirizzo2, 148, 176);
    doc.text(venditore2.cap + ' ' + venditore2.comune, 148, 181);
    doc.text('' + venditore2.nazione, 148, 186);
  }

  doc.save(acquirente.cognome + ' Provisionsbest\xE4tigung.pdf');
};

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widerrufsBelehrung = undefined;

var _jspdf = __webpack_require__(32);

var _jspdf2 = _interopRequireDefault(_jspdf);

var _ImageLogo = __webpack_require__(39);

var _IvdLogo = __webpack_require__(222);

var _widerrufsBelehrungBG = __webpack_require__(1095);

var _utils = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var widerrufsBelehrung = exports.widerrufsBelehrung = function widerrufsBelehrung(acquirente, acquirente2, dataPrenotazione, oggetto, firma) {
  var doc = new _jspdf2.default();

  var nomeCompletoAcquirente = (0, _utils.nomeCompleto)(acquirente);
  var indirizzoCompletoAcquirente = (0, _utils.indirizzoCompleto)(acquirente);
  var nomeCompletoAcquirente2 = (0, _utils.nomeCompleto)(acquirente2);
  var indirizzoCompletoAcquirente2 = (0, _utils.indirizzoCompleto)(acquirente2);

  doc.addImage(_widerrufsBelehrungBG.imgData, 'JPEG', 0, 0, 210, 297);
  doc.addImage(_ImageLogo.imgLogo, 'JPEG', 20, 10, 35, 8);

  //nascondo il logo ivd con un quadrato bianco
  doc.addImage(_IvdLogo.ivdLogo, 'JPEG', 180, 10, 30, 20, undefined, 'SLOW');

  if (nomeCompletoAcquirente.length > 100 || indirizzoCompletoAcquirente.length > 100 || (0, _utils.nomeCompleto)(acquirente2 || acquirente).length > 100) {
    doc.setFontSize(8);
  } else if (nomeCompletoAcquirente.length > 70 || indirizzoCompletoAcquirente.length > 70 || (0, _utils.nomeCompleto)(acquirente2 || acquirente).length > 70) doc.setFontSize(10);else {
    doc.setFontSize(12);
  }
  doc.text((0, _utils.contattiFirma)(firma), 61, 38);

  // nuovo
  if (!acquirente2) {
    doc.text(nomeCompletoAcquirente, 61, 63);
    doc.text(indirizzoCompletoAcquirente, 61, 68);
  } else {
    doc.text('1. ' + nomeCompletoAcquirente + ', ' + indirizzoCompletoAcquirente, 61, 63);
    doc.text('2. ' + nomeCompletoAcquirente2 + ', ' + indirizzoCompletoAcquirente2, 61, 68);
  }

  //fine nuovo
  doc.text('Maklervertrag', 61, 86);
  doc.text('' + dataPrenotazione, 61, 95);
  doc.text((0, _utils.indirizzoOggetto)(oggetto), 61, 101);
  doc.setFontSize(10);
  doc.text(firma.name + ' ' + (firma.name2 && ' - ' + firma.name2), 64, 148);
  doc.text(firma.adresse + ', ' + firma.plz + ' ' + firma.stadt, 64, 154);
  doc.text('per E-Mail: ' + firma.email, 64, 160);
  doc.text('per Fax: ' + firma.fax, 64, 166);
  doc.text('Bei Fragen errichen Sie uns unter: ' + firma.telefon, 64, 172);

  doc.addPage();
  doc.addImage(_widerrufsBelehrungBG.imgData2, 'JPEG', 0, 0, 210, 297);

  doc.save(acquirente.cognome + ' Widerrufsbelehrung.pdf');
};

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vollmachtNotarauftrag = undefined;

var _jspdf = __webpack_require__(32);

var _jspdf2 = _interopRequireDefault(_jspdf);

var _ImageLogo = __webpack_require__(39);

var _utils = __webpack_require__(9);

var _vollmachtNotarauftragBG = __webpack_require__(1096);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vollmachtNotarauftrag = exports.vollmachtNotarauftrag = function vollmachtNotarauftrag(acquirente, acquirente2, venditore, venditore2, oggetto, notaio, prezzoDiVendita, firma) {
  var doc = new _jspdf2.default();

  var dittaAcquirente = (0, _utils.ditta)(acquirente);
  var nomeCompletoAcquirente = (0, _utils.nomeCompleto)(acquirente);
  var indirizzoCompletoAcquirente = (0, _utils.indirizzoCompleto)(acquirente);
  var nomeCompletoAcquirente2 = (0, _utils.nomeCompleto)(acquirente2);
  var indirizzoCompletoAcquirente2 = (0, _utils.indirizzoCompleto)(acquirente2);
  var nomeCompletoVenditore = (0, _utils.nomeCompleto)(venditore);
  var indirizzoCompletoVenditore = (0, _utils.indirizzoCompleto)(venditore);
  var nomeCompletoVenditore2 = (0, _utils.nomeCompleto)(venditore2);
  var indirizzoCompletoVenditore2 = (0, _utils.indirizzoCompleto)(venditore2);

  doc.addImage(_vollmachtNotarauftragBG.imgData, 'JPEG', 0, 0, 210, 297);
  doc.addImage(_ImageLogo.imgLogo, 'JPEG', 165, 10, 35, 8);
  doc.setFontSize(12);

  if (!venditore2) {
    if ((0, _utils.ditta)(venditore).length > 0) {
      doc.text((0, _utils.ditta)(venditore), 30, 36);
      doc.text(nomeCompletoVenditore, 30, 41);
      doc.text(indirizzoCompletoVenditore, 30, 46);
    } else {
      doc.text(nomeCompletoVenditore, 30, 36);
      doc.text(indirizzoCompletoVenditore, 30, 41);
    }
  } else {
    if ((0, _utils.ditta)(venditore).length > 0) {
      doc.text((0, _utils.ditta)(venditore), 30, 36);
      doc.text('1. ' + nomeCompletoVenditore + ', ' + indirizzoCompletoVenditore, 30, 41);
      doc.text('2. ' + nomeCompletoVenditore2 + ', ' + indirizzoCompletoVenditore2, 30, 46);
    } else {
      doc.text('1. ' + nomeCompletoVenditore + ', ' + indirizzoCompletoVenditore, 30, 36);
      doc.text('2. ' + nomeCompletoVenditore2 + ', ' + indirizzoCompletoVenditore2, 30, 41);
    }
  }

  if (!acquirente2) {
    if (dittaAcquirente.length > 0) {
      doc.text(dittaAcquirente, 30, 63);
      doc.text(nomeCompletoAcquirente, 30, 68);
      doc.text(indirizzoCompletoAcquirente, 30, 73);
    } else {
      doc.text(nomeCompletoAcquirente, 30, 63);
      doc.text(indirizzoCompletoAcquirente, 30, 68);
    }
  } else {
    if (dittaAcquirente.length > 0) {
      doc.text(dittaAcquirente, 30, 63);
      doc.text('1. ' + nomeCompletoAcquirente + ', ' + indirizzoCompletoAcquirente, 30, 68);
      doc.text('2. ' + nomeCompletoAcquirente2 + ', ' + indirizzoCompletoAcquirente2, 30, 73);
    } else {
      doc.text('1. ' + nomeCompletoAcquirente + ', ' + indirizzoCompletoAcquirente, 30, 63);
      doc.text('2. ' + nomeCompletoAcquirente2 + ', ' + indirizzoCompletoAcquirente2, 30, 68);
    }
  }

  doc.text('Rif. ID: ' + oggetto.rifId + ' - ' + (oggetto.tipologia ? oggetto.tipologia === 'Eigentumswohnung' || oggetto.tipologia === 'property_apt' ? 'Eigentumswohnung' : 'Gewerbe' : ''), 30, 111);
  doc.text('Kaufpreis: ' + (0, _utils.formattaPrezzo)(prezzoDiVendita, true), 30, 116);
  doc.text((0, _utils.indirizzoOggetto)(oggetto), 30, 135);
  oggetto.grundbuch && doc.text('Grundbuch von ' + oggetto.grundbuch + ' - Blatt: ' + oggetto.grundbuchBlatt, 30, 157);

  doc.text((0, _utils.contattiFirma)(firma), 30, 185);

  if (notaio) {
    doc.text((0, _utils.ditta)(notaio), 30, 217);
    doc.text((0, _utils.nomeCompleto)(notaio), 30, 222);
    doc.text((0, _utils.indirizzoCompleto)(notaio), 30, 227);
  }

  doc.save(acquirente.cognome + ' Vollmacht Notarauftrag.pdf');
};

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notarDatenblatt = undefined;

var _jspdf = __webpack_require__(32);

var _jspdf2 = _interopRequireDefault(_jspdf);

var _ImageLogo = __webpack_require__(39);

var _utils = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { ivdLogo } from './img/IvdLogo';
var notarDatenblatt = exports.notarDatenblatt = function notarDatenblatt(acquirente, acquirente2, venditore, venditore2, oggetto, notaio, verwalter, belastungsVollmacht, utente, firma, ceo, prezzoDiVendita, linguaRogito) {
  var doc = new _jspdf2.default('p', 'mm', 'a4');
  doc.setFont('times');
  var fontStart = 10;

  var cartaIntestata = function cartaIntestata() {
    doc.addImage(_ImageLogo.imgLogo, 'JPEG', 130, 10, 55, 12, undefined, 'SLOW');
    //linea rossa
    doc.setDrawColor(145, 0, 0);
    doc.setLineWidth(7);
    doc.line(146, 26, 199, 26);
    //linea grigia
    doc.setDrawColor(143, 143, 143);
    doc.setLineWidth(7);
    doc.line(15, 26, 146, 26);

    //Header
    doc.setFontSize(fontStart + 1);
    doc.setTextColor(255, 255, 255);

    doc.setFontType('bold');
    doc.text(firma.name + ' ' + (firma.name2 && ' - ' + firma.name2) + ' - ' + firma.adresse + ', ' + firma.plz + ' ' + firma.stadt, 19, 27);
    //Footer
    doc.setDrawColor(0, 0, 0);
    doc.setLineWidth(0.2);
    doc.line(15, 267, 15, 282);
    doc.line(55, 267, 55, 282);
    doc.line(110, 267, 110, 282);
    // doc.line(160, 267, 160, 282);
    doc.setFontSize(fontStart);
    doc.setTextColor(143, 143, 143);
    doc.text('Inhaberin:', 16, 270);
    var position = 274;

    ceo.forEach(function (eachCeo) {
      doc.text('' + eachCeo.name, 16, position);
      position += 4;
    });
    doc.text('Telefon: ' + firma.telefon, 56, 270);
    doc.text('Telefax: ' + firma.fax, 56, 274);
    doc.text('E-Mail: ' + firma.email, 56, 278);
    doc.text('Web: ' + firma.website, 56, 282);
    doc.text('Steuernummer: ' + firma.steuerNr, 111, 270);
    doc.text('' + (firma.ustIdNr && 'Ust.-IdNr.: ' + firma.ustIdNr), 111, 274);

    //Logo IVD
    // doc.addImage(ivdLogo, 'JPEG', 161, 270, 30, 12, undefined, 'SLOW');
  };

  var datiVerwalter = function datiVerwalter() {
    //Verwalter
    if (verwalter) {
      acapo += 10;
      verwalter && doc.setFontSize(14);
      verwalter && doc.setFontType('bold');
      verwalter && doc.text('Verwalter', 15, acapo);
      acapo += 5;
      verwalter && doc.setFontSize(12);
      verwalter && doc.setFontType('normal');
      verwalter && doc.text(verwalter.ditta, 15, acapo);

      if (verwalter.cognome) {
        acapo += 5;
        doc.text(verwalter.titolo + ' ' + verwalter.nome + ' ' + verwalter.cognome, 15, acapo);
      }
      acapo += 5;
      doc.text(verwalter.indirizzo + ', ' + verwalter.cap + ' ' + verwalter.comune, 15, acapo);
      acapo += 5;
      doc.text('' + (verwalter.telefono1 && 'Tel.: ' + verwalter.telefono1 + ' - ') + (verwalter.fax && 'Fax: ' + verwalter.fax + ' - ') + (verwalter.cellulare && 'Handy: ' + verwalter.cellulare + ' - ') + (verwalter.email && 'E-Mail: ' + verwalter.email), 15, acapo);
    }
  };

  cartaIntestata();
  //riquadro contatti
  doc.setDrawColor(215, 240, 245);
  doc.setLineWidth(70);
  doc.line(146, 70, 199, 70);
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(fontStart);
  doc.setFontType('normal');
  doc.text('Ihr Ansprechpartner', 149, 40);
  doc.setFontType('bold');
  doc.text('' + utente.name, 149, 44);
  doc.setFontType('normal');
  doc.text('' + utente.email, 149, 48);
  doc.text('Tel. ' + utente.telefon, 149, 52);
  doc.text('' + firma.website, 149, 56);
  doc.setFontType('bold');
  doc.text('Öffnungszeiten', 149, 68);
  doc.setFontType('normal');
  doc.text('' + firma.open, 149, 72);
  doc.setFontType('bold');
  doc.text('' + (firma.name2 ? firma.name2 : firma.name), 149, 84);
  doc.setFontType('normal');
  doc.text('' + firma.motto, 149, 88);
  doc.text('' + firma.adresse, 149, 92);
  doc.text(firma.plz + ' ' + firma.stadt, 149, 96);
  doc.text('' + firma.staat, 149, 100);

  if (notaio) {
    //Intestazione Datenblatt
    doc.setFontSize(12);
    doc.setFontType('normal');
    doc.text(notaio.ditta, 15, 38);
    doc.text(notaio.titolo + ' ' + notaio.nome + ' ' + notaio.cognome, 15, 43);
    doc.text(notaio.indirizzo + ' ' + notaio.indirizzo2, 15, 48);
    doc.text(notaio.cap + ' ' + notaio.comune, 15, 53);
  }

  //Data e titolo
  doc.setFontSize(14);
  doc.setFontType('bold');
  doc.text('Datenblatt zur Vorbereitung eines Kaufvertragsentwurfs', 15, 70);

  //Objekt
  var acapo = 90;
  doc.setFontSize(14);
  doc.setFontType('bold');
  doc.text('Objekt', 15, 85);
  doc.setFontSize(12);
  doc.setFontType('normal');
  doc.text('Adresse: ' + oggetto.via + ' ' + oggetto.numeroCivico + ', ' + oggetto.cap + ' ' + oggetto.citta, 15, acapo);
  acapo += 5;
  doc.text((oggetto.tipologia ? oggetto.tipologia === 'Eigentumswohnung' || oggetto.tipologia === 'property_apt' ? 'WE' : 'TE' : 'WE') + ' Nr. ' + oggetto.numeroAppartamento, 15, acapo);

  if (oggetto.m2) {
    acapo += 5;
    doc.text('m2: ' + oggetto.m2, 15, acapo);
  }
  if (oggetto.piano) {
    acapo += 5;
    doc.text('Etage: ' + oggetto.piano, 15, acapo);
  }
  if (oggetto.stato) {
    acapo += 5;
    doc.text('Status: ' + (oggetto.stato === 'vacant' || oggetto.stato === 'leerstehend' ? 'leerstehend' : 'vermietet'), 15, acapo);
  }
  if (oggetto.stato === 'vermietet' || oggetto.stato === 'rented') {
    acapo += 5;
    doc.text('Kaltmiete: ' + (0, _utils.formattaPrezzo)(oggetto.affittoNetto, true), 15, acapo);
  }
  if (oggetto.wohngeld) {
    acapo += 5;
    doc.text('Wohngeld: ' + (0, _utils.formattaPrezzo)(oggetto.wohngeld, true), 15, acapo);
  }
  if (oggetto.ruecklage) {
    acapo += 5;
    doc.text('R\xFCcklage: ' + oggetto.ruecklage, 15, acapo);
  }
  acapo += 5;
  doc.text('Kaufpreis: ' + (0, _utils.formattaPrezzo)(prezzoDiVendita, true), 15, acapo);

  acapo += 5;
  doc.text('Belastungsvollmacht: ' + (belastungsVollmacht ? 'Ja' : 'Nein'), 15, acapo);

  if (oggetto.grundbuch) {
    acapo += 5;
    doc.text('Amtsgericht ' + oggetto.amtsgericht + ', Grundbuch von ' + oggetto.grundbuch + ', Blatt Nr. ' + oggetto.grundbuchBlatt, 15, acapo);
  }
  if (linguaRogito) {
    acapo += 5;
    doc.text('Zus\xE4tzliche Beurkundungssprache: ' + linguaRogito, 15, acapo);
  }

  if (oggetto.note) {
    acapo += 5;
    doc.text('Anmerkung: ' + oggetto.note, 15, acapo);
  }

  if (oggetto.mobilio) {
    acapo += 5;
    doc.text('Einrichtung: siehe Liste', 15, acapo);
  }

  //Verkäufer
  acapo += 10;
  doc.setFontSize(14);
  doc.setFontType('bold');
  doc.text('Verk\xE4ufer', 15, acapo);
  acapo += 5;
  doc.setFontSize(12);
  doc.setFontType('normal');
  doc.text('' + (venditore.ditta && 'Firma: ' + venditore.ditta + ' - ') + (0, _utils.nomeCompleto)(venditore), 15, acapo);
  acapo += 5;
  doc.text((0, _utils.indirizzoCompleto)(venditore), 15, acapo);
  if (venditore.dataDiNascita) {
    acapo += 5;
    doc.text('Geburtsdatum: ' + (0, _utils.formattaData)(venditore.dataDiNascita), 15, acapo);
  }
  acapo += 5;
  doc.text('' + (venditore.telefono1 && 'Tel.: ' + venditore.telefono1 + ' - ') + (venditore.fax && 'Fax: ' + venditore.fax + ' - ') + (venditore.cellulare && 'Handy: ' + venditore.cellulare + ' - ') + (venditore.email && 'E-Mail: ' + venditore.email), 15, acapo);

  if (venditore.bank || venditore.iban || venditore.bic) {
    acapo += 5;
    doc.text((venditore.bank && 'Bank: ' + venditore.bank) + ' ' + (venditore.iban && '- IBAN: ' + venditore.iban) + ' ' + (venditore.bic && '- BIC/SWIFT: ' + venditore.bic) + ' ', 15, acapo);
  }

  if (venditore2) {
    acapo += 10;
    doc.text('' + (venditore2.ditta && 'Firma: ' + venditore2.ditta + ' - ') + (0, _utils.nomeCompleto)(venditore2), 15, acapo);
    acapo += 5;
    doc.text((0, _utils.indirizzoCompleto)(venditore2), 15, acapo);
    if (venditore2.dataDiNascita) {
      acapo += 5;
      doc.text('Geburtsdatum: ' + (0, _utils.formattaData)(venditore2.dataDiNascita), 15, acapo);
    }
    acapo += 5;
    doc.text('' + (venditore2.telefono1 && 'Tel.: ' + venditore2.telefono1 + ' - ') + (venditore2.fax && 'Fax: ' + venditore2.fax + ' - ') + (venditore2.cellulare && 'Handy: ' + venditore2.cellulare + ' - ') + (venditore2.email && 'E-Mail: ' + venditore2.email), 15, acapo);
    if (venditore2.bank || venditore2.iban || venditore2.bic) {
      acapo += 5;
      doc.text((venditore2.bank && 'Bank: ' + venditore2.bank) + ' ' + (venditore2.iban && '- IBAN: ' + venditore2.iban) + ' ' + (venditore2.bic && '- BIC/SWIFT: ' + venditore2.bic) + ' ', 15, acapo);
    }
  }

  //Käufer
  acapo += 10;
  doc.setFontSize(14);
  doc.setFontType('bold');
  doc.text('K\xE4ufer', 15, acapo);
  acapo += 5;
  doc.setFontSize(12);
  doc.setFontType('normal');
  doc.text('' + (acquirente.ditta && 'Firma: ' + acquirente.ditta + ' - ') + (0, _utils.nomeCompleto)(acquirente), 15, acapo);
  acapo += 5;
  doc.text((0, _utils.indirizzoCompleto)(acquirente), 15, acapo);
  if (acquirente.dataDiNascita) {
    acapo += 5;
    doc.text('Geburtsdatum: ' + (0, _utils.formattaData)(acquirente.dataDiNascita), 15, acapo);
  }
  acapo += 5;
  doc.text('' + (acquirente.telefono1 && 'Tel.: ' + acquirente.telefono1 + ' - ') + (acquirente.fax && 'Fax: ' + acquirente.fax + ' - ') + (acquirente.cellulare && 'Handy: ' + acquirente.cellulare + ' - ') + (acquirente.email && 'E-Mail: ' + acquirente.email), 15, acapo);
  if (acquirente2) {
    acapo += 10;
    doc.text('' + (acquirente2.ditta && 'Firma: ' + acquirente2.ditta + ' - ') + (0, _utils.nomeCompleto)(acquirente2), 15, acapo);
    acapo += 5;
    doc.text((0, _utils.indirizzoCompleto)(acquirente2), 15, acapo);
    if (acquirente2.dataDiNascita) {
      acapo += 5;
      doc.text('Geburtsdatum: ' + (0, _utils.formattaData)(acquirente2.dataDiNascita), 15, acapo);
    }
    acapo += 5;
    doc.text('' + (acquirente2.telefono1 && 'Tel.: ' + acquirente2.telefono1 + ' - ') + (acquirente2.fax && 'Fax: ' + acquirente2.fax + ' - ') + (acquirente2.cellulare && 'Handy: ' + acquirente2.cellulare + ' - ') + (acquirente2.email && 'E-Mail: ' + acquirente2.email), 15, acapo);
  }
  console.log(acapo);
  if (acapo > 240) {
    doc.addPage();
    cartaIntestata();
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(10);
    doc.setFontType('normal');
    acapo = 28;
    datiVerwalter();
  } else {
    datiVerwalter();
  }

  if (oggetto.mobilio) {
    doc.addPage();
    cartaIntestata();

    //Titolo per Einrichtungsliste
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(12);
    doc.setFontType('bold');
    doc.text('Einrichtung', 15, 38);
    doc.setFontSize(10);
    doc.setFontType('normal');

    //questa funzione splitta il testo in array di linee di testo. Lo reitero e aggiungo margine dall'alto fino a 260 che è fondo pagina, dopodichè aggiungo pagina e reinizializzo il margine alto
    var lines = doc.splitTextToSize(oggetto.mobilio, 180);
    var y = 45;
    for (var i = 0; i < lines.length; i++) {
      if (y > 260) {
        y = 38;
        doc.addPage();
        cartaIntestata();
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(10);
        doc.setFontType('normal');
      }
      doc.text(15, y, lines[i]);
      y = y + 5;
    }
  }

  doc.save('Notar Danteblatt.pdf');
};

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(4);

var _withForm = __webpack_require__(21);

var _withForm2 = _interopRequireDefault(_withForm);

__webpack_require__(29);

__webpack_require__(30);

__webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserForm = function (_React$Component) {
  _inherits(UserForm, _React$Component);

  function UserForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UserForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserForm.__proto__ || Object.getPrototypeOf(UserForm)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (e) {
      e.preventDefault();

      if (!_this.props.data.users.name || !_this.props.data.users.role) {
        _this.props.renderError(_this.props.t('Inserisci Nome e Ruolo'));
      } else {
        _this.props.renderError('');
        _this.props.onSubmit({
          name: _this.props.data.users.name,
          role: _this.props.data.users.role,
          email: _this.props.data.users.email,
          telefon: _this.props.data.users.telefon,
          qualifica: _this.props.data.users.qualifica,
          firebaseAuthId: _this.props.data.users.firebaseAuthId
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UserForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          renderSelect = _props.renderSelect,
          renderInput = _props.renderInput;

      var roleTypeOptions = ['Admin', 'Mitarbeiter', 'Geschäftsführer'].map(function (roleType) {
        return {
          value: roleType,
          label: roleType
        };
      });
      return _react2.default.createElement(
        'form',
        { className: 'form', onSubmit: this.onSubmit },
        this.props.data.error && _react2.default.createElement(
          'p',
          { className: 'form__error' },
          this.props.data.error
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'button',
            { className: 'btn-floating blue right' },
            _react2.default.createElement(
              'i',
              { className: 'material-icons' },
              'save'
            )
          )
        ),
        renderInput('users', 'name', t('Nome e cognome'), undefined, undefined, undefined, undefined, '*'),
        renderSelect('users', 'role', roleTypeOptions, t('Ruolo'), '*'),
        renderInput('users', 'firebaseAuthId', 'Firebase Auth Id'),
        renderInput('users', 'email', t('email')),
        renderInput('users', 'telefon', t('landline')),
        renderInput('users', 'qualifica', t('Qualifica'))
      );
    }
  }]);

  return UserForm;
}(_react2.default.Component);

exports.default = (0, _reactI18next.withTranslation)()((0, _withForm2.default)(UserForm));

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FirmaForm = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(4);

var _withForm = __webpack_require__(21);

var _withForm2 = _interopRequireDefault(_withForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FirmaForm = exports.FirmaForm = function (_React$Component) {
  _inherits(FirmaForm, _React$Component);

  function FirmaForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FirmaForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FirmaForm.__proto__ || Object.getPrototypeOf(FirmaForm)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (e) {
      e.preventDefault();

      _this.props.onSubmit({
        name: _this.props.data.firma.name,
        name2: _this.props.data.firma.name2,
        adresse: _this.props.data.firma.adresse,
        plz: _this.props.data.firma.plz,
        stadt: _this.props.data.firma.stadt,
        staat: _this.props.data.firma.staat,
        telefon: _this.props.data.firma.telefon,
        fax: _this.props.data.firma.fax,
        email: _this.props.data.firma.email,
        website: _this.props.data.firma.website,
        steuerNr: _this.props.data.firma.steuerNr,
        ustIdNr: _this.props.data.firma.ustIdNr,
        motto: _this.props.data.firma.motto,
        open: _this.props.data.firma.open,
        kontoInhaber: _this.props.data.firma.kontoInhaber,
        bank: _this.props.data.firma.bank,
        iban: _this.props.data.firma.iban,
        bic: _this.props.data.firma.bic,
        ivaApplicata: _this.props.data.firma.ivaApplicata
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FirmaForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          renderInput = _props.renderInput,
          changeHandlerValuta = _props.changeHandlerValuta;

      return _react2.default.createElement(
        'form',
        { className: 'form', onSubmit: this.onSubmit },
        _react2.default.createElement(
          'div',
          { className: 'fixed-action-btn' },
          _react2.default.createElement(
            'button',
            { className: 'btn-floating blue btn-large' },
            _react2.default.createElement(
              'i',
              { className: 'material-icons' },
              'save'
            )
          )
        ),
        renderInput('firma', 'name', t('Nome')),
        renderInput('firma', 'name2', t('Ragione sociale')),
        renderInput('firma', 'adresse', t('Indirizzo')),
        renderInput('firma', 'plz', t('CAP')),
        renderInput('firma', 'stadt', t('Città')),
        renderInput('firma', 'staat', t('Nazione')),
        renderInput('firma', 'telefon', t('Telefono fisso')),
        renderInput('firma', 'fax', 'Fax'),
        renderInput('firma', 'email', t('Email')),
        renderInput('firma', 'website', t('Sito web')),
        renderInput('firma', 'steuerNr', t('Codice fiscale tedesco')),
        renderInput('firma', 'ustIdNr', 'Ust.-IdNr.'),
        renderInput('firma', 'motto', 'Motto'),
        renderInput('firma', 'open', t('Orari di apertura')),
        renderInput('firma', 'kontoInhaber', t('Intestatario conto corrente')),
        renderInput('firma', 'bank', t('Banca')),
        renderInput('firma', 'iban', 'IBAN'),
        renderInput('firma', 'bic', 'BIC/SWIFT'),
        renderInput('firma', 'ivaApplicata', t('vat_applied'), undefined, changeHandlerValuta, undefined, undefined, '%')
      );
    }
  }]);

  return FirmaForm;
}(_react2.default.Component);

exports.default = (0, _reactI18next.withTranslation)()((0, _withForm2.default)(FirmaForm));

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomerForm = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _withForm = __webpack_require__(21);

var _withForm2 = _interopRequireDefault(_withForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CustomerForm = exports.CustomerForm = function (_React$Component) {
  _inherits(CustomerForm, _React$Component);

  function CustomerForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CustomerForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CustomerForm.__proto__ || Object.getPrototypeOf(CustomerForm)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (e) {
      e.preventDefault();

      var clienti = _this.props.data.clienti;


      if (!clienti.cognome && !clienti.ditta) {
        _this.props.renderError(_this.props.t('form_alert_missing_name'));
      } else {
        _this.props.renderError('');
        _this.props.onSubmit({
          cloudURL: clienti.cloudURL,
          nome: clienti.nome,
          cognome: clienti.cognome,
          titolo: clienti.titolo,
          dataDiNascita: clienti.dataDiNascita ? clienti.dataDiNascita.valueOf() : null,
          ditta: clienti.ditta,
          indirizzo: clienti.indirizzo,
          indirizzo2: clienti.indirizzo2,
          cap: clienti.cap,
          comune: clienti.comune,
          nazione: clienti.nazione,
          lingua: clienti.lingua,
          email: clienti.email,
          consulenteVenditaId: clienti.consulenteVenditaId,
          telefono1: clienti.telefono1,
          fax: clienti.fax,
          cellulare: clienti.cellulare,
          codiceFiscale: clienti.codiceFiscale,
          handelsRegisterNummer: clienti.handelsRegisterNummer,
          bank: clienti.bank,
          iban: clienti.iban,
          bic: clienti.bic,
          visible: clienti.visible,
          www: clienti.www,
          note: clienti.note,
          dataRegistrazione: clienti.dataRegistrazione ? clienti.dataRegistrazione.valueOf() : null,
          dataConsensoDSGVO: clienti.dataConsensoDSGVO ? clienti.dataConsensoDSGVO.valueOf() : null,
          consensoDSGVO: clienti.consensoDSGVO
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CustomerForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          renderCheckbox = _props.renderCheckbox,
          renderInput = _props.renderInput,
          renderSelect = _props.renderSelect,
          renderSingleDate = _props.renderSingleDate,
          renderTextArea = _props.renderTextArea,
          changeHandlerValidate = _props.changeHandlerValidate,
          clienti = _props.clienti,
          renderModal = _props.renderModal;

      var consulenteVenditaOptions = this.props.utenti.map(function (consulente) {
        return {
          value: consulente.id,
          label: consulente.name
        };
      });

      return _react2.default.createElement(
        'div',
        null,
        this.props.data.error && _react2.default.createElement(
          'div',
          { className: 'form__error' },
          t(this.props.data.error),
          this.props.data.error === 'customer_already_registered' && renderModal(t('btn_label_verify'))
        ),
        _react2.default.createElement(
          'form',
          { className: 'form', onSubmit: this.onSubmit },
          _react2.default.createElement(
            'div',
            { className: 'fixed-action-btn' },
            _react2.default.createElement(
              'button',
              { className: 'btn-floating blue btn-large' },
              _react2.default.createElement(
                'i',
                { className: 'material-icons' },
                'save'
              )
            )
          ),
          renderSingleDate('clienti', 'dataRegistrazione', 'calendarDataRegistrazioneFocused', t('customer_registration_date')),
          renderSelect('clienti', 'consulenteVenditaId', consulenteVenditaOptions, t('sales_rep_name')),
          renderSelect('clienti', 'titolo', [{ value: 'Herr', label: 'Herr' }, { value: 'Frau', label: 'Frau' }, { value: 'Herr Dr.', label: 'Herr Dr.' }, { value: 'Frau Dr.', label: 'Frau Dr.' }], t('customer_title')),
          renderInput('clienti', 'nome', t('firstname')),
          renderInput('clienti', 'cognome', t('lastname'), 'text', changeHandlerValidate, clienti, undefined, '*'),
          renderInput('clienti', 'email', t('email'), 'text', changeHandlerValidate, clienti),
          renderInput('clienti', 'telefono1', t('landline')),
          renderInput('clienti', 'fax', t('fax')),
          renderInput('clienti', 'cellulare', t('mobile')),
          renderInput('clienti', 'www', t('website')),
          renderSingleDate('clienti', 'dataDiNascita', 'calendarFocused', t('birthdate')),
          renderInput('clienti', 'codiceFiscale', t('taxpayer_number')),
          renderInput('clienti', 'ditta', t('company')),
          renderInput('clienti', 'handelsRegisterNummer', t('company_register_number')),
          renderInput('clienti', 'indirizzo', t('address')),
          renderInput('clienti', 'indirizzo2', t('address_extention')),
          renderInput('clienti', 'cap', t('zipcode')),
          renderInput('clienti', 'comune', t('city')),
          renderInput('clienti', 'nazione', t('nation')),
          renderInput('clienti', 'lingua', t('language')),
          renderInput('clienti', 'bank', t('bank')),
          renderInput('clienti', 'iban', 'IBAN'),
          renderInput('clienti', 'bic', 'BIC/SWIFT'),
          renderInput('clienti', 'cloudURL', 'Cloud URL', undefined, undefined, undefined, 'https://www...'),
          renderTextArea('clienti', 'note', 'Note'),
          this.props.utente.role === 'Admin' ? renderCheckbox('clienti', 'visible', t('visible')) : '',
          renderCheckbox('clienti', 'consensoDSGVO', t('gdpr_consent')),
          renderSingleDate('clienti', 'dataConsensoDSGVO', 'calendarDataConsensoDSGVOFocused', t('gdpr_consent_date')),
          this.props.data.error && _react2.default.createElement(
            'p',
            { className: 'form__error' },
            this.props.data.error
          )
        )
      );
    }
  }]);

  return CustomerForm;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    utenti: state.utenti,
    clienti: state.clienti,
    utente: state.utenti.find(function (utente) {
      return utente.firebaseAuthId === state.auth.uid;
    })
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()((0, _withForm2.default)(CustomerForm)));

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FatturaForm = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _withForm = __webpack_require__(21);

var _withForm2 = _interopRequireDefault(_withForm);

__webpack_require__(29);

__webpack_require__(30);

__webpack_require__(31);

var _materializeCss = __webpack_require__(61);

var _materializeCss2 = _interopRequireDefault(_materializeCss);

var _utils = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FatturaForm = exports.FatturaForm = function (_React$Component) {
  _inherits(FatturaForm, _React$Component);

  function FatturaForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FatturaForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FatturaForm.__proto__ || Object.getPrototypeOf(FatturaForm)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (e) {
      e.preventDefault();

      var fatture = _this.props.data.fatture;


      var deal = _this.props.deals.find(function (deal) {
        return deal.id === fatture.dealId;
      });
      var importoNetto = (0, _utils.trasformaInNumero)(fatture.importoNetto) || deal && deal.amount / 2 || '0';
      var mahngebuehren = (0, _utils.trasformaInNumero)(fatture.mahngebuehren);
      var mahngebuehren2 = (0, _utils.trasformaInNumero)(fatture.mahngebuehren2);

      if (!fatture.numeroFattura || !fatture.dataFattura || !fatture.clienteId || !fatture.dealId && !fatture.descrizioneProdotto) {
        _this.props.renderError(_this.props.t('invoice_form_submission_error'));
      } else {
        _this.props.renderError('');
        _this.props.onSubmit({
          dealId: fatture.dealId,
          clienteId: fatture.clienteId,
          clienteId2: fatture.clienteId2,
          numeroFattura: fatture.numeroFattura,
          dataFattura: fatture.dataFattura ? fatture.dataFattura.valueOf() : null,
          dataZahlungserinnerung: fatture.dataZahlungserinnerung ? fatture.dataZahlungserinnerung.valueOf() : null,
          dataMahnung: fatture.dataMahnung ? fatture.dataMahnung.valueOf() : null,
          dataMahnung2: fatture.dataMahnung2 ? fatture.dataMahnung2.valueOf() : null,
          mahngebuehren: mahngebuehren,
          mahngebuehren2: mahngebuehren2,
          payed: fatture.payed,
          payedAt: fatture.payedAt ? fatture.payedAt.valueOf() : null,
          descrizioneProdotto: fatture.descrizioneProdotto,
          importoNetto: importoNetto,
          dataPrestazione: fatture.dataPrestazione ? fatture.dataPrestazione.valueOf() : null
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FatturaForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      _materializeCss2.default.AutoInit();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          renderSelect = _props.renderSelect,
          renderCheckbox = _props.renderCheckbox,
          renderInput = _props.renderInput,
          renderSingleDate = _props.renderSingleDate,
          changeHandlerValuta = _props.changeHandlerValuta;
      var fatture = this.props.data.fatture;


      var options = this.props.clienti.map(function (cliente) {
        return {
          value: cliente.id,
          label: cliente.nome + ' ' + cliente.cognome + ' ' + (cliente.ditta && '- Firma ' + cliente.ditta)
        };
      });

      var dealIdOptions = this.props.deals.map(function (deal) {
        var oggetto = _this2.props.oggetti.find(function (ogg) {
          return ogg.id === deal.oggettoId;
        });
        return {
          value: deal.id,
          label: oggetto.rifId + ' - ' + (0, _utils.indirizzoOggetto)(oggetto)
        };
      });

      return _react2.default.createElement(
        'form',
        { className: 'form', onSubmit: this.onSubmit },
        this.props.data.error && _react2.default.createElement(
          'p',
          { className: 'form__error' },
          this.props.data.error
        ),
        ' ',
        _react2.default.createElement(
          'div',
          { className: 'fixed-action-btn' },
          _react2.default.createElement(
            'button',
            { className: 'btn-floating blue btn-large' },
            _react2.default.createElement(
              'i',
              { className: 'material-icons' },
              'save'
            )
          )
        ),
        renderSelect('fatture', 'dealId', dealIdOptions, t('Vendita')),
        renderSelect('fatture', 'clienteId', options, t('Cliente'), '*'),
        renderSelect('fatture', 'clienteId2', options, '2. ' + t('Cliente')),
        renderInput('fatture', 'numeroFattura', t('Numero fattura'), undefined, undefined, undefined, undefined, '*'),
        renderInput('fatture', 'importoNetto', t('Importo netto'), undefined, changeHandlerValuta),
        renderSingleDate('fatture', 'dataFattura', 'calendarDataFatturaFocused', t('Data fattura'), '*'),
        renderSingleDate('fatture', 'dataZahlungserinnerung', 'calendarDataZahlungserinnerungFocused', t('Data sollecito')),
        renderSingleDate('fatture', 'dataMahnung', 'calendarDataMahnungFocused', '1. ' + t('Sollecito con penale')),
        renderInput('fatture', 'mahngebuehren', '1. ' + t('Penale'), undefined, changeHandlerValuta),
        renderSingleDate('fatture', 'dataMahnung2', 'calendarDataMahnung2Focused', '2. ' + t('Sollecito con penale')),
        renderInput('fatture', 'mahngebuehren2', '2. ' + t('Penale'), undefined, changeHandlerValuta),
        renderCheckbox('fatture', 'payed', t('Pagato')),
        _react2.default.createElement(
          'div',
          { className: 'visible-' + fatture.payed + ' form' },
          renderSingleDate('fatture', 'payedAt', 'calendarPayedAtFocused', t('Pagato il'))
        ),
        _react2.default.createElement(
          'blockquote',
          null,
          t('Usare questi campi solo se non si è associata una vendita!'),
          ' ',
          renderInput('fatture', 'descrizioneProdotto', t('Descrizione prodotto')),
          renderSingleDate('fatture', 'dataPrestazione', 'calendarDataPrestazioneFocused', t('Data prestazione'))
        )
      );
    }
  }]);

  return FatturaForm;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    deals: state.deals,
    clienti: state.clienti,
    oggetti: state.oggetti
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()((0, _withForm2.default)(FatturaForm)));

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EvaluationList = undefined;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _Card = __webpack_require__(56);

var _Card2 = _interopRequireDefault(_Card);

var _deals = __webpack_require__(85);

var _deals2 = _interopRequireDefault(_deals);

var _utils = __webpack_require__(9);

var _elements = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EvaluationList = exports.EvaluationList = function EvaluationList(_ref) {
  var oggettoEvaluation = _ref.oggettoEvaluation,
      evaluations = _ref.evaluations,
      ruolo = _ref.ruolo,
      oggetti = _ref.oggetti,
      t = _ref.t;

  var evaluationsPayload = oggettoEvaluation || evaluations;

  return _react2.default.createElement(
    'div',
    { className: 'container' },
    evaluationsPayload.length > 0 && _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'h5',
        null,
        ruolo || ''
      ),
      evaluationsPayload.sort(function (a, b) {
        return a.dataEvaluation > b.dataEvaluation ? -1 : 1;
      }).map(function (evaluation) {
        var dataEvaluation = (0, _utils.formattaData)(evaluation.dataEvaluation);
        var oggetto = oggetti.find(function (oggetto) {
          return oggetto.id === evaluation.oggettoId;
        });

        return _react2.default.createElement(_Card2.default, {
          key: evaluation.id,
          visible: evaluation.visible,
          link: '/evaluationview/' + evaluation.id,
          titolo: evaluation.oggettoId ? 'Rif.Id: ' + oggetto.rifId + ' - ' + oggetto.via + ' ' + oggetto.numeroCivico + ', WE ' + oggetto.numeroAppartamento + ', ' + oggetto.cap + ' ' + oggetto.citta : evaluation.titolo,
          sottotitolo: evaluation.result ? (0, _utils.formattaPrezzo)(evaluation.result, true) + '/m2 (Tot.: ' + (0, _utils.formattaPrezzo)(evaluation.result * evaluation.m2 / 100, true) + ')' : '',
          titoloDestra: _react2.default.createElement(
            'div',
            { className: 'foto-container' },
            oggetto && oggetto.downloadURLsCover && _react2.default.createElement('img', {
              className: 'foto',
              src: oggetto.downloadURLsCover[0] || ''
            }),
            (0, _elements.folderButton)(evaluation, oggetto && oggetto.downloadURLsCover && true, 'Valutazioni', oggetto ? oggetto.via.split(' ')[0] : evaluation.titolo.split(' ')[0], oggetto && oggetto.downloadURLsCover)
          ),
          corpo: [dataEvaluation]
        });
      })
    )
  );
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    evaluations: (0, _deals2.default)('evaluations', state.evaluations, state.filters, undefined, state.oggetti),
    oggetti: state.oggetti
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()(EvaluationList));

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactGeocode = __webpack_require__(1121);

var _reactGeocode2 = _interopRequireDefault(_reactGeocode);

var _reactI18next = __webpack_require__(4);

var _configureStore = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Map = function (_Component) {
  _inherits(Map, _Component);

  function Map(props) {
    _classCallCheck(this, Map);

    var _this = _possibleConstructorReturn(this, (Map.__proto__ || Object.getPrototypeOf(Map)).call(this, props));

    _this.state = {
      stores: [{ latitude: '', longitude: '' }],
      indirizzo: _this.props.indirizzo || _this.props.oggetto.via + '+' + _this.props.oggetto.numeroCivico + ',+' + _this.props.oggetto.cap + '+' + _this.props.oggetto.citta
    };
    return _this;
  }

  _createClass(Map, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      _reactGeocode2.default.setApiKey('AIzaSyBlElUhBRSKAy_GooSEN7uZaA1dLtjzfzE');
      _reactGeocode2.default.setLanguage('de');
      _reactGeocode2.default.setRegion('de');
      _reactGeocode2.default.enableDebug();

      _reactGeocode2.default.fromAddress(this.state.indirizzo).then(function (response) {
        var _response$results$0$g = response.results[0].geometry.location,
            lat = _response$results$0$g.lat,
            lng = _response$results$0$g.lng;

        _this2.setState(function (prevState) {
          return prevState.stores[0].latitude = lat, prevState.stores[0].longitude = lng;
        });
        // se vengo da view oggetti, passo le coordinata allo store per inviarle a WP
        if (_this2.props.oggetto) {
          _this2.props.startEditOggetto(_this2.props.oggetto.id, _extends({}, _this2.props.oggetto, {
            latitude: lat,
            longitude: lng
          }));
        }
      }, function (error) {
        console.error(error);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;
      var _state = this.state,
          indirizzo = _state.indirizzo,
          stores = _state.stores;


      return _react2.default.createElement(
        'div',
        { className: 'container' },
        _react2.default.createElement(
          'div',
          { className: 'grey lighten-4' },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h1',
              null,
              t('Mappa')
            )
          )
        ),
        _react2.default.createElement(
          'a',
          {
            href: 'https://www.google.de/maps/place/' + indirizzo + '/',
            target: '_blank'
          },
          _react2.default.createElement('img', {
            src: 'https://maps.googleapis.com/maps/api/staticmap?center=' + indirizzo + '&zoom=15&size=400x400&maptype=roadmap\n  &markers=color:blue%7Clabel:A%7C' + stores[0].latitude + ',' + stores[0].longitude + '\n  &key=AIzaSyBlElUhBRSKAy_GooSEN7uZaA1dLtjzfzE'
          })
        )
      );
    }
  }]);

  return Map;
}(_react.Component);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    startEditOggetto: function startEditOggetto(id, oggetto) {
      return dispatch(_configureStore.storeActions.find(function (action) {
        return action.label === 'oggetti';
      }).startEditAction(id, oggetto));
    }
  };
};

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)((0, _reactI18next.withTranslation)()(Map));

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OggettoForm = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _withForm = __webpack_require__(21);

var _withForm2 = _interopRequireDefault(_withForm);

__webpack_require__(29);

__webpack_require__(30);

__webpack_require__(31);

var _materializeCss = __webpack_require__(61);

var _materializeCss2 = _interopRequireDefault(_materializeCss);

var _utils = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OggettoForm = exports.OggettoForm = function (_React$Component) {
  _inherits(OggettoForm, _React$Component);

  function OggettoForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OggettoForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OggettoForm.__proto__ || Object.getPrototypeOf(OggettoForm)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (e) {
      e.preventDefault();

      var oggetti = _this.props.data.oggetti;


      var wohngeld = (0, _utils.trasformaInNumero)(oggetti.wohngeld);
      var affittoNetto = (0, _utils.trasformaInNumero)(oggetti.affittoNetto);
      var kaufpreis = (0, _utils.trasformaInNumero)(oggetti.kaufpreis);
      var provvigione = (0, _utils.trasformaInNumero)(oggetti.provvigione);

      if (!oggetti.via || !oggetti.rifId) {
        _this.props.renderError(_this.props.t('property_form_submit_error'));
      } else {
        _this.props.renderError('');

        _this.props.onSubmit({
          affittoNetto: affittoNetto,
          amtsgericht: oggetti.amtsgericht,
          ascensore: oggetti.ascensore,
          bagni: oggetti.bagni,
          balcone: oggetti.balcone,
          baujahr: oggetti.baujahr,
          cap: oggetti.cap,
          citta: oggetti.citta,
          cantina: oggetti.cantina,
          condizioni: oggetti.condizioni,
          cloudURL: oggetti.cloudURL,
          dataInserimentoOggetto: oggetti.dataInserimentoOggetto ? oggetti.dataInserimentoOggetto.valueOf() : null,
          dataModificaOggetto: oggetti.dataModificaOggetto ? oggetti.dataModificaOggetto.valueOf() : null,
          descrizione: oggetti.descrizione,
          descrizioneDe: oggetti.descrizioneDe,
          descrizioneEn: oggetti.descrizioneEn,
          downloadURLs: oggetti.downloadURLs || [],
          downloadURLsId: oggetti.downloadURLsId || [],
          downloadURLsCover: oggetti.downloadURLsCover || [],
          downloadURLsCoverId: oggetti.downloadURLsCoverId || [],
          downloadURLsGrundriss: oggetti.downloadURLsGrundriss || [],
          downloadURLsGrundrissId: oggetti.downloadURLsGrundrissId || [],
          energieAusweisTyp: oggetti.energieAusweisTyp,
          energieAusweisBis: oggetti.energieAusweisBis,
          energieBedarf: oggetti.energieBedarf,
          energieTraeger: oggetti.energieTraeger,
          featuredProperty: oggetti.featuredProperty,
          filenames: oggetti.filenames,
          filenamesCover: oggetti.filenamesCover,
          filenamesGrundriss: oggetti.filenamesGrundriss,
          giardino: oggetti.giardino,
          grundbuch: oggetti.grundbuch,
          grundbuchBlatt: oggetti.grundbuchBlatt,
          heizungsart: oggetti.heizungsart,
          inquilinoId: oggetti.inquilinoId,
          kaufpreis: kaufpreis,
          m2: oggetti.m2,
          mobilio: oggetti.mobilio,
          nazione: oggetti.nazione,
          note: oggetti.note,
          numeroCivico: oggetti.numeroCivico,
          numeroAppartamento: oggetti.numeroAppartamento,
          piano: oggetti.piano,
          prenotato: oggetti.prenotato,
          proprietarioId: oggetti.proprietarioId,
          proprietarioId2: oggetti.proprietarioId2,
          provvigione: provvigione,
          quartiere: oggetti.quartiere,
          rifId: oggetti.rifId,
          ruecklage: oggetti.ruecklage,
          stato: oggetti.stato,
          status: oggetti.status,
          // themeSlider: oggetti.themeSlider,
          tipologia: oggetti.tipologia,
          titolo: oggetti.titolo,
          titoloEn: oggetti.titoloEn,
          titoloDe: oggetti.titoloDe,
          vani: oggetti.vani,
          verwalter: oggetti.verwalter,
          venduto: oggetti.venduto,
          via: oggetti.via,
          videoId: oggetti.videoId,
          visible: oggetti.visible,
          wohngeld: wohngeld
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OggettoForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      _materializeCss2.default.AutoInit();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          renderTextArea = _props.renderTextArea,
          renderCheckbox = _props.renderCheckbox,
          renderSelect = _props.renderSelect,
          renderInput = _props.renderInput,
          renderUploadImage = _props.renderUploadImage,
          changeHandlerValuta = _props.changeHandlerValuta;


      var options = this.props.clienti.map(function (cliente) {
        return {
          value: cliente.id,
          label: cliente.nome + ' ' + cliente.cognome + ' ' + (cliente.ditta && '- ' + t('company') + ' ' + cliente.ditta)
        };
      });

      var optionsQuartiere = ['Charlottenburg', 'Friedrichshain', 'Hohenschonhausen', 'Kreuzberg', 'Lichtenberg', 'Lichtenrade', 'Mitte', 'Moabit', 'Neukölln', 'Pankow', 'Prenzlauer Berg', 'Reinickendorf', 'Schöneberg', 'Spandau', 'Steglitz', 'Tegel', 'Tempelhof', 'Tiergarten', 'Treptow-Köpenick', 'Wedding', 'Weißensee', 'Wilmersdorf', 'Zehlendorf'].map(function (quartiere) {
        return {
          value: quartiere,
          label: quartiere
        };
      });

      var optionsTipologia = ['property_apt', 'property_commercial', 'property_nursing_home', 'property_other'].map(function (dealType) {
        return {
          value: dealType,
          label: t(dealType)
        };
      });
      return _react2.default.createElement(
        'form',
        { className: 'form', onSubmit: this.onSubmit },
        this.props.data.error && _react2.default.createElement(
          'p',
          { className: 'form__error' },
          this.props.data.error
        ),
        ' ',
        _react2.default.createElement(
          'div',
          { className: 'fixed-action-btn' },
          _react2.default.createElement(
            'button',
            { className: 'btn-floating blue btn-large' },
            _react2.default.createElement(
              'i',
              { className: 'material-icons' },
              'save'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col s12' },
            _react2.default.createElement(
              'ul',
              {
                ref: function ref(Tabs) {
                  _this2.Tabs = Tabs;
                },
                className: 'tabs'
              },
              _react2.default.createElement(
                'li',
                { className: 'tab col s4' },
                _react2.default.createElement(
                  'a',
                  { className: 'active', href: '#test1' },
                  t('Dati principali')
                )
              ),
              _react2.default.createElement(
                'li',
                { className: 'tab col s4' },
                _react2.default.createElement(
                  'a',
                  { href: '#test2' },
                  'Expos\xE9'
                )
              ),
              _react2.default.createElement(
                'li',
                { className: 'tab col s4' },
                _react2.default.createElement(
                  'a',
                  { href: '#test3' },
                  t('Immagini')
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { id: 'test1', className: 'col s12' },
            _react2.default.createElement(
              'div',
              { label: 'Eckdaten' },
              renderInput('oggetti', 'rifId', t('Rif') + '. ID', undefined, undefined, undefined, undefined, '*'),
              renderSelect('oggetti', 'tipologia', optionsTipologia, t('Tipo di immobile')),
              renderInput('oggetti', 'via', t('address'), undefined, undefined, undefined, undefined, '*'),
              renderInput('oggetti', 'numeroCivico', 'Nr.'),
              renderInput('oggetti', 'cap', t('zipcode')),
              renderSelect('oggetti', 'quartiere', optionsQuartiere, t('Quartiere')),
              renderSelect('oggetti', 'citta', [{ value: 'Berlin', label: 'Berlin' }, { value: 'Leipzig', label: 'Leipzig' }], t('city')),
              renderInput('oggetti', 'nazione', t('nation')),
              renderInput('oggetti', 'numeroAppartamento', t('Numero appartamento')),
              renderInput('oggetti', 'amtsgericht', t('Pretura (Amtsgericht)')),
              renderInput('oggetti', 'grundbuch', t('Libro Fondiario (Grundbuch)')),
              renderInput('oggetti', 'grundbuchBlatt', t('Foglio')),
              renderInput('oggetti', 'm2', 'M2'),
              renderInput('oggetti', 'piano', t('Piano')),
              renderTextArea('oggetti', 'mobilio', t('Mobili e valore')),
              renderSelect('oggetti', 'stato', [{ value: 'vacant', label: t('vacant') }, { value: 'rented', label: t('rented') }], t('Stato abitativo')),
              renderInput('oggetti', 'wohngeld', t('Quota condominiale'), 'text', changeHandlerValuta),
              renderInput('oggetti', 'ruecklage', t('Fondo di accantonamento per manutenzione'), undefined, undefined, undefined, 'Gesamt oder anteilig?'),
              renderInput('oggetti', 'affittoNetto', t('Affitto netto'), 'text', changeHandlerValuta),
              renderInput('oggetti', 'kaufpreis', t('Prezzo di vendita'), 'text', changeHandlerValuta),
              renderSelect('oggetti', 'verwalter', options, t('Amministratore di condominio')),
              renderSelect('oggetti', 'proprietarioId', options, t('Proprietario')),
              renderSelect('oggetti', 'proprietarioId2', options, '2. ' + t('Proprietario')),
              renderSelect('oggetti', 'inquilinoId', options, t('Inquilino')),
              renderInput('oggetti', 'cloudURL', 'Cloud URL', undefined, undefined, undefined, 'http://www...'),
              renderInput('oggetti', 'videoId', 'YouTube Video ID'),
              renderTextArea('oggetti', 'note'),
              renderCheckbox('oggetti', 'status', t('property_status')),
              renderCheckbox('oggetti', 'venduto', t('Venduto')),
              renderCheckbox('oggetti', 'prenotato', t('reserved')),
              renderCheckbox('oggetti', 'featuredProperty', t('featured_property')),
              this.props.utente && this.props.utente.role === 'Admin' ? renderCheckbox('oggetti', 'visible', t('visible')) : ''
            )
          ),
          _react2.default.createElement(
            'div',
            { id: 'test2', className: 'col s12' },
            _react2.default.createElement(
              'div',
              { label: 'Expos\xE9' },
              renderInput('oggetti', 'titolo', t('Titolo principale') + ' ' + t('italiano'), undefined, undefined, undefined, 'Titolo in italiano'),
              renderTextArea('oggetti', 'descrizione', t('Descrizione') + ' ' + t('italiano')),
              renderInput('oggetti', 'titoloDe', t('Titolo principale') + ' ' + t('tedesco'), undefined, undefined, undefined, 'Überschrift des Exposés'),
              renderTextArea('oggetti', 'descrizioneDe', t('Descrizione') + ' ' + t('tedesco')),
              renderInput('oggetti', 'titoloEn', t('Titolo principale') + ' ' + t('inglese'), undefined, undefined, undefined, 'English title'),
              renderTextArea('oggetti', 'descrizioneEn', t('Descrizione') + ' ' + t('inglese')),
              renderInput('oggetti', 'vani', t('Vani')),
              renderInput('oggetti', 'bagni', t('Bagni')),
              renderSelect('oggetti', 'condizioni', [{ value: 'new', label: t('new') }, { value: 'refurbished', label: t('refurbished') }, { value: 'fully_renovated', label: t('fully_renovated') }, { value: 'modernized', label: t('modernized') }, { value: 'good', label: t('good') }, {
                value: 'to_renovate',
                label: t('to_renovate')
              }], t('property_condition')),
              renderInput('oggetti', 'baujahr', t('Anno di costruzione')),
              renderSelect('oggetti', 'energieAusweisTyp', [{
                value: 'based_on_consumption',
                label: t('based_on_consumption')
              }, {
                value: 'based_on_requirement',
                label: t('based_on_requirement')
              }], t('Certificato energetico - tipologia')),
              renderInput('oggetti', 'energieAusweisBis', t('Certificato energetico - valido fino al')),
              renderSelect('oggetti', 'heizungsart', [{
                value: 'heating_central',
                label: t('heating_central')
              }, {
                value: 'heating_floor',
                label: t('heating_floor')
              }], t('Tipologia riscaldamento')),
              renderSelect('oggetti', 'energieTraeger', [{
                value: 'heating_gas',
                label: t('heating_gas')
              }, {
                value: 'heating_oil',
                label: t('heating_oil')
              }, {
                value: 'heating_district',
                label: t('heating_district')
              }], t('Fonte energetica')),
              renderInput('oggetti', 'energieBedarf', t('energy_consumption_kwh')),
              renderInput('oggetti', 'provvigione', t('Provvigione'), 'text', changeHandlerValuta, undefined, t('IVA inclusa')),
              renderCheckbox('oggetti', 'balcone', t('Balcone')),
              renderCheckbox('oggetti', 'ascensore', t('Ascensore')),
              renderCheckbox('oggetti', 'giardino', t('Giardino')),
              renderCheckbox('oggetti', 'cantina', t('Cantina'))
            )
          ),
          _react2.default.createElement(
            'div',
            { id: 'test3', className: 'col s12' },
            _react2.default.createElement(
              'ul',
              { className: 'collection' },
              renderUploadImage('oggetti', 'downloadURLsCover', 'Cover'),
              renderUploadImage('oggetti', 'downloadURLs', t('images')),
              renderUploadImage('oggetti', 'downloadURLsGrundriss', t('floor_plan'))
            )
          )
        )
      );
    }
  }]);

  return OggettoForm;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    clienti: state.clienti,
    utente: state.utenti.find(function (utente) {
      return utente.firebaseAuthId === state.auth.uid;
    })
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()((0, _withForm2.default)(OggettoForm)));

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LeadForm = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _withForm = __webpack_require__(21);

var _withForm2 = _interopRequireDefault(_withForm);

__webpack_require__(29);

__webpack_require__(30);

__webpack_require__(31);

var _materializeCss = __webpack_require__(61);

var _materializeCss2 = _interopRequireDefault(_materializeCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeadForm = exports.LeadForm = function (_React$Component) {
  _inherits(LeadForm, _React$Component);

  function LeadForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LeadForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LeadForm.__proto__ || Object.getPrototypeOf(LeadForm)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (e) {
      e.preventDefault();
      var leads = _this.props.data.leads;

      var leadBudget = parseFloat(leads.leadBudget, 10) * 100;

      if (!leads.leadId || leads.leadBudget < 1) {
        _this.props.renderError(_this.props.t('Inserisci il budget'));
      } else {
        _this.props.renderError('');
        _this.props.onSubmit({
          leadCreatedAt: leads.leadCreatedAt ? leads.leadCreatedAt.valueOf() : null,
          leadId: leads.leadId,
          leadBudget: leadBudget,
          leadCity: leads.leadCity,
          leadOggettoStato: leads.leadOggettoStato,
          leadNote: leads.leadNote
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LeadForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      _materializeCss2.default.AutoInit();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          renderSelect = _props.renderSelect,
          renderInput = _props.renderInput,
          renderSingleDate = _props.renderSingleDate,
          renderTextArea = _props.renderTextArea,
          changeHandlerValuta = _props.changeHandlerValuta;

      var options = this.props.clienti.map(function (cliente) {
        return {
          value: cliente.id,
          label: cliente.nome + ' ' + cliente.cognome + ' ' + (cliente.ditta && '- Firma ' + cliente.ditta)
        };
      });

      return _react2.default.createElement(
        'form',
        { className: 'form', onSubmit: this.onSubmit },
        this.props.data.error && _react2.default.createElement(
          'p',
          { className: 'form__error' },
          this.props.data.error
        ),
        _react2.default.createElement(
          'div',
          { className: 'fixed-action-btn' },
          _react2.default.createElement(
            'button',
            { className: 'btn-floating blue btn-large' },
            _react2.default.createElement(
              'i',
              { className: 'material-icons' },
              'save'
            )
          )
        ),
        renderSingleDate('leads', 'leadCreatedAt', 'calendarFocused', t('Data richiesta')),
        renderSelect('leads', 'leadId', options, t('Cliente'), '*'),
        renderInput('leads', 'leadBudget', 'Budget', 'text', changeHandlerValuta, undefined, undefined, '*'),
        renderSelect('leads', 'leadOggettoStato', [{ value: 'libero', label: t('Appartamento libero') }, { value: 'affittato', label: t('Appartamento affittato') }, {
          value: 'libero o affittato',
          label: t('Appartamento libero o affittato')
        }, { value: 'commerciale', label: t('Locale commerciale') }, { value: 'aph', label: t('Casa di cura') }, { value: '', label: t('Indifferente') }], t('Tipologia immobile e stato')),
        renderSelect('leads', 'leadCity', [{ value: 'Berlin', label: 'Berlin' }, { value: 'Leipzig', label: 'Leipzig' }], t('city')),
        renderTextArea('leads', 'leadNote')
      );
    }
  }]);

  return LeadForm;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    utenti: state.utenti,
    clienti: state.clienti
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()((0, _withForm2.default)(LeadForm)));

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OfferedPropertiesForm = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _withForm = __webpack_require__(21);

var _withForm2 = _interopRequireDefault(_withForm);

__webpack_require__(29);

__webpack_require__(30);

__webpack_require__(31);

var _materializeCss = __webpack_require__(61);

var _materializeCss2 = _interopRequireDefault(_materializeCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OfferedPropertiesForm = exports.OfferedPropertiesForm = function (_React$Component) {
  _inherits(OfferedPropertiesForm, _React$Component);

  function OfferedPropertiesForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OfferedPropertiesForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OfferedPropertiesForm.__proto__ || Object.getPrototypeOf(OfferedPropertiesForm)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (e) {
      e.preventDefault();

      if (!_this.props.data.offers.oggettoId) {
        _this.props.renderError(_this.props.t('Inserisci un immobile da proporre al cliente'));
      } else {
        _this.props.renderError('');
        _this.props.onSubmit({
          offerCreatedAt: _this.props.data.offers.offerCreatedAt ? _this.props.data.offers.offerCreatedAt.valueOf() : null,
          oggettoId: _this.props.data.offers.oggettoId,
          leadId: _this.props.data.offers.leadId,
          offertoTramite: _this.props.data.offers.offertoTramite,
          consulenteId: _this.props.data.offers.consulenteId,
          feedback: _this.props.data.offers.feedback,
          offerNote: _this.props.data.offers.offerNote
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OfferedPropertiesForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      _materializeCss2.default.AutoInit();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          renderSelect = _props.renderSelect,
          renderSingleDate = _props.renderSingleDate,
          renderTextArea = _props.renderTextArea;


      var oggettiOptions = this.props.oggetti.map(function (oggetto) {
        return {
          value: oggetto.id,
          label: 'Rif.Id: ' + oggetto.rifId + ' - ' + oggetto.via + ' ' + oggetto.numeroCivico + ', WE ' + oggetto.numeroAppartamento + ', ' + oggetto.cap + ' ' + oggetto.citta
        };
      });

      var consulenteVenditaOptions = this.props.utenti.map(function (consulente) {
        return {
          value: consulente.id,
          label: consulente.name
        };
      });

      return _react2.default.createElement(
        'form',
        { className: 'form', onSubmit: this.onSubmit },
        this.props.data.error && _react2.default.createElement(
          'p',
          { className: 'form__error' },
          this.props.data.error
        ),
        _react2.default.createElement(
          'div',
          { className: 'fixed-action-btn' },
          _react2.default.createElement(
            'button',
            { className: 'btn-floating blue btn-large' },
            _react2.default.createElement(
              'i',
              { className: 'material-icons' },
              'save'
            )
          )
        ),
        renderSelect('offers', 'oggettoId', oggettiOptions, t('Immobile')),
        renderSelect('offers', 'consulenteId', consulenteVenditaOptions, t('Offerto da')),
        renderSingleDate('offers', 'offerCreatedAt', 'calendarFocused', t('Data invio proposta')),
        renderSelect('offers', 'offertoTramite', [{ value: 'email', label: t('Email') }, { value: 'telefono', label: t('Telefono') }, { value: 'presenza', label: t('Di presenza') }], t('Offerto via')),
        renderSelect('offers', 'feedback', [{ value: 'positivo', label: t('Positivo') }, { value: 'negativo', label: t('Negativo') }, { value: 'neutro', label: t('Neutro') }, { value: 'sconosciuto', label: t('Non ha risposto') }, { value: 'not_relevant', label: t('not_relevant') }], t('Feedback del cliente')),
        renderTextArea('offers', 'offerNote')
      );
    }
  }]);

  return OfferedPropertiesForm;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    utenti: state.utenti,
    oggetti: state.oggetti
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()((0, _withForm2.default)(OfferedPropertiesForm)));

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _withForm = __webpack_require__(21);

var _withForm2 = _interopRequireDefault(_withForm);

var _ExternalLinks = __webpack_require__(615);

var _ExternalLinks2 = _interopRequireDefault(_ExternalLinks);

var _IntestazioneParagrafo = __webpack_require__(616);

var _IntestazioneParagrafo2 = _interopRequireDefault(_IntestazioneParagrafo);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _materializeCss = __webpack_require__(61);

var _materializeCss2 = _interopRequireDefault(_materializeCss);

var _utils = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EvaluationForm = function (_Component) {
  _inherits(EvaluationForm, _Component);

  function EvaluationForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, EvaluationForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EvaluationForm.__proto__ || Object.getPrototypeOf(EvaluationForm)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (e) {
      e.preventDefault();

      var evaluations = _this.props.data.evaluations;


      var m2 = (0, _utils.trasformaInNumero)(evaluations.m2);
      var affittoNetto = (0, _utils.trasformaInNumero)(evaluations.affittoNetto);
      var rendite = (0, _utils.trasformaInNumero)(evaluations.rendite);
      var bodenRichtwert = (0, _utils.trasformaInNumero)(evaluations.bodenRichtwert);
      var bodenRichtwert2 = (0, _utils.trasformaInNumero)(evaluations.bodenRichtwert2);
      var bodenRichtwert3 = (0, _utils.trasformaInNumero)(evaluations.bodenRichtwert3);
      var mietspiegel = (0, _utils.trasformaInNumero)(evaluations.mietspiegel);
      var mietendeckel = (0, _utils.trasformaInNumero)(evaluations.mietendeckel);
      var immobilienpreisMin = (0, _utils.trasformaInNumero)(evaluations.immobilienpreisMin);
      var immobilienpreisMax = (0, _utils.trasformaInNumero)(evaluations.immobilienpreisMax);
      var immobilienpreisAverage = (0, _utils.trasformaInNumero)(evaluations.immobilienpreisAverage);
      var is24Evaluation = (0, _utils.trasformaInNumero)(evaluations.is24Evaluation);
      var result = (0, _utils.trasformaInNumero)(evaluations.result);

      if (!evaluations.titolo && !evaluations.oggettoId) {
        _this.props.renderError(_this.props.t('evaluation_form_submission_error'));
      } else {
        _this.props.onSubmit({
          affittoNetto: affittoNetto,
          // cover: evaluations.cover,
          bodenRichtwert: bodenRichtwert,
          bodenRichtwert2: bodenRichtwert2,
          bodenRichtwert3: bodenRichtwert3,
          bodenrichtwertSnippet: evaluations.bodenrichtwertSnippet,
          cloudURL: evaluations.cloudURL,
          dataEvaluation: evaluations.dataEvaluation.valueOf(),
          mietspiegel: mietspiegel,
          mietendeckel: mietendeckel,
          mietspiegelSnippet: evaluations.mietspiegelSnippet,
          m2: m2,
          immobilienpreisMin: immobilienpreisMin,
          immobilienpreisMax: immobilienpreisMax,
          immobilienpreisAverage: immobilienpreisAverage,
          immobilienPreisSnippet: evaluations.immobilienPreisSnippet,
          is24Evaluation: is24Evaluation,
          is24Snippet: evaluations.is24Snippet,
          note: evaluations.note,
          oggettoId: evaluations.oggettoId,
          rendite: rendite,
          result: result,
          testoIntroduttivoDe: evaluations.testoIntroduttivoDe,
          testoFinaleDe: evaluations.testoFinaleDe,
          testoIntroduttivoEn: evaluations.testoIntroduttivoEn,
          testoFinaleEn: evaluations.testoFinaleEn,
          testoIntroduttivoIt: evaluations.testoIntroduttivoIt,
          testoFinaleIt: evaluations.testoFinaleIt,
          titolo: evaluations.titolo,
          visible: evaluations.visible,
          wohnlage: evaluations.wohnlage,
          wohnlageSnippet: evaluations.wohnlageSnippet
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EvaluationForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      _materializeCss2.default.AutoInit();
    }
  }, {
    key: 'render',
    value: function render() {
      var evaluations = this.props.data.evaluations;
      var _props = this.props,
          t = _props.t,
          renderSelect = _props.renderSelect,
          renderInput = _props.renderInput,
          renderTextArea = _props.renderTextArea,
          renderCheckbox = _props.renderCheckbox,
          renderUploadImage = _props.renderUploadImage,
          changeHandlerValuta = _props.changeHandlerValuta;


      var rendite = (0, _utils.trasformaInNumero)(evaluations.rendite);
      var affitto = (0, _utils.trasformaInNumero)(evaluations.affittoNetto);
      var price = (0, _utils.formattaPrezzo)(affitto * 120000 / rendite, true);
      var m2 = (0, _utils.trasformaInNumero)(evaluations.m2);
      var m2Price = (0, _utils.formattaPrezzo)(affitto * 120000 / rendite / m2, true, true);
      var m2Rent = (0, _utils.formattaPrezzo)(affitto * 100 / m2, true);

      var oggettiOptions = this.props.oggetti.map(function (oggetto) {
        return {
          value: oggetto.id,
          label: 'Rif.Id: ' + oggetto.rifId + ' - ' + oggetto.via + ' ' + oggetto.numeroCivico + ', WE ' + oggetto.numeroAppartamento + ', ' + oggetto.cap + ' ' + oggetto.citta
        };
      });

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_IntestazioneParagrafo2.default, { intestazione: t('useful_links') }),
        _react2.default.createElement(_ExternalLinks2.default, null),
        _react2.default.createElement(
          'form',
          { className: 'form', onSubmit: this.onSubmit },
          this.props.data.error && _react2.default.createElement(
            'p',
            { className: 'form__error' },
            this.props.data.error
          ),
          ' ',
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_IntestazioneParagrafo2.default, {
              intestazione: t('yield_calculator_header')
            }),
            _react2.default.createElement(
              'div',
              { className: 'evaluation' },
              _react2.default.createElement(
                'div',
                null,
                renderInput('evaluations', 'affittoNetto', t('net_rent'), undefined, changeHandlerValuta),
                renderInput('evaluations', 'm2', t('m2'), undefined, changeHandlerValuta),
                renderInput('evaluations', 'rendite', t('property_yield'), undefined, changeHandlerValuta)
              ),
              _react2.default.createElement(
                'div',
                { className: 'card' },
                _react2.default.createElement(
                  'div',
                  { className: 'card-content blue-text' },
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'h6',
                      null,
                      t('calculated_price') + ': ' + price
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    t('m2_price') + ': ' + m2Price
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    t('m2_rent_price') + ': ' + m2Rent
                  )
                )
              )
            ),
            _react2.default.createElement(_IntestazioneParagrafo2.default, { intestazione: t('evaluation_summary') }),
            renderSelect('evaluations', 'oggettoId', oggettiOptions, t('Oggetto')),
            !evaluations.oggettoId && renderInput('evaluations', 'titolo', t('evaluation_title'), undefined, undefined, undefined, undefined, '*'),
            renderSelect('evaluations', 'wohnlage', [{
              value: 'simple_area',
              label: t('simple_area')
            }, {
              value: 'average_area',
              label: t('average_area')
            }, {
              value: 'good_area',
              label: t('good_area')
            }, {
              value: 'top_area',
              label: t('top_area')
            }], t('area_classification')),
            _react2.default.createElement(
              'div',
              { className: 'evaluation' },
              renderInput('evaluations', 'bodenRichtwert', t('land_price'), undefined, changeHandlerValuta, undefined, (0, _moment2.default)().format('YYYY')),
              renderInput('evaluations', 'bodenRichtwert2', (0, _moment2.default)().subtract(1, 'years').format('YYYY'), undefined, changeHandlerValuta),
              renderInput('evaluations', 'bodenRichtwert3', (0, _moment2.default)().subtract(2, 'years').format('YYYY'), undefined, changeHandlerValuta)
            ),
            _react2.default.createElement(
              'div',
              { className: 'evaluation' },
              renderInput('evaluations', 'mietspiegel', t('rent_mietspiegel'), undefined, changeHandlerValuta),
              renderInput('evaluations', 'mietendeckel', t('rent_mietendeckel'), undefined, changeHandlerValuta)
            ),
            _react2.default.createElement(
              'div',
              { className: 'evaluation' },
              renderInput('evaluations', 'immobilienpreisMin', t('sold_price_min'), undefined, changeHandlerValuta),
              renderInput('evaluations', 'immobilienpreisMax', t('sold_price_max'), undefined, changeHandlerValuta),
              renderInput('evaluations', 'immobilienpreisAverage', t('sold_price_average'), undefined, changeHandlerValuta)
            ),
            renderInput('evaluations', 'is24Evaluation', t('is24_evaluation'), undefined, changeHandlerValuta),
            renderInput('evaluations', 'result', t('evaluation_result'), undefined, changeHandlerValuta),
            renderTextArea('evaluations', 'note'),
            renderInput('evaluations', 'cloudURL', 'cloud URL'),
            this.props.utente.role === 'Admin' ? renderCheckbox('evaluations', 'visible', t('visible')) : ''
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'ul',
              { className: 'collection' },
              renderUploadImage('evaluations', 'wohnlageSnippet', 'Wohnlage'),
              renderUploadImage('evaluations', 'bodenrichtwertSnippet', 'Bodenrichtwert'),
              renderUploadImage('evaluations', 'immobilienPreisSnippet', 'Immobilien Preis Info'),
              renderUploadImage('evaluations', 'is24Snippet', 'ImmoScout24'),
              renderUploadImage('evaluations', 'mietspiegelSnippet', 'Mietspiegel')
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            t('german'),
            renderTextArea('evaluations', 'testoIntroduttivoDe', t('evaluation_text_initial')),
            renderTextArea('evaluations', 'testoFinaleDe', t('evaluation_text_final'))
          ),
          _react2.default.createElement(
            'div',
            null,
            t('english'),
            renderTextArea('evaluations', 'testoIntroduttivoEn', t('evaluation_text_initial')),
            renderTextArea('evaluations', 'testoFinaleEn', t('evaluation_text_final'))
          ),
          _react2.default.createElement(
            'div',
            null,
            t('italian'),
            renderTextArea('evaluations', 'testoIntroduttivoIt', t('evaluation_text_initial')),
            renderTextArea('evaluations', 'testoFinaleIt', t('evaluation_text_final'))
          ),
          _react2.default.createElement(
            'div',
            { className: 'fixed-action-btn' },
            _react2.default.createElement(
              'button',
              { className: 'btn-floating blue btn-large' },
              _react2.default.createElement(
                'i',
                { className: 'material-icons' },
                'save'
              )
            )
          )
        )
      );
    }
  }]);

  return EvaluationForm;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    evaluations: state.evaluations,
    oggetti: state.oggetti,
    utente: state.utenti.find(function (utente) {
      return utente.firebaseAuthId === state.auth.uid;
    })
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()((0, _withForm2.default)(EvaluationForm)));

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(4);

var _elements = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExternalLinks = function ExternalLinks(_ref) {
  var t = _ref.t;

  return _react2.default.createElement(
    'div',
    null,
    (0, _elements.linkButton)('https://fbinter.stadt-berlin.de/fb/index.jsp?loginkey=showAreaSelection&mapId=k_wohnlagenadr2019@senstadt&areaSelection=address', 'Wohnlagekarte'),
    (0, _elements.linkButton)('https://fbinter.stadt-berlin.de/boris/', 'Bodenrichtwert'),
    (0, _elements.linkButton)('https://www.stadtentwicklung.berlin.de/wohnen/mietspiegel/index.shtml', 'Mietspiegel'),
    (0, _elements.linkButton)('https://mietendeckel.berlin.de/wp-content/uploads/200221_mietendeckel_mietentabelle.pdf', 'Mietendeckel'),
    (0, _elements.linkButton)('https://aks-berlin.poet.de/aks-immobilien/control/flowcontroller.html?lJc8bZnDh=g5UjKk70&_flowId=root&_flowExecutionKey=e1s1', 'Immobilienpreis-Info'),
    (0, _elements.linkButton)('https://www.immobilienscout24.de/realestatevaluation/secured/managementv2/index.html#/', 'IS24 Bewertung')
  );
};

exports.default = (0, _reactI18next.withTranslation)()(ExternalLinks);

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Intestazione = function Intestazione(_ref) {
  var intestazione = _ref.intestazione;

  return _react2.default.createElement(
    'div',
    { className: 'grey lighten-4' },
    _react2.default.createElement(
      'h1',
      null,
      intestazione
    )
  );
};
exports.default = Intestazione;

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewsletterForm = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _withForm = __webpack_require__(21);

var _withForm2 = _interopRequireDefault(_withForm);

__webpack_require__(29);

__webpack_require__(30);

__webpack_require__(31);

var _materializeCss = __webpack_require__(61);

var _materializeCss2 = _interopRequireDefault(_materializeCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NewsletterForm = exports.NewsletterForm = function (_React$Component) {
  _inherits(NewsletterForm, _React$Component);

  function NewsletterForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NewsletterForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NewsletterForm.__proto__ || Object.getPrototypeOf(NewsletterForm)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (e) {
      e.preventDefault();
      var newsletters = _this.props.data.newsletters;

      _this.props.onSubmit({
        dataNewsletter: newsletters.dataNewsletter ? newsletters.dataNewsletter.valueOf() : null,
        oggetto1: newsletters.oggetto1 || null,
        oggetto2: newsletters.oggetto2 || null,
        oggetto3: newsletters.oggetto3 || null,
        oggetto4: newsletters.oggetto4 || null,
        oggetto5: newsletters.oggetto5 || null,
        oggetto6: newsletters.oggetto6 || null,
        newsletterText: newsletters.newsletterText || null,
        visible: newsletters.visible
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NewsletterForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      _materializeCss2.default.AutoInit();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          renderSelect = _props.renderSelect,
          renderSingleDate = _props.renderSingleDate,
          renderTextArea = _props.renderTextArea,
          renderCheckbox = _props.renderCheckbox;

      var oggettiOptions = this.props.oggetti.map(function (oggetto) {
        return {
          value: oggetto.id,
          label: 'Rif.Id: ' + oggetto.rifId + ' - ' + oggetto.via + ' ' + oggetto.numeroCivico + ', WE ' + oggetto.numeroAppartamento + ', ' + oggetto.cap + ' ' + oggetto.citta
        };
      });

      return _react2.default.createElement(
        'form',
        { className: 'form', onSubmit: this.onSubmit },
        this.props.data.error && _react2.default.createElement(
          'p',
          { className: 'form__error' },
          this.props.data.error
        ),
        _react2.default.createElement(
          'div',
          { className: 'fixed-action-btn' },
          _react2.default.createElement(
            'button',
            { className: 'btn-floating blue btn-large' },
            _react2.default.createElement(
              'i',
              { className: 'material-icons' },
              'save'
            )
          )
        ),
        renderSingleDate('newsletters', 'dataNewsletter', 'calendarFocused', t('newsletter_send_date')),
        renderSelect('newsletters', 'oggetto1', oggettiOptions, t('property')),
        renderSelect('newsletters', 'oggetto2', oggettiOptions, t('property')),
        renderSelect('newsletters', 'oggetto3', oggettiOptions, t('property')),
        renderSelect('newsletters', 'oggetto4', oggettiOptions, t('property')),
        renderSelect('newsletters', 'oggetto5', oggettiOptions, t('property')),
        renderSelect('newsletters', 'oggetto6', oggettiOptions, t('property')),
        renderTextArea('newsletters', 'newsletterText'),
        this.props.utente && this.props.utente.role === 'Admin' ? renderCheckbox('newsletters', 'visible', t('visible')) : ''
      );
    }
  }]);

  return NewsletterForm;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    utente: state.utenti.find(function (utente) {
      return utente.firebaseAuthId === state.auth.uid;
    }),
    oggetti: state.oggetti
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()((0, _withForm2.default)(NewsletterForm)));

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(619);
module.exports = __webpack_require__(821);


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(620);

__webpack_require__(817);

__webpack_require__(818);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(621);
__webpack_require__(624);
__webpack_require__(625);
__webpack_require__(626);
__webpack_require__(627);
__webpack_require__(628);
__webpack_require__(629);
__webpack_require__(630);
__webpack_require__(631);
__webpack_require__(632);
__webpack_require__(633);
__webpack_require__(634);
__webpack_require__(635);
__webpack_require__(636);
__webpack_require__(637);
__webpack_require__(638);
__webpack_require__(639);
__webpack_require__(640);
__webpack_require__(641);
__webpack_require__(642);
__webpack_require__(643);
__webpack_require__(644);
__webpack_require__(645);
__webpack_require__(646);
__webpack_require__(647);
__webpack_require__(648);
__webpack_require__(649);
__webpack_require__(650);
__webpack_require__(651);
__webpack_require__(652);
__webpack_require__(653);
__webpack_require__(654);
__webpack_require__(655);
__webpack_require__(656);
__webpack_require__(657);
__webpack_require__(658);
__webpack_require__(659);
__webpack_require__(660);
__webpack_require__(661);
__webpack_require__(662);
__webpack_require__(663);
__webpack_require__(664);
__webpack_require__(665);
__webpack_require__(666);
__webpack_require__(667);
__webpack_require__(668);
__webpack_require__(669);
__webpack_require__(670);
__webpack_require__(671);
__webpack_require__(672);
__webpack_require__(673);
__webpack_require__(674);
__webpack_require__(675);
__webpack_require__(676);
__webpack_require__(677);
__webpack_require__(678);
__webpack_require__(679);
__webpack_require__(680);
__webpack_require__(681);
__webpack_require__(682);
__webpack_require__(683);
__webpack_require__(684);
__webpack_require__(685);
__webpack_require__(686);
__webpack_require__(687);
__webpack_require__(688);
__webpack_require__(689);
__webpack_require__(690);
__webpack_require__(691);
__webpack_require__(692);
__webpack_require__(693);
__webpack_require__(694);
__webpack_require__(695);
__webpack_require__(696);
__webpack_require__(697);
__webpack_require__(698);
__webpack_require__(699);
__webpack_require__(701);
__webpack_require__(702);
__webpack_require__(704);
__webpack_require__(705);
__webpack_require__(706);
__webpack_require__(707);
__webpack_require__(708);
__webpack_require__(709);
__webpack_require__(710);
__webpack_require__(712);
__webpack_require__(713);
__webpack_require__(714);
__webpack_require__(715);
__webpack_require__(716);
__webpack_require__(717);
__webpack_require__(718);
__webpack_require__(719);
__webpack_require__(720);
__webpack_require__(721);
__webpack_require__(722);
__webpack_require__(723);
__webpack_require__(724);
__webpack_require__(181);
__webpack_require__(725);
__webpack_require__(244);
__webpack_require__(726);
__webpack_require__(245);
__webpack_require__(727);
__webpack_require__(728);
__webpack_require__(729);
__webpack_require__(730);
__webpack_require__(731);
__webpack_require__(248);
__webpack_require__(250);
__webpack_require__(251);
__webpack_require__(732);
__webpack_require__(733);
__webpack_require__(734);
__webpack_require__(735);
__webpack_require__(736);
__webpack_require__(737);
__webpack_require__(738);
__webpack_require__(739);
__webpack_require__(740);
__webpack_require__(741);
__webpack_require__(742);
__webpack_require__(743);
__webpack_require__(744);
__webpack_require__(745);
__webpack_require__(746);
__webpack_require__(747);
__webpack_require__(748);
__webpack_require__(749);
__webpack_require__(750);
__webpack_require__(751);
__webpack_require__(752);
__webpack_require__(753);
__webpack_require__(754);
__webpack_require__(755);
__webpack_require__(756);
__webpack_require__(757);
__webpack_require__(758);
__webpack_require__(759);
__webpack_require__(760);
__webpack_require__(761);
__webpack_require__(762);
__webpack_require__(763);
__webpack_require__(764);
__webpack_require__(765);
__webpack_require__(766);
__webpack_require__(767);
__webpack_require__(768);
__webpack_require__(769);
__webpack_require__(770);
__webpack_require__(771);
__webpack_require__(772);
__webpack_require__(773);
__webpack_require__(774);
__webpack_require__(775);
__webpack_require__(776);
__webpack_require__(777);
__webpack_require__(778);
__webpack_require__(779);
__webpack_require__(780);
__webpack_require__(781);
__webpack_require__(782);
__webpack_require__(783);
__webpack_require__(784);
__webpack_require__(785);
__webpack_require__(786);
__webpack_require__(787);
__webpack_require__(788);
__webpack_require__(789);
__webpack_require__(790);
__webpack_require__(791);
__webpack_require__(792);
__webpack_require__(793);
__webpack_require__(794);
__webpack_require__(795);
__webpack_require__(796);
__webpack_require__(797);
__webpack_require__(798);
__webpack_require__(799);
__webpack_require__(800);
__webpack_require__(801);
__webpack_require__(802);
__webpack_require__(803);
__webpack_require__(804);
__webpack_require__(805);
__webpack_require__(806);
__webpack_require__(807);
__webpack_require__(808);
__webpack_require__(809);
__webpack_require__(810);
__webpack_require__(811);
__webpack_require__(812);
__webpack_require__(813);
__webpack_require__(814);
__webpack_require__(815);
__webpack_require__(816);
module.exports = __webpack_require__(45);


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(8);
var has = __webpack_require__(40);
var DESCRIPTORS = __webpack_require__(16);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(34);
var META = __webpack_require__(64).KEY;
var $fails = __webpack_require__(10);
var shared = __webpack_require__(104);
var setToStringTag = __webpack_require__(90);
var uid = __webpack_require__(75);
var wks = __webpack_require__(13);
var wksExt = __webpack_require__(226);
var wksDefine = __webpack_require__(162);
var enumKeys = __webpack_require__(623);
var isArray = __webpack_require__(128);
var anObject = __webpack_require__(7);
var isObject = __webpack_require__(11);
var toObject = __webpack_require__(19);
var toIObject = __webpack_require__(41);
var toPrimitive = __webpack_require__(52);
var createDesc = __webpack_require__(74);
var _create = __webpack_require__(78);
var gOPNExt = __webpack_require__(229);
var $GOPD = __webpack_require__(42);
var $GOPS = __webpack_require__(127);
var $DP = __webpack_require__(17);
var $keys = __webpack_require__(76);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(79).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(106).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(63)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(33)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(104)('native-function-to-string', Function.toString);


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(76);
var gOPS = __webpack_require__(127);
var pIE = __webpack_require__(106);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(78) });


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(16), 'Object', { defineProperty: __webpack_require__(17).f });


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(16), 'Object', { defineProperties: __webpack_require__(228) });


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(41);
var $getOwnPropertyDescriptor = __webpack_require__(42).f;

__webpack_require__(54)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(19);
var $getPrototypeOf = __webpack_require__(43);

__webpack_require__(54)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(19);
var $keys = __webpack_require__(76);

__webpack_require__(54)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(54)('getOwnPropertyNames', function () {
  return __webpack_require__(229).f;
});


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(11);
var meta = __webpack_require__(64).onFreeze;

__webpack_require__(54)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(11);
var meta = __webpack_require__(64).onFreeze;

__webpack_require__(54)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(11);
var meta = __webpack_require__(64).onFreeze;

__webpack_require__(54)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(11);

__webpack_require__(54)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(11);

__webpack_require__(54)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(11);

__webpack_require__(54)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(1);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(230) });


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(1);
$export($export.S, 'Object', { is: __webpack_require__(231) });


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(1);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(166).set });


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(91);
var test = {};
test[__webpack_require__(13)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(34)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(1);

$export($export.P, 'Function', { bind: __webpack_require__(232) });


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(17).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(16) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(11);
var getPrototypeOf = __webpack_require__(43);
var HAS_INSTANCE = __webpack_require__(13)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(17).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseInt = __webpack_require__(234);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseFloat = __webpack_require__(235);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(8);
var has = __webpack_require__(40);
var cof = __webpack_require__(47);
var inheritIfRequired = __webpack_require__(168);
var toPrimitive = __webpack_require__(52);
var fails = __webpack_require__(10);
var gOPN = __webpack_require__(79).f;
var gOPD = __webpack_require__(42).f;
var dP = __webpack_require__(17).f;
var $trim = __webpack_require__(92).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(78)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(16) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(34)(global, NUMBER, $Number);
}


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toInteger = __webpack_require__(48);
var aNumberValue = __webpack_require__(236);
var repeat = __webpack_require__(169);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(10)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $fails = __webpack_require__(10);
var aNumberValue = __webpack_require__(236);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(1);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(1);
var _isFinite = __webpack_require__(8).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(1);

$export($export.S, 'Number', { isInteger: __webpack_require__(237) });


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(1);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(1);
var isInteger = __webpack_require__(237);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(1);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(1);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseFloat = __webpack_require__(235);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseInt = __webpack_require__(234);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(1);
var log1p = __webpack_require__(238);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(1);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(1);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(1);
var sign = __webpack_require__(170);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(1);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(1);
var $expm1 = __webpack_require__(171);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', { fround: __webpack_require__(239) });


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(1);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(1);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(10)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', { log1p: __webpack_require__(238) });


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', { sign: __webpack_require__(170) });


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(1);
var expm1 = __webpack_require__(171);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(10)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(1);
var expm1 = __webpack_require__(171);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var toAbsoluteIndex = __webpack_require__(77);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var toIObject = __webpack_require__(41);
var toLength = __webpack_require__(15);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(92)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(129)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(172)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $at = __webpack_require__(129)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(1);
var toLength = __webpack_require__(15);
var context = __webpack_require__(174);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(175)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(1);
var context = __webpack_require__(174);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(175)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(169)
});


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(1);
var toLength = __webpack_require__(15);
var context = __webpack_require__(174);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(175)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(35)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(35)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(35)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(35)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(35)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(35)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(35)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(35)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(35)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(35)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(35)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(35)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(35)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(1);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(19);
var toPrimitive = __webpack_require__(52);

$export($export.P + $export.F * __webpack_require__(10)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(1);
var toISOString = __webpack_require__(700);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(10);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(34)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(13)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(33)(proto, TO_PRIMITIVE, __webpack_require__(703));


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(7);
var toPrimitive = __webpack_require__(52);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(1);

$export($export.S, 'Array', { isArray: __webpack_require__(128) });


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(46);
var $export = __webpack_require__(1);
var toObject = __webpack_require__(19);
var call = __webpack_require__(240);
var isArrayIter = __webpack_require__(176);
var toLength = __webpack_require__(15);
var createProperty = __webpack_require__(177);
var getIterFn = __webpack_require__(178);

$export($export.S + $export.F * !__webpack_require__(131)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var createProperty = __webpack_require__(177);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(10)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(1);
var toIObject = __webpack_require__(41);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(105) != Object || !__webpack_require__(49)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var html = __webpack_require__(165);
var cof = __webpack_require__(47);
var toAbsoluteIndex = __webpack_require__(77);
var toLength = __webpack_require__(15);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(10)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var aFunction = __webpack_require__(26);
var toObject = __webpack_require__(19);
var fails = __webpack_require__(10);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(49)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $forEach = __webpack_require__(55)(0);
var STRICT = __webpack_require__(49)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11);
var isArray = __webpack_require__(128);
var SPECIES = __webpack_require__(13)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $map = __webpack_require__(55)(1);

$export($export.P + $export.F * !__webpack_require__(49)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $filter = __webpack_require__(55)(2);

$export($export.P + $export.F * !__webpack_require__(49)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $some = __webpack_require__(55)(3);

$export($export.P + $export.F * !__webpack_require__(49)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $every = __webpack_require__(55)(4);

$export($export.P + $export.F * !__webpack_require__(49)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $reduce = __webpack_require__(241);

$export($export.P + $export.F * !__webpack_require__(49)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $reduce = __webpack_require__(241);

$export($export.P + $export.F * !__webpack_require__(49)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $indexOf = __webpack_require__(126)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(49)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toIObject = __webpack_require__(41);
var toInteger = __webpack_require__(48);
var toLength = __webpack_require__(15);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(49)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(1);

$export($export.P, 'Array', { copyWithin: __webpack_require__(242) });

__webpack_require__(65)('copyWithin');


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(1);

$export($export.P, 'Array', { fill: __webpack_require__(180) });

__webpack_require__(65)('fill');


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(1);
var $find = __webpack_require__(55)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(65)(KEY);


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(1);
var $find = __webpack_require__(55)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(65)(KEY);


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(80)('Array');


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var inheritIfRequired = __webpack_require__(168);
var dP = __webpack_require__(17).f;
var gOPN = __webpack_require__(79).f;
var isRegExp = __webpack_require__(130);
var $flags = __webpack_require__(107);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(16) && (!CORRECT_NEW || __webpack_require__(10)(function () {
  re2[__webpack_require__(13)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(34)(global, 'RegExp', $RegExp);
}

__webpack_require__(80)('RegExp');


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(245);
var anObject = __webpack_require__(7);
var $flags = __webpack_require__(107);
var DESCRIPTORS = __webpack_require__(16);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(34)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(10)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(7);
var toLength = __webpack_require__(15);
var advanceStringIndex = __webpack_require__(183);
var regExpExec = __webpack_require__(132);

// @@match logic
__webpack_require__(133)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(7);
var toObject = __webpack_require__(19);
var toLength = __webpack_require__(15);
var toInteger = __webpack_require__(48);
var advanceStringIndex = __webpack_require__(183);
var regExpExec = __webpack_require__(132);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(133)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(7);
var sameValue = __webpack_require__(231);
var regExpExec = __webpack_require__(132);

// @@search logic
__webpack_require__(133)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(130);
var anObject = __webpack_require__(7);
var speciesConstructor = __webpack_require__(108);
var advanceStringIndex = __webpack_require__(183);
var toLength = __webpack_require__(15);
var callRegExpExec = __webpack_require__(132);
var regexpExec = __webpack_require__(182);
var fails = __webpack_require__(10);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(133)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(63);
var global = __webpack_require__(8);
var ctx = __webpack_require__(46);
var classof = __webpack_require__(91);
var $export = __webpack_require__(1);
var isObject = __webpack_require__(11);
var aFunction = __webpack_require__(26);
var anInstance = __webpack_require__(81);
var forOf = __webpack_require__(82);
var speciesConstructor = __webpack_require__(108);
var task = __webpack_require__(184).set;
var microtask = __webpack_require__(185)();
var newPromiseCapabilityModule = __webpack_require__(186);
var perform = __webpack_require__(246);
var userAgent = __webpack_require__(134);
var promiseResolve = __webpack_require__(247);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(13)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(83)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(90)($Promise, PROMISE);
__webpack_require__(80)(PROMISE);
Wrapper = __webpack_require__(45)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(131)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(252);
var validate = __webpack_require__(84);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(135)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $typed = __webpack_require__(136);
var buffer = __webpack_require__(187);
var anObject = __webpack_require__(7);
var toAbsoluteIndex = __webpack_require__(77);
var toLength = __webpack_require__(15);
var isObject = __webpack_require__(11);
var ArrayBuffer = __webpack_require__(8).ArrayBuffer;
var speciesConstructor = __webpack_require__(108);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(10)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(80)(ARRAY_BUFFER);


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
$export($export.G + $export.W + $export.F * !__webpack_require__(136).ABV, {
  DataView: __webpack_require__(187).DataView
});


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(59)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(59)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(59)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(59)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(59)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(59)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(59)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(59)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(59)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(1);
var aFunction = __webpack_require__(26);
var anObject = __webpack_require__(7);
var rApply = (__webpack_require__(8).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(10)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(1);
var create = __webpack_require__(78);
var aFunction = __webpack_require__(26);
var anObject = __webpack_require__(7);
var isObject = __webpack_require__(11);
var fails = __webpack_require__(10);
var bind = __webpack_require__(232);
var rConstruct = (__webpack_require__(8).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(17);
var $export = __webpack_require__(1);
var anObject = __webpack_require__(7);
var toPrimitive = __webpack_require__(52);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(10)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(1);
var gOPD = __webpack_require__(42).f;
var anObject = __webpack_require__(7);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(1);
var anObject = __webpack_require__(7);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(173)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(42);
var getPrototypeOf = __webpack_require__(43);
var has = __webpack_require__(40);
var $export = __webpack_require__(1);
var isObject = __webpack_require__(11);
var anObject = __webpack_require__(7);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(42);
var $export = __webpack_require__(1);
var anObject = __webpack_require__(7);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(1);
var getProto = __webpack_require__(43);
var anObject = __webpack_require__(7);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(1);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(1);
var anObject = __webpack_require__(7);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(1);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(254) });


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(1);
var anObject = __webpack_require__(7);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(17);
var gOPD = __webpack_require__(42);
var getPrototypeOf = __webpack_require__(43);
var has = __webpack_require__(40);
var $export = __webpack_require__(1);
var createDesc = __webpack_require__(74);
var anObject = __webpack_require__(7);
var isObject = __webpack_require__(11);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(1);
var setProto = __webpack_require__(166);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(1);
var $includes = __webpack_require__(126)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(65)('includes');


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(1);
var flattenIntoArray = __webpack_require__(255);
var toObject = __webpack_require__(19);
var toLength = __webpack_require__(15);
var aFunction = __webpack_require__(26);
var arraySpeciesCreate = __webpack_require__(179);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(65)('flatMap');


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(1);
var flattenIntoArray = __webpack_require__(255);
var toObject = __webpack_require__(19);
var toLength = __webpack_require__(15);
var toInteger = __webpack_require__(48);
var arraySpeciesCreate = __webpack_require__(179);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(65)('flatten');


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(1);
var $at = __webpack_require__(129)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(1);
var $pad = __webpack_require__(256);
var userAgent = __webpack_require__(134);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(1);
var $pad = __webpack_require__(256);
var userAgent = __webpack_require__(134);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(92)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(92)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(1);
var defined = __webpack_require__(53);
var toLength = __webpack_require__(15);
var isRegExp = __webpack_require__(130);
var getFlags = __webpack_require__(107);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(173)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(162)('asyncIterator');


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(162)('observable');


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(1);
var ownKeys = __webpack_require__(254);
var toIObject = __webpack_require__(41);
var gOPD = __webpack_require__(42);
var createProperty = __webpack_require__(177);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(1);
var $values = __webpack_require__(257)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(1);
var $entries = __webpack_require__(257)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(19);
var aFunction = __webpack_require__(26);
var $defineProperty = __webpack_require__(17);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(16) && $export($export.P + __webpack_require__(137), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(19);
var aFunction = __webpack_require__(26);
var $defineProperty = __webpack_require__(17);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(16) && $export($export.P + __webpack_require__(137), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(19);
var toPrimitive = __webpack_require__(52);
var getPrototypeOf = __webpack_require__(43);
var getOwnPropertyDescriptor = __webpack_require__(42).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(16) && $export($export.P + __webpack_require__(137), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(19);
var toPrimitive = __webpack_require__(52);
var getPrototypeOf = __webpack_require__(43);
var getOwnPropertyDescriptor = __webpack_require__(42).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(16) && $export($export.P + __webpack_require__(137), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(1);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(258)('Map') });


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(1);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(258)('Set') });


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(138)('Map');


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(138)('Set');


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(138)('WeakMap');


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(138)('WeakSet');


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(139)('Map');


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(139)('Set');


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(139)('WeakMap');


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(139)('WeakSet');


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(1);

$export($export.G, { global: __webpack_require__(8) });


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(1);

$export($export.S, 'System', { global: __webpack_require__(8) });


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(1);
var cof = __webpack_require__(47);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);
var scale = __webpack_require__(260);
var fround = __webpack_require__(239);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', { scale: __webpack_require__(260) });


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(1);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(1);
var core = __webpack_require__(45);
var global = __webpack_require__(8);
var speciesConstructor = __webpack_require__(108);
var promiseResolve = __webpack_require__(247);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(1);
var newPromiseCapability = __webpack_require__(186);
var perform = __webpack_require__(246);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(60);
var anObject = __webpack_require__(7);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(60);
var anObject = __webpack_require__(7);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(60);
var anObject = __webpack_require__(7);
var getPrototypeOf = __webpack_require__(43);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(250);
var from = __webpack_require__(259);
var metadata = __webpack_require__(60);
var anObject = __webpack_require__(7);
var getPrototypeOf = __webpack_require__(43);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(60);
var anObject = __webpack_require__(7);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(60);
var anObject = __webpack_require__(7);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(60);
var anObject = __webpack_require__(7);
var getPrototypeOf = __webpack_require__(43);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(60);
var anObject = __webpack_require__(7);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(60);
var anObject = __webpack_require__(7);
var aFunction = __webpack_require__(26);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(1);
var microtask = __webpack_require__(185)();
var process = __webpack_require__(8).process;
var isNode = __webpack_require__(47)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(1);
var global = __webpack_require__(8);
var core = __webpack_require__(45);
var microtask = __webpack_require__(185)();
var OBSERVABLE = __webpack_require__(13)('observable');
var aFunction = __webpack_require__(26);
var anObject = __webpack_require__(7);
var anInstance = __webpack_require__(81);
var redefineAll = __webpack_require__(83);
var hide = __webpack_require__(33);
var forOf = __webpack_require__(82);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(80)('Observable');


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(8);
var $export = __webpack_require__(1);
var userAgent = __webpack_require__(134);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $task = __webpack_require__(184);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(181);
var getKeys = __webpack_require__(76);
var redefine = __webpack_require__(34);
var global = __webpack_require__(8);
var hide = __webpack_require__(33);
var Iterators = __webpack_require__(93);
var wks = __webpack_require__(13);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(819);
module.exports = __webpack_require__(45).RegExp.escape;


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(1);
var $re = __webpack_require__(820)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 820 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(94);

var _reactDom2 = _interopRequireDefault(_reactDom);

__webpack_require__(826);

var _reactRedux = __webpack_require__(5);

var _firebase = __webpack_require__(192);

var _AppRouter = __webpack_require__(907);

var _AppRouter2 = _interopRequireDefault(_AppRouter);

var _configureStore = __webpack_require__(14);

var _configureStore2 = _interopRequireDefault(_configureStore);

var _auth = __webpack_require__(224);

__webpack_require__(1184);

__webpack_require__(1185);

__webpack_require__(1186);

var _LoadingPage = __webpack_require__(1187);

var _LoadingPage2 = _interopRequireDefault(_LoadingPage);

var _utils = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _utils.generaToken)();

var store = (0, _configureStore2.default)();

var jsx = _react2.default.createElement(
  _react.Suspense,
  { fallback: _react2.default.createElement(
      'div',
      null,
      'Loading...'
    ) },
  _react2.default.createElement(
    _reactRedux.Provider,
    { store: store },
    _react2.default.createElement(_AppRouter2.default, null)
  )
);
var hasRendered = false;
var renderApp = function renderApp() {
  if (!hasRendered) {
    _reactDom2.default.render(jsx, document.getElementById('app'));
    hasRendered = true;
  }
};

_reactDom2.default.render(_react2.default.createElement(_LoadingPage2.default, null), document.getElementById('app'));

_firebase.firebase.auth().onAuthStateChanged(function (user) {
  if (user) {
    store.dispatch((0, _auth.login)(user.uid));
    for (var i = 0; i < _configureStore.storeActions.length; i++) {
      if (i === _configureStore.storeActions.length - 1) {
        store.dispatch(_configureStore.storeActions[i].startSetAction()).then(function () {
          renderApp();
          if (_AppRouter.history.location.pathname === '/') {
            _AppRouter.history.push('/deals');
          }
        });
      } else {
        store.dispatch(_configureStore.storeActions[i].startSetAction());
      }
    }
  } else {
    store.dispatch((0, _auth.logout)());
    renderApp();
    _AppRouter.history.push('/');
  }
});

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(261),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.concurrent_mode"):60111,y=n?Symbol.for("react.forward_ref"):60112,z=n?Symbol.for("react.suspense"):60113,aa=n?Symbol.for("react.memo"):
60115,ba=n?Symbol.for("react.lazy"):60116,A="function"===typeof Symbol&&Symbol.iterator;function ca(a,b,d,c,e,g,h,f){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[d,c,e,g,h,f],m=0;a=Error(b.replace(/%s/g,function(){return l[m++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function B(a){for(var b=arguments.length-1,d="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)d+="&args[]="+encodeURIComponent(arguments[c+1]);ca(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",d)}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
function E(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?B("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}var H=G.prototype=new F;
H.constructor=G;k(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,d){var c=void 0,e={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=b[c]);var f=arguments.length-2;if(1===f)e.children=d;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];e.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===e[c]&&(e[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:h,props:e,_owner:J.current}}
function da(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,d,c){if(P.length){var e=P.pop();e.result=a;e.keyPrefix=b;e.func=d;e.context=c;e.count=0;return e}return{result:a,keyPrefix:b,func:d,context:c,count:0}}
function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,d,c){var e=typeof a;if("undefined"===e||"boolean"===e)a=null;var g=!1;if(null===a)g=!0;else switch(e){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return d(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){e=a[h];var f=b+T(e,h);g+=S(e,f,d,c)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),h=
0;!(e=a.next()).done;)e=e.value,f=b+T(e,h++),g+=S(e,f,d,c);else"object"===e&&(d=""+a,B("31","[object Object]"===d?"object with keys {"+Object.keys(a).join(", ")+"}":d,""));return g}function U(a,b,d){return null==a?0:S(a,"",b,d)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ea(a,b){a.func.call(a.context,b,a.count++)}
function fa(a,b,d){var c=a.result,e=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,d,function(a){return a}):null!=a&&(N(a)&&(a=da(a,e+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+d)),c.push(a))}function V(a,b,d,c,e){var g="";null!=d&&(g=(""+d).replace(O,"$&/")+"/");b=Q(b,g,c,e);U(a,fa,b);R(b)}function W(){var a=I.current;null===a?B("307"):void 0;return a}
var X={Children:{map:function(a,b,d){if(null==a)return a;var c=[];V(a,c,null,b,d);return c},forEach:function(a,b,d){if(null==a)return a;b=Q(null,null,b,d);U(a,ea,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){N(a)?void 0:B("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:y,render:a}},lazy:function(a){return{$$typeof:ba,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:aa,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
b,d){return W().useImperativeHandle(a,b,d)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,d){return W().useReducer(a,b,d)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,StrictMode:t,Suspense:z,createElement:M,cloneElement:function(a,b,d){null===a||void 0===a?B("267",a):void 0;var c=void 0,e=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=
b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)e.children=d;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];e.children=l}return{$$typeof:p,type:a.type,key:g,ref:h,props:e,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.8.0",
unstable_ConcurrentMode:x,unstable_Profiler:u,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentOwner:J,assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(2),p=__webpack_require__(261),ba=__webpack_require__(824);function ca(a,b,c,d,e,f,g,h){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[c,d,e,f,g,h],k=0;a=Error(b.replace(/%s/g,function(){return l[k++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function t(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);ca(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}aa?void 0:t("227");function da(a,b,c,d,e,f,g,h,l){var k=Array.prototype.slice.call(arguments,3);try{b.apply(c,k)}catch(m){this.onError(m)}}
var ea=!1,fa=null,ha=!1,ia=null,ja={onError:function(a){ea=!0;fa=a}};function ka(a,b,c,d,e,f,g,h,l){ea=!1;fa=null;da.apply(ja,arguments)}function la(a,b,c,d,e,f,g,h,l){ka.apply(this,arguments);if(ea){if(ea){var k=fa;ea=!1;fa=null}else t("198"),k=void 0;ha||(ha=!0,ia=k)}}var ma=null,na={};
function oa(){if(ma)for(var a in na){var b=na[a],c=ma.indexOf(a);-1<c?void 0:t("96",a);if(!pa[c]){b.extractEvents?void 0:t("97",a);pa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;ra.hasOwnProperty(h)?t("99",h):void 0;ra[h]=f;var l=f.phasedRegistrationNames;if(l){for(e in l)l.hasOwnProperty(e)&&sa(l[e],g,h);e=!0}else f.registrationName?(sa(f.registrationName,g,h),e=!0):e=!1;e?void 0:t("98",d,a)}}}}
function sa(a,b,c){ta[a]?t("100",a):void 0;ta[a]=b;ua[a]=b.eventTypes[c].dependencies}var pa=[],ra={},ta={},ua={},va=null,wa=null,xa=null;function ya(a,b,c){var d=a.type||"unknown-event";a.currentTarget=xa(c);la(d,b,void 0,a);a.currentTarget=null}function za(a,b){null==b?t("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function Aa(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ba=null;function Ca(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)ya(a,b[d],c[d]);else b&&ya(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}
var Da={injectEventPluginOrder:function(a){ma?t("101"):void 0;ma=Array.prototype.slice.call(a);oa()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];na.hasOwnProperty(c)&&na[c]===d||(na[c]?t("102",c):void 0,na[c]=d,b=!0)}b&&oa()}};
function Ea(a,b){var c=a.stateNode;if(!c)return null;var d=va(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?t("231",b,typeof c):void 0;
return c}function Fa(a){null!==a&&(Ba=za(Ba,a));a=Ba;Ba=null;if(a&&(Aa(a,Ca),Ba?t("95"):void 0,ha))throw a=ia,ha=!1,ia=null,a;}var Ga=Math.random().toString(36).slice(2),Ha="__reactInternalInstance$"+Ga,Ia="__reactEventHandlers$"+Ga;function Ja(a){if(a[Ha])return a[Ha];for(;!a[Ha];)if(a.parentNode)a=a.parentNode;else return null;a=a[Ha];return 5===a.tag||6===a.tag?a:null}function Ka(a){a=a[Ha];return!a||5!==a.tag&&6!==a.tag?null:a}
function La(a){if(5===a.tag||6===a.tag)return a.stateNode;t("33")}function Ma(a){return a[Ia]||null}function Na(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Oa(a,b,c){if(b=Ea(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=za(c._dispatchListeners,b),c._dispatchInstances=za(c._dispatchInstances,a)}
function Pa(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Na(b);for(b=c.length;0<b--;)Oa(c[b],"captured",a);for(b=0;b<c.length;b++)Oa(c[b],"bubbled",a)}}function Qa(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ea(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=za(c._dispatchListeners,b),c._dispatchInstances=za(c._dispatchInstances,a))}function Ra(a){a&&a.dispatchConfig.registrationName&&Qa(a._targetInst,null,a)}
function Sa(a){Aa(a,Pa)}var Ta=!("undefined"===typeof window||!window.document||!window.document.createElement);function Ua(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Va={animationend:Ua("Animation","AnimationEnd"),animationiteration:Ua("Animation","AnimationIteration"),animationstart:Ua("Animation","AnimationStart"),transitionend:Ua("Transition","TransitionEnd")},Wa={},Xa={};
Ta&&(Xa=document.createElement("div").style,"AnimationEvent"in window||(delete Va.animationend.animation,delete Va.animationiteration.animation,delete Va.animationstart.animation),"TransitionEvent"in window||delete Va.transitionend.transition);function Ya(a){if(Wa[a])return Wa[a];if(!Va[a])return a;var b=Va[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Xa)return Wa[a]=b[c];return a}
var Za=Ya("animationend"),$a=Ya("animationiteration"),ab=Ya("animationstart"),bb=Ya("transitionend"),cb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),db=null,eb=null,fb=null;
function gb(){if(fb)return fb;var a,b=eb,c=b.length,d,e="value"in db?db.value:db.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return fb=e.slice(a,1<d?1-d:void 0)}function hb(){return!0}function ib(){return!1}
function A(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?hb:ib;this.isPropagationStopped=ib;return this}
p(A.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=hb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=hb)},persist:function(){this.isPersistent=hb},isPersistent:ib,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ib;this._dispatchInstances=this._dispatchListeners=null}});A.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
A.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;p(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=p({},d.Interface,a);c.extend=d.extend;jb(c);return c};jb(A);function kb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function lb(a){a instanceof this?void 0:t("279");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}
function jb(a){a.eventPool=[];a.getPooled=kb;a.release=lb}var mb=A.extend({data:null}),nb=A.extend({data:null}),ob=[9,13,27,32],pb=Ta&&"CompositionEvent"in window,qb=null;Ta&&"documentMode"in document&&(qb=document.documentMode);
var rb=Ta&&"TextEvent"in window&&!qb,sb=Ta&&(!pb||qb&&8<qb&&11>=qb),tb=String.fromCharCode(32),vb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},wb=!1;
function xb(a,b){switch(a){case "keyup":return-1!==ob.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function yb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var zb=!1;function Ab(a,b){switch(a){case "compositionend":return yb(b);case "keypress":if(32!==b.which)return null;wb=!0;return tb;case "textInput":return a=b.data,a===tb&&wb?null:a;default:return null}}
function Bb(a,b){if(zb)return"compositionend"===a||!pb&&xb(a,b)?(a=gb(),fb=eb=db=null,zb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return sb&&"ko"!==b.locale?null:b.data;default:return null}}
var Cb={eventTypes:vb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(pb)b:{switch(a){case "compositionstart":e=vb.compositionStart;break b;case "compositionend":e=vb.compositionEnd;break b;case "compositionupdate":e=vb.compositionUpdate;break b}e=void 0}else zb?xb(a,c)&&(e=vb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=vb.compositionStart);e?(sb&&"ko"!==c.locale&&(zb||e!==vb.compositionStart?e===vb.compositionEnd&&zb&&(f=gb()):(db=d,eb="value"in db?db.value:db.textContent,zb=
!0)),e=mb.getPooled(e,b,c,d),f?e.data=f:(f=yb(c),null!==f&&(e.data=f)),Sa(e),f=e):f=null;(a=rb?Ab(a,c):Bb(a,c))?(b=nb.getPooled(vb.beforeInput,b,c,d),b.data=a,Sa(b)):b=null;return null===f?b:null===b?f:[f,b]}},Db=null,Eb=null,Fb=null;function Gb(a){if(a=wa(a)){"function"!==typeof Db?t("280"):void 0;var b=va(a.stateNode);Db(a.stateNode,a.type,b)}}function Hb(a){Eb?Fb?Fb.push(a):Fb=[a]:Eb=a}function Ib(){if(Eb){var a=Eb,b=Fb;Fb=Eb=null;Gb(a);if(b)for(a=0;a<b.length;a++)Gb(b[a])}}
function Jb(a,b){return a(b)}function Kb(a,b,c){return a(b,c)}function Lb(){}var Mb=!1;function Nb(a,b){if(Mb)return a(b);Mb=!0;try{return Jb(a,b)}finally{if(Mb=!1,null!==Eb||null!==Fb)Lb(),Ib()}}var Ob={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Pb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Ob[a.type]:"textarea"===b?!0:!1}
function Qb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Sb(a){if(!Ta)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function Tb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ub(a){var b=Tb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function Vb(a){a._valueTracker||(a._valueTracker=Ub(a))}function Wb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Tb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var Xb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,Yb=/^(.*)[\\\/]/,D="function"===typeof Symbol&&Symbol.for,Zb=D?Symbol.for("react.element"):60103,$b=D?Symbol.for("react.portal"):60106,ac=D?Symbol.for("react.fragment"):60107,bc=D?Symbol.for("react.strict_mode"):60108,cc=D?Symbol.for("react.profiler"):60114,dc=D?Symbol.for("react.provider"):60109,ec=D?Symbol.for("react.context"):60110,fc=D?Symbol.for("react.concurrent_mode"):60111,gc=D?Symbol.for("react.forward_ref"):60112,hc=D?Symbol.for("react.suspense"):
60113,ic=D?Symbol.for("react.memo"):60115,jc=D?Symbol.for("react.lazy"):60116,kc="function"===typeof Symbol&&Symbol.iterator;function lc(a){if(null===a||"object"!==typeof a)return null;a=kc&&a[kc]||a["@@iterator"];return"function"===typeof a?a:null}
function mc(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case fc:return"ConcurrentMode";case ac:return"Fragment";case $b:return"Portal";case cc:return"Profiler";case bc:return"StrictMode";case hc:return"Suspense"}if("object"===typeof a)switch(a.$$typeof){case ec:return"Context.Consumer";case dc:return"Context.Provider";case gc:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+
")":"ForwardRef");case ic:return mc(a.type);case jc:if(a=1===a._status?a._result:null)return mc(a)}return null}function nc(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=mc(a.type);c=null;d&&(c=mc(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Yb,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
var oc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,pc=Object.prototype.hasOwnProperty,qc={},rc={};
function sc(a){if(pc.call(rc,a))return!0;if(pc.call(qc,a))return!1;if(oc.test(a))return rc[a]=!0;qc[a]=!0;return!1}function tc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function uc(a,b,c,d){if(null===b||"undefined"===typeof b||tc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function F(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var G={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){G[a]=new F(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];G[b]=new F(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){G[a]=new F(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){G[a]=new F(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){G[a]=new F(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){G[a]=new F(a,3,!0,a,null)});
["capture","download"].forEach(function(a){G[a]=new F(a,4,!1,a,null)});["cols","rows","size","span"].forEach(function(a){G[a]=new F(a,6,!1,a,null)});["rowSpan","start"].forEach(function(a){G[a]=new F(a,5,!1,a.toLowerCase(),null)});var vc=/[\-:]([a-z])/g;function wc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(vc,
wc);G[b]=new F(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(vc,wc);G[b]=new F(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(vc,wc);G[b]=new F(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});G.tabIndex=new F("tabIndex",1,!1,"tabindex",null);
function xc(a,b,c,d){var e=G.hasOwnProperty(b)?G[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(uc(b,c,e,d)&&(c=null),d||null===e?sc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function yc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function zc(a,b){var c=b.checked;return p({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ac(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=yc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bc(a,b){b=b.checked;null!=b&&xc(a,"checked",b,!1)}
function Cc(a,b){Bc(a,b);var c=yc(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Dc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Dc(a,b.type,yc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Ec(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Dc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var Fc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Gc(a,b,c){a=A.getPooled(Fc.change,a,b,c);a.type="change";Hb(c);Sa(a);return a}var Hc=null,Ic=null;function Jc(a){Fa(a)}
function Kc(a){var b=La(a);if(Wb(b))return a}function Lc(a,b){if("change"===a)return b}var Mc=!1;Ta&&(Mc=Sb("input")&&(!document.documentMode||9<document.documentMode));function Nc(){Hc&&(Hc.detachEvent("onpropertychange",Oc),Ic=Hc=null)}function Oc(a){"value"===a.propertyName&&Kc(Ic)&&(a=Gc(Ic,a,Qb(a)),Nb(Jc,a))}function Pc(a,b,c){"focus"===a?(Nc(),Hc=b,Ic=c,Hc.attachEvent("onpropertychange",Oc)):"blur"===a&&Nc()}function Qc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Kc(Ic)}
function Rc(a,b){if("click"===a)return Kc(b)}function Sc(a,b){if("input"===a||"change"===a)return Kc(b)}
var Tc={eventTypes:Fc,_isInputEventSupported:Mc,extractEvents:function(a,b,c,d){var e=b?La(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Lc:Pb(e)?Mc?f=Sc:(f=Qc,g=Pc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Rc);if(f&&(f=f(a,b)))return Gc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Dc(e,"number",e.value)}},Uc=A.extend({view:null,detail:null}),Vc={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Wc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Vc[a])?!!b[a]:!1}function Xc(){return Wc}
var Yc=0,Zc=0,$c=!1,ad=!1,bd=Uc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Xc,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Yc;Yc=a.screenX;return $c?"mousemove"===a.type?a.screenX-b:0:($c=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Zc;Zc=a.screenY;return ad?"mousemove"===a.type?a.screenY-b:0:(ad=!0,0)}}),cd=bd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),dd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},ed={eventTypes:dd,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Ja(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,l=void 0,k=void 0;if("mouseout"===a||"mouseover"===a)g=bd,h=dd.mouseLeave,l=dd.mouseEnter,k="mouse";
else if("pointerout"===a||"pointerover"===a)g=cd,h=dd.pointerLeave,l=dd.pointerEnter,k="pointer";var m=null==f?e:La(f);e=null==b?e:La(b);a=g.getPooled(h,f,c,d);a.type=k+"leave";a.target=m;a.relatedTarget=e;c=g.getPooled(l,b,c,d);c.type=k+"enter";c.target=e;c.relatedTarget=m;d=b;if(f&&d)a:{b=f;e=d;k=0;for(g=b;g;g=Na(g))k++;g=0;for(l=e;l;l=Na(l))g++;for(;0<k-g;)b=Na(b),k--;for(;0<g-k;)e=Na(e),g--;for(;k--;){if(b===e||b===e.alternate)break a;b=Na(b);e=Na(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){k=
f.alternate;if(null!==k&&k===e)break;b.push(f);f=Na(f)}for(f=[];d&&d!==e;){k=d.alternate;if(null!==k&&k===e)break;f.push(d);d=Na(d)}for(d=0;d<b.length;d++)Qa(b[d],"bubbled",a);for(d=f.length;0<d--;)Qa(f[d],"captured",c);return[a,c]}};function fd(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var gd=Object.prototype.hasOwnProperty;
function hd(a,b){if(fd(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!gd.call(b,c[d])||!fd(a[c[d]],b[c[d]]))return!1;return!0}function kd(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function ld(a){2!==kd(a)?t("188"):void 0}
function md(a){var b=a.alternate;if(!b)return b=kd(a),3===b?t("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return ld(e),a;if(g===d)return ld(e),b;g=g.sibling}t("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:t("189")}}c.alternate!==d?t("190"):void 0}3!==c.tag?t("188"):void 0;return c.stateNode.current===c?a:b}function nd(a){a=md(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var od=A.extend({animationName:null,elapsedTime:null,pseudoElement:null}),pd=A.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),qd=Uc.extend({relatedTarget:null});function rd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var sd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},td={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},ud=Uc.extend({key:function(a){if(a.key){var b=sd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=rd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?td[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Xc,charCode:function(a){return"keypress"===
a.type?rd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?rd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),vd=bd.extend({dataTransfer:null}),wd=Uc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Xc}),xd=A.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),yd=bd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),zd=[["abort","abort"],[Za,"animationEnd"],[$a,"animationIteration"],[ab,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[bb,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],Ad={},Bd={};function Cd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Ad[a]=b;Bd[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["auxclick","auxClick"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],
["pointerdown","pointerDown"],["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){Cd(a,!0)});zd.forEach(function(a){Cd(a,!1)});
var Dd={eventTypes:Ad,isInteractiveTopLevelEventType:function(a){a=Bd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Bd[a];if(!e)return null;switch(a){case "keypress":if(0===rd(c))return null;case "keydown":case "keyup":a=ud;break;case "blur":case "focus":a=qd;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=bd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
vd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=wd;break;case Za:case $a:case ab:a=od;break;case bb:a=xd;break;case "scroll":a=Uc;break;case "wheel":a=yd;break;case "copy":case "cut":case "paste":a=pd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=cd;break;default:a=A}b=a.getPooled(e,b,c,d);Sa(b);return b}},Ed=Dd.isInteractiveTopLevelEventType,
Fd=[];function Gd(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Ja(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Qb(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=null,h=0;h<pa.length;h++){var l=pa[h];l&&(l=l.extractEvents(d,b,f,e))&&(g=za(g,l))}Fa(g)}}var Hd=!0;
function H(a,b){if(!b)return null;var c=(Ed(a)?Id:Jd).bind(null,a);b.addEventListener(a,c,!1)}function Kd(a,b){if(!b)return null;var c=(Ed(a)?Id:Jd).bind(null,a);b.addEventListener(a,c,!0)}function Id(a,b){Kb(Jd,a,b)}
function Jd(a,b){if(Hd){var c=Qb(b);c=Ja(c);null===c||"number"!==typeof c.tag||2===kd(c)||(c=null);if(Fd.length){var d=Fd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Nb(Gd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Fd.length&&Fd.push(a)}}}var Ld={},Md=0,Nd="_reactListenersID"+(""+Math.random()).slice(2);
function Od(a){Object.prototype.hasOwnProperty.call(a,Nd)||(a[Nd]=Md++,Ld[a[Nd]]={});return Ld[a[Nd]]}function Pd(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Qd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Rd(a,b){var c=Qd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Qd(c)}}function Sd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Sd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
function Td(){for(var a=window,b=Pd();b instanceof a.HTMLIFrameElement;){try{a=b.contentDocument.defaultView}catch(c){break}b=Pd(a.document)}return b}function Ud(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
var Vd=Ta&&"documentMode"in document&&11>=document.documentMode,Wd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Xd=null,Yd=null,Zd=null,$d=!1;
function ae(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if($d||null==Xd||Xd!==Pd(c))return null;c=Xd;"selectionStart"in c&&Ud(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return Zd&&hd(Zd,c)?null:(Zd=c,a=A.getPooled(Wd.select,Yd,a,b),a.type="select",a.target=Xd,Sa(a),a)}
var be={eventTypes:Wd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Od(e);f=ua.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?La(b):window;switch(a){case "focus":if(Pb(e)||"true"===e.contentEditable)Xd=e,Yd=b,Zd=null;break;case "blur":Zd=Yd=Xd=null;break;case "mousedown":$d=!0;break;case "contextmenu":case "mouseup":case "dragend":return $d=!1,ae(c,d);case "selectionchange":if(Vd)break;
case "keydown":case "keyup":return ae(c,d)}return null}};Da.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));va=Ma;wa=Ka;xa=La;Da.injectEventPluginsByName({SimpleEventPlugin:Dd,EnterLeaveEventPlugin:ed,ChangeEventPlugin:Tc,SelectEventPlugin:be,BeforeInputEventPlugin:Cb});function ce(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
function de(a,b){a=p({children:void 0},b);if(b=ce(b.children))a.children=b;return a}function ee(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+yc(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function fe(a,b){null!=b.dangerouslySetInnerHTML?t("91"):void 0;return p({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function ge(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?t("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:t("93"),b=b[0]),c=b),null==c&&(c=""));a._wrapperState={initialValue:yc(c)}}
function he(a,b){var c=yc(b.value),d=yc(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function ie(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var je={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function ke(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function le(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?ke(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var me=void 0,ne=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==je.svg||"innerHTML"in a)a.innerHTML=b;else{me=me||document.createElement("div");me.innerHTML="<svg>"+b+"</svg>";for(b=me.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function oe(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var pe={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},qe=["Webkit","ms","Moz","O"];Object.keys(pe).forEach(function(a){qe.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);pe[b]=pe[a]})});function re(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||pe.hasOwnProperty(a)&&pe[a]?(""+b).trim():b+"px"}
function se(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=re(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var te=p({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function ue(a,b){b&&(te[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?t("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?t("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:t("61")),null!=b.style&&"object"!==typeof b.style?t("62",""):void 0)}
function ve(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
function we(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Od(a);b=ua[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Kd("scroll",a);break;case "focus":case "blur":Kd("focus",a);Kd("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":Sb(e)&&Kd(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===cb.indexOf(e)&&H(e,a)}c[e]=!0}}}function xe(){}var ye=null,ze=null;
function Ae(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function Be(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}
var Ce="function"===typeof setTimeout?setTimeout:void 0,De="function"===typeof clearTimeout?clearTimeout:void 0,Ee=ba.unstable_scheduleCallback,Fe=ba.unstable_cancelCallback;
function Ge(a,b,c,d,e){a[Ia]=e;"input"===c&&"radio"===e.type&&null!=e.name&&Bc(a,e);ve(c,d);d=ve(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?se(a,h):"dangerouslySetInnerHTML"===g?ne(a,h):"children"===g?oe(a,h):xc(a,g,h,d)}switch(c){case "input":Cc(a,e);break;case "textarea":he(a,e);break;case "select":b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?ee(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?ee(a,!!e.multiple,e.defaultValue,
!0):ee(a,!!e.multiple,e.multiple?[]:"",!1))}}function He(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function Ie(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var Je=[],Ke=-1;function I(a){0>Ke||(a.current=Je[Ke],Je[Ke]=null,Ke--)}function J(a,b){Ke++;Je[Ke]=a.current;a.current=b}var Le={},K={current:Le},L={current:!1},Me=Le;
function Oe(a,b){var c=a.type.contextTypes;if(!c)return Le;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function M(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Pe(a){I(L,a);I(K,a)}function Qe(a){I(L,a);I(K,a)}
function Re(a,b,c){K.current!==Le?t("168"):void 0;J(K,b,a);J(L,c,a)}function Se(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)e in a?void 0:t("108",mc(b)||"Unknown",e);return p({},c,d)}function Te(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||Le;Me=K.current;J(K,b,a);J(L,L.current,a);return!0}
function Ue(a,b,c){var d=a.stateNode;d?void 0:t("169");c?(b=Se(a,b,Me),d.__reactInternalMemoizedMergedChildContext=b,I(L,a),I(K,a),J(K,b,a)):I(L,a);J(L,c,a)}var Ve=null,We=null;function Xe(a){return function(b){try{return a(b)}catch(c){}}}
function Ye(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Ve=Xe(function(a){return b.onCommitFiberRoot(c,a)});We=Xe(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}
function Ze(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.contextDependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function N(a,b,c,d){return new Ze(a,b,c,d)}
function $e(a){a=a.prototype;return!(!a||!a.isReactComponent)}function af(a){if("function"===typeof a)return $e(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gc)return 11;if(a===ic)return 14}return 2}
function bf(a,b){var c=a.alternate;null===c?(c=N(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;c.contextDependencies=a.contextDependencies;c.sibling=a.sibling;
c.index=a.index;c.ref=a.ref;return c}
function cf(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)$e(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ac:return df(c.children,e,f,b);case fc:return ef(c,e|3,f,b);case bc:return ef(c,e|2,f,b);case cc:return a=N(12,c,b,e|4),a.elementType=cc,a.type=cc,a.expirationTime=f,a;case hc:return a=N(13,c,b,e),a.elementType=hc,a.type=hc,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case dc:g=10;break a;case ec:g=9;break a;case gc:g=11;break a;case ic:g=
14;break a;case jc:g=16;d=null;break a}t("130",null==a?a:typeof a,"")}b=N(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function df(a,b,c,d){a=N(7,a,d,b);a.expirationTime=c;return a}function ef(a,b,c,d){a=N(8,a,d,b);b=0===(b&1)?bc:fc;a.elementType=b;a.type=b;a.expirationTime=c;return a}function ff(a,b,c){a=N(6,a,null,b);a.expirationTime=c;return a}
function gf(a,b,c){b=N(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}function hf(a,b){a.didError=!1;var c=a.earliestPendingTime;0===c?a.earliestPendingTime=a.latestPendingTime=b:c<b?a.earliestPendingTime=b:a.latestPendingTime>b&&(a.latestPendingTime=b);jf(b,a)}
function kf(a,b){a.didError=!1;a.latestPingedTime>=b&&(a.latestPingedTime=0);var c=a.earliestPendingTime,d=a.latestPendingTime;c===b?a.earliestPendingTime=d===b?a.latestPendingTime=0:d:d===b&&(a.latestPendingTime=c);c=a.earliestSuspendedTime;d=a.latestSuspendedTime;0===c?a.earliestSuspendedTime=a.latestSuspendedTime=b:c<b?a.earliestSuspendedTime=b:d>b&&(a.latestSuspendedTime=b);jf(b,a)}function lf(a,b){var c=a.earliestPendingTime;a=a.earliestSuspendedTime;c>b&&(b=c);a>b&&(b=a);return b}
function jf(a,b){var c=b.earliestSuspendedTime,d=b.latestSuspendedTime,e=b.earliestPendingTime,f=b.latestPingedTime;e=0!==e?e:f;0===e&&(0===a||d<a)&&(e=d);a=e;0!==a&&c>a&&(a=c);b.nextExpirationTimeToWorkOn=e;b.expirationTime=a}function P(a,b){if(a&&a.defaultProps){b=p({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}
function mf(a){var b=a._result;switch(a._status){case 1:return b;case 2:throw b;case 0:throw b;default:a._status=0;b=a._ctor;b=b();b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)});switch(a._status){case 1:return a._result;case 2:throw a._result;}a._result=b;throw b;}}var nf=(new aa.Component).refs;
function of(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:p({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var xf={isMounted:function(a){return(a=a._reactInternalFiber)?2===kd(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=pf();d=qf(d,a);var e=rf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);sf();tf(a,e);uf(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=pf();d=qf(d,a);var e=rf(d);e.tag=vf;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);sf();tf(a,e);uf(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=pf();c=qf(c,a);var d=rf(c);d.tag=
wf;void 0!==b&&null!==b&&(d.callback=b);sf();tf(a,d);uf(a,c)}};function yf(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!hd(c,d)||!hd(e,f):!0}
function zf(a,b,c){var d=!1,e=Le;var f=b.contextType;"object"===typeof f&&null!==f?f=Af(f):(e=M(b)?Me:K.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Oe(a,e):Le);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=xf;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Bf(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&xf.enqueueReplaceState(b,b.state,null)}
function Cf(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=nf;var f=b.contextType;"object"===typeof f&&null!==f?e.context=Af(f):(f=M(b)?Me:K.current,e.context=Oe(a,f));f=a.updateQueue;null!==f&&(Df(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(of(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&xf.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(Df(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Ef=Array.isArray;
function Ff(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(1!==c.tag?t("309"):void 0,d=c.stateNode);d?void 0:t("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===nf&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?t("284"):void 0;c._owner?void 0:t("290",a)}return a}
function Gf(a,b){"textarea"!==a.type&&t("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function Hf(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=bf(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=ff(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function l(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Ff(a,b,c),d.return=a,d;d=cf(c.type,c.key,c.props,null,a.mode,d);d.ref=Ff(a,b,c);d.return=a;return d}function k(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=gf(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=df(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function q(a,b,c){if("string"===typeof b||"number"===typeof b)return b=ff(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Zb:return c=cf(b.type,b.key,b.props,null,a.mode,c),c.ref=Ff(a,null,b),c.return=a,c;case $b:return b=gf(b,a.mode,c),b.return=a,b}if(Ef(b)||
lc(b))return b=df(b,a.mode,c,null),b.return=a,b;Gf(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Zb:return c.key===e?c.type===ac?m(a,b,c.props.children,d,e):l(a,b,c,d):null;case $b:return c.key===e?k(a,b,c,d):null}if(Ef(c)||lc(c))return null!==e?null:m(a,b,c,d,null);Gf(a,c)}return null}function C(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Zb:return a=a.get(null===d.key?c:d.key)||null,d.type===ac?m(b,a,d.props.children,e,d.key):l(b,a,d,e);case $b:return a=a.get(null===d.key?c:d.key)||null,k(b,a,d,e)}if(Ef(d)||lc(d))return a=a.get(c)||null,m(b,a,d,e,null);Gf(b,d)}return null}function w(e,g,h,k){for(var l=null,m=null,n=g,u=g=0,r=null;null!==n&&u<h.length;u++){n.index>u?(r=n,n=null):r=n.sibling;var v=x(e,n,h[u],k);if(null===v){null===n&&(n=r);break}a&&
n&&null===v.alternate&&b(e,n);g=f(v,g,u);null===m?l=v:m.sibling=v;m=v;n=r}if(u===h.length)return c(e,n),l;if(null===n){for(;u<h.length;u++)if(n=q(e,h[u],k))g=f(n,g,u),null===m?l=n:m.sibling=n,m=n;return l}for(n=d(e,n);u<h.length;u++)if(r=C(n,e,u,h[u],k))a&&null!==r.alternate&&n.delete(null===r.key?u:r.key),g=f(r,g,u),null===m?l=r:m.sibling=r,m=r;a&&n.forEach(function(a){return b(e,a)});return l}function E(e,g,h,k){var l=lc(h);"function"!==typeof l?t("150"):void 0;h=l.call(h);null==h?t("151"):void 0;
for(var m=l=null,n=g,u=g=0,r=null,v=h.next();null!==n&&!v.done;u++,v=h.next()){n.index>u?(r=n,n=null):r=n.sibling;var z=x(e,n,v.value,k);if(null===z){n||(n=r);break}a&&n&&null===z.alternate&&b(e,n);g=f(z,g,u);null===m?l=z:m.sibling=z;m=z;n=r}if(v.done)return c(e,n),l;if(null===n){for(;!v.done;u++,v=h.next())v=q(e,v.value,k),null!==v&&(g=f(v,g,u),null===m?l=v:m.sibling=v,m=v);return l}for(n=d(e,n);!v.done;u++,v=h.next())v=C(n,e,u,v.value,k),null!==v&&(a&&null!==v.alternate&&n.delete(null===v.key?u:
v.key),g=f(v,g,u),null===m?l=v:m.sibling=v,m=v);a&&n.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ac&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Zb:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===ac:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===ac?f.props.children:f.props,h);d.ref=Ff(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=
k.sibling}f.type===ac?(d=df(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=cf(f.type,f.key,f.props,null,a.mode,h),h.ref=Ff(a,d,f),h.return=a,a=h)}return g(a);case $b:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=gf(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=
""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=ff(f,a.mode,h),d.return=a,a=d),g(a);if(Ef(f))return w(a,d,f,h);if(lc(f))return E(a,d,f,h);l&&Gf(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:h=a.type,t("152",h.displayName||h.name||"Component")}return c(a,d)}}var If=Hf(!0),Jf=Hf(!1),Kf={},Lf={current:Kf},Mf={current:Kf},Nf={current:Kf};function Of(a){a===Kf?t("174"):void 0;return a}
function Pf(a,b){J(Nf,b,a);J(Mf,a,a);J(Lf,Kf,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:le(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=le(b,c)}I(Lf,a);J(Lf,b,a)}function Qf(a){I(Lf,a);I(Mf,a);I(Nf,a)}function Rf(a){Of(Nf.current);var b=Of(Lf.current);var c=le(b,a.type);b!==c&&(J(Mf,a,a),J(Lf,c,a))}function Sf(a){Mf.current===a&&(I(Lf,a),I(Mf,a))}
var Tf=0,Uf=2,Vf=4,Wf=8,Xf=16,Yf=32,Zf=64,$f=128,ag=Xb.ReactCurrentDispatcher,bg=0,cg=null,Q=null,dg=null,eg=null,R=null,fg=null,gg=0,hg=null,ig=0,jg=!1,kg=null,lg=0;function mg(){t("307")}function ng(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!fd(a[c],b[c]))return!1;return!0}
function og(a,b,c,d,e,f){bg=f;cg=b;dg=null!==a?a.memoizedState:null;ag.current=null===dg?pg:qg;b=c(d,e);if(jg){do jg=!1,lg+=1,dg=null!==a?a.memoizedState:null,fg=eg,hg=R=Q=null,ag.current=qg,b=c(d,e);while(jg);kg=null;lg=0}ag.current=rg;a=cg;a.memoizedState=eg;a.expirationTime=gg;a.updateQueue=hg;a.effectTag|=ig;a=null!==Q&&null!==Q.next;bg=0;fg=R=eg=dg=Q=cg=null;gg=0;hg=null;ig=0;a?t("300"):void 0;return b}
function sg(){ag.current=rg;bg=0;fg=R=eg=dg=Q=cg=null;gg=0;hg=null;ig=0;jg=!1;kg=null;lg=0}function tg(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===R?eg=R=a:R=R.next=a;return R}function ug(){if(null!==fg)R=fg,fg=R.next,Q=dg,dg=null!==Q?Q.next:null;else{null===dg?t("310"):void 0;Q=dg;var a={memoizedState:Q.memoizedState,baseState:Q.baseState,queue:Q.queue,baseUpdate:Q.baseUpdate,next:null};R=null===R?eg=a:R.next=a;dg=Q.next}return R}
function vg(a,b){return"function"===typeof b?b(a):b}
function wg(a){var b=ug(),c=b.queue;null===c?t("311"):void 0;if(0<lg){var d=c.dispatch;if(null!==kg){var e=kg.get(c);if(void 0!==e){kg.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);fd(f,b.memoizedState)||(xg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==d){var h=e=null,l=d,k=!1;do{var m=l.expirationTime;
m<bg?(k||(k=!0,h=g,e=f),m>gg&&(gg=m)):f=l.eagerReducer===a?l.eagerState:a(f,l.action);g=l;l=l.next}while(null!==l&&l!==d);k||(h=g,e=f);fd(f,b.memoizedState)||(xg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.eagerReducer=a;c.eagerState=f}return[b.memoizedState,c.dispatch]}
function yg(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===hg?(hg={lastEffect:null},hg.lastEffect=a.next=a):(b=hg.lastEffect,null===b?hg.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,hg.lastEffect=a));return a}function zg(a,b,c,d){var e=tg();ig|=a;e.memoizedState=yg(b,c,void 0,void 0===d?null:d)}
function Bg(a,b,c,d){var e=ug();d=void 0===d?null:d;var f=void 0;if(null!==Q){var g=Q.memoizedState;f=g.destroy;if(null!==d&&ng(d,g.deps)){yg(Tf,c,f,d);return}}ig|=a;e.memoizedState=yg(b,c,f,d)}function Cg(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Dg(){}
function Eg(a,b,c){25>lg?void 0:t("301");var d=a.alternate;if(a===cg||null!==d&&d===cg)if(jg=!0,a={expirationTime:bg,action:c,eagerReducer:null,eagerState:null,next:null},null===kg&&(kg=new Map),c=kg.get(b),void 0===c)kg.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{sf();var e=pf();e=qf(e,a);var f={expirationTime:e,action:c,eagerReducer:null,eagerState:null,next:null},g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===
d||0===d.expirationTime)&&(d=b.eagerReducer,null!==d))try{var l=b.eagerState,k=d(l,c);f.eagerReducer=d;f.eagerState=k;if(fd(k,l))return}catch(m){}finally{}uf(a,e)}}
var rg={readContext:Af,useCallback:mg,useContext:mg,useEffect:mg,useImperativeHandle:mg,useLayoutEffect:mg,useMemo:mg,useReducer:mg,useRef:mg,useState:mg,useDebugValue:mg},pg={readContext:Af,useCallback:function(a,b){tg().memoizedState=[a,void 0===b?null:b];return a},useContext:Af,useEffect:function(a,b){return zg(516,$f|Zf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):[a];return zg(4,Vf|Yf,Cg.bind(null,b,a),c)},useLayoutEffect:function(a,b){return zg(4,Vf|Yf,a,b)},
useMemo:function(a,b){var c=tg();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=tg();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,eagerReducer:a,eagerState:b};a=a.dispatch=Eg.bind(null,cg,a);return[d.memoizedState,a]},useRef:function(a){var b=tg();a={current:a};return b.memoizedState=a},useState:function(a){var b=tg();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,dispatch:null,eagerReducer:vg,
eagerState:a};a=a.dispatch=Eg.bind(null,cg,a);return[b.memoizedState,a]},useDebugValue:Dg},qg={readContext:Af,useCallback:function(a,b){var c=ug();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&ng(b,d[1]))return d[0];c.memoizedState=[a,b];return a},useContext:Af,useEffect:function(a,b){return Bg(516,$f|Zf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):[a];return Bg(4,Vf|Yf,Cg.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Bg(4,Vf|Yf,a,b)},
useMemo:function(a,b){var c=ug();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&ng(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:wg,useRef:function(){return ug().memoizedState},useState:function(a){return wg(vg,a)},useDebugValue:Dg},Fg=null,Gg=null,Hg=!1;
function Ig(a,b){var c=N(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function Jg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;default:return!1}}
function Kg(a){if(Hg){var b=Gg;if(b){var c=b;if(!Jg(a,b)){b=He(c);if(!b||!Jg(a,b)){a.effectTag|=2;Hg=!1;Fg=a;return}Ig(Fg,c)}Fg=a;Gg=Ie(b)}else a.effectTag|=2,Hg=!1,Fg=a}}function Lg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag;)a=a.return;Fg=a}function Mg(a){if(a!==Fg)return!1;if(!Hg)return Lg(a),Hg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Be(b,a.memoizedProps))for(b=Gg;b;)Ig(a,b),b=He(b);Lg(a);Gg=Fg?He(a.stateNode):null;return!0}function Ng(){Gg=Fg=null;Hg=!1}
var Og=Xb.ReactCurrentOwner,xg=!1;function S(a,b,c,d){b.child=null===a?Jf(b,null,c,d):If(b,a.child,c,d)}function Pg(a,b,c,d,e){c=c.render;var f=b.ref;Qg(b,e);d=og(a,b,c,d,f,e);if(null!==a&&!xg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Rg(a,b,e);b.effectTag|=1;S(a,b,d,e);return b.child}
function Sg(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!$e(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,Tg(a,b,g,d,e,f);a=cf(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:hd,c(e,d)&&a.ref===b.ref))return Rg(a,b,f);b.effectTag|=1;a=bf(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function Tg(a,b,c,d,e,f){return null!==a&&hd(a.memoizedProps,d)&&a.ref===b.ref&&(xg=!1,e<f)?Rg(a,b,f):Ug(a,b,c,d,f)}function Vg(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Ug(a,b,c,d,e){var f=M(c)?Me:K.current;f=Oe(b,f);Qg(b,e);c=og(a,b,c,d,f,e);if(null!==a&&!xg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Rg(a,b,e);b.effectTag|=1;S(a,b,c,e);return b.child}
function Wg(a,b,c,d,e){if(M(c)){var f=!0;Te(b)}else f=!1;Qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),zf(b,c,d,e),Cf(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var l=g.context,k=c.contextType;"object"===typeof k&&null!==k?k=Af(k):(k=M(c)?Me:K.current,k=Oe(b,k));var m=c.getDerivedStateFromProps,q="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;q||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&Bf(b,g,d,k);Xg=!1;var x=b.memoizedState;l=g.state=x;var C=b.updateQueue;null!==C&&(Df(b,C,d,g,e),l=b.memoizedState);h!==d||x!==l||L.current||Xg?("function"===typeof m&&(of(b,c,m,d),l=b.memoizedState),(h=Xg||yf(b,c,h,d,x,l,k))?(q||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=l),g.props=d,g.state=l,g.context=k,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:P(b.type,h),l=g.context,k=c.contextType,"object"===typeof k&&null!==k?k=Af(k):(k=M(c)?Me:K.current,k=Oe(b,k)),m=c.getDerivedStateFromProps,(q="function"===
typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&Bf(b,g,d,k),Xg=!1,l=b.memoizedState,x=g.state=l,C=b.updateQueue,null!==C&&(Df(b,C,d,g,e),x=b.memoizedState),h!==d||l!==x||L.current||Xg?("function"===typeof m&&(of(b,c,m,d),x=b.memoizedState),(m=Xg||yf(b,c,h,d,l,x,k))?(q||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===
typeof g.componentWillUpdate&&g.componentWillUpdate(d,x,k),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,k)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=
x),g.props=d,g.state=x,g.context=k,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),d=!1);return Yg(a,b,c,d,f,e)}
function Yg(a,b,c,d,e,f){Vg(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Ue(b,c,!1),Rg(a,b,f);d=b.stateNode;Og.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=If(b,a.child,null,f),b.child=If(b,null,h,f)):S(a,b,h,f);b.memoizedState=d.state;e&&Ue(b,c,!0);return b.child}function Zg(a){var b=a.stateNode;b.pendingContext?Re(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Re(a,b.context,!1);Pf(a,b.containerInfo)}
function $g(a,b,c){var d=b.mode,e=b.pendingProps,f=b.memoizedState;if(0===(b.effectTag&64)){f=null;var g=!1}else f={timedOutAt:null!==f?f.timedOutAt:0},g=!0,b.effectTag&=-65;if(null===a)if(g){var h=e.fallback;a=df(null,d,0,null);0===(b.mode&1)&&(a.child=null!==b.memoizedState?b.child.child:b.child);d=df(h,d,c,null);a.sibling=d;c=a;c.return=d.return=b}else c=d=Jf(b,null,e.children,c);else null!==a.memoizedState?(d=a.child,h=d.sibling,g?(c=e.fallback,e=bf(d,d.pendingProps,0),0===(b.mode&1)&&(g=null!==
b.memoizedState?b.child.child:b.child,g!==d.child&&(e.child=g)),d=e.sibling=bf(h,c,h.expirationTime),c=e,e.childExpirationTime=0,c.return=d.return=b):c=d=If(b,d.child,e.children,c)):(h=a.child,g?(g=e.fallback,e=df(null,d,0,null),e.child=h,0===(b.mode&1)&&(e.child=null!==b.memoizedState?b.child.child:b.child),d=e.sibling=df(g,d,c,null),d.effectTag|=2,c=e,e.childExpirationTime=0,c.return=d.return=b):d=c=If(b,h,e.children,c)),b.stateNode=a.stateNode;b.memoizedState=f;b.child=c;return d}
function Rg(a,b,c){null!==a&&(b.contextDependencies=a.contextDependencies);if(b.childExpirationTime<c)return null;null!==a&&b.child!==a.child?t("153"):void 0;if(null!==b.child){a=b.child;c=bf(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=bf(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function ah(a,b,c){var d=b.expirationTime;if(null!==a)if(a.memoizedProps!==b.pendingProps||L.current)xg=!0;else{if(d<c){xg=!1;switch(b.tag){case 3:Zg(b);Ng();break;case 5:Rf(b);break;case 1:M(b.type)&&Te(b);break;case 4:Pf(b,b.stateNode.containerInfo);break;case 10:bh(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return $g(a,b,c);b=Rg(a,b,c);return null!==b?b.sibling:null}}return Rg(a,b,c)}}else xg=!1;b.expirationTime=0;switch(b.tag){case 2:d=
b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;var e=Oe(b,K.current);Qg(b,c);e=og(null,b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;sg();if(M(d)){var f=!0;Te(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&of(b,d,g,a);e.updater=xf;b.stateNode=e;e._reactInternalFiber=b;Cf(b,d,a,c);b=Yg(null,b,d,!0,f,
c)}else b.tag=0,S(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);f=b.pendingProps;a=mf(e);b.type=a;e=b.tag=af(a);f=P(a,f);g=void 0;switch(e){case 0:g=Ug(null,b,a,f,c);break;case 1:g=Wg(null,b,a,f,c);break;case 11:g=Pg(null,b,a,f,c);break;case 14:g=Sg(null,b,a,P(a.type,f),d,c);break;default:t("306",a,"")}return g;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:P(d,e),Ug(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,
e=b.elementType===d?e:P(d,e),Wg(a,b,d,e,c);case 3:Zg(b);d=b.updateQueue;null===d?t("282"):void 0;e=b.memoizedState;e=null!==e?e.element:null;Df(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)Ng(),b=Rg(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)Gg=Ie(b.stateNode.containerInfo),Fg=b,e=Hg=!0;e?(b.effectTag|=2,b.child=Jf(b,null,d,c)):(S(a,b,d,c),Ng());b=b.child}return b;case 5:return Rf(b),null===a&&Kg(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,
g=e.children,Be(d,e)?g=null:null!==f&&Be(d,f)&&(b.effectTag|=16),Vg(a,b),1!==c&&b.mode&1&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(S(a,b,g,c),b=b.child),b;case 6:return null===a&&Kg(b),null;case 13:return $g(a,b,c);case 4:return Pf(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=If(b,null,d,c):S(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:P(d,e),Pg(a,b,d,e,c);case 7:return S(a,b,b.pendingProps,c),b.child;case 8:return S(a,b,b.pendingProps.children,
c),b.child;case 12:return S(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;bh(b,f);if(null!==g){var h=g.value;f=fd(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!L.current){b=Rg(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var l=h.contextDependencies;if(null!==l){g=h.child;for(var k=l.first;null!==k;){if(k.context===d&&0!==
(k.observedBits&f)){1===h.tag&&(k=rf(c),k.tag=wf,tf(h,k));h.expirationTime<c&&(h.expirationTime=c);k=h.alternate;null!==k&&k.expirationTime<c&&(k.expirationTime=c);for(var m=h.return;null!==m;){k=m.alternate;if(m.childExpirationTime<c)m.childExpirationTime=c,null!==k&&k.childExpirationTime<c&&(k.childExpirationTime=c);else if(null!==k&&k.childExpirationTime<c)k.childExpirationTime=c;else break;m=m.return}l.expirationTime<c&&(l.expirationTime=c);break}k=k.next}}else g=10===h.tag?h.type===b.type?null:
h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}S(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,Qg(b,c),e=Af(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,S(a,b,d,c),b.child;case 14:return e=b.type,f=P(e,b.pendingProps),f=P(e.type,f),Sg(a,b,e,f,d,c);case 15:return Tg(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===
d?e:P(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,M(d)?(a=!0,Te(b)):a=!1,Qg(b,c),zf(b,d,e,c),Cf(b,d,e,c),Yg(null,b,d,!0,a,c);default:t("156")}}var ch={current:null},dh=null,eh=null,fh=null;function bh(a,b){var c=a.type._context;J(ch,c._currentValue,a);c._currentValue=b}function gh(a){var b=ch.current;I(ch,a);a.type._context._currentValue=b}function Qg(a,b){dh=a;fh=eh=null;var c=a.contextDependencies;null!==c&&c.expirationTime>=b&&(xg=!0);a.contextDependencies=null}
function Af(a,b){if(fh!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)fh=a,b=1073741823;b={context:a,observedBits:b,next:null};null===eh?(null===dh?t("308"):void 0,eh=b,dh.contextDependencies={first:b,expirationTime:0}):eh=eh.next=b}return a._currentValue}var hh=0,vf=1,wf=2,ih=3,Xg=!1;function jh(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function kh(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function rf(a){return{expirationTime:a,tag:hh,payload:null,callback:null,next:null,nextEffect:null}}function lh(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function tf(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=jh(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=jh(a.memoizedState),e=c.updateQueue=jh(c.memoizedState)):d=a.updateQueue=kh(e):null===e&&(e=c.updateQueue=kh(d));null===e||d===e?lh(d,b):null===d.lastUpdate||null===e.lastUpdate?(lh(d,b),lh(e,b)):(lh(d,b),e.lastUpdate=b)}
function mh(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=jh(a.memoizedState):nh(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function nh(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=kh(b));return b}
function oh(a,b,c,d,e,f){switch(c.tag){case vf:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case ih:a.effectTag=a.effectTag&-2049|64;case hh:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return p({},d,e);case wf:Xg=!0}return d}
function Df(a,b,c,d,e){Xg=!1;b=nh(a,b);for(var f=b.baseState,g=null,h=0,l=b.firstUpdate,k=f;null!==l;){var m=l.expirationTime;m<e?(null===g&&(g=l,f=k),h<m&&(h=m)):(k=oh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=32,l.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=l:(b.lastEffect.nextEffect=l,b.lastEffect=l)));l=l.next}m=null;for(l=b.firstCapturedUpdate;null!==l;){var q=l.expirationTime;q<e?(null===m&&(m=l,null===g&&(f=k)),h<q&&(h=q)):(k=oh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=
32,l.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=l:(b.lastCapturedEffect.nextEffect=l,b.lastCapturedEffect=l)));l=l.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=k);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;a.expirationTime=h;a.memoizedState=k}
function ph(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);qh(b.firstEffect,c);b.firstEffect=b.lastEffect=null;qh(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function qh(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;"function"!==typeof c?t("191",c):void 0;c.call(d)}a=a.nextEffect}}
function rh(a,b){return{value:a,source:b,stack:nc(b)}}function sh(a){a.effectTag|=4}var wh=void 0,xh=void 0,yh=void 0,zh=void 0;wh=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};xh=function(){};
yh=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;Of(Lf.current);a=null;switch(c){case "input":f=zc(g,f);d=zc(g,d);a=[];break;case "option":f=de(g,f);d=de(g,d);a=[];break;case "select":f=p({},f,{value:void 0});d=p({},d,{value:void 0});a=[];break;case "textarea":f=fe(g,f);d=fe(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=xe)}ue(c,d);g=c=void 0;var h=null;for(c in f)if(!d.hasOwnProperty(c)&&f.hasOwnProperty(c)&&null!=f[c])if("style"===
c){var l=f[c];for(g in l)l.hasOwnProperty(g)&&(h||(h={}),h[g]="")}else"dangerouslySetInnerHTML"!==c&&"children"!==c&&"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(ta.hasOwnProperty(c)?a||(a=[]):(a=a||[]).push(c,null));for(c in d){var k=d[c];l=null!=f?f[c]:void 0;if(d.hasOwnProperty(c)&&k!==l&&(null!=k||null!=l))if("style"===c)if(l){for(g in l)!l.hasOwnProperty(g)||k&&k.hasOwnProperty(g)||(h||(h={}),h[g]="");for(g in k)k.hasOwnProperty(g)&&l[g]!==k[g]&&(h||
(h={}),h[g]=k[g])}else h||(a||(a=[]),a.push(c,h)),h=k;else"dangerouslySetInnerHTML"===c?(k=k?k.__html:void 0,l=l?l.__html:void 0,null!=k&&l!==k&&(a=a||[]).push(c,""+k)):"children"===c?l===k||"string"!==typeof k&&"number"!==typeof k||(a=a||[]).push(c,""+k):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&(ta.hasOwnProperty(c)?(null!=k&&we(e,c),a||l===k||(a=[])):(a=a||[]).push(c,k))}h&&(a=a||[]).push("style",h);e=a;(b.updateQueue=e)&&sh(b)}};zh=function(a,b,c,d){c!==d&&sh(b)};
var Ah="function"===typeof WeakSet?WeakSet:Set;function Bh(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=nc(c));null!==c&&mc(c.type);b=b.value;null!==a&&1===a.tag&&mc(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Ch(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Dh(a,c)}else b.current=null}
function Eh(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if((d.tag&a)!==Tf){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}(d.tag&b)!==Tf&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
function Fh(a,b){for(var c=a;;){if(5===c.tag){var d=c.stateNode;if(b)d.style.display="none";else{d=c.stateNode;var e=c.memoizedProps.style;e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null;d.style.display=re("display",e)}}else if(6===c.tag)c.stateNode.nodeValue=b?"":c.memoizedProps;else if(13===c.tag&&null!==c.memoizedState){d=c.child.sibling;d.return=c;c=d;continue}else if(null!==c.child){c.child.return=c;c=c.child;continue}if(c===a)break;for(;null===c.sibling;){if(null===c.return||
c.return===a)return;c=c.return}c.sibling.return=c.return;c=c.sibling}}
function Gh(a){"function"===typeof We&&We(a);switch(a.tag){case 0:case 11:case 14:case 15:var b=a.updateQueue;if(null!==b&&(b=b.lastEffect,null!==b)){var c=b=b.next;do{var d=c.destroy;if(void 0!==d){var e=a;try{d()}catch(f){Dh(e,f)}}c=c.next}while(c!==b)}break;case 1:Ch(a);b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(f){Dh(a,f)}break;case 5:Ch(a);break;case 4:Hh(a)}}
function Ih(a){return 5===a.tag||3===a.tag||4===a.tag}
function Jh(a){a:{for(var b=a.return;null!==b;){if(Ih(b)){var c=b;break a}b=b.return}t("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:t("161")}c.effectTag&16&&(oe(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Ih(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(g=b,h=e.stateNode,8===g.nodeType?(f=g.parentNode,f.insertBefore(h,g)):(f=g,f.appendChild(h)),g=g._reactRootContainer,null!==g&&void 0!==g||null!==f.onclick||(f.onclick=xe)):b.appendChild(e.stateNode);
else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function Hh(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?t("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(Gh(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag?(d=b.stateNode.containerInfo,e=!0):Gh(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function Kh(a,b){switch(b.tag){case 0:case 11:case 14:case 15:Eh(Vf,Wf,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&Ge(c,f,e,a,d,b)}break;case 6:null===b.stateNode?t("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 12:break;case 13:c=b.memoizedState;d=void 0;a=b;null===c?d=!1:(d=!0,a=b.child,0===c.timedOutAt&&(c.timedOutAt=pf()));null!==a&&Fh(a,d);c=
b.updateQueue;if(null!==c){b.updateQueue=null;var g=b.stateNode;null===g&&(g=b.stateNode=new Ah);c.forEach(function(a){var c=Lh.bind(null,b,a);g.has(a)||(g.add(a),a.then(c,c))})}break;case 17:break;default:t("163")}}var Mh="function"===typeof WeakMap?WeakMap:Map;function Nh(a,b,c){c=rf(c);c.tag=ih;c.payload={element:null};var d=b.value;c.callback=function(){Oh(d);Bh(a,b)};return c}
function Ph(a,b,c){c=rf(c);c.tag=ih;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Qh?Qh=new Set([this]):Qh.add(this));var c=b.value,e=b.stack;Bh(a,b);this.componentDidCatch(c,{componentStack:null!==e?e:""})});return c}
function Rh(a){switch(a.tag){case 1:M(a.type)&&Pe(a);var b=a.effectTag;return b&2048?(a.effectTag=b&-2049|64,a):null;case 3:return Qf(a),Qe(a),b=a.effectTag,0!==(b&64)?t("285"):void 0,a.effectTag=b&-2049|64,a;case 5:return Sf(a),null;case 13:return b=a.effectTag,b&2048?(a.effectTag=b&-2049|64,a):null;case 4:return Qf(a),null;case 10:return gh(a),null;default:return null}}
var Sh=Xb.ReactCurrentDispatcher,Th=Xb.ReactCurrentOwner,Uh=1073741822,Vh=0,Wh=!1,T=null,Xh=null,U=0,Yh=-1,Zh=!1,V=null,$h=!1,ai=null,bi=null,ci=null,Qh=null;function di(){if(null!==T)for(var a=T.return;null!==a;){var b=a;switch(b.tag){case 1:var c=b.type.childContextTypes;null!==c&&void 0!==c&&Pe(b);break;case 3:Qf(b);Qe(b);break;case 5:Sf(b);break;case 4:Qf(b);break;case 10:gh(b)}a=a.return}Xh=null;U=0;Yh=-1;Zh=!1;T=null}
function ei(a,b){ci=bi=ai=null;var c=W;W=!0;do{if(b.effectTag&512){var d=!1,e=void 0;try{var f=b;Eh($f,Tf,f);Eh(Tf,Zf,f)}catch(g){d=!0,e=g}d&&Dh(b,e)}b=b.nextEffect}while(null!==b);W=c;c=a.expirationTime;0!==c&&fi(a,c)}function sf(){null!==bi&&Fe(bi);null!==ci&&ci()}
function gi(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&1024)){T=a;a:{var e=b;b=a;var f=U;var g=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:M(b.type)&&Pe(b);break;case 3:Qf(b);Qe(b);g=b.stateNode;g.pendingContext&&(g.context=g.pendingContext,g.pendingContext=null);if(null===e||null===e.child)Mg(b),b.effectTag&=-3;xh(b);break;case 5:Sf(b);var h=Of(Nf.current);f=b.type;if(null!==e&&null!=b.stateNode)yh(e,b,f,g,h),e.ref!==b.ref&&(b.effectTag|=
128);else if(g){var l=Of(Lf.current);if(Mg(b)){g=b;e=g.stateNode;var k=g.type,m=g.memoizedProps,q=h;e[Ha]=g;e[Ia]=m;f=void 0;h=k;switch(h){case "iframe":case "object":H("load",e);break;case "video":case "audio":for(k=0;k<cb.length;k++)H(cb[k],e);break;case "source":H("error",e);break;case "img":case "image":case "link":H("error",e);H("load",e);break;case "form":H("reset",e);H("submit",e);break;case "details":H("toggle",e);break;case "input":Ac(e,m);H("invalid",e);we(q,"onChange");break;case "select":e._wrapperState=
{wasMultiple:!!m.multiple};H("invalid",e);we(q,"onChange");break;case "textarea":ge(e,m),H("invalid",e),we(q,"onChange")}ue(h,m);k=null;for(f in m)m.hasOwnProperty(f)&&(l=m[f],"children"===f?"string"===typeof l?e.textContent!==l&&(k=["children",l]):"number"===typeof l&&e.textContent!==""+l&&(k=["children",""+l]):ta.hasOwnProperty(f)&&null!=l&&we(q,f));switch(h){case "input":Vb(e);Ec(e,m,!0);break;case "textarea":Vb(e);ie(e,m);break;case "select":case "option":break;default:"function"===typeof m.onClick&&
(e.onclick=xe)}f=k;g.updateQueue=f;g=null!==f?!0:!1;g&&sh(b)}else{m=b;e=f;q=g;k=9===h.nodeType?h:h.ownerDocument;l===je.html&&(l=ke(e));l===je.html?"script"===e?(e=k.createElement("div"),e.innerHTML="<script>\x3c/script>",k=e.removeChild(e.firstChild)):"string"===typeof q.is?k=k.createElement(e,{is:q.is}):(k=k.createElement(e),"select"===e&&q.multiple&&(k.multiple=!0)):k=k.createElementNS(l,e);e=k;e[Ha]=m;e[Ia]=g;wh(e,b,!1,!1);q=e;k=f;m=g;var x=h,C=ve(k,m);switch(k){case "iframe":case "object":H("load",
q);h=m;break;case "video":case "audio":for(h=0;h<cb.length;h++)H(cb[h],q);h=m;break;case "source":H("error",q);h=m;break;case "img":case "image":case "link":H("error",q);H("load",q);h=m;break;case "form":H("reset",q);H("submit",q);h=m;break;case "details":H("toggle",q);h=m;break;case "input":Ac(q,m);h=zc(q,m);H("invalid",q);we(x,"onChange");break;case "option":h=de(q,m);break;case "select":q._wrapperState={wasMultiple:!!m.multiple};h=p({},m,{value:void 0});H("invalid",q);we(x,"onChange");break;case "textarea":ge(q,
m);h=fe(q,m);H("invalid",q);we(x,"onChange");break;default:h=m}ue(k,h);l=void 0;var w=k,E=q,v=h;for(l in v)if(v.hasOwnProperty(l)){var n=v[l];"style"===l?se(E,n):"dangerouslySetInnerHTML"===l?(n=n?n.__html:void 0,null!=n&&ne(E,n)):"children"===l?"string"===typeof n?("textarea"!==w||""!==n)&&oe(E,n):"number"===typeof n&&oe(E,""+n):"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&"autoFocus"!==l&&(ta.hasOwnProperty(l)?null!=n&&we(x,l):null!=n&&xc(E,l,n,C))}switch(k){case "input":Vb(q);
Ec(q,m,!1);break;case "textarea":Vb(q);ie(q,m);break;case "option":null!=m.value&&q.setAttribute("value",""+yc(m.value));break;case "select":h=q;h.multiple=!!m.multiple;q=m.value;null!=q?ee(h,!!m.multiple,q,!1):null!=m.defaultValue&&ee(h,!!m.multiple,m.defaultValue,!0);break;default:"function"===typeof h.onClick&&(q.onclick=xe)}(g=Ae(f,g))&&sh(b);b.stateNode=e}null!==b.ref&&(b.effectTag|=128)}else null===b.stateNode?t("166"):void 0;break;case 6:e&&null!=b.stateNode?zh(e,b,e.memoizedProps,g):("string"!==
typeof g&&(null===b.stateNode?t("166"):void 0),e=Of(Nf.current),Of(Lf.current),Mg(b)?(g=b,f=g.stateNode,e=g.memoizedProps,f[Ha]=g,(g=f.nodeValue!==e)&&sh(b)):(f=b,g=(9===e.nodeType?e:e.ownerDocument).createTextNode(g),g[Ha]=b,f.stateNode=g));break;case 11:break;case 13:g=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=f;T=b;break a}g=null!==g;f=null!==e&&null!==e.memoizedState;null!==e&&!g&&f&&(e=e.child.sibling,null!==e&&(h=b.firstEffect,null!==h?(b.firstEffect=e,e.nextEffect=h):(b.firstEffect=
b.lastEffect=e,e.nextEffect=null),e.effectTag=8));if(g||f)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:Qf(b);xh(b);break;case 10:gh(b);break;case 9:break;case 14:break;case 17:M(b.type)&&Pe(b);break;default:t("156")}T=null}b=a;if(1===U||1!==b.childExpirationTime){g=0;for(f=b.child;null!==f;)e=f.expirationTime,h=f.childExpirationTime,e>g&&(g=e),h>g&&(g=h),f=f.sibling;b.childExpirationTime=g}if(null!==T)return T;null!==c&&0===(c.effectTag&1024)&&(null===c.firstEffect&&(c.firstEffect=
a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a))}else{a=Rh(a,U);if(null!==a)return a.effectTag&=1023,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=1024)}if(null!==d)return d;if(null!==c)a=c;else break}return null}
function hi(a){var b=ah(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=gi(a));Th.current=null;return b}
function ii(a,b){Wh?t("243"):void 0;sf();Wh=!0;var c=Sh.current;Sh.current=rg;var d=a.nextExpirationTimeToWorkOn;if(d!==U||a!==Xh||null===T)di(),Xh=a,U=d,T=bf(Xh.current,null,U),a.pendingCommitExpirationTime=0;var e=!1;do{try{if(b)for(;null!==T&&!ji();)T=hi(T);else for(;null!==T;)T=hi(T)}catch(E){if(fh=eh=dh=null,sg(),null===T)e=!0,Oh(E);else{null===T?t("271"):void 0;var f=T,g=f.return;if(null===g)e=!0,Oh(E);else{a:{var h=a,l=g,k=f,m=E;g=U;k.effectTag|=1024;k.firstEffect=k.lastEffect=null;if(null!==
m&&"object"===typeof m&&"function"===typeof m.then){var q=m;m=l;var x=-1,C=-1;do{if(13===m.tag){var w=m.alternate;if(null!==w&&(w=w.memoizedState,null!==w)){C=10*(1073741822-w.timedOutAt);break}w=m.pendingProps.maxDuration;if("number"===typeof w)if(0>=w)x=0;else if(-1===x||w<x)x=w}m=m.return}while(null!==m);m=l;do{if(w=13===m.tag)w=void 0===m.memoizedProps.fallback?!1:null===m.memoizedState;if(w){l=m.updateQueue;null===l?(l=new Set,l.add(q),m.updateQueue=l):l.add(q);if(0===(m.mode&1)){m.effectTag|=
64;k.effectTag&=-1957;1===k.tag&&(null===k.alternate?k.tag=17:(g=rf(1073741823),g.tag=wf,tf(k,g)));k.expirationTime=1073741823;break a}k=h.pingCache;null===k?(k=h.pingCache=new Mh,l=new Set,k.set(q,l)):(l=k.get(q),void 0===l&&(l=new Set,k.set(q,l)));l.has(g)||(l.add(g),k=ki.bind(null,h,q,g),q.then(k,k));-1===x?h=1073741823:(-1===C&&(C=10*(1073741822-lf(h,g))-5E3),h=C+x);0<=h&&Yh<h&&(Yh=h);m.effectTag|=2048;m.expirationTime=g;break a}m=m.return}while(null!==m);m=Error((mc(k.type)||"A React component")+
" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+nc(k))}Zh=!0;m=rh(m,k);h=l;do{switch(h.tag){case 3:h.effectTag|=2048;h.expirationTime=g;g=Nh(h,m,g);mh(h,g);break a;case 1:if(q=m,x=h.type,C=h.stateNode,0===(h.effectTag&64)&&("function"===typeof x.getDerivedStateFromError||null!==C&&"function"===typeof C.componentDidCatch&&(null===Qh||!Qh.has(C)))){h.effectTag|=2048;
h.expirationTime=g;g=Ph(h,q,g);mh(h,g);break a}}h=h.return}while(null!==h)}T=gi(f);continue}}}break}while(1);Wh=!1;Sh.current=c;fh=eh=dh=null;sg();if(e)Xh=null,a.finishedWork=null;else if(null!==T)a.finishedWork=null;else{c=a.current.alternate;null===c?t("281"):void 0;Xh=null;if(Zh){e=a.latestPendingTime;f=a.latestSuspendedTime;g=a.latestPingedTime;if(0!==e&&e<d||0!==f&&f<d||0!==g&&g<d){kf(a,d);li(a,c,d,a.expirationTime,-1);return}if(!a.didError&&b){a.didError=!0;d=a.nextExpirationTimeToWorkOn=d;
b=a.expirationTime=1073741823;li(a,c,d,b,-1);return}}b&&-1!==Yh?(kf(a,d),b=10*(1073741822-lf(a,d)),b<Yh&&(Yh=b),b=10*(1073741822-pf()),b=Yh-b,li(a,c,d,a.expirationTime,0>b?0:b)):(a.pendingCommitExpirationTime=d,a.finishedWork=c)}}
function Dh(a,b){for(var c=a.return;null!==c;){switch(c.tag){case 1:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Qh||!Qh.has(d))){a=rh(b,a);a=Ph(c,a,1073741823);tf(c,a);uf(c,1073741823);return}break;case 3:a=rh(b,a);a=Nh(c,a,1073741823);tf(c,a);uf(c,1073741823);return}c=c.return}3===a.tag&&(c=rh(b,a),c=Nh(a,c,1073741823),tf(a,c),uf(a,1073741823))}
function qf(a,b){0!==Vh?a=Vh:Wh?a=$h?1073741823:U:b.mode&1?(a=mi?1073741822-10*(((1073741822-a+15)/10|0)+1):1073741822-25*(((1073741822-a+500)/25|0)+1),null!==Xh&&a===U&&--a):a=1073741823;mi&&(0===ni||a<ni)&&(ni=a);return a}
function ki(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);if(null!==Xh&&U===c)Xh=null;else if(b=a.earliestSuspendedTime,d=a.latestSuspendedTime,0!==b&&c<=b&&c>=d){a.didError=!1;b=a.latestPingedTime;if(0===b||b>c)a.latestPingedTime=c;jf(c,a);c=a.expirationTime;0!==c&&fi(a,c)}}function Lh(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=pf();b=qf(b,a);a=oi(a,b);null!==a&&(hf(a,b),b=a.expirationTime,0!==b&&fi(a,b))}
function oi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}return e}
function uf(a,b){a=oi(a,b);null!==a&&(!Wh&&0!==U&&b>U&&di(),hf(a,b),Wh&&!$h&&Xh===a||fi(a,a.expirationTime),pi>qi&&(pi=0,t("185")))}function ri(a,b,c,d,e){var f=Vh;Vh=1073741823;try{return a(b,c,d,e)}finally{Vh=f}}var si=null,X=null,ti=0,ui=void 0,W=!1,vi=null,Y=0,ni=0,wi=!1,xi=null,Z=!1,yi=!1,mi=!1,zi=null,Ai=ba.unstable_now(),Bi=1073741822-(Ai/10|0),Ci=Bi,qi=50,pi=0,Di=null;function Ei(){Bi=1073741822-((ba.unstable_now()-Ai)/10|0)}
function Fi(a,b){if(0!==ti){if(b<ti)return;null!==ui&&ba.unstable_cancelCallback(ui)}ti=b;a=ba.unstable_now()-Ai;ui=ba.unstable_scheduleCallback(Gi,{timeout:10*(1073741822-b)-a})}function li(a,b,c,d,e){a.expirationTime=d;0!==e||ji()?0<e&&(a.timeoutHandle=Ce(Hi.bind(null,a,b,c),e)):(a.pendingCommitExpirationTime=c,a.finishedWork=b)}function Hi(a,b,c){a.pendingCommitExpirationTime=c;a.finishedWork=b;Ei();Ci=Bi;Ii(a,c)}function pf(){if(W)return Ci;Ji();if(0===Y||1===Y)Ei(),Ci=Bi;return Ci}
function fi(a,b){null===a.nextScheduledRoot?(a.expirationTime=b,null===X?(si=X=a,a.nextScheduledRoot=a):(X=X.nextScheduledRoot=a,X.nextScheduledRoot=si)):b>a.expirationTime&&(a.expirationTime=b);W||(Z?yi&&(vi=a,Y=1073741823,Ki(a,1073741823,!1)):1073741823===b?Li(1073741823,!1):Fi(a,b))}
function Ji(){var a=0,b=null;if(null!==X)for(var c=X,d=si;null!==d;){var e=d.expirationTime;if(0===e){null===c||null===X?t("244"):void 0;if(d===d.nextScheduledRoot){si=X=d.nextScheduledRoot=null;break}else if(d===si)si=e=d.nextScheduledRoot,X.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===X){X=c;X.nextScheduledRoot=si;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{e>a&&(a=e,b=d);if(d===X)break;if(1073741823===
a)break;c=d;d=d.nextScheduledRoot}}vi=b;Y=a}var Mi=!1;function ji(){return Mi?!0:ba.unstable_shouldYield()?Mi=!0:!1}function Gi(){try{if(!ji()&&null!==si){Ei();var a=si;do{var b=a.expirationTime;0!==b&&Bi<=b&&(a.nextExpirationTimeToWorkOn=Bi);a=a.nextScheduledRoot}while(a!==si)}Li(0,!0)}finally{Mi=!1}}
function Li(a,b){Ji();if(b)for(Ei(),Ci=Bi;null!==vi&&0!==Y&&a<=Y&&!(Mi&&Bi>Y);)Ki(vi,Y,Bi>Y),Ji(),Ei(),Ci=Bi;else for(;null!==vi&&0!==Y&&a<=Y;)Ki(vi,Y,!1),Ji();b&&(ti=0,ui=null);0!==Y&&Fi(vi,Y);pi=0;Di=null;if(null!==zi)for(a=zi,zi=null,b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){wi||(wi=!0,xi=d)}}if(wi)throw a=xi,xi=null,wi=!1,a;}function Ii(a,b){W?t("253"):void 0;vi=a;Y=b;Ki(a,b,!1);Li(1073741823,!1)}
function Ki(a,b,c){W?t("245"):void 0;W=!0;if(c){var d=a.finishedWork;null!==d?Oi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,De(d)),ii(a,c),d=a.finishedWork,null!==d&&(ji()?a.finishedWork=d:Oi(a,d,b)))}else d=a.finishedWork,null!==d?Oi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,De(d)),ii(a,c),d=a.finishedWork,null!==d&&Oi(a,d,b));W=!1}
function Oi(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime>=c&&(null===zi?zi=[d]:zi.push(d),d._defer)){a.finishedWork=b;a.expirationTime=0;return}a.finishedWork=null;a===Di?pi++:(Di=a,pi=0);$h=Wh=!0;a.current===b?t("177"):void 0;c=a.pendingCommitExpirationTime;0===c?t("261"):void 0;a.pendingCommitExpirationTime=0;d=b.expirationTime;var e=b.childExpirationTime;d=e>d?e:d;a.didError=!1;0===d?(a.earliestPendingTime=0,a.latestPendingTime=0,a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=
0):(d<a.latestPingedTime&&(a.latestPingedTime=0),e=a.latestPendingTime,0!==e&&(e>d?a.earliestPendingTime=a.latestPendingTime=0:a.earliestPendingTime>d&&(a.earliestPendingTime=a.latestPendingTime)),e=a.earliestSuspendedTime,0===e?hf(a,d):d<a.latestSuspendedTime?(a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0,hf(a,d)):d>e&&hf(a,d));jf(0,a);Th.current=null;1<b.effectTag?null!==b.lastEffect?(b.lastEffect.nextEffect=b,d=b.firstEffect):d=b:d=b.firstEffect;ye=Hd;e=Td();if(Ud(e)){if("selectionStart"in
e)var f={start:e.selectionStart,end:e.selectionEnd};else a:{f=(f=e.ownerDocument)&&f.defaultView||window;var g=f.getSelection&&f.getSelection();if(g&&0!==g.rangeCount){f=g.anchorNode;var h=g.anchorOffset,l=g.focusNode;g=g.focusOffset;try{f.nodeType,l.nodeType}catch(ub){f=null;break a}var k=0,m=-1,q=-1,x=0,C=0,w=e,E=null;b:for(;;){for(var v;;){w!==f||0!==h&&3!==w.nodeType||(m=k+h);w!==l||0!==g&&3!==w.nodeType||(q=k+g);3===w.nodeType&&(k+=w.nodeValue.length);if(null===(v=w.firstChild))break;E=w;w=v}for(;;){if(w===
e)break b;E===f&&++x===h&&(m=k);E===l&&++C===g&&(q=k);if(null!==(v=w.nextSibling))break;w=E;E=w.parentNode}w=v}f=-1===m||-1===q?null:{start:m,end:q}}else f=null}f=f||{start:0,end:0}}else f=null;ze={focusedElem:e,selectionRange:f};Hd=!1;for(V=d;null!==V;){e=!1;f=void 0;try{for(;null!==V;){if(V.effectTag&256)a:{var n=V.alternate;h=V;switch(h.tag){case 0:case 11:case 15:Eh(Uf,Tf,h);break a;case 1:if(h.effectTag&256&&null!==n){var u=n.memoizedProps,z=n.memoizedState,Ag=h.stateNode,Ni=Ag.getSnapshotBeforeUpdate(h.elementType===
h.type?u:P(h.type,u),z);Ag.__reactInternalSnapshotBeforeUpdate=Ni}break a;case 3:case 5:case 6:case 4:case 17:break a;default:t("163")}}V=V.nextEffect}}catch(ub){e=!0,f=ub}e&&(null===V?t("178"):void 0,Dh(V,f),null!==V&&(V=V.nextEffect))}for(V=d;null!==V;){n=!1;u=void 0;try{for(;null!==V;){var y=V.effectTag;y&16&&oe(V.stateNode,"");if(y&128){var B=V.alternate;if(null!==B){var r=B.ref;null!==r&&("function"===typeof r?r(null):r.current=null)}}switch(y&14){case 2:Jh(V);V.effectTag&=-3;break;case 6:Jh(V);
V.effectTag&=-3;Kh(V.alternate,V);break;case 4:Kh(V.alternate,V);break;case 8:z=V;Hh(z);z.return=null;z.child=null;z.memoizedState=null;z.updateQueue=null;var O=z.alternate;null!==O&&(O.return=null,O.child=null,O.memoizedState=null,O.updateQueue=null)}V=V.nextEffect}}catch(ub){n=!0,u=ub}n&&(null===V?t("178"):void 0,Dh(V,u),null!==V&&(V=V.nextEffect))}r=ze;B=Td();y=r.focusedElem;n=r.selectionRange;if(B!==y&&y&&y.ownerDocument&&Sd(y.ownerDocument.documentElement,y)){null!==n&&Ud(y)&&(B=n.start,r=n.end,
void 0===r&&(r=B),"selectionStart"in y?(y.selectionStart=B,y.selectionEnd=Math.min(r,y.value.length)):(r=(B=y.ownerDocument||document)&&B.defaultView||window,r.getSelection&&(r=r.getSelection(),u=y.textContent.length,O=Math.min(n.start,u),n=void 0===n.end?O:Math.min(n.end,u),!r.extend&&O>n&&(u=n,n=O,O=u),u=Rd(y,O),z=Rd(y,n),u&&z&&(1!==r.rangeCount||r.anchorNode!==u.node||r.anchorOffset!==u.offset||r.focusNode!==z.node||r.focusOffset!==z.offset)&&(B=B.createRange(),B.setStart(u.node,u.offset),r.removeAllRanges(),
O>n?(r.addRange(B),r.extend(z.node,z.offset)):(B.setEnd(z.node,z.offset),r.addRange(B))))));B=[];for(r=y;r=r.parentNode;)1===r.nodeType&&B.push({element:r,left:r.scrollLeft,top:r.scrollTop});"function"===typeof y.focus&&y.focus();for(y=0;y<B.length;y++)r=B[y],r.element.scrollLeft=r.left,r.element.scrollTop=r.top}ze=null;Hd=!!ye;ye=null;a.current=b;for(V=d;null!==V;){y=!1;B=void 0;try{for(r=a,O=c;null!==V;){var qa=V.effectTag;if(qa&36){var Rb=V.alternate;n=V;u=O;switch(n.tag){case 0:case 11:case 15:Eh(Xf,
Yf,n);break;case 1:var id=n.stateNode;if(n.effectTag&4)if(null===Rb)id.componentDidMount();else{var dj=n.elementType===n.type?Rb.memoizedProps:P(n.type,Rb.memoizedProps);id.componentDidUpdate(dj,Rb.memoizedState,id.__reactInternalSnapshotBeforeUpdate)}var th=n.updateQueue;null!==th&&ph(n,th,id,u);break;case 3:var uh=n.updateQueue;if(null!==uh){z=null;if(null!==n.child)switch(n.child.tag){case 5:z=n.child.stateNode;break;case 1:z=n.child.stateNode}ph(n,uh,z,u)}break;case 5:var ej=n.stateNode;null===
Rb&&n.effectTag&4&&Ae(n.type,n.memoizedProps)&&ej.focus();break;case 6:break;case 4:break;case 12:break;case 13:break;case 17:break;default:t("163")}}if(qa&128){var jd=V.ref;if(null!==jd){var vh=V.stateNode;switch(V.tag){case 5:var Ne=vh;break;default:Ne=vh}"function"===typeof jd?jd(Ne):jd.current=Ne}}qa&512&&(ai=r);V=V.nextEffect}}catch(ub){y=!0,B=ub}y&&(null===V?t("178"):void 0,Dh(V,B),null!==V&&(V=V.nextEffect))}null!==d&&null!==ai&&(qa=ei.bind(null,a,d),bi=Ee(qa),ci=qa);Wh=$h=!1;"function"===
typeof Ve&&Ve(b.stateNode);qa=b.expirationTime;b=b.childExpirationTime;b=b>qa?b:qa;0===b&&(Qh=null);a.expirationTime=b;a.finishedWork=null}function Oh(a){null===vi?t("246"):void 0;vi.expirationTime=0;wi||(wi=!0,xi=a)}function Pi(a,b){var c=Z;Z=!0;try{return a(b)}finally{(Z=c)||W||Li(1073741823,!1)}}function Qi(a,b){if(Z&&!yi){yi=!0;try{return a(b)}finally{yi=!1}}return a(b)}
function Ri(a,b,c){if(mi)return a(b,c);Z||W||0===ni||(Li(ni,!1),ni=0);var d=mi,e=Z;Z=mi=!0;try{return a(b,c)}finally{mi=d,(Z=e)||W||Li(1073741823,!1)}}
function Si(a,b,c,d,e){var f=b.current;a:if(c){c=c._reactInternalFiber;b:{2===kd(c)&&1===c.tag?void 0:t("170");var g=c;do{switch(g.tag){case 3:g=g.stateNode.context;break b;case 1:if(M(g.type)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}}g=g.return}while(null!==g);t("171");g=void 0}if(1===c.tag){var h=c.type;if(M(h)){c=Se(c,h,g);break a}}c=g}else c=Le;null===b.context?b.context=c:b.pendingContext=c;b=e;e=rf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);
sf();tf(f,e);uf(f,d);return d}function Ti(a,b,c,d){var e=b.current,f=pf();e=qf(f,e);return Si(a,b,c,e,d)}function Ui(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function Vi(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$b,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
Db=function(a,b,c){switch(b){case "input":Cc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Ma(d);e?void 0:t("90");Wb(d);Cc(d,e)}}}break;case "textarea":he(a,c);break;case "select":b=c.value,null!=b&&ee(a,!!c.multiple,b,!1)}};
function Wi(a){var b=1073741822-25*(((1073741822-pf()+500)/25|0)+1);b>=Uh&&(b=Uh-1);this._expirationTime=Uh=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}Wi.prototype.render=function(a){this._defer?void 0:t("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new Xi;Si(a,b,null,c,d._onCommit);return d};
Wi.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Wi.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:t("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?t("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;Ii(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};Wi.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function Xi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}Xi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Xi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?t("191",c):void 0;c()}}};
function Yi(a,b,c){b=N(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,pingCache:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,didError:!1,pendingCommitExpirationTime:0,finishedWork:null,timeoutHandle:-1,context:null,pendingContext:null,hydrate:c,nextExpirationTimeToWorkOn:0,expirationTime:0,firstBatch:null,nextScheduledRoot:null};this._internalRoot=b.stateNode=a}
Yi.prototype.render=function(a,b){var c=this._internalRoot,d=new Xi;b=void 0===b?null:b;null!==b&&d.then(b);Ti(a,c,null,d._onCommit);return d};Yi.prototype.unmount=function(a){var b=this._internalRoot,c=new Xi;a=void 0===a?null:a;null!==a&&c.then(a);Ti(null,b,null,c._onCommit);return c};Yi.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new Xi;c=void 0===c?null:c;null!==c&&e.then(c);Ti(b,d,a,e._onCommit);return e};
Yi.prototype.createBatch=function(){var a=new Wi(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime>=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function Zi(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Jb=Pi;Kb=Ri;Lb=function(){W||0===ni||(Li(ni,!1),ni=0)};
function $i(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new Yi(a,!1,b)}
function aj(a,b,c,d,e){var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=Ui(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=$i(c,d);if("function"===typeof e){var h=e;e=function(){var a=Ui(f._internalRoot);h.call(a)}}Qi(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return Ui(f._internalRoot)}
function bj(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Zi(b)?void 0:t("200");return Vi(a,b,null,c)}
var fj={createPortal:bj,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?t("188"):t("268",Object.keys(a)));a=nd(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){Zi(b)?void 0:t("200");return aj(null,a,b,!0,c)},render:function(a,b,c){Zi(b)?void 0:t("200");return aj(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){Zi(c)?void 0:t("200");null==a||void 0===a._reactInternalFiber?
t("38"):void 0;return aj(a,b,c,!1,d)},unmountComponentAtNode:function(a){Zi(a)?void 0:t("40");return a._reactRootContainer?(Qi(function(){aj(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return bj.apply(void 0,arguments)},unstable_batchedUpdates:Pi,unstable_interactiveUpdates:Ri,flushSync:function(a,b){W?t("187"):void 0;var c=Z;Z=!0;try{return ri(a,b)}finally{Z=c,Li(1073741823,!1)}},unstable_createRoot:cj,unstable_flushControlled:function(a){var b=
Z;Z=!0;try{ri(a)}finally{(Z=b)||W||Li(1073741823,!1)}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Ka,La,Ma,Da.injectEventPluginsByName,ra,Sa,function(a){Aa(a,Ra)},Hb,Ib,Jd,Fa]}};function cj(a,b){Zi(a)?void 0:t("299","unstable_createRoot");return new Yi(a,!0,null!=b&&!0===b.hydrate)}
(function(a){var b=a.findFiberByHostInstance;return Ye(p({},a,{overrideProps:null,currentDispatcherRef:Xb.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=nd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))})({findFiberByHostInstance:Ja,bundleType:0,version:"16.8.0",rendererPackageName:"react-dom"});var gj={default:fj},hj=gj&&fj||gj;module.exports=hj.default||hj;


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(825);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** @license React v0.13.6
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var d=null,e=!1,g=3,k=-1,l=-1,m=!1,n=!1;function p(){if(!m){var a=d.expirationTime;n?q():n=!0;r(t,a)}}
function u(){var a=d,b=d.next;if(d===b)d=null;else{var c=d.previous;d=c.next=b;b.previous=c}a.next=a.previous=null;c=a.callback;b=a.expirationTime;a=a.priorityLevel;var f=g,Q=l;g=a;l=b;try{var h=c()}finally{g=f,l=Q}if("function"===typeof h)if(h={callback:h,priorityLevel:a,expirationTime:b,next:null,previous:null},null===d)d=h.next=h.previous=h;else{c=null;a=d;do{if(a.expirationTime>=b){c=a;break}a=a.next}while(a!==d);null===c?c=d:c===d&&(d=h,p());b=c.previous;b.next=c.previous=h;h.next=c;h.previous=
b}}function v(){if(-1===k&&null!==d&&1===d.priorityLevel){m=!0;try{do u();while(null!==d&&1===d.priorityLevel)}finally{m=!1,null!==d?p():n=!1}}}function t(a){m=!0;var b=e;e=a;try{if(a)for(;null!==d;){var c=exports.unstable_now();if(d.expirationTime<=c){do u();while(null!==d&&d.expirationTime<=c)}else break}else if(null!==d){do u();while(null!==d&&!w())}}finally{m=!1,e=b,null!==d?p():n=!1,v()}}
var x=Date,y="function"===typeof setTimeout?setTimeout:void 0,z="function"===typeof clearTimeout?clearTimeout:void 0,A="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,B="function"===typeof cancelAnimationFrame?cancelAnimationFrame:void 0,C,D;function E(a){C=A(function(b){z(D);a(b)});D=y(function(){B(C);a(exports.unstable_now())},100)}
if("object"===typeof performance&&"function"===typeof performance.now){var F=performance;exports.unstable_now=function(){return F.now()}}else exports.unstable_now=function(){return x.now()};var r,q,w,G=null;"undefined"!==typeof window?G=window:"undefined"!==typeof global&&(G=global);
if(G&&G._schedMock){var H=G._schedMock;r=H[0];q=H[1];w=H[2];exports.unstable_now=H[3]}else if("undefined"===typeof window||"function"!==typeof MessageChannel){var I=null,J=function(a){if(null!==I)try{I(a)}finally{I=null}};r=function(a){null!==I?setTimeout(r,0,a):(I=a,setTimeout(J,0,!1))};q=function(){I=null};w=function(){return!1}}else{"undefined"!==typeof console&&("function"!==typeof A&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),
"function"!==typeof B&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));var K=null,L=!1,M=-1,N=!1,O=!1,P=0,R=33,S=33;w=function(){return P<=exports.unstable_now()};var T=new MessageChannel,U=T.port2;T.port1.onmessage=function(){L=!1;var a=K,b=M;K=null;M=-1;var c=exports.unstable_now(),f=!1;if(0>=P-c)if(-1!==b&&b<=c)f=!0;else{N||(N=!0,E(V));K=a;M=b;return}if(null!==a){O=!0;try{a(f)}finally{O=!1}}};
var V=function(a){if(null!==K){E(V);var b=a-P+S;b<S&&R<S?(8>b&&(b=8),S=b<R?R:b):R=b;P=a+S;L||(L=!0,U.postMessage(void 0))}else N=!1};r=function(a,b){K=a;M=b;O||0>b?U.postMessage(void 0):N||(N=!0,E(V))};q=function(){K=null;L=!1;M=-1}}exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;
exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=g,f=k;g=a;k=exports.unstable_now();try{return b()}finally{g=c,k=f,v()}};exports.unstable_next=function(a){switch(g){case 1:case 2:case 3:var b=3;break;default:b=g}var c=g,f=k;g=b;k=exports.unstable_now();try{return a()}finally{g=c,k=f,v()}};
exports.unstable_scheduleCallback=function(a,b){var c=-1!==k?k:exports.unstable_now();if("object"===typeof b&&null!==b&&"number"===typeof b.timeout)b=c+b.timeout;else switch(g){case 1:b=c+-1;break;case 2:b=c+250;break;case 5:b=c+1073741823;break;case 4:b=c+1E4;break;default:b=c+5E3}a={callback:a,priorityLevel:g,expirationTime:b,next:null,previous:null};if(null===d)d=a.next=a.previous=a,p();else{c=null;var f=d;do{if(f.expirationTime>b){c=f;break}f=f.next}while(f!==d);null===c?c=d:c===d&&(d=a,p());
b=c.previous;b.next=c.previous=a;a.next=c;a.previous=b}return a};exports.unstable_cancelCallback=function(a){var b=a.next;if(null!==b){if(b===a)d=null;else{a===d&&(d=b);var c=a.previous;c.next=b;b.previous=c}a.next=a.previous=null}};exports.unstable_wrapCallback=function(a){var b=g;return function(){var c=g,f=k;g=b;k=exports.unstable_now();try{return a.apply(this,arguments)}finally{g=c,k=f,v()}}};exports.unstable_getCurrentPriorityLevel=function(){return g};
exports.unstable_shouldYield=function(){return!e&&(null!==d&&d.expirationTime<l||w())};exports.unstable_continueExecution=function(){null!==d&&p()};exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return d};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _i18next = __webpack_require__(827);

var _i18next2 = _interopRequireDefault(_i18next);

var _reactI18next = __webpack_require__(4);

var _i18nextXhrBackend = __webpack_require__(861);

var _i18nextXhrBackend2 = _interopRequireDefault(_i18nextXhrBackend);

var _i18nextBrowserLanguagedetector = __webpack_require__(866);

var _i18nextBrowserLanguagedetector2 = _interopRequireDefault(_i18nextBrowserLanguagedetector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// not like to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

var Languages = ['it', 'de', 'en'];

_i18next2.default
// load translation using xhr -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
// learn more: https://github.com/i18next/i18next-xhr-backend
.use(_i18nextXhrBackend2.default)
// detect user language
// learn more: https://github.com/i18next/i18next-browser-languageDetector
.use(_i18nextBrowserLanguagedetector2.default)
// pass the i18n instance to react-i18next.
.use(_reactI18next.initReactI18next)
// init i18next
// for all options read: https://www.i18next.com/overview/configuration-options
.init({
  fallbackLng: 'it',
  debug: true,
  whitelist: Languages,
  interpolation: {
    escapeValue: false // not needed for react as it escapes by default
  }
});

exports.default = _i18next2.default;

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(840);











var consoleLogger = {
  type: 'logger',
  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    var _console;

    /* eslint no-console: 0 */
    if (console && console[type]) (_console = console)[type].apply(_console, __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */](args));
  }
};

var Logger =
/*#__PURE__*/
function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */](this, Logger);

    this.init(concreteLogger, options);
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */](Logger, [{
    key: "init",
    value: function init(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.prefix = options.prefix || 'i18next:';
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.forward(args, 'log', '', true);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.forward(args, 'warn', '', true);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.forward(args, 'error', '');
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create(moduleName) {
      return new Logger(this.logger, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */]({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }, this.options));
    }
  }]);

  return Logger;
}();

var baseLogger = new Logger();

var EventEmitter =
/*#__PURE__*/
function () {
  function EventEmitter() {
    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */](this, EventEmitter);

    this.observers = {};
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */](EventEmitter, [{
    key: "on",
    value: function on(events, listener) {
      var _this = this;

      events.split(' ').forEach(function (event) {
        _this.observers[event] = _this.observers[event] || [];

        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      if (!this.observers[event]) return;

      if (!listener) {
        delete this.observers[event];
        return;
      }

      this.observers[event] = this.observers[event].filter(function (l) {
        return l !== listener;
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function (observer) {
          observer.apply(void 0, args);
        });
      }

      if (this.observers['*']) {
        var _cloned = [].concat(this.observers['*']);

        _cloned.forEach(function (observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);

  return EventEmitter;
}();

// http://lea.verou.me/2016/12/resolve-promises-externally-with-this-one-weird-trick/
function defer() {
  var res;
  var rej;
  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  /* eslint prefer-template: 0 */

  return '' + object;
}
function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');

  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();
    object = object[key];
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
  var value = getPath(data, key);

  if (value !== undefined) {
    return value;
  } // Fallback to default values


  return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
  /* eslint no-restricted-syntax: 0 */
  for (var prop in source) {
    if (prop in target) {
      // If we reached a leaf string in target or source then replace with source or skip depending on the 'overwrite' switch
      if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
        if (overwrite) target[prop] = source[prop];
      } else {
        deepExtend(target[prop], source[prop], overwrite);
      }
    } else {
      target[prop] = source[prop];
    }
  }

  return target;
}
function regexEscape(str) {
  /* eslint no-useless-escape: 0 */
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
/* eslint-disable */

var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
/* eslint-enable */

function escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}

var ResourceStore =
/*#__PURE__*/
function (_EventEmitter) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__["a" /* default */](ResourceStore, _EventEmitter);

  function ResourceStore(data) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */](this, ResourceStore);

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */](this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */](ResourceStore).call(this));
    EventEmitter.call(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */](_this)); // <=IE10 fix (unable to call parent constructor)

    _this.data = data || {};
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */](ResourceStore, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index = this.options.ns.indexOf(ns);

      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var path = [lng, ns];
      if (key && typeof key !== 'string') path = path.concat(key);
      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
      }

      return getPath(this.data, path);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        silent: false
      };
      var keySeparator = this.options.keySeparator;
      if (keySeparator === undefined) keySeparator = '.';
      var path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        value = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      setPath(this.data, path, value);
      if (!options.silent) this.emit('added', lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        silent: false
      };

      /* eslint no-restricted-syntax: 0 */
      for (var m in resources) {
        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }

      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
        silent: false
      };
      var path = [lng, ns];

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        deep = resources;
        resources = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      var pack = getPath(this.data, path) || {};

      if (deep) {
        deepExtend(pack, resources, overwrite);
      } else {
        pack = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */]({}, pack, resources);
      }

      setPath(this.data, path, pack);
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }

      this.removeNamespaces(ns);
      this.emit('removed', lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== undefined;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS; // COMPATIBILITY: remove extend in v2.1.0

      if (this.options.compatibilityAPI === 'v1') return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */]({}, {}, this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);

  return ResourceStore;
}(EventEmitter);

var postProcessor = {
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};

var checkedLoadedFor = {};

var Translator =
/*#__PURE__*/
function (_EventEmitter) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__["a" /* default */](Translator, _EventEmitter);

  function Translator(services) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */](this, Translator);

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */](this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */](Translator).call(this));
    EventEmitter.call(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */](_this)); // <=IE10 fix (unable to call parent constructor)

    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */](_this));
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    _this.logger = baseLogger.create('translator');
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */](Translator, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng) this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== undefined;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator || this.options.nsSeparator;
      if (nsSeparator === undefined) nsSeparator = ':';
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS;

      if (nsSeparator && key.indexOf(nsSeparator) > -1) {
        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }

      if (typeof namespaces === 'string') namespaces = [namespaces];
      return {
        key: key,
        namespaces: namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate(keys, options) {
      var _this2 = this;

      if (__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */](options) !== 'object' && this.options.overloadTranslationOptionHandler) {
        /* eslint prefer-rest-params: 0 */
        options = this.options.overloadTranslationOptionHandler(arguments);
      }

      if (!options) options = {}; // non valid keys handling

      if (keys === undefined || keys === null
      /* || keys === ''*/
      ) return '';
      if (!Array.isArray(keys)) keys = [String(keys)]; // separators

      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator; // get namespace(s)

      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
          key = _this$extractFromKey.key,
          namespaces = _this$extractFromKey.namespaces;

      var namespace = namespaces[namespaces.length - 1]; // return key on CIMode

      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;

      if (lng && lng.toLowerCase() === 'cimode') {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;
          return namespace + nsSeparator + key;
        }

        return key;
      } // resolve from store


      var resolved = this.resolve(keys, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays; // object

      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';

      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
        if (!options.returnObjects && !this.options.returnObjects) {
          this.logger.warn('accessing an object - but returnObjects options is not enabled!');
          return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, options) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
        } // if we got a separator we loop over children - else we just return object as is
        // as having it set to false means no hierarchy so no lookup for nested values


        if (keySeparator) {
          var resTypeIsArray = resType === '[object Array]';
          var copy$$1 = resTypeIsArray ? [] : {}; // apply child translation on a copy

          /* eslint no-restricted-syntax: 0 */

          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;

          for (var m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
              copy$$1[m] = this.translate(deepKey, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */]({}, options, {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy$$1[m] === deepKey) copy$$1[m] = res[m]; // if nothing found use orginal value as fallback
            }
          }

          res = copy$$1;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
        // array special treatment
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options);
      } else {
        // string, empty or null
        var usedDefault = false;
        var usedKey = false; // fallback value

        if (!this.isValidLookup(res) && options.defaultValue !== undefined) {
          usedDefault = true;

          if (options.count !== undefined) {
            var suffix = this.pluralResolver.getSuffix(lng, options.count);
            res = options["defaultValue".concat(suffix)];
          }

          if (!res) res = options.defaultValue;
        }

        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        } // save missing


        var updateMissing = options.defaultValue && options.defaultValue !== res && this.options.updateMissing;

        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? options.defaultValue : res);
          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);

          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
            for (var i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === 'all') {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }

          var send = function send(l, k) {
            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
            }

            _this2.emit('missingKey', l, namespace, k, res);
          };

          if (this.options.saveMissing) {
            var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';

            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function (l) {
                var plurals = _this2.pluralResolver.getPluralFormsOfKey(l, key);

                plurals.forEach(function (p) {
                  return send([l], p);
                });
              });
            } else {
              send(lngs, key);
            }
          }
        } // extend


        res = this.extendTranslation(res, keys, options, resolved); // append namespace if still key

        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key); // parseMissingKeyHandler

        if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
      } // return


      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved) {
      var _this3 = this;

      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, options, resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved: resolved
        });
      } else if (!options.skipInterpolation) {
        // i18next.parsing
        if (options.interpolation) this.interpolator.init(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */]({}, options, {
          interpolation: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */]({}, this.options.interpolation, options.interpolation)
        })); // interpolate

        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */]({}, this.options.interpolation.defaultVariables, data);
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options); // nesting

        if (options.nest !== false) res = this.interpolator.nest(res, function () {
          return _this3.translate.apply(_this3, arguments);
        }, options);
        if (options.interpolation) this.interpolator.reset();
      } // post process


      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */]({
          i18nResolved: resolved
        }, options) : options, this);
      }

      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this4 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var found;
      var usedKey; // plain key

      var exactUsedKey; // key with context / plural

      var usedLng;
      var usedNS;
      if (typeof keys === 'string') keys = [keys]; // forEach possible key

      keys.forEach(function (k) {
        if (_this4.isValidLookup(found)) return;

        var extracted = _this4.extractFromKey(k, options);

        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function (ns) {
          if (_this4.isValidLookup(found)) return;
          usedNS = ns;

          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;

            _this4.logger.warn("key \"".concat(usedKey, "\" for namespace \"").concat(usedNS, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace was not yet loaded"), 'This means something IS WRONG in your application setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
          }

          codes.forEach(function (code) {
            if (_this4.isValidLookup(found)) return;
            usedLng = code;
            var finalKey = key;
            var finalKeys = [finalKey];

            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count); // fallback for plural if context not found

              if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix); // get key for context if needed

              if (needsContextHandling) finalKeys.push(finalKey += "".concat(_this4.options.contextSeparator).concat(options.context)); // get key for plural if needed

              if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
            } // iterate over finalKeys starting with most specific pluralkey (-> contextkey only) -> singularkey only


            var possibleKey;
            /* eslint no-cond-assign: 0 */

            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey: usedKey,
        exactUsedKey: exactUsedKey,
        usedLng: usedLng,
        usedNS: usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }]);

  return Translator;
}(EventEmitter);

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil =
/*#__PURE__*/
function () {
  function LanguageUtil(options) {
    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */](this, LanguageUtil);

    this.options = options;
    this.whitelist = this.options.whitelist || false;
    this.logger = baseLogger.create('languageUtils');
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */](LanguageUtil, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return null;
      var p = code.split('-');
      if (p.length === 2) return null;
      p.pop();
      return this.formatLanguageCode(p.join('-'));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return code;
      var p = code.split('-');
      return this.formatLanguageCode(p[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      // http://www.iana.org/assignments/language-tags/language-tags.xhtml
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
        var p = code.split('-');

        if (this.options.lowerCaseLng) {
          p = p.map(function (part) {
            return part.toLowerCase();
          });
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase(); // if lenght 2 guess it's a country

          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
        }

        return p.join('-');
      }

      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isWhitelisted",
    value: function isWhitelisted(code) {
      if (this.options.load === 'languageOnly' || this.options.nonExplicitWhitelist) {
        code = this.getLanguagePartFromCode(code);
      }

      return !this.whitelist || !this.whitelist.length || this.whitelist.indexOf(code) > -1;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
      if (!code) return fallbacks["default"] || []; // asume we have an object defining fallbacks

      var found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks["default"];
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this = this;

      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];

      var addCode = function addCode(c) {
        if (!c) return;

        if (_this.isWhitelisted(c)) {
          codes.push(c);
        } else {
          _this.logger.warn("rejecting non-whitelisted language code: ".concat(c));
        }
      };

      if (typeof code === 'string' && code.indexOf('-') > -1) {
        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === 'string') {
        addCode(this.formatLanguageCode(code));
      }

      fallbackCodes.forEach(function (fc) {
        if (codes.indexOf(fc) < 0) addCode(_this.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);

  return LanguageUtil;
}();

/* eslint-disable */

var sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'id', 'ja', 'jbo', 'ka', 'kk', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n === 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n === 1 ? 0 : n === 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};
/* eslint-enable */

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver =
/*#__PURE__*/
function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */](this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');
    this.rules = createRules();
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */](PluralResolver, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var rule = this.getRule(code);
      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      var _this = this;

      var ret = [];
      var rule = this.getRule(code);
      if (!rule) return ret;
      rule.numbers.forEach(function (n) {
        var suffix = _this.getSuffix(code, n);

        ret.push("".concat(key).concat(suffix));
      });
      return ret;
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var _this2 = this;

      var rule = this.getRule(code);

      if (rule) {
        // if (rule.numbers.length === 1) return ''; // only singular
        var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        var suffix = rule.numbers[idx]; // special treatment for lngs only having singular and plural

        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
          if (suffix === 2) {
            suffix = 'plural';
          } else if (suffix === 1) {
            suffix = '';
          }
        }

        var returnSuffix = function returnSuffix() {
          return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
        }; // COMPATIBILITY JSON
        // v1


        if (this.options.compatibilityJSON === 'v1') {
          if (suffix === 1) return '';
          if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
          return returnSuffix();
        } else if (
        /* v2 */
        this.options.compatibilityJSON === 'v2') {
          return returnSuffix();
        } else if (
        /* v3 - gettext index */
        this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
          return returnSuffix();
        }

        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
      }

      this.logger.warn("no plural rule found for: ".concat(code));
      return '';
    }
  }]);

  return PluralResolver;
}();

var Interpolator =
/*#__PURE__*/
function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */](this, Interpolator);

    this.logger = baseLogger.create('interpolator');
    this.options = options;

    this.format = options.interpolation && options.interpolation.format || function (value) {
      return value;
    };

    this.init(options);
  }
  /* eslint no-param-reassign: 0 */


  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */](Interpolator, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== undefined ? iOpts.escape : escape;
      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
      this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false; // the regexp

      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options) this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      // the regexp
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, 'g');
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data, lng, options) {
      var _this = this;

      var match;
      var value;
      var replaces;
      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};

      function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
      }

      var handleFormat = function handleFormat(key) {
        if (key.indexOf(_this.formatSeparator) < 0) {
          var path = getPathWithDefaults(data, defaultData, key);
          return _this.alwaysFormat ? _this.format(path, undefined, lng) : path;
        }

        var p = key.split(_this.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this.formatSeparator).trim();
        return _this.format(getPathWithDefaults(data, defaultData, k), f, lng, options);
      };

      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      replaces = 0; // unescape if has unescapePrefix/Suffix

      /* eslint no-cond-assign: 0 */

      while (match = this.regexpUnescape.exec(str)) {
        value = handleFormat(match[1].trim());

        if (value === undefined) {
          if (typeof missingInterpolationHandler === 'function') {
            var temp = missingInterpolationHandler(str, match, options);
            value = typeof temp === 'string' ? temp : '';
          } else {
            this.logger.warn("missed to pass in variable ".concat(match[1], " for interpolating ").concat(str));
            value = '';
          }
        } else if (typeof value !== 'string' && !this.useRawValueToEscape) {
          value = makeString(value);
        }

        str = str.replace(match[0], regexSafe(value));
        this.regexpUnescape.lastIndex = 0;
        replaces++;

        if (replaces >= this.maxReplaces) {
          break;
        }
      }

      replaces = 0; // regular escape on demand

      while (match = this.regexp.exec(str)) {
        value = handleFormat(match[1].trim());

        if (value === undefined) {
          if (typeof missingInterpolationHandler === 'function') {
            var _temp = missingInterpolationHandler(str, match, options);

            value = typeof _temp === 'string' ? _temp : '';
          } else {
            this.logger.warn("missed to pass in variable ".concat(match[1], " for interpolating ").concat(str));
            value = '';
          }
        } else if (typeof value !== 'string' && !this.useRawValueToEscape) {
          value = makeString(value);
        }

        value = this.escapeValue ? regexSafe(this.escape(value)) : regexSafe(value);
        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
        replaces++;

        if (replaces >= this.maxReplaces) {
          break;
        }
      }

      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var match;
      var value;

      var clonedOptions = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */]({}, options);

      clonedOptions.applyPostProcessor = false; // avoid post processing on nested lookup

      delete clonedOptions.defaultValue; // assert we do not get a endless loop on interpolating defaultValue again and again
      // if value is something like "myKey": "lorem $(anotherKey, { "count": {{aValueInOptions}} })"

      function handleHasOptions(key, inheritedOptions) {
        if (key.indexOf(',') < 0) return key;
        var p = key.split(',');
        var optionsString = p.pop();
        key = p.join(',');
        optionsString = this.interpolate(optionsString, clonedOptions);
        optionsString = optionsString.replace(/'/g, '"');

        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */]({}, inheritedOptions, clonedOptions);
        } catch (e) {
          this.logger.error("failed parsing options string in nesting for key ".concat(key), e);
        } // assert we do not get a endless loop on interpolating defaultValue again and again


        delete clonedOptions.defaultValue;
        return key;
      } // regular escape on demand


      while (match = this.nestingRegexp.exec(str)) {
        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions); // is only the nesting key (key1 = '$(key2)') return the value without stringify

        if (value && match[0] === str && typeof value !== 'string') return value; // no string to include or empty

        if (typeof value !== 'string') value = makeString(value);

        if (!value) {
          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
          value = '';
        } // Nested keys should not be escaped by default #854
        // value = this.escapeValue ? regexSafe(utils.escape(value)) : regexSafe(value);


        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }

      return str;
    }
  }]);

  return Interpolator;
}();

function remove(arr, what) {
  var found = arr.indexOf(what);

  while (found !== -1) {
    arr.splice(found, 1);
    found = arr.indexOf(what);
  }
}

var Connector =
/*#__PURE__*/
function (_EventEmitter) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__["a" /* default */](Connector, _EventEmitter);

  function Connector(backend, store, services) {
    var _this;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */](this, Connector);

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */](this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */](Connector).call(this));
    EventEmitter.call(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */](_this)); // <=IE10 fix (unable to call parent constructor)

    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = baseLogger.create('backendConnector');
    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */](Connector, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;

      // find what needs to be loaded
      var toLoad = [];
      var pending = [];
      var toLoadLanguages = [];
      var toLoadNamespaces = [];
      languages.forEach(function (lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function (ns) {
          var name = "".concat(lng, "|").concat(ns);

          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2; // loaded
          } else if (_this2.state[name] < 0) ; else if (_this2.state[name] === 1) {
            if (pending.indexOf(name) < 0) pending.push(name);
          } else {
            _this2.state[name] = 1; // pending

            hasAllNamespaces = false;
            if (pending.indexOf(name) < 0) pending.push(name);
            if (toLoad.indexOf(name) < 0) toLoad.push(name);
            if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
          }
        });
        if (!hasAllNamespaces) toLoadLanguages.push(lng);
      });

      if (toLoad.length || pending.length) {
        this.queue.push({
          pending: pending,
          loaded: {},
          errors: [],
          callback: callback
        });
      }

      return {
        toLoad: toLoad,
        pending: pending,
        toLoadLanguages: toLoadLanguages,
        toLoadNamespaces: toLoadNamespaces
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data) {
      var _name$split = name.split('|'),
          _name$split2 = __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_slicedToArray__["a" /* default */](_name$split, 2),
          lng = _name$split2[0],
          ns = _name$split2[1];

      if (err) this.emit('failedLoading', lng, ns, err);

      if (data) {
        this.store.addResourceBundle(lng, ns, data);
      } // set loaded


      this.state[name] = err ? -1 : 2; // consolidated loading done in this run - only emit once for a loaded namespace

      var loaded = {}; // callback if ready

      this.queue.forEach(function (q) {
        pushPath(q.loaded, [lng], ns);
        remove(q.pending, name);
        if (err) q.errors.push(err);

        if (q.pending.length === 0 && !q.done) {
          // only do once per loaded -> this.emit('loaded', q.loaded);
          Object.keys(q.loaded).forEach(function (l) {
            if (!loaded[l]) loaded[l] = [];

            if (q.loaded[l].length) {
              q.loaded[l].forEach(function (ns) {
                if (loaded[l].indexOf(ns) < 0) loaded[l].push(ns);
              });
            }
          });
          /* eslint no-param-reassign: 0 */

          q.done = true;

          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      }); // emit consolidated loaded event

      this.emit('loaded', loaded); // remove done load requests

      this.queue = this.queue.filter(function (q) {
        return !q.done;
      });
    }
  }, {
    key: "read",
    value: function read(lng, ns, fcName) {
      var _this3 = this;

      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 250;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      if (!lng.length) return callback(null, {}); // noting to load

      return this.backend[fcName](lng, ns, function (err, data) {
        if (err && data
        /* = retryFlag */
        && tried < 5) {
          setTimeout(function () {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }

        callback(err, data);
      });
    }
    /* eslint consistent-return: 0 */

  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;

      if (!this.backend) {
        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
        return callback && callback();
      }

      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === 'string') namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);

      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback(); // nothing to load and no pendings...callback now

        return null; // pendings will trigger callback
      }

      toLoad.toLoad.forEach(function (name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;

      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      var _name$split3 = name.split('|'),
          _name$split4 = __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_slicedToArray__["a" /* default */](_name$split3, 2),
          lng = _name$split4[0],
          ns = _name$split4[1];

      this.read(lng, ns, 'read', undefined, undefined, function (err, data) {
        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);

        _this5.loaded(name, err, data);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn("did not save key \"".concat(key, "\" for namespace \"").concat(namespace, "\" as the namespace was not yet loaded"), 'This means something IS WRONG in your application setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        return;
      } // ignore non valid keys


      if (key === undefined || key === null || key === '') return;

      if (this.backend && this.backend.create) {
        this.backend.create(languages, namespace, key, fallbackValue, null
        /* unused callback */
        , __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */]({}, options, {
          isUpdate: isUpdate
        }));
      } // write to store to avoid resending


      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);

  return Connector;
}(EventEmitter);

function get() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    // string or array of namespaces
    whitelist: false,
    // array with whitelisted languages
    nonExplicitWhitelist: false,
    load: 'all',
    // | currentOnly | languageOnly
    preload: false,
    // array with preload languages
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    // allow bundling certain languages that are not remotely fetched
    saveMissing: false,
    // enable to send missing values
    updateMissing: false,
    // enable to update default values if different from translated value (only useful on initial development, or when keeping code as source of truth)
    saveMissingTo: 'fallback',
    // 'current' || 'all'
    saveMissingPlurals: true,
    // will save all forms not only singular key
    missingKeyHandler: false,
    // function(lng, ns, key, fallbackValue) -> override if prefer on handling
    missingInterpolationHandler: false,
    // function(str, match)
    postProcess: false,
    // string or array of postProcessor names
    postProcessPassResolved: false,
    // pass resolved object into 'options.i18nResolved' for postprocessor
    returnNull: true,
    // allows null value as valid translation
    returnEmptyString: true,
    // allows empty string value as valid translation
    returnObjects: false,
    joinArrays: false,
    // or string to join array
    returnedObjectHandler: false,
    // function(key, value, options) triggered if key returns object but returnObjects is set to false
    parseMissingKeyHandler: false,
    // function(key) parsed a key that was not found in t() before returning
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if (__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */](args[1]) === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];

      if (__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */](args[2]) === 'object' || __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */](args[3]) === 'object') {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function (key) {
          ret[key] = options[key];
        });
      }

      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng, options) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      // prefixEscaped: '{{',
      // suffixEscaped: '}}',
      // unescapeSuffix: '',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      // nestingPrefixEscaped: '$t(',
      // nestingSuffixEscaped: ')',
      // defaultVariables: undefined // object that can have values to interpolate on - extends passed in interpolation data
      maxReplaces: 1000 // max replaces to prevent endless loop

    }
  };
}
/* eslint no-param-reassign: 0 */

function transformOptions(options) {
  // create namespace object if namespace is passed in as string
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS]; // extend whitelist with cimode

  if (options.whitelist && options.whitelist.indexOf('cimode') < 0) {
    options.whitelist = options.whitelist.concat(['cimode']);
  }

  return options;
}

function noop() {}

var I18n =
/*#__PURE__*/
function (_EventEmitter) {
  __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__["a" /* default */](I18n, _EventEmitter);

  function I18n() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */](this, I18n);

    _this = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */](this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */](I18n).call(this));
    EventEmitter.call(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */](_this)); // <=IE10 fix (unable to call parent constructor)

    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = baseLogger;
    _this.modules = {
      external: []
    };

    if (callback && !_this.isInitialized && !options.isClone) {
      // https://github.com/i18next/i18next/issues/879
      if (!_this.options.initImmediate) {
        _this.init(options, callback);

        return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */](_this, __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */](_this));
      }

      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */](I18n, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      this.options = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */]({}, get(), this.options, transformOptions(options));
      this.format = this.options.interpolation.format;
      if (!callback) callback = noop;

      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === 'function') return new ClassOrObject();
        return ClassOrObject;
      } // init services


      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }

        var lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var s = this.services;
        s.logger = baseLogger;
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });
        s.interpolator = new Interpolator(this.options);
        s.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options); // pipe events from backendConnector

        s.backendConnector.on('*', function (event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });

        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          s.languageDetector.init(s, this.options.detection, this.options);
        }

        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }

        this.translator = new Translator(this.services, this.options); // pipe events from translator

        this.translator.on('*', function (event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function (m) {
          if (m.init) m.init(_this2);
        });
      }

      if (!this.modules.languageDetector && !this.options.lng) {
        this.logger.warn('init: no languageDetector is used and no lng is defined');
      } // append api


      var storeApi = ['getResource', 'addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApi.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store;

          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var deferred = defer();

      var load = function load() {
        _this2.changeLanguage(_this2.options.lng, function (err, t) {
          _this2.isInitialized = true;

          _this2.logger.log('initialized', _this2.options);

          _this2.emit('initialized', _this2.options);

          deferred.resolve(t); // not rejecting on err (as err is only a loading translation failed warning)

          callback(err, t);
        });
      };

      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }

      return deferred;
    }
    /* eslint consistent-return: 0 */

  }, {
    key: "loadResources",
    value: function loadResources(language) {
      var _this3 = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
      var usedCallback = callback;
      var usedLng = typeof language === 'string' ? language : this.language;
      if (typeof language === 'function') usedCallback = language;

      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback(); // avoid loading resources for cimode

        var toLoad = [];

        var append = function append(lng) {
          if (!lng) return;

          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);

          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };

        if (!usedLng) {
          // at least load fallbacks in this case
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function (l) {
            return append(l);
          });
        } else {
          append(usedLng);
        }

        if (this.options.preload) {
          this.options.preload.forEach(function (l) {
            return append(l);
          });
        }

        this.services.backendConnector.load(toLoad, this.options.ns, usedCallback);
      } else {
        usedCallback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = defer();
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = noop;
      this.services.backendConnector.reload(lngs, ns, function (err) {
        deferred.resolve(); // not rejecting on err (as err is only a loading translation failed warning)

        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use(module) {
      if (module.type === 'backend') {
        this.modules.backend = module;
      }

      if (module.type === 'logger' || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }

      if (module.type === 'languageDetector') {
        this.modules.languageDetector = module;
      }

      if (module.type === 'i18nFormat') {
        this.modules.i18nFormat = module;
      }

      if (module.type === 'postProcessor') {
        postProcessor.addPostProcessor(module);
      }

      if (module.type === '3rdParty') {
        this.modules.external.push(module);
      }

      return this;
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;

      this.isLanguageChangingTo = lng;
      var deferred = defer();
      this.emit('languageChanging', lng);

      var done = function done(err, l) {
        if (l) {
          _this4.language = l;
          _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);

          _this4.translator.changeLanguage(l);

          _this4.isLanguageChangingTo = undefined;

          _this4.emit('languageChanged', l);

          _this4.logger.log('languageChanged', l);
        } else {
          _this4.isLanguageChangingTo = undefined;
        }

        deferred.resolve(function () {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback) callback(err, function () {
          return _this4.t.apply(_this4, arguments);
        });
      };

      var setLng = function setLng(l) {
        if (l) {
          if (!_this4.language) {
            _this4.language = l;
            _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
          }

          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
          if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
        }

        _this4.loadResources(l, function (err) {
          done(err, l);
        });
      };

      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        this.services.languageDetector.detect(setLng);
      } else {
        setLng(lng);
      }

      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns) {
      var _this5 = this;

      var fixedT = function fixedT(key, opts) {
        var options;

        if (__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */](opts) !== 'object') {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }

          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */]({}, opts);
        }

        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        return _this5.t(key, options);
      };

      if (typeof lng === 'string') {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }

      fixedT.ns = ns;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t() {
      var _this$translator;

      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;

      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function hasLoadedNamespace(ns) {
      var _this6 = this;

      if (!this.isInitialized) {
        this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
        return false;
      }

      if (!this.languages || !this.languages.length) {
        this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
        return false;
      }

      var lng = this.languages[0];
      var fallbackLng = this.options ? this.options.fallbackLng : false;
      var lastLng = this.languages[this.languages.length - 1]; // we're in cimode so this shall pass

      if (lng.toLowerCase() === 'cimode') return true;

      var loadNotPending = function loadNotPending(l, n) {
        var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];

        return loadState === -1 || loadState === 2;
      }; // loaded -> SUCCESS


      if (this.hasResourceBundle(lng, ns)) return true; // were not loading at all -> SEMI SUCCESS

      if (!this.services.backendConnector.backend) return true; // failed loading ns - but at least fallback is not pending -> SEMI SUCCESS

      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
      return false;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces(ns, callback) {
      var _this7 = this;

      var deferred = defer();

      if (!this.options.ns) {
        callback && callback();
        return Promise.resolve();
      }

      if (typeof ns === 'string') ns = [ns];
      ns.forEach(function (n) {
        if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
      });
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = defer();
      if (typeof lngs === 'string') lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function (lng) {
        return preloaded.indexOf(lng) < 0;
      }); // Exit early if all given languages are already preloaded

      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }

      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
      if (!lng) return 'rtl';
      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];
      return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
    }
    /* eslint class-methods-use-this: 0 */

  }, {
    key: "createInstance",
    value: function createInstance() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      return new I18n(options, callback);
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this8 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

      var mergedOptions = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectSpread__["a" /* default */]({}, this.options, options, {
        isClone: true
      });

      var clone = new I18n(mergedOptions);
      var membersToCopy = ['store', 'services', 'language'];
      membersToCopy.forEach(function (m) {
        clone[m] = _this8[m];
      });
      clone.translator = new Translator(clone.services, clone.options);
      clone.translator.on('*', function (event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }

        clone.emit.apply(clone, [event].concat(args));
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = clone.options; // sync options

      return clone;
    }
  }]);

  return I18n;
}(EventEmitter);

var i18next = new I18n();

/* harmony default export */ __webpack_exports__["default"] = (i18next);


/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty__ = __webpack_require__(829);

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      __WEBPACK_IMPORTED_MODULE_0__defineProperty__["a" /* default */](target, key, source[key]);
    });
  }

  return target;
}

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _possibleConstructorReturn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_esm_typeof__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assertThisInitialized__ = __webpack_require__(263);


function _possibleConstructorReturn(self, call) {
  if (call && (__WEBPACK_IMPORTED_MODULE_0__helpers_esm_typeof__["a" /* default */](call) === "object" || typeof call === "function")) {
    return call;
  }

  return __WEBPACK_IMPORTED_MODULE_1__assertThisInitialized__["a" /* default */](self);
}

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _getPrototypeOf;
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inherits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf__ = __webpack_require__(835);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf__["a" /* default */](subClass, superClass);
}

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toConsumableArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArray__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nonIterableSpread__ = __webpack_require__(839);



function _toConsumableArray(arr) {
  return __WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles__["a" /* default */](arr) || __WEBPACK_IMPORTED_MODULE_1__iterableToArray__["a" /* default */](arr) || __WEBPACK_IMPORTED_MODULE_2__nonIterableSpread__["a" /* default */]();
}

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithoutHoles;
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArray;
function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableSpread;
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _slicedToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nonIterableRest__ = __webpack_require__(843);



function _slicedToArray(arr, i) {
  return __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles__["a" /* default */](arr) || __WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit__["a" /* default */](arr, i) || __WEBPACK_IMPORTED_MODULE_2__nonIterableRest__["a" /* default */]();
}

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithHoles;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArrayLimit;
function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableRest;
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export nodesToString */
/* harmony export (immutable) */ __webpack_exports__["a"] = Trans;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html_parse_stringify2__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html_parse_stringify2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_html_parse_stringify2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__context__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(141);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default.a(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






function hasChildren(node) {
  return node && (node.children || node.props && node.props.children);
}

function getChildren(node) {
  if (!node) return [];
  return node && node.children ? node.children : node.props && node.props.children;
}

function hasValidReactChildren(children) {
  if (Object.prototype.toString.call(children) !== '[object Array]') return false;
  return children.every(function (child) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(child);
  });
}

function getAsArray(data) {
  return Array.isArray(data) ? data : [data];
}

function nodesToString(startingString, children, index, i18nOptions) {
  if (!children) return '';
  var stringNode = startingString;
  var childrenArray = getAsArray(children);
  var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
  childrenArray.forEach(function (child, i) {
    var elementKey = "".concat(i);

    if (typeof child === 'string') {
      stringNode = "".concat(stringNode).concat(child);
    } else if (hasChildren(child)) {
      var elementTag = keepArray.indexOf(child.type) > -1 && Object.keys(child.props).length === 1 && typeof hasChildren(child) === 'string' ? child.type : elementKey;

      if (child.props && child.props.i18nIsDynamicList) {
        // we got a dynamic list like "<ul>{['a', 'b'].map(item => ( <li key={item}>{item}</li> ))}</ul>""
        // the result should be "<0></0>" and not "<0><0>a</0><1>b</1></0>"
        stringNode = "".concat(stringNode, "<").concat(elementTag, "></").concat(elementTag, ">");
      } else {
        // regular case mapping the inner children
        stringNode = "".concat(stringNode, "<").concat(elementTag, ">").concat(nodesToString('', getChildren(child), i + 1, i18nOptions), "</").concat(elementTag, ">");
      }
    } else if (__WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(child)) {
      if (keepArray.indexOf(child.type) > -1 && Object.keys(child.props).length === 0) {
        stringNode = "".concat(stringNode, "<").concat(child.type, "/>");
      } else {
        stringNode = "".concat(stringNode, "<").concat(elementKey, "></").concat(elementKey, ">");
      }
    } else if (__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof___default.a(child) === 'object') {
      var clone = _objectSpread({}, child);

      var format = clone.format;
      delete clone.format;
      var keys = Object.keys(clone);

      if (format && keys.length === 1) {
        stringNode = "".concat(stringNode, "{{").concat(keys[0], ", ").concat(format, "}}");
      } else if (keys.length === 1) {
        stringNode = "".concat(stringNode, "{{").concat(keys[0], "}}");
      } else {
        // not a valid interpolation object (can only contain one value plus format)
        __WEBPACK_IMPORTED_MODULE_6__utils__["d" /* warn */]("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", child);
      }
    } else {
      __WEBPACK_IMPORTED_MODULE_6__utils__["d" /* warn */]("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", child);
    }
  });
  return stringNode;
}

function renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts) {
  if (targetString === '') return []; // check if contains tags we need to replace from html string to react nodes

  var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
  var emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.join('|')).test(targetString); // no need to replace tags in the targetstring

  if (!children && !emptyChildrenButNeedsHandling) return [targetString]; // v2 -> interpolates upfront no need for "some <0>{{var}}</0>"" -> will be just "some {{var}}" in translation file

  var data = {};

  function getData(childs) {
    var childrenArray = getAsArray(childs);
    childrenArray.forEach(function (child) {
      if (typeof child === 'string') return;
      if (hasChildren(child)) getData(getChildren(child));else if (__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof___default.a(child) === 'object' && !__WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(child)) Object.assign(data, child);
    });
  }

  getData(children);
  var interpolatedString = i18n.services.interpolator.interpolate(targetString, _objectSpread({}, data, {}, combinedTOpts), i18n.language); // parse ast from string with additional wrapper tag
  // -> avoids issues in parser removing prepending text nodes

  var ast = __WEBPACK_IMPORTED_MODULE_4_html_parse_stringify2___default.a.parse("<0>".concat(interpolatedString, "</0>"));

  function mapAST(reactNode, astNode) {
    var reactNodes = getAsArray(reactNode);
    var astNodes = getAsArray(astNode);
    return astNodes.reduce(function (mem, node, i) {
      var translationContent = node.children && node.children[0] && node.children[0].content;

      if (node.type === 'tag') {
        var child = reactNodes[parseInt(node.name, 10)] || {};
        var isElement = __WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(child);

        if (typeof child === 'string') {
          mem.push(child);
        } else if (hasChildren(child)) {
          var childs = getChildren(child);
          var mappedChildren = mapAST(childs, node.children);
          var inner = hasValidReactChildren(childs) && mappedChildren.length === 0 ? childs : mappedChildren;
          if (child.dummy) child.children = inner; // needed on preact!

          mem.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(child, _objectSpread({}, child.props, {
            key: i
          }), inner));
        } else if (emptyChildrenButNeedsHandling && __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof___default.a(child) === 'object' && child.dummy && !isElement) {
          // we have a empty Trans node (the dummy element) with a targetstring that contains html tags needing
          // conversion to react nodes
          // so we just need to map the inner stuff
          var _inner = mapAST(reactNodes
          /* wrong but we need something */
          , node.children);

          mem.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(child, _objectSpread({}, child.props, {
            key: i
          }), _inner));
        } else if (Number.isNaN(parseFloat(node.name))) {
          if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
            if (node.voidElement) {
              mem.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(node.name, {
                key: "".concat(node.name, "-").concat(i)
              }));
            } else {
              var _inner2 = mapAST(reactNodes
              /* wrong but we need something */
              , node.children);

              mem.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(node.name, {
                key: "".concat(node.name, "-").concat(i)
              }, _inner2));
            }
          } else if (node.voidElement) {
            mem.push("<".concat(node.name, " />"));
          } else {
            var _inner3 = mapAST(reactNodes
            /* wrong but we need something */
            , node.children);

            mem.push("<".concat(node.name, ">").concat(_inner3, "</").concat(node.name, ">"));
          }
        } else if (__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof___default.a(child) === 'object' && !isElement) {
          var content = node.children[0] ? translationContent : null; // v1
          // as interpolation was done already we just have a regular content node
          // in the translation AST while having an object in reactNodes
          // -> push the content no need to interpolate again

          if (content) mem.push(content);
        } else if (node.children.length === 1 && translationContent) {
          // If component does not have children, but translation - has
          // with this in component could be components={[<span class='make-beautiful'/>]} and in translation - 'some text <0>some highlighted message</0>'
          mem.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(child, _objectSpread({}, child.props, {
            key: i
          }), translationContent));
        } else {
          mem.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(child, _objectSpread({}, child.props, {
            key: i
          })));
        }
      } else if (node.type === 'text') {
        mem.push(node.content);
      }

      return mem;
    }, []);
  } // call mapAST with having react nodes nested into additional node like
  // we did for the string ast from translation
  // return the children of that extra node to get expected result


  var result = mapAST([{
    dummy: true,
    children: children
  }], ast);
  return getChildren(result[0]);
}

function Trans(_ref) {
  var children = _ref.children,
      count = _ref.count,
      parent = _ref.parent,
      i18nKey = _ref.i18nKey,
      tOptions = _ref.tOptions,
      values = _ref.values,
      defaults = _ref.defaults,
      components = _ref.components,
      ns = _ref.ns,
      i18nFromProps = _ref.i18n,
      tFromProps = _ref.t,
      additionalProps = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default.a(_ref, ["children", "count", "parent", "i18nKey", "tOptions", "values", "defaults", "components", "ns", "i18n", "t"]);

  var ReactI18nContext = __WEBPACK_IMPORTED_MODULE_3_react__["useContext"](__WEBPACK_IMPORTED_MODULE_5__context__["a" /* I18nContext */]);

  var _ref2 = __WEBPACK_IMPORTED_MODULE_5__context__["e" /* getHasUsedI18nextProvider */]() ? ReactI18nContext || {} : {},
      i18nFromContext = _ref2.i18n,
      defaultNSFromContext = _ref2.defaultNS;

  var i18n = i18nFromProps || i18nFromContext || __WEBPACK_IMPORTED_MODULE_5__context__["f" /* getI18n */]();

  if (!i18n) {
    __WEBPACK_IMPORTED_MODULE_6__utils__["e" /* warnOnce */]('You will need pass in an i18next instance by using i18nextReactModule');
    return children;
  }

  var t = tFromProps || i18n.t.bind(i18n) || function (k) {
    return k;
  };

  var reactI18nextOptions = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_5__context__["d" /* getDefaults */](), {}, i18n.options && i18n.options.react);

  var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent; // prepare having a namespace

  var namespaces = ns || t.ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  var defaultValue = defaults || nodesToString('', children, 0, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue;
  var hashTransKey = reactI18nextOptions.hashTransKey;
  var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
  var interpolationOverride = values ? {} : {
    interpolation: {
      prefix: '#$?',
      suffix: '?$#'
    }
  };

  var combinedTOpts = _objectSpread({}, tOptions, {
    count: count
  }, values, {}, interpolationOverride, {
    defaultValue: defaultValue,
    ns: namespaces
  });

  var translation = key ? t(key, combinedTOpts) : defaultValue;
  if (!useAsParent) return renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(useAsParent, additionalProps, renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts));
}

/***/ }),
/* 845 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 846 */
/***/ (function(module, exports) {

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
    parse: __webpack_require__(848),
    stringify: __webpack_require__(851)
};


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

/*jshint -W030 */
var tagRE = /(?:<!--[\S\s]*?-->|<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>)/g;
var parseTag = __webpack_require__(849);
// re-used obj for quick lookups of components
var empty = Object.create ? Object.create(null) : {};
// common logic for pushing a child node onto a list
function pushTextNode(list, html, level, start, ignoreWhitespace) {
    // calculate correct end of the content slice in case there's
    // no tag after the text node.
    var end = html.indexOf('<', start);
    var content = html.slice(start, end === -1 ? undefined : end);
    // if a node is nothing but whitespace, collapse it as the spec states:
    // https://www.w3.org/TR/html4/struct/text.html#h-9.1
    if (/^\s*$/.test(content)) {
        content = ' ';
    }
    // don't add whitespace-only text nodes if they would be trailing text nodes
    // or if they would be leading whitespace-only text nodes:
    //  * end > -1 indicates this is not a trailing text node
    //  * leading node is when level is -1 and list has length 0
    if ((!ignoreWhitespace && end > -1 && level + list.length >= 0) || content !== ' ') {
        list.push({
            type: 'text',
            content: content
        });
    }
}

module.exports = function parse(html, options) {
    options || (options = {});
    options.components || (options.components = empty);
    var result = [];
    var current;
    var level = -1;
    var arr = [];
    var byTag = {};
    var inComponent = false;

    html.replace(tagRE, function (tag, index) {
        if (inComponent) {
            if (tag !== ('</' + current.name + '>')) {
                return;
            } else {
                inComponent = false;
            }
        }

        var isOpen = tag.charAt(1) !== '/';
        var isComment = tag.indexOf('<!--') === 0;
        var start = index + tag.length;
        var nextChar = html.charAt(start);
        var parent;

        if (isOpen && !isComment) {
            level++;

            current = parseTag(tag);
            if (current.type === 'tag' && options.components[current.name]) {
                current.type = 'component';
                inComponent = true;
            }

            if (!current.voidElement && !inComponent && nextChar && nextChar !== '<') {
                pushTextNode(current.children, html, level, start, options.ignoreWhitespace);
            }

            byTag[current.tagName] = current;

            // if we're at root, push new base node
            if (level === 0) {
                result.push(current);
            }

            parent = arr[level - 1];

            if (parent) {
                parent.children.push(current);
            }

            arr[level] = current;
        }

        if (isComment || !isOpen || current.voidElement) {
            if (!isComment) {
                level--;
            }
            if (!inComponent && nextChar !== '<' && nextChar) {
                // trailing text node
                // if we're at the root, push a base text node. otherwise add as
                // a child to the current node.
                parent = level === -1 ? result : arr[level].children;
                pushTextNode(parent, html, level, start, options.ignoreWhitespace);
            }
        }
    });

    // If the "html" passed isn't actually html, add it as a text node.
    if (!result.length && html.length) {
        pushTextNode(result, html, 0, 0, options.ignoreWhitespace);
    }

    return result;
};


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

var attrRE = /([\w-]+)|=|(['"])([.\s\S]*?)\2/g;
var voidElements = __webpack_require__(850);

module.exports = function (tag) {
    var i = 0;
    var key;
    var expectingValueAfterEquals = true;
    var res = {
        type: 'tag',
        name: '',
        voidElement: false,
        attrs: {},
        children: []
    };

    tag.replace(attrRE, function (match) {
        if (match === '=') {
            expectingValueAfterEquals = true;
            i++;
            return;
        }

        if (!expectingValueAfterEquals) {
            if (key) {
                res.attrs[key] = key; // boolean attribute
            }
            key=match;
        } else {
            if (i === 0) {
                if (voidElements[match] || tag.charAt(tag.length - 2) === '/') {
                    res.voidElement = true;
                }
                res.name = match;
            } else {
                res.attrs[key] = match.replace(/^['"]|['"]$/g, '');
                key=undefined;
            }
        }
        i++;
        expectingValueAfterEquals = false;
    });

    return res;
};


/***/ }),
/* 850 */
/***/ (function(module, exports) {

/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */

module.exports = {
  "area": true,
  "base": true,
  "br": true,
  "col": true,
  "embed": true,
  "hr": true,
  "img": true,
  "input": true,
  "keygen": true,
  "link": true,
  "menuitem": true,
  "meta": true,
  "param": true,
  "source": true,
  "track": true,
  "wbr": true
};


/***/ }),
/* 851 */
/***/ (function(module, exports) {

function attrString(attrs) {
    var buff = [];
    for (var key in attrs) {
        buff.push(key + '="' + attrs[key] + '"');
    }
    if (!buff.length) {
        return '';
    }
    return ' ' + buff.join(' ');
}

function stringify(buff, doc) {
    switch (doc.type) {
    case 'text':
        return buff + doc.content;
    case 'tag':
        buff += '<' + doc.name + (doc.attrs ? attrString(doc.attrs) : '') + (doc.voidElement ? '/>' : '>');
        if (doc.voidElement) {
            return buff;
        }
        return buff + doc.children.reduce(stringify, '') + '</' + doc.name + '>';
    }
}

module.exports = function (doc) {
    return doc.reduce(function (token, rootEl) {
        return token + stringify('', rootEl);
    }, '');
};


/***/ }),
/* 852 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;

/***/ }),
/* 853 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

/***/ }),
/* 854 */
/***/ (function(module, exports) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;

/***/ }),
/* 855 */
/***/ (function(module, exports) {

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit;

/***/ }),
/* 856 */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

module.exports = _nonIterableRest;

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withTranslation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__useTranslation__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(141);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default.a(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function withTranslation(ns) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function Extend(WrappedComponent) {
    function I18nextWithTranslation(_ref) {
      var forwardedRef = _ref.forwardedRef,
          rest = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default.a(_ref, ["forwardedRef"]);

      var _useTranslation = __WEBPACK_IMPORTED_MODULE_4__useTranslation__["a" /* useTranslation */](ns, rest),
          _useTranslation2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default.a(_useTranslation, 3),
          t = _useTranslation2[0],
          i18n = _useTranslation2[1],
          ready = _useTranslation2[2];

      var passDownProps = _objectSpread({}, rest, {
        t: t,
        i18n: i18n,
        tReady: ready
      });

      if (options.withRef && forwardedRef) {
        passDownProps.ref = forwardedRef;
      } else if (!options.withRef && forwardedRef) {
        passDownProps.forwardedRef = forwardedRef;
      }

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(WrappedComponent, passDownProps);
    }

    I18nextWithTranslation.displayName = "withI18nextTranslation(".concat(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* getDisplayName */](WrappedComponent), ")");
    I18nextWithTranslation.WrappedComponent = WrappedComponent;

    var forwardRef = function forwardRef(props, ref) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(I18nextWithTranslation, Object.assign({}, props, {
        forwardedRef: ref
      }));
    };

    return options.withRef ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(forwardRef) : I18nextWithTranslation;
  };
}

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Translation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__useTranslation__ = __webpack_require__(188);



function Translation(props) {
  var ns = props.ns,
      children = props.children,
      options = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default.a(props, ["ns", "children"]);

  var _useTranslation = __WEBPACK_IMPORTED_MODULE_2__useTranslation__["a" /* useTranslation */](ns, options),
      _useTranslation2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default.a(_useTranslation, 3),
      t = _useTranslation2[0],
      i18n = _useTranslation2[1],
      ready = _useTranslation2[2];

  return children(t, {
    i18n: i18n,
    lng: i18n.language
  }, ready);
}

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = I18nextProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__context__ = __webpack_require__(95);


function I18nextProvider(_ref) {
  var i18n = _ref.i18n,
      defaultNS = _ref.defaultNS,
      children = _ref.children;
  __WEBPACK_IMPORTED_MODULE_1__context__["k" /* usedI18nextProvider */](true);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__context__["a" /* I18nContext */].Provider, {
    value: {
      i18n: i18n,
      defaultNS: defaultNS
    }
  }, children);
}

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withSSR;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__useSSR__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__context__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(141);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default.a(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





function withSSR() {
  return function Extend(WrappedComponent) {
    function I18nextWithSSR(_ref) {
      var initialI18nStore = _ref.initialI18nStore,
          initialLanguage = _ref.initialLanguage,
          rest = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default.a(_ref, ["initialI18nStore", "initialLanguage"]);

      __WEBPACK_IMPORTED_MODULE_3__useSSR__["a" /* useSSR */](initialI18nStore, initialLanguage);
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(WrappedComponent, _objectSpread({}, rest));
    }

    I18nextWithSSR.getInitialProps = __WEBPACK_IMPORTED_MODULE_4__context__["c" /* composeInitialProps */](WrappedComponent);
    I18nextWithSSR.displayName = "withI18nextSSR(".concat(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* getDisplayName */](WrappedComponent), ")");
    I18nextWithSSR.WrappedComponent = WrappedComponent;
    return I18nextWithSSR;
  };
}

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_typeof__ = __webpack_require__(865);





var arr = [];
var each = arr.forEach;
var slice = arr.slice;
function defaults(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        if (obj[prop] === undefined) obj[prop] = source[prop];
      }
    }
  });
  return obj;
}

function addQueryString(url, params) {
  if (params && __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_typeof__["a" /* default */](params) === 'object') {
    var queryString = '',
        e = encodeURIComponent; // Must encode data

    for (var paramName in params) {
      queryString += '&' + e(paramName) + '=' + e(params[paramName]);
    }

    if (!queryString) {
      return url;
    }

    url = url + (url.indexOf('?') !== -1 ? '&' : '?') + queryString.slice(1);
  }

  return url;
} // https://gist.github.com/Xeoncross/7663273


function ajax(url, options, callback, data, cache) {
  if (data && __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_typeof__["a" /* default */](data) === 'object') {
    if (!cache) {
      data['_t'] = new Date();
    } // URL encoded form data must be in querystring format


    data = addQueryString('', data).slice(1);
  }

  if (options.queryStringParams) {
    url = addQueryString(url, options.queryStringParams);
  }

  try {
    var x;

    if (XMLHttpRequest) {
      x = new XMLHttpRequest();
    } else {
      x = new ActiveXObject('MSXML2.XMLHTTP.3.0');
    }

    x.open(data ? 'POST' : 'GET', url, 1);

    if (!options.crossDomain) {
      x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    }

    x.withCredentials = !!options.withCredentials;

    if (data) {
      x.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    }

    if (x.overrideMimeType) {
      x.overrideMimeType("application/json");
    }

    var h = options.customHeaders;
    h = typeof h === 'function' ? h() : h;

    if (h) {
      for (var i in h) {
        x.setRequestHeader(i, h[i]);
      }
    }

    x.onreadystatechange = function () {
      x.readyState > 3 && callback && callback(x.responseText, x);
    };

    x.send(data);
  } catch (e) {
    console && console.log(e);
  }
}

function getDefaults() {
  return {
    loadPath: '/locales/{{lng}}/{{ns}}.json',
    addPath: '/locales/add/{{lng}}/{{ns}}',
    allowMultiLoading: false,
    parse: JSON.parse,
    parsePayload: function parsePayload(namespace, key, fallbackValue) {
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */]({}, key, fallbackValue || '');
    },
    crossDomain: false,
    ajax: ajax
  };
}

var Backend =
/*#__PURE__*/
function () {
  function Backend(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */](this, Backend);

    this.init(services, options);
    this.type = 'backend';
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */](Backend, [{
    key: "init",
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.services = services;
      this.options = defaults(options, this.options || {}, getDefaults());
    }
  }, {
    key: "readMulti",
    value: function readMulti(languages, namespaces, callback) {
      var loadPath = this.options.loadPath;

      if (typeof this.options.loadPath === 'function') {
        loadPath = this.options.loadPath(languages, namespaces);
      }

      var url = this.services.interpolator.interpolate(loadPath, {
        lng: languages.join('+'),
        ns: namespaces.join('+')
      });
      this.loadUrl(url, callback);
    }
  }, {
    key: "read",
    value: function read(language, namespace, callback) {
      var loadPath = this.options.loadPath;

      if (typeof this.options.loadPath === 'function') {
        loadPath = this.options.loadPath([language], [namespace]);
      }

      var url = this.services.interpolator.interpolate(loadPath, {
        lng: language,
        ns: namespace
      });
      this.loadUrl(url, callback);
    }
  }, {
    key: "loadUrl",
    value: function loadUrl(url, callback) {
      var _this = this;

      this.options.ajax(url, this.options, function (data, xhr) {
        if (xhr.status >= 500 && xhr.status < 600) return callback('failed loading ' + url, true
        /* retry */
        );
        if (xhr.status >= 400 && xhr.status < 500) return callback('failed loading ' + url, false
        /* no retry */
        );
        var ret, err;

        try {
          ret = _this.options.parse(data, url);
        } catch (e) {
          err = 'failed parsing ' + url + ' to json';
        }

        if (err) return callback(err, false);
        callback(null, ret);
      });
    }
  }, {
    key: "create",
    value: function create(languages, namespace, key, fallbackValue) {
      var _this2 = this;

      if (typeof languages === 'string') languages = [languages];
      var payload = this.options.parsePayload(namespace, key, fallbackValue);
      languages.forEach(function (lng) {
        var url = _this2.services.interpolator.interpolate(_this2.options.addPath, {
          lng: lng,
          ns: namespace
        });

        _this2.options.ajax(url, _this2.options, function (data, xhr) {//const statusCode = xhr.status.toString();
          // TODO: if statusCode === 4xx do log
        }, payload);
      });
    }
  }]);

  return Backend;
}();

Backend.type = 'backend';

/* harmony default export */ __webpack_exports__["default"] = (Backend);


/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(868);



var arr = [];
var each = arr.forEach;
var slice = arr.slice;
function defaults(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        if (obj[prop] === undefined) obj[prop] = source[prop];
      }
    }
  });
  return obj;
}

var cookie = {
  create: function create(name, value, minutes, domain) {
    var expires;

    if (minutes) {
      var date = new Date();
      date.setTime(date.getTime() + minutes * 60 * 1000);
      expires = '; expires=' + date.toGMTString();
    } else expires = '';

    domain = domain ? 'domain=' + domain + ';' : '';
    document.cookie = name + '=' + value + expires + ';' + domain + 'path=/';
  },
  read: function read(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');

    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];

      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }

      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }

    return null;
  },
  remove: function remove(name) {
    this.create(name, '', -1);
  }
};
var cookie$1 = {
  name: 'cookie',
  lookup: function lookup(options) {
    var found;

    if (options.lookupCookie && typeof document !== 'undefined') {
      var c = cookie.read(options.lookupCookie);
      if (c) found = c;
    }

    return found;
  },
  cacheUserLanguage: function cacheUserLanguage(lng, options) {
    if (options.lookupCookie && typeof document !== 'undefined') {
      cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain);
    }
  }
};

var querystring = {
  name: 'querystring',
  lookup: function lookup(options) {
    var found;

    if (typeof window !== 'undefined') {
      var query = window.location.search.substring(1);
      var params = query.split('&');

      for (var i = 0; i < params.length; i++) {
        var pos = params[i].indexOf('=');

        if (pos > 0) {
          var key = params[i].substring(0, pos);

          if (key === options.lookupQuerystring) {
            found = params[i].substring(pos + 1);
          }
        }
      }
    }

    return found;
  }
};

var hasLocalStorageSupport;

try {
  hasLocalStorageSupport = window !== 'undefined' && window.localStorage !== null;
  var testKey = 'i18next.translate.boo';
  window.localStorage.setItem(testKey, 'foo');
  window.localStorage.removeItem(testKey);
} catch (e) {
  hasLocalStorageSupport = false;
}

var localStorage = {
  name: 'localStorage',
  lookup: function lookup(options) {
    var found;

    if (options.lookupLocalStorage && hasLocalStorageSupport) {
      var lng = window.localStorage.getItem(options.lookupLocalStorage);
      if (lng) found = lng;
    }

    return found;
  },
  cacheUserLanguage: function cacheUserLanguage(lng, options) {
    if (options.lookupLocalStorage && hasLocalStorageSupport) {
      window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
  }
};

var navigator$1 = {
  name: 'navigator',
  lookup: function lookup(options) {
    var found = [];

    if (typeof navigator !== 'undefined') {
      if (navigator.languages) {
        // chrome only; not an array, so can't use .push.apply instead of iterating
        for (var i = 0; i < navigator.languages.length; i++) {
          found.push(navigator.languages[i]);
        }
      }

      if (navigator.userLanguage) {
        found.push(navigator.userLanguage);
      }

      if (navigator.language) {
        found.push(navigator.language);
      }
    }

    return found.length > 0 ? found : undefined;
  }
};

var htmlTag = {
  name: 'htmlTag',
  lookup: function lookup(options) {
    var found;
    var htmlTag = options.htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);

    if (htmlTag && typeof htmlTag.getAttribute === 'function') {
      found = htmlTag.getAttribute('lang');
    }

    return found;
  }
};

var path = {
  name: 'path',
  lookup: function lookup(options) {
    var found;

    if (typeof window !== 'undefined') {
      var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);

      if (language instanceof Array) {
        if (typeof options.lookupFromPathIndex === 'number') {
          if (typeof language[options.lookupFromPathIndex] !== 'string') {
            return undefined;
          }

          found = language[options.lookupFromPathIndex].replace('/', '');
        } else {
          found = language[0].replace('/', '');
        }
      }
    }

    return found;
  }
};

var subdomain = {
  name: 'subdomain',
  lookup: function lookup(options) {
    var found;

    if (typeof window !== 'undefined') {
      var language = window.location.href.match(/(?:http[s]*\:\/\/)*(.*?)\.(?=[^\/]*\..{2,5})/gi);

      if (language instanceof Array) {
        if (typeof options.lookupFromSubdomainIndex === 'number') {
          found = language[options.lookupFromSubdomainIndex].replace('http://', '').replace('https://', '').replace('.', '');
        } else {
          found = language[0].replace('http://', '').replace('https://', '').replace('.', '');
        }
      }
    }

    return found;
  }
};

function getDefaults() {
  return {
    order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
    lookupQuerystring: 'lng',
    lookupCookie: 'i18next',
    lookupLocalStorage: 'i18nextLng',
    // cache user language
    caches: ['localStorage'],
    excludeCacheFor: ['cimode'],
    //cookieMinutes: 10,
    //cookieDomain: 'myDomain'
    checkWhitelist: true
  };
}

var Browser =
/*#__PURE__*/
function () {
  function Browser(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */](this, Browser);

    this.type = 'languageDetector';
    this.detectors = {};
    this.init(services, options);
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */](Browser, [{
    key: "init",
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.services = services;
      this.options = defaults(options, this.options || {}, getDefaults()); // backwards compatibility

      if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
      this.i18nOptions = i18nOptions;
      this.addDetector(cookie$1);
      this.addDetector(querystring);
      this.addDetector(localStorage);
      this.addDetector(navigator$1);
      this.addDetector(htmlTag);
      this.addDetector(path);
      this.addDetector(subdomain);
    }
  }, {
    key: "addDetector",
    value: function addDetector(detector) {
      this.detectors[detector.name] = detector;
    }
  }, {
    key: "detect",
    value: function detect(detectionOrder) {
      var _this = this;

      if (!detectionOrder) detectionOrder = this.options.order;
      var detected = [];
      detectionOrder.forEach(function (detectorName) {
        if (_this.detectors[detectorName]) {
          var lookup = _this.detectors[detectorName].lookup(_this.options);

          if (lookup && typeof lookup === 'string') lookup = [lookup];
          if (lookup) detected = detected.concat(lookup);
        }
      });
      var found;
      detected.forEach(function (lng) {
        if (found) return;

        var cleanedLng = _this.services.languageUtils.formatLanguageCode(lng);

        if (!_this.options.checkWhitelist || _this.services.languageUtils.isWhitelisted(cleanedLng)) found = cleanedLng;
      });

      if (!found) {
        var fallbacks = this.i18nOptions.fallbackLng;
        if (typeof fallbacks === 'string') fallbacks = [fallbacks];
        if (!fallbacks) fallbacks = [];

        if (Object.prototype.toString.apply(fallbacks) === '[object Array]') {
          found = fallbacks[0];
        } else {
          found = fallbacks[0] || fallbacks["default"] && fallbacks["default"][0];
        }
      }

      return found;
    }
  }, {
    key: "cacheUserLanguage",
    value: function cacheUserLanguage(lng, caches) {
      var _this2 = this;

      if (!caches) caches = this.options.caches;
      if (!caches) return;
      if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
      caches.forEach(function (cacheName) {
        if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
      });
    }
  }]);

  return Browser;
}();

Browser.type = 'languageDetector';

/* harmony default export */ __webpack_exports__["default"] = (Browser);


/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(190);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  __WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */]('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  Provider.displayName = 'Provider';

  return Provider;
}

/* harmony default export */ __webpack_exports__["b"] = (createProvider());

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(871);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(893);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(273);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */](mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */](function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */](function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"](mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(881);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */](value)
    : __WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */](value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(879);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(25)))

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(270);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(883);


/** Built-in value references. */
var getPrototype = __WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */](Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(887);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */](root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(25), __webpack_require__(886)(module)))

/***/ }),
/* 886 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(271);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */](inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(272);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(273);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */](mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */](function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(274);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(894);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(190);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      __WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */]('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var firebase = _interopDefault(__webpack_require__(50));
__webpack_require__(896);
__webpack_require__(897);
__webpack_require__(898);
__webpack_require__(900);
__webpack_require__(901);
__webpack_require__(903);
__webpack_require__(904);
__webpack_require__(905);
__webpack_require__(906);

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
console.warn("\nIt looks like you're using the development build of the Firebase JS SDK.\nWhen deploying Firebase apps to production, it is advisable to only import\nthe individual SDK components you intend to use.\n\nFor the module builds, these are available in the following manner\n(replace <PACKAGE> with the name of a component - i.e. auth, database, etc):\n\nCommonJS Modules:\nconst firebase = require('firebase/app');\nrequire('firebase/<PACKAGE>');\n\nES Modules:\nimport firebase from 'firebase/app';\nimport 'firebase/<PACKAGE>';\n\nTypescript:\nimport * as firebase from 'firebase/app';\nimport 'firebase/<PACKAGE>';\n");

module.exports = firebase;
//# sourceMappingURL=index.cjs.js.map


/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__firebase_app__);
(function() {var k,aa="function"==typeof Object.defineProperties?Object.defineProperty:function(a,b,c){a!=Array.prototype&&a!=Object.prototype&&(a[b]=c.value)},ba="undefined"!=typeof window&&window===this?this:"undefined"!=typeof global&&null!=global?global:this;function ca(a,b){if(b){var c=ba;a=a.split(".");for(var d=0;d<a.length-1;d++){var e=a[d];e in c||(c[e]={});c=c[e]}a=a[a.length-1];d=c[a];b=b(d);b!=d&&null!=b&&aa(c,a,{configurable:!0,writable:!0,value:b})}}
function da(a){var b=0;return function(){return b<a.length?{done:!1,value:a[b++]}:{done:!0}}}function ea(a){var b="undefined"!=typeof Symbol&&Symbol.iterator&&a[Symbol.iterator];return b?b.call(a):{next:da(a)}}
ca("Promise",function(a){function b(g){this.b=0;this.c=void 0;this.a=[];var h=this.f();try{g(h.resolve,h.reject)}catch(m){h.reject(m)}}function c(){this.a=null}function d(g){return g instanceof b?g:new b(function(h){h(g)})}if(a)return a;c.prototype.b=function(g){if(null==this.a){this.a=[];var h=this;this.c(function(){h.g()})}this.a.push(g)};var e=ba.setTimeout;c.prototype.c=function(g){e(g,0)};c.prototype.g=function(){for(;this.a&&this.a.length;){var g=this.a;this.a=[];for(var h=0;h<g.length;++h){var m=
g[h];g[h]=null;try{m()}catch(p){this.f(p)}}}this.a=null};c.prototype.f=function(g){this.c(function(){throw g;})};b.prototype.f=function(){function g(p){return function(u){m||(m=!0,p.call(h,u))}}var h=this,m=!1;return{resolve:g(this.m),reject:g(this.g)}};b.prototype.m=function(g){if(g===this)this.g(new TypeError("A Promise cannot resolve to itself"));else if(g instanceof b)this.o(g);else{a:switch(typeof g){case "object":var h=null!=g;break a;case "function":h=!0;break a;default:h=!1}h?this.u(g):this.h(g)}};
b.prototype.u=function(g){var h=void 0;try{h=g.then}catch(m){this.g(m);return}"function"==typeof h?this.v(h,g):this.h(g)};b.prototype.g=function(g){this.i(2,g)};b.prototype.h=function(g){this.i(1,g)};b.prototype.i=function(g,h){if(0!=this.b)throw Error("Cannot settle("+g+", "+h+"): Promise already settled in state"+this.b);this.b=g;this.c=h;this.l()};b.prototype.l=function(){if(null!=this.a){for(var g=0;g<this.a.length;++g)f.b(this.a[g]);this.a=null}};var f=new c;b.prototype.o=function(g){var h=this.f();
g.La(h.resolve,h.reject)};b.prototype.v=function(g,h){var m=this.f();try{g.call(h,m.resolve,m.reject)}catch(p){m.reject(p)}};b.prototype.then=function(g,h){function m(C,N){return"function"==typeof C?function(wa){try{p(C(wa))}catch(ld){u(ld)}}:N}var p,u,A=new b(function(C,N){p=C;u=N});this.La(m(g,p),m(h,u));return A};b.prototype.catch=function(g){return this.then(void 0,g)};b.prototype.La=function(g,h){function m(){switch(p.b){case 1:g(p.c);break;case 2:h(p.c);break;default:throw Error("Unexpected state: "+
p.b);}}var p=this;null==this.a?f.b(m):this.a.push(m)};b.resolve=d;b.reject=function(g){return new b(function(h,m){m(g)})};b.race=function(g){return new b(function(h,m){for(var p=ea(g),u=p.next();!u.done;u=p.next())d(u.value).La(h,m)})};b.all=function(g){var h=ea(g),m=h.next();return m.done?d([]):new b(function(p,u){function A(wa){return function(ld){C[wa]=ld;N--;0==N&&p(C)}}var C=[],N=0;do C.push(void 0),N++,d(m.value).La(A(C.length-1),u),m=h.next();while(!m.done)})};return b});
var fa=fa||{},l=this||self;function n(a){return"string"==typeof a}function ha(a){return"boolean"==typeof a}var ia=/^[\w+/_-]+[=]{0,2}$/,ja=null;function ka(){}
function la(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";
else if("function"==b&&"undefined"==typeof a.call)return"object";return b}function ma(a){return null===a}function na(a){return"array"==la(a)}function oa(a){var b=la(a);return"array"==b||"object"==b&&"number"==typeof a.length}function q(a){return"function"==la(a)}function r(a){var b=typeof a;return"object"==b&&null!=a||"function"==b}var pa="closure_uid_"+(1E9*Math.random()>>>0),qa=0;function ra(a,b,c){return a.call.apply(a.bind,arguments)}
function sa(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var e=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(e,d);return a.apply(b,e)}}return function(){return a.apply(b,arguments)}}function t(a,b,c){Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?t=ra:t=sa;return t.apply(null,arguments)}
function ta(a,b){var c=Array.prototype.slice.call(arguments,1);return function(){var d=c.slice();d.push.apply(d,arguments);return a.apply(this,d)}}var ua=Date.now||function(){return+new Date};function v(a,b){function c(){}c.prototype=b.prototype;a.qb=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.gd=function(d,e,f){for(var g=Array(arguments.length-2),h=2;h<arguments.length;h++)g[h-2]=arguments[h];return b.prototype[e].apply(d,g)}};function va(a){if(!a)return!1;try{return!!a.$goog_Thenable}catch(b){return!1}};function w(a){if(Error.captureStackTrace)Error.captureStackTrace(this,w);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a))}v(w,Error);w.prototype.name="CustomError";function xa(a,b){a=a.split("%s");for(var c="",d=a.length-1,e=0;e<d;e++)c+=a[e]+(e<b.length?b[e]:"%s");w.call(this,c+a[d])}v(xa,w);xa.prototype.name="AssertionError";function ya(a,b){throw new xa("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1));};function za(a,b){this.c=a;this.f=b;this.b=0;this.a=null}za.prototype.get=function(){if(0<this.b){this.b--;var a=this.a;this.a=a.next;a.next=null}else a=this.c();return a};function Aa(a,b){a.f(b);100>a.b&&(a.b++,b.next=a.a,a.a=b)};function Ba(){this.b=this.a=null}var Da=new za(function(){return new Ca},function(a){a.reset()});Ba.prototype.add=function(a,b){var c=Da.get();c.set(a,b);this.b?this.b.next=c:this.a=c;this.b=c};function Ea(){var a=Fa,b=null;a.a&&(b=a.a,a.a=a.a.next,a.a||(a.b=null),b.next=null);return b}function Ca(){this.next=this.b=this.a=null}Ca.prototype.set=function(a,b){this.a=a;this.b=b;this.next=null};Ca.prototype.reset=function(){this.next=this.b=this.a=null};function Ga(a,b){a:{try{var c=a&&a.ownerDocument,d=c&&(c.defaultView||c.parentWindow);d=d||l;if(d.Element&&d.Location){var e=d;break a}}catch(g){}e=null}if(e&&"undefined"!=typeof e[b]&&(!a||!(a instanceof e[b])&&(a instanceof e.Location||a instanceof e.Element))){if(r(a))try{var f=a.constructor.displayName||a.constructor.name||Object.prototype.toString.call(a)}catch(g){f="<object could not be stringified>"}else f=void 0===a?"undefined":null===a?"null":typeof a;ya("Argument is not a %s (or a non-Element, non-Location mock); got: %s",
b,f)}};var Ha=Array.prototype.indexOf?function(a,b){return Array.prototype.indexOf.call(a,b,void 0)}:function(a,b){if(n(a))return n(b)&&1==b.length?a.indexOf(b,0):-1;for(var c=0;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},x=Array.prototype.forEach?function(a,b,c){Array.prototype.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=n(a)?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)};function Ia(a,b){for(var c=n(a)?a.split(""):a,d=a.length-1;0<=d;--d)d in c&&b.call(void 0,c[d],d,a)}
var Ja=Array.prototype.map?function(a,b){return Array.prototype.map.call(a,b,void 0)}:function(a,b){for(var c=a.length,d=Array(c),e=n(a)?a.split(""):a,f=0;f<c;f++)f in e&&(d[f]=b.call(void 0,e[f],f,a));return d},Ka=Array.prototype.some?function(a,b){return Array.prototype.some.call(a,b,void 0)}:function(a,b){for(var c=a.length,d=n(a)?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a))return!0;return!1};
function La(a){a:{var b=Ma;for(var c=a.length,d=n(a)?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a)){b=e;break a}b=-1}return 0>b?null:n(a)?a.charAt(b):a[b]}function Na(a,b){return 0<=Ha(a,b)}function Oa(a,b){b=Ha(a,b);var c;(c=0<=b)&&Array.prototype.splice.call(a,b,1);return c}function Pa(a,b){var c=0;Ia(a,function(d,e){b.call(void 0,d,e,a)&&1==Array.prototype.splice.call(a,e,1).length&&c++})}function Qa(a){return Array.prototype.concat.apply([],arguments)}
function Ra(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return[]};function Sa(a,b){for(var c in a)b.call(void 0,a[c],c,a)}function Ta(a){for(var b in a)return!1;return!0}function Ua(a){var b={},c;for(c in a)b[c]=a[c];return b}var Va="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");function Wa(a,b){for(var c,d,e=1;e<arguments.length;e++){d=arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<Va.length;f++)c=Va[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c])}};function Xa(a,b){this.a=a===Ya&&b||"";this.b=Za}Xa.prototype.qa=!0;Xa.prototype.pa=function(){return this.a};Xa.prototype.toString=function(){return"Const{"+this.a+"}"};function $a(a){if(a instanceof Xa&&a.constructor===Xa&&a.b===Za)return a.a;ya("expected object of type Const, got '"+a+"'");return"type_error:Const"}var Za={},Ya={},ab=new Xa(Ya,"");function bb(){this.a="";this.b=cb}bb.prototype.qa=!0;bb.prototype.pa=function(){return this.a.toString()};bb.prototype.toString=function(){return"TrustedResourceUrl{"+this.a+"}"};function db(a){if(a instanceof bb&&a.constructor===bb&&a.b===cb)return a.a;ya("expected object of type TrustedResourceUrl, got '"+a+"' of type "+la(a));return"type_error:TrustedResourceUrl"}
function eb(a,b){var c=$a(a);if(!fb.test(c))throw Error("Invalid TrustedResourceUrl format: "+c);a=c.replace(gb,function(d,e){if(!Object.prototype.hasOwnProperty.call(b,e))throw Error('Found marker, "'+e+'", in format string, "'+c+'", but no valid label mapping found in args: '+JSON.stringify(b));d=b[e];return d instanceof Xa?$a(d):encodeURIComponent(String(d))});return hb(a)}var gb=/%{(\w+)}/g,fb=/^((https:)?\/\/[0-9a-z.:[\]-]+\/|\/[^/\\]|[^:/\\%]+\/|[^:/\\%]*[?#]|about:blank#)/i,cb={};
function hb(a){var b=new bb;b.a=a;return b};var ib=String.prototype.trim?function(a){return a.trim()}:function(a){return/^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1]},jb=/&/g,kb=/</g,lb=/>/g,mb=/"/g,nb=/'/g,ob=/\x00/g,pb=/[\x00&<>"']/;function y(a,b){return-1!=a.indexOf(b)}function qb(a,b){return a<b?-1:a>b?1:0};function rb(){this.a="";this.b=sb}rb.prototype.qa=!0;rb.prototype.pa=function(){return this.a.toString()};rb.prototype.toString=function(){return"SafeUrl{"+this.a+"}"};function tb(a){if(a instanceof rb&&a.constructor===rb&&a.b===sb)return a.a;ya("expected object of type SafeUrl, got '"+a+"' of type "+la(a));return"type_error:SafeUrl"}var ub=/^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;
function vb(a){if(a instanceof rb)return a;a="object"==typeof a&&a.qa?a.pa():String(a);ub.test(a)||(a="about:invalid#zClosurez");return wb(a)}var sb={};function wb(a){var b=new rb;b.a=a;return b}wb("about:blank");var xb;a:{var yb=l.navigator;if(yb){var zb=yb.userAgent;if(zb){xb=zb;break a}}xb=""}function z(a){return y(xb,a)};function Ab(){this.a="";this.b=Bb}Ab.prototype.qa=!0;Ab.prototype.pa=function(){return this.a.toString()};Ab.prototype.toString=function(){return"SafeHtml{"+this.a+"}"};function Cb(a){if(a instanceof Ab&&a.constructor===Ab&&a.b===Bb)return a.a;ya("expected object of type SafeHtml, got '"+a+"' of type "+la(a));return"type_error:SafeHtml"}var Bb={};function Db(a){var b=new Ab;b.a=a;return b}Db("<!DOCTYPE html>");var Eb=Db("");Db("<br>");function Fb(a){var b=hb($a(ab));Ga(a,"HTMLIFrameElement");a.src=db(b).toString()}function Gb(a,b){Ga(a,"HTMLScriptElement");a.src=db(b);if(null===ja)b:{b=l.document;if((b=b.querySelector&&b.querySelector("script[nonce]"))&&(b=b.nonce||b.getAttribute("nonce"))&&ia.test(b)){ja=b;break b}ja=""}b=ja;b&&a.setAttribute("nonce",b)};function Hb(a,b){for(var c=a.split("%s"),d="",e=Array.prototype.slice.call(arguments,1);e.length&&1<c.length;)d+=c.shift()+e.shift();return d+c.join("%s")}function Ib(a){pb.test(a)&&(-1!=a.indexOf("&")&&(a=a.replace(jb,"&amp;")),-1!=a.indexOf("<")&&(a=a.replace(kb,"&lt;")),-1!=a.indexOf(">")&&(a=a.replace(lb,"&gt;")),-1!=a.indexOf('"')&&(a=a.replace(mb,"&quot;")),-1!=a.indexOf("'")&&(a=a.replace(nb,"&#39;")),-1!=a.indexOf("\x00")&&(a=a.replace(ob,"&#0;")));return a};function Jb(a){l.setTimeout(function(){throw a;},0)}var Kb;
function Lb(){var a=l.MessageChannel;"undefined"===typeof a&&"undefined"!==typeof window&&window.postMessage&&window.addEventListener&&!z("Presto")&&(a=function(){var e=document.createElement("IFRAME");e.style.display="none";Fb(e);document.documentElement.appendChild(e);var f=e.contentWindow;e=f.document;e.open();e.write(Cb(Eb));e.close();var g="callImmediate"+Math.random(),h="file:"==f.location.protocol?"*":f.location.protocol+"//"+f.location.host;e=t(function(m){if(("*"==h||m.origin==h)&&m.data==
g)this.port1.onmessage()},this);f.addEventListener("message",e,!1);this.port1={};this.port2={postMessage:function(){f.postMessage(g,h)}}});if("undefined"!==typeof a&&!z("Trident")&&!z("MSIE")){var b=new a,c={},d=c;b.port1.onmessage=function(){if(void 0!==c.next){c=c.next;var e=c.yb;c.yb=null;e()}};return function(e){d.next={yb:e};d=d.next;b.port2.postMessage(0)}}return"undefined"!==typeof document&&"onreadystatechange"in document.createElement("SCRIPT")?function(e){var f=document.createElement("SCRIPT");
f.onreadystatechange=function(){f.onreadystatechange=null;f.parentNode.removeChild(f);f=null;e();e=null};document.documentElement.appendChild(f)}:function(e){l.setTimeout(e,0)}};function Mb(a,b){Nb||Ob();Pb||(Nb(),Pb=!0);Fa.add(a,b)}var Nb;function Ob(){if(l.Promise&&l.Promise.resolve){var a=l.Promise.resolve(void 0);Nb=function(){a.then(Qb)}}else Nb=function(){var b=Qb;!q(l.setImmediate)||l.Window&&l.Window.prototype&&!z("Edge")&&l.Window.prototype.setImmediate==l.setImmediate?(Kb||(Kb=Lb()),Kb(b)):l.setImmediate(b)}}var Pb=!1,Fa=new Ba;function Qb(){for(var a;a=Ea();){try{a.a.call(a.b)}catch(b){Jb(b)}Aa(Da,a)}Pb=!1};function B(a,b){this.a=Rb;this.i=void 0;this.f=this.b=this.c=null;this.g=this.h=!1;if(a!=ka)try{var c=this;a.call(b,function(d){Sb(c,Tb,d)},function(d){if(!(d instanceof Ub))try{if(d instanceof Error)throw d;throw Error("Promise rejected.");}catch(e){}Sb(c,Vb,d)})}catch(d){Sb(this,Vb,d)}}var Rb=0,Tb=2,Vb=3;function Wb(){this.next=this.f=this.b=this.g=this.a=null;this.c=!1}Wb.prototype.reset=function(){this.f=this.b=this.g=this.a=null;this.c=!1};var Xb=new za(function(){return new Wb},function(a){a.reset()});
function Yb(a,b,c){var d=Xb.get();d.g=a;d.b=b;d.f=c;return d}function D(a){if(a instanceof B)return a;var b=new B(ka);Sb(b,Tb,a);return b}function E(a){return new B(function(b,c){c(a)})}function Zb(a,b,c){$b(a,b,c,null)||Mb(ta(b,a))}function ac(a){return new B(function(b,c){var d=a.length,e=[];if(d)for(var f=function(p,u){d--;e[p]=u;0==d&&b(e)},g=function(p){c(p)},h=0,m;h<a.length;h++)m=a[h],Zb(m,ta(f,h),g);else b(e)})}
function bc(a){return new B(function(b){var c=a.length,d=[];if(c)for(var e=function(h,m,p){c--;d[h]=m?{Gb:!0,value:p}:{Gb:!1,reason:p};0==c&&b(d)},f=0,g;f<a.length;f++)g=a[f],Zb(g,ta(e,f,!0),ta(e,f,!1));else b(d)})}B.prototype.then=function(a,b,c){return cc(this,q(a)?a:null,q(b)?b:null,c)};B.prototype.$goog_Thenable=!0;k=B.prototype;k.ka=function(a,b){a=Yb(a,a,b);a.c=!0;dc(this,a);return this};k.s=function(a,b){return cc(this,null,a,b)};
k.cancel=function(a){this.a==Rb&&Mb(function(){var b=new Ub(a);ec(this,b)},this)};function ec(a,b){if(a.a==Rb)if(a.c){var c=a.c;if(c.b){for(var d=0,e=null,f=null,g=c.b;g&&(g.c||(d++,g.a==a&&(e=g),!(e&&1<d)));g=g.next)e||(f=g);e&&(c.a==Rb&&1==d?ec(c,b):(f?(d=f,d.next==c.f&&(c.f=d),d.next=d.next.next):fc(c),gc(c,e,Vb,b)))}a.c=null}else Sb(a,Vb,b)}function dc(a,b){a.b||a.a!=Tb&&a.a!=Vb||hc(a);a.f?a.f.next=b:a.b=b;a.f=b}
function cc(a,b,c,d){var e=Yb(null,null,null);e.a=new B(function(f,g){e.g=b?function(h){try{var m=b.call(d,h);f(m)}catch(p){g(p)}}:f;e.b=c?function(h){try{var m=c.call(d,h);void 0===m&&h instanceof Ub?g(h):f(m)}catch(p){g(p)}}:g});e.a.c=a;dc(a,e);return e.a}k.Oc=function(a){this.a=Rb;Sb(this,Tb,a)};k.Pc=function(a){this.a=Rb;Sb(this,Vb,a)};
function Sb(a,b,c){a.a==Rb&&(a===c&&(b=Vb,c=new TypeError("Promise cannot resolve to itself")),a.a=1,$b(c,a.Oc,a.Pc,a)||(a.i=c,a.a=b,a.c=null,hc(a),b!=Vb||c instanceof Ub||ic(a,c)))}function $b(a,b,c,d){if(a instanceof B)return dc(a,Yb(b||ka,c||null,d)),!0;if(va(a))return a.then(b,c,d),!0;if(r(a))try{var e=a.then;if(q(e))return jc(a,e,b,c,d),!0}catch(f){return c.call(d,f),!0}return!1}
function jc(a,b,c,d,e){function f(m){h||(h=!0,d.call(e,m))}function g(m){h||(h=!0,c.call(e,m))}var h=!1;try{b.call(a,g,f)}catch(m){f(m)}}function hc(a){a.h||(a.h=!0,Mb(a.Zb,a))}function fc(a){var b=null;a.b&&(b=a.b,a.b=b.next,b.next=null);a.b||(a.f=null);return b}k.Zb=function(){for(var a;a=fc(this);)gc(this,a,this.a,this.i);this.h=!1};
function gc(a,b,c,d){if(c==Vb&&b.b&&!b.c)for(;a&&a.g;a=a.c)a.g=!1;if(b.a)b.a.c=null,kc(b,c,d);else try{b.c?b.g.call(b.f):kc(b,c,d)}catch(e){lc.call(null,e)}Aa(Xb,b)}function kc(a,b,c){b==Tb?a.g.call(a.f,c):a.b&&a.b.call(a.f,c)}function ic(a,b){a.g=!0;Mb(function(){a.g&&lc.call(null,b)})}var lc=Jb;function Ub(a){w.call(this,a)}v(Ub,w);Ub.prototype.name="cancel";function mc(){0!=nc&&(oc[this[pa]||(this[pa]=++qa)]=this);this.va=this.va;this.la=this.la}var nc=0,oc={};mc.prototype.va=!1;function pc(a){if(!a.va&&(a.va=!0,a.za(),0!=nc)){var b=a[pa]||(a[pa]=++qa);if(0!=nc&&a.la&&0<a.la.length)throw Error(a+" did not empty its onDisposeCallbacks queue. This probably means it overrode dispose() or disposeInternal() without calling the superclass' method.");delete oc[b]}}mc.prototype.za=function(){if(this.la)for(;this.la.length;)this.la.shift()()};function qc(a){qc[" "](a);return a}qc[" "]=ka;function rc(a,b){var c=sc;return Object.prototype.hasOwnProperty.call(c,a)?c[a]:c[a]=b(a)};var tc=z("Opera"),uc=z("Trident")||z("MSIE"),vc=z("Edge"),wc=vc||uc,xc=z("Gecko")&&!(y(xb.toLowerCase(),"webkit")&&!z("Edge"))&&!(z("Trident")||z("MSIE"))&&!z("Edge"),yc=y(xb.toLowerCase(),"webkit")&&!z("Edge");function zc(){var a=l.document;return a?a.documentMode:void 0}var Ac;
a:{var Bc="",Cc=function(){var a=xb;if(xc)return/rv:([^\);]+)(\)|;)/.exec(a);if(vc)return/Edge\/([\d\.]+)/.exec(a);if(uc)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(yc)return/WebKit\/(\S+)/.exec(a);if(tc)return/(?:Version)[ \/]?(\S+)/.exec(a)}();Cc&&(Bc=Cc?Cc[1]:"");if(uc){var Dc=zc();if(null!=Dc&&Dc>parseFloat(Bc)){Ac=String(Dc);break a}}Ac=Bc}var sc={};
function Ec(a){return rc(a,function(){for(var b=0,c=ib(String(Ac)).split("."),d=ib(String(a)).split("."),e=Math.max(c.length,d.length),f=0;0==b&&f<e;f++){var g=c[f]||"",h=d[f]||"";do{g=/(\d*)(\D*)(.*)/.exec(g)||["","","",""];h=/(\d*)(\D*)(.*)/.exec(h)||["","","",""];if(0==g[0].length&&0==h[0].length)break;b=qb(0==g[1].length?0:parseInt(g[1],10),0==h[1].length?0:parseInt(h[1],10))||qb(0==g[2].length,0==h[2].length)||qb(g[2],h[2]);g=g[3];h=h[3]}while(0==b)}return 0<=b})}var Fc;
Fc=l.document&&uc?zc():void 0;var Gc=Object.freeze||function(a){return a};var Hc=!uc||9<=Number(Fc),Ic=uc&&!Ec("9"),Jc=function(){if(!l.addEventListener||!Object.defineProperty)return!1;var a=!1,b=Object.defineProperty({},"passive",{get:function(){a=!0}});try{l.addEventListener("test",ka,b),l.removeEventListener("test",ka,b)}catch(c){}return a}();function F(a,b){this.type=a;this.b=this.target=b;this.Mb=!0}F.prototype.preventDefault=function(){this.Mb=!1};function Kc(a,b){F.call(this,a?a.type:"");this.relatedTarget=this.b=this.target=null;this.button=this.screenY=this.screenX=this.clientY=this.clientX=0;this.key="";this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.pointerId=0;this.pointerType="";this.a=null;if(a){var c=this.type=a.type,d=a.changedTouches&&a.changedTouches.length?a.changedTouches[0]:null;this.target=a.target||a.srcElement;this.b=b;if(b=a.relatedTarget){if(xc){a:{try{qc(b.nodeName);var e=!0;break a}catch(f){}e=!1}e||(b=null)}}else"mouseover"==
c?b=a.fromElement:"mouseout"==c&&(b=a.toElement);this.relatedTarget=b;d?(this.clientX=void 0!==d.clientX?d.clientX:d.pageX,this.clientY=void 0!==d.clientY?d.clientY:d.pageY,this.screenX=d.screenX||0,this.screenY=d.screenY||0):(this.clientX=void 0!==a.clientX?a.clientX:a.pageX,this.clientY=void 0!==a.clientY?a.clientY:a.pageY,this.screenX=a.screenX||0,this.screenY=a.screenY||0);this.button=a.button;this.key=a.key||"";this.ctrlKey=a.ctrlKey;this.altKey=a.altKey;this.shiftKey=a.shiftKey;this.metaKey=
a.metaKey;this.pointerId=a.pointerId||0;this.pointerType=n(a.pointerType)?a.pointerType:Lc[a.pointerType]||"";this.a=a;a.defaultPrevented&&this.preventDefault()}}v(Kc,F);var Lc=Gc({2:"touch",3:"pen",4:"mouse"});Kc.prototype.preventDefault=function(){Kc.qb.preventDefault.call(this);var a=this.a;if(a.preventDefault)a.preventDefault();else if(a.returnValue=!1,Ic)try{if(a.ctrlKey||112<=a.keyCode&&123>=a.keyCode)a.keyCode=-1}catch(b){}};Kc.prototype.f=function(){return this.a};var Mc="closure_listenable_"+(1E6*Math.random()|0),Nc=0;function Oc(a,b,c,d,e){this.listener=a;this.proxy=null;this.src=b;this.type=c;this.capture=!!d;this.Pa=e;this.key=++Nc;this.ta=this.Ka=!1}function Pc(a){a.ta=!0;a.listener=null;a.proxy=null;a.src=null;a.Pa=null};function Qc(a){this.src=a;this.a={};this.b=0}Qc.prototype.add=function(a,b,c,d,e){var f=a.toString();a=this.a[f];a||(a=this.a[f]=[],this.b++);var g=Rc(a,b,d,e);-1<g?(b=a[g],c||(b.Ka=!1)):(b=new Oc(b,this.src,f,!!d,e),b.Ka=c,a.push(b));return b};function Sc(a,b){var c=b.type;c in a.a&&Oa(a.a[c],b)&&(Pc(b),0==a.a[c].length&&(delete a.a[c],a.b--))}function Rc(a,b,c,d){for(var e=0;e<a.length;++e){var f=a[e];if(!f.ta&&f.listener==b&&f.capture==!!c&&f.Pa==d)return e}return-1};var Tc="closure_lm_"+(1E6*Math.random()|0),Uc={},Vc=0;function Wc(a,b,c,d,e){if(d&&d.once)Xc(a,b,c,d,e);else if(na(b))for(var f=0;f<b.length;f++)Wc(a,b[f],c,d,e);else c=Yc(c),a&&a[Mc]?Zc(a,b,c,r(d)?!!d.capture:!!d,e):$c(a,b,c,!1,d,e)}
function $c(a,b,c,d,e,f){if(!b)throw Error("Invalid event type");var g=r(e)?!!e.capture:!!e,h=ad(a);h||(a[Tc]=h=new Qc(a));c=h.add(b,c,d,g,f);if(!c.proxy){d=bd();c.proxy=d;d.src=a;d.listener=c;if(a.addEventListener)Jc||(e=g),void 0===e&&(e=!1),a.addEventListener(b.toString(),d,e);else if(a.attachEvent)a.attachEvent(cd(b.toString()),d);else if(a.addListener&&a.removeListener)a.addListener(d);else throw Error("addEventListener and attachEvent are unavailable.");Vc++}}
function bd(){var a=dd,b=Hc?function(c){return a.call(b.src,b.listener,c)}:function(c){c=a.call(b.src,b.listener,c);if(!c)return c};return b}function Xc(a,b,c,d,e){if(na(b))for(var f=0;f<b.length;f++)Xc(a,b[f],c,d,e);else c=Yc(c),a&&a[Mc]?ed(a,b,c,r(d)?!!d.capture:!!d,e):$c(a,b,c,!0,d,e)}
function fd(a,b,c,d,e){if(na(b))for(var f=0;f<b.length;f++)fd(a,b[f],c,d,e);else(d=r(d)?!!d.capture:!!d,c=Yc(c),a&&a[Mc])?(a=a.u,b=String(b).toString(),b in a.a&&(f=a.a[b],c=Rc(f,c,d,e),-1<c&&(Pc(f[c]),Array.prototype.splice.call(f,c,1),0==f.length&&(delete a.a[b],a.b--)))):a&&(a=ad(a))&&(b=a.a[b.toString()],a=-1,b&&(a=Rc(b,c,d,e)),(c=-1<a?b[a]:null)&&gd(c))}
function gd(a){if("number"!=typeof a&&a&&!a.ta){var b=a.src;if(b&&b[Mc])Sc(b.u,a);else{var c=a.type,d=a.proxy;b.removeEventListener?b.removeEventListener(c,d,a.capture):b.detachEvent?b.detachEvent(cd(c),d):b.addListener&&b.removeListener&&b.removeListener(d);Vc--;(c=ad(b))?(Sc(c,a),0==c.b&&(c.src=null,b[Tc]=null)):Pc(a)}}}function cd(a){return a in Uc?Uc[a]:Uc[a]="on"+a}
function hd(a,b,c,d){var e=!0;if(a=ad(a))if(b=a.a[b.toString()])for(b=b.concat(),a=0;a<b.length;a++){var f=b[a];f&&f.capture==c&&!f.ta&&(f=id(f,d),e=e&&!1!==f)}return e}function id(a,b){var c=a.listener,d=a.Pa||a.src;a.Ka&&gd(a);return c.call(d,b)}
function dd(a,b){if(a.ta)return!0;if(!Hc){if(!b)a:{b=["window","event"];for(var c=l,d=0;d<b.length;d++)if(c=c[b[d]],null==c){b=null;break a}b=c}d=b;b=new Kc(d,this);c=!0;if(!(0>d.keyCode||void 0!=d.returnValue)){a:{var e=!1;if(0==d.keyCode)try{d.keyCode=-1;break a}catch(g){e=!0}if(e||void 0==d.returnValue)d.returnValue=!0}d=[];for(e=b.b;e;e=e.parentNode)d.push(e);a=a.type;for(e=d.length-1;0<=e;e--){b.b=d[e];var f=hd(d[e],a,!0,b);c=c&&f}for(e=0;e<d.length;e++)b.b=d[e],f=hd(d[e],a,!1,b),c=c&&f}return c}return id(a,
new Kc(b,this))}function ad(a){a=a[Tc];return a instanceof Qc?a:null}var jd="__closure_events_fn_"+(1E9*Math.random()>>>0);function Yc(a){if(q(a))return a;a[jd]||(a[jd]=function(b){return a.handleEvent(b)});return a[jd]};function G(){mc.call(this);this.u=new Qc(this);this.Sb=this;this.Xa=null}v(G,mc);G.prototype[Mc]=!0;G.prototype.addEventListener=function(a,b,c,d){Wc(this,a,b,c,d)};G.prototype.removeEventListener=function(a,b,c,d){fd(this,a,b,c,d)};
G.prototype.dispatchEvent=function(a){var b,c=this.Xa;if(c)for(b=[];c;c=c.Xa)b.push(c);c=this.Sb;var d=a.type||a;if(n(a))a=new F(a,c);else if(a instanceof F)a.target=a.target||c;else{var e=a;a=new F(d,c);Wa(a,e)}e=!0;if(b)for(var f=b.length-1;0<=f;f--){var g=a.b=b[f];e=kd(g,d,!0,a)&&e}g=a.b=c;e=kd(g,d,!0,a)&&e;e=kd(g,d,!1,a)&&e;if(b)for(f=0;f<b.length;f++)g=a.b=b[f],e=kd(g,d,!1,a)&&e;return e};
G.prototype.za=function(){G.qb.za.call(this);if(this.u){var a=this.u,b=0,c;for(c in a.a){for(var d=a.a[c],e=0;e<d.length;e++)++b,Pc(d[e]);delete a.a[c];a.b--}}this.Xa=null};function Zc(a,b,c,d,e){a.u.add(String(b),c,!1,d,e)}function ed(a,b,c,d,e){a.u.add(String(b),c,!0,d,e)}
function kd(a,b,c,d){b=a.u.a[String(b)];if(!b)return!0;b=b.concat();for(var e=!0,f=0;f<b.length;++f){var g=b[f];if(g&&!g.ta&&g.capture==c){var h=g.listener,m=g.Pa||g.src;g.Ka&&Sc(a.u,g);e=!1!==h.call(m,d)&&e}}return e&&0!=d.Mb};function md(a,b,c){if(q(a))c&&(a=t(a,c));else if(a&&"function"==typeof a.handleEvent)a=t(a.handleEvent,a);else throw Error("Invalid listener argument");return 2147483647<Number(b)?-1:l.setTimeout(a,b||0)}function nd(a){var b=null;return(new B(function(c,d){b=md(function(){c(void 0)},a);-1==b&&d(Error("Failed to schedule timer."))})).s(function(c){l.clearTimeout(b);throw c;})};function od(a){if(a.U&&"function"==typeof a.U)return a.U();if(n(a))return a.split("");if(oa(a)){for(var b=[],c=a.length,d=0;d<c;d++)b.push(a[d]);return b}b=[];c=0;for(d in a)b[c++]=a[d];return b}function pd(a){if(a.X&&"function"==typeof a.X)return a.X();if(!a.U||"function"!=typeof a.U){if(oa(a)||n(a)){var b=[];a=a.length;for(var c=0;c<a;c++)b.push(c);return b}b=[];c=0;for(var d in a)b[c++]=d;return b}}
function qd(a,b){if(a.forEach&&"function"==typeof a.forEach)a.forEach(b,void 0);else if(oa(a)||n(a))x(a,b,void 0);else for(var c=pd(a),d=od(a),e=d.length,f=0;f<e;f++)b.call(void 0,d[f],c&&c[f],a)};function rd(a,b){this.b={};this.a=[];this.c=0;var c=arguments.length;if(1<c){if(c%2)throw Error("Uneven number of arguments");for(var d=0;d<c;d+=2)this.set(arguments[d],arguments[d+1])}else if(a)if(a instanceof rd)for(c=a.X(),d=0;d<c.length;d++)this.set(c[d],a.get(c[d]));else for(d in a)this.set(d,a[d])}k=rd.prototype;k.U=function(){sd(this);for(var a=[],b=0;b<this.a.length;b++)a.push(this.b[this.a[b]]);return a};k.X=function(){sd(this);return this.a.concat()};
k.clear=function(){this.b={};this.c=this.a.length=0};function sd(a){if(a.c!=a.a.length){for(var b=0,c=0;b<a.a.length;){var d=a.a[b];td(a.b,d)&&(a.a[c++]=d);b++}a.a.length=c}if(a.c!=a.a.length){var e={};for(c=b=0;b<a.a.length;)d=a.a[b],td(e,d)||(a.a[c++]=d,e[d]=1),b++;a.a.length=c}}k.get=function(a,b){return td(this.b,a)?this.b[a]:b};k.set=function(a,b){td(this.b,a)||(this.c++,this.a.push(a));this.b[a]=b};
k.forEach=function(a,b){for(var c=this.X(),d=0;d<c.length;d++){var e=c[d],f=this.get(e);a.call(b,f,e,this)}};function td(a,b){return Object.prototype.hasOwnProperty.call(a,b)};var ud=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;function vd(a,b){if(a){a=a.split("&");for(var c=0;c<a.length;c++){var d=a[c].indexOf("="),e=null;if(0<=d){var f=a[c].substring(0,d);e=a[c].substring(d+1)}else f=a[c];b(f,e?decodeURIComponent(e.replace(/\+/g," ")):"")}}};function wd(a,b){this.b=this.i=this.f="";this.l=null;this.g=this.c="";this.h=!1;var c;a instanceof wd?(this.h=void 0!==b?b:a.h,xd(this,a.f),this.i=a.i,this.b=a.b,yd(this,a.l),this.c=a.c,zd(this,Ad(a.a)),this.g=a.g):a&&(c=String(a).match(ud))?(this.h=!!b,xd(this,c[1]||"",!0),this.i=Bd(c[2]||""),this.b=Bd(c[3]||"",!0),yd(this,c[4]),this.c=Bd(c[5]||"",!0),zd(this,c[6]||"",!0),this.g=Bd(c[7]||"")):(this.h=!!b,this.a=new Cd(null,this.h))}
wd.prototype.toString=function(){var a=[],b=this.f;b&&a.push(Dd(b,Ed,!0),":");var c=this.b;if(c||"file"==b)a.push("//"),(b=this.i)&&a.push(Dd(b,Ed,!0),"@"),a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g,"%$1")),c=this.l,null!=c&&a.push(":",String(c));if(c=this.c)this.b&&"/"!=c.charAt(0)&&a.push("/"),a.push(Dd(c,"/"==c.charAt(0)?Fd:Gd,!0));(c=this.a.toString())&&a.push("?",c);(c=this.g)&&a.push("#",Dd(c,Hd));return a.join("")};
wd.prototype.resolve=function(a){var b=new wd(this),c=!!a.f;c?xd(b,a.f):c=!!a.i;c?b.i=a.i:c=!!a.b;c?b.b=a.b:c=null!=a.l;var d=a.c;if(c)yd(b,a.l);else if(c=!!a.c){if("/"!=d.charAt(0))if(this.b&&!this.c)d="/"+d;else{var e=b.c.lastIndexOf("/");-1!=e&&(d=b.c.substr(0,e+1)+d)}e=d;if(".."==e||"."==e)d="";else if(y(e,"./")||y(e,"/.")){d=0==e.lastIndexOf("/",0);e=e.split("/");for(var f=[],g=0;g<e.length;){var h=e[g++];"."==h?d&&g==e.length&&f.push(""):".."==h?((1<f.length||1==f.length&&""!=f[0])&&f.pop(),
d&&g==e.length&&f.push("")):(f.push(h),d=!0)}d=f.join("/")}else d=e}c?b.c=d:c=""!==a.a.toString();c?zd(b,Ad(a.a)):c=!!a.g;c&&(b.g=a.g);return b};function xd(a,b,c){a.f=c?Bd(b,!0):b;a.f&&(a.f=a.f.replace(/:$/,""))}function yd(a,b){if(b){b=Number(b);if(isNaN(b)||0>b)throw Error("Bad port number "+b);a.l=b}else a.l=null}function zd(a,b,c){b instanceof Cd?(a.a=b,Id(a.a,a.h)):(c||(b=Dd(b,Jd)),a.a=new Cd(b,a.h))}function H(a,b,c){a.a.set(b,c)}function Kd(a,b){return a.a.get(b)}
function Ld(a){return a instanceof wd?new wd(a):new wd(a,void 0)}function Md(a,b){var c=new wd(null,void 0);xd(c,"https");a&&(c.b=a);b&&(c.c=b);return c}function Bd(a,b){return a?b?decodeURI(a.replace(/%25/g,"%2525")):decodeURIComponent(a):""}function Dd(a,b,c){return n(a)?(a=encodeURI(a).replace(b,Nd),c&&(a=a.replace(/%25([0-9a-fA-F]{2})/g,"%$1")),a):null}function Nd(a){a=a.charCodeAt(0);return"%"+(a>>4&15).toString(16)+(a&15).toString(16)}
var Ed=/[#\/\?@]/g,Gd=/[#\?:]/g,Fd=/[#\?]/g,Jd=/[#\?@]/g,Hd=/#/g;function Cd(a,b){this.b=this.a=null;this.c=a||null;this.f=!!b}function Od(a){a.a||(a.a=new rd,a.b=0,a.c&&vd(a.c,function(b,c){a.add(decodeURIComponent(b.replace(/\+/g," ")),c)}))}function Pd(a){var b=pd(a);if("undefined"==typeof b)throw Error("Keys are undefined");var c=new Cd(null,void 0);a=od(a);for(var d=0;d<b.length;d++){var e=b[d],f=a[d];na(f)?Qd(c,e,f):c.add(e,f)}return c}k=Cd.prototype;
k.add=function(a,b){Od(this);this.c=null;a=Rd(this,a);var c=this.a.get(a);c||this.a.set(a,c=[]);c.push(b);this.b+=1;return this};function Sd(a,b){Od(a);b=Rd(a,b);td(a.a.b,b)&&(a.c=null,a.b-=a.a.get(b).length,a=a.a,td(a.b,b)&&(delete a.b[b],a.c--,a.a.length>2*a.c&&sd(a)))}k.clear=function(){this.a=this.c=null;this.b=0};function Td(a,b){Od(a);b=Rd(a,b);return td(a.a.b,b)}k.forEach=function(a,b){Od(this);this.a.forEach(function(c,d){x(c,function(e){a.call(b,e,d,this)},this)},this)};
k.X=function(){Od(this);for(var a=this.a.U(),b=this.a.X(),c=[],d=0;d<b.length;d++)for(var e=a[d],f=0;f<e.length;f++)c.push(b[d]);return c};k.U=function(a){Od(this);var b=[];if(n(a))Td(this,a)&&(b=Qa(b,this.a.get(Rd(this,a))));else{a=this.a.U();for(var c=0;c<a.length;c++)b=Qa(b,a[c])}return b};k.set=function(a,b){Od(this);this.c=null;a=Rd(this,a);Td(this,a)&&(this.b-=this.a.get(a).length);this.a.set(a,[b]);this.b+=1;return this};
k.get=function(a,b){if(!a)return b;a=this.U(a);return 0<a.length?String(a[0]):b};function Qd(a,b,c){Sd(a,b);0<c.length&&(a.c=null,a.a.set(Rd(a,b),Ra(c)),a.b+=c.length)}k.toString=function(){if(this.c)return this.c;if(!this.a)return"";for(var a=[],b=this.a.X(),c=0;c<b.length;c++){var d=b[c],e=encodeURIComponent(String(d));d=this.U(d);for(var f=0;f<d.length;f++){var g=e;""!==d[f]&&(g+="="+encodeURIComponent(String(d[f])));a.push(g)}}return this.c=a.join("&")};
function Ad(a){var b=new Cd;b.c=a.c;a.a&&(b.a=new rd(a.a),b.b=a.b);return b}function Rd(a,b){b=String(b);a.f&&(b=b.toLowerCase());return b}function Id(a,b){b&&!a.f&&(Od(a),a.c=null,a.a.forEach(function(c,d){var e=d.toLowerCase();d!=e&&(Sd(this,d),Qd(this,e,c))},a));a.f=b};var Ud=!uc||9<=Number(Fc);function Vd(a){var b=document;return n(a)?b.getElementById(a):a}function Wd(a,b){Sa(b,function(c,d){c&&"object"==typeof c&&c.qa&&(c=c.pa());"style"==d?a.style.cssText=c:"class"==d?a.className=c:"for"==d?a.htmlFor=c:Xd.hasOwnProperty(d)?a.setAttribute(Xd[d],c):0==d.lastIndexOf("aria-",0)||0==d.lastIndexOf("data-",0)?a.setAttribute(d,c):a[d]=c})}
var Xd={cellpadding:"cellPadding",cellspacing:"cellSpacing",colspan:"colSpan",frameborder:"frameBorder",height:"height",maxlength:"maxLength",nonce:"nonce",role:"role",rowspan:"rowSpan",type:"type",usemap:"useMap",valign:"vAlign",width:"width"};
function Yd(a,b,c){var d=arguments,e=document,f=String(d[0]),g=d[1];if(!Ud&&g&&(g.name||g.type)){f=["<",f];g.name&&f.push(' name="',Ib(g.name),'"');if(g.type){f.push(' type="',Ib(g.type),'"');var h={};Wa(h,g);delete h.type;g=h}f.push(">");f=f.join("")}f=e.createElement(f);g&&(n(g)?f.className=g:na(g)?f.className=g.join(" "):Wd(f,g));2<d.length&&Zd(e,f,d);return f}
function Zd(a,b,c){function d(g){g&&b.appendChild(n(g)?a.createTextNode(g):g)}for(var e=2;e<c.length;e++){var f=c[e];!oa(f)||r(f)&&0<f.nodeType?d(f):x($d(f)?Ra(f):f,d)}}function $d(a){if(a&&"number"==typeof a.length){if(r(a))return"function"==typeof a.item||"string"==typeof a.item;if(q(a))return"function"==typeof a.item}return!1};function ae(a){var b=[];be(new ce,a,b);return b.join("")}function ce(){}
function be(a,b,c){if(null==b)c.push("null");else{if("object"==typeof b){if(na(b)){var d=b;b=d.length;c.push("[");for(var e="",f=0;f<b;f++)c.push(e),be(a,d[f],c),e=",";c.push("]");return}if(b instanceof String||b instanceof Number||b instanceof Boolean)b=b.valueOf();else{c.push("{");e="";for(d in b)Object.prototype.hasOwnProperty.call(b,d)&&(f=b[d],"function"!=typeof f&&(c.push(e),de(d,c),c.push(":"),be(a,f,c),e=","));c.push("}");return}}switch(typeof b){case "string":de(b,c);break;case "number":c.push(isFinite(b)&&
!isNaN(b)?String(b):"null");break;case "boolean":c.push(String(b));break;case "function":c.push("null");break;default:throw Error("Unknown type: "+typeof b);}}}var ee={'"':'\\"',"\\":"\\\\","/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},fe=/\uffff/.test("\uffff")?/[\\"\x00-\x1f\x7f-\uffff]/g:/[\\"\x00-\x1f\x7f-\xff]/g;
function de(a,b){b.push('"',a.replace(fe,function(c){var d=ee[c];d||(d="\\u"+(c.charCodeAt(0)|65536).toString(16).substr(1),ee[c]=d);return d}),'"')};/*

 Copyright 2017 Google Inc.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
function ge(){var a=I();return uc&&!!Fc&&11==Fc||/Edge\/\d+/.test(a)}function he(){return l.window&&l.window.location.href||self&&self.location&&self.location.href||""}function ie(a,b){b=b||l.window;var c="about:blank";a&&(c=tb(vb(a)).toString());b.location.href=c}function je(a,b){var c=[],d;for(d in a)d in b?typeof a[d]!=typeof b[d]?c.push(d):"object"==typeof a[d]&&null!=a[d]&&null!=b[d]?0<je(a[d],b[d]).length&&c.push(d):a[d]!==b[d]&&c.push(d):c.push(d);for(d in b)d in a||c.push(d);return c}
function ke(){var a=I();a=le(a)!=me?null:(a=a.match(/\sChrome\/(\d+)/i))&&2==a.length?parseInt(a[1],10):null;return a&&30>a?!1:!uc||!Fc||9<Fc}function ne(a){a=(a||I()).toLowerCase();return a.match(/android/)||a.match(/webos/)||a.match(/iphone|ipad|ipod/)||a.match(/blackberry/)||a.match(/windows phone/)||a.match(/iemobile/)?!0:!1}function oe(a){a=a||l.window;try{a.close()}catch(b){}}
function pe(a,b,c){var d=Math.floor(1E9*Math.random()).toString();b=b||500;c=c||600;var e=(window.screen.availHeight-c)/2,f=(window.screen.availWidth-b)/2;b={width:b,height:c,top:0<e?e:0,left:0<f?f:0,location:!0,resizable:!0,statusbar:!0,toolbar:!1};c=I().toLowerCase();d&&(b.target=d,y(c,"crios/")&&(b.target="_blank"));le(I())==qe&&(a=a||"http://localhost",b.scrollbars=!0);c=a||"";(a=b)||(a={});d=window;b=c instanceof rb?c:vb("undefined"!=typeof c.href?c.href:String(c));c=a.target||c.target;e=[];
for(g in a)switch(g){case "width":case "height":case "top":case "left":e.push(g+"="+a[g]);break;case "target":case "noopener":case "noreferrer":break;default:e.push(g+"="+(a[g]?1:0))}var g=e.join(",");(z("iPhone")&&!z("iPod")&&!z("iPad")||z("iPad")||z("iPod"))&&d.navigator&&d.navigator.standalone&&c&&"_self"!=c?(g=d.document.createElement("A"),Ga(g,"HTMLAnchorElement"),b instanceof rb||b instanceof rb||(b="object"==typeof b&&b.qa?b.pa():String(b),ub.test(b)||(b="about:invalid#zClosurez"),b=wb(b)),
g.href=tb(b),g.setAttribute("target",c),a.noreferrer&&g.setAttribute("rel","noreferrer"),a=document.createEvent("MouseEvent"),a.initMouseEvent("click",!0,!0,d,1),g.dispatchEvent(a),g={}):a.noreferrer?(g=d.open("",c,g),a=tb(b).toString(),g&&(wc&&y(a,";")&&(a="'"+a.replace(/'/g,"%27")+"'"),g.opener=null,a=Db('<meta name="referrer" content="no-referrer"><meta http-equiv="refresh" content="0; url='+Ib(a)+'">'),g.document.write(Cb(a)),g.document.close())):(g=d.open(tb(b).toString(),c,g))&&a.noopener&&
(g.opener=null);if(g)try{g.focus()}catch(h){}return g}function re(a){return new B(function(b){function c(){nd(2E3).then(function(){if(!a||a.closed)b();else return c()})}return c()})}var se=/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/,te=/^[^@]+@[^@]+$/;function ue(){var a=null;return(new B(function(b){"complete"==l.document.readyState?b():(a=function(){b()},Xc(window,"load",a))})).s(function(b){fd(window,"load",a);throw b;})}
function ve(){return we(void 0)?ue().then(function(){return new B(function(a,b){var c=l.document,d=setTimeout(function(){b(Error("Cordova framework is not ready."))},1E3);c.addEventListener("deviceready",function(){clearTimeout(d);a()},!1)})}):E(Error("Cordova must run in an Android or iOS file scheme."))}function we(a){a=a||I();return!("file:"!==xe()&&"ionic:"!==xe()||!a.toLowerCase().match(/iphone|ipad|ipod|android/))}function ye(){var a=l.window;try{return!(!a||a==a.top)}catch(b){return!1}}
function ze(){return"undefined"!==typeof l.WorkerGlobalScope&&"function"===typeof l.importScripts}function Ae(){return __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.hasOwnProperty("reactNative")?"ReactNative":__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.hasOwnProperty("node")?"Node":ze()?"Worker":"Browser"}function Be(){var a=Ae();return"ReactNative"===a||"Node"===a}function Ce(){for(var a=50,b=[];0<a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62*Math.random()))),a--;return b.join("")}
var qe="Firefox",me="Chrome";
function le(a){var b=a.toLowerCase();if(y(b,"opera/")||y(b,"opr/")||y(b,"opios/"))return"Opera";if(y(b,"iemobile"))return"IEMobile";if(y(b,"msie")||y(b,"trident/"))return"IE";if(y(b,"edge/"))return"Edge";if(y(b,"firefox/"))return qe;if(y(b,"silk/"))return"Silk";if(y(b,"blackberry"))return"Blackberry";if(y(b,"webos"))return"Webos";if(!y(b,"safari/")||y(b,"chrome/")||y(b,"crios/")||y(b,"android"))if(!y(b,"chrome/")&&!y(b,"crios/")||y(b,"edge/")){if(y(b,"android"))return"Android";if((a=a.match(/([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/))&&
2==a.length)return a[1]}else return me;else return"Safari";return"Other"}var De={Wc:"FirebaseCore-web",Yc:"FirebaseUI-web"};function Ee(a,b){b=b||[];var c=[],d={},e;for(e in De)d[De[e]]=!0;for(e=0;e<b.length;e++)"undefined"!==typeof d[b[e]]&&(delete d[b[e]],c.push(b[e]));c.sort();b=c;b.length||(b=["FirebaseCore-web"]);c=Ae();"Browser"===c?(d=I(),c=le(d)):"Worker"===c&&(d=I(),c=le(d)+"-"+c);return c+"/JsCore/"+a+"/"+b.join(",")}function I(){return l.navigator&&l.navigator.userAgent||""}
function J(a,b){a=a.split(".");b=b||l;for(var c=0;c<a.length&&"object"==typeof b&&null!=b;c++)b=b[a[c]];c!=a.length&&(b=void 0);return b}function Fe(){try{var a=l.localStorage,b=Ge();if(a)return a.setItem(b,"1"),a.removeItem(b),ge()?!!l.indexedDB:!0}catch(c){return ze()&&!!l.indexedDB}return!1}function He(){return(Ie()||"chrome-extension:"===xe()||we())&&!Be()&&Fe()&&!ze()}function Ie(){return"http:"===xe()||"https:"===xe()}function xe(){return l.location&&l.location.protocol||null}
function Je(a){a=a||I();return ne(a)||le(a)==qe?!1:!0}function Ke(a){return"undefined"===typeof a?null:ae(a)}function Le(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&null!==a[c]&&void 0!==a[c]&&(b[c]=a[c]);return b}function Me(a){if(null!==a)return JSON.parse(a)}function Ge(a){return a?a:Math.floor(1E9*Math.random()).toString()}function Ne(a){a=a||I();return"Safari"==le(a)||a.toLowerCase().match(/iphone|ipad|ipod/)?!1:!0}
function Oe(){var a=l.___jsl;if(a&&a.H)for(var b in a.H)if(a.H[b].r=a.H[b].r||[],a.H[b].L=a.H[b].L||[],a.H[b].r=a.H[b].L.concat(),a.CP)for(var c=0;c<a.CP.length;c++)a.CP[c]=null}function Pe(a,b){if(a>b)throw Error("Short delay should be less than long delay!");this.a=a;this.c=b;a=I();b=Ae();this.b=ne(a)||"ReactNative"===b}
Pe.prototype.get=function(){var a=l.navigator;return(a&&"boolean"===typeof a.onLine&&(Ie()||"chrome-extension:"===xe()||"undefined"!==typeof a.connection)?a.onLine:1)?this.b?this.c:this.a:Math.min(5E3,this.a)};function Qe(){var a=l.document;return a&&"undefined"!==typeof a.visibilityState?"visible"==a.visibilityState:!0}
function Re(){var a=l.document,b=null;return Qe()||!a?D():(new B(function(c){b=function(){Qe()&&(a.removeEventListener("visibilitychange",b,!1),c())};a.addEventListener("visibilitychange",b,!1)})).s(function(c){a.removeEventListener("visibilitychange",b,!1);throw c;})}function Se(a){try{var b=new Date(parseInt(a,10));if(!isNaN(b.getTime())&&!/[^0-9]/.test(a))return b.toUTCString()}catch(c){}return null}function Te(){return!(!J("fireauth.oauthhelper",l)&&!J("fireauth.iframe",l))}
function Ue(){var a=l.navigator;return a&&a.serviceWorker&&a.serviceWorker.controller||null}function Ve(){var a=l.navigator;return a&&a.serviceWorker?D().then(function(){return a.serviceWorker.ready}).then(function(b){return b.active||null}).s(function(){return null}):D(null)};var We={};function Xe(a){We[a]||(We[a]=!0,"undefined"!==typeof console&&"function"===typeof console.warn&&console.warn(a))};var Ye;try{var Ze={};Object.defineProperty(Ze,"abcd",{configurable:!0,enumerable:!0,value:1});Object.defineProperty(Ze,"abcd",{configurable:!0,enumerable:!0,value:2});Ye=2==Ze.abcd}catch(a){Ye=!1}function K(a,b,c){Ye?Object.defineProperty(a,b,{configurable:!0,enumerable:!0,value:c}):a[b]=c}function L(a,b){if(b)for(var c in b)b.hasOwnProperty(c)&&K(a,c,b[c])}function $e(a){var b={};L(b,a);return b}function af(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&(b[c]=a[c]);return b}
function bf(a,b){if(!b||!b.length)return!0;if(!a)return!1;for(var c=0;c<b.length;c++){var d=a[b[c]];if(void 0===d||null===d||""===d)return!1}return!0}function cf(a){var b=a;if("object"==typeof a&&null!=a){b="length"in a?[]:{};for(var c in a)K(b,c,cf(a[c]))}return b};function df(a){var b={},c=a[ef],d=a[ff];a=a[gf];if(!a||a!=hf&&!c)throw Error("Invalid provider user info!");b[jf]=d||null;b[kf]=c||null;K(this,lf,a);K(this,mf,cf(b))}var hf="EMAIL_SIGNIN",ef="email",ff="newEmail",gf="requestType",kf="email",jf="fromEmail",mf="data",lf="operation";function M(a,b){this.code=nf+a;this.message=b||of[a]||""}v(M,Error);M.prototype.A=function(){return{code:this.code,message:this.message}};M.prototype.toJSON=function(){return this.A()};function pf(a){var b=a&&a.code;return b?new M(b.substring(nf.length),a.message):null}
var nf="auth/",of={"admin-restricted-operation":"This operation is restricted to administrators only.","argument-error":"","app-not-authorized":"This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.","app-not-installed":"The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
"captcha-check-failed":"The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.","code-expired":"The SMS code has expired. Please re-send the verification code to try again.","cordova-not-ready":"Cordova framework is not ready.","cors-unsupported":"This browser is not supported.","credential-already-in-use":"This credential is already associated with a different user account.","custom-token-mismatch":"The custom token corresponds to a different audience.",
"requires-recent-login":"This operation is sensitive and requires recent authentication. Log in again before retrying this request.","dynamic-link-not-activated":"Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.","email-already-in-use":"The email address is already in use by another account.","expired-action-code":"The action code has expired. ","cancelled-popup-request":"This operation has been cancelled due to another conflicting popup being opened.",
"internal-error":"An internal error has occurred.","invalid-app-credential":"The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.","invalid-app-id":"The mobile app identifier is not registed for the current project.","invalid-user-token":"This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.","invalid-auth-event":"An internal error has occurred.",
"invalid-verification-code":"The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure use the verification code provided by the user.","invalid-continue-uri":"The continue URL provided in the request is invalid.","invalid-cordova-configuration":"The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
"invalid-custom-token":"The custom token format is incorrect. Please check the documentation.","invalid-dynamic-link-domain":"The provided dynamic link domain is not configured or authorized for the current project.","invalid-email":"The email address is badly formatted.","invalid-api-key":"Your API key is invalid, please check you have copied it correctly.","invalid-cert-hash":"The SHA-1 certificate hash provided is invalid.","invalid-credential":"The supplied auth credential is malformed or has expired.",
"invalid-message-payload":"The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.","invalid-oauth-provider":"EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.","invalid-oauth-client-id":"The OAuth client ID provided is either invalid or does not match the specified API key.","unauthorized-domain":"This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
"invalid-action-code":"The action code is invalid. This can happen if the code is malformed, expired, or has already been used.","wrong-password":"The password is invalid or the user does not have a password.","invalid-persistence-type":"The specified persistence type is invalid. It can only be local, session or none.","invalid-phone-number":"The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
"invalid-provider-id":"The specified provider ID is invalid.","invalid-recipient-email":"The email corresponding to this action failed to send as the provided recipient email address is invalid.","invalid-sender":"The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.","invalid-verification-id":"The verification ID used to create the phone auth credential is invalid.","invalid-tenant-id":"The Auth instance's tenant ID is invalid.",
"missing-android-pkg-name":"An Android Package Name must be provided if the Android App is required to be installed.","auth-domain-config-required":"Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.","missing-app-credential":"The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.","missing-verification-code":"The phone auth credential was created with an empty SMS verification code.",
"missing-continue-uri":"A continue URL must be provided in the request.","missing-iframe-start":"An internal error has occurred.","missing-ios-bundle-id":"An iOS Bundle ID must be provided if an App Store ID is provided.","missing-or-invalid-nonce":"The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.","missing-phone-number":"To send verification codes, provide a phone number for the recipient.",
"missing-verification-id":"The phone auth credential was created with an empty verification ID.","app-deleted":"This instance of FirebaseApp has been deleted.","account-exists-with-different-credential":"An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.","network-request-failed":"A network error (such as timeout, interrupted connection or unreachable host) has occurred.","no-auth-event":"An internal error has occurred.",
"no-such-provider":"User was not linked to an account with the given provider.","null-user":"A null user object was provided as the argument for an operation which requires a non-null user object.","operation-not-allowed":"The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.","operation-not-supported-in-this-environment":'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
"popup-blocked":"Unable to establish a connection with the popup. It may have been blocked by the browser.","popup-closed-by-user":"The popup has been closed by the user before finalizing the operation.","provider-already-linked":"User can only be linked to one identity for the given provider.","quota-exceeded":"The project's quota for this operation has been exceeded.","redirect-cancelled-by-user":"The redirect operation has been cancelled by the user before finalizing.","redirect-operation-pending":"A redirect sign-in operation is already pending.",
"rejected-credential":"The request contains malformed or mismatching credentials.","tenant-id-mismatch":"The provided tenant ID does not match the Auth instance's tenant ID",timeout:"The operation has timed out.","user-token-expired":"The user's credential is no longer valid. The user must sign in again.","too-many-requests":"We have blocked all requests from this device due to unusual activity. Try again later.","unauthorized-continue-uri":"The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
"unsupported-persistence-type":"The current environment does not support the specified persistence type.","unsupported-tenant-operation":"This operation is not supported in a multi-tenant context.","user-cancelled":"The user did not grant your application the permissions it requested.","user-not-found":"There is no user record corresponding to this identifier. The user may have been deleted.","user-disabled":"The user account has been disabled by an administrator.","user-mismatch":"The supplied credentials do not correspond to the previously signed in user.",
"user-signed-out":"","weak-password":"The password must be 6 characters long or more.","web-storage-unsupported":"This browser is not supported or 3rd party cookies and data may be disabled."};function qf(a){a=Ld(a);var b=Kd(a,rf)||null,c=Kd(a,sf)||null,d=Kd(a,tf)||null;d=d?uf[d]||null:null;if(!b||!c||!d)throw new M("argument-error",rf+", "+sf+"and "+tf+" are required in a valid action code URL.");L(this,{apiKey:b,operation:d,code:c,continueUrl:Kd(a,vf)||null,languageCode:Kd(a,wf)||null,tenantId:Kd(a,xf)||null})}var rf="apiKey",sf="oobCode",vf="continueUrl",wf="languageCode",tf="mode",xf="tenantId",uf={recoverEmail:"RECOVER_EMAIL",resetPassword:"PASSWORD_RESET",signIn:hf,verifyEmail:"VERIFY_EMAIL"};
function yf(a){try{return new qf(a)}catch(b){return null}};function zf(a){var b=a[Af];if("undefined"===typeof b)throw new M("missing-continue-uri");if("string"!==typeof b||"string"===typeof b&&!b.length)throw new M("invalid-continue-uri");this.h=b;this.b=this.a=null;this.g=!1;var c=a[Bf];if(c&&"object"===typeof c){b=c[Cf];var d=c[Df];c=c[Ef];if("string"===typeof b&&b.length){this.a=b;if("undefined"!==typeof d&&"boolean"!==typeof d)throw new M("argument-error",Df+" property must be a boolean when specified.");this.g=!!d;if("undefined"!==typeof c&&("string"!==
typeof c||"string"===typeof c&&!c.length))throw new M("argument-error",Ef+" property must be a non empty string when specified.");this.b=c||null}else{if("undefined"!==typeof b)throw new M("argument-error",Cf+" property must be a non empty string when specified.");if("undefined"!==typeof d||"undefined"!==typeof c)throw new M("missing-android-pkg-name");}}else if("undefined"!==typeof c)throw new M("argument-error",Bf+" property must be a non null object when specified.");this.f=null;if((b=a[Ff])&&"object"===
typeof b)if(b=b[Gf],"string"===typeof b&&b.length)this.f=b;else{if("undefined"!==typeof b)throw new M("argument-error",Gf+" property must be a non empty string when specified.");}else if("undefined"!==typeof b)throw new M("argument-error",Ff+" property must be a non null object when specified.");b=a[Hf];if("undefined"!==typeof b&&"boolean"!==typeof b)throw new M("argument-error",Hf+" property must be a boolean when specified.");this.c=!!b;a=a[If];if("undefined"!==typeof a&&("string"!==typeof a||"string"===
typeof a&&!a.length))throw new M("argument-error",If+" property must be a non empty string when specified.");this.i=a||null}var Bf="android",If="dynamicLinkDomain",Hf="handleCodeInApp",Ff="iOS",Af="url",Df="installApp",Ef="minimumVersion",Cf="packageName",Gf="bundleId";
function Jf(a){var b={};b.continueUrl=a.h;b.canHandleCodeInApp=a.c;if(b.androidPackageName=a.a)b.androidMinimumVersion=a.b,b.androidInstallApp=a.g;b.iOSBundleId=a.f;b.dynamicLinkDomain=a.i;for(var c in b)null===b[c]&&delete b[c];return b};function Kf(a){return Ja(a,function(b){b=b.toString(16);return 1<b.length?b:"0"+b}).join("")};var Lf=null,Mf=null;function Nf(a){var b="";Of(a,function(c){b+=String.fromCharCode(c)});return b}function Of(a,b){function c(m){for(;d<a.length;){var p=a.charAt(d++),u=Mf[p];if(null!=u)return u;if(!/^[\s\xa0]*$/.test(p))throw Error("Unknown base64 encoding at char: "+p);}return m}Pf();for(var d=0;;){var e=c(-1),f=c(0),g=c(64),h=c(64);if(64===h&&-1===e)break;b(e<<2|f>>4);64!=g&&(b(f<<4&240|g>>2),64!=h&&b(g<<6&192|h))}}
function Pf(){if(!Lf){Lf={};Mf={};for(var a=0;65>a;a++)Lf[a]="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a),Mf[Lf[a]]=a,62<=a&&(Mf["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.".charAt(a)]=a)}};function Qf(a){this.f=a.sub;ua();this.a=a.provider_id||a.firebase&&a.firebase.sign_in_provider||null;this.c=a.firebase&&a.firebase.tenant||null;this.b=!!a.is_anonymous||"anonymous"==this.a}Qf.prototype.R=function(){return this.c};Qf.prototype.g=function(){return this.b};function Rf(a){return(a=Sf(a))&&a.sub&&a.iss&&a.aud&&a.exp?new Qf(a):null}
function Sf(a){if(!a)return null;a=a.split(".");if(3!=a.length)return null;a=a[1];for(var b=(4-a.length%4)%4,c=0;c<b;c++)a+=".";try{return JSON.parse(Nf(a))}catch(d){}return null};var Tf={bd:{cb:"https://www.googleapis.com/identitytoolkit/v3/relyingparty/",ib:"https://securetoken.googleapis.com/v1/token",id:"p"},dd:{cb:"https://staging-www.sandbox.googleapis.com/identitytoolkit/v3/relyingparty/",ib:"https://staging-securetoken.sandbox.googleapis.com/v1/token",id:"s"},ed:{cb:"https://www-googleapis-test.sandbox.google.com/identitytoolkit/v3/relyingparty/",ib:"https://test-securetoken.sandbox.googleapis.com/v1/token",id:"t"}};
function Uf(a){for(var b in Tf)if(Tf[b].id===a)return a=Tf[b],{firebaseEndpoint:a.cb,secureTokenEndpoint:a.ib};return null}var Vf;Vf=Uf("__EID__")?"__EID__":void 0;var Wf="oauth_consumer_key oauth_nonce oauth_signature oauth_signature_method oauth_timestamp oauth_token oauth_version".split(" "),Xf=["client_id","response_type","scope","redirect_uri","state"],Yf={Xc:{Ea:"locale",sa:700,ra:600,Fa:"facebook.com",Qa:Xf},Zc:{Ea:null,sa:500,ra:750,Fa:"github.com",Qa:Xf},$c:{Ea:"hl",sa:515,ra:680,Fa:"google.com",Qa:Xf},fd:{Ea:"lang",sa:485,ra:705,Fa:"twitter.com",Qa:Wf},Vc:{Ea:"locale",sa:600,ra:600,Fa:"apple.com",Qa:[]}};
function Zf(a){for(var b in Yf)if(Yf[b].Fa==a)return Yf[b];return null};function $f(a){var b={};b["facebook.com"]=ag;b["google.com"]=bg;b["github.com"]=cg;b["twitter.com"]=dg;var c=a&&a[eg];try{if(c)return b[c]?new b[c](a):new fg(a);if("undefined"!==typeof a[gg])return new hg(a)}catch(d){}return null}var gg="idToken",eg="providerId";
function hg(a){var b=a[eg];if(!b&&a[gg]){var c=Rf(a[gg]);c&&c.a&&(b=c.a)}if(!b)throw Error("Invalid additional user info!");if("anonymous"==b||"custom"==b)b=null;c=!1;"undefined"!==typeof a.isNewUser?c=!!a.isNewUser:"identitytoolkit#SignupNewUserResponse"===a.kind&&(c=!0);K(this,"providerId",b);K(this,"isNewUser",c)}function fg(a){hg.call(this,a);a=Me(a.rawUserInfo||"{}");K(this,"profile",cf(a||{}))}v(fg,hg);
function ag(a){fg.call(this,a);if("facebook.com"!=this.providerId)throw Error("Invalid provider ID!");}v(ag,fg);function cg(a){fg.call(this,a);if("github.com"!=this.providerId)throw Error("Invalid provider ID!");K(this,"username",this.profile&&this.profile.login||null)}v(cg,fg);function bg(a){fg.call(this,a);if("google.com"!=this.providerId)throw Error("Invalid provider ID!");}v(bg,fg);
function dg(a){fg.call(this,a);if("twitter.com"!=this.providerId)throw Error("Invalid provider ID!");K(this,"username",a.screenName||null)}v(dg,fg);function ig(a){var b=Ld(a),c=Kd(b,"link"),d=Kd(Ld(c),"link");b=Kd(b,"deep_link_id");return Kd(Ld(b),"link")||b||d||c||a};function jg(){}function kg(a,b){return a.then(function(c){if(c[lg]){var d=Rf(c[lg]);if(!d||b!=d.f)throw new M("user-mismatch");return c}throw new M("user-mismatch");}).s(function(c){throw c&&c.code&&c.code==nf+"user-not-found"?new M("user-mismatch"):c;})}function mg(a,b){if(b)this.a=b;else throw new M("internal-error","failed to construct a credential");K(this,"providerId",a);K(this,"signInMethod",a)}mg.prototype.na=function(a){return ng(a,og(this))};
mg.prototype.b=function(a,b){var c=og(this);c.idToken=b;return pg(a,c)};mg.prototype.f=function(a,b){return kg(qg(a,og(this)),b)};function og(a){return{pendingToken:a.a,requestUri:"http://localhost"}}mg.prototype.A=function(){return{providerId:this.providerId,signInMethod:this.signInMethod,pendingToken:this.a}};function rg(a){if(a&&a.providerId&&a.signInMethod&&0==a.providerId.indexOf("saml.")&&a.pendingToken)try{return new mg(a.providerId,a.pendingToken)}catch(b){}return null}
function sg(a,b,c){this.a=null;if(b.idToken||b.accessToken)b.idToken&&K(this,"idToken",b.idToken),b.accessToken&&K(this,"accessToken",b.accessToken),b.nonce&&!b.pendingToken&&K(this,"nonce",b.nonce),b.pendingToken&&(this.a=b.pendingToken);else if(b.oauthToken&&b.oauthTokenSecret)K(this,"accessToken",b.oauthToken),K(this,"secret",b.oauthTokenSecret);else throw new M("internal-error","failed to construct a credential");K(this,"providerId",a);K(this,"signInMethod",c)}
sg.prototype.na=function(a){return ng(a,tg(this))};sg.prototype.b=function(a,b){var c=tg(this);c.idToken=b;return pg(a,c)};sg.prototype.f=function(a,b){var c=tg(this);return kg(qg(a,c),b)};
function tg(a){var b={};a.idToken&&(b.id_token=a.idToken);a.accessToken&&(b.access_token=a.accessToken);a.secret&&(b.oauth_token_secret=a.secret);b.providerId=a.providerId;a.nonce&&!a.a&&(b.nonce=a.nonce);b={postBody:Pd(b).toString(),requestUri:"http://localhost"};a.a&&(delete b.postBody,b.pendingToken=a.a);return b}
sg.prototype.A=function(){var a={providerId:this.providerId,signInMethod:this.signInMethod};this.idToken&&(a.oauthIdToken=this.idToken);this.accessToken&&(a.oauthAccessToken=this.accessToken);this.secret&&(a.oauthTokenSecret=this.secret);this.nonce&&(a.nonce=this.nonce);this.a&&(a.pendingToken=this.a);return a};
function ug(a){if(a&&a.providerId&&a.signInMethod){var b={idToken:a.oauthIdToken,accessToken:a.oauthTokenSecret?null:a.oauthAccessToken,oauthTokenSecret:a.oauthTokenSecret,oauthToken:a.oauthTokenSecret&&a.oauthAccessToken,nonce:a.nonce,pendingToken:a.pendingToken};try{return new sg(a.providerId,b,a.signInMethod)}catch(c){}}return null}function vg(a,b){this.Fc=b||[];L(this,{providerId:a,isOAuthProvider:!0});this.zb={};this.eb=(Zf(a)||{}).Ea||null;this.bb=null}
vg.prototype.Ga=function(a){this.zb=Ua(a);return this};function wg(a){if("string"!==typeof a||0!=a.indexOf("saml."))throw new M("argument-error",'SAML provider IDs must be prefixed with "saml."');vg.call(this,a,[])}v(wg,vg);function O(a){vg.call(this,a,Xf);this.a=[]}v(O,vg);O.prototype.ya=function(a){Na(this.a,a)||this.a.push(a);return this};O.prototype.Hb=function(){return Ra(this.a)};
O.prototype.credential=function(a,b){var c;r(a)?c={idToken:a.idToken||null,accessToken:a.accessToken||null,nonce:a.rawNonce||null}:c={idToken:a||null,accessToken:b||null};if(!c.idToken&&!c.accessToken)throw new M("argument-error","credential failed: must provide the ID token and/or the access token.");return new sg(this.providerId,c,this.providerId)};function xg(){O.call(this,"facebook.com")}v(xg,O);K(xg,"PROVIDER_ID","facebook.com");K(xg,"FACEBOOK_SIGN_IN_METHOD","facebook.com");
function yg(a){if(!a)throw new M("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;r(a)&&(b=a.accessToken);return(new xg).credential({accessToken:b})}function zg(){O.call(this,"github.com")}v(zg,O);K(zg,"PROVIDER_ID","github.com");K(zg,"GITHUB_SIGN_IN_METHOD","github.com");
function Ag(a){if(!a)throw new M("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;r(a)&&(b=a.accessToken);return(new zg).credential({accessToken:b})}function Bg(){O.call(this,"google.com");this.ya("profile")}v(Bg,O);K(Bg,"PROVIDER_ID","google.com");K(Bg,"GOOGLE_SIGN_IN_METHOD","google.com");function Cg(a,b){var c=a;r(a)&&(c=a.idToken,b=a.accessToken);return(new Bg).credential({idToken:c,accessToken:b})}function Dg(){vg.call(this,"twitter.com",Wf)}v(Dg,vg);
K(Dg,"PROVIDER_ID","twitter.com");K(Dg,"TWITTER_SIGN_IN_METHOD","twitter.com");function Eg(a,b){var c=a;r(c)||(c={oauthToken:a,oauthTokenSecret:b});if(!c.oauthToken||!c.oauthTokenSecret)throw new M("argument-error","credential failed: expected 2 arguments (the OAuth access token and secret).");return new sg("twitter.com",c,"twitter.com")}
function Fg(a,b,c){this.a=a;this.c=b;K(this,"providerId","password");K(this,"signInMethod",c===Gg.EMAIL_LINK_SIGN_IN_METHOD?Gg.EMAIL_LINK_SIGN_IN_METHOD:Gg.EMAIL_PASSWORD_SIGN_IN_METHOD)}Fg.prototype.na=function(a){return this.signInMethod==Gg.EMAIL_LINK_SIGN_IN_METHOD?P(a,Hg,{email:this.a,oobCode:this.c}):P(a,Ig,{email:this.a,password:this.c})};
Fg.prototype.b=function(a,b){return this.signInMethod==Gg.EMAIL_LINK_SIGN_IN_METHOD?P(a,Jg,{idToken:b,email:this.a,oobCode:this.c}):P(a,Kg,{idToken:b,email:this.a,password:this.c})};Fg.prototype.f=function(a,b){return kg(this.na(a),b)};Fg.prototype.A=function(){return{email:this.a,password:this.c,signInMethod:this.signInMethod}};function Lg(a){return a&&a.email&&a.password?new Fg(a.email,a.password,a.signInMethod):null}function Gg(){L(this,{providerId:"password",isOAuthProvider:!1})}
function Mg(a,b){b=Ng(b);if(!b)throw new M("argument-error","Invalid email link!");return new Fg(a,b.code,Gg.EMAIL_LINK_SIGN_IN_METHOD)}function Ng(a){a=ig(a);return(a=yf(a))&&a.operation===hf?a:null}L(Gg,{PROVIDER_ID:"password"});L(Gg,{EMAIL_LINK_SIGN_IN_METHOD:"emailLink"});L(Gg,{EMAIL_PASSWORD_SIGN_IN_METHOD:"password"});function Og(a){if(!(a.Va&&a.Ua||a.Ha&&a.ba))throw new M("internal-error");this.a=a;K(this,"providerId","phone");K(this,"signInMethod","phone")}Og.prototype.na=function(a){return a.Wa(Pg(this))};
Og.prototype.b=function(a,b){var c=Pg(this);c.idToken=b;return P(a,Qg,c)};Og.prototype.f=function(a,b){var c=Pg(this);c.operation="REAUTH";a=P(a,Rg,c);return kg(a,b)};Og.prototype.A=function(){var a={providerId:"phone"};this.a.Va&&(a.verificationId=this.a.Va);this.a.Ua&&(a.verificationCode=this.a.Ua);this.a.Ha&&(a.temporaryProof=this.a.Ha);this.a.ba&&(a.phoneNumber=this.a.ba);return a};
function Sg(a){if(a&&"phone"===a.providerId&&(a.verificationId&&a.verificationCode||a.temporaryProof&&a.phoneNumber)){var b={};x(["verificationId","verificationCode","temporaryProof","phoneNumber"],function(c){a[c]&&(b[c]=a[c])});return new Og(b)}return null}function Pg(a){return a.a.Ha&&a.a.ba?{temporaryProof:a.a.Ha,phoneNumber:a.a.ba}:{sessionInfo:a.a.Va,code:a.a.Ua}}
function Tg(a){try{this.a=a||__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.auth()}catch(b){throw new M("argument-error","Either an instance of firebase.auth.Auth must be passed as an argument to the firebase.auth.PhoneAuthProvider constructor, or the default firebase App instance must be initialized via firebase.initializeApp().");}L(this,{providerId:"phone",isOAuthProvider:!1})}
Tg.prototype.Wa=function(a,b){var c=this.a.b;return D(b.verify()).then(function(d){if(!n(d))throw new M("argument-error","An implementation of firebase.auth.ApplicationVerifier.prototype.verify() must return a firebase.Promise that resolves with a string.");switch(b.type){case "recaptcha":return Ug(c,{phoneNumber:a,recaptchaToken:d}).then(function(e){"function"===typeof b.reset&&b.reset();return e},function(e){"function"===typeof b.reset&&b.reset();throw e;});default:throw new M("argument-error",
'Only firebase.auth.ApplicationVerifiers with type="recaptcha" are currently supported.');}})};function Vg(a,b){if(!a)throw new M("missing-verification-id");if(!b)throw new M("missing-verification-code");return new Og({Va:a,Ua:b})}L(Tg,{PROVIDER_ID:"phone"});L(Tg,{PHONE_SIGN_IN_METHOD:"phone"});
function Wg(a){if(a.temporaryProof&&a.phoneNumber)return new Og({Ha:a.temporaryProof,ba:a.phoneNumber});var b=a&&a.providerId;if(!b||"password"===b)return null;var c=a&&a.oauthAccessToken,d=a&&a.oauthTokenSecret,e=a&&a.nonce,f=a&&a.oauthIdToken,g=a&&a.pendingToken;try{switch(b){case "google.com":return Cg(f,c);case "facebook.com":return yg(c);case "github.com":return Ag(c);case "twitter.com":return Eg(c,d);default:return c||d||f||g?g?0==b.indexOf("saml.")?new mg(b,g):new sg(b,{pendingToken:g,idToken:a.oauthIdToken,
accessToken:a.oauthAccessToken},b):(new O(b)).credential({idToken:f,accessToken:c,rawNonce:e}):null}}catch(h){return null}}function Xg(a){if(!a.isOAuthProvider)throw new M("invalid-oauth-provider");};function Yg(a,b,c,d,e,f,g){this.c=a;this.b=b||null;this.g=c||null;this.f=d||null;this.i=f||null;this.h=g||null;this.a=e||null;if(this.g||this.a){if(this.g&&this.a)throw new M("invalid-auth-event");if(this.g&&!this.f)throw new M("invalid-auth-event");}else throw new M("invalid-auth-event");}Yg.prototype.getUid=function(){var a=[];a.push(this.c);this.b&&a.push(this.b);this.f&&a.push(this.f);this.h&&a.push(this.h);return a.join("-")};Yg.prototype.R=function(){return this.h};
Yg.prototype.A=function(){return{type:this.c,eventId:this.b,urlResponse:this.g,sessionId:this.f,postBody:this.i,tenantId:this.h,error:this.a&&this.a.A()}};function Zg(a){a=a||{};return a.type?new Yg(a.type,a.eventId,a.urlResponse,a.sessionId,a.error&&pf(a.error),a.postBody,a.tenantId):null};/*

 Copyright 2018 Google Inc.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
function $g(){this.b=null;this.a=[]}var ah=null;function bh(a){var b=ah;b.a.push(a);b.b||(b.b=function(c){for(var d=0;d<b.a.length;d++)b.a[d](c)},a=J("universalLinks.subscribe",l),"function"===typeof a&&a(null,b.b))};function ch(a){var b="unauthorized-domain",c=void 0,d=Ld(a);a=d.b;d=d.f;"chrome-extension"==d?c=Hb("This chrome extension ID (chrome-extension://%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):"http"==d||"https"==d?c=Hb("This domain (%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):b="operation-not-supported-in-this-environment";
M.call(this,b,c)}v(ch,M);function dh(a,b,c){M.call(this,a,c);a=b||{};a.Ab&&K(this,"email",a.Ab);a.ba&&K(this,"phoneNumber",a.ba);a.credential&&K(this,"credential",a.credential);a.Qb&&K(this,"tenantId",a.Qb)}v(dh,M);dh.prototype.A=function(){var a={code:this.code,message:this.message};this.email&&(a.email=this.email);this.phoneNumber&&(a.phoneNumber=this.phoneNumber);this.tenantId&&(a.tenantId=this.tenantId);var b=this.credential&&this.credential.A();b&&Wa(a,b);return a};dh.prototype.toJSON=function(){return this.A()};
function eh(a){if(a.code){var b=a.code||"";0==b.indexOf(nf)&&(b=b.substring(nf.length));var c={credential:Wg(a),Qb:a.tenantId};if(a.email)c.Ab=a.email;else if(a.phoneNumber)c.ba=a.phoneNumber;else if(!c.credential)return new M(b,a.message||void 0);return new dh(b,c,a.message)}return null};function fh(){}fh.prototype.c=null;function gh(a){return a.c||(a.c=a.b())};var hh;function ih(){}v(ih,fh);ih.prototype.a=function(){var a=jh(this);return a?new ActiveXObject(a):new XMLHttpRequest};ih.prototype.b=function(){var a={};jh(this)&&(a[0]=!0,a[1]=!0);return a};
function jh(a){if(!a.f&&"undefined"==typeof XMLHttpRequest&&"undefined"!=typeof ActiveXObject){for(var b=["MSXML2.XMLHTTP.6.0","MSXML2.XMLHTTP.3.0","MSXML2.XMLHTTP","Microsoft.XMLHTTP"],c=0;c<b.length;c++){var d=b[c];try{return new ActiveXObject(d),a.f=d}catch(e){}}throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");}return a.f}hh=new ih;function kh(){}v(kh,fh);kh.prototype.a=function(){var a=new XMLHttpRequest;if("withCredentials"in a)return a;if("undefined"!=typeof XDomainRequest)return new lh;throw Error("Unsupported browser");};kh.prototype.b=function(){return{}};
function lh(){this.a=new XDomainRequest;this.readyState=0;this.onreadystatechange=null;this.responseType=this.responseText=this.response="";this.status=-1;this.statusText="";this.a.onload=t(this.fc,this);this.a.onerror=t(this.Ib,this);this.a.onprogress=t(this.gc,this);this.a.ontimeout=t(this.kc,this)}k=lh.prototype;k.open=function(a,b,c){if(null!=c&&!c)throw Error("Only async requests are supported.");this.a.open(a,b)};
k.send=function(a){if(a)if("string"==typeof a)this.a.send(a);else throw Error("Only string data is supported");else this.a.send()};k.abort=function(){this.a.abort()};k.setRequestHeader=function(){};k.getResponseHeader=function(a){return"content-type"==a.toLowerCase()?this.a.contentType:""};k.fc=function(){this.status=200;this.response=this.responseText=this.a.responseText;mh(this,4)};k.Ib=function(){this.status=500;this.response=this.responseText="";mh(this,4)};k.kc=function(){this.Ib()};
k.gc=function(){this.status=200;mh(this,1)};function mh(a,b){a.readyState=b;if(a.onreadystatechange)a.onreadystatechange()}k.getAllResponseHeaders=function(){return"content-type: "+this.a.contentType};function nh(a,b,c){this.reset(a,b,c,void 0,void 0)}nh.prototype.a=null;var oh=0;nh.prototype.reset=function(a,b,c,d,e){"number"==typeof e||oh++;d||ua();delete this.a};function ph(a){this.f=a;this.b=this.c=this.a=null}function qh(a,b){this.name=a;this.value=b}qh.prototype.toString=function(){return this.name};var rh=new qh("SEVERE",1E3),sh=new qh("WARNING",900),th=new qh("CONFIG",700),uh=new qh("FINE",500);function vh(a){if(a.c)return a.c;if(a.a)return vh(a.a);ya("Root logger has no level set.");return null}ph.prototype.log=function(a,b,c){if(a.value>=vh(this).value)for(q(b)&&(b=b()),a=new nh(a,String(b),this.f),c&&(a.a=c),c=this;c;)c=c.a};var wh={},xh=null;
function yh(a){xh||(xh=new ph(""),wh[""]=xh,xh.c=th);var b;if(!(b=wh[a])){b=new ph(a);var c=a.lastIndexOf("."),d=a.substr(c+1);c=yh(a.substr(0,c));c.b||(c.b={});c.b[d]=b;b.a=c;wh[a]=b}return b};function zh(a,b){a&&a.log(uh,b,void 0)};function Ah(a){this.f=a}v(Ah,fh);Ah.prototype.a=function(){return new Bh(this.f)};Ah.prototype.b=function(a){return function(){return a}}({});function Bh(a){G.call(this);this.o=a;this.readyState=Ch;this.status=0;this.responseType=this.responseText=this.response=this.statusText="";this.onreadystatechange=null;this.i=new Headers;this.b=null;this.m="GET";this.g="";this.a=!1;this.h=yh("goog.net.FetchXmlHttp");this.l=this.c=this.f=null}v(Bh,G);var Ch=0;k=Bh.prototype;
k.open=function(a,b){if(this.readyState!=Ch)throw this.abort(),Error("Error reopening a connection");this.m=a;this.g=b;this.readyState=1;Dh(this)};k.send=function(a){if(1!=this.readyState)throw this.abort(),Error("need to call open() first. ");this.a=!0;var b={headers:this.i,method:this.m,credentials:void 0,cache:void 0};a&&(b.body=a);this.o.fetch(new Request(this.g,b)).then(this.jc.bind(this),this.Oa.bind(this))};
k.abort=function(){this.response=this.responseText="";this.i=new Headers;this.status=0;this.c&&this.c.cancel("Request was aborted.");1<=this.readyState&&this.a&&4!=this.readyState&&(this.a=!1,Eh(this,!1));this.readyState=Ch};
k.jc=function(a){this.a&&(this.f=a,this.b||(this.b=a.headers,this.readyState=2,Dh(this)),this.a&&(this.readyState=3,Dh(this),this.a&&("arraybuffer"===this.responseType?a.arrayBuffer().then(this.hc.bind(this),this.Oa.bind(this)):"undefined"!==typeof l.ReadableStream&&"body"in a?(this.response=this.responseText="",this.c=a.body.getReader(),this.l=new TextDecoder,Fh(this)):a.text().then(this.ic.bind(this),this.Oa.bind(this)))))};function Fh(a){a.c.read().then(a.ec.bind(a)).catch(a.Oa.bind(a))}
k.ec=function(a){if(this.a){var b=this.l.decode(a.value?a.value:new Uint8Array(0),{stream:!a.done});b&&(this.response=this.responseText+=b);a.done?Eh(this,!0):Dh(this);3==this.readyState&&Fh(this)}};k.ic=function(a){this.a&&(this.response=this.responseText=a,Eh(this,!0))};k.hc=function(a){this.a&&(this.response=a,Eh(this,!0))};k.Oa=function(a){var b=this.h;b&&b.log(sh,"Failed to fetch url "+this.g,a instanceof Error?a:Error(a));this.a&&Eh(this,!0)};
function Eh(a,b){b&&a.f&&(a.status=a.f.status,a.statusText=a.f.statusText);a.readyState=4;a.f=null;a.c=null;a.l=null;Dh(a)}k.setRequestHeader=function(a,b){this.i.append(a,b)};k.getResponseHeader=function(a){return this.b?this.b.get(a.toLowerCase())||"":((a=this.h)&&a.log(sh,"Attempting to get response header but no headers have been received for url: "+this.g,void 0),"")};
k.getAllResponseHeaders=function(){if(!this.b){var a=this.h;a&&a.log(sh,"Attempting to get all response headers but no headers have been received for url: "+this.g,void 0);return""}a=[];for(var b=this.b.entries(),c=b.next();!c.done;)c=c.value,a.push(c[0]+": "+c[1]),c=b.next();return a.join("\r\n")};function Dh(a){a.onreadystatechange&&a.onreadystatechange.call(a)};function Gh(a){G.call(this);this.headers=new rd;this.B=a||null;this.c=!1;this.w=this.a=null;this.h=this.O=this.l="";this.f=this.J=this.i=this.I=!1;this.g=0;this.o=null;this.m=Hh;this.v=this.P=!1}v(Gh,G);var Hh="";Gh.prototype.b=yh("goog.net.XhrIo");var Ih=/^https?$/i,Jh=["POST","PUT"];
function Kh(a,b,c,d,e){if(a.a)throw Error("[goog.net.XhrIo] Object is active with another request="+a.l+"; newUri="+b);c=c?c.toUpperCase():"GET";a.l=b;a.h="";a.O=c;a.I=!1;a.c=!0;a.a=a.B?a.B.a():hh.a();a.w=a.B?gh(a.B):gh(hh);a.a.onreadystatechange=t(a.Lb,a);try{zh(a.b,Lh(a,"Opening Xhr")),a.J=!0,a.a.open(c,String(b),!0),a.J=!1}catch(g){zh(a.b,Lh(a,"Error opening Xhr: "+g.message));Mh(a,g);return}b=d||"";var f=new rd(a.headers);e&&qd(e,function(g,h){f.set(h,g)});e=La(f.X());d=l.FormData&&b instanceof
l.FormData;!Na(Jh,c)||e||d||f.set("Content-Type","application/x-www-form-urlencoded;charset=utf-8");f.forEach(function(g,h){this.a.setRequestHeader(h,g)},a);a.m&&(a.a.responseType=a.m);"withCredentials"in a.a&&a.a.withCredentials!==a.P&&(a.a.withCredentials=a.P);try{Nh(a),0<a.g&&(a.v=Oh(a.a),zh(a.b,Lh(a,"Will abort after "+a.g+"ms if incomplete, xhr2 "+a.v)),a.v?(a.a.timeout=a.g,a.a.ontimeout=t(a.Ia,a)):a.o=md(a.Ia,a.g,a)),zh(a.b,Lh(a,"Sending request")),a.i=!0,a.a.send(b),a.i=!1}catch(g){zh(a.b,
Lh(a,"Send error: "+g.message)),Mh(a,g)}}function Oh(a){return uc&&Ec(9)&&"number"==typeof a.timeout&&void 0!==a.ontimeout}function Ma(a){return"content-type"==a.toLowerCase()}k=Gh.prototype;k.Ia=function(){"undefined"!=typeof fa&&this.a&&(this.h="Timed out after "+this.g+"ms, aborting",zh(this.b,Lh(this,this.h)),this.dispatchEvent("timeout"),this.abort(8))};function Mh(a,b){a.c=!1;a.a&&(a.f=!0,a.a.abort(),a.f=!1);a.h=b;Ph(a);Qh(a)}
function Ph(a){a.I||(a.I=!0,a.dispatchEvent("complete"),a.dispatchEvent("error"))}k.abort=function(){this.a&&this.c&&(zh(this.b,Lh(this,"Aborting")),this.c=!1,this.f=!0,this.a.abort(),this.f=!1,this.dispatchEvent("complete"),this.dispatchEvent("abort"),Qh(this))};k.za=function(){this.a&&(this.c&&(this.c=!1,this.f=!0,this.a.abort(),this.f=!1),Qh(this,!0));Gh.qb.za.call(this)};k.Lb=function(){this.va||(this.J||this.i||this.f?Rh(this):this.yc())};k.yc=function(){Rh(this)};
function Rh(a){if(a.c&&"undefined"!=typeof fa)if(a.w[1]&&4==Sh(a)&&2==Th(a))zh(a.b,Lh(a,"Local request error detected and ignored"));else if(a.i&&4==Sh(a))md(a.Lb,0,a);else if(a.dispatchEvent("readystatechange"),4==Sh(a)){zh(a.b,Lh(a,"Request complete"));a.c=!1;try{var b=Th(a);a:switch(b){case 200:case 201:case 202:case 204:case 206:case 304:case 1223:var c=!0;break a;default:c=!1}var d;if(!(d=c)){var e;if(e=0===b){var f=String(a.l).match(ud)[1]||null;if(!f&&l.self&&l.self.location){var g=l.self.location.protocol;
f=g.substr(0,g.length-1)}e=!Ih.test(f?f.toLowerCase():"")}d=e}if(d)a.dispatchEvent("complete"),a.dispatchEvent("success");else{try{var h=2<Sh(a)?a.a.statusText:""}catch(m){zh(a.b,"Can not get status: "+m.message),h=""}a.h=h+" ["+Th(a)+"]";Ph(a)}}finally{Qh(a)}}}function Qh(a,b){if(a.a){Nh(a);var c=a.a,d=a.w[0]?ka:null;a.a=null;a.w=null;b||a.dispatchEvent("ready");try{c.onreadystatechange=d}catch(e){(a=a.b)&&a.log(rh,"Problem encountered resetting onreadystatechange: "+e.message,void 0)}}}
function Nh(a){a.a&&a.v&&(a.a.ontimeout=null);a.o&&(l.clearTimeout(a.o),a.o=null)}function Sh(a){return a.a?a.a.readyState:0}function Th(a){try{return 2<Sh(a)?a.a.status:-1}catch(b){return-1}}function Uh(a){try{return a.a?a.a.responseText:""}catch(b){return zh(a.b,"Can not get responseText: "+b.message),""}}
k.getResponse=function(){try{if(!this.a)return null;if("response"in this.a)return this.a.response;switch(this.m){case Hh:case "text":return this.a.responseText;case "arraybuffer":if("mozResponseArrayBuffer"in this.a)return this.a.mozResponseArrayBuffer}var a=this.b;a&&a.log(rh,"Response type "+this.m+" is not supported on this browser",void 0);return null}catch(b){return zh(this.b,"Can not get response: "+b.message),null}};function Lh(a,b){return b+" ["+a.O+" "+a.l+" "+Th(a)+"]"};/*
 Portions of this code are from MochiKit, received by
 The Closure Authors under the MIT license. All other code is Copyright
 2005-2009 The Closure Authors. All Rights Reserved.
*/
function Vh(a){var b=Wh;this.g=[];this.v=b;this.o=a||null;this.f=this.a=!1;this.c=void 0;this.u=this.w=this.i=!1;this.h=0;this.b=null;this.l=0}Vh.prototype.cancel=function(a){if(this.a)this.c instanceof Vh&&this.c.cancel();else{if(this.b){var b=this.b;delete this.b;a?b.cancel(a):(b.l--,0>=b.l&&b.cancel())}this.v?this.v.call(this.o,this):this.u=!0;this.a||(a=new Xh(this),Yh(this),Zh(this,!1,a))}};Vh.prototype.m=function(a,b){this.i=!1;Zh(this,a,b)};function Zh(a,b,c){a.a=!0;a.c=c;a.f=!b;$h(a)}
function Yh(a){if(a.a){if(!a.u)throw new ai(a);a.u=!1}}function bi(a,b){ci(a,null,b,void 0)}function ci(a,b,c,d){a.g.push([b,c,d]);a.a&&$h(a)}Vh.prototype.then=function(a,b,c){var d,e,f=new B(function(g,h){d=g;e=h});ci(this,d,function(g){g instanceof Xh?f.cancel():e(g)});return f.then(a,b,c)};Vh.prototype.$goog_Thenable=!0;function di(a){return Ka(a.g,function(b){return q(b[1])})}
function $h(a){if(a.h&&a.a&&di(a)){var b=a.h,c=ei[b];c&&(l.clearTimeout(c.a),delete ei[b]);a.h=0}a.b&&(a.b.l--,delete a.b);b=a.c;for(var d=c=!1;a.g.length&&!a.i;){var e=a.g.shift(),f=e[0],g=e[1];e=e[2];if(f=a.f?g:f)try{var h=f.call(e||a.o,b);void 0!==h&&(a.f=a.f&&(h==b||h instanceof Error),a.c=b=h);if(va(b)||"function"===typeof l.Promise&&b instanceof l.Promise)d=!0,a.i=!0}catch(m){b=m,a.f=!0,di(a)||(c=!0)}}a.c=b;d&&(h=t(a.m,a,!0),d=t(a.m,a,!1),b instanceof Vh?(ci(b,h,d),b.w=!0):b.then(h,d));c&&(b=
new fi(b),ei[b.a]=b,a.h=b.a)}function ai(){w.call(this)}v(ai,w);ai.prototype.message="Deferred has already fired";ai.prototype.name="AlreadyCalledError";function Xh(){w.call(this)}v(Xh,w);Xh.prototype.message="Deferred was canceled";Xh.prototype.name="CanceledError";function fi(a){this.a=l.setTimeout(t(this.c,this),0);this.b=a}fi.prototype.c=function(){delete ei[this.a];throw this.b;};var ei={};function gi(a){var b={},c=b.document||document,d=db(a).toString(),e=document.createElement("SCRIPT"),f={Nb:e,Ia:void 0},g=new Vh(f),h=null,m=null!=b.timeout?b.timeout:5E3;0<m&&(h=window.setTimeout(function(){hi(e,!0);var p=new ii(ji,"Timeout reached for loading script "+d);Yh(g);Zh(g,!1,p)},m),f.Ia=h);e.onload=e.onreadystatechange=function(){e.readyState&&"loaded"!=e.readyState&&"complete"!=e.readyState||(hi(e,b.hd||!1,h),Yh(g),Zh(g,!0,null))};e.onerror=function(){hi(e,!0,h);var p=new ii(ki,"Error while loading script "+
d);Yh(g);Zh(g,!1,p)};f=b.attributes||{};Wa(f,{type:"text/javascript",charset:"UTF-8"});Wd(e,f);Gb(e,a);li(c).appendChild(e);return g}function li(a){var b;return(b=(a||document).getElementsByTagName("HEAD"))&&0!=b.length?b[0]:a.documentElement}function Wh(){if(this&&this.Nb){var a=this.Nb;a&&"SCRIPT"==a.tagName&&hi(a,!0,this.Ia)}}
function hi(a,b,c){null!=c&&l.clearTimeout(c);a.onload=ka;a.onerror=ka;a.onreadystatechange=ka;b&&window.setTimeout(function(){a&&a.parentNode&&a.parentNode.removeChild(a)},0)}var ki=0,ji=1;function ii(a,b){var c="Jsloader error (code #"+a+")";b&&(c+=": "+b);w.call(this,c);this.code=a}v(ii,w);function mi(a){this.f=a}v(mi,fh);mi.prototype.a=function(){return new this.f};mi.prototype.b=function(){return{}};
function ni(a,b,c){this.c=a;a=b||{};this.l=a.secureTokenEndpoint||"https://securetoken.googleapis.com/v1/token";this.u=a.secureTokenTimeout||oi;this.g=Ua(a.secureTokenHeaders||pi);this.h=a.firebaseEndpoint||"https://www.googleapis.com/identitytoolkit/v3/relyingparty/";this.i=a.firebaseTimeout||qi;this.a=Ua(a.firebaseHeaders||ri);c&&(this.a["X-Client-Version"]=c,this.g["X-Client-Version"]=c);c="Node"==Ae();c=l.XMLHttpRequest||c&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node.XMLHttpRequest;if(!c&&
!ze())throw new M("internal-error","The XMLHttpRequest compatibility library was not found.");this.f=void 0;ze()?this.f=new Ah(self):Be()?this.f=new mi(c):this.f=new kh;this.b=null}var si,lg="idToken",oi=new Pe(3E4,6E4),pi={"Content-Type":"application/x-www-form-urlencoded"},qi=new Pe(3E4,6E4),ri={"Content-Type":"application/json"};function ti(a,b){b?a.a["X-Firebase-Locale"]=b:delete a.a["X-Firebase-Locale"]}
function ui(a,b){b?(a.a["X-Client-Version"]=b,a.g["X-Client-Version"]=b):(delete a.a["X-Client-Version"],delete a.g["X-Client-Version"])}ni.prototype.R=function(){return this.b};function vi(a,b,c,d,e,f,g){ke()||ze()?a=t(a.o,a):(si||(si=new B(function(h,m){wi(h,m)})),a=t(a.m,a));a(b,c,d,e,f,g)}
ni.prototype.o=function(a,b,c,d,e,f){if(ze()&&("undefined"===typeof l.fetch||"undefined"===typeof l.Headers||"undefined"===typeof l.Request))throw new M("operation-not-supported-in-this-environment","fetch, Headers and Request native APIs or equivalent Polyfills must be available to support HTTP requests from a Worker environment.");var g=new Gh(this.f);if(f){g.g=Math.max(0,f);var h=setTimeout(function(){g.dispatchEvent("timeout")},f)}Zc(g,"complete",function(){h&&clearTimeout(h);var m=null;try{m=
JSON.parse(Uh(this))||null}catch(p){m=null}b&&b(m)});ed(g,"ready",function(){h&&clearTimeout(h);pc(this)});ed(g,"timeout",function(){h&&clearTimeout(h);pc(this);b&&b(null)});Kh(g,a,c,d,e)};var xi=new Xa(Ya,"https://apis.google.com/js/client.js?onload=%{onload}"),yi="__fcb"+Math.floor(1E6*Math.random()).toString();
function wi(a,b){if(((window.gapi||{}).client||{}).request)a();else{l[yi]=function(){((window.gapi||{}).client||{}).request?a():b(Error("CORS_UNSUPPORTED"))};var c=eb(xi,{onload:yi});bi(gi(c),function(){b(Error("CORS_UNSUPPORTED"))})}}
ni.prototype.m=function(a,b,c,d,e){var f=this;si.then(function(){window.gapi.client.setApiKey(f.c);var g=window.gapi.auth.getToken();window.gapi.auth.setToken(null);window.gapi.client.request({path:a,method:c,body:d,headers:e,authType:"none",callback:function(h){window.gapi.auth.setToken(g);b&&b(h)}})}).s(function(g){b&&b({error:{message:g&&g.message||"CORS_UNSUPPORTED"}})})};
function zi(a,b){return new B(function(c,d){"refresh_token"==b.grant_type&&b.refresh_token||"authorization_code"==b.grant_type&&b.code?vi(a,a.l+"?key="+encodeURIComponent(a.c),function(e){e?e.error?d(Ai(e)):e.access_token&&e.refresh_token?c(e):d(new M("internal-error")):d(new M("network-request-failed"))},"POST",Pd(b).toString(),a.g,a.u.get()):d(new M("internal-error"))})}
function Bi(a,b,c,d,e,f){var g=Ld(a.h+b);H(g,"key",a.c);f&&H(g,"cb",ua().toString());var h="GET"==c;if(h)for(var m in d)d.hasOwnProperty(m)&&H(g,m,d[m]);return new B(function(p,u){vi(a,g.toString(),function(A){A?A.error?u(Ai(A,e||{})):p(A):u(new M("network-request-failed"))},c,h?void 0:ae(Le(d)),a.a,a.i.get())})}function Ci(a){a=a.email;if(!n(a)||!te.test(a))throw new M("invalid-email");}function Di(a){"email"in a&&Ci(a)}
function Ei(a,b){return P(a,Fi,{identifier:b,continueUri:Ie()?he():"http://localhost"}).then(function(c){return c.signinMethods||[]})}function Gi(a){return P(a,Hi,{}).then(function(b){return b.authorizedDomains||[]})}function Ii(a){if(!a[lg])throw new M("internal-error");}
function Ji(a){if(a.phoneNumber||a.temporaryProof){if(!a.phoneNumber||!a.temporaryProof)throw new M("internal-error");}else{if(!a.sessionInfo)throw new M("missing-verification-id");if(!a.code)throw new M("missing-verification-code");}}ni.prototype.ob=function(){return P(this,Ki,{})};ni.prototype.rb=function(a,b){return P(this,Li,{idToken:a,email:b})};ni.prototype.sb=function(a,b){return P(this,Kg,{idToken:a,password:b})};var Mi={displayName:"DISPLAY_NAME",photoUrl:"PHOTO_URL"};k=ni.prototype;
k.tb=function(a,b){var c={idToken:a},d=[];Sa(Mi,function(e,f){var g=b[f];null===g?d.push(e):f in b&&(c[f]=g)});d.length&&(c.deleteAttribute=d);return P(this,Li,c)};k.kb=function(a,b){a={requestType:"PASSWORD_RESET",email:a};Wa(a,b);return P(this,Ni,a)};k.lb=function(a,b){a={requestType:"EMAIL_SIGNIN",email:a};Wa(a,b);return P(this,Oi,a)};k.jb=function(a,b){a={requestType:"VERIFY_EMAIL",idToken:a};Wa(a,b);return P(this,Pi,a)};function Ug(a,b){return P(a,Qi,b)}k.Wa=function(a){return P(this,Ri,a)};
function Si(a,b,c){return P(a,Ti,{idToken:b,deleteProvider:c})}function Ui(a){if(!a.requestUri||!a.sessionId&&!a.postBody&&!a.pendingToken)throw new M("internal-error");}function Vi(a,b){b.oauthIdToken&&b.providerId&&0==b.providerId.indexOf("oidc.")&&!b.pendingToken&&(a.sessionId?b.nonce=a.sessionId:a.postBody&&(a=new Cd(a.postBody),Td(a,"nonce")&&(b.nonce=a.get("nonce"))));return b}
function Wi(a){var b=null;a.needConfirmation?(a.code="account-exists-with-different-credential",b=eh(a)):"FEDERATED_USER_ID_ALREADY_LINKED"==a.errorMessage?(a.code="credential-already-in-use",b=eh(a)):"EMAIL_EXISTS"==a.errorMessage?(a.code="email-already-in-use",b=eh(a)):a.errorMessage&&(b=Xi(a.errorMessage));if(b)throw b;if(!a[lg])throw new M("internal-error");}function ng(a,b){b.returnIdpCredential=!0;return P(a,Yi,b)}function pg(a,b){b.returnIdpCredential=!0;return P(a,Zi,b)}
function qg(a,b){b.returnIdpCredential=!0;b.autoCreate=!1;return P(a,$i,b)}function aj(a){if(!a.oobCode)throw new M("invalid-action-code");}k.ab=function(a,b){return P(this,bj,{oobCode:a,newPassword:b})};k.Ma=function(a){return P(this,cj,{oobCode:a})};k.Ya=function(a){return P(this,dj,{oobCode:a})};
var dj={endpoint:"setAccountInfo",D:aj,fa:"email",F:!0},cj={endpoint:"resetPassword",D:aj,K:function(a){var b=a.requestType;if(!b||!a.email&&"EMAIL_SIGNIN"!=b)throw new M("internal-error");},F:!0},ej={endpoint:"signupNewUser",D:function(a){Ci(a);if(!a.password)throw new M("weak-password");},K:Ii,T:!0,F:!0},Fi={endpoint:"createAuthUri",F:!0},fj={endpoint:"deleteAccount",V:["idToken"]},Ti={endpoint:"setAccountInfo",V:["idToken","deleteProvider"],D:function(a){if(!na(a.deleteProvider))throw new M("internal-error");
}},Hg={endpoint:"emailLinkSignin",V:["email","oobCode"],D:Ci,K:Ii,T:!0,F:!0},Jg={endpoint:"emailLinkSignin",V:["idToken","email","oobCode"],D:Ci,K:Ii,T:!0},gj={endpoint:"getAccountInfo"},Oi={endpoint:"getOobConfirmationCode",V:["requestType"],D:function(a){if("EMAIL_SIGNIN"!=a.requestType)throw new M("internal-error");Ci(a)},fa:"email",F:!0},Pi={endpoint:"getOobConfirmationCode",V:["idToken","requestType"],D:function(a){if("VERIFY_EMAIL"!=a.requestType)throw new M("internal-error");},fa:"email",F:!0},
Ni={endpoint:"getOobConfirmationCode",V:["requestType"],D:function(a){if("PASSWORD_RESET"!=a.requestType)throw new M("internal-error");Ci(a)},fa:"email",F:!0},Hi={wb:!0,endpoint:"getProjectConfig",Kb:"GET"},hj={wb:!0,endpoint:"getRecaptchaParam",Kb:"GET",K:function(a){if(!a.recaptchaSiteKey)throw new M("internal-error");}},bj={endpoint:"resetPassword",D:aj,fa:"email",F:!0},Qi={endpoint:"sendVerificationCode",V:["phoneNumber","recaptchaToken"],fa:"sessionInfo",F:!0},Li={endpoint:"setAccountInfo",V:["idToken"],
D:Di,T:!0},Kg={endpoint:"setAccountInfo",V:["idToken"],D:function(a){Di(a);if(!a.password)throw new M("weak-password");},K:Ii,T:!0},Ki={endpoint:"signupNewUser",K:Ii,T:!0,F:!0},Yi={endpoint:"verifyAssertion",D:Ui,Ra:Vi,K:Wi,T:!0,F:!0},$i={endpoint:"verifyAssertion",D:Ui,Ra:Vi,K:function(a){if(a.errorMessage&&"USER_NOT_FOUND"==a.errorMessage)throw new M("user-not-found");if(a.errorMessage)throw Xi(a.errorMessage);if(!a[lg])throw new M("internal-error");},T:!0,F:!0},Zi={endpoint:"verifyAssertion",D:function(a){Ui(a);
if(!a.idToken)throw new M("internal-error");},Ra:Vi,K:Wi,T:!0},ij={endpoint:"verifyCustomToken",D:function(a){if(!a.token)throw new M("invalid-custom-token");},K:Ii,T:!0,F:!0},Ig={endpoint:"verifyPassword",D:function(a){Ci(a);if(!a.password)throw new M("wrong-password");},K:Ii,T:!0,F:!0},Ri={endpoint:"verifyPhoneNumber",D:Ji,K:Ii,F:!0},Qg={endpoint:"verifyPhoneNumber",D:function(a){if(!a.idToken)throw new M("internal-error");Ji(a)},K:function(a){if(a.temporaryProof)throw a.code="credential-already-in-use",
eh(a);Ii(a)}},Rg={Yb:{USER_NOT_FOUND:"user-not-found"},endpoint:"verifyPhoneNumber",D:Ji,K:Ii,F:!0};
function P(a,b,c){if(!bf(c,b.V))return E(new M("internal-error"));var d=b.Kb||"POST",e;return D(c).then(b.D).then(function(){b.T&&(c.returnSecureToken=!0);b.F&&a.b&&"undefined"===typeof c.tenantId&&(c.tenantId=a.b);return Bi(a,b.endpoint,d,c,b.Yb,b.wb||!1)}).then(function(f){e=f;return b.Ra?b.Ra(c,e):e}).then(b.K).then(function(){if(!b.fa)return e;if(!(b.fa in e))throw new M("internal-error");return e[b.fa]})}function Xi(a){return Ai({error:{errors:[{message:a}],code:400,message:a}})}
function Ai(a,b){var c=(a.error&&a.error.errors&&a.error.errors[0]||{}).reason||"";var d={keyInvalid:"invalid-api-key",ipRefererBlocked:"app-not-authorized"};if(c=d[c]?new M(d[c]):null)return c;c=a.error&&a.error.message||"";d={INVALID_CUSTOM_TOKEN:"invalid-custom-token",CREDENTIAL_MISMATCH:"custom-token-mismatch",MISSING_CUSTOM_TOKEN:"internal-error",INVALID_IDENTIFIER:"invalid-email",MISSING_CONTINUE_URI:"internal-error",INVALID_EMAIL:"invalid-email",INVALID_PASSWORD:"wrong-password",USER_DISABLED:"user-disabled",
MISSING_PASSWORD:"internal-error",EMAIL_EXISTS:"email-already-in-use",PASSWORD_LOGIN_DISABLED:"operation-not-allowed",INVALID_IDP_RESPONSE:"invalid-credential",INVALID_PENDING_TOKEN:"invalid-credential",FEDERATED_USER_ID_ALREADY_LINKED:"credential-already-in-use",MISSING_OR_INVALID_NONCE:"missing-or-invalid-nonce",INVALID_MESSAGE_PAYLOAD:"invalid-message-payload",INVALID_RECIPIENT_EMAIL:"invalid-recipient-email",INVALID_SENDER:"invalid-sender",EMAIL_NOT_FOUND:"user-not-found",RESET_PASSWORD_EXCEED_LIMIT:"too-many-requests",
EXPIRED_OOB_CODE:"expired-action-code",INVALID_OOB_CODE:"invalid-action-code",MISSING_OOB_CODE:"internal-error",INVALID_PROVIDER_ID:"invalid-provider-id",CREDENTIAL_TOO_OLD_LOGIN_AGAIN:"requires-recent-login",INVALID_ID_TOKEN:"invalid-user-token",TOKEN_EXPIRED:"user-token-expired",USER_NOT_FOUND:"user-token-expired",CORS_UNSUPPORTED:"cors-unsupported",DYNAMIC_LINK_NOT_ACTIVATED:"dynamic-link-not-activated",INVALID_APP_ID:"invalid-app-id",TOO_MANY_ATTEMPTS_TRY_LATER:"too-many-requests",WEAK_PASSWORD:"weak-password",
OPERATION_NOT_ALLOWED:"operation-not-allowed",USER_CANCELLED:"user-cancelled",CAPTCHA_CHECK_FAILED:"captcha-check-failed",INVALID_APP_CREDENTIAL:"invalid-app-credential",INVALID_CODE:"invalid-verification-code",INVALID_PHONE_NUMBER:"invalid-phone-number",INVALID_SESSION_INFO:"invalid-verification-id",INVALID_TEMPORARY_PROOF:"invalid-credential",MISSING_APP_CREDENTIAL:"missing-app-credential",MISSING_CODE:"missing-verification-code",MISSING_PHONE_NUMBER:"missing-phone-number",MISSING_SESSION_INFO:"missing-verification-id",
QUOTA_EXCEEDED:"quota-exceeded",SESSION_EXPIRED:"code-expired",REJECTED_CREDENTIAL:"rejected-credential",INVALID_CONTINUE_URI:"invalid-continue-uri",MISSING_ANDROID_PACKAGE_NAME:"missing-android-pkg-name",MISSING_IOS_BUNDLE_ID:"missing-ios-bundle-id",UNAUTHORIZED_DOMAIN:"unauthorized-continue-uri",INVALID_DYNAMIC_LINK_DOMAIN:"invalid-dynamic-link-domain",INVALID_OAUTH_CLIENT_ID:"invalid-oauth-client-id",INVALID_CERT_HASH:"invalid-cert-hash",UNSUPPORTED_TENANT_OPERATION:"unsupported-tenant-operation",
INVALID_TENANT_ID:"invalid-tenant-id",ADMIN_ONLY_OPERATION:"admin-restricted-operation"};Wa(d,b||{});b=(b=c.match(/^[^\s]+\s*:\s*([\s\S]*)$/))&&1<b.length?b[1]:void 0;for(var e in d)if(0===c.indexOf(e))return new M(d[e],b);!b&&a&&(b=Ke(a));return new M("internal-error",b)};function jj(a){this.b=a;this.a=null;this.gb=kj(this)}
function kj(a){return lj().then(function(){return new B(function(b,c){J("gapi.iframes.getContext")().open({where:document.body,url:a.b,messageHandlersFilter:J("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"),attributes:{style:{position:"absolute",top:"-100px",width:"1px",height:"1px"}},dontclear:!0},function(d){function e(){clearTimeout(f);b()}a.a=d;a.a.restyle({setHideOnLeave:!1});var f=setTimeout(function(){c(Error("Network Error"))},mj.get());d.ping(e).then(e,function(){c(Error("Network Error"))})})})})}
function nj(a,b){return a.gb.then(function(){return new B(function(c){a.a.send(b.type,b,c,J("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})})}function oj(a,b){a.gb.then(function(){a.a.register("authEvent",b,J("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})}var pj=new Xa(Ya,"https://apis.google.com/js/api.js?onload=%{onload}"),qj=new Pe(3E4,6E4),mj=new Pe(5E3,15E3),rj=null;
function lj(){return rj?rj:rj=(new B(function(a,b){function c(){Oe();J("gapi.load")("gapi.iframes",{callback:a,ontimeout:function(){Oe();b(Error("Network Error"))},timeout:qj.get()})}if(J("gapi.iframes.Iframe"))a();else if(J("gapi.load"))c();else{var d="__iframefcb"+Math.floor(1E6*Math.random()).toString();l[d]=function(){J("gapi.load")?c():b(Error("Network Error"))};d=eb(pj,{onload:d});D(gi(d)).s(function(){b(Error("Network Error"))})}})).s(function(a){rj=null;throw a;})};function sj(a,b,c){this.i=a;this.g=b;this.h=c;this.f=null;this.a=Md(this.i,"/__/auth/iframe");H(this.a,"apiKey",this.g);H(this.a,"appName",this.h);this.b=null;this.c=[]}sj.prototype.toString=function(){this.f?H(this.a,"v",this.f):Sd(this.a.a,"v");this.b?H(this.a,"eid",this.b):Sd(this.a.a,"eid");this.c.length?H(this.a,"fw",this.c.join(",")):Sd(this.a.a,"fw");return this.a.toString()};function tj(a,b,c,d,e){this.o=a;this.m=b;this.c=c;this.u=d;this.i=this.g=this.l=null;this.a=e;this.h=this.f=null}
tj.prototype.nb=function(a){this.h=a;return this};
tj.prototype.toString=function(){var a=Md(this.o,"/__/auth/handler");H(a,"apiKey",this.m);H(a,"appName",this.c);H(a,"authType",this.u);if(this.a.isOAuthProvider){var b=this.a;try{var c=__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.app(this.c).auth().ha()}catch(h){c=null}b.bb=c;H(a,"providerId",this.a.providerId);b=this.a;c=Le(b.zb);for(var d in c)c[d]=c[d].toString();d=b.Fc;c=Ua(c);for(var e=0;e<d.length;e++){var f=d[e];f in c&&delete c[f]}b.eb&&b.bb&&!c[b.eb]&&(c[b.eb]=b.bb);Ta(c)||H(a,"customParameters",Ke(c))}"function"===typeof this.a.Hb&&
(b=this.a.Hb(),b.length&&H(a,"scopes",b.join(",")));this.l?H(a,"redirectUrl",this.l):Sd(a.a,"redirectUrl");this.g?H(a,"eventId",this.g):Sd(a.a,"eventId");this.i?H(a,"v",this.i):Sd(a.a,"v");if(this.b)for(var g in this.b)this.b.hasOwnProperty(g)&&!Kd(a,g)&&H(a,g,this.b[g]);this.h?H(a,"tid",this.h):Sd(a.a,"tid");this.f?H(a,"eid",this.f):Sd(a.a,"eid");g=uj(this.c);g.length&&H(a,"fw",g.join(","));return a.toString()};function uj(a){try{return __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.app(a).auth().Ca()}catch(b){return[]}}
function vj(a,b,c,d,e){this.u=a;this.f=b;this.b=c;this.c=d||null;this.h=e||null;this.m=this.o=this.v=null;this.g=[];this.l=this.a=null}
function wj(a){var b=he();return Gi(a).then(function(c){a:{var d=Ld(b),e=d.f;d=d.b;for(var f=0;f<c.length;f++){var g=c[f];var h=d;var m=e;0==g.indexOf("chrome-extension://")?h=Ld(g).b==h&&"chrome-extension"==m:"http"!=m&&"https"!=m?h=!1:se.test(g)?h=h==g:(g=g.split(".").join("\\."),h=(new RegExp("^(.+\\."+g+"|"+g+")$","i")).test(h));if(h){c=!0;break a}}c=!1}if(!c)throw new ch(he());})}
function xj(a){if(a.l)return a.l;a.l=ue().then(function(){if(!a.o){var b=a.c,c=a.h,d=uj(a.b),e=new sj(a.u,a.f,a.b);e.f=b;e.b=c;e.c=Ra(d||[]);a.o=e.toString()}a.i=new jj(a.o);yj(a)});return a.l}k=vj.prototype;k.Fb=function(a,b,c){var d=new M("popup-closed-by-user"),e=new M("web-storage-unsupported"),f=this,g=!1;return this.ia().then(function(){zj(f).then(function(h){h||(a&&oe(a),b(e),g=!0)})}).s(function(){}).then(function(){if(!g)return re(a)}).then(function(){if(!g)return nd(c).then(function(){b(d)})})};
k.Ob=function(){var a=I();return!Je(a)&&!Ne(a)};k.Jb=function(){return!1};
k.Db=function(a,b,c,d,e,f,g,h){if(!a)return E(new M("popup-blocked"));if(g&&!Je())return this.ia().s(function(p){oe(a);e(p)}),d(),D();this.a||(this.a=wj(Aj(this)));var m=this;return this.a.then(function(){var p=m.ia().s(function(u){oe(a);e(u);throw u;});d();return p}).then(function(){Xg(c);if(!g){var p=Bj(m.u,m.f,m.b,b,c,null,f,m.c,void 0,m.h,h);ie(p,a)}}).s(function(p){"auth/network-request-failed"==p.code&&(m.a=null);throw p;})};
function Aj(a){a.m||(a.v=a.c?Ee(a.c,uj(a.b)):null,a.m=new ni(a.f,Uf(a.h),a.v));return a.m}k.Eb=function(a,b,c,d){this.a||(this.a=wj(Aj(this)));var e=this;return this.a.then(function(){Xg(b);var f=Bj(e.u,e.f,e.b,a,b,he(),c,e.c,void 0,e.h,d);ie(f)}).s(function(f){"auth/network-request-failed"==f.code&&(e.a=null);throw f;})};k.ia=function(){var a=this;return xj(this).then(function(){return a.i.gb}).s(function(){a.a=null;throw new M("network-request-failed");})};k.Rb=function(){return!0};
function Bj(a,b,c,d,e,f,g,h,m,p,u){a=new tj(a,b,c,d,e);a.l=f;a.g=g;a.i=h;a.b=Ua(m||null);a.f=p;return a.nb(u).toString()}function yj(a){if(!a.i)throw Error("IfcHandler must be initialized!");oj(a.i,function(b){var c={};if(b&&b.authEvent){var d=!1;b=Zg(b.authEvent);for(c=0;c<a.g.length;c++)d=a.g[c](b)||d;c={};c.status=d?"ACK":"ERROR";return D(c)}c.status="ERROR";return D(c)})}
function zj(a){var b={type:"webStorageSupport"};return xj(a).then(function(){return nj(a.i,b)}).then(function(c){if(c&&c.length&&"undefined"!==typeof c[0].webStorageSupport)return c[0].webStorageSupport;throw Error();})}k.Aa=function(a){this.g.push(a)};k.Na=function(a){Pa(this.g,function(b){return b==a})};function Cj(a){this.a=a||__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.reactNative&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.reactNative.AsyncStorage;if(!this.a)throw new M("internal-error","The React Native compatibility library was not found.");this.type="asyncStorage"}k=Cj.prototype;k.get=function(a){return D(this.a.getItem(a)).then(function(b){return b&&Me(b)})};k.set=function(a,b){return D(this.a.setItem(a,Ke(b)))};k.S=function(a){return D(this.a.removeItem(a))};k.$=function(){};k.ea=function(){};function Dj(a){this.b=a;this.a={};this.f=t(this.c,this)}var Ej=[];function Fj(){var a=ze()?self:null;x(Ej,function(c){c.b==a&&(b=c)});if(!b){var b=new Dj(a);Ej.push(b)}return b}
Dj.prototype.c=function(a){var b=a.data.eventType,c=a.data.eventId,d=this.a[b];if(d&&0<d.length){a.ports[0].postMessage({status:"ack",eventId:c,eventType:b,response:null});var e=[];x(d,function(f){e.push(D().then(function(){return f(a.origin,a.data.data)}))});bc(e).then(function(f){var g=[];x(f,function(h){g.push({fulfilled:h.Gb,value:h.value,reason:h.reason?h.reason.message:void 0})});x(g,function(h){for(var m in h)"undefined"===typeof h[m]&&delete h[m]});a.ports[0].postMessage({status:"done",eventId:c,
eventType:b,response:g})})}};function Gj(a,b,c){Ta(a.a)&&a.b.addEventListener("message",a.f);"undefined"===typeof a.a[b]&&(a.a[b]=[]);a.a[b].push(c)};function Hj(a){this.a=a}Hj.prototype.postMessage=function(a,b){this.a.postMessage(a,b)};function Ij(a){this.c=a;this.b=!1;this.a=[]}
function Jj(a,b,c,d){var e,f=c||{},g,h,m,p=null;if(a.b)return E(Error("connection_unavailable"));var u=d?800:50,A="undefined"!==typeof MessageChannel?new MessageChannel:null;return(new B(function(C,N){A?(e=Math.floor(Math.random()*Math.pow(10,20)).toString(),A.port1.start(),h=setTimeout(function(){N(Error("unsupported_event"))},u),g=function(wa){wa.data.eventId===e&&("ack"===wa.data.status?(clearTimeout(h),m=setTimeout(function(){N(Error("timeout"))},3E3)):"done"===wa.data.status?(clearTimeout(m),
"undefined"!==typeof wa.data.response?C(wa.data.response):N(Error("unknown_error"))):(clearTimeout(h),clearTimeout(m),N(Error("invalid_response"))))},p={messageChannel:A,onMessage:g},a.a.push(p),A.port1.addEventListener("message",g),a.c.postMessage({eventType:b,eventId:e,data:f},[A.port2])):N(Error("connection_unavailable"))})).then(function(C){Kj(a,p);return C}).s(function(C){Kj(a,p);throw C;})}
function Kj(a,b){if(b){var c=b.messageChannel,d=b.onMessage;c&&(c.port1.removeEventListener("message",d),c.port1.close());Pa(a.a,function(e){return e==b})}}Ij.prototype.close=function(){for(;0<this.a.length;)Kj(this,this.a[0]);this.b=!0};function Lj(){if(!Mj())throw new M("web-storage-unsupported");this.c={};this.a=[];this.b=0;this.u=l.indexedDB;this.type="indexedDB";this.g=this.l=this.f=this.i=null;this.o=!1;this.h=null;var a=this;ze()&&self?(this.l=Fj(),Gj(this.l,"keyChanged",function(b,c){return Nj(a).then(function(d){0<d.length&&x(a.a,function(e){e(d)});return{keyProcessed:Na(d,c.key)}})}),Gj(this.l,"ping",function(){return D(["keyChanged"])})):Ve().then(function(b){if(a.h=b)a.g=new Ij(new Hj(b)),Jj(a.g,"ping",null,!0).then(function(c){c[0].fulfilled&&
Na(c[0].value,"keyChanged")&&(a.o=!0)}).s(function(){})})}var Oj;function Pj(a){return new B(function(b,c){var d=a.u.deleteDatabase("firebaseLocalStorageDb");d.onsuccess=function(){b()};d.onerror=function(e){c(Error(e.target.error))}})}
function Qj(a){return new B(function(b,c){var d=a.u.open("firebaseLocalStorageDb",1);d.onerror=function(e){try{e.preventDefault()}catch(f){}c(Error(e.target.error))};d.onupgradeneeded=function(e){e=e.target.result;try{e.createObjectStore("firebaseLocalStorage",{keyPath:"fbase_key"})}catch(f){c(f)}};d.onsuccess=function(e){e=e.target.result;e.objectStoreNames.contains("firebaseLocalStorage")?b(e):Pj(a).then(function(){return Qj(a)}).then(function(f){b(f)}).s(function(f){c(f)})}})}
function Rj(a){a.m||(a.m=Qj(a));return a.m}function Mj(){try{return!!l.indexedDB}catch(a){return!1}}function Sj(a){return a.objectStore("firebaseLocalStorage")}function Tj(a,b){return a.transaction(["firebaseLocalStorage"],b?"readwrite":"readonly")}function Uj(a){return new B(function(b,c){a.onsuccess=function(d){d&&d.target?b(d.target.result):b()};a.onerror=function(d){c(d.target.error)}})}k=Lj.prototype;
k.set=function(a,b){var c=!1,d,e=this;return Rj(this).then(function(f){d=f;f=Sj(Tj(d,!0));return Uj(f.get(a))}).then(function(f){var g=Sj(Tj(d,!0));if(f)return f.value=b,Uj(g.put(f));e.b++;c=!0;f={};f.fbase_key=a;f.value=b;return Uj(g.add(f))}).then(function(){e.c[a]=b;return Vj(e,a)}).ka(function(){c&&e.b--})};function Vj(a,b){return a.g&&a.h&&Ue()===a.h?Jj(a.g,"keyChanged",{key:b},a.o).then(function(){}).s(function(){}):D()}
k.get=function(a){return Rj(this).then(function(b){return Uj(Sj(Tj(b,!1)).get(a))}).then(function(b){return b&&b.value})};k.S=function(a){var b=!1,c=this;return Rj(this).then(function(d){b=!0;c.b++;return Uj(Sj(Tj(d,!0))["delete"](a))}).then(function(){delete c.c[a];return Vj(c,a)}).ka(function(){b&&c.b--})};
function Nj(a){return Rj(a).then(function(b){var c=Sj(Tj(b,!1));return c.getAll?Uj(c.getAll()):new B(function(d,e){var f=[],g=c.openCursor();g.onsuccess=function(h){(h=h.target.result)?(f.push(h.value),h["continue"]()):d(f)};g.onerror=function(h){e(h.target.error)}})}).then(function(b){var c={},d=[];if(0==a.b){for(d=0;d<b.length;d++)c[b[d].fbase_key]=b[d].value;d=je(a.c,c);a.c=c}return d})}k.$=function(a){0==this.a.length&&Wj(this);this.a.push(a)};
k.ea=function(a){Pa(this.a,function(b){return b==a});0==this.a.length&&Xj(this)};function Wj(a){function b(){a.f=setTimeout(function(){a.i=Nj(a).then(function(c){0<c.length&&x(a.a,function(d){d(c)})}).then(function(){b()}).s(function(c){"STOP_EVENT"!=c.message&&b()})},800)}Xj(a);b()}function Xj(a){a.i&&a.i.cancel("STOP_EVENT");a.f&&(clearTimeout(a.f),a.f=null)};function Yj(a){var b=this,c=null;this.a=[];this.type="indexedDB";this.c=a;this.b=D().then(function(){if(Mj()){var d=Ge(),e="__sak"+d;Oj||(Oj=new Lj);c=Oj;return c.set(e,d).then(function(){return c.get(e)}).then(function(f){if(f!==d)throw Error("indexedDB not supported!");return c.S(e)}).then(function(){return c}).s(function(){return b.c})}return b.c}).then(function(d){b.type=d.type;d.$(function(e){x(b.a,function(f){f(e)})});return d})}k=Yj.prototype;k.get=function(a){return this.b.then(function(b){return b.get(a)})};
k.set=function(a,b){return this.b.then(function(c){return c.set(a,b)})};k.S=function(a){return this.b.then(function(b){return b.S(a)})};k.$=function(a){this.a.push(a)};k.ea=function(a){Pa(this.a,function(b){return b==a})};function Zj(){this.a={};this.type="inMemory"}k=Zj.prototype;k.get=function(a){return D(this.a[a])};k.set=function(a,b){this.a[a]=b;return D()};k.S=function(a){delete this.a[a];return D()};k.$=function(){};k.ea=function(){};function ak(){if(!bk()){if("Node"==Ae())throw new M("internal-error","The LocalStorage compatibility library was not found.");throw new M("web-storage-unsupported");}this.a=ck()||__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node.localStorage;this.type="localStorage"}function ck(){try{var a=l.localStorage,b=Ge();a&&(a.setItem(b,"1"),a.removeItem(b));return a}catch(c){return null}}
function bk(){var a="Node"==Ae();a=ck()||a&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node.localStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}}k=ak.prototype;k.get=function(a){var b=this;return D().then(function(){var c=b.a.getItem(a);return Me(c)})};k.set=function(a,b){var c=this;return D().then(function(){var d=Ke(b);null===d?c.S(a):c.a.setItem(a,d)})};k.S=function(a){var b=this;return D().then(function(){b.a.removeItem(a)})};
k.$=function(a){l.window&&Wc(l.window,"storage",a)};k.ea=function(a){l.window&&fd(l.window,"storage",a)};function dk(){this.type="nullStorage"}k=dk.prototype;k.get=function(){return D(null)};k.set=function(){return D()};k.S=function(){return D()};k.$=function(){};k.ea=function(){};function ek(){if(!fk()){if("Node"==Ae())throw new M("internal-error","The SessionStorage compatibility library was not found.");throw new M("web-storage-unsupported");}this.a=gk()||__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node.sessionStorage;this.type="sessionStorage"}function gk(){try{var a=l.sessionStorage,b=Ge();a&&(a.setItem(b,"1"),a.removeItem(b));return a}catch(c){return null}}
function fk(){var a="Node"==Ae();a=gk()||a&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node.sessionStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}}k=ek.prototype;k.get=function(a){var b=this;return D().then(function(){var c=b.a.getItem(a);return Me(c)})};k.set=function(a,b){var c=this;return D().then(function(){var d=Ke(b);null===d?c.S(a):c.a.setItem(a,d)})};k.S=function(a){var b=this;return D().then(function(){b.a.removeItem(a)})};k.$=function(){};
k.ea=function(){};function hk(){var a={};a.Browser=ik;a.Node=jk;a.ReactNative=kk;a.Worker=lk;this.a=a[Ae()]}var mk,ik={C:ak,Ta:ek},jk={C:ak,Ta:ek},kk={C:Cj,Ta:dk},lk={C:ak,Ta:dk};var nk={ad:"local",NONE:"none",cd:"session"};function ok(a){var b=new M("invalid-persistence-type"),c=new M("unsupported-persistence-type");a:{for(d in nk)if(nk[d]==a){var d=!0;break a}d=!1}if(!d||"string"!==typeof a)throw b;switch(Ae()){case "ReactNative":if("session"===a)throw c;break;case "Node":if("none"!==a)throw c;break;default:if(!Fe()&&"none"!==a)throw c;}}
function pk(){var a=!Ne(I())&&ye()?!0:!1,b=Je(),c=Fe();this.m=a;this.h=b;this.l=c;this.a={};mk||(mk=new hk);a=mk;try{this.g=!ge()&&Te()||!l.indexedDB?new a.a.C:new Yj(ze()?new Zj:new a.a.C)}catch(d){this.g=new Zj,this.h=!0}try{this.i=new a.a.Ta}catch(d){this.i=new Zj}this.u=new Zj;this.f=t(this.Pb,this);this.b={}}var qk;function rk(){qk||(qk=new pk);return qk}function sk(a,b){switch(b){case "session":return a.i;case "none":return a.u;default:return a.g}}
function tk(a,b){return"firebase:"+a.name+(b?":"+b:"")}function uk(a,b,c){var d=tk(b,c),e=sk(a,b.C);return a.get(b,c).then(function(f){var g=null;try{g=Me(l.localStorage.getItem(d))}catch(h){}if(g&&!f)return l.localStorage.removeItem(d),a.set(b,g,c);g&&f&&"localStorage"!=e.type&&l.localStorage.removeItem(d)})}k=pk.prototype;k.get=function(a,b){return sk(this,a.C).get(tk(a,b))};function vk(a,b,c){c=tk(b,c);"local"==b.C&&(a.b[c]=null);return sk(a,b.C).S(c)}
k.set=function(a,b,c){var d=tk(a,c),e=this,f=sk(this,a.C);return f.set(d,b).then(function(){return f.get(d)}).then(function(g){"local"==a.C&&(e.b[d]=g)})};k.addListener=function(a,b,c){a=tk(a,b);this.l&&(this.b[a]=l.localStorage.getItem(a));Ta(this.a)&&(sk(this,"local").$(this.f),this.h||(ge()||!Te())&&l.indexedDB||!this.l||wk(this));this.a[a]||(this.a[a]=[]);this.a[a].push(c)};
k.removeListener=function(a,b,c){a=tk(a,b);this.a[a]&&(Pa(this.a[a],function(d){return d==c}),0==this.a[a].length&&delete this.a[a]);Ta(this.a)&&(sk(this,"local").ea(this.f),xk(this))};function wk(a){xk(a);a.c=setInterval(function(){for(var b in a.a){var c=l.localStorage.getItem(b),d=a.b[b];c!=d&&(a.b[b]=c,c=new Kc({type:"storage",key:b,target:window,oldValue:d,newValue:c,a:!0}),a.Pb(c))}},1E3)}function xk(a){a.c&&(clearInterval(a.c),a.c=null)}
k.Pb=function(a){if(a&&a.f){var b=a.a.key;if(null==b)for(var c in this.a){var d=this.b[c];"undefined"===typeof d&&(d=null);var e=l.localStorage.getItem(c);e!==d&&(this.b[c]=e,this.$a(c))}else if(0==b.indexOf("firebase:")&&this.a[b]){"undefined"!==typeof a.a.a?sk(this,"local").ea(this.f):xk(this);if(this.m)if(c=l.localStorage.getItem(b),d=a.a.newValue,d!==c)null!==d?l.localStorage.setItem(b,d):l.localStorage.removeItem(b);else if(this.b[b]===d&&"undefined"===typeof a.a.a)return;var f=this;c=function(){if("undefined"!==
typeof a.a.a||f.b[b]!==l.localStorage.getItem(b))f.b[b]=l.localStorage.getItem(b),f.$a(b)};uc&&Fc&&10==Fc&&l.localStorage.getItem(b)!==a.a.newValue&&a.a.newValue!==a.a.oldValue?setTimeout(c,10):c()}}else x(a,t(this.$a,this))};k.$a=function(a){this.a[a]&&x(this.a[a],function(b){b()})};function yk(a){this.a=a;this.b=rk()}var zk={name:"authEvent",C:"local"};function Ak(a){return a.b.get(zk,a.a).then(function(b){return Zg(b)})};function Bk(){this.a=rk()};function Ck(){this.b=-1};function Dk(a,b){this.b=Ek;this.f=l.Uint8Array?new Uint8Array(this.b):Array(this.b);this.g=this.c=0;this.a=[];this.i=a;this.h=b;this.l=l.Int32Array?new Int32Array(64):Array(64);void 0!==Fk||(l.Int32Array?Fk=new Int32Array(Gk):Fk=Gk);this.reset()}var Fk;v(Dk,Ck);for(var Ek=64,Hk=Ek-1,Ik=[],Jk=0;Jk<Hk;Jk++)Ik[Jk]=0;var Kk=Qa(128,Ik);Dk.prototype.reset=function(){this.g=this.c=0;this.a=l.Int32Array?new Int32Array(this.h):Ra(this.h)};
function Lk(a){for(var b=a.f,c=a.l,d=0,e=0;e<b.length;)c[d++]=b[e]<<24|b[e+1]<<16|b[e+2]<<8|b[e+3],e=4*d;for(b=16;64>b;b++){e=c[b-15]|0;d=c[b-2]|0;var f=(c[b-16]|0)+((e>>>7|e<<25)^(e>>>18|e<<14)^e>>>3)|0,g=(c[b-7]|0)+((d>>>17|d<<15)^(d>>>19|d<<13)^d>>>10)|0;c[b]=f+g|0}d=a.a[0]|0;e=a.a[1]|0;var h=a.a[2]|0,m=a.a[3]|0,p=a.a[4]|0,u=a.a[5]|0,A=a.a[6]|0;f=a.a[7]|0;for(b=0;64>b;b++){var C=((d>>>2|d<<30)^(d>>>13|d<<19)^(d>>>22|d<<10))+(d&e^d&h^e&h)|0;g=p&u^~p&A;f=f+((p>>>6|p<<26)^(p>>>11|p<<21)^(p>>>25|p<<
7))|0;g=g+(Fk[b]|0)|0;g=f+(g+(c[b]|0)|0)|0;f=A;A=u;u=p;p=m+g|0;m=h;h=e;e=d;d=g+C|0}a.a[0]=a.a[0]+d|0;a.a[1]=a.a[1]+e|0;a.a[2]=a.a[2]+h|0;a.a[3]=a.a[3]+m|0;a.a[4]=a.a[4]+p|0;a.a[5]=a.a[5]+u|0;a.a[6]=a.a[6]+A|0;a.a[7]=a.a[7]+f|0}
function Mk(a,b,c){void 0===c&&(c=b.length);var d=0,e=a.c;if(n(b))for(;d<c;)a.f[e++]=b.charCodeAt(d++),e==a.b&&(Lk(a),e=0);else if(oa(b))for(;d<c;){var f=b[d++];if(!("number"==typeof f&&0<=f&&255>=f&&f==(f|0)))throw Error("message must be a byte array");a.f[e++]=f;e==a.b&&(Lk(a),e=0)}else throw Error("message must be string or array");a.c=e;a.g+=c}
var Gk=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,
4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];function Nk(){Dk.call(this,8,Ok)}v(Nk,Dk);var Ok=[1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225];function Pk(a,b,c,d,e){this.u=a;this.i=b;this.l=c;this.m=d||null;this.o=e||null;this.h=b+":"+c;this.v=new Bk;this.g=new yk(this.h);this.f=null;this.b=[];this.a=this.c=null}function Qk(a){return new M("invalid-cordova-configuration",a)}k=Pk.prototype;
k.ia=function(){return this.Da?this.Da:this.Da=ve().then(function(){if("function"!==typeof J("universalLinks.subscribe",l))throw Qk("cordova-universal-links-plugin-fix is not installed");if("undefined"===typeof J("BuildInfo.packageName",l))throw Qk("cordova-plugin-buildinfo is not installed");if("function"!==typeof J("cordova.plugins.browsertab.openUrl",l))throw Qk("cordova-plugin-browsertab is not installed");if("function"!==typeof J("cordova.InAppBrowser.open",l))throw Qk("cordova-plugin-inappbrowser is not installed");
},function(){throw new M("cordova-not-ready");})};function Rk(){for(var a=20,b=[];0<a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62*Math.random()))),a--;return b.join("")}function Sk(a){var b=new Nk;Mk(b,a);a=[];var c=8*b.g;56>b.c?Mk(b,Kk,56-b.c):Mk(b,Kk,b.b-(b.c-56));for(var d=63;56<=d;d--)b.f[d]=c&255,c/=256;Lk(b);for(d=c=0;d<b.i;d++)for(var e=24;0<=e;e-=8)a[c++]=b.a[d]>>e&255;return Kf(a)}
k.Fb=function(a,b){b(new M("operation-not-supported-in-this-environment"));return D()};k.Db=function(){return E(new M("operation-not-supported-in-this-environment"))};k.Rb=function(){return!1};k.Ob=function(){return!0};k.Jb=function(){return!0};
k.Eb=function(a,b,c,d){if(this.c)return E(new M("redirect-operation-pending"));var e=this,f=l.document,g=null,h=null,m=null,p=null;return this.c=D().then(function(){Xg(b);return Tk(e)}).then(function(){return Uk(e,a,b,c,d)}).then(function(){return(new B(function(u,A){h=function(){var C=J("cordova.plugins.browsertab.close",l);u();"function"===typeof C&&C();e.a&&"function"===typeof e.a.close&&(e.a.close(),e.a=null);return!1};e.Aa(h);m=function(){g||(g=nd(2E3).then(function(){A(new M("redirect-cancelled-by-user"))}))};
p=function(){Qe()&&m()};f.addEventListener("resume",m,!1);I().toLowerCase().match(/android/)||f.addEventListener("visibilitychange",p,!1)})).s(function(u){return Vk(e).then(function(){throw u;})})}).ka(function(){m&&f.removeEventListener("resume",m,!1);p&&f.removeEventListener("visibilitychange",p,!1);g&&g.cancel();h&&e.Na(h);e.c=null})};
function Uk(a,b,c,d,e){var f=Rk(),g=new Yg(b,d,null,f,new M("no-auth-event"),null,e),h=J("BuildInfo.packageName",l);if("string"!==typeof h)throw new M("invalid-cordova-configuration");var m=J("BuildInfo.displayName",l),p={};if(I().toLowerCase().match(/iphone|ipad|ipod/))p.ibi=h;else if(I().toLowerCase().match(/android/))p.apn=h;else return E(new M("operation-not-supported-in-this-environment"));m&&(p.appDisplayName=m);f=Sk(f);p.sessionId=f;var u=Bj(a.u,a.i,a.l,b,c,null,d,a.m,p,a.o,e);return a.ia().then(function(){var A=
a.h;return a.v.a.set(zk,g.A(),A)}).then(function(){var A=J("cordova.plugins.browsertab.isAvailable",l);if("function"!==typeof A)throw new M("invalid-cordova-configuration");var C=null;A(function(N){if(N){C=J("cordova.plugins.browsertab.openUrl",l);if("function"!==typeof C)throw new M("invalid-cordova-configuration");C(u)}else{C=J("cordova.InAppBrowser.open",l);if("function"!==typeof C)throw new M("invalid-cordova-configuration");N=I();a.a=C(u,N.match(/(iPad|iPhone|iPod).*OS 7_\d/i)||N.match(/(iPad|iPhone|iPod).*OS 8_\d/i)?
"_blank":"_system","location=yes")}})})}function Wk(a,b){for(var c=0;c<a.b.length;c++)try{a.b[c](b)}catch(d){}}function Tk(a){a.f||(a.f=a.ia().then(function(){return new B(function(b){function c(d){b(d);a.Na(c);return!1}a.Aa(c);Xk(a)})}));return a.f}function Vk(a){var b=null;return Ak(a.g).then(function(c){b=c;c=a.g;return vk(c.b,zk,c.a)}).then(function(){return b})}
function Xk(a){function b(g){d=!0;e&&e.cancel();Vk(a).then(function(h){var m=c;if(h&&g&&g.url){var p=null;m=ig(g.url);-1!=m.indexOf("/__/auth/callback")&&(p=Ld(m),p=Me(Kd(p,"firebaseError")||null),p=(p="object"===typeof p?pf(p):null)?new Yg(h.c,h.b,null,null,p,null,h.R()):new Yg(h.c,h.b,m,h.f,null,null,h.R()));m=p||c}Wk(a,m)})}var c=new Yg("unknown",null,null,null,new M("no-auth-event")),d=!1,e=nd(500).then(function(){return Vk(a).then(function(){d||Wk(a,c)})}),f=l.handleOpenURL;l.handleOpenURL=function(g){0==
g.toLowerCase().indexOf(J("BuildInfo.packageName",l).toLowerCase()+"://")&&b({url:g});if("function"===typeof f)try{f(g)}catch(h){console.error(h)}};ah||(ah=new $g);bh(b)}k.Aa=function(a){this.b.push(a);Tk(this).s(function(b){"auth/invalid-cordova-configuration"===b.code&&(b=new Yg("unknown",null,null,null,new M("no-auth-event")),a(b))})};k.Na=function(a){Pa(this.b,function(b){return b==a})};function Yk(a){this.a=a;this.b=rk()}var Zk={name:"pendingRedirect",C:"session"};function $k(a){return a.b.set(Zk,"pending",a.a)}function al(a){return vk(a.b,Zk,a.a)}function bl(a){return a.b.get(Zk,a.a).then(function(b){return"pending"==b})};function cl(a,b,c){this.i={};this.v=0;this.B=a;this.u=b;this.m=c;this.h=[];this.f=!1;this.l=t(this.o,this);this.b=new dl;this.w=new el;this.g=new Yk(this.u+":"+this.m);this.c={};this.c.unknown=this.b;this.c.signInViaRedirect=this.b;this.c.linkViaRedirect=this.b;this.c.reauthViaRedirect=this.b;this.c.signInViaPopup=this.w;this.c.linkViaPopup=this.w;this.c.reauthViaPopup=this.w;this.a=fl(this.B,this.u,this.m,Vf)}
function fl(a,b,c,d){var e=__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION||null;return we()?new Pk(a,b,c,e,d):new vj(a,b,c,e,d)}cl.prototype.reset=function(){this.f=!1;this.a.Na(this.l);this.a=fl(this.B,this.u,this.m);this.i={}};function gl(a){a.f||(a.f=!0,a.a.Aa(a.l));var b=a.a;return a.a.ia().s(function(c){a.a==b&&a.reset();throw c;})}function hl(a){a.a.Ob()&&gl(a).s(function(b){var c=new Yg("unknown",null,null,null,new M("operation-not-supported-in-this-environment"));il(b)&&a.o(c)});a.a.Jb()||jl(a.b)}
function kl(a,b){Na(a.h,b)||a.h.push(b);a.f||bl(a.g).then(function(c){c?al(a.g).then(function(){gl(a).s(function(d){var e=new Yg("unknown",null,null,null,new M("operation-not-supported-in-this-environment"));il(d)&&a.o(e)})}):hl(a)}).s(function(){hl(a)})}function ll(a,b){Pa(a.h,function(c){return c==b})}
cl.prototype.o=function(a){if(!a)throw new M("invalid-auth-event");6E5<=ua()-this.v&&(this.i={},this.v=0);if(a&&a.getUid()&&this.i.hasOwnProperty(a.getUid()))return!1;for(var b=!1,c=0;c<this.h.length;c++){var d=this.h[c];if(d.xb(a.c,a.b)){if(b=this.c[a.c])b.h(a,d),a&&(a.f||a.b)&&(this.i[a.getUid()]=!0,this.v=ua());b=!0;break}}jl(this.b);return b};var ml=new Pe(2E3,1E4),nl=new Pe(3E4,6E4);cl.prototype.oa=function(){return this.b.oa()};
function ol(a,b,c,d,e,f,g){return a.a.Db(b,c,d,function(){a.f||(a.f=!0,a.a.Aa(a.l))},function(){a.reset()},e,f,g)}function il(a){return a&&"auth/cordova-not-ready"==a.code?!0:!1}
function pl(a,b,c,d,e){var f;return $k(a.g).then(function(){return a.a.Eb(b,c,d,e).s(function(g){if(il(g))throw new M("operation-not-supported-in-this-environment");f=g;return al(a.g).then(function(){throw f;})}).then(function(){return a.a.Rb()?new B(function(){}):al(a.g).then(function(){return a.oa()}).then(function(){}).s(function(){})})})}function ql(a,b,c,d,e){return a.a.Fb(d,function(f){b.ja(c,null,f,e)},ml.get())}var rl={};
function sl(a,b,c){var d=b+":"+c;rl[d]||(rl[d]=new cl(a,b,c));return rl[d]}function dl(){this.b=null;this.f=[];this.c=[];this.a=null;this.i=this.g=!1}dl.prototype.reset=function(){this.b=null;this.a&&(this.a.cancel(),this.a=null)};
dl.prototype.h=function(a,b){if(a){this.reset();this.g=!0;var c=a.c,d=a.b,e=a.a&&"auth/web-storage-unsupported"==a.a.code,f=a.a&&"auth/operation-not-supported-in-this-environment"==a.a.code;this.i=!(!e&&!f);"unknown"!=c||e||f?a.a?(tl(this,!0,null,a.a),D()):b.Ba(c,d)?ul(this,a,b):E(new M("invalid-auth-event")):(tl(this,!1,null,null),D())}else E(new M("invalid-auth-event"))};function jl(a){a.g||(a.g=!0,tl(a,!1,null,null))}function vl(a){a.g&&!a.i&&tl(a,!1,null,null)}
function ul(a,b,c){c=c.Ba(b.c,b.b);var d=b.g,e=b.f,f=b.i,g=b.R(),h=!!b.c.match(/Redirect$/);c(d,e,g,f).then(function(m){tl(a,h,m,null)}).s(function(m){tl(a,h,null,m)})}function wl(a,b){a.b=function(){return E(b)};if(a.c.length)for(var c=0;c<a.c.length;c++)a.c[c](b)}function xl(a,b){a.b=function(){return D(b)};if(a.f.length)for(var c=0;c<a.f.length;c++)a.f[c](b)}function tl(a,b,c,d){b?d?wl(a,d):xl(a,c):xl(a,{user:null});a.f=[];a.c=[]}
dl.prototype.oa=function(){var a=this;return new B(function(b,c){a.b?a.b().then(b,c):(a.f.push(b),a.c.push(c),yl(a))})};function yl(a){var b=new M("timeout");a.a&&a.a.cancel();a.a=nd(nl.get()).then(function(){a.b||(a.g=!0,tl(a,!0,null,b))})}function el(){}el.prototype.h=function(a,b){if(a){var c=a.c,d=a.b;a.a?(b.ja(a.c,null,a.a,a.b),D()):b.Ba(c,d)?zl(a,b):E(new M("invalid-auth-event"))}else E(new M("invalid-auth-event"))};
function zl(a,b){var c=a.b,d=a.c;b.Ba(d,c)(a.g,a.f,a.R(),a.i).then(function(e){b.ja(d,e,null,c)}).s(function(e){b.ja(d,null,e,c)})};function Al(){this.vb=!1;Object.defineProperty(this,"appVerificationDisabled",{get:function(){return this.vb},set:function(a){this.vb=a},enumerable:!1})};function Bl(a,b){this.a=b;K(this,"verificationId",a)}Bl.prototype.confirm=function(a){a=Vg(this.verificationId,a);return this.a(a)};function Cl(a,b,c,d){return(new Tg(a)).Wa(b,c).then(function(e){return new Bl(e,d)})};function Dl(a){var b=Sf(a);if(!(b&&b.exp&&b.auth_time&&b.iat))throw new M("internal-error","An internal error occurred. The token obtained by Firebase appears to be malformed. Please retry the operation.");L(this,{token:a,expirationTime:Se(1E3*b.exp),authTime:Se(1E3*b.auth_time),issuedAtTime:Se(1E3*b.iat),signInProvider:b.firebase&&b.firebase.sign_in_provider?b.firebase.sign_in_provider:null,claims:b})};function El(a,b,c){this.h=a;this.i=b;this.g=c;this.c=3E4;this.f=96E4;this.b=null;this.a=this.c;if(this.f<this.c)throw Error("Proactive refresh lower bound greater than upper bound!");}El.prototype.start=function(){this.a=this.c;Fl(this,!0)};function Gl(a,b){if(b)return a.a=a.c,a.g();b=a.a;a.a*=2;a.a>a.f&&(a.a=a.f);return b}function Fl(a,b){a.stop();a.b=nd(Gl(a,b)).then(function(){return Re()}).then(function(){return a.h()}).then(function(){Fl(a,!0)}).s(function(c){a.i(c)&&Fl(a,!1)})}
El.prototype.stop=function(){this.b&&(this.b.cancel(),this.b=null)};function Hl(a){this.f=a;this.b=this.a=null;this.c=0}Hl.prototype.A=function(){return{apiKey:this.f.c,refreshToken:this.a,accessToken:this.b,expirationTime:this.c}};function Il(a,b){var c=b[lg],d=b.refreshToken;b=Jl(b.expiresIn);a.b=c;a.c=b;a.a=d}function Kl(a,b){a.b=b.b;a.a=b.a;a.c=b.c}function Jl(a){return ua()+1E3*parseInt(a,10)}
function Ll(a,b){return zi(a.f,b).then(function(c){a.b=c.access_token;a.c=Jl(c.expires_in);a.a=c.refresh_token;return{accessToken:a.b,expirationTime:a.c,refreshToken:a.a}}).s(function(c){"auth/user-token-expired"==c.code&&(a.a=null);throw c;})}Hl.prototype.getToken=function(a){a=!!a;return this.b&&!this.a?E(new M("user-token-expired")):a||!this.b||ua()>this.c-3E4?this.a?Ll(this,{grant_type:"refresh_token",refresh_token:this.a}):D(null):D({accessToken:this.b,expirationTime:this.c,refreshToken:this.a})};function Ml(a,b){this.a=a||null;this.b=b||null;L(this,{lastSignInTime:Se(b||null),creationTime:Se(a||null)})}function Nl(a){return new Ml(a.a,a.b)}Ml.prototype.A=function(){return{lastLoginAt:this.b,createdAt:this.a}};function Ol(a,b,c,d,e,f){L(this,{uid:a,displayName:d||null,photoURL:e||null,email:c||null,phoneNumber:f||null,providerId:b})}function Pl(a,b){F.call(this,a);for(var c in b)this[c]=b[c]}v(Pl,F);
function Q(a,b,c){this.I=[];this.l=a.apiKey;this.m=a.appName;this.o=a.authDomain||null;a=__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION?Ee(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION):null;this.a=new ni(this.l,Uf(Vf),a);this.b=new Hl(this.a);Ql(this,b[lg]);Il(this.b,b);K(this,"refreshToken",this.b.a);Rl(this,c||{});G.call(this);this.J=!1;this.o&&He()&&(this.i=sl(this.o,this.l,this.m));this.O=[];this.h=null;this.w=Sl(this);this.W=t(this.Ja,this);var d=this;this.ga=null;this.xa=function(e){d.ua(e.g)};this.Z=null;this.P=[];this.wa=function(e){Tl(d,
e.c)};this.Y=null}v(Q,G);Q.prototype.ua=function(a){this.ga=a;ti(this.a,a)};Q.prototype.ha=function(){return this.ga};function Ul(a,b){a.Z&&fd(a.Z,"languageCodeChanged",a.xa);(a.Z=b)&&Wc(b,"languageCodeChanged",a.xa)}function Tl(a,b){a.P=b;ui(a.a,__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION?Ee(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION,a.P):null)}Q.prototype.Ca=function(){return Ra(this.P)};function Vl(a,b){a.Y&&fd(a.Y,"frameworkChanged",a.wa);(a.Y=b)&&Wc(b,"frameworkChanged",a.wa)}Q.prototype.Ja=function(){this.w.b&&(this.w.stop(),this.w.start())};
function Wl(a){try{return __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.app(a.m).auth()}catch(b){throw new M("internal-error","No firebase.auth.Auth instance is available for the Firebase App '"+a.m+"'!");}}function Sl(a){return new El(function(){return a.G(!0)},function(b){return b&&"auth/network-request-failed"==b.code?!0:!1},function(){var b=a.b.c-ua()-3E5;return 0<b?b:0})}function Xl(a){a.B||a.w.b||(a.w.start(),fd(a,"tokenChanged",a.W),Wc(a,"tokenChanged",a.W))}function Yl(a){fd(a,"tokenChanged",a.W);a.w.stop()}
function Ql(a,b){a.ma=b;K(a,"_lat",b)}function Zl(a,b){Pa(a.O,function(c){return c==b})}function $l(a){for(var b=[],c=0;c<a.O.length;c++)b.push(a.O[c](a));return bc(b).then(function(){return a})}function am(a){a.i&&!a.J&&(a.J=!0,kl(a.i,a))}
function Rl(a,b){L(a,{uid:b.uid,displayName:b.displayName||null,photoURL:b.photoURL||null,email:b.email||null,emailVerified:b.emailVerified||!1,phoneNumber:b.phoneNumber||null,isAnonymous:b.isAnonymous||!1,tenantId:b.tenantId||null,metadata:new Ml(b.createdAt,b.lastLoginAt),providerData:[]});a.a.b=a.tenantId}K(Q.prototype,"providerId","firebase");function bm(){}function cm(a){return D().then(function(){if(a.B)throw new M("app-deleted");})}
function dm(a){return Ja(a.providerData,function(b){return b.providerId})}function em(a,b){b&&(fm(a,b.providerId),a.providerData.push(b))}function fm(a,b){Pa(a.providerData,function(c){return c.providerId==b})}function gm(a,b,c){("uid"!=b||c)&&a.hasOwnProperty(b)&&K(a,b,c)}
function hm(a,b){a!=b&&(L(a,{uid:b.uid,displayName:b.displayName,photoURL:b.photoURL,email:b.email,emailVerified:b.emailVerified,phoneNumber:b.phoneNumber,isAnonymous:b.isAnonymous,tenantId:b.tenantId,providerData:[]}),b.metadata?K(a,"metadata",Nl(b.metadata)):K(a,"metadata",new Ml),x(b.providerData,function(c){em(a,c)}),Kl(a.b,b.b),K(a,"refreshToken",a.b.a))}k=Q.prototype;k.reload=function(){var a=this;return R(this,cm(this).then(function(){return im(a).then(function(){return $l(a)}).then(bm)}))};
function im(a){return a.G().then(function(b){var c=a.isAnonymous;return jm(a,b).then(function(){c||gm(a,"isAnonymous",!1);return b})})}k.dc=function(a){return this.G(a).then(function(b){return new Dl(b)})};k.G=function(a){var b=this;return R(this,cm(this).then(function(){return b.b.getToken(a)}).then(function(c){if(!c)throw new M("internal-error");c.accessToken!=b.ma&&(Ql(b,c.accessToken),b.dispatchEvent(new Pl("tokenChanged")));gm(b,"refreshToken",c.refreshToken);return c.accessToken}))};
function km(a,b){b[lg]&&a.ma!=b[lg]&&(Il(a.b,b),a.dispatchEvent(new Pl("tokenChanged")),Ql(a,b[lg]),gm(a,"refreshToken",a.b.a))}function jm(a,b){return P(a.a,gj,{idToken:b}).then(t(a.zc,a))}
k.zc=function(a){a=a.users;if(!a||!a.length)throw new M("internal-error");a=a[0];Rl(this,{uid:a.localId,displayName:a.displayName,photoURL:a.photoUrl,email:a.email,emailVerified:!!a.emailVerified,phoneNumber:a.phoneNumber,lastLoginAt:a.lastLoginAt,createdAt:a.createdAt,tenantId:a.tenantId});for(var b=lm(a),c=0;c<b.length;c++)em(this,b[c]);gm(this,"isAnonymous",!(this.email&&a.passwordHash)&&!(this.providerData&&this.providerData.length))};
function lm(a){return(a=a.providerUserInfo)&&a.length?Ja(a,function(b){return new Ol(b.rawId,b.providerId,b.email,b.displayName,b.photoUrl,b.phoneNumber)}):[]}k.Ac=function(a){Xe("firebase.User.prototype.reauthenticateAndRetrieveDataWithCredential is deprecated. Please use firebase.User.prototype.reauthenticateWithCredential instead.");return this.hb(a)};
k.hb=function(a){var b=this,c=null;return R(this,a.f(this.a,this.uid).then(function(d){km(b,d);c=mm(b,d,"reauthenticate");b.h=null;return b.reload()}).then(function(){return c}),!0)};function nm(a,b){return im(a).then(function(){if(Na(dm(a),b))return $l(a).then(function(){throw new M("provider-already-linked");})})}k.rc=function(a){Xe("firebase.User.prototype.linkAndRetrieveDataWithCredential is deprecated. Please use firebase.User.prototype.linkWithCredential instead.");return this.fb(a)};
k.fb=function(a){var b=this,c=null;return R(this,nm(this,a.providerId).then(function(){return b.G()}).then(function(d){return a.b(b.a,d)}).then(function(d){c=mm(b,d,"link");return om(b,d)}).then(function(){return c}))};k.sc=function(a,b){var c=this;return R(this,nm(this,"phone").then(function(){return Cl(Wl(c),a,b,t(c.fb,c))}))};k.Bc=function(a,b){var c=this;return R(this,D().then(function(){return Cl(Wl(c),a,b,t(c.hb,c))}),!0)};
function mm(a,b,c){var d=Wg(b);b=$f(b);return $e({user:a,credential:d,additionalUserInfo:b,operationType:c})}function om(a,b){km(a,b);return a.reload().then(function(){return a})}k.rb=function(a){var b=this;return R(this,this.G().then(function(c){return b.a.rb(c,a)}).then(function(c){km(b,c);return b.reload()}))};k.Sc=function(a){var b=this;return R(this,this.G().then(function(c){return a.b(b.a,c)}).then(function(c){km(b,c);return b.reload()}))};
k.sb=function(a){var b=this;return R(this,this.G().then(function(c){return b.a.sb(c,a)}).then(function(c){km(b,c);return b.reload()}))};
k.tb=function(a){if(void 0===a.displayName&&void 0===a.photoURL)return cm(this);var b=this;return R(this,this.G().then(function(c){return b.a.tb(c,{displayName:a.displayName,photoUrl:a.photoURL})}).then(function(c){km(b,c);gm(b,"displayName",c.displayName||null);gm(b,"photoURL",c.photoUrl||null);x(b.providerData,function(d){"password"===d.providerId&&(K(d,"displayName",b.displayName),K(d,"photoURL",b.photoURL))});return $l(b)}).then(bm))};
k.Qc=function(a){var b=this;return R(this,im(this).then(function(c){return Na(dm(b),a)?Si(b.a,c,[a]).then(function(d){var e={};x(d.providerUserInfo||[],function(f){e[f.providerId]=!0});x(dm(b),function(f){e[f]||fm(b,f)});e[Tg.PROVIDER_ID]||K(b,"phoneNumber",null);return $l(b)}):$l(b).then(function(){throw new M("no-such-provider");})}))};
k.delete=function(){var a=this;return R(this,this.G().then(function(b){return P(a.a,fj,{idToken:b})}).then(function(){a.dispatchEvent(new Pl("userDeleted"))})).then(function(){for(var b=0;b<a.I.length;b++)a.I[b].cancel("app-deleted");Ul(a,null);Vl(a,null);a.I=[];a.B=!0;Yl(a);K(a,"refreshToken",null);a.i&&ll(a.i,a)})};
k.xb=function(a,b){return"linkViaPopup"==a&&(this.g||null)==b&&this.f||"reauthViaPopup"==a&&(this.g||null)==b&&this.f||"linkViaRedirect"==a&&(this.ca||null)==b||"reauthViaRedirect"==a&&(this.ca||null)==b?!0:!1};k.ja=function(a,b,c,d){"linkViaPopup"!=a&&"reauthViaPopup"!=a||d!=(this.g||null)||(c&&this.v?this.v(c):b&&!c&&this.f&&this.f(b),this.c&&(this.c.cancel(),this.c=null),delete this.f,delete this.v)};
k.Ba=function(a,b){return"linkViaPopup"==a&&b==(this.g||null)?t(this.Bb,this):"reauthViaPopup"==a&&b==(this.g||null)?t(this.Cb,this):"linkViaRedirect"==a&&(this.ca||null)==b?t(this.Bb,this):"reauthViaRedirect"==a&&(this.ca||null)==b?t(this.Cb,this):null};k.tc=function(a){var b=this;return pm(this,"linkViaPopup",a,function(){return nm(b,a.providerId).then(function(){return $l(b)})},!1)};k.Cc=function(a){return pm(this,"reauthViaPopup",a,function(){return D()},!0)};
function pm(a,b,c,d,e){if(!He())return E(new M("operation-not-supported-in-this-environment"));if(a.h&&!e)return E(a.h);var f=Zf(c.providerId),g=Ge(a.uid+":::"),h=null;(!Je()||ye())&&a.o&&c.isOAuthProvider&&(h=Bj(a.o,a.l,a.m,b,c,null,g,__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION||null,null,null,a.tenantId));var m=pe(h,f&&f.sa,f&&f.ra);d=d().then(function(){qm(a);if(!e)return a.G().then(function(){})}).then(function(){return ol(a.i,m,b,c,g,!!h,a.tenantId)}).then(function(){return new B(function(p,u){a.ja(b,null,new M("cancelled-popup-request"),
a.g||null);a.f=p;a.v=u;a.g=g;a.c=ql(a.i,a,b,m,g)})}).then(function(p){m&&oe(m);return p?$e(p):null}).s(function(p){m&&oe(m);throw p;});return R(a,d,e)}k.uc=function(a){var b=this;return rm(this,"linkViaRedirect",a,function(){return nm(b,a.providerId)},!1)};k.Dc=function(a){return rm(this,"reauthViaRedirect",a,function(){return D()},!0)};
function rm(a,b,c,d,e){if(!He())return E(new M("operation-not-supported-in-this-environment"));if(a.h&&!e)return E(a.h);var f=null,g=Ge(a.uid+":::");d=d().then(function(){qm(a);if(!e)return a.G().then(function(){})}).then(function(){a.ca=g;return $l(a)}).then(function(h){a.da&&(h=a.da,h=h.b.set(sm,a.A(),h.a));return h}).then(function(){return pl(a.i,b,c,g,a.tenantId)}).s(function(h){f=h;if(a.da)return tm(a.da);throw f;}).then(function(){if(f)throw f;});return R(a,d,e)}
function qm(a){if(!a.i||!a.J){if(a.i&&!a.J)throw new M("internal-error");throw new M("auth-domain-config-required");}}k.Bb=function(a,b,c,d){var e=this;this.c&&(this.c.cancel(),this.c=null);var f=null;c=this.G().then(function(g){return pg(e.a,{requestUri:a,postBody:d,sessionId:b,idToken:g})}).then(function(g){f=mm(e,g,"link");return om(e,g)}).then(function(){return f});return R(this,c)};
k.Cb=function(a,b,c,d){var e=this;this.c&&(this.c.cancel(),this.c=null);var f=null,g=D().then(function(){return kg(qg(e.a,{requestUri:a,sessionId:b,postBody:d,tenantId:c}),e.uid)}).then(function(h){f=mm(e,h,"reauthenticate");km(e,h);e.h=null;return e.reload()}).then(function(){return f});return R(this,g,!0)};
k.jb=function(a){var b=this,c=null;return R(this,this.G().then(function(d){c=d;return"undefined"===typeof a||Ta(a)?{}:Jf(new zf(a))}).then(function(d){return b.a.jb(c,d)}).then(function(d){if(b.email!=d)return b.reload()}).then(function(){}))};function R(a,b,c){var d=um(a,b,c);a.I.push(d);d.ka(function(){Oa(a.I,d)});return d}
function um(a,b,c){return a.h&&!c?(b.cancel(),E(a.h)):b.s(function(d){!d||"auth/user-disabled"!=d.code&&"auth/user-token-expired"!=d.code||(a.h||a.dispatchEvent(new Pl("userInvalidated")),a.h=d);throw d;})}k.toJSON=function(){return this.A()};
k.A=function(){var a={uid:this.uid,displayName:this.displayName,photoURL:this.photoURL,email:this.email,emailVerified:this.emailVerified,phoneNumber:this.phoneNumber,isAnonymous:this.isAnonymous,tenantId:this.tenantId,providerData:[],apiKey:this.l,appName:this.m,authDomain:this.o,stsTokenManager:this.b.A(),redirectEventId:this.ca||null};this.metadata&&Wa(a,this.metadata.A());x(this.providerData,function(b){a.providerData.push(af(b))});return a};
function vm(a){if(!a.apiKey)return null;var b={apiKey:a.apiKey,authDomain:a.authDomain,appName:a.appName},c={};if(a.stsTokenManager&&a.stsTokenManager.accessToken&&a.stsTokenManager.expirationTime)c[lg]=a.stsTokenManager.accessToken,c.refreshToken=a.stsTokenManager.refreshToken||null,c.expiresIn=(a.stsTokenManager.expirationTime-ua())/1E3;else return null;var d=new Q(b,c,a);a.providerData&&x(a.providerData,function(e){e&&em(d,$e(e))});a.redirectEventId&&(d.ca=a.redirectEventId);return d}
function wm(a,b,c,d){var e=new Q(a,b);c&&(e.da=c);d&&Tl(e,d);return e.reload().then(function(){return e})}function xm(a,b,c,d){b=b||{apiKey:a.l,authDomain:a.o,appName:a.m};var e=a.b,f={};f[lg]=e.b;f.refreshToken=e.a;f.expiresIn=(e.c-ua())/1E3;b=new Q(b,f);c&&(b.da=c);d&&Tl(b,d);hm(b,a);return b};function ym(a){this.a=a;this.b=rk()}var sm={name:"redirectUser",C:"session"};function tm(a){return vk(a.b,sm,a.a)}function zm(a,b){return a.b.get(sm,a.a).then(function(c){c&&b&&(c.authDomain=b);return vm(c||{})})};function Am(a){this.a=a;this.b=rk();this.c=null;this.f=Bm(this);this.b.addListener(Cm("local"),this.a,t(this.g,this))}Am.prototype.g=function(){var a=this,b=Cm("local");Dm(this,function(){return D().then(function(){return a.c&&"local"!=a.c.C?a.b.get(b,a.a):null}).then(function(c){if(c)return Em(a,"local").then(function(){a.c=b})})})};function Em(a,b){var c=[],d;for(d in nk)nk[d]!==b&&c.push(vk(a.b,Cm(nk[d]),a.a));c.push(vk(a.b,Fm,a.a));return ac(c)}
function Bm(a){var b=Cm("local"),c=Cm("session"),d=Cm("none");return uk(a.b,b,a.a).then(function(){return a.b.get(c,a.a)}).then(function(e){return e?c:a.b.get(d,a.a).then(function(f){return f?d:a.b.get(b,a.a).then(function(g){return g?b:a.b.get(Fm,a.a).then(function(h){return h?Cm(h):b})})})}).then(function(e){a.c=e;return Em(a,e.C)}).s(function(){a.c||(a.c=b)})}var Fm={name:"persistence",C:"session"};function Cm(a){return{name:"authUser",C:a}}
Am.prototype.mb=function(a){var b=null,c=this;ok(a);return Dm(this,function(){return a!=c.c.C?c.b.get(c.c,c.a).then(function(d){b=d;return Em(c,a)}).then(function(){c.c=Cm(a);if(b)return c.b.set(c.c,b,c.a)}):D()})};function Gm(a){return Dm(a,function(){return a.b.set(Fm,a.c.C,a.a)})}function Hm(a,b){return Dm(a,function(){return a.b.set(a.c,b.A(),a.a)})}function Im(a){return Dm(a,function(){return vk(a.b,a.c,a.a)})}
function Jm(a,b){return Dm(a,function(){return a.b.get(a.c,a.a).then(function(c){c&&b&&(c.authDomain=b);return vm(c||{})})})}function Dm(a,b){a.f=a.f.then(b,b);return a.f};function Km(a){this.l=!1;K(this,"settings",new Al);K(this,"app",a);if(S(this).options&&S(this).options.apiKey)a=__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION?Ee(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION):null,this.b=new ni(S(this).options&&S(this).options.apiKey,Uf(Vf),a);else throw new M("invalid-api-key");this.O=[];this.m=[];this.J=[];this.Ub=__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.createSubscribe(t(this.oc,this));this.W=void 0;this.Vb=__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.createSubscribe(t(this.pc,this));Lm(this,null);this.h=new Am(S(this).options.apiKey+":"+S(this).name);this.w=
new ym(S(this).options.apiKey+":"+S(this).name);this.Y=T(this,Mm(this));this.i=T(this,Nm(this));this.ga=!1;this.ma=t(this.Nc,this);this.ub=t(this.aa,this);this.wa=t(this.bc,this);this.xa=t(this.mc,this);this.Ja=t(this.nc,this);this.a=null;Om(this);this.INTERNAL={};this.INTERNAL["delete"]=t(this.delete,this);this.INTERNAL.logFramework=t(this.vc,this);this.o=0;G.call(this);Pm(this);this.I=[]}v(Km,G);function Qm(a){F.call(this,"languageCodeChanged");this.g=a}v(Qm,F);
function Rm(a){F.call(this,"frameworkChanged");this.c=a}v(Rm,F);k=Km.prototype;k.mb=function(a){a=this.h.mb(a);return T(this,a)};k.ua=function(a){this.Z===a||this.l||(this.Z=a,ti(this.b,this.Z),this.dispatchEvent(new Qm(this.ha())))};k.ha=function(){return this.Z};k.Tc=function(){var a=l.navigator;this.ua(a?a.languages&&a.languages[0]||a.language||a.userLanguage||null:null)};k.vc=function(a){this.I.push(a);ui(this.b,__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION?Ee(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION,this.I):null);this.dispatchEvent(new Rm(this.I))};
k.Ca=function(){return Ra(this.I)};k.nb=function(a){this.P===a||this.l||(this.P=a,this.b.b=this.P)};k.R=function(){return this.P};function Pm(a){Object.defineProperty(a,"lc",{get:function(){return this.ha()},set:function(b){this.ua(b)},enumerable:!1});a.Z=null;Object.defineProperty(a,"ti",{get:function(){return this.R()},set:function(b){this.nb(b)},enumerable:!1});a.P=null}
k.toJSON=function(){return{apiKey:S(this).options.apiKey,authDomain:S(this).options.authDomain,appName:S(this).name,currentUser:U(this)&&U(this).A()}};function Sm(a){return a.Tb||E(new M("auth-domain-config-required"))}function Om(a){var b=S(a).options.authDomain,c=S(a).options.apiKey;b&&He()&&(a.Tb=a.Y.then(function(){if(!a.l){a.a=sl(b,c,S(a).name);kl(a.a,a);U(a)&&am(U(a));if(a.B){am(a.B);var d=a.B;d.ua(a.ha());Ul(d,a);d=a.B;Tl(d,a.I);Vl(d,a);a.B=null}return a.a}}))}
k.xb=function(a,b){switch(a){case "unknown":case "signInViaRedirect":return!0;case "signInViaPopup":return this.g==b&&!!this.f;default:return!1}};k.ja=function(a,b,c,d){"signInViaPopup"==a&&this.g==d&&(c&&this.v?this.v(c):b&&!c&&this.f&&this.f(b),this.c&&(this.c.cancel(),this.c=null),delete this.f,delete this.v)};k.Ba=function(a,b){return"signInViaRedirect"==a||"signInViaPopup"==a&&this.g==b&&this.f?t(this.ac,this):null};
k.ac=function(a,b,c,d){var e=this;a={requestUri:a,postBody:d,sessionId:b,tenantId:c};this.c&&(this.c.cancel(),this.c=null);var f=null,g=null,h=ng(e.b,a).then(function(m){f=Wg(m);g=$f(m);return m});a=e.Y.then(function(){return h}).then(function(m){return Tm(e,m)}).then(function(){return $e({user:U(e),credential:f,additionalUserInfo:g,operationType:"signIn"})});return T(this,a)};
k.Lc=function(a){if(!He())return E(new M("operation-not-supported-in-this-environment"));var b=this,c=Zf(a.providerId),d=Ge(),e=null;(!Je()||ye())&&S(this).options.authDomain&&a.isOAuthProvider&&(e=Bj(S(this).options.authDomain,S(this).options.apiKey,S(this).name,"signInViaPopup",a,null,d,__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION||null,null,null,this.R()));var f=pe(e,c&&c.sa,c&&c.ra);c=Sm(this).then(function(g){return ol(g,f,"signInViaPopup",a,d,!!e,b.R())}).then(function(){return new B(function(g,h){b.ja("signInViaPopup",
null,new M("cancelled-popup-request"),b.g);b.f=g;b.v=h;b.g=d;b.c=ql(b.a,b,"signInViaPopup",f,d)})}).then(function(g){f&&oe(f);return g?$e(g):null}).s(function(g){f&&oe(f);throw g;});return T(this,c)};k.Mc=function(a){if(!He())return E(new M("operation-not-supported-in-this-environment"));var b=this,c=Sm(this).then(function(){return Gm(b.h)}).then(function(){return pl(b.a,"signInViaRedirect",a,void 0,b.R())});return T(this,c)};
function Um(a){if(!He())return E(new M("operation-not-supported-in-this-environment"));var b=Sm(a).then(function(){return a.a.oa()}).then(function(c){return c?$e(c):null});return T(a,b)}k.oa=function(){var a=this;return Um(this).then(function(b){a.a&&vl(a.a.b);return b}).s(function(b){a.a&&vl(a.a.b);throw b;})};
k.Rc=function(a){if(!a)return E(new M("null-user"));if(this.P!=a.tenantId)return E(new M("tenant-id-mismatch"));var b=this,c={};c.apiKey=S(this).options.apiKey;c.authDomain=S(this).options.authDomain;c.appName=S(this).name;var d=xm(a,c,b.w,b.Ca());return T(this,this.i.then(function(){if(S(b).options.apiKey!=a.l)return d.reload()}).then(function(){if(U(b)&&a.uid==U(b).uid)return hm(U(b),a),b.aa(a);Lm(b,d);am(d);return b.aa(d)}).then(function(){Vm(b)}))};
function Tm(a,b){var c={};c.apiKey=S(a).options.apiKey;c.authDomain=S(a).options.authDomain;c.appName=S(a).name;return a.Y.then(function(){return wm(c,b,a.w,a.Ca())}).then(function(d){if(U(a)&&d.uid==U(a).uid)return hm(U(a),d),a.aa(d);Lm(a,d);am(d);return a.aa(d)}).then(function(){Vm(a)})}
function Lm(a,b){U(a)&&(Zl(U(a),a.ub),fd(U(a),"tokenChanged",a.wa),fd(U(a),"userDeleted",a.xa),fd(U(a),"userInvalidated",a.Ja),Yl(U(a)));b&&(b.O.push(a.ub),Wc(b,"tokenChanged",a.wa),Wc(b,"userDeleted",a.xa),Wc(b,"userInvalidated",a.Ja),0<a.o&&Xl(b));K(a,"currentUser",b);b&&(b.ua(a.ha()),Ul(b,a),Tl(b,a.I),Vl(b,a))}k.pb=function(){var a=this,b=this.i.then(function(){a.a&&vl(a.a.b);if(!U(a))return D();Lm(a,null);return Im(a.h).then(function(){Vm(a)})});return T(this,b)};
function Wm(a){var b=zm(a.w,S(a).options.authDomain).then(function(c){if(a.B=c)c.da=a.w;return tm(a.w)});return T(a,b)}function Mm(a){var b=S(a).options.authDomain,c=Wm(a).then(function(){return Jm(a.h,b)}).then(function(d){return d?(d.da=a.w,a.B&&(a.B.ca||null)==(d.ca||null)?d:d.reload().then(function(){return Hm(a.h,d).then(function(){return d})}).s(function(e){return"auth/network-request-failed"==e.code?d:Im(a.h)})):null}).then(function(d){Lm(a,d||null)});return T(a,c)}
function Nm(a){return a.Y.then(function(){return Um(a)}).s(function(){}).then(function(){if(!a.l)return a.ma()}).s(function(){}).then(function(){if(!a.l){a.ga=!0;var b=a.h;b.b.addListener(Cm("local"),b.a,a.ma)}})}
k.Nc=function(){var a=this;return Jm(this.h,S(this).options.authDomain).then(function(b){if(!a.l){var c;if(c=U(a)&&b){c=U(a).uid;var d=b.uid;c=void 0===c||null===c||""===c||void 0===d||null===d||""===d?!1:c==d}if(c)return hm(U(a),b),U(a).G();if(U(a)||b)Lm(a,b),b&&(am(b),b.da=a.w),a.a&&kl(a.a,a),Vm(a)}})};k.aa=function(a){return Hm(this.h,a)};k.bc=function(){Vm(this);this.aa(U(this))};k.mc=function(){this.pb()};k.nc=function(){this.pb()};
function Xm(a,b){var c=null,d=null;return T(a,b.then(function(e){c=Wg(e);d=$f(e);return Tm(a,e)}).then(function(){return $e({user:U(a),credential:c,additionalUserInfo:d,operationType:"signIn"})}))}k.oc=function(a){var b=this;this.addAuthTokenListener(function(){a.next(U(b))})};k.pc=function(a){var b=this;Ym(this,function(){a.next(U(b))})};k.xc=function(a,b,c){var d=this;this.ga&&Promise.resolve().then(function(){q(a)?a(U(d)):q(a.next)&&a.next(U(d))});return this.Ub(a,b,c)};
k.wc=function(a,b,c){var d=this;this.ga&&Promise.resolve().then(function(){d.W=d.getUid();q(a)?a(U(d)):q(a.next)&&a.next(U(d))});return this.Vb(a,b,c)};k.cc=function(a){var b=this,c=this.i.then(function(){return U(b)?U(b).G(a).then(function(d){return{accessToken:d}}):null});return T(this,c)};k.Hc=function(a){var b=this;return this.i.then(function(){return Xm(b,P(b.b,ij,{token:a}))}).then(function(c){var d=c.user;gm(d,"isAnonymous",!1);b.aa(d);return c})};
k.Ic=function(a,b){var c=this;return this.i.then(function(){return Xm(c,P(c.b,Ig,{email:a,password:b}))})};k.Xb=function(a,b){var c=this;return this.i.then(function(){return Xm(c,P(c.b,ej,{email:a,password:b}))})};k.Sa=function(a){var b=this;return this.i.then(function(){return Xm(b,a.na(b.b))})};k.Gc=function(a){Xe("firebase.auth.Auth.prototype.signInAndRetrieveDataWithCredential is deprecated. Please use firebase.auth.Auth.prototype.signInWithCredential instead.");return this.Sa(a)};
k.ob=function(){var a=this;return this.i.then(function(){var b=U(a);if(b&&b.isAnonymous){var c=$e({providerId:null,isNewUser:!1});return $e({user:b,credential:null,additionalUserInfo:c,operationType:"signIn"})}return Xm(a,a.b.ob()).then(function(d){var e=d.user;gm(e,"isAnonymous",!0);a.aa(e);return d})})};function S(a){return a.app}function U(a){return a.currentUser}k.getUid=function(){return U(this)&&U(this).uid||null};function Zm(a){return U(a)&&U(a)._lat||null}
function Vm(a){if(a.ga){for(var b=0;b<a.m.length;b++)if(a.m[b])a.m[b](Zm(a));if(a.W!==a.getUid()&&a.J.length)for(a.W=a.getUid(),b=0;b<a.J.length;b++)if(a.J[b])a.J[b](Zm(a))}}k.Wb=function(a){this.addAuthTokenListener(a);this.o++;0<this.o&&U(this)&&Xl(U(this))};k.Ec=function(a){var b=this;x(this.m,function(c){c==a&&b.o--});0>this.o&&(this.o=0);0==this.o&&U(this)&&Yl(U(this));this.removeAuthTokenListener(a)};
k.addAuthTokenListener=function(a){var b=this;this.m.push(a);T(this,this.i.then(function(){b.l||Na(b.m,a)&&a(Zm(b))}))};k.removeAuthTokenListener=function(a){Pa(this.m,function(b){return b==a})};function Ym(a,b){a.J.push(b);T(a,a.i.then(function(){!a.l&&Na(a.J,b)&&a.W!==a.getUid()&&(a.W=a.getUid(),b(Zm(a)))}))}
k.delete=function(){this.l=!0;for(var a=0;a<this.O.length;a++)this.O[a].cancel("app-deleted");this.O=[];this.h&&(a=this.h,a.b.removeListener(Cm("local"),a.a,this.ma));this.a&&(ll(this.a,this),vl(this.a.b));return Promise.resolve()};function T(a,b){a.O.push(b);b.ka(function(){Oa(a.O,b)});return b}k.$b=function(a){return T(this,Ei(this.b,a))};k.qc=function(a){return!!Ng(a)};
k.lb=function(a,b){var c=this;return T(this,D().then(function(){var d=new zf(b);if(!d.c)throw new M("argument-error",Hf+" must be true when sending sign in link to email");return Jf(d)}).then(function(d){return c.b.lb(a,d)}).then(function(){}))};k.Uc=function(a){return this.Ma(a).then(function(b){return b.data.email})};k.ab=function(a,b){return T(this,this.b.ab(a,b).then(function(){}))};k.Ma=function(a){return T(this,this.b.Ma(a).then(function(b){return new df(b)}))};
k.Ya=function(a){return T(this,this.b.Ya(a).then(function(){}))};k.kb=function(a,b){var c=this;return T(this,D().then(function(){return"undefined"===typeof b||Ta(b)?{}:Jf(new zf(b))}).then(function(d){return c.b.kb(a,d)}).then(function(){}))};k.Kc=function(a,b){return T(this,Cl(this,a,b,t(this.Sa,this)))};
k.Jc=function(a,b){var c=this;return T(this,D().then(function(){var d=b||he(),e=Mg(a,d);d=Ng(d);if(!d)throw new M("argument-error","Invalid email link!");if(d.tenantId!==c.R())throw new M("tenant-id-mismatch");return c.Sa(e)}))};function $m(){}$m.prototype.render=function(){};$m.prototype.reset=function(){};$m.prototype.getResponse=function(){};$m.prototype.execute=function(){};function an(){this.a={};this.b=1E12}var bn=null;an.prototype.render=function(a,b){this.a[this.b.toString()]=new cn(a,b);return this.b++};an.prototype.reset=function(a){var b=dn(this,a);a=en(a);b&&a&&(b.delete(),delete this.a[a])};an.prototype.getResponse=function(a){return(a=dn(this,a))?a.getResponse():null};an.prototype.execute=function(a){(a=dn(this,a))&&a.execute()};function dn(a,b){return(b=en(b))?a.a[b]||null:null}function en(a){return(a="undefined"===typeof a?1E12:a)?a.toString():null}
function cn(a,b){this.g=!1;this.c=b;this.a=this.b=null;this.h="invisible"!==this.c.size;this.f=Vd(a);var c=this;this.i=function(){c.execute()};this.h?this.execute():Wc(this.f,"click",this.i)}cn.prototype.getResponse=function(){fn(this);return this.b};
cn.prototype.execute=function(){fn(this);var a=this;this.a||(this.a=setTimeout(function(){a.b=Ce();var b=a.c.callback,c=a.c["expired-callback"];if(b)try{b(a.b)}catch(d){}a.a=setTimeout(function(){a.a=null;a.b=null;if(c)try{c()}catch(d){}a.h&&a.execute()},6E4)},500))};cn.prototype.delete=function(){fn(this);this.g=!0;clearTimeout(this.a);this.a=null;fd(this.f,"click",this.i)};function fn(a){if(a.g)throw Error("reCAPTCHA mock was already deleted!");};function gn(){}gn.prototype.g=function(){bn||(bn=new an);return D(bn)};gn.prototype.c=function(){};var hn=null;function jn(){this.b=l.grecaptcha?Infinity:0;this.f=null;this.a="__rcb"+Math.floor(1E6*Math.random()).toString()}var kn=new Xa(Ya,"https://www.google.com/recaptcha/api.js?onload=%{onload}&render=explicit&hl=%{hl}"),ln=new Pe(3E4,6E4);
jn.prototype.g=function(a){var b=this;return new B(function(c,d){var e=setTimeout(function(){d(new M("network-request-failed"))},ln.get());if(!l.grecaptcha||a!==b.f&&!b.b){l[b.a]=function(){if(l.grecaptcha){b.f=a;var g=l.grecaptcha.render;l.grecaptcha.render=function(h,m){h=g(h,m);b.b++;return h};clearTimeout(e);c(l.grecaptcha)}else clearTimeout(e),d(new M("internal-error"));delete l[b.a]};var f=eb(kn,{onload:b.a,hl:a||""});D(gi(f)).s(function(){clearTimeout(e);d(new M("internal-error","Unable to load external reCAPTCHA dependencies!"))})}else clearTimeout(e),
c(l.grecaptcha)})};jn.prototype.c=function(){this.b--};var mn=null;function nn(a,b,c,d,e,f,g){K(this,"type","recaptcha");this.c=this.f=null;this.B=!1;this.u=b;this.g=null;g?(hn||(hn=new gn),g=hn):(mn||(mn=new jn),g=mn);this.m=g;this.a=c||{theme:"light",type:"image"};this.h=[];if(this.a[on])throw new M("argument-error","sitekey should not be provided for reCAPTCHA as one is automatically provisioned for the current project.");this.i="invisible"===this.a[pn];if(!l.document)throw new M("operation-not-supported-in-this-environment","RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment with DOM support.");
if(!Vd(b)||!this.i&&Vd(b).hasChildNodes())throw new M("argument-error","reCAPTCHA container is either not found or already contains inner elements!");this.o=new ni(a,f||null,e||null);this.v=d||function(){return null};var h=this;this.l=[];var m=this.a[qn];this.a[qn]=function(u){rn(h,u);if("function"===typeof m)m(u);else if("string"===typeof m){var A=J(m,l);"function"===typeof A&&A(u)}};var p=this.a[sn];this.a[sn]=function(){rn(h,null);if("function"===typeof p)p();else if("string"===typeof p){var u=
J(p,l);"function"===typeof u&&u()}}}var qn="callback",sn="expired-callback",on="sitekey",pn="size";function rn(a,b){for(var c=0;c<a.l.length;c++)try{a.l[c](b)}catch(d){}}function tn(a,b){Pa(a.l,function(c){return c==b})}function un(a,b){a.h.push(b);b.ka(function(){Oa(a.h,b)});return b}k=nn.prototype;
k.Da=function(){var a=this;return this.f?this.f:this.f=un(this,D().then(function(){if(Ie()&&!ze())return ue();throw new M("operation-not-supported-in-this-environment","RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment.");}).then(function(){return a.m.g(a.v())}).then(function(b){a.g=b;return P(a.o,hj,{})}).then(function(b){a.a[on]=b.recaptchaSiteKey}).s(function(b){a.f=null;throw b;}))};
k.render=function(){vn(this);var a=this;return un(this,this.Da().then(function(){if(null===a.c){var b=a.u;if(!a.i){var c=Vd(b);b=Yd("DIV");c.appendChild(b)}a.c=a.g.render(b,a.a)}return a.c}))};k.verify=function(){vn(this);var a=this;return un(this,this.render().then(function(b){return new B(function(c){var d=a.g.getResponse(b);if(d)c(d);else{var e=function(f){f&&(tn(a,e),c(f))};a.l.push(e);a.i&&a.g.execute(a.c)}})}))};k.reset=function(){vn(this);null!==this.c&&this.g.reset(this.c)};
function vn(a){if(a.B)throw new M("internal-error","RecaptchaVerifier instance has been destroyed.");}k.clear=function(){vn(this);this.B=!0;this.m.c();for(var a=0;a<this.h.length;a++)this.h[a].cancel("RecaptchaVerifier instance has been destroyed.");if(!this.i){a=Vd(this.u);for(var b;b=a.firstChild;)a.removeChild(b)}};
function wn(a,b,c){var d=!1;try{this.b=c||__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.app()}catch(g){throw new M("argument-error","No firebase.app.App instance is currently initialized.");}if(this.b.options&&this.b.options.apiKey)c=this.b.options.apiKey;else throw new M("invalid-api-key");var e=this,f=null;try{f=this.b.auth().Ca()}catch(g){}try{d=this.b.auth().settings.appVerificationDisabledForTesting}catch(g){}f=__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION?Ee(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION,f):null;nn.call(this,c,a,b,function(){try{var g=e.b.auth().ha()}catch(h){g=
null}return g},f,Uf(Vf),d)}v(wn,nn);function xn(a,b,c,d){a:{c=Array.prototype.slice.call(c);var e=0;for(var f=!1,g=0;g<b.length;g++)if(b[g].optional)f=!0;else{if(f)throw new M("internal-error","Argument validator encountered a required argument after an optional argument.");e++}f=b.length;if(c.length<e||f<c.length)d="Expected "+(e==f?1==e?"1 argument":e+" arguments":e+"-"+f+" arguments")+" but got "+c.length+".";else{for(e=0;e<c.length;e++)if(f=b[e].optional&&void 0===c[e],!b[e].N(c[e])&&!f){b=b[e];if(0>e||e>=yn.length)throw new M("internal-error",
"Argument validator received an unsupported number of arguments.");c=yn[e];d=(d?"":c+" argument ")+(b.name?'"'+b.name+'" ':"")+"must be "+b.M+".";break a}d=null}}if(d)throw new M("argument-error",a+" failed: "+d);}var yn="First Second Third Fourth Fifth Sixth Seventh Eighth Ninth".split(" ");function V(a,b){return{name:a||"",M:"a valid string",optional:!!b,N:n}}function zn(a,b){return{name:a||"",M:"a boolean",optional:!!b,N:ha}}
function W(a,b){return{name:a||"",M:"a valid object",optional:!!b,N:r}}function An(a,b){return{name:a||"",M:"a function",optional:!!b,N:q}}function Bn(a,b){return{name:a||"",M:"null",optional:!!b,N:ma}}function Cn(){return{name:"",M:"an HTML element",optional:!1,N:function(a){return!!(a&&a instanceof Element)}}}function Dn(){return{name:"auth",M:"an instance of Firebase Auth",optional:!0,N:function(a){return!!(a&&a instanceof Km)}}}
function En(){return{name:"app",M:"an instance of Firebase App",optional:!0,N:function(a){return!!(a&&a instanceof __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.app.App)}}}function Fn(a){return{name:a?a+"Credential":"credential",M:a?"a valid "+a+" credential":"a valid credential",optional:!1,N:function(b){if(!b)return!1;var c=!a||b.providerId===a;return!(!b.na||!c)}}}
function Gn(){return{name:"authProvider",M:"a valid Auth provider",optional:!1,N:function(a){return!!(a&&a.providerId&&a.hasOwnProperty&&a.hasOwnProperty("isOAuthProvider"))}}}function Hn(){return{name:"applicationVerifier",M:"an implementation of firebase.auth.ApplicationVerifier",optional:!1,N:function(a){return!!(a&&n(a.type)&&q(a.verify))}}}function X(a,b,c,d){return{name:c||"",M:a.M+" or "+b.M,optional:!!d,N:function(e){return a.N(e)||b.N(e)}}};function Y(a,b){for(var c in b){var d=b[c].name;a[d]=In(d,a[c],b[c].j)}}function Jn(a,b){for(var c in b){var d=b[c].name;d!==c&&Object.defineProperty(a,d,{get:ta(function(e){return this[e]},c),set:ta(function(e,f,g,h){xn(e,[g],[h],!0);this[f]=h},d,c,b[c].Za),enumerable:!0})}}function Z(a,b,c,d){a[b]=In(b,c,d)}
function In(a,b,c){function d(){var g=Array.prototype.slice.call(arguments);xn(e,c,g);return b.apply(this,g)}if(!c)return b;var e=Kn(a),f;for(f in b)d[f]=b[f];for(f in b.prototype)d.prototype[f]=b.prototype[f];return d}function Kn(a){a=a.split(".");return a[a.length-1]};Y(Km.prototype,{Ya:{name:"applyActionCode",j:[V("code")]},Ma:{name:"checkActionCode",j:[V("code")]},ab:{name:"confirmPasswordReset",j:[V("code"),V("newPassword")]},Xb:{name:"createUserWithEmailAndPassword",j:[V("email"),V("password")]},$b:{name:"fetchSignInMethodsForEmail",j:[V("email")]},oa:{name:"getRedirectResult",j:[]},qc:{name:"isSignInWithEmailLink",j:[V("emailLink")]},wc:{name:"onAuthStateChanged",j:[X(W(),An(),"nextOrObserver"),An("opt_error",!0),An("opt_completed",!0)]},xc:{name:"onIdTokenChanged",
j:[X(W(),An(),"nextOrObserver"),An("opt_error",!0),An("opt_completed",!0)]},kb:{name:"sendPasswordResetEmail",j:[V("email"),X(W("opt_actionCodeSettings",!0),Bn(null,!0),"opt_actionCodeSettings",!0)]},lb:{name:"sendSignInLinkToEmail",j:[V("email"),W("actionCodeSettings")]},mb:{name:"setPersistence",j:[V("persistence")]},Gc:{name:"signInAndRetrieveDataWithCredential",j:[Fn()]},ob:{name:"signInAnonymously",j:[]},Sa:{name:"signInWithCredential",j:[Fn()]},Hc:{name:"signInWithCustomToken",j:[V("token")]},
Ic:{name:"signInWithEmailAndPassword",j:[V("email"),V("password")]},Jc:{name:"signInWithEmailLink",j:[V("email"),V("emailLink",!0)]},Kc:{name:"signInWithPhoneNumber",j:[V("phoneNumber"),Hn()]},Lc:{name:"signInWithPopup",j:[Gn()]},Mc:{name:"signInWithRedirect",j:[Gn()]},Rc:{name:"updateCurrentUser",j:[X(function(a){return{name:"user",M:"an instance of Firebase User",optional:!!a,N:function(b){return!!(b&&b instanceof Q)}}}(),Bn(),"user")]},pb:{name:"signOut",j:[]},toJSON:{name:"toJSON",j:[V(null,!0)]},
Tc:{name:"useDeviceLanguage",j:[]},Uc:{name:"verifyPasswordResetCode",j:[V("code")]}});Jn(Km.prototype,{lc:{name:"languageCode",Za:X(V(),Bn(),"languageCode")},ti:{name:"tenantId",Za:X(V(),Bn(),"tenantId")}});Km.Persistence=nk;Km.Persistence.LOCAL="local";Km.Persistence.SESSION="session";Km.Persistence.NONE="none";
Y(Q.prototype,{"delete":{name:"delete",j:[]},dc:{name:"getIdTokenResult",j:[zn("opt_forceRefresh",!0)]},G:{name:"getIdToken",j:[zn("opt_forceRefresh",!0)]},rc:{name:"linkAndRetrieveDataWithCredential",j:[Fn()]},fb:{name:"linkWithCredential",j:[Fn()]},sc:{name:"linkWithPhoneNumber",j:[V("phoneNumber"),Hn()]},tc:{name:"linkWithPopup",j:[Gn()]},uc:{name:"linkWithRedirect",j:[Gn()]},Ac:{name:"reauthenticateAndRetrieveDataWithCredential",j:[Fn()]},hb:{name:"reauthenticateWithCredential",j:[Fn()]},Bc:{name:"reauthenticateWithPhoneNumber",
j:[V("phoneNumber"),Hn()]},Cc:{name:"reauthenticateWithPopup",j:[Gn()]},Dc:{name:"reauthenticateWithRedirect",j:[Gn()]},reload:{name:"reload",j:[]},jb:{name:"sendEmailVerification",j:[X(W("opt_actionCodeSettings",!0),Bn(null,!0),"opt_actionCodeSettings",!0)]},toJSON:{name:"toJSON",j:[V(null,!0)]},Qc:{name:"unlink",j:[V("provider")]},rb:{name:"updateEmail",j:[V("email")]},sb:{name:"updatePassword",j:[V("password")]},Sc:{name:"updatePhoneNumber",j:[Fn("phone")]},tb:{name:"updateProfile",j:[W("profile")]}});
Y(an.prototype,{execute:{name:"execute"},render:{name:"render"},reset:{name:"reset"},getResponse:{name:"getResponse"}});Y($m.prototype,{execute:{name:"execute"},render:{name:"render"},reset:{name:"reset"},getResponse:{name:"getResponse"}});Y(B.prototype,{ka:{name:"finally"},s:{name:"catch"},then:{name:"then"}});Jn(Al.prototype,{appVerificationDisabled:{name:"appVerificationDisabledForTesting",Za:zn("appVerificationDisabledForTesting")}});Y(Bl.prototype,{confirm:{name:"confirm",j:[V("verificationCode")]}});
Z(jg,"fromJSON",function(a){a=n(a)?JSON.parse(a):a;for(var b,c=[ug,Lg,Sg,rg],d=0;d<c.length;d++)if(b=c[d](a))return b;return null},[X(V(),W(),"json")]);Z(Gg,"credential",function(a,b){return new Fg(a,b)},[V("email"),V("password")]);Y(Fg.prototype,{A:{name:"toJSON",j:[V(null,!0)]}});Y(xg.prototype,{ya:{name:"addScope",j:[V("scope")]},Ga:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(xg,"credential",yg,[X(V(),W(),"token")]);Z(Gg,"credentialWithLink",Mg,[V("email"),V("emailLink")]);
Y(zg.prototype,{ya:{name:"addScope",j:[V("scope")]},Ga:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(zg,"credential",Ag,[X(V(),W(),"token")]);Y(Bg.prototype,{ya:{name:"addScope",j:[V("scope")]},Ga:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(Bg,"credential",Cg,[X(V(),X(W(),Bn()),"idToken"),X(V(),Bn(),"accessToken",!0)]);Y(Dg.prototype,{Ga:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(Dg,"credential",Eg,[X(V(),W(),"token"),V("secret",!0)]);
Y(O.prototype,{ya:{name:"addScope",j:[V("scope")]},credential:{name:"credential",j:[X(V(),X(W(),Bn()),"optionsOrIdToken"),X(V(),Bn(),"accessToken",!0)]},Ga:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Y(sg.prototype,{A:{name:"toJSON",j:[V(null,!0)]}});Y(mg.prototype,{A:{name:"toJSON",j:[V(null,!0)]}});Z(Tg,"credential",Vg,[V("verificationId"),V("verificationCode")]);Y(Tg.prototype,{Wa:{name:"verifyPhoneNumber",j:[V("phoneNumber"),Hn()]}});
Y(Og.prototype,{A:{name:"toJSON",j:[V(null,!0)]}});Y(M.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(dh.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(ch.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(wn.prototype,{clear:{name:"clear",j:[]},render:{name:"render",j:[]},verify:{name:"verify",j:[]}});Z(qf,"parseLink",yf,[V("link")]);
(function(){if("undefined"!==typeof __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.registerService){var a={ActionCodeInfo:{Operation:{EMAIL_SIGNIN:hf,PASSWORD_RESET:"PASSWORD_RESET",RECOVER_EMAIL:"RECOVER_EMAIL",VERIFY_EMAIL:"VERIFY_EMAIL"}},Auth:Km,AuthCredential:jg,Error:M};Z(a,"EmailAuthProvider",Gg,[]);Z(a,"FacebookAuthProvider",xg,[]);Z(a,"GithubAuthProvider",zg,[]);Z(a,"GoogleAuthProvider",Bg,[]);Z(a,"TwitterAuthProvider",Dg,[]);Z(a,"OAuthProvider",O,[V("providerId")]);Z(a,"SAMLAuthProvider",
wg,[V("providerId")]);Z(a,"PhoneAuthProvider",Tg,[Dn()]);Z(a,"RecaptchaVerifier",wn,[X(V(),Cn(),"recaptchaContainer"),W("recaptchaParameters",!0),En()]);Z(a,"ActionCodeURL",qf,[]);__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.registerService("auth",function(b,c){b=new Km(b);c({INTERNAL:{getUid:t(b.getUid,b),getToken:t(b.cc,b),addAuthTokenListener:t(b.Wb,b),removeAuthTokenListener:t(b.Ec,b)}});return b},a,function(b,c){if("create"===b)try{c.auth()}catch(d){}});__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.extendNamespace({User:Q})}else throw Error("Cannot find the firebase namespace; be sure to include firebase-app.js before this library.");
})();}).apply(typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});

//# sourceMappingURL=auth.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(25)))

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var firebase = _interopDefault(__webpack_require__(50));
var tslib = __webpack_require__(51);
var util = __webpack_require__(66);
var logger$1 = __webpack_require__(110);

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Wraps a DOM Storage object and:
 * - automatically encode objects as JSON strings before storing them to allow us to store arbitrary types.
 * - prefixes names with "firebase:" to avoid collisions with app data.
 *
 * We automatically (see storage.js) create two such wrappers, one for sessionStorage,
 * and one for localStorage.
 *
 * @constructor
 */
var DOMStorageWrapper = /** @class */ (function () {
    /**
     * @param {Storage} domStorage_ The underlying storage object (e.g. localStorage or sessionStorage)
     */
    function DOMStorageWrapper(domStorage_) {
        this.domStorage_ = domStorage_;
        // Use a prefix to avoid collisions with other stuff saved by the app.
        this.prefix_ = 'firebase:';
    }
    /**
     * @param {string} key The key to save the value under
     * @param {?Object} value The value being stored, or null to remove the key.
     */
    DOMStorageWrapper.prototype.set = function (key, value) {
        if (value == null) {
            this.domStorage_.removeItem(this.prefixedName_(key));
        }
        else {
            this.domStorage_.setItem(this.prefixedName_(key), util.stringify(value));
        }
    };
    /**
     * @param {string} key
     * @return {*} The value that was stored under this key, or null
     */
    DOMStorageWrapper.prototype.get = function (key) {
        var storedVal = this.domStorage_.getItem(this.prefixedName_(key));
        if (storedVal == null) {
            return null;
        }
        else {
            return util.jsonEval(storedVal);
        }
    };
    /**
     * @param {string} key
     */
    DOMStorageWrapper.prototype.remove = function (key) {
        this.domStorage_.removeItem(this.prefixedName_(key));
    };
    /**
     * @param {string} name
     * @return {string}
     */
    DOMStorageWrapper.prototype.prefixedName_ = function (name) {
        return this.prefix_ + name;
    };
    DOMStorageWrapper.prototype.toString = function () {
        return this.domStorage_.toString();
    };
    return DOMStorageWrapper;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An in-memory storage implementation that matches the API of DOMStorageWrapper
 * (TODO: create interface for both to implement).
 *
 * @constructor
 */
var MemoryStorage = /** @class */ (function () {
    function MemoryStorage() {
        this.cache_ = {};
        this.isInMemoryStorage = true;
    }
    MemoryStorage.prototype.set = function (key, value) {
        if (value == null) {
            delete this.cache_[key];
        }
        else {
            this.cache_[key] = value;
        }
    };
    MemoryStorage.prototype.get = function (key) {
        if (util.contains(this.cache_, key)) {
            return this.cache_[key];
        }
        return null;
    };
    MemoryStorage.prototype.remove = function (key) {
        delete this.cache_[key];
    };
    return MemoryStorage;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Helper to create a DOMStorageWrapper or else fall back to MemoryStorage.
 * TODO: Once MemoryStorage and DOMStorageWrapper have a shared interface this method annotation should change
 * to reflect this type
 *
 * @param {string} domStorageName Name of the underlying storage object
 *   (e.g. 'localStorage' or 'sessionStorage').
 * @return {?} Turning off type information until a common interface is defined.
 */
var createStoragefor = function (domStorageName) {
    try {
        // NOTE: just accessing "localStorage" or "window['localStorage']" may throw a security exception,
        // so it must be inside the try/catch.
        if (typeof window !== 'undefined' &&
            typeof window[domStorageName] !== 'undefined') {
            // Need to test cache. Just because it's here doesn't mean it works
            var domStorage = window[domStorageName];
            domStorage.setItem('firebase:sentinel', 'cache');
            domStorage.removeItem('firebase:sentinel');
            return new DOMStorageWrapper(domStorage);
        }
    }
    catch (e) { }
    // Failed to create wrapper.  Just return in-memory storage.
    // TODO: log?
    return new MemoryStorage();
};
/** A storage object that lasts across sessions */
var PersistentStorage = createStoragefor('localStorage');
/** A storage object that only lasts one session */
var SessionStorage = createStoragefor('sessionStorage');

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var logClient = new logger$1.Logger('@firebase/database');
/**
 * Returns a locally-unique ID (generated by just incrementing up from 0 each time its called).
 * @type {function(): number} Generated ID.
 */
var LUIDGenerator = (function () {
    var id = 1;
    return function () {
        return id++;
    };
})();
/**
 * Sha1 hash of the input string
 * @param {!string} str The string to hash
 * @return {!string} The resulting hash
 */
var sha1 = function (str) {
    var utf8Bytes = util.stringToByteArray(str);
    var sha1 = new util.Sha1();
    sha1.update(utf8Bytes);
    var sha1Bytes = sha1.digest();
    return util.base64.encodeByteArray(sha1Bytes);
};
/**
 * @param {...*} var_args
 * @return {string}
 * @private
 */
var buildLogMessage_ = function () {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    var message = '';
    for (var i = 0; i < var_args.length; i++) {
        if (Array.isArray(var_args[i]) ||
            (var_args[i] &&
                typeof var_args[i] === 'object' &&
                typeof var_args[i].length === 'number')) {
            message += buildLogMessage_.apply(null, var_args[i]);
        }
        else if (typeof var_args[i] === 'object') {
            message += util.stringify(var_args[i]);
        }
        else {
            message += var_args[i];
        }
        message += ' ';
    }
    return message;
};
/**
 * Use this for all debug messages in Firebase.
 * @type {?function(string)}
 */
var logger = null;
/**
 * Flag to check for log availability on first log message
 * @type {boolean}
 * @private
 */
var firstLog_ = true;
/**
 * The implementation of Firebase.enableLogging (defined here to break dependencies)
 * @param {boolean|?function(string)} logger_ A flag to turn on logging, or a custom logger
 * @param {boolean=} persistent Whether or not to persist logging settings across refreshes
 */
var enableLogging = function (logger_, persistent) {
    util.assert(!persistent || (logger_ === true || logger_ === false), "Can't turn on custom loggers persistently.");
    if (logger_ === true) {
        logClient.logLevel = logger$1.LogLevel.VERBOSE;
        logger = logClient.log.bind(logClient);
        if (persistent)
            SessionStorage.set('logging_enabled', true);
    }
    else if (typeof logger_ === 'function') {
        logger = logger_;
    }
    else {
        logger = null;
        SessionStorage.remove('logging_enabled');
    }
};
/**
 *
 * @param {...(string|Arguments)} var_args
 */
var log = function () {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    if (firstLog_ === true) {
        firstLog_ = false;
        if (logger === null && SessionStorage.get('logging_enabled') === true)
            enableLogging(true);
    }
    if (logger) {
        var message = buildLogMessage_.apply(null, var_args);
        logger(message);
    }
};
/**
 * @param {!string} prefix
 * @return {function(...[*])}
 */
var logWrapper = function (prefix) {
    return function () {
        var var_args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            var_args[_i] = arguments[_i];
        }
        log.apply(void 0, tslib.__spread([prefix], var_args));
    };
};
/**
 * @param {...string} var_args
 */
var error = function () {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    var message = 'FIREBASE INTERNAL ERROR: ' + buildLogMessage_.apply(void 0, tslib.__spread(var_args));
    logClient.error(message);
};
/**
 * @param {...string} var_args
 */
var fatal = function () {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    var message = "FIREBASE FATAL ERROR: " + buildLogMessage_.apply(void 0, tslib.__spread(var_args));
    logClient.error(message);
    throw new Error(message);
};
/**
 * @param {...*} var_args
 */
var warn = function () {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    var message = 'FIREBASE WARNING: ' + buildLogMessage_.apply(void 0, tslib.__spread(var_args));
    logClient.warn(message);
};
/**
 * Logs a warning if the containing page uses https. Called when a call to new Firebase
 * does not use https.
 */
var warnIfPageIsSecure = function () {
    // Be very careful accessing browser globals. Who knows what may or may not exist.
    if (typeof window !== 'undefined' &&
        window.location &&
        window.location.protocol &&
        window.location.protocol.indexOf('https:') !== -1) {
        warn('Insecure Firebase access from a secure page. ' +
            'Please use https in calls to new Firebase().');
    }
};
/**
 * Returns true if data is NaN, or +/- Infinity.
 * @param {*} data
 * @return {boolean}
 */
var isInvalidJSONNumber = function (data) {
    return (typeof data === 'number' &&
        (data != data || // NaN
            data == Number.POSITIVE_INFINITY ||
            data == Number.NEGATIVE_INFINITY));
};
/**
 * @param {function()} fn
 */
var executeWhenDOMReady = function (fn) {
    if (util.isNodeSdk() || document.readyState === 'complete') {
        fn();
    }
    else {
        // Modeled after jQuery. Try DOMContentLoaded and onreadystatechange (which
        // fire before onload), but fall back to onload.
        var called_1 = false;
        var wrappedFn_1 = function () {
            if (!document.body) {
                setTimeout(wrappedFn_1, Math.floor(10));
                return;
            }
            if (!called_1) {
                called_1 = true;
                fn();
            }
        };
        if (document.addEventListener) {
            document.addEventListener('DOMContentLoaded', wrappedFn_1, false);
            // fallback to onload.
            window.addEventListener('load', wrappedFn_1, false);
        }
        else if (document.attachEvent) {
            // IE.
            document.attachEvent('onreadystatechange', function () {
                if (document.readyState === 'complete')
                    wrappedFn_1();
            });
            // fallback to onload.
            window.attachEvent('onload', wrappedFn_1);
            // jQuery has an extra hack for IE that we could employ (based on
            // http://javascript.nwbox.com/IEContentLoaded/) But it looks really old.
            // I'm hoping we don't need it.
        }
    }
};
/**
 * Minimum key name. Invalid for actual data, used as a marker to sort before any valid names
 * @type {!string}
 */
var MIN_NAME = '[MIN_NAME]';
/**
 * Maximum key name. Invalid for actual data, used as a marker to sort above any valid names
 * @type {!string}
 */
var MAX_NAME = '[MAX_NAME]';
/**
 * Compares valid Firebase key names, plus min and max name
 * @param {!string} a
 * @param {!string} b
 * @return {!number}
 */
var nameCompare = function (a, b) {
    if (a === b) {
        return 0;
    }
    else if (a === MIN_NAME || b === MAX_NAME) {
        return -1;
    }
    else if (b === MIN_NAME || a === MAX_NAME) {
        return 1;
    }
    else {
        var aAsInt = tryParseInt(a), bAsInt = tryParseInt(b);
        if (aAsInt !== null) {
            if (bAsInt !== null) {
                return aAsInt - bAsInt == 0 ? a.length - b.length : aAsInt - bAsInt;
            }
            else {
                return -1;
            }
        }
        else if (bAsInt !== null) {
            return 1;
        }
        else {
            return a < b ? -1 : 1;
        }
    }
};
/**
 * @param {!string} a
 * @param {!string} b
 * @return {!number} comparison result.
 */
var stringCompare = function (a, b) {
    if (a === b) {
        return 0;
    }
    else if (a < b) {
        return -1;
    }
    else {
        return 1;
    }
};
/**
 * @param {string} key
 * @param {Object} obj
 * @return {*}
 */
var requireKey = function (key, obj) {
    if (obj && key in obj) {
        return obj[key];
    }
    else {
        throw new Error('Missing required key (' + key + ') in object: ' + util.stringify(obj));
    }
};
/**
 * @param {*} obj
 * @return {string}
 */
var ObjectToUniqueKey = function (obj) {
    if (typeof obj !== 'object' || obj === null)
        return util.stringify(obj);
    var keys = [];
    for (var k in obj) {
        keys.push(k);
    }
    // Export as json, but with the keys sorted.
    keys.sort();
    var key = '{';
    for (var i = 0; i < keys.length; i++) {
        if (i !== 0)
            key += ',';
        key += util.stringify(keys[i]);
        key += ':';
        key += ObjectToUniqueKey(obj[keys[i]]);
    }
    key += '}';
    return key;
};
/**
 * Splits a string into a number of smaller segments of maximum size
 * @param {!string} str The string
 * @param {!number} segsize The maximum number of chars in the string.
 * @return {Array.<string>} The string, split into appropriately-sized chunks
 */
var splitStringBySize = function (str, segsize) {
    var len = str.length;
    if (len <= segsize) {
        return [str];
    }
    var dataSegs = [];
    for (var c = 0; c < len; c += segsize) {
        if (c + segsize > len) {
            dataSegs.push(str.substring(c, len));
        }
        else {
            dataSegs.push(str.substring(c, c + segsize));
        }
    }
    return dataSegs;
};
/**
 * Apply a function to each (key, value) pair in an object or
 * apply a function to each (index, value) pair in an array
 * @param obj The object or array to iterate over
 * @param fn The function to apply
 */
function each(obj, fn) {
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            fn(key, obj[key]);
        }
    }
}
/**
 * Borrowed from http://hg.secondlife.com/llsd/src/tip/js/typedarray.js (MIT License)
 * I made one modification at the end and removed the NaN / Infinity
 * handling (since it seemed broken [caused an overflow] and we don't need it).  See MJL comments.
 * @param {!number} v A double
 * @return {string}
 */
var doubleToIEEE754String = function (v) {
    util.assert(!isInvalidJSONNumber(v), 'Invalid JSON number'); // MJL
    var ebits = 11, fbits = 52;
    var bias = (1 << (ebits - 1)) - 1, s, e, f, ln, i, bits, str;
    // Compute sign, exponent, fraction
    // Skip NaN / Infinity handling --MJL.
    if (v === 0) {
        e = 0;
        f = 0;
        s = 1 / v === -Infinity ? 1 : 0;
    }
    else {
        s = v < 0;
        v = Math.abs(v);
        if (v >= Math.pow(2, 1 - bias)) {
            // Normalized
            ln = Math.min(Math.floor(Math.log(v) / Math.LN2), bias);
            e = ln + bias;
            f = Math.round(v * Math.pow(2, fbits - ln) - Math.pow(2, fbits));
        }
        else {
            // Denormalized
            e = 0;
            f = Math.round(v / Math.pow(2, 1 - bias - fbits));
        }
    }
    // Pack sign, exponent, fraction
    bits = [];
    for (i = fbits; i; i -= 1) {
        bits.push(f % 2 ? 1 : 0);
        f = Math.floor(f / 2);
    }
    for (i = ebits; i; i -= 1) {
        bits.push(e % 2 ? 1 : 0);
        e = Math.floor(e / 2);
    }
    bits.push(s ? 1 : 0);
    bits.reverse();
    str = bits.join('');
    // Return the data as a hex string. --MJL
    var hexByteString = '';
    for (i = 0; i < 64; i += 8) {
        var hexByte = parseInt(str.substr(i, 8), 2).toString(16);
        if (hexByte.length === 1)
            hexByte = '0' + hexByte;
        hexByteString = hexByteString + hexByte;
    }
    return hexByteString.toLowerCase();
};
/**
 * Used to detect if we're in a Chrome content script (which executes in an
 * isolated environment where long-polling doesn't work).
 * @return {boolean}
 */
var isChromeExtensionContentScript = function () {
    return !!(typeof window === 'object' &&
        window['chrome'] &&
        window['chrome']['extension'] &&
        !/^chrome/.test(window.location.href));
};
/**
 * Used to detect if we're in a Windows 8 Store app.
 * @return {boolean}
 */
var isWindowsStoreApp = function () {
    // Check for the presence of a couple WinRT globals
    return typeof Windows === 'object' && typeof Windows.UI === 'object';
};
/**
 * Converts a server error code to a Javascript Error
 * @param {!string} code
 * @param {!Query} query
 * @return {Error}
 */
var errorForServerCode = function (code, query) {
    var reason = 'Unknown Error';
    if (code === 'too_big') {
        reason =
            'The data requested exceeds the maximum size ' +
                'that can be accessed with a single request.';
    }
    else if (code == 'permission_denied') {
        reason = "Client doesn't have permission to access the desired data.";
    }
    else if (code == 'unavailable') {
        reason = 'The service is unavailable';
    }
    var error = new Error(code + ' at ' + query.path.toString() + ': ' + reason);
    error.code = code.toUpperCase();
    return error;
};
/**
 * Used to test for integer-looking strings
 * @type {RegExp}
 * @private
 */
var INTEGER_REGEXP_ = new RegExp('^-?(0*)\\d{1,10}$');
/**
 * If the string contains a 32-bit integer, return it.  Else return null.
 * @param {!string} str
 * @return {?number}
 */
var tryParseInt = function (str) {
    if (INTEGER_REGEXP_.test(str)) {
        var intVal = Number(str);
        if (intVal >= -2147483648 && intVal <= 2147483647) {
            return intVal;
        }
    }
    return null;
};
/**
 * Helper to run some code but catch any exceptions and re-throw them later.
 * Useful for preventing user callbacks from breaking internal code.
 *
 * Re-throwing the exception from a setTimeout is a little evil, but it's very
 * convenient (we don't have to try to figure out when is a safe point to
 * re-throw it), and the behavior seems reasonable:
 *
 * * If you aren't pausing on exceptions, you get an error in the console with
 *   the correct stack trace.
 * * If you're pausing on all exceptions, the debugger will pause on your
 *   exception and then again when we rethrow it.
 * * If you're only pausing on uncaught exceptions, the debugger will only pause
 *   on us re-throwing it.
 *
 * @param {!function()} fn The code to guard.
 */
var exceptionGuard = function (fn) {
    try {
        fn();
    }
    catch (e) {
        // Re-throw exception when it's safe.
        setTimeout(function () {
            // It used to be that "throw e" would result in a good console error with
            // relevant context, but as of Chrome 39, you just get the firebase.js
            // file/line number where we re-throw it, which is useless. So we log
            // e.stack explicitly.
            var stack = e.stack || '';
            warn('Exception was thrown by user callback.', stack);
            throw e;
        }, Math.floor(0));
    }
};
/**
 * @return {boolean} true if we think we're currently being crawled.
 */
var beingCrawled = function () {
    var userAgent = (typeof window === 'object' &&
        window['navigator'] &&
        window['navigator']['userAgent']) ||
        '';
    // For now we whitelist the most popular crawlers.  We should refine this to be the set of crawlers we
    // believe to support JavaScript/AJAX rendering.
    // NOTE: Google Webmaster Tools doesn't really belong, but their "This is how a visitor to your website
    // would have seen the page" is flaky if we don't treat it as a crawler.
    return (userAgent.search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i) >= 0);
};
/**
 * Same as setTimeout() except on Node.JS it will /not/ prevent the process from exiting.
 *
 * It is removed with clearTimeout() as normal.
 *
 * @param {Function} fn Function to run.
 * @param {number} time Milliseconds to wait before running.
 * @return {number|Object} The setTimeout() return value.
 */
var setTimeoutNonBlocking = function (fn, time) {
    var timeout = setTimeout(fn, time);
    if (typeof timeout === 'object' && timeout['unref']) {
        timeout['unref']();
    }
    return timeout;
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An immutable object representing a parsed path.  It's immutable so that you
 * can pass them around to other functions without worrying about them changing
 * it.
 */
var Path = /** @class */ (function () {
    /**
     * @param {string|Array.<string>} pathOrString Path string to parse,
     *      or another path, or the raw tokens array
     * @param {number=} pieceNum
     */
    function Path(pathOrString, pieceNum) {
        if (pieceNum === void 0) {
            this.pieces_ = pathOrString.split('/');
            // Remove empty pieces.
            var copyTo = 0;
            for (var i = 0; i < this.pieces_.length; i++) {
                if (this.pieces_[i].length > 0) {
                    this.pieces_[copyTo] = this.pieces_[i];
                    copyTo++;
                }
            }
            this.pieces_.length = copyTo;
            this.pieceNum_ = 0;
        }
        else {
            this.pieces_ = pathOrString;
            this.pieceNum_ = pieceNum;
        }
    }
    Object.defineProperty(Path, "Empty", {
        /**
         * Singleton to represent an empty path
         *
         * @const
         */
        get: function () {
            return new Path('');
        },
        enumerable: true,
        configurable: true
    });
    Path.prototype.getFront = function () {
        if (this.pieceNum_ >= this.pieces_.length)
            return null;
        return this.pieces_[this.pieceNum_];
    };
    /**
     * @return {number} The number of segments in this path
     */
    Path.prototype.getLength = function () {
        return this.pieces_.length - this.pieceNum_;
    };
    /**
     * @return {!Path}
     */
    Path.prototype.popFront = function () {
        var pieceNum = this.pieceNum_;
        if (pieceNum < this.pieces_.length) {
            pieceNum++;
        }
        return new Path(this.pieces_, pieceNum);
    };
    /**
     * @return {?string}
     */
    Path.prototype.getBack = function () {
        if (this.pieceNum_ < this.pieces_.length)
            return this.pieces_[this.pieces_.length - 1];
        return null;
    };
    Path.prototype.toString = function () {
        var pathString = '';
        for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
            if (this.pieces_[i] !== '')
                pathString += '/' + this.pieces_[i];
        }
        return pathString || '/';
    };
    Path.prototype.toUrlEncodedString = function () {
        var pathString = '';
        for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
            if (this.pieces_[i] !== '')
                pathString += '/' + encodeURIComponent(String(this.pieces_[i]));
        }
        return pathString || '/';
    };
    /**
     * Shallow copy of the parts of the path.
     *
     * @param {number=} begin
     * @return {!Array<string>}
     */
    Path.prototype.slice = function (begin) {
        if (begin === void 0) { begin = 0; }
        return this.pieces_.slice(this.pieceNum_ + begin);
    };
    /**
     * @return {?Path}
     */
    Path.prototype.parent = function () {
        if (this.pieceNum_ >= this.pieces_.length)
            return null;
        var pieces = [];
        for (var i = this.pieceNum_; i < this.pieces_.length - 1; i++)
            pieces.push(this.pieces_[i]);
        return new Path(pieces, 0);
    };
    /**
     * @param {string|!Path} childPathObj
     * @return {!Path}
     */
    Path.prototype.child = function (childPathObj) {
        var pieces = [];
        for (var i = this.pieceNum_; i < this.pieces_.length; i++)
            pieces.push(this.pieces_[i]);
        if (childPathObj instanceof Path) {
            for (var i = childPathObj.pieceNum_; i < childPathObj.pieces_.length; i++) {
                pieces.push(childPathObj.pieces_[i]);
            }
        }
        else {
            var childPieces = childPathObj.split('/');
            for (var i = 0; i < childPieces.length; i++) {
                if (childPieces[i].length > 0)
                    pieces.push(childPieces[i]);
            }
        }
        return new Path(pieces, 0);
    };
    /**
     * @return {boolean} True if there are no segments in this path
     */
    Path.prototype.isEmpty = function () {
        return this.pieceNum_ >= this.pieces_.length;
    };
    /**
     * @param {!Path} outerPath
     * @param {!Path} innerPath
     * @return {!Path} The path from outerPath to innerPath
     */
    Path.relativePath = function (outerPath, innerPath) {
        var outer = outerPath.getFront(), inner = innerPath.getFront();
        if (outer === null) {
            return innerPath;
        }
        else if (outer === inner) {
            return Path.relativePath(outerPath.popFront(), innerPath.popFront());
        }
        else {
            throw new Error('INTERNAL ERROR: innerPath (' +
                innerPath +
                ') is not within ' +
                'outerPath (' +
                outerPath +
                ')');
        }
    };
    /**
     * @param {!Path} left
     * @param {!Path} right
     * @return {number} -1, 0, 1 if left is less, equal, or greater than the right.
     */
    Path.comparePaths = function (left, right) {
        var leftKeys = left.slice();
        var rightKeys = right.slice();
        for (var i = 0; i < leftKeys.length && i < rightKeys.length; i++) {
            var cmp = nameCompare(leftKeys[i], rightKeys[i]);
            if (cmp !== 0)
                return cmp;
        }
        if (leftKeys.length === rightKeys.length)
            return 0;
        return leftKeys.length < rightKeys.length ? -1 : 1;
    };
    /**
     *
     * @param {Path} other
     * @return {boolean} true if paths are the same.
     */
    Path.prototype.equals = function (other) {
        if (this.getLength() !== other.getLength()) {
            return false;
        }
        for (var i = this.pieceNum_, j = other.pieceNum_; i <= this.pieces_.length; i++, j++) {
            if (this.pieces_[i] !== other.pieces_[j]) {
                return false;
            }
        }
        return true;
    };
    /**
     *
     * @param {!Path} other
     * @return {boolean} True if this path is a parent (or the same as) other
     */
    Path.prototype.contains = function (other) {
        var i = this.pieceNum_;
        var j = other.pieceNum_;
        if (this.getLength() > other.getLength()) {
            return false;
        }
        while (i < this.pieces_.length) {
            if (this.pieces_[i] !== other.pieces_[j]) {
                return false;
            }
            ++i;
            ++j;
        }
        return true;
    };
    return Path;
}()); // end Path
/**
 * Dynamic (mutable) path used to count path lengths.
 *
 * This class is used to efficiently check paths for valid
 * length (in UTF8 bytes) and depth (used in path validation).
 *
 * Throws Error exception if path is ever invalid.
 *
 * The definition of a path always begins with '/'.
 */
var ValidationPath = /** @class */ (function () {
    /**
     * @param {!Path} path Initial Path.
     * @param {string} errorPrefix_ Prefix for any error messages.
     */
    function ValidationPath(path, errorPrefix_) {
        this.errorPrefix_ = errorPrefix_;
        /** @type {!Array<string>} */
        this.parts_ = path.slice();
        /** @type {number} Initialize to number of '/' chars needed in path. */
        this.byteLength_ = Math.max(1, this.parts_.length);
        for (var i = 0; i < this.parts_.length; i++) {
            this.byteLength_ += util.stringLength(this.parts_[i]);
        }
        this.checkValid_();
    }
    Object.defineProperty(ValidationPath, "MAX_PATH_DEPTH", {
        /** @const {number} Maximum key depth. */
        get: function () {
            return 32;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ValidationPath, "MAX_PATH_LENGTH_BYTES", {
        /** @const {number} Maximum number of (UTF8) bytes in a Firebase path. */
        get: function () {
            return 768;
        },
        enumerable: true,
        configurable: true
    });
    /** @param {string} child */
    ValidationPath.prototype.push = function (child) {
        // Count the needed '/'
        if (this.parts_.length > 0) {
            this.byteLength_ += 1;
        }
        this.parts_.push(child);
        this.byteLength_ += util.stringLength(child);
        this.checkValid_();
    };
    ValidationPath.prototype.pop = function () {
        var last = this.parts_.pop();
        this.byteLength_ -= util.stringLength(last);
        // Un-count the previous '/'
        if (this.parts_.length > 0) {
            this.byteLength_ -= 1;
        }
    };
    ValidationPath.prototype.checkValid_ = function () {
        if (this.byteLength_ > ValidationPath.MAX_PATH_LENGTH_BYTES) {
            throw new Error(this.errorPrefix_ +
                'has a key path longer than ' +
                ValidationPath.MAX_PATH_LENGTH_BYTES +
                ' bytes (' +
                this.byteLength_ +
                ').');
        }
        if (this.parts_.length > ValidationPath.MAX_PATH_DEPTH) {
            throw new Error(this.errorPrefix_ +
                'path specified exceeds the maximum depth that can be written (' +
                ValidationPath.MAX_PATH_DEPTH +
                ') or object contains a cycle ' +
                this.toErrorString());
        }
    };
    /**
     * String for use in error messages - uses '.' notation for path.
     *
     * @return {string}
     */
    ValidationPath.prototype.toErrorString = function () {
        if (this.parts_.length == 0) {
            return '';
        }
        return "in property '" + this.parts_.join('.') + "'";
    };
    return ValidationPath;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var PROTOCOL_VERSION = '5';
var VERSION_PARAM = 'v';
var TRANSPORT_SESSION_PARAM = 's';
var REFERER_PARAM = 'r';
var FORGE_REF = 'f';
var FORGE_DOMAIN = 'firebaseio.com';
var LAST_SESSION_PARAM = 'ls';
var WEBSOCKET = 'websocket';
var LONG_POLLING = 'long_polling';

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A class that holds metadata about a Repo object
 *
 * @constructor
 */
var RepoInfo = /** @class */ (function () {
    /**
     * @param {string} host Hostname portion of the url for the repo
     * @param {boolean} secure Whether or not this repo is accessed over ssl
     * @param {string} namespace The namespace represented by the repo
     * @param {boolean} webSocketOnly Whether to prefer websockets over all other transports (used by Nest).
     * @param {string=} persistenceKey Override the default session persistence storage key
     */
    function RepoInfo(host, secure, namespace, webSocketOnly, persistenceKey, includeNamespaceInQueryParams) {
        if (persistenceKey === void 0) { persistenceKey = ''; }
        if (includeNamespaceInQueryParams === void 0) { includeNamespaceInQueryParams = false; }
        this.secure = secure;
        this.namespace = namespace;
        this.webSocketOnly = webSocketOnly;
        this.persistenceKey = persistenceKey;
        this.includeNamespaceInQueryParams = includeNamespaceInQueryParams;
        this.host = host.toLowerCase();
        this.domain = this.host.substr(this.host.indexOf('.') + 1);
        this.internalHost = PersistentStorage.get('host:' + host) || this.host;
    }
    RepoInfo.prototype.needsQueryParam = function () {
        return (this.host !== this.internalHost ||
            this.isCustomHost() ||
            this.includeNamespaceInQueryParams);
    };
    RepoInfo.prototype.isCacheableHost = function () {
        return this.internalHost.substr(0, 2) === 's-';
    };
    RepoInfo.prototype.isDemoHost = function () {
        return this.domain === 'firebaseio-demo.com';
    };
    RepoInfo.prototype.isCustomHost = function () {
        return (this.domain !== 'firebaseio.com' && this.domain !== 'firebaseio-demo.com');
    };
    RepoInfo.prototype.updateHost = function (newHost) {
        if (newHost !== this.internalHost) {
            this.internalHost = newHost;
            if (this.isCacheableHost()) {
                PersistentStorage.set('host:' + this.host, this.internalHost);
            }
        }
    };
    /**
     * Returns the websocket URL for this repo
     * @param {string} type of connection
     * @param {Object} params list
     * @return {string} The URL for this repo
     */
    RepoInfo.prototype.connectionURL = function (type, params) {
        util.assert(typeof type === 'string', 'typeof type must == string');
        util.assert(typeof params === 'object', 'typeof params must == object');
        var connURL;
        if (type === WEBSOCKET) {
            connURL =
                (this.secure ? 'wss://' : 'ws://') + this.internalHost + '/.ws?';
        }
        else if (type === LONG_POLLING) {
            connURL =
                (this.secure ? 'https://' : 'http://') + this.internalHost + '/.lp?';
        }
        else {
            throw new Error('Unknown connection type: ' + type);
        }
        if (this.needsQueryParam()) {
            params['ns'] = this.namespace;
        }
        var pairs = [];
        each(params, function (key, value) {
            pairs.push(key + '=' + value);
        });
        return connURL + pairs.join('&');
    };
    /** @return {string} */
    RepoInfo.prototype.toString = function () {
        var str = this.toURLString();
        if (this.persistenceKey) {
            str += '<' + this.persistenceKey + '>';
        }
        return str;
    };
    /** @return {string} */
    RepoInfo.prototype.toURLString = function () {
        return (this.secure ? 'https://' : 'http://') + this.host;
    };
    return RepoInfo;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param {!string} pathString
 * @return {string}
 */
function decodePath(pathString) {
    var pathStringDecoded = '';
    var pieces = pathString.split('/');
    for (var i = 0; i < pieces.length; i++) {
        if (pieces[i].length > 0) {
            var piece = pieces[i];
            try {
                piece = decodeURIComponent(piece.replace(/\+/g, ' '));
            }
            catch (e) { }
            pathStringDecoded += '/' + piece;
        }
    }
    return pathStringDecoded;
}
/**
 * @param {!string} queryString
 * @return {!{[key:string]:string}} key value hash
 */
function decodeQuery(queryString) {
    var e_1, _a;
    var results = {};
    if (queryString.charAt(0) === '?') {
        queryString = queryString.substring(1);
    }
    try {
        for (var _b = tslib.__values(queryString.split('&')), _c = _b.next(); !_c.done; _c = _b.next()) {
            var segment = _c.value;
            if (segment.length === 0) {
                continue;
            }
            var kv = segment.split('=');
            if (kv.length === 2) {
                results[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1]);
            }
            else {
                warn("Invalid query segment '" + segment + "' in query '" + queryString + "'");
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return results;
}
/**
 *
 * @param {!string} dataURL
 * @return {{repoInfo: !RepoInfo, path: !Path}}
 */
var parseRepoInfo = function (dataURL) {
    var parsedUrl = parseDatabaseURL(dataURL), namespace = parsedUrl.namespace;
    if (parsedUrl.domain === 'firebase') {
        fatal(parsedUrl.host +
            ' is no longer supported. ' +
            'Please use <YOUR FIREBASE>.firebaseio.com instead');
    }
    // Catch common error of uninitialized namespace value.
    if ((!namespace || namespace == 'undefined') &&
        parsedUrl.domain !== 'localhost') {
        fatal('Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com');
    }
    if (!parsedUrl.secure) {
        warnIfPageIsSecure();
    }
    var webSocketOnly = parsedUrl.scheme === 'ws' || parsedUrl.scheme === 'wss';
    return {
        repoInfo: new RepoInfo(parsedUrl.host, parsedUrl.secure, namespace, webSocketOnly, 
        /*persistenceKey=*/ '', 
        /*includeNamespaceInQueryParams=*/ namespace != parsedUrl.subdomain),
        path: new Path(parsedUrl.pathString)
    };
};
/**
 *
 * @param {!string} dataURL
 * @return {{host: string, port: number, domain: string, subdomain: string, secure: boolean, scheme: string, pathString: string, namespace: string}}
 */
var parseDatabaseURL = function (dataURL) {
    // Default to empty strings in the event of a malformed string.
    var host = '', domain = '', subdomain = '', pathString = '', namespace = '';
    // Always default to SSL, unless otherwise specified.
    var secure = true, scheme = 'https', port = 443;
    // Don't do any validation here. The caller is responsible for validating the result of parsing.
    if (typeof dataURL === 'string') {
        // Parse scheme.
        var colonInd = dataURL.indexOf('//');
        if (colonInd >= 0) {
            scheme = dataURL.substring(0, colonInd - 1);
            dataURL = dataURL.substring(colonInd + 2);
        }
        // Parse host, path, and query string.
        var slashInd = dataURL.indexOf('/');
        if (slashInd === -1) {
            slashInd = dataURL.length;
        }
        var questionMarkInd = dataURL.indexOf('?');
        if (questionMarkInd === -1) {
            questionMarkInd = dataURL.length;
        }
        host = dataURL.substring(0, Math.min(slashInd, questionMarkInd));
        if (slashInd < questionMarkInd) {
            // For pathString, questionMarkInd will always come after slashInd
            pathString = decodePath(dataURL.substring(slashInd, questionMarkInd));
        }
        var queryParams = decodeQuery(dataURL.substring(Math.min(dataURL.length, questionMarkInd)));
        // If we have a port, use scheme for determining if it's secure.
        colonInd = host.indexOf(':');
        if (colonInd >= 0) {
            secure = scheme === 'https' || scheme === 'wss';
            port = parseInt(host.substring(colonInd + 1), 10);
        }
        else {
            colonInd = dataURL.length;
        }
        var parts = host.split('.');
        if (parts.length === 3) {
            // Normalize namespaces to lowercase to share storage / connection.
            domain = parts[1];
            subdomain = parts[0].toLowerCase();
            // We interpret the subdomain of a 3 component URL as the namespace name.
            namespace = subdomain;
        }
        else if (parts.length === 2) {
            domain = parts[0];
        }
        else if (parts[0].slice(0, colonInd).toLowerCase() === 'localhost') {
            domain = 'localhost';
        }
        // Always treat the value of the `ns` as the namespace name if it is present.
        if ('ns' in queryParams) {
            namespace = queryParams['ns'];
        }
    }
    return {
        host: host,
        port: port,
        domain: domain,
        subdomain: subdomain,
        secure: secure,
        scheme: scheme,
        pathString: pathString,
        namespace: namespace
    };
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * True for invalid Firebase keys
 * @type {RegExp}
 * @private
 */
var INVALID_KEY_REGEX_ = /[\[\].#$\/\u0000-\u001F\u007F]/;
/**
 * True for invalid Firebase paths.
 * Allows '/' in paths.
 * @type {RegExp}
 * @private
 */
var INVALID_PATH_REGEX_ = /[\[\].#$\u0000-\u001F\u007F]/;
/**
 * Maximum number of characters to allow in leaf value
 * @type {number}
 * @private
 */
var MAX_LEAF_SIZE_ = 10 * 1024 * 1024;
/**
 * @param {*} key
 * @return {boolean}
 */
var isValidKey = function (key) {
    return (typeof key === 'string' && key.length !== 0 && !INVALID_KEY_REGEX_.test(key));
};
/**
 * @param {string} pathString
 * @return {boolean}
 */
var isValidPathString = function (pathString) {
    return (typeof pathString === 'string' &&
        pathString.length !== 0 &&
        !INVALID_PATH_REGEX_.test(pathString));
};
/**
 * @param {string} pathString
 * @return {boolean}
 */
var isValidRootPathString = function (pathString) {
    if (pathString) {
        // Allow '/.info/' at the beginning.
        pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
    }
    return isValidPathString(pathString);
};
/**
 * @param {*} priority
 * @return {boolean}
 */
var isValidPriority = function (priority) {
    return (priority === null ||
        typeof priority === 'string' ||
        (typeof priority === 'number' && !isInvalidJSONNumber(priority)) ||
        (priority && typeof priority === 'object' && util.contains(priority, '.sv')));
};
/**
 * Pre-validate a datum passed as an argument to Firebase function.
 *
 * @param {string} fnName
 * @param {number} argumentNumber
 * @param {*} data
 * @param {!Path} path
 * @param {boolean} optional
 */
var validateFirebaseDataArg = function (fnName, argumentNumber, data, path, optional) {
    if (optional && data === undefined)
        return;
    validateFirebaseData(util.errorPrefix(fnName, argumentNumber, optional), data, path);
};
/**
 * Validate a data object client-side before sending to server.
 *
 * @param {string} errorPrefix
 * @param {*} data
 * @param {!Path|!ValidationPath} path_
 */
var validateFirebaseData = function (errorPrefix, data, path_) {
    var path = path_ instanceof Path ? new ValidationPath(path_, errorPrefix) : path_;
    if (data === undefined) {
        throw new Error(errorPrefix + 'contains undefined ' + path.toErrorString());
    }
    if (typeof data === 'function') {
        throw new Error(errorPrefix +
            'contains a function ' +
            path.toErrorString() +
            ' with contents = ' +
            data.toString());
    }
    if (isInvalidJSONNumber(data)) {
        throw new Error(errorPrefix + 'contains ' + data.toString() + ' ' + path.toErrorString());
    }
    // Check max leaf size, but try to avoid the utf8 conversion if we can.
    if (typeof data === 'string' &&
        data.length > MAX_LEAF_SIZE_ / 3 &&
        util.stringLength(data) > MAX_LEAF_SIZE_) {
        throw new Error(errorPrefix +
            'contains a string greater than ' +
            MAX_LEAF_SIZE_ +
            ' utf8 bytes ' +
            path.toErrorString() +
            " ('" +
            data.substring(0, 50) +
            "...')");
    }
    // TODO = Perf = Consider combining the recursive validation of keys into NodeFromJSON
    // to save extra walking of large objects.
    if (data && typeof data === 'object') {
        var hasDotValue_1 = false;
        var hasActualChild_1 = false;
        each(data, function (key, value) {
            if (key === '.value') {
                hasDotValue_1 = true;
            }
            else if (key !== '.priority' && key !== '.sv') {
                hasActualChild_1 = true;
                if (!isValidKey(key)) {
                    throw new Error(errorPrefix +
                        ' contains an invalid key (' +
                        key +
                        ') ' +
                        path.toErrorString() +
                        '.  Keys must be non-empty strings ' +
                        'and can\'t contain ".", "#", "$", "/", "[", or "]"');
                }
            }
            path.push(key);
            validateFirebaseData(errorPrefix, value, path);
            path.pop();
        });
        if (hasDotValue_1 && hasActualChild_1) {
            throw new Error(errorPrefix +
                ' contains ".value" child ' +
                path.toErrorString() +
                ' in addition to actual children.');
        }
    }
};
/**
 * Pre-validate paths passed in the firebase function.
 *
 * @param {string} errorPrefix
 * @param {Array<!Path>} mergePaths
 */
var validateFirebaseMergePaths = function (errorPrefix, mergePaths) {
    var i, curPath;
    for (i = 0; i < mergePaths.length; i++) {
        curPath = mergePaths[i];
        var keys = curPath.slice();
        for (var j = 0; j < keys.length; j++) {
            if (keys[j] === '.priority' && j === keys.length - 1) ;
            else if (!isValidKey(keys[j])) {
                throw new Error(errorPrefix +
                    'contains an invalid key (' +
                    keys[j] +
                    ') in path ' +
                    curPath.toString() +
                    '. Keys must be non-empty strings ' +
                    'and can\'t contain ".", "#", "$", "/", "[", or "]"');
            }
        }
    }
    // Check that update keys are not descendants of each other.
    // We rely on the property that sorting guarantees that ancestors come
    // right before descendants.
    mergePaths.sort(Path.comparePaths);
    var prevPath = null;
    for (i = 0; i < mergePaths.length; i++) {
        curPath = mergePaths[i];
        if (prevPath !== null && prevPath.contains(curPath)) {
            throw new Error(errorPrefix +
                'contains a path ' +
                prevPath.toString() +
                ' that is ancestor of another path ' +
                curPath.toString());
        }
        prevPath = curPath;
    }
};
/**
 * pre-validate an object passed as an argument to firebase function (
 * must be an object - e.g. for firebase.update()).
 *
 * @param {string} fnName
 * @param {number} argumentNumber
 * @param {*} data
 * @param {!Path} path
 * @param {boolean} optional
 */
var validateFirebaseMergeDataArg = function (fnName, argumentNumber, data, path, optional) {
    if (optional && data === undefined)
        return;
    var errorPrefix = util.errorPrefix(fnName, argumentNumber, optional);
    if (!(data && typeof data === 'object') || Array.isArray(data)) {
        throw new Error(errorPrefix + ' must be an object containing the children to replace.');
    }
    var mergePaths = [];
    each(data, function (key, value) {
        var curPath = new Path(key);
        validateFirebaseData(errorPrefix, value, path.child(curPath));
        if (curPath.getBack() === '.priority') {
            if (!isValidPriority(value)) {
                throw new Error(errorPrefix +
                    "contains an invalid value for '" +
                    curPath.toString() +
                    "', which must be a valid " +
                    'Firebase priority (a string, finite number, server value, or null).');
            }
        }
        mergePaths.push(curPath);
    });
    validateFirebaseMergePaths(errorPrefix, mergePaths);
};
var validatePriority = function (fnName, argumentNumber, priority, optional) {
    if (optional && priority === undefined)
        return;
    if (isInvalidJSONNumber(priority))
        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
            'is ' +
            priority.toString() +
            ', but must be a valid Firebase priority (a string, finite number, ' +
            'server value, or null).');
    // Special case to allow importing data with a .sv.
    if (!isValidPriority(priority))
        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid Firebase priority ' +
            '(a string, finite number, server value, or null).');
};
var validateEventType = function (fnName, argumentNumber, eventType, optional) {
    if (optional && eventType === undefined)
        return;
    switch (eventType) {
        case 'value':
        case 'child_added':
        case 'child_removed':
        case 'child_changed':
        case 'child_moved':
            break;
        default:
            throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
                'must be a valid event type = "value", "child_added", "child_removed", ' +
                '"child_changed", or "child_moved".');
    }
};
var validateKey = function (fnName, argumentNumber, key, optional) {
    if (optional && key === undefined)
        return;
    if (!isValidKey(key))
        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
            'was an invalid key = "' +
            key +
            '".  Firebase keys must be non-empty strings and ' +
            'can\'t contain ".", "#", "$", "/", "[", or "]").');
};
var validatePathString = function (fnName, argumentNumber, pathString, optional) {
    if (optional && pathString === undefined)
        return;
    if (!isValidPathString(pathString))
        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
            'was an invalid path = "' +
            pathString +
            '". Paths must be non-empty strings and ' +
            'can\'t contain ".", "#", "$", "[", or "]"');
};
var validateRootPathString = function (fnName, argumentNumber, pathString, optional) {
    if (pathString) {
        // Allow '/.info/' at the beginning.
        pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
    }
    validatePathString(fnName, argumentNumber, pathString, optional);
};
var validateWritablePath = function (fnName, path) {
    if (path.getFront() === '.info') {
        throw new Error(fnName + " failed = Can't modify data under /.info/");
    }
};
var validateUrl = function (fnName, argumentNumber, parsedUrl) {
    // TODO = Validate server better.
    var pathString = parsedUrl.path.toString();
    if (!(typeof parsedUrl.repoInfo.host === 'string') ||
        parsedUrl.repoInfo.host.length === 0 ||
        (!isValidKey(parsedUrl.repoInfo.namespace) &&
            parsedUrl.repoInfo.host.split(':')[0] !== 'localhost') ||
        (pathString.length !== 0 && !isValidRootPathString(pathString))) {
        throw new Error(util.errorPrefix(fnName, argumentNumber, false) +
            'must be a valid firebase URL and ' +
            'the path can\'t contain ".", "#", "$", "[", or "]".');
    }
};
var validateBoolean = function (fnName, argumentNumber, bool, optional) {
    if (optional && bool === undefined)
        return;
    if (typeof bool !== 'boolean')
        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) + 'must be a boolean.');
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @constructor
 */
var OnDisconnect = /** @class */ (function () {
    /**
     * @param {!Repo} repo_
     * @param {!Path} path_
     */
    function OnDisconnect(repo_, path_) {
        this.repo_ = repo_;
        this.path_ = path_;
    }
    /**
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.cancel = function (onComplete) {
        util.validateArgCount('OnDisconnect.cancel', 0, 1, arguments.length);
        util.validateCallback('OnDisconnect.cancel', 1, onComplete, true);
        var deferred = new util.Deferred();
        this.repo_.onDisconnectCancel(this.path_, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.remove = function (onComplete) {
        util.validateArgCount('OnDisconnect.remove', 0, 1, arguments.length);
        validateWritablePath('OnDisconnect.remove', this.path_);
        util.validateCallback('OnDisconnect.remove', 1, onComplete, true);
        var deferred = new util.Deferred();
        this.repo_.onDisconnectSet(this.path_, null, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*} value
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.set = function (value, onComplete) {
        util.validateArgCount('OnDisconnect.set', 1, 2, arguments.length);
        validateWritablePath('OnDisconnect.set', this.path_);
        validateFirebaseDataArg('OnDisconnect.set', 1, value, this.path_, false);
        util.validateCallback('OnDisconnect.set', 2, onComplete, true);
        var deferred = new util.Deferred();
        this.repo_.onDisconnectSet(this.path_, value, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*} value
     * @param {number|string|null} priority
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.setWithPriority = function (value, priority, onComplete) {
        util.validateArgCount('OnDisconnect.setWithPriority', 2, 3, arguments.length);
        validateWritablePath('OnDisconnect.setWithPriority', this.path_);
        validateFirebaseDataArg('OnDisconnect.setWithPriority', 1, value, this.path_, false);
        validatePriority('OnDisconnect.setWithPriority', 2, priority, false);
        util.validateCallback('OnDisconnect.setWithPriority', 3, onComplete, true);
        var deferred = new util.Deferred();
        this.repo_.onDisconnectSetWithPriority(this.path_, value, priority, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {!Object} objectToMerge
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.update = function (objectToMerge, onComplete) {
        util.validateArgCount('OnDisconnect.update', 1, 2, arguments.length);
        validateWritablePath('OnDisconnect.update', this.path_);
        if (Array.isArray(objectToMerge)) {
            var newObjectToMerge = {};
            for (var i = 0; i < objectToMerge.length; ++i) {
                newObjectToMerge['' + i] = objectToMerge[i];
            }
            objectToMerge = newObjectToMerge;
            warn('Passing an Array to firebase.database.onDisconnect().update() is deprecated. Use set() if you want to overwrite the ' +
                'existing data, or an Object with integer keys if you really do want to only update some of the children.');
        }
        validateFirebaseMergeDataArg('OnDisconnect.update', 1, objectToMerge, this.path_, false);
        util.validateCallback('OnDisconnect.update', 2, onComplete, true);
        var deferred = new util.Deferred();
        this.repo_.onDisconnectUpdate(this.path_, objectToMerge, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    return OnDisconnect;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var TransactionResult = /** @class */ (function () {
    /**
     * A type for the resolve value of Firebase.transaction.
     * @constructor
     * @dict
     * @param {boolean} committed
     * @param {DataSnapshot} snapshot
     */
    function TransactionResult(committed, snapshot) {
        this.committed = committed;
        this.snapshot = snapshot;
    }
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users
    TransactionResult.prototype.toJSON = function () {
        util.validateArgCount('TransactionResult.toJSON', 0, 1, arguments.length);
        return { committed: this.committed, snapshot: this.snapshot.toJSON() };
    };
    return TransactionResult;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Fancy ID generator that creates 20-character string identifiers with the
 * following properties:
 *
 * 1. They're based on timestamp so that they sort *after* any existing ids.
 * 2. They contain 72-bits of random data after the timestamp so that IDs won't
 *    collide with other clients' IDs.
 * 3. They sort *lexicographically* (so the timestamp is converted to characters
 *    that will sort properly).
 * 4. They're monotonically increasing. Even if you generate more than one in
 *    the same timestamp, the latter ones will sort after the former ones. We do
 *    this by using the previous random bits but "incrementing" them by 1 (only
 *    in the case of a timestamp collision).
 */
var nextPushId = (function () {
    // Modeled after base64 web-safe chars, but ordered by ASCII.
    var PUSH_CHARS = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz';
    // Timestamp of last push, used to prevent local collisions if you push twice
    // in one ms.
    var lastPushTime = 0;
    // We generate 72-bits of randomness which get turned into 12 characters and
    // appended to the timestamp to prevent collisions with other clients. We
    // store the last characters we generated because in the event of a collision,
    // we'll use those same characters except "incremented" by one.
    var lastRandChars = [];
    return function (now) {
        var duplicateTime = now === lastPushTime;
        lastPushTime = now;
        var i;
        var timeStampChars = new Array(8);
        for (i = 7; i >= 0; i--) {
            timeStampChars[i] = PUSH_CHARS.charAt(now % 64);
            // NOTE: Can't use << here because javascript will convert to int and lose
            // the upper bits.
            now = Math.floor(now / 64);
        }
        util.assert(now === 0, 'Cannot push at time == 0');
        var id = timeStampChars.join('');
        if (!duplicateTime) {
            for (i = 0; i < 12; i++) {
                lastRandChars[i] = Math.floor(Math.random() * 64);
            }
        }
        else {
            // If the timestamp hasn't changed since last push, use the same random
            // number, except incremented by 1.
            for (i = 11; i >= 0 && lastRandChars[i] === 63; i--) {
                lastRandChars[i] = 0;
            }
            lastRandChars[i]++;
        }
        for (i = 0; i < 12; i++) {
            id += PUSH_CHARS.charAt(lastRandChars[i]);
        }
        util.assert(id.length === 20, 'nextPushId: Length should be 20.');
        return id;
    };
})();

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 *
 * @param {!string} name
 * @param {!Node} node
 * @constructor
 * @struct
 */
var NamedNode = /** @class */ (function () {
    function NamedNode(name, node) {
        this.name = name;
        this.node = node;
    }
    /**
     *
     * @param {!string} name
     * @param {!Node} node
     * @return {NamedNode}
     */
    NamedNode.Wrap = function (name, node) {
        return new NamedNode(name, node);
    };
    return NamedNode;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 *
 * @constructor
 */
var Index = /** @class */ (function () {
    function Index() {
    }
    /**
     * @return {function(!NamedNode, !NamedNode):number} A standalone comparison function for
     * this index
     */
    Index.prototype.getCompare = function () {
        return this.compare.bind(this);
    };
    /**
     * Given a before and after value for a node, determine if the indexed value has changed. Even if they are different,
     * it's possible that the changes are isolated to parts of the snapshot that are not indexed.
     *
     * @param {!Node} oldNode
     * @param {!Node} newNode
     * @return {boolean} True if the portion of the snapshot being indexed changed between oldNode and newNode
     */
    Index.prototype.indexedValueChanged = function (oldNode, newNode) {
        var oldWrapped = new NamedNode(MIN_NAME, oldNode);
        var newWrapped = new NamedNode(MIN_NAME, newNode);
        return this.compare(oldWrapped, newWrapped) !== 0;
    };
    /**
     * @return {!NamedNode} a node wrapper that will sort equal to or less than
     * any other node wrapper, using this index
     */
    Index.prototype.minPost = function () {
        return NamedNode.MIN;
    };
    return Index;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __EMPTY_NODE;
var KeyIndex = /** @class */ (function (_super) {
    tslib.__extends(KeyIndex, _super);
    function KeyIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(KeyIndex, "__EMPTY_NODE", {
        get: function () {
            return __EMPTY_NODE;
        },
        set: function (val) {
            __EMPTY_NODE = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.compare = function (a, b) {
        return nameCompare(a.name, b.name);
    };
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.isDefinedOn = function (node) {
        // We could probably return true here (since every node has a key), but it's never called
        // so just leaving unimplemented for now.
        throw util.assertionError('KeyIndex.isDefinedOn not expected to be called.');
    };
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
        return false; // The key for a node never changes.
    };
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.minPost = function () {
        return NamedNode.MIN;
    };
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.maxPost = function () {
        // TODO: This should really be created once and cached in a static property, but
        // NamedNode isn't defined yet, so I can't use it in a static.  Bleh.
        return new NamedNode(MAX_NAME, __EMPTY_NODE);
    };
    /**
     * @param {*} indexValue
     * @param {string} name
     * @return {!NamedNode}
     */
    KeyIndex.prototype.makePost = function (indexValue, name) {
        util.assert(typeof indexValue === 'string', 'KeyIndex indexValue must always be a string.');
        // We just use empty node, but it'll never be compared, since our comparator only looks at name.
        return new NamedNode(indexValue, __EMPTY_NODE);
    };
    /**
     * @return {!string} String representation for inclusion in a query spec
     */
    KeyIndex.prototype.toString = function () {
        return '.key';
    };
    return KeyIndex;
}(Index));
var KEY_INDEX = new KeyIndex();

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var MAX_NODE;
function setMaxNode(val) {
    MAX_NODE = val;
}
/**
 * @param {(!string|!number)} priority
 * @return {!string}
 */
var priorityHashText = function (priority) {
    if (typeof priority === 'number')
        return 'number:' + doubleToIEEE754String(priority);
    else
        return 'string:' + priority;
};
/**
 * Validates that a priority snapshot Node is valid.
 *
 * @param {!Node} priorityNode
 */
var validatePriorityNode = function (priorityNode) {
    if (priorityNode.isLeafNode()) {
        var val = priorityNode.val();
        util.assert(typeof val === 'string' ||
            typeof val === 'number' ||
            (typeof val === 'object' &&
                util.contains(val, '.sv')), 'Priority must be a string or number.');
    }
    else {
        util.assert(priorityNode === MAX_NODE || priorityNode.isEmpty(), 'priority of unexpected type.');
    }
    // Don't call getPriority() on MAX_NODE to avoid hitting assertion.
    util.assert(priorityNode === MAX_NODE || priorityNode.getPriority().isEmpty(), "Priority nodes can't have a priority of their own.");
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __childrenNodeConstructor;
/**
 * LeafNode is a class for storing leaf nodes in a DataSnapshot.  It
 * implements Node and stores the value of the node (a string,
 * number, or boolean) accessible via getValue().
 */
var LeafNode = /** @class */ (function () {
    /**
     * @implements {Node}
     * @param {!(string|number|boolean|Object)} value_ The value to store in this leaf node.
     *                                         The object type is possible in the event of a deferred value
     * @param {!Node=} priorityNode_ The priority of this node.
     */
    function LeafNode(value_, priorityNode_) {
        if (priorityNode_ === void 0) { priorityNode_ = LeafNode.__childrenNodeConstructor.EMPTY_NODE; }
        this.value_ = value_;
        this.priorityNode_ = priorityNode_;
        this.lazyHash_ = null;
        util.assert(this.value_ !== undefined && this.value_ !== null, "LeafNode shouldn't be created with null/undefined value.");
        validatePriorityNode(this.priorityNode_);
    }
    Object.defineProperty(LeafNode, "__childrenNodeConstructor", {
        get: function () {
            return __childrenNodeConstructor;
        },
        set: function (val) {
            __childrenNodeConstructor = val;
        },
        enumerable: true,
        configurable: true
    });
    /** @inheritDoc */
    LeafNode.prototype.isLeafNode = function () {
        return true;
    };
    /** @inheritDoc */
    LeafNode.prototype.getPriority = function () {
        return this.priorityNode_;
    };
    /** @inheritDoc */
    LeafNode.prototype.updatePriority = function (newPriorityNode) {
        return new LeafNode(this.value_, newPriorityNode);
    };
    /** @inheritDoc */
    LeafNode.prototype.getImmediateChild = function (childName) {
        // Hack to treat priority as a regular child
        if (childName === '.priority') {
            return this.priorityNode_;
        }
        else {
            return LeafNode.__childrenNodeConstructor.EMPTY_NODE;
        }
    };
    /** @inheritDoc */
    LeafNode.prototype.getChild = function (path) {
        if (path.isEmpty()) {
            return this;
        }
        else if (path.getFront() === '.priority') {
            return this.priorityNode_;
        }
        else {
            return LeafNode.__childrenNodeConstructor.EMPTY_NODE;
        }
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.hasChild = function () {
        return false;
    };
    /** @inheritDoc */
    LeafNode.prototype.getPredecessorChildName = function (childName, childNode) {
        return null;
    };
    /** @inheritDoc */
    LeafNode.prototype.updateImmediateChild = function (childName, newChildNode) {
        if (childName === '.priority') {
            return this.updatePriority(newChildNode);
        }
        else if (newChildNode.isEmpty() && childName !== '.priority') {
            return this;
        }
        else {
            return LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateImmediateChild(childName, newChildNode).updatePriority(this.priorityNode_);
        }
    };
    /** @inheritDoc */
    LeafNode.prototype.updateChild = function (path, newChildNode) {
        var front = path.getFront();
        if (front === null) {
            return newChildNode;
        }
        else if (newChildNode.isEmpty() && front !== '.priority') {
            return this;
        }
        else {
            util.assert(front !== '.priority' || path.getLength() === 1, '.priority must be the last token in a path');
            return this.updateImmediateChild(front, LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateChild(path.popFront(), newChildNode));
        }
    };
    /** @inheritDoc */
    LeafNode.prototype.isEmpty = function () {
        return false;
    };
    /** @inheritDoc */
    LeafNode.prototype.numChildren = function () {
        return 0;
    };
    /** @inheritDoc */
    LeafNode.prototype.forEachChild = function (index, action) {
        return false;
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.val = function (exportFormat) {
        if (exportFormat && !this.getPriority().isEmpty())
            return {
                '.value': this.getValue(),
                '.priority': this.getPriority().val()
            };
        else
            return this.getValue();
    };
    /** @inheritDoc */
    LeafNode.prototype.hash = function () {
        if (this.lazyHash_ === null) {
            var toHash = '';
            if (!this.priorityNode_.isEmpty())
                toHash +=
                    'priority:' +
                        priorityHashText(this.priorityNode_.val()) +
                        ':';
            var type = typeof this.value_;
            toHash += type + ':';
            if (type === 'number') {
                toHash += doubleToIEEE754String(this.value_);
            }
            else {
                toHash += this.value_;
            }
            this.lazyHash_ = sha1(toHash);
        }
        return this.lazyHash_;
    };
    /**
     * Returns the value of the leaf node.
     * @return {Object|string|number|boolean} The value of the node.
     */
    LeafNode.prototype.getValue = function () {
        return this.value_;
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.compareTo = function (other) {
        if (other === LeafNode.__childrenNodeConstructor.EMPTY_NODE) {
            return 1;
        }
        else if (other instanceof LeafNode.__childrenNodeConstructor) {
            return -1;
        }
        else {
            util.assert(other.isLeafNode(), 'Unknown node type');
            return this.compareToLeafNode_(other);
        }
    };
    /**
     * Comparison specifically for two leaf nodes
     * @param {!LeafNode} otherLeaf
     * @return {!number}
     * @private
     */
    LeafNode.prototype.compareToLeafNode_ = function (otherLeaf) {
        var otherLeafType = typeof otherLeaf.value_;
        var thisLeafType = typeof this.value_;
        var otherIndex = LeafNode.VALUE_TYPE_ORDER.indexOf(otherLeafType);
        var thisIndex = LeafNode.VALUE_TYPE_ORDER.indexOf(thisLeafType);
        util.assert(otherIndex >= 0, 'Unknown leaf type: ' + otherLeafType);
        util.assert(thisIndex >= 0, 'Unknown leaf type: ' + thisLeafType);
        if (otherIndex === thisIndex) {
            // Same type, compare values
            if (thisLeafType === 'object') {
                // Deferred value nodes are all equal, but we should also never get to this point...
                return 0;
            }
            else {
                // Note that this works because true > false, all others are number or string comparisons
                if (this.value_ < otherLeaf.value_) {
                    return -1;
                }
                else if (this.value_ === otherLeaf.value_) {
                    return 0;
                }
                else {
                    return 1;
                }
            }
        }
        else {
            return thisIndex - otherIndex;
        }
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.withIndex = function () {
        return this;
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.isIndexed = function () {
        return true;
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.equals = function (other) {
        /**
         * @inheritDoc
         */
        if (other === this) {
            return true;
        }
        else if (other.isLeafNode()) {
            var otherLeaf = other;
            return (this.value_ === otherLeaf.value_ &&
                this.priorityNode_.equals(otherLeaf.priorityNode_));
        }
        else {
            return false;
        }
    };
    /**
     * The sort order for comparing leaf nodes of different types. If two leaf nodes have
     * the same type, the comparison falls back to their value
     * @type {Array.<!string>}
     * @const
     */
    LeafNode.VALUE_TYPE_ORDER = ['object', 'boolean', 'number', 'string'];
    return LeafNode;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var nodeFromJSON;
var MAX_NODE$1;
function setNodeFromJSON(val) {
    nodeFromJSON = val;
}
function setMaxNode$1(val) {
    MAX_NODE$1 = val;
}
/**
 * @constructor
 * @extends {Index}
 * @private
 */
var PriorityIndex = /** @class */ (function (_super) {
    tslib.__extends(PriorityIndex, _super);
    function PriorityIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.compare = function (a, b) {
        var aPriority = a.node.getPriority();
        var bPriority = b.node.getPriority();
        var indexCmp = aPriority.compareTo(bPriority);
        if (indexCmp === 0) {
            return nameCompare(a.name, b.name);
        }
        else {
            return indexCmp;
        }
    };
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.isDefinedOn = function (node) {
        return !node.getPriority().isEmpty();
    };
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
        return !oldNode.getPriority().equals(newNode.getPriority());
    };
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.minPost = function () {
        return NamedNode.MIN;
    };
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.maxPost = function () {
        return new NamedNode(MAX_NAME, new LeafNode('[PRIORITY-POST]', MAX_NODE$1));
    };
    /**
     * @param {*} indexValue
     * @param {string} name
     * @return {!NamedNode}
     */
    PriorityIndex.prototype.makePost = function (indexValue, name) {
        var priorityNode = nodeFromJSON(indexValue);
        return new NamedNode(name, new LeafNode('[PRIORITY-POST]', priorityNode));
    };
    /**
     * @return {!string} String representation for inclusion in a query spec
     */
    PriorityIndex.prototype.toString = function () {
        return '.priority';
    };
    return PriorityIndex;
}(Index));
var PRIORITY_INDEX = new PriorityIndex();

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An iterator over an LLRBNode.
 */
var SortedMapIterator = /** @class */ (function () {
    /**
     * @template K, V, T
     * @param {LLRBNode|LLRBEmptyNode} node Node to iterate.
     * @param {?K} startKey
     * @param {function(K, K): number} comparator
     * @param {boolean} isReverse_ Whether or not to iterate in reverse
     * @param {(function(K, V):T)=} resultGenerator_
     */
    function SortedMapIterator(node, startKey, comparator, isReverse_, resultGenerator_) {
        if (resultGenerator_ === void 0) { resultGenerator_ = null; }
        this.isReverse_ = isReverse_;
        this.resultGenerator_ = resultGenerator_;
        /** @private
         * @type {Array.<!LLRBNode>}
         */
        this.nodeStack_ = [];
        var cmp = 1;
        while (!node.isEmpty()) {
            node = node;
            cmp = startKey ? comparator(node.key, startKey) : 1;
            // flip the comparison if we're going in reverse
            if (isReverse_)
                cmp *= -1;
            if (cmp < 0) {
                // This node is less than our start key. ignore it
                if (this.isReverse_) {
                    node = node.left;
                }
                else {
                    node = node.right;
                }
            }
            else if (cmp === 0) {
                // This node is exactly equal to our start key. Push it on the stack, but stop iterating;
                this.nodeStack_.push(node);
                break;
            }
            else {
                // This node is greater than our start key, add it to the stack and move to the next one
                this.nodeStack_.push(node);
                if (this.isReverse_) {
                    node = node.right;
                }
                else {
                    node = node.left;
                }
            }
        }
    }
    SortedMapIterator.prototype.getNext = function () {
        if (this.nodeStack_.length === 0)
            return null;
        var node = this.nodeStack_.pop();
        var result;
        if (this.resultGenerator_)
            result = this.resultGenerator_(node.key, node.value);
        else
            result = { key: node.key, value: node.value };
        if (this.isReverse_) {
            node = node.left;
            while (!node.isEmpty()) {
                this.nodeStack_.push(node);
                node = node.right;
            }
        }
        else {
            node = node.right;
            while (!node.isEmpty()) {
                this.nodeStack_.push(node);
                node = node.left;
            }
        }
        return result;
    };
    SortedMapIterator.prototype.hasNext = function () {
        return this.nodeStack_.length > 0;
    };
    SortedMapIterator.prototype.peek = function () {
        if (this.nodeStack_.length === 0)
            return null;
        var node = this.nodeStack_[this.nodeStack_.length - 1];
        if (this.resultGenerator_) {
            return this.resultGenerator_(node.key, node.value);
        }
        else {
            return { key: node.key, value: node.value };
        }
    };
    return SortedMapIterator;
}());
/**
 * Represents a node in a Left-leaning Red-Black tree.
 */
var LLRBNode = /** @class */ (function () {
    /**
     * @template K, V
     * @param {!K} key Key associated with this node.
     * @param {!V} value Value associated with this node.
     * @param {?boolean} color Whether this node is red.
     * @param {?(LLRBNode|LLRBEmptyNode)=} left Left child.
     * @param {?(LLRBNode|LLRBEmptyNode)=} right Right child.
     */
    function LLRBNode(key, value, color, left, right) {
        this.key = key;
        this.value = value;
        this.color = color != null ? color : LLRBNode.RED;
        this.left =
            left != null ? left : SortedMap.EMPTY_NODE;
        this.right =
            right != null ? right : SortedMap.EMPTY_NODE;
    }
    /**
     * Returns a copy of the current node, optionally replacing pieces of it.
     *
     * @param {?K} key New key for the node, or null.
     * @param {?V} value New value for the node, or null.
     * @param {?boolean} color New color for the node, or null.
     * @param {?LLRBNode|LLRBEmptyNode} left New left child for the node, or null.
     * @param {?LLRBNode|LLRBEmptyNode} right New right child for the node, or null.
     * @return {!LLRBNode} The node copy.
     */
    LLRBNode.prototype.copy = function (key, value, color, left, right) {
        return new LLRBNode(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
    };
    /**
     * @return {number} The total number of nodes in the tree.
     */
    LLRBNode.prototype.count = function () {
        return this.left.count() + 1 + this.right.count();
    };
    /**
     * @return {boolean} True if the tree is empty.
     */
    LLRBNode.prototype.isEmpty = function () {
        return false;
    };
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param {function(!K, !V):*} action Callback function to be called for each
     *   node.  If it returns true, traversal is aborted.
     * @return {*} The first truthy value returned by action, or the last falsey
     *   value returned by action
     */
    LLRBNode.prototype.inorderTraversal = function (action) {
        return (this.left.inorderTraversal(action) ||
            action(this.key, this.value) ||
            this.right.inorderTraversal(action));
    };
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param {function(!Object, !Object)} action Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @return {*} True if traversal was aborted.
     */
    LLRBNode.prototype.reverseTraversal = function (action) {
        return (this.right.reverseTraversal(action) ||
            action(this.key, this.value) ||
            this.left.reverseTraversal(action));
    };
    /**
     * @return {!Object} The minimum node in the tree.
     * @private
     */
    LLRBNode.prototype.min_ = function () {
        if (this.left.isEmpty()) {
            return this;
        }
        else {
            return this.left.min_();
        }
    };
    /**
     * @return {!K} The maximum key in the tree.
     */
    LLRBNode.prototype.minKey = function () {
        return this.min_().key;
    };
    /**
     * @return {!K} The maximum key in the tree.
     */
    LLRBNode.prototype.maxKey = function () {
        if (this.right.isEmpty()) {
            return this.key;
        }
        else {
            return this.right.maxKey();
        }
    };
    /**
     *
     * @param {!Object} key Key to insert.
     * @param {!Object} value Value to insert.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBNode} New tree, with the key/value added.
     */
    LLRBNode.prototype.insert = function (key, value, comparator) {
        var cmp, n;
        n = this;
        cmp = comparator(key, n.key);
        if (cmp < 0) {
            n = n.copy(null, null, null, n.left.insert(key, value, comparator), null);
        }
        else if (cmp === 0) {
            n = n.copy(null, value, null, null, null);
        }
        else {
            n = n.copy(null, null, null, null, n.right.insert(key, value, comparator));
        }
        return n.fixUp_();
    };
    /**
     * @private
     * @return {!LLRBNode|LLRBEmptyNode} New tree, with the minimum key removed.
     */
    LLRBNode.prototype.removeMin_ = function () {
        if (this.left.isEmpty()) {
            return SortedMap.EMPTY_NODE;
        }
        var n = this;
        if (!n.left.isRed_() && !n.left.left.isRed_())
            n = n.moveRedLeft_();
        n = n.copy(null, null, null, n.left.removeMin_(), null);
        return n.fixUp_();
    };
    /**
     * @param {!Object} key The key of the item to remove.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBNode|LLRBEmptyNode} New tree, with the specified item removed.
     */
    LLRBNode.prototype.remove = function (key, comparator) {
        var n, smallest;
        n = this;
        if (comparator(key, n.key) < 0) {
            if (!n.left.isEmpty() && !n.left.isRed_() && !n.left.left.isRed_()) {
                n = n.moveRedLeft_();
            }
            n = n.copy(null, null, null, n.left.remove(key, comparator), null);
        }
        else {
            if (n.left.isRed_())
                n = n.rotateRight_();
            if (!n.right.isEmpty() && !n.right.isRed_() && !n.right.left.isRed_()) {
                n = n.moveRedRight_();
            }
            if (comparator(key, n.key) === 0) {
                if (n.right.isEmpty()) {
                    return SortedMap.EMPTY_NODE;
                }
                else {
                    smallest = n.right.min_();
                    n = n.copy(smallest.key, smallest.value, null, null, n.right.removeMin_());
                }
            }
            n = n.copy(null, null, null, null, n.right.remove(key, comparator));
        }
        return n.fixUp_();
    };
    /**
     * @private
     * @return {boolean} Whether this is a RED node.
     */
    LLRBNode.prototype.isRed_ = function () {
        return this.color;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree after performing any needed rotations.
     */
    LLRBNode.prototype.fixUp_ = function () {
        var n = this;
        if (n.right.isRed_() && !n.left.isRed_())
            n = n.rotateLeft_();
        if (n.left.isRed_() && n.left.left.isRed_())
            n = n.rotateRight_();
        if (n.left.isRed_() && n.right.isRed_())
            n = n.colorFlip_();
        return n;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after moveRedLeft.
     */
    LLRBNode.prototype.moveRedLeft_ = function () {
        var n = this.colorFlip_();
        if (n.right.left.isRed_()) {
            n = n.copy(null, null, null, null, n.right.rotateRight_());
            n = n.rotateLeft_();
            n = n.colorFlip_();
        }
        return n;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after moveRedRight.
     */
    LLRBNode.prototype.moveRedRight_ = function () {
        var n = this.colorFlip_();
        if (n.left.left.isRed_()) {
            n = n.rotateRight_();
            n = n.colorFlip_();
        }
        return n;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after rotateLeft.
     */
    LLRBNode.prototype.rotateLeft_ = function () {
        var nl = this.copy(null, null, LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, nl, null);
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after rotateRight.
     */
    LLRBNode.prototype.rotateRight_ = function () {
        var nr = this.copy(null, null, LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, nr);
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after colorFlip.
     */
    LLRBNode.prototype.colorFlip_ = function () {
        var left = this.left.copy(null, null, !this.left.color, null, null);
        var right = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, left, right);
    };
    /**
     * For testing.
     *
     * @private
     * @return {boolean} True if all is well.
     */
    LLRBNode.prototype.checkMaxDepth_ = function () {
        var blackDepth = this.check_();
        return Math.pow(2.0, blackDepth) <= this.count() + 1;
    };
    /**
     * @private
     * @return {number} Not sure what this returns exactly. :-).
     */
    LLRBNode.prototype.check_ = function () {
        var blackDepth;
        if (this.isRed_() && this.left.isRed_()) {
            throw new Error('Red node has red child(' + this.key + ',' + this.value + ')');
        }
        if (this.right.isRed_()) {
            throw new Error('Right child of (' + this.key + ',' + this.value + ') is red');
        }
        blackDepth = this.left.check_();
        if (blackDepth !== this.right.check_()) {
            throw new Error('Black depths differ');
        }
        else {
            return blackDepth + (this.isRed_() ? 0 : 1);
        }
    };
    LLRBNode.RED = true;
    LLRBNode.BLACK = false;
    return LLRBNode;
}());
/**
 * Represents an empty node (a leaf node in the Red-Black Tree).
 */
var LLRBEmptyNode = /** @class */ (function () {
    function LLRBEmptyNode() {
    }
    /**
     * Returns a copy of the current node.
     *
     * @return {!LLRBEmptyNode} The node copy.
     */
    LLRBEmptyNode.prototype.copy = function (key, value, color, left, right) {
        return this;
    };
    /**
     * Returns a copy of the tree, with the specified key/value added.
     *
     * @param {!K} key Key to be added.
     * @param {!V} value Value to be added.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBNode} New tree, with item added.
     */
    LLRBEmptyNode.prototype.insert = function (key, value, comparator) {
        return new LLRBNode(key, value, null);
    };
    /**
     * Returns a copy of the tree, with the specified key removed.
     *
     * @param {!K} key The key to remove.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBEmptyNode} New tree, with item removed.
     */
    LLRBEmptyNode.prototype.remove = function (key, comparator) {
        return this;
    };
    /**
     * @return {number} The total number of nodes in the tree.
     */
    LLRBEmptyNode.prototype.count = function () {
        return 0;
    };
    /**
     * @return {boolean} True if the tree is empty.
     */
    LLRBEmptyNode.prototype.isEmpty = function () {
        return true;
    };
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param {function(!K, !V):*} action Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @return {boolean} True if traversal was aborted.
     */
    LLRBEmptyNode.prototype.inorderTraversal = function (action) {
        return false;
    };
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param {function(!K, !V)} action Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @return {boolean} True if traversal was aborted.
     */
    LLRBEmptyNode.prototype.reverseTraversal = function (action) {
        return false;
    };
    /**
     * @return {null}
     */
    LLRBEmptyNode.prototype.minKey = function () {
        return null;
    };
    /**
     * @return {null}
     */
    LLRBEmptyNode.prototype.maxKey = function () {
        return null;
    };
    /**
     * @private
     * @return {number} Not sure what this returns exactly. :-).
     */
    LLRBEmptyNode.prototype.check_ = function () {
        return 0;
    };
    /**
     * @private
     * @return {boolean} Whether this node is red.
     */
    LLRBEmptyNode.prototype.isRed_ = function () {
        return false;
    };
    return LLRBEmptyNode;
}());
/**
 * An immutable sorted map implementation, based on a Left-leaning Red-Black
 * tree.
 */
var SortedMap = /** @class */ (function () {
    /**
     * @template K, V
     * @param {function(K, K):number} comparator_ Key comparator.
     * @param {LLRBNode=} root_ (Optional) Root node for the map.
     */
    function SortedMap(comparator_, root_) {
        if (root_ === void 0) { root_ = SortedMap.EMPTY_NODE; }
        this.comparator_ = comparator_;
        this.root_ = root_;
    }
    /**
     * Returns a copy of the map, with the specified key/value added or replaced.
     * (TODO: We should perhaps rename this method to 'put')
     *
     * @param {!K} key Key to be added.
     * @param {!V} value Value to be added.
     * @return {!SortedMap.<K, V>} New map, with item added.
     */
    SortedMap.prototype.insert = function (key, value) {
        return new SortedMap(this.comparator_, this.root_
            .insert(key, value, this.comparator_)
            .copy(null, null, LLRBNode.BLACK, null, null));
    };
    /**
     * Returns a copy of the map, with the specified key removed.
     *
     * @param {!K} key The key to remove.
     * @return {!SortedMap.<K, V>} New map, with item removed.
     */
    SortedMap.prototype.remove = function (key) {
        return new SortedMap(this.comparator_, this.root_
            .remove(key, this.comparator_)
            .copy(null, null, LLRBNode.BLACK, null, null));
    };
    /**
     * Returns the value of the node with the given key, or null.
     *
     * @param {!K} key The key to look up.
     * @return {?V} The value of the node with the given key, or null if the
     * key doesn't exist.
     */
    SortedMap.prototype.get = function (key) {
        var cmp;
        var node = this.root_;
        while (!node.isEmpty()) {
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) {
                return node.value;
            }
            else if (cmp < 0) {
                node = node.left;
            }
            else if (cmp > 0) {
                node = node.right;
            }
        }
        return null;
    };
    /**
     * Returns the key of the item *before* the specified key, or null if key is the first item.
     * @param {K} key The key to find the predecessor of
     * @return {?K} The predecessor key.
     */
    SortedMap.prototype.getPredecessorKey = function (key) {
        var cmp, node = this.root_, rightParent = null;
        while (!node.isEmpty()) {
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) {
                if (!node.left.isEmpty()) {
                    node = node.left;
                    while (!node.right.isEmpty())
                        node = node.right;
                    return node.key;
                }
                else if (rightParent) {
                    return rightParent.key;
                }
                else {
                    return null; // first item.
                }
            }
            else if (cmp < 0) {
                node = node.left;
            }
            else if (cmp > 0) {
                rightParent = node;
                node = node.right;
            }
        }
        throw new Error('Attempted to find predecessor key for a nonexistent key.  What gives?');
    };
    /**
     * @return {boolean} True if the map is empty.
     */
    SortedMap.prototype.isEmpty = function () {
        return this.root_.isEmpty();
    };
    /**
     * @return {number} The total number of nodes in the map.
     */
    SortedMap.prototype.count = function () {
        return this.root_.count();
    };
    /**
     * @return {?K} The minimum key in the map.
     */
    SortedMap.prototype.minKey = function () {
        return this.root_.minKey();
    };
    /**
     * @return {?K} The maximum key in the map.
     */
    SortedMap.prototype.maxKey = function () {
        return this.root_.maxKey();
    };
    /**
     * Traverses the map in key order and calls the specified action function
     * for each key/value pair.
     *
     * @param {function(!K, !V):*} action Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @return {*} The first truthy value returned by action, or the last falsey
     *   value returned by action
     */
    SortedMap.prototype.inorderTraversal = function (action) {
        return this.root_.inorderTraversal(action);
    };
    /**
     * Traverses the map in reverse key order and calls the specified action function
     * for each key/value pair.
     *
     * @param {function(!Object, !Object)} action Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @return {*} True if the traversal was aborted.
     */
    SortedMap.prototype.reverseTraversal = function (action) {
        return this.root_.reverseTraversal(action);
    };
    /**
     * Returns an iterator over the SortedMap.
     * @template T
     * @param {(function(K, V):T)=} resultGenerator
     * @return {SortedMapIterator.<K, V, T>} The iterator.
     */
    SortedMap.prototype.getIterator = function (resultGenerator) {
        return new SortedMapIterator(this.root_, null, this.comparator_, false, resultGenerator);
    };
    SortedMap.prototype.getIteratorFrom = function (key, resultGenerator) {
        return new SortedMapIterator(this.root_, key, this.comparator_, false, resultGenerator);
    };
    SortedMap.prototype.getReverseIteratorFrom = function (key, resultGenerator) {
        return new SortedMapIterator(this.root_, key, this.comparator_, true, resultGenerator);
    };
    SortedMap.prototype.getReverseIterator = function (resultGenerator) {
        return new SortedMapIterator(this.root_, null, this.comparator_, true, resultGenerator);
    };
    /**
     * Always use the same empty node, to reduce memory.
     * @const
     */
    SortedMap.EMPTY_NODE = new LLRBEmptyNode();
    return SortedMap;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_2 = Math.log(2);
/**
 * @constructor
 */
var Base12Num = /** @class */ (function () {
    /**
     * @param {number} length
     */
    function Base12Num(length) {
        var logBase2 = function (num) {
            return parseInt((Math.log(num) / LOG_2), 10);
        };
        var bitMask = function (bits) { return parseInt(Array(bits + 1).join('1'), 2); };
        this.count = logBase2(length + 1);
        this.current_ = this.count - 1;
        var mask = bitMask(this.count);
        this.bits_ = (length + 1) & mask;
    }
    /**
     * @return {boolean}
     */
    Base12Num.prototype.nextBitIsOne = function () {
        //noinspection JSBitwiseOperatorUsage
        var result = !(this.bits_ & (0x1 << this.current_));
        this.current_--;
        return result;
    };
    return Base12Num;
}());
/**
 * Takes a list of child nodes and constructs a SortedSet using the given comparison
 * function
 *
 * Uses the algorithm described in the paper linked here:
 * http://citeseerx.ist.psu.edu/viewdoc/summary?doi=10.1.1.46.1458
 *
 * @template K, V
 * @param {Array.<!NamedNode>} childList Unsorted list of children
 * @param {function(!NamedNode, !NamedNode):number} cmp The comparison method to be used
 * @param {(function(NamedNode):K)=} keyFn An optional function to extract K from a node wrapper, if K's
 *                                                        type is not NamedNode
 * @param {(function(K, K):number)=} mapSortFn An optional override for comparator used by the generated sorted map
 * @return {SortedMap.<K, V>}
 */
var buildChildSet = function (childList, cmp, keyFn, mapSortFn) {
    childList.sort(cmp);
    var buildBalancedTree = function (low, high) {
        var length = high - low;
        var namedNode;
        var key;
        if (length == 0) {
            return null;
        }
        else if (length == 1) {
            namedNode = childList[low];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new LLRBNode(key, namedNode.node, LLRBNode.BLACK, null, null);
        }
        else {
            var middle = parseInt((length / 2), 10) + low;
            var left = buildBalancedTree(low, middle);
            var right = buildBalancedTree(middle + 1, high);
            namedNode = childList[middle];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new LLRBNode(key, namedNode.node, LLRBNode.BLACK, left, right);
        }
    };
    var buildFrom12Array = function (base12) {
        var node = null;
        var root = null;
        var index = childList.length;
        var buildPennant = function (chunkSize, color) {
            var low = index - chunkSize;
            var high = index;
            index -= chunkSize;
            var childTree = buildBalancedTree(low + 1, high);
            var namedNode = childList[low];
            var key = keyFn ? keyFn(namedNode) : namedNode;
            attachPennant(new LLRBNode(key, namedNode.node, color, null, childTree));
        };
        var attachPennant = function (pennant) {
            if (node) {
                node.left = pennant;
                node = pennant;
            }
            else {
                root = pennant;
                node = pennant;
            }
        };
        for (var i = 0; i < base12.count; ++i) {
            var isOne = base12.nextBitIsOne();
            // The number of nodes taken in each slice is 2^(arr.length - (i + 1))
            var chunkSize = Math.pow(2, base12.count - (i + 1));
            if (isOne) {
                buildPennant(chunkSize, LLRBNode.BLACK);
            }
            else {
                // current == 2
                buildPennant(chunkSize, LLRBNode.BLACK);
                buildPennant(chunkSize, LLRBNode.RED);
            }
        }
        return root;
    };
    var base12 = new Base12Num(childList.length);
    var root = buildFrom12Array(base12);
    return new SortedMap(mapSortFn || cmp, root);
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _defaultIndexMap;
var fallbackObject = {};
var IndexMap = /** @class */ (function () {
    function IndexMap(indexes_, indexSet_) {
        this.indexes_ = indexes_;
        this.indexSet_ = indexSet_;
    }
    Object.defineProperty(IndexMap, "Default", {
        /**
         * The default IndexMap for nodes without a priority
         */
        get: function () {
            util.assert(fallbackObject && PRIORITY_INDEX, 'ChildrenNode.ts has not been loaded');
            _defaultIndexMap =
                _defaultIndexMap ||
                    new IndexMap({ '.priority': fallbackObject }, { '.priority': PRIORITY_INDEX });
            return _defaultIndexMap;
        },
        enumerable: true,
        configurable: true
    });
    IndexMap.prototype.get = function (indexKey) {
        var sortedMap = util.safeGet(this.indexes_, indexKey);
        if (!sortedMap)
            throw new Error('No index defined for ' + indexKey);
        if (sortedMap instanceof SortedMap) {
            return sortedMap;
        }
        else {
            // The index exists, but it falls back to just name comparison. Return null so that the calling code uses the
            // regular child map
            return null;
        }
    };
    IndexMap.prototype.hasIndex = function (indexDefinition) {
        return util.contains(this.indexSet_, indexDefinition.toString());
    };
    IndexMap.prototype.addIndex = function (indexDefinition, existingChildren) {
        util.assert(indexDefinition !== KEY_INDEX, "KeyIndex always exists and isn't meant to be added to the IndexMap.");
        var childList = [];
        var sawIndexedValue = false;
        var iter = existingChildren.getIterator(NamedNode.Wrap);
        var next = iter.getNext();
        while (next) {
            sawIndexedValue =
                sawIndexedValue || indexDefinition.isDefinedOn(next.node);
            childList.push(next);
            next = iter.getNext();
        }
        var newIndex;
        if (sawIndexedValue) {
            newIndex = buildChildSet(childList, indexDefinition.getCompare());
        }
        else {
            newIndex = fallbackObject;
        }
        var indexName = indexDefinition.toString();
        var newIndexSet = tslib.__assign({}, this.indexSet_);
        newIndexSet[indexName] = indexDefinition;
        var newIndexes = tslib.__assign({}, this.indexes_);
        newIndexes[indexName] = newIndex;
        return new IndexMap(newIndexes, newIndexSet);
    };
    /**
     * Ensure that this node is properly tracked in any indexes that we're maintaining
     */
    IndexMap.prototype.addToIndexes = function (namedNode, existingChildren) {
        var _this = this;
        var newIndexes = util.map(this.indexes_, function (indexedChildren, indexName) {
            var index = util.safeGet(_this.indexSet_, indexName);
            util.assert(index, 'Missing index implementation for ' + indexName);
            if (indexedChildren === fallbackObject) {
                // Check to see if we need to index everything
                if (index.isDefinedOn(namedNode.node)) {
                    // We need to build this index
                    var childList = [];
                    var iter = existingChildren.getIterator(NamedNode.Wrap);
                    var next = iter.getNext();
                    while (next) {
                        if (next.name != namedNode.name) {
                            childList.push(next);
                        }
                        next = iter.getNext();
                    }
                    childList.push(namedNode);
                    return buildChildSet(childList, index.getCompare());
                }
                else {
                    // No change, this remains a fallback
                    return fallbackObject;
                }
            }
            else {
                var existingSnap = existingChildren.get(namedNode.name);
                var newChildren = indexedChildren;
                if (existingSnap) {
                    newChildren = newChildren.remove(new NamedNode(namedNode.name, existingSnap));
                }
                return newChildren.insert(namedNode, namedNode.node);
            }
        });
        return new IndexMap(newIndexes, this.indexSet_);
    };
    /**
     * Create a new IndexMap instance with the given value removed
     */
    IndexMap.prototype.removeFromIndexes = function (namedNode, existingChildren) {
        var newIndexes = util.map(this.indexes_, function (indexedChildren) {
            if (indexedChildren === fallbackObject) {
                // This is the fallback. Just return it, nothing to do in this case
                return indexedChildren;
            }
            else {
                var existingSnap = existingChildren.get(namedNode.name);
                if (existingSnap) {
                    return indexedChildren.remove(new NamedNode(namedNode.name, existingSnap));
                }
                else {
                    // No record of this child
                    return indexedChildren;
                }
            }
        });
        return new IndexMap(newIndexes, this.indexSet_);
    };
    return IndexMap;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function NAME_ONLY_COMPARATOR(left, right) {
    return nameCompare(left.name, right.name);
}
function NAME_COMPARATOR(left, right) {
    return nameCompare(left, right);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// TODO: For memory savings, don't store priorityNode_ if it's empty.
var EMPTY_NODE;
/**
 * ChildrenNode is a class for storing internal nodes in a DataSnapshot
 * (i.e. nodes with children).  It implements Node and stores the
 * list of children in the children property, sorted by child name.
 *
 * @constructor
 * @implements {Node}
 */
var ChildrenNode = /** @class */ (function () {
    /**
     *
     * @param {!SortedMap.<string, !Node>} children_ List of children
     * of this node..
     * @param {?Node} priorityNode_ The priority of this node (as a snapshot node).
     * @param {!IndexMap} indexMap_
     */
    function ChildrenNode(children_, priorityNode_, indexMap_) {
        this.children_ = children_;
        this.priorityNode_ = priorityNode_;
        this.indexMap_ = indexMap_;
        this.lazyHash_ = null;
        /**
         * Note: The only reason we allow null priority is for EMPTY_NODE, since we can't use
         * EMPTY_NODE as the priority of EMPTY_NODE.  We might want to consider making EMPTY_NODE its own
         * class instead of an empty ChildrenNode.
         */
        if (this.priorityNode_) {
            validatePriorityNode(this.priorityNode_);
        }
        if (this.children_.isEmpty()) {
            util.assert(!this.priorityNode_ || this.priorityNode_.isEmpty(), 'An empty node cannot have a priority');
        }
    }
    Object.defineProperty(ChildrenNode, "EMPTY_NODE", {
        get: function () {
            return (EMPTY_NODE ||
                (EMPTY_NODE = new ChildrenNode(new SortedMap(NAME_COMPARATOR), null, IndexMap.Default)));
        },
        enumerable: true,
        configurable: true
    });
    /** @inheritDoc */
    ChildrenNode.prototype.isLeafNode = function () {
        return false;
    };
    /** @inheritDoc */
    ChildrenNode.prototype.getPriority = function () {
        return this.priorityNode_ || EMPTY_NODE;
    };
    /** @inheritDoc */
    ChildrenNode.prototype.updatePriority = function (newPriorityNode) {
        if (this.children_.isEmpty()) {
            // Don't allow priorities on empty nodes
            return this;
        }
        else {
            return new ChildrenNode(this.children_, newPriorityNode, this.indexMap_);
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.getImmediateChild = function (childName) {
        // Hack to treat priority as a regular child
        if (childName === '.priority') {
            return this.getPriority();
        }
        else {
            var child = this.children_.get(childName);
            return child === null ? EMPTY_NODE : child;
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.getChild = function (path) {
        var front = path.getFront();
        if (front === null)
            return this;
        return this.getImmediateChild(front).getChild(path.popFront());
    };
    /** @inheritDoc */
    ChildrenNode.prototype.hasChild = function (childName) {
        return this.children_.get(childName) !== null;
    };
    /** @inheritDoc */
    ChildrenNode.prototype.updateImmediateChild = function (childName, newChildNode) {
        util.assert(newChildNode, 'We should always be passing snapshot nodes');
        if (childName === '.priority') {
            return this.updatePriority(newChildNode);
        }
        else {
            var namedNode = new NamedNode(childName, newChildNode);
            var newChildren = void 0, newIndexMap = void 0, newPriority = void 0;
            if (newChildNode.isEmpty()) {
                newChildren = this.children_.remove(childName);
                newIndexMap = this.indexMap_.removeFromIndexes(namedNode, this.children_);
            }
            else {
                newChildren = this.children_.insert(childName, newChildNode);
                newIndexMap = this.indexMap_.addToIndexes(namedNode, this.children_);
            }
            newPriority = newChildren.isEmpty() ? EMPTY_NODE : this.priorityNode_;
            return new ChildrenNode(newChildren, newPriority, newIndexMap);
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.updateChild = function (path, newChildNode) {
        var front = path.getFront();
        if (front === null) {
            return newChildNode;
        }
        else {
            util.assert(path.getFront() !== '.priority' || path.getLength() === 1, '.priority must be the last token in a path');
            var newImmediateChild = this.getImmediateChild(front).updateChild(path.popFront(), newChildNode);
            return this.updateImmediateChild(front, newImmediateChild);
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.isEmpty = function () {
        return this.children_.isEmpty();
    };
    /** @inheritDoc */
    ChildrenNode.prototype.numChildren = function () {
        return this.children_.count();
    };
    /** @inheritDoc */
    ChildrenNode.prototype.val = function (exportFormat) {
        if (this.isEmpty())
            return null;
        var obj = {};
        var numKeys = 0, maxKey = 0, allIntegerKeys = true;
        this.forEachChild(PRIORITY_INDEX, function (key, childNode) {
            obj[key] = childNode.val(exportFormat);
            numKeys++;
            if (allIntegerKeys && ChildrenNode.INTEGER_REGEXP_.test(key)) {
                maxKey = Math.max(maxKey, Number(key));
            }
            else {
                allIntegerKeys = false;
            }
        });
        if (!exportFormat && allIntegerKeys && maxKey < 2 * numKeys) {
            // convert to array.
            var array = [];
            for (var key in obj)
                array[key] = obj[key];
            return array;
        }
        else {
            if (exportFormat && !this.getPriority().isEmpty()) {
                obj['.priority'] = this.getPriority().val();
            }
            return obj;
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.hash = function () {
        if (this.lazyHash_ === null) {
            var toHash_1 = '';
            if (!this.getPriority().isEmpty())
                toHash_1 +=
                    'priority:' +
                        priorityHashText(this.getPriority().val()) +
                        ':';
            this.forEachChild(PRIORITY_INDEX, function (key, childNode) {
                var childHash = childNode.hash();
                if (childHash !== '')
                    toHash_1 += ':' + key + ':' + childHash;
            });
            this.lazyHash_ = toHash_1 === '' ? '' : sha1(toHash_1);
        }
        return this.lazyHash_;
    };
    /** @inheritDoc */
    ChildrenNode.prototype.getPredecessorChildName = function (childName, childNode, index) {
        var idx = this.resolveIndex_(index);
        if (idx) {
            var predecessor = idx.getPredecessorKey(new NamedNode(childName, childNode));
            return predecessor ? predecessor.name : null;
        }
        else {
            return this.children_.getPredecessorKey(childName);
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {?string}
     */
    ChildrenNode.prototype.getFirstChildName = function (indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            var minKey = idx.minKey();
            return minKey && minKey.name;
        }
        else {
            return this.children_.minKey();
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {?NamedNode}
     */
    ChildrenNode.prototype.getFirstChild = function (indexDefinition) {
        var minKey = this.getFirstChildName(indexDefinition);
        if (minKey) {
            return new NamedNode(minKey, this.children_.get(minKey));
        }
        else {
            return null;
        }
    };
    /**
     * Given an index, return the key name of the largest value we have, according to that index
     * @param {!Index} indexDefinition
     * @return {?string}
     */
    ChildrenNode.prototype.getLastChildName = function (indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            var maxKey = idx.maxKey();
            return maxKey && maxKey.name;
        }
        else {
            return this.children_.maxKey();
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {?NamedNode}
     */
    ChildrenNode.prototype.getLastChild = function (indexDefinition) {
        var maxKey = this.getLastChildName(indexDefinition);
        if (maxKey) {
            return new NamedNode(maxKey, this.children_.get(maxKey));
        }
        else {
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.forEachChild = function (index, action) {
        var idx = this.resolveIndex_(index);
        if (idx) {
            return idx.inorderTraversal(function (wrappedNode) {
                return action(wrappedNode.name, wrappedNode.node);
            });
        }
        else {
            return this.children_.inorderTraversal(action);
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {SortedMapIterator}
     */
    ChildrenNode.prototype.getIterator = function (indexDefinition) {
        return this.getIteratorFrom(indexDefinition.minPost(), indexDefinition);
    };
    /**
     *
     * @param {!NamedNode} startPost
     * @param {!Index} indexDefinition
     * @return {!SortedMapIterator}
     */
    ChildrenNode.prototype.getIteratorFrom = function (startPost, indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            return idx.getIteratorFrom(startPost, function (key) { return key; });
        }
        else {
            var iterator = this.children_.getIteratorFrom(startPost.name, NamedNode.Wrap);
            var next = iterator.peek();
            while (next != null && indexDefinition.compare(next, startPost) < 0) {
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {!SortedMapIterator}
     */
    ChildrenNode.prototype.getReverseIterator = function (indexDefinition) {
        return this.getReverseIteratorFrom(indexDefinition.maxPost(), indexDefinition);
    };
    /**
     * @param {!NamedNode} endPost
     * @param {!Index} indexDefinition
     * @return {!SortedMapIterator}
     */
    ChildrenNode.prototype.getReverseIteratorFrom = function (endPost, indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            return idx.getReverseIteratorFrom(endPost, function (key) {
                return key;
            });
        }
        else {
            var iterator = this.children_.getReverseIteratorFrom(endPost.name, NamedNode.Wrap);
            var next = iterator.peek();
            while (next != null && indexDefinition.compare(next, endPost) > 0) {
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.compareTo = function (other) {
        if (this.isEmpty()) {
            if (other.isEmpty()) {
                return 0;
            }
            else {
                return -1;
            }
        }
        else if (other.isLeafNode() || other.isEmpty()) {
            return 1;
        }
        else if (other === MAX_NODE$2) {
            return -1;
        }
        else {
            // Must be another node with children.
            return 0;
        }
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.withIndex = function (indexDefinition) {
        if (indexDefinition === KEY_INDEX ||
            this.indexMap_.hasIndex(indexDefinition)) {
            return this;
        }
        else {
            var newIndexMap = this.indexMap_.addIndex(indexDefinition, this.children_);
            return new ChildrenNode(this.children_, this.priorityNode_, newIndexMap);
        }
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.isIndexed = function (index) {
        return index === KEY_INDEX || this.indexMap_.hasIndex(index);
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.equals = function (other) {
        if (other === this) {
            return true;
        }
        else if (other.isLeafNode()) {
            return false;
        }
        else {
            var otherChildrenNode = other;
            if (!this.getPriority().equals(otherChildrenNode.getPriority())) {
                return false;
            }
            else if (this.children_.count() === otherChildrenNode.children_.count()) {
                var thisIter = this.getIterator(PRIORITY_INDEX);
                var otherIter = otherChildrenNode.getIterator(PRIORITY_INDEX);
                var thisCurrent = thisIter.getNext();
                var otherCurrent = otherIter.getNext();
                while (thisCurrent && otherCurrent) {
                    if (thisCurrent.name !== otherCurrent.name ||
                        !thisCurrent.node.equals(otherCurrent.node)) {
                        return false;
                    }
                    thisCurrent = thisIter.getNext();
                    otherCurrent = otherIter.getNext();
                }
                return thisCurrent === null && otherCurrent === null;
            }
            else {
                return false;
            }
        }
    };
    /**
     * Returns a SortedMap ordered by index, or null if the default (by-key) ordering can be used
     * instead.
     *
     * @private
     * @param {!Index} indexDefinition
     * @return {?SortedMap.<NamedNode, Node>}
     */
    ChildrenNode.prototype.resolveIndex_ = function (indexDefinition) {
        if (indexDefinition === KEY_INDEX) {
            return null;
        }
        else {
            return this.indexMap_.get(indexDefinition.toString());
        }
    };
    /**
     * @private
     * @type {RegExp}
     */
    ChildrenNode.INTEGER_REGEXP_ = /^(0|[1-9]\d*)$/;
    return ChildrenNode;
}());
/**
 * @constructor
 * @extends {ChildrenNode}
 * @private
 */
var MaxNode = /** @class */ (function (_super) {
    tslib.__extends(MaxNode, _super);
    function MaxNode() {
        return _super.call(this, new SortedMap(NAME_COMPARATOR), ChildrenNode.EMPTY_NODE, IndexMap.Default) || this;
    }
    MaxNode.prototype.compareTo = function (other) {
        if (other === this) {
            return 0;
        }
        else {
            return 1;
        }
    };
    MaxNode.prototype.equals = function (other) {
        // Not that we every compare it, but MAX_NODE is only ever equal to itself
        return other === this;
    };
    MaxNode.prototype.getPriority = function () {
        return this;
    };
    MaxNode.prototype.getImmediateChild = function (childName) {
        return ChildrenNode.EMPTY_NODE;
    };
    MaxNode.prototype.isEmpty = function () {
        return false;
    };
    return MaxNode;
}(ChildrenNode));
/**
 * Marker that will sort higher than any other snapshot.
 * @type {!MAX_NODE}
 * @const
 */
var MAX_NODE$2 = new MaxNode();
Object.defineProperties(NamedNode, {
    MIN: {
        value: new NamedNode(MIN_NAME, ChildrenNode.EMPTY_NODE)
    },
    MAX: {
        value: new NamedNode(MAX_NAME, MAX_NODE$2)
    }
});
/**
 * Reference Extensions
 */
KeyIndex.__EMPTY_NODE = ChildrenNode.EMPTY_NODE;
LeafNode.__childrenNodeConstructor = ChildrenNode;
setMaxNode(MAX_NODE$2);
setMaxNode$1(MAX_NODE$2);

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var USE_HINZE = true;
/**
 * Constructs a snapshot node representing the passed JSON and returns it.
 * @param {*} json JSON to create a node for.
 * @param {?string|?number=} priority Optional priority to use.  This will be ignored if the
 * passed JSON contains a .priority property.
 * @return {!Node}
 */
function nodeFromJSON$1(json, priority) {
    if (priority === void 0) { priority = null; }
    if (json === null) {
        return ChildrenNode.EMPTY_NODE;
    }
    if (typeof json === 'object' && '.priority' in json) {
        priority = json['.priority'];
    }
    util.assert(priority === null ||
        typeof priority === 'string' ||
        typeof priority === 'number' ||
        (typeof priority === 'object' && '.sv' in priority), 'Invalid priority type found: ' + typeof priority);
    if (typeof json === 'object' && '.value' in json && json['.value'] !== null) {
        json = json['.value'];
    }
    // Valid leaf nodes include non-objects or server-value wrapper objects
    if (typeof json !== 'object' || '.sv' in json) {
        var jsonLeaf = json;
        return new LeafNode(jsonLeaf, nodeFromJSON$1(priority));
    }
    if (!(json instanceof Array) && USE_HINZE) {
        var children_1 = [];
        var childrenHavePriority_1 = false;
        var hinzeJsonObj = json;
        each(hinzeJsonObj, function (key, child) {
            if (key.substring(0, 1) !== '.') {
                // Ignore metadata nodes
                var childNode = nodeFromJSON$1(child);
                if (!childNode.isEmpty()) {
                    childrenHavePriority_1 =
                        childrenHavePriority_1 || !childNode.getPriority().isEmpty();
                    children_1.push(new NamedNode(key, childNode));
                }
            }
        });
        if (children_1.length == 0) {
            return ChildrenNode.EMPTY_NODE;
        }
        var childSet = buildChildSet(children_1, NAME_ONLY_COMPARATOR, function (namedNode) { return namedNode.name; }, NAME_COMPARATOR);
        if (childrenHavePriority_1) {
            var sortedChildSet = buildChildSet(children_1, PRIORITY_INDEX.getCompare());
            return new ChildrenNode(childSet, nodeFromJSON$1(priority), new IndexMap({ '.priority': sortedChildSet }, { '.priority': PRIORITY_INDEX }));
        }
        else {
            return new ChildrenNode(childSet, nodeFromJSON$1(priority), IndexMap.Default);
        }
    }
    else {
        var node_1 = ChildrenNode.EMPTY_NODE;
        each(json, function (key, childData) {
            if (util.contains(json, key)) {
                if (key.substring(0, 1) !== '.') {
                    // ignore metadata nodes.
                    var childNode = nodeFromJSON$1(childData);
                    if (childNode.isLeafNode() || !childNode.isEmpty())
                        node_1 = node_1.updateImmediateChild(key, childNode);
                }
            }
        });
        return node_1.updatePriority(nodeFromJSON$1(priority));
    }
}
setNodeFromJSON(nodeFromJSON$1);

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @constructor
 * @extends {Index}
 * @private
 */
var ValueIndex = /** @class */ (function (_super) {
    tslib.__extends(ValueIndex, _super);
    function ValueIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.compare = function (a, b) {
        var indexCmp = a.node.compareTo(b.node);
        if (indexCmp === 0) {
            return nameCompare(a.name, b.name);
        }
        else {
            return indexCmp;
        }
    };
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.isDefinedOn = function (node) {
        return true;
    };
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
        return !oldNode.equals(newNode);
    };
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.minPost = function () {
        return NamedNode.MIN;
    };
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.maxPost = function () {
        return NamedNode.MAX;
    };
    /**
     * @param {*} indexValue
     * @param {string} name
     * @return {!NamedNode}
     */
    ValueIndex.prototype.makePost = function (indexValue, name) {
        var valueNode = nodeFromJSON$1(indexValue);
        return new NamedNode(name, valueNode);
    };
    /**
     * @return {!string} String representation for inclusion in a query spec
     */
    ValueIndex.prototype.toString = function () {
        return '.value';
    };
    return ValueIndex;
}(Index));
var VALUE_INDEX = new ValueIndex();

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param {!Path} indexPath
 * @constructor
 * @extends {Index}
 */
var PathIndex = /** @class */ (function (_super) {
    tslib.__extends(PathIndex, _super);
    function PathIndex(indexPath_) {
        var _this = _super.call(this) || this;
        _this.indexPath_ = indexPath_;
        util.assert(!indexPath_.isEmpty() && indexPath_.getFront() !== '.priority', "Can't create PathIndex with empty path or .priority key");
        return _this;
    }
    /**
     * @param {!Node} snap
     * @return {!Node}
     * @protected
     */
    PathIndex.prototype.extractChild = function (snap) {
        return snap.getChild(this.indexPath_);
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.isDefinedOn = function (node) {
        return !node.getChild(this.indexPath_).isEmpty();
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.compare = function (a, b) {
        var aChild = this.extractChild(a.node);
        var bChild = this.extractChild(b.node);
        var indexCmp = aChild.compareTo(bChild);
        if (indexCmp === 0) {
            return nameCompare(a.name, b.name);
        }
        else {
            return indexCmp;
        }
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.makePost = function (indexValue, name) {
        var valueNode = nodeFromJSON$1(indexValue);
        var node = ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, valueNode);
        return new NamedNode(name, node);
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.maxPost = function () {
        var node = ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, MAX_NODE$2);
        return new NamedNode(MAX_NAME, node);
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.toString = function () {
        return this.indexPath_.slice().join('/');
    };
    return PathIndex;
}(Index));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Class representing a firebase data snapshot.  It wraps a SnapshotNode and
 * surfaces the public methods (val, forEach, etc.) we want to expose.
 */
var DataSnapshot = /** @class */ (function () {
    /**
     * @param {!Node} node_ A SnapshotNode to wrap.
     * @param {!Reference} ref_ The ref of the location this snapshot came from.
     * @param {!Index} index_ The iteration order for this snapshot
     */
    function DataSnapshot(node_, ref_, index_) {
        this.node_ = node_;
        this.ref_ = ref_;
        this.index_ = index_;
    }
    /**
     * Retrieves the snapshot contents as JSON.  Returns null if the snapshot is
     * empty.
     *
     * @return {*} JSON representation of the DataSnapshot contents, or null if empty.
     */
    DataSnapshot.prototype.val = function () {
        util.validateArgCount('DataSnapshot.val', 0, 0, arguments.length);
        return this.node_.val();
    };
    /**
     * Returns the snapshot contents as JSON, including priorities of node.  Suitable for exporting
     * the entire node contents.
     * @return {*} JSON representation of the DataSnapshot contents, or null if empty.
     */
    DataSnapshot.prototype.exportVal = function () {
        util.validateArgCount('DataSnapshot.exportVal', 0, 0, arguments.length);
        return this.node_.val(true);
    };
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users
    DataSnapshot.prototype.toJSON = function () {
        // Optional spacer argument is unnecessary because we're depending on recursion rather than stringifying the content
        util.validateArgCount('DataSnapshot.toJSON', 0, 1, arguments.length);
        return this.exportVal();
    };
    /**
     * Returns whether the snapshot contains a non-null value.
     *
     * @return {boolean} Whether the snapshot contains a non-null value, or is empty.
     */
    DataSnapshot.prototype.exists = function () {
        util.validateArgCount('DataSnapshot.exists', 0, 0, arguments.length);
        return !this.node_.isEmpty();
    };
    /**
     * Returns a DataSnapshot of the specified child node's contents.
     *
     * @param {!string} childPathString Path to a child.
     * @return {!DataSnapshot} DataSnapshot for child node.
     */
    DataSnapshot.prototype.child = function (childPathString) {
        util.validateArgCount('DataSnapshot.child', 0, 1, arguments.length);
        // Ensure the childPath is a string (can be a number)
        childPathString = String(childPathString);
        validatePathString('DataSnapshot.child', 1, childPathString, false);
        var childPath = new Path(childPathString);
        var childRef = this.ref_.child(childPath);
        return new DataSnapshot(this.node_.getChild(childPath), childRef, PRIORITY_INDEX);
    };
    /**
     * Returns whether the snapshot contains a child at the specified path.
     *
     * @param {!string} childPathString Path to a child.
     * @return {boolean} Whether the child exists.
     */
    DataSnapshot.prototype.hasChild = function (childPathString) {
        util.validateArgCount('DataSnapshot.hasChild', 1, 1, arguments.length);
        validatePathString('DataSnapshot.hasChild', 1, childPathString, false);
        var childPath = new Path(childPathString);
        return !this.node_.getChild(childPath).isEmpty();
    };
    /**
     * Returns the priority of the object, or null if no priority was set.
     *
     * @return {string|number|null} The priority.
     */
    DataSnapshot.prototype.getPriority = function () {
        util.validateArgCount('DataSnapshot.getPriority', 0, 0, arguments.length);
        // typecast here because we never return deferred values or internal priorities (MAX_PRIORITY)
        return this.node_.getPriority().val();
    };
    /**
     * Iterates through child nodes and calls the specified action for each one.
     *
     * @param {function(!DataSnapshot)} action Callback function to be called
     * for each child.
     * @return {boolean} True if forEach was canceled by action returning true for
     * one of the child nodes.
     */
    DataSnapshot.prototype.forEach = function (action) {
        var _this = this;
        util.validateArgCount('DataSnapshot.forEach', 1, 1, arguments.length);
        util.validateCallback('DataSnapshot.forEach', 1, action, false);
        if (this.node_.isLeafNode())
            return false;
        var childrenNode = this.node_;
        // Sanitize the return value to a boolean. ChildrenNode.forEachChild has a weird return type...
        return !!childrenNode.forEachChild(this.index_, function (key, node) {
            return action(new DataSnapshot(node, _this.ref_.child(key), PRIORITY_INDEX));
        });
    };
    /**
     * Returns whether this DataSnapshot has children.
     * @return {boolean} True if the DataSnapshot contains 1 or more child nodes.
     */
    DataSnapshot.prototype.hasChildren = function () {
        util.validateArgCount('DataSnapshot.hasChildren', 0, 0, arguments.length);
        if (this.node_.isLeafNode())
            return false;
        else
            return !this.node_.isEmpty();
    };
    Object.defineProperty(DataSnapshot.prototype, "key", {
        get: function () {
            return this.ref_.getKey();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns the number of children for this DataSnapshot.
     * @return {number} The number of children that this DataSnapshot contains.
     */
    DataSnapshot.prototype.numChildren = function () {
        util.validateArgCount('DataSnapshot.numChildren', 0, 0, arguments.length);
        return this.node_.numChildren();
    };
    /**
     * @return {Reference} The Firebase reference for the location this snapshot's data came from.
     */
    DataSnapshot.prototype.getRef = function () {
        util.validateArgCount('DataSnapshot.ref', 0, 0, arguments.length);
        return this.ref_;
    };
    Object.defineProperty(DataSnapshot.prototype, "ref", {
        get: function () {
            return this.getRef();
        },
        enumerable: true,
        configurable: true
    });
    return DataSnapshot;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Encapsulates the data needed to raise an event
 * @implements {Event}
 */
var DataEvent = /** @class */ (function () {
    /**
     * @param {!string} eventType One of: value, child_added, child_changed, child_moved, child_removed
     * @param {!EventRegistration} eventRegistration The function to call to with the event data. User provided
     * @param {!DataSnapshot} snapshot The data backing the event
     * @param {?string=} prevName Optional, the name of the previous child for child_* events.
     */
    function DataEvent(eventType, eventRegistration, snapshot, prevName) {
        this.eventType = eventType;
        this.eventRegistration = eventRegistration;
        this.snapshot = snapshot;
        this.prevName = prevName;
    }
    /**
     * @inheritDoc
     */
    DataEvent.prototype.getPath = function () {
        var ref = this.snapshot.getRef();
        if (this.eventType === 'value') {
            return ref.path;
        }
        else {
            return ref.getParent().path;
        }
    };
    /**
     * @inheritDoc
     */
    DataEvent.prototype.getEventType = function () {
        return this.eventType;
    };
    /**
     * @inheritDoc
     */
    DataEvent.prototype.getEventRunner = function () {
        return this.eventRegistration.getEventRunner(this);
    };
    /**
     * @inheritDoc
     */
    DataEvent.prototype.toString = function () {
        return (this.getPath().toString() +
            ':' +
            this.eventType +
            ':' +
            util.stringify(this.snapshot.exportVal()));
    };
    return DataEvent;
}());
var CancelEvent = /** @class */ (function () {
    /**
     * @param {EventRegistration} eventRegistration
     * @param {Error} error
     * @param {!Path} path
     */
    function CancelEvent(eventRegistration, error, path) {
        this.eventRegistration = eventRegistration;
        this.error = error;
        this.path = path;
    }
    /**
     * @inheritDoc
     */
    CancelEvent.prototype.getPath = function () {
        return this.path;
    };
    /**
     * @inheritDoc
     */
    CancelEvent.prototype.getEventType = function () {
        return 'cancel';
    };
    /**
     * @inheritDoc
     */
    CancelEvent.prototype.getEventRunner = function () {
        return this.eventRegistration.getEventRunner(this);
    };
    /**
     * @inheritDoc
     */
    CancelEvent.prototype.toString = function () {
        return this.path.toString() + ':cancel';
    };
    return CancelEvent;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Represents registration for 'value' events.
 */
var ValueEventRegistration = /** @class */ (function () {
    /**
     * @param {?function(!DataSnapshot)} callback_
     * @param {?function(Error)} cancelCallback_
     * @param {?Object} context_
     */
    function ValueEventRegistration(callback_, cancelCallback_, context_) {
        this.callback_ = callback_;
        this.cancelCallback_ = cancelCallback_;
        this.context_ = context_;
    }
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.respondsTo = function (eventType) {
        return eventType === 'value';
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.createEvent = function (change, query) {
        var index = query.getQueryParams().getIndex();
        return new DataEvent('value', this, new DataSnapshot(change.snapshotNode, query.getRef(), index));
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.getEventRunner = function (eventData) {
        var ctx = this.context_;
        if (eventData.getEventType() === 'cancel') {
            util.assert(this.cancelCallback_, 'Raising a cancel event on a listener with no cancel callback');
            var cancelCB_1 = this.cancelCallback_;
            return function () {
                // We know that error exists, we checked above that this is a cancel event
                cancelCB_1.call(ctx, eventData.error);
            };
        }
        else {
            var cb_1 = this.callback_;
            return function () {
                cb_1.call(ctx, eventData.snapshot);
            };
        }
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.createCancelEvent = function (error, path) {
        if (this.cancelCallback_) {
            return new CancelEvent(this, error, path);
        }
        else {
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.matches = function (other) {
        if (!(other instanceof ValueEventRegistration)) {
            return false;
        }
        else if (!other.callback_ || !this.callback_) {
            // If no callback specified, we consider it to match any callback.
            return true;
        }
        else {
            return (other.callback_ === this.callback_ && other.context_ === this.context_);
        }
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.hasAnyCallback = function () {
        return this.callback_ !== null;
    };
    return ValueEventRegistration;
}());
/**
 * Represents the registration of 1 or more child_xxx events.
 *
 * Currently, it is always exactly 1 child_xxx event, but the idea is we might let you
 * register a group of callbacks together in the future.
 *
 * @constructor
 * @implements {EventRegistration}
 */
var ChildEventRegistration = /** @class */ (function () {
    /**
     * @param {?Object.<string, function(!DataSnapshot, ?string=)>} callbacks_
     * @param {?function(Error)} cancelCallback_
     * @param {Object=} context_
     */
    function ChildEventRegistration(callbacks_, cancelCallback_, context_) {
        this.callbacks_ = callbacks_;
        this.cancelCallback_ = cancelCallback_;
        this.context_ = context_;
    }
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.respondsTo = function (eventType) {
        var eventToCheck = eventType === 'children_added' ? 'child_added' : eventType;
        eventToCheck =
            eventToCheck === 'children_removed' ? 'child_removed' : eventToCheck;
        return util.contains(this.callbacks_, eventToCheck);
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.createCancelEvent = function (error, path) {
        if (this.cancelCallback_) {
            return new CancelEvent(this, error, path);
        }
        else {
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.createEvent = function (change, query) {
        util.assert(change.childName != null, 'Child events should have a childName.');
        var ref = query.getRef().child(/** @type {!string} */ change.childName);
        var index = query.getQueryParams().getIndex();
        return new DataEvent(change.type, this, new DataSnapshot(change.snapshotNode, ref, index), change.prevName);
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.getEventRunner = function (eventData) {
        var ctx = this.context_;
        if (eventData.getEventType() === 'cancel') {
            util.assert(this.cancelCallback_, 'Raising a cancel event on a listener with no cancel callback');
            var cancelCB_2 = this.cancelCallback_;
            return function () {
                // We know that error exists, we checked above that this is a cancel event
                cancelCB_2.call(ctx, eventData.error);
            };
        }
        else {
            var cb_2 = this.callbacks_[eventData.eventType];
            return function () {
                cb_2.call(ctx, eventData.snapshot, eventData.prevName);
            };
        }
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.matches = function (other) {
        var _this = this;
        if (other instanceof ChildEventRegistration) {
            if (!this.callbacks_ || !other.callbacks_) {
                return true;
            }
            else if (this.context_ === other.context_) {
                var otherKeys = Object.keys(other.callbacks_);
                var thisKeys = Object.keys(this.callbacks_);
                var otherCount = otherKeys.length;
                var thisCount = thisKeys.length;
                if (otherCount === thisCount) {
                    // If count is 1, do an exact match on eventType, if either is defined but null, it's a match.
                    // If event types don't match, not a match
                    // If count is not 1, exact match across all
                    if (otherCount === 1) {
                        var otherKey = otherKeys[0];
                        var thisKey = thisKeys[0];
                        return (thisKey === otherKey &&
                            (!other.callbacks_[otherKey] ||
                                !this.callbacks_[thisKey] ||
                                other.callbacks_[otherKey] === this.callbacks_[thisKey]));
                    }
                    else {
                        // Exact match on each key.
                        return thisKeys.every(function (eventType) {
                            return other.callbacks_[eventType] === _this.callbacks_[eventType];
                        });
                    }
                }
            }
        }
        return false;
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.hasAnyCallback = function () {
        return this.callbacks_ !== null;
    };
    return ChildEventRegistration;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __referenceConstructor;
/**
 * A Query represents a filter to be applied to a firebase location.  This object purely represents the
 * query expression (and exposes our public API to build the query).  The actual query logic is in ViewBase.js.
 *
 * Since every Firebase reference is a query, Firebase inherits from this object.
 */
var Query = /** @class */ (function () {
    function Query(repo, path, queryParams_, orderByCalled_) {
        this.repo = repo;
        this.path = path;
        this.queryParams_ = queryParams_;
        this.orderByCalled_ = orderByCalled_;
    }
    Object.defineProperty(Query, "__referenceConstructor", {
        get: function () {
            util.assert(__referenceConstructor, 'Reference.ts has not been loaded');
            return __referenceConstructor;
        },
        set: function (val) {
            __referenceConstructor = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Validates start/end values for queries.
     * @param {!QueryParams} params
     * @private
     */
    Query.validateQueryEndpoints_ = function (params) {
        var startNode = null;
        var endNode = null;
        if (params.hasStart()) {
            startNode = params.getIndexStartValue();
        }
        if (params.hasEnd()) {
            endNode = params.getIndexEndValue();
        }
        if (params.getIndex() === KEY_INDEX) {
            var tooManyArgsError = 'Query: When ordering by key, you may only pass one argument to ' +
                'startAt(), endAt(), or equalTo().';
            var wrongArgTypeError = 'Query: When ordering by key, the argument passed to startAt(), endAt(),' +
                'or equalTo() must be a string.';
            if (params.hasStart()) {
                var startName = params.getIndexStartName();
                if (startName != MIN_NAME) {
                    throw new Error(tooManyArgsError);
                }
                else if (typeof startNode !== 'string') {
                    throw new Error(wrongArgTypeError);
                }
            }
            if (params.hasEnd()) {
                var endName = params.getIndexEndName();
                if (endName != MAX_NAME) {
                    throw new Error(tooManyArgsError);
                }
                else if (typeof endNode !== 'string') {
                    throw new Error(wrongArgTypeError);
                }
            }
        }
        else if (params.getIndex() === PRIORITY_INDEX) {
            if ((startNode != null && !isValidPriority(startNode)) ||
                (endNode != null && !isValidPriority(endNode))) {
                throw new Error('Query: When ordering by priority, the first argument passed to startAt(), ' +
                    'endAt(), or equalTo() must be a valid priority value (null, a number, or a string).');
            }
        }
        else {
            util.assert(params.getIndex() instanceof PathIndex ||
                params.getIndex() === VALUE_INDEX, 'unknown index type.');
            if ((startNode != null && typeof startNode === 'object') ||
                (endNode != null && typeof endNode === 'object')) {
                throw new Error('Query: First argument passed to startAt(), endAt(), or equalTo() cannot be ' +
                    'an object.');
            }
        }
    };
    /**
     * Validates that limit* has been called with the correct combination of parameters
     * @param {!QueryParams} params
     * @private
     */
    Query.validateLimit_ = function (params) {
        if (params.hasStart() &&
            params.hasEnd() &&
            params.hasLimit() &&
            !params.hasAnchoredLimit()) {
            throw new Error("Query: Can't combine startAt(), endAt(), and limit(). Use limitToFirst() or limitToLast() instead.");
        }
    };
    /**
     * Validates that no other order by call has been made
     * @param {!string} fnName
     * @private
     */
    Query.prototype.validateNoPreviousOrderByCall_ = function (fnName) {
        if (this.orderByCalled_ === true) {
            throw new Error(fnName + ": You can't combine multiple orderBy calls.");
        }
    };
    /**
     * @return {!QueryParams}
     */
    Query.prototype.getQueryParams = function () {
        return this.queryParams_;
    };
    /**
     * @return {!Reference}
     */
    Query.prototype.getRef = function () {
        util.validateArgCount('Query.ref', 0, 0, arguments.length);
        // This is a slight hack. We cannot goog.require('fb.api.Firebase'), since Firebase requires fb.api.Query.
        // However, we will always export 'Firebase' to the global namespace, so it's guaranteed to exist by the time this
        // method gets called.
        return new Query.__referenceConstructor(this.repo, this.path);
    };
    /**
     * @param {!string} eventType
     * @param {!function(DataSnapshot, string=)} callback
     * @param {(function(Error)|Object)=} cancelCallbackOrContext
     * @param {Object=} context
     * @return {!function(DataSnapshot, string=)}
     */
    Query.prototype.on = function (eventType, callback, cancelCallbackOrContext, context) {
        util.validateArgCount('Query.on', 2, 4, arguments.length);
        validateEventType('Query.on', 1, eventType, false);
        util.validateCallback('Query.on', 2, callback, false);
        var ret = Query.getCancelAndContextArgs_('Query.on', cancelCallbackOrContext, context);
        if (eventType === 'value') {
            this.onValueEvent(callback, ret.cancel, ret.context);
        }
        else {
            var callbacks = {};
            callbacks[eventType] = callback;
            this.onChildEvent(callbacks, ret.cancel, ret.context);
        }
        return callback;
    };
    /**
     * @param {!function(!DataSnapshot)} callback
     * @param {?function(Error)} cancelCallback
     * @param {?Object} context
     * @protected
     */
    Query.prototype.onValueEvent = function (callback, cancelCallback, context) {
        var container = new ValueEventRegistration(callback, cancelCallback || null, context || null);
        this.repo.addEventCallbackForQuery(this, container);
    };
    /**
     * @param {!Object.<string, !function(!DataSnapshot, ?string)>} callbacks
     * @param {?function(Error)} cancelCallback
     * @param {?Object} context
     * @protected
     */
    Query.prototype.onChildEvent = function (callbacks, cancelCallback, context) {
        var container = new ChildEventRegistration(callbacks, cancelCallback, context);
        this.repo.addEventCallbackForQuery(this, container);
    };
    /**
     * @param {string=} eventType
     * @param {(function(!DataSnapshot, ?string=))=} callback
     * @param {Object=} context
     */
    Query.prototype.off = function (eventType, callback, context) {
        util.validateArgCount('Query.off', 0, 3, arguments.length);
        validateEventType('Query.off', 1, eventType, true);
        util.validateCallback('Query.off', 2, callback, true);
        util.validateContextObject('Query.off', 3, context, true);
        var container = null;
        var callbacks = null;
        if (eventType === 'value') {
            var valueCallback = callback || null;
            container = new ValueEventRegistration(valueCallback, null, context || null);
        }
        else if (eventType) {
            if (callback) {
                callbacks = {};
                callbacks[eventType] = callback;
            }
            container = new ChildEventRegistration(callbacks, null, context || null);
        }
        this.repo.removeEventCallbackForQuery(this, container);
    };
    /**
     * Attaches a listener, waits for the first event, and then removes the listener
     * @param {!string} eventType
     * @param {!function(!DataSnapshot, string=)} userCallback
     * @param failureCallbackOrContext
     * @param context
     * @return {!firebase.Promise}
     */
    Query.prototype.once = function (eventType, userCallback, failureCallbackOrContext, context) {
        var _this = this;
        util.validateArgCount('Query.once', 1, 4, arguments.length);
        validateEventType('Query.once', 1, eventType, false);
        util.validateCallback('Query.once', 2, userCallback, true);
        var ret = Query.getCancelAndContextArgs_('Query.once', failureCallbackOrContext, context);
        // TODO: Implement this more efficiently (in particular, use 'get' wire protocol for 'value' event)
        // TODO: consider actually wiring the callbacks into the promise. We cannot do this without a breaking change
        // because the API currently expects callbacks will be called synchronously if the data is cached, but this is
        // against the Promise specification.
        var firstCall = true;
        var deferred = new util.Deferred();
        // A dummy error handler in case a user wasn't expecting promises
        deferred.promise.catch(function () { });
        var onceCallback = function (snapshot) {
            // NOTE: Even though we unsubscribe, we may get called multiple times if a single action (e.g. set() with JSON)
            // triggers multiple events (e.g. child_added or child_changed).
            if (firstCall) {
                firstCall = false;
                _this.off(eventType, onceCallback);
                if (userCallback) {
                    userCallback.bind(ret.context)(snapshot);
                }
                deferred.resolve(snapshot);
            }
        };
        this.on(eventType, onceCallback, 
        /*cancel=*/ function (err) {
            _this.off(eventType, onceCallback);
            if (ret.cancel)
                ret.cancel.bind(ret.context)(err);
            deferred.reject(err);
        });
        return deferred.promise;
    };
    /**
     * Set a limit and anchor it to the start of the window.
     * @param {!number} limit
     * @return {!Query}
     */
    Query.prototype.limitToFirst = function (limit) {
        util.validateArgCount('Query.limitToFirst', 1, 1, arguments.length);
        if (typeof limit !== 'number' ||
            Math.floor(limit) !== limit ||
            limit <= 0) {
            throw new Error('Query.limitToFirst: First argument must be a positive integer.');
        }
        if (this.queryParams_.hasLimit()) {
            throw new Error('Query.limitToFirst: Limit was already set (by another call to limit, ' +
                'limitToFirst, or limitToLast).');
        }
        return new Query(this.repo, this.path, this.queryParams_.limitToFirst(limit), this.orderByCalled_);
    };
    /**
     * Set a limit and anchor it to the end of the window.
     * @param {!number} limit
     * @return {!Query}
     */
    Query.prototype.limitToLast = function (limit) {
        util.validateArgCount('Query.limitToLast', 1, 1, arguments.length);
        if (typeof limit !== 'number' ||
            Math.floor(limit) !== limit ||
            limit <= 0) {
            throw new Error('Query.limitToLast: First argument must be a positive integer.');
        }
        if (this.queryParams_.hasLimit()) {
            throw new Error('Query.limitToLast: Limit was already set (by another call to limit, ' +
                'limitToFirst, or limitToLast).');
        }
        return new Query(this.repo, this.path, this.queryParams_.limitToLast(limit), this.orderByCalled_);
    };
    /**
     * Given a child path, return a new query ordered by the specified grandchild path.
     * @param {!string} path
     * @return {!Query}
     */
    Query.prototype.orderByChild = function (path) {
        util.validateArgCount('Query.orderByChild', 1, 1, arguments.length);
        if (path === '$key') {
            throw new Error('Query.orderByChild: "$key" is invalid.  Use Query.orderByKey() instead.');
        }
        else if (path === '$priority') {
            throw new Error('Query.orderByChild: "$priority" is invalid.  Use Query.orderByPriority() instead.');
        }
        else if (path === '$value') {
            throw new Error('Query.orderByChild: "$value" is invalid.  Use Query.orderByValue() instead.');
        }
        validatePathString('Query.orderByChild', 1, path, false);
        this.validateNoPreviousOrderByCall_('Query.orderByChild');
        var parsedPath = new Path(path);
        if (parsedPath.isEmpty()) {
            throw new Error('Query.orderByChild: cannot pass in empty path.  Use Query.orderByValue() instead.');
        }
        var index = new PathIndex(parsedPath);
        var newParams = this.queryParams_.orderBy(index);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * Return a new query ordered by the KeyIndex
     * @return {!Query}
     */
    Query.prototype.orderByKey = function () {
        util.validateArgCount('Query.orderByKey', 0, 0, arguments.length);
        this.validateNoPreviousOrderByCall_('Query.orderByKey');
        var newParams = this.queryParams_.orderBy(KEY_INDEX);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * Return a new query ordered by the PriorityIndex
     * @return {!Query}
     */
    Query.prototype.orderByPriority = function () {
        util.validateArgCount('Query.orderByPriority', 0, 0, arguments.length);
        this.validateNoPreviousOrderByCall_('Query.orderByPriority');
        var newParams = this.queryParams_.orderBy(PRIORITY_INDEX);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * Return a new query ordered by the ValueIndex
     * @return {!Query}
     */
    Query.prototype.orderByValue = function () {
        util.validateArgCount('Query.orderByValue', 0, 0, arguments.length);
        this.validateNoPreviousOrderByCall_('Query.orderByValue');
        var newParams = this.queryParams_.orderBy(VALUE_INDEX);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * @param {number|string|boolean|null} value
     * @param {?string=} name
     * @return {!Query}
     */
    Query.prototype.startAt = function (value, name) {
        if (value === void 0) { value = null; }
        util.validateArgCount('Query.startAt', 0, 2, arguments.length);
        validateFirebaseDataArg('Query.startAt', 1, value, this.path, true);
        validateKey('Query.startAt', 2, name, true);
        var newParams = this.queryParams_.startAt(value, name);
        Query.validateLimit_(newParams);
        Query.validateQueryEndpoints_(newParams);
        if (this.queryParams_.hasStart()) {
            throw new Error('Query.startAt: Starting point was already set (by another call to startAt ' +
                'or equalTo).');
        }
        // Calling with no params tells us to start at the beginning.
        if (value === undefined) {
            value = null;
            name = null;
        }
        return new Query(this.repo, this.path, newParams, this.orderByCalled_);
    };
    /**
     * @param {number|string|boolean|null} value
     * @param {?string=} name
     * @return {!Query}
     */
    Query.prototype.endAt = function (value, name) {
        if (value === void 0) { value = null; }
        util.validateArgCount('Query.endAt', 0, 2, arguments.length);
        validateFirebaseDataArg('Query.endAt', 1, value, this.path, true);
        validateKey('Query.endAt', 2, name, true);
        var newParams = this.queryParams_.endAt(value, name);
        Query.validateLimit_(newParams);
        Query.validateQueryEndpoints_(newParams);
        if (this.queryParams_.hasEnd()) {
            throw new Error('Query.endAt: Ending point was already set (by another call to endAt or ' +
                'equalTo).');
        }
        return new Query(this.repo, this.path, newParams, this.orderByCalled_);
    };
    /**
     * Load the selection of children with exactly the specified value, and, optionally,
     * the specified name.
     * @param {number|string|boolean|null} value
     * @param {string=} name
     * @return {!Query}
     */
    Query.prototype.equalTo = function (value, name) {
        util.validateArgCount('Query.equalTo', 1, 2, arguments.length);
        validateFirebaseDataArg('Query.equalTo', 1, value, this.path, false);
        validateKey('Query.equalTo', 2, name, true);
        if (this.queryParams_.hasStart()) {
            throw new Error('Query.equalTo: Starting point was already set (by another call to startAt or ' +
                'equalTo).');
        }
        if (this.queryParams_.hasEnd()) {
            throw new Error('Query.equalTo: Ending point was already set (by another call to endAt or ' +
                'equalTo).');
        }
        return this.startAt(value, name).endAt(value, name);
    };
    /**
     * @return {!string} URL for this location.
     */
    Query.prototype.toString = function () {
        util.validateArgCount('Query.toString', 0, 0, arguments.length);
        return this.repo.toString() + this.path.toUrlEncodedString();
    };
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users.
    Query.prototype.toJSON = function () {
        // An optional spacer argument is unnecessary for a string.
        util.validateArgCount('Query.toJSON', 0, 1, arguments.length);
        return this.toString();
    };
    /**
     * An object representation of the query parameters used by this Query.
     * @return {!Object}
     */
    Query.prototype.queryObject = function () {
        return this.queryParams_.getQueryObject();
    };
    /**
     * @return {!string}
     */
    Query.prototype.queryIdentifier = function () {
        var obj = this.queryObject();
        var id = ObjectToUniqueKey(obj);
        return id === '{}' ? 'default' : id;
    };
    /**
     * Return true if this query and the provided query are equivalent; otherwise, return false.
     * @param {Query} other
     * @return {boolean}
     */
    Query.prototype.isEqual = function (other) {
        util.validateArgCount('Query.isEqual', 1, 1, arguments.length);
        if (!(other instanceof Query)) {
            var error = 'Query.isEqual failed: First argument must be an instance of firebase.database.Query.';
            throw new Error(error);
        }
        var sameRepo = this.repo === other.repo;
        var samePath = this.path.equals(other.path);
        var sameQueryIdentifier = this.queryIdentifier() === other.queryIdentifier();
        return sameRepo && samePath && sameQueryIdentifier;
    };
    /**
     * Helper used by .on and .once to extract the context and or cancel arguments.
     * @param {!string} fnName The function name (on or once)
     * @param {(function(Error)|Object)=} cancelOrContext
     * @param {Object=} context
     * @return {{cancel: ?function(Error), context: ?Object}}
     * @private
     */
    Query.getCancelAndContextArgs_ = function (fnName, cancelOrContext, context) {
        var ret = { cancel: null, context: null };
        if (cancelOrContext && context) {
            ret.cancel = cancelOrContext;
            util.validateCallback(fnName, 3, ret.cancel, true);
            ret.context = context;
            util.validateContextObject(fnName, 4, ret.context, true);
        }
        else if (cancelOrContext) {
            // we have either a cancel callback or a context.
            if (typeof cancelOrContext === 'object' && cancelOrContext !== null) {
                // it's a context!
                ret.context = cancelOrContext;
            }
            else if (typeof cancelOrContext === 'function') {
                ret.cancel = cancelOrContext;
            }
            else {
                throw new Error(util.errorPrefix(fnName, 3, true) +
                    ' must either be a cancel callback or a context object.');
            }
        }
        return ret;
    };
    Object.defineProperty(Query.prototype, "ref", {
        get: function () {
            return this.getRef();
        },
        enumerable: true,
        configurable: true
    });
    return Query;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Helper class to store a sparse set of snapshots.
 */
var SparseSnapshotTree = /** @class */ (function () {
    function SparseSnapshotTree() {
        this.value = null;
        this.children = new Map();
    }
    /**
     * Gets the node stored at the given path if one exists.
     *
     * @param path Path to look up snapshot for.
     * @return The retrieved node, or null.
     */
    SparseSnapshotTree.prototype.find = function (path) {
        if (this.value != null) {
            return this.value.getChild(path);
        }
        else if (!path.isEmpty() && this.children.size > 0) {
            var childKey = path.getFront();
            path = path.popFront();
            if (this.children.has(childKey)) {
                var childTree = this.children.get(childKey);
                return childTree.find(path);
            }
            else {
                return null;
            }
        }
        else {
            return null;
        }
    };
    /**
     * Stores the given node at the specified path. If there is already a node
     * at a shallower path, it merges the new data into that snapshot node.
     *
     * @param path Path to look up snapshot for.
     * @param data The new data, or null.
     */
    SparseSnapshotTree.prototype.remember = function (path, data) {
        if (path.isEmpty()) {
            this.value = data;
            this.children.clear();
        }
        else if (this.value !== null) {
            this.value = this.value.updateChild(path, data);
        }
        else {
            var childKey = path.getFront();
            if (!this.children.has(childKey)) {
                this.children.set(childKey, new SparseSnapshotTree());
            }
            var child = this.children.get(childKey);
            path = path.popFront();
            child.remember(path, data);
        }
    };
    /**
     * Purge the data at path from the cache.
     *
     * @param path Path to look up snapshot for.
     * @return True if this node should now be removed.
     */
    SparseSnapshotTree.prototype.forget = function (path) {
        if (path.isEmpty()) {
            this.value = null;
            this.children.clear();
            return true;
        }
        else {
            if (this.value !== null) {
                if (this.value.isLeafNode()) {
                    // We're trying to forget a node that doesn't exist
                    return false;
                }
                else {
                    var value = this.value;
                    this.value = null;
                    var self_1 = this;
                    value.forEachChild(PRIORITY_INDEX, function (key, tree) {
                        self_1.remember(new Path(key), tree);
                    });
                    return this.forget(path);
                }
            }
            else if (this.children.size > 0) {
                var childKey = path.getFront();
                path = path.popFront();
                if (this.children.has(childKey)) {
                    var safeToRemove = this.children.get(childKey).forget(path);
                    if (safeToRemove) {
                        this.children.delete(childKey);
                    }
                }
                return this.children.size === 0;
            }
            else {
                return true;
            }
        }
    };
    /**
     * Recursively iterates through all of the stored tree and calls the
     * callback on each one.
     *
     * @param prefixPath Path to look up node for.
     * @param func The function to invoke for each tree.
     */
    SparseSnapshotTree.prototype.forEachTree = function (prefixPath, func) {
        if (this.value !== null) {
            func(prefixPath, this.value);
        }
        else {
            this.forEachChild(function (key, tree) {
                var path = new Path(prefixPath.toString() + '/' + key);
                tree.forEachTree(path, func);
            });
        }
    };
    /**
     * Iterates through each immediate child and triggers the callback.
     *
     * @param func The function to invoke for each child.
     */
    SparseSnapshotTree.prototype.forEachChild = function (func) {
        this.children.forEach(function (tree, key) {
            func(key, tree);
        });
    };
    return SparseSnapshotTree;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Generate placeholders for deferred values.
 * @param {?Object} values
 * @return {!Object}
 */
var generateWithValues = function (values) {
    values = values || {};
    values['timestamp'] = values['timestamp'] || new Date().getTime();
    return values;
};
/**
 * Value to use when firing local events. When writing server values, fire
 * local events with an approximate value, otherwise return value as-is.
 * @param {(Object|string|number|boolean)} value
 * @param {!Object} serverValues
 * @return {!(string|number|boolean)}
 */
var resolveDeferredValue = function (value, serverValues) {
    if (!value || typeof value !== 'object') {
        return value;
    }
    else {
        util.assert('.sv' in value, 'Unexpected leaf node or priority contents');
        return serverValues[value['.sv']];
    }
};
/**
 * Recursively replace all deferred values and priorities in the tree with the
 * specified generated replacement values.
 * @param {!SparseSnapshotTree} tree
 * @param {!Object} serverValues
 * @return {!SparseSnapshotTree}
 */
var resolveDeferredValueTree = function (tree, serverValues) {
    var resolvedTree = new SparseSnapshotTree();
    tree.forEachTree(new Path(''), function (path, node) {
        resolvedTree.remember(path, resolveDeferredValueSnapshot(node, serverValues));
    });
    return resolvedTree;
};
/**
 * Recursively replace all deferred values and priorities in the node with the
 * specified generated replacement values.  If there are no server values in the node,
 * it'll be returned as-is.
 * @param {!Node} node
 * @param {!Object} serverValues
 * @return {!Node}
 */
var resolveDeferredValueSnapshot = function (node, serverValues) {
    var rawPri = node.getPriority().val();
    var priority = resolveDeferredValue(rawPri, serverValues);
    var newNode;
    if (node.isLeafNode()) {
        var leafNode = node;
        var value = resolveDeferredValue(leafNode.getValue(), serverValues);
        if (value !== leafNode.getValue() ||
            priority !== leafNode.getPriority().val()) {
            return new LeafNode(value, nodeFromJSON$1(priority));
        }
        else {
            return node;
        }
    }
    else {
        var childrenNode = node;
        newNode = childrenNode;
        if (priority !== childrenNode.getPriority().val()) {
            newNode = newNode.updatePriority(new LeafNode(priority));
        }
        childrenNode.forEachChild(PRIORITY_INDEX, function (childName, childNode) {
            var newChildNode = resolveDeferredValueSnapshot(childNode, serverValues);
            if (newChildNode !== childNode) {
                newNode = newNode.updateImmediateChild(childName, newChildNode);
            }
        });
        return newNode;
    }
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 *
 * @enum
 */
var OperationType;
(function (OperationType) {
    OperationType[OperationType["OVERWRITE"] = 0] = "OVERWRITE";
    OperationType[OperationType["MERGE"] = 1] = "MERGE";
    OperationType[OperationType["ACK_USER_WRITE"] = 2] = "ACK_USER_WRITE";
    OperationType[OperationType["LISTEN_COMPLETE"] = 3] = "LISTEN_COMPLETE";
})(OperationType || (OperationType = {}));
/**
 * @param {boolean} fromUser
 * @param {boolean} fromServer
 * @param {?string} queryId
 * @param {boolean} tagged
 * @constructor
 */
var OperationSource = /** @class */ (function () {
    function OperationSource(fromUser, fromServer, queryId, tagged) {
        this.fromUser = fromUser;
        this.fromServer = fromServer;
        this.queryId = queryId;
        this.tagged = tagged;
        util.assert(!tagged || fromServer, 'Tagged queries must be from server.');
    }
    /**
     * @const
     * @type {!OperationSource}
     */
    OperationSource.User = new OperationSource(
    /*fromUser=*/ true, false, null, 
    /*tagged=*/ false);
    /**
     * @const
     * @type {!OperationSource}
     */
    OperationSource.Server = new OperationSource(false, 
    /*fromServer=*/ true, null, 
    /*tagged=*/ false);
    /**
     * @param {string} queryId
     * @return {!OperationSource}
     */
    OperationSource.forServerTaggedQuery = function (queryId) {
        return new OperationSource(false, 
        /*fromServer=*/ true, queryId, 
        /*tagged=*/ true);
    };
    return OperationSource;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var AckUserWrite = /** @class */ (function () {
    /**
     *
     * @param {!Path} path
     * @param {!ImmutableTree<!boolean>} affectedTree A tree containing true for each affected path. Affected paths can't overlap.
     * @param {!boolean} revert
     */
    function AckUserWrite(
    /**@inheritDoc */ path, 
    /**@inheritDoc */ affectedTree, 
    /**@inheritDoc */ revert) {
        this.path = path;
        this.affectedTree = affectedTree;
        this.revert = revert;
        /** @inheritDoc */
        this.type = OperationType.ACK_USER_WRITE;
        /** @inheritDoc */
        this.source = OperationSource.User;
    }
    /**
     * @inheritDoc
     */
    AckUserWrite.prototype.operationForChild = function (childName) {
        if (!this.path.isEmpty()) {
            util.assert(this.path.getFront() === childName, 'operationForChild called for unrelated child.');
            return new AckUserWrite(this.path.popFront(), this.affectedTree, this.revert);
        }
        else if (this.affectedTree.value != null) {
            util.assert(this.affectedTree.children.isEmpty(), 'affectedTree should not have overlapping affected paths.');
            // All child locations are affected as well; just return same operation.
            return this;
        }
        else {
            var childTree = this.affectedTree.subtree(new Path(childName));
            return new AckUserWrite(Path.Empty, childTree, this.revert);
        }
    };
    return AckUserWrite;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var emptyChildrenSingleton;
/**
 * Singleton empty children collection.
 *
 * @const
 * @type {!SortedMap.<string, !ImmutableTree.<?>>}
 */
var EmptyChildren = function () {
    if (!emptyChildrenSingleton) {
        emptyChildrenSingleton = new SortedMap(stringCompare);
    }
    return emptyChildrenSingleton;
};
/**
 * A tree with immutable elements.
 */
var ImmutableTree = /** @class */ (function () {
    /**
     * @template T
     * @param {?T} value
     * @param {SortedMap.<string, !ImmutableTree.<T>>=} children
     */
    function ImmutableTree(value, children) {
        if (children === void 0) { children = EmptyChildren(); }
        this.value = value;
        this.children = children;
    }
    /**
     * @template T
     * @param {!Object.<string, !T>} obj
     * @return {!ImmutableTree.<!T>}
     */
    ImmutableTree.fromObject = function (obj) {
        var tree = ImmutableTree.Empty;
        each(obj, function (childPath, childSnap) {
            tree = tree.set(new Path(childPath), childSnap);
        });
        return tree;
    };
    /**
     * True if the value is empty and there are no children
     * @return {boolean}
     */
    ImmutableTree.prototype.isEmpty = function () {
        return this.value === null && this.children.isEmpty();
    };
    /**
     * Given a path and predicate, return the first node and the path to that node
     * where the predicate returns true.
     *
     * TODO Do a perf test -- If we're creating a bunch of {path: value:} objects
     * on the way back out, it may be better to pass down a pathSoFar obj.
     *
     * @param {!Path} relativePath The remainder of the path
     * @param {function(T):boolean} predicate The predicate to satisfy to return a
     *   node
     * @return {?{path:!Path, value:!T}}
     */
    ImmutableTree.prototype.findRootMostMatchingPathAndValue = function (relativePath, predicate) {
        if (this.value != null && predicate(this.value)) {
            return { path: Path.Empty, value: this.value };
        }
        else {
            if (relativePath.isEmpty()) {
                return null;
            }
            else {
                var front = relativePath.getFront();
                var child = this.children.get(front);
                if (child !== null) {
                    var childExistingPathAndValue = child.findRootMostMatchingPathAndValue(relativePath.popFront(), predicate);
                    if (childExistingPathAndValue != null) {
                        var fullPath = new Path(front).child(childExistingPathAndValue.path);
                        return { path: fullPath, value: childExistingPathAndValue.value };
                    }
                    else {
                        return null;
                    }
                }
                else {
                    return null;
                }
            }
        }
    };
    /**
     * Find, if it exists, the shortest subpath of the given path that points a defined
     * value in the tree
     * @param {!Path} relativePath
     * @return {?{path: !Path, value: !T}}
     */
    ImmutableTree.prototype.findRootMostValueAndPath = function (relativePath) {
        return this.findRootMostMatchingPathAndValue(relativePath, function () { return true; });
    };
    /**
     * @param {!Path} relativePath
     * @return {!ImmutableTree.<T>} The subtree at the given path
     */
    ImmutableTree.prototype.subtree = function (relativePath) {
        if (relativePath.isEmpty()) {
            return this;
        }
        else {
            var front = relativePath.getFront();
            var childTree = this.children.get(front);
            if (childTree !== null) {
                return childTree.subtree(relativePath.popFront());
            }
            else {
                return ImmutableTree.Empty;
            }
        }
    };
    /**
     * Sets a value at the specified path.
     *
     * @param {!Path} relativePath Path to set value at.
     * @param {?T} toSet Value to set.
     * @return {!ImmutableTree.<T>} Resulting tree.
     */
    ImmutableTree.prototype.set = function (relativePath, toSet) {
        if (relativePath.isEmpty()) {
            return new ImmutableTree(toSet, this.children);
        }
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front) || ImmutableTree.Empty;
            var newChild = child.set(relativePath.popFront(), toSet);
            var newChildren = this.children.insert(front, newChild);
            return new ImmutableTree(this.value, newChildren);
        }
    };
    /**
     * Removes the value at the specified path.
     *
     * @param {!Path} relativePath Path to value to remove.
     * @return {!ImmutableTree.<T>} Resulting tree.
     */
    ImmutableTree.prototype.remove = function (relativePath) {
        if (relativePath.isEmpty()) {
            if (this.children.isEmpty()) {
                return ImmutableTree.Empty;
            }
            else {
                return new ImmutableTree(null, this.children);
            }
        }
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front);
            if (child) {
                var newChild = child.remove(relativePath.popFront());
                var newChildren = void 0;
                if (newChild.isEmpty()) {
                    newChildren = this.children.remove(front);
                }
                else {
                    newChildren = this.children.insert(front, newChild);
                }
                if (this.value === null && newChildren.isEmpty()) {
                    return ImmutableTree.Empty;
                }
                else {
                    return new ImmutableTree(this.value, newChildren);
                }
            }
            else {
                return this;
            }
        }
    };
    /**
     * Gets a value from the tree.
     *
     * @param {!Path} relativePath Path to get value for.
     * @return {?T} Value at path, or null.
     */
    ImmutableTree.prototype.get = function (relativePath) {
        if (relativePath.isEmpty()) {
            return this.value;
        }
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front);
            if (child) {
                return child.get(relativePath.popFront());
            }
            else {
                return null;
            }
        }
    };
    /**
     * Replace the subtree at the specified path with the given new tree.
     *
     * @param {!Path} relativePath Path to replace subtree for.
     * @param {!ImmutableTree} newTree New tree.
     * @return {!ImmutableTree} Resulting tree.
     */
    ImmutableTree.prototype.setTree = function (relativePath, newTree) {
        if (relativePath.isEmpty()) {
            return newTree;
        }
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front) || ImmutableTree.Empty;
            var newChild = child.setTree(relativePath.popFront(), newTree);
            var newChildren = void 0;
            if (newChild.isEmpty()) {
                newChildren = this.children.remove(front);
            }
            else {
                newChildren = this.children.insert(front, newChild);
            }
            return new ImmutableTree(this.value, newChildren);
        }
    };
    /**
     * Performs a depth first fold on this tree. Transforms a tree into a single
     * value, given a function that operates on the path to a node, an optional
     * current value, and a map of child names to folded subtrees
     * @template V
     * @param {function(Path, ?T, Object.<string, V>):V} fn
     * @return {V}
     */
    ImmutableTree.prototype.fold = function (fn) {
        return this.fold_(Path.Empty, fn);
    };
    /**
     * Recursive helper for public-facing fold() method
     * @template V
     * @param {!Path} pathSoFar
     * @param {function(Path, ?T, Object.<string, V>):V} fn
     * @return {V}
     * @private
     */
    ImmutableTree.prototype.fold_ = function (pathSoFar, fn) {
        var accum = {};
        this.children.inorderTraversal(function (childKey, childTree) {
            accum[childKey] = childTree.fold_(pathSoFar.child(childKey), fn);
        });
        return fn(pathSoFar, this.value, accum);
    };
    /**
     * Find the first matching value on the given path. Return the result of applying f to it.
     * @template V
     * @param {!Path} path
     * @param {!function(!Path, !T):?V} f
     * @return {?V}
     */
    ImmutableTree.prototype.findOnPath = function (path, f) {
        return this.findOnPath_(path, Path.Empty, f);
    };
    ImmutableTree.prototype.findOnPath_ = function (pathToFollow, pathSoFar, f) {
        var result = this.value ? f(pathSoFar, this.value) : false;
        if (result) {
            return result;
        }
        else {
            if (pathToFollow.isEmpty()) {
                return null;
            }
            else {
                var front = pathToFollow.getFront();
                var nextChild = this.children.get(front);
                if (nextChild) {
                    return nextChild.findOnPath_(pathToFollow.popFront(), pathSoFar.child(front), f);
                }
                else {
                    return null;
                }
            }
        }
    };
    /**
     *
     * @param {!Path} path
     * @param {!function(!Path, !T)} f
     * @returns {!ImmutableTree.<T>}
     */
    ImmutableTree.prototype.foreachOnPath = function (path, f) {
        return this.foreachOnPath_(path, Path.Empty, f);
    };
    ImmutableTree.prototype.foreachOnPath_ = function (pathToFollow, currentRelativePath, f) {
        if (pathToFollow.isEmpty()) {
            return this;
        }
        else {
            if (this.value) {
                f(currentRelativePath, this.value);
            }
            var front = pathToFollow.getFront();
            var nextChild = this.children.get(front);
            if (nextChild) {
                return nextChild.foreachOnPath_(pathToFollow.popFront(), currentRelativePath.child(front), f);
            }
            else {
                return ImmutableTree.Empty;
            }
        }
    };
    /**
     * Calls the given function for each node in the tree that has a value.
     *
     * @param {function(!Path, !T)} f A function to be called with
     *   the path from the root of the tree to a node, and the value at that node.
     *   Called in depth-first order.
     */
    ImmutableTree.prototype.foreach = function (f) {
        this.foreach_(Path.Empty, f);
    };
    ImmutableTree.prototype.foreach_ = function (currentRelativePath, f) {
        this.children.inorderTraversal(function (childName, childTree) {
            childTree.foreach_(currentRelativePath.child(childName), f);
        });
        if (this.value) {
            f(currentRelativePath, this.value);
        }
    };
    /**
     *
     * @param {function(string, !T)} f
     */
    ImmutableTree.prototype.foreachChild = function (f) {
        this.children.inorderTraversal(function (childName, childTree) {
            if (childTree.value) {
                f(childName, childTree.value);
            }
        });
    };
    ImmutableTree.Empty = new ImmutableTree(null);
    return ImmutableTree;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param {!OperationSource} source
 * @param {!Path} path
 * @constructor
 * @implements {Operation}
 */
var ListenComplete = /** @class */ (function () {
    function ListenComplete(source, path) {
        this.source = source;
        this.path = path;
        /** @inheritDoc */
        this.type = OperationType.LISTEN_COMPLETE;
    }
    ListenComplete.prototype.operationForChild = function (childName) {
        if (this.path.isEmpty()) {
            return new ListenComplete(this.source, Path.Empty);
        }
        else {
            return new ListenComplete(this.source, this.path.popFront());
        }
    };
    return ListenComplete;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param {!OperationSource} source
 * @param {!Path} path
 * @param {!Node} snap
 * @constructor
 * @implements {Operation}
 */
var Overwrite = /** @class */ (function () {
    function Overwrite(source, path, snap) {
        this.source = source;
        this.path = path;
        this.snap = snap;
        /** @inheritDoc */
        this.type = OperationType.OVERWRITE;
    }
    Overwrite.prototype.operationForChild = function (childName) {
        if (this.path.isEmpty()) {
            return new Overwrite(this.source, Path.Empty, this.snap.getImmediateChild(childName));
        }
        else {
            return new Overwrite(this.source, this.path.popFront(), this.snap);
        }
    };
    return Overwrite;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param {!OperationSource} source
 * @param {!Path} path
 * @param {!ImmutableTree.<!Node>} children
 * @constructor
 * @implements {Operation}
 */
var Merge = /** @class */ (function () {
    function Merge(
    /**@inheritDoc */ source, 
    /**@inheritDoc */ path, 
    /**@inheritDoc */ children) {
        this.source = source;
        this.path = path;
        this.children = children;
        /** @inheritDoc */
        this.type = OperationType.MERGE;
    }
    /**
     * @inheritDoc
     */
    Merge.prototype.operationForChild = function (childName) {
        if (this.path.isEmpty()) {
            var childTree = this.children.subtree(new Path(childName));
            if (childTree.isEmpty()) {
                // This child is unaffected
                return null;
            }
            else if (childTree.value) {
                // We have a snapshot for the child in question.  This becomes an overwrite of the child.
                return new Overwrite(this.source, Path.Empty, childTree.value);
            }
            else {
                // This is a merge at a deeper level
                return new Merge(this.source, Path.Empty, childTree);
            }
        }
        else {
            util.assert(this.path.getFront() === childName, "Can't get a merge for a child not on the path of the operation");
            return new Merge(this.source, this.path.popFront(), this.children);
        }
    };
    /**
     * @inheritDoc
     */
    Merge.prototype.toString = function () {
        return ('Operation(' +
            this.path +
            ': ' +
            this.source.toString() +
            ' merge: ' +
            this.children.toString() +
            ')');
    };
    return Merge;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A cache node only stores complete children. Additionally it holds a flag whether the node can be considered fully
 * initialized in the sense that we know at one point in time this represented a valid state of the world, e.g.
 * initialized with data from the server, or a complete overwrite by the client. The filtered flag also tracks
 * whether a node potentially had children removed due to a filter.
 */
var CacheNode = /** @class */ (function () {
    /**
     * @param {!Node} node_
     * @param {boolean} fullyInitialized_
     * @param {boolean} filtered_
     */
    function CacheNode(node_, fullyInitialized_, filtered_) {
        this.node_ = node_;
        this.fullyInitialized_ = fullyInitialized_;
        this.filtered_ = filtered_;
    }
    /**
     * Returns whether this node was fully initialized with either server data or a complete overwrite by the client
     * @return {boolean}
     */
    CacheNode.prototype.isFullyInitialized = function () {
        return this.fullyInitialized_;
    };
    /**
     * Returns whether this node is potentially missing children due to a filter applied to the node
     * @return {boolean}
     */
    CacheNode.prototype.isFiltered = function () {
        return this.filtered_;
    };
    /**
     * @param {!Path} path
     * @return {boolean}
     */
    CacheNode.prototype.isCompleteForPath = function (path) {
        if (path.isEmpty()) {
            return this.isFullyInitialized() && !this.filtered_;
        }
        var childKey = path.getFront();
        return this.isCompleteForChild(childKey);
    };
    /**
     * @param {!string} key
     * @return {boolean}
     */
    CacheNode.prototype.isCompleteForChild = function (key) {
        return ((this.isFullyInitialized() && !this.filtered_) || this.node_.hasChild(key));
    };
    /**
     * @return {!Node}
     */
    CacheNode.prototype.getNode = function () {
        return this.node_;
    };
    return CacheNode;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Stores the data we have cached for a view.
 *
 * serverSnap is the cached server data, eventSnap is the cached event data (server data plus any local writes).
 *
 * @constructor
 */
var ViewCache = /** @class */ (function () {
    /**
     *
     * @param {!CacheNode} eventCache_
     * @param {!CacheNode} serverCache_
     */
    function ViewCache(eventCache_, serverCache_) {
        this.eventCache_ = eventCache_;
        this.serverCache_ = serverCache_;
    }
    /**
     * @param {!Node} eventSnap
     * @param {boolean} complete
     * @param {boolean} filtered
     * @return {!ViewCache}
     */
    ViewCache.prototype.updateEventSnap = function (eventSnap, complete, filtered) {
        return new ViewCache(new CacheNode(eventSnap, complete, filtered), this.serverCache_);
    };
    /**
     * @param {!Node} serverSnap
     * @param {boolean} complete
     * @param {boolean} filtered
     * @return {!ViewCache}
     */
    ViewCache.prototype.updateServerSnap = function (serverSnap, complete, filtered) {
        return new ViewCache(this.eventCache_, new CacheNode(serverSnap, complete, filtered));
    };
    /**
     * @return {!CacheNode}
     */
    ViewCache.prototype.getEventCache = function () {
        return this.eventCache_;
    };
    /**
     * @return {?Node}
     */
    ViewCache.prototype.getCompleteEventSnap = function () {
        return this.eventCache_.isFullyInitialized()
            ? this.eventCache_.getNode()
            : null;
    };
    /**
     * @return {!CacheNode}
     */
    ViewCache.prototype.getServerCache = function () {
        return this.serverCache_;
    };
    /**
     * @return {?Node}
     */
    ViewCache.prototype.getCompleteServerSnap = function () {
        return this.serverCache_.isFullyInitialized()
            ? this.serverCache_.getNode()
            : null;
    };
    /**
     * @const
     * @type {ViewCache}
     */
    ViewCache.Empty = new ViewCache(new CacheNode(ChildrenNode.EMPTY_NODE, 
    /*fullyInitialized=*/ false, 
    /*filtered=*/ false), new CacheNode(ChildrenNode.EMPTY_NODE, 
    /*fullyInitialized=*/ false, 
    /*filtered=*/ false));
    return ViewCache;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @constructor
 * @struct
 * @param {!string} type The event type
 * @param {!Node} snapshotNode The data
 * @param {string=} childName The name for this child, if it's a child event
 * @param {Node=} oldSnap Used for intermediate processing of child changed events
 * @param {string=} prevName The name for the previous child, if applicable
 */
var Change = /** @class */ (function () {
    function Change(type, snapshotNode, childName, oldSnap, prevName) {
        this.type = type;
        this.snapshotNode = snapshotNode;
        this.childName = childName;
        this.oldSnap = oldSnap;
        this.prevName = prevName;
    }
    /**
     * @param {!Node} snapshot
     * @return {!Change}
     */
    Change.valueChange = function (snapshot) {
        return new Change(Change.VALUE, snapshot);
    };
    /**
     * @param {string} childKey
     * @param {!Node} snapshot
     * @return {!Change}
     */
    Change.childAddedChange = function (childKey, snapshot) {
        return new Change(Change.CHILD_ADDED, snapshot, childKey);
    };
    /**
     * @param {string} childKey
     * @param {!Node} snapshot
     * @return {!Change}
     */
    Change.childRemovedChange = function (childKey, snapshot) {
        return new Change(Change.CHILD_REMOVED, snapshot, childKey);
    };
    /**
     * @param {string} childKey
     * @param {!Node} newSnapshot
     * @param {!Node} oldSnapshot
     * @return {!Change}
     */
    Change.childChangedChange = function (childKey, newSnapshot, oldSnapshot) {
        return new Change(Change.CHILD_CHANGED, newSnapshot, childKey, oldSnapshot);
    };
    /**
     * @param {string} childKey
     * @param {!Node} snapshot
     * @return {!Change}
     */
    Change.childMovedChange = function (childKey, snapshot) {
        return new Change(Change.CHILD_MOVED, snapshot, childKey);
    };
    //event types
    /** Event type for a child added */
    Change.CHILD_ADDED = 'child_added';
    /** Event type for a child removed */
    Change.CHILD_REMOVED = 'child_removed';
    /** Event type for a child changed */
    Change.CHILD_CHANGED = 'child_changed';
    /** Event type for a child moved */
    Change.CHILD_MOVED = 'child_moved';
    /** Event type for a value change */
    Change.VALUE = 'value';
    return Change;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Doesn't really filter nodes but applies an index to the node and keeps track of any changes
 *
 * @constructor
 * @implements {NodeFilter}
 * @param {!Index} index
 */
var IndexedFilter = /** @class */ (function () {
    function IndexedFilter(index_) {
        this.index_ = index_;
    }
    IndexedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        util.assert(snap.isIndexed(this.index_), 'A node must be indexed if only a child is updated');
        var oldChild = snap.getImmediateChild(key);
        // Check if anything actually changed.
        if (oldChild.getChild(affectedPath).equals(newChild.getChild(affectedPath))) {
            // There's an edge case where a child can enter or leave the view because affectedPath was set to null.
            // In this case, affectedPath will appear null in both the old and new snapshots.  So we need
            // to avoid treating these cases as "nothing changed."
            if (oldChild.isEmpty() == newChild.isEmpty()) {
                // Nothing changed.
                // This assert should be valid, but it's expensive (can dominate perf testing) so don't actually do it.
                //assert(oldChild.equals(newChild), 'Old and new snapshots should be equal.');
                return snap;
            }
        }
        if (optChangeAccumulator != null) {
            if (newChild.isEmpty()) {
                if (snap.hasChild(key)) {
                    optChangeAccumulator.trackChildChange(Change.childRemovedChange(key, oldChild));
                }
                else {
                    util.assert(snap.isLeafNode(), 'A child remove without an old child only makes sense on a leaf node');
                }
            }
            else if (oldChild.isEmpty()) {
                optChangeAccumulator.trackChildChange(Change.childAddedChange(key, newChild));
            }
            else {
                optChangeAccumulator.trackChildChange(Change.childChangedChange(key, newChild, oldChild));
            }
        }
        if (snap.isLeafNode() && newChild.isEmpty()) {
            return snap;
        }
        else {
            // Make sure the node is indexed
            return snap.updateImmediateChild(key, newChild).withIndex(this.index_);
        }
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
        if (optChangeAccumulator != null) {
            if (!oldSnap.isLeafNode()) {
                oldSnap.forEachChild(PRIORITY_INDEX, function (key, childNode) {
                    if (!newSnap.hasChild(key)) {
                        optChangeAccumulator.trackChildChange(Change.childRemovedChange(key, childNode));
                    }
                });
            }
            if (!newSnap.isLeafNode()) {
                newSnap.forEachChild(PRIORITY_INDEX, function (key, childNode) {
                    if (oldSnap.hasChild(key)) {
                        var oldChild = oldSnap.getImmediateChild(key);
                        if (!oldChild.equals(childNode)) {
                            optChangeAccumulator.trackChildChange(Change.childChangedChange(key, childNode, oldChild));
                        }
                    }
                    else {
                        optChangeAccumulator.trackChildChange(Change.childAddedChange(key, childNode));
                    }
                });
            }
        }
        return newSnap.withIndex(this.index_);
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
        if (oldSnap.isEmpty()) {
            return ChildrenNode.EMPTY_NODE;
        }
        else {
            return oldSnap.updatePriority(newPriority);
        }
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.filtersNodes = function () {
        return false;
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.getIndexedFilter = function () {
        return this;
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.getIndex = function () {
        return this.index_;
    };
    return IndexedFilter;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ChildChangeAccumulator = /** @class */ (function () {
    function ChildChangeAccumulator() {
        this.changeMap = new Map();
    }
    ChildChangeAccumulator.prototype.trackChildChange = function (change) {
        var type = change.type;
        var childKey = change.childName;
        util.assert(type == Change.CHILD_ADDED ||
            type == Change.CHILD_CHANGED ||
            type == Change.CHILD_REMOVED, 'Only child changes supported for tracking');
        util.assert(childKey !== '.priority', 'Only non-priority child changes can be tracked.');
        var oldChange = this.changeMap.get(childKey);
        if (oldChange) {
            var oldType = oldChange.type;
            if (type == Change.CHILD_ADDED && oldType == Change.CHILD_REMOVED) {
                this.changeMap.set(childKey, Change.childChangedChange(childKey, change.snapshotNode, oldChange.snapshotNode));
            }
            else if (type == Change.CHILD_REMOVED &&
                oldType == Change.CHILD_ADDED) {
                this.changeMap.delete(childKey);
            }
            else if (type == Change.CHILD_REMOVED &&
                oldType == Change.CHILD_CHANGED) {
                this.changeMap.set(childKey, Change.childRemovedChange(childKey, oldChange.oldSnap));
            }
            else if (type == Change.CHILD_CHANGED &&
                oldType == Change.CHILD_ADDED) {
                this.changeMap.set(childKey, Change.childAddedChange(childKey, change.snapshotNode));
            }
            else if (type == Change.CHILD_CHANGED &&
                oldType == Change.CHILD_CHANGED) {
                this.changeMap.set(childKey, Change.childChangedChange(childKey, change.snapshotNode, oldChange.oldSnap));
            }
            else {
                throw util.assertionError('Illegal combination of changes: ' +
                    change +
                    ' occurred after ' +
                    oldChange);
            }
        }
        else {
            this.changeMap.set(childKey, change);
        }
    };
    ChildChangeAccumulator.prototype.getChanges = function () {
        return Array.from(this.changeMap.values());
    };
    return ChildChangeAccumulator;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An implementation of CompleteChildSource that never returns any additional children
 *
 * @private
 * @constructor
 * @implements CompleteChildSource
 */
var NoCompleteChildSource_ = /** @class */ (function () {
    function NoCompleteChildSource_() {
    }
    /**
     * @inheritDoc
     */
    NoCompleteChildSource_.prototype.getCompleteChild = function (childKey) {
        return null;
    };
    /**
     * @inheritDoc
     */
    NoCompleteChildSource_.prototype.getChildAfterChild = function (index, child, reverse) {
        return null;
    };
    return NoCompleteChildSource_;
}());
/**
 * Singleton instance.
 * @const
 * @type {!CompleteChildSource}
 */
var NO_COMPLETE_CHILD_SOURCE = new NoCompleteChildSource_();
/**
 * An implementation of CompleteChildSource that uses a WriteTree in addition to any other server data or
 * old event caches available to calculate complete children.
 *
 *
 * @implements CompleteChildSource
 */
var WriteTreeCompleteChildSource = /** @class */ (function () {
    /**
     * @param {!WriteTreeRef} writes_
     * @param {!ViewCache} viewCache_
     * @param {?Node} optCompleteServerCache_
     */
    function WriteTreeCompleteChildSource(writes_, viewCache_, optCompleteServerCache_) {
        if (optCompleteServerCache_ === void 0) { optCompleteServerCache_ = null; }
        this.writes_ = writes_;
        this.viewCache_ = viewCache_;
        this.optCompleteServerCache_ = optCompleteServerCache_;
    }
    /**
     * @inheritDoc
     */
    WriteTreeCompleteChildSource.prototype.getCompleteChild = function (childKey) {
        var node = this.viewCache_.getEventCache();
        if (node.isCompleteForChild(childKey)) {
            return node.getNode().getImmediateChild(childKey);
        }
        else {
            var serverNode = this.optCompleteServerCache_ != null
                ? new CacheNode(this.optCompleteServerCache_, true, false)
                : this.viewCache_.getServerCache();
            return this.writes_.calcCompleteChild(childKey, serverNode);
        }
    };
    /**
     * @inheritDoc
     */
    WriteTreeCompleteChildSource.prototype.getChildAfterChild = function (index, child, reverse) {
        var completeServerData = this.optCompleteServerCache_ != null
            ? this.optCompleteServerCache_
            : this.viewCache_.getCompleteServerSnap();
        var nodes = this.writes_.calcIndexedSlice(completeServerData, child, 1, reverse, index);
        if (nodes.length === 0) {
            return null;
        }
        else {
            return nodes[0];
        }
    };
    return WriteTreeCompleteChildSource;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @constructor
 * @struct
 */
var ProcessorResult = /** @class */ (function () {
    /**
     * @param {!ViewCache} viewCache
     * @param {!Array.<!Change>} changes
     */
    function ProcessorResult(viewCache, changes) {
        this.viewCache = viewCache;
        this.changes = changes;
    }
    return ProcessorResult;
}());
/**
 * @constructor
 */
var ViewProcessor = /** @class */ (function () {
    /**
     * @param {!NodeFilter} filter_
     */
    function ViewProcessor(filter_) {
        this.filter_ = filter_;
    }
    /**
     * @param {!ViewCache} viewCache
     */
    ViewProcessor.prototype.assertIndexed = function (viewCache) {
        util.assert(viewCache
            .getEventCache()
            .getNode()
            .isIndexed(this.filter_.getIndex()), 'Event snap not indexed');
        util.assert(viewCache
            .getServerCache()
            .getNode()
            .isIndexed(this.filter_.getIndex()), 'Server snap not indexed');
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!Operation} operation
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @return {!ProcessorResult}
     */
    ViewProcessor.prototype.applyOperation = function (oldViewCache, operation, writesCache, completeCache) {
        var accumulator = new ChildChangeAccumulator();
        var newViewCache, filterServerNode;
        if (operation.type === OperationType.OVERWRITE) {
            var overwrite = operation;
            if (overwrite.source.fromUser) {
                newViewCache = this.applyUserOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, accumulator);
            }
            else {
                util.assert(overwrite.source.fromServer, 'Unknown source.');
                // We filter the node if it's a tagged update or the node has been previously filtered  and the
                // update is not at the root in which case it is ok (and necessary) to mark the node unfiltered
                // again
                filterServerNode =
                    overwrite.source.tagged ||
                        (oldViewCache.getServerCache().isFiltered() &&
                            !overwrite.path.isEmpty());
                newViewCache = this.applyServerOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, filterServerNode, accumulator);
            }
        }
        else if (operation.type === OperationType.MERGE) {
            var merge = operation;
            if (merge.source.fromUser) {
                newViewCache = this.applyUserMerge_(oldViewCache, merge.path, merge.children, writesCache, completeCache, accumulator);
            }
            else {
                util.assert(merge.source.fromServer, 'Unknown source.');
                // We filter the node if it's a tagged update or the node has been previously filtered
                filterServerNode =
                    merge.source.tagged || oldViewCache.getServerCache().isFiltered();
                newViewCache = this.applyServerMerge_(oldViewCache, merge.path, merge.children, writesCache, completeCache, filterServerNode, accumulator);
            }
        }
        else if (operation.type === OperationType.ACK_USER_WRITE) {
            var ackUserWrite = operation;
            if (!ackUserWrite.revert) {
                newViewCache = this.ackUserWrite_(oldViewCache, ackUserWrite.path, ackUserWrite.affectedTree, writesCache, completeCache, accumulator);
            }
            else {
                newViewCache = this.revertUserWrite_(oldViewCache, ackUserWrite.path, writesCache, completeCache, accumulator);
            }
        }
        else if (operation.type === OperationType.LISTEN_COMPLETE) {
            newViewCache = this.listenComplete_(oldViewCache, operation.path, writesCache, accumulator);
        }
        else {
            throw util.assertionError('Unknown operation type: ' + operation.type);
        }
        var changes = accumulator.getChanges();
        ViewProcessor.maybeAddValueEvent_(oldViewCache, newViewCache, changes);
        return new ProcessorResult(newViewCache, changes);
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!ViewCache} newViewCache
     * @param {!Array.<!Change>} accumulator
     * @private
     */
    ViewProcessor.maybeAddValueEvent_ = function (oldViewCache, newViewCache, accumulator) {
        var eventSnap = newViewCache.getEventCache();
        if (eventSnap.isFullyInitialized()) {
            var isLeafOrEmpty = eventSnap.getNode().isLeafNode() || eventSnap.getNode().isEmpty();
            var oldCompleteSnap = oldViewCache.getCompleteEventSnap();
            if (accumulator.length > 0 ||
                !oldViewCache.getEventCache().isFullyInitialized() ||
                (isLeafOrEmpty &&
                    !eventSnap.getNode().equals(/** @type {!Node} */ oldCompleteSnap)) ||
                !eventSnap
                    .getNode()
                    .getPriority()
                    .equals(oldCompleteSnap.getPriority())) {
                accumulator.push(Change.valueChange(
                /** @type {!Node} */ newViewCache.getCompleteEventSnap()));
            }
        }
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} changePath
     * @param {!WriteTreeRef} writesCache
     * @param {!CompleteChildSource} source
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.generateEventCacheAfterServerEvent_ = function (viewCache, changePath, writesCache, source, accumulator) {
        var oldEventSnap = viewCache.getEventCache();
        if (writesCache.shadowingWrite(changePath) != null) {
            // we have a shadowing write, ignore changes
            return viewCache;
        }
        else {
            var newEventCache = void 0, serverNode = void 0;
            if (changePath.isEmpty()) {
                // TODO: figure out how this plays with "sliding ack windows"
                util.assert(viewCache.getServerCache().isFullyInitialized(), 'If change path is empty, we must have complete server data');
                if (viewCache.getServerCache().isFiltered()) {
                    // We need to special case this, because we need to only apply writes to complete children, or
                    // we might end up raising events for incomplete children. If the server data is filtered deep
                    // writes cannot be guaranteed to be complete
                    var serverCache = viewCache.getCompleteServerSnap();
                    var completeChildren = serverCache instanceof ChildrenNode
                        ? serverCache
                        : ChildrenNode.EMPTY_NODE;
                    var completeEventChildren = writesCache.calcCompleteEventChildren(completeChildren);
                    newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeEventChildren, accumulator);
                }
                else {
                    var completeNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
                    newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeNode, accumulator);
                }
            }
            else {
                var childKey = changePath.getFront();
                if (childKey == '.priority') {
                    util.assert(changePath.getLength() == 1, "Can't have a priority with additional path components");
                    var oldEventNode = oldEventSnap.getNode();
                    serverNode = viewCache.getServerCache().getNode();
                    // we might have overwrites for this priority
                    var updatedPriority = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventNode, serverNode);
                    if (updatedPriority != null) {
                        newEventCache = this.filter_.updatePriority(oldEventNode, updatedPriority);
                    }
                    else {
                        // priority didn't change, keep old node
                        newEventCache = oldEventSnap.getNode();
                    }
                }
                else {
                    var childChangePath = changePath.popFront();
                    // update child
                    var newEventChild = void 0;
                    if (oldEventSnap.isCompleteForChild(childKey)) {
                        serverNode = viewCache.getServerCache().getNode();
                        var eventChildUpdate = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventSnap.getNode(), serverNode);
                        if (eventChildUpdate != null) {
                            newEventChild = oldEventSnap
                                .getNode()
                                .getImmediateChild(childKey)
                                .updateChild(childChangePath, eventChildUpdate);
                        }
                        else {
                            // Nothing changed, just keep the old child
                            newEventChild = oldEventSnap
                                .getNode()
                                .getImmediateChild(childKey);
                        }
                    }
                    else {
                        newEventChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
                    }
                    if (newEventChild != null) {
                        newEventCache = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newEventChild, childChangePath, source, accumulator);
                    }
                    else {
                        // no complete child available or no change
                        newEventCache = oldEventSnap.getNode();
                    }
                }
            }
            return viewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized() || changePath.isEmpty(), this.filter_.filtersNodes());
        }
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!Path} changePath
     * @param {!Node} changedSnap
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @param {boolean} filterServerNode
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.applyServerOverwrite_ = function (oldViewCache, changePath, changedSnap, writesCache, completeCache, filterServerNode, accumulator) {
        var oldServerSnap = oldViewCache.getServerCache();
        var newServerCache;
        var serverFilter = filterServerNode
            ? this.filter_
            : this.filter_.getIndexedFilter();
        if (changePath.isEmpty()) {
            newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), changedSnap, null);
        }
        else if (serverFilter.filtersNodes() && !oldServerSnap.isFiltered()) {
            // we want to filter the server node, but we didn't filter the server node yet, so simulate a full update
            var newServerNode = oldServerSnap
                .getNode()
                .updateChild(changePath, changedSnap);
            newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), newServerNode, null);
        }
        else {
            var childKey = changePath.getFront();
            if (!oldServerSnap.isCompleteForPath(changePath) &&
                changePath.getLength() > 1) {
                // We don't update incomplete nodes with updates intended for other listeners
                return oldViewCache;
            }
            var childChangePath = changePath.popFront();
            var childNode = oldServerSnap.getNode().getImmediateChild(childKey);
            var newChildNode = childNode.updateChild(childChangePath, changedSnap);
            if (childKey == '.priority') {
                newServerCache = serverFilter.updatePriority(oldServerSnap.getNode(), newChildNode);
            }
            else {
                newServerCache = serverFilter.updateChild(oldServerSnap.getNode(), childKey, newChildNode, childChangePath, NO_COMPLETE_CHILD_SOURCE, null);
            }
        }
        var newViewCache = oldViewCache.updateServerSnap(newServerCache, oldServerSnap.isFullyInitialized() || changePath.isEmpty(), serverFilter.filtersNodes());
        var source = new WriteTreeCompleteChildSource(writesCache, newViewCache, completeCache);
        return this.generateEventCacheAfterServerEvent_(newViewCache, changePath, writesCache, source, accumulator);
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!Path} changePath
     * @param {!Node} changedSnap
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.applyUserOverwrite_ = function (oldViewCache, changePath, changedSnap, writesCache, completeCache, accumulator) {
        var oldEventSnap = oldViewCache.getEventCache();
        var newViewCache, newEventCache;
        var source = new WriteTreeCompleteChildSource(writesCache, oldViewCache, completeCache);
        if (changePath.isEmpty()) {
            newEventCache = this.filter_.updateFullNode(oldViewCache.getEventCache().getNode(), changedSnap, accumulator);
            newViewCache = oldViewCache.updateEventSnap(newEventCache, true, this.filter_.filtersNodes());
        }
        else {
            var childKey = changePath.getFront();
            if (childKey === '.priority') {
                newEventCache = this.filter_.updatePriority(oldViewCache.getEventCache().getNode(), changedSnap);
                newViewCache = oldViewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized(), oldEventSnap.isFiltered());
            }
            else {
                var childChangePath = changePath.popFront();
                var oldChild = oldEventSnap.getNode().getImmediateChild(childKey);
                var newChild = void 0;
                if (childChangePath.isEmpty()) {
                    // Child overwrite, we can replace the child
                    newChild = changedSnap;
                }
                else {
                    var childNode = source.getCompleteChild(childKey);
                    if (childNode != null) {
                        if (childChangePath.getBack() === '.priority' &&
                            childNode.getChild(childChangePath.parent()).isEmpty()) {
                            // This is a priority update on an empty node. If this node exists on the server, the
                            // server will send down the priority in the update, so ignore for now
                            newChild = childNode;
                        }
                        else {
                            newChild = childNode.updateChild(childChangePath, changedSnap);
                        }
                    }
                    else {
                        // There is no complete child node available
                        newChild = ChildrenNode.EMPTY_NODE;
                    }
                }
                if (!oldChild.equals(newChild)) {
                    var newEventSnap = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newChild, childChangePath, source, accumulator);
                    newViewCache = oldViewCache.updateEventSnap(newEventSnap, oldEventSnap.isFullyInitialized(), this.filter_.filtersNodes());
                }
                else {
                    newViewCache = oldViewCache;
                }
            }
        }
        return newViewCache;
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {string} childKey
     * @return {boolean}
     * @private
     */
    ViewProcessor.cacheHasChild_ = function (viewCache, childKey) {
        return viewCache.getEventCache().isCompleteForChild(childKey);
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {ImmutableTree.<!Node>} changedChildren
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} serverCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.applyUserMerge_ = function (viewCache, path, changedChildren, writesCache, serverCache, accumulator) {
        var _this = this;
        // HACK: In the case of a limit query, there may be some changes that bump things out of the
        // window leaving room for new items.  It's important we process these changes first, so we
        // iterate the changes twice, first processing any that affect items currently in view.
        // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
        // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
        // not the other.
        var curViewCache = viewCache;
        changedChildren.foreach(function (relativePath, childNode) {
            var writePath = path.child(relativePath);
            if (ViewProcessor.cacheHasChild_(viewCache, writePath.getFront())) {
                curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
            }
        });
        changedChildren.foreach(function (relativePath, childNode) {
            var writePath = path.child(relativePath);
            if (!ViewProcessor.cacheHasChild_(viewCache, writePath.getFront())) {
                curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
            }
        });
        return curViewCache;
    };
    /**
     * @param {!Node} node
     * @param {ImmutableTree.<!Node>} merge
     * @return {!Node}
     * @private
     */
    ViewProcessor.prototype.applyMerge_ = function (node, merge) {
        merge.foreach(function (relativePath, childNode) {
            node = node.updateChild(relativePath, childNode);
        });
        return node;
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {!ImmutableTree.<!Node>} changedChildren
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} serverCache
     * @param {boolean} filterServerNode
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.applyServerMerge_ = function (viewCache, path, changedChildren, writesCache, serverCache, filterServerNode, accumulator) {
        var _this = this;
        // If we don't have a cache yet, this merge was intended for a previously listen in the same location. Ignore it and
        // wait for the complete data update coming soon.
        if (viewCache
            .getServerCache()
            .getNode()
            .isEmpty() &&
            !viewCache.getServerCache().isFullyInitialized()) {
            return viewCache;
        }
        // HACK: In the case of a limit query, there may be some changes that bump things out of the
        // window leaving room for new items.  It's important we process these changes first, so we
        // iterate the changes twice, first processing any that affect items currently in view.
        // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
        // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
        // not the other.
        var curViewCache = viewCache;
        var viewMergeTree;
        if (path.isEmpty()) {
            viewMergeTree = changedChildren;
        }
        else {
            viewMergeTree = ImmutableTree.Empty.setTree(path, changedChildren);
        }
        var serverNode = viewCache.getServerCache().getNode();
        viewMergeTree.children.inorderTraversal(function (childKey, childTree) {
            if (serverNode.hasChild(childKey)) {
                var serverChild = viewCache
                    .getServerCache()
                    .getNode()
                    .getImmediateChild(childKey);
                var newChild = _this.applyMerge_(serverChild, childTree);
                curViewCache = _this.applyServerOverwrite_(curViewCache, new Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
            }
        });
        viewMergeTree.children.inorderTraversal(function (childKey, childMergeTree) {
            var isUnknownDeepMerge = !viewCache.getServerCache().isCompleteForChild(childKey) &&
                childMergeTree.value == null;
            if (!serverNode.hasChild(childKey) && !isUnknownDeepMerge) {
                var serverChild = viewCache
                    .getServerCache()
                    .getNode()
                    .getImmediateChild(childKey);
                var newChild = _this.applyMerge_(serverChild, childMergeTree);
                curViewCache = _this.applyServerOverwrite_(curViewCache, new Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
            }
        });
        return curViewCache;
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} ackPath
     * @param {!ImmutableTree<!boolean>} affectedTree
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.ackUserWrite_ = function (viewCache, ackPath, affectedTree, writesCache, completeCache, accumulator) {
        if (writesCache.shadowingWrite(ackPath) != null) {
            return viewCache;
        }
        // Only filter server node if it is currently filtered
        var filterServerNode = viewCache.getServerCache().isFiltered();
        // Essentially we'll just get our existing server cache for the affected paths and re-apply it as a server update
        // now that it won't be shadowed.
        var serverCache = viewCache.getServerCache();
        if (affectedTree.value != null) {
            // This is an overwrite.
            if ((ackPath.isEmpty() && serverCache.isFullyInitialized()) ||
                serverCache.isCompleteForPath(ackPath)) {
                return this.applyServerOverwrite_(viewCache, ackPath, serverCache.getNode().getChild(ackPath), writesCache, completeCache, filterServerNode, accumulator);
            }
            else if (ackPath.isEmpty()) {
                // This is a goofy edge case where we are acking data at this location but don't have full data.  We
                // should just re-apply whatever we have in our cache as a merge.
                var changedChildren_1 = ImmutableTree.Empty;
                serverCache.getNode().forEachChild(KEY_INDEX, function (name, node) {
                    changedChildren_1 = changedChildren_1.set(new Path(name), node);
                });
                return this.applyServerMerge_(viewCache, ackPath, changedChildren_1, writesCache, completeCache, filterServerNode, accumulator);
            }
            else {
                return viewCache;
            }
        }
        else {
            // This is a merge.
            var changedChildren_2 = ImmutableTree.Empty;
            affectedTree.foreach(function (mergePath, value) {
                var serverCachePath = ackPath.child(mergePath);
                if (serverCache.isCompleteForPath(serverCachePath)) {
                    changedChildren_2 = changedChildren_2.set(mergePath, serverCache.getNode().getChild(serverCachePath));
                }
            });
            return this.applyServerMerge_(viewCache, ackPath, changedChildren_2, writesCache, completeCache, filterServerNode, accumulator);
        }
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {!WriteTreeRef} writesCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.listenComplete_ = function (viewCache, path, writesCache, accumulator) {
        var oldServerNode = viewCache.getServerCache();
        var newViewCache = viewCache.updateServerSnap(oldServerNode.getNode(), oldServerNode.isFullyInitialized() || path.isEmpty(), oldServerNode.isFiltered());
        return this.generateEventCacheAfterServerEvent_(newViewCache, path, writesCache, NO_COMPLETE_CHILD_SOURCE, accumulator);
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeServerCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.revertUserWrite_ = function (viewCache, path, writesCache, completeServerCache, accumulator) {
        var complete;
        if (writesCache.shadowingWrite(path) != null) {
            return viewCache;
        }
        else {
            var source = new WriteTreeCompleteChildSource(writesCache, viewCache, completeServerCache);
            var oldEventCache = viewCache.getEventCache().getNode();
            var newEventCache = void 0;
            if (path.isEmpty() || path.getFront() === '.priority') {
                var newNode = void 0;
                if (viewCache.getServerCache().isFullyInitialized()) {
                    newNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
                }
                else {
                    var serverChildren = viewCache.getServerCache().getNode();
                    util.assert(serverChildren instanceof ChildrenNode, 'serverChildren would be complete if leaf node');
                    newNode = writesCache.calcCompleteEventChildren(serverChildren);
                }
                newNode = newNode;
                newEventCache = this.filter_.updateFullNode(oldEventCache, newNode, accumulator);
            }
            else {
                var childKey = path.getFront();
                var newChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
                if (newChild == null &&
                    viewCache.getServerCache().isCompleteForChild(childKey)) {
                    newChild = oldEventCache.getImmediateChild(childKey);
                }
                if (newChild != null) {
                    newEventCache = this.filter_.updateChild(oldEventCache, childKey, newChild, path.popFront(), source, accumulator);
                }
                else if (viewCache
                    .getEventCache()
                    .getNode()
                    .hasChild(childKey)) {
                    // No complete child available, delete the existing one, if any
                    newEventCache = this.filter_.updateChild(oldEventCache, childKey, ChildrenNode.EMPTY_NODE, path.popFront(), source, accumulator);
                }
                else {
                    newEventCache = oldEventCache;
                }
                if (newEventCache.isEmpty() &&
                    viewCache.getServerCache().isFullyInitialized()) {
                    // We might have reverted all child writes. Maybe the old event was a leaf node
                    complete = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
                    if (complete.isLeafNode()) {
                        newEventCache = this.filter_.updateFullNode(newEventCache, complete, accumulator);
                    }
                }
            }
            complete =
                viewCache.getServerCache().isFullyInitialized() ||
                    writesCache.shadowingWrite(Path.Empty) != null;
            return viewCache.updateEventSnap(newEventCache, complete, this.filter_.filtersNodes());
        }
    };
    return ViewProcessor;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An EventGenerator is used to convert "raw" changes (Change) as computed by the
 * CacheDiffer into actual events (Event) that can be raised.  See generateEventsForChanges()
 * for details.
 *
 * @constructor
 */
var EventGenerator = /** @class */ (function () {
    /**
     *
     * @param {!Query} query_
     */
    function EventGenerator(query_) {
        this.query_ = query_;
        /**
         * @private
         * @type {!Index}
         */
        this.index_ = this.query_.getQueryParams().getIndex();
    }
    /**
     * Given a set of raw changes (no moved events and prevName not specified yet), and a set of
     * EventRegistrations that should be notified of these changes, generate the actual events to be raised.
     *
     * Notes:
     *  - child_moved events will be synthesized at this time for any child_changed events that affect
     *    our index.
     *  - prevName will be calculated based on the index ordering.
     *
     * @param {!Array.<!Change>} changes
     * @param {!Node} eventCache
     * @param {!Array.<!EventRegistration>} eventRegistrations
     * @return {!Array.<!Event>}
     */
    EventGenerator.prototype.generateEventsForChanges = function (changes, eventCache, eventRegistrations) {
        var _this = this;
        var events = [];
        var moves = [];
        changes.forEach(function (change) {
            if (change.type === Change.CHILD_CHANGED &&
                _this.index_.indexedValueChanged(change.oldSnap, change.snapshotNode)) {
                moves.push(Change.childMovedChange(change.childName, change.snapshotNode));
            }
        });
        this.generateEventsForType_(events, Change.CHILD_REMOVED, changes, eventRegistrations, eventCache);
        this.generateEventsForType_(events, Change.CHILD_ADDED, changes, eventRegistrations, eventCache);
        this.generateEventsForType_(events, Change.CHILD_MOVED, moves, eventRegistrations, eventCache);
        this.generateEventsForType_(events, Change.CHILD_CHANGED, changes, eventRegistrations, eventCache);
        this.generateEventsForType_(events, Change.VALUE, changes, eventRegistrations, eventCache);
        return events;
    };
    /**
     * Given changes of a single change type, generate the corresponding events.
     *
     * @param {!Array.<!Event>} events
     * @param {!string} eventType
     * @param {!Array.<!Change>} changes
     * @param {!Array.<!EventRegistration>} registrations
     * @param {!Node} eventCache
     * @private
     */
    EventGenerator.prototype.generateEventsForType_ = function (events, eventType, changes, registrations, eventCache) {
        var _this = this;
        var filteredChanges = changes.filter(function (change) { return change.type === eventType; });
        filteredChanges.sort(this.compareChanges_.bind(this));
        filteredChanges.forEach(function (change) {
            var materializedChange = _this.materializeSingleChange_(change, eventCache);
            registrations.forEach(function (registration) {
                if (registration.respondsTo(change.type)) {
                    events.push(registration.createEvent(materializedChange, _this.query_));
                }
            });
        });
    };
    /**
     * @param {!Change} change
     * @param {!Node} eventCache
     * @return {!Change}
     * @private
     */
    EventGenerator.prototype.materializeSingleChange_ = function (change, eventCache) {
        if (change.type === 'value' || change.type === 'child_removed') {
            return change;
        }
        else {
            change.prevName = eventCache.getPredecessorChildName(
            /** @type {!string} */
            change.childName, change.snapshotNode, this.index_);
            return change;
        }
    };
    /**
     * @param {!Change} a
     * @param {!Change} b
     * @return {number}
     * @private
     */
    EventGenerator.prototype.compareChanges_ = function (a, b) {
        if (a.childName == null || b.childName == null) {
            throw util.assertionError('Should only compare child_ events.');
        }
        var aWrapped = new NamedNode(a.childName, a.snapshotNode);
        var bWrapped = new NamedNode(b.childName, b.snapshotNode);
        return this.index_.compare(aWrapped, bWrapped);
    };
    return EventGenerator;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A view represents a specific location and query that has 1 or more event registrations.
 *
 * It does several things:
 *  - Maintains the list of event registrations for this location/query.
 *  - Maintains a cache of the data visible for this location/query.
 *  - Applies new operations (via applyOperation), updates the cache, and based on the event
 *    registrations returns the set of events to be raised.
 * @constructor
 */
var View = /** @class */ (function () {
    /**
     *
     * @param {!Query} query_
     * @param {!ViewCache} initialViewCache
     */
    function View(query_, initialViewCache) {
        this.query_ = query_;
        this.eventRegistrations_ = [];
        var params = this.query_.getQueryParams();
        var indexFilter = new IndexedFilter(params.getIndex());
        var filter = params.getNodeFilter();
        /**
         * @type {ViewProcessor}
         * @private
         */
        this.processor_ = new ViewProcessor(filter);
        var initialServerCache = initialViewCache.getServerCache();
        var initialEventCache = initialViewCache.getEventCache();
        // Don't filter server node with other filter than index, wait for tagged listen
        var serverSnap = indexFilter.updateFullNode(ChildrenNode.EMPTY_NODE, initialServerCache.getNode(), null);
        var eventSnap = filter.updateFullNode(ChildrenNode.EMPTY_NODE, initialEventCache.getNode(), null);
        var newServerCache = new CacheNode(serverSnap, initialServerCache.isFullyInitialized(), indexFilter.filtersNodes());
        var newEventCache = new CacheNode(eventSnap, initialEventCache.isFullyInitialized(), filter.filtersNodes());
        /**
         * @type {!ViewCache}
         * @private
         */
        this.viewCache_ = new ViewCache(newEventCache, newServerCache);
        /**
         * @type {!EventGenerator}
         * @private
         */
        this.eventGenerator_ = new EventGenerator(this.query_);
    }
    /**
     * @return {!Query}
     */
    View.prototype.getQuery = function () {
        return this.query_;
    };
    /**
     * @return {?Node}
     */
    View.prototype.getServerCache = function () {
        return this.viewCache_.getServerCache().getNode();
    };
    /**
     * @param {!Path} path
     * @return {?Node}
     */
    View.prototype.getCompleteServerCache = function (path) {
        var cache = this.viewCache_.getCompleteServerSnap();
        if (cache) {
            // If this isn't a "loadsAllData" view, then cache isn't actually a complete cache and
            // we need to see if it contains the child we're interested in.
            if (this.query_.getQueryParams().loadsAllData() ||
                (!path.isEmpty() && !cache.getImmediateChild(path.getFront()).isEmpty())) {
                return cache.getChild(path);
            }
        }
        return null;
    };
    /**
     * @return {boolean}
     */
    View.prototype.isEmpty = function () {
        return this.eventRegistrations_.length === 0;
    };
    /**
     * @param {!EventRegistration} eventRegistration
     */
    View.prototype.addEventRegistration = function (eventRegistration) {
        this.eventRegistrations_.push(eventRegistration);
    };
    /**
     * @param {?EventRegistration} eventRegistration If null, remove all callbacks.
     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
     * @return {!Array.<!Event>} Cancel events, if cancelError was provided.
     */
    View.prototype.removeEventRegistration = function (eventRegistration, cancelError) {
        var cancelEvents = [];
        if (cancelError) {
            util.assert(eventRegistration == null, 'A cancel should cancel all event registrations.');
            var path_1 = this.query_.path;
            this.eventRegistrations_.forEach(function (registration) {
                cancelError /** @type {!Error} */ = cancelError;
                var maybeEvent = registration.createCancelEvent(cancelError, path_1);
                if (maybeEvent) {
                    cancelEvents.push(maybeEvent);
                }
            });
        }
        if (eventRegistration) {
            var remaining = [];
            for (var i = 0; i < this.eventRegistrations_.length; ++i) {
                var existing = this.eventRegistrations_[i];
                if (!existing.matches(eventRegistration)) {
                    remaining.push(existing);
                }
                else if (eventRegistration.hasAnyCallback()) {
                    // We're removing just this one
                    remaining = remaining.concat(this.eventRegistrations_.slice(i + 1));
                    break;
                }
            }
            this.eventRegistrations_ = remaining;
        }
        else {
            this.eventRegistrations_ = [];
        }
        return cancelEvents;
    };
    /**
     * Applies the given Operation, updates our cache, and returns the appropriate events.
     *
     * @param {!Operation} operation
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeServerCache
     * @return {!Array.<!Event>}
     */
    View.prototype.applyOperation = function (operation, writesCache, completeServerCache) {
        if (operation.type === OperationType.MERGE &&
            operation.source.queryId !== null) {
            util.assert(this.viewCache_.getCompleteServerSnap(), 'We should always have a full cache before handling merges');
            util.assert(this.viewCache_.getCompleteEventSnap(), 'Missing event cache, even though we have a server cache');
        }
        var oldViewCache = this.viewCache_;
        var result = this.processor_.applyOperation(oldViewCache, operation, writesCache, completeServerCache);
        this.processor_.assertIndexed(result.viewCache);
        util.assert(result.viewCache.getServerCache().isFullyInitialized() ||
            !oldViewCache.getServerCache().isFullyInitialized(), 'Once a server snap is complete, it should never go back');
        this.viewCache_ = result.viewCache;
        return this.generateEventsForChanges_(result.changes, result.viewCache.getEventCache().getNode(), null);
    };
    /**
     * @param {!EventRegistration} registration
     * @return {!Array.<!Event>}
     */
    View.prototype.getInitialEvents = function (registration) {
        var eventSnap = this.viewCache_.getEventCache();
        var initialChanges = [];
        if (!eventSnap.getNode().isLeafNode()) {
            var eventNode = eventSnap.getNode();
            eventNode.forEachChild(PRIORITY_INDEX, function (key, childNode) {
                initialChanges.push(Change.childAddedChange(key, childNode));
            });
        }
        if (eventSnap.isFullyInitialized()) {
            initialChanges.push(Change.valueChange(eventSnap.getNode()));
        }
        return this.generateEventsForChanges_(initialChanges, eventSnap.getNode(), registration);
    };
    /**
     * @private
     * @param {!Array.<!Change>} changes
     * @param {!Node} eventCache
     * @param {EventRegistration=} eventRegistration
     * @return {!Array.<!Event>}
     */
    View.prototype.generateEventsForChanges_ = function (changes, eventCache, eventRegistration) {
        var registrations = eventRegistration
            ? [eventRegistration]
            : this.eventRegistrations_;
        return this.eventGenerator_.generateEventsForChanges(changes, eventCache, registrations);
    };
    return View;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __referenceConstructor$1;
/**
 * SyncPoint represents a single location in a SyncTree with 1 or more event registrations, meaning we need to
 * maintain 1 or more Views at this location to cache server data and raise appropriate events for server changes
 * and user writes (set, transaction, update).
 *
 * It's responsible for:
 *  - Maintaining the set of 1 or more views necessary at this location (a SyncPoint with 0 views should be removed).
 *  - Proxying user / server operations to the views as appropriate (i.e. applyServerOverwrite,
 *    applyUserOverwrite, etc.)
 */
var SyncPoint = /** @class */ (function () {
    function SyncPoint() {
        /**
         * The Views being tracked at this location in the tree, stored as a map where the key is a
         * queryId and the value is the View for that query.
         *
         * NOTE: This list will be quite small (usually 1, but perhaps 2 or 3; any more is an odd use case).
         */
        this.views = new Map();
    }
    Object.defineProperty(SyncPoint, "__referenceConstructor", {
        get: function () {
            util.assert(__referenceConstructor$1, 'Reference.ts has not been loaded');
            return __referenceConstructor$1;
        },
        set: function (val) {
            util.assert(!__referenceConstructor$1, '__referenceConstructor has already been defined');
            __referenceConstructor$1 = val;
        },
        enumerable: true,
        configurable: true
    });
    SyncPoint.prototype.isEmpty = function () {
        return this.views.size === 0;
    };
    SyncPoint.prototype.applyOperation = function (operation, writesCache, optCompleteServerCache) {
        var e_1, _a;
        var queryId = operation.source.queryId;
        if (queryId !== null) {
            var view = this.views.get(queryId);
            util.assert(view != null, 'SyncTree gave us an op for an invalid query.');
            return view.applyOperation(operation, writesCache, optCompleteServerCache);
        }
        else {
            var events = [];
            try {
                for (var _b = tslib.__values(this.views.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var view = _c.value;
                    events = events.concat(view.applyOperation(operation, writesCache, optCompleteServerCache));
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return events;
        }
    };
    /**
     * Add an event callback for the specified query.
     *
     * @param {!Query} query
     * @param {!EventRegistration} eventRegistration
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} serverCache Complete server cache, if we have it.
     * @param {boolean} serverCacheComplete
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncPoint.prototype.addEventRegistration = function (query, eventRegistration, writesCache, serverCache, serverCacheComplete) {
        var queryId = query.queryIdentifier();
        var view = this.views.get(queryId);
        if (!view) {
            // TODO: make writesCache take flag for complete server node
            var eventCache = writesCache.calcCompleteEventCache(serverCacheComplete ? serverCache : null);
            var eventCacheComplete = false;
            if (eventCache) {
                eventCacheComplete = true;
            }
            else if (serverCache instanceof ChildrenNode) {
                eventCache = writesCache.calcCompleteEventChildren(serverCache);
                eventCacheComplete = false;
            }
            else {
                eventCache = ChildrenNode.EMPTY_NODE;
                eventCacheComplete = false;
            }
            var viewCache = new ViewCache(new CacheNode(
            /** @type {!Node} */ eventCache, eventCacheComplete, false), new CacheNode(
            /** @type {!Node} */ serverCache, serverCacheComplete, false));
            view = new View(query, viewCache);
            this.views.set(queryId, view);
        }
        // This is guaranteed to exist now, we just created anything that was missing
        view.addEventRegistration(eventRegistration);
        return view.getInitialEvents(eventRegistration);
    };
    /**
     * Remove event callback(s).  Return cancelEvents if a cancelError is specified.
     *
     * If query is the default query, we'll check all views for the specified eventRegistration.
     * If eventRegistration is null, we'll remove all callbacks for the specified view(s).
     *
     * @param {!Query} query
     * @param {?EventRegistration} eventRegistration If null, remove all callbacks.
     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
     * @return {{removed:!Array.<!Query>, events:!Array.<!Event>}} removed queries and any cancel events
     */
    SyncPoint.prototype.removeEventRegistration = function (query, eventRegistration, cancelError) {
        var e_2, _a;
        var queryId = query.queryIdentifier();
        var removed = [];
        var cancelEvents = [];
        var hadCompleteView = this.hasCompleteView();
        if (queryId === 'default') {
            try {
                // When you do ref.off(...), we search all views for the registration to remove.
                for (var _b = tslib.__values(this.views.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var _d = tslib.__read(_c.value, 2), viewQueryId = _d[0], view = _d[1];
                    cancelEvents = cancelEvents.concat(view.removeEventRegistration(eventRegistration, cancelError));
                    if (view.isEmpty()) {
                        this.views.delete(viewQueryId);
                        // We'll deal with complete views later.
                        if (!view
                            .getQuery()
                            .getQueryParams()
                            .loadsAllData()) {
                            removed.push(view.getQuery());
                        }
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        else {
            // remove the callback from the specific view.
            var view = this.views.get(queryId);
            if (view) {
                cancelEvents = cancelEvents.concat(view.removeEventRegistration(eventRegistration, cancelError));
                if (view.isEmpty()) {
                    this.views.delete(queryId);
                    // We'll deal with complete views later.
                    if (!view
                        .getQuery()
                        .getQueryParams()
                        .loadsAllData()) {
                        removed.push(view.getQuery());
                    }
                }
            }
        }
        if (hadCompleteView && !this.hasCompleteView()) {
            // We removed our last complete view.
            removed.push(new SyncPoint.__referenceConstructor(query.repo, query.path));
        }
        return { removed: removed, events: cancelEvents };
    };
    SyncPoint.prototype.getQueryViews = function () {
        var e_3, _a;
        var result = [];
        try {
            for (var _b = tslib.__values(this.views.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var view = _c.value;
                if (!view
                    .getQuery()
                    .getQueryParams()
                    .loadsAllData()) {
                    result.push(view);
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return result;
    };
    /**
     * @param path The path to the desired complete snapshot
     * @return A complete cache, if it exists
     */
    SyncPoint.prototype.getCompleteServerCache = function (path) {
        var e_4, _a;
        var serverCache = null;
        try {
            for (var _b = tslib.__values(this.views.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var view = _c.value;
                serverCache = serverCache || view.getCompleteServerCache(path);
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
        return serverCache;
    };
    SyncPoint.prototype.viewForQuery = function (query) {
        var params = query.getQueryParams();
        if (params.loadsAllData()) {
            return this.getCompleteView();
        }
        else {
            var queryId = query.queryIdentifier();
            return this.views.get(queryId);
        }
    };
    SyncPoint.prototype.viewExistsForQuery = function (query) {
        return this.viewForQuery(query) != null;
    };
    SyncPoint.prototype.hasCompleteView = function () {
        return this.getCompleteView() != null;
    };
    SyncPoint.prototype.getCompleteView = function () {
        var e_5, _a;
        try {
            for (var _b = tslib.__values(this.views.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var view = _c.value;
                if (view
                    .getQuery()
                    .getQueryParams()
                    .loadsAllData()) {
                    return view;
                }
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_5) throw e_5.error; }
        }
        return null;
    };
    return SyncPoint;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * This class holds a collection of writes that can be applied to nodes in unison. It abstracts away the logic with
 * dealing with priority writes and multiple nested writes. At any given path there is only allowed to be one write
 * modifying that path. Any write to an existing path or shadowing an existing path will modify that existing write
 * to reflect the write added.
 */
var CompoundWrite = /** @class */ (function () {
    function CompoundWrite(writeTree_) {
        this.writeTree_ = writeTree_;
    }
    CompoundWrite.prototype.addWrite = function (path, node) {
        if (path.isEmpty()) {
            return new CompoundWrite(new ImmutableTree(node));
        }
        else {
            var rootmost = this.writeTree_.findRootMostValueAndPath(path);
            if (rootmost != null) {
                var rootMostPath = rootmost.path;
                var value = rootmost.value;
                var relativePath = Path.relativePath(rootMostPath, path);
                value = value.updateChild(relativePath, node);
                return new CompoundWrite(this.writeTree_.set(rootMostPath, value));
            }
            else {
                var subtree = new ImmutableTree(node);
                var newWriteTree = this.writeTree_.setTree(path, subtree);
                return new CompoundWrite(newWriteTree);
            }
        }
    };
    CompoundWrite.prototype.addWrites = function (path, updates) {
        var newWrite = this;
        each(updates, function (childKey, node) {
            newWrite = newWrite.addWrite(path.child(childKey), node);
        });
        return newWrite;
    };
    /**
     * Will remove a write at the given path and deeper paths. This will <em>not</em> modify a write at a higher
     * location, which must be removed by calling this method with that path.
     *
     * @param path The path at which a write and all deeper writes should be removed
     * @return {!CompoundWrite} The new CompoundWrite with the removed path
     */
    CompoundWrite.prototype.removeWrite = function (path) {
        if (path.isEmpty()) {
            return CompoundWrite.Empty;
        }
        else {
            var newWriteTree = this.writeTree_.setTree(path, ImmutableTree.Empty);
            return new CompoundWrite(newWriteTree);
        }
    };
    /**
     * Returns whether this CompoundWrite will fully overwrite a node at a given location and can therefore be
     * considered "complete".
     *
     * @param path The path to check for
     * @return Whether there is a complete write at that path
     */
    CompoundWrite.prototype.hasCompleteWrite = function (path) {
        return this.getCompleteNode(path) != null;
    };
    /**
     * Returns a node for a path if and only if the node is a "complete" overwrite at that path. This will not aggregate
     * writes from deeper paths, but will return child nodes from a more shallow path.
     *
     * @param path The path to get a complete write
     * @return The node if complete at that path, or null otherwise.
     */
    CompoundWrite.prototype.getCompleteNode = function (path) {
        var rootmost = this.writeTree_.findRootMostValueAndPath(path);
        if (rootmost != null) {
            return this.writeTree_
                .get(rootmost.path)
                .getChild(Path.relativePath(rootmost.path, path));
        }
        else {
            return null;
        }
    };
    /**
     * Returns all children that are guaranteed to be a complete overwrite.
     *
     * @return A list of all complete children.
     */
    CompoundWrite.prototype.getCompleteChildren = function () {
        var children = [];
        var node = this.writeTree_.value;
        if (node != null) {
            // If it's a leaf node, it has no children; so nothing to do.
            if (!node.isLeafNode()) {
                node.forEachChild(PRIORITY_INDEX, function (childName, childNode) {
                    children.push(new NamedNode(childName, childNode));
                });
            }
        }
        else {
            this.writeTree_.children.inorderTraversal(function (childName, childTree) {
                if (childTree.value != null) {
                    children.push(new NamedNode(childName, childTree.value));
                }
            });
        }
        return children;
    };
    CompoundWrite.prototype.childCompoundWrite = function (path) {
        if (path.isEmpty()) {
            return this;
        }
        else {
            var shadowingNode = this.getCompleteNode(path);
            if (shadowingNode != null) {
                return new CompoundWrite(new ImmutableTree(shadowingNode));
            }
            else {
                return new CompoundWrite(this.writeTree_.subtree(path));
            }
        }
    };
    /**
     * Returns true if this CompoundWrite is empty and therefore does not modify any nodes.
     * @return Whether this CompoundWrite is empty
     */
    CompoundWrite.prototype.isEmpty = function () {
        return this.writeTree_.isEmpty();
    };
    /**
     * Applies this CompoundWrite to a node. The node is returned with all writes from this CompoundWrite applied to the
     * node
     * @param node The node to apply this CompoundWrite to
     * @return The node with all writes applied
     */
    CompoundWrite.prototype.apply = function (node) {
        return applySubtreeWrite(Path.Empty, this.writeTree_, node);
    };
    CompoundWrite.Empty = new CompoundWrite(new ImmutableTree(null));
    return CompoundWrite;
}());
function applySubtreeWrite(relativePath, writeTree, node) {
    if (writeTree.value != null) {
        // Since there a write is always a leaf, we're done here
        return node.updateChild(relativePath, writeTree.value);
    }
    else {
        var priorityWrite_1 = null;
        writeTree.children.inorderTraversal(function (childKey, childTree) {
            if (childKey === '.priority') {
                // Apply priorities at the end so we don't update priorities for either empty nodes or forget
                // to apply priorities to empty nodes that are later filled
                util.assert(childTree.value !== null, 'Priority writes must always be leaf nodes');
                priorityWrite_1 = childTree.value;
            }
            else {
                node = applySubtreeWrite(relativePath.child(childKey), childTree, node);
            }
        });
        // If there was a priority write, we only apply it if the node is not empty
        if (!node.getChild(relativePath).isEmpty() && priorityWrite_1 !== null) {
            node = node.updateChild(relativePath.child('.priority'), priorityWrite_1);
        }
        return node;
    }
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * WriteTree tracks all pending user-initiated writes and has methods to calculate the result of merging them
 * with underlying server data (to create "event cache" data).  Pending writes are added with addOverwrite()
 * and addMerge(), and removed with removeWrite().
 *
 * @constructor
 */
var WriteTree = /** @class */ (function () {
    function WriteTree() {
        /**
         * A tree tracking the result of applying all visible writes.  This does not include transactions with
         * applyLocally=false or writes that are completely shadowed by other writes.
         *
         * @type {!CompoundWrite}
         * @private
         */
        this.visibleWrites_ = CompoundWrite.Empty;
        /**
         * A list of all pending writes, regardless of visibility and shadowed-ness.  Used to calculate arbitrary
         * sets of the changed data, such as hidden writes (from transactions) or changes with certain writes excluded (also
         * used by transactions).
         *
         * @type {!Array.<!WriteRecord>}
         * @private
         */
        this.allWrites_ = [];
        this.lastWriteId_ = -1;
    }
    /**
     * Create a new WriteTreeRef for the given path. For use with a new sync point at the given path.
     *
     * @param {!Path} path
     * @return {!WriteTreeRef}
     */
    WriteTree.prototype.childWrites = function (path) {
        return new WriteTreeRef(path, this);
    };
    /**
     * Record a new overwrite from user code.
     *
     * @param {!Path} path
     * @param {!Node} snap
     * @param {!number} writeId
     * @param {boolean=} visible This is set to false by some transactions. It should be excluded from event caches
     */
    WriteTree.prototype.addOverwrite = function (path, snap, writeId, visible) {
        util.assert(writeId > this.lastWriteId_, 'Stacking an older write on top of newer ones');
        if (visible === undefined) {
            visible = true;
        }
        this.allWrites_.push({
            path: path,
            snap: snap,
            writeId: writeId,
            visible: visible
        });
        if (visible) {
            this.visibleWrites_ = this.visibleWrites_.addWrite(path, snap);
        }
        this.lastWriteId_ = writeId;
    };
    /**
     * Record a new merge from user code.
     *
     * @param {!Path} path
     * @param {!Object.<string, !Node>} changedChildren
     * @param {!number} writeId
     */
    WriteTree.prototype.addMerge = function (path, changedChildren, writeId) {
        util.assert(writeId > this.lastWriteId_, 'Stacking an older merge on top of newer ones');
        this.allWrites_.push({
            path: path,
            children: changedChildren,
            writeId: writeId,
            visible: true
        });
        this.visibleWrites_ = this.visibleWrites_.addWrites(path, changedChildren);
        this.lastWriteId_ = writeId;
    };
    /**
     * @param {!number} writeId
     * @return {?WriteRecord}
     */
    WriteTree.prototype.getWrite = function (writeId) {
        for (var i = 0; i < this.allWrites_.length; i++) {
            var record = this.allWrites_[i];
            if (record.writeId === writeId) {
                return record;
            }
        }
        return null;
    };
    /**
     * Remove a write (either an overwrite or merge) that has been successfully acknowledge by the server. Recalculates
     * the tree if necessary.  We return true if it may have been visible, meaning views need to reevaluate.
     *
     * @param {!number} writeId
     * @return {boolean} true if the write may have been visible (meaning we'll need to reevaluate / raise
     * events as a result).
     */
    WriteTree.prototype.removeWrite = function (writeId) {
        // Note: disabling this check. It could be a transaction that preempted another transaction, and thus was applied
        // out of order.
        //const validClear = revert || this.allWrites_.length === 0 || writeId <= this.allWrites_[0].writeId;
        //assert(validClear, "Either we don't have this write, or it's the first one in the queue");
        var _this = this;
        var idx = this.allWrites_.findIndex(function (s) {
            return s.writeId === writeId;
        });
        util.assert(idx >= 0, 'removeWrite called with nonexistent writeId.');
        var writeToRemove = this.allWrites_[idx];
        this.allWrites_.splice(idx, 1);
        var removedWriteWasVisible = writeToRemove.visible;
        var removedWriteOverlapsWithOtherWrites = false;
        var i = this.allWrites_.length - 1;
        while (removedWriteWasVisible && i >= 0) {
            var currentWrite = this.allWrites_[i];
            if (currentWrite.visible) {
                if (i >= idx &&
                    this.recordContainsPath_(currentWrite, writeToRemove.path)) {
                    // The removed write was completely shadowed by a subsequent write.
                    removedWriteWasVisible = false;
                }
                else if (writeToRemove.path.contains(currentWrite.path)) {
                    // Either we're covering some writes or they're covering part of us (depending on which came first).
                    removedWriteOverlapsWithOtherWrites = true;
                }
            }
            i--;
        }
        if (!removedWriteWasVisible) {
            return false;
        }
        else if (removedWriteOverlapsWithOtherWrites) {
            // There's some shadowing going on. Just rebuild the visible writes from scratch.
            this.resetTree_();
            return true;
        }
        else {
            // There's no shadowing.  We can safely just remove the write(s) from visibleWrites.
            if (writeToRemove.snap) {
                this.visibleWrites_ = this.visibleWrites_.removeWrite(writeToRemove.path);
            }
            else {
                var children = writeToRemove.children;
                each(children, function (childName) {
                    _this.visibleWrites_ = _this.visibleWrites_.removeWrite(writeToRemove.path.child(childName));
                });
            }
            return true;
        }
    };
    /**
     * Return a complete snapshot for the given path if there's visible write data at that path, else null.
     * No server data is considered.
     *
     * @param {!Path} path
     * @return {?Node}
     */
    WriteTree.prototype.getCompleteWriteData = function (path) {
        return this.visibleWrites_.getCompleteNode(path);
    };
    /**
     * Given optional, underlying server data, and an optional set of constraints (exclude some sets, include hidden
     * writes), attempt to calculate a complete snapshot for the given path
     *
     * @param {!Path} treePath
     * @param {?Node} completeServerCache
     * @param {Array.<number>=} writeIdsToExclude An optional set to be excluded
     * @param {boolean=} includeHiddenWrites Defaults to false, whether or not to layer on writes with visible set to false
     * @return {?Node}
     */
    WriteTree.prototype.calcCompleteEventCache = function (treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
        if (!writeIdsToExclude && !includeHiddenWrites) {
            var shadowingNode = this.visibleWrites_.getCompleteNode(treePath);
            if (shadowingNode != null) {
                return shadowingNode;
            }
            else {
                var subMerge = this.visibleWrites_.childCompoundWrite(treePath);
                if (subMerge.isEmpty()) {
                    return completeServerCache;
                }
                else if (completeServerCache == null &&
                    !subMerge.hasCompleteWrite(Path.Empty)) {
                    // We wouldn't have a complete snapshot, since there's no underlying data and no complete shadow
                    return null;
                }
                else {
                    var layeredCache = completeServerCache || ChildrenNode.EMPTY_NODE;
                    return subMerge.apply(layeredCache);
                }
            }
        }
        else {
            var merge = this.visibleWrites_.childCompoundWrite(treePath);
            if (!includeHiddenWrites && merge.isEmpty()) {
                return completeServerCache;
            }
            else {
                // If the server cache is null, and we don't have a complete cache, we need to return null
                if (!includeHiddenWrites &&
                    completeServerCache == null &&
                    !merge.hasCompleteWrite(Path.Empty)) {
                    return null;
                }
                else {
                    var filter = function (write) {
                        return ((write.visible || includeHiddenWrites) &&
                            (!writeIdsToExclude ||
                                !~writeIdsToExclude.indexOf(write.writeId)) &&
                            (write.path.contains(treePath) || treePath.contains(write.path)));
                    };
                    var mergeAtPath = WriteTree.layerTree_(this.allWrites_, filter, treePath);
                    var layeredCache = completeServerCache || ChildrenNode.EMPTY_NODE;
                    return mergeAtPath.apply(layeredCache);
                }
            }
        }
    };
    /**
     * With optional, underlying server data, attempt to return a children node of children that we have complete data for.
     * Used when creating new views, to pre-fill their complete event children snapshot.
     *
     * @param {!Path} treePath
     * @param {?ChildrenNode} completeServerChildren
     * @return {!ChildrenNode}
     */
    WriteTree.prototype.calcCompleteEventChildren = function (treePath, completeServerChildren) {
        var completeChildren = ChildrenNode.EMPTY_NODE;
        var topLevelSet = this.visibleWrites_.getCompleteNode(treePath);
        if (topLevelSet) {
            if (!topLevelSet.isLeafNode()) {
                // we're shadowing everything. Return the children.
                topLevelSet.forEachChild(PRIORITY_INDEX, function (childName, childSnap) {
                    completeChildren = completeChildren.updateImmediateChild(childName, childSnap);
                });
            }
            return completeChildren;
        }
        else if (completeServerChildren) {
            // Layer any children we have on top of this
            // We know we don't have a top-level set, so just enumerate existing children
            var merge_1 = this.visibleWrites_.childCompoundWrite(treePath);
            completeServerChildren.forEachChild(PRIORITY_INDEX, function (childName, childNode) {
                var node = merge_1
                    .childCompoundWrite(new Path(childName))
                    .apply(childNode);
                completeChildren = completeChildren.updateImmediateChild(childName, node);
            });
            // Add any complete children we have from the set
            merge_1.getCompleteChildren().forEach(function (namedNode) {
                completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
            });
            return completeChildren;
        }
        else {
            // We don't have anything to layer on top of. Layer on any children we have
            // Note that we can return an empty snap if we have a defined delete
            var merge = this.visibleWrites_.childCompoundWrite(treePath);
            merge.getCompleteChildren().forEach(function (namedNode) {
                completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
            });
            return completeChildren;
        }
    };
    /**
     * Given that the underlying server data has updated, determine what, if anything, needs to be
     * applied to the event cache.
     *
     * Possibilities:
     *
     * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
     *
     * 2. Some write is completely shadowing. No events to be raised
     *
     * 3. Is partially shadowed. Events
     *
     * Either existingEventSnap or existingServerSnap must exist
     *
     * @param {!Path} treePath
     * @param {!Path} childPath
     * @param {?Node} existingEventSnap
     * @param {?Node} existingServerSnap
     * @return {?Node}
     */
    WriteTree.prototype.calcEventCacheAfterServerOverwrite = function (treePath, childPath, existingEventSnap, existingServerSnap) {
        util.assert(existingEventSnap || existingServerSnap, 'Either existingEventSnap or existingServerSnap must exist');
        var path = treePath.child(childPath);
        if (this.visibleWrites_.hasCompleteWrite(path)) {
            // At this point we can probably guarantee that we're in case 2, meaning no events
            // May need to check visibility while doing the findRootMostValueAndPath call
            return null;
        }
        else {
            // No complete shadowing. We're either partially shadowing or not shadowing at all.
            var childMerge = this.visibleWrites_.childCompoundWrite(path);
            if (childMerge.isEmpty()) {
                // We're not shadowing at all. Case 1
                return existingServerSnap.getChild(childPath);
            }
            else {
                // This could be more efficient if the serverNode + updates doesn't change the eventSnap
                // However this is tricky to find out, since user updates don't necessary change the server
                // snap, e.g. priority updates on empty nodes, or deep deletes. Another special case is if the server
                // adds nodes, but doesn't change any existing writes. It is therefore not enough to
                // only check if the updates change the serverNode.
                // Maybe check if the merge tree contains these special cases and only do a full overwrite in that case?
                return childMerge.apply(existingServerSnap.getChild(childPath));
            }
        }
    };
    /**
     * Returns a complete child for a given server snap after applying all user writes or null if there is no
     * complete child for this ChildKey.
     *
     * @param {!Path} treePath
     * @param {!string} childKey
     * @param {!CacheNode} existingServerSnap
     * @return {?Node}
     */
    WriteTree.prototype.calcCompleteChild = function (treePath, childKey, existingServerSnap) {
        var path = treePath.child(childKey);
        var shadowingNode = this.visibleWrites_.getCompleteNode(path);
        if (shadowingNode != null) {
            return shadowingNode;
        }
        else {
            if (existingServerSnap.isCompleteForChild(childKey)) {
                var childMerge = this.visibleWrites_.childCompoundWrite(path);
                return childMerge.apply(existingServerSnap.getNode().getImmediateChild(childKey));
            }
            else {
                return null;
            }
        }
    };
    /**
     * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
     * a higher path, this will return the child of that write relative to the write and this path.
     * Returns null if there is no write at this path.
     */
    WriteTree.prototype.shadowingWrite = function (path) {
        return this.visibleWrites_.getCompleteNode(path);
    };
    /**
     * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
     * the window, but may now be in the window.
     */
    WriteTree.prototype.calcIndexedSlice = function (treePath, completeServerData, startPost, count, reverse, index) {
        var toIterate;
        var merge = this.visibleWrites_.childCompoundWrite(treePath);
        var shadowingNode = merge.getCompleteNode(Path.Empty);
        if (shadowingNode != null) {
            toIterate = shadowingNode;
        }
        else if (completeServerData != null) {
            toIterate = merge.apply(completeServerData);
        }
        else {
            // no children to iterate on
            return [];
        }
        toIterate = toIterate.withIndex(index);
        if (!toIterate.isEmpty() && !toIterate.isLeafNode()) {
            var nodes = [];
            var cmp = index.getCompare();
            var iter = reverse
                ? toIterate.getReverseIteratorFrom(startPost, index)
                : toIterate.getIteratorFrom(startPost, index);
            var next = iter.getNext();
            while (next && nodes.length < count) {
                if (cmp(next, startPost) !== 0) {
                    nodes.push(next);
                }
                next = iter.getNext();
            }
            return nodes;
        }
        else {
            return [];
        }
    };
    WriteTree.prototype.recordContainsPath_ = function (writeRecord, path) {
        if (writeRecord.snap) {
            return writeRecord.path.contains(path);
        }
        else {
            for (var childName in writeRecord.children) {
                if (writeRecord.children.hasOwnProperty(childName) &&
                    writeRecord.path.child(childName).contains(path)) {
                    return true;
                }
            }
            return false;
        }
    };
    /**
     * Re-layer the writes and merges into a tree so we can efficiently calculate event snapshots
     */
    WriteTree.prototype.resetTree_ = function () {
        this.visibleWrites_ = WriteTree.layerTree_(this.allWrites_, WriteTree.DefaultFilter_, Path.Empty);
        if (this.allWrites_.length > 0) {
            this.lastWriteId_ = this.allWrites_[this.allWrites_.length - 1].writeId;
        }
        else {
            this.lastWriteId_ = -1;
        }
    };
    /**
     * The default filter used when constructing the tree. Keep everything that's visible.
     */
    WriteTree.DefaultFilter_ = function (write) {
        return write.visible;
    };
    /**
     * Static method. Given an array of WriteRecords, a filter for which ones to include, and a path, construct the tree of
     * event data at that path.
     */
    WriteTree.layerTree_ = function (writes, filter, treeRoot) {
        var compoundWrite = CompoundWrite.Empty;
        for (var i = 0; i < writes.length; ++i) {
            var write = writes[i];
            // Theory, a later set will either:
            // a) abort a relevant transaction, so no need to worry about excluding it from calculating that transaction
            // b) not be relevant to a transaction (separate branch), so again will not affect the data for that transaction
            if (filter(write)) {
                var writePath = write.path;
                var relativePath = void 0;
                if (write.snap) {
                    if (treeRoot.contains(writePath)) {
                        relativePath = Path.relativePath(treeRoot, writePath);
                        compoundWrite = compoundWrite.addWrite(relativePath, write.snap);
                    }
                    else if (writePath.contains(treeRoot)) {
                        relativePath = Path.relativePath(writePath, treeRoot);
                        compoundWrite = compoundWrite.addWrite(Path.Empty, write.snap.getChild(relativePath));
                    }
                }
                else if (write.children) {
                    if (treeRoot.contains(writePath)) {
                        relativePath = Path.relativePath(treeRoot, writePath);
                        compoundWrite = compoundWrite.addWrites(relativePath, write.children);
                    }
                    else if (writePath.contains(treeRoot)) {
                        relativePath = Path.relativePath(writePath, treeRoot);
                        if (relativePath.isEmpty()) {
                            compoundWrite = compoundWrite.addWrites(Path.Empty, write.children);
                        }
                        else {
                            var child = util.safeGet(write.children, relativePath.getFront());
                            if (child) {
                                // There exists a child in this node that matches the root path
                                var deepNode = child.getChild(relativePath.popFront());
                                compoundWrite = compoundWrite.addWrite(Path.Empty, deepNode);
                            }
                        }
                    }
                }
                else {
                    throw util.assertionError('WriteRecord should have .snap or .children');
                }
            }
        }
        return compoundWrite;
    };
    return WriteTree;
}());
/**
 * A WriteTreeRef wraps a WriteTree and a path, for convenient access to a particular subtree.  All of the methods
 * just proxy to the underlying WriteTree.
 *
 * @constructor
 */
var WriteTreeRef = /** @class */ (function () {
    /**
     * @param {!Path} path
     * @param {!WriteTree} writeTree
     */
    function WriteTreeRef(path, writeTree) {
        this.treePath_ = path;
        this.writeTree_ = writeTree;
    }
    /**
     * If possible, returns a complete event cache, using the underlying server data if possible. In addition, can be used
     * to get a cache that includes hidden writes, and excludes arbitrary writes. Note that customizing the returned node
     * can lead to a more expensive calculation.
     *
     * @param {?Node} completeServerCache
     * @param {Array.<number>=} writeIdsToExclude Optional writes to exclude.
     * @param {boolean=} includeHiddenWrites Defaults to false, whether or not to layer on writes with visible set to false
     * @return {?Node}
     */
    WriteTreeRef.prototype.calcCompleteEventCache = function (completeServerCache, writeIdsToExclude, includeHiddenWrites) {
        return this.writeTree_.calcCompleteEventCache(this.treePath_, completeServerCache, writeIdsToExclude, includeHiddenWrites);
    };
    /**
     * If possible, returns a children node containing all of the complete children we have data for. The returned data is a
     * mix of the given server data and write data.
     *
     * @param {?ChildrenNode} completeServerChildren
     * @return {!ChildrenNode}
     */
    WriteTreeRef.prototype.calcCompleteEventChildren = function (completeServerChildren) {
        return this.writeTree_.calcCompleteEventChildren(this.treePath_, completeServerChildren);
    };
    /**
     * Given that either the underlying server data has updated or the outstanding writes have updated, determine what,
     * if anything, needs to be applied to the event cache.
     *
     * Possibilities:
     *
     * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
     *
     * 2. Some write is completely shadowing. No events to be raised
     *
     * 3. Is partially shadowed. Events should be raised
     *
     * Either existingEventSnap or existingServerSnap must exist, this is validated via an assert
     *
     * @param {!Path} path
     * @param {?Node} existingEventSnap
     * @param {?Node} existingServerSnap
     * @return {?Node}
     */
    WriteTreeRef.prototype.calcEventCacheAfterServerOverwrite = function (path, existingEventSnap, existingServerSnap) {
        return this.writeTree_.calcEventCacheAfterServerOverwrite(this.treePath_, path, existingEventSnap, existingServerSnap);
    };
    /**
     * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
     * a higher path, this will return the child of that write relative to the write and this path.
     * Returns null if there is no write at this path.
     *
     * @param {!Path} path
     * @return {?Node}
     */
    WriteTreeRef.prototype.shadowingWrite = function (path) {
        return this.writeTree_.shadowingWrite(this.treePath_.child(path));
    };
    /**
     * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
     * the window, but may now be in the window
     *
     * @param {?Node} completeServerData
     * @param {!NamedNode} startPost
     * @param {!number} count
     * @param {boolean} reverse
     * @param {!Index} index
     * @return {!Array.<!NamedNode>}
     */
    WriteTreeRef.prototype.calcIndexedSlice = function (completeServerData, startPost, count, reverse, index) {
        return this.writeTree_.calcIndexedSlice(this.treePath_, completeServerData, startPost, count, reverse, index);
    };
    /**
     * Returns a complete child for a given server snap after applying all user writes or null if there is no
     * complete child for this ChildKey.
     *
     * @param {!string} childKey
     * @param {!CacheNode} existingServerCache
     * @return {?Node}
     */
    WriteTreeRef.prototype.calcCompleteChild = function (childKey, existingServerCache) {
        return this.writeTree_.calcCompleteChild(this.treePath_, childKey, existingServerCache);
    };
    /**
     * Return a WriteTreeRef for a child.
     *
     * @param {string} childName
     * @return {!WriteTreeRef}
     */
    WriteTreeRef.prototype.child = function (childName) {
        return new WriteTreeRef(this.treePath_.child(childName), this.writeTree_);
    };
    return WriteTreeRef;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * SyncTree is the central class for managing event callback registration, data caching, views
 * (query processing), and event generation.  There are typically two SyncTree instances for
 * each Repo, one for the normal Firebase data, and one for the .info data.
 *
 * It has a number of responsibilities, including:
 *  - Tracking all user event callbacks (registered via addEventRegistration() and removeEventRegistration()).
 *  - Applying and caching data changes for user set(), transaction(), and update() calls
 *    (applyUserOverwrite(), applyUserMerge()).
 *  - Applying and caching data changes for server data changes (applyServerOverwrite(),
 *    applyServerMerge()).
 *  - Generating user-facing events for server and user changes (all of the apply* methods
 *    return the set of events that need to be raised as a result).
 *  - Maintaining the appropriate set of server listens to ensure we are always subscribed
 *    to the correct set of paths and queries to satisfy the current set of user event
 *    callbacks (listens are started/stopped using the provided listenProvider).
 *
 * NOTE: Although SyncTree tracks event callbacks and calculates events to raise, the actual
 * events are returned to the caller rather than raised synchronously.
 *
 * @constructor
 */
var SyncTree = /** @class */ (function () {
    /**
     * @param {!ListenProvider} listenProvider_ Used by SyncTree to start / stop listening
     *   to server data.
     */
    function SyncTree(listenProvider_) {
        this.listenProvider_ = listenProvider_;
        /**
         * Tree of SyncPoints.  There's a SyncPoint at any location that has 1 or more views.
         */
        this.syncPointTree_ = ImmutableTree.Empty;
        /**
         * A tree of all pending user writes (user-initiated set()'s, transaction()'s, update()'s, etc.).
         */
        this.pendingWriteTree_ = new WriteTree();
        this.tagToQueryMap = new Map();
        this.queryToTagMap = new Map();
    }
    /**
     * Apply the data changes for a user-generated set() or transaction() call.
     *
     * @return Events to raise.
     */
    SyncTree.prototype.applyUserOverwrite = function (path, newData, writeId, visible) {
        // Record pending write.
        this.pendingWriteTree_.addOverwrite(path, newData, writeId, visible);
        if (!visible) {
            return [];
        }
        else {
            return this.applyOperationToSyncPoints_(new Overwrite(OperationSource.User, path, newData));
        }
    };
    /**
     * Apply the data from a user-generated update() call
     *
     * @return Events to raise.
     */
    SyncTree.prototype.applyUserMerge = function (path, changedChildren, writeId) {
        // Record pending merge.
        this.pendingWriteTree_.addMerge(path, changedChildren, writeId);
        var changeTree = ImmutableTree.fromObject(changedChildren);
        return this.applyOperationToSyncPoints_(new Merge(OperationSource.User, path, changeTree));
    };
    /**
     * Acknowledge a pending user write that was previously registered with applyUserOverwrite() or applyUserMerge().
     *
     * @param revert True if the given write failed and needs to be reverted
     * @return Events to raise.
     */
    SyncTree.prototype.ackUserWrite = function (writeId, revert) {
        if (revert === void 0) { revert = false; }
        var write = this.pendingWriteTree_.getWrite(writeId);
        var needToReevaluate = this.pendingWriteTree_.removeWrite(writeId);
        if (!needToReevaluate) {
            return [];
        }
        else {
            var affectedTree_1 = ImmutableTree.Empty;
            if (write.snap != null) {
                // overwrite
                affectedTree_1 = affectedTree_1.set(Path.Empty, true);
            }
            else {
                each(write.children, function (pathString, node) {
                    affectedTree_1 = affectedTree_1.set(new Path(pathString), node);
                });
            }
            return this.applyOperationToSyncPoints_(new AckUserWrite(write.path, affectedTree_1, revert));
        }
    };
    /**
     * Apply new server data for the specified path..
     *
     * @return Events to raise.
     */
    SyncTree.prototype.applyServerOverwrite = function (path, newData) {
        return this.applyOperationToSyncPoints_(new Overwrite(OperationSource.Server, path, newData));
    };
    /**
     * Apply new server data to be merged in at the specified path.
     *
     * @return Events to raise.
     */
    SyncTree.prototype.applyServerMerge = function (path, changedChildren) {
        var changeTree = ImmutableTree.fromObject(changedChildren);
        return this.applyOperationToSyncPoints_(new Merge(OperationSource.Server, path, changeTree));
    };
    /**
     * Apply a listen complete for a query
     *
     * @return Events to raise.
     */
    SyncTree.prototype.applyListenComplete = function (path) {
        return this.applyOperationToSyncPoints_(new ListenComplete(OperationSource.Server, path));
    };
    /**
     * Apply new server data for the specified tagged query.
     *
     * @return Events to raise.
     */
    SyncTree.prototype.applyTaggedQueryOverwrite = function (path, snap, tag) {
        var queryKey = this.queryKeyForTag_(tag);
        if (queryKey != null) {
            var r = SyncTree.parseQueryKey_(queryKey);
            var queryPath = r.path, queryId = r.queryId;
            var relativePath = Path.relativePath(queryPath, path);
            var op = new Overwrite(OperationSource.forServerTaggedQuery(queryId), relativePath, snap);
            return this.applyTaggedOperation_(queryPath, op);
        }
        else {
            // Query must have been removed already
            return [];
        }
    };
    /**
     * Apply server data to be merged in for the specified tagged query.
     *
     * @return Events to raise.
     */
    SyncTree.prototype.applyTaggedQueryMerge = function (path, changedChildren, tag) {
        var queryKey = this.queryKeyForTag_(tag);
        if (queryKey) {
            var r = SyncTree.parseQueryKey_(queryKey);
            var queryPath = r.path, queryId = r.queryId;
            var relativePath = Path.relativePath(queryPath, path);
            var changeTree = ImmutableTree.fromObject(changedChildren);
            var op = new Merge(OperationSource.forServerTaggedQuery(queryId), relativePath, changeTree);
            return this.applyTaggedOperation_(queryPath, op);
        }
        else {
            // We've already removed the query. No big deal, ignore the update
            return [];
        }
    };
    /**
     * Apply a listen complete for a tagged query
     *
     * @return Events to raise.
     */
    SyncTree.prototype.applyTaggedListenComplete = function (path, tag) {
        var queryKey = this.queryKeyForTag_(tag);
        if (queryKey) {
            var r = SyncTree.parseQueryKey_(queryKey);
            var queryPath = r.path, queryId = r.queryId;
            var relativePath = Path.relativePath(queryPath, path);
            var op = new ListenComplete(OperationSource.forServerTaggedQuery(queryId), relativePath);
            return this.applyTaggedOperation_(queryPath, op);
        }
        else {
            // We've already removed the query. No big deal, ignore the update
            return [];
        }
    };
    /**
     * Add an event callback for the specified query.
     *
     * @return Events to raise.
     */
    SyncTree.prototype.addEventRegistration = function (query, eventRegistration) {
        var path = query.path;
        var serverCache = null;
        var foundAncestorDefaultView = false;
        // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
        // Consider optimizing this once there's a better understanding of what actual behavior will be.
        this.syncPointTree_.foreachOnPath(path, function (pathToSyncPoint, sp) {
            var relativePath = Path.relativePath(pathToSyncPoint, path);
            serverCache = serverCache || sp.getCompleteServerCache(relativePath);
            foundAncestorDefaultView =
                foundAncestorDefaultView || sp.hasCompleteView();
        });
        var syncPoint = this.syncPointTree_.get(path);
        if (!syncPoint) {
            syncPoint = new SyncPoint();
            this.syncPointTree_ = this.syncPointTree_.set(path, syncPoint);
        }
        else {
            foundAncestorDefaultView =
                foundAncestorDefaultView || syncPoint.hasCompleteView();
            serverCache = serverCache || syncPoint.getCompleteServerCache(Path.Empty);
        }
        var serverCacheComplete;
        if (serverCache != null) {
            serverCacheComplete = true;
        }
        else {
            serverCacheComplete = false;
            serverCache = ChildrenNode.EMPTY_NODE;
            var subtree = this.syncPointTree_.subtree(path);
            subtree.foreachChild(function (childName, childSyncPoint) {
                var completeCache = childSyncPoint.getCompleteServerCache(Path.Empty);
                if (completeCache) {
                    serverCache = serverCache.updateImmediateChild(childName, completeCache);
                }
            });
        }
        var viewAlreadyExists = syncPoint.viewExistsForQuery(query);
        if (!viewAlreadyExists && !query.getQueryParams().loadsAllData()) {
            // We need to track a tag for this query
            var queryKey = SyncTree.makeQueryKey_(query);
            util.assert(!this.queryToTagMap.has(queryKey), 'View does not exist, but we have a tag');
            var tag = SyncTree.getNextQueryTag_();
            this.queryToTagMap.set(queryKey, tag);
            this.tagToQueryMap.set(tag, queryKey);
        }
        var writesCache = this.pendingWriteTree_.childWrites(path);
        var events = syncPoint.addEventRegistration(query, eventRegistration, writesCache, serverCache, serverCacheComplete);
        if (!viewAlreadyExists && !foundAncestorDefaultView) {
            var view /** @type !View */ = syncPoint.viewForQuery(query);
            events = events.concat(this.setupListener_(query, view));
        }
        return events;
    };
    /**
     * Remove event callback(s).
     *
     * If query is the default query, we'll check all queries for the specified eventRegistration.
     * If eventRegistration is null, we'll remove all callbacks for the specified query/queries.
     *
     * @param eventRegistration If null, all callbacks are removed.
     * @param cancelError If a cancelError is provided, appropriate cancel events will be returned.
     * @return Cancel events, if cancelError was provided.
     */
    SyncTree.prototype.removeEventRegistration = function (query, eventRegistration, cancelError) {
        var _this = this;
        // Find the syncPoint first. Then deal with whether or not it has matching listeners
        var path = query.path;
        var maybeSyncPoint = this.syncPointTree_.get(path);
        var cancelEvents = [];
        // A removal on a default query affects all queries at that location. A removal on an indexed query, even one without
        // other query constraints, does *not* affect all queries at that location. So this check must be for 'default', and
        // not loadsAllData().
        if (maybeSyncPoint &&
            (query.queryIdentifier() === 'default' ||
                maybeSyncPoint.viewExistsForQuery(query))) {
            /**
             * @type {{removed: !Array.<!Query>, events: !Array.<!Event>}}
             */
            var removedAndEvents = maybeSyncPoint.removeEventRegistration(query, eventRegistration, cancelError);
            if (maybeSyncPoint.isEmpty()) {
                this.syncPointTree_ = this.syncPointTree_.remove(path);
            }
            var removed = removedAndEvents.removed;
            cancelEvents = removedAndEvents.events;
            // We may have just removed one of many listeners and can short-circuit this whole process
            // We may also not have removed a default listener, in which case all of the descendant listeners should already be
            // properly set up.
            //
            // Since indexed queries can shadow if they don't have other query constraints, check for loadsAllData(), instead of
            // queryId === 'default'
            var removingDefault = -1 !==
                removed.findIndex(function (query) {
                    return query.getQueryParams().loadsAllData();
                });
            var covered = this.syncPointTree_.findOnPath(path, function (relativePath, parentSyncPoint) {
                return parentSyncPoint.hasCompleteView();
            });
            if (removingDefault && !covered) {
                var subtree = this.syncPointTree_.subtree(path);
                // There are potentially child listeners. Determine what if any listens we need to send before executing the
                // removal
                if (!subtree.isEmpty()) {
                    // We need to fold over our subtree and collect the listeners to send
                    var newViews = this.collectDistinctViewsForSubTree_(subtree);
                    // Ok, we've collected all the listens we need. Set them up.
                    for (var i = 0; i < newViews.length; ++i) {
                        var view = newViews[i], newQuery = view.getQuery();
                        var listener = this.createListenerForView_(view);
                        this.listenProvider_.startListening(SyncTree.queryForListening_(newQuery), this.tagForQuery_(newQuery), listener.hashFn, listener.onComplete);
                    }
                }
            }
            // If we removed anything and we're not covered by a higher up listen, we need to stop listening on this query
            // The above block has us covered in terms of making sure we're set up on listens lower in the tree.
            // Also, note that if we have a cancelError, it's already been removed at the provider level.
            if (!covered && removed.length > 0 && !cancelError) {
                // If we removed a default, then we weren't listening on any of the other queries here. Just cancel the one
                // default. Otherwise, we need to iterate through and cancel each individual query
                if (removingDefault) {
                    // We don't tag default listeners
                    var defaultTag = null;
                    this.listenProvider_.stopListening(SyncTree.queryForListening_(query), defaultTag);
                }
                else {
                    removed.forEach(function (queryToRemove) {
                        var tagToRemove = _this.queryToTagMap.get(SyncTree.makeQueryKey_(queryToRemove));
                        _this.listenProvider_.stopListening(SyncTree.queryForListening_(queryToRemove), tagToRemove);
                    });
                }
            }
            // Now, clear all of the tags we're tracking for the removed listens
            this.removeTags_(removed);
        }
        return cancelEvents;
    };
    /**
     * Returns a complete cache, if we have one, of the data at a particular path. The location must have a listener above
     * it, but as this is only used by transaction code, that should always be the case anyways.
     *
     * Note: this method will *include* hidden writes from transaction with applyLocally set to false.
     *
     * @param path The path to the data we want
     * @param writeIdsToExclude A specific set to be excluded
     */
    SyncTree.prototype.calcCompleteEventCache = function (path, writeIdsToExclude) {
        var includeHiddenSets = true;
        var writeTree = this.pendingWriteTree_;
        var serverCache = this.syncPointTree_.findOnPath(path, function (pathSoFar, syncPoint) {
            var relativePath = Path.relativePath(pathSoFar, path);
            var serverCache = syncPoint.getCompleteServerCache(relativePath);
            if (serverCache) {
                return serverCache;
            }
        });
        return writeTree.calcCompleteEventCache(path, serverCache, writeIdsToExclude, includeHiddenSets);
    };
    /**
     * This collapses multiple unfiltered views into a single view, since we only need a single
     * listener for them.
     */
    SyncTree.prototype.collectDistinctViewsForSubTree_ = function (subtree) {
        return subtree.fold(function (relativePath, maybeChildSyncPoint, childMap) {
            if (maybeChildSyncPoint && maybeChildSyncPoint.hasCompleteView()) {
                var completeView = maybeChildSyncPoint.getCompleteView();
                return [completeView];
            }
            else {
                // No complete view here, flatten any deeper listens into an array
                var views_1 = [];
                if (maybeChildSyncPoint) {
                    views_1 = maybeChildSyncPoint.getQueryViews();
                }
                each(childMap, function (_key, childViews) {
                    views_1 = views_1.concat(childViews);
                });
                return views_1;
            }
        });
    };
    SyncTree.prototype.removeTags_ = function (queries) {
        for (var j = 0; j < queries.length; ++j) {
            var removedQuery = queries[j];
            if (!removedQuery.getQueryParams().loadsAllData()) {
                // We should have a tag for this
                var removedQueryKey = SyncTree.makeQueryKey_(removedQuery);
                var removedQueryTag = this.queryToTagMap.get(removedQueryKey);
                this.queryToTagMap.delete(removedQueryKey);
                this.tagToQueryMap.delete(removedQueryTag);
            }
        }
    };
    /**
     * Normalizes a query to a query we send the server for listening
     *
     * @return The normalized query
     */
    SyncTree.queryForListening_ = function (query) {
        if (query.getQueryParams().loadsAllData() &&
            !query.getQueryParams().isDefault()) {
            // We treat queries that load all data as default queries
            // Cast is necessary because ref() technically returns Firebase which is actually fb.api.Firebase which inherits
            // from Query
            return query.getRef();
        }
        else {
            return query;
        }
    };
    /**
     * For a given new listen, manage the de-duplication of outstanding subscriptions.
     *
     * @return This method can return events to support synchronous data sources
     */
    SyncTree.prototype.setupListener_ = function (query, view) {
        var path = query.path;
        var tag = this.tagForQuery_(query);
        var listener = this.createListenerForView_(view);
        var events = this.listenProvider_.startListening(SyncTree.queryForListening_(query), tag, listener.hashFn, listener.onComplete);
        var subtree = this.syncPointTree_.subtree(path);
        // The root of this subtree has our query. We're here because we definitely need to send a listen for that, but we
        // may need to shadow other listens as well.
        if (tag) {
            util.assert(!subtree.value.hasCompleteView(), "If we're adding a query, it shouldn't be shadowed");
        }
        else {
            // Shadow everything at or below this location, this is a default listener.
            var queriesToStop = subtree.fold(function (relativePath, maybeChildSyncPoint, childMap) {
                if (!relativePath.isEmpty() &&
                    maybeChildSyncPoint &&
                    maybeChildSyncPoint.hasCompleteView()) {
                    return [maybeChildSyncPoint.getCompleteView().getQuery()];
                }
                else {
                    // No default listener here, flatten any deeper queries into an array
                    var queries_1 = [];
                    if (maybeChildSyncPoint) {
                        queries_1 = queries_1.concat(maybeChildSyncPoint.getQueryViews().map(function (view) { return view.getQuery(); }));
                    }
                    each(childMap, function (_key, childQueries) {
                        queries_1 = queries_1.concat(childQueries);
                    });
                    return queries_1;
                }
            });
            for (var i = 0; i < queriesToStop.length; ++i) {
                var queryToStop = queriesToStop[i];
                this.listenProvider_.stopListening(SyncTree.queryForListening_(queryToStop), this.tagForQuery_(queryToStop));
            }
        }
        return events;
    };
    SyncTree.prototype.createListenerForView_ = function (view) {
        var _this = this;
        var query = view.getQuery();
        var tag = this.tagForQuery_(query);
        return {
            hashFn: function () {
                var cache = view.getServerCache() || ChildrenNode.EMPTY_NODE;
                return cache.hash();
            },
            onComplete: function (status) {
                if (status === 'ok') {
                    if (tag) {
                        return _this.applyTaggedListenComplete(query.path, tag);
                    }
                    else {
                        return _this.applyListenComplete(query.path);
                    }
                }
                else {
                    // If a listen failed, kill all of the listeners here, not just the one that triggered the error.
                    // Note that this may need to be scoped to just this listener if we change permissions on filtered children
                    var error = errorForServerCode(status, query);
                    return _this.removeEventRegistration(query, 
                    /*eventRegistration*/ null, error);
                }
            }
        };
    };
    /**
     * Given a query, computes a "queryKey" suitable for use in our queryToTagMap_.
     */
    SyncTree.makeQueryKey_ = function (query) {
        return query.path.toString() + '$' + query.queryIdentifier();
    };
    /**
     * Given a queryKey (created by makeQueryKey), parse it back into a path and queryId.
     */
    SyncTree.parseQueryKey_ = function (queryKey) {
        var splitIndex = queryKey.indexOf('$');
        util.assert(splitIndex !== -1 && splitIndex < queryKey.length - 1, 'Bad queryKey.');
        return {
            queryId: queryKey.substr(splitIndex + 1),
            path: new Path(queryKey.substr(0, splitIndex))
        };
    };
    /**
     * Return the query associated with the given tag, if we have one
     */
    SyncTree.prototype.queryKeyForTag_ = function (tag) {
        return this.tagToQueryMap.get(tag);
    };
    /**
     * Return the tag associated with the given query.
     */
    SyncTree.prototype.tagForQuery_ = function (query) {
        var queryKey = SyncTree.makeQueryKey_(query);
        return this.queryToTagMap.get(queryKey);
    };
    /**
     * Static accessor for query tags.
     */
    SyncTree.getNextQueryTag_ = function () {
        return SyncTree.nextQueryTag_++;
    };
    /**
     * A helper method to apply tagged operations
     */
    SyncTree.prototype.applyTaggedOperation_ = function (queryPath, operation) {
        var syncPoint = this.syncPointTree_.get(queryPath);
        util.assert(syncPoint, "Missing sync point for query tag that we're tracking");
        var writesCache = this.pendingWriteTree_.childWrites(queryPath);
        return syncPoint.applyOperation(operation, writesCache, 
        /*serverCache=*/ null);
    };
    /**
     * A helper method that visits all descendant and ancestor SyncPoints, applying the operation.
     *
     * NOTES:
     * - Descendant SyncPoints will be visited first (since we raise events depth-first).
  
     * - We call applyOperation() on each SyncPoint passing three things:
     *   1. A version of the Operation that has been made relative to the SyncPoint location.
     *   2. A WriteTreeRef of any writes we have cached at the SyncPoint location.
     *   3. A snapshot Node with cached server data, if we have it.
  
     * - We concatenate all of the events returned by each SyncPoint and return the result.
     */
    SyncTree.prototype.applyOperationToSyncPoints_ = function (operation) {
        return this.applyOperationHelper_(operation, this.syncPointTree_, 
        /*serverCache=*/ null, this.pendingWriteTree_.childWrites(Path.Empty));
    };
    /**
     * Recursive helper for applyOperationToSyncPoints_
     */
    SyncTree.prototype.applyOperationHelper_ = function (operation, syncPointTree, serverCache, writesCache) {
        if (operation.path.isEmpty()) {
            return this.applyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache);
        }
        else {
            var syncPoint = syncPointTree.get(Path.Empty);
            // If we don't have cached server data, see if we can get it from this SyncPoint.
            if (serverCache == null && syncPoint != null) {
                serverCache = syncPoint.getCompleteServerCache(Path.Empty);
            }
            var events = [];
            var childName = operation.path.getFront();
            var childOperation = operation.operationForChild(childName);
            var childTree = syncPointTree.children.get(childName);
            if (childTree && childOperation) {
                var childServerCache = serverCache
                    ? serverCache.getImmediateChild(childName)
                    : null;
                var childWritesCache = writesCache.child(childName);
                events = events.concat(this.applyOperationHelper_(childOperation, childTree, childServerCache, childWritesCache));
            }
            if (syncPoint) {
                events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
            }
            return events;
        }
    };
    /**
     * Recursive helper for applyOperationToSyncPoints_
     */
    SyncTree.prototype.applyOperationDescendantsHelper_ = function (operation, syncPointTree, serverCache, writesCache) {
        var _this = this;
        var syncPoint = syncPointTree.get(Path.Empty);
        // If we don't have cached server data, see if we can get it from this SyncPoint.
        if (serverCache == null && syncPoint != null) {
            serverCache = syncPoint.getCompleteServerCache(Path.Empty);
        }
        var events = [];
        syncPointTree.children.inorderTraversal(function (childName, childTree) {
            var childServerCache = serverCache
                ? serverCache.getImmediateChild(childName)
                : null;
            var childWritesCache = writesCache.child(childName);
            var childOperation = operation.operationForChild(childName);
            if (childOperation) {
                events = events.concat(_this.applyOperationDescendantsHelper_(childOperation, childTree, childServerCache, childWritesCache));
            }
        });
        if (syncPoint) {
            events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
        }
        return events;
    };
    /**
     * Static tracker for next query tag.
     */
    SyncTree.nextQueryTag_ = 1;
    return SyncTree;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Mutable object which basically just stores a reference to the "latest" immutable snapshot.
 *
 * @constructor
 */
var SnapshotHolder = /** @class */ (function () {
    function SnapshotHolder() {
        this.rootNode_ = ChildrenNode.EMPTY_NODE;
    }
    SnapshotHolder.prototype.getNode = function (path) {
        return this.rootNode_.getChild(path);
    };
    SnapshotHolder.prototype.updateSnapshot = function (path, newSnapshotNode) {
        this.rootNode_ = this.rootNode_.updateChild(path, newSnapshotNode);
    };
    return SnapshotHolder;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Abstraction around FirebaseApp's token fetching capabilities.
 */
var AuthTokenProvider = /** @class */ (function () {
    /**
     * @param {!FirebaseApp} app_
     */
    function AuthTokenProvider(app_) {
        this.app_ = app_;
    }
    /**
     * @param {boolean} forceRefresh
     * @return {!Promise<FirebaseAuthTokenData>}
     */
    AuthTokenProvider.prototype.getToken = function (forceRefresh) {
        return this.app_['INTERNAL']['getToken'](forceRefresh).then(null, 
        // .catch
        function (error) {
            // TODO: Need to figure out all the cases this is raised and whether
            // this makes sense.
            if (error && error.code === 'auth/token-not-initialized') {
                log('Got auth/token-not-initialized error.  Treating as null token.');
                return null;
            }
            else {
                return Promise.reject(error);
            }
        });
    };
    AuthTokenProvider.prototype.addTokenChangeListener = function (listener) {
        // TODO: We might want to wrap the listener and call it with no args to
        // avoid a leaky abstraction, but that makes removing the listener harder.
        this.app_['INTERNAL']['addAuthTokenListener'](listener);
    };
    AuthTokenProvider.prototype.removeTokenChangeListener = function (listener) {
        this.app_['INTERNAL']['removeAuthTokenListener'](listener);
    };
    AuthTokenProvider.prototype.notifyForInvalidToken = function () {
        var errorMessage = 'Provided authentication credentials for the app named "' +
            this.app_.name +
            '" are invalid. This usually indicates your app was not ' +
            'initialized correctly. ';
        if ('credential' in this.app_.options) {
            errorMessage +=
                'Make sure the "credential" property provided to initializeApp() ' +
                    'is authorized to access the specified "databaseURL" and is from the correct ' +
                    'project.';
        }
        else if ('serviceAccount' in this.app_.options) {
            errorMessage +=
                'Make sure the "serviceAccount" property provided to initializeApp() ' +
                    'is authorized to access the specified "databaseURL" and is from the correct ' +
                    'project.';
        }
        else {
            errorMessage +=
                'Make sure the "apiKey" and "databaseURL" properties provided to ' +
                    'initializeApp() match the values provided for your app at ' +
                    'https://console.firebase.google.com/.';
        }
        warn(errorMessage);
    };
    return AuthTokenProvider;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Tracks a collection of stats.
 *
 * @constructor
 */
var StatsCollection = /** @class */ (function () {
    function StatsCollection() {
        this.counters_ = {};
    }
    StatsCollection.prototype.incrementCounter = function (name, amount) {
        if (amount === void 0) { amount = 1; }
        if (!util.contains(this.counters_, name))
            this.counters_[name] = 0;
        this.counters_[name] += amount;
    };
    StatsCollection.prototype.get = function () {
        return util.deepCopy(this.counters_);
    };
    return StatsCollection;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var StatsManager = /** @class */ (function () {
    function StatsManager() {
    }
    StatsManager.getCollection = function (repoInfo) {
        var hashString = repoInfo.toString();
        if (!this.collections_[hashString]) {
            this.collections_[hashString] = new StatsCollection();
        }
        return this.collections_[hashString];
    };
    StatsManager.getOrCreateReporter = function (repoInfo, creatorFunction) {
        var hashString = repoInfo.toString();
        if (!this.reporters_[hashString]) {
            this.reporters_[hashString] = creatorFunction();
        }
        return this.reporters_[hashString];
    };
    StatsManager.collections_ = {};
    StatsManager.reporters_ = {};
    return StatsManager;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns the delta from the previous call to get stats.
 *
 * @param collection_ The collection to "listen" to.
 * @constructor
 */
var StatsListener = /** @class */ (function () {
    function StatsListener(collection_) {
        this.collection_ = collection_;
        this.last_ = null;
    }
    StatsListener.prototype.get = function () {
        var newStats = this.collection_.get();
        var delta = tslib.__assign({}, newStats);
        if (this.last_) {
            each(this.last_, function (stat, value) {
                delta[stat] = delta[stat] - value;
            });
        }
        this.last_ = newStats;
        return delta;
    };
    return StatsListener;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Assuming some apps may have a short amount of time on page, and a bulk of firebase operations probably
// happen on page load, we try to report our first set of stats pretty quickly, but we wait at least 10
// seconds to try to ensure the Firebase connection is established / settled.
var FIRST_STATS_MIN_TIME = 10 * 1000;
var FIRST_STATS_MAX_TIME = 30 * 1000;
// We'll continue to report stats on average every 5 minutes.
var REPORT_STATS_INTERVAL = 5 * 60 * 1000;
/**
 * @constructor
 */
var StatsReporter = /** @class */ (function () {
    /**
     * @param collection
     * @param server_
     */
    function StatsReporter(collection, server_) {
        this.server_ = server_;
        this.statsToReport_ = {};
        this.statsListener_ = new StatsListener(collection);
        var timeout = FIRST_STATS_MIN_TIME +
            (FIRST_STATS_MAX_TIME - FIRST_STATS_MIN_TIME) * Math.random();
        setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(timeout));
    }
    StatsReporter.prototype.includeStat = function (stat) {
        this.statsToReport_[stat] = true;
    };
    StatsReporter.prototype.reportStats_ = function () {
        var _this = this;
        var stats = this.statsListener_.get();
        var reportedStats = {};
        var haveStatsToReport = false;
        each(stats, function (stat, value) {
            if (value > 0 && util.contains(_this.statsToReport_, stat)) {
                reportedStats[stat] = value;
                haveStatsToReport = true;
            }
        });
        if (haveStatsToReport) {
            this.server_.reportStats(reportedStats);
        }
        // queue our next run.
        setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(Math.random() * 2 * REPORT_STATS_INTERVAL));
    };
    return StatsReporter;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The event queue serves a few purposes:
 * 1. It ensures we maintain event order in the face of event callbacks doing operations that result in more
 *    events being queued.
 * 2. raiseQueuedEvents() handles being called reentrantly nicely.  That is, if in the course of raising events,
 *    raiseQueuedEvents() is called again, the "inner" call will pick up raising events where the "outer" call
 *    left off, ensuring that the events are still raised synchronously and in order.
 * 3. You can use raiseEventsAtPath and raiseEventsForChangedPath to ensure only relevant previously-queued
 *    events are raised synchronously.
 *
 * NOTE: This can all go away if/when we move to async events.
 *
 * @constructor
 */
var EventQueue = /** @class */ (function () {
    function EventQueue() {
        /**
         * @private
         * @type {!Array.<EventList>}
         */
        this.eventLists_ = [];
        /**
         * Tracks recursion depth of raiseQueuedEvents_, for debugging purposes.
         * @private
         * @type {!number}
         */
        this.recursionDepth_ = 0;
    }
    /**
     * @param {!Array.<Event>} eventDataList The new events to queue.
     */
    EventQueue.prototype.queueEvents = function (eventDataList) {
        // We group events by path, storing them in a single EventList, to make it easier to skip over them quickly.
        var currList = null;
        for (var i = 0; i < eventDataList.length; i++) {
            var eventData = eventDataList[i];
            var eventPath = eventData.getPath();
            if (currList !== null && !eventPath.equals(currList.getPath())) {
                this.eventLists_.push(currList);
                currList = null;
            }
            if (currList === null) {
                currList = new EventList(eventPath);
            }
            currList.add(eventData);
        }
        if (currList) {
            this.eventLists_.push(currList);
        }
    };
    /**
     * Queues the specified events and synchronously raises all events (including previously queued ones)
     * for the specified path.
     *
     * It is assumed that the new events are all for the specified path.
     *
     * @param {!Path} path The path to raise events for.
     * @param {!Array.<Event>} eventDataList The new events to raise.
     */
    EventQueue.prototype.raiseEventsAtPath = function (path, eventDataList) {
        this.queueEvents(eventDataList);
        this.raiseQueuedEventsMatchingPredicate_(function (eventPath) {
            return eventPath.equals(path);
        });
    };
    /**
     * Queues the specified events and synchronously raises all events (including previously queued ones) for
     * locations related to the specified change path (i.e. all ancestors and descendants).
     *
     * It is assumed that the new events are all related (ancestor or descendant) to the specified path.
     *
     * @param {!Path} changedPath The path to raise events for.
     * @param {!Array.<!Event>} eventDataList The events to raise
     */
    EventQueue.prototype.raiseEventsForChangedPath = function (changedPath, eventDataList) {
        this.queueEvents(eventDataList);
        this.raiseQueuedEventsMatchingPredicate_(function (eventPath) {
            return eventPath.contains(changedPath) || changedPath.contains(eventPath);
        });
    };
    /**
     * @param {!function(!Path):boolean} predicate
     * @private
     */
    EventQueue.prototype.raiseQueuedEventsMatchingPredicate_ = function (predicate) {
        this.recursionDepth_++;
        var sentAll = true;
        for (var i = 0; i < this.eventLists_.length; i++) {
            var eventList = this.eventLists_[i];
            if (eventList) {
                var eventPath = eventList.getPath();
                if (predicate(eventPath)) {
                    this.eventLists_[i].raise();
                    this.eventLists_[i] = null;
                }
                else {
                    sentAll = false;
                }
            }
        }
        if (sentAll) {
            this.eventLists_ = [];
        }
        this.recursionDepth_--;
    };
    return EventQueue;
}());
/**
 * @param {!Path} path
 * @constructor
 */
var EventList = /** @class */ (function () {
    function EventList(path_) {
        this.path_ = path_;
        /**
         * @type {!Array.<Event>}
         * @private
         */
        this.events_ = [];
    }
    /**
     * @param {!Event} eventData
     */
    EventList.prototype.add = function (eventData) {
        this.events_.push(eventData);
    };
    /**
     * Iterates through the list and raises each event
     */
    EventList.prototype.raise = function () {
        for (var i = 0; i < this.events_.length; i++) {
            var eventData = this.events_[i];
            if (eventData !== null) {
                this.events_[i] = null;
                var eventFn = eventData.getEventRunner();
                if (logger) {
                    log('event: ' + eventData.toString());
                }
                exceptionGuard(eventFn);
            }
        }
    };
    /**
     * @return {!Path}
     */
    EventList.prototype.getPath = function () {
        return this.path_;
    };
    return EventList;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Base class to be used if you want to emit events. Call the constructor with
 * the set of allowed event names.
 */
var EventEmitter = /** @class */ (function () {
    /**
     * @param {!Array.<string>} allowedEvents_
     */
    function EventEmitter(allowedEvents_) {
        this.allowedEvents_ = allowedEvents_;
        this.listeners_ = {};
        util.assert(Array.isArray(allowedEvents_) && allowedEvents_.length > 0, 'Requires a non-empty array');
    }
    /**
     * To be called by derived classes to trigger events.
     * @param {!string} eventType
     * @param {...*} var_args
     */
    EventEmitter.prototype.trigger = function (eventType) {
        var var_args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            var_args[_i - 1] = arguments[_i];
        }
        if (Array.isArray(this.listeners_[eventType])) {
            // Clone the list, since callbacks could add/remove listeners.
            var listeners = tslib.__spread(this.listeners_[eventType]);
            for (var i = 0; i < listeners.length; i++) {
                listeners[i].callback.apply(listeners[i].context, var_args);
            }
        }
    };
    EventEmitter.prototype.on = function (eventType, callback, context) {
        this.validateEventType_(eventType);
        this.listeners_[eventType] = this.listeners_[eventType] || [];
        this.listeners_[eventType].push({ callback: callback, context: context });
        var eventData = this.getInitialEvent(eventType);
        if (eventData) {
            callback.apply(context, eventData);
        }
    };
    EventEmitter.prototype.off = function (eventType, callback, context) {
        this.validateEventType_(eventType);
        var listeners = this.listeners_[eventType] || [];
        for (var i = 0; i < listeners.length; i++) {
            if (listeners[i].callback === callback &&
                (!context || context === listeners[i].context)) {
                listeners.splice(i, 1);
                return;
            }
        }
    };
    EventEmitter.prototype.validateEventType_ = function (eventType) {
        util.assert(this.allowedEvents_.find(function (et) {
            return et === eventType;
        }), 'Unknown event: ' + eventType);
    };
    return EventEmitter;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @extends {EventEmitter}
 */
var VisibilityMonitor = /** @class */ (function (_super) {
    tslib.__extends(VisibilityMonitor, _super);
    function VisibilityMonitor() {
        var _this = _super.call(this, ['visible']) || this;
        var hidden;
        var visibilityChange;
        if (typeof document !== 'undefined' &&
            typeof document.addEventListener !== 'undefined') {
            if (typeof document['hidden'] !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                visibilityChange = 'visibilitychange';
                hidden = 'hidden';
            }
            else if (typeof document['mozHidden'] !== 'undefined') {
                visibilityChange = 'mozvisibilitychange';
                hidden = 'mozHidden';
            }
            else if (typeof document['msHidden'] !== 'undefined') {
                visibilityChange = 'msvisibilitychange';
                hidden = 'msHidden';
            }
            else if (typeof document['webkitHidden'] !== 'undefined') {
                visibilityChange = 'webkitvisibilitychange';
                hidden = 'webkitHidden';
            }
        }
        // Initially, we always assume we are visible. This ensures that in browsers
        // without page visibility support or in cases where we are never visible
        // (e.g. chrome extension), we act as if we are visible, i.e. don't delay
        // reconnects
        _this.visible_ = true;
        if (visibilityChange) {
            document.addEventListener(visibilityChange, function () {
                var visible = !document[hidden];
                if (visible !== _this.visible_) {
                    _this.visible_ = visible;
                    _this.trigger('visible', visible);
                }
            }, false);
        }
        return _this;
    }
    VisibilityMonitor.getInstance = function () {
        return new VisibilityMonitor();
    };
    /**
     * @param {!string} eventType
     * @return {Array.<boolean>}
     */
    VisibilityMonitor.prototype.getInitialEvent = function (eventType) {
        util.assert(eventType === 'visible', 'Unknown event type: ' + eventType);
        return [this.visible_];
    };
    return VisibilityMonitor;
}(EventEmitter));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Monitors online state (as reported by window.online/offline events).
 *
 * The expectation is that this could have many false positives (thinks we are online
 * when we're not), but no false negatives.  So we can safely use it to determine when
 * we definitely cannot reach the internet.
 *
 * @extends {EventEmitter}
 */
var OnlineMonitor = /** @class */ (function (_super) {
    tslib.__extends(OnlineMonitor, _super);
    function OnlineMonitor() {
        var _this = _super.call(this, ['online']) || this;
        _this.online_ = true;
        // We've had repeated complaints that Cordova apps can get stuck "offline", e.g.
        // https://forum.ionicframework.com/t/firebase-connection-is-lost-and-never-come-back/43810
        // It would seem that the 'online' event does not always fire consistently. So we disable it
        // for Cordova.
        if (typeof window !== 'undefined' &&
            typeof window.addEventListener !== 'undefined' &&
            !util.isMobileCordova()) {
            window.addEventListener('online', function () {
                if (!_this.online_) {
                    _this.online_ = true;
                    _this.trigger('online', true);
                }
            }, false);
            window.addEventListener('offline', function () {
                if (_this.online_) {
                    _this.online_ = false;
                    _this.trigger('online', false);
                }
            }, false);
        }
        return _this;
    }
    OnlineMonitor.getInstance = function () {
        return new OnlineMonitor();
    };
    /**
     * @param {!string} eventType
     * @return {Array.<boolean>}
     */
    OnlineMonitor.prototype.getInitialEvent = function (eventType) {
        util.assert(eventType === 'online', 'Unknown event type: ' + eventType);
        return [this.online_];
    };
    /**
     * @return {boolean}
     */
    OnlineMonitor.prototype.currentlyOnline = function () {
        return this.online_;
    };
    return OnlineMonitor;
}(EventEmitter));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * This class ensures the packets from the server arrive in order
 * This class takes data from the server and ensures it gets passed into the callbacks in order.
 * @constructor
 */
var PacketReceiver = /** @class */ (function () {
    /**
     * @param onMessage_
     */
    function PacketReceiver(onMessage_) {
        this.onMessage_ = onMessage_;
        this.pendingResponses = [];
        this.currentResponseNum = 0;
        this.closeAfterResponse = -1;
        this.onClose = null;
    }
    PacketReceiver.prototype.closeAfter = function (responseNum, callback) {
        this.closeAfterResponse = responseNum;
        this.onClose = callback;
        if (this.closeAfterResponse < this.currentResponseNum) {
            this.onClose();
            this.onClose = null;
        }
    };
    /**
     * Each message from the server comes with a response number, and an array of data. The responseNumber
     * allows us to ensure that we process them in the right order, since we can't be guaranteed that all
     * browsers will respond in the same order as the requests we sent
     * @param {number} requestNum
     * @param {Array} data
     */
    PacketReceiver.prototype.handleResponse = function (requestNum, data) {
        var _this = this;
        this.pendingResponses[requestNum] = data;
        var _loop_1 = function () {
            var toProcess = this_1.pendingResponses[this_1.currentResponseNum];
            delete this_1.pendingResponses[this_1.currentResponseNum];
            var _loop_2 = function (i) {
                if (toProcess[i]) {
                    exceptionGuard(function () {
                        _this.onMessage_(toProcess[i]);
                    });
                }
            };
            for (var i = 0; i < toProcess.length; ++i) {
                _loop_2(i);
            }
            if (this_1.currentResponseNum === this_1.closeAfterResponse) {
                if (this_1.onClose) {
                    this_1.onClose();
                    this_1.onClose = null;
                }
                return "break";
            }
            this_1.currentResponseNum++;
        };
        var this_1 = this;
        while (this.pendingResponses[this.currentResponseNum]) {
            var state_1 = _loop_1();
            if (state_1 === "break")
                break;
        }
    };
    return PacketReceiver;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// URL query parameters associated with longpolling
var FIREBASE_LONGPOLL_START_PARAM = 'start';
var FIREBASE_LONGPOLL_CLOSE_COMMAND = 'close';
var FIREBASE_LONGPOLL_COMMAND_CB_NAME = 'pLPCommand';
var FIREBASE_LONGPOLL_DATA_CB_NAME = 'pRTLPCB';
var FIREBASE_LONGPOLL_ID_PARAM = 'id';
var FIREBASE_LONGPOLL_PW_PARAM = 'pw';
var FIREBASE_LONGPOLL_SERIAL_PARAM = 'ser';
var FIREBASE_LONGPOLL_CALLBACK_ID_PARAM = 'cb';
var FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM = 'seg';
var FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET = 'ts';
var FIREBASE_LONGPOLL_DATA_PARAM = 'd';
var FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM = 'dframe';
//Data size constants.
//TODO: Perf: the maximum length actually differs from browser to browser.
// We should check what browser we're on and set accordingly.
var MAX_URL_DATA_SIZE = 1870;
var SEG_HEADER_SIZE = 30; //ie: &seg=8299234&ts=982389123&d=
var MAX_PAYLOAD_SIZE = MAX_URL_DATA_SIZE - SEG_HEADER_SIZE;
/**
 * Keepalive period
 * send a fresh request at minimum every 25 seconds. Opera has a maximum request
 * length of 30 seconds that we can't exceed.
 * @const
 * @type {number}
 */
var KEEPALIVE_REQUEST_INTERVAL = 25000;
/**
 * How long to wait before aborting a long-polling connection attempt.
 * @const
 * @type {number}
 */
var LP_CONNECT_TIMEOUT = 30000;
/**
 * This class manages a single long-polling connection.
 *
 * @constructor
 * @implements {Transport}
 */
var BrowserPollConnection = /** @class */ (function () {
    /**
     * @param {string} connId An identifier for this connection, used for logging
     * @param {RepoInfo} repoInfo The info for the endpoint to send data to.
     * @param {string=} transportSessionId Optional transportSessionid if we are reconnecting for an existing
     *                                         transport session
     * @param {string=}  lastSessionId Optional lastSessionId if the PersistentConnection has already created a
     *                                     connection previously
     */
    function BrowserPollConnection(connId, repoInfo, transportSessionId, lastSessionId) {
        this.connId = connId;
        this.repoInfo = repoInfo;
        this.transportSessionId = transportSessionId;
        this.lastSessionId = lastSessionId;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.everConnected_ = false;
        this.log_ = logWrapper(connId);
        this.stats_ = StatsManager.getCollection(repoInfo);
        this.urlFn = function (params) {
            return repoInfo.connectionURL(LONG_POLLING, params);
        };
    }
    /**
     *
     * @param {function(Object)} onMessage Callback when messages arrive
     * @param {function()} onDisconnect Callback with connection lost.
     */
    BrowserPollConnection.prototype.open = function (onMessage, onDisconnect) {
        var _this = this;
        this.curSegmentNum = 0;
        this.onDisconnect_ = onDisconnect;
        this.myPacketOrderer = new PacketReceiver(onMessage);
        this.isClosed_ = false;
        this.connectTimeoutTimer_ = setTimeout(function () {
            _this.log_('Timed out trying to connect.');
            // Make sure we clear the host cache
            _this.onClosed_();
            _this.connectTimeoutTimer_ = null;
        }, Math.floor(LP_CONNECT_TIMEOUT));
        // Ensure we delay the creation of the iframe until the DOM is loaded.
        executeWhenDOMReady(function () {
            if (_this.isClosed_)
                return;
            //Set up a callback that gets triggered once a connection is set up.
            _this.scriptTagHolder = new FirebaseIFrameScriptHolder(function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var _a = tslib.__read(args, 5), command = _a[0], arg1 = _a[1], arg2 = _a[2], arg3 = _a[3], arg4 = _a[4];
                _this.incrementIncomingBytes_(args);
                if (!_this.scriptTagHolder)
                    return; // we closed the connection.
                if (_this.connectTimeoutTimer_) {
                    clearTimeout(_this.connectTimeoutTimer_);
                    _this.connectTimeoutTimer_ = null;
                }
                _this.everConnected_ = true;
                if (command == FIREBASE_LONGPOLL_START_PARAM) {
                    _this.id = arg1;
                    _this.password = arg2;
                }
                else if (command === FIREBASE_LONGPOLL_CLOSE_COMMAND) {
                    // Don't clear the host cache. We got a response from the server, so we know it's reachable
                    if (arg1) {
                        // We aren't expecting any more data (other than what the server's already in the process of sending us
                        // through our already open polls), so don't send any more.
                        _this.scriptTagHolder.sendNewPolls = false;
                        // arg1 in this case is the last response number sent by the server. We should try to receive
                        // all of the responses up to this one before closing
                        _this.myPacketOrderer.closeAfter(arg1, function () {
                            _this.onClosed_();
                        });
                    }
                    else {
                        _this.onClosed_();
                    }
                }
                else {
                    throw new Error('Unrecognized command received: ' + command);
                }
            }, function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var _a = tslib.__read(args, 2), pN = _a[0], data = _a[1];
                _this.incrementIncomingBytes_(args);
                _this.myPacketOrderer.handleResponse(pN, data);
            }, function () {
                _this.onClosed_();
            }, _this.urlFn);
            //Send the initial request to connect. The serial number is simply to keep the browser from pulling previous results
            //from cache.
            var urlParams = {};
            urlParams[FIREBASE_LONGPOLL_START_PARAM] = 't';
            urlParams[FIREBASE_LONGPOLL_SERIAL_PARAM] = Math.floor(Math.random() * 100000000);
            if (_this.scriptTagHolder.uniqueCallbackIdentifier)
                urlParams[FIREBASE_LONGPOLL_CALLBACK_ID_PARAM] = _this.scriptTagHolder.uniqueCallbackIdentifier;
            urlParams[VERSION_PARAM] = PROTOCOL_VERSION;
            if (_this.transportSessionId) {
                urlParams[TRANSPORT_SESSION_PARAM] = _this.transportSessionId;
            }
            if (_this.lastSessionId) {
                urlParams[LAST_SESSION_PARAM] = _this.lastSessionId;
            }
            if (typeof location !== 'undefined' &&
                location.href &&
                location.href.indexOf(FORGE_DOMAIN) !== -1) {
                urlParams[REFERER_PARAM] = FORGE_REF;
            }
            var connectURL = _this.urlFn(urlParams);
            _this.log_('Connecting via long-poll to ' + connectURL);
            _this.scriptTagHolder.addTag(connectURL, function () {
                /* do nothing */
            });
        });
    };
    /**
     * Call this when a handshake has completed successfully and we want to consider the connection established
     */
    BrowserPollConnection.prototype.start = function () {
        this.scriptTagHolder.startLongPoll(this.id, this.password);
        this.addDisconnectPingFrame(this.id, this.password);
    };
    /**
     * Forces long polling to be considered as a potential transport
     */
    BrowserPollConnection.forceAllow = function () {
        BrowserPollConnection.forceAllow_ = true;
    };
    /**
     * Forces longpolling to not be considered as a potential transport
     */
    BrowserPollConnection.forceDisallow = function () {
        BrowserPollConnection.forceDisallow_ = true;
    };
    // Static method, use string literal so it can be accessed in a generic way
    BrowserPollConnection.isAvailable = function () {
        if (util.isNodeSdk()) {
            return false;
        }
        else if (BrowserPollConnection.forceAllow_) {
            return true;
        }
        else {
            // NOTE: In React-Native there's normally no 'document', but if you debug a React-Native app in
            // the Chrome debugger, 'document' is defined, but document.createElement is null (2015/06/08).
            return (!BrowserPollConnection.forceDisallow_ &&
                typeof document !== 'undefined' &&
                document.createElement != null &&
                !isChromeExtensionContentScript() &&
                !isWindowsStoreApp());
        }
    };
    /**
     * No-op for polling
     */
    BrowserPollConnection.prototype.markConnectionHealthy = function () { };
    /**
     * Stops polling and cleans up the iframe
     * @private
     */
    BrowserPollConnection.prototype.shutdown_ = function () {
        this.isClosed_ = true;
        if (this.scriptTagHolder) {
            this.scriptTagHolder.close();
            this.scriptTagHolder = null;
        }
        //remove the disconnect frame, which will trigger an XHR call to the server to tell it we're leaving.
        if (this.myDisconnFrame) {
            document.body.removeChild(this.myDisconnFrame);
            this.myDisconnFrame = null;
        }
        if (this.connectTimeoutTimer_) {
            clearTimeout(this.connectTimeoutTimer_);
            this.connectTimeoutTimer_ = null;
        }
    };
    /**
     * Triggered when this transport is closed
     * @private
     */
    BrowserPollConnection.prototype.onClosed_ = function () {
        if (!this.isClosed_) {
            this.log_('Longpoll is closing itself');
            this.shutdown_();
            if (this.onDisconnect_) {
                this.onDisconnect_(this.everConnected_);
                this.onDisconnect_ = null;
            }
        }
    };
    /**
     * External-facing close handler. RealTime has requested we shut down. Kill our connection and tell the server
     * that we've left.
     */
    BrowserPollConnection.prototype.close = function () {
        if (!this.isClosed_) {
            this.log_('Longpoll is being closed.');
            this.shutdown_();
        }
    };
    /**
     * Send the JSON object down to the server. It will need to be stringified, base64 encoded, and then
     * broken into chunks (since URLs have a small maximum length).
     * @param {!Object} data The JSON data to transmit.
     */
    BrowserPollConnection.prototype.send = function (data) {
        var dataStr = util.stringify(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter('bytes_sent', dataStr.length);
        //first, lets get the base64-encoded data
        var base64data = util.base64Encode(dataStr);
        //We can only fit a certain amount in each URL, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        var dataSegs = splitStringBySize(base64data, MAX_PAYLOAD_SIZE);
        //Enqueue each segment for transmission. We assign each chunk a sequential ID and a total number
        //of segments so that we can reassemble the packet on the server.
        for (var i = 0; i < dataSegs.length; i++) {
            this.scriptTagHolder.enqueueSegment(this.curSegmentNum, dataSegs.length, dataSegs[i]);
            this.curSegmentNum++;
        }
    };
    /**
     * This is how we notify the server that we're leaving.
     * We aren't able to send requests with DHTML on a window close event, but we can
     * trigger XHR requests in some browsers (everything but Opera basically).
     * @param {!string} id
     * @param {!string} pw
     */
    BrowserPollConnection.prototype.addDisconnectPingFrame = function (id, pw) {
        if (util.isNodeSdk())
            return;
        this.myDisconnFrame = document.createElement('iframe');
        var urlParams = {};
        urlParams[FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM] = 't';
        urlParams[FIREBASE_LONGPOLL_ID_PARAM] = id;
        urlParams[FIREBASE_LONGPOLL_PW_PARAM] = pw;
        this.myDisconnFrame.src = this.urlFn(urlParams);
        this.myDisconnFrame.style.display = 'none';
        document.body.appendChild(this.myDisconnFrame);
    };
    /**
     * Used to track the bytes received by this client
     * @param {*} args
     * @private
     */
    BrowserPollConnection.prototype.incrementIncomingBytes_ = function (args) {
        // TODO: This is an annoying perf hit just to track the number of incoming bytes.  Maybe it should be opt-in.
        var bytesReceived = util.stringify(args).length;
        this.bytesReceived += bytesReceived;
        this.stats_.incrementCounter('bytes_received', bytesReceived);
    };
    return BrowserPollConnection;
}());
/*********************************************************************************************
 * A wrapper around an iframe that is used as a long-polling script holder.
 * @constructor
 *********************************************************************************************/
var FirebaseIFrameScriptHolder = /** @class */ (function () {
    /**
     * @param commandCB - The callback to be called when control commands are recevied from the server.
     * @param onMessageCB - The callback to be triggered when responses arrive from the server.
     * @param onDisconnect - The callback to be triggered when this tag holder is closed
     * @param urlFn - A function that provides the URL of the endpoint to send data to.
     */
    function FirebaseIFrameScriptHolder(commandCB, onMessageCB, onDisconnect, urlFn) {
        this.onDisconnect = onDisconnect;
        this.urlFn = urlFn;
        //We maintain a count of all of the outstanding requests, because if we have too many active at once it can cause
        //problems in some browsers.
        this.outstandingRequests = new Set();
        //A queue of the pending segments waiting for transmission to the server.
        this.pendingSegs = [];
        //A serial number. We use this for two things:
        // 1) A way to ensure the browser doesn't cache responses to polls
        // 2) A way to make the server aware when long-polls arrive in a different order than we started them. The
        //    server needs to release both polls in this case or it will cause problems in Opera since Opera can only execute
        //    JSONP code in the order it was added to the iframe.
        this.currentSerial = Math.floor(Math.random() * 100000000);
        // This gets set to false when we're "closing down" the connection (e.g. we're switching transports but there's still
        // incoming data from the server that we're waiting for).
        this.sendNewPolls = true;
        if (!util.isNodeSdk()) {
            //Each script holder registers a couple of uniquely named callbacks with the window. These are called from the
            //iframes where we put the long-polling script tags. We have two callbacks:
            //   1) Command Callback - Triggered for control issues, like starting a connection.
            //   2) Message Callback - Triggered when new data arrives.
            this.uniqueCallbackIdentifier = LUIDGenerator();
            window[FIREBASE_LONGPOLL_COMMAND_CB_NAME + this.uniqueCallbackIdentifier] = commandCB;
            window[FIREBASE_LONGPOLL_DATA_CB_NAME + this.uniqueCallbackIdentifier] = onMessageCB;
            //Create an iframe for us to add script tags to.
            this.myIFrame = FirebaseIFrameScriptHolder.createIFrame_();
            // Set the iframe's contents.
            var script = '';
            // if we set a javascript url, it's IE and we need to set the document domain. The javascript url is sufficient
            // for ie9, but ie8 needs to do it again in the document itself.
            if (this.myIFrame.src &&
                this.myIFrame.src.substr(0, 'javascript:'.length) === 'javascript:') {
                var currentDomain = document.domain;
                script = '<script>document.domain="' + currentDomain + '";</script>';
            }
            var iframeContents = '<html><body>' + script + '</body></html>';
            try {
                this.myIFrame.doc.open();
                this.myIFrame.doc.write(iframeContents);
                this.myIFrame.doc.close();
            }
            catch (e) {
                log('frame writing exception');
                if (e.stack) {
                    log(e.stack);
                }
                log(e);
            }
        }
        else {
            this.commandCB = commandCB;
            this.onMessageCB = onMessageCB;
        }
    }
    /**
     * Each browser has its own funny way to handle iframes. Here we mush them all together into one object that I can
     * actually use.
     * @private
     * @return {Element}
     */
    FirebaseIFrameScriptHolder.createIFrame_ = function () {
        var iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        // This is necessary in order to initialize the document inside the iframe
        if (document.body) {
            document.body.appendChild(iframe);
            try {
                // If document.domain has been modified in IE, this will throw an error, and we need to set the
                // domain of the iframe's document manually. We can do this via a javascript: url as the src attribute
                // Also note that we must do this *after* the iframe has been appended to the page. Otherwise it doesn't work.
                var a = iframe.contentWindow.document;
                if (!a) {
                    // Apologies for the log-spam, I need to do something to keep closure from optimizing out the assignment above.
                    log('No IE domain setting required');
                }
            }
            catch (e) {
                var domain = document.domain;
                iframe.src =
                    "javascript:void((function(){document.open();document.domain='" +
                        domain +
                        "';document.close();})())";
            }
        }
        else {
            // LongPollConnection attempts to delay initialization until the document is ready, so hopefully this
            // never gets hit.
            throw 'Document body has not initialized. Wait to initialize Firebase until after the document is ready.';
        }
        // Get the document of the iframe in a browser-specific way.
        if (iframe.contentDocument) {
            iframe.doc = iframe.contentDocument; // Firefox, Opera, Safari
        }
        else if (iframe.contentWindow) {
            iframe.doc = iframe.contentWindow.document; // Internet Explorer
        }
        else if (iframe.document) {
            iframe.doc = iframe.document; //others?
        }
        return iframe;
    };
    /**
     * Cancel all outstanding queries and remove the frame.
     */
    FirebaseIFrameScriptHolder.prototype.close = function () {
        var _this = this;
        //Mark this iframe as dead, so no new requests are sent.
        this.alive = false;
        if (this.myIFrame) {
            //We have to actually remove all of the html inside this iframe before removing it from the
            //window, or IE will continue loading and executing the script tags we've already added, which
            //can lead to some errors being thrown. Setting innerHTML seems to be the easiest way to do this.
            this.myIFrame.doc.body.innerHTML = '';
            setTimeout(function () {
                if (_this.myIFrame !== null) {
                    document.body.removeChild(_this.myIFrame);
                    _this.myIFrame = null;
                }
            }, Math.floor(0));
        }
        // Protect from being called recursively.
        var onDisconnect = this.onDisconnect;
        if (onDisconnect) {
            this.onDisconnect = null;
            onDisconnect();
        }
    };
    /**
     * Actually start the long-polling session by adding the first script tag(s) to the iframe.
     * @param {!string} id - The ID of this connection
     * @param {!string} pw - The password for this connection
     */
    FirebaseIFrameScriptHolder.prototype.startLongPoll = function (id, pw) {
        this.myID = id;
        this.myPW = pw;
        this.alive = true;
        //send the initial request. If there are requests queued, make sure that we transmit as many as we are currently able to.
        while (this.newRequest_()) { }
    };
    /**
     * This is called any time someone might want a script tag to be added. It adds a script tag when there aren't
     * too many outstanding requests and we are still alive.
     *
     * If there are outstanding packet segments to send, it sends one. If there aren't, it sends a long-poll anyways if
     * needed.
     */
    FirebaseIFrameScriptHolder.prototype.newRequest_ = function () {
        // We keep one outstanding request open all the time to receive data, but if we need to send data
        // (pendingSegs.length > 0) then we create a new request to send the data.  The server will automatically
        // close the old request.
        if (this.alive &&
            this.sendNewPolls &&
            this.outstandingRequests.size < (this.pendingSegs.length > 0 ? 2 : 1)) {
            //construct our url
            this.currentSerial++;
            var urlParams = {};
            urlParams[FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
            urlParams[FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
            urlParams[FIREBASE_LONGPOLL_SERIAL_PARAM] = this.currentSerial;
            var theURL = this.urlFn(urlParams);
            //Now add as much data as we can.
            var curDataString = '';
            var i = 0;
            while (this.pendingSegs.length > 0) {
                //first, lets see if the next segment will fit.
                var nextSeg = this.pendingSegs[0];
                if (nextSeg.d.length + SEG_HEADER_SIZE + curDataString.length <=
                    MAX_URL_DATA_SIZE) {
                    //great, the segment will fit. Lets append it.
                    var theSeg = this.pendingSegs.shift();
                    curDataString =
                        curDataString +
                            '&' +
                            FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM +
                            i +
                            '=' +
                            theSeg.seg +
                            '&' +
                            FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET +
                            i +
                            '=' +
                            theSeg.ts +
                            '&' +
                            FIREBASE_LONGPOLL_DATA_PARAM +
                            i +
                            '=' +
                            theSeg.d;
                    i++;
                }
                else {
                    break;
                }
            }
            theURL = theURL + curDataString;
            this.addLongPollTag_(theURL, this.currentSerial);
            return true;
        }
        else {
            return false;
        }
    };
    /**
     * Queue a packet for transmission to the server.
     * @param segnum - A sequential id for this packet segment used for reassembly
     * @param totalsegs - The total number of segments in this packet
     * @param data - The data for this segment.
     */
    FirebaseIFrameScriptHolder.prototype.enqueueSegment = function (segnum, totalsegs, data) {
        //add this to the queue of segments to send.
        this.pendingSegs.push({ seg: segnum, ts: totalsegs, d: data });
        //send the data immediately if there isn't already data being transmitted, unless
        //startLongPoll hasn't been called yet.
        if (this.alive) {
            this.newRequest_();
        }
    };
    /**
     * Add a script tag for a regular long-poll request.
     * @param {!string} url - The URL of the script tag.
     * @param {!number} serial - The serial number of the request.
     * @private
     */
    FirebaseIFrameScriptHolder.prototype.addLongPollTag_ = function (url, serial) {
        var _this = this;
        //remember that we sent this request.
        this.outstandingRequests.add(serial);
        var doNewRequest = function () {
            _this.outstandingRequests.delete(serial);
            _this.newRequest_();
        };
        // If this request doesn't return on its own accord (by the server sending us some data), we'll
        // create a new one after the KEEPALIVE interval to make sure we always keep a fresh request open.
        var keepaliveTimeout = setTimeout(doNewRequest, Math.floor(KEEPALIVE_REQUEST_INTERVAL));
        var readyStateCB = function () {
            // Request completed.  Cancel the keepalive.
            clearTimeout(keepaliveTimeout);
            // Trigger a new request so we can continue receiving data.
            doNewRequest();
        };
        this.addTag(url, readyStateCB);
    };
    /**
     * Add an arbitrary script tag to the iframe.
     * @param {!string} url - The URL for the script tag source.
     * @param {!function()} loadCB - A callback to be triggered once the script has loaded.
     */
    FirebaseIFrameScriptHolder.prototype.addTag = function (url, loadCB) {
        var _this = this;
        if (util.isNodeSdk()) {
            this.doNodeLongPoll(url, loadCB);
        }
        else {
            setTimeout(function () {
                try {
                    // if we're already closed, don't add this poll
                    if (!_this.sendNewPolls)
                        return;
                    var newScript_1 = _this.myIFrame.doc.createElement('script');
                    newScript_1.type = 'text/javascript';
                    newScript_1.async = true;
                    newScript_1.src = url;
                    newScript_1.onload = newScript_1.onreadystatechange = function () {
                        var rstate = newScript_1.readyState;
                        if (!rstate || rstate === 'loaded' || rstate === 'complete') {
                            newScript_1.onload = newScript_1.onreadystatechange = null;
                            if (newScript_1.parentNode) {
                                newScript_1.parentNode.removeChild(newScript_1);
                            }
                            loadCB();
                        }
                    };
                    newScript_1.onerror = function () {
                        log('Long-poll script failed to load: ' + url);
                        _this.sendNewPolls = false;
                        _this.close();
                    };
                    _this.myIFrame.doc.body.appendChild(newScript_1);
                }
                catch (e) {
                    // TODO: we should make this error visible somehow
                }
            }, Math.floor(1));
        }
    };
    return FirebaseIFrameScriptHolder;
}());

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** The semver (www.semver.org) version of the SDK. */
var SDK_VERSION = '';
// SDK_VERSION should be set before any database instance is created
function setSDKVersion(version) {
    SDK_VERSION = version;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var WEBSOCKET_MAX_FRAME_SIZE = 16384;
var WEBSOCKET_KEEPALIVE_INTERVAL = 45000;
var WebSocketImpl = null;
if (typeof MozWebSocket !== 'undefined') {
    WebSocketImpl = MozWebSocket;
}
else if (typeof WebSocket !== 'undefined') {
    WebSocketImpl = WebSocket;
}
/**
 * Create a new websocket connection with the given callbacks.
 * @constructor
 * @implements {Transport}
 */
var WebSocketConnection = /** @class */ (function () {
    /**
     * @param {string} connId identifier for this transport
     * @param {RepoInfo} repoInfo The info for the websocket endpoint.
     * @param {string=} transportSessionId Optional transportSessionId if this is connecting to an existing transport
     *                                         session
     * @param {string=} lastSessionId Optional lastSessionId if there was a previous connection
     */
    function WebSocketConnection(connId, repoInfo, transportSessionId, lastSessionId) {
        this.connId = connId;
        this.keepaliveTimer = null;
        this.frames = null;
        this.totalFrames = 0;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.log_ = logWrapper(this.connId);
        this.stats_ = StatsManager.getCollection(repoInfo);
        this.connURL = WebSocketConnection.connectionURL_(repoInfo, transportSessionId, lastSessionId);
    }
    /**
     * @param {RepoInfo} repoInfo The info for the websocket endpoint.
     * @param {string=} transportSessionId Optional transportSessionId if this is connecting to an existing transport
     *                                         session
     * @param {string=} lastSessionId Optional lastSessionId if there was a previous connection
     * @return {string} connection url
     * @private
     */
    WebSocketConnection.connectionURL_ = function (repoInfo, transportSessionId, lastSessionId) {
        var urlParams = {};
        urlParams[VERSION_PARAM] = PROTOCOL_VERSION;
        if (!util.isNodeSdk() &&
            typeof location !== 'undefined' &&
            location.href &&
            location.href.indexOf(FORGE_DOMAIN) !== -1) {
            urlParams[REFERER_PARAM] = FORGE_REF;
        }
        if (transportSessionId) {
            urlParams[TRANSPORT_SESSION_PARAM] = transportSessionId;
        }
        if (lastSessionId) {
            urlParams[LAST_SESSION_PARAM] = lastSessionId;
        }
        return repoInfo.connectionURL(WEBSOCKET, urlParams);
    };
    /**
     *
     * @param onMessage Callback when messages arrive
     * @param onDisconnect Callback with connection lost.
     */
    WebSocketConnection.prototype.open = function (onMessage, onDisconnect) {
        var _this = this;
        this.onDisconnect = onDisconnect;
        this.onMessage = onMessage;
        this.log_('Websocket connecting to ' + this.connURL);
        this.everConnected_ = false;
        // Assume failure until proven otherwise.
        PersistentStorage.set('previous_websocket_failure', true);
        try {
            if (util.isNodeSdk()) {
                var device = util.CONSTANTS.NODE_ADMIN ? 'AdminNode' : 'Node';
                // UA Format: Firebase/<wire_protocol>/<sdk_version>/<platform>/<device>
                var options = {
                    headers: {
                        'User-Agent': "Firebase/" + PROTOCOL_VERSION + "/" + SDK_VERSION + "/" + process.platform + "/" + device
                    }
                };
                // Plumb appropriate http_proxy environment variable into faye-websocket if it exists.
                var env = process['env'];
                var proxy = this.connURL.indexOf('wss://') == 0
                    ? env['HTTPS_PROXY'] || env['https_proxy']
                    : env['HTTP_PROXY'] || env['http_proxy'];
                if (proxy) {
                    options['proxy'] = { origin: proxy };
                }
                this.mySock = new WebSocketImpl(this.connURL, [], options);
            }
            else {
                this.mySock = new WebSocketImpl(this.connURL);
            }
        }
        catch (e) {
            this.log_('Error instantiating WebSocket.');
            var error = e.message || e.data;
            if (error) {
                this.log_(error);
            }
            this.onClosed_();
            return;
        }
        this.mySock.onopen = function () {
            _this.log_('Websocket connected.');
            _this.everConnected_ = true;
        };
        this.mySock.onclose = function () {
            _this.log_('Websocket connection was disconnected.');
            _this.mySock = null;
            _this.onClosed_();
        };
        this.mySock.onmessage = function (m) {
            _this.handleIncomingFrame(m);
        };
        this.mySock.onerror = function (e) {
            _this.log_('WebSocket error.  Closing connection.');
            var error = e.message || e.data;
            if (error) {
                _this.log_(error);
            }
            _this.onClosed_();
        };
    };
    /**
     * No-op for websockets, we don't need to do anything once the connection is confirmed as open
     */
    WebSocketConnection.prototype.start = function () { };
    WebSocketConnection.forceDisallow = function () {
        WebSocketConnection.forceDisallow_ = true;
    };
    WebSocketConnection.isAvailable = function () {
        var isOldAndroid = false;
        if (typeof navigator !== 'undefined' && navigator.userAgent) {
            var oldAndroidRegex = /Android ([0-9]{0,}\.[0-9]{0,})/;
            var oldAndroidMatch = navigator.userAgent.match(oldAndroidRegex);
            if (oldAndroidMatch && oldAndroidMatch.length > 1) {
                if (parseFloat(oldAndroidMatch[1]) < 4.4) {
                    isOldAndroid = true;
                }
            }
        }
        return (!isOldAndroid &&
            WebSocketImpl !== null &&
            !WebSocketConnection.forceDisallow_);
    };
    /**
     * Returns true if we previously failed to connect with this transport.
     * @return {boolean}
     */
    WebSocketConnection.previouslyFailed = function () {
        // If our persistent storage is actually only in-memory storage,
        // we default to assuming that it previously failed to be safe.
        return (PersistentStorage.isInMemoryStorage ||
            PersistentStorage.get('previous_websocket_failure') === true);
    };
    WebSocketConnection.prototype.markConnectionHealthy = function () {
        PersistentStorage.remove('previous_websocket_failure');
    };
    WebSocketConnection.prototype.appendFrame_ = function (data) {
        this.frames.push(data);
        if (this.frames.length == this.totalFrames) {
            var fullMess = this.frames.join('');
            this.frames = null;
            var jsonMess = util.jsonEval(fullMess);
            //handle the message
            this.onMessage(jsonMess);
        }
    };
    /**
     * @param {number} frameCount The number of frames we are expecting from the server
     * @private
     */
    WebSocketConnection.prototype.handleNewFrameCount_ = function (frameCount) {
        this.totalFrames = frameCount;
        this.frames = [];
    };
    /**
     * Attempts to parse a frame count out of some text. If it can't, assumes a value of 1
     * @param {!String} data
     * @return {?String} Any remaining data to be process, or null if there is none
     * @private
     */
    WebSocketConnection.prototype.extractFrameCount_ = function (data) {
        util.assert(this.frames === null, 'We already have a frame buffer');
        // TODO: The server is only supposed to send up to 9999 frames (i.e. length <= 4), but that isn't being enforced
        // currently.  So allowing larger frame counts (length <= 6).  See https://app.asana.com/0/search/8688598998380/8237608042508
        if (data.length <= 6) {
            var frameCount = Number(data);
            if (!isNaN(frameCount)) {
                this.handleNewFrameCount_(frameCount);
                return null;
            }
        }
        this.handleNewFrameCount_(1);
        return data;
    };
    /**
     * Process a websocket frame that has arrived from the server.
     * @param mess The frame data
     */
    WebSocketConnection.prototype.handleIncomingFrame = function (mess) {
        if (this.mySock === null)
            return; // Chrome apparently delivers incoming packets even after we .close() the connection sometimes.
        var data = mess['data'];
        this.bytesReceived += data.length;
        this.stats_.incrementCounter('bytes_received', data.length);
        this.resetKeepAlive();
        if (this.frames !== null) {
            // we're buffering
            this.appendFrame_(data);
        }
        else {
            // try to parse out a frame count, otherwise, assume 1 and process it
            var remainingData = this.extractFrameCount_(data);
            if (remainingData !== null) {
                this.appendFrame_(remainingData);
            }
        }
    };
    /**
     * Send a message to the server
     * @param {Object} data The JSON object to transmit
     */
    WebSocketConnection.prototype.send = function (data) {
        this.resetKeepAlive();
        var dataStr = util.stringify(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter('bytes_sent', dataStr.length);
        //We can only fit a certain amount in each websocket frame, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        var dataSegs = splitStringBySize(dataStr, WEBSOCKET_MAX_FRAME_SIZE);
        //Send the length header
        if (dataSegs.length > 1) {
            this.sendString_(String(dataSegs.length));
        }
        //Send the actual data in segments.
        for (var i = 0; i < dataSegs.length; i++) {
            this.sendString_(dataSegs[i]);
        }
    };
    WebSocketConnection.prototype.shutdown_ = function () {
        this.isClosed_ = true;
        if (this.keepaliveTimer) {
            clearInterval(this.keepaliveTimer);
            this.keepaliveTimer = null;
        }
        if (this.mySock) {
            this.mySock.close();
            this.mySock = null;
        }
    };
    WebSocketConnection.prototype.onClosed_ = function () {
        if (!this.isClosed_) {
            this.log_('WebSocket is closing itself');
            this.shutdown_();
            // since this is an internal close, trigger the close listener
            if (this.onDisconnect) {
                this.onDisconnect(this.everConnected_);
                this.onDisconnect = null;
            }
        }
    };
    /**
     * External-facing close handler.
     * Close the websocket and kill the connection.
     */
    WebSocketConnection.prototype.close = function () {
        if (!this.isClosed_) {
            this.log_('WebSocket is being closed');
            this.shutdown_();
        }
    };
    /**
     * Kill the current keepalive timer and start a new one, to ensure that it always fires N seconds after
     * the last activity.
     */
    WebSocketConnection.prototype.resetKeepAlive = function () {
        var _this = this;
        clearInterval(this.keepaliveTimer);
        this.keepaliveTimer = setInterval(function () {
            //If there has been no websocket activity for a while, send a no-op
            if (_this.mySock) {
                _this.sendString_('0');
            }
            _this.resetKeepAlive();
        }, Math.floor(WEBSOCKET_KEEPALIVE_INTERVAL));
    };
    /**
     * Send a string over the websocket.
     *
     * @param {string} str String to send.
     * @private
     */
    WebSocketConnection.prototype.sendString_ = function (str) {
        // Firefox seems to sometimes throw exceptions (NS_ERROR_UNEXPECTED) from websocket .send()
        // calls for some unknown reason.  We treat these as an error and disconnect.
        // See https://app.asana.com/0/58926111402292/68021340250410
        try {
            this.mySock.send(str);
        }
        catch (e) {
            this.log_('Exception thrown from WebSocket.send():', e.message || e.data, 'Closing connection.');
            setTimeout(this.onClosed_.bind(this), 0);
        }
    };
    /**
     * Number of response before we consider the connection "healthy."
     * @type {number}
     */
    WebSocketConnection.responsesRequiredToBeHealthy = 2;
    /**
     * Time to wait for the connection te become healthy before giving up.
     * @type {number}
     */
    WebSocketConnection.healthyTimeout = 30000;
    return WebSocketConnection;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Currently simplistic, this class manages what transport a Connection should use at various stages of its
 * lifecycle.
 *
 * It starts with longpolling in a browser, and httppolling on node. It then upgrades to websockets if
 * they are available.
 * @constructor
 */
var TransportManager = /** @class */ (function () {
    /**
     * @param {!RepoInfo} repoInfo Metadata around the namespace we're connecting to
     */
    function TransportManager(repoInfo) {
        this.initTransports_(repoInfo);
    }
    Object.defineProperty(TransportManager, "ALL_TRANSPORTS", {
        /**
         * @const
         * @type {!Array.<function(new:Transport, string, RepoInfo, string=)>}
         */
        get: function () {
            return [BrowserPollConnection, WebSocketConnection];
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {!RepoInfo} repoInfo
     * @private
     */
    TransportManager.prototype.initTransports_ = function (repoInfo) {
        var e_1, _a;
        var isWebSocketsAvailable = WebSocketConnection && WebSocketConnection['isAvailable']();
        var isSkipPollConnection = isWebSocketsAvailable && !WebSocketConnection.previouslyFailed();
        if (repoInfo.webSocketOnly) {
            if (!isWebSocketsAvailable)
                warn("wss:// URL used, but browser isn't known to support websockets.  Trying anyway.");
            isSkipPollConnection = true;
        }
        if (isSkipPollConnection) {
            this.transports_ = [WebSocketConnection];
        }
        else {
            var transports = (this.transports_ = []);
            try {
                for (var _b = tslib.__values(TransportManager.ALL_TRANSPORTS), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var transport = _c.value;
                    if (transport && transport['isAvailable']()) {
                        transports.push(transport);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
    };
    /**
     * @return {function(new:Transport, !string, !RepoInfo, string=, string=)} The constructor for the
     * initial transport to use
     */
    TransportManager.prototype.initialTransport = function () {
        if (this.transports_.length > 0) {
            return this.transports_[0];
        }
        else {
            throw new Error('No transports available');
        }
    };
    /**
     * @return {?function(new:Transport, function(),function(), string=)} The constructor for the next
     * transport, or null
     */
    TransportManager.prototype.upgradeTransport = function () {
        if (this.transports_.length > 1) {
            return this.transports_[1];
        }
        else {
            return null;
        }
    };
    return TransportManager;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Abort upgrade attempt if it takes longer than 60s.
var UPGRADE_TIMEOUT = 60000;
// For some transports (WebSockets), we need to "validate" the transport by exchanging a few requests and responses.
// If we haven't sent enough requests within 5s, we'll start sending noop ping requests.
var DELAY_BEFORE_SENDING_EXTRA_REQUESTS = 5000;
// If the initial data sent triggers a lot of bandwidth (i.e. it's a large put or a listen for a large amount of data)
// then we may not be able to exchange our ping/pong requests within the healthy timeout.  So if we reach the timeout
// but we've sent/received enough bytes, we don't cancel the connection.
var BYTES_SENT_HEALTHY_OVERRIDE = 10 * 1024;
var BYTES_RECEIVED_HEALTHY_OVERRIDE = 100 * 1024;
var MESSAGE_TYPE = 't';
var MESSAGE_DATA = 'd';
var CONTROL_SHUTDOWN = 's';
var CONTROL_RESET = 'r';
var CONTROL_ERROR = 'e';
var CONTROL_PONG = 'o';
var SWITCH_ACK = 'a';
var END_TRANSMISSION = 'n';
var PING = 'p';
var SERVER_HELLO = 'h';
/**
 * Creates a new real-time connection to the server using whichever method works
 * best in the current browser.
 *
 * @constructor
 */
var Connection = /** @class */ (function () {
    /**
     * @param {!string} id - an id for this connection
     * @param {!RepoInfo} repoInfo_ - the info for the endpoint to connect to
     * @param {function(Object)} onMessage_ - the callback to be triggered when a server-push message arrives
     * @param {function(number, string)} onReady_ - the callback to be triggered when this connection is ready to send messages.
     * @param {function()} onDisconnect_ - the callback to be triggered when a connection was lost
     * @param {function(string)} onKill_ - the callback to be triggered when this connection has permanently shut down.
     * @param {string=} lastSessionId - last session id in persistent connection. is used to clean up old session in real-time server
     */
    function Connection(id, repoInfo_, onMessage_, onReady_, onDisconnect_, onKill_, lastSessionId) {
        this.id = id;
        this.repoInfo_ = repoInfo_;
        this.onMessage_ = onMessage_;
        this.onReady_ = onReady_;
        this.onDisconnect_ = onDisconnect_;
        this.onKill_ = onKill_;
        this.lastSessionId = lastSessionId;
        this.connectionCount = 0;
        this.pendingDataMessages = [];
        this.state_ = 0 /* CONNECTING */;
        this.log_ = logWrapper('c:' + this.id + ':');
        this.transportManager_ = new TransportManager(repoInfo_);
        this.log_('Connection created');
        this.start_();
    }
    /**
     * Starts a connection attempt
     * @private
     */
    Connection.prototype.start_ = function () {
        var _this = this;
        var conn = this.transportManager_.initialTransport();
        this.conn_ = new conn(this.nextTransportId_(), this.repoInfo_, undefined, this.lastSessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.primaryResponsesRequired_ = conn['responsesRequiredToBeHealthy'] || 0;
        var onMessageReceived = this.connReceiver_(this.conn_);
        var onConnectionLost = this.disconnReceiver_(this.conn_);
        this.tx_ = this.conn_;
        this.rx_ = this.conn_;
        this.secondaryConn_ = null;
        this.isHealthy_ = false;
        /*
         * Firefox doesn't like when code from one iframe tries to create another iframe by way of the parent frame.
         * This can occur in the case of a redirect, i.e. we guessed wrong on what server to connect to and received a reset.
         * Somehow, setTimeout seems to make this ok. That doesn't make sense from a security perspective, since you should
         * still have the context of your originating frame.
         */
        setTimeout(function () {
            // this.conn_ gets set to null in some of the tests. Check to make sure it still exists before using it
            _this.conn_ && _this.conn_.open(onMessageReceived, onConnectionLost);
        }, Math.floor(0));
        var healthyTimeout_ms = conn['healthyTimeout'] || 0;
        if (healthyTimeout_ms > 0) {
            this.healthyTimeout_ = setTimeoutNonBlocking(function () {
                _this.healthyTimeout_ = null;
                if (!_this.isHealthy_) {
                    if (_this.conn_ &&
                        _this.conn_.bytesReceived > BYTES_RECEIVED_HEALTHY_OVERRIDE) {
                        _this.log_('Connection exceeded healthy timeout but has received ' +
                            _this.conn_.bytesReceived +
                            ' bytes.  Marking connection healthy.');
                        _this.isHealthy_ = true;
                        _this.conn_.markConnectionHealthy();
                    }
                    else if (_this.conn_ &&
                        _this.conn_.bytesSent > BYTES_SENT_HEALTHY_OVERRIDE) {
                        _this.log_('Connection exceeded healthy timeout but has sent ' +
                            _this.conn_.bytesSent +
                            ' bytes.  Leaving connection alive.');
                        // NOTE: We don't want to mark it healthy, since we have no guarantee that the bytes have made it to
                        // the server.
                    }
                    else {
                        _this.log_('Closing unhealthy connection after timeout.');
                        _this.close();
                    }
                }
            }, Math.floor(healthyTimeout_ms));
        }
    };
    /**
     * @return {!string}
     * @private
     */
    Connection.prototype.nextTransportId_ = function () {
        return 'c:' + this.id + ':' + this.connectionCount++;
    };
    Connection.prototype.disconnReceiver_ = function (conn) {
        var _this = this;
        return function (everConnected) {
            if (conn === _this.conn_) {
                _this.onConnectionLost_(everConnected);
            }
            else if (conn === _this.secondaryConn_) {
                _this.log_('Secondary connection lost.');
                _this.onSecondaryConnectionLost_();
            }
            else {
                _this.log_('closing an old connection');
            }
        };
    };
    Connection.prototype.connReceiver_ = function (conn) {
        var _this = this;
        return function (message) {
            if (_this.state_ != 2 /* DISCONNECTED */) {
                if (conn === _this.rx_) {
                    _this.onPrimaryMessageReceived_(message);
                }
                else if (conn === _this.secondaryConn_) {
                    _this.onSecondaryMessageReceived_(message);
                }
                else {
                    _this.log_('message on old connection');
                }
            }
        };
    };
    /**
     *
     * @param {Object} dataMsg An arbitrary data message to be sent to the server
     */
    Connection.prototype.sendRequest = function (dataMsg) {
        // wrap in a data message envelope and send it on
        var msg = { t: 'd', d: dataMsg };
        this.sendData_(msg);
    };
    Connection.prototype.tryCleanupConnection = function () {
        if (this.tx_ === this.secondaryConn_ && this.rx_ === this.secondaryConn_) {
            this.log_('cleaning up and promoting a connection: ' + this.secondaryConn_.connId);
            this.conn_ = this.secondaryConn_;
            this.secondaryConn_ = null;
            // the server will shutdown the old connection
        }
    };
    Connection.prototype.onSecondaryControl_ = function (controlData) {
        if (MESSAGE_TYPE in controlData) {
            var cmd = controlData[MESSAGE_TYPE];
            if (cmd === SWITCH_ACK) {
                this.upgradeIfSecondaryHealthy_();
            }
            else if (cmd === CONTROL_RESET) {
                // Most likely the session wasn't valid. Abandon the switch attempt
                this.log_('Got a reset on secondary, closing it');
                this.secondaryConn_.close();
                // If we were already using this connection for something, than we need to fully close
                if (this.tx_ === this.secondaryConn_ ||
                    this.rx_ === this.secondaryConn_) {
                    this.close();
                }
            }
            else if (cmd === CONTROL_PONG) {
                this.log_('got pong on secondary.');
                this.secondaryResponsesRequired_--;
                this.upgradeIfSecondaryHealthy_();
            }
        }
    };
    Connection.prototype.onSecondaryMessageReceived_ = function (parsedData) {
        var layer = requireKey('t', parsedData);
        var data = requireKey('d', parsedData);
        if (layer == 'c') {
            this.onSecondaryControl_(data);
        }
        else if (layer == 'd') {
            // got a data message, but we're still second connection. Need to buffer it up
            this.pendingDataMessages.push(data);
        }
        else {
            throw new Error('Unknown protocol layer: ' + layer);
        }
    };
    Connection.prototype.upgradeIfSecondaryHealthy_ = function () {
        if (this.secondaryResponsesRequired_ <= 0) {
            this.log_('Secondary connection is healthy.');
            this.isHealthy_ = true;
            this.secondaryConn_.markConnectionHealthy();
            this.proceedWithUpgrade_();
        }
        else {
            // Send a ping to make sure the connection is healthy.
            this.log_('sending ping on secondary.');
            this.secondaryConn_.send({ t: 'c', d: { t: PING, d: {} } });
        }
    };
    Connection.prototype.proceedWithUpgrade_ = function () {
        // tell this connection to consider itself open
        this.secondaryConn_.start();
        // send ack
        this.log_('sending client ack on secondary');
        this.secondaryConn_.send({ t: 'c', d: { t: SWITCH_ACK, d: {} } });
        // send end packet on primary transport, switch to sending on this one
        // can receive on this one, buffer responses until end received on primary transport
        this.log_('Ending transmission on primary');
        this.conn_.send({ t: 'c', d: { t: END_TRANSMISSION, d: {} } });
        this.tx_ = this.secondaryConn_;
        this.tryCleanupConnection();
    };
    Connection.prototype.onPrimaryMessageReceived_ = function (parsedData) {
        // Must refer to parsedData properties in quotes, so closure doesn't touch them.
        var layer = requireKey('t', parsedData);
        var data = requireKey('d', parsedData);
        if (layer == 'c') {
            this.onControl_(data);
        }
        else if (layer == 'd') {
            this.onDataMessage_(data);
        }
    };
    Connection.prototype.onDataMessage_ = function (message) {
        this.onPrimaryResponse_();
        // We don't do anything with data messages, just kick them up a level
        this.onMessage_(message);
    };
    Connection.prototype.onPrimaryResponse_ = function () {
        if (!this.isHealthy_) {
            this.primaryResponsesRequired_--;
            if (this.primaryResponsesRequired_ <= 0) {
                this.log_('Primary connection is healthy.');
                this.isHealthy_ = true;
                this.conn_.markConnectionHealthy();
            }
        }
    };
    Connection.prototype.onControl_ = function (controlData) {
        var cmd = requireKey(MESSAGE_TYPE, controlData);
        if (MESSAGE_DATA in controlData) {
            var payload = controlData[MESSAGE_DATA];
            if (cmd === SERVER_HELLO) {
                this.onHandshake_(payload);
            }
            else if (cmd === END_TRANSMISSION) {
                this.log_('recvd end transmission on primary');
                this.rx_ = this.secondaryConn_;
                for (var i = 0; i < this.pendingDataMessages.length; ++i) {
                    this.onDataMessage_(this.pendingDataMessages[i]);
                }
                this.pendingDataMessages = [];
                this.tryCleanupConnection();
            }
            else if (cmd === CONTROL_SHUTDOWN) {
                // This was previously the 'onKill' callback passed to the lower-level connection
                // payload in this case is the reason for the shutdown. Generally a human-readable error
                this.onConnectionShutdown_(payload);
            }
            else if (cmd === CONTROL_RESET) {
                // payload in this case is the host we should contact
                this.onReset_(payload);
            }
            else if (cmd === CONTROL_ERROR) {
                error('Server Error: ' + payload);
            }
            else if (cmd === CONTROL_PONG) {
                this.log_('got pong on primary.');
                this.onPrimaryResponse_();
                this.sendPingOnPrimaryIfNecessary_();
            }
            else {
                error('Unknown control packet command: ' + cmd);
            }
        }
    };
    /**
     *
     * @param {Object} handshake The handshake data returned from the server
     * @private
     */
    Connection.prototype.onHandshake_ = function (handshake) {
        var timestamp = handshake.ts;
        var version = handshake.v;
        var host = handshake.h;
        this.sessionId = handshake.s;
        this.repoInfo_.updateHost(host);
        // if we've already closed the connection, then don't bother trying to progress further
        if (this.state_ == 0 /* CONNECTING */) {
            this.conn_.start();
            this.onConnectionEstablished_(this.conn_, timestamp);
            if (PROTOCOL_VERSION !== version) {
                warn('Protocol version mismatch detected');
            }
            // TODO: do we want to upgrade? when? maybe a delay?
            this.tryStartUpgrade_();
        }
    };
    Connection.prototype.tryStartUpgrade_ = function () {
        var conn = this.transportManager_.upgradeTransport();
        if (conn) {
            this.startUpgrade_(conn);
        }
    };
    Connection.prototype.startUpgrade_ = function (conn) {
        var _this = this;
        this.secondaryConn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.sessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.secondaryResponsesRequired_ =
            conn['responsesRequiredToBeHealthy'] || 0;
        var onMessage = this.connReceiver_(this.secondaryConn_);
        var onDisconnect = this.disconnReceiver_(this.secondaryConn_);
        this.secondaryConn_.open(onMessage, onDisconnect);
        // If we haven't successfully upgraded after UPGRADE_TIMEOUT, give up and kill the secondary.
        setTimeoutNonBlocking(function () {
            if (_this.secondaryConn_) {
                _this.log_('Timed out trying to upgrade.');
                _this.secondaryConn_.close();
            }
        }, Math.floor(UPGRADE_TIMEOUT));
    };
    Connection.prototype.onReset_ = function (host) {
        this.log_('Reset packet received.  New host: ' + host);
        this.repoInfo_.updateHost(host);
        // TODO: if we're already "connected", we need to trigger a disconnect at the next layer up.
        // We don't currently support resets after the connection has already been established
        if (this.state_ === 1 /* CONNECTED */) {
            this.close();
        }
        else {
            // Close whatever connections we have open and start again.
            this.closeConnections_();
            this.start_();
        }
    };
    Connection.prototype.onConnectionEstablished_ = function (conn, timestamp) {
        var _this = this;
        this.log_('Realtime connection established.');
        this.conn_ = conn;
        this.state_ = 1 /* CONNECTED */;
        if (this.onReady_) {
            this.onReady_(timestamp, this.sessionId);
            this.onReady_ = null;
        }
        // If after 5 seconds we haven't sent enough requests to the server to get the connection healthy,
        // send some pings.
        if (this.primaryResponsesRequired_ === 0) {
            this.log_('Primary connection is healthy.');
            this.isHealthy_ = true;
        }
        else {
            setTimeoutNonBlocking(function () {
                _this.sendPingOnPrimaryIfNecessary_();
            }, Math.floor(DELAY_BEFORE_SENDING_EXTRA_REQUESTS));
        }
    };
    Connection.prototype.sendPingOnPrimaryIfNecessary_ = function () {
        // If the connection isn't considered healthy yet, we'll send a noop ping packet request.
        if (!this.isHealthy_ && this.state_ === 1 /* CONNECTED */) {
            this.log_('sending ping on primary.');
            this.sendData_({ t: 'c', d: { t: PING, d: {} } });
        }
    };
    Connection.prototype.onSecondaryConnectionLost_ = function () {
        var conn = this.secondaryConn_;
        this.secondaryConn_ = null;
        if (this.tx_ === conn || this.rx_ === conn) {
            // we are relying on this connection already in some capacity. Therefore, a failure is real
            this.close();
        }
    };
    /**
     *
     * @param {boolean} everConnected Whether or not the connection ever reached a server. Used to determine if
     * we should flush the host cache
     * @private
     */
    Connection.prototype.onConnectionLost_ = function (everConnected) {
        this.conn_ = null;
        // NOTE: IF you're seeing a Firefox error for this line, I think it might be because it's getting
        // called on window close and RealtimeState.CONNECTING is no longer defined.  Just a guess.
        if (!everConnected && this.state_ === 0 /* CONNECTING */) {
            this.log_('Realtime connection failed.');
            // Since we failed to connect at all, clear any cached entry for this namespace in case the machine went away
            if (this.repoInfo_.isCacheableHost()) {
                PersistentStorage.remove('host:' + this.repoInfo_.host);
                // reset the internal host to what we would show the user, i.e. <ns>.firebaseio.com
                this.repoInfo_.internalHost = this.repoInfo_.host;
            }
        }
        else if (this.state_ === 1 /* CONNECTED */) {
            this.log_('Realtime connection lost.');
        }
        this.close();
    };
    /**
     *
     * @param {string} reason
     * @private
     */
    Connection.prototype.onConnectionShutdown_ = function (reason) {
        this.log_('Connection shutdown command received. Shutting down...');
        if (this.onKill_) {
            this.onKill_(reason);
            this.onKill_ = null;
        }
        // We intentionally don't want to fire onDisconnect (kill is a different case),
        // so clear the callback.
        this.onDisconnect_ = null;
        this.close();
    };
    Connection.prototype.sendData_ = function (data) {
        if (this.state_ !== 1 /* CONNECTED */) {
            throw 'Connection is not connected';
        }
        else {
            this.tx_.send(data);
        }
    };
    /**
     * Cleans up this connection, calling the appropriate callbacks
     */
    Connection.prototype.close = function () {
        if (this.state_ !== 2 /* DISCONNECTED */) {
            this.log_('Closing realtime connection.');
            this.state_ = 2 /* DISCONNECTED */;
            this.closeConnections_();
            if (this.onDisconnect_) {
                this.onDisconnect_();
                this.onDisconnect_ = null;
            }
        }
    };
    /**
     *
     * @private
     */
    Connection.prototype.closeConnections_ = function () {
        this.log_('Shutting down all connections');
        if (this.conn_) {
            this.conn_.close();
            this.conn_ = null;
        }
        if (this.secondaryConn_) {
            this.secondaryConn_.close();
            this.secondaryConn_ = null;
        }
        if (this.healthyTimeout_) {
            clearTimeout(this.healthyTimeout_);
            this.healthyTimeout_ = null;
        }
    };
    return Connection;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Interface defining the set of actions that can be performed against the Firebase server
 * (basically corresponds to our wire protocol).
 *
 * @interface
 */
var ServerActions = /** @class */ (function () {
    function ServerActions() {
    }
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, string)=} onComplete
     * @param {string=} hash
     */
    ServerActions.prototype.put = function (pathString, data, onComplete, hash) { };
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, ?string)} onComplete
     * @param {string=} hash
     */
    ServerActions.prototype.merge = function (pathString, data, onComplete, hash) { };
    /**
     * Refreshes the auth token for the current connection.
     * @param {string} token The authentication token
     */
    ServerActions.prototype.refreshAuthToken = function (token) { };
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, string)=} onComplete
     */
    ServerActions.prototype.onDisconnectPut = function (pathString, data, onComplete) { };
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, string)=} onComplete
     */
    ServerActions.prototype.onDisconnectMerge = function (pathString, data, onComplete) { };
    /**
     * @param {string} pathString
     * @param {function(string, string)=} onComplete
     */
    ServerActions.prototype.onDisconnectCancel = function (pathString, onComplete) { };
    /**
     * @param {Object.<string, *>} stats
     */
    ServerActions.prototype.reportStats = function (stats) { };
    return ServerActions;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var RECONNECT_MIN_DELAY = 1000;
var RECONNECT_MAX_DELAY_DEFAULT = 60 * 5 * 1000; // 5 minutes in milliseconds (Case: 1858)
var RECONNECT_MAX_DELAY_FOR_ADMINS = 30 * 1000; // 30 seconds for admin clients (likely to be a backend server)
var RECONNECT_DELAY_MULTIPLIER = 1.3;
var RECONNECT_DELAY_RESET_TIMEOUT = 30000; // Reset delay back to MIN_DELAY after being connected for 30sec.
var SERVER_KILL_INTERRUPT_REASON = 'server_kill';
// If auth fails repeatedly, we'll assume something is wrong and log a warning / back off.
var INVALID_AUTH_TOKEN_THRESHOLD = 3;
/**
 * Firebase connection.  Abstracts wire protocol and handles reconnecting.
 *
 * NOTE: All JSON objects sent to the realtime connection must have property names enclosed
 * in quotes to make sure the closure compiler does not minify them.
 */
var PersistentConnection = /** @class */ (function (_super) {
    tslib.__extends(PersistentConnection, _super);
    /**
     * @implements {ServerActions}
     * @param repoInfo_ Data about the namespace we are connecting to
     * @param onDataUpdate_ A callback for new data from the server
     */
    function PersistentConnection(repoInfo_, onDataUpdate_, onConnectStatus_, onServerInfoUpdate_, authTokenProvider_, authOverride_) {
        var _this = _super.call(this) || this;
        _this.repoInfo_ = repoInfo_;
        _this.onDataUpdate_ = onDataUpdate_;
        _this.onConnectStatus_ = onConnectStatus_;
        _this.onServerInfoUpdate_ = onServerInfoUpdate_;
        _this.authTokenProvider_ = authTokenProvider_;
        _this.authOverride_ = authOverride_;
        // Used for diagnostic logging.
        _this.id = PersistentConnection.nextPersistentConnectionId_++;
        _this.log_ = logWrapper('p:' + _this.id + ':');
        _this.interruptReasons_ = {};
        /** Map<path, Map<queryId, ListenSpec>> */
        _this.listens = new Map();
        _this.outstandingPuts_ = [];
        _this.outstandingPutCount_ = 0;
        _this.onDisconnectRequestQueue_ = [];
        _this.connected_ = false;
        _this.reconnectDelay_ = RECONNECT_MIN_DELAY;
        _this.maxReconnectDelay_ = RECONNECT_MAX_DELAY_DEFAULT;
        _this.securityDebugCallback_ = null;
        _this.lastSessionId = null;
        _this.establishConnectionTimer_ = null;
        _this.visible_ = false;
        // Before we get connected, we keep a queue of pending messages to send.
        _this.requestCBHash_ = {};
        _this.requestNumber_ = 0;
        _this.realtime_ = null;
        _this.authToken_ = null;
        _this.forceTokenRefresh_ = false;
        _this.invalidAuthTokenCount_ = 0;
        _this.firstConnection_ = true;
        _this.lastConnectionAttemptTime_ = null;
        _this.lastConnectionEstablishedTime_ = null;
        if (authOverride_ && !util.isNodeSdk()) {
            throw new Error('Auth override specified in options, but not supported on non Node.js platforms');
        }
        _this.scheduleConnect_(0);
        VisibilityMonitor.getInstance().on('visible', _this.onVisible_, _this);
        if (repoInfo_.host.indexOf('fblocal') === -1) {
            OnlineMonitor.getInstance().on('online', _this.onOnline_, _this);
        }
        return _this;
    }
    PersistentConnection.prototype.sendRequest = function (action, body, onResponse) {
        var curReqNum = ++this.requestNumber_;
        var msg = { r: curReqNum, a: action, b: body };
        this.log_(util.stringify(msg));
        util.assert(this.connected_, "sendRequest call when we're not connected not allowed.");
        this.realtime_.sendRequest(msg);
        if (onResponse) {
            this.requestCBHash_[curReqNum] = onResponse;
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.listen = function (query, currentHashFn, tag, onComplete) {
        var queryId = query.queryIdentifier();
        var pathString = query.path.toString();
        this.log_('Listen called for ' + pathString + ' ' + queryId);
        if (!this.listens.has(pathString)) {
            this.listens.set(pathString, new Map());
        }
        util.assert(query.getQueryParams().isDefault() ||
            !query.getQueryParams().loadsAllData(), 'listen() called for non-default but complete query');
        util.assert(!this.listens.get(pathString).has(queryId), 'listen() called twice for same path/queryId.');
        var listenSpec = {
            onComplete: onComplete,
            hashFn: currentHashFn,
            query: query,
            tag: tag
        };
        this.listens.get(pathString).set(queryId, listenSpec);
        if (this.connected_) {
            this.sendListen_(listenSpec);
        }
    };
    PersistentConnection.prototype.sendListen_ = function (listenSpec) {
        var _this = this;
        var query = listenSpec.query;
        var pathString = query.path.toString();
        var queryId = query.queryIdentifier();
        this.log_('Listen on ' + pathString + ' for ' + queryId);
        var req = { /*path*/ p: pathString };
        var action = 'q';
        // Only bother to send query if it's non-default.
        if (listenSpec.tag) {
            req['q'] = query.queryObject();
            req['t'] = listenSpec.tag;
        }
        req[ /*hash*/'h'] = listenSpec.hashFn();
        this.sendRequest(action, req, function (message) {
            var payload = message[ /*data*/'d'];
            var status = message[ /*status*/'s'];
            // print warnings in any case...
            PersistentConnection.warnOnListenWarnings_(payload, query);
            var currentListenSpec = _this.listens.get(pathString) &&
                _this.listens.get(pathString).get(queryId);
            // only trigger actions if the listen hasn't been removed and readded
            if (currentListenSpec === listenSpec) {
                _this.log_('listen response', message);
                if (status !== 'ok') {
                    _this.removeListen_(pathString, queryId);
                }
                if (listenSpec.onComplete) {
                    listenSpec.onComplete(status, payload);
                }
            }
        });
    };
    PersistentConnection.warnOnListenWarnings_ = function (payload, query) {
        if (payload && typeof payload === 'object' && util.contains(payload, 'w')) {
            var warnings = util.safeGet(payload, 'w');
            if (Array.isArray(warnings) && ~warnings.indexOf('no_index')) {
                var indexSpec = '".indexOn": "' +
                    query
                        .getQueryParams()
                        .getIndex()
                        .toString() +
                    '"';
                var indexPath = query.path.toString();
                warn("Using an unspecified index. Your data will be downloaded and " +
                    ("filtered on the client. Consider adding " + indexSpec + " at ") +
                    (indexPath + " to your security rules for better performance."));
            }
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.refreshAuthToken = function (token) {
        this.authToken_ = token;
        this.log_('Auth token refreshed');
        if (this.authToken_) {
            this.tryAuth();
        }
        else {
            //If we're connected we want to let the server know to unauthenticate us. If we're not connected, simply delete
            //the credential so we dont become authenticated next time we connect.
            if (this.connected_) {
                this.sendRequest('unauth', {}, function () { });
            }
        }
        this.reduceReconnectDelayIfAdminCredential_(token);
    };
    PersistentConnection.prototype.reduceReconnectDelayIfAdminCredential_ = function (credential) {
        // NOTE: This isn't intended to be bulletproof (a malicious developer can always just modify the client).
        // Additionally, we don't bother resetting the max delay back to the default if auth fails / expires.
        var isFirebaseSecret = credential && credential.length === 40;
        if (isFirebaseSecret || util.isAdmin(credential)) {
            this.log_('Admin auth credential detected.  Reducing max reconnect time.');
            this.maxReconnectDelay_ = RECONNECT_MAX_DELAY_FOR_ADMINS;
        }
    };
    /**
     * Attempts to authenticate with the given credentials. If the authentication attempt fails, it's triggered like
     * a auth revoked (the connection is closed).
     */
    PersistentConnection.prototype.tryAuth = function () {
        var _this = this;
        if (this.connected_ && this.authToken_) {
            var token_1 = this.authToken_;
            var authMethod = util.isValidFormat(token_1) ? 'auth' : 'gauth';
            var requestData = { cred: token_1 };
            if (this.authOverride_ === null) {
                requestData['noauth'] = true;
            }
            else if (typeof this.authOverride_ === 'object') {
                requestData['authvar'] = this.authOverride_;
            }
            this.sendRequest(authMethod, requestData, function (res) {
                var status = res[ /*status*/'s'];
                var data = res[ /*data*/'d'] || 'error';
                if (_this.authToken_ === token_1) {
                    if (status === 'ok') {
                        _this.invalidAuthTokenCount_ = 0;
                    }
                    else {
                        // Triggers reconnect and force refresh for auth token
                        _this.onAuthRevoked_(status, data);
                    }
                }
            });
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.unlisten = function (query, tag) {
        var pathString = query.path.toString();
        var queryId = query.queryIdentifier();
        this.log_('Unlisten called for ' + pathString + ' ' + queryId);
        util.assert(query.getQueryParams().isDefault() ||
            !query.getQueryParams().loadsAllData(), 'unlisten() called for non-default but complete query');
        var listen = this.removeListen_(pathString, queryId);
        if (listen && this.connected_) {
            this.sendUnlisten_(pathString, queryId, query.queryObject(), tag);
        }
    };
    PersistentConnection.prototype.sendUnlisten_ = function (pathString, queryId, queryObj, tag) {
        this.log_('Unlisten on ' + pathString + ' for ' + queryId);
        var req = { /*path*/ p: pathString };
        var action = 'n';
        // Only bother sending queryId if it's non-default.
        if (tag) {
            req['q'] = queryObj;
            req['t'] = tag;
        }
        this.sendRequest(action, req);
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.onDisconnectPut = function (pathString, data, onComplete) {
        if (this.connected_) {
            this.sendOnDisconnect_('o', pathString, data, onComplete);
        }
        else {
            this.onDisconnectRequestQueue_.push({
                pathString: pathString,
                action: 'o',
                data: data,
                onComplete: onComplete
            });
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.onDisconnectMerge = function (pathString, data, onComplete) {
        if (this.connected_) {
            this.sendOnDisconnect_('om', pathString, data, onComplete);
        }
        else {
            this.onDisconnectRequestQueue_.push({
                pathString: pathString,
                action: 'om',
                data: data,
                onComplete: onComplete
            });
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.onDisconnectCancel = function (pathString, onComplete) {
        if (this.connected_) {
            this.sendOnDisconnect_('oc', pathString, null, onComplete);
        }
        else {
            this.onDisconnectRequestQueue_.push({
                pathString: pathString,
                action: 'oc',
                data: null,
                onComplete: onComplete
            });
        }
    };
    PersistentConnection.prototype.sendOnDisconnect_ = function (action, pathString, data, onComplete) {
        var request = { /*path*/ p: pathString, /*data*/ d: data };
        this.log_('onDisconnect ' + action, request);
        this.sendRequest(action, request, function (response) {
            if (onComplete) {
                setTimeout(function () {
                    onComplete(response[ /*status*/'s'], response[ /* data */'d']);
                }, Math.floor(0));
            }
        });
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.put = function (pathString, data, onComplete, hash) {
        this.putInternal('p', pathString, data, onComplete, hash);
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.merge = function (pathString, data, onComplete, hash) {
        this.putInternal('m', pathString, data, onComplete, hash);
    };
    PersistentConnection.prototype.putInternal = function (action, pathString, data, onComplete, hash) {
        var request = {
            /*path*/ p: pathString,
            /*data*/ d: data
        };
        if (hash !== undefined)
            request[ /*hash*/'h'] = hash;
        // TODO: Only keep track of the most recent put for a given path?
        this.outstandingPuts_.push({
            action: action,
            request: request,
            onComplete: onComplete
        });
        this.outstandingPutCount_++;
        var index = this.outstandingPuts_.length - 1;
        if (this.connected_) {
            this.sendPut_(index);
        }
        else {
            this.log_('Buffering put: ' + pathString);
        }
    };
    PersistentConnection.prototype.sendPut_ = function (index) {
        var _this = this;
        var action = this.outstandingPuts_[index].action;
        var request = this.outstandingPuts_[index].request;
        var onComplete = this.outstandingPuts_[index].onComplete;
        this.outstandingPuts_[index].queued = this.connected_;
        this.sendRequest(action, request, function (message) {
            _this.log_(action + ' response', message);
            delete _this.outstandingPuts_[index];
            _this.outstandingPutCount_--;
            // Clean up array occasionally.
            if (_this.outstandingPutCount_ === 0) {
                _this.outstandingPuts_ = [];
            }
            if (onComplete)
                onComplete(message[ /*status*/'s'], message[ /* data */'d']);
        });
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.reportStats = function (stats) {
        var _this = this;
        // If we're not connected, we just drop the stats.
        if (this.connected_) {
            var request = { /*counters*/ c: stats };
            this.log_('reportStats', request);
            this.sendRequest(/*stats*/ 's', request, function (result) {
                var status = result[ /*status*/'s'];
                if (status !== 'ok') {
                    var errorReason = result[ /* data */'d'];
                    _this.log_('reportStats', 'Error sending stats: ' + errorReason);
                }
            });
        }
    };
    PersistentConnection.prototype.onDataMessage_ = function (message) {
        if ('r' in message) {
            // this is a response
            this.log_('from server: ' + util.stringify(message));
            var reqNum = message['r'];
            var onResponse = this.requestCBHash_[reqNum];
            if (onResponse) {
                delete this.requestCBHash_[reqNum];
                onResponse(message[ /*body*/'b']);
            }
        }
        else if ('error' in message) {
            throw 'A server-side error has occurred: ' + message['error'];
        }
        else if ('a' in message) {
            // a and b are action and body, respectively
            this.onDataPush_(message['a'], message['b']);
        }
    };
    PersistentConnection.prototype.onDataPush_ = function (action, body) {
        this.log_('handleServerMessage', action, body);
        if (action === 'd')
            this.onDataUpdate_(body[ /*path*/'p'], body[ /*data*/'d'], 
            /*isMerge*/ false, body['t']);
        else if (action === 'm')
            this.onDataUpdate_(body[ /*path*/'p'], body[ /*data*/'d'], 
            /*isMerge=*/ true, body['t']);
        else if (action === 'c')
            this.onListenRevoked_(body[ /*path*/'p'], body[ /*query*/'q']);
        else if (action === 'ac')
            this.onAuthRevoked_(body[ /*status code*/'s'], body[ /* explanation */'d']);
        else if (action === 'sd')
            this.onSecurityDebugPacket_(body);
        else
            error('Unrecognized action received from server: ' +
                util.stringify(action) +
                '\nAre you using the latest client?');
    };
    PersistentConnection.prototype.onReady_ = function (timestamp, sessionId) {
        this.log_('connection ready');
        this.connected_ = true;
        this.lastConnectionEstablishedTime_ = new Date().getTime();
        this.handleTimestamp_(timestamp);
        this.lastSessionId = sessionId;
        if (this.firstConnection_) {
            this.sendConnectStats_();
        }
        this.restoreState_();
        this.firstConnection_ = false;
        this.onConnectStatus_(true);
    };
    PersistentConnection.prototype.scheduleConnect_ = function (timeout) {
        var _this = this;
        util.assert(!this.realtime_, "Scheduling a connect when we're already connected/ing?");
        if (this.establishConnectionTimer_) {
            clearTimeout(this.establishConnectionTimer_);
        }
        // NOTE: Even when timeout is 0, it's important to do a setTimeout to work around an infuriating "Security Error" in
        // Firefox when trying to write to our long-polling iframe in some scenarios (e.g. Forge or our unit tests).
        this.establishConnectionTimer_ = setTimeout(function () {
            _this.establishConnectionTimer_ = null;
            _this.establishConnection_();
        }, Math.floor(timeout));
    };
    PersistentConnection.prototype.onVisible_ = function (visible) {
        // NOTE: Tabbing away and back to a window will defeat our reconnect backoff, but I think that's fine.
        if (visible &&
            !this.visible_ &&
            this.reconnectDelay_ === this.maxReconnectDelay_) {
            this.log_('Window became visible.  Reducing delay.');
            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
            if (!this.realtime_) {
                this.scheduleConnect_(0);
            }
        }
        this.visible_ = visible;
    };
    PersistentConnection.prototype.onOnline_ = function (online) {
        if (online) {
            this.log_('Browser went online.');
            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
            if (!this.realtime_) {
                this.scheduleConnect_(0);
            }
        }
        else {
            this.log_('Browser went offline.  Killing connection.');
            if (this.realtime_) {
                this.realtime_.close();
            }
        }
    };
    PersistentConnection.prototype.onRealtimeDisconnect_ = function () {
        this.log_('data client disconnected');
        this.connected_ = false;
        this.realtime_ = null;
        // Since we don't know if our sent transactions succeeded or not, we need to cancel them.
        this.cancelSentTransactions_();
        // Clear out the pending requests.
        this.requestCBHash_ = {};
        if (this.shouldReconnect_()) {
            if (!this.visible_) {
                this.log_("Window isn't visible.  Delaying reconnect.");
                this.reconnectDelay_ = this.maxReconnectDelay_;
                this.lastConnectionAttemptTime_ = new Date().getTime();
            }
            else if (this.lastConnectionEstablishedTime_) {
                // If we've been connected long enough, reset reconnect delay to minimum.
                var timeSinceLastConnectSucceeded = new Date().getTime() - this.lastConnectionEstablishedTime_;
                if (timeSinceLastConnectSucceeded > RECONNECT_DELAY_RESET_TIMEOUT)
                    this.reconnectDelay_ = RECONNECT_MIN_DELAY;
                this.lastConnectionEstablishedTime_ = null;
            }
            var timeSinceLastConnectAttempt = new Date().getTime() - this.lastConnectionAttemptTime_;
            var reconnectDelay = Math.max(0, this.reconnectDelay_ - timeSinceLastConnectAttempt);
            reconnectDelay = Math.random() * reconnectDelay;
            this.log_('Trying to reconnect in ' + reconnectDelay + 'ms');
            this.scheduleConnect_(reconnectDelay);
            // Adjust reconnect delay for next time.
            this.reconnectDelay_ = Math.min(this.maxReconnectDelay_, this.reconnectDelay_ * RECONNECT_DELAY_MULTIPLIER);
        }
        this.onConnectStatus_(false);
    };
    PersistentConnection.prototype.establishConnection_ = function () {
        if (this.shouldReconnect_()) {
            this.log_('Making a connection attempt');
            this.lastConnectionAttemptTime_ = new Date().getTime();
            this.lastConnectionEstablishedTime_ = null;
            var onDataMessage_1 = this.onDataMessage_.bind(this);
            var onReady_1 = this.onReady_.bind(this);
            var onDisconnect_1 = this.onRealtimeDisconnect_.bind(this);
            var connId_1 = this.id + ':' + PersistentConnection.nextConnectionId_++;
            var self_1 = this;
            var lastSessionId_1 = this.lastSessionId;
            var canceled_1 = false;
            var connection_1 = null;
            var closeFn_1 = function () {
                if (connection_1) {
                    connection_1.close();
                }
                else {
                    canceled_1 = true;
                    onDisconnect_1();
                }
            };
            var sendRequestFn = function (msg) {
                util.assert(connection_1, "sendRequest call when we're not connected not allowed.");
                connection_1.sendRequest(msg);
            };
            this.realtime_ = {
                close: closeFn_1,
                sendRequest: sendRequestFn
            };
            var forceRefresh = this.forceTokenRefresh_;
            this.forceTokenRefresh_ = false;
            // First fetch auth token, and establish connection after fetching the token was successful
            this.authTokenProvider_
                .getToken(forceRefresh)
                .then(function (result) {
                if (!canceled_1) {
                    log('getToken() completed. Creating connection.');
                    self_1.authToken_ = result && result.accessToken;
                    connection_1 = new Connection(connId_1, self_1.repoInfo_, onDataMessage_1, onReady_1, onDisconnect_1, 
                    /* onKill= */ function (reason) {
                        warn(reason + ' (' + self_1.repoInfo_.toString() + ')');
                        self_1.interrupt(SERVER_KILL_INTERRUPT_REASON);
                    }, lastSessionId_1);
                }
                else {
                    log('getToken() completed but was canceled');
                }
            })
                .then(null, function (error) {
                self_1.log_('Failed to get token: ' + error);
                if (!canceled_1) {
                    if (util.CONSTANTS.NODE_ADMIN) {
                        // This may be a critical error for the Admin Node.js SDK, so log a warning.
                        // But getToken() may also just have temporarily failed, so we still want to
                        // continue retrying.
                        warn(error);
                    }
                    closeFn_1();
                }
            });
        }
    };
    PersistentConnection.prototype.interrupt = function (reason) {
        log('Interrupting connection for reason: ' + reason);
        this.interruptReasons_[reason] = true;
        if (this.realtime_) {
            this.realtime_.close();
        }
        else {
            if (this.establishConnectionTimer_) {
                clearTimeout(this.establishConnectionTimer_);
                this.establishConnectionTimer_ = null;
            }
            if (this.connected_) {
                this.onRealtimeDisconnect_();
            }
        }
    };
    PersistentConnection.prototype.resume = function (reason) {
        log('Resuming connection for reason: ' + reason);
        delete this.interruptReasons_[reason];
        if (util.isEmpty(this.interruptReasons_)) {
            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
            if (!this.realtime_) {
                this.scheduleConnect_(0);
            }
        }
    };
    PersistentConnection.prototype.handleTimestamp_ = function (timestamp) {
        var delta = timestamp - new Date().getTime();
        this.onServerInfoUpdate_({ serverTimeOffset: delta });
    };
    PersistentConnection.prototype.cancelSentTransactions_ = function () {
        for (var i = 0; i < this.outstandingPuts_.length; i++) {
            var put = this.outstandingPuts_[i];
            if (put && /*hash*/ 'h' in put.request && put.queued) {
                if (put.onComplete)
                    put.onComplete('disconnect');
                delete this.outstandingPuts_[i];
                this.outstandingPutCount_--;
            }
        }
        // Clean up array occasionally.
        if (this.outstandingPutCount_ === 0)
            this.outstandingPuts_ = [];
    };
    PersistentConnection.prototype.onListenRevoked_ = function (pathString, query) {
        // Remove the listen and manufacture a "permission_denied" error for the failed listen.
        var queryId;
        if (!query) {
            queryId = 'default';
        }
        else {
            queryId = query.map(function (q) { return ObjectToUniqueKey(q); }).join('$');
        }
        var listen = this.removeListen_(pathString, queryId);
        if (listen && listen.onComplete)
            listen.onComplete('permission_denied');
    };
    PersistentConnection.prototype.removeListen_ = function (pathString, queryId) {
        var normalizedPathString = new Path(pathString).toString(); // normalize path.
        var listen;
        if (this.listens.has(normalizedPathString)) {
            var map = this.listens.get(normalizedPathString);
            listen = map.get(queryId);
            map.delete(queryId);
            if (map.size === 0) {
                this.listens.delete(normalizedPathString);
            }
        }
        else {
            // all listens for this path has already been removed
            listen = undefined;
        }
        return listen;
    };
    PersistentConnection.prototype.onAuthRevoked_ = function (statusCode, explanation) {
        log('Auth token revoked: ' + statusCode + '/' + explanation);
        this.authToken_ = null;
        this.forceTokenRefresh_ = true;
        this.realtime_.close();
        if (statusCode === 'invalid_token' || statusCode === 'permission_denied') {
            // We'll wait a couple times before logging the warning / increasing the
            // retry period since oauth tokens will report as "invalid" if they're
            // just expired. Plus there may be transient issues that resolve themselves.
            this.invalidAuthTokenCount_++;
            if (this.invalidAuthTokenCount_ >= INVALID_AUTH_TOKEN_THRESHOLD) {
                // Set a long reconnect delay because recovery is unlikely
                this.reconnectDelay_ = RECONNECT_MAX_DELAY_FOR_ADMINS;
                // Notify the auth token provider that the token is invalid, which will log
                // a warning
                this.authTokenProvider_.notifyForInvalidToken();
            }
        }
    };
    PersistentConnection.prototype.onSecurityDebugPacket_ = function (body) {
        if (this.securityDebugCallback_) {
            this.securityDebugCallback_(body);
        }
        else {
            if ('msg' in body) {
                console.log('FIREBASE: ' + body['msg'].replace('\n', '\nFIREBASE: '));
            }
        }
    };
    PersistentConnection.prototype.restoreState_ = function () {
        var e_1, _a, e_2, _b;
        //Re-authenticate ourselves if we have a credential stored.
        this.tryAuth();
        try {
            // Puts depend on having received the corresponding data update from the server before they complete, so we must
            // make sure to send listens before puts.
            for (var _c = tslib.__values(this.listens.values()), _d = _c.next(); !_d.done; _d = _c.next()) {
                var queries = _d.value;
                try {
                    for (var _e = (e_2 = void 0, tslib.__values(queries.values())), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var listenSpec = _f.value;
                        this.sendListen_(listenSpec);
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        for (var i = 0; i < this.outstandingPuts_.length; i++) {
            if (this.outstandingPuts_[i])
                this.sendPut_(i);
        }
        while (this.onDisconnectRequestQueue_.length) {
            var request = this.onDisconnectRequestQueue_.shift();
            this.sendOnDisconnect_(request.action, request.pathString, request.data, request.onComplete);
        }
    };
    /**
     * Sends client stats for first connection
     */
    PersistentConnection.prototype.sendConnectStats_ = function () {
        var stats = {};
        var clientName = 'js';
        if (util.CONSTANTS.NODE_ADMIN) {
            clientName = 'admin_node';
        }
        else if (util.CONSTANTS.NODE_CLIENT) {
            clientName = 'node';
        }
        stats['sdk.' + clientName + '.' + SDK_VERSION.replace(/\./g, '-')] = 1;
        if (util.isMobileCordova()) {
            stats['framework.cordova'] = 1;
        }
        else if (util.isReactNative()) {
            stats['framework.reactnative'] = 1;
        }
        this.reportStats(stats);
    };
    PersistentConnection.prototype.shouldReconnect_ = function () {
        var online = OnlineMonitor.getInstance().currentlyOnline();
        return util.isEmpty(this.interruptReasons_) && online;
    };
    PersistentConnection.nextPersistentConnectionId_ = 0;
    /**
     * Counter for number of connections created. Mainly used for tagging in the logs
     */
    PersistentConnection.nextConnectionId_ = 0;
    return PersistentConnection;
}(ServerActions));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An implementation of ServerActions that communicates with the server via REST requests.
 * This is mostly useful for compatibility with crawlers, where we don't want to spin up a full
 * persistent connection (using WebSockets or long-polling)
 */
var ReadonlyRestClient = /** @class */ (function (_super) {
    tslib.__extends(ReadonlyRestClient, _super);
    /**
     * @param {!RepoInfo} repoInfo_ Data about the namespace we are connecting to
     * @param {function(string, *, boolean, ?number)} onDataUpdate_ A callback for new data from the server
     * @param {AuthTokenProvider} authTokenProvider_
     * @implements {ServerActions}
     */
    function ReadonlyRestClient(repoInfo_, onDataUpdate_, authTokenProvider_) {
        var _this = _super.call(this) || this;
        _this.repoInfo_ = repoInfo_;
        _this.onDataUpdate_ = onDataUpdate_;
        _this.authTokenProvider_ = authTokenProvider_;
        /** @private {function(...[*])} */
        _this.log_ = logWrapper('p:rest:');
        /**
         * We don't actually need to track listens, except to prevent us calling an onComplete for a listen
         * that's been removed. :-/
         *
         * @private {!Object.<string, !Object>}
         */
        _this.listens_ = {};
        return _this;
    }
    ReadonlyRestClient.prototype.reportStats = function (stats) {
        throw new Error('Method not implemented.');
    };
    /**
     * @param {!Query} query
     * @param {?number=} tag
     * @return {string}
     * @private
     */
    ReadonlyRestClient.getListenId_ = function (query, tag) {
        if (tag !== undefined) {
            return 'tag$' + tag;
        }
        else {
            util.assert(query.getQueryParams().isDefault(), "should have a tag if it's not a default query.");
            return query.path.toString();
        }
    };
    /** @inheritDoc */
    ReadonlyRestClient.prototype.listen = function (query, currentHashFn, tag, onComplete) {
        var _this = this;
        var pathString = query.path.toString();
        this.log_('Listen called for ' + pathString + ' ' + query.queryIdentifier());
        // Mark this listener so we can tell if it's removed.
        var listenId = ReadonlyRestClient.getListenId_(query, tag);
        var thisListen = {};
        this.listens_[listenId] = thisListen;
        var queryStringParameters = query
            .getQueryParams()
            .toRestQueryStringParameters();
        this.restRequest_(pathString + '.json', queryStringParameters, function (error, result) {
            var data = result;
            if (error === 404) {
                data = null;
                error = null;
            }
            if (error === null) {
                _this.onDataUpdate_(pathString, data, /*isMerge=*/ false, tag);
            }
            if (util.safeGet(_this.listens_, listenId) === thisListen) {
                var status_1;
                if (!error) {
                    status_1 = 'ok';
                }
                else if (error == 401) {
                    status_1 = 'permission_denied';
                }
                else {
                    status_1 = 'rest_error:' + error;
                }
                onComplete(status_1, null);
            }
        });
    };
    /** @inheritDoc */
    ReadonlyRestClient.prototype.unlisten = function (query, tag) {
        var listenId = ReadonlyRestClient.getListenId_(query, tag);
        delete this.listens_[listenId];
    };
    /** @inheritDoc */
    ReadonlyRestClient.prototype.refreshAuthToken = function (token) {
        // no-op since we just always call getToken.
    };
    /**
     * Performs a REST request to the given path, with the provided query string parameters,
     * and any auth credentials we have.
     *
     * @param {!string} pathString
     * @param {!Object.<string, *>} queryStringParameters
     * @param {?function(?number, *=)} callback
     * @private
     */
    ReadonlyRestClient.prototype.restRequest_ = function (pathString, queryStringParameters, callback) {
        var _this = this;
        if (queryStringParameters === void 0) { queryStringParameters = {}; }
        queryStringParameters['format'] = 'export';
        this.authTokenProvider_
            .getToken(/*forceRefresh=*/ false)
            .then(function (authTokenData) {
            var authToken = authTokenData && authTokenData.accessToken;
            if (authToken) {
                queryStringParameters['auth'] = authToken;
            }
            var url = (_this.repoInfo_.secure ? 'https://' : 'http://') +
                _this.repoInfo_.host +
                pathString +
                '?' +
                'ns=' +
                _this.repoInfo_.namespace +
                util.querystring(queryStringParameters);
            _this.log_('Sending REST request for ' + url);
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function () {
                if (callback && xhr.readyState === 4) {
                    _this.log_('REST Response for ' + url + ' received. status:', xhr.status, 'response:', xhr.responseText);
                    var res = null;
                    if (xhr.status >= 200 && xhr.status < 300) {
                        try {
                            res = util.jsonEval(xhr.responseText);
                        }
                        catch (e) {
                            warn('Failed to parse JSON response for ' +
                                url +
                                ': ' +
                                xhr.responseText);
                        }
                        callback(null, res);
                    }
                    else {
                        // 401 and 404 are expected.
                        if (xhr.status !== 401 && xhr.status !== 404) {
                            warn('Got unsuccessful REST response for ' +
                                url +
                                ' Status: ' +
                                xhr.status);
                        }
                        callback(xhr.status);
                    }
                    callback = null;
                }
            };
            xhr.open('GET', url, /*asynchronous=*/ true);
            xhr.send();
        });
    };
    return ReadonlyRestClient;
}(ServerActions));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var INTERRUPT_REASON = 'repo_interrupt';
/**
 * A connection to a single data repository.
 */
var Repo = /** @class */ (function () {
    function Repo(repoInfo_, forceRestClient, app) {
        var _this = this;
        this.repoInfo_ = repoInfo_;
        this.app = app;
        this.dataUpdateCount = 0;
        this.statsListener_ = null;
        this.eventQueue_ = new EventQueue();
        this.nextWriteId_ = 1;
        this.interceptServerDataCallback_ = null;
        /** A list of data pieces and paths to be set when this client disconnects. */
        this.onDisconnect_ = new SparseSnapshotTree();
        // TODO: This should be @private but it's used by test_access.js and internal.js
        this.persistentConnection_ = null;
        var authTokenProvider = new AuthTokenProvider(app);
        this.stats_ = StatsManager.getCollection(repoInfo_);
        if (forceRestClient || beingCrawled()) {
            this.server_ = new ReadonlyRestClient(this.repoInfo_, this.onDataUpdate_.bind(this), authTokenProvider);
            // Minor hack: Fire onConnect immediately, since there's no actual connection.
            setTimeout(this.onConnectStatus_.bind(this, true), 0);
        }
        else {
            var authOverride = app.options['databaseAuthVariableOverride'];
            // Validate authOverride
            if (typeof authOverride !== 'undefined' && authOverride !== null) {
                if (typeof authOverride !== 'object') {
                    throw new Error('Only objects are supported for option databaseAuthVariableOverride');
                }
                try {
                    util.stringify(authOverride);
                }
                catch (e) {
                    throw new Error('Invalid authOverride provided: ' + e);
                }
            }
            this.persistentConnection_ = new PersistentConnection(this.repoInfo_, this.onDataUpdate_.bind(this), this.onConnectStatus_.bind(this), this.onServerInfoUpdate_.bind(this), authTokenProvider, authOverride);
            this.server_ = this.persistentConnection_;
        }
        authTokenProvider.addTokenChangeListener(function (token) {
            _this.server_.refreshAuthToken(token);
        });
        // In the case of multiple Repos for the same repoInfo (i.e. there are multiple Firebase.Contexts being used),
        // we only want to create one StatsReporter.  As such, we'll report stats over the first Repo created.
        this.statsReporter_ = StatsManager.getOrCreateReporter(repoInfo_, function () { return new StatsReporter(_this.stats_, _this.server_); });
        this.transactions_init_();
        // Used for .info.
        this.infoData_ = new SnapshotHolder();
        this.infoSyncTree_ = new SyncTree({
            startListening: function (query, tag, currentHashFn, onComplete) {
                var infoEvents = [];
                var node = _this.infoData_.getNode(query.path);
                // This is possibly a hack, but we have different semantics for .info endpoints. We don't raise null events
                // on initial data...
                if (!node.isEmpty()) {
                    infoEvents = _this.infoSyncTree_.applyServerOverwrite(query.path, node);
                    setTimeout(function () {
                        onComplete('ok');
                    }, 0);
                }
                return infoEvents;
            },
            stopListening: function () { }
        });
        this.updateInfo_('connected', false);
        this.serverSyncTree_ = new SyncTree({
            startListening: function (query, tag, currentHashFn, onComplete) {
                _this.server_.listen(query, currentHashFn, tag, function (status, data) {
                    var events = onComplete(status, data);
                    _this.eventQueue_.raiseEventsForChangedPath(query.path, events);
                });
                // No synchronous events for network-backed sync trees
                return [];
            },
            stopListening: function (query, tag) {
                _this.server_.unlisten(query, tag);
            }
        });
    }
    /**
     * @return The URL corresponding to the root of this Firebase.
     */
    Repo.prototype.toString = function () {
        return ((this.repoInfo_.secure ? 'https://' : 'http://') + this.repoInfo_.host);
    };
    /**
     * @return The namespace represented by the repo.
     */
    Repo.prototype.name = function () {
        return this.repoInfo_.namespace;
    };
    /**
     * @return The time in milliseconds, taking the server offset into account if we have one.
     */
    Repo.prototype.serverTime = function () {
        var offsetNode = this.infoData_.getNode(new Path('.info/serverTimeOffset'));
        var offset = offsetNode.val() || 0;
        return new Date().getTime() + offset;
    };
    /**
     * Generate ServerValues using some variables from the repo object.
     */
    Repo.prototype.generateServerValues = function () {
        return generateWithValues({
            timestamp: this.serverTime()
        });
    };
    /**
     * Called by realtime when we get new messages from the server.
     */
    Repo.prototype.onDataUpdate_ = function (pathString, data, isMerge, tag) {
        // For testing.
        this.dataUpdateCount++;
        var path = new Path(pathString);
        data = this.interceptServerDataCallback_
            ? this.interceptServerDataCallback_(pathString, data)
            : data;
        var events = [];
        if (tag) {
            if (isMerge) {
                var taggedChildren = util.map(data, function (raw) {
                    return nodeFromJSON$1(raw);
                });
                events = this.serverSyncTree_.applyTaggedQueryMerge(path, taggedChildren, tag);
            }
            else {
                var taggedSnap = nodeFromJSON$1(data);
                events = this.serverSyncTree_.applyTaggedQueryOverwrite(path, taggedSnap, tag);
            }
        }
        else if (isMerge) {
            var changedChildren = util.map(data, function (raw) {
                return nodeFromJSON$1(raw);
            });
            events = this.serverSyncTree_.applyServerMerge(path, changedChildren);
        }
        else {
            var snap = nodeFromJSON$1(data);
            events = this.serverSyncTree_.applyServerOverwrite(path, snap);
        }
        var affectedPath = path;
        if (events.length > 0) {
            // Since we have a listener outstanding for each transaction, receiving any events
            // is a proxy for some change having occurred.
            affectedPath = this.rerunTransactions_(path);
        }
        this.eventQueue_.raiseEventsForChangedPath(affectedPath, events);
    };
    // TODO: This should be @private but it's used by test_access.js and internal.js
    Repo.prototype.interceptServerData_ = function (callback) {
        this.interceptServerDataCallback_ = callback;
    };
    Repo.prototype.onConnectStatus_ = function (connectStatus) {
        this.updateInfo_('connected', connectStatus);
        if (connectStatus === false) {
            this.runOnDisconnectEvents_();
        }
    };
    Repo.prototype.onServerInfoUpdate_ = function (updates) {
        var _this = this;
        each(updates, function (key, value) {
            _this.updateInfo_(key, value);
        });
    };
    Repo.prototype.updateInfo_ = function (pathString, value) {
        var path = new Path('/.info/' + pathString);
        var newNode = nodeFromJSON$1(value);
        this.infoData_.updateSnapshot(path, newNode);
        var events = this.infoSyncTree_.applyServerOverwrite(path, newNode);
        this.eventQueue_.raiseEventsForChangedPath(path, events);
    };
    Repo.prototype.getNextWriteId_ = function () {
        return this.nextWriteId_++;
    };
    Repo.prototype.setWithPriority = function (path, newVal, newPriority, onComplete) {
        var _this = this;
        this.log_('set', {
            path: path.toString(),
            value: newVal,
            priority: newPriority
        });
        // TODO: Optimize this behavior to either (a) store flag to skip resolving where possible and / or
        // (b) store unresolved paths on JSON parse
        var serverValues = this.generateServerValues();
        var newNodeUnresolved = nodeFromJSON$1(newVal, newPriority);
        var newNode = resolveDeferredValueSnapshot(newNodeUnresolved, serverValues);
        var writeId = this.getNextWriteId_();
        var events = this.serverSyncTree_.applyUserOverwrite(path, newNode, writeId, true);
        this.eventQueue_.queueEvents(events);
        this.server_.put(path.toString(), newNodeUnresolved.val(/*export=*/ true), function (status, errorReason) {
            var success = status === 'ok';
            if (!success) {
                warn('set at ' + path + ' failed: ' + status);
            }
            var clearEvents = _this.serverSyncTree_.ackUserWrite(writeId, !success);
            _this.eventQueue_.raiseEventsForChangedPath(path, clearEvents);
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
        var affectedPath = this.abortTransactions_(path);
        this.rerunTransactions_(affectedPath);
        // We queued the events above, so just flush the queue here
        this.eventQueue_.raiseEventsForChangedPath(affectedPath, []);
    };
    Repo.prototype.update = function (path, childrenToMerge, onComplete) {
        var _this = this;
        this.log_('update', { path: path.toString(), value: childrenToMerge });
        // Start with our existing data and merge each child into it.
        var empty = true;
        var serverValues = this.generateServerValues();
        var changedChildren = {};
        each(childrenToMerge, function (changedKey, changedValue) {
            empty = false;
            var newNodeUnresolved = nodeFromJSON$1(changedValue);
            changedChildren[changedKey] = resolveDeferredValueSnapshot(newNodeUnresolved, serverValues);
        });
        if (!empty) {
            var writeId_1 = this.getNextWriteId_();
            var events = this.serverSyncTree_.applyUserMerge(path, changedChildren, writeId_1);
            this.eventQueue_.queueEvents(events);
            this.server_.merge(path.toString(), childrenToMerge, function (status, errorReason) {
                var success = status === 'ok';
                if (!success) {
                    warn('update at ' + path + ' failed: ' + status);
                }
                var clearEvents = _this.serverSyncTree_.ackUserWrite(writeId_1, !success);
                var affectedPath = clearEvents.length > 0 ? _this.rerunTransactions_(path) : path;
                _this.eventQueue_.raiseEventsForChangedPath(affectedPath, clearEvents);
                _this.callOnCompleteCallback(onComplete, status, errorReason);
            });
            each(childrenToMerge, function (changedPath) {
                var affectedPath = _this.abortTransactions_(path.child(changedPath));
                _this.rerunTransactions_(affectedPath);
            });
            // We queued the events above, so just flush the queue here
            this.eventQueue_.raiseEventsForChangedPath(path, []);
        }
        else {
            log("update() called with empty data.  Don't do anything.");
            this.callOnCompleteCallback(onComplete, 'ok');
        }
    };
    /**
     * Applies all of the changes stored up in the onDisconnect_ tree.
     */
    Repo.prototype.runOnDisconnectEvents_ = function () {
        var _this = this;
        this.log_('onDisconnectEvents');
        var serverValues = this.generateServerValues();
        var resolvedOnDisconnectTree = resolveDeferredValueTree(this.onDisconnect_, serverValues);
        var events = [];
        resolvedOnDisconnectTree.forEachTree(Path.Empty, function (path, snap) {
            events = events.concat(_this.serverSyncTree_.applyServerOverwrite(path, snap));
            var affectedPath = _this.abortTransactions_(path);
            _this.rerunTransactions_(affectedPath);
        });
        this.onDisconnect_ = new SparseSnapshotTree();
        this.eventQueue_.raiseEventsForChangedPath(Path.Empty, events);
    };
    Repo.prototype.onDisconnectCancel = function (path, onComplete) {
        var _this = this;
        this.server_.onDisconnectCancel(path.toString(), function (status, errorReason) {
            if (status === 'ok') {
                _this.onDisconnect_.forget(path);
            }
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    Repo.prototype.onDisconnectSet = function (path, value, onComplete) {
        var _this = this;
        var newNode = nodeFromJSON$1(value);
        this.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), function (status, errorReason) {
            if (status === 'ok') {
                _this.onDisconnect_.remember(path, newNode);
            }
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    Repo.prototype.onDisconnectSetWithPriority = function (path, value, priority, onComplete) {
        var _this = this;
        var newNode = nodeFromJSON$1(value, priority);
        this.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), function (status, errorReason) {
            if (status === 'ok') {
                _this.onDisconnect_.remember(path, newNode);
            }
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    Repo.prototype.onDisconnectUpdate = function (path, childrenToMerge, onComplete) {
        var _this = this;
        if (util.isEmpty(childrenToMerge)) {
            log("onDisconnect().update() called with empty data.  Don't do anything.");
            this.callOnCompleteCallback(onComplete, 'ok');
            return;
        }
        this.server_.onDisconnectMerge(path.toString(), childrenToMerge, function (status, errorReason) {
            if (status === 'ok') {
                each(childrenToMerge, function (childName, childNode) {
                    var newChildNode = nodeFromJSON$1(childNode);
                    _this.onDisconnect_.remember(path.child(childName), newChildNode);
                });
            }
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    Repo.prototype.addEventCallbackForQuery = function (query, eventRegistration) {
        var events;
        if (query.path.getFront() === '.info') {
            events = this.infoSyncTree_.addEventRegistration(query, eventRegistration);
        }
        else {
            events = this.serverSyncTree_.addEventRegistration(query, eventRegistration);
        }
        this.eventQueue_.raiseEventsAtPath(query.path, events);
    };
    Repo.prototype.removeEventCallbackForQuery = function (query, eventRegistration) {
        // These are guaranteed not to raise events, since we're not passing in a cancelError. However, we can future-proof
        // a little bit by handling the return values anyways.
        var events;
        if (query.path.getFront() === '.info') {
            events = this.infoSyncTree_.removeEventRegistration(query, eventRegistration);
        }
        else {
            events = this.serverSyncTree_.removeEventRegistration(query, eventRegistration);
        }
        this.eventQueue_.raiseEventsAtPath(query.path, events);
    };
    Repo.prototype.interrupt = function () {
        if (this.persistentConnection_) {
            this.persistentConnection_.interrupt(INTERRUPT_REASON);
        }
    };
    Repo.prototype.resume = function () {
        if (this.persistentConnection_) {
            this.persistentConnection_.resume(INTERRUPT_REASON);
        }
    };
    Repo.prototype.stats = function (showDelta) {
        if (showDelta === void 0) { showDelta = false; }
        if (typeof console === 'undefined')
            return;
        var stats;
        if (showDelta) {
            if (!this.statsListener_)
                this.statsListener_ = new StatsListener(this.stats_);
            stats = this.statsListener_.get();
        }
        else {
            stats = this.stats_.get();
        }
        var longestName = Object.keys(stats).reduce(function (previousValue, currentValue) {
            return Math.max(currentValue.length, previousValue);
        }, 0);
        each(stats, function (stat, value) {
            var paddedStat = stat;
            // pad stat names to be the same length (plus 2 extra spaces).
            for (var i = stat.length; i < longestName + 2; i++) {
                paddedStat += ' ';
            }
            console.log(paddedStat + value);
        });
    };
    Repo.prototype.statsIncrementCounter = function (metric) {
        this.stats_.incrementCounter(metric);
        this.statsReporter_.includeStat(metric);
    };
    Repo.prototype.log_ = function () {
        var var_args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            var_args[_i] = arguments[_i];
        }
        var prefix = '';
        if (this.persistentConnection_) {
            prefix = this.persistentConnection_.id + ':';
        }
        log.apply(void 0, tslib.__spread([prefix], var_args));
    };
    Repo.prototype.callOnCompleteCallback = function (callback, status, errorReason) {
        if (callback) {
            exceptionGuard(function () {
                if (status == 'ok') {
                    callback(null);
                }
                else {
                    var code = (status || 'error').toUpperCase();
                    var message = code;
                    if (errorReason)
                        message += ': ' + errorReason;
                    var error = new Error(message);
                    error.code = code;
                    callback(error);
                }
            });
        }
    };
    Object.defineProperty(Repo.prototype, "database", {
        get: function () {
            return this.__database || (this.__database = new Database(this));
        },
        enumerable: true,
        configurable: true
    });
    return Repo;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Filters nodes by range and uses an IndexFilter to track any changes after filtering the node
 *
 * @constructor
 * @implements {NodeFilter}
 */
var RangedFilter = /** @class */ (function () {
    /**
     * @param {!QueryParams} params
     */
    function RangedFilter(params) {
        this.indexedFilter_ = new IndexedFilter(params.getIndex());
        this.index_ = params.getIndex();
        this.startPost_ = RangedFilter.getStartPost_(params);
        this.endPost_ = RangedFilter.getEndPost_(params);
    }
    /**
     * @return {!NamedNode}
     */
    RangedFilter.prototype.getStartPost = function () {
        return this.startPost_;
    };
    /**
     * @return {!NamedNode}
     */
    RangedFilter.prototype.getEndPost = function () {
        return this.endPost_;
    };
    /**
     * @param {!NamedNode} node
     * @return {boolean}
     */
    RangedFilter.prototype.matches = function (node) {
        return (this.index_.compare(this.getStartPost(), node) <= 0 &&
            this.index_.compare(node, this.getEndPost()) <= 0);
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.matches(new NamedNode(key, newChild))) {
            newChild = ChildrenNode.EMPTY_NODE;
        }
        return this.indexedFilter_.updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
        if (newSnap.isLeafNode()) {
            // Make sure we have a children node with the correct index, not a leaf node;
            newSnap = ChildrenNode.EMPTY_NODE;
        }
        var filtered = newSnap.withIndex(this.index_);
        // Don't support priorities on queries
        filtered = filtered.updatePriority(ChildrenNode.EMPTY_NODE);
        var self = this;
        newSnap.forEachChild(PRIORITY_INDEX, function (key, childNode) {
            if (!self.matches(new NamedNode(key, childNode))) {
                filtered = filtered.updateImmediateChild(key, ChildrenNode.EMPTY_NODE);
            }
        });
        return this.indexedFilter_.updateFullNode(oldSnap, filtered, optChangeAccumulator);
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.filtersNodes = function () {
        return true;
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.getIndexedFilter = function () {
        return this.indexedFilter_;
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.getIndex = function () {
        return this.index_;
    };
    /**
     * @param {!QueryParams} params
     * @return {!NamedNode}
     * @private
     */
    RangedFilter.getStartPost_ = function (params) {
        if (params.hasStart()) {
            var startName = params.getIndexStartName();
            return params.getIndex().makePost(params.getIndexStartValue(), startName);
        }
        else {
            return params.getIndex().minPost();
        }
    };
    /**
     * @param {!QueryParams} params
     * @return {!NamedNode}
     * @private
     */
    RangedFilter.getEndPost_ = function (params) {
        if (params.hasEnd()) {
            var endName = params.getIndexEndName();
            return params.getIndex().makePost(params.getIndexEndValue(), endName);
        }
        else {
            return params.getIndex().maxPost();
        }
    };
    return RangedFilter;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Applies a limit and a range to a node and uses RangedFilter to do the heavy lifting where possible
 *
 * @constructor
 * @implements {NodeFilter}
 */
var LimitedFilter = /** @class */ (function () {
    /**
     * @param {!QueryParams} params
     */
    function LimitedFilter(params) {
        this.rangedFilter_ = new RangedFilter(params);
        this.index_ = params.getIndex();
        this.limit_ = params.getLimit();
        this.reverse_ = !params.isViewFromLeft();
    }
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.rangedFilter_.matches(new NamedNode(key, newChild))) {
            newChild = ChildrenNode.EMPTY_NODE;
        }
        if (snap.getImmediateChild(key).equals(newChild)) {
            // No change
            return snap;
        }
        else if (snap.numChildren() < this.limit_) {
            return this.rangedFilter_
                .getIndexedFilter()
                .updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
        }
        else {
            return this.fullLimitUpdateChild_(snap, key, newChild, source, optChangeAccumulator);
        }
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
        var filtered;
        if (newSnap.isLeafNode() || newSnap.isEmpty()) {
            // Make sure we have a children node with the correct index, not a leaf node;
            filtered = ChildrenNode.EMPTY_NODE.withIndex(this.index_);
        }
        else {
            if (this.limit_ * 2 < newSnap.numChildren() &&
                newSnap.isIndexed(this.index_)) {
                // Easier to build up a snapshot, since what we're given has more than twice the elements we want
                filtered = ChildrenNode.EMPTY_NODE.withIndex(this.index_);
                // anchor to the startPost, endPost, or last element as appropriate
                var iterator = void 0;
                if (this.reverse_) {
                    iterator = newSnap.getReverseIteratorFrom(this.rangedFilter_.getEndPost(), this.index_);
                }
                else {
                    iterator = newSnap.getIteratorFrom(this.rangedFilter_.getStartPost(), this.index_);
                }
                var count = 0;
                while (iterator.hasNext() && count < this.limit_) {
                    var next = iterator.getNext();
                    var inRange = void 0;
                    if (this.reverse_) {
                        inRange =
                            this.index_.compare(this.rangedFilter_.getStartPost(), next) <= 0;
                    }
                    else {
                        inRange =
                            this.index_.compare(next, this.rangedFilter_.getEndPost()) <= 0;
                    }
                    if (inRange) {
                        filtered = filtered.updateImmediateChild(next.name, next.node);
                        count++;
                    }
                    else {
                        // if we have reached the end post, we cannot keep adding elemments
                        break;
                    }
                }
            }
            else {
                // The snap contains less than twice the limit. Faster to delete from the snap than build up a new one
                filtered = newSnap.withIndex(this.index_);
                // Don't support priorities on queries
                filtered = filtered.updatePriority(ChildrenNode.EMPTY_NODE);
                var startPost = void 0;
                var endPost = void 0;
                var cmp = void 0;
                var iterator = void 0;
                if (this.reverse_) {
                    iterator = filtered.getReverseIterator(this.index_);
                    startPost = this.rangedFilter_.getEndPost();
                    endPost = this.rangedFilter_.getStartPost();
                    var indexCompare_1 = this.index_.getCompare();
                    cmp = function (a, b) { return indexCompare_1(b, a); };
                }
                else {
                    iterator = filtered.getIterator(this.index_);
                    startPost = this.rangedFilter_.getStartPost();
                    endPost = this.rangedFilter_.getEndPost();
                    cmp = this.index_.getCompare();
                }
                var count = 0;
                var foundStartPost = false;
                while (iterator.hasNext()) {
                    var next = iterator.getNext();
                    if (!foundStartPost && cmp(startPost, next) <= 0) {
                        // start adding
                        foundStartPost = true;
                    }
                    var inRange = foundStartPost && count < this.limit_ && cmp(next, endPost) <= 0;
                    if (inRange) {
                        count++;
                    }
                    else {
                        filtered = filtered.updateImmediateChild(next.name, ChildrenNode.EMPTY_NODE);
                    }
                }
            }
        }
        return this.rangedFilter_
            .getIndexedFilter()
            .updateFullNode(oldSnap, filtered, optChangeAccumulator);
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.filtersNodes = function () {
        return true;
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.getIndexedFilter = function () {
        return this.rangedFilter_.getIndexedFilter();
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.getIndex = function () {
        return this.index_;
    };
    /**
     * @param {!Node} snap
     * @param {string} childKey
     * @param {!Node} childSnap
     * @param {!CompleteChildSource} source
     * @param {?ChildChangeAccumulator} changeAccumulator
     * @return {!Node}
     * @private
     */
    LimitedFilter.prototype.fullLimitUpdateChild_ = function (snap, childKey, childSnap, source, changeAccumulator) {
        // TODO: rename all cache stuff etc to general snap terminology
        var cmp;
        if (this.reverse_) {
            var indexCmp_1 = this.index_.getCompare();
            cmp = function (a, b) { return indexCmp_1(b, a); };
        }
        else {
            cmp = this.index_.getCompare();
        }
        var oldEventCache = snap;
        util.assert(oldEventCache.numChildren() == this.limit_, '');
        var newChildNamedNode = new NamedNode(childKey, childSnap);
        var windowBoundary = this.reverse_
            ? oldEventCache.getFirstChild(this.index_)
            : oldEventCache.getLastChild(this.index_);
        var inRange = this.rangedFilter_.matches(newChildNamedNode);
        if (oldEventCache.hasChild(childKey)) {
            var oldChildSnap = oldEventCache.getImmediateChild(childKey);
            var nextChild = source.getChildAfterChild(this.index_, windowBoundary, this.reverse_);
            while (nextChild != null &&
                (nextChild.name == childKey || oldEventCache.hasChild(nextChild.name))) {
                // There is a weird edge case where a node is updated as part of a merge in the write tree, but hasn't
                // been applied to the limited filter yet. Ignore this next child which will be updated later in
                // the limited filter...
                nextChild = source.getChildAfterChild(this.index_, nextChild, this.reverse_);
            }
            var compareNext = nextChild == null ? 1 : cmp(nextChild, newChildNamedNode);
            var remainsInWindow = inRange && !childSnap.isEmpty() && compareNext >= 0;
            if (remainsInWindow) {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange(Change.childChangedChange(childKey, childSnap, oldChildSnap));
                }
                return oldEventCache.updateImmediateChild(childKey, childSnap);
            }
            else {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange(Change.childRemovedChange(childKey, oldChildSnap));
                }
                var newEventCache = oldEventCache.updateImmediateChild(childKey, ChildrenNode.EMPTY_NODE);
                var nextChildInRange = nextChild != null && this.rangedFilter_.matches(nextChild);
                if (nextChildInRange) {
                    if (changeAccumulator != null) {
                        changeAccumulator.trackChildChange(Change.childAddedChange(nextChild.name, nextChild.node));
                    }
                    return newEventCache.updateImmediateChild(nextChild.name, nextChild.node);
                }
                else {
                    return newEventCache;
                }
            }
        }
        else if (childSnap.isEmpty()) {
            // we're deleting a node, but it was not in the window, so ignore it
            return snap;
        }
        else if (inRange) {
            if (cmp(windowBoundary, newChildNamedNode) >= 0) {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange(Change.childRemovedChange(windowBoundary.name, windowBoundary.node));
                    changeAccumulator.trackChildChange(Change.childAddedChange(childKey, childSnap));
                }
                return oldEventCache
                    .updateImmediateChild(childKey, childSnap)
                    .updateImmediateChild(windowBoundary.name, ChildrenNode.EMPTY_NODE);
            }
            else {
                return snap;
            }
        }
        else {
            return snap;
        }
    };
    return LimitedFilter;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * This class is an immutable-from-the-public-api struct containing a set of query parameters defining a
 * range to be returned for a particular location. It is assumed that validation of parameters is done at the
 * user-facing API level, so it is not done here.
 * @constructor
 */
var QueryParams = /** @class */ (function () {
    function QueryParams() {
        this.limitSet_ = false;
        this.startSet_ = false;
        this.startNameSet_ = false;
        this.endSet_ = false;
        this.endNameSet_ = false;
        this.limit_ = 0;
        this.viewFrom_ = '';
        this.indexStartValue_ = null;
        this.indexStartName_ = '';
        this.indexEndValue_ = null;
        this.indexEndName_ = '';
        this.index_ = PRIORITY_INDEX;
    }
    /**
     * @return {boolean}
     */
    QueryParams.prototype.hasStart = function () {
        return this.startSet_;
    };
    /**
     * @return {boolean} True if it would return from left.
     */
    QueryParams.prototype.isViewFromLeft = function () {
        if (this.viewFrom_ === '') {
            // limit(), rather than limitToFirst or limitToLast was called.
            // This means that only one of startSet_ and endSet_ is true. Use them
            // to calculate which side of the view to anchor to. If neither is set,
            // anchor to the end.
            return this.startSet_;
        }
        else {
            return (this.viewFrom_ === QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT);
        }
    };
    /**
     * Only valid to call if hasStart() returns true
     * @return {*}
     */
    QueryParams.prototype.getIndexStartValue = function () {
        util.assert(this.startSet_, 'Only valid if start has been set');
        return this.indexStartValue_;
    };
    /**
     * Only valid to call if hasStart() returns true.
     * Returns the starting key name for the range defined by these query parameters
     * @return {!string}
     */
    QueryParams.prototype.getIndexStartName = function () {
        util.assert(this.startSet_, 'Only valid if start has been set');
        if (this.startNameSet_) {
            return this.indexStartName_;
        }
        else {
            return MIN_NAME;
        }
    };
    /**
     * @return {boolean}
     */
    QueryParams.prototype.hasEnd = function () {
        return this.endSet_;
    };
    /**
     * Only valid to call if hasEnd() returns true.
     * @return {*}
     */
    QueryParams.prototype.getIndexEndValue = function () {
        util.assert(this.endSet_, 'Only valid if end has been set');
        return this.indexEndValue_;
    };
    /**
     * Only valid to call if hasEnd() returns true.
     * Returns the end key name for the range defined by these query parameters
     * @return {!string}
     */
    QueryParams.prototype.getIndexEndName = function () {
        util.assert(this.endSet_, 'Only valid if end has been set');
        if (this.endNameSet_) {
            return this.indexEndName_;
        }
        else {
            return MAX_NAME;
        }
    };
    /**
     * @return {boolean}
     */
    QueryParams.prototype.hasLimit = function () {
        return this.limitSet_;
    };
    /**
     * @return {boolean} True if a limit has been set and it has been explicitly anchored
     */
    QueryParams.prototype.hasAnchoredLimit = function () {
        return this.limitSet_ && this.viewFrom_ !== '';
    };
    /**
     * Only valid to call if hasLimit() returns true
     * @return {!number}
     */
    QueryParams.prototype.getLimit = function () {
        util.assert(this.limitSet_, 'Only valid if limit has been set');
        return this.limit_;
    };
    /**
     * @return {!Index}
     */
    QueryParams.prototype.getIndex = function () {
        return this.index_;
    };
    /**
     * @return {!QueryParams}
     * @private
     */
    QueryParams.prototype.copy_ = function () {
        var copy = new QueryParams();
        copy.limitSet_ = this.limitSet_;
        copy.limit_ = this.limit_;
        copy.startSet_ = this.startSet_;
        copy.indexStartValue_ = this.indexStartValue_;
        copy.startNameSet_ = this.startNameSet_;
        copy.indexStartName_ = this.indexStartName_;
        copy.endSet_ = this.endSet_;
        copy.indexEndValue_ = this.indexEndValue_;
        copy.endNameSet_ = this.endNameSet_;
        copy.indexEndName_ = this.indexEndName_;
        copy.index_ = this.index_;
        copy.viewFrom_ = this.viewFrom_;
        return copy;
    };
    /**
     * @param {!number} newLimit
     * @return {!QueryParams}
     */
    QueryParams.prototype.limit = function (newLimit) {
        var newParams = this.copy_();
        newParams.limitSet_ = true;
        newParams.limit_ = newLimit;
        newParams.viewFrom_ = '';
        return newParams;
    };
    /**
     * @param {!number} newLimit
     * @return {!QueryParams}
     */
    QueryParams.prototype.limitToFirst = function (newLimit) {
        var newParams = this.copy_();
        newParams.limitSet_ = true;
        newParams.limit_ = newLimit;
        newParams.viewFrom_ = QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT;
        return newParams;
    };
    /**
     * @param {!number} newLimit
     * @return {!QueryParams}
     */
    QueryParams.prototype.limitToLast = function (newLimit) {
        var newParams = this.copy_();
        newParams.limitSet_ = true;
        newParams.limit_ = newLimit;
        newParams.viewFrom_ = QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_RIGHT;
        return newParams;
    };
    /**
     * @param {*} indexValue
     * @param {?string=} key
     * @return {!QueryParams}
     */
    QueryParams.prototype.startAt = function (indexValue, key) {
        var newParams = this.copy_();
        newParams.startSet_ = true;
        if (indexValue === undefined) {
            indexValue = null;
        }
        newParams.indexStartValue_ = indexValue;
        if (key != null) {
            newParams.startNameSet_ = true;
            newParams.indexStartName_ = key;
        }
        else {
            newParams.startNameSet_ = false;
            newParams.indexStartName_ = '';
        }
        return newParams;
    };
    /**
     * @param {*} indexValue
     * @param {?string=} key
     * @return {!QueryParams}
     */
    QueryParams.prototype.endAt = function (indexValue, key) {
        var newParams = this.copy_();
        newParams.endSet_ = true;
        if (indexValue === undefined) {
            indexValue = null;
        }
        newParams.indexEndValue_ = indexValue;
        if (key !== undefined) {
            newParams.endNameSet_ = true;
            newParams.indexEndName_ = key;
        }
        else {
            newParams.endNameSet_ = false;
            newParams.indexEndName_ = '';
        }
        return newParams;
    };
    /**
     * @param {!Index} index
     * @return {!QueryParams}
     */
    QueryParams.prototype.orderBy = function (index) {
        var newParams = this.copy_();
        newParams.index_ = index;
        return newParams;
    };
    /**
     * @return {!Object}
     */
    QueryParams.prototype.getQueryObject = function () {
        var WIRE_PROTOCOL_CONSTANTS = QueryParams.WIRE_PROTOCOL_CONSTANTS_;
        var obj = {};
        if (this.startSet_) {
            obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_VALUE] = this.indexStartValue_;
            if (this.startNameSet_) {
                obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_NAME] = this.indexStartName_;
            }
        }
        if (this.endSet_) {
            obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_VALUE] = this.indexEndValue_;
            if (this.endNameSet_) {
                obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_NAME] = this.indexEndName_;
            }
        }
        if (this.limitSet_) {
            obj[WIRE_PROTOCOL_CONSTANTS.LIMIT] = this.limit_;
            var viewFrom = this.viewFrom_;
            if (viewFrom === '') {
                if (this.isViewFromLeft()) {
                    viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT;
                }
                else {
                    viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_RIGHT;
                }
            }
            obj[WIRE_PROTOCOL_CONSTANTS.VIEW_FROM] = viewFrom;
        }
        // For now, priority index is the default, so we only specify if it's some other index
        if (this.index_ !== PRIORITY_INDEX) {
            obj[WIRE_PROTOCOL_CONSTANTS.INDEX] = this.index_.toString();
        }
        return obj;
    };
    /**
     * @return {boolean}
     */
    QueryParams.prototype.loadsAllData = function () {
        return !(this.startSet_ || this.endSet_ || this.limitSet_);
    };
    /**
     * @return {boolean}
     */
    QueryParams.prototype.isDefault = function () {
        return this.loadsAllData() && this.index_ == PRIORITY_INDEX;
    };
    /**
     * @return {!NodeFilter}
     */
    QueryParams.prototype.getNodeFilter = function () {
        if (this.loadsAllData()) {
            return new IndexedFilter(this.getIndex());
        }
        else if (this.hasLimit()) {
            return new LimitedFilter(this);
        }
        else {
            return new RangedFilter(this);
        }
    };
    /**
     * Returns a set of REST query string parameters representing this query.
     *
     * @return {!Object.<string,*>} query string parameters
     */
    QueryParams.prototype.toRestQueryStringParameters = function () {
        var REST_CONSTANTS = QueryParams.REST_QUERY_CONSTANTS_;
        var qs = {};
        if (this.isDefault()) {
            return qs;
        }
        var orderBy;
        if (this.index_ === PRIORITY_INDEX) {
            orderBy = REST_CONSTANTS.PRIORITY_INDEX;
        }
        else if (this.index_ === VALUE_INDEX) {
            orderBy = REST_CONSTANTS.VALUE_INDEX;
        }
        else if (this.index_ === KEY_INDEX) {
            orderBy = REST_CONSTANTS.KEY_INDEX;
        }
        else {
            util.assert(this.index_ instanceof PathIndex, 'Unrecognized index type!');
            orderBy = this.index_.toString();
        }
        qs[REST_CONSTANTS.ORDER_BY] = util.stringify(orderBy);
        if (this.startSet_) {
            qs[REST_CONSTANTS.START_AT] = util.stringify(this.indexStartValue_);
            if (this.startNameSet_) {
                qs[REST_CONSTANTS.START_AT] += ',' + util.stringify(this.indexStartName_);
            }
        }
        if (this.endSet_) {
            qs[REST_CONSTANTS.END_AT] = util.stringify(this.indexEndValue_);
            if (this.endNameSet_) {
                qs[REST_CONSTANTS.END_AT] += ',' + util.stringify(this.indexEndName_);
            }
        }
        if (this.limitSet_) {
            if (this.isViewFromLeft()) {
                qs[REST_CONSTANTS.LIMIT_TO_FIRST] = this.limit_;
            }
            else {
                qs[REST_CONSTANTS.LIMIT_TO_LAST] = this.limit_;
            }
        }
        return qs;
    };
    /**
     * Wire Protocol Constants
     * @const
     * @enum {string}
     * @private
     */
    QueryParams.WIRE_PROTOCOL_CONSTANTS_ = {
        INDEX_START_VALUE: 'sp',
        INDEX_START_NAME: 'sn',
        INDEX_END_VALUE: 'ep',
        INDEX_END_NAME: 'en',
        LIMIT: 'l',
        VIEW_FROM: 'vf',
        VIEW_FROM_LEFT: 'l',
        VIEW_FROM_RIGHT: 'r',
        INDEX: 'i'
    };
    /**
     * REST Query Constants
     * @const
     * @enum {string}
     * @private
     */
    QueryParams.REST_QUERY_CONSTANTS_ = {
        ORDER_BY: 'orderBy',
        PRIORITY_INDEX: '$priority',
        VALUE_INDEX: '$value',
        KEY_INDEX: '$key',
        START_AT: 'startAt',
        END_AT: 'endAt',
        LIMIT_TO_FIRST: 'limitToFirst',
        LIMIT_TO_LAST: 'limitToLast'
    };
    /**
     * Default, empty query parameters
     * @type {!QueryParams}
     * @const
     */
    QueryParams.DEFAULT = new QueryParams();
    return QueryParams;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Reference = /** @class */ (function (_super) {
    tslib.__extends(Reference, _super);
    /**
     * Call options:
     *   new Reference(Repo, Path) or
     *   new Reference(url: string, string|RepoManager)
     *
     * Externally - this is the firebase.database.Reference type.
     *
     * @param {!Repo} repo
     * @param {(!Path)} path
     * @extends {Query}
     */
    function Reference(repo, path) {
        var _this = this;
        if (!(repo instanceof Repo)) {
            throw new Error('new Reference() no longer supported - use app.database().');
        }
        // call Query's constructor, passing in the repo and path.
        _this = _super.call(this, repo, path, QueryParams.DEFAULT, false) || this;
        return _this;
    }
    /** @return {?string} */
    Reference.prototype.getKey = function () {
        util.validateArgCount('Reference.key', 0, 0, arguments.length);
        if (this.path.isEmpty())
            return null;
        else
            return this.path.getBack();
    };
    /**
     * @param {!(string|Path)} pathString
     * @return {!Reference}
     */
    Reference.prototype.child = function (pathString) {
        util.validateArgCount('Reference.child', 1, 1, arguments.length);
        if (typeof pathString === 'number') {
            pathString = String(pathString);
        }
        else if (!(pathString instanceof Path)) {
            if (this.path.getFront() === null)
                validateRootPathString('Reference.child', 1, pathString, false);
            else
                validatePathString('Reference.child', 1, pathString, false);
        }
        return new Reference(this.repo, this.path.child(pathString));
    };
    /** @return {?Reference} */
    Reference.prototype.getParent = function () {
        util.validateArgCount('Reference.parent', 0, 0, arguments.length);
        var parentPath = this.path.parent();
        return parentPath === null ? null : new Reference(this.repo, parentPath);
    };
    /** @return {!Reference} */
    Reference.prototype.getRoot = function () {
        util.validateArgCount('Reference.root', 0, 0, arguments.length);
        var ref = this;
        while (ref.getParent() !== null) {
            ref = ref.getParent();
        }
        return ref;
    };
    /** @return {!Database} */
    Reference.prototype.databaseProp = function () {
        return this.repo.database;
    };
    /**
     * @param {*} newVal
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.set = function (newVal, onComplete) {
        util.validateArgCount('Reference.set', 1, 2, arguments.length);
        validateWritablePath('Reference.set', this.path);
        validateFirebaseDataArg('Reference.set', 1, newVal, this.path, false);
        util.validateCallback('Reference.set', 2, onComplete, true);
        var deferred = new util.Deferred();
        this.repo.setWithPriority(this.path, newVal, 
        /*priority=*/ null, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {!Object} objectToMerge
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.update = function (objectToMerge, onComplete) {
        util.validateArgCount('Reference.update', 1, 2, arguments.length);
        validateWritablePath('Reference.update', this.path);
        if (Array.isArray(objectToMerge)) {
            var newObjectToMerge = {};
            for (var i = 0; i < objectToMerge.length; ++i) {
                newObjectToMerge['' + i] = objectToMerge[i];
            }
            objectToMerge = newObjectToMerge;
            warn('Passing an Array to Firebase.update() is deprecated. ' +
                'Use set() if you want to overwrite the existing data, or ' +
                'an Object with integer keys if you really do want to ' +
                'only update some of the children.');
        }
        validateFirebaseMergeDataArg('Reference.update', 1, objectToMerge, this.path, false);
        util.validateCallback('Reference.update', 2, onComplete, true);
        var deferred = new util.Deferred();
        this.repo.update(this.path, objectToMerge, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*} newVal
     * @param {string|number|null} newPriority
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.setWithPriority = function (newVal, newPriority, onComplete) {
        util.validateArgCount('Reference.setWithPriority', 2, 3, arguments.length);
        validateWritablePath('Reference.setWithPriority', this.path);
        validateFirebaseDataArg('Reference.setWithPriority', 1, newVal, this.path, false);
        validatePriority('Reference.setWithPriority', 2, newPriority, false);
        util.validateCallback('Reference.setWithPriority', 3, onComplete, true);
        if (this.getKey() === '.length' || this.getKey() === '.keys')
            throw 'Reference.setWithPriority failed: ' +
                this.getKey() +
                ' is a read-only object.';
        var deferred = new util.Deferred();
        this.repo.setWithPriority(this.path, newVal, newPriority, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.remove = function (onComplete) {
        util.validateArgCount('Reference.remove', 0, 1, arguments.length);
        validateWritablePath('Reference.remove', this.path);
        util.validateCallback('Reference.remove', 1, onComplete, true);
        return this.set(null, onComplete);
    };
    /**
     * @param {function(*):*} transactionUpdate
     * @param {(function(?Error, boolean, ?DataSnapshot))=} onComplete
     * @param {boolean=} applyLocally
     * @return {!Promise}
     */
    Reference.prototype.transaction = function (transactionUpdate, onComplete, applyLocally) {
        util.validateArgCount('Reference.transaction', 1, 3, arguments.length);
        validateWritablePath('Reference.transaction', this.path);
        util.validateCallback('Reference.transaction', 1, transactionUpdate, false);
        util.validateCallback('Reference.transaction', 2, onComplete, true);
        // NOTE: applyLocally is an internal-only option for now.  We need to decide if we want to keep it and how
        // to expose it.
        validateBoolean('Reference.transaction', 3, applyLocally, true);
        if (this.getKey() === '.length' || this.getKey() === '.keys')
            throw 'Reference.transaction failed: ' +
                this.getKey() +
                ' is a read-only object.';
        if (applyLocally === undefined)
            applyLocally = true;
        var deferred = new util.Deferred();
        if (typeof onComplete === 'function') {
            deferred.promise.catch(function () { });
        }
        var promiseComplete = function (error, committed, snapshot) {
            if (error) {
                deferred.reject(error);
            }
            else {
                deferred.resolve(new TransactionResult(committed, snapshot));
            }
            if (typeof onComplete === 'function') {
                onComplete(error, committed, snapshot);
            }
        };
        this.repo.startTransaction(this.path, transactionUpdate, promiseComplete, applyLocally);
        return deferred.promise;
    };
    /**
     * @param {string|number|null} priority
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.setPriority = function (priority, onComplete) {
        util.validateArgCount('Reference.setPriority', 1, 2, arguments.length);
        validateWritablePath('Reference.setPriority', this.path);
        validatePriority('Reference.setPriority', 1, priority, false);
        util.validateCallback('Reference.setPriority', 2, onComplete, true);
        var deferred = new util.Deferred();
        this.repo.setWithPriority(this.path.child('.priority'), priority, null, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*=} value
     * @param {function(?Error)=} onComplete
     * @return {!Reference}
     */
    Reference.prototype.push = function (value, onComplete) {
        util.validateArgCount('Reference.push', 0, 2, arguments.length);
        validateWritablePath('Reference.push', this.path);
        validateFirebaseDataArg('Reference.push', 1, value, this.path, true);
        util.validateCallback('Reference.push', 2, onComplete, true);
        var now = this.repo.serverTime();
        var name = nextPushId(now);
        // push() returns a ThennableReference whose promise is fulfilled with a regular Reference.
        // We use child() to create handles to two different references. The first is turned into a
        // ThennableReference below by adding then() and catch() methods and is used as the
        // return value of push(). The second remains a regular Reference and is used as the fulfilled
        // value of the first ThennableReference.
        var thennablePushRef = this.child(name);
        var pushRef = this.child(name);
        var promise;
        if (value != null) {
            promise = thennablePushRef.set(value, onComplete).then(function () { return pushRef; });
        }
        else {
            promise = Promise.resolve(pushRef);
        }
        thennablePushRef.then = promise.then.bind(promise);
        thennablePushRef.catch = promise.then.bind(promise, undefined);
        if (typeof onComplete === 'function') {
            promise.catch(function () { });
        }
        return thennablePushRef;
    };
    /**
     * @return {!OnDisconnect}
     */
    Reference.prototype.onDisconnect = function () {
        validateWritablePath('Reference.onDisconnect', this.path);
        return new OnDisconnect(this.repo, this.path);
    };
    Object.defineProperty(Reference.prototype, "database", {
        get: function () {
            return this.databaseProp();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "key", {
        get: function () {
            return this.getKey();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "parent", {
        get: function () {
            return this.getParent();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "root", {
        get: function () {
            return this.getRoot();
        },
        enumerable: true,
        configurable: true
    });
    return Reference;
}(Query));
/**
 * Define reference constructor in various modules
 *
 * We are doing this here to avoid several circular
 * dependency issues
 */
Query.__referenceConstructor = Reference;
SyncPoint.__referenceConstructor = Reference;

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Node in a Tree.
 */
var TreeNode = /** @class */ (function () {
    function TreeNode() {
        // TODO: Consider making accessors that create children and value lazily or
        // separate Internal / Leaf 'types'.
        this.children = {};
        this.childCount = 0;
        this.value = null;
    }
    return TreeNode;
}());
/**
 * A light-weight tree, traversable by path.  Nodes can have both values and children.
 * Nodes are not enumerated (by forEachChild) unless they have a value or non-empty
 * children.
 */
var Tree = /** @class */ (function () {
    /**
     * @template T
     * @param {string=} name_ Optional name of the node.
     * @param {Tree=} parent_ Optional parent node.
     * @param {TreeNode=} node_ Optional node to wrap.
     */
    function Tree(name_, parent_, node_) {
        if (name_ === void 0) { name_ = ''; }
        if (parent_ === void 0) { parent_ = null; }
        if (node_ === void 0) { node_ = new TreeNode(); }
        this.name_ = name_;
        this.parent_ = parent_;
        this.node_ = node_;
    }
    /**
     * Returns a sub-Tree for the given path.
     *
     * @param {!(string|Path)} pathObj Path to look up.
     * @return {!Tree.<T>} Tree for path.
     */
    Tree.prototype.subTree = function (pathObj) {
        // TODO: Require pathObj to be Path?
        var path = pathObj instanceof Path ? pathObj : new Path(pathObj);
        var child = this, next;
        while ((next = path.getFront()) !== null) {
            var childNode = util.safeGet(child.node_.children, next) || new TreeNode();
            child = new Tree(next, child, childNode);
            path = path.popFront();
        }
        return child;
    };
    /**
     * Returns the data associated with this tree node.
     *
     * @return {?T} The data or null if no data exists.
     */
    Tree.prototype.getValue = function () {
        return this.node_.value;
    };
    /**
     * Sets data to this tree node.
     *
     * @param {!T} value Value to set.
     */
    Tree.prototype.setValue = function (value) {
        util.assert(typeof value !== 'undefined', 'Cannot set value to undefined');
        this.node_.value = value;
        this.updateParents_();
    };
    /**
     * Clears the contents of the tree node (its value and all children).
     */
    Tree.prototype.clear = function () {
        this.node_.value = null;
        this.node_.children = {};
        this.node_.childCount = 0;
        this.updateParents_();
    };
    /**
     * @return {boolean} Whether the tree has any children.
     */
    Tree.prototype.hasChildren = function () {
        return this.node_.childCount > 0;
    };
    /**
     * @return {boolean} Whether the tree is empty (no value or children).
     */
    Tree.prototype.isEmpty = function () {
        return this.getValue() === null && !this.hasChildren();
    };
    /**
     * Calls action for each child of this tree node.
     *
     * @param {function(!Tree.<T>)} action Action to be called for each child.
     */
    Tree.prototype.forEachChild = function (action) {
        var _this = this;
        each(this.node_.children, function (child, childTree) {
            action(new Tree(child, _this, childTree));
        });
    };
    /**
     * Does a depth-first traversal of this node's descendants, calling action for each one.
     *
     * @param {function(!Tree.<T>)} action Action to be called for each child.
     * @param {boolean=} includeSelf Whether to call action on this node as well. Defaults to
     *   false.
     * @param {boolean=} childrenFirst Whether to call action on children before calling it on
     *   parent.
     */
    Tree.prototype.forEachDescendant = function (action, includeSelf, childrenFirst) {
        if (includeSelf && !childrenFirst)
            action(this);
        this.forEachChild(function (child) {
            child.forEachDescendant(action, /*includeSelf=*/ true, childrenFirst);
        });
        if (includeSelf && childrenFirst)
            action(this);
    };
    /**
     * Calls action on each ancestor node.
     *
     * @param {function(!Tree.<T>)} action Action to be called on each parent; return
     *   true to abort.
     * @param {boolean=} includeSelf Whether to call action on this node as well.
     * @return {boolean} true if the action callback returned true.
     */
    Tree.prototype.forEachAncestor = function (action, includeSelf) {
        var node = includeSelf ? this : this.parent();
        while (node !== null) {
            if (action(node)) {
                return true;
            }
            node = node.parent();
        }
        return false;
    };
    /**
     * Does a depth-first traversal of this node's descendants.  When a descendant with a value
     * is found, action is called on it and traversal does not continue inside the node.
     * Action is *not* called on this node.
     *
     * @param {function(!Tree.<T>)} action Action to be called for each child.
     */
    Tree.prototype.forEachImmediateDescendantWithValue = function (action) {
        this.forEachChild(function (child) {
            if (child.getValue() !== null)
                action(child);
            else
                child.forEachImmediateDescendantWithValue(action);
        });
    };
    /**
     * @return {!Path} The path of this tree node, as a Path.
     */
    Tree.prototype.path = function () {
        return new Path(this.parent_ === null
            ? this.name_
            : this.parent_.path() + '/' + this.name_);
    };
    /**
     * @return {string} The name of the tree node.
     */
    Tree.prototype.name = function () {
        return this.name_;
    };
    /**
     * @return {?Tree} The parent tree node, or null if this is the root of the tree.
     */
    Tree.prototype.parent = function () {
        return this.parent_;
    };
    /**
     * Adds or removes this child from its parent based on whether it's empty or not.
     *
     * @private
     */
    Tree.prototype.updateParents_ = function () {
        if (this.parent_ !== null)
            this.parent_.updateChild_(this.name_, this);
    };
    /**
     * Adds or removes the passed child to this tree node, depending on whether it's empty.
     *
     * @param {string} childName The name of the child to update.
     * @param {!Tree.<T>} child The child to update.
     * @private
     */
    Tree.prototype.updateChild_ = function (childName, child) {
        var childEmpty = child.isEmpty();
        var childExists = util.contains(this.node_.children, childName);
        if (childEmpty && childExists) {
            delete this.node_.children[childName];
            this.node_.childCount--;
            this.updateParents_();
        }
        else if (!childEmpty && !childExists) {
            this.node_.children[childName] = child.node_;
            this.node_.childCount++;
            this.updateParents_();
        }
    };
    return Tree;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// TODO: This is pretty messy.  Ideally, a lot of this would move into FirebaseData, or a transaction-specific
// component used by FirebaseData, but it has ties to user callbacks (transaction update and onComplete) as well
// as the realtime connection (to send transactions to the server).  So that all needs to be decoupled first.
// For now it's part of Repo, but in its own file.
/**
 * @enum {number}
 */
var TransactionStatus;
(function (TransactionStatus) {
    // We've run the transaction and updated transactionResultData_ with the result, but it isn't currently sent to the
    // server. A transaction will go from RUN -> SENT -> RUN if it comes back from the server as rejected due to
    // mismatched hash.
    TransactionStatus[TransactionStatus["RUN"] = 0] = "RUN";
    // We've run the transaction and sent it to the server and it's currently outstanding (hasn't come back as accepted
    // or rejected yet).
    TransactionStatus[TransactionStatus["SENT"] = 1] = "SENT";
    // Temporary state used to mark completed transactions (whether successful or aborted).  The transaction will be
    // removed when we get a chance to prune completed ones.
    TransactionStatus[TransactionStatus["COMPLETED"] = 2] = "COMPLETED";
    // Used when an already-sent transaction needs to be aborted (e.g. due to a conflicting set() call that was made).
    // If it comes back as unsuccessful, we'll abort it.
    TransactionStatus[TransactionStatus["SENT_NEEDS_ABORT"] = 3] = "SENT_NEEDS_ABORT";
    // Temporary state used to mark transactions that need to be aborted.
    TransactionStatus[TransactionStatus["NEEDS_ABORT"] = 4] = "NEEDS_ABORT";
})(TransactionStatus || (TransactionStatus = {}));
/**
 * If a transaction does not succeed after 25 retries, we abort it.  Among other things this ensure that if there's
 * ever a bug causing a mismatch between client / server hashes for some data, we won't retry indefinitely.
 * @type {number}
 * @const
 * @private
 */
Repo.MAX_TRANSACTION_RETRIES_ = 25;
/**
 * Setup the transaction data structures
 * @private
 */
Repo.prototype.transactions_init_ = function () {
    /**
     * Stores queues of outstanding transactions for Firebase locations.
     *
     * @type {!Tree.<Array.<!Transaction>>}
     * @private
     */
    this.transactionQueueTree_ = new Tree();
};
/**
 * Creates a new transaction, adds it to the transactions we're tracking, and sends it to the server if possible.
 *
 * @param {!Path} path Path at which to do transaction.
 * @param {function(*):*} transactionUpdate Update callback.
 * @param {?function(?Error, boolean, ?DataSnapshot)} onComplete Completion callback.
 * @param {boolean} applyLocally Whether or not to make intermediate results visible
 */
Repo.prototype.startTransaction = function (path, transactionUpdate, onComplete, applyLocally) {
    this.log_('transaction on ' + path);
    // Add a watch to make sure we get server updates.
    var valueCallback = function () { };
    var watchRef = new Reference(this, path);
    watchRef.on('value', valueCallback);
    var unwatcher = function () {
        watchRef.off('value', valueCallback);
    };
    // Initialize transaction.
    var transaction = {
        path: path,
        update: transactionUpdate,
        onComplete: onComplete,
        // One of TransactionStatus enums.
        status: null,
        // Used when combining transactions at different locations to figure out which one goes first.
        order: LUIDGenerator(),
        // Whether to raise local events for this transaction.
        applyLocally: applyLocally,
        // Count of how many times we've retried the transaction.
        retryCount: 0,
        // Function to call to clean up our .on() listener.
        unwatcher: unwatcher,
        // Stores why a transaction was aborted.
        abortReason: null,
        currentWriteId: null,
        currentInputSnapshot: null,
        currentOutputSnapshotRaw: null,
        currentOutputSnapshotResolved: null
    };
    // Run transaction initially.
    var currentState = this.getLatestState_(path);
    transaction.currentInputSnapshot = currentState;
    var newVal = transaction.update(currentState.val());
    if (newVal === undefined) {
        // Abort transaction.
        transaction.unwatcher();
        transaction.currentOutputSnapshotRaw = null;
        transaction.currentOutputSnapshotResolved = null;
        if (transaction.onComplete) {
            // We just set the input snapshot, so this cast should be safe
            var snapshot = new DataSnapshot(transaction.currentInputSnapshot, new Reference(this, transaction.path), PRIORITY_INDEX);
            transaction.onComplete(null, false, snapshot);
        }
    }
    else {
        validateFirebaseData('transaction failed: Data returned ', newVal, transaction.path);
        // Mark as run and add to our queue.
        transaction.status = TransactionStatus.RUN;
        var queueNode = this.transactionQueueTree_.subTree(path);
        var nodeQueue = queueNode.getValue() || [];
        nodeQueue.push(transaction);
        queueNode.setValue(nodeQueue);
        // Update visibleData and raise events
        // Note: We intentionally raise events after updating all of our transaction state, since the user could
        // start new transactions from the event callbacks.
        var priorityForNode = void 0;
        if (typeof newVal === 'object' &&
            newVal !== null &&
            util.contains(newVal, '.priority')) {
            priorityForNode = util.safeGet(newVal, '.priority');
            util.assert(isValidPriority(priorityForNode), 'Invalid priority returned by transaction. ' +
                'Priority must be a valid string, finite number, server value, or null.');
        }
        else {
            var currentNode = this.serverSyncTree_.calcCompleteEventCache(path) ||
                ChildrenNode.EMPTY_NODE;
            priorityForNode = currentNode.getPriority().val();
        }
        priorityForNode /** @type {null|number|string} */ = priorityForNode;
        var serverValues = this.generateServerValues();
        var newNodeUnresolved = nodeFromJSON$1(newVal, priorityForNode);
        var newNode = resolveDeferredValueSnapshot(newNodeUnresolved, serverValues);
        transaction.currentOutputSnapshotRaw = newNodeUnresolved;
        transaction.currentOutputSnapshotResolved = newNode;
        transaction.currentWriteId = this.getNextWriteId_();
        var events = this.serverSyncTree_.applyUserOverwrite(path, newNode, transaction.currentWriteId, transaction.applyLocally);
        this.eventQueue_.raiseEventsForChangedPath(path, events);
        this.sendReadyTransactions_();
    }
};
/**
 * @param {!Path} path
 * @param {Array.<number>=} excludeSets A specific set to exclude
 * @return {Node}
 * @private
 */
Repo.prototype.getLatestState_ = function (path, excludeSets) {
    return (this.serverSyncTree_.calcCompleteEventCache(path, excludeSets) ||
        ChildrenNode.EMPTY_NODE);
};
/**
 * Sends any already-run transactions that aren't waiting for outstanding transactions to
 * complete.
 *
 * Externally it's called with no arguments, but it calls itself recursively with a particular
 * transactionQueueTree node to recurse through the tree.
 *
 * @param {Tree.<Array.<Transaction>>=} node  transactionQueueTree node to start at.
 * @private
 */
Repo.prototype.sendReadyTransactions_ = function (node) {
    var _this = this;
    if (node === void 0) { node = this.transactionQueueTree_; }
    // Before recursing, make sure any completed transactions are removed.
    if (!node) {
        this.pruneCompletedTransactionsBelowNode_(node);
    }
    if (node.getValue() !== null) {
        var queue = this.buildTransactionQueue_(node);
        util.assert(queue.length > 0, 'Sending zero length transaction queue');
        var allRun = queue.every(function (transaction) { return transaction.status === TransactionStatus.RUN; });
        // If they're all run (and not sent), we can send them.  Else, we must wait.
        if (allRun) {
            this.sendTransactionQueue_(node.path(), queue);
        }
    }
    else if (node.hasChildren()) {
        node.forEachChild(function (childNode) {
            _this.sendReadyTransactions_(childNode);
        });
    }
};
/**
 * Given a list of run transactions, send them to the server and then handle the result (success or failure).
 *
 * @param {!Path} path The location of the queue.
 * @param {!Array.<Transaction>} queue Queue of transactions under the specified location.
 * @private
 */
Repo.prototype.sendTransactionQueue_ = function (path, queue) {
    var _this = this;
    // Mark transactions as sent and increment retry count!
    var setsToIgnore = queue.map(function (txn) {
        return txn.currentWriteId;
    });
    var latestState = this.getLatestState_(path, setsToIgnore);
    var snapToSend = latestState;
    var latestHash = latestState.hash();
    for (var i = 0; i < queue.length; i++) {
        var txn = queue[i];
        util.assert(txn.status === TransactionStatus.RUN, 'tryToSendTransactionQueue_: items in queue should all be run.');
        txn.status = TransactionStatus.SENT;
        txn.retryCount++;
        var relativePath = Path.relativePath(path, txn.path);
        // If we've gotten to this point, the output snapshot must be defined.
        snapToSend = snapToSend.updateChild(relativePath /**@type {!Node} */, txn.currentOutputSnapshotRaw);
    }
    var dataToSend = snapToSend.val(true);
    var pathToSend = path;
    // Send the put.
    this.server_.put(pathToSend.toString(), dataToSend, function (status) {
        _this.log_('transaction put response', {
            path: pathToSend.toString(),
            status: status
        });
        var events = [];
        if (status === 'ok') {
            // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
            // the callback could trigger more transactions or sets.
            var callbacks = [];
            for (var i = 0; i < queue.length; i++) {
                queue[i].status = TransactionStatus.COMPLETED;
                events = events.concat(_this.serverSyncTree_.ackUserWrite(queue[i].currentWriteId));
                if (queue[i].onComplete) {
                    // We never unset the output snapshot, and given that this transaction is complete, it should be set
                    var node = queue[i].currentOutputSnapshotResolved;
                    var ref = new Reference(_this, queue[i].path);
                    var snapshot = new DataSnapshot(node, ref, PRIORITY_INDEX);
                    callbacks.push(queue[i].onComplete.bind(null, null, true, snapshot));
                }
                queue[i].unwatcher();
            }
            // Now remove the completed transactions.
            _this.pruneCompletedTransactionsBelowNode_(_this.transactionQueueTree_.subTree(path));
            // There may be pending transactions that we can now send.
            _this.sendReadyTransactions_();
            _this.eventQueue_.raiseEventsForChangedPath(path, events);
            // Finally, trigger onComplete callbacks.
            for (var i = 0; i < callbacks.length; i++) {
                exceptionGuard(callbacks[i]);
            }
        }
        else {
            // transactions are no longer sent.  Update their status appropriately.
            if (status === 'datastale') {
                for (var i = 0; i < queue.length; i++) {
                    if (queue[i].status === TransactionStatus.SENT_NEEDS_ABORT)
                        queue[i].status = TransactionStatus.NEEDS_ABORT;
                    else
                        queue[i].status = TransactionStatus.RUN;
                }
            }
            else {
                warn('transaction at ' + pathToSend.toString() + ' failed: ' + status);
                for (var i = 0; i < queue.length; i++) {
                    queue[i].status = TransactionStatus.NEEDS_ABORT;
                    queue[i].abortReason = status;
                }
            }
            _this.rerunTransactions_(path);
        }
    }, latestHash);
};
/**
 * Finds all transactions dependent on the data at changedPath and reruns them.
 *
 * Should be called any time cached data changes.
 *
 * Return the highest path that was affected by rerunning transactions.  This is the path at which events need to
 * be raised for.
 *
 * @param {!Path} changedPath The path in mergedData that changed.
 * @return {!Path} The rootmost path that was affected by rerunning transactions.
 * @private
 */
Repo.prototype.rerunTransactions_ = function (changedPath) {
    var rootMostTransactionNode = this.getAncestorTransactionNode_(changedPath);
    var path = rootMostTransactionNode.path();
    var queue = this.buildTransactionQueue_(rootMostTransactionNode);
    this.rerunTransactionQueue_(queue, path);
    return path;
};
/**
 * Does all the work of rerunning transactions (as well as cleans up aborted transactions and whatnot).
 *
 * @param {Array.<Transaction>} queue The queue of transactions to run.
 * @param {!Path} path The path the queue is for.
 * @private
 */
Repo.prototype.rerunTransactionQueue_ = function (queue, path) {
    if (queue.length === 0) {
        return; // Nothing to do!
    }
    // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
    // the callback could trigger more transactions or sets.
    var callbacks = [];
    var events = [];
    // Ignore all of the sets we're going to re-run.
    var txnsToRerun = queue.filter(function (q) {
        return q.status === TransactionStatus.RUN;
    });
    var setsToIgnore = txnsToRerun.map(function (q) {
        return q.currentWriteId;
    });
    for (var i = 0; i < queue.length; i++) {
        var transaction = queue[i];
        var relativePath = Path.relativePath(path, transaction.path);
        var abortTransaction = false, abortReason = void 0;
        util.assert(relativePath !== null, 'rerunTransactionsUnderNode_: relativePath should not be null.');
        if (transaction.status === TransactionStatus.NEEDS_ABORT) {
            abortTransaction = true;
            abortReason = transaction.abortReason;
            events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
        }
        else if (transaction.status === TransactionStatus.RUN) {
            if (transaction.retryCount >= Repo.MAX_TRANSACTION_RETRIES_) {
                abortTransaction = true;
                abortReason = 'maxretry';
                events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
            }
            else {
                // This code reruns a transaction
                var currentNode = this.getLatestState_(transaction.path, setsToIgnore);
                transaction.currentInputSnapshot = currentNode;
                var newData = queue[i].update(currentNode.val());
                if (newData !== undefined) {
                    validateFirebaseData('transaction failed: Data returned ', newData, transaction.path);
                    var newDataNode = nodeFromJSON$1(newData);
                    var hasExplicitPriority = typeof newData === 'object' &&
                        newData != null &&
                        util.contains(newData, '.priority');
                    if (!hasExplicitPriority) {
                        // Keep the old priority if there wasn't a priority explicitly specified.
                        newDataNode = newDataNode.updatePriority(currentNode.getPriority());
                    }
                    var oldWriteId = transaction.currentWriteId;
                    var serverValues = this.generateServerValues();
                    var newNodeResolved = resolveDeferredValueSnapshot(newDataNode, serverValues);
                    transaction.currentOutputSnapshotRaw = newDataNode;
                    transaction.currentOutputSnapshotResolved = newNodeResolved;
                    transaction.currentWriteId = this.getNextWriteId_();
                    // Mutates setsToIgnore in place
                    setsToIgnore.splice(setsToIgnore.indexOf(oldWriteId), 1);
                    events = events.concat(this.serverSyncTree_.applyUserOverwrite(transaction.path, newNodeResolved, transaction.currentWriteId, transaction.applyLocally));
                    events = events.concat(this.serverSyncTree_.ackUserWrite(oldWriteId, true));
                }
                else {
                    abortTransaction = true;
                    abortReason = 'nodata';
                    events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
                }
            }
        }
        this.eventQueue_.raiseEventsForChangedPath(path, events);
        events = [];
        if (abortTransaction) {
            // Abort.
            queue[i].status = TransactionStatus.COMPLETED;
            // Removing a listener can trigger pruning which can muck with mergedData/visibleData (as it prunes data).
            // So defer the unwatcher until we're done.
            (function (unwatcher) {
                setTimeout(unwatcher, Math.floor(0));
            })(queue[i].unwatcher);
            if (queue[i].onComplete) {
                if (abortReason === 'nodata') {
                    var ref = new Reference(this, queue[i].path);
                    // We set this field immediately, so it's safe to cast to an actual snapshot
                    var lastInput /** @type {!Node} */ = queue[i].currentInputSnapshot;
                    var snapshot = new DataSnapshot(lastInput, ref, PRIORITY_INDEX);
                    callbacks.push(queue[i].onComplete.bind(null, null, false, snapshot));
                }
                else {
                    callbacks.push(queue[i].onComplete.bind(null, new Error(abortReason), false, null));
                }
            }
        }
    }
    // Clean up completed transactions.
    this.pruneCompletedTransactionsBelowNode_(this.transactionQueueTree_);
    // Now fire callbacks, now that we're in a good, known state.
    for (var i = 0; i < callbacks.length; i++) {
        exceptionGuard(callbacks[i]);
    }
    // Try to send the transaction result to the server.
    this.sendReadyTransactions_();
};
/**
 * Returns the rootmost ancestor node of the specified path that has a pending transaction on it, or just returns
 * the node for the given path if there are no pending transactions on any ancestor.
 *
 * @param {!Path} path The location to start at.
 * @return {!Tree.<Array.<!Transaction>>} The rootmost node with a transaction.
 * @private
 */
Repo.prototype.getAncestorTransactionNode_ = function (path) {
    var front;
    // Start at the root and walk deeper into the tree towards path until we find a node with pending transactions.
    var transactionNode = this.transactionQueueTree_;
    while ((front = path.getFront()) !== null &&
        transactionNode.getValue() === null) {
        transactionNode = transactionNode.subTree(front);
        path = path.popFront();
    }
    return transactionNode;
};
/**
 * Builds the queue of all transactions at or below the specified transactionNode.
 *
 * @param {!Tree.<Array.<Transaction>>} transactionNode
 * @return {Array.<Transaction>} The generated queue.
 * @private
 */
Repo.prototype.buildTransactionQueue_ = function (transactionNode) {
    // Walk any child transaction queues and aggregate them into a single queue.
    var transactionQueue = [];
    this.aggregateTransactionQueuesForNode_(transactionNode, transactionQueue);
    // Sort them by the order the transactions were created.
    transactionQueue.sort(function (a, b) {
        return a.order - b.order;
    });
    return transactionQueue;
};
/**
 * @param {!Tree.<Array.<Transaction>>} node
 * @param {Array.<Transaction>} queue
 * @private
 */
Repo.prototype.aggregateTransactionQueuesForNode_ = function (node, queue) {
    var _this = this;
    var nodeQueue = node.getValue();
    if (nodeQueue !== null) {
        for (var i = 0; i < nodeQueue.length; i++) {
            queue.push(nodeQueue[i]);
        }
    }
    node.forEachChild(function (child) {
        _this.aggregateTransactionQueuesForNode_(child, queue);
    });
};
/**
 * Remove COMPLETED transactions at or below this node in the transactionQueueTree_.
 *
 * @param {!Tree.<Array.<!Transaction>>} node
 * @private
 */
Repo.prototype.pruneCompletedTransactionsBelowNode_ = function (node) {
    var _this = this;
    var queue = node.getValue();
    if (queue) {
        var to = 0;
        for (var from = 0; from < queue.length; from++) {
            if (queue[from].status !== TransactionStatus.COMPLETED) {
                queue[to] = queue[from];
                to++;
            }
        }
        queue.length = to;
        node.setValue(queue.length > 0 ? queue : null);
    }
    node.forEachChild(function (childNode) {
        _this.pruneCompletedTransactionsBelowNode_(childNode);
    });
};
/**
 * Aborts all transactions on ancestors or descendants of the specified path.  Called when doing a set() or update()
 * since we consider them incompatible with transactions.
 *
 * @param {!Path} path Path for which we want to abort related transactions.
 * @return {!Path}
 * @private
 */
Repo.prototype.abortTransactions_ = function (path) {
    var _this = this;
    var affectedPath = this.getAncestorTransactionNode_(path).path();
    var transactionNode = this.transactionQueueTree_.subTree(path);
    transactionNode.forEachAncestor(function (node) {
        _this.abortTransactionsOnNode_(node);
    });
    this.abortTransactionsOnNode_(transactionNode);
    transactionNode.forEachDescendant(function (node) {
        _this.abortTransactionsOnNode_(node);
    });
    return affectedPath;
};
/**
 * Abort transactions stored in this transaction queue node.
 *
 * @param {!Tree.<Array.<Transaction>>} node Node to abort transactions for.
 * @private
 */
Repo.prototype.abortTransactionsOnNode_ = function (node) {
    var queue = node.getValue();
    if (queue !== null) {
        // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
        // the callback could trigger more transactions or sets.
        var callbacks = [];
        // Go through queue.  Any already-sent transactions must be marked for abort, while the unsent ones
        // can be immediately aborted and removed.
        var events = [];
        var lastSent = -1;
        for (var i = 0; i < queue.length; i++) {
            if (queue[i].status === TransactionStatus.SENT_NEEDS_ABORT) ;
            else if (queue[i].status === TransactionStatus.SENT) {
                util.assert(lastSent === i - 1, 'All SENT items should be at beginning of queue.');
                lastSent = i;
                // Mark transaction for abort when it comes back.
                queue[i].status = TransactionStatus.SENT_NEEDS_ABORT;
                queue[i].abortReason = 'set';
            }
            else {
                util.assert(queue[i].status === TransactionStatus.RUN, 'Unexpected transaction status in abort');
                // We can abort it immediately.
                queue[i].unwatcher();
                events = events.concat(this.serverSyncTree_.ackUserWrite(queue[i].currentWriteId, true));
                if (queue[i].onComplete) {
                    var snapshot = null;
                    callbacks.push(queue[i].onComplete.bind(null, new Error('set'), false, snapshot));
                }
            }
        }
        if (lastSent === -1) {
            // We're not waiting for any sent transactions.  We can clear the queue.
            node.setValue(null);
        }
        else {
            // Remove the transactions we aborted.
            queue.length = lastSent + 1;
        }
        // Now fire the callbacks.
        this.eventQueue_.raiseEventsForChangedPath(node.path(), events);
        for (var i = 0; i < callbacks.length; i++) {
            exceptionGuard(callbacks[i]);
        }
    }
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** @const {string} */
var DATABASE_URL_OPTION = 'databaseURL';
/**
 * This variable is also defined in the firebase node.js admin SDK. Before
 * modifying this definition, consult the definition in:
 *
 * https://github.com/firebase/firebase-admin-node
 *
 * and make sure the two are consistent.
 */
var FIREBASE_DATABASE_EMULATOR_HOST_VAR = 'FIREBASE_DATABASE_EMULATOR_HOST';
var _staticInstance;
/**
 * Creates and caches Repo instances.
 */
var RepoManager = /** @class */ (function () {
    function RepoManager() {
        /**
         * @private {!Object.<string, Object<string, !fb.core.Repo>>}
         */
        this.repos_ = {};
        /**
         * If true, new Repos will be created to use ReadonlyRestClient (for testing purposes).
         * @private {boolean}
         */
        this.useRestClient_ = false;
    }
    RepoManager.getInstance = function () {
        if (!_staticInstance) {
            _staticInstance = new RepoManager();
        }
        return _staticInstance;
    };
    // TODO(koss): Remove these functions unless used in tests?
    RepoManager.prototype.interrupt = function () {
        for (var appName in this.repos_) {
            for (var dbUrl in this.repos_[appName]) {
                this.repos_[appName][dbUrl].interrupt();
            }
        }
    };
    RepoManager.prototype.resume = function () {
        for (var appName in this.repos_) {
            for (var dbUrl in this.repos_[appName]) {
                this.repos_[appName][dbUrl].resume();
            }
        }
    };
    /**
     * This function should only ever be called to CREATE a new database instance.
     *
     * @param {!FirebaseApp} app
     * @return {!Database}
     */
    RepoManager.prototype.databaseFromApp = function (app, url) {
        var dbUrl = url || app.options[DATABASE_URL_OPTION];
        if (dbUrl === undefined) {
            fatal("Can't determine Firebase Database URL.  Be sure to include " +
                DATABASE_URL_OPTION +
                ' option when calling firebase.initializeApp().');
        }
        var parsedUrl = parseRepoInfo(dbUrl);
        var repoInfo = parsedUrl.repoInfo;
        var dbEmulatorHost = undefined;
        if (typeof process !== 'undefined') {
            dbEmulatorHost = process.env[FIREBASE_DATABASE_EMULATOR_HOST_VAR];
        }
        if (dbEmulatorHost) {
            dbUrl = "http://" + dbEmulatorHost + "?ns=" + repoInfo.namespace;
            parsedUrl = parseRepoInfo(dbUrl);
            repoInfo = parsedUrl.repoInfo;
        }
        validateUrl('Invalid Firebase Database URL', 1, parsedUrl);
        if (!parsedUrl.path.isEmpty()) {
            fatal('Database URL must point to the root of a Firebase Database ' +
                '(not including a child path).');
        }
        var repo = this.createRepo(repoInfo, app);
        return repo.database;
    };
    /**
     * Remove the repo and make sure it is disconnected.
     *
     * @param {!Repo} repo
     */
    RepoManager.prototype.deleteRepo = function (repo) {
        var appRepos = util.safeGet(this.repos_, repo.app.name);
        // This should never happen...
        if (!appRepos || util.safeGet(appRepos, repo.repoInfo_.toURLString()) !== repo) {
            fatal("Database " + repo.app.name + "(" + repo.repoInfo_ + ") has already been deleted.");
        }
        repo.interrupt();
        delete appRepos[repo.repoInfo_.toURLString()];
    };
    /**
     * Ensures a repo doesn't already exist and then creates one using the
     * provided app.
     *
     * @param {!RepoInfo} repoInfo The metadata about the Repo
     * @param {!FirebaseApp} app
     * @return {!Repo} The Repo object for the specified server / repoName.
     */
    RepoManager.prototype.createRepo = function (repoInfo, app) {
        var appRepos = util.safeGet(this.repos_, app.name);
        if (!appRepos) {
            appRepos = {};
            this.repos_[app.name] = appRepos;
        }
        var repo = util.safeGet(appRepos, repoInfo.toURLString());
        if (repo) {
            fatal('Database initialized multiple times. Please make sure the format of the database URL matches with each database() call.');
        }
        repo = new Repo(repoInfo, this.useRestClient_, app);
        appRepos[repoInfo.toURLString()] = repo;
        return repo;
    };
    /**
     * Forces us to use ReadonlyRestClient instead of PersistentConnection for new Repos.
     * @param {boolean} forceRestClient
     */
    RepoManager.prototype.forceRestClient = function (forceRestClient) {
        this.useRestClient_ = forceRestClient;
    };
    return RepoManager;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Class representing a firebase database.
 * @implements {FirebaseService}
 */
var Database = /** @class */ (function () {
    /**
     * The constructor should not be called by users of our public API.
     * @param {!Repo} repo_
     */
    function Database(repo_) {
        this.repo_ = repo_;
        if (!(repo_ instanceof Repo)) {
            fatal("Don't call new Database() directly - please use firebase.database().");
        }
        /** @type {Reference} */
        this.root_ = new Reference(repo_, Path.Empty);
        this.INTERNAL = new DatabaseInternals(this);
    }
    Object.defineProperty(Database.prototype, "app", {
        get: function () {
            return this.repo_.app;
        },
        enumerable: true,
        configurable: true
    });
    Database.prototype.ref = function (path) {
        this.checkDeleted_('ref');
        util.validateArgCount('database.ref', 0, 1, arguments.length);
        if (path instanceof Reference) {
            return this.refFromURL(path.toString());
        }
        return path !== undefined ? this.root_.child(path) : this.root_;
    };
    /**
     * Returns a reference to the root or the path specified in url.
     * We throw a exception if the url is not in the same domain as the
     * current repo.
     * @param {string} url
     * @return {!Reference} Firebase reference.
     */
    Database.prototype.refFromURL = function (url) {
        /** @const {string} */
        var apiName = 'database.refFromURL';
        this.checkDeleted_(apiName);
        util.validateArgCount(apiName, 1, 1, arguments.length);
        var parsedURL = parseRepoInfo(url);
        validateUrl(apiName, 1, parsedURL);
        var repoInfo = parsedURL.repoInfo;
        if (repoInfo.host !== this.repo_.repoInfo_.host) {
            fatal(apiName +
                ': Host name does not match the current database: ' +
                '(found ' +
                repoInfo.host +
                ' but expected ' +
                this.repo_.repoInfo_.host +
                ')');
        }
        return this.ref(parsedURL.path.toString());
    };
    /**
     * @param {string} apiName
     */
    Database.prototype.checkDeleted_ = function (apiName) {
        if (this.repo_ === null) {
            fatal('Cannot call ' + apiName + ' on a deleted database.');
        }
    };
    // Make individual repo go offline.
    Database.prototype.goOffline = function () {
        util.validateArgCount('database.goOffline', 0, 0, arguments.length);
        this.checkDeleted_('goOffline');
        this.repo_.interrupt();
    };
    Database.prototype.goOnline = function () {
        util.validateArgCount('database.goOnline', 0, 0, arguments.length);
        this.checkDeleted_('goOnline');
        this.repo_.resume();
    };
    Database.ServerValue = {
        TIMESTAMP: {
            '.sv': 'timestamp'
        }
    };
    return Database;
}());
var DatabaseInternals = /** @class */ (function () {
    /** @param {!Database} database */
    function DatabaseInternals(database) {
        this.database = database;
    }
    /** @return {Promise<void>} */
    DatabaseInternals.prototype.delete = function () {
        return tslib.__awaiter(this, void 0, void 0, function () {
            return tslib.__generator(this, function (_a) {
                this.database.checkDeleted_('delete');
                RepoManager.getInstance().deleteRepo(this.database.repo_);
                this.database.repo_ = null;
                this.database.root_ = null;
                this.database.INTERNAL = null;
                this.database = null;
                return [2 /*return*/];
            });
        });
    };
    return DatabaseInternals;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * INTERNAL methods for internal-use only (tests, etc.).
 *
 * Customers shouldn't use these or else should be aware that they could break at any time.
 *
 * @const
 */
var forceLongPolling = function () {
    WebSocketConnection.forceDisallow();
    BrowserPollConnection.forceAllow();
};
var forceWebSockets = function () {
    BrowserPollConnection.forceDisallow();
};
/* Used by App Manager */
var isWebSocketsAvailable = function () {
    return WebSocketConnection['isAvailable']();
};
var setSecurityDebugCallback = function (ref, callback) {
    ref.repo.persistentConnection_.securityDebugCallback_ = callback;
};
var stats = function (ref, showDelta) {
    ref.repo.stats(showDelta);
};
var statsIncrementCounter = function (ref, metric) {
    ref.repo.statsIncrementCounter(metric);
};
var dataUpdateCount = function (ref) {
    return ref.repo.dataUpdateCount;
};
var interceptServerData = function (ref, callback) {
    return ref.repo.interceptServerData_(callback);
};

var INTERNAL = /*#__PURE__*/Object.freeze({
  __proto__: null,
  forceLongPolling: forceLongPolling,
  forceWebSockets: forceWebSockets,
  isWebSocketsAvailable: isWebSocketsAvailable,
  setSecurityDebugCallback: setSecurityDebugCallback,
  stats: stats,
  statsIncrementCounter: statsIncrementCounter,
  dataUpdateCount: dataUpdateCount,
  interceptServerData: interceptServerData
});

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DataConnection = PersistentConnection;
/**
 * @param {!string} pathString
 * @param {function(*)} onComplete
 */
PersistentConnection.prototype.simpleListen = function (pathString, onComplete) {
    this.sendRequest('q', { p: pathString }, onComplete);
};
/**
 * @param {*} data
 * @param {function(*)} onEcho
 */
PersistentConnection.prototype.echo = function (data, onEcho) {
    this.sendRequest('echo', { d: data }, onEcho);
};
// RealTimeConnection properties that we use in tests.
var RealTimeConnection = Connection;
/**
 * @param {function(): string} newHash
 * @return {function()}
 */
var hijackHash = function (newHash) {
    var oldPut = PersistentConnection.prototype.put;
    PersistentConnection.prototype.put = function (pathString, data, opt_onComplete, opt_hash) {
        if (opt_hash !== undefined) {
            opt_hash = newHash();
        }
        oldPut.call(this, pathString, data, opt_onComplete, opt_hash);
    };
    return function () {
        PersistentConnection.prototype.put = oldPut;
    };
};
/**
 * @type {function(new:RepoInfo, !string, boolean, !string, boolean): undefined}
 */
var ConnectionTarget = RepoInfo;
/**
 * @param {!Query} query
 * @return {!string}
 */
var queryIdentifier = function (query) {
    return query.queryIdentifier();
};
/**
 * Forces the RepoManager to create Repos that use ReadonlyRestClient instead of PersistentConnection.
 *
 * @param {boolean} forceRestClient
 */
var forceRestClient = function (forceRestClient) {
    RepoManager.getInstance().forceRestClient(forceRestClient);
};

var TEST_ACCESS = /*#__PURE__*/Object.freeze({
  __proto__: null,
  DataConnection: DataConnection,
  RealTimeConnection: RealTimeConnection,
  hijackHash: hijackHash,
  ConnectionTarget: ConnectionTarget,
  queryIdentifier: queryIdentifier,
  forceRestClient: forceRestClient
});

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ServerValue = Database.ServerValue;
function registerDatabase(instance) {
    // set SDK_VERSION
    setSDKVersion(instance.SDK_VERSION);
    // Register the Database Service with the 'firebase' namespace.
    var namespace = instance.INTERNAL.registerService('database', function (app, unused, url) { return RepoManager.getInstance().databaseFromApp(app, url); }, 
    // firebase.database namespace properties
    {
        Reference: Reference,
        Query: Query,
        Database: Database,
        DataSnapshot: DataSnapshot,
        enableLogging: enableLogging,
        INTERNAL: INTERNAL,
        ServerValue: ServerValue,
        TEST_ACCESS: TEST_ACCESS
    }, null, true);
    if (util.isNodeSdk()) {
        module.exports = namespace;
    }
}
registerDatabase(firebase);

exports.DataSnapshot = DataSnapshot;
exports.Database = Database;
exports.OnDisconnect = OnDisconnect;
exports.Query = Query;
exports.Reference = Reference;
exports.ServerValue = ServerValue;
exports.enableLogging = enableLogging;
exports.registerDatabase = registerDatabase;
//# sourceMappingURL=index.cjs.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(142)))

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var firebase = _interopDefault(__webpack_require__(50));
var tslib = __webpack_require__(51);
var logger = __webpack_require__(110);
var util = __webpack_require__(66);
var webchannelWrapper = __webpack_require__(899);

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** The semver (www.semver.org) version of the SDK. */
var SDK_VERSION = firebase.SDK_VERSION;

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var logClient = new logger.Logger('@firebase/firestore');
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["ERROR"] = 1] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 2] = "SILENT";
})(LogLevel || (LogLevel = {}));
// Helper methods are needed because variables can't be exported as read/write
function getLogLevel() {
    if (logClient.logLevel === logger.LogLevel.DEBUG) {
        return LogLevel.DEBUG;
    }
    else if (logClient.logLevel === logger.LogLevel.SILENT) {
        return LogLevel.SILENT;
    }
    else {
        return LogLevel.ERROR;
    }
}
function setLogLevel(newLevel) {
    /**
     * Map the new log level to the associated Firebase Log Level
     */
    switch (newLevel) {
        case LogLevel.DEBUG:
            logClient.logLevel = logger.LogLevel.DEBUG;
            break;
        case LogLevel.ERROR:
            logClient.logLevel = logger.LogLevel.ERROR;
            break;
        case LogLevel.SILENT:
            logClient.logLevel = logger.LogLevel.SILENT;
            break;
        default:
            logClient.error("Firestore (" + SDK_VERSION + "): Invalid value passed to `setLogLevel`");
    }
}
function debug(tag, msg) {
    var obj = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        obj[_i - 2] = arguments[_i];
    }
    if (logClient.logLevel <= logger.LogLevel.DEBUG) {
        var args = obj.map(argToString);
        logClient.debug.apply(logClient, tslib.__spreadArrays(["Firestore (" + SDK_VERSION + ") [" + tag + "]: " + msg], args));
    }
}
function error(msg) {
    var obj = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        obj[_i - 1] = arguments[_i];
    }
    if (logClient.logLevel <= logger.LogLevel.ERROR) {
        var args = obj.map(argToString);
        logClient.error.apply(logClient, tslib.__spreadArrays(["Firestore (" + SDK_VERSION + "): " + msg], args));
    }
}
/**
 * Converts an additional log parameter to a string representation.
 */
function argToString(obj) {
    if (typeof obj === 'string') {
        return obj;
    }
    else {
        var platform = PlatformSupport.getPlatform();
        try {
            return platform.formatJSON(obj);
        }
        catch (e) {
            // Converting to JSON failed, just log the object directly
            return obj;
        }
    }
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Unconditionally fails, throwing an Error with the given message.
 *
 * Returns any so it can be used in expressions:
 * @example
 * let futureVar = fail('not implemented yet');
 */
function fail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    var message = "FIRESTORE (" + SDK_VERSION + ") INTERNAL ASSERTION FAILED: " + failure;
    error(message);
    // NOTE: We don't use FirestoreError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 */
function assert(assertion, message) {
    if (!assertion) {
        fail(message);
    }
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provides singleton helpers where setup code can inject a platform at runtime.
 * setPlatform needs to be set before Firestore is used and must be set exactly
 * once.
 */
var PlatformSupport = /** @class */ (function () {
    function PlatformSupport() {
    }
    PlatformSupport.setPlatform = function (platform) {
        if (PlatformSupport.platform) {
            fail('Platform already defined');
        }
        PlatformSupport.platform = platform;
    };
    PlatformSupport.getPlatform = function () {
        if (!PlatformSupport.platform) {
            fail('Platform not set');
        }
        return PlatformSupport.platform;
    };
    return PlatformSupport;
}());
/**
 * Returns the representation of an empty "proto" byte string for the
 * platform.
 */
function emptyByteString() {
    return PlatformSupport.getPlatform().emptyByteString;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Code = {
    // Causes are copied from:
    // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
    /** Not an error; returned on success. */
    OK: 'ok',
    /** The operation was cancelled (typically by the caller). */
    CANCELLED: 'cancelled',
    /** Unknown error or an error from a different error domain. */
    UNKNOWN: 'unknown',
    /**
     * Client specified an invalid argument. Note that this differs from
     * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
     * problematic regardless of the state of the system (e.g., a malformed file
     * name).
     */
    INVALID_ARGUMENT: 'invalid-argument',
    /**
     * Deadline expired before operation could complete. For operations that
     * change the state of the system, this error may be returned even if the
     * operation has completed successfully. For example, a successful response
     * from a server could have been delayed long enough for the deadline to
     * expire.
     */
    DEADLINE_EXCEEDED: 'deadline-exceeded',
    /** Some requested entity (e.g., file or directory) was not found. */
    NOT_FOUND: 'not-found',
    /**
     * Some entity that we attempted to create (e.g., file or directory) already
     * exists.
     */
    ALREADY_EXISTS: 'already-exists',
    /**
     * The caller does not have permission to execute the specified operation.
     * PERMISSION_DENIED must not be used for rejections caused by exhausting
     * some resource (use RESOURCE_EXHAUSTED instead for those errors).
     * PERMISSION_DENIED must not be used if the caller can not be identified
     * (use UNAUTHENTICATED instead for those errors).
     */
    PERMISSION_DENIED: 'permission-denied',
    /**
     * The request does not have valid authentication credentials for the
     * operation.
     */
    UNAUTHENTICATED: 'unauthenticated',
    /**
     * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
     * entire file system is out of space.
     */
    RESOURCE_EXHAUSTED: 'resource-exhausted',
    /**
     * Operation was rejected because the system is not in a state required for
     * the operation's execution. For example, directory to be deleted may be
     * non-empty, an rmdir operation is applied to a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
     *  (a) Use UNAVAILABLE if the client can retry just the failing call.
     *  (b) Use ABORTED if the client should retry at a higher-level
     *      (e.g., restarting a read-modify-write sequence).
     *  (c) Use FAILED_PRECONDITION if the client should not retry until
     *      the system state has been explicitly fixed. E.g., if an "rmdir"
     *      fails because the directory is non-empty, FAILED_PRECONDITION
     *      should be returned since the client should not retry unless
     *      they have first fixed up the directory by deleting files from it.
     *  (d) Use FAILED_PRECONDITION if the client performs conditional
     *      REST Get/Update/Delete on a resource and the resource on the
     *      server does not match the condition. E.g., conflicting
     *      read-modify-write on the same resource.
     */
    FAILED_PRECONDITION: 'failed-precondition',
    /**
     * The operation was aborted, typically due to a concurrency issue like
     * sequencer check failures, transaction aborts, etc.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */
    ABORTED: 'aborted',
    /**
     * Operation was attempted past the valid range. E.g., seeking or reading
     * past end of file.
     *
     * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
     * if the system state changes. For example, a 32-bit file system will
     * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
     * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
     * an offset past the current file size.
     *
     * There is a fair bit of overlap between FAILED_PRECONDITION and
     * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
     * when it applies so that callers who are iterating through a space can
     * easily look for an OUT_OF_RANGE error to detect when they are done.
     */
    OUT_OF_RANGE: 'out-of-range',
    /** Operation is not implemented or not supported/enabled in this service. */
    UNIMPLEMENTED: 'unimplemented',
    /**
     * Internal errors. Means some invariants expected by underlying System has
     * been broken. If you see one of these errors, Something is very broken.
     */
    INTERNAL: 'internal',
    /**
     * The service is currently unavailable. This is a most likely a transient
     * condition and may be corrected by retrying with a backoff.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */
    UNAVAILABLE: 'unavailable',
    /** Unrecoverable data loss or corruption. */
    DATA_LOSS: 'data-loss'
};
/**
 * An error class used for Firestore-generated errors. Ideally we should be
 * using FirebaseError, but integrating with it is overly arduous at the moment,
 * so we define our own compatible error class (with a `name` of 'FirebaseError'
 * and compatible `code` and `message` fields.)
 */
var FirestoreError = /** @class */ (function (_super) {
    tslib.__extends(FirestoreError, _super);
    function FirestoreError(code, message) {
        var _this = _super.call(this, message) || this;
        _this.code = code;
        _this.message = message;
        _this.name = 'FirebaseError';
        // HACK: We write a toString property directly because Error is not a real
        // class and so inheritance does not work correctly. We could alternatively
        // do the same "back-door inheritance" trick that FirebaseError does.
        _this.toString = function () { return _this.name + ": [code=" + _this.code + "]: " + _this.message; };
        return _this;
    }
    return FirestoreError;
}(Error));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Helper function to prevent instantiation through the constructor.
 *
 * This method creates a new constructor that throws when it's invoked.
 * The prototype of that constructor is then set to the prototype of the hidden
 * "class" to expose all the prototype methods and allow for instanceof
 * checks.
 *
 * To also make all the static methods available, all properties of the
 * original constructor are copied to the new constructor.
 */
function makeConstructorPrivate(cls, optionalMessage) {
    function PublicConstructor() {
        var error = 'This constructor is private.';
        if (optionalMessage) {
            error += ' ';
            error += optionalMessage;
        }
        throw new FirestoreError(Code.INVALID_ARGUMENT, error);
    }
    // Make sure instanceof checks work and all methods are exposed on the public
    // constructor
    PublicConstructor.prototype = cls.prototype;
    // Copy any static methods/members
    for (var staticProperty in cls) {
        if (cls.hasOwnProperty(staticProperty)) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            PublicConstructor[staticProperty] = cls[staticProperty];
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return PublicConstructor;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function contains(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
/** Returns the given value if it's defined or the defaultValue otherwise. */
function defaulted(value, defaultValue) {
    return value !== undefined ? value : defaultValue;
}
function forEachNumber(obj, fn) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var num = Number(key);
            if (!isNaN(num)) {
                fn(num, obj[key]);
            }
        }
    }
}
function values(obj) {
    var vs = [];
    forEach(obj, function (_, v) { return vs.push(v); });
    return vs;
}
function forEach(obj, fn) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            fn(key, obj[key]);
        }
    }
}
function isEmpty(obj) {
    assert(obj != null && typeof obj === 'object', 'isEmpty() expects object parameter.');
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            return false;
        }
    }
    return true;
}
function shallowCopy(obj) {
    assert(obj && typeof obj === 'object', 'shallowCopy() expects object parameter.');
    var result = {};
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            result[key] = obj[key];
        }
    }
    return result;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Validates that no arguments were passed in the invocation of functionName.
 *
 * Forward the magic "arguments" variable as second parameter on which the
 * parameter validation is performed:
 * validateNoArgs('myFunction', arguments);
 */
function validateNoArgs(functionName, args) {
    if (args.length !== 0) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() does not support arguments, " +
            'but was called with ' +
            formatPlural(args.length, 'argument') +
            '.');
    }
}
/**
 * Validates the invocation of functionName has the exact number of arguments.
 *
 * Forward the magic "arguments" variable as second parameter on which the
 * parameter validation is performed:
 * validateExactNumberOfArgs('myFunction', arguments, 2);
 */
function validateExactNumberOfArgs(functionName, args, numberOfArgs) {
    if (args.length !== numberOfArgs) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires " +
            formatPlural(numberOfArgs, 'argument') +
            ', but was called with ' +
            formatPlural(args.length, 'argument') +
            '.');
    }
}
/**
 * Validates the invocation of functionName has at least the provided number of
 * arguments (but can have many more).
 *
 * Forward the magic "arguments" variable as second parameter on which the
 * parameter validation is performed:
 * validateAtLeastNumberOfArgs('myFunction', arguments, 2);
 */
function validateAtLeastNumberOfArgs(functionName, args, minNumberOfArgs) {
    if (args.length < minNumberOfArgs) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires at least " +
            formatPlural(minNumberOfArgs, 'argument') +
            ', but was called with ' +
            formatPlural(args.length, 'argument') +
            '.');
    }
}
/**
 * Validates the invocation of functionName has number of arguments between
 * the values provided.
 *
 * Forward the magic "arguments" variable as second parameter on which the
 * parameter validation is performed:
 * validateBetweenNumberOfArgs('myFunction', arguments, 2, 3);
 */
function validateBetweenNumberOfArgs(functionName, args, minNumberOfArgs, maxNumberOfArgs) {
    if (args.length < minNumberOfArgs || args.length > maxNumberOfArgs) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires between " + minNumberOfArgs + " and " +
            (maxNumberOfArgs + " arguments, but was called with ") +
            formatPlural(args.length, 'argument') +
            '.');
    }
}
/**
 * Validates the provided argument is an array and has as least the expected
 * number of elements.
 */
function validateNamedArrayAtLeastNumberOfElements(functionName, value, name, minNumberOfElements) {
    if (!(value instanceof Array) || value.length < minNumberOfElements) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires its " + name + " argument to be an " +
            'array with at least ' +
            (formatPlural(minNumberOfElements, 'element') + "."));
    }
}
/**
 * Validates the provided positional argument has the native JavaScript type
 * using typeof checks.
 */
function validateArgType(functionName, type, position, argument) {
    validateType(functionName, type, ordinal(position) + " argument", argument);
}
/**
 * Validates the provided argument has the native JavaScript type using
 * typeof checks or is undefined.
 */
function validateOptionalArgType(functionName, type, position, argument) {
    if (argument !== undefined) {
        validateArgType(functionName, type, position, argument);
    }
}
/**
 * Validates the provided named option has the native JavaScript type using
 * typeof checks.
 */
function validateNamedType(functionName, type, optionName, argument) {
    validateType(functionName, type, optionName + " option", argument);
}
/**
 * Validates the provided named option has the native JavaScript type using
 * typeof checks or is undefined.
 */
function validateNamedOptionalType(functionName, type, optionName, argument) {
    if (argument !== undefined) {
        validateNamedType(functionName, type, optionName, argument);
    }
}
function validateArrayElements(functionName, optionName, typeDescription, argument, validator) {
    if (!(argument instanceof Array)) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires its " + optionName + " " +
            ("option to be an array, but it was: " + valueDescription(argument)));
    }
    for (var i = 0; i < argument.length; ++i) {
        if (!validator(argument[i])) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires all " + optionName + " " +
                ("elements to be " + typeDescription + ", but the value at index " + i + " ") +
                ("was: " + valueDescription(argument[i])));
        }
    }
}
function validateOptionalArrayElements(functionName, optionName, typeDescription, argument, validator) {
    if (argument !== undefined) {
        validateArrayElements(functionName, optionName, typeDescription, argument, validator);
    }
}
/**
 * Validates that the provided named option equals one of the expected values.
 */
function validateNamedPropertyEquals(functionName, inputName, optionName, input, expected) {
    var expectedDescription = [];
    for (var _i = 0, expected_1 = expected; _i < expected_1.length; _i++) {
        var val = expected_1[_i];
        if (val === input) {
            return;
        }
        expectedDescription.push(valueDescription(val));
    }
    var actualDescription = valueDescription(input);
    throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid value " + actualDescription + " provided to function " + functionName + "() for option " +
        ("\"" + optionName + "\". Acceptable values: " + expectedDescription.join(', ')));
}
/**
 * Validates that the provided named option equals one of the expected values or
 * is undefined.
 */
function validateNamedOptionalPropertyEquals(functionName, inputName, optionName, input, expected) {
    if (input !== undefined) {
        validateNamedPropertyEquals(functionName, inputName, optionName, input, expected);
    }
}
/**
 * Validates that the provided argument is a valid enum.
 *
 * @param functionName Function making the validation call.
 * @param enums Array containing all possible values for the enum.
 * @param position Position of the argument in `functionName`.
 * @param argument Arugment to validate.
 */
function validateStringEnum(functionName, enums, position, argument) {
    if (!enums.some(function (element) { return element === argument; })) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid value " + valueDescription(argument) + " provided to function " +
            (functionName + "() for its " + ordinal(position) + " argument. Acceptable ") +
            ("values: " + enums.join(', ')));
    }
}
/** Helper to validate the type of a provided input. */
function validateType(functionName, type, inputName, input) {
    var valid = false;
    if (type === 'object') {
        valid = isPlainObject(input);
    }
    else if (type === 'non-empty string') {
        valid = typeof input === 'string' && input !== '';
    }
    else {
        valid = typeof input === type;
    }
    if (!valid) {
        var description = valueDescription(input);
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires its " + inputName + " " +
            ("to be of type " + type + ", but it was: " + description));
    }
}
/**
 * Returns true if it's a non-null object without a custom prototype
 * (i.e. excludes Array, Date, etc.).
 */
function isPlainObject(input) {
    return (typeof input === 'object' &&
        input !== null &&
        (Object.getPrototypeOf(input) === Object.prototype ||
            Object.getPrototypeOf(input) === null));
}
/** Returns a string describing the type / value of the provided input. */
function valueDescription(input) {
    if (input === undefined) {
        return 'undefined';
    }
    else if (input === null) {
        return 'null';
    }
    else if (typeof input === 'string') {
        if (input.length > 20) {
            input = input.substring(0, 20) + "...";
        }
        return JSON.stringify(input);
    }
    else if (typeof input === 'number' || typeof input === 'boolean') {
        return '' + input;
    }
    else if (typeof input === 'object') {
        if (input instanceof Array) {
            return 'an array';
        }
        else {
            var customObjectName = tryGetCustomObjectType(input);
            if (customObjectName) {
                return "a custom " + customObjectName + " object";
            }
            else {
                return 'an object';
            }
        }
    }
    else if (typeof input === 'function') {
        return 'a function';
    }
    else {
        return fail('Unknown wrong type: ' + typeof input);
    }
}
/** Hacky method to try to get the constructor name for an object. */
function tryGetCustomObjectType(input) {
    if (input.constructor) {
        var funcNameRegex = /function\s+([^\s(]+)\s*\(/;
        var results = funcNameRegex.exec(input.constructor.toString());
        if (results && results.length > 1) {
            return results[1];
        }
    }
    return null;
}
/** Validates the provided argument is defined. */
function validateDefined(functionName, position, argument) {
    if (argument === undefined) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires a valid " + ordinal(position) + " " +
            "argument, but it was undefined.");
    }
}
/**
 * Validates the provided positional argument is an object, and its keys and
 * values match the expected keys and types provided in optionTypes.
 */
function validateOptionNames(functionName, options, optionNames) {
    forEach(options, function (key, _) {
        if (optionNames.indexOf(key) < 0) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Unknown option '" + key + "' passed to function " + functionName + "(). " +
                'Available options: ' +
                optionNames.join(', '));
        }
    });
}
/**
 * Helper method to throw an error that the provided argument did not pass
 * an instanceof check.
 */
function invalidClassError(functionName, type, position, argument) {
    var description = valueDescription(argument);
    return new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires its " + ordinal(position) + " " +
        ("argument to be a " + type + ", but it was: " + description));
}
function validatePositiveNumber(functionName, position, n) {
    if (n <= 0) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function \"" + functionName + "()\" requires its " + ordinal(position) + " argument to be a positive number, but it was: " + n + ".");
    }
}
/** Converts a number to its english word representation */
function ordinal(num) {
    switch (num) {
        case 1:
            return 'first';
        case 2:
            return 'second';
        case 3:
            return 'third';
        default:
            return num + 'th';
    }
}
/**
 * Formats the given word as plural conditionally given the preceding number.
 */
function formatPlural(num, str) {
    return num + " " + str + (num === 1 ? '' : 's');
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var AutoId = /** @class */ (function () {
    function AutoId() {
    }
    AutoId.newId = function () {
        // Alphanumeric characters
        var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var autoId = '';
        for (var i = 0; i < 20; i++) {
            autoId += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        assert(autoId.length === 20, 'Invalid auto ID: ' + autoId);
        return autoId;
    };
    return AutoId;
}());
function primitiveComparator(left, right) {
    if (left < right) {
        return -1;
    }
    if (left > right) {
        return 1;
    }
    return 0;
}
/** Helper to compare nullable (or undefined-able) objects using isEqual(). */
function equals(left, right) {
    if (left !== null && left !== undefined) {
        return !!(right && left.isEqual(right));
    }
    else {
        // HACK: Explicitly cast since TypeScript's type narrowing apparently isn't
        // smart enough.
        return left === right;
    }
}
/** Helper to compare arrays using isEqual(). */
function arrayEquals(left, right) {
    if (left.length !== right.length) {
        return false;
    }
    for (var i = 0; i < left.length; i++) {
        if (!left[i].isEqual(right[i])) {
            return false;
        }
    }
    return true;
}
/**
 * Returns the immediate lexicographically-following string. This is useful to
 * construct an inclusive range for indexeddb iterators.
 */
function immediateSuccessor(s) {
    // Return the input string, with an additional NUL byte appended.
    return s + '\0';
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Helper function to assert Uint8Array is available at runtime. */
function assertUint8ArrayAvailable() {
    if (typeof Uint8Array === 'undefined') {
        throw new FirestoreError(Code.UNIMPLEMENTED, 'Uint8Arrays are not available in this environment.');
    }
}
/** Helper function to assert Base64 functions are available at runtime. */
function assertBase64Available() {
    if (!PlatformSupport.getPlatform().base64Available) {
        throw new FirestoreError(Code.UNIMPLEMENTED, 'Blobs are unavailable in Firestore in this environment.');
    }
}
/**
 * Immutable class holding a blob (binary data).
 * This class is directly exposed in the public API.
 *
 * Note that while you can't hide the constructor in JavaScript code, we are
 * using the hack above to make sure no-one outside this module can call it.
 */
var Blob = /** @class */ (function () {
    function Blob(binaryString) {
        assertBase64Available();
        this._binaryString = binaryString;
    }
    Blob.fromBase64String = function (base64) {
        validateExactNumberOfArgs('Blob.fromBase64String', arguments, 1);
        validateArgType('Blob.fromBase64String', 'string', 1, base64);
        assertBase64Available();
        try {
            var binaryString = PlatformSupport.getPlatform().atob(base64);
            return new Blob(binaryString);
        }
        catch (e) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Failed to construct Blob from Base64 string: ' + e);
        }
    };
    Blob.fromUint8Array = function (array) {
        validateExactNumberOfArgs('Blob.fromUint8Array', arguments, 1);
        assertUint8ArrayAvailable();
        if (!(array instanceof Uint8Array)) {
            throw invalidClassError('Blob.fromUint8Array', 'Uint8Array', 1, array);
        }
        // We can't call array.map directly because it expects the return type to
        // be a Uint8Array, whereas we can convert it to a regular array by invoking
        // map on the Array prototype.
        var binaryString = Array.prototype.map
            .call(array, function (char) {
            return String.fromCharCode(char);
        })
            .join('');
        return new Blob(binaryString);
    };
    Blob.prototype.toBase64 = function () {
        validateExactNumberOfArgs('Blob.toBase64', arguments, 0);
        assertBase64Available();
        return PlatformSupport.getPlatform().btoa(this._binaryString);
    };
    Blob.prototype.toUint8Array = function () {
        validateExactNumberOfArgs('Blob.toUint8Array', arguments, 0);
        assertUint8ArrayAvailable();
        var buffer = new Uint8Array(this._binaryString.length);
        for (var i = 0; i < this._binaryString.length; i++) {
            buffer[i] = this._binaryString.charCodeAt(i);
        }
        return buffer;
    };
    Blob.prototype.toString = function () {
        return 'Blob(base64: ' + this.toBase64() + ')';
    };
    Blob.prototype.isEqual = function (other) {
        return this._binaryString === other._binaryString;
    };
    /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */
    Blob.prototype._compareTo = function (other) {
        return primitiveComparator(this._binaryString, other._binaryString);
    };
    return Blob;
}());
// Public instance that disallows construction at runtime. This constructor is
// used when exporting Blob on firebase.firestore.Blob and will be called Blob
// publicly. Internally we still use Blob which has a type checked private
// constructor. Note that Blob and PublicBlob can be used interchangeably in
// instanceof checks.
// For our internal TypeScript code PublicBlob doesn't exist as a type, and so
// we need to use Blob as type and export it too.
var PublicBlob = makeConstructorPrivate(Blob, 'Use Blob.fromUint8Array() or Blob.fromBase64String() instead.');

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DatabaseInfo = /** @class */ (function () {
    /**
     * Constructs a DatabaseInfo using the provided host, databaseId and
     * persistenceKey.
     *
     * @param databaseId The database to use.
     * @param persistenceKey A unique identifier for this Firestore's local
     * storage (used in conjunction with the databaseId).
     * @param host The Firestore backend host to connect to.
     * @param ssl Whether to use SSL when connecting.
     * @param forceLongPolling Whether to use the forceLongPolling option
     * when using WebChannel as the network transport.
     */
    function DatabaseInfo(databaseId, persistenceKey, host, ssl, forceLongPolling) {
        this.databaseId = databaseId;
        this.persistenceKey = persistenceKey;
        this.host = host;
        this.ssl = ssl;
        this.forceLongPolling = forceLongPolling;
    }
    return DatabaseInfo;
}());
/** The default database name for a project. */
var DEFAULT_DATABASE_NAME = '(default)';
/** Represents the database ID a Firestore client is associated with. */
var DatabaseId = /** @class */ (function () {
    function DatabaseId(projectId, database) {
        this.projectId = projectId;
        this.database = database ? database : DEFAULT_DATABASE_NAME;
    }
    Object.defineProperty(DatabaseId.prototype, "isDefaultDatabase", {
        get: function () {
            return this.database === DEFAULT_DATABASE_NAME;
        },
        enumerable: true,
        configurable: true
    });
    DatabaseId.prototype.isEqual = function (other) {
        return (other instanceof DatabaseId &&
            other.projectId === this.projectId &&
            other.database === this.database);
    };
    DatabaseId.prototype.compareTo = function (other) {
        return (primitiveComparator(this.projectId, other.projectId) ||
            primitiveComparator(this.database, other.database));
    };
    return DatabaseId;
}());

/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * `ListenSequence` is a monotonic sequence. It is initialized with a minimum value to
 * exceed. All subsequent calls to next will return increasing values. If provided with a
 * `SequenceNumberSyncer`, it will additionally bump its next value when told of a new value, as
 * well as write out sequence numbers that it produces via `next()`.
 */
var ListenSequence = /** @class */ (function () {
    function ListenSequence(previousValue, sequenceNumberSyncer) {
        var _this = this;
        this.previousValue = previousValue;
        if (sequenceNumberSyncer) {
            sequenceNumberSyncer.sequenceNumberHandler = function (sequenceNumber) {
                return _this.setPreviousValue(sequenceNumber);
            };
            this.writeNewSequenceNumber = function (sequenceNumber) {
                return sequenceNumberSyncer.writeSequenceNumber(sequenceNumber);
            };
        }
    }
    ListenSequence.prototype.setPreviousValue = function (externalPreviousValue) {
        this.previousValue = Math.max(externalPreviousValue, this.previousValue);
        return this.previousValue;
    };
    ListenSequence.prototype.next = function () {
        var nextValue = ++this.previousValue;
        if (this.writeNewSequenceNumber) {
            this.writeNewSequenceNumber(nextValue);
        }
        return nextValue;
    };
    ListenSequence.INVALID = -1;
    return ListenSequence;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DOCUMENT_KEY_NAME = '__name__';
/**
 * Path represents an ordered sequence of string segments.
 */
var BasePath = /** @class */ (function () {
    function BasePath(segments, offset, length) {
        if (offset === undefined) {
            offset = 0;
        }
        else if (offset > segments.length) {
            fail('offset ' + offset + ' out of range ' + segments.length);
        }
        if (length === undefined) {
            length = segments.length - offset;
        }
        else if (length > segments.length - offset) {
            fail('length ' + length + ' out of range ' + (segments.length - offset));
        }
        this.segments = segments;
        this.offset = offset;
        this.len = length;
    }
    Object.defineProperty(BasePath.prototype, "length", {
        get: function () {
            return this.len;
        },
        enumerable: true,
        configurable: true
    });
    BasePath.prototype.isEqual = function (other) {
        return BasePath.comparator(this, other) === 0;
    };
    BasePath.prototype.child = function (nameOrPath) {
        var segments = this.segments.slice(this.offset, this.limit());
        if (nameOrPath instanceof BasePath) {
            nameOrPath.forEach(function (segment) {
                segments.push(segment);
            });
        }
        else {
            segments.push(nameOrPath);
        }
        return this.construct(segments);
    };
    /** The index of one past the last segment of the path. */
    BasePath.prototype.limit = function () {
        return this.offset + this.length;
    };
    BasePath.prototype.popFirst = function (size) {
        size = size === undefined ? 1 : size;
        assert(this.length >= size, "Can't call popFirst() with less segments");
        return this.construct(this.segments, this.offset + size, this.length - size);
    };
    BasePath.prototype.popLast = function () {
        assert(!this.isEmpty(), "Can't call popLast() on empty path");
        return this.construct(this.segments, this.offset, this.length - 1);
    };
    BasePath.prototype.firstSegment = function () {
        assert(!this.isEmpty(), "Can't call firstSegment() on empty path");
        return this.segments[this.offset];
    };
    BasePath.prototype.lastSegment = function () {
        return this.get(this.length - 1);
    };
    BasePath.prototype.get = function (index) {
        assert(index < this.length, 'Index out of range');
        return this.segments[this.offset + index];
    };
    BasePath.prototype.isEmpty = function () {
        return this.length === 0;
    };
    BasePath.prototype.isPrefixOf = function (other) {
        if (other.length < this.length) {
            return false;
        }
        for (var i = 0; i < this.length; i++) {
            if (this.get(i) !== other.get(i)) {
                return false;
            }
        }
        return true;
    };
    BasePath.prototype.isImmediateParentOf = function (potentialChild) {
        if (this.length + 1 !== potentialChild.length) {
            return false;
        }
        for (var i = 0; i < this.length; i++) {
            if (this.get(i) !== potentialChild.get(i)) {
                return false;
            }
        }
        return true;
    };
    BasePath.prototype.forEach = function (fn) {
        for (var i = this.offset, end = this.limit(); i < end; i++) {
            fn(this.segments[i]);
        }
    };
    BasePath.prototype.toArray = function () {
        return this.segments.slice(this.offset, this.limit());
    };
    BasePath.comparator = function (p1, p2) {
        var len = Math.min(p1.length, p2.length);
        for (var i = 0; i < len; i++) {
            var left = p1.get(i);
            var right = p2.get(i);
            if (left < right) {
                return -1;
            }
            if (left > right) {
                return 1;
            }
        }
        if (p1.length < p2.length) {
            return -1;
        }
        if (p1.length > p2.length) {
            return 1;
        }
        return 0;
    };
    return BasePath;
}());
/**
 * A slash-separated path for navigating resources (documents and collections)
 * within Firestore.
 */
var ResourcePath = /** @class */ (function (_super) {
    tslib.__extends(ResourcePath, _super);
    function ResourcePath() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ResourcePath.prototype.construct = function (segments, offset, length) {
        return new ResourcePath(segments, offset, length);
    };
    ResourcePath.prototype.canonicalString = function () {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        return this.toArray().join('/');
    };
    ResourcePath.prototype.toString = function () {
        return this.canonicalString();
    };
    /**
     * Creates a resource path from the given slash-delimited string.
     */
    ResourcePath.fromString = function (path) {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        if (path.indexOf('//') >= 0) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid path (" + path + "). Paths must not contain // in them.");
        }
        // We may still have an empty segment at the beginning or end if they had a
        // leading or trailing slash (which we allow).
        var segments = path.split('/').filter(function (segment) { return segment.length > 0; });
        return new ResourcePath(segments);
    };
    ResourcePath.EMPTY_PATH = new ResourcePath([]);
    return ResourcePath;
}(BasePath));
var identifierRegExp = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
/** A dot-separated path for navigating sub-objects within a document. */
var FieldPath = /** @class */ (function (_super) {
    tslib.__extends(FieldPath, _super);
    function FieldPath() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FieldPath.prototype.construct = function (segments, offset, length) {
        return new FieldPath(segments, offset, length);
    };
    /**
     * Returns true if the string could be used as a segment in a field path
     * without escaping.
     */
    FieldPath.isValidIdentifier = function (segment) {
        return identifierRegExp.test(segment);
    };
    FieldPath.prototype.canonicalString = function () {
        return this.toArray()
            .map(function (str) {
            str = str.replace('\\', '\\\\').replace('`', '\\`');
            if (!FieldPath.isValidIdentifier(str)) {
                str = '`' + str + '`';
            }
            return str;
        })
            .join('.');
    };
    FieldPath.prototype.toString = function () {
        return this.canonicalString();
    };
    /**
     * Returns true if this field references the key of a document.
     */
    FieldPath.prototype.isKeyField = function () {
        return this.length === 1 && this.get(0) === DOCUMENT_KEY_NAME;
    };
    /**
     * The field designating the key of a document.
     */
    FieldPath.keyField = function () {
        return new FieldPath([DOCUMENT_KEY_NAME]);
    };
    /**
     * Parses a field string from the given server-formatted string.
     *
     * - Splitting the empty string is not allowed (for now at least).
     * - Empty segments within the string (e.g. if there are two consecutive
     *   separators) are not allowed.
     *
     * TODO(b/37244157): we should make this more strict. Right now, it allows
     * non-identifier path components, even if they aren't escaped.
     */
    FieldPath.fromServerFormat = function (path) {
        var segments = [];
        var current = '';
        var i = 0;
        var addCurrentSegment = function () {
            if (current.length === 0) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid field path (" + path + "). Paths must not be empty, begin " +
                    "with '.', end with '.', or contain '..'");
            }
            segments.push(current);
            current = '';
        };
        var inBackticks = false;
        while (i < path.length) {
            var c = path[i];
            if (c === '\\') {
                if (i + 1 === path.length) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Path has trailing escape character: ' + path);
                }
                var next = path[i + 1];
                if (!(next === '\\' || next === '.' || next === '`')) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Path has invalid escape sequence: ' + path);
                }
                current += next;
                i += 2;
            }
            else if (c === '`') {
                inBackticks = !inBackticks;
                i++;
            }
            else if (c === '.' && !inBackticks) {
                addCurrentSegment();
                i++;
            }
            else {
                current += c;
                i++;
            }
        }
        addCurrentSegment();
        if (inBackticks) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Unterminated ` in path: ' + path);
        }
        return new FieldPath(segments);
    };
    FieldPath.EMPTY_PATH = new FieldPath([]);
    return FieldPath;
}(BasePath));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DocumentKey = /** @class */ (function () {
    function DocumentKey(path) {
        this.path = path;
        assert(DocumentKey.isDocumentKey(path), 'Invalid DocumentKey with an odd number of segments: ' +
            path.toArray().join('/'));
    }
    /** Returns true if the document is in the specified collectionId. */
    DocumentKey.prototype.hasCollectionId = function (collectionId) {
        return (this.path.length >= 2 &&
            this.path.get(this.path.length - 2) === collectionId);
    };
    DocumentKey.prototype.isEqual = function (other) {
        return (other !== null && ResourcePath.comparator(this.path, other.path) === 0);
    };
    DocumentKey.prototype.toString = function () {
        return this.path.toString();
    };
    DocumentKey.comparator = function (k1, k2) {
        return ResourcePath.comparator(k1.path, k2.path);
    };
    DocumentKey.isDocumentKey = function (path) {
        return path.length % 2 === 0;
    };
    /**
     * Creates and returns a new document key with the given segments.
     *
     * @param path The segments of the path to the document
     * @return A new instance of DocumentKey
     */
    DocumentKey.fromSegments = function (segments) {
        return new DocumentKey(new ResourcePath(segments.slice()));
    };
    /**
     * Creates and returns a new document key using '/' to split the string into
     * segments.
     *
     * @param path The slash-separated path string to the document
     * @return A new instance of DocumentKey
     */
    DocumentKey.fromPathString = function (path) {
        return new DocumentKey(ResourcePath.fromString(path));
    };
    DocumentKey.EMPTY = new DocumentKey(new ResourcePath([]));
    return DocumentKey;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Deferred = /** @class */ (function () {
    function Deferred() {
        var _this = this;
        this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }
    return Deferred;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Wellknown "timer" IDs used when scheduling delayed operations on the
 * AsyncQueue. These IDs can then be used from tests to check for the presence
 * of operations or to run them early.
 *
 * The string values are used when encoding these timer IDs in JSON spec tests.
 */
var TimerId;
(function (TimerId) {
    /** All can be used with runDelayedOperationsEarly() to run all timers. */
    TimerId["All"] = "all";
    /**
     * The following 4 timers are used in persistent_stream.ts for the listen and
     * write streams. The "Idle" timer is used to close the stream due to
     * inactivity. The "ConnectionBackoff" timer is used to restart a stream once
     * the appropriate backoff delay has elapsed.
     */
    TimerId["ListenStreamIdle"] = "listen_stream_idle";
    TimerId["ListenStreamConnectionBackoff"] = "listen_stream_connection_backoff";
    TimerId["WriteStreamIdle"] = "write_stream_idle";
    TimerId["WriteStreamConnectionBackoff"] = "write_stream_connection_backoff";
    /**
     * A timer used in online_state_tracker.ts to transition from
     * OnlineState.Unknown to Offline after a set timeout, rather than waiting
     * indefinitely for success or failure.
     */
    TimerId["OnlineStateTimeout"] = "online_state_timeout";
    /**
     * A timer used to update the client metadata in IndexedDb, which is used
     * to determine the primary leaseholder.
     */
    TimerId["ClientMetadataRefresh"] = "client_metadata_refresh";
    /** A timer used to periodically attempt LRU Garbage collection */
    TimerId["LruGarbageCollection"] = "lru_garbage_collection";
    /**
     * A timer used to retry transactions. Since there can be multiple concurrent
     * transactions, multiple of these may be in the queue at a given time.
     */
    TimerId["RetryTransaction"] = "retry_transaction";
})(TimerId || (TimerId = {}));
/**
 * Represents an operation scheduled to be run in the future on an AsyncQueue.
 *
 * It is created via DelayedOperation.createAndSchedule().
 *
 * Supports cancellation (via cancel()) and early execution (via skipDelay()).
 */
var DelayedOperation = /** @class */ (function () {
    function DelayedOperation(asyncQueue, timerId, targetTimeMs, op, removalCallback) {
        this.asyncQueue = asyncQueue;
        this.timerId = timerId;
        this.targetTimeMs = targetTimeMs;
        this.op = op;
        this.removalCallback = removalCallback;
        this.deferred = new Deferred();
        this.then = this.deferred.promise.then.bind(this.deferred.promise);
        this.catch = this.deferred.promise.catch.bind(this.deferred.promise);
        // It's normal for the deferred promise to be canceled (due to cancellation)
        // and so we attach a dummy catch callback to avoid
        // 'UnhandledPromiseRejectionWarning' log spam.
        this.deferred.promise.catch(function (err) { });
    }
    /**
     * Creates and returns a DelayedOperation that has been scheduled to be
     * executed on the provided asyncQueue after the provided delayMs.
     *
     * @param asyncQueue The queue to schedule the operation on.
     * @param id A Timer ID identifying the type of operation this is.
     * @param delayMs The delay (ms) before the operation should be scheduled.
     * @param op The operation to run.
     * @param removalCallback A callback to be called synchronously once the
     *   operation is executed or canceled, notifying the AsyncQueue to remove it
     *   from its delayedOperations list.
     *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
     *   the DelayedOperation class public.
     */
    DelayedOperation.createAndSchedule = function (asyncQueue, timerId, delayMs, op, removalCallback) {
        var targetTime = Date.now() + delayMs;
        var delayedOp = new DelayedOperation(asyncQueue, timerId, targetTime, op, removalCallback);
        delayedOp.start(delayMs);
        return delayedOp;
    };
    /**
     * Starts the timer. This is called immediately after construction by
     * createAndSchedule().
     */
    DelayedOperation.prototype.start = function (delayMs) {
        var _this = this;
        this.timerHandle = setTimeout(function () { return _this.handleDelayElapsed(); }, delayMs);
    };
    /**
     * Queues the operation to run immediately (if it hasn't already been run or
     * canceled).
     */
    DelayedOperation.prototype.skipDelay = function () {
        return this.handleDelayElapsed();
    };
    /**
     * Cancels the operation if it hasn't already been executed or canceled. The
     * promise will be rejected.
     *
     * As long as the operation has not yet been run, calling cancel() provides a
     * guarantee that the operation will not be run.
     */
    DelayedOperation.prototype.cancel = function (reason) {
        if (this.timerHandle !== null) {
            this.clearTimeout();
            this.deferred.reject(new FirestoreError(Code.CANCELLED, 'Operation cancelled' + (reason ? ': ' + reason : '')));
        }
    };
    DelayedOperation.prototype.handleDelayElapsed = function () {
        var _this = this;
        this.asyncQueue.enqueueAndForget(function () {
            if (_this.timerHandle !== null) {
                _this.clearTimeout();
                return _this.op().then(function (result) {
                    return _this.deferred.resolve(result);
                });
            }
            else {
                return Promise.resolve();
            }
        });
    };
    DelayedOperation.prototype.clearTimeout = function () {
        if (this.timerHandle !== null) {
            this.removalCallback(this);
            clearTimeout(this.timerHandle);
            this.timerHandle = null;
        }
    };
    return DelayedOperation;
}());
var AsyncQueue = /** @class */ (function () {
    function AsyncQueue() {
        // The last promise in the queue.
        this.tail = Promise.resolve();
        // Is this AsyncQueue being shut down? Once it is set to true, it will not
        // be changed again.
        this._isShuttingDown = false;
        // Operations scheduled to be queued in the future. Operations are
        // automatically removed after they are run or canceled.
        this.delayedOperations = [];
        // visible for testing
        this.failure = null;
        // Flag set while there's an outstanding AsyncQueue operation, used for
        // assertion sanity-checks.
        this.operationInProgress = false;
        // List of TimerIds to fast-forward delays for.
        this.timerIdsToSkip = [];
    }
    Object.defineProperty(AsyncQueue.prototype, "isShuttingDown", {
        // Is this AsyncQueue being shut down? If true, this instance will not enqueue
        // any new operations, Promises from enqueue requests will not resolve.
        get: function () {
            return this._isShuttingDown;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Adds a new operation to the queue without waiting for it to complete (i.e.
     * we ignore the Promise result).
     */
    AsyncQueue.prototype.enqueueAndForget = function (op) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.enqueue(op);
    };
    /**
     * Regardless if the queue has initialized shutdown, adds a new operation to the
     * queue without waiting for it to complete (i.e. we ignore the Promise result).
     */
    AsyncQueue.prototype.enqueueAndForgetEvenAfterShutdown = function (op) {
        this.verifyNotFailed();
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.enqueueInternal(op);
    };
    /**
     * Regardless if the queue has initialized shutdown, adds a new operation to the
     * queue.
     */
    AsyncQueue.prototype.enqueueEvenAfterShutdown = function (op) {
        this.verifyNotFailed();
        return this.enqueueInternal(op);
    };
    /**
     * Adds a new operation to the queue and initialize the shut down of this queue.
     * Returns a promise that will be resolved when the promise returned by the new
     * operation is (with its value).
     * Once this method is called, the only possible way to request running an operation
     * is through `enqueueAndForgetEvenAfterShutdown`.
     */
    AsyncQueue.prototype.enqueueAndInitiateShutdown = function (op) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.verifyNotFailed();
                        if (!!this._isShuttingDown) return [3 /*break*/, 2];
                        this._isShuttingDown = true;
                        return [4 /*yield*/, this.enqueueEvenAfterShutdown(op)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Adds a new operation to the queue. Returns a promise that will be resolved
     * when the promise returned by the new operation is (with its value).
     */
    AsyncQueue.prototype.enqueue = function (op) {
        this.verifyNotFailed();
        if (this._isShuttingDown) {
            // Return a Promise which never resolves.
            return new Promise(function (resolve) { });
        }
        return this.enqueueInternal(op);
    };
    AsyncQueue.prototype.enqueueInternal = function (op) {
        var _this = this;
        var newTail = this.tail.then(function () {
            _this.operationInProgress = true;
            return op()
                .catch(function (error$1) {
                _this.failure = error$1;
                _this.operationInProgress = false;
                var message = error$1.stack || error$1.message || '';
                error('INTERNAL UNHANDLED ERROR: ', message);
                // Escape the promise chain and throw the error globally so that
                // e.g. any global crash reporting library detects and reports it.
                // (but not for simulated errors in our tests since this breaks mocha)
                if (message.indexOf('Firestore Test Simulated Error') < 0) {
                    setTimeout(function () {
                        throw error$1;
                    }, 0);
                }
                // Re-throw the error so that this.tail becomes a rejected Promise and
                // all further attempts to chain (via .then) will just short-circuit
                // and return the rejected Promise.
                throw error$1;
            })
                .then(function (result) {
                _this.operationInProgress = false;
                return result;
            });
        });
        this.tail = newTail;
        return newTail;
    };
    /**
     * Schedules an operation to be queued on the AsyncQueue once the specified
     * `delayMs` has elapsed. The returned CancelablePromise can be used to cancel
     * the operation prior to its running.
     */
    AsyncQueue.prototype.enqueueAfterDelay = function (timerId, delayMs, op) {
        var _this = this;
        this.verifyNotFailed();
        assert(delayMs >= 0, "Attempted to schedule an operation with a negative delay of " + delayMs);
        // Fast-forward delays for timerIds that have been overriden.
        if (this.timerIdsToSkip.indexOf(timerId) > -1) {
            delayMs = 0;
        }
        var delayedOp = DelayedOperation.createAndSchedule(this, timerId, delayMs, op, function (removedOp) {
            return _this.removeDelayedOperation(removedOp);
        });
        this.delayedOperations.push(delayedOp);
        return delayedOp;
    };
    AsyncQueue.prototype.verifyNotFailed = function () {
        if (this.failure) {
            fail('AsyncQueue is already failed: ' +
                (this.failure.stack || this.failure.message));
        }
    };
    /**
     * Verifies there's an operation currently in-progress on the AsyncQueue.
     * Unfortunately we can't verify that the running code is in the promise chain
     * of that operation, so this isn't a foolproof check, but it should be enough
     * to catch some bugs.
     */
    AsyncQueue.prototype.verifyOperationInProgress = function () {
        assert(this.operationInProgress, 'verifyOpInProgress() called when no op in progress on this queue.');
    };
    /**
     * Waits until all currently queued tasks are finished executing. Delayed
     * operations are not run.
     */
    AsyncQueue.prototype.drain = function () {
        // It should still be possible to drain the queue after it is shutting down.
        return this.enqueueEvenAfterShutdown(function () { return Promise.resolve(); });
    };
    /**
     * For Tests: Determine if a delayed operation with a particular TimerId
     * exists.
     */
    AsyncQueue.prototype.containsDelayedOperation = function (timerId) {
        for (var _i = 0, _a = this.delayedOperations; _i < _a.length; _i++) {
            var op = _a[_i];
            if (op.timerId === timerId) {
                return true;
            }
        }
        return false;
    };
    /**
     * For Tests: Runs some or all delayed operations early.
     *
     * @param lastTimerId Delayed operations up to and including this TimerId will
     *  be drained. Throws if no such operation exists. Pass TimerId.All to run
     *  all delayed operations.
     * @returns a Promise that resolves once all operations have been run.
     */
    AsyncQueue.prototype.runDelayedOperationsEarly = function (lastTimerId) {
        var _this = this;
        // Note that draining may generate more delayed ops, so we do that first.
        return this.drain().then(function () {
            assert(lastTimerId === TimerId.All ||
                _this.containsDelayedOperation(lastTimerId), "Attempted to drain to missing operation " + lastTimerId);
            // Run ops in the same order they'd run if they ran naturally.
            _this.delayedOperations.sort(function (a, b) { return a.targetTimeMs - b.targetTimeMs; });
            for (var _i = 0, _a = _this.delayedOperations; _i < _a.length; _i++) {
                var op = _a[_i];
                op.skipDelay();
                if (lastTimerId !== TimerId.All && op.timerId === lastTimerId) {
                    break;
                }
            }
            return _this.drain();
        });
    };
    /**
     * For Tests: Skip all subsequent delays for a timer id.
     */
    AsyncQueue.prototype.skipDelaysForTimerId = function (timerId) {
        this.timerIdsToSkip.push(timerId);
    };
    /** Called once a DelayedOperation is run or canceled. */
    AsyncQueue.prototype.removeDelayedOperation = function (op) {
        // NOTE: indexOf / slice are O(n), but delayedOperations is expected to be small.
        var index = this.delayedOperations.indexOf(op);
        assert(index >= 0, 'Delayed operation not found.');
        this.delayedOperations.splice(index, 1);
    };
    return AsyncQueue;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var escapeChar = '\u0001';
var encodedSeparatorChar = '\u0001';
var encodedNul = '\u0010';
var encodedEscape = '\u0011';
/**
 * Encodes a resource path into a IndexedDb-compatible string form.
 */
function encode(path) {
    var result = '';
    for (var i = 0; i < path.length; i++) {
        if (result.length > 0) {
            result = encodeSeparator(result);
        }
        result = encodeSegment(path.get(i), result);
    }
    return encodeSeparator(result);
}
/** Encodes a single segment of a resource path into the given result */
function encodeSegment(segment, resultBuf) {
    var result = resultBuf;
    var length = segment.length;
    for (var i = 0; i < length; i++) {
        var c = segment.charAt(i);
        switch (c) {
            case '\0':
                result += escapeChar + encodedNul;
                break;
            case escapeChar:
                result += escapeChar + encodedEscape;
                break;
            default:
                result += c;
        }
    }
    return result;
}
/** Encodes a path separator into the given result */
function encodeSeparator(result) {
    return result + escapeChar + encodedSeparatorChar;
}
/**
 * Decodes the given IndexedDb-compatible string form of a resource path into
 * a ResourcePath instance. Note that this method is not suitable for use with
 * decoding resource names from the server; those are One Platform format
 * strings.
 */
function decode(path) {
    // Event the empty path must encode as a path of at least length 2. A path
    // with exactly 2 must be the empty path.
    var length = path.length;
    assert(length >= 2, 'Invalid path ' + path);
    if (length === 2) {
        assert(path.charAt(0) === escapeChar && path.charAt(1) === encodedSeparatorChar, 'Non-empty path ' + path + ' had length 2');
        return ResourcePath.EMPTY_PATH;
    }
    // Escape characters cannot exist past the second-to-last position in the
    // source value.
    var lastReasonableEscapeIndex = length - 2;
    var segments = [];
    var segmentBuilder = '';
    for (var start = 0; start < length;) {
        // The last two characters of a valid encoded path must be a separator, so
        // there must be an end to this segment.
        var end = path.indexOf(escapeChar, start);
        if (end < 0 || end > lastReasonableEscapeIndex) {
            fail('Invalid encoded resource path: "' + path + '"');
        }
        var next = path.charAt(end + 1);
        switch (next) {
            case encodedSeparatorChar:
                var currentPiece = path.substring(start, end);
                var segment = void 0;
                if (segmentBuilder.length === 0) {
                    // Avoid copying for the common case of a segment that excludes \0
                    // and \001
                    segment = currentPiece;
                }
                else {
                    segmentBuilder += currentPiece;
                    segment = segmentBuilder;
                    segmentBuilder = '';
                }
                segments.push(segment);
                break;
            case encodedNul:
                segmentBuilder += path.substring(start, end);
                segmentBuilder += '\0';
                break;
            case encodedEscape:
                // The escape character can be used in the output to encode itself.
                segmentBuilder += path.substring(start, end + 1);
                break;
            default:
                fail('Invalid encoded resource path: "' + path + '"');
        }
        start = end + 2;
    }
    return new ResourcePath(segments);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Timestamp = /** @class */ (function () {
    function Timestamp(seconds, nanoseconds) {
        this.seconds = seconds;
        this.nanoseconds = nanoseconds;
        if (nanoseconds < 0) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Timestamp nanoseconds out of range: ' + nanoseconds);
        }
        if (nanoseconds >= 1e9) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Timestamp nanoseconds out of range: ' + nanoseconds);
        }
        // Midnight at the beginning of 1/1/1 is the earliest Firestore supports.
        if (seconds < -62135596800) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Timestamp seconds out of range: ' + seconds);
        }
        // This will break in the year 10,000.
        if (seconds >= 253402300800) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Timestamp seconds out of range: ' + seconds);
        }
    }
    Timestamp.now = function () {
        return Timestamp.fromMillis(Date.now());
    };
    Timestamp.fromDate = function (date) {
        return Timestamp.fromMillis(date.getTime());
    };
    Timestamp.fromMillis = function (milliseconds) {
        var seconds = Math.floor(milliseconds / 1000);
        var nanos = (milliseconds - seconds * 1000) * 1e6;
        return new Timestamp(seconds, nanos);
    };
    Timestamp.prototype.toDate = function () {
        return new Date(this.toMillis());
    };
    Timestamp.prototype.toMillis = function () {
        return this.seconds * 1000 + this.nanoseconds / 1e6;
    };
    Timestamp.prototype._compareTo = function (other) {
        if (this.seconds === other.seconds) {
            return primitiveComparator(this.nanoseconds, other.nanoseconds);
        }
        return primitiveComparator(this.seconds, other.seconds);
    };
    Timestamp.prototype.isEqual = function (other) {
        return (other.seconds === this.seconds && other.nanoseconds === this.nanoseconds);
    };
    Timestamp.prototype.toString = function () {
        return ('Timestamp(seconds=' +
            this.seconds +
            ', nanoseconds=' +
            this.nanoseconds +
            ')');
    };
    return Timestamp;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A version of a document in Firestore. This corresponds to the version
 * timestamp, such as update_time or read_time.
 */
var SnapshotVersion = /** @class */ (function () {
    function SnapshotVersion(timestamp) {
        this.timestamp = timestamp;
    }
    // TODO(b/34176344): Once we no longer need to use the old alpha protos,
    // delete this constructor and use a timestamp-backed version everywhere.
    SnapshotVersion.fromMicroseconds = function (value) {
        var seconds = Math.floor(value / 1e6);
        var nanos = (value % 1e6) * 1e3;
        return new SnapshotVersion(new Timestamp(seconds, nanos));
    };
    SnapshotVersion.fromTimestamp = function (value) {
        return new SnapshotVersion(value);
    };
    SnapshotVersion.forDeletedDoc = function () {
        return SnapshotVersion.MIN;
    };
    SnapshotVersion.prototype.compareTo = function (other) {
        return this.timestamp._compareTo(other.timestamp);
    };
    SnapshotVersion.prototype.isEqual = function (other) {
        return this.timestamp.isEqual(other.timestamp);
    };
    /** Returns a number representation of the version for use in spec tests. */
    SnapshotVersion.prototype.toMicroseconds = function () {
        // Convert to microseconds.
        return this.timestamp.seconds * 1e6 + this.timestamp.nanoseconds / 1000;
    };
    SnapshotVersion.prototype.toString = function () {
        return 'SnapshotVersion(' + this.timestamp.toString() + ')';
    };
    SnapshotVersion.prototype.toTimestamp = function () {
        return this.timestamp;
    };
    SnapshotVersion.MIN = new SnapshotVersion(new Timestamp(0, 0));
    return SnapshotVersion;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// An immutable sorted map implementation, based on a Left-leaning Red-Black
// tree.
var SortedMap = /** @class */ (function () {
    function SortedMap(comparator, root) {
        this.comparator = comparator;
        this.root = root ? root : LLRBNode.EMPTY;
    }
    // Returns a copy of the map, with the specified key/value added or replaced.
    SortedMap.prototype.insert = function (key, value) {
        return new SortedMap(this.comparator, this.root
            .insert(key, value, this.comparator)
            .copy(null, null, LLRBNode.BLACK, null, null));
    };
    // Returns a copy of the map, with the specified key removed.
    SortedMap.prototype.remove = function (key) {
        return new SortedMap(this.comparator, this.root
            .remove(key, this.comparator)
            .copy(null, null, LLRBNode.BLACK, null, null));
    };
    // Returns the value of the node with the given key, or null.
    SortedMap.prototype.get = function (key) {
        var node = this.root;
        while (!node.isEmpty()) {
            var cmp = this.comparator(key, node.key);
            if (cmp === 0) {
                return node.value;
            }
            else if (cmp < 0) {
                node = node.left;
            }
            else if (cmp > 0) {
                node = node.right;
            }
        }
        return null;
    };
    // Returns the index of the element in this sorted map, or -1 if it doesn't
    // exist.
    SortedMap.prototype.indexOf = function (key) {
        // Number of nodes that were pruned when descending right
        var prunedNodes = 0;
        var node = this.root;
        while (!node.isEmpty()) {
            var cmp = this.comparator(key, node.key);
            if (cmp === 0) {
                return prunedNodes + node.left.size;
            }
            else if (cmp < 0) {
                node = node.left;
            }
            else {
                // Count all nodes left of the node plus the node itself
                prunedNodes += node.left.size + 1;
                node = node.right;
            }
        }
        // Node not found
        return -1;
    };
    SortedMap.prototype.isEmpty = function () {
        return this.root.isEmpty();
    };
    Object.defineProperty(SortedMap.prototype, "size", {
        // Returns the total number of nodes in the map.
        get: function () {
            return this.root.size;
        },
        enumerable: true,
        configurable: true
    });
    // Returns the minimum key in the map.
    SortedMap.prototype.minKey = function () {
        return this.root.minKey();
    };
    // Returns the maximum key in the map.
    SortedMap.prototype.maxKey = function () {
        return this.root.maxKey();
    };
    // Traverses the map in key order and calls the specified action function
    // for each key/value pair. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    SortedMap.prototype.inorderTraversal = function (action) {
        return this.root.inorderTraversal(action);
    };
    SortedMap.prototype.forEach = function (fn) {
        this.inorderTraversal(function (k, v) {
            fn(k, v);
            return false;
        });
    };
    SortedMap.prototype.toString = function () {
        var descriptions = [];
        this.inorderTraversal(function (k, v) {
            descriptions.push(k + ":" + v);
            return false;
        });
        return "{" + descriptions.join(', ') + "}";
    };
    // Traverses the map in reverse key order and calls the specified action
    // function for each key/value pair. If action returns true, traversal is
    // aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    SortedMap.prototype.reverseTraversal = function (action) {
        return this.root.reverseTraversal(action);
    };
    // Returns an iterator over the SortedMap.
    SortedMap.prototype.getIterator = function () {
        return new SortedMapIterator(this.root, null, this.comparator, false);
    };
    SortedMap.prototype.getIteratorFrom = function (key) {
        return new SortedMapIterator(this.root, key, this.comparator, false);
    };
    SortedMap.prototype.getReverseIterator = function () {
        return new SortedMapIterator(this.root, null, this.comparator, true);
    };
    SortedMap.prototype.getReverseIteratorFrom = function (key) {
        return new SortedMapIterator(this.root, key, this.comparator, true);
    };
    return SortedMap;
}()); // end SortedMap
// An iterator over an LLRBNode.
var SortedMapIterator = /** @class */ (function () {
    function SortedMapIterator(node, startKey, comparator, isReverse) {
        this.isReverse = isReverse;
        this.nodeStack = [];
        var cmp = 1;
        while (!node.isEmpty()) {
            cmp = startKey ? comparator(node.key, startKey) : 1;
            // flip the comparison if we're going in reverse
            if (isReverse) {
                cmp *= -1;
            }
            if (cmp < 0) {
                // This node is less than our start key. ignore it
                if (this.isReverse) {
                    node = node.left;
                }
                else {
                    node = node.right;
                }
            }
            else if (cmp === 0) {
                // This node is exactly equal to our start key. Push it on the stack,
                // but stop iterating;
                this.nodeStack.push(node);
                break;
            }
            else {
                // This node is greater than our start key, add it to the stack and move
                // to the next one
                this.nodeStack.push(node);
                if (this.isReverse) {
                    node = node.right;
                }
                else {
                    node = node.left;
                }
            }
        }
    }
    SortedMapIterator.prototype.getNext = function () {
        assert(this.nodeStack.length > 0, 'getNext() called on iterator when hasNext() is false.');
        var node = this.nodeStack.pop();
        var result = { key: node.key, value: node.value };
        if (this.isReverse) {
            node = node.left;
            while (!node.isEmpty()) {
                this.nodeStack.push(node);
                node = node.right;
            }
        }
        else {
            node = node.right;
            while (!node.isEmpty()) {
                this.nodeStack.push(node);
                node = node.left;
            }
        }
        return result;
    };
    SortedMapIterator.prototype.hasNext = function () {
        return this.nodeStack.length > 0;
    };
    SortedMapIterator.prototype.peek = function () {
        if (this.nodeStack.length === 0) {
            return null;
        }
        var node = this.nodeStack[this.nodeStack.length - 1];
        return { key: node.key, value: node.value };
    };
    return SortedMapIterator;
}()); // end SortedMapIterator
// Represents a node in a Left-leaning Red-Black tree.
var LLRBNode = /** @class */ (function () {
    function LLRBNode(key, value, color, left, right) {
        this.key = key;
        this.value = value;
        this.color = color != null ? color : LLRBNode.RED;
        this.left = left != null ? left : LLRBNode.EMPTY;
        this.right = right != null ? right : LLRBNode.EMPTY;
        this.size = this.left.size + 1 + this.right.size;
    }
    // Returns a copy of the current node, optionally replacing pieces of it.
    LLRBNode.prototype.copy = function (key, value, color, left, right) {
        return new LLRBNode(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
    };
    LLRBNode.prototype.isEmpty = function () {
        return false;
    };
    // Traverses the tree in key order and calls the specified action function
    // for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    LLRBNode.prototype.inorderTraversal = function (action) {
        return (this.left.inorderTraversal(action) ||
            action(this.key, this.value) ||
            this.right.inorderTraversal(action));
    };
    // Traverses the tree in reverse key order and calls the specified action
    // function for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    LLRBNode.prototype.reverseTraversal = function (action) {
        return (this.right.reverseTraversal(action) ||
            action(this.key, this.value) ||
            this.left.reverseTraversal(action));
    };
    // Returns the minimum node in the tree.
    LLRBNode.prototype.min = function () {
        if (this.left.isEmpty()) {
            return this;
        }
        else {
            return this.left.min();
        }
    };
    // Returns the maximum key in the tree.
    LLRBNode.prototype.minKey = function () {
        return this.min().key;
    };
    // Returns the maximum key in the tree.
    LLRBNode.prototype.maxKey = function () {
        if (this.right.isEmpty()) {
            return this.key;
        }
        else {
            return this.right.maxKey();
        }
    };
    // Returns new tree, with the key/value added.
    LLRBNode.prototype.insert = function (key, value, comparator) {
        var n = this;
        var cmp = comparator(key, n.key);
        if (cmp < 0) {
            n = n.copy(null, null, null, n.left.insert(key, value, comparator), null);
        }
        else if (cmp === 0) {
            n = n.copy(null, value, null, null, null);
        }
        else {
            n = n.copy(null, null, null, null, n.right.insert(key, value, comparator));
        }
        return n.fixUp();
    };
    LLRBNode.prototype.removeMin = function () {
        if (this.left.isEmpty()) {
            return LLRBNode.EMPTY;
        }
        var n = this;
        if (!n.left.isRed() && !n.left.left.isRed()) {
            n = n.moveRedLeft();
        }
        n = n.copy(null, null, null, n.left.removeMin(), null);
        return n.fixUp();
    };
    // Returns new tree, with the specified item removed.
    LLRBNode.prototype.remove = function (key, comparator) {
        var smallest;
        var n = this;
        if (comparator(key, n.key) < 0) {
            if (!n.left.isEmpty() && !n.left.isRed() && !n.left.left.isRed()) {
                n = n.moveRedLeft();
            }
            n = n.copy(null, null, null, n.left.remove(key, comparator), null);
        }
        else {
            if (n.left.isRed()) {
                n = n.rotateRight();
            }
            if (!n.right.isEmpty() && !n.right.isRed() && !n.right.left.isRed()) {
                n = n.moveRedRight();
            }
            if (comparator(key, n.key) === 0) {
                if (n.right.isEmpty()) {
                    return LLRBNode.EMPTY;
                }
                else {
                    smallest = n.right.min();
                    n = n.copy(smallest.key, smallest.value, null, null, n.right.removeMin());
                }
            }
            n = n.copy(null, null, null, null, n.right.remove(key, comparator));
        }
        return n.fixUp();
    };
    LLRBNode.prototype.isRed = function () {
        return this.color;
    };
    // Returns new tree after performing any needed rotations.
    LLRBNode.prototype.fixUp = function () {
        var n = this;
        if (n.right.isRed() && !n.left.isRed()) {
            n = n.rotateLeft();
        }
        if (n.left.isRed() && n.left.left.isRed()) {
            n = n.rotateRight();
        }
        if (n.left.isRed() && n.right.isRed()) {
            n = n.colorFlip();
        }
        return n;
    };
    LLRBNode.prototype.moveRedLeft = function () {
        var n = this.colorFlip();
        if (n.right.left.isRed()) {
            n = n.copy(null, null, null, null, n.right.rotateRight());
            n = n.rotateLeft();
            n = n.colorFlip();
        }
        return n;
    };
    LLRBNode.prototype.moveRedRight = function () {
        var n = this.colorFlip();
        if (n.left.left.isRed()) {
            n = n.rotateRight();
            n = n.colorFlip();
        }
        return n;
    };
    LLRBNode.prototype.rotateLeft = function () {
        var nl = this.copy(null, null, LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, nl, null);
    };
    LLRBNode.prototype.rotateRight = function () {
        var nr = this.copy(null, null, LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, nr);
    };
    LLRBNode.prototype.colorFlip = function () {
        var left = this.left.copy(null, null, !this.left.color, null, null);
        var right = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, left, right);
    };
    // For testing.
    LLRBNode.prototype.checkMaxDepth = function () {
        var blackDepth = this.check();
        if (Math.pow(2.0, blackDepth) <= this.size + 1) {
            return true;
        }
        else {
            return false;
        }
    };
    // In a balanced RB tree, the black-depth (number of black nodes) from root to
    // leaves is equal on both sides.  This function verifies that or asserts.
    LLRBNode.prototype.check = function () {
        if (this.isRed() && this.left.isRed()) {
            throw fail('Red node has red child(' + this.key + ',' + this.value + ')');
        }
        if (this.right.isRed()) {
            throw fail('Right child of (' + this.key + ',' + this.value + ') is red');
        }
        var blackDepth = this.left.check();
        if (blackDepth !== this.right.check()) {
            throw fail('Black depths differ');
        }
        else {
            return blackDepth + (this.isRed() ? 0 : 1);
        }
    };
    // Empty node is shared between all LLRB trees.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    LLRBNode.EMPTY = null;
    LLRBNode.RED = true;
    LLRBNode.BLACK = false;
    return LLRBNode;
}()); // end LLRBNode
// Represents an empty node (a leaf node in the Red-Black Tree).
var LLRBEmptyNode = /** @class */ (function () {
    function LLRBEmptyNode() {
        this.size = 0;
    }
    Object.defineProperty(LLRBEmptyNode.prototype, "key", {
        get: function () {
            throw fail('LLRBEmptyNode has no key.');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LLRBEmptyNode.prototype, "value", {
        get: function () {
            throw fail('LLRBEmptyNode has no value.');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LLRBEmptyNode.prototype, "color", {
        get: function () {
            throw fail('LLRBEmptyNode has no color.');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LLRBEmptyNode.prototype, "left", {
        get: function () {
            throw fail('LLRBEmptyNode has no left child.');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LLRBEmptyNode.prototype, "right", {
        get: function () {
            throw fail('LLRBEmptyNode has no right child.');
        },
        enumerable: true,
        configurable: true
    });
    // Returns a copy of the current node.
    LLRBEmptyNode.prototype.copy = function (key, value, color, left, right) {
        return this;
    };
    // Returns a copy of the tree, with the specified key/value added.
    LLRBEmptyNode.prototype.insert = function (key, value, comparator) {
        return new LLRBNode(key, value);
    };
    // Returns a copy of the tree, with the specified key removed.
    LLRBEmptyNode.prototype.remove = function (key, comparator) {
        return this;
    };
    LLRBEmptyNode.prototype.isEmpty = function () {
        return true;
    };
    LLRBEmptyNode.prototype.inorderTraversal = function (action) {
        return false;
    };
    LLRBEmptyNode.prototype.reverseTraversal = function (action) {
        return false;
    };
    LLRBEmptyNode.prototype.minKey = function () {
        return null;
    };
    LLRBEmptyNode.prototype.maxKey = function () {
        return null;
    };
    LLRBEmptyNode.prototype.isRed = function () {
        return false;
    };
    // For testing.
    LLRBEmptyNode.prototype.checkMaxDepth = function () {
        return true;
    };
    LLRBEmptyNode.prototype.check = function () {
        return 0;
    };
    return LLRBEmptyNode;
}()); // end LLRBEmptyNode
LLRBNode.EMPTY = new LLRBEmptyNode();

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * SortedSet is an immutable (copy-on-write) collection that holds elements
 * in order specified by the provided comparator.
 *
 * NOTE: if provided comparator returns 0 for two elements, we consider them to
 * be equal!
 */
var SortedSet = /** @class */ (function () {
    function SortedSet(comparator) {
        this.comparator = comparator;
        this.data = new SortedMap(this.comparator);
    }
    /**
     * Creates a SortedSet from the keys of the map.
     * This is currently implemented as an O(n) copy.
     */
    SortedSet.fromMapKeys = function (map) {
        var keys = new SortedSet(map.comparator);
        map.forEach(function (key) {
            keys = keys.add(key);
        });
        return keys;
    };
    SortedSet.prototype.has = function (elem) {
        return this.data.get(elem) !== null;
    };
    SortedSet.prototype.first = function () {
        return this.data.minKey();
    };
    SortedSet.prototype.last = function () {
        return this.data.maxKey();
    };
    Object.defineProperty(SortedSet.prototype, "size", {
        get: function () {
            return this.data.size;
        },
        enumerable: true,
        configurable: true
    });
    SortedSet.prototype.indexOf = function (elem) {
        return this.data.indexOf(elem);
    };
    /** Iterates elements in order defined by "comparator" */
    SortedSet.prototype.forEach = function (cb) {
        this.data.inorderTraversal(function (k, v) {
            cb(k);
            return false;
        });
    };
    /** Iterates over `elem`s such that: range[0] <= elem < range[1]. */
    SortedSet.prototype.forEachInRange = function (range, cb) {
        var iter = this.data.getIteratorFrom(range[0]);
        while (iter.hasNext()) {
            var elem = iter.getNext();
            if (this.comparator(elem.key, range[1]) >= 0) {
                return;
            }
            cb(elem.key);
        }
    };
    /**
     * Iterates over `elem`s such that: start <= elem until false is returned.
     */
    SortedSet.prototype.forEachWhile = function (cb, start) {
        var iter;
        if (start !== undefined) {
            iter = this.data.getIteratorFrom(start);
        }
        else {
            iter = this.data.getIterator();
        }
        while (iter.hasNext()) {
            var elem = iter.getNext();
            var result = cb(elem.key);
            if (!result) {
                return;
            }
        }
    };
    /** Finds the least element greater than or equal to `elem`. */
    SortedSet.prototype.firstAfterOrEqual = function (elem) {
        var iter = this.data.getIteratorFrom(elem);
        return iter.hasNext() ? iter.getNext().key : null;
    };
    SortedSet.prototype.getIterator = function () {
        return new SortedSetIterator(this.data.getIterator());
    };
    SortedSet.prototype.getIteratorFrom = function (key) {
        return new SortedSetIterator(this.data.getIteratorFrom(key));
    };
    /** Inserts or updates an element */
    SortedSet.prototype.add = function (elem) {
        return this.copy(this.data.remove(elem).insert(elem, true));
    };
    /** Deletes an element */
    SortedSet.prototype.delete = function (elem) {
        if (!this.has(elem)) {
            return this;
        }
        return this.copy(this.data.remove(elem));
    };
    SortedSet.prototype.isEmpty = function () {
        return this.data.isEmpty();
    };
    SortedSet.prototype.unionWith = function (other) {
        var result = this;
        other.forEach(function (elem) {
            result = result.add(elem);
        });
        return result;
    };
    SortedSet.prototype.isEqual = function (other) {
        if (!(other instanceof SortedSet)) {
            return false;
        }
        if (this.size !== other.size) {
            return false;
        }
        var thisIt = this.data.getIterator();
        var otherIt = other.data.getIterator();
        while (thisIt.hasNext()) {
            var thisElem = thisIt.getNext().key;
            var otherElem = otherIt.getNext().key;
            if (this.comparator(thisElem, otherElem) !== 0) {
                return false;
            }
        }
        return true;
    };
    SortedSet.prototype.toArray = function () {
        var res = [];
        this.forEach(function (targetId) {
            res.push(targetId);
        });
        return res;
    };
    SortedSet.prototype.toString = function () {
        var result = [];
        this.forEach(function (elem) { return result.push(elem); });
        return 'SortedSet(' + result.toString() + ')';
    };
    SortedSet.prototype.copy = function (data) {
        var result = new SortedSet(this.comparator);
        result.data = data;
        return result;
    };
    return SortedSet;
}());
var SortedSetIterator = /** @class */ (function () {
    function SortedSetIterator(iter) {
        this.iter = iter;
    }
    SortedSetIterator.prototype.getNext = function () {
        return this.iter.getNext().key;
    };
    SortedSetIterator.prototype.hasNext = function () {
        return this.iter.hasNext();
    };
    return SortedSetIterator;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var EMPTY_MAYBE_DOCUMENT_MAP = new SortedMap(DocumentKey.comparator);
function maybeDocumentMap() {
    return EMPTY_MAYBE_DOCUMENT_MAP;
}
function nullableMaybeDocumentMap() {
    return maybeDocumentMap();
}
var EMPTY_DOCUMENT_MAP = new SortedMap(DocumentKey.comparator);
function documentMap() {
    return EMPTY_DOCUMENT_MAP;
}
var EMPTY_DOCUMENT_VERSION_MAP = new SortedMap(DocumentKey.comparator);
function documentVersionMap() {
    return EMPTY_DOCUMENT_VERSION_MAP;
}
var EMPTY_DOCUMENT_KEY_SET = new SortedSet(DocumentKey.comparator);
function documentKeySet() {
    var keys = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        keys[_i] = arguments[_i];
    }
    var set = EMPTY_DOCUMENT_KEY_SET;
    for (var _a = 0, keys_1 = keys; _a < keys_1.length; _a++) {
        var key = keys_1[_a];
        set = set.add(key);
    }
    return set;
}
var EMPTY_TARGET_ID_SET = new SortedSet(primitiveComparator);
function targetIdSet() {
    return EMPTY_TARGET_ID_SET;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var BATCHID_UNKNOWN = -1;
/**
 * A batch of mutations that will be sent as one unit to the backend.
 */
var MutationBatch = /** @class */ (function () {
    /**
     * @param batchId The unique ID of this mutation batch.
     * @param localWriteTime The original write time of this mutation.
     * @param baseMutations Mutations that are used to populate the base
     * values when this mutation is applied locally. This can be used to locally
     * overwrite values that are persisted in the remote document cache. Base
     * mutations are never sent to the backend.
     * @param mutations The user-provided mutations in this mutation batch.
     * User-provided mutations are applied both locally and remotely on the
     * backend.
     */
    function MutationBatch(batchId, localWriteTime, baseMutations, mutations) {
        this.batchId = batchId;
        this.localWriteTime = localWriteTime;
        this.baseMutations = baseMutations;
        this.mutations = mutations;
        assert(mutations.length > 0, 'Cannot create an empty mutation batch');
    }
    /**
     * Applies all the mutations in this MutationBatch to the specified document
     * to create a new remote document
     *
     * @param docKey The key of the document to apply mutations to.
     * @param maybeDoc The document to apply mutations to.
     * @param batchResult The result of applying the MutationBatch to the
     * backend.
     */
    MutationBatch.prototype.applyToRemoteDocument = function (docKey, maybeDoc, batchResult) {
        if (maybeDoc) {
            assert(maybeDoc.key.isEqual(docKey), "applyToRemoteDocument: key " + docKey + " should match maybeDoc key\n        " + maybeDoc.key);
        }
        var mutationResults = batchResult.mutationResults;
        assert(mutationResults.length === this.mutations.length, "Mismatch between mutations length\n      (" + this.mutations.length + ") and mutation results length\n      (" + mutationResults.length + ").");
        for (var i = 0; i < this.mutations.length; i++) {
            var mutation = this.mutations[i];
            if (mutation.key.isEqual(docKey)) {
                var mutationResult = mutationResults[i];
                maybeDoc = mutation.applyToRemoteDocument(maybeDoc, mutationResult);
            }
        }
        return maybeDoc;
    };
    /**
     * Computes the local view of a document given all the mutations in this
     * batch.
     *
     * @param docKey The key of the document to apply mutations to.
     * @param maybeDoc The document to apply mutations to.
     */
    MutationBatch.prototype.applyToLocalView = function (docKey, maybeDoc) {
        if (maybeDoc) {
            assert(maybeDoc.key.isEqual(docKey), "applyToLocalDocument: key " + docKey + " should match maybeDoc key\n        " + maybeDoc.key);
        }
        // First, apply the base state. This allows us to apply non-idempotent
        // transform against a consistent set of values.
        for (var _i = 0, _a = this.baseMutations; _i < _a.length; _i++) {
            var mutation = _a[_i];
            if (mutation.key.isEqual(docKey)) {
                maybeDoc = mutation.applyToLocalView(maybeDoc, maybeDoc, this.localWriteTime);
            }
        }
        var baseDoc = maybeDoc;
        // Second, apply all user-provided mutations.
        for (var _b = 0, _c = this.mutations; _b < _c.length; _b++) {
            var mutation = _c[_b];
            if (mutation.key.isEqual(docKey)) {
                maybeDoc = mutation.applyToLocalView(maybeDoc, baseDoc, this.localWriteTime);
            }
        }
        return maybeDoc;
    };
    /**
     * Computes the local view for all provided documents given the mutations in
     * this batch.
     */
    MutationBatch.prototype.applyToLocalDocumentSet = function (maybeDocs) {
        var _this = this;
        // TODO(mrschmidt): This implementation is O(n^2). If we apply the mutations
        // directly (as done in `applyToLocalView()`), we can reduce the complexity
        // to O(n).
        var mutatedDocuments = maybeDocs;
        this.mutations.forEach(function (m) {
            var mutatedDocument = _this.applyToLocalView(m.key, maybeDocs.get(m.key));
            if (mutatedDocument) {
                mutatedDocuments = mutatedDocuments.insert(m.key, mutatedDocument);
            }
        });
        return mutatedDocuments;
    };
    MutationBatch.prototype.keys = function () {
        return this.mutations.reduce(function (keys, m) { return keys.add(m.key); }, documentKeySet());
    };
    MutationBatch.prototype.isEqual = function (other) {
        return (this.batchId === other.batchId &&
            arrayEquals(this.mutations, other.mutations) &&
            arrayEquals(this.baseMutations, other.baseMutations));
    };
    return MutationBatch;
}());
/** The result of applying a mutation batch to the backend. */
var MutationBatchResult = /** @class */ (function () {
    function MutationBatchResult(batch, commitVersion, mutationResults, streamToken, 
    /**
     * A pre-computed mapping from each mutated document to the resulting
     * version.
     */
    docVersions) {
        this.batch = batch;
        this.commitVersion = commitVersion;
        this.mutationResults = mutationResults;
        this.streamToken = streamToken;
        this.docVersions = docVersions;
    }
    /**
     * Creates a new MutationBatchResult for the given batch and results. There
     * must be one result for each mutation in the batch. This static factory
     * caches a document=>version mapping (docVersions).
     */
    MutationBatchResult.from = function (batch, commitVersion, results, streamToken) {
        assert(batch.mutations.length === results.length, 'Mutations sent ' +
            batch.mutations.length +
            ' must equal results received ' +
            results.length);
        var versionMap = documentVersionMap();
        var mutations = batch.mutations;
        for (var i = 0; i < mutations.length; i++) {
            versionMap = versionMap.insert(mutations[i].key, results[i].version);
        }
        return new MutationBatchResult(batch, commitVersion, results, streamToken, versionMap);
    };
    return MutationBatchResult;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * PersistencePromise<> is essentially a re-implementation of Promise<> except
 * it has a .next() method instead of .then() and .next() and .catch() callbacks
 * are executed synchronously when a PersistencePromise resolves rather than
 * asynchronously (Promise<> implementations use setImmediate() or similar).
 *
 * This is necessary to interoperate with IndexedDB which will automatically
 * commit transactions if control is returned to the event loop without
 * synchronously initiating another operation on the transaction.
 *
 * NOTE: .then() and .catch() only allow a single consumer, unlike normal
 * Promises.
 */
var PersistencePromise = /** @class */ (function () {
    function PersistencePromise(callback) {
        var _this = this;
        // NOTE: next/catchCallback will always point to our own wrapper functions,
        // not the user's raw next() or catch() callbacks.
        this.nextCallback = null;
        this.catchCallback = null;
        // When the operation resolves, we'll set result or error and mark isDone.
        this.result = undefined;
        this.error = undefined;
        this.isDone = false;
        // Set to true when .then() or .catch() are called and prevents additional
        // chaining.
        this.callbackAttached = false;
        callback(function (value) {
            _this.isDone = true;
            _this.result = value;
            if (_this.nextCallback) {
                // value should be defined unless T is Void, but we can't express
                // that in the type system.
                _this.nextCallback(value);
            }
        }, function (error) {
            _this.isDone = true;
            _this.error = error;
            if (_this.catchCallback) {
                _this.catchCallback(error);
            }
        });
    }
    PersistencePromise.prototype.catch = function (fn) {
        return this.next(undefined, fn);
    };
    PersistencePromise.prototype.next = function (nextFn, catchFn) {
        var _this = this;
        if (this.callbackAttached) {
            fail('Called next() or catch() twice for PersistencePromise');
        }
        this.callbackAttached = true;
        if (this.isDone) {
            if (!this.error) {
                return this.wrapSuccess(nextFn, this.result);
            }
            else {
                return this.wrapFailure(catchFn, this.error);
            }
        }
        else {
            return new PersistencePromise(function (resolve, reject) {
                _this.nextCallback = function (value) {
                    _this.wrapSuccess(nextFn, value).next(resolve, reject);
                };
                _this.catchCallback = function (error) {
                    _this.wrapFailure(catchFn, error).next(resolve, reject);
                };
            });
        }
    };
    PersistencePromise.prototype.toPromise = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.next(resolve, reject);
        });
    };
    PersistencePromise.prototype.wrapUserFunction = function (fn) {
        try {
            var result = fn();
            if (result instanceof PersistencePromise) {
                return result;
            }
            else {
                return PersistencePromise.resolve(result);
            }
        }
        catch (e) {
            return PersistencePromise.reject(e);
        }
    };
    PersistencePromise.prototype.wrapSuccess = function (nextFn, value) {
        if (nextFn) {
            return this.wrapUserFunction(function () { return nextFn(value); });
        }
        else {
            // If there's no nextFn, then R must be the same as T
            return PersistencePromise.resolve(value);
        }
    };
    PersistencePromise.prototype.wrapFailure = function (catchFn, error) {
        if (catchFn) {
            return this.wrapUserFunction(function () { return catchFn(error); });
        }
        else {
            return PersistencePromise.reject(error);
        }
    };
    PersistencePromise.resolve = function (result) {
        return new PersistencePromise(function (resolve, reject) {
            resolve(result);
        });
    };
    PersistencePromise.reject = function (error) {
        return new PersistencePromise(function (resolve, reject) {
            reject(error);
        });
    };
    PersistencePromise.waitFor = function (
    // Accept all Promise types in waitFor().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    all) {
        return new PersistencePromise(function (resolve, reject) {
            var expectedCount = 0;
            var resolvedCount = 0;
            var done = false;
            all.forEach(function (element) {
                ++expectedCount;
                element.next(function () {
                    ++resolvedCount;
                    if (done && resolvedCount === expectedCount) {
                        resolve();
                    }
                }, function (err) { return reject(err); });
            });
            done = true;
            if (resolvedCount === expectedCount) {
                resolve();
            }
        });
    };
    /**
     * Given an array of predicate functions that asynchronously evaluate to a
     * boolean, implements a short-circuiting `or` between the results. Predicates
     * will be evaluated until one of them returns `true`, then stop. The final
     * result will be whether any of them returned `true`.
     */
    PersistencePromise.or = function (predicates) {
        var p = PersistencePromise.resolve(false);
        var _loop_1 = function (predicate) {
            p = p.next(function (isTrue) {
                if (isTrue) {
                    return PersistencePromise.resolve(isTrue);
                }
                else {
                    return predicate();
                }
            });
        };
        for (var _i = 0, predicates_1 = predicates; _i < predicates_1.length; _i++) {
            var predicate = predicates_1[_i];
            _loop_1(predicate);
        }
        return p;
    };
    PersistencePromise.forEach = function (collection, f) {
        var _this = this;
        var promises = [];
        collection.forEach(function (r, s) {
            promises.push(f.call(_this, r, s));
        });
        return this.waitFor(promises);
    };
    return PersistencePromise;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG = 'SimpleDb';
/**
 * The maximum number of retry attempts for an IndexedDb transaction that fails
 * with a DOMException.
 */
var TRANSACTION_RETRY_COUNT = 3;
/**
 * Provides a wrapper around IndexedDb with a simplified interface that uses
 * Promise-like return values to chain operations. Real promises cannot be used
 * since .then() continuations are executed asynchronously (e.g. via
 * .setImmediate), which would cause IndexedDB to end the transaction.
 * See PersistencePromise for more details.
 */
var SimpleDb = /** @class */ (function () {
    function SimpleDb(db) {
        this.db = db;
        var iOSVersion = SimpleDb.getIOSVersion(util.getUA());
        // NOTE: According to https://bugs.webkit.org/show_bug.cgi?id=197050, the
        // bug we're checking for should exist in iOS >= 12.2 and < 13, but for
        // whatever reason it's much harder to hit after 12.2 so we only proactively
        // log on 12.2.
        if (iOSVersion === 12.2) {
            error('Firestore persistence suffers from a bug in iOS 12.2 ' +
                'Safari that may cause your app to stop working. See ' +
                'https://stackoverflow.com/q/56496296/110915 for details ' +
                'and a potential workaround.');
        }
    }
    /**
     * Opens the specified database, creating or upgrading it if necessary.
     *
     * Note that `version` must not be a downgrade. IndexedDB does not support downgrading the schema
     * version. We currently do not support any way to do versioning outside of IndexedDB's versioning
     * mechanism, as only version-upgrade transactions are allowed to do things like create
     * objectstores.
     */
    SimpleDb.openOrCreate = function (name, version, schemaConverter) {
        assert(SimpleDb.isAvailable(), 'IndexedDB not supported in current environment.');
        debug(LOG_TAG, 'Opening database:', name);
        return new PersistencePromise(function (resolve, reject) {
            // TODO(mikelehen): Investigate browser compatibility.
            // https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
            // suggests IE9 and older WebKit browsers handle upgrade
            // differently. They expect setVersion, as described here:
            // https://developer.mozilla.org/en-US/docs/Web/API/IDBVersionChangeRequest/setVersion
            var request = window.indexedDB.open(name, version);
            request.onsuccess = function (event) {
                var db = event.target.result;
                resolve(new SimpleDb(db));
            };
            request.onblocked = function () {
                reject(new FirestoreError(Code.FAILED_PRECONDITION, 'Cannot upgrade IndexedDB schema while another tab is open. ' +
                    'Close all tabs that access Firestore and reload this page to proceed.'));
            };
            request.onerror = function (event) {
                var error = event.target.error;
                if (error.name === 'VersionError') {
                    reject(new FirestoreError(Code.FAILED_PRECONDITION, 'A newer version of the Firestore SDK was previously used and so the persisted ' +
                        'data is not compatible with the version of the SDK you are now using. The SDK ' +
                        'will operate with persistence disabled. If you need persistence, please ' +
                        're-upgrade to a newer version of the SDK or else clear the persisted IndexedDB ' +
                        'data for your app to start fresh.'));
                }
                else {
                    reject(error);
                }
            };
            request.onupgradeneeded = function (event) {
                debug(LOG_TAG, 'Database "' + name + '" requires upgrade from version:', event.oldVersion);
                var db = event.target.result;
                schemaConverter
                    .createOrUpgrade(db, request.transaction, event.oldVersion, SCHEMA_VERSION)
                    .next(function () {
                    debug(LOG_TAG, 'Database upgrade to version ' + SCHEMA_VERSION + ' complete');
                });
            };
        }).toPromise();
    };
    /** Deletes the specified database. */
    SimpleDb.delete = function (name) {
        debug(LOG_TAG, 'Removing database:', name);
        return wrapRequest(window.indexedDB.deleteDatabase(name)).toPromise();
    };
    /** Returns true if IndexedDB is available in the current environment. */
    SimpleDb.isAvailable = function () {
        if (typeof window === 'undefined' || window.indexedDB == null) {
            return false;
        }
        if (SimpleDb.isMockPersistence()) {
            return true;
        }
        // In some Node environments, `window` is defined, but `window.navigator` is
        // not. We don't support IndexedDB persistence in Node if the
        // isMockPersistence() check above returns false.
        if (window.navigator === undefined) {
            return false;
        }
        // We extensively use indexed array values and compound keys,
        // which IE and Edge do not support. However, they still have indexedDB
        // defined on the window, so we need to check for them here and make sure
        // to return that persistence is not enabled for those browsers.
        // For tracking support of this feature, see here:
        // https://developer.microsoft.com/en-us/microsoft-edge/platform/status/indexeddbarraysandmultientrysupport/
        // Check the UA string to find out the browser.
        var ua = util.getUA();
        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
        // Edge
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML,
        // like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
        // iOS Safari: Disable for users running iOS version < 10.
        var iOSVersion = SimpleDb.getIOSVersion(ua);
        var isUnsupportedIOS = 0 < iOSVersion && iOSVersion < 10;
        // Android browser: Disable for userse running version < 4.5.
        var androidVersion = SimpleDb.getAndroidVersion(ua);
        var isUnsupportedAndroid = 0 < androidVersion && androidVersion < 4.5;
        if (ua.indexOf('MSIE ') > 0 ||
            ua.indexOf('Trident/') > 0 ||
            ua.indexOf('Edge/') > 0 ||
            isUnsupportedIOS ||
            isUnsupportedAndroid) {
            return false;
        }
        else {
            return true;
        }
    };
    /**
     * Returns true if the backing IndexedDB store is the Node IndexedDBShim
     * (see https://github.com/axemclion/IndexedDBShim).
     */
    SimpleDb.isMockPersistence = function () {
        return (typeof process !== 'undefined' &&
            process.env.USE_MOCK_PERSISTENCE === 'YES');
    };
    /** Helper to get a typed SimpleDbStore from a transaction. */
    SimpleDb.getStore = function (txn, store) {
        return txn.store(store);
    };
    // visible for testing
    /** Parse User Agent to determine iOS version. Returns -1 if not found. */
    SimpleDb.getIOSVersion = function (ua) {
        var iOSVersionRegex = ua.match(/i(?:phone|pad|pod) os ([\d_]+)/i);
        var version = iOSVersionRegex
            ? iOSVersionRegex[1]
                .split('_')
                .slice(0, 2)
                .join('.')
            : '-1';
        return Number(version);
    };
    // visible for testing
    /** Parse User Agent to determine Android version. Returns -1 if not found. */
    SimpleDb.getAndroidVersion = function (ua) {
        var androidVersionRegex = ua.match(/Android ([\d.]+)/i);
        var version = androidVersionRegex
            ? androidVersionRegex[1]
                .split('.')
                .slice(0, 2)
                .join('.')
            : '-1';
        return Number(version);
    };
    SimpleDb.prototype.setVersionChangeListener = function (versionChangeListener) {
        this.db.onversionchange = function (event) {
            return versionChangeListener(event);
        };
    };
    SimpleDb.prototype.runTransaction = function (mode, objectStores, transactionFn) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var readonly, idempotent, attemptNumber, _loop_1, this_1, state_1;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        readonly = mode.startsWith('readonly');
                        idempotent = mode.endsWith('idempotent');
                        attemptNumber = 0;
                        _loop_1 = function () {
                            var transaction, transactionFnResult, error_1, retryable;
                            return tslib.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        ++attemptNumber;
                                        transaction = SimpleDbTransaction.open(this_1.db, readonly ? 'readonly' : 'readwrite', objectStores);
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([1, 3, , 4]);
                                        transactionFnResult = transactionFn(transaction)
                                            .catch(function (error) {
                                            // Abort the transaction if there was an error.
                                            transaction.abort(error);
                                            // We cannot actually recover, and calling `abort()` will cause the transaction's
                                            // completion promise to be rejected. This in turn means that we won't use
                                            // `transactionFnResult` below. We return a rejection here so that we don't add the
                                            // possibility of returning `void` to the type of `transactionFnResult`.
                                            return PersistencePromise.reject(error);
                                        })
                                            .toPromise();
                                        // As noted above, errors are propagated by aborting the transaction. So
                                        // we swallow any error here to avoid the browser logging it as unhandled.
                                        transactionFnResult.catch(function () { });
                                        // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
                                        // fire), but still return the original transactionFnResult back to the
                                        // caller.
                                        return [4 /*yield*/, transaction.completionPromise];
                                    case 2:
                                        // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
                                        // fire), but still return the original transactionFnResult back to the
                                        // caller.
                                        _a.sent();
                                        return [2 /*return*/, { value: transactionFnResult }];
                                    case 3:
                                        error_1 = _a.sent();
                                        retryable = idempotent &&
                                            error_1.name !== 'FirebaseError' &&
                                            attemptNumber < TRANSACTION_RETRY_COUNT;
                                        debug(LOG_TAG, 'Transaction failed with error: %s. Retrying: %s.', error_1.message, retryable);
                                        if (!retryable) {
                                            return [2 /*return*/, { value: Promise.reject(error_1) }];
                                        }
                                        return [3 /*break*/, 4];
                                    case 4: return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _a.label = 1;
                    case 1:
                        return [5 /*yield**/, _loop_1()];
                    case 2:
                        state_1 = _a.sent();
                        if (typeof state_1 === "object")
                            return [2 /*return*/, state_1.value];
                        return [3 /*break*/, 1];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    SimpleDb.prototype.close = function () {
        this.db.close();
    };
    return SimpleDb;
}());
/**
 * A controller for iterating over a key range or index. It allows an iterate
 * callback to delete the currently-referenced object, or jump to a new key
 * within the key range or index.
 */
var IterationController = /** @class */ (function () {
    function IterationController(dbCursor) {
        this.dbCursor = dbCursor;
        this.shouldStop = false;
        this.nextKey = null;
    }
    Object.defineProperty(IterationController.prototype, "isDone", {
        get: function () {
            return this.shouldStop;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IterationController.prototype, "skipToKey", {
        get: function () {
            return this.nextKey;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IterationController.prototype, "cursor", {
        set: function (value) {
            this.dbCursor = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * This function can be called to stop iteration at any point.
     */
    IterationController.prototype.done = function () {
        this.shouldStop = true;
    };
    /**
     * This function can be called to skip to that next key, which could be
     * an index or a primary key.
     */
    IterationController.prototype.skip = function (key) {
        this.nextKey = key;
    };
    /**
     * Delete the current cursor value from the object store.
     *
     * NOTE: You CANNOT do this with a keysOnly query.
     */
    IterationController.prototype.delete = function () {
        return wrapRequest(this.dbCursor.delete());
    };
    return IterationController;
}());
/**
 * Wraps an IDBTransaction and exposes a store() method to get a handle to a
 * specific object store.
 */
var SimpleDbTransaction = /** @class */ (function () {
    function SimpleDbTransaction(transaction) {
        var _this = this;
        this.transaction = transaction;
        this.aborted = false;
        /**
         * A promise that resolves with the result of the IndexedDb transaction.
         */
        this.completionDeferred = new Deferred();
        this.transaction.oncomplete = function () {
            _this.completionDeferred.resolve();
        };
        this.transaction.onabort = function () {
            if (transaction.error) {
                _this.completionDeferred.reject(transaction.error);
            }
            else {
                _this.completionDeferred.resolve();
            }
        };
        this.transaction.onerror = function (event) {
            var error = checkForAndReportiOSError(event.target.error);
            _this.completionDeferred.reject(error);
        };
    }
    SimpleDbTransaction.open = function (db, mode, objectStoreNames) {
        return new SimpleDbTransaction(db.transaction(objectStoreNames, mode));
    };
    Object.defineProperty(SimpleDbTransaction.prototype, "completionPromise", {
        get: function () {
            return this.completionDeferred.promise;
        },
        enumerable: true,
        configurable: true
    });
    SimpleDbTransaction.prototype.abort = function (error) {
        if (error) {
            this.completionDeferred.reject(error);
        }
        if (!this.aborted) {
            debug(LOG_TAG, 'Aborting transaction:', error ? error.message : 'Client-initiated abort');
            this.aborted = true;
            this.transaction.abort();
        }
    };
    /**
     * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
     * operations performed on the SimpleDbStore happen within the context of this
     * transaction and it cannot be used anymore once the transaction is
     * completed.
     *
     * Note that we can't actually enforce that the KeyType and ValueType are
     * correct, but they allow type safety through the rest of the consuming code.
     */
    SimpleDbTransaction.prototype.store = function (storeName) {
        var store = this.transaction.objectStore(storeName);
        assert(!!store, 'Object store not part of transaction: ' + storeName);
        return new SimpleDbStore(store);
    };
    return SimpleDbTransaction;
}());
/**
 * A wrapper around an IDBObjectStore providing an API that:
 *
 * 1) Has generic KeyType / ValueType parameters to provide strongly-typed
 * methods for acting against the object store.
 * 2) Deals with IndexedDB's onsuccess / onerror event callbacks, making every
 * method return a PersistencePromise instead.
 * 3) Provides a higher-level API to avoid needing to do excessive wrapping of
 * intermediate IndexedDB types (IDBCursorWithValue, etc.)
 */
var SimpleDbStore = /** @class */ (function () {
    function SimpleDbStore(store) {
        this.store = store;
    }
    SimpleDbStore.prototype.put = function (keyOrValue, value) {
        var request;
        if (value !== undefined) {
            debug(LOG_TAG, 'PUT', this.store.name, keyOrValue, value);
            request = this.store.put(value, keyOrValue);
        }
        else {
            debug(LOG_TAG, 'PUT', this.store.name, '<auto-key>', keyOrValue);
            request = this.store.put(keyOrValue);
        }
        return wrapRequest(request);
    };
    /**
     * Adds a new value into an Object Store and returns the new key. Similar to
     * IndexedDb's `add()`, this method will fail on primary key collisions.
     *
     * @param value The object to write.
     * @return The key of the value to add.
     */
    SimpleDbStore.prototype.add = function (value) {
        debug(LOG_TAG, 'ADD', this.store.name, value, value);
        var request = this.store.add(value);
        return wrapRequest(request);
    };
    /**
     * Gets the object with the specified key from the specified store, or null
     * if no object exists with the specified key.
     *
     * @key The key of the object to get.
     * @return The object with the specified key or null if no object exists.
     */
    SimpleDbStore.prototype.get = function (key) {
        var _this = this;
        var request = this.store.get(key);
        // We're doing an unsafe cast to ValueType.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return wrapRequest(request).next(function (result) {
            // Normalize nonexistence to null.
            if (result === undefined) {
                result = null;
            }
            debug(LOG_TAG, 'GET', _this.store.name, key, result);
            return result;
        });
    };
    SimpleDbStore.prototype.delete = function (key) {
        debug(LOG_TAG, 'DELETE', this.store.name, key);
        var request = this.store.delete(key);
        return wrapRequest(request);
    };
    /**
     * If we ever need more of the count variants, we can add overloads. For now,
     * all we need is to count everything in a store.
     *
     * Returns the number of rows in the store.
     */
    SimpleDbStore.prototype.count = function () {
        debug(LOG_TAG, 'COUNT', this.store.name);
        var request = this.store.count();
        return wrapRequest(request);
    };
    SimpleDbStore.prototype.loadAll = function (indexOrRange, range) {
        var cursor = this.cursor(this.options(indexOrRange, range));
        var results = [];
        return this.iterateCursor(cursor, function (key, value) {
            results.push(value);
        }).next(function () {
            return results;
        });
    };
    SimpleDbStore.prototype.deleteAll = function (indexOrRange, range) {
        debug(LOG_TAG, 'DELETE ALL', this.store.name);
        var options = this.options(indexOrRange, range);
        options.keysOnly = false;
        var cursor = this.cursor(options);
        return this.iterateCursor(cursor, function (key, value, control) {
            // NOTE: Calling delete() on a cursor is documented as more efficient than
            // calling delete() on an object store with a single key
            // (https://developer.mozilla.org/en-US/docs/Web/API/IDBObjectStore/delete),
            // however, this requires us *not* to use a keysOnly cursor
            // (https://developer.mozilla.org/en-US/docs/Web/API/IDBCursor/delete). We
            // may want to compare the performance of each method.
            return control.delete();
        });
    };
    SimpleDbStore.prototype.iterate = function (optionsOrCallback, callback) {
        var options;
        if (!callback) {
            options = {};
            callback = optionsOrCallback;
        }
        else {
            options = optionsOrCallback;
        }
        var cursor = this.cursor(options);
        return this.iterateCursor(cursor, callback);
    };
    /**
     * Iterates over a store, but waits for the given callback to complete for
     * each entry before iterating the next entry. This allows the callback to do
     * asynchronous work to determine if this iteration should continue.
     *
     * The provided callback should return `true` to continue iteration, and
     * `false` otherwise.
     */
    SimpleDbStore.prototype.iterateSerial = function (callback) {
        var cursorRequest = this.cursor({});
        return new PersistencePromise(function (resolve, reject) {
            cursorRequest.onerror = function (event) {
                var error = checkForAndReportiOSError(event.target.error);
                reject(error);
            };
            cursorRequest.onsuccess = function (event) {
                var cursor = event.target.result;
                if (!cursor) {
                    resolve();
                    return;
                }
                callback(cursor.primaryKey, cursor.value).next(function (shouldContinue) {
                    if (shouldContinue) {
                        cursor.continue();
                    }
                    else {
                        resolve();
                    }
                });
            };
        });
    };
    SimpleDbStore.prototype.iterateCursor = function (cursorRequest, fn) {
        var results = [];
        return new PersistencePromise(function (resolve, reject) {
            cursorRequest.onerror = function (event) {
                reject(event.target.error);
            };
            cursorRequest.onsuccess = function (event) {
                var cursor = event.target.result;
                if (!cursor) {
                    resolve();
                    return;
                }
                var controller = new IterationController(cursor);
                var userResult = fn(cursor.primaryKey, cursor.value, controller);
                if (userResult instanceof PersistencePromise) {
                    var userPromise = userResult.catch(function (err) {
                        controller.done();
                        return PersistencePromise.reject(err);
                    });
                    results.push(userPromise);
                }
                if (controller.isDone) {
                    resolve();
                }
                else if (controller.skipToKey === null) {
                    cursor.continue();
                }
                else {
                    cursor.continue(controller.skipToKey);
                }
            };
        }).next(function () {
            return PersistencePromise.waitFor(results);
        });
    };
    SimpleDbStore.prototype.options = function (indexOrRange, range) {
        var indexName = undefined;
        if (indexOrRange !== undefined) {
            if (typeof indexOrRange === 'string') {
                indexName = indexOrRange;
            }
            else {
                assert(range === undefined, '3rd argument must not be defined if 2nd is a range.');
                range = indexOrRange;
            }
        }
        return { index: indexName, range: range };
    };
    SimpleDbStore.prototype.cursor = function (options) {
        var direction = 'next';
        if (options.reverse) {
            direction = 'prev';
        }
        if (options.index) {
            var index = this.store.index(options.index);
            if (options.keysOnly) {
                return index.openKeyCursor(options.range, direction);
            }
            else {
                return index.openCursor(options.range, direction);
            }
        }
        else {
            return this.store.openCursor(options.range, direction);
        }
    };
    return SimpleDbStore;
}());
/**
 * Wraps an IDBRequest in a PersistencePromise, using the onsuccess / onerror
 * handlers to resolve / reject the PersistencePromise as appropriate.
 */
function wrapRequest(request) {
    return new PersistencePromise(function (resolve, reject) {
        request.onsuccess = function (event) {
            var result = event.target.result;
            resolve(result);
        };
        request.onerror = function (event) {
            var error = checkForAndReportiOSError(event.target.error);
            reject(error);
        };
    });
}
// Guard so we only report the error once.
var reportedIOSError = false;
function checkForAndReportiOSError(error) {
    var iOSVersion = SimpleDb.getIOSVersion(util.getUA());
    if (iOSVersion >= 12.2 && iOSVersion < 13) {
        var IOS_ERROR = 'An internal error was encountered in the Indexed Database server';
        if (error.message.indexOf(IOS_ERROR) >= 0) {
            // Wrap error in a more descriptive one.
            var newError_1 = new FirestoreError('internal', "IOS_INDEXEDDB_BUG1: IndexedDb has thrown '" + IOS_ERROR + "'. This is likely " +
                "due to an unavoidable bug in iOS. See https://stackoverflow.com/q/56496296/110915 " +
                "for details and a potential workaround.");
            if (!reportedIOSError) {
                reportedIOSError = true;
                // Throw a global exception outside of this promise chain, for the user to
                // potentially catch.
                setTimeout(function () {
                    throw newError_1;
                }, 0);
            }
            return newError_1;
        }
    }
    return error;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** A mutation queue for a specific user, backed by IndexedDB. */
var IndexedDbMutationQueue = /** @class */ (function () {
    function IndexedDbMutationQueue(
    /**
     * The normalized userId (e.g. null UID => "" userId) used to store /
     * retrieve mutations.
     */
    userId, serializer, indexManager, referenceDelegate) {
        this.userId = userId;
        this.serializer = serializer;
        this.indexManager = indexManager;
        this.referenceDelegate = referenceDelegate;
        /**
         * Caches the document keys for pending mutation batches. If the mutation
         * has been removed from IndexedDb, the cached value may continue to
         * be used to retrieve the batch's document keys. To remove a cached value
         * locally, `removeCachedMutationKeys()` should be invoked either directly
         * or through `removeMutationBatches()`.
         *
         * With multi-tab, when the primary client acknowledges or rejects a mutation,
         * this cache is used by secondary clients to invalidate the local
         * view of the documents that were previously affected by the mutation.
         */
        // PORTING NOTE: Multi-tab only.
        this.documentKeysByBatchId = {};
    }
    /**
     * Creates a new mutation queue for the given user.
     * @param user The user for which to create a mutation queue.
     * @param serializer The serializer to use when persisting to IndexedDb.
     */
    IndexedDbMutationQueue.forUser = function (user, serializer, indexManager, referenceDelegate) {
        // TODO(mcg): Figure out what constraints there are on userIDs
        // In particular, are there any reserved characters? are empty ids allowed?
        // For the moment store these together in the same mutations table assuming
        // that empty userIDs aren't allowed.
        assert(user.uid !== '', 'UserID must not be an empty string.');
        var userId = user.isAuthenticated() ? user.uid : '';
        return new IndexedDbMutationQueue(userId, serializer, indexManager, referenceDelegate);
    };
    IndexedDbMutationQueue.prototype.checkEmpty = function (transaction) {
        var empty = true;
        var range = IDBKeyRange.bound([this.userId, Number.NEGATIVE_INFINITY], [this.userId, Number.POSITIVE_INFINITY]);
        return mutationsStore(transaction)
            .iterate({ index: DbMutationBatch.userMutationsIndex, range: range }, function (key, value, control) {
            empty = false;
            control.done();
        })
            .next(function () { return empty; });
    };
    IndexedDbMutationQueue.prototype.acknowledgeBatch = function (transaction, batch, streamToken) {
        return this.getMutationQueueMetadata(transaction).next(function (metadata) {
            metadata.lastStreamToken = convertStreamToken(streamToken);
            return mutationQueuesStore(transaction).put(metadata);
        });
    };
    IndexedDbMutationQueue.prototype.getLastStreamToken = function (transaction) {
        return this.getMutationQueueMetadata(transaction).next(function (metadata) { return metadata.lastStreamToken; });
    };
    IndexedDbMutationQueue.prototype.setLastStreamToken = function (transaction, streamToken) {
        return this.getMutationQueueMetadata(transaction).next(function (metadata) {
            metadata.lastStreamToken = convertStreamToken(streamToken);
            return mutationQueuesStore(transaction).put(metadata);
        });
    };
    IndexedDbMutationQueue.prototype.addMutationBatch = function (transaction, localWriteTime, baseMutations, mutations) {
        var _this = this;
        var documentStore = documentMutationsStore(transaction);
        var mutationStore = mutationsStore(transaction);
        // The IndexedDb implementation in Chrome (and Firefox) does not handle
        // compound indices that include auto-generated keys correctly. To ensure
        // that the index entry is added correctly in all browsers, we perform two
        // writes: The first write is used to retrieve the next auto-generated Batch
        // ID, and the second write populates the index and stores the actual
        // mutation batch.
        // See: https://bugs.chromium.org/p/chromium/issues/detail?id=701972
        // We write an empty object to obtain key
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return mutationStore.add({}).next(function (batchId) {
            assert(typeof batchId === 'number', 'Auto-generated key is not a number');
            var batch = new MutationBatch(batchId, localWriteTime, baseMutations, mutations);
            var dbBatch = _this.serializer.toDbMutationBatch(_this.userId, batch);
            var promises = [];
            var collectionParents = new SortedSet(function (l, r) {
                return primitiveComparator(l.canonicalString(), r.canonicalString());
            });
            for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
                var mutation = mutations_1[_i];
                var indexKey = DbDocumentMutation.key(_this.userId, mutation.key.path, batchId);
                collectionParents = collectionParents.add(mutation.key.path.popLast());
                promises.push(mutationStore.put(dbBatch));
                promises.push(documentStore.put(indexKey, DbDocumentMutation.PLACEHOLDER));
            }
            collectionParents.forEach(function (parent) {
                promises.push(_this.indexManager.addToCollectionParentIndex(transaction, parent));
            });
            transaction.addOnCommittedListener(function () {
                _this.documentKeysByBatchId[batchId] = batch.keys();
            });
            return PersistencePromise.waitFor(promises).next(function () { return batch; });
        });
    };
    IndexedDbMutationQueue.prototype.lookupMutationBatch = function (transaction, batchId) {
        var _this = this;
        return mutationsStore(transaction)
            .get(batchId)
            .next(function (dbBatch) {
            if (dbBatch) {
                assert(dbBatch.userId === _this.userId, "Unexpected user '" + dbBatch.userId + "' for mutation batch " + batchId);
                return _this.serializer.fromDbMutationBatch(dbBatch);
            }
            return null;
        });
    };
    IndexedDbMutationQueue.prototype.lookupMutationKeys = function (transaction, batchId) {
        var _this = this;
        if (this.documentKeysByBatchId[batchId]) {
            return PersistencePromise.resolve(this.documentKeysByBatchId[batchId]);
        }
        else {
            return this.lookupMutationBatch(transaction, batchId).next(function (batch) {
                if (batch) {
                    var keys = batch.keys();
                    _this.documentKeysByBatchId[batchId] = keys;
                    return keys;
                }
                else {
                    return null;
                }
            });
        }
    };
    IndexedDbMutationQueue.prototype.getNextMutationBatchAfterBatchId = function (transaction, batchId) {
        var _this = this;
        var nextBatchId = batchId + 1;
        var range = IDBKeyRange.lowerBound([this.userId, nextBatchId]);
        var foundBatch = null;
        return mutationsStore(transaction)
            .iterate({ index: DbMutationBatch.userMutationsIndex, range: range }, function (key, dbBatch, control) {
            if (dbBatch.userId === _this.userId) {
                assert(dbBatch.batchId >= nextBatchId, 'Should have found mutation after ' + nextBatchId);
                foundBatch = _this.serializer.fromDbMutationBatch(dbBatch);
            }
            control.done();
        })
            .next(function () { return foundBatch; });
    };
    IndexedDbMutationQueue.prototype.getHighestUnacknowledgedBatchId = function (transaction) {
        var range = IDBKeyRange.upperBound([
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        var batchId = BATCHID_UNKNOWN;
        return mutationsStore(transaction)
            .iterate({ index: DbMutationBatch.userMutationsIndex, range: range, reverse: true }, function (key, dbBatch, control) {
            batchId = dbBatch.batchId;
            control.done();
        })
            .next(function () { return batchId; });
    };
    IndexedDbMutationQueue.prototype.getAllMutationBatches = function (transaction) {
        var _this = this;
        var range = IDBKeyRange.bound([this.userId, BATCHID_UNKNOWN], [this.userId, Number.POSITIVE_INFINITY]);
        return mutationsStore(transaction)
            .loadAll(DbMutationBatch.userMutationsIndex, range)
            .next(function (dbBatches) {
            return dbBatches.map(function (dbBatch) { return _this.serializer.fromDbMutationBatch(dbBatch); });
        });
    };
    IndexedDbMutationQueue.prototype.getAllMutationBatchesAffectingDocumentKey = function (transaction, documentKey) {
        var _this = this;
        // Scan the document-mutation index starting with a prefix starting with
        // the given documentKey.
        var indexPrefix = DbDocumentMutation.prefixForPath(this.userId, documentKey.path);
        var indexStart = IDBKeyRange.lowerBound(indexPrefix);
        var results = [];
        return documentMutationsStore(transaction)
            .iterate({ range: indexStart }, function (indexKey, _, control) {
            var userID = indexKey[0], encodedPath = indexKey[1], batchId = indexKey[2];
            // Only consider rows matching exactly the specific key of
            // interest. Note that because we order by path first, and we
            // order terminators before path separators, we'll encounter all
            // the index rows for documentKey contiguously. In particular, all
            // the rows for documentKey will occur before any rows for
            // documents nested in a subcollection beneath documentKey so we
            // can stop as soon as we hit any such row.
            var path = decode(encodedPath);
            if (userID !== _this.userId || !documentKey.path.isEqual(path)) {
                control.done();
                return;
            }
            // Look up the mutation batch in the store.
            return mutationsStore(transaction)
                .get(batchId)
                .next(function (mutation) {
                if (!mutation) {
                    throw fail('Dangling document-mutation reference found: ' +
                        indexKey +
                        ' which points to ' +
                        batchId);
                }
                assert(mutation.userId === _this.userId, "Unexpected user '" + mutation.userId + "' for mutation batch " + batchId);
                results.push(_this.serializer.fromDbMutationBatch(mutation));
            });
        })
            .next(function () { return results; });
    };
    IndexedDbMutationQueue.prototype.getAllMutationBatchesAffectingDocumentKeys = function (transaction, documentKeys) {
        var _this = this;
        var uniqueBatchIDs = new SortedSet(primitiveComparator);
        var promises = [];
        documentKeys.forEach(function (documentKey) {
            var indexStart = DbDocumentMutation.prefixForPath(_this.userId, documentKey.path);
            var range = IDBKeyRange.lowerBound(indexStart);
            var promise = documentMutationsStore(transaction).iterate({ range: range }, function (indexKey, _, control) {
                var userID = indexKey[0], encodedPath = indexKey[1], batchID = indexKey[2];
                // Only consider rows matching exactly the specific key of
                // interest. Note that because we order by path first, and we
                // order terminators before path separators, we'll encounter all
                // the index rows for documentKey contiguously. In particular, all
                // the rows for documentKey will occur before any rows for
                // documents nested in a subcollection beneath documentKey so we
                // can stop as soon as we hit any such row.
                var path = decode(encodedPath);
                if (userID !== _this.userId || !documentKey.path.isEqual(path)) {
                    control.done();
                    return;
                }
                uniqueBatchIDs = uniqueBatchIDs.add(batchID);
            });
            promises.push(promise);
        });
        return PersistencePromise.waitFor(promises).next(function () {
            return _this.lookupMutationBatches(transaction, uniqueBatchIDs);
        });
    };
    IndexedDbMutationQueue.prototype.getAllMutationBatchesAffectingQuery = function (transaction, query) {
        var _this = this;
        assert(!query.isDocumentQuery(), "Document queries shouldn't go down this path");
        assert(!query.isCollectionGroupQuery(), 'CollectionGroup queries should be handled in LocalDocumentsView');
        var queryPath = query.path;
        var immediateChildrenLength = queryPath.length + 1;
        // TODO(mcg): Actually implement a single-collection query
        //
        // This is actually executing an ancestor query, traversing the whole
        // subtree below the collection which can be horrifically inefficient for
        // some structures. The right way to solve this is to implement the full
        // value index, but that's not in the cards in the near future so this is
        // the best we can do for the moment.
        //
        // Since we don't yet index the actual properties in the mutations, our
        // current approach is to just return all mutation batches that affect
        // documents in the collection being queried.
        var indexPrefix = DbDocumentMutation.prefixForPath(this.userId, queryPath);
        var indexStart = IDBKeyRange.lowerBound(indexPrefix);
        // Collect up unique batchIDs encountered during a scan of the index. Use a
        // SortedSet to accumulate batch IDs so they can be traversed in order in a
        // scan of the main table.
        var uniqueBatchIDs = new SortedSet(primitiveComparator);
        return documentMutationsStore(transaction)
            .iterate({ range: indexStart }, function (indexKey, _, control) {
            var userID = indexKey[0], encodedPath = indexKey[1], batchID = indexKey[2];
            var path = decode(encodedPath);
            if (userID !== _this.userId || !queryPath.isPrefixOf(path)) {
                control.done();
                return;
            }
            // Rows with document keys more than one segment longer than the
            // query path can't be matches. For example, a query on 'rooms'
            // can't match the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            if (path.length !== immediateChildrenLength) {
                return;
            }
            uniqueBatchIDs = uniqueBatchIDs.add(batchID);
        })
            .next(function () { return _this.lookupMutationBatches(transaction, uniqueBatchIDs); });
    };
    IndexedDbMutationQueue.prototype.lookupMutationBatches = function (transaction, batchIDs) {
        var _this = this;
        var results = [];
        var promises = [];
        // TODO(rockwood): Implement this using iterate.
        batchIDs.forEach(function (batchId) {
            promises.push(mutationsStore(transaction)
                .get(batchId)
                .next(function (mutation) {
                if (mutation === null) {
                    throw fail('Dangling document-mutation reference found, ' +
                        'which points to ' +
                        batchId);
                }
                assert(mutation.userId === _this.userId, "Unexpected user '" + mutation.userId + "' for mutation batch " + batchId);
                results.push(_this.serializer.fromDbMutationBatch(mutation));
            }));
        });
        return PersistencePromise.waitFor(promises).next(function () { return results; });
    };
    IndexedDbMutationQueue.prototype.removeMutationBatch = function (transaction, batch) {
        var _this = this;
        return removeMutationBatch(transaction.simpleDbTransaction, this.userId, batch).next(function (removedDocuments) {
            transaction.addOnCommittedListener(function () {
                _this.removeCachedMutationKeys(batch.batchId);
            });
            return PersistencePromise.forEach(removedDocuments, function (key) {
                return _this.referenceDelegate.removeMutationReference(transaction, key);
            });
        });
    };
    IndexedDbMutationQueue.prototype.removeCachedMutationKeys = function (batchId) {
        delete this.documentKeysByBatchId[batchId];
    };
    IndexedDbMutationQueue.prototype.performConsistencyCheck = function (txn) {
        var _this = this;
        return this.checkEmpty(txn).next(function (empty) {
            if (!empty) {
                return PersistencePromise.resolve();
            }
            // Verify that there are no entries in the documentMutations index if
            // the queue is empty.
            var startRange = IDBKeyRange.lowerBound(DbDocumentMutation.prefixForUser(_this.userId));
            var danglingMutationReferences = [];
            return documentMutationsStore(txn)
                .iterate({ range: startRange }, function (key, _, control) {
                var userID = key[0];
                if (userID !== _this.userId) {
                    control.done();
                    return;
                }
                else {
                    var path = decode(key[1]);
                    danglingMutationReferences.push(path);
                }
            })
                .next(function () {
                assert(danglingMutationReferences.length === 0, 'Document leak -- detected dangling mutation references when queue is empty. ' +
                    'Dangling keys: ' +
                    danglingMutationReferences.map(function (p) { return p.canonicalString(); }));
            });
        });
    };
    IndexedDbMutationQueue.prototype.containsKey = function (txn, key) {
        return mutationQueueContainsKey(txn, this.userId, key);
    };
    // PORTING NOTE: Multi-tab only (state is held in memory in other clients).
    /** Returns the mutation queue's metadata from IndexedDb. */
    IndexedDbMutationQueue.prototype.getMutationQueueMetadata = function (transaction) {
        var _this = this;
        return mutationQueuesStore(transaction)
            .get(this.userId)
            .next(function (metadata) {
            return (metadata ||
                new DbMutationQueue(_this.userId, BATCHID_UNKNOWN, 
                /*lastStreamToken=*/ ''));
        });
    };
    return IndexedDbMutationQueue;
}());
/**
 * @return true if the mutation queue for the given user contains a pending
 *         mutation for the given key.
 */
function mutationQueueContainsKey(txn, userId, key) {
    var indexKey = DbDocumentMutation.prefixForPath(userId, key.path);
    var encodedPath = indexKey[1];
    var startRange = IDBKeyRange.lowerBound(indexKey);
    var containsKey = false;
    return documentMutationsStore(txn)
        .iterate({ range: startRange, keysOnly: true }, function (key, value, control) {
        var userID = key[0], keyPath = key[1], /*batchID*/ _ = key[2];
        if (userID === userId && keyPath === encodedPath) {
            containsKey = true;
        }
        control.done();
    })
        .next(function () { return containsKey; });
}
/** Returns true if any mutation queue contains the given document. */
function mutationQueuesContainKey(txn, docKey) {
    var found = false;
    return mutationQueuesStore(txn)
        .iterateSerial(function (userId) {
        return mutationQueueContainsKey(txn, userId, docKey).next(function (containsKey) {
            if (containsKey) {
                found = true;
            }
            return PersistencePromise.resolve(!containsKey);
        });
    })
        .next(function () { return found; });
}
/**
 * Delete a mutation batch and the associated document mutations.
 * @return A PersistencePromise of the document mutations that were removed.
 */
function removeMutationBatch(txn, userId, batch) {
    var mutationStore = txn.store(DbMutationBatch.store);
    var indexTxn = txn.store(DbDocumentMutation.store);
    var promises = [];
    var range = IDBKeyRange.only(batch.batchId);
    var numDeleted = 0;
    var removePromise = mutationStore.iterate({ range: range }, function (key, value, control) {
        numDeleted++;
        return control.delete();
    });
    promises.push(removePromise.next(function () {
        assert(numDeleted === 1, 'Dangling document-mutation reference found: Missing batch ' +
            batch.batchId);
    }));
    var removedDocuments = [];
    for (var _i = 0, _a = batch.mutations; _i < _a.length; _i++) {
        var mutation = _a[_i];
        var indexKey = DbDocumentMutation.key(userId, mutation.key.path, batch.batchId);
        promises.push(indexTxn.delete(indexKey));
        removedDocuments.push(mutation.key);
    }
    return PersistencePromise.waitFor(promises).next(function () { return removedDocuments; });
}
function convertStreamToken(token) {
    if (token instanceof Uint8Array) {
        // TODO(b/78771403): Convert tokens to strings during deserialization
        assert(SimpleDb.isMockPersistence(), 'Persisting non-string stream tokens is only supported with mock persistence.');
        return token.toString();
    }
    else {
        return token;
    }
}
/**
 * Helper to get a typed SimpleDbStore for the mutations object store.
 */
function mutationsStore(txn) {
    return IndexedDbPersistence.getStore(txn, DbMutationBatch.store);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */
function documentMutationsStore(txn) {
    return IndexedDbPersistence.getStore(txn, DbDocumentMutation.store);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */
function mutationQueuesStore(txn) {
    return IndexedDbPersistence.getStore(txn, DbMutationQueue.store);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var RESERVED_BITS = 1;
var GeneratorIds;
(function (GeneratorIds) {
    GeneratorIds[GeneratorIds["QueryCache"] = 0] = "QueryCache";
    GeneratorIds[GeneratorIds["SyncEngine"] = 1] = "SyncEngine"; // The target IDs for limbo detection are odd (end in 1).
})(GeneratorIds || (GeneratorIds = {}));
/**
 * Generates monotonically increasing target IDs for sending targets to the
 * watch stream.
 *
 * The client constructs two generators, one for the query cache (via
 * forQueryCache()), and one for limbo documents (via forSyncEngine()). These
 * two generators produce non-overlapping IDs (by using even and odd IDs
 * respectively).
 *
 * By separating the target ID space, the query cache can generate target IDs
 * that persist across client restarts, while sync engine can independently
 * generate in-memory target IDs that are transient and can be reused after a
 * restart.
 */
// TODO(mrschmidt): Explore removing this class in favor of generating these IDs
// directly in SyncEngine and LocalStore.
var TargetIdGenerator = /** @class */ (function () {
    /**
     * Instantiates a new TargetIdGenerator. If a seed is provided, the generator
     * will use the seed value as the next target ID.
     */
    function TargetIdGenerator(generatorId, seed) {
        this.generatorId = generatorId;
        assert((generatorId & RESERVED_BITS) === generatorId, "Generator ID " + generatorId + " contains more than " + RESERVED_BITS + " reserved bits");
        this.seek(seed !== undefined ? seed : this.generatorId);
    }
    TargetIdGenerator.prototype.next = function () {
        var nextId = this.nextId;
        this.nextId += 1 << RESERVED_BITS;
        return nextId;
    };
    /**
     * Returns the ID that follows the given ID. Subsequent calls to `next()`
     * use the newly returned target ID as their base.
     */
    // PORTING NOTE: Multi-tab only.
    TargetIdGenerator.prototype.after = function (targetId) {
        this.seek(targetId + (1 << RESERVED_BITS));
        return this.next();
    };
    TargetIdGenerator.prototype.seek = function (targetId) {
        assert((targetId & RESERVED_BITS) === this.generatorId, 'Cannot supply target ID from different generator ID');
        this.nextId = targetId;
    };
    TargetIdGenerator.forTargetCache = function () {
        // We seed the query cache generator to return '2' as its first ID, as there
        // is no differentiation in the protocol layer between an unset number and
        // the number '0'. If we were to sent a target with target ID '0', the
        // backend would consider it unset and replace it with its own ID.
        var targetIdGenerator = new TargetIdGenerator(GeneratorIds.QueryCache, 2);
        return targetIdGenerator;
    };
    TargetIdGenerator.forSyncEngine = function () {
        // Sync engine assigns target IDs for limbo document detection.
        return new TargetIdGenerator(GeneratorIds.SyncEngine);
    };
    return TargetIdGenerator;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var IndexedDbTargetCache = /** @class */ (function () {
    function IndexedDbTargetCache(referenceDelegate, serializer) {
        this.referenceDelegate = referenceDelegate;
        this.serializer = serializer;
        // PORTING NOTE: We don't cache global metadata for the target cache, since
        // some of it (in particular `highestTargetId`) can be modified by secondary
        // tabs. We could perhaps be more granular (and e.g. still cache
        // `lastRemoteSnapshotVersion` in memory) but for simplicity we currently go
        // to IndexedDb whenever we need to read metadata. We can revisit if it turns
        // out to have a meaningful performance impact.
        this.targetIdGenerator = TargetIdGenerator.forTargetCache();
    }
    IndexedDbTargetCache.prototype.allocateTargetId = function (transaction) {
        var _this = this;
        return this.retrieveMetadata(transaction).next(function (metadata) {
            metadata.highestTargetId = _this.targetIdGenerator.after(metadata.highestTargetId);
            return _this.saveMetadata(transaction, metadata).next(function () { return metadata.highestTargetId; });
        });
    };
    IndexedDbTargetCache.prototype.getLastRemoteSnapshotVersion = function (transaction) {
        return this.retrieveMetadata(transaction).next(function (metadata) {
            return SnapshotVersion.fromTimestamp(new Timestamp(metadata.lastRemoteSnapshotVersion.seconds, metadata.lastRemoteSnapshotVersion.nanoseconds));
        });
    };
    IndexedDbTargetCache.prototype.getHighestSequenceNumber = function (transaction) {
        return getHighestListenSequenceNumber(transaction.simpleDbTransaction);
    };
    IndexedDbTargetCache.prototype.setTargetsMetadata = function (transaction, highestListenSequenceNumber, lastRemoteSnapshotVersion) {
        var _this = this;
        return this.retrieveMetadata(transaction).next(function (metadata) {
            metadata.highestListenSequenceNumber = highestListenSequenceNumber;
            if (lastRemoteSnapshotVersion) {
                metadata.lastRemoteSnapshotVersion = lastRemoteSnapshotVersion.toTimestamp();
            }
            if (highestListenSequenceNumber > metadata.highestListenSequenceNumber) {
                metadata.highestListenSequenceNumber = highestListenSequenceNumber;
            }
            return _this.saveMetadata(transaction, metadata);
        });
    };
    IndexedDbTargetCache.prototype.addTargetData = function (transaction, targetData) {
        var _this = this;
        return this.saveTargetData(transaction, targetData).next(function () {
            return _this.retrieveMetadata(transaction).next(function (metadata) {
                metadata.targetCount += 1;
                _this.updateMetadataFromTargetData(targetData, metadata);
                return _this.saveMetadata(transaction, metadata);
            });
        });
    };
    IndexedDbTargetCache.prototype.updateTargetData = function (transaction, targetData) {
        return this.saveTargetData(transaction, targetData);
    };
    IndexedDbTargetCache.prototype.removeTargetData = function (transaction, targetData) {
        var _this = this;
        return this.removeMatchingKeysForTargetId(transaction, targetData.targetId)
            .next(function () { return targetsStore(transaction).delete(targetData.targetId); })
            .next(function () { return _this.retrieveMetadata(transaction); })
            .next(function (metadata) {
            assert(metadata.targetCount > 0, 'Removing from an empty target cache');
            metadata.targetCount -= 1;
            return _this.saveMetadata(transaction, metadata);
        });
    };
    /**
     * Drops any targets with sequence number less than or equal to the upper bound, excepting those
     * present in `activeTargetIds`. Document associations for the removed targets are also removed.
     * Returns the number of targets removed.
     */
    IndexedDbTargetCache.prototype.removeTargets = function (txn, upperBound, activeTargetIds) {
        var _this = this;
        var count = 0;
        var promises = [];
        return targetsStore(txn)
            .iterate(function (key, value) {
            var targetData = _this.serializer.fromDbTarget(value);
            if (targetData.sequenceNumber <= upperBound &&
                activeTargetIds.get(targetData.targetId) === null) {
                count++;
                promises.push(_this.removeTargetData(txn, targetData));
            }
        })
            .next(function () { return PersistencePromise.waitFor(promises); })
            .next(function () { return count; });
    };
    /**
     * Call provided function with each `TargetData` that we have cached.
     */
    IndexedDbTargetCache.prototype.forEachTarget = function (txn, f) {
        var _this = this;
        return targetsStore(txn).iterate(function (key, value) {
            var targetData = _this.serializer.fromDbTarget(value);
            f(targetData);
        });
    };
    IndexedDbTargetCache.prototype.retrieveMetadata = function (transaction) {
        return retrieveMetadata(transaction.simpleDbTransaction);
    };
    IndexedDbTargetCache.prototype.saveMetadata = function (transaction, metadata) {
        return globalTargetStore(transaction).put(DbTargetGlobal.key, metadata);
    };
    IndexedDbTargetCache.prototype.saveTargetData = function (transaction, targetData) {
        return targetsStore(transaction).put(this.serializer.toDbTarget(targetData));
    };
    /**
     * In-place updates the provided metadata to account for values in the given
     * TargetData. Saving is done separately. Returns true if there were any
     * changes to the metadata.
     */
    IndexedDbTargetCache.prototype.updateMetadataFromTargetData = function (targetData, metadata) {
        var updated = false;
        if (targetData.targetId > metadata.highestTargetId) {
            metadata.highestTargetId = targetData.targetId;
            updated = true;
        }
        if (targetData.sequenceNumber > metadata.highestListenSequenceNumber) {
            metadata.highestListenSequenceNumber = targetData.sequenceNumber;
            updated = true;
        }
        return updated;
    };
    IndexedDbTargetCache.prototype.getTargetCount = function (transaction) {
        return this.retrieveMetadata(transaction).next(function (metadata) { return metadata.targetCount; });
    };
    IndexedDbTargetCache.prototype.getTargetData = function (transaction, target) {
        var _this = this;
        // Iterating by the canonicalId may yield more than one result because
        // canonicalId values are not required to be unique per target. This query
        // depends on the queryTargets index to be efficient.
        var canonicalId = target.canonicalId();
        var range = IDBKeyRange.bound([canonicalId, Number.NEGATIVE_INFINITY], [canonicalId, Number.POSITIVE_INFINITY]);
        var result = null;
        return targetsStore(transaction)
            .iterate({ range: range, index: DbTarget.queryTargetsIndexName }, function (key, value, control) {
            var found = _this.serializer.fromDbTarget(value);
            // After finding a potential match, check that the target is
            // actually equal to the requested target.
            if (target.isEqual(found.target)) {
                result = found;
                control.done();
            }
        })
            .next(function () { return result; });
    };
    IndexedDbTargetCache.prototype.addMatchingKeys = function (txn, keys, targetId) {
        var _this = this;
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        var promises = [];
        var store = documentTargetStore(txn);
        keys.forEach(function (key) {
            var path = encode(key.path);
            promises.push(store.put(new DbTargetDocument(targetId, path)));
            promises.push(_this.referenceDelegate.addReference(txn, key));
        });
        return PersistencePromise.waitFor(promises);
    };
    IndexedDbTargetCache.prototype.removeMatchingKeys = function (txn, keys, targetId) {
        var _this = this;
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        var store = documentTargetStore(txn);
        return PersistencePromise.forEach(keys, function (key) {
            var path = encode(key.path);
            return PersistencePromise.waitFor([
                store.delete([targetId, path]),
                _this.referenceDelegate.removeReference(txn, key)
            ]);
        });
    };
    IndexedDbTargetCache.prototype.removeMatchingKeysForTargetId = function (txn, targetId) {
        var store = documentTargetStore(txn);
        var range = IDBKeyRange.bound([targetId], [targetId + 1], 
        /*lowerOpen=*/ false, 
        /*upperOpen=*/ true);
        return store.delete(range);
    };
    IndexedDbTargetCache.prototype.getMatchingKeysForTargetId = function (txn, targetId) {
        var range = IDBKeyRange.bound([targetId], [targetId + 1], 
        /*lowerOpen=*/ false, 
        /*upperOpen=*/ true);
        var store = documentTargetStore(txn);
        var result = documentKeySet();
        return store
            .iterate({ range: range, keysOnly: true }, function (key, _, control) {
            var path = decode(key[1]);
            var docKey = new DocumentKey(path);
            result = result.add(docKey);
        })
            .next(function () { return result; });
    };
    IndexedDbTargetCache.prototype.containsKey = function (txn, key) {
        var path = encode(key.path);
        var range = IDBKeyRange.bound([path], [immediateSuccessor(path)], 
        /*lowerOpen=*/ false, 
        /*upperOpen=*/ true);
        var count = 0;
        return documentTargetStore(txn)
            .iterate({
            index: DbTargetDocument.documentTargetsIndex,
            keysOnly: true,
            range: range
        }, function (_a, _, control) {
            var targetId = _a[0], path = _a[1];
            // Having a sentinel row for a document does not count as containing that document;
            // For the target cache, containing the document means the document is part of some
            // target.
            if (targetId !== 0) {
                count++;
                control.done();
            }
        })
            .next(function () { return count > 0; });
    };
    IndexedDbTargetCache.prototype.getTargetDataForTarget = function (transaction, targetId) {
        var _this = this;
        return targetsStore(transaction)
            .get(targetId)
            .next(function (found) {
            if (found) {
                return _this.serializer.fromDbTarget(found);
            }
            else {
                return null;
            }
        });
    };
    return IndexedDbTargetCache;
}());
/**
 * Helper to get a typed SimpleDbStore for the queries object store.
 */
function targetsStore(txn) {
    return IndexedDbPersistence.getStore(txn, DbTarget.store);
}
/**
 * Helper to get a typed SimpleDbStore for the target globals object store.
 */
function globalTargetStore(txn) {
    return IndexedDbPersistence.getStore(txn, DbTargetGlobal.store);
}
function retrieveMetadata(txn) {
    var globalStore = SimpleDb.getStore(txn, DbTargetGlobal.store);
    return globalStore.get(DbTargetGlobal.key).next(function (metadata) {
        assert(metadata !== null, 'Missing metadata row.');
        return metadata;
    });
}
function getHighestListenSequenceNumber(txn) {
    return retrieveMetadata(txn).next(function (targetGlobal) { return targetGlobal.highestListenSequenceNumber; });
}
/**
 * Helper to get a typed SimpleDbStore for the document target object store.
 */
function documentTargetStore(txn) {
    return IndexedDbPersistence.getStore(txn, DbTargetDocument.store);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provides a set of fields that can be used to partially patch a document.
 * FieldMask is used in conjunction with ObjectValue.
 * Examples:
 *   foo - Overwrites foo entirely with the provided value. If foo is not
 *         present in the companion ObjectValue, the field is deleted.
 *   foo.bar - Overwrites only the field bar of the object foo.
 *             If foo is not an object, foo is replaced with an object
 *             containing foo
 */
var FieldMask = /** @class */ (function () {
    function FieldMask(fields) {
        this.fields = fields;
        // TODO(dimond): validation of FieldMask
    }
    FieldMask.fromSet = function (fields) {
        return new FieldMask(fields);
    };
    FieldMask.fromArray = function (fields) {
        var fieldsAsSet = new SortedSet(FieldPath.comparator);
        fields.forEach(function (fieldPath) { return (fieldsAsSet = fieldsAsSet.add(fieldPath)); });
        return new FieldMask(fieldsAsSet);
    };
    /**
     * Verifies that `fieldPath` is included by at least one field in this field
     * mask.
     *
     * This is an O(n) operation, where `n` is the size of the field mask.
     */
    FieldMask.prototype.covers = function (fieldPath) {
        var found = false;
        this.fields.forEach(function (fieldMaskPath) {
            if (fieldMaskPath.isPrefixOf(fieldPath)) {
                found = true;
            }
        });
        return found;
    };
    FieldMask.prototype.isEqual = function (other) {
        return this.fields.isEqual(other.fields);
    };
    return FieldMask;
}());
/** A field path and the TransformOperation to perform upon it. */
var FieldTransform = /** @class */ (function () {
    function FieldTransform(field, transform) {
        this.field = field;
        this.transform = transform;
    }
    FieldTransform.prototype.isEqual = function (other) {
        return (this.field.isEqual(other.field) && this.transform.isEqual(other.transform));
    };
    return FieldTransform;
}());
/** The result of successfully applying a mutation to the backend. */
var MutationResult = /** @class */ (function () {
    function MutationResult(
    /**
     * The version at which the mutation was committed:
     *
     * - For most operations, this is the updateTime in the WriteResult.
     * - For deletes, the commitTime of the WriteResponse (because deletes are
     *   not stored and have no updateTime).
     *
     * Note that these versions can be different: No-op writes will not change
     * the updateTime even though the commitTime advances.
     */
    version, 
    /**
     * The resulting fields returned from the backend after a
     * TransformMutation has been committed. Contains one FieldValue for each
     * FieldTransform that was in the mutation.
     *
     * Will be null if the mutation was not a TransformMutation.
     */
    transformResults) {
        this.version = version;
        this.transformResults = transformResults;
    }
    return MutationResult;
}());
var MutationType;
(function (MutationType) {
    MutationType[MutationType["Set"] = 0] = "Set";
    MutationType[MutationType["Patch"] = 1] = "Patch";
    MutationType[MutationType["Transform"] = 2] = "Transform";
    MutationType[MutationType["Delete"] = 3] = "Delete";
})(MutationType || (MutationType = {}));
/**
 * Encodes a precondition for a mutation. This follows the model that the
 * backend accepts with the special case of an explicit "empty" precondition
 * (meaning no precondition).
 */
var Precondition = /** @class */ (function () {
    function Precondition(updateTime, exists) {
        this.updateTime = updateTime;
        this.exists = exists;
        assert(updateTime === undefined || exists === undefined, 'Precondition can specify "exists" or "updateTime" but not both');
    }
    /** Creates a new Precondition with an exists flag. */
    Precondition.exists = function (exists) {
        return new Precondition(undefined, exists);
    };
    /** Creates a new Precondition based on a version a document exists at. */
    Precondition.updateTime = function (version) {
        return new Precondition(version);
    };
    Object.defineProperty(Precondition.prototype, "isNone", {
        /** Returns whether this Precondition is empty. */
        get: function () {
            return this.updateTime === undefined && this.exists === undefined;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns true if the preconditions is valid for the given document
     * (or null if no document is available).
     */
    Precondition.prototype.isValidFor = function (maybeDoc) {
        if (this.updateTime !== undefined) {
            return (maybeDoc instanceof Document &&
                maybeDoc.version.isEqual(this.updateTime));
        }
        else if (this.exists !== undefined) {
            return this.exists === maybeDoc instanceof Document;
        }
        else {
            assert(this.isNone, 'Precondition should be empty');
            return true;
        }
    };
    Precondition.prototype.isEqual = function (other) {
        return (equals(this.updateTime, other.updateTime) &&
            this.exists === other.exists);
    };
    Precondition.NONE = new Precondition();
    return Precondition;
}());
/**
 * A mutation describes a self-contained change to a document. Mutations can
 * create, replace, delete, and update subsets of documents.
 *
 * Mutations not only act on the value of the document but also it version.
 *
 * For local mutations (mutations that haven't been committed yet), we preserve
 * the existing version for Set, Patch, and Transform mutations. For Delete
 * mutations, we reset the version to 0.
 *
 * Here's the expected transition table.
 *
 * MUTATION           APPLIED TO            RESULTS IN
 *
 * SetMutation        Document(v3)          Document(v3)
 * SetMutation        NoDocument(v3)        Document(v0)
 * SetMutation        null                  Document(v0)
 * PatchMutation      Document(v3)          Document(v3)
 * PatchMutation      NoDocument(v3)        NoDocument(v3)
 * PatchMutation      null                  null
 * TransformMutation  Document(v3)          Document(v3)
 * TransformMutation  NoDocument(v3)        NoDocument(v3)
 * TransformMutation  null                  null
 * DeleteMutation     Document(v3)          NoDocument(v0)
 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
 * DeleteMutation     null                  NoDocument(v0)
 *
 * For acknowledged mutations, we use the updateTime of the WriteResponse as
 * the resulting version for Set, Patch, and Transform mutations. As deletes
 * have no explicit update time, we use the commitTime of the WriteResponse for
 * Delete mutations.
 *
 * If a mutation is acknowledged by the backend but fails the precondition check
 * locally, we return an `UnknownDocument` and rely on Watch to send us the
 * updated version.
 *
 * Note that TransformMutations don't create Documents (in the case of being
 * applied to a NoDocument), even though they would on the backend. This is
 * because the client always combines the TransformMutation with a SetMutation
 * or PatchMutation and we only want to apply the transform if the prior
 * mutation resulted in a Document (always true for a SetMutation, but not
 * necessarily for a PatchMutation).
 *
 * ## Subclassing Notes
 *
 * Subclasses of Mutation need to implement applyToRemoteDocument() and
 * applyToLocalView() to implement the actual behavior of applying the mutation
 * to some source document.
 */
var Mutation = /** @class */ (function () {
    function Mutation() {
    }
    Mutation.prototype.verifyKeyMatches = function (maybeDoc) {
        if (maybeDoc != null) {
            assert(maybeDoc.key.isEqual(this.key), 'Can only apply a mutation to a document with the same key');
        }
    };
    /**
     * Returns the version from the given document for use as the result of a
     * mutation. Mutations are defined to return the version of the base document
     * only if it is an existing document. Deleted and unknown documents have a
     * post-mutation version of SnapshotVersion.MIN.
     */
    Mutation.getPostMutationVersion = function (maybeDoc) {
        if (maybeDoc instanceof Document) {
            return maybeDoc.version;
        }
        else {
            return SnapshotVersion.MIN;
        }
    };
    return Mutation;
}());
/**
 * A mutation that creates or replaces the document at the given key with the
 * object value contents.
 */
var SetMutation = /** @class */ (function (_super) {
    tslib.__extends(SetMutation, _super);
    function SetMutation(key, value, precondition) {
        var _this = _super.call(this) || this;
        _this.key = key;
        _this.value = value;
        _this.precondition = precondition;
        _this.type = MutationType.Set;
        return _this;
    }
    SetMutation.prototype.applyToRemoteDocument = function (maybeDoc, mutationResult) {
        this.verifyKeyMatches(maybeDoc);
        assert(mutationResult.transformResults == null, 'Transform results received by SetMutation.');
        // Unlike applyToLocalView, if we're applying a mutation to a remote
        // document the server has accepted the mutation so the precondition must
        // have held.
        var version = mutationResult.version;
        return new Document(this.key, version, {
            hasCommittedMutations: true
        }, this.value);
    };
    SetMutation.prototype.applyToLocalView = function (maybeDoc, baseDoc, localWriteTime) {
        this.verifyKeyMatches(maybeDoc);
        if (!this.precondition.isValidFor(maybeDoc)) {
            return maybeDoc;
        }
        var version = Mutation.getPostMutationVersion(maybeDoc);
        return new Document(this.key, version, {
            hasLocalMutations: true
        }, this.value);
    };
    SetMutation.prototype.extractBaseValue = function (maybeDoc) {
        return null;
    };
    SetMutation.prototype.isEqual = function (other) {
        return (other instanceof SetMutation &&
            this.key.isEqual(other.key) &&
            this.value.isEqual(other.value) &&
            this.precondition.isEqual(other.precondition));
    };
    return SetMutation;
}(Mutation));
/**
 * A mutation that modifies fields of the document at the given key with the
 * given values. The values are applied through a field mask:
 *
 *  * When a field is in both the mask and the values, the corresponding field
 *    is updated.
 *  * When a field is in neither the mask nor the values, the corresponding
 *    field is unmodified.
 *  * When a field is in the mask but not in the values, the corresponding field
 *    is deleted.
 *  * When a field is not in the mask but is in the values, the values map is
 *    ignored.
 */
var PatchMutation = /** @class */ (function (_super) {
    tslib.__extends(PatchMutation, _super);
    function PatchMutation(key, data, fieldMask, precondition) {
        var _this = _super.call(this) || this;
        _this.key = key;
        _this.data = data;
        _this.fieldMask = fieldMask;
        _this.precondition = precondition;
        _this.type = MutationType.Patch;
        return _this;
    }
    PatchMutation.prototype.applyToRemoteDocument = function (maybeDoc, mutationResult) {
        this.verifyKeyMatches(maybeDoc);
        assert(mutationResult.transformResults == null, 'Transform results received by PatchMutation.');
        if (!this.precondition.isValidFor(maybeDoc)) {
            // Since the mutation was not rejected, we know that the  precondition
            // matched on the backend. We therefore must not have the expected version
            // of the document in our cache and return an UnknownDocument with the
            // known updateTime.
            return new UnknownDocument(this.key, mutationResult.version);
        }
        var newData = this.patchDocument(maybeDoc);
        return new Document(this.key, mutationResult.version, {
            hasCommittedMutations: true
        }, newData);
    };
    PatchMutation.prototype.applyToLocalView = function (maybeDoc, baseDoc, localWriteTime) {
        this.verifyKeyMatches(maybeDoc);
        if (!this.precondition.isValidFor(maybeDoc)) {
            return maybeDoc;
        }
        var version = Mutation.getPostMutationVersion(maybeDoc);
        var newData = this.patchDocument(maybeDoc);
        return new Document(this.key, version, {
            hasLocalMutations: true
        }, newData);
    };
    PatchMutation.prototype.extractBaseValue = function (maybeDoc) {
        return null;
    };
    PatchMutation.prototype.isEqual = function (other) {
        return (other instanceof PatchMutation &&
            this.key.isEqual(other.key) &&
            this.fieldMask.isEqual(other.fieldMask) &&
            this.precondition.isEqual(other.precondition));
    };
    /**
     * Patches the data of document if available or creates a new document. Note
     * that this does not check whether or not the precondition of this patch
     * holds.
     */
    PatchMutation.prototype.patchDocument = function (maybeDoc) {
        var data;
        if (maybeDoc instanceof Document) {
            data = maybeDoc.data();
        }
        else {
            data = ObjectValue.EMPTY;
        }
        return this.patchObject(data);
    };
    PatchMutation.prototype.patchObject = function (data) {
        var _this = this;
        this.fieldMask.fields.forEach(function (fieldPath) {
            if (!fieldPath.isEmpty()) {
                var newValue = _this.data.field(fieldPath);
                if (newValue !== null) {
                    data = data.set(fieldPath, newValue);
                }
                else {
                    data = data.delete(fieldPath);
                }
            }
        });
        return data;
    };
    return PatchMutation;
}(Mutation));
/**
 * A mutation that modifies specific fields of the document with transform
 * operations. Currently the only supported transform is a server timestamp, but
 * IP Address, increment(n), etc. could be supported in the future.
 *
 * It is somewhat similar to a PatchMutation in that it patches specific fields
 * and has no effect when applied to a null or NoDocument (see comment on
 * Mutation for rationale).
 */
var TransformMutation = /** @class */ (function (_super) {
    tslib.__extends(TransformMutation, _super);
    function TransformMutation(key, fieldTransforms) {
        var _this = _super.call(this) || this;
        _this.key = key;
        _this.fieldTransforms = fieldTransforms;
        _this.type = MutationType.Transform;
        // NOTE: We set a precondition of exists: true as a safety-check, since we
        // always combine TransformMutations with a SetMutation or PatchMutation which
        // (if successful) should end up with an existing document.
        _this.precondition = Precondition.exists(true);
        return _this;
    }
    TransformMutation.prototype.applyToRemoteDocument = function (maybeDoc, mutationResult) {
        this.verifyKeyMatches(maybeDoc);
        assert(mutationResult.transformResults != null, 'Transform results missing for TransformMutation.');
        if (!this.precondition.isValidFor(maybeDoc)) {
            // Since the mutation was not rejected, we know that the  precondition
            // matched on the backend. We therefore must not have the expected version
            // of the document in our cache and return an UnknownDocument with the
            // known updateTime.
            return new UnknownDocument(this.key, mutationResult.version);
        }
        var doc = this.requireDocument(maybeDoc);
        var transformResults = this.serverTransformResults(maybeDoc, mutationResult.transformResults);
        var version = mutationResult.version;
        var newData = this.transformObject(doc.data(), transformResults);
        return new Document(this.key, version, {
            hasCommittedMutations: true
        }, newData);
    };
    TransformMutation.prototype.applyToLocalView = function (maybeDoc, baseDoc, localWriteTime) {
        this.verifyKeyMatches(maybeDoc);
        if (!this.precondition.isValidFor(maybeDoc)) {
            return maybeDoc;
        }
        var doc = this.requireDocument(maybeDoc);
        var transformResults = this.localTransformResults(localWriteTime, maybeDoc, baseDoc);
        var newData = this.transformObject(doc.data(), transformResults);
        return new Document(this.key, doc.version, {
            hasLocalMutations: true
        }, newData);
    };
    TransformMutation.prototype.extractBaseValue = function (maybeDoc) {
        var baseObject = null;
        for (var _i = 0, _a = this.fieldTransforms; _i < _a.length; _i++) {
            var fieldTransform = _a[_i];
            var existingValue = maybeDoc instanceof Document
                ? maybeDoc.field(fieldTransform.field)
                : undefined;
            var coercedValue = fieldTransform.transform.computeBaseValue(existingValue || null);
            if (coercedValue != null) {
                if (baseObject == null) {
                    baseObject = ObjectValue.EMPTY.set(fieldTransform.field, coercedValue);
                }
                else {
                    baseObject = baseObject.set(fieldTransform.field, coercedValue);
                }
            }
        }
        return baseObject;
    };
    TransformMutation.prototype.isEqual = function (other) {
        return (other instanceof TransformMutation &&
            this.key.isEqual(other.key) &&
            arrayEquals(this.fieldTransforms, other.fieldTransforms) &&
            this.precondition.isEqual(other.precondition));
    };
    /**
     * Asserts that the given MaybeDocument is actually a Document and verifies
     * that it matches the key for this mutation. Since we only support
     * transformations with precondition exists this method is guaranteed to be
     * safe.
     */
    TransformMutation.prototype.requireDocument = function (maybeDoc) {
        assert(maybeDoc instanceof Document, 'Unknown MaybeDocument type ' + maybeDoc);
        var doc = maybeDoc;
        assert(doc.key.isEqual(this.key), 'Can only transform a document with the same key');
        return doc;
    };
    /**
     * Creates a list of "transform results" (a transform result is a field value
     * representing the result of applying a transform) for use after a
     * TransformMutation has been acknowledged by the server.
     *
     * @param baseDoc The document prior to applying this mutation batch.
     * @param serverTransformResults The transform results received by the server.
     * @return The transform results list.
     */
    TransformMutation.prototype.serverTransformResults = function (baseDoc, serverTransformResults) {
        var transformResults = [];
        assert(this.fieldTransforms.length === serverTransformResults.length, "server transform result count (" + serverTransformResults.length + ") " +
            ("should match field transform count (" + this.fieldTransforms.length + ")"));
        for (var i = 0; i < serverTransformResults.length; i++) {
            var fieldTransform = this.fieldTransforms[i];
            var transform = fieldTransform.transform;
            var previousValue = null;
            if (baseDoc instanceof Document) {
                previousValue = baseDoc.field(fieldTransform.field);
            }
            transformResults.push(transform.applyToRemoteDocument(previousValue, serverTransformResults[i]));
        }
        return transformResults;
    };
    /**
     * Creates a list of "transform results" (a transform result is a field value
     * representing the result of applying a transform) for use when applying a
     * TransformMutation locally.
     *
     * @param localWriteTime The local time of the transform mutation (used to
     *     generate ServerTimestampValues).
     * @param maybeDoc The current state of the document after applying all
     *     previous mutations.
     * @param baseDoc The document prior to applying this mutation batch.
     * @return The transform results list.
     */
    TransformMutation.prototype.localTransformResults = function (localWriteTime, maybeDoc, baseDoc) {
        var transformResults = [];
        for (var _i = 0, _a = this.fieldTransforms; _i < _a.length; _i++) {
            var fieldTransform = _a[_i];
            var transform = fieldTransform.transform;
            var previousValue = null;
            if (maybeDoc instanceof Document) {
                previousValue = maybeDoc.field(fieldTransform.field);
            }
            if (previousValue === null && baseDoc instanceof Document) {
                // If the current document does not contain a value for the mutated
                // field, use the value that existed before applying this mutation
                // batch. This solves an edge case where a PatchMutation clears the
                // values in a nested map before the TransformMutation is applied.
                previousValue = baseDoc.field(fieldTransform.field);
            }
            transformResults.push(transform.applyToLocalView(previousValue, localWriteTime));
        }
        return transformResults;
    };
    TransformMutation.prototype.transformObject = function (data, transformResults) {
        assert(transformResults.length === this.fieldTransforms.length, 'TransformResults length mismatch.');
        for (var i = 0; i < this.fieldTransforms.length; i++) {
            var fieldTransform = this.fieldTransforms[i];
            var fieldPath = fieldTransform.field;
            data = data.set(fieldPath, transformResults[i]);
        }
        return data;
    };
    return TransformMutation;
}(Mutation));
/** A mutation that deletes the document at the given key. */
var DeleteMutation = /** @class */ (function (_super) {
    tslib.__extends(DeleteMutation, _super);
    function DeleteMutation(key, precondition) {
        var _this = _super.call(this) || this;
        _this.key = key;
        _this.precondition = precondition;
        _this.type = MutationType.Delete;
        return _this;
    }
    DeleteMutation.prototype.applyToRemoteDocument = function (maybeDoc, mutationResult) {
        this.verifyKeyMatches(maybeDoc);
        assert(mutationResult.transformResults == null, 'Transform results received by DeleteMutation.');
        // Unlike applyToLocalView, if we're applying a mutation to a remote
        // document the server has accepted the mutation so the precondition must
        // have held.
        return new NoDocument(this.key, mutationResult.version, {
            hasCommittedMutations: true
        });
    };
    DeleteMutation.prototype.applyToLocalView = function (maybeDoc, baseDoc, localWriteTime) {
        this.verifyKeyMatches(maybeDoc);
        if (!this.precondition.isValidFor(maybeDoc)) {
            return maybeDoc;
        }
        if (maybeDoc) {
            assert(maybeDoc.key.isEqual(this.key), 'Can only apply mutation to document with same key');
        }
        return new NoDocument(this.key, SnapshotVersion.forDeletedDoc());
    };
    DeleteMutation.prototype.extractBaseValue = function (maybeDoc) {
        return null;
    };
    DeleteMutation.prototype.isEqual = function (other) {
        return (other instanceof DeleteMutation &&
            this.key.isEqual(other.key) &&
            this.precondition.isEqual(other.precondition));
    };
    return DeleteMutation;
}(Mutation));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var TypeOrder;
(function (TypeOrder) {
    // This order is defined by the backend.
    TypeOrder[TypeOrder["NullValue"] = 0] = "NullValue";
    TypeOrder[TypeOrder["BooleanValue"] = 1] = "BooleanValue";
    TypeOrder[TypeOrder["NumberValue"] = 2] = "NumberValue";
    TypeOrder[TypeOrder["TimestampValue"] = 3] = "TimestampValue";
    TypeOrder[TypeOrder["StringValue"] = 4] = "StringValue";
    TypeOrder[TypeOrder["BlobValue"] = 5] = "BlobValue";
    TypeOrder[TypeOrder["RefValue"] = 6] = "RefValue";
    TypeOrder[TypeOrder["GeoPointValue"] = 7] = "GeoPointValue";
    TypeOrder[TypeOrder["ArrayValue"] = 8] = "ArrayValue";
    TypeOrder[TypeOrder["ObjectValue"] = 9] = "ObjectValue";
})(TypeOrder || (TypeOrder = {}));
/** Defines the return value for pending server timestamps. */
var ServerTimestampBehavior;
(function (ServerTimestampBehavior) {
    ServerTimestampBehavior[ServerTimestampBehavior["Default"] = 0] = "Default";
    ServerTimestampBehavior[ServerTimestampBehavior["Estimate"] = 1] = "Estimate";
    ServerTimestampBehavior[ServerTimestampBehavior["Previous"] = 2] = "Previous";
})(ServerTimestampBehavior || (ServerTimestampBehavior = {}));
/** Holds properties that define field value deserialization options. */
var FieldValueOptions = /** @class */ (function () {
    function FieldValueOptions(serverTimestampBehavior, timestampsInSnapshots) {
        this.serverTimestampBehavior = serverTimestampBehavior;
        this.timestampsInSnapshots = timestampsInSnapshots;
    }
    FieldValueOptions.fromSnapshotOptions = function (options, timestampsInSnapshots) {
        switch (options.serverTimestamps) {
            case 'estimate':
                return new FieldValueOptions(ServerTimestampBehavior.Estimate, timestampsInSnapshots);
            case 'previous':
                return new FieldValueOptions(ServerTimestampBehavior.Previous, timestampsInSnapshots);
            case 'none': // Fall-through intended.
            case undefined:
                return new FieldValueOptions(ServerTimestampBehavior.Default, timestampsInSnapshots);
            default:
                return fail('fromSnapshotOptions() called with invalid options.');
        }
    };
    return FieldValueOptions;
}());
/**
 * A field value represents a datatype as stored by Firestore.
 */
var FieldValue = /** @class */ (function () {
    function FieldValue() {
    }
    FieldValue.prototype.toString = function () {
        var val = this.value();
        return val === null ? 'null' : val.toString();
    };
    FieldValue.prototype.defaultCompareTo = function (other) {
        assert(this.typeOrder !== other.typeOrder, 'Default compareTo should not be used for values of same type.');
        var cmp = primitiveComparator(this.typeOrder, other.typeOrder);
        return cmp;
    };
    return FieldValue;
}());
var NullValue = /** @class */ (function (_super) {
    tslib.__extends(NullValue, _super);
    function NullValue() {
        var _this = _super.call(this) || this;
        _this.typeOrder = TypeOrder.NullValue;
        // internalValue is unused but we add it to work around
        // https://github.com/Microsoft/TypeScript/issues/15585
        _this.internalValue = null;
        return _this;
    }
    NullValue.prototype.value = function (options) {
        return null;
    };
    NullValue.prototype.isEqual = function (other) {
        return other instanceof NullValue;
    };
    NullValue.prototype.compareTo = function (other) {
        if (other instanceof NullValue) {
            return 0;
        }
        return this.defaultCompareTo(other);
    };
    NullValue.INSTANCE = new NullValue();
    return NullValue;
}(FieldValue));
var BooleanValue = /** @class */ (function (_super) {
    tslib.__extends(BooleanValue, _super);
    function BooleanValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.BooleanValue;
        return _this;
    }
    BooleanValue.prototype.value = function (options) {
        return this.internalValue;
    };
    BooleanValue.prototype.isEqual = function (other) {
        return (other instanceof BooleanValue &&
            this.internalValue === other.internalValue);
    };
    BooleanValue.prototype.compareTo = function (other) {
        if (other instanceof BooleanValue) {
            return primitiveComparator(this, other);
        }
        return this.defaultCompareTo(other);
    };
    BooleanValue.of = function (value) {
        return value ? BooleanValue.TRUE : BooleanValue.FALSE;
    };
    BooleanValue.TRUE = new BooleanValue(true);
    BooleanValue.FALSE = new BooleanValue(false);
    return BooleanValue;
}(FieldValue));
/** Base class for IntegerValue and DoubleValue. */
var NumberValue = /** @class */ (function (_super) {
    tslib.__extends(NumberValue, _super);
    function NumberValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.NumberValue;
        return _this;
    }
    NumberValue.prototype.value = function (options) {
        return this.internalValue;
    };
    NumberValue.prototype.compareTo = function (other) {
        if (other instanceof NumberValue) {
            return numericComparator(this.internalValue, other.internalValue);
        }
        return this.defaultCompareTo(other);
    };
    return NumberValue;
}(FieldValue));
/** Utility function to compare doubles (using Firestore semantics for NaN). */
function numericComparator(left, right) {
    if (left < right) {
        return -1;
    }
    else if (left > right) {
        return 1;
    }
    else if (left === right) {
        return 0;
    }
    else {
        // one or both are NaN.
        if (isNaN(left)) {
            return isNaN(right) ? 0 : -1;
        }
        else {
            return 1;
        }
    }
}
/**
 * Utility function to check numbers for equality using Firestore semantics
 * (NaN === NaN, -0.0 !== 0.0).
 */
function numericEquals(left, right) {
    // Implemented based on Object.is() polyfill from
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
    if (left === right) {
        // +0 != -0
        return left !== 0 || 1 / left === 1 / right;
    }
    else {
        // NaN == NaN
        return left !== left && right !== right;
    }
}
var IntegerValue = /** @class */ (function (_super) {
    tslib.__extends(IntegerValue, _super);
    function IntegerValue() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IntegerValue.prototype.isEqual = function (other) {
        // NOTE: DoubleValue and IntegerValue instances may compareTo() the same,
        // but that doesn't make them equal via isEqual().
        if (other instanceof IntegerValue) {
            return numericEquals(this.internalValue, other.internalValue);
        }
        else {
            return false;
        }
    };
    return IntegerValue;
}(NumberValue));
var DoubleValue = /** @class */ (function (_super) {
    tslib.__extends(DoubleValue, _super);
    function DoubleValue() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DoubleValue.prototype.isEqual = function (other) {
        // NOTE: DoubleValue and IntegerValue instances may compareTo() the same,
        // but that doesn't make them equal via isEqual().
        if (other instanceof DoubleValue) {
            return numericEquals(this.internalValue, other.internalValue);
        }
        else {
            return false;
        }
    };
    DoubleValue.NAN = new DoubleValue(NaN);
    DoubleValue.POSITIVE_INFINITY = new DoubleValue(Infinity);
    DoubleValue.NEGATIVE_INFINITY = new DoubleValue(-Infinity);
    return DoubleValue;
}(NumberValue));
// TODO(b/37267885): Add truncation support
var StringValue = /** @class */ (function (_super) {
    tslib.__extends(StringValue, _super);
    function StringValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.StringValue;
        return _this;
    }
    StringValue.prototype.value = function (options) {
        return this.internalValue;
    };
    StringValue.prototype.isEqual = function (other) {
        return (other instanceof StringValue && this.internalValue === other.internalValue);
    };
    StringValue.prototype.compareTo = function (other) {
        if (other instanceof StringValue) {
            return primitiveComparator(this.internalValue, other.internalValue);
        }
        return this.defaultCompareTo(other);
    };
    return StringValue;
}(FieldValue));
var TimestampValue = /** @class */ (function (_super) {
    tslib.__extends(TimestampValue, _super);
    function TimestampValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.TimestampValue;
        return _this;
    }
    TimestampValue.prototype.value = function (options) {
        if (!options || options.timestampsInSnapshots) {
            return this.internalValue;
        }
        else {
            return this.internalValue.toDate();
        }
    };
    TimestampValue.prototype.isEqual = function (other) {
        return (other instanceof TimestampValue &&
            this.internalValue.isEqual(other.internalValue));
    };
    TimestampValue.prototype.compareTo = function (other) {
        if (other instanceof TimestampValue) {
            return this.internalValue._compareTo(other.internalValue);
        }
        else if (other instanceof ServerTimestampValue) {
            // Concrete timestamps come before server timestamps.
            return -1;
        }
        else {
            return this.defaultCompareTo(other);
        }
    };
    return TimestampValue;
}(FieldValue));
/**
 * Represents a locally-applied ServerTimestamp.
 *
 * Notes:
 * - ServerTimestampValue instances are created as the result of applying a
 *   TransformMutation (see TransformMutation.applyTo()). They can only exist in
 *   the local view of a document. Therefore they do not need to be parsed or
 *   serialized.
 * - When evaluated locally (e.g. for snapshot.data()), they by default
 *   evaluate to `null`. This behavior can be configured by passing custom
 *   FieldValueOptions to value().
 * - With respect to other ServerTimestampValues, they sort by their
 *   localWriteTime.
 */
var ServerTimestampValue = /** @class */ (function (_super) {
    tslib.__extends(ServerTimestampValue, _super);
    function ServerTimestampValue(localWriteTime, previousValue) {
        var _this = _super.call(this) || this;
        _this.localWriteTime = localWriteTime;
        _this.previousValue = previousValue;
        _this.typeOrder = TypeOrder.TimestampValue;
        return _this;
    }
    ServerTimestampValue.prototype.value = function (options) {
        if (options &&
            options.serverTimestampBehavior === ServerTimestampBehavior.Estimate) {
            return new TimestampValue(this.localWriteTime).value(options);
        }
        else if (options &&
            options.serverTimestampBehavior === ServerTimestampBehavior.Previous) {
            return this.previousValue ? this.previousValue.value(options) : null;
        }
        else {
            return null;
        }
    };
    ServerTimestampValue.prototype.isEqual = function (other) {
        return (other instanceof ServerTimestampValue &&
            this.localWriteTime.isEqual(other.localWriteTime));
    };
    ServerTimestampValue.prototype.compareTo = function (other) {
        if (other instanceof ServerTimestampValue) {
            return this.localWriteTime._compareTo(other.localWriteTime);
        }
        else if (other instanceof TimestampValue) {
            // Server timestamps come after all concrete timestamps.
            return 1;
        }
        else {
            return this.defaultCompareTo(other);
        }
    };
    ServerTimestampValue.prototype.toString = function () {
        return '<ServerTimestamp localTime=' + this.localWriteTime.toString() + '>';
    };
    return ServerTimestampValue;
}(FieldValue));
var BlobValue = /** @class */ (function (_super) {
    tslib.__extends(BlobValue, _super);
    function BlobValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.BlobValue;
        return _this;
    }
    BlobValue.prototype.value = function (options) {
        return this.internalValue;
    };
    BlobValue.prototype.isEqual = function (other) {
        return (other instanceof BlobValue &&
            this.internalValue.isEqual(other.internalValue));
    };
    BlobValue.prototype.compareTo = function (other) {
        if (other instanceof BlobValue) {
            return this.internalValue._compareTo(other.internalValue);
        }
        return this.defaultCompareTo(other);
    };
    return BlobValue;
}(FieldValue));
var RefValue = /** @class */ (function (_super) {
    tslib.__extends(RefValue, _super);
    function RefValue(databaseId, key) {
        var _this = _super.call(this) || this;
        _this.databaseId = databaseId;
        _this.key = key;
        _this.typeOrder = TypeOrder.RefValue;
        return _this;
    }
    RefValue.prototype.value = function (options) {
        return this.key;
    };
    RefValue.prototype.isEqual = function (other) {
        if (other instanceof RefValue) {
            return (this.key.isEqual(other.key) && this.databaseId.isEqual(other.databaseId));
        }
        else {
            return false;
        }
    };
    RefValue.prototype.compareTo = function (other) {
        if (other instanceof RefValue) {
            var cmp = this.databaseId.compareTo(other.databaseId);
            return cmp !== 0 ? cmp : DocumentKey.comparator(this.key, other.key);
        }
        return this.defaultCompareTo(other);
    };
    return RefValue;
}(FieldValue));
var GeoPointValue = /** @class */ (function (_super) {
    tslib.__extends(GeoPointValue, _super);
    function GeoPointValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.GeoPointValue;
        return _this;
    }
    GeoPointValue.prototype.value = function (options) {
        return this.internalValue;
    };
    GeoPointValue.prototype.isEqual = function (other) {
        return (other instanceof GeoPointValue &&
            this.internalValue.isEqual(other.internalValue));
    };
    GeoPointValue.prototype.compareTo = function (other) {
        if (other instanceof GeoPointValue) {
            return this.internalValue._compareTo(other.internalValue);
        }
        return this.defaultCompareTo(other);
    };
    return GeoPointValue;
}(FieldValue));
var ObjectValue = /** @class */ (function (_super) {
    tslib.__extends(ObjectValue, _super);
    function ObjectValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.ObjectValue;
        return _this;
    }
    ObjectValue.prototype.value = function (options) {
        var result = {};
        this.internalValue.inorderTraversal(function (key, val) {
            result[key] = val.value(options);
        });
        return result;
    };
    ObjectValue.prototype.forEach = function (action) {
        this.internalValue.inorderTraversal(action);
    };
    ObjectValue.prototype.isEqual = function (other) {
        if (other instanceof ObjectValue) {
            var it1 = this.internalValue.getIterator();
            var it2 = other.internalValue.getIterator();
            while (it1.hasNext() && it2.hasNext()) {
                var next1 = it1.getNext();
                var next2 = it2.getNext();
                if (next1.key !== next2.key || !next1.value.isEqual(next2.value)) {
                    return false;
                }
            }
            return !it1.hasNext() && !it2.hasNext();
        }
        return false;
    };
    ObjectValue.prototype.compareTo = function (other) {
        if (other instanceof ObjectValue) {
            var it1 = this.internalValue.getIterator();
            var it2 = other.internalValue.getIterator();
            while (it1.hasNext() && it2.hasNext()) {
                var next1 = it1.getNext();
                var next2 = it2.getNext();
                var cmp = primitiveComparator(next1.key, next2.key) ||
                    next1.value.compareTo(next2.value);
                if (cmp) {
                    return cmp;
                }
            }
            // Only equal if both iterators are exhausted
            return primitiveComparator(it1.hasNext(), it2.hasNext());
        }
        else {
            return this.defaultCompareTo(other);
        }
    };
    ObjectValue.prototype.set = function (path, to) {
        assert(!path.isEmpty(), 'Cannot set field for empty path on ObjectValue');
        if (path.length === 1) {
            return this.setChild(path.firstSegment(), to);
        }
        else {
            var child = this.child(path.firstSegment());
            if (!(child instanceof ObjectValue)) {
                child = ObjectValue.EMPTY;
            }
            var newChild = child.set(path.popFirst(), to);
            return this.setChild(path.firstSegment(), newChild);
        }
    };
    ObjectValue.prototype.delete = function (path) {
        assert(!path.isEmpty(), 'Cannot delete field for empty path on ObjectValue');
        if (path.length === 1) {
            return new ObjectValue(this.internalValue.remove(path.firstSegment()));
        }
        else {
            // nested field
            var child = this.child(path.firstSegment());
            if (child instanceof ObjectValue) {
                var newChild = child.delete(path.popFirst());
                return new ObjectValue(this.internalValue.insert(path.firstSegment(), newChild));
            }
            else {
                // Don't actually change a primitive value to an object for a delete
                return this;
            }
        }
    };
    ObjectValue.prototype.contains = function (path) {
        return this.field(path) !== null;
    };
    ObjectValue.prototype.field = function (path) {
        assert(!path.isEmpty(), "Can't get field of empty path");
        var field = this;
        path.forEach(function (pathSegment) {
            if (field instanceof ObjectValue) {
                field = field.internalValue.get(pathSegment);
            }
            else {
                field = null;
            }
        });
        return field;
    };
    /**
     * Returns a FieldMask built from all FieldPaths starting from this ObjectValue,
     * including paths from nested objects.
     */
    ObjectValue.prototype.fieldMask = function () {
        var fields = new SortedSet(FieldPath.comparator);
        this.internalValue.forEach(function (key, value) {
            var currentPath = new FieldPath([key]);
            if (value instanceof ObjectValue) {
                var nestedMask = value.fieldMask();
                var nestedFields = nestedMask.fields;
                if (nestedFields.isEmpty()) {
                    // Preserve the empty map by adding it to the FieldMask.
                    fields = fields.add(currentPath);
                }
                else {
                    // For nested and non-empty ObjectValues, add the FieldPath of the
                    // leaf nodes.
                    nestedFields.forEach(function (nestedPath) {
                        fields = fields.add(currentPath.child(nestedPath));
                    });
                }
            }
            else {
                fields = fields.add(currentPath);
            }
        });
        return FieldMask.fromSet(fields);
    };
    ObjectValue.prototype.toString = function () {
        return this.internalValue.toString();
    };
    ObjectValue.prototype.child = function (childName) {
        return this.internalValue.get(childName) || undefined;
    };
    ObjectValue.prototype.setChild = function (childName, value) {
        return new ObjectValue(this.internalValue.insert(childName, value));
    };
    ObjectValue.EMPTY = new ObjectValue(new SortedMap(primitiveComparator));
    return ObjectValue;
}(FieldValue));
var ArrayValue = /** @class */ (function (_super) {
    tslib.__extends(ArrayValue, _super);
    function ArrayValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.ArrayValue;
        return _this;
    }
    ArrayValue.prototype.value = function (options) {
        return this.internalValue.map(function (v) { return v.value(options); });
    };
    /**
     * Returns true if the given value is contained in this array.
     */
    ArrayValue.prototype.contains = function (value) {
        for (var _i = 0, _a = this.internalValue; _i < _a.length; _i++) {
            var element = _a[_i];
            if (element.isEqual(value)) {
                return true;
            }
        }
        return false;
    };
    ArrayValue.prototype.forEach = function (action) {
        this.internalValue.forEach(action);
    };
    ArrayValue.prototype.isEqual = function (other) {
        if (other instanceof ArrayValue) {
            if (this.internalValue.length !== other.internalValue.length) {
                return false;
            }
            for (var i = 0; i < this.internalValue.length; i++) {
                if (!this.internalValue[i].isEqual(other.internalValue[i])) {
                    return false;
                }
            }
            return true;
        }
        return false;
    };
    ArrayValue.prototype.compareTo = function (other) {
        if (other instanceof ArrayValue) {
            var minLength = Math.min(this.internalValue.length, other.internalValue.length);
            for (var i = 0; i < minLength; i++) {
                var cmp = this.internalValue[i].compareTo(other.internalValue[i]);
                if (cmp) {
                    return cmp;
                }
            }
            return primitiveComparator(this.internalValue.length, other.internalValue.length);
        }
        else {
            return this.defaultCompareTo(other);
        }
    };
    ArrayValue.prototype.toString = function () {
        var descriptions = this.internalValue.map(function (v) { return v.toString(); });
        return "[" + descriptions.join(',') + "]";
    };
    return ArrayValue;
}(FieldValue));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The result of a lookup for a given path may be an existing document or a
 * marker that this document does not exist at a given version.
 */
var MaybeDocument = /** @class */ (function () {
    function MaybeDocument(key, version) {
        this.key = key;
        this.version = version;
    }
    MaybeDocument.compareByKey = function (d1, d2) {
        return DocumentKey.comparator(d1.key, d2.key);
    };
    return MaybeDocument;
}());
/**
 * Represents a document in Firestore with a key, version, data and whether the
 * data has local mutations applied to it.
 */
var Document = /** @class */ (function (_super) {
    tslib.__extends(Document, _super);
    function Document(key, version, options, objectValue, proto, converter) {
        var _this = _super.call(this, key, version) || this;
        _this.objectValue = objectValue;
        _this.proto = proto;
        _this.converter = converter;
        assert(_this.objectValue !== undefined ||
            (_this.proto !== undefined && _this.converter !== undefined), 'If objectValue is not defined, proto and converter need to be set.');
        _this.hasLocalMutations = !!options.hasLocalMutations;
        _this.hasCommittedMutations = !!options.hasCommittedMutations;
        return _this;
    }
    Document.prototype.field = function (path) {
        if (this.objectValue) {
            return this.objectValue.field(path);
        }
        else {
            if (!this.fieldValueCache) {
                // TODO(b/136090445): Remove the cache when `getField` is no longer
                // called during Query ordering.
                this.fieldValueCache = new Map();
            }
            var canonicalPath = path.canonicalString();
            var fieldValue = this.fieldValueCache.get(canonicalPath);
            if (fieldValue === undefined) {
                // Instead of deserializing the full Document proto, we only
                // deserialize the value at the requested field path. This speeds up
                // Query execution as query filters can discard documents based on a
                // single field.
                var protoValue = this.getProtoField(path);
                if (protoValue === undefined) {
                    fieldValue = null;
                }
                else {
                    fieldValue = this.converter(protoValue);
                }
                this.fieldValueCache.set(canonicalPath, fieldValue);
            }
            return fieldValue;
        }
    };
    Document.prototype.data = function () {
        var _this = this;
        if (!this.objectValue) {
            var result_1 = ObjectValue.EMPTY;
            forEach(this.proto.fields || {}, function (key, value) {
                result_1 = result_1.set(new FieldPath([key]), _this.converter(value));
            });
            this.objectValue = result_1;
            // Once objectValue is computed, values inside the fieldValueCache are no
            // longer accessed.
            this.fieldValueCache = undefined;
        }
        return this.objectValue;
    };
    Document.prototype.value = function () {
        return this.data().value();
    };
    Document.prototype.isEqual = function (other) {
        return (other instanceof Document &&
            this.key.isEqual(other.key) &&
            this.version.isEqual(other.version) &&
            this.hasLocalMutations === other.hasLocalMutations &&
            this.hasCommittedMutations === other.hasCommittedMutations &&
            this.data().isEqual(other.data()));
    };
    Document.prototype.toString = function () {
        return ("Document(" + this.key + ", " + this.version + ", " + this.data().toString() + ", " +
            ("{hasLocalMutations: " + this.hasLocalMutations + "}), ") +
            ("{hasCommittedMutations: " + this.hasCommittedMutations + "})"));
    };
    Object.defineProperty(Document.prototype, "hasPendingWrites", {
        get: function () {
            return this.hasLocalMutations || this.hasCommittedMutations;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns the nested Protobuf value for 'path`. Can only be called if
     * `proto` was provided at construction time.
     */
    Document.prototype.getProtoField = function (path) {
        assert(this.proto !== undefined, 'Can only call getProtoField() when proto is defined');
        var protoValue = this.proto.fields
            ? this.proto.fields[path.firstSegment()]
            : undefined;
        for (var i = 1; i < path.length; ++i) {
            if (!protoValue || !protoValue.mapValue || !protoValue.mapValue.fields) {
                return undefined;
            }
            protoValue = protoValue.mapValue.fields[path.get(i)];
        }
        return protoValue;
    };
    Document.compareByField = function (field, d1, d2) {
        var v1 = d1.field(field);
        var v2 = d2.field(field);
        if (v1 !== null && v2 !== null) {
            return v1.compareTo(v2);
        }
        else {
            return fail("Trying to compare documents on fields that don't exist");
        }
    };
    return Document;
}(MaybeDocument));
/**
 * A class representing a deleted document.
 * Version is set to 0 if we don't point to any specific time, otherwise it
 * denotes time we know it didn't exist at.
 */
var NoDocument = /** @class */ (function (_super) {
    tslib.__extends(NoDocument, _super);
    function NoDocument(key, version, options) {
        var _this = _super.call(this, key, version) || this;
        _this.hasCommittedMutations = !!(options && options.hasCommittedMutations);
        return _this;
    }
    NoDocument.prototype.toString = function () {
        return "NoDocument(" + this.key + ", " + this.version + ")";
    };
    Object.defineProperty(NoDocument.prototype, "hasPendingWrites", {
        get: function () {
            return this.hasCommittedMutations;
        },
        enumerable: true,
        configurable: true
    });
    NoDocument.prototype.isEqual = function (other) {
        return (other instanceof NoDocument &&
            other.hasCommittedMutations === this.hasCommittedMutations &&
            other.version.isEqual(this.version) &&
            other.key.isEqual(this.key));
    };
    return NoDocument;
}(MaybeDocument));
/**
 * A class representing an existing document whose data is unknown (e.g. a
 * document that was updated without a known base document).
 */
var UnknownDocument = /** @class */ (function (_super) {
    tslib.__extends(UnknownDocument, _super);
    function UnknownDocument() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UnknownDocument.prototype.toString = function () {
        return "UnknownDocument(" + this.key + ", " + this.version + ")";
    };
    Object.defineProperty(UnknownDocument.prototype, "hasPendingWrites", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    UnknownDocument.prototype.isEqual = function (other) {
        return (other instanceof UnknownDocument &&
            other.version.isEqual(this.version) &&
            other.key.isEqual(this.key));
    };
    return UnknownDocument;
}(MaybeDocument));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A map implementation that uses objects as keys. Objects must implement the
 * Equatable interface and must be immutable. Entries in the map are stored
 * together with the key being produced from the mapKeyFn. This map
 * automatically handles collisions of keys.
 */
var ObjectMap = /** @class */ (function () {
    function ObjectMap(mapKeyFn) {
        this.mapKeyFn = mapKeyFn;
        /**
         * The inner map for a key -> value pair. Due to the possibility of
         * collisions we keep a list of entries that we do a linear search through
         * to find an actual match. Note that collisions should be rare, so we still
         * expect near constant time lookups in practice.
         */
        this.inner = {};
    }
    /** Get a value for this key, or undefined if it does not exist. */
    ObjectMap.prototype.get = function (key) {
        var id = this.mapKeyFn(key);
        var matches = this.inner[id];
        if (matches === undefined) {
            return undefined;
        }
        for (var _i = 0, matches_1 = matches; _i < matches_1.length; _i++) {
            var _a = matches_1[_i], otherKey = _a[0], value = _a[1];
            if (otherKey.isEqual(key)) {
                return value;
            }
        }
        return undefined;
    };
    ObjectMap.prototype.has = function (key) {
        return this.get(key) !== undefined;
    };
    /** Put this key and value in the map. */
    ObjectMap.prototype.set = function (key, value) {
        var id = this.mapKeyFn(key);
        var matches = this.inner[id];
        if (matches === undefined) {
            this.inner[id] = [[key, value]];
            return;
        }
        for (var i = 0; i < matches.length; i++) {
            if (matches[i][0].isEqual(key)) {
                matches[i] = [key, value];
                return;
            }
        }
        matches.push([key, value]);
    };
    /**
     * Remove this key from the map. Returns a boolean if anything was deleted.
     */
    ObjectMap.prototype.delete = function (key) {
        var id = this.mapKeyFn(key);
        var matches = this.inner[id];
        if (matches === undefined) {
            return false;
        }
        for (var i = 0; i < matches.length; i++) {
            if (matches[i][0].isEqual(key)) {
                if (matches.length === 1) {
                    delete this.inner[id];
                }
                else {
                    matches.splice(i, 1);
                }
                return true;
            }
        }
        return false;
    };
    ObjectMap.prototype.forEach = function (fn) {
        forEach(this.inner, function (_, entries) {
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var _a = entries_1[_i], k = _a[0], v = _a[1];
                fn(k, v);
            }
        });
    };
    ObjectMap.prototype.isEmpty = function () {
        return isEmpty(this.inner);
    };
    return ObjectMap;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An in-memory buffer of entries to be written to a RemoteDocumentCache.
 * It can be used to batch up a set of changes to be written to the cache, but
 * additionally supports reading entries back with the `getEntry()` method,
 * falling back to the underlying RemoteDocumentCache if no entry is
 * buffered.
 *
 * Entries added to the cache *must* be read first. This is to facilitate
 * calculating the size delta of the pending changes.
 *
 * PORTING NOTE: This class was implemented then removed from other platforms.
 * If byte-counting ends up being needed on the other platforms, consider
 * porting this class as part of that implementation work.
 */
var RemoteDocumentChangeBuffer = /** @class */ (function () {
    function RemoteDocumentChangeBuffer() {
        // A mapping of document key to the new cache entry that should be written (or null if any
        // existing cache entry should be removed).
        this.changes = new ObjectMap(function (key) { return key.toString(); });
        this.changesApplied = false;
    }
    Object.defineProperty(RemoteDocumentChangeBuffer.prototype, "readTime", {
        get: function () {
            assert(this._readTime !== undefined, 'Read time is not set. All removeEntry() calls must include a readTime if `trackRemovals` is used.');
            return this._readTime;
        },
        set: function (value) {
            // Right now (for simplicity) we just track a single readTime for all the
            // added entries since we expect them to all be the same, but we could
            // rework to store per-entry readTimes if necessary.
            assert(this._readTime === undefined || this._readTime.isEqual(value), 'All changes in a RemoteDocumentChangeBuffer must have the same read time');
            this._readTime = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Buffers a `RemoteDocumentCache.addEntry()` call.
     *
     * You can only modify documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */
    RemoteDocumentChangeBuffer.prototype.addEntry = function (maybeDocument, readTime) {
        this.assertNotApplied();
        this.readTime = readTime;
        this.changes.set(maybeDocument.key, maybeDocument);
    };
    /**
     * Buffers a `RemoteDocumentCache.removeEntry()` call.
     *
     * You can only remove documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */
    RemoteDocumentChangeBuffer.prototype.removeEntry = function (key, readTime) {
        this.assertNotApplied();
        if (readTime) {
            this.readTime = readTime;
        }
        this.changes.set(key, null);
    };
    /**
     * Looks up an entry in the cache. The buffered changes will first be checked,
     * and if no buffered change applies, this will forward to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction The transaction in which to perform any persistence
     *     operations.
     * @param documentKey The key of the entry to look up.
     * @return The cached Document or NoDocument entry, or null if we have nothing
     * cached.
     */
    RemoteDocumentChangeBuffer.prototype.getEntry = function (transaction, documentKey) {
        this.assertNotApplied();
        var bufferedEntry = this.changes.get(documentKey);
        if (bufferedEntry !== undefined) {
            return PersistencePromise.resolve(bufferedEntry);
        }
        else {
            return this.getFromCache(transaction, documentKey);
        }
    };
    /**
     * Looks up several entries in the cache, forwarding to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction The transaction in which to perform any persistence
     *     operations.
     * @param documentKeys The keys of the entries to look up.
     * @return A map of cached `Document`s or `NoDocument`s, indexed by key. If an
     *     entry cannot be found, the corresponding key will be mapped to a null
     *     value.
     */
    RemoteDocumentChangeBuffer.prototype.getEntries = function (transaction, documentKeys) {
        return this.getAllFromCache(transaction, documentKeys);
    };
    /**
     * Applies buffered changes to the underlying RemoteDocumentCache, using
     * the provided transaction.
     */
    RemoteDocumentChangeBuffer.prototype.apply = function (transaction) {
        this.assertNotApplied();
        this.changesApplied = true;
        return this.applyChanges(transaction);
    };
    /** Helper to assert this.changes is not null  */
    RemoteDocumentChangeBuffer.prototype.assertNotApplied = function () {
        assert(!this.changesApplied, 'Changes have already been applied.');
    };
    return RemoteDocumentChangeBuffer;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var IndexedDbRemoteDocumentCache = /** @class */ (function () {
    /**
     * @param {LocalSerializer} serializer The document serializer.
     * @param {IndexManager} indexManager The query indexes that need to be maintained.
     */
    function IndexedDbRemoteDocumentCache(serializer, indexManager) {
        this.serializer = serializer;
        this.indexManager = indexManager;
    }
    /**
     * Adds the supplied entries to the cache.
     *
     * All calls of `addEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */
    IndexedDbRemoteDocumentCache.prototype.addEntry = function (transaction, key, doc) {
        var documentStore = remoteDocumentsStore(transaction);
        return documentStore.put(dbKey(key), doc);
    };
    /**
     * Removes a document from the cache.
     *
     * All calls of `removeEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */
    IndexedDbRemoteDocumentCache.prototype.removeEntry = function (transaction, documentKey) {
        var store = remoteDocumentsStore(transaction);
        var key = dbKey(documentKey);
        return store.delete(key);
    };
    /**
     * Updates the current cache size.
     *
     * Callers to `addEntry()` and `removeEntry()` *must* call this afterwards to update the
     * cache's metadata.
     */
    IndexedDbRemoteDocumentCache.prototype.updateMetadata = function (transaction, sizeDelta) {
        var _this = this;
        return this.getMetadata(transaction).next(function (metadata) {
            metadata.byteSize += sizeDelta;
            return _this.setMetadata(transaction, metadata);
        });
    };
    IndexedDbRemoteDocumentCache.prototype.getEntry = function (transaction, documentKey) {
        var _this = this;
        return remoteDocumentsStore(transaction)
            .get(dbKey(documentKey))
            .next(function (dbRemoteDoc) {
            return _this.maybeDecodeDocument(dbRemoteDoc);
        });
    };
    /**
     * Looks up an entry in the cache.
     *
     * @param documentKey The key of the entry to look up.
     * @return The cached MaybeDocument entry and its size, or null if we have nothing cached.
     */
    IndexedDbRemoteDocumentCache.prototype.getSizedEntry = function (transaction, documentKey) {
        var _this = this;
        return remoteDocumentsStore(transaction)
            .get(dbKey(documentKey))
            .next(function (dbRemoteDoc) {
            var doc = _this.maybeDecodeDocument(dbRemoteDoc);
            return doc
                ? {
                    maybeDocument: doc,
                    size: dbDocumentSize(dbRemoteDoc)
                }
                : null;
        });
    };
    IndexedDbRemoteDocumentCache.prototype.getEntries = function (transaction, documentKeys) {
        var _this = this;
        var results = nullableMaybeDocumentMap();
        return this.forEachDbEntry(transaction, documentKeys, function (key, dbRemoteDoc) {
            var doc = _this.maybeDecodeDocument(dbRemoteDoc);
            results = results.insert(key, doc);
        }).next(function () { return results; });
    };
    /**
     * Looks up several entries in the cache.
     *
     * @param documentKeys The set of keys entries to look up.
     * @return A map of MaybeDocuments indexed by key (if a document cannot be
     *     found, the key will be mapped to null) and a map of sizes indexed by
     *     key (zero if the key cannot be found).
     */
    IndexedDbRemoteDocumentCache.prototype.getSizedEntries = function (transaction, documentKeys) {
        var _this = this;
        var results = nullableMaybeDocumentMap();
        var sizeMap = new SortedMap(DocumentKey.comparator);
        return this.forEachDbEntry(transaction, documentKeys, function (key, dbRemoteDoc) {
            var doc = _this.maybeDecodeDocument(dbRemoteDoc);
            if (doc) {
                results = results.insert(key, doc);
                sizeMap = sizeMap.insert(key, dbDocumentSize(dbRemoteDoc));
            }
            else {
                results = results.insert(key, null);
                sizeMap = sizeMap.insert(key, 0);
            }
        }).next(function () {
            return { maybeDocuments: results, sizeMap: sizeMap };
        });
    };
    IndexedDbRemoteDocumentCache.prototype.forEachDbEntry = function (transaction, documentKeys, callback) {
        if (documentKeys.isEmpty()) {
            return PersistencePromise.resolve();
        }
        var range = IDBKeyRange.bound(documentKeys.first().path.toArray(), documentKeys.last().path.toArray());
        var keyIter = documentKeys.getIterator();
        var nextKey = keyIter.getNext();
        return remoteDocumentsStore(transaction)
            .iterate({ range: range }, function (potentialKeyRaw, dbRemoteDoc, control) {
            var potentialKey = DocumentKey.fromSegments(potentialKeyRaw);
            // Go through keys not found in cache.
            while (nextKey && DocumentKey.comparator(nextKey, potentialKey) < 0) {
                callback(nextKey, null);
                nextKey = keyIter.getNext();
            }
            if (nextKey && nextKey.isEqual(potentialKey)) {
                // Key found in cache.
                callback(nextKey, dbRemoteDoc);
                nextKey = keyIter.hasNext() ? keyIter.getNext() : null;
            }
            // Skip to the next key (if there is one).
            if (nextKey) {
                control.skip(nextKey.path.toArray());
            }
            else {
                control.done();
            }
        })
            .next(function () {
            // The rest of the keys are not in the cache. One case where `iterate`
            // above won't go through them is when the cache is empty.
            while (nextKey) {
                callback(nextKey, null);
                nextKey = keyIter.hasNext() ? keyIter.getNext() : null;
            }
        });
    };
    IndexedDbRemoteDocumentCache.prototype.getDocumentsMatchingQuery = function (transaction, query, sinceReadTime) {
        var _this = this;
        assert(!query.isCollectionGroupQuery(), 'CollectionGroup queries should be handled in LocalDocumentsView');
        var results = documentMap();
        var immediateChildrenPathLength = query.path.length + 1;
        var iterationOptions = {};
        if (sinceReadTime.isEqual(SnapshotVersion.MIN)) {
            // Documents are ordered by key, so we can use a prefix scan to narrow
            // down the documents we need to match the query against.
            var startKey = query.path.toArray();
            iterationOptions.range = IDBKeyRange.lowerBound(startKey);
        }
        else {
            // Execute an index-free query and filter by read time. This is safe
            // since all document changes to queries that have a
            // lastLimboFreeSnapshotVersion (`sinceReadTime`) have a read time set.
            var collectionKey = query.path.toArray();
            var readTimeKey = this.serializer.toDbTimestampKey(sinceReadTime);
            iterationOptions.range = IDBKeyRange.lowerBound([collectionKey, readTimeKey], 
            /* open= */ true);
            iterationOptions.index = DbRemoteDocument.collectionReadTimeIndex;
        }
        return remoteDocumentsStore(transaction)
            .iterate(iterationOptions, function (key, dbRemoteDoc, control) {
            // The query is actually returning any path that starts with the query
            // path prefix which may include documents in subcollections. For
            // example, a query on 'rooms' will return rooms/abc/messages/xyx but we
            // shouldn't match it. Fix this by discarding rows with document keys
            // more than one segment longer than the query path.
            if (key.length !== immediateChildrenPathLength) {
                return;
            }
            var maybeDoc = _this.serializer.fromDbRemoteDocument(dbRemoteDoc);
            if (!query.path.isPrefixOf(maybeDoc.key.path)) {
                control.done();
            }
            else if (maybeDoc instanceof Document && query.matches(maybeDoc)) {
                results = results.insert(maybeDoc.key, maybeDoc);
            }
        })
            .next(function () { return results; });
    };
    /**
     * Returns the set of documents that have been updated since the specified read
     * time.
     */
    // PORTING NOTE: This is only used for multi-tab synchronization.
    IndexedDbRemoteDocumentCache.prototype.getNewDocumentChanges = function (transaction, sinceReadTime) {
        var _this = this;
        var changedDocs = maybeDocumentMap();
        var lastReadTime = this.serializer.toDbTimestampKey(sinceReadTime);
        var documentsStore = remoteDocumentsStore(transaction);
        var range = IDBKeyRange.lowerBound(lastReadTime, true);
        return documentsStore
            .iterate({ index: DbRemoteDocument.readTimeIndex, range: range }, function (_, dbRemoteDoc) {
            // Unlike `getEntry()` and others, `getNewDocumentChanges()` parses
            // the documents directly since we want to keep sentinel deletes.
            var doc = _this.serializer.fromDbRemoteDocument(dbRemoteDoc);
            changedDocs = changedDocs.insert(doc.key, doc);
            lastReadTime = dbRemoteDoc.readTime;
        })
            .next(function () {
            return {
                changedDocs: changedDocs,
                readTime: _this.serializer.fromDbTimestampKey(lastReadTime)
            };
        });
    };
    /**
     * Returns the last document that has changed, as well as the read time of the
     * last change. If no document has changed, returns SnapshotVersion.MIN.
     */
    // PORTING NOTE: This is only used for multi-tab synchronization.
    IndexedDbRemoteDocumentCache.prototype.getLastDocumentChange = function (transaction) {
        var _this = this;
        var documentsStore = remoteDocumentsStore(transaction);
        // If there are no existing entries, we return SnapshotVersion.MIN.
        var readTime = SnapshotVersion.MIN;
        var changedDoc;
        return documentsStore
            .iterate({ index: DbRemoteDocument.readTimeIndex, reverse: true }, function (key, dbRemoteDoc, control) {
            changedDoc = _this.serializer.fromDbRemoteDocument(dbRemoteDoc);
            if (dbRemoteDoc.readTime) {
                readTime = _this.serializer.fromDbTimestampKey(dbRemoteDoc.readTime);
            }
            control.done();
        })
            .next(function () {
            return { changedDoc: changedDoc, readTime: readTime };
        });
    };
    IndexedDbRemoteDocumentCache.prototype.newChangeBuffer = function (options) {
        return new IndexedDbRemoteDocumentCache.RemoteDocumentChangeBuffer(this, !!options && options.trackRemovals);
    };
    IndexedDbRemoteDocumentCache.prototype.getSize = function (txn) {
        return this.getMetadata(txn).next(function (metadata) { return metadata.byteSize; });
    };
    IndexedDbRemoteDocumentCache.prototype.getMetadata = function (txn) {
        return documentGlobalStore(txn)
            .get(DbRemoteDocumentGlobal.key)
            .next(function (metadata) {
            assert(!!metadata, 'Missing document cache metadata');
            return metadata;
        });
    };
    IndexedDbRemoteDocumentCache.prototype.setMetadata = function (txn, metadata) {
        return documentGlobalStore(txn).put(DbRemoteDocumentGlobal.key, metadata);
    };
    /**
     * Decodes `remoteDoc` and returns the document (or null, if the document
     * corresponds to the format used for sentinel deletes).
     */
    IndexedDbRemoteDocumentCache.prototype.maybeDecodeDocument = function (dbRemoteDoc) {
        if (dbRemoteDoc) {
            var doc = this.serializer.fromDbRemoteDocument(dbRemoteDoc);
            if (doc instanceof NoDocument &&
                doc.version.isEqual(SnapshotVersion.forDeletedDoc())) {
                // The document is a sentinel removal and should only be used in the
                // `getNewDocumentChanges()`.
                return null;
            }
            return doc;
        }
        return null;
    };
    /**
     * Handles the details of adding and updating documents in the IndexedDbRemoteDocumentCache.
     *
     * Unlike the MemoryRemoteDocumentChangeBuffer, the IndexedDb implementation computes the size
     * delta for all submitted changes. This avoids having to re-read all documents from IndexedDb
     * when we apply the changes.
     */
    IndexedDbRemoteDocumentCache.RemoteDocumentChangeBuffer = /** @class */ (function (_super) {
        tslib.__extends(class_1, _super);
        /**
         * @param documentCache The IndexedDbRemoteDocumentCache to apply the changes to.
         * @param trackRemovals Whether to create sentinel deletes that can be tracked by
         * `getNewDocumentChanges()`.
         */
        function class_1(documentCache, trackRemovals) {
            var _this = _super.call(this) || this;
            _this.documentCache = documentCache;
            _this.trackRemovals = trackRemovals;
            // A map of document sizes prior to applying the changes in this buffer.
            _this.documentSizes = new ObjectMap(function (key) { return key.toString(); });
            return _this;
        }
        class_1.prototype.applyChanges = function (transaction) {
            var _this = this;
            var promises = [];
            var sizeDelta = 0;
            var collectionParents = new SortedSet(function (l, r) {
                return primitiveComparator(l.canonicalString(), r.canonicalString());
            });
            this.changes.forEach(function (key, maybeDocument) {
                var previousSize = _this.documentSizes.get(key);
                assert(previousSize !== undefined, "Cannot modify a document that wasn't read (for " + key + ")");
                if (maybeDocument) {
                    assert(!_this.readTime.isEqual(SnapshotVersion.MIN), 'Cannot add a document with a read time of zero');
                    var doc = _this.documentCache.serializer.toDbRemoteDocument(maybeDocument, _this.readTime);
                    collectionParents = collectionParents.add(key.path.popLast());
                    var size = dbDocumentSize(doc);
                    sizeDelta += size - previousSize;
                    promises.push(_this.documentCache.addEntry(transaction, key, doc));
                }
                else {
                    sizeDelta -= previousSize;
                    if (_this.trackRemovals) {
                        // In order to track removals, we store a "sentinel delete" in the
                        // RemoteDocumentCache. This entry is represented by a NoDocument
                        // with a version of 0 and ignored by `maybeDecodeDocument()` but
                        // preserved in `getNewDocumentChanges()`.
                        var deletedDoc = _this.documentCache.serializer.toDbRemoteDocument(new NoDocument(key, SnapshotVersion.forDeletedDoc()), _this.readTime);
                        promises.push(_this.documentCache.addEntry(transaction, key, deletedDoc));
                    }
                    else {
                        promises.push(_this.documentCache.removeEntry(transaction, key));
                    }
                }
            });
            collectionParents.forEach(function (parent) {
                promises.push(_this.documentCache.indexManager.addToCollectionParentIndex(transaction, parent));
            });
            promises.push(this.documentCache.updateMetadata(transaction, sizeDelta));
            return PersistencePromise.waitFor(promises);
        };
        class_1.prototype.getFromCache = function (transaction, documentKey) {
            var _this = this;
            // Record the size of everything we load from the cache so we can compute a delta later.
            return this.documentCache
                .getSizedEntry(transaction, documentKey)
                .next(function (getResult) {
                if (getResult === null) {
                    _this.documentSizes.set(documentKey, 0);
                    return null;
                }
                else {
                    _this.documentSizes.set(documentKey, getResult.size);
                    return getResult.maybeDocument;
                }
            });
        };
        class_1.prototype.getAllFromCache = function (transaction, documentKeys) {
            var _this = this;
            // Record the size of everything we load from the cache so we can compute
            // a delta later.
            return this.documentCache
                .getSizedEntries(transaction, documentKeys)
                .next(function (_a) {
                var maybeDocuments = _a.maybeDocuments, sizeMap = _a.sizeMap;
                // Note: `getAllFromCache` returns two maps instead of a single map from
                // keys to `DocumentSizeEntry`s. This is to allow returning the
                // `NullableMaybeDocumentMap` directly, without a conversion.
                sizeMap.forEach(function (documentKey, size) {
                    _this.documentSizes.set(documentKey, size);
                });
                return maybeDocuments;
            });
        };
        return class_1;
    }(RemoteDocumentChangeBuffer));
    return IndexedDbRemoteDocumentCache;
}());
function documentGlobalStore(txn) {
    return IndexedDbPersistence.getStore(txn, DbRemoteDocumentGlobal.store);
}
/**
 * Helper to get a typed SimpleDbStore for the remoteDocuments object store.
 */
function remoteDocumentsStore(txn) {
    return IndexedDbPersistence.getStore(txn, DbRemoteDocument.store);
}
function dbKey(docKey) {
    return docKey.path.toArray();
}
/**
 * Retrusn an approximate size for the given document.
 */
function dbDocumentSize(doc) {
    var value;
    if (doc.document) {
        value = doc.document;
    }
    else if (doc.unknownDocument) {
        value = doc.unknownDocument;
    }
    else if (doc.noDocument) {
        value = doc.noDocument;
    }
    else {
        throw fail('Unknown remote document type');
    }
    return JSON.stringify(value).length;
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An in-memory implementation of IndexManager.
 */
var MemoryIndexManager = /** @class */ (function () {
    function MemoryIndexManager() {
        this.collectionParentIndex = new MemoryCollectionParentIndex();
    }
    MemoryIndexManager.prototype.addToCollectionParentIndex = function (transaction, collectionPath) {
        this.collectionParentIndex.add(collectionPath);
        return PersistencePromise.resolve();
    };
    MemoryIndexManager.prototype.getCollectionParents = function (transaction, collectionId) {
        return PersistencePromise.resolve(this.collectionParentIndex.getEntries(collectionId));
    };
    return MemoryIndexManager;
}());
/**
 * Internal implementation of the collection-parent index exposed by MemoryIndexManager.
 * Also used for in-memory caching by IndexedDbIndexManager and initial index population
 * in indexeddb_schema.ts
 */
var MemoryCollectionParentIndex = /** @class */ (function () {
    function MemoryCollectionParentIndex() {
        this.index = {};
    }
    // Returns false if the entry already existed.
    MemoryCollectionParentIndex.prototype.add = function (collectionPath) {
        assert(collectionPath.length % 2 === 1, 'Expected a collection path.');
        var collectionId = collectionPath.lastSegment();
        var parentPath = collectionPath.popLast();
        var existingParents = this.index[collectionId] ||
            new SortedSet(ResourcePath.comparator);
        var added = !existingParents.has(parentPath);
        this.index[collectionId] = existingParents.add(parentPath);
        return added;
    };
    MemoryCollectionParentIndex.prototype.has = function (collectionPath) {
        var collectionId = collectionPath.lastSegment();
        var parentPath = collectionPath.popLast();
        var existingParents = this.index[collectionId];
        return existingParents && existingParents.has(parentPath);
    };
    MemoryCollectionParentIndex.prototype.getEntries = function (collectionId) {
        var parentPaths = this.index[collectionId] ||
            new SortedSet(ResourcePath.comparator);
        return parentPaths.toArray();
    };
    return MemoryCollectionParentIndex;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Schema Version for the Web client:
 * 1. Initial version including Mutation Queue, Query Cache, and Remote Document
 *    Cache
 * 2. Used to ensure a targetGlobal object exists and add targetCount to it. No
 *    longer required because migration 3 unconditionally clears it.
 * 3. Dropped and re-created Query Cache to deal with cache corruption related
 *    to limbo resolution. Addresses
 *    https://github.com/firebase/firebase-ios-sdk/issues/1548
 * 4. Multi-Tab Support.
 * 5. Removal of held write acks.
 * 6. Create document global for tracking document cache size.
 * 7. Ensure every cached document has a sentinel row with a sequence number.
 * 8. Add collection-parent index for Collection Group queries.
 * 9. Change RemoteDocumentChanges store to be keyed by readTime rather than
 *    an auto-incrementing ID. This is required for Index-Free queries.
 */
var SCHEMA_VERSION = 9;
/** Performs database creation and schema upgrades. */
var SchemaConverter = /** @class */ (function () {
    function SchemaConverter(serializer) {
        this.serializer = serializer;
    }
    /**
     * Performs database creation and schema upgrades.
     *
     * Note that in production, this method is only ever used to upgrade the schema
     * to SCHEMA_VERSION. Different values of toVersion are only used for testing
     * and local feature development.
     */
    SchemaConverter.prototype.createOrUpgrade = function (db, txn, fromVersion, toVersion) {
        var _this = this;
        assert(fromVersion < toVersion &&
            fromVersion >= 0 &&
            toVersion <= SCHEMA_VERSION, "Unexpected schema upgrade from v" + fromVersion + " to v{toVersion}.");
        var simpleDbTransaction = new SimpleDbTransaction(txn);
        if (fromVersion < 1 && toVersion >= 1) {
            createPrimaryClientStore(db);
            createMutationQueue(db);
            createQueryCache(db);
            createRemoteDocumentCache(db);
        }
        // Migration 2 to populate the targetGlobal object no longer needed since
        // migration 3 unconditionally clears it.
        var p = PersistencePromise.resolve();
        if (fromVersion < 3 && toVersion >= 3) {
            // Brand new clients don't need to drop and recreate--only clients that
            // potentially have corrupt data.
            if (fromVersion !== 0) {
                dropQueryCache(db);
                createQueryCache(db);
            }
            p = p.next(function () { return writeEmptyTargetGlobalEntry(simpleDbTransaction); });
        }
        if (fromVersion < 4 && toVersion >= 4) {
            if (fromVersion !== 0) {
                // Schema version 3 uses auto-generated keys to generate globally unique
                // mutation batch IDs (this was previously ensured internally by the
                // client). To migrate to the new schema, we have to read all mutations
                // and write them back out. We preserve the existing batch IDs to guarantee
                // consistency with other object stores. Any further mutation batch IDs will
                // be auto-generated.
                p = p.next(function () {
                    return upgradeMutationBatchSchemaAndMigrateData(db, simpleDbTransaction);
                });
            }
            p = p.next(function () {
                createClientMetadataStore(db);
            });
        }
        if (fromVersion < 5 && toVersion >= 5) {
            p = p.next(function () { return _this.removeAcknowledgedMutations(simpleDbTransaction); });
        }
        if (fromVersion < 6 && toVersion >= 6) {
            p = p.next(function () {
                createDocumentGlobalStore(db);
                return _this.addDocumentGlobal(simpleDbTransaction);
            });
        }
        if (fromVersion < 7 && toVersion >= 7) {
            p = p.next(function () { return _this.ensureSequenceNumbers(simpleDbTransaction); });
        }
        if (fromVersion < 8 && toVersion >= 8) {
            p = p.next(function () {
                return _this.createCollectionParentIndex(db, simpleDbTransaction);
            });
        }
        if (fromVersion < 9 && toVersion >= 9) {
            p = p.next(function () {
                // Multi-Tab used to manage its own changelog, but this has been moved
                // to the DbRemoteDocument object store itself. Since the previous change
                // log only contained transient data, we can drop its object store.
                dropRemoteDocumentChangesStore(db);
                createRemoteDocumentReadTimeIndex(txn);
            });
        }
        return p;
    };
    SchemaConverter.prototype.addDocumentGlobal = function (txn) {
        var byteCount = 0;
        return txn
            .store(DbRemoteDocument.store)
            .iterate(function (_, doc) {
            byteCount += dbDocumentSize(doc);
        })
            .next(function () {
            var metadata = new DbRemoteDocumentGlobal(byteCount);
            return txn
                .store(DbRemoteDocumentGlobal.store)
                .put(DbRemoteDocumentGlobal.key, metadata);
        });
    };
    SchemaConverter.prototype.removeAcknowledgedMutations = function (txn) {
        var _this = this;
        var queuesStore = txn.store(DbMutationQueue.store);
        var mutationsStore = txn.store(DbMutationBatch.store);
        return queuesStore.loadAll().next(function (queues) {
            return PersistencePromise.forEach(queues, function (queue) {
                var range = IDBKeyRange.bound([queue.userId, BATCHID_UNKNOWN], [queue.userId, queue.lastAcknowledgedBatchId]);
                return mutationsStore
                    .loadAll(DbMutationBatch.userMutationsIndex, range)
                    .next(function (dbBatches) {
                    return PersistencePromise.forEach(dbBatches, function (dbBatch) {
                        assert(dbBatch.userId === queue.userId, "Cannot process batch " + dbBatch.batchId + " from unexpected user");
                        var batch = _this.serializer.fromDbMutationBatch(dbBatch);
                        return removeMutationBatch(txn, queue.userId, batch).next(function () { });
                    });
                });
            });
        });
    };
    /**
     * Ensures that every document in the remote document cache has a corresponding sentinel row
     * with a sequence number. Missing rows are given the most recently used sequence number.
     */
    SchemaConverter.prototype.ensureSequenceNumbers = function (txn) {
        var documentTargetStore = txn.store(DbTargetDocument.store);
        var documentsStore = txn.store(DbRemoteDocument.store);
        return getHighestListenSequenceNumber(txn).next(function (currentSequenceNumber) {
            var writeSentinelKey = function (path) {
                return documentTargetStore.put(new DbTargetDocument(0, encode(path), currentSequenceNumber));
            };
            var promises = [];
            return documentsStore
                .iterate(function (key, doc) {
                var path = new ResourcePath(key);
                var docSentinelKey = sentinelKey(path);
                promises.push(documentTargetStore.get(docSentinelKey).next(function (maybeSentinel) {
                    if (!maybeSentinel) {
                        return writeSentinelKey(path);
                    }
                    else {
                        return PersistencePromise.resolve();
                    }
                }));
            })
                .next(function () { return PersistencePromise.waitFor(promises); });
        });
    };
    SchemaConverter.prototype.createCollectionParentIndex = function (db, txn) {
        // Create the index.
        db.createObjectStore(DbCollectionParent.store, {
            keyPath: DbCollectionParent.keyPath
        });
        var collectionParentsStore = txn.store(DbCollectionParent.store);
        // Helper to add an index entry iff we haven't already written it.
        var cache = new MemoryCollectionParentIndex();
        var addEntry = function (collectionPath) {
            if (cache.add(collectionPath)) {
                var collectionId = collectionPath.lastSegment();
                var parentPath = collectionPath.popLast();
                return collectionParentsStore.put({
                    collectionId: collectionId,
                    parent: encode(parentPath)
                });
            }
        };
        // Index existing remote documents.
        return txn
            .store(DbRemoteDocument.store)
            .iterate({ keysOnly: true }, function (pathSegments, _) {
            var path = new ResourcePath(pathSegments);
            return addEntry(path.popLast());
        })
            .next(function () {
            // Index existing mutations.
            return txn
                .store(DbDocumentMutation.store)
                .iterate({ keysOnly: true }, function (_a, _) {
                var userID = _a[0], encodedPath = _a[1], batchId = _a[2];
                var path = decode(encodedPath);
                return addEntry(path.popLast());
            });
        });
    };
    return SchemaConverter;
}());
function sentinelKey(path) {
    return [0, encode(path)];
}
/**
 * Wrapper class to store timestamps (seconds and nanos) in IndexedDb objects.
 */
var DbTimestamp = /** @class */ (function () {
    function DbTimestamp(seconds, nanoseconds) {
        this.seconds = seconds;
        this.nanoseconds = nanoseconds;
    }
    return DbTimestamp;
}());
/**
 * A singleton object to be stored in the 'owner' store in IndexedDb.
 *
 * A given database can have a single primary tab assigned at a given time. That
 * tab must validate that it is still holding the primary lease before every
 * operation that requires locked access. The primary tab should regularly
 * write an updated timestamp to this lease to prevent other tabs from
 * "stealing" the primary lease
 */
var DbPrimaryClient = /** @class */ (function () {
    function DbPrimaryClient(ownerId, 
    /** Whether to allow shared access from multiple tabs. */
    allowTabSynchronization, leaseTimestampMs) {
        this.ownerId = ownerId;
        this.allowTabSynchronization = allowTabSynchronization;
        this.leaseTimestampMs = leaseTimestampMs;
    }
    /**
     * Name of the IndexedDb object store.
     *
     * Note that the name 'owner' is chosen to ensure backwards compatibility with
     * older clients that only supported single locked access to the persistence
     * layer.
     */
    DbPrimaryClient.store = 'owner';
    /**
     * The key string used for the single object that exists in the
     * DbPrimaryClient store.
     */
    DbPrimaryClient.key = 'owner';
    return DbPrimaryClient;
}());
function createPrimaryClientStore(db) {
    db.createObjectStore(DbPrimaryClient.store);
}
/**
 * An object to be stored in the 'mutationQueues' store in IndexedDb.
 *
 * Each user gets a single queue of MutationBatches to apply to the server.
 * DbMutationQueue tracks the metadata about the queue.
 */
var DbMutationQueue = /** @class */ (function () {
    function DbMutationQueue(
    /**
     * The normalized user ID to which this queue belongs.
     */
    userId, 
    /**
     * An identifier for the highest numbered batch that has been acknowledged
     * by the server. All MutationBatches in this queue with batchIds less
     * than or equal to this value are considered to have been acknowledged by
     * the server.
     *
     * NOTE: this is deprecated and no longer used by the code.
     */
    lastAcknowledgedBatchId, 
    /**
     * A stream token that was previously sent by the server.
     *
     * See StreamingWriteRequest in datastore.proto for more details about
     * usage.
     *
     * After sending this token, earlier tokens may not be used anymore so
     * only a single stream token is retained.
     */
    lastStreamToken) {
        this.userId = userId;
        this.lastAcknowledgedBatchId = lastAcknowledgedBatchId;
        this.lastStreamToken = lastStreamToken;
    }
    /** Name of the IndexedDb object store.  */
    DbMutationQueue.store = 'mutationQueues';
    /** Keys are automatically assigned via the userId property. */
    DbMutationQueue.keyPath = 'userId';
    return DbMutationQueue;
}());
/**
 * An object to be stored in the 'mutations' store in IndexedDb.
 *
 * Represents a batch of user-level mutations intended to be sent to the server
 * in a single write. Each user-level batch gets a separate DbMutationBatch
 * with a new batchId.
 */
var DbMutationBatch = /** @class */ (function () {
    function DbMutationBatch(
    /**
     * The normalized user ID to which this batch belongs.
     */
    userId, 
    /**
     * An identifier for this batch, allocated using an auto-generated key.
     */
    batchId, 
    /**
     * The local write time of the batch, stored as milliseconds since the
     * epoch.
     */
    localWriteTimeMs, 
    /**
     * A list of "mutations" that represent a partial base state from when this
     * write batch was initially created. During local application of the write
     * batch, these baseMutations are applied prior to the real writes in order
     * to override certain document fields from the remote document cache. This
     * is necessary in the case of non-idempotent writes (e.g. `increment()`
     * transforms) to make sure that the local view of the modified documents
     * doesn't flicker if the remote document cache receives the result of the
     * non-idempotent write before the write is removed from the queue.
     *
     * These mutations are never sent to the backend.
     */
    baseMutations, 
    /**
     * A list of mutations to apply. All mutations will be applied atomically.
     *
     * Mutations are serialized via JsonProtoSerializer.toMutation().
     */
    mutations) {
        this.userId = userId;
        this.batchId = batchId;
        this.localWriteTimeMs = localWriteTimeMs;
        this.baseMutations = baseMutations;
        this.mutations = mutations;
    }
    /** Name of the IndexedDb object store.  */
    DbMutationBatch.store = 'mutations';
    /** Keys are automatically assigned via the userId, batchId properties. */
    DbMutationBatch.keyPath = 'batchId';
    /** The index name for lookup of mutations by user. */
    DbMutationBatch.userMutationsIndex = 'userMutationsIndex';
    /** The user mutations index is keyed by [userId, batchId] pairs. */
    DbMutationBatch.userMutationsKeyPath = ['userId', 'batchId'];
    return DbMutationBatch;
}());
function createMutationQueue(db) {
    db.createObjectStore(DbMutationQueue.store, {
        keyPath: DbMutationQueue.keyPath
    });
    var mutationBatchesStore = db.createObjectStore(DbMutationBatch.store, {
        keyPath: DbMutationBatch.keyPath,
        autoIncrement: true
    });
    mutationBatchesStore.createIndex(DbMutationBatch.userMutationsIndex, DbMutationBatch.userMutationsKeyPath, { unique: true });
    db.createObjectStore(DbDocumentMutation.store);
}
/**
 * Upgrade function to migrate the 'mutations' store from V1 to V3. Loads
 * and rewrites all data.
 */
function upgradeMutationBatchSchemaAndMigrateData(db, txn) {
    var v1MutationsStore = txn.store(DbMutationBatch.store);
    return v1MutationsStore.loadAll().next(function (existingMutations) {
        db.deleteObjectStore(DbMutationBatch.store);
        var mutationsStore = db.createObjectStore(DbMutationBatch.store, {
            keyPath: DbMutationBatch.keyPath,
            autoIncrement: true
        });
        mutationsStore.createIndex(DbMutationBatch.userMutationsIndex, DbMutationBatch.userMutationsKeyPath, { unique: true });
        var v3MutationsStore = txn.store(DbMutationBatch.store);
        var writeAll = existingMutations.map(function (mutation) {
            return v3MutationsStore.put(mutation);
        });
        return PersistencePromise.waitFor(writeAll);
    });
}
/**
 * An object to be stored in the 'documentMutations' store in IndexedDb.
 *
 * A manually maintained index of all the mutation batches that affect a given
 * document key. The rows in this table are references based on the contents of
 * DbMutationBatch.mutations.
 */
var DbDocumentMutation = /** @class */ (function () {
    function DbDocumentMutation() {
    }
    /**
     * Creates a [userId] key for use in the DbDocumentMutations index to iterate
     * over all of a user's document mutations.
     */
    DbDocumentMutation.prefixForUser = function (userId) {
        return [userId];
    };
    /**
     * Creates a [userId, encodedPath] key for use in the DbDocumentMutations
     * index to iterate over all at document mutations for a given path or lower.
     */
    DbDocumentMutation.prefixForPath = function (userId, path) {
        return [userId, encode(path)];
    };
    /**
     * Creates a full index key of [userId, encodedPath, batchId] for inserting
     * and deleting into the DbDocumentMutations index.
     */
    DbDocumentMutation.key = function (userId, path, batchId) {
        return [userId, encode(path), batchId];
    };
    DbDocumentMutation.store = 'documentMutations';
    /**
     * Because we store all the useful information for this store in the key,
     * there is no useful information to store as the value. The raw (unencoded)
     * path cannot be stored because IndexedDb doesn't store prototype
     * information.
     */
    DbDocumentMutation.PLACEHOLDER = new DbDocumentMutation();
    return DbDocumentMutation;
}());
function createRemoteDocumentCache(db) {
    db.createObjectStore(DbRemoteDocument.store);
}
/**
 * Represents the known absence of a document at a particular version.
 * Stored in IndexedDb as part of a DbRemoteDocument object.
 */
var DbNoDocument = /** @class */ (function () {
    function DbNoDocument(path, readTime) {
        this.path = path;
        this.readTime = readTime;
    }
    return DbNoDocument;
}());
/**
 * Represents a document that is known to exist but whose data is unknown.
 * Stored in IndexedDb as part of a DbRemoteDocument object.
 */
var DbUnknownDocument = /** @class */ (function () {
    function DbUnknownDocument(path, version) {
        this.path = path;
        this.version = version;
    }
    return DbUnknownDocument;
}());
/**
 * An object to be stored in the 'remoteDocuments' store in IndexedDb.
 * It represents either:
 *
 * - A complete document.
 * - A "no document" representing a document that is known not to exist (at
 * some version).
 * - An "unknown document" representing a document that is known to exist (at
 * some version) but whose contents are unknown.
 *
 * Note: This is the persisted equivalent of a MaybeDocument and could perhaps
 * be made more general if necessary.
 */
var DbRemoteDocument = /** @class */ (function () {
    // TODO: We are currently storing full document keys almost three times
    // (once as part of the primary key, once - partly - as `parentPath` and once
    // inside the encoded documents). During our next migration, we should
    // rewrite the primary key as parentPath + document ID which would allow us
    // to drop one value.
    function DbRemoteDocument(
    /**
     * Set to an instance of DbUnknownDocument if the data for a document is
     * not known, but it is known that a document exists at the specified
     * version (e.g. it had a successful update applied to it)
     */
    unknownDocument, 
    /**
     * Set to an instance of a DbNoDocument if it is known that no document
     * exists.
     */
    noDocument, 
    /**
     * Set to an instance of a Document if there's a cached version of the
     * document.
     */
    document, 
    /**
     * Documents that were written to the remote document store based on
     * a write acknowledgment are marked with `hasCommittedMutations`. These
     * documents are potentially inconsistent with the backend's copy and use
     * the write's commit version as their document version.
     */
    hasCommittedMutations, 
    /**
     * When the document was read from the backend. Undefined for data written
     * prior to schema version 9.
     */
    readTime, 
    /**
     * The path of the collection this document is part of. Undefined for data
     * written prior to schema version 9.
     */
    parentPath) {
        this.unknownDocument = unknownDocument;
        this.noDocument = noDocument;
        this.document = document;
        this.hasCommittedMutations = hasCommittedMutations;
        this.readTime = readTime;
        this.parentPath = parentPath;
    }
    DbRemoteDocument.store = 'remoteDocuments';
    /**
     * An index that provides access to all entries sorted by read time (which
     * corresponds to the last modification time of each row).
     *
     * This index is used to provide a changelog for Multi-Tab.
     */
    DbRemoteDocument.readTimeIndex = 'readTimeIndex';
    DbRemoteDocument.readTimeIndexPath = 'readTime';
    /**
     * An index that provides access to documents in a collection sorted by read
     * time.
     *
     * This index is used to allow the RemoteDocumentCache to fetch newly changed
     * documents in a collection.
     */
    DbRemoteDocument.collectionReadTimeIndex = 'collectionReadTimeIndex';
    DbRemoteDocument.collectionReadTimeIndexPath = ['parentPath', 'readTime'];
    return DbRemoteDocument;
}());
/**
 * Contains a single entry that has metadata about the remote document cache.
 */
var DbRemoteDocumentGlobal = /** @class */ (function () {
    /**
     * @param byteSize Approximately the total size in bytes of all the documents in the document
     * cache.
     */
    function DbRemoteDocumentGlobal(byteSize) {
        this.byteSize = byteSize;
    }
    DbRemoteDocumentGlobal.store = 'remoteDocumentGlobal';
    DbRemoteDocumentGlobal.key = 'remoteDocumentGlobalKey';
    return DbRemoteDocumentGlobal;
}());
function createDocumentGlobalStore(db) {
    db.createObjectStore(DbRemoteDocumentGlobal.store);
}
/**
 * An object to be stored in the 'targets' store in IndexedDb.
 *
 * This is based on and should be kept in sync with the proto used in the iOS
 * client.
 *
 * Each query the client listens to against the server is tracked on disk so
 * that the query can be efficiently resumed on restart.
 */
var DbTarget = /** @class */ (function () {
    function DbTarget(
    /**
     * An auto-generated sequential numeric identifier for the query.
     *
     * Queries are stored using their canonicalId as the key, but these
     * canonicalIds can be quite long so we additionally assign a unique
     * queryId which can be used by referenced data structures (e.g.
     * indexes) to minimize the on-disk cost.
     */
    targetId, 
    /**
     * The canonical string representing this query. This is not unique.
     */
    canonicalId, 
    /**
     * The last readTime received from the Watch Service for this query.
     *
     * This is the same value as TargetChange.read_time in the protos.
     */
    readTime, 
    /**
     * An opaque, server-assigned token that allows watching a query to be
     * resumed after disconnecting without retransmitting all the data
     * that matches the query. The resume token essentially identifies a
     * point in time from which the server should resume sending results.
     *
     * This is related to the snapshotVersion in that the resumeToken
     * effectively also encodes that value, but the resumeToken is opaque
     * and sometimes encodes additional information.
     *
     * A consequence of this is that the resumeToken should be used when
     * asking the server to reason about where this client is in the watch
     * stream, but the client should use the snapshotVersion for its own
     * purposes.
     *
     * This is the same value as TargetChange.resume_token in the protos.
     */
    resumeToken, 
    /**
     * A sequence number representing the last time this query was
     * listened to, used for garbage collection purposes.
     *
     * Conventionally this would be a timestamp value, but device-local
     * clocks are unreliable and they must be able to create new listens
     * even while disconnected. Instead this should be a monotonically
     * increasing number that's incremented on each listen call.
     *
     * This is different from the queryId since the queryId is an
     * immutable identifier assigned to the Query on first use while
     * lastListenSequenceNumber is updated every time the query is
     * listened to.
     */
    lastListenSequenceNumber, 
    /**
     * Denotes the maximum snapshot version at which the associated query view
     * contained no limbo documents.  Undefined for data written prior to
     * schema version 9.
     */
    lastLimboFreeSnapshotVersion, 
    /**
     * The query for this target.
     *
     * Because canonical ids are not unique we must store the actual query. We
     * use the proto to have an object we can persist without having to
     * duplicate translation logic to and from a `Query` object.
     */
    query) {
        this.targetId = targetId;
        this.canonicalId = canonicalId;
        this.readTime = readTime;
        this.resumeToken = resumeToken;
        this.lastListenSequenceNumber = lastListenSequenceNumber;
        this.lastLimboFreeSnapshotVersion = lastLimboFreeSnapshotVersion;
        this.query = query;
    }
    DbTarget.store = 'targets';
    /** Keys are automatically assigned via the targetId property. */
    DbTarget.keyPath = 'targetId';
    /** The name of the queryTargets index. */
    DbTarget.queryTargetsIndexName = 'queryTargetsIndex';
    /**
     * The index of all canonicalIds to the targets that they match. This is not
     * a unique mapping because canonicalId does not promise a unique name for all
     * possible queries, so we append the targetId to make the mapping unique.
     */
    DbTarget.queryTargetsKeyPath = ['canonicalId', 'targetId'];
    return DbTarget;
}());
/**
 * An object representing an association between a target and a document, or a
 * sentinel row marking the last sequence number at which a document was used.
 * Each document cached must have a corresponding sentinel row before lru
 * garbage collection is enabled.
 *
 * The target associations and sentinel rows are co-located so that orphaned
 * documents and their sequence numbers can be identified efficiently via a scan
 * of this store.
 */
var DbTargetDocument = /** @class */ (function () {
    function DbTargetDocument(
    /**
     * The targetId identifying a target or 0 for a sentinel row.
     */
    targetId, 
    /**
     * The path to the document, as encoded in the key.
     */
    path, 
    /**
     * If this is a sentinel row, this should be the sequence number of the last
     * time the document specified by `path` was used. Otherwise, it should be
     * `undefined`.
     */
    sequenceNumber) {
        this.targetId = targetId;
        this.path = path;
        this.sequenceNumber = sequenceNumber;
        assert((targetId === 0) === (sequenceNumber !== undefined), 'A target-document row must either have targetId == 0 and a defined sequence number, or a non-zero targetId and no sequence number');
    }
    /** Name of the IndexedDb object store.  */
    DbTargetDocument.store = 'targetDocuments';
    /** Keys are automatically assigned via the targetId, path properties. */
    DbTargetDocument.keyPath = ['targetId', 'path'];
    /** The index name for the reverse index. */
    DbTargetDocument.documentTargetsIndex = 'documentTargetsIndex';
    /** We also need to create the reverse index for these properties. */
    DbTargetDocument.documentTargetsKeyPath = ['path', 'targetId'];
    return DbTargetDocument;
}());
/**
 * A record of global state tracked across all Targets, tracked separately
 * to avoid the need for extra indexes.
 *
 * This should be kept in-sync with the proto used in the iOS client.
 */
var DbTargetGlobal = /** @class */ (function () {
    function DbTargetGlobal(
    /**
     * The highest numbered target id across all targets.
     *
     * See DbTarget.targetId.
     */
    highestTargetId, 
    /**
     * The highest numbered lastListenSequenceNumber across all targets.
     *
     * See DbTarget.lastListenSequenceNumber.
     */
    highestListenSequenceNumber, 
    /**
     * A global snapshot version representing the last consistent snapshot we
     * received from the backend. This is monotonically increasing and any
     * snapshots received from the backend prior to this version (e.g. for
     * targets resumed with a resumeToken) should be suppressed (buffered)
     * until the backend has caught up to this snapshot version again. This
     * prevents our cache from ever going backwards in time.
     */
    lastRemoteSnapshotVersion, 
    /**
     * The number of targets persisted.
     */
    targetCount) {
        this.highestTargetId = highestTargetId;
        this.highestListenSequenceNumber = highestListenSequenceNumber;
        this.lastRemoteSnapshotVersion = lastRemoteSnapshotVersion;
        this.targetCount = targetCount;
    }
    /**
     * The key string used for the single object that exists in the
     * DbTargetGlobal store.
     */
    DbTargetGlobal.key = 'targetGlobalKey';
    DbTargetGlobal.store = 'targetGlobal';
    return DbTargetGlobal;
}());
/**
 * An object representing an association between a Collection id (e.g. 'messages')
 * to a parent path (e.g. '/chats/123') that contains it as a (sub)collection.
 * This is used to efficiently find all collections to query when performing
 * a Collection Group query.
 */
var DbCollectionParent = /** @class */ (function () {
    function DbCollectionParent(
    /**
     * The collectionId (e.g. 'messages')
     */
    collectionId, 
    /**
     * The path to the parent (either a document location or an empty path for
     * a root-level collection).
     */
    parent) {
        this.collectionId = collectionId;
        this.parent = parent;
    }
    /** Name of the IndexedDb object store. */
    DbCollectionParent.store = 'collectionParents';
    /** Keys are automatically assigned via the collectionId, parent properties. */
    DbCollectionParent.keyPath = ['collectionId', 'parent'];
    return DbCollectionParent;
}());
function createQueryCache(db) {
    var targetDocumentsStore = db.createObjectStore(DbTargetDocument.store, {
        keyPath: DbTargetDocument.keyPath
    });
    targetDocumentsStore.createIndex(DbTargetDocument.documentTargetsIndex, DbTargetDocument.documentTargetsKeyPath, { unique: true });
    var targetStore = db.createObjectStore(DbTarget.store, {
        keyPath: DbTarget.keyPath
    });
    // NOTE: This is unique only because the TargetId is the suffix.
    targetStore.createIndex(DbTarget.queryTargetsIndexName, DbTarget.queryTargetsKeyPath, { unique: true });
    db.createObjectStore(DbTargetGlobal.store);
}
function dropQueryCache(db) {
    db.deleteObjectStore(DbTargetDocument.store);
    db.deleteObjectStore(DbTarget.store);
    db.deleteObjectStore(DbTargetGlobal.store);
}
function dropRemoteDocumentChangesStore(db) {
    if (db.objectStoreNames.contains('remoteDocumentChanges')) {
        db.deleteObjectStore('remoteDocumentChanges');
    }
}
/**
 * Creates the target global singleton row.
 *
 * @param {IDBTransaction} txn The version upgrade transaction for indexeddb
 */
function writeEmptyTargetGlobalEntry(txn) {
    var globalStore = txn.store(DbTargetGlobal.store);
    var metadata = new DbTargetGlobal(
    /*highestTargetId=*/ 0, 
    /*lastListenSequenceNumber=*/ 0, SnapshotVersion.MIN.toTimestamp(), 
    /*targetCount=*/ 0);
    return globalStore.put(DbTargetGlobal.key, metadata);
}
/**
 * Creates indices on the RemoteDocuments store used for both multi-tab
 * and Index-Free queries.
 */
function createRemoteDocumentReadTimeIndex(txn) {
    var remoteDocumentStore = txn.objectStore(DbRemoteDocument.store);
    remoteDocumentStore.createIndex(DbRemoteDocument.readTimeIndex, DbRemoteDocument.readTimeIndexPath, { unique: false });
    remoteDocumentStore.createIndex(DbRemoteDocument.collectionReadTimeIndex, DbRemoteDocument.collectionReadTimeIndexPath, { unique: false });
}
/**
 * A record of the metadata state of each client.
 *
 * PORTING NOTE: This is used to synchronize multi-tab state and does not need
 * to be ported to iOS or Android.
 */
var DbClientMetadata = /** @class */ (function () {
    function DbClientMetadata(
    // Note: Previous schema versions included a field
    // "lastProcessedDocumentChangeId". Don't use anymore.
    /** The auto-generated client id assigned at client startup. */
    clientId, 
    /** The last time this state was updated. */
    updateTimeMs, 
    /** Whether the client's network connection is enabled. */
    networkEnabled, 
    /** Whether this client is running in a foreground tab. */
    inForeground) {
        this.clientId = clientId;
        this.updateTimeMs = updateTimeMs;
        this.networkEnabled = networkEnabled;
        this.inForeground = inForeground;
    }
    /** Name of the IndexedDb object store. */
    DbClientMetadata.store = 'clientMetadata';
    /** Keys are automatically assigned via the clientId properties. */
    DbClientMetadata.keyPath = 'clientId';
    return DbClientMetadata;
}());
function createClientMetadataStore(db) {
    db.createObjectStore(DbClientMetadata.store, {
        keyPath: DbClientMetadata.keyPath
    });
}
// Visible for testing
var V1_STORES = [
    DbMutationQueue.store,
    DbMutationBatch.store,
    DbDocumentMutation.store,
    DbRemoteDocument.store,
    DbTarget.store,
    DbPrimaryClient.store,
    DbTargetGlobal.store,
    DbTargetDocument.store
];
// V2 is no longer usable (see comment at top of file)
// Visible for testing
var V3_STORES = V1_STORES;
// Visible for testing
// Note: DbRemoteDocumentChanges is no longer used and dropped with v9.
var V4_STORES = tslib.__spreadArrays(V3_STORES, [DbClientMetadata.store]);
// V5 does not change the set of stores.
var V6_STORES = tslib.__spreadArrays(V4_STORES, [DbRemoteDocumentGlobal.store]);
// V7 does not change the set of stores.
var V8_STORES = tslib.__spreadArrays(V6_STORES, [DbCollectionParent.store]);
// V9 does not change the set of stores.
/**
 * The list of all default IndexedDB stores used throughout the SDK. This is
 * used when creating transactions so that access across all stores is done
 * atomically.
 */
var ALL_STORES = V8_STORES;

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A persisted implementation of IndexManager.
 */
var IndexedDbIndexManager = /** @class */ (function () {
    function IndexedDbIndexManager() {
        /**
         * An in-memory copy of the index entries we've already written since the SDK
         * launched. Used to avoid re-writing the same entry repeatedly.
         *
         * This is *NOT* a complete cache of what's in persistence and so can never be used to
         * satisfy reads.
         */
        this.collectionParentsCache = new MemoryCollectionParentIndex();
    }
    /**
     * Adds a new entry to the collection parent index.
     *
     * Repeated calls for the same collectionPath should be avoided within a
     * transaction as IndexedDbIndexManager only caches writes once a transaction
     * has been committed.
     */
    IndexedDbIndexManager.prototype.addToCollectionParentIndex = function (transaction, collectionPath) {
        var _this = this;
        assert(collectionPath.length % 2 === 1, 'Expected a collection path.');
        if (!this.collectionParentsCache.has(collectionPath)) {
            var collectionId = collectionPath.lastSegment();
            var parentPath = collectionPath.popLast();
            transaction.addOnCommittedListener(function () {
                // Add the collection to the in memory cache only if the transaction was
                // successfully committed.
                _this.collectionParentsCache.add(collectionPath);
            });
            return collectionParentsStore(transaction).put({
                collectionId: collectionId,
                parent: encode(parentPath)
            });
        }
        return PersistencePromise.resolve();
    };
    IndexedDbIndexManager.prototype.getCollectionParents = function (transaction, collectionId) {
        var parentPaths = [];
        var range = IDBKeyRange.bound([collectionId, ''], [immediateSuccessor(collectionId), ''], 
        /*lowerOpen=*/ false, 
        /*upperOpen=*/ true);
        return collectionParentsStore(transaction)
            .loadAll(range)
            .next(function (entries) {
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var entry = entries_1[_i];
                // This collectionId guard shouldn't be necessary (and isn't as long
                // as we're running in a real browser), but there's a bug in
                // indexeddbshim that breaks our range in our tests running in node:
                // https://github.com/axemclion/IndexedDBShim/issues/334
                if (entry.collectionId !== collectionId) {
                    break;
                }
                parentPaths.push(decode(entry.parent));
            }
            return parentPaths;
        });
    };
    return IndexedDbIndexManager;
}());
/**
 * Helper to get a typed SimpleDbStore for the collectionParents
 * document store.
 */
function collectionParentsStore(txn) {
    return IndexedDbPersistence.getStore(txn, DbCollectionParent.store);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** An enumeration of the different purposes we have for targets. */
var TargetPurpose;
(function (TargetPurpose) {
    /** A regular, normal query target. */
    TargetPurpose[TargetPurpose["Listen"] = 0] = "Listen";
    /**
     * The query target was used to refill a query after an existence filter mismatch.
     */
    TargetPurpose[TargetPurpose["ExistenceFilterMismatch"] = 1] = "ExistenceFilterMismatch";
    /** The query target was used to resolve a limbo document. */
    TargetPurpose[TargetPurpose["LimboResolution"] = 2] = "LimboResolution";
})(TargetPurpose || (TargetPurpose = {}));
/**
 * An immutable set of metadata that the local store tracks for each target.
 */
var TargetData = /** @class */ (function () {
    function TargetData(
    /** The target being listened to. */
    target, 
    /**
     * The target ID to which the target corresponds; Assigned by the
     * LocalStore for user listens and by the SyncEngine for limbo watches.
     */
    targetId, 
    /** The purpose of the target. */
    purpose, 
    /**
     * The sequence number of the last transaction during which this target data
     * was modified.
     */
    sequenceNumber, 
    /** The latest snapshot version seen for this target. */
    snapshotVersion, 
    /**
     * The maximum snapshot version at which the associated view
     * contained no limbo documents.
     */
    lastLimboFreeSnapshotVersion, 
    /**
     * An opaque, server-assigned token that allows watching a target to be
     * resumed after disconnecting without retransmitting all the data that
     * matches the target. The resume token essentially identifies a point in
     * time from which the server should resume sending results.
     */
    resumeToken) {
        if (snapshotVersion === void 0) { snapshotVersion = SnapshotVersion.MIN; }
        if (lastLimboFreeSnapshotVersion === void 0) { lastLimboFreeSnapshotVersion = SnapshotVersion.MIN; }
        if (resumeToken === void 0) { resumeToken = emptyByteString(); }
        this.target = target;
        this.targetId = targetId;
        this.purpose = purpose;
        this.sequenceNumber = sequenceNumber;
        this.snapshotVersion = snapshotVersion;
        this.lastLimboFreeSnapshotVersion = lastLimboFreeSnapshotVersion;
        this.resumeToken = resumeToken;
    }
    /** Creates a new target data instance with an updated sequence number. */
    TargetData.prototype.withSequenceNumber = function (sequenceNumber) {
        return new TargetData(this.target, this.targetId, this.purpose, sequenceNumber, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken);
    };
    /**
     * Creates a new target data instance with an updated resume token and
     * snapshot version.
     */
    TargetData.prototype.withResumeToken = function (resumeToken, snapshotVersion) {
        return new TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, snapshotVersion, this.lastLimboFreeSnapshotVersion, resumeToken);
    };
    /**
     * Creates a new target data instance with an updated last limbo free
     * snapshot version number.
     */
    TargetData.prototype.withLastLimboFreeSnapshotVersion = function (lastLimboFreeSnapshotVersion) {
        return new TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, lastLimboFreeSnapshotVersion, this.resumeToken);
    };
    TargetData.prototype.isEqual = function (other) {
        return (this.targetId === other.targetId &&
            this.purpose === other.purpose &&
            this.sequenceNumber === other.sequenceNumber &&
            this.snapshotVersion.isEqual(other.snapshotVersion) &&
            this.lastLimboFreeSnapshotVersion.isEqual(other.lastLimboFreeSnapshotVersion) &&
            this.resumeToken === other.resumeToken &&
            this.target.isEqual(other.target));
    };
    return TargetData;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Serializer for values stored in the LocalStore. */
var LocalSerializer = /** @class */ (function () {
    function LocalSerializer(remoteSerializer) {
        this.remoteSerializer = remoteSerializer;
    }
    /** Decodes a remote document from storage locally to a Document. */
    LocalSerializer.prototype.fromDbRemoteDocument = function (remoteDoc) {
        if (remoteDoc.document) {
            return this.remoteSerializer.fromDocument(remoteDoc.document, !!remoteDoc.hasCommittedMutations);
        }
        else if (remoteDoc.noDocument) {
            var key = DocumentKey.fromSegments(remoteDoc.noDocument.path);
            var version = this.fromDbTimestamp(remoteDoc.noDocument.readTime);
            return new NoDocument(key, version, {
                hasCommittedMutations: !!remoteDoc.hasCommittedMutations
            });
        }
        else if (remoteDoc.unknownDocument) {
            var key = DocumentKey.fromSegments(remoteDoc.unknownDocument.path);
            var version = this.fromDbTimestamp(remoteDoc.unknownDocument.version);
            return new UnknownDocument(key, version);
        }
        else {
            return fail('Unexpected DbRemoteDocument');
        }
    };
    /** Encodes a document for storage locally. */
    LocalSerializer.prototype.toDbRemoteDocument = function (maybeDoc, readTime) {
        var dbReadTime = this.toDbTimestampKey(readTime);
        var parentPath = maybeDoc.key.path.popLast().toArray();
        if (maybeDoc instanceof Document) {
            var doc = maybeDoc.proto
                ? maybeDoc.proto
                : this.remoteSerializer.toDocument(maybeDoc);
            var hasCommittedMutations = maybeDoc.hasCommittedMutations;
            return new DbRemoteDocument(
            /* unknownDocument= */ null, 
            /* noDocument= */ null, doc, hasCommittedMutations, dbReadTime, parentPath);
        }
        else if (maybeDoc instanceof NoDocument) {
            var path = maybeDoc.key.path.toArray();
            var readTime_1 = this.toDbTimestamp(maybeDoc.version);
            var hasCommittedMutations = maybeDoc.hasCommittedMutations;
            return new DbRemoteDocument(
            /* unknownDocument= */ null, new DbNoDocument(path, readTime_1), 
            /* document= */ null, hasCommittedMutations, dbReadTime, parentPath);
        }
        else if (maybeDoc instanceof UnknownDocument) {
            var path = maybeDoc.key.path.toArray();
            var readTime_2 = this.toDbTimestamp(maybeDoc.version);
            return new DbRemoteDocument(new DbUnknownDocument(path, readTime_2), 
            /* noDocument= */ null, 
            /* document= */ null, 
            /* hasCommittedMutations= */ true, dbReadTime, parentPath);
        }
        else {
            return fail('Unexpected MaybeDocument');
        }
    };
    LocalSerializer.prototype.toDbTimestampKey = function (snapshotVersion) {
        var timestamp = snapshotVersion.toTimestamp();
        return [timestamp.seconds, timestamp.nanoseconds];
    };
    LocalSerializer.prototype.fromDbTimestampKey = function (dbTimestampKey) {
        var timestamp = new Timestamp(dbTimestampKey[0], dbTimestampKey[1]);
        return SnapshotVersion.fromTimestamp(timestamp);
    };
    LocalSerializer.prototype.toDbTimestamp = function (snapshotVersion) {
        var timestamp = snapshotVersion.toTimestamp();
        return new DbTimestamp(timestamp.seconds, timestamp.nanoseconds);
    };
    LocalSerializer.prototype.fromDbTimestamp = function (dbTimestamp) {
        var timestamp = new Timestamp(dbTimestamp.seconds, dbTimestamp.nanoseconds);
        return SnapshotVersion.fromTimestamp(timestamp);
    };
    /** Encodes a batch of mutations into a DbMutationBatch for local storage. */
    LocalSerializer.prototype.toDbMutationBatch = function (userId, batch) {
        var _this = this;
        var serializedBaseMutations = batch.baseMutations.map(function (m) {
            return _this.remoteSerializer.toMutation(m);
        });
        var serializedMutations = batch.mutations.map(function (m) {
            return _this.remoteSerializer.toMutation(m);
        });
        return new DbMutationBatch(userId, batch.batchId, batch.localWriteTime.toMillis(), serializedBaseMutations, serializedMutations);
    };
    /** Decodes a DbMutationBatch into a MutationBatch */
    LocalSerializer.prototype.fromDbMutationBatch = function (dbBatch) {
        var _this = this;
        var baseMutations = (dbBatch.baseMutations || []).map(function (m) {
            return _this.remoteSerializer.fromMutation(m);
        });
        var mutations = dbBatch.mutations.map(function (m) {
            return _this.remoteSerializer.fromMutation(m);
        });
        var timestamp = Timestamp.fromMillis(dbBatch.localWriteTimeMs);
        return new MutationBatch(dbBatch.batchId, timestamp, baseMutations, mutations);
    };
    /*
     * Encodes a set of document keys into an array of EncodedResourcePaths.
     */
    LocalSerializer.prototype.toDbResourcePaths = function (keys) {
        var encodedKeys = [];
        keys.forEach(function (key) {
            encodedKeys.push(encode(key.path));
        });
        return encodedKeys;
    };
    /** Decodes an array of EncodedResourcePaths into a set of document keys. */
    LocalSerializer.prototype.fromDbResourcePaths = function (encodedPaths) {
        var keys = documentKeySet();
        for (var _i = 0, encodedPaths_1 = encodedPaths; _i < encodedPaths_1.length; _i++) {
            var documentKey = encodedPaths_1[_i];
            keys = keys.add(new DocumentKey(decode(documentKey)));
        }
        return keys;
    };
    /** Decodes a DbTarget into TargetData */
    LocalSerializer.prototype.fromDbTarget = function (dbTarget) {
        var version = this.fromDbTimestamp(dbTarget.readTime);
        var lastLimboFreeSnapshotVersion = dbTarget.lastLimboFreeSnapshotVersion !== undefined
            ? this.fromDbTimestamp(dbTarget.lastLimboFreeSnapshotVersion)
            : SnapshotVersion.MIN;
        // TODO(b/140573486): Convert to platform representation
        var resumeToken = dbTarget.resumeToken;
        var target;
        if (isDocumentQuery(dbTarget.query)) {
            target = this.remoteSerializer.fromDocumentsTarget(dbTarget.query);
        }
        else {
            target = this.remoteSerializer.fromQueryTarget(dbTarget.query);
        }
        return new TargetData(target, dbTarget.targetId, TargetPurpose.Listen, dbTarget.lastListenSequenceNumber, version, lastLimboFreeSnapshotVersion, resumeToken);
    };
    /** Encodes TargetData into a DbTarget for storage locally. */
    LocalSerializer.prototype.toDbTarget = function (targetData) {
        assert(TargetPurpose.Listen === targetData.purpose, 'Only queries with purpose ' +
            TargetPurpose.Listen +
            ' may be stored, got ' +
            targetData.purpose);
        var dbTimestamp = this.toDbTimestamp(targetData.snapshotVersion);
        var dbLastLimboFreeTimestamp = this.toDbTimestamp(targetData.lastLimboFreeSnapshotVersion);
        var queryProto;
        if (targetData.target.isDocumentQuery()) {
            queryProto = this.remoteSerializer.toDocumentsTarget(targetData.target);
        }
        else {
            queryProto = this.remoteSerializer.toQueryTarget(targetData.target);
        }
        var resumeToken;
        if (targetData.resumeToken instanceof Uint8Array) {
            // TODO(b/78771403): Convert tokens to strings during deserialization
            assert(SimpleDb.isMockPersistence(), 'Persisting non-string stream tokens is only supported with mock persistence .');
            resumeToken = targetData.resumeToken.toString();
        }
        else {
            resumeToken = targetData.resumeToken;
        }
        // lastListenSequenceNumber is always 0 until we do real GC.
        return new DbTarget(targetData.targetId, targetData.target.canonicalId(), dbTimestamp, resumeToken, targetData.sequenceNumber, dbLastLimboFreeTimestamp, queryProto);
    };
    return LocalSerializer;
}());
/**
 * A helper function for figuring out what kind of query has been stored.
 */
function isDocumentQuery(dbQuery) {
    return dbQuery.documents !== undefined;
}

/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function bufferEntryComparator(_a, _b) {
    var aSequence = _a[0], aIndex = _a[1];
    var bSequence = _b[0], bIndex = _b[1];
    var seqCmp = primitiveComparator(aSequence, bSequence);
    if (seqCmp === 0) {
        // This order doesn't matter, but we can bias against churn by sorting
        // entries created earlier as less than newer entries.
        return primitiveComparator(aIndex, bIndex);
    }
    else {
        return seqCmp;
    }
}
/**
 * Used to calculate the nth sequence number. Keeps a rolling buffer of the
 * lowest n values passed to `addElement`, and finally reports the largest of
 * them in `maxValue`.
 */
var RollingSequenceNumberBuffer = /** @class */ (function () {
    function RollingSequenceNumberBuffer(maxElements) {
        this.maxElements = maxElements;
        this.buffer = new SortedSet(bufferEntryComparator);
        this.previousIndex = 0;
    }
    RollingSequenceNumberBuffer.prototype.nextIndex = function () {
        return ++this.previousIndex;
    };
    RollingSequenceNumberBuffer.prototype.addElement = function (sequenceNumber) {
        var entry = [sequenceNumber, this.nextIndex()];
        if (this.buffer.size < this.maxElements) {
            this.buffer = this.buffer.add(entry);
        }
        else {
            var highestValue = this.buffer.last();
            if (bufferEntryComparator(entry, highestValue) < 0) {
                this.buffer = this.buffer.delete(highestValue).add(entry);
            }
        }
    };
    Object.defineProperty(RollingSequenceNumberBuffer.prototype, "maxValue", {
        get: function () {
            // Guaranteed to be non-empty. If we decide we are not collecting any
            // sequence numbers, nthSequenceNumber below short-circuits. If we have
            // decided that we are collecting n sequence numbers, it's because n is some
            // percentage of the existing sequence numbers. That means we should never
            // be in a situation where we are collecting sequence numbers but don't
            // actually have any.
            return this.buffer.last()[0];
        },
        enumerable: true,
        configurable: true
    });
    return RollingSequenceNumberBuffer;
}());
var GC_DID_NOT_RUN = {
    didRun: false,
    sequenceNumbersCollected: 0,
    targetsRemoved: 0,
    documentsRemoved: 0
};
var LruParams = /** @class */ (function () {
    function LruParams(
    // When we attempt to collect, we will only do so if the cache size is greater than this
    // threshold. Passing `COLLECTION_DISABLED` here will cause collection to always be skipped.
    cacheSizeCollectionThreshold, 
    // The percentage of sequence numbers that we will attempt to collect
    percentileToCollect, 
    // A cap on the total number of sequence numbers that will be collected. This prevents
    // us from collecting a huge number of sequence numbers if the cache has grown very large.
    maximumSequenceNumbersToCollect) {
        this.cacheSizeCollectionThreshold = cacheSizeCollectionThreshold;
        this.percentileToCollect = percentileToCollect;
        this.maximumSequenceNumbersToCollect = maximumSequenceNumbersToCollect;
    }
    LruParams.withCacheSize = function (cacheSize) {
        return new LruParams(cacheSize, LruParams.DEFAULT_COLLECTION_PERCENTILE, LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
    };
    LruParams.COLLECTION_DISABLED = -1;
    LruParams.MINIMUM_CACHE_SIZE_BYTES = 1 * 1024 * 1024;
    LruParams.DEFAULT_CACHE_SIZE_BYTES = 40 * 1024 * 1024;
    LruParams.DEFAULT_COLLECTION_PERCENTILE = 10;
    LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT = 1000;
    LruParams.DEFAULT = new LruParams(LruParams.DEFAULT_CACHE_SIZE_BYTES, LruParams.DEFAULT_COLLECTION_PERCENTILE, LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
    LruParams.DISABLED = new LruParams(LruParams.COLLECTION_DISABLED, 0, 0);
    return LruParams;
}());
/** How long we wait to try running LRU GC after SDK initialization. */
var INITIAL_GC_DELAY_MS = 1 * 60 * 1000;
/** Minimum amount of time between GC checks, after the first one. */
var REGULAR_GC_DELAY_MS = 5 * 60 * 1000;
/**
 * This class is responsible for the scheduling of LRU garbage collection. It handles checking
 * whether or not GC is enabled, as well as which delay to use before the next run.
 */
var LruScheduler = /** @class */ (function () {
    function LruScheduler(garbageCollector, asyncQueue, localStore) {
        this.garbageCollector = garbageCollector;
        this.asyncQueue = asyncQueue;
        this.localStore = localStore;
        this.hasRun = false;
        this.gcTask = null;
    }
    LruScheduler.prototype.start = function () {
        assert(this.gcTask === null, 'Cannot start an already started LruScheduler');
        if (this.garbageCollector.params.cacheSizeCollectionThreshold !==
            LruParams.COLLECTION_DISABLED) {
            this.scheduleGC();
        }
    };
    LruScheduler.prototype.stop = function () {
        if (this.gcTask) {
            this.gcTask.cancel();
            this.gcTask = null;
        }
    };
    Object.defineProperty(LruScheduler.prototype, "started", {
        get: function () {
            return this.gcTask !== null;
        },
        enumerable: true,
        configurable: true
    });
    LruScheduler.prototype.scheduleGC = function () {
        var _this = this;
        assert(this.gcTask === null, 'Cannot schedule GC while a task is pending');
        var delay = this.hasRun ? REGULAR_GC_DELAY_MS : INITIAL_GC_DELAY_MS;
        debug('LruGarbageCollector', "Garbage collection scheduled in " + delay + "ms");
        this.gcTask = this.asyncQueue.enqueueAfterDelay(TimerId.LruGarbageCollection, delay, function () {
            _this.gcTask = null;
            _this.hasRun = true;
            return _this.localStore
                .collectGarbage(_this.garbageCollector)
                .then(function () { return _this.scheduleGC(); })
                .catch(ignoreIfPrimaryLeaseLoss);
        });
    };
    return LruScheduler;
}());
/** Implements the steps for LRU garbage collection. */
var LruGarbageCollector = /** @class */ (function () {
    function LruGarbageCollector(delegate, params) {
        this.delegate = delegate;
        this.params = params;
    }
    /** Given a percentile of target to collect, returns the number of targets to collect. */
    LruGarbageCollector.prototype.calculateTargetCount = function (txn, percentile) {
        return this.delegate.getSequenceNumberCount(txn).next(function (targetCount) {
            return Math.floor((percentile / 100.0) * targetCount);
        });
    };
    /** Returns the nth sequence number, counting in order from the smallest. */
    LruGarbageCollector.prototype.nthSequenceNumber = function (txn, n) {
        var _this = this;
        if (n === 0) {
            return PersistencePromise.resolve(ListenSequence.INVALID);
        }
        var buffer = new RollingSequenceNumberBuffer(n);
        return this.delegate
            .forEachTarget(txn, function (target) { return buffer.addElement(target.sequenceNumber); })
            .next(function () {
            return _this.delegate.forEachOrphanedDocumentSequenceNumber(txn, function (sequenceNumber) { return buffer.addElement(sequenceNumber); });
        })
            .next(function () { return buffer.maxValue; });
    };
    /**
     * Removes targets with a sequence number equal to or less than the given upper bound, and removes
     * document associations with those targets.
     */
    LruGarbageCollector.prototype.removeTargets = function (txn, upperBound, activeTargetIds) {
        return this.delegate.removeTargets(txn, upperBound, activeTargetIds);
    };
    /**
     * Removes documents that have a sequence number equal to or less than the upper bound and are not
     * otherwise pinned.
     */
    LruGarbageCollector.prototype.removeOrphanedDocuments = function (txn, upperBound) {
        return this.delegate.removeOrphanedDocuments(txn, upperBound);
    };
    LruGarbageCollector.prototype.collect = function (txn, activeTargetIds) {
        var _this = this;
        if (this.params.cacheSizeCollectionThreshold === LruParams.COLLECTION_DISABLED) {
            debug('LruGarbageCollector', 'Garbage collection skipped; disabled');
            return PersistencePromise.resolve(GC_DID_NOT_RUN);
        }
        return this.getCacheSize(txn).next(function (cacheSize) {
            if (cacheSize < _this.params.cacheSizeCollectionThreshold) {
                debug('LruGarbageCollector', "Garbage collection skipped; Cache size " + cacheSize + " " +
                    ("is lower than threshold " + _this.params.cacheSizeCollectionThreshold));
                return GC_DID_NOT_RUN;
            }
            else {
                return _this.runGarbageCollection(txn, activeTargetIds);
            }
        });
    };
    LruGarbageCollector.prototype.getCacheSize = function (txn) {
        return this.delegate.getCacheSize(txn);
    };
    LruGarbageCollector.prototype.runGarbageCollection = function (txn, activeTargetIds) {
        var _this = this;
        var upperBoundSequenceNumber;
        var sequenceNumbersToCollect, targetsRemoved;
        // Timestamps for various pieces of the process
        var countedTargetsTs, foundUpperBoundTs, removedTargetsTs, removedDocumentsTs;
        var startTs = Date.now();
        return this.calculateTargetCount(txn, this.params.percentileToCollect)
            .next(function (sequenceNumbers) {
            // Cap at the configured max
            if (sequenceNumbers > _this.params.maximumSequenceNumbersToCollect) {
                debug('LruGarbageCollector', 'Capping sequence numbers to collect down ' +
                    ("to the maximum of " + _this.params.maximumSequenceNumbersToCollect + " ") +
                    ("from " + sequenceNumbers));
                sequenceNumbersToCollect = _this.params
                    .maximumSequenceNumbersToCollect;
            }
            else {
                sequenceNumbersToCollect = sequenceNumbers;
            }
            countedTargetsTs = Date.now();
            return _this.nthSequenceNumber(txn, sequenceNumbersToCollect);
        })
            .next(function (upperBound) {
            upperBoundSequenceNumber = upperBound;
            foundUpperBoundTs = Date.now();
            return _this.removeTargets(txn, upperBoundSequenceNumber, activeTargetIds);
        })
            .next(function (numTargetsRemoved) {
            targetsRemoved = numTargetsRemoved;
            removedTargetsTs = Date.now();
            return _this.removeOrphanedDocuments(txn, upperBoundSequenceNumber);
        })
            .next(function (documentsRemoved) {
            removedDocumentsTs = Date.now();
            if (getLogLevel() <= LogLevel.DEBUG) {
                var desc = 'LRU Garbage Collection\n' +
                    ("\tCounted targets in " + (countedTargetsTs - startTs) + "ms\n") +
                    ("\tDetermined least recently used " + sequenceNumbersToCollect + " in ") +
                    (foundUpperBoundTs - countedTargetsTs + "ms\n") +
                    ("\tRemoved " + targetsRemoved + " targets in ") +
                    (removedTargetsTs - foundUpperBoundTs + "ms\n") +
                    ("\tRemoved " + documentsRemoved + " documents in ") +
                    (removedDocumentsTs - removedTargetsTs + "ms\n") +
                    ("Total Duration: " + (removedDocumentsTs - startTs) + "ms");
                debug('LruGarbageCollector', desc);
            }
            return PersistencePromise.resolve({
                didRun: true,
                sequenceNumbersCollected: sequenceNumbersToCollect,
                targetsRemoved: targetsRemoved,
                documentsRemoved: documentsRemoved
            });
        });
    };
    return LruGarbageCollector;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A base class representing a persistence transaction, encapsulating both the
 * transaction's sequence numbers as well as a list of onCommitted listeners.
 *
 * When you call Persistence.runTransaction(), it will create a transaction and
 * pass it to your callback. You then pass it to any method that operates
 * on persistence.
 */
var PersistenceTransaction = /** @class */ (function () {
    function PersistenceTransaction() {
        this.onCommittedListeners = [];
    }
    PersistenceTransaction.prototype.addOnCommittedListener = function (listener) {
        this.onCommittedListeners.push(listener);
    };
    PersistenceTransaction.prototype.raiseOnCommittedEvent = function () {
        this.onCommittedListeners.forEach(function (listener) { return listener(); });
    };
    return PersistenceTransaction;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$1 = 'IndexedDbPersistence';
/**
 * Oldest acceptable age in milliseconds for client metadata before the client
 * is considered inactive and its associated data is garbage collected.
 */
var MAX_CLIENT_AGE_MS = 30 * 60 * 1000; // 30 minutes
/**
 * Oldest acceptable metadata age for clients that may participate in the
 * primary lease election. Clients that have not updated their client metadata
 * within 5 seconds are not eligible to receive a primary lease.
 */
var MAX_PRIMARY_ELIGIBLE_AGE_MS = 5000;
/**
 * The interval at which clients will update their metadata, including
 * refreshing their primary lease if held or potentially trying to acquire it if
 * not held.
 *
 * Primary clients may opportunistically refresh their metadata earlier
 * if they're already performing an IndexedDB operation.
 */
var CLIENT_METADATA_REFRESH_INTERVAL_MS = 4000;
/** User-facing error when the primary lease is required but not available. */
var PRIMARY_LEASE_LOST_ERROR_MSG = 'The current tab is not in the required state to perform this operation. ' +
    'It might be necessary to refresh the browser tab.';
var PRIMARY_LEASE_EXCLUSIVE_ERROR_MSG = 'Another tab has exclusive access to the persistence layer. ' +
    'To allow shared access, make sure to invoke ' +
    '`enablePersistence()` with `synchronizeTabs:true` in all tabs.';
var UNSUPPORTED_PLATFORM_ERROR_MSG = 'This platform is either missing' +
    ' IndexedDB or is known to have an incomplete implementation. Offline' +
    ' persistence has been disabled.';
// The format of the LocalStorage key that stores zombied client is:
//     firestore_zombie_<persistence_prefix>_<instance_key>
var ZOMBIED_CLIENTS_KEY_PREFIX = 'firestore_zombie';
var IndexedDbTransaction = /** @class */ (function (_super) {
    tslib.__extends(IndexedDbTransaction, _super);
    function IndexedDbTransaction(simpleDbTransaction, currentSequenceNumber) {
        var _this = _super.call(this) || this;
        _this.simpleDbTransaction = simpleDbTransaction;
        _this.currentSequenceNumber = currentSequenceNumber;
        return _this;
    }
    return IndexedDbTransaction;
}(PersistenceTransaction));
/**
 * An IndexedDB-backed instance of Persistence. Data is stored persistently
 * across sessions.
 *
 * On Web only, the Firestore SDKs support shared access to its persistence
 * layer. This allows multiple browser tabs to read and write to IndexedDb and
 * to synchronize state even without network connectivity. Shared access is
 * currently optional and not enabled unless all clients invoke
 * `enablePersistence()` with `{synchronizeTabs:true}`.
 *
 * In multi-tab mode, if multiple clients are active at the same time, the SDK
 * will designate one client as the “primary client”. An effort is made to pick
 * a visible, network-connected and active client, and this client is
 * responsible for letting other clients know about its presence. The primary
 * client writes a unique client-generated identifier (the client ID) to
 * IndexedDb’s “owner” store every 4 seconds. If the primary client fails to
 * update this entry, another client can acquire the lease and take over as
 * primary.
 *
 * Some persistence operations in the SDK are designated as primary-client only
 * operations. This includes the acknowledgment of mutations and all updates of
 * remote documents. The effects of these operations are written to persistence
 * and then broadcast to other tabs via LocalStorage (see
 * `WebStorageSharedClientState`), which then refresh their state from
 * persistence.
 *
 * Similarly, the primary client listens to notifications sent by secondary
 * clients to discover persistence changes written by secondary clients, such as
 * the addition of new mutations and query targets.
 *
 * If multi-tab is not enabled and another tab already obtained the primary
 * lease, IndexedDbPersistence enters a failed state and all subsequent
 * operations will automatically fail.
 *
 * Additionally, there is an optimization so that when a tab is closed, the
 * primary lease is released immediately (this is especially important to make
 * sure that a refreshed tab is able to immediately re-acquire the primary
 * lease). Unfortunately, IndexedDB cannot be reliably used in window.unload
 * since it is an asynchronous API. So in addition to attempting to give up the
 * lease, the leaseholder writes its client ID to a "zombiedClient" entry in
 * LocalStorage which acts as an indicator that another tab should go ahead and
 * take the primary lease immediately regardless of the current lease timestamp.
 *
 * TODO(b/114226234): Remove `synchronizeTabs` section when multi-tab is no
 * longer optional.
 */
var IndexedDbPersistence = /** @class */ (function () {
    function IndexedDbPersistence(allowTabSynchronization, persistenceKey, clientId, platform, lruParams, queue, serializer, sequenceNumberSyncer) {
        this.allowTabSynchronization = allowTabSynchronization;
        this.persistenceKey = persistenceKey;
        this.clientId = clientId;
        this.queue = queue;
        this.sequenceNumberSyncer = sequenceNumberSyncer;
        this._started = false;
        this.isPrimary = false;
        this.networkEnabled = true;
        /** Our window.unload handler, if registered. */
        this.windowUnloadHandler = null;
        this.inForeground = false;
        /** Our 'visibilitychange' listener if registered. */
        this.documentVisibilityHandler = null;
        /** The client metadata refresh task. */
        this.clientMetadataRefresher = null;
        /** The last time we garbage collected the client metadata object store. */
        this.lastGarbageCollectionTime = Number.NEGATIVE_INFINITY;
        /** A listener to notify on primary state changes. */
        this.primaryStateListener = function (_) { return Promise.resolve(); };
        this.referenceDelegate = new IndexedDbLruDelegate(this, lruParams);
        this.dbName = persistenceKey + IndexedDbPersistence.MAIN_DATABASE;
        this.serializer = new LocalSerializer(serializer);
        this.document = platform.document;
        this.targetCache = new IndexedDbTargetCache(this.referenceDelegate, this.serializer);
        this.indexManager = new IndexedDbIndexManager();
        this.remoteDocumentCache = new IndexedDbRemoteDocumentCache(this.serializer, this.indexManager);
        if (platform.window && platform.window.localStorage) {
            this.window = platform.window;
            this.webStorage = this.window.localStorage;
        }
        else {
            throw new FirestoreError(Code.UNIMPLEMENTED, 'IndexedDB persistence is only available on platforms that support LocalStorage.');
        }
    }
    IndexedDbPersistence.getStore = function (txn, store) {
        if (txn instanceof IndexedDbTransaction) {
            return SimpleDb.getStore(txn.simpleDbTransaction, store);
        }
        else {
            throw fail('IndexedDbPersistence must use instances of IndexedDbTransaction');
        }
    };
    IndexedDbPersistence.createIndexedDbPersistence = function (options) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var persistence;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!IndexedDbPersistence.isAvailable()) {
                            throw new FirestoreError(Code.UNIMPLEMENTED, UNSUPPORTED_PLATFORM_ERROR_MSG);
                        }
                        persistence = new IndexedDbPersistence(options.allowTabSynchronization, options.persistenceKey, options.clientId, options.platform, options.lruParams, options.queue, options.serializer, options.sequenceNumberSyncer);
                        return [4 /*yield*/, persistence.start()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, persistence];
                }
            });
        });
    };
    /**
     * Attempt to start IndexedDb persistence.
     *
     * @return {Promise<void>} Whether persistence was enabled.
     */
    IndexedDbPersistence.prototype.start = function () {
        var _this = this;
        assert(!this.started, 'IndexedDbPersistence double-started!');
        assert(this.window !== null, "Expected 'window' to be defined");
        return SimpleDb.openOrCreate(this.dbName, SCHEMA_VERSION, new SchemaConverter(this.serializer))
            .then(function (db) {
            _this.simpleDb = db;
            // NOTE: This is expected to fail sometimes (in the case of another tab already
            // having the persistence lock), so it's the first thing we should do.
            return _this.updateClientMetadataAndTryBecomePrimary();
        })
            .then(function () {
            _this.attachVisibilityHandler();
            _this.attachWindowUnloadHook();
            _this.scheduleClientMetadataAndPrimaryLeaseRefreshes();
            return _this.simpleDb.runTransaction('readonly-idempotent', [DbTargetGlobal.store], function (txn) { return getHighestListenSequenceNumber(txn); });
        })
            .then(function (highestListenSequenceNumber) {
            _this.listenSequence = new ListenSequence(highestListenSequenceNumber, _this.sequenceNumberSyncer);
        })
            .then(function () {
            _this._started = true;
        })
            .catch(function (reason) {
            _this.simpleDb && _this.simpleDb.close();
            return Promise.reject(reason);
        });
    };
    IndexedDbPersistence.prototype.setPrimaryStateListener = function (primaryStateListener) {
        var _this = this;
        this.primaryStateListener = function (primaryState) { return tslib.__awaiter(_this, void 0, void 0, function () {
            return tslib.__generator(this, function (_a) {
                if (this.started) {
                    return [2 /*return*/, primaryStateListener(primaryState)];
                }
                return [2 /*return*/];
            });
        }); };
        return primaryStateListener(this.isPrimary);
    };
    IndexedDbPersistence.prototype.setDatabaseDeletedListener = function (databaseDeletedListener) {
        var _this = this;
        this.simpleDb.setVersionChangeListener(function (event) { return tslib.__awaiter(_this, void 0, void 0, function () {
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(event.newVersion === null)) return [3 /*break*/, 2];
                        return [4 /*yield*/, databaseDeletedListener()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    };
    IndexedDbPersistence.prototype.setNetworkEnabled = function (networkEnabled) {
        var _this = this;
        if (this.networkEnabled !== networkEnabled) {
            this.networkEnabled = networkEnabled;
            // Schedule a primary lease refresh for immediate execution. The eventual
            // lease update will be propagated via `primaryStateListener`.
            this.queue.enqueueAndForget(function () { return tslib.__awaiter(_this, void 0, void 0, function () {
                return tslib.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this.started) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.updateClientMetadataAndTryBecomePrimary()];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            }); });
        }
    };
    /**
     * Updates the client metadata in IndexedDb and attempts to either obtain or
     * extend the primary lease for the local client. Asynchronously notifies the
     * primary state listener if the client either newly obtained or released its
     * primary lease.
     */
    IndexedDbPersistence.prototype.updateClientMetadataAndTryBecomePrimary = function () {
        var _this = this;
        return this.simpleDb
            .runTransaction('readwrite-idempotent', ALL_STORES, function (txn) {
            var metadataStore = clientMetadataStore(txn);
            return metadataStore
                .put(new DbClientMetadata(_this.clientId, Date.now(), _this.networkEnabled, _this.inForeground))
                .next(function () {
                if (_this.isPrimary) {
                    return _this.verifyPrimaryLease(txn).next(function (success) {
                        if (!success) {
                            _this.isPrimary = false;
                            _this.queue.enqueueAndForget(function () {
                                return _this.primaryStateListener(false);
                            });
                        }
                    });
                }
            })
                .next(function () { return _this.canActAsPrimary(txn); })
                .next(function (canActAsPrimary) {
                if (_this.isPrimary && !canActAsPrimary) {
                    return _this.releasePrimaryLeaseIfHeld(txn).next(function () { return false; });
                }
                else if (canActAsPrimary) {
                    return _this.acquireOrExtendPrimaryLease(txn).next(function () { return true; });
                }
                else {
                    return /* canActAsPrimary= */ false;
                }
            });
        })
            .catch(function (e) {
            if (!_this.allowTabSynchronization) {
                throw e;
            }
            debug(LOG_TAG$1, 'Releasing owner lease after error during lease refresh', e);
            return /* isPrimary= */ false;
        })
            .then(function (isPrimary) {
            if (_this.isPrimary !== isPrimary) {
                _this.queue.enqueueAndForget(function () {
                    return _this.primaryStateListener(isPrimary);
                });
            }
            _this.isPrimary = isPrimary;
        });
    };
    IndexedDbPersistence.prototype.verifyPrimaryLease = function (txn) {
        var _this = this;
        var store = primaryClientStore(txn);
        return store.get(DbPrimaryClient.key).next(function (primaryClient) {
            return PersistencePromise.resolve(_this.isLocalClient(primaryClient));
        });
    };
    IndexedDbPersistence.prototype.removeClientMetadata = function (txn) {
        var metadataStore = clientMetadataStore(txn);
        return metadataStore.delete(this.clientId);
    };
    /**
     * If the garbage collection threshold has passed, prunes the
     * RemoteDocumentChanges and the ClientMetadata store based on the last update
     * time of all clients.
     */
    IndexedDbPersistence.prototype.maybeGarbageCollectMultiClientState = function () {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var inactiveClients;
            var _this = this;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.isPrimary &&
                            !this.isWithinAge(this.lastGarbageCollectionTime, MAX_CLIENT_AGE_MS))) return [3 /*break*/, 2];
                        this.lastGarbageCollectionTime = Date.now();
                        return [4 /*yield*/, this.runTransaction('maybeGarbageCollectMultiClientState', 'readwrite-primary-idempotent', function (txn) {
                                var metadataStore = IndexedDbPersistence.getStore(txn, DbClientMetadata.store);
                                return metadataStore.loadAll().next(function (existingClients) {
                                    var active = _this.filterActiveClients(existingClients, MAX_CLIENT_AGE_MS);
                                    var inactive = existingClients.filter(function (client) { return active.indexOf(client) === -1; });
                                    // Delete metadata for clients that are no longer considered active.
                                    return PersistencePromise.forEach(inactive, function (inactiveClient) {
                                        return metadataStore.delete(inactiveClient.clientId);
                                    }).next(function () { return inactive; });
                                });
                            })];
                    case 1:
                        inactiveClients = _a.sent();
                        // Delete potential leftover entries that may continue to mark the
                        // inactive clients as zombied in LocalStorage.
                        // Ideally we'd delete the IndexedDb and LocalStorage zombie entries for
                        // the client atomically, but we can't. So we opt to delete the IndexedDb
                        // entries first to avoid potentially reviving a zombied client.
                        inactiveClients.forEach(function (inactiveClient) {
                            _this.window.localStorage.removeItem(_this.zombiedClientLocalStorageKey(inactiveClient.clientId));
                        });
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Schedules a recurring timer to update the client metadata and to either
     * extend or acquire the primary lease if the client is eligible.
     */
    IndexedDbPersistence.prototype.scheduleClientMetadataAndPrimaryLeaseRefreshes = function () {
        var _this = this;
        this.clientMetadataRefresher = this.queue.enqueueAfterDelay(TimerId.ClientMetadataRefresh, CLIENT_METADATA_REFRESH_INTERVAL_MS, function () {
            return _this.updateClientMetadataAndTryBecomePrimary()
                .then(function () { return _this.maybeGarbageCollectMultiClientState(); })
                .then(function () { return _this.scheduleClientMetadataAndPrimaryLeaseRefreshes(); });
        });
    };
    /** Checks whether `client` is the local client. */
    IndexedDbPersistence.prototype.isLocalClient = function (client) {
        return client ? client.ownerId === this.clientId : false;
    };
    /**
     * Evaluate the state of all active clients and determine whether the local
     * client is or can act as the holder of the primary lease. Returns whether
     * the client is eligible for the lease, but does not actually acquire it.
     * May return 'false' even if there is no active leaseholder and another
     * (foreground) client should become leaseholder instead.
     */
    IndexedDbPersistence.prototype.canActAsPrimary = function (txn) {
        var _this = this;
        var store = primaryClientStore(txn);
        return store
            .get(DbPrimaryClient.key)
            .next(function (currentPrimary) {
            var currentLeaseIsValid = currentPrimary !== null &&
                _this.isWithinAge(currentPrimary.leaseTimestampMs, MAX_PRIMARY_ELIGIBLE_AGE_MS) &&
                !_this.isClientZombied(currentPrimary.ownerId);
            // A client is eligible for the primary lease if:
            // - its network is enabled and the client's tab is in the foreground.
            // - its network is enabled and no other client's tab is in the
            //   foreground.
            // - every clients network is disabled and the client's tab is in the
            //   foreground.
            // - every clients network is disabled and no other client's tab is in
            //   the foreground.
            if (currentLeaseIsValid) {
                if (_this.isLocalClient(currentPrimary) && _this.networkEnabled) {
                    return true;
                }
                if (!_this.isLocalClient(currentPrimary)) {
                    if (!currentPrimary.allowTabSynchronization) {
                        // Fail the `canActAsPrimary` check if the current leaseholder has
                        // not opted into multi-tab synchronization. If this happens at
                        // client startup, we reject the Promise returned by
                        // `enablePersistence()` and the user can continue to use Firestore
                        // with in-memory persistence.
                        // If this fails during a lease refresh, we will instead block the
                        // AsyncQueue from executing further operations. Note that this is
                        // acceptable since mixing & matching different `synchronizeTabs`
                        // settings is not supported.
                        //
                        // TODO(b/114226234): Remove this check when `synchronizeTabs` can
                        // no longer be turned off.
                        throw new FirestoreError(Code.FAILED_PRECONDITION, PRIMARY_LEASE_EXCLUSIVE_ERROR_MSG);
                    }
                    return false;
                }
            }
            if (_this.networkEnabled && _this.inForeground) {
                return true;
            }
            return clientMetadataStore(txn)
                .loadAll()
                .next(function (existingClients) {
                // Process all existing clients and determine whether at least one of
                // them is better suited to obtain the primary lease.
                var preferredCandidate = _this.filterActiveClients(existingClients, MAX_PRIMARY_ELIGIBLE_AGE_MS).find(function (otherClient) {
                    if (_this.clientId !== otherClient.clientId) {
                        var otherClientHasBetterNetworkState = !_this.networkEnabled && otherClient.networkEnabled;
                        var otherClientHasBetterVisibility = !_this.inForeground && otherClient.inForeground;
                        var otherClientHasSameNetworkState = _this.networkEnabled === otherClient.networkEnabled;
                        if (otherClientHasBetterNetworkState ||
                            (otherClientHasBetterVisibility &&
                                otherClientHasSameNetworkState)) {
                            return true;
                        }
                    }
                    return false;
                });
                return preferredCandidate === undefined;
            });
        })
            .next(function (canActAsPrimary) {
            if (_this.isPrimary !== canActAsPrimary) {
                debug(LOG_TAG$1, "Client " + (canActAsPrimary ? 'is' : 'is not') + " eligible for a primary lease.");
            }
            return canActAsPrimary;
        });
    };
    IndexedDbPersistence.prototype.shutdown = function () {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // The shutdown() operations are idempotent and can be called even when
                        // start() aborted (e.g. because it couldn't acquire the persistence lease).
                        this._started = false;
                        this.markClientZombied();
                        if (this.clientMetadataRefresher) {
                            this.clientMetadataRefresher.cancel();
                            this.clientMetadataRefresher = null;
                        }
                        this.detachVisibilityHandler();
                        this.detachWindowUnloadHook();
                        return [4 /*yield*/, this.simpleDb.runTransaction('readwrite-idempotent', [DbPrimaryClient.store, DbClientMetadata.store], function (txn) {
                                return _this.releasePrimaryLeaseIfHeld(txn).next(function () {
                                    return _this.removeClientMetadata(txn);
                                });
                            })];
                    case 1:
                        _a.sent();
                        this.simpleDb.close();
                        // Remove the entry marking the client as zombied from LocalStorage since
                        // we successfully deleted its metadata from IndexedDb.
                        this.removeClientZombiedEntry();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Returns clients that are not zombied and have an updateTime within the
     * provided threshold.
     */
    IndexedDbPersistence.prototype.filterActiveClients = function (clients, activityThresholdMs) {
        var _this = this;
        return clients.filter(function (client) {
            return _this.isWithinAge(client.updateTimeMs, activityThresholdMs) &&
                !_this.isClientZombied(client.clientId);
        });
    };
    IndexedDbPersistence.prototype.getActiveClients = function () {
        var _this = this;
        return this.simpleDb.runTransaction('readonly-idempotent', [DbClientMetadata.store], function (txn) {
            return clientMetadataStore(txn)
                .loadAll()
                .next(function (clients) {
                return _this.filterActiveClients(clients, MAX_CLIENT_AGE_MS).map(function (clientMetadata) { return clientMetadata.clientId; });
            });
        });
    };
    IndexedDbPersistence.clearPersistence = function (persistenceKey) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var dbName;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!IndexedDbPersistence.isAvailable()) {
                            return [2 /*return*/, Promise.resolve()];
                        }
                        dbName = persistenceKey + IndexedDbPersistence.MAIN_DATABASE;
                        return [4 /*yield*/, SimpleDb.delete(dbName)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(IndexedDbPersistence.prototype, "started", {
        get: function () {
            return this._started;
        },
        enumerable: true,
        configurable: true
    });
    IndexedDbPersistence.prototype.getMutationQueue = function (user) {
        assert(this.started, 'Cannot initialize MutationQueue before persistence is started.');
        return IndexedDbMutationQueue.forUser(user, this.serializer, this.indexManager, this.referenceDelegate);
    };
    IndexedDbPersistence.prototype.getTargetCache = function () {
        assert(this.started, 'Cannot initialize TargetCache before persistence is started.');
        return this.targetCache;
    };
    IndexedDbPersistence.prototype.getRemoteDocumentCache = function () {
        assert(this.started, 'Cannot initialize RemoteDocumentCache before persistence is started.');
        return this.remoteDocumentCache;
    };
    IndexedDbPersistence.prototype.getIndexManager = function () {
        assert(this.started, 'Cannot initialize IndexManager before persistence is started.');
        return this.indexManager;
    };
    IndexedDbPersistence.prototype.runTransaction = function (action, mode, transactionOperation) {
        var _this = this;
        debug(LOG_TAG$1, 'Starting transaction:', action);
        // TODO(schmidt-sebastian): Simplify once all transactions are idempotent.
        var idempotent = mode.endsWith('idempotent');
        var readonly = mode.startsWith('readonly');
        var simpleDbMode = readonly
            ? idempotent
                ? 'readonly-idempotent'
                : 'readonly'
            : idempotent
                ? 'readwrite-idempotent'
                : 'readwrite';
        var persistenceTransaction;
        // Do all transactions as readwrite against all object stores, since we
        // are the only reader/writer.
        return this.simpleDb
            .runTransaction(simpleDbMode, ALL_STORES, function (simpleDbTxn) {
            persistenceTransaction = new IndexedDbTransaction(simpleDbTxn, _this.listenSequence.next());
            if (mode === 'readwrite-primary' ||
                mode === 'readwrite-primary-idempotent') {
                // While we merely verify that we have (or can acquire) the lease
                // immediately, we wait to extend the primary lease until after
                // executing transactionOperation(). This ensures that even if the
                // transactionOperation takes a long time, we'll use a recent
                // leaseTimestampMs in the extended (or newly acquired) lease.
                return _this.verifyPrimaryLease(simpleDbTxn)
                    .next(function (holdsPrimaryLease) {
                    if (holdsPrimaryLease) {
                        return /* holdsPrimaryLease= */ true;
                    }
                    return _this.canActAsPrimary(simpleDbTxn);
                })
                    .next(function (holdsPrimaryLease) {
                    if (!holdsPrimaryLease) {
                        error("Failed to obtain primary lease for action '" + action + "'.");
                        _this.isPrimary = false;
                        _this.queue.enqueueAndForget(function () {
                            return _this.primaryStateListener(false);
                        });
                        throw new FirestoreError(Code.FAILED_PRECONDITION, PRIMARY_LEASE_LOST_ERROR_MSG);
                    }
                    return transactionOperation(persistenceTransaction);
                })
                    .next(function (result) {
                    return _this.acquireOrExtendPrimaryLease(simpleDbTxn).next(function () { return result; });
                });
            }
            else {
                return _this.verifyAllowTabSynchronization(simpleDbTxn).next(function () {
                    return transactionOperation(persistenceTransaction);
                });
            }
        })
            .then(function (result) {
            persistenceTransaction.raiseOnCommittedEvent();
            return result;
        });
    };
    /**
     * Verifies that the current tab is the primary leaseholder or alternatively
     * that the leaseholder has opted into multi-tab synchronization.
     */
    // TODO(b/114226234): Remove this check when `synchronizeTabs` can no longer
    // be turned off.
    IndexedDbPersistence.prototype.verifyAllowTabSynchronization = function (txn) {
        var _this = this;
        var store = primaryClientStore(txn);
        return store.get(DbPrimaryClient.key).next(function (currentPrimary) {
            var currentLeaseIsValid = currentPrimary !== null &&
                _this.isWithinAge(currentPrimary.leaseTimestampMs, MAX_PRIMARY_ELIGIBLE_AGE_MS) &&
                !_this.isClientZombied(currentPrimary.ownerId);
            if (currentLeaseIsValid && !_this.isLocalClient(currentPrimary)) {
                if (!currentPrimary.allowTabSynchronization) {
                    throw new FirestoreError(Code.FAILED_PRECONDITION, PRIMARY_LEASE_EXCLUSIVE_ERROR_MSG);
                }
            }
        });
    };
    /**
     * Obtains or extends the new primary lease for the local client. This
     * method does not verify that the client is eligible for this lease.
     */
    IndexedDbPersistence.prototype.acquireOrExtendPrimaryLease = function (txn) {
        var newPrimary = new DbPrimaryClient(this.clientId, this.allowTabSynchronization, Date.now());
        return primaryClientStore(txn).put(DbPrimaryClient.key, newPrimary);
    };
    IndexedDbPersistence.isAvailable = function () {
        return SimpleDb.isAvailable();
    };
    /**
     * Generates a string used as a prefix when storing data in IndexedDB and
     * LocalStorage.
     */
    IndexedDbPersistence.buildStoragePrefix = function (databaseInfo) {
        // Use two different prefix formats:
        //
        //   * firestore / persistenceKey / projectID . databaseID / ...
        //   * firestore / persistenceKey / projectID / ...
        //
        // projectIDs are DNS-compatible names and cannot contain dots
        // so there's no danger of collisions.
        var database = databaseInfo.databaseId.projectId;
        if (!databaseInfo.databaseId.isDefaultDatabase) {
            database += '.' + databaseInfo.databaseId.database;
        }
        return 'firestore/' + databaseInfo.persistenceKey + '/' + database + '/';
    };
    /** Checks the primary lease and removes it if we are the current primary. */
    IndexedDbPersistence.prototype.releasePrimaryLeaseIfHeld = function (txn) {
        var _this = this;
        var store = primaryClientStore(txn);
        return store.get(DbPrimaryClient.key).next(function (primaryClient) {
            if (_this.isLocalClient(primaryClient)) {
                debug(LOG_TAG$1, 'Releasing primary lease.');
                return store.delete(DbPrimaryClient.key);
            }
            else {
                return PersistencePromise.resolve();
            }
        });
    };
    /** Verifies that `updateTimeMs` is within `maxAgeMs`. */
    IndexedDbPersistence.prototype.isWithinAge = function (updateTimeMs, maxAgeMs) {
        var now = Date.now();
        var minAcceptable = now - maxAgeMs;
        var maxAcceptable = now;
        if (updateTimeMs < minAcceptable) {
            return false;
        }
        else if (updateTimeMs > maxAcceptable) {
            error("Detected an update time that is in the future: " + updateTimeMs + " > " + maxAcceptable);
            return false;
        }
        return true;
    };
    IndexedDbPersistence.prototype.attachVisibilityHandler = function () {
        var _this = this;
        if (this.document !== null &&
            typeof this.document.addEventListener === 'function') {
            this.documentVisibilityHandler = function () {
                _this.queue.enqueueAndForget(function () {
                    _this.inForeground = _this.document.visibilityState === 'visible';
                    return _this.updateClientMetadataAndTryBecomePrimary();
                });
            };
            this.document.addEventListener('visibilitychange', this.documentVisibilityHandler);
            this.inForeground = this.document.visibilityState === 'visible';
        }
    };
    IndexedDbPersistence.prototype.detachVisibilityHandler = function () {
        if (this.documentVisibilityHandler) {
            assert(this.document !== null &&
                typeof this.document.addEventListener === 'function', "Expected 'document.addEventListener' to be a function");
            this.document.removeEventListener('visibilitychange', this.documentVisibilityHandler);
            this.documentVisibilityHandler = null;
        }
    };
    /**
     * Attaches a window.unload handler that will synchronously write our
     * clientId to a "zombie client id" location in LocalStorage. This can be used
     * by tabs trying to acquire the primary lease to determine that the lease
     * is no longer valid even if the timestamp is recent. This is particularly
     * important for the refresh case (so the tab correctly re-acquires the
     * primary lease). LocalStorage is used for this rather than IndexedDb because
     * it is a synchronous API and so can be used reliably from  an unload
     * handler.
     */
    IndexedDbPersistence.prototype.attachWindowUnloadHook = function () {
        var _this = this;
        if (typeof this.window.addEventListener === 'function') {
            this.windowUnloadHandler = function () {
                // Note: In theory, this should be scheduled on the AsyncQueue since it
                // accesses internal state. We execute this code directly during shutdown
                // to make sure it gets a chance to run.
                _this.markClientZombied();
                _this.queue.enqueueAndForget(function () {
                    // Attempt graceful shutdown (including releasing our primary lease),
                    // but there's no guarantee it will complete.
                    return _this.shutdown();
                });
            };
            this.window.addEventListener('unload', this.windowUnloadHandler);
        }
    };
    IndexedDbPersistence.prototype.detachWindowUnloadHook = function () {
        if (this.windowUnloadHandler) {
            assert(typeof this.window.removeEventListener === 'function', "Expected 'window.removeEventListener' to be a function");
            this.window.removeEventListener('unload', this.windowUnloadHandler);
            this.windowUnloadHandler = null;
        }
    };
    /**
     * Returns whether a client is "zombied" based on its LocalStorage entry.
     * Clients become zombied when their tab closes without running all of the
     * cleanup logic in `shutdown()`.
     */
    IndexedDbPersistence.prototype.isClientZombied = function (clientId) {
        try {
            var isZombied = this.webStorage.getItem(this.zombiedClientLocalStorageKey(clientId)) !==
                null;
            debug(LOG_TAG$1, "Client '" + clientId + "' " + (isZombied ? 'is' : 'is not') + " zombied in LocalStorage");
            return isZombied;
        }
        catch (e) {
            // Gracefully handle if LocalStorage isn't working.
            error(LOG_TAG$1, 'Failed to get zombied client id.', e);
            return false;
        }
    };
    /**
     * Record client as zombied (a client that had its tab closed). Zombied
     * clients are ignored during primary tab selection.
     */
    IndexedDbPersistence.prototype.markClientZombied = function () {
        try {
            this.webStorage.setItem(this.zombiedClientLocalStorageKey(this.clientId), String(Date.now()));
        }
        catch (e) {
            // Gracefully handle if LocalStorage isn't available / working.
            error('Failed to set zombie client id.', e);
        }
    };
    /** Removes the zombied client entry if it exists. */
    IndexedDbPersistence.prototype.removeClientZombiedEntry = function () {
        try {
            this.webStorage.removeItem(this.zombiedClientLocalStorageKey(this.clientId));
        }
        catch (e) {
            // Ignore
        }
    };
    IndexedDbPersistence.prototype.zombiedClientLocalStorageKey = function (clientId) {
        return ZOMBIED_CLIENTS_KEY_PREFIX + "_" + this.persistenceKey + "_" + clientId;
    };
    /**
     * The name of the main (and currently only) IndexedDB database. this name is
     * appended to the prefix provided to the IndexedDbPersistence constructor.
     */
    IndexedDbPersistence.MAIN_DATABASE = 'main';
    return IndexedDbPersistence;
}());
function isPrimaryLeaseLostError(err) {
    return (err.code === Code.FAILED_PRECONDITION &&
        err.message === PRIMARY_LEASE_LOST_ERROR_MSG);
}
/**
 * Verifies the error thrown by a LocalStore operation. If a LocalStore
 * operation fails because the primary lease has been taken by another client,
 * we ignore the error (the persistence layer will immediately call
 * `applyPrimaryLease` to propagate the primary state change). All other errors
 * are re-thrown.
 *
 * @param err An error returned by a LocalStore operation.
 * @return A Promise that resolves after we recovered, or the original error.
 */
function ignoreIfPrimaryLeaseLoss(err) {
    return tslib.__awaiter(this, void 0, void 0, function () {
        return tslib.__generator(this, function (_a) {
            if (isPrimaryLeaseLostError(err)) {
                debug(LOG_TAG$1, 'Unexpectedly lost primary lease');
            }
            else {
                throw err;
            }
            return [2 /*return*/];
        });
    });
}
/**
 * Helper to get a typed SimpleDbStore for the primary client object store.
 */
function primaryClientStore(txn) {
    return txn.store(DbPrimaryClient.store);
}
/**
 * Helper to get a typed SimpleDbStore for the client metadata object store.
 */
function clientMetadataStore(txn) {
    return txn.store(DbClientMetadata.store);
}
/** Provides LRU functionality for IndexedDB persistence. */
var IndexedDbLruDelegate = /** @class */ (function () {
    function IndexedDbLruDelegate(db, params) {
        this.db = db;
        this.inMemoryPins = null;
        this.garbageCollector = new LruGarbageCollector(this, params);
    }
    IndexedDbLruDelegate.prototype.getSequenceNumberCount = function (txn) {
        var docCountPromise = this.orphanedDocmentCount(txn);
        var targetCountPromise = this.db.getTargetCache().getTargetCount(txn);
        return targetCountPromise.next(function (targetCount) {
            return docCountPromise.next(function (docCount) { return targetCount + docCount; });
        });
    };
    IndexedDbLruDelegate.prototype.orphanedDocmentCount = function (txn) {
        var orphanedCount = 0;
        return this.forEachOrphanedDocumentSequenceNumber(txn, function (_) {
            orphanedCount++;
        }).next(function () { return orphanedCount; });
    };
    IndexedDbLruDelegate.prototype.forEachTarget = function (txn, f) {
        return this.db.getTargetCache().forEachTarget(txn, f);
    };
    IndexedDbLruDelegate.prototype.forEachOrphanedDocumentSequenceNumber = function (txn, f) {
        return this.forEachOrphanedDocument(txn, function (docKey, sequenceNumber) {
            return f(sequenceNumber);
        });
    };
    IndexedDbLruDelegate.prototype.setInMemoryPins = function (inMemoryPins) {
        this.inMemoryPins = inMemoryPins;
    };
    IndexedDbLruDelegate.prototype.addReference = function (txn, key) {
        return writeSentinelKey(txn, key);
    };
    IndexedDbLruDelegate.prototype.removeReference = function (txn, key) {
        return writeSentinelKey(txn, key);
    };
    IndexedDbLruDelegate.prototype.removeTargets = function (txn, upperBound, activeTargetIds) {
        return this.db
            .getTargetCache()
            .removeTargets(txn, upperBound, activeTargetIds);
    };
    IndexedDbLruDelegate.prototype.removeMutationReference = function (txn, key) {
        return writeSentinelKey(txn, key);
    };
    /**
     * Returns true if anything would prevent this document from being garbage
     * collected, given that the document in question is not present in any
     * targets and has a sequence number less than or equal to the upper bound for
     * the collection run.
     */
    IndexedDbLruDelegate.prototype.isPinned = function (txn, docKey) {
        if (this.inMemoryPins.containsKey(docKey)) {
            return PersistencePromise.resolve(true);
        }
        else {
            return mutationQueuesContainKey(txn, docKey);
        }
    };
    IndexedDbLruDelegate.prototype.removeOrphanedDocuments = function (txn, upperBound) {
        var _this = this;
        var documentCache = this.db.getRemoteDocumentCache();
        var changeBuffer = documentCache.newChangeBuffer();
        var promises = [];
        var documentCount = 0;
        var iteration = this.forEachOrphanedDocument(txn, function (docKey, sequenceNumber) {
            if (sequenceNumber <= upperBound) {
                var p = _this.isPinned(txn, docKey).next(function (isPinned) {
                    if (!isPinned) {
                        documentCount++;
                        // Our size accounting requires us to read all documents before
                        // removing them.
                        return changeBuffer.getEntry(txn, docKey).next(function () {
                            changeBuffer.removeEntry(docKey);
                            return documentTargetStore(txn).delete(sentinelKey$1(docKey));
                        });
                    }
                });
                promises.push(p);
            }
        });
        return iteration
            .next(function () { return PersistencePromise.waitFor(promises); })
            .next(function () { return changeBuffer.apply(txn); })
            .next(function () { return documentCount; });
    };
    IndexedDbLruDelegate.prototype.removeTarget = function (txn, targetData) {
        var updated = targetData.withSequenceNumber(txn.currentSequenceNumber);
        return this.db.getTargetCache().updateTargetData(txn, updated);
    };
    IndexedDbLruDelegate.prototype.updateLimboDocument = function (txn, key) {
        return writeSentinelKey(txn, key);
    };
    /**
     * Call provided function for each document in the cache that is 'orphaned'. Orphaned
     * means not a part of any target, so the only entry in the target-document index for
     * that document will be the sentinel row (targetId 0), which will also have the sequence
     * number for the last time the document was accessed.
     */
    IndexedDbLruDelegate.prototype.forEachOrphanedDocument = function (txn, f) {
        var store = documentTargetStore(txn);
        var nextToReport = ListenSequence.INVALID;
        var nextPath;
        return store
            .iterate({
            index: DbTargetDocument.documentTargetsIndex
        }, function (_a, _b) {
            var targetId = _a[0], docKey = _a[1];
            var path = _b.path, sequenceNumber = _b.sequenceNumber;
            if (targetId === 0) {
                // if nextToReport is valid, report it, this is a new key so the
                // last one must not be a member of any targets.
                if (nextToReport !== ListenSequence.INVALID) {
                    f(new DocumentKey(decode(nextPath)), nextToReport);
                }
                // set nextToReport to be this sequence number. It's the next one we
                // might report, if we don't find any targets for this document.
                // Note that the sequence number must be defined when the targetId
                // is 0.
                nextToReport = sequenceNumber;
                nextPath = path;
            }
            else {
                // set nextToReport to be invalid, we know we don't need to report
                // this one since we found a target for it.
                nextToReport = ListenSequence.INVALID;
            }
        })
            .next(function () {
            // Since we report sequence numbers after getting to the next key, we
            // need to check if the last key we iterated over was an orphaned
            // document and report it.
            if (nextToReport !== ListenSequence.INVALID) {
                f(new DocumentKey(decode(nextPath)), nextToReport);
            }
        });
    };
    IndexedDbLruDelegate.prototype.getCacheSize = function (txn) {
        return this.db.getRemoteDocumentCache().getSize(txn);
    };
    return IndexedDbLruDelegate;
}());
function sentinelKey$1(key) {
    return [0, encode(key.path)];
}
/**
 * @return A value suitable for writing a sentinel row in the target-document
 * store.
 */
function sentinelRow(key, sequenceNumber) {
    return new DbTargetDocument(0, encode(key.path), sequenceNumber);
}
function writeSentinelKey(txn, key) {
    return documentTargetStore(txn).put(sentinelRow(key, txn.currentSequenceNumber));
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A readonly view of the local state of all documents we're tracking (i.e. we
 * have a cached version in remoteDocumentCache or local mutations for the
 * document). The view is computed by applying the mutations in the
 * MutationQueue to the RemoteDocumentCache.
 */
var LocalDocumentsView = /** @class */ (function () {
    function LocalDocumentsView(remoteDocumentCache, mutationQueue, indexManager) {
        this.remoteDocumentCache = remoteDocumentCache;
        this.mutationQueue = mutationQueue;
        this.indexManager = indexManager;
    }
    /**
     * Get the local view of the document identified by `key`.
     *
     * @return Local view of the document or null if we don't have any cached
     * state for it.
     */
    LocalDocumentsView.prototype.getDocument = function (transaction, key) {
        var _this = this;
        return this.mutationQueue
            .getAllMutationBatchesAffectingDocumentKey(transaction, key)
            .next(function (batches) { return _this.getDocumentInternal(transaction, key, batches); });
    };
    /** Internal version of `getDocument` that allows reusing batches. */
    LocalDocumentsView.prototype.getDocumentInternal = function (transaction, key, inBatches) {
        return this.remoteDocumentCache.getEntry(transaction, key).next(function (doc) {
            for (var _i = 0, inBatches_1 = inBatches; _i < inBatches_1.length; _i++) {
                var batch = inBatches_1[_i];
                doc = batch.applyToLocalView(key, doc);
            }
            return doc;
        });
    };
    // Returns the view of the given `docs` as they would appear after applying
    // all mutations in the given `batches`.
    LocalDocumentsView.prototype.applyLocalMutationsToDocuments = function (transaction, docs, batches) {
        var results = nullableMaybeDocumentMap();
        docs.forEach(function (key, localView) {
            for (var _i = 0, batches_1 = batches; _i < batches_1.length; _i++) {
                var batch = batches_1[_i];
                localView = batch.applyToLocalView(key, localView);
            }
            results = results.insert(key, localView);
        });
        return results;
    };
    /**
     * Gets the local view of the documents identified by `keys`.
     *
     * If we don't have cached state for a document in `keys`, a NoDocument will
     * be stored for that key in the resulting set.
     */
    LocalDocumentsView.prototype.getDocuments = function (transaction, keys) {
        var _this = this;
        return this.remoteDocumentCache
            .getEntries(transaction, keys)
            .next(function (docs) { return _this.getLocalViewOfDocuments(transaction, docs); });
    };
    /**
     * Similar to `getDocuments`, but creates the local view from the given
     * `baseDocs` without retrieving documents from the local store.
     */
    LocalDocumentsView.prototype.getLocalViewOfDocuments = function (transaction, baseDocs) {
        var _this = this;
        return this.mutationQueue
            .getAllMutationBatchesAffectingDocumentKeys(transaction, baseDocs)
            .next(function (batches) {
            var docs = _this.applyLocalMutationsToDocuments(transaction, baseDocs, batches);
            var results = maybeDocumentMap();
            docs.forEach(function (key, maybeDoc) {
                // TODO(http://b/32275378): Don't conflate missing / deleted.
                if (!maybeDoc) {
                    maybeDoc = new NoDocument(key, SnapshotVersion.forDeletedDoc());
                }
                results = results.insert(key, maybeDoc);
            });
            return results;
        });
    };
    /**
     * Performs a query against the local view of all documents.
     *
     * @param transaction The persistence transaction.
     * @param query The query to match documents against.
     * @param sinceReadTime If not set to SnapshotVersion.MIN, return only
     *     documents that have been read since this snapshot version (exclusive).
     */
    LocalDocumentsView.prototype.getDocumentsMatchingQuery = function (transaction, query, sinceReadTime) {
        if (query.isDocumentQuery()) {
            return this.getDocumentsMatchingDocumentQuery(transaction, query.path);
        }
        else if (query.isCollectionGroupQuery()) {
            return this.getDocumentsMatchingCollectionGroupQuery(transaction, query, sinceReadTime);
        }
        else {
            return this.getDocumentsMatchingCollectionQuery(transaction, query, sinceReadTime);
        }
    };
    LocalDocumentsView.prototype.getDocumentsMatchingDocumentQuery = function (transaction, docPath) {
        // Just do a simple document lookup.
        return this.getDocument(transaction, new DocumentKey(docPath)).next(function (maybeDoc) {
            var result = documentMap();
            if (maybeDoc instanceof Document) {
                result = result.insert(maybeDoc.key, maybeDoc);
            }
            return result;
        });
    };
    LocalDocumentsView.prototype.getDocumentsMatchingCollectionGroupQuery = function (transaction, query, sinceReadTime) {
        var _this = this;
        assert(query.path.isEmpty(), 'Currently we only support collection group queries at the root.');
        var collectionId = query.collectionGroup;
        var results = documentMap();
        return this.indexManager
            .getCollectionParents(transaction, collectionId)
            .next(function (parents) {
            // Perform a collection query against each parent that contains the
            // collectionId and aggregate the results.
            return PersistencePromise.forEach(parents, function (parent) {
                var collectionQuery = query.asCollectionQueryAtPath(parent.child(collectionId));
                return _this.getDocumentsMatchingCollectionQuery(transaction, collectionQuery, sinceReadTime).next(function (r) {
                    r.forEach(function (key, doc) {
                        results = results.insert(key, doc);
                    });
                });
            }).next(function () { return results; });
        });
    };
    LocalDocumentsView.prototype.getDocumentsMatchingCollectionQuery = function (transaction, query, sinceReadTime) {
        var _this = this;
        // Query the remote documents and overlay mutations.
        var results;
        var mutationBatches;
        return this.remoteDocumentCache
            .getDocumentsMatchingQuery(transaction, query, sinceReadTime)
            .next(function (queryResults) {
            results = queryResults;
            return _this.mutationQueue.getAllMutationBatchesAffectingQuery(transaction, query);
        })
            .next(function (matchingMutationBatches) {
            mutationBatches = matchingMutationBatches;
            // It is possible that a PatchMutation can make a document match a query, even if
            // the version in the RemoteDocumentCache is not a match yet (waiting for server
            // to ack). To handle this, we find all document keys affected by the PatchMutations
            // that are not in `result` yet, and back fill them via `remoteDocumentCache.getEntries`,
            // otherwise those `PatchMutations` will be ignored because no base document can be found,
            // and lead to missing result for the query.
            return _this.addMissingBaseDocuments(transaction, mutationBatches, results).next(function (mergedDocuments) {
                results = mergedDocuments;
                for (var _i = 0, mutationBatches_1 = mutationBatches; _i < mutationBatches_1.length; _i++) {
                    var batch = mutationBatches_1[_i];
                    for (var _a = 0, _b = batch.mutations; _a < _b.length; _a++) {
                        var mutation = _b[_a];
                        var key = mutation.key;
                        var baseDoc = results.get(key);
                        var mutatedDoc = mutation.applyToLocalView(baseDoc, baseDoc, batch.localWriteTime);
                        if (mutatedDoc instanceof Document) {
                            results = results.insert(key, mutatedDoc);
                        }
                        else {
                            results = results.remove(key);
                        }
                    }
                }
            });
        })
            .next(function () {
            // Finally, filter out any documents that don't actually match
            // the query.
            results.forEach(function (key, doc) {
                if (!query.matches(doc)) {
                    results = results.remove(key);
                }
            });
            return results;
        });
    };
    LocalDocumentsView.prototype.addMissingBaseDocuments = function (transaction, matchingMutationBatches, existingDocuments) {
        var missingBaseDocEntriesForPatching = documentKeySet();
        for (var _i = 0, matchingMutationBatches_1 = matchingMutationBatches; _i < matchingMutationBatches_1.length; _i++) {
            var batch = matchingMutationBatches_1[_i];
            for (var _a = 0, _b = batch.mutations; _a < _b.length; _a++) {
                var mutation = _b[_a];
                if (mutation instanceof PatchMutation &&
                    existingDocuments.get(mutation.key) === null) {
                    missingBaseDocEntriesForPatching = missingBaseDocEntriesForPatching.add(mutation.key);
                }
            }
        }
        var mergedDocuments = existingDocuments;
        return this.remoteDocumentCache
            .getEntries(transaction, missingBaseDocEntriesForPatching)
            .next(function (missingBaseDocs) {
            missingBaseDocs.forEach(function (key, doc) {
                if (doc !== null && doc instanceof Document) {
                    mergedDocuments = mergedDocuments.insert(key, doc);
                }
            });
            return mergedDocuments;
        });
    };
    return LocalDocumentsView;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A collection of references to a document from some kind of numbered entity
 * (either a target ID or batch ID). As references are added to or removed from
 * the set corresponding events are emitted to a registered garbage collector.
 *
 * Each reference is represented by a DocumentReference object. Each of them
 * contains enough information to uniquely identify the reference. They are all
 * stored primarily in a set sorted by key. A document is considered garbage if
 * there's no references in that set (this can be efficiently checked thanks to
 * sorting by key).
 *
 * ReferenceSet also keeps a secondary set that contains references sorted by
 * IDs. This one is used to efficiently implement removal of all references by
 * some target ID.
 */
var ReferenceSet = /** @class */ (function () {
    function ReferenceSet() {
        // A set of outstanding references to a document sorted by key.
        this.refsByKey = new SortedSet(DocReference.compareByKey);
        // A set of outstanding references to a document sorted by target id.
        this.refsByTarget = new SortedSet(DocReference.compareByTargetId);
    }
    /** Returns true if the reference set contains no references. */
    ReferenceSet.prototype.isEmpty = function () {
        return this.refsByKey.isEmpty();
    };
    /** Adds a reference to the given document key for the given ID. */
    ReferenceSet.prototype.addReference = function (key, id) {
        var ref = new DocReference(key, id);
        this.refsByKey = this.refsByKey.add(ref);
        this.refsByTarget = this.refsByTarget.add(ref);
    };
    /** Add references to the given document keys for the given ID. */
    ReferenceSet.prototype.addReferences = function (keys, id) {
        var _this = this;
        keys.forEach(function (key) { return _this.addReference(key, id); });
    };
    /**
     * Removes a reference to the given document key for the given
     * ID.
     */
    ReferenceSet.prototype.removeReference = function (key, id) {
        this.removeRef(new DocReference(key, id));
    };
    ReferenceSet.prototype.removeReferences = function (keys, id) {
        var _this = this;
        keys.forEach(function (key) { return _this.removeReference(key, id); });
    };
    /**
     * Clears all references with a given ID. Calls removeRef() for each key
     * removed.
     */
    ReferenceSet.prototype.removeReferencesForId = function (id) {
        var _this = this;
        var emptyKey = DocumentKey.EMPTY;
        var startRef = new DocReference(emptyKey, id);
        var endRef = new DocReference(emptyKey, id + 1);
        var keys = [];
        this.refsByTarget.forEachInRange([startRef, endRef], function (ref) {
            _this.removeRef(ref);
            keys.push(ref.key);
        });
        return keys;
    };
    ReferenceSet.prototype.removeAllReferences = function () {
        var _this = this;
        this.refsByKey.forEach(function (ref) { return _this.removeRef(ref); });
    };
    ReferenceSet.prototype.removeRef = function (ref) {
        this.refsByKey = this.refsByKey.delete(ref);
        this.refsByTarget = this.refsByTarget.delete(ref);
    };
    ReferenceSet.prototype.referencesForId = function (id) {
        var emptyKey = DocumentKey.EMPTY;
        var startRef = new DocReference(emptyKey, id);
        var endRef = new DocReference(emptyKey, id + 1);
        var keys = documentKeySet();
        this.refsByTarget.forEachInRange([startRef, endRef], function (ref) {
            keys = keys.add(ref.key);
        });
        return keys;
    };
    ReferenceSet.prototype.containsKey = function (key) {
        var ref = new DocReference(key, 0);
        var firstRef = this.refsByKey.firstAfterOrEqual(ref);
        return firstRef !== null && key.isEqual(firstRef.key);
    };
    return ReferenceSet;
}());
var DocReference = /** @class */ (function () {
    function DocReference(key, targetOrBatchId) {
        this.key = key;
        this.targetOrBatchId = targetOrBatchId;
    }
    /** Compare by key then by ID */
    DocReference.compareByKey = function (left, right) {
        return (DocumentKey.comparator(left.key, right.key) ||
            primitiveComparator(left.targetOrBatchId, right.targetOrBatchId));
    };
    /** Compare by ID then by key */
    DocReference.compareByTargetId = function (left, right) {
        return (primitiveComparator(left.targetOrBatchId, right.targetOrBatchId) ||
            DocumentKey.comparator(left.key, right.key));
    };
    return DocReference;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$2 = 'LocalStore';
/**
 * Local storage in the Firestore client. Coordinates persistence components
 * like the mutation queue and remote document cache to present a
 * latency-compensated view of stored data.
 *
 * The LocalStore is responsible for accepting mutations from the Sync Engine.
 * Writes from the client are put into a queue as provisional Mutations until
 * they are processed by the RemoteStore and confirmed as having been written
 * to the server.
 *
 * The local store provides the local version of documents that have been
 * modified locally. It maintains the constraint:
 *
 *   LocalDocument = RemoteDocument + Active(LocalMutations)
 *
 * (Active mutations are those that are enqueued and have not been previously
 * acknowledged or rejected).
 *
 * The RemoteDocument ("ground truth") state is provided via the
 * applyChangeBatch method. It will be some version of a server-provided
 * document OR will be a server-provided document PLUS acknowledged mutations:
 *
 *   RemoteDocument' = RemoteDocument + Acknowledged(LocalMutations)
 *
 * Note that this "dirty" version of a RemoteDocument will not be identical to a
 * server base version, since it has LocalMutations added to it pending getting
 * an authoritative copy from the server.
 *
 * Since LocalMutations can be rejected by the server, we have to be able to
 * revert a LocalMutation that has already been applied to the LocalDocument
 * (typically done by replaying all remaining LocalMutations to the
 * RemoteDocument to re-apply).
 *
 * The LocalStore is responsible for the garbage collection of the documents it
 * contains. For now, it every doc referenced by a view, the mutation queue, or
 * the RemoteStore.
 *
 * It also maintains the persistence of mapping queries to resume tokens and
 * target ids. It needs to know this data about queries to properly know what
 * docs it would be allowed to garbage collect.
 *
 * The LocalStore must be able to efficiently execute queries against its local
 * cache of the documents, to provide the initial set of results before any
 * remote changes have been received.
 *
 * Note: In TypeScript, most methods return Promises since the implementation
 * may rely on fetching data from IndexedDB which is async.
 * These Promises will only be rejected on an I/O error or other internal
 * (unexpected) failure (e.g. failed assert) and always represent an
 * unrecoverable error (should be caught / reported by the async_queue).
 */
var LocalStore = /** @class */ (function () {
    function LocalStore(
    /** Manages our in-memory or durable persistence. */
    persistence, queryEngine, initialUser) {
        this.persistence = persistence;
        this.queryEngine = queryEngine;
        /**
         * The set of document references maintained by any local views.
         */
        this.localViewReferences = new ReferenceSet();
        /**
         * Maps a targetID to data about its target.
         *
         * PORTING NOTE: We are using an immutable data structure on Web to make re-runs
         * of `applyRemoteEvent()` idempotent.
         */
        this.targetDataByTarget = new SortedMap(primitiveComparator);
        /** Maps a target to its targetID. */
        // TODO(wuandy): Evaluate if TargetId can be part of Target.
        this.targetIdByTarget = new ObjectMap(function (t) {
            return t.canonicalId();
        });
        /**
         * The read time of the last entry processed by `getNewDocumentChanges()`.
         *
         * PORTING NOTE: This is only used for multi-tab synchronization.
         */
        this.lastDocumentChangeReadTime = SnapshotVersion.MIN;
        assert(persistence.started, 'LocalStore was passed an unstarted persistence implementation');
        this.persistence.referenceDelegate.setInMemoryPins(this.localViewReferences);
        this.mutationQueue = persistence.getMutationQueue(initialUser);
        this.remoteDocuments = persistence.getRemoteDocumentCache();
        this.targetCache = persistence.getTargetCache();
        this.localDocuments = new LocalDocumentsView(this.remoteDocuments, this.mutationQueue, this.persistence.getIndexManager());
        this.queryEngine.setLocalDocumentsView(this.localDocuments);
    }
    /** Starts the LocalStore. */
    LocalStore.prototype.start = function () {
        return this.synchronizeLastDocumentChangeReadTime();
    };
    /**
     * Tells the LocalStore that the currently authenticated user has changed.
     *
     * In response the local store switches the mutation queue to the new user and
     * returns any resulting document changes.
     */
    // PORTING NOTE: Android and iOS only return the documents affected by the
    // change.
    LocalStore.prototype.handleUserChange = function (user) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var newMutationQueue, newLocalDocuments, result;
            var _this = this;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        newMutationQueue = this.mutationQueue;
                        newLocalDocuments = this.localDocuments;
                        return [4 /*yield*/, this.persistence.runTransaction('Handle user change', 'readonly-idempotent', function (txn) {
                                // Swap out the mutation queue, grabbing the pending mutation batches
                                // before and after.
                                var oldBatches;
                                return _this.mutationQueue
                                    .getAllMutationBatches(txn)
                                    .next(function (promisedOldBatches) {
                                    oldBatches = promisedOldBatches;
                                    newMutationQueue = _this.persistence.getMutationQueue(user);
                                    // Recreate our LocalDocumentsView using the new
                                    // MutationQueue.
                                    newLocalDocuments = new LocalDocumentsView(_this.remoteDocuments, newMutationQueue, _this.persistence.getIndexManager());
                                    return newMutationQueue.getAllMutationBatches(txn);
                                })
                                    .next(function (newBatches) {
                                    var removedBatchIds = [];
                                    var addedBatchIds = [];
                                    // Union the old/new changed keys.
                                    var changedKeys = documentKeySet();
                                    for (var _i = 0, oldBatches_1 = oldBatches; _i < oldBatches_1.length; _i++) {
                                        var batch = oldBatches_1[_i];
                                        removedBatchIds.push(batch.batchId);
                                        for (var _a = 0, _b = batch.mutations; _a < _b.length; _a++) {
                                            var mutation = _b[_a];
                                            changedKeys = changedKeys.add(mutation.key);
                                        }
                                    }
                                    for (var _c = 0, newBatches_1 = newBatches; _c < newBatches_1.length; _c++) {
                                        var batch = newBatches_1[_c];
                                        addedBatchIds.push(batch.batchId);
                                        for (var _d = 0, _e = batch.mutations; _d < _e.length; _d++) {
                                            var mutation = _e[_d];
                                            changedKeys = changedKeys.add(mutation.key);
                                        }
                                    }
                                    // Return the set of all (potentially) changed documents and the list
                                    // of mutation batch IDs that were affected by change.
                                    return newLocalDocuments
                                        .getDocuments(txn, changedKeys)
                                        .next(function (affectedDocuments) {
                                        return {
                                            affectedDocuments: affectedDocuments,
                                            removedBatchIds: removedBatchIds,
                                            addedBatchIds: addedBatchIds
                                        };
                                    });
                                });
                            })];
                    case 1:
                        result = _a.sent();
                        this.mutationQueue = newMutationQueue;
                        this.localDocuments = newLocalDocuments;
                        this.queryEngine.setLocalDocumentsView(this.localDocuments);
                        return [2 /*return*/, result];
                }
            });
        });
    };
    /* Accept locally generated Mutations and commit them to storage. */
    LocalStore.prototype.localWrite = function (mutations) {
        var _this = this;
        var localWriteTime = Timestamp.now();
        var keys = mutations.reduce(function (keys, m) { return keys.add(m.key); }, documentKeySet());
        var existingDocs;
        return this.persistence
            .runTransaction('Locally write mutations', 'readwrite-idempotent', function (txn) {
            // Load and apply all existing mutations. This lets us compute the
            // current base state for all non-idempotent transforms before applying
            // any additional user-provided writes.
            return _this.localDocuments.getDocuments(txn, keys).next(function (docs) {
                existingDocs = docs;
                // For non-idempotent mutations (such as `FieldValue.increment()`),
                // we record the base state in a separate patch mutation. This is
                // later used to guarantee consistent values and prevents flicker
                // even if the backend sends us an update that already includes our
                // transform.
                var baseMutations = [];
                for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
                    var mutation = mutations_1[_i];
                    var baseValue = mutation.extractBaseValue(existingDocs.get(mutation.key));
                    if (baseValue != null) {
                        // NOTE: The base state should only be applied if there's some
                        // existing document to override, so use a Precondition of
                        // exists=true
                        baseMutations.push(new PatchMutation(mutation.key, baseValue, baseValue.fieldMask(), Precondition.exists(true)));
                    }
                }
                return _this.mutationQueue.addMutationBatch(txn, localWriteTime, baseMutations, mutations);
            });
        })
            .then(function (batch) {
            var changes = batch.applyToLocalDocumentSet(existingDocs);
            return { batchId: batch.batchId, changes: changes };
        });
    };
    /** Returns the local view of the documents affected by a mutation batch. */
    // PORTING NOTE: Multi-tab only.
    LocalStore.prototype.lookupMutationDocuments = function (batchId) {
        var _this = this;
        return this.persistence.runTransaction('Lookup mutation documents', 'readonly-idempotent', function (txn) {
            return _this.mutationQueue
                .lookupMutationKeys(txn, batchId)
                .next(function (keys) {
                if (keys) {
                    return _this.localDocuments.getDocuments(txn, keys);
                }
                else {
                    return PersistencePromise.resolve(null);
                }
            });
        });
    };
    /**
     * Acknowledge the given batch.
     *
     * On the happy path when a batch is acknowledged, the local store will
     *
     *  + remove the batch from the mutation queue;
     *  + apply the changes to the remote document cache;
     *  + recalculate the latency compensated view implied by those changes (there
     *    may be mutations in the queue that affect the documents but haven't been
     *    acknowledged yet); and
     *  + give the changed documents back the sync engine
     *
     * @returns The resulting (modified) documents.
     */
    LocalStore.prototype.acknowledgeBatch = function (batchResult) {
        var _this = this;
        return this.persistence.runTransaction('Acknowledge batch', 'readwrite-primary-idempotent', function (txn) {
            var affected = batchResult.batch.keys();
            var documentBuffer = _this.remoteDocuments.newChangeBuffer({
                trackRemovals: true // Make sure document removals show up in `getNewDocumentChanges()`
            });
            return _this.mutationQueue
                .acknowledgeBatch(txn, batchResult.batch, batchResult.streamToken)
                .next(function () {
                return _this.applyWriteToRemoteDocuments(txn, batchResult, documentBuffer);
            })
                .next(function () { return documentBuffer.apply(txn); })
                .next(function () { return _this.mutationQueue.performConsistencyCheck(txn); })
                .next(function () { return _this.localDocuments.getDocuments(txn, affected); });
        });
    };
    /**
     * Remove mutations from the MutationQueue for the specified batch;
     * LocalDocuments will be recalculated.
     *
     * @returns The resulting modified documents.
     */
    LocalStore.prototype.rejectBatch = function (batchId) {
        var _this = this;
        return this.persistence.runTransaction('Reject batch', 'readwrite-primary-idempotent', function (txn) {
            var affectedKeys;
            return _this.mutationQueue
                .lookupMutationBatch(txn, batchId)
                .next(function (batch) {
                assert(batch !== null, 'Attempt to reject nonexistent batch!');
                affectedKeys = batch.keys();
                return _this.mutationQueue.removeMutationBatch(txn, batch);
            })
                .next(function () {
                return _this.mutationQueue.performConsistencyCheck(txn);
            })
                .next(function () {
                return _this.localDocuments.getDocuments(txn, affectedKeys);
            });
        });
    };
    /**
     * Returns the largest (latest) batch id in mutation queue that is pending server response.
     * Returns `BATCHID_UNKNOWN` if the queue is empty.
     */
    LocalStore.prototype.getHighestUnacknowledgedBatchId = function () {
        var _this = this;
        return this.persistence.runTransaction('Get highest unacknowledged batch id', 'readonly-idempotent', function (txn) {
            return _this.mutationQueue.getHighestUnacknowledgedBatchId(txn);
        });
    };
    /** Returns the last recorded stream token for the current user. */
    LocalStore.prototype.getLastStreamToken = function () {
        var _this = this;
        return this.persistence.runTransaction('Get last stream token', 'readonly-idempotent', function (txn) {
            return _this.mutationQueue.getLastStreamToken(txn);
        });
    };
    /**
     * Sets the stream token for the current user without acknowledging any
     * mutation batch. This is usually only useful after a stream handshake or in
     * response to an error that requires clearing the stream token.
     */
    LocalStore.prototype.setLastStreamToken = function (streamToken) {
        var _this = this;
        return this.persistence.runTransaction('Set last stream token', 'readwrite-primary-idempotent', function (txn) {
            return _this.mutationQueue.setLastStreamToken(txn, streamToken);
        });
    };
    /**
     * Returns the last consistent snapshot processed (used by the RemoteStore to
     * determine whether to buffer incoming snapshots from the backend).
     */
    LocalStore.prototype.getLastRemoteSnapshotVersion = function () {
        var _this = this;
        return this.persistence.runTransaction('Get last remote snapshot version', 'readonly-idempotent', function (txn) { return _this.targetCache.getLastRemoteSnapshotVersion(txn); });
    };
    /**
     * Update the "ground-state" (remote) documents. We assume that the remote
     * event reflects any write batches that have been acknowledged or rejected
     * (i.e. we do not re-apply local mutations to updates from this event).
     *
     * LocalDocuments are re-calculated if there are remaining mutations in the
     * queue.
     */
    LocalStore.prototype.applyRemoteEvent = function (remoteEvent) {
        var _this = this;
        var remoteVersion = remoteEvent.snapshotVersion;
        var newTargetDataByTargetMap = this.targetDataByTarget;
        return this.persistence
            .runTransaction('Apply remote event', 'readwrite-primary-idempotent', function (txn) {
            var documentBuffer = _this.remoteDocuments.newChangeBuffer({
                trackRemovals: true // Make sure document removals show up in `getNewDocumentChanges()`
            });
            // Reset newTargetDataByTargetMap in case this transaction gets re-run.
            newTargetDataByTargetMap = _this.targetDataByTarget;
            var promises = [];
            forEachNumber(remoteEvent.targetChanges, function (targetId, change) {
                var oldTargetData = newTargetDataByTargetMap.get(targetId);
                if (!oldTargetData) {
                    return;
                }
                // Only update the remote keys if the target is still active. This
                // ensures that we can persist the updated target data along with
                // the updated assignment.
                promises.push(_this.targetCache
                    .removeMatchingKeys(txn, change.removedDocuments, targetId)
                    .next(function () {
                    return _this.targetCache.addMatchingKeys(txn, change.addedDocuments, targetId);
                }));
                var resumeToken = change.resumeToken;
                // Update the resume token if the change includes one.
                if (resumeToken.length > 0) {
                    var newTargetData = oldTargetData
                        .withResumeToken(resumeToken, remoteVersion)
                        .withSequenceNumber(txn.currentSequenceNumber);
                    newTargetDataByTargetMap = newTargetDataByTargetMap.insert(targetId, newTargetData);
                    // Update the target data if there are target changes (or if
                    // sufficient time has passed since the last update).
                    if (LocalStore.shouldPersistTargetData(oldTargetData, newTargetData, change)) {
                        promises.push(_this.targetCache.updateTargetData(txn, newTargetData));
                    }
                }
            });
            var changedDocs = maybeDocumentMap();
            var updatedKeys = documentKeySet();
            remoteEvent.documentUpdates.forEach(function (key, doc) {
                updatedKeys = updatedKeys.add(key);
            });
            // Each loop iteration only affects its "own" doc, so it's safe to get all the remote
            // documents in advance in a single call.
            promises.push(documentBuffer.getEntries(txn, updatedKeys).next(function (existingDocs) {
                remoteEvent.documentUpdates.forEach(function (key, doc) {
                    var existingDoc = existingDocs.get(key);
                    // Note: The order of the steps below is important, since we want
                    // to ensure that rejected limbo resolutions (which fabricate
                    // NoDocuments with SnapshotVersion.MIN) never add documents to
                    // cache.
                    if (doc instanceof NoDocument &&
                        doc.version.isEqual(SnapshotVersion.MIN)) {
                        // NoDocuments with SnapshotVersion.MIN are used in manufactured
                        // events. We remove these documents from cache since we lost
                        // access.
                        documentBuffer.removeEntry(key, remoteVersion);
                        changedDocs = changedDocs.insert(key, doc);
                    }
                    else if (existingDoc == null ||
                        doc.version.compareTo(existingDoc.version) > 0 ||
                        (doc.version.compareTo(existingDoc.version) === 0 &&
                            existingDoc.hasPendingWrites)) {
                        // TODO(index-free): Make this an assert when we enable
                        // Index-Free queries
                        if (SnapshotVersion.MIN.isEqual(remoteVersion)) {
                            error(LOG_TAG$2, 'Cannot add a document when the remote version is zero');
                        }
                        documentBuffer.addEntry(doc, remoteVersion);
                        changedDocs = changedDocs.insert(key, doc);
                    }
                    else {
                        debug(LOG_TAG$2, 'Ignoring outdated watch update for ', key, '. Current version:', existingDoc.version, ' Watch version:', doc.version);
                    }
                    if (remoteEvent.resolvedLimboDocuments.has(key)) {
                        promises.push(_this.persistence.referenceDelegate.updateLimboDocument(txn, key));
                    }
                });
            }));
            // HACK: The only reason we allow a null snapshot version is so that we
            // can synthesize remote events when we get permission denied errors while
            // trying to resolve the state of a locally cached document that is in
            // limbo.
            if (!remoteVersion.isEqual(SnapshotVersion.MIN)) {
                var updateRemoteVersion = _this.targetCache
                    .getLastRemoteSnapshotVersion(txn)
                    .next(function (lastRemoteSnapshotVersion) {
                    assert(remoteVersion.compareTo(lastRemoteSnapshotVersion) >= 0, 'Watch stream reverted to previous snapshot?? ' +
                        remoteVersion +
                        ' < ' +
                        lastRemoteSnapshotVersion);
                    return _this.targetCache.setTargetsMetadata(txn, txn.currentSequenceNumber, remoteVersion);
                });
                promises.push(updateRemoteVersion);
            }
            return PersistencePromise.waitFor(promises)
                .next(function () { return documentBuffer.apply(txn); })
                .next(function () {
                return _this.localDocuments.getLocalViewOfDocuments(txn, changedDocs);
            });
        })
            .then(function (changedDocs) {
            _this.targetDataByTarget = newTargetDataByTargetMap;
            return changedDocs;
        });
    };
    /**
     * Returns true if the newTargetData should be persisted during an update of
     * an active target. TargetData should always be persisted when a target is
     * being released and should not call this function.
     *
     * While the target is active, TargetData updates can be omitted when nothing
     * about the target has changed except metadata like the resume token or
     * snapshot version. Occasionally it's worth the extra write to prevent these
     * values from getting too stale after a crash, but this doesn't have to be
     * too frequent.
     */
    LocalStore.shouldPersistTargetData = function (oldTargetData, newTargetData, change) {
        assert(newTargetData.resumeToken.length > 0, 'Attempted to persist target data with no resume token');
        // Always persist target data if we don't already have a resume token.
        if (oldTargetData.resumeToken.length === 0) {
            return true;
        }
        // Don't allow resume token changes to be buffered indefinitely. This
        // allows us to be reasonably up-to-date after a crash and avoids needing
        // to loop over all active queries on shutdown. Especially in the browser
        // we may not get time to do anything interesting while the current tab is
        // closing.
        var timeDelta = newTargetData.snapshotVersion.toMicroseconds() -
            oldTargetData.snapshotVersion.toMicroseconds();
        if (timeDelta >= this.RESUME_TOKEN_MAX_AGE_MICROS) {
            return true;
        }
        // Otherwise if the only thing that has changed about a target is its resume
        // token it's not worth persisting. Note that the RemoteStore keeps an
        // in-memory view of the currently active targets which includes the current
        // resume token, so stream failure or user changes will still use an
        // up-to-date resume token regardless of what we do here.
        var changes = change.addedDocuments.size +
            change.modifiedDocuments.size +
            change.removedDocuments.size;
        return changes > 0;
    };
    /**
     * Notify local store of the changed views to locally pin documents.
     */
    LocalStore.prototype.notifyLocalViewChanges = function (viewChanges) {
        var _this = this;
        for (var _i = 0, viewChanges_1 = viewChanges; _i < viewChanges_1.length; _i++) {
            var viewChange = viewChanges_1[_i];
            var targetId = viewChange.targetId;
            this.localViewReferences.addReferences(viewChange.addedKeys, targetId);
            this.localViewReferences.removeReferences(viewChange.removedKeys, targetId);
            if (!viewChange.fromCache) {
                var targetData = this.targetDataByTarget.get(targetId);
                assert(targetData !== null, "Can't set limbo-free snapshot version for unknown target: " + targetId);
                // Advance the last limbo free snapshot version
                var lastLimboFreeSnapshotVersion = targetData.snapshotVersion;
                var updatedTargetData = targetData.withLastLimboFreeSnapshotVersion(lastLimboFreeSnapshotVersion);
                this.targetDataByTarget = this.targetDataByTarget.insert(targetId, updatedTargetData);
            }
        }
        return this.persistence.runTransaction('notifyLocalViewChanges', 'readwrite-idempotent', function (txn) {
            return PersistencePromise.forEach(viewChanges, function (viewChange) {
                return PersistencePromise.forEach(viewChange.removedKeys, function (key) {
                    return _this.persistence.referenceDelegate.removeReference(txn, key);
                });
            });
        });
    };
    /**
     * Gets the mutation batch after the passed in batchId in the mutation queue
     * or null if empty.
     * @param afterBatchId If provided, the batch to search after.
     * @returns The next mutation or null if there wasn't one.
     */
    LocalStore.prototype.nextMutationBatch = function (afterBatchId) {
        var _this = this;
        return this.persistence.runTransaction('Get next mutation batch', 'readonly-idempotent', function (txn) {
            if (afterBatchId === undefined) {
                afterBatchId = BATCHID_UNKNOWN;
            }
            return _this.mutationQueue.getNextMutationBatchAfterBatchId(txn, afterBatchId);
        });
    };
    /**
     * Read the current value of a Document with a given key or null if not
     * found - used for testing.
     */
    LocalStore.prototype.readDocument = function (key) {
        var _this = this;
        return this.persistence.runTransaction('read document', 'readonly-idempotent', function (txn) {
            return _this.localDocuments.getDocument(txn, key);
        });
    };
    /**
     * Assigns the given target an internal ID so that its results can be pinned so
     * they don't get GC'd. A target must be allocated in the local store before
     * the store can be used to manage its view.
     *
     * Allocating an already allocated `Target` will return the existing `TargetData`
     * for that `Target`.
     */
    LocalStore.prototype.allocateTarget = function (target) {
        var _this = this;
        return this.persistence
            .runTransaction('Allocate target', 'readwrite-idempotent', function (txn) {
            var targetData;
            return _this.targetCache
                .getTargetData(txn, target)
                .next(function (cached) {
                if (cached) {
                    // This target has been listened to previously, so reuse the
                    // previous targetID.
                    // TODO(mcg): freshen last accessed date?
                    targetData = cached;
                    return PersistencePromise.resolve(targetData);
                }
                else {
                    return _this.targetCache.allocateTargetId(txn).next(function (targetId) {
                        targetData = new TargetData(target, targetId, TargetPurpose.Listen, txn.currentSequenceNumber);
                        return _this.targetCache
                            .addTargetData(txn, targetData)
                            .next(function () { return targetData; });
                    });
                }
            });
        })
            .then(function (targetData) {
            if (_this.targetDataByTarget.get(targetData.targetId) === null) {
                _this.targetDataByTarget = _this.targetDataByTarget.insert(targetData.targetId, targetData);
                _this.targetIdByTarget.set(target, targetData.targetId);
            }
            return targetData;
        });
    };
    /**
     * Returns the TargetData as seen by the LocalStore, including updates that may
     * have not yet been persisted to the TargetCache.
     */
    // Visible for testing.
    LocalStore.prototype.getTargetData = function (transaction, target) {
        var targetId = this.targetIdByTarget.get(target);
        if (targetId !== undefined) {
            return PersistencePromise.resolve(this.targetDataByTarget.get(targetId));
        }
        else {
            return this.targetCache.getTargetData(transaction, target);
        }
    };
    /**
     * Unpin all the documents associated with the given target. If
     * `keepPersistedTargetData` is set to false and Eager GC enabled, the method
     * directly removes the associated target data from the target cache.
     *
     * Releasing a non-existing `Target` is a no-op.
     */
    // PORTING NOTE: `keepPersistedTargetData` is multi-tab only.
    LocalStore.prototype.releaseTarget = function (targetId, keepPersistedTargetData) {
        var _this = this;
        var targetData = this.targetDataByTarget.get(targetId);
        if (!targetData) {
            return Promise.resolve();
        }
        var mode = keepPersistedTargetData
            ? 'readwrite-idempotent'
            : 'readwrite-primary-idempotent';
        return this.persistence
            .runTransaction('Release target', mode, function (txn) {
            // References for documents sent via Watch are automatically removed
            // when we delete a target's data from the reference delegate.
            // Since this does not remove references for locally mutated documents,
            // we have to remove the target associations for these documents
            // manually.
            // This operation needs to be run inside the transaction since EagerGC
            // uses the local view references during the transaction's commit.
            // Fortunately, the operation is safe to be re-run in case the
            // transaction fails since there are no side effects if the target has
            // already been removed.
            var removed = _this.localViewReferences.removeReferencesForId(targetId);
            if (!keepPersistedTargetData) {
                return PersistencePromise.forEach(removed, function (key) {
                    return _this.persistence.referenceDelegate.removeReference(txn, key);
                }).next(function () {
                    _this.persistence.referenceDelegate.removeTarget(txn, targetData);
                });
            }
            else {
                return PersistencePromise.resolve();
            }
        })
            .then(function () {
            _this.targetDataByTarget = _this.targetDataByTarget.remove(targetId);
            _this.targetIdByTarget.delete(targetData.target);
        });
    };
    /**
     * Runs the specified query against the local store and returns the results,
     * potentially taking advantage of query data from previous executions (such
     * as the set of remote keys).
     *
     * @param usePreviousResults Whether results from previous executions can
     * be used to optimize this query execution.
     */
    LocalStore.prototype.executeQuery = function (query, usePreviousResults) {
        var _this = this;
        var lastLimboFreeSnapshotVersion = SnapshotVersion.MIN;
        var remoteKeys = documentKeySet();
        return this.persistence.runTransaction('Execute query', 'readonly-idempotent', function (txn) {
            return _this.getTargetData(txn, query.toTarget())
                .next(function (targetData) {
                if (targetData) {
                    lastLimboFreeSnapshotVersion =
                        targetData.lastLimboFreeSnapshotVersion;
                    return _this.targetCache
                        .getMatchingKeysForTargetId(txn, targetData.targetId)
                        .next(function (result) {
                        remoteKeys = result;
                    });
                }
            })
                .next(function () {
                return _this.queryEngine.getDocumentsMatchingQuery(txn, query, usePreviousResults
                    ? lastLimboFreeSnapshotVersion
                    : SnapshotVersion.MIN, usePreviousResults ? remoteKeys : documentKeySet());
            })
                .next(function (documents) {
                return { documents: documents, remoteKeys: remoteKeys };
            });
        });
    };
    /**
     * Returns the keys of the documents that are associated with the given
     * target id in the remote table.
     */
    LocalStore.prototype.remoteDocumentKeys = function (targetId) {
        var _this = this;
        return this.persistence.runTransaction('Remote document keys', 'readonly-idempotent', function (txn) {
            return _this.targetCache.getMatchingKeysForTargetId(txn, targetId);
        });
    };
    // PORTING NOTE: Multi-tab only.
    LocalStore.prototype.getActiveClients = function () {
        return this.persistence.getActiveClients();
    };
    // PORTING NOTE: Multi-tab only.
    LocalStore.prototype.removeCachedMutationBatchMetadata = function (batchId) {
        this.mutationQueue.removeCachedMutationKeys(batchId);
    };
    // PORTING NOTE: Multi-tab only.
    LocalStore.prototype.setNetworkEnabled = function (networkEnabled) {
        this.persistence.setNetworkEnabled(networkEnabled);
    };
    LocalStore.prototype.applyWriteToRemoteDocuments = function (txn, batchResult, documentBuffer) {
        var _this = this;
        var batch = batchResult.batch;
        var docKeys = batch.keys();
        var promiseChain = PersistencePromise.resolve();
        docKeys.forEach(function (docKey) {
            promiseChain = promiseChain
                .next(function () {
                return documentBuffer.getEntry(txn, docKey);
            })
                .next(function (remoteDoc) {
                var doc = remoteDoc;
                var ackVersion = batchResult.docVersions.get(docKey);
                assert(ackVersion !== null, 'ackVersions should contain every doc in the write.');
                if (!doc || doc.version.compareTo(ackVersion) < 0) {
                    doc = batch.applyToRemoteDocument(docKey, doc, batchResult);
                    if (!doc) {
                        assert(!remoteDoc, 'Mutation batch ' +
                            batch +
                            ' applied to document ' +
                            remoteDoc +
                            ' resulted in null');
                    }
                    else {
                        // We use the commitVersion as the readTime rather than the
                        // document's updateTime since the updateTime is not advanced
                        // for updates that do not modify the underlying document.
                        documentBuffer.addEntry(doc, batchResult.commitVersion);
                    }
                }
            });
        });
        return promiseChain.next(function () {
            return _this.mutationQueue.removeMutationBatch(txn, batch);
        });
    };
    LocalStore.prototype.collectGarbage = function (garbageCollector) {
        var _this = this;
        return this.persistence.runTransaction('Collect garbage', 'readwrite-primary-idempotent', function (txn) { return garbageCollector.collect(txn, _this.targetDataByTarget); });
    };
    // PORTING NOTE: Multi-tab only.
    LocalStore.prototype.getTarget = function (targetId) {
        var _this = this;
        var cachedTargetData = this.targetDataByTarget.get(targetId);
        if (cachedTargetData) {
            return Promise.resolve(cachedTargetData.target);
        }
        else {
            return this.persistence.runTransaction('Get target data', 'readonly-idempotent', function (txn) {
                return _this.targetCache
                    .getTargetDataForTarget(txn, targetId)
                    .next(function (targetData) { return (targetData ? targetData.target : null); });
            });
        }
    };
    /**
     * Returns the set of documents that have been updated since the last call.
     * If this is the first call, returns the set of changes since client
     * initialization. Further invocations will return document changes since
     * the point of rejection.
     */
    // PORTING NOTE: Multi-tab only.
    LocalStore.prototype.getNewDocumentChanges = function () {
        var _this = this;
        return this.persistence
            .runTransaction('Get new document changes', 'readonly-idempotent', function (txn) {
            return _this.remoteDocuments.getNewDocumentChanges(txn, _this.lastDocumentChangeReadTime);
        })
            .then(function (_a) {
            var changedDocs = _a.changedDocs, readTime = _a.readTime;
            _this.lastDocumentChangeReadTime = readTime;
            return changedDocs;
        });
    };
    /**
     * Reads the newest document change from persistence and forwards the internal
     * synchronization marker so that calls to `getNewDocumentChanges()`
     * only return changes that happened after client initialization.
     */
    // PORTING NOTE: Multi-tab only.
    LocalStore.prototype.synchronizeLastDocumentChangeReadTime = function () {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var remoteDocumentCache_1;
            var _this = this;
            return tslib.__generator(this, function (_a) {
                if (this.remoteDocuments instanceof IndexedDbRemoteDocumentCache) {
                    remoteDocumentCache_1 = this.remoteDocuments;
                    return [2 /*return*/, this.persistence
                            .runTransaction('Synchronize last document change read time', 'readonly-idempotent', function (txn) { return remoteDocumentCache_1.getLastDocumentChange(txn); })
                            .then(function (_a) {
                            var readTime = _a.readTime;
                            _this.lastDocumentChangeReadTime = readTime;
                        })];
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * The maximum time to leave a resume token buffered without writing it out.
     * This value is arbitrary: it's long enough to avoid several writes
     * (possibly indefinitely if updates come more frequently than this) but
     * short enough that restarting after crashing will still have a pretty
     * recent resume token.
     */
    LocalStore.RESUME_TOKEN_MAX_AGE_MICROS = 5 * 60 * 1e6;
    return LocalStore;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var MemoryMutationQueue = /** @class */ (function () {
    function MemoryMutationQueue(indexManager, referenceDelegate) {
        this.indexManager = indexManager;
        this.referenceDelegate = referenceDelegate;
        /**
         * The set of all mutations that have been sent but not yet been applied to
         * the backend.
         */
        this.mutationQueue = [];
        /** Next value to use when assigning sequential IDs to each mutation batch. */
        this.nextBatchId = 1;
        /** The last received stream token from the server, used to acknowledge which
         * responses the client has processed. Stream tokens are opaque checkpoint
         * markers whose only real value is their inclusion in the next request.
         */
        this.lastStreamToken = emptyByteString();
        /** An ordered mapping between documents and the mutations batch IDs. */
        this.batchesByDocumentKey = new SortedSet(DocReference.compareByKey);
    }
    MemoryMutationQueue.prototype.checkEmpty = function (transaction) {
        return PersistencePromise.resolve(this.mutationQueue.length === 0);
    };
    MemoryMutationQueue.prototype.acknowledgeBatch = function (transaction, batch, streamToken) {
        var batchId = batch.batchId;
        var batchIndex = this.indexOfExistingBatchId(batchId, 'acknowledged');
        assert(batchIndex === 0, 'Can only acknowledge the first batch in the mutation queue');
        // Verify that the batch in the queue is the one to be acknowledged.
        var check = this.mutationQueue[batchIndex];
        assert(batchId === check.batchId, 'Queue ordering failure: expected batch ' +
            batchId +
            ', got batch ' +
            check.batchId);
        this.lastStreamToken = streamToken;
        return PersistencePromise.resolve();
    };
    MemoryMutationQueue.prototype.getLastStreamToken = function (transaction) {
        return PersistencePromise.resolve(this.lastStreamToken);
    };
    MemoryMutationQueue.prototype.setLastStreamToken = function (transaction, streamToken) {
        this.lastStreamToken = streamToken;
        return PersistencePromise.resolve();
    };
    MemoryMutationQueue.prototype.addMutationBatch = function (transaction, localWriteTime, baseMutations, mutations) {
        assert(mutations.length !== 0, 'Mutation batches should not be empty');
        var batchId = this.nextBatchId;
        this.nextBatchId++;
        if (this.mutationQueue.length > 0) {
            var prior = this.mutationQueue[this.mutationQueue.length - 1];
            assert(prior.batchId < batchId, 'Mutation batchIDs must be monotonically increasing order');
        }
        var batch = new MutationBatch(batchId, localWriteTime, baseMutations, mutations);
        this.mutationQueue.push(batch);
        // Track references by document key and index collection parents.
        for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
            var mutation = mutations_1[_i];
            this.batchesByDocumentKey = this.batchesByDocumentKey.add(new DocReference(mutation.key, batchId));
            this.indexManager.addToCollectionParentIndex(transaction, mutation.key.path.popLast());
        }
        return PersistencePromise.resolve(batch);
    };
    MemoryMutationQueue.prototype.lookupMutationBatch = function (transaction, batchId) {
        return PersistencePromise.resolve(this.findMutationBatch(batchId));
    };
    MemoryMutationQueue.prototype.lookupMutationKeys = function (transaction, batchId) {
        var mutationBatch = this.findMutationBatch(batchId);
        assert(mutationBatch != null, 'Failed to find local mutation batch.');
        return PersistencePromise.resolve(mutationBatch.keys());
    };
    MemoryMutationQueue.prototype.getNextMutationBatchAfterBatchId = function (transaction, batchId) {
        var nextBatchId = batchId + 1;
        // The requested batchId may still be out of range so normalize it to the
        // start of the queue.
        var rawIndex = this.indexOfBatchId(nextBatchId);
        var index = rawIndex < 0 ? 0 : rawIndex;
        return PersistencePromise.resolve(this.mutationQueue.length > index ? this.mutationQueue[index] : null);
    };
    MemoryMutationQueue.prototype.getHighestUnacknowledgedBatchId = function () {
        return PersistencePromise.resolve(this.mutationQueue.length === 0 ? BATCHID_UNKNOWN : this.nextBatchId - 1);
    };
    MemoryMutationQueue.prototype.getAllMutationBatches = function (transaction) {
        return PersistencePromise.resolve(this.mutationQueue.slice());
    };
    MemoryMutationQueue.prototype.getAllMutationBatchesAffectingDocumentKey = function (transaction, documentKey) {
        var _this = this;
        var start = new DocReference(documentKey, 0);
        var end = new DocReference(documentKey, Number.POSITIVE_INFINITY);
        var result = [];
        this.batchesByDocumentKey.forEachInRange([start, end], function (ref) {
            assert(documentKey.isEqual(ref.key), "Should only iterate over a single key's batches");
            var batch = _this.findMutationBatch(ref.targetOrBatchId);
            assert(batch !== null, 'Batches in the index must exist in the main table');
            result.push(batch);
        });
        return PersistencePromise.resolve(result);
    };
    MemoryMutationQueue.prototype.getAllMutationBatchesAffectingDocumentKeys = function (transaction, documentKeys) {
        var _this = this;
        var uniqueBatchIDs = new SortedSet(primitiveComparator);
        documentKeys.forEach(function (documentKey) {
            var start = new DocReference(documentKey, 0);
            var end = new DocReference(documentKey, Number.POSITIVE_INFINITY);
            _this.batchesByDocumentKey.forEachInRange([start, end], function (ref) {
                assert(documentKey.isEqual(ref.key), "For each key, should only iterate over a single key's batches");
                uniqueBatchIDs = uniqueBatchIDs.add(ref.targetOrBatchId);
            });
        });
        return PersistencePromise.resolve(this.findMutationBatches(uniqueBatchIDs));
    };
    MemoryMutationQueue.prototype.getAllMutationBatchesAffectingQuery = function (transaction, query) {
        assert(!query.isCollectionGroupQuery(), 'CollectionGroup queries should be handled in LocalDocumentsView');
        // Use the query path as a prefix for testing if a document matches the
        // query.
        var prefix = query.path;
        var immediateChildrenPathLength = prefix.length + 1;
        // Construct a document reference for actually scanning the index. Unlike
        // the prefix the document key in this reference must have an even number of
        // segments. The empty segment can be used a suffix of the query path
        // because it precedes all other segments in an ordered traversal.
        var startPath = prefix;
        if (!DocumentKey.isDocumentKey(startPath)) {
            startPath = startPath.child('');
        }
        var start = new DocReference(new DocumentKey(startPath), 0);
        // Find unique batchIDs referenced by all documents potentially matching the
        // query.
        var uniqueBatchIDs = new SortedSet(primitiveComparator);
        this.batchesByDocumentKey.forEachWhile(function (ref) {
            var rowKeyPath = ref.key.path;
            if (!prefix.isPrefixOf(rowKeyPath)) {
                return false;
            }
            else {
                // Rows with document keys more than one segment longer than the query
                // path can't be matches. For example, a query on 'rooms' can't match
                // the document /rooms/abc/messages/xyx.
                // TODO(mcg): we'll need a different scanner when we implement
                // ancestor queries.
                if (rowKeyPath.length === immediateChildrenPathLength) {
                    uniqueBatchIDs = uniqueBatchIDs.add(ref.targetOrBatchId);
                }
                return true;
            }
        }, start);
        return PersistencePromise.resolve(this.findMutationBatches(uniqueBatchIDs));
    };
    MemoryMutationQueue.prototype.findMutationBatches = function (batchIDs) {
        var _this = this;
        // Construct an array of matching batches, sorted by batchID to ensure that
        // multiple mutations affecting the same document key are applied in order.
        var result = [];
        batchIDs.forEach(function (batchId) {
            var batch = _this.findMutationBatch(batchId);
            if (batch !== null) {
                result.push(batch);
            }
        });
        return result;
    };
    MemoryMutationQueue.prototype.removeMutationBatch = function (transaction, batch) {
        var _this = this;
        // Find the position of the first batch for removal. This need not be the
        // first entry in the queue.
        var batchIndex = this.indexOfExistingBatchId(batch.batchId, 'removed');
        assert(batchIndex === 0, 'Can only remove the first entry of the mutation queue');
        this.mutationQueue.shift();
        var references = this.batchesByDocumentKey;
        return PersistencePromise.forEach(batch.mutations, function (mutation) {
            var ref = new DocReference(mutation.key, batch.batchId);
            references = references.delete(ref);
            return _this.referenceDelegate.removeMutationReference(transaction, mutation.key);
        }).next(function () {
            _this.batchesByDocumentKey = references;
        });
    };
    MemoryMutationQueue.prototype.removeCachedMutationKeys = function (batchId) {
        // No-op since the memory mutation queue does not maintain a separate cache.
    };
    MemoryMutationQueue.prototype.containsKey = function (txn, key) {
        var ref = new DocReference(key, 0);
        var firstRef = this.batchesByDocumentKey.firstAfterOrEqual(ref);
        return PersistencePromise.resolve(key.isEqual(firstRef && firstRef.key));
    };
    MemoryMutationQueue.prototype.performConsistencyCheck = function (txn) {
        if (this.mutationQueue.length === 0) {
            assert(this.batchesByDocumentKey.isEmpty(), 'Document leak -- detected dangling mutation references when queue is empty.');
        }
        return PersistencePromise.resolve();
    };
    /**
     * Finds the index of the given batchId in the mutation queue and asserts that
     * the resulting index is within the bounds of the queue.
     *
     * @param batchId The batchId to search for
     * @param action A description of what the caller is doing, phrased in passive
     * form (e.g. "acknowledged" in a routine that acknowledges batches).
     */
    MemoryMutationQueue.prototype.indexOfExistingBatchId = function (batchId, action) {
        var index = this.indexOfBatchId(batchId);
        assert(index >= 0 && index < this.mutationQueue.length, 'Batches must exist to be ' + action);
        return index;
    };
    /**
     * Finds the index of the given batchId in the mutation queue. This operation
     * is O(1).
     *
     * @return The computed index of the batch with the given batchId, based on
     * the state of the queue. Note this index can be negative if the requested
     * batchId has already been remvoed from the queue or past the end of the
     * queue if the batchId is larger than the last added batch.
     */
    MemoryMutationQueue.prototype.indexOfBatchId = function (batchId) {
        if (this.mutationQueue.length === 0) {
            // As an index this is past the end of the queue
            return 0;
        }
        // Examine the front of the queue to figure out the difference between the
        // batchId and indexes in the array. Note that since the queue is ordered
        // by batchId, if the first batch has a larger batchId then the requested
        // batchId doesn't exist in the queue.
        var firstBatchId = this.mutationQueue[0].batchId;
        return batchId - firstBatchId;
    };
    /**
     * A version of lookupMutationBatch that doesn't return a promise, this makes
     * other functions that uses this code easier to read and more efficent.
     */
    MemoryMutationQueue.prototype.findMutationBatch = function (batchId) {
        var index = this.indexOfBatchId(batchId);
        if (index < 0 || index >= this.mutationQueue.length) {
            return null;
        }
        var batch = this.mutationQueue[index];
        assert(batch.batchId === batchId, 'If found batch must match');
        return batch;
    };
    return MemoryMutationQueue;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function documentEntryMap() {
    return new SortedMap(DocumentKey.comparator);
}
var MemoryRemoteDocumentCache = /** @class */ (function () {
    /**
     * @param sizer Used to assess the size of a document. For eager GC, this is expected to just
     * return 0 to avoid unnecessarily doing the work of calculating the size.
     */
    function MemoryRemoteDocumentCache(indexManager, sizer) {
        this.indexManager = indexManager;
        this.sizer = sizer;
        /** Underlying cache of documents and their read times. */
        this.docs = documentEntryMap();
        /** Size of all cached documents. */
        this.size = 0;
    }
    /**
     * Adds the supplied entry to the cache and updates the cache size as appropriate.
     *
     * All calls of `addEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */
    MemoryRemoteDocumentCache.prototype.addEntry = function (transaction, doc, readTime) {
        assert(!readTime.isEqual(SnapshotVersion.MIN), 'Cannot add a document with a read time of zero');
        var key = doc.key;
        var entry = this.docs.get(key);
        var previousSize = entry ? entry.size : 0;
        var currentSize = this.sizer(doc);
        this.docs = this.docs.insert(key, {
            maybeDocument: doc,
            size: currentSize,
            readTime: readTime
        });
        this.size += currentSize - previousSize;
        return this.indexManager.addToCollectionParentIndex(transaction, key.path.popLast());
    };
    /**
     * Removes the specified entry from the cache and updates the cache size as appropriate.
     *
     * All calls of `removeEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */
    MemoryRemoteDocumentCache.prototype.removeEntry = function (documentKey) {
        var entry = this.docs.get(documentKey);
        if (entry) {
            this.docs = this.docs.remove(documentKey);
            this.size -= entry.size;
        }
    };
    MemoryRemoteDocumentCache.prototype.getEntry = function (transaction, documentKey) {
        var entry = this.docs.get(documentKey);
        return PersistencePromise.resolve(entry ? entry.maybeDocument : null);
    };
    MemoryRemoteDocumentCache.prototype.getEntries = function (transaction, documentKeys) {
        var _this = this;
        var results = nullableMaybeDocumentMap();
        documentKeys.forEach(function (documentKey) {
            var entry = _this.docs.get(documentKey);
            results = results.insert(documentKey, entry ? entry.maybeDocument : null);
        });
        return PersistencePromise.resolve(results);
    };
    MemoryRemoteDocumentCache.prototype.getDocumentsMatchingQuery = function (transaction, query, sinceReadTime) {
        assert(!query.isCollectionGroupQuery(), 'CollectionGroup queries should be handled in LocalDocumentsView');
        var results = documentMap();
        // Documents are ordered by key, so we can use a prefix scan to narrow down
        // the documents we need to match the query against.
        var prefix = new DocumentKey(query.path.child(''));
        var iterator = this.docs.getIteratorFrom(prefix);
        while (iterator.hasNext()) {
            var _a = iterator.getNext(), key = _a.key, _b = _a.value, maybeDocument = _b.maybeDocument, readTime = _b.readTime;
            if (!query.path.isPrefixOf(key.path)) {
                break;
            }
            if (readTime.compareTo(sinceReadTime) <= 0) {
                continue;
            }
            if (maybeDocument instanceof Document && query.matches(maybeDocument)) {
                results = results.insert(maybeDocument.key, maybeDocument);
            }
        }
        return PersistencePromise.resolve(results);
    };
    MemoryRemoteDocumentCache.prototype.forEachDocumentKey = function (transaction, f) {
        return PersistencePromise.forEach(this.docs, function (key) { return f(key); });
    };
    MemoryRemoteDocumentCache.prototype.getNewDocumentChanges = function (transaction, sinceReadTime) {
        throw new Error('getNewDocumentChanges() is not supported with MemoryPersistence');
    };
    MemoryRemoteDocumentCache.prototype.newChangeBuffer = function (options) {
        // `trackRemovals` is ignores since the MemoryRemoteDocumentCache keeps
        // a separate changelog and does not need special handling for removals.
        return new MemoryRemoteDocumentCache.RemoteDocumentChangeBuffer(this);
    };
    MemoryRemoteDocumentCache.prototype.getSize = function (txn) {
        return PersistencePromise.resolve(this.size);
    };
    /**
     * Handles the details of adding and updating documents in the MemoryRemoteDocumentCache.
     */
    MemoryRemoteDocumentCache.RemoteDocumentChangeBuffer = /** @class */ (function (_super) {
        tslib.__extends(class_1, _super);
        function class_1(documentCache) {
            var _this = _super.call(this) || this;
            _this.documentCache = documentCache;
            return _this;
        }
        class_1.prototype.applyChanges = function (transaction) {
            var _this = this;
            var promises = [];
            this.changes.forEach(function (key, doc) {
                if (doc) {
                    promises.push(_this.documentCache.addEntry(transaction, doc, _this.readTime));
                }
                else {
                    _this.documentCache.removeEntry(key);
                }
            });
            return PersistencePromise.waitFor(promises);
        };
        class_1.prototype.getFromCache = function (transaction, documentKey) {
            return this.documentCache.getEntry(transaction, documentKey);
        };
        class_1.prototype.getAllFromCache = function (transaction, documentKeys) {
            return this.documentCache.getEntries(transaction, documentKeys);
        };
        return class_1;
    }(RemoteDocumentChangeBuffer));
    return MemoryRemoteDocumentCache;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var MemoryTargetCache = /** @class */ (function () {
    function MemoryTargetCache(persistence) {
        this.persistence = persistence;
        /**
         * Maps a target to the data about that target
         */
        this.targets = new ObjectMap(function (t) { return t.canonicalId(); });
        /** The last received snapshot version. */
        this.lastRemoteSnapshotVersion = SnapshotVersion.MIN;
        /** The highest numbered target ID encountered. */
        this.highestTargetId = 0;
        /** The highest sequence number encountered. */
        this.highestSequenceNumber = 0;
        /**
         * A ordered bidirectional mapping between documents and the remote target
         * IDs.
         */
        this.references = new ReferenceSet();
        this.targetCount = 0;
        this.targetIdGenerator = TargetIdGenerator.forTargetCache();
    }
    MemoryTargetCache.prototype.forEachTarget = function (txn, f) {
        this.targets.forEach(function (_, targetData) { return f(targetData); });
        return PersistencePromise.resolve();
    };
    MemoryTargetCache.prototype.getLastRemoteSnapshotVersion = function (transaction) {
        return PersistencePromise.resolve(this.lastRemoteSnapshotVersion);
    };
    MemoryTargetCache.prototype.getHighestSequenceNumber = function (transaction) {
        return PersistencePromise.resolve(this.highestSequenceNumber);
    };
    MemoryTargetCache.prototype.allocateTargetId = function (transaction) {
        var nextTargetId = this.targetIdGenerator.after(this.highestTargetId);
        this.highestTargetId = nextTargetId;
        return PersistencePromise.resolve(nextTargetId);
    };
    MemoryTargetCache.prototype.setTargetsMetadata = function (transaction, highestListenSequenceNumber, lastRemoteSnapshotVersion) {
        if (lastRemoteSnapshotVersion) {
            this.lastRemoteSnapshotVersion = lastRemoteSnapshotVersion;
        }
        if (highestListenSequenceNumber > this.highestSequenceNumber) {
            this.highestSequenceNumber = highestListenSequenceNumber;
        }
        return PersistencePromise.resolve();
    };
    MemoryTargetCache.prototype.saveTargetData = function (targetData) {
        this.targets.set(targetData.target, targetData);
        var targetId = targetData.targetId;
        if (targetId > this.highestTargetId) {
            this.highestTargetId = targetId;
        }
        if (targetData.sequenceNumber > this.highestSequenceNumber) {
            this.highestSequenceNumber = targetData.sequenceNumber;
        }
    };
    MemoryTargetCache.prototype.addTargetData = function (transaction, targetData) {
        assert(!this.targets.has(targetData.target), 'Adding a target that already exists');
        this.saveTargetData(targetData);
        this.targetCount += 1;
        return PersistencePromise.resolve();
    };
    MemoryTargetCache.prototype.updateTargetData = function (transaction, targetData) {
        assert(this.targets.has(targetData.target), 'Updating a non-existent target');
        this.saveTargetData(targetData);
        return PersistencePromise.resolve();
    };
    MemoryTargetCache.prototype.removeTargetData = function (transaction, targetData) {
        assert(this.targetCount > 0, 'Removing a target from an empty cache');
        assert(this.targets.has(targetData.target), 'Removing a non-existent target from the cache');
        this.targets.delete(targetData.target);
        this.references.removeReferencesForId(targetData.targetId);
        this.targetCount -= 1;
        return PersistencePromise.resolve();
    };
    MemoryTargetCache.prototype.removeTargets = function (transaction, upperBound, activeTargetIds) {
        var _this = this;
        var count = 0;
        var removals = [];
        this.targets.forEach(function (key, targetData) {
            if (targetData.sequenceNumber <= upperBound &&
                activeTargetIds.get(targetData.targetId) === null) {
                _this.targets.delete(key);
                removals.push(_this.removeMatchingKeysForTargetId(transaction, targetData.targetId));
                count++;
            }
        });
        return PersistencePromise.waitFor(removals).next(function () { return count; });
    };
    MemoryTargetCache.prototype.getTargetCount = function (transaction) {
        return PersistencePromise.resolve(this.targetCount);
    };
    MemoryTargetCache.prototype.getTargetData = function (transaction, target) {
        var targetData = this.targets.get(target) || null;
        return PersistencePromise.resolve(targetData);
    };
    MemoryTargetCache.prototype.getTargetDataForTarget = function (transaction, targetId) {
        // This method is only needed for multi-tab and we can't implement it
        // efficiently without additional data structures.
        return fail('Not yet implemented.');
    };
    MemoryTargetCache.prototype.addMatchingKeys = function (txn, keys, targetId) {
        this.references.addReferences(keys, targetId);
        var referenceDelegate = this.persistence.referenceDelegate;
        var promises = [];
        if (referenceDelegate) {
            keys.forEach(function (key) {
                promises.push(referenceDelegate.addReference(txn, key));
            });
        }
        return PersistencePromise.waitFor(promises);
    };
    MemoryTargetCache.prototype.removeMatchingKeys = function (txn, keys, targetId) {
        this.references.removeReferences(keys, targetId);
        var referenceDelegate = this.persistence.referenceDelegate;
        var promises = [];
        if (referenceDelegate) {
            keys.forEach(function (key) {
                promises.push(referenceDelegate.removeReference(txn, key));
            });
        }
        return PersistencePromise.waitFor(promises);
    };
    MemoryTargetCache.prototype.removeMatchingKeysForTargetId = function (txn, targetId) {
        this.references.removeReferencesForId(targetId);
        return PersistencePromise.resolve();
    };
    MemoryTargetCache.prototype.getMatchingKeysForTargetId = function (txn, targetId) {
        var matchingKeys = this.references.referencesForId(targetId);
        return PersistencePromise.resolve(matchingKeys);
    };
    MemoryTargetCache.prototype.containsKey = function (txn, key) {
        return PersistencePromise.resolve(this.references.containsKey(key));
    };
    return MemoryTargetCache;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$3 = 'MemoryPersistence';
/**
 * A memory-backed instance of Persistence. Data is stored only in RAM and
 * not persisted across sessions.
 */
var MemoryPersistence = /** @class */ (function () {
    /**
     * The constructor accepts a factory for creating a reference delegate. This
     * allows both the delegate and this instance to have strong references to
     * each other without having nullable fields that would then need to be
     * checked or asserted on every access.
     */
    function MemoryPersistence(clientId, referenceDelegateFactory) {
        var _this = this;
        this.clientId = clientId;
        this.mutationQueues = {};
        this.listenSequence = new ListenSequence(0);
        this._started = false;
        this._started = true;
        this.referenceDelegate = referenceDelegateFactory(this);
        this.targetCache = new MemoryTargetCache(this);
        var sizer = function (doc) {
            return _this.referenceDelegate.documentSize(doc);
        };
        this.indexManager = new MemoryIndexManager();
        this.remoteDocumentCache = new MemoryRemoteDocumentCache(this.indexManager, sizer);
    }
    MemoryPersistence.createLruPersistence = function (clientId, serializer, params) {
        var factory = function (p) {
            return new MemoryLruDelegate(p, new LocalSerializer(serializer), params);
        };
        return new MemoryPersistence(clientId, factory);
    };
    MemoryPersistence.createEagerPersistence = function (clientId) {
        var factory = function (p) {
            return new MemoryEagerDelegate(p);
        };
        return new MemoryPersistence(clientId, factory);
    };
    MemoryPersistence.prototype.shutdown = function () {
        // No durable state to ensure is closed on shutdown.
        this._started = false;
        return Promise.resolve();
    };
    Object.defineProperty(MemoryPersistence.prototype, "started", {
        get: function () {
            return this._started;
        },
        enumerable: true,
        configurable: true
    });
    MemoryPersistence.prototype.getActiveClients = function () {
        return tslib.__awaiter(this, void 0, void 0, function () {
            return tslib.__generator(this, function (_a) {
                return [2 /*return*/, [this.clientId]];
            });
        });
    };
    MemoryPersistence.prototype.setPrimaryStateListener = function (primaryStateListener) {
        // All clients using memory persistence act as primary.
        return primaryStateListener(true);
    };
    MemoryPersistence.prototype.setDatabaseDeletedListener = function () {
        // No op.
    };
    MemoryPersistence.prototype.setNetworkEnabled = function (networkEnabled) {
        // No op.
    };
    MemoryPersistence.prototype.getIndexManager = function () {
        return this.indexManager;
    };
    MemoryPersistence.prototype.getMutationQueue = function (user) {
        var queue = this.mutationQueues[user.toKey()];
        if (!queue) {
            queue = new MemoryMutationQueue(this.indexManager, this.referenceDelegate);
            this.mutationQueues[user.toKey()] = queue;
        }
        return queue;
    };
    MemoryPersistence.prototype.getTargetCache = function () {
        return this.targetCache;
    };
    MemoryPersistence.prototype.getRemoteDocumentCache = function () {
        return this.remoteDocumentCache;
    };
    MemoryPersistence.prototype.runTransaction = function (action, mode, transactionOperation) {
        var _this = this;
        debug(LOG_TAG$3, 'Starting transaction:', action);
        var txn = new MemoryTransaction(this.listenSequence.next());
        this.referenceDelegate.onTransactionStarted();
        return transactionOperation(txn)
            .next(function (result) {
            return _this.referenceDelegate
                .onTransactionCommitted(txn)
                .next(function () { return result; });
        })
            .toPromise()
            .then(function (result) {
            txn.raiseOnCommittedEvent();
            return result;
        });
    };
    MemoryPersistence.prototype.mutationQueuesContainKey = function (transaction, key) {
        return PersistencePromise.or(values(this.mutationQueues)
            .map(function (queue) { return function () { return queue.containsKey(transaction, key); }; }));
    };
    return MemoryPersistence;
}());
/**
 * Memory persistence is not actually transactional, but future implementations
 * may have transaction-scoped state.
 */
var MemoryTransaction = /** @class */ (function (_super) {
    tslib.__extends(MemoryTransaction, _super);
    function MemoryTransaction(currentSequenceNumber) {
        var _this = _super.call(this) || this;
        _this.currentSequenceNumber = currentSequenceNumber;
        return _this;
    }
    return MemoryTransaction;
}(PersistenceTransaction));
var MemoryEagerDelegate = /** @class */ (function () {
    function MemoryEagerDelegate(persistence) {
        this.persistence = persistence;
        this.inMemoryPins = null;
        this._orphanedDocuments = null;
    }
    Object.defineProperty(MemoryEagerDelegate.prototype, "orphanedDocuments", {
        get: function () {
            if (!this._orphanedDocuments) {
                throw fail('orphanedDocuments is only valid during a transaction.');
            }
            else {
                return this._orphanedDocuments;
            }
        },
        enumerable: true,
        configurable: true
    });
    MemoryEagerDelegate.prototype.setInMemoryPins = function (inMemoryPins) {
        this.inMemoryPins = inMemoryPins;
    };
    MemoryEagerDelegate.prototype.addReference = function (txn, key) {
        this.orphanedDocuments.delete(key);
        return PersistencePromise.resolve();
    };
    MemoryEagerDelegate.prototype.removeReference = function (txn, key) {
        this.orphanedDocuments.add(key);
        return PersistencePromise.resolve();
    };
    MemoryEagerDelegate.prototype.removeMutationReference = function (txn, key) {
        this.orphanedDocuments.add(key);
        return PersistencePromise.resolve();
    };
    MemoryEagerDelegate.prototype.removeTarget = function (txn, targetData) {
        var _this = this;
        var cache = this.persistence.getTargetCache();
        return cache
            .getMatchingKeysForTargetId(txn, targetData.targetId)
            .next(function (keys) {
            keys.forEach(function (key) { return _this.orphanedDocuments.add(key); });
        })
            .next(function () { return cache.removeTargetData(txn, targetData); });
    };
    MemoryEagerDelegate.prototype.onTransactionStarted = function () {
        this._orphanedDocuments = new Set();
    };
    MemoryEagerDelegate.prototype.onTransactionCommitted = function (txn) {
        var _this = this;
        // Remove newly orphaned documents.
        var cache = this.persistence.getRemoteDocumentCache();
        var changeBuffer = cache.newChangeBuffer();
        return PersistencePromise.forEach(this.orphanedDocuments, function (key) {
            return _this.isReferenced(txn, key).next(function (isReferenced) {
                if (!isReferenced) {
                    changeBuffer.removeEntry(key);
                }
            });
        }).next(function () {
            _this._orphanedDocuments = null;
            return changeBuffer.apply(txn);
        });
    };
    MemoryEagerDelegate.prototype.updateLimboDocument = function (txn, key) {
        var _this = this;
        return this.isReferenced(txn, key).next(function (isReferenced) {
            if (isReferenced) {
                _this.orphanedDocuments.delete(key);
            }
            else {
                _this.orphanedDocuments.add(key);
            }
        });
    };
    MemoryEagerDelegate.prototype.documentSize = function (doc) {
        // For eager GC, we don't care about the document size, there are no size thresholds.
        return 0;
    };
    MemoryEagerDelegate.prototype.isReferenced = function (txn, key) {
        var _this = this;
        return PersistencePromise.or([
            function () { return _this.persistence.getTargetCache().containsKey(txn, key); },
            function () { return _this.persistence.mutationQueuesContainKey(txn, key); },
            function () { return PersistencePromise.resolve(_this.inMemoryPins.containsKey(key)); }
        ]);
    };
    return MemoryEagerDelegate;
}());
var MemoryLruDelegate = /** @class */ (function () {
    function MemoryLruDelegate(persistence, serializer, lruParams) {
        this.persistence = persistence;
        this.serializer = serializer;
        this.inMemoryPins = null;
        this.orphanedSequenceNumbers = new ObjectMap(function (k) { return encode(k.path); });
        this.garbageCollector = new LruGarbageCollector(this, lruParams);
    }
    // No-ops, present so memory persistence doesn't have to care which delegate
    // it has.
    MemoryLruDelegate.prototype.onTransactionStarted = function () { };
    MemoryLruDelegate.prototype.onTransactionCommitted = function (txn) {
        return PersistencePromise.resolve();
    };
    MemoryLruDelegate.prototype.forEachTarget = function (txn, f) {
        return this.persistence.getTargetCache().forEachTarget(txn, f);
    };
    MemoryLruDelegate.prototype.getSequenceNumberCount = function (txn) {
        var docCountPromise = this.orphanedDocumentCount(txn);
        var targetCountPromise = this.persistence
            .getTargetCache()
            .getTargetCount(txn);
        return targetCountPromise.next(function (targetCount) {
            return docCountPromise.next(function (docCount) { return targetCount + docCount; });
        });
    };
    MemoryLruDelegate.prototype.orphanedDocumentCount = function (txn) {
        var orphanedCount = 0;
        return this.forEachOrphanedDocumentSequenceNumber(txn, function (_) {
            orphanedCount++;
        }).next(function () { return orphanedCount; });
    };
    MemoryLruDelegate.prototype.forEachOrphanedDocumentSequenceNumber = function (txn, f) {
        var _this = this;
        return PersistencePromise.forEach(this.orphanedSequenceNumbers, function (key, sequenceNumber) {
            // Pass in the exact sequence number as the upper bound so we know it won't be pinned by
            // being too recent.
            return _this.isPinned(txn, key, sequenceNumber).next(function (isPinned) {
                if (!isPinned) {
                    return f(sequenceNumber);
                }
                else {
                    return PersistencePromise.resolve();
                }
            });
        });
    };
    MemoryLruDelegate.prototype.setInMemoryPins = function (inMemoryPins) {
        this.inMemoryPins = inMemoryPins;
    };
    MemoryLruDelegate.prototype.removeTargets = function (txn, upperBound, activeTargetIds) {
        return this.persistence
            .getTargetCache()
            .removeTargets(txn, upperBound, activeTargetIds);
    };
    MemoryLruDelegate.prototype.removeOrphanedDocuments = function (txn, upperBound) {
        var _this = this;
        var count = 0;
        var cache = this.persistence.getRemoteDocumentCache();
        var changeBuffer = cache.newChangeBuffer();
        var p = cache.forEachDocumentKey(txn, function (key) {
            return _this.isPinned(txn, key, upperBound).next(function (isPinned) {
                if (!isPinned) {
                    count++;
                    changeBuffer.removeEntry(key);
                }
            });
        });
        return p.next(function () { return changeBuffer.apply(txn); }).next(function () { return count; });
    };
    MemoryLruDelegate.prototype.removeMutationReference = function (txn, key) {
        this.orphanedSequenceNumbers.set(key, txn.currentSequenceNumber);
        return PersistencePromise.resolve();
    };
    MemoryLruDelegate.prototype.removeTarget = function (txn, targetData) {
        var updated = targetData.withSequenceNumber(txn.currentSequenceNumber);
        return this.persistence.getTargetCache().updateTargetData(txn, updated);
    };
    MemoryLruDelegate.prototype.addReference = function (txn, key) {
        this.orphanedSequenceNumbers.set(key, txn.currentSequenceNumber);
        return PersistencePromise.resolve();
    };
    MemoryLruDelegate.prototype.removeReference = function (txn, key) {
        this.orphanedSequenceNumbers.set(key, txn.currentSequenceNumber);
        return PersistencePromise.resolve();
    };
    MemoryLruDelegate.prototype.updateLimboDocument = function (txn, key) {
        this.orphanedSequenceNumbers.set(key, txn.currentSequenceNumber);
        return PersistencePromise.resolve();
    };
    MemoryLruDelegate.prototype.documentSize = function (maybeDoc) {
        var remoteDocument = this.serializer.toDbRemoteDocument(maybeDoc, maybeDoc.version);
        var value;
        if (remoteDocument.document) {
            value = remoteDocument.document;
        }
        else if (remoteDocument.unknownDocument) {
            value = remoteDocument.unknownDocument;
        }
        else if (remoteDocument.noDocument) {
            value = remoteDocument.noDocument;
        }
        else {
            throw fail('Unknown remote document type');
        }
        return JSON.stringify(value).length;
    };
    MemoryLruDelegate.prototype.isPinned = function (txn, key, upperBound) {
        var _this = this;
        return PersistencePromise.or([
            function () { return _this.persistence.mutationQueuesContainKey(txn, key); },
            function () { return PersistencePromise.resolve(_this.inMemoryPins.containsKey(key)); },
            function () { return _this.persistence.getTargetCache().containsKey(txn, key); },
            function () {
                var orphanedAt = _this.orphanedSequenceNumbers.get(key);
                return PersistencePromise.resolve(orphanedAt !== undefined && orphanedAt > upperBound);
            }
        ]);
    };
    MemoryLruDelegate.prototype.getCacheSize = function (txn) {
        return this.persistence.getRemoteDocumentCache().getSize(txn);
    };
    return MemoryLruDelegate;
}());

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A naive implementation of QueryEngine that just loads all the documents in
 * the queried collection and then filters them in memory.
 */
var SimpleQueryEngine = /** @class */ (function () {
    function SimpleQueryEngine() {
    }
    SimpleQueryEngine.prototype.setLocalDocumentsView = function (localDocuments) {
        this.localDocumentsView = localDocuments;
    };
    /** Returns all local documents matching the specified query. */
    SimpleQueryEngine.prototype.getDocumentsMatchingQuery = function (transaction, query, lastLimboFreeSnapshotVersion, remoteKeys) {
        assert(this.localDocumentsView !== undefined, 'setLocalDocumentsView() not called');
        // TODO: Once LocalDocumentsView provides a getCollectionDocuments()
        // method, we should call that here and then filter the results.
        return this.localDocumentsView.getDocumentsMatchingQuery(transaction, query, SnapshotVersion.MIN);
    };
    return SimpleQueryEngine;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Untyped Number alias we can use to check for ES6 methods / properties.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var NumberAsAny = Number;
/**
 * Minimum safe integer in Javascript because of floating point precision.
 * Added to not rely on ES6 features.
 */
var MIN_SAFE_INTEGER = NumberAsAny.MIN_SAFE_INTEGER || -(Math.pow(2, 53) - 1);
/**
 * Maximum safe integer in Javascript because of floating point precision.
 * Added to not rely on ES6 features.
 */
var MAX_SAFE_INTEGER = NumberAsAny.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;
/**
 * Returns whether an number is an integer, uses native implementation if
 * available.
 * Added to not rely on ES6 features.
 * @param value The value to test for being an integer
 */
var isInteger = NumberAsAny.isInteger ||
    (function (value) {
        return typeof value === 'number' &&
            isFinite(value) &&
            Math.floor(value) === value;
    });
/**
 * Returns whether a variable is either undefined or null.
 */
function isNullOrUndefined(value) {
    return value === null || value === undefined;
}
/**
 * Returns whether a value is an integer and in the safe integer range
 * @param value The value to test for being an integer and in the safe range
 */
function isSafeInteger(value) {
    return (isInteger(value) &&
        value <= MAX_SAFE_INTEGER &&
        value >= MIN_SAFE_INTEGER);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$4 = 'ExponentialBackoff';
/**
 * Initial backoff time in milliseconds after an error.
 * Set to 1s according to https://cloud.google.com/apis/design/errors.
 */
var DEFAULT_BACKOFF_INITIAL_DELAY_MS = 1000;
var DEFAULT_BACKOFF_FACTOR = 1.5;
/** Maximum backoff time in milliseconds */
var DEFAULT_BACKOFF_MAX_DELAY_MS = 60 * 1000;
/**
 * A helper for running delayed tasks following an exponential backoff curve
 * between attempts.
 *
 * Each delay is made up of a "base" delay which follows the exponential
 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
 * base delay. This prevents clients from accidentally synchronizing their
 * delays causing spikes of load to the backend.
 */
var ExponentialBackoff = /** @class */ (function () {
    function ExponentialBackoff(
    /**
     * The AsyncQueue to run backoff operations on.
     */
    queue, 
    /**
     * The ID to use when scheduling backoff operations on the AsyncQueue.
     */
    timerId, 
    /**
     * The initial delay (used as the base delay on the first retry attempt).
     * Note that jitter will still be applied, so the actual delay could be as
     * little as 0.5*initialDelayMs.
     */
    initialDelayMs, 
    /**
     * The multiplier to use to determine the extended base delay after each
     * attempt.
     */
    backoffFactor, 
    /**
     * The maximum base delay after which no further backoff is performed.
     * Note that jitter will still be applied, so the actual delay could be as
     * much as 1.5*maxDelayMs.
     */
    maxDelayMs) {
        if (initialDelayMs === void 0) { initialDelayMs = DEFAULT_BACKOFF_INITIAL_DELAY_MS; }
        if (backoffFactor === void 0) { backoffFactor = DEFAULT_BACKOFF_FACTOR; }
        if (maxDelayMs === void 0) { maxDelayMs = DEFAULT_BACKOFF_MAX_DELAY_MS; }
        this.queue = queue;
        this.timerId = timerId;
        this.initialDelayMs = initialDelayMs;
        this.backoffFactor = backoffFactor;
        this.maxDelayMs = maxDelayMs;
        this.currentBaseMs = 0;
        this.timerPromise = null;
        /** The last backoff attempt, as epoch milliseconds. */
        this.lastAttemptTime = Date.now();
        this.reset();
    }
    /**
     * Resets the backoff delay.
     *
     * The very next backoffAndWait() will have no delay. If it is called again
     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
     * subsequent ones will increase according to the backoffFactor.
     */
    ExponentialBackoff.prototype.reset = function () {
        this.currentBaseMs = 0;
    };
    /**
     * Resets the backoff delay to the maximum delay (e.g. for use after a
     * RESOURCE_EXHAUSTED error).
     */
    ExponentialBackoff.prototype.resetToMax = function () {
        this.currentBaseMs = this.maxDelayMs;
    };
    /**
     * Returns a promise that resolves after currentDelayMs, and increases the
     * delay for any subsequent attempts. If there was a pending backoff operation
     * already, it will be canceled.
     */
    ExponentialBackoff.prototype.backoffAndRun = function (op) {
        var _this = this;
        // Cancel any pending backoff operation.
        this.cancel();
        // First schedule using the current base (which may be 0 and should be
        // honored as such).
        var desiredDelayWithJitterMs = Math.floor(this.currentBaseMs + this.jitterDelayMs());
        // Guard against lastAttemptTime being in the future due to a clock change.
        var delaySoFarMs = Math.max(0, Date.now() - this.lastAttemptTime);
        // Guard against the backoff delay already being past.
        var remainingDelayMs = Math.max(0, desiredDelayWithJitterMs - delaySoFarMs);
        if (this.currentBaseMs > 0) {
            debug(LOG_TAG$4, "Backing off for " + remainingDelayMs + " ms " +
                ("(base delay: " + this.currentBaseMs + " ms, ") +
                ("delay with jitter: " + desiredDelayWithJitterMs + " ms, ") +
                ("last attempt: " + delaySoFarMs + " ms ago)"));
        }
        this.timerPromise = this.queue.enqueueAfterDelay(this.timerId, remainingDelayMs, function () {
            _this.lastAttemptTime = Date.now();
            return op();
        });
        // Apply backoff factor to determine next delay and ensure it is within
        // bounds.
        this.currentBaseMs *= this.backoffFactor;
        if (this.currentBaseMs < this.initialDelayMs) {
            this.currentBaseMs = this.initialDelayMs;
        }
        if (this.currentBaseMs > this.maxDelayMs) {
            this.currentBaseMs = this.maxDelayMs;
        }
    };
    ExponentialBackoff.prototype.cancel = function () {
        if (this.timerPromise !== null) {
            this.timerPromise.cancel();
            this.timerPromise = null;
        }
    };
    /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */
    ExponentialBackoff.prototype.jitterDelayMs = function () {
        return (Math.random() - 0.5) * this.currentBaseMs;
    };
    return ExponentialBackoff;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$5 = 'PersistentStream';
/**
 * PersistentStream can be in one of 5 states (each described in detail below)
 * based on the following state transition diagram:
 *
 *          start() called             auth & connection succeeded
 * INITIAL ----------------> STARTING -----------------------------> OPEN
 *                             ^  |                                   |
 *                             |  |                    error occurred |
 *                             |  \-----------------------------v-----/
 *                             |                                |
 *                    backoff  |                                |
 *                    elapsed  |              start() called    |
 *                             \--- BACKOFF <---------------- ERROR
 *
 * [any state] --------------------------> INITIAL
 *               stop() called or
 *               idle timer expired
 */
var PersistentStreamState;
(function (PersistentStreamState) {
    /**
     * The streaming RPC is not yet running and there's no error condition.
     * Calling start() will start the stream immediately without backoff.
     * While in this state isStarted() will return false.
     */
    PersistentStreamState[PersistentStreamState["Initial"] = 0] = "Initial";
    /**
     * The stream is starting, either waiting for an auth token or for the stream
     * to successfully open. While in this state, isStarted() will return true but
     * isOpen() will return false.
     */
    PersistentStreamState[PersistentStreamState["Starting"] = 1] = "Starting";
    /**
     * The streaming RPC is up and running. Requests and responses can flow
     * freely. Both isStarted() and isOpen() will return true.
     */
    PersistentStreamState[PersistentStreamState["Open"] = 2] = "Open";
    /**
     * The stream encountered an error. The next start attempt will back off.
     * While in this state isStarted() will return false.
     */
    PersistentStreamState[PersistentStreamState["Error"] = 3] = "Error";
    /**
     * An in-between state after an error where the stream is waiting before
     * re-starting. After waiting is complete, the stream will try to open.
     * While in this state isStarted() will return true but isOpen() will return
     * false.
     */
    PersistentStreamState[PersistentStreamState["Backoff"] = 4] = "Backoff";
})(PersistentStreamState || (PersistentStreamState = {}));
/** The time a stream stays open after it is marked idle. */
var IDLE_TIMEOUT_MS = 60 * 1000;
/**
 * A PersistentStream is an abstract base class that represents a streaming RPC
 * to the Firestore backend. It's built on top of the connections own support
 * for streaming RPCs, and adds several critical features for our clients:
 *
 *   - Exponential backoff on failure
 *   - Authentication via CredentialsProvider
 *   - Dispatching all callbacks into the shared worker queue
 *   - Closing idle streams after 60 seconds of inactivity
 *
 * Subclasses of PersistentStream implement serialization of models to and
 * from the JSON representation of the protocol buffers for a specific
 * streaming RPC.
 *
 * ## Starting and Stopping
 *
 * Streaming RPCs are stateful and need to be start()ed before messages can
 * be sent and received. The PersistentStream will call the onOpen() function
 * of the listener once the stream is ready to accept requests.
 *
 * Should a start() fail, PersistentStream will call the registered onClose()
 * listener with a FirestoreError indicating what went wrong.
 *
 * A PersistentStream can be started and stopped repeatedly.
 *
 * Generic types:
 *  SendType: The type of the outgoing message of the underlying
 *    connection stream
 *  ReceiveType: The type of the incoming message of the underlying
 *    connection stream
 *  ListenerType: The type of the listener that will be used for callbacks
 */
var PersistentStream = /** @class */ (function () {
    function PersistentStream(queue, connectionTimerId, idleTimerId, connection, credentialsProvider, listener) {
        this.queue = queue;
        this.idleTimerId = idleTimerId;
        this.connection = connection;
        this.credentialsProvider = credentialsProvider;
        this.listener = listener;
        this.state = PersistentStreamState.Initial;
        /**
         * A close count that's incremented every time the stream is closed; used by
         * getCloseGuardedDispatcher() to invalidate callbacks that happen after
         * close.
         */
        this.closeCount = 0;
        this.idleTimer = null;
        this.stream = null;
        this.backoff = new ExponentialBackoff(queue, connectionTimerId);
    }
    /**
     * Returns true if start() has been called and no error has occurred. True
     * indicates the stream is open or in the process of opening (which
     * encompasses respecting backoff, getting auth tokens, and starting the
     * actual RPC). Use isOpen() to determine if the stream is open and ready for
     * outbound requests.
     */
    PersistentStream.prototype.isStarted = function () {
        return (this.state === PersistentStreamState.Starting ||
            this.state === PersistentStreamState.Open ||
            this.state === PersistentStreamState.Backoff);
    };
    /**
     * Returns true if the underlying RPC is open (the onOpen() listener has been
     * called) and the stream is ready for outbound requests.
     */
    PersistentStream.prototype.isOpen = function () {
        return this.state === PersistentStreamState.Open;
    };
    /**
     * Starts the RPC. Only allowed if isStarted() returns false. The stream is
     * not immediately ready for use: onOpen() will be invoked when the RPC is
     * ready for outbound requests, at which point isOpen() will return true.
     *
     * When start returns, isStarted() will return true.
     */
    PersistentStream.prototype.start = function () {
        if (this.state === PersistentStreamState.Error) {
            this.performBackoff();
            return;
        }
        assert(this.state === PersistentStreamState.Initial, 'Already started');
        this.auth();
    };
    /**
     * Stops the RPC. This call is idempotent and allowed regardless of the
     * current isStarted() state.
     *
     * When stop returns, isStarted() and isOpen() will both return false.
     */
    PersistentStream.prototype.stop = function () {
        return tslib.__awaiter(this, void 0, void 0, function () {
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isStarted()) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.close(PersistentStreamState.Initial)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * After an error the stream will usually back off on the next attempt to
     * start it. If the error warrants an immediate restart of the stream, the
     * sender can use this to indicate that the receiver should not back off.
     *
     * Each error will call the onClose() listener. That function can decide to
     * inhibit backoff if required.
     */
    PersistentStream.prototype.inhibitBackoff = function () {
        assert(!this.isStarted(), 'Can only inhibit backoff in a stopped state');
        this.state = PersistentStreamState.Initial;
        this.backoff.reset();
    };
    /**
     * Marks this stream as idle. If no further actions are performed on the
     * stream for one minute, the stream will automatically close itself and
     * notify the stream's onClose() handler with Status.OK. The stream will then
     * be in a !isStarted() state, requiring the caller to start the stream again
     * before further use.
     *
     * Only streams that are in state 'Open' can be marked idle, as all other
     * states imply pending network operations.
     */
    PersistentStream.prototype.markIdle = function () {
        var _this = this;
        // Starts the idle time if we are in state 'Open' and are not yet already
        // running a timer (in which case the previous idle timeout still applies).
        if (this.isOpen() && this.idleTimer === null) {
            this.idleTimer = this.queue.enqueueAfterDelay(this.idleTimerId, IDLE_TIMEOUT_MS, function () { return _this.handleIdleCloseTimer(); });
        }
    };
    /** Sends a message to the underlying stream. */
    PersistentStream.prototype.sendRequest = function (msg) {
        this.cancelIdleCheck();
        this.stream.send(msg);
    };
    /** Called by the idle timer when the stream should close due to inactivity. */
    PersistentStream.prototype.handleIdleCloseTimer = function () {
        return tslib.__awaiter(this, void 0, void 0, function () {
            return tslib.__generator(this, function (_a) {
                if (this.isOpen()) {
                    // When timing out an idle stream there's no reason to force the stream into backoff when
                    // it restarts so set the stream state to Initial instead of Error.
                    return [2 /*return*/, this.close(PersistentStreamState.Initial)];
                }
                return [2 /*return*/];
            });
        });
    };
    /** Marks the stream as active again. */
    PersistentStream.prototype.cancelIdleCheck = function () {
        if (this.idleTimer) {
            this.idleTimer.cancel();
            this.idleTimer = null;
        }
    };
    /**
     * Closes the stream and cleans up as necessary:
     *
     * * closes the underlying GRPC stream;
     * * calls the onClose handler with the given 'error';
     * * sets internal stream state to 'finalState';
     * * adjusts the backoff timer based on the error
     *
     * A new stream can be opened by calling start().
     *
     * @param finalState the intended state of the stream after closing.
     * @param error the error the connection was closed with.
     */
    PersistentStream.prototype.close = function (finalState, error$1) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        assert(this.isStarted(), 'Only started streams should be closed.');
                        assert(finalState === PersistentStreamState.Error || isNullOrUndefined(error$1), "Can't provide an error when not in an error state.");
                        // Cancel any outstanding timers (they're guaranteed not to execute).
                        this.cancelIdleCheck();
                        this.backoff.cancel();
                        // Invalidates any stream-related callbacks (e.g. from auth or the
                        // underlying stream), guaranteeing they won't execute.
                        this.closeCount++;
                        if (finalState !== PersistentStreamState.Error) {
                            // If this is an intentional close ensure we don't delay our next connection attempt.
                            this.backoff.reset();
                        }
                        else if (error$1 && error$1.code === Code.RESOURCE_EXHAUSTED) {
                            // Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
                            error(error$1.toString());
                            error('Using maximum backoff delay to prevent overloading the backend.');
                            this.backoff.resetToMax();
                        }
                        else if (error$1 && error$1.code === Code.UNAUTHENTICATED) {
                            // "unauthenticated" error means the token was rejected. Try force refreshing it in case it
                            // just expired.
                            this.credentialsProvider.invalidateToken();
                        }
                        // Clean up the underlying stream because we are no longer interested in events.
                        if (this.stream !== null) {
                            this.tearDown();
                            this.stream.close();
                            this.stream = null;
                        }
                        // This state must be assigned before calling onClose() to allow the callback to
                        // inhibit backoff or otherwise manipulate the state in its non-started state.
                        this.state = finalState;
                        // Notify the listener that the stream closed.
                        return [4 /*yield*/, this.listener.onClose(error$1)];
                    case 1:
                        // Notify the listener that the stream closed.
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Can be overridden to perform additional cleanup before the stream is closed.
     * Calling super.tearDown() is not required.
     */
    PersistentStream.prototype.tearDown = function () { };
    PersistentStream.prototype.auth = function () {
        var _this = this;
        assert(this.state === PersistentStreamState.Initial, 'Must be in initial state to auth');
        this.state = PersistentStreamState.Starting;
        var dispatchIfNotClosed = this.getCloseGuardedDispatcher(this.closeCount);
        // TODO(mikelehen): Just use dispatchIfNotClosed, but see TODO below.
        var closeCount = this.closeCount;
        this.credentialsProvider.getToken().then(function (token) {
            // Stream can be stopped while waiting for authentication.
            // TODO(mikelehen): We really should just use dispatchIfNotClosed
            // and let this dispatch onto the queue, but that opened a spec test can
            // of worms that I don't want to deal with in this PR.
            if (_this.closeCount === closeCount) {
                // Normally we'd have to schedule the callback on the AsyncQueue.
                // However, the following calls are safe to be called outside the
                // AsyncQueue since they don't chain asynchronous calls
                _this.startStream(token);
            }
        }, function (error) {
            dispatchIfNotClosed(function () {
                var rpcError = new FirestoreError(Code.UNKNOWN, 'Fetching auth token failed: ' + error.message);
                return _this.handleStreamClose(rpcError);
            });
        });
    };
    PersistentStream.prototype.startStream = function (token) {
        var _this = this;
        assert(this.state === PersistentStreamState.Starting, 'Trying to start stream in a non-starting state');
        var dispatchIfNotClosed = this.getCloseGuardedDispatcher(this.closeCount);
        this.stream = this.startRpc(token);
        this.stream.onOpen(function () {
            dispatchIfNotClosed(function () {
                assert(_this.state === PersistentStreamState.Starting, 'Expected stream to be in state Starting, but was ' + _this.state);
                _this.state = PersistentStreamState.Open;
                return _this.listener.onOpen();
            });
        });
        this.stream.onClose(function (error) {
            dispatchIfNotClosed(function () {
                return _this.handleStreamClose(error);
            });
        });
        this.stream.onMessage(function (msg) {
            dispatchIfNotClosed(function () {
                return _this.onMessage(msg);
            });
        });
    };
    PersistentStream.prototype.performBackoff = function () {
        var _this = this;
        assert(this.state === PersistentStreamState.Error, 'Should only perform backoff when in Error state');
        this.state = PersistentStreamState.Backoff;
        this.backoff.backoffAndRun(function () { return tslib.__awaiter(_this, void 0, void 0, function () {
            return tslib.__generator(this, function (_a) {
                assert(this.state === PersistentStreamState.Backoff, 'Backoff elapsed but state is now: ' + this.state);
                this.state = PersistentStreamState.Initial;
                this.start();
                assert(this.isStarted(), 'PersistentStream should have started');
                return [2 /*return*/];
            });
        }); });
    };
    // Visible for tests
    PersistentStream.prototype.handleStreamClose = function (error) {
        assert(this.isStarted(), "Can't handle server close on non-started stream");
        debug(LOG_TAG$5, "close with error: " + error);
        this.stream = null;
        // In theory the stream could close cleanly, however, in our current model
        // we never expect this to happen because if we stop a stream ourselves,
        // this callback will never be called. To prevent cases where we retry
        // without a backoff accidentally, we set the stream to error in all cases.
        return this.close(PersistentStreamState.Error, error);
    };
    /**
     * Returns a "dispatcher" function that dispatches operations onto the
     * AsyncQueue but only runs them if closeCount remains unchanged. This allows
     * us to turn auth / stream callbacks into no-ops if the stream is closed /
     * re-opened, etc.
     */
    PersistentStream.prototype.getCloseGuardedDispatcher = function (startCloseCount) {
        var _this = this;
        return function (fn) {
            _this.queue.enqueueAndForget(function () {
                if (_this.closeCount === startCloseCount) {
                    return fn();
                }
                else {
                    debug(LOG_TAG$5, 'stream callback skipped by getCloseGuardedDispatcher.');
                    return Promise.resolve();
                }
            });
        };
    };
    return PersistentStream;
}());
/**
 * A PersistentStream that implements the Listen RPC.
 *
 * Once the Listen stream has called the onOpen() listener, any number of
 * listen() and unlisten() calls can be made to control what changes will be
 * sent from the server for ListenResponses.
 */
var PersistentListenStream = /** @class */ (function (_super) {
    tslib.__extends(PersistentListenStream, _super);
    function PersistentListenStream(queue, connection, credentials, serializer, listener) {
        var _this = _super.call(this, queue, TimerId.ListenStreamConnectionBackoff, TimerId.ListenStreamIdle, connection, credentials, listener) || this;
        _this.serializer = serializer;
        return _this;
    }
    PersistentListenStream.prototype.startRpc = function (token) {
        return this.connection.openStream('Listen', token);
    };
    PersistentListenStream.prototype.onMessage = function (watchChangeProto) {
        // A successful response means the stream is healthy
        this.backoff.reset();
        var watchChange = this.serializer.fromWatchChange(watchChangeProto);
        var snapshot = this.serializer.versionFromListenResponse(watchChangeProto);
        return this.listener.onWatchChange(watchChange, snapshot);
    };
    /**
     * Registers interest in the results of the given target. If the target
     * includes a resumeToken it will be included in the request. Results that
     * affect the target will be streamed back as WatchChange messages that
     * reference the targetId.
     */
    PersistentListenStream.prototype.watch = function (targetData) {
        var request = {};
        request.database = this.serializer.encodedDatabaseId;
        request.addTarget = this.serializer.toTarget(targetData);
        var labels = this.serializer.toListenRequestLabels(targetData);
        if (labels) {
            request.labels = labels;
        }
        this.sendRequest(request);
    };
    /**
     * Unregisters interest in the results of the target associated with the
     * given targetId.
     */
    PersistentListenStream.prototype.unwatch = function (targetId) {
        var request = {};
        request.database = this.serializer.encodedDatabaseId;
        request.removeTarget = targetId;
        this.sendRequest(request);
    };
    return PersistentListenStream;
}(PersistentStream));
/**
 * A Stream that implements the Write RPC.
 *
 * The Write RPC requires the caller to maintain special streamToken
 * state in between calls, to help the server understand which responses the
 * client has processed by the time the next request is made. Every response
 * will contain a streamToken; this value must be passed to the next
 * request.
 *
 * After calling start() on this stream, the next request must be a handshake,
 * containing whatever streamToken is on hand. Once a response to this
 * request is received, all pending mutations may be submitted. When
 * submitting multiple batches of mutations at the same time, it's
 * okay to use the same streamToken for the calls to writeMutations.
 *
 * TODO(b/33271235): Use proto types
 */
var PersistentWriteStream = /** @class */ (function (_super) {
    tslib.__extends(PersistentWriteStream, _super);
    function PersistentWriteStream(queue, connection, credentials, serializer, listener) {
        var _this = _super.call(this, queue, TimerId.WriteStreamConnectionBackoff, TimerId.WriteStreamIdle, connection, credentials, listener) || this;
        _this.serializer = serializer;
        _this.handshakeComplete_ = false;
        /**
         * The last received stream token from the server, used to acknowledge which
         * responses the client has processed. Stream tokens are opaque checkpoint
         * markers whose only real value is their inclusion in the next request.
         *
         * PersistentWriteStream manages propagating this value from responses to the
         * next request.
         */
        _this.lastStreamToken = emptyByteString();
        return _this;
    }
    Object.defineProperty(PersistentWriteStream.prototype, "handshakeComplete", {
        /**
         * Tracks whether or not a handshake has been successfully exchanged and
         * the stream is ready to accept mutations.
         */
        get: function () {
            return this.handshakeComplete_;
        },
        enumerable: true,
        configurable: true
    });
    // Override of PersistentStream.start
    PersistentWriteStream.prototype.start = function () {
        this.handshakeComplete_ = false;
        _super.prototype.start.call(this);
    };
    PersistentWriteStream.prototype.tearDown = function () {
        if (this.handshakeComplete_) {
            this.writeMutations([]);
        }
    };
    PersistentWriteStream.prototype.startRpc = function (token) {
        return this.connection.openStream('Write', token);
    };
    PersistentWriteStream.prototype.onMessage = function (responseProto) {
        // Always capture the last stream token.
        assert(!!responseProto.streamToken, 'Got a write response without a stream token');
        this.lastStreamToken = responseProto.streamToken;
        if (!this.handshakeComplete_) {
            // The first response is always the handshake response
            assert(!responseProto.writeResults || responseProto.writeResults.length === 0, 'Got mutation results for handshake');
            this.handshakeComplete_ = true;
            return this.listener.onHandshakeComplete();
        }
        else {
            // A successful first write response means the stream is healthy,
            // Note, that we could consider a successful handshake healthy, however,
            // the write itself might be causing an error we want to back off from.
            this.backoff.reset();
            var results = this.serializer.fromWriteResults(responseProto.writeResults, responseProto.commitTime);
            var commitVersion = this.serializer.fromVersion(responseProto.commitTime);
            return this.listener.onMutationResult(commitVersion, results);
        }
    };
    /**
     * Sends an initial streamToken to the server, performing the handshake
     * required to make the StreamingWrite RPC work. Subsequent
     * calls should wait until onHandshakeComplete was called.
     */
    PersistentWriteStream.prototype.writeHandshake = function () {
        assert(this.isOpen(), 'Writing handshake requires an opened stream');
        assert(!this.handshakeComplete_, 'Handshake already completed');
        // TODO(dimond): Support stream resumption. We intentionally do not set the
        // stream token on the handshake, ignoring any stream token we might have.
        var request = {};
        request.database = this.serializer.encodedDatabaseId;
        this.sendRequest(request);
    };
    /** Sends a group of mutations to the Firestore backend to apply. */
    PersistentWriteStream.prototype.writeMutations = function (mutations) {
        var _this = this;
        assert(this.isOpen(), 'Writing mutations requires an opened stream');
        assert(this.handshakeComplete_, 'Handshake must be complete before writing mutations');
        assert(this.lastStreamToken.length > 0, 'Trying to write mutation without a token');
        var request = {
            // Protos are typed with string, but we support UInt8Array on Node
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            streamToken: this.lastStreamToken,
            writes: mutations.map(function (mutation) { return _this.serializer.toMutation(mutation); })
        };
        this.sendRequest(request);
    };
    return PersistentWriteStream;
}(PersistentStream));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Datastore is a wrapper around the external Google Cloud Datastore grpc API,
 * which provides an interface that is more convenient for the rest of the
 * client SDK architecture to consume.
 */
var Datastore = /** @class */ (function () {
    function Datastore(queue, connection, credentials, serializer) {
        this.queue = queue;
        this.connection = connection;
        this.credentials = credentials;
        this.serializer = serializer;
    }
    Datastore.prototype.newPersistentWriteStream = function (listener) {
        return new PersistentWriteStream(this.queue, this.connection, this.credentials, this.serializer, listener);
    };
    Datastore.prototype.newPersistentWatchStream = function (listener) {
        return new PersistentListenStream(this.queue, this.connection, this.credentials, this.serializer, listener);
    };
    Datastore.prototype.commit = function (mutations) {
        var _this = this;
        var params = {
            database: this.serializer.encodedDatabaseId,
            writes: mutations.map(function (m) { return _this.serializer.toMutation(m); })
        };
        return this.invokeRPC('Commit', params).then(function (response) {
            return _this.serializer.fromWriteResults(response.writeResults, response.commitTime);
        });
    };
    Datastore.prototype.lookup = function (keys) {
        var _this = this;
        var params = {
            database: this.serializer.encodedDatabaseId,
            documents: keys.map(function (k) { return _this.serializer.toName(k); })
        };
        return this.invokeStreamingRPC('BatchGetDocuments', params).then(function (response) {
            var docs = maybeDocumentMap();
            response.forEach(function (proto) {
                var doc = _this.serializer.fromMaybeDocument(proto);
                docs = docs.insert(doc.key, doc);
            });
            var result = [];
            keys.forEach(function (key) {
                var doc = docs.get(key);
                assert(!!doc, 'Missing entity in write response for ' + key);
                result.push(doc);
            });
            return result;
        });
    };
    /** Gets an auth token and invokes the provided RPC. */
    Datastore.prototype.invokeRPC = function (rpcName, request) {
        var _this = this;
        return this.credentials
            .getToken()
            .then(function (token) {
            return _this.connection.invokeRPC(rpcName, request, token);
        })
            .catch(function (error) {
            if (error.code === Code.UNAUTHENTICATED) {
                _this.credentials.invalidateToken();
            }
            throw error;
        });
    };
    /** Gets an auth token and invokes the provided RPC with streamed results. */
    Datastore.prototype.invokeStreamingRPC = function (rpcName, request) {
        var _this = this;
        return this.credentials
            .getToken()
            .then(function (token) {
            return _this.connection.invokeStreamingRPC(rpcName, request, token);
        })
            .catch(function (error) {
            if (error.code === Code.UNAUTHENTICATED) {
                _this.credentials.invalidateToken();
            }
            throw error;
        });
    };
    return Datastore;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Internal transaction object responsible for accumulating the mutations to
 * perform and the base versions for any documents read.
 */
var Transaction = /** @class */ (function () {
    function Transaction(datastore) {
        this.datastore = datastore;
        // The version of each document that was read during this transaction.
        this.readVersions = documentVersionMap();
        this.mutations = [];
        this.committed = false;
        /**
         * A deferred usage error that occurred previously in this transaction that
         * will cause the transaction to fail once it actually commits.
         */
        this.lastWriteError = null;
        /**
         * Set of documents that have been written in the transaction.
         *
         * When there's more than one write to the same key in a transaction, any
         * writes after hte first are handled differently.
         */
        this.writtenDocs = new Set();
    }
    Transaction.prototype.lookup = function (keys) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var docs;
            var _this = this;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.ensureCommitNotCalled();
                        if (this.mutations.length > 0) {
                            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Firestore transactions require all reads to be executed before all writes.');
                        }
                        return [4 /*yield*/, this.datastore.lookup(keys)];
                    case 1:
                        docs = _a.sent();
                        docs.forEach(function (doc) {
                            if (doc instanceof NoDocument || doc instanceof Document) {
                                _this.recordVersion(doc);
                            }
                            else {
                                fail('Document in a transaction was a ' + doc.constructor.name);
                            }
                        });
                        return [2 /*return*/, docs];
                }
            });
        });
    };
    Transaction.prototype.set = function (key, data) {
        this.write(data.toMutations(key, this.precondition(key)));
        this.writtenDocs.add(key);
    };
    Transaction.prototype.update = function (key, data) {
        try {
            this.write(data.toMutations(key, this.preconditionForUpdate(key)));
        }
        catch (e) {
            this.lastWriteError = e;
        }
        this.writtenDocs.add(key);
    };
    Transaction.prototype.delete = function (key) {
        this.write([new DeleteMutation(key, this.precondition(key))]);
        this.writtenDocs.add(key);
    };
    Transaction.prototype.commit = function () {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var unwritten;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.ensureCommitNotCalled();
                        if (this.lastWriteError) {
                            throw this.lastWriteError;
                        }
                        unwritten = this.readVersions;
                        // For each mutation, note that the doc was written.
                        this.mutations.forEach(function (mutation) {
                            unwritten = unwritten.remove(mutation.key);
                        });
                        if (!unwritten.isEmpty()) {
                            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Every document read in a transaction must also be written.');
                        }
                        return [4 /*yield*/, this.datastore.commit(this.mutations)];
                    case 1:
                        _a.sent();
                        this.committed = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    Transaction.prototype.recordVersion = function (doc) {
        var docVersion;
        if (doc instanceof Document) {
            docVersion = doc.version;
        }
        else if (doc instanceof NoDocument) {
            // For deleted docs, we must use baseVersion 0 when we overwrite them.
            docVersion = SnapshotVersion.forDeletedDoc();
        }
        else {
            throw fail('Document in a transaction was a ' + doc.constructor.name);
        }
        var existingVersion = this.readVersions.get(doc.key);
        if (existingVersion !== null) {
            if (!docVersion.isEqual(existingVersion)) {
                // This transaction will fail no matter what.
                throw new FirestoreError(Code.ABORTED, 'Document version changed between two reads.');
            }
        }
        else {
            this.readVersions = this.readVersions.insert(doc.key, docVersion);
        }
    };
    /**
     * Returns the version of this document when it was read in this transaction,
     * as a precondition, or no precondition if it was not read.
     */
    Transaction.prototype.precondition = function (key) {
        var version = this.readVersions.get(key);
        if (!this.writtenDocs.has(key) && version) {
            return Precondition.updateTime(version);
        }
        else {
            return Precondition.NONE;
        }
    };
    /**
     * Returns the precondition for a document if the operation is an update.
     */
    Transaction.prototype.preconditionForUpdate = function (key) {
        var version = this.readVersions.get(key);
        // The first time a document is written, we want to take into account the
        // read time and existence
        if (!this.writtenDocs.has(key) && version) {
            if (version.isEqual(SnapshotVersion.forDeletedDoc())) {
                // The document doesn't exist, so fail the transaction.
                // This has to be validated locally because you can't send a
                // precondition that a document does not exist without changing the
                // semantics of the backend write to be an insert. This is the reverse
                // of what we want, since we want to assert that the document doesn't
                // exist but then send the update and have it fail. Since we can't
                // express that to the backend, we have to validate locally.
                // Note: this can change once we can send separate verify writes in the
                // transaction.
                throw new FirestoreError(Code.INVALID_ARGUMENT, "Can't update a document that doesn't exist.");
            }
            // Document exists, base precondition on document update time.
            return Precondition.updateTime(version);
        }
        else {
            // Document was not read, so we just use the preconditions for a blind
            // update.
            return Precondition.exists(true);
        }
    };
    Transaction.prototype.write = function (mutations) {
        this.ensureCommitNotCalled();
        this.mutations = this.mutations.concat(mutations);
    };
    Transaction.prototype.ensureCommitNotCalled = function () {
        assert(!this.committed, 'A transaction object cannot be used after its update callback has been invoked.');
    };
    return Transaction;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Describes the online state of the Firestore client. Note that this does not
 * indicate whether or not the remote store is trying to connect or not. This is
 * primarily used by the View / EventManager code to change their behavior while
 * offline (e.g. get() calls shouldn't wait for data from the server and
 * snapshot events should set metadata.isFromCache=true).
 */
var OnlineState;
(function (OnlineState) {
    /**
     * The Firestore client is in an unknown online state. This means the client
     * is either not actively trying to establish a connection or it is currently
     * trying to establish a connection, but it has not succeeded or failed yet.
     * Higher-level components should not operate in offline mode.
     */
    OnlineState[OnlineState["Unknown"] = 0] = "Unknown";
    /**
     * The client is connected and the connections are healthy. This state is
     * reached after a successful connection and there has been at least one
     * successful message received from the backends.
     */
    OnlineState[OnlineState["Online"] = 1] = "Online";
    /**
     * The client is either trying to establish a connection but failing, or it
     * has been explicitly marked offline via a call to disableNetwork().
     * Higher-level components should operate in offline mode.
     */
    OnlineState[OnlineState["Offline"] = 2] = "Offline";
})(OnlineState || (OnlineState = {}));
/** The source of an online state event. */
var OnlineStateSource;
(function (OnlineStateSource) {
    OnlineStateSource[OnlineStateSource["RemoteStore"] = 0] = "RemoteStore";
    OnlineStateSource[OnlineStateSource["SharedClientState"] = 1] = "SharedClientState";
})(OnlineStateSource || (OnlineStateSource = {}));

/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$6 = 'OnlineStateTracker';
// To deal with transient failures, we allow multiple stream attempts before
// giving up and transitioning from OnlineState.Unknown to Offline.
// TODO(mikelehen): This used to be set to 2 as a mitigation for b/66228394.
// @jdimond thinks that bug is sufficiently fixed so that we can set this back
// to 1. If that works okay, we could potentially remove this logic entirely.
var MAX_WATCH_STREAM_FAILURES = 1;
// To deal with stream attempts that don't succeed or fail in a timely manner,
// we have a timeout for OnlineState to reach Online or Offline.
// If the timeout is reached, we transition to Offline rather than waiting
// indefinitely.
var ONLINE_STATE_TIMEOUT_MS = 10 * 1000;
/**
 * A component used by the RemoteStore to track the OnlineState (that is,
 * whether or not the client as a whole should be considered to be online or
 * offline), implementing the appropriate heuristics.
 *
 * In particular, when the client is trying to connect to the backend, we
 * allow up to MAX_WATCH_STREAM_FAILURES within ONLINE_STATE_TIMEOUT_MS for
 * a connection to succeed. If we have too many failures or the timeout elapses,
 * then we set the OnlineState to Offline, and the client will behave as if
 * it is offline (get()s will return cached data, etc.).
 */
var OnlineStateTracker = /** @class */ (function () {
    function OnlineStateTracker(asyncQueue, onlineStateHandler) {
        this.asyncQueue = asyncQueue;
        this.onlineStateHandler = onlineStateHandler;
        /** The current OnlineState. */
        this.state = OnlineState.Unknown;
        /**
         * A count of consecutive failures to open the stream. If it reaches the
         * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
         * Offline.
         */
        this.watchStreamFailures = 0;
        /**
         * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
         * transition from OnlineState.Unknown to OnlineState.Offline without waiting
         * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
         */
        this.onlineStateTimer = null;
        /**
         * Whether the client should log a warning message if it fails to connect to
         * the backend (initially true, cleared after a successful stream, or if we've
         * logged the message already).
         */
        this.shouldWarnClientIsOffline = true;
    }
    /**
     * Called by RemoteStore when a watch stream is started (including on each
     * backoff attempt).
     *
     * If this is the first attempt, it sets the OnlineState to Unknown and starts
     * the onlineStateTimer.
     */
    OnlineStateTracker.prototype.handleWatchStreamStart = function () {
        var _this = this;
        if (this.watchStreamFailures === 0) {
            this.setAndBroadcast(OnlineState.Unknown);
            assert(this.onlineStateTimer === null, "onlineStateTimer shouldn't be started yet");
            this.onlineStateTimer = this.asyncQueue.enqueueAfterDelay(TimerId.OnlineStateTimeout, ONLINE_STATE_TIMEOUT_MS, function () {
                _this.onlineStateTimer = null;
                assert(_this.state === OnlineState.Unknown, 'Timer should be canceled if we transitioned to a different state.');
                _this.logClientOfflineWarningIfNecessary("Backend didn't respond within " + ONLINE_STATE_TIMEOUT_MS / 1000 + " " +
                    "seconds.");
                _this.setAndBroadcast(OnlineState.Offline);
                // NOTE: handleWatchStreamFailure() will continue to increment
                // watchStreamFailures even though we are already marked Offline,
                // but this is non-harmful.
                return Promise.resolve();
            });
        }
    };
    /**
     * Updates our OnlineState as appropriate after the watch stream reports a
     * failure. The first failure moves us to the 'Unknown' state. We then may
     * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
     * actually transition to the 'Offline' state.
     */
    OnlineStateTracker.prototype.handleWatchStreamFailure = function (error) {
        if (this.state === OnlineState.Online) {
            this.setAndBroadcast(OnlineState.Unknown);
            // To get to OnlineState.Online, set() must have been called which would
            // have reset our heuristics.
            assert(this.watchStreamFailures === 0, 'watchStreamFailures must be 0');
            assert(this.onlineStateTimer === null, 'onlineStateTimer must be null');
        }
        else {
            this.watchStreamFailures++;
            if (this.watchStreamFailures >= MAX_WATCH_STREAM_FAILURES) {
                this.clearOnlineStateTimer();
                this.logClientOfflineWarningIfNecessary("Connection failed " + MAX_WATCH_STREAM_FAILURES + " " +
                    ("times. Most recent error: " + error.toString()));
                this.setAndBroadcast(OnlineState.Offline);
            }
        }
    };
    /**
     * Explicitly sets the OnlineState to the specified state.
     *
     * Note that this resets our timers / failure counters, etc. used by our
     * Offline heuristics, so must not be used in place of
     * handleWatchStreamStart() and handleWatchStreamFailure().
     */
    OnlineStateTracker.prototype.set = function (newState) {
        this.clearOnlineStateTimer();
        this.watchStreamFailures = 0;
        if (newState === OnlineState.Online) {
            // We've connected to watch at least once. Don't warn the developer
            // about being offline going forward.
            this.shouldWarnClientIsOffline = false;
        }
        this.setAndBroadcast(newState);
    };
    OnlineStateTracker.prototype.setAndBroadcast = function (newState) {
        if (newState !== this.state) {
            this.state = newState;
            this.onlineStateHandler(newState);
        }
    };
    OnlineStateTracker.prototype.logClientOfflineWarningIfNecessary = function (details) {
        var message = "Could not reach Cloud Firestore backend. " + details + "\n" +
            "This typically indicates that your device does not have a healthy " +
            "Internet connection at the moment. The client will operate in offline " +
            "mode until it is able to successfully connect to the backend.";
        if (this.shouldWarnClientIsOffline) {
            error(message);
            this.shouldWarnClientIsOffline = false;
        }
        else {
            debug(LOG_TAG$6, message);
        }
    };
    OnlineStateTracker.prototype.clearOnlineStateTimer = function () {
        if (this.onlineStateTimer !== null) {
            this.onlineStateTimer.cancel();
            this.onlineStateTimer = null;
        }
    };
    return OnlineStateTracker;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Error Codes describing the different ways GRPC can fail. These are copied
 * directly from GRPC's sources here:
 *
 * https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
 *
 * Important! The names of these identifiers matter because the string forms
 * are used for reverse lookups from the webchannel stream. Do NOT change the
 * names of these identifiers.
 */
var RpcCode;
(function (RpcCode) {
    RpcCode[RpcCode["OK"] = 0] = "OK";
    RpcCode[RpcCode["CANCELLED"] = 1] = "CANCELLED";
    RpcCode[RpcCode["UNKNOWN"] = 2] = "UNKNOWN";
    RpcCode[RpcCode["INVALID_ARGUMENT"] = 3] = "INVALID_ARGUMENT";
    RpcCode[RpcCode["DEADLINE_EXCEEDED"] = 4] = "DEADLINE_EXCEEDED";
    RpcCode[RpcCode["NOT_FOUND"] = 5] = "NOT_FOUND";
    RpcCode[RpcCode["ALREADY_EXISTS"] = 6] = "ALREADY_EXISTS";
    RpcCode[RpcCode["PERMISSION_DENIED"] = 7] = "PERMISSION_DENIED";
    RpcCode[RpcCode["UNAUTHENTICATED"] = 16] = "UNAUTHENTICATED";
    RpcCode[RpcCode["RESOURCE_EXHAUSTED"] = 8] = "RESOURCE_EXHAUSTED";
    RpcCode[RpcCode["FAILED_PRECONDITION"] = 9] = "FAILED_PRECONDITION";
    RpcCode[RpcCode["ABORTED"] = 10] = "ABORTED";
    RpcCode[RpcCode["OUT_OF_RANGE"] = 11] = "OUT_OF_RANGE";
    RpcCode[RpcCode["UNIMPLEMENTED"] = 12] = "UNIMPLEMENTED";
    RpcCode[RpcCode["INTERNAL"] = 13] = "INTERNAL";
    RpcCode[RpcCode["UNAVAILABLE"] = 14] = "UNAVAILABLE";
    RpcCode[RpcCode["DATA_LOSS"] = 15] = "DATA_LOSS";
})(RpcCode || (RpcCode = {}));
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a non-write operation.
 *
 * See isPermanentWriteError for classifying write errors.
 */
function isPermanentError(code) {
    switch (code) {
        case Code.OK:
            return fail('Treated status OK as error');
        case Code.CANCELLED:
        case Code.UNKNOWN:
        case Code.DEADLINE_EXCEEDED:
        case Code.RESOURCE_EXHAUSTED:
        case Code.INTERNAL:
        case Code.UNAVAILABLE:
        // Unauthenticated means something went wrong with our token and we need
        // to retry with new credentials which will happen automatically.
        case Code.UNAUTHENTICATED:
            return false;
        case Code.INVALID_ARGUMENT:
        case Code.NOT_FOUND:
        case Code.ALREADY_EXISTS:
        case Code.PERMISSION_DENIED:
        case Code.FAILED_PRECONDITION:
        // Aborted might be retried in some scenarios, but that is dependant on
        // the context and should handled individually by the calling code.
        // See https://cloud.google.com/apis/design/errors.
        case Code.ABORTED:
        case Code.OUT_OF_RANGE:
        case Code.UNIMPLEMENTED:
        case Code.DATA_LOSS:
            return true;
        default:
            return fail('Unknown status code: ' + code);
    }
}
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a write operation.
 *
 * Write operations must be handled specially because as of b/119437764, ABORTED
 * errors on the write stream should be retried too (even though ABORTED errors
 * are not generally retryable).
 *
 * Note that during the initial handshake on the write stream an ABORTED error
 * signals that we should discard our stream token (i.e. it is permanent). This
 * means a handshake error should be classified with isPermanentError, above.
 */
function isPermanentWriteError(code) {
    return isPermanentError(code) && code !== Code.ABORTED;
}
/**
 * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
 *
 * @returns The Code equivalent to the given status string or undefined if
 *     there is no match.
 */
function mapCodeFromRpcStatus(status) {
    // lookup by string
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var code = RpcCode[status];
    if (code === undefined) {
        return undefined;
    }
    return mapCodeFromRpcCode(code);
}
/**
 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
 * are not the same as HTTP status codes.
 *
 * @returns The Code equivalent to the given GRPC status code. Fails if there
 *     is no match.
 */
function mapCodeFromRpcCode(code) {
    if (code === undefined) {
        // This shouldn't normally happen, but in certain error cases (like trying
        // to send invalid proto messages) we may get an error with no GRPC code.
        error('GRPC error has no .code');
        return Code.UNKNOWN;
    }
    switch (code) {
        case RpcCode.OK:
            return Code.OK;
        case RpcCode.CANCELLED:
            return Code.CANCELLED;
        case RpcCode.UNKNOWN:
            return Code.UNKNOWN;
        case RpcCode.DEADLINE_EXCEEDED:
            return Code.DEADLINE_EXCEEDED;
        case RpcCode.RESOURCE_EXHAUSTED:
            return Code.RESOURCE_EXHAUSTED;
        case RpcCode.INTERNAL:
            return Code.INTERNAL;
        case RpcCode.UNAVAILABLE:
            return Code.UNAVAILABLE;
        case RpcCode.UNAUTHENTICATED:
            return Code.UNAUTHENTICATED;
        case RpcCode.INVALID_ARGUMENT:
            return Code.INVALID_ARGUMENT;
        case RpcCode.NOT_FOUND:
            return Code.NOT_FOUND;
        case RpcCode.ALREADY_EXISTS:
            return Code.ALREADY_EXISTS;
        case RpcCode.PERMISSION_DENIED:
            return Code.PERMISSION_DENIED;
        case RpcCode.FAILED_PRECONDITION:
            return Code.FAILED_PRECONDITION;
        case RpcCode.ABORTED:
            return Code.ABORTED;
        case RpcCode.OUT_OF_RANGE:
            return Code.OUT_OF_RANGE;
        case RpcCode.UNIMPLEMENTED:
            return Code.UNIMPLEMENTED;
        case RpcCode.DATA_LOSS:
            return Code.DATA_LOSS;
        default:
            return fail('Unknown status code: ' + code);
    }
}
/**
 * Maps an RPC code from a Code. This is the reverse operation from
 * mapCodeFromRpcCode and should really only be used in tests.
 */
function mapRpcCodeFromCode(code) {
    if (code === undefined) {
        return RpcCode.OK;
    }
    switch (code) {
        case Code.OK:
            return RpcCode.OK;
        case Code.CANCELLED:
            return RpcCode.CANCELLED;
        case Code.UNKNOWN:
            return RpcCode.UNKNOWN;
        case Code.DEADLINE_EXCEEDED:
            return RpcCode.DEADLINE_EXCEEDED;
        case Code.RESOURCE_EXHAUSTED:
            return RpcCode.RESOURCE_EXHAUSTED;
        case Code.INTERNAL:
            return RpcCode.INTERNAL;
        case Code.UNAVAILABLE:
            return RpcCode.UNAVAILABLE;
        case Code.UNAUTHENTICATED:
            return RpcCode.UNAUTHENTICATED;
        case Code.INVALID_ARGUMENT:
            return RpcCode.INVALID_ARGUMENT;
        case Code.NOT_FOUND:
            return RpcCode.NOT_FOUND;
        case Code.ALREADY_EXISTS:
            return RpcCode.ALREADY_EXISTS;
        case Code.PERMISSION_DENIED:
            return RpcCode.PERMISSION_DENIED;
        case Code.FAILED_PRECONDITION:
            return RpcCode.FAILED_PRECONDITION;
        case Code.ABORTED:
            return RpcCode.ABORTED;
        case Code.OUT_OF_RANGE:
            return RpcCode.OUT_OF_RANGE;
        case Code.UNIMPLEMENTED:
            return RpcCode.UNIMPLEMENTED;
        case Code.DATA_LOSS:
            return RpcCode.DATA_LOSS;
        default:
            return fail('Unknown status code: ' + code);
    }
}
/**
 * Converts an HTTP response's error status to the equivalent error code.
 *
 * @param status An HTTP error response status ("FAILED_PRECONDITION",
 * "UNKNOWN", etc.)
 * @returns The equivalent Code. Non-matching responses are mapped to
 *     Code.UNKNOWN.
 */
function mapCodeFromHttpResponseErrorStatus(status) {
    var serverError = status.toLowerCase().replace('_', '-');
    return Object.values(Code).indexOf(serverError) >= 0
        ? serverError
        : Code.UNKNOWN;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * DocumentSet is an immutable (copy-on-write) collection that holds documents
 * in order specified by the provided comparator. We always add a document key
 * comparator on top of what is provided to guarantee document equality based on
 * the key.
 */
var DocumentSet = /** @class */ (function () {
    /** The default ordering is by key if the comparator is omitted */
    function DocumentSet(comp) {
        // We are adding document key comparator to the end as it's the only
        // guaranteed unique property of a document.
        if (comp) {
            this.comparator = function (d1, d2) {
                return comp(d1, d2) || DocumentKey.comparator(d1.key, d2.key);
            };
        }
        else {
            this.comparator = function (d1, d2) {
                return DocumentKey.comparator(d1.key, d2.key);
            };
        }
        this.keyedMap = documentMap();
        this.sortedSet = new SortedMap(this.comparator);
    }
    /**
     * Returns an empty copy of the existing DocumentSet, using the same
     * comparator.
     */
    DocumentSet.emptySet = function (oldSet) {
        return new DocumentSet(oldSet.comparator);
    };
    DocumentSet.prototype.has = function (key) {
        return this.keyedMap.get(key) != null;
    };
    DocumentSet.prototype.get = function (key) {
        return this.keyedMap.get(key);
    };
    DocumentSet.prototype.first = function () {
        return this.sortedSet.minKey();
    };
    DocumentSet.prototype.last = function () {
        return this.sortedSet.maxKey();
    };
    DocumentSet.prototype.isEmpty = function () {
        return this.sortedSet.isEmpty();
    };
    /**
     * Returns the index of the provided key in the document set, or -1 if the
     * document key is not present in the set;
     */
    DocumentSet.prototype.indexOf = function (key) {
        var doc = this.keyedMap.get(key);
        return doc ? this.sortedSet.indexOf(doc) : -1;
    };
    Object.defineProperty(DocumentSet.prototype, "size", {
        get: function () {
            return this.sortedSet.size;
        },
        enumerable: true,
        configurable: true
    });
    /** Iterates documents in order defined by "comparator" */
    DocumentSet.prototype.forEach = function (cb) {
        this.sortedSet.inorderTraversal(function (k, v) {
            cb(k);
            return false;
        });
    };
    /** Inserts or updates a document with the same key */
    DocumentSet.prototype.add = function (doc) {
        // First remove the element if we have it.
        var set = this.delete(doc.key);
        return set.copy(set.keyedMap.insert(doc.key, doc), set.sortedSet.insert(doc, null));
    };
    /** Deletes a document with a given key */
    DocumentSet.prototype.delete = function (key) {
        var doc = this.get(key);
        if (!doc) {
            return this;
        }
        return this.copy(this.keyedMap.remove(key), this.sortedSet.remove(doc));
    };
    DocumentSet.prototype.isEqual = function (other) {
        if (!(other instanceof DocumentSet)) {
            return false;
        }
        if (this.size !== other.size) {
            return false;
        }
        var thisIt = this.sortedSet.getIterator();
        var otherIt = other.sortedSet.getIterator();
        while (thisIt.hasNext()) {
            var thisDoc = thisIt.getNext().key;
            var otherDoc = otherIt.getNext().key;
            if (!thisDoc.isEqual(otherDoc)) {
                return false;
            }
        }
        return true;
    };
    DocumentSet.prototype.toString = function () {
        var docStrings = [];
        this.forEach(function (doc) {
            docStrings.push(doc.toString());
        });
        if (docStrings.length === 0) {
            return 'DocumentSet ()';
        }
        else {
            return 'DocumentSet (\n  ' + docStrings.join('  \n') + '\n)';
        }
    };
    DocumentSet.prototype.copy = function (keyedMap, sortedSet) {
        var newSet = new DocumentSet();
        newSet.comparator = this.comparator;
        newSet.keyedMap = keyedMap;
        newSet.sortedSet = sortedSet;
        return newSet;
    };
    return DocumentSet;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ChangeType;
(function (ChangeType) {
    ChangeType[ChangeType["Added"] = 0] = "Added";
    ChangeType[ChangeType["Removed"] = 1] = "Removed";
    ChangeType[ChangeType["Modified"] = 2] = "Modified";
    ChangeType[ChangeType["Metadata"] = 3] = "Metadata";
})(ChangeType || (ChangeType = {}));
var SyncState;
(function (SyncState) {
    SyncState[SyncState["Local"] = 0] = "Local";
    SyncState[SyncState["Synced"] = 1] = "Synced";
})(SyncState || (SyncState = {}));
/**
 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
 * duplicate events for the same doc.
 */
var DocumentChangeSet = /** @class */ (function () {
    function DocumentChangeSet() {
        this.changeMap = new SortedMap(DocumentKey.comparator);
    }
    DocumentChangeSet.prototype.track = function (change) {
        var key = change.doc.key;
        var oldChange = this.changeMap.get(key);
        if (!oldChange) {
            this.changeMap = this.changeMap.insert(key, change);
            return;
        }
        // Merge the new change with the existing change.
        if (change.type !== ChangeType.Added &&
            oldChange.type === ChangeType.Metadata) {
            this.changeMap = this.changeMap.insert(key, change);
        }
        else if (change.type === ChangeType.Metadata &&
            oldChange.type !== ChangeType.Removed) {
            this.changeMap = this.changeMap.insert(key, {
                type: oldChange.type,
                doc: change.doc
            });
        }
        else if (change.type === ChangeType.Modified &&
            oldChange.type === ChangeType.Modified) {
            this.changeMap = this.changeMap.insert(key, {
                type: ChangeType.Modified,
                doc: change.doc
            });
        }
        else if (change.type === ChangeType.Modified &&
            oldChange.type === ChangeType.Added) {
            this.changeMap = this.changeMap.insert(key, {
                type: ChangeType.Added,
                doc: change.doc
            });
        }
        else if (change.type === ChangeType.Removed &&
            oldChange.type === ChangeType.Added) {
            this.changeMap = this.changeMap.remove(key);
        }
        else if (change.type === ChangeType.Removed &&
            oldChange.type === ChangeType.Modified) {
            this.changeMap = this.changeMap.insert(key, {
                type: ChangeType.Removed,
                doc: oldChange.doc
            });
        }
        else if (change.type === ChangeType.Added &&
            oldChange.type === ChangeType.Removed) {
            this.changeMap = this.changeMap.insert(key, {
                type: ChangeType.Modified,
                doc: change.doc
            });
        }
        else {
            // This includes these cases, which don't make sense:
            // Added->Added
            // Removed->Removed
            // Modified->Added
            // Removed->Modified
            // Metadata->Added
            // Removed->Metadata
            fail('unsupported combination of changes: ' +
                JSON.stringify(change) +
                ' after ' +
                JSON.stringify(oldChange));
        }
    };
    DocumentChangeSet.prototype.getChanges = function () {
        var changes = [];
        this.changeMap.inorderTraversal(function (key, change) {
            changes.push(change);
        });
        return changes;
    };
    return DocumentChangeSet;
}());
var ViewSnapshot = /** @class */ (function () {
    function ViewSnapshot(query, docs, oldDocs, docChanges, mutatedKeys, fromCache, syncStateChanged, excludesMetadataChanges) {
        this.query = query;
        this.docs = docs;
        this.oldDocs = oldDocs;
        this.docChanges = docChanges;
        this.mutatedKeys = mutatedKeys;
        this.fromCache = fromCache;
        this.syncStateChanged = syncStateChanged;
        this.excludesMetadataChanges = excludesMetadataChanges;
    }
    /** Returns a view snapshot as if all documents in the snapshot were added. */
    ViewSnapshot.fromInitialDocuments = function (query, documents, mutatedKeys, fromCache) {
        var changes = [];
        documents.forEach(function (doc) {
            changes.push({ type: ChangeType.Added, doc: doc });
        });
        return new ViewSnapshot(query, documents, DocumentSet.emptySet(documents), changes, mutatedKeys, fromCache, 
        /* syncStateChanged= */ true, 
        /* excludesMetadataChanges= */ false);
    };
    Object.defineProperty(ViewSnapshot.prototype, "hasPendingWrites", {
        get: function () {
            return !this.mutatedKeys.isEmpty();
        },
        enumerable: true,
        configurable: true
    });
    ViewSnapshot.prototype.isEqual = function (other) {
        if (this.fromCache !== other.fromCache ||
            this.syncStateChanged !== other.syncStateChanged ||
            !this.mutatedKeys.isEqual(other.mutatedKeys) ||
            !this.query.isEqual(other.query) ||
            !this.docs.isEqual(other.docs) ||
            !this.oldDocs.isEqual(other.oldDocs)) {
            return false;
        }
        var changes = this.docChanges;
        var otherChanges = other.docChanges;
        if (changes.length !== otherChanges.length) {
            return false;
        }
        for (var i = 0; i < changes.length; i++) {
            if (changes[i].type !== otherChanges[i].type ||
                !changes[i].doc.isEqual(otherChanges[i].doc)) {
                return false;
            }
        }
        return true;
    };
    return ViewSnapshot;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An event from the RemoteStore. It is split into targetChanges (changes to the
 * state or the set of documents in our watched targets) and documentUpdates
 * (changes to the actual documents).
 */
var RemoteEvent = /** @class */ (function () {
    function RemoteEvent(
    /**
     * The snapshot version this event brings us up to, or MIN if not set.
     */
    snapshotVersion, 
    /**
     * A map from target to changes to the target. See TargetChange.
     */
    targetChanges, 
    /**
     * A set of targets that is known to be inconsistent. Listens for these
     * targets should be re-established without resume tokens.
     */
    targetMismatches, 
    /**
     * A set of which documents have changed or been deleted, along with the
     * doc's new values (if not deleted).
     */
    documentUpdates, 
    /**
     * A set of which document updates are due only to limbo resolution targets.
     */
    resolvedLimboDocuments) {
        this.snapshotVersion = snapshotVersion;
        this.targetChanges = targetChanges;
        this.targetMismatches = targetMismatches;
        this.documentUpdates = documentUpdates;
        this.resolvedLimboDocuments = resolvedLimboDocuments;
    }
    /**
     * HACK: Views require RemoteEvents in order to determine whether the view is
     * CURRENT, but secondary tabs don't receive remote events. So this method is
     * used to create a synthesized RemoteEvent that can be used to apply a
     * CURRENT status change to a View, for queries executed in a different tab.
     */
    // PORTING NOTE: Multi-tab only
    RemoteEvent.createSynthesizedRemoteEventForCurrentChange = function (targetId, current) {
        var _a;
        var targetChanges = (_a = {},
            _a[targetId] = TargetChange.createSynthesizedTargetChangeForCurrentChange(targetId, current),
            _a);
        return new RemoteEvent(SnapshotVersion.MIN, targetChanges, targetIdSet(), maybeDocumentMap(), documentKeySet());
    };
    return RemoteEvent;
}());
/**
 * A TargetChange specifies the set of changes for a specific target as part of
 * a RemoteEvent. These changes track which documents are added, modified or
 * removed, as well as the target's resume token and whether the target is
 * marked CURRENT.
 * The actual changes *to* documents are not part of the TargetChange since
 * documents may be part of multiple targets.
 */
var TargetChange = /** @class */ (function () {
    function TargetChange(
    /**
     * An opaque, server-assigned token that allows watching a query to be resumed
     * after disconnecting without retransmitting all the data that matches the
     * query. The resume token essentially identifies a point in time from which
     * the server should resume sending results.
     */
    resumeToken, 
    /**
     * The "current" (synced) status of this target. Note that "current"
     * has special meaning in the RPC protocol that implies that a target is
     * both up-to-date and consistent with the rest of the watch stream.
     */
    current, 
    /**
     * The set of documents that were newly assigned to this target as part of
     * this remote event.
     */
    addedDocuments, 
    /**
     * The set of documents that were already assigned to this target but received
     * an update during this remote event.
     */
    modifiedDocuments, 
    /**
     * The set of documents that were removed from this target as part of this
     * remote event.
     */
    removedDocuments) {
        this.resumeToken = resumeToken;
        this.current = current;
        this.addedDocuments = addedDocuments;
        this.modifiedDocuments = modifiedDocuments;
        this.removedDocuments = removedDocuments;
    }
    /**
     * HACK: Views require TargetChanges in order to determine whether the view is
     * CURRENT, but secondary tabs don't receive remote events. So this method is
     * used to create a synthesized TargetChanges that can be used to apply a
     * CURRENT status change to a View, for queries executed in a different tab.
     */
    // PORTING NOTE: Multi-tab only
    TargetChange.createSynthesizedTargetChangeForCurrentChange = function (targetId, current) {
        return new TargetChange(emptyByteString(), current, documentKeySet(), documentKeySet(), documentKeySet());
    };
    return TargetChange;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Represents a changed document and a list of target ids to which this change
 * applies.
 *
 * If document has been deleted NoDocument will be provided.
 */
var DocumentWatchChange = /** @class */ (function () {
    function DocumentWatchChange(
    /** The new document applies to all of these targets. */
    updatedTargetIds, 
    /** The new document is removed from all of these targets. */
    removedTargetIds, 
    /** The key of the document for this change. */
    key, 
    /**
     * The new document or NoDocument if it was deleted. Is null if the
     * document went out of view without the server sending a new document.
     */
    newDoc) {
        this.updatedTargetIds = updatedTargetIds;
        this.removedTargetIds = removedTargetIds;
        this.key = key;
        this.newDoc = newDoc;
    }
    return DocumentWatchChange;
}());
var ExistenceFilterChange = /** @class */ (function () {
    function ExistenceFilterChange(targetId, existenceFilter) {
        this.targetId = targetId;
        this.existenceFilter = existenceFilter;
    }
    return ExistenceFilterChange;
}());
var WatchTargetChangeState;
(function (WatchTargetChangeState) {
    WatchTargetChangeState[WatchTargetChangeState["NoChange"] = 0] = "NoChange";
    WatchTargetChangeState[WatchTargetChangeState["Added"] = 1] = "Added";
    WatchTargetChangeState[WatchTargetChangeState["Removed"] = 2] = "Removed";
    WatchTargetChangeState[WatchTargetChangeState["Current"] = 3] = "Current";
    WatchTargetChangeState[WatchTargetChangeState["Reset"] = 4] = "Reset";
})(WatchTargetChangeState || (WatchTargetChangeState = {}));
var WatchTargetChange = /** @class */ (function () {
    function WatchTargetChange(
    /** What kind of change occurred to the watch target. */
    state, 
    /** The target IDs that were added/removed/set. */
    targetIds, 
    /**
     * An opaque, server-assigned token that allows watching a target to be
     * resumed after disconnecting without retransmitting all the data that
     * matches the target. The resume token essentially identifies a point in
     * time from which the server should resume sending results.
     */
    resumeToken, 
    /** An RPC error indicating why the watch failed. */
    cause) {
        if (resumeToken === void 0) { resumeToken = emptyByteString(); }
        if (cause === void 0) { cause = null; }
        this.state = state;
        this.targetIds = targetIds;
        this.resumeToken = resumeToken;
        this.cause = cause;
    }
    return WatchTargetChange;
}());
/** Tracks the internal state of a Watch target. */
var TargetState = /** @class */ (function () {
    function TargetState() {
        /**
         * The number of pending responses (adds or removes) that we are waiting on.
         * We only consider targets active that have no pending responses.
         */
        this.pendingResponses = 0;
        /**
         * Keeps track of the document changes since the last raised snapshot.
         *
         * These changes are continuously updated as we receive document updates and
         * always reflect the current set of changes against the last issued snapshot.
         */
        this.documentChanges = snapshotChangesMap();
        /** See public getters for explanations of these fields. */
        this._resumeToken = emptyByteString();
        this._current = false;
        /**
         * Whether this target state should be included in the next snapshot. We
         * initialize to true so that newly-added targets are included in the next
         * RemoteEvent.
         */
        this._hasPendingChanges = true;
    }
    Object.defineProperty(TargetState.prototype, "current", {
        /**
         * Whether this target has been marked 'current'.
         *
         * 'Current' has special meaning in the RPC protocol: It implies that the
         * Watch backend has sent us all changes up to the point at which the target
         * was added and that the target is consistent with the rest of the watch
         * stream.
         */
        get: function () {
            return this._current;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TargetState.prototype, "resumeToken", {
        /** The last resume token sent to us for this target. */
        get: function () {
            return this._resumeToken;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TargetState.prototype, "isPending", {
        /** Whether this target has pending target adds or target removes. */
        get: function () {
            return this.pendingResponses !== 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TargetState.prototype, "hasPendingChanges", {
        /** Whether we have modified any state that should trigger a snapshot. */
        get: function () {
            return this._hasPendingChanges;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Applies the resume token to the TargetChange, but only when it has a new
     * value. Empty resumeTokens are discarded.
     */
    TargetState.prototype.updateResumeToken = function (resumeToken) {
        if (resumeToken.length > 0) {
            this._hasPendingChanges = true;
            this._resumeToken = resumeToken;
        }
    };
    /**
     * Creates a target change from the current set of changes.
     *
     * To reset the document changes after raising this snapshot, call
     * `clearPendingChanges()`.
     */
    TargetState.prototype.toTargetChange = function () {
        var addedDocuments = documentKeySet();
        var modifiedDocuments = documentKeySet();
        var removedDocuments = documentKeySet();
        this.documentChanges.forEach(function (key, changeType) {
            switch (changeType) {
                case ChangeType.Added:
                    addedDocuments = addedDocuments.add(key);
                    break;
                case ChangeType.Modified:
                    modifiedDocuments = modifiedDocuments.add(key);
                    break;
                case ChangeType.Removed:
                    removedDocuments = removedDocuments.add(key);
                    break;
                default:
                    fail('Encountered invalid change type: ' + changeType);
            }
        });
        return new TargetChange(this._resumeToken, this._current, addedDocuments, modifiedDocuments, removedDocuments);
    };
    /**
     * Resets the document changes and sets `hasPendingChanges` to false.
     */
    TargetState.prototype.clearPendingChanges = function () {
        this._hasPendingChanges = false;
        this.documentChanges = snapshotChangesMap();
    };
    TargetState.prototype.addDocumentChange = function (key, changeType) {
        this._hasPendingChanges = true;
        this.documentChanges = this.documentChanges.insert(key, changeType);
    };
    TargetState.prototype.removeDocumentChange = function (key) {
        this._hasPendingChanges = true;
        this.documentChanges = this.documentChanges.remove(key);
    };
    TargetState.prototype.recordPendingTargetRequest = function () {
        this.pendingResponses += 1;
    };
    TargetState.prototype.recordTargetResponse = function () {
        this.pendingResponses -= 1;
    };
    TargetState.prototype.markCurrent = function () {
        this._hasPendingChanges = true;
        this._current = true;
    };
    return TargetState;
}());
var LOG_TAG$7 = 'WatchChangeAggregator';
/**
 * A helper class to accumulate watch changes into a RemoteEvent.
 */
var WatchChangeAggregator = /** @class */ (function () {
    function WatchChangeAggregator(metadataProvider) {
        this.metadataProvider = metadataProvider;
        /** The internal state of all tracked targets. */
        this.targetStates = {};
        /** Keeps track of the documents to update since the last raised snapshot. */
        this.pendingDocumentUpdates = maybeDocumentMap();
        /** A mapping of document keys to their set of target IDs. */
        this.pendingDocumentTargetMapping = documentTargetMap();
        /**
         * A list of targets with existence filter mismatches. These targets are
         * known to be inconsistent and their listens needs to be re-established by
         * RemoteStore.
         */
        this.pendingTargetResets = new SortedSet(primitiveComparator);
    }
    /**
     * Processes and adds the DocumentWatchChange to the current set of changes.
     */
    WatchChangeAggregator.prototype.handleDocumentChange = function (docChange) {
        for (var _i = 0, _a = docChange.updatedTargetIds; _i < _a.length; _i++) {
            var targetId = _a[_i];
            if (docChange.newDoc instanceof Document) {
                this.addDocumentToTarget(targetId, docChange.newDoc);
            }
            else if (docChange.newDoc instanceof NoDocument) {
                this.removeDocumentFromTarget(targetId, docChange.key, docChange.newDoc);
            }
        }
        for (var _b = 0, _c = docChange.removedTargetIds; _b < _c.length; _b++) {
            var targetId = _c[_b];
            this.removeDocumentFromTarget(targetId, docChange.key, docChange.newDoc);
        }
    };
    /** Processes and adds the WatchTargetChange to the current set of changes. */
    WatchChangeAggregator.prototype.handleTargetChange = function (targetChange) {
        var _this = this;
        this.forEachTarget(targetChange, function (targetId) {
            var targetState = _this.ensureTargetState(targetId);
            switch (targetChange.state) {
                case WatchTargetChangeState.NoChange:
                    if (_this.isActiveTarget(targetId)) {
                        targetState.updateResumeToken(targetChange.resumeToken);
                    }
                    break;
                case WatchTargetChangeState.Added:
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    targetState.recordTargetResponse();
                    if (!targetState.isPending) {
                        // We have a freshly added target, so we need to reset any state
                        // that we had previously. This can happen e.g. when remove and add
                        // back a target for existence filter mismatches.
                        targetState.clearPendingChanges();
                    }
                    targetState.updateResumeToken(targetChange.resumeToken);
                    break;
                case WatchTargetChangeState.Removed:
                    // We need to keep track of removed targets to we can post-filter and
                    // remove any target changes.
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    targetState.recordTargetResponse();
                    if (!targetState.isPending) {
                        _this.removeTarget(targetId);
                    }
                    assert(!targetChange.cause, 'WatchChangeAggregator does not handle errored targets');
                    break;
                case WatchTargetChangeState.Current:
                    if (_this.isActiveTarget(targetId)) {
                        targetState.markCurrent();
                        targetState.updateResumeToken(targetChange.resumeToken);
                    }
                    break;
                case WatchTargetChangeState.Reset:
                    if (_this.isActiveTarget(targetId)) {
                        // Reset the target and synthesizes removes for all existing
                        // documents. The backend will re-add any documents that still
                        // match the target before it sends the next global snapshot.
                        _this.resetTarget(targetId);
                        targetState.updateResumeToken(targetChange.resumeToken);
                    }
                    break;
                default:
                    fail('Unknown target watch change state: ' + targetChange.state);
            }
        });
    };
    /**
     * Iterates over all targetIds that the watch change applies to: either the
     * targetIds explicitly listed in the change or the targetIds of all currently
     * active targets.
     */
    WatchChangeAggregator.prototype.forEachTarget = function (targetChange, fn) {
        if (targetChange.targetIds.length > 0) {
            targetChange.targetIds.forEach(fn);
        }
        else {
            forEachNumber(this.targetStates, fn);
        }
    };
    /**
     * Handles existence filters and synthesizes deletes for filter mismatches.
     * Targets that are invalidated by filter mismatches are added to
     * `pendingTargetResets`.
     */
    WatchChangeAggregator.prototype.handleExistenceFilter = function (watchChange) {
        var targetId = watchChange.targetId;
        var expectedCount = watchChange.existenceFilter.count;
        var targetData = this.targetDataForActiveTarget(targetId);
        if (targetData) {
            var target = targetData.target;
            if (target.isDocumentQuery()) {
                if (expectedCount === 0) {
                    // The existence filter told us the document does not exist. We deduce
                    // that this document does not exist and apply a deleted document to
                    // our updates. Without applying this deleted document there might be
                    // another query that will raise this document as part of a snapshot
                    // until it is resolved, essentially exposing inconsistency between
                    // queries.
                    var key = new DocumentKey(target.path);
                    this.removeDocumentFromTarget(targetId, key, new NoDocument(key, SnapshotVersion.forDeletedDoc()));
                }
                else {
                    assert(expectedCount === 1, 'Single document existence filter with count: ' + expectedCount);
                }
            }
            else {
                var currentSize = this.getCurrentDocumentCountForTarget(targetId);
                if (currentSize !== expectedCount) {
                    // Existence filter mismatch: We reset the mapping and raise a new
                    // snapshot with `isFromCache:true`.
                    this.resetTarget(targetId);
                    this.pendingTargetResets = this.pendingTargetResets.add(targetId);
                }
            }
        }
    };
    /**
     * Converts the currently accumulated state into a remote event at the
     * provided snapshot version. Resets the accumulated changes before returning.
     */
    WatchChangeAggregator.prototype.createRemoteEvent = function (snapshotVersion) {
        var _this = this;
        var targetChanges = {};
        forEachNumber(this.targetStates, function (targetId, targetState) {
            var targetData = _this.targetDataForActiveTarget(targetId);
            if (targetData) {
                if (targetState.current && targetData.target.isDocumentQuery()) {
                    // Document queries for document that don't exist can produce an empty
                    // result set. To update our local cache, we synthesize a document
                    // delete if we have not previously received the document. This
                    // resolves the limbo state of the document, removing it from
                    // limboDocumentRefs.
                    //
                    // TODO(dimond): Ideally we would have an explicit lookup target
                    // instead resulting in an explicit delete message and we could
                    // remove this special logic.
                    var key = new DocumentKey(targetData.target.path);
                    if (_this.pendingDocumentUpdates.get(key) === null &&
                        !_this.targetContainsDocument(targetId, key)) {
                        _this.removeDocumentFromTarget(targetId, key, new NoDocument(key, snapshotVersion));
                    }
                }
                if (targetState.hasPendingChanges) {
                    targetChanges[targetId] = targetState.toTargetChange();
                    targetState.clearPendingChanges();
                }
            }
        });
        var resolvedLimboDocuments = documentKeySet();
        // We extract the set of limbo-only document updates as the GC logic
        // special-cases documents that do not appear in the target cache.
        //
        // TODO(gsoltis): Expand on this comment once GC is available in the JS
        // client.
        this.pendingDocumentTargetMapping.forEach(function (key, targets) {
            var isOnlyLimboTarget = true;
            targets.forEachWhile(function (targetId) {
                var targetData = _this.targetDataForActiveTarget(targetId);
                if (targetData &&
                    targetData.purpose !== TargetPurpose.LimboResolution) {
                    isOnlyLimboTarget = false;
                    return false;
                }
                return true;
            });
            if (isOnlyLimboTarget) {
                resolvedLimboDocuments = resolvedLimboDocuments.add(key);
            }
        });
        var remoteEvent = new RemoteEvent(snapshotVersion, targetChanges, this.pendingTargetResets, this.pendingDocumentUpdates, resolvedLimboDocuments);
        this.pendingDocumentUpdates = maybeDocumentMap();
        this.pendingDocumentTargetMapping = documentTargetMap();
        this.pendingTargetResets = new SortedSet(primitiveComparator);
        return remoteEvent;
    };
    /**
     * Adds the provided document to the internal list of document updates and
     * its document key to the given target's mapping.
     */
    // Visible for testing.
    WatchChangeAggregator.prototype.addDocumentToTarget = function (targetId, document) {
        if (!this.isActiveTarget(targetId)) {
            return;
        }
        var changeType = this.targetContainsDocument(targetId, document.key)
            ? ChangeType.Modified
            : ChangeType.Added;
        var targetState = this.ensureTargetState(targetId);
        targetState.addDocumentChange(document.key, changeType);
        this.pendingDocumentUpdates = this.pendingDocumentUpdates.insert(document.key, document);
        this.pendingDocumentTargetMapping = this.pendingDocumentTargetMapping.insert(document.key, this.ensureDocumentTargetMapping(document.key).add(targetId));
    };
    /**
     * Removes the provided document from the target mapping. If the
     * document no longer matches the target, but the document's state is still
     * known (e.g. we know that the document was deleted or we received the change
     * that caused the filter mismatch), the new document can be provided
     * to update the remote document cache.
     */
    // Visible for testing.
    WatchChangeAggregator.prototype.removeDocumentFromTarget = function (targetId, key, updatedDocument) {
        if (!this.isActiveTarget(targetId)) {
            return;
        }
        var targetState = this.ensureTargetState(targetId);
        if (this.targetContainsDocument(targetId, key)) {
            targetState.addDocumentChange(key, ChangeType.Removed);
        }
        else {
            // The document may have entered and left the target before we raised a
            // snapshot, so we can just ignore the change.
            targetState.removeDocumentChange(key);
        }
        this.pendingDocumentTargetMapping = this.pendingDocumentTargetMapping.insert(key, this.ensureDocumentTargetMapping(key).delete(targetId));
        if (updatedDocument) {
            this.pendingDocumentUpdates = this.pendingDocumentUpdates.insert(key, updatedDocument);
        }
    };
    WatchChangeAggregator.prototype.removeTarget = function (targetId) {
        delete this.targetStates[targetId];
    };
    /**
     * Returns the current count of documents in the target. This includes both
     * the number of documents that the LocalStore considers to be part of the
     * target as well as any accumulated changes.
     */
    WatchChangeAggregator.prototype.getCurrentDocumentCountForTarget = function (targetId) {
        var targetState = this.ensureTargetState(targetId);
        var targetChange = targetState.toTargetChange();
        return (this.metadataProvider.getRemoteKeysForTarget(targetId).size +
            targetChange.addedDocuments.size -
            targetChange.removedDocuments.size);
    };
    /**
     * Increment the number of acks needed from watch before we can consider the
     * server to be 'in-sync' with the client's active targets.
     */
    WatchChangeAggregator.prototype.recordPendingTargetRequest = function (targetId) {
        // For each request we get we need to record we need a response for it.
        var targetState = this.ensureTargetState(targetId);
        targetState.recordPendingTargetRequest();
    };
    WatchChangeAggregator.prototype.ensureTargetState = function (targetId) {
        if (!this.targetStates[targetId]) {
            this.targetStates[targetId] = new TargetState();
        }
        return this.targetStates[targetId];
    };
    WatchChangeAggregator.prototype.ensureDocumentTargetMapping = function (key) {
        var targetMapping = this.pendingDocumentTargetMapping.get(key);
        if (!targetMapping) {
            targetMapping = new SortedSet(primitiveComparator);
            this.pendingDocumentTargetMapping = this.pendingDocumentTargetMapping.insert(key, targetMapping);
        }
        return targetMapping;
    };
    /**
     * Verifies that the user is still interested in this target (by calling
     * `getTargetDataForTarget()`) and that we are not waiting for pending ADDs
     * from watch.
     */
    WatchChangeAggregator.prototype.isActiveTarget = function (targetId) {
        var targetActive = this.targetDataForActiveTarget(targetId) !== null;
        if (!targetActive) {
            debug(LOG_TAG$7, 'Detected inactive target', targetId);
        }
        return targetActive;
    };
    /**
     * Returns the TargetData for an active target (i.e. a target that the user
     * is still interested in that has no outstanding target change requests).
     */
    WatchChangeAggregator.prototype.targetDataForActiveTarget = function (targetId) {
        var targetState = this.targetStates[targetId];
        return targetState && targetState.isPending
            ? null
            : this.metadataProvider.getTargetDataForTarget(targetId);
    };
    /**
     * Resets the state of a Watch target to its initial state (e.g. sets
     * 'current' to false, clears the resume token and removes its target mapping
     * from all documents).
     */
    WatchChangeAggregator.prototype.resetTarget = function (targetId) {
        var _this = this;
        assert(!this.targetStates[targetId].isPending, 'Should only reset active targets');
        this.targetStates[targetId] = new TargetState();
        // Trigger removal for any documents currently mapped to this target.
        // These removals will be part of the initial snapshot if Watch does not
        // resend these documents.
        var existingKeys = this.metadataProvider.getRemoteKeysForTarget(targetId);
        existingKeys.forEach(function (key) {
            _this.removeDocumentFromTarget(targetId, key, /*updatedDocument=*/ null);
        });
    };
    /**
     * Returns whether the LocalStore considers the document to be part of the
     * specified target.
     */
    WatchChangeAggregator.prototype.targetContainsDocument = function (targetId, key) {
        var existingKeys = this.metadataProvider.getRemoteKeysForTarget(targetId);
        return existingKeys.has(key);
    };
    return WatchChangeAggregator;
}());
function documentTargetMap() {
    return new SortedMap(DocumentKey.comparator);
}
function snapshotChangesMap() {
    return new SortedMap(DocumentKey.comparator);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$8 = 'RemoteStore';
// TODO(b/35853402): Negotiate this with the stream.
var MAX_PENDING_WRITES = 10;
/**
 * RemoteStore - An interface to remotely stored data, basically providing a
 * wrapper around the Datastore that is more reliable for the rest of the
 * system.
 *
 * RemoteStore is responsible for maintaining the connection to the server.
 * - maintaining a list of active listens.
 * - reconnecting when the connection is dropped.
 * - resuming all the active listens on reconnect.
 *
 * RemoteStore handles all incoming events from the Datastore.
 * - listening to the watch stream and repackaging the events as RemoteEvents
 * - notifying SyncEngine of any changes to the active listens.
 *
 * RemoteStore takes writes from other components and handles them reliably.
 * - pulling pending mutations from LocalStore and sending them to Datastore.
 * - retrying mutations that failed because of network problems.
 * - acking mutations to the SyncEngine once they are accepted or rejected.
 */
var RemoteStore = /** @class */ (function () {
    function RemoteStore(
    /**
     * The local store, used to fill the write pipeline with outbound mutations.
     */
    localStore, 
    /** The client-side proxy for interacting with the backend. */
    datastore, asyncQueue, onlineStateHandler, connectivityMonitor) {
        var _this = this;
        this.localStore = localStore;
        this.datastore = datastore;
        /**
         * A list of up to MAX_PENDING_WRITES writes that we have fetched from the
         * LocalStore via fillWritePipeline() and have or will send to the write
         * stream.
         *
         * Whenever writePipeline.length > 0 the RemoteStore will attempt to start or
         * restart the write stream. When the stream is established the writes in the
         * pipeline will be sent in order.
         *
         * Writes remain in writePipeline until they are acknowledged by the backend
         * and thus will automatically be re-sent if the stream is interrupted /
         * restarted before they're acknowledged.
         *
         * Write responses from the backend are linked to their originating request
         * purely based on order, and so we can just shift() writes from the front of
         * the writePipeline as we receive responses.
         */
        this.writePipeline = [];
        /**
         * A mapping of watched targets that the client cares about tracking and the
         * user has explicitly called a 'listen' for this target.
         *
         * These targets may or may not have been sent to or acknowledged by the
         * server. On re-establishing the listen stream, these targets should be sent
         * to the server. The targets removed with unlistens are removed eagerly
         * without waiting for confirmation from the listen stream.
         */
        this.listenTargets = {};
        this.watchChangeAggregator = null;
        /**
         * Set to true by enableNetwork() and false by disableNetwork() and indicates
         * the user-preferred network state.
         */
        this.networkEnabled = false;
        this.isPrimary = false;
        this.connectivityMonitor = connectivityMonitor;
        this.connectivityMonitor.addCallback(function (status) {
            asyncQueue.enqueueAndForget(function () { return tslib.__awaiter(_this, void 0, void 0, function () {
                return tslib.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this.canUseNetwork()) return [3 /*break*/, 2];
                            debug(LOG_TAG$8, 'Restarting streams for network reachability change.');
                            return [4 /*yield*/, this.restartNetwork()];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            }); });
        });
        this.onlineStateTracker = new OnlineStateTracker(asyncQueue, onlineStateHandler);
        // Create streams (but note they're not started yet).
        this.watchStream = this.datastore.newPersistentWatchStream({
            onOpen: this.onWatchStreamOpen.bind(this),
            onClose: this.onWatchStreamClose.bind(this),
            onWatchChange: this.onWatchStreamChange.bind(this)
        });
        this.writeStream = this.datastore.newPersistentWriteStream({
            onOpen: this.onWriteStreamOpen.bind(this),
            onClose: this.onWriteStreamClose.bind(this),
            onHandshakeComplete: this.onWriteHandshakeComplete.bind(this),
            onMutationResult: this.onMutationResult.bind(this)
        });
    }
    /**
     * Starts up the remote store, creating streams, restoring state from
     * LocalStore, etc.
     */
    RemoteStore.prototype.start = function () {
        return this.enableNetwork();
    };
    /** Re-enables the network. Idempotent. */
    RemoteStore.prototype.enableNetwork = function () {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.networkEnabled = true;
                        if (!this.canUseNetwork()) return [3 /*break*/, 3];
                        _a = this.writeStream;
                        return [4 /*yield*/, this.localStore.getLastStreamToken()];
                    case 1:
                        _a.lastStreamToken = _b.sent();
                        if (this.shouldStartWatchStream()) {
                            this.startWatchStream();
                        }
                        else {
                            this.onlineStateTracker.set(OnlineState.Unknown);
                        }
                        // This will start the write stream if necessary.
                        return [4 /*yield*/, this.fillWritePipeline()];
                    case 2:
                        // This will start the write stream if necessary.
                        _b.sent();
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Temporarily disables the network. The network can be re-enabled using
     * enableNetwork().
     */
    RemoteStore.prototype.disableNetwork = function () {
        return tslib.__awaiter(this, void 0, void 0, function () {
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.networkEnabled = false;
                        return [4 /*yield*/, this.disableNetworkInternal()];
                    case 1:
                        _a.sent();
                        // Set the OnlineState to Offline so get()s return from cache, etc.
                        this.onlineStateTracker.set(OnlineState.Offline);
                        return [2 /*return*/];
                }
            });
        });
    };
    RemoteStore.prototype.disableNetworkInternal = function () {
        return tslib.__awaiter(this, void 0, void 0, function () {
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.writeStream.stop()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.watchStream.stop()];
                    case 2:
                        _a.sent();
                        if (this.writePipeline.length > 0) {
                            debug(LOG_TAG$8, "Stopping write stream with " + this.writePipeline.length + " pending writes");
                            this.writePipeline = [];
                        }
                        this.cleanUpWatchStreamState();
                        return [2 /*return*/];
                }
            });
        });
    };
    RemoteStore.prototype.shutdown = function () {
        return tslib.__awaiter(this, void 0, void 0, function () {
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        debug(LOG_TAG$8, 'RemoteStore shutting down.');
                        this.networkEnabled = false;
                        return [4 /*yield*/, this.disableNetworkInternal()];
                    case 1:
                        _a.sent();
                        this.connectivityMonitor.shutdown();
                        // Set the OnlineState to Unknown (rather than Offline) to avoid potentially
                        // triggering spurious listener events with cached data, etc.
                        this.onlineStateTracker.set(OnlineState.Unknown);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Starts new listen for the given target. Uses resume token if provided. It
     * is a no-op if the target of given `TargetData` is already being listened to.
     */
    RemoteStore.prototype.listen = function (targetData) {
        if (contains(this.listenTargets, targetData.targetId)) {
            return;
        }
        // Mark this as something the client is currently listening for.
        this.listenTargets[targetData.targetId] = targetData;
        if (this.shouldStartWatchStream()) {
            // The listen will be sent in onWatchStreamOpen
            this.startWatchStream();
        }
        else if (this.watchStream.isOpen()) {
            this.sendWatchRequest(targetData);
        }
    };
    /**
     * Removes the listen from server. It is a no-op if the given target id is
     * not being listened to.
     */
    RemoteStore.prototype.unlisten = function (targetId) {
        if (!contains(this.listenTargets, targetId)) {
            return;
        }
        delete this.listenTargets[targetId];
        if (this.watchStream.isOpen()) {
            this.sendUnwatchRequest(targetId);
        }
        if (isEmpty(this.listenTargets)) {
            if (this.watchStream.isOpen()) {
                this.watchStream.markIdle();
            }
            else if (this.canUseNetwork()) {
                // Revert to OnlineState.Unknown if the watch stream is not open and we
                // have no listeners, since without any listens to send we cannot
                // confirm if the stream is healthy and upgrade to OnlineState.Online.
                this.onlineStateTracker.set(OnlineState.Unknown);
            }
        }
    };
    /** {@link TargetMetadataProvider.getTargetDataForTarget} */
    RemoteStore.prototype.getTargetDataForTarget = function (targetId) {
        return this.listenTargets[targetId] || null;
    };
    /** {@link TargetMetadataProvider.getRemoteKeysForTarget} */
    RemoteStore.prototype.getRemoteKeysForTarget = function (targetId) {
        return this.syncEngine.getRemoteKeysForTarget(targetId);
    };
    /**
     * We need to increment the the expected number of pending responses we're due
     * from watch so we wait for the ack to process any messages from this target.
     */
    RemoteStore.prototype.sendWatchRequest = function (targetData) {
        this.watchChangeAggregator.recordPendingTargetRequest(targetData.targetId);
        this.watchStream.watch(targetData);
    };
    /**
     * We need to increment the expected number of pending responses we're due
     * from watch so we wait for the removal on the server before we process any
     * messages from this target.
     */
    RemoteStore.prototype.sendUnwatchRequest = function (targetId) {
        this.watchChangeAggregator.recordPendingTargetRequest(targetId);
        this.watchStream.unwatch(targetId);
    };
    RemoteStore.prototype.startWatchStream = function () {
        assert(this.shouldStartWatchStream(), 'startWatchStream() called when shouldStartWatchStream() is false.');
        this.watchChangeAggregator = new WatchChangeAggregator(this);
        this.watchStream.start();
        this.onlineStateTracker.handleWatchStreamStart();
    };
    /**
     * Returns whether the watch stream should be started because it's necessary
     * and has not yet been started.
     */
    RemoteStore.prototype.shouldStartWatchStream = function () {
        return (this.canUseNetwork() &&
            !this.watchStream.isStarted() &&
            !isEmpty(this.listenTargets));
    };
    RemoteStore.prototype.canUseNetwork = function () {
        return this.isPrimary && this.networkEnabled;
    };
    RemoteStore.prototype.cleanUpWatchStreamState = function () {
        this.watchChangeAggregator = null;
    };
    RemoteStore.prototype.onWatchStreamOpen = function () {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib.__generator(this, function (_a) {
                forEachNumber(this.listenTargets, function (targetId, targetData) {
                    _this.sendWatchRequest(targetData);
                });
                return [2 /*return*/];
            });
        });
    };
    RemoteStore.prototype.onWatchStreamClose = function (error) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            return tslib.__generator(this, function (_a) {
                if (error === undefined) {
                    // Graceful stop (due to stop() or idle timeout). Make sure that's
                    // desirable.
                    assert(!this.shouldStartWatchStream(), 'Watch stream was stopped gracefully while still needed.');
                }
                this.cleanUpWatchStreamState();
                // If we still need the watch stream, retry the connection.
                if (this.shouldStartWatchStream()) {
                    this.onlineStateTracker.handleWatchStreamFailure(error);
                    this.startWatchStream();
                }
                else {
                    // No need to restart watch stream because there are no active targets.
                    // The online state is set to unknown because there is no active attempt
                    // at establishing a connection
                    this.onlineStateTracker.set(OnlineState.Unknown);
                }
                return [2 /*return*/];
            });
        });
    };
    RemoteStore.prototype.onWatchStreamChange = function (watchChange, snapshotVersion) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var lastRemoteSnapshotVersion;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Mark the client as online since we got a message from the server
                        this.onlineStateTracker.set(OnlineState.Online);
                        if (watchChange instanceof WatchTargetChange &&
                            watchChange.state === WatchTargetChangeState.Removed &&
                            watchChange.cause) {
                            // There was an error on a target, don't wait for a consistent snapshot
                            // to raise events
                            return [2 /*return*/, this.handleTargetError(watchChange)];
                        }
                        if (watchChange instanceof DocumentWatchChange) {
                            this.watchChangeAggregator.handleDocumentChange(watchChange);
                        }
                        else if (watchChange instanceof ExistenceFilterChange) {
                            this.watchChangeAggregator.handleExistenceFilter(watchChange);
                        }
                        else {
                            assert(watchChange instanceof WatchTargetChange, 'Expected watchChange to be an instance of WatchTargetChange');
                            this.watchChangeAggregator.handleTargetChange(watchChange);
                        }
                        if (!!snapshotVersion.isEqual(SnapshotVersion.MIN)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.localStore.getLastRemoteSnapshotVersion()];
                    case 1:
                        lastRemoteSnapshotVersion = _a.sent();
                        if (!(snapshotVersion.compareTo(lastRemoteSnapshotVersion) >= 0)) return [3 /*break*/, 3];
                        // We have received a target change with a global snapshot if the snapshot
                        // version is not equal to SnapshotVersion.MIN.
                        return [4 /*yield*/, this.raiseWatchSnapshot(snapshotVersion)];
                    case 2:
                        // We have received a target change with a global snapshot if the snapshot
                        // version is not equal to SnapshotVersion.MIN.
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Takes a batch of changes from the Datastore, repackages them as a
     * RemoteEvent, and passes that on to the listener, which is typically the
     * SyncEngine.
     */
    RemoteStore.prototype.raiseWatchSnapshot = function (snapshotVersion) {
        var _this = this;
        assert(!snapshotVersion.isEqual(SnapshotVersion.MIN), "Can't raise event for unknown SnapshotVersion");
        var remoteEvent = this.watchChangeAggregator.createRemoteEvent(snapshotVersion);
        // Update in-memory resume tokens. LocalStore will update the
        // persistent view of these when applying the completed RemoteEvent.
        forEachNumber(remoteEvent.targetChanges, function (targetId, change) {
            if (change.resumeToken.length > 0) {
                var targetData = _this.listenTargets[targetId];
                // A watched target might have been removed already.
                if (targetData) {
                    _this.listenTargets[targetId] = targetData.withResumeToken(change.resumeToken, snapshotVersion);
                }
            }
        });
        // Re-establish listens for the targets that have been invalidated by
        // existence filter mismatches.
        remoteEvent.targetMismatches.forEach(function (targetId) {
            var targetData = _this.listenTargets[targetId];
            if (!targetData) {
                // A watched target might have been removed already.
                return;
            }
            // Clear the resume token for the target, since we're in a known mismatch
            // state.
            _this.listenTargets[targetId] = targetData.withResumeToken(emptyByteString(), targetData.snapshotVersion);
            // Cause a hard reset by unwatching and rewatching immediately, but
            // deliberately don't send a resume token so that we get a full update.
            _this.sendUnwatchRequest(targetId);
            // Mark the target we send as being on behalf of an existence filter
            // mismatch, but don't actually retain that in listenTargets. This ensures
            // that we flag the first re-listen this way without impacting future
            // listens of this target (that might happen e.g. on reconnect).
            var requestTargetData = new TargetData(targetData.target, targetId, TargetPurpose.ExistenceFilterMismatch, targetData.sequenceNumber);
            _this.sendWatchRequest(requestTargetData);
        });
        // Finally raise remote event
        return this.syncEngine.applyRemoteEvent(remoteEvent);
    };
    /** Handles an error on a target */
    RemoteStore.prototype.handleTargetError = function (watchChange) {
        var _this = this;
        assert(!!watchChange.cause, 'Handling target error without a cause');
        var error = watchChange.cause;
        var promiseChain = Promise.resolve();
        watchChange.targetIds.forEach(function (targetId) {
            promiseChain = promiseChain.then(function () { return tslib.__awaiter(_this, void 0, void 0, function () {
                return tslib.__generator(this, function (_a) {
                    // A watched target might have been removed already.
                    if (contains(this.listenTargets, targetId)) {
                        delete this.listenTargets[targetId];
                        this.watchChangeAggregator.removeTarget(targetId);
                        return [2 /*return*/, this.syncEngine.rejectListen(targetId, error)];
                    }
                    return [2 /*return*/];
                });
            }); });
        });
        return promiseChain;
    };
    /**
     * Attempts to fill our write pipeline with writes from the LocalStore.
     *
     * Called internally to bootstrap or refill the write pipeline and by
     * SyncEngine whenever there are new mutations to process.
     *
     * Starts the write stream if necessary.
     */
    RemoteStore.prototype.fillWritePipeline = function () {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var lastBatchIdRetrieved, batch;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.canAddToWritePipeline()) return [3 /*break*/, 4];
                        lastBatchIdRetrieved = this.writePipeline.length > 0
                            ? this.writePipeline[this.writePipeline.length - 1].batchId
                            : BATCHID_UNKNOWN;
                        return [4 /*yield*/, this.localStore.nextMutationBatch(lastBatchIdRetrieved)];
                    case 1:
                        batch = _a.sent();
                        if (!(batch === null)) return [3 /*break*/, 2];
                        if (this.writePipeline.length === 0) {
                            this.writeStream.markIdle();
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        this.addToWritePipeline(batch);
                        return [4 /*yield*/, this.fillWritePipeline()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        if (this.shouldStartWriteStream()) {
                            this.startWriteStream();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Returns true if we can add to the write pipeline (i.e. the network is
     * enabled and the write pipeline is not full).
     */
    RemoteStore.prototype.canAddToWritePipeline = function () {
        return (this.canUseNetwork() && this.writePipeline.length < MAX_PENDING_WRITES);
    };
    // For testing
    RemoteStore.prototype.outstandingWrites = function () {
        return this.writePipeline.length;
    };
    /**
     * Queues additional writes to be sent to the write stream, sending them
     * immediately if the write stream is established.
     */
    RemoteStore.prototype.addToWritePipeline = function (batch) {
        assert(this.canAddToWritePipeline(), 'addToWritePipeline called when pipeline is full');
        this.writePipeline.push(batch);
        if (this.writeStream.isOpen() && this.writeStream.handshakeComplete) {
            this.writeStream.writeMutations(batch.mutations);
        }
    };
    RemoteStore.prototype.shouldStartWriteStream = function () {
        return (this.canUseNetwork() &&
            !this.writeStream.isStarted() &&
            this.writePipeline.length > 0);
    };
    RemoteStore.prototype.startWriteStream = function () {
        assert(this.shouldStartWriteStream(), 'startWriteStream() called when shouldStartWriteStream() is false.');
        this.writeStream.start();
    };
    RemoteStore.prototype.onWriteStreamOpen = function () {
        return tslib.__awaiter(this, void 0, void 0, function () {
            return tslib.__generator(this, function (_a) {
                this.writeStream.writeHandshake();
                return [2 /*return*/];
            });
        });
    };
    RemoteStore.prototype.onWriteHandshakeComplete = function () {
        var _this = this;
        // Record the stream token.
        return this.localStore
            .setLastStreamToken(this.writeStream.lastStreamToken)
            .then(function () {
            // Send the write pipeline now that the stream is established.
            for (var _i = 0, _a = _this.writePipeline; _i < _a.length; _i++) {
                var batch = _a[_i];
                _this.writeStream.writeMutations(batch.mutations);
            }
        })
            .catch(ignoreIfPrimaryLeaseLoss);
    };
    RemoteStore.prototype.onMutationResult = function (commitVersion, results) {
        var _this = this;
        // This is a response to a write containing mutations and should be
        // correlated to the first write in our write pipeline.
        assert(this.writePipeline.length > 0, 'Got result for empty write pipeline');
        var batch = this.writePipeline.shift();
        var success = MutationBatchResult.from(batch, commitVersion, results, this.writeStream.lastStreamToken);
        return this.syncEngine.applySuccessfulWrite(success).then(function () {
            // It's possible that with the completion of this mutation another
            // slot has freed up.
            return _this.fillWritePipeline();
        });
    };
    RemoteStore.prototype.onWriteStreamClose = function (error) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var errorHandling;
            var _this = this;
            return tslib.__generator(this, function (_a) {
                if (error === undefined) {
                    // Graceful stop (due to stop() or idle timeout). Make sure that's
                    // desirable.
                    assert(!this.shouldStartWriteStream(), 'Write stream was stopped gracefully while still needed.');
                }
                // If the write stream closed due to an error, invoke the error callbacks if
                // there are pending writes.
                if (error && this.writePipeline.length > 0) {
                    errorHandling = void 0;
                    if (this.writeStream.handshakeComplete) {
                        // This error affects the actual write.
                        errorHandling = this.handleWriteError(error);
                    }
                    else {
                        // If there was an error before the handshake has finished, it's
                        // possible that the server is unable to process the stream token
                        // we're sending. (Perhaps it's too old?)
                        errorHandling = this.handleHandshakeError(error);
                    }
                    return [2 /*return*/, errorHandling.then(function () {
                            // The write stream might have been started by refilling the write
                            // pipeline for failed writes
                            if (_this.shouldStartWriteStream()) {
                                _this.startWriteStream();
                            }
                        })];
                }
                return [2 /*return*/];
            });
        });
    };
    RemoteStore.prototype.handleHandshakeError = function (error) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            return tslib.__generator(this, function (_a) {
                // Reset the token if it's a permanent error, signaling the write stream is
                // no longer valid. Note that the handshake does not count as a write: see
                // comments on isPermanentWriteError for details.
                if (isPermanentError(error.code)) {
                    debug(LOG_TAG$8, 'RemoteStore error before completed handshake; resetting stream token: ', this.writeStream.lastStreamToken);
                    this.writeStream.lastStreamToken = emptyByteString();
                    return [2 /*return*/, this.localStore
                            .setLastStreamToken(emptyByteString())
                            .catch(ignoreIfPrimaryLeaseLoss)];
                }
                return [2 /*return*/];
            });
        });
    };
    RemoteStore.prototype.handleWriteError = function (error) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var batch;
            var _this = this;
            return tslib.__generator(this, function (_a) {
                // Only handle permanent errors here. If it's transient, just let the retry
                // logic kick in.
                if (isPermanentWriteError(error.code)) {
                    batch = this.writePipeline.shift();
                    // In this case it's also unlikely that the server itself is melting
                    // down -- this was just a bad request so inhibit backoff on the next
                    // restart.
                    this.writeStream.inhibitBackoff();
                    return [2 /*return*/, this.syncEngine
                            .rejectFailedWrite(batch.batchId, error)
                            .then(function () {
                            // It's possible that with the completion of this mutation
                            // another slot has freed up.
                            return _this.fillWritePipeline();
                        })];
                }
                return [2 /*return*/];
            });
        });
    };
    RemoteStore.prototype.createTransaction = function () {
        return new Transaction(this.datastore);
    };
    RemoteStore.prototype.restartNetwork = function () {
        return tslib.__awaiter(this, void 0, void 0, function () {
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.networkEnabled = false;
                        return [4 /*yield*/, this.disableNetworkInternal()];
                    case 1:
                        _a.sent();
                        this.onlineStateTracker.set(OnlineState.Unknown);
                        return [4 /*yield*/, this.enableNetwork()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RemoteStore.prototype.handleCredentialChange = function () {
        return tslib.__awaiter(this, void 0, void 0, function () {
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.canUseNetwork()) return [3 /*break*/, 2];
                        // Tear down and re-create our network streams. This will ensure we get a fresh auth token
                        // for the new user and re-fill the write pipeline with new mutations from the LocalStore
                        // (since mutations are per-user).
                        debug(LOG_TAG$8, 'RemoteStore restarting streams for new credential');
                        return [4 /*yield*/, this.restartNetwork()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Toggles the network state when the client gains or loses its primary lease.
     */
    RemoteStore.prototype.applyPrimaryState = function (isPrimary) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isPrimary = isPrimary;
                        if (!(isPrimary && this.networkEnabled)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.enableNetwork()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        if (!!isPrimary) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.disableNetworkInternal()];
                    case 3:
                        _a.sent();
                        this.onlineStateTracker.set(OnlineState.Unknown);
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return RemoteStore;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Immutable class representing a geo point as latitude-longitude pair.
 * This class is directly exposed in the public API, including its constructor.
 */
var GeoPoint = /** @class */ (function () {
    function GeoPoint(latitude, longitude) {
        validateExactNumberOfArgs('GeoPoint', arguments, 2);
        validateArgType('GeoPoint', 'number', 1, latitude);
        validateArgType('GeoPoint', 'number', 2, longitude);
        if (!isFinite(latitude) || latitude < -90 || latitude > 90) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Latitude must be a number between -90 and 90, but was: ' + latitude);
        }
        if (!isFinite(longitude) || longitude < -180 || longitude > 180) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Longitude must be a number between -180 and 180, but was: ' + longitude);
        }
        this._lat = latitude;
        this._long = longitude;
    }
    Object.defineProperty(GeoPoint.prototype, "latitude", {
        /**
         * Returns the latitude of this geo point, a number between -90 and 90.
         */
        get: function () {
            return this._lat;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GeoPoint.prototype, "longitude", {
        /**
         * Returns the longitude of this geo point, a number between -180 and 180.
         */
        get: function () {
            return this._long;
        },
        enumerable: true,
        configurable: true
    });
    GeoPoint.prototype.isEqual = function (other) {
        return this._lat === other._lat && this._long === other._long;
    };
    /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */
    GeoPoint.prototype._compareTo = function (other) {
        return (primitiveComparator(this._lat, other._lat) ||
            primitiveComparator(this._long, other._long));
    };
    return GeoPoint;
}());

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A Target represents the WatchTarget representation of a Query, which is used
 * by the LocalStore and the RemoteStore to keep track of and to execute
 * backend queries. While a Query can represent multiple Targets, each Targets
 * maps to a single WatchTarget in RemoteStore and a single TargetData entry
 * in persistence.
 */
var Target = /** @class */ (function () {
    /**
     * Initializes a Target with a path and optional additional query constraints.
     * Path must currently be empty if this is a collection group query.
     *
     * NOTE: you should always construct `Target` from `Query.toTarget` instead of
     * using this constructor, because `Query` provides an implicit `orderBy`
     * property.
     */
    function Target(path, collectionGroup, orderBy, filters, limit, startAt, endAt) {
        if (collectionGroup === void 0) { collectionGroup = null; }
        if (orderBy === void 0) { orderBy = []; }
        if (filters === void 0) { filters = []; }
        if (limit === void 0) { limit = null; }
        if (startAt === void 0) { startAt = null; }
        if (endAt === void 0) { endAt = null; }
        this.path = path;
        this.collectionGroup = collectionGroup;
        this.orderBy = orderBy;
        this.filters = filters;
        this.limit = limit;
        this.startAt = startAt;
        this.endAt = endAt;
        this.memoizedCanonicalId = null;
    }
    Target.prototype.canonicalId = function () {
        if (this.memoizedCanonicalId === null) {
            var canonicalId = this.path.canonicalString();
            if (this.collectionGroup !== null) {
                canonicalId += '|cg:' + this.collectionGroup;
            }
            canonicalId += '|f:';
            for (var _i = 0, _a = this.filters; _i < _a.length; _i++) {
                var filter = _a[_i];
                canonicalId += filter.canonicalId();
                canonicalId += ',';
            }
            canonicalId += '|ob:';
            // TODO(dimond): make this collision resistant
            for (var _b = 0, _c = this.orderBy; _b < _c.length; _b++) {
                var orderBy = _c[_b];
                canonicalId += orderBy.canonicalId();
                canonicalId += ',';
            }
            if (!isNullOrUndefined(this.limit)) {
                canonicalId += '|l:';
                canonicalId += this.limit;
            }
            if (this.startAt) {
                canonicalId += '|lb:';
                canonicalId += this.startAt.canonicalId();
            }
            if (this.endAt) {
                canonicalId += '|ub:';
                canonicalId += this.endAt.canonicalId();
            }
            this.memoizedCanonicalId = canonicalId;
        }
        return this.memoizedCanonicalId;
    };
    Target.prototype.toString = function () {
        var str = this.path.canonicalString();
        if (this.collectionGroup !== null) {
            str += ' collectionGroup=' + this.collectionGroup;
        }
        if (this.filters.length > 0) {
            str += ", filters: [" + this.filters.join(', ') + "]";
        }
        if (!isNullOrUndefined(this.limit)) {
            str += ', limit: ' + this.limit;
        }
        if (this.orderBy.length > 0) {
            str += ", orderBy: [" + this.orderBy.join(', ') + "]";
        }
        if (this.startAt) {
            str += ', startAt: ' + this.startAt.canonicalId();
        }
        if (this.endAt) {
            str += ', endAt: ' + this.endAt.canonicalId();
        }
        return "Target(" + str + ")";
    };
    Target.prototype.isEqual = function (other) {
        if (this.limit !== other.limit) {
            return false;
        }
        if (this.orderBy.length !== other.orderBy.length) {
            return false;
        }
        for (var i = 0; i < this.orderBy.length; i++) {
            if (!this.orderBy[i].isEqual(other.orderBy[i])) {
                return false;
            }
        }
        if (this.filters.length !== other.filters.length) {
            return false;
        }
        for (var i = 0; i < this.filters.length; i++) {
            if (!this.filters[i].isEqual(other.filters[i])) {
                return false;
            }
        }
        if (this.collectionGroup !== other.collectionGroup) {
            return false;
        }
        if (!this.path.isEqual(other.path)) {
            return false;
        }
        if (this.startAt !== null
            ? !this.startAt.isEqual(other.startAt)
            : other.startAt !== null) {
            return false;
        }
        return this.endAt !== null
            ? this.endAt.isEqual(other.endAt)
            : other.endAt === null;
    };
    Target.prototype.isDocumentQuery = function () {
        return (DocumentKey.isDocumentKey(this.path) &&
            this.collectionGroup === null &&
            this.filters.length === 0);
    };
    return Target;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LimitType;
(function (LimitType) {
    LimitType["First"] = "F";
    LimitType["Last"] = "L";
})(LimitType || (LimitType = {}));
/**
 * Query encapsulates all the query attributes we support in the SDK. It can
 * be run against the LocalStore, as well as be converted to a `Target` to
 * query the RemoteStore results.
 */
var Query = /** @class */ (function () {
    /**
     * Initializes a Query with a path and optional additional query constraints.
     * Path must currently be empty if this is a collection group query.
     */
    function Query(path, collectionGroup, explicitOrderBy, filters, limit, limitType, startAt, endAt) {
        if (collectionGroup === void 0) { collectionGroup = null; }
        if (explicitOrderBy === void 0) { explicitOrderBy = []; }
        if (filters === void 0) { filters = []; }
        if (limit === void 0) { limit = null; }
        if (limitType === void 0) { limitType = LimitType.First; }
        if (startAt === void 0) { startAt = null; }
        if (endAt === void 0) { endAt = null; }
        this.path = path;
        this.collectionGroup = collectionGroup;
        this.explicitOrderBy = explicitOrderBy;
        this.filters = filters;
        this.limit = limit;
        this.limitType = limitType;
        this.startAt = startAt;
        this.endAt = endAt;
        this.memoizedOrderBy = null;
        // The corresponding `Target` of this `Query` instance.
        this.memorizedTarget = null;
        if (this.startAt) {
            this.assertValidBound(this.startAt);
        }
        if (this.endAt) {
            this.assertValidBound(this.endAt);
        }
    }
    Query.atPath = function (path) {
        return new Query(path);
    };
    Object.defineProperty(Query.prototype, "orderBy", {
        get: function () {
            if (this.memoizedOrderBy === null) {
                var inequalityField = this.getInequalityFilterField();
                var firstOrderByField = this.getFirstOrderByField();
                if (inequalityField !== null && firstOrderByField === null) {
                    // In order to implicitly add key ordering, we must also add the
                    // inequality filter field for it to be a valid query.
                    // Note that the default inequality field and key ordering is ascending.
                    if (inequalityField.isKeyField()) {
                        this.memoizedOrderBy = [KEY_ORDERING_ASC];
                    }
                    else {
                        this.memoizedOrderBy = [
                            new OrderBy(inequalityField),
                            KEY_ORDERING_ASC
                        ];
                    }
                }
                else {
                    assert(inequalityField === null ||
                        (firstOrderByField !== null &&
                            inequalityField.isEqual(firstOrderByField)), 'First orderBy should match inequality field.');
                    this.memoizedOrderBy = [];
                    var foundKeyOrdering = false;
                    for (var _i = 0, _a = this.explicitOrderBy; _i < _a.length; _i++) {
                        var orderBy = _a[_i];
                        this.memoizedOrderBy.push(orderBy);
                        if (orderBy.field.isKeyField()) {
                            foundKeyOrdering = true;
                        }
                    }
                    if (!foundKeyOrdering) {
                        // The order of the implicit key ordering always matches the last
                        // explicit order by
                        var lastDirection = this.explicitOrderBy.length > 0
                            ? this.explicitOrderBy[this.explicitOrderBy.length - 1].dir
                            : Direction.ASCENDING;
                        this.memoizedOrderBy.push(lastDirection === Direction.ASCENDING
                            ? KEY_ORDERING_ASC
                            : KEY_ORDERING_DESC);
                    }
                }
            }
            return this.memoizedOrderBy;
        },
        enumerable: true,
        configurable: true
    });
    Query.prototype.addFilter = function (filter) {
        assert(this.getInequalityFilterField() == null ||
            !(filter instanceof FieldFilter) ||
            !filter.isInequality() ||
            filter.field.isEqual(this.getInequalityFilterField()), 'Query must only have one inequality field.');
        assert(!this.isDocumentQuery(), 'No filtering allowed for document query');
        var newFilters = this.filters.concat([filter]);
        return new Query(this.path, this.collectionGroup, this.explicitOrderBy.slice(), newFilters, this.limit, this.limitType, this.startAt, this.endAt);
    };
    Query.prototype.addOrderBy = function (orderBy) {
        assert(!this.startAt && !this.endAt, 'Bounds must be set after orderBy');
        // TODO(dimond): validate that orderBy does not list the same key twice.
        var newOrderBy = this.explicitOrderBy.concat([orderBy]);
        return new Query(this.path, this.collectionGroup, newOrderBy, this.filters.slice(), this.limit, this.limitType, this.startAt, this.endAt);
    };
    Query.prototype.withLimitToFirst = function (limit) {
        return new Query(this.path, this.collectionGroup, this.explicitOrderBy.slice(), this.filters.slice(), limit, LimitType.First, this.startAt, this.endAt);
    };
    Query.prototype.withLimitToLast = function (limit) {
        return new Query(this.path, this.collectionGroup, this.explicitOrderBy.slice(), this.filters.slice(), limit, LimitType.Last, this.startAt, this.endAt);
    };
    Query.prototype.withStartAt = function (bound) {
        return new Query(this.path, this.collectionGroup, this.explicitOrderBy.slice(), this.filters.slice(), this.limit, this.limitType, bound, this.endAt);
    };
    Query.prototype.withEndAt = function (bound) {
        return new Query(this.path, this.collectionGroup, this.explicitOrderBy.slice(), this.filters.slice(), this.limit, this.limitType, this.startAt, bound);
    };
    /**
     * Helper to convert a collection group query into a collection query at a
     * specific path. This is used when executing collection group queries, since
     * we have to split the query into a set of collection queries at multiple
     * paths.
     */
    Query.prototype.asCollectionQueryAtPath = function (path) {
        return new Query(path, 
        /*collectionGroup=*/ null, this.explicitOrderBy.slice(), this.filters.slice(), this.limit, this.limitType, this.startAt, this.endAt);
    };
    /**
     * Returns true if this query does not specify any query constraints that
     * could remove results.
     */
    Query.prototype.matchesAllDocuments = function () {
        return (this.filters.length === 0 &&
            this.limit === null &&
            this.startAt == null &&
            this.endAt == null &&
            (this.explicitOrderBy.length === 0 ||
                (this.explicitOrderBy.length === 1 &&
                    this.explicitOrderBy[0].field.isKeyField())));
    };
    // TODO(b/29183165): This is used to get a unique string from a query to, for
    // example, use as a dictionary key, but the implementation is subject to
    // collisions. Make it collision-free.
    Query.prototype.canonicalId = function () {
        return this.toTarget().canonicalId() + "|lt:" + this.limitType;
    };
    Query.prototype.toString = function () {
        return "Query(target=" + this.toTarget().toString() + "; limitType=" + this.limitType + ")";
    };
    Query.prototype.isEqual = function (other) {
        return (this.toTarget().isEqual(other.toTarget()) &&
            this.limitType === other.limitType);
    };
    Query.prototype.docComparator = function (d1, d2) {
        var comparedOnKeyField = false;
        for (var _i = 0, _a = this.orderBy; _i < _a.length; _i++) {
            var orderBy = _a[_i];
            var comp = orderBy.compare(d1, d2);
            if (comp !== 0) {
                return comp;
            }
            comparedOnKeyField = comparedOnKeyField || orderBy.field.isKeyField();
        }
        // Assert that we actually compared by key
        assert(comparedOnKeyField, "orderBy used that doesn't compare on key field");
        return 0;
    };
    Query.prototype.matches = function (doc) {
        return (this.matchesPathAndCollectionGroup(doc) &&
            this.matchesOrderBy(doc) &&
            this.matchesFilters(doc) &&
            this.matchesBounds(doc));
    };
    Query.prototype.hasLimitToFirst = function () {
        return !isNullOrUndefined(this.limit) && this.limitType === LimitType.First;
    };
    Query.prototype.hasLimitToLast = function () {
        return !isNullOrUndefined(this.limit) && this.limitType === LimitType.Last;
    };
    Query.prototype.getFirstOrderByField = function () {
        return this.explicitOrderBy.length > 0
            ? this.explicitOrderBy[0].field
            : null;
    };
    Query.prototype.getInequalityFilterField = function () {
        for (var _i = 0, _a = this.filters; _i < _a.length; _i++) {
            var filter = _a[_i];
            if (filter instanceof FieldFilter && filter.isInequality()) {
                return filter.field;
            }
        }
        return null;
    };
    // Checks if any of the provided Operators are included in the query and
    // returns the first one that is, or null if none are.
    Query.prototype.findFilterOperator = function (operators) {
        for (var _i = 0, _a = this.filters; _i < _a.length; _i++) {
            var filter = _a[_i];
            if (filter instanceof FieldFilter) {
                if (operators.indexOf(filter.op) >= 0) {
                    return filter.op;
                }
            }
        }
        return null;
    };
    Query.prototype.isDocumentQuery = function () {
        return this.toTarget().isDocumentQuery();
    };
    Query.prototype.isCollectionGroupQuery = function () {
        return this.collectionGroup !== null;
    };
    /**
     * Converts this `Query` instance to it's corresponding `Target`
     * representation.
     */
    Query.prototype.toTarget = function () {
        if (!this.memorizedTarget) {
            if (this.limitType === LimitType.First) {
                this.memorizedTarget = new Target(this.path, this.collectionGroup, this.orderBy, this.filters, this.limit, this.startAt, this.endAt);
            }
            else {
                // Flip the orderBy directions since we want the last results
                var orderBys = [];
                for (var _i = 0, _a = this.orderBy; _i < _a.length; _i++) {
                    var orderBy = _a[_i];
                    var dir = orderBy.dir === Direction.DESCENDING
                        ? Direction.ASCENDING
                        : Direction.DESCENDING;
                    orderBys.push(new OrderBy(orderBy.field, dir));
                }
                // We need to swap the cursors to match the now-flipped query ordering.
                var startAt = this.endAt
                    ? new Bound(this.endAt.position, !this.endAt.before)
                    : null;
                var endAt = this.startAt
                    ? new Bound(this.startAt.position, !this.startAt.before)
                    : null;
                // Now return as a LimitType.First query.
                this.memorizedTarget = new Target(this.path, this.collectionGroup, orderBys, this.filters, this.limit, startAt, endAt);
            }
        }
        return this.memorizedTarget;
    };
    Query.prototype.matchesPathAndCollectionGroup = function (doc) {
        var docPath = doc.key.path;
        if (this.collectionGroup !== null) {
            // NOTE: this.path is currently always empty since we don't expose Collection
            // Group queries rooted at a document path yet.
            return (doc.key.hasCollectionId(this.collectionGroup) &&
                this.path.isPrefixOf(docPath));
        }
        else if (DocumentKey.isDocumentKey(this.path)) {
            // exact match for document queries
            return this.path.isEqual(docPath);
        }
        else {
            // shallow ancestor queries by default
            return this.path.isImmediateParentOf(docPath);
        }
    };
    /**
     * A document must have a value for every ordering clause in order to show up
     * in the results.
     */
    Query.prototype.matchesOrderBy = function (doc) {
        for (var _i = 0, _a = this.explicitOrderBy; _i < _a.length; _i++) {
            var orderBy = _a[_i];
            // order by key always matches
            if (!orderBy.field.isKeyField() && doc.field(orderBy.field) === null) {
                return false;
            }
        }
        return true;
    };
    Query.prototype.matchesFilters = function (doc) {
        for (var _i = 0, _a = this.filters; _i < _a.length; _i++) {
            var filter = _a[_i];
            if (!filter.matches(doc)) {
                return false;
            }
        }
        return true;
    };
    /**
     * Makes sure a document is within the bounds, if provided.
     */
    Query.prototype.matchesBounds = function (doc) {
        if (this.startAt && !this.startAt.sortsBeforeDocument(this.orderBy, doc)) {
            return false;
        }
        if (this.endAt && this.endAt.sortsBeforeDocument(this.orderBy, doc)) {
            return false;
        }
        return true;
    };
    Query.prototype.assertValidBound = function (bound) {
        assert(bound.position.length <= this.orderBy.length, 'Bound is longer than orderBy');
    };
    return Query;
}());
var Filter = /** @class */ (function () {
    function Filter() {
    }
    return Filter;
}());
var Operator = /** @class */ (function () {
    function Operator(name) {
        this.name = name;
    }
    Operator.fromString = function (op) {
        switch (op) {
            case '<':
                return Operator.LESS_THAN;
            case '<=':
                return Operator.LESS_THAN_OR_EQUAL;
            case '==':
                return Operator.EQUAL;
            case '>=':
                return Operator.GREATER_THAN_OR_EQUAL;
            case '>':
                return Operator.GREATER_THAN;
            case 'array-contains':
                return Operator.ARRAY_CONTAINS;
            case 'in':
                return Operator.IN;
            case 'array-contains-any':
                return Operator.ARRAY_CONTAINS_ANY;
            default:
                return fail('Unknown FieldFilter operator: ' + op);
        }
    };
    Operator.prototype.toString = function () {
        return this.name;
    };
    Operator.prototype.isEqual = function (other) {
        return this.name === other.name;
    };
    Operator.LESS_THAN = new Operator('<');
    Operator.LESS_THAN_OR_EQUAL = new Operator('<=');
    Operator.EQUAL = new Operator('==');
    Operator.GREATER_THAN = new Operator('>');
    Operator.GREATER_THAN_OR_EQUAL = new Operator('>=');
    Operator.ARRAY_CONTAINS = new Operator('array-contains');
    Operator.IN = new Operator('in');
    Operator.ARRAY_CONTAINS_ANY = new Operator('array-contains-any');
    return Operator;
}());
var FieldFilter = /** @class */ (function (_super) {
    tslib.__extends(FieldFilter, _super);
    function FieldFilter(field, op, value) {
        var _this = _super.call(this) || this;
        _this.field = field;
        _this.op = op;
        _this.value = value;
        return _this;
    }
    /**
     * Creates a filter based on the provided arguments.
     */
    FieldFilter.create = function (field, op, value) {
        if (field.isKeyField()) {
            if (op === Operator.IN) {
                assert(value instanceof ArrayValue, 'Comparing on key with IN, but filter value not an ArrayValue');
                assert(value.internalValue.every(function (elem) {
                    return elem instanceof RefValue;
                }), 'Comparing on key with IN, but an array value was not a RefValue');
                return new KeyFieldInFilter(field, value);
            }
            else {
                assert(value instanceof RefValue, 'Comparing on key, but filter value not a RefValue');
                assert(op !== Operator.ARRAY_CONTAINS && op !== Operator.ARRAY_CONTAINS_ANY, "'" + op.toString() + "' queries don't make sense on document keys.");
                return new KeyFieldFilter(field, op, value);
            }
        }
        else if (value.isEqual(NullValue.INSTANCE)) {
            if (op !== Operator.EQUAL) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. Null supports only equality comparisons.');
            }
            return new FieldFilter(field, op, value);
        }
        else if (value.isEqual(DoubleValue.NAN)) {
            if (op !== Operator.EQUAL) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. NaN supports only equality comparisons.');
            }
            return new FieldFilter(field, op, value);
        }
        else if (op === Operator.ARRAY_CONTAINS) {
            return new ArrayContainsFilter(field, value);
        }
        else if (op === Operator.IN) {
            assert(value instanceof ArrayValue, 'IN filter has invalid value: ' + value.toString());
            return new InFilter(field, value);
        }
        else if (op === Operator.ARRAY_CONTAINS_ANY) {
            assert(value instanceof ArrayValue, 'ARRAY_CONTAINS_ANY filter has invalid value: ' + value.toString());
            return new ArrayContainsAnyFilter(field, value);
        }
        else {
            return new FieldFilter(field, op, value);
        }
    };
    FieldFilter.prototype.matches = function (doc) {
        var other = doc.field(this.field);
        // Only compare types with matching backend order (such as double and int).
        return (other !== null &&
            this.value.typeOrder === other.typeOrder &&
            this.matchesComparison(other.compareTo(this.value)));
    };
    FieldFilter.prototype.matchesComparison = function (comparison) {
        switch (this.op) {
            case Operator.LESS_THAN:
                return comparison < 0;
            case Operator.LESS_THAN_OR_EQUAL:
                return comparison <= 0;
            case Operator.EQUAL:
                return comparison === 0;
            case Operator.GREATER_THAN:
                return comparison > 0;
            case Operator.GREATER_THAN_OR_EQUAL:
                return comparison >= 0;
            default:
                return fail('Unknown FieldFilter operator: ' + this.op);
        }
    };
    FieldFilter.prototype.isInequality = function () {
        return ([
            Operator.LESS_THAN,
            Operator.LESS_THAN_OR_EQUAL,
            Operator.GREATER_THAN,
            Operator.GREATER_THAN_OR_EQUAL
        ].indexOf(this.op) >= 0);
    };
    FieldFilter.prototype.canonicalId = function () {
        // TODO(b/29183165): Technically, this won't be unique if two values have
        // the same description, such as the int 3 and the string "3". So we should
        // add the types in here somehow, too.
        return (this.field.canonicalString() + this.op.toString() + this.value.toString());
    };
    FieldFilter.prototype.isEqual = function (other) {
        if (other instanceof FieldFilter) {
            return (this.op.isEqual(other.op) &&
                this.field.isEqual(other.field) &&
                this.value.isEqual(other.value));
        }
        else {
            return false;
        }
    };
    FieldFilter.prototype.toString = function () {
        return this.field.canonicalString() + " " + this.op + " " + this.value.value();
    };
    return FieldFilter;
}(Filter));
/** Filter that matches on key fields (i.e. '__name__'). */
var KeyFieldFilter = /** @class */ (function (_super) {
    tslib.__extends(KeyFieldFilter, _super);
    function KeyFieldFilter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KeyFieldFilter.prototype.matches = function (doc) {
        var refValue = this.value;
        var comparison = DocumentKey.comparator(doc.key, refValue.key);
        return this.matchesComparison(comparison);
    };
    return KeyFieldFilter;
}(FieldFilter));
/** Filter that matches on key fields within an array. */
var KeyFieldInFilter = /** @class */ (function (_super) {
    tslib.__extends(KeyFieldInFilter, _super);
    function KeyFieldInFilter(field, value) {
        var _this = _super.call(this, field, Operator.IN, value) || this;
        _this.value = value;
        return _this;
    }
    KeyFieldInFilter.prototype.matches = function (doc) {
        var arrayValue = this.value;
        return arrayValue.internalValue.some(function (refValue) {
            return doc.key.isEqual(refValue.key);
        });
    };
    return KeyFieldInFilter;
}(FieldFilter));
/** A Filter that implements the array-contains operator. */
var ArrayContainsFilter = /** @class */ (function (_super) {
    tslib.__extends(ArrayContainsFilter, _super);
    function ArrayContainsFilter(field, value) {
        return _super.call(this, field, Operator.ARRAY_CONTAINS, value) || this;
    }
    ArrayContainsFilter.prototype.matches = function (doc) {
        var other = doc.field(this.field);
        return other instanceof ArrayValue && other.contains(this.value);
    };
    return ArrayContainsFilter;
}(FieldFilter));
/** A Filter that implements the IN operator. */
var InFilter = /** @class */ (function (_super) {
    tslib.__extends(InFilter, _super);
    function InFilter(field, value) {
        var _this = _super.call(this, field, Operator.IN, value) || this;
        _this.value = value;
        return _this;
    }
    InFilter.prototype.matches = function (doc) {
        var arrayValue = this.value;
        var other = doc.field(this.field);
        return other !== null && arrayValue.contains(other);
    };
    return InFilter;
}(FieldFilter));
/** A Filter that implements the array-contains-any operator. */
var ArrayContainsAnyFilter = /** @class */ (function (_super) {
    tslib.__extends(ArrayContainsAnyFilter, _super);
    function ArrayContainsAnyFilter(field, value) {
        var _this = _super.call(this, field, Operator.ARRAY_CONTAINS_ANY, value) || this;
        _this.value = value;
        return _this;
    }
    ArrayContainsAnyFilter.prototype.matches = function (doc) {
        var _this = this;
        var other = doc.field(this.field);
        return (other instanceof ArrayValue &&
            other.internalValue.some(function (lhsElem) {
                return _this.value.contains(lhsElem);
            }));
    };
    return ArrayContainsAnyFilter;
}(FieldFilter));
/**
 * The direction of sorting in an order by.
 */
var Direction = /** @class */ (function () {
    function Direction(name) {
        this.name = name;
    }
    Direction.prototype.toString = function () {
        return this.name;
    };
    Direction.ASCENDING = new Direction('asc');
    Direction.DESCENDING = new Direction('desc');
    return Direction;
}());
/**
 * Represents a bound of a query.
 *
 * The bound is specified with the given components representing a position and
 * whether it's just before or just after the position (relative to whatever the
 * query order is).
 *
 * The position represents a logical index position for a query. It's a prefix
 * of values for the (potentially implicit) order by clauses of a query.
 *
 * Bound provides a function to determine whether a document comes before or
 * after a bound. This is influenced by whether the position is just before or
 * just after the provided values.
 */
var Bound = /** @class */ (function () {
    function Bound(position, before) {
        this.position = position;
        this.before = before;
    }
    Bound.prototype.canonicalId = function () {
        // TODO(b/29183165): Make this collision robust.
        var canonicalId = this.before ? 'b:' : 'a:';
        for (var _i = 0, _a = this.position; _i < _a.length; _i++) {
            var component = _a[_i];
            canonicalId += component.toString();
        }
        return canonicalId;
    };
    /**
     * Returns true if a document sorts before a bound using the provided sort
     * order.
     */
    Bound.prototype.sortsBeforeDocument = function (orderBy, doc) {
        assert(this.position.length <= orderBy.length, "Bound has more components than query's orderBy");
        var comparison = 0;
        for (var i = 0; i < this.position.length; i++) {
            var orderByComponent = orderBy[i];
            var component = this.position[i];
            if (orderByComponent.field.isKeyField()) {
                assert(component instanceof RefValue, 'Bound has a non-key value where the key path is being used.');
                comparison = DocumentKey.comparator(component.key, doc.key);
            }
            else {
                var docValue = doc.field(orderByComponent.field);
                assert(docValue !== null, 'Field should exist since document matched the orderBy already.');
                comparison = component.compareTo(docValue);
            }
            if (orderByComponent.dir === Direction.DESCENDING) {
                comparison = comparison * -1;
            }
            if (comparison !== 0) {
                break;
            }
        }
        return this.before ? comparison <= 0 : comparison < 0;
    };
    Bound.prototype.isEqual = function (other) {
        if (other === null) {
            return false;
        }
        if (this.before !== other.before ||
            this.position.length !== other.position.length) {
            return false;
        }
        for (var i = 0; i < this.position.length; i++) {
            var thisPosition = this.position[i];
            var otherPosition = other.position[i];
            if (!thisPosition.isEqual(otherPosition)) {
                return false;
            }
        }
        return true;
    };
    return Bound;
}());
/**
 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
 */
var OrderBy = /** @class */ (function () {
    function OrderBy(field, dir) {
        this.field = field;
        if (dir === undefined) {
            dir = Direction.ASCENDING;
        }
        this.dir = dir;
        this.isKeyOrderBy = field.isKeyField();
    }
    OrderBy.prototype.compare = function (d1, d2) {
        var comparison = this.isKeyOrderBy
            ? Document.compareByKey(d1, d2)
            : Document.compareByField(this.field, d1, d2);
        switch (this.dir) {
            case Direction.ASCENDING:
                return comparison;
            case Direction.DESCENDING:
                return -1 * comparison;
            default:
                return fail('Unknown direction: ' + this.dir);
        }
    };
    OrderBy.prototype.canonicalId = function () {
        // TODO(b/29183165): Make this collision robust.
        return this.field.canonicalString() + this.dir.toString();
    };
    OrderBy.prototype.toString = function () {
        return this.field.canonicalString() + " (" + this.dir + ")";
    };
    OrderBy.prototype.isEqual = function (other) {
        return this.dir === other.dir && this.field.isEqual(other.field);
    };
    return OrderBy;
}());
var KEY_ORDERING_ASC = new OrderBy(FieldPath.keyField(), Direction.ASCENDING);
var KEY_ORDERING_DESC = new OrderBy(FieldPath.keyField(), Direction.DESCENDING);

/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Transforms a value into a server-generated timestamp. */
var ServerTimestampTransform = /** @class */ (function () {
    function ServerTimestampTransform() {
    }
    ServerTimestampTransform.prototype.applyToLocalView = function (previousValue, localWriteTime) {
        return new ServerTimestampValue(localWriteTime, previousValue);
    };
    ServerTimestampTransform.prototype.applyToRemoteDocument = function (previousValue, transformResult) {
        return transformResult;
    };
    ServerTimestampTransform.prototype.computeBaseValue = function (previousValue) {
        return null; // Server timestamps are idempotent and don't require a base value.
    };
    ServerTimestampTransform.prototype.isEqual = function (other) {
        return other instanceof ServerTimestampTransform;
    };
    ServerTimestampTransform.instance = new ServerTimestampTransform();
    return ServerTimestampTransform;
}());
/** Transforms an array value via a union operation. */
var ArrayUnionTransformOperation = /** @class */ (function () {
    function ArrayUnionTransformOperation(elements) {
        this.elements = elements;
    }
    ArrayUnionTransformOperation.prototype.applyToLocalView = function (previousValue, localWriteTime) {
        return this.apply(previousValue);
    };
    ArrayUnionTransformOperation.prototype.applyToRemoteDocument = function (previousValue, transformResult) {
        // The server just sends null as the transform result for array operations,
        // so we have to calculate a result the same as we do for local
        // applications.
        return this.apply(previousValue);
    };
    ArrayUnionTransformOperation.prototype.apply = function (previousValue) {
        var result = coercedFieldValuesArray(previousValue);
        var _loop_1 = function (toUnion) {
            if (!result.find(function (element) { return element.isEqual(toUnion); })) {
                result.push(toUnion);
            }
        };
        for (var _i = 0, _a = this.elements; _i < _a.length; _i++) {
            var toUnion = _a[_i];
            _loop_1(toUnion);
        }
        return new ArrayValue(result);
    };
    ArrayUnionTransformOperation.prototype.computeBaseValue = function (previousValue) {
        return null; // Array transforms are idempotent and don't require a base value.
    };
    ArrayUnionTransformOperation.prototype.isEqual = function (other) {
        return (other instanceof ArrayUnionTransformOperation &&
            arrayEquals(other.elements, this.elements));
    };
    return ArrayUnionTransformOperation;
}());
/** Transforms an array value via a remove operation. */
var ArrayRemoveTransformOperation = /** @class */ (function () {
    function ArrayRemoveTransformOperation(elements) {
        this.elements = elements;
    }
    ArrayRemoveTransformOperation.prototype.applyToLocalView = function (previousValue, localWriteTime) {
        return this.apply(previousValue);
    };
    ArrayRemoveTransformOperation.prototype.applyToRemoteDocument = function (previousValue, transformResult) {
        // The server just sends null as the transform result for array operations,
        // so we have to calculate a result the same as we do for local
        // applications.
        return this.apply(previousValue);
    };
    ArrayRemoveTransformOperation.prototype.apply = function (previousValue) {
        var result = coercedFieldValuesArray(previousValue);
        var _loop_2 = function (toRemove) {
            result = result.filter(function (element) { return !element.isEqual(toRemove); });
        };
        for (var _i = 0, _a = this.elements; _i < _a.length; _i++) {
            var toRemove = _a[_i];
            _loop_2(toRemove);
        }
        return new ArrayValue(result);
    };
    ArrayRemoveTransformOperation.prototype.computeBaseValue = function (previousValue) {
        return null; // Array transforms are idempotent and don't require a base value.
    };
    ArrayRemoveTransformOperation.prototype.isEqual = function (other) {
        return (other instanceof ArrayRemoveTransformOperation &&
            arrayEquals(other.elements, this.elements));
    };
    return ArrayRemoveTransformOperation;
}());
/**
 * Implements the backend semantics for locally computed NUMERIC_ADD (increment)
 * transforms. Converts all field values to integers or doubles, but unlike the
 * backend does not cap integer values at 2^63. Instead, JavaScript number
 * arithmetic is used and precision loss can occur for values greater than 2^53.
 */
var NumericIncrementTransformOperation = /** @class */ (function () {
    function NumericIncrementTransformOperation(operand) {
        this.operand = operand;
    }
    NumericIncrementTransformOperation.prototype.applyToLocalView = function (previousValue, localWriteTime) {
        var baseValue = this.computeBaseValue(previousValue);
        // PORTING NOTE: Since JavaScript's integer arithmetic is limited to 53 bit
        // precision and resolves overflows by reducing precision, we do not
        // manually cap overflows at 2^63.
        // Return an integer value iff the previous value and the operand is an
        // integer.
        if (baseValue instanceof IntegerValue &&
            this.operand instanceof IntegerValue) {
            var sum = baseValue.internalValue + this.operand.internalValue;
            return new IntegerValue(sum);
        }
        else {
            var sum = baseValue.internalValue + this.operand.internalValue;
            return new DoubleValue(sum);
        }
    };
    NumericIncrementTransformOperation.prototype.applyToRemoteDocument = function (previousValue, transformResult) {
        assert(transformResult !== null, "Didn't receive transformResult for NUMERIC_ADD transform");
        return transformResult;
    };
    /**
     * Inspects the provided value, returning the provided value if it is already
     * a NumberValue, otherwise returning a coerced IntegerValue of 0.
     */
    NumericIncrementTransformOperation.prototype.computeBaseValue = function (previousValue) {
        return previousValue instanceof NumberValue
            ? previousValue
            : new IntegerValue(0);
    };
    NumericIncrementTransformOperation.prototype.isEqual = function (other) {
        return (other instanceof NumericIncrementTransformOperation &&
            this.operand.isEqual(other.operand));
    };
    return NumericIncrementTransformOperation;
}());
function coercedFieldValuesArray(value) {
    if (value instanceof ArrayValue) {
        return value.internalValue.slice();
    }
    else {
        // coerce to empty array.
        return [];
    }
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ExistenceFilter = /** @class */ (function () {
    // TODO(b/33078163): just use simplest form of existence filter for now
    function ExistenceFilter(count) {
        this.count = count;
    }
    ExistenceFilter.prototype.isEqual = function (other) {
        return other && other.count === this.count;
    };
    return ExistenceFilter;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DIRECTIONS = (function () {
    var dirs = {};
    dirs[Direction.ASCENDING.name] = 'ASCENDING';
    dirs[Direction.DESCENDING.name] = 'DESCENDING';
    return dirs;
})();
var OPERATORS = (function () {
    var ops = {};
    ops[Operator.LESS_THAN.name] = 'LESS_THAN';
    ops[Operator.LESS_THAN_OR_EQUAL.name] = 'LESS_THAN_OR_EQUAL';
    ops[Operator.GREATER_THAN.name] = 'GREATER_THAN';
    ops[Operator.GREATER_THAN_OR_EQUAL.name] = 'GREATER_THAN_OR_EQUAL';
    ops[Operator.EQUAL.name] = 'EQUAL';
    ops[Operator.ARRAY_CONTAINS.name] = 'ARRAY_CONTAINS';
    ops[Operator.IN.name] = 'IN';
    ops[Operator.ARRAY_CONTAINS_ANY.name] = 'ARRAY_CONTAINS_ANY';
    return ops;
})();
// A RegExp matching ISO 8601 UTC timestamps with optional fraction.
var ISO_REG_EXP = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
function assertPresent(value, description) {
    assert(!isNullOrUndefined(value), description + ' is missing');
}
function parseInt64(value) {
    // TODO(bjornick): Handle int64 greater than 53 bits.
    if (typeof value === 'number') {
        return value;
    }
    else if (typeof value === 'string') {
        return Number(value);
    }
    else {
        return fail("can't parse " + value);
    }
}
/**
 * Generates JsonObject values for the Datastore API suitable for sending to
 * either GRPC stub methods or via the JSON/HTTP REST API.
 * TODO(klimt): We can remove the databaseId argument if we keep the full
 * resource name in documents.
 */
var JsonProtoSerializer = /** @class */ (function () {
    function JsonProtoSerializer(databaseId, options) {
        this.databaseId = databaseId;
        this.options = options;
    }
    JsonProtoSerializer.prototype.emptyByteString = function () {
        if (this.options.useProto3Json) {
            return '';
        }
        else {
            return new Uint8Array(0);
        }
    };
    JsonProtoSerializer.prototype.unsafeCastProtoByteString = function (byteString) {
        // byteStrings can be either string or UInt8Array, but the typings say
        // it's always a string. Cast as string to avoid type check failing
        return byteString;
    };
    JsonProtoSerializer.prototype.fromRpcStatus = function (status) {
        var code = status.code === undefined
            ? Code.UNKNOWN
            : mapCodeFromRpcCode(status.code);
        return new FirestoreError(code, status.message || '');
    };
    /**
     * Returns a value for a number (or null) that's appropriate to put into
     * a google.protobuf.Int32Value proto.
     * DO NOT USE THIS FOR ANYTHING ELSE.
     * This method cheats. It's typed as returning "number" because that's what
     * our generated proto interfaces say Int32Value must be. But GRPC actually
     * expects a { value: <number> } struct.
     */
    JsonProtoSerializer.prototype.toInt32Value = function (val) {
        if (this.options.useProto3Json || isNullOrUndefined(val)) {
            return val;
        }
        else {
            // ProtobufJS requires that we wrap Int32Values.
            // Use any because we need to match generated Proto types.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return { value: val };
        }
    };
    /**
     * Returns a number (or null) from a google.protobuf.Int32Value proto.
     * DO NOT USE THIS FOR ANYTHING ELSE.
     * This method cheats. It's typed as accepting "number" because that's what
     * our generated proto interfaces say Int32Value must be, but it actually
     * accepts { value: number } to match our serialization in toInt32Value().
     */
    JsonProtoSerializer.prototype.fromInt32Value = function (val) {
        var result;
        if (typeof val === 'object') {
            // Use any because we need to match generated Proto types.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            result = val.value;
        }
        else {
            // We accept raw numbers (without the {value: ... } wrapper) for
            // compatibility with legacy persisted data.
            result = val;
        }
        return isNullOrUndefined(result) ? null : result;
    };
    /**
     * Returns a value for a Date that's appropriate to put into a proto.
     * DO NOT USE THIS FOR ANYTHING ELSE.
     * This method cheats. It's typed as returning "string" because that's what
     * our generated proto interfaces say dates must be. But it's easier and safer
     * to actually return a Timestamp proto.
     */
    JsonProtoSerializer.prototype.toTimestamp = function (timestamp) {
        if (this.options.useProto3Json) {
            // Serialize to ISO-8601 date format, but with full nano resolution.
            // Since JS Date has only millis, let's only use it for the seconds and
            // then manually add the fractions to the end.
            var jsDateStr = new Date(timestamp.seconds * 1000).toISOString();
            // Remove .xxx frac part and Z in the end.
            var strUntilSeconds = jsDateStr.replace(/\.\d*/, '').replace('Z', '');
            // Pad the fraction out to 9 digits (nanos).
            var nanoStr = ('000000000' + timestamp.nanoseconds).slice(-9);
            return strUntilSeconds + "." + nanoStr + "Z";
        }
        else {
            return {
                seconds: '' + timestamp.seconds,
                nanos: timestamp.nanoseconds
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
            };
        }
    };
    JsonProtoSerializer.prototype.fromTimestamp = function (date) {
        // The json interface (for the browser) will return an iso timestamp string,
        // while the proto js library (for node) will return a
        // google.protobuf.Timestamp instance.
        if (typeof date === 'string') {
            // TODO(b/37282237): Use strings for Proto3 timestamps
            // assert(this.options.useProto3Json,
            //   'The timestamp string format requires Proto3.');
            return this.fromIso8601String(date);
        }
        else {
            assert(!!date, 'Cannot deserialize null or undefined timestamp.');
            // TODO(b/37282237): Use strings for Proto3 timestamps
            // assert(!this.options.useProto3Json,
            //   'The timestamp instance format requires Proto JS.');
            var seconds = parseInt64(date.seconds || '0');
            var nanos = date.nanos || 0;
            return new Timestamp(seconds, nanos);
        }
    };
    JsonProtoSerializer.prototype.fromIso8601String = function (utc) {
        // The date string can have higher precision (nanos) than the Date class
        // (millis), so we do some custom parsing here.
        // Parse the nanos right out of the string.
        var nanos = 0;
        var fraction = ISO_REG_EXP.exec(utc);
        assert(!!fraction, 'invalid timestamp: ' + utc);
        if (fraction[1]) {
            // Pad the fraction out to 9 digits (nanos).
            var nanoStr = fraction[1];
            nanoStr = (nanoStr + '000000000').substr(0, 9);
            nanos = Number(nanoStr);
        }
        // Parse the date to get the seconds.
        var date = new Date(utc);
        var seconds = Math.floor(date.getTime() / 1000);
        return new Timestamp(seconds, nanos);
    };
    /**
     * Returns a value for bytes that's appropriate to put in a proto.
     * DO NOT USE THIS FOR ANYTHING ELSE.
     * This method cheats. It's typed as returning "string" because that's what
     * our generated proto interfaces say bytes must be. But it should return
     * an Uint8Array in Node.
     */
    JsonProtoSerializer.prototype.toBytes = function (bytes) {
        if (this.options.useProto3Json) {
            return bytes.toBase64();
        }
        else {
            // The typings say it's a string, but it needs to be a Uint8Array in Node.
            return this.unsafeCastProtoByteString(bytes.toUint8Array());
        }
    };
    /**
     * Parse the blob from the protos into the internal Blob class. Note that the
     * typings assume all blobs are strings, but they are actually Uint8Arrays
     * on Node.
     */
    JsonProtoSerializer.prototype.fromBlob = function (blob) {
        if (typeof blob === 'string') {
            assert(this.options.useProto3Json, 'Expected bytes to be passed in as Uint8Array, but got a string instead.');
            return Blob.fromBase64String(blob);
        }
        else {
            assert(!this.options.useProto3Json, 'Expected bytes to be passed in as Uint8Array, but got a string instead.');
            return Blob.fromUint8Array(blob);
        }
    };
    JsonProtoSerializer.prototype.toVersion = function (version) {
        return this.toTimestamp(version.toTimestamp());
    };
    JsonProtoSerializer.prototype.fromVersion = function (version) {
        assert(!!version, "Trying to deserialize version that isn't set");
        return SnapshotVersion.fromTimestamp(this.fromTimestamp(version));
    };
    JsonProtoSerializer.prototype.toResourceName = function (databaseId, path) {
        return this.fullyQualifiedPrefixPath(databaseId)
            .child('documents')
            .child(path)
            .canonicalString();
    };
    JsonProtoSerializer.prototype.fromResourceName = function (name) {
        var resource = ResourcePath.fromString(name);
        assert(this.isValidResourceName(resource), 'Tried to deserialize invalid key ' + resource.toString());
        return resource;
    };
    JsonProtoSerializer.prototype.toName = function (key) {
        return this.toResourceName(this.databaseId, key.path);
    };
    JsonProtoSerializer.prototype.fromName = function (name) {
        var resource = this.fromResourceName(name);
        assert(resource.get(1) === this.databaseId.projectId, 'Tried to deserialize key from different project: ' +
            resource.get(1) +
            ' vs ' +
            this.databaseId.projectId);
        assert((!resource.get(3) && !this.databaseId.database) ||
            resource.get(3) === this.databaseId.database, 'Tried to deserialize key from different database: ' +
            resource.get(3) +
            ' vs ' +
            this.databaseId.database);
        return new DocumentKey(this.extractLocalPathFromResourceName(resource));
    };
    JsonProtoSerializer.prototype.toQueryPath = function (path) {
        return this.toResourceName(this.databaseId, path);
    };
    JsonProtoSerializer.prototype.fromQueryPath = function (name) {
        var resourceName = this.fromResourceName(name);
        // In v1beta1 queries for collections at the root did not have a trailing
        // "/documents". In v1 all resource paths contain "/documents". Preserve the
        // ability to read the v1beta1 form for compatibility with queries persisted
        // in the local target cache.
        if (resourceName.length === 4) {
            return ResourcePath.EMPTY_PATH;
        }
        return this.extractLocalPathFromResourceName(resourceName);
    };
    Object.defineProperty(JsonProtoSerializer.prototype, "encodedDatabaseId", {
        get: function () {
            var path = new ResourcePath([
                'projects',
                this.databaseId.projectId,
                'databases',
                this.databaseId.database
            ]);
            return path.canonicalString();
        },
        enumerable: true,
        configurable: true
    });
    JsonProtoSerializer.prototype.fullyQualifiedPrefixPath = function (databaseId) {
        return new ResourcePath([
            'projects',
            databaseId.projectId,
            'databases',
            databaseId.database
        ]);
    };
    JsonProtoSerializer.prototype.extractLocalPathFromResourceName = function (resourceName) {
        assert(resourceName.length > 4 && resourceName.get(4) === 'documents', 'tried to deserialize invalid key ' + resourceName.toString());
        return resourceName.popFirst(5);
    };
    JsonProtoSerializer.prototype.isValidResourceName = function (path) {
        // Resource names have at least 4 components (project ID, database ID)
        return (path.length >= 4 &&
            path.get(0) === 'projects' &&
            path.get(2) === 'databases');
    };
    JsonProtoSerializer.prototype.toValue = function (val) {
        if (val instanceof NullValue) {
            return { nullValue: 'NULL_VALUE' };
        }
        else if (val instanceof BooleanValue) {
            return { booleanValue: val.value() };
        }
        else if (val instanceof IntegerValue) {
            return { integerValue: '' + val.value() };
        }
        else if (val instanceof DoubleValue) {
            var doubleValue = val.value();
            if (this.options.useProto3Json) {
                // Proto 3 let's us encode NaN and Infinity as string values as
                // expected by the backend. This is currently not checked by our unit
                // tests because they rely on protobuf.js.
                if (isNaN(doubleValue)) {
                    return { doubleValue: 'NaN' };
                }
                else if (doubleValue === Infinity) {
                    return { doubleValue: 'Infinity' };
                }
                else if (doubleValue === -Infinity) {
                    return { doubleValue: '-Infinity' };
                }
            }
            return { doubleValue: val.value() };
        }
        else if (val instanceof StringValue) {
            return { stringValue: val.value() };
        }
        else if (val instanceof ObjectValue) {
            return { mapValue: this.toMapValue(val) };
        }
        else if (val instanceof ArrayValue) {
            return { arrayValue: this.toArrayValue(val) };
        }
        else if (val instanceof TimestampValue) {
            return {
                timestampValue: this.toTimestamp(val.internalValue)
            };
        }
        else if (val instanceof GeoPointValue) {
            return {
                geoPointValue: {
                    latitude: val.value().latitude,
                    longitude: val.value().longitude
                }
            };
        }
        else if (val instanceof BlobValue) {
            return {
                bytesValue: this.toBytes(val.value())
            };
        }
        else if (val instanceof RefValue) {
            return {
                referenceValue: this.toResourceName(val.databaseId, val.key.path)
            };
        }
        else {
            return fail('Unknown FieldValue ' + JSON.stringify(val));
        }
    };
    JsonProtoSerializer.prototype.fromValue = function (obj) {
        var _this = this;
        if ('nullValue' in obj) {
            return NullValue.INSTANCE;
        }
        else if ('booleanValue' in obj) {
            return BooleanValue.of(obj.booleanValue);
        }
        else if ('integerValue' in obj) {
            return new IntegerValue(parseInt64(obj.integerValue));
        }
        else if ('doubleValue' in obj) {
            if (this.options.useProto3Json) {
                // Proto 3 uses the string values 'NaN' and 'Infinity'.
                if (obj.doubleValue === 'NaN') {
                    return DoubleValue.NAN;
                }
                else if (obj.doubleValue === 'Infinity') {
                    return DoubleValue.POSITIVE_INFINITY;
                }
                else if (obj.doubleValue === '-Infinity') {
                    return DoubleValue.NEGATIVE_INFINITY;
                }
            }
            return new DoubleValue(obj.doubleValue);
        }
        else if ('stringValue' in obj) {
            return new StringValue(obj.stringValue);
        }
        else if ('mapValue' in obj) {
            return this.fromFields(obj.mapValue.fields || {});
        }
        else if ('arrayValue' in obj) {
            // "values" is not present if the array is empty
            assertPresent(obj.arrayValue, 'arrayValue');
            var values = obj.arrayValue.values || [];
            return new ArrayValue(values.map(function (v) { return _this.fromValue(v); }));
        }
        else if ('timestampValue' in obj) {
            assertPresent(obj.timestampValue, 'timestampValue');
            return new TimestampValue(this.fromTimestamp(obj.timestampValue));
        }
        else if ('geoPointValue' in obj) {
            assertPresent(obj.geoPointValue, 'geoPointValue');
            var latitude = obj.geoPointValue.latitude || 0;
            var longitude = obj.geoPointValue.longitude || 0;
            return new GeoPointValue(new GeoPoint(latitude, longitude));
        }
        else if ('bytesValue' in obj) {
            assertPresent(obj.bytesValue, 'bytesValue');
            var blob = this.fromBlob(obj.bytesValue);
            return new BlobValue(blob);
        }
        else if ('referenceValue' in obj) {
            assertPresent(obj.referenceValue, 'referenceValue');
            var resourceName = this.fromResourceName(obj.referenceValue);
            var dbId = new DatabaseId(resourceName.get(1), resourceName.get(3));
            var key = new DocumentKey(this.extractLocalPathFromResourceName(resourceName));
            return new RefValue(dbId, key);
        }
        else {
            return fail('Unknown Value proto ' + JSON.stringify(obj));
        }
    };
    /** Creates an api.Document from key and fields (but no create/update time) */
    JsonProtoSerializer.prototype.toMutationDocument = function (key, fields) {
        return {
            name: this.toName(key),
            fields: this.toFields(fields)
        };
    };
    JsonProtoSerializer.prototype.toDocument = function (document) {
        assert(!document.hasLocalMutations, "Can't serialize documents with mutations.");
        return {
            name: this.toName(document.key),
            fields: this.toFields(document.data()),
            updateTime: this.toTimestamp(document.version.toTimestamp())
        };
    };
    JsonProtoSerializer.prototype.fromDocument = function (document, hasCommittedMutations) {
        var _this = this;
        var key = this.fromName(document.name);
        var version = this.fromVersion(document.updateTime);
        return new Document(key, version, { hasCommittedMutations: !!hasCommittedMutations }, undefined, document, function (v) { return _this.fromValue(v); });
    };
    JsonProtoSerializer.prototype.toFields = function (fields) {
        var _this = this;
        var result = {};
        fields.forEach(function (key, value) {
            result[key] = _this.toValue(value);
        });
        return result;
    };
    JsonProtoSerializer.prototype.fromFields = function (object) {
        var _this = this;
        // Proto map<string, Value> gets mapped to Object, so cast it.
        var map = object;
        var result = ObjectValue.EMPTY;
        forEach(map, function (key, value) {
            result = result.set(new FieldPath([key]), _this.fromValue(value));
        });
        return result;
    };
    JsonProtoSerializer.prototype.toMapValue = function (map) {
        return {
            fields: this.toFields(map)
        };
    };
    JsonProtoSerializer.prototype.toArrayValue = function (array) {
        var _this = this;
        var result = [];
        array.forEach(function (value) {
            result.push(_this.toValue(value));
        });
        return { values: result };
    };
    JsonProtoSerializer.prototype.fromFound = function (doc) {
        var _this = this;
        assert(!!doc.found, 'Tried to deserialize a found document from a missing document.');
        assertPresent(doc.found.name, 'doc.found.name');
        assertPresent(doc.found.updateTime, 'doc.found.updateTime');
        var key = this.fromName(doc.found.name);
        var version = this.fromVersion(doc.found.updateTime);
        return new Document(key, version, {}, undefined, doc.found, function (v) {
            return _this.fromValue(v);
        });
    };
    JsonProtoSerializer.prototype.fromMissing = function (result) {
        assert(!!result.missing, 'Tried to deserialize a missing document from a found document.');
        assert(!!result.readTime, 'Tried to deserialize a missing document without a read time.');
        var key = this.fromName(result.missing);
        var version = this.fromVersion(result.readTime);
        return new NoDocument(key, version);
    };
    JsonProtoSerializer.prototype.fromMaybeDocument = function (result) {
        if ('found' in result) {
            return this.fromFound(result);
        }
        else if ('missing' in result) {
            return this.fromMissing(result);
        }
        return fail('invalid batch get response: ' + JSON.stringify(result));
    };
    JsonProtoSerializer.prototype.toWatchTargetChangeState = function (state) {
        switch (state) {
            case WatchTargetChangeState.Added:
                return 'ADD';
            case WatchTargetChangeState.Current:
                return 'CURRENT';
            case WatchTargetChangeState.NoChange:
                return 'NO_CHANGE';
            case WatchTargetChangeState.Removed:
                return 'REMOVE';
            case WatchTargetChangeState.Reset:
                return 'RESET';
            default:
                return fail('Unknown WatchTargetChangeState: ' + state);
        }
    };
    JsonProtoSerializer.prototype.toTestWatchChange = function (watchChange) {
        if (watchChange instanceof ExistenceFilterChange) {
            return {
                filter: {
                    count: watchChange.existenceFilter.count,
                    targetId: watchChange.targetId
                }
            };
        }
        if (watchChange instanceof DocumentWatchChange) {
            if (watchChange.newDoc instanceof Document) {
                var doc = watchChange.newDoc;
                return {
                    documentChange: {
                        document: {
                            name: this.toName(doc.key),
                            fields: this.toFields(doc.data()),
                            updateTime: this.toVersion(doc.version)
                        },
                        targetIds: watchChange.updatedTargetIds,
                        removedTargetIds: watchChange.removedTargetIds
                    }
                };
            }
            else if (watchChange.newDoc instanceof NoDocument) {
                var doc = watchChange.newDoc;
                return {
                    documentDelete: {
                        document: this.toName(doc.key),
                        readTime: this.toVersion(doc.version),
                        removedTargetIds: watchChange.removedTargetIds
                    }
                };
            }
            else if (watchChange.newDoc === null) {
                return {
                    documentRemove: {
                        document: this.toName(watchChange.key),
                        removedTargetIds: watchChange.removedTargetIds
                    }
                };
            }
        }
        if (watchChange instanceof WatchTargetChange) {
            var cause = undefined;
            if (watchChange.cause) {
                cause = {
                    code: mapRpcCodeFromCode(watchChange.cause.code),
                    message: watchChange.cause.message
                };
            }
            return {
                targetChange: {
                    targetChangeType: this.toWatchTargetChangeState(watchChange.state),
                    targetIds: watchChange.targetIds,
                    resumeToken: this.unsafeCastProtoByteString(watchChange.resumeToken),
                    cause: cause
                }
            };
        }
        return fail('Unrecognized watch change: ' + JSON.stringify(watchChange));
    };
    JsonProtoSerializer.prototype.fromWatchChange = function (change) {
        var _this = this;
        var watchChange;
        if ('targetChange' in change) {
            assertPresent(change.targetChange, 'targetChange');
            // proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
            // if unset
            var state = this.fromWatchTargetChangeState(change.targetChange.targetChangeType || 'NO_CHANGE');
            var targetIds = change.targetChange.targetIds || [];
            var resumeToken = change.targetChange.resumeToken || this.emptyByteString();
            var causeProto = change.targetChange.cause;
            var cause = causeProto && this.fromRpcStatus(causeProto);
            watchChange = new WatchTargetChange(state, targetIds, resumeToken, cause || null);
        }
        else if ('documentChange' in change) {
            assertPresent(change.documentChange, 'documentChange');
            assertPresent(change.documentChange.document, 'documentChange.name');
            assertPresent(change.documentChange.document.name, 'documentChange.document.name');
            assertPresent(change.documentChange.document.updateTime, 'documentChange.document.updateTime');
            var entityChange = change.documentChange;
            var key = this.fromName(entityChange.document.name);
            var version = this.fromVersion(entityChange.document.updateTime);
            var doc = new Document(key, version, {}, undefined, entityChange.document, function (v) { return _this.fromValue(v); });
            var updatedTargetIds = entityChange.targetIds || [];
            var removedTargetIds = entityChange.removedTargetIds || [];
            watchChange = new DocumentWatchChange(updatedTargetIds, removedTargetIds, doc.key, doc);
        }
        else if ('documentDelete' in change) {
            assertPresent(change.documentDelete, 'documentDelete');
            assertPresent(change.documentDelete.document, 'documentDelete.document');
            var docDelete = change.documentDelete;
            var key = this.fromName(docDelete.document);
            var version = docDelete.readTime
                ? this.fromVersion(docDelete.readTime)
                : SnapshotVersion.forDeletedDoc();
            var doc = new NoDocument(key, version);
            var removedTargetIds = docDelete.removedTargetIds || [];
            watchChange = new DocumentWatchChange([], removedTargetIds, doc.key, doc);
        }
        else if ('documentRemove' in change) {
            assertPresent(change.documentRemove, 'documentRemove');
            assertPresent(change.documentRemove.document, 'documentRemove');
            var docRemove = change.documentRemove;
            var key = this.fromName(docRemove.document);
            var removedTargetIds = docRemove.removedTargetIds || [];
            watchChange = new DocumentWatchChange([], removedTargetIds, key, null);
        }
        else if ('filter' in change) {
            // TODO(dimond): implement existence filter parsing with strategy.
            assertPresent(change.filter, 'filter');
            assertPresent(change.filter.targetId, 'filter.targetId');
            var filter = change.filter;
            var count = filter.count || 0;
            var existenceFilter = new ExistenceFilter(count);
            var targetId = filter.targetId;
            watchChange = new ExistenceFilterChange(targetId, existenceFilter);
        }
        else {
            return fail('Unknown change type ' + JSON.stringify(change));
        }
        return watchChange;
    };
    JsonProtoSerializer.prototype.fromWatchTargetChangeState = function (state) {
        if (state === 'NO_CHANGE') {
            return WatchTargetChangeState.NoChange;
        }
        else if (state === 'ADD') {
            return WatchTargetChangeState.Added;
        }
        else if (state === 'REMOVE') {
            return WatchTargetChangeState.Removed;
        }
        else if (state === 'CURRENT') {
            return WatchTargetChangeState.Current;
        }
        else if (state === 'RESET') {
            return WatchTargetChangeState.Reset;
        }
        else {
            return fail('Got unexpected TargetChange.state: ' + state);
        }
    };
    JsonProtoSerializer.prototype.versionFromListenResponse = function (change) {
        // We have only reached a consistent snapshot for the entire stream if there
        // is a read_time set and it applies to all targets (i.e. the list of
        // targets is empty). The backend is guaranteed to send such responses.
        if (!('targetChange' in change)) {
            return SnapshotVersion.MIN;
        }
        var targetChange = change.targetChange;
        if (targetChange.targetIds && targetChange.targetIds.length) {
            return SnapshotVersion.MIN;
        }
        if (!targetChange.readTime) {
            return SnapshotVersion.MIN;
        }
        return this.fromVersion(targetChange.readTime);
    };
    JsonProtoSerializer.prototype.toMutation = function (mutation) {
        var _this = this;
        var result;
        if (mutation instanceof SetMutation) {
            result = {
                update: this.toMutationDocument(mutation.key, mutation.value)
            };
        }
        else if (mutation instanceof DeleteMutation) {
            result = { delete: this.toName(mutation.key) };
        }
        else if (mutation instanceof PatchMutation) {
            result = {
                update: this.toMutationDocument(mutation.key, mutation.data),
                updateMask: this.toDocumentMask(mutation.fieldMask)
            };
        }
        else if (mutation instanceof TransformMutation) {
            result = {
                transform: {
                    document: this.toName(mutation.key),
                    fieldTransforms: mutation.fieldTransforms.map(function (transform) {
                        return _this.toFieldTransform(transform);
                    })
                }
            };
        }
        else {
            return fail('Unknown mutation type ' + mutation.type);
        }
        if (!mutation.precondition.isNone) {
            result.currentDocument = this.toPrecondition(mutation.precondition);
        }
        return result;
    };
    JsonProtoSerializer.prototype.fromMutation = function (proto) {
        var _this = this;
        var precondition = proto.currentDocument
            ? this.fromPrecondition(proto.currentDocument)
            : Precondition.NONE;
        if (proto.update) {
            assertPresent(proto.update.name, 'name');
            var key = this.fromName(proto.update.name);
            var value = this.fromFields(proto.update.fields || {});
            if (proto.updateMask) {
                var fieldMask = this.fromDocumentMask(proto.updateMask);
                return new PatchMutation(key, value, fieldMask, precondition);
            }
            else {
                return new SetMutation(key, value, precondition);
            }
        }
        else if (proto.delete) {
            var key = this.fromName(proto.delete);
            return new DeleteMutation(key, precondition);
        }
        else if (proto.transform) {
            var key = this.fromName(proto.transform.document);
            var fieldTransforms = proto.transform.fieldTransforms.map(function (transform) {
                return _this.fromFieldTransform(transform);
            });
            assert(precondition.exists === true, 'Transforms only support precondition "exists == true"');
            return new TransformMutation(key, fieldTransforms);
        }
        else {
            return fail('unknown mutation proto: ' + JSON.stringify(proto));
        }
    };
    JsonProtoSerializer.prototype.toPrecondition = function (precondition) {
        assert(!precondition.isNone, "Can't serialize an empty precondition");
        if (precondition.updateTime !== undefined) {
            return {
                updateTime: this.toVersion(precondition.updateTime)
            };
        }
        else if (precondition.exists !== undefined) {
            return { exists: precondition.exists };
        }
        else {
            return fail('Unknown precondition');
        }
    };
    JsonProtoSerializer.prototype.fromPrecondition = function (precondition) {
        if (precondition.updateTime !== undefined) {
            return Precondition.updateTime(this.fromVersion(precondition.updateTime));
        }
        else if (precondition.exists !== undefined) {
            return Precondition.exists(precondition.exists);
        }
        else {
            return Precondition.NONE;
        }
    };
    JsonProtoSerializer.prototype.fromWriteResult = function (proto, commitTime) {
        var _this = this;
        // NOTE: Deletes don't have an updateTime.
        var version = proto.updateTime
            ? this.fromVersion(proto.updateTime)
            : this.fromVersion(commitTime);
        if (version.isEqual(SnapshotVersion.MIN)) {
            // The Firestore Emulator currently returns an update time of 0 for
            // deletes of non-existing documents (rather than null). This breaks the
            // test "get deleted doc while offline with source=cache" as NoDocuments
            // with version 0 are filtered by IndexedDb's RemoteDocumentCache.
            // TODO(#2149): Remove this when Emulator is fixed
            version = this.fromVersion(commitTime);
        }
        var transformResults = null;
        if (proto.transformResults && proto.transformResults.length > 0) {
            transformResults = proto.transformResults.map(function (result) {
                return _this.fromValue(result);
            });
        }
        return new MutationResult(version, transformResults);
    };
    JsonProtoSerializer.prototype.fromWriteResults = function (protos, commitTime) {
        var _this = this;
        if (protos && protos.length > 0) {
            assert(commitTime !== undefined, 'Received a write result without a commit time');
            return protos.map(function (proto) { return _this.fromWriteResult(proto, commitTime); });
        }
        else {
            return [];
        }
    };
    JsonProtoSerializer.prototype.toFieldTransform = function (fieldTransform) {
        var _this = this;
        var transform = fieldTransform.transform;
        if (transform instanceof ServerTimestampTransform) {
            return {
                fieldPath: fieldTransform.field.canonicalString(),
                setToServerValue: 'REQUEST_TIME'
            };
        }
        else if (transform instanceof ArrayUnionTransformOperation) {
            return {
                fieldPath: fieldTransform.field.canonicalString(),
                appendMissingElements: {
                    values: transform.elements.map(function (v) { return _this.toValue(v); })
                }
            };
        }
        else if (transform instanceof ArrayRemoveTransformOperation) {
            return {
                fieldPath: fieldTransform.field.canonicalString(),
                removeAllFromArray: {
                    values: transform.elements.map(function (v) { return _this.toValue(v); })
                }
            };
        }
        else if (transform instanceof NumericIncrementTransformOperation) {
            return {
                fieldPath: fieldTransform.field.canonicalString(),
                increment: this.toValue(transform.operand)
            };
        }
        else {
            throw fail('Unknown transform: ' + fieldTransform.transform);
        }
    };
    JsonProtoSerializer.prototype.fromFieldTransform = function (proto) {
        var _this = this;
        var transform = null;
        if ('setToServerValue' in proto) {
            assert(proto.setToServerValue === 'REQUEST_TIME', 'Unknown server value transform proto: ' + JSON.stringify(proto));
            transform = ServerTimestampTransform.instance;
        }
        else if ('appendMissingElements' in proto) {
            var values = proto.appendMissingElements.values || [];
            transform = new ArrayUnionTransformOperation(values.map(function (v) { return _this.fromValue(v); }));
        }
        else if ('removeAllFromArray' in proto) {
            var values = proto.removeAllFromArray.values || [];
            transform = new ArrayRemoveTransformOperation(values.map(function (v) { return _this.fromValue(v); }));
        }
        else if ('increment' in proto) {
            var operand = this.fromValue(proto.increment);
            assert(operand instanceof NumberValue, 'NUMERIC_ADD transform requires a NumberValue');
            transform = new NumericIncrementTransformOperation(operand);
        }
        else {
            fail('Unknown transform proto: ' + JSON.stringify(proto));
        }
        var fieldPath = FieldPath.fromServerFormat(proto.fieldPath);
        return new FieldTransform(fieldPath, transform);
    };
    JsonProtoSerializer.prototype.toDocumentsTarget = function (target) {
        return { documents: [this.toQueryPath(target.path)] };
    };
    JsonProtoSerializer.prototype.fromDocumentsTarget = function (documentsTarget) {
        var count = documentsTarget.documents.length;
        assert(count === 1, 'DocumentsTarget contained other than 1 document: ' + count);
        var name = documentsTarget.documents[0];
        return Query.atPath(this.fromQueryPath(name)).toTarget();
    };
    JsonProtoSerializer.prototype.toQueryTarget = function (target) {
        // Dissect the path into parent, collectionId, and optional key filter.
        var result = { structuredQuery: {} };
        var path = target.path;
        if (target.collectionGroup !== null) {
            assert(path.length % 2 === 0, 'Collection Group queries should be within a document path or root.');
            result.parent = this.toQueryPath(path);
            result.structuredQuery.from = [
                {
                    collectionId: target.collectionGroup,
                    allDescendants: true
                }
            ];
        }
        else {
            assert(path.length % 2 !== 0, 'Document queries with filters are not supported.');
            result.parent = this.toQueryPath(path.popLast());
            result.structuredQuery.from = [{ collectionId: path.lastSegment() }];
        }
        var where = this.toFilter(target.filters);
        if (where) {
            result.structuredQuery.where = where;
        }
        var orderBy = this.toOrder(target.orderBy);
        if (orderBy) {
            result.structuredQuery.orderBy = orderBy;
        }
        var limit = this.toInt32Value(target.limit);
        if (limit !== null) {
            result.structuredQuery.limit = limit;
        }
        if (target.startAt) {
            result.structuredQuery.startAt = this.toCursor(target.startAt);
        }
        if (target.endAt) {
            result.structuredQuery.endAt = this.toCursor(target.endAt);
        }
        return result;
    };
    JsonProtoSerializer.prototype.fromQueryTarget = function (target) {
        var path = this.fromQueryPath(target.parent);
        var query = target.structuredQuery;
        var fromCount = query.from ? query.from.length : 0;
        var collectionGroup = null;
        if (fromCount > 0) {
            assert(fromCount === 1, 'StructuredQuery.from with more than one collection is not supported.');
            var from = query.from[0];
            if (from.allDescendants) {
                collectionGroup = from.collectionId;
            }
            else {
                path = path.child(from.collectionId);
            }
        }
        var filterBy = [];
        if (query.where) {
            filterBy = this.fromFilter(query.where);
        }
        var orderBy = [];
        if (query.orderBy) {
            orderBy = this.fromOrder(query.orderBy);
        }
        var limit = null;
        if (query.limit) {
            limit = this.fromInt32Value(query.limit);
        }
        var startAt = null;
        if (query.startAt) {
            startAt = this.fromCursor(query.startAt);
        }
        var endAt = null;
        if (query.endAt) {
            endAt = this.fromCursor(query.endAt);
        }
        return new Query(path, collectionGroup, orderBy, filterBy, limit, LimitType.First, startAt, endAt).toTarget();
    };
    JsonProtoSerializer.prototype.toListenRequestLabels = function (targetData) {
        var value = this.toLabel(targetData.purpose);
        if (value == null) {
            return null;
        }
        else {
            return {
                'goog-listen-tags': value
            };
        }
    };
    JsonProtoSerializer.prototype.toLabel = function (purpose) {
        switch (purpose) {
            case TargetPurpose.Listen:
                return null;
            case TargetPurpose.ExistenceFilterMismatch:
                return 'existence-filter-mismatch';
            case TargetPurpose.LimboResolution:
                return 'limbo-document';
            default:
                return fail('Unrecognized query purpose: ' + purpose);
        }
    };
    JsonProtoSerializer.prototype.toTarget = function (targetData) {
        var result;
        var target = targetData.target;
        if (target.isDocumentQuery()) {
            result = { documents: this.toDocumentsTarget(target) };
        }
        else {
            result = { query: this.toQueryTarget(target) };
        }
        result.targetId = targetData.targetId;
        if (targetData.resumeToken.length > 0) {
            result.resumeToken = this.unsafeCastProtoByteString(targetData.resumeToken);
        }
        return result;
    };
    JsonProtoSerializer.prototype.toFilter = function (filters) {
        var _this = this;
        if (filters.length === 0) {
            return;
        }
        var protos = filters.map(function (filter) {
            if (filter instanceof FieldFilter) {
                return _this.toUnaryOrFieldFilter(filter);
            }
            else {
                return fail('Unrecognized filter: ' + JSON.stringify(filter));
            }
        });
        if (protos.length === 1) {
            return protos[0];
        }
        return { compositeFilter: { op: 'AND', filters: protos } };
    };
    JsonProtoSerializer.prototype.fromFilter = function (filter) {
        var _this = this;
        if (!filter) {
            return [];
        }
        else if (filter.unaryFilter !== undefined) {
            return [this.fromUnaryFilter(filter)];
        }
        else if (filter.fieldFilter !== undefined) {
            return [this.fromFieldFilter(filter)];
        }
        else if (filter.compositeFilter !== undefined) {
            return filter.compositeFilter
                .filters.map(function (f) { return _this.fromFilter(f); })
                .reduce(function (accum, current) { return accum.concat(current); });
        }
        else {
            return fail('Unknown filter: ' + JSON.stringify(filter));
        }
    };
    JsonProtoSerializer.prototype.toOrder = function (orderBys) {
        var _this = this;
        if (orderBys.length === 0) {
            return;
        }
        return orderBys.map(function (order) { return _this.toPropertyOrder(order); });
    };
    JsonProtoSerializer.prototype.fromOrder = function (orderBys) {
        var _this = this;
        return orderBys.map(function (order) { return _this.fromPropertyOrder(order); });
    };
    JsonProtoSerializer.prototype.toCursor = function (cursor) {
        var _this = this;
        return {
            before: cursor.before,
            values: cursor.position.map(function (component) { return _this.toValue(component); })
        };
    };
    JsonProtoSerializer.prototype.fromCursor = function (cursor) {
        var _this = this;
        var before = !!cursor.before;
        var position = cursor.values.map(function (component) { return _this.fromValue(component); });
        return new Bound(position, before);
    };
    // visible for testing
    JsonProtoSerializer.prototype.toDirection = function (dir) {
        return DIRECTIONS[dir.name];
    };
    // visible for testing
    JsonProtoSerializer.prototype.fromDirection = function (dir) {
        switch (dir) {
            case 'ASCENDING':
                return Direction.ASCENDING;
            case 'DESCENDING':
                return Direction.DESCENDING;
            default:
                return undefined;
        }
    };
    // visible for testing
    JsonProtoSerializer.prototype.toOperatorName = function (op) {
        return OPERATORS[op.name];
    };
    JsonProtoSerializer.prototype.fromOperatorName = function (op) {
        switch (op) {
            case 'EQUAL':
                return Operator.EQUAL;
            case 'GREATER_THAN':
                return Operator.GREATER_THAN;
            case 'GREATER_THAN_OR_EQUAL':
                return Operator.GREATER_THAN_OR_EQUAL;
            case 'LESS_THAN':
                return Operator.LESS_THAN;
            case 'LESS_THAN_OR_EQUAL':
                return Operator.LESS_THAN_OR_EQUAL;
            case 'ARRAY_CONTAINS':
                return Operator.ARRAY_CONTAINS;
            case 'IN':
                return Operator.IN;
            case 'ARRAY_CONTAINS_ANY':
                return Operator.ARRAY_CONTAINS_ANY;
            case 'OPERATOR_UNSPECIFIED':
                return fail('Unspecified operator');
            default:
                return fail('Unknown operator');
        }
    };
    JsonProtoSerializer.prototype.toFieldPathReference = function (path) {
        return { fieldPath: path.canonicalString() };
    };
    JsonProtoSerializer.prototype.fromFieldPathReference = function (fieldReference) {
        return FieldPath.fromServerFormat(fieldReference.fieldPath);
    };
    // visible for testing
    JsonProtoSerializer.prototype.toPropertyOrder = function (orderBy) {
        return {
            field: this.toFieldPathReference(orderBy.field),
            direction: this.toDirection(orderBy.dir)
        };
    };
    JsonProtoSerializer.prototype.fromPropertyOrder = function (orderBy) {
        return new OrderBy(this.fromFieldPathReference(orderBy.field), this.fromDirection(orderBy.direction));
    };
    JsonProtoSerializer.prototype.fromFieldFilter = function (filter) {
        return FieldFilter.create(this.fromFieldPathReference(filter.fieldFilter.field), this.fromOperatorName(filter.fieldFilter.op), this.fromValue(filter.fieldFilter.value));
    };
    // visible for testing
    JsonProtoSerializer.prototype.toUnaryOrFieldFilter = function (filter) {
        if (filter.op === Operator.EQUAL) {
            if (filter.value.isEqual(DoubleValue.NAN)) {
                return {
                    unaryFilter: {
                        field: this.toFieldPathReference(filter.field),
                        op: 'IS_NAN'
                    }
                };
            }
            else if (filter.value.isEqual(NullValue.INSTANCE)) {
                return {
                    unaryFilter: {
                        field: this.toFieldPathReference(filter.field),
                        op: 'IS_NULL'
                    }
                };
            }
        }
        return {
            fieldFilter: {
                field: this.toFieldPathReference(filter.field),
                op: this.toOperatorName(filter.op),
                value: this.toValue(filter.value)
            }
        };
    };
    JsonProtoSerializer.prototype.fromUnaryFilter = function (filter) {
        switch (filter.unaryFilter.op) {
            case 'IS_NAN':
                var nanField = this.fromFieldPathReference(filter.unaryFilter.field);
                return FieldFilter.create(nanField, Operator.EQUAL, DoubleValue.NAN);
            case 'IS_NULL':
                var nullField = this.fromFieldPathReference(filter.unaryFilter.field);
                return FieldFilter.create(nullField, Operator.EQUAL, NullValue.INSTANCE);
            case 'OPERATOR_UNSPECIFIED':
                return fail('Unspecified filter');
            default:
                return fail('Unknown filter');
        }
    };
    JsonProtoSerializer.prototype.toDocumentMask = function (fieldMask) {
        var canonicalFields = [];
        fieldMask.fields.forEach(function (field) {
            return canonicalFields.push(field.canonicalString());
        });
        return {
            fieldPaths: canonicalFields
        };
    };
    JsonProtoSerializer.prototype.fromDocumentMask = function (proto) {
        var paths = proto.fieldPaths || [];
        var fields = paths.map(function (path) { return FieldPath.fromServerFormat(path); });
        return FieldMask.fromArray(fields);
    };
    return JsonProtoSerializer;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Holds the listeners and the last received ViewSnapshot for a query being
 * tracked by EventManager.
 */
var QueryListenersInfo = /** @class */ (function () {
    function QueryListenersInfo() {
        this.viewSnap = null;
        this.targetId = 0;
        this.listeners = [];
    }
    return QueryListenersInfo;
}());
/**
 * EventManager is responsible for mapping queries to query event emitters.
 * It handles "fan-out". -- Identical queries will re-use the same watch on the
 * backend.
 */
var EventManager = /** @class */ (function () {
    function EventManager(syncEngine) {
        this.syncEngine = syncEngine;
        this.queries = new ObjectMap(function (q) {
            return q.canonicalId();
        });
        this.onlineState = OnlineState.Unknown;
        this.snapshotsInSyncListeners = new Set();
        this.syncEngine.subscribe(this);
    }
    EventManager.prototype.listen = function (listener) {
        var query = listener.query;
        var firstListen = false;
        var queryInfo = this.queries.get(query);
        if (!queryInfo) {
            firstListen = true;
            queryInfo = new QueryListenersInfo();
            this.queries.set(query, queryInfo);
        }
        queryInfo.listeners.push(listener);
        // Run global snapshot listeners if a consistent snapshot has been emitted.
        var raisedEvent = listener.applyOnlineStateChange(this.onlineState);
        assert(!raisedEvent, "applyOnlineStateChange() shouldn't raise an event for brand-new listeners.");
        if (queryInfo.viewSnap) {
            var raisedEvent_1 = listener.onViewSnapshot(queryInfo.viewSnap);
            if (raisedEvent_1) {
                this.raiseSnapshotsInSyncEvent();
            }
        }
        if (firstListen) {
            return this.syncEngine.listen(query).then(function (targetId) {
                queryInfo.targetId = targetId;
                return targetId;
            });
        }
        else {
            return Promise.resolve(queryInfo.targetId);
        }
    };
    EventManager.prototype.unlisten = function (listener) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var query, lastListen, queryInfo, i;
            return tslib.__generator(this, function (_a) {
                query = listener.query;
                lastListen = false;
                queryInfo = this.queries.get(query);
                if (queryInfo) {
                    i = queryInfo.listeners.indexOf(listener);
                    if (i >= 0) {
                        queryInfo.listeners.splice(i, 1);
                        lastListen = queryInfo.listeners.length === 0;
                    }
                }
                if (lastListen) {
                    this.queries.delete(query);
                    return [2 /*return*/, this.syncEngine.unlisten(query)];
                }
                return [2 /*return*/];
            });
        });
    };
    EventManager.prototype.onWatchChange = function (viewSnaps) {
        var raisedEvent = false;
        for (var _i = 0, viewSnaps_1 = viewSnaps; _i < viewSnaps_1.length; _i++) {
            var viewSnap = viewSnaps_1[_i];
            var query = viewSnap.query;
            var queryInfo = this.queries.get(query);
            if (queryInfo) {
                for (var _a = 0, _b = queryInfo.listeners; _a < _b.length; _a++) {
                    var listener = _b[_a];
                    if (listener.onViewSnapshot(viewSnap)) {
                        raisedEvent = true;
                    }
                }
                queryInfo.viewSnap = viewSnap;
            }
        }
        if (raisedEvent) {
            this.raiseSnapshotsInSyncEvent();
        }
    };
    EventManager.prototype.onWatchError = function (query, error) {
        var queryInfo = this.queries.get(query);
        if (queryInfo) {
            for (var _i = 0, _a = queryInfo.listeners; _i < _a.length; _i++) {
                var listener = _a[_i];
                listener.onError(error);
            }
        }
        // Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
        // after an error.
        this.queries.delete(query);
    };
    EventManager.prototype.onOnlineStateChange = function (onlineState) {
        this.onlineState = onlineState;
        var raisedEvent = false;
        this.queries.forEach(function (_, queryInfo) {
            for (var _i = 0, _a = queryInfo.listeners; _i < _a.length; _i++) {
                var listener = _a[_i];
                // Run global snapshot listeners if a consistent snapshot has been emitted.
                if (listener.applyOnlineStateChange(onlineState)) {
                    raisedEvent = true;
                }
            }
        });
        if (raisedEvent) {
            this.raiseSnapshotsInSyncEvent();
        }
    };
    EventManager.prototype.addSnapshotsInSyncListener = function (observer) {
        this.snapshotsInSyncListeners.add(observer);
        // Immediately fire an initial event, indicating all existing listeners
        // are in-sync.
        observer.next();
    };
    EventManager.prototype.removeSnapshotsInSyncListener = function (observer) {
        this.snapshotsInSyncListeners.delete(observer);
    };
    // Call all global snapshot listeners that have been set.
    EventManager.prototype.raiseSnapshotsInSyncEvent = function () {
        this.snapshotsInSyncListeners.forEach(function (observer) {
            observer.next();
        });
    };
    return EventManager;
}());
/**
 * QueryListener takes a series of internal view snapshots and determines
 * when to raise the event.
 *
 * It uses an Observer to dispatch events.
 */
var QueryListener = /** @class */ (function () {
    function QueryListener(query, queryObserver, options) {
        this.query = query;
        this.queryObserver = queryObserver;
        /**
         * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
         * observer. This flag is set to true once we've actually raised an event.
         */
        this.raisedInitialEvent = false;
        this.snap = null;
        this.onlineState = OnlineState.Unknown;
        this.options = options || {};
    }
    /**
     * Applies the new ViewSnapshot to this listener, raising a user-facing event
     * if applicable (depending on what changed, whether the user has opted into
     * metadata-only changes, etc.). Returns true if a user-facing event was
     * indeed raised.
     */
    QueryListener.prototype.onViewSnapshot = function (snap) {
        assert(snap.docChanges.length > 0 || snap.syncStateChanged, 'We got a new snapshot with no changes?');
        if (!this.options.includeMetadataChanges) {
            // Remove the metadata only changes.
            var docChanges = [];
            for (var _i = 0, _a = snap.docChanges; _i < _a.length; _i++) {
                var docChange = _a[_i];
                if (docChange.type !== ChangeType.Metadata) {
                    docChanges.push(docChange);
                }
            }
            snap = new ViewSnapshot(snap.query, snap.docs, snap.oldDocs, docChanges, snap.mutatedKeys, snap.fromCache, snap.syncStateChanged, 
            /* excludesMetadataChanges= */ true);
        }
        var raisedEvent = false;
        if (!this.raisedInitialEvent) {
            if (this.shouldRaiseInitialEvent(snap, this.onlineState)) {
                this.raiseInitialEvent(snap);
                raisedEvent = true;
            }
        }
        else if (this.shouldRaiseEvent(snap)) {
            this.queryObserver.next(snap);
            raisedEvent = true;
        }
        this.snap = snap;
        return raisedEvent;
    };
    QueryListener.prototype.onError = function (error) {
        this.queryObserver.error(error);
    };
    /** Returns whether a snapshot was raised. */
    QueryListener.prototype.applyOnlineStateChange = function (onlineState) {
        this.onlineState = onlineState;
        var raisedEvent = false;
        if (this.snap &&
            !this.raisedInitialEvent &&
            this.shouldRaiseInitialEvent(this.snap, onlineState)) {
            this.raiseInitialEvent(this.snap);
            raisedEvent = true;
        }
        return raisedEvent;
    };
    QueryListener.prototype.shouldRaiseInitialEvent = function (snap, onlineState) {
        assert(!this.raisedInitialEvent, 'Determining whether to raise first event but already had first event');
        // Always raise the first event when we're synced
        if (!snap.fromCache) {
            return true;
        }
        // NOTE: We consider OnlineState.Unknown as online (it should become Offline
        // or Online if we wait long enough).
        var maybeOnline = onlineState !== OnlineState.Offline;
        // Don't raise the event if we're online, aren't synced yet (checked
        // above) and are waiting for a sync.
        if (this.options.waitForSyncWhenOnline && maybeOnline) {
            assert(snap.fromCache, 'Waiting for sync, but snapshot is not from cache');
            return false;
        }
        // Raise data from cache if we have any documents or we are offline
        return !snap.docs.isEmpty() || onlineState === OnlineState.Offline;
    };
    QueryListener.prototype.shouldRaiseEvent = function (snap) {
        // We don't need to handle includeDocumentMetadataChanges here because
        // the Metadata only changes have already been stripped out if needed.
        // At this point the only changes we will see are the ones we should
        // propagate.
        if (snap.docChanges.length > 0) {
            return true;
        }
        var hasPendingWritesChanged = this.snap && this.snap.hasPendingWrites !== snap.hasPendingWrites;
        if (snap.syncStateChanged || hasPendingWritesChanged) {
            return this.options.includeMetadataChanges === true;
        }
        // Generally we should have hit one of the cases above, but it's possible
        // to get here if there were only metadata docChanges and they got
        // stripped out.
        return false;
    };
    QueryListener.prototype.raiseInitialEvent = function (snap) {
        assert(!this.raisedInitialEvent, 'Trying to raise initial events for second time');
        snap = ViewSnapshot.fromInitialDocuments(snap.query, snap.docs, snap.mutatedKeys, snap.fromCache);
        this.raisedInitialEvent = true;
        this.queryObserver.next(snap);
    };
    return QueryListener;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A set of changes to what documents are currently in view and out of view for
 * a given query. These changes are sent to the LocalStore by the View (via
 * the SyncEngine) and are used to pin / unpin documents as appropriate.
 */
var LocalViewChanges = /** @class */ (function () {
    function LocalViewChanges(targetId, fromCache, addedKeys, removedKeys) {
        this.targetId = targetId;
        this.fromCache = fromCache;
        this.addedKeys = addedKeys;
        this.removedKeys = removedKeys;
    }
    LocalViewChanges.fromSnapshot = function (targetId, viewSnapshot) {
        var addedKeys = documentKeySet();
        var removedKeys = documentKeySet();
        for (var _i = 0, _a = viewSnapshot.docChanges; _i < _a.length; _i++) {
            var docChange = _a[_i];
            switch (docChange.type) {
                case ChangeType.Added:
                    addedKeys = addedKeys.add(docChange.doc.key);
                    break;
                case ChangeType.Removed:
                    removedKeys = removedKeys.add(docChange.doc.key);
                    break;
                // do nothing
            }
        }
        return new LocalViewChanges(targetId, viewSnapshot.fromCache, addedKeys, removedKeys);
    };
    return LocalViewChanges;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var AddedLimboDocument = /** @class */ (function () {
    function AddedLimboDocument(key) {
        this.key = key;
    }
    return AddedLimboDocument;
}());
var RemovedLimboDocument = /** @class */ (function () {
    function RemovedLimboDocument(key) {
        this.key = key;
    }
    return RemovedLimboDocument;
}());
/**
 * View is responsible for computing the final merged truth of what docs are in
 * a query. It gets notified of local and remote changes to docs, and applies
 * the query filters and limits to determine the most correct possible results.
 */
var View = /** @class */ (function () {
    function View(query, 
    /** Documents included in the remote target */
    _syncedDocuments) {
        this.query = query;
        this._syncedDocuments = _syncedDocuments;
        this.syncState = null;
        /**
         * A flag whether the view is current with the backend. A view is considered
         * current after it has seen the current flag from the backend and did not
         * lose consistency within the watch stream (e.g. because of an existence
         * filter mismatch).
         */
        this.current = false;
        /** Documents in the view but not in the remote target */
        this.limboDocuments = documentKeySet();
        /** Document Keys that have local changes */
        this.mutatedKeys = documentKeySet();
        this.documentSet = new DocumentSet(query.docComparator.bind(query));
    }
    Object.defineProperty(View.prototype, "syncedDocuments", {
        /**
         * The set of remote documents that the server has told us belongs to the target associated with
         * this view.
         */
        get: function () {
            return this._syncedDocuments;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Iterates over a set of doc changes, applies the query limit, and computes
     * what the new results should be, what the changes were, and whether we may
     * need to go back to the local cache for more results. Does not make any
     * changes to the view.
     * @param docChanges The doc changes to apply to this view.
     * @param previousChanges If this is being called with a refill, then start
     *        with this set of docs and changes instead of the current view.
     * @return a new set of docs, changes, and refill flag.
     */
    View.prototype.computeDocChanges = function (docChanges, previousChanges) {
        var _this = this;
        var changeSet = previousChanges
            ? previousChanges.changeSet
            : new DocumentChangeSet();
        var oldDocumentSet = previousChanges
            ? previousChanges.documentSet
            : this.documentSet;
        var newMutatedKeys = previousChanges
            ? previousChanges.mutatedKeys
            : this.mutatedKeys;
        var newDocumentSet = oldDocumentSet;
        var needsRefill = false;
        // Track the last doc in a (full) limit. This is necessary, because some
        // update (a delete, or an update moving a doc past the old limit) might
        // mean there is some other document in the local cache that either should
        // come (1) between the old last limit doc and the new last document, in the
        // case of updates, or (2) after the new last document, in the case of
        // deletes. So we keep this doc at the old limit to compare the updates to.
        //
        // Note that this should never get used in a refill (when previousChanges is
        // set), because there will only be adds -- no deletes or updates.
        var lastDocInLimit = this.query.hasLimitToFirst() && oldDocumentSet.size === this.query.limit
            ? oldDocumentSet.last()
            : null;
        var firstDocInLimit = this.query.hasLimitToLast() && oldDocumentSet.size === this.query.limit
            ? oldDocumentSet.first()
            : null;
        docChanges.inorderTraversal(function (key, newMaybeDoc) {
            var oldDoc = oldDocumentSet.get(key);
            var newDoc = newMaybeDoc instanceof Document ? newMaybeDoc : null;
            if (newDoc) {
                assert(key.isEqual(newDoc.key), 'Mismatching keys found in document changes: ' +
                    key +
                    ' != ' +
                    newDoc.key);
                newDoc = _this.query.matches(newDoc) ? newDoc : null;
            }
            var oldDocHadPendingMutations = oldDoc
                ? _this.mutatedKeys.has(oldDoc.key)
                : false;
            var newDocHasPendingMutations = newDoc
                ? newDoc.hasLocalMutations ||
                    // We only consider committed mutations for documents that were
                    // mutated during the lifetime of the view.
                    (_this.mutatedKeys.has(newDoc.key) && newDoc.hasCommittedMutations)
                : false;
            var changeApplied = false;
            // Calculate change
            if (oldDoc && newDoc) {
                var docsEqual = oldDoc.data().isEqual(newDoc.data());
                if (!docsEqual) {
                    if (!_this.shouldWaitForSyncedDocument(oldDoc, newDoc)) {
                        changeSet.track({
                            type: ChangeType.Modified,
                            doc: newDoc
                        });
                        changeApplied = true;
                        if ((lastDocInLimit &&
                            _this.query.docComparator(newDoc, lastDocInLimit) > 0) ||
                            (firstDocInLimit &&
                                _this.query.docComparator(newDoc, firstDocInLimit) < 0)) {
                            // This doc moved from inside the limit to outside the limit.
                            // That means there may be some other doc in the local cache
                            // that should be included instead.
                            needsRefill = true;
                        }
                    }
                }
                else if (oldDocHadPendingMutations !== newDocHasPendingMutations) {
                    changeSet.track({ type: ChangeType.Metadata, doc: newDoc });
                    changeApplied = true;
                }
            }
            else if (!oldDoc && newDoc) {
                changeSet.track({ type: ChangeType.Added, doc: newDoc });
                changeApplied = true;
            }
            else if (oldDoc && !newDoc) {
                changeSet.track({ type: ChangeType.Removed, doc: oldDoc });
                changeApplied = true;
                if (lastDocInLimit || firstDocInLimit) {
                    // A doc was removed from a full limit query. We'll need to
                    // requery from the local cache to see if we know about some other
                    // doc that should be in the results.
                    needsRefill = true;
                }
            }
            if (changeApplied) {
                if (newDoc) {
                    newDocumentSet = newDocumentSet.add(newDoc);
                    if (newDocHasPendingMutations) {
                        newMutatedKeys = newMutatedKeys.add(key);
                    }
                    else {
                        newMutatedKeys = newMutatedKeys.delete(key);
                    }
                }
                else {
                    newDocumentSet = newDocumentSet.delete(key);
                    newMutatedKeys = newMutatedKeys.delete(key);
                }
            }
        });
        // Drop documents out to meet limit/limitToLast requirement.
        if (this.query.hasLimitToFirst() || this.query.hasLimitToLast()) {
            while (newDocumentSet.size > this.query.limit) {
                var oldDoc = this.query.hasLimitToFirst()
                    ? newDocumentSet.last()
                    : newDocumentSet.first();
                newDocumentSet = newDocumentSet.delete(oldDoc.key);
                newMutatedKeys = newMutatedKeys.delete(oldDoc.key);
                changeSet.track({ type: ChangeType.Removed, doc: oldDoc });
            }
        }
        assert(!needsRefill || !previousChanges, 'View was refilled using docs that themselves needed refilling.');
        return {
            documentSet: newDocumentSet,
            changeSet: changeSet,
            needsRefill: needsRefill,
            mutatedKeys: newMutatedKeys
        };
    };
    View.prototype.shouldWaitForSyncedDocument = function (oldDoc, newDoc) {
        // We suppress the initial change event for documents that were modified as
        // part of a write acknowledgment (e.g. when the value of a server transform
        // is applied) as Watch will send us the same document again.
        // By suppressing the event, we only raise two user visible events (one with
        // `hasPendingWrites` and the final state of the document) instead of three
        // (one with `hasPendingWrites`, the modified document with
        // `hasPendingWrites` and the final state of the document).
        return (oldDoc.hasLocalMutations &&
            newDoc.hasCommittedMutations &&
            !newDoc.hasLocalMutations);
    };
    /**
     * Updates the view with the given ViewDocumentChanges and optionally updates
     * limbo docs and sync state from the provided target change.
     * @param docChanges The set of changes to make to the view's docs.
     * @param updateLimboDocuments Whether to update limbo documents based on this
     *        change.
     * @param targetChange A target change to apply for computing limbo docs and
     *        sync state.
     * @return A new ViewChange with the given docs, changes, and sync state.
     */
    // PORTING NOTE: The iOS/Android clients always compute limbo document changes.
    View.prototype.applyChanges = function (docChanges, updateLimboDocuments, targetChange) {
        var _this = this;
        assert(!docChanges.needsRefill, 'Cannot apply changes that need a refill');
        var oldDocs = this.documentSet;
        this.documentSet = docChanges.documentSet;
        this.mutatedKeys = docChanges.mutatedKeys;
        // Sort changes based on type and query comparator
        var changes = docChanges.changeSet.getChanges();
        changes.sort(function (c1, c2) {
            return (compareChangeType(c1.type, c2.type) ||
                _this.query.docComparator(c1.doc, c2.doc));
        });
        this.applyTargetChange(targetChange);
        var limboChanges = updateLimboDocuments
            ? this.updateLimboDocuments()
            : [];
        var synced = this.limboDocuments.size === 0 && this.current;
        var newSyncState = synced ? SyncState.Synced : SyncState.Local;
        var syncStateChanged = newSyncState !== this.syncState;
        this.syncState = newSyncState;
        if (changes.length === 0 && !syncStateChanged) {
            // no changes
            return { limboChanges: limboChanges };
        }
        else {
            var snap = new ViewSnapshot(this.query, docChanges.documentSet, oldDocs, changes, docChanges.mutatedKeys, newSyncState === SyncState.Local, syncStateChanged, 
            /* excludesMetadataChanges= */ false);
            return {
                snapshot: snap,
                limboChanges: limboChanges
            };
        }
    };
    /**
     * Applies an OnlineState change to the view, potentially generating a
     * ViewChange if the view's syncState changes as a result.
     */
    View.prototype.applyOnlineStateChange = function (onlineState) {
        if (this.current && onlineState === OnlineState.Offline) {
            // If we're offline, set `current` to false and then call applyChanges()
            // to refresh our syncState and generate a ViewChange as appropriate. We
            // are guaranteed to get a new TargetChange that sets `current` back to
            // true once the client is back online.
            this.current = false;
            return this.applyChanges({
                documentSet: this.documentSet,
                changeSet: new DocumentChangeSet(),
                mutatedKeys: this.mutatedKeys,
                needsRefill: false
            }, 
            /* updateLimboDocuments= */ false);
        }
        else {
            // No effect, just return a no-op ViewChange.
            return { limboChanges: [] };
        }
    };
    /**
     * Returns whether the doc for the given key should be in limbo.
     */
    View.prototype.shouldBeInLimbo = function (key) {
        // If the remote end says it's part of this query, it's not in limbo.
        if (this._syncedDocuments.has(key)) {
            return false;
        }
        // The local store doesn't think it's a result, so it shouldn't be in limbo.
        if (!this.documentSet.has(key)) {
            return false;
        }
        // If there are local changes to the doc, they might explain why the server
        // doesn't know that it's part of the query. So don't put it in limbo.
        // TODO(klimt): Ideally, we would only consider changes that might actually
        // affect this specific query.
        if (this.documentSet.get(key).hasLocalMutations) {
            return false;
        }
        // Everything else is in limbo.
        return true;
    };
    /**
     * Updates syncedDocuments, current, and limbo docs based on the given change.
     * Returns the list of changes to which docs are in limbo.
     */
    View.prototype.applyTargetChange = function (targetChange) {
        var _this = this;
        if (targetChange) {
            targetChange.addedDocuments.forEach(function (key) { return (_this._syncedDocuments = _this._syncedDocuments.add(key)); });
            targetChange.modifiedDocuments.forEach(function (key) {
                return assert(_this._syncedDocuments.has(key), "Modified document " + key + " not found in view.");
            });
            targetChange.removedDocuments.forEach(function (key) { return (_this._syncedDocuments = _this._syncedDocuments.delete(key)); });
            this.current = targetChange.current;
        }
    };
    View.prototype.updateLimboDocuments = function () {
        var _this = this;
        // We can only determine limbo documents when we're in-sync with the server.
        if (!this.current) {
            return [];
        }
        // TODO(klimt): Do this incrementally so that it's not quadratic when
        // updating many documents.
        var oldLimboDocuments = this.limboDocuments;
        this.limboDocuments = documentKeySet();
        this.documentSet.forEach(function (doc) {
            if (_this.shouldBeInLimbo(doc.key)) {
                _this.limboDocuments = _this.limboDocuments.add(doc.key);
            }
        });
        // Diff the new limbo docs with the old limbo docs.
        var changes = [];
        oldLimboDocuments.forEach(function (key) {
            if (!_this.limboDocuments.has(key)) {
                changes.push(new RemovedLimboDocument(key));
            }
        });
        this.limboDocuments.forEach(function (key) {
            if (!oldLimboDocuments.has(key)) {
                changes.push(new AddedLimboDocument(key));
            }
        });
        return changes;
    };
    /**
     * Update the in-memory state of the current view with the state read from
     * persistence.
     *
     * We update the query view whenever a client's primary status changes:
     * - When a client transitions from primary to secondary, it can miss
     *   LocalStorage updates and its query views may temporarily not be
     *   synchronized with the state on disk.
     * - For secondary to primary transitions, the client needs to update the list
     *   of `syncedDocuments` since secondary clients update their query views
     *   based purely on synthesized RemoteEvents.
     *
     * @param queryResult.documents - The documents that match the query according
     * to the LocalStore.
     * @param queryResult.remoteKeys - The keys of the documents that match the
     * query according to the backend.
     *
     * @return The ViewChange that resulted from this synchronization.
     */
    // PORTING NOTE: Multi-tab only.
    View.prototype.synchronizeWithPersistedState = function (queryResult) {
        this._syncedDocuments = queryResult.remoteKeys;
        this.limboDocuments = documentKeySet();
        var docChanges = this.computeDocChanges(queryResult.documents);
        return this.applyChanges(docChanges, /*updateLimboDocuments=*/ true);
    };
    /**
     * Returns a view snapshot as if this query was just listened to. Contains
     * a document add for every existing document and the `fromCache` and
     * `hasPendingWrites` status of the already established view.
     */
    // PORTING NOTE: Multi-tab only.
    View.prototype.computeInitialSnapshot = function () {
        return ViewSnapshot.fromInitialDocuments(this.query, this.documentSet, this.mutatedKeys, this.syncState === SyncState.Local);
    };
    return View;
}());
function compareChangeType(c1, c2) {
    var order = function (change) {
        switch (change) {
            case ChangeType.Added:
                return 1;
            case ChangeType.Modified:
                return 2;
            case ChangeType.Metadata:
                // A metadata change is converted to a modified change at the public
                // api layer.  Since we sort by document key and then change type,
                // metadata and modified changes must be sorted equivalently.
                return 2;
            case ChangeType.Removed:
                return 0;
            default:
                return fail('Unknown ChangeType: ' + change);
        }
    };
    return order(c1) - order(c2);
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var RETRY_COUNT = 5;
/**
 * TransactionRunner encapsulates the logic needed to run and retry transactions
 * with backoff.
 */
var TransactionRunner = /** @class */ (function () {
    function TransactionRunner(asyncQueue, remoteStore, updateFunction, deferred) {
        this.asyncQueue = asyncQueue;
        this.remoteStore = remoteStore;
        this.updateFunction = updateFunction;
        this.deferred = deferred;
        this.retries = RETRY_COUNT;
        this.backoff = new ExponentialBackoff(this.asyncQueue, TimerId.RetryTransaction);
    }
    /** Runs the transaction and sets the result on deferred. */
    TransactionRunner.prototype.run = function () {
        this.runWithBackOff();
    };
    TransactionRunner.prototype.runWithBackOff = function () {
        var _this = this;
        this.backoff.backoffAndRun(function () { return tslib.__awaiter(_this, void 0, void 0, function () {
            var transaction, userPromise;
            var _this = this;
            return tslib.__generator(this, function (_a) {
                transaction = this.remoteStore.createTransaction();
                userPromise = this.tryRunUpdateFunction(transaction);
                if (userPromise) {
                    userPromise
                        .then(function (result) {
                        _this.asyncQueue.enqueueAndForget(function () {
                            return transaction
                                .commit()
                                .then(function () {
                                _this.deferred.resolve(result);
                            })
                                .catch(function (commitError) {
                                _this.handleTransactionError(commitError);
                            });
                        });
                    })
                        .catch(function (userPromiseError) {
                        _this.handleTransactionError(userPromiseError);
                    });
                }
                return [2 /*return*/];
            });
        }); });
    };
    TransactionRunner.prototype.tryRunUpdateFunction = function (transaction) {
        try {
            var userPromise = this.updateFunction(transaction);
            if (isNullOrUndefined(userPromise) ||
                !userPromise.catch ||
                !userPromise.then) {
                this.deferred.reject(Error('Transaction callback must return a Promise'));
                return null;
            }
            return userPromise;
        }
        catch (error) {
            // Do not retry errors thrown by user provided updateFunction.
            this.deferred.reject(error);
            return null;
        }
    };
    TransactionRunner.prototype.handleTransactionError = function (error) {
        var _this = this;
        if (this.retries > 0 && this.isRetryableTransactionError(error)) {
            this.retries -= 1;
            this.asyncQueue.enqueueAndForget(function () {
                _this.runWithBackOff();
                return Promise.resolve();
            });
        }
        else {
            this.deferred.reject(error);
        }
    };
    TransactionRunner.prototype.isRetryableTransactionError = function (error) {
        if (error.name === 'FirebaseError') {
            // In transactions, the backend will fail outdated reads with FAILED_PRECONDITION and
            // non-matching document versions with ABORTED. These errors should be retried.
            var code = error.code;
            return (code === 'aborted' ||
                code === 'failed-precondition' ||
                !isPermanentError(code));
        }
        return false;
    };
    return TransactionRunner;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$9 = 'SyncEngine';
/**
 * QueryView contains all of the data that SyncEngine needs to keep track of for
 * a particular query.
 */
var QueryView = /** @class */ (function () {
    function QueryView(
    /**
     * The query itself.
     */
    query, 
    /**
     * The target number created by the client that is used in the watch
     * stream to identify this query.
     */
    targetId, 
    /**
     * The view is responsible for computing the final merged truth of what
     * docs are in the query. It gets notified of local and remote changes,
     * and applies the query filters and limits to determine the most correct
     * possible results.
     */
    view) {
        this.query = query;
        this.targetId = targetId;
        this.view = view;
    }
    return QueryView;
}());
/** Tracks a limbo resolution. */
var LimboResolution = /** @class */ (function () {
    function LimboResolution(key) {
        this.key = key;
        /**
         * Set to true once we've received a document. This is used in
         * getRemoteKeysForTarget() and ultimately used by WatchChangeAggregator to
         * decide whether it needs to manufacture a delete event for the target once
         * the target is CURRENT.
         */
        this.receivedDocument = false;
    }
    return LimboResolution;
}());
/**
 * SyncEngine is the central controller in the client SDK architecture. It is
 * the glue code between the EventManager, LocalStore, and RemoteStore. Some of
 * SyncEngine's responsibilities include:
 * 1. Coordinating client requests and remote events between the EventManager
 *    and the local and remote data stores.
 * 2. Managing a View object for each query, providing the unified view between
 *    the local and remote data stores.
 * 3. Notifying the RemoteStore when the LocalStore has new mutations in its
 *    queue that need sending to the backend.
 *
 * The SyncEngine’s methods should only ever be called by methods running in the
 * global async queue.
 */
var SyncEngine = /** @class */ (function () {
    function SyncEngine(localStore, remoteStore, 
    // PORTING NOTE: Manages state synchronization in multi-tab environments.
    sharedClientState, currentUser) {
        this.localStore = localStore;
        this.remoteStore = remoteStore;
        this.sharedClientState = sharedClientState;
        this.currentUser = currentUser;
        this.syncEngineListener = null;
        this.queryViewsByQuery = new ObjectMap(function (q) {
            return q.canonicalId();
        });
        this.queriesByTarget = {};
        this.limboTargetsByKey = new SortedMap(DocumentKey.comparator);
        this.limboResolutionsByTarget = {};
        this.limboDocumentRefs = new ReferenceSet();
        /** Stores user completion handlers, indexed by User and BatchId. */
        this.mutationUserCallbacks = {};
        /** Stores user callbacks waiting for all pending writes to be acknowledged. */
        this.pendingWritesCallbacks = new Map();
        this.limboTargetIdGenerator = TargetIdGenerator.forSyncEngine();
        // The primary state is set to `true` or `false` immediately after Firestore
        // startup. In the interim, a client should only be considered primary if
        // `isPrimary` is true.
        this.isPrimary = undefined;
        this.onlineState = OnlineState.Unknown;
    }
    Object.defineProperty(SyncEngine.prototype, "isPrimaryClient", {
        // Only used for testing.
        get: function () {
            return this.isPrimary === true;
        },
        enumerable: true,
        configurable: true
    });
    /** Subscribes to SyncEngine notifications. Has to be called exactly once. */
    SyncEngine.prototype.subscribe = function (syncEngineListener) {
        assert(syncEngineListener !== null, 'SyncEngine listener cannot be null');
        assert(this.syncEngineListener === null, 'SyncEngine already has a subscriber.');
        this.syncEngineListener = syncEngineListener;
    };
    /**
     * Initiates the new listen, resolves promise when listen enqueued to the
     * server. All the subsequent view snapshots or errors are sent to the
     * subscribed handlers. Returns the targetId of the query.
     */
    SyncEngine.prototype.listen = function (query) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var targetId, viewSnapshot, queryView, targetData, status_1;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.assertSubscribed('listen()');
                        queryView = this.queryViewsByQuery.get(query);
                        if (!queryView) return [3 /*break*/, 1];
                        // PORTING NOTE: With Multi-Tab Web, it is possible that a query view
                        // already exists when EventManager calls us for the first time. This
                        // happens when the primary tab is already listening to this query on
                        // behalf of another tab and the user of the primary also starts listening
                        // to the query. EventManager will not have an assigned target ID in this
                        // case and calls `listen` to obtain this ID.
                        targetId = queryView.targetId;
                        this.sharedClientState.addLocalQueryTarget(targetId);
                        viewSnapshot = queryView.view.computeInitialSnapshot();
                        return [3 /*break*/, 4];
                    case 1: return [4 /*yield*/, this.localStore.allocateTarget(query.toTarget())];
                    case 2:
                        targetData = _a.sent();
                        status_1 = this.sharedClientState.addLocalQueryTarget(targetData.targetId);
                        targetId = targetData.targetId;
                        return [4 /*yield*/, this.initializeViewAndComputeSnapshot(query, targetId, status_1 === 'current')];
                    case 3:
                        viewSnapshot = _a.sent();
                        if (this.isPrimary) {
                            this.remoteStore.listen(targetData);
                        }
                        _a.label = 4;
                    case 4:
                        this.syncEngineListener.onWatchChange([viewSnapshot]);
                        return [2 /*return*/, targetId];
                }
            });
        });
    };
    /**
     * Registers a view for a previously unknown query and computes its initial
     * snapshot.
     */
    SyncEngine.prototype.initializeViewAndComputeSnapshot = function (query, targetId, current) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var queryResult, view, viewDocChanges, synthesizedTargetChange, viewChange, data;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.localStore.executeQuery(query, 
                        /* usePreviousResults= */ true)];
                    case 1:
                        queryResult = _a.sent();
                        view = new View(query, queryResult.remoteKeys);
                        viewDocChanges = view.computeDocChanges(queryResult.documents);
                        synthesizedTargetChange = TargetChange.createSynthesizedTargetChangeForCurrentChange(targetId, current && this.onlineState !== OnlineState.Offline);
                        viewChange = view.applyChanges(viewDocChanges, 
                        /* updateLimboDocuments= */ this.isPrimary === true, synthesizedTargetChange);
                        assert(viewChange.limboChanges.length === 0, 'View returned limbo docs before target ack from the server.');
                        assert(!!viewChange.snapshot, 'applyChanges for new view should always return a snapshot');
                        data = new QueryView(query, targetId, view);
                        this.queryViewsByQuery.set(query, data);
                        if (!this.queriesByTarget[targetId]) {
                            this.queriesByTarget[targetId] = [];
                        }
                        this.queriesByTarget[targetId].push(query);
                        return [2 /*return*/, viewChange.snapshot];
                }
            });
        });
    };
    /**
     * Reconcile the list of synced documents in an existing view with those
     * from persistence.
     */
    // PORTING NOTE: Multi-tab only.
    SyncEngine.prototype.synchronizeViewAndComputeSnapshot = function (queryView) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var queryResult, viewSnapshot;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.localStore.executeQuery(queryView.query, 
                        /* usePreviousResults= */ true)];
                    case 1:
                        queryResult = _a.sent();
                        viewSnapshot = queryView.view.synchronizeWithPersistedState(queryResult);
                        if (this.isPrimary) {
                            this.updateTrackedLimbos(queryView.targetId, viewSnapshot.limboChanges);
                        }
                        return [2 /*return*/, viewSnapshot];
                }
            });
        });
    };
    /** Stops listening to the query. */
    SyncEngine.prototype.unlisten = function (query) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var queryView, queries, targetRemainsActive;
            var _this = this;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.assertSubscribed('unlisten()');
                        queryView = this.queryViewsByQuery.get(query);
                        assert(!!queryView, 'Trying to unlisten on query not found:' + query);
                        queries = this.queriesByTarget[queryView.targetId];
                        if (queries.length > 1) {
                            this.queriesByTarget[queryView.targetId] = queries.filter(function (q) { return !q.isEqual(query); });
                            this.queryViewsByQuery.delete(query);
                            return [2 /*return*/];
                        }
                        if (!this.isPrimary) return [3 /*break*/, 3];
                        // We need to remove the local query target first to allow us to verify
                        // whether any other client is still interested in this target.
                        this.sharedClientState.removeLocalQueryTarget(queryView.targetId);
                        targetRemainsActive = this.sharedClientState.isActiveQueryTarget(queryView.targetId);
                        if (!!targetRemainsActive) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.localStore
                                .releaseTarget(queryView.targetId, /*keepPersistedTargetData=*/ false)
                                .then(function () {
                                _this.sharedClientState.clearQueryState(queryView.targetId);
                                _this.remoteStore.unlisten(queryView.targetId);
                                _this.removeAndCleanupTarget(queryView.targetId);
                            })
                                .catch(ignoreIfPrimaryLeaseLoss)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [3 /*break*/, 5];
                    case 3:
                        this.removeAndCleanupTarget(queryView.targetId);
                        return [4 /*yield*/, this.localStore.releaseTarget(queryView.targetId, 
                            /*keepPersistedTargetData=*/ true)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Initiates the write of local mutation batch which involves adding the
     * writes to the mutation queue, notifying the remote store about new
     * mutations and raising events for any changes this write caused.
     *
     * The promise returned by this call is resolved when the above steps
     * have completed, *not* when the write was acked by the backend. The
     * userCallback is resolved once the write was acked/rejected by the
     * backend (or failed locally for any other reason).
     */
    SyncEngine.prototype.write = function (batch, userCallback) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.assertSubscribed('write()');
                        return [4 /*yield*/, this.localStore.localWrite(batch)];
                    case 1:
                        result = _a.sent();
                        this.sharedClientState.addPendingMutation(result.batchId);
                        this.addMutationCallback(result.batchId, userCallback);
                        return [4 /*yield*/, this.emitNewSnapsAndNotifyLocalStore(result.changes)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.remoteStore.fillWritePipeline()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Takes an updateFunction in which a set of reads and writes can be performed
     * atomically. In the updateFunction, the client can read and write values
     * using the supplied transaction object. After the updateFunction, all
     * changes will be committed. If a retryable error occurs (ex: some other
     * client has changed any of the data referenced), then the updateFunction
     * will be called again after a backoff. If the updateFunction still fails
     * after all retries, then the transaction will be rejected.
     *
     * The transaction object passed to the updateFunction contains methods for
     * accessing documents and collections. Unlike other datastore access, data
     * accessed with the transaction will not reflect local changes that have not
     * been committed. For this reason, it is required that all reads are
     * performed before any writes. Transactions must be performed while online.
     *
     * The Deferred input is resolved when the transaction is fully committed.
     */
    SyncEngine.prototype.runTransaction = function (asyncQueue, updateFunction, deferred) {
        new TransactionRunner(asyncQueue, this.remoteStore, updateFunction, deferred).run();
    };
    SyncEngine.prototype.applyRemoteEvent = function (remoteEvent) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var changes, error_1;
            var _this = this;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.assertSubscribed('applyRemoteEvent()');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 6]);
                        return [4 /*yield*/, this.localStore.applyRemoteEvent(remoteEvent)];
                    case 2:
                        changes = _a.sent();
                        // Update `receivedDocument` as appropriate for any limbo targets.
                        forEach(remoteEvent.targetChanges, function (targetId, targetChange) {
                            var limboResolution = _this.limboResolutionsByTarget[Number(targetId)];
                            if (limboResolution) {
                                // Since this is a limbo resolution lookup, it's for a single document
                                // and it could be added, modified, or removed, but not a combination.
                                assert(targetChange.addedDocuments.size +
                                    targetChange.modifiedDocuments.size +
                                    targetChange.removedDocuments.size <=
                                    1, 'Limbo resolution for single document contains multiple changes.');
                                if (targetChange.addedDocuments.size > 0) {
                                    limboResolution.receivedDocument = true;
                                }
                                else if (targetChange.modifiedDocuments.size > 0) {
                                    assert(limboResolution.receivedDocument, 'Received change for limbo target document without add.');
                                }
                                else if (targetChange.removedDocuments.size > 0) {
                                    assert(limboResolution.receivedDocument, 'Received remove for limbo target document without add.');
                                    limboResolution.receivedDocument = false;
                                }
                            }
                        });
                        return [4 /*yield*/, this.emitNewSnapsAndNotifyLocalStore(changes, remoteEvent)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        error_1 = _a.sent();
                        return [4 /*yield*/, ignoreIfPrimaryLeaseLoss(error_1)];
                    case 5:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Applies an OnlineState change to the sync engine and notifies any views of
     * the change.
     */
    SyncEngine.prototype.applyOnlineStateChange = function (onlineState, source) {
        // If we are the secondary client, we explicitly ignore the remote store's
        // online state (the local client may go offline, even though the primary
        // tab remains online) and only apply the primary tab's online state from
        // SharedClientState.
        if ((this.isPrimary && source === OnlineStateSource.RemoteStore) ||
            (!this.isPrimary && source === OnlineStateSource.SharedClientState)) {
            this.assertSubscribed('applyOnlineStateChange()');
            var newViewSnapshots_1 = [];
            this.queryViewsByQuery.forEach(function (query, queryView) {
                var viewChange = queryView.view.applyOnlineStateChange(onlineState);
                assert(viewChange.limboChanges.length === 0, 'OnlineState should not affect limbo documents.');
                if (viewChange.snapshot) {
                    newViewSnapshots_1.push(viewChange.snapshot);
                }
            });
            this.syncEngineListener.onOnlineStateChange(onlineState);
            this.syncEngineListener.onWatchChange(newViewSnapshots_1);
            this.onlineState = onlineState;
            if (this.isPrimary) {
                this.sharedClientState.setOnlineState(onlineState);
            }
        }
    };
    SyncEngine.prototype.rejectListen = function (targetId, err) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var limboResolution, limboKey, documentUpdates, resolvedLimboDocuments, event_1;
            var _this = this;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.assertSubscribed('rejectListens()');
                        // PORTING NOTE: Multi-tab only.
                        this.sharedClientState.updateQueryState(targetId, 'rejected', err);
                        limboResolution = this.limboResolutionsByTarget[targetId];
                        limboKey = limboResolution && limboResolution.key;
                        if (!limboKey) return [3 /*break*/, 1];
                        // Since this query failed, we won't want to manually unlisten to it.
                        // So go ahead and remove it from bookkeeping.
                        this.limboTargetsByKey = this.limboTargetsByKey.remove(limboKey);
                        delete this.limboResolutionsByTarget[targetId];
                        documentUpdates = new SortedMap(DocumentKey.comparator);
                        documentUpdates = documentUpdates.insert(limboKey, new NoDocument(limboKey, SnapshotVersion.forDeletedDoc()));
                        resolvedLimboDocuments = documentKeySet().add(limboKey);
                        event_1 = new RemoteEvent(SnapshotVersion.MIN, 
                        /* targetChanges= */ {}, 
                        /* targetMismatches= */ new SortedSet(primitiveComparator), documentUpdates, resolvedLimboDocuments);
                        return [2 /*return*/, this.applyRemoteEvent(event_1)];
                    case 1: return [4 /*yield*/, this.localStore
                            .releaseTarget(targetId, /* keepPersistedTargetData */ false)
                            .then(function () { return _this.removeAndCleanupTarget(targetId, err); })
                            .catch(ignoreIfPrimaryLeaseLoss)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // PORTING NOTE: Multi-tab only
    SyncEngine.prototype.applyBatchState = function (batchId, batchState, error) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var documents;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.assertSubscribed('applyBatchState()');
                        return [4 /*yield*/, this.localStore.lookupMutationDocuments(batchId)];
                    case 1:
                        documents = _a.sent();
                        if (documents === null) {
                            // A throttled tab may not have seen the mutation before it was completed
                            // and removed from the mutation queue, in which case we won't have cached
                            // the affected documents. In this case we can safely ignore the update
                            // since that means we didn't apply the mutation locally at all (if we
                            // had, we would have cached the affected documents), and so we will just
                            // see any resulting document changes via normal remote document updates
                            // as applicable.
                            debug(LOG_TAG$9, 'Cannot apply mutation batch with id: ' + batchId);
                            return [2 /*return*/];
                        }
                        if (!(batchState === 'pending')) return [3 /*break*/, 3];
                        // If we are the primary client, we need to send this write to the
                        // backend. Secondary clients will ignore these writes since their remote
                        // connection is disabled.
                        return [4 /*yield*/, this.remoteStore.fillWritePipeline()];
                    case 2:
                        // If we are the primary client, we need to send this write to the
                        // backend. Secondary clients will ignore these writes since their remote
                        // connection is disabled.
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        if (batchState === 'acknowledged' || batchState === 'rejected') {
                            // NOTE: Both these methods are no-ops for batches that originated from
                            // other clients.
                            this.processUserCallback(batchId, error ? error : null);
                            this.localStore.removeCachedMutationBatchMetadata(batchId);
                        }
                        else {
                            fail("Unknown batchState: " + batchState);
                        }
                        _a.label = 4;
                    case 4: return [4 /*yield*/, this.emitNewSnapsAndNotifyLocalStore(documents)];
                    case 5:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SyncEngine.prototype.applySuccessfulWrite = function (mutationBatchResult) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var batchId, changes, error_2;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.assertSubscribed('applySuccessfulWrite()');
                        batchId = mutationBatchResult.batch.batchId;
                        // The local store may or may not be able to apply the write result and
                        // raise events immediately (depending on whether the watcher is caught
                        // up), so we raise user callbacks first so that they consistently happen
                        // before listen events.
                        this.processUserCallback(batchId, /*error=*/ null);
                        this.triggerPendingWritesCallbacks(batchId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 6]);
                        return [4 /*yield*/, this.localStore.acknowledgeBatch(mutationBatchResult)];
                    case 2:
                        changes = _a.sent();
                        this.sharedClientState.updateMutationState(batchId, 'acknowledged');
                        return [4 /*yield*/, this.emitNewSnapsAndNotifyLocalStore(changes)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        error_2 = _a.sent();
                        return [4 /*yield*/, ignoreIfPrimaryLeaseLoss(error_2)];
                    case 5:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    SyncEngine.prototype.rejectFailedWrite = function (batchId, error) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var changes, error_3;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.assertSubscribed('rejectFailedWrite()');
                        // The local store may or may not be able to apply the write result and
                        // raise events immediately (depending on whether the watcher is caught up),
                        // so we raise user callbacks first so that they consistently happen before
                        // listen events.
                        this.processUserCallback(batchId, error);
                        this.triggerPendingWritesCallbacks(batchId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 6]);
                        return [4 /*yield*/, this.localStore.rejectBatch(batchId)];
                    case 2:
                        changes = _a.sent();
                        this.sharedClientState.updateMutationState(batchId, 'rejected', error);
                        return [4 /*yield*/, this.emitNewSnapsAndNotifyLocalStore(changes)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        error_3 = _a.sent();
                        return [4 /*yield*/, ignoreIfPrimaryLeaseLoss(error_3)];
                    case 5:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Registers a user callback that resolves when all pending mutations at the moment of calling
     * are acknowledged .
     */
    SyncEngine.prototype.registerPendingWritesCallback = function (callback) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var highestBatchId, callbacks;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.remoteStore.canUseNetwork()) {
                            debug(LOG_TAG$9, 'The network is disabled. The task returned by ' +
                                "'awaitPendingWrites()' will not complete until the network is enabled.");
                        }
                        return [4 /*yield*/, this.localStore.getHighestUnacknowledgedBatchId()];
                    case 1:
                        highestBatchId = _a.sent();
                        if (highestBatchId === BATCHID_UNKNOWN) {
                            // Trigger the callback right away if there is no pending writes at the moment.
                            callback.resolve();
                            return [2 /*return*/];
                        }
                        callbacks = this.pendingWritesCallbacks.get(highestBatchId) || [];
                        callbacks.push(callback);
                        this.pendingWritesCallbacks.set(highestBatchId, callbacks);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Triggers the callbacks that are waiting for this batch id to get acknowledged by server,
     * if there are any.
     */
    SyncEngine.prototype.triggerPendingWritesCallbacks = function (batchId) {
        (this.pendingWritesCallbacks.get(batchId) || []).forEach(function (callback) {
            callback.resolve();
        });
        this.pendingWritesCallbacks.delete(batchId);
    };
    /** Reject all outstanding callbacks waiting for pending writes to complete. */
    SyncEngine.prototype.rejectOutstandingPendingWritesCallbacks = function (errorMessage) {
        this.pendingWritesCallbacks.forEach(function (callbacks) {
            callbacks.forEach(function (callback) {
                callback.reject(new FirestoreError(Code.CANCELLED, errorMessage));
            });
        });
        this.pendingWritesCallbacks.clear();
    };
    SyncEngine.prototype.addMutationCallback = function (batchId, callback) {
        var newCallbacks = this.mutationUserCallbacks[this.currentUser.toKey()];
        if (!newCallbacks) {
            newCallbacks = new SortedMap(primitiveComparator);
        }
        newCallbacks = newCallbacks.insert(batchId, callback);
        this.mutationUserCallbacks[this.currentUser.toKey()] = newCallbacks;
    };
    /**
     * Resolves or rejects the user callback for the given batch and then discards
     * it.
     */
    SyncEngine.prototype.processUserCallback = function (batchId, error) {
        var newCallbacks = this.mutationUserCallbacks[this.currentUser.toKey()];
        // NOTE: Mutations restored from persistence won't have callbacks, so it's
        // okay for there to be no callback for this ID.
        if (newCallbacks) {
            var callback = newCallbacks.get(batchId);
            if (callback) {
                assert(batchId === newCallbacks.minKey(), 'Mutation callbacks processed out-of-order?');
                if (error) {
                    callback.reject(error);
                }
                else {
                    callback.resolve();
                }
                newCallbacks = newCallbacks.remove(batchId);
            }
            this.mutationUserCallbacks[this.currentUser.toKey()] = newCallbacks;
        }
    };
    SyncEngine.prototype.removeAndCleanupTarget = function (targetId, error) {
        var _this = this;
        if (error === void 0) { error = null; }
        this.sharedClientState.removeLocalQueryTarget(targetId);
        assert(this.queriesByTarget[targetId] &&
            this.queriesByTarget[targetId].length !== 0, "There are no queries mapped to target id " + targetId);
        for (var _i = 0, _a = this.queriesByTarget[targetId]; _i < _a.length; _i++) {
            var query = _a[_i];
            this.queryViewsByQuery.delete(query);
            if (error) {
                this.syncEngineListener.onWatchError(query, error);
            }
        }
        delete this.queriesByTarget[targetId];
        if (this.isPrimary) {
            var limboKeys = this.limboDocumentRefs.referencesForId(targetId);
            this.limboDocumentRefs.removeReferencesForId(targetId);
            limboKeys.forEach(function (limboKey) {
                var isReferenced = _this.limboDocumentRefs.containsKey(limboKey);
                if (!isReferenced) {
                    // We removed the last reference for this key
                    _this.removeLimboTarget(limboKey);
                }
            });
        }
    };
    SyncEngine.prototype.removeLimboTarget = function (key) {
        // It's possible that the target already got removed because the query failed. In that case,
        // the key won't exist in `limboTargetsByKey`. Only do the cleanup if we still have the target.
        var limboTargetId = this.limboTargetsByKey.get(key);
        if (limboTargetId === null) {
            // This target already got removed, because the query failed.
            return;
        }
        this.remoteStore.unlisten(limboTargetId);
        this.limboTargetsByKey = this.limboTargetsByKey.remove(key);
        delete this.limboResolutionsByTarget[limboTargetId];
    };
    SyncEngine.prototype.updateTrackedLimbos = function (targetId, limboChanges) {
        for (var _i = 0, limboChanges_1 = limboChanges; _i < limboChanges_1.length; _i++) {
            var limboChange = limboChanges_1[_i];
            if (limboChange instanceof AddedLimboDocument) {
                this.limboDocumentRefs.addReference(limboChange.key, targetId);
                this.trackLimboChange(limboChange);
            }
            else if (limboChange instanceof RemovedLimboDocument) {
                debug(LOG_TAG$9, 'Document no longer in limbo: ' + limboChange.key);
                this.limboDocumentRefs.removeReference(limboChange.key, targetId);
                var isReferenced = this.limboDocumentRefs.containsKey(limboChange.key);
                if (!isReferenced) {
                    // We removed the last reference for this key
                    this.removeLimboTarget(limboChange.key);
                }
            }
            else {
                fail('Unknown limbo change: ' + JSON.stringify(limboChange));
            }
        }
    };
    SyncEngine.prototype.trackLimboChange = function (limboChange) {
        var key = limboChange.key;
        if (!this.limboTargetsByKey.get(key)) {
            debug(LOG_TAG$9, 'New document in limbo: ' + key);
            var limboTargetId = this.limboTargetIdGenerator.next();
            var query = Query.atPath(key.path);
            this.limboResolutionsByTarget[limboTargetId] = new LimboResolution(key);
            this.remoteStore.listen(new TargetData(query.toTarget(), limboTargetId, TargetPurpose.LimboResolution, ListenSequence.INVALID));
            this.limboTargetsByKey = this.limboTargetsByKey.insert(key, limboTargetId);
        }
    };
    // Visible for testing
    SyncEngine.prototype.currentLimboDocs = function () {
        return this.limboTargetsByKey;
    };
    SyncEngine.prototype.emitNewSnapsAndNotifyLocalStore = function (changes, remoteEvent) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var newSnaps, docChangesInAllViews, queriesProcessed;
            var _this = this;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        newSnaps = [];
                        docChangesInAllViews = [];
                        queriesProcessed = [];
                        this.queryViewsByQuery.forEach(function (_, queryView) {
                            queriesProcessed.push(Promise.resolve()
                                .then(function () {
                                var viewDocChanges = queryView.view.computeDocChanges(changes);
                                if (!viewDocChanges.needsRefill) {
                                    return viewDocChanges;
                                }
                                // The query has a limit and some docs were removed, so we need
                                // to re-run the query against the local store to make sure we
                                // didn't lose any good docs that had been past the limit.
                                return _this.localStore
                                    .executeQuery(queryView.query, /* usePreviousResults= */ false)
                                    .then(function (_a) {
                                    var documents = _a.documents;
                                    return queryView.view.computeDocChanges(documents, viewDocChanges);
                                });
                            })
                                .then(function (viewDocChanges) {
                                var targetChange = remoteEvent && remoteEvent.targetChanges[queryView.targetId];
                                var viewChange = queryView.view.applyChanges(viewDocChanges, 
                                /* updateLimboDocuments= */ _this.isPrimary === true, targetChange);
                                _this.updateTrackedLimbos(queryView.targetId, viewChange.limboChanges);
                                if (viewChange.snapshot) {
                                    if (_this.isPrimary) {
                                        _this.sharedClientState.updateQueryState(queryView.targetId, viewChange.snapshot.fromCache ? 'not-current' : 'current');
                                    }
                                    newSnaps.push(viewChange.snapshot);
                                    var docChanges = LocalViewChanges.fromSnapshot(queryView.targetId, viewChange.snapshot);
                                    docChangesInAllViews.push(docChanges);
                                }
                            }));
                        });
                        return [4 /*yield*/, Promise.all(queriesProcessed)];
                    case 1:
                        _a.sent();
                        this.syncEngineListener.onWatchChange(newSnaps);
                        return [4 /*yield*/, this.localStore.notifyLocalViewChanges(docChangesInAllViews)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SyncEngine.prototype.assertSubscribed = function (fnName) {
        assert(this.syncEngineListener !== null, 'Trying to call ' + fnName + ' before calling subscribe().');
    };
    SyncEngine.prototype.handleCredentialChange = function (user) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var userChanged, result;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        userChanged = !this.currentUser.isEqual(user);
                        this.currentUser = user;
                        if (!userChanged) return [3 /*break*/, 3];
                        // Fails tasks waiting for pending writes requested by previous user.
                        this.rejectOutstandingPendingWritesCallbacks("'waitForPendingWrites' promise is rejected due to a user change.");
                        return [4 /*yield*/, this.localStore.handleUserChange(user)];
                    case 1:
                        result = _a.sent();
                        // TODO(b/114226417): Consider calling this only in the primary tab.
                        this.sharedClientState.handleUserChange(user, result.removedBatchIds, result.addedBatchIds);
                        return [4 /*yield*/, this.emitNewSnapsAndNotifyLocalStore(result.affectedDocuments)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [4 /*yield*/, this.remoteStore.handleCredentialChange()];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // PORTING NOTE: Multi-tab only
    SyncEngine.prototype.applyPrimaryState = function (isPrimary) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var activeTargets, activeQueries, _i, activeQueries_1, targetData, activeTargets_1, p_1;
            var _this = this;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(isPrimary === true && this.isPrimary !== true)) return [3 /*break*/, 3];
                        this.isPrimary = true;
                        return [4 /*yield*/, this.remoteStore.applyPrimaryState(true)];
                    case 1:
                        _a.sent();
                        activeTargets = this.sharedClientState.getAllActiveQueryTargets();
                        return [4 /*yield*/, this.synchronizeQueryViewsAndRaiseSnapshots(activeTargets.toArray())];
                    case 2:
                        activeQueries = _a.sent();
                        for (_i = 0, activeQueries_1 = activeQueries; _i < activeQueries_1.length; _i++) {
                            targetData = activeQueries_1[_i];
                            this.remoteStore.listen(targetData);
                        }
                        return [3 /*break*/, 7];
                    case 3:
                        if (!(isPrimary === false && this.isPrimary !== false)) return [3 /*break*/, 7];
                        this.isPrimary = false;
                        activeTargets_1 = [];
                        p_1 = Promise.resolve();
                        forEachNumber(this.queriesByTarget, function (targetId, _) {
                            if (_this.sharedClientState.isLocalQueryTarget(targetId)) {
                                activeTargets_1.push(targetId);
                            }
                            else {
                                p_1 = p_1.then(function () {
                                    _this.removeAndCleanupTarget(targetId);
                                    return _this.localStore.releaseTarget(targetId, 
                                    /*keepPersistedTargetData=*/ true);
                                });
                            }
                            _this.remoteStore.unlisten(targetId);
                        });
                        return [4 /*yield*/, p_1];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.synchronizeQueryViewsAndRaiseSnapshots(activeTargets_1)];
                    case 5:
                        _a.sent();
                        this.resetLimboDocuments();
                        return [4 /*yield*/, this.remoteStore.applyPrimaryState(false)];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    // PORTING NOTE: Multi-tab only.
    SyncEngine.prototype.resetLimboDocuments = function () {
        var _this = this;
        forEachNumber(this.limboResolutionsByTarget, function (targetId) {
            _this.remoteStore.unlisten(targetId);
        });
        this.limboDocumentRefs.removeAllReferences();
        this.limboResolutionsByTarget = [];
        this.limboTargetsByKey = new SortedMap(DocumentKey.comparator);
    };
    /**
     * Reconcile the query views of the provided query targets with the state from
     * persistence. Raises snapshots for any changes that affect the local
     * client and returns the updated state of all target's query data.
     */
    // PORTING NOTE: Multi-tab only.
    SyncEngine.prototype.synchronizeQueryViewsAndRaiseSnapshots = function (targets) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var activeQueries, newViewSnapshots, _i, targets_1, targetId, targetData, queries, _a, queries_1, query, queryView, viewChange, target;
            return tslib.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        activeQueries = [];
                        newViewSnapshots = [];
                        _i = 0, targets_1 = targets;
                        _b.label = 1;
                    case 1:
                        if (!(_i < targets_1.length)) return [3 /*break*/, 14];
                        targetId = targets_1[_i];
                        targetData = void 0;
                        queries = this.queriesByTarget[targetId];
                        if (!(queries && queries.length !== 0)) return [3 /*break*/, 8];
                        // For queries that have a local View, we need to update their state
                        // in LocalStore (as the resume token and the snapshot version
                        // might have changed) and reconcile their views with the persisted
                        // state (the list of syncedDocuments may have gotten out of sync).
                        return [4 /*yield*/, this.localStore.releaseTarget(targetId, 
                            /*keepPersistedTargetData=*/ true)];
                    case 2:
                        // For queries that have a local View, we need to update their state
                        // in LocalStore (as the resume token and the snapshot version
                        // might have changed) and reconcile their views with the persisted
                        // state (the list of syncedDocuments may have gotten out of sync).
                        _b.sent();
                        return [4 /*yield*/, this.localStore.allocateTarget(queries[0].toTarget())];
                    case 3:
                        targetData = _b.sent();
                        _a = 0, queries_1 = queries;
                        _b.label = 4;
                    case 4:
                        if (!(_a < queries_1.length)) return [3 /*break*/, 7];
                        query = queries_1[_a];
                        queryView = this.queryViewsByQuery.get(query);
                        assert(!!queryView, "No query view found for " + query);
                        return [4 /*yield*/, this.synchronizeViewAndComputeSnapshot(queryView)];
                    case 5:
                        viewChange = _b.sent();
                        if (viewChange.snapshot) {
                            newViewSnapshots.push(viewChange.snapshot);
                        }
                        _b.label = 6;
                    case 6:
                        _a++;
                        return [3 /*break*/, 4];
                    case 7: return [3 /*break*/, 12];
                    case 8:
                        assert(this.isPrimary === true, 'A secondary tab should never have an active target without an active query.');
                        return [4 /*yield*/, this.localStore.getTarget(targetId)];
                    case 9:
                        target = _b.sent();
                        assert(!!target, "Target for id " + targetId + " not found");
                        return [4 /*yield*/, this.localStore.allocateTarget(target)];
                    case 10:
                        targetData = _b.sent();
                        return [4 /*yield*/, this.initializeViewAndComputeSnapshot(this.synthesizeTargetToQuery(target), targetId, 
                            /*current=*/ false)];
                    case 11:
                        _b.sent();
                        _b.label = 12;
                    case 12:
                        activeQueries.push(targetData);
                        _b.label = 13;
                    case 13:
                        _i++;
                        return [3 /*break*/, 1];
                    case 14:
                        this.syncEngineListener.onWatchChange(newViewSnapshots);
                        return [2 /*return*/, activeQueries];
                }
            });
        });
    };
    /**
     * Creates a `Query` object from the specified `Target`. There is no way to
     * obtain the original `Query`, so we synthesize a `Query` from the `Target`
     * object.
     *
     * The synthesized result might be different from the original `Query`, but
     * since the synthesized `Query` should return the same results as the
     * original one (only the presentation of results might differ), the potential
     * difference will not cause issues.
     */
    // PORTING NOTE: Multi-tab only
    SyncEngine.prototype.synthesizeTargetToQuery = function (target) {
        return new Query(target.path, target.collectionGroup, target.orderBy, target.filters, target.limit, LimitType.First, target.startAt, target.endAt);
    };
    // PORTING NOTE: Multi-tab only
    SyncEngine.prototype.getActiveClients = function () {
        return this.localStore.getActiveClients();
    };
    // PORTING NOTE: Multi-tab only
    SyncEngine.prototype.applyTargetState = function (targetId, state, error) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var _a, changes, synthesizedRemoteEvent;
            return tslib.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.isPrimary) {
                            // If we receive a target state notification via WebStorage, we are
                            // either already secondary or another tab has taken the primary lease.
                            debug(LOG_TAG$9, 'Ignoring unexpected query state notification.');
                            return [2 /*return*/];
                        }
                        if (!this.queriesByTarget[targetId]) return [3 /*break*/, 7];
                        _a = state;
                        switch (_a) {
                            case 'current': return [3 /*break*/, 1];
                            case 'not-current': return [3 /*break*/, 1];
                            case 'rejected': return [3 /*break*/, 4];
                        }
                        return [3 /*break*/, 6];
                    case 1: return [4 /*yield*/, this.localStore.getNewDocumentChanges()];
                    case 2:
                        changes = _b.sent();
                        synthesizedRemoteEvent = RemoteEvent.createSynthesizedRemoteEventForCurrentChange(targetId, state === 'current');
                        return [4 /*yield*/, this.emitNewSnapsAndNotifyLocalStore(changes, synthesizedRemoteEvent)];
                    case 3:
                        _b.sent();
                        return [3 /*break*/, 7];
                    case 4: return [4 /*yield*/, this.localStore.releaseTarget(targetId, 
                        /* keepPersistedTargetData */ true)];
                    case 5:
                        _b.sent();
                        this.removeAndCleanupTarget(targetId, error);
                        return [3 /*break*/, 7];
                    case 6:
                        fail('Unexpected target state: ' + state);
                        _b.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    // PORTING NOTE: Multi-tab only
    SyncEngine.prototype.applyActiveTargetsChange = function (added, removed) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var _i, added_1, targetId, target, targetData, _loop_1, this_1, _a, removed_1, targetId;
            var _this = this;
            return tslib.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.isPrimary) {
                            return [2 /*return*/];
                        }
                        _i = 0, added_1 = added;
                        _b.label = 1;
                    case 1:
                        if (!(_i < added_1.length)) return [3 /*break*/, 6];
                        targetId = added_1[_i];
                        assert(!this.queriesByTarget[targetId], 'Trying to add an already active target');
                        return [4 /*yield*/, this.localStore.getTarget(targetId)];
                    case 2:
                        target = _b.sent();
                        assert(!!target, "Query data for active target " + targetId + " not found");
                        return [4 /*yield*/, this.localStore.allocateTarget(target)];
                    case 3:
                        targetData = _b.sent();
                        return [4 /*yield*/, this.initializeViewAndComputeSnapshot(this.synthesizeTargetToQuery(target), targetData.targetId, 
                            /*current=*/ false)];
                    case 4:
                        _b.sent();
                        this.remoteStore.listen(targetData);
                        _b.label = 5;
                    case 5:
                        _i++;
                        return [3 /*break*/, 1];
                    case 6:
                        _loop_1 = function (targetId) {
                            return tslib.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        // Check that the target is still active since the target might have been
                                        // removed if it has been rejected by the backend.
                                        if (!this_1.queriesByTarget[targetId]) {
                                            return [2 /*return*/, "continue"];
                                        }
                                        // Release queries that are still active.
                                        return [4 /*yield*/, this_1.localStore
                                                .releaseTarget(targetId, /* keepPersistedTargetData */ false)
                                                .then(function () {
                                                _this.remoteStore.unlisten(targetId);
                                                _this.removeAndCleanupTarget(targetId);
                                            })
                                                .catch(ignoreIfPrimaryLeaseLoss)];
                                    case 1:
                                        // Release queries that are still active.
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _a = 0, removed_1 = removed;
                        _b.label = 7;
                    case 7:
                        if (!(_a < removed_1.length)) return [3 /*break*/, 10];
                        targetId = removed_1[_a];
                        return [5 /*yield**/, _loop_1(targetId)];
                    case 8:
                        _b.sent();
                        _b.label = 9;
                    case 9:
                        _a++;
                        return [3 /*break*/, 7];
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    // PORTING NOTE: Multi-tab only. In other clients, LocalStore is unaware of
    // the online state.
    SyncEngine.prototype.enableNetwork = function () {
        this.localStore.setNetworkEnabled(true);
        return this.remoteStore.enableNetwork();
    };
    // PORTING NOTE: Multi-tab only. In other clients, LocalStore is unaware of
    // the online state.
    SyncEngine.prototype.disableNetwork = function () {
        this.localStore.setNetworkEnabled(false);
        return this.remoteStore.disableNetwork();
    };
    SyncEngine.prototype.getRemoteKeysForTarget = function (targetId) {
        var limboResolution = this.limboResolutionsByTarget[targetId];
        if (limboResolution && limboResolution.receivedDocument) {
            return documentKeySet().add(limboResolution.key);
        }
        else {
            var keySet = documentKeySet();
            var queries = this.queriesByTarget[targetId];
            if (!queries) {
                return keySet;
            }
            for (var _i = 0, queries_2 = queries; _i < queries_2.length; _i++) {
                var query = queries_2[_i];
                var queryView = this.queryViewsByQuery.get(query);
                assert(!!queryView, "No query view found for " + query);
                keySet = keySet.unionWith(queryView.view.syncedDocuments);
            }
            return keySet;
        }
    };
    return SyncEngine;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Simple wrapper around a nullable UID. Mostly exists to make code more
 * readable.
 */
var User = /** @class */ (function () {
    function User(uid) {
        this.uid = uid;
    }
    User.prototype.isAuthenticated = function () {
        return this.uid != null;
    };
    /**
     * Returns a key representing this user, suitable for inclusion in a
     * dictionary.
     */
    User.prototype.toKey = function () {
        if (this.isAuthenticated()) {
            return 'uid:' + this.uid;
        }
        else {
            return 'anonymous-user';
        }
    };
    User.prototype.isEqual = function (otherUser) {
        return otherUser.uid === this.uid;
    };
    /** A user with a null UID. */
    User.UNAUTHENTICATED = new User(null);
    // TODO(mikelehen): Look into getting a proper uid-equivalent for
    // non-FirebaseAuth providers.
    User.GOOGLE_CREDENTIALS = new User('google-credentials-uid');
    User.FIRST_PARTY = new User('first-party-uid');
    return User;
}());

/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$a = 'SharedClientState';
// The format of the LocalStorage key that stores the client state is:
//     firestore_clients_<persistence_prefix>_<instance_key>
var CLIENT_STATE_KEY_PREFIX = 'firestore_clients';
// The format of the WebStorage key that stores the mutation state is:
//     firestore_mutations_<persistence_prefix>_<batch_id>
//     (for unauthenticated users)
// or: firestore_mutations_<persistence_prefix>_<batch_id>_<user_uid>
//
// 'user_uid' is last to avoid needing to escape '_' characters that it might
// contain.
var MUTATION_BATCH_KEY_PREFIX = 'firestore_mutations';
// The format of the WebStorage key that stores a query target's metadata is:
//     firestore_targets_<persistence_prefix>_<target_id>
var QUERY_TARGET_KEY_PREFIX = 'firestore_targets';
// The WebStorage prefix that stores the primary tab's online state. The
// format of the key is:
//     firestore_online_state_<persistence_prefix>
var ONLINE_STATE_KEY_PREFIX = 'firestore_online_state';
// The WebStorage key prefix for the key that stores the last sequence number allocated. The key
// looks like 'firestore_sequence_number_<persistence_prefix>'.
var SEQUENCE_NUMBER_KEY_PREFIX = 'firestore_sequence_number';
/**
 * Holds the state of a mutation batch, including its user ID, batch ID and
 * whether the batch is 'pending', 'acknowledged' or 'rejected'.
 */
// Visible for testing
var MutationMetadata = /** @class */ (function () {
    function MutationMetadata(user, batchId, state, error) {
        this.user = user;
        this.batchId = batchId;
        this.state = state;
        this.error = error;
        assert((error !== undefined) === (state === 'rejected'), "MutationMetadata must contain an error iff state is 'rejected'");
    }
    /**
     * Parses a MutationMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */
    MutationMetadata.fromWebStorageEntry = function (user, batchId, value) {
        var mutationBatch = JSON.parse(value);
        var validData = typeof mutationBatch === 'object' &&
            ['pending', 'acknowledged', 'rejected'].indexOf(mutationBatch.state) !==
                -1 &&
            (mutationBatch.error === undefined ||
                typeof mutationBatch.error === 'object');
        var firestoreError = undefined;
        if (validData && mutationBatch.error) {
            validData =
                typeof mutationBatch.error.message === 'string' &&
                    typeof mutationBatch.error.code === 'string';
            if (validData) {
                firestoreError = new FirestoreError(mutationBatch.error.code, mutationBatch.error.message);
            }
        }
        if (validData) {
            return new MutationMetadata(user, batchId, mutationBatch.state, firestoreError);
        }
        else {
            error(LOG_TAG$a, "Failed to parse mutation state for ID '" + batchId + "': " + value);
            return null;
        }
    };
    MutationMetadata.prototype.toWebStorageJSON = function () {
        var batchMetadata = {
            state: this.state,
            updateTimeMs: Date.now() // Modify the existing value to trigger update.
        };
        if (this.error) {
            batchMetadata.error = {
                code: this.error.code,
                message: this.error.message
            };
        }
        return JSON.stringify(batchMetadata);
    };
    return MutationMetadata;
}());
/**
 * Holds the state of a query target, including its target ID and whether the
 * target is 'not-current', 'current' or 'rejected'.
 */
// Visible for testing
var QueryTargetMetadata = /** @class */ (function () {
    function QueryTargetMetadata(targetId, state, error) {
        this.targetId = targetId;
        this.state = state;
        this.error = error;
        assert((error !== undefined) === (state === 'rejected'), "QueryTargetMetadata must contain an error iff state is 'rejected'");
    }
    /**
     * Parses a QueryTargetMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */
    QueryTargetMetadata.fromWebStorageEntry = function (targetId, value) {
        var targetState = JSON.parse(value);
        var validData = typeof targetState === 'object' &&
            ['not-current', 'current', 'rejected'].indexOf(targetState.state) !==
                -1 &&
            (targetState.error === undefined ||
                typeof targetState.error === 'object');
        var firestoreError = undefined;
        if (validData && targetState.error) {
            validData =
                typeof targetState.error.message === 'string' &&
                    typeof targetState.error.code === 'string';
            if (validData) {
                firestoreError = new FirestoreError(targetState.error.code, targetState.error.message);
            }
        }
        if (validData) {
            return new QueryTargetMetadata(targetId, targetState.state, firestoreError);
        }
        else {
            error(LOG_TAG$a, "Failed to parse target state for ID '" + targetId + "': " + value);
            return null;
        }
    };
    QueryTargetMetadata.prototype.toWebStorageJSON = function () {
        var targetState = {
            state: this.state,
            updateTimeMs: Date.now() // Modify the existing value to trigger update.
        };
        if (this.error) {
            targetState.error = {
                code: this.error.code,
                message: this.error.message
            };
        }
        return JSON.stringify(targetState);
    };
    return QueryTargetMetadata;
}());
/**
 * This class represents the immutable ClientState for a client read from
 * WebStorage, containing the list of active query targets.
 */
var RemoteClientState = /** @class */ (function () {
    function RemoteClientState(clientId, activeTargetIds) {
        this.clientId = clientId;
        this.activeTargetIds = activeTargetIds;
    }
    /**
     * Parses a RemoteClientState from the JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */
    RemoteClientState.fromWebStorageEntry = function (clientId, value) {
        var clientState = JSON.parse(value);
        var validData = typeof clientState === 'object' &&
            clientState.activeTargetIds instanceof Array;
        var activeTargetIdsSet = targetIdSet();
        for (var i = 0; validData && i < clientState.activeTargetIds.length; ++i) {
            validData = isSafeInteger(clientState.activeTargetIds[i]);
            activeTargetIdsSet = activeTargetIdsSet.add(clientState.activeTargetIds[i]);
        }
        if (validData) {
            return new RemoteClientState(clientId, activeTargetIdsSet);
        }
        else {
            error(LOG_TAG$a, "Failed to parse client data for instance '" + clientId + "': " + value);
            return null;
        }
    };
    return RemoteClientState;
}());
/**
 * This class represents the online state for all clients participating in
 * multi-tab. The online state is only written to by the primary client, and
 * used in secondary clients to update their query views.
 */
var SharedOnlineState = /** @class */ (function () {
    function SharedOnlineState(clientId, onlineState) {
        this.clientId = clientId;
        this.onlineState = onlineState;
    }
    /**
     * Parses a SharedOnlineState from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */
    SharedOnlineState.fromWebStorageEntry = function (value) {
        var onlineState = JSON.parse(value);
        var validData = typeof onlineState === 'object' &&
            onlineState.onlineState in OnlineState &&
            typeof onlineState.clientId === 'string';
        if (validData) {
            return new SharedOnlineState(onlineState.clientId, OnlineState[onlineState.onlineState]);
        }
        else {
            error(LOG_TAG$a, "Failed to parse online state: " + value);
            return null;
        }
    };
    return SharedOnlineState;
}());
/**
 * Metadata state of the local client. Unlike `RemoteClientState`, this class is
 * mutable and keeps track of all pending mutations, which allows us to
 * update the range of pending mutation batch IDs as new mutations are added or
 * removed.
 *
 * The data in `LocalClientState` is not read from WebStorage and instead
 * updated via its instance methods. The updated state can be serialized via
 * `toWebStorageJSON()`.
 */
// Visible for testing.
var LocalClientState = /** @class */ (function () {
    function LocalClientState() {
        this.activeTargetIds = targetIdSet();
    }
    LocalClientState.prototype.addQueryTarget = function (targetId) {
        this.activeTargetIds = this.activeTargetIds.add(targetId);
    };
    LocalClientState.prototype.removeQueryTarget = function (targetId) {
        this.activeTargetIds = this.activeTargetIds.delete(targetId);
    };
    /**
     * Converts this entry into a JSON-encoded format we can use for WebStorage.
     * Does not encode `clientId` as it is part of the key in WebStorage.
     */
    LocalClientState.prototype.toWebStorageJSON = function () {
        var data = {
            activeTargetIds: this.activeTargetIds.toArray(),
            updateTimeMs: Date.now() // Modify the existing value to trigger update.
        };
        return JSON.stringify(data);
    };
    return LocalClientState;
}());
/**
 * `WebStorageSharedClientState` uses WebStorage (window.localStorage) as the
 * backing store for the SharedClientState. It keeps track of all active
 * clients and supports modifications of the local client's data.
 */
var WebStorageSharedClientState = /** @class */ (function () {
    function WebStorageSharedClientState(queue, platform, persistenceKey, localClientId, initialUser) {
        this.queue = queue;
        this.platform = platform;
        this.persistenceKey = persistenceKey;
        this.localClientId = localClientId;
        this.syncEngine = null;
        this.onlineStateHandler = null;
        this.sequenceNumberHandler = null;
        this.activeClients = {};
        this.storageListener = this.handleWebStorageEvent.bind(this);
        this.started = false;
        /**
         * Captures WebStorage events that occur before `start()` is called. These
         * events are replayed once `WebStorageSharedClientState` is started.
         */
        this.earlyEvents = [];
        if (!WebStorageSharedClientState.isAvailable(this.platform)) {
            throw new FirestoreError(Code.UNIMPLEMENTED, 'LocalStorage is not available on this platform.');
        }
        // Escape the special characters mentioned here:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
        var escapedPersistenceKey = persistenceKey.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        this.storage = this.platform.window.localStorage;
        this.currentUser = initialUser;
        this.localClientStorageKey = this.toWebStorageClientStateKey(this.localClientId);
        this.sequenceNumberKey = SEQUENCE_NUMBER_KEY_PREFIX + "_" + persistenceKey;
        this.activeClients[this.localClientId] = new LocalClientState();
        this.clientStateKeyRe = new RegExp("^" + CLIENT_STATE_KEY_PREFIX + "_" + escapedPersistenceKey + "_([^_]*)$");
        this.mutationBatchKeyRe = new RegExp("^" + MUTATION_BATCH_KEY_PREFIX + "_" + escapedPersistenceKey + "_(\\d+)(?:_(.*))?$");
        this.queryTargetKeyRe = new RegExp("^" + QUERY_TARGET_KEY_PREFIX + "_" + escapedPersistenceKey + "_(\\d+)$");
        this.onlineStateKey = ONLINE_STATE_KEY_PREFIX + "_" + persistenceKey;
        // Rather than adding the storage observer during start(), we add the
        // storage observer during initialization. This ensures that we collect
        // events before other components populate their initial state (during their
        // respective start() calls). Otherwise, we might for example miss a
        // mutation that is added after LocalStore's start() processed the existing
        // mutations but before we observe WebStorage events.
        this.platform.window.addEventListener('storage', this.storageListener);
    }
    /** Returns 'true' if WebStorage is available in the current environment. */
    WebStorageSharedClientState.isAvailable = function (platform) {
        return !!(platform.window && platform.window.localStorage != null);
    };
    WebStorageSharedClientState.prototype.start = function () {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var existingClients, _i, existingClients_1, clientId, storageItem, clientState, onlineStateJSON, onlineState, _a, _b, event_1;
            var _this = this;
            return tslib.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        assert(!this.started, 'WebStorageSharedClientState already started');
                        assert(this.syncEngine !== null, 'syncEngine property must be set before calling start()');
                        assert(this.onlineStateHandler !== null, 'onlineStateHandler property must be set before calling start()');
                        return [4 /*yield*/, this.syncEngine.getActiveClients()];
                    case 1:
                        existingClients = _c.sent();
                        for (_i = 0, existingClients_1 = existingClients; _i < existingClients_1.length; _i++) {
                            clientId = existingClients_1[_i];
                            if (clientId === this.localClientId) {
                                continue;
                            }
                            storageItem = this.getItem(this.toWebStorageClientStateKey(clientId));
                            if (storageItem) {
                                clientState = RemoteClientState.fromWebStorageEntry(clientId, storageItem);
                                if (clientState) {
                                    this.activeClients[clientState.clientId] = clientState;
                                }
                            }
                        }
                        this.persistClientState();
                        onlineStateJSON = this.storage.getItem(this.onlineStateKey);
                        if (onlineStateJSON) {
                            onlineState = this.fromWebStorageOnlineState(onlineStateJSON);
                            if (onlineState) {
                                this.handleOnlineStateEvent(onlineState);
                            }
                        }
                        for (_a = 0, _b = this.earlyEvents; _a < _b.length; _a++) {
                            event_1 = _b[_a];
                            this.handleWebStorageEvent(event_1);
                        }
                        this.earlyEvents = [];
                        // Register a window unload hook to remove the client metadata entry from
                        // WebStorage even if `shutdown()` was not called.
                        this.platform.window.addEventListener('unload', function () { return _this.shutdown(); });
                        this.started = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    WebStorageSharedClientState.prototype.writeSequenceNumber = function (sequenceNumber) {
        this.setItem(this.sequenceNumberKey, JSON.stringify(sequenceNumber));
    };
    WebStorageSharedClientState.prototype.getAllActiveQueryTargets = function () {
        var activeTargets = targetIdSet();
        forEach(this.activeClients, function (key, value) {
            activeTargets = activeTargets.unionWith(value.activeTargetIds);
        });
        return activeTargets;
    };
    WebStorageSharedClientState.prototype.isActiveQueryTarget = function (targetId) {
        // This is not using `obj.forEach` since `forEach` doesn't support early
        // return.
        for (var clientId in this.activeClients) {
            if (this.activeClients.hasOwnProperty(clientId)) {
                if (this.activeClients[clientId].activeTargetIds.has(targetId)) {
                    return true;
                }
            }
        }
        return false;
    };
    WebStorageSharedClientState.prototype.addPendingMutation = function (batchId) {
        this.persistMutationState(batchId, 'pending');
    };
    WebStorageSharedClientState.prototype.updateMutationState = function (batchId, state, error) {
        this.persistMutationState(batchId, state, error);
        // Once a final mutation result is observed by other clients, they no longer
        // access the mutation's metadata entry. Since WebStorage replays events
        // in order, it is safe to delete the entry right after updating it.
        this.removeMutationState(batchId);
    };
    WebStorageSharedClientState.prototype.addLocalQueryTarget = function (targetId) {
        var queryState = 'not-current';
        // Lookup an existing query state if the target ID was already registered
        // by another tab
        if (this.isActiveQueryTarget(targetId)) {
            var storageItem = this.storage.getItem(this.toWebStorageQueryTargetMetadataKey(targetId));
            if (storageItem) {
                var metadata = QueryTargetMetadata.fromWebStorageEntry(targetId, storageItem);
                if (metadata) {
                    queryState = metadata.state;
                }
            }
        }
        this.localClientState.addQueryTarget(targetId);
        this.persistClientState();
        return queryState;
    };
    WebStorageSharedClientState.prototype.removeLocalQueryTarget = function (targetId) {
        this.localClientState.removeQueryTarget(targetId);
        this.persistClientState();
    };
    WebStorageSharedClientState.prototype.isLocalQueryTarget = function (targetId) {
        return this.localClientState.activeTargetIds.has(targetId);
    };
    WebStorageSharedClientState.prototype.clearQueryState = function (targetId) {
        this.removeItem(this.toWebStorageQueryTargetMetadataKey(targetId));
    };
    WebStorageSharedClientState.prototype.updateQueryState = function (targetId, state, error) {
        this.persistQueryTargetState(targetId, state, error);
    };
    WebStorageSharedClientState.prototype.handleUserChange = function (user, removedBatchIds, addedBatchIds) {
        var _this = this;
        removedBatchIds.forEach(function (batchId) {
            _this.removeMutationState(batchId);
        });
        this.currentUser = user;
        addedBatchIds.forEach(function (batchId) {
            _this.addPendingMutation(batchId);
        });
    };
    WebStorageSharedClientState.prototype.setOnlineState = function (onlineState) {
        this.persistOnlineState(onlineState);
    };
    WebStorageSharedClientState.prototype.shutdown = function () {
        if (this.started) {
            this.platform.window.removeEventListener('storage', this.storageListener);
            this.removeItem(this.localClientStorageKey);
            this.started = false;
        }
    };
    WebStorageSharedClientState.prototype.getItem = function (key) {
        var value = this.storage.getItem(key);
        debug(LOG_TAG$a, 'READ', key, value);
        return value;
    };
    WebStorageSharedClientState.prototype.setItem = function (key, value) {
        debug(LOG_TAG$a, 'SET', key, value);
        this.storage.setItem(key, value);
    };
    WebStorageSharedClientState.prototype.removeItem = function (key) {
        debug(LOG_TAG$a, 'REMOVE', key);
        this.storage.removeItem(key);
    };
    WebStorageSharedClientState.prototype.handleWebStorageEvent = function (event) {
        var _this = this;
        if (event.storageArea === this.storage) {
            debug(LOG_TAG$a, 'EVENT', event.key, event.newValue);
            if (event.key === this.localClientStorageKey) {
                error('Received WebStorage notification for local change. Another client might have ' +
                    'garbage-collected our state');
                return;
            }
            this.queue.enqueueAndForget(function () { return tslib.__awaiter(_this, void 0, void 0, function () {
                var clientState, clientId, mutationMetadata, queryTargetMetadata, onlineState, sequenceNumber;
                return tslib.__generator(this, function (_a) {
                    if (!this.started) {
                        this.earlyEvents.push(event);
                        return [2 /*return*/];
                    }
                    if (event.key === null) {
                        return [2 /*return*/];
                    }
                    if (this.clientStateKeyRe.test(event.key)) {
                        if (event.newValue != null) {
                            clientState = this.fromWebStorageClientState(event.key, event.newValue);
                            if (clientState) {
                                return [2 /*return*/, this.handleClientStateEvent(clientState.clientId, clientState)];
                            }
                        }
                        else {
                            clientId = this.fromWebStorageClientStateKey(event.key);
                            return [2 /*return*/, this.handleClientStateEvent(clientId, null)];
                        }
                    }
                    else if (this.mutationBatchKeyRe.test(event.key)) {
                        if (event.newValue !== null) {
                            mutationMetadata = this.fromWebStorageMutationMetadata(event.key, event.newValue);
                            if (mutationMetadata) {
                                return [2 /*return*/, this.handleMutationBatchEvent(mutationMetadata)];
                            }
                        }
                    }
                    else if (this.queryTargetKeyRe.test(event.key)) {
                        if (event.newValue !== null) {
                            queryTargetMetadata = this.fromWebStorageQueryTargetMetadata(event.key, event.newValue);
                            if (queryTargetMetadata) {
                                return [2 /*return*/, this.handleQueryTargetEvent(queryTargetMetadata)];
                            }
                        }
                    }
                    else if (event.key === this.onlineStateKey) {
                        if (event.newValue !== null) {
                            onlineState = this.fromWebStorageOnlineState(event.newValue);
                            if (onlineState) {
                                return [2 /*return*/, this.handleOnlineStateEvent(onlineState)];
                            }
                        }
                    }
                    else if (event.key === this.sequenceNumberKey) {
                        assert(!!this.sequenceNumberHandler, 'Missing sequenceNumberHandler');
                        sequenceNumber = fromWebStorageSequenceNumber(event.newValue);
                        if (sequenceNumber !== ListenSequence.INVALID) {
                            this.sequenceNumberHandler(sequenceNumber);
                        }
                    }
                    return [2 /*return*/];
                });
            }); });
        }
    };
    Object.defineProperty(WebStorageSharedClientState.prototype, "localClientState", {
        get: function () {
            return this.activeClients[this.localClientId];
        },
        enumerable: true,
        configurable: true
    });
    WebStorageSharedClientState.prototype.persistClientState = function () {
        this.setItem(this.localClientStorageKey, this.localClientState.toWebStorageJSON());
    };
    WebStorageSharedClientState.prototype.persistMutationState = function (batchId, state, error) {
        var mutationState = new MutationMetadata(this.currentUser, batchId, state, error);
        var mutationKey = this.toWebStorageMutationBatchKey(batchId);
        this.setItem(mutationKey, mutationState.toWebStorageJSON());
    };
    WebStorageSharedClientState.prototype.removeMutationState = function (batchId) {
        var mutationKey = this.toWebStorageMutationBatchKey(batchId);
        this.removeItem(mutationKey);
    };
    WebStorageSharedClientState.prototype.persistOnlineState = function (onlineState) {
        var entry = {
            clientId: this.localClientId,
            onlineState: OnlineState[onlineState]
        };
        this.storage.setItem(this.onlineStateKey, JSON.stringify(entry));
    };
    WebStorageSharedClientState.prototype.persistQueryTargetState = function (targetId, state, error) {
        var targetKey = this.toWebStorageQueryTargetMetadataKey(targetId);
        var targetMetadata = new QueryTargetMetadata(targetId, state, error);
        this.setItem(targetKey, targetMetadata.toWebStorageJSON());
    };
    /** Assembles the key for a client state in WebStorage */
    WebStorageSharedClientState.prototype.toWebStorageClientStateKey = function (clientId) {
        assert(clientId.indexOf('_') === -1, "Client key cannot contain '_', but was '" + clientId + "'");
        return CLIENT_STATE_KEY_PREFIX + "_" + this.persistenceKey + "_" + clientId;
    };
    /** Assembles the key for a query state in WebStorage */
    WebStorageSharedClientState.prototype.toWebStorageQueryTargetMetadataKey = function (targetId) {
        return QUERY_TARGET_KEY_PREFIX + "_" + this.persistenceKey + "_" + targetId;
    };
    /** Assembles the key for a mutation batch in WebStorage */
    WebStorageSharedClientState.prototype.toWebStorageMutationBatchKey = function (batchId) {
        var mutationKey = MUTATION_BATCH_KEY_PREFIX + "_" + this.persistenceKey + "_" + batchId;
        if (this.currentUser.isAuthenticated()) {
            mutationKey += "_" + this.currentUser.uid;
        }
        return mutationKey;
    };
    /**
     * Parses a client state key in WebStorage. Returns null if the key does not
     * match the expected key format.
     */
    WebStorageSharedClientState.prototype.fromWebStorageClientStateKey = function (key) {
        var match = this.clientStateKeyRe.exec(key);
        return match ? match[1] : null;
    };
    /**
     * Parses a client state in WebStorage. Returns 'null' if the value could not
     * be parsed.
     */
    WebStorageSharedClientState.prototype.fromWebStorageClientState = function (key, value) {
        var clientId = this.fromWebStorageClientStateKey(key);
        assert(clientId !== null, "Cannot parse client state key '" + key + "'");
        return RemoteClientState.fromWebStorageEntry(clientId, value);
    };
    /**
     * Parses a mutation batch state in WebStorage. Returns 'null' if the value
     * could not be parsed.
     */
    WebStorageSharedClientState.prototype.fromWebStorageMutationMetadata = function (key, value) {
        var match = this.mutationBatchKeyRe.exec(key);
        assert(match !== null, "Cannot parse mutation batch key '" + key + "'");
        var batchId = Number(match[1]);
        var userId = match[2] !== undefined ? match[2] : null;
        return MutationMetadata.fromWebStorageEntry(new User(userId), batchId, value);
    };
    /**
     * Parses a query target state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */
    WebStorageSharedClientState.prototype.fromWebStorageQueryTargetMetadata = function (key, value) {
        var match = this.queryTargetKeyRe.exec(key);
        assert(match !== null, "Cannot parse query target key '" + key + "'");
        var targetId = Number(match[1]);
        return QueryTargetMetadata.fromWebStorageEntry(targetId, value);
    };
    /**
     * Parses an online state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */
    WebStorageSharedClientState.prototype.fromWebStorageOnlineState = function (value) {
        return SharedOnlineState.fromWebStorageEntry(value);
    };
    WebStorageSharedClientState.prototype.handleMutationBatchEvent = function (mutationBatch) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            return tslib.__generator(this, function (_a) {
                if (mutationBatch.user.uid !== this.currentUser.uid) {
                    debug(LOG_TAG$a, "Ignoring mutation for non-active user " + mutationBatch.user.uid);
                    return [2 /*return*/];
                }
                return [2 /*return*/, this.syncEngine.applyBatchState(mutationBatch.batchId, mutationBatch.state, mutationBatch.error)];
            });
        });
    };
    WebStorageSharedClientState.prototype.handleQueryTargetEvent = function (targetMetadata) {
        return this.syncEngine.applyTargetState(targetMetadata.targetId, targetMetadata.state, targetMetadata.error);
    };
    WebStorageSharedClientState.prototype.handleClientStateEvent = function (clientId, clientState) {
        var _this = this;
        var existingTargets = this.getAllActiveQueryTargets();
        if (clientState) {
            this.activeClients[clientId] = clientState;
        }
        else {
            delete this.activeClients[clientId];
        }
        var newTargets = this.getAllActiveQueryTargets();
        var addedTargets = [];
        var removedTargets = [];
        newTargets.forEach(function (targetId) { return tslib.__awaiter(_this, void 0, void 0, function () {
            return tslib.__generator(this, function (_a) {
                if (!existingTargets.has(targetId)) {
                    addedTargets.push(targetId);
                }
                return [2 /*return*/];
            });
        }); });
        existingTargets.forEach(function (targetId) { return tslib.__awaiter(_this, void 0, void 0, function () {
            return tslib.__generator(this, function (_a) {
                if (!newTargets.has(targetId)) {
                    removedTargets.push(targetId);
                }
                return [2 /*return*/];
            });
        }); });
        return this.syncEngine.applyActiveTargetsChange(addedTargets, removedTargets);
    };
    WebStorageSharedClientState.prototype.handleOnlineStateEvent = function (onlineState) {
        // We check whether the client that wrote this online state is still active
        // by comparing its client ID to the list of clients kept active in
        // IndexedDb. If a client does not update their IndexedDb client state
        // within 5 seconds, it is considered inactive and we don't emit an online
        // state event.
        if (this.activeClients[onlineState.clientId]) {
            this.onlineStateHandler(onlineState.onlineState);
        }
    };
    return WebStorageSharedClientState;
}());
function fromWebStorageSequenceNumber(seqString) {
    var sequenceNumber = ListenSequence.INVALID;
    if (seqString != null) {
        try {
            var parsed = JSON.parse(seqString);
            assert(typeof parsed === 'number', 'Found non-numeric sequence number');
            sequenceNumber = parsed;
        }
        catch (e) {
            error(LOG_TAG$a, 'Failed to read sequence number from WebStorage', e);
        }
    }
    return sequenceNumber;
}
/**
 * `MemorySharedClientState` is a simple implementation of SharedClientState for
 * clients using memory persistence. The state in this class remains fully
 * isolated and no synchronization is performed.
 */
var MemorySharedClientState = /** @class */ (function () {
    function MemorySharedClientState() {
        this.localState = new LocalClientState();
        this.queryState = {};
        this.syncEngine = null;
        this.onlineStateHandler = null;
        this.sequenceNumberHandler = null;
    }
    MemorySharedClientState.prototype.addPendingMutation = function (batchId) {
        // No op.
    };
    MemorySharedClientState.prototype.updateMutationState = function (batchId, state, error) {
        // No op.
    };
    MemorySharedClientState.prototype.addLocalQueryTarget = function (targetId) {
        this.localState.addQueryTarget(targetId);
        return this.queryState[targetId] || 'not-current';
    };
    MemorySharedClientState.prototype.updateQueryState = function (targetId, state, error) {
        this.queryState[targetId] = state;
    };
    MemorySharedClientState.prototype.removeLocalQueryTarget = function (targetId) {
        this.localState.removeQueryTarget(targetId);
    };
    MemorySharedClientState.prototype.isLocalQueryTarget = function (targetId) {
        return this.localState.activeTargetIds.has(targetId);
    };
    MemorySharedClientState.prototype.clearQueryState = function (targetId) {
        delete this.queryState[targetId];
    };
    MemorySharedClientState.prototype.getAllActiveQueryTargets = function () {
        return this.localState.activeTargetIds;
    };
    MemorySharedClientState.prototype.isActiveQueryTarget = function (targetId) {
        return this.localState.activeTargetIds.has(targetId);
    };
    MemorySharedClientState.prototype.start = function () {
        this.localState = new LocalClientState();
        return Promise.resolve();
    };
    MemorySharedClientState.prototype.handleUserChange = function (user, removedBatchIds, addedBatchIds) {
        // No op.
    };
    MemorySharedClientState.prototype.setOnlineState = function (onlineState) {
        // No op.
    };
    MemorySharedClientState.prototype.shutdown = function () { };
    MemorySharedClientState.prototype.writeSequenceNumber = function (sequenceNumber) { };
    return MemorySharedClientState;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$b = 'FirestoreClient';
/** DOMException error code constants. */
var DOM_EXCEPTION_INVALID_STATE = 11;
var DOM_EXCEPTION_ABORTED = 20;
var DOM_EXCEPTION_QUOTA_EXCEEDED = 22;
var IndexedDbPersistenceSettings = /** @class */ (function () {
    function IndexedDbPersistenceSettings(cacheSizeBytes, synchronizeTabs) {
        this.cacheSizeBytes = cacheSizeBytes;
        this.synchronizeTabs = synchronizeTabs;
    }
    IndexedDbPersistenceSettings.prototype.lruParams = function () {
        return LruParams.withCacheSize(this.cacheSizeBytes);
    };
    return IndexedDbPersistenceSettings;
}());
var MemoryPersistenceSettings = /** @class */ (function () {
    function MemoryPersistenceSettings() {
    }
    return MemoryPersistenceSettings;
}());
/**
 * FirestoreClient is a top-level class that constructs and owns all of the
 * pieces of the client SDK architecture. It is responsible for creating the
 * async queue that is shared by all of the other components in the system.
 */
var FirestoreClient = /** @class */ (function () {
    function FirestoreClient(platform, databaseInfo, credentials, 
    /**
     * Asynchronous queue responsible for all of our internal processing. When
     * we get incoming work from the user (via public API) or the network
     * (incoming GRPC messages), we should always schedule onto this queue.
     * This ensures all of our work is properly serialized (e.g. we don't
     * start processing a new operation while the previous one is waiting for
     * an async I/O to complete).
     */
    asyncQueue) {
        this.platform = platform;
        this.databaseInfo = databaseInfo;
        this.credentials = credentials;
        this.asyncQueue = asyncQueue;
        this.clientId = AutoId.newId();
    }
    /**
     * Starts up the FirestoreClient, returning only whether or not enabling
     * persistence succeeded.
     *
     * The intent here is to "do the right thing" as far as users are concerned.
     * Namely, in cases where offline persistence is requested and possible,
     * enable it, but otherwise fall back to persistence disabled. For the most
     * part we expect this to succeed one way or the other so we don't expect our
     * users to actually wait on the firestore.enablePersistence Promise since
     * they generally won't care.
     *
     * Of course some users actually do care about whether or not persistence
     * was successfully enabled, so the Promise returned from this method
     * indicates this outcome.
     *
     * This presents a problem though: even before enablePersistence resolves or
     * rejects, users may have made calls to e.g. firestore.collection() which
     * means that the FirestoreClient in there will be available and will be
     * enqueuing actions on the async queue.
     *
     * Meanwhile any failure of an operation on the async queue causes it to
     * panic and reject any further work, on the premise that unhandled errors
     * are fatal.
     *
     * Consequently the fallback is handled internally here in start, and if the
     * fallback succeeds we signal success to the async queue even though the
     * start() itself signals failure.
     *
     * @param persistenceSettings Settings object to configure offline
     *     persistence.
     * @returns A deferred result indicating the user-visible result of enabling
     *     offline persistence. This method will reject this if IndexedDB fails to
     *     start for any reason. If usePersistence is false this is
     *     unconditionally resolved.
     */
    FirestoreClient.prototype.start = function (persistenceSettings) {
        var _this = this;
        this.verifyNotTerminated();
        // We defer our initialization until we get the current user from
        // setChangeListener(). We block the async queue until we got the initial
        // user and the initialization is completed. This will prevent any scheduled
        // work from happening before initialization is completed.
        //
        // If initializationDone resolved then the FirestoreClient is in a usable
        // state.
        var initializationDone = new Deferred();
        // If usePersistence is true, certain classes of errors while starting are
        // recoverable but only by falling back to persistence disabled.
        //
        // If there's an error in the first case but not in recovery we cannot
        // reject the promise blocking the async queue because this will cause the
        // async queue to panic.
        var persistenceResult = new Deferred();
        var initialized = false;
        this.credentials.setChangeListener(function (user) {
            if (!initialized) {
                initialized = true;
                _this.initializePersistence(persistenceSettings, persistenceResult, user)
                    .then(function (maybeLruGc) { return _this.initializeRest(user, maybeLruGc); })
                    .then(initializationDone.resolve, initializationDone.reject);
            }
            else {
                _this.asyncQueue.enqueueAndForget(function () {
                    return _this.handleCredentialChange(user);
                });
            }
        });
        // Block the async queue until initialization is done
        this.asyncQueue.enqueueAndForget(function () {
            return initializationDone.promise;
        });
        // Return only the result of enabling persistence. Note that this does not
        // need to await the completion of initializationDone because the result of
        // this method should not reflect any other kind of failure to start.
        return persistenceResult.promise;
    };
    /** Enables the network connection and requeues all pending operations. */
    FirestoreClient.prototype.enableNetwork = function () {
        var _this = this;
        this.verifyNotTerminated();
        return this.asyncQueue.enqueue(function () {
            return _this.syncEngine.enableNetwork();
        });
    };
    /**
     * Initializes persistent storage, attempting to use IndexedDB if
     * usePersistence is true or memory-only if false.
     *
     * If IndexedDB fails because it's already open in another tab or because the
     * platform can't possibly support our implementation then this method rejects
     * the persistenceResult and falls back on memory-only persistence.
     *
     * @param persistenceSettings Settings object to configure offline persistence
     * @param persistenceResult A deferred result indicating the user-visible
     *     result of enabling offline persistence. This method will reject this if
     *     IndexedDB fails to start for any reason. If usePersistence is false
     *     this is unconditionally resolved.
     * @returns a Promise indicating whether or not initialization should
     *     continue, i.e. that one of the persistence implementations actually
     *     succeeded.
     */
    FirestoreClient.prototype.initializePersistence = function (persistenceSettings, persistenceResult, user) {
        var _this = this;
        if (persistenceSettings instanceof IndexedDbPersistenceSettings) {
            return this.startIndexedDbPersistence(user, persistenceSettings)
                .then(function (maybeLruGc) {
                persistenceResult.resolve();
                return maybeLruGc;
            })
                .catch(function (error) {
                // Regardless of whether or not the retry succeeds, from an user
                // perspective, offline persistence has failed.
                persistenceResult.reject(error);
                // An unknown failure on the first stage shuts everything down.
                if (!_this.canFallback(error)) {
                    throw error;
                }
                console.warn('Error enabling offline persistence. Falling back to' +
                    ' persistence disabled: ' +
                    error);
                return _this.startMemoryPersistence();
            });
        }
        else {
            // When usePersistence == false, enabling offline persistence is defined
            // to unconditionally succeed. This allows start() to have the same
            // signature for both cases, despite the fact that the returned promise
            // is only used in the enablePersistence call.
            persistenceResult.resolve();
            return this.startMemoryPersistence();
        }
    };
    /**
     * Decides whether the provided error allows us to gracefully disable
     * persistence (as opposed to crashing the client).
     */
    FirestoreClient.prototype.canFallback = function (error) {
        if (error instanceof FirestoreError) {
            return (error.code === Code.FAILED_PRECONDITION ||
                error.code === Code.UNIMPLEMENTED);
        }
        else if (typeof DOMException !== 'undefined' &&
            error instanceof DOMException) {
            // There are a few known circumstances where we can open IndexedDb but
            // trying to read/write will fail (e.g. quota exceeded). For
            // well-understood cases, we attempt to detect these and then gracefully
            // fall back to memory persistence.
            // NOTE: Rather than continue to add to this list, we could decide to
            // always fall back, with the risk that we might accidentally hide errors
            // representing actual SDK bugs.
            return (
            // When the browser is out of quota we could get either quota exceeded
            // or an aborted error depending on whether the error happened during
            // schema migration.
            error.code === DOM_EXCEPTION_QUOTA_EXCEEDED ||
                error.code === DOM_EXCEPTION_ABORTED ||
                // Firefox Private Browsing mode disables IndexedDb and returns
                // INVALID_STATE for any usage.
                error.code === DOM_EXCEPTION_INVALID_STATE);
        }
        return true;
    };
    /**
     * Checks that the client has not been terminated. Ensures that other methods on
     * this class cannot be called after the client is terminated.
     */
    FirestoreClient.prototype.verifyNotTerminated = function () {
        if (this.asyncQueue.isShuttingDown) {
            throw new FirestoreError(Code.FAILED_PRECONDITION, 'The client has already been terminated.');
        }
    };
    /**
     * Starts IndexedDB-based persistence.
     *
     * @returns A promise indicating success or failure.
     */
    FirestoreClient.prototype.startIndexedDbPersistence = function (user, settings) {
        var _this = this;
        // TODO(http://b/33384523): For now we just disable garbage collection
        // when persistence is enabled.
        var persistenceKey = IndexedDbPersistence.buildStoragePrefix(this.databaseInfo);
        // Opt to use proto3 JSON in case the platform doesn't support Uint8Array.
        var serializer = new JsonProtoSerializer(this.databaseInfo.databaseId, {
            useProto3Json: true
        });
        return Promise.resolve().then(function () { return tslib.__awaiter(_this, void 0, void 0, function () {
            var lruParams, persistence;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (settings.synchronizeTabs &&
                            !WebStorageSharedClientState.isAvailable(this.platform)) {
                            throw new FirestoreError(Code.UNIMPLEMENTED, 'IndexedDB persistence is only available on platforms that support LocalStorage.');
                        }
                        lruParams = settings.lruParams();
                        this.sharedClientState = settings.synchronizeTabs
                            ? new WebStorageSharedClientState(this.asyncQueue, this.platform, persistenceKey, this.clientId, user)
                            : new MemorySharedClientState();
                        return [4 /*yield*/, IndexedDbPersistence.createIndexedDbPersistence({
                                allowTabSynchronization: settings.synchronizeTabs,
                                persistenceKey: persistenceKey,
                                clientId: this.clientId,
                                platform: this.platform,
                                queue: this.asyncQueue,
                                serializer: serializer,
                                lruParams: lruParams,
                                sequenceNumberSyncer: this.sharedClientState
                            })];
                    case 1:
                        persistence = _a.sent();
                        this.persistence = persistence;
                        return [2 /*return*/, persistence.referenceDelegate.garbageCollector];
                }
            });
        }); });
    };
    /**
     * Starts Memory-backed persistence. In practice this cannot fail.
     *
     * @returns A promise that will successfully resolve.
     */
    FirestoreClient.prototype.startMemoryPersistence = function () {
        this.persistence = MemoryPersistence.createEagerPersistence(this.clientId);
        this.sharedClientState = new MemorySharedClientState();
        return Promise.resolve(null);
    };
    /**
     * Initializes the rest of the FirestoreClient, assuming the initial user
     * has been obtained from the credential provider and some persistence
     * implementation is available in this.persistence.
     */
    FirestoreClient.prototype.initializeRest = function (user, maybeLruGc) {
        var _this = this;
        debug(LOG_TAG$b, 'Initializing. user=', user.uid);
        return this.platform
            .loadConnection(this.databaseInfo)
            .then(function (connection) { return tslib.__awaiter(_this, void 0, void 0, function () {
            var queryEngine, connectivityMonitor, serializer, datastore, remoteStoreOnlineStateChangedHandler, sharedClientStateOnlineStateChangedHandler;
            var _this = this;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryEngine = new SimpleQueryEngine();
                        this.localStore = new LocalStore(this.persistence, queryEngine, user);
                        return [4 /*yield*/, this.localStore.start()];
                    case 1:
                        _a.sent();
                        if (maybeLruGc) {
                            // We're running LRU Garbage collection. Set up the scheduler.
                            this.lruScheduler = new LruScheduler(maybeLruGc, this.asyncQueue, this.localStore);
                        }
                        connectivityMonitor = this.platform.newConnectivityMonitor();
                        serializer = this.platform.newSerializer(this.databaseInfo.databaseId);
                        datastore = new Datastore(this.asyncQueue, connection, this.credentials, serializer);
                        remoteStoreOnlineStateChangedHandler = function (onlineState) {
                            return _this.syncEngine.applyOnlineStateChange(onlineState, OnlineStateSource.RemoteStore);
                        };
                        sharedClientStateOnlineStateChangedHandler = function (onlineState) {
                            return _this.syncEngine.applyOnlineStateChange(onlineState, OnlineStateSource.SharedClientState);
                        };
                        this.remoteStore = new RemoteStore(this.localStore, datastore, this.asyncQueue, remoteStoreOnlineStateChangedHandler, connectivityMonitor);
                        this.syncEngine = new SyncEngine(this.localStore, this.remoteStore, this.sharedClientState, user);
                        this.sharedClientState.onlineStateHandler = sharedClientStateOnlineStateChangedHandler;
                        // Set up wiring between sync engine and other components
                        this.remoteStore.syncEngine = this.syncEngine;
                        this.sharedClientState.syncEngine = this.syncEngine;
                        this.eventMgr = new EventManager(this.syncEngine);
                        // PORTING NOTE: LocalStore doesn't need an explicit start() on the Web.
                        return [4 /*yield*/, this.sharedClientState.start()];
                    case 2:
                        // PORTING NOTE: LocalStore doesn't need an explicit start() on the Web.
                        _a.sent();
                        return [4 /*yield*/, this.remoteStore.start()];
                    case 3:
                        _a.sent();
                        // NOTE: This will immediately call the listener, so we make sure to
                        // set it after localStore / remoteStore are started.
                        return [4 /*yield*/, this.persistence.setPrimaryStateListener(function (isPrimary) { return tslib.__awaiter(_this, void 0, void 0, function () {
                                return tslib.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.syncEngine.applyPrimaryState(isPrimary)];
                                        case 1:
                                            _a.sent();
                                            if (this.lruScheduler) {
                                                if (isPrimary && !this.lruScheduler.started) {
                                                    this.lruScheduler.start();
                                                }
                                                else if (!isPrimary) {
                                                    this.lruScheduler.stop();
                                                }
                                            }
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 4:
                        // NOTE: This will immediately call the listener, so we make sure to
                        // set it after localStore / remoteStore are started.
                        _a.sent();
                        // When a user calls clearPersistence() in one client, all other clients
                        // need to be terminated to allow the delete to succeed.
                        return [4 /*yield*/, this.persistence.setDatabaseDeletedListener(function () { return tslib.__awaiter(_this, void 0, void 0, function () {
                                return tslib.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.terminate()];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 5:
                        // When a user calls clearPersistence() in one client, all other clients
                        // need to be terminated to allow the delete to succeed.
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    FirestoreClient.prototype.handleCredentialChange = function (user) {
        this.asyncQueue.verifyOperationInProgress();
        debug(LOG_TAG$b, 'Credential Changed. Current user: ' + user.uid);
        return this.syncEngine.handleCredentialChange(user);
    };
    /** Disables the network connection. Pending operations will not complete. */
    FirestoreClient.prototype.disableNetwork = function () {
        var _this = this;
        this.verifyNotTerminated();
        return this.asyncQueue.enqueue(function () {
            return _this.syncEngine.disableNetwork();
        });
    };
    FirestoreClient.prototype.terminate = function () {
        var _this = this;
        return this.asyncQueue.enqueueAndInitiateShutdown(function () { return tslib.__awaiter(_this, void 0, void 0, function () {
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // PORTING NOTE: LocalStore does not need an explicit shutdown on web.
                        if (this.lruScheduler) {
                            this.lruScheduler.stop();
                        }
                        return [4 /*yield*/, this.remoteStore.shutdown()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.sharedClientState.shutdown()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.persistence.shutdown()];
                    case 3:
                        _a.sent();
                        // `removeChangeListener` must be called after shutting down the
                        // RemoteStore as it will prevent the RemoteStore from retrieving
                        // auth tokens.
                        this.credentials.removeChangeListener();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * Returns a Promise that resolves when all writes that were pending at the time this
     * method was called received server acknowledgement. An acknowledgement can be either acceptance
     * or rejection.
     */
    FirestoreClient.prototype.waitForPendingWrites = function () {
        var _this = this;
        this.verifyNotTerminated();
        var deferred = new Deferred();
        this.asyncQueue.enqueueAndForget(function () {
            return _this.syncEngine.registerPendingWritesCallback(deferred);
        });
        return deferred.promise;
    };
    FirestoreClient.prototype.listen = function (query, observer, options) {
        var _this = this;
        this.verifyNotTerminated();
        var listener = new QueryListener(query, observer, options);
        this.asyncQueue.enqueueAndForget(function () {
            return _this.eventMgr.listen(listener);
        });
        return listener;
    };
    FirestoreClient.prototype.unlisten = function (listener) {
        var _this = this;
        // Checks for termination but does not raise error, allowing unlisten after
        // termination to be a no-op.
        if (this.clientTerminated) {
            return;
        }
        this.asyncQueue.enqueueAndForget(function () {
            return _this.eventMgr.unlisten(listener);
        });
    };
    FirestoreClient.prototype.getDocumentFromLocalCache = function (docKey) {
        var _this = this;
        this.verifyNotTerminated();
        return this.asyncQueue
            .enqueue(function () {
            return _this.localStore.readDocument(docKey);
        })
            .then(function (maybeDoc) {
            if (maybeDoc instanceof Document) {
                return maybeDoc;
            }
            else if (maybeDoc instanceof NoDocument) {
                return null;
            }
            else {
                throw new FirestoreError(Code.UNAVAILABLE, 'Failed to get document from cache. (However, this document may ' +
                    "exist on the server. Run again without setting 'source' in " +
                    'the GetOptions to attempt to retrieve the document from the ' +
                    'server.)');
            }
        });
    };
    FirestoreClient.prototype.getDocumentsFromLocalCache = function (query) {
        var _this = this;
        this.verifyNotTerminated();
        return this.asyncQueue.enqueue(function () { return tslib.__awaiter(_this, void 0, void 0, function () {
            var queryResult, view, viewDocChanges;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.localStore.executeQuery(query, 
                        /* usePreviousResults= */ true)];
                    case 1:
                        queryResult = _a.sent();
                        view = new View(query, queryResult.remoteKeys);
                        viewDocChanges = view.computeDocChanges(queryResult.documents);
                        return [2 /*return*/, view.applyChanges(viewDocChanges, 
                            /* updateLimboDocuments= */ false).snapshot];
                }
            });
        }); });
    };
    FirestoreClient.prototype.write = function (mutations) {
        var _this = this;
        this.verifyNotTerminated();
        var deferred = new Deferred();
        this.asyncQueue.enqueueAndForget(function () {
            return _this.syncEngine.write(mutations, deferred);
        });
        return deferred.promise;
    };
    FirestoreClient.prototype.databaseId = function () {
        return this.databaseInfo.databaseId;
    };
    FirestoreClient.prototype.addSnapshotsInSyncListener = function (observer) {
        var _this = this;
        this.verifyNotTerminated();
        this.asyncQueue.enqueueAndForget(function () {
            _this.eventMgr.addSnapshotsInSyncListener(observer);
            return Promise.resolve();
        });
    };
    FirestoreClient.prototype.removeSnapshotsInSyncListener = function (observer) {
        // Checks for shutdown but does not raise error, allowing remove after
        // shutdown to be a no-op.
        if (this.clientTerminated) {
            return;
        }
        this.eventMgr.removeSnapshotsInSyncListener(observer);
    };
    Object.defineProperty(FirestoreClient.prototype, "clientTerminated", {
        get: function () {
            // Technically, the asyncQueue is still running, but only accepting operations
            // related to termination or supposed to be run after termination. It is effectively
            // terminated to the eyes of users.
            return this.asyncQueue.isShuttingDown;
        },
        enumerable: true,
        configurable: true
    });
    FirestoreClient.prototype.transaction = function (updateFunction) {
        var _this = this;
        this.verifyNotTerminated();
        var deferred = new Deferred();
        this.asyncQueue.enqueueAndForget(function () {
            _this.syncEngine.runTransaction(_this.asyncQueue, updateFunction, deferred);
            return Promise.resolve();
        });
        return deferred.promise;
    };
    return FirestoreClient;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/*
 * A wrapper implementation of Observer<T> that will dispatch events
 * asynchronously. To allow immediate silencing, a mute call is added which
 * causes events scheduled to no longer be raised.
 */
var AsyncObserver = /** @class */ (function () {
    function AsyncObserver(observer) {
        this.observer = observer;
        /**
         * When set to true, will not raise future events. Necessary to deal with
         * async detachment of listener.
         */
        this.muted = false;
    }
    AsyncObserver.prototype.next = function (value) {
        this.scheduleEvent(this.observer.next, value);
    };
    AsyncObserver.prototype.error = function (error) {
        this.scheduleEvent(this.observer.error, error);
    };
    AsyncObserver.prototype.mute = function () {
        this.muted = true;
    };
    AsyncObserver.prototype.scheduleEvent = function (eventHandler, event) {
        var _this = this;
        if (!this.muted) {
            setTimeout(function () {
                if (!_this.muted) {
                    eventHandler(event);
                }
            }, 0);
        }
    };
    return AsyncObserver;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// The objects that are a part of this API are exposed to third-parties as
// compiled javascript so we want to flag our private members with a leading
// underscore to discourage their use.
/**
 * A FieldPath refers to a field in a document. The path may consist of a single
 * field name (referring to a top-level field in the document), or a list of
 * field names (referring to a nested field in the document).
 */
var FieldPath$1 = /** @class */ (function () {
    /**
     * Creates a FieldPath from the provided field names. If more than one field
     * name is provided, the path will point to a nested field in a document.
     *
     * @param fieldNames A list of field names.
     */
    function FieldPath$1() {
        var fieldNames = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            fieldNames[_i] = arguments[_i];
        }
        validateNamedArrayAtLeastNumberOfElements('FieldPath', fieldNames, 'fieldNames', 1);
        for (var i = 0; i < fieldNames.length; ++i) {
            validateArgType('FieldPath', 'string', i, fieldNames[i]);
            if (fieldNames[i].length === 0) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). " +
                    'Field names must not be empty.');
            }
        }
        this._internalPath = new FieldPath(fieldNames);
    }
    FieldPath$1.documentId = function () {
        return FieldPath$1._DOCUMENT_ID;
    };
    FieldPath$1.prototype.isEqual = function (other) {
        if (!(other instanceof FieldPath$1)) {
            throw invalidClassError('isEqual', 'FieldPath', 1, other);
        }
        return this._internalPath.isEqual(other._internalPath);
    };
    /**
     * Internal Note: The backend doesn't technically support querying by
     * document ID. Instead it queries by the entire document name (full path
     * included), but in the cases we currently support documentId(), the net
     * effect is the same.
     */
    FieldPath$1._DOCUMENT_ID = new FieldPath$1(FieldPath.keyField().canonicalString());
    return FieldPath$1;
}());
/**
 * Matches any characters in a field path string that are reserved.
 */
var RESERVED = new RegExp('[~\\*/\\[\\]]');
/**
 * Parses a field path string into a FieldPath, treating dots as separators.
 */
function fromDotSeparatedString(path) {
    var found = path.search(RESERVED);
    if (found >= 0) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid field path (" + path + "). Paths must not contain " +
            "'~', '*', '/', '[', or ']'");
    }
    try {
        return new (FieldPath$1.bind.apply(FieldPath$1, tslib.__spreadArrays([void 0], path.split('.'))))();
    }
    catch (e) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid field path (" + path + "). Paths must not be empty, " +
            "begin with '.', end with '.', or contain '..'");
    }
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var OAuthToken = /** @class */ (function () {
    function OAuthToken(value, user) {
        this.user = user;
        this.type = 'OAuth';
        this.authHeaders = { Authorization: "Bearer " + value };
    }
    return OAuthToken;
}());
/** A CredentialsProvider that always yields an empty token. */
var EmptyCredentialsProvider = /** @class */ (function () {
    function EmptyCredentialsProvider() {
        /**
         * Stores the listener registered with setChangeListener()
         * This isn't actually necessary since the UID never changes, but we use this
         * to verify the listen contract is adhered to in tests.
         */
        this.changeListener = null;
    }
    EmptyCredentialsProvider.prototype.getToken = function () {
        return Promise.resolve(null);
    };
    EmptyCredentialsProvider.prototype.invalidateToken = function () { };
    EmptyCredentialsProvider.prototype.setChangeListener = function (changeListener) {
        assert(!this.changeListener, 'Can only call setChangeListener() once.');
        this.changeListener = changeListener;
        // Fire with initial user.
        changeListener(User.UNAUTHENTICATED);
    };
    EmptyCredentialsProvider.prototype.removeChangeListener = function () {
        assert(this.changeListener !== null, 'removeChangeListener() when no listener registered');
        this.changeListener = null;
    };
    return EmptyCredentialsProvider;
}());
var FirebaseCredentialsProvider = /** @class */ (function () {
    function FirebaseCredentialsProvider(app) {
        var _this = this;
        this.app = app;
        /**
         * The auth token listener registered with FirebaseApp, retained here so we
         * can unregister it.
         */
        this.tokenListener = null;
        /** Tracks the current User. */
        this.currentUser = User.UNAUTHENTICATED;
        this.receivedInitialUser = false;
        /**
         * Counter used to detect if the token changed while a getToken request was
         * outstanding.
         */
        this.tokenCounter = 0;
        /** The listener registered with setChangeListener(). */
        this.changeListener = null;
        this.forceRefresh = false;
        this.tokenListener = function () {
            _this.tokenCounter++;
            _this.currentUser = _this.getUser();
            _this.receivedInitialUser = true;
            if (_this.changeListener) {
                _this.changeListener(_this.currentUser);
            }
        };
        this.tokenCounter = 0;
        // Will fire at least once where we set this.currentUser
        this.app.INTERNAL.addAuthTokenListener(this.tokenListener);
    }
    FirebaseCredentialsProvider.prototype.getToken = function () {
        var _this = this;
        assert(this.tokenListener != null, 'getToken cannot be called after listener removed.');
        // Take note of the current value of the tokenCounter so that this method
        // can fail (with an ABORTED error) if there is a token change while the
        // request is outstanding.
        var initialTokenCounter = this.tokenCounter;
        var forceRefresh = this.forceRefresh;
        this.forceRefresh = false;
        return this.app.INTERNAL.getToken(forceRefresh).then(function (tokenData) {
            // Cancel the request since the token changed while the request was
            // outstanding so the response is potentially for a previous user (which
            // user, we can't be sure).
            if (_this.tokenCounter !== initialTokenCounter) {
                throw new FirestoreError(Code.ABORTED, 'getToken aborted due to token change.');
            }
            else {
                if (tokenData) {
                    assert(typeof tokenData.accessToken === 'string', 'Invalid tokenData returned from getToken():' + tokenData);
                    return new OAuthToken(tokenData.accessToken, _this.currentUser);
                }
                else {
                    return null;
                }
            }
        });
    };
    FirebaseCredentialsProvider.prototype.invalidateToken = function () {
        this.forceRefresh = true;
    };
    FirebaseCredentialsProvider.prototype.setChangeListener = function (changeListener) {
        assert(!this.changeListener, 'Can only call setChangeListener() once.');
        this.changeListener = changeListener;
        // Fire the initial event
        if (this.receivedInitialUser) {
            changeListener(this.currentUser);
        }
    };
    FirebaseCredentialsProvider.prototype.removeChangeListener = function () {
        assert(this.tokenListener != null, 'removeChangeListener() called twice');
        assert(this.changeListener !== null, 'removeChangeListener() called when no listener registered');
        this.app.INTERNAL.removeAuthTokenListener(this.tokenListener);
        this.tokenListener = null;
        this.changeListener = null;
    };
    // Auth.getUid() can return null even with a user logged in. It is because
    // getUid() is synchronous, but the auth code populating Uid is asynchronous.
    // This method should only be called in the AuthTokenListener callback
    // to guarantee to get the actual user.
    FirebaseCredentialsProvider.prototype.getUser = function () {
        var currentUid = this.app.INTERNAL.getUid();
        assert(currentUid === null || typeof currentUid === 'string', 'Received invalid UID: ' + currentUid);
        return new User(currentUid);
    };
    return FirebaseCredentialsProvider;
}());
/*
 * FirstPartyToken provides a fresh token each time its value
 * is requested, because if the token is too old, requests will be rejected.
 * Technically this may no longer be necessary since the SDK should gracefully
 * recover from unauthenticated errors (see b/33147818 for context), but it's
 * safer to keep the implementation as-is.
 */
var FirstPartyToken = /** @class */ (function () {
    function FirstPartyToken(gapi, sessionIndex) {
        this.gapi = gapi;
        this.sessionIndex = sessionIndex;
        this.type = 'FirstParty';
        this.user = User.FIRST_PARTY;
    }
    Object.defineProperty(FirstPartyToken.prototype, "authHeaders", {
        get: function () {
            var headers = {
                'X-Goog-AuthUser': this.sessionIndex
            };
            var authHeader = this.gapi.auth.getAuthHeaderValueForFirstParty([]);
            if (authHeader) {
                headers['Authorization'] = authHeader;
            }
            return headers;
        },
        enumerable: true,
        configurable: true
    });
    return FirstPartyToken;
}());
/*
 * Provides user credentials required for the Firestore JavaScript SDK
 * to authenticate the user, using technique that is only available
 * to applications hosted by Google.
 */
var FirstPartyCredentialsProvider = /** @class */ (function () {
    function FirstPartyCredentialsProvider(gapi, sessionIndex) {
        this.gapi = gapi;
        this.sessionIndex = sessionIndex;
    }
    FirstPartyCredentialsProvider.prototype.getToken = function () {
        return Promise.resolve(new FirstPartyToken(this.gapi, this.sessionIndex));
    };
    FirstPartyCredentialsProvider.prototype.setChangeListener = function (changeListener) {
        // Fire with initial uid.
        changeListener(User.FIRST_PARTY);
    };
    FirstPartyCredentialsProvider.prototype.removeChangeListener = function () { };
    FirstPartyCredentialsProvider.prototype.invalidateToken = function () { };
    return FirstPartyCredentialsProvider;
}());
/**
 * Builds a CredentialsProvider depending on the type of
 * the credentials passed in.
 */
function makeCredentialsProvider(credentials) {
    if (!credentials) {
        return new EmptyCredentialsProvider();
    }
    switch (credentials.type) {
        case 'gapi':
            var client = credentials.client;
            // Make sure this really is a Gapi client.
            assert(!!(typeof client === 'object' &&
                client !== null &&
                client['auth'] &&
                client['auth']['getAuthHeaderValueForFirstParty']), 'unexpected gapi interface');
            return new FirstPartyCredentialsProvider(client, credentials.sessionIndex || '0');
        case 'provider':
            return credentials.client;
        default:
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'makeCredentialsProvider failed due to invalid credential type');
    }
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function isPartialObserver(obj) {
    return implementsAnyMethods(obj, ['next', 'error', 'complete']);
}
/**
 * Returns true if obj is an object and contains at least one of the specified
 * methods.
 */
function implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }
    var object = obj;
    for (var _i = 0, methods_1 = methods; _i < methods_1.length; _i++) {
        var method = methods_1[_i];
        if (method in object && typeof object[method] === 'function') {
            return true;
        }
    }
    return false;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An opaque base class for FieldValue sentinel objects in our public API,
 * with public static methods for creating said sentinel objects.
 */
var FieldValueImpl = /** @class */ (function () {
    function FieldValueImpl(_methodName) {
        this._methodName = _methodName;
    }
    FieldValueImpl.delete = function () {
        validateNoArgs('FieldValue.delete', arguments);
        return DeleteFieldValueImpl.instance;
    };
    FieldValueImpl.serverTimestamp = function () {
        validateNoArgs('FieldValue.serverTimestamp', arguments);
        return ServerTimestampFieldValueImpl.instance;
    };
    FieldValueImpl.arrayUnion = function () {
        var elements = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            elements[_i] = arguments[_i];
        }
        validateAtLeastNumberOfArgs('FieldValue.arrayUnion', arguments, 1);
        // NOTE: We don't actually parse the data until it's used in set() or
        // update() since we need access to the Firestore instance.
        return new ArrayUnionFieldValueImpl(elements);
    };
    FieldValueImpl.arrayRemove = function () {
        var elements = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            elements[_i] = arguments[_i];
        }
        validateAtLeastNumberOfArgs('FieldValue.arrayRemove', arguments, 1);
        // NOTE: We don't actually parse the data until it's used in set() or
        // update() since we need access to the Firestore instance.
        return new ArrayRemoveFieldValueImpl(elements);
    };
    FieldValueImpl.increment = function (n) {
        validateArgType('FieldValue.increment', 'number', 1, n);
        validateExactNumberOfArgs('FieldValue.increment', arguments, 1);
        return new NumericIncrementFieldValueImpl(n);
    };
    FieldValueImpl.prototype.isEqual = function (other) {
        return this === other;
    };
    return FieldValueImpl;
}());
var DeleteFieldValueImpl = /** @class */ (function (_super) {
    tslib.__extends(DeleteFieldValueImpl, _super);
    function DeleteFieldValueImpl() {
        return _super.call(this, 'FieldValue.delete') || this;
    }
    /** Singleton instance. */
    DeleteFieldValueImpl.instance = new DeleteFieldValueImpl();
    return DeleteFieldValueImpl;
}(FieldValueImpl));
var ServerTimestampFieldValueImpl = /** @class */ (function (_super) {
    tslib.__extends(ServerTimestampFieldValueImpl, _super);
    function ServerTimestampFieldValueImpl() {
        return _super.call(this, 'FieldValue.serverTimestamp') || this;
    }
    /** Singleton instance. */
    ServerTimestampFieldValueImpl.instance = new ServerTimestampFieldValueImpl();
    return ServerTimestampFieldValueImpl;
}(FieldValueImpl));
var ArrayUnionFieldValueImpl = /** @class */ (function (_super) {
    tslib.__extends(ArrayUnionFieldValueImpl, _super);
    function ArrayUnionFieldValueImpl(_elements) {
        var _this = _super.call(this, 'FieldValue.arrayUnion') || this;
        _this._elements = _elements;
        return _this;
    }
    return ArrayUnionFieldValueImpl;
}(FieldValueImpl));
var ArrayRemoveFieldValueImpl = /** @class */ (function (_super) {
    tslib.__extends(ArrayRemoveFieldValueImpl, _super);
    function ArrayRemoveFieldValueImpl(_elements) {
        var _this = _super.call(this, 'FieldValue.arrayRemove') || this;
        _this._elements = _elements;
        return _this;
    }
    return ArrayRemoveFieldValueImpl;
}(FieldValueImpl));
var NumericIncrementFieldValueImpl = /** @class */ (function (_super) {
    tslib.__extends(NumericIncrementFieldValueImpl, _super);
    function NumericIncrementFieldValueImpl(_operand) {
        var _this = _super.call(this, 'FieldValue.increment') || this;
        _this._operand = _operand;
        return _this;
    }
    return NumericIncrementFieldValueImpl;
}(FieldValueImpl));
// Public instance that disallows construction at runtime. This constructor is
// used when exporting FieldValueImpl on firebase.firestore.FieldValue and will
// be called FieldValue publicly. Internally we still use FieldValueImpl which
// has a type-checked private constructor. Note that FieldValueImpl and
// PublicFieldValue can be used interchangeably in instanceof checks.
// For our internal TypeScript code PublicFieldValue doesn't exist as a type,
// and so we need to use FieldValueImpl as type and export it too.
var PublicFieldValue = makeConstructorPrivate(FieldValueImpl, 'Use FieldValue.<field>() instead.');

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var RESERVED_FIELD_REGEX = /^__.*__$/;
/** The result of parsing document data (e.g. for a setData call). */
var ParsedSetData = /** @class */ (function () {
    function ParsedSetData(data, fieldMask, fieldTransforms) {
        this.data = data;
        this.fieldMask = fieldMask;
        this.fieldTransforms = fieldTransforms;
    }
    ParsedSetData.prototype.toMutations = function (key, precondition) {
        var mutations = [];
        if (this.fieldMask !== null) {
            mutations.push(new PatchMutation(key, this.data, this.fieldMask, precondition));
        }
        else {
            mutations.push(new SetMutation(key, this.data, precondition));
        }
        if (this.fieldTransforms.length > 0) {
            mutations.push(new TransformMutation(key, this.fieldTransforms));
        }
        return mutations;
    };
    return ParsedSetData;
}());
/** The result of parsing "update" data (i.e. for an updateData call). */
var ParsedUpdateData = /** @class */ (function () {
    function ParsedUpdateData(data, fieldMask, fieldTransforms) {
        this.data = data;
        this.fieldMask = fieldMask;
        this.fieldTransforms = fieldTransforms;
    }
    ParsedUpdateData.prototype.toMutations = function (key, precondition) {
        var mutations = [
            new PatchMutation(key, this.data, this.fieldMask, precondition)
        ];
        if (this.fieldTransforms.length > 0) {
            mutations.push(new TransformMutation(key, this.fieldTransforms));
        }
        return mutations;
    };
    return ParsedUpdateData;
}());
/*
 * Represents what type of API method provided the data being parsed; useful
 * for determining which error conditions apply during parsing and providing
 * better error messages.
 */
var UserDataSource;
(function (UserDataSource) {
    UserDataSource[UserDataSource["Set"] = 0] = "Set";
    UserDataSource[UserDataSource["Update"] = 1] = "Update";
    UserDataSource[UserDataSource["MergeSet"] = 2] = "MergeSet";
    /**
     * Indicates the source is a where clause, cursor bound, arrayUnion()
     * element, etc. Of note, isWrite(source) will return false.
     */
    UserDataSource[UserDataSource["Argument"] = 3] = "Argument";
    /**
     * Indicates that the source is an Argument that may directly contain nested
     * arrays (e.g. the operand of an `in` query).
     */
    UserDataSource[UserDataSource["ArrayArgument"] = 4] = "ArrayArgument";
})(UserDataSource || (UserDataSource = {}));
function isWrite(dataSource) {
    switch (dataSource) {
        case UserDataSource.Set: // fall through
        case UserDataSource.MergeSet: // fall through
        case UserDataSource.Update:
            return true;
        case UserDataSource.Argument:
        case UserDataSource.ArrayArgument:
            return false;
        default:
            throw fail("Unexpected case for UserDataSource: " + dataSource);
    }
}
/** A "context" object passed around while parsing user data. */
var ParseContext = /** @class */ (function () {
    /**
     * Initializes a ParseContext with the given source and path.
     *
     * @param dataSource Indicates what kind of API method this data came from.
     * @param methodName The name of the method the user called to create this
     *     ParseContext.
     * @param path A path within the object being parsed. This could be an empty
     *     path (in which case the context represents the root of the data being
     *     parsed), or a nonempty path (indicating the context represents a nested
     *     location within the data).
     * @param arrayElement Whether or not this context corresponds to an element
     *     of an array.
     * @param fieldTransforms A mutable list of field transforms encountered while
     *     parsing the data.
     * @param fieldMask A mutable list of field paths encountered while parsing
     *     the data.
     *
     * TODO(b/34871131): We don't support array paths right now, so path can be
     * null to indicate the context represents any location within an array (in
     * which case certain features will not work and errors will be somewhat
     * compromised).
     */
    function ParseContext(dataSource, methodName, path, arrayElement, fieldTransforms, fieldMask) {
        this.dataSource = dataSource;
        this.methodName = methodName;
        this.path = path;
        this.arrayElement = arrayElement;
        // Minor hack: If fieldTransforms is undefined, we assume this is an
        // external call and we need to validate the entire path.
        if (fieldTransforms === undefined) {
            this.validatePath();
        }
        this.arrayElement = arrayElement !== undefined ? arrayElement : false;
        this.fieldTransforms = fieldTransforms || [];
        this.fieldMask = fieldMask || [];
    }
    ParseContext.prototype.childContextForField = function (field) {
        var childPath = this.path == null ? null : this.path.child(field);
        var context = new ParseContext(this.dataSource, this.methodName, childPath, 
        /*arrayElement=*/ false, this.fieldTransforms, this.fieldMask);
        context.validatePathSegment(field);
        return context;
    };
    ParseContext.prototype.childContextForFieldPath = function (field) {
        var childPath = this.path == null ? null : this.path.child(field);
        var context = new ParseContext(this.dataSource, this.methodName, childPath, 
        /*arrayElement=*/ false, this.fieldTransforms, this.fieldMask);
        context.validatePath();
        return context;
    };
    ParseContext.prototype.childContextForArray = function (index) {
        // TODO(b/34871131): We don't support array paths right now; so make path
        // null.
        return new ParseContext(this.dataSource, this.methodName, 
        /*path=*/ null, 
        /*arrayElement=*/ true, this.fieldTransforms, this.fieldMask);
    };
    ParseContext.prototype.createError = function (reason) {
        var fieldDescription = this.path === null || this.path.isEmpty()
            ? ''
            : " (found in field " + this.path.toString() + ")";
        return new FirestoreError(Code.INVALID_ARGUMENT, "Function " + this.methodName + "() called with invalid data. " +
            reason +
            fieldDescription);
    };
    /** Returns 'true' if 'fieldPath' was traversed when creating this context. */
    ParseContext.prototype.contains = function (fieldPath) {
        return (this.fieldMask.find(function (field) { return fieldPath.isPrefixOf(field); }) !== undefined ||
            this.fieldTransforms.find(function (transform) {
                return fieldPath.isPrefixOf(transform.field);
            }) !== undefined);
    };
    ParseContext.prototype.validatePath = function () {
        // TODO(b/34871131): Remove null check once we have proper paths for fields
        // within arrays.
        if (this.path === null) {
            return;
        }
        for (var i = 0; i < this.path.length; i++) {
            this.validatePathSegment(this.path.get(i));
        }
    };
    ParseContext.prototype.validatePathSegment = function (segment) {
        if (segment.length === 0) {
            throw this.createError('Document fields must not be empty');
        }
        if (isWrite(this.dataSource) && RESERVED_FIELD_REGEX.test(segment)) {
            throw this.createError('Document fields cannot begin and end with "__"');
        }
    };
    return ParseContext;
}());
/**
 * A placeholder object for DocumentReferences in this file, in order to
 * avoid a circular dependency. See the comments for `DataPreConverter` for
 * the full context.
 */
var DocumentKeyReference = /** @class */ (function () {
    function DocumentKeyReference(databaseId, key) {
        this.databaseId = databaseId;
        this.key = key;
    }
    return DocumentKeyReference;
}());
/**
 * Helper for parsing raw user input (provided via the API) into internal model
 * classes.
 */
var UserDataConverter = /** @class */ (function () {
    function UserDataConverter(preConverter) {
        this.preConverter = preConverter;
    }
    /** Parse document data from a non-merge set() call. */
    UserDataConverter.prototype.parseSetData = function (methodName, input) {
        var context = new ParseContext(UserDataSource.Set, methodName, FieldPath.EMPTY_PATH);
        validatePlainObject('Data must be an object, but it was:', context, input);
        var updateData = this.parseData(input, context);
        return new ParsedSetData(updateData, 
        /* fieldMask= */ null, context.fieldTransforms);
    };
    /** Parse document data from a set() call with '{merge:true}'. */
    UserDataConverter.prototype.parseMergeData = function (methodName, input, fieldPaths) {
        var context = new ParseContext(UserDataSource.MergeSet, methodName, FieldPath.EMPTY_PATH);
        validatePlainObject('Data must be an object, but it was:', context, input);
        var updateData = this.parseData(input, context);
        var fieldMask;
        var fieldTransforms;
        if (!fieldPaths) {
            fieldMask = FieldMask.fromArray(context.fieldMask);
            fieldTransforms = context.fieldTransforms;
        }
        else {
            var validatedFieldPaths = new SortedSet(FieldPath.comparator);
            for (var _i = 0, fieldPaths_1 = fieldPaths; _i < fieldPaths_1.length; _i++) {
                var stringOrFieldPath = fieldPaths_1[_i];
                var fieldPath = void 0;
                if (stringOrFieldPath instanceof FieldPath$1) {
                    fieldPath = stringOrFieldPath._internalPath;
                }
                else if (typeof stringOrFieldPath === 'string') {
                    fieldPath = fieldPathFromDotSeparatedString(methodName, stringOrFieldPath);
                }
                else {
                    throw fail('Expected stringOrFieldPath to be a string or a FieldPath');
                }
                if (!context.contains(fieldPath)) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, "Field '" + fieldPath + "' is specified in your field mask but missing from your input data.");
                }
                validatedFieldPaths = validatedFieldPaths.add(fieldPath);
            }
            fieldMask = FieldMask.fromSet(validatedFieldPaths);
            fieldTransforms = context.fieldTransforms.filter(function (transform) {
                return fieldMask.covers(transform.field);
            });
        }
        return new ParsedSetData(updateData, fieldMask, fieldTransforms);
    };
    /** Parse update data from an update() call. */
    UserDataConverter.prototype.parseUpdateData = function (methodName, input) {
        var _this = this;
        var context = new ParseContext(UserDataSource.Update, methodName, FieldPath.EMPTY_PATH);
        validatePlainObject('Data must be an object, but it was:', context, input);
        var fieldMaskPaths = new SortedSet(FieldPath.comparator);
        var updateData = ObjectValue.EMPTY;
        forEach(input, function (key, value) {
            var path = fieldPathFromDotSeparatedString(methodName, key);
            var childContext = context.childContextForFieldPath(path);
            value = _this.runPreConverter(value, childContext);
            if (value instanceof DeleteFieldValueImpl) {
                // Add it to the field mask, but don't add anything to updateData.
                fieldMaskPaths = fieldMaskPaths.add(path);
            }
            else {
                var parsedValue = _this.parseData(value, childContext);
                if (parsedValue != null) {
                    fieldMaskPaths = fieldMaskPaths.add(path);
                    updateData = updateData.set(path, parsedValue);
                }
            }
        });
        var mask = FieldMask.fromSet(fieldMaskPaths);
        return new ParsedUpdateData(updateData, mask, context.fieldTransforms);
    };
    /** Parse update data from a list of field/value arguments. */
    UserDataConverter.prototype.parseUpdateVarargs = function (methodName, field, value, moreFieldsAndValues) {
        var context = new ParseContext(UserDataSource.Update, methodName, FieldPath.EMPTY_PATH);
        var keys = [fieldPathFromArgument(methodName, field)];
        var values = [value];
        if (moreFieldsAndValues.length % 2 !== 0) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + methodName + "() needs to be called with an even number " +
                'of arguments that alternate between field names and values.');
        }
        for (var i = 0; i < moreFieldsAndValues.length; i += 2) {
            keys.push(fieldPathFromArgument(methodName, moreFieldsAndValues[i]));
            values.push(moreFieldsAndValues[i + 1]);
        }
        var fieldMaskPaths = new SortedSet(FieldPath.comparator);
        var updateData = ObjectValue.EMPTY;
        for (var i = 0; i < keys.length; ++i) {
            var path = keys[i];
            var childContext = context.childContextForFieldPath(path);
            var value_1 = this.runPreConverter(values[i], childContext);
            if (value_1 instanceof DeleteFieldValueImpl) {
                // Add it to the field mask, but don't add anything to updateData.
                fieldMaskPaths = fieldMaskPaths.add(path);
            }
            else {
                var parsedValue = this.parseData(value_1, childContext);
                if (parsedValue != null) {
                    fieldMaskPaths = fieldMaskPaths.add(path);
                    updateData = updateData.set(path, parsedValue);
                }
            }
        }
        var mask = FieldMask.fromSet(fieldMaskPaths);
        return new ParsedUpdateData(updateData, mask, context.fieldTransforms);
    };
    /**
     * Parse a "query value" (e.g. value in a where filter or a value in a cursor
     * bound).
     *
     * @param allowArrays Whether the query value is an array that may directly
     * contain additional arrays (e.g. the operand of an `in` query).
     */
    UserDataConverter.prototype.parseQueryValue = function (methodName, input, allowArrays) {
        if (allowArrays === void 0) { allowArrays = false; }
        var context = new ParseContext(allowArrays ? UserDataSource.ArrayArgument : UserDataSource.Argument, methodName, FieldPath.EMPTY_PATH);
        var parsed = this.parseData(input, context);
        assert(parsed != null, 'Parsed data should not be null.');
        assert(context.fieldTransforms.length === 0, 'Field transforms should have been disallowed.');
        return parsed;
    };
    /** Sends data through this.preConverter, handling any thrown errors. */
    UserDataConverter.prototype.runPreConverter = function (input, context) {
        try {
            return this.preConverter(input);
        }
        catch (e) {
            var message = errorMessage(e);
            throw context.createError(message);
        }
    };
    /**
     * Internal helper for parsing user data.
     *
     * @param input Data to be parsed.
     * @param context A context object representing the current path being parsed,
     * the source of the data being parsed, etc.
     * @return The parsed value, or null if the value was a FieldValue sentinel
     * that should not be included in the resulting parsed data.
     */
    UserDataConverter.prototype.parseData = function (input, context) {
        input = this.runPreConverter(input, context);
        if (looksLikeJsonObject(input)) {
            validatePlainObject('Unsupported field value:', context, input);
            return this.parseObject(input, context);
        }
        else if (input instanceof FieldValueImpl) {
            // FieldValues usually parse into transforms (except FieldValue.delete())
            // in which case we do not want to include this field in our parsed data
            // (as doing so will overwrite the field directly prior to the transform
            // trying to transform it). So we don't add this location to
            // context.fieldMask and we return null as our parsing result.
            this.parseSentinelFieldValue(input, context);
            return null;
        }
        else {
            // If context.path is null we are inside an array and we don't support
            // field mask paths more granular than the top-level array.
            if (context.path) {
                context.fieldMask.push(context.path);
            }
            if (input instanceof Array) {
                // TODO(b/34871131): Include the path containing the array in the error
                // message.
                // In the case of IN queries, the parsed data is an array (representing
                // the set of values to be included for the IN query) that may directly
                // contain additional arrays (each representing an individual field
                // value), so we disable this validation.
                if (context.arrayElement &&
                    context.dataSource !== UserDataSource.ArrayArgument) {
                    throw context.createError('Nested arrays are not supported');
                }
                return this.parseArray(input, context);
            }
            else {
                return this.parseScalarValue(input, context);
            }
        }
    };
    UserDataConverter.prototype.parseObject = function (obj, context) {
        var _this = this;
        var result = new SortedMap(primitiveComparator);
        if (isEmpty(obj)) {
            // If we encounter an empty object, we explicitly add it to the update
            // mask to ensure that the server creates a map entry.
            if (context.path && context.path.length > 0) {
                context.fieldMask.push(context.path);
            }
        }
        else {
            forEach(obj, function (key, val) {
                var parsedValue = _this.parseData(val, context.childContextForField(key));
                if (parsedValue != null) {
                    result = result.insert(key, parsedValue);
                }
            });
        }
        return new ObjectValue(result);
    };
    UserDataConverter.prototype.parseArray = function (array, context) {
        var result = [];
        var entryIndex = 0;
        for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
            var entry = array_1[_i];
            var parsedEntry = this.parseData(entry, context.childContextForArray(entryIndex));
            if (parsedEntry == null) {
                // Just include nulls in the array for fields being replaced with a
                // sentinel.
                parsedEntry = NullValue.INSTANCE;
            }
            result.push(parsedEntry);
            entryIndex++;
        }
        return new ArrayValue(result);
    };
    /**
     * "Parses" the provided FieldValueImpl, adding any necessary transforms to
     * context.fieldTransforms.
     */
    UserDataConverter.prototype.parseSentinelFieldValue = function (value, context) {
        // Sentinels are only supported with writes, and not within arrays.
        if (!isWrite(context.dataSource)) {
            throw context.createError(value._methodName + "() can only be used with update() and set()");
        }
        if (context.path === null) {
            throw context.createError(value._methodName + "() is not currently supported inside arrays");
        }
        if (value instanceof DeleteFieldValueImpl) {
            if (context.dataSource === UserDataSource.MergeSet) {
                // No transform to add for a delete, but we need to add it to our
                // fieldMask so it gets deleted.
                context.fieldMask.push(context.path);
            }
            else if (context.dataSource === UserDataSource.Update) {
                assert(context.path.length > 0, 'FieldValue.delete() at the top level should have already' +
                    ' been handled.');
                throw context.createError('FieldValue.delete() can only appear at the top level ' +
                    'of your update data');
            }
            else {
                // We shouldn't encounter delete sentinels for queries or non-merge set() calls.
                throw context.createError('FieldValue.delete() cannot be used with set() unless you pass ' +
                    '{merge:true}');
            }
        }
        else if (value instanceof ServerTimestampFieldValueImpl) {
            context.fieldTransforms.push(new FieldTransform(context.path, ServerTimestampTransform.instance));
        }
        else if (value instanceof ArrayUnionFieldValueImpl) {
            var parsedElements = this.parseArrayTransformElements(value._methodName, value._elements);
            var arrayUnion = new ArrayUnionTransformOperation(parsedElements);
            context.fieldTransforms.push(new FieldTransform(context.path, arrayUnion));
        }
        else if (value instanceof ArrayRemoveFieldValueImpl) {
            var parsedElements = this.parseArrayTransformElements(value._methodName, value._elements);
            var arrayRemove = new ArrayRemoveTransformOperation(parsedElements);
            context.fieldTransforms.push(new FieldTransform(context.path, arrayRemove));
        }
        else if (value instanceof NumericIncrementFieldValueImpl) {
            var operand = this.parseQueryValue('FieldValue.increment', value._operand);
            var numericIncrement = new NumericIncrementTransformOperation(operand);
            context.fieldTransforms.push(new FieldTransform(context.path, numericIncrement));
        }
        else {
            fail('Unknown FieldValue type: ' + value);
        }
    };
    /**
     * Helper to parse a scalar value (i.e. not an Object, Array, or FieldValue)
     *
     * @return The parsed value
     */
    UserDataConverter.prototype.parseScalarValue = function (value, context) {
        if (value === null) {
            return NullValue.INSTANCE;
        }
        else if (typeof value === 'number') {
            if (isSafeInteger(value)) {
                return new IntegerValue(value);
            }
            else {
                return new DoubleValue(value);
            }
        }
        else if (typeof value === 'boolean') {
            return BooleanValue.of(value);
        }
        else if (typeof value === 'string') {
            return new StringValue(value);
        }
        else if (value instanceof Date) {
            return new TimestampValue(Timestamp.fromDate(value));
        }
        else if (value instanceof Timestamp) {
            // Firestore backend truncates precision down to microseconds. To ensure
            // offline mode works the same with regards to truncation, perform the
            // truncation immediately without waiting for the backend to do that.
            return new TimestampValue(new Timestamp(value.seconds, Math.floor(value.nanoseconds / 1000) * 1000));
        }
        else if (value instanceof GeoPoint) {
            return new GeoPointValue(value);
        }
        else if (value instanceof Blob) {
            return new BlobValue(value);
        }
        else if (value instanceof DocumentKeyReference) {
            return new RefValue(value.databaseId, value.key);
        }
        else {
            throw context.createError("Unsupported field value: " + valueDescription(value));
        }
    };
    UserDataConverter.prototype.parseArrayTransformElements = function (methodName, elements) {
        var _this = this;
        return elements.map(function (element, i) {
            // Although array transforms are used with writes, the actual elements
            // being unioned or removed are not considered writes since they cannot
            // contain any FieldValue sentinels, etc.
            var context = new ParseContext(UserDataSource.Argument, methodName, FieldPath.EMPTY_PATH);
            return _this.parseData(element, context.childContextForArray(i));
        });
    };
    return UserDataConverter;
}());
/**
 * Checks whether an object looks like a JSON object that should be converted
 * into a struct. Normal class/prototype instances are considered to look like
 * JSON objects since they should be converted to a struct value. Arrays, Dates,
 * GeoPoints, etc. are not considered to look like JSON objects since they map
 * to specific FieldValue types other than ObjectValue.
 */
function looksLikeJsonObject(input) {
    return (typeof input === 'object' &&
        input !== null &&
        !(input instanceof Array) &&
        !(input instanceof Date) &&
        !(input instanceof Timestamp) &&
        !(input instanceof GeoPoint) &&
        !(input instanceof Blob) &&
        !(input instanceof DocumentKeyReference) &&
        !(input instanceof FieldValueImpl));
}
function validatePlainObject(message, context, input) {
    if (!looksLikeJsonObject(input) || !isPlainObject(input)) {
        var description = valueDescription(input);
        if (description === 'an object') {
            // Massage the error if it was an object.
            throw context.createError(message + ' a custom object');
        }
        else {
            throw context.createError(message + ' ' + description);
        }
    }
}
/**
 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
 */
function fieldPathFromArgument(methodName, path) {
    if (path instanceof FieldPath$1) {
        return path._internalPath;
    }
    else if (typeof path === 'string') {
        return fieldPathFromDotSeparatedString(methodName, path);
    }
    else {
        var message = 'Field path arguments must be of type string or FieldPath.';
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + methodName + "() called with invalid data. " + message);
    }
}
/**
 * Wraps fromDotSeparatedString with an error message about the method that
 * was thrown.
 * @param methodName The publicly visible method name
 * @param path The dot-separated string form of a field path which will be split
 * on dots.
 */
function fieldPathFromDotSeparatedString(methodName, path) {
    try {
        return fromDotSeparatedString(path)._internalPath;
    }
    catch (e) {
        var message = errorMessage(e);
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + methodName + "() called with invalid data. " + message);
    }
}
/**
 * Extracts the message from a caught exception, which should be an Error object
 * though JS doesn't guarantee that.
 */
function errorMessage(error) {
    return error instanceof Error ? error.message : error.toString();
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// settings() defaults:
var DEFAULT_HOST = 'firestore.googleapis.com';
var DEFAULT_SSL = true;
var DEFAULT_TIMESTAMPS_IN_SNAPSHOTS = true;
var DEFAULT_FORCE_LONG_POLLING = false;
/**
 * Constant used to indicate the LRU garbage collection should be disabled.
 * Set this value as the `cacheSizeBytes` on the settings passed to the
 * `Firestore` instance.
 */
var CACHE_SIZE_UNLIMITED = LruParams.COLLECTION_DISABLED;
// enablePersistence() defaults:
var DEFAULT_SYNCHRONIZE_TABS = false;
/**
 * A concrete type describing all the values that can be applied via a
 * user-supplied firestore.Settings object. This is a separate type so that
 * defaults can be supplied and the value can be checked for equality.
 */
var FirestoreSettings = /** @class */ (function () {
    function FirestoreSettings(settings) {
        if (settings.host === undefined) {
            if (settings.ssl !== undefined) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
            }
            this.host = DEFAULT_HOST;
            this.ssl = DEFAULT_SSL;
        }
        else {
            validateNamedType('settings', 'non-empty string', 'host', settings.host);
            this.host = settings.host;
            validateNamedOptionalType('settings', 'boolean', 'ssl', settings.ssl);
            this.ssl = defaulted(settings.ssl, DEFAULT_SSL);
        }
        validateOptionNames('settings', settings, [
            'host',
            'ssl',
            'credentials',
            'timestampsInSnapshots',
            'cacheSizeBytes',
            'experimentalForceLongPolling'
        ]);
        validateNamedOptionalType('settings', 'object', 'credentials', settings.credentials);
        this.credentials = settings.credentials;
        validateNamedOptionalType('settings', 'boolean', 'timestampsInSnapshots', settings.timestampsInSnapshots);
        // Nobody should set timestampsInSnapshots anymore, but the error depends on
        // whether they set it to true or false...
        if (settings.timestampsInSnapshots === true) {
            error("\n  The timestampsInSnapshots setting now defaults to true and you no\n  longer need to explicitly set it. In a future release, the setting\n  will be removed entirely and so it is recommended that you remove it\n  from your firestore.settings() call now.");
        }
        else if (settings.timestampsInSnapshots === false) {
            error("\n  The timestampsInSnapshots setting will soon be removed. YOU MUST UPDATE\n  YOUR CODE.\n\n  To hide this warning, stop using the timestampsInSnapshots setting in your\n  firestore.settings({ ... }) call.\n\n  Once you remove the setting, Timestamps stored in Cloud Firestore will be\n  read back as Firebase Timestamp objects instead of as system Date objects.\n  So you will also need to update code expecting a Date to instead expect a\n  Timestamp. For example:\n\n  // Old:\n  const date = snapshot.get('created_at');\n  // New:\n  const timestamp = snapshot.get('created_at'); const date =\n  timestamp.toDate();\n\n  Please audit all existing usages of Date when you enable the new\n  behavior.");
        }
        this.timestampsInSnapshots = defaulted(settings.timestampsInSnapshots, DEFAULT_TIMESTAMPS_IN_SNAPSHOTS);
        validateNamedOptionalType('settings', 'number', 'cacheSizeBytes', settings.cacheSizeBytes);
        if (settings.cacheSizeBytes === undefined) {
            this.cacheSizeBytes = LruParams.DEFAULT_CACHE_SIZE_BYTES;
        }
        else {
            if (settings.cacheSizeBytes !== CACHE_SIZE_UNLIMITED &&
                settings.cacheSizeBytes < LruParams.MINIMUM_CACHE_SIZE_BYTES) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, "cacheSizeBytes must be at least " + LruParams.MINIMUM_CACHE_SIZE_BYTES);
            }
            else {
                this.cacheSizeBytes = settings.cacheSizeBytes;
            }
        }
        validateNamedOptionalType('settings', 'boolean', 'experimentalForceLongPolling', settings.experimentalForceLongPolling);
        this.forceLongPolling =
            settings.experimentalForceLongPolling === undefined
                ? DEFAULT_FORCE_LONG_POLLING
                : settings.experimentalForceLongPolling;
    }
    FirestoreSettings.prototype.isEqual = function (other) {
        return (this.host === other.host &&
            this.ssl === other.ssl &&
            this.timestampsInSnapshots === other.timestampsInSnapshots &&
            this.credentials === other.credentials &&
            this.cacheSizeBytes === other.cacheSizeBytes &&
            this.forceLongPolling === other.forceLongPolling);
    };
    return FirestoreSettings;
}());
/**
 * The root reference to the database.
 */
var Firestore = /** @class */ (function () {
    function Firestore(databaseIdOrApp) {
        var _this = this;
        this._firebaseApp = null;
        // Public for use in tests.
        // TODO(mikelehen): Use modularized initialization instead.
        this._queue = new AsyncQueue();
        this.INTERNAL = {
            delete: function () { return tslib.__awaiter(_this, void 0, void 0, function () {
                return tslib.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // The client must be initalized to ensure that all subsequent API usage
                            // throws an exception.
                            this.ensureClientConfigured();
                            return [4 /*yield*/, this._firestoreClient.terminate()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); }
        };
        if (typeof databaseIdOrApp.options === 'object') {
            // This is very likely a Firebase app object
            // TODO(b/34177605): Can we somehow use instanceof?
            var app = databaseIdOrApp;
            this._firebaseApp = app;
            this._databaseId = Firestore.databaseIdFromApp(app);
            this._persistenceKey = app.name;
            this._credentials = new FirebaseCredentialsProvider(app);
        }
        else {
            var external_1 = databaseIdOrApp;
            if (!external_1.projectId) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, 'Must provide projectId');
            }
            this._databaseId = new DatabaseId(external_1.projectId, external_1.database);
            // Use a default persistenceKey that lines up with FirebaseApp.
            this._persistenceKey = '[DEFAULT]';
            this._credentials = new EmptyCredentialsProvider();
        }
        this._settings = new FirestoreSettings({});
        this._dataConverter = this.createDataConverter(this._databaseId);
    }
    Firestore.prototype.settings = function (settingsLiteral) {
        validateExactNumberOfArgs('Firestore.settings', arguments, 1);
        validateArgType('Firestore.settings', 'object', 1, settingsLiteral);
        if (contains(settingsLiteral, 'persistence')) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, '"persistence" is now specified with a separate call to ' +
                'firestore.enablePersistence().');
        }
        var newSettings = new FirestoreSettings(settingsLiteral);
        if (this._firestoreClient && !this._settings.isEqual(newSettings)) {
            throw new FirestoreError(Code.FAILED_PRECONDITION, 'Firestore has already been started and its settings can no longer ' +
                'be changed. You can only call settings() before calling any other ' +
                'methods on a Firestore object.');
        }
        this._settings = newSettings;
        if (newSettings.credentials !== undefined) {
            this._credentials = makeCredentialsProvider(newSettings.credentials);
        }
    };
    Firestore.prototype.enableNetwork = function () {
        this.ensureClientConfigured();
        return this._firestoreClient.enableNetwork();
    };
    Firestore.prototype.disableNetwork = function () {
        this.ensureClientConfigured();
        return this._firestoreClient.disableNetwork();
    };
    Firestore.prototype.enablePersistence = function (settings) {
        if (this._firestoreClient) {
            throw new FirestoreError(Code.FAILED_PRECONDITION, 'Firestore has already been started and persistence can no longer ' +
                'be enabled. You can only call enablePersistence() before calling ' +
                'any other methods on a Firestore object.');
        }
        var synchronizeTabs = false;
        if (settings) {
            if (settings.experimentalTabSynchronization !== undefined) {
                error("The 'experimentalTabSynchronization' setting has been renamed to " +
                    "'synchronizeTabs'. In a future release, the setting will be removed " +
                    'and it is recommended that you update your ' +
                    "firestore.enablePersistence() call to use 'synchronizeTabs'.");
            }
            synchronizeTabs = defaulted(settings.synchronizeTabs !== undefined
                ? settings.synchronizeTabs
                : settings.experimentalTabSynchronization, DEFAULT_SYNCHRONIZE_TABS);
        }
        return this.configureClient(new IndexedDbPersistenceSettings(this._settings.cacheSizeBytes, synchronizeTabs));
    };
    Firestore.prototype.clearPersistence = function () {
        var _this = this;
        var persistenceKey = IndexedDbPersistence.buildStoragePrefix(this.makeDatabaseInfo());
        var deferred = new Deferred();
        this._queue.enqueueAndForgetEvenAfterShutdown(function () { return tslib.__awaiter(_this, void 0, void 0, function () {
            var e_1;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        if (this._firestoreClient !== undefined &&
                            !this._firestoreClient.clientTerminated) {
                            throw new FirestoreError(Code.FAILED_PRECONDITION, 'Persistence cannot be cleared after this Firestore instance is initialized.');
                        }
                        return [4 /*yield*/, IndexedDbPersistence.clearPersistence(persistenceKey)];
                    case 1:
                        _a.sent();
                        deferred.resolve();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        deferred.reject(e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
        return deferred.promise;
    };
    Firestore.prototype.terminate = function () {
        this.app._removeServiceInstance('firestore');
        return this.INTERNAL.delete();
    };
    Object.defineProperty(Firestore.prototype, "_isTerminated", {
        get: function () {
            this.ensureClientConfigured();
            return this._firestoreClient.clientTerminated;
        },
        enumerable: true,
        configurable: true
    });
    Firestore.prototype.waitForPendingWrites = function () {
        this.ensureClientConfigured();
        return this._firestoreClient.waitForPendingWrites();
    };
    Firestore.prototype.onSnapshotsInSync = function (arg) {
        this.ensureClientConfigured();
        if (isPartialObserver(arg)) {
            return this.onSnapshotsInSyncInternal(arg);
        }
        else {
            validateArgType('Firestore.onSnapshotsInSync', 'function', 1, arg);
            var observer = {
                next: arg
            };
            return this.onSnapshotsInSyncInternal(observer);
        }
    };
    Firestore.prototype.onSnapshotsInSyncInternal = function (observer) {
        var _this = this;
        var errHandler = function (err) {
            throw fail('Uncaught Error in onSnapshotsInSync');
        };
        var asyncObserver = new AsyncObserver({
            next: function () {
                if (observer.next) {
                    observer.next();
                }
            },
            error: errHandler
        });
        this._firestoreClient.addSnapshotsInSyncListener(asyncObserver);
        return function () {
            asyncObserver.mute();
            _this._firestoreClient.removeSnapshotsInSyncListener(asyncObserver);
        };
    };
    Firestore.prototype.ensureClientConfigured = function () {
        if (!this._firestoreClient) {
            // Kick off starting the client but don't actually wait for it.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.configureClient(new MemoryPersistenceSettings());
        }
        return this._firestoreClient;
    };
    Firestore.prototype.makeDatabaseInfo = function () {
        return new DatabaseInfo(this._databaseId, this._persistenceKey, this._settings.host, this._settings.ssl, this._settings.forceLongPolling);
    };
    Firestore.prototype.configureClient = function (persistenceSettings) {
        assert(!!this._settings.host, 'FirestoreSettings.host is not set');
        assert(!this._firestoreClient, 'configureClient() called multiple times');
        var databaseInfo = this.makeDatabaseInfo();
        this._firestoreClient = new FirestoreClient(PlatformSupport.getPlatform(), databaseInfo, this._credentials, this._queue);
        return this._firestoreClient.start(persistenceSettings);
    };
    Firestore.prototype.createDataConverter = function (databaseId) {
        var preConverter = function (value) {
            if (value instanceof DocumentReference) {
                var thisDb = databaseId;
                var otherDb = value.firestore._databaseId;
                if (!otherDb.isEqual(thisDb)) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Document reference is for database ' +
                        (otherDb.projectId + "/" + otherDb.database + " but should be ") +
                        ("for database " + thisDb.projectId + "/" + thisDb.database));
                }
                return new DocumentKeyReference(databaseId, value._key);
            }
            else {
                return value;
            }
        };
        return new UserDataConverter(preConverter);
    };
    Firestore.databaseIdFromApp = function (app) {
        var options = app.options;
        if (!contains(options, 'projectId')) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
        }
        var projectId = options['projectId'];
        if (!projectId || typeof projectId !== 'string') {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'projectId must be a string in FirebaseApp.options');
        }
        return new DatabaseId(projectId);
    };
    Object.defineProperty(Firestore.prototype, "app", {
        get: function () {
            if (!this._firebaseApp) {
                throw new FirestoreError(Code.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is " +
                    'not available');
            }
            return this._firebaseApp;
        },
        enumerable: true,
        configurable: true
    });
    Firestore.prototype.collection = function (pathString) {
        validateExactNumberOfArgs('Firestore.collection', arguments, 1);
        validateArgType('Firestore.collection', 'non-empty string', 1, pathString);
        this.ensureClientConfigured();
        return new CollectionReference(ResourcePath.fromString(pathString), this);
    };
    Firestore.prototype.doc = function (pathString) {
        validateExactNumberOfArgs('Firestore.doc', arguments, 1);
        validateArgType('Firestore.doc', 'non-empty string', 1, pathString);
        this.ensureClientConfigured();
        return DocumentReference.forPath(ResourcePath.fromString(pathString), this);
    };
    Firestore.prototype.collectionGroup = function (collectionId) {
        validateExactNumberOfArgs('Firestore.collectionGroup', arguments, 1);
        validateArgType('Firestore.collectionGroup', 'non-empty string', 1, collectionId);
        if (collectionId.indexOf('/') >= 0) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid collection ID '" + collectionId + "' passed to function " +
                "Firestore.collectionGroup(). Collection IDs must not contain '/'.");
        }
        this.ensureClientConfigured();
        return new Query$1(new Query(ResourcePath.EMPTY_PATH, collectionId), this);
    };
    Firestore.prototype.runTransaction = function (updateFunction) {
        var _this = this;
        validateExactNumberOfArgs('Firestore.runTransaction', arguments, 1);
        validateArgType('Firestore.runTransaction', 'function', 1, updateFunction);
        return this.ensureClientConfigured().transaction(function (transaction) {
            return updateFunction(new Transaction$1(_this, transaction));
        });
    };
    Firestore.prototype.batch = function () {
        this.ensureClientConfigured();
        return new WriteBatch(this);
    };
    Object.defineProperty(Firestore, "logLevel", {
        get: function () {
            switch (getLogLevel()) {
                case LogLevel.DEBUG:
                    return 'debug';
                case LogLevel.ERROR:
                    return 'error';
                case LogLevel.SILENT:
                    return 'silent';
                default:
                    return fail('Unknown log level: ' + getLogLevel());
            }
        },
        enumerable: true,
        configurable: true
    });
    Firestore.setLogLevel = function (level) {
        validateExactNumberOfArgs('Firestore.setLogLevel', arguments, 1);
        validateArgType('Firestore.setLogLevel', 'non-empty string', 1, level);
        switch (level) {
            case 'debug':
                setLogLevel(LogLevel.DEBUG);
                break;
            case 'error':
                setLogLevel(LogLevel.ERROR);
                break;
            case 'silent':
                setLogLevel(LogLevel.SILENT);
                break;
            default:
                throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid log level: ' + level);
        }
    };
    // Note: this is not a property because the minifier can't work correctly with
    // the way TypeScript compiler outputs properties.
    Firestore.prototype._areTimestampsInSnapshotsEnabled = function () {
        return this._settings.timestampsInSnapshots;
    };
    return Firestore;
}());
/**
 * A reference to a transaction.
 */
var Transaction$1 = /** @class */ (function () {
    function Transaction(_firestore, _transaction) {
        this._firestore = _firestore;
        this._transaction = _transaction;
    }
    Transaction.prototype.get = function (documentRef) {
        var _this = this;
        validateExactNumberOfArgs('Transaction.get', arguments, 1);
        var ref = validateReference('Transaction.get', documentRef, this._firestore);
        return this._transaction
            .lookup([ref._key])
            .then(function (docs) {
            if (!docs || docs.length !== 1) {
                return fail('Mismatch in docs returned from document lookup.');
            }
            var doc = docs[0];
            if (doc instanceof NoDocument) {
                return new DocumentSnapshot(_this._firestore, ref._key, null, 
                /* fromCache= */ false, 
                /* hasPendingWrites= */ false);
            }
            else if (doc instanceof Document) {
                return new DocumentSnapshot(_this._firestore, ref._key, doc, 
                /* fromCache= */ false, 
                /* hasPendingWrites= */ false);
            }
            else {
                throw fail("BatchGetDocumentsRequest returned unexpected document type: " + doc.constructor.name);
            }
        });
    };
    Transaction.prototype.set = function (documentRef, value, options) {
        validateBetweenNumberOfArgs('Transaction.set', arguments, 2, 3);
        var ref = validateReference('Transaction.set', documentRef, this._firestore);
        options = validateSetOptions('Transaction.set', options);
        var parsed = options.merge || options.mergeFields
            ? this._firestore._dataConverter.parseMergeData('Transaction.set', value, options.mergeFields)
            : this._firestore._dataConverter.parseSetData('Transaction.set', value);
        this._transaction.set(ref._key, parsed);
        return this;
    };
    Transaction.prototype.update = function (documentRef, fieldOrUpdateData, value) {
        var moreFieldsAndValues = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            moreFieldsAndValues[_i - 3] = arguments[_i];
        }
        var ref;
        var parsed;
        if (typeof fieldOrUpdateData === 'string' ||
            fieldOrUpdateData instanceof FieldPath$1) {
            validateAtLeastNumberOfArgs('Transaction.update', arguments, 3);
            ref = validateReference('Transaction.update', documentRef, this._firestore);
            parsed = this._firestore._dataConverter.parseUpdateVarargs('Transaction.update', fieldOrUpdateData, value, moreFieldsAndValues);
        }
        else {
            validateExactNumberOfArgs('Transaction.update', arguments, 2);
            ref = validateReference('Transaction.update', documentRef, this._firestore);
            parsed = this._firestore._dataConverter.parseUpdateData('Transaction.update', fieldOrUpdateData);
        }
        this._transaction.update(ref._key, parsed);
        return this;
    };
    Transaction.prototype.delete = function (documentRef) {
        validateExactNumberOfArgs('Transaction.delete', arguments, 1);
        var ref = validateReference('Transaction.delete', documentRef, this._firestore);
        this._transaction.delete(ref._key);
        return this;
    };
    return Transaction;
}());
var WriteBatch = /** @class */ (function () {
    function WriteBatch(_firestore) {
        this._firestore = _firestore;
        this._mutations = [];
        this._committed = false;
    }
    WriteBatch.prototype.set = function (documentRef, value, options) {
        validateBetweenNumberOfArgs('WriteBatch.set', arguments, 2, 3);
        this.verifyNotCommitted();
        var ref = validateReference('WriteBatch.set', documentRef, this._firestore);
        options = validateSetOptions('WriteBatch.set', options);
        var parsed = options.merge || options.mergeFields
            ? this._firestore._dataConverter.parseMergeData('WriteBatch.set', value, options.mergeFields)
            : this._firestore._dataConverter.parseSetData('WriteBatch.set', value);
        this._mutations = this._mutations.concat(parsed.toMutations(ref._key, Precondition.NONE));
        return this;
    };
    WriteBatch.prototype.update = function (documentRef, fieldOrUpdateData, value) {
        var moreFieldsAndValues = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            moreFieldsAndValues[_i - 3] = arguments[_i];
        }
        this.verifyNotCommitted();
        var ref;
        var parsed;
        if (typeof fieldOrUpdateData === 'string' ||
            fieldOrUpdateData instanceof FieldPath$1) {
            validateAtLeastNumberOfArgs('WriteBatch.update', arguments, 3);
            ref = validateReference('WriteBatch.update', documentRef, this._firestore);
            parsed = this._firestore._dataConverter.parseUpdateVarargs('WriteBatch.update', fieldOrUpdateData, value, moreFieldsAndValues);
        }
        else {
            validateExactNumberOfArgs('WriteBatch.update', arguments, 2);
            ref = validateReference('WriteBatch.update', documentRef, this._firestore);
            parsed = this._firestore._dataConverter.parseUpdateData('WriteBatch.update', fieldOrUpdateData);
        }
        this._mutations = this._mutations.concat(parsed.toMutations(ref._key, Precondition.exists(true)));
        return this;
    };
    WriteBatch.prototype.delete = function (documentRef) {
        validateExactNumberOfArgs('WriteBatch.delete', arguments, 1);
        this.verifyNotCommitted();
        var ref = validateReference('WriteBatch.delete', documentRef, this._firestore);
        this._mutations = this._mutations.concat(new DeleteMutation(ref._key, Precondition.NONE));
        return this;
    };
    WriteBatch.prototype.commit = function () {
        return tslib.__awaiter(this, void 0, void 0, function () {
            return tslib.__generator(this, function (_a) {
                this.verifyNotCommitted();
                this._committed = true;
                if (this._mutations.length > 0) {
                    return [2 /*return*/, this._firestore.ensureClientConfigured().write(this._mutations)];
                }
                return [2 /*return*/];
            });
        });
    };
    WriteBatch.prototype.verifyNotCommitted = function () {
        if (this._committed) {
            throw new FirestoreError(Code.FAILED_PRECONDITION, 'A write batch can no longer be used after commit() ' +
                'has been called.');
        }
    };
    return WriteBatch;
}());
/**
 * A reference to a particular document in a collection in the database.
 */
var DocumentReference = /** @class */ (function () {
    function DocumentReference(_key, firestore) {
        this._key = _key;
        this.firestore = firestore;
        this._firestoreClient = this.firestore.ensureClientConfigured();
    }
    DocumentReference.forPath = function (path, firestore) {
        if (path.length % 2 !== 0) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid document reference. Document ' +
                'references must have an even number of segments, but ' +
                (path.canonicalString() + " has " + path.length));
        }
        return new DocumentReference(new DocumentKey(path), firestore);
    };
    Object.defineProperty(DocumentReference.prototype, "id", {
        get: function () {
            return this._key.path.lastSegment();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentReference.prototype, "parent", {
        get: function () {
            return new CollectionReference(this._key.path.popLast(), this.firestore);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentReference.prototype, "path", {
        get: function () {
            return this._key.path.canonicalString();
        },
        enumerable: true,
        configurable: true
    });
    DocumentReference.prototype.collection = function (pathString) {
        validateExactNumberOfArgs('DocumentReference.collection', arguments, 1);
        validateArgType('DocumentReference.collection', 'non-empty string', 1, pathString);
        if (!pathString) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Must provide a non-empty collection name to collection()');
        }
        var path = ResourcePath.fromString(pathString);
        return new CollectionReference(this._key.path.child(path), this.firestore);
    };
    DocumentReference.prototype.isEqual = function (other) {
        if (!(other instanceof DocumentReference)) {
            throw invalidClassError('isEqual', 'DocumentReference', 1, other);
        }
        return this.firestore === other.firestore && this._key.isEqual(other._key);
    };
    DocumentReference.prototype.set = function (value, options) {
        validateBetweenNumberOfArgs('DocumentReference.set', arguments, 1, 2);
        options = validateSetOptions('DocumentReference.set', options);
        var parsed = options.merge || options.mergeFields
            ? this.firestore._dataConverter.parseMergeData('DocumentReference.set', value, options.mergeFields)
            : this.firestore._dataConverter.parseSetData('DocumentReference.set', value);
        return this._firestoreClient.write(parsed.toMutations(this._key, Precondition.NONE));
    };
    DocumentReference.prototype.update = function (fieldOrUpdateData, value) {
        var moreFieldsAndValues = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            moreFieldsAndValues[_i - 2] = arguments[_i];
        }
        var parsed;
        if (typeof fieldOrUpdateData === 'string' ||
            fieldOrUpdateData instanceof FieldPath$1) {
            validateAtLeastNumberOfArgs('DocumentReference.update', arguments, 2);
            parsed = this.firestore._dataConverter.parseUpdateVarargs('DocumentReference.update', fieldOrUpdateData, value, moreFieldsAndValues);
        }
        else {
            validateExactNumberOfArgs('DocumentReference.update', arguments, 1);
            parsed = this.firestore._dataConverter.parseUpdateData('DocumentReference.update', fieldOrUpdateData);
        }
        return this._firestoreClient.write(parsed.toMutations(this._key, Precondition.exists(true)));
    };
    DocumentReference.prototype.delete = function () {
        validateExactNumberOfArgs('DocumentReference.delete', arguments, 0);
        return this._firestoreClient.write([
            new DeleteMutation(this._key, Precondition.NONE)
        ]);
    };
    DocumentReference.prototype.onSnapshot = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        validateBetweenNumberOfArgs('DocumentReference.onSnapshot', arguments, 1, 4);
        var options = {
            includeMetadataChanges: false
        };
        var observer;
        var currArg = 0;
        if (typeof args[currArg] === 'object' &&
            !isPartialObserver(args[currArg])) {
            options = args[currArg];
            validateOptionNames('DocumentReference.onSnapshot', options, [
                'includeMetadataChanges'
            ]);
            validateNamedOptionalType('DocumentReference.onSnapshot', 'boolean', 'includeMetadataChanges', options.includeMetadataChanges);
            currArg++;
        }
        var internalOptions = {
            includeMetadataChanges: options.includeMetadataChanges
        };
        if (isPartialObserver(args[currArg])) {
            observer = args[currArg];
        }
        else {
            validateArgType('DocumentReference.onSnapshot', 'function', currArg, args[currArg]);
            validateOptionalArgType('DocumentReference.onSnapshot', 'function', currArg + 1, args[currArg + 1]);
            validateOptionalArgType('DocumentReference.onSnapshot', 'function', currArg + 2, args[currArg + 2]);
            observer = {
                next: args[currArg],
                error: args[currArg + 1],
                complete: args[currArg + 2]
            };
        }
        return this.onSnapshotInternal(internalOptions, observer);
    };
    DocumentReference.prototype.onSnapshotInternal = function (options, observer) {
        var _this = this;
        var errHandler = function (err) {
            console.error('Uncaught Error in onSnapshot:', err);
        };
        if (observer.error) {
            errHandler = observer.error.bind(observer);
        }
        var asyncObserver = new AsyncObserver({
            next: function (snapshot) {
                if (observer.next) {
                    assert(snapshot.docs.size <= 1, 'Too many documents returned on a document query');
                    var doc = snapshot.docs.get(_this._key);
                    observer.next(new DocumentSnapshot(_this.firestore, _this._key, doc, snapshot.fromCache, snapshot.hasPendingWrites));
                }
            },
            error: errHandler
        });
        var internalListener = this._firestoreClient.listen(Query.atPath(this._key.path), asyncObserver, options);
        return function () {
            asyncObserver.mute();
            _this._firestoreClient.unlisten(internalListener);
        };
    };
    DocumentReference.prototype.get = function (options) {
        var _this = this;
        validateBetweenNumberOfArgs('DocumentReference.get', arguments, 0, 1);
        validateGetOptions('DocumentReference.get', options);
        return new Promise(function (resolve, reject) {
            if (options && options.source === 'cache') {
                _this.firestore
                    .ensureClientConfigured()
                    .getDocumentFromLocalCache(_this._key)
                    .then(function (doc) {
                    resolve(new DocumentSnapshot(_this.firestore, _this._key, doc, 
                    /*fromCache=*/ true, doc instanceof Document ? doc.hasLocalMutations : false));
                }, reject);
            }
            else {
                _this.getViaSnapshotListener(resolve, reject, options);
            }
        });
    };
    DocumentReference.prototype.getViaSnapshotListener = function (resolve, reject, options) {
        var unlisten = this.onSnapshotInternal({
            includeMetadataChanges: true,
            waitForSyncWhenOnline: true
        }, {
            next: function (snap) {
                // Remove query first before passing event to user to avoid
                // user actions affecting the now stale query.
                unlisten();
                if (!snap.exists && snap.metadata.fromCache) {
                    // TODO(dimond): If we're online and the document doesn't
                    // exist then we resolve with a doc.exists set to false. If
                    // we're offline however, we reject the Promise in this
                    // case. Two options: 1) Cache the negative response from
                    // the server so we can deliver that even when you're
                    // offline 2) Actually reject the Promise in the online case
                    // if the document doesn't exist.
                    reject(new FirestoreError(Code.UNAVAILABLE, 'Failed to get document because the client is ' + 'offline.'));
                }
                else if (snap.exists &&
                    snap.metadata.fromCache &&
                    options &&
                    options.source === 'server') {
                    reject(new FirestoreError(Code.UNAVAILABLE, 'Failed to get document from server. (However, this ' +
                        'document does exist in the local cache. Run again ' +
                        'without setting source to "server" to ' +
                        'retrieve the cached document.)'));
                }
                else {
                    resolve(snap);
                }
            },
            error: reject
        });
    };
    return DocumentReference;
}());
var SnapshotMetadata = /** @class */ (function () {
    function SnapshotMetadata(hasPendingWrites, fromCache) {
        this.hasPendingWrites = hasPendingWrites;
        this.fromCache = fromCache;
    }
    SnapshotMetadata.prototype.isEqual = function (other) {
        return (this.hasPendingWrites === other.hasPendingWrites &&
            this.fromCache === other.fromCache);
    };
    return SnapshotMetadata;
}());
var DocumentSnapshot = /** @class */ (function () {
    function DocumentSnapshot(_firestore, _key, _document, _fromCache, _hasPendingWrites) {
        this._firestore = _firestore;
        this._key = _key;
        this._document = _document;
        this._fromCache = _fromCache;
        this._hasPendingWrites = _hasPendingWrites;
    }
    DocumentSnapshot.prototype.data = function (options) {
        validateBetweenNumberOfArgs('DocumentSnapshot.data', arguments, 0, 1);
        options = validateSnapshotOptions('DocumentSnapshot.data', options);
        return !this._document
            ? undefined
            : this.convertObject(this._document.data(), FieldValueOptions.fromSnapshotOptions(options, this._firestore._areTimestampsInSnapshotsEnabled()));
    };
    DocumentSnapshot.prototype.get = function (fieldPath, options) {
        validateBetweenNumberOfArgs('DocumentSnapshot.get', arguments, 1, 2);
        options = validateSnapshotOptions('DocumentSnapshot.get', options);
        if (this._document) {
            var value = this._document
                .data()
                .field(fieldPathFromArgument('DocumentSnapshot.get', fieldPath));
            if (value !== null) {
                return this.convertValue(value, FieldValueOptions.fromSnapshotOptions(options, this._firestore._areTimestampsInSnapshotsEnabled()));
            }
        }
        return undefined;
    };
    Object.defineProperty(DocumentSnapshot.prototype, "id", {
        get: function () {
            return this._key.path.lastSegment();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentSnapshot.prototype, "ref", {
        get: function () {
            return new DocumentReference(this._key, this._firestore);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentSnapshot.prototype, "exists", {
        get: function () {
            return this._document !== null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentSnapshot.prototype, "metadata", {
        get: function () {
            return new SnapshotMetadata(this._hasPendingWrites, this._fromCache);
        },
        enumerable: true,
        configurable: true
    });
    DocumentSnapshot.prototype.isEqual = function (other) {
        if (!(other instanceof DocumentSnapshot)) {
            throw invalidClassError('isEqual', 'DocumentSnapshot', 1, other);
        }
        return (this._firestore === other._firestore &&
            this._fromCache === other._fromCache &&
            this._key.isEqual(other._key) &&
            (this._document === null
                ? other._document === null
                : this._document.isEqual(other._document)));
    };
    DocumentSnapshot.prototype.convertObject = function (data, options) {
        var _this = this;
        var result = {};
        data.forEach(function (key, value) {
            result[key] = _this.convertValue(value, options);
        });
        return result;
    };
    DocumentSnapshot.prototype.convertValue = function (value, options) {
        if (value instanceof ObjectValue) {
            return this.convertObject(value, options);
        }
        else if (value instanceof ArrayValue) {
            return this.convertArray(value, options);
        }
        else if (value instanceof RefValue) {
            var key = value.value(options);
            var database = this._firestore.ensureClientConfigured().databaseId();
            if (!value.databaseId.isEqual(database)) {
                // TODO(b/64130202): Somehow support foreign references.
                error("Document " + this._key.path + " contains a document " +
                    "reference within a different database (" +
                    (value.databaseId.projectId + "/" + value.databaseId.database + ") which is not ") +
                    "supported. It will be treated as a reference in the current " +
                    ("database (" + database.projectId + "/" + database.database + ") ") +
                    "instead.");
            }
            return new DocumentReference(key, this._firestore);
        }
        else {
            return value.value(options);
        }
    };
    DocumentSnapshot.prototype.convertArray = function (data, options) {
        var _this = this;
        return data.internalValue.map(function (value) {
            return _this.convertValue(value, options);
        });
    };
    return DocumentSnapshot;
}());
var QueryDocumentSnapshot = /** @class */ (function (_super) {
    tslib.__extends(QueryDocumentSnapshot, _super);
    function QueryDocumentSnapshot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    QueryDocumentSnapshot.prototype.data = function (options) {
        var data = _super.prototype.data.call(this, options);
        assert(typeof data === 'object', 'Document in a QueryDocumentSnapshot should exist');
        return data;
    };
    return QueryDocumentSnapshot;
}(DocumentSnapshot));
var Query$1 = /** @class */ (function () {
    function Query(_query, firestore) {
        this._query = _query;
        this.firestore = firestore;
    }
    Query.prototype.where = function (field, opStr, value) {
        validateExactNumberOfArgs('Query.where', arguments, 3);
        validateDefined('Query.where', 3, value);
        // Enumerated from the WhereFilterOp type in index.d.ts.
        var whereFilterOpEnums = [
            '<',
            '<=',
            '==',
            '>=',
            '>',
            'array-contains',
            'in',
            'array-contains-any'
        ];
        validateStringEnum('Query.where', whereFilterOpEnums, 2, opStr);
        var fieldValue;
        var fieldPath = fieldPathFromArgument('Query.where', field);
        var operator = Operator.fromString(opStr);
        if (fieldPath.isKeyField()) {
            if (operator === Operator.ARRAY_CONTAINS ||
                operator === Operator.ARRAY_CONTAINS_ANY) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid Query. You can't perform '" + operator.toString() + "' " +
                    'queries on FieldPath.documentId().');
            }
            else if (operator === Operator.IN) {
                this.validateDisjunctiveFilterElements(value, operator);
                var referenceList = [];
                for (var _i = 0, _a = value; _i < _a.length; _i++) {
                    var arrayValue = _a[_i];
                    referenceList.push(this.parseDocumentIdValue(arrayValue));
                }
                fieldValue = new ArrayValue(referenceList);
            }
            else {
                fieldValue = this.parseDocumentIdValue(value);
            }
        }
        else {
            if (operator === Operator.IN ||
                operator === Operator.ARRAY_CONTAINS_ANY) {
                this.validateDisjunctiveFilterElements(value, operator);
            }
            fieldValue = this.firestore._dataConverter.parseQueryValue('Query.where', value, 
            // We only allow nested arrays for IN queries.
            /** allowArrays = */ operator === Operator.IN ? true : false);
        }
        var filter = FieldFilter.create(fieldPath, operator, fieldValue);
        this.validateNewFilter(filter);
        return new Query(this._query.addFilter(filter), this.firestore);
    };
    Query.prototype.orderBy = function (field, directionStr) {
        validateBetweenNumberOfArgs('Query.orderBy', arguments, 1, 2);
        validateOptionalArgType('Query.orderBy', 'non-empty string', 2, directionStr);
        var direction;
        if (directionStr === undefined || directionStr === 'asc') {
            direction = Direction.ASCENDING;
        }
        else if (directionStr === 'desc') {
            direction = Direction.DESCENDING;
        }
        else {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Function Query.orderBy() has unknown direction '" + directionStr + "', " +
                "expected 'asc' or 'desc'.");
        }
        if (this._query.startAt !== null) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. You must not call Query.startAt() or ' +
                'Query.startAfter() before calling Query.orderBy().');
        }
        if (this._query.endAt !== null) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. You must not call Query.endAt() or ' +
                'Query.endBefore() before calling Query.orderBy().');
        }
        var fieldPath = fieldPathFromArgument('Query.orderBy', field);
        var orderBy = new OrderBy(fieldPath, direction);
        this.validateNewOrderBy(orderBy);
        return new Query(this._query.addOrderBy(orderBy), this.firestore);
    };
    Query.prototype.limit = function (n) {
        validateExactNumberOfArgs('Query.limit', arguments, 1);
        validateArgType('Query.limit', 'number', 1, n);
        validatePositiveNumber('Query.limit', 1, n);
        return new Query(this._query.withLimitToFirst(n), this.firestore);
    };
    Query.prototype.limitToLast = function (n) {
        validateExactNumberOfArgs('Query.limitToLast', arguments, 1);
        validateArgType('Query.limitToLast', 'number', 1, n);
        validatePositiveNumber('Query.limitToLast', 1, n);
        return new Query(this._query.withLimitToLast(n), this.firestore);
    };
    Query.prototype.startAt = function (docOrField) {
        var fields = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            fields[_i - 1] = arguments[_i];
        }
        validateAtLeastNumberOfArgs('Query.startAt', arguments, 1);
        var bound = this.boundFromDocOrFields('Query.startAt', docOrField, fields, 
        /*before=*/ true);
        return new Query(this._query.withStartAt(bound), this.firestore);
    };
    Query.prototype.startAfter = function (docOrField) {
        var fields = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            fields[_i - 1] = arguments[_i];
        }
        validateAtLeastNumberOfArgs('Query.startAfter', arguments, 1);
        var bound = this.boundFromDocOrFields('Query.startAfter', docOrField, fields, 
        /*before=*/ false);
        return new Query(this._query.withStartAt(bound), this.firestore);
    };
    Query.prototype.endBefore = function (docOrField) {
        var fields = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            fields[_i - 1] = arguments[_i];
        }
        validateAtLeastNumberOfArgs('Query.endBefore', arguments, 1);
        var bound = this.boundFromDocOrFields('Query.endBefore', docOrField, fields, 
        /*before=*/ true);
        return new Query(this._query.withEndAt(bound), this.firestore);
    };
    Query.prototype.endAt = function (docOrField) {
        var fields = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            fields[_i - 1] = arguments[_i];
        }
        validateAtLeastNumberOfArgs('Query.endAt', arguments, 1);
        var bound = this.boundFromDocOrFields('Query.endAt', docOrField, fields, 
        /*before=*/ false);
        return new Query(this._query.withEndAt(bound), this.firestore);
    };
    Query.prototype.isEqual = function (other) {
        if (!(other instanceof Query)) {
            throw invalidClassError('isEqual', 'Query', 1, other);
        }
        return (this.firestore === other.firestore && this._query.isEqual(other._query));
    };
    /** Helper function to create a bound from a document or fields */
    Query.prototype.boundFromDocOrFields = function (methodName, docOrField, fields, before) {
        validateDefined(methodName, 1, docOrField);
        if (docOrField instanceof DocumentSnapshot) {
            if (fields.length > 0) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, "Too many arguments provided to " + methodName + "().");
            }
            var snap = docOrField;
            if (!snap.exists) {
                throw new FirestoreError(Code.NOT_FOUND, "Can't use a DocumentSnapshot that doesn't exist for " +
                    (methodName + "()."));
            }
            return this.boundFromDocument(methodName, snap._document, before);
        }
        else {
            var allFields = [docOrField].concat(fields);
            return this.boundFromFields(methodName, allFields, before);
        }
    };
    /**
     * Create a Bound from a query and a document.
     *
     * Note that the Bound will always include the key of the document
     * and so only the provided document will compare equal to the returned
     * position.
     *
     * Will throw if the document does not contain all fields of the order by
     * of the query or if any of the fields in the order by are an uncommitted
     * server timestamp.
     */
    Query.prototype.boundFromDocument = function (methodName, doc, before) {
        var components = [];
        // Because people expect to continue/end a query at the exact document
        // provided, we need to use the implicit sort order rather than the explicit
        // sort order, because it's guaranteed to contain the document key. That way
        // the position becomes unambiguous and the query continues/ends exactly at
        // the provided document. Without the key (by using the explicit sort
        // orders), multiple documents could match the position, yielding duplicate
        // results.
        for (var _i = 0, _a = this._query.orderBy; _i < _a.length; _i++) {
            var orderBy = _a[_i];
            if (orderBy.field.isKeyField()) {
                components.push(new RefValue(this.firestore._databaseId, doc.key));
            }
            else {
                var value = doc.field(orderBy.field);
                if (value instanceof ServerTimestampValue) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. You are trying to start or end a query using a ' +
                        'document for which the field "' +
                        orderBy.field +
                        '" is an uncommitted server timestamp. (Since the value of ' +
                        'this field is unknown, you cannot start/end a query with it.)');
                }
                else if (value !== null) {
                    components.push(value);
                }
                else {
                    var field = orderBy.field.canonicalString();
                    throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. You are trying to start or end a query using a " +
                        ("document for which the field '" + field + "' (used as the ") +
                        "orderBy) does not exist.");
                }
            }
        }
        return new Bound(components, before);
    };
    /**
     * Converts a list of field values to a Bound for the given query.
     */
    Query.prototype.boundFromFields = function (methodName, values, before) {
        // Use explicit order by's because it has to match the query the user made
        var orderBy = this._query.explicitOrderBy;
        if (values.length > orderBy.length) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Too many arguments provided to " + methodName + "(). " +
                "The number of arguments must be less than or equal to the " +
                "number of Query.orderBy() clauses");
        }
        var components = [];
        for (var i = 0; i < values.length; i++) {
            var rawValue = values[i];
            var orderByComponent = orderBy[i];
            if (orderByComponent.field.isKeyField()) {
                if (typeof rawValue !== 'string') {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. Expected a string for document ID in " +
                        (methodName + "(), but got a " + typeof rawValue));
                }
                if (!this._query.isCollectionGroupQuery() &&
                    rawValue.indexOf('/') !== -1) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. When querying a collection and ordering by FieldPath.documentId(), " +
                        ("the value passed to " + methodName + "() must be a plain document ID, but ") +
                        ("'" + rawValue + "' contains a slash."));
                }
                var path = this._query.path.child(ResourcePath.fromString(rawValue));
                if (!DocumentKey.isDocumentKey(path)) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. When querying a collection group and ordering by " +
                        ("FieldPath.documentId(), the value passed to " + methodName + "() must result in a ") +
                        ("valid document path, but '" + path + "' is not because it contains an odd number ") +
                        "of segments.");
                }
                var key = new DocumentKey(path);
                components.push(new RefValue(this.firestore._databaseId, key));
            }
            else {
                var wrapped = this.firestore._dataConverter.parseQueryValue(methodName, rawValue);
                components.push(wrapped);
            }
        }
        return new Bound(components, before);
    };
    Query.prototype.onSnapshot = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        validateBetweenNumberOfArgs('Query.onSnapshot', arguments, 1, 4);
        var options = {};
        var observer;
        var currArg = 0;
        if (typeof args[currArg] === 'object' &&
            !isPartialObserver(args[currArg])) {
            options = args[currArg];
            validateOptionNames('Query.onSnapshot', options, [
                'includeMetadataChanges'
            ]);
            validateNamedOptionalType('Query.onSnapshot', 'boolean', 'includeMetadataChanges', options.includeMetadataChanges);
            currArg++;
        }
        if (isPartialObserver(args[currArg])) {
            observer = args[currArg];
        }
        else {
            validateArgType('Query.onSnapshot', 'function', currArg, args[currArg]);
            validateOptionalArgType('Query.onSnapshot', 'function', currArg + 1, args[currArg + 1]);
            validateOptionalArgType('Query.onSnapshot', 'function', currArg + 2, args[currArg + 2]);
            observer = {
                next: args[currArg],
                error: args[currArg + 1],
                complete: args[currArg + 2]
            };
        }
        this.validateHasExplicitOrderByForLimitToLast(this._query);
        return this.onSnapshotInternal(options, observer);
    };
    Query.prototype.onSnapshotInternal = function (options, observer) {
        var _this = this;
        var errHandler = function (err) {
            console.error('Uncaught Error in onSnapshot:', err);
        };
        if (observer.error) {
            errHandler = observer.error.bind(observer);
        }
        var asyncObserver = new AsyncObserver({
            next: function (result) {
                if (observer.next) {
                    observer.next(new QuerySnapshot(_this.firestore, _this._query, result));
                }
            },
            error: errHandler
        });
        var firestoreClient = this.firestore.ensureClientConfigured();
        var internalListener = firestoreClient.listen(this._query, asyncObserver, options);
        return function () {
            asyncObserver.mute();
            firestoreClient.unlisten(internalListener);
        };
    };
    Query.prototype.validateHasExplicitOrderByForLimitToLast = function (query) {
        if (query.hasLimitToLast() && query.explicitOrderBy.length === 0) {
            throw new FirestoreError(Code.UNIMPLEMENTED, 'limitToLast() queries require specifying at least one orderBy() clause');
        }
    };
    Query.prototype.get = function (options) {
        var _this = this;
        validateBetweenNumberOfArgs('Query.get', arguments, 0, 1);
        validateGetOptions('Query.get', options);
        this.validateHasExplicitOrderByForLimitToLast(this._query);
        return new Promise(function (resolve, reject) {
            if (options && options.source === 'cache') {
                _this.firestore
                    .ensureClientConfigured()
                    .getDocumentsFromLocalCache(_this._query)
                    .then(function (viewSnap) {
                    resolve(new QuerySnapshot(_this.firestore, _this._query, viewSnap));
                }, reject);
            }
            else {
                _this.getViaSnapshotListener(resolve, reject, options);
            }
        });
    };
    Query.prototype.getViaSnapshotListener = function (resolve, reject, options) {
        var unlisten = this.onSnapshotInternal({
            includeMetadataChanges: true,
            waitForSyncWhenOnline: true
        }, {
            next: function (result) {
                // Remove query first before passing event to user to avoid
                // user actions affecting the now stale query.
                unlisten();
                if (result.metadata.fromCache &&
                    options &&
                    options.source === 'server') {
                    reject(new FirestoreError(Code.UNAVAILABLE, 'Failed to get documents from server. (However, these ' +
                        'documents may exist in the local cache. Run again ' +
                        'without setting source to "server" to ' +
                        'retrieve the cached documents.)'));
                }
                else {
                    resolve(result);
                }
            },
            error: reject
        });
    };
    /**
     * Parses the given documentIdValue into a ReferenceValue, throwing
     * appropriate errors if the value is anything other than a DocumentReference
     * or String, or if the string is malformed.
     */
    Query.prototype.parseDocumentIdValue = function (documentIdValue) {
        if (typeof documentIdValue === 'string') {
            if (documentIdValue === '') {
                throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. When querying with FieldPath.documentId(), you ' +
                    'must provide a valid document ID, but it was an empty string.');
            }
            if (!this._query.isCollectionGroupQuery() &&
                documentIdValue.indexOf('/') !== -1) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. When querying a collection by " +
                    "FieldPath.documentId(), you must provide a plain document ID, but " +
                    ("'" + documentIdValue + "' contains a '/' character."));
            }
            var path = this._query.path.child(ResourcePath.fromString(documentIdValue));
            if (!DocumentKey.isDocumentKey(path)) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. When querying a collection group by " +
                    "FieldPath.documentId(), the value provided must result in a valid document path, " +
                    ("but '" + path + "' is not because it has an odd number of segments (" + path.length + ")."));
            }
            return new RefValue(this.firestore._databaseId, new DocumentKey(path));
        }
        else if (documentIdValue instanceof DocumentReference) {
            var ref = documentIdValue;
            return new RefValue(this.firestore._databaseId, ref._key);
        }
        else {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. When querying with FieldPath.documentId(), you must provide a valid " +
                "string or a DocumentReference, but it was: " +
                (valueDescription(documentIdValue) + "."));
        }
    };
    /**
     * Validates that the value passed into a disjunctrive filter satisfies all
     * array requirements.
     */
    Query.prototype.validateDisjunctiveFilterElements = function (value, operator) {
        if (!Array.isArray(value) || value.length === 0) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid Query. A non-empty array is required for ' +
                ("'" + operator.toString() + "' filters."));
        }
        if (value.length > 10) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid Query. '" + operator.toString() + "' filters support a " +
                'maximum of 10 elements in the value array.');
        }
        if (value.indexOf(null) >= 0) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid Query. '" + operator.toString() + "' filters cannot contain 'null' " +
                'in the value array.');
        }
        if (value.filter(function (element) { return Number.isNaN(element); }).length > 0) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid Query. '" + operator.toString() + "' filters cannot contain 'NaN' " +
                'in the value array.');
        }
    };
    Query.prototype.validateNewFilter = function (filter) {
        if (filter instanceof FieldFilter) {
            var arrayOps = [Operator.ARRAY_CONTAINS, Operator.ARRAY_CONTAINS_ANY];
            var disjunctiveOps = [Operator.IN, Operator.ARRAY_CONTAINS_ANY];
            var isArrayOp = arrayOps.indexOf(filter.op) >= 0;
            var isDisjunctiveOp = disjunctiveOps.indexOf(filter.op) >= 0;
            if (filter.isInequality()) {
                var existingField = this._query.getInequalityFilterField();
                if (existingField !== null && !existingField.isEqual(filter.field)) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. All where filters with an inequality' +
                        ' (<, <=, >, or >=) must be on the same field. But you have' +
                        (" inequality filters on '" + existingField.toString() + "'") +
                        (" and '" + filter.field.toString() + "'"));
                }
                var firstOrderByField = this._query.getFirstOrderByField();
                if (firstOrderByField !== null) {
                    this.validateOrderByAndInequalityMatch(filter.field, firstOrderByField);
                }
            }
            else if (isDisjunctiveOp || isArrayOp) {
                // You can have at most 1 disjunctive filter and 1 array filter. Check if
                // the new filter conflicts with an existing one.
                var conflictingOp = null;
                if (isDisjunctiveOp) {
                    conflictingOp = this._query.findFilterOperator(disjunctiveOps);
                }
                if (conflictingOp === null && isArrayOp) {
                    conflictingOp = this._query.findFilterOperator(arrayOps);
                }
                if (conflictingOp != null) {
                    // We special case when it's a duplicate op to give a slightly clearer error message.
                    if (conflictingOp === filter.op) {
                        throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. You cannot use more than one ' +
                            ("'" + filter.op.toString() + "' filter."));
                    }
                    else {
                        throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. You cannot use '" + filter.op.toString() + "' filters " +
                            ("with '" + conflictingOp.toString() + "' filters."));
                    }
                }
            }
        }
    };
    Query.prototype.validateNewOrderBy = function (orderBy) {
        if (this._query.getFirstOrderByField() === null) {
            // This is the first order by. It must match any inequality.
            var inequalityField = this._query.getInequalityFilterField();
            if (inequalityField !== null) {
                this.validateOrderByAndInequalityMatch(inequalityField, orderBy.field);
            }
        }
    };
    Query.prototype.validateOrderByAndInequalityMatch = function (inequality, orderBy) {
        if (!orderBy.isEqual(inequality)) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. You have a where filter with an inequality " +
                ("(<, <=, >, or >=) on field '" + inequality.toString() + "' ") +
                ("and so you must also use '" + inequality.toString() + "' ") +
                "as your first Query.orderBy(), but your first Query.orderBy() " +
                ("is on field '" + orderBy.toString() + "' instead."));
        }
    };
    return Query;
}());
var QuerySnapshot = /** @class */ (function () {
    function QuerySnapshot(_firestore, _originalQuery, _snapshot) {
        this._firestore = _firestore;
        this._originalQuery = _originalQuery;
        this._snapshot = _snapshot;
        this._cachedChanges = null;
        this._cachedChangesIncludeMetadataChanges = null;
        this.metadata = new SnapshotMetadata(_snapshot.hasPendingWrites, _snapshot.fromCache);
    }
    Object.defineProperty(QuerySnapshot.prototype, "docs", {
        get: function () {
            var result = [];
            this.forEach(function (doc) { return result.push(doc); });
            return result;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuerySnapshot.prototype, "empty", {
        get: function () {
            return this._snapshot.docs.isEmpty();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuerySnapshot.prototype, "size", {
        get: function () {
            return this._snapshot.docs.size;
        },
        enumerable: true,
        configurable: true
    });
    QuerySnapshot.prototype.forEach = function (callback, thisArg) {
        var _this = this;
        validateBetweenNumberOfArgs('QuerySnapshot.forEach', arguments, 1, 2);
        validateArgType('QuerySnapshot.forEach', 'function', 1, callback);
        this._snapshot.docs.forEach(function (doc) {
            callback.call(thisArg, _this.convertToDocumentImpl(doc));
        });
    };
    Object.defineProperty(QuerySnapshot.prototype, "query", {
        get: function () {
            return new Query$1(this._originalQuery, this._firestore);
        },
        enumerable: true,
        configurable: true
    });
    QuerySnapshot.prototype.docChanges = function (options) {
        if (options) {
            validateOptionNames('QuerySnapshot.docChanges', options, [
                'includeMetadataChanges'
            ]);
            validateNamedOptionalType('QuerySnapshot.docChanges', 'boolean', 'includeMetadataChanges', options.includeMetadataChanges);
        }
        var includeMetadataChanges = !!(options && options.includeMetadataChanges);
        if (includeMetadataChanges && this._snapshot.excludesMetadataChanges) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'To include metadata changes with your document changes, you must ' +
                'also pass { includeMetadataChanges:true } to onSnapshot().');
        }
        if (!this._cachedChanges ||
            this._cachedChangesIncludeMetadataChanges !== includeMetadataChanges) {
            this._cachedChanges = changesFromSnapshot(this._firestore, includeMetadataChanges, this._snapshot);
            this._cachedChangesIncludeMetadataChanges = includeMetadataChanges;
        }
        return this._cachedChanges;
    };
    /** Check the equality. The call can be very expensive. */
    QuerySnapshot.prototype.isEqual = function (other) {
        if (!(other instanceof QuerySnapshot)) {
            throw invalidClassError('isEqual', 'QuerySnapshot', 1, other);
        }
        return (this._firestore === other._firestore &&
            this._originalQuery.isEqual(other._originalQuery) &&
            this._snapshot.isEqual(other._snapshot));
    };
    QuerySnapshot.prototype.convertToDocumentImpl = function (doc) {
        return new QueryDocumentSnapshot(this._firestore, doc.key, doc, this.metadata.fromCache, this._snapshot.mutatedKeys.has(doc.key));
    };
    return QuerySnapshot;
}());
// TODO(2018/11/01): As of 2018/04/17 we're changing docChanges from an array
// into a method. Because this is a runtime breaking change and somewhat subtle
// (both Array and Function have a .length, etc.), we'll replace commonly-used
// properties (including Symbol.iterator) to throw a custom error message. In
// ~6 months we can delete the custom error as most folks will have hopefully
// migrated.
function throwDocChangesMethodError() {
    throw new FirestoreError(Code.INVALID_ARGUMENT, 'QuerySnapshot.docChanges has been changed from a property into a ' +
        'method, so usages like "querySnapshot.docChanges" should become ' +
        '"querySnapshot.docChanges()"');
}
var docChangesPropertiesToOverride = tslib.__spreadArrays([
    'length',
    'forEach',
    'map'
], (typeof Symbol !== 'undefined' ? [Symbol.iterator] : []));
docChangesPropertiesToOverride.forEach(function (property) {
    /**
     * We are (re-)defining properties on QuerySnapshot.prototype.docChanges which
     * is a Function. This could fail, in particular in the case of 'length' which
     * already exists on Function.prototype and on IE11 is improperly defined with
     * `{ configurable: false }`. So we wrap this in a try/catch to ensure that we
     * still have a functional SDK.
     */
    try {
        Object.defineProperty(QuerySnapshot.prototype.docChanges, property, {
            get: function () { return throwDocChangesMethodError(); }
        });
    }
    catch (err) { } // Ignore this failure intentionally
});
var CollectionReference = /** @class */ (function (_super) {
    tslib.__extends(CollectionReference, _super);
    function CollectionReference(path, firestore) {
        var _this = _super.call(this, Query.atPath(path), firestore) || this;
        if (path.length % 2 !== 1) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid collection reference. Collection ' +
                'references must have an odd number of segments, but ' +
                (path.canonicalString() + " has " + path.length));
        }
        return _this;
    }
    Object.defineProperty(CollectionReference.prototype, "id", {
        get: function () {
            return this._query.path.lastSegment();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CollectionReference.prototype, "parent", {
        get: function () {
            var parentPath = this._query.path.popLast();
            if (parentPath.isEmpty()) {
                return null;
            }
            else {
                return new DocumentReference(new DocumentKey(parentPath), this.firestore);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CollectionReference.prototype, "path", {
        get: function () {
            return this._query.path.canonicalString();
        },
        enumerable: true,
        configurable: true
    });
    CollectionReference.prototype.doc = function (pathString) {
        validateBetweenNumberOfArgs('CollectionReference.doc', arguments, 0, 1);
        // We allow omission of 'pathString' but explicitly prohibit passing in both
        // 'undefined' and 'null'.
        if (arguments.length === 0) {
            pathString = AutoId.newId();
        }
        validateArgType('CollectionReference.doc', 'non-empty string', 1, pathString);
        if (pathString === '') {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Document path must be a non-empty string');
        }
        var path = ResourcePath.fromString(pathString);
        return DocumentReference.forPath(this._query.path.child(path), this.firestore);
    };
    CollectionReference.prototype.add = function (value) {
        validateExactNumberOfArgs('CollectionReference.add', arguments, 1);
        validateArgType('CollectionReference.add', 'object', 1, value);
        var docRef = this.doc();
        return docRef.set(value).then(function () { return docRef; });
    };
    return CollectionReference;
}(Query$1));
function validateSetOptions(methodName, options) {
    if (options === undefined) {
        return {
            merge: false
        };
    }
    validateOptionNames(methodName, options, ['merge', 'mergeFields']);
    validateNamedOptionalType(methodName, 'boolean', 'merge', options.merge);
    validateOptionalArrayElements(methodName, 'mergeFields', 'a string or a FieldPath', options.mergeFields, function (element) {
        return typeof element === 'string' || element instanceof FieldPath$1;
    });
    if (options.mergeFields !== undefined && options.merge !== undefined) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid options passed to function " + methodName + "(): You cannot specify both \"merge\" " +
            "and \"mergeFields\".");
    }
    return options;
}
function validateSnapshotOptions(methodName, options) {
    if (options === undefined) {
        return {};
    }
    validateOptionNames(methodName, options, ['serverTimestamps']);
    validateNamedOptionalPropertyEquals(methodName, 'options', 'serverTimestamps', options.serverTimestamps, ['estimate', 'previous', 'none']);
    return options;
}
function validateGetOptions(methodName, options) {
    validateOptionalArgType(methodName, 'object', 1, options);
    if (options) {
        validateOptionNames(methodName, options, ['source']);
        validateNamedOptionalPropertyEquals(methodName, 'options', 'source', options.source, ['default', 'server', 'cache']);
    }
}
function validateReference(methodName, documentRef, firestore) {
    if (!(documentRef instanceof DocumentReference)) {
        throw invalidClassError(methodName, 'DocumentReference', 1, documentRef);
    }
    else if (documentRef.firestore !== firestore) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, 'Provided document reference is from a different Firestore instance.');
    }
    else {
        return documentRef;
    }
}
/**
 * Calculates the array of firestore.DocumentChange's for a given ViewSnapshot.
 *
 * Exported for testing.
 */
function changesFromSnapshot(firestore, includeMetadataChanges, snapshot) {
    if (snapshot.oldDocs.isEmpty()) {
        // Special case the first snapshot because index calculation is easy and
        // fast
        var lastDoc_1;
        var index_1 = 0;
        return snapshot.docChanges.map(function (change) {
            var doc = new QueryDocumentSnapshot(firestore, change.doc.key, change.doc, snapshot.fromCache, snapshot.mutatedKeys.has(change.doc.key));
            assert(change.type === ChangeType.Added, 'Invalid event type for first snapshot');
            assert(!lastDoc_1 || snapshot.query.docComparator(lastDoc_1, change.doc) < 0, 'Got added events in wrong order');
            lastDoc_1 = change.doc;
            return {
                type: 'added',
                doc: doc,
                oldIndex: -1,
                newIndex: index_1++
            };
        });
    }
    else {
        // A DocumentSet that is updated incrementally as changes are applied to use
        // to lookup the index of a document.
        var indexTracker_1 = snapshot.oldDocs;
        return snapshot.docChanges
            .filter(function (change) { return includeMetadataChanges || change.type !== ChangeType.Metadata; })
            .map(function (change) {
            var doc = new QueryDocumentSnapshot(firestore, change.doc.key, change.doc, snapshot.fromCache, snapshot.mutatedKeys.has(change.doc.key));
            var oldIndex = -1;
            var newIndex = -1;
            if (change.type !== ChangeType.Added) {
                oldIndex = indexTracker_1.indexOf(change.doc.key);
                assert(oldIndex >= 0, 'Index for document not found');
                indexTracker_1 = indexTracker_1.delete(change.doc.key);
            }
            if (change.type !== ChangeType.Removed) {
                indexTracker_1 = indexTracker_1.add(change.doc);
                newIndex = indexTracker_1.indexOf(change.doc.key);
            }
            return { type: resultChangeType(change.type), doc: doc, oldIndex: oldIndex, newIndex: newIndex };
        });
    }
}
function resultChangeType(type) {
    switch (type) {
        case ChangeType.Added:
            return 'added';
        case ChangeType.Modified:
        case ChangeType.Metadata:
            return 'modified';
        case ChangeType.Removed:
            return 'removed';
        default:
            return fail('Unknown change type: ' + type);
    }
}
// Export the classes with a private constructor (it will fail if invoked
// at runtime). Note that this still allows instanceof checks.
// We're treating the variables as class names, so disable checking for lower
// case variable names.
var PublicFirestore = makeConstructorPrivate(Firestore, 'Use firebase.firestore() instead.');
var PublicTransaction = makeConstructorPrivate(Transaction$1, 'Use firebase.firestore().runTransaction() instead.');
var PublicWriteBatch = makeConstructorPrivate(WriteBatch, 'Use firebase.firestore().batch() instead.');
var PublicDocumentReference = makeConstructorPrivate(DocumentReference, 'Use firebase.firestore().doc() instead.');
var PublicDocumentSnapshot = makeConstructorPrivate(DocumentSnapshot);
var PublicQueryDocumentSnapshot = makeConstructorPrivate(QueryDocumentSnapshot);
var PublicQuery = makeConstructorPrivate(Query$1);
var PublicQuerySnapshot = makeConstructorPrivate(QuerySnapshot);
var PublicCollectionReference = makeConstructorPrivate(CollectionReference, 'Use firebase.firestore().collection() instead.');

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var firestoreNamespace = {
    Firestore: PublicFirestore,
    GeoPoint: GeoPoint,
    Timestamp: Timestamp,
    Blob: PublicBlob,
    Transaction: PublicTransaction,
    WriteBatch: PublicWriteBatch,
    DocumentReference: PublicDocumentReference,
    DocumentSnapshot: PublicDocumentSnapshot,
    Query: PublicQuery,
    QueryDocumentSnapshot: PublicQueryDocumentSnapshot,
    QuerySnapshot: PublicQuerySnapshot,
    CollectionReference: PublicCollectionReference,
    FieldPath: FieldPath$1,
    FieldValue: PublicFieldValue,
    setLogLevel: Firestore.setLogLevel,
    CACHE_SIZE_UNLIMITED: CACHE_SIZE_UNLIMITED
};
/**
 * Configures Firestore as part of the Firebase SDK by calling registerService.
 */
function configureForFirebase(firebase) {
    firebase.INTERNAL.registerService('firestore', function (app) { return new Firestore(app); }, shallowCopy(firestoreNamespace));
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var NoopConnectivityMonitor = /** @class */ (function () {
    function NoopConnectivityMonitor() {
    }
    NoopConnectivityMonitor.prototype.addCallback = function (callback) {
        // No-op.
    };
    NoopConnectivityMonitor.prototype.shutdown = function () {
        // No-op.
    };
    return NoopConnectivityMonitor;
}());

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$c = 'ConnectivityMonitor';
/**
 * Browser implementation of ConnectivityMonitor.
 */
var BrowserConnectivityMonitor = /** @class */ (function () {
    function BrowserConnectivityMonitor() {
        var _this = this;
        this.networkAvailableListener = function () {
            return _this.onNetworkAvailable();
        };
        this.networkUnavailableListener = function () {
            return _this.onNetworkUnavailable();
        };
        this.callbacks = [];
        this.configureNetworkMonitoring();
    }
    BrowserConnectivityMonitor.prototype.addCallback = function (callback) {
        this.callbacks.push(callback);
    };
    BrowserConnectivityMonitor.prototype.shutdown = function () {
        window.removeEventListener('online', this.networkAvailableListener);
        window.removeEventListener('offline', this.networkUnavailableListener);
    };
    BrowserConnectivityMonitor.prototype.configureNetworkMonitoring = function () {
        window.addEventListener('online', this.networkAvailableListener);
        window.addEventListener('offline', this.networkUnavailableListener);
    };
    BrowserConnectivityMonitor.prototype.onNetworkAvailable = function () {
        debug(LOG_TAG$c, 'Network connectivity changed: AVAILABLE');
        for (var _i = 0, _a = this.callbacks; _i < _a.length; _i++) {
            var callback = _a[_i];
            callback(0 /* AVAILABLE */);
        }
    };
    BrowserConnectivityMonitor.prototype.onNetworkUnavailable = function () {
        debug(LOG_TAG$c, 'Network connectivity changed: UNAVAILABLE');
        for (var _i = 0, _a = this.callbacks; _i < _a.length; _i++) {
            var callback = _a[_i];
            callback(1 /* UNAVAILABLE */);
        }
    };
    // TODO(chenbrian): Consider passing in window either into this component or
    // here for testing via FakeWindow.
    /** Checks that all used attributes of window are available. */
    BrowserConnectivityMonitor.isAvailable = function () {
        return (typeof window !== 'undefined' &&
            window.addEventListener !== undefined &&
            window.removeEventListener !== undefined);
    };
    return BrowserConnectivityMonitor;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provides a simple helper class that implements the Stream interface to
 * bridge to other implementations that are streams but do not implement the
 * interface. The stream callbacks are invoked with the callOn... methods.
 */
var StreamBridge = /** @class */ (function () {
    function StreamBridge(args) {
        this.sendFn = args.sendFn;
        this.closeFn = args.closeFn;
    }
    StreamBridge.prototype.onOpen = function (callback) {
        assert(!this.wrappedOnOpen, 'Called onOpen on stream twice!');
        this.wrappedOnOpen = callback;
    };
    StreamBridge.prototype.onClose = function (callback) {
        assert(!this.wrappedOnClose, 'Called onClose on stream twice!');
        this.wrappedOnClose = callback;
    };
    StreamBridge.prototype.onMessage = function (callback) {
        assert(!this.wrappedOnMessage, 'Called onMessage on stream twice!');
        this.wrappedOnMessage = callback;
    };
    StreamBridge.prototype.close = function () {
        this.closeFn();
    };
    StreamBridge.prototype.send = function (msg) {
        this.sendFn(msg);
    };
    StreamBridge.prototype.callOnOpen = function () {
        assert(this.wrappedOnOpen !== undefined, 'Cannot call onOpen because no callback was set');
        this.wrappedOnOpen();
    };
    StreamBridge.prototype.callOnClose = function (err) {
        assert(this.wrappedOnClose !== undefined, 'Cannot call onClose because no callback was set');
        this.wrappedOnClose(err);
    };
    StreamBridge.prototype.callOnMessage = function (msg) {
        assert(this.wrappedOnMessage !== undefined, 'Cannot call onMessage because no callback was set');
        this.wrappedOnMessage(msg);
    };
    return StreamBridge;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$d = 'Connection';
var RPC_STREAM_SERVICE = 'google.firestore.v1.Firestore';
var RPC_URL_VERSION = 'v1';
/** Maps RPC names to the corresponding REST endpoint name. */
var RPC_NAME_REST_MAPPING = {
    BatchGetDocuments: 'batchGet',
    Commit: 'commit'
};
// TODO(b/38203344): The SDK_VERSION is set independently from Firebase because
// we are doing out-of-band releases. Once we release as part of Firebase, we
// should use the Firebase version instead.
var X_GOOG_API_CLIENT_VALUE = 'gl-js/ fire/' + SDK_VERSION;
var XHR_TIMEOUT_SECS = 15;
var WebChannelConnection = /** @class */ (function () {
    function WebChannelConnection(info) {
        this.databaseId = info.databaseId;
        var proto = info.ssl ? 'https' : 'http';
        this.baseUrl = proto + '://' + info.host;
        this.forceLongPolling = info.forceLongPolling;
    }
    /**
     * Modifies the headers for a request, adding any authorization token if
     * present and any additional headers for the request.
     */
    WebChannelConnection.prototype.modifyHeadersForRequest = function (headers, token) {
        if (token) {
            for (var header in token.authHeaders) {
                if (token.authHeaders.hasOwnProperty(header)) {
                    headers[header] = token.authHeaders[header];
                }
            }
        }
        headers['X-Goog-Api-Client'] = X_GOOG_API_CLIENT_VALUE;
    };
    WebChannelConnection.prototype.invokeRPC = function (rpcName, request, token) {
        var _this = this;
        var url = this.makeUrl(rpcName);
        return new Promise(function (resolve, reject) {
            // XhrIo doesn't have TS typings.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var xhr = new webchannelWrapper.XhrIo();
            xhr.listenOnce(webchannelWrapper.EventType.COMPLETE, function () {
                try {
                    switch (xhr.getLastErrorCode()) {
                        case webchannelWrapper.ErrorCode.NO_ERROR:
                            var json = xhr.getResponseJson();
                            debug(LOG_TAG$d, 'XHR received:', JSON.stringify(json));
                            resolve(json);
                            break;
                        case webchannelWrapper.ErrorCode.TIMEOUT:
                            debug(LOG_TAG$d, 'RPC "' + rpcName + '" timed out');
                            reject(new FirestoreError(Code.DEADLINE_EXCEEDED, 'Request time out'));
                            break;
                        case webchannelWrapper.ErrorCode.HTTP_ERROR:
                            var status_1 = xhr.getStatus();
                            debug(LOG_TAG$d, 'RPC "' + rpcName + '" failed with status:', status_1, 'response text:', xhr.getResponseText());
                            if (status_1 > 0) {
                                var responseError = xhr.getResponseJson().error;
                                if (!!responseError &&
                                    !!responseError.status &&
                                    !!responseError.message) {
                                    var firestoreErrorCode = mapCodeFromHttpResponseErrorStatus(responseError.status);
                                    reject(new FirestoreError(firestoreErrorCode, responseError.message));
                                }
                                else {
                                    reject(new FirestoreError(Code.UNKNOWN, 'Server responded with status ' + xhr.getStatus()));
                                }
                            }
                            else {
                                // If we received an HTTP_ERROR but there's no status code,
                                // it's most probably a connection issue
                                debug(LOG_TAG$d, 'RPC "' + rpcName + '" failed');
                                reject(new FirestoreError(Code.UNAVAILABLE, 'Connection failed.'));
                            }
                            break;
                        default:
                            fail('RPC "' +
                                rpcName +
                                '" failed with unanticipated ' +
                                'webchannel error ' +
                                xhr.getLastErrorCode() +
                                ': ' +
                                xhr.getLastError() +
                                ', giving up.');
                    }
                }
                finally {
                    debug(LOG_TAG$d, 'RPC "' + rpcName + '" completed.');
                }
            });
            // The database field is already encoded in URL. Specifying it again in
            // the body is not necessary in production, and will cause duplicate field
            // errors in the Firestore Emulator. Let's remove it.
            var jsonObj = tslib.__assign({}, request);
            delete jsonObj.database;
            var requestString = JSON.stringify(jsonObj);
            debug(LOG_TAG$d, 'XHR sending: ', url + ' ' + requestString);
            // Content-Type: text/plain will avoid preflight requests which might
            // mess with CORS and redirects by proxies. If we add custom headers
            // we will need to change this code to potentially use the
            // $httpOverwrite parameter supported by ESF to avoid
            // triggering preflight requests.
            var headers = { 'Content-Type': 'text/plain' };
            _this.modifyHeadersForRequest(headers, token);
            xhr.send(url, 'POST', requestString, headers, XHR_TIMEOUT_SECS);
        });
    };
    WebChannelConnection.prototype.invokeStreamingRPC = function (rpcName, request, token) {
        // The REST API automatically aggregates all of the streamed results, so we
        // can just use the normal invoke() method.
        return this.invokeRPC(rpcName, request, token);
    };
    WebChannelConnection.prototype.openStream = function (rpcName, token) {
        var urlParts = [
            this.baseUrl,
            '/',
            RPC_STREAM_SERVICE,
            '/',
            rpcName,
            '/channel'
        ];
        var webchannelTransport = webchannelWrapper.createWebChannelTransport();
        var request = {
            // Background channel test avoids the initial two test calls and decreases
            // initial cold start time.
            // TODO(dimond): wenboz@ mentioned this might affect use with proxies and
            // we should monitor closely for any reports.
            backgroundChannelTest: true,
            // Required for backend stickiness, routing behavior is based on this
            // parameter.
            httpSessionIdParam: 'gsessionid',
            initMessageHeaders: {},
            messageUrlParams: {
                // This param is used to improve routing and project isolation by the
                // backend and must be included in every request.
                database: "projects/" + this.databaseId.projectId + "/databases/" + this.databaseId.database
            },
            sendRawJson: true,
            supportsCrossDomainXhr: true,
            internalChannelParams: {
                // Override the default timeout (randomized between 10-20 seconds) since
                // a large write batch on a slow internet connection may take a long
                // time to send to the backend. Rather than have WebChannel impose a
                // tight timeout which could lead to infinite timeouts and retries, we
                // set it very large (5-10 minutes) and rely on the browser's builtin
                // timeouts to kick in if the request isn't working.
                forwardChannelRequestTimeoutMs: 10 * 60 * 1000
            },
            forceLongPolling: this.forceLongPolling
        };
        this.modifyHeadersForRequest(request.initMessageHeaders, token);
        // Sending the custom headers we just added to request.initMessageHeaders
        // (Authorization, etc.) will trigger the browser to make a CORS preflight
        // request because the XHR will no longer meet the criteria for a "simple"
        // CORS request:
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
        //
        // Therefore to avoid the CORS preflight request (an extra network
        // roundtrip), we use the httpHeadersOverwriteParam option to specify that
        // the headers should instead be encoded into a special "$httpHeaders" query
        // parameter, which is recognized by the webchannel backend. This is
        // formally defined here:
        // https://github.com/google/closure-library/blob/b0e1815b13fb92a46d7c9b3c30de5d6a396a3245/closure/goog/net/rpc/httpcors.js#L32
        //
        // But for some unclear reason (see
        // https://github.com/firebase/firebase-js-sdk/issues/703), this breaks
        // ReactNative and so we exclude it, which just means ReactNative may be
        // subject to the extra network roundtrip for CORS preflight.
        if (!util.isReactNative()) {
            request.httpHeadersOverwriteParam = '$httpHeaders';
        }
        var url = urlParts.join('');
        debug(LOG_TAG$d, 'Creating WebChannel: ' + url + ' ' + request);
        // Use any because listen isn't defined on it.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var channel = webchannelTransport.createWebChannel(url, request);
        // WebChannel supports sending the first message with the handshake - saving
        // a network round trip. However, it will have to call send in the same
        // JS event loop as open. In order to enforce this, we delay actually
        // opening the WebChannel until send is called. Whether we have called
        // open is tracked with this variable.
        var opened = false;
        // A flag to determine whether the stream was closed (by us or through an
        // error/close event) to avoid delivering multiple close events or sending
        // on a closed stream
        var closed = false;
        var streamBridge = new StreamBridge({
            sendFn: function (msg) {
                if (!closed) {
                    if (!opened) {
                        debug(LOG_TAG$d, 'Opening WebChannel transport.');
                        channel.open();
                        opened = true;
                    }
                    debug(LOG_TAG$d, 'WebChannel sending:', msg);
                    channel.send(msg);
                }
                else {
                    debug(LOG_TAG$d, 'Not sending because WebChannel is closed:', msg);
                }
            },
            closeFn: function () { return channel.close(); }
        });
        // Closure events are guarded and exceptions are swallowed, so catch any
        // exception and rethrow using a setTimeout so they become visible again.
        // Note that eventually this function could go away if we are confident
        // enough the code is exception free.
        var unguardedEventListen = function (type, fn) {
            // TODO(dimond): closure typing seems broken because WebChannel does
            // not implement goog.events.Listenable
            channel.listen(type, function (param) {
                try {
                    fn(param);
                }
                catch (e) {
                    setTimeout(function () {
                        throw e;
                    }, 0);
                }
            });
        };
        unguardedEventListen(webchannelWrapper.WebChannel.EventType.OPEN, function () {
            if (!closed) {
                debug(LOG_TAG$d, 'WebChannel transport opened.');
            }
        });
        unguardedEventListen(webchannelWrapper.WebChannel.EventType.CLOSE, function () {
            if (!closed) {
                closed = true;
                debug(LOG_TAG$d, 'WebChannel transport closed');
                streamBridge.callOnClose();
            }
        });
        unguardedEventListen(webchannelWrapper.WebChannel.EventType.ERROR, function (err) {
            if (!closed) {
                closed = true;
                debug(LOG_TAG$d, 'WebChannel transport errored:', err);
                streamBridge.callOnClose(new FirestoreError(Code.UNAVAILABLE, 'The operation could not be completed'));
            }
        });
        unguardedEventListen(webchannelWrapper.WebChannel.EventType.MESSAGE, function (msg) {
            if (!closed) {
                var msgData = msg.data[0];
                assert(!!msgData, 'Got a webchannel message without data.');
                // TODO(b/35143891): There is a bug in One Platform that caused errors
                // (and only errors) to be wrapped in an extra array. To be forward
                // compatible with the bug we need to check either condition. The latter
                // can be removed once the fix has been rolled out.
                // Use any because msgData.error is not typed.
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                var msgDataAsAny = msgData;
                var error = msgDataAsAny.error || (msgDataAsAny[0] && msgDataAsAny[0].error);
                if (error) {
                    debug(LOG_TAG$d, 'WebChannel received error:', error);
                    // error.status will be a string like 'OK' or 'NOT_FOUND'.
                    var status_2 = error.status;
                    var code = mapCodeFromRpcStatus(status_2);
                    var message = error.message;
                    if (code === undefined) {
                        code = Code.INTERNAL;
                        message =
                            'Unknown error status: ' +
                                status_2 +
                                ' with message ' +
                                error.message;
                    }
                    // Mark closed so no further events are propagated
                    closed = true;
                    streamBridge.callOnClose(new FirestoreError(code, message));
                    channel.close();
                }
                else {
                    debug(LOG_TAG$d, 'WebChannel received:', msgData);
                    streamBridge.callOnMessage(msgData);
                }
            }
        });
        setTimeout(function () {
            // Technically we could/should wait for the WebChannel opened event,
            // but because we want to send the first message with the WebChannel
            // handshake we pretend the channel opened here (asynchronously), and
            // then delay the actual open until the first message is sent.
            streamBridge.callOnOpen();
        }, 0);
        return streamBridge;
    };
    // visible for testing
    WebChannelConnection.prototype.makeUrl = function (rpcName) {
        var urlRpcName = RPC_NAME_REST_MAPPING[rpcName];
        assert(urlRpcName !== undefined, 'Unknown REST mapping for: ' + rpcName);
        return (this.baseUrl +
            '/' +
            RPC_URL_VERSION +
            '/projects/' +
            this.databaseId.projectId +
            '/databases/' +
            this.databaseId.database +
            '/documents:' +
            urlRpcName);
    };
    return WebChannelConnection;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var BrowserPlatform = /** @class */ (function () {
    function BrowserPlatform() {
        this.emptyByteString = '';
        this.base64Available = typeof atob !== 'undefined';
    }
    Object.defineProperty(BrowserPlatform.prototype, "document", {
        get: function () {
            return typeof document !== 'undefined' ? document : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BrowserPlatform.prototype, "window", {
        get: function () {
            return typeof window !== 'undefined' ? window : null;
        },
        enumerable: true,
        configurable: true
    });
    BrowserPlatform.prototype.loadConnection = function (databaseInfo) {
        return Promise.resolve(new WebChannelConnection(databaseInfo));
    };
    BrowserPlatform.prototype.newConnectivityMonitor = function () {
        if (BrowserConnectivityMonitor.isAvailable()) {
            return new BrowserConnectivityMonitor();
        }
        else {
            return new NoopConnectivityMonitor();
        }
    };
    BrowserPlatform.prototype.newSerializer = function (databaseId) {
        return new JsonProtoSerializer(databaseId, { useProto3Json: true });
    };
    BrowserPlatform.prototype.formatJSON = function (value) {
        return JSON.stringify(value);
    };
    BrowserPlatform.prototype.atob = function (encoded) {
        return atob(encoded);
    };
    BrowserPlatform.prototype.btoa = function (raw) {
        return btoa(raw);
    };
    return BrowserPlatform;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * This code needs to run before Firestore is used. This can be achieved in
 * several ways:
 *   1) Through the JSCompiler compiling this code and then (automatically)
 *      executing it before exporting the Firestore symbols.
 *   2) Through importing this module first in a Firestore main module
 */
PlatformSupport.setPlatform(new BrowserPlatform());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function registerFirestore(instance) {
    configureForFirebase(instance);
}
registerFirestore(firebase);

exports.registerFirestore = registerFirestore;
//# sourceMappingURL=index.cjs.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(142)))

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ErrorCode", function() { return tmp_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventType", function() { return tmp_3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WebChannel", function() { return tmp_4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "XhrIo", function() { return tmp_5; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createWebChannelTransport", function() { return tmp_1; });
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var g,goog=goog||{},k=commonjsGlobal;function m(a){return "string"==typeof a}function aa(a){return "number"==typeof a}function n(a,b){a=a.split(".");b=b||k;for(var c=0;c<a.length;c++)if(b=b[a[c]],null==b)return null;return b}function ba(){}
function p(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return "array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return "object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return "array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return "function"}else return "null";
else if("function"==b&&"undefined"==typeof a.call)return "object";return b}function q(a){return "array"==p(a)}function ca(a){var b=p(a);return "array"==b||"object"==b&&"number"==typeof a.length}function r(a){var b=typeof a;return "object"==b&&null!=a||"function"==b}var t="closure_uid_"+(1E9*Math.random()>>>0),da=0;function ea(a,b,c){return a.call.apply(a.bind,arguments)}
function fa(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var e=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(e,d);return a.apply(b,e)}}return function(){return a.apply(b,arguments)}}function u(a,b,c){Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?u=ea:u=fa;return u.apply(null,arguments)}
function v(a,b){var c=Array.prototype.slice.call(arguments,1);return function(){var d=c.slice();d.push.apply(d,arguments);return a.apply(this,d)}}var w=Date.now||function(){return +new Date};function x(a,b){function c(){}c.prototype=b.prototype;a.N=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.yb=function(d,e,f){for(var h=Array(arguments.length-2),l=2;l<arguments.length;l++)h[l-2]=arguments[l];return b.prototype[e].apply(d,h)};}function y(){this.j=this.j;this.i=this.i;}var ha=0;y.prototype.j=!1;y.prototype.la=function(){if(!this.j&&(this.j=!0,this.G(),0!=ha)){var a=this[t]||(this[t]=++da);}};y.prototype.G=function(){if(this.i)for(;this.i.length;)this.i.shift()();};var ja=Array.prototype.indexOf?function(a,b){return Array.prototype.indexOf.call(a,b,void 0)}:function(a,b){if(m(a))return m(b)&&1==b.length?a.indexOf(b,0):-1;for(var c=0;c<a.length;c++)if(c in a&&a[c]===b)return c;return -1},la=Array.prototype.forEach?function(a,b,c){Array.prototype.forEach.call(a,b,c);}:function(a,b,c){for(var d=a.length,e=m(a)?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a);};
function ma(a){a:{var b=na;for(var c=a.length,d=m(a)?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a)){b=e;break a}b=-1;}return 0>b?null:m(a)?a.charAt(b):a[b]}function oa(a){return Array.prototype.concat.apply([],arguments)}function pa(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return []}function qa(a){return /^[\s\xa0]*$/.test(a)}var ra=String.prototype.trim?function(a){return a.trim()}:function(a){return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1]};function z(a,b){return -1!=a.indexOf(b)}function sa(a,b){return a<b?-1:a>b?1:0}var A;a:{var ta=k.navigator;if(ta){var ua=ta.userAgent;if(ua){A=ua;break a}}A="";}function va(a,b,c){for(var d in a)b.call(c,a[d],d,a);}function wa(a){var b={},c;for(c in a)b[c]=a[c];return b}var xa="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");function ya(a,b){for(var c,d,e=1;e<arguments.length;e++){d=arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<xa.length;f++)c=xa[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c]);}}function za(a){za[" "](a);return a}za[" "]=ba;function Aa(a,b){var c=Ba;return Object.prototype.hasOwnProperty.call(c,a)?c[a]:c[a]=b(a)}var Ca=z(A,"Opera"),B=z(A,"Trident")||z(A,"MSIE"),Da=z(A,"Edge"),Ea=Da||B,Fa=z(A,"Gecko")&&!(z(A.toLowerCase(),"webkit")&&!z(A,"Edge"))&&!(z(A,"Trident")||z(A,"MSIE"))&&!z(A,"Edge"),Ga=z(A.toLowerCase(),"webkit")&&!z(A,"Edge");function Ha(){var a=k.document;return a?a.documentMode:void 0}var Ia;
a:{var Ja="",Ka=function(){var a=A;if(Fa)return /rv:([^\);]+)(\)|;)/.exec(a);if(Da)return /Edge\/([\d\.]+)/.exec(a);if(B)return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(Ga)return /WebKit\/(\S+)/.exec(a);if(Ca)return /(?:Version)[ \/]?(\S+)/.exec(a)}();Ka&&(Ja=Ka?Ka[1]:"");if(B){var La=Ha();if(null!=La&&La>parseFloat(Ja)){Ia=String(La);break a}}Ia=Ja;}var Ba={};
function Ma(a){return Aa(a,function(){for(var b=0,c=ra(String(Ia)).split("."),d=ra(String(a)).split("."),e=Math.max(c.length,d.length),f=0;0==b&&f<e;f++){var h=c[f]||"",l=d[f]||"";do{h=/(\d*)(\D*)(.*)/.exec(h)||["","","",""];l=/(\d*)(\D*)(.*)/.exec(l)||["","","",""];if(0==h[0].length&&0==l[0].length)break;b=sa(0==h[1].length?0:parseInt(h[1],10),0==l[1].length?0:parseInt(l[1],10))||sa(0==h[2].length,0==l[2].length)||sa(h[2],l[2]);h=h[3];l=l[3];}while(0==b)}return 0<=b})}var Na;var Oa=k.document;
Na=Oa&&B?Ha()||("CSS1Compat"==Oa.compatMode?parseInt(Ia,10):5):void 0;var Pa=!B||9<=Number(Na),Qa=B&&!Ma("9"),Ra=function(){if(!k.addEventListener||!Object.defineProperty)return !1;var a=!1,b=Object.defineProperty({},"passive",{get:function(){a=!0;}});try{k.addEventListener("test",ba,b),k.removeEventListener("test",ba,b);}catch(c){}return a}();function C(a,b){this.type=a;this.a=this.target=b;this.Ja=!0;}C.prototype.b=function(){this.Ja=!1;};function D(a,b){C.call(this,a?a.type:"");this.relatedTarget=this.a=this.target=null;this.button=this.screenY=this.screenX=this.clientY=this.clientX=0;this.key="";this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.pointerId=0;this.pointerType="";this.c=null;if(a){var c=this.type=a.type,d=a.changedTouches&&a.changedTouches.length?a.changedTouches[0]:null;this.target=a.target||a.srcElement;this.a=b;if(b=a.relatedTarget){if(Fa){a:{try{za(b.nodeName);var e=!0;break a}catch(f){}e=!1;}e||(b=null);}}else"mouseover"==
c?b=a.fromElement:"mouseout"==c&&(b=a.toElement);this.relatedTarget=b;d?(this.clientX=void 0!==d.clientX?d.clientX:d.pageX,this.clientY=void 0!==d.clientY?d.clientY:d.pageY,this.screenX=d.screenX||0,this.screenY=d.screenY||0):(this.clientX=void 0!==a.clientX?a.clientX:a.pageX,this.clientY=void 0!==a.clientY?a.clientY:a.pageY,this.screenX=a.screenX||0,this.screenY=a.screenY||0);this.button=a.button;this.key=a.key||"";this.ctrlKey=a.ctrlKey;this.altKey=a.altKey;this.shiftKey=a.shiftKey;this.metaKey=
a.metaKey;this.pointerId=a.pointerId||0;this.pointerType=m(a.pointerType)?a.pointerType:Sa[a.pointerType]||"";this.c=a;a.defaultPrevented&&this.b();}}x(D,C);var Sa={2:"touch",3:"pen",4:"mouse"};D.prototype.b=function(){D.N.b.call(this);var a=this.c;if(a.preventDefault)a.preventDefault();else if(a.returnValue=!1,Qa)try{if(a.ctrlKey||112<=a.keyCode&&123>=a.keyCode)a.keyCode=-1;}catch(b){}};var E="closure_listenable_"+(1E6*Math.random()|0),Ta=0;function Ua(a,b,c,d,e){this.listener=a;this.proxy=null;this.src=b;this.type=c;this.capture=!!d;this.da=e;this.key=++Ta;this.X=this.Z=!1;}function Va(a){a.X=!0;a.listener=null;a.proxy=null;a.src=null;a.da=null;}function Wa(a){this.src=a;this.a={};this.b=0;}Wa.prototype.add=function(a,b,c,d,e){var f=a.toString();a=this.a[f];a||(a=this.a[f]=[],this.b++);var h=Xa(a,b,d,e);-1<h?(b=a[h],c||(b.Z=!1)):(b=new Ua(b,this.src,f,!!d,e),b.Z=c,a.push(b));return b};function Ya(a,b){var c=b.type;if(c in a.a){var d=a.a[c],e=ja(d,b),f;(f=0<=e)&&Array.prototype.splice.call(d,e,1);f&&(Va(b),0==a.a[c].length&&(delete a.a[c],a.b--));}}
function Xa(a,b,c,d){for(var e=0;e<a.length;++e){var f=a[e];if(!f.X&&f.listener==b&&f.capture==!!c&&f.da==d)return e}return -1}var Za="closure_lm_"+(1E6*Math.random()|0),$a={};function bb(a,b,c,d,e){if(d&&d.once)return cb(a,b,c,d,e);if(q(b)){for(var f=0;f<b.length;f++)bb(a,b[f],c,d,e);return null}c=db(c);return a&&a[E]?a.Aa(b,c,r(d)?!!d.capture:!!d,e):eb(a,b,c,!1,d,e)}
function eb(a,b,c,d,e,f){if(!b)throw Error("Invalid event type");var h=r(e)?!!e.capture:!!e;if(h&&!Pa)return null;var l=fb(a);l||(a[Za]=l=new Wa(a));c=l.add(b,c,d,h,f);if(c.proxy)return c;d=gb();c.proxy=d;d.src=a;d.listener=c;if(a.addEventListener)Ra||(e=h),void 0===e&&(e=!1),a.addEventListener(b.toString(),d,e);else if(a.attachEvent)a.attachEvent(hb(b.toString()),d);else if(a.addListener&&a.removeListener)a.addListener(d);else throw Error("addEventListener and attachEvent are unavailable.");return c}function gb(){var a=ib,b=Pa?function(c){return a.call(b.src,b.listener,c)}:function(c){c=a.call(b.src,b.listener,c);if(!c)return c};return b}function cb(a,b,c,d,e){if(q(b)){for(var f=0;f<b.length;f++)cb(a,b[f],c,d,e);return null}c=db(c);return a&&a[E]?a.Ba(b,c,r(d)?!!d.capture:!!d,e):eb(a,b,c,!0,d,e)}
function jb(a,b,c,d,e){if(q(b))for(var f=0;f<b.length;f++)jb(a,b[f],c,d,e);else(d=r(d)?!!d.capture:!!d,c=db(c),a&&a[E])?(a=a.c,b=String(b).toString(),b in a.a&&(f=a.a[b],c=Xa(f,c,d,e),-1<c&&(Va(f[c]),Array.prototype.splice.call(f,c,1),0==f.length&&(delete a.a[b],a.b--)))):a&&(a=fb(a))&&(b=a.a[b.toString()],a=-1,b&&(a=Xa(b,c,d,e)),(c=-1<a?b[a]:null)&&kb(c));}
function kb(a){if(!aa(a)&&a&&!a.X){var b=a.src;if(b&&b[E])Ya(b.c,a);else{var c=a.type,d=a.proxy;b.removeEventListener?b.removeEventListener(c,d,a.capture):b.detachEvent?b.detachEvent(hb(c),d):b.addListener&&b.removeListener&&b.removeListener(d);(c=fb(b))?(Ya(c,a),0==c.b&&(c.src=null,b[Za]=null)):Va(a);}}}function hb(a){return a in $a?$a[a]:$a[a]="on"+a}function lb(a,b){var c=a.listener,d=a.da||a.src;a.Z&&kb(a);return c.call(d,b)}
function ib(a,b){return a.X?!0:Pa?lb(a,new D(b,this)):(b=new D(b||n("window.event"),this),lb(a,b))}function fb(a){a=a[Za];return a instanceof Wa?a:null}var mb="__closure_events_fn_"+(1E9*Math.random()>>>0);function db(a){if("function"==p(a))return a;a[mb]||(a[mb]=function(b){return a.handleEvent(b)});return a[mb]}function G(){y.call(this);this.c=new Wa(this);this.J=this;this.B=null;}x(G,y);G.prototype[E]=!0;g=G.prototype;g.addEventListener=function(a,b,c,d){bb(this,a,b,c,d);};g.removeEventListener=function(a,b,c,d){jb(this,a,b,c,d);};
g.dispatchEvent=function(a){var b,c=this.B;if(c)for(b=[];c;c=c.B)b.push(c);c=this.J;var d=a.type||a;if(m(a))a=new C(a,c);else if(a instanceof C)a.target=a.target||c;else{var e=a;a=new C(d,c);ya(a,e);}e=!0;if(b)for(var f=b.length-1;0<=f;f--){var h=a.a=b[f];e=nb(h,d,!0,a)&&e;}h=a.a=c;e=nb(h,d,!0,a)&&e;e=nb(h,d,!1,a)&&e;if(b)for(f=0;f<b.length;f++)h=a.a=b[f],e=nb(h,d,!1,a)&&e;return e};
g.G=function(){G.N.G.call(this);if(this.c){var a=this.c,c;for(c in a.a){for(var d=a.a[c],e=0;e<d.length;e++)Va(d[e]);delete a.a[c];a.b--;}}this.B=null;};g.Aa=function(a,b,c,d){return this.c.add(String(a),b,!1,c,d)};g.Ba=function(a,b,c,d){return this.c.add(String(a),b,!0,c,d)};
function nb(a,b,c,d){b=a.c.a[String(b)];if(!b)return !0;b=b.concat();for(var e=!0,f=0;f<b.length;++f){var h=b[f];if(h&&!h.X&&h.capture==c){var l=h.listener,F=h.da||h.src;h.Z&&Ya(a.c,h);e=!1!==l.call(F,d)&&e;}}return e&&0!=d.Ja}var ob=k.JSON.stringify;function pb(a,b){this.c=a;this.f=b;this.b=0;this.a=null;}pb.prototype.get=function(){if(0<this.b){this.b--;var a=this.a;this.a=a.next;a.next=null;}else a=this.c();return a};function qb(){this.b=this.a=null;}var sb=new pb(function(){return new rb},function(a){a.reset();});qb.prototype.add=function(a,b){var c=sb.get();c.set(a,b);this.b?this.b.next=c:this.a=c;this.b=c;};function tb(){var a=ub,b=null;a.a&&(b=a.a,a.a=a.a.next,a.a||(a.b=null),b.next=null);return b}function rb(){this.next=this.b=this.a=null;}rb.prototype.set=function(a,b){this.a=a;this.b=b;this.next=null;};rb.prototype.reset=function(){this.next=this.b=this.a=null;};function vb(a){k.setTimeout(function(){throw a;},0);}function wb(a,b){xb||yb();zb||(xb(),zb=!0);ub.add(a,b);}var xb;function yb(){var a=k.Promise.resolve(void 0);xb=function(){a.then(Ab);};}var zb=!1,ub=new qb;function Ab(){for(var a;a=tb();){try{a.a.call(a.b);}catch(c){vb(c);}var b=sb;b.f(a);100>b.b&&(b.b++,a.next=b.a,b.a=a);}zb=!1;}function Cb(a,b){G.call(this);this.b=a||1;this.a=b||k;this.f=u(this.gb,this);this.g=w();}x(Cb,G);g=Cb.prototype;g.ba=!1;g.L=null;g.gb=function(){if(this.ba){var a=w()-this.g;0<a&&a<.8*this.b?this.L=this.a.setTimeout(this.f,this.b-a):(this.L&&(this.a.clearTimeout(this.L),this.L=null),this.dispatchEvent("tick"),this.ba&&(Db(this),this.start()));}};g.start=function(){this.ba=!0;this.L||(this.L=this.a.setTimeout(this.f,this.b),this.g=w());};function Db(a){a.ba=!1;a.L&&(a.a.clearTimeout(a.L),a.L=null);}
g.G=function(){Cb.N.G.call(this);Db(this);delete this.a;};function Eb(a,b,c){if("function"==p(a))c&&(a=u(a,c));else if(a&&"function"==typeof a.handleEvent)a=u(a.handleEvent,a);else throw Error("Invalid listener argument");return 2147483647<Number(b)?-1:k.setTimeout(a,b||0)}function Fb(a,b,c){y.call(this);this.f=null!=c?u(a,c):a;this.c=b;this.b=u(this.ab,this);this.a=[];}x(Fb,y);g=Fb.prototype;g.ea=!1;g.U=null;g.Ua=function(a){this.a=arguments;this.U?this.ea=!0:Gb(this);};g.G=function(){Fb.N.G.call(this);this.U&&(k.clearTimeout(this.U),this.U=null,this.ea=!1,this.a=[]);};g.ab=function(){this.U=null;this.ea&&(this.ea=!1,Gb(this));};function Gb(a){a.U=Eb(a.b,a.c);a.f.apply(null,a.a);}function H(a){y.call(this);this.b=a;this.a={};}x(H,y);var Hb=[];function Ib(a,b,c,d){q(c)||(c&&(Hb[0]=c.toString()),c=Hb);for(var e=0;e<c.length;e++){var f=bb(b,c[e],d||a.handleEvent,!1,a.b||a);if(!f)break;a.a[f.key]=f;}}function Jb(a){va(a.a,function(b,c){this.a.hasOwnProperty(c)&&kb(b);},a);a.a={};}H.prototype.G=function(){H.N.G.call(this);Jb(this);};H.prototype.handleEvent=function(){throw Error("EventHandler.handleEvent not implemented");};function Kb(){}var I=new G;function Lb(a){C.call(this,"serverreachability",a);}x(Lb,C);function J(a){I.dispatchEvent(new Lb(I,a));}function Mb(a){C.call(this,"statevent",a);}x(Mb,C);function K(a){I.dispatchEvent(new Mb(I,a));}function Nb(a){C.call(this,"timingevent",a);}x(Nb,C);function Ob(a,b){if("function"!=p(a))throw Error("Fn must not be null and must be a function");return k.setTimeout(function(){a();},b)}var Pb={NO_ERROR:0,hb:1,ob:2,nb:3,kb:4,mb:5,pb:6,Ma:7,TIMEOUT:8,sb:9};var Qb={jb:"complete",wb:"success",Na:"error",Ma:"abort",ub:"ready",vb:"readystatechange",TIMEOUT:"timeout",qb:"incrementaldata",tb:"progress",lb:"downloadprogress",xb:"uploadprogress"};function Rb(){}Rb.prototype.a=null;function Sb(a){var b;(b=a.a)||(b=a.a={});return b}function Tb(){}var L={OPEN:"a",ib:"b",Na:"c",rb:"d"};function Ub(){C.call(this,"d");}x(Ub,C);function Vb(){C.call(this,"c");}x(Vb,C);var Wb;function Xb(){}x(Xb,Rb);Wb=new Xb;function M(a,b,c){this.g=a;this.W=b;this.V=c||1;this.I=new H(this);this.O=Yb;a=Ea?125:void 0;this.P=new Cb(a);this.h=null;this.b=!1;this.l=this.D=this.f=this.F=this.v=this.R=this.i=null;this.j=[];this.a=null;this.A=0;this.c=this.w=null;this.o=-1;this.m=!1;this.J=0;this.B=null;this.s=this.S=this.H=!1;}var Yb=45E3,Zb={},$b={};g=M.prototype;g.setTimeout=function(a){this.O=a;};function ac(a,b,c){a.F=1;a.f=bc(N(b));a.l=c;a.H=!0;cc(a,null);}function dc(a,b,c,d){a.F=1;a.f=bc(N(b));a.l=null;a.H=c;cc(a,d);}
function cc(a,b){a.v=w();ec(a);a.D=N(a.f);fc(a.D,"t",a.V);a.A=0;a.a=a.g.$(a.g.Y()?b:null);0<a.J&&(a.B=new Fb(u(a.Ka,a,a.a),a.J));Ib(a.I,a.a,"readystatechange",a.eb);b=a.h?wa(a.h):{};a.l?(a.w||(a.w="POST"),b["Content-Type"]="application/x-www-form-urlencoded",a.a.ca(a.D,a.w,a.l,b)):(a.w="GET",a.a.ca(a.D,a.w,null,b));J(1);}g.eb=function(a){a=a.target;var b=this.B;b&&3==O(a)?b.Ua():this.Ka(a);};
g.Ka=function(a){try{if(a==this.a)a:{var b=O(this.a),c=this.a.ya(),d=this.a.T();if(!(3>b||3==b&&!Ea&&!this.a.aa())){this.m||4!=b||7==c||(8==c||0>=d?J(3):J(2));gc(this);var e=this.a.T();this.o=e;var f=this.a.aa();if(this.b=200==e){if(this.S&&!this.s){b:{if(this.a){var h=hc(this.a,"X-HTTP-Initial-Response");if(h&&!qa(h)){var l=h;break b}}l=null;}if(l)this.s=!0,ic(this,l);else{this.b=!1;this.c=3;K(12);P(this);jc(this);break a}}this.H?(kc(this,b,f),Ea&&this.b&&3==b&&(Ib(this.I,this.P,"tick",this.cb),this.P.start())):
ic(this,f);4==b&&P(this);this.b&&!this.m&&(4==b?this.g.na(this):(this.b=!1,ec(this)));}else 400==e&&0<f.indexOf("Unknown SID")?(this.c=3,K(12)):(this.c=0,K(13)),P(this),jc(this);}}}catch(F){}finally{}};function kc(a,b,c){for(var d=!0;!a.m&&a.A<c.length;){var e=lc(a,c);if(e==$b){4==b&&(a.c=4,K(14),d=!1);break}else if(e==Zb){a.c=4;K(15);d=!1;break}else ic(a,e);}4==b&&0==c.length&&(a.c=1,K(16),d=!1);a.b=a.b&&d;d||(P(a),jc(a));}
g.cb=function(){if(this.a){var a=O(this.a),b=this.a.aa();this.A<b.length&&(gc(this),kc(this,a,b),this.b&&4!=a&&ec(this));}};function lc(a,b){var c=a.A,d=b.indexOf("\n",c);if(-1==d)return $b;c=Number(b.substring(c,d));if(isNaN(c))return Zb;d+=1;if(d+c>b.length)return $b;b=b.substr(d,c);a.A=d+c;return b}g.cancel=function(){this.m=!0;P(this);};function ec(a){a.R=w()+a.O;mc(a,a.O);}function mc(a,b){if(null!=a.i)throw Error("WatchDog timer not null");a.i=Ob(u(a.bb,a),b);}
function gc(a){a.i&&(k.clearTimeout(a.i),a.i=null);}g.bb=function(){this.i=null;var a=w();0<=a-this.R?(2!=this.F&&(J(3),K(17)),P(this),this.c=2,jc(this)):mc(this,this.R-a);};function jc(a){a.g.Da()||a.m||a.g.na(a);}function P(a){gc(a);var b=a.B;b&&"function"==typeof b.la&&b.la();a.B=null;Db(a.P);Jb(a.I);a.a&&(b=a.a,a.a=null,b.abort(),b.la());}function ic(a,b){try{a.g.Ga(a,b),J(4);}catch(c){}}function nc(a){if(a.C&&"function"==typeof a.C)return a.C();if(m(a))return a.split("");if(ca(a)){for(var b=[],c=a.length,d=0;d<c;d++)b.push(a[d]);return b}b=[];c=0;for(d in a)b[c++]=a[d];return b}
function oc(a,b){if(a.forEach&&"function"==typeof a.forEach)a.forEach(b,void 0);else if(ca(a)||m(a))la(a,b,void 0);else{if(a.K&&"function"==typeof a.K)var c=a.K();else if(a.C&&"function"==typeof a.C)c=void 0;else if(ca(a)||m(a)){c=[];for(var d=a.length,e=0;e<d;e++)c.push(e);}else for(e in c=[],d=0,a)c[d++]=e;d=nc(a);e=d.length;for(var f=0;f<e;f++)b.call(void 0,d[f],c&&c[f],a);}}function Q(a,b){this.b={};this.a=[];this.c=0;var c=arguments.length;if(1<c){if(c%2)throw Error("Uneven number of arguments");for(var d=0;d<c;d+=2)this.set(arguments[d],arguments[d+1]);}else if(a)if(a instanceof Q)for(c=a.K(),d=0;d<c.length;d++)this.set(c[d],a.get(c[d]));else for(d in a)this.set(d,a[d]);}g=Q.prototype;g.C=function(){pc(this);for(var a=[],b=0;b<this.a.length;b++)a.push(this.b[this.a[b]]);return a};g.K=function(){pc(this);return this.a.concat()};
function qc(a){a.b={};a.a.length=0;a.c=0;}function rc(a,b){R(a.b,b)&&(delete a.b[b],a.c--,a.a.length>2*a.c&&pc(a));}function pc(a){if(a.c!=a.a.length){for(var b=0,c=0;b<a.a.length;){var d=a.a[b];R(a.b,d)&&(a.a[c++]=d);b++;}a.a.length=c;}if(a.c!=a.a.length){var e={};for(c=b=0;b<a.a.length;)d=a.a[b],R(e,d)||(a.a[c++]=d,e[d]=1),b++;a.a.length=c;}}g.get=function(a,b){return R(this.b,a)?this.b[a]:b};g.set=function(a,b){R(this.b,a)||(this.c++,this.a.push(a));this.b[a]=b;};
g.forEach=function(a,b){for(var c=this.K(),d=0;d<c.length;d++){var e=c[d],f=this.get(e);a.call(b,f,e,this);}};function R(a,b){return Object.prototype.hasOwnProperty.call(a,b)}var sc=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;function tc(a,b){if(a){a=a.split("&");for(var c=0;c<a.length;c++){var d=a[c].indexOf("="),e=null;if(0<=d){var f=a[c].substring(0,d);e=a[c].substring(d+1);}else f=a[c];b(f,e?decodeURIComponent(e.replace(/\+/g," ")):"");}}}function S(a,b){this.b=this.j=this.f="";this.i=null;this.g=this.a="";this.h=!1;var c;a instanceof S?(this.h=void 0!==b?b:a.h,uc(this,a.f),this.j=a.j,vc(this,a.b),wc(this,a.i),this.a=a.a,xc(this,yc(a.c)),this.g=a.g):a&&(c=String(a).match(sc))?(this.h=!!b,uc(this,c[1]||"",!0),this.j=zc(c[2]||""),vc(this,c[3]||"",!0),wc(this,c[4]),this.a=zc(c[5]||"",!0),xc(this,c[6]||"",!0),this.g=zc(c[7]||"")):(this.h=!!b,this.c=new Ac(null,this.h));}
S.prototype.toString=function(){var a=[],b=this.f;b&&a.push(Bc(b,Cc,!0),":");var c=this.b;if(c||"file"==b)a.push("//"),(b=this.j)&&a.push(Bc(b,Cc,!0),"@"),a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g,"%$1")),c=this.i,null!=c&&a.push(":",String(c));if(c=this.a)this.b&&"/"!=c.charAt(0)&&a.push("/"),a.push(Bc(c,"/"==c.charAt(0)?Dc:Ec,!0));(c=this.c.toString())&&a.push("?",c);(c=this.g)&&a.push("#",Bc(c,Fc));return a.join("")};
S.prototype.resolve=function(a){var b=N(this),c=!!a.f;c?uc(b,a.f):c=!!a.j;c?b.j=a.j:c=!!a.b;c?vc(b,a.b):c=null!=a.i;var d=a.a;if(c)wc(b,a.i);else if(c=!!a.a){if("/"!=d.charAt(0))if(this.b&&!this.a)d="/"+d;else{var e=b.a.lastIndexOf("/");-1!=e&&(d=b.a.substr(0,e+1)+d);}e=d;if(".."==e||"."==e)d="";else if(z(e,"./")||z(e,"/.")){d=0==e.lastIndexOf("/",0);e=e.split("/");for(var f=[],h=0;h<e.length;){var l=e[h++];"."==l?d&&h==e.length&&f.push(""):".."==l?((1<f.length||1==f.length&&""!=f[0])&&f.pop(),d&&
h==e.length&&f.push("")):(f.push(l),d=!0);}d=f.join("/");}else d=e;}c?b.a=d:c=""!==a.c.toString();c?xc(b,yc(a.c)):c=!!a.g;c&&(b.g=a.g);return b};function N(a){return new S(a)}function uc(a,b,c){a.f=c?zc(b,!0):b;a.f&&(a.f=a.f.replace(/:$/,""));}function vc(a,b,c){a.b=c?zc(b,!0):b;}function wc(a,b){if(b){b=Number(b);if(isNaN(b)||0>b)throw Error("Bad port number "+b);a.i=b;}else a.i=null;}function xc(a,b,c){b instanceof Ac?(a.c=b,Gc(a.c,a.h)):(c||(b=Bc(b,Hc)),a.c=new Ac(b,a.h));}
function T(a,b,c){a.c.set(b,c);}function fc(a,b,c){q(c)||(c=[String(c)]);Ic(a.c,b,c);}function bc(a){T(a,"zx",Math.floor(2147483648*Math.random()).toString(36)+Math.abs(Math.floor(2147483648*Math.random())^w()).toString(36));return a}function Jc(a){return a instanceof S?N(a):new S(a,void 0)}function Kc(a,b,c,d){var e=new S(null,void 0);a&&uc(e,a);b&&vc(e,b);c&&wc(e,c);d&&(e.a=d);return e}function zc(a,b){return a?b?decodeURI(a.replace(/%25/g,"%2525")):decodeURIComponent(a):""}
function Bc(a,b,c){return m(a)?(a=encodeURI(a).replace(b,Lc),c&&(a=a.replace(/%25([0-9a-fA-F]{2})/g,"%$1")),a):null}function Lc(a){a=a.charCodeAt(0);return "%"+(a>>4&15).toString(16)+(a&15).toString(16)}var Cc=/[#\/\?@]/g,Ec=/[#\?:]/g,Dc=/[#\?]/g,Hc=/[#\?@]/g,Fc=/#/g;function Ac(a,b){this.b=this.a=null;this.c=a||null;this.f=!!b;}function U(a){a.a||(a.a=new Q,a.b=0,a.c&&tc(a.c,function(b,c){a.add(decodeURIComponent(b.replace(/\+/g," ")),c);}));}g=Ac.prototype;
g.add=function(a,b){U(this);this.c=null;a=V(this,a);var c=this.a.get(a);c||this.a.set(a,c=[]);c.push(b);this.b+=1;return this};function Mc(a,b){U(a);b=V(a,b);R(a.a.b,b)&&(a.c=null,a.b-=a.a.get(b).length,rc(a.a,b));}function Nc(a,b){U(a);b=V(a,b);return R(a.a.b,b)}g.forEach=function(a,b){U(this);this.a.forEach(function(c,d){la(c,function(e){a.call(b,e,d,this);},this);},this);};
g.K=function(){U(this);for(var a=this.a.C(),b=this.a.K(),c=[],d=0;d<b.length;d++)for(var e=a[d],f=0;f<e.length;f++)c.push(b[d]);return c};g.C=function(a){U(this);var b=[];if(m(a))Nc(this,a)&&(b=oa(b,this.a.get(V(this,a))));else{a=this.a.C();for(var c=0;c<a.length;c++)b=oa(b,a[c]);}return b};g.set=function(a,b){U(this);this.c=null;a=V(this,a);Nc(this,a)&&(this.b-=this.a.get(a).length);this.a.set(a,[b]);this.b+=1;return this};
g.get=function(a,b){if(!a)return b;a=this.C(a);return 0<a.length?String(a[0]):b};function Ic(a,b,c){Mc(a,b);0<c.length&&(a.c=null,a.a.set(V(a,b),pa(c)),a.b+=c.length);}g.toString=function(){if(this.c)return this.c;if(!this.a)return "";for(var a=[],b=this.a.K(),c=0;c<b.length;c++){var d=b[c],e=encodeURIComponent(String(d));d=this.C(d);for(var f=0;f<d.length;f++){var h=e;""!==d[f]&&(h+="="+encodeURIComponent(String(d[f])));a.push(h);}}return this.c=a.join("&")};
function yc(a){var b=new Ac;b.c=a.c;a.a&&(b.a=new Q(a.a),b.b=a.b);return b}function V(a,b){b=String(b);a.f&&(b=b.toLowerCase());return b}function Gc(a,b){b&&!a.f&&(U(a),a.c=null,a.a.forEach(function(c,d){var e=d.toLowerCase();d!=e&&(Mc(this,d),Ic(this,e,c));},a));a.f=b;}function Qc(){}function Rc(){}x(Rc,Qc);function Sc(a){this.a=a;this.b=this.h=null;this.g=!1;this.i=null;this.c=-1;this.l=this.f=null;}g=Sc.prototype;g.M=null;function Uc(a){var b=a.a.F.a;if(null!=b)K(4),b?(K(10),Vc(a.a,a,!1)):(K(11),Vc(a.a,a,!0));else{a.b=new M(a,void 0,void 0);a.b.h=a.h;b=a.a;b=Wc(b,b.Y()?a.f:null,a.i);K(4);fc(b,"TYPE","xmlhttp");var c=a.a.j,d=a.a.I;c&&d&&T(b,c,d);dc(a.b,b,!1,a.f);}}g.$=function(a){return this.a.$(a)};g.abort=function(){this.b&&(this.b.cancel(),this.b=null);this.c=-1;};g.Da=function(){return !1};
g.Ga=function(a,b){this.c=a.o;if(0==this.M){if(!this.a.o&&(a=a.a)){var c=hc(a,"X-Client-Wire-Protocol");this.l=c?c:null;this.a.j&&(a=hc(a,"X-HTTP-Session-Id"))&&(this.a.I=a);}if(b){try{var d=this.a.ja.a.parse(b);}catch(e){b=this.a;b.m=this.c;W(b,2);return}this.f=d[0];}else b=this.a,b.m=this.c,W(b,2);}else if(1==this.M)if(this.g)K(6);else if("11111"==b){if(K(5),this.g=!0,!B||10<=Number(Na))this.c=200,this.b.cancel(),K(11),Vc(this.a,this,!0);}else K(7),this.g=!1;};
g.na=function(){this.c=this.b.o;if(this.b.b)0==this.M?(this.M=1,Uc(this)):1==this.M&&(this.g?(K(11),Vc(this.a,this,!0)):(K(10),Vc(this.a,this,!1)));else{0==this.M?K(8):1==this.M&&K(9);var a=this.a;a.m=this.c;W(a,2);}};g.Y=function(){return this.a.Y()};g.ma=function(){return this.a.ma()};function Xc(){this.a=this.b=null;}function Yc(){this.a=new Q;}function Zc(a){var b=typeof a;return "object"==b&&a||"function"==b?"o"+(a[t]||(a[t]=++da)):b.charAt(0)+a}Yc.prototype.add=function(a){this.a.set(Zc(a),a);};Yc.prototype.C=function(){return this.a.C()};function $c(a,b){this.b=a;this.a=b;}function ad(a){this.g=a||bd;k.PerformanceNavigationTiming?(a=k.performance.getEntriesByType("navigation"),a=0<a.length&&("hq"==a[0].nextHopProtocol||"h2"==a[0].nextHopProtocol)):a=!!(k.ka&&k.ka.Ea&&k.ka.Ea()&&k.ka.Ea().zb);this.f=a?this.g:1;this.a=null;1<this.f&&(this.a=new Yc);this.b=null;this.c=[];}var bd=10;function cd(a,b){!a.a&&(z(b,"spdy")||z(b,"quic")||z(b,"h2"))&&(a.f=a.g,a.a=new Yc,a.b&&(dd(a,a.b),a.b=null));}function ed(a){return a.b?!0:a.a?a.a.a.c>=a.f:!1}
function fd(a){return a.b?1:a.a?a.a.a.c:0}function gd(a,b){a.b?a=a.b==b:a.a?(b=Zc(b),a=R(a.a.a.b,b)):a=!1;return a}function dd(a,b){a.a?a.a.add(b):a.b=b;}function hd(a,b){if(a.b&&a.b==b)a.b=null;else{var c;if(c=a.a)c=Zc(b),c=R(a.a.a.b,c);c&&rc(a.a.a,Zc(b));}}ad.prototype.cancel=function(){this.c=id(this);this.b?(this.b.cancel(),this.b=null):this.a&&0!=this.a.a.c&&(la(this.a.C(),function(a){a.cancel();}),qc(this.a.a));};
function id(a){if(null!=a.b)return a.c.concat(a.b.j);if(null!=a.a&&0!=a.a.a.c){var b=a.c;la(a.a.C(),function(c){b=b.concat(c.j);});return b}return pa(a.c)}function jd(){}jd.prototype.stringify=function(a){return k.JSON.stringify(a,void 0)};jd.prototype.parse=function(a){return k.JSON.parse(a,void 0)};function kd(){this.a=new jd;}function ld(a,b,c){var d=c||"";try{oc(a,function(e,f){var h=e;r(e)&&(h=ob(e));b.push(d+f+"="+encodeURIComponent(h));});}catch(e){throw b.push(d+"type="+encodeURIComponent("_badmap")),e;}}function md(a,b){var c=new Kb;if(k.Image){var d=new Image;d.onload=v(nd,c,d,"TestLoadImage: loaded",!0,b);d.onerror=v(nd,c,d,"TestLoadImage: error",!1,b);d.onabort=v(nd,c,d,"TestLoadImage: abort",!1,b);d.ontimeout=v(nd,c,d,"TestLoadImage: timeout",!1,b);k.setTimeout(function(){if(d.ontimeout)d.ontimeout();},1E4);d.src=a;}else b(!1);}function nd(a,b,c,d,e){try{b.onload=null,b.onerror=null,b.onabort=null,b.ontimeout=null,e(d);}catch(f){}}var od=k.JSON.parse;function X(a){G.call(this);this.headers=new Q;this.H=a||null;this.b=!1;this.s=this.a=null;this.A="";this.h=0;this.f="";this.g=this.w=this.l=this.v=!1;this.o=0;this.m=null;this.I=pd;this.D=this.F=!1;}x(X,G);var pd="",qd=/^https?$/i,rd=["POST","PUT"];g=X.prototype;
g.ca=function(a,b,c,d){if(this.a)throw Error("[goog.net.XhrIo] Object is active with another request="+this.A+"; newUri="+a);b=b?b.toUpperCase():"GET";this.A=a;this.f="";this.h=0;this.v=!1;this.b=!0;this.a=new XMLHttpRequest;this.s=this.H?Sb(this.H):Sb(Wb);this.a.onreadystatechange=u(this.Fa,this);try{this.w=!0,this.a.open(b,String(a),!0),this.w=!1;}catch(f){sd(this,f);return}a=c||"";var e=new Q(this.headers);d&&oc(d,function(f,h){e.set(h,f);});d=ma(e.K());c=k.FormData&&a instanceof k.FormData;!(0<=
ja(rd,b))||d||c||e.set("Content-Type","application/x-www-form-urlencoded;charset=utf-8");e.forEach(function(f,h){this.a.setRequestHeader(h,f);},this);this.I&&(this.a.responseType=this.I);"withCredentials"in this.a&&this.a.withCredentials!==this.F&&(this.a.withCredentials=this.F);try{td(this),0<this.o&&((this.D=ud(this.a))?(this.a.timeout=this.o,this.a.ontimeout=u(this.Ca,this)):this.m=Eb(this.Ca,this.o,this)),this.l=!0,this.a.send(a),this.l=!1;}catch(f){sd(this,f);}};
function ud(a){return B&&Ma(9)&&aa(a.timeout)&&void 0!==a.ontimeout}function na(a){return "content-type"==a.toLowerCase()}g.Ca=function(){"undefined"!=typeof goog&&this.a&&(this.f="Timed out after "+this.o+"ms, aborting",this.h=8,this.dispatchEvent("timeout"),this.abort(8));};function sd(a,b){a.b=!1;a.a&&(a.g=!0,a.a.abort(),a.g=!1);a.f=b;a.h=5;vd(a);wd(a);}function vd(a){a.v||(a.v=!0,a.dispatchEvent("complete"),a.dispatchEvent("error"));}
g.abort=function(a){this.a&&this.b&&(this.b=!1,this.g=!0,this.a.abort(),this.g=!1,this.h=a||7,this.dispatchEvent("complete"),this.dispatchEvent("abort"),wd(this));};g.G=function(){this.a&&(this.b&&(this.b=!1,this.g=!0,this.a.abort(),this.g=!1),wd(this,!0));X.N.G.call(this);};g.Fa=function(){this.j||(this.w||this.l||this.g?xd(this):this.$a());};g.$a=function(){xd(this);};
function xd(a){if(a.b&&"undefined"!=typeof goog&&(!a.s[1]||4!=O(a)||2!=a.T()))if(a.l&&4==O(a))Eb(a.Fa,0,a);else if(a.dispatchEvent("readystatechange"),4==O(a)){a.b=!1;try{var b=a.T();a:switch(b){case 200:case 201:case 202:case 204:case 206:case 304:case 1223:var c=!0;break a;default:c=!1;}var d;if(!(d=c)){var e;if(e=0===b){var f=String(a.A).match(sc)[1]||null;if(!f&&k.self&&k.self.location){var h=k.self.location.protocol;f=h.substr(0,h.length-1);}e=!qd.test(f?f.toLowerCase():"");}d=e;}d?(a.dispatchEvent("complete"),
a.dispatchEvent("success")):(a.h=6,a.f=a.za()+" ["+a.T()+"]",vd(a));}finally{wd(a);}}}function wd(a,b){if(a.a){td(a);var c=a.a,d=a.s[0]?ba:null;a.a=null;a.s=null;b||a.dispatchEvent("ready");try{c.onreadystatechange=d;}catch(e){}}}function td(a){a.a&&a.D&&(a.a.ontimeout=null);a.m&&(k.clearTimeout(a.m),a.m=null);}function O(a){return a.a?a.a.readyState:0}g.T=function(){try{return 2<O(this)?this.a.status:-1}catch(a){return -1}};g.za=function(){try{return 2<O(this)?this.a.statusText:""}catch(a){return ""}};
g.aa=function(){try{return this.a?this.a.responseText:""}catch(a){return ""}};g.Va=function(a){if(this.a){var b=this.a.responseText;a&&0==b.indexOf(a)&&(b=b.substring(a.length));return od(b)}};function hc(a,b){return a.a?a.a.getResponseHeader(b):null}g.ya=function(){return this.h};g.Ya=function(){return m(this.f)?this.f:String(this.f)};function yd(a){var b="";va(a,function(c,d){b+=d;b+=":";b+=c;b+="\r\n";});return b}function zd(a,b,c){a:{for(d in c){var d=!1;break a}d=!0;}if(d)return a;c=yd(c);if(m(a)){b=encodeURIComponent(String(b));c=null!=c?"="+encodeURIComponent(String(c)):"";if(b+=c){c=a.indexOf("#");0>c&&(c=a.length);d=a.indexOf("?");if(0>d||d>c){d=c;var e="";}else e=a.substring(d+1,c);a=[a.substr(0,d),e,a.substr(c)];c=a[1];a[1]=b?c?c+"&"+b:b:c;a=a[0]+(a[1]?"?"+a[1]:"")+a[2];}return a}T(a,b,c);return a}function Ad(a){this.f=[];this.F=new Xc;this.ga=this.pa=this.B=this.ha=this.a=this.I=this.j=this.V=this.g=this.J=this.i=null;this.Ra=this.P=0;this.Pa=!!n("internalChannelParams.failFast",a);this.ia=this.w=this.s=this.l=this.h=this.c=null;this.oa=!0;this.m=this.ra=this.O=-1;this.S=this.v=this.A=0;this.Oa=n("internalChannelParams.baseRetryDelayMs",a)||5E3;this.Sa=n("internalChannelParams.retryDelaySeedMs",a)||1E4;this.Qa=n("internalChannelParams.forwardChannelMaxRetries",a)||2;this.qa=n("internalChannelParams.forwardChannelRequestTimeoutMs",
a)||2E4;this.La=a&&a.Ab||void 0;this.D=void 0;this.R=a&&a.supportsCrossDomainXhr||!1;this.H="";this.b=new ad(a&&a.concurrentRequestLimit);this.ja=new kd;this.o=a&&void 0!==a.backgroundChannelTest?a.backgroundChannelTest:!0;(this.W=a&&a.fastHandshake||!1)&&!this.o&&(this.o=!0);a&&a.forceLongPolling&&(this.oa=!1);this.fa=void 0;}g=Ad.prototype;g.wa=8;g.u=1;
function Bd(a){Cd(a);if(3==a.u){var b=a.P++,c=N(a.B);T(c,"SID",a.H);T(c,"RID",b);T(c,"TYPE","terminate");Dd(a,c);b=new M(a,b,void 0);b.F=2;b.f=bc(N(c));c=!1;k.navigator&&k.navigator.sendBeacon&&(c=k.navigator.sendBeacon(b.f.toString(),""));!c&&k.Image&&((new Image).src=b.f,c=!0);c||(b.a=b.g.$(null),b.a.ca(b.f));b.v=w();ec(b);}Ed(a);}
function Cd(a){a.w&&(a.w.abort(),a.w=null);a.a&&(a.a.cancel(),a.a=null);a.l&&(k.clearTimeout(a.l),a.l=null);Fd(a);a.b.cancel();a.h&&(aa(a.h)&&k.clearTimeout(a.h),a.h=null);}function Gd(a,b){a.f.push(new $c(a.Ra++,b));3==a.u&&Hd(a);}g.Da=function(){return 0==this.u};function Hd(a){ed(a.b)||a.h||(a.h=!0,wb(a.Ia,a),a.A=0);}
function Id(a,b){if(fd(a.b)>=a.b.f-(a.h?1:0))return !1;if(a.h)return a.f=b.j.concat(a.f),!0;if(1==a.u||2==a.u||a.A>=(a.Pa?0:a.Qa))return !1;a.h=Ob(u(a.Ia,a,b),Jd(a,a.A));a.A++;return !0}
g.Ia=function(a){if(this.h)if(this.h=null,1==this.u){if(!a){this.P=Math.floor(1E5*Math.random());a=this.P++;var b=new M(this,a,void 0),c=this.i;this.J&&(c?(c=wa(c),ya(c,this.J)):c=this.J);null===this.g&&(b.h=c);var d;if(this.W)a:{for(var e=d=0;e<this.f.length;e++){b:{var f=this.f[e];if("__data__"in f.a&&(f=f.a.__data__,m(f))){f=f.length;break b}f=void 0;}if(void 0===f)break;d+=f;if(4096<d){d=e;break a}if(4096===d||e===this.f.length-1){d=e+1;break a}}d=1E3;}else d=1E3;d=Kd(this,b,d);e=N(this.B);T(e,
"RID",a);T(e,"CVER",22);this.o&&this.j&&T(e,"X-HTTP-Session-Id",this.j);Dd(this,e);this.g&&c&&zd(e,this.g,c);dd(this.b,b);this.W?(T(e,"$req",d),T(e,"SID","null"),b.S=!0,ac(b,e,null)):ac(b,e,d);this.u=2;}}else 3==this.u&&(a?Ld(this,a):0==this.f.length||ed(this.b)||Ld(this));};
function Ld(a,b){var c;b?c=b.W:c=a.P++;var d=N(a.B);T(d,"SID",a.H);T(d,"RID",c);T(d,"AID",a.O);Dd(a,d);a.g&&a.i&&zd(d,a.g,a.i);c=new M(a,c,a.A+1);null===a.g&&(c.h=a.i);b&&(a.f=b.j.concat(a.f));b=Kd(a,c,1E3);c.setTimeout(Math.round(.5*a.qa)+Math.round(.5*a.qa*Math.random()));dd(a.b,c);ac(c,d,b);}function Dd(a,b){a.c&&oc({},function(c,d){T(b,d,c);});}
function Kd(a,b,c){c=Math.min(a.f.length,c);var d=a.c?u(a.c.Ta,a.c,a):null;a:for(var e=a.f,f=-1;;){var h=["count="+c];-1==f?0<c?(f=e[0].b,h.push("ofs="+f)):f=0:h.push("ofs="+f);for(var l=!0,F=0;F<c;F++){var Bb=e[F].b,Tc=e[F].a;Bb-=f;if(0>Bb)f=Math.max(0,e[F].b-100),l=!1;else try{ld(Tc,h,"req"+Bb+"_");}catch(Ud){d&&d(Tc);}}if(l){d=h.join("&");break a}}a=a.f.splice(0,c);b.j=a;return d}function Md(a){a.a||a.l||(a.S=1,wb(a.Ha,a),a.v=0);}
function Nd(a){if(a.a||a.l||3<=a.v)return !1;a.S++;a.l=Ob(u(a.Ha,a),Jd(a,a.v));a.v++;return !0}g.Ha=function(){this.l=null;this.a=new M(this,"rpc",this.S);null===this.g&&(this.a.h=this.i);this.a.J=0;var a=N(this.pa);T(a,"RID","rpc");T(a,"SID",this.H);T(a,"CI",this.ia?"0":"1");T(a,"AID",this.O);Dd(this,a);T(a,"TYPE","xmlhttp");this.g&&this.i&&zd(a,this.g,this.i);this.D&&this.a.setTimeout(this.D);dc(this.a,a,!0,this.ga);};
function Vc(a,b,c){var d=b.l;d&&cd(a.b,d);a.ia=a.oa&&c;a.m=b.c;a.B=Wc(a,null,a.ha);Hd(a);}
g.Ga=function(a,b){if(0!=this.u&&(this.a==a||gd(this.b,a)))if(this.m=a.o,!a.s&&gd(this.b,a)&&3==this.u){try{var c=this.ja.a.parse(b);}catch(f){c=null;}if(q(c)&&3==c.length){b=c;if(0==b[0])a:{if(!this.l){if(this.a)if(this.a.v+3E3<a.v)Fd(this),this.a.cancel(),this.a=null;else break a;Nd(this);K(18);}}else this.ra=b[1],0<this.ra-this.O&&37500>b[2]&&this.ia&&0==this.v&&!this.s&&(this.s=Ob(u(this.Za,this),6E3));if(1>=fd(this.b)&&this.fa){try{this.fa();}catch(f){}this.fa=void 0;}}else W(this,11);}else if((a.s||
this.a==a)&&Fd(this),!qa(b))for(b=c=this.ja.a.parse(b),c=0;c<b.length;c++){var d=b[c];this.O=d[0];d=d[1];if(2==this.u)if("c"==d[0]){this.H=d[1];this.ga=d[2];var e=d[3];null!=e&&(this.wa=e);d=d[5];null!=d&&aa(d)&&0<d&&(this.D=1.5*d);this.o&&(d=a.a)&&((e=hc(d,"X-Client-Wire-Protocol"))&&cd(this.b,e),this.j&&(d=hc(d,"X-HTTP-Session-Id")))&&(this.I=d,T(this.B,this.j,d));this.u=3;this.c&&this.c.va();d=a;this.pa=Wc(this,this.Y()?this.ga:null,this.ha);d.s?(hd(this.b,d),(e=this.D)&&d.setTimeout(e),d.i&&(gc(d),
ec(d)),this.a=d):Md(this);0<this.f.length&&Hd(this);}else"stop"!=d[0]&&"close"!=d[0]||W(this,7);else 3==this.u&&("stop"==d[0]||"close"==d[0]?"stop"==d[0]?W(this,7):Bd(this):"noop"!=d[0]&&this.c&&this.c.ua(d),this.v=0);}};g.Za=function(){null!=this.s&&(this.s=null,this.a.cancel(),this.a=null,Nd(this),K(19));};function Fd(a){null!=a.s&&(k.clearTimeout(a.s),a.s=null);}
g.na=function(a){var b=null;if(this.a==a){Fd(this);this.a=null;var c=2;}else if(gd(this.b,a))b=a.j,hd(this.b,a),c=1;else return;this.m=a.o;if(0!=this.u)if(a.b)1==c?(b=w()-a.v,I.dispatchEvent(new Nb(I,a.l?a.l.length:0,b,this.A)),Hd(this)):Md(this);else{var d=a.c;if(3==d||0==d&&0<this.m||!(1==c&&Id(this,a)||2==c&&Nd(this)))switch(b&&0<b.length&&(a=this.b,a.c=a.c.concat(b)),d){case 1:W(this,5);break;case 4:W(this,10);break;case 3:W(this,6);break;default:W(this,2);}}};
function Jd(a,b){var c=a.Oa+Math.floor(Math.random()*a.Sa);a.ma()||(c*=2);return c*b}function W(a,b){if(2==b){var c=null;a.c&&(c=null);var d=u(a.fb,a);c||(c=new S("//www.google.com/images/cleardot.gif"),k.location&&"http"==k.location.protocol||uc(c,"https"),bc(c));md(c.toString(),d);}else K(2);a.u=0;a.c&&a.c.ta(b);Ed(a);Cd(a);}g.fb=function(a){a?K(2):K(1);};function Ed(a){a.u=0;a.m=-1;if(a.c){if(0!=id(a.b).length||0!=a.f.length)a.b.c.length=0,pa(a.f),a.f.length=0;a.c.sa();}}
function Wc(a,b,c){var d=Jc(c);if(""!=d.b)b&&vc(d,b+"."+d.b),wc(d,d.i);else{var e=k.location,f;b?f=b+"."+e.hostname:f=e.hostname;d=Kc(e.protocol,f,+e.port,c);}a.V&&va(a.V,function(h,l){T(d,l,h);});b=a.j;c=a.I;b&&c&&T(d,b,c);T(d,"VER",a.wa);Dd(a,d);return d}g.$=function(a){if(a&&!this.R)throw Error("Can't create secondary domain capable XhrIo object.");a=new X(this.La);a.F=this.R;return a};g.ma=function(){return !!this.c&&!0};g.Y=function(){return this.R};function Od(){}g=Od.prototype;g.va=function(){};
g.ua=function(){};g.ta=function(){};g.sa=function(){};g.Ta=function(){};function Pd(a){for(var b=arguments[0],c=1;c<arguments.length;c++){var d=arguments[c];if(0==d.lastIndexOf("/",0))b=d;else{var e;(e=""==b)||(e=b.length-1,e=0<=e&&b.indexOf("/",e)==e);e?b+=d:b+="/"+d;}}return b}function Qd(){if(B&&!(10<=Number(Na)))throw Error("Environmental error: no available transport.");}Qd.prototype.a=function(a,b){return new Y(a,b)};
function Y(a,b){G.call(this);this.a=new Ad(b);this.g=a;this.m=b&&b.testUrl?b.testUrl:Pd(this.g,"test");this.b=b&&b.messageUrlParams||null;a=b&&b.messageHeaders||null;b&&b.clientProtocolHeaderRequired&&(a?a["X-Client-Protocol"]="webchannel":a={"X-Client-Protocol":"webchannel"});this.a.i=a;a=b&&b.initMessageHeaders||null;b&&b.messageContentType&&(a?a["X-WebChannel-Content-Type"]=b.messageContentType:a={"X-WebChannel-Content-Type":b.messageContentType});b&&b.xa&&(a?a["X-WebChannel-Client-Profile"]=b.xa:
a={"X-WebChannel-Client-Profile":b.xa});this.a.J=a;(a=b&&b.httpHeadersOverwriteParam)&&!qa(a)&&(this.a.g=a);this.l=b&&b.supportsCrossDomainXhr||!1;this.h=b&&b.sendRawJson||!1;(b=b&&b.httpSessionIdParam)&&!qa(b)&&(this.a.j=b,a=this.b,null!==a&&b in a&&(a=this.b,b in a&&delete a[b]));this.f=new Z(this);}x(Y,G);g=Y.prototype;g.addEventListener=function(a,b,c,d){Y.N.addEventListener.call(this,a,b,c,d);};g.removeEventListener=function(a,b,c,d){Y.N.removeEventListener.call(this,a,b,c,d);};
g.Wa=function(){this.a.c=this.f;this.l&&(this.a.R=!0);var a=this.a,b=this.m,c=this.g,d=this.b||void 0;K(0);a.ha=c;a.V=d||{};a.o&&(a.F.b=[],a.F.a=!1);a.w=new Sc(a);null===a.g&&(a.w.h=a.i);c=b;a.g&&a.i&&(c=zd(b,a.g,a.i));a=a.w;a.i=c;b=Wc(a.a,null,a.i);K(3);c=a.a.F.b;null!=c?(a.f=c[0],a.M=1,Uc(a)):(fc(b,"MODE","init"),!a.a.o&&a.a.j&&fc(b,"X-HTTP-Session-Id",a.a.j),a.b=new M(a,void 0,void 0),a.b.h=a.h,dc(a.b,b,!1,null),a.M=0);};g.close=function(){Bd(this.a);};
g.Xa=function(a){if(m(a)){var b={};b.__data__=a;Gd(this.a,b);}else this.h?(b={},b.__data__=ob(a),Gd(this.a,b)):Gd(this.a,a);};g.G=function(){this.a.c=null;delete this.f;Bd(this.a);delete this.a;Y.N.G.call(this);};function Rd(a){Ub.call(this);var b=a.__sm__;if(b){a:{for(var c in b){a=c;break a}a=void 0;}(this.c=a)?(a=this.c,this.data=null!==b&&a in b?b[a]:void 0):this.data=b;}else this.data=a;}x(Rd,Ub);function Sd(){Vb.call(this);this.status=1;}x(Sd,Vb);function Z(a){this.a=a;}x(Z,Od);Z.prototype.va=function(){this.a.dispatchEvent("a");};
Z.prototype.ua=function(a){this.a.dispatchEvent(new Rd(a));};Z.prototype.ta=function(a){this.a.dispatchEvent(new Sd(a));};Z.prototype.sa=function(){this.a.dispatchEvent("b");};var Td=v(function(a,b){function c(){}c.prototype=a.prototype;var d=new c;a.apply(d,Array.prototype.slice.call(arguments,1));return d},Qd);/*

 Copyright 2017 Google Inc.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
Qd.prototype.createWebChannel=Qd.prototype.a;Y.prototype.send=Y.prototype.Xa;Y.prototype.open=Y.prototype.Wa;Y.prototype.close=Y.prototype.close;Pb.NO_ERROR=0;Pb.TIMEOUT=8;Pb.HTTP_ERROR=6;Qb.COMPLETE="complete";Tb.EventType=L;L.OPEN="a";L.CLOSE="b";L.ERROR="c";L.MESSAGE="d";G.prototype.listen=G.prototype.Aa;X.prototype.listenOnce=X.prototype.Ba;X.prototype.getLastError=X.prototype.Ya;X.prototype.getLastErrorCode=X.prototype.ya;X.prototype.getStatus=X.prototype.T;X.prototype.getStatusText=X.prototype.za;
X.prototype.getResponseJson=X.prototype.Va;X.prototype.getResponseText=X.prototype.aa;X.prototype.send=X.prototype.ca;var tmp={createWebChannelTransport:Td,ErrorCode:Pb,EventType:Qb,WebChannel:Tb,XhrIo:X};
var tmp_1 = tmp.createWebChannelTransport;
var tmp_2 = tmp.ErrorCode;
var tmp_3 = tmp.EventType;
var tmp_4 = tmp.WebChannel;
var tmp_5 = tmp.XhrIo;

/* harmony default export */ __webpack_exports__["default"] = (tmp);

//# sourceMappingURL=index.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(25)))

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var firebase = _interopDefault(__webpack_require__(50));
var tslib = __webpack_require__(51);

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Standard error codes for different ways a request can fail, as defined by:
 * https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
 *
 * This map is used primarily to convert from a backend error code string to
 * a client SDK error code string, and make sure it's in the supported set.
 */
var errorCodeMap = {
    OK: 'ok',
    CANCELLED: 'cancelled',
    UNKNOWN: 'unknown',
    INVALID_ARGUMENT: 'invalid-argument',
    DEADLINE_EXCEEDED: 'deadline-exceeded',
    NOT_FOUND: 'not-found',
    ALREADY_EXISTS: 'already-exists',
    PERMISSION_DENIED: 'permission-denied',
    UNAUTHENTICATED: 'unauthenticated',
    RESOURCE_EXHAUSTED: 'resource-exhausted',
    FAILED_PRECONDITION: 'failed-precondition',
    ABORTED: 'aborted',
    OUT_OF_RANGE: 'out-of-range',
    UNIMPLEMENTED: 'unimplemented',
    INTERNAL: 'internal',
    UNAVAILABLE: 'unavailable',
    DATA_LOSS: 'data-loss'
};
/**
 * An explicit error that can be thrown from a handler to send an error to the
 * client that called the function.
 */
var HttpsErrorImpl = /** @class */ (function (_super) {
    tslib.__extends(HttpsErrorImpl, _super);
    function HttpsErrorImpl(code, message, details) {
        var _this = _super.call(this, message) || this;
        // This is a workaround for a bug in TypeScript when extending Error:
        // tslint:disable-next-line
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, HttpsErrorImpl.prototype);
        _this.code = code;
        _this.details = details;
        return _this;
    }
    return HttpsErrorImpl;
}(Error));
/**
 * Takes an HTTP status code and returns the corresponding ErrorCode.
 * This is the standard HTTP status code -> error mapping defined in:
 * https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
 *
 * @param status An HTTP status code.
 * @return The corresponding ErrorCode, or ErrorCode.UNKNOWN if none.
 */
function codeForHTTPStatus(status) {
    // Make sure any successful status is OK.
    if (status >= 200 && status < 300) {
        return 'ok';
    }
    switch (status) {
        case 0:
            // This can happen if the server returns 500.
            return 'internal';
        case 400:
            return 'invalid-argument';
        case 401:
            return 'unauthenticated';
        case 403:
            return 'permission-denied';
        case 404:
            return 'not-found';
        case 409:
            return 'aborted';
        case 429:
            return 'resource-exhausted';
        case 499:
            return 'cancelled';
        case 500:
            return 'internal';
        case 501:
            return 'unimplemented';
        case 503:
            return 'unavailable';
        case 504:
            return 'deadline-exceeded';
    }
}
/**
 * Takes an HTTP response and returns the corresponding Error, if any.
 */
function _errorForResponse(status, bodyJSON, serializer) {
    var code = codeForHTTPStatus(status);
    // Start with reasonable defaults from the status code.
    var description = code;
    var details = undefined;
    // Then look through the body for explicit details.
    try {
        var errorJSON = bodyJSON && bodyJSON.error;
        if (errorJSON) {
            var status_1 = errorJSON.status;
            if (typeof status_1 === 'string') {
                if (!errorCodeMap[status_1]) {
                    // They must've included an unknown error code in the body.
                    return new HttpsErrorImpl('internal', 'internal');
                }
                code = errorCodeMap[status_1];
                // TODO(klimt): Add better default descriptions for error enums.
                // The default description needs to be updated for the new code.
                description = status_1;
            }
            var message = errorJSON.message;
            if (typeof message === 'string') {
                description = message;
            }
            details = errorJSON.details;
            if (details !== undefined) {
                details = serializer.decode(details);
            }
        }
    }
    catch (e) {
        // If we couldn't parse explicit error data, that's fine.
    }
    if (code === 'ok') {
        // Technically, there's an edge case where a developer could explicitly
        // return an error code of OK, and we will treat it as success, but that
        // seems reasonable.
        return null;
    }
    return new HttpsErrorImpl(code, description, details);
}

/**
 * Helper class to get metadata that should be included with a function call.
 */
var ContextProvider = /** @class */ (function () {
    function ContextProvider(app) {
        this.app = app;
    }
    ContextProvider.prototype.getAuthToken = function () {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var token, e_1;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.app.INTERNAL.getToken()];
                    case 1:
                        token = _a.sent();
                        if (!token) {
                            return [2 /*return*/, undefined];
                        }
                        return [2 /*return*/, token.accessToken];
                    case 2:
                        e_1 = _a.sent();
                        // If there's any error when trying to get the auth token, leave it off.
                        return [2 /*return*/, undefined];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ContextProvider.prototype.getInstanceIdToken = function () {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var messaging, token, e_2;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        // HACK: Until we have a separate instanceId package, this is a quick way
                        // to load in the messaging instance for this app.
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        if (!this.app.messaging) {
                            return [2 /*return*/, undefined];
                        }
                        messaging = this.app.messaging();
                        return [4 /*yield*/, messaging.getToken()];
                    case 1:
                        token = _a.sent();
                        if (!token) {
                            return [2 /*return*/, undefined];
                        }
                        return [2 /*return*/, token];
                    case 2:
                        e_2 = _a.sent();
                        // We don't warn on this, because it usually means messaging isn't set up.
                        // console.warn('Failed to retrieve instance id token.', e);
                        // If there's any error when trying to get the token, leave it off.
                        return [2 /*return*/, undefined];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ContextProvider.prototype.getContext = function () {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var authToken, instanceIdToken;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAuthToken()];
                    case 1:
                        authToken = _a.sent();
                        return [4 /*yield*/, this.getInstanceIdToken()];
                    case 2:
                        instanceIdToken = _a.sent();
                        return [2 /*return*/, { authToken: authToken, instanceIdToken: instanceIdToken }];
                }
            });
        });
    };
    return ContextProvider;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LONG_TYPE = 'type.googleapis.com/google.protobuf.Int64Value';
var UNSIGNED_LONG_TYPE = 'type.googleapis.com/google.protobuf.UInt64Value';
function mapValues(
// { [k: string]: unknown } is no longer a wildcard assignment target after typescript 3.5
// eslint-disable-next-line @typescript-eslint/no-explicit-any
o, f) {
    var result = {};
    for (var key in o) {
        if (o.hasOwnProperty(key)) {
            result[key] = f(o[key]);
        }
    }
    return result;
}
var Serializer = /** @class */ (function () {
    function Serializer() {
    }
    // Takes data and encodes it in a JSON-friendly way, such that types such as
    // Date are preserved.
    Serializer.prototype.encode = function (data) {
        var _this = this;
        if (data == null) {
            return null;
        }
        if (data instanceof Number) {
            data = data.valueOf();
        }
        if (typeof data === 'number' && isFinite(data)) {
            // Any number in JS is safe to put directly in JSON and parse as a double
            // without any loss of precision.
            return data;
        }
        if (data === true || data === false) {
            return data;
        }
        if (Object.prototype.toString.call(data) === '[object String]') {
            return data;
        }
        if (Array.isArray(data)) {
            return data.map(function (x) { return _this.encode(x); });
        }
        if (typeof data === 'function' || typeof data === 'object') {
            return mapValues(data, function (x) { return _this.encode(x); });
        }
        // If we got this far, the data is not encodable.
        throw new Error('Data cannot be encoded in JSON: ' + data);
    };
    // Takes data that's been encoded in a JSON-friendly form and returns a form
    // with richer datatypes, such as Dates, etc.
    Serializer.prototype.decode = function (json) {
        var _this = this;
        if (json == null) {
            return json;
        }
        if (json['@type']) {
            switch (json['@type']) {
                case LONG_TYPE:
                // Fall through and handle this the same as unsigned.
                case UNSIGNED_LONG_TYPE: {
                    // Technically, this could work return a valid number for malformed
                    // data if there was a number followed by garbage. But it's just not
                    // worth all the extra code to detect that case.
                    var value = Number(json['value']);
                    if (isNaN(value)) {
                        throw new Error('Data cannot be decoded from JSON: ' + json);
                    }
                    return value;
                }
                default: {
                    throw new Error('Data cannot be decoded from JSON: ' + json);
                }
            }
        }
        if (Array.isArray(json)) {
            return json.map(function (x) { return _this.decode(x); });
        }
        if (typeof json === 'function' || typeof json === 'object') {
            return mapValues(json, function (x) { return _this.decode(x); });
        }
        // Anything else is safe to return.
        return json;
    };
    return Serializer;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a Promise that will be rejected after the given duration.
 * The error will be of type HttpsErrorImpl.
 *
 * @param millis Number of milliseconds to wait before rejecting.
 */
function failAfter(millis) {
    return new Promise(function (_, reject) {
        setTimeout(function () {
            reject(new HttpsErrorImpl('deadline-exceeded', 'deadline-exceeded'));
        }, millis);
    });
}
/**
 * The main class for the Firebase Functions SDK.
 */
var Service = /** @class */ (function () {
    /**
     * Creates a new Functions service for the given app and (optional) region.
     * @param app_ The FirebaseApp to use.
     * @param region_ The region to call functions in.
     */
    function Service(app_, region_) {
        var _this = this;
        if (region_ === void 0) { region_ = 'us-central1'; }
        this.app_ = app_;
        this.region_ = region_;
        this.serializer = new Serializer();
        this.emulatorOrigin = null;
        this.INTERNAL = {
            delete: function () {
                return _this.deleteService();
            }
        };
        this.contextProvider = new ContextProvider(app_);
        // Cancels all ongoing requests when resolved.
        this.cancelAllRequests = new Promise(function (resolve) {
            _this.deleteService = function () {
                return resolve();
            };
        });
    }
    Object.defineProperty(Service.prototype, "app", {
        get: function () {
            return this.app_;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns the URL for a callable with the given name.
     * @param name The name of the callable.
     */
    Service.prototype._url = function (name) {
        var projectId = this.app_.options.projectId;
        var region = this.region_;
        if (this.emulatorOrigin !== null) {
            var origin_1 = this.emulatorOrigin;
            return origin_1 + "/" + projectId + "/" + region + "/" + name;
        }
        return "https://" + region + "-" + projectId + ".cloudfunctions.net/" + name;
    };
    /**
     * Changes this instance to point to a Cloud Functions emulator running
     * locally. See https://firebase.google.com/docs/functions/local-emulator
     *
     * @param origin The origin of the local emulator, such as
     * "http://localhost:5005".
     */
    Service.prototype.useFunctionsEmulator = function (origin) {
        this.emulatorOrigin = origin;
    };
    /**
     * Returns a reference to the callable https trigger with the given name.
     * @param name The name of the trigger.
     */
    Service.prototype.httpsCallable = function (name, options) {
        var _this = this;
        return function (data) {
            return _this.call(name, data, options || {});
        };
    };
    /**
     * Does an HTTP POST and returns the completed response.
     * @param url The url to post to.
     * @param body The JSON body of the post.
     * @param headers The HTTP headers to include in the request.
     * @return A Promise that will succeed when the request finishes.
     */
    Service.prototype.postJSON = function (url, body, headers) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var response, e_1, json, e_2;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        headers.append('Content-Type', 'application/json');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetch(url, {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: headers
                            })];
                    case 2:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        // This could be an unhandled error on the backend, or it could be a
                        // network error. There's no way to know, since an unhandled error on the
                        // backend will fail to set the proper CORS header, and thus will be
                        // treated as a network error by fetch.
                        return [2 /*return*/, {
                                status: 0,
                                json: null
                            }];
                    case 4:
                        json = null;
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, response.json()];
                    case 6:
                        json = _a.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        e_2 = _a.sent();
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/, {
                            status: response.status,
                            json: json
                        }];
                }
            });
        });
    };
    /**
     * Calls a callable function asynchronously and returns the result.
     * @param name The name of the callable trigger.
     * @param data The data to pass as params to the function.s
     */
    Service.prototype.call = function (name, data, options) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var url, body, headers, context, timeout, response, error, responseData, decodedData;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this._url(name);
                        // Encode any special types, such as dates, in the input data.
                        data = this.serializer.encode(data);
                        body = { data: data };
                        headers = new Headers();
                        return [4 /*yield*/, this.contextProvider.getContext()];
                    case 1:
                        context = _a.sent();
                        if (context.authToken) {
                            headers.append('Authorization', 'Bearer ' + context.authToken);
                        }
                        if (context.instanceIdToken) {
                            headers.append('Firebase-Instance-ID-Token', context.instanceIdToken);
                        }
                        timeout = options.timeout || 70000;
                        return [4 /*yield*/, Promise.race([
                                this.postJSON(url, body, headers),
                                failAfter(timeout),
                                this.cancelAllRequests
                            ])];
                    case 2:
                        response = _a.sent();
                        // If service was deleted, interrupted response throws an error.
                        if (!response) {
                            throw new HttpsErrorImpl('cancelled', 'Firebase Functions instance was deleted.');
                        }
                        error = _errorForResponse(response.status, response.json, this.serializer);
                        if (error) {
                            throw error;
                        }
                        if (!response.json) {
                            throw new HttpsErrorImpl('internal', 'Response is not valid JSON object.');
                        }
                        responseData = response.json.data;
                        // TODO(klimt): For right now, allow "result" instead of "data", for
                        // backwards compatibility.
                        if (typeof responseData === 'undefined') {
                            responseData = response.json.result;
                        }
                        if (typeof responseData === 'undefined') {
                            // Consider the response malformed.
                            throw new HttpsErrorImpl('internal', 'Response is missing data field.');
                        }
                        decodedData = this.serializer.decode(responseData);
                        return [2 /*return*/, { data: decodedData }];
                }
            });
        });
    };
    return Service;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Type constant for Firebase Functions.
 */
var FUNCTIONS_TYPE = 'functions';
function factory(app, _unused, region) {
    return new Service(app, region);
}
function registerFunctions(instance) {
    var namespaceExports = {
        // no-inline
        Functions: Service
    };
    instance.INTERNAL.registerService(FUNCTIONS_TYPE, factory, namespaceExports, 
    // We don't need to wait on any AppHooks.
    undefined, 
    // Allow multiple functions instances per app.
    true);
}
registerFunctions(firebase);

exports.registerFunctions = registerFunctions;
//# sourceMappingURL=index.cjs.js.map


/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isSupported", function() { return isSupported; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerMessaging", function() { return registerMessaging; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tslib__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_util__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__firebase_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firebase_installations__ = __webpack_require__(143);





/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a;
var ERROR_MAP = (_a = {},
    _a["only-available-in-window" /* AVAILABLE_IN_WINDOW */] = 'This method is available in a Window context.',
    _a["only-available-in-sw" /* AVAILABLE_IN_SW */] = 'This method is available in a service worker context.',
    _a["should-be-overriden" /* SHOULD_BE_INHERITED */] = 'This method should be overriden by extended classes.',
    _a["bad-sender-id" /* BAD_SENDER_ID */] = "Please ensure that 'messagingSenderId' is set " +
        'correctly in the options passed into firebase.initializeApp().',
    _a["permission-default" /* PERMISSION_DEFAULT */] = 'The required permissions were not granted and dismissed instead.',
    _a["permission-blocked" /* PERMISSION_BLOCKED */] = 'The required permissions were not granted and blocked instead.',
    _a["unsupported-browser" /* UNSUPPORTED_BROWSER */] = "This browser doesn't support the API's " +
        'required to use the firebase SDK.',
    _a["notifications-blocked" /* NOTIFICATIONS_BLOCKED */] = 'Notifications have been blocked.',
    _a["failed-serviceworker-registration" /* FAILED_DEFAULT_REGISTRATION */] = 'We are unable to register the ' +
        'default service worker. {$browserErrorMessage}',
    _a["sw-registration-expected" /* SW_REGISTRATION_EXPECTED */] = 'A service worker registration was the expected input.',
    _a["get-subscription-failed" /* GET_SUBSCRIPTION_FAILED */] = 'There was an error when trying to get ' +
        'any existing Push Subscriptions.',
    _a["invalid-saved-token" /* INVALID_SAVED_TOKEN */] = 'Unable to access details of the saved token.',
    _a["sw-reg-redundant" /* SW_REG_REDUNDANT */] = 'The service worker being used for push was made redundant.',
    _a["token-subscribe-failed" /* TOKEN_SUBSCRIBE_FAILED */] = 'A problem occured while subscribing the user to FCM: {$errorInfo}',
    _a["token-subscribe-no-token" /* TOKEN_SUBSCRIBE_NO_TOKEN */] = 'FCM returned no token when subscribing the user to push.',
    _a["token-unsubscribe-failed" /* TOKEN_UNSUBSCRIBE_FAILED */] = 'A problem occured while unsubscribing the ' +
        'user from FCM: {$errorInfo}',
    _a["token-update-failed" /* TOKEN_UPDATE_FAILED */] = 'A problem occured while updating the user from FCM: {$errorInfo}',
    _a["token-update-no-token" /* TOKEN_UPDATE_NO_TOKEN */] = 'FCM returned no token when updating the user to push.',
    _a["use-sw-before-get-token" /* USE_SW_BEFORE_GET_TOKEN */] = 'The useServiceWorker() method may only be called once and must be ' +
        'called before calling getToken() to ensure your service worker is used.',
    _a["invalid-delete-token" /* INVALID_DELETE_TOKEN */] = 'You must pass a valid token into ' +
        'deleteToken(), i.e. the token from getToken().',
    _a["delete-token-not-found" /* DELETE_TOKEN_NOT_FOUND */] = 'The deletion attempt for token could not ' +
        'be performed as the token was not found.',
    _a["delete-scope-not-found" /* DELETE_SCOPE_NOT_FOUND */] = 'The deletion attempt for service worker ' +
        'scope could not be performed as the scope was not found.',
    _a["bg-handler-function-expected" /* BG_HANDLER_FUNCTION_EXPECTED */] = 'The input to setBackgroundMessageHandler() must be a function.',
    _a["no-window-client-to-msg" /* NO_WINDOW_CLIENT_TO_MSG */] = 'An attempt was made to message a non-existant window client.',
    _a["unable-to-resubscribe" /* UNABLE_TO_RESUBSCRIBE */] = 'There was an error while re-subscribing ' +
        'the FCM token for push messaging. Will have to resubscribe the ' +
        'user on next visit. {$errorInfo}',
    _a["no-fcm-token-for-resubscribe" /* NO_FCM_TOKEN_FOR_RESUBSCRIBE */] = 'Could not find an FCM token ' +
        'and as a result, unable to resubscribe. Will have to resubscribe the ' +
        'user on next visit.',
    _a["failed-to-delete-token" /* FAILED_TO_DELETE_TOKEN */] = 'Unable to delete the currently saved token.',
    _a["no-sw-in-reg" /* NO_SW_IN_REG */] = 'Even though the service worker registration was ' +
        'successful, there was a problem accessing the service worker itself.',
    _a["bad-scope" /* BAD_SCOPE */] = 'The service worker scope must be a string with at ' +
        'least one character.',
    _a["bad-vapid-key" /* BAD_VAPID_KEY */] = 'The public VAPID key is not a Uint8Array with 65 bytes.',
    _a["bad-subscription" /* BAD_SUBSCRIPTION */] = 'The subscription must be a valid PushSubscription.',
    _a["bad-token" /* BAD_TOKEN */] = 'The FCM Token used for storage / lookup was not ' +
        'a valid token string.',
    _a["failed-delete-vapid-key" /* FAILED_DELETE_VAPID_KEY */] = 'The VAPID key could not be deleted.',
    _a["invalid-public-vapid-key" /* INVALID_PUBLIC_VAPID_KEY */] = 'The public VAPID key must be a string.',
    _a["use-public-key-before-get-token" /* USE_PUBLIC_KEY_BEFORE_GET_TOKEN */] = 'The usePublicVapidKey() method may only be called once and must be ' +
        'called before calling getToken() to ensure your VAPID key is used.',
    _a["public-vapid-key-decryption-failed" /* PUBLIC_KEY_DECRYPTION_FAILED */] = 'The public VAPID key did not equal 65 bytes when decrypted.',
    _a);
var errorFactory = new __WEBPACK_IMPORTED_MODULE_2__firebase_util__["ErrorFactory"]('messaging', 'Messaging', ERROR_MAP);

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DEFAULT_PUBLIC_VAPID_KEY = new Uint8Array([
    0x04,
    0x33,
    0x94,
    0xf7,
    0xdf,
    0xa1,
    0xeb,
    0xb1,
    0xdc,
    0x03,
    0xa2,
    0x5e,
    0x15,
    0x71,
    0xdb,
    0x48,
    0xd3,
    0x2e,
    0xed,
    0xed,
    0xb2,
    0x34,
    0xdb,
    0xb7,
    0x47,
    0x3a,
    0x0c,
    0x8f,
    0xc4,
    0xcc,
    0xe1,
    0x6f,
    0x3c,
    0x8c,
    0x84,
    0xdf,
    0xab,
    0xb6,
    0x66,
    0x3e,
    0xf2,
    0x0c,
    0xd4,
    0x8b,
    0xfe,
    0xe3,
    0xf9,
    0x76,
    0x2f,
    0x14,
    0x1c,
    0x63,
    0x08,
    0x6a,
    0x6f,
    0x2d,
    0xb1,
    0x1a,
    0x95,
    0xb0,
    0xce,
    0x37,
    0xc0,
    0x9c,
    0x6e
]);
var ENDPOINT = 'https://fcmregistrations.googleapis.com/v1';
var FN_CAMPAIGN_ID = 'google.c.a.c_id';
var FN_CAMPAIGN_NAME = 'google.c.a.c_l';
var FN_CAMPAIGN_TIME = 'google.c.a.ts';
/** Set to '1' if Analytics is enabled for the campaign */
var FN_CAMPAIGN_ANALYTICS_ENABLED = 'google.c.a.e';

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var MessageType;
(function (MessageType) {
    MessageType["PUSH_MSG_RECEIVED"] = "push-msg-received";
    MessageType["NOTIFICATION_CLICKED"] = "notification-clicked";
})(MessageType || (MessageType = {}));

/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function isArrayBufferEqual(a, b) {
    if (a == null || b == null) {
        return false;
    }
    if (a === b) {
        return true;
    }
    if (a.byteLength !== b.byteLength) {
        return false;
    }
    var viewA = new DataView(a);
    var viewB = new DataView(b);
    for (var i = 0; i < a.byteLength; i++) {
        if (viewA.getUint8(i) !== viewB.getUint8(i)) {
            return false;
        }
    }
    return true;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function toBase64(arrayBuffer) {
    var uint8Version = new Uint8Array(arrayBuffer);
    return btoa(String.fromCharCode.apply(String, __WEBPACK_IMPORTED_MODULE_1_tslib__["__spread"](uint8Version)));
}
function arrayBufferToBase64(arrayBuffer) {
    var base64String = toBase64(arrayBuffer);
    return base64String
        .replace(/=/g, '')
        .replace(/\+/g, '-')
        .replace(/\//g, '_');
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var SubscriptionManager = /** @class */ (function () {
    function SubscriptionManager() {
    }
    SubscriptionManager.prototype.getToken = function (app, subscription, vapidKey) {
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
            var headers, body, subscribeOptions, responseData, response, err_1, message;
            return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getHeaders(app)];
                    case 1:
                        headers = _a.sent();
                        body = getBody(subscription, vapidKey);
                        subscribeOptions = {
                            method: 'POST',
                            headers: headers,
                            body: JSON.stringify(body)
                        };
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 5, , 6]);
                        return [4 /*yield*/, fetch(getEndpoint(app), subscribeOptions)];
                    case 3:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 4:
                        responseData = _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        err_1 = _a.sent();
                        throw errorFactory.create("token-subscribe-failed" /* TOKEN_SUBSCRIBE_FAILED */, {
                            errorInfo: err_1
                        });
                    case 6:
                        if (responseData.error) {
                            message = responseData.error.message;
                            throw errorFactory.create("token-subscribe-failed" /* TOKEN_SUBSCRIBE_FAILED */, {
                                errorInfo: message
                            });
                        }
                        if (!responseData.token) {
                            throw errorFactory.create("token-subscribe-no-token" /* TOKEN_SUBSCRIBE_NO_TOKEN */);
                        }
                        return [2 /*return*/, responseData.token];
                }
            });
        });
    };
    /**
     * Update the underlying token details for fcmToken.
     */
    SubscriptionManager.prototype.updateToken = function (tokenDetails, app, subscription, vapidKey) {
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
            var headers, body, updateOptions, responseData, response, err_2, message;
            return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getHeaders(app)];
                    case 1:
                        headers = _a.sent();
                        body = getBody(subscription, vapidKey);
                        updateOptions = {
                            method: 'PATCH',
                            headers: headers,
                            body: JSON.stringify(body)
                        };
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 5, , 6]);
                        return [4 /*yield*/, fetch(getEndpoint(app) + "/" + tokenDetails.fcmToken, updateOptions)];
                    case 3:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 4:
                        responseData = _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        err_2 = _a.sent();
                        throw errorFactory.create("token-update-failed" /* TOKEN_UPDATE_FAILED */, {
                            errorInfo: err_2
                        });
                    case 6:
                        if (responseData.error) {
                            message = responseData.error.message;
                            throw errorFactory.create("token-update-failed" /* TOKEN_UPDATE_FAILED */, {
                                errorInfo: message
                            });
                        }
                        if (!responseData.token) {
                            throw errorFactory.create("token-update-no-token" /* TOKEN_UPDATE_NO_TOKEN */);
                        }
                        return [2 /*return*/, responseData.token];
                }
            });
        });
    };
    SubscriptionManager.prototype.deleteToken = function (app, tokenDetails) {
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
            var headers, unsubscribeOptions, response, responseData, message, err_3;
            return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getHeaders(app)];
                    case 1:
                        headers = _a.sent();
                        unsubscribeOptions = {
                            method: 'DELETE',
                            headers: headers
                        };
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 5, , 6]);
                        return [4 /*yield*/, fetch(getEndpoint(app) + "/" + tokenDetails.fcmToken, unsubscribeOptions)];
                    case 3:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 4:
                        responseData = _a.sent();
                        if (responseData.error) {
                            message = responseData.error.message;
                            throw errorFactory.create("token-unsubscribe-failed" /* TOKEN_UNSUBSCRIBE_FAILED */, {
                                errorInfo: message
                            });
                        }
                        return [3 /*break*/, 6];
                    case 5:
                        err_3 = _a.sent();
                        throw errorFactory.create("token-unsubscribe-failed" /* TOKEN_UNSUBSCRIBE_FAILED */, {
                            errorInfo: err_3
                        });
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    return SubscriptionManager;
}());
function getEndpoint(app) {
    return ENDPOINT + "/projects/" + app.options.projectId + "/registrations";
}
function getHeaders(app) {
    return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
        var installations, authToken;
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
            switch (_a.label) {
                case 0:
                    installations = app.installations();
                    return [4 /*yield*/, installations.getToken()];
                case 1:
                    authToken = _a.sent();
                    return [2 /*return*/, new Headers({
                            'Content-Type': 'application/json',
                            Accept: 'application/json',
                            'x-goog-api-key': app.options.apiKey,
                            'x-goog-firebase-installations-auth': "FIS " + authToken
                        })];
            }
        });
    });
}
function getBody(subscription, vapidKey) {
    var p256dh = arrayBufferToBase64(subscription.getKey('p256dh'));
    var auth = arrayBufferToBase64(subscription.getKey('auth'));
    var body = {
        web: {
            endpoint: subscription.endpoint,
            p256dh: p256dh,
            auth: auth
        }
    };
    if (!isArrayBufferEqual(vapidKey.buffer, DEFAULT_PUBLIC_VAPID_KEY.buffer)) {
        body.web.applicationPubKey = arrayBufferToBase64(vapidKey);
    }
    return body;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function base64ToArrayBuffer(base64String) {
    var padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    var base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');
    var rawData = atob(base64);
    var outputArray = new Uint8Array(rawData.length);
    for (var i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var OLD_DB_NAME = 'undefined';
var OLD_OBJECT_STORE_NAME = 'fcm_token_object_Store';
function handleDb(db, app) {
    if (!db.objectStoreNames.contains(OLD_OBJECT_STORE_NAME)) {
        // We found a database with the name 'undefined', but our expected object
        // store isn't defined.
        return;
    }
    var transaction = db.transaction(OLD_OBJECT_STORE_NAME);
    var objectStore = transaction.objectStore(OLD_OBJECT_STORE_NAME);
    var subscriptionManager = new SubscriptionManager();
    var openCursorRequest = objectStore.openCursor();
    openCursorRequest.onerror = function (event) {
        // NOOP - Nothing we can do.
        console.warn('Unable to cleanup old IDB.', event);
    };
    openCursorRequest.onsuccess = function () {
        var cursor = openCursorRequest.result;
        if (cursor) {
            // cursor.value contains the current record being iterated through
            // this is where you'd do something with the result
            var tokenDetails = cursor.value;
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            subscriptionManager.deleteToken(app, tokenDetails);
            cursor.continue();
        }
        else {
            db.close();
            indexedDB.deleteDatabase(OLD_DB_NAME);
        }
    };
}
function cleanV1(app) {
    var request = indexedDB.open(OLD_DB_NAME);
    request.onerror = function (_event) {
        // NOOP - Nothing we can do.
    };
    request.onsuccess = function (_event) {
        var db = request.result;
        handleDb(db, app);
    };
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DbInterface = /** @class */ (function () {
    function DbInterface() {
        this.dbPromise = null;
    }
    /** Gets record(s) from the objectStore that match the given key. */
    DbInterface.prototype.get = function (key) {
        return this.createTransaction(function (objectStore) { return objectStore.get(key); });
    };
    /** Gets record(s) from the objectStore that match the given index. */
    DbInterface.prototype.getIndex = function (index, key) {
        function runRequest(objectStore) {
            var idbIndex = objectStore.index(index);
            return idbIndex.get(key);
        }
        return this.createTransaction(runRequest);
    };
    /** Assigns or overwrites the record for the given value. */
    // IndexedDB values are of type "any"
    DbInterface.prototype.put = function (value) {
        return this.createTransaction(function (objectStore) { return objectStore.put(value); }, 'readwrite');
    };
    /** Deletes record(s) from the objectStore that match the given key. */
    DbInterface.prototype.delete = function (key) {
        return this.createTransaction(function (objectStore) { return objectStore.delete(key); }, 'readwrite');
    };
    /**
     * Close the currently open database.
     */
    DbInterface.prototype.closeDatabase = function () {
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
            var db;
            return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.dbPromise) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.dbPromise];
                    case 1:
                        db = _a.sent();
                        db.close();
                        this.dbPromise = null;
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates an IndexedDB Transaction and passes its objectStore to the
     * runRequest function, which runs the database request.
     *
     * @return Promise that resolves with the result of the runRequest function
     */
    DbInterface.prototype.createTransaction = function (runRequest, mode) {
        if (mode === void 0) { mode = 'readonly'; }
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
            var db, transaction, request, result;
            return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDb()];
                    case 1:
                        db = _a.sent();
                        transaction = db.transaction(this.objectStoreName, mode);
                        request = transaction.objectStore(this.objectStoreName);
                        return [4 /*yield*/, promisify(runRequest(request))];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                transaction.oncomplete = function () {
                                    resolve(result);
                                };
                                transaction.onerror = function () {
                                    reject(transaction.error);
                                };
                            })];
                }
            });
        });
    };
    /** Gets the cached db connection or opens a new one. */
    DbInterface.prototype.getDb = function () {
        var _this = this;
        if (!this.dbPromise) {
            this.dbPromise = new Promise(function (resolve, reject) {
                var request = indexedDB.open(_this.dbName, _this.dbVersion);
                request.onsuccess = function () {
                    resolve(request.result);
                };
                request.onerror = function () {
                    _this.dbPromise = null;
                    reject(request.error);
                };
                request.onupgradeneeded = function (event) { return _this.onDbUpgrade(request, event); };
            });
        }
        return this.dbPromise;
    };
    return DbInterface;
}());
/** Promisifies an IDBRequest. Resolves with the IDBRequest's result. */
function promisify(request) {
    return new Promise(function (resolve, reject) {
        request.onsuccess = function () {
            resolve(request.result);
        };
        request.onerror = function () {
            reject(request.error);
        };
    });
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var TokenDetailsModel = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_1_tslib__["__extends"](TokenDetailsModel, _super);
    function TokenDetailsModel(app) {
        var _this = _super.call(this) || this;
        _this.app = app;
        _this.dbName = 'fcm_token_details_db';
        _this.dbVersion = 4;
        _this.objectStoreName = 'fcm_token_object_Store';
        return _this;
    }
    TokenDetailsModel.prototype.onDbUpgrade = function (request, event) {
        var db = request.result;
        // Lack of 'break' statements is intentional.
        switch (event.oldVersion) {
            case 0: {
                // New IDB instance
                var objectStore = db.createObjectStore(this.objectStoreName, {
                    keyPath: 'swScope'
                });
                // Make sure the sender ID can be searched
                objectStore.createIndex('fcmSenderId', 'fcmSenderId', {
                    unique: false
                });
                objectStore.createIndex('fcmToken', 'fcmToken', { unique: true });
            }
            case 1: {
                // Prior to version 2, we were using either 'fcm_token_details_db'
                // or 'undefined' as the database name due to bug in the SDK
                // So remove the old tokens and databases.
                cleanV1(this.app);
            }
            case 2: {
                // Update from v2 to v4 directly in a single openCursor request.
                // We need to do this because for some reason, doing a subsequent update on the same data
                // in the same transaction drops the first update.
                var objectStore = request.transaction.objectStore(this.objectStoreName);
                var cursorRequest_1 = objectStore.openCursor();
                cursorRequest_1.onsuccess = function () {
                    var cursor = cursorRequest_1.result;
                    if (cursor) {
                        var value = cursor.value;
                        var newValue = __WEBPACK_IMPORTED_MODULE_1_tslib__["__assign"]({}, value);
                        if (!value.createTime) {
                            newValue.createTime = Date.now();
                        }
                        if (typeof value.vapidKey === 'string') {
                            newValue.vapidKey = base64ToArrayBuffer(value.vapidKey);
                        }
                        if (typeof value.auth === 'string') {
                            newValue.auth = base64ToArrayBuffer(value.auth).buffer;
                        }
                        if (typeof value.auth === 'string') {
                            newValue.p256dh = base64ToArrayBuffer(value.p256dh).buffer;
                        }
                        if (typeof value.fcmPushSet === 'string') {
                            delete newValue.fcmPushSet;
                        }
                        cursor.update(newValue);
                        cursor.continue();
                    }
                };
                // Break here as we've already updated to v4.
                break;
            }
            case 3: {
                // Update from V3 to V4.
                var objectStore = request.transaction.objectStore(this.objectStoreName);
                var cursorRequest_2 = objectStore.openCursor();
                cursorRequest_2.onsuccess = function () {
                    var cursor = cursorRequest_2.result;
                    if (cursor) {
                        var value = cursor.value;
                        var newValue = __WEBPACK_IMPORTED_MODULE_1_tslib__["__assign"]({}, value);
                        if (typeof value.fcmPushSet === 'string') {
                            delete newValue.fcmPushSet;
                        }
                        cursor.update(newValue);
                        cursor.continue();
                    }
                };
            }
        }
    };
    /**
     * Given a token, this method will look up the details in indexedDB.
     */
    TokenDetailsModel.prototype.getTokenDetailsFromToken = function (fcmToken) {
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
            return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
                if (!fcmToken) {
                    throw errorFactory.create("bad-token" /* BAD_TOKEN */);
                }
                validateInputs({ fcmToken: fcmToken });
                return [2 /*return*/, this.getIndex('fcmToken', fcmToken)];
            });
        });
    };
    /**
     * Given a service worker scope, this method will look up the details in
     * indexedDB.
     * @return The details associated with that token.
     */
    TokenDetailsModel.prototype.getTokenDetailsFromSWScope = function (swScope) {
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
            return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
                if (!swScope) {
                    throw errorFactory.create("bad-scope" /* BAD_SCOPE */);
                }
                validateInputs({ swScope: swScope });
                return [2 /*return*/, this.get(swScope)];
            });
        });
    };
    /**
     * Save the details for the fcm token for re-use at a later date.
     * @param input A plain js object containing args to save.
     */
    TokenDetailsModel.prototype.saveTokenDetails = function (tokenDetails) {
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
            return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
                if (!tokenDetails.swScope) {
                    throw errorFactory.create("bad-scope" /* BAD_SCOPE */);
                }
                if (!tokenDetails.vapidKey) {
                    throw errorFactory.create("bad-vapid-key" /* BAD_VAPID_KEY */);
                }
                if (!tokenDetails.endpoint || !tokenDetails.auth || !tokenDetails.p256dh) {
                    throw errorFactory.create("bad-subscription" /* BAD_SUBSCRIPTION */);
                }
                if (!tokenDetails.fcmSenderId) {
                    throw errorFactory.create("bad-sender-id" /* BAD_SENDER_ID */);
                }
                if (!tokenDetails.fcmToken) {
                    throw errorFactory.create("bad-token" /* BAD_TOKEN */);
                }
                validateInputs(tokenDetails);
                return [2 /*return*/, this.put(tokenDetails)];
            });
        });
    };
    /**
     * This method deletes details of the current FCM token.
     * It's returning a promise in case we need to move to an async
     * method for deleting at a later date.
     *
     * @return Resolves once the FCM token details have been deleted and returns
     * the deleted details.
     */
    TokenDetailsModel.prototype.deleteToken = function (token) {
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
            var details;
            return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (typeof token !== 'string' || token.length === 0) {
                            return [2 /*return*/, Promise.reject(errorFactory.create("invalid-delete-token" /* INVALID_DELETE_TOKEN */))];
                        }
                        return [4 /*yield*/, this.getTokenDetailsFromToken(token)];
                    case 1:
                        details = _a.sent();
                        if (!details) {
                            throw errorFactory.create("delete-token-not-found" /* DELETE_TOKEN_NOT_FOUND */);
                        }
                        return [4 /*yield*/, this.delete(details.swScope)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, details];
                }
            });
        });
    };
    return TokenDetailsModel;
}(DbInterface));
/**
 * This method takes an object and will check for known arguments and
 * validate the input.
 * @return Promise that resolves if input is valid, rejects otherwise.
 */
function validateInputs(input) {
    if (input.fcmToken) {
        if (typeof input.fcmToken !== 'string' || input.fcmToken.length === 0) {
            throw errorFactory.create("bad-token" /* BAD_TOKEN */);
        }
    }
    if (input.swScope) {
        if (typeof input.swScope !== 'string' || input.swScope.length === 0) {
            throw errorFactory.create("bad-scope" /* BAD_SCOPE */);
        }
    }
    if (input.vapidKey) {
        if (!(input.vapidKey instanceof Uint8Array) ||
            input.vapidKey.length !== 65) {
            throw errorFactory.create("bad-vapid-key" /* BAD_VAPID_KEY */);
        }
    }
    if (input.endpoint) {
        if (typeof input.endpoint !== 'string' || input.endpoint.length === 0) {
            throw errorFactory.create("bad-subscription" /* BAD_SUBSCRIPTION */);
        }
    }
    if (input.auth) {
        if (!(input.auth instanceof ArrayBuffer)) {
            throw errorFactory.create("bad-subscription" /* BAD_SUBSCRIPTION */);
        }
    }
    if (input.p256dh) {
        if (!(input.p256dh instanceof ArrayBuffer)) {
            throw errorFactory.create("bad-subscription" /* BAD_SUBSCRIPTION */);
        }
    }
    if (input.fcmSenderId) {
        if (typeof input.fcmSenderId !== 'string' ||
            input.fcmSenderId.length === 0) {
            throw errorFactory.create("bad-sender-id" /* BAD_SENDER_ID */);
        }
    }
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var UNCOMPRESSED_PUBLIC_KEY_SIZE = 65;
var VapidDetailsModel = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_1_tslib__["__extends"](VapidDetailsModel, _super);
    function VapidDetailsModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dbName = 'fcm_vapid_details_db';
        _this.dbVersion = 1;
        _this.objectStoreName = 'fcm_vapid_object_Store';
        return _this;
    }
    VapidDetailsModel.prototype.onDbUpgrade = function (request) {
        var db = request.result;
        db.createObjectStore(this.objectStoreName, { keyPath: 'swScope' });
    };
    /**
     * Given a service worker scope, this method will look up the vapid key
     * in indexedDB.
     */
    VapidDetailsModel.prototype.getVapidFromSWScope = function (swScope) {
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
            var result;
            return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (typeof swScope !== 'string' || swScope.length === 0) {
                            throw errorFactory.create("bad-scope" /* BAD_SCOPE */);
                        }
                        return [4 /*yield*/, this.get(swScope)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result ? result.vapidKey : undefined];
                }
            });
        });
    };
    /**
     * Save a vapid key against a swScope for later date.
     */
    VapidDetailsModel.prototype.saveVapidDetails = function (swScope, vapidKey) {
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
            var details;
            return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
                if (typeof swScope !== 'string' || swScope.length === 0) {
                    throw errorFactory.create("bad-scope" /* BAD_SCOPE */);
                }
                if (vapidKey === null || vapidKey.length !== UNCOMPRESSED_PUBLIC_KEY_SIZE) {
                    throw errorFactory.create("bad-vapid-key" /* BAD_VAPID_KEY */);
                }
                details = {
                    swScope: swScope,
                    vapidKey: vapidKey
                };
                return [2 /*return*/, this.put(details)];
            });
        });
    };
    /**
     * This method deletes details of the current FCM VAPID key for a SW scope.
     * Resolves once the scope/vapid details have been deleted and returns the
     * deleted vapid key.
     */
    VapidDetailsModel.prototype.deleteVapidDetails = function (swScope) {
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
            var vapidKey;
            return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getVapidFromSWScope(swScope)];
                    case 1:
                        vapidKey = _a.sent();
                        if (!vapidKey) {
                            throw errorFactory.create("delete-scope-not-found" /* DELETE_SCOPE_NOT_FOUND */);
                        }
                        return [4 /*yield*/, this.delete(swScope)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, vapidKey];
                }
            });
        });
    };
    return VapidDetailsModel;
}(DbInterface));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Token should be refreshed once a week.
var TOKEN_EXPIRATION_MILLIS = 7 * 24 * 60 * 60 * 1000; // 7 days
var BaseController = /** @class */ (function () {
    function BaseController(app) {
        var _this = this;
        this.app = app;
        this.vapidDetailsModel = new VapidDetailsModel();
        this.subscriptionManager = new SubscriptionManager();
        if (!app.options.messagingSenderId ||
            typeof app.options.messagingSenderId !== 'string') {
            throw errorFactory.create("bad-sender-id" /* BAD_SENDER_ID */);
        }
        this.INTERNAL = {
            delete: function () { return _this.delete(); }
        };
        this.tokenDetailsModel = new TokenDetailsModel(app);
    }
    BaseController.prototype.getToken = function () {
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
            var currentPermission, swReg, publicVapidKey, pushSubscription, tokenDetails;
            return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        currentPermission = this.getNotificationPermission_();
                        if (currentPermission === 'denied') {
                            throw errorFactory.create("notifications-blocked" /* NOTIFICATIONS_BLOCKED */);
                        }
                        else if (currentPermission !== 'granted') {
                            // We must wait for permission to be granted
                            return [2 /*return*/, null];
                        }
                        return [4 /*yield*/, this.getSWRegistration_()];
                    case 1:
                        swReg = _a.sent();
                        return [4 /*yield*/, this.getPublicVapidKey_()];
                    case 2:
                        publicVapidKey = _a.sent();
                        return [4 /*yield*/, this.getPushSubscription(swReg, publicVapidKey)];
                    case 3:
                        pushSubscription = _a.sent();
                        return [4 /*yield*/, this.tokenDetailsModel.getTokenDetailsFromSWScope(swReg.scope)];
                    case 4:
                        tokenDetails = _a.sent();
                        if (tokenDetails) {
                            return [2 /*return*/, this.manageExistingToken(swReg, pushSubscription, publicVapidKey, tokenDetails)];
                        }
                        return [2 /*return*/, this.getNewToken(swReg, pushSubscription, publicVapidKey)];
                }
            });
        });
    };
    /**
     * manageExistingToken is triggered if there's an existing FCM token in the
     * database and it can take 3 different actions:
     * 1) Retrieve the existing FCM token from the database.
     * 2) If VAPID details have changed: Delete the existing token and create a
     * new one with the new VAPID key.
     * 3) If the database cache is invalidated: Send a request to FCM to update
     * the token, and to check if the token is still valid on FCM-side.
     */
    BaseController.prototype.manageExistingToken = function (swReg, pushSubscription, publicVapidKey, tokenDetails) {
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
            var isTokenValid, now;
            return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isTokenValid = isTokenStillValid(pushSubscription, publicVapidKey, tokenDetails);
                        if (!isTokenValid) return [3 /*break*/, 1];
                        now = Date.now();
                        if (now < tokenDetails.createTime + TOKEN_EXPIRATION_MILLIS) {
                            return [2 /*return*/, tokenDetails.fcmToken];
                        }
                        else {
                            return [2 /*return*/, this.updateToken(swReg, pushSubscription, publicVapidKey, tokenDetails)];
                        }
                    case 1: 
                    // If the token is no longer valid (for example if the VAPID details
                    // have changed), delete the existing token from the FCM client and server
                    // database. No need to unsubscribe from the Service Worker as we have a
                    // good push subscription that we'd like to use in getNewToken.
                    return [4 /*yield*/, this.deleteTokenFromDB(tokenDetails.fcmToken)];
                    case 2:
                        // If the token is no longer valid (for example if the VAPID details
                        // have changed), delete the existing token from the FCM client and server
                        // database. No need to unsubscribe from the Service Worker as we have a
                        // good push subscription that we'd like to use in getNewToken.
                        _a.sent();
                        return [2 /*return*/, this.getNewToken(swReg, pushSubscription, publicVapidKey)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    BaseController.prototype.updateToken = function (swReg, pushSubscription, publicVapidKey, tokenDetails) {
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
            var updatedToken, allDetails, e_1;
            return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 6]);
                        return [4 /*yield*/, this.subscriptionManager.updateToken(tokenDetails, this.app, pushSubscription, publicVapidKey)];
                    case 1:
                        updatedToken = _a.sent();
                        allDetails = {
                            swScope: swReg.scope,
                            vapidKey: publicVapidKey,
                            fcmSenderId: this.app.options.messagingSenderId,
                            fcmToken: updatedToken,
                            createTime: Date.now(),
                            endpoint: pushSubscription.endpoint,
                            auth: pushSubscription.getKey('auth'),
                            p256dh: pushSubscription.getKey('p256dh')
                        };
                        return [4 /*yield*/, this.tokenDetailsModel.saveTokenDetails(allDetails)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.vapidDetailsModel.saveVapidDetails(swReg.scope, publicVapidKey)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, updatedToken];
                    case 4:
                        e_1 = _a.sent();
                        return [4 /*yield*/, this.deleteToken(tokenDetails.fcmToken)];
                    case 5:
                        _a.sent();
                        throw e_1;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    BaseController.prototype.getNewToken = function (swReg, pushSubscription, publicVapidKey) {
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
            var newToken, allDetails;
            return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.subscriptionManager.getToken(this.app, pushSubscription, publicVapidKey)];
                    case 1:
                        newToken = _a.sent();
                        allDetails = {
                            swScope: swReg.scope,
                            vapidKey: publicVapidKey,
                            fcmSenderId: this.app.options.messagingSenderId,
                            fcmToken: newToken,
                            createTime: Date.now(),
                            endpoint: pushSubscription.endpoint,
                            auth: pushSubscription.getKey('auth'),
                            p256dh: pushSubscription.getKey('p256dh')
                        };
                        return [4 /*yield*/, this.tokenDetailsModel.saveTokenDetails(allDetails)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.vapidDetailsModel.saveVapidDetails(swReg.scope, publicVapidKey)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, newToken];
                }
            });
        });
    };
    /**
     * This method deletes tokens that the token manager looks after,
     * unsubscribes the token from FCM  and then unregisters the push
     * subscription if it exists. It returns a promise that indicates
     * whether or not the unsubscribe request was processed successfully.
     */
    BaseController.prototype.deleteToken = function (token) {
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
            var registration, pushSubscription;
            return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // Delete the token details from the database.
                    return [4 /*yield*/, this.deleteTokenFromDB(token)];
                    case 1:
                        // Delete the token details from the database.
                        _a.sent();
                        return [4 /*yield*/, this.getSWRegistration_()];
                    case 2:
                        registration = _a.sent();
                        if (!registration) return [3 /*break*/, 4];
                        return [4 /*yield*/, registration.pushManager.getSubscription()];
                    case 3:
                        pushSubscription = _a.sent();
                        if (pushSubscription) {
                            return [2 /*return*/, pushSubscription.unsubscribe()];
                        }
                        _a.label = 4;
                    case 4: 
                    // If there's no SW, consider it a success.
                    return [2 /*return*/, true];
                }
            });
        });
    };
    /**
     * This method will delete the token from the client database, and make a
     * call to FCM to remove it from the server DB. Does not temper with the
     * push subscription.
     */
    BaseController.prototype.deleteTokenFromDB = function (token) {
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
            var tokenDetails;
            return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tokenDetailsModel.deleteToken(token)];
                    case 1:
                        tokenDetails = _a.sent();
                        return [4 /*yield*/, this.subscriptionManager.deleteToken(this.app, tokenDetails)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets a PushSubscription for the current user.
     */
    BaseController.prototype.getPushSubscription = function (swRegistration, publicVapidKey) {
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
            var subscription;
            return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, swRegistration.pushManager.getSubscription()];
                    case 1:
                        subscription = _a.sent();
                        if (subscription) {
                            return [2 /*return*/, subscription];
                        }
                        return [2 /*return*/, swRegistration.pushManager.subscribe({
                                userVisibleOnly: true,
                                applicationServerKey: publicVapidKey
                            })];
                }
            });
        });
    };
    //
    // The following methods should only be available in the window.
    //
    /**
     * @deprecated Use Notification.requestPermission() instead.
     * https://developer.mozilla.org/en-US/docs/Web/API/Notification/requestPermission
     */
    BaseController.prototype.requestPermission = function () {
        throw errorFactory.create("only-available-in-window" /* AVAILABLE_IN_WINDOW */);
    };
    BaseController.prototype.useServiceWorker = function (_registration) {
        throw errorFactory.create("only-available-in-window" /* AVAILABLE_IN_WINDOW */);
    };
    BaseController.prototype.usePublicVapidKey = function (_b64PublicKey) {
        throw errorFactory.create("only-available-in-window" /* AVAILABLE_IN_WINDOW */);
    };
    BaseController.prototype.onMessage = function (_nextOrObserver, _error, _completed) {
        throw errorFactory.create("only-available-in-window" /* AVAILABLE_IN_WINDOW */);
    };
    BaseController.prototype.onTokenRefresh = function (_nextOrObserver, _error, _completed) {
        throw errorFactory.create("only-available-in-window" /* AVAILABLE_IN_WINDOW */);
    };
    //
    // The following methods are used by the service worker only.
    //
    BaseController.prototype.setBackgroundMessageHandler = function (_callback) {
        throw errorFactory.create("only-available-in-sw" /* AVAILABLE_IN_SW */);
    };
    //
    // The following methods are used by the service themselves and not exposed
    // publicly or not expected to be used by developers.
    //
    /**
     * This method is required to adhere to the Firebase interface.
     * It closes any currently open indexdb database connections.
     */
    BaseController.prototype.delete = function () {
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
            return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this.tokenDetailsModel.closeDatabase(),
                            this.vapidDetailsModel.closeDatabase()
                        ])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Returns the current Notification Permission state.
     */
    BaseController.prototype.getNotificationPermission_ = function () {
        return Notification.permission;
    };
    BaseController.prototype.getTokenDetailsModel = function () {
        return this.tokenDetailsModel;
    };
    BaseController.prototype.getVapidDetailsModel = function () {
        return this.vapidDetailsModel;
    };
    // Visible for testing
    // TODO: make protected
    BaseController.prototype.getSubscriptionManager = function () {
        return this.subscriptionManager;
    };
    return BaseController;
}());
/**
 * Checks if the tokenDetails match the details provided in the clients.
 */
function isTokenStillValid(pushSubscription, publicVapidKey, tokenDetails) {
    if (!tokenDetails.vapidKey ||
        !isArrayBufferEqual(publicVapidKey.buffer, tokenDetails.vapidKey.buffer)) {
        return false;
    }
    var isEndpointEqual = pushSubscription.endpoint === tokenDetails.endpoint;
    var isAuthEqual = isArrayBufferEqual(pushSubscription.getKey('auth'), tokenDetails.auth);
    var isP256dhEqual = isArrayBufferEqual(pushSubscription.getKey('p256dh'), tokenDetails.p256dh);
    return isEndpointEqual && isAuthEqual && isP256dhEqual;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var FCM_MSG = 'FCM_MSG';
var SwController = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_1_tslib__["__extends"](SwController, _super);
    function SwController(app) {
        var _this = _super.call(this, app) || this;
        _this.bgMessageHandler = null;
        self.addEventListener('push', function (e) {
            _this.onPush(e);
        });
        self.addEventListener('pushsubscriptionchange', function (e) {
            _this.onSubChange(e);
        });
        self.addEventListener('notificationclick', function (e) {
            _this.onNotificationClick(e);
        });
        return _this;
    }
    // Visible for testing
    // TODO: Make private
    SwController.prototype.onPush = function (event) {
        event.waitUntil(this.onPush_(event));
    };
    // Visible for testing
    // TODO: Make private
    SwController.prototype.onSubChange = function (event) {
        event.waitUntil(this.onSubChange_(event));
    };
    // Visible for testing
    // TODO: Make private
    SwController.prototype.onNotificationClick = function (event) {
        event.waitUntil(this.onNotificationClick_(event));
    };
    /**
     * A handler for push events that shows notifications based on the content of
     * the payload.
     *
     * The payload must be a JSON-encoded Object with a `notification` key. The
     * value of the `notification` property will be used as the NotificationOptions
     * object passed to showNotification. Additionally, the `title` property of the
     * notification object will be used as the title.
     *
     * If there is no notification data in the payload then no notification will be
     * shown.
     */
    SwController.prototype.onPush_ = function (event) {
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
            var msgPayload, hasVisibleClients, notificationDetails, notificationTitle, reg, actions, maxActions;
            return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!event.data) {
                            return [2 /*return*/];
                        }
                        try {
                            msgPayload = event.data.json();
                        }
                        catch (err) {
                            // Not JSON so not an FCM message
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.hasVisibleClients_()];
                    case 1:
                        hasVisibleClients = _a.sent();
                        if (hasVisibleClients) {
                            // App in foreground. Send to page.
                            return [2 /*return*/, this.sendMessageToWindowClients_(msgPayload)];
                        }
                        notificationDetails = this.getNotificationData_(msgPayload);
                        if (!notificationDetails) return [3 /*break*/, 3];
                        notificationTitle = notificationDetails.title || '';
                        return [4 /*yield*/, this.getSWRegistration_()];
                    case 2:
                        reg = _a.sent();
                        actions = notificationDetails.actions;
                        maxActions = Notification.maxActions;
                        if (actions && maxActions && actions.length > maxActions) {
                            console.warn("This browser only supports " + maxActions + " actions." +
                                "The remaining actions will not be displayed.");
                        }
                        return [2 /*return*/, reg.showNotification(notificationTitle, notificationDetails)];
                    case 3:
                        if (!this.bgMessageHandler) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.bgMessageHandler(msgPayload)];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    SwController.prototype.onSubChange_ = function (_event) {
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
            var registration, err_1, err_2, tokenDetailsModel, tokenDetails;
            return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.getSWRegistration_()];
                    case 1:
                        registration = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        throw errorFactory.create("unable-to-resubscribe" /* UNABLE_TO_RESUBSCRIBE */, {
                            errorInfo: err_1
                        });
                    case 3:
                        _a.trys.push([3, 5, , 8]);
                        return [4 /*yield*/, registration.pushManager.getSubscription()];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 5:
                        err_2 = _a.sent();
                        tokenDetailsModel = this.getTokenDetailsModel();
                        return [4 /*yield*/, tokenDetailsModel.getTokenDetailsFromSWScope(registration.scope)];
                    case 6:
                        tokenDetails = _a.sent();
                        if (!tokenDetails) {
                            // This should rarely occure, but could if indexedDB
                            // is corrupted or wiped
                            throw err_2;
                        }
                        // Attempt to delete the token if we know it's bad
                        return [4 /*yield*/, this.deleteToken(tokenDetails.fcmToken)];
                    case 7:
                        // Attempt to delete the token if we know it's bad
                        _a.sent();
                        throw err_2;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    SwController.prototype.onNotificationClick_ = function (event) {
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
            var msgPayload, link, windowClient, internalMsg;
            return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!event.notification ||
                            !event.notification.data ||
                            !event.notification.data[FCM_MSG]) {
                            // Not an FCM notification, do nothing.
                            return [2 /*return*/];
                        }
                        else if (event.action) {
                            // User clicked on an action button.
                            // This will allow devs to act on action button clicks by using a custom
                            // onNotificationClick listener that they define.
                            return [2 /*return*/];
                        }
                        // Prevent other listeners from receiving the event
                        event.stopImmediatePropagation();
                        event.notification.close();
                        msgPayload = event.notification.data[FCM_MSG];
                        if (!msgPayload.notification) {
                            // Nothing to do.
                            return [2 /*return*/];
                        }
                        link = (msgPayload.fcmOptions && msgPayload.fcmOptions.link) ||
                            msgPayload.notification.click_action;
                        if (!link) {
                            if (msgPayload.data && FN_CAMPAIGN_ID in msgPayload.data) {
                                link = self.location.origin;
                            }
                            else {
                                // Nothing to do.
                                return [2 /*return*/];
                            }
                        }
                        return [4 /*yield*/, this.getWindowClient_(link)];
                    case 1:
                        windowClient = _a.sent();
                        if (!!windowClient) return [3 /*break*/, 4];
                        return [4 /*yield*/, self.clients.openWindow(link)];
                    case 2:
                        // Unable to find window client so need to open one.
                        windowClient = _a.sent();
                        // Wait three seconds for the client to initialize and set up the message
                        // handler so that it can receive the message.
                        return [4 /*yield*/, sleep(3000)];
                    case 3:
                        // Wait three seconds for the client to initialize and set up the message
                        // handler so that it can receive the message.
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, windowClient.focus()];
                    case 5:
                        windowClient = _a.sent();
                        _a.label = 6;
                    case 6:
                        if (!windowClient) {
                            // Window Client will not be returned if it's for a third party origin.
                            return [2 /*return*/];
                        }
                        // Delete notification and fcmOptions data from payload before sending to
                        // the page.
                        delete msgPayload.notification;
                        delete msgPayload.fcmOptions;
                        internalMsg = createNewMsg(MessageType.NOTIFICATION_CLICKED, msgPayload);
                        // Attempt to send a message to the client to handle the data
                        // Is affected by: https://github.com/slightlyoff/ServiceWorker/issues/728
                        return [2 /*return*/, this.attemptToMessageClient_(windowClient, internalMsg)];
                }
            });
        });
    };
    // Visible for testing
    // TODO: Make private
    SwController.prototype.getNotificationData_ = function (msgPayload) {
        var _a;
        if (!msgPayload) {
            return;
        }
        if (typeof msgPayload.notification !== 'object') {
            return;
        }
        var notificationInformation = __WEBPACK_IMPORTED_MODULE_1_tslib__["__assign"]({}, msgPayload.notification);
        // Put the message payload under FCM_MSG name so we can identify the
        // notification as being an FCM notification vs a notification from
        // somewhere else (i.e. normal web push or developer generated
        // notification).
        notificationInformation.data = __WEBPACK_IMPORTED_MODULE_1_tslib__["__assign"](__WEBPACK_IMPORTED_MODULE_1_tslib__["__assign"]({}, msgPayload.notification.data), (_a = {}, _a[FCM_MSG] = msgPayload, _a));
        return notificationInformation;
    };
    /**
     * Calling setBackgroundMessageHandler will opt in to some specific
     * behaviours.
     * 1.) If a notification doesn't need to be shown due to a window already
     * being visible, then push messages will be sent to the page.
     * 2.) If a notification needs to be shown, and the message contains no
     * notification data this method will be called
     * and the promise it returns will be passed to event.waitUntil.
     * If you do not set this callback then all push messages will let and the
     * developer can handle them in a their own 'push' event callback
     *
     * @param callback The callback to be called when a push message is received
     * and a notification must be shown. The callback will be given the data from
     * the push message.
     */
    SwController.prototype.setBackgroundMessageHandler = function (callback) {
        if (!callback || typeof callback !== 'function') {
            throw errorFactory.create("bg-handler-function-expected" /* BG_HANDLER_FUNCTION_EXPECTED */);
        }
        this.bgMessageHandler = callback;
    };
    /**
     * @param url The URL to look for when focusing a client.
     * @return Returns an existing window client or a newly opened WindowClient.
     */
    // Visible for testing
    // TODO: Make private
    SwController.prototype.getWindowClient_ = function (url) {
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
            var parsedURL, clientList, suitableClient, i, parsedClientUrl;
            return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        parsedURL = new URL(url, self.location.href).href;
                        return [4 /*yield*/, getClientList()];
                    case 1:
                        clientList = _a.sent();
                        suitableClient = null;
                        for (i = 0; i < clientList.length; i++) {
                            parsedClientUrl = new URL(clientList[i].url, self.location.href)
                                .href;
                            if (parsedClientUrl === parsedURL) {
                                suitableClient = clientList[i];
                                break;
                            }
                        }
                        return [2 /*return*/, suitableClient];
                }
            });
        });
    };
    /**
     * This message will attempt to send the message to a window client.
     * @param client The WindowClient to send the message to.
     * @param message The message to send to the client.
     * @returns Returns a promise that resolves after sending the message. This
     * does not guarantee that the message was successfully received.
     */
    // Visible for testing
    // TODO: Make private
    SwController.prototype.attemptToMessageClient_ = function (client, message) {
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
            return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
                // NOTE: This returns a promise in case this API is abstracted later on to
                // do additional work
                if (!client) {
                    throw errorFactory.create("no-window-client-to-msg" /* NO_WINDOW_CLIENT_TO_MSG */);
                }
                client.postMessage(message);
                return [2 /*return*/];
            });
        });
    };
    /**
     * @returns If there is currently a visible WindowClient, this method will
     * resolve to true, otherwise false.
     */
    // Visible for testing
    // TODO: Make private
    SwController.prototype.hasVisibleClients_ = function () {
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
            var clientList;
            return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getClientList()];
                    case 1:
                        clientList = _a.sent();
                        return [2 /*return*/, clientList.some(function (client) {
                                return client.visibilityState === 'visible' &&
                                    // Ignore chrome-extension clients as that matches the background pages
                                    // of extensions, which are always considered visible.
                                    !client.url.startsWith('chrome-extension://');
                            })];
                }
            });
        });
    };
    /**
     * @param msgPayload The data from the push event that should be sent to all
     * available pages.
     * @returns Returns a promise that resolves once the message has been sent to
     * all WindowClients.
     */
    // Visible for testing
    // TODO: Make private
    SwController.prototype.sendMessageToWindowClients_ = function (msgPayload) {
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
            var clientList, internalMsg;
            var _this = this;
            return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getClientList()];
                    case 1:
                        clientList = _a.sent();
                        internalMsg = createNewMsg(MessageType.PUSH_MSG_RECEIVED, msgPayload);
                        return [4 /*yield*/, Promise.all(clientList.map(function (client) {
                                return _this.attemptToMessageClient_(client, internalMsg);
                            }))];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * This will register the default service worker and return the registration.
     * @return he service worker registration to be used for the push service.
     */
    SwController.prototype.getSWRegistration_ = function () {
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
            return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
                return [2 /*return*/, self.registration];
            });
        });
    };
    /**
     * This will return the default VAPID key or the uint8array version of the
     * public VAPID key provided by the developer.
     */
    SwController.prototype.getPublicVapidKey_ = function () {
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
            var swReg, vapidKeyFromDatabase;
            return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSWRegistration_()];
                    case 1:
                        swReg = _a.sent();
                        if (!swReg) {
                            throw errorFactory.create("sw-registration-expected" /* SW_REGISTRATION_EXPECTED */);
                        }
                        return [4 /*yield*/, this.getVapidDetailsModel().getVapidFromSWScope(swReg.scope)];
                    case 2:
                        vapidKeyFromDatabase = _a.sent();
                        if (vapidKeyFromDatabase == null) {
                            return [2 /*return*/, DEFAULT_PUBLIC_VAPID_KEY];
                        }
                        return [2 /*return*/, vapidKeyFromDatabase];
                }
            });
        });
    };
    return SwController;
}(BaseController));
function getClientList() {
    return self.clients.matchAll({
        type: 'window',
        includeUncontrolled: true
        // TS doesn't know that "type: 'window'" means it'll return WindowClient[]
    });
}
function createNewMsg(msgType, msgData) {
    return {
        firebaseMessagingType: msgType,
        firebaseMessagingData: msgData
    };
}
function sleep(ms) {
    return new Promise(function (resolve) {
        setTimeout(resolve, ms);
    });
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DEFAULT_SW_PATH = '/firebase-messaging-sw.js';
var DEFAULT_SW_SCOPE = '/firebase-cloud-messaging-push-scope';

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var WindowController = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_1_tslib__["__extends"](WindowController, _super);
    /**
     * A service that provides a MessagingService instance.
     */
    function WindowController(app) {
        var _this = _super.call(this, app) || this;
        _this.registrationToUse = null;
        _this.publicVapidKeyToUse = null;
        _this.messageObserver = null;
        // @ts-ignore: Unused variable error, this is not implemented yet.
        _this.tokenRefreshObserver = null;
        _this.onMessageInternal = __WEBPACK_IMPORTED_MODULE_2__firebase_util__["createSubscribe"](function (observer) {
            _this.messageObserver = observer;
        });
        _this.onTokenRefreshInternal = __WEBPACK_IMPORTED_MODULE_2__firebase_util__["createSubscribe"](function (observer) {
            _this.tokenRefreshObserver = observer;
        });
        _this.setupSWMessageListener_();
        return _this;
    }
    /**
     * Request permission if it is not currently granted
     *
     * @return Resolves if the permission was granted, otherwise rejects
     *
     * @deprecated Use Notification.requestPermission() instead.
     * https://developer.mozilla.org/en-US/docs/Web/API/Notification/requestPermission
     */
    WindowController.prototype.requestPermission = function () {
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
            var permissionResult;
            return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.getNotificationPermission_() === 'granted') {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, Notification.requestPermission()];
                    case 1:
                        permissionResult = _a.sent();
                        if (permissionResult === 'granted') {
                            return [2 /*return*/];
                        }
                        else if (permissionResult === 'denied') {
                            throw errorFactory.create("permission-blocked" /* PERMISSION_BLOCKED */);
                        }
                        else {
                            throw errorFactory.create("permission-default" /* PERMISSION_DEFAULT */);
                        }
                }
            });
        });
    };
    /**
     * This method allows a developer to override the default service worker and
     * instead use a custom service worker.
     *
     * @param registration The service worker registration that should be used to
     * receive the push messages.
     */
    WindowController.prototype.useServiceWorker = function (registration) {
        if (!(registration instanceof ServiceWorkerRegistration)) {
            throw errorFactory.create("sw-registration-expected" /* SW_REGISTRATION_EXPECTED */);
        }
        if (this.registrationToUse != null) {
            throw errorFactory.create("use-sw-before-get-token" /* USE_SW_BEFORE_GET_TOKEN */);
        }
        this.registrationToUse = registration;
    };
    /**
     * This method allows a developer to override the default vapid key
     * and instead use a custom VAPID public key.
     *
     * @param publicKey A URL safe base64 encoded string.
     */
    WindowController.prototype.usePublicVapidKey = function (publicKey) {
        if (typeof publicKey !== 'string') {
            throw errorFactory.create("invalid-public-vapid-key" /* INVALID_PUBLIC_VAPID_KEY */);
        }
        if (this.publicVapidKeyToUse != null) {
            throw errorFactory.create("use-public-key-before-get-token" /* USE_PUBLIC_KEY_BEFORE_GET_TOKEN */);
        }
        var parsedKey = base64ToArrayBuffer(publicKey);
        if (parsedKey.length !== 65) {
            throw errorFactory.create("public-vapid-key-decryption-failed" /* PUBLIC_KEY_DECRYPTION_FAILED */);
        }
        this.publicVapidKeyToUse = parsedKey;
    };
    /**
     * @export
     * @param nextOrObserver An observer object or a function triggered on
     * message.
     * @param error A function triggered on message error.
     * @param completed function triggered when the observer is removed.
     * @return The unsubscribe function for the observer.
     */
    WindowController.prototype.onMessage = function (nextOrObserver, error, completed) {
        if (typeof nextOrObserver === 'function') {
            return this.onMessageInternal(nextOrObserver, error, completed);
        }
        else {
            return this.onMessageInternal(nextOrObserver);
        }
    };
    /**
     * @param nextOrObserver An observer object or a function triggered on token
     * refresh.
     * @param error A function triggered on token refresh error.
     * @param completed function triggered when the observer is removed.
     * @return The unsubscribe function for the observer.
     */
    WindowController.prototype.onTokenRefresh = function (nextOrObserver, error, completed) {
        if (typeof nextOrObserver === 'function') {
            return this.onTokenRefreshInternal(nextOrObserver, error, completed);
        }
        else {
            return this.onTokenRefreshInternal(nextOrObserver);
        }
    };
    /**
     * Given a registration, wait for the service worker it relates to
     * become activer
     * @param registration Registration to wait for service worker to become active
     * @return Wait for service worker registration to become active
     */
    // Visible for testing
    // TODO: Make private
    WindowController.prototype.waitForRegistrationToActivate_ = function (registration) {
        var serviceWorker = registration.installing || registration.waiting || registration.active;
        return new Promise(function (resolve, reject) {
            if (!serviceWorker) {
                // This is a rare scenario but has occured in firefox
                reject(errorFactory.create("no-sw-in-reg" /* NO_SW_IN_REG */));
                return;
            }
            // Because the Promise function is called on next tick there is a
            // small chance that the worker became active or redundant already.
            if (serviceWorker.state === 'activated') {
                resolve(registration);
                return;
            }
            if (serviceWorker.state === 'redundant') {
                reject(errorFactory.create("sw-reg-redundant" /* SW_REG_REDUNDANT */));
                return;
            }
            var stateChangeListener = function () {
                if (serviceWorker.state === 'activated') {
                    resolve(registration);
                }
                else if (serviceWorker.state === 'redundant') {
                    reject(errorFactory.create("sw-reg-redundant" /* SW_REG_REDUNDANT */));
                }
                else {
                    // Return early and wait to next state change
                    return;
                }
                serviceWorker.removeEventListener('statechange', stateChangeListener);
            };
            serviceWorker.addEventListener('statechange', stateChangeListener);
        });
    };
    /**
     * This will register the default service worker and return the registration
     * @return The service worker registration to be used for the push service.
     */
    WindowController.prototype.getSWRegistration_ = function () {
        var _this = this;
        if (this.registrationToUse) {
            return this.waitForRegistrationToActivate_(this.registrationToUse);
        }
        // Make the registration null so we know useServiceWorker will not
        // use a new service worker as registrationToUse is no longer undefined
        this.registrationToUse = null;
        return navigator.serviceWorker
            .register(DEFAULT_SW_PATH, {
            scope: DEFAULT_SW_SCOPE
        })
            .catch(function (err) {
            throw errorFactory.create("failed-serviceworker-registration" /* FAILED_DEFAULT_REGISTRATION */, {
                browserErrorMessage: err.message
            });
        })
            .then(function (registration) {
            return _this.waitForRegistrationToActivate_(registration).then(function () {
                _this.registrationToUse = registration;
                // We update after activation due to an issue with Firefox v49 where
                // a race condition occassionally causes the service worker to not
                // install
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                registration.update();
                return registration;
            });
        });
    };
    /**
     * This will return the default VAPID key or the uint8array version of the
     * public VAPID key provided by the developer.
     */
    WindowController.prototype.getPublicVapidKey_ = function () {
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
            return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_a) {
                if (this.publicVapidKeyToUse) {
                    return [2 /*return*/, this.publicVapidKeyToUse];
                }
                return [2 /*return*/, DEFAULT_PUBLIC_VAPID_KEY];
            });
        });
    };
    /**
     * This method will set up a message listener to handle
     * events from the service worker that should trigger
     * events in the page.
     */
    // Visible for testing
    // TODO: Make private
    WindowController.prototype.setupSWMessageListener_ = function () {
        var _this = this;
        navigator.serviceWorker.addEventListener('message', function (event) {
            if (!event.data ||
                !event.data.firebaseMessagingType ||
                !event.data.firebaseMessagingData) {
                // Not a message from FCM
                return;
            }
            var _a = event.data, firebaseMessagingType = _a.firebaseMessagingType, firebaseMessagingData = _a.firebaseMessagingData;
            if (_this.messageObserver) {
                _this.messageObserver.next(firebaseMessagingData);
            }
            var data = firebaseMessagingData.data;
            if (data &&
                FN_CAMPAIGN_ID in data &&
                data[FN_CAMPAIGN_ANALYTICS_ENABLED] === '1') {
                // This message has a campaign id, meaning it was sent using the FN Console.
                // Analytics is enabled on this message, so we should log it.
                var eventType = getEventType(firebaseMessagingType);
                _this.app.INTERNAL.analytics.logEvent(eventType, 
                /* eslint-disable camelcase */
                {
                    message_name: data[FN_CAMPAIGN_NAME],
                    message_id: data[FN_CAMPAIGN_ID],
                    message_time: data[FN_CAMPAIGN_TIME],
                    message_device_time: Math.floor(Date.now() / 1000)
                }
                /* eslint-enable camelcase */
                );
            }
        }, false);
    };
    return WindowController;
}(BaseController));
function getEventType(messageType) {
    switch (messageType) {
        case MessageType.NOTIFICATION_CLICKED:
            return 'notification_open';
        case MessageType.PUSH_MSG_RECEIVED:
            return 'notification_foreground';
        default:
            throw new Error();
    }
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function registerMessaging(instance) {
    var messagingName = 'messaging';
    var factoryMethod = function (app) {
        if (!isSupported()) {
            throw errorFactory.create("unsupported-browser" /* UNSUPPORTED_BROWSER */);
        }
        if (self && 'ServiceWorkerGlobalScope' in self) {
            // Running in ServiceWorker context
            return new SwController(app);
        }
        else {
            // Assume we are in the window context.
            return new WindowController(app);
        }
    };
    var namespaceExports = {
        isSupported: isSupported
    };
    instance.INTERNAL.registerService(messagingName, factoryMethod, namespaceExports);
}
registerMessaging(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a);
function isSupported() {
    if (self && 'ServiceWorkerGlobalScope' in self) {
        // Running in ServiceWorker context
        return isSWControllerSupported();
    }
    else {
        // Assume we are in the window context.
        return isWindowControllerSupported();
    }
}
/**
 * Checks to see if the required APIs exist.
 */
function isWindowControllerSupported() {
    return (navigator.cookieEnabled &&
        'serviceWorker' in navigator &&
        'PushManager' in window &&
        'Notification' in window &&
        'fetch' in window &&
        ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') &&
        PushSubscription.prototype.hasOwnProperty('getKey'));
}
/**
 * Checks to see if the required APIs exist within SW Context.
 */
function isSWControllerSupported() {
    return ('PushManager' in self &&
        'Notification' in self &&
        ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') &&
        PushSubscription.prototype.hasOwnProperty('getKey'));
}


//# sourceMappingURL=index.esm.js.map


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = global || self, factory(global.idb = {}));
}(this, function (exports) { 'use strict';

  function toArray(arr) {
    return Array.prototype.slice.call(arr);
  }

  function promisifyRequest(request) {
    return new Promise(function(resolve, reject) {
      request.onsuccess = function() {
        resolve(request.result);
      };

      request.onerror = function() {
        reject(request.error);
      };
    });
  }

  function promisifyRequestCall(obj, method, args) {
    var request;
    var p = new Promise(function(resolve, reject) {
      request = obj[method].apply(obj, args);
      promisifyRequest(request).then(resolve, reject);
    });

    p.request = request;
    return p;
  }

  function promisifyCursorRequestCall(obj, method, args) {
    var p = promisifyRequestCall(obj, method, args);
    return p.then(function(value) {
      if (!value) return;
      return new Cursor(value, p.request);
    });
  }

  function proxyProperties(ProxyClass, targetProp, properties) {
    properties.forEach(function(prop) {
      Object.defineProperty(ProxyClass.prototype, prop, {
        get: function() {
          return this[targetProp][prop];
        },
        set: function(val) {
          this[targetProp][prop] = val;
        }
      });
    });
  }

  function proxyRequestMethods(ProxyClass, targetProp, Constructor, properties) {
    properties.forEach(function(prop) {
      if (!(prop in Constructor.prototype)) return;
      ProxyClass.prototype[prop] = function() {
        return promisifyRequestCall(this[targetProp], prop, arguments);
      };
    });
  }

  function proxyMethods(ProxyClass, targetProp, Constructor, properties) {
    properties.forEach(function(prop) {
      if (!(prop in Constructor.prototype)) return;
      ProxyClass.prototype[prop] = function() {
        return this[targetProp][prop].apply(this[targetProp], arguments);
      };
    });
  }

  function proxyCursorRequestMethods(ProxyClass, targetProp, Constructor, properties) {
    properties.forEach(function(prop) {
      if (!(prop in Constructor.prototype)) return;
      ProxyClass.prototype[prop] = function() {
        return promisifyCursorRequestCall(this[targetProp], prop, arguments);
      };
    });
  }

  function Index(index) {
    this._index = index;
  }

  proxyProperties(Index, '_index', [
    'name',
    'keyPath',
    'multiEntry',
    'unique'
  ]);

  proxyRequestMethods(Index, '_index', IDBIndex, [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
  ]);

  proxyCursorRequestMethods(Index, '_index', IDBIndex, [
    'openCursor',
    'openKeyCursor'
  ]);

  function Cursor(cursor, request) {
    this._cursor = cursor;
    this._request = request;
  }

  proxyProperties(Cursor, '_cursor', [
    'direction',
    'key',
    'primaryKey',
    'value'
  ]);

  proxyRequestMethods(Cursor, '_cursor', IDBCursor, [
    'update',
    'delete'
  ]);

  // proxy 'next' methods
  ['advance', 'continue', 'continuePrimaryKey'].forEach(function(methodName) {
    if (!(methodName in IDBCursor.prototype)) return;
    Cursor.prototype[methodName] = function() {
      var cursor = this;
      var args = arguments;
      return Promise.resolve().then(function() {
        cursor._cursor[methodName].apply(cursor._cursor, args);
        return promisifyRequest(cursor._request).then(function(value) {
          if (!value) return;
          return new Cursor(value, cursor._request);
        });
      });
    };
  });

  function ObjectStore(store) {
    this._store = store;
  }

  ObjectStore.prototype.createIndex = function() {
    return new Index(this._store.createIndex.apply(this._store, arguments));
  };

  ObjectStore.prototype.index = function() {
    return new Index(this._store.index.apply(this._store, arguments));
  };

  proxyProperties(ObjectStore, '_store', [
    'name',
    'keyPath',
    'indexNames',
    'autoIncrement'
  ]);

  proxyRequestMethods(ObjectStore, '_store', IDBObjectStore, [
    'put',
    'add',
    'delete',
    'clear',
    'get',
    'getAll',
    'getKey',
    'getAllKeys',
    'count'
  ]);

  proxyCursorRequestMethods(ObjectStore, '_store', IDBObjectStore, [
    'openCursor',
    'openKeyCursor'
  ]);

  proxyMethods(ObjectStore, '_store', IDBObjectStore, [
    'deleteIndex'
  ]);

  function Transaction(idbTransaction) {
    this._tx = idbTransaction;
    this.complete = new Promise(function(resolve, reject) {
      idbTransaction.oncomplete = function() {
        resolve();
      };
      idbTransaction.onerror = function() {
        reject(idbTransaction.error);
      };
      idbTransaction.onabort = function() {
        reject(idbTransaction.error);
      };
    });
  }

  Transaction.prototype.objectStore = function() {
    return new ObjectStore(this._tx.objectStore.apply(this._tx, arguments));
  };

  proxyProperties(Transaction, '_tx', [
    'objectStoreNames',
    'mode'
  ]);

  proxyMethods(Transaction, '_tx', IDBTransaction, [
    'abort'
  ]);

  function UpgradeDB(db, oldVersion, transaction) {
    this._db = db;
    this.oldVersion = oldVersion;
    this.transaction = new Transaction(transaction);
  }

  UpgradeDB.prototype.createObjectStore = function() {
    return new ObjectStore(this._db.createObjectStore.apply(this._db, arguments));
  };

  proxyProperties(UpgradeDB, '_db', [
    'name',
    'version',
    'objectStoreNames'
  ]);

  proxyMethods(UpgradeDB, '_db', IDBDatabase, [
    'deleteObjectStore',
    'close'
  ]);

  function DB(db) {
    this._db = db;
  }

  DB.prototype.transaction = function() {
    return new Transaction(this._db.transaction.apply(this._db, arguments));
  };

  proxyProperties(DB, '_db', [
    'name',
    'version',
    'objectStoreNames'
  ]);

  proxyMethods(DB, '_db', IDBDatabase, [
    'close'
  ]);

  // Add cursor iterators
  // TODO: remove this once browsers do the right thing with promises
  ['openCursor', 'openKeyCursor'].forEach(function(funcName) {
    [ObjectStore, Index].forEach(function(Constructor) {
      // Don't create iterateKeyCursor if openKeyCursor doesn't exist.
      if (!(funcName in Constructor.prototype)) return;

      Constructor.prototype[funcName.replace('open', 'iterate')] = function() {
        var args = toArray(arguments);
        var callback = args[args.length - 1];
        var nativeObject = this._store || this._index;
        var request = nativeObject[funcName].apply(nativeObject, args.slice(0, -1));
        request.onsuccess = function() {
          callback(request.result);
        };
      };
    });
  });

  // polyfill getAll
  [Index, ObjectStore].forEach(function(Constructor) {
    if (Constructor.prototype.getAll) return;
    Constructor.prototype.getAll = function(query, count) {
      var instance = this;
      var items = [];

      return new Promise(function(resolve) {
        instance.iterateCursor(query, function(cursor) {
          if (!cursor) {
            resolve(items);
            return;
          }
          items.push(cursor.value);

          if (count !== undefined && items.length == count) {
            resolve(items);
            return;
          }
          cursor.continue();
        });
      });
    };
  });

  function openDb(name, version, upgradeCallback) {
    var p = promisifyRequestCall(indexedDB, 'open', [name, version]);
    var request = p.request;

    if (request) {
      request.onupgradeneeded = function(event) {
        if (upgradeCallback) {
          upgradeCallback(new UpgradeDB(request.result, event.oldVersion, request.transaction));
        }
      };
    }

    return p.then(function(db) {
      return new DB(db);
    });
  }

  function deleteDb(name) {
    return promisifyRequestCall(indexedDB, 'deleteDatabase', [name]);
  }

  exports.openDb = openDb;
  exports.deleteDb = deleteDb;

  Object.defineProperty(exports, '__esModule', { value: true });

}));


/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerStorage", function() { return registerStorage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tslib__ = __webpack_require__(51);



/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Constants used in the Firebase Storage library.
 */
/**
 * Domain name for firebase storage.
 */
var DEFAULT_HOST = 'firebasestorage.googleapis.com';
/**
 * The key in Firebase config json for the storage bucket.
 */
var CONFIG_STORAGE_BUCKET_KEY = 'storageBucket';
/**
 * 2 minutes
 *
 * The timeout for all operations except upload.
 */
var DEFAULT_MAX_OPERATION_RETRY_TIME = 2 * 60 * 1000;
/**
 * 10 minutes
 *
 * The timeout for upload.
 */
var DEFAULT_MAX_UPLOAD_RETRY_TIME = 10 * 60 * 1000;
/**
 * This is the value of Number.MIN_SAFE_INTEGER, which is not well supported
 * enough for us to use it directly.
 */
var MIN_SAFE_INTEGER = -9007199254740991;

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var FirebaseStorageError = /** @class */ (function () {
    function FirebaseStorageError(code, message) {
        this.code_ = prependCode(code);
        this.message_ = 'Firebase Storage: ' + message;
        this.serverResponse_ = null;
        this.name_ = 'FirebaseError';
    }
    FirebaseStorageError.prototype.codeProp = function () {
        return this.code;
    };
    FirebaseStorageError.prototype.codeEquals = function (code) {
        return prependCode(code) === this.codeProp();
    };
    FirebaseStorageError.prototype.serverResponseProp = function () {
        return this.serverResponse_;
    };
    FirebaseStorageError.prototype.setServerResponseProp = function (serverResponse) {
        this.serverResponse_ = serverResponse;
    };
    Object.defineProperty(FirebaseStorageError.prototype, "name", {
        get: function () {
            return this.name_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseStorageError.prototype, "code", {
        get: function () {
            return this.code_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseStorageError.prototype, "message", {
        get: function () {
            return this.message_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseStorageError.prototype, "serverResponse", {
        get: function () {
            return this.serverResponse_;
        },
        enumerable: true,
        configurable: true
    });
    return FirebaseStorageError;
}());
var Code = {
    // Shared between all platforms
    UNKNOWN: 'unknown',
    OBJECT_NOT_FOUND: 'object-not-found',
    BUCKET_NOT_FOUND: 'bucket-not-found',
    PROJECT_NOT_FOUND: 'project-not-found',
    QUOTA_EXCEEDED: 'quota-exceeded',
    UNAUTHENTICATED: 'unauthenticated',
    UNAUTHORIZED: 'unauthorized',
    RETRY_LIMIT_EXCEEDED: 'retry-limit-exceeded',
    INVALID_CHECKSUM: 'invalid-checksum',
    CANCELED: 'canceled',
    // JS specific
    INVALID_EVENT_NAME: 'invalid-event-name',
    INVALID_URL: 'invalid-url',
    INVALID_DEFAULT_BUCKET: 'invalid-default-bucket',
    NO_DEFAULT_BUCKET: 'no-default-bucket',
    CANNOT_SLICE_BLOB: 'cannot-slice-blob',
    SERVER_FILE_WRONG_SIZE: 'server-file-wrong-size',
    NO_DOWNLOAD_URL: 'no-download-url',
    INVALID_ARGUMENT: 'invalid-argument',
    INVALID_ARGUMENT_COUNT: 'invalid-argument-count',
    APP_DELETED: 'app-deleted',
    INVALID_ROOT_OPERATION: 'invalid-root-operation',
    INVALID_FORMAT: 'invalid-format',
    INTERNAL_ERROR: 'internal-error'
};
function prependCode(code) {
    return 'storage/' + code;
}
function unknown() {
    var message = 'An unknown error occurred, please check the error payload for ' +
        'server response.';
    return new FirebaseStorageError(Code.UNKNOWN, message);
}
function objectNotFound(path) {
    return new FirebaseStorageError(Code.OBJECT_NOT_FOUND, "Object '" + path + "' does not exist.");
}
function quotaExceeded(bucket) {
    return new FirebaseStorageError(Code.QUOTA_EXCEEDED, "Quota for bucket '" +
        bucket +
        "' exceeded, please view quota on " +
        'https://firebase.google.com/pricing/.');
}
function unauthenticated() {
    var message = 'User is not authenticated, please authenticate using Firebase ' +
        'Authentication and try again.';
    return new FirebaseStorageError(Code.UNAUTHENTICATED, message);
}
function unauthorized(path) {
    return new FirebaseStorageError(Code.UNAUTHORIZED, "User does not have permission to access '" + path + "'.");
}
function retryLimitExceeded() {
    return new FirebaseStorageError(Code.RETRY_LIMIT_EXCEEDED, 'Max retry time for operation exceeded, please try again.');
}
function canceled() {
    return new FirebaseStorageError(Code.CANCELED, 'User canceled the upload/download.');
}
function invalidUrl(url) {
    return new FirebaseStorageError(Code.INVALID_URL, "Invalid URL '" + url + "'.");
}
function invalidDefaultBucket(bucket) {
    return new FirebaseStorageError(Code.INVALID_DEFAULT_BUCKET, "Invalid default bucket '" + bucket + "'.");
}
function noDefaultBucket() {
    return new FirebaseStorageError(Code.NO_DEFAULT_BUCKET, 'No default bucket ' +
        "found. Did you set the '" +
        CONFIG_STORAGE_BUCKET_KEY +
        "' property when initializing the app?");
}
function cannotSliceBlob() {
    return new FirebaseStorageError(Code.CANNOT_SLICE_BLOB, 'Cannot slice blob for upload. Please retry the upload.');
}
function serverFileWrongSize() {
    return new FirebaseStorageError(Code.SERVER_FILE_WRONG_SIZE, 'Server recorded incorrect upload file size, please retry the upload.');
}
function noDownloadURL() {
    return new FirebaseStorageError(Code.NO_DOWNLOAD_URL, 'The given file does not have any download URLs.');
}
function invalidArgument(index, fnName, message) {
    return new FirebaseStorageError(Code.INVALID_ARGUMENT, 'Invalid argument in `' + fnName + '` at index ' + index + ': ' + message);
}
function invalidArgumentCount(argMin, argMax, fnName, real) {
    var countPart;
    var plural;
    if (argMin === argMax) {
        countPart = argMin;
        plural = argMin === 1 ? 'argument' : 'arguments';
    }
    else {
        countPart = 'between ' + argMin + ' and ' + argMax;
        plural = 'arguments';
    }
    return new FirebaseStorageError(Code.INVALID_ARGUMENT_COUNT, 'Invalid argument count in `' +
        fnName +
        '`: Expected ' +
        countPart +
        ' ' +
        plural +
        ', received ' +
        real +
        '.');
}
function appDeleted() {
    return new FirebaseStorageError(Code.APP_DELETED, 'The Firebase app was deleted.');
}
/**
 * @param name The name of the operation that was invalid.
 */
function invalidRootOperation(name) {
    return new FirebaseStorageError(Code.INVALID_ROOT_OPERATION, "The operation '" +
        name +
        "' cannot be performed on a root reference, create a non-root " +
        "reference using child, such as .child('file.png').");
}
/**
 * @param format The format that was not valid.
 * @param message A message describing the format violation.
 */
function invalidFormat(format, message) {
    return new FirebaseStorageError(Code.INVALID_FORMAT, "String does not match format '" + format + "': " + message);
}
/**
 * @param message A message describing the internal error.
 */
function internalError(message) {
    throw new FirebaseStorageError(Code.INTERNAL_ERROR, 'Internal error: ' + message);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var StringFormat = {
    RAW: 'raw',
    BASE64: 'base64',
    BASE64URL: 'base64url',
    DATA_URL: 'data_url'
};
function formatValidator(stringFormat) {
    switch (stringFormat) {
        case StringFormat.RAW:
        case StringFormat.BASE64:
        case StringFormat.BASE64URL:
        case StringFormat.DATA_URL:
            return;
        default:
            throw 'Expected one of the event types: [' +
                StringFormat.RAW +
                ', ' +
                StringFormat.BASE64 +
                ', ' +
                StringFormat.BASE64URL +
                ', ' +
                StringFormat.DATA_URL +
                '].';
    }
}
/**
 * @struct
 */
var StringData = /** @class */ (function () {
    function StringData(data, contentType) {
        this.data = data;
        this.contentType = contentType || null;
    }
    return StringData;
}());
function dataFromString(format, stringData) {
    switch (format) {
        case StringFormat.RAW:
            return new StringData(utf8Bytes_(stringData));
        case StringFormat.BASE64:
        case StringFormat.BASE64URL:
            return new StringData(base64Bytes_(format, stringData));
        case StringFormat.DATA_URL:
            return new StringData(dataURLBytes_(stringData), dataURLContentType_(stringData));
        // do nothing
    }
    // assert(false);
    throw unknown();
}
function utf8Bytes_(value) {
    var b = [];
    for (var i = 0; i < value.length; i++) {
        var c = value.charCodeAt(i);
        if (c <= 127) {
            b.push(c);
        }
        else {
            if (c <= 2047) {
                b.push(192 | (c >> 6), 128 | (c & 63));
            }
            else {
                if ((c & 64512) === 55296) {
                    // The start of a surrogate pair.
                    var valid = i < value.length - 1 && (value.charCodeAt(i + 1) & 64512) === 56320;
                    if (!valid) {
                        // The second surrogate wasn't there.
                        b.push(239, 191, 189);
                    }
                    else {
                        var hi = c;
                        var lo = value.charCodeAt(++i);
                        c = 65536 | ((hi & 1023) << 10) | (lo & 1023);
                        b.push(240 | (c >> 18), 128 | ((c >> 12) & 63), 128 | ((c >> 6) & 63), 128 | (c & 63));
                    }
                }
                else {
                    if ((c & 64512) === 56320) {
                        // Invalid low surrogate.
                        b.push(239, 191, 189);
                    }
                    else {
                        b.push(224 | (c >> 12), 128 | ((c >> 6) & 63), 128 | (c & 63));
                    }
                }
            }
        }
    }
    return new Uint8Array(b);
}
function percentEncodedBytes_(value) {
    var decoded;
    try {
        decoded = decodeURIComponent(value);
    }
    catch (e) {
        throw invalidFormat(StringFormat.DATA_URL, 'Malformed data URL.');
    }
    return utf8Bytes_(decoded);
}
function base64Bytes_(format, value) {
    switch (format) {
        case StringFormat.BASE64: {
            var hasMinus = value.indexOf('-') !== -1;
            var hasUnder = value.indexOf('_') !== -1;
            if (hasMinus || hasUnder) {
                var invalidChar = hasMinus ? '-' : '_';
                throw invalidFormat(format, "Invalid character '" +
                    invalidChar +
                    "' found: is it base64url encoded?");
            }
            break;
        }
        case StringFormat.BASE64URL: {
            var hasPlus = value.indexOf('+') !== -1;
            var hasSlash = value.indexOf('/') !== -1;
            if (hasPlus || hasSlash) {
                var invalidChar = hasPlus ? '+' : '/';
                throw invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64 encoded?");
            }
            value = value.replace(/-/g, '+').replace(/_/g, '/');
            break;
        }
        // do nothing
    }
    var bytes;
    try {
        bytes = atob(value);
    }
    catch (e) {
        throw invalidFormat(format, 'Invalid character found');
    }
    var array = new Uint8Array(bytes.length);
    for (var i = 0; i < bytes.length; i++) {
        array[i] = bytes.charCodeAt(i);
    }
    return array;
}
/**
 * @struct
 */
var DataURLParts = /** @class */ (function () {
    function DataURLParts(dataURL) {
        this.base64 = false;
        this.contentType = null;
        var matches = dataURL.match(/^data:([^,]+)?,/);
        if (matches === null) {
            throw invalidFormat(StringFormat.DATA_URL, "Must be formatted 'data:[<mediatype>][;base64],<data>");
        }
        var middle = matches[1] || null;
        if (middle != null) {
            this.base64 = endsWith(middle, ';base64');
            this.contentType = this.base64
                ? middle.substring(0, middle.length - ';base64'.length)
                : middle;
        }
        this.rest = dataURL.substring(dataURL.indexOf(',') + 1);
    }
    return DataURLParts;
}());
function dataURLBytes_(dataUrl) {
    var parts = new DataURLParts(dataUrl);
    if (parts.base64) {
        return base64Bytes_(StringFormat.BASE64, parts.rest);
    }
    else {
        return percentEncodedBytes_(parts.rest);
    }
}
function dataURLContentType_(dataUrl) {
    var parts = new DataURLParts(dataUrl);
    return parts.contentType;
}
function endsWith(s, end) {
    var longEnough = s.length >= end.length;
    if (!longEnough) {
        return false;
    }
    return s.substring(s.length - end.length) === end;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var TaskEvent = {
    /** Triggered whenever the task changes or progress is updated. */
    STATE_CHANGED: 'state_changed'
};
var InternalTaskState = {
    RUNNING: 'running',
    PAUSING: 'pausing',
    PAUSED: 'paused',
    SUCCESS: 'success',
    CANCELING: 'canceling',
    CANCELED: 'canceled',
    ERROR: 'error'
};
var TaskState = {
    /** The task is currently transferring data. */
    RUNNING: 'running',
    /** The task was paused by the user. */
    PAUSED: 'paused',
    /** The task completed successfully. */
    SUCCESS: 'success',
    /** The task was canceled. */
    CANCELED: 'canceled',
    /** The task failed with an error. */
    ERROR: 'error'
};
function taskStateFromInternalTaskState(state) {
    switch (state) {
        case InternalTaskState.RUNNING:
        case InternalTaskState.PAUSING:
        case InternalTaskState.CANCELING:
            return TaskState.RUNNING;
        case InternalTaskState.PAUSED:
            return TaskState.PAUSED;
        case InternalTaskState.SUCCESS:
            return TaskState.SUCCESS;
        case InternalTaskState.CANCELED:
            return TaskState.CANCELED;
        case InternalTaskState.ERROR:
            return TaskState.ERROR;
        default:
            // TODO(andysoto): assert(false);
            return TaskState.ERROR;
    }
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @return False if the object is undefined or null, true otherwise.
 */
function isDef(p) {
    return p != null;
}
function isJustDef(p) {
    return p !== void 0;
}
function isFunction(p) {
    return typeof p === 'function';
}
function isObject(p) {
    return typeof p === 'object';
}
function isNonNullObject(p) {
    return isObject(p) && p !== null;
}
function isNonArrayObject(p) {
    return isObject(p) && !Array.isArray(p);
}
function isString(p) {
    return typeof p === 'string' || p instanceof String;
}
function isInteger(p) {
    return isNumber(p) && Number.isInteger(p);
}
function isNumber(p) {
    return typeof p === 'number' || p instanceof Number;
}
function isNativeBlob(p) {
    return isNativeBlobDefined() && p instanceof Blob;
}
function isNativeBlobDefined() {
    return typeof Blob !== 'undefined';
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @enum{number}
 */
var ErrorCode;
(function (ErrorCode) {
    ErrorCode[ErrorCode["NO_ERROR"] = 0] = "NO_ERROR";
    ErrorCode[ErrorCode["NETWORK_ERROR"] = 1] = "NETWORK_ERROR";
    ErrorCode[ErrorCode["ABORT"] = 2] = "ABORT";
})(ErrorCode || (ErrorCode = {}));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * We use this instead of goog.net.XhrIo because goog.net.XhrIo is hyuuuuge and
 * doesn't work in React Native on Android.
 */
var NetworkXhrIo = /** @class */ (function () {
    function NetworkXhrIo() {
        var _this = this;
        this.sent_ = false;
        this.xhr_ = new XMLHttpRequest();
        this.errorCode_ = ErrorCode.NO_ERROR;
        this.sendPromise_ = new Promise(function (resolve) {
            _this.xhr_.addEventListener('abort', function () {
                _this.errorCode_ = ErrorCode.ABORT;
                resolve(_this);
            });
            _this.xhr_.addEventListener('error', function () {
                _this.errorCode_ = ErrorCode.NETWORK_ERROR;
                resolve(_this);
            });
            _this.xhr_.addEventListener('load', function () {
                resolve(_this);
            });
        });
    }
    /**
     * @override
     */
    NetworkXhrIo.prototype.send = function (url, method, body, headers) {
        if (this.sent_) {
            throw internalError('cannot .send() more than once');
        }
        this.sent_ = true;
        this.xhr_.open(method, url, true);
        if (isDef(headers)) {
            for (var key in headers) {
                if (headers.hasOwnProperty(key)) {
                    this.xhr_.setRequestHeader(key, headers[key].toString());
                }
            }
        }
        if (isDef(body)) {
            this.xhr_.send(body);
        }
        else {
            this.xhr_.send();
        }
        return this.sendPromise_;
    };
    /**
     * @override
     */
    NetworkXhrIo.prototype.getErrorCode = function () {
        if (!this.sent_) {
            throw internalError('cannot .getErrorCode() before sending');
        }
        return this.errorCode_;
    };
    /**
     * @override
     */
    NetworkXhrIo.prototype.getStatus = function () {
        if (!this.sent_) {
            throw internalError('cannot .getStatus() before sending');
        }
        try {
            return this.xhr_.status;
        }
        catch (e) {
            return -1;
        }
    };
    /**
     * @override
     */
    NetworkXhrIo.prototype.getResponseText = function () {
        if (!this.sent_) {
            throw internalError('cannot .getResponseText() before sending');
        }
        return this.xhr_.responseText;
    };
    /**
     * Aborts the request.
     * @override
     */
    NetworkXhrIo.prototype.abort = function () {
        this.xhr_.abort();
    };
    /**
     * @override
     */
    NetworkXhrIo.prototype.getResponseHeader = function (header) {
        return this.xhr_.getResponseHeader(header);
    };
    /**
     * @override
     */
    NetworkXhrIo.prototype.addUploadProgressListener = function (listener) {
        if (isDef(this.xhr_.upload)) {
            this.xhr_.upload.addEventListener('progress', listener);
        }
    };
    /**
     * @override
     */
    NetworkXhrIo.prototype.removeUploadProgressListener = function (listener) {
        if (isDef(this.xhr_.upload)) {
            this.xhr_.upload.removeEventListener('progress', listener);
        }
    };
    return NetworkXhrIo;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Factory-like class for creating XhrIo instances.
 */
var XhrIoPool = /** @class */ (function () {
    function XhrIoPool() {
    }
    XhrIoPool.prototype.createXhrIo = function () {
        return new NetworkXhrIo();
    };
    return XhrIoPool;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getBlobBuilder() {
    if (typeof BlobBuilder !== 'undefined') {
        return BlobBuilder;
    }
    else if (typeof WebKitBlobBuilder !== 'undefined') {
        return WebKitBlobBuilder;
    }
    else {
        return undefined;
    }
}
/**
 * Concatenates one or more values together and converts them to a Blob.
 *
 * @param args The values that will make up the resulting blob.
 * @return The blob.
 */
function getBlob() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var BlobBuilder = getBlobBuilder();
    if (BlobBuilder !== undefined) {
        var bb = new BlobBuilder();
        for (var i = 0; i < args.length; i++) {
            bb.append(args[i]);
        }
        return bb.getBlob();
    }
    else {
        if (isNativeBlobDefined()) {
            return new Blob(args);
        }
        else {
            throw Error("This browser doesn't seem to support creating Blobs");
        }
    }
}
/**
 * Slices the blob. The returned blob contains data from the start byte
 * (inclusive) till the end byte (exclusive). Negative indices cannot be used.
 *
 * @param blob The blob to be sliced.
 * @param start Index of the starting byte.
 * @param end Index of the ending byte.
 * @return The blob slice or null if not supported.
 */
function sliceBlob(blob, start, end) {
    if (blob.webkitSlice) {
        return blob.webkitSlice(start, end);
    }
    else if (blob.mozSlice) {
        return blob.mozSlice(start, end);
    }
    else if (blob.slice) {
        return blob.slice(start, end);
    }
    return null;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param opt_elideCopy If true, doesn't copy mutable input data
 *     (e.g. Uint8Arrays). Pass true only if you know the objects will not be
 *     modified after this blob's construction.
 */
var FbsBlob = /** @class */ (function () {
    function FbsBlob(data, elideCopy) {
        var size = 0;
        var blobType = '';
        if (isNativeBlob(data)) {
            this.data_ = data;
            size = data.size;
            blobType = data.type;
        }
        else if (data instanceof ArrayBuffer) {
            if (elideCopy) {
                this.data_ = new Uint8Array(data);
            }
            else {
                this.data_ = new Uint8Array(data.byteLength);
                this.data_.set(new Uint8Array(data));
            }
            size = this.data_.length;
        }
        else if (data instanceof Uint8Array) {
            if (elideCopy) {
                this.data_ = data;
            }
            else {
                this.data_ = new Uint8Array(data.length);
                this.data_.set(data);
            }
            size = data.length;
        }
        this.size_ = size;
        this.type_ = blobType;
    }
    FbsBlob.prototype.size = function () {
        return this.size_;
    };
    FbsBlob.prototype.type = function () {
        return this.type_;
    };
    FbsBlob.prototype.slice = function (startByte, endByte) {
        if (isNativeBlob(this.data_)) {
            var realBlob = this.data_;
            var sliced = sliceBlob(realBlob, startByte, endByte);
            if (sliced === null) {
                return null;
            }
            return new FbsBlob(sliced);
        }
        else {
            var slice = new Uint8Array(this.data_.buffer, startByte, endByte - startByte);
            return new FbsBlob(slice, true);
        }
    };
    FbsBlob.getBlob = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (isNativeBlobDefined()) {
            var blobby = args.map(function (val) {
                if (val instanceof FbsBlob) {
                    return val.data_;
                }
                else {
                    return val;
                }
            });
            return new FbsBlob(getBlob.apply(null, blobby));
        }
        else {
            var uint8Arrays = args.map(function (val) {
                if (isString(val)) {
                    return dataFromString(StringFormat.RAW, val).data;
                }
                else {
                    // Blobs don't exist, so this has to be a Uint8Array.
                    return val.data_;
                }
            });
            var finalLength_1 = 0;
            uint8Arrays.forEach(function (array) {
                finalLength_1 += array.byteLength;
            });
            var merged_1 = new Uint8Array(finalLength_1);
            var index_1 = 0;
            uint8Arrays.forEach(function (array) {
                for (var i = 0; i < array.length; i++) {
                    merged_1[index_1++] = array[i];
                }
            });
            return new FbsBlob(merged_1, true);
        }
    };
    FbsBlob.prototype.uploadData = function () {
        return this.data_;
    };
    return FbsBlob;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @struct
 */
var Location = /** @class */ (function () {
    function Location(bucket, path) {
        this.bucket = bucket;
        this.path_ = path;
    }
    Object.defineProperty(Location.prototype, "path", {
        get: function () {
            return this.path_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Location.prototype, "isRoot", {
        get: function () {
            return this.path.length === 0;
        },
        enumerable: true,
        configurable: true
    });
    Location.prototype.fullServerUrl = function () {
        var encode = encodeURIComponent;
        return '/b/' + encode(this.bucket) + '/o/' + encode(this.path);
    };
    Location.prototype.bucketOnlyServerUrl = function () {
        var encode = encodeURIComponent;
        return '/b/' + encode(this.bucket) + '/o';
    };
    Location.makeFromBucketSpec = function (bucketString) {
        var bucketLocation;
        try {
            bucketLocation = Location.makeFromUrl(bucketString);
        }
        catch (e) {
            // Not valid URL, use as-is. This lets you put bare bucket names in
            // config.
            return new Location(bucketString, '');
        }
        if (bucketLocation.path === '') {
            return bucketLocation;
        }
        else {
            throw invalidDefaultBucket(bucketString);
        }
    };
    Location.makeFromUrl = function (url) {
        var location = null;
        var bucketDomain = '([A-Za-z0-9.\\-_]+)';
        function gsModify(loc) {
            if (loc.path.charAt(loc.path.length - 1) === '/') {
                loc.path_ = loc.path_.slice(0, -1);
            }
        }
        var gsPath = '(/(.*))?$';
        var path = '(/([^?#]*).*)?$';
        var gsRegex = new RegExp('^gs://' + bucketDomain + gsPath, 'i');
        var gsIndices = { bucket: 1, path: 3 };
        function httpModify(loc) {
            loc.path_ = decodeURIComponent(loc.path);
        }
        var version = 'v[A-Za-z0-9_]+';
        var hostRegex = DEFAULT_HOST.replace(/[.]/g, '\\.');
        var httpRegex = new RegExp("^https?://" + hostRegex + "/" + version + "/b/" + bucketDomain + "/o" + path, 'i');
        var httpIndices = { bucket: 1, path: 3 };
        var groups = [
            { regex: gsRegex, indices: gsIndices, postModify: gsModify },
            { regex: httpRegex, indices: httpIndices, postModify: httpModify }
        ];
        for (var i = 0; i < groups.length; i++) {
            var group = groups[i];
            var captures = group.regex.exec(url);
            if (captures) {
                var bucketValue = captures[group.indices.bucket];
                var pathValue = captures[group.indices.path];
                if (!pathValue) {
                    pathValue = '';
                }
                location = new Location(bucketValue, pathValue);
                group.postModify(location);
                break;
            }
        }
        if (location == null) {
            throw invalidUrl(url);
        }
        return location;
    };
    return Location;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns the Object resulting from parsing the given JSON, or null if the
 * given string does not represent a JSON object.
 */
function jsonObjectOrNull(s) {
    var obj;
    try {
        obj = JSON.parse(s);
    }
    catch (e) {
        return null;
    }
    if (isNonArrayObject(obj)) {
        return obj;
    }
    else {
        return null;
    }
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Contains helper methods for manipulating paths.
 */
/**
 * @return Null if the path is already at the root.
 */
function parent(path) {
    if (path.length === 0) {
        return null;
    }
    var index = path.lastIndexOf('/');
    if (index === -1) {
        return '';
    }
    var newPath = path.slice(0, index);
    return newPath;
}
function child(path, childPath) {
    var canonicalChildPath = childPath
        .split('/')
        .filter(function (component) { return component.length > 0; })
        .join('/');
    if (path.length === 0) {
        return canonicalChildPath;
    }
    else {
        return path + '/' + canonicalChildPath;
    }
}
/**
 * Returns the last component of a path.
 * '/foo/bar' -> 'bar'
 * '/foo/bar/baz/' -> 'baz/'
 * '/a' -> 'a'
 */
function lastComponent(path) {
    var index = path.lastIndexOf('/', path.length - 2);
    if (index === -1) {
        return path;
    }
    else {
        return path.slice(index + 1);
    }
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function makeUrl(urlPart) {
    return "https://" + DEFAULT_HOST + "/v0" + urlPart;
}
function makeQueryString(params) {
    var encode = encodeURIComponent;
    var queryPart = '?';
    for (var key in params) {
        if (params.hasOwnProperty(key)) {
            // @ts-ignore TODO: remove once typescript is upgraded to 3.5.x
            var nextPart = encode(key) + '=' + encode(params[key]);
            queryPart = queryPart + nextPart + '&';
        }
    }
    // Chop off the extra '&' or '?' on the end
    queryPart = queryPart.slice(0, -1);
    return queryPart;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function noXform_(metadata, value) {
    return value;
}
/**
 * @struct
 */
var Mapping = /** @class */ (function () {
    function Mapping(server, local, writable, xform) {
        this.server = server;
        this.local = local || server;
        this.writable = !!writable;
        this.xform = xform || noXform_;
    }
    return Mapping;
}());
var mappings_ = null;
function xformPath(fullPath) {
    if (!isString(fullPath) || fullPath.length < 2) {
        return fullPath;
    }
    else {
        return lastComponent(fullPath);
    }
}
function getMappings() {
    if (mappings_) {
        return mappings_;
    }
    var mappings = [];
    mappings.push(new Mapping('bucket'));
    mappings.push(new Mapping('generation'));
    mappings.push(new Mapping('metageneration'));
    mappings.push(new Mapping('name', 'fullPath', true));
    function mappingsXformPath(_metadata, fullPath) {
        return xformPath(fullPath);
    }
    var nameMapping = new Mapping('name');
    nameMapping.xform = mappingsXformPath;
    mappings.push(nameMapping);
    /**
     * Coerces the second param to a number, if it is defined.
     */
    function xformSize(_metadata, size) {
        if (isDef(size)) {
            return Number(size);
        }
        else {
            return size;
        }
    }
    var sizeMapping = new Mapping('size');
    sizeMapping.xform = xformSize;
    mappings.push(sizeMapping);
    mappings.push(new Mapping('timeCreated'));
    mappings.push(new Mapping('updated'));
    mappings.push(new Mapping('md5Hash', null, true));
    mappings.push(new Mapping('cacheControl', null, true));
    mappings.push(new Mapping('contentDisposition', null, true));
    mappings.push(new Mapping('contentEncoding', null, true));
    mappings.push(new Mapping('contentLanguage', null, true));
    mappings.push(new Mapping('contentType', null, true));
    mappings.push(new Mapping('metadata', 'customMetadata', true));
    mappings_ = mappings;
    return mappings_;
}
function addRef(metadata, authWrapper) {
    function generateRef() {
        var bucket = metadata['bucket'];
        var path = metadata['fullPath'];
        var loc = new Location(bucket, path);
        return authWrapper.makeStorageReference(loc);
    }
    Object.defineProperty(metadata, 'ref', { get: generateRef });
}
function fromResource(authWrapper, resource, mappings) {
    var metadata = {};
    metadata['type'] = 'file';
    var len = mappings.length;
    for (var i = 0; i < len; i++) {
        var mapping = mappings[i];
        metadata[mapping.local] = mapping.xform(metadata, resource[mapping.server]);
    }
    addRef(metadata, authWrapper);
    return metadata;
}
function fromResourceString(authWrapper, resourceString, mappings) {
    var obj = jsonObjectOrNull(resourceString);
    if (obj === null) {
        return null;
    }
    var resource = obj;
    return fromResource(authWrapper, resource, mappings);
}
function downloadUrlFromResourceString(metadata, resourceString) {
    var obj = jsonObjectOrNull(resourceString);
    if (obj === null) {
        return null;
    }
    if (!isString(obj['downloadTokens'])) {
        // This can happen if objects are uploaded through GCS and retrieved
        // through list, so we don't want to throw an Error.
        return null;
    }
    var tokens = obj['downloadTokens'];
    if (tokens.length === 0) {
        return null;
    }
    var encode = encodeURIComponent;
    var tokensList = tokens.split(',');
    var urls = tokensList.map(function (token) {
        var bucket = metadata['bucket'];
        var path = metadata['fullPath'];
        var urlPart = '/b/' + encode(bucket) + '/o/' + encode(path);
        var base = makeUrl(urlPart);
        var queryString = makeQueryString({
            alt: 'media',
            token: token
        });
        return base + queryString;
    });
    return urls[0];
}
function toResourceString(metadata, mappings) {
    var resource = {};
    var len = mappings.length;
    for (var i = 0; i < len; i++) {
        var mapping = mappings[i];
        if (mapping.writable) {
            resource[mapping.server] = metadata[mapping.local];
        }
    }
    return JSON.stringify(resource);
}
function metadataValidator(p) {
    if (!isObject(p) || !p) {
        throw 'Expected Metadata object.';
    }
    for (var key in p) {
        if (p.hasOwnProperty(key)) {
            var val = p[key];
            if (key === 'customMetadata') {
                if (!isObject(val)) {
                    throw 'Expected object for \'customMetadata\' mapping.';
                }
            }
            else {
                if (isNonNullObject(val)) {
                    throw "Mapping for '" + key + "' cannot be an object.";
                }
            }
        }
    }
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var MAX_RESULTS_KEY = 'maxResults';
var MAX_MAX_RESULTS = 1000;
var PAGE_TOKEN_KEY = 'pageToken';
var PREFIXES_KEY = 'prefixes';
var ITEMS_KEY = 'items';
function fromBackendResponse(authWrapper, resource) {
    var listResult = {
        prefixes: [],
        items: [],
        nextPageToken: resource['nextPageToken']
    };
    var bucket = authWrapper.bucket();
    if (bucket === null) {
        throw noDefaultBucket();
    }
    if (resource[PREFIXES_KEY]) {
        for (var _i = 0, _a = resource[PREFIXES_KEY]; _i < _a.length; _i++) {
            var path = _a[_i];
            var pathWithoutTrailingSlash = path.replace(/\/$/, '');
            var reference = authWrapper.makeStorageReference(new Location(bucket, pathWithoutTrailingSlash));
            listResult.prefixes.push(reference);
        }
    }
    if (resource[ITEMS_KEY]) {
        for (var _b = 0, _c = resource[ITEMS_KEY]; _b < _c.length; _b++) {
            var item = _c[_b];
            var reference = authWrapper.makeStorageReference(new Location(bucket, item['name']));
            listResult.items.push(reference);
        }
    }
    return listResult;
}
function fromResponseString(authWrapper, resourceString) {
    var obj = jsonObjectOrNull(resourceString);
    if (obj === null) {
        return null;
    }
    var resource = obj;
    return fromBackendResponse(authWrapper, resource);
}
function listOptionsValidator(p) {
    if (!isObject(p) || !p) {
        throw 'Expected ListOptions object.';
    }
    for (var key in p) {
        if (key === MAX_RESULTS_KEY) {
            if (!isInteger(p[MAX_RESULTS_KEY]) ||
                p[MAX_RESULTS_KEY] <= 0) {
                throw 'Expected maxResults to be a positive number.';
            }
            if (p[MAX_RESULTS_KEY] > 1000) {
                throw "Expected maxResults to be less than or equal to " + MAX_MAX_RESULTS + ".";
            }
        }
        else if (key === PAGE_TOKEN_KEY) {
            if (p[PAGE_TOKEN_KEY] && !isString(p[PAGE_TOKEN_KEY])) {
                throw 'Expected pageToken to be string.';
            }
        }
        else {
            throw 'Unknown option: ' + key;
        }
    }
}

var RequestInfo = /** @class */ (function () {
    function RequestInfo(url, method, 
    /**
     * Returns the value with which to resolve the request's promise. Only called
     * if the request is successful. Throw from this function to reject the
     * returned Request's promise with the thrown error.
     * Note: The XhrIo passed to this function may be reused after this callback
     * returns. Do not keep a reference to it in any way.
     */
    handler, timeout) {
        this.url = url;
        this.method = method;
        this.handler = handler;
        this.timeout = timeout;
        this.urlParams = {};
        this.headers = {};
        this.body = null;
        this.errorHandler = null;
        /**
         * Called with the current number of bytes uploaded and total size (-1 if not
         * computable) of the request body (i.e. used to report upload progress).
         */
        this.progressCallback = null;
        this.successCodes = [200];
        this.additionalRetryCodes = [];
    }
    return RequestInfo;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Throws the UNKNOWN FirebaseStorageError if cndn is false.
 */
function handlerCheck(cndn) {
    if (!cndn) {
        throw unknown();
    }
}
function metadataHandler(authWrapper, mappings) {
    function handler(xhr, text) {
        var metadata = fromResourceString(authWrapper, text, mappings);
        handlerCheck(metadata !== null);
        return metadata;
    }
    return handler;
}
function listHandler(authWrapper) {
    function handler(xhr, text) {
        var listResult = fromResponseString(authWrapper, text);
        handlerCheck(listResult !== null);
        return listResult;
    }
    return handler;
}
function downloadUrlHandler(authWrapper, mappings) {
    function handler(xhr, text) {
        var metadata = fromResourceString(authWrapper, text, mappings);
        handlerCheck(metadata !== null);
        return downloadUrlFromResourceString(metadata, text);
    }
    return handler;
}
function sharedErrorHandler(location) {
    function errorHandler(xhr, err) {
        var newErr;
        if (xhr.getStatus() === 401) {
            newErr = unauthenticated();
        }
        else {
            if (xhr.getStatus() === 402) {
                newErr = quotaExceeded(location.bucket);
            }
            else {
                if (xhr.getStatus() === 403) {
                    newErr = unauthorized(location.path);
                }
                else {
                    newErr = err;
                }
            }
        }
        newErr.setServerResponseProp(err.serverResponseProp());
        return newErr;
    }
    return errorHandler;
}
function objectErrorHandler(location) {
    var shared = sharedErrorHandler(location);
    function errorHandler(xhr, err) {
        var newErr = shared(xhr, err);
        if (xhr.getStatus() === 404) {
            newErr = objectNotFound(location.path);
        }
        newErr.setServerResponseProp(err.serverResponseProp());
        return newErr;
    }
    return errorHandler;
}
function getMetadata(authWrapper, location, mappings) {
    var urlPart = location.fullServerUrl();
    var url = makeUrl(urlPart);
    var method = 'GET';
    var timeout = authWrapper.maxOperationRetryTime();
    var requestInfo = new RequestInfo(url, method, metadataHandler(authWrapper, mappings), timeout);
    requestInfo.errorHandler = objectErrorHandler(location);
    return requestInfo;
}
function list(authWrapper, location, delimiter, pageToken, maxResults) {
    var urlParams = {};
    if (location.isRoot) {
        urlParams['prefix'] = '';
    }
    else {
        urlParams['prefix'] = location.path + '/';
    }
    if (delimiter && delimiter.length > 0) {
        urlParams['delimiter'] = delimiter;
    }
    if (pageToken) {
        urlParams['pageToken'] = pageToken;
    }
    if (maxResults) {
        urlParams['maxResults'] = maxResults;
    }
    var urlPart = location.bucketOnlyServerUrl();
    var url = makeUrl(urlPart);
    var method = 'GET';
    var timeout = authWrapper.maxOperationRetryTime();
    var requestInfo = new RequestInfo(url, method, listHandler(authWrapper), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.errorHandler = sharedErrorHandler(location);
    return requestInfo;
}
function getDownloadUrl(authWrapper, location, mappings) {
    var urlPart = location.fullServerUrl();
    var url = makeUrl(urlPart);
    var method = 'GET';
    var timeout = authWrapper.maxOperationRetryTime();
    var requestInfo = new RequestInfo(url, method, downloadUrlHandler(authWrapper, mappings), timeout);
    requestInfo.errorHandler = objectErrorHandler(location);
    return requestInfo;
}
function updateMetadata(authWrapper, location, metadata, mappings) {
    var urlPart = location.fullServerUrl();
    var url = makeUrl(urlPart);
    var method = 'PATCH';
    var body = toResourceString(metadata, mappings);
    var headers = { 'Content-Type': 'application/json; charset=utf-8' };
    var timeout = authWrapper.maxOperationRetryTime();
    var requestInfo = new RequestInfo(url, method, metadataHandler(authWrapper, mappings), timeout);
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = objectErrorHandler(location);
    return requestInfo;
}
function deleteObject(authWrapper, location) {
    var urlPart = location.fullServerUrl();
    var url = makeUrl(urlPart);
    var method = 'DELETE';
    var timeout = authWrapper.maxOperationRetryTime();
    function handler(_xhr, _text) { }
    var requestInfo = new RequestInfo(url, method, handler, timeout);
    requestInfo.successCodes = [200, 204];
    requestInfo.errorHandler = objectErrorHandler(location);
    return requestInfo;
}
function determineContentType_(metadata, blob) {
    return ((metadata && metadata['contentType']) ||
        (blob && blob.type()) ||
        'application/octet-stream');
}
function metadataForUpload_(location, blob, metadata) {
    var metadataClone = Object.assign({}, metadata);
    metadataClone['fullPath'] = location.path;
    metadataClone['size'] = blob.size();
    if (!metadataClone['contentType']) {
        metadataClone['contentType'] = determineContentType_(null, blob);
    }
    return metadataClone;
}
function multipartUpload(authWrapper, location, mappings, blob, metadata) {
    var urlPart = location.bucketOnlyServerUrl();
    var headers = {
        'X-Goog-Upload-Protocol': 'multipart'
    };
    function genBoundary() {
        var str = '';
        for (var i = 0; i < 2; i++) {
            str =
                str +
                    Math.random()
                        .toString()
                        .slice(2);
        }
        return str;
    }
    var boundary = genBoundary();
    headers['Content-Type'] = 'multipart/related; boundary=' + boundary;
    var metadata_ = metadataForUpload_(location, blob, metadata);
    var metadataString = toResourceString(metadata_, mappings);
    var preBlobPart = '--' +
        boundary +
        '\r\n' +
        'Content-Type: application/json; charset=utf-8\r\n\r\n' +
        metadataString +
        '\r\n--' +
        boundary +
        '\r\n' +
        'Content-Type: ' +
        metadata_['contentType'] +
        '\r\n\r\n';
    var postBlobPart = '\r\n--' + boundary + '--';
    var body = FbsBlob.getBlob(preBlobPart, blob, postBlobPart);
    if (body === null) {
        throw cannotSliceBlob();
    }
    var urlParams = { name: metadata_['fullPath'] };
    var url = makeUrl(urlPart);
    var method = 'POST';
    var timeout = authWrapper.maxUploadRetryTime();
    var requestInfo = new RequestInfo(url, method, metadataHandler(authWrapper, mappings), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.errorHandler = sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param current The number of bytes that have been uploaded so far.
 * @param total The total number of bytes in the upload.
 * @param opt_finalized True if the server has finished the upload.
 * @param opt_metadata The upload metadata, should
 *     only be passed if opt_finalized is true.
 * @struct
 */
var ResumableUploadStatus = /** @class */ (function () {
    function ResumableUploadStatus(current, total, finalized, metadata) {
        this.current = current;
        this.total = total;
        this.finalized = !!finalized;
        this.metadata = metadata || null;
    }
    return ResumableUploadStatus;
}());
function checkResumeHeader_(xhr, allowed) {
    var status = null;
    try {
        status = xhr.getResponseHeader('X-Goog-Upload-Status');
    }
    catch (e) {
        handlerCheck(false);
    }
    var allowedStatus = allowed || ['active'];
    handlerCheck(!!status && allowedStatus.indexOf(status) !== -1);
    return status;
}
function createResumableUpload(authWrapper, location, mappings, blob, metadata) {
    var urlPart = location.bucketOnlyServerUrl();
    var metadataForUpload = metadataForUpload_(location, blob, metadata);
    var urlParams = { name: metadataForUpload['fullPath'] };
    var url = makeUrl(urlPart);
    var method = 'POST';
    var headers = {
        'X-Goog-Upload-Protocol': 'resumable',
        'X-Goog-Upload-Command': 'start',
        'X-Goog-Upload-Header-Content-Length': blob.size(),
        'X-Goog-Upload-Header-Content-Type': metadataForUpload['contentType'],
        'Content-Type': 'application/json; charset=utf-8'
    };
    var body = toResourceString(metadataForUpload, mappings);
    var timeout = authWrapper.maxUploadRetryTime();
    function handler(xhr) {
        checkResumeHeader_(xhr);
        var url;
        try {
            url = xhr.getResponseHeader('X-Goog-Upload-URL');
        }
        catch (e) {
            handlerCheck(false);
        }
        handlerCheck(isString(url));
        return url;
    }
    var requestInfo = new RequestInfo(url, method, handler, timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 */
function getResumableUploadStatus(authWrapper, location, url, blob) {
    var headers = { 'X-Goog-Upload-Command': 'query' };
    function handler(xhr) {
        var status = checkResumeHeader_(xhr, ['active', 'final']);
        var sizeString = null;
        try {
            sizeString = xhr.getResponseHeader('X-Goog-Upload-Size-Received');
        }
        catch (e) {
            handlerCheck(false);
        }
        if (!sizeString) {
            // null or empty string
            handlerCheck(false);
        }
        var size = Number(sizeString);
        handlerCheck(!isNaN(size));
        return new ResumableUploadStatus(size, blob.size(), status === 'final');
    }
    var method = 'POST';
    var timeout = authWrapper.maxUploadRetryTime();
    var requestInfo = new RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.errorHandler = sharedErrorHandler(location);
    return requestInfo;
}
/**
 * Any uploads via the resumable upload API must transfer a number of bytes
 * that is a multiple of this number.
 */
var resumableUploadChunkSize = 256 * 1024;
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 * @param chunkSize Number of bytes to upload.
 * @param status The previous status.
 *     If not passed or null, we start from the beginning.
 * @throws fbs.Error If the upload is already complete, the passed in status
 *     has a final size inconsistent with the blob, or the blob cannot be sliced
 *     for upload.
 */
function continueResumableUpload(location, authWrapper, url, blob, chunkSize, mappings, status, progressCallback) {
    // TODO(andysoto): standardize on internal asserts
    // assert(!(opt_status && opt_status.finalized));
    var status_ = new ResumableUploadStatus(0, 0);
    if (status) {
        status_.current = status.current;
        status_.total = status.total;
    }
    else {
        status_.current = 0;
        status_.total = blob.size();
    }
    if (blob.size() !== status_.total) {
        throw serverFileWrongSize();
    }
    var bytesLeft = status_.total - status_.current;
    var bytesToUpload = bytesLeft;
    if (chunkSize > 0) {
        bytesToUpload = Math.min(bytesToUpload, chunkSize);
    }
    var startByte = status_.current;
    var endByte = startByte + bytesToUpload;
    var uploadCommand = bytesToUpload === bytesLeft ? 'upload, finalize' : 'upload';
    var headers = {
        'X-Goog-Upload-Command': uploadCommand,
        'X-Goog-Upload-Offset': status_.current
    };
    var body = blob.slice(startByte, endByte);
    if (body === null) {
        throw cannotSliceBlob();
    }
    function handler(xhr, text) {
        // TODO(andysoto): Verify the MD5 of each uploaded range:
        // the 'x-range-md5' header comes back with status code 308 responses.
        // We'll only be able to bail out though, because you can't re-upload a
        // range that you previously uploaded.
        var uploadStatus = checkResumeHeader_(xhr, ['active', 'final']);
        var newCurrent = status_.current + bytesToUpload;
        var size = blob.size();
        var metadata;
        if (uploadStatus === 'final') {
            metadata = metadataHandler(authWrapper, mappings)(xhr, text);
        }
        else {
            metadata = null;
        }
        return new ResumableUploadStatus(newCurrent, size, uploadStatus === 'final', metadata);
    }
    var method = 'POST';
    var timeout = authWrapper.maxUploadRetryTime();
    var requestInfo = new RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.progressCallback = progressCallback || null;
    requestInfo.errorHandler = sharedErrorHandler(location);
    return requestInfo;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @struct
 */
var Observer = /** @class */ (function () {
    function Observer(nextOrObserver, error, complete) {
        var asFunctions = isFunction(nextOrObserver) ||
            isDef(error) ||
            isDef(complete);
        if (asFunctions) {
            this.next = nextOrObserver;
            this.error = error || null;
            this.complete = complete || null;
        }
        else {
            var observer = nextOrObserver;
            this.next = observer.next || null;
            this.error = observer.error || null;
            this.complete = observer.complete || null;
        }
    }
    return Observer;
}());

var UploadTaskSnapshot = /** @class */ (function () {
    function UploadTaskSnapshot(bytesTransferred, totalBytes, state, metadata, task, ref) {
        this.bytesTransferred = bytesTransferred;
        this.totalBytes = totalBytes;
        this.state = state;
        this.metadata = metadata;
        this.task = task;
        this.ref = ref;
    }
    return UploadTaskSnapshot;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param name Name of the function.
 * @param specs Argument specs.
 * @param passed The actual arguments passed to the function.
 * @throws {fbs.Error} If the arguments are invalid.
 */
function validate(name, specs, passed) {
    var minArgs = specs.length;
    var maxArgs = specs.length;
    for (var i = 0; i < specs.length; i++) {
        if (specs[i].optional) {
            minArgs = i;
            break;
        }
    }
    var validLength = minArgs <= passed.length && passed.length <= maxArgs;
    if (!validLength) {
        throw invalidArgumentCount(minArgs, maxArgs, name, passed.length);
    }
    for (var i = 0; i < passed.length; i++) {
        try {
            specs[i].validator(passed[i]);
        }
        catch (e) {
            if (e instanceof Error) {
                throw invalidArgument(i, name, e.message);
            }
            else {
                throw invalidArgument(i, name, e);
            }
        }
    }
}
/**
 * @struct
 */
var ArgSpec = /** @class */ (function () {
    function ArgSpec(validator, optional) {
        var self = this;
        this.validator = function (p) {
            if (self.optional && !isJustDef(p)) {
                return;
            }
            validator(p);
        };
        this.optional = !!optional;
    }
    return ArgSpec;
}());
function and_(v1, v2) {
    return function (p) {
        v1(p);
        v2(p);
    };
}
function stringSpec(validator, optional) {
    function stringValidator(p) {
        if (!isString(p)) {
            throw 'Expected string.';
        }
    }
    var chainedValidator;
    if (validator) {
        chainedValidator = and_(stringValidator, validator);
    }
    else {
        chainedValidator = stringValidator;
    }
    return new ArgSpec(chainedValidator, optional);
}
function uploadDataSpec() {
    function validator(p) {
        var valid = p instanceof Uint8Array ||
            p instanceof ArrayBuffer ||
            (isNativeBlobDefined() && p instanceof Blob);
        if (!valid) {
            throw 'Expected Blob or File.';
        }
    }
    return new ArgSpec(validator);
}
function metadataSpec(optional) {
    return new ArgSpec(metadataValidator, optional);
}
function listOptionSpec(optional) {
    return new ArgSpec(listOptionsValidator, optional);
}
function nonNegativeNumberSpec() {
    function validator(p) {
        var valid = isNumber(p) && p >= 0;
        if (!valid) {
            throw 'Expected a number 0 or greater.';
        }
    }
    return new ArgSpec(validator);
}
function looseObjectSpec(validator, optional) {
    function isLooseObjectValidator(p) {
        var isLooseObject = p === null || (isDef(p) && p instanceof Object);
        if (!isLooseObject) {
            throw 'Expected an Object.';
        }
        if (validator !== undefined && validator !== null) {
            validator(p);
        }
    }
    return new ArgSpec(isLooseObjectValidator, optional);
}
function nullFunctionSpec(optional) {
    function validator(p) {
        var valid = p === null || isFunction(p);
        if (!valid) {
            throw 'Expected a Function.';
        }
    }
    return new ArgSpec(validator, optional);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a function that invokes f with its arguments asynchronously as a
 * microtask, i.e. as soon as possible after the current script returns back
 * into browser code.
 */
function async(f) {
    return function () {
        var argsToForward = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            argsToForward[_i] = arguments[_i];
        }
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        Promise.resolve().then(function () { return f.apply(void 0, argsToForward); });
    };
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Represents a blob being uploaded. Can be used to pause/resume/cancel the
 * upload and manage callbacks for various events.
 */
var UploadTask = /** @class */ (function () {
    /**
     * @param ref The firebaseStorage.Reference object this task came
     *     from, untyped to avoid cyclic dependencies.
     * @param blob The blob to upload.
     */
    function UploadTask(ref, authWrapper, location, mappings, blob, metadata) {
        var _this = this;
        if (metadata === void 0) { metadata = null; }
        this.transferred_ = 0;
        this.needToFetchStatus_ = false;
        this.needToFetchMetadata_ = false;
        this.observers_ = [];
        this.error_ = null;
        this.uploadUrl_ = null;
        this.request_ = null;
        this.chunkMultiplier_ = 1;
        this.resolve_ = null;
        this.reject_ = null;
        this.ref_ = ref;
        this.authWrapper_ = authWrapper;
        this.location_ = location;
        this.blob_ = blob;
        this.metadata_ = metadata;
        this.mappings_ = mappings;
        this.resumable_ = this.shouldDoResumable_(this.blob_);
        this.state_ = InternalTaskState.RUNNING;
        this.errorHandler_ = function (error) {
            _this.request_ = null;
            _this.chunkMultiplier_ = 1;
            if (error.codeEquals(Code.CANCELED)) {
                _this.needToFetchStatus_ = true;
                _this.completeTransitions_();
            }
            else {
                _this.error_ = error;
                _this.transition_(InternalTaskState.ERROR);
            }
        };
        this.metadataErrorHandler_ = function (error) {
            _this.request_ = null;
            if (error.codeEquals(Code.CANCELED)) {
                _this.completeTransitions_();
            }
            else {
                _this.error_ = error;
                _this.transition_(InternalTaskState.ERROR);
            }
        };
        this.promise_ = new Promise(function (resolve, reject) {
            _this.resolve_ = resolve;
            _this.reject_ = reject;
            _this.start_();
        });
        // Prevent uncaught rejections on the internal promise from bubbling out
        // to the top level with a dummy handler.
        this.promise_.then(null, function () { });
    }
    UploadTask.prototype.makeProgressCallback_ = function () {
        var _this = this;
        var sizeBefore = this.transferred_;
        return function (loaded) { return _this.updateProgress_(sizeBefore + loaded); };
    };
    UploadTask.prototype.shouldDoResumable_ = function (blob) {
        return blob.size() > 256 * 1024;
    };
    UploadTask.prototype.start_ = function () {
        if (this.state_ !== InternalTaskState.RUNNING) {
            // This can happen if someone pauses us in a resume callback, for example.
            return;
        }
        if (this.request_ !== null) {
            return;
        }
        if (this.resumable_) {
            if (this.uploadUrl_ === null) {
                this.createResumable_();
            }
            else {
                if (this.needToFetchStatus_) {
                    this.fetchStatus_();
                }
                else {
                    if (this.needToFetchMetadata_) {
                        // Happens if we miss the metadata on upload completion.
                        this.fetchMetadata_();
                    }
                    else {
                        this.continueUpload_();
                    }
                }
            }
        }
        else {
            this.oneShotUpload_();
        }
    };
    UploadTask.prototype.resolveToken_ = function (callback) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.authWrapper_.getAuthToken().then(function (authToken) {
            switch (_this.state_) {
                case InternalTaskState.RUNNING:
                    callback(authToken);
                    break;
                case InternalTaskState.CANCELING:
                    _this.transition_(InternalTaskState.CANCELED);
                    break;
                case InternalTaskState.PAUSING:
                    _this.transition_(InternalTaskState.PAUSED);
                    break;
            }
        });
    };
    // TODO(andysoto): assert false
    UploadTask.prototype.createResumable_ = function () {
        var _this = this;
        this.resolveToken_(function (authToken) {
            var requestInfo = createResumableUpload(_this.authWrapper_, _this.location_, _this.mappings_, _this.blob_, _this.metadata_);
            var createRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
            _this.request_ = createRequest;
            createRequest.getPromise().then(function (url) {
                _this.request_ = null;
                _this.uploadUrl_ = url;
                _this.needToFetchStatus_ = false;
                _this.completeTransitions_();
            }, _this.errorHandler_);
        });
    };
    UploadTask.prototype.fetchStatus_ = function () {
        var _this = this;
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        var url = this.uploadUrl_;
        this.resolveToken_(function (authToken) {
            var requestInfo = getResumableUploadStatus(_this.authWrapper_, _this.location_, url, _this.blob_);
            var statusRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
            _this.request_ = statusRequest;
            statusRequest.getPromise().then(function (status) {
                status = status;
                _this.request_ = null;
                _this.updateProgress_(status.current);
                _this.needToFetchStatus_ = false;
                if (status.finalized) {
                    _this.needToFetchMetadata_ = true;
                }
                _this.completeTransitions_();
            }, _this.errorHandler_);
        });
    };
    UploadTask.prototype.continueUpload_ = function () {
        var _this = this;
        var chunkSize = resumableUploadChunkSize * this.chunkMultiplier_;
        var status = new ResumableUploadStatus(this.transferred_, this.blob_.size());
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        var url = this.uploadUrl_;
        this.resolveToken_(function (authToken) {
            var requestInfo;
            try {
                requestInfo = continueResumableUpload(_this.location_, _this.authWrapper_, url, _this.blob_, chunkSize, _this.mappings_, status, _this.makeProgressCallback_());
            }
            catch (e) {
                _this.error_ = e;
                _this.transition_(InternalTaskState.ERROR);
                return;
            }
            var uploadRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
            _this.request_ = uploadRequest;
            uploadRequest
                .getPromise()
                .then(function (newStatus) {
                _this.increaseMultiplier_();
                _this.request_ = null;
                _this.updateProgress_(newStatus.current);
                if (newStatus.finalized) {
                    _this.metadata_ = newStatus.metadata;
                    _this.transition_(InternalTaskState.SUCCESS);
                }
                else {
                    _this.completeTransitions_();
                }
            }, _this.errorHandler_);
        });
    };
    UploadTask.prototype.increaseMultiplier_ = function () {
        var currentSize = resumableUploadChunkSize * this.chunkMultiplier_;
        // Max chunk size is 32M.
        if (currentSize < 32 * 1024 * 1024) {
            this.chunkMultiplier_ *= 2;
        }
    };
    UploadTask.prototype.fetchMetadata_ = function () {
        var _this = this;
        this.resolveToken_(function (authToken) {
            var requestInfo = getMetadata(_this.authWrapper_, _this.location_, _this.mappings_);
            var metadataRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
            _this.request_ = metadataRequest;
            metadataRequest.getPromise().then(function (metadata) {
                _this.request_ = null;
                _this.metadata_ = metadata;
                _this.transition_(InternalTaskState.SUCCESS);
            }, _this.metadataErrorHandler_);
        });
    };
    UploadTask.prototype.oneShotUpload_ = function () {
        var _this = this;
        this.resolveToken_(function (authToken) {
            var requestInfo = multipartUpload(_this.authWrapper_, _this.location_, _this.mappings_, _this.blob_, _this.metadata_);
            var multipartRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
            _this.request_ = multipartRequest;
            multipartRequest.getPromise().then(function (metadata) {
                _this.request_ = null;
                _this.metadata_ = metadata;
                _this.updateProgress_(_this.blob_.size());
                _this.transition_(InternalTaskState.SUCCESS);
            }, _this.errorHandler_);
        });
    };
    UploadTask.prototype.updateProgress_ = function (transferred) {
        var old = this.transferred_;
        this.transferred_ = transferred;
        // A progress update can make the "transferred" value smaller (e.g. a
        // partial upload not completed by server, after which the "transferred"
        // value may reset to the value at the beginning of the request).
        if (this.transferred_ !== old) {
            this.notifyObservers_();
        }
    };
    UploadTask.prototype.transition_ = function (state) {
        if (this.state_ === state) {
            return;
        }
        switch (state) {
            case InternalTaskState.CANCELING:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING);
                this.state_ = state;
                if (this.request_ !== null) {
                    this.request_.cancel();
                }
                break;
            case InternalTaskState.PAUSING:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING);
                this.state_ = state;
                if (this.request_ !== null) {
                    this.request_.cancel();
                }
                break;
            case InternalTaskState.RUNNING:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.PAUSING);
                var wasPaused = this.state_ === InternalTaskState.PAUSED;
                this.state_ = state;
                if (wasPaused) {
                    this.notifyObservers_();
                    this.start_();
                }
                break;
            case InternalTaskState.PAUSED:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSING);
                this.state_ = state;
                this.notifyObservers_();
                break;
            case InternalTaskState.CANCELED:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.CANCELING);
                this.error_ = canceled();
                this.state_ = state;
                this.notifyObservers_();
                break;
            case InternalTaskState.ERROR:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this.state_ = state;
                this.notifyObservers_();
                break;
            case InternalTaskState.SUCCESS:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this.state_ = state;
                this.notifyObservers_();
                break;
        }
    };
    UploadTask.prototype.completeTransitions_ = function () {
        switch (this.state_) {
            case InternalTaskState.PAUSING:
                this.transition_(InternalTaskState.PAUSED);
                break;
            case InternalTaskState.CANCELING:
                this.transition_(InternalTaskState.CANCELED);
                break;
            case InternalTaskState.RUNNING:
                this.start_();
                break;
        }
    };
    Object.defineProperty(UploadTask.prototype, "snapshot", {
        get: function () {
            var externalState = taskStateFromInternalTaskState(this.state_);
            return new UploadTaskSnapshot(this.transferred_, this.blob_.size(), externalState, this.metadata_, this, this.ref_);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Adds a callback for an event.
     * @param type The type of event to listen for.
     */
    UploadTask.prototype.on = function (type, nextOrObserver, error, completed) {
        function typeValidator() {
            if (type !== TaskEvent.STATE_CHANGED) {
                throw "Expected one of the event types: [" + TaskEvent.STATE_CHANGED + "].";
            }
        }
        var nextOrObserverMessage = 'Expected a function or an Object with one of ' +
            '`next`, `error`, `complete` properties.';
        var nextValidator = nullFunctionSpec(true).validator;
        var observerValidator = looseObjectSpec(null, true).validator;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        function nextOrObserverValidator(p) {
            try {
                nextValidator(p);
                return;
            }
            catch (e) { }
            try {
                observerValidator(p);
                var anyDefined = isJustDef(p['next']) ||
                    isJustDef(p['error']) ||
                    isJustDef(p['complete']);
                if (!anyDefined) {
                    throw '';
                }
                return;
            }
            catch (e) {
                throw nextOrObserverMessage;
            }
        }
        var specs = [
            stringSpec(typeValidator),
            looseObjectSpec(nextOrObserverValidator, true),
            nullFunctionSpec(true),
            nullFunctionSpec(true)
        ];
        validate('on', specs, arguments);
        var self = this;
        function makeBinder(specs) {
            function binder(nextOrObserver, error, complete) {
                if (specs !== null) {
                    validate('on', specs, arguments);
                }
                var observer = new Observer(nextOrObserver, error, completed);
                self.addObserver_(observer);
                return function () {
                    self.removeObserver_(observer);
                };
            }
            return binder;
        }
        function binderNextOrObserverValidator(p) {
            if (p === null) {
                throw nextOrObserverMessage;
            }
            nextOrObserverValidator(p);
        }
        var binderSpecs = [
            looseObjectSpec(binderNextOrObserverValidator),
            nullFunctionSpec(true),
            nullFunctionSpec(true)
        ];
        var typeOnly = !(isJustDef(nextOrObserver) ||
            isJustDef(error) ||
            isJustDef(completed));
        if (typeOnly) {
            return makeBinder(binderSpecs);
        }
        else {
            return makeBinder(null)(nextOrObserver, error, completed);
        }
    };
    /**
     * This object behaves like a Promise, and resolves with its snapshot data
     * when the upload completes.
     * @param onFulfilled The fulfillment callback. Promise chaining works as normal.
     * @param onRejected The rejection callback.
     */
    UploadTask.prototype.then = function (onFulfilled, onRejected) {
        // These casts are needed so that TypeScript can infer the types of the
        // resulting Promise.
        return this.promise_.then(onFulfilled, onRejected);
    };
    /**
     * Equivalent to calling `then(null, onRejected)`.
     */
    UploadTask.prototype.catch = function (onRejected) {
        return this.then(null, onRejected);
    };
    /**
     * Adds the given observer.
     */
    UploadTask.prototype.addObserver_ = function (observer) {
        this.observers_.push(observer);
        this.notifyObserver_(observer);
    };
    /**
     * Removes the given observer.
     */
    UploadTask.prototype.removeObserver_ = function (observer) {
        var i = this.observers_.indexOf(observer);
        if (i !== -1) {
            this.observers_.splice(i, 1);
        }
    };
    UploadTask.prototype.notifyObservers_ = function () {
        var _this = this;
        this.finishPromise_();
        var observers = this.observers_.slice();
        observers.forEach(function (observer) {
            _this.notifyObserver_(observer);
        });
    };
    UploadTask.prototype.finishPromise_ = function () {
        if (this.resolve_ !== null) {
            var triggered = true;
            switch (taskStateFromInternalTaskState(this.state_)) {
                case TaskState.SUCCESS:
                    async(this.resolve_.bind(null, this.snapshot))();
                    break;
                case TaskState.CANCELED:
                case TaskState.ERROR:
                    var toCall = this.reject_;
                    async(toCall.bind(null, this.error_))();
                    break;
                default:
                    triggered = false;
                    break;
            }
            if (triggered) {
                this.resolve_ = null;
                this.reject_ = null;
            }
        }
    };
    UploadTask.prototype.notifyObserver_ = function (observer) {
        var externalState = taskStateFromInternalTaskState(this.state_);
        switch (externalState) {
            case TaskState.RUNNING:
            case TaskState.PAUSED:
                if (observer.next) {
                    async(observer.next.bind(observer, this.snapshot))();
                }
                break;
            case TaskState.SUCCESS:
                if (observer.complete) {
                    async(observer.complete.bind(observer))();
                }
                break;
            case TaskState.CANCELED:
            case TaskState.ERROR:
                if (observer.error) {
                    async(observer.error.bind(observer, this.error_))();
                }
                break;
            default:
                // TODO(andysoto): assert(false);
                if (observer.error) {
                    async(observer.error.bind(observer, this.error_))();
                }
        }
    };
    /**
     * Resumes a paused task. Has no effect on a currently running or failed task.
     * @return True if the operation took effect, false if ignored.
     */
    UploadTask.prototype.resume = function () {
        validate('resume', [], arguments);
        var valid = this.state_ === InternalTaskState.PAUSED ||
            this.state_ === InternalTaskState.PAUSING;
        if (valid) {
            this.transition_(InternalTaskState.RUNNING);
        }
        return valid;
    };
    /**
     * Pauses a currently running task. Has no effect on a paused or failed task.
     * @return True if the operation took effect, false if ignored.
     */
    UploadTask.prototype.pause = function () {
        validate('pause', [], arguments);
        var valid = this.state_ === InternalTaskState.RUNNING;
        if (valid) {
            this.transition_(InternalTaskState.PAUSING);
        }
        return valid;
    };
    /**
     * Cancels a currently running or paused task. Has no effect on a complete or
     * failed task.
     * @return True if the operation took effect, false if ignored.
     */
    UploadTask.prototype.cancel = function () {
        validate('cancel', [], arguments);
        var valid = this.state_ === InternalTaskState.RUNNING ||
            this.state_ === InternalTaskState.PAUSING;
        if (valid) {
            this.transition_(InternalTaskState.CANCELING);
        }
        return valid;
    };
    return UploadTask;
}());

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provides methods to interact with a bucket in the Firebase Storage service.
 * @param location An fbs.location, or the URL at
 *     which to base this object, in one of the following forms:
 *         gs://<bucket>/<object-path>
 *         http[s]://firebasestorage.googleapis.com/
 *                     <api-version>/b/<bucket>/o/<object-path>
 *     Any query or fragment strings will be ignored in the http[s]
 *     format. If no value is passed, the storage object will use a URL based on
 *     the project ID of the base firebase.App instance.
 */
var Reference = /** @class */ (function () {
    function Reference(authWrapper, location) {
        this.authWrapper = authWrapper;
        if (location instanceof Location) {
            this.location = location;
        }
        else {
            this.location = Location.makeFromUrl(location);
        }
    }
    /**
     * @return The URL for the bucket and path this object references,
     *     in the form gs://<bucket>/<object-path>
     * @override
     */
    Reference.prototype.toString = function () {
        validate('toString', [], arguments);
        return 'gs://' + this.location.bucket + '/' + this.location.path;
    };
    Reference.prototype.newRef = function (authWrapper, location) {
        return new Reference(authWrapper, location);
    };
    Reference.prototype.mappings = function () {
        return getMappings();
    };
    /**
     * @return A reference to the object obtained by
     *     appending childPath, removing any duplicate, beginning, or trailing
     *     slashes.
     */
    Reference.prototype.child = function (childPath) {
        validate('child', [stringSpec()], arguments);
        var newPath = child(this.location.path, childPath);
        var location = new Location(this.location.bucket, newPath);
        return this.newRef(this.authWrapper, location);
    };
    Object.defineProperty(Reference.prototype, "parent", {
        /**
         * @return A reference to the parent of the
         *     current object, or null if the current object is the root.
         */
        get: function () {
            var newPath = parent(this.location.path);
            if (newPath === null) {
                return null;
            }
            var location = new Location(this.location.bucket, newPath);
            return this.newRef(this.authWrapper, location);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "root", {
        /**
         * @return An reference to the root of this
         *     object's bucket.
         */
        get: function () {
            var location = new Location(this.location.bucket, '');
            return this.newRef(this.authWrapper, location);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "bucket", {
        get: function () {
            return this.location.bucket;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "fullPath", {
        get: function () {
            return this.location.path;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "name", {
        get: function () {
            return lastComponent(this.location.path);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "storage", {
        get: function () {
            return this.authWrapper.service();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Uploads a blob to this object's location.
     * @param data The blob to upload.
     * @return An UploadTask that lets you control and
     *     observe the upload.
     */
    Reference.prototype.put = function (data, metadata) {
        if (metadata === void 0) { metadata = null; }
        validate('put', [uploadDataSpec(), metadataSpec(true)], arguments);
        this.throwIfRoot_('put');
        return new UploadTask(this, this.authWrapper, this.location, this.mappings(), new FbsBlob(data), metadata);
    };
    /**
     * Uploads a string to this object's location.
     * @param value The string to upload.
     * @param format The format of the string to upload.
     * @return An UploadTask that lets you control and
     *     observe the upload.
     */
    Reference.prototype.putString = function (value, format, metadata) {
        if (format === void 0) { format = StringFormat.RAW; }
        validate('putString', [stringSpec(), stringSpec(formatValidator, true), metadataSpec(true)], arguments);
        this.throwIfRoot_('putString');
        var data = dataFromString(format, value);
        var metadataClone = Object.assign({}, metadata);
        if (!isDef(metadataClone['contentType']) &&
            isDef(data.contentType)) {
            metadataClone['contentType'] = data.contentType;
        }
        return new UploadTask(this, this.authWrapper, this.location, this.mappings(), new FbsBlob(data.data, true), metadataClone);
    };
    /**
     * Deletes the object at this location.
     * @return A promise that resolves if the deletion succeeds.
     */
    Reference.prototype.delete = function () {
        var _this = this;
        validate('delete', [], arguments);
        this.throwIfRoot_('delete');
        return this.authWrapper.getAuthToken().then(function (authToken) {
            var requestInfo = deleteObject(_this.authWrapper, _this.location);
            return _this.authWrapper.makeRequest(requestInfo, authToken).getPromise();
        });
    };
    /**
     * List all items (files) and prefixes (folders) under this storage reference.
     *
     * This is a helper method for calling list() repeatedly until there are
     * no more results. The default pagination size is 1000.
     *
     * Note: The results may not be consistent if objects are changed while this
     * operation is running.
     *
     * Warning: listAll may potentially consume too many resources if there are
     * too many results.
     *
     * @return A Promise that resolves with all the items and prefixes under
     *      the current storage reference. `prefixes` contains references to
     *      sub-directories and `items` contains references to objects in this
     *      folder. `nextPageToken` is never returned.
     */
    Reference.prototype.listAll = function () {
        validate('listAll', [], arguments);
        var accumulator = {
            prefixes: [],
            items: []
        };
        return this.listAllHelper(accumulator).then(function () { return accumulator; });
    };
    Reference.prototype.listAllHelper = function (accumulator, pageToken) {
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
            var opt, nextPage;
            var _a, _b;
            return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_c) {
                switch (_c.label) {
                    case 0:
                        opt = {
                            // maxResults is 1000 by default.
                            pageToken: pageToken
                        };
                        return [4 /*yield*/, this.list(opt)];
                    case 1:
                        nextPage = _c.sent();
                        (_a = accumulator.prefixes).push.apply(_a, nextPage.prefixes);
                        (_b = accumulator.items).push.apply(_b, nextPage.items);
                        if (!(nextPage.nextPageToken != null)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.listAllHelper(accumulator, nextPage.nextPageToken)];
                    case 2:
                        _c.sent();
                        _c.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * List items (files) and prefixes (folders) under this storage reference.
     *
     * List API is only available for Firebase Rules Version 2.
     *
     * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
     * delimited folder structure.
     * Refer to GCS's List API if you want to learn more.
     *
     * To adhere to Firebase Rules's Semantics, Firebase Storage does not
     * support objects whose paths end with "/" or contain two consecutive
     * "/"s. Firebase Storage List API will filter these unsupported objects.
     * list() may fail if there are too many unsupported objects in the bucket.
     *
     * @param options See ListOptions for details.
     * @return A Promise that resolves with the items and prefixes.
     *      `prefixes` contains references to sub-folders and `items`
     *      contains references to objects in this folder. `nextPageToken`
     *      can be used to get the rest of the results.
     */
    Reference.prototype.list = function (options) {
        validate('list', [listOptionSpec(true)], arguments);
        var self = this;
        return this.authWrapper.getAuthToken().then(function (authToken) {
            var op = options || {};
            var requestInfo = list(self.authWrapper, self.location, 
            /*delimiter= */ '/', op.pageToken, op.maxResults);
            return self.authWrapper.makeRequest(requestInfo, authToken).getPromise();
        });
    };
    /**
     *     A promise that resolves with the metadata for this object. If this
     *     object doesn't exist or metadata cannot be retreived, the promise is
     *     rejected.
     */
    Reference.prototype.getMetadata = function () {
        var _this = this;
        validate('getMetadata', [], arguments);
        this.throwIfRoot_('getMetadata');
        return this.authWrapper.getAuthToken().then(function (authToken) {
            var requestInfo = getMetadata(_this.authWrapper, _this.location, _this.mappings());
            return _this.authWrapper.makeRequest(requestInfo, authToken).getPromise();
        });
    };
    /**
     * Updates the metadata for this object.
     * @param metadata The new metadata for the object.
     *     Only values that have been explicitly set will be changed. Explicitly
     *     setting a value to null will remove the metadata.
     * @return A promise that resolves
     *     with the new metadata for this object.
     *     @see firebaseStorage.Reference.prototype.getMetadata
     */
    Reference.prototype.updateMetadata = function (metadata) {
        var _this = this;
        validate('updateMetadata', [metadataSpec()], arguments);
        this.throwIfRoot_('updateMetadata');
        return this.authWrapper.getAuthToken().then(function (authToken) {
            var requestInfo = updateMetadata(_this.authWrapper, _this.location, metadata, _this.mappings());
            return _this.authWrapper.makeRequest(requestInfo, authToken).getPromise();
        });
    };
    /**
     * @return A promise that resolves with the download
     *     URL for this object.
     */
    Reference.prototype.getDownloadURL = function () {
        var _this = this;
        validate('getDownloadURL', [], arguments);
        this.throwIfRoot_('getDownloadURL');
        return this.authWrapper.getAuthToken().then(function (authToken) {
            var requestInfo = getDownloadUrl(_this.authWrapper, _this.location, _this.mappings());
            return _this.authWrapper
                .makeRequest(requestInfo, authToken)
                .getPromise()
                .then(function (url) {
                if (url === null) {
                    throw noDownloadURL();
                }
                return url;
            });
        });
    };
    Reference.prototype.throwIfRoot_ = function (name) {
        if (this.location.path === '') {
            throw invalidRootOperation(name);
        }
    };
    return Reference;
}());

/**
 * A request whose promise always fails.
 * @struct
 * @template T
 */
var FailRequest = /** @class */ (function () {
    function FailRequest(error) {
        this.promise_ = Promise.reject(error);
    }
    /** @inheritDoc */
    FailRequest.prototype.getPromise = function () {
        return this.promise_;
    };
    /** @inheritDoc */
    FailRequest.prototype.cancel = function (_appDelete) {
    };
    return FailRequest;
}());

var RequestMap = /** @class */ (function () {
    function RequestMap() {
        this.map = new Map();
        this.id = MIN_SAFE_INTEGER;
    }
    /**
     * Registers the given request with this map.
     * The request is unregistered when it completes.
     *
     * @param request The request to register.
     */
    RequestMap.prototype.addRequest = function (request) {
        var _this = this;
        var id = this.id;
        this.id++;
        this.map.set(id, request);
        request
            .getPromise()
            .then(function () { return _this.map.delete(id); }, function () { return _this.map.delete(id); });
    };
    /**
     * Cancels all registered requests.
     */
    RequestMap.prototype.clear = function () {
        this.map.forEach(function (v) {
            v && v.cancel(true);
        });
        this.map.clear();
    };
    return RequestMap;
}());

/**
 * @param app If null, getAuthToken always resolves with null.
 * @param service The storage service associated with this auth wrapper.
 *     Untyped to avoid circular type dependencies.
 * @struct
 */
var AuthWrapper = /** @class */ (function () {
    function AuthWrapper(app, maker, requestMaker, service, pool) {
        this.bucket_ = null;
        this.deleted_ = false;
        this.app_ = app;
        if (this.app_ !== null) {
            var options = this.app_.options;
            if (isDef(options)) {
                this.bucket_ = AuthWrapper.extractBucket_(options);
            }
        }
        this.storageRefMaker_ = maker;
        this.requestMaker_ = requestMaker;
        this.pool_ = pool;
        this.service_ = service;
        this.maxOperationRetryTime_ = DEFAULT_MAX_OPERATION_RETRY_TIME;
        this.maxUploadRetryTime_ = DEFAULT_MAX_UPLOAD_RETRY_TIME;
        this.requestMap_ = new RequestMap();
    }
    AuthWrapper.extractBucket_ = function (config) {
        var bucketString = config[CONFIG_STORAGE_BUCKET_KEY] || null;
        if (bucketString == null) {
            return null;
        }
        var loc = Location.makeFromBucketSpec(bucketString);
        return loc.bucket;
    };
    AuthWrapper.prototype.getAuthToken = function () {
        // TODO(andysoto): remove ifDef checks after firebase-app implements stubs
        // (b/28673818).
        if (this.app_ !== null &&
            isDef(this.app_.INTERNAL) &&
            isDef(this.app_.INTERNAL.getToken)) {
            return this.app_.INTERNAL.getToken().then(function (response) {
                if (response !== null) {
                    return response.accessToken;
                }
                else {
                    return null;
                }
            }, function () { return null; });
        }
        else {
            return Promise.resolve(null);
        }
    };
    AuthWrapper.prototype.bucket = function () {
        if (this.deleted_) {
            throw appDeleted();
        }
        else {
            return this.bucket_;
        }
    };
    /**
     * The service associated with this auth wrapper. Untyped to avoid circular
     * type dependencies.
     */
    AuthWrapper.prototype.service = function () {
        return this.service_;
    };
    /**
     * Returns a new firebaseStorage.Reference object referencing this AuthWrapper
     * at the given Location.
     * @param loc The Location.
     * @return Actually a firebaseStorage.Reference, typing not allowed
     *     because of circular dependency problems.
     */
    AuthWrapper.prototype.makeStorageReference = function (loc) {
        return this.storageRefMaker_(this, loc);
    };
    AuthWrapper.prototype.makeRequest = function (requestInfo, authToken) {
        if (!this.deleted_) {
            var request = this.requestMaker_(requestInfo, authToken, this.pool_);
            this.requestMap_.addRequest(request);
            return request;
        }
        else {
            return new FailRequest(appDeleted());
        }
    };
    /**
     * Stop running requests and prevent more from being created.
     */
    AuthWrapper.prototype.deleteApp = function () {
        this.deleted_ = true;
        this.app_ = null;
        this.requestMap_.clear();
    };
    AuthWrapper.prototype.maxUploadRetryTime = function () {
        return this.maxUploadRetryTime_;
    };
    AuthWrapper.prototype.setMaxUploadRetryTime = function (time) {
        this.maxUploadRetryTime_ = time;
    };
    AuthWrapper.prototype.maxOperationRetryTime = function () {
        return this.maxOperationRetryTime_;
    };
    AuthWrapper.prototype.setMaxOperationRetryTime = function (time) {
        this.maxOperationRetryTime_ = time;
    };
    return AuthWrapper;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param f May be invoked
 *     before the function returns.
 * @param callback Get all the arguments passed to the function
 *     passed to f, including the initial boolean.
 */
function start(f, callback, timeout) {
    // TODO(andysoto): make this code cleaner (probably refactor into an actual
    // type instead of a bunch of functions with state shared in the closure)
    var waitSeconds = 1;
    // Would type this as "number" but that doesn't work for Node so ¯\_(ツ)_/¯
    // TODO: find a way to exclude Node type definition for storage because storage only works in browser
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var timeoutId = null;
    var hitTimeout = false;
    var cancelState = 0;
    function canceled() {
        return cancelState === 2;
    }
    var triggeredCallback = false;
    // TODO: This disable can be removed and the 'ignoreRestArgs' option added to
    // the no-explicit-any rule when ESlint releases it.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function triggerCallback() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!triggeredCallback) {
            triggeredCallback = true;
            callback.apply(null, args);
        }
    }
    function callWithDelay(millis) {
        timeoutId = setTimeout(function () {
            timeoutId = null;
            f(handler, canceled());
        }, millis);
    }
    // TODO: This disable can be removed and the 'ignoreRestArgs' option added to
    // the no-explicit-any rule when ESlint releases it.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function handler(success) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (triggeredCallback) {
            return;
        }
        if (success) {
            triggerCallback.call.apply(triggerCallback, __WEBPACK_IMPORTED_MODULE_1_tslib__["__spreadArrays"]([null, success], args));
            return;
        }
        var mustStop = canceled() || hitTimeout;
        if (mustStop) {
            triggerCallback.call.apply(triggerCallback, __WEBPACK_IMPORTED_MODULE_1_tslib__["__spreadArrays"]([null, success], args));
            return;
        }
        if (waitSeconds < 64) {
            /* TODO(andysoto): don't back off so quickly if we know we're offline. */
            waitSeconds *= 2;
        }
        var waitMillis;
        if (cancelState === 1) {
            cancelState = 2;
            waitMillis = 0;
        }
        else {
            waitMillis = (waitSeconds + Math.random()) * 1000;
        }
        callWithDelay(waitMillis);
    }
    var stopped = false;
    function stop(wasTimeout) {
        if (stopped) {
            return;
        }
        stopped = true;
        if (triggeredCallback) {
            return;
        }
        if (timeoutId !== null) {
            if (!wasTimeout) {
                cancelState = 2;
            }
            clearTimeout(timeoutId);
            callWithDelay(0);
        }
        else {
            if (!wasTimeout) {
                cancelState = 1;
            }
        }
    }
    callWithDelay(0);
    setTimeout(function () {
        hitTimeout = true;
        stop(true);
    }, timeout);
    return stop;
}
/**
 * Stops the retry loop from repeating.
 * If the function is currently "in between" retries, it is invoked immediately
 * with the second parameter as "true". Otherwise, it will be invoked once more
 * after the current invocation finishes iff the current invocation would have
 * triggered another retry.
 */
function stop(id) {
    id(false);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @struct
 * @template T
 */
var NetworkRequest = /** @class */ (function () {
    function NetworkRequest(url, method, headers, body, successCodes, additionalRetryCodes, callback, errorCallback, timeout, progressCallback, pool) {
        var _this = this;
        this.pendingXhr_ = null;
        this.backoffId_ = null;
        this.resolve_ = null;
        this.reject_ = null;
        this.canceled_ = false;
        this.appDelete_ = false;
        this.url_ = url;
        this.method_ = method;
        this.headers_ = headers;
        this.body_ = body;
        this.successCodes_ = successCodes.slice();
        this.additionalRetryCodes_ = additionalRetryCodes.slice();
        this.callback_ = callback;
        this.errorCallback_ = errorCallback;
        this.progressCallback_ = progressCallback;
        this.timeout_ = timeout;
        this.pool_ = pool;
        this.promise_ = new Promise(function (resolve, reject) {
            _this.resolve_ = resolve;
            _this.reject_ = reject;
            _this.start_();
        });
    }
    /**
     * Actually starts the retry loop.
     */
    NetworkRequest.prototype.start_ = function () {
        var self = this;
        function doTheRequest(backoffCallback, canceled) {
            if (canceled) {
                backoffCallback(false, new RequestEndStatus(false, null, true));
                return;
            }
            var xhr = self.pool_.createXhrIo();
            self.pendingXhr_ = xhr;
            function progressListener(progressEvent) {
                var loaded = progressEvent.loaded;
                var total = progressEvent.lengthComputable ? progressEvent.total : -1;
                if (self.progressCallback_ !== null) {
                    self.progressCallback_(loaded, total);
                }
            }
            if (self.progressCallback_ !== null) {
                xhr.addUploadProgressListener(progressListener);
            }
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            xhr
                .send(self.url_, self.method_, self.body_, self.headers_)
                .then(function (xhr) {
                if (self.progressCallback_ !== null) {
                    xhr.removeUploadProgressListener(progressListener);
                }
                self.pendingXhr_ = null;
                xhr = xhr;
                var hitServer = xhr.getErrorCode() === ErrorCode.NO_ERROR;
                var status = xhr.getStatus();
                if (!hitServer || self.isRetryStatusCode_(status)) {
                    var wasCanceled = xhr.getErrorCode() === ErrorCode.ABORT;
                    backoffCallback(false, new RequestEndStatus(false, null, wasCanceled));
                    return;
                }
                var successCode = self.successCodes_.indexOf(status) !== -1;
                backoffCallback(true, new RequestEndStatus(successCode, xhr));
            });
        }
        /**
         * @param requestWentThrough True if the request eventually went
         *     through, false if it hit the retry limit or was canceled.
         */
        function backoffDone(requestWentThrough, status) {
            var resolve = self.resolve_;
            var reject = self.reject_;
            var xhr = status.xhr;
            if (status.wasSuccessCode) {
                try {
                    var result = self.callback_(xhr, xhr.getResponseText());
                    if (isJustDef(result)) {
                        resolve(result);
                    }
                    else {
                        resolve();
                    }
                }
                catch (e) {
                    reject(e);
                }
            }
            else {
                if (xhr !== null) {
                    var err = unknown();
                    err.setServerResponseProp(xhr.getResponseText());
                    if (self.errorCallback_) {
                        reject(self.errorCallback_(xhr, err));
                    }
                    else {
                        reject(err);
                    }
                }
                else {
                    if (status.canceled) {
                        var err = self.appDelete_ ? appDeleted() : canceled();
                        reject(err);
                    }
                    else {
                        var err = retryLimitExceeded();
                        reject(err);
                    }
                }
            }
        }
        if (this.canceled_) {
            backoffDone(false, new RequestEndStatus(false, null, true));
        }
        else {
            this.backoffId_ = start(doTheRequest, backoffDone, this.timeout_);
        }
    };
    /** @inheritDoc */
    NetworkRequest.prototype.getPromise = function () {
        return this.promise_;
    };
    /** @inheritDoc */
    NetworkRequest.prototype.cancel = function (appDelete) {
        this.canceled_ = true;
        this.appDelete_ = appDelete || false;
        if (this.backoffId_ !== null) {
            stop(this.backoffId_);
        }
        if (this.pendingXhr_ !== null) {
            this.pendingXhr_.abort();
        }
    };
    NetworkRequest.prototype.isRetryStatusCode_ = function (status) {
        // The codes for which to retry came from this page:
        // https://cloud.google.com/storage/docs/exponential-backoff
        var isFiveHundredCode = status >= 500 && status < 600;
        var extraRetryCodes = [
            // Request Timeout: web server didn't receive full request in time.
            408,
            // Too Many Requests: you're getting rate-limited, basically.
            429
        ];
        var isExtraRetryCode = extraRetryCodes.indexOf(status) !== -1;
        var isRequestSpecificRetryCode = this.additionalRetryCodes_.indexOf(status) !== -1;
        return isFiveHundredCode || isExtraRetryCode || isRequestSpecificRetryCode;
    };
    return NetworkRequest;
}());
/**
 * A collection of information about the result of a network request.
 * @param opt_canceled Defaults to false.
 * @struct
 */
var RequestEndStatus = /** @class */ (function () {
    function RequestEndStatus(wasSuccessCode, xhr, canceled) {
        this.wasSuccessCode = wasSuccessCode;
        this.xhr = xhr;
        this.canceled = !!canceled;
    }
    return RequestEndStatus;
}());
function addAuthHeader_(headers, authToken) {
    if (authToken !== null && authToken.length > 0) {
        headers['Authorization'] = 'Firebase ' + authToken;
    }
}
function addVersionHeader_(headers) {
    var version = typeof __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION : 'AppManager';
    headers['X-Firebase-Storage-Version'] = 'webjs/' + version;
}
/**
 * @template T
 */
function makeRequest(requestInfo, authToken, pool) {
    var queryPart = makeQueryString(requestInfo.urlParams);
    var url = requestInfo.url + queryPart;
    var headers = Object.assign({}, requestInfo.headers);
    addAuthHeader_(headers, authToken);
    addVersionHeader_(headers);
    return new NetworkRequest(url, requestInfo.method, headers, requestInfo.body, requestInfo.successCodes, requestInfo.additionalRetryCodes, requestInfo.handler, requestInfo.errorHandler, requestInfo.timeout, requestInfo.progressCallback, pool);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A service that provides firebaseStorage.Reference instances.
 * @param opt_url gs:// url to a custom Storage Bucket
 *
 * @struct
 */
var Service = /** @class */ (function () {
    function Service(app, pool, url) {
        this.bucket_ = null;
        function maker(authWrapper, loc) {
            return new Reference(authWrapper, loc);
        }
        this.authWrapper_ = new AuthWrapper(app, maker, makeRequest, this, pool);
        this.app_ = app;
        if (url != null) {
            this.bucket_ = Location.makeFromBucketSpec(url);
        }
        else {
            var authWrapperBucket = this.authWrapper_.bucket();
            if (authWrapperBucket != null) {
                this.bucket_ = new Location(authWrapperBucket, '');
            }
        }
        this.internals_ = new ServiceInternals(this);
    }
    /**
     * Returns a firebaseStorage.Reference for the given path in the default
     * bucket.
     */
    Service.prototype.ref = function (path) {
        function validator(path) {
            if (typeof path !== 'string') {
                throw 'Path is not a string.';
            }
            if (/^[A-Za-z]+:\/\//.test(path)) {
                throw 'Expected child path but got a URL, use refFromURL instead.';
            }
        }
        validate('ref', [stringSpec(validator, true)], arguments);
        if (this.bucket_ == null) {
            throw new Error('No Storage Bucket defined in Firebase Options.');
        }
        var ref = new Reference(this.authWrapper_, this.bucket_);
        if (path != null) {
            return ref.child(path);
        }
        else {
            return ref;
        }
    };
    /**
     * Returns a firebaseStorage.Reference object for the given absolute URL,
     * which must be a gs:// or http[s]:// URL.
     */
    Service.prototype.refFromURL = function (url) {
        function validator(p) {
            if (typeof p !== 'string') {
                throw 'Path is not a string.';
            }
            if (!/^[A-Za-z]+:\/\//.test(p)) {
                throw 'Expected full URL but got a child path, use ref instead.';
            }
            try {
                Location.makeFromUrl(p);
            }
            catch (e) {
                throw 'Expected valid full URL but got an invalid one.';
            }
        }
        validate('refFromURL', [stringSpec(validator, false)], arguments);
        return new Reference(this.authWrapper_, url);
    };
    Object.defineProperty(Service.prototype, "maxUploadRetryTime", {
        get: function () {
            return this.authWrapper_.maxUploadRetryTime();
        },
        enumerable: true,
        configurable: true
    });
    Service.prototype.setMaxUploadRetryTime = function (time) {
        validate('setMaxUploadRetryTime', [nonNegativeNumberSpec()], arguments);
        this.authWrapper_.setMaxUploadRetryTime(time);
    };
    Service.prototype.setMaxOperationRetryTime = function (time) {
        validate('setMaxOperationRetryTime', [nonNegativeNumberSpec()], arguments);
        this.authWrapper_.setMaxOperationRetryTime(time);
    };
    Object.defineProperty(Service.prototype, "app", {
        get: function () {
            return this.app_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Service.prototype, "INTERNAL", {
        get: function () {
            return this.internals_;
        },
        enumerable: true,
        configurable: true
    });
    return Service;
}());
/**
 * @struct
 */
var ServiceInternals = /** @class */ (function () {
    function ServiceInternals(service) {
        this.service_ = service;
    }
    /**
     * Called when the associated app is deleted.
     * @see {!fbs.AuthWrapper.prototype.deleteApp}
     */
    ServiceInternals.prototype.delete = function () {
        this.service_.authWrapper_.deleteApp();
        return Promise.resolve();
    };
    return ServiceInternals;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Type constant for Firebase Storage.
 */
var STORAGE_TYPE = 'storage';
function factory(app, unused, url) {
    return new Service(app, new XhrIoPool(), url);
}
function registerStorage(instance) {
    var namespaceExports = {
        // no-inline
        TaskState: TaskState,
        TaskEvent: TaskEvent,
        StringFormat: StringFormat,
        Storage: Service,
        Reference: Reference
    };
    instance.INTERNAL.registerService(STORAGE_TYPE, factory, namespaceExports, undefined, 
    // Allow multiple storage instances per app.
    true);
}
registerStorage(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a);


//# sourceMappingURL=index.esm.js.map


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var firebase = _interopDefault(__webpack_require__(50));
var tslib = __webpack_require__(51);
var util = __webpack_require__(66);
__webpack_require__(143);
var logger$1 = __webpack_require__(110);

var version = "0.2.25";

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var SDK_VERSION = version;
/** The prefix for start User Timing marks used for creating Traces. */
var TRACE_START_MARK_PREFIX = 'FB-PERF-TRACE-START';
/** The prefix for stop User Timing marks used for creating Traces. */
var TRACE_STOP_MARK_PREFIX = 'FB-PERF-TRACE-STOP';
/** The prefix for User Timing measure used for creating Traces. */
var TRACE_MEASURE_PREFIX = 'FB-PERF-TRACE-MEASURE';
/** The prefix for out of the box page load Trace name. */
var OOB_TRACE_PAGE_LOAD_PREFIX = '_wt_';
var FIRST_PAINT_COUNTER_NAME = '_fp';
var FIRST_CONTENTFUL_PAINT_COUNTER_NAME = '_fcp';
var FIRST_INPUT_DELAY_COUNTER_NAME = '_fid';
var CONFIG_LOCAL_STORAGE_KEY = '@firebase/performance/config';
var CONFIG_EXPIRY_LOCAL_STORAGE_KEY = '@firebase/performance/configexpire';
var SERVICE = 'performance';
var SERVICE_NAME = 'Performance';

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a;
var ERROR_DESCRIPTION_MAP = (_a = {},
    _a["trace started" /* TRACE_STARTED_BEFORE */] = 'Trace {$traceName} was started before.',
    _a["trace stopped" /* TRACE_STOPPED_BEFORE */] = 'Trace {$traceName} is not running.',
    _a["no window" /* NO_WINDOW */] = 'Window is not available.',
    _a["no app id" /* NO_APP_ID */] = 'App id is not available.',
    _a["no project id" /* NO_PROJECT_ID */] = 'Project id is not available.',
    _a["no api key" /* NO_API_KEY */] = 'Api key is not available.',
    _a["invalid cc log" /* INVALID_CC_LOG */] = 'Attempted to queue invalid cc event',
    _a["FB not default" /* FB_NOT_DEFAULT */] = 'Performance can only start when Firebase app instance is the default one.',
    _a["RC response not ok" /* RC_NOT_OK */] = 'RC response is not ok',
    _a["invalid attribute name" /* INVALID_ATTRIBUTE_NAME */] = 'Attribute name {$attributeName} is invalid.',
    _a["invalid attribute value" /* INVALID_ATTRIBUTE_VALUE */] = 'Attribute value {$attributeValue} is invalid.',
    _a["invalide custom metric name" /* INVALID_CUSTOM_METRIC_NAME */] = 'Custom metric name {$customMetricName} is invalid',
    _a);
var ERROR_FACTORY = new util.ErrorFactory(SERVICE, SERVICE_NAME, ERROR_DESCRIPTION_MAP);

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var apiInstance;
var windowInstance;
/**
 * This class holds a reference to various browser related objects injected by set methods.
 */
var Api = /** @class */ (function () {
    function Api(window) {
        if (!window) {
            throw ERROR_FACTORY.create("no window" /* NO_WINDOW */);
        }
        this.performance = window.performance;
        this.PerformanceObserver = window.PerformanceObserver;
        this.windowLocation = window.location;
        this.navigator = window.navigator;
        this.document = window.document;
        if (this.navigator && this.navigator.cookieEnabled) {
            // If user blocks cookies on the browser, accessing localStorage will throw an exception.
            this.localStorage = window.localStorage;
        }
        if (window.perfMetrics && window.perfMetrics.onFirstInputDelay) {
            this.onFirstInputDelay = window.perfMetrics.onFirstInputDelay;
        }
    }
    Api.prototype.getUrl = function () {
        // Do not capture the string query part of url.
        return this.windowLocation.href.split('?')[0];
    };
    Api.prototype.mark = function (name) {
        if (!this.performance || !this.performance.mark) {
            return;
        }
        this.performance.mark(name);
    };
    Api.prototype.measure = function (measureName, mark1, mark2) {
        if (!this.performance || !this.performance.measure) {
            return;
        }
        this.performance.measure(measureName, mark1, mark2);
    };
    Api.prototype.getEntriesByType = function (type) {
        if (!this.performance || !this.performance.getEntriesByType) {
            return [];
        }
        return this.performance.getEntriesByType(type);
    };
    Api.prototype.getEntriesByName = function (name) {
        if (!this.performance || !this.performance.getEntriesByName) {
            return [];
        }
        return this.performance.getEntriesByName(name);
    };
    Api.prototype.getTimeOrigin = function () {
        // Polyfill the time origin with performance.timing.navigationStart.
        return (this.performance &&
            (this.performance.timeOrigin || this.performance.timing.navigationStart));
    };
    Api.prototype.requiredApisAvailable = function () {
        if (fetch && Promise && this.navigator && this.navigator.cookieEnabled) {
            return true;
        }
        return false;
    };
    Api.prototype.setupObserver = function (entryType, callback) {
        if (!this.PerformanceObserver) {
            return;
        }
        var observer = new this.PerformanceObserver(function (list) {
            for (var _i = 0, _a = list.getEntries(); _i < _a.length; _i++) {
                var entry = _a[_i];
                // `entry` is a PerformanceEntry instance.
                callback(entry);
            }
        });
        // Start observing the entry types you care about.
        observer.observe({ entryTypes: [entryType] });
    };
    Api.getInstance = function () {
        if (apiInstance === undefined) {
            apiInstance = new Api(windowInstance);
        }
        return apiInstance;
    };
    return Api;
}());
function setupApi(window) {
    windowInstance = window;
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var settingsServiceInstance;
var SettingsService = /** @class */ (function () {
    function SettingsService() {
        // The variable which controls logging of automatic traces and HTTP/S network monitoring.
        this.instrumentationEnabled = true;
        // The variable which controls logging of custom traces.
        this.dataCollectionEnabled = true;
        // Configuration flags set through remote config.
        this.loggingEnabled = false;
        // Sampling rate between 0 and 1.
        this.tracesSamplingRate = 1;
        this.networkRequestsSamplingRate = 1;
        // Address of logging service.
        this.logEndPointUrl = 'https://firebaselogging.googleapis.com/v0cc/log?format=json_proto';
        this.logSource = 462;
        // Flags which control per session logging of traces and network requests.
        this.logTraceAfterSampling = false;
        this.logNetworkAfterSampling = false;
        // TTL of config retrieved from remote config in hours.
        this.configTimeToLive = 12;
    }
    SettingsService.prototype.getAppId = function () {
        var appId = this.firebaseAppInstance &&
            this.firebaseAppInstance.options &&
            this.firebaseAppInstance.options.appId;
        if (!appId) {
            throw ERROR_FACTORY.create("no app id" /* NO_APP_ID */);
        }
        return appId;
    };
    SettingsService.prototype.getProjectId = function () {
        var projectId = this.firebaseAppInstance &&
            this.firebaseAppInstance.options &&
            this.firebaseAppInstance.options.projectId;
        if (!projectId) {
            throw ERROR_FACTORY.create("no project id" /* NO_PROJECT_ID */);
        }
        return projectId;
    };
    SettingsService.prototype.getApiKey = function () {
        var apiKey = this.firebaseAppInstance &&
            this.firebaseAppInstance.options &&
            this.firebaseAppInstance.options.apiKey;
        if (!apiKey) {
            throw ERROR_FACTORY.create("no api key" /* NO_API_KEY */);
        }
        return apiKey;
    };
    SettingsService.getInstance = function () {
        if (settingsServiceInstance === undefined) {
            settingsServiceInstance = new SettingsService();
        }
        return settingsServiceInstance;
    };
    return SettingsService;
}());

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var iid;
function getIidPromise() {
    var iidPromise = SettingsService.getInstance()
        .firebaseAppInstance.installations()
        .getId();
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    iidPromise.then(function (iidVal) {
        iid = iidVal;
    });
    return iidPromise;
}
// This method should be used after the iid is retrieved by getIidPromise method.
function getIid() {
    return iid;
}
function getAuthTokenPromise() {
    var authTokenPromise = SettingsService.getInstance()
        .firebaseAppInstance.installations()
        .getToken();
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    authTokenPromise.then(function (authTokenVal) {
    });
    return authTokenPromise;
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var VisibilityState;
(function (VisibilityState) {
    VisibilityState[VisibilityState["UNKNOWN"] = 0] = "UNKNOWN";
    VisibilityState[VisibilityState["VISIBLE"] = 1] = "VISIBLE";
    VisibilityState[VisibilityState["HIDDEN"] = 2] = "HIDDEN";
    VisibilityState[VisibilityState["PRERENDER"] = 3] = "PRERENDER";
    VisibilityState[VisibilityState["UNLOADED"] = 4] = "UNLOADED";
})(VisibilityState || (VisibilityState = {}));
var RESERVED_ATTRIBUTE_PREFIXES = ['firebase_', 'google_', 'ga_'];
var ATTRIBUTE_FORMAT_REGEX = new RegExp('^[a-zA-Z]\\w*$');
var MAX_ATTRIBUTE_NAME_LENGTH = 40;
var MAX_ATTRIBUTE_VALUE_LENGTH = 100;
function getServiceWorkerStatus() {
    var navigator = Api.getInstance().navigator;
    if ('serviceWorker' in navigator) {
        if (navigator.serviceWorker.controller) {
            return 2 /* CONTROLLED */;
        }
        else {
            return 3 /* UNCONTROLLED */;
        }
    }
    else {
        return 1 /* UNSUPPORTED */;
    }
}
function getVisibilityState() {
    var document = Api.getInstance().document;
    var visibilityState = document.visibilityState;
    switch (visibilityState) {
        case 'visible':
            return VisibilityState.VISIBLE;
        case 'hidden':
            return VisibilityState.HIDDEN;
        case 'prerender':
            return VisibilityState.PRERENDER;
        default:
            return VisibilityState.UNKNOWN;
    }
}
function getEffectiveConnectionType() {
    var navigator = Api.getInstance().navigator;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var navigatorConnection = navigator.connection;
    var effectiveType = navigatorConnection && navigatorConnection.effectiveType;
    switch (effectiveType) {
        case 'slow-2g':
            return 1 /* CONNECTION_SLOW_2G */;
        case '2g':
            return 2 /* CONNECTION_2G */;
        case '3g':
            return 3 /* CONNECTION_3G */;
        case '4g':
            return 4 /* CONNECTION_4G */;
        default:
            return 0 /* UNKNOWN */;
    }
}
function isValidCustomAttributeName(name) {
    if (name.length === 0 || name.length > MAX_ATTRIBUTE_NAME_LENGTH) {
        return false;
    }
    var matchesReservedPrefix = RESERVED_ATTRIBUTE_PREFIXES.some(function (prefix) {
        return name.startsWith(prefix);
    });
    return !matchesReservedPrefix && !!name.match(ATTRIBUTE_FORMAT_REGEX);
}
function isValidCustomAttributeValue(value) {
    return value.length !== 0 && value.length <= MAX_ATTRIBUTE_VALUE_LENGTH;
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var consoleLogger = new logger$1.Logger(SERVICE_NAME);
consoleLogger.logLevel = logger$1.LogLevel.INFO;

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var REMOTE_CONFIG_SDK_VERSION = '0.0.1';
// These values will be used if the remote config object is successfully
// retrieved, but the template does not have these fields.
var SECONDARY_CONFIGS = {
    loggingEnabled: true
};
var FIS_AUTH_PREFIX = 'FIREBASE_INSTALLATIONS_AUTH';
function getConfig(iid) {
    var config = getStoredConfig();
    if (config) {
        processConfig(config);
        return Promise.resolve();
    }
    return getRemoteConfig(iid)
        .then(function (config) { return processConfig(config); })
        .then(function (config) { return storeConfig(config); }, 
    /** Do nothing for error, use defaults set in settings service. */ function () { });
}
function getStoredConfig() {
    var localStorage = Api.getInstance().localStorage;
    var expiryString = localStorage.getItem(CONFIG_EXPIRY_LOCAL_STORAGE_KEY);
    if (!expiryString || !configValid(expiryString)) {
        return;
    }
    var configStringified = localStorage.getItem(CONFIG_LOCAL_STORAGE_KEY);
    if (!configStringified) {
        return;
    }
    try {
        var configResponse = JSON.parse(configStringified);
        return configResponse;
    }
    catch (_a) {
        return;
    }
}
function storeConfig(config) {
    if (!config) {
        return;
    }
    var localStorage = Api.getInstance().localStorage;
    localStorage.setItem(CONFIG_LOCAL_STORAGE_KEY, JSON.stringify(config));
    localStorage.setItem(CONFIG_EXPIRY_LOCAL_STORAGE_KEY, String(Date.now() +
        SettingsService.getInstance().configTimeToLive * 60 * 60 * 1000));
}
var COULD_NOT_GET_CONFIG_MSG = 'Could not fetch config, will use default configs';
function getRemoteConfig(iid) {
    // Perf needs auth token only to retrieve remote config.
    return getAuthTokenPromise()
        .then(function (authToken) {
        var projectId = SettingsService.getInstance().getProjectId();
        var configEndPoint = "https://firebaseremoteconfig.googleapis.com/v1/projects/" + projectId + "/namespaces/fireperf:fetch?key=" + SettingsService.getInstance().getApiKey();
        var request = new Request(configEndPoint, {
            method: 'POST',
            headers: {
                Authorization: FIS_AUTH_PREFIX + " " + authToken
            },
            /* eslint-disable camelcase */
            body: JSON.stringify({
                app_instance_id: iid,
                app_instance_id_token: authToken,
                app_id: SettingsService.getInstance().getAppId(),
                app_version: SDK_VERSION,
                sdk_version: REMOTE_CONFIG_SDK_VERSION
            })
            /* eslint-enable camelcase */
        });
        return fetch(request).then(function (response) {
            if (response.ok) {
                return response.json();
            }
            // In case response is not ok. This will be caught by catch.
            throw ERROR_FACTORY.create("RC response not ok" /* RC_NOT_OK */);
        });
    })
        .catch(function () {
        consoleLogger.info(COULD_NOT_GET_CONFIG_MSG);
        return undefined;
    });
}
/**
 * Processes config coming either from calling RC or from local storage.
 * This method only runs if call is successful or config in storage
 * is valie.
 */
function processConfig(config) {
    if (!config) {
        return config;
    }
    var settingsServiceInstance = SettingsService.getInstance();
    var entries = config.entries || {};
    if (entries.fpr_enabled !== undefined) {
        // TODO: Change the assignment of loggingEnabled once the received type is known.
        settingsServiceInstance.loggingEnabled =
            String(entries.fpr_enabled) === 'true';
    }
    else {
        // Config retrieved successfully, but there is no fpr_enabled in template.
        // Use secondary configs value.
        settingsServiceInstance.loggingEnabled = SECONDARY_CONFIGS.loggingEnabled;
    }
    if (entries.fpr_log_source) {
        settingsServiceInstance.logSource = Number(entries.fpr_log_source);
    }
    if (entries.fpr_log_endpoint_url) {
        settingsServiceInstance.logEndPointUrl = entries.fpr_log_endpoint_url;
    }
    if (entries.fpr_vc_network_request_sampling_rate !== undefined) {
        settingsServiceInstance.networkRequestsSamplingRate = Number(entries.fpr_vc_network_request_sampling_rate);
    }
    if (entries.fpr_vc_trace_sampling_rate !== undefined) {
        settingsServiceInstance.tracesSamplingRate = Number(entries.fpr_vc_trace_sampling_rate);
    }
    // Set the per session trace and network logging flags.
    settingsServiceInstance.logTraceAfterSampling = shouldLogAfterSampling(settingsServiceInstance.tracesSamplingRate);
    settingsServiceInstance.logNetworkAfterSampling = shouldLogAfterSampling(settingsServiceInstance.networkRequestsSamplingRate);
    return config;
}
function configValid(expiry) {
    return Number(expiry) > Date.now();
}
function shouldLogAfterSampling(samplingRate) {
    return Math.random() <= samplingRate;
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var initializationStatus = 1 /* notInitialized */;
var initializationPromise;
function getInitializationPromise() {
    initializationStatus = 2 /* initializationPending */;
    initializationPromise = initializationPromise || initializePerf();
    return initializationPromise;
}
function isPerfInitialized() {
    return initializationStatus === 3 /* initialized */;
}
function initializePerf() {
    return getDocumentReadyComplete()
        .then(function () { return getIidPromise(); })
        .then(function (iid) { return getConfig(iid); })
        .then(function () { return changeInitializationStatus(); }, function () { return changeInitializationStatus(); });
}
/**
 * Returns a promise which resolves whenever the document readystate is complete or
 * immediately if it is called after page load complete.
 */
function getDocumentReadyComplete() {
    var document = Api.getInstance().document;
    return new Promise(function (resolve) {
        if (document && document.readyState !== 'complete') {
            var handler_1 = function () {
                if (document.readyState === 'complete') {
                    document.removeEventListener('readystatechange', handler_1);
                    resolve();
                }
            };
            document.addEventListener('readystatechange', handler_1);
        }
        else {
            resolve();
        }
    });
}
function changeInitializationStatus() {
    initializationStatus = 3 /* initialized */;
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DEFAULT_SEND_INTERVAL_MS = 10 * 1000;
var INITIAL_SEND_TIME_DELAY_MS = 5.5 * 1000;
// If end point does not work, the call will be tried for these many times.
var DEFAULT_REMAINING_TRIES = 3;
var remainingTries = DEFAULT_REMAINING_TRIES;
/* eslint-enable camelcase */
var queue = [];
function processQueue(timeOffset) {
    setTimeout(function () {
        // If there is no remainingTries left, stop retrying.
        if (remainingTries === 0) {
            return;
        }
        // If there are no events to process, wait for DEFAULT_SEND_INTERVAL_MS and try again.
        if (!queue.length) {
            return processQueue(DEFAULT_SEND_INTERVAL_MS);
        }
        // Capture a snapshot of the queue and empty the "official queue".
        var staged = tslib.__spreadArrays(queue);
        queue = [];
        /* eslint-disable camelcase */
        // We will pass the JSON serialized event to the backend.
        var log_event = staged.map(function (evt) { return ({
            source_extension_json: evt.message,
            event_time_ms: String(evt.eventTime)
        }); });
        var data = {
            request_time_ms: String(Date.now()),
            client_info: {
                client_type: 1,
                js_client_info: {}
            },
            log_source: SettingsService.getInstance().logSource,
            log_event: log_event
        };
        /* eslint-enable camelcase */
        fetch(SettingsService.getInstance().logEndPointUrl, {
            method: 'POST',
            body: JSON.stringify(data)
        })
            .then(function (res) {
            if (!res.ok) {
                consoleLogger.info('Call to Firebase backend failed.');
            }
            return res.json();
        })
            .then(function (res) {
            var wait = Number(res.next_request_wait_millis);
            // Find the next call wait time from the response.
            var requestOffset = isNaN(wait)
                ? DEFAULT_SEND_INTERVAL_MS
                : Math.max(DEFAULT_SEND_INTERVAL_MS, wait);
            remainingTries = DEFAULT_REMAINING_TRIES;
            // Schedule the next process.
            processQueue(requestOffset);
        })
            .catch(function () {
            /**
             * If the request fails for some reason, add the events that were attempted
             * back to the primary queue to retry later.
             */
            queue = tslib.__spreadArrays(staged, queue);
            remainingTries--;
            consoleLogger.info("Tries left: " + remainingTries + ".");
            processQueue(DEFAULT_SEND_INTERVAL_MS);
        });
    }, timeOffset);
}
processQueue(INITIAL_SEND_TIME_DELAY_MS);
function addToQueue(evt) {
    if (!evt.eventTime || !evt.message) {
        throw ERROR_FACTORY.create("invalid cc log" /* INVALID_CC_LOG */);
    }
    // Add the new event to the queue.
    queue = tslib.__spreadArrays(queue, [evt]);
}
/** Log handler for cc service to send the performance logs to the server. */
function ccHandler(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
serializer) {
    // The underscores for loggerInstance and level parameters are added to avoid the
    // noUnusedParameters related error.
    return function (_loggerInstance, _level) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        var message = serializer.apply(void 0, args);
        addToQueue({
            message: message,
            eventTime: Date.now()
        });
    };
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-enble camelcase */
var logger;
// This method is not called before initialization.
function getLogger() {
    if (logger) {
        return logger;
    }
    var ccLogger = ccHandler(serializer);
    logger = new logger$1.Logger('@firebase/performance/cc');
    logger.logHandler = ccLogger;
    return logger;
}
function logTrace(trace) {
    var settingsService = SettingsService.getInstance();
    // Do not log if trace is auto generated and instrumentation is disabled.
    if (!settingsService.instrumentationEnabled && trace.isAuto) {
        return;
    }
    // Do not log if trace is custom and data collection is disabled.
    if (!settingsService.dataCollectionEnabled && !trace.isAuto) {
        return;
    }
    // Do not log if required apis are not available.
    if (!Api.getInstance().requiredApisAvailable()) {
        return;
    }
    // Only log the page load auto traces if page is visible.
    if (trace.isAuto && getVisibilityState() !== VisibilityState.VISIBLE) {
        return;
    }
    if (!settingsService.loggingEnabled ||
        !settingsService.logTraceAfterSampling) {
        return;
    }
    if (isPerfInitialized()) {
        sendTraceLog(trace);
    }
    else {
        // Custom traces can be used before the initialization but logging
        // should wait until after.
        getInitializationPromise().then(function () { return sendTraceLog(trace); }, function () { return sendTraceLog(trace); });
    }
}
function sendTraceLog(trace) {
    if (getIid()) {
        setTimeout(function () { return getLogger().log(trace, 1 /* Trace */); }, 0);
    }
}
function logNetworkRequest(networkRequest) {
    var settingsService = SettingsService.getInstance();
    // Do not log network requests if instrumentation is disabled.
    if (!settingsService.instrumentationEnabled) {
        return;
    }
    // Do not log the js sdk's call to cc service to avoid unnecessary cycle.
    if (networkRequest.url === settingsService.logEndPointUrl.split('?')[0]) {
        return;
    }
    if (!settingsService.loggingEnabled ||
        !settingsService.logNetworkAfterSampling) {
        return;
    }
    setTimeout(function () { return getLogger().log(networkRequest, 0 /* NetworkRequest */); }, 0);
}
function serializer(resource, resourceType) {
    if (resourceType === 0 /* NetworkRequest */) {
        return serializeNetworkRequest(resource);
    }
    return serializeTrace(resource);
}
function serializeNetworkRequest(networkRequest) {
    var networkRequestMetric = {
        url: networkRequest.url,
        http_method: networkRequest.httpMethod || 0,
        http_response_code: 200,
        response_payload_bytes: networkRequest.responsePayloadBytes,
        client_start_time_us: networkRequest.startTimeUs,
        time_to_response_initiated_us: networkRequest.timeToResponseInitiatedUs,
        time_to_response_completed_us: networkRequest.timeToResponseCompletedUs
    };
    var perfMetric = {
        application_info: getApplicationInfo(),
        network_request_metric: networkRequestMetric
    };
    return JSON.stringify(perfMetric);
}
function serializeTrace(trace) {
    var traceMetric = {
        name: trace.name,
        is_auto: trace.isAuto,
        client_start_time_us: trace.startTimeUs,
        duration_us: trace.durationUs
    };
    if (Object.keys(trace.counters).length !== 0) {
        traceMetric.counters = convertToKeyValueArray(trace.counters);
    }
    var customAttributes = trace.getAttributes();
    if (Object.keys(customAttributes).length !== 0) {
        traceMetric.custom_attributes = convertToKeyValueArray(customAttributes);
    }
    var perfMetric = {
        application_info: getApplicationInfo(),
        trace_metric: traceMetric
    };
    return JSON.stringify(perfMetric);
}
function getApplicationInfo() {
    return {
        google_app_id: SettingsService.getInstance().getAppId(),
        app_instance_id: getIid(),
        web_app_info: {
            sdk_version: SDK_VERSION,
            page_url: Api.getInstance().getUrl(),
            service_worker_status: getServiceWorkerStatus(),
            visibility_state: getVisibilityState(),
            effective_connection_type: getEffectiveConnectionType()
        },
        application_process_state: 0
    };
}
function convertToKeyValueArray(obj) {
    var keys = Object.keys(obj);
    return keys.map(function (key) { return ({ key: key, value: obj[key] }); });
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var MAX_METRIC_NAME_LENGTH = 100;
var RESERVED_AUTO_PREFIX = '_';
var oobMetrics = [
    FIRST_PAINT_COUNTER_NAME,
    FIRST_CONTENTFUL_PAINT_COUNTER_NAME,
    FIRST_INPUT_DELAY_COUNTER_NAME
];
/**
 * Returns true if the metric is custom and does not start with reserved prefix, or if
 * the metric is one of out of the box page load trace metrics.
 */
function isValidMetricName(name, traceName) {
    if (name.length === 0 || name.length > MAX_METRIC_NAME_LENGTH) {
        return false;
    }
    return ((traceName &&
        traceName.startsWith(OOB_TRACE_PAGE_LOAD_PREFIX) &&
        oobMetrics.indexOf(name) > -1) ||
        !name.startsWith(RESERVED_AUTO_PREFIX));
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Trace = /** @class */ (function () {
    /**
     * @param name The name of the trace.
     * @param isAuto If the trace is auto-instrumented.
     * @param traceMeasureName The name of the measure marker in user timing specification. This field
     * is only set when the trace is built for logging when the user directly uses the user timing
     * api (performance.mark and performance.measure).
     */
    function Trace(name, isAuto, traceMeasureName) {
        if (isAuto === void 0) { isAuto = false; }
        this.name = name;
        this.isAuto = isAuto;
        this.state = 1 /* UNINITIALIZED */;
        this.customAttributes = {};
        this.counters = {};
        this.api = Api.getInstance();
        this.randomId = Math.floor(Math.random() * 1000000);
        if (!this.isAuto) {
            this.traceStartMark = TRACE_START_MARK_PREFIX + "-" + this.randomId + "-" + this.name;
            this.traceStopMark = TRACE_STOP_MARK_PREFIX + "-" + this.randomId + "-" + this.name;
            this.traceMeasure =
                traceMeasureName ||
                    TRACE_MEASURE_PREFIX + "-" + this.randomId + "-" + this.name;
            if (traceMeasureName) {
                // For the case of direct user timing traces, no start stop will happen. The measure object
                // is already available.
                this.calculateTraceMetrics();
            }
        }
    }
    /**
     * Starts a trace. The measurement of the duration starts at this point.
     */
    Trace.prototype.start = function () {
        if (this.state !== 1 /* UNINITIALIZED */) {
            throw ERROR_FACTORY.create("trace started" /* TRACE_STARTED_BEFORE */, {
                traceName: this.name
            });
        }
        this.api.mark(this.traceStartMark);
        this.state = 2 /* RUNNING */;
    };
    /**
     * Stops the trace. The measurement of the duration of the trace stops at this point and trace
     * is logged.
     */
    Trace.prototype.stop = function () {
        if (this.state !== 2 /* RUNNING */) {
            throw ERROR_FACTORY.create("trace stopped" /* TRACE_STOPPED_BEFORE */, {
                traceName: this.name
            });
        }
        this.state = 3 /* TERMINATED */;
        this.api.mark(this.traceStopMark);
        this.api.measure(this.traceMeasure, this.traceStartMark, this.traceStopMark);
        this.calculateTraceMetrics();
        logTrace(this);
    };
    /**
     * Records a trace with predetermined values. If this method is used a trace is created and logged
     * directly. No need to use start and stop methods.
     * @param startTime Trace start time since epoch in millisec
     * @param duration The duraction of the trace in millisec
     * @param options An object which can optionally hold maps of custom metrics and custom attributes
     */
    Trace.prototype.record = function (startTime, duration, options) {
        this.durationUs = Math.floor(duration * 1000);
        this.startTimeUs = Math.floor(startTime * 1000);
        if (options && options.attributes) {
            this.customAttributes = tslib.__assign({}, options.attributes);
        }
        if (options && options.metrics) {
            for (var _i = 0, _a = Object.keys(options.metrics); _i < _a.length; _i++) {
                var metric = _a[_i];
                if (!isNaN(Number(options.metrics[metric]))) {
                    this.counters[metric] = Number(Math.floor(options.metrics[metric]));
                }
            }
        }
        logTrace(this);
    };
    /**
     * Increments a custom metric by a certain number or 1 if number not specified. Will create a new
     * custom metric if one with the given name does not exist.
     * @param counter Name of the custom metric
     * @param num Increment by value
     */
    Trace.prototype.incrementMetric = function (counter, num) {
        if (num === void 0) { num = 1; }
        if (this.counters[counter] === undefined) {
            this.putMetric(counter, 0);
        }
        this.counters[counter] += num;
    };
    /**
     * Sets a custom metric to a specified value. Will create a new custom metric if one with the
     * given name does not exist.
     * @param counter Name of the custom metric
     * @param num Set custom metric to this value
     */
    Trace.prototype.putMetric = function (counter, num) {
        if (isValidMetricName(counter, this.name)) {
            this.counters[counter] = num;
        }
        else {
            throw ERROR_FACTORY.create("invalide custom metric name" /* INVALID_CUSTOM_METRIC_NAME */, {
                customMetricName: counter
            });
        }
    };
    /**
     * Returns the value of the custom metric by that name. If a custom metric with that name does
     * not exist will return zero.
     * @param counter
     */
    Trace.prototype.getMetric = function (counter) {
        return this.counters[counter] || 0;
    };
    /**
     * Sets a custom attribute of a trace to a certain value.
     * @param attr
     * @param value
     */
    Trace.prototype.putAttribute = function (attr, value) {
        var isValidName = isValidCustomAttributeName(attr);
        var isValidValue = isValidCustomAttributeValue(value);
        if (isValidName && isValidValue) {
            this.customAttributes[attr] = value;
            return;
        }
        // Throw appropriate error when the attribute name or value is invalid.
        if (!isValidName) {
            throw ERROR_FACTORY.create("invalid attribute name" /* INVALID_ATTRIBUTE_NAME */, {
                attributeName: attr
            });
        }
        if (!isValidValue) {
            throw ERROR_FACTORY.create("invalid attribute value" /* INVALID_ATTRIBUTE_VALUE */, {
                attributeValue: value
            });
        }
    };
    /**
     * Retrieves the value a custom attribute of a trace is set to.
     * @param attr
     */
    Trace.prototype.getAttribute = function (attr) {
        return this.customAttributes[attr];
    };
    Trace.prototype.removeAttribute = function (attr) {
        if (this.customAttributes[attr] === undefined) {
            return;
        }
        delete this.customAttributes[attr];
    };
    Trace.prototype.getAttributes = function () {
        return tslib.__assign({}, this.customAttributes);
    };
    Trace.prototype.setStartTime = function (startTime) {
        this.startTimeUs = startTime;
    };
    Trace.prototype.setDuration = function (duration) {
        this.durationUs = duration;
    };
    /**
     * Calculates and assigns the duration and start time of the trace using the measure performance
     * entry.
     */
    Trace.prototype.calculateTraceMetrics = function () {
        var perfMeasureEntries = this.api.getEntriesByName(this.traceMeasure);
        var perfMeasureEntry = perfMeasureEntries && perfMeasureEntries[0];
        if (perfMeasureEntry) {
            this.durationUs = Math.floor(perfMeasureEntry.duration * 1000);
            this.startTimeUs = Math.floor((perfMeasureEntry.startTime + this.api.getTimeOrigin()) * 1000);
        }
    };
    /**
     * @param navigationTimings A single element array which contains the navigationTIming object of
     * the page load
     * @param paintTimings A array which contains paintTiming object of the page load
     * @param firstInputDelay First input delay in millisec
     */
    Trace.createOobTrace = function (navigationTimings, paintTimings, firstInputDelay) {
        var route = Api.getInstance().getUrl();
        if (!route) {
            return;
        }
        var trace = new Trace(OOB_TRACE_PAGE_LOAD_PREFIX + route, true);
        var timeOriginUs = Math.floor(Api.getInstance().getTimeOrigin() * 1000);
        trace.setStartTime(timeOriginUs);
        // navigationTimings includes only one element.
        if (navigationTimings && navigationTimings[0]) {
            trace.setDuration(Math.floor(navigationTimings[0].duration * 1000));
            trace.putMetric('domInteractive', Math.floor(navigationTimings[0].domInteractive * 1000));
            trace.putMetric('domContentLoadedEventEnd', Math.floor(navigationTimings[0].domContentLoadedEventEnd * 1000));
            trace.putMetric('loadEventEnd', Math.floor(navigationTimings[0].loadEventEnd * 1000));
        }
        var FIRST_PAINT = 'first-paint';
        var FIRST_CONTENTFUL_PAINT = 'first-contentful-paint';
        if (paintTimings) {
            var firstPaint = paintTimings.find(function (paintObject) { return paintObject.name === FIRST_PAINT; });
            if (firstPaint && firstPaint.startTime) {
                trace.putMetric(FIRST_PAINT_COUNTER_NAME, Math.floor(firstPaint.startTime * 1000));
            }
            var firstContentfulPaint = paintTimings.find(function (paintObject) { return paintObject.name === FIRST_CONTENTFUL_PAINT; });
            if (firstContentfulPaint && firstContentfulPaint.startTime) {
                trace.putMetric(FIRST_CONTENTFUL_PAINT_COUNTER_NAME, Math.floor(firstContentfulPaint.startTime * 1000));
            }
            if (firstInputDelay) {
                trace.putMetric(FIRST_INPUT_DELAY_COUNTER_NAME, Math.floor(firstInputDelay * 1000));
            }
        }
        logTrace(trace);
    };
    Trace.createUserTimingTrace = function (measureName) {
        var trace = new Trace(measureName, false, measureName);
        logTrace(trace);
    };
    return Trace;
}());

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function createNetworkRequestEntry(entry) {
    var performanceEntry = entry;
    if (!performanceEntry || performanceEntry.responseStart === undefined) {
        return;
    }
    var timeOrigin = Api.getInstance().getTimeOrigin();
    var startTimeUs = Math.floor((performanceEntry.startTime + timeOrigin) * 1000);
    var timeToResponseInitiatedUs = performanceEntry.responseStart
        ? Math.floor((performanceEntry.responseStart - performanceEntry.startTime) * 1000)
        : undefined;
    var timeToResponseCompletedUs = Math.floor((performanceEntry.responseEnd - performanceEntry.startTime) * 1000);
    // Remove the query params from logged network request url.
    var url = performanceEntry.name && performanceEntry.name.split('?')[0];
    var networkRequest = {
        url: url,
        responsePayloadBytes: performanceEntry.transferSize,
        startTimeUs: startTimeUs,
        timeToResponseInitiatedUs: timeToResponseInitiatedUs,
        timeToResponseCompletedUs: timeToResponseCompletedUs
    };
    logNetworkRequest(networkRequest);
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var FID_WAIT_TIME_MS = 5000;
function setupOobResources() {
    // Do not initialize unless iid is available.
    if (!getIid()) {
        return;
    }
    // The load event might not have fired yet, and that means performance navigation timing
    // object has a duration of 0. The setup should run after all current tasks in js queue.
    setTimeout(function () { return setupOobTraces(); }, 0);
    setTimeout(function () { return setupNetworkRequests(); }, 0);
    setTimeout(function () { return setupUserTimingTraces(); }, 0);
}
function setupNetworkRequests() {
    var api = Api.getInstance();
    var resources = api.getEntriesByType('resource');
    for (var _i = 0, resources_1 = resources; _i < resources_1.length; _i++) {
        var resource = resources_1[_i];
        createNetworkRequestEntry(resource);
    }
    api.setupObserver('resource', createNetworkRequestEntry);
}
function setupOobTraces() {
    var api = Api.getInstance();
    var navigationTimings = api.getEntriesByType('navigation');
    var paintTimings = api.getEntriesByType('paint');
    // If First Input Desly polyfill is added to the page, report the fid value.
    // https://github.com/GoogleChromeLabs/first-input-delay
    if (api.onFirstInputDelay) {
        // If the fid call back is not called for certain time, continue without it.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var timeoutId_1 = setTimeout(function () {
            Trace.createOobTrace(navigationTimings, paintTimings);
            timeoutId_1 = undefined;
        }, FID_WAIT_TIME_MS);
        api.onFirstInputDelay(function (fid) {
            if (timeoutId_1) {
                clearTimeout(timeoutId_1);
                Trace.createOobTrace(navigationTimings, paintTimings, fid);
            }
        });
    }
    else {
        Trace.createOobTrace(navigationTimings, paintTimings);
    }
}
function setupUserTimingTraces() {
    var api = Api.getInstance();
    // Run through the measure performance entries collected up to this point.
    var measures = api.getEntriesByType('measure');
    for (var _i = 0, measures_1 = measures; _i < measures_1.length; _i++) {
        var measure = measures_1[_i];
        createUserTimingTrace(measure);
    }
    // Setup an observer to capture the measures from this point on.
    api.setupObserver('measure', createUserTimingTrace);
}
function createUserTimingTrace(measure) {
    var measureName = measure.name;
    // Do not create a trace, if the user timing marks and measures are created by the sdk itself.
    if (measureName.substring(0, TRACE_MEASURE_PREFIX.length) ===
        TRACE_MEASURE_PREFIX) {
        return;
    }
    Trace.createUserTimingTrace(measureName);
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var PerformanceController = /** @class */ (function () {
    function PerformanceController(app) {
        this.app = app;
        if (Api.getInstance().requiredApisAvailable()) {
            getInitializationPromise().then(setupOobResources, setupOobResources);
        }
        else {
            consoleLogger.info('Firebase Performance cannot start if browser does not support fetch and Promise or cookie is disabled.');
        }
    }
    PerformanceController.prototype.trace = function (name) {
        return new Trace(name);
    };
    Object.defineProperty(PerformanceController.prototype, "instrumentationEnabled", {
        get: function () {
            return SettingsService.getInstance().instrumentationEnabled;
        },
        set: function (val) {
            SettingsService.getInstance().instrumentationEnabled = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PerformanceController.prototype, "dataCollectionEnabled", {
        get: function () {
            return SettingsService.getInstance().dataCollectionEnabled;
        },
        set: function (val) {
            SettingsService.getInstance().dataCollectionEnabled = val;
        },
        enumerable: true,
        configurable: true
    });
    return PerformanceController;
}());

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DEFAULT_ENTRY_NAME = '[DEFAULT]';
function registerPerformance(instance) {
    var factoryMethod = function (app) {
        if (app.name !== DEFAULT_ENTRY_NAME) {
            throw ERROR_FACTORY.create("FB not default" /* FB_NOT_DEFAULT */);
        }
        if (typeof window === 'undefined') {
            throw ERROR_FACTORY.create("no window" /* NO_WINDOW */);
        }
        setupApi(window);
        SettingsService.getInstance().firebaseAppInstance = app;
        return new PerformanceController(app);
    };
    // Register performance with firebase-app.
    var namespaceExports = {};
    instance.INTERNAL.registerService('performance', factoryMethod, namespaceExports);
}
registerPerformance(firebase);

exports.registerPerformance = registerPerformance;
//# sourceMappingURL=index.cjs.js.map


/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "factory", function() { return factory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerAnalytics", function() { return registerAnalytics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetGlobalVars", function() { return resetGlobalVars; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "settings", function() { return settings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tslib__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_installations__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firebase_util__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firebase_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__firebase_util__);





/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ANALYTICS_ID_FIELD = 'measurementId';
// Key to attach FID to in gtag params.
var GA_FID_KEY = 'firebase_id';
var ORIGIN_KEY = 'origin';
var GTAG_URL = 'https://www.googletagmanager.com/gtag/js';
var GtagCommand;
(function (GtagCommand) {
    GtagCommand["EVENT"] = "event";
    GtagCommand["SET"] = "set";
    GtagCommand["CONFIG"] = "config";
})(GtagCommand || (GtagCommand = {}));
/*
 * Officially recommended event names for gtag.js
 * Any other string is also allowed.
 */
var EventName;
(function (EventName) {
    EventName["ADD_PAYMENT_INFO"] = "add_payment_info";
    EventName["ADD_TO_CART"] = "add_to_cart";
    EventName["ADD_TO_WISHLIST"] = "add_to_wishlist";
    EventName["BEGIN_CHECKOUT"] = "begin_checkout";
    EventName["CHECKOUT_PROGRESS"] = "checkout_progress";
    EventName["EXCEPTION"] = "exception";
    EventName["GENERATE_LEAD"] = "generate_lead";
    EventName["LOGIN"] = "login";
    EventName["PAGE_VIEW"] = "page_view";
    EventName["PURCHASE"] = "purchase";
    EventName["REFUND"] = "refund";
    EventName["REMOVE_FROM_CART"] = "remove_from_cart";
    EventName["SCREEN_VIEW"] = "screen_view";
    EventName["SEARCH"] = "search";
    EventName["SELECT_CONTENT"] = "select_content";
    EventName["SET_CHECKOUT_OPTION"] = "set_checkout_option";
    EventName["SHARE"] = "share";
    EventName["SIGN_UP"] = "sign_up";
    EventName["TIMING_COMPLETE"] = "timing_complete";
    EventName["VIEW_ITEM"] = "view_item";
    EventName["VIEW_ITEM_LIST"] = "view_item_list";
    EventName["VIEW_PROMOTION"] = "view_promotion";
    EventName["VIEW_SEARCH_RESULTS"] = "view_search_results";
})(EventName || (EventName = {}));

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Logs an analytics event through the Firebase SDK.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param eventName Google Analytics event name, choose from standard list or use a custom string.
 * @param eventParams Analytics event parameters.
 */
function logEvent(gtagFunction, analyticsId, eventName, eventParams, options) {
    var params = eventParams || {};
    if (!options || !options.global) {
        params = __WEBPACK_IMPORTED_MODULE_1_tslib__["__assign"](__WEBPACK_IMPORTED_MODULE_1_tslib__["__assign"]({}, eventParams), { 'send_to': analyticsId });
    }
    // Workaround for http://b/141370449 - third argument cannot be undefined.
    gtagFunction(GtagCommand.EVENT, eventName, params || {});
}
// TODO: Brad is going to add `screen_name` to GA Gold config parameter schema
/**
 * Set screen_name parameter for this Google Analytics ID.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param screenName Screen name string to set.
 */
function setCurrentScreen(gtagFunction, analyticsId, screenName, options) {
    if (options && options.global) {
        gtagFunction(GtagCommand.SET, { 'screen_name': screenName });
    }
    else {
        gtagFunction(GtagCommand.CONFIG, analyticsId, {
            update: true,
            'screen_name': screenName
        });
    }
}
/**
 * Set user_id parameter for this Google Analytics ID.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param id User ID string to set
 */
function setUserId(gtagFunction, analyticsId, id, options) {
    if (options && options.global) {
        gtagFunction(GtagCommand.SET, { 'user_id': id });
    }
    else {
        gtagFunction(GtagCommand.CONFIG, analyticsId, {
            update: true,
            'user_id': id
        });
    }
}
/**
 * Set all other user properties other than user_id and screen_name.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param properties Map of user properties to set
 */
function setUserProperties(gtagFunction, analyticsId, properties, options) {
    if (options && options.global) {
        var flatProperties = {};
        for (var _i = 0, _a = Object.keys(properties); _i < _a.length; _i++) {
            var key = _a[_i];
            // use dot notation for merge behavior in gtag.js
            flatProperties["user_properties." + key] = properties[key];
        }
        gtagFunction(GtagCommand.SET, flatProperties);
    }
    else {
        gtagFunction(GtagCommand.CONFIG, analyticsId, {
            update: true,
            'user_properties': properties
        });
    }
}
/**
 * Set whether collection is enabled for this ID.
 *
 * @param enabled If true, collection is enabled for this ID.
 */
function setAnalyticsCollectionEnabled(analyticsId, enabled) {
    window["ga-disable-" + analyticsId] = !enabled;
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Initialize the analytics instance in gtag.js by calling config command with fid.
 *
 * NOTE: We combine analytics initialization and setting fid together because we want fid to be
 * part of the `page_view` event that's sent during the initialization
 * @param app Firebase app
 * @param gtagCore The gtag function that's not wrapped.
 */
function initializeGAId(app, gtagCore) {
    return __WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"](this, void 0, void 0, function () {
        var fid;
        var _a;
        return __WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"](this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, app.installations().getId()];
                case 1:
                    fid = _b.sent();
                    // This command initializes gtag.js and only needs to be called once for the entire web app,
                    // but since it is idempotent, we can call it multiple times.
                    // We keep it together with other initialization logic for better code structure.
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    gtagCore('js', new Date());
                    // It should be the first config command called on this GA-ID
                    // Initialize this GA-ID and set FID on it using the gtag config API.
                    gtagCore(GtagCommand.CONFIG, app.options[ANALYTICS_ID_FIELD], (_a = {},
                        _a[GA_FID_KEY] = fid,
                        // guard against developers accidentally setting properties with prefix `firebase_`
                        _a[ORIGIN_KEY] = 'firebase',
                        _a.update = true,
                        _a));
                    return [2 /*return*/];
            }
        });
    });
}
function insertScriptTag(dataLayerName) {
    var script = document.createElement('script');
    // We are not providing an analyticsId in the URL because it would trigger a `page_view`
    // without fid. We will initialize ga-id using gtag (config) command together with fid.
    script.src = GTAG_URL + "?l=" + dataLayerName;
    script.async = true;
    document.head.appendChild(script);
}
/** Get reference to, or create, global datalayer.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer")
 */
function getOrCreateDataLayer(dataLayerName) {
    // Check for existing dataLayer and create if needed.
    var dataLayer = [];
    if (Array.isArray(window[dataLayerName])) {
        dataLayer = window[dataLayerName];
    }
    else {
        window[dataLayerName] = dataLayer;
    }
    return dataLayer;
}
/**
 * Wraps a standard gtag function with extra code to wait for completion of
 * relevant initialization promises before sending requests.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer
 * @param initializedIdPromisesMap Map of gaIds to their initialization promises
 */
function wrapGtag(gtagCore, initializedIdPromisesMap) {
    return function (command, idOrNameOrParams, gtagParams) {
        // If event, check that relevant initialization promises have completed.
        if (command === GtagCommand.EVENT) {
            var initializationPromisesToWaitFor = [];
            // If there's a 'send_to' param, check if any ID specified matches
            // a FID we have begun a fetch on.
            if (gtagParams && gtagParams['send_to']) {
                var gaSendToList = gtagParams['send_to'];
                // Make it an array if is isn't, so it can be dealt with the same way.
                if (!Array.isArray(gaSendToList)) {
                    gaSendToList = [gaSendToList];
                }
                for (var _i = 0, gaSendToList_1 = gaSendToList; _i < gaSendToList_1.length; _i++) {
                    var sendToId = gaSendToList_1[_i];
                    var initializationPromise = initializedIdPromisesMap[sendToId];
                    // Groups will not be in the map.
                    if (initializationPromise) {
                        initializationPromisesToWaitFor.push(initializationPromise);
                    }
                    else {
                        // There is an item in 'send_to' that is not associated
                        // directly with an FID, possibly a group.  Empty this array
                        // and let it get populated below.
                        initializationPromisesToWaitFor = [];
                        break;
                    }
                }
            }
            // This will be unpopulated if there was no 'send_to' field , or
            // if not all entries in the 'send_to' field could be mapped to
            // a FID. In these cases, wait on all pending initialization promises.
            if (initializationPromisesToWaitFor.length === 0) {
                for (var _a = 0, _b = Object.values(initializedIdPromisesMap); _a < _b.length; _a++) {
                    var idPromise = _b[_a];
                    initializationPromisesToWaitFor.push(idPromise);
                }
            }
            // Run core gtag function with args after all relevant initialization
            // promises have been resolved.
            Promise.all(initializationPromisesToWaitFor)
                // Workaround for http://b/141370449 - third argument cannot be undefined.
                .then(function () {
                return gtagCore(GtagCommand.EVENT, idOrNameOrParams, gtagParams || {});
            })
                .catch(function (e) { return console.error(e); });
        }
        else if (command === GtagCommand.CONFIG) {
            var initializationPromiseToWait = initializedIdPromisesMap[idOrNameOrParams] ||
                Promise.resolve();
            initializationPromiseToWait
                .then(function () {
                gtagCore(GtagCommand.CONFIG, idOrNameOrParams, gtagParams);
            })
                .catch(function (e) { return console.error(e); });
        }
        else {
            // SET command.
            // Splitting calls for CONFIG and SET to make it clear which signature
            // Typescript is checking.
            gtagCore(GtagCommand.SET, idOrNameOrParams);
        }
    };
}
/**
 * Creates global gtag function or wraps existing one if found.
 * This wrapped function attaches Firebase instance ID (FID) to gtag 'config' and
 * 'event' calls that belong to the GAID associated with this Firebase instance.
 *
 * @param initializedIdPromisesMap Map of gaId to initialization promises.
 * @param dataLayerName Name of global GA datalayer array.
 * @param gtagFunctionName Name of global gtag function ("gtag" if not user-specified)
 */
function wrapOrCreateGtag(initializedIdPromisesMap, dataLayerName, gtagFunctionName) {
    // Create a basic core gtag function
    var gtagCore = function () {
        var _args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            _args[_i] = arguments[_i];
        }
        // Must push IArguments object, not an array.
        window[dataLayerName].push(arguments);
    };
    // Replace it with existing one if found
    if (window[gtagFunctionName] &&
        typeof window[gtagFunctionName] === 'function') {
        // @ts-ignore
        gtagCore = window[gtagFunctionName];
    }
    window[gtagFunctionName] = wrapGtag(gtagCore, initializedIdPromisesMap);
    return {
        gtagCore: gtagCore,
        wrappedGtag: window[gtagFunctionName]
    };
}
/**
 * Returns first script tag in DOM matching our gtag url pattern.
 */
function findGtagScriptOnPage() {
    var scriptTags = window.document.getElementsByTagName('script');
    for (var _i = 0, _a = Object.values(scriptTags); _i < _a.length; _i++) {
        var tag = _a[_i];
        if (tag.src && tag.src.includes(GTAG_URL)) {
            return tag;
        }
    }
    return null;
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a;
var ERRORS = (_a = {},
    _a["no-ga-id" /* NO_GA_ID */] = "\"" + ANALYTICS_ID_FIELD + "\" field is empty in " +
        'Firebase config. Firebase Analytics ' +
        'requires this field to contain a valid measurement ID.',
    _a["already-exists" /* ALREADY_EXISTS */] = 'A Firebase Analytics instance with the measurement ID ${id} ' +
        ' already exists. ' +
        'Only one Firebase Analytics instance can be created for each measurement ID.',
    _a["already-initialized" /* ALREADY_INITIALIZED */] = 'Firebase Analytics has already been initialized.' +
        'settings() must be called before initializing any Analytics instance' +
        'or it will have no effect.',
    _a);
var ERROR_FACTORY = new __WEBPACK_IMPORTED_MODULE_3__firebase_util__["ErrorFactory"]('analytics', 'Analytics', ERRORS);

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Maps gaId to FID fetch promises.
 */
var initializedIdPromisesMap = {};
/**
 * Name for window global data layer array used by GA: defaults to 'dataLayer'.
 */
var dataLayerName = 'dataLayer';
/**
 * Name for window global gtag function used by GA: defaults to 'gtag'.
 */
var gtagName = 'gtag';
/**
 * Reproduction of standard gtag function or reference to existing
 * gtag function on window object.
 */
var gtagCoreFunction;
/**
 * Wrapper around gtag function that ensures FID is sent with all
 * relevant event and config calls.
 */
var wrappedGtagFunction;
/**
 * Flag to ensure page initialization steps (creation or wrapping of
 * dataLayer and gtag script) are only run once per page load.
 */
var globalInitDone = false;
/**
 * For testing
 */
function resetGlobalVars(newGlobalInitDone, newGaInitializedPromise) {
    if (newGlobalInitDone === void 0) { newGlobalInitDone = false; }
    if (newGaInitializedPromise === void 0) { newGaInitializedPromise = {}; }
    globalInitDone = newGlobalInitDone;
    initializedIdPromisesMap = newGaInitializedPromise;
    dataLayerName = 'dataLayer';
    gtagName = 'gtag';
}
/**
 * This must be run before calling firebase.analytics() or it won't
 * have any effect.
 * @param options Custom gtag and dataLayer names.
 */
function settings(options) {
    if (globalInitDone) {
        throw ERROR_FACTORY.create("already-initialized" /* ALREADY_INITIALIZED */);
    }
    if (options.dataLayerName) {
        dataLayerName = options.dataLayerName;
    }
    if (options.gtagName) {
        gtagName = options.gtagName;
    }
}
function factory(app, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
extendApp) {
    var analyticsId = app.options[ANALYTICS_ID_FIELD];
    if (!analyticsId) {
        throw ERROR_FACTORY.create("no-ga-id" /* NO_GA_ID */);
    }
    if (initializedIdPromisesMap[analyticsId] != null) {
        throw ERROR_FACTORY.create("already-exists" /* ALREADY_EXISTS */, {
            id: analyticsId
        });
    }
    if (!globalInitDone) {
        // Steps here should only be done once per page: creation or wrapping
        // of dataLayer and global gtag function.
        // Detect if user has already put the gtag <script> tag on this page.
        if (!findGtagScriptOnPage()) {
            insertScriptTag(dataLayerName);
        }
        getOrCreateDataLayer(dataLayerName);
        var _a = wrapOrCreateGtag(initializedIdPromisesMap, dataLayerName, gtagName), wrappedGtag = _a.wrappedGtag, gtagCore = _a.gtagCore;
        wrappedGtagFunction = wrappedGtag;
        gtagCoreFunction = gtagCore;
        globalInitDone = true;
    }
    // Async but non-blocking.
    initializedIdPromisesMap[analyticsId] = initializeGAId(app, gtagCoreFunction);
    var analyticsInstance = {
        app: app,
        logEvent: function (eventName, eventParams, options) {
            return logEvent(wrappedGtagFunction, analyticsId, eventName, eventParams, options);
        },
        setCurrentScreen: function (screenName, options) {
            return setCurrentScreen(wrappedGtagFunction, analyticsId, screenName, options);
        },
        setUserId: function (id, options) {
            return setUserId(wrappedGtagFunction, analyticsId, id, options);
        },
        setUserProperties: function (properties, options) {
            return setUserProperties(wrappedGtagFunction, analyticsId, properties, options);
        },
        setAnalyticsCollectionEnabled: function (enabled) {
            return setAnalyticsCollectionEnabled(analyticsId, enabled);
        }
    };
    extendApp({
        INTERNAL: {
            analytics: {
                logEvent: analyticsInstance.logEvent
            }
        }
    });
    return analyticsInstance;
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Type constant for Firebase Analytics.
 */
var ANALYTICS_TYPE = 'analytics';
function registerAnalytics(instance) {
    instance.INTERNAL.registerService(ANALYTICS_TYPE, factory, {
        settings: settings,
        EventName: EventName
    }, 
    // We don't need to wait on any AppHooks.
    undefined, 
    // Allow multiple analytics instances per app.
    false);
}
registerAnalytics(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a);


//# sourceMappingURL=index.esm.js.map


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var firebase = _interopDefault(__webpack_require__(50));
__webpack_require__(143);
var tslib = __webpack_require__(51);
var util = __webpack_require__(66);
var logger = __webpack_require__(110);

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Implements the {@link RemoteConfigClient} abstraction with success response caching.
 *
 * <p>Comparable to the browser's Cache API for responses, but the Cache API requires a Service
 * Worker, which requires HTTPS, which would significantly complicate SDK installation. Also, the
 * Cache API doesn't support matching entries by time.
 */
var CachingClient = /** @class */ (function () {
    function CachingClient(client, storage, storageCache, logger) {
        this.client = client;
        this.storage = storage;
        this.storageCache = storageCache;
        this.logger = logger;
    }
    /**
     * Returns true if the age of the cached fetched configs is less than or equal to
     * {@link Settings#minimumFetchIntervalInSeconds}.
     *
     * <p>This is comparable to passing `headers = { 'Cache-Control': max-age <maxAge> }` to the
     * native Fetch API.
     *
     * <p>Visible for testing.
     */
    CachingClient.prototype.isCachedDataFresh = function (cacheMaxAgeMillis, lastSuccessfulFetchTimestampMillis) {
        // Cache can only be fresh if it's populated.
        if (!lastSuccessfulFetchTimestampMillis) {
            this.logger.debug('Config fetch cache check. Cache unpopulated.');
            return false;
        }
        // Calculates age of cache entry.
        var cacheAgeMillis = Date.now() - lastSuccessfulFetchTimestampMillis;
        var isCachedDataFresh = cacheAgeMillis <= cacheMaxAgeMillis;
        this.logger.debug('Config fetch cache check.' +
            (" Cache age millis: " + cacheAgeMillis + ".") +
            (" Cache max age millis (minimumFetchIntervalMillis setting): " + cacheMaxAgeMillis + ".") +
            (" Is cache hit: " + isCachedDataFresh + "."));
        return isCachedDataFresh;
    };
    CachingClient.prototype.fetch = function (request) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var _a, lastSuccessfulFetchTimestampMillis, lastSuccessfulFetchResponse, response, storageOperations;
            return tslib.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this.storage.getLastSuccessfulFetchTimestampMillis(),
                            this.storage.getLastSuccessfulFetchResponse()
                        ])];
                    case 1:
                        _a = _b.sent(), lastSuccessfulFetchTimestampMillis = _a[0], lastSuccessfulFetchResponse = _a[1];
                        // Exits early on cache hit.
                        if (lastSuccessfulFetchResponse &&
                            this.isCachedDataFresh(request.cacheMaxAgeMillis, lastSuccessfulFetchTimestampMillis)) {
                            return [2 /*return*/, lastSuccessfulFetchResponse];
                        }
                        // Deviates from pure decorator by not honoring a passed ETag since we don't have a public API
                        // that allows the caller to pass an ETag.
                        request.eTag =
                            lastSuccessfulFetchResponse && lastSuccessfulFetchResponse.eTag;
                        return [4 /*yield*/, this.client.fetch(request)];
                    case 2:
                        response = _b.sent();
                        storageOperations = [
                            // Uses write-through cache for consistency with synchronous public API.
                            this.storageCache.setLastSuccessfulFetchTimestampMillis(Date.now())
                        ];
                        if (response.status === 200) {
                            // Caches response only if it has changed, ie non-304 responses.
                            storageOperations.push(this.storage.setLastSuccessfulFetchResponse(response));
                        }
                        return [4 /*yield*/, Promise.all(storageOperations)];
                    case 3:
                        _b.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    return CachingClient;
}());

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a;
var ERROR_DESCRIPTION_MAP = (_a = {},
    _a["registration-window" /* REGISTRATION_WINDOW */] = 'Undefined window object. This SDK only supports usage in a browser environment.',
    _a["registration-project-id" /* REGISTRATION_PROJECT_ID */] = 'Undefined project identifier. Check Firebase app initialization.',
    _a["registration-api-key" /* REGISTRATION_API_KEY */] = 'Undefined API key. Check Firebase app initialization.',
    _a["registration-app-id" /* REGISTRATION_APP_ID */] = 'Undefined app identifier. Check Firebase app initialization.',
    _a["storage-open" /* STORAGE_OPEN */] = 'Error thrown when opening storage. Original error: {$originalErrorMessage}.',
    _a["storage-get" /* STORAGE_GET */] = 'Error thrown when reading from storage. Original error: {$originalErrorMessage}.',
    _a["storage-set" /* STORAGE_SET */] = 'Error thrown when writing to storage. Original error: {$originalErrorMessage}.',
    _a["storage-delete" /* STORAGE_DELETE */] = 'Error thrown when deleting from storage. Original error: {$originalErrorMessage}.',
    _a["fetch-client-network" /* FETCH_NETWORK */] = 'Fetch client failed to connect to a network. Check Internet connection.' +
        ' Original error: {$originalErrorMessage}.',
    _a["fetch-timeout" /* FETCH_TIMEOUT */] = 'The config fetch request timed out. ' +
        ' Configure timeout using "fetchTimeoutMillis" SDK setting.',
    _a["fetch-throttle" /* FETCH_THROTTLE */] = 'The config fetch request timed out while in an exponential backoff state.' +
        ' Configure timeout using "fetchTimeoutMillis" SDK setting.' +
        ' Unix timestamp in milliseconds when fetch request throttling ends: {$throttleEndTimeMillis}.',
    _a["fetch-client-parse" /* FETCH_PARSE */] = 'Fetch client could not parse response.' +
        ' Original error: {$originalErrorMessage}.',
    _a["fetch-status" /* FETCH_STATUS */] = 'Fetch server returned an HTTP error status. HTTP status: {$httpStatus}.',
    _a);
var ERROR_FACTORY = new util.ErrorFactory('remoteconfig' /* service */, 'Remote Config' /* service name */, ERROR_DESCRIPTION_MAP);
// Note how this is like typeof/instanceof, but for ErrorCode.
function hasErrorCode(e, errorCode) {
    return e instanceof util.FirebaseError && e.code.indexOf(errorCode) !== -1;
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Attempts to get the most accurate browser language setting.
 *
 * <p>Adapted from getUserLanguage in packages/auth/src/utils.js for TypeScript.
 *
 * <p>Defers default language specification to server logic for consistency.
 *
 * @param navigatorLanguage Enables tests to override read-only {@link NavigatorLanguage}.
 */
function getUserLanguage(navigatorLanguage) {
    if (navigatorLanguage === void 0) { navigatorLanguage = navigator; }
    return (
    // Most reliable, but only supported in Chrome/Firefox.
    (navigatorLanguage.languages && navigatorLanguage.languages[0]) ||
        // Supported in most browsers, but returns the language of the browser
        // UI, not the language set in browser settings.
        navigatorLanguage.language
    // Polyfill otherwise.
    );
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Implements the Client abstraction for the Remote Config REST API.
 */
var RestClient = /** @class */ (function () {
    function RestClient(firebaseInstallations, sdkVersion, namespace, projectId, apiKey, appId) {
        this.firebaseInstallations = firebaseInstallations;
        this.sdkVersion = sdkVersion;
        this.namespace = namespace;
        this.projectId = projectId;
        this.apiKey = apiKey;
        this.appId = appId;
    }
    /**
     * Fetches from the Remote Config REST API.
     *
     * @throws a {@link ErrorCode.FETCH_NETWORK} error if {@link GlobalFetch#fetch} can't
     * connect to the network.
     * @throws a {@link ErrorCode.FETCH_PARSE} error if {@link Response#json} can't parse the
     * fetch response.
     * @throws a {@link ErrorCode.FETCH_STATUS} error if the service returns an HTTP error status.
     */
    RestClient.prototype.fetch = function (request) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var _a, installationId, installationToken, urlBase, url, headers, requestBody, options, fetchPromise, timeoutPromise, response, originalError_1, errorCode, status, responseEtag, config, state, responseBody, originalError_2;
            return tslib.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this.firebaseInstallations.getId(),
                            this.firebaseInstallations.getToken()
                        ])];
                    case 1:
                        _a = _b.sent(), installationId = _a[0], installationToken = _a[1];
                        urlBase = window.FIREBASE_REMOTE_CONFIG_URL_BASE ||
                            'https://firebaseremoteconfig.googleapis.com';
                        url = urlBase + "/v1/projects/" + this.projectId + "/namespaces/" + this.namespace + ":fetch?key=" + this.apiKey;
                        headers = {
                            'Content-Type': 'application/json',
                            'Content-Encoding': 'gzip',
                            // Deviates from pure decorator by not passing max-age header since we don't currently have
                            // service behavior using that header.
                            'If-None-Match': request.eTag || '*'
                        };
                        requestBody = {
                            /* eslint-disable camelcase */
                            sdk_version: this.sdkVersion,
                            app_instance_id: installationId,
                            app_instance_id_token: installationToken,
                            app_id: this.appId,
                            language_code: getUserLanguage()
                            /* eslint-enable camelcase */
                        };
                        options = {
                            method: 'POST',
                            headers: headers,
                            body: JSON.stringify(requestBody)
                        };
                        fetchPromise = fetch(url, options);
                        timeoutPromise = new Promise(function (_resolve, reject) {
                            // Maps async event listener to Promise API.
                            request.signal.addEventListener(function () {
                                // Emulates https://heycam.github.io/webidl/#aborterror
                                var error = new Error('The operation was aborted.');
                                error.name = 'AbortError';
                                reject(error);
                            });
                        });
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 5, , 6]);
                        return [4 /*yield*/, Promise.race([fetchPromise, timeoutPromise])];
                    case 3:
                        _b.sent();
                        return [4 /*yield*/, fetchPromise];
                    case 4:
                        response = _b.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        originalError_1 = _b.sent();
                        errorCode = "fetch-client-network" /* FETCH_NETWORK */;
                        if (originalError_1.name === 'AbortError') {
                            errorCode = "fetch-timeout" /* FETCH_TIMEOUT */;
                        }
                        throw ERROR_FACTORY.create(errorCode, {
                            originalErrorMessage: originalError_1.message
                        });
                    case 6:
                        status = response.status;
                        responseEtag = response.headers.get('ETag') || undefined;
                        if (!(response.status === 200)) return [3 /*break*/, 11];
                        responseBody = void 0;
                        _b.label = 7;
                    case 7:
                        _b.trys.push([7, 9, , 10]);
                        return [4 /*yield*/, response.json()];
                    case 8:
                        responseBody = _b.sent();
                        return [3 /*break*/, 10];
                    case 9:
                        originalError_2 = _b.sent();
                        throw ERROR_FACTORY.create("fetch-client-parse" /* FETCH_PARSE */, {
                            originalErrorMessage: originalError_2.message
                        });
                    case 10:
                        config = responseBody['entries'];
                        state = responseBody['state'];
                        _b.label = 11;
                    case 11:
                        // Normalizes based on legacy state.
                        if (state === 'INSTANCE_STATE_UNSPECIFIED') {
                            status = 500;
                        }
                        else if (state === 'NO_CHANGE') {
                            status = 304;
                        }
                        else if (state === 'NO_TEMPLATE' || state === 'EMPTY_CONFIG') {
                            // These cases can be fixed remotely, so normalize to safe value.
                            config = {};
                        }
                        // Normalize to exception-based control flow for non-success cases.
                        // Encapsulates HTTP specifics in this class as much as possible. Status is still the best for
                        // differentiating success states (200 from 304; the state body param is undefined in a
                        // standard 304).
                        if (status !== 304 && status !== 200) {
                            throw ERROR_FACTORY.create("fetch-status" /* FETCH_STATUS */, {
                                httpStatus: status
                            });
                        }
                        return [2 /*return*/, { status: status, eTag: responseEtag, config: config }];
                }
            });
        });
    };
    return RestClient;
}());

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Shims a minimal AbortSignal.
 *
 * <p>AbortController's AbortSignal conveniently decouples fetch timeout logic from other aspects
 * of networking, such as retries. Firebase doesn't use AbortController enough to justify a
 * polyfill recommendation, like we do with the Fetch API, but this minimal shim can easily be
 * swapped out if/when we do.
 */
var RemoteConfigAbortSignal = /** @class */ (function () {
    function RemoteConfigAbortSignal() {
        this.listeners = [];
    }
    RemoteConfigAbortSignal.prototype.addEventListener = function (listener) {
        this.listeners.push(listener);
    };
    RemoteConfigAbortSignal.prototype.abort = function () {
        this.listeners.forEach(function (listener) { return listener(); });
    };
    return RemoteConfigAbortSignal;
}());

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DEFAULT_VALUE_FOR_BOOLEAN = false;
var DEFAULT_VALUE_FOR_STRING = '';
var DEFAULT_VALUE_FOR_NUMBER = 0;
var BOOLEAN_TRUTHY_VALUES = ['1', 'true', 't', 'yes', 'y', 'on'];
var Value = /** @class */ (function () {
    function Value(_source, _value) {
        if (_value === void 0) { _value = DEFAULT_VALUE_FOR_STRING; }
        this._source = _source;
        this._value = _value;
    }
    Value.prototype.asString = function () {
        return this._value;
    };
    Value.prototype.asBoolean = function () {
        if (this._source === 'static') {
            return DEFAULT_VALUE_FOR_BOOLEAN;
        }
        return BOOLEAN_TRUTHY_VALUES.indexOf(this._value.toLowerCase()) >= 0;
    };
    Value.prototype.asNumber = function () {
        if (this._source === 'static') {
            return DEFAULT_VALUE_FOR_NUMBER;
        }
        var num = Number(this._value);
        if (isNaN(num)) {
            num = DEFAULT_VALUE_FOR_NUMBER;
        }
        return num;
    };
    Value.prototype.getSource = function () {
        return this._source;
    };
    return Value;
}());

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DEFAULT_FETCH_TIMEOUT_MILLIS = 60 * 1000; // One minute
var DEFAULT_CACHE_MAX_AGE_MILLIS = 12 * 60 * 60 * 1000; // Twelve hours.
/**
 * Encapsulates business logic mapping network and storage dependencies to the public SDK API.
 *
 * See {@link https://github.com/FirebasePrivate/firebase-js-sdk/blob/master/packages/firebase/index.d.ts|interface documentation} for method descriptions.
 */
var RemoteConfig = /** @class */ (function () {
    function RemoteConfig(
    // Required by FirebaseServiceFactory interface.
    app, 
    // JS doesn't support private yet
    // (https://github.com/tc39/proposal-class-fields#private-fields), so we hint using an
    // underscore prefix.
    _client, _storageCache, _storage, _logger) {
        this.app = app;
        this._client = _client;
        this._storageCache = _storageCache;
        this._storage = _storage;
        this._logger = _logger;
        // Tracks completion of initialization promise.
        this._isInitializationComplete = false;
        this.settings = {
            fetchTimeoutMillis: DEFAULT_FETCH_TIMEOUT_MILLIS,
            minimumFetchIntervalMillis: DEFAULT_CACHE_MAX_AGE_MILLIS
        };
        this.defaultConfig = {};
    }
    // Based on packages/firestore/src/util/log.ts but not static because we need per-instance levels
    // to differentiate 2p and 3p use-cases.
    RemoteConfig.prototype.setLogLevel = function (logLevel) {
        switch (logLevel) {
            case 'debug':
                this._logger.logLevel = logger.LogLevel.DEBUG;
                break;
            case 'silent':
                this._logger.logLevel = logger.LogLevel.SILENT;
                break;
            default:
                this._logger.logLevel = logger.LogLevel.ERROR;
        }
    };
    Object.defineProperty(RemoteConfig.prototype, "fetchTimeMillis", {
        get: function () {
            return this._storageCache.getLastSuccessfulFetchTimestampMillis() || -1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RemoteConfig.prototype, "lastFetchStatus", {
        get: function () {
            return this._storageCache.getLastFetchStatus() || 'no-fetch-yet';
        },
        enumerable: true,
        configurable: true
    });
    RemoteConfig.prototype.activate = function () {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var _a, lastSuccessfulFetchResponse, activeConfigEtag;
            return tslib.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this._storage.getLastSuccessfulFetchResponse(),
                            this._storage.getActiveConfigEtag()
                        ])];
                    case 1:
                        _a = _b.sent(), lastSuccessfulFetchResponse = _a[0], activeConfigEtag = _a[1];
                        if (!lastSuccessfulFetchResponse ||
                            !lastSuccessfulFetchResponse.config ||
                            !lastSuccessfulFetchResponse.eTag ||
                            lastSuccessfulFetchResponse.eTag === activeConfigEtag) {
                            // Either there is no successful fetched config, or is the same as current active
                            // config.
                            return [2 /*return*/, false];
                        }
                        return [4 /*yield*/, Promise.all([
                                this._storageCache.setActiveConfig(lastSuccessfulFetchResponse.config),
                                this._storage.setActiveConfigEtag(lastSuccessfulFetchResponse.eTag)
                            ])];
                    case 2:
                        _b.sent();
                        return [2 /*return*/, true];
                }
            });
        });
    };
    RemoteConfig.prototype.ensureInitialized = function () {
        var _this = this;
        if (!this._initializePromise) {
            this._initializePromise = this._storageCache
                .loadFromStorage()
                .then(function () {
                _this._isInitializationComplete = true;
            });
        }
        return this._initializePromise;
    };
    /**
     * @throws a {@link ErrorCode.FETCH_CLIENT_TIMEOUT} if the request takes longer than
     * {@link Settings.fetchTimeoutInSeconds} or
     * {@link DEFAULT_FETCH_TIMEOUT_SECONDS}.
     */
    RemoteConfig.prototype.fetch = function () {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) { return tslib.__awaiter(_this, void 0, void 0, function () {
                        var abortSignal, e_1, lastFetchStatus;
                        var _this = this;
                        return tslib.__generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    abortSignal = new RemoteConfigAbortSignal();
                                    setTimeout(function () { return tslib.__awaiter(_this, void 0, void 0, function () {
                                        return tslib.__generator(this, function (_a) {
                                            // Note a very low delay, eg < 10ms, can elapse before listeners are initialized.
                                            abortSignal.abort();
                                            return [2 /*return*/];
                                        });
                                    }); }, this.settings.fetchTimeoutMillis);
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 4, , 6]);
                                    return [4 /*yield*/, this._client.fetch({
                                            cacheMaxAgeMillis: this.settings.minimumFetchIntervalMillis,
                                            signal: abortSignal
                                        })];
                                case 2:
                                    _a.sent();
                                    return [4 /*yield*/, this._storageCache.setLastFetchStatus('success')];
                                case 3:
                                    _a.sent();
                                    resolve();
                                    return [3 /*break*/, 6];
                                case 4:
                                    e_1 = _a.sent();
                                    lastFetchStatus = hasErrorCode(e_1, "fetch-throttle" /* FETCH_THROTTLE */)
                                        ? 'throttle'
                                        : 'failure';
                                    return [4 /*yield*/, this._storageCache.setLastFetchStatus(lastFetchStatus)];
                                case 5:
                                    _a.sent();
                                    reject(e_1);
                                    return [3 /*break*/, 6];
                                case 6: return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    RemoteConfig.prototype.fetchAndActivate = function () {
        return tslib.__awaiter(this, void 0, void 0, function () {
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetch()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.activate()];
                }
            });
        });
    };
    RemoteConfig.prototype.getAll = function () {
        var _this = this;
        return getAllKeys(this._storageCache.getActiveConfig(), this.defaultConfig).reduce(function (allConfigs, key) {
            allConfigs[key] = _this.getValue(key);
            return allConfigs;
        }, {});
    };
    RemoteConfig.prototype.getBoolean = function (key) {
        return this.getValue(key).asBoolean();
    };
    RemoteConfig.prototype.getNumber = function (key) {
        return this.getValue(key).asNumber();
    };
    RemoteConfig.prototype.getString = function (key) {
        return this.getValue(key).asString();
    };
    RemoteConfig.prototype.getValue = function (key) {
        if (!this._isInitializationComplete) {
            this._logger.debug("A value was requested for key \"" + key + "\" before SDK initialization completed." +
                ' Await on ensureInitialized if the intent was to get a previously activated value.');
        }
        var activeConfig = this._storageCache.getActiveConfig();
        if (activeConfig && activeConfig[key] !== undefined) {
            return new Value('remote', activeConfig[key]);
        }
        else if (this.defaultConfig && this.defaultConfig[key] !== undefined) {
            return new Value('default', String(this.defaultConfig[key]));
        }
        this._logger.debug("Returning static value for key \"" + key + "\"." +
            ' Define a default or remote value if this is unintentional.');
        return new Value('static');
    };
    return RemoteConfig;
}());
/**
 * Dedupes and returns an array of all the keys of the received objects.
 */
function getAllKeys(obj1, obj2) {
    if (obj1 === void 0) { obj1 = {}; }
    if (obj2 === void 0) { obj2 = {}; }
    return Object.keys(tslib.__assign(tslib.__assign({}, obj1), obj2));
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Converts an error event associated with a {@link IDBRequest} to a {@link FirebaseError}.
 */
function toFirebaseError(event, errorCode) {
    var originalError = event.target.error || undefined;
    return ERROR_FACTORY.create(errorCode, {
        originalErrorMessage: originalError && originalError.message
    });
}
/**
 * A general-purpose store keyed by app + namespace + {@link
 * ProjectNamespaceKeyFieldValue}.
 *
 * <p>The Remote Config SDK can be used with multiple app installations, and each app can interact
 * with multiple namespaces, so this store uses app (ID + name) and namespace as common parent keys
 * for a set of key-value pairs. See {@link Storage#createCompositeKey}.
 *
 * <p>Visible for testing.
 */
var APP_NAMESPACE_STORE = 'app_namespace_store';
var DB_NAME = 'firebase_remote_config';
var DB_VERSION = 1;
// Visible for testing.
function openDatabase() {
    return new Promise(function (resolve, reject) {
        var request = indexedDB.open(DB_NAME, DB_VERSION);
        request.onerror = function (event) {
            reject(toFirebaseError(event, "storage-open" /* STORAGE_OPEN */));
        };
        request.onsuccess = function (event) {
            resolve(event.target.result);
        };
        request.onupgradeneeded = function (event) {
            var db = event.target.result;
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch (event.oldVersion) {
                case 0:
                    db.createObjectStore(APP_NAMESPACE_STORE, {
                        keyPath: 'compositeKey'
                    });
            }
        };
    });
}
/**
 * Abstracts data persistence.
 */
var Storage = /** @class */ (function () {
    /**
     * @param appId enables storage segmentation by app (ID + name).
     * @param appName enables storage segmentation by app (ID + name).
     * @param namespace enables storage segmentation by namespace.
     */
    function Storage(appId, appName, namespace, openDbPromise) {
        if (openDbPromise === void 0) { openDbPromise = openDatabase(); }
        this.appId = appId;
        this.appName = appName;
        this.namespace = namespace;
        this.openDbPromise = openDbPromise;
    }
    Storage.prototype.getLastFetchStatus = function () {
        return this.get('last_fetch_status');
    };
    Storage.prototype.setLastFetchStatus = function (status) {
        return this.set('last_fetch_status', status);
    };
    // This is comparable to a cache entry timestamp. If we need to expire other data, we could
    // consider adding timestamp to all storage records and an optional max age arg to getters.
    Storage.prototype.getLastSuccessfulFetchTimestampMillis = function () {
        return this.get('last_successful_fetch_timestamp_millis');
    };
    Storage.prototype.setLastSuccessfulFetchTimestampMillis = function (timestamp) {
        return this.set('last_successful_fetch_timestamp_millis', timestamp);
    };
    Storage.prototype.getLastSuccessfulFetchResponse = function () {
        return this.get('last_successful_fetch_response');
    };
    Storage.prototype.setLastSuccessfulFetchResponse = function (response) {
        return this.set('last_successful_fetch_response', response);
    };
    Storage.prototype.getActiveConfig = function () {
        return this.get('active_config');
    };
    Storage.prototype.setActiveConfig = function (config) {
        return this.set('active_config', config);
    };
    Storage.prototype.getActiveConfigEtag = function () {
        return this.get('active_config_etag');
    };
    Storage.prototype.setActiveConfigEtag = function (etag) {
        return this.set('active_config_etag', etag);
    };
    Storage.prototype.getThrottleMetadata = function () {
        return this.get('throttle_metadata');
    };
    Storage.prototype.setThrottleMetadata = function (metadata) {
        return this.set('throttle_metadata', metadata);
    };
    Storage.prototype.deleteThrottleMetadata = function () {
        return this.delete('throttle_metadata');
    };
    Storage.prototype.get = function (key) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var db;
            var _this = this;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.openDbPromise];
                    case 1:
                        db = _a.sent();
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                var transaction = db.transaction([APP_NAMESPACE_STORE], 'readonly');
                                var objectStore = transaction.objectStore(APP_NAMESPACE_STORE);
                                var compositeKey = _this.createCompositeKey(key);
                                try {
                                    var request = objectStore.get(compositeKey);
                                    request.onerror = function (event) {
                                        reject(toFirebaseError(event, "storage-get" /* STORAGE_GET */));
                                    };
                                    request.onsuccess = function (event) {
                                        var result = event.target.result;
                                        if (result) {
                                            resolve(result.value);
                                        }
                                        else {
                                            resolve(undefined);
                                        }
                                    };
                                }
                                catch (e) {
                                    reject(ERROR_FACTORY.create("storage-get" /* STORAGE_GET */, {
                                        originalErrorMessage: e && e.message
                                    }));
                                }
                            })];
                }
            });
        });
    };
    Storage.prototype.set = function (key, value) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var db;
            var _this = this;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.openDbPromise];
                    case 1:
                        db = _a.sent();
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                var transaction = db.transaction([APP_NAMESPACE_STORE], 'readwrite');
                                var objectStore = transaction.objectStore(APP_NAMESPACE_STORE);
                                var compositeKey = _this.createCompositeKey(key);
                                try {
                                    var request = objectStore.put({
                                        compositeKey: compositeKey,
                                        value: value
                                    });
                                    request.onerror = function (event) {
                                        reject(toFirebaseError(event, "storage-set" /* STORAGE_SET */));
                                    };
                                    request.onsuccess = function () {
                                        resolve();
                                    };
                                }
                                catch (e) {
                                    reject(ERROR_FACTORY.create("storage-set" /* STORAGE_SET */, {
                                        originalErrorMessage: e && e.message
                                    }));
                                }
                            })];
                }
            });
        });
    };
    Storage.prototype.delete = function (key) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var db;
            var _this = this;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.openDbPromise];
                    case 1:
                        db = _a.sent();
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                var transaction = db.transaction([APP_NAMESPACE_STORE], 'readwrite');
                                var objectStore = transaction.objectStore(APP_NAMESPACE_STORE);
                                var compositeKey = _this.createCompositeKey(key);
                                try {
                                    var request = objectStore.delete(compositeKey);
                                    request.onerror = function (event) {
                                        reject(toFirebaseError(event, "storage-delete" /* STORAGE_DELETE */));
                                    };
                                    request.onsuccess = function () {
                                        resolve();
                                    };
                                }
                                catch (e) {
                                    reject(ERROR_FACTORY.create("storage-delete" /* STORAGE_DELETE */, {
                                        originalErrorMessage: e && e.message
                                    }));
                                }
                            })];
                }
            });
        });
    };
    // Facilitates composite key functionality (which is unsupported in IE).
    Storage.prototype.createCompositeKey = function (key) {
        return [this.appId, this.appName, this.namespace, key].join();
    };
    return Storage;
}());

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A memory cache layer over storage to support the SDK's synchronous read requirements.
 */
var StorageCache = /** @class */ (function () {
    function StorageCache(storage) {
        this.storage = storage;
    }
    /**
     * Memory-only getters
     */
    StorageCache.prototype.getLastFetchStatus = function () {
        return this.lastFetchStatus;
    };
    StorageCache.prototype.getLastSuccessfulFetchTimestampMillis = function () {
        return this.lastSuccessfulFetchTimestampMillis;
    };
    StorageCache.prototype.getActiveConfig = function () {
        return this.activeConfig;
    };
    /**
     * Read-ahead getter
     */
    StorageCache.prototype.loadFromStorage = function () {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var lastFetchStatusPromise, lastSuccessfulFetchTimestampMillisPromise, activeConfigPromise, lastFetchStatus, lastSuccessfulFetchTimestampMillis, activeConfig;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        lastFetchStatusPromise = this.storage.getLastFetchStatus();
                        lastSuccessfulFetchTimestampMillisPromise = this.storage.getLastSuccessfulFetchTimestampMillis();
                        activeConfigPromise = this.storage.getActiveConfig();
                        return [4 /*yield*/, lastFetchStatusPromise];
                    case 1:
                        lastFetchStatus = _a.sent();
                        if (lastFetchStatus) {
                            this.lastFetchStatus = lastFetchStatus;
                        }
                        return [4 /*yield*/, lastSuccessfulFetchTimestampMillisPromise];
                    case 2:
                        lastSuccessfulFetchTimestampMillis = _a.sent();
                        if (lastSuccessfulFetchTimestampMillis) {
                            this.lastSuccessfulFetchTimestampMillis = lastSuccessfulFetchTimestampMillis;
                        }
                        return [4 /*yield*/, activeConfigPromise];
                    case 3:
                        activeConfig = _a.sent();
                        if (activeConfig) {
                            this.activeConfig = activeConfig;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Write-through setters
     */
    StorageCache.prototype.setLastFetchStatus = function (status) {
        this.lastFetchStatus = status;
        return this.storage.setLastFetchStatus(status);
    };
    StorageCache.prototype.setLastSuccessfulFetchTimestampMillis = function (timestampMillis) {
        this.lastSuccessfulFetchTimestampMillis = timestampMillis;
        return this.storage.setLastSuccessfulFetchTimestampMillis(timestampMillis);
    };
    StorageCache.prototype.setActiveConfig = function (activeConfig) {
        this.activeConfig = activeConfig;
        return this.storage.setActiveConfig(activeConfig);
    };
    return StorageCache;
}());

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The amount of milliseconds to exponentially increase.
 */
var INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */
var BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */
var MAX_VALUE_MILLIS = 4 * 60 * 60 * 1000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */
var RANDOM_FACTOR = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */
function calculateBackoffMillis(backoffCount) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    var currBaseValue = INTERVAL_MILLIS * Math.pow(BACKOFF_FACTOR, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    var randomWait = Math.round(
    // A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    RANDOM_FACTOR *
        currBaseValue *
        // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
        // if we add or subtract.
        (Math.random() - 0.5) *
        2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min(MAX_VALUE_MILLIS, currBaseValue + randomWait);
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Supports waiting on a backoff by:
 *
 * <ul>
 *   <li>Promisifying setTimeout, so we can set a timeout in our Promise chain</li>
 *   <li>Listening on a signal bus for abort events, just like the Fetch API</li>
 *   <li>Failing in the same way the Fetch API fails, so timing out a live request and a throttled
 *       request appear the same.</li>
 * </ul>
 *
 * <p>Visible for testing.
 */
function setAbortableTimeout(signal, throttleEndTimeMillis) {
    return new Promise(function (resolve, reject) {
        // Derives backoff from given end time, normalizing negative numbers to zero.
        var backoffMillis = Math.max(throttleEndTimeMillis - Date.now(), 0);
        var timeout = setTimeout(resolve, backoffMillis);
        // Adds listener, rather than sets onabort, because signal is a shared object.
        signal.addEventListener(function () {
            clearTimeout(timeout);
            // If the request completes before this timeout, the rejection has no effect.
            reject(ERROR_FACTORY.create("fetch-throttle" /* FETCH_THROTTLE */, {
                throttleEndTimeMillis: throttleEndTimeMillis
            }));
        });
    });
}
/**
 * Returns true if the {@link Error} indicates a fetch request may succeed later.
 */
function isRetriableError(e) {
    if (!(e instanceof util.FirebaseError)) {
        return false;
    }
    // Uses string index defined by ErrorData, which FirebaseError implements.
    var httpStatus = Number(e['httpStatus']);
    return (httpStatus === 429 ||
        httpStatus === 500 ||
        httpStatus === 503 ||
        httpStatus === 504);
}
/**
 * Decorates a Client with retry logic.
 *
 * <p>Comparable to CachingClient, but uses backoff logic instead of cache max age and doesn't cache
 * responses (because the SDK has no use for error responses).
 */
var RetryingClient = /** @class */ (function () {
    function RetryingClient(client, storage) {
        this.client = client;
        this.storage = storage;
    }
    RetryingClient.prototype.fetch = function (request) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var throttleMetadata;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.storage.getThrottleMetadata()];
                    case 1:
                        throttleMetadata = (_a.sent()) || {
                            backoffCount: 0,
                            throttleEndTimeMillis: Date.now()
                        };
                        return [2 /*return*/, this.attemptFetch(request, throttleMetadata)];
                }
            });
        });
    };
    /**
     * A recursive helper for attempting a fetch request repeatedly.
     *
     * @throws any non-retriable errors.
     */
    RetryingClient.prototype.attemptFetch = function (request, _a) {
        var throttleEndTimeMillis = _a.throttleEndTimeMillis, backoffCount = _a.backoffCount;
        return tslib.__awaiter(this, void 0, void 0, function () {
            var response, e_1, throttleMetadata;
            return tslib.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: 
                    // Starts with a (potentially zero) timeout to support resumption from stored state.
                    // Ensures the throttle end time is honored if the last attempt timed out.
                    // Note the SDK will never make a request if the fetch timeout expires at this point.
                    return [4 /*yield*/, setAbortableTimeout(request.signal, throttleEndTimeMillis)];
                    case 1:
                        // Starts with a (potentially zero) timeout to support resumption from stored state.
                        // Ensures the throttle end time is honored if the last attempt timed out.
                        // Note the SDK will never make a request if the fetch timeout expires at this point.
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 5, , 7]);
                        return [4 /*yield*/, this.client.fetch(request)];
                    case 3:
                        response = _b.sent();
                        // Note the SDK only clears throttle state if response is success or non-retriable.
                        return [4 /*yield*/, this.storage.deleteThrottleMetadata()];
                    case 4:
                        // Note the SDK only clears throttle state if response is success or non-retriable.
                        _b.sent();
                        return [2 /*return*/, response];
                    case 5:
                        e_1 = _b.sent();
                        if (!isRetriableError(e_1)) {
                            throw e_1;
                        }
                        throttleMetadata = {
                            throttleEndTimeMillis: Date.now() + calculateBackoffMillis(backoffCount),
                            backoffCount: backoffCount + 1
                        };
                        // Persists state.
                        return [4 /*yield*/, this.storage.setThrottleMetadata(throttleMetadata)];
                    case 6:
                        // Persists state.
                        _b.sent();
                        return [2 /*return*/, this.attemptFetch(request, throttleMetadata)];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    return RetryingClient;
}());

var name = "@firebase/remote-config";

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function registerRemoteConfig(firebaseInstance) {
    firebaseInstance.INTERNAL.registerService('remoteConfig', function (app, _, namespace) {
        // Guards against the SDK being used in non-browser environments.
        if (typeof window === 'undefined') {
            throw ERROR_FACTORY.create("registration-window" /* REGISTRATION_WINDOW */);
        }
        // Normalizes optional inputs.
        var _a = app.options, projectId = _a.projectId, apiKey = _a.apiKey, appId = _a.appId;
        if (!projectId) {
            throw ERROR_FACTORY.create("registration-project-id" /* REGISTRATION_PROJECT_ID */);
        }
        if (!apiKey) {
            throw ERROR_FACTORY.create("registration-api-key" /* REGISTRATION_API_KEY */);
        }
        if (!appId) {
            throw ERROR_FACTORY.create("registration-app-id" /* REGISTRATION_APP_ID */);
        }
        namespace = namespace || 'firebase';
        var storage = new Storage(appId, app.name, namespace);
        var storageCache = new StorageCache(storage);
        var logger$1 = new logger.Logger(name);
        // Sets ERROR as the default log level.
        // See RemoteConfig#setLogLevel for corresponding normalization to ERROR log level.
        logger$1.logLevel = logger.LogLevel.ERROR;
        var restClient = new RestClient(app.installations(), 
        // Uses the JS SDK version, by which the RC package version can be deduced, if necessary.
        firebaseInstance.SDK_VERSION, namespace, projectId, apiKey, appId);
        var retryingClient = new RetryingClient(restClient, storage);
        var cachingClient = new CachingClient(retryingClient, storage, storageCache, logger$1);
        var remoteConfigInstance = new RemoteConfig(app, cachingClient, storageCache, storage, logger$1);
        // Starts warming cache.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        remoteConfigInstance.ensureInitialized();
        return remoteConfigInstance;
    }, undefined, undefined, true /* allowMultipleInstances */);
}
registerRemoteConfig(firebase);

exports.registerRemoteConfig = registerRemoteConfig;
//# sourceMappingURL=index.cjs.js.map


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.history = undefined;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(23);

var _reactRedux = __webpack_require__(5);

var _createBrowserHistory = __webpack_require__(919);

var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

var _DealDashboardPage = __webpack_require__(923);

var _DealDashboardPage2 = _interopRequireDefault(_DealDashboardPage);

var _EditDealPage = __webpack_require__(996);

var _EditDealPage2 = _interopRequireDefault(_EditDealPage);

var _ViewDealPage = __webpack_require__(1093);

var _ViewDealPage2 = _interopRequireDefault(_ViewDealPage);

var _EditUtentePage = __webpack_require__(1099);

var _EditUtentePage2 = _interopRequireDefault(_EditUtentePage);

var _ViewUtentiPage = __webpack_require__(1100);

var _ViewUtentiPage2 = _interopRequireDefault(_ViewUtentiPage);

var _UtentiDashboardPage = __webpack_require__(1101);

var _UtentiDashboardPage2 = _interopRequireDefault(_UtentiDashboardPage);

var _EditFirmaPage = __webpack_require__(1104);

var _EditFirmaPage2 = _interopRequireDefault(_EditFirmaPage);

var _ViewFirmaPage = __webpack_require__(1105);

var _ViewFirmaPage2 = _interopRequireDefault(_ViewFirmaPage);

var _EditClientiPage = __webpack_require__(1106);

var _EditClientiPage2 = _interopRequireDefault(_EditClientiPage);

var _ViewClientiPage = __webpack_require__(1107);

var _ViewClientiPage2 = _interopRequireDefault(_ViewClientiPage);

var _ClientiDashboardPage = __webpack_require__(1109);

var _ClientiDashboardPage2 = _interopRequireDefault(_ClientiDashboardPage);

var _EditFatturaPage = __webpack_require__(1110);

var _EditFatturaPage2 = _interopRequireDefault(_EditFatturaPage);

var _ViewFatturaPage = __webpack_require__(1111);

var _ViewFatturaPage2 = _interopRequireDefault(_ViewFatturaPage);

var _FattureDashboardPage = __webpack_require__(1116);

var _FattureDashboardPage2 = _interopRequireDefault(_FattureDashboardPage);

var _OggettiDashboardPage = __webpack_require__(1117);

var _OggettiDashboardPage2 = _interopRequireDefault(_OggettiDashboardPage);

var _ViewOggettiPage = __webpack_require__(1118);

var _ViewOggettiPage2 = _interopRequireDefault(_ViewOggettiPage);

var _EditOggettoPage = __webpack_require__(1128);

var _EditOggettoPage2 = _interopRequireDefault(_EditOggettoPage);

var _ViewOggettoMatchPage = __webpack_require__(1129);

var _ViewOggettoMatchPage2 = _interopRequireDefault(_ViewOggettoMatchPage);

var _LeadsDashboardPage = __webpack_require__(1130);

var _LeadsDashboardPage2 = _interopRequireDefault(_LeadsDashboardPage);

var _EditLeadPage = __webpack_require__(1132);

var _EditLeadPage2 = _interopRequireDefault(_EditLeadPage);

var _ViewLeadMatchPage = __webpack_require__(1133);

var _ViewLeadMatchPage2 = _interopRequireDefault(_ViewLeadMatchPage);

var _ViewLeadPage = __webpack_require__(1134);

var _ViewLeadPage2 = _interopRequireDefault(_ViewLeadPage);

var _EditOfferedProperties = __webpack_require__(1136);

var _EditOfferedProperties2 = _interopRequireDefault(_EditOfferedProperties);

var _ModuliList = __webpack_require__(1137);

var _ModuliList2 = _interopRequireDefault(_ModuliList);

var _NotFoundPage = __webpack_require__(1138);

var _NotFoundPage2 = _interopRequireDefault(_NotFoundPage);

var _LoginPage = __webpack_require__(1139);

var _LoginPage2 = _interopRequireDefault(_LoginPage);

var _PrivateRoute = __webpack_require__(1140);

var _PrivateRoute2 = _interopRequireDefault(_PrivateRoute);

var _PublicRoute = __webpack_require__(1145);

var _PublicRoute2 = _interopRequireDefault(_PublicRoute);

var _MAAForm = __webpack_require__(1146);

var _MAAForm2 = _interopRequireDefault(_MAAForm);

var _VWBForm = __webpack_require__(1149);

var _VWBForm2 = _interopRequireDefault(_VWBForm);

var _VollmachtForm = __webpack_require__(1150);

var _VollmachtForm2 = _interopRequireDefault(_VollmachtForm);

var _ProvisionForm = __webpack_require__(1152);

var _ProvisionForm2 = _interopRequireDefault(_ProvisionForm);

var _NotarauftragForm = __webpack_require__(1153);

var _NotarauftragForm2 = _interopRequireDefault(_NotarauftragForm);

var _NotarDatenblattForm = __webpack_require__(1154);

var _NotarDatenblattForm2 = _interopRequireDefault(_NotarDatenblattForm);

var _EvaluationDashboard = __webpack_require__(1155);

var _EvaluationDashboard2 = _interopRequireDefault(_EvaluationDashboard);

var _EditEvaluation = __webpack_require__(1156);

var _EditEvaluation2 = _interopRequireDefault(_EditEvaluation);

var _ViewEvaluation = __webpack_require__(1157);

var _ViewEvaluation2 = _interopRequireDefault(_ViewEvaluation);

var _NewsletterDashboard = __webpack_require__(1159);

var _NewsletterDashboard2 = _interopRequireDefault(_NewsletterDashboard);

var _EditNewsletter = __webpack_require__(1161);

var _EditNewsletter2 = _interopRequireDefault(_EditNewsletter);

var _ViewNewsletter = __webpack_require__(1162);

var _ViewNewsletter2 = _interopRequireDefault(_ViewNewsletter);

var _AddPage = __webpack_require__(1164);

var _AddPage2 = _interopRequireDefault(_AddPage);

var _LinksPage = __webpack_require__(1165);

var _LinksPage2 = _interopRequireDefault(_LinksPage);

var _DsgvoForm = __webpack_require__(1181);

var _DsgvoForm2 = _interopRequireDefault(_DsgvoForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var history = exports.history = (0, _createBrowserHistory2.default)();

var AppRouter = function AppRouter() {
  return _react2.default.createElement(
    _reactRouterDom.Router,
    { history: history },
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        _reactRouterDom.Switch,
        null,
        _react2.default.createElement(_PublicRoute2.default, { path: '/', component: _LoginPage2.default, exact: true }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/deals',
          activeClass: 'deals',
          component: _DealDashboardPage2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/create',
          activeClass: 'deals',
          component: _AddPage2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/edit/:id',
          activeClass: 'deals',
          component: _EditDealPage2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/view/:id',
          activeClass: 'deals',
          component: _ViewDealPage2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/clienti',
          activeClass: 'clienti',
          component: _ClientiDashboardPage2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/clienticreate',
          activeClass: 'clienti',
          component: _AddPage2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/clientiedit/:id',
          activeClass: 'clienti',
          component: _EditClientiPage2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/clientiview/:id',
          activeClass: 'clienti',
          component: _ViewClientiPage2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/oggetti',
          activeClass: 'oggetti',
          component: _OggettiDashboardPage2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/oggettocreate',
          activeClass: 'oggetti',
          component: _AddPage2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/oggettoview/:id',
          activeClass: 'oggetti',
          component: _ViewOggettiPage2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/oggettoedit/:id',
          activeClass: 'oggetti',
          component: _EditOggettoPage2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/oggettomatchview/:id',
          component: _ViewOggettoMatchPage2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/evaluations',
          activeClass: 'evaluations',
          component: _EvaluationDashboard2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/evaluationcreate',
          activeClass: 'evaluations',
          component: _AddPage2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/evaluationedit/:id',
          activeClass: 'evaluations',
          component: _EditEvaluation2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/evaluationview/:id',
          activeClass: 'evaluations',
          component: _ViewEvaluation2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/newsletters',
          activeClass: 'newsletters',
          component: _NewsletterDashboard2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/newslettercreate',
          activeClass: 'newsletters',
          component: _AddPage2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/newsletteredit/:id',
          activeClass: 'newsletters',
          component: _EditNewsletter2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/newsletterview/:id',
          activeClass: 'newsletters',
          component: _ViewNewsletter2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/utenti',
          activeClass: 'utenti',
          component: _UtentiDashboardPage2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/utenticreate',
          activeClass: 'utenti',
          component: _AddPage2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/utentiedit/:id',
          activeClass: 'utenti',
          component: _EditUtentePage2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/utentiview/:id',
          activeClass: 'utenti',
          component: _ViewUtentiPage2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/firma',
          activeClass: 'firma',
          component: _UtentiDashboardPage2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/firmacreate',
          activeClass: 'firma',
          component: _AddPage2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/firmaview/:id',
          activeClass: 'firma',
          component: _ViewFirmaPage2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/firmaedit/:id',
          activeClass: 'firma',
          component: _EditFirmaPage2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/fatture',
          activeClass: 'fatture',
          component: _FattureDashboardPage2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/fatturacreate',
          activeClass: 'fatture',
          component: _AddPage2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/fatturaview/:id',
          activeClass: 'fatture',
          component: _ViewFatturaPage2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/fatturaedit/:id',
          activeClass: 'fatture',
          component: _EditFatturaPage2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/leads',
          activeClass: 'leads',
          component: _LeadsDashboardPage2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/leadscreate',
          activeClass: 'leads',
          component: _AddPage2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/leadedit/:id',
          activeClass: 'leads',
          component: _EditLeadPage2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/leadmatchview/:id',
          activeClass: 'leads',
          component: _ViewLeadMatchPage2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/leadview/:id',
          activeClass: 'leads',
          component: _ViewLeadPage2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/editoffer/:id',
          activeClass: 'offers',
          component: _EditOfferedProperties2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/createoffer',
          activeClass: 'offers',
          component: _AddPage2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/links',
          activeClass: 'links',
          component: _LinksPage2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/moduli',
          activeClass: 'moduli',
          component: _ModuliList2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/makleralleinauftrag',
          activeClass: 'moduli',
          component: _MAAForm2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/provisionsbestaetigung',
          activeClass: 'moduli',
          component: _ProvisionForm2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/widerrufsbelehrung',
          activeClass: 'moduli',
          component: _VWBForm2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/vollmachtnotarauftrag',
          activeClass: 'moduli',
          component: _NotarauftragForm2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/vollmachtunterlagen',
          activeClass: 'moduli',
          component: _VollmachtForm2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/notardatenblatt',
          activeClass: 'moduli',
          component: _NotarDatenblattForm2.default
        }),
        _react2.default.createElement(_PrivateRoute2.default, {
          path: '/dsgvo',
          activeClass: 'moduli',
          component: _DsgvoForm2.default
        }),
        _react2.default.createElement(_reactRouterDom.Route, { component: _NotFoundPage2.default })
      )
    )
  );
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    uid: state.auth.uid
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(AppRouter);

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _implementation = __webpack_require__(909);

var _implementation2 = _interopRequireDefault(_implementation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gud = __webpack_require__(910);

var _gud2 = _interopRequireDefault(_gud);

var _warning = __webpack_require__(911);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (false) {
            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(_react.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(_react.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);


  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports.default = createReactContext;
module.exports = exports['default'];

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(912);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createBrowserHistory */
/* unused harmony export createHashHistory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(146);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */]({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["default"](location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && __WEBPACK_IMPORTED_MODULE_2_value_equal__["default"](a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */](false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */](history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');
  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */](false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */](history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    return '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */](history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(915)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 915 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.6
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
exports.isSuspense=function(a){return t(a)===p};


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var ReactIs = __webpack_require__(277);
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};

var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};

var TYPE_STATICS = {};
TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;

function getStatics(component) {
    if (ReactIs.isMemo(component)) {
        return MEMO_STATICS;
    }
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* unused harmony export createMemoryHistory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* unused harmony export locationsAreEqual */
/* unused harmony export parsePath */
/* unused harmony export createPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(146);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */]({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["default"](location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && __WEBPACK_IMPORTED_MODULE_2_value_equal__["default"](a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */](false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */](history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');
  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */](false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */](history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    return '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */](history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(279);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(267);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(920);

var _PathUtils = __webpack_require__(280);

var _createTransitionManager = __webpack_require__(921);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(922);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolvePathname = __webpack_require__(193);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(194);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(280);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(279);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _DealList = __webpack_require__(195);

var _DealList2 = _interopRequireDefault(_DealList);

var _ListFilters = __webpack_require__(96);

var _ListFilters2 = _interopRequireDefault(_ListFilters);

var _DealsSummary = __webpack_require__(989);

var _DealsSummary2 = _interopRequireDefault(_DealsSummary);

var _configureStore = __webpack_require__(14);

var _elements = __webpack_require__(18);

var _Intestazione = __webpack_require__(20);

var _Intestazione2 = _interopRequireDefault(_Intestazione);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DealDashboardPage = function (_React$Component) {
  _inherits(DealDashboardPage, _React$Component);

  function DealDashboardPage() {
    _classCallCheck(this, DealDashboardPage);

    return _possibleConstructorReturn(this, (DealDashboardPage.__proto__ || Object.getPrototypeOf(DealDashboardPage)).apply(this, arguments));
  }

  _createClass(DealDashboardPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.startSetDeals();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          utente = _props.utente;

      var options = [{ value: 'date', label: 'Data' }, { value: 'amount', label: 'Importo' }, { value: 'paid', label: 'Pagato' }];
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Intestazione2.default, { intestazione: t('Vendite') }),
        _react2.default.createElement(_ListFilters2.default, { options: options }),
        _react2.default.createElement(_DealsSummary2.default, null),
        utente && (utente.role === 'Admin' || utente.role === 'Geschäftsführer') && (0, _elements.addButton)('/create'),
        utente && _react2.default.createElement(_DealList2.default, null)
      );
    }
  }]);

  return DealDashboardPage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    utente: state.utenti.find(function (utente) {
      return utente.firebaseAuthId === state.auth.uid;
    })
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    startSetDeals: function startSetDeals() {
      return dispatch(_configureStore.storeActions.find(function (action) {
        return action.label === 'deals';
      }).startSetAction());
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactI18next.withTranslation)()(DealDashboardPage));

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 282,
	"./af.js": 282,
	"./ar": 283,
	"./ar-dz": 284,
	"./ar-dz.js": 284,
	"./ar-kw": 285,
	"./ar-kw.js": 285,
	"./ar-ly": 286,
	"./ar-ly.js": 286,
	"./ar-ma": 287,
	"./ar-ma.js": 287,
	"./ar-sa": 288,
	"./ar-sa.js": 288,
	"./ar-tn": 289,
	"./ar-tn.js": 289,
	"./ar.js": 283,
	"./az": 290,
	"./az.js": 290,
	"./be": 291,
	"./be.js": 291,
	"./bg": 292,
	"./bg.js": 292,
	"./bn": 293,
	"./bn.js": 293,
	"./bo": 294,
	"./bo.js": 294,
	"./br": 295,
	"./br.js": 295,
	"./bs": 296,
	"./bs.js": 296,
	"./ca": 297,
	"./ca.js": 297,
	"./cs": 298,
	"./cs.js": 298,
	"./cv": 299,
	"./cv.js": 299,
	"./cy": 300,
	"./cy.js": 300,
	"./da": 301,
	"./da.js": 301,
	"./de": 302,
	"./de-at": 303,
	"./de-at.js": 303,
	"./de-ch": 304,
	"./de-ch.js": 304,
	"./de.js": 302,
	"./dv": 305,
	"./dv.js": 305,
	"./el": 306,
	"./el.js": 306,
	"./en-au": 307,
	"./en-au.js": 307,
	"./en-ca": 308,
	"./en-ca.js": 308,
	"./en-gb": 309,
	"./en-gb.js": 309,
	"./en-ie": 310,
	"./en-ie.js": 310,
	"./en-nz": 311,
	"./en-nz.js": 311,
	"./eo": 312,
	"./eo.js": 312,
	"./es": 313,
	"./es-do": 314,
	"./es-do.js": 314,
	"./es.js": 313,
	"./et": 315,
	"./et.js": 315,
	"./eu": 316,
	"./eu.js": 316,
	"./fa": 317,
	"./fa.js": 317,
	"./fi": 318,
	"./fi.js": 318,
	"./fo": 319,
	"./fo.js": 319,
	"./fr": 320,
	"./fr-ca": 321,
	"./fr-ca.js": 321,
	"./fr-ch": 322,
	"./fr-ch.js": 322,
	"./fr.js": 320,
	"./fy": 323,
	"./fy.js": 323,
	"./gd": 324,
	"./gd.js": 324,
	"./gl": 325,
	"./gl.js": 325,
	"./gom-latn": 326,
	"./gom-latn.js": 326,
	"./he": 327,
	"./he.js": 327,
	"./hi": 328,
	"./hi.js": 328,
	"./hr": 329,
	"./hr.js": 329,
	"./hu": 330,
	"./hu.js": 330,
	"./hy-am": 331,
	"./hy-am.js": 331,
	"./id": 332,
	"./id.js": 332,
	"./is": 333,
	"./is.js": 333,
	"./it": 334,
	"./it.js": 334,
	"./ja": 335,
	"./ja.js": 335,
	"./jv": 336,
	"./jv.js": 336,
	"./ka": 337,
	"./ka.js": 337,
	"./kk": 338,
	"./kk.js": 338,
	"./km": 339,
	"./km.js": 339,
	"./kn": 340,
	"./kn.js": 340,
	"./ko": 341,
	"./ko.js": 341,
	"./ky": 342,
	"./ky.js": 342,
	"./lb": 343,
	"./lb.js": 343,
	"./lo": 344,
	"./lo.js": 344,
	"./lt": 345,
	"./lt.js": 345,
	"./lv": 346,
	"./lv.js": 346,
	"./me": 347,
	"./me.js": 347,
	"./mi": 348,
	"./mi.js": 348,
	"./mk": 349,
	"./mk.js": 349,
	"./ml": 350,
	"./ml.js": 350,
	"./mr": 351,
	"./mr.js": 351,
	"./ms": 352,
	"./ms-my": 353,
	"./ms-my.js": 353,
	"./ms.js": 352,
	"./my": 354,
	"./my.js": 354,
	"./nb": 355,
	"./nb.js": 355,
	"./ne": 356,
	"./ne.js": 356,
	"./nl": 357,
	"./nl-be": 358,
	"./nl-be.js": 358,
	"./nl.js": 357,
	"./nn": 359,
	"./nn.js": 359,
	"./pa-in": 360,
	"./pa-in.js": 360,
	"./pl": 361,
	"./pl.js": 361,
	"./pt": 362,
	"./pt-br": 363,
	"./pt-br.js": 363,
	"./pt.js": 362,
	"./ro": 364,
	"./ro.js": 364,
	"./ru": 365,
	"./ru.js": 365,
	"./sd": 366,
	"./sd.js": 366,
	"./se": 367,
	"./se.js": 367,
	"./si": 368,
	"./si.js": 368,
	"./sk": 369,
	"./sk.js": 369,
	"./sl": 370,
	"./sl.js": 370,
	"./sq": 371,
	"./sq.js": 371,
	"./sr": 372,
	"./sr-cyrl": 373,
	"./sr-cyrl.js": 373,
	"./sr.js": 372,
	"./ss": 374,
	"./ss.js": 374,
	"./sv": 375,
	"./sv.js": 375,
	"./sw": 376,
	"./sw.js": 376,
	"./ta": 377,
	"./ta.js": 377,
	"./te": 378,
	"./te.js": 378,
	"./tet": 379,
	"./tet.js": 379,
	"./th": 380,
	"./th.js": 380,
	"./tl-ph": 381,
	"./tl-ph.js": 381,
	"./tlh": 382,
	"./tlh.js": 382,
	"./tr": 383,
	"./tr.js": 383,
	"./tzl": 384,
	"./tzl.js": 384,
	"./tzm": 385,
	"./tzm-latn": 386,
	"./tzm-latn.js": 386,
	"./tzm.js": 385,
	"./uk": 387,
	"./uk.js": 387,
	"./ur": 388,
	"./ur.js": 388,
	"./uz": 389,
	"./uz-latn": 390,
	"./uz-latn.js": 390,
	"./uz.js": 389,
	"./vi": 391,
	"./vi.js": 391,
	"./x-pseudo": 392,
	"./x-pseudo.js": 392,
	"./yo": 393,
	"./yo.js": 393,
	"./zh-cn": 394,
	"./zh-cn.js": 394,
	"./zh-hk": 395,
	"./zh-hk.js": 395,
	"./zh-tw": 396,
	"./zh-tw.js": 396
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 924;

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

var v1 = __webpack_require__(926);
var v4 = __webpack_require__(927);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(397);
var bytesToUuid = __webpack_require__(398);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

// random #'s we need to init node and clockseq
var _seedBytes = rng();

// Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
var _nodeId = [
  _seedBytes[0] | 0x01,
  _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
];

// Per 4.2.2, randomize (14 bit) clockseq
var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;

// Previous uuid creation time
var _lastMSecs = 0, _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};

  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  var node = options.node || _nodeId;
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(397);
var bytesToUuid = __webpack_require__(398);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options == 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProgressBar = function ProgressBar(props) {
  return _react2.default.createElement(
    'div',
    { className: 'progress-bar' },
    _react2.default.createElement(Filler, { percentage: props.percentage })
  );
};

var Filler = function Filler(props) {
  return _react2.default.createElement('div', { className: 'filler', style: { width: props.percentage + '%' } });
};

var TodoProgressBar = function TodoProgressBar(_ref) {
  var t = _ref.t,
      todo1 = _ref.todo1,
      todo2 = _ref.todo2,
      todo3 = _ref.todo3,
      todo4 = _ref.todo4,
      todo5 = _ref.todo5,
      todo6 = _ref.todo6,
      todo7 = _ref.todo7,
      todo8 = _ref.todo8,
      todo9 = _ref.todo9,
      todo10 = _ref.todo10,
      todo11 = _ref.todo11;

  // conto i todo fatti
  var todoCount = 0;
  todo1 && todoCount++;
  todo2 && todoCount++;
  todo3 && todoCount++;
  todo4 && todoCount++;
  todo5 && todoCount++;
  todo6 && todoCount++;
  todo7 && todoCount++;
  todo8 && todoCount++;
  todo9 && todoCount++;
  todo10 && todoCount++;
  todo11 && todoCount++;
  return _react2.default.createElement(
    'blockquote',
    null,
    t('To-do eseguiti') + ': ' + todoCount + ' von 11',
    _react2.default.createElement(ProgressBar, { percentage: todoCount * 100 / 11 })
  );
};
exports.default = (0, _reactI18next.withTranslation)()(TodoProgressBar);

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(36);
var bind = __webpack_require__(399);
var Axios = __webpack_require__(930);
var mergeConfig = __webpack_require__(405);
var defaults = __webpack_require__(402);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(406);
axios.CancelToken = __webpack_require__(943);
axios.isCancel = __webpack_require__(401);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(944);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(36);
var buildURL = __webpack_require__(400);
var InterceptorManager = __webpack_require__(931);
var dispatchRequest = __webpack_require__(932);
var mergeConfig = __webpack_require__(405);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(36);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(36);
var transformData = __webpack_require__(933);
var isCancel = __webpack_require__(401);
var defaults = __webpack_require__(402);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(36);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(36);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(404);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(938);
var combineURLs = __webpack_require__(939);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(36);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(36);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(36);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(406);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 65);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(2);

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(24);

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(12);

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(27);

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(44);

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(0);

/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(97);

/***/ }),
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function () {
      function render() {
        return _react2["default"].createElement(
          "svg",
          _extends({ viewBox: "0 0 12 12" }, this.props),
          _react2["default"].createElement("path", { fillRule: "evenodd", d: "M11.53.47a.75.75 0 0 0-1.061 0l-4.47 4.47L1.529.47A.75.75 0 1 0 .468 1.531l4.47 4.47-4.47 4.47a.75.75 0 1 0 1.061 1.061l4.47-4.47 4.47 4.47a.75.75 0 1 0 1.061-1.061l-4.47-4.47 4.47-4.47a.75.75 0 0 0 0-1.061z" })
        );
      }

      return render;
    }()
  }]);

  return SVG;
}(_react2["default"].Component);

exports["default"] = SVG;

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(111);

/***/ }),
/* 15 */,
/* 16 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(112);

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(148);

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(149);

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(408);

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(94);

/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(409);

/***/ }),
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(410);

/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(545);

/***/ }),
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(551);

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(39);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactAddonsShallowCompare = __webpack_require__(14);

var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);

var _moment = __webpack_require__(7);

var _moment2 = _interopRequireDefault(_moment);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactPortal = __webpack_require__(40);

var _reactPortal2 = _interopRequireDefault(_reactPortal);

var _airbnbPropTypes = __webpack_require__(1);

var _consolidatedEvents = __webpack_require__(18);

var _isTouchDevice = __webpack_require__(9);

var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);

var _defaultPhrases = __webpack_require__(3);

var _OutsideClickHandler = __webpack_require__(17);

var _OutsideClickHandler2 = _interopRequireDefault(_OutsideClickHandler);

var _getResponsiveContainerStyles = __webpack_require__(29);

var _getResponsiveContainerStyles2 = _interopRequireDefault(_getResponsiveContainerStyles);

var _isInclusivelyAfterDay = __webpack_require__(16);

var _isInclusivelyAfterDay2 = _interopRequireDefault(_isInclusivelyAfterDay);

var _DateRangePickerInputController = __webpack_require__(55);

var _DateRangePickerInputController2 = _interopRequireDefault(_DateRangePickerInputController);

var _DayPickerRangeController = __webpack_require__(58);

var _DayPickerRangeController2 = _interopRequireDefault(_DayPickerRangeController);

var _close = __webpack_require__(11);

var _close2 = _interopRequireDefault(_close);

var _DateRangePickerShape = __webpack_require__(43);

var _DateRangePickerShape2 = _interopRequireDefault(_DateRangePickerShape);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(_DateRangePickerShape2['default']);

var defaultProps = {
  // required props for a functional interactive DateRangePicker
  startDate: null,
  endDate: null,
  focusedInput: null,

  // input related props
  startDateId: _constants.START_DATE,
  startDatePlaceholderText: 'Start Date',
  endDateId: _constants.END_DATE,
  endDatePlaceholderText: 'End Date',
  disabled: false,
  required: false,
  readOnly: false,
  screenReaderInputMessage: '',
  showClearDates: false,
  showDefaultInputIcon: false,
  inputIconPosition: _constants.ICON_BEFORE_POSITION,
  customInputIcon: null,
  customArrowIcon: null,
  customCloseIcon: null,

  // calendar presentation and interaction related props
  renderMonth: null,
  orientation: _constants.HORIZONTAL_ORIENTATION,
  anchorDirection: _constants.ANCHOR_LEFT,
  openDirection: _constants.OPEN_DOWN,
  horizontalMargin: 0,
  withPortal: false,
  withFullScreenPortal: false,
  initialVisibleMonth: null,
  numberOfMonths: 2,
  keepOpenOnDateSelect: false,
  reopenPickerOnClearDates: false,
  renderCalendarInfo: null,
  hideKeyboardShortcutsPanel: false,
  daySize: _constants.DAY_SIZE,
  isRTL: false,
  firstDayOfWeek: null,

  // navigation related props
  navPrev: null,
  navNext: null,

  onPrevMonthClick: function () {
    function onPrevMonthClick() {}

    return onPrevMonthClick;
  }(),
  onNextMonthClick: function () {
    function onNextMonthClick() {}

    return onNextMonthClick;
  }(),
  onClose: function () {
    function onClose() {}

    return onClose;
  }(),

  // day presentation and interaction related props
  renderDay: null,
  minimumNights: 1,
  enableOutsideDays: false,
  isDayBlocked: function () {
    function isDayBlocked() {
      return false;
    }

    return isDayBlocked;
  }(),
  isOutsideRange: function () {
    function isOutsideRange(day) {
      return !(0, _isInclusivelyAfterDay2['default'])(day, (0, _moment2['default'])());
    }

    return isOutsideRange;
  }(),
  isDayHighlighted: function () {
    function isDayHighlighted() {
      return false;
    }

    return isDayHighlighted;
  }(),

  // internationalization
  displayFormat: function () {
    function displayFormat() {
      return _moment2['default'].localeData().longDateFormat('L');
    }

    return displayFormat;
  }(),
  monthFormat: 'MMMM YYYY',
  weekDayFormat: 'dd',
  phrases: _defaultPhrases.DateRangePickerPhrases
};

var DateRangePicker = function (_React$Component) {
  _inherits(DateRangePicker, _React$Component);

  function DateRangePicker(props) {
    _classCallCheck(this, DateRangePicker);

    var _this = _possibleConstructorReturn(this, (DateRangePicker.__proto__ || Object.getPrototypeOf(DateRangePicker)).call(this, props));

    _this.state = {
      dayPickerContainerStyles: {},
      isDateRangePickerInputFocused: false,
      isDayPickerFocused: false,
      showKeyboardShortcuts: false
    };

    _this.isTouchDevice = false;

    _this.onOutsideClick = _this.onOutsideClick.bind(_this);
    _this.onDateRangePickerInputFocus = _this.onDateRangePickerInputFocus.bind(_this);
    _this.onDayPickerFocus = _this.onDayPickerFocus.bind(_this);
    _this.onDayPickerBlur = _this.onDayPickerBlur.bind(_this);
    _this.showKeyboardShortcutsPanel = _this.showKeyboardShortcutsPanel.bind(_this);

    _this.responsivizePickerPosition = _this.responsivizePickerPosition.bind(_this);

    _this.setDayPickerContainerRef = _this.setDayPickerContainerRef.bind(_this);
    _this.setDayPickerRef = _this.setDayPickerRef.bind(_this);
    return _this;
  }

  _createClass(DateRangePicker, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        this.resizeHandle = (0, _consolidatedEvents.addEventListener)(window, 'resize', this.responsivizePickerPosition, { passive: true });
        this.responsivizePickerPosition();

        if (this.props.focusedInput) {
          this.setState({
            isDateRangePickerInputFocused: true
          });
        }

        this.isTouchDevice = (0, _isTouchDevice2['default'])();
      }

      return componentDidMount;
    }()
  }, {
    key: 'shouldComponentUpdate',
    value: function () {
      function shouldComponentUpdate(nextProps, nextState) {
        return (0, _reactAddonsShallowCompare2['default'])(this, nextProps, nextState);
      }

      return shouldComponentUpdate;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate(prevProps) {
        if (!prevProps.focusedInput && this.props.focusedInput && this.isOpened()) {
          // The date picker just changed from being closed to being open.
          this.responsivizePickerPosition();
        }
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        if (this.resizeHandle) (0, _consolidatedEvents.removeEventListener)(this.resizeHandle);
      }

      return componentWillUnmount;
    }()
  }, {
    key: 'onOutsideClick',
    value: function () {
      function onOutsideClick() {
        var _props = this.props,
            onFocusChange = _props.onFocusChange,
            onClose = _props.onClose,
            startDate = _props.startDate,
            endDate = _props.endDate;

        if (!this.isOpened()) return;

        this.setState({
          isDateRangePickerInputFocused: false,
          isDayPickerFocused: false,
          showKeyboardShortcuts: false
        });

        onFocusChange(null);
        onClose({ startDate: startDate, endDate: endDate });
      }

      return onOutsideClick;
    }()
  }, {
    key: 'onDateRangePickerInputFocus',
    value: function () {
      function onDateRangePickerInputFocus(focusedInput) {
        var _props2 = this.props,
            onFocusChange = _props2.onFocusChange,
            withPortal = _props2.withPortal,
            withFullScreenPortal = _props2.withFullScreenPortal;

        if (focusedInput) {
          var moveFocusToDayPicker = withPortal || withFullScreenPortal || this.isTouchDevice;
          if (moveFocusToDayPicker) {
            this.onDayPickerFocus();
          } else {
            this.onDayPickerBlur();
          }
        }

        onFocusChange(focusedInput);
      }

      return onDateRangePickerInputFocus;
    }()
  }, {
    key: 'onDayPickerFocus',
    value: function () {
      function onDayPickerFocus() {
        var _props3 = this.props,
            focusedInput = _props3.focusedInput,
            onFocusChange = _props3.onFocusChange;

        if (!focusedInput) onFocusChange(_constants.START_DATE);

        this.setState({
          isDateRangePickerInputFocused: false,
          isDayPickerFocused: true,
          showKeyboardShortcuts: false
        });
      }

      return onDayPickerFocus;
    }()
  }, {
    key: 'onDayPickerBlur',
    value: function () {
      function onDayPickerBlur() {
        this.setState({
          isDateRangePickerInputFocused: true,
          isDayPickerFocused: false,
          showKeyboardShortcuts: false
        });
      }

      return onDayPickerBlur;
    }()
  }, {
    key: 'getDayPickerContainerClasses',
    value: function () {
      function getDayPickerContainerClasses() {
        var _props4 = this.props,
            orientation = _props4.orientation,
            withPortal = _props4.withPortal,
            withFullScreenPortal = _props4.withFullScreenPortal,
            anchorDirection = _props4.anchorDirection,
            openDirection = _props4.openDirection,
            isRTL = _props4.isRTL;

        var dayPickerClassName = (0, _classnames2['default'])('DateRangePicker__picker', {
          'DateRangePicker__picker--direction-left': anchorDirection === _constants.ANCHOR_LEFT,
          'DateRangePicker__picker--direction-right': anchorDirection === _constants.ANCHOR_RIGHT,
          'DateRangePicker__picker--open-down': openDirection === _constants.OPEN_DOWN,
          'DateRangePicker__picker--open-up': openDirection === _constants.OPEN_UP,
          'DateRangePicker__picker--horizontal': orientation === _constants.HORIZONTAL_ORIENTATION,
          'DateRangePicker__picker--vertical': orientation === _constants.VERTICAL_ORIENTATION,
          'DateRangePicker__picker--portal': withPortal || withFullScreenPortal,
          'DateRangePicker__picker--full-screen-portal': withFullScreenPortal,
          'DateRangePicker__picker--rtl': isRTL
        });

        return dayPickerClassName;
      }

      return getDayPickerContainerClasses;
    }()
  }, {
    key: 'getDayPickerDOMNode',
    value: function () {
      function getDayPickerDOMNode() {
        return _reactDom2['default'].findDOMNode(this.dayPicker); // eslint-disable-line react/no-find-dom-node
      }

      return getDayPickerDOMNode;
    }()
  }, {
    key: 'setDayPickerContainerRef',
    value: function () {
      function setDayPickerContainerRef(ref) {
        this.dayPickerContainer = ref;
      }

      return setDayPickerContainerRef;
    }()
  }, {
    key: 'setDayPickerRef',
    value: function () {
      function setDayPickerRef(ref) {
        this.dayPicker = ref;
      }

      return setDayPickerRef;
    }()
  }, {
    key: 'isOpened',
    value: function () {
      function isOpened() {
        var focusedInput = this.props.focusedInput;

        return focusedInput === _constants.START_DATE || focusedInput === _constants.END_DATE;
      }

      return isOpened;
    }()
  }, {
    key: 'responsivizePickerPosition',
    value: function () {
      function responsivizePickerPosition() {
        // It's possible the portal props have been changed in response to window resizes
        // So let's ensure we reset this back to the base state each time
        this.setState({ dayPickerContainerStyles: {} });

        if (!this.isOpened()) {
          return;
        }

        var _props5 = this.props,
            anchorDirection = _props5.anchorDirection,
            horizontalMargin = _props5.horizontalMargin,
            withPortal = _props5.withPortal,
            withFullScreenPortal = _props5.withFullScreenPortal;
        var dayPickerContainerStyles = this.state.dayPickerContainerStyles;

        var isAnchoredLeft = anchorDirection === _constants.ANCHOR_LEFT;
        if (!withPortal && !withFullScreenPortal) {
          var containerRect = this.dayPickerContainer.getBoundingClientRect();
          var currentOffset = dayPickerContainerStyles[anchorDirection] || 0;
          var containerEdge = isAnchoredLeft ? containerRect[_constants.ANCHOR_RIGHT] : containerRect[_constants.ANCHOR_LEFT];

          this.setState({
            dayPickerContainerStyles: (0, _getResponsiveContainerStyles2['default'])(anchorDirection, currentOffset, containerEdge, horizontalMargin)
          });
        }
      }

      return responsivizePickerPosition;
    }()
  }, {
    key: 'showKeyboardShortcutsPanel',
    value: function () {
      function showKeyboardShortcutsPanel() {
        this.setState({
          isDateRangePickerInputFocused: false,
          isDayPickerFocused: true,
          showKeyboardShortcuts: true
        });
      }

      return showKeyboardShortcutsPanel;
    }()
  }, {
    key: 'maybeRenderDayPickerWithPortal',
    value: function () {
      function maybeRenderDayPickerWithPortal() {
        var _props6 = this.props,
            withPortal = _props6.withPortal,
            withFullScreenPortal = _props6.withFullScreenPortal;

        if (!this.isOpened()) {
          return null;
        }

        if (withPortal || withFullScreenPortal) {
          return _react2['default'].createElement(_reactPortal2['default'], { isOpened: true }, this.renderDayPicker());
        }

        return this.renderDayPicker();
      }

      return maybeRenderDayPickerWithPortal;
    }()
  }, {
    key: 'renderDayPicker',
    value: function () {
      function renderDayPicker() {
        var _props7 = this.props,
            isDayBlocked = _props7.isDayBlocked,
            isDayHighlighted = _props7.isDayHighlighted,
            isOutsideRange = _props7.isOutsideRange,
            numberOfMonths = _props7.numberOfMonths,
            orientation = _props7.orientation,
            monthFormat = _props7.monthFormat,
            renderMonth = _props7.renderMonth,
            navPrev = _props7.navPrev,
            navNext = _props7.navNext,
            onPrevMonthClick = _props7.onPrevMonthClick,
            onNextMonthClick = _props7.onNextMonthClick,
            onDatesChange = _props7.onDatesChange,
            onFocusChange = _props7.onFocusChange,
            withPortal = _props7.withPortal,
            withFullScreenPortal = _props7.withFullScreenPortal,
            daySize = _props7.daySize,
            enableOutsideDays = _props7.enableOutsideDays,
            focusedInput = _props7.focusedInput,
            startDate = _props7.startDate,
            endDate = _props7.endDate,
            minimumNights = _props7.minimumNights,
            keepOpenOnDateSelect = _props7.keepOpenOnDateSelect,
            renderDay = _props7.renderDay,
            renderCalendarInfo = _props7.renderCalendarInfo,
            firstDayOfWeek = _props7.firstDayOfWeek,
            initialVisibleMonth = _props7.initialVisibleMonth,
            hideKeyboardShortcutsPanel = _props7.hideKeyboardShortcutsPanel,
            customCloseIcon = _props7.customCloseIcon,
            onClose = _props7.onClose,
            phrases = _props7.phrases,
            isRTL = _props7.isRTL,
            weekDayFormat = _props7.weekDayFormat;
        var _state = this.state,
            dayPickerContainerStyles = _state.dayPickerContainerStyles,
            isDayPickerFocused = _state.isDayPickerFocused,
            showKeyboardShortcuts = _state.showKeyboardShortcuts;

        var onOutsideClick = !withFullScreenPortal && withPortal ? this.onOutsideClick : undefined;
        var initialVisibleMonthThunk = initialVisibleMonth || function () {
          return startDate || endDate || (0, _moment2['default'])();
        };

        var closeIcon = customCloseIcon || _react2['default'].createElement(_close2['default'], null);

        return _react2['default'].createElement('div', { // eslint-disable-line jsx-a11y/no-static-element-interactions
          ref: this.setDayPickerContainerRef,
          className: this.getDayPickerContainerClasses(),
          style: dayPickerContainerStyles,
          onClick: onOutsideClick
        }, _react2['default'].createElement(_DayPickerRangeController2['default'], {
          ref: this.setDayPickerRef,
          orientation: orientation,
          enableOutsideDays: enableOutsideDays,
          numberOfMonths: numberOfMonths,
          onPrevMonthClick: onPrevMonthClick,
          onNextMonthClick: onNextMonthClick,
          onDatesChange: onDatesChange,
          onFocusChange: onFocusChange,
          onClose: onClose,
          focusedInput: focusedInput,
          startDate: startDate,
          endDate: endDate,
          monthFormat: monthFormat,
          renderMonth: renderMonth,
          withPortal: withPortal || withFullScreenPortal,
          daySize: daySize,
          initialVisibleMonth: initialVisibleMonthThunk,
          hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
          navPrev: navPrev,
          navNext: navNext,
          minimumNights: minimumNights,
          isOutsideRange: isOutsideRange,
          isDayHighlighted: isDayHighlighted,
          isDayBlocked: isDayBlocked,
          keepOpenOnDateSelect: keepOpenOnDateSelect,
          renderDay: renderDay,
          renderCalendarInfo: renderCalendarInfo,
          isFocused: isDayPickerFocused,
          showKeyboardShortcuts: showKeyboardShortcuts,
          onBlur: this.onDayPickerBlur,
          phrases: phrases,
          isRTL: isRTL,
          firstDayOfWeek: firstDayOfWeek,
          weekDayFormat: weekDayFormat
        }), withFullScreenPortal && _react2['default'].createElement('button', {
          className: 'DateRangePicker__close',
          type: 'button',
          onClick: this.onOutsideClick,
          'aria-label': phrases.closeDatePicker
        }, _react2['default'].createElement('div', { className: 'DateRangePicker__close' }, closeIcon)));
      }

      return renderDayPicker;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props8 = this.props,
            startDate = _props8.startDate,
            startDateId = _props8.startDateId,
            startDatePlaceholderText = _props8.startDatePlaceholderText,
            endDate = _props8.endDate,
            endDateId = _props8.endDateId,
            endDatePlaceholderText = _props8.endDatePlaceholderText,
            focusedInput = _props8.focusedInput,
            screenReaderInputMessage = _props8.screenReaderInputMessage,
            showClearDates = _props8.showClearDates,
            showDefaultInputIcon = _props8.showDefaultInputIcon,
            inputIconPosition = _props8.inputIconPosition,
            customInputIcon = _props8.customInputIcon,
            customArrowIcon = _props8.customArrowIcon,
            customCloseIcon = _props8.customCloseIcon,
            disabled = _props8.disabled,
            required = _props8.required,
            readOnly = _props8.readOnly,
            openDirection = _props8.openDirection,
            phrases = _props8.phrases,
            isOutsideRange = _props8.isOutsideRange,
            minimumNights = _props8.minimumNights,
            withPortal = _props8.withPortal,
            withFullScreenPortal = _props8.withFullScreenPortal,
            displayFormat = _props8.displayFormat,
            reopenPickerOnClearDates = _props8.reopenPickerOnClearDates,
            keepOpenOnDateSelect = _props8.keepOpenOnDateSelect,
            onDatesChange = _props8.onDatesChange,
            onClose = _props8.onClose,
            isRTL = _props8.isRTL;
        var isDateRangePickerInputFocused = this.state.isDateRangePickerInputFocused;

        var onOutsideClick = !withPortal && !withFullScreenPortal ? this.onOutsideClick : undefined;

        return _react2['default'].createElement('div', { className: 'DateRangePicker' }, _react2['default'].createElement(_OutsideClickHandler2['default'], { onOutsideClick: onOutsideClick }, _react2['default'].createElement(_DateRangePickerInputController2['default'], {
          startDate: startDate,
          startDateId: startDateId,
          startDatePlaceholderText: startDatePlaceholderText,
          isStartDateFocused: focusedInput === _constants.START_DATE,
          endDate: endDate,
          endDateId: endDateId,
          endDatePlaceholderText: endDatePlaceholderText,
          isEndDateFocused: focusedInput === _constants.END_DATE,
          displayFormat: displayFormat,
          showClearDates: showClearDates,
          showCaret: !withPortal && !withFullScreenPortal,
          showDefaultInputIcon: showDefaultInputIcon,
          inputIconPosition: inputIconPosition,
          customInputIcon: customInputIcon,
          customArrowIcon: customArrowIcon,
          customCloseIcon: customCloseIcon,
          disabled: disabled,
          required: required,
          readOnly: readOnly,
          openDirection: openDirection,
          reopenPickerOnClearDates: reopenPickerOnClearDates,
          keepOpenOnDateSelect: keepOpenOnDateSelect,
          isOutsideRange: isOutsideRange,
          minimumNights: minimumNights,
          withFullScreenPortal: withFullScreenPortal,
          onDatesChange: onDatesChange,
          onFocusChange: this.onDateRangePickerInputFocus,
          onArrowDown: this.onDayPickerFocus,
          onQuestionMark: this.showKeyboardShortcutsPanel,
          onClose: onClose,
          phrases: phrases,
          screenReaderMessage: screenReaderInputMessage,
          isFocused: isDateRangePickerInputFocused,
          isRTL: isRTL
        }), this.maybeRenderDayPickerWithPortal()));
      }

      return render;
    }()
  }]);

  return DateRangePicker;
}(_react2['default'].Component);

exports['default'] = DateRangePicker;

DateRangePicker.propTypes = propTypes;
DateRangePicker.defaultProps = defaultProps;

/***/ })
/******/ ]);

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function noop() {
  return null;
}

noop.isRequired = noop;

function noopThunk() {
  return noop;
}

module.exports = {
  and: noopThunk,
  between: noopThunk,
  booleanSome: noopThunk,
  childrenHavePropXorChildren: noopThunk,
  childrenOf: noopThunk,
  childrenOfType: noopThunk,
  childrenSequenceOf: noopThunk,
  componentWithName: noopThunk,
  disallowedIf: noopThunk,
  elementType: noopThunk,
  empty: noopThunk,
  explicitNull: noopThunk,
  forbidExtraProps: Object,
  integer: noopThunk,
  keysOf: noopThunk,
  mutuallyExclusiveProps: noopThunk,
  mutuallyExclusiveTrueProps: noopThunk,
  nChildren: noopThunk,
  nonNegativeInteger: noop,
  nonNegativeNumber: noopThunk,
  numericString: noopThunk,
  object: noopThunk,
  or: noopThunk,
  range: noopThunk,
  ref: noopThunk,
  requiredBy: noopThunk,
  restrictedProp: noopThunk,
  sequenceOf: noopThunk,
  shape: noopThunk,
  stringStartsWith: noopThunk,
  uniqueArray: noopThunk,
  uniqueArrayOf: noopThunk,
  valuesOf: noopThunk,
  withShape: noopThunk
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = normalizeEventOptions;

var _canUsePassiveEventListeners = __webpack_require__(949);

var _canUsePassiveEventListeners2 = _interopRequireDefault(_canUsePassiveEventListeners);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function normalizeEventOptions(eventOptions) {
  if (!eventOptions) {
    return undefined;
  }

  if (!(0, _canUsePassiveEventListeners2['default'])()) {
    // If the browser does not support the passive option, then it is expecting
    // a boolean for the options argument to specify whether it should use
    // capture or not. In more modern browsers, this is passed via the `capture`
    // option, so let's just hoist that value up.
    return !!eventOptions.capture;
  }

  return eventOptions;
}

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = canUsePassiveEventListeners;

var _canUseDOM = __webpack_require__(950);

var _canUseDOM2 = _interopRequireDefault(_canUseDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Adapted from Modernizr
// https://github.com/Modernizr/Modernizr/blob/5eea7e2a/feature-detects/dom/passiveeventlisteners.js#L26-L35
function testPassiveEventListeners() {
  if (!_canUseDOM2['default']) {
    return false;
  }

  if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) {
    return false;
  }

  var supportsPassiveOption = false;
  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function () {
        function get() {
          supportsPassiveOption = true;
        }

        return get;
      }()
    });
    window.addEventListener('test', null, opts);
  } catch (e) {
    // do nothing
  }

  return supportsPassiveOption;
}

var memoized = void 0;

function canUsePassiveEventListeners() {
  if (memoized === undefined) {
    memoized = testPassiveEventListeners();
  }
  return memoized;
}

/***/ }),
/* 950 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports['default'] = CAN_USE_DOM;

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _eventOptionsKey = __webpack_require__(952);

var _eventOptionsKey2 = _interopRequireDefault(_eventOptionsKey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ensureCanMutateNextEventHandlers(eventHandlers) {
  if (eventHandlers.handlers === eventHandlers.nextHandlers) {
    // eslint-disable-next-line no-param-reassign
    eventHandlers.nextHandlers = eventHandlers.handlers.slice();
  }
}

var TargetEventHandlers = function () {
  function TargetEventHandlers(target) {
    _classCallCheck(this, TargetEventHandlers);

    this.target = target;
    this.events = {};
  }

  _createClass(TargetEventHandlers, [{
    key: 'getEventHandlers',
    value: function () {
      function getEventHandlers(eventName, options) {
        var key = String(eventName) + ' ' + String((0, _eventOptionsKey2['default'])(options));

        if (!this.events[key]) {
          this.events[key] = {
            handlers: [],
            handleEvent: undefined
          };
          this.events[key].nextHandlers = this.events[key].handlers;
        }

        return this.events[key];
      }

      return getEventHandlers;
    }()
  }, {
    key: 'handleEvent',
    value: function () {
      function handleEvent(eventName, options, event) {
        var eventHandlers = this.getEventHandlers(eventName, options);
        eventHandlers.handlers = eventHandlers.nextHandlers;
        eventHandlers.handlers.forEach(function (handler) {
          if (handler) {
            // We need to check for presence here because a handler function may
            // cause later handlers to get removed. This can happen if you for
            // instance have a waypoint that unmounts another waypoint as part of an
            // onEnter/onLeave handler.
            handler(event);
          }
        });
      }

      return handleEvent;
    }()
  }, {
    key: 'add',
    value: function () {
      function add(eventName, listener, options) {
        var _this = this;

        // options has already been normalized at this point.
        var eventHandlers = this.getEventHandlers(eventName, options);

        ensureCanMutateNextEventHandlers(eventHandlers);

        if (eventHandlers.nextHandlers.length === 0) {
          eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options);

          this.target.addEventListener(eventName, eventHandlers.handleEvent, options);
        }

        eventHandlers.nextHandlers.push(listener);

        var isSubscribed = true;
        var unsubscribe = function () {
          function unsubscribe() {
            if (!isSubscribed) {
              return;
            }

            isSubscribed = false;

            ensureCanMutateNextEventHandlers(eventHandlers);
            var index = eventHandlers.nextHandlers.indexOf(listener);
            eventHandlers.nextHandlers.splice(index, 1);

            if (eventHandlers.nextHandlers.length === 0) {
              // All event handlers have been removed, so we want to remove the event
              // listener from the target node.

              if (_this.target) {
                // There can be a race condition where the target may no longer exist
                // when this function is called, e.g. when a React component is
                // unmounting. Guarding against this prevents the following error:
                //
                //   Cannot read property 'removeEventListener' of undefined
                _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options);
              }

              eventHandlers.handleEvent = undefined;
            }
          }

          return unsubscribe;
        }();
        return unsubscribe;
      }

      return add;
    }()
  }]);

  return TargetEventHandlers;
}();

exports['default'] = TargetEventHandlers;

/***/ }),
/* 952 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = eventOptionsKey;
/* eslint-disable no-bitwise */

/**
 * Generate a unique key for any set of event options
 */
function eventOptionsKey(normalizedEventOptions) {
  if (!normalizedEventOptions) {
    return 0;
  }

  // If the browser does not support passive event listeners, the normalized
  // event options will be a boolean.
  if (normalizedEventOptions === true) {
    return 100;
  }

  // At this point, the browser supports passive event listeners, so we expect
  // the event options to be an object with possible properties of capture,
  // passive, and once.
  //
  // We want to consistently return the same value, regardless of the order of
  // these properties, so let's use binary maths to assign each property to a
  // bit, and then add those together (with an offset to account for the
  // booleans at the beginning of this function).
  var capture = normalizedEventOptions.capture << 0;
  var passive = normalizedEventOptions.passive << 1;
  var once = normalizedEventOptions.once << 2;
  return capture + passive + once;
}

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 411,
	"./af.js": 411,
	"./ar": 412,
	"./ar-dz": 413,
	"./ar-dz.js": 413,
	"./ar-kw": 414,
	"./ar-kw.js": 414,
	"./ar-ly": 415,
	"./ar-ly.js": 415,
	"./ar-ma": 416,
	"./ar-ma.js": 416,
	"./ar-sa": 417,
	"./ar-sa.js": 417,
	"./ar-tn": 418,
	"./ar-tn.js": 418,
	"./ar.js": 412,
	"./az": 419,
	"./az.js": 419,
	"./be": 420,
	"./be.js": 420,
	"./bg": 421,
	"./bg.js": 421,
	"./bm": 422,
	"./bm.js": 422,
	"./bn": 423,
	"./bn.js": 423,
	"./bo": 424,
	"./bo.js": 424,
	"./br": 425,
	"./br.js": 425,
	"./bs": 426,
	"./bs.js": 426,
	"./ca": 427,
	"./ca.js": 427,
	"./cs": 428,
	"./cs.js": 428,
	"./cv": 429,
	"./cv.js": 429,
	"./cy": 430,
	"./cy.js": 430,
	"./da": 431,
	"./da.js": 431,
	"./de": 432,
	"./de-at": 433,
	"./de-at.js": 433,
	"./de-ch": 434,
	"./de-ch.js": 434,
	"./de.js": 432,
	"./dv": 435,
	"./dv.js": 435,
	"./el": 436,
	"./el.js": 436,
	"./en-SG": 437,
	"./en-SG.js": 437,
	"./en-au": 438,
	"./en-au.js": 438,
	"./en-ca": 439,
	"./en-ca.js": 439,
	"./en-gb": 440,
	"./en-gb.js": 440,
	"./en-ie": 441,
	"./en-ie.js": 441,
	"./en-il": 442,
	"./en-il.js": 442,
	"./en-nz": 443,
	"./en-nz.js": 443,
	"./eo": 444,
	"./eo.js": 444,
	"./es": 445,
	"./es-do": 446,
	"./es-do.js": 446,
	"./es-us": 447,
	"./es-us.js": 447,
	"./es.js": 445,
	"./et": 448,
	"./et.js": 448,
	"./eu": 449,
	"./eu.js": 449,
	"./fa": 450,
	"./fa.js": 450,
	"./fi": 451,
	"./fi.js": 451,
	"./fo": 452,
	"./fo.js": 452,
	"./fr": 453,
	"./fr-ca": 454,
	"./fr-ca.js": 454,
	"./fr-ch": 455,
	"./fr-ch.js": 455,
	"./fr.js": 453,
	"./fy": 456,
	"./fy.js": 456,
	"./ga": 457,
	"./ga.js": 457,
	"./gd": 458,
	"./gd.js": 458,
	"./gl": 459,
	"./gl.js": 459,
	"./gom-latn": 460,
	"./gom-latn.js": 460,
	"./gu": 461,
	"./gu.js": 461,
	"./he": 462,
	"./he.js": 462,
	"./hi": 463,
	"./hi.js": 463,
	"./hr": 464,
	"./hr.js": 464,
	"./hu": 465,
	"./hu.js": 465,
	"./hy-am": 466,
	"./hy-am.js": 466,
	"./id": 467,
	"./id.js": 467,
	"./is": 468,
	"./is.js": 468,
	"./it": 469,
	"./it-ch": 470,
	"./it-ch.js": 470,
	"./it.js": 469,
	"./ja": 471,
	"./ja.js": 471,
	"./jv": 472,
	"./jv.js": 472,
	"./ka": 473,
	"./ka.js": 473,
	"./kk": 474,
	"./kk.js": 474,
	"./km": 475,
	"./km.js": 475,
	"./kn": 476,
	"./kn.js": 476,
	"./ko": 477,
	"./ko.js": 477,
	"./ku": 478,
	"./ku.js": 478,
	"./ky": 479,
	"./ky.js": 479,
	"./lb": 480,
	"./lb.js": 480,
	"./lo": 481,
	"./lo.js": 481,
	"./lt": 482,
	"./lt.js": 482,
	"./lv": 483,
	"./lv.js": 483,
	"./me": 484,
	"./me.js": 484,
	"./mi": 485,
	"./mi.js": 485,
	"./mk": 486,
	"./mk.js": 486,
	"./ml": 487,
	"./ml.js": 487,
	"./mn": 488,
	"./mn.js": 488,
	"./mr": 489,
	"./mr.js": 489,
	"./ms": 490,
	"./ms-my": 491,
	"./ms-my.js": 491,
	"./ms.js": 490,
	"./mt": 492,
	"./mt.js": 492,
	"./my": 493,
	"./my.js": 493,
	"./nb": 494,
	"./nb.js": 494,
	"./ne": 495,
	"./ne.js": 495,
	"./nl": 496,
	"./nl-be": 497,
	"./nl-be.js": 497,
	"./nl.js": 496,
	"./nn": 498,
	"./nn.js": 498,
	"./pa-in": 499,
	"./pa-in.js": 499,
	"./pl": 500,
	"./pl.js": 500,
	"./pt": 501,
	"./pt-br": 502,
	"./pt-br.js": 502,
	"./pt.js": 501,
	"./ro": 503,
	"./ro.js": 503,
	"./ru": 504,
	"./ru.js": 504,
	"./sd": 505,
	"./sd.js": 505,
	"./se": 506,
	"./se.js": 506,
	"./si": 507,
	"./si.js": 507,
	"./sk": 508,
	"./sk.js": 508,
	"./sl": 509,
	"./sl.js": 509,
	"./sq": 510,
	"./sq.js": 510,
	"./sr": 511,
	"./sr-cyrl": 512,
	"./sr-cyrl.js": 512,
	"./sr.js": 511,
	"./ss": 513,
	"./ss.js": 513,
	"./sv": 514,
	"./sv.js": 514,
	"./sw": 515,
	"./sw.js": 515,
	"./ta": 516,
	"./ta.js": 516,
	"./te": 517,
	"./te.js": 517,
	"./tet": 518,
	"./tet.js": 518,
	"./tg": 519,
	"./tg.js": 519,
	"./th": 520,
	"./th.js": 520,
	"./tl-ph": 521,
	"./tl-ph.js": 521,
	"./tlh": 522,
	"./tlh.js": 522,
	"./tr": 523,
	"./tr.js": 523,
	"./tzl": 524,
	"./tzl.js": 524,
	"./tzm": 525,
	"./tzm-latn": 526,
	"./tzm-latn.js": 526,
	"./tzm.js": 525,
	"./ug-cn": 527,
	"./ug-cn.js": 527,
	"./uk": 528,
	"./uk.js": 528,
	"./ur": 529,
	"./ur.js": 529,
	"./uz": 530,
	"./uz-latn": 531,
	"./uz-latn.js": 531,
	"./uz.js": 530,
	"./vi": 532,
	"./vi.js": 532,
	"./x-pseudo": 533,
	"./x-pseudo.js": 533,
	"./yo": 534,
	"./yo.js": 534,
	"./zh-cn": 535,
	"./zh-cn.js": 535,
	"./zh-hk": 536,
	"./zh-hk.js": 536,
	"./zh-tw": 537,
	"./zh-tw.js": 537
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 953;

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

var moment = __webpack_require__(3);

function isValidMoment(testMoment) {
  if (typeof moment.isMoment === 'function' && !moment.isMoment(testMoment)) {
    return false;
  }

  /* istanbul ignore else  */
  if (typeof testMoment.isValid === 'function') {
    // moment 1.7.0+
    return testMoment.isValid();
  }

  /* istanbul ignore next */
  return !isNaN(testMoment);
}

module.exports = {
  isValidMoment : isValidMoment,
};


/***/ }),
/* 955 */
/***/ (function(module, exports) {

var messages = {
  invalidPredicate: '`predicate` must be a function',
  invalidPropValidator: '`propValidator` must be a function',
  requiredCore: 'is marked as required',
  invalidTypeCore: 'Invalid input type',
  predicateFailureCore: 'Failed to succeed with predicate',
  anonymousMessage: '<<anonymous>>',
  baseInvalidMessage: 'Invalid ',
};

function constructPropValidatorVariations(propValidator) {
  if (typeof propValidator !== 'function') {
    throw new Error(messages.invalidPropValidator);
  }

  var requiredPropValidator = propValidator.bind(null, false, null);
  requiredPropValidator.isRequired = propValidator.bind(null, true, null);

  requiredPropValidator.withPredicate = function predicateApplication(predicate) {
    if (typeof predicate !== 'function') {
      throw new Error(messages.invalidPredicate);
    }
    var basePropValidator = propValidator.bind(null, false, predicate);
    basePropValidator.isRequired = propValidator.bind(null, true, predicate);
    return basePropValidator;
  };

  return requiredPropValidator;
}

function createInvalidRequiredErrorMessage(propName, componentName, value) {
  return new Error(
    'The prop `' + propName + '` ' + messages.requiredCore +
    ' in `' + componentName + '`, but its value is `' + value + '`.'
  );
}

var independentGuardianValue = -1;

function preValidationRequireCheck(isRequired, componentName, propFullName, propValue) {
  var isPropValueUndefined = typeof propValue === 'undefined';
  var isPropValueNull = propValue === null;

  if (isRequired) {
    if (isPropValueUndefined) {
      return createInvalidRequiredErrorMessage(propFullName, componentName, 'undefined');
    } else if (isPropValueNull) {
      return createInvalidRequiredErrorMessage(propFullName, componentName, 'null');
    }
  }

  if (isPropValueUndefined || isPropValueNull) {
    return null;
  }

  return independentGuardianValue;
}

function createMomentChecker(type, typeValidator, validator, momentType) {

  function propValidator(
    isRequired, // Bound parameter to indicate with the propType is required
    predicate, // Bound parameter to allow user to add dynamic validation
    props,
    propName,
    componentName,
    location,
    propFullName
  ) {
    var propValue = props[ propName ];
    var propType = typeof propValue;

    componentName = componentName || messages.anonymousMessage;
    propFullName = propFullName || propName;

    var preValidationRequireCheckValue = preValidationRequireCheck(
      isRequired, componentName, propFullName, propValue
    );

    if (preValidationRequireCheckValue !== independentGuardianValue) {
      return preValidationRequireCheckValue;
    }

    if (typeValidator && !typeValidator(propValue)) {
      return new Error(
        messages.invalidTypeCore + ': `' + propName + '` of type `' + propType + '` ' +
        'supplied to `' + componentName + '`, expected `' + type + '`.'
      );
    }

    if (!validator(propValue)) {
      return new Error(
        messages.baseInvalidMessage + location + ' `' + propName + '` of type `' + propType + '` ' +
        'supplied to `' + componentName + '`, expected `' + momentType + '`.'
      );
    }

    if (predicate && !predicate(propValue)) {
      var predicateName = predicate.name || messages.anonymousMessage;
      return new Error(
        messages.baseInvalidMessage + location + ' `' + propName + '` of type `' + propType + '` ' +
        'supplied to `' + componentName + '`. ' + messages.predicateFailureCore + ' `' +
        predicateName + '`.'
      );
    }

    return null;

  }

  return constructPropValidatorVariations(propValidator);

}

module.exports = {
  constructPropValidatorVariations: constructPropValidatorVariations,
  createMomentChecker: createMomentChecker,
  messages: messages,
};


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(538); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(151);
var getPolyfill = __webpack_require__(541);

module.exports = function shimAssign() {
	var polyfill = getPolyfill();
	define(
		Object,
		{ assign: polyfill },
		{ assign: function () { return Object.assign !== polyfill; } }
	);
	return polyfill;
};


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(198),
    now = __webpack_require__(960),
    toNumber = __webpack_require__(962);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(549);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(198),
    isSymbol = __webpack_require__(963);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(964),
    isObjectLike = __webpack_require__(967);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(550),
    getRawTag = __webpack_require__(965),
    objectToString = __webpack_require__(966);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(550);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 966 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 967 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 968 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = getActiveElement;
function getActiveElement() {
  return typeof document !== 'undefined' && document.activeElement;
}

/***/ }),
/* 969 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = isTransitionEndSupported;
function isTransitionEndSupported() {
  return !!(typeof window !== 'undefined' && 'TransitionEvent' in window);
}

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = getCalendarMonthWeeks;

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _constants = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function getCalendarMonthWeeks(month, enableOutsideDays) {
  var firstDayOfWeek = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _moment2['default'].localeData().firstDayOfWeek();

  if (!_moment2['default'].isMoment(month) || !month.isValid()) {
    throw new TypeError('`month` must be a valid moment object');
  }
  if (_constants.WEEKDAYS.indexOf(firstDayOfWeek) === -1) {
    throw new TypeError('`firstDayOfWeek` must be an integer between 0 and 6');
  }

  // set utc offset to get correct dates in future (when timezone changes)
  var firstOfMonth = month.clone().startOf('month').hour(12);
  var lastOfMonth = month.clone().endOf('month').hour(12);

  // calculate the exact first and last days to fill the entire matrix
  // (considering days outside month)
  var prevDays = (firstOfMonth.day() + 7 - firstDayOfWeek) % 7;
  var nextDays = (firstDayOfWeek + 6 - lastOfMonth.day()) % 7;
  var firstDay = firstOfMonth.clone().subtract(prevDays, 'day');
  var lastDay = lastOfMonth.clone().add(nextDays, 'day');

  var totalDays = lastDay.diff(firstDay, 'days') + 1;

  var currentDay = firstDay.clone();
  var weeksInMonth = [];

  for (var i = 0; i < totalDays; i += 1) {
    if (i % 7 === 0) {
      weeksInMonth.push([]);
    }

    var day = null;
    if (i >= prevDays && i < totalDays - nextDays || enableOutsideDays) {
      day = currentDay.clone();
    }

    weeksInMonth[weeksInMonth.length - 1].push(day);

    currentDay.add(1, 'day');
  }

  return weeksInMonth;
}

/***/ }),
/* 971 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = getPhrase;
function getPhrase(phrase, args) {
  if (typeof phrase === 'string') return phrase;

  if (typeof phrase === 'function') {
    return phrase(args);
  }

  return '';
}

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 69);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __webpack_require__(2);

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __webpack_require__(24);

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function () {
      function render() {
        return _react2["default"].createElement(
          "svg",
          _extends({ viewBox: "0 0 12 12" }, this.props),
          _react2["default"].createElement("path", { fillRule: "evenodd", d: "M11.53.47a.75.75 0 0 0-1.061 0l-4.47 4.47L1.529.47A.75.75 0 1 0 .468 1.531l4.47 4.47-4.47 4.47a.75.75 0 1 0 1.061 1.061l4.47-4.47 4.47 4.47a.75.75 0 1 0 1.061-1.061l-4.47-4.47 4.47-4.47a.75.75 0 0 0 0-1.061z" })
        );
      }

      return render;
    }()
  }]);

  return SVG;
}(_react2["default"].Component);

exports["default"] = SVG;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __webpack_require__(27);

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __webpack_require__(6);

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __webpack_require__(37);

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = __webpack_require__(44);

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BOTTOM_RIGHT = exports.TOP_RIGHT = exports.TOP_LEFT = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

exports.KeyboardShortcutRow = KeyboardShortcutRow;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _airbnbPropTypes = __webpack_require__(1);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _defaultPhrases = __webpack_require__(3);

var _getPhrasePropTypes = __webpack_require__(5);

var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);

var _close = __webpack_require__(11);

var _close2 = _interopRequireDefault(_close);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var TOP_LEFT = exports.TOP_LEFT = 'top-left';
var TOP_RIGHT = exports.TOP_RIGHT = 'top-right';
var BOTTOM_RIGHT = exports.BOTTOM_RIGHT = 'bottom-right';

var propTypes = {
  block: _propTypes2['default'].bool,
  buttonLocation: _propTypes2['default'].oneOf([TOP_LEFT, TOP_RIGHT, BOTTOM_RIGHT]),
  showKeyboardShortcutsPanel: _propTypes2['default'].bool,
  openKeyboardShortcutsPanel: _propTypes2['default'].func,
  closeKeyboardShortcutsPanel: _propTypes2['default'].func,
  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DayPickerKeyboardShortcutsPhrases))
};

var defaultProps = {
  block: false,
  buttonLocation: BOTTOM_RIGHT,
  showKeyboardShortcutsPanel: false,
  openKeyboardShortcutsPanel: function () {
    function openKeyboardShortcutsPanel() {}

    return openKeyboardShortcutsPanel;
  }(),
  closeKeyboardShortcutsPanel: function () {
    function closeKeyboardShortcutsPanel() {}

    return closeKeyboardShortcutsPanel;
  }(),

  phrases: _defaultPhrases.DayPickerKeyboardShortcutsPhrases
};

function KeyboardShortcutRow(_ref) {
  var unicode = _ref.unicode,
      label = _ref.label,
      action = _ref.action;

  return _react2['default'].createElement('li', { className: 'KeyboardShortcutRow' }, _react2['default'].createElement('div', {
    className: 'KeyboardShortcutRow__key-container'
  }, _react2['default'].createElement('span', {
    className: 'KeyboardShortcutRow__key',
    role: 'img',
    'aria-label': label
  }, unicode)), _react2['default'].createElement('div', { className: 'KeyboardShortcutRow__action' }, action));
}

KeyboardShortcutRow.propTypes = {
  unicode: _propTypes2['default'].string.isRequired,
  label: _propTypes2['default'].string.isRequired,
  action: _propTypes2['default'].string.isRequired
};

var DayPickerKeyboardShortcuts = function (_React$Component) {
  _inherits(DayPickerKeyboardShortcuts, _React$Component);

  function DayPickerKeyboardShortcuts() {
    var _ref2;

    _classCallCheck(this, DayPickerKeyboardShortcuts);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref2 = DayPickerKeyboardShortcuts.__proto__ || Object.getPrototypeOf(DayPickerKeyboardShortcuts)).call.apply(_ref2, [this].concat(args)));

    _this.onClick = _this.onClick.bind(_this);
    _this.setShowKeyboardShortcutsButtonRef = _this.setShowKeyboardShortcutsButtonRef.bind(_this);
    return _this;
  }

  _createClass(DayPickerKeyboardShortcuts, [{
    key: 'onClick',
    value: function () {
      function onClick() {
        var _this2 = this;

        var openKeyboardShortcutsPanel = this.props.openKeyboardShortcutsPanel;

        // we want to return focus to this button after closing the keyboard shortcuts panel

        openKeyboardShortcutsPanel(function () {
          _this2.showKeyboardShortcutsButton.focus();
        });
      }

      return onClick;
    }()
  }, {
    key: 'setShowKeyboardShortcutsButtonRef',
    value: function () {
      function setShowKeyboardShortcutsButtonRef(ref) {
        this.showKeyboardShortcutsButton = ref;
      }

      return setShowKeyboardShortcutsButtonRef;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            block = _props.block,
            buttonLocation = _props.buttonLocation,
            showKeyboardShortcutsPanel = _props.showKeyboardShortcutsPanel,
            closeKeyboardShortcutsPanel = _props.closeKeyboardShortcutsPanel,
            phrases = _props.phrases;

        var keyboardShortcuts = [{
          unicode: '↵',
          label: phrases.enterKey,
          action: phrases.selectFocusedDate
        }, {
          unicode: '←/→',
          label: phrases.leftArrowRightArrow,
          action: phrases.moveFocusByOneDay
        }, {
          unicode: '↑/↓',
          label: phrases.upArrowDownArrow,
          action: phrases.moveFocusByOneWeek
        }, {
          unicode: 'PgUp/PgDn',
          label: phrases.pageUpPageDown,
          action: phrases.moveFocusByOneMonth
        }, {
          unicode: 'Home/End',
          label: phrases.homeEnd,
          action: phrases.moveFocustoStartAndEndOfWeek
        }, {
          unicode: 'Esc',
          label: phrases.escape,
          action: phrases.returnFocusToInput
        }, {
          unicode: '?',
          label: phrases.questionMark,
          action: phrases.openThisPanel
        }];

        var toggleButtonText = showKeyboardShortcutsPanel ? phrases.hideKeyboardShortcutsPanel : phrases.showKeyboardShortcutsPanel;

        return _react2['default'].createElement('div', null, _react2['default'].createElement('button', {
          ref: this.setShowKeyboardShortcutsButtonRef,
          className: (0, _classnames2['default'])('DayPickerKeyboardShortcuts__show', {
            'DayPickerKeyboardShortcuts__show--bottom-right': buttonLocation === BOTTOM_RIGHT,
            'DayPickerKeyboardShortcuts__show--top-right': buttonLocation === TOP_RIGHT,
            'DayPickerKeyboardShortcuts__show--top-left': buttonLocation === TOP_LEFT
          }),
          type: 'button',
          'aria-label': toggleButtonText,
          onClick: this.onClick,
          onMouseUp: function () {
            function onMouseUp(e) {
              e.currentTarget.blur();
            }

            return onMouseUp;
          }()
        }, _react2['default'].createElement('span', { className: 'DayPickerKeyboardShortcuts__show_span' }, '?')), showKeyboardShortcutsPanel && _react2['default'].createElement('div', {
          className: (0, _classnames2['default'])('DayPickerKeyboardShortcuts__panel', {
            'DayPickerKeyboardShortcuts__panel--block': block
          }),
          role: 'dialog',
          'aria-labelledby': 'DayPickerKeyboardShortcuts__title'
        }, _react2['default'].createElement('div', {
          id: 'DayPickerKeyboardShortcuts__title',
          className: 'DayPickerKeyboardShortcuts__title'
        }, phrases.keyboardShortcuts), _react2['default'].createElement('button', {
          className: 'DayPickerKeyboardShortcuts__close',
          type: 'button',
          'aria-label': phrases.hideKeyboardShortcutsPanel,
          onClick: closeKeyboardShortcutsPanel,
          onKeyDown: function () {
            function onKeyDown(e) {
              // Because the close button is the only focusable element inside of the panel, this
              // amount to a very basic focus trap. The user can exit the panel by "pressing" the
              // close button or hitting escape
              if (e.key === 'Tab') {
                e.preventDefault();
              }
            }

            return onKeyDown;
          }()
        }, _react2['default'].createElement(_close2['default'], null)), _react2['default'].createElement('ul', { className: 'DayPickerKeyboardShortcuts__list' }, keyboardShortcuts.map(function (_ref3) {
          var unicode = _ref3.unicode,
              label = _ref3.label,
              action = _ref3.action;
          return _react2['default'].createElement(KeyboardShortcutRow, { key: label, unicode: unicode, label: label, action: action });
        }))));
      }

      return render;
    }()
  }]);

  return DayPickerKeyboardShortcuts;
}(_react2['default'].Component);

exports['default'] = DayPickerKeyboardShortcuts;

DayPickerKeyboardShortcuts.propTypes = (0, _airbnbPropTypes.forbidExtraProps)(propTypes);
DayPickerKeyboardShortcuts.defaultProps = defaultProps;

/***/ })

/******/ });

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 70);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __webpack_require__(2);

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __webpack_require__(24);

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __webpack_require__(12);

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function () {
      function render() {
        return _react2["default"].createElement(
          "svg",
          _extends({ viewBox: "0 0 1000 1000" }, this.props),
          _react2["default"].createElement("path", { d: "M336.2 274.5l-210.1 210h805.4c13 0 23 10 23 23s-10 23-23 23H126.1l210.1 210.1c11 11 11 21 0 32-5 5-10 7-16 7s-11-2-16-7l-249.1-249c-11-11-11-21 0-32l249.1-249.1c21-21.1 53 10.9 32 32z" })
        );
      }

      return render;
    }()
  }]);

  return SVG;
}(_react2["default"].Component);

exports["default"] = SVG;

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function () {
      function render() {
        return _react2["default"].createElement(
          "svg",
          _extends({ viewBox: "0 0 1000 1000" }, this.props),
          _react2["default"].createElement("path", { d: "M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z" })
        );
      }

      return render;
    }()
  }]);

  return SVG;
}(_react2["default"].Component);

exports["default"] = SVG;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __webpack_require__(27);

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __webpack_require__(6);

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function () {
      function render() {
        return _react2["default"].createElement(
          "svg",
          _extends({ viewBox: "0 0 1000 1000" }, this.props),
          _react2["default"].createElement("path", { d: "M967.5 288.5L514.3 740.7c-11 11-21 11-32 0L29.1 288.5c-4-5-6-11-6-16 0-13 10-23 23-23 6 0 11 2 15 7l437.2 436.2 437.2-436.2c4-5 9-7 16-7 6 0 11 2 16 7 9 10.9 9 21 0 32z" })
        );
      }

      return render;
    }()
  }]);

  return SVG;
}(_react2["default"].Component);

exports["default"] = SVG;

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function () {
      function render() {
        return _react2["default"].createElement(
          "svg",
          _extends({ viewBox: "0 0 1000 1000" }, this.props),
          _react2["default"].createElement("path", { d: "M32.1 712.6l453.2-452.2c11-11 21-11 32 0l453.2 452.2c4 5 6 10 6 16 0 13-10 23-22 23-7 0-12-2-16-7L501.3 308.5 64.1 744.7c-4 5-9 7-15 7-7 0-12-2-17-7-9-11-9-21 0-32.1z" })
        );
      }

      return render;
    }()
  }]);

  return SVG;
}(_react2["default"].Component);

exports["default"] = SVG;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __webpack_require__(37);

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = __webpack_require__(44);

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = DayPickerNavigation;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _airbnbPropTypes = __webpack_require__(1);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _defaultPhrases = __webpack_require__(3);

var _getPhrasePropTypes = __webpack_require__(5);

var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);

var _arrowLeft = __webpack_require__(25);

var _arrowLeft2 = _interopRequireDefault(_arrowLeft);

var _arrowRight = __webpack_require__(26);

var _arrowRight2 = _interopRequireDefault(_arrowRight);

var _chevronUp = __webpack_require__(42);

var _chevronUp2 = _interopRequireDefault(_chevronUp);

var _chevronDown = __webpack_require__(41);

var _chevronDown2 = _interopRequireDefault(_chevronDown);

var _ScrollableOrientationShape = __webpack_require__(8);

var _ScrollableOrientationShape2 = _interopRequireDefault(_ScrollableOrientationShape);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
  navPrev: _propTypes2['default'].node,
  navNext: _propTypes2['default'].node,
  orientation: _ScrollableOrientationShape2['default'],

  onPrevMonthClick: _propTypes2['default'].func,
  onNextMonthClick: _propTypes2['default'].func,

  // internationalization
  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DayPickerNavigationPhrases)),

  isRTL: _propTypes2['default'].bool
});

var defaultProps = {
  navPrev: null,
  navNext: null,
  orientation: _constants.HORIZONTAL_ORIENTATION,

  onPrevMonthClick: function () {
    function onPrevMonthClick() {}

    return onPrevMonthClick;
  }(),
  onNextMonthClick: function () {
    function onNextMonthClick() {}

    return onNextMonthClick;
  }(),

  // internationalization
  phrases: _defaultPhrases.DayPickerNavigationPhrases,
  isRTL: false
};

function DayPickerNavigation(props) {
  var navPrev = props.navPrev,
      navNext = props.navNext,
      onPrevMonthClick = props.onPrevMonthClick,
      onNextMonthClick = props.onNextMonthClick,
      orientation = props.orientation,
      phrases = props.phrases,
      isRTL = props.isRTL;

  var isVertical = orientation !== _constants.HORIZONTAL_ORIENTATION;
  var isVerticalScrollable = orientation === _constants.VERTICAL_SCROLLABLE;

  var navPrevIcon = navPrev;
  var navNextIcon = navNext;
  var isDefaultNavPrev = false;
  var isDefaultNavNext = false;
  if (!navPrevIcon) {
    isDefaultNavPrev = true;
    navPrevIcon = isVertical ? _react2['default'].createElement(_chevronUp2['default'], null) : _react2['default'].createElement(_arrowLeft2['default'], null);
    if (isRTL && !isVertical) {
      navPrevIcon = _react2['default'].createElement(_arrowRight2['default'], null);
    }
  }
  if (!navNextIcon) {
    isDefaultNavNext = true;
    navNextIcon = isVertical ? _react2['default'].createElement(_chevronDown2['default'], null) : _react2['default'].createElement(_arrowRight2['default'], null);
    if (isRTL && !isVertical) {
      navNextIcon = _react2['default'].createElement(_arrowLeft2['default'], null);
    }
  }

  var navClassNames = (0, _classnames2['default'])('DayPickerNavigation', {
    'DayPickerNavigation--horizontal': !isVertical,
    'DayPickerNavigation--vertical': isVertical,
    'DayPickerNavigation--vertical-scrollable': isVerticalScrollable
  });
  var prevClassNames = (0, _classnames2['default'])('DayPickerNavigation__prev', {
    'DayPickerNavigation__prev--default': isDefaultNavPrev,
    'DayPickerNavigation__prev--rtl': isRTL
  });
  var nextClassNames = (0, _classnames2['default'])('DayPickerNavigation__next', {
    'DayPickerNavigation__next--default': isDefaultNavNext,
    'DayPickerNavigation__next--rtl': isRTL
  });

  return _react2['default'].createElement('div', { className: navClassNames }, !isVerticalScrollable && _react2['default'].createElement('button', {
    type: 'button',
    'aria-label': phrases.jumpToPrevMonth,
    className: prevClassNames,
    onClick: onPrevMonthClick,
    onMouseUp: function () {
      function onMouseUp(e) {
        e.currentTarget.blur();
      }

      return onMouseUp;
    }()
  }, navPrevIcon), _react2['default'].createElement('button', {
    type: 'button',
    'aria-label': phrases.jumpToNextMonth,
    className: nextClassNames,
    onClick: onNextMonthClick,
    onMouseUp: function () {
      function onMouseUp(e) {
        e.currentTarget.blur();
      }

      return onMouseUp;
    }()
  }, navNextIcon));
}

DayPickerNavigation.propTypes = propTypes;
DayPickerNavigation.defaultProps = defaultProps;

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = __webpack_require__(101);

/***/ })

/******/ });

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(975);


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ES2015 = __webpack_require__(976);
var assign = __webpack_require__(564);

var ES2016 = assign(assign({}, ES2015), {
	// https://github.com/tc39/ecma262/pull/60
	SameValueNonNumber: function SameValueNonNumber(x, y) {
		if (typeof x === 'number' || typeof x !== typeof y) {
			throw new TypeError('SameValueNonNumber requires two non-number values of the same type.');
		}
		return this.SameValue(x, y);
	}
});

module.exports = ES2016;


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(117);
var toPrimitive = __webpack_require__(977);
var keys = __webpack_require__(196);

var GetIntrinsic = __webpack_require__(202);

var $TypeError = GetIntrinsic('%TypeError%');
var $SyntaxError = GetIntrinsic('%SyntaxError%');
var $Array = GetIntrinsic('%Array%');
var $String = GetIntrinsic('%String%');
var $Object = GetIntrinsic('%Object%');
var $Number = GetIntrinsic('%Number%');
var $Symbol = GetIntrinsic('%Symbol%', true);
var $RegExp = GetIntrinsic('%RegExp%');

var hasSymbols = !!$Symbol;

var assertRecord = __webpack_require__(561);
var $isNaN = __webpack_require__(562);
var $isFinite = __webpack_require__(563);
var MAX_SAFE_INTEGER = $Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;

var assign = __webpack_require__(564);
var sign = __webpack_require__(565);
var mod = __webpack_require__(566);
var isPrimitive = __webpack_require__(982);
var parseInteger = parseInt;
var bind = __webpack_require__(114);
var arraySlice = bind.call(Function.call, $Array.prototype.slice);
var strSlice = bind.call(Function.call, $String.prototype.slice);
var isBinary = bind.call(Function.call, $RegExp.prototype.test, /^0b[01]+$/i);
var isOctal = bind.call(Function.call, $RegExp.prototype.test, /^0o[0-7]+$/i);
var regexExec = bind.call(Function.call, $RegExp.prototype.exec);
var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
var nonWSregex = new $RegExp('[' + nonWS + ']', 'g');
var hasNonWS = bind.call(Function.call, $RegExp.prototype.test, nonWSregex);
var invalidHexLiteral = /^[-+]0x[0-9a-f]+$/i;
var isInvalidHexLiteral = bind.call(Function.call, $RegExp.prototype.test, invalidHexLiteral);
var $charCodeAt = bind.call(Function.call, $String.prototype.charCodeAt);

var toStr = bind.call(Function.call, Object.prototype.toString);

var $NumberValueOf = bind.call(Function.call, GetIntrinsic('%NumberPrototype%').valueOf);
var $BooleanValueOf = bind.call(Function.call, GetIntrinsic('%BooleanPrototype%').valueOf);
var $StringValueOf = bind.call(Function.call, GetIntrinsic('%StringPrototype%').valueOf);
var $DateValueOf = bind.call(Function.call, GetIntrinsic('%DatePrototype%').valueOf);

var $floor = Math.floor;
var $abs = Math.abs;

var $ObjectCreate = Object.create;
var $gOPD = $Object.getOwnPropertyDescriptor;

var $isExtensible = $Object.isExtensible;

var $defineProperty = $Object.defineProperty;

// whitespace from: http://es5.github.io/#x15.5.4.20
// implementation from https://github.com/es-shims/es5-shim/blob/v3.4.0/es5-shim.js#L1304-L1324
var ws = [
	'\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003',
	'\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028',
	'\u2029\uFEFF'
].join('');
var trimRegex = new RegExp('(^[' + ws + ']+)|([' + ws + ']+$)', 'g');
var replace = bind.call(Function.call, $String.prototype.replace);
var trim = function (value) {
	return replace(value, trimRegex, '');
};

var ES5 = __webpack_require__(983);

var hasRegExpMatcher = __webpack_require__(985);

// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-abstract-operations
var ES6 = assign(assign({}, ES5), {

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-call-f-v-args
	Call: function Call(F, V) {
		var args = arguments.length > 2 ? arguments[2] : [];
		if (!this.IsCallable(F)) {
			throw new $TypeError(F + ' is not a function');
		}
		return F.apply(V, args);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toprimitive
	ToPrimitive: toPrimitive,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toboolean
	// ToBoolean: ES5.ToBoolean,

	// https://ecma-international.org/ecma-262/6.0/#sec-tonumber
	ToNumber: function ToNumber(argument) {
		var value = isPrimitive(argument) ? argument : toPrimitive(argument, $Number);
		if (typeof value === 'symbol') {
			throw new $TypeError('Cannot convert a Symbol value to a number');
		}
		if (typeof value === 'string') {
			if (isBinary(value)) {
				return this.ToNumber(parseInteger(strSlice(value, 2), 2));
			} else if (isOctal(value)) {
				return this.ToNumber(parseInteger(strSlice(value, 2), 8));
			} else if (hasNonWS(value) || isInvalidHexLiteral(value)) {
				return NaN;
			} else {
				var trimmed = trim(value);
				if (trimmed !== value) {
					return this.ToNumber(trimmed);
				}
			}
		}
		return $Number(value);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tointeger
	// ToInteger: ES5.ToNumber,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint32
	// ToInt32: ES5.ToInt32,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint32
	// ToUint32: ES5.ToUint32,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint16
	ToInt16: function ToInt16(argument) {
		var int16bit = this.ToUint16(argument);
		return int16bit >= 0x8000 ? int16bit - 0x10000 : int16bit;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint16
	// ToUint16: ES5.ToUint16,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint8
	ToInt8: function ToInt8(argument) {
		var int8bit = this.ToUint8(argument);
		return int8bit >= 0x80 ? int8bit - 0x100 : int8bit;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint8
	ToUint8: function ToUint8(argument) {
		var number = this.ToNumber(argument);
		if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
		var posInt = sign(number) * $floor($abs(number));
		return mod(posInt, 0x100);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint8clamp
	ToUint8Clamp: function ToUint8Clamp(argument) {
		var number = this.ToNumber(argument);
		if ($isNaN(number) || number <= 0) { return 0; }
		if (number >= 0xFF) { return 0xFF; }
		var f = $floor(argument);
		if (f + 0.5 < number) { return f + 1; }
		if (number < f + 0.5) { return f; }
		if (f % 2 !== 0) { return f + 1; }
		return f;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tostring
	ToString: function ToString(argument) {
		if (typeof argument === 'symbol') {
			throw new $TypeError('Cannot convert a Symbol value to a string');
		}
		return $String(argument);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toobject
	ToObject: function ToObject(value) {
		this.RequireObjectCoercible(value);
		return $Object(value);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-topropertykey
	ToPropertyKey: function ToPropertyKey(argument) {
		var key = this.ToPrimitive(argument, $String);
		return typeof key === 'symbol' ? key : this.ToString(key);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	ToLength: function ToLength(argument) {
		var len = this.ToInteger(argument);
		if (len <= 0) { return 0; } // includes converting -0 to +0
		if (len > MAX_SAFE_INTEGER) { return MAX_SAFE_INTEGER; }
		return len;
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-canonicalnumericindexstring
	CanonicalNumericIndexString: function CanonicalNumericIndexString(argument) {
		if (toStr(argument) !== '[object String]') {
			throw new $TypeError('must be a string');
		}
		if (argument === '-0') { return -0; }
		var n = this.ToNumber(argument);
		if (this.SameValue(this.ToString(n), argument)) { return n; }
		return void 0;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-requireobjectcoercible
	RequireObjectCoercible: ES5.CheckObjectCoercible,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isarray
	IsArray: $Array.isArray || function IsArray(argument) {
		return toStr(argument) === '[object Array]';
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-iscallable
	// IsCallable: ES5.IsCallable,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isconstructor
	IsConstructor: function IsConstructor(argument) {
		return typeof argument === 'function' && !!argument.prototype; // unfortunately there's no way to truly check this without try/catch `new argument`
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isextensible-o
	IsExtensible: Object.preventExtensions
		? function IsExtensible(obj) {
			if (isPrimitive(obj)) {
				return false;
			}
			return $isExtensible(obj);
		}
		: function isExtensible(obj) { return true; }, // eslint-disable-line no-unused-vars

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isinteger
	IsInteger: function IsInteger(argument) {
		if (typeof argument !== 'number' || $isNaN(argument) || !$isFinite(argument)) {
			return false;
		}
		var abs = $abs(argument);
		return $floor(abs) === abs;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-ispropertykey
	IsPropertyKey: function IsPropertyKey(argument) {
		return typeof argument === 'string' || typeof argument === 'symbol';
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-isregexp
	IsRegExp: function IsRegExp(argument) {
		if (!argument || typeof argument !== 'object') {
			return false;
		}
		if (hasSymbols) {
			var isRegExp = argument[$Symbol.match];
			if (typeof isRegExp !== 'undefined') {
				return ES5.ToBoolean(isRegExp);
			}
		}
		return hasRegExpMatcher(argument);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevalue
	// SameValue: ES5.SameValue,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero
	SameValueZero: function SameValueZero(x, y) {
		return (x === y) || ($isNaN(x) && $isNaN(y));
	},

	/**
	 * 7.3.2 GetV (V, P)
	 * 1. Assert: IsPropertyKey(P) is true.
	 * 2. Let O be ToObject(V).
	 * 3. ReturnIfAbrupt(O).
	 * 4. Return O.[[Get]](P, V).
	 */
	GetV: function GetV(V, P) {
		// 7.3.2.1
		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}

		// 7.3.2.2-3
		var O = this.ToObject(V);

		// 7.3.2.4
		return O[P];
	},

	/**
	 * 7.3.9 - https://ecma-international.org/ecma-262/6.0/#sec-getmethod
	 * 1. Assert: IsPropertyKey(P) is true.
	 * 2. Let func be GetV(O, P).
	 * 3. ReturnIfAbrupt(func).
	 * 4. If func is either undefined or null, return undefined.
	 * 5. If IsCallable(func) is false, throw a TypeError exception.
	 * 6. Return func.
	 */
	GetMethod: function GetMethod(O, P) {
		// 7.3.9.1
		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}

		// 7.3.9.2
		var func = this.GetV(O, P);

		// 7.3.9.4
		if (func == null) {
			return void 0;
		}

		// 7.3.9.5
		if (!this.IsCallable(func)) {
			throw new $TypeError(P + 'is not a function');
		}

		// 7.3.9.6
		return func;
	},

	/**
	 * 7.3.1 Get (O, P) - https://ecma-international.org/ecma-262/6.0/#sec-get-o-p
	 * 1. Assert: Type(O) is Object.
	 * 2. Assert: IsPropertyKey(P) is true.
	 * 3. Return O.[[Get]](P, O).
	 */
	Get: function Get(O, P) {
		// 7.3.1.1
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(O) is not Object');
		}
		// 7.3.1.2
		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}
		// 7.3.1.3
		return O[P];
	},

	Type: function Type(x) {
		if (typeof x === 'symbol') {
			return 'Symbol';
		}
		return ES5.Type(x);
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-speciesconstructor
	SpeciesConstructor: function SpeciesConstructor(O, defaultConstructor) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(O) is not Object');
		}
		var C = O.constructor;
		if (typeof C === 'undefined') {
			return defaultConstructor;
		}
		if (this.Type(C) !== 'Object') {
			throw new $TypeError('O.constructor is not an Object');
		}
		var S = hasSymbols && $Symbol.species ? C[$Symbol.species] : void 0;
		if (S == null) {
			return defaultConstructor;
		}
		if (this.IsConstructor(S)) {
			return S;
		}
		throw new $TypeError('no constructor found');
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-completepropertydescriptor
	CompletePropertyDescriptor: function CompletePropertyDescriptor(Desc) {
		assertRecord(this, 'Property Descriptor', 'Desc', Desc);

		if (this.IsGenericDescriptor(Desc) || this.IsDataDescriptor(Desc)) {
			if (!has(Desc, '[[Value]]')) {
				Desc['[[Value]]'] = void 0;
			}
			if (!has(Desc, '[[Writable]]')) {
				Desc['[[Writable]]'] = false;
			}
		} else {
			if (!has(Desc, '[[Get]]')) {
				Desc['[[Get]]'] = void 0;
			}
			if (!has(Desc, '[[Set]]')) {
				Desc['[[Set]]'] = void 0;
			}
		}
		if (!has(Desc, '[[Enumerable]]')) {
			Desc['[[Enumerable]]'] = false;
		}
		if (!has(Desc, '[[Configurable]]')) {
			Desc['[[Configurable]]'] = false;
		}
		return Desc;
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-set-o-p-v-throw
	Set: function Set(O, P, V, Throw) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('O must be an Object');
		}
		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('P must be a Property Key');
		}
		if (this.Type(Throw) !== 'Boolean') {
			throw new $TypeError('Throw must be a Boolean');
		}
		if (Throw) {
			O[P] = V;
			return true;
		} else {
			try {
				O[P] = V;
			} catch (e) {
				return false;
			}
		}
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-hasownproperty
	HasOwnProperty: function HasOwnProperty(O, P) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('O must be an Object');
		}
		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('P must be a Property Key');
		}
		return has(O, P);
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-hasproperty
	HasProperty: function HasProperty(O, P) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('O must be an Object');
		}
		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('P must be a Property Key');
		}
		return P in O;
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-isconcatspreadable
	IsConcatSpreadable: function IsConcatSpreadable(O) {
		if (this.Type(O) !== 'Object') {
			return false;
		}
		if (hasSymbols && typeof $Symbol.isConcatSpreadable === 'symbol') {
			var spreadable = this.Get(O, Symbol.isConcatSpreadable);
			if (typeof spreadable !== 'undefined') {
				return this.ToBoolean(spreadable);
			}
		}
		return this.IsArray(O);
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-invoke
	Invoke: function Invoke(O, P) {
		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('P must be a Property Key');
		}
		var argumentsList = arraySlice(arguments, 2);
		var func = this.GetV(O, P);
		return this.Call(func, O, argumentsList);
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-getiterator
	GetIterator: function GetIterator(obj, method) {
		if (!hasSymbols) {
			throw new SyntaxError('ES.GetIterator depends on native iterator support.');
		}

		var actualMethod = method;
		if (arguments.length < 2) {
			actualMethod = this.GetMethod(obj, $Symbol.iterator);
		}
		var iterator = this.Call(actualMethod, obj);
		if (this.Type(iterator) !== 'Object') {
			throw new $TypeError('iterator must return an object');
		}

		return iterator;
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-iteratornext
	IteratorNext: function IteratorNext(iterator, value) {
		var result = this.Invoke(iterator, 'next', arguments.length < 2 ? [] : [value]);
		if (this.Type(result) !== 'Object') {
			throw new $TypeError('iterator next must return an object');
		}
		return result;
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-iteratorcomplete
	IteratorComplete: function IteratorComplete(iterResult) {
		if (this.Type(iterResult) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(iterResult) is not Object');
		}
		return this.ToBoolean(this.Get(iterResult, 'done'));
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-iteratorvalue
	IteratorValue: function IteratorValue(iterResult) {
		if (this.Type(iterResult) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(iterResult) is not Object');
		}
		return this.Get(iterResult, 'value');
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-iteratorstep
	IteratorStep: function IteratorStep(iterator) {
		var result = this.IteratorNext(iterator);
		var done = this.IteratorComplete(result);
		return done === true ? false : result;
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-iteratorclose
	IteratorClose: function IteratorClose(iterator, completion) {
		if (this.Type(iterator) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(iterator) is not Object');
		}
		if (!this.IsCallable(completion)) {
			throw new $TypeError('Assertion failed: completion is not a thunk for a Completion Record');
		}
		var completionThunk = completion;

		var iteratorReturn = this.GetMethod(iterator, 'return');

		if (typeof iteratorReturn === 'undefined') {
			return completionThunk();
		}

		var completionRecord;
		try {
			var innerResult = this.Call(iteratorReturn, iterator, []);
		} catch (e) {
			// if we hit here, then "e" is the innerResult completion that needs re-throwing

			// if the completion is of type "throw", this will throw.
			completionRecord = completionThunk();
			completionThunk = null; // ensure it's not called twice.

			// if not, then return the innerResult completion
			throw e;
		}
		completionRecord = completionThunk(); // if innerResult worked, then throw if the completion does
		completionThunk = null; // ensure it's not called twice.

		if (this.Type(innerResult) !== 'Object') {
			throw new $TypeError('iterator .return must return an object');
		}

		return completionRecord;
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-createiterresultobject
	CreateIterResultObject: function CreateIterResultObject(value, done) {
		if (this.Type(done) !== 'Boolean') {
			throw new $TypeError('Assertion failed: Type(done) is not Boolean');
		}
		return {
			value: value,
			done: done
		};
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-regexpexec
	RegExpExec: function RegExpExec(R, S) {
		if (this.Type(R) !== 'Object') {
			throw new $TypeError('R must be an Object');
		}
		if (this.Type(S) !== 'String') {
			throw new $TypeError('S must be a String');
		}
		var exec = this.Get(R, 'exec');
		if (this.IsCallable(exec)) {
			var result = this.Call(exec, R, [S]);
			if (result === null || this.Type(result) === 'Object') {
				return result;
			}
			throw new $TypeError('"exec" method must return `null` or an Object');
		}
		return regexExec(R, S);
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-arrayspeciescreate
	ArraySpeciesCreate: function ArraySpeciesCreate(originalArray, length) {
		if (!this.IsInteger(length) || length < 0) {
			throw new $TypeError('Assertion failed: length must be an integer >= 0');
		}
		var len = length === 0 ? 0 : length;
		var C;
		var isArray = this.IsArray(originalArray);
		if (isArray) {
			C = this.Get(originalArray, 'constructor');
			// TODO: figure out how to make a cross-realm normal Array, a same-realm Array
			// if (this.IsConstructor(C)) {
			// 	if C is another realm's Array, C = undefined
			// 	Object.getPrototypeOf(Object.getPrototypeOf(Object.getPrototypeOf(Array))) === null ?
			// }
			if (this.Type(C) === 'Object' && hasSymbols && $Symbol.species) {
				C = this.Get(C, $Symbol.species);
				if (C === null) {
					C = void 0;
				}
			}
		}
		if (typeof C === 'undefined') {
			return $Array(len);
		}
		if (!this.IsConstructor(C)) {
			throw new $TypeError('C must be a constructor');
		}
		return new C(len); // this.Construct(C, len);
	},

	CreateDataProperty: function CreateDataProperty(O, P, V) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(O) is not Object');
		}
		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}
		var oldDesc = $gOPD(O, P);
		var extensible = oldDesc || (typeof $isExtensible !== 'function' || $isExtensible(O));
		var immutable = oldDesc && (!oldDesc.writable || !oldDesc.configurable);
		if (immutable || !extensible) {
			return false;
		}
		var newDesc = {
			configurable: true,
			enumerable: true,
			value: V,
			writable: true
		};
		$defineProperty(O, P, newDesc);
		return true;
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-createdatapropertyorthrow
	CreateDataPropertyOrThrow: function CreateDataPropertyOrThrow(O, P, V) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(O) is not Object');
		}
		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}
		var success = this.CreateDataProperty(O, P, V);
		if (!success) {
			throw new $TypeError('unable to create data property');
		}
		return success;
	},

	// https://www.ecma-international.org/ecma-262/6.0/#sec-objectcreate
	ObjectCreate: function ObjectCreate(proto, internalSlotsList) {
		if (proto !== null && this.Type(proto) !== 'Object') {
			throw new $TypeError('Assertion failed: proto must be null or an object');
		}
		var slots = arguments.length < 2 ? [] : internalSlotsList;
		if (slots.length > 0) {
			throw new $SyntaxError('es-abstract does not yet support internal slots');
		}

		if (proto === null && !$ObjectCreate) {
			throw new $SyntaxError('native Object.create support is required to create null objects');
		}

		return $ObjectCreate(proto);
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-advancestringindex
	AdvanceStringIndex: function AdvanceStringIndex(S, index, unicode) {
		if (this.Type(S) !== 'String') {
			throw new $TypeError('S must be a String');
		}
		if (!this.IsInteger(index) || index < 0 || index > MAX_SAFE_INTEGER) {
			throw new $TypeError('Assertion failed: length must be an integer >= 0 and <= 2**53');
		}
		if (this.Type(unicode) !== 'Boolean') {
			throw new $TypeError('Assertion failed: unicode must be a Boolean');
		}
		if (!unicode) {
			return index + 1;
		}
		var length = S.length;
		if ((index + 1) >= length) {
			return index + 1;
		}

		var first = $charCodeAt(S, index);
		if (first < 0xD800 || first > 0xDBFF) {
			return index + 1;
		}

		var second = $charCodeAt(S, index + 1);
		if (second < 0xDC00 || second > 0xDFFF) {
			return index + 1;
		}

		return index + 2;
	},

	// https://www.ecma-international.org/ecma-262/6.0/#sec-createmethodproperty
	CreateMethodProperty: function CreateMethodProperty(O, P, V) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(O) is not Object');
		}

		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}

		var newDesc = {
			configurable: true,
			enumerable: false,
			value: V,
			writable: true
		};
		return !!$defineProperty(O, P, newDesc);
	},

	// https://www.ecma-international.org/ecma-262/6.0/#sec-definepropertyorthrow
	DefinePropertyOrThrow: function DefinePropertyOrThrow(O, P, desc) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(O) is not Object');
		}

		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}

		return !!$defineProperty(O, P, desc);
	},

	// https://www.ecma-international.org/ecma-262/6.0/#sec-deletepropertyorthrow
	DeletePropertyOrThrow: function DeletePropertyOrThrow(O, P) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(O) is not Object');
		}

		if (!this.IsPropertyKey(P)) {
			throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}

		var success = delete O[P];
		if (!success) {
			throw new TypeError('Attempt to delete property failed.');
		}
		return success;
	},

	// https://www.ecma-international.org/ecma-262/6.0/#sec-enumerableownnames
	EnumerableOwnNames: function EnumerableOwnNames(O) {
		if (this.Type(O) !== 'Object') {
			throw new $TypeError('Assertion failed: Type(O) is not Object');
		}

		return keys(O);
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-number-prototype-object
	thisNumberValue: function thisNumberValue(value) {
		if (this.Type(value) === 'Number') {
			return value;
		}

		return $NumberValueOf(value);
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-boolean-prototype-object
	thisBooleanValue: function thisBooleanValue(value) {
		if (this.Type(value) === 'Boolean') {
			return value;
		}

		return $BooleanValueOf(value);
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-string-prototype-object
	thisStringValue: function thisStringValue(value) {
		if (this.Type(value) === 'String') {
			return value;
		}

		return $StringValueOf(value);
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-date-prototype-object
	thisTimeValue: function thisTimeValue(value) {
		return $DateValueOf(value);
	}
});

delete ES6.CheckObjectCoercible; // renamed in ES6 to RequireObjectCoercible

module.exports = ES6;


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(978);


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';

var isPrimitive = __webpack_require__(560);
var isCallable = __webpack_require__(201);
var isDate = __webpack_require__(979);
var isSymbol = __webpack_require__(980);

var ordinaryToPrimitive = function OrdinaryToPrimitive(O, hint) {
	if (typeof O === 'undefined' || O === null) {
		throw new TypeError('Cannot call method on ' + O);
	}
	if (typeof hint !== 'string' || (hint !== 'number' && hint !== 'string')) {
		throw new TypeError('hint must be "string" or "number"');
	}
	var methodNames = hint === 'string' ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
	var method, result, i;
	for (i = 0; i < methodNames.length; ++i) {
		method = O[methodNames[i]];
		if (isCallable(method)) {
			result = method.call(O);
			if (isPrimitive(result)) {
				return result;
			}
		}
	}
	throw new TypeError('No default value');
};

var GetMethod = function GetMethod(O, P) {
	var func = O[P];
	if (func !== null && typeof func !== 'undefined') {
		if (!isCallable(func)) {
			throw new TypeError(func + ' returned for property ' + P + ' of object ' + O + ' is not a function');
		}
		return func;
	}
	return void 0;
};

// http://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive
module.exports = function ToPrimitive(input) {
	if (isPrimitive(input)) {
		return input;
	}
	var hint = 'default';
	if (arguments.length > 1) {
		if (arguments[1] === String) {
			hint = 'string';
		} else if (arguments[1] === Number) {
			hint = 'number';
		}
	}

	var exoticToPrim;
	if (hasSymbols) {
		if (Symbol.toPrimitive) {
			exoticToPrim = GetMethod(input, Symbol.toPrimitive);
		} else if (isSymbol(input)) {
			exoticToPrim = Symbol.prototype.valueOf;
		}
	}
	if (typeof exoticToPrim !== 'undefined') {
		var result = exoticToPrim.call(input, hint);
		if (isPrimitive(result)) {
			return result;
		}
		throw new TypeError('unable to convert exotic object to primitive');
	}
	if (hint === 'default' && (isDate(input) || isSymbol(input))) {
		hint = 'string';
	}
	return ordinaryToPrimitive(input, hint === 'default' ? 'number' : hint);
};


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateObject(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) { return false; }
	return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;
var hasSymbols = __webpack_require__(981)();

if (hasSymbols) {
	var symToStr = Symbol.prototype.toString;
	var symStringRegex = /^Symbol\(.*\)$/;
	var isSymbolObject = function isRealSymbolObject(value) {
		if (typeof value.valueOf() !== 'symbol') {
			return false;
		}
		return symStringRegex.test(symToStr.call(value));
	};

	module.exports = function isSymbol(value) {
		if (typeof value === 'symbol') {
			return true;
		}
		if (toStr.call(value) !== '[object Symbol]') {
			return false;
		}
		try {
			return isSymbolObject(value);
		} catch (e) {
			return false;
		}
	};
} else {

	module.exports = function isSymbol(value) {
		// this environment does not support Symbols.
		return false && value;
	};
}


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var origSymbol = global.Symbol;
var hasSymbolSham = __webpack_require__(540);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 982 */
/***/ (function(module, exports) {

module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(202);

var $Object = GetIntrinsic('%Object%');
var $TypeError = GetIntrinsic('%TypeError%');
var $String = GetIntrinsic('%String%');

var assertRecord = __webpack_require__(561);
var $isNaN = __webpack_require__(562);
var $isFinite = __webpack_require__(563);

var sign = __webpack_require__(565);
var mod = __webpack_require__(566);

var IsCallable = __webpack_require__(201);
var toPrimitive = __webpack_require__(984);

var has = __webpack_require__(117);

// https://es5.github.io/#x9
var ES5 = {
	ToPrimitive: toPrimitive,

	ToBoolean: function ToBoolean(value) {
		return !!value;
	},
	ToNumber: function ToNumber(value) {
		return +value; // eslint-disable-line no-implicit-coercion
	},
	ToInteger: function ToInteger(value) {
		var number = this.ToNumber(value);
		if ($isNaN(number)) { return 0; }
		if (number === 0 || !$isFinite(number)) { return number; }
		return sign(number) * Math.floor(Math.abs(number));
	},
	ToInt32: function ToInt32(x) {
		return this.ToNumber(x) >> 0;
	},
	ToUint32: function ToUint32(x) {
		return this.ToNumber(x) >>> 0;
	},
	ToUint16: function ToUint16(value) {
		var number = this.ToNumber(value);
		if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
		var posInt = sign(number) * Math.floor(Math.abs(number));
		return mod(posInt, 0x10000);
	},
	ToString: function ToString(value) {
		return $String(value);
	},
	ToObject: function ToObject(value) {
		this.CheckObjectCoercible(value);
		return $Object(value);
	},
	CheckObjectCoercible: function CheckObjectCoercible(value, optMessage) {
		/* jshint eqnull:true */
		if (value == null) {
			throw new $TypeError(optMessage || 'Cannot call method on ' + value);
		}
		return value;
	},
	IsCallable: IsCallable,
	SameValue: function SameValue(x, y) {
		if (x === y) { // 0 === -0, but they are not identical.
			if (x === 0) { return 1 / x === 1 / y; }
			return true;
		}
		return $isNaN(x) && $isNaN(y);
	},

	// https://www.ecma-international.org/ecma-262/5.1/#sec-8
	Type: function Type(x) {
		if (x === null) {
			return 'Null';
		}
		if (typeof x === 'undefined') {
			return 'Undefined';
		}
		if (typeof x === 'function' || typeof x === 'object') {
			return 'Object';
		}
		if (typeof x === 'number') {
			return 'Number';
		}
		if (typeof x === 'boolean') {
			return 'Boolean';
		}
		if (typeof x === 'string') {
			return 'String';
		}
	},

	// https://ecma-international.org/ecma-262/6.0/#sec-property-descriptor-specification-type
	IsPropertyDescriptor: function IsPropertyDescriptor(Desc) {
		if (this.Type(Desc) !== 'Object') {
			return false;
		}
		var allowed = {
			'[[Configurable]]': true,
			'[[Enumerable]]': true,
			'[[Get]]': true,
			'[[Set]]': true,
			'[[Value]]': true,
			'[[Writable]]': true
		};

		for (var key in Desc) { // eslint-disable-line
			if (has(Desc, key) && !allowed[key]) {
				return false;
			}
		}

		var isData = has(Desc, '[[Value]]');
		var IsAccessor = has(Desc, '[[Get]]') || has(Desc, '[[Set]]');
		if (isData && IsAccessor) {
			throw new $TypeError('Property Descriptors may not be both accessor and data descriptors');
		}
		return true;
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-8.10.1
	IsAccessorDescriptor: function IsAccessorDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		assertRecord(this, 'Property Descriptor', 'Desc', Desc);

		if (!has(Desc, '[[Get]]') && !has(Desc, '[[Set]]')) {
			return false;
		}

		return true;
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-8.10.2
	IsDataDescriptor: function IsDataDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		assertRecord(this, 'Property Descriptor', 'Desc', Desc);

		if (!has(Desc, '[[Value]]') && !has(Desc, '[[Writable]]')) {
			return false;
		}

		return true;
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-8.10.3
	IsGenericDescriptor: function IsGenericDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		assertRecord(this, 'Property Descriptor', 'Desc', Desc);

		if (!this.IsAccessorDescriptor(Desc) && !this.IsDataDescriptor(Desc)) {
			return true;
		}

		return false;
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-8.10.4
	FromPropertyDescriptor: function FromPropertyDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return Desc;
		}

		assertRecord(this, 'Property Descriptor', 'Desc', Desc);

		if (this.IsDataDescriptor(Desc)) {
			return {
				value: Desc['[[Value]]'],
				writable: !!Desc['[[Writable]]'],
				enumerable: !!Desc['[[Enumerable]]'],
				configurable: !!Desc['[[Configurable]]']
			};
		} else if (this.IsAccessorDescriptor(Desc)) {
			return {
				get: Desc['[[Get]]'],
				set: Desc['[[Set]]'],
				enumerable: !!Desc['[[Enumerable]]'],
				configurable: !!Desc['[[Configurable]]']
			};
		} else {
			throw new $TypeError('FromPropertyDescriptor must be called with a fully populated Property Descriptor');
		}
	},

	// https://ecma-international.org/ecma-262/5.1/#sec-8.10.5
	ToPropertyDescriptor: function ToPropertyDescriptor(Obj) {
		if (this.Type(Obj) !== 'Object') {
			throw new $TypeError('ToPropertyDescriptor requires an object');
		}

		var desc = {};
		if (has(Obj, 'enumerable')) {
			desc['[[Enumerable]]'] = this.ToBoolean(Obj.enumerable);
		}
		if (has(Obj, 'configurable')) {
			desc['[[Configurable]]'] = this.ToBoolean(Obj.configurable);
		}
		if (has(Obj, 'value')) {
			desc['[[Value]]'] = Obj.value;
		}
		if (has(Obj, 'writable')) {
			desc['[[Writable]]'] = this.ToBoolean(Obj.writable);
		}
		if (has(Obj, 'get')) {
			var getter = Obj.get;
			if (typeof getter !== 'undefined' && !this.IsCallable(getter)) {
				throw new TypeError('getter must be a function');
			}
			desc['[[Get]]'] = getter;
		}
		if (has(Obj, 'set')) {
			var setter = Obj.set;
			if (typeof setter !== 'undefined' && !this.IsCallable(setter)) {
				throw new $TypeError('setter must be a function');
			}
			desc['[[Set]]'] = setter;
		}

		if ((has(desc, '[[Get]]') || has(desc, '[[Set]]')) && (has(desc, '[[Value]]') || has(desc, '[[Writable]]'))) {
			throw new $TypeError('Invalid property descriptor. Cannot both specify accessors and a value or writable attribute');
		}
		return desc;
	}
};

module.exports = ES5;


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

var isPrimitive = __webpack_require__(560);

var isCallable = __webpack_require__(201);

// http://ecma-international.org/ecma-262/5.1/#sec-8.12.8
var ES5internalSlots = {
	'[[DefaultValue]]': function (O) {
		var actualHint;
		if (arguments.length > 1) {
			actualHint = arguments[1];
		} else {
			actualHint = toStr.call(O) === '[object Date]' ? String : Number;
		}

		if (actualHint === String || actualHint === Number) {
			var methods = actualHint === String ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
			var value, i;
			for (i = 0; i < methods.length; ++i) {
				if (isCallable(O[methods[i]])) {
					value = O[methods[i]]();
					if (isPrimitive(value)) {
						return value;
					}
				}
			}
			throw new TypeError('No default value');
		}
		throw new TypeError('invalid [[DefaultValue]] hint supplied');
	}
};

// http://ecma-international.org/ecma-262/5.1/#sec-9.1
module.exports = function ToPrimitive(input) {
	if (isPrimitive(input)) {
		return input;
	}
	if (arguments.length > 1) {
		return ES5internalSlots['[[DefaultValue]]'](input, arguments[1]);
	}
	return ES5internalSlots['[[DefaultValue]]'](input);
};


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(117);
var regexExec = RegExp.prototype.exec;
var gOPD = Object.getOwnPropertyDescriptor;

var tryRegexExecCall = function tryRegexExec(value) {
	try {
		var lastIndex = value.lastIndex;
		value.lastIndex = 0;

		regexExec.call(value);
		return true;
	} catch (e) {
		return false;
	} finally {
		value.lastIndex = lastIndex;
	}
};
var toStr = Object.prototype.toString;
var regexClass = '[object RegExp]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isRegex(value) {
	if (!value || typeof value !== 'object') {
		return false;
	}
	if (!hasToStringTag) {
		return toStr.call(value) === regexClass;
	}

	var descriptor = gOPD(value, 'lastIndex');
	var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
	if (!hasLastIndexDataProperty) {
		return false;
	}

	return tryRegexExecCall(value);
};


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getPolyfill = __webpack_require__(567);
var define = __webpack_require__(151);

module.exports = function shimValues() {
	var polyfill = getPolyfill();
	define(Object, { values: polyfill }, {
		values: function testValues() {
			return Object.values !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 74);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __webpack_require__(2);

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __webpack_require__(24);

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
  }

  _createClass(SVG, [{
    key: "render",
    value: function () {
      function render() {
        return _react2["default"].createElement(
          "svg",
          _extends({ viewBox: "0 0 12 12" }, this.props),
          _react2["default"].createElement("path", { fillRule: "evenodd", d: "M11.53.47a.75.75 0 0 0-1.061 0l-4.47 4.47L1.529.47A.75.75 0 1 0 .468 1.531l4.47 4.47-4.47 4.47a.75.75 0 1 0 1.061 1.061l4.47-4.47 4.47 4.47a.75.75 0 1 0 1.061-1.061l-4.47-4.47 4.47-4.47a.75.75 0 0 0 0-1.061z" })
        );
      }

      return render;
    }()
  }]);

  return SVG;
}(_react2["default"].Component);

exports["default"] = SVG;

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = __webpack_require__(99);

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = __webpack_require__(112);

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

module.exports = __webpack_require__(148);

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

module.exports = __webpack_require__(149);

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __webpack_require__(12);

/***/ }),

/***/ 29:
/***/ (function(module, exports) {

module.exports = __webpack_require__(408);

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __webpack_require__(27);

/***/ }),

/***/ 33:
/***/ (function(module, exports) {

module.exports = __webpack_require__(197);

/***/ }),

/***/ 34:
/***/ (function(module, exports) {

module.exports = __webpack_require__(100);

/***/ }),

/***/ 40:
/***/ (function(module, exports) {

module.exports = __webpack_require__(409);

/***/ }),

/***/ 45:
/***/ (function(module, exports) {

module.exports = __webpack_require__(569);

/***/ }),

/***/ 59:
/***/ (function(module, exports) {

module.exports = __webpack_require__(570);

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = __webpack_require__(44);

/***/ }),

/***/ 60:
/***/ (function(module, exports) {

module.exports = __webpack_require__(571);

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __webpack_require__(0);

/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(7);

var _moment2 = _interopRequireDefault(_moment);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactPortal = __webpack_require__(40);

var _reactPortal2 = _interopRequireDefault(_reactPortal);

var _airbnbPropTypes = __webpack_require__(1);

var _consolidatedEvents = __webpack_require__(18);

var _isTouchDevice = __webpack_require__(9);

var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);

var _SingleDatePickerShape = __webpack_require__(45);

var _SingleDatePickerShape2 = _interopRequireDefault(_SingleDatePickerShape);

var _defaultPhrases = __webpack_require__(3);

var _OutsideClickHandler = __webpack_require__(17);

var _OutsideClickHandler2 = _interopRequireDefault(_OutsideClickHandler);

var _toMomentObject = __webpack_require__(34);

var _toMomentObject2 = _interopRequireDefault(_toMomentObject);

var _toLocalizedDateString = __webpack_require__(33);

var _toLocalizedDateString2 = _interopRequireDefault(_toLocalizedDateString);

var _getResponsiveContainerStyles = __webpack_require__(29);

var _getResponsiveContainerStyles2 = _interopRequireDefault(_getResponsiveContainerStyles);

var _toISODateString = __webpack_require__(13);

var _toISODateString2 = _interopRequireDefault(_toISODateString);

var _SingleDatePickerInput = __webpack_require__(60);

var _SingleDatePickerInput2 = _interopRequireDefault(_SingleDatePickerInput);

var _DayPickerSingleDateController = __webpack_require__(59);

var _DayPickerSingleDateController2 = _interopRequireDefault(_DayPickerSingleDateController);

var _close = __webpack_require__(11);

var _close2 = _interopRequireDefault(_close);

var _isInclusivelyAfterDay = __webpack_require__(16);

var _isInclusivelyAfterDay2 = _interopRequireDefault(_isInclusivelyAfterDay);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(_SingleDatePickerShape2['default']);

var defaultProps = {
  // required props for a functional interactive SingleDatePicker
  date: null,
  focused: false,

  // input related props
  id: 'date',
  placeholder: 'Date',
  disabled: false,
  required: false,
  readOnly: false,
  screenReaderInputMessage: '',
  showClearDate: false,
  showDefaultInputIcon: false,
  inputIconPosition: _constants.ICON_BEFORE_POSITION,
  customInputIcon: null,
  customCloseIcon: null,

  // calendar presentation and interaction related props
  orientation: _constants.HORIZONTAL_ORIENTATION,
  anchorDirection: _constants.ANCHOR_LEFT,
  openDirection: _constants.OPEN_DOWN,
  horizontalMargin: 0,
  withPortal: false,
  withFullScreenPortal: false,
  initialVisibleMonth: null,
  firstDayOfWeek: null,
  numberOfMonths: 2,
  keepOpenOnDateSelect: false,
  reopenPickerOnClearDate: false,
  renderCalendarInfo: null,
  hideKeyboardShortcutsPanel: false,
  daySize: _constants.DAY_SIZE,
  isRTL: false,

  // navigation related props
  navPrev: null,
  navNext: null,

  onPrevMonthClick: function () {
    function onPrevMonthClick() {}

    return onPrevMonthClick;
  }(),
  onNextMonthClick: function () {
    function onNextMonthClick() {}

    return onNextMonthClick;
  }(),
  onClose: function () {
    function onClose() {}

    return onClose;
  }(),

  // month presentation and interaction related props
  renderMonth: null,

  // day presentation and interaction related props
  renderDay: null,
  enableOutsideDays: false,
  isDayBlocked: function () {
    function isDayBlocked() {
      return false;
    }

    return isDayBlocked;
  }(),
  isOutsideRange: function () {
    function isOutsideRange(day) {
      return !(0, _isInclusivelyAfterDay2['default'])(day, (0, _moment2['default'])());
    }

    return isOutsideRange;
  }(),
  isDayHighlighted: function () {
    function isDayHighlighted() {}

    return isDayHighlighted;
  }(),

  // internationalization props
  displayFormat: function () {
    function displayFormat() {
      return _moment2['default'].localeData().longDateFormat('L');
    }

    return displayFormat;
  }(),
  monthFormat: 'MMMM YYYY',
  weekDayFormat: 'dd',
  phrases: _defaultPhrases.SingleDatePickerPhrases
};

var SingleDatePicker = function (_React$Component) {
  _inherits(SingleDatePicker, _React$Component);

  function SingleDatePicker(props) {
    _classCallCheck(this, SingleDatePicker);

    var _this = _possibleConstructorReturn(this, (SingleDatePicker.__proto__ || Object.getPrototypeOf(SingleDatePicker)).call(this, props));

    _this.isTouchDevice = false;

    _this.state = {
      dayPickerContainerStyles: {},
      isDayPickerFocused: false,
      isInputFocused: false
    };

    _this.onDayPickerFocus = _this.onDayPickerFocus.bind(_this);
    _this.onDayPickerBlur = _this.onDayPickerBlur.bind(_this);

    _this.onChange = _this.onChange.bind(_this);
    _this.onFocus = _this.onFocus.bind(_this);
    _this.onClearFocus = _this.onClearFocus.bind(_this);
    _this.clearDate = _this.clearDate.bind(_this);

    _this.responsivizePickerPosition = _this.responsivizePickerPosition.bind(_this);

    _this.setDayPickerContainerRef = _this.setDayPickerContainerRef.bind(_this);
    return _this;
  }

  /* istanbul ignore next */

  _createClass(SingleDatePicker, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        this.resizeHandle = (0, _consolidatedEvents.addEventListener)(window, 'resize', this.responsivizePickerPosition, { passive: true });
        this.responsivizePickerPosition();

        if (this.props.focused) {
          this.setState({
            isInputFocused: true
          });
        }

        this.isTouchDevice = (0, _isTouchDevice2['default'])();
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate(prevProps) {
        if (!prevProps.focused && this.props.focused) {
          this.responsivizePickerPosition();
        }
      }

      return componentDidUpdate;
    }()

    /* istanbul ignore next */

  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        (0, _consolidatedEvents.removeEventListener)(this.resizeHandle);
      }

      return componentWillUnmount;
    }()
  }, {
    key: 'onChange',
    value: function () {
      function onChange(dateString) {
        var _props = this.props,
            isOutsideRange = _props.isOutsideRange,
            keepOpenOnDateSelect = _props.keepOpenOnDateSelect,
            onDateChange = _props.onDateChange,
            onFocusChange = _props.onFocusChange,
            onClose = _props.onClose;

        var newDate = (0, _toMomentObject2['default'])(dateString, this.getDisplayFormat());

        var isValid = newDate && !isOutsideRange(newDate);
        if (isValid) {
          onDateChange(newDate);
          if (!keepOpenOnDateSelect) {
            onFocusChange({ focused: false });
            onClose({ date: newDate });
          }
        } else {
          onDateChange(null);
        }
      }

      return onChange;
    }()
  }, {
    key: 'onFocus',
    value: function () {
      function onFocus() {
        var _props2 = this.props,
            disabled = _props2.disabled,
            onFocusChange = _props2.onFocusChange,
            withPortal = _props2.withPortal,
            withFullScreenPortal = _props2.withFullScreenPortal;

        var moveFocusToDayPicker = withPortal || withFullScreenPortal || this.isTouchDevice;
        if (moveFocusToDayPicker) {
          this.onDayPickerFocus();
        } else {
          this.onDayPickerBlur();
        }

        if (!disabled) {
          onFocusChange({ focused: true });
        }
      }

      return onFocus;
    }()
  }, {
    key: 'onClearFocus',
    value: function () {
      function onClearFocus() {
        var _props3 = this.props,
            startDate = _props3.startDate,
            endDate = _props3.endDate,
            focused = _props3.focused,
            onFocusChange = _props3.onFocusChange,
            onClose = _props3.onClose;

        if (!focused) return;

        this.setState({
          isInputFocused: false,
          isDayPickerFocused: false
        });

        onFocusChange({ focused: false });
        onClose({ startDate: startDate, endDate: endDate });
      }

      return onClearFocus;
    }()
  }, {
    key: 'onDayPickerFocus',
    value: function () {
      function onDayPickerFocus() {
        this.setState({
          isInputFocused: false,
          isDayPickerFocused: true
        });
      }

      return onDayPickerFocus;
    }()
  }, {
    key: 'onDayPickerBlur',
    value: function () {
      function onDayPickerBlur() {
        this.setState({
          isInputFocused: true,
          isDayPickerFocused: false
        });
      }

      return onDayPickerBlur;
    }()
  }, {
    key: 'getDateString',
    value: function () {
      function getDateString(date) {
        var displayFormat = this.getDisplayFormat();
        if (date && displayFormat) {
          return date && date.format(displayFormat);
        }
        return (0, _toLocalizedDateString2['default'])(date);
      }

      return getDateString;
    }()
  }, {
    key: 'getDayPickerContainerClasses',
    value: function () {
      function getDayPickerContainerClasses() {
        var _props4 = this.props,
            orientation = _props4.orientation,
            withPortal = _props4.withPortal,
            withFullScreenPortal = _props4.withFullScreenPortal,
            anchorDirection = _props4.anchorDirection,
            openDirection = _props4.openDirection,
            isRTL = _props4.isRTL;

        var dayPickerClassName = (0, _classnames2['default'])('SingleDatePicker__picker', {
          'SingleDatePicker__picker--direction-left': anchorDirection === _constants.ANCHOR_LEFT,
          'SingleDatePicker__picker--direction-right': anchorDirection === _constants.ANCHOR_RIGHT,
          'SingleDatePicker__picker--open-down': openDirection === _constants.OPEN_DOWN,
          'SingleDatePicker__picker--open-up': openDirection === _constants.OPEN_UP,
          'SingleDatePicker__picker--horizontal': orientation === _constants.HORIZONTAL_ORIENTATION,
          'SingleDatePicker__picker--vertical': orientation === _constants.VERTICAL_ORIENTATION,
          'SingleDatePicker__picker--portal': withPortal || withFullScreenPortal,
          'SingleDatePicker__picker--full-screen-portal': withFullScreenPortal,
          'SingleDatePicker__picker--rtl': isRTL
        });

        return dayPickerClassName;
      }

      return getDayPickerContainerClasses;
    }()
  }, {
    key: 'getDisplayFormat',
    value: function () {
      function getDisplayFormat() {
        var displayFormat = this.props.displayFormat;

        return typeof displayFormat === 'string' ? displayFormat : displayFormat();
      }

      return getDisplayFormat;
    }()
  }, {
    key: 'setDayPickerContainerRef',
    value: function () {
      function setDayPickerContainerRef(ref) {
        this.dayPickerContainer = ref;
      }

      return setDayPickerContainerRef;
    }()
  }, {
    key: 'clearDate',
    value: function () {
      function clearDate() {
        var _props5 = this.props,
            onDateChange = _props5.onDateChange,
            reopenPickerOnClearDate = _props5.reopenPickerOnClearDate,
            onFocusChange = _props5.onFocusChange;

        onDateChange(null);
        if (reopenPickerOnClearDate) {
          onFocusChange({ focused: true });
        }
      }

      return clearDate;
    }()

    /* istanbul ignore next */

  }, {
    key: 'responsivizePickerPosition',
    value: function () {
      function responsivizePickerPosition() {
        // It's possible the portal props have been changed in response to window resizes
        // So let's ensure we reset this back to the base state each time
        this.setState({ dayPickerContainerStyles: {} });

        var _props6 = this.props,
            anchorDirection = _props6.anchorDirection,
            horizontalMargin = _props6.horizontalMargin,
            withPortal = _props6.withPortal,
            withFullScreenPortal = _props6.withFullScreenPortal,
            focused = _props6.focused;
        var dayPickerContainerStyles = this.state.dayPickerContainerStyles;

        if (!focused) {
          return;
        }

        var isAnchoredLeft = anchorDirection === _constants.ANCHOR_LEFT;

        if (!withPortal && !withFullScreenPortal) {
          var containerRect = this.dayPickerContainer.getBoundingClientRect();
          var currentOffset = dayPickerContainerStyles[anchorDirection] || 0;
          var containerEdge = isAnchoredLeft ? containerRect[_constants.ANCHOR_RIGHT] : containerRect[_constants.ANCHOR_LEFT];

          this.setState({
            dayPickerContainerStyles: (0, _getResponsiveContainerStyles2['default'])(anchorDirection, currentOffset, containerEdge, horizontalMargin)
          });
        }
      }

      return responsivizePickerPosition;
    }()
  }, {
    key: 'maybeRenderDayPickerWithPortal',
    value: function () {
      function maybeRenderDayPickerWithPortal() {
        var _props7 = this.props,
            focused = _props7.focused,
            withPortal = _props7.withPortal,
            withFullScreenPortal = _props7.withFullScreenPortal;

        if (!focused) {
          return null;
        }

        if (withPortal || withFullScreenPortal) {
          return _react2['default'].createElement(_reactPortal2['default'], { isOpened: true }, this.renderDayPicker());
        }

        return this.renderDayPicker();
      }

      return maybeRenderDayPickerWithPortal;
    }()
  }, {
    key: 'renderDayPicker',
    value: function () {
      function renderDayPicker() {
        var _props8 = this.props,
            onDateChange = _props8.onDateChange,
            date = _props8.date,
            onFocusChange = _props8.onFocusChange,
            focused = _props8.focused,
            enableOutsideDays = _props8.enableOutsideDays,
            numberOfMonths = _props8.numberOfMonths,
            orientation = _props8.orientation,
            monthFormat = _props8.monthFormat,
            navPrev = _props8.navPrev,
            navNext = _props8.navNext,
            onPrevMonthClick = _props8.onPrevMonthClick,
            onNextMonthClick = _props8.onNextMonthClick,
            withPortal = _props8.withPortal,
            withFullScreenPortal = _props8.withFullScreenPortal,
            keepOpenOnDateSelect = _props8.keepOpenOnDateSelect,
            initialVisibleMonth = _props8.initialVisibleMonth,
            renderMonth = _props8.renderMonth,
            renderDay = _props8.renderDay,
            renderCalendarInfo = _props8.renderCalendarInfo,
            hideKeyboardShortcutsPanel = _props8.hideKeyboardShortcutsPanel,
            firstDayOfWeek = _props8.firstDayOfWeek,
            customCloseIcon = _props8.customCloseIcon,
            phrases = _props8.phrases,
            daySize = _props8.daySize,
            isRTL = _props8.isRTL,
            isOutsideRange = _props8.isOutsideRange,
            isDayBlocked = _props8.isDayBlocked,
            isDayHighlighted = _props8.isDayHighlighted,
            weekDayFormat = _props8.weekDayFormat;
        var _state = this.state,
            dayPickerContainerStyles = _state.dayPickerContainerStyles,
            isDayPickerFocused = _state.isDayPickerFocused;

        var onOutsideClick = !withFullScreenPortal && withPortal ? this.onClearFocus : undefined;
        var closeIcon = customCloseIcon || _react2['default'].createElement(_close2['default'], null);

        return _react2['default'].createElement('div', { // eslint-disable-line jsx-a11y/no-static-element-interactions
          ref: this.setDayPickerContainerRef,
          className: this.getDayPickerContainerClasses(),
          style: dayPickerContainerStyles,
          onClick: onOutsideClick
        }, _react2['default'].createElement(_DayPickerSingleDateController2['default'], {
          date: date,
          onDateChange: onDateChange,
          onFocusChange: onFocusChange,
          orientation: orientation,
          enableOutsideDays: enableOutsideDays,
          numberOfMonths: numberOfMonths,
          monthFormat: monthFormat,
          withPortal: withPortal || withFullScreenPortal,
          focused: focused,
          keepOpenOnDateSelect: keepOpenOnDateSelect,
          hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
          initialVisibleMonth: initialVisibleMonth,
          navPrev: navPrev,
          navNext: navNext,
          onPrevMonthClick: onPrevMonthClick,
          onNextMonthClick: onNextMonthClick,
          renderMonth: renderMonth,
          renderDay: renderDay,
          renderCalendarInfo: renderCalendarInfo,
          isFocused: isDayPickerFocused,
          phrases: phrases,
          daySize: daySize,
          isRTL: isRTL,
          isOutsideRange: isOutsideRange,
          isDayBlocked: isDayBlocked,
          isDayHighlighted: isDayHighlighted,
          firstDayOfWeek: firstDayOfWeek,
          weekDayFormat: weekDayFormat
        }), withFullScreenPortal && _react2['default'].createElement('button', {
          'aria-label': phrases.closeDatePicker,
          className: 'SingleDatePicker__close',
          type: 'button',
          onClick: this.onClearFocus
        }, _react2['default'].createElement('div', { className: 'SingleDatePicker__close-icon' }, closeIcon)));
      }

      return renderDayPicker;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props9 = this.props,
            id = _props9.id,
            placeholder = _props9.placeholder,
            disabled = _props9.disabled,
            focused = _props9.focused,
            required = _props9.required,
            readOnly = _props9.readOnly,
            openDirection = _props9.openDirection,
            showClearDate = _props9.showClearDate,
            showDefaultInputIcon = _props9.showDefaultInputIcon,
            inputIconPosition = _props9.inputIconPosition,
            customInputIcon = _props9.customInputIcon,
            date = _props9.date,
            phrases = _props9.phrases,
            withPortal = _props9.withPortal,
            withFullScreenPortal = _props9.withFullScreenPortal,
            screenReaderInputMessage = _props9.screenReaderInputMessage,
            isRTL = _props9.isRTL;
        var isInputFocused = this.state.isInputFocused;

        var displayValue = this.getDateString(date);
        var inputValue = (0, _toISODateString2['default'])(date);

        var onOutsideClick = !withPortal && !withFullScreenPortal ? this.onClearFocus : undefined;

        return _react2['default'].createElement('div', { className: 'SingleDatePicker' }, _react2['default'].createElement(_OutsideClickHandler2['default'], { onOutsideClick: onOutsideClick }, _react2['default'].createElement(_SingleDatePickerInput2['default'], {
          id: id,
          placeholder: placeholder,
          focused: focused,
          isFocused: isInputFocused,
          disabled: disabled,
          required: required,
          readOnly: readOnly,
          openDirection: openDirection,
          showCaret: !withPortal && !withFullScreenPortal,
          onClearDate: this.clearDate,
          showClearDate: showClearDate,
          showDefaultInputIcon: showDefaultInputIcon,
          inputIconPosition: inputIconPosition,
          customInputIcon: customInputIcon,
          displayValue: displayValue,
          inputValue: inputValue,
          onChange: this.onChange,
          onFocus: this.onFocus,
          onKeyDownShiftTab: this.onClearFocus,
          onKeyDownTab: this.onClearFocus,
          onKeyDownArrowDown: this.onDayPickerFocus,
          screenReaderMessage: screenReaderInputMessage,
          phrases: phrases,
          isRTL: isRTL
        }), this.maybeRenderDayPickerWithPortal()));
      }

      return render;
    }()
  }]);

  return SingleDatePicker;
}(_react2['default'].Component);

exports['default'] = SingleDatePicker;

SingleDatePicker.propTypes = propTypes;
SingleDatePicker.defaultProps = defaultProps;

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = __webpack_require__(97);

/***/ })

/******/ });

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = isInclusivelyBeforeDay;

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _isAfterDay = __webpack_require__(116);

var _isAfterDay2 = _interopRequireDefault(_isAfterDay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function isInclusivelyBeforeDay(a, b) {
  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
  return !(0, _isAfterDay2['default'])(a, b);
}

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DealsSummary = undefined;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _deals = __webpack_require__(85);

var _deals2 = _interopRequireDefault(_deals);

var _dealsTotal = __webpack_require__(990);

var _dealsTotal2 = _interopRequireDefault(_dealsTotal);

var _dealsPayed = __webpack_require__(991);

var _dealsPayed2 = _interopRequireDefault(_dealsPayed);

var _reactI18next = __webpack_require__(4);

var _utils = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DealsSummary = exports.DealsSummary = function DealsSummary(_ref) {
  var dealCount = _ref.dealCount,
      dealsTotal = _ref.dealsTotal,
      dealsPayed = _ref.dealsPayed;

  return _react2.default.createElement(
    _reactI18next.Translation,
    null,
    function (t) {
      var dealWord = dealCount === 1 ? 'Deal' : 'Deals';
      var formattedDealsTotal = (0, _utils.formattaPrezzo)(dealsTotal, true);
      var formattedDealsPayed = (0, _utils.formattaPrezzo)(dealsPayed, true);
      var dealsPending = (0, _utils.formattaPrezzo)(dealsTotal - dealsPayed, true);

      return _react2.default.createElement(
        'div',
        { className: 'container' },
        _react2.default.createElement(
          'span',
          null,
          dealCount
        ),
        ' ',
        t('Vendite'),
        ' - ',
        t('Totale'),
        ':',
        ' ',
        _react2.default.createElement(
          'span',
          null,
          formattedDealsTotal
        ),
        ' - ',
        t('Incassate'),
        ':',
        ' ',
        _react2.default.createElement(
          'span',
          null,
          formattedDealsPayed
        ),
        ' - ',
        t('Aperte'),
        ':',
        ' ',
        _react2.default.createElement(
          'span',
          null,
          dealsPending
        )
      );
    }
  );
};

var mapStateToProps = function mapStateToProps(state) {
  //lo chiami anche da dealsList
  var visibleDeals = (0, _deals2.default)('deals', state.deals, state.filters, state.utenti.find(function (utente) {
    return utente.firebaseAuthId === state.auth.uid;
  }), state.oggetti, state.clienti, state.fatture);
  // const payedDeals = visibleDeals.filter(deal =>
  //   state.fatture.find(fattura => fattura.dealId === deal.id && fattura.payed)
  // );
  return {
    dealCount: visibleDeals.length,
    dealsTotal: (0, _dealsTotal2.default)(visibleDeals, state.utenti.find(function (utente) {
      return utente.firebaseAuthId === state.auth.uid;
    })),
    dealsPayed: (0, _dealsPayed2.default)(visibleDeals, state.utenti.find(function (utente) {
      return utente.firebaseAuthId === state.auth.uid;
    }), state.fatture)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(DealsSummary);

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// Get Deal Total

exports.default = function (deals) {
  var utente = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Mitarbeiter';

  if (utente.role === 'Mitarbeiter') {
    return deals.map(function (deal) {
      return deal.provvStefano;
    }).reduce(function (sum, value) {
      return sum + value;
    }, 0);
  } else {
    return deals.map(function (deal) {
      return deal.provvM2square;
    }).reduce(function (sum, value) {
      return sum + value;
    }, 0);
  }
};

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// Get Deal Payed

exports.default = function (deals) {
  var utente = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Mitarbeiter';
  var fatture = arguments[2];

  if (utente.role === 'Mitarbeiter') {
    return deals.filter(function (deal) {
      return deal.payedStefano;
    }).map(function (deal) {
      return deal.provvStefano;
    }).reduce(function (sum, value) {
      return sum + value;
    }, 0);
  } else {
    var dealsFatturati = deals.filter(function (deal) {
      return fatture.find(function (fattura) {
        return fattura.dealId === deal.id && fattura.payed;
      });
    }).map(function (deal) {
      return deal.provvM2square;
    }).reduce(function (sum, value) {
      return sum + value;
    }, 0);

    var dealsGutschrift = deals.filter(function (deal) {
      return deal.feePayed;
    }).map(function (deal) {
      return deal.provvM2square;
    }).reduce(function (sum, value) {
      return sum + value;
    }, 0);

    return dealsFatturati + dealsGutschrift;
  }
};

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Filters Reducer

var filtersReducerDefaultState = {
  text: '',
  sortBy: 'date',
  startDate: (0, _moment2.default)().startOf('year'),
  endDate: (0, _moment2.default)().endOf('year'),
  lead: '',
  leadStato: ''
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : filtersReducerDefaultState;
  var action = arguments[1];

  switch (action.type) {
    case 'SET_TEXT_FILTER':
      return _extends({}, state, {
        text: action.text
      });
    case 'SORT_BY_AMOUNT':
      return _extends({}, state, {
        sortBy: 'amount'
      });
    case 'SORT_BY_DATE':
      return _extends({}, state, {
        sortBy: 'date'
      });
    case 'SORT_BY_PAID':
      return _extends({}, state, {
        sortBy: 'paid'
      });
    case 'SORT_BY_PUBLISHED':
      return _extends({}, state, {
        sortBy: 'published'
      });
    case 'SORT_BY_NAME':
      return _extends({}, state, {
        sortBy: 'name'
      });

    case 'SET_START_DATE':
      return _extends({}, state, {
        startDate: action.startDate
      });
    case 'SET_END_DATE':
      return _extends({}, state, {
        endDate: action.endDate
      });
    case 'SET_LEAD_FILTER':
      return _extends({}, state, {
        lead: action.lead
      });
    case 'SET_LEADSTATO_FILTER':
      return _extends({}, state, {
        leadStato: action.leadStato
      });
    default:
      return state;
  }
};

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case 'LOGIN':
            return {
                uid: action.uid
            };
        case 'LOGOUT':
            return {};
        default:
            return state;
    }
};

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _firebase = __webpack_require__(192);

var _firebase2 = _interopRequireDefault(_firebase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var storeSection = function storeSection(label) {
  var _this = this;

  _classCallCheck(this, storeSection);

  this.addAction = function (fields) {
    return {
      type: 'ADD_' + _this.label.toUpperCase(),
      fields: fields
    };
  };

  this.startAddAction = function (fields) {
    return function (dispatch) {
      return _firebase2.default.ref('/' + _this.label).push(fields).then(function (ref) {
        dispatch(_this.addAction(_extends({
          id: ref.key
        }, fields)));
      });
    };
  };

  this.removeAction = function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        id = _ref.id;

    return {
      type: 'REMOVE_' + _this.label.toUpperCase(),
      id: id
    };
  };

  this.startRemoveAction = function () {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        id = _ref2.id;

    return function (dispatch) {
      return _firebase2.default.ref('/' + _this.label + '/' + id).remove().then(function () {
        dispatch(_this.removeAction({ id: id }));
      });
    };
  };

  this.editAction = function (id, updates) {
    return {
      type: 'EDIT_' + _this.label.toUpperCase(),
      id: id,
      updates: updates
    };
  };

  this.startEditAction = function (id, updates) {
    return function (dispatch) {
      return _firebase2.default.ref('/' + _this.label + '/' + id).update(updates).then(function () {
        dispatch(_this.editAction(id, updates));
      });
    };
  };

  this.setAction = function (fields) {
    return {
      type: 'SET_' + _this.label.toUpperCase(),
      fields: fields
    };
  };

  this.startSetAction = function () {
    return function (dispatch) {
      return _firebase2.default.ref('' + _this.label).once('value').then(function (snapshot) {
        var fields = [];
        snapshot.forEach(function (childSnapshot) {
          fields.push(_extends({
            id: childSnapshot.key
          }, childSnapshot.val()));
        });
        dispatch(_this.setAction(fields));
      });
    };
  };

  this.actionReducer = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var action = arguments[1];

    switch (action.type) {
      case 'ADD_' + _this.label.toUpperCase():
        return [].concat(_toConsumableArray(state), [action.fields]);
      case 'REMOVE_' + _this.label.toUpperCase():
        return state.filter(function (_ref3) {
          var id = _ref3.id;
          return id !== action.id;
        });
      case 'EDIT_' + _this.label.toUpperCase():
        return state.map(function (storeItem) {
          if (storeItem.id === action.id) {
            return _extends({}, storeItem, action.updates);
          } else {
            return storeItem;
          }
        });
      case 'SET_' + _this.label.toUpperCase():
        return action.fields;
      default:
        return state;
    }
  };

  this.getActions = function () {
    var name = _this.label[0].toUpperCase() + _this.label.slice(1);
    return {
      label: _this.label,
      startAddAction: _this.startAddAction,
      startSetAction: _this.startSetAction,
      startRemoveAction: _this.startRemoveAction,
      startEditAction: _this.startEditAction
    };
  };

  this.label = label;
  // this.fields = action.fields;
}

// ADD ACTION


// REMOVE ACTION


// EDIT ACTION


// SET ACTION


//REDUCER////////////////////////////////


// GETTER
;

exports.default = storeSection;

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditDealPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _configureStore = __webpack_require__(14);

var _DealForm = __webpack_require__(573);

var _DealForm2 = _interopRequireDefault(_DealForm);

var _OptionModal = __webpack_require__(58);

var _OptionModal2 = _interopRequireDefault(_OptionModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditDealPage = exports.EditDealPage = function (_React$Component) {
  _inherits(EditDealPage, _React$Component);

  function EditDealPage() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, EditDealPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditDealPage.__proto__ || Object.getPrototypeOf(EditDealPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isOpen: false,
      modalContent: 'remove_confirm',
      btnEnabled: true
    }, _this.handleOpenModal = function () {
      _this.setState(function () {
        return {
          isOpen: true
        };
      });
    }, _this.handleCloseModal = function () {
      _this.setState({ isOpen: false });
    }, _this.onSubmit = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(deal) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.props.startEditDeal(_this.props.deal.id, deal);

              case 2:
                _this.props.history.push('/view/' + _this.props.deal.id);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), _this.onValidate = function () {
      var fatture = _this.props.fatture.filter(function (fattura) {
        return fattura.dealId === _this.props.deal.id;
      });
      if (fatture.length === 0) return true;

      return false;
    }, _this.onRemove = function () {
      if (_this.onValidate()) {
        _this.props.startRemoveDeal({ id: _this.props.deal.id });
        _this.props.history.push('/deals');
      } else {
        _this.setState(function () {
          return {
            isOpen: true,
            modalContent: 'cannot_delete_deal',
            btnEnabled: false
          };
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // verifico che non ci siano fatture emesse per questa vendita


  _createClass(EditDealPage, [{
    key: 'render',
    value: function render() {
      if (!this.props.deal) {
        this.props.history.push('/deals');
        return _react2.default.createElement(
          'div',
          null,
          'Loading...'
        );
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'h1',
              null,
              this.props.t('Modifica dati vendita')
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(_OptionModal2.default, {
            isOpen: this.state.isOpen,
            contentLabel: 'remove',
            modalContent: this.props.t(this.state.modalContent),
            onCancel: this.handleCloseModal,
            onConfirm: this.onRemove,
            btnEnabled: this.state.btnEnabled
          }),
          _react2.default.createElement(_DealForm2.default, { deal: this.props.deal, onSubmit: this.onSubmit }),
          _react2.default.createElement(
            'button',
            {
              className: 'btn-floating red margine-basso',
              onClick: this.handleOpenModal
            },
            _react2.default.createElement(
              'i',
              { className: 'material-icons' },
              'delete'
            )
          )
        )
      );
    }
  }]);

  return EditDealPage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    deal: state.deals.find(function (deal) {
      return deal.id === props.match.params.id;
    }),
    fatture: state.fatture
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    startEditDeal: function startEditDeal(id, deal) {
      return dispatch(_configureStore.storeActions.find(function (action) {
        return action.label === 'deals';
      }).startEditAction(id, deal));
    },
    startRemoveDeal: function startRemoveDeal(data) {
      return dispatch(_configureStore.storeActions.find(function (action) {
        return action.label === 'deals';
      }).startRemoveAction(data));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactI18next.withTranslation)()(EditDealPage));

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _VirtualizedSelect = __webpack_require__(998);

var _VirtualizedSelect2 = _interopRequireDefault(_VirtualizedSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _VirtualizedSelect2.default;

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _VirtualizedSelect = __webpack_require__(999);

var _VirtualizedSelect2 = _interopRequireDefault(_VirtualizedSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _VirtualizedSelect2.default;

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactSelect = __webpack_require__(1000);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _AutoSizer = __webpack_require__(1002);

var _AutoSizer2 = _interopRequireDefault(_AutoSizer);

var _List = __webpack_require__(1039);

var _List2 = _interopRequireDefault(_List);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Import directly to avoid Webpack bundling the parts of react-virtualized that we are not using


var VirtualizedSelect = function (_Component) {
  _inherits(VirtualizedSelect, _Component);

  function VirtualizedSelect(props, context) {
    _classCallCheck(this, VirtualizedSelect);

    var _this = _possibleConstructorReturn(this, (VirtualizedSelect.__proto__ || Object.getPrototypeOf(VirtualizedSelect)).call(this, props, context));

    _this._renderMenu = _this._renderMenu.bind(_this);
    _this._optionRenderer = _this._optionRenderer.bind(_this);
    _this._setListRef = _this._setListRef.bind(_this);
    _this._setSelectRef = _this._setSelectRef.bind(_this);
    return _this;
  }

  /** See List#recomputeRowHeights */


  _createClass(VirtualizedSelect, [{
    key: 'recomputeOptionHeights',
    value: function recomputeOptionHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this._listRef) {
        this._listRef.recomputeRowHeights(index);
      }
    }

    /** See Select#focus (in react-select) */

  }, {
    key: 'focus',
    value: function focus() {
      if (this._selectRef) {
        return this._selectRef.focus();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var SelectComponent = this._getSelectComponent();

      return _react2.default.createElement(SelectComponent, _extends({}, this.props, {
        ref: this._setSelectRef,
        menuRenderer: this._renderMenu,
        menuStyle: { overflow: 'hidden' }
      }));
    }

    // See https://github.com/JedWatson/react-select/#effeciently-rendering-large-lists-with-windowing

  }, {
    key: '_renderMenu',
    value: function _renderMenu(_ref) {
      var _this2 = this;

      var focusedOption = _ref.focusedOption,
          focusOption = _ref.focusOption,
          labelKey = _ref.labelKey,
          onSelect = _ref.onSelect,
          options = _ref.options,
          selectValue = _ref.selectValue,
          valueArray = _ref.valueArray,
          valueKey = _ref.valueKey;
      var _props = this.props,
          listProps = _props.listProps,
          optionRenderer = _props.optionRenderer;

      var focusedOptionIndex = options.indexOf(focusedOption);
      var height = this._calculateListHeight({ options: options });
      var innerRowRenderer = optionRenderer || this._optionRenderer;

      // react-select 1.0.0-rc2 passes duplicate `onSelect` and `selectValue` props to `menuRenderer`
      // The `Creatable` HOC only overrides `onSelect` which breaks an edge-case
      // In order to support creating items via clicking on the placeholder option,
      // We need to ensure that the specified `onSelect` handle is the one we use.
      // See issue #33

      function wrappedRowRenderer(_ref2) {
        var index = _ref2.index,
            key = _ref2.key,
            style = _ref2.style;

        var option = options[index];

        return innerRowRenderer({
          focusedOption: focusedOption,
          focusedOptionIndex: focusedOptionIndex,
          focusOption: focusOption,
          key: key,
          labelKey: labelKey,
          onSelect: onSelect,
          option: option,
          optionIndex: index,
          options: options,
          selectValue: onSelect,
          style: style,
          valueArray: valueArray,
          valueKey: valueKey
        });
      }

      return _react2.default.createElement(
        _AutoSizer2.default,
        { disableHeight: true },
        function (_ref3) {
          var width = _ref3.width;
          return _react2.default.createElement(_List2.default, _extends({
            className: 'VirtualSelectGrid',
            height: height,
            ref: _this2._setListRef,
            rowCount: options.length,
            rowHeight: function rowHeight(_ref4) {
              var index = _ref4.index;
              return _this2._getOptionHeight({
                option: options[index]
              });
            },
            rowRenderer: wrappedRowRenderer,
            scrollToIndex: focusedOptionIndex,
            width: width
          }, listProps));
        }
      );
    }
  }, {
    key: '_calculateListHeight',
    value: function _calculateListHeight(_ref5) {
      var options = _ref5.options;
      var maxHeight = this.props.maxHeight;


      var height = 0;

      for (var optionIndex = 0; optionIndex < options.length; optionIndex++) {
        var option = options[optionIndex];

        height += this._getOptionHeight({ option: option });

        if (height > maxHeight) {
          return maxHeight;
        }
      }

      return height;
    }
  }, {
    key: '_getOptionHeight',
    value: function _getOptionHeight(_ref6) {
      var option = _ref6.option;
      var optionHeight = this.props.optionHeight;


      return optionHeight instanceof Function ? optionHeight({ option: option }) : optionHeight;
    }
  }, {
    key: '_getSelectComponent',
    value: function _getSelectComponent() {
      var _props2 = this.props,
          async = _props2.async,
          selectComponent = _props2.selectComponent;


      if (selectComponent) {
        return selectComponent;
      } else if (async) {
        return _reactSelect2.default.Async;
      } else {
        return _reactSelect2.default;
      }
    }
  }, {
    key: '_optionRenderer',
    value: function _optionRenderer(_ref7) {
      var focusedOption = _ref7.focusedOption,
          focusOption = _ref7.focusOption,
          key = _ref7.key,
          labelKey = _ref7.labelKey,
          option = _ref7.option,
          selectValue = _ref7.selectValue,
          style = _ref7.style,
          valueArray = _ref7.valueArray;

      var className = ['VirtualizedSelectOption'];

      if (option === focusedOption) {
        className.push('VirtualizedSelectFocusedOption');
      }

      if (option.disabled) {
        className.push('VirtualizedSelectDisabledOption');
      }

      if (valueArray && valueArray.indexOf(option) >= 0) {
        className.push('VirtualizedSelectSelectedOption');
      }

      if (option.className) {
        className.push(option.className);
      }

      var events = option.disabled ? {} : {
        onClick: function onClick() {
          return selectValue(option);
        },
        onMouseEnter: function onMouseEnter() {
          return focusOption(option);
        }
      };

      return _react2.default.createElement(
        'div',
        _extends({
          className: className.join(' '),
          key: key,
          style: style,
          title: option.title
        }, events),
        option[labelKey]
      );
    }
  }, {
    key: '_setListRef',
    value: function _setListRef(ref) {
      this._listRef = ref;
    }
  }, {
    key: '_setSelectRef',
    value: function _setSelectRef(ref) {
      this._selectRef = ref;
    }
  }]);

  return VirtualizedSelect;
}(_react.Component);

VirtualizedSelect.propTypes = {
  async: _propTypes2.default.bool,
  listProps: _propTypes2.default.object,
  maxHeight: _propTypes2.default.number,
  optionHeight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
  optionRenderer: _propTypes2.default.func,
  selectComponent: _propTypes2.default.func
};
VirtualizedSelect.defaultProps = {
  async: false,
  maxHeight: 200,
  optionHeight: 35
};
exports.default = VirtualizedSelect;

/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Async", function() { return Async; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AsyncCreatable", function() { return AsyncCreatableSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Creatable", function() { return CreatableSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Value", function() { return Value; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Option", function() { return Option; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultMenuRenderer", function() { return menuRenderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultArrowRenderer", function() { return arrowRenderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultClearRenderer", function() { return clearRenderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultFilterOptions", function() { return filterOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_input_autosize__ = __webpack_require__(1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_input_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_input_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);






var arrowRenderer = function arrowRenderer(_ref) {
	var onMouseDown = _ref.onMouseDown;

	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', {
		className: 'Select-arrow',
		onMouseDown: onMouseDown
	});
};

arrowRenderer.propTypes = {
	onMouseDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};

var clearRenderer = function clearRenderer() {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', {
		className: 'Select-clear',
		dangerouslySetInnerHTML: { __html: '&times;' }
	});
};

var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

var stripDiacritics = function stripDiacritics(str) {
	for (var i = 0; i < map.length; i++) {
		str = str.replace(map[i].letters, map[i].base);
	}
	return str;
};

var trim = function trim(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

var isValid = function isValid(value) {
	return typeof value !== 'undefined' && value !== null && value !== '';
};

var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
	if (props.ignoreAccents) {
		filterValue = stripDiacritics(filterValue);
	}

	if (props.ignoreCase) {
		filterValue = filterValue.toLowerCase();
	}

	if (props.trimFilter) {
		filterValue = trim(filterValue);
	}

	if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
		return i[props.valueKey];
	});

	return options.filter(function (option) {
		if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
		if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
		if (!filterValue) return true;

		var value = option[props.valueKey];
		var label = option[props.labelKey];
		var hasValue = isValid(value);
		var hasLabel = isValid(label);

		if (!hasValue && !hasLabel) {
			return false;
		}

		var valueTest = hasValue ? String(value) : null;
		var labelTest = hasLabel ? String(label) : null;

		if (props.ignoreAccents) {
			if (valueTest && props.matchProp !== 'label') valueTest = stripDiacritics(valueTest);
			if (labelTest && props.matchProp !== 'value') labelTest = stripDiacritics(labelTest);
		}

		if (props.ignoreCase) {
			if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
			if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
		}

		return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
	});
};

var menuRenderer = function menuRenderer(_ref) {
	var focusedOption = _ref.focusedOption,
	    focusOption = _ref.focusOption,
	    inputValue = _ref.inputValue,
	    instancePrefix = _ref.instancePrefix,
	    onFocus = _ref.onFocus,
	    onOptionRef = _ref.onOptionRef,
	    onSelect = _ref.onSelect,
	    optionClassName = _ref.optionClassName,
	    optionComponent = _ref.optionComponent,
	    optionRenderer = _ref.optionRenderer,
	    options = _ref.options,
	    removeValue = _ref.removeValue,
	    selectValue = _ref.selectValue,
	    valueArray = _ref.valueArray,
	    valueKey = _ref.valueKey;

	var Option = optionComponent;

	return options.map(function (option, i) {
		var isSelected = valueArray && valueArray.some(function (x) {
			return x[valueKey] === option[valueKey];
		});
		var isFocused = option === focusedOption;
		var optionClass = __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(optionClassName, {
			'Select-option': true,
			'is-selected': isSelected,
			'is-focused': isFocused,
			'is-disabled': option.disabled
		});

		return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
			Option,
			{
				className: optionClass,
				focusOption: focusOption,
				inputValue: inputValue,
				instancePrefix: instancePrefix,
				isDisabled: option.disabled,
				isFocused: isFocused,
				isSelected: isSelected,
				key: 'option-' + i + '-' + option[valueKey],
				onFocus: onFocus,
				onSelect: onSelect,
				option: option,
				optionIndex: i,
				ref: function ref(_ref2) {
					onOptionRef(_ref2, isFocused);
				},
				removeValue: removeValue,
				selectValue: selectValue
			},
			optionRenderer(option, i, inputValue)
		);
	});
};

menuRenderer.propTypes = {
	focusOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	focusedOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
	inputValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	instancePrefix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	onOptionRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	optionClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	optionComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	optionRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
	removeValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	selectValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	valueArray: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
	valueKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

var blockEvent = (function (event) {
	event.preventDefault();
	event.stopPropagation();
	if (event.target.tagName !== 'A' || !('href' in event.target)) {
		return;
	}
	if (event.target.target) {
		window.open(event.target.href, event.target.target);
	} else {
		window.location.href = event.target.href;
	}
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Option = function (_React$Component) {
	inherits(Option, _React$Component);

	function Option(props) {
		classCallCheck(this, Option);

		var _this = possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
		_this.handleMouseMove = _this.handleMouseMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.onFocus = _this.onFocus.bind(_this);
		return _this;
	}

	createClass(Option, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onSelect(this.props.option, event);
		}
	}, {
		key: 'handleMouseEnter',
		value: function handleMouseEnter(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleMouseMove',
		value: function handleMouseMove(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'onFocus',
		value: function onFocus(event) {
			if (!this.props.isFocused) {
				this.props.onFocus(this.props.option, event);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    option = _props.option,
			    instancePrefix = _props.instancePrefix,
			    optionIndex = _props.optionIndex;

			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(this.props.className, option.className);

			return option.disabled ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className,
					onMouseDown: blockEvent,
					onClick: blockEvent },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className,
					style: option.style,
					role: 'option',
					'aria-label': option.label,
					onMouseDown: this.handleMouseDown,
					onMouseEnter: this.handleMouseEnter,
					onMouseMove: this.handleMouseMove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEnd,
					id: instancePrefix + '-option-' + optionIndex,
					title: option.title },
				this.props.children
			);
		}
	}]);
	return Option;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Option.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
	className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // className (based on mouse position)
	instancePrefix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired, // unique prefix for the ids (used for aria)
	isDisabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is disabled
	isFocused: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is focused
	isSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is selected
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle mouseEnter on option element
	onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle click on option element
	onUnfocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle mouseLeave on option element
	option: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired, // object that is base for that option
	optionIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number // index of the option, used to generate unique ids for aria
};

var Value = function (_React$Component) {
	inherits(Value, _React$Component);

	function Value(props) {
		classCallCheck(this, Value);

		var _this = possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.onRemove = _this.onRemove.bind(_this);
		_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		return _this;
	}

	createClass(Value, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			if (event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			if (this.props.onClick) {
				event.stopPropagation();
				this.props.onClick(this.props.value, event);
				return;
			}
			if (this.props.value.href) {
				event.stopPropagation();
			}
		}
	}, {
		key: 'onRemove',
		value: function onRemove(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onRemove(this.props.value);
		}
	}, {
		key: 'handleTouchEndRemove',
		value: function handleTouchEndRemove(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.onRemove(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'renderRemoveIcon',
		value: function renderRemoveIcon() {
			if (this.props.disabled || !this.props.onRemove) return;
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: 'Select-value-icon',
					'aria-hidden': 'true',
					onMouseDown: this.onRemove,
					onTouchEnd: this.handleTouchEndRemove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove },
				'\xD7'
			);
		}
	}, {
		key: 'renderLabel',
		value: function renderLabel() {
			var className = 'Select-value-label';
			return this.props.onClick || this.props.value.href ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'a',
				{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
				this.props.children
			);
		}
	}, {
		key: 'render',
		value: function render() {
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: __WEBPACK_IMPORTED_MODULE_1_classnames___default.a('Select-value', this.props.value.disabled ? 'Select-value-disabled' : '', this.props.value.className),
					style: this.props.value.style,
					title: this.props.value.title
				},
				this.renderRemoveIcon(),
				this.renderLabel()
			);
		}
	}]);
	return Value;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Value.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
	disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // disabled prop passed to ReactSelect
	id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // Unique id for the value - used for aria
	onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle click on value label
	onRemove: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle removal of the value
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired // the option object for this value
};

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/react-select
*/
var stringifyValue = function stringifyValue(value) {
	return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
};

var stringOrNode = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]);
var stringOrNumber = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]);

var instanceId = 1;

var shouldShowValue = function shouldShowValue(state, props) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	if (!inputValue) return true;

	if (!onSelectResetsInput) {
		return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
	}

	return false;
};

var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
};

/**
 * Retrieve a value from the given options and valueKey
 * @param {String|Number|Array} value	- the selected value(s)
 * @param {Object}		 props	- the Select component's props (or nextProps)
 */
var expandValue = function expandValue(value, props) {
	var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
	var options = props.options,
	    valueKey = props.valueKey;

	if (!options) return;
	for (var i = 0; i < options.length; i++) {
		if (String(options[i][valueKey]) === String(value)) return options[i];
	}
};

var handleRequired = function handleRequired(value, multi) {
	if (!value) return true;
	return multi ? value.length === 0 : Object.keys(value).length === 0;
};

var Select$1 = function (_React$Component) {
	inherits(Select, _React$Component);

	function Select(props) {
		classCallCheck(this, Select);

		var _this = possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

		['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
			return _this[fn] = _this[fn].bind(_this);
		});

		_this.state = {
			inputValue: '',
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false,
			required: false
		};
		return _this;
	}

	createClass(Select, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
			var valueArray = this.getValueArray(this.props.value);

			if (this.props.required) {
				this.setState({
					required: handleRequired(valueArray[0], this.props.multi)
				});
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
				console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
			}
			if (this.props.autoFocus || this.props.autofocus) {
				this.focus();
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var valueArray = this.getValueArray(nextProps.value, nextProps);

			if (nextProps.required) {
				this.setState({
					required: handleRequired(valueArray[0], nextProps.multi)
				});
			} else if (this.props.required) {
				// Used to be required but it's not any more
				this.setState({ required: false });
			}

			if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
				this.setState({ inputValue: this.handleInputValueChange('') });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			// focus to the selected option
			if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
				var focusedOptionNode = __WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"](this.focused);
				var menuNode = __WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"](this.menu);

				var scrollTop = menuNode.scrollTop;
				var scrollBottom = scrollTop + menuNode.offsetHeight;
				var optionTop = focusedOptionNode.offsetTop;
				var optionBottom = optionTop + focusedOptionNode.offsetHeight;

				if (scrollTop > optionTop || scrollBottom < optionBottom) {
					menuNode.scrollTop = focusedOptionNode.offsetTop;
				}

				// We still set hasScrolledToOption to true even if we didn't
				// actually need to scroll, as we've still confirmed that the
				// option is in view.
				this.hasScrolledToOption = true;
			} else if (!this.state.isOpen) {
				this.hasScrolledToOption = false;
			}

			if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
				this._scrollToFocusedOptionOnUpdate = false;
				var focusedDOM = __WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"](this.focused);
				var menuDOM = __WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"](this.menu);
				var focusedRect = focusedDOM.getBoundingClientRect();
				var menuRect = menuDOM.getBoundingClientRect();
				if (focusedRect.bottom > menuRect.bottom) {
					menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
				} else if (focusedRect.top < menuRect.top) {
					menuDOM.scrollTop = focusedDOM.offsetTop;
				}
			}
			if (this.props.scrollMenuIntoView && this.menuContainer) {
				var menuContainerRect = this.menuContainer.getBoundingClientRect();
				if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
					window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
				}
			}
			if (prevProps.disabled !== this.props.disabled) {
				this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
				this.closeMenu();
			}
			if (prevState.isOpen !== this.state.isOpen) {
				this.toggleTouchOutsideEvent(this.state.isOpen);
				var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
				handler && handler();
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.toggleTouchOutsideEvent(false);
		}
	}, {
		key: 'toggleTouchOutsideEvent',
		value: function toggleTouchOutsideEvent(enabled) {
			var eventTogglerName = enabled ? document.addEventListener ? 'addEventListener' : 'attachEvent' : document.removeEventListener ? 'removeEventListener' : 'detachEvent';
			var pref = document.addEventListener ? '' : 'on';

			document[eventTogglerName](pref + 'touchstart', this.handleTouchOutside);
			document[eventTogglerName](pref + 'mousedown', this.handleTouchOutside);
		}
	}, {
		key: 'handleTouchOutside',
		value: function handleTouchOutside(event) {
			// handle touch outside on ios to dismiss menu
			if (this.wrapper && !this.wrapper.contains(event.target)) {
				this.closeMenu();
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			if (!this.input) return;
			this.input.focus();
		}
	}, {
		key: 'blurInput',
		value: function blurInput() {
			if (!this.input) return;
			this.input.blur();
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchEndClearValue',
		value: function handleTouchEndClearValue(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Clear the value
			this.clearValue(event);
		}
	}, {
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (event.target.tagName === 'INPUT') {
				if (!this.state.isFocused) {
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
				} else if (!this.state.isOpen) {
					this.setState({
						isOpen: true,
						isPseudoFocused: false,
						focusedOption: null
					});
				}

				return;
			}

			// prevent default event handlers
			event.preventDefault();

			// for the non-searchable select, toggle the menu
			if (!this.props.searchable) {
				// This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
				this.focus();
				return this.setState({
					isOpen: !this.state.isOpen,
					focusedOption: null
				});
			}

			if (this.state.isFocused) {
				// On iOS, we can get into a state where we think the input is focused but it isn't really,
				// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
				// Call focus() again here to be safe.
				this.focus();

				var input = this.input;
				var toOpen = true;

				if (typeof input.getInput === 'function') {
					// Get the actual DOM input if the ref is an <AutosizeInput /> component
					input = input.getInput();
				}

				// clears the value so that the cursor will be at the end of input when the component re-renders
				input.value = '';

				if (this._focusAfterClear) {
					toOpen = false;
					this._focusAfterClear = false;
				}

				// if the input is focused, ensure the menu is open
				this.setState({
					isOpen: toOpen,
					isPseudoFocused: false,
					focusedOption: null
				});
			} else {
				// otherwise, focus the input and open the menu
				this._openAfterFocus = this.props.openOnClick;
				this.focus();
				this.setState({ focusedOption: null });
			}
		}
	}, {
		key: 'handleMouseDownOnArrow',
		value: function handleMouseDownOnArrow(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (this.state.isOpen) {
				// prevent default event handlers
				event.stopPropagation();
				event.preventDefault();
				// close the menu
				this.closeMenu();
			} else {
				// If the menu isn't open, let the event bubble to the main handleMouseDown
				this.setState({
					isOpen: true
				});
			}
		}
	}, {
		key: 'handleMouseDownOnMenu',
		value: function handleMouseDownOnMenu(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.stopPropagation();
			event.preventDefault();

			this._openAfterFocus = true;
			this.focus();
		}
	}, {
		key: 'closeMenu',
		value: function closeMenu() {
			if (this.props.onCloseResetsInput) {
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			} else {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			}
			this.hasScrolledToOption = false;
		}
	}, {
		key: 'handleInputFocus',
		value: function handleInputFocus(event) {
			if (this.props.disabled) return;

			var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
			toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.

			if (this.props.onFocus) {
				this.props.onFocus(event);
			}

			this.setState({
				isFocused: true,
				isOpen: !!toOpen
			});

			this._focusAfterClear = false;
			this._openAfterFocus = false;
		}
	}, {
		key: 'handleInputBlur',
		value: function handleInputBlur(event) {
			// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
			if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
				this.focus();
				return;
			}

			if (this.props.onBlur) {
				this.props.onBlur(event);
			}
			var onBlurredState = {
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false
			};
			if (this.props.onBlurResetsInput) {
				onBlurredState.inputValue = this.handleInputValueChange('');
			}
			this.setState(onBlurredState);
		}
	}, {
		key: 'handleInputChange',
		value: function handleInputChange(event) {
			var newInputValue = event.target.value;

			if (this.state.inputValue !== event.target.value) {
				newInputValue = this.handleInputValueChange(newInputValue);
			}

			this.setState({
				inputValue: newInputValue,
				isOpen: true,
				isPseudoFocused: false
			});
		}
	}, {
		key: 'setInputValue',
		value: function setInputValue(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			this.setState({
				inputValue: newValue
			});
		}
	}, {
		key: 'handleInputValueChange',
		value: function handleInputValueChange(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				// Note: != used deliberately here to catch undefined and null
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			return newValue;
		}
	}, {
		key: 'handleKeyDown',
		value: function handleKeyDown(event) {
			if (this.props.disabled) return;

			if (typeof this.props.onInputKeyDown === 'function') {
				this.props.onInputKeyDown(event);
				if (event.defaultPrevented) {
					return;
				}
			}

			switch (event.keyCode) {
				case 8:
					// backspace
					if (!this.state.inputValue && this.props.backspaceRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
				case 9:
					// tab
					if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
						break;
					}
					event.preventDefault();
					this.selectFocusedOption();
					break;
				case 13:
					// enter
					event.preventDefault();
					event.stopPropagation();
					if (this.state.isOpen) {
						this.selectFocusedOption();
					} else {
						this.focusNextOption();
					}
					break;
				case 27:
					// escape
					event.preventDefault();
					if (this.state.isOpen) {
						this.closeMenu();
						event.stopPropagation();
					} else if (this.props.clearable && this.props.escapeClearsValue) {
						this.clearValue(event);
						event.stopPropagation();
					}
					break;
				case 32:
					// space
					if (this.props.searchable) {
						break;
					}
					event.preventDefault();
					if (!this.state.isOpen) {
						this.focusNextOption();
						break;
					}
					event.stopPropagation();
					this.selectFocusedOption();
					break;
				case 38:
					// up
					event.preventDefault();
					this.focusPreviousOption();
					break;
				case 40:
					// down
					event.preventDefault();
					this.focusNextOption();
					break;
				case 33:
					// page up
					event.preventDefault();
					this.focusPageUpOption();
					break;
				case 34:
					// page down
					event.preventDefault();
					this.focusPageDownOption();
					break;
				case 35:
					// end key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusEndOption();
					break;
				case 36:
					// home key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusStartOption();
					break;
				case 46:
					// delete
					if (!this.state.inputValue && this.props.deleteRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
			}
		}
	}, {
		key: 'handleValueClick',
		value: function handleValueClick(option, event) {
			if (!this.props.onValueClick) return;
			this.props.onValueClick(option, event);
		}
	}, {
		key: 'handleMenuScroll',
		value: function handleMenuScroll(event) {
			if (!this.props.onMenuScrollToBottom) return;
			var target = event.target;

			if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
				this.props.onMenuScrollToBottom();
			}
		}
	}, {
		key: 'getOptionLabel',
		value: function getOptionLabel(op) {
			return op[this.props.labelKey];
		}

		/**
   * Turns a value into an array from the given options
   * @param {String|Number|Array} value		- the value of the select input
   * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
   * @returns	{Array}	the value of the select represented in an array
   */

	}, {
		key: 'getValueArray',
		value: function getValueArray(value) {
			var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

			/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
			var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
			if (props.multi) {
				if (typeof value === 'string') {
					value = value.split(props.delimiter);
				}
				if (!Array.isArray(value)) {
					if (value === null || value === undefined) return [];
					value = [value];
				}
				return value.map(function (value) {
					return expandValue(value, props);
				}).filter(function (i) {
					return i;
				});
			}
			var expandedValue = expandValue(value, props);
			return expandedValue ? [expandedValue] : [];
		}
	}, {
		key: 'setValue',
		value: function setValue(value) {
			var _this2 = this;

			if (this.props.autoBlur) {
				this.blurInput();
			}
			if (this.props.required) {
				var required = handleRequired(value, this.props.multi);
				this.setState({ required: required });
			}
			if (this.props.simpleValue && value) {
				value = this.props.multi ? value.map(function (i) {
					return i[_this2.props.valueKey];
				}).join(this.props.delimiter) : value[this.props.valueKey];
			}
			if (this.props.onChange) {
				this.props.onChange(value);
			}
		}
	}, {
		key: 'selectValue',
		value: function selectValue(value) {
			var _this3 = this;

			// NOTE: we actually add/set the value in a callback to make sure the
			// input value is empty to avoid styling issues in Chrome
			if (this.props.closeOnSelect) {
				this.hasScrolledToOption = false;
			}
			var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
			if (this.props.multi) {
				this.setState({
					focusedIndex: null,
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect
				}, function () {
					var valueArray = _this3.getValueArray(_this3.props.value);
					if (valueArray.some(function (i) {
						return i[_this3.props.valueKey] === value[_this3.props.valueKey];
					})) {
						_this3.removeValue(value);
					} else {
						_this3.addValue(value);
					}
				});
			} else {
				this.setState({
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect,
					isPseudoFocused: this.state.isFocused
				}, function () {
					_this3.setValue(value);
				});
			}
		}
	}, {
		key: 'addValue',
		value: function addValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			var visibleOptions = this._visibleOptions.filter(function (val) {
				return !val.disabled;
			});
			var lastValueIndex = visibleOptions.indexOf(value);
			this.setValue(valueArray.concat(value));
			if (!this.props.closeOnSelect) {
				return;
			}
			if (visibleOptions.length - 1 === lastValueIndex) {
				// the last option was selected; focus the second-last one
				this.focusOption(visibleOptions[lastValueIndex - 1]);
			} else if (visibleOptions.length > lastValueIndex) {
				// focus the option below the selected one
				this.focusOption(visibleOptions[lastValueIndex + 1]);
			}
		}
	}, {
		key: 'popValue',
		value: function popValue() {
			var valueArray = this.getValueArray(this.props.value);
			if (!valueArray.length) return;
			if (valueArray[valueArray.length - 1].clearableValue === false) return;
			this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
		}
	}, {
		key: 'removeValue',
		value: function removeValue(value) {
			var _this4 = this;

			var valueArray = this.getValueArray(this.props.value);
			this.setValue(valueArray.filter(function (i) {
				return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
			}));
			this.focus();
		}
	}, {
		key: 'clearValue',
		value: function clearValue(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, ignore it.
			if (event && event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.preventDefault();

			this.setValue(this.getResetValue());
			this.setState({
				inputValue: this.handleInputValueChange(''),
				isOpen: false
			}, this.focus);

			this._focusAfterClear = true;
		}
	}, {
		key: 'getResetValue',
		value: function getResetValue() {
			if (this.props.resetValue !== undefined) {
				return this.props.resetValue;
			} else if (this.props.multi) {
				return [];
			} else {
				return null;
			}
		}
	}, {
		key: 'focusOption',
		value: function focusOption(option) {
			this.setState({
				focusedOption: option
			});
		}
	}, {
		key: 'focusNextOption',
		value: function focusNextOption() {
			this.focusAdjacentOption('next');
		}
	}, {
		key: 'focusPreviousOption',
		value: function focusPreviousOption() {
			this.focusAdjacentOption('previous');
		}
	}, {
		key: 'focusPageUpOption',
		value: function focusPageUpOption() {
			this.focusAdjacentOption('page_up');
		}
	}, {
		key: 'focusPageDownOption',
		value: function focusPageDownOption() {
			this.focusAdjacentOption('page_down');
		}
	}, {
		key: 'focusStartOption',
		value: function focusStartOption() {
			this.focusAdjacentOption('start');
		}
	}, {
		key: 'focusEndOption',
		value: function focusEndOption() {
			this.focusAdjacentOption('end');
		}
	}, {
		key: 'focusAdjacentOption',
		value: function focusAdjacentOption(dir) {
			var options = this._visibleOptions.map(function (option, index) {
				return { option: option, index: index };
			}).filter(function (option) {
				return !option.option.disabled;
			});
			this._scrollToFocusedOptionOnUpdate = true;
			if (!this.state.isOpen) {
				var newState = {
					focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
					isOpen: true
				};
				if (this.props.onSelectResetsInput) {
					newState.inputValue = '';
				}
				this.setState(newState);
				return;
			}
			if (!options.length) return;
			var focusedIndex = -1;
			for (var i = 0; i < options.length; i++) {
				if (this._focusedOption === options[i].option) {
					focusedIndex = i;
					break;
				}
			}
			if (dir === 'next' && focusedIndex !== -1) {
				focusedIndex = (focusedIndex + 1) % options.length;
			} else if (dir === 'previous') {
				if (focusedIndex > 0) {
					focusedIndex = focusedIndex - 1;
				} else {
					focusedIndex = options.length - 1;
				}
			} else if (dir === 'start') {
				focusedIndex = 0;
			} else if (dir === 'end') {
				focusedIndex = options.length - 1;
			} else if (dir === 'page_up') {
				var potentialIndex = focusedIndex - this.props.pageSize;
				if (potentialIndex < 0) {
					focusedIndex = 0;
				} else {
					focusedIndex = potentialIndex;
				}
			} else if (dir === 'page_down') {
				var _potentialIndex = focusedIndex + this.props.pageSize;
				if (_potentialIndex > options.length - 1) {
					focusedIndex = options.length - 1;
				} else {
					focusedIndex = _potentialIndex;
				}
			}

			if (focusedIndex === -1) {
				focusedIndex = 0;
			}

			this.setState({
				focusedIndex: options[focusedIndex].index,
				focusedOption: options[focusedIndex].option
			});
		}
	}, {
		key: 'getFocusedOption',
		value: function getFocusedOption() {
			return this._focusedOption;
		}
	}, {
		key: 'selectFocusedOption',
		value: function selectFocusedOption() {
			if (this._focusedOption) {
				return this.selectValue(this._focusedOption);
			}
		}
	}, {
		key: 'renderLoading',
		value: function renderLoading() {
			if (!this.props.isLoading) return;
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', { className: 'Select-loading' })
			);
		}
	}, {
		key: 'renderValue',
		value: function renderValue(valueArray, isOpen) {
			var _this5 = this;

			var renderLabel = this.props.valueRenderer || this.getOptionLabel;
			var ValueComponent = this.props.valueComponent;
			if (!valueArray.length) {
				var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
				return showPlaceholder ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ className: 'Select-placeholder' },
					this.props.placeholder
				) : null;
			}
			var onClick = this.props.onValueClick ? this.handleValueClick : null;
			if (this.props.multi) {
				return valueArray.map(function (value, i) {
					return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						ValueComponent,
						{
							disabled: _this5.props.disabled || value.clearableValue === false,
							id: _this5._instancePrefix + '-value-' + i,
							instancePrefix: _this5._instancePrefix,
							key: 'value-' + i + '-' + value[_this5.props.valueKey],
							onClick: onClick,
							onRemove: _this5.removeValue,
							placeholder: _this5.props.placeholder,
							value: value,
							values: valueArray
						},
						renderLabel(value, i),
						__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
							'span',
							{ className: 'Select-aria-only' },
							'\xA0'
						)
					);
				});
			} else if (shouldShowValue(this.state, this.props)) {
				if (isOpen) onClick = null;
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					ValueComponent,
					{
						disabled: this.props.disabled,
						id: this._instancePrefix + '-value-item',
						instancePrefix: this._instancePrefix,
						onClick: onClick,
						placeholder: this.props.placeholder,
						value: valueArray[0]
					},
					renderLabel(valueArray[0])
				);
			}
		}
	}, {
		key: 'renderInput',
		value: function renderInput(valueArray, focusedOptionIndex) {
			var _classNames,
			    _this6 = this;

			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default.a('Select-input', this.props.inputProps.className);
			var isOpen = this.state.isOpen;

			var ariaOwns = __WEBPACK_IMPORTED_MODULE_1_classnames___default.a((_classNames = {}, defineProperty(_classNames, this._instancePrefix + '-list', isOpen), defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));

			var value = this.state.inputValue;
			if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
				// it hides input value when it is not focused and was not reset on select
				value = '';
			}

			var inputProps = _extends({}, this.props.inputProps, {
				'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
				'aria-describedby': this.props['aria-describedby'],
				'aria-expanded': '' + isOpen,
				'aria-haspopup': '' + isOpen,
				'aria-label': this.props['aria-label'],
				'aria-labelledby': this.props['aria-labelledby'],
				'aria-owns': ariaOwns,
				onBlur: this.handleInputBlur,
				onChange: this.handleInputChange,
				onFocus: this.handleInputFocus,
				ref: function ref(_ref) {
					return _this6.input = _ref;
				},
				role: 'combobox',
				required: this.state.required,
				tabIndex: this.props.tabIndex,
				value: value
			});

			if (this.props.inputRenderer) {
				return this.props.inputRenderer(inputProps);
			}

			if (this.props.disabled || !this.props.searchable) {
				var divProps = objectWithoutProperties(this.props.inputProps, []);


				var _ariaOwns = __WEBPACK_IMPORTED_MODULE_1_classnames___default.a(defineProperty({}, this._instancePrefix + '-list', isOpen));
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', _extends({}, divProps, {
					'aria-expanded': isOpen,
					'aria-owns': _ariaOwns,
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-disabled': '' + this.props.disabled,
					'aria-label': this.props['aria-label'],
					'aria-labelledby': this.props['aria-labelledby'],
					className: className,
					onBlur: this.handleInputBlur,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref2) {
						return _this6.input = _ref2;
					},
					role: 'combobox',
					style: { border: 0, width: 1, display: 'inline-block' },
					tabIndex: this.props.tabIndex || 0
				}));
			}

			if (this.props.autosize) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_input_autosize___default.a, _extends({ id: this.props.id }, inputProps, { className: className, minWidth: '5' }));
			}
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className, key: 'input-wrap', style: { display: 'inline-block' } },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', _extends({ id: this.props.id }, inputProps))
			);
		}
	}, {
		key: 'renderClear',
		value: function renderClear() {
			var valueArray = this.getValueArray(this.props.value);
			if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
			var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
			var clear = this.props.clearRenderer();

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{
					'aria-label': ariaLabel,
					className: 'Select-clear-zone',
					onMouseDown: this.clearValue,
					onTouchEnd: this.handleTouchEndClearValue,
					onTouchMove: this.handleTouchMove,
					onTouchStart: this.handleTouchStart,
					title: ariaLabel
				},
				clear
			);
		}
	}, {
		key: 'renderArrow',
		value: function renderArrow() {
			if (!this.props.arrowRenderer) return;

			var onMouseDown = this.handleMouseDownOnArrow;
			var isOpen = this.state.isOpen;
			var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });

			if (!arrow) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{
					className: 'Select-arrow-zone',
					onMouseDown: onMouseDown
				},
				arrow
			);
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1(excludeOptions) {
			var filterValue = this.state.inputValue;
			var options = this.props.options || [];
			if (this.props.filterOptions) {
				// Maintain backwards compatibility with boolean attribute
				var filterOptions$$1 = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : filterOptions;

				return filterOptions$$1(options, filterValue, excludeOptions, {
					filterOption: this.props.filterOption,
					ignoreAccents: this.props.ignoreAccents,
					ignoreCase: this.props.ignoreCase,
					labelKey: this.props.labelKey,
					matchPos: this.props.matchPos,
					matchProp: this.props.matchProp,
					trimFilter: this.props.trimFilter,
					valueKey: this.props.valueKey
				});
			} else {
				return options;
			}
		}
	}, {
		key: 'onOptionRef',
		value: function onOptionRef(ref, isFocused) {
			if (isFocused) {
				this.focused = ref;
			}
		}
	}, {
		key: 'renderMenu',
		value: function renderMenu(options, valueArray, focusedOption) {
			if (options && options.length) {
				return this.props.menuRenderer({
					focusedOption: focusedOption,
					focusOption: this.focusOption,
					inputValue: this.state.inputValue,
					instancePrefix: this._instancePrefix,
					labelKey: this.props.labelKey,
					onFocus: this.focusOption,
					onOptionRef: this.onOptionRef,
					onSelect: this.selectValue,
					optionClassName: this.props.optionClassName,
					optionComponent: this.props.optionComponent,
					optionRenderer: this.props.optionRenderer || this.getOptionLabel,
					options: options,
					removeValue: this.removeValue,
					selectValue: this.selectValue,
					valueArray: valueArray,
					valueKey: this.props.valueKey
				});
			} else if (this.props.noResultsText) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ className: 'Select-noresults' },
					this.props.noResultsText
				);
			} else {
				return null;
			}
		}
	}, {
		key: 'renderHiddenField',
		value: function renderHiddenField(valueArray) {
			var _this7 = this;

			if (!this.props.name) return;
			if (this.props.joinValues) {
				var value = valueArray.map(function (i) {
					return stringifyValue(i[_this7.props.valueKey]);
				}).join(this.props.delimiter);
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
					disabled: this.props.disabled,
					name: this.props.name,
					ref: function ref(_ref3) {
						return _this7.value = _ref3;
					},
					type: 'hidden',
					value: value
				});
			}
			return valueArray.map(function (item, index) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
					disabled: _this7.props.disabled,
					key: 'hidden.' + index,
					name: _this7.props.name,
					ref: 'value' + index,
					type: 'hidden',
					value: stringifyValue(item[_this7.props.valueKey])
				});
			});
		}
	}, {
		key: 'getFocusableOptionIndex',
		value: function getFocusableOptionIndex(selectedOption) {
			var options = this._visibleOptions;
			if (!options.length) return null;

			var valueKey = this.props.valueKey;
			var focusedOption = this.state.focusedOption || selectedOption;
			if (focusedOption && !focusedOption.disabled) {
				var focusedOptionIndex = -1;
				options.some(function (option, index) {
					var isOptionEqual = option[valueKey] === focusedOption[valueKey];
					if (isOptionEqual) {
						focusedOptionIndex = index;
					}
					return isOptionEqual;
				});
				if (focusedOptionIndex !== -1) {
					return focusedOptionIndex;
				}
			}

			for (var i = 0; i < options.length; i++) {
				if (!options[i].disabled) return i;
			}
			return null;
		}
	}, {
		key: 'renderOuter',
		value: function renderOuter(options, valueArray, focusedOption) {
			var _this8 = this;

			var menu = this.renderMenu(options, valueArray, focusedOption);
			if (!menu) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref5) {
						return _this8.menuContainer = _ref5;
					}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{
						className: 'Select-menu',
						id: this._instancePrefix + '-list',
						onMouseDown: this.handleMouseDownOnMenu,
						onScroll: this.handleMenuScroll,
						ref: function ref(_ref4) {
							return _this8.menu = _ref4;
						},
						role: 'listbox',
						style: this.props.menuStyle,
						tabIndex: -1
					},
					menu
				)
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this9 = this;

			var valueArray = this.getValueArray(this.props.value);
			var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
			var isOpen = this.state.isOpen;
			if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
			var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);

			var focusedOption = null;
			if (focusedOptionIndex !== null) {
				focusedOption = this._focusedOption = options[focusedOptionIndex];
			} else {
				focusedOption = this._focusedOption = null;
			}
			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default.a('Select', this.props.className, {
				'has-value': valueArray.length,
				'is-clearable': this.props.clearable,
				'is-disabled': this.props.disabled,
				'is-focused': this.state.isFocused,
				'is-loading': this.props.isLoading,
				'is-open': isOpen,
				'is-pseudo-focused': this.state.isPseudoFocused,
				'is-searchable': this.props.searchable,
				'Select--multi': this.props.multi,
				'Select--rtl': this.props.rtl,
				'Select--single': !this.props.multi
			});

			var removeMessage = null;
			if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
				removeMessage = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'span',
					{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
					this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
				);
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref7) {
						return _this9.wrapper = _ref7;
					},
					className: className,
					style: this.props.wrapperStyle },
				this.renderHiddenField(valueArray),
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ ref: function ref(_ref6) {
							return _this9.control = _ref6;
						},
						className: 'Select-control',
						onKeyDown: this.handleKeyDown,
						onMouseDown: this.handleMouseDown,
						onTouchEnd: this.handleTouchEnd,
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						style: this.props.style
					},
					__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						'div',
						{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
						this.renderValue(valueArray, isOpen),
						this.renderInput(valueArray, focusedOptionIndex)
					),
					removeMessage,
					this.renderLoading(),
					this.renderClear(),
					this.renderArrow()
				),
				isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
			);
		}
	}]);
	return Select;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Select$1.propTypes = {
	'aria-describedby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
	'aria-label': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // aria label (for assistive tech)
	'aria-labelledby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id of an element that should be used as the label (for assistive tech)
	arrowRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // create the drop-down caret element
	autoBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // automatically blur the component when an option is selected
	autoFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // autofocus the component on mount
	autofocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // deprecated; use autoFocus instead
	autosize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to enable autosizing or not
	backspaceRemoves: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether backspace removes an item if there is no text input
	backspaceToRemoveMessage: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
	className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // className for the outer element
	clearAllText: stringOrNode, // title for the "clear" control when multi: true
	clearRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // create clearable x element
	clearValueText: stringOrNode, // title for the "clear" control
	clearable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // should it be possible to reset value
	closeOnSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to close the menu when a value is selected
	deleteRemoves: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether delete removes an item if there is no text input
	delimiter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // delimiter to use to join multiple values for the hidden field value
	disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the Select is disabled or not
	escapeClearsValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether escape clears the value when the menu is closed
	filterOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to filter a single option (option, filterString)
	filterOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
	id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id to set on the input element for accessibility or tests
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to strip diacritics when filtering
	ignoreCase: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to perform case-insensitive filtering
	inputProps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // custom attributes for the Input
	inputRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // returns a custom input component
	instanceId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // set the components instanceId
	isLoading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the Select is loading externally or not (such as options being loaded)
	joinValues: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
	labelKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // path of the label value in option objects
	matchPos: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // (any|start) match the start or entire string when filtering
	matchProp: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // (any|label|value) which option property to filter on
	menuBuffer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
	menuContainerStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the menu container
	menuRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // renders a custom menu with options
	menuStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the menu
	multi: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // multi-value input
	name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // generates a hidden <input /> tag with this field name for html forms
	noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
	onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onBlur handler: function (event) {}
	onBlurResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared on blur
	onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onClose: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is closed
	onCloseResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared when menu is closed through the arrow
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onFocus handler: function (event) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onInputChange handler: function (inputValue) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // input keyDown handler: function (event) {}
	onMenuScrollToBottom: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
	onOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is opened
	onSelectResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared on select (works only for multiselect)
	onValueClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onClick handler for value labels: function (value, event) {}
	openOnClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // boolean to control opening the menu when the control is clicked
	openOnFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // always open options menu on focus
	optionClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // additional class(es) to apply to the <Option /> elements
	optionComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // option component to render in dropdown
	optionRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // optionRenderer: function (option) {}
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, // array of options
	pageSize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, // number of entries to page when using page up/down keys
	placeholder: stringOrNode, // field placeholder, displayed when there's no value
	removeSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the selected option is removed from the dropdown on multi selects
	required: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // applies HTML5 required attribute when needed
	resetValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // value to use when you clear the control
	rtl: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // set to true in order to use react-select in right-to-left direction
	scrollMenuIntoView: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
	searchable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to enable searching feature or not
	simpleValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
	style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the control
	tabIndex: stringOrNumber, // optional tab index of the control
	tabSelectsValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to treat tabbing out while focused to be value selection
	trimFilter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to trim whitespace around filter value
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // initial field value
	valueComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // value component to render
	valueKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // path of the label value in option objects
	valueRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // valueRenderer: function (option) {}
	wrapperStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object // optional style to apply to the component wrapper
};

Select$1.defaultProps = {
	arrowRenderer: arrowRenderer,
	autosize: true,
	backspaceRemoves: true,
	backspaceToRemoveMessage: 'Press backspace to remove {label}',
	clearable: true,
	clearAllText: 'Clear all',
	clearRenderer: clearRenderer,
	clearValueText: 'Clear value',
	closeOnSelect: true,
	deleteRemoves: true,
	delimiter: ',',
	disabled: false,
	escapeClearsValue: true,
	filterOptions: filterOptions,
	ignoreAccents: true,
	ignoreCase: true,
	inputProps: {},
	isLoading: false,
	joinValues: false,
	labelKey: 'label',
	matchPos: 'any',
	matchProp: 'any',
	menuBuffer: 0,
	menuRenderer: menuRenderer,
	multi: false,
	noResultsText: 'No results found',
	onBlurResetsInput: true,
	onCloseResetsInput: true,
	onSelectResetsInput: true,
	openOnClick: true,
	optionComponent: Option,
	pageSize: 5,
	placeholder: 'Select...',
	removeSelected: true,
	required: false,
	rtl: false,
	scrollMenuIntoView: true,
	searchable: true,
	simpleValue: false,
	tabSelectsValue: true,
	trimFilter: true,
	valueComponent: Value,
	valueKey: 'value'
};

var propTypes = {
	autoload: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
	cache: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // object to use to cache results; set to null/false to disable caching
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // strip diacritics when filtering; defaults to true
	ignoreCase: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // perform case-insensitive filtering; defaults to true
	loadOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
	loadingPlaceholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// replaces the placeholder while options are loading
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	multi: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // multi-value input
	noResultsText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// field noResultsText, displayed when no options come back from the server
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // optional for keeping track of what is being typed
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired, // array of options
	placeholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	searchPromptText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// label to prompt for search input
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any // initial field value
};

var defaultCache = {};

var defaultChildren = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

var defaultProps = {
	autoload: true,
	cache: defaultCache,
	children: defaultChildren,
	ignoreAccents: true,
	ignoreCase: true,
	loadingPlaceholder: 'Loading...',
	options: [],
	searchPromptText: 'Type to search'
};

var Async = function (_Component) {
	inherits(Async, _Component);

	function Async(props, context) {
		classCallCheck(this, Async);

		var _this = possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));

		_this._cache = props.cache === defaultCache ? {} : props.cache;

		_this.state = {
			inputValue: '',
			isLoading: false,
			options: props.options
		};

		_this.onInputChange = _this.onInputChange.bind(_this);
		return _this;
	}

	createClass(Async, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var autoload = this.props.autoload;


			if (autoload) {
				this.loadOptions('');
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.options !== this.props.options) {
				this.setState({
					options: nextProps.options
				});
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this._callback = null;
		}
	}, {
		key: 'loadOptions',
		value: function loadOptions(inputValue) {
			var _this2 = this;

			var loadOptions = this.props.loadOptions;

			var cache = this._cache;

			if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
				this._callback = null;

				this.setState({
					isLoading: false,
					options: cache[inputValue]
				});

				return;
			}

			var callback = function callback(error, data) {
				var options = data && data.options || [];

				if (cache) {
					cache[inputValue] = options;
				}

				if (callback === _this2._callback) {
					_this2._callback = null;

					_this2.setState({
						isLoading: false,
						options: options
					});
				}
			};

			// Ignore all but the most recent request
			this._callback = callback;

			var promise = loadOptions(inputValue, callback);
			if (promise) {
				promise.then(function (data) {
					return callback(null, data);
				}, function (error) {
					return callback(error);
				});
			}

			if (this._callback && !this.state.isLoading) {
				this.setState({
					isLoading: true
				});
			}
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(inputValue) {
			var _props = this.props,
			    ignoreAccents = _props.ignoreAccents,
			    ignoreCase = _props.ignoreCase,
			    onInputChange = _props.onInputChange;

			var newInputValue = inputValue;

			if (onInputChange) {
				var value = onInputChange(newInputValue);
				// Note: != used deliberately here to catch undefined and null
				if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
					newInputValue = '' + value;
				}
			}

			var transformedInputValue = newInputValue;

			if (ignoreAccents) {
				transformedInputValue = stripDiacritics(transformedInputValue);
			}

			if (ignoreCase) {
				transformedInputValue = transformedInputValue.toLowerCase();
			}

			this.setState({ inputValue: newInputValue });
			this.loadOptions(transformedInputValue);

			// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
			return newInputValue;
		}
	}, {
		key: 'noResultsText',
		value: function noResultsText() {
			var _props2 = this.props,
			    loadingPlaceholder = _props2.loadingPlaceholder,
			    noResultsText = _props2.noResultsText,
			    searchPromptText = _props2.searchPromptText;
			var _state = this.state,
			    inputValue = _state.inputValue,
			    isLoading = _state.isLoading;


			if (isLoading) {
				return loadingPlaceholder;
			}
			if (inputValue && noResultsText) {
				return noResultsText;
			}
			return searchPromptText;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props3 = this.props,
			    children = _props3.children,
			    loadingPlaceholder = _props3.loadingPlaceholder,
			    placeholder = _props3.placeholder;
			var _state2 = this.state,
			    isLoading = _state2.isLoading,
			    options = _state2.options;


			var props = {
				noResultsText: this.noResultsText(),
				placeholder: isLoading ? loadingPlaceholder : placeholder,
				options: isLoading && loadingPlaceholder ? [] : options,
				ref: function ref(_ref) {
					return _this3.select = _ref;
				}
			};

			return children(_extends({}, this.props, props, {
				isLoading: isLoading,
				onInputChange: this.onInputChange
			}));
		}
	}]);
	return Async;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

Async.propTypes = propTypes;
Async.defaultProps = defaultProps;

var CreatableSelect = function (_React$Component) {
	inherits(CreatableSelect, _React$Component);

	function CreatableSelect(props, context) {
		classCallCheck(this, CreatableSelect);

		var _this = possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));

		_this.filterOptions = _this.filterOptions.bind(_this);
		_this.menuRenderer = _this.menuRenderer.bind(_this);
		_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
		_this.onInputChange = _this.onInputChange.bind(_this);
		_this.onOptionSelect = _this.onOptionSelect.bind(_this);
		return _this;
	}

	createClass(CreatableSelect, [{
		key: 'createNewOption',
		value: function createNewOption() {
			var _props = this.props,
			    isValidNewOption = _props.isValidNewOption,
			    newOptionCreator = _props.newOptionCreator,
			    onNewOptionClick = _props.onNewOptionClick,
			    _props$options = _props.options,
			    options = _props$options === undefined ? [] : _props$options;


			if (isValidNewOption({ label: this.inputValue })) {
				var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
				var _isOptionUnique = this.isOptionUnique({ option: option, options: options });

				// Don't add the same option twice.
				if (_isOptionUnique) {
					if (onNewOptionClick) {
						onNewOptionClick(option);
					} else {
						options.unshift(option);

						this.select.selectValue(option);
					}
				}
			}
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1() {
			var _props2 = this.props,
			    filterOptions$$1 = _props2.filterOptions,
			    isValidNewOption = _props2.isValidNewOption,
			    promptTextCreator = _props2.promptTextCreator,
			    showNewOptionAtTop = _props2.showNewOptionAtTop;

			// TRICKY Check currently selected options as well.
			// Don't display a create-prompt for a value that's selected.
			// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.

			var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];

			var filteredOptions = filterOptions$$1.apply(undefined, arguments) || [];

			if (isValidNewOption({ label: this.inputValue })) {
				var _newOptionCreator = this.props.newOptionCreator;


				var option = _newOptionCreator({
					label: this.inputValue,
					labelKey: this.labelKey,
					valueKey: this.valueKey
				});

				// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
				// For multi-selects, this would remove it from the filtered list.
				var _isOptionUnique2 = this.isOptionUnique({
					option: option,
					options: excludeOptions.concat(filteredOptions)
				});

				if (_isOptionUnique2) {
					var prompt = promptTextCreator(this.inputValue);

					this._createPlaceholderOption = _newOptionCreator({
						label: prompt,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});

					if (showNewOptionAtTop) {
						filteredOptions.unshift(this._createPlaceholderOption);
					} else {
						filteredOptions.push(this._createPlaceholderOption);
					}
				}
			}

			return filteredOptions;
		}
	}, {
		key: 'isOptionUnique',
		value: function isOptionUnique(_ref) {
			var option = _ref.option,
			    options = _ref.options;
			var isOptionUnique = this.props.isOptionUnique;


			options = options || this.props.options;

			return isOptionUnique({
				labelKey: this.labelKey,
				option: option,
				options: options,
				valueKey: this.valueKey
			});
		}
	}, {
		key: 'menuRenderer',
		value: function menuRenderer$$1(params) {
			var menuRenderer$$1 = this.props.menuRenderer;


			return menuRenderer$$1(_extends({}, params, {
				onSelect: this.onOptionSelect,
				selectValue: this.onOptionSelect
			}));
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(input) {
			var onInputChange = this.props.onInputChange;

			// This value may be needed in between Select mounts (when this.select is null)

			this.inputValue = input;

			if (onInputChange) {
				this.inputValue = onInputChange(input);
			}

			return this.inputValue;
		}
	}, {
		key: 'onInputKeyDown',
		value: function onInputKeyDown(event) {
			var _props3 = this.props,
			    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
			    onInputKeyDown = _props3.onInputKeyDown;

			var focusedOption = this.select.getFocusedOption();

			if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption(event)) {
				this.createNewOption();

				// Prevent decorated Select from doing anything additional with this keyDown event
				event.preventDefault();
			} else if (onInputKeyDown) {
				onInputKeyDown(event);
			}
		}
	}, {
		key: 'onOptionSelect',
		value: function onOptionSelect(option) {
			if (option === this._createPlaceholderOption) {
				this.createNewOption();
			} else {
				this.select.selectValue(option);
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props4 = this.props,
			    refProp = _props4.ref,
			    restProps = objectWithoutProperties(_props4, ['ref']);
			var children = this.props.children;

			// We can't use destructuring default values to set the children,
			// because it won't apply work if `children` is null. A falsy check is
			// more reliable in real world use-cases.

			if (!children) {
				children = defaultChildren$2;
			}

			var props = _extends({}, restProps, {
				allowCreate: true,
				filterOptions: this.filterOptions,
				menuRenderer: this.menuRenderer,
				onInputChange: this.onInputChange,
				onInputKeyDown: this.onInputKeyDown,
				ref: function ref(_ref2) {
					_this2.select = _ref2;

					// These values may be needed in between Select mounts (when this.select is null)
					if (_ref2) {
						_this2.labelKey = _ref2.props.labelKey;
						_this2.valueKey = _ref2.props.valueKey;
					}
					if (refProp) {
						refProp(_ref2);
					}
				}
			});

			return children(props);
		}
	}]);
	return CreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var defaultChildren$2 = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

var isOptionUnique = function isOptionUnique(_ref3) {
	var option = _ref3.option,
	    options = _ref3.options,
	    labelKey = _ref3.labelKey,
	    valueKey = _ref3.valueKey;

	if (!options || !options.length) {
		return true;
	}

	return options.filter(function (existingOption) {
		return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
	}).length === 0;
};

var isValidNewOption = function isValidNewOption(_ref4) {
	var label = _ref4.label;
	return !!label;
};

var newOptionCreator = function newOptionCreator(_ref5) {
	var label = _ref5.label,
	    labelKey = _ref5.labelKey,
	    valueKey = _ref5.valueKey;

	var option = {};
	option[valueKey] = label;
	option[labelKey] = label;
	option.className = 'Select-create-option-placeholder';

	return option;
};

var promptTextCreator = function promptTextCreator(label) {
	return 'Create option "' + label + '"';
};

var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
	var keyCode = _ref6.keyCode;

	switch (keyCode) {
		case 9: // TAB
		case 13: // ENTER
		case 188:
			// COMMA
			return true;
		default:
			return false;
	}
};

// Default prop methods
CreatableSelect.isOptionUnique = isOptionUnique;
CreatableSelect.isValidNewOption = isValidNewOption;
CreatableSelect.newOptionCreator = newOptionCreator;
CreatableSelect.promptTextCreator = promptTextCreator;
CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;

CreatableSelect.defaultProps = {
	filterOptions: filterOptions,
	isOptionUnique: isOptionUnique,
	isValidNewOption: isValidNewOption,
	menuRenderer: menuRenderer,
	newOptionCreator: newOptionCreator,
	promptTextCreator: promptTextCreator,
	shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption,
	showNewOptionAtTop: true
};

CreatableSelect.propTypes = {
	// Child function responsible for creating the inner Select component
	// This component can be used to compose HOCs (eg Creatable and Async)
	// (props: Object): PropTypes.element
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.filterOptions
	filterOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,

	// Searches for any matching option within the set of options.
	// This function prevents duplicate options from being created.
	// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
	isOptionUnique: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Determines if the current input text represents a valid option.
	// ({ label: string }): boolean
	isValidNewOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.menuRenderer
	menuRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,

	// Factory to create new option.
	// ({ label: string, labelKey: string, valueKey: string }): Object
	newOptionCreator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// input change handler: function (inputValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// input keyDown handler: function (event) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// new option click handler: function (option) {}
	onNewOptionClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.options
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,

	// Creates prompt/placeholder option text.
	// (filterText: string): string
	promptTextCreator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	ref: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
	shouldKeyDownEventCreateNewOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Where to show prompt/placeholder option text.
	// true: new option prompt at top of list (default)
	// false: new option prompt at bottom of list
	showNewOptionAtTop: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};

var AsyncCreatableSelect = function (_React$Component) {
	inherits(AsyncCreatableSelect, _React$Component);

	function AsyncCreatableSelect() {
		classCallCheck(this, AsyncCreatableSelect);
		return possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
	}

	createClass(AsyncCreatableSelect, [{
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				Async,
				this.props,
				function (_ref) {
					var ref = _ref.ref,
					    asyncProps = objectWithoutProperties(_ref, ['ref']);

					var asyncRef = ref;
					return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						CreatableSelect,
						asyncProps,
						function (_ref2) {
							var ref = _ref2.ref,
							    creatableProps = objectWithoutProperties(_ref2, ['ref']);

							var creatableRef = ref;
							return _this2.props.children(_extends({}, creatableProps, {
								ref: function ref(select) {
									creatableRef(select);
									asyncRef(select);
									_this2.select = select;
								}
							}));
						}
					);
				}
			);
		}
	}]);
	return AsyncCreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var defaultChildren$1 = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

AsyncCreatableSelect.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
};

AsyncCreatableSelect.defaultProps = {
	children: defaultChildren$1
};

Select$1.Async = Async;
Select$1.AsyncCreatable = AsyncCreatableSelect;
Select$1.Creatable = CreatableSelect;
Select$1.Value = Value;
Select$1.Option = Option;


/* harmony default export */ __webpack_exports__["default"] = (Select$1);


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId()
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var id = nextProps.id;

			if (id !== this.props.id) {
				this.setState({ inputId: id || generateId() });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AutoSizer = __webpack_require__(1003);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AutoSizer).default;
  }
});
Object.defineProperty(exports, 'AutoSizer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AutoSizer).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(203);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(212);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(122);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(123);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(214);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(219);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var React = _interopRequireWildcard(_react);

var _detectElementResize = __webpack_require__(1038);

var _detectElementResize2 = _interopRequireDefault(_detectElementResize);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AutoSizer = function (_React$PureComponent) {
  (0, _inherits3.default)(AutoSizer, _React$PureComponent);

  function AutoSizer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AutoSizer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AutoSizer.__proto__ || (0, _getPrototypeOf2.default)(AutoSizer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      height: _this.props.defaultHeight || 0,
      width: _this.props.defaultWidth || 0
    }, _this._onResize = function () {
      var _this$props = _this.props,
          disableHeight = _this$props.disableHeight,
          disableWidth = _this$props.disableWidth,
          onResize = _this$props.onResize;


      if (_this._parentNode) {
        // Guard against AutoSizer component being removed from the DOM immediately after being added.
        // This can result in invalid style values which can result in NaN values if we don't handle them.
        // See issue #150 for more context.

        var _height = _this._parentNode.offsetHeight || 0;
        var _width = _this._parentNode.offsetWidth || 0;

        var _style = window.getComputedStyle(_this._parentNode) || {};
        var paddingLeft = parseInt(_style.paddingLeft, 10) || 0;
        var paddingRight = parseInt(_style.paddingRight, 10) || 0;
        var paddingTop = parseInt(_style.paddingTop, 10) || 0;
        var paddingBottom = parseInt(_style.paddingBottom, 10) || 0;

        var newHeight = _height - paddingTop - paddingBottom;
        var newWidth = _width - paddingLeft - paddingRight;

        if (!disableHeight && _this.state.height !== newHeight || !disableWidth && _this.state.width !== newWidth) {
          _this.setState({
            height: _height - paddingTop - paddingBottom,
            width: _width - paddingLeft - paddingRight
          });

          onResize({ height: _height, width: _width });
        }
      }
    }, _this._setRef = function (autoSizer) {
      _this._autoSizer = autoSizer;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AutoSizer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var nonce = this.props.nonce;

      if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
        // Delay access of parentNode until mount.
        // This handles edge-cases where the component has already been unmounted before its ref has been set,
        // As well as libraries like react-lite which have a slightly different lifecycle.
        this._parentNode = this._autoSizer.parentNode;

        // Defer requiring resize handler in order to support server-side rendering.
        // See issue #41
        this._detectElementResize = (0, _detectElementResize2.default)(nonce);
        this._detectElementResize.addResizeListener(this._parentNode, this._onResize);

        this._onResize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._detectElementResize && this._parentNode) {
        this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          disableHeight = _props.disableHeight,
          disableWidth = _props.disableWidth,
          style = _props.style;
      var _state = this.state,
          height = _state.height,
          width = _state.width;

      // Outer div should not force width/height since that may prevent containers from shrinking.
      // Inner component should overflow and use calculated width/height.
      // See issue #68 for more information.

      var outerStyle = { overflow: 'visible' };
      var childParams = {};

      if (!disableHeight) {
        outerStyle.height = 0;
        childParams.height = height;
      }

      if (!disableWidth) {
        outerStyle.width = 0;
        childParams.width = width;
      }

      /**
       * TODO: Avoid rendering children before the initial measurements have been collected.
       * At best this would just be wasting cycles.
       * Add this check into version 10 though as it could break too many ref callbacks in version 9.
       * Note that if default width/height props were provided this would still work with SSR.
      if (
        height !== 0 &&
        width !== 0
      ) {
        child = children({ height, width })
      }
      */

      return React.createElement(
        'div',
        {
          className: className,
          ref: this._setRef,
          style: (0, _extends3.default)({}, outerStyle, style) },
        children(childParams)
      );
    }
  }]);
  return AutoSizer;
}(React.PureComponent);

AutoSizer.defaultProps = {
  onResize: function onResize() {},
  disableHeight: false,
  disableWidth: false,
  style: {}
};
AutoSizer.propTypes =  true ? null : {
  /** Function responsible for rendering children.*/
  children: _propTypes2.default.func.isRequired,


  /** Optional custom CSS class name to attach to root AutoSizer element.  */
  className: _propTypes2.default.string,


  /** Default height to use for initial render; useful for SSR */
  defaultHeight: _propTypes2.default.number,


  /** Default width to use for initial render; useful for SSR */
  defaultWidth: _propTypes2.default.number,


  /** Disable dynamic :height property */
  disableHeight: _propTypes2.default.bool.isRequired,


  /** Disable dynamic :width property */
  disableWidth: _propTypes2.default.bool.isRequired,


  /** Nonce of the inlined stylesheet for Content Security Policy */
  nonce: _propTypes2.default.string,


  /** Callback to be invoked on-resize */
  onResize: _propTypes2.default.func.isRequired,


  /** Optional inline style */
  style: _propTypes2.default.object
};
exports.default = AutoSizer;

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1005);
module.exports = __webpack_require__(22).Object.assign;


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(57);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1006) });


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(119);
var gOPS = __webpack_require__(211);
var pIE = __webpack_require__(156);
var toObject = __webpack_require__(157);
var IObject = __webpack_require__(577);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(103)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(89);
var toLength = __webpack_require__(578);
var toAbsoluteIndex = __webpack_require__(1008);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(207);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1010);
module.exports = __webpack_require__(22).Object.getPrototypeOf;


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(157);
var $getPrototypeOf = __webpack_require__(579);

__webpack_require__(213)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1012), __esModule: true };

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1013);
var $Object = __webpack_require__(22).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(57);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(71), 'Object', { defineProperty: __webpack_require__(69).f });


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1015), __esModule: true };

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(581);
__webpack_require__(585);
module.exports = __webpack_require__(216).f('iterator');


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(207);
var defined = __webpack_require__(206);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(215);
var descriptor = __webpack_require__(154);
var setToStringTag = __webpack_require__(158);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(87)(IteratorPrototype, __webpack_require__(38)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(69);
var anObject = __webpack_require__(62);
var getKeys = __webpack_require__(119);

module.exports = __webpack_require__(71) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(1020);
var step = __webpack_require__(1021);
var Iterators = __webpack_require__(124);
var toIObject = __webpack_require__(89);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(582)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 1020 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 1021 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1023), __esModule: true };

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1024);
__webpack_require__(587);
__webpack_require__(1029);
__webpack_require__(1030);
module.exports = __webpack_require__(22).Symbol;


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(28);
var has = __webpack_require__(88);
var DESCRIPTORS = __webpack_require__(71);
var $export = __webpack_require__(57);
var redefine = __webpack_require__(583);
var META = __webpack_require__(1025).KEY;
var $fails = __webpack_require__(103);
var shared = __webpack_require__(209);
var setToStringTag = __webpack_require__(158);
var uid = __webpack_require__(155);
var wks = __webpack_require__(38);
var wksExt = __webpack_require__(216);
var wksDefine = __webpack_require__(217);
var enumKeys = __webpack_require__(1026);
var isArray = __webpack_require__(1027);
var anObject = __webpack_require__(62);
var isObject = __webpack_require__(70);
var toIObject = __webpack_require__(89);
var toPrimitive = __webpack_require__(205);
var createDesc = __webpack_require__(154);
var _create = __webpack_require__(215);
var gOPNExt = __webpack_require__(1028);
var $GOPD = __webpack_require__(218);
var $DP = __webpack_require__(69);
var $keys = __webpack_require__(119);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(586).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(156).f = $propertyIsEnumerable;
  __webpack_require__(211).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(121)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(87)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(155)('meta');
var isObject = __webpack_require__(70);
var has = __webpack_require__(88);
var setDesc = __webpack_require__(69).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(103)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(119);
var gOPS = __webpack_require__(211);
var pIE = __webpack_require__(156);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(120);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(89);
var gOPN = __webpack_require__(586).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(217)('asyncIterator');


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(217)('observable');


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1032), __esModule: true };

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1033);
module.exports = __webpack_require__(22).Object.setPrototypeOf;


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(57);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(1034).set });


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(70);
var anObject = __webpack_require__(62);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(118)(Function.call, __webpack_require__(218).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1036), __esModule: true };

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1037);
var $Object = __webpack_require__(22).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(57);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(215) });


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createDetectElementResize;
/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 * 4) Add nonce for style element.
 **/

function createDetectElementResize(nonce) {
  // Check `document` and `window` in case of server-side rendering
  var _window;
  if (typeof window !== 'undefined') {
    _window = window;
  } else if (typeof self !== 'undefined') {
    _window = self;
  } else {
    _window = global;
  }

  var attachEvent = typeof document !== 'undefined' && document.attachEvent;

  if (!attachEvent) {
    var requestFrame = function () {
      var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
        return _window.setTimeout(fn, 20);
      };
      return function (fn) {
        return raf(fn);
      };
    }();

    var cancelFrame = function () {
      var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
      return function (id) {
        return cancel(id);
      };
    }();

    var resetTriggers = function resetTriggers(element) {
      var triggers = element.__resizeTriggers__,
          expand = triggers.firstElementChild,
          contract = triggers.lastElementChild,
          expandChild = expand.firstElementChild;
      contract.scrollLeft = contract.scrollWidth;
      contract.scrollTop = contract.scrollHeight;
      expandChild.style.width = expand.offsetWidth + 1 + 'px';
      expandChild.style.height = expand.offsetHeight + 1 + 'px';
      expand.scrollLeft = expand.scrollWidth;
      expand.scrollTop = expand.scrollHeight;
    };

    var checkTriggers = function checkTriggers(element) {
      return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
    };

    var scrollListener = function scrollListener(e) {
      // Don't measure (which forces) reflow for scrolls that happen inside of children!
      if (e.target.className && typeof e.target.className.indexOf === 'function' && e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) {
        return;
      }

      var element = this;
      resetTriggers(this);
      if (this.__resizeRAF__) {
        cancelFrame(this.__resizeRAF__);
      }
      this.__resizeRAF__ = requestFrame(function () {
        if (checkTriggers(element)) {
          element.__resizeLast__.width = element.offsetWidth;
          element.__resizeLast__.height = element.offsetHeight;
          element.__resizeListeners__.forEach(function (fn) {
            fn.call(element, e);
          });
        }
      });
    };

    /* Detect CSS Animations support to detect element display/re-attach */
    var animation = false,
        keyframeprefix = '',
        animationstartevent = 'animationstart',
        domPrefixes = 'Webkit Moz O ms'.split(' '),
        startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
        pfx = '';
    {
      var elm = document.createElement('fakeelement');
      if (elm.style.animationName !== undefined) {
        animation = true;
      }

      if (animation === false) {
        for (var i = 0; i < domPrefixes.length; i++) {
          if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
            pfx = domPrefixes[i];
            keyframeprefix = '-' + pfx.toLowerCase() + '-';
            animationstartevent = startEvents[i];
            animation = true;
            break;
          }
        }
      }
    }

    var animationName = 'resizeanim';
    var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
    var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
  }

  var createStyles = function createStyles(doc) {
    if (!doc.getElementById('detectElementResize')) {
      //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
      var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
          head = doc.head || doc.getElementsByTagName('head')[0],
          style = doc.createElement('style');

      style.id = 'detectElementResize';
      style.type = 'text/css';

      if (nonce != null) {
        style.setAttribute('nonce', nonce);
      }

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(doc.createTextNode(css));
      }

      head.appendChild(style);
    }
  };

  var addResizeListener = function addResizeListener(element, fn) {
    if (attachEvent) {
      element.attachEvent('onresize', fn);
    } else {
      if (!element.__resizeTriggers__) {
        var doc = element.ownerDocument;
        var elementStyle = _window.getComputedStyle(element);
        if (elementStyle && elementStyle.position == 'static') {
          element.style.position = 'relative';
        }
        createStyles(doc);
        element.__resizeLast__ = {};
        element.__resizeListeners__ = [];
        (element.__resizeTriggers__ = doc.createElement('div')).className = 'resize-triggers';
        element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';
        element.appendChild(element.__resizeTriggers__);
        resetTriggers(element);
        element.addEventListener('scroll', scrollListener, true);

        /* Listen for a css animation to detect element display/re-attach */
        if (animationstartevent) {
          element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
            if (e.animationName == animationName) {
              resetTriggers(element);
            }
          };
          element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
        }
      }
      element.__resizeListeners__.push(fn);
    }
  };

  var removeResizeListener = function removeResizeListener(element, fn) {
    if (attachEvent) {
      element.detachEvent('onresize', fn);
    } else {
      element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
      if (!element.__resizeListeners__.length) {
        element.removeEventListener('scroll', scrollListener, true);
        if (element.__resizeTriggers__.__animationListener__) {
          element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
          element.__resizeTriggers__.__animationListener__ = null;
        }
        try {
          element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
        } catch (e) {
          // Preact compat; see developit/preact-compat/issues/228
        }
      }
    }
  };

  return {
    addResizeListener: addResizeListener,
    removeResizeListener: removeResizeListener
  };
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(25)))

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bpfrpt_proptype_RowRendererParams = exports.List = exports.default = undefined;

var _List = __webpack_require__(1040);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_List).default;
  }
});
Object.defineProperty(exports, 'List', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_List).default;
  }
});

var _types = __webpack_require__(596);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.bpfrpt_proptype_RowRendererParams = _types.bpfrpt_proptype_RowRendererParams;

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(203);

var _extends3 = _interopRequireDefault(_extends2);

var _getOwnPropertyDescriptor = __webpack_require__(1041);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = __webpack_require__(212);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(122);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(123);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(214);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(219);

var _inherits3 = _interopRequireDefault(_inherits2);

var _Grid = __webpack_require__(1044);

var _Grid2 = _interopRequireDefault(_Grid);

var _react = __webpack_require__(2);

var React = _interopRequireWildcard(_react);

var _clsx = __webpack_require__(588);

var _clsx2 = _interopRequireDefault(_clsx);

var _types = __webpack_require__(596);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * It is inefficient to create and manage a large list of DOM elements within a scrolling container
 * if only a few of those elements are visible. The primary purpose of this component is to improve
 * performance by only rendering the DOM nodes that a user is able to see based on their current
 * scroll position.
 *
 * This component renders a virtualized list of elements with either fixed or dynamic heights.
 */

var List = function (_React$PureComponent) {
  (0, _inherits3.default)(List, _React$PureComponent);

  function List() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, List);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = List.__proto__ || (0, _getPrototypeOf2.default)(List)).call.apply(_ref, [this].concat(args))), _this), _this._cellRenderer = function (_ref2) {
      var parent = _ref2.parent,
          rowIndex = _ref2.rowIndex,
          style = _ref2.style,
          isScrolling = _ref2.isScrolling,
          isVisible = _ref2.isVisible,
          key = _ref2.key;
      var rowRenderer = _this.props.rowRenderer;

      // TRICKY The style object is sometimes cached by Grid.
      // This prevents new style objects from bypassing shallowCompare().
      // However as of React 16, style props are auto-frozen (at least in dev mode)
      // Check to make sure we can still modify the style before proceeding.
      // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713

      var _Object$getOwnPropert = (0, _getOwnPropertyDescriptor2.default)(style, 'width'),
          writable = _Object$getOwnPropert.writable;

      if (writable) {
        // By default, List cells should be 100% width.
        // This prevents them from flowing under a scrollbar (if present).
        style.width = '100%';
      }

      return rowRenderer({
        index: rowIndex,
        style: style,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent
      });
    }, _this._setRef = function (ref) {
      _this.Grid = ref;
    }, _this._onScroll = function (_ref3) {
      var clientHeight = _ref3.clientHeight,
          scrollHeight = _ref3.scrollHeight,
          scrollTop = _ref3.scrollTop;
      var onScroll = _this.props.onScroll;


      onScroll({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop });
    }, _this._onSectionRendered = function (_ref4) {
      var rowOverscanStartIndex = _ref4.rowOverscanStartIndex,
          rowOverscanStopIndex = _ref4.rowOverscanStopIndex,
          rowStartIndex = _ref4.rowStartIndex,
          rowStopIndex = _ref4.rowStopIndex;
      var onRowsRendered = _this.props.onRowsRendered;


      onRowsRendered({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(List, [{
    key: 'forceUpdateGrid',
    value: function forceUpdateGrid() {
      if (this.Grid) {
        this.Grid.forceUpdate();
      }
    }

    /** See Grid#getOffsetForCell */

  }, {
    key: 'getOffsetForRow',
    value: function getOffsetForRow(_ref5) {
      var alignment = _ref5.alignment,
          index = _ref5.index;

      if (this.Grid) {
        var _Grid$getOffsetForCel = this.Grid.getOffsetForCell({
          alignment: alignment,
          rowIndex: index,
          columnIndex: 0
        }),
            _scrollTop = _Grid$getOffsetForCel.scrollTop;

        return _scrollTop;
      }
      return 0;
    }

    /** CellMeasurer compatibility */

  }, {
    key: 'invalidateCellSizeAfterRender',
    value: function invalidateCellSizeAfterRender(_ref6) {
      var columnIndex = _ref6.columnIndex,
          rowIndex = _ref6.rowIndex;

      if (this.Grid) {
        this.Grid.invalidateCellSizeAfterRender({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }

    /** See Grid#measureAllCells */

  }, {
    key: 'measureAllRows',
    value: function measureAllRows() {
      if (this.Grid) {
        this.Grid.measureAllCells();
      }
    }

    /** CellMeasurer compatibility */

  }, {
    key: 'recomputeGridSize',
    value: function recomputeGridSize() {
      var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref7$columnIndex = _ref7.columnIndex,
          columnIndex = _ref7$columnIndex === undefined ? 0 : _ref7$columnIndex,
          _ref7$rowIndex = _ref7.rowIndex,
          rowIndex = _ref7$rowIndex === undefined ? 0 : _ref7$rowIndex;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }

    /** See Grid#recomputeGridSize */

  }, {
    key: 'recomputeRowHeights',
    value: function recomputeRowHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: index,
          columnIndex: 0
        });
      }
    }

    /** See Grid#scrollToPosition */

  }, {
    key: 'scrollToPosition',
    value: function scrollToPosition() {
      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToPosition({ scrollTop: scrollTop });
      }
    }

    /** See Grid#scrollToCell */

  }, {
    key: 'scrollToRow',
    value: function scrollToRow() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToCell({
          columnIndex: 0,
          rowIndex: index
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          noRowsRenderer = _props.noRowsRenderer,
          scrollToIndex = _props.scrollToIndex,
          width = _props.width;


      var classNames = (0, _clsx2.default)('ReactVirtualized__List', className);

      return React.createElement(_Grid2.default, (0, _extends3.default)({}, this.props, {
        autoContainerWidth: true,
        cellRenderer: this._cellRenderer,
        className: classNames,
        columnWidth: width,
        columnCount: 1,
        noContentRenderer: noRowsRenderer,
        onScroll: this._onScroll,
        onSectionRendered: this._onSectionRendered,
        ref: this._setRef,
        scrollToRow: scrollToIndex
      }));
    }
  }]);
  return List;
}(React.PureComponent);

List.defaultProps = {
  autoHeight: false,
  estimatedRowSize: 30,
  onScroll: function onScroll() {},
  noRowsRenderer: function noRowsRenderer() {
    return null;
  },
  onRowsRendered: function onRowsRendered() {},
  overscanIndicesGetter: _Grid.accessibilityOverscanIndicesGetter,
  overscanRowCount: 10,
  scrollToAlignment: 'auto',
  scrollToIndex: -1,
  style: {}
};
List.propTypes =  true ? null : {
  "aria-label": _propTypes2.default.string,


  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: _propTypes2.default.bool.isRequired,


  /** Optional CSS class name */
  className: _propTypes2.default.string,


  /**
   * Used to estimate the total height of a List before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: _propTypes2.default.number.isRequired,


  /** Height constraint for list (determines how many actual rows are rendered) */
  height: _propTypes2.default.number.isRequired,


  /** Optional renderer to be used in place of rows when rowCount is 0 */
  noRowsRenderer: function noRowsRenderer() {
    return (typeof _Grid.bpfrpt_proptype_NoContentRenderer === 'function' ? _Grid.bpfrpt_proptype_NoContentRenderer.isRequired ? _Grid.bpfrpt_proptype_NoContentRenderer.isRequired : _Grid.bpfrpt_proptype_NoContentRenderer : _propTypes2.default.shape(_Grid.bpfrpt_proptype_NoContentRenderer).isRequired).apply(this, arguments);
  },


  /** Callback invoked with information about the slice of rows that were just rendered.  */

  onRowsRendered: _propTypes2.default.func.isRequired,


  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   */
  onScroll: _propTypes2.default.func.isRequired,


  /** See Grid#overscanIndicesGetter */
  overscanIndicesGetter: function overscanIndicesGetter() {
    return (typeof _Grid.bpfrpt_proptype_OverscanIndicesGetter === 'function' ? _Grid.bpfrpt_proptype_OverscanIndicesGetter.isRequired ? _Grid.bpfrpt_proptype_OverscanIndicesGetter.isRequired : _Grid.bpfrpt_proptype_OverscanIndicesGetter : _propTypes2.default.shape(_Grid.bpfrpt_proptype_OverscanIndicesGetter).isRequired).apply(this, arguments);
  },


  /**
   * Number of rows to render above/below the visible bounds of the list.
   * These rows can help for smoother scrolling on touch devices.
   */
  overscanRowCount: _propTypes2.default.number.isRequired,


  /** Either a fixed row height (number) or a function that returns the height of a row given its index.  */
  rowHeight: function rowHeight() {
    return (typeof _Grid.bpfrpt_proptype_CellSize === 'function' ? _Grid.bpfrpt_proptype_CellSize.isRequired ? _Grid.bpfrpt_proptype_CellSize.isRequired : _Grid.bpfrpt_proptype_CellSize : _propTypes2.default.shape(_Grid.bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
  },


  /** Responsible for rendering a row given an index; ({ index: number }): node */
  rowRenderer: function rowRenderer() {
    return (typeof _types.bpfrpt_proptype_RowRenderer === 'function' ? _types.bpfrpt_proptype_RowRenderer.isRequired ? _types.bpfrpt_proptype_RowRenderer.isRequired : _types.bpfrpt_proptype_RowRenderer : _propTypes2.default.shape(_types.bpfrpt_proptype_RowRenderer).isRequired).apply(this, arguments);
  },


  /** Number of rows in list. */
  rowCount: _propTypes2.default.number.isRequired,


  /** See Grid#scrollToAlignment */
  scrollToAlignment: function scrollToAlignment() {
    return (typeof _Grid.bpfrpt_proptype_Alignment === 'function' ? _Grid.bpfrpt_proptype_Alignment.isRequired ? _Grid.bpfrpt_proptype_Alignment.isRequired : _Grid.bpfrpt_proptype_Alignment : _propTypes2.default.shape(_Grid.bpfrpt_proptype_Alignment).isRequired).apply(this, arguments);
  },


  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  scrollToIndex: _propTypes2.default.number.isRequired,


  /** Vertical offset. */
  scrollTop: _propTypes2.default.number,


  /** Optional inline style */
  style: _propTypes2.default.object.isRequired,


  /** Tab index for focus */
  tabIndex: _propTypes2.default.number,


  /** Width of list */
  width: _propTypes2.default.number.isRequired
};
exports.default = List;

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1042), __esModule: true };

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1043);
var $Object = __webpack_require__(22).Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(89);
var $getOwnPropertyDescriptor = __webpack_require__(218).f;

__webpack_require__(213)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bpfrpt_proptype_Scroll = exports.bpfrpt_proptype_CellRendererParams = exports.bpfrpt_proptype_RenderedSection = exports.bpfrpt_proptype_OverscanIndicesGetter = exports.bpfrpt_proptype_CellSize = exports.bpfrpt_proptype_CellPosition = exports.bpfrpt_proptype_Alignment = exports.bpfrpt_proptype_NoContentRenderer = exports.defaultOverscanIndicesGetter = exports.defaultCellRangeRenderer = exports.accessibilityOverscanIndicesGetter = exports.Grid = exports.default = undefined;

var _Grid = __webpack_require__(1045);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Grid).default;
  }
});
Object.defineProperty(exports, 'Grid', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Grid).default;
  }
});

var _accessibilityOverscanIndicesGetter = __webpack_require__(1078);

Object.defineProperty(exports, 'accessibilityOverscanIndicesGetter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_accessibilityOverscanIndicesGetter).default;
  }
});

var _defaultCellRangeRenderer = __webpack_require__(590);

Object.defineProperty(exports, 'defaultCellRangeRenderer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_defaultCellRangeRenderer).default;
  }
});

var _defaultOverscanIndicesGetter = __webpack_require__(589);

Object.defineProperty(exports, 'defaultOverscanIndicesGetter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_defaultOverscanIndicesGetter).default;
  }
});

var _types = __webpack_require__(72);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.bpfrpt_proptype_NoContentRenderer = _types.bpfrpt_proptype_NoContentRenderer;
exports.bpfrpt_proptype_Alignment = _types.bpfrpt_proptype_Alignment;
exports.bpfrpt_proptype_CellPosition = _types.bpfrpt_proptype_CellPosition;
exports.bpfrpt_proptype_CellSize = _types.bpfrpt_proptype_CellSize;
exports.bpfrpt_proptype_OverscanIndicesGetter = _types.bpfrpt_proptype_OverscanIndicesGetter;
exports.bpfrpt_proptype_RenderedSection = _types.bpfrpt_proptype_RenderedSection;
exports.bpfrpt_proptype_CellRendererParams = _types.bpfrpt_proptype_CellRendererParams;
exports.bpfrpt_proptype_Scroll = _types.bpfrpt_proptype_Scroll;

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = undefined;

var _assign = __webpack_require__(574);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(203);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(212);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(122);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(123);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(214);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(219);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var React = _interopRequireWildcard(_react);

var _clsx = __webpack_require__(588);

var _clsx2 = _interopRequireDefault(_clsx);

var _calculateSizeAndPositionDataAndUpdateScrollOffset = __webpack_require__(1046);

var _calculateSizeAndPositionDataAndUpdateScrollOffset2 = _interopRequireDefault(_calculateSizeAndPositionDataAndUpdateScrollOffset);

var _ScalingCellSizeAndPositionManager = __webpack_require__(220);

var _ScalingCellSizeAndPositionManager2 = _interopRequireDefault(_ScalingCellSizeAndPositionManager);

var _createCallbackMemoizer = __webpack_require__(1051);

var _createCallbackMemoizer2 = _interopRequireDefault(_createCallbackMemoizer);

var _defaultOverscanIndicesGetter = __webpack_require__(589);

var _defaultOverscanIndicesGetter2 = _interopRequireDefault(_defaultOverscanIndicesGetter);

var _updateScrollIndexHelper = __webpack_require__(1055);

var _updateScrollIndexHelper2 = _interopRequireDefault(_updateScrollIndexHelper);

var _defaultCellRangeRenderer = __webpack_require__(590);

var _defaultCellRangeRenderer2 = _interopRequireDefault(_defaultCellRangeRenderer);

var _scrollbarSize = __webpack_require__(1056);

var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);

var _reactLifecyclesCompat = __webpack_require__(1059);

var _requestAnimationTimeout = __webpack_require__(1060);

var _types = __webpack_require__(72);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;

/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */


var SCROLL_POSITION_CHANGE_REASONS = {
  OBSERVED: 'observed',
  REQUESTED: 'requested'
};

var renderNull = function renderNull() {
  return null;
};

/**
 * Renders tabular data with virtualization along the vertical and horizontal axes.
 * Row heights and column widths must be known ahead of time and specified as properties.
 */
var Grid = function (_React$PureComponent) {
  (0, _inherits3.default)(Grid, _React$PureComponent);

  // Invokes onSectionRendered callback only when start/stop row or column indices change
  function Grid(props) {
    (0, _classCallCheck3.default)(this, Grid);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Grid.__proto__ || (0, _getPrototypeOf2.default)(Grid)).call(this, props));

    _this._onGridRenderedMemoizer = (0, _createCallbackMemoizer2.default)();
    _this._onScrollMemoizer = (0, _createCallbackMemoizer2.default)(false);
    _this._deferredInvalidateColumnIndex = null;
    _this._deferredInvalidateRowIndex = null;
    _this._recomputeScrollLeftFlag = false;
    _this._recomputeScrollTopFlag = false;
    _this._horizontalScrollBarSize = 0;
    _this._verticalScrollBarSize = 0;
    _this._scrollbarPresenceChanged = false;
    _this._renderedColumnStartIndex = 0;
    _this._renderedColumnStopIndex = 0;
    _this._renderedRowStartIndex = 0;
    _this._renderedRowStopIndex = 0;
    _this._styleCache = {};
    _this._cellCache = {};

    _this._debounceScrollEndedCallback = function () {
      _this._disablePointerEventsTimeoutId = null;
      // isScrolling is used to determine if we reset styleCache
      _this.setState({
        isScrolling: false,
        needToResetStyleCache: false
      });
    };

    _this._invokeOnGridRenderedHelper = function () {
      var onSectionRendered = _this.props.onSectionRendered;


      _this._onGridRenderedMemoizer({
        callback: onSectionRendered,
        indices: {
          columnOverscanStartIndex: _this._columnStartIndex,
          columnOverscanStopIndex: _this._columnStopIndex,
          columnStartIndex: _this._renderedColumnStartIndex,
          columnStopIndex: _this._renderedColumnStopIndex,
          rowOverscanStartIndex: _this._rowStartIndex,
          rowOverscanStopIndex: _this._rowStopIndex,
          rowStartIndex: _this._renderedRowStartIndex,
          rowStopIndex: _this._renderedRowStopIndex
        }
      });
    };

    _this._setScrollingContainerRef = function (ref) {
      _this._scrollingContainer = ref;
    };

    _this._onScroll = function (event) {
      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
      // See issue #404 for more information.
      if (event.target === _this._scrollingContainer) {
        _this.handleScrollEvent(event.target);
      }
    };

    var columnSizeAndPositionManager = new _ScalingCellSizeAndPositionManager2.default({
      cellCount: props.columnCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return Grid._wrapSizeGetter(props.columnWidth)(params);
      },
      estimatedCellSize: Grid._getEstimatedColumnSize(props)
    });
    var rowSizeAndPositionManager = new _ScalingCellSizeAndPositionManager2.default({
      cellCount: props.rowCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return Grid._wrapSizeGetter(props.rowHeight)(params);
      },
      estimatedCellSize: Grid._getEstimatedRowSize(props)
    });

    _this.state = {
      instanceProps: {
        columnSizeAndPositionManager: columnSizeAndPositionManager,
        rowSizeAndPositionManager: rowSizeAndPositionManager,

        prevColumnWidth: props.columnWidth,
        prevRowHeight: props.rowHeight,
        prevColumnCount: props.columnCount,
        prevRowCount: props.rowCount,
        prevIsScrolling: props.isScrolling === true,
        prevScrollToColumn: props.scrollToColumn,
        prevScrollToRow: props.scrollToRow,
        prevScrollLeft: props.scrollLeft,
        prevScrollTop: props.scrollTop,

        scrollbarSize: 0,
        scrollbarSizeMeasured: false
      },
      isScrolling: false,
      scrollDirectionHorizontal: _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD,
      scrollDirectionVertical: _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD,
      scrollLeft: props.scrollLeft || 0,
      scrollTop: props.scrollTop || 0,
      scrollPositionChangeReason: null,

      needToResetStyleCache: false
    };

    if (props.scrollToRow > 0) {
      _this._initialScrollTop = _this._getCalculatedScrollTop(props, _this.state);
    }
    if (props.scrollToColumn > 0) {
      _this._initialScrollLeft = _this._getCalculatedScrollLeft(props, _this.state);
    }
    return _this;
  }

  /**
   * Gets offsets for a given cell and alignment.
   */


  (0, _createClass3.default)(Grid, [{
    key: 'getOffsetForCell',
    value: function getOffsetForCell() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$alignment = _ref.alignment,
          alignment = _ref$alignment === undefined ? this.props.scrollToAlignment : _ref$alignment,
          _ref$columnIndex = _ref.columnIndex,
          columnIndex = _ref$columnIndex === undefined ? this.props.scrollToColumn : _ref$columnIndex,
          _ref$rowIndex = _ref.rowIndex,
          rowIndex = _ref$rowIndex === undefined ? this.props.scrollToRow : _ref$rowIndex;

      var offsetProps = (0, _extends3.default)({}, this.props, {
        scrollToAlignment: alignment,
        scrollToColumn: columnIndex,
        scrollToRow: rowIndex
      });

      return {
        scrollLeft: this._getCalculatedScrollLeft(offsetProps),
        scrollTop: this._getCalculatedScrollTop(offsetProps)
      };
    }

    /**
     * Gets estimated total rows' height.
     */

  }, {
    key: 'getTotalRowsHeight',
    value: function getTotalRowsHeight() {
      return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
    }

    /**
     * Gets estimated total columns' width.
     */

  }, {
    key: 'getTotalColumnsWidth',
    value: function getTotalColumnsWidth() {
      return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
    }

    /**
     * This method handles a scroll event originating from an external scroll control.
     * It's an advanced method and should probably not be used unless you're implementing a custom scroll-bar solution.
     */

  }, {
    key: 'handleScrollEvent',
    value: function handleScrollEvent(_ref2) {
      var _ref2$scrollLeft = _ref2.scrollLeft,
          scrollLeftParam = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft,
          _ref2$scrollTop = _ref2.scrollTop,
          scrollTopParam = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop;

      // On iOS, we can arrive at negative offsets by swiping past the start.
      // To prevent flicker here, we make playing in the negative offset zone cause nothing to happen.
      if (scrollTopParam < 0) {
        return;
      }

      // Prevent pointer events from interrupting a smooth scroll
      this._debounceScrollEnded();

      var _props = this.props,
          autoHeight = _props.autoHeight,
          autoWidth = _props.autoWidth,
          height = _props.height,
          width = _props.width;
      var instanceProps = this.state.instanceProps;

      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.

      var scrollbarSize = instanceProps.scrollbarSize;
      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
      var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), scrollLeftParam);
      var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), scrollTopParam);

      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.
      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
        // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
        // Don't change direction for an axis unless scroll offset has changed.
        var _scrollDirectionHorizontal = scrollLeft !== this.state.scrollLeft ? scrollLeft > this.state.scrollLeft ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionHorizontal;
        var _scrollDirectionVertical = scrollTop !== this.state.scrollTop ? scrollTop > this.state.scrollTop ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionVertical;

        var newState = {
          isScrolling: true,
          scrollDirectionHorizontal: _scrollDirectionHorizontal,
          scrollDirectionVertical: _scrollDirectionVertical,
          scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.OBSERVED
        };

        if (!autoHeight) {
          newState.scrollTop = scrollTop;
        }

        if (!autoWidth) {
          newState.scrollLeft = scrollLeft;
        }

        newState.needToResetStyleCache = false;
        this.setState(newState);
      }

      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        totalColumnsWidth: totalColumnsWidth,
        totalRowsHeight: totalRowsHeight
      });
    }

    /**
     * Invalidate Grid size and recompute visible cells.
     * This is a deferred wrapper for recomputeGridSize().
     * It sets a flag to be evaluated on cDM/cDU to avoid unnecessary renders.
     * This method is intended for advanced use-cases like CellMeasurer.
     */
    // @TODO (bvaughn) Add automated test coverage for this.

  }, {
    key: 'invalidateCellSizeAfterRender',
    value: function invalidateCellSizeAfterRender(_ref3) {
      var columnIndex = _ref3.columnIndex,
          rowIndex = _ref3.rowIndex;

      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
    }

    /**
     * Pre-measure all columns and rows in a Grid.
     * Typically cells are only measured as needed and estimated sizes are used for cells that have not yet been measured.
     * This method ensures that the next call to getTotalSize() returns an exact size (as opposed to just an estimated one).
     */

  }, {
    key: 'measureAllCells',
    value: function measureAllCells() {
      var _props2 = this.props,
          columnCount = _props2.columnCount,
          rowCount = _props2.rowCount;
      var instanceProps = this.state.instanceProps;

      instanceProps.columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
      instanceProps.rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
    }

    /**
     * Forced recompute of row heights and column widths.
     * This function should be called if dynamic column or row sizes have changed but nothing else has.
     * Since Grid only receives :columnCount and :rowCount it has no way of detecting when the underlying data changes.
     */

  }, {
    key: 'recomputeGridSize',
    value: function recomputeGridSize() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$columnIndex = _ref4.columnIndex,
          columnIndex = _ref4$columnIndex === undefined ? 0 : _ref4$columnIndex,
          _ref4$rowIndex = _ref4.rowIndex,
          rowIndex = _ref4$rowIndex === undefined ? 0 : _ref4$rowIndex;

      var _props3 = this.props,
          scrollToColumn = _props3.scrollToColumn,
          scrollToRow = _props3.scrollToRow;
      var instanceProps = this.state.instanceProps;


      instanceProps.columnSizeAndPositionManager.resetCell(columnIndex);
      instanceProps.rowSizeAndPositionManager.resetCell(rowIndex);

      // Cell sizes may be determined by a function property.
      // In this case the cDU handler can't know if they changed.
      // Store this flag to let the next cDU pass know it needs to recompute the scroll offset.
      this._recomputeScrollLeftFlag = scrollToColumn >= 0 && (this.state.scrollDirectionHorizontal === _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD ? columnIndex <= scrollToColumn : columnIndex >= scrollToColumn);
      this._recomputeScrollTopFlag = scrollToRow >= 0 && (this.state.scrollDirectionVertical === _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD ? rowIndex <= scrollToRow : rowIndex >= scrollToRow);

      // Clear cell cache in case we are scrolling;
      // Invalid row heights likely mean invalid cached content as well.
      this._styleCache = {};
      this._cellCache = {};

      this.forceUpdate();
    }

    /**
     * Ensure column and row are visible.
     */

  }, {
    key: 'scrollToCell',
    value: function scrollToCell(_ref5) {
      var columnIndex = _ref5.columnIndex,
          rowIndex = _ref5.rowIndex;
      var columnCount = this.props.columnCount;


      var props = this.props;

      // Don't adjust scroll offset for single-column grids (eg List, Table).
      // This can cause a funky scroll offset because of the vertical scrollbar width.
      if (columnCount > 1 && columnIndex !== undefined) {
        this._updateScrollLeftForScrollToColumn((0, _extends3.default)({}, props, {
          scrollToColumn: columnIndex
        }));
      }

      if (rowIndex !== undefined) {
        this._updateScrollTopForScrollToRow((0, _extends3.default)({}, props, {
          scrollToRow: rowIndex
        }));
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props4 = this.props,
          getScrollbarSize = _props4.getScrollbarSize,
          height = _props4.height,
          scrollLeft = _props4.scrollLeft,
          scrollToColumn = _props4.scrollToColumn,
          scrollTop = _props4.scrollTop,
          scrollToRow = _props4.scrollToRow,
          width = _props4.width;
      var instanceProps = this.state.instanceProps;

      // Reset initial offsets to be ignored in browser

      this._initialScrollTop = 0;
      this._initialScrollLeft = 0;

      // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.
      this._handleInvalidatedGridSize();

      // If this component was first rendered server-side, scrollbar size will be undefined.
      // In that event we need to remeasure.
      if (!instanceProps.scrollbarSizeMeasured) {
        this.setState(function (prevState) {
          var stateUpdate = (0, _extends3.default)({}, prevState, { needToResetStyleCache: false });
          stateUpdate.instanceProps.scrollbarSize = getScrollbarSize();
          stateUpdate.instanceProps.scrollbarSizeMeasured = true;
          return stateUpdate;
        });
      }

      if (typeof scrollLeft === 'number' && scrollLeft >= 0 || typeof scrollTop === 'number' && scrollTop >= 0) {
        var stateUpdate = Grid._getScrollToPositionStateUpdate({
          prevState: this.state,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        });
        if (stateUpdate) {
          stateUpdate.needToResetStyleCache = false;
          this.setState(stateUpdate);
        }
      }

      // refs don't work in `react-test-renderer`
      if (this._scrollingContainer) {
        // setting the ref's scrollLeft and scrollTop.
        // Somehow in MultiGrid the main grid doesn't trigger a update on mount.
        if (this._scrollingContainer.scrollLeft !== this.state.scrollLeft) {
          this._scrollingContainer.scrollLeft = this.state.scrollLeft;
        }
        if (this._scrollingContainer.scrollTop !== this.state.scrollTop) {
          this._scrollingContainer.scrollTop = this.state.scrollTop;
        }
      }

      // Don't update scroll offset if the size is 0; we don't render any cells in this case.
      // Setting a state may cause us to later thing we've updated the offce when we haven't.
      var sizeIsBiggerThanZero = height > 0 && width > 0;
      if (scrollToColumn >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollLeftForScrollToColumn();
      }
      if (scrollToRow >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollTopForScrollToRow();
      }

      // Update onRowsRendered callback
      this._invokeOnGridRenderedHelper();

      // Initialize onScroll callback
      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalColumnsWidth: instanceProps.columnSizeAndPositionManager.getTotalSize(),
        totalRowsHeight: instanceProps.rowSizeAndPositionManager.getTotalSize()
      });

      this._maybeCallOnScrollbarPresenceChange();
    }

    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) New scroll-to-cell props have been set
     */

  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _props5 = this.props,
          autoHeight = _props5.autoHeight,
          autoWidth = _props5.autoWidth,
          columnCount = _props5.columnCount,
          height = _props5.height,
          rowCount = _props5.rowCount,
          scrollToAlignment = _props5.scrollToAlignment,
          scrollToColumn = _props5.scrollToColumn,
          scrollToRow = _props5.scrollToRow,
          width = _props5.width;
      var _state = this.state,
          scrollLeft = _state.scrollLeft,
          scrollPositionChangeReason = _state.scrollPositionChangeReason,
          scrollTop = _state.scrollTop,
          instanceProps = _state.instanceProps;
      // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.

      this._handleInvalidatedGridSize();

      // Handle edge case where column or row count has only just increased over 0.
      // In this case we may have to restore a previously-specified scroll offset.
      // For more info see bvaughn/react-virtualized/issues/218
      var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0;

      // Make sure requested changes to :scrollLeft or :scrollTop get applied.
      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
      // So we only set these when we require an adjustment of the scroll position.
      // See issue #2 for more information.
      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
        // @TRICKY :autoHeight and :autoWidth properties instructs Grid to leave :scrollTop and :scrollLeft management to an external HOC (eg WindowScroller).
        // In this case we should avoid checking scrollingContainer.scrollTop and scrollingContainer.scrollLeft since it forces layout/flow.
        if (!autoWidth && scrollLeft >= 0 && (scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }
        if (!autoHeight && scrollTop >= 0 && (scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      }

      // Special case where the previous size was 0:
      // In this case we don't show any windowed cells at all.
      // So we should always recalculate offset afterwards.
      var sizeJustIncreasedFromZero = (prevProps.width === 0 || prevProps.height === 0) && height > 0 && width > 0;

      // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
      // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?
      if (this._recomputeScrollLeftFlag) {
        this._recomputeScrollLeftFlag = false;
        this._updateScrollLeftForScrollToColumn(this.props);
      } else {
        (0, _updateScrollIndexHelper2.default)({
          cellSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
          previousCellsCount: prevProps.columnCount,
          previousCellSize: prevProps.columnWidth,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToColumn,
          previousSize: prevProps.width,
          scrollOffset: scrollLeft,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToColumn,
          size: width,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollLeftForScrollToColumn(_this2.props);
          }
        });
      }

      if (this._recomputeScrollTopFlag) {
        this._recomputeScrollTopFlag = false;
        this._updateScrollTopForScrollToRow(this.props);
      } else {
        (0, _updateScrollIndexHelper2.default)({
          cellSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
          previousCellsCount: prevProps.rowCount,
          previousCellSize: prevProps.rowHeight,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToRow,
          previousSize: prevProps.height,
          scrollOffset: scrollTop,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToRow,
          size: height,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollTopForScrollToRow(_this2.props);
          }
        });
      }

      // Update onRowsRendered callback if start/stop indices have changed
      this._invokeOnGridRenderedHelper();

      // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners
      if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();

        this._invokeOnScrollMemoizer({
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          totalColumnsWidth: totalColumnsWidth,
          totalRowsHeight: totalRowsHeight
        });
      }

      this._maybeCallOnScrollbarPresenceChange();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        (0, _requestAnimationTimeout.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
      }
    }

    /**
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */

  }, {
    key: 'render',
    value: function render() {
      var _props6 = this.props,
          autoContainerWidth = _props6.autoContainerWidth,
          autoHeight = _props6.autoHeight,
          autoWidth = _props6.autoWidth,
          className = _props6.className,
          containerProps = _props6.containerProps,
          containerRole = _props6.containerRole,
          containerStyle = _props6.containerStyle,
          height = _props6.height,
          id = _props6.id,
          noContentRenderer = _props6.noContentRenderer,
          role = _props6.role,
          style = _props6.style,
          tabIndex = _props6.tabIndex,
          width = _props6.width;
      var _state2 = this.state,
          instanceProps = _state2.instanceProps,
          needToResetStyleCache = _state2.needToResetStyleCache;


      var isScrolling = this._isScrolling();

      var gridStyle = {
        boxSizing: 'border-box',
        direction: 'ltr',
        height: autoHeight ? 'auto' : height,
        position: 'relative',
        width: autoWidth ? 'auto' : width,
        WebkitOverflowScrolling: 'touch',
        willChange: 'transform'
      };

      if (needToResetStyleCache) {
        this._styleCache = {};
      }

      // calculate _styleCache here
      // if state.isScrolling (not from _isScrolling) then reset
      if (!this.state.isScrolling) {
        this._resetStyleCache();
      }

      // calculate children to render here
      this._calculateChildrenToRender(this.props, this.state);

      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();

      // Force browser to hide scrollbars when we know they aren't necessary.
      // Otherwise once scrollbars appear they may not disappear again.
      // For more info see issue #116
      var verticalScrollBarSize = totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
      var horizontalScrollBarSize = totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;

      if (horizontalScrollBarSize !== this._horizontalScrollBarSize || verticalScrollBarSize !== this._verticalScrollBarSize) {
        this._horizontalScrollBarSize = horizontalScrollBarSize;
        this._verticalScrollBarSize = verticalScrollBarSize;
        this._scrollbarPresenceChanged = true;
      }

      // Also explicitly init styles to 'auto' if scrollbars are required.
      // This works around an obscure edge case where external CSS styles have not yet been loaded,
      // But an initial scroll index of offset is set as an external prop.
      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
      // This was originally reported via clauderic/react-infinite-calendar/issues/23
      gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
      gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';

      var childrenToDisplay = this._childrenToDisplay;

      var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;

      return React.createElement(
        'div',
        (0, _extends3.default)({
          ref: this._setScrollingContainerRef
        }, containerProps, {
          'aria-label': this.props['aria-label'],
          'aria-readonly': this.props['aria-readonly'],
          className: (0, _clsx2.default)('ReactVirtualized__Grid', className),
          id: id,
          onScroll: this._onScroll,
          role: role,
          style: (0, _extends3.default)({}, gridStyle, style),
          tabIndex: tabIndex }),
        childrenToDisplay.length > 0 && React.createElement(
          'div',
          {
            className: 'ReactVirtualized__Grid__innerScrollContainer',
            role: containerRole,
            style: (0, _extends3.default)({
              width: autoContainerWidth ? 'auto' : totalColumnsWidth,
              height: totalRowsHeight,
              maxWidth: totalColumnsWidth,
              maxHeight: totalRowsHeight,
              overflow: 'hidden',
              pointerEvents: isScrolling ? 'none' : '',
              position: 'relative'
            }, containerStyle) },
          childrenToDisplay
        ),
        showNoContentRenderer && noContentRenderer()
      );
    }

    /* ---------------------------- Helper methods ---------------------------- */

  }, {
    key: '_calculateChildrenToRender',
    value: function _calculateChildrenToRender() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var cellRenderer = props.cellRenderer,
          cellRangeRenderer = props.cellRangeRenderer,
          columnCount = props.columnCount,
          deferredMeasurementCache = props.deferredMeasurementCache,
          height = props.height,
          overscanColumnCount = props.overscanColumnCount,
          overscanIndicesGetter = props.overscanIndicesGetter,
          overscanRowCount = props.overscanRowCount,
          rowCount = props.rowCount,
          width = props.width,
          isScrollingOptOut = props.isScrollingOptOut;
      var scrollDirectionHorizontal = state.scrollDirectionHorizontal,
          scrollDirectionVertical = state.scrollDirectionVertical,
          instanceProps = state.instanceProps;


      var scrollTop = this._initialScrollTop > 0 ? this._initialScrollTop : state.scrollTop;
      var scrollLeft = this._initialScrollLeft > 0 ? this._initialScrollLeft : state.scrollLeft;

      var isScrolling = this._isScrolling(props, state);

      this._childrenToDisplay = [];

      // Render only enough columns and rows to cover the visible area of the grid.
      if (height > 0 && width > 0) {
        var visibleColumnIndices = instanceProps.columnSizeAndPositionManager.getVisibleCellRange({
          containerSize: width,
          offset: scrollLeft
        });
        var visibleRowIndices = instanceProps.rowSizeAndPositionManager.getVisibleCellRange({
          containerSize: height,
          offset: scrollTop
        });

        var horizontalOffsetAdjustment = instanceProps.columnSizeAndPositionManager.getOffsetAdjustment({
          containerSize: width,
          offset: scrollLeft
        });
        var verticalOffsetAdjustment = instanceProps.rowSizeAndPositionManager.getOffsetAdjustment({
          containerSize: height,
          offset: scrollTop
        });

        // Store for _invokeOnGridRenderedHelper()
        this._renderedColumnStartIndex = visibleColumnIndices.start;
        this._renderedColumnStopIndex = visibleColumnIndices.stop;
        this._renderedRowStartIndex = visibleRowIndices.start;
        this._renderedRowStopIndex = visibleRowIndices.stop;

        var overscanColumnIndices = overscanIndicesGetter({
          direction: 'horizontal',
          cellCount: columnCount,
          overscanCellsCount: overscanColumnCount,
          scrollDirection: scrollDirectionHorizontal,
          startIndex: typeof visibleColumnIndices.start === 'number' ? visibleColumnIndices.start : 0,
          stopIndex: typeof visibleColumnIndices.stop === 'number' ? visibleColumnIndices.stop : -1
        });

        var overscanRowIndices = overscanIndicesGetter({
          direction: 'vertical',
          cellCount: rowCount,
          overscanCellsCount: overscanRowCount,
          scrollDirection: scrollDirectionVertical,
          startIndex: typeof visibleRowIndices.start === 'number' ? visibleRowIndices.start : 0,
          stopIndex: typeof visibleRowIndices.stop === 'number' ? visibleRowIndices.stop : -1
        });

        // Store for _invokeOnGridRenderedHelper()
        var columnStartIndex = overscanColumnIndices.overscanStartIndex;
        var columnStopIndex = overscanColumnIndices.overscanStopIndex;
        var rowStartIndex = overscanRowIndices.overscanStartIndex;
        var rowStopIndex = overscanRowIndices.overscanStopIndex;

        // Advanced use-cases (eg CellMeasurer) require batched measurements to determine accurate sizes.
        if (deferredMeasurementCache) {
          // If rows have a dynamic height, scan the rows we are about to render.
          // If any have not yet been measured, then we need to render all columns initially,
          // Because the height of the row is equal to the tallest cell within that row,
          // (And so we can't know the height without measuring all column-cells first).
          if (!deferredMeasurementCache.hasFixedHeight()) {
            for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
              if (!deferredMeasurementCache.has(rowIndex, 0)) {
                columnStartIndex = 0;
                columnStopIndex = columnCount - 1;
                break;
              }
            }
          }

          // If columns have a dynamic width, scan the columns we are about to render.
          // If any have not yet been measured, then we need to render all rows initially,
          // Because the width of the column is equal to the widest cell within that column,
          // (And so we can't know the width without measuring all row-cells first).
          if (!deferredMeasurementCache.hasFixedWidth()) {
            for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
              if (!deferredMeasurementCache.has(0, columnIndex)) {
                rowStartIndex = 0;
                rowStopIndex = rowCount - 1;
                break;
              }
            }
          }
        }

        this._childrenToDisplay = cellRangeRenderer({
          cellCache: this._cellCache,
          cellRenderer: cellRenderer,
          columnSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
          columnStartIndex: columnStartIndex,
          columnStopIndex: columnStopIndex,
          deferredMeasurementCache: deferredMeasurementCache,
          horizontalOffsetAdjustment: horizontalOffsetAdjustment,
          isScrolling: isScrolling,
          isScrollingOptOut: isScrollingOptOut,
          parent: this,
          rowSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
          rowStartIndex: rowStartIndex,
          rowStopIndex: rowStopIndex,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          styleCache: this._styleCache,
          verticalOffsetAdjustment: verticalOffsetAdjustment,
          visibleColumnIndices: visibleColumnIndices,
          visibleRowIndices: visibleRowIndices
        });

        // update the indices
        this._columnStartIndex = columnStartIndex;
        this._columnStopIndex = columnStopIndex;
        this._rowStartIndex = rowStartIndex;
        this._rowStopIndex = rowStopIndex;
      }
    }

    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Grid.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */

  }, {
    key: '_debounceScrollEnded',
    value: function _debounceScrollEnded() {
      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;


      if (this._disablePointerEventsTimeoutId) {
        (0, _requestAnimationTimeout.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
      }

      this._disablePointerEventsTimeoutId = (0, _requestAnimationTimeout.requestAnimationTimeout)(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
    }
  }, {
    key: '_handleInvalidatedGridSize',


    /**
     * Check for batched CellMeasurer size invalidations.
     * This will occur the first time one or more previously unmeasured cells are rendered.
     */
    value: function _handleInvalidatedGridSize() {
      if (typeof this._deferredInvalidateColumnIndex === 'number' && typeof this._deferredInvalidateRowIndex === 'number') {
        var columnIndex = this._deferredInvalidateColumnIndex;
        var rowIndex = this._deferredInvalidateRowIndex;

        this._deferredInvalidateColumnIndex = null;
        this._deferredInvalidateRowIndex = null;

        this.recomputeGridSize({ columnIndex: columnIndex, rowIndex: rowIndex });
      }
    }
  }, {
    key: '_invokeOnScrollMemoizer',
    value: function _invokeOnScrollMemoizer(_ref6) {
      var _this3 = this;

      var scrollLeft = _ref6.scrollLeft,
          scrollTop = _ref6.scrollTop,
          totalColumnsWidth = _ref6.totalColumnsWidth,
          totalRowsHeight = _ref6.totalRowsHeight;

      this._onScrollMemoizer({
        callback: function callback(_ref7) {
          var scrollLeft = _ref7.scrollLeft,
              scrollTop = _ref7.scrollTop;
          var _props7 = _this3.props,
              height = _props7.height,
              onScroll = _props7.onScroll,
              width = _props7.width;


          onScroll({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalRowsHeight,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
            scrollWidth: totalColumnsWidth
          });
        },
        indices: {
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        }
      });
    }
  }, {
    key: '_isScrolling',
    value: function _isScrolling() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      // If isScrolling is defined in props, use it to override the value in state
      // This is a performance optimization for WindowScroller + Grid
      return Object.hasOwnProperty.call(props, 'isScrolling') ? Boolean(props.isScrolling) : Boolean(state.isScrolling);
    }
  }, {
    key: '_maybeCallOnScrollbarPresenceChange',
    value: function _maybeCallOnScrollbarPresenceChange() {
      if (this._scrollbarPresenceChanged) {
        var _onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;


        this._scrollbarPresenceChanged = false;

        _onScrollbarPresenceChange({
          horizontal: this._horizontalScrollBarSize > 0,
          size: this.state.instanceProps.scrollbarSize,
          vertical: this._verticalScrollBarSize > 0
        });
      }
    }
  }, {
    key: 'scrollToPosition',


    /**
     * Scroll to the specified offset(s).
     * Useful for animating position changes.
     */
    value: function scrollToPosition(_ref8) {
      var scrollLeft = _ref8.scrollLeft,
          scrollTop = _ref8.scrollTop;

      var stateUpdate = Grid._getScrollToPositionStateUpdate({
        prevState: this.state,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      });

      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }, {
    key: '_getCalculatedScrollLeft',
    value: function _getCalculatedScrollLeft() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      return Grid._getCalculatedScrollLeft(props, state);
    }
  }, {
    key: '_updateScrollLeftForScrollToColumn',
    value: function _updateScrollLeftForScrollToColumn() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      var stateUpdate = Grid._getScrollLeftForScrollToColumnStateUpdate(props, state);
      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }, {
    key: '_getCalculatedScrollTop',
    value: function _getCalculatedScrollTop() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      return Grid._getCalculatedScrollTop(props, state);
    }
  }, {
    key: '_resetStyleCache',
    value: function _resetStyleCache() {
      var styleCache = this._styleCache;
      var cellCache = this._cellCache;
      var isScrollingOptOut = this.props.isScrollingOptOut;

      // Reset cell and style caches once scrolling stops.
      // This makes Grid simpler to use (since cells commonly change).
      // And it keeps the caches from growing too large.
      // Performance is most sensitive when a user is scrolling.
      // Don't clear visible cells from cellCache if isScrollingOptOut is specified.
      // This keeps the cellCache to a resonable size.

      this._cellCache = {};
      this._styleCache = {};

      // Copy over the visible cell styles so avoid unnecessary re-render.
      for (var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++) {
        for (var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++) {
          var key = rowIndex + '-' + columnIndex;
          this._styleCache[key] = styleCache[key];

          if (isScrollingOptOut) {
            this._cellCache[key] = cellCache[key];
          }
        }
      }
    }
  }, {
    key: '_updateScrollTopForScrollToRow',
    value: function _updateScrollTopForScrollToRow() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      var stateUpdate = Grid._getScrollTopForScrollToRowStateUpdate(props, state);
      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var newState = {};
      var instanceProps = prevState.instanceProps;


      if (nextProps.columnCount === 0 && prevState.scrollLeft !== 0 || nextProps.rowCount === 0 && prevState.scrollTop !== 0) {
        newState.scrollLeft = 0;
        newState.scrollTop = 0;

        // only use scroll{Left,Top} from props if scrollTo{Column,Row} isn't specified
        // scrollTo{Column,Row} should override scroll{Left,Top}
      } else if (nextProps.scrollLeft !== instanceProps.prevScrollLeft && nextProps.scrollToColumn < 0 || nextProps.scrollTop !== instanceProps.prevScrollTop && nextProps.scrollToRow < 0) {
        (0, _assign2.default)(newState, Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: nextProps.scrollLeft,
          scrollTop: nextProps.scrollTop
        }));
      }

      // Initially we should not clearStyleCache
      newState.needToResetStyleCache = false;
      if (nextProps.columnWidth !== instanceProps.prevColumnWidth || nextProps.rowHeight !== instanceProps.prevRowHeight) {
        // Reset cache. set it to {} in render
        newState.needToResetStyleCache = true;
      }

      instanceProps.columnSizeAndPositionManager.configure({
        cellCount: nextProps.columnCount,
        estimatedCellSize: Grid._getEstimatedColumnSize(nextProps),
        cellSizeGetter: Grid._wrapSizeGetter(nextProps.columnWidth)
      });

      instanceProps.rowSizeAndPositionManager.configure({
        cellCount: nextProps.rowCount,
        estimatedCellSize: Grid._getEstimatedRowSize(nextProps),
        cellSizeGetter: Grid._wrapSizeGetter(nextProps.rowHeight)
      });

      if (instanceProps.prevColumnCount === 0 || instanceProps.prevRowCount === 0) {
        instanceProps.prevColumnCount = 0;
        instanceProps.prevRowCount = 0;
      }

      // If scrolling is controlled outside this component, clear cache when scrolling stops
      if (nextProps.autoHeight && nextProps.isScrolling === false && instanceProps.prevIsScrolling === true) {
        (0, _assign2.default)(newState, {
          isScrolling: false
        });
      }

      var maybeStateA = void 0;
      var maybeStateB = void 0;

      (0, _calculateSizeAndPositionDataAndUpdateScrollOffset2.default)({
        cellCount: instanceProps.prevColumnCount,
        cellSize: typeof instanceProps.prevColumnWidth === 'number' ? instanceProps.prevColumnWidth : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return instanceProps.columnSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.columnCount,
        nextCellSize: typeof nextProps.columnWidth === 'number' ? nextProps.columnWidth : null,
        nextScrollToIndex: nextProps.scrollToColumn,
        scrollToIndex: instanceProps.prevScrollToColumn,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          maybeStateA = Grid._getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState);
        }
      });
      (0, _calculateSizeAndPositionDataAndUpdateScrollOffset2.default)({
        cellCount: instanceProps.prevRowCount,
        cellSize: typeof instanceProps.prevRowHeight === 'number' ? instanceProps.prevRowHeight : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return instanceProps.rowSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.rowCount,
        nextCellSize: typeof nextProps.rowHeight === 'number' ? nextProps.rowHeight : null,
        nextScrollToIndex: nextProps.scrollToRow,
        scrollToIndex: instanceProps.prevScrollToRow,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          maybeStateB = Grid._getScrollTopForScrollToRowStateUpdate(nextProps, prevState);
        }
      });

      instanceProps.prevColumnCount = nextProps.columnCount;
      instanceProps.prevColumnWidth = nextProps.columnWidth;
      instanceProps.prevIsScrolling = nextProps.isScrolling === true;
      instanceProps.prevRowCount = nextProps.rowCount;
      instanceProps.prevRowHeight = nextProps.rowHeight;
      instanceProps.prevScrollToColumn = nextProps.scrollToColumn;
      instanceProps.prevScrollToRow = nextProps.scrollToRow;
      instanceProps.prevScrollLeft = nextProps.scrollLeft;
      instanceProps.prevScrollTop = nextProps.scrollTop;

      // getting scrollBarSize (moved from componentWillMount)
      instanceProps.scrollbarSize = nextProps.getScrollbarSize();
      if (instanceProps.scrollbarSize === undefined) {
        instanceProps.scrollbarSizeMeasured = false;
        instanceProps.scrollbarSize = 0;
      } else {
        instanceProps.scrollbarSizeMeasured = true;
      }

      newState.instanceProps = instanceProps;

      return (0, _extends3.default)({}, newState, maybeStateA, maybeStateB);
    }
  }, {
    key: '_getEstimatedColumnSize',
    value: function _getEstimatedColumnSize(props) {
      return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
    }
  }, {
    key: '_getEstimatedRowSize',
    value: function _getEstimatedRowSize(props) {
      return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
    }
  }, {
    key: '_getScrollToPositionStateUpdate',


    /**
     * Get the updated state after scrolling to
     * scrollLeft and scrollTop
     */
    value: function _getScrollToPositionStateUpdate(_ref9) {
      var prevState = _ref9.prevState,
          scrollLeft = _ref9.scrollLeft,
          scrollTop = _ref9.scrollTop;

      var newState = {
        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
      };

      if (typeof scrollLeft === 'number' && scrollLeft >= 0) {
        newState.scrollDirectionHorizontal = scrollLeft > prevState.scrollLeft ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD;
        newState.scrollLeft = scrollLeft;
      }

      if (typeof scrollTop === 'number' && scrollTop >= 0) {
        newState.scrollDirectionVertical = scrollTop > prevState.scrollTop ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD;
        newState.scrollTop = scrollTop;
      }

      if (typeof scrollLeft === 'number' && scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft || typeof scrollTop === 'number' && scrollTop >= 0 && scrollTop !== prevState.scrollTop) {
        return newState;
      }
      return null;
    }
  }, {
    key: '_wrapSizeGetter',
    value: function _wrapSizeGetter(value) {
      return typeof value === 'function' ? value : function () {
        return value;
      };
    }
  }, {
    key: '_getCalculatedScrollLeft',
    value: function _getCalculatedScrollLeft(nextProps, prevState) {
      var columnCount = nextProps.columnCount,
          height = nextProps.height,
          scrollToAlignment = nextProps.scrollToAlignment,
          scrollToColumn = nextProps.scrollToColumn,
          width = nextProps.width;
      var scrollLeft = prevState.scrollLeft,
          instanceProps = prevState.instanceProps;


      if (columnCount > 0) {
        var finalColumn = columnCount - 1;
        var targetIndex = scrollToColumn < 0 ? finalColumn : Math.min(finalColumn, scrollToColumn);
        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalRowsHeight > height ? instanceProps.scrollbarSize : 0;

        return instanceProps.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: width - scrollBarSize,
          currentOffset: scrollLeft,
          targetIndex: targetIndex
        });
      }
      return 0;
    }
  }, {
    key: '_getScrollLeftForScrollToColumnStateUpdate',
    value: function _getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState) {
      var scrollLeft = prevState.scrollLeft;

      var calculatedScrollLeft = Grid._getCalculatedScrollLeft(nextProps, prevState);

      if (typeof calculatedScrollLeft === 'number' && calculatedScrollLeft >= 0 && scrollLeft !== calculatedScrollLeft) {
        return Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: calculatedScrollLeft,
          scrollTop: -1
        });
      }
      return null;
    }
  }, {
    key: '_getCalculatedScrollTop',
    value: function _getCalculatedScrollTop(nextProps, prevState) {
      var height = nextProps.height,
          rowCount = nextProps.rowCount,
          scrollToAlignment = nextProps.scrollToAlignment,
          scrollToRow = nextProps.scrollToRow,
          width = nextProps.width;
      var scrollTop = prevState.scrollTop,
          instanceProps = prevState.instanceProps;


      if (rowCount > 0) {
        var finalRow = rowCount - 1;
        var targetIndex = scrollToRow < 0 ? finalRow : Math.min(finalRow, scrollToRow);
        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;

        return instanceProps.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: height - scrollBarSize,
          currentOffset: scrollTop,
          targetIndex: targetIndex
        });
      }
      return 0;
    }
  }, {
    key: '_getScrollTopForScrollToRowStateUpdate',
    value: function _getScrollTopForScrollToRowStateUpdate(nextProps, prevState) {
      var scrollTop = prevState.scrollTop;

      var calculatedScrollTop = Grid._getCalculatedScrollTop(nextProps, prevState);

      if (typeof calculatedScrollTop === 'number' && calculatedScrollTop >= 0 && scrollTop !== calculatedScrollTop) {
        return Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: -1,
          scrollTop: calculatedScrollTop
        });
      }
      return null;
    }
  }]);
  return Grid;
}(React.PureComponent);

Grid.defaultProps = {
  'aria-label': 'grid',
  'aria-readonly': true,
  autoContainerWidth: false,
  autoHeight: false,
  autoWidth: false,
  cellRangeRenderer: _defaultCellRangeRenderer2.default,
  containerRole: 'rowgroup',
  containerStyle: {},
  estimatedColumnSize: 100,
  estimatedRowSize: 30,
  getScrollbarSize: _scrollbarSize2.default,
  noContentRenderer: renderNull,
  onScroll: function onScroll() {},
  onScrollbarPresenceChange: function onScrollbarPresenceChange() {},
  onSectionRendered: function onSectionRendered() {},
  overscanColumnCount: 0,
  overscanIndicesGetter: _defaultOverscanIndicesGetter2.default,
  overscanRowCount: 10,
  role: 'grid',
  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
  scrollToAlignment: 'auto',
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  tabIndex: 0,
  isScrollingOptOut: false
};
Grid.propTypes =  true ? null : {
  "aria-label": _propTypes2.default.string.isRequired,
  "aria-readonly": _propTypes2.default.bool,


  /**
   * Set the width of the inner scrollable container to 'auto'.
   * This is useful for single-column Grids to ensure that the column doesn't extend below a vertical scrollbar.
   */
  autoContainerWidth: _propTypes2.default.bool.isRequired,


  /**
   * Removes fixed height from the scrollingContainer so that the total height of rows can stretch the window.
   * Intended for use with WindowScroller
   */
  autoHeight: _propTypes2.default.bool.isRequired,


  /**
   * Removes fixed width from the scrollingContainer so that the total width of rows can stretch the window.
   * Intended for use with WindowScroller
   */
  autoWidth: _propTypes2.default.bool.isRequired,


  /** Responsible for rendering a cell given an row and column index.  */
  cellRenderer: function cellRenderer() {
    return (typeof _types.bpfrpt_proptype_CellRenderer === 'function' ? _types.bpfrpt_proptype_CellRenderer.isRequired ? _types.bpfrpt_proptype_CellRenderer.isRequired : _types.bpfrpt_proptype_CellRenderer : _propTypes2.default.shape(_types.bpfrpt_proptype_CellRenderer).isRequired).apply(this, arguments);
  },


  /** Responsible for rendering a group of cells given their index ranges.  */
  cellRangeRenderer: function cellRangeRenderer() {
    return (typeof _types.bpfrpt_proptype_CellRangeRenderer === 'function' ? _types.bpfrpt_proptype_CellRangeRenderer.isRequired ? _types.bpfrpt_proptype_CellRangeRenderer.isRequired : _types.bpfrpt_proptype_CellRangeRenderer : _propTypes2.default.shape(_types.bpfrpt_proptype_CellRangeRenderer).isRequired).apply(this, arguments);
  },


  /** Optional custom CSS class name to attach to root Grid element.  */
  className: _propTypes2.default.string,


  /** Number of columns in grid.  */
  columnCount: _propTypes2.default.number.isRequired,


  /** Either a fixed column width (number) or a function that returns the width of a column given its index.  */
  columnWidth: function columnWidth() {
    return (typeof _types.bpfrpt_proptype_CellSize === 'function' ? _types.bpfrpt_proptype_CellSize.isRequired ? _types.bpfrpt_proptype_CellSize.isRequired : _types.bpfrpt_proptype_CellSize : _propTypes2.default.shape(_types.bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
  },


  /** Unfiltered props for the Grid container. */
  containerProps: _propTypes2.default.object,


  /** ARIA role for the cell-container.  */
  containerRole: _propTypes2.default.string.isRequired,


  /** Optional inline style applied to inner cell-container */
  containerStyle: _propTypes2.default.object.isRequired,


  /**
   * If CellMeasurer is used to measure this Grid's children, this should be a pointer to its CellMeasurerCache.
   * A shared CellMeasurerCache reference enables Grid and CellMeasurer to share measurement data.
   */
  deferredMeasurementCache: _propTypes2.default.object,


  /**
   * Used to estimate the total width of a Grid before all of its columns have actually been measured.
   * The estimated total width is adjusted as columns are rendered.
   */
  estimatedColumnSize: _propTypes2.default.number.isRequired,


  /**
   * Used to estimate the total height of a Grid before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: _propTypes2.default.number.isRequired,


  /** Exposed for testing purposes only.  */
  getScrollbarSize: _propTypes2.default.func.isRequired,


  /** Height of Grid; this property determines the number of visible (vs virtualized) rows.  */
  height: _propTypes2.default.number.isRequired,


  /** Optional custom id to attach to root Grid element.  */
  id: _propTypes2.default.string,


  /**
   * Override internal is-scrolling state tracking.
   * This property is primarily intended for use with the WindowScroller component.
   */
  isScrolling: _propTypes2.default.bool,


  /**
   * Opt-out of isScrolling param passed to cellRangeRenderer.
   * To avoid the extra render when scroll stops.
   */
  isScrollingOptOut: _propTypes2.default.bool.isRequired,


  /** Optional renderer to be used in place of rows when either :rowCount or :columnCount is 0.  */
  noContentRenderer: function noContentRenderer() {
    return (typeof _types.bpfrpt_proptype_NoContentRenderer === 'function' ? _types.bpfrpt_proptype_NoContentRenderer.isRequired ? _types.bpfrpt_proptype_NoContentRenderer.isRequired : _types.bpfrpt_proptype_NoContentRenderer : _propTypes2.default.shape(_types.bpfrpt_proptype_NoContentRenderer).isRequired).apply(this, arguments);
  },


  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   */
  onScroll: _propTypes2.default.func.isRequired,


  /**
   * Called whenever a horizontal or vertical scrollbar is added or removed.
   * This prop is not intended for end-user use;
   * It is used by MultiGrid to support fixed-row/fixed-column scroll syncing.
   */
  onScrollbarPresenceChange: _propTypes2.default.func.isRequired,


  /** Callback invoked with information about the section of the Grid that was just rendered.  */
  onSectionRendered: _propTypes2.default.func.isRequired,


  /**
   * Number of columns to render before/after the visible section of the grid.
   * These columns can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   */
  overscanColumnCount: _propTypes2.default.number.isRequired,


  /**
   * Calculates the number of cells to overscan before and after a specified range.
   * This function ensures that overscanning doesn't exceed the available cells.
   */
  overscanIndicesGetter: function overscanIndicesGetter() {
    return (typeof _types.bpfrpt_proptype_OverscanIndicesGetter === 'function' ? _types.bpfrpt_proptype_OverscanIndicesGetter.isRequired ? _types.bpfrpt_proptype_OverscanIndicesGetter.isRequired : _types.bpfrpt_proptype_OverscanIndicesGetter : _propTypes2.default.shape(_types.bpfrpt_proptype_OverscanIndicesGetter).isRequired).apply(this, arguments);
  },


  /**
   * Number of rows to render above/below the visible section of the grid.
   * These rows can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   */
  overscanRowCount: _propTypes2.default.number.isRequired,


  /** ARIA role for the grid element.  */
  role: _propTypes2.default.string.isRequired,


  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * Should implement the following interface: ({ index: number }): number
   */
  rowHeight: function rowHeight() {
    return (typeof _types.bpfrpt_proptype_CellSize === 'function' ? _types.bpfrpt_proptype_CellSize.isRequired ? _types.bpfrpt_proptype_CellSize.isRequired : _types.bpfrpt_proptype_CellSize : _propTypes2.default.shape(_types.bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
  },


  /** Number of rows in grid.  */
  rowCount: _propTypes2.default.number.isRequired,


  /** Wait this amount of time after the last scroll event before resetting Grid `pointer-events`. */
  scrollingResetTimeInterval: _propTypes2.default.number.isRequired,


  /** Horizontal offset. */
  scrollLeft: _propTypes2.default.number,


  /**
   * Controls scroll-to-cell behavior of the Grid.
   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
   */
  scrollToAlignment: function scrollToAlignment() {
    return (typeof _types.bpfrpt_proptype_Alignment === 'function' ? _types.bpfrpt_proptype_Alignment.isRequired ? _types.bpfrpt_proptype_Alignment.isRequired : _types.bpfrpt_proptype_Alignment : _propTypes2.default.shape(_types.bpfrpt_proptype_Alignment).isRequired).apply(this, arguments);
  },


  /** Column index to ensure visible (by forcefully scrolling if necessary) */
  scrollToColumn: _propTypes2.default.number.isRequired,


  /** Vertical offset. */
  scrollTop: _propTypes2.default.number,


  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  scrollToRow: _propTypes2.default.number.isRequired,


  /** Optional inline style */
  style: _propTypes2.default.object.isRequired,


  /** Tab index for focus */
  tabIndex: _propTypes2.default.number,


  /** Width of Grid; this property determines the number of visible (vs virtualized) columns.  */
  width: _propTypes2.default.number.isRequired
};


(0, _reactLifecyclesCompat.polyfill)(Grid);
exports.default = Grid;

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calculateSizeAndPositionDataAndUpdateScrollOffset;
function calculateSizeAndPositionDataAndUpdateScrollOffset(_ref) {
  var cellCount = _ref.cellCount,
      cellSize = _ref.cellSize,
      computeMetadataCallback = _ref.computeMetadataCallback,
      computeMetadataCallbackProps = _ref.computeMetadataCallbackProps,
      nextCellsCount = _ref.nextCellsCount,
      nextCellSize = _ref.nextCellSize,
      nextScrollToIndex = _ref.nextScrollToIndex,
      scrollToIndex = _ref.scrollToIndex,
      updateScrollOffsetForScrollToIndex = _ref.updateScrollOffsetForScrollToIndex;

  // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
  // In that event users should use the manual recompute methods to inform of changes.
  if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
    computeMetadataCallback(computeMetadataCallbackProps);

    // Updated cell metadata may have hidden the previous scrolled-to item.
    // In this case we should also update the scrollTop to ensure it stays visible.
    if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) {
      updateScrollOffsetForScrollToIndex();
    }
  }
}

/**
 * Helper method that determines when to recalculate row or column metadata.
 */

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(122);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(123);

var _createClass3 = _interopRequireDefault(_createClass2);

var _linearLayoutVector = __webpack_require__(1049);

var _linearLayoutVector2 = _interopRequireDefault(_linearLayoutVector);

var _types = __webpack_require__(72);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Just-in-time calculates and caches size and position information for a collection of cells.
 */

var CellSizeAndPositionManager = function () {

  // Measurements for cells up to this index can be trusted; cells afterward should be estimated.
  function CellSizeAndPositionManager(_ref) {
    var cellCount = _ref.cellCount,
        cellSizeGetter = _ref.cellSizeGetter,
        estimatedCellSize = _ref.estimatedCellSize;
    (0, _classCallCheck3.default)(this, CellSizeAndPositionManager);
    this._lastMeasuredIndex = -1;

    this._cellSizeGetter = cellSizeGetter;
    this._cellCount = cellCount;
    this._estimatedCellSize = estimatedCellSize;
    this._layoutVector = new _linearLayoutVector2.default();
    this._layoutVector.setLength(cellCount);
    this._layoutVector.setDefaultSize(estimatedCellSize);
  }
  // Cache of size and position data for cells, mapped by cell index.
  // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex


  (0, _createClass3.default)(CellSizeAndPositionManager, [{
    key: 'areOffsetsAdjusted',
    value: function areOffsetsAdjusted() {
      return false;
    }
  }, {
    key: 'configure',
    value: function configure(_ref2) {
      var cellCount = _ref2.cellCount,
          estimatedCellSize = _ref2.estimatedCellSize,
          cellSizeGetter = _ref2.cellSizeGetter;

      this._cellCount = cellCount;
      this._estimatedCellSize = estimatedCellSize;
      this._cellSizeGetter = cellSizeGetter;
      this._layoutVector.setLength(cellCount);
      this._layoutVector.setDefaultSize(estimatedCellSize);
    }
  }, {
    key: 'getCellCount',
    value: function getCellCount() {
      return this._cellCount;
    }
  }, {
    key: 'getEstimatedCellSize',
    value: function getEstimatedCellSize() {
      return this._estimatedCellSize;
    }
  }, {
    key: 'getLastMeasuredIndex',
    value: function getLastMeasuredIndex() {
      return this._lastMeasuredIndex;
    }
  }, {
    key: 'getOffsetAdjustment',
    value: function getOffsetAdjustment() {
      return 0;
    }

    /**
     * This method returns the size and position for the cell at the specified index.
     * It just-in-time calculates (or used cached values) for cells leading up to the index.
     */

  }, {
    key: 'getSizeAndPositionOfCell',
    value: function getSizeAndPositionOfCell(index) {
      if (index < 0 || index >= this._cellCount) {
        throw Error('Requested index ' + index + ' is outside of range 0..' + this._cellCount);
      }
      var vector = this._layoutVector;
      if (index > this._lastMeasuredIndex) {
        var token = { index: this._lastMeasuredIndex + 1 };

        for (var i = token.index; i <= index; token.index = ++i) {
          var _size = this._cellSizeGetter(token);
          // undefined or NaN probably means a logic error in the size getter.
          // null means we're using CellMeasurer and haven't yet measured a given index.
          if (_size === undefined || _size !== _size) {
            throw Error('Invalid size returned for cell ' + i + ' of value ' + _size);
          } else if (_size !== null) {
            vector.setItemSize(i, _size);
          }
        }
        this._lastMeasuredIndex = Math.min(index, this._cellCount - 1);
      }

      return {
        offset: vector.start(index),
        size: vector.getItemSize(index)
      };
    }
  }, {
    key: 'getSizeAndPositionOfLastMeasuredCell',
    value: function getSizeAndPositionOfLastMeasuredCell() {
      var index = this._lastMeasuredIndex;
      if (index <= 0) {
        return {
          offset: 0,
          size: 0
        };
      }
      var vector = this._layoutVector;
      return {
        offset: vector.start(index),
        size: vector.getItemSize(index)
      };
    }

    /**
     * Total size of all cells being measured.
     * This value will be completely estimated initially.
     * As cells are measured, the estimate will be updated.
     */

  }, {
    key: 'getTotalSize',
    value: function getTotalSize() {
      var lastIndex = this._cellCount - 1;
      return lastIndex >= 0 ? this._layoutVector.end(lastIndex) : 0;
    }

    /**
     * Determines a new offset that ensures a certain cell is visible, given the current offset.
     * If the cell is already visible then the current offset will be returned.
     * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
     *
     * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
     * @param containerSize Size (width or height) of the container viewport
     * @param currentOffset Container's current (x or y) offset
     * @param totalSize Total size (width or height) of all cells
     * @return Offset to use to ensure the specified cell is visible
     */

  }, {
    key: 'getUpdatedOffsetForIndex',
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align,
          align = _ref3$align === undefined ? 'auto' : _ref3$align,
          containerSize = _ref3.containerSize,
          currentOffset = _ref3.currentOffset,
          targetIndex = _ref3.targetIndex;

      if (containerSize <= 0) {
        return 0;
      }

      var datum = this.getSizeAndPositionOfCell(targetIndex);
      var maxOffset = datum.offset;
      var minOffset = maxOffset - containerSize + datum.size;

      var idealOffset = void 0;

      switch (align) {
        case 'start':
          idealOffset = maxOffset;
          break;
        case 'end':
          idealOffset = minOffset;
          break;
        case 'center':
          idealOffset = maxOffset - (containerSize - datum.size) / 2;
          break;
        default:
          idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
          break;
      }

      var totalSize = this.getTotalSize();

      return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
    }
  }, {
    key: 'getVisibleCellRange',
    value: function getVisibleCellRange(params) {
      if (this.getTotalSize() === 0) {
        return {};
      }

      var containerSize = params.containerSize,
          offset = params.offset;

      var maxOffset = offset + containerSize - 1;
      return {
        start: this._findNearestCell(offset),
        stop: this._findNearestCell(maxOffset)
      };
    }

    /**
     * Clear all cached values for cells after the specified index.
     * This method should be called for any cell that has changed its size.
     * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionOfCell() is called.
     */

  }, {
    key: 'resetCell',
    value: function resetCell(index) {
      this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
    }

    /**
     * Searches for the cell (index) nearest the specified offset.
     *
     * If no exact match is found the next lowest cell index will be returned.
     * This allows partially visible cells (with offsets just before/above the fold) to be visible.
     */

  }, {
    key: '_findNearestCell',
    value: function _findNearestCell(offset) {
      if (isNaN(offset)) {
        throw Error('Invalid offset ' + offset + ' specified');
      }

      var vector = this._layoutVector;
      var lastIndex = this._cellCount - 1;
      // Our search algorithms find the nearest match at or below the specified offset.
      // So make sure the offset is at least 0 or no match will be found.
      var targetOffset = Math.max(0, Math.min(offset, vector.start(lastIndex)));
      // First interrogate the constant-time lookup table
      var nearestCellIndex = vector.indexOf(targetOffset);

      // If we haven't yet measured this high, compute sizes for each cell up to the desired offset.
      while (nearestCellIndex > this._lastMeasuredIndex) {
        // Measure all the cells up to the one we want to find presently.
        // Do this before the last-index check to ensure the sparse array
        // is fully populated.
        this.getSizeAndPositionOfCell(nearestCellIndex);
        // No need to search and compare again if we're at the end.
        if (nearestCellIndex === lastIndex) {
          return nearestCellIndex;
        }
        nearestCellIndex = vector.indexOf(targetOffset);
        // Guard in case `getSizeAndPositionOfCell` didn't fully measure to
        // the nearestCellIndex. This might happen scrolling quickly down
        // and back up on large lists -- possible race with React or DOM?
        if (nearestCellIndex === -1) {
          nearestCellIndex = this._lastMeasuredIndex;
          this._lastMeasuredIndex = nearestCellIndex - 1;
          targetOffset = Math.max(0, Math.min(offset, vector.start(lastIndex)));
        }
      }

      return nearestCellIndex;
    }
  }]);
  return CellSizeAndPositionManager;
}();

exports.default = CellSizeAndPositionManager;

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

module.exports = LinearLayoutVector;

LinearLayoutVector.prototype.getLength = getLength;
LinearLayoutVector.prototype.setLength = setLength;
LinearLayoutVector.prototype.getDefaultSize = getDefaultSize;
LinearLayoutVector.prototype.setDefaultSize = setDefaultSize;
LinearLayoutVector.prototype.getAxisOffset = getAxisOffset;
LinearLayoutVector.prototype.setAxisOffset = setAxisOffset;
LinearLayoutVector.prototype.getGap = getGap;
LinearLayoutVector.prototype.setGap = setGap;
LinearLayoutVector.prototype.getItemSize = getItemSize;
LinearLayoutVector.prototype.setItemSize = setItemSize;
LinearLayoutVector.prototype.insert = insert;
LinearLayoutVector.prototype.remove = remove;
LinearLayoutVector.prototype.start = start;
LinearLayoutVector.prototype.end = end;
LinearLayoutVector.prototype.indexOf = indexOf;
LinearLayoutVector.prototype.clear = clear;
LinearLayoutVector.prototype.toString = toString;

/**
 * A sparse array of sizes that represent items in a dimension.
 *
 * Provides efficient support for finding the cumulative distance to
 * the start/end of an item along the axis, and similarly for finding the
 * index of the item at a particular distance.
 *
 * Default size is used for items whose size hasn't been specified.
 */
function LinearLayoutVector(block_size) {

    if(block_size === undefined) {
        block_size = 128;
    }

    // Assumption: vector elements (sizes) will typically be set in
    // small ranges that reflect localized scrolling.  Allocate vector
    // elements in blocks of block_size, which must be a power of 2.
    // block_shift is the power of 2 and block_mask masks off as many
    // low order bits.  The block_table contains all of the allocated
    // blocks and has length/block_size elements which are allocated lazily.
    var pow = (Math.log(block_size) / Math.log(2)) | 0,
        size = Math.pow(2, pow),
        mask = size - 1;

    this.block_size  = size;
    this.block_shift = pow;
    this.block_mask  = mask;
    this.block_table = [];

    this._defaultSize = 0;
    this._axisOffset = 0;
    this._gap = 0;

    // Sorted Vector of intervals for the pending removes, in descending order,
    // for example [7, 5, 3, 1] for the removes at 7, 6, 5, 3, 2, 1
    this.removes = null;
    // Sorted Vector of intervals for the pending inserts, in ascending order,
    // for example [1, 3, 5, 7] for the inserts at 1, 2, 3, 5, 6, 7
    this.inserts = null;

    this._length = 0;
    // What the length will be after any pending changes are flushed.
    this._pendingLength = -1;
}

/**
 * The number of item size valued elements.
 *
 * @default 0
 */
function getLength() {
    return this._pendingLength === -1 ? this._length : this._pendingLength;
}

/**
 * @private
 * Grows or truncates the vector to be the specified newLength.
 * When truncating, releases empty blocks and sets to NaN any values
 * in the last block beyond the newLength.
 */
function setLength(newLength) {
    flushPendingChanges.call(this);

    if(newLength < this._length) {
        // Clear any remaining non-NaN values in the last block
        var blockIndex = newLength >> this.block_shift;
        var endIndex = Math.min(blockIndex * this.block_size + this.block_size, this._length) - 1;
        clearInterval.call(this, newLength, endIndex);
    }

    this._length = newLength;

    // update the table
    var partialBlock = ((this._length & this.block_mask) === 0) ? 0 : 1;
    this.block_table.length = (this._length >> this.block_shift) + partialBlock;
}

//----------------------------------
//  defaultSize
//----------------------------------

/**
 * The size of items whose size was not specified with setItemSize.
 *
 * @default 0
 */
function getDefaultSize() {
    return this._defaultSize;
}

/**
 * @private
 */
function setDefaultSize(value) {
    this._defaultSize = value;
}

//----------------------------------
//  axisOffset
//----------------------------------

/**
 * The offset of the first item from the origin in the majorAxis
 * direction. This is useful when implementing padding,
 * in addition to gaps, for virtual layouts.
 *
 * @see #gap
 */
function getAxisOffset() {
    return this._axisOffset;
}

/**
 * @private
 */
function setAxisOffset(value) {
    this._axisOffset = value;
}

//----------------------------------
//  gap
//----------------------------------

/**
 * The distance between items.
 *
 * @default 0
 */
function getGap() {
    return this._gap;
}

/**
 * @private
 */
function setGap(value) {
    this._gap = value;
}

//--------------------------------------------------------------------------
//
//  Methods
//
//--------------------------------------------------------------------------

/**
 * Return the size of the item at index.  If no size was ever
 * specified then then the defaultSize is returned.
 *
 * @param index The item's index.
 * @see defaultSize
 */
function getItemSize(index) {
    flushPendingChanges.call(this);

    var block = this.block_table[index >> this.block_shift];
    if(block) {
        var value = block.sizes[index & this.block_mask];
        return (value !== value) ? this._defaultSize : value;
    } else {
        return this._defaultSize;
    }
}

/**
 * Set the size of the item at index. If an index is
 * set to <code>NaN</code> then subsequent calls to get
 * will return the defaultSize.
 *
 * @param index The item's index.
 * @param value The item's size.
 * @see defaultSize
 */
function setItemSize(index, value) {
    flushPendingChanges.call(this);

    if(index >= this.getLength()) {
        throw new Error("Invalid index and all that.");
    }

    var blockIndex = index >> this.block_shift;
    var block = this.block_table[blockIndex];
    if(!block) {
        block = this.block_table[blockIndex] = new Block(this.block_size);
    }

    var sizesIndex = index & this.block_mask;
    var sizes = block.sizes;
    var oldValue = sizes[sizesIndex];
    if(oldValue === value) {
        return;
    }

    if(oldValue !== oldValue) {
        block.defaultCount -= 1;
        block.sizesSum += value;
    } else if(value !== value) {
        block.defaultCount += 1;
        block.sizesSum -= oldValue;
    } else {
        block.sizesSum += value - oldValue;
    }

    sizes[sizesIndex] = value;
}

/**
 * Make room for a new item at index by shifting all of the sizes
 * one position to the right, beginning with startIndex.
 *
 * The value at index will be NaN.
 *
 * This is similar to array.splice(index, 0, NaN).
 *
 * @param index The position of the new NaN size item.
 */
function insert(index) {
    // We don't support interleaved pending inserts and removes
    if(this.removes) {
        flushPendingChanges.call(this);
    }

    if(this.inserts) {
        // Update the last interval or add a new one?
        var lastIndex = this.inserts.length - 1;
        var intervalEnd = this.inserts[lastIndex];

        if(index === intervalEnd + 1) {
            // Extend the end of the interval
            this.inserts[lastIndex] = index;
        } else if(index > intervalEnd) {
            // New interval
            this.inserts.push(index);
            this.inserts.push(index);
        } else {
            // We can't support pending inserts that are not ascending
            flushPendingChanges.call(this);
        }
    }

    this._pendingLength = Math.max(this._length, index + 1);

    if(!this.inserts) {
        this.inserts = [];
        this.inserts.push(index);
        this.inserts.push(index);
    }
}

/**
 * Remove index by shifting all of the sizes one position to the left,
 * begining with index+1.
 *
 * This is similar to array.splice(index, 1).
 *
 * @param index The position to be removed.
 */
function remove(index) {
    // We don't support interleaved pending inserts and removes
    if(this.inserts) {
        flushPendingChanges.call(this);
    }

    // length getter takes into account pending inserts/removes but doesn't flush
    if(index >= this.getLength()) {
        throw new Error("Invalid index and all that.");
    }

    if(this.removes) {
        // Update the last interval or add a new one?
        var lastIndex = this.removes.length - 1;
        var intervalStart = this.removes[lastIndex];

        if(index === intervalStart - 1) {
            // Extend the start of the interval
            this.removes[lastIndex] = index;
        } else if(index < intervalStart) {
            // New interval
            this.removes.push(index);
            this.removes.push(index);
        } else {
            // We can't support pending removes that are not descending
            flushPendingChanges.call(this);
        }
    }

    this._pendingLength = (this._pendingLength === -1) ? length - 1 : this._pendingLength - 1;

    if(!this.removes) {
        this.removes = [];
        this.removes.push(index);
        this.removes.push(index);
    }
}

/**
 * @private
 * Returns true when all sizes in the specified interval for the block are NaN
 */
function isIntervalClear(block, index, count) {
    var sizes = block.sizes, size;
    for(count += index; index < count; ++index) {
        if((size = sizes[index]) === size) {
            return false;
        }
    }
    return true;
}

/**
 * @private
 * Copies elements between blocks. Indices relative to the blocks.
 * If srcBlock is null, then it fills the destination with NaNs.
 * The case of srcBlock === dstBlock is also supported.
 * The caller must ensure that count is within range.
 */
function inBlockCopy(dstBlock, dstIndexStart, srcBlock, srcIndexStart, count) {
    var ascending = dstIndexStart < srcIndexStart;

    var srcIndex = ascending ? srcIndexStart : srcIndexStart + count - 1;
    var dstIndex = ascending ? dstIndexStart : dstIndexStart + count - 1;
    var increment = ascending ? +1 : -1;

    var dstSizes = dstBlock.sizes;
    var srcSizes = srcBlock ? srcBlock.sizes : null;
    var dstValue = NaN;
    var srcValue = NaN;
    var sizesSumDelta = 0; // How much the destination sizesSum will change
    var defaultCountDelta = 0; // How much the destination defaultCount will change

    while(count > 0) {
        if(srcSizes) {
            srcValue = srcSizes[srcIndex];
        }

        dstValue = dstSizes[dstIndex];

        // Are the values different?
        if(srcValue !== dstValue) { // Triple '=' to handle NaN comparison

            // Are we removing a default size or a chached size?
            if(dstValue !== dstValue) {
                defaultCountDelta--;
            } else {
                sizesSumDelta -= dstValue;
            }

            // Are we adding a default size or a cached size?
            if(srcValue !== srcValue) {
                defaultCountDelta++;
            } else {
                sizesSumDelta += srcValue;
            }

            dstSizes[dstIndex] = srcValue;
        }

        srcIndex += increment;
        dstIndex += increment;
        count--;
    }

    dstBlock.sizesSum += sizesSumDelta;
    dstBlock.defaultCount += defaultCountDelta;
}

/**
 * @private
 * Copies 'count' elements from dstIndex to srcIndex.
 * Safe for overlapping source and destination intervals.
 * If any blocks are left full of NaNs, they will be deallcated.
 */
function copyInterval(dstIndex, srcIndex, count) {
    var ascending = dstIndex < srcIndex;
    if(!ascending) {
        dstIndex += count - 1;
        srcIndex += count - 1;
    }

    while(count > 0) {
        // Figure out destination block
        var dstBlockIndex = dstIndex >> this.block_shift;
        var dstSizesIndex = dstIndex & this.block_mask;
        var dstBlock = this.block_table[dstBlockIndex];

        // Figure out source block
        var srcBlockIndex = srcIndex >> this.block_shift;
        var srcSizesIndex = srcIndex & this.block_mask;
        var srcBlock = this.block_table[srcBlockIndex];

        // Figure out number of elements to copy
        var copyCount = ascending ?
            Math.min(this.block_size - dstSizesIndex, this.block_size - srcSizesIndex) :
            1 + Math.min(dstSizesIndex, srcSizesIndex);

        copyCount = Math.min(copyCount, count);

        // Figure out the start index for each block
        var dstStartIndex = ascending ? dstSizesIndex : dstSizesIndex - copyCount + 1;
        var srcStartIndex = ascending ? srcSizesIndex : srcSizesIndex - copyCount + 1;

        // Check whether a destination block needs to be allocated.
        // Allocate only if there are non-default values to be copied from the source.
        if(srcBlock && !dstBlock && isIntervalClear(srcBlock, srcStartIndex, copyCount)) {
            dstBlock = new Block(this.block_size);
            this.block_table[dstBlockIndex] = dstBlock;
        }

        // Copy to non-null dstBlock, srcBlock can be null
        if(dstBlock) {
            inBlockCopy(dstBlock, dstStartIndex, srcBlock, srcStartIndex, copyCount);

            // If this is the last time we're visiting this block, and it contains
            // only NaNs, then remove it
            if(dstBlock.defaultCount === this.block_size) {
                var blockEndReached = ascending ?
                    (dstStartIndex + copyCount === this.block_size) :
                    (dstStartIndex === 0);
                if(blockEndReached || count === copyCount)
                    this.block_table[dstBlockIndex] = null;
            }
        }

        dstIndex += ascending ? copyCount : -copyCount;
        srcIndex += ascending ? copyCount : -copyCount;
        count -= copyCount;
    }
}

/**
 * @private
 * Sets all elements within the specified interval to NaN (both ends inclusive).
 * Releases empty blocks.
 */
function clearInterval(start, end) {
    while(start <= end) {
        // Figure our destination block
        var blockIndex = start >> this.block_shift;
        var sizesIndex = start & this.block_mask;
        var block = this.block_table[blockIndex];

        // Figure out number of elements to clear in this iteration
        // Make sure we don't clear more items than requested
        var clearCount = this.block_size - sizesIndex;
        clearCount = Math.min(clearCount, end - start + 1);

        if(block) {
            if(clearCount === this.block_size) {
                this.block_table[blockIndex] = null;
            } else {
                // Copying from null source block is equivalent of clearing the destination block
                inBlockCopy(block, sizesIndex, null /*srcBlock*/, 0, clearCount);

                // If the blockDst contains only default sizes, then remove the block
                if(block.defaultCount === this.block_size) {
                    this.block_table[blockIndex] = null;
                }
            }
        }

        start += clearCount;
    }
}

/**
 * @private
 * Removes the elements designated by the intervals and truncates
 * the LinearLayoutVector to the new length.
 * 'intervals' is a Vector of descending intervals [7, 5, 3, 1]
 */
function removeIntervals(intervals) {
    var intervalsCount = intervals.length;
    if(intervalsCount === 0) {
        return;
    }

    // Adding final nextIntervalStart value (see below).
    intervals.reverse(); // turn into ascending, for example [7, 5, 3, 1] --> [1, 3, 5, 7]
    intervals.push(this.getLength());

    // Move the elements
    var dstStart = intervals[0];
    var srcStart;
    var count;
    var i = 0;
    do {
        var intervalEnd = intervals[i + 1];
        var nextIntervalStart = intervals[i + 2]
        i += 2;

        // Start copy from after the end of current interval
        srcStart = intervalEnd + 1;

        // copy all elements up to the start of the next interval.
        count = nextIntervalStart - srcStart;

        copyInterval.call(this, dstStart, srcStart, count);
        dstStart += count;
    } while(i < intervalsCount)

    // Truncate the excess elements.
    this.setLength(dstStart);
}

/**
 * @private
 * Increases the length and inserts NaN values for the elements designated by the intervals.
 * 'intervals' is a Vector of ascending intervals [1, 3, 5, 7]
 */
function insertIntervals(intervals, newLength) {
    var intervalsCount = intervals.length;
    if(intervalsCount === 0) {
        return;
    }

    // Allocate enough space for the insertions, all the elements
    // allocated are NaN by default.
    var oldLength = this.getLength();
    this.setLength(newLength);

    var srcEnd = oldLength - 1;
    var dstEnd = newLength - 1;
    var i = intervalsCount - 2;
    while(i >= 0) {
        // Find current interval
        var intervalStart = intervals[i];
        var intervalEnd = intervals[i + 1];
        i -= 2;

        // Start after the current interval
        var dstStart = intervalEnd + 1;
        var copyCount = dstEnd - dstStart + 1;
        var srcStart = srcEnd - copyCount + 1;

        copyInterval.call(this, dstStart, srcStart, copyCount);
        dstStart -= copyCount;
        dstEnd = intervalStart - 1;

        // Fill in with default NaN values after the copy
        clearInterval.call(this, intervalStart, intervalEnd);
    }
}

/**
 * @private
 * Processes any pending removes or pending inserts.
 */
function flushPendingChanges() {
    var intervals;
    if(this.removes) {
        intervals = this.removes;
        this.removes = null;
        this._pendingLength = -1;
        removeIntervals.call(this, intervals);
    } else if(this.inserts) {
        intervals = this.inserts;
        var newLength = this._pendingLength;
        this.inserts = null;
        this._pendingLength = -1;
        insertIntervals.call(this, intervals, newLength);
    }
}

/**
 * The cumulative distance to the start of the item at index, including
 * the gaps between items and the axisOffset.
 *
 * The value of start(0) is axisOffset.
 *
 * Equivalent to:
 * <pre>
 * var distance = this.getAxisOffset();
 * for (var i = 0; i &lt; index; i++)
 *     distance += get(i);
 * return distance + (gap * index);
 * </pre>
 *
 * The actual implementation is relatively efficient.
 *
 * @param index The item's index.
 * @see #end
 */
function start(index) {

    flushPendingChanges.call(this);

    if((this._length === 0) || (index === 0)) {
        return this.getAxisOffset();
    }

    if(index >= this._length) {
        throw new Error("Invalid index and all that.");
    }

    var distance = this.getAxisOffset();
    var blockIndex = index >> this.block_shift;
    for(var i = 0; i < blockIndex; i++)
    {
        var block = this.block_table[i];
        distance += block ?
            block.sizesSum + (block.defaultCount * this._defaultSize) :
            this.block_size * this._defaultSize;
    }
    var lastBlock = this.block_table[blockIndex];
    var lastBlockOffset = index & ~this.block_mask;
    var lastBlockLength = index - lastBlockOffset;
    if(lastBlock) {
        var sizes = lastBlock.sizes;
        for(i = 0; i < lastBlockLength; i++) {
            var size = sizes[i];
            distance += (size !== size) ? this._defaultSize : size;
        }
    } else {
        distance += this._defaultSize * lastBlockLength;
    }
    distance += index * this.getGap();
    return distance;
}

/**
 * The cumulative distance to the end of the item at index, including
 * the gaps between items.
 *
 * If <code>index &lt;(length-1)</code> then the value of this
 * function is defined as:
 * <code>start(index) + get(index)</code>.
 *
 * @param index The item's index.
 * @see #start
 */
function end(index) {
    flushPendingChanges.call(this);
    return this.start(index) + this.getItemSize(index);
}

/**
 * Returns the index of the item that overlaps the specified distance.
 *
 * The item at index <code>i</code> overlaps a distance value
 * if <code>start(i) &lt;= distance &lt; end(i)</code>.
 *
 * If no such item exists, -1 is returned.
 */
function indexOf(distance) {
    flushPendingChanges.call(this);
    var index = indexOfInternal.call(this, distance);
    return (index >= this._length) ? -1 : index;
}

function indexOfInternal(distance) {

    if((this._length === 0) || (distance < 0)) {
        return -1;
    }

    // The area of the first item includes the axisOffset
    var curDistance = this.getAxisOffset();

    if(distance < curDistance) {
        return 0;
    }

    var index = -1,
        block = null,
        blockSize = this.block_size,
        defaultSize = this._defaultSize,
        gap = this.getGap(),
        blockGap = gap * blockSize;

    // Find the block that contains distance and the index of its
    // first element
    var blockIndex = -1,
        blockTable = this.block_table,
        blockTableLength = blockTable.length;

    for(; ++blockIndex < blockTableLength;) {
        block = blockTable[blockIndex];
        var blockDistance = blockGap + (
            block ?
                block.sizesSum + (block.defaultCount * defaultSize) :
                blockSize * defaultSize
        );

        if((distance === curDistance) || ((distance >= curDistance) && (distance < (curDistance + blockDistance)))) {
            index = blockIndex << this.block_shift;
            break;
        }
        curDistance += blockDistance;
    }

    if((index === -1) || (distance === curDistance)) {
        return index;
    }

    // At this point index corresponds to the first item in this block
    if(block) {
        // Find the item that contains distance and return its index
        var sizes = block.sizes,
            n = this.block_size - 1;
        for(var i = 0; i < n; i++) {
            var size = sizes[i];
            curDistance += gap + (size !== size ? this._defaultSize : size);
            if(curDistance > distance) {
                return index + i;
            }
        }
        // TBD special-case for the very last index
        return index + this.block_size - 1;
    } else {
        return index + Math.floor(Number(distance - curDistance) / Number(this._defaultSize + gap));
    }
}

/**
 * Clear all cached state, reset length to zero.
 */
function clear() {
    // Discard any pending changes, before setting the length
    // otherwise the length setter will commit the changes.
    this.removes = null;
    this.inserts = null;
    this._pendingLength = -1;

    this.setLength(0); // clears the this.block_table as well
}

function toString() {
    return "LinearLayoutVector { " +
        "length: " + this._length + ", " +
        "size: " + this.end(this.getLength() -1) + ", " +
        "[blocks: " + this.block_table.length + "]" + ", " +
        "gap: " + this._gap + ", " +
        "defaultSize: " + this._defaultSize + ", " +
        "pendingRemoves: " + (this.removes ? this.removes.length : 0) + ", " +
        "pendingInserts: " + (this.inserts ? this.inserts.length : 0) +
        " }";
}

/**
 * @private
 * A LinearLayoutVector block of layout element heights or widths.
 *
 * Total "distance" for a Block is: sizesSum + (defaultCount * distanceVector.default).
 */
function Block(block_size) {

    this.sizes = new Array(block_size);
    this.sizesSum = 0;
    this.defaultCount = block_size;

    for(var i = -1; ++i < block_size;) {
        this.sizes[i] = NaN;
    }
}


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DEFAULT_MAX_ELEMENT_SIZE = 1500000;
var CHROME_MAX_ELEMENT_SIZE = 1.67771e7;

var isBrowser = function isBrowser() {
  return typeof window !== 'undefined';
};

var isChrome = function isChrome() {
  return !!window.chrome && !!window.chrome.webstore;
};

var getMaxElementSize = exports.getMaxElementSize = function getMaxElementSize() {
  if (isBrowser()) {
    if (isChrome()) {
      return CHROME_MAX_ELEMENT_SIZE;
    }
  }
  return DEFAULT_MAX_ELEMENT_SIZE;
};

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(1052);

var _keys2 = _interopRequireDefault(_keys);

exports.default = createCallbackMemoizer;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
 */
function createCallbackMemoizer() {
  var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  var cachedIndices = {};

  return function (_ref) {
    var callback = _ref.callback,
        indices = _ref.indices;

    var keys = (0, _keys2.default)(indices);
    var allInitialized = !requireAllKeys || keys.every(function (key) {
      var value = indices[key];
      return Array.isArray(value) ? value.length > 0 : value >= 0;
    });
    var indexChanged = keys.length !== (0, _keys2.default)(cachedIndices).length || keys.some(function (key) {
      var cachedValue = cachedIndices[key];
      var value = indices[key];

      return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
    });

    cachedIndices = indices;

    if (allInitialized && indexChanged) {
      callback(indices);
    }
  };
}

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1053), __esModule: true };

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1054);
module.exports = __webpack_require__(22).Object.keys;


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(157);
var $keys = __webpack_require__(119);

__webpack_require__(213)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = updateScrollIndexHelper;

var _ScalingCellSizeAndPositionManager = __webpack_require__(220);

var _ScalingCellSizeAndPositionManager2 = _interopRequireDefault(_ScalingCellSizeAndPositionManager);

var _types = __webpack_require__(72);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Helper function that determines when to update scroll offsets to ensure that a scroll-to-index remains visible.
 * This function also ensures that the scroll ofset isn't past the last column/row of cells.
 */

function updateScrollIndexHelper(_ref) {
  var cellSize = _ref.cellSize,
      cellSizeAndPositionManager = _ref.cellSizeAndPositionManager,
      previousCellsCount = _ref.previousCellsCount,
      previousCellSize = _ref.previousCellSize,
      previousScrollToAlignment = _ref.previousScrollToAlignment,
      previousScrollToIndex = _ref.previousScrollToIndex,
      previousSize = _ref.previousSize,
      scrollOffset = _ref.scrollOffset,
      scrollToAlignment = _ref.scrollToAlignment,
      scrollToIndex = _ref.scrollToIndex,
      size = _ref.size,
      sizeJustIncreasedFromZero = _ref.sizeJustIncreasedFromZero,
      updateScrollIndexCallback = _ref.updateScrollIndexCallback;

  var cellCount = cellSizeAndPositionManager.getCellCount();
  var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
  var sizeHasChanged = size !== previousSize || sizeJustIncreasedFromZero || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize;

  // If we have a new scroll target OR if height/row-height has changed,
  // We should ensure that the scroll target is visible.
  if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) {
    updateScrollIndexCallback(scrollToIndex);

    // If we don't have a selected item but list size or number of children have decreased,
    // Make sure we aren't scrolled too far past the current content.
  } else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) {
    // We need to ensure that the current scroll offset is still within the collection's range.
    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
    // Just check to make sure we're still okay.
    // Only adjust the scroll position if we've scrolled below the last set of rows.
    if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) {
      updateScrollIndexCallback(cellCount - 1);
    }
  }
}

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1057);

exports.__esModule = true;
exports.default = scrollbarSize;

var _inDOM = _interopRequireDefault(__webpack_require__(1058));

var size;

function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (_inDOM.default) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}

module.exports = exports["default"];

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bpfrpt_proptype_AnimationTimeoutId = exports.requestAnimationTimeout = exports.cancelAnimationTimeout = undefined;

var _promise = __webpack_require__(1061);

var _promise2 = _interopRequireDefault(_promise);

var _animationFrame = __webpack_require__(1077);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bpfrpt_proptype_AnimationTimeoutId =  true ? null : {
  id: _propTypes2.default.number.isRequired
};
var cancelAnimationTimeout = exports.cancelAnimationTimeout = function cancelAnimationTimeout(frame) {
  return (0, _animationFrame.caf)(frame.id);
};

/**
 * Recursively calls requestAnimationFrame until a specified delay has been met or exceeded.
 * When the delay time has been reached the function you're timing out will be called.
 *
 * Credit: Joe Lambert (https://gist.github.com/joelambert/1002116#file-requesttimeout-js)
 */
var requestAnimationTimeout = exports.requestAnimationTimeout = function requestAnimationTimeout(callback, delay) {
  var start = void 0;
  // wait for end of processing current event handler, because event handler may be long
  _promise2.default.resolve().then(function () {
    start = Date.now();
  });

  var timeout = function timeout() {
    if (Date.now() - start >= delay) {
      callback.call();
    } else {
      frame.id = (0, _animationFrame.raf)(timeout);
    }
  };

  var frame = {
    id: (0, _animationFrame.raf)(timeout)
  };

  return frame;
};
exports.bpfrpt_proptype_AnimationTimeoutId = bpfrpt_proptype_AnimationTimeoutId;

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1062), __esModule: true };

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(587);
__webpack_require__(581);
__webpack_require__(585);
__webpack_require__(1063);
__webpack_require__(1075);
__webpack_require__(1076);
module.exports = __webpack_require__(22).Promise;


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(121);
var global = __webpack_require__(28);
var ctx = __webpack_require__(118);
var classof = __webpack_require__(591);
var $export = __webpack_require__(57);
var isObject = __webpack_require__(70);
var aFunction = __webpack_require__(153);
var anInstance = __webpack_require__(1064);
var forOf = __webpack_require__(1065);
var speciesConstructor = __webpack_require__(592);
var task = __webpack_require__(593).set;
var microtask = __webpack_require__(1070)();
var newPromiseCapabilityModule = __webpack_require__(221);
var perform = __webpack_require__(594);
var userAgent = __webpack_require__(1071);
var promiseResolve = __webpack_require__(595);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(38)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(1072)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(158)($Promise, PROMISE);
__webpack_require__(1073)(PROMISE);
Wrapper = __webpack_require__(22)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(1074)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 1064 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(118);
var call = __webpack_require__(1066);
var isArrayIter = __webpack_require__(1067);
var anObject = __webpack_require__(62);
var toLength = __webpack_require__(578);
var getIterFn = __webpack_require__(1068);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(62);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(124);
var ITERATOR = __webpack_require__(38)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(591);
var ITERATOR = __webpack_require__(38)('iterator');
var Iterators = __webpack_require__(124);
module.exports = __webpack_require__(22).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 1069 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(28);
var macrotask = __webpack_require__(593).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(120)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(28);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(87);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(28);
var core = __webpack_require__(22);
var dP = __webpack_require__(69);
var DESCRIPTORS = __webpack_require__(71);
var SPECIES = __webpack_require__(38)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(38)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(57);
var core = __webpack_require__(22);
var global = __webpack_require__(28);
var speciesConstructor = __webpack_require__(592);
var promiseResolve = __webpack_require__(595);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(57);
var newPromiseCapability = __webpack_require__(221);
var perform = __webpack_require__(594);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


// Properly handle server-side rendering.
var win = void 0;

if (typeof window !== 'undefined') {
  win = window;
} else if (typeof self !== 'undefined') {
  win = self;
} else {
  win = {};
}

// requestAnimationFrame() shim by Paul Irish
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
var request = win.requestAnimationFrame || win.webkitRequestAnimationFrame || win.mozRequestAnimationFrame || win.oRequestAnimationFrame || win.msRequestAnimationFrame || function (callback) {
  return win.setTimeout(callback, 1000 / 60);
};

var cancel = win.cancelAnimationFrame || win.webkitCancelAnimationFrame || win.mozCancelAnimationFrame || win.oCancelAnimationFrame || win.msCancelAnimationFrame || function (id) {
  win.clearTimeout(id);
};

var raf = exports.raf = request;
var caf = exports.caf = cancel;

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SCROLL_DIRECTION_VERTICAL = exports.SCROLL_DIRECTION_HORIZONTAL = exports.SCROLL_DIRECTION_FORWARD = exports.SCROLL_DIRECTION_BACKWARD = undefined;
exports.default = defaultOverscanIndicesGetter;

var _types = __webpack_require__(72);

var SCROLL_DIRECTION_BACKWARD = exports.SCROLL_DIRECTION_BACKWARD = -1;

var SCROLL_DIRECTION_FORWARD = exports.SCROLL_DIRECTION_FORWARD = 1;

var SCROLL_DIRECTION_HORIZONTAL = exports.SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var SCROLL_DIRECTION_VERTICAL = exports.SCROLL_DIRECTION_VERTICAL = 'vertical';

/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */

function defaultOverscanIndicesGetter(_ref) {
  var cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;

  // Make sure we render at least 1 cell extra before and after (except near boundaries)
  // This is necessary in order to support keyboard navigation (TAB/SHIFT+TAB) in some cases
  // For more info see issues #625
  overscanCellsCount = Math.max(1, overscanCellsCount);

  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
    return {
      overscanStartIndex: Math.max(0, startIndex - 1),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + 1)
    };
  }
}

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__(1080);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
module.exports = exports['default'];

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(94);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(1081);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(598);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(600);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = 'ReactModalPortal';
var bodyOpenClassName = exports.bodyOpenClassName = 'ReactModal__Body--open';

var canUseDOM = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof document.createElement === 'function';

var isReact16 = _reactDom2.default.createPortal !== undefined;
var createPortal = isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      parent.removeChild(_this.node);
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!canUseDOM) return;

      if (!isReact16) {
        this.node = document.createElement('div');
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (!canUseDOM) return;
      var isOpen = newProps.isOpen;
      // Stop unnecessary renders if modal is remaining closed

      if (!this.props.isOpen && !isOpen) return;

      var currentParent = getParentElement(this.props.parentSelector);
      var newParent = getParentElement(newProps.parentSelector);

      if (newParent !== currentParent) {
        currentParent.removeChild(this.node);
        newParent.appendChild(this.node);
      }

      !isReact16 && this.renderPortal(newProps);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(newProps) {
      if (!canUseDOM) return;
      if (newProps.portalClassName !== this.props.portalClassName) {
        this.node.className = newProps.portalClassName;
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (!canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (!canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = document.createElement('div');
      }

      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({ ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: 'setAppElement',
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable no-console */

  }, {
    key: 'injectCSS',
    value: function injectCSS() {
      "production" !== "production" && console.warn('React-Modal: injectCSS has been deprecated ' + 'and no longer has any effect. It will be removed in a later version');
    }
    /* eslint-enable no-console */

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfter: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnOverlayClick: true,
  parentSelector: function parentSelector() {
    return document.body;
  }
};
Modal.defaultStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.75)'
  },
  content: {
    position: 'absolute',
    top: '40px',
    left: '40px',
    right: '40px',
    bottom: '40px',
    border: '1px solid #ccc',
    background: '#fff',
    overflow: 'auto',
    WebkitOverflowScrolling: 'touch',
    borderRadius: '4px',
    outline: 'none',
    padding: '20px'
  }
};
exports.default = Modal;

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _focusManager = __webpack_require__(1082);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(1083);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(598);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _refCount = __webpack_require__(599);

var refCount = _interopRequireWildcard(_refCount);

var _bodyClassList = __webpack_require__(1084);

var bodyClassList = _interopRequireWildcard(_bodyClassList);

var _safeHTMLElement = __webpack_require__(600);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: 'ReactModal__Overlay',
  content: 'ReactModal__Content'
};

var TAB_KEY = 9;
var ESC_KEY = 27;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setFocusAfterRender = function (focus) {
      _this.focusAfterRender = _this.props.shouldFocusAfterRender && focus;
    };

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
    };

    _this.setContentRef = function (content) {
      _this.content = content;
    };

    _this.afterClose = function () {
      focusManager.returnFocus();
      focusManager.teardownScopedFocus();
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        focusManager.setupScopedFocus(_this.node);
        focusManager.markForFocusLater();
        _this.setState({ isOpen: true }, function () {
          _this.setState({ afterOpen: true });

          if (_this.props.isOpen && _this.props.onAfterOpen) {
            _this.props.onAfterOpen();
          }
        });
      }
    };

    _this.close = function () {
      _this.beforeClose();
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus();
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === TAB_KEY) {
        (0, _scopeTab2.default)(_this.content, event);
      }
      if (event.keyCode === ESC_KEY) {
        event.preventDefault();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === 'undefined' ? 'undefined' : _typeof(additional)) === 'object' ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + '--after-open',
        beforeClose: CLASS_NAMES[which] + '--before-close'
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + ' ' + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + ' ' + classNames.beforeClose;
      }
      return typeof additional === 'string' && additional ? className + ' ' + additional : className;
    };

    _this.ariaAttributes = function (items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc['aria-' + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Focus needs to be set when mounting and already open
      if (this.props.isOpen) {
        this.setFocusAfterRender(true);
        this.open();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (false) {
        if (newProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + 'This may cause unexpected behavior when multiple modals are open.');
        }
      }
      // Focus only needs to be set once when the modal is being opened
      if (!this.props.isOpen && newProps.isOpen) {
        this.setFocusAfterRender(true);
        this.open();
      } else if (this.props.isOpen && !newProps.isOpen) {
        this.close();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.focusAfterRender) {
        this.focusContent();
        this.setFocusAfterRender(false);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.beforeClose();
      clearTimeout(this.closeTimer);
    }
  }, {
    key: 'beforeOpen',
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          bodyOpenClassName = _props.bodyOpenClassName;
      // Add body class

      bodyClassList.add(bodyOpenClassName);
      // Add aria-hidden to appElement
      if (ariaHideApp) {
        ariaAppHider.hide(appElement);
      }
    }
  }, {
    key: 'beforeClose',
    value: function beforeClose() {
      var _props2 = this.props,
          appElement = _props2.appElement,
          ariaHideApp = _props2.ariaHideApp,
          bodyOpenClassName = _props2.bodyOpenClassName;
      // Remove class if no more modals are open

      bodyClassList.remove(bodyOpenClassName);
      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && refCount.totalCount() < 1) {
        ariaAppHider.show(appElement);
      }
    }

    // Don't steal focus from inner elements

  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          className = _props3.className,
          overlayClassName = _props3.overlayClassName,
          defaultStyles = _props3.defaultStyles;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      return this.shouldBeClosed() ? null : _react2.default.createElement(
        'div',
        {
          ref: this.setOverlayRef,
          className: this.buildClassName('overlay', overlayClassName),
          style: _extends({}, overlayStyles, this.props.style.overlay),
          onClick: this.handleOverlayOnClick },
        _react2.default.createElement(
          'div',
          _extends({
            ref: this.setContentRef,
            style: _extends({}, contentStyles, this.props.style.content),
            className: this.buildClassName('content', className),
            tabIndex: '-1',
            onKeyDown: this.handleKeyDown,
            onMouseDown: this.handleContentOnMouseDown,
            onClick: this.handleContentOnClick,
            role: this.props.role,
            'aria-label': this.props.contentLabel
          }, this.ariaAttributes(this.props.aria || {})),
          this.props.children
        )
      );
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  }
};
ModalPortal.propTypes = {
  isOpen: _propTypes.PropTypes.bool.isRequired,
  defaultStyles: _propTypes.PropTypes.shape({
    content: _propTypes.PropTypes.object,
    overlay: _propTypes.PropTypes.object
  }),
  style: _propTypes.PropTypes.shape({
    content: _propTypes.PropTypes.object,
    overlay: _propTypes.PropTypes.object
  }),
  className: _propTypes.PropTypes.oneOfType([_propTypes.PropTypes.string, _propTypes.PropTypes.object]),
  overlayClassName: _propTypes.PropTypes.oneOfType([_propTypes.PropTypes.string, _propTypes.PropTypes.object]),
  bodyOpenClassName: _propTypes.PropTypes.string,
  ariaHideApp: _propTypes.PropTypes.bool,
  appElement: _propTypes.PropTypes.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes.PropTypes.func,
  onRequestClose: _propTypes.PropTypes.func,
  closeTimeoutMS: _propTypes.PropTypes.number,
  shouldFocusAfterRender: _propTypes.PropTypes.bool,
  shouldCloseOnOverlayClick: _propTypes.PropTypes.bool,
  role: _propTypes.PropTypes.string,
  contentLabel: _propTypes.PropTypes.string,
  aria: _propTypes.PropTypes.object,
  children: _propTypes.PropTypes.node
};
exports.default = ModalPortal;
module.exports = exports['default'];

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(597);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var toFocus = null;
  try {
    toFocus = focusLaterElements.pop();
    toFocus.focus();
    return;
  } catch (e) {
    console.warn(['You tried to return focus to', toFocus, 'but it is not in the DOM anymore'].join(" "));
  }
}
/* eslint-enable no-console */

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener('blur', handleBlur, false);
    document.addEventListener('focus', handleFocus, true);
  } else {
    window.attachEvent('onBlur', handleBlur);
    document.attachEvent('onFocus', handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener('blur', handleBlur);
    document.removeEventListener('focus', handleFocus);
  } else {
    window.detachEvent('onBlur', handleBlur);
    document.detachEvent('onFocus', handleFocus);
  }
}

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;

var _tabbable = __webpack_require__(597);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);
  if (!tabbable.length) {
    event.preventDefault();
    return;
  }
  var finalTabbable = tabbable[event.shiftKey ? 0 : tabbable.length - 1];
  var leavingFinalTabbable = finalTabbable === document.activeElement ||
  // handle immediate shift+tab after opening with mouse
  node === document.activeElement;
  if (!leavingFinalTabbable) return;
  event.preventDefault();
  var target = tabbable[event.shiftKey ? tabbable.length - 1 : 0];
  target.focus();
}
module.exports = exports['default'];

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.remove = remove;

var _refCount = __webpack_require__(599);

var refCount = _interopRequireWildcard(_refCount);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function add(bodyClass) {
  // Increment class(es) on refCount tracker and add class(es) to body
  bodyClass.split(' ').map(refCount.add).forEach(function (className) {
    return document.body.classList.add(className);
  });
}

function remove(bodyClass) {
  var classListMap = refCount.get();
  // Decrement class(es) from the refCount tracker
  // and remove unused class(es) from body
  bodyClass.split(' ').map(refCount.remove).filter(function (className) {
    return classListMap[className] === 0;
  }).forEach(function (className) {
    return document.body.classList.remove(className);
  });
}

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["useDropzone"] = useDropzone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_file_selector__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_index__ = __webpack_require__(1091);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint prefer-template: 0 */




/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */

var Dropzone = __WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"](function (_ref, ref) {
  var children = _ref.children,
      params = _objectWithoutProperties(_ref, ["children"]);

  var _useDropzone = useDropzone(params),
      open = _useDropzone.open,
      props = _objectWithoutProperties(_useDropzone, ["open"]);

  __WEBPACK_IMPORTED_MODULE_0_react__["useImperativeHandle"](ref, function () {
    return {
      open: open
    };
  }, [open]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, children(_objectSpread({}, props, {
    open: open
  })));
});
Dropzone.displayName = 'Dropzone';
Dropzone.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.draggedFiles Files in active drag
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Set accepted file types.
   * See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),

  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * If true, disables drag 'n' drop
   */
  noDrag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Minimum file size (in bytes)
   */
  minSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * Enable/disable the dropzone
   */
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are droppped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["default"] = (Dropzone);
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */

/**
 * An object with the current dropzone state and some helper functions.
 *
 * @typedef {object} DropzoneState
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} draggedFiles Files in active drag
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */

var initialState = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  draggedFiles: [],
  acceptedFiles: [],
  fileRejections: []
};
/**
 * A React hook that creates a drag 'n' drop area.
 *
 * ```jsx
 * function MyDropzone(props) {
 *   const {getRootProps, getInputProps} = useDropzone({
 *     onDrop: acceptedFiles => {
 *       // do something with the File objects, e.g. upload to some server
 *     }
 *   });
 *   return (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag and drop some files here, or click to select files</p>
 *     </div>
 *   )
 * }
 * ```
 *
 * @function useDropzone
 *
 * @param {object} props
 * @param {string|string[]} [props.accept] Set accepted file types.
 * See https://github.com/okonet/attr-accept for more information.
 * Keep in mind that mime type determination is not reliable across platforms. CSV files,
 * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
 * Windows. In some cases there might not be a mime type set at all.
 * See: https://github.com/react-dropzone/react-dropzone/issues/276
 * @param {boolean} [props.multiple=true] Allow drag 'n' drop (or selection from the file dialog) of multiple files
 * @param {boolean} [props.preventDropOnDocument=true] If false, allow dropped items to take over the current browser window
 * @param {boolean} [props.noClick=false] If true, disables click to open the native file selection dialog
 * @param {boolean} [props.noKeyboard=false] If true, disables SPACE/ENTER to open the native file selection dialog.
 * Note that it also stops tracking the focus state.
 * @param {boolean} [props.noDrag=false] If true, disables drag 'n' drop
 * @param {boolean} [props.noDragEventsBubbling=false] If true, stops drag event propagation to parents
 * @param {number} [props.minSize=0] Minimum file size (in bytes)
 * @param {number} [props.maxSize=Infinity] Maximum file size (in bytes)
 * @param {boolean} [props.disabled=false] Enable/disable the dropzone
 * @param {getFilesFromEvent} [props.getFilesFromEvent] Use this to provide a custom file aggregator
 * @param {Function} [props.onFileDialogCancel] Cb for when closing the file dialog with no selection
 * @param {dragCb} [props.onDragEnter] Cb for when the `dragenter` event occurs.
 * @param {dragCb} [props.onDragLeave] Cb for when the `dragleave` event occurs
 * @param {dragCb} [props.onDragOver] Cb for when the `dragover` event occurs
 * @param {dropCb} [props.onDrop] Cb for when the `drop` event occurs.
 * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
 *
 * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
 * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
 * If `multiple` is set to false and additional files are droppped,
 * all files besides the first will be rejected.
 * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
 *
 * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
 * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
 *
 * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
 * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
 *
 * ```js
 * function onDrop(acceptedFiles) {
 *   const req = request.post('/upload')
 *   acceptedFiles.forEach(file => {
 *     req.attach(file.name, file)
 *   })
 *   req.end(callback)
 * }
 * ```
 * @param {dropAcceptedCb} [props.onDropAccepted]
 * @param {dropRejectedCb} [props.onDropRejected]
 *
 * @returns {DropzoneState}
 */

function useDropzone() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      accept = _ref2.accept,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      _ref2$getFilesFromEve = _ref2.getFilesFromEvent,
      getFilesFromEvent = _ref2$getFilesFromEve === void 0 ? __WEBPACK_IMPORTED_MODULE_2_file_selector__["a" /* fromEvent */] : _ref2$getFilesFromEve,
      _ref2$maxSize = _ref2.maxSize,
      maxSize = _ref2$maxSize === void 0 ? Infinity : _ref2$maxSize,
      _ref2$minSize = _ref2.minSize,
      minSize = _ref2$minSize === void 0 ? 0 : _ref2$minSize,
      _ref2$multiple = _ref2.multiple,
      multiple = _ref2$multiple === void 0 ? true : _ref2$multiple,
      onDragEnter = _ref2.onDragEnter,
      onDragLeave = _ref2.onDragLeave,
      onDragOver = _ref2.onDragOver,
      onDrop = _ref2.onDrop,
      onDropAccepted = _ref2.onDropAccepted,
      onDropRejected = _ref2.onDropRejected,
      onFileDialogCancel = _ref2.onFileDialogCancel,
      _ref2$preventDropOnDo = _ref2.preventDropOnDocument,
      preventDropOnDocument = _ref2$preventDropOnDo === void 0 ? true : _ref2$preventDropOnDo,
      _ref2$noClick = _ref2.noClick,
      noClick = _ref2$noClick === void 0 ? false : _ref2$noClick,
      _ref2$noKeyboard = _ref2.noKeyboard,
      noKeyboard = _ref2$noKeyboard === void 0 ? false : _ref2$noKeyboard,
      _ref2$noDrag = _ref2.noDrag,
      noDrag = _ref2$noDrag === void 0 ? false : _ref2$noDrag,
      _ref2$noDragEventsBub = _ref2.noDragEventsBubbling,
      noDragEventsBubbling = _ref2$noDragEventsBub === void 0 ? false : _ref2$noDragEventsBub;

  var rootRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
  var inputRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);

  var _useReducer = __WEBPACK_IMPORTED_MODULE_0_react__["useReducer"](reducer, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var isFocused = state.isFocused,
      isFileDialogActive = state.isFileDialogActive,
      draggedFiles = state.draggedFiles; // Fn for opening the file dialog programmatically

  var openFileDialog = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function () {
    if (inputRef.current) {
      dispatch({
        type: 'openDialog'
      });
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }, [dispatch]); // Update file dialog active state when the window is focused on

  var onWindowFocus = function onWindowFocus() {
    // Execute the timeout only if the file dialog is opened in the browser
    if (isFileDialogActive) {
      setTimeout(function () {
        if (inputRef.current) {
          var files = inputRef.current.files;

          if (!files.length) {
            dispatch({
              type: 'closeDialog'
            });

            if (typeof onFileDialogCancel === 'function') {
              onFileDialogCancel();
            }
          }
        }
      }, 300);
    }
  };

  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    window.addEventListener('focus', onWindowFocus, false);
    return function () {
      window.removeEventListener('focus', onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancel]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone

  var onKeyDownCb = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function (event) {
    // Ignore keyboard events bubbling up the DOM tree
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }

    if (event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, inputRef]); // Update focus state for the dropzone

  var onFocusCb = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function () {
    dispatch({
      type: 'focus'
    });
  }, []);
  var onBlurCb = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function () {
    dispatch({
      type: 'blur'
    });
  }, []); // Cb to open the file dialog when click occurs on the dropzone

  var onClickCb = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function () {
    if (noClick) {
      return;
    } // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
    // to ensure React can handle state changes
    // See: https://github.com/react-dropzone/react-dropzone/issues/450


    if (__WEBPACK_IMPORTED_MODULE_3__utils_index__["g" /* isIeOrEdge */]()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [inputRef, noClick]);
  var dragTargetsRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"]([]);

  var onDocumentDrop = function onDocumentDrop(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
      return;
    }

    event.preventDefault();
    dragTargetsRef.current = [];
  };

  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    if (preventDropOnDocument) {
      document.addEventListener('dragover', __WEBPACK_IMPORTED_MODULE_3__utils_index__["i" /* onDocumentDragOver */], false);
      document.addEventListener('drop', onDocumentDrop, false);
    }

    return function () {
      if (preventDropOnDocument) {
        document.removeEventListener('dragover', __WEBPACK_IMPORTED_MODULE_3__utils_index__["i" /* onDocumentDragOver */]);
        document.removeEventListener('drop', onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]);
  var onDragEnterCb = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [].concat(_toConsumableArray(dragTargetsRef.current), [event.target]);

    if (__WEBPACK_IMPORTED_MODULE_3__utils_index__["f" /* isEvtWithFiles */](event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (draggedFiles) {
        if (__WEBPACK_IMPORTED_MODULE_3__utils_index__["h" /* isPropagationStopped */](event) && !noDragEventsBubbling) {
          return;
        }

        dispatch({
          draggedFiles: draggedFiles,
          isDragActive: true,
          type: 'setDraggedFiles'
        });

        if (onDragEnter) {
          onDragEnter(event);
        }
      });
    }
  }, [getFilesFromEvent, onDragEnter, noDragEventsBubbling]);
  var onDragOverCb = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);

    if (event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = 'copy';
      } catch (_unused) {}
      /* eslint-disable-line no-empty */

    }

    if (__WEBPACK_IMPORTED_MODULE_3__utils_index__["f" /* isEvtWithFiles */](event) && onDragOver) {
      onDragOver(event);
    }

    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event); // Only deactivate once the dropzone and all children have been left

    var targets = dragTargetsRef.current.filter(function (target) {
      return rootRef.current && rootRef.current.contains(target);
    }); // Make sure to remove a target present multiple times only once
    // (Firefox may fire dragenter/dragleave multiple times on the same element)

    var targetIdx = targets.indexOf(event.target);

    if (targetIdx !== -1) {
      targets.splice(targetIdx, 1);
    }

    dragTargetsRef.current = targets;

    if (targets.length > 0) {
      return;
    }

    dispatch({
      isDragActive: false,
      type: 'setDraggedFiles',
      draggedFiles: []
    });

    if (__WEBPACK_IMPORTED_MODULE_3__utils_index__["f" /* isEvtWithFiles */](event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, onDragLeave, noDragEventsBubbling]);
  var onDropCb = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [];

    if (__WEBPACK_IMPORTED_MODULE_3__utils_index__["f" /* isEvtWithFiles */](event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (__WEBPACK_IMPORTED_MODULE_3__utils_index__["h" /* isPropagationStopped */](event) && !noDragEventsBubbling) {
          return;
        }

        var acceptedFiles = [];
        var fileRejections = [];
        files.forEach(function (file) {
          var _fileAccepted = __WEBPACK_IMPORTED_MODULE_3__utils_index__["d" /* fileAccepted */](file, accept),
              _fileAccepted2 = _slicedToArray(_fileAccepted, 2),
              accepted = _fileAccepted2[0],
              acceptError = _fileAccepted2[1];

          var _fileMatchSize = __WEBPACK_IMPORTED_MODULE_3__utils_index__["e" /* fileMatchSize */](file, minSize, maxSize),
              _fileMatchSize2 = _slicedToArray(_fileMatchSize, 2),
              sizeMatch = _fileMatchSize2[0],
              sizeError = _fileMatchSize2[1];

          if (accepted && sizeMatch) {
            acceptedFiles.push(file);
          } else {
            var errors = [acceptError, sizeError].filter(function (e) {
              return e;
            });
            fileRejections.push({
              file: file,
              errors: errors
            });
          }
        });

        if (!multiple && acceptedFiles.length > 1) {
          // Reject everything and empty accepted files
          acceptedFiles.forEach(function (file) {
            fileRejections.push({
              file: file,
              errors: [__WEBPACK_IMPORTED_MODULE_3__utils_index__["a" /* TOO_MANY_FILES_REJECTION */]]
            });
          });
          acceptedFiles.splice(0);
        }

        dispatch({
          acceptedFiles: acceptedFiles,
          fileRejections: fileRejections,
          type: 'setFiles'
        });

        if (onDrop) {
          onDrop(acceptedFiles, fileRejections, event);
        }

        if (fileRejections.length > 0 && onDropRejected) {
          onDropRejected(fileRejections, event);
        }

        if (acceptedFiles.length > 0 && onDropAccepted) {
          onDropAccepted(acceptedFiles, event);
        }
      });
    }

    dispatch({
      type: 'reset'
    });
  }, [multiple, accept, minSize, maxSize, getFilesFromEvent, onDrop, onDropAccepted, onDropRejected, noDragEventsBubbling]);

  var composeHandler = function composeHandler(fn) {
    return disabled ? null : fn;
  };

  var composeKeyboardHandler = function composeKeyboardHandler(fn) {
    return noKeyboard ? null : composeHandler(fn);
  };

  var composeDragHandler = function composeDragHandler(fn) {
    return noDrag ? null : composeHandler(fn);
  };

  var stopPropagation = function stopPropagation(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };

  var getRootProps = __WEBPACK_IMPORTED_MODULE_0_react__["useMemo"](function () {
    return function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$refKey = _ref3.refKey,
          refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey,
          onKeyDown = _ref3.onKeyDown,
          onFocus = _ref3.onFocus,
          onBlur = _ref3.onBlur,
          onClick = _ref3.onClick,
          onDragEnter = _ref3.onDragEnter,
          onDragOver = _ref3.onDragOver,
          onDragLeave = _ref3.onDragLeave,
          onDrop = _ref3.onDrop,
          rest = _objectWithoutProperties(_ref3, ["refKey", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"]);

      return _objectSpread(_defineProperty({
        onKeyDown: composeKeyboardHandler(__WEBPACK_IMPORTED_MODULE_3__utils_index__["c" /* composeEventHandlers */](onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(__WEBPACK_IMPORTED_MODULE_3__utils_index__["c" /* composeEventHandlers */](onFocus, onFocusCb)),
        onBlur: composeKeyboardHandler(__WEBPACK_IMPORTED_MODULE_3__utils_index__["c" /* composeEventHandlers */](onBlur, onBlurCb)),
        onClick: composeHandler(__WEBPACK_IMPORTED_MODULE_3__utils_index__["c" /* composeEventHandlers */](onClick, onClickCb)),
        onDragEnter: composeDragHandler(__WEBPACK_IMPORTED_MODULE_3__utils_index__["c" /* composeEventHandlers */](onDragEnter, onDragEnterCb)),
        onDragOver: composeDragHandler(__WEBPACK_IMPORTED_MODULE_3__utils_index__["c" /* composeEventHandlers */](onDragOver, onDragOverCb)),
        onDragLeave: composeDragHandler(__WEBPACK_IMPORTED_MODULE_3__utils_index__["c" /* composeEventHandlers */](onDragLeave, onDragLeaveCb)),
        onDrop: composeDragHandler(__WEBPACK_IMPORTED_MODULE_3__utils_index__["c" /* composeEventHandlers */](onDrop, onDropCb))
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}, {}, rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
  var onInputElementClick = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function (event) {
    event.stopPropagation();
  }, []);
  var getInputProps = __WEBPACK_IMPORTED_MODULE_0_react__["useMemo"](function () {
    return function () {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$refKey = _ref4.refKey,
          refKey = _ref4$refKey === void 0 ? 'ref' : _ref4$refKey,
          onChange = _ref4.onChange,
          onClick = _ref4.onClick,
          rest = _objectWithoutProperties(_ref4, ["refKey", "onChange", "onClick"]);

      var inputProps = _defineProperty({
        accept: accept,
        multiple: multiple,
        type: 'file',
        style: {
          display: 'none'
        },
        onChange: composeHandler(__WEBPACK_IMPORTED_MODULE_3__utils_index__["c" /* composeEventHandlers */](onChange, onDropCb)),
        onClick: composeHandler(__WEBPACK_IMPORTED_MODULE_3__utils_index__["c" /* composeEventHandlers */](onClick, onInputElementClick)),
        autoComplete: 'off',
        tabIndex: -1
      }, refKey, inputRef);

      return _objectSpread({}, inputProps, {}, rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  var fileCount = draggedFiles.length;
  var isDragAccept = fileCount > 0 && __WEBPACK_IMPORTED_MODULE_3__utils_index__["b" /* allFilesAccepted */]({
    files: draggedFiles,
    accept: accept,
    minSize: minSize,
    maxSize: maxSize,
    multiple: multiple
  });
  var isDragReject = fileCount > 0 && !isDragAccept;
  return _objectSpread({}, state, {
    isDragAccept: isDragAccept,
    isDragReject: isDragReject,
    isFocused: isFocused && !disabled,
    getRootProps: getRootProps,
    getInputProps: getInputProps,
    rootRef: rootRef,
    inputRef: inputRef,
    open: composeHandler(openFileDialog)
  });
}

function reducer(state, action) {
  /* istanbul ignore next */
  switch (action.type) {
    case 'focus':
      return _objectSpread({}, state, {
        isFocused: true
      });

    case 'blur':
      return _objectSpread({}, state, {
        isFocused: false
      });

    case 'openDialog':
      return _objectSpread({}, state, {
        isFileDialogActive: true
      });

    case 'closeDialog':
      return _objectSpread({}, state, {
        isFileDialogActive: false
      });

    case 'setDraggedFiles':
      /* eslint no-case-declarations: 0 */
      var isDragActive = action.isDragActive,
          draggedFiles = action.draggedFiles;
      return _objectSpread({}, state, {
        draggedFiles: draggedFiles,
        isDragActive: isDragActive
      });

    case 'setFiles':
      return _objectSpread({}, state, {
        acceptedFiles: action.acceptedFiles,
        fileRejections: action.fileRejections
      });

    case 'reset':
      return _objectSpread({}, state, {
        isFileDialogActive: false,
        isDragActive: false,
        draggedFiles: [],
        acceptedFiles: [],
        fileRejections: []
      });

    default:
      return state;
  }
}

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__file_selector__ = __webpack_require__(1088);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__file_selector__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fromEvent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__file__ = __webpack_require__(1090);


var FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
/**
 * Convert a DragEvent's DataTrasfer object to a list of File objects
 * NOTE: If some of the items are folders,
 * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
 * @param evt
 */
function fromEvent(evt) {
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */](this, void 0, void 0, function () {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */](this, function (_a) {
            return [2 /*return*/, isDragEvt(evt) && evt.dataTransfer
                    ? getDataTransferFiles(evt.dataTransfer, evt.type)
                    : getInputFiles(evt)];
        });
    });
}
function isDragEvt(value) {
    return !!value.dataTransfer;
}
function getInputFiles(evt) {
    var files = isInput(evt.target)
        ? evt.target.files
            ? fromList(evt.target.files)
            : []
        : [];
    return files.map(function (file) { return __WEBPACK_IMPORTED_MODULE_1__file__["a" /* toFileWithPath */](file); });
}
function isInput(value) {
    return value !== null;
}
function getDataTransferFiles(dt, type) {
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */](this, void 0, void 0, function () {
        var items, files;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */](this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!dt.items) return [3 /*break*/, 2];
                    items = fromList(dt.items)
                        .filter(function (item) { return item.kind === 'file'; });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== 'drop') {
                        return [2 /*return*/, items];
                    }
                    return [4 /*yield*/, Promise.all(items.map(toFilePromises))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, noIgnoredFiles(flatten(files))];
                case 2: return [2 /*return*/, noIgnoredFiles(fromList(dt.files)
                        .map(function (file) { return __WEBPACK_IMPORTED_MODULE_1__file__["a" /* toFileWithPath */](file); }))];
            }
        });
    });
}
function noIgnoredFiles(files) {
    return files.filter(function (file) { return FILES_TO_IGNORE.indexOf(file.name) === -1; });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function fromList(items) {
    var files = [];
    // tslint:disable: prefer-for-of
    for (var i = 0; i < items.length; i++) {
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') {
        return fromDataTransferItem(item);
    }
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) {
        return fromDirEntry(entry);
    }
    return fromDataTransferItem(item);
}
function flatten(items) {
    return items.reduce(function (acc, files) { return __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spread */](acc, (Array.isArray(files) ? flatten(files) : [files])); }, []);
}
function fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) {
        return Promise.reject(item + " is not a File");
    }
    var fwp = __WEBPACK_IMPORTED_MODULE_1__file__["a" /* toFileWithPath */](file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function fromEntry(entry) {
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */](this, void 0, void 0, function () {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */](this, function (_a) {
            return [2 /*return*/, entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function (resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function (batch) { return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */](_this, void 0, void 0, function () {
                var files, err_1, items;
                return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */](this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!batch.length) return [3 /*break*/, 5];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, Promise.all(entries)];
                        case 2:
                            files = _a.sent();
                            resolve(files);
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            reject(err_1);
                            return [3 /*break*/, 4];
                        case 4: return [3 /*break*/, 6];
                        case 5:
                            items = Promise.all(batch.map(fromEntry));
                            entries.push(items);
                            // Continue reading
                            readEntries();
                            _a.label = 6;
                        case 6: return [2 /*return*/];
                    }
                });
            }); }, function (err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function fromFileEntry(entry) {
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */](this, void 0, void 0, function () {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */](this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    entry.file(function (file) {
                        var fwp = __WEBPACK_IMPORTED_MODULE_1__file__["a" /* toFileWithPath */](file, entry.fullPath);
                        resolve(fwp);
                    }, function (err) {
                        reject(err);
                    });
                })];
        });
    });
}
//# sourceMappingURL=file-selector.js.map

/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __extends */
/* unused harmony export __assign */
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* harmony export (immutable) */ __webpack_exports__["a"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["b"] = __generator;
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* harmony export (immutable) */ __webpack_exports__["c"] = __spread;
/* unused harmony export __spreadArrays */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export COMMON_MIME_TYPES */
/* harmony export (immutable) */ __webpack_exports__["a"] = toFileWithPath;
var COMMON_MIME_TYPES = new Map([
    ['avi', 'video/avi'],
    ['gif', 'image/gif'],
    ['ico', 'image/x-icon'],
    ['jpeg', 'image/jpeg'],
    ['jpg', 'image/jpeg'],
    ['mkv', 'video/x-matroska'],
    ['mov', 'video/quicktime'],
    ['mp4', 'video/mp4'],
    ['pdf', 'application/pdf'],
    ['png', 'image/png'],
    ['zip', 'application/zip'],
    ['doc', 'application/msword'],
    ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
]);
function toFileWithPath(file, path) {
    var f = withMimeType(file);
    if (typeof f.path !== 'string') { // on electron, path is already set to the absolute path
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, 'path', {
            value: typeof path === 'string'
                ? path
                // If <input webkitdirectory> is set,
                // the File will have a {webkitRelativePath} property
                // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory
                : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0
                    ? webkitRelativePath
                    : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split('.')
            .pop().toLowerCase();
        var type = COMMON_MIME_TYPES.get(ext);
        if (type) {
            Object.defineProperty(file, 'type', {
                value: type,
                writable: false,
                configurable: false,
                enumerable: true
            });
        }
    }
    return file;
}
//# sourceMappingURL=file.js.map

/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FILE_INVALID_TYPE */
/* unused harmony export FILE_TOO_LARGE */
/* unused harmony export FILE_TOO_SMALL */
/* unused harmony export TOO_MANY_FILES */
/* unused harmony export getInvalidTypeRejectionErr */
/* unused harmony export getTooLargeRejectionErr */
/* unused harmony export getTooSmallRejectionErr */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TOO_MANY_FILES_REJECTION; });
/* harmony export (immutable) */ __webpack_exports__["d"] = fileAccepted;
/* harmony export (immutable) */ __webpack_exports__["e"] = fileMatchSize;
/* harmony export (immutable) */ __webpack_exports__["b"] = allFilesAccepted;
/* harmony export (immutable) */ __webpack_exports__["h"] = isPropagationStopped;
/* harmony export (immutable) */ __webpack_exports__["f"] = isEvtWithFiles;
/* unused harmony export isKindFile */
/* harmony export (immutable) */ __webpack_exports__["i"] = onDocumentDragOver;
/* harmony export (immutable) */ __webpack_exports__["g"] = isIeOrEdge;
/* harmony export (immutable) */ __webpack_exports__["c"] = composeEventHandlers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_attr_accept__ = __webpack_require__(1092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_attr_accept___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_attr_accept__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

 // Error codes

var FILE_INVALID_TYPE = 'file-invalid-type';
var FILE_TOO_LARGE = 'file-too-large';
var FILE_TOO_SMALL = 'file-too-small';
var TOO_MANY_FILES = 'too-many-files'; // File Errors

var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr(accept) {
  accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
  var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(', ')) : accept;
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(messageSuffix)
  };
};
var getTooLargeRejectionErr = function getTooLargeRejectionErr(maxSize) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(maxSize, " bytes")
  };
};
var getTooSmallRejectionErr = function getTooSmallRejectionErr(minSize) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(minSize, " bytes")
  };
};
var TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: 'Too many files'
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted

function fileAccepted(file, accept) {
  var isAcceptable = file.type === 'application/x-moz-file' || __WEBPACK_IMPORTED_MODULE_0_attr_accept___default.a(file, accept);
  return [isAcceptable, isAcceptable ? null : getInvalidTypeRejectionErr(accept)];
}
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size)) {
    if (isDefined(minSize) && isDefined(maxSize)) {
      if (file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
      if (file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
    } else if (isDefined(minSize) && file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];else if (isDefined(maxSize) && file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
  }

  return [true, null];
}

function isDefined(value) {
  return value !== undefined && value !== null;
}

function allFilesAccepted(_ref) {
  var files = _ref.files,
      accept = _ref.accept,
      minSize = _ref.minSize,
      maxSize = _ref.maxSize,
      multiple = _ref.multiple;

  if (!multiple && files.length > 1) {
    return false;
  }

  return files.every(function (file) {
    var _fileAccepted = fileAccepted(file, accept),
        _fileAccepted2 = _slicedToArray(_fileAccepted, 1),
        accepted = _fileAccepted2[0];

    var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
        _fileMatchSize2 = _slicedToArray(_fileMatchSize, 1),
        sizeMatch = _fileMatchSize2[0];

    return accepted && sizeMatch;
  });
} // React's synthetic events has event.isPropagationStopped,
// but to remain compatibility with other libs (Preact) fall back
// to check event.cancelBubble

function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === 'function') {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== 'undefined') {
    return event.cancelBubble;
  }

  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  } // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
  // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file


  return Array.prototype.some.call(event.dataTransfer.types, function (type) {
    return type === 'Files' || type === 'application/x-moz-file';
  });
}
function isKindFile(item) {
  return _typeof(item) === 'object' && item !== null && item.kind === 'file';
} // allow the entire document to be a drag target

function onDocumentDragOver(event) {
  event.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf('Edge/') !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
/**
 * This is intended to be used to compose event handlers
 * They are executed in order until one of them calls `event.isPropagationStopped()`.
 * Note that the check is done on the first invoke too,
 * meaning that if propagation was stopped before invoking the fns,
 * no handlers will be executed.
 *
 * @param {Function} fns the event hanlder functions
 * @return {Function} the event handler to add to an element
 */

function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return fns.some(function (fn) {
      if (!isPropagationStopped(event) && fn) {
        fn.apply(void 0, [event].concat(args));
      }

      return isPropagationStopped(event);
    });
  };
}

/***/ }),
/* 1092 */
/***/ (function(module, exports) {

module.exports=function(e){function r(n){if(t[n])return t[n].exports;var o=t[n]={i:n,l:!1,exports:{}};return e[n].call(o.exports,o,o.exports,r),o.l=!0,o.exports}var t={};return r.m=e,r.c=t,r.d=function(e,t,n){r.o(e,t)||Object.defineProperty(e,t,{configurable:!1,enumerable:!0,get:n})},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,r){return Object.prototype.hasOwnProperty.call(e,r)},r.p="",r(r.s=0)}([function(e,r,t){"use strict";r.__esModule=!0,r.default=function(e,r){if(e&&r){var t=Array.isArray(r)?r:r.split(","),n=e.name||"",o=e.type||"",u=o.replace(/\/.*$/,"");return t.some(function(e){var r=e.trim();return"."===r.charAt(0)?n.toLowerCase().endsWith(r.toLowerCase()):r.endsWith("/*")?u===r.replace(/\/.*$/,""):o===r})}return!0}}]);

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewDealPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _reactRouterDom = __webpack_require__(23);

var _Provisionsbestaetigung = __webpack_require__(601);

var _WiderrufsBelehrung = __webpack_require__(602);

var _VollmachtNotarauftrag = __webpack_require__(603);

var _UebergabeProtokoll = __webpack_require__(1097);

var _NotarDatenblatt = __webpack_require__(604);

var _TodoForm = __webpack_require__(1098);

var _TodoForm2 = _interopRequireDefault(_TodoForm);

var _FattureList = __webpack_require__(223);

var _FattureList2 = _interopRequireDefault(_FattureList);

var _ClientiList = __webpack_require__(125);

var _ClientiList2 = _interopRequireDefault(_ClientiList);

var _OggettiList = __webpack_require__(73);

var _OggettiList2 = _interopRequireDefault(_OggettiList);

var _Intestazione = __webpack_require__(20);

var _Intestazione2 = _interopRequireDefault(_Intestazione);

var _utils = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ViewDealPage = exports.ViewDealPage = function (_React$Component) {
  _inherits(ViewDealPage, _React$Component);

  function ViewDealPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ViewDealPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ViewDealPage.__proto__ || Object.getPrototypeOf(ViewDealPage)).call.apply(_ref, [this].concat(args))), _this), _this.findContact = function (contact) {
      return _this.props.clienti.filter(function (cliente) {
        return cliente.id === contact;
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ViewDealPage, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$deal = this.props.deal,
          acquirenteId = _props$deal.acquirenteId,
          acquirenteId2 = _props$deal.acquirenteId2,
          agenziaPartnerId = _props$deal.agenziaPartnerId,
          amount = _props$deal.amount,
          belastungsVollmacht = _props$deal.belastungsVollmacht,
          consulenteVendita = _props$deal.consulenteVendita,
          createdAt = _props$deal.createdAt,
          dataRogito = _props$deal.dataRogito,
          feePayed = _props$deal.feePayed,
          id = _props$deal.id,
          linguaRogito = _props$deal.linguaRogito,
          notaioId = _props$deal.notaioId,
          note = _props$deal.note,
          oggettoId = _props$deal.oggettoId,
          payedAtStefano = _props$deal.payedAtStefano,
          payedStefano = _props$deal.payedStefano,
          payedAgenziaPartner = _props$deal.payedAgenziaPartner,
          prezzoDiVendita = _props$deal.prezzoDiVendita,
          provvM2square = _props$deal.provvM2square,
          provvStefano = _props$deal.provvStefano,
          provvAgenziaPartner = _props$deal.provvAgenziaPartner,
          venditoreId = _props$deal.venditoreId,
          venditoreId2 = _props$deal.venditoreId2;
      var _props = this.props,
          utente = _props.utente,
          t = _props.t;

      var oggetto = this.props.oggetti.find(function (ogg) {
        return ogg.id === oggettoId;
      });
      var acquirente = this.findContact(acquirenteId);
      var acquirente2 = this.findContact(acquirenteId2);
      var venditore = this.findContact(venditoreId);
      var venditore2 = this.findContact(venditoreId2);
      var notaio = this.findContact(notaioId);
      var verwalter = this.findContact(oggetto.verwalter);
      var agenziaPartner = this.findContact(agenziaPartnerId);

      var kundenbetreuer = this.props.utenti.find(function (utente) {
        return utente.id === consulenteVendita;
      });
      var provvPercentuale = (0, _utils.formattaPrezzo)(amount / prezzoDiVendita / 2 * (100 + (0, _utils.trasformaInNumero)(this.props.firma.ivaApplicata, true)), false, true);
      var dataPrenotazione = (0, _utils.formattaData)(createdAt);
      // Determino quante fatture sono state pagate per mostrare i colori adatti. Da dealFature mi arriva un array
      var payed = 0;
      if (feePayed) {
        payed = 2;
      } else {
        this.props.fatture.map(function (fattura) {
          return fattura.payed && payed++;
        });
        if (payed > 0) {
          if (payed === this.props.fatture.length) {
            payed = 2;
          } else {
            payed = 1;
          }
        }
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Intestazione2.default, {
          intestazione: oggetto && 'Rif. Id: ' + oggetto.rifId + ' - ' + oggetto.via + ' ' + oggetto.numeroCivico + ', WE ' + oggetto.numeroAppartamento
        }),
        _react2.default.createElement(
          'div',
          { className: 'container section' },
          _react2.default.createElement(
            'div',
            null,
            (utente.role === 'Admin' || utente.role === 'Geschäftsführer') && _react2.default.createElement(
              _reactRouterDom.Link,
              {
                className: 'btn-floating orange right btn-floating-margin',
                to: '/edit/' + id
              },
              _react2.default.createElement(
                'i',
                { className: 'material-icons' },
                'edit'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            prezzoDiVendita > 0 && _react2.default.createElement(
              'h5',
              null,
              t('Prezzo di vendita'),
              ':',
              ' ',
              (0, _utils.formattaPrezzo)(prezzoDiVendita, true)
            ),
            createdAt > 0 && _react2.default.createElement(
              'p',
              null,
              t('Data prenotazione'),
              ': ',
              (0, _utils.formattaData)(createdAt)
            ),
            dataRogito > 0 && _react2.default.createElement(
              'p',
              null,
              t('Data del rogito'),
              ': ',
              (0, _utils.formattaData)(dataRogito)
            ),
            note && _react2.default.createElement(
              'p',
              null,
              t('Note'),
              ': ',
              note
            )
          ),
          _react2.default.createElement('div', { className: 'divider' }),
          _react2.default.createElement(
            'div',
            null,
            amount > 0 && _react2.default.createElement(
              'h5',
              null,
              t('Provvigione'),
              ':',
              ' ',
              utente.role === 'Admin' || utente.role === 'Geschäftsführer' ? (0, _utils.formattaPrezzo)(amount, true) : ''
            ),
            kundenbetreuer && _react2.default.createElement(
              'p',
              null,
              t('Consulente vendita'),
              ': ',
              kundenbetreuer.name
            ),
            utente.role === 'Admin' || utente.role === 'Geschäftsführer' ? provvM2square > 0 && _react2.default.createElement(
              'p',
              { className: 'list-item--paid' + payed },
              'm2Square: ',
              (0, _utils.formattaPrezzo)(provvM2square, true)
            ) : '',
            provvStefano > 0 && _react2.default.createElement(
              'p',
              { className: '' + (payedStefano && 'list-item--paid') },
              'Stefano: ',
              (0, _utils.formattaPrezzo)(provvStefano, true)
            ),
            payedAtStefano > 0 && _react2.default.createElement(
              'p',
              null,
              t('Pagato'),
              ' Stefano: ',
              (0, _utils.formattaData)(payedAtStefano)
            ),
            utente.role === 'Admin' || utente.role === 'Geschäftsführer' ? provvAgenziaPartner > 0 && _react2.default.createElement(
              'p',
              { className: '' + (payedAgenziaPartner && 'list-item--paid') },
              t('Provvigione'),
              ' ',
              t('Partner commerciale'),
              ':',
              ' ',
              (0, _utils.formattaPrezzo)(provvAgenziaPartner, true)
            ) : ''
          ),
          _react2.default.createElement('div', { className: 'divider' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'section' },
          _react2.default.createElement(
            'div',
            { className: 'grey lighten-4' },
            _react2.default.createElement(
              'div',
              { className: 'container' },
              _react2.default.createElement(
                'h1',
                null,
                t('Crea documentazione')
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'ul',
              { className: 'collection' },
              _react2.default.createElement(
                'li',
                { className: 'collection-item' },
                _react2.default.createElement(
                  'div',
                  null,
                  ' ',
                  t('Conferma provvigione'),
                  _react2.default.createElement(
                    'a',
                    { href: '#!', className: 'secondary-content' },
                    _react2.default.createElement(
                      'i',
                      {
                        className: 'material-icons',
                        onClick: function onClick() {
                          (0, _Provisionsbestaetigung.creaPrenotazione)(acquirente[0], acquirente2[0], venditore[0], venditore2[0], oggetto, provvPercentuale, prezzoDiVendita, _this2.props.firma);
                        }
                      },
                      'picture_as_pdf'
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'li',
                { className: 'collection-item' },
                _react2.default.createElement(
                  'div',
                  null,
                  t('Informativa sul diritto di recesso'),
                  _react2.default.createElement(
                    'a',
                    { href: '#!', className: 'secondary-content' },
                    _react2.default.createElement(
                      'i',
                      {
                        className: 'material-icons',
                        onClick: function onClick() {
                          (0, _WiderrufsBelehrung.widerrufsBelehrung)(acquirente[0], acquirente2[0], dataPrenotazione, oggetto, _this2.props.firma);
                        }
                      },
                      'picture_as_pdf'
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'li',
                { className: 'collection-item' },
                _react2.default.createElement(
                  'div',
                  null,
                  t('Delega richiesta bozza di contratto'),
                  _react2.default.createElement(
                    'a',
                    { href: '#!', className: 'secondary-content' },
                    _react2.default.createElement(
                      'i',
                      {
                        className: 'material-icons',
                        onClick: function onClick() {
                          (0, _VollmachtNotarauftrag.vollmachtNotarauftrag)(acquirente[0], acquirente2[0], venditore[0], venditore2[0], oggetto, notaio[0], prezzoDiVendita, _this2.props.firma);
                        }
                      },
                      'picture_as_pdf'
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'li',
                { className: 'collection-item' },
                _react2.default.createElement(
                  'div',
                  null,
                  t('Foglio informativo per il notaio'),
                  _react2.default.createElement(
                    'a',
                    { href: '#!', className: 'secondary-content' },
                    _react2.default.createElement(
                      'i',
                      {
                        className: 'material-icons',
                        onClick: function onClick() {
                          (0, _NotarDatenblatt.notarDatenblatt)(acquirente[0], acquirente2[0], venditore[0], venditore2[0], oggetto, notaio[0], verwalter[0], belastungsVollmacht, utente, _this2.props.firma, _this2.props.ceo, prezzoDiVendita, linguaRogito);
                        }
                      },
                      'picture_as_pdf'
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'li',
                { className: 'collection-item' },
                _react2.default.createElement(
                  'div',
                  null,
                  t('Protocollo consegna appartamento'),
                  _react2.default.createElement(
                    'a',
                    { href: '#!', className: 'secondary-content' },
                    _react2.default.createElement(
                      'i',
                      {
                        className: 'material-icons',
                        onClick: function onClick() {
                          (0, _UebergabeProtokoll.protocollo)(acquirente[0], acquirente2[0], venditore[0], venditore2[0], oggetto, _this2.props.utente, _this2.props.firma, _this2.props.ceo);
                        }
                      },
                      'picture_as_pdf'
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'grey lighten-4' },
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'h1',
              null,
              t('Informazioni')
            )
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_OggettiList2.default, { oggetto: [oggetto], ruolo: '' + t('Oggetti') })
        ),
        venditoreId && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_ClientiList2.default, { cliente: venditore, ruolo: '' + t('Venditore') })
        ),
        venditoreId2 && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_ClientiList2.default, { cliente: venditore2, ruolo: '2. ' + t('Venditore') })
        ),
        acquirenteId && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_ClientiList2.default, { cliente: acquirente, ruolo: '' + t('Acquirente') })
        ),
        acquirenteId2 && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_ClientiList2.default, {
            cliente: acquirente2,
            ruolo: '2. ' + t('Acquirente')
          })
        ),
        notaio && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_ClientiList2.default, { cliente: notaio, ruolo: '' + t('Notaio') })
        ),
        agenziaPartnerId && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_ClientiList2.default, {
            cliente: agenziaPartner,
            ruolo: '' + t('Partner commerciale')
          })
        ),
        utente.role === 'Admin' || utente.role === 'Geschäftsführer' ? _react2.default.createElement(_FattureList2.default, {
          dealFatture: this.props.fatture,
          ruolo: '' + t('Fatture')
        }) : '',
        _react2.default.createElement(_TodoForm2.default, { dealId: id })
      );
    }
  }]);

  return ViewDealPage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    deal: state.deals.find(function (deal) {
      return deal.id === props.match.params.id;
    }),
    clienti: state.clienti,
    oggetti: state.oggetti,
    fatture: state.fatture.filter(function (fattura) {
      return fattura.dealId === props.match.params.id;
    }),
    utente: state.utenti.find(function (utente) {
      return utente.firebaseAuthId === state.auth.uid;
    }),
    utenti: state.utenti,
    ceo: state.utenti.filter(function (utente) {
      return utente.role === 'Geschäftsführer';
    }),
    firma: state.firma[0]
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()(ViewDealPage));

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var imgData = exports.imgData = 'data:image/jpeg;base64,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';

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var imgData=exports.imgData='data:image/jpeg;base64,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';var imgData2=exports.imgData2='data:image/jpeg;base64,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';

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var imgData = exports.imgData = 'data:image/jpeg;base64,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';

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.protocollo = undefined;

var _jspdf = __webpack_require__(32);

var _jspdf2 = _interopRequireDefault(_jspdf);

var _ImageLogo = __webpack_require__(39);

var _utils = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var protocollo = exports.protocollo = function protocollo(acquirente, acquirente2, venditore, venditore2, oggetto, utente, firma, ceo) {
  var doc = new _jspdf2.default('p', 'mm', 'a4');
  doc.addImage(_ImageLogo.imgLogo, 'JPEG', 130, 10, 55, 12);

  //linea rossa
  doc.setDrawColor(145, 0, 0);
  doc.setLineWidth(7);
  doc.line(146, 26, 199, 26);
  //linea grigia
  doc.setDrawColor(143, 143, 143);
  doc.setLineWidth(7);
  doc.line(15, 26, 146, 26);

  //Header
  doc.setFontSize(11);
  doc.setTextColor(255, 255, 255);
  doc.setFont('times');
  doc.setFontType('bold');
  doc.text(firma.name + ' ' + (firma.name2 && ' - ' + firma.name2) + ' - ' + firma.adresse + ', ' + firma.plz + ' ' + firma.stadt, 19, 27);

  //riquadro contatti
  doc.setDrawColor(215, 240, 245);
  doc.setLineWidth(70);
  doc.line(146, 70, 199, 70);
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(10);
  doc.setFontType('normal');
  doc.text('Ihr Ansprechpartner', 149, 40);
  doc.setFontType('bold');
  doc.text('' + utente.name, 149, 44);
  doc.setFontType('normal');
  doc.text('' + utente.email, 149, 48);
  doc.text('Tel. ' + utente.telefon, 149, 52);
  doc.text('' + firma.website, 149, 56);
  doc.setFontType('bold');
  doc.text('Öffnungszeiten', 149, 68);
  doc.setFontType('normal');
  doc.text('' + firma.open, 149, 72);
  doc.setFontType('bold');
  doc.text('' + (firma.name2 ? firma.name2 : firma.name), 149, 84);
  doc.setFontType('normal');
  doc.text('' + firma.motto, 149, 88);
  doc.text('' + firma.adresse, 149, 92);
  doc.text(firma.plz + ' ' + firma.stadt, 149, 96);
  doc.text('' + firma.staat, 149, 100);

  //Dati oggetto e parti
  var dati = 40;
  doc.setFontSize(16);
  doc.setFontType('bold');
  doc.text('Übergabeprotokoll', 15, dati);
  doc.setFontSize(10);
  doc.text('Objekt: ' + (0, _utils.indirizzoOggetto)(oggetto), 15, dati + 10);
  doc.setFontType('normal');
  venditore.ditta ? doc.text('Alter Eigent\xFCmer: ' + venditore.ditta, 15, dati + 18) : doc.text('Alter Eigent\xFCmer: ' + venditore.nome + ' ' + venditore.cognome + (venditore2 ? ', ' + venditore2.nome + ' ' + venditore2.cognome : ''), 15, dati + 18);
  acquirente.ditta ? doc.text('Neuer Eigent\xFCmer: ' + acquirente.ditta, 15, dati + 24) : doc.text('Neuer Eigent\xFCmer: ' + acquirente.nome + ' ' + acquirente.cognome + (acquirente2 ? ', ' + acquirente2.nome + ' ' + acquirente2.cognome : ''), 15, dati + 24);

  //Schüssel
  doc.setFontType('bold');
  var chiavi = 75;
  doc.text('Schl\xFCssel\xFCbergabe', 15, chiavi);

  doc.setFontType('normal');
  doc.text('Hauseingangst\xFCr: ________________ - Wohnungst\xFCr: __________________', 15, chiavi + 8);
  doc.text('Keller: ________________________ - Briefkasten: ____________________', 15, chiavi + 16);
  doc.text('Sonstiges: ______________________________________________________', 15, chiavi + 24);

  //Heizkosten
  doc.setFontType('bold');
  var termosifoni = chiavi + 39;
  doc.text('Heizkostenverteiler', 15, termosifoni);

  doc.setFontType('normal');
  doc.text('Raum', 15, termosifoni + 7);
  doc.text('Zählernummer', 65, termosifoni + 7);
  doc.text('Zählerstand', 120, termosifoni + 7);
  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(0.2);
  doc.line(15, termosifoni + 8, 170, termosifoni + 8);
  doc.line(15, termosifoni + 16, 170, termosifoni + 16);
  doc.line(15, termosifoni + 24, 170, termosifoni + 24);
  doc.line(15, termosifoni + 32, 170, termosifoni + 32);
  doc.line(15, termosifoni + 40, 170, termosifoni + 40);
  doc.line(15, termosifoni + 48, 170, termosifoni + 48);
  doc.line(15, termosifoni + 56, 170, termosifoni + 56);
  doc.line(15, termosifoni + 64, 170, termosifoni + 64);
  doc.line(15, termosifoni + 8, 15, termosifoni + 64);
  doc.line(55, termosifoni + 8, 55, termosifoni + 64);
  doc.line(110, termosifoni + 8, 110, termosifoni + 64);
  doc.line(170, termosifoni + 8, 170, termosifoni + 64);

  //Gas Elektro Wasser
  doc.setFontType('bold');
  var gas = termosifoni + 75;
  doc.text('Gas', 17, gas + 15);
  doc.text('Elektro', 17, gas + 23);
  doc.text('Wasser Kalt', 17, gas + 31);
  doc.text('Wasser Warm', 17, gas + 39);

  doc.setFontType('normal');
  doc.text('Zählernummer', 65, gas + 7);
  doc.text('Zählerstand', 120, gas + 7);
  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(0.2);
  doc.line(15, gas + 8, 170, gas + 8);
  doc.line(15, gas + 16, 170, gas + 16);
  doc.line(15, gas + 24, 170, gas + 24);
  doc.line(15, gas + 32, 170, gas + 32);
  doc.line(15, gas + 40, 170, gas + 40);
  doc.line(15, gas + 8, 15, gas + 40);
  doc.line(55, gas + 8, 55, gas + 40);
  doc.line(110, gas + 8, 110, gas + 40);
  doc.line(170, gas + 8, 170, gas + 40);

  //Data
  doc.setFontType('normal');
  doc.text('Berlin,', 15, 240);

  //Firme

  doc.text('_____________________________', 15, 255);
  doc.text('Alter Eigentümer', 15, 260);
  doc.text('_____________________________', 110, 255);
  doc.text('Neuer Eigentümer', 110, 260);

  //Footer
  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(0.2);
  doc.line(15, 267, 15, 282);
  doc.line(55, 267, 55, 282);
  doc.line(110, 267, 110, 282);
  // doc.line(160, 267, 160, 282);
  doc.setFontSize(10);
  doc.setTextColor(143, 143, 143);
  doc.text('Inhaberin:', 16, 270);
  var position = 274;

  ceo.forEach(function (eachCeo) {
    doc.text('' + eachCeo.name, 16, position);
    position += 4;
  });
  doc.text('Telefon: ' + firma.telefon, 56, 270);
  doc.text('Telefax: ' + firma.fax, 56, 274);
  doc.text('E-Mail: ' + firma.email, 56, 278);
  doc.text('Web: ' + firma.website, 56, 282);
  doc.text('Steuernummer: ' + firma.steuerNr, 111, 270);
  doc.text('' + (firma.ustIdNr && 'Ust.-IdNr.: ' + firma.ustIdNr), 111, 274);

  //Logo IVD
  // doc.addImage(ivdLogo, 'JPEG', 161, 270, 30, 12);

  doc.save('\xDCbergabeprotokoll ' + (0, _utils.indirizzoOggetto)(oggetto) + '.pdf');
};
// import { ivdLogo } from './img/IvdLogo';

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TodoForm = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _configureStore = __webpack_require__(14);

var _Intestazione = __webpack_require__(20);

var _Intestazione2 = _interopRequireDefault(_Intestazione);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TodoForm = exports.TodoForm = function (_React$Component) {
  _inherits(TodoForm, _React$Component);

  function TodoForm(props) {
    _classCallCheck(this, TodoForm);

    var _this = _possibleConstructorReturn(this, (TodoForm.__proto__ || Object.getPrototypeOf(TodoForm)).call(this, props));

    _this.onTodoChange = function (item) {
      _this.setState(function () {
        return _defineProperty({}, item, !_this.state[item]);
      });
      _this.props.startEditDeal(_this.props.deal.id, _defineProperty({}, item, !_this.state[item]));
    };

    _this.renderTodoItem = function (item, label) {
      return _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'label',
          null,
          ' ',
          _react2.default.createElement('input', {
            type: 'checkbox',
            name: item,
            checked: _this.state[item],
            onChange: function onChange() {
              return _this.onTodoChange(item);
            }
          }),
          ' ',
          _react2.default.createElement(
            'span',
            null,
            label
          )
        )
      );
    };

    _this.state = {
      todo1: props.deal.todo1 ? props.deal.todo1 : false,
      todo2: props.deal.todo2 ? props.deal.todo2 : false,
      todo3: props.deal.todo3 ? props.deal.todo3 : false,
      todo4: props.deal.todo4 ? props.deal.todo4 : false,
      todo5: props.deal.todo5 ? props.deal.todo5 : false,
      todo6: props.deal.todo6 ? props.deal.todo6 : false,
      todo7: props.deal.todo7 ? props.deal.todo7 : false,
      todo8: props.deal.todo8 ? props.deal.todo8 : false,
      todo9: props.deal.todo9 ? props.deal.todo9 : false,
      todo10: props.deal.todo10 ? props.deal.todo10 : false,
      todo11: props.deal.todo11 ? props.deal.todo11 : false
    };
    return _this;
  }

  _createClass(TodoForm, [{
    key: 'render',
    value: function render() {
      var t = this.props.t;

      return _react2.default.createElement(
        'div',
        { className: 'margine-basso' },
        _react2.default.createElement(_Intestazione2.default, { intestazione: 'To-Do' }),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'ul',
            null,
            this.renderTodoItem('todo1', t('Prenotazione')),
            this.renderTodoItem('todo2', t('Informativa sul diritto di recesso')),
            this.renderTodoItem('todo3', t('Prova di solvibilità')),
            this.renderTodoItem('todo4', t("Documenti inviati all'acquirente")),
            this.renderTodoItem('todo5', t('Delega incarico notaio sottoscritta')),
            this.renderTodoItem('todo6', t('Foglio informativo per il notaio inviato')),
            this.renderTodoItem('todo7', t('Informazioni sul fondo di accantonamento')),
            this.renderTodoItem('todo8', t('Bozza di contratto')),
            this.renderTodoItem('todo9', t('Data rogito concordata')),
            this.renderTodoItem('todo10', t('Modulo riciclo di denaro compilato')),
            this.renderTodoItem('todo11', t('Immobile consegnato'))
          )
        )
      );
    }
  }]);

  return TodoForm;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    deal: state.deals.find(function (deal) {
      return deal.id === props.dealId;
    })
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    startEditDeal: function startEditDeal(id, deal) {
      return dispatch(_configureStore.storeActions.find(function (action) {
        return action.label === 'deals';
      }).startEditAction(id, deal));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactI18next.withTranslation)()(TodoForm));

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditUtentePage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _UserForm = __webpack_require__(605);

var _UserForm2 = _interopRequireDefault(_UserForm);

var _configureStore = __webpack_require__(14);

var _OptionModal = __webpack_require__(58);

var _OptionModal2 = _interopRequireDefault(_OptionModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditUtentePage = exports.EditUtentePage = function (_React$Component) {
  _inherits(EditUtentePage, _React$Component);

  function EditUtentePage() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, EditUtentePage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditUtentePage.__proto__ || Object.getPrototypeOf(EditUtentePage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isOpen: false,
      modalContent: 'remove_confirm',
      btnEnabled: true
    }, _this.handleOpenModal = function () {
      _this.setState(function () {
        return {
          isOpen: true
        };
      });
    }, _this.handleCloseModal = function () {
      _this.setState({ isOpen: false });
    }, _this.onSubmit = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(utente) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.props.startEditUser(_this.props.utente.id, utente);

              case 2:
                _this.props.history.push('/utenti');

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), _this.onRemove = function () {
      _this.props.startRemoveUser({ id: _this.props.utente.id });
      _this.props.history.push('/utenti');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EditUtentePage, [{
    key: 'render',
    value: function render() {
      if (!this.props.utente) {
        this.props.history.push('/utenti');
        return _react2.default.createElement(
          'div',
          null,
          'Loading...'
        );
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'h1',
              null,
              this.props.t('Modifica utente')
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'button',
            {
              className: 'btn-floating red right btn-floating-margin',
              onClick: this.handleOpenModal
            },
            _react2.default.createElement(
              'i',
              { className: 'material-icons' },
              'remove'
            )
          ),
          _react2.default.createElement(_OptionModal2.default, {
            isOpen: this.state.isOpen,
            contentLabel: 'remove',
            modalContent: this.props.t(this.state.modalContent),
            onCancel: this.handleCloseModal,
            onConfirm: this.onRemove,
            btnEnabled: this.state.btnEnabled
          }),
          _react2.default.createElement(_UserForm2.default, { user: this.props.utente, onSubmit: this.onSubmit })
        )
      );
    }
  }]);

  return EditUtentePage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    utente: state.utenti.find(function (utente) {
      return utente.id === props.match.params.id;
    })
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    startEditUser: function startEditUser(id, utente) {
      return dispatch(_configureStore.storeActions.find(function (action) {
        return action.label === 'utenti';
      }).startEditAction(id, utente));
    },
    startRemoveUser: function startRemoveUser(data) {
      return dispatch(_configureStore.storeActions.find(function (action) {
        return action.label === 'utenti';
      }).startRemoveAction(data));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactI18next.withTranslation)()(EditUtentePage));

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewUtentiPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _Intestazione = __webpack_require__(20);

var _Intestazione2 = _interopRequireDefault(_Intestazione);

var _elements = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ViewUtentiPage = exports.ViewUtentiPage = function (_React$Component) {
  _inherits(ViewUtentiPage, _React$Component);

  function ViewUtentiPage() {
    _classCallCheck(this, ViewUtentiPage);

    return _possibleConstructorReturn(this, (ViewUtentiPage.__proto__ || Object.getPrototypeOf(ViewUtentiPage)).apply(this, arguments));
  }

  _createClass(ViewUtentiPage, [{
    key: 'render',
    value: function render() {
      var t = this.props.t;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Intestazione2.default, { intestazione: t('Utente') }),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          this.props.utente.name.length > 0 && _react2.default.createElement(
            'div',
            null,
            t('Nome e cognome'),
            ': ',
            this.props.utente.name
          ),
          this.props.utente.role.length > 0 && _react2.default.createElement(
            'div',
            null,
            t('Ruolo'),
            ': ',
            this.props.utente.role
          ),
          (0, _elements.editButton)('/useredit/' + this.props.utente.id)
        )
      );
    }
  }]);

  return ViewUtentiPage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    utente: state.utenti.find(function (utente) {
      return utente.id === props.match.params.id;
    })
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()(ViewUtentiPage));

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _UtentiList = __webpack_require__(1102);

var _UtentiList2 = _interopRequireDefault(_UtentiList);

var _FirmaList = __webpack_require__(1103);

var _FirmaList2 = _interopRequireDefault(_FirmaList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UtentiDashboardPage = function UtentiDashboardPage() {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_UtentiList2.default, null),
    _react2.default.createElement(_FirmaList2.default, null)
  );
};

exports.default = UtentiDashboardPage;

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UtentiList = undefined;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(23);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _Card = __webpack_require__(56);

var _Card2 = _interopRequireDefault(_Card);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UtentiList = exports.UtentiList = function UtentiList(props) {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { className: 'grey lighten-4' },
      _react2.default.createElement(
        'div',
        { className: 'container' },
        _react2.default.createElement(
          'h1',
          null,
          props.t('Utenti')
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'container' },
      _react2.default.createElement(
        _reactRouterDom.Link,
        { className: 'btn-floating green right', to: '/utenticreate' },
        _react2.default.createElement(
          'i',
          { className: 'material-icons' },
          'add'
        )
      ),
      _react2.default.createElement(
        'div',
        null,
        props.utenti.length > 0 && props.utenti.map(function (utente) {
          return _react2.default.createElement(_Card2.default, {
            key: utente.id,
            titolo: '' + utente.name,
            sottotitolo: '' + utente.qualifica,
            titoloDestra: '' + utente.role,
            visible: true,
            link: '/utentiedit/' + utente.id,
            corpo: [utente.email, utente.telefon]
          });
        })
      )
    )
  );
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    utenti: state.utenti,
    firma: state.firma
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()(UtentiList));

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FirmaList = undefined;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(23);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _Card = __webpack_require__(56);

var _Card2 = _interopRequireDefault(_Card);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FirmaList = exports.FirmaList = function FirmaList(_ref) {
  var t = _ref.t,
      firma = _ref.firma;
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { className: 'grey lighten-4' },
      _react2.default.createElement(
        'div',
        { className: 'container' },
        _react2.default.createElement(
          'h1',
          null,
          t('Dati aziendali')
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'container' },
      _react2.default.createElement(
        'div',
        null,
        firma.length < 1 && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _reactRouterDom.Link,
            { className: 'btn-floating', to: '/firmacreate' },
            _react2.default.createElement(
              'i',
              { className: 'material-icons' },
              'add'
            )
          )
        )
      ),
      _react2.default.createElement(
        'div',
        null,
        firma && firma.map(function (firma) {
          var telefono = t('Telefono fisso') + ': ' + firma.telefon + ' - Fax: ' + firma.fax;
          var partitaIVA = t('Codice fiscale tedesco') + ' ' + firma.steuerNr + ' - Ust.-IdNr. ' + firma.ustIdNr;
          var orariApertura = t('Orari di apertura') + ' ' + firma.open;
          var datiBancari = t('Dati conto corrente') + ': ' + t('Intestatario') + ' ' + firma.kontoInhaber + ' - ' + t('Banca') + ' ' + firma.bank;
          var ibanBic = 'IBAN ' + firma.iban + ' - BIC ' + firma.bic;
          return _react2.default.createElement(_Card2.default, {
            key: firma.id,
            titolo: firma.name + ' ' + (firma.name2 && ' - ' + firma.name2),
            sottotitolo: firma.adresse + ', ' + firma.plz + ' ' + firma.stadt + ', ' + firma.staat,
            titoloDestra: '' + firma.email,
            visible: true,
            link: '/firmaedit/' + firma.id,
            corpo: [telefono, firma.website, partitaIVA, firma.motto, orariApertura, datiBancari, ibanBic]
          });
        })
      )
    )
  );
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    firma: state.firma
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()(FirmaList));

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditFirmaPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _FirmaForm = __webpack_require__(606);

var _FirmaForm2 = _interopRequireDefault(_FirmaForm);

var _configureStore = __webpack_require__(14);

var _OptionModal = __webpack_require__(58);

var _OptionModal2 = _interopRequireDefault(_OptionModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditFirmaPage = exports.EditFirmaPage = function (_React$Component) {
  _inherits(EditFirmaPage, _React$Component);

  function EditFirmaPage() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, EditFirmaPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditFirmaPage.__proto__ || Object.getPrototypeOf(EditFirmaPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isOpen: false,
      modalContent: 'remove_confirm',
      btnEnabled: true
    }, _this.handleOpenModal = function () {
      _this.setState(function () {
        return {
          isOpen: true
        };
      });
    }, _this.handleCloseModal = function () {
      _this.setState({ isOpen: false });
    }, _this.onSubmit = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(firma) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.props.startEditFirma(_this.props.firma.id, firma);

              case 2:
                _this.props.history.push('/utenti');

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), _this.onRemove = function () {
      _this.props.startRemoveFirma({ id: _this.props.firma.id });
      _this.props.history.push('/utenti');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EditFirmaPage, [{
    key: 'render',
    value: function render() {
      if (!this.props.firma) {
        this.props.history.push('/utenti');
        return _react2.default.createElement(
          'div',
          null,
          'Loading...'
        );
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'h1',
              null,
              this.props.t('Modifica dati azienda')
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(_OptionModal2.default, {
            isOpen: this.state.isOpen,
            contentLabel: 'remove',
            modalContent: this.props.t(this.state.modalContent),
            onCancel: this.handleCloseModal,
            onConfirm: this.onRemove,
            btnEnabled: this.state.btnEnabled
          }),
          _react2.default.createElement(_FirmaForm2.default, { firma: this.props.firma, onSubmit: this.onSubmit }),
          _react2.default.createElement(
            'button',
            {
              className: 'btn-floating red margine-basso',
              onClick: this.handleOpenModal
            },
            _react2.default.createElement(
              'i',
              { className: 'material-icons' },
              'delete'
            )
          )
        )
      );
    }
  }]);

  return EditFirmaPage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    firma: state.firma.find(function (firma) {
      return firma.id === props.match.params.id;
    })
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    startEditFirma: function startEditFirma(id, firma) {
      return dispatch(_configureStore.storeActions.find(function (action) {
        return action.label === 'firma';
      }).startEditAction(id, firma));
    },
    startRemoveFirma: function startRemoveFirma(data) {
      return dispatch(_configureStore.storeActions.find(function (action) {
        return action.label === 'firma';
      }).startRemoveAction(data));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactI18next.withTranslation)()(EditFirmaPage));

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewFirmaPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _Intestazione = __webpack_require__(20);

var _Intestazione2 = _interopRequireDefault(_Intestazione);

var _elements = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ViewFirmaPage = exports.ViewFirmaPage = function (_React$Component) {
  _inherits(ViewFirmaPage, _React$Component);

  function ViewFirmaPage() {
    _classCallCheck(this, ViewFirmaPage);

    return _possibleConstructorReturn(this, (ViewFirmaPage.__proto__ || Object.getPrototypeOf(ViewFirmaPage)).apply(this, arguments));
  }

  _createClass(ViewFirmaPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Intestazione2.default, { intestazione: 'Firma' }),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          this.props.utente.name.length > 0 && _react2.default.createElement(
            'div',
            null,
            'Name: ',
            this.props.utente.name
          ),
          this.props.utente.role.length > 0 && _react2.default.createElement(
            'div',
            null,
            'Rolle: ',
            this.props.utente.role
          ),
          (0, _elements.editButton)('/useredit/' + this.props.utente.id)
        )
      );
    }
  }]);

  return ViewFirmaPage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    firma: state.firma.find(function (firma) {
      return firma.id === props.match.params.id;
    })
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()(ViewFirmaPage));

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditClientePage = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _ClientiForm = __webpack_require__(607);

var _ClientiForm2 = _interopRequireDefault(_ClientiForm);

var _configureStore = __webpack_require__(14);

var _OptionModal = __webpack_require__(58);

var _OptionModal2 = _interopRequireDefault(_OptionModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditClientePage = exports.EditClientePage = function (_React$Component) {
  _inherits(EditClientePage, _React$Component);

  function EditClientePage() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, EditClientePage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditClientePage.__proto__ || Object.getPrototypeOf(EditClientePage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isOpen: false,
      modalContent: 'remove_confirm',
      btnEnabled: true
    }, _this.handleOpenModal = function () {
      _this.setState(function () {
        return {
          isOpen: true
        };
      });
    }, _this.handleCloseModal = function () {
      _this.setState({ isOpen: false });
    }, _this.onSubmit = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(cliente) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.props.startEditCustomer(_this.props.cliente.id, cliente);

              case 2:
                _this.props.history.push('/clientiview/' + _this.props.cliente.id);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), _this.onValidate = function () {
      var lead = _this.props.leads.find(function (lead) {
        return lead.leadId === _this.props.cliente.id;
      });
      var deals = _this.props.deals.find(function (deal) {
        return deal.agenziaPartnerId === _this.props.cliente.id || deal.venditoreId === _this.props.cliente.id || deal.venditoreId2 === _this.props.cliente.id || deal.acquirenteId === _this.props.cliente.id || deal.acquirenteId2 === _this.props.cliente.id || deal.notaioId === _this.props.cliente.id;
      });
      var oggetti = _this.props.oggetti.find(function (oggetto) {
        return oggetto.proprietarioId === _this.props.cliente.id || oggetto.proprietarioId2 === _this.props.cliente.id || oggetto.verwalter === _this.props.cliente.id;
      });
      var fatture = _this.props.fatture.find(function (fattura) {
        return fattura.clienteId === _this.props.cliente.id || fattura.clienteId2 === _this.props.cliente.id;
      });
      if (!lead && !deals && !oggetti && !fatture) {
        return true;
      } else {
        return false;
      }
    }, _this.onRemove = function () {
      if (_this.onValidate()) {
        _this.props.startRemoveCustomer({ id: _this.props.cliente.id });
        _this.props.history.push('/clienti');
      } else {
        _this.setState(function () {
          return {
            isOpen: true,
            modalContent: 'cannot_delete',
            btnEnabled: false
          };
        });
      }
    }, _this.onDisable = function () {
      if (_this.onValidate()) {
        _this.props.startEditCustomer(_this.props.cliente.id, _extends({}, _this.props.cliente, {
          visible: false
        }));
        _this.props.history.push('/clienti');
      } else {
        _this.setState(function () {
          return {
            isOpen: true,
            modalContent: 'cannot_delete',
            btnEnabled: false
          };
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // prima di cancellare verifico se non è usato in altri campi


  _createClass(EditClientePage, [{
    key: 'render',
    value: function render() {
      if (!this.props.cliente || this.props.utente.role === 'Mitarbeiter' && !this.props.cliente.visible) {
        this.props.history.push('/clienti');
        return _react2.default.createElement(
          'div',
          null,
          'Loading...'
        );
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'h1',
              null,
              this.props.t('Modifica contatto')
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(_OptionModal2.default, {
            isOpen: this.state.isOpen,
            contentLabel: 'remove',
            modalContent: this.props.t(this.state.modalContent),
            onCancel: this.handleCloseModal,
            onConfirm: this.props.utente.role === 'Admin' ? this.onRemove : this.onDisable,
            btnEnabled: this.state.btnEnabled
          }),
          _react2.default.createElement(_ClientiForm2.default, {
            customer: this.props.cliente,
            onSubmit: this.onSubmit
          }),
          _react2.default.createElement(
            'button',
            {
              className: 'btn-floating red margine-basso',
              onClick: this.handleOpenModal
            },
            _react2.default.createElement(
              'i',
              { className: 'material-icons' },
              'delete'
            )
          )
        )
      );
    }
  }]);

  return EditClientePage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    cliente: state.clienti.find(function (cliente) {
      return cliente.id === props.match.params.id;
    }),
    utente: state.utenti.find(function (utente) {
      return utente.firebaseAuthId === state.auth.uid;
    }),
    leads: state.leads,
    deals: state.deals,
    oggetti: state.oggetti,
    fatture: state.fatture
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    startEditCustomer: function startEditCustomer(id, cliente, visible) {
      return dispatch(_configureStore.storeActions.find(function (action) {
        return action.label === 'clienti';
      }).startEditAction(id, cliente, visible));
    },
    startRemoveCustomer: function startRemoveCustomer(data) {
      return dispatch(_configureStore.storeActions.find(function (action) {
        return action.label === 'clienti';
      }).startRemoveAction(data));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactI18next.withTranslation)()(EditClientePage));

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewClientiPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _DealList = __webpack_require__(195);

var _DealList2 = _interopRequireDefault(_DealList);

var _FattureList = __webpack_require__(223);

var _FattureList2 = _interopRequireDefault(_FattureList);

var _LeadsList = __webpack_require__(159);

var _LeadsList2 = _interopRequireDefault(_LeadsList);

var _OggettiList = __webpack_require__(73);

var _OggettiList2 = _interopRequireDefault(_OggettiList);

var _Intestazione = __webpack_require__(20);

var _Intestazione2 = _interopRequireDefault(_Intestazione);

var _elements = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ViewClientiPage = exports.ViewClientiPage = function (_React$Component) {
  _inherits(ViewClientiPage, _React$Component);

  function ViewClientiPage() {
    _classCallCheck(this, ViewClientiPage);

    return _possibleConstructorReturn(this, (ViewClientiPage.__proto__ || Object.getPrototypeOf(ViewClientiPage)).apply(this, arguments));
  }

  _createClass(ViewClientiPage, [{
    key: 'render',
    value: function render() {
      var _props$cliente = this.props.cliente,
          cap = _props$cliente.cap,
          cellulare = _props$cliente.cellulare,
          cognome = _props$cliente.cognome,
          comune = _props$cliente.comune,
          consulenteVenditaId = _props$cliente.consulenteVenditaId,
          ditta = _props$cliente.ditta,
          email = _props$cliente.email,
          fax = _props$cliente.fax,
          id = _props$cliente.id,
          indirizzo = _props$cliente.indirizzo,
          indirizzo2 = _props$cliente.indirizzo2,
          nazione = _props$cliente.nazione,
          nome = _props$cliente.nome,
          note = _props$cliente.note,
          telefono1 = _props$cliente.telefono1,
          titolo = _props$cliente.titolo,
          www = _props$cliente.www,
          consensoDSGVO = _props$cliente.consensoDSGVO;
      var _props = this.props,
          utente = _props.utente,
          t = _props.t;


      var dealFatture = this.props.fatture.filter(function (fattura) {
        return fattura.clienteId === id || fattura.clienteId2 === id;
      });
      var clienteDeals = this.props.deals.filter(function (deal) {
        return deal.acquirenteId === id || deal.acquirenteId2 === id || deal.venditoreId === id || deal.venditoreId2 === id || deal.agenziaPartnerId === id;
      });
      var consulenteVendita = this.props.utenti.find(function (utente) {
        return utente.id === consulenteVenditaId;
      });
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Intestazione2.default, {
          intestazione: cognome && _react2.default.createElement(
            'span',
            null,
            titolo,
            ' ',
            nome,
            ' ',
            cognome
          )
        }),
        _react2.default.createElement(
          'div',
          { className: 'container section' },
          _react2.default.createElement(
            'div',
            null,
            (0, _elements.editButton)('/clientiedit/' + id),
            (0, _elements.contactDetailsButton)(this.props.cliente)
          ),
          _react2.default.createElement(
            'div',
            null,
            ditta && _react2.default.createElement(
              'h5',
              null,
              ditta
            ),
            consulenteVendita && _react2.default.createElement(
              'p',
              null,
              '(' + consulenteVendita.name + ')'
            ),
            indirizzo && _react2.default.createElement(
              'p',
              null,
              indirizzo + ' ' + (indirizzo2 && indirizzo2) + ', ' + cap + ' ' + comune + (nazione && ', ' + nazione)
            ),
            telefono1 && _react2.default.createElement(
              'p',
              null,
              t('Telefono fisso'),
              ': ',
              telefono1
            ),
            fax && _react2.default.createElement(
              'p',
              null,
              'Fax: ',
              fax
            ),
            cellulare && _react2.default.createElement(
              'p',
              null,
              t('Cellulare'),
              ': ',
              cellulare
            ),
            www && _react2.default.createElement(
              'p',
              null,
              t('Sito web'),
              ': ',
              _react2.default.createElement(
                'a',
                { href: 'http://' + www },
                www
              )
            ),
            email && _react2.default.createElement(
              'p',
              null,
              t('Email'),
              ': ',
              _react2.default.createElement(
                'a',
                { href: 'mailto:' + email },
                email
              )
            ),
            note && _react2.default.createElement(
              'p',
              null,
              t('Note'),
              ': ',
              note
            ),
            consensoDSGVO && _react2.default.createElement(
              'p',
              null,
              t('Consenso al trattamento dei dati personali'),
              ': ',
              t('sì')
            )
          )
        ),
        _react2.default.createElement(_LeadsList2.default, { userLeads: this.props.leads, ruolo: t('Richieste') }),
        _react2.default.createElement(_OggettiList2.default, { oggetto: this.props.oggetti, ruolo: t('Oggetti') }),
        _react2.default.createElement(_DealList2.default, { clienteDeals: clienteDeals, ruolo: t('Vendite') }),
        (utente.role === 'Admin' || utente.role === 'Geschäftsführer') && _react2.default.createElement(_FattureList2.default, { dealFatture: dealFatture, ruolo: t('invoices') })
      );
    }
  }]);

  return ViewClientiPage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    cliente: state.clienti.find(function (cliente) {
      return cliente.id === props.match.params.id;
    }),
    leads: state.leads.filter(function (lead) {
      return lead.leadId === props.match.params.id;
    }),
    oggetti: state.oggetti.filter(function (oggetto) {
      return oggetto.proprietarioId === props.match.params.id || oggetto.proprietarioId2 === props.match.params.id || oggetto.verwalter === props.match.params.id;
    }),
    fatture: state.fatture,
    deals: state.deals,
    utente: state.utenti.find(function (utente) {
      return utente.firebaseAuthId === state.auth.uid;
    }),
    utenti: state.utenti,
    lingua: state.lingua
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()(ViewClientiPage));

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// Get visible leads

exports.default = function (leads, _ref) {
  var lead = _ref.lead,
      leadStato = _ref.leadStato,
      sortBy = _ref.sortBy;

  return leads.filter(function (illead) {
    var budgetMatch = illead.leadBudget >= lead * 100 && illead.leadBudget <= lead * 120 || !lead;
    var statoMatch = illead.leadOggettoStato === leadStato || leadStato === '' || illead.leadOggettoStato === '';
    return budgetMatch && statoMatch;
  }).sort(function (a, b) {
    if (sortBy === 'date') {
      return a.leadCreatedAt < b.leadCreatedAt ? 1 : -1;
    } else if (sortBy === 'amount') {
      return a.leadBudget > b.leadBudget ? 1 : -1;
    }
  });
};

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _ClientiList = __webpack_require__(125);

var _ClientiList2 = _interopRequireDefault(_ClientiList);

var _ListFilters = __webpack_require__(96);

var _ListFilters2 = _interopRequireDefault(_ListFilters);

var _configureStore = __webpack_require__(14);

var _elements = __webpack_require__(18);

var _Intestazione = __webpack_require__(20);

var _Intestazione2 = _interopRequireDefault(_Intestazione);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ClientiDashboardPage = function (_React$Component) {
  _inherits(ClientiDashboardPage, _React$Component);

  function ClientiDashboardPage() {
    _classCallCheck(this, ClientiDashboardPage);

    return _possibleConstructorReturn(this, (ClientiDashboardPage.__proto__ || Object.getPrototypeOf(ClientiDashboardPage)).apply(this, arguments));
  }

  _createClass(ClientiDashboardPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.startSetCustomers();
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;


      var options = [{ value: 'name', label: 'Cognome' }, { value: 'date', label: 'Data' }];

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Intestazione2.default, { intestazione: t('Rubrica contatti') }),
        _react2.default.createElement(_ListFilters2.default, { options: options }),
        (0, _elements.addButton)('/clienticreate'),
        _react2.default.createElement(_ClientiList2.default, null)
      );
    }
  }]);

  return ClientiDashboardPage;
}(_react2.default.Component);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    startSetCustomers: function startSetCustomers() {
      return dispatch(_configureStore.storeActions.find(function (action) {
        return action.label === 'clienti';
      }).startSetAction());
    }
  };
};

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)((0, _reactI18next.withTranslation)()(ClientiDashboardPage));

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditFatturaPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _FatturaForm = __webpack_require__(608);

var _FatturaForm2 = _interopRequireDefault(_FatturaForm);

var _configureStore = __webpack_require__(14);

var _OptionModal = __webpack_require__(58);

var _OptionModal2 = _interopRequireDefault(_OptionModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditFatturaPage = exports.EditFatturaPage = function (_React$Component) {
  _inherits(EditFatturaPage, _React$Component);

  function EditFatturaPage() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, EditFatturaPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditFatturaPage.__proto__ || Object.getPrototypeOf(EditFatturaPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isOpen: false,
      modalContent: 'remove_confirm',
      btnEnabled: true
    }, _this.handleOpenModal = function () {
      _this.setState(function () {
        return {
          isOpen: true
        };
      });
    }, _this.handleCloseModal = function () {
      _this.setState({ isOpen: false });
    }, _this.onSubmit = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(fattura) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.props.startEditFattura(_this.props.fattura.id, fattura);

              case 2:
                _this.props.history.push('/fatturaview/' + _this.props.fattura.id);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), _this.onRemove = function () {
      _this.props.startRemoveFattura({ id: _this.props.fattura.id });
      _this.props.history.push('/fatture');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EditFatturaPage, [{
    key: 'render',
    value: function render() {
      if (!this.props.fattura) {
        this.props.history.push('/fatture');
        return _react2.default.createElement(
          'div',
          null,
          'Loading...'
        );
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'h1',
              null,
              this.props.t('Modifica fattura')
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(_OptionModal2.default, {
            isOpen: this.state.isOpen,
            contentLabel: 'remove',
            modalContent: this.props.t(this.state.modalContent),
            onCancel: this.handleCloseModal,
            onConfirm: this.onRemove,
            btnEnabled: this.state.btnEnabled
          }),
          _react2.default.createElement(_FatturaForm2.default, { fattura: this.props.fattura, onSubmit: this.onSubmit }),
          _react2.default.createElement(
            'button',
            {
              className: 'btn-floating red margine-basso',
              onClick: this.handleOpenModal
            },
            _react2.default.createElement(
              'i',
              { className: 'material-icons' },
              'delete'
            )
          )
        )
      );
    }
  }]);

  return EditFatturaPage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    fattura: state.fatture.find(function (fattura) {
      return fattura.id === props.match.params.id;
    })
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    startEditFattura: function startEditFattura(id, fattura) {
      return dispatch(_configureStore.storeActions.find(function (action) {
        return action.label === 'fatture';
      }).startEditAction(id, fattura));
    },
    startRemoveFattura: function startRemoveFattura(data) {
      return dispatch(_configureStore.storeActions.find(function (action) {
        return action.label === 'fatture';
      }).startRemoveAction(data));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactI18next.withTranslation)()(EditFatturaPage));

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewFatturePage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _Fattura = __webpack_require__(1112);

var _Mahnung = __webpack_require__(1113);

var _Mahnung2 = __webpack_require__(1114);

var _Zahlungserinnerung = __webpack_require__(1115);

var _OggettiList = __webpack_require__(73);

var _OggettiList2 = _interopRequireDefault(_OggettiList);

var _DealList = __webpack_require__(195);

var _DealList2 = _interopRequireDefault(_DealList);

var _ClientiList = __webpack_require__(125);

var _ClientiList2 = _interopRequireDefault(_ClientiList);

var _Intestazione = __webpack_require__(20);

var _Intestazione2 = _interopRequireDefault(_Intestazione);

var _utils = __webpack_require__(9);

var _elements = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ViewFatturePage = exports.ViewFatturePage = function (_React$Component) {
  _inherits(ViewFatturePage, _React$Component);

  function ViewFatturePage() {
    _classCallCheck(this, ViewFatturePage);

    return _possibleConstructorReturn(this, (ViewFatturePage.__proto__ || Object.getPrototypeOf(ViewFatturePage)).apply(this, arguments));
  }

  _createClass(ViewFatturePage, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var t = this.props.t;

      var singleFattura = this.props.fatture.find(function (fattura) {
        return fattura.id === _this2.props.match.params.id;
      });
      var deal = this.props.deals.find(function (deal) {
        return deal.id === singleFattura.dealId;
      });

      var oggetto = deal ? this.props.oggetti.find(function (ogg) {
        return ogg.id === deal.oggettoId;
      }) : '';
      var acquirente = deal ? this.props.clienti.find(function (ilcliente) {
        return ilcliente.id === deal.acquirenteId;
      }) : '';
      var acquirente2 = deal ? this.props.clienti.find(function (ilcliente) {
        return ilcliente.id === deal.acquirenteId2;
      }) : '';
      var cliente = this.props.clienti.find(function (cliente) {
        return cliente.id === singleFattura.clienteId;
      });
      var cliente2 = this.props.clienti.find(function (cliente) {
        return cliente.id === singleFattura.clienteId2;
      });
      var ceo = this.props.utenti.filter(function (utente) {
        return utente.role === 'Geschäftsführer';
      });
      var utente = this.props.utenti.find(function (utente) {
        return utente.firebaseAuthId === _this2.props.auth.uid;
      });

      if (singleFattura) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_Intestazione2.default, {
            intestazione: oggetto ? 'Rif. Id: ' + oggetto.rifId + ' - ' + (0, _utils.indirizzoOggetto)(oggetto) : singleFattura.descrizioneProdotto
          }),
          _react2.default.createElement(
            'div',
            { className: 'container section' },
            _react2.default.createElement(
              'div',
              null,
              (0, _elements.editButton)('/fatturaedit/' + singleFattura.id)
            ),
            _react2.default.createElement(
              'div',
              { className: 'section' },
              deal && deal.dealType,
              singleFattura.numeroFattura && _react2.default.createElement(
                'h5',
                null,
                t('Numero fattura'),
                ': ',
                singleFattura.numeroFattura
              ),
              _react2.default.createElement(
                'h5',
                null,
                t('Importo netto'),
                ':',
                ' ',
                (0, _utils.formattaPrezzo)(singleFattura.importoNetto, true)
              ),
              singleFattura.note,
              _react2.default.createElement(
                'div',
                { className: 'list-item__title' },
                oggetto && 'Rif. Id: ' + oggetto.rifId + ' - ' + (0, _utils.indirizzoOggetto)(oggetto)
              ),
              cliente && _react2.default.createElement(
                'div',
                null,
                t('Cliente'),
                ': ',
                cliente.nome,
                ' ',
                cliente.cognome,
                ' ',
                cliente.ditta && ' - Firma: ' + cliente.ditta
              ),
              cliente2 && _react2.default.createElement(
                'div',
                null,
                '2. ',
                t('Cliente'),
                ': ',
                cliente2.nome,
                ' ',
                cliente2.cognome,
                ' ',
                cliente2.ditta && ' - Firma: ' + cliente2.ditta
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              singleFattura.dataFattura && _react2.default.createElement(
                'div',
                null,
                t('Data fattura'),
                ': ',
                (0, _utils.formattaData)(singleFattura.dataFattura)
              ),
              singleFattura && _react2.default.createElement(
                'div',
                null,
                t('vat_applied'),
                ': ',
                this.props.firma.ivaApplicata,
                '%'
              ),
              singleFattura.dataZahlungserinnerung && _react2.default.createElement(
                'div',
                null,
                t('Sollecito'),
                ':',
                ' ',
                (0, _utils.formattaData)(singleFattura.dataZahlungserinnerung)
              ),
              singleFattura.dataMahnung && _react2.default.createElement(
                'div',
                null,
                '1. ',
                t('Sollecito con penale'),
                ':',
                ' ',
                (0, _utils.formattaData)(singleFattura.dataMahnung)
              ),
              singleFattura.dataMahnung2 && _react2.default.createElement(
                'div',
                null,
                '2. ',
                t('Sollecito con penale'),
                ':',
                ' ',
                (0, _utils.formattaData)(singleFattura.dataMahnung2)
              ),
              deal && deal.dataRogito > 0 && _react2.default.createElement(
                'div',
                null,
                t('Data del rogito'),
                ': ',
                (0, _utils.formattaData)(deal.dataRogito)
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'section' },
            _react2.default.createElement(
              'div',
              { className: 'grey lighten-4' },
              _react2.default.createElement(
                'div',
                { className: 'container' },
                _react2.default.createElement(
                  'h1',
                  null,
                  t('Crea documentazione')
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'container' },
              _react2.default.createElement(
                'ul',
                { className: 'collection' },
                _react2.default.createElement(
                  'li',
                  { className: 'collection-item' },
                  _react2.default.createElement(
                    'div',
                    null,
                    ' ',
                    t('Fattura'),
                    _react2.default.createElement(
                      'a',
                      { href: '#!', className: 'secondary-content' },
                      _react2.default.createElement(
                        'i',
                        {
                          className: 'material-icons',
                          onClick: function onClick() {
                            (0, _Fattura.fattura)(cliente, cliente2, singleFattura.numeroFattura, singleFattura.dataFattura, singleFattura.descrizioneProdotto, singleFattura.importoNetto, _this2.props.firma.ivaApplicata, singleFattura.dataPrestazione, oggetto, deal && deal.prezzoDiVendita, deal && deal.dataRogito, deal && deal.amount, deal && deal.createdAt, deal && deal.dealType, acquirente, acquirente2, _this2.props.firma, utente, ceo);
                          }
                        },
                        'picture_as_pdf'
                      )
                    )
                  )
                ),
                singleFattura.dataZahlungserinnerung && _react2.default.createElement(
                  'li',
                  { className: 'collection-item' },
                  _react2.default.createElement(
                    'div',
                    null,
                    t('Sollecito'),
                    _react2.default.createElement(
                      'a',
                      { href: '#!', className: 'secondary-content' },
                      _react2.default.createElement(
                        'i',
                        {
                          className: 'material-icons',
                          onClick: function onClick() {
                            (0, _Zahlungserinnerung.zahlungserinnerung)(cliente, cliente2, singleFattura.numeroFattura, singleFattura.dataFattura, singleFattura.dataZahlungserinnerung, deal && deal.amount, _this2.props.firma, utente, ceo, singleFattura.importoNetto, _this2.props.firma.ivaApplicata);
                          }
                        },
                        'picture_as_pdf'
                      )
                    )
                  )
                ),
                singleFattura.dataMahnung && _react2.default.createElement(
                  'li',
                  { className: 'collection-item' },
                  _react2.default.createElement(
                    'div',
                    null,
                    t('Sollecito con penale'),
                    _react2.default.createElement(
                      'a',
                      { href: '#!', className: 'secondary-content' },
                      _react2.default.createElement(
                        'i',
                        {
                          className: 'material-icons',
                          onClick: function onClick() {
                            (0, _Mahnung.mahnung)(cliente, cliente2, singleFattura.numeroFattura, singleFattura.dataFattura, singleFattura.dataZahlungserinnerung, singleFattura.dataMahnung, deal && deal.amount, singleFattura.mahngebuehren, _this2.props.firma, utente, ceo, singleFattura.importoNetto, _this2.props.firma.ivaApplicata);
                          }
                        },
                        'picture_as_pdf'
                      )
                    )
                  )
                ),
                singleFattura.dataMahnung2 && _react2.default.createElement(
                  'li',
                  { className: 'collection-item' },
                  _react2.default.createElement(
                    'div',
                    null,
                    '2. ',
                    t('Sollecito con penale'),
                    _react2.default.createElement(
                      'a',
                      { href: '#!', className: 'secondary-content' },
                      _react2.default.createElement(
                        'i',
                        {
                          className: 'material-icons',
                          onClick: function onClick() {
                            (0, _Mahnung2.mahnung2)(cliente, cliente2, singleFattura.numeroFattura, singleFattura.dataFattura, singleFattura.dataZahlungserinnerung, singleFattura.dataMahnung, singleFattura.dataMahnung2, deal && deal.amount, singleFattura.mahngebuehren2, _this2.props.firma, utente, ceo, singleFattura.importoNetto, _this2.props.firma.ivaApplicata);
                          }
                        },
                        'picture_as_pdf'
                      )
                    )
                  )
                )
              )
            )
          ),
          deal && _react2.default.createElement(_DealList2.default, { clienteDeals: [deal], ruolo: '' + t('Vendita') }),
          oggetto && _react2.default.createElement(_OggettiList2.default, { oggetto: [oggetto], ruolo: '' + t('Oggetto') }),
          cliente && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_ClientiList2.default, {
              cliente: [cliente],
              ruolo: '' + t('Intestatario fattura')
            })
          ),
          cliente2 && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_ClientiList2.default, {
              cliente: [cliente2],
              ruolo: '2. ' + t('Intestatario fattura')
            })
          )
        );
      } else {
        return _react2.default.createElement(
          'div',
          null,
          'Loading...'
        );
      }
    }
  }]);

  return ViewFatturePage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    fatture: state.fatture,
    clienti: state.clienti,
    deals: state.deals,
    oggetti: state.oggetti,
    firma: state.firma[0],
    utenti: state.utenti,
    lingua: state.lingua,
    auth: state.auth
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()(ViewFatturePage));

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fattura = undefined;

var _jspdf = __webpack_require__(32);

var _jspdf2 = _interopRequireDefault(_jspdf);

var _ImageLogo = __webpack_require__(39);

var _utils = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fattura = exports.fattura = function fattura(cliente, cliente2, numeroFattura, dataFattura, descrizioneProdotto, importoNetto) {
  var iva = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 19;
  var dataPrestazione = arguments[7];
  var oggetto = arguments[8];
  var prezzoDiVendita = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : '0';
  var dataRogito = arguments[10];
  var amount = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : '0';
  var dataPrenotazione = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : null;
  var dealType = arguments.length > 13 && arguments[13] !== undefined ? arguments[13] : '';
  var acquirente = arguments[14];
  var acquirente2 = arguments[15];
  var firma = arguments[16];
  var utente = arguments[17];
  var ceo = arguments.length > 18 && arguments[18] !== undefined ? arguments[18] : [];

  var doc = new _jspdf2.default('p', 'mm', 'a4');
  var acqNome = cliente && cliente.titolo + ' ' + cliente.nome + ' ' + cliente.cognome;
  var acqInd = cliente && cliente.indirizzo + ' ' + (cliente.indirizzo2 && cliente.indirizzo2);
  var acqNome2 = cliente2 && cliente2.titolo + ' ' + cliente2.nome + ' ' + cliente2.cognome;
  var acqInd2 = cliente2 && cliente2.indirizzo + ' ' + (cliente2.indirizzo2 && cliente2.indirizzo2);
  var formulaSaluto = 'Sehr geehrte Damen und Herren';
  if (cliente.titolo === 'Herr') {
    formulaSaluto = 'Sehr geehrter Herr';
  } else if (cliente.titolo === 'Frau') {
    formulaSaluto = 'Sehr geehrte Frau';
  }
  var formulaSaluto2 = 'Sehr geehrte Damen und Herren';
  if (cliente2) {
    if (cliente2.titolo === 'Herr') {
      formulaSaluto2 = 'Sehr geehrter Herr';
    } else if (cliente2.titolo === 'Frau') {
      formulaSaluto2 = 'Sehr geehrte Frau';
    }
  }
  var provvPercentuale = importoNetto ? (0, _utils.formattaPrezzo)(importoNetto / prezzoDiVendita, false, true, true) : (0, _utils.formattaPrezzo)(amount / prezzoDiVendita, false, true, true);
  var corpoFattura = void 0;
  if (dealType === 'Kauf Eigentumswohnung' || dealType === 'Kauf Gewerbe') {
    corpoFattura = 'entsprechend dem rechtskr\xE4ftigen Kaufvertrag vom ' + (0, _utils.formattaData)(dataRogito) + ' sowie unserer Vereinbarung berechnen wir Ihnen f\xFCr unsere Nachweis- bzw. Vermittlungst\xE4tigkeit zum Verkauf des Objekts ' + oggetto.via + ' ' + oggetto.numeroCivico + ', ' + (dealType === 'Kauf Eigentumswohnung' ? 'WE' : 'TE') + ' ' + oggetto.numeroAppartamento + ', ' + oggetto.cap + ' ' + oggetto.citta + ':';
  } else if (dealType === 'APH') {
    corpoFattura = 'Objekt:\xA0' + oggetto.via + ' ' + oggetto.numeroCivico + ', ' + oggetto.cap + ' ' + oggetto.citta + '\nWohneinheit: ' + oggetto.numeroAppartamento + '\nMakler: Angelo Arboscello\nKunde: ' + acquirente.nome + ' ' + acquirente.cognome + '\nNotartermin: ' + (0, _utils.formattaData)(dataRogito);
  } else {
    corpoFattura = 'hier ist die Rechnung f\xFCr Ihre gew\xE4hlten Leistungen.';
  }

  doc.addImage(_ImageLogo.imgLogo, 'JPEG', 130, 10, 55, 12);

  //linea rossa
  doc.setDrawColor(145, 0, 0);
  doc.setLineWidth(7);
  doc.line(146, 26, 199, 26);
  //linea grigia
  doc.setDrawColor(143, 143, 143);
  doc.setLineWidth(7);
  doc.line(15, 26, 146, 26);

  //Header
  doc.setFontSize(11);
  doc.setTextColor(255, 255, 255);
  doc.setFont('times');
  doc.setFontType('bold');
  doc.text(firma.name + ' ' + (firma.name2 && ' - ' + firma.name2) + ' - ' + firma.adresse + ', ' + firma.plz + ' ' + firma.stadt, 19, 27);

  //riquadro contatti
  doc.setDrawColor(215, 240, 245);
  doc.setLineWidth(70);
  doc.line(146, 70, 199, 70);
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(10);
  doc.setFontType('normal');
  doc.text('Ihr Ansprechpartner', 149, 40);
  doc.setFontType('bold');
  doc.text('' + utente.name, 149, 44);
  doc.setFontType('normal');
  doc.text('' + utente.email, 149, 48);
  doc.text('Tel. ' + utente.telefon, 149, 52);
  doc.text('' + firma.website, 149, 56);
  doc.setFontType('bold');
  doc.text('Öffnungszeiten', 149, 68);
  doc.setFontType('normal');
  doc.text('' + firma.open, 149, 72);
  doc.setFontType('bold');
  doc.text('' + (firma.name2 ? firma.name2 : firma.name), 149, 84);
  doc.setFontType('normal');
  doc.text('' + firma.motto, 149, 88);
  doc.text('' + firma.adresse, 149, 92);
  doc.text(firma.plz + ' ' + firma.stadt, 149, 96);
  doc.text('' + firma.staat, 149, 100);

  //Intestazione fattura
  doc.setFontSize(12);
  doc.setFontType('normal');
  doc.text(cliente.ditta, 15, 38);
  doc.text(acqNome, 15, 43);
  doc.text(acqInd, 15, 48);
  doc.text(cliente.cap + ' ' + cliente.comune, 15, 53);
  doc.text('' + cliente.nazione, 15, 58);
  cliente2 && doc.text(acqNome2, 15, 65);
  cliente2 && doc.text(acqInd2, 15, 70);
  cliente2 && doc.text(cliente2.cap + ' ' + cliente2.comune, 15, 75);
  cliente2 && doc.text('' + cliente2.nazione, 15, 80);

  //Dati fattura
  doc.setFontType('bold');
  doc.text('Rechnung Nr. ' + numeroFattura, 15, 96);
  doc.setFontType('normal');
  doc.text('Berlin, ' + (0, _utils.formattaData)(dataFattura), 100, 96);

  // Linea per piegare
  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(0.1);
  doc.line(5, 90, 10, 90);

  //Corpo
  dealType !== 'APH' && doc.text('' + formulaSaluto + (cliente.titolo && ' ' + cliente.cognome) + ',', 15, 110);
  cliente2 && doc.text('' + formulaSaluto2 + (cliente2.titolo && ' ' + cliente2.cognome) + ',', 15, 115);
  var lines = doc.setFontSize(12).splitTextToSize(corpoFattura, 150);
  dealType !== 'APH' ? doc.text(15, 125 + 12 / 110, lines) : doc.text(corpoFattura, 15, 110);

  if (dealType !== '') {
    //Cifre
    doc.text(provvPercentuale + ' Provision aus Kaufpreis ' + (0, _utils.formattaPrezzo)(prezzoDiVendita, true), 15, 150);
    importoNetto ? doc.text((0, _utils.formattaPrezzo)(importoNetto, true), 120, 150) : doc.text((0, _utils.formattaPrezzo)(amount, true), 120, 150);

    doc.text(iva + '% MWSt.', 15, 155);
    importoNetto ? doc.text((0, _utils.formattaPrezzo)(importoNetto / 100 * iva, true), 120, 155) : doc.text((0, _utils.formattaPrezzo)(amount / 100 * iva, true), 120, 155);
    doc.setDrawColor(0, 0, 0);
    doc.setLineWidth(0.2);
    doc.line(15, 157, 146, 157);
    doc.text('Rechnungsbetrag inkl. ' + iva + '% MWSt.', 15, 162);
    doc.setFontType('bold');
    importoNetto ? doc.text((0, _utils.formattaPrezzo)(importoNetto * parseFloat('1.' + iva), true), 120, 162) : doc.text((0, _utils.formattaPrezzo)(amount * parseFloat('1.' + iva), true), 120, 162);

    //Zeitraum
    doc.setFontType('normal');
    doc.text('Leistungszeitraum: vom ' + (0, _utils.formattaData)(dataPrenotazione) + ' bis ' + (0, _utils.formattaData)(dataRogito), 15, 175);
  } else {
    //Cifre
    doc.text('' + descrizioneProdotto, 15, 150);
    doc.text((0, _utils.formattaPrezzo)(importoNetto, true), 120, 150);
    doc.text(iva + '% MWSt.', 15, 155);
    doc.text((0, _utils.formattaPrezzo)(importoNetto / 100 * iva, true), 120, 155);
    doc.setDrawColor(0, 0, 0);
    doc.setLineWidth(0.2);
    doc.line(15, 157, 146, 157);
    doc.text('Rechnungsbetrag inkl. ' + iva + '% MWSt.', 15, 162);
    doc.setFontType('bold');
    doc.text((0, _utils.formattaPrezzo)(importoNetto * parseFloat('1.' + iva), true), 120, 162);

    //Zeitraum
    doc.setFontType('normal');
    doc.text('Leistungszeitraum: ' + (0, _utils.formattaData)(dataPrestazione), 15, 175);
  }

  //Coordinate pagamento
  doc.text('Bitte zahlen Sie den Rechnungsbetrag innerhalb von 7 Tagen ohne Abzug per', 15, 185);
  doc.text('Überweisung auf unser Konto:', 15, 190);
  doc.text('Kontoinhaber: ' + firma.kontoInhaber, 15, 200);
  doc.text('Bankinstitut: ' + firma.bank, 15, 205);
  doc.text('IBAN: ' + firma.iban, 15, 210);
  doc.text('BIC: ' + firma.bic, 15, 215);
  doc.text('Verwendungszweck: Rechnung Nr. ' + numeroFattura, 15, 220);

  //Saluti finali
  doc.text('Sollten Sie noch Fragen haben, so stehen wir auch weiterhin gerne zur Verfügung.', 15, 230);
  doc.text('Mit freundlichen Grüßen', 15, 240);
  doc.text('' + utente.name, 15, 245);

  //Footer
  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(0.2);
  doc.line(15, 267, 15, 282);
  doc.line(55, 267, 55, 282);
  doc.line(110, 267, 110, 282);
  // doc.line(160, 267, 160, 282);
  doc.setFontSize(10);
  doc.setTextColor(143, 143, 143);
  doc.text('Inhaberin:', 16, 270);
  var position = 274;

  ceo.forEach(function (eachCeo) {
    doc.text('' + eachCeo.name, 16, position);
    position += 4;
  });
  doc.text('Telefon: ' + firma.telefon, 56, 270);
  doc.text('Telefax: ' + firma.fax, 56, 274);
  doc.text('E-Mail: ' + firma.email, 56, 278);
  doc.text('Web: ' + firma.website, 56, 282);
  doc.text('Steuernummer: ' + firma.steuerNr, 111, 270);
  doc.text('' + (firma.ustIdNr && 'Ust.-IdNr.: ' + firma.ustIdNr), 111, 274);

  //Logo IVD
  // doc.addImage(ivdLogo, 'JPEG', 161, 270, 30, 12);

  doc.save('Rechnung ' + numeroFattura.replace('/', '-') + ' ' + cliente.cognome + '.pdf');
};
// import { ivdLogo } from './img/IvdLogo';

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mahnung = undefined;

var _jspdf = __webpack_require__(32);

var _jspdf2 = _interopRequireDefault(_jspdf);

var _ImageLogo = __webpack_require__(39);

var _utils = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mahnung = exports.mahnung = function mahnung(cliente, cliente2, numeroFattura, dataFattura, dataZahlungserinnerung, dataMahnung, amount, mahngebuehren, firma, utente, ceo, importoNetto, iva) {
  var doc = new _jspdf2.default('p', 'mm', 'a4');
  var importo = importoNetto || amount;
  var acqNome = cliente.titolo + ' ' + cliente.nome + ' ' + cliente.cognome;
  var acqInd = cliente.indirizzo + ' ' + (cliente.indirizzo2 && cliente.indirizzo2);
  var acqNome2 = cliente2 && cliente2.titolo + ' ' + cliente2.nome + ' ' + cliente2.cognome;
  var acqInd2 = cliente2 && cliente2.indirizzo + ' ' + (cliente2.indirizzo2 && cliente2.indirizzo2);
  var formulaSaluto = 'Sehr geehrte Damen und Herren';
  if (cliente.titolo === 'Herr') {
    formulaSaluto = 'Sehr geehrter Herr';
  } else if (cliente.titolo === 'Frau') {
    formulaSaluto = 'Sehr geehrte Frau';
  }
  var formulaSaluto2 = 'Sehr geehrte Damen und Herren';
  if (cliente2) {
    if (cliente2.titolo === 'Herr') {
      formulaSaluto2 = 'Sehr geehrter Herr';
    } else if (cliente2.titolo === 'Frau') {
      formulaSaluto2 = 'Sehr geehrte Frau';
    }
  }
  var corpoFattura = 'mit unserem Schreiben vom ' + (0, _utils.formattaData)(dataFattura) + ' haben wir Ihnen den f\xE4lligen Betrag in H\xF6he von ' + (0, _utils.formattaPrezzo)(importo * parseFloat('1.' + iva), true) + '  f\xFCr obengenannte Rechnungsnummer in Rechnung gestellt.\nAuf unsere Zahlungserinnerung vom ' + (0, _utils.formattaData)(dataZahlungserinnerung) + ' haben Sie leider nicht reagiert. Aus gegebenen Anlass sehen wir uns gezwungen, Mahngeb\xFChren wie folgt zu verrechnen:';

  doc.addImage(_ImageLogo.imgLogo, 'JPEG', 130, 10, 55, 12);

  //linea rossa
  doc.setDrawColor(145, 0, 0);
  doc.setLineWidth(7);
  doc.line(146, 26, 199, 26);
  //linea grigia
  doc.setDrawColor(143, 143, 143);
  doc.setLineWidth(7);
  doc.line(15, 26, 146, 26);

  //Header
  doc.setFontSize(11);
  doc.setTextColor(255, 255, 255);
  doc.setFont('times');
  doc.setFontType('bold');
  doc.text(firma.name + ' ' + (firma.name2 && ' - ' + firma.name2) + ' - ' + firma.adresse + ', ' + firma.plz + ' ' + firma.stadt, 19, 27);

  //riquadro contatti
  doc.setDrawColor(215, 240, 245);
  doc.setLineWidth(70);
  doc.line(146, 70, 199, 70);
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(10);
  doc.setFontType('normal');
  doc.text('Ihr Ansprechpartner', 149, 40);
  doc.setFontType('bold');
  doc.text('' + utente.name, 149, 44);
  doc.setFontType('normal');
  doc.text('' + utente.email, 149, 48);
  doc.text('Tel. ' + utente.telefon, 149, 52);
  doc.text('' + firma.website, 149, 56);
  doc.setFontType('bold');
  doc.text('Öffnungszeiten', 149, 68);
  doc.setFontType('normal');
  doc.text('' + firma.open, 149, 72);
  doc.setFontType('bold');
  doc.text('' + (firma.name2 ? firma.name2 : firma.name), 149, 84);
  doc.setFontType('normal');
  doc.text('' + firma.motto, 149, 88);
  doc.text('' + firma.adresse, 149, 92);
  doc.text(firma.plz + ' ' + firma.stadt, 149, 96);
  doc.text('' + firma.staat, 149, 100);

  //Intestazione fattura
  doc.setFontSize(12);
  doc.setFontType('normal');
  doc.text(cliente.ditta, 15, 38);
  doc.text(acqNome, 15, 43);
  doc.text(acqInd, 15, 48);
  doc.text(cliente.cap + ' ' + cliente.comune, 15, 53);
  doc.text('' + cliente.nazione, 15, 58);
  cliente2 && doc.text(acqNome2, 15, 65);
  cliente2 && doc.text(acqInd2, 15, 70);
  cliente2 && doc.text(cliente2.cap + ' ' + cliente2.comune, 15, 75);
  cliente2 && doc.text('' + cliente2.nazione, 15, 80);

  //Dati fattura
  doc.setFontType('bold');
  doc.text('1. Mahnung\nRechnung Nr. ' + numeroFattura + '\nRechnungsdatum: ' + (0, _utils.formattaData)(dataFattura) + ' \nRechnungsbetrag: ' + (0, _utils.formattaPrezzo)(importo * parseFloat('1.' + iva), true), 15, 96);
  doc.setFontType('normal');
  doc.text('Berlin, ' + (0, _utils.formattaData)(dataMahnung), 100, 96);

  // Linea per piegare
  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(0.1);
  doc.line(5, 90, 10, 90);

  //Corpo

  doc.text('' + formulaSaluto + (cliente.titolo && ' ' + cliente.cognome) + ',', 15, 120);
  cliente2 && doc.text('' + formulaSaluto2 + (cliente2.titolo && ' ' + cliente2.cognome) + ',', 15, 125);
  var lines = doc.setFontSize(12).splitTextToSize(corpoFattura, 150);
  doc.text(15, 130 + 12 / 110, lines);

  //Cifre
  doc.text('Rechnungsbetrag', 15, 155);
  doc.text((0, _utils.formattaPrezzo)(importo * parseFloat('1.' + iva), true), 120, 155);

  doc.text('Mahngebühren', 15, 160);
  doc.text((0, _utils.formattaPrezzo)(mahngebuehren, true), 120, 160);
  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(0.2);
  doc.line(15, 162, 146, 162);
  doc.setFontType('bold');
  doc.text('Zu zahlender Gesamtbetrag', 15, 167);
  doc.text((0, _utils.formattaPrezzo)(importo * parseFloat('1.' + iva) + mahngebuehren, true), 120, 167);
  doc.setFontType('normal');

  //Coordinate pagamento
  doc.text('Bitte zahlen Sie den offenen Gesamtbetrag innerhalb von 7 Tagen per', 15, 185);
  doc.text('Überweisung auf unser Konto:', 15, 190);
  doc.text('Kontoinhaber: ' + firma.kontoInhaber, 15, 200);
  doc.text('Bankinstitut: ' + firma.bank, 15, 205);
  doc.text('IBAN: ' + firma.iban, 15, 210);
  doc.text('BIC: ' + firma.bic, 15, 215);
  doc.text('Verwendungszweck: Rechnung Nr. ' + numeroFattura, 15, 220);

  //Saluti finali
  doc.text('Sofern Sie die Zahlung zwischenzeitlich veranlasst haben, bitten wir Sie, dieses Schreiben \nals gegenstandlos zu betrachten.\nSollten Sie noch Fragen haben, so stehen wir auch weiterhin gerne zur Verfügung.', 15, 230);
  doc.text('Mit freundlichen Grüßen', 15, 250);
  doc.text('' + utente.name, 15, 255);

  //Footer
  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(0.2);
  doc.line(15, 267, 15, 282);
  doc.line(55, 267, 55, 282);
  doc.line(110, 267, 110, 282);
  // doc.line(160, 267, 160, 282);
  doc.setFontSize(10);
  doc.setTextColor(143, 143, 143);
  doc.text('Inhaberin:', 16, 270);
  var position = 274;

  ceo.forEach(function (eachCeo) {
    doc.text('' + eachCeo.name, 16, position);
    position += 4;
  });
  doc.text('Telefon: ' + firma.telefon, 56, 270);
  doc.text('Telefax: ' + firma.fax, 56, 274);
  doc.text('E-Mail: ' + firma.email, 56, 278);
  doc.text('Web: ' + firma.website, 56, 282);
  doc.text('Steuernummer: ' + firma.steuerNr, 111, 270);
  doc.text('' + (firma.ustIdNr && 'Ust.-IdNr.: ' + firma.ustIdNr), 111, 274);

  //Logo IVD
  // doc.addImage(ivdLogo, 'JPEG', 161, 270, 30, 12);

  doc.save('Mahnung Rechnung ' + numeroFattura.replace('/', '-') + ' ' + cliente.cognome + '.pdf');
};
// import { ivdLogo } from './img/IvdLogo';

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mahnung2 = undefined;

var _jspdf = __webpack_require__(32);

var _jspdf2 = _interopRequireDefault(_jspdf);

var _ImageLogo = __webpack_require__(39);

var _utils = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mahnung2 = exports.mahnung2 = function mahnung2(cliente, cliente2, numeroFattura, dataFattura, dataZahlungserinnerung, dataMahnung, dataMahnung2, amount, mahngebuehren, firma, utente, ceo, importoNetto, iva) {
  var doc = new _jspdf2.default('p', 'mm', 'a4');
  var importo = importoNetto || amount;
  var acqNome = cliente.titolo + ' ' + cliente.nome + ' ' + cliente.cognome;
  var acqInd = cliente.indirizzo + ' ' + (cliente.indirizzo2 && cliente.indirizzo2);
  var acqNome2 = cliente2 && cliente2.titolo + ' ' + cliente2.nome + ' ' + cliente2.cognome;
  var acqInd2 = cliente2 && cliente2.indirizzo + ' ' + (cliente2.indirizzo2 && cliente2.indirizzo2);
  var formulaSaluto = 'Sehr geehrte Damen und Herren';
  if (cliente.titolo === 'Herr') {
    formulaSaluto = 'Sehr geehrter Herr';
  } else if (cliente.titolo === 'Frau') {
    formulaSaluto = 'Sehr geehrte Frau';
  }
  var formulaSaluto2 = 'Sehr geehrte Damen und Herren';
  if (cliente2) {
    if (cliente2.titolo === 'Herr') {
      formulaSaluto2 = 'Sehr geehrter Herr';
    } else if (cliente2.titolo === 'Frau') {
      formulaSaluto2 = 'Sehr geehrte Frau';
    }
  }
  var corpoFattura = 'trotz unserer Erinnerungen vom ' + (0, _utils.formattaData)(dataZahlungserinnerung) + ' und vom ' + (0, _utils.formattaData)(dataMahnung) + ' konnten wir bis zum heutigen Tag keinen Zahlungseingang feststellen.\n\nZur Zahlung offen sind folgende Betr\xE4ge:';

  doc.addImage(_ImageLogo.imgLogo, 'JPEG', 130, 10, 55, 12);

  //linea rossa
  doc.setDrawColor(145, 0, 0);
  doc.setLineWidth(7);
  doc.line(146, 26, 199, 26);
  //linea grigia
  doc.setDrawColor(143, 143, 143);
  doc.setLineWidth(7);
  doc.line(15, 26, 146, 26);

  //Header
  doc.setFontSize(11);
  doc.setTextColor(255, 255, 255);
  doc.setFont('times');
  doc.setFontType('bold');
  doc.text(firma.name + ' ' + (firma.name2 && ' - ' + firma.name2) + ' - ' + firma.adresse + ', ' + firma.plz + ' ' + firma.stadt, 19, 27);

  //riquadro contatti
  doc.setDrawColor(215, 240, 245);
  doc.setLineWidth(70);
  doc.line(146, 70, 199, 70);
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(10);
  doc.setFontType('normal');
  doc.text('Ihr Ansprechpartner', 149, 40);
  doc.setFontType('bold');
  doc.text('' + utente.name, 149, 44);
  doc.setFontType('normal');
  doc.text('' + utente.email, 149, 48);
  doc.text('Tel. ' + utente.telefon, 149, 52);
  doc.text('' + firma.website, 149, 56);
  doc.setFontType('bold');
  doc.text('Öffnungszeiten', 149, 68);
  doc.setFontType('normal');
  doc.text('' + firma.open, 149, 72);
  doc.setFontType('bold');
  doc.text('' + (firma.name2 ? firma.name2 : firma.name), 149, 84);
  doc.setFontType('normal');
  doc.text('' + firma.motto, 149, 88);
  doc.text('' + firma.adresse, 149, 92);
  doc.text(firma.plz + ' ' + firma.stadt, 149, 96);
  doc.text('' + firma.staat, 149, 100);

  //Intestazione fattura
  doc.setFontSize(12);
  doc.setFontType('normal');
  doc.text(cliente.ditta, 15, 38);
  doc.text(acqNome, 15, 43);
  doc.text(acqInd, 15, 48);
  doc.text(cliente.cap + ' ' + cliente.comune, 15, 53);
  doc.text('' + cliente.nazione, 15, 58);
  cliente2 && doc.text(acqNome2, 15, 65);
  cliente2 && doc.text(acqInd2, 15, 70);
  cliente2 && doc.text(cliente2.cap + ' ' + cliente2.comune, 15, 75);
  cliente2 && doc.text('' + cliente2.nazione, 15, 80);

  //Dati fattura
  doc.setFontType('bold');
  doc.text('Letzte Mahnung\nRechnung Nr. ' + numeroFattura + '\nRechnungsdatum: ' + (0, _utils.formattaData)(dataFattura) + ' \nRechnungsbetrag: ' + (0, _utils.formattaPrezzo)(importo * parseFloat('1.' + iva), true), 15, 96);
  doc.setFontType('normal');
  doc.text('Berlin, ' + (0, _utils.formattaData)(dataMahnung2), 100, 96);

  // Linea per piegare
  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(0.1);
  doc.line(5, 90, 10, 90);

  //Corpo

  doc.text('' + formulaSaluto + (cliente.titolo && ' ' + cliente.cognome) + ',', 15, 120);
  cliente2 && doc.text('' + formulaSaluto2 + (cliente2.titolo && ' ' + cliente2.cognome) + ',', 15, 125);
  var lines = doc.setFontSize(12).splitTextToSize(corpoFattura, 150);
  doc.text(15, 130 + 12 / 110, lines);

  //Cifre
  doc.text('Rechnungsbetrag', 15, 155);
  doc.text((0, _utils.formattaPrezzo)(importo * parseFloat('1.' + iva), true), 120, 155);

  doc.text('Mahngebühren', 15, 160);
  doc.text((0, _utils.formattaPrezzo)(mahngebuehren, true), 120, 160);
  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(0.2);
  doc.line(15, 162, 146, 162);
  doc.setFontType('bold');
  doc.text('Zu zahlender Gesamtbetrag', 15, 167);
  doc.text((0, _utils.formattaPrezzo)(importo * parseFloat('1.' + iva) + mahngebuehren, true), 120, 167);
  doc.setFontType('normal');

  //Coordinate pagamento
  doc.text('Bitte zahlen Sie den offenen Gesamtbetrag innerhalb von 7 Tagen per', 15, 180);
  doc.text('Überweisung auf unser Konto:', 15, 185);
  doc.text('Kontoinhaber: ' + firma.kontoInhaber, 15, 195);
  doc.text('Bankinstitut: ' + firma.bank, 15, 200);
  doc.text('IBAN: ' + firma.iban, 15, 205);
  doc.text('BIC: ' + firma.bic, 15, 210);
  doc.text('Verwendungszweck: Rechnung Nr. ' + numeroFattura, 15, 215);

  //Saluti finali
  doc.text('Sollten Sie auch diese letzte Frist ohne Zahlungseingang verstreichen lassen, sehen wir \nuns gezwungen, gerichtliche Schritte gegen Sie einzuleiten.\nSofern Sie die Zahlung zwischenzeitlich veranlasst haben, bitten wir Sie, dieses Schreiben \nals gegenstandlos zu betrachten.', 15, 225);
  doc.text('Mit freundlichen Grüßen', 15, 250);
  doc.text('' + utente.name, 15, 255);

  //Footer
  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(0.2);
  doc.line(15, 267, 15, 282);
  doc.line(55, 267, 55, 282);
  doc.line(110, 267, 110, 282);
  // doc.line(160, 267, 160, 282);
  doc.setFontSize(10);
  doc.setTextColor(143, 143, 143);
  doc.text('Inhaberin:', 16, 270);
  var position = 274;

  ceo.forEach(function (eachCeo) {
    doc.text('' + eachCeo.name, 16, position);
    position += 4;
  });
  doc.text('Telefon: ' + firma.telefon, 56, 270);
  doc.text('Telefax: ' + firma.fax, 56, 274);
  doc.text('E-Mail: ' + firma.email, 56, 278);
  doc.text('Web: ' + firma.website, 56, 282);
  doc.text('Steuernummer: ' + firma.steuerNr, 111, 270);
  doc.text('' + (firma.ustIdNr && 'Ust.-IdNr.: ' + firma.ustIdNr), 111, 274);

  //Logo IVD
  // doc.addImage(ivdLogo, 'JPEG', 161, 270, 30, 12);

  doc.save('Letzte Mahnung Rechnung ' + numeroFattura.replace('/', '-') + ' ' + cliente.cognome + '.pdf');
};
// import { ivdLogo } from './img/IvdLogo';

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zahlungserinnerung = undefined;

var _jspdf = __webpack_require__(32);

var _jspdf2 = _interopRequireDefault(_jspdf);

var _ImageLogo = __webpack_require__(39);

var _utils = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var zahlungserinnerung = exports.zahlungserinnerung = function zahlungserinnerung(cliente, cliente2, numeroFattura, dataFattura, dataZahlungserinnerung, amount, firma, utente, ceo, importoNetto, iva) {
  var doc = new _jspdf2.default('p', 'mm', 'a4');
  var importo = importoNetto || amount;
  var acqNome = cliente.titolo + ' ' + cliente.nome + ' ' + cliente.cognome;
  var acqInd = cliente.indirizzo + ' ' + (cliente.indirizzo2 && cliente.indirizzo2);
  var acqNome2 = cliente2 && cliente2.titolo + ' ' + cliente2.nome + ' ' + cliente2.cognome;
  var acqInd2 = cliente2 && cliente2.indirizzo + ' ' + (cliente2.indirizzo2 && cliente2.indirizzo2);
  var formulaSaluto = 'Sehr geehrte Damen und Herren';
  if (cliente.titolo === 'Herr') {
    formulaSaluto = 'Sehr geehrter Herr';
  } else if (cliente.titolo === 'Frau') {
    formulaSaluto = 'Sehr geehrte Frau';
  }
  var formulaSaluto2 = 'Sehr geehrte Damen und Herren';
  if (cliente2) {
    if (cliente2.titolo === 'Herr') {
      formulaSaluto2 = 'Sehr geehrter Herr';
    } else if (cliente2.titolo === 'Frau') {
      formulaSaluto2 = 'Sehr geehrte Frau';
    }
  }
  var corpoFattura = 'f\xFCr die oben aufgef\xFChrte Rechnung konnten wir bis heute leider keine Zahlungseingang feststellen. \nSicherlich handelt es sich um ein Versehen. Eine Kopie der Rechnung vom ' + (0, _utils.formattaData)(dataFattura) + ' haben wir dem Schreiben beigelegt. \n\nUm Mahnungsgeb\xFChren zu vermeiden, \xFCberweisen Sie bitte den f\xE4lligen Beitrag von ' + (0, _utils.formattaPrezzo)(importo, true) + '  innerhalb von 7 Tagen ohne Abz\xFCge auf das untenstehende Bankkonto. \n\nSofern Sie die Zahlung zwischenzeitlich veranlasst haben, bitten wir Sie, dieses Schreiben als gegenstandlos zu betrachten.';

  doc.addImage(_ImageLogo.imgLogo, 'JPEG', 130, 10, 55, 12);

  //linea rossa
  doc.setDrawColor(145, 0, 0);
  doc.setLineWidth(7);
  doc.line(146, 26, 199, 26);
  //linea grigia
  doc.setDrawColor(143, 143, 143);
  doc.setLineWidth(7);
  doc.line(15, 26, 146, 26);

  //Header
  doc.setFontSize(11);
  doc.setTextColor(255, 255, 255);
  doc.setFont('times');
  doc.setFontType('bold');
  doc.text(firma.name + ' ' + (firma.name2 && ' - ' + firma.name2) + ' - ' + firma.adresse + ', ' + firma.plz + ' ' + firma.stadt, 19, 27);

  //riquadro contatti
  doc.setDrawColor(215, 240, 245);
  doc.setLineWidth(70);
  doc.line(146, 70, 199, 70);
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(10);
  doc.setFontType('normal');
  doc.text('Ihr Ansprechpartner', 149, 40);
  doc.setFontType('bold');
  doc.text('' + utente.name, 149, 44);
  doc.setFontType('normal');
  doc.text('' + utente.email, 149, 48);
  doc.text('Tel. ' + utente.telefon, 149, 52);
  doc.text('' + firma.website, 149, 56);
  doc.setFontType('bold');
  doc.text('Öffnungszeiten', 149, 68);
  doc.setFontType('normal');
  doc.text('' + firma.open, 149, 72);
  doc.setFontType('bold');
  doc.text('' + (firma.name2 ? firma.name2 : firma.name), 149, 84);
  doc.setFontType('normal');
  doc.text('' + firma.motto, 149, 88);
  doc.text('' + firma.adresse, 149, 92);
  doc.text(firma.plz + ' ' + firma.stadt, 149, 96);
  doc.text('' + firma.staat, 149, 100);

  var acapo = 38;
  //Intestazione fattura
  doc.setFontSize(12);
  doc.setFontType('normal');
  doc.text(cliente.ditta, 15, acapo);
  acapo += 5;
  doc.text(acqNome, 15, acapo);
  acapo += 5;
  doc.text(acqInd, 15, acapo);
  acapo += 5;
  doc.text(cliente.cap + ' ' + cliente.comune, 15, acapo);
  acapo += 5;
  doc.text('' + cliente.nazione, 15, acapo);
  acapo += 7;
  cliente2 && doc.text(acqNome2, 15, acapo);
  acapo += 5;
  cliente2 && doc.text(acqInd2, 15, acapo);
  acapo += 5;
  cliente2 && doc.text(cliente2.cap + ' ' + cliente2.comune, 15, acapo);
  acapo += 5;
  cliente2 && doc.text('' + cliente2.nazione, 15, acapo);

  acapo += 10;
  // Linea per piegare
  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(0.1);
  doc.line(5, acapo, 10, acapo);
  acapo += 6;
  //Dati fattura
  doc.setFontType('bold');
  doc.text('Zahlungserinnerung\nRechnung Nr. ' + numeroFattura, 15, acapo);
  doc.setFontType('normal');
  doc.text('Berlin, ' + (0, _utils.formattaData)(dataZahlungserinnerung), 100, acapo);
  acapo += 14;
  //Corpo
  doc.text('' + formulaSaluto + (cliente.titolo && ' ' + cliente.cognome) + ',', 15, acapo);
  acapo += 5;
  cliente2 && doc.text('' + formulaSaluto2 + (cliente2.titolo && ' ' + cliente2.cognome) + ',', 15, acapo);
  acapo += 10;
  var lines = doc.setFontSize(12).splitTextToSize(corpoFattura, 150);
  doc.text(15, acapo + 12 / 110, lines);
  //Coordinate pagamento
  acapo += 55;
  doc.text('Kontoverbindung:', 15, acapo);
  acapo += 5;
  doc.text('Kontoinhaber: ' + firma.kontoInhaber, 15, acapo);
  acapo += 5;
  doc.text('Bankinstitut: ' + firma.bank, 15, acapo);
  acapo += 5;
  doc.text('IBAN: ' + firma.iban, 15, acapo);
  acapo += 5;
  doc.text('BIC: ' + firma.bic, 15, acapo);
  acapo += 5;
  doc.text('Verwendungszweck: Rechnung Nr. ' + numeroFattura, 15, acapo);
  acapo += 15;

  //Saluti finali
  doc.text('Sollten Sie noch Fragen haben, so stehen wir auch weiterhin gerne zur Verfügung.', 15, acapo);
  acapo += 10;
  doc.text('Mit freundlichen Grüßen', 15, acapo);
  acapo += 5;
  doc.text('' + utente.name, 15, acapo);

  //Footer
  doc.setDrawColor(0, 0, 0);
  doc.setLineWidth(0.2);
  doc.line(15, 267, 15, 282);
  doc.line(55, 267, 55, 282);
  doc.line(110, 267, 110, 282);
  // doc.line(160, 267, 160, 282);
  doc.setFontSize(10);
  doc.setTextColor(143, 143, 143);
  doc.text('Inhaberin:', 16, 270);
  var position = 274;

  ceo.forEach(function (eachCeo) {
    doc.text('' + eachCeo.name, 16, position);
    position += 4;
  });
  doc.text('Telefon: ' + firma.telefon, 56, 270);
  doc.text('Telefax: ' + firma.fax, 56, 274);
  doc.text('E-Mail: ' + firma.email, 56, 278);
  doc.text('Web: ' + firma.website, 56, 282);
  doc.text('Steuernummer: ' + firma.steuerNr, 111, 270);
  doc.text('' + (firma.ustIdNr && 'Ust.-IdNr.: ' + firma.ustIdNr), 111, 274);

  //Logo IVD
  // doc.addImage(ivdLogo, 'JPEG', 161, 270, 30, 12);

  doc.save('Zahlungserinnerung - Rechnung ' + numeroFattura.replace('/', '-') + ' ' + cliente.cognome + '.pdf');
};
// import { ivdLogo } from './img/IvdLogo';

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _FattureList = __webpack_require__(223);

var _FattureList2 = _interopRequireDefault(_FattureList);

var _ListFilters = __webpack_require__(96);

var _ListFilters2 = _interopRequireDefault(_ListFilters);

var _configureStore = __webpack_require__(14);

var _elements = __webpack_require__(18);

var _Intestazione = __webpack_require__(20);

var _Intestazione2 = _interopRequireDefault(_Intestazione);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FattureDashboardPage = function (_React$Component) {
  _inherits(FattureDashboardPage, _React$Component);

  function FattureDashboardPage() {
    _classCallCheck(this, FattureDashboardPage);

    return _possibleConstructorReturn(this, (FattureDashboardPage.__proto__ || Object.getPrototypeOf(FattureDashboardPage)).apply(this, arguments));
  }

  _createClass(FattureDashboardPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.startSetFatture();
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;


      var options = [{ value: 'date', label: 'Data' }];

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Intestazione2.default, { intestazione: t('Fatture') }),
        _react2.default.createElement(_ListFilters2.default, { options: options }),
        (0, _elements.addButton)('/fatturacreate'),
        _react2.default.createElement(_FattureList2.default, null)
      );
    }
  }]);

  return FattureDashboardPage;
}(_react2.default.Component);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    startSetFatture: function startSetFatture() {
      return dispatch(_configureStore.storeActions.find(function (action) {
        return action.label === 'fatture';
      }).startSetAction());
    }
  };
};

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)((0, _reactI18next.withTranslation)()(FattureDashboardPage));

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _OggettiList = __webpack_require__(73);

var _OggettiList2 = _interopRequireDefault(_OggettiList);

var _ListFilters = __webpack_require__(96);

var _ListFilters2 = _interopRequireDefault(_ListFilters);

var _configureStore = __webpack_require__(14);

var _elements = __webpack_require__(18);

var _Intestazione = __webpack_require__(20);

var _Intestazione2 = _interopRequireDefault(_Intestazione);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OggettiDashboardPage = function (_React$Component) {
  _inherits(OggettiDashboardPage, _React$Component);

  function OggettiDashboardPage() {
    _classCallCheck(this, OggettiDashboardPage);

    return _possibleConstructorReturn(this, (OggettiDashboardPage.__proto__ || Object.getPrototypeOf(OggettiDashboardPage)).apply(this, arguments));
  }

  _createClass(OggettiDashboardPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.startSetOggetti();
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;

      var options = [{ value: 'name', label: 'Indirizzo' }, { value: 'date', label: 'Data' }, { value: 'published', label: 'Pubblicato' }];
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Intestazione2.default, { intestazione: t('Oggetti') }),
        _react2.default.createElement(_ListFilters2.default, { options: options }),
        (0, _elements.addButton)('/oggettocreate'),
        _react2.default.createElement(_OggettiList2.default, null)
      );
    }
  }]);

  return OggettiDashboardPage;
}(_react2.default.Component);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    startSetOggetti: function startSetOggetti() {
      return dispatch(_configureStore.storeActions.find(function (action) {
        return action.label === 'oggetti';
      }).startSetAction());
    }
  };
};

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)((0, _reactI18next.withTranslation)()(OggettiDashboardPage));

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewOggettiPage = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactRouterDom = __webpack_require__(23);

var _reactI18next = __webpack_require__(4);

var _utils = __webpack_require__(9);

var _ClientiList = __webpack_require__(125);

var _ClientiList2 = _interopRequireDefault(_ClientiList);

var _Expose = __webpack_require__(1119);

var _ImmoscoutAPI = __webpack_require__(1120);

var _ImmoscoutAPI2 = _interopRequireDefault(_ImmoscoutAPI);

var _Intestazione = __webpack_require__(20);

var _Intestazione2 = _interopRequireDefault(_Intestazione);

var _EvaluationList = __webpack_require__(609);

var _EvaluationList2 = _interopRequireDefault(_EvaluationList);

var _Mappa = __webpack_require__(610);

var _Mappa2 = _interopRequireDefault(_Mappa);

var _M2SquareAPI = __webpack_require__(1123);

var _M2SquareAPI2 = _interopRequireDefault(_M2SquareAPI);

var _collectionItem = __webpack_require__(160);

var _collectionItem2 = _interopRequireDefault(_collectionItem);

var _elements = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ViewOggettiPage = exports.ViewOggettiPage = function (_React$Component) {
  _inherits(ViewOggettiPage, _React$Component);

  function ViewOggettiPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ViewOggettiPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ViewOggettiPage.__proto__ || Object.getPrototypeOf(ViewOggettiPage)).call.apply(_ref, [this].concat(args))), _this), _this.findContact = function (contact) {
      return _this.props.clienti.filter(function (cliente) {
        return cliente.id === contact;
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ViewOggettiPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      M.AutoInit();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (this.props.oggetto && this.props.utente) {
        var _props = this.props,
            t = _props.t,
            oggetto = _props.oggetto,
            evaluation = _props.evaluation;

        var verwalter = this.findContact(oggetto.verwalter);
        var proprietario = this.findContact(oggetto.proprietarioId);
        var proprietario2 = this.findContact(oggetto.proprietarioId2);
        var inquilino = this.findContact(oggetto.inquilinoId);
        var rendita = oggetto.affittoNetto ? parseFloat(oggetto.affittoNetto * 1200 / oggetto.kaufpreis).toFixed(2).toString().replace(/\./, ',') : null;
        var titolo = (0, _utils.indirizzoOggetto)(oggetto) + ' ' + oggetto.quartiere;

        // copia dell'oggetto se voglio fare un duplicato da passare a WP
        var oggettoCopy = _extends({}, oggetto, {
          downloadURLs: [[], [], []],
          downloadURLsId: [[], [], []],
          downloadURLsCover: [],
          downloadURLsCoverId: [],
          downloadURLsGrundriss: [],
          downloadURLsGrundrissId: [],
          postId: '',
          postIdDe: '',
          postIdEn: '',
          postIdIt: '',
          linkDe: '',
          linkEn: '',
          linkIt: ''
        });

        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_Intestazione2.default, { intestazione: titolo }),
          _react2.default.createElement(
            'div',
            { className: 'container section' },
            _react2.default.createElement(
              'div',
              null,
              (0, _elements.editButton)('/oggettoedit/' + oggetto.id),
              !oggetto.venduto && _react2.default.createElement(
                _reactRouterDom.Link,
                {
                  className: 'btn-floating green accent-3 right btn-floating-margin',
                  to: '/oggettomatchview/' + oggetto.id
                },
                _react2.default.createElement(
                  'i',
                  { className: 'material-icons' },
                  'search'
                )
              ),
              !evaluation && _react2.default.createElement(
                _reactRouterDom.Link,
                {
                  to: {
                    pathname: '/evaluationcreate',
                    state: {
                      oggettoId: oggetto.id,
                      titolo: titolo,
                      affittoNetto: oggetto.affittoNetto,
                      m2: parseFloat(oggetto.m2).toString().replace(/,/g, '.') * 100
                    }
                  },
                  className: 'btn-floating  pink lighten-3 right btn-floating-margin'
                },
                _react2.default.createElement(
                  'i',
                  { className: 'material-icons' },
                  'attach_money'
                )
              ),
              (0, _elements.folderButton)(oggetto, false, 'Exposé', oggetto.rifId)
            ),
            _react2.default.createElement(
              'div',
              null,
              oggetto.tipologia && _react2.default.createElement(
                'p',
                null,
                t('property_type'),
                ': ',
                t(oggetto.tipologia)
              ),
              oggetto.rifId && _react2.default.createElement(
                'p',
                null,
                'Ref. id: ',
                oggetto.rifId
              ),
              rendita && _react2.default.createElement(
                'div',
                null,
                t('property_yield'),
                ': ',
                rendita,
                '%'
              ),
              oggetto.kaufpreis > 0 && _react2.default.createElement(
                'p',
                null,
                t('Prezzo di vendita') + ': ' + (0, _utils.formattaPrezzo)(oggetto.kaufpreis, true)
              ),
              oggetto.status && _react2.default.createElement(
                'p',
                { className: 'green-text' },
                t('property_status')
              ),
              _react2.default.createElement(
                'ul',
                { className: 'collapsible' },
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'div',
                    { className: 'collapsible-header' },
                    _react2.default.createElement(
                      'i',
                      { className: 'material-icons' },
                      'list'
                    ),
                    t('Dettagli immobile')
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'collapsible-body' },
                    oggetto.amtsgericht && _react2.default.createElement(
                      'p',
                      null,
                      t('Pretura (Amtsgericht)'),
                      ': ',
                      oggetto.amtsgericht
                    ),
                    oggetto.grundbuch && _react2.default.createElement(
                      'p',
                      null,
                      t('Libro Fondiario (Grundbuch)'),
                      ' ',
                      oggetto.grundbuch
                    ),
                    oggetto.grundbuchBlatt && _react2.default.createElement(
                      'p',
                      null,
                      t('Foglio'),
                      ' Nr.: ',
                      oggetto.grundbuchBlatt
                    ),
                    oggetto.ruecklage && _react2.default.createElement(
                      'p',
                      null,
                      t('Fondo di accantonamento per manutenzione'),
                      ':',
                      ' ',
                      oggetto.ruecklage
                    ),
                    oggetto.baujahr && _react2.default.createElement(
                      'p',
                      null,
                      t('Anno di costruzione') + ': ' + oggetto.baujahr
                    ),
                    oggetto.energieAusweisTyp && _react2.default.createElement(
                      'p',
                      null,
                      t('Certificato energetico - tipologia') + ': ' + t(oggetto.energieAusweisTyp)
                    ),
                    oggetto.energieAusweisBis && _react2.default.createElement(
                      'p',
                      null,
                      t('Valido fino al') + ': ' + oggetto.energieAusweisBis
                    ),
                    oggetto.heizungsart && _react2.default.createElement(
                      'p',
                      null,
                      t('Tipologia riscaldamento') + ': ' + t(oggetto.heizungsart)
                    ),
                    oggetto.energieTraeger && _react2.default.createElement(
                      'p',
                      null,
                      t('Fonte energetica') + ': ' + t(oggetto.energieTraeger)
                    ),
                    oggetto.energieBedarf && _react2.default.createElement(
                      'p',
                      null,
                      t('Consumo energetico') + ': ' + oggetto.energieBedarf
                    ),
                    oggetto.m2 && _react2.default.createElement(
                      'p',
                      null,
                      'm2: ' + oggetto.m2
                    ),
                    oggetto.piano && _react2.default.createElement(
                      'p',
                      null,
                      t('Piano') + ': ' + oggetto.piano
                    ),
                    oggetto.stato && _react2.default.createElement(
                      'p',
                      null,
                      t('Stato abitativo') + ': ' + t(oggetto.stato)
                    ),
                    oggetto.affittoNetto > 0 && _react2.default.createElement(
                      'p',
                      null,
                      t('Affitto netto') + ': ' + (0, _utils.formattaPrezzo)(oggetto.affittoNetto, true)
                    ),
                    t('Quota condominiale') + ': ' + (0, _utils.formattaPrezzo)(oggetto.wohngeld, true),
                    oggetto.vani && _react2.default.createElement(
                      'p',
                      null,
                      t('Vani') + ': ' + oggetto.vani
                    ),
                    oggetto.bagni && _react2.default.createElement(
                      'p',
                      null,
                      t('Bagni') + ': ' + oggetto.bagni
                    ),
                    oggetto.balcone && _react2.default.createElement(
                      'p',
                      null,
                      t('Balcone') + ': ' + t('sì')
                    ),
                    oggetto.ascensore && _react2.default.createElement(
                      'p',
                      null,
                      t('Ascensore') + ': ' + t('sì')
                    ),
                    oggetto.giardino && _react2.default.createElement(
                      'p',
                      null,
                      t('Giardino') + ': ' + t('sì')
                    ),
                    oggetto.cantina && _react2.default.createElement(
                      'p',
                      null,
                      t('Cantina') + ': ' + t('sì')
                    ),
                    oggetto.condizioni && _react2.default.createElement(
                      'p',
                      null,
                      t('Condizioni immobile') + ': ' + t(oggetto.condizioni)
                    )
                  )
                )
              ),
              oggetto.note && _react2.default.createElement(
                'p',
                null,
                'Note: ' + oggetto.note
              ),
              oggetto.prenotato === true && _react2.default.createElement(
                'h5',
                { className: 'orange-text' },
                t('reserved'),
                '!'
              ),
              oggetto.venduto === true && _react2.default.createElement(
                'h5',
                { className: 'red-text' },
                t('Venduto'),
                '!'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'container section' },
            _react2.default.createElement(
              'div',
              { className: 'btn-row' },
              this.props.utente && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h5',
                  null,
                  'Admin Console'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'admin-console' },
                  _react2.default.createElement(
                    'div',
                    { className: 'admin-console-item' },
                    _react2.default.createElement(_ImmoscoutAPI2.default, { oggetto: oggetto })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'admin-console-item' },
                    _react2.default.createElement(_M2SquareAPI2.default, { oggetto: oggetto })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'admin-console-item' },
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(
                        'span',
                        null,
                        t('property_duplicate')
                      ),
                      _react2.default.createElement(
                        _reactRouterDom.Link,
                        {
                          to: {
                            pathname: '/oggettocreate',
                            state: {
                              oggetto: oggettoCopy
                            }
                          },
                          className: 'btn-floating  blue lighten-3 btn-floating-margin'
                        },
                        _react2.default.createElement(
                          'i',
                          { className: 'material-icons' },
                          'content_copy'
                        )
                      )
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'container section' },
            _react2.default.createElement(
              'ul',
              { className: 'collection  s12 m6' },
              oggetto.downloadURLsCover && oggetto.titoloDe && _react2.default.createElement(_collectionItem2.default, {
                label: 'Expos\xE9 ' + t('tedesco'),
                action: function action() {
                  (0, _Expose.expose)(oggetto, _this2.props.firma, _this2.props.utente, _this2.props.ceo, 'de');
                },
                icon: 'picture_as_pdf',
                btnColor: 'blue'
              }),
              oggetto.downloadURLsCover && oggetto.titolo && _react2.default.createElement(_collectionItem2.default, {
                label: 'Expos\xE9 ' + t('italiano'),
                action: function action() {
                  (0, _Expose.expose)(oggetto, _this2.props.firma, _this2.props.utente, _this2.props.ceo, 'it');
                },
                icon: 'picture_as_pdf',
                btnColor: 'blue'
              }),
              oggetto.downloadURLsCover && oggetto.titoloEn && _react2.default.createElement(_collectionItem2.default, {
                label: 'Expos\xE9 ' + t('inglese'),
                action: function action() {
                  (0, _Expose.expose)(oggetto, _this2.props.firma, _this2.props.utente, _this2.props.ceo, 'en');
                },
                icon: 'picture_as_pdf',
                btnColor: 'blue'
              })
            ),
            !oggetto.downloadURLsCover || oggetto.titolo.length < 1 || oggetto.titoloDe.length < 1 || oggetto.titoloEn.length < 1 ? _react2.default.createElement(
              'div',
              { className: '' },
              t('Per creare un exposé inserisci almeno una immagine di copertina e un titolo principale')
            ) : ''
          ),
          oggetto.verwalter && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_ClientiList2.default, {
              cliente: verwalter,
              ruolo: t('Amministratore di condominio')
            })
          ),
          oggetto.proprietarioId && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_ClientiList2.default, { cliente: proprietario, ruolo: t('Proprietario') })
          ),
          oggetto.proprietarioId2 && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_ClientiList2.default, {
              cliente: proprietario2,
              ruolo: '2. ' + t('Proprietario')
            })
          ),
          oggetto.inquilinoId && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_ClientiList2.default, { cliente: inquilino, ruolo: t('Inquilino') })
          ),
          evaluation && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_EvaluationList2.default, {
              oggettoEvaluation: [evaluation],
              ruolo: t('evaluation')
            })
          ),
          (0, _elements.imageView)(oggetto.downloadURLsCover, t('Immagine di copertina')),
          _react2.default.createElement(
            'div',
            { className: 'container' },
            oggetto.downloadURLs && _react2.default.createElement(
              'div',
              { className: 'grey lighten-4' },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h1',
                  null,
                  t('Immagini')
                )
              ),
              ' ',
              Array.isArray(oggetto.downloadURLs[0]) ? oggetto.downloadURLs[0].map(function (downloadURL, i) {
                return _react2.default.createElement('img', { className: 'foto', key: i, src: downloadURL });
              }) : oggetto.downloadURLs.map(function (downloadURL, i) {
                return _react2.default.createElement('img', { className: 'foto', key: i, src: downloadURL });
              })
            )
          ),
          (0, _elements.imageView)(oggetto.downloadURLsGrundriss, t('Planimetria')),
          _react2.default.createElement(_Mappa2.default, { oggetto: oggetto }),
          oggetto.titolo && _react2.default.createElement(
            'div',
            { className: 'container margine-basso' },
            _react2.default.createElement(
              'div',
              { className: 'grey lighten-4' },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h1',
                  null,
                  t("Testo dell'exposé in italiano")
                )
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              'Titolo: ' + oggetto.titolo
            ),
            _react2.default.createElement(
              'div',
              null,
              'Descrizione: ' + oggetto.descrizione
            )
          ),
          oggetto.titoloDe && _react2.default.createElement(
            'div',
            { className: 'container margine-basso' },
            _react2.default.createElement(
              'div',
              { className: 'grey lighten-4' },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h1',
                  null,
                  t("Testo dell'exposé in tedesco")
                )
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              'Titel: ' + oggetto.titoloDe
            ),
            _react2.default.createElement(
              'div',
              null,
              'Beschreibung: ' + oggetto.descrizioneDe
            )
          ),
          oggetto.titoloEn && _react2.default.createElement(
            'div',
            { className: 'container margine-basso' },
            _react2.default.createElement(
              'div',
              { className: 'grey lighten-4' },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h1',
                  null,
                  t("Testo dell'exposé in inglese")
                )
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              'Title: ' + oggetto.titoloEn
            ),
            _react2.default.createElement(
              'div',
              null,
              'Description: ' + oggetto.descrizioneEn
            )
          ),
          oggetto.dataInserimentoOggetto && _react2.default.createElement(
            'div',
            { className: 'container' },
            'Data inserimento oggetto:',
            ' ',
            (0, _utils.formattaData)(oggetto.dataInserimentoOggetto)
          ),
          oggetto.dataModificaOggetto && _react2.default.createElement(
            'div',
            { className: 'container margine-basso' },
            'Data modifica oggetto: ',
            (0, _utils.formattaData)(oggetto.dataModificaOggetto)
          )
        );
      } else {
        return _react2.default.createElement(
          'div',
          null,
          'Loading...'
        );
      }
    }
  }]);

  return ViewOggettiPage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    oggetto: state.oggetti.find(function (oggetto) {
      return oggetto.id === props.match.params.id;
    }),
    clienti: state.clienti,
    firma: state.firma[0],
    ceo: state.utenti.filter(function (utente) {
      return utente.role === 'Geschäftsführer';
    }),
    utente: state.utenti.find(function (utente) {
      return utente.firebaseAuthId === state.auth.uid;
    }),
    evaluation: state.evaluations.find(function (evaluation) {
      return evaluation.oggettoId === props.match.params.id;
    })
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()(ViewOggettiPage));

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.expose = undefined;

var _jspdf = __webpack_require__(32);

var _jspdf2 = _interopRequireDefault(_jspdf);

var _ImageLogo = __webpack_require__(39);

var _utils = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var expose = exports.expose = function expose(oggetto, firma, utente, ceo, lingua) {
  var doc = new _jspdf2.default('p', 'mm', 'a4');
  doc.setFont('times');
  var fontStart = 10;
  var traduzione = {};
  if (lingua === 'de') {
    traduzione = {
      ansprechpartner: 'Ihr Ansprechpartner',
      oeffnungszeiten: 'Öffnungszeiten',
      saluti: 'Mit freundlichen Grüßen',
      titolo: oggetto.titoloDe,
      bagni: 'Badezimmer',
      piano: 'Etage',
      baujahr: 'Baujahr',
      heizungsart: 'Heizungsart',
      energieAusweisTyp: 'Energieausweis-Typ',
      energieAusweisBis: 'Energieausweis gültig bis',
      energieBedarf: 'Energieverbrauch KWh/(m²*a)',
      energieTraeger: 'Wesentliche Energieträger',
      wohngeld: 'Hausgeld',
      affittoNetto: 'Kaltmiete',
      provvigione: 'Käuferprovision (inkl. MWSt.)',
      balcone: 'Balkon',
      ascensore: 'Aufzug',
      giardino: 'Garten',
      cantina: 'Keller',
      condizioni: 'Zustand',
      vani: 'Zimmer',
      m2: 'Größe',
      rifId: 'Ref. ID',
      descrizione: oggetto.descrizioneDe
    };
  } else if (lingua === 'it') {
    traduzione = {
      ansprechpartner: 'Il Suo referente',
      oeffnungszeiten: 'Orari di apertura',
      saluti: 'Cordiali saluti',
      titolo: oggetto.titolo,
      bagni: 'Bagni',
      piano: 'Piano',
      baujahr: 'Anno di costruzione',
      heizungsart: 'Tipo di riscaldamento',
      energieAusweisTyp: 'Certificato energetico basato sul',
      energieAusweisBis: 'Valido fino al',
      energieBedarf: 'Consumo energetico KWh/(m²*a)',
      energieTraeger: 'Fonte energetica primaria',
      wohngeld: 'Condominio',
      affittoNetto: 'Affitto netto',
      provvigione: "Provvigione per l'acquirente (IVA inclusa)",
      balcone: 'Balcone',
      ascensore: 'Ascensore',
      giardino: 'Giardino',
      cantina: 'Cantina',
      condizioni: 'Condizioni',
      vani: 'Vani',
      m2: 'Ampiezza',
      rifId: 'Rif. ID',
      descrizione: oggetto.descrizione
    };
  } else if (lingua === 'en') {
    traduzione = {
      ansprechpartner: 'Your Agent',
      oeffnungszeiten: 'Opening hours',
      saluti: 'Best regards',
      titolo: oggetto.titoloEn,
      bagni: 'Bathrooms',
      piano: 'Floor No.',
      baujahr: 'Year built',
      heizungsart: 'Heating type',
      energieAusweisTyp: 'Energy pass based on',
      energieAusweisBis: 'Valid until',
      energieBedarf: 'Energy consumption KWh/(m²*a)',
      energieTraeger: 'Primary energy carrier',
      wohngeld: 'Monthly costs',
      affittoNetto: 'Net monthly rent',
      provvigione: 'Agency fee for buyer (VAT included)',
      balcone: 'Balcony',
      ascensore: 'Elevator',
      giardino: 'Garden',
      cantina: 'Cellar',
      condizioni: 'Condition',
      vani: 'Rooms',
      m2: 'Size',
      rifId: 'Ref. ID',
      descrizione: oggetto.descrizioneEn
    };
  }
  var cartaIntestata = function cartaIntestata() {
    doc.addImage(_ImageLogo.imgLogo, 'JPEG', 130, 10, 55, 12, undefined, 'SLOW');
    //linea rossa
    doc.setDrawColor(145, 0, 0);
    doc.setLineWidth(7);
    doc.line(146, 26, 199, 26);
    //linea grigia
    doc.setDrawColor(143, 143, 143);
    doc.setLineWidth(7);
    doc.line(15, 26, 146, 26);

    //Header
    doc.setFontSize(fontStart + 1);
    doc.setTextColor(255, 255, 255);

    doc.setFontType('bold');
    doc.text(firma.name + ' ' + (firma.name2 && ' - ' + firma.name2) + ' - ' + firma.adresse + ', ' + firma.plz + ' ' + firma.stadt, 19, 27);
    //Footer
    doc.setDrawColor(0, 0, 0);
    doc.setLineWidth(0.2);
    doc.line(15, 267, 15, 282);
    doc.line(55, 267, 55, 282);
    doc.line(110, 267, 110, 282);
    // doc.line(160, 267, 160, 282);
    doc.setFontSize(fontStart);
    doc.setTextColor(143, 143, 143);
    doc.text('Inhaberin:', 16, 270);
    var position = 274;

    ceo.forEach(function (eachCeo) {
      doc.text('' + eachCeo.name, 16, position);
      position += 4;
    });
    doc.text('Telefon: ' + firma.telefon, 56, 270);
    doc.text('Telefax: ' + firma.fax, 56, 274);
    doc.text('E-Mail: ' + firma.email, 56, 278);
    doc.text('Web: ' + firma.website, 56, 282);
    doc.text('Steuernummer: ' + firma.steuerNr, 111, 270);
    doc.text('' + (firma.ustIdNr && 'Ust.-IdNr.: ' + firma.ustIdNr), 111, 274);

    //Logo IVD
    // doc.addImage(ivdLogo, 'JPEG', 161, 270, 30, 12, undefined, 'SLOW');
  };
  var frontpage = function frontpage() {
    //Frontpage
    cartaIntestata();
    var cover = new Image();
    cover.src = oggetto.downloadURLsCover;
    doc.addImage(cover, 'JPEG', 30, 35, 0, 70, undefined, 'SLOW');

    if (oggetto.downloadURLsGrundriss && oggetto.downloadURLsGrundriss.length > 0) {
      var grundriss = new Image();
      grundriss.src = oggetto.downloadURLsGrundriss[0];
      var xPos = 90;
      var yPos = 65;
      if (grundriss.width < grundriss.height) {
        xPos = 65;
        yPos = 90;
      }
      doc.addImage(grundriss, 'JPEG', 115, 130, xPos, yPos, undefined, 'SLOW');
    }

    //riquadro contatti
    doc.setDrawColor(215, 240, 245);
    doc.setLineWidth(70);
    doc.line(146, 70, 199, 70);
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(fontStart);
    doc.setFontType('normal');
    doc.text(traduzione.ansprechpartner, 149, 40);
    doc.setFontType('bold');
    doc.text('' + utente.name, 149, 44);
    doc.setFontType('normal');
    doc.text('' + utente.email, 149, 48);
    doc.text('Tel. ' + utente.telefon, 149, 52);
    doc.text('' + firma.website, 149, 56);
    doc.setFontType('bold');
    doc.text(traduzione.oeffnungszeiten, 149, 68);
    doc.setFontType('normal');
    doc.text('' + firma.open, 149, 72);
    doc.setFontType('bold');
    doc.text('' + (firma.name2 ? firma.name2 : firma.name), 149, 84);
    doc.setFontType('normal');
    doc.text('' + firma.motto, 149, 88);
    doc.text('' + firma.adresse, 149, 92);
    doc.text(firma.plz + ' ' + firma.stadt, 149, 96);
    doc.text('' + firma.staat, 149, 100);

    //Titolo
    doc.setFontSize(fontStart + 10);
    doc.setFontType('bold');
    //per centrare il titolo uso poco più della metà della larghezza di pagina e il tag 'center'
    // doc.text(traduzione.titolo, 107, 120, 'center');

    var linesTitolo = doc.splitTextToSize(traduzione.titolo, 180);
    doc.text(15, 120 + 12 / 110, linesTitolo);

    //Prezzo e indirizzo
    doc.setFontSize(fontStart + 8);
    doc.setFontType('normal');
    doc.setTextColor(145, 0, 0);
    doc.text('' + (0, _utils.formattaPrezzo)(oggetto.kaufpreis, true), 15, 135);
    doc.setFontSize(fontStart + 5);
    doc.setTextColor(0, 0, 0);
    doc.text(oggetto.via + ' ' + oggetto.numeroCivico, 15, 145);
    doc.text(oggetto.cap + ' ' + oggetto.citta, 15, 150);
    doc.text('' + oggetto.quartiere, 15, 155);
    //linea di separazione
    doc.setDrawColor(143, 143, 143);
    doc.setLineWidth(0.05);
    doc.line(15, 160, 60, 160);

    //Dettagli tecnici
    var acapo = 160;
    doc.setFontSize(fontStart + 2);
    if (oggetto.rifId.length > 0) {
      acapo += 5;
      doc.text(traduzione.rifId + ': ' + oggetto.rifId, 15, acapo);
    }

    if (oggetto.m2.length > 0) {
      acapo += 5;
      doc.text(traduzione.m2 + ': ' + oggetto.m2 + ' m2', 15, acapo);
    }

    if (oggetto.vani.length > 0) {
      acapo += 5;
      doc.text(traduzione.vani + ': ' + oggetto.vani, 15, acapo);
    }

    if (oggetto.bagni.length > 0) {
      acapo += 5;
      doc.text(traduzione.bagni + ': ' + oggetto.bagni, 15, acapo);
    }

    if (oggetto.piano.length > 0) {
      acapo += 5;
      doc.text(traduzione.piano + ': ' + oggetto.piano, 15, acapo);
    }

    if (oggetto.baujahr.length > 0) {
      acapo += 5;
      doc.text(traduzione.baujahr + ': ' + oggetto.baujahr, 15, acapo);
    }

    if (oggetto.heizungsart.length > 0) {
      var heizungsArt = oggetto.heizungsart;
      if (lingua === 'it') {
        if (heizungsArt === 'Zentralheizung' || heizungsArt === 'heating_central') {
          heizungsArt = 'centralizzato';
        } else if (heizungsArt === 'Etagenheizung' || heizungsArt === 'heating_floor') {
          heizungsArt = 'indipendente';
        }
      } else if (lingua === 'en') {
        if (heizungsArt === 'Zentralheizung' || heizungsArt === 'heating_central') {
          heizungsArt = 'central';
        } else if (heizungsArt === 'Etagenheizung' || heizungsArt === 'heating_floor') {
          heizungsArt = 'floor heating';
        }
      } else if (lingua === 'de') {
        if (heizungsArt === 'heating_central') {
          heizungsArt = 'Zentralheizung';
        } else if (heizungsArt === 'heating_floor') {
          heizungsArt = 'Etagenheizung';
        }
      }
      acapo += 5;
      doc.text(traduzione.heizungsart + ': ' + heizungsArt, 15, acapo);
    }

    if (oggetto.energieAusweisTyp.length > 0) {
      var energieausweis = oggetto.energieAusweisTyp;
      if (lingua === 'it') {
        if (energieausweis === 'Verbrauchsausweis' || energieausweis === 'based_on_consumption') {
          energieausweis = 'consumo';
        } else if (energieausweis === 'Bedarfsausweis' || energieausweis === 'based_on_requirement') {
          energieausweis = 'fabbisogno';
        }
      } else if (lingua === 'en') {
        if (energieausweis === 'Verbrauchsausweis' || energieausweis === 'based_on_consumption') {
          energieausweis = 'consumption';
        } else if (energieausweis === 'Bedarfsausweis' || energieausweis === 'based_on_requirement') {
          energieausweis = 'requirement';
        }
      } else if (lingua === 'de') {
        if (energieausweis === 'based_on_consumption') {
          energieausweis = 'Verbrauchsausweis';
        } else if (energieausweis === 'based_on_requirement') {
          energieausweis = 'Bedarfsausweis';
        }
      }

      acapo += 5;
      doc.text(traduzione.energieAusweisTyp + ': ' + energieausweis, 15, acapo);
    }

    if (oggetto.energieAusweisBis.length > 0) {
      acapo += 5;
      doc.text(traduzione.energieAusweisBis + ': ' + oggetto.energieAusweisBis, 15, acapo);
    }

    if (oggetto.energieBedarf.length > 0) {
      acapo += 5;
      doc.text(traduzione.energieBedarf + ': ' + oggetto.energieBedarf, 15, acapo);
    }

    if (oggetto.energieTraeger.length > 0) {
      var energietraeger = oggetto.energieTraeger;
      if (lingua === 'it') {
        if (energietraeger === 'Erdgas' || energietraeger === 'heating_gas') {
          energietraeger = 'gas';
        } else if (energietraeger === 'Öl' || energietraeger === 'heating_oil') {
          energietraeger = 'olio combustibile';
        } else if (energietraeger === 'Fernwärme' || energietraeger === 'heating_district') {
          energietraeger = 'teleriscaldamento';
        }
      } else if (lingua === 'en') {
        if (energietraeger === 'Erdgas' || energietraeger === 'heating_gas') {
          energietraeger = 'gaz';
        } else if (energietraeger === 'Öl' || energietraeger === 'heating_oil') {
          energietraeger = 'fuel oil';
        } else if (energietraeger === 'Fernwärme' || energietraeger === 'heating_district') {
          energietraeger = 'district heating';
        }
      } else if (lingua === 'de') {
        if (energietraeger === 'heating_gas') {
          energietraeger = 'Erdgas';
        } else if (energietraeger === 'heating_oil') {
          energietraeger = 'Öl';
        } else if (energietraeger === 'heating_district') {
          energietraeger = 'Fernwärme';
        }
      }

      acapo += 5;
      doc.text(traduzione.energieTraeger + ': ' + energietraeger, 15, acapo);
    }

    if (oggetto.wohngeld > 0) {
      acapo += 5;
      doc.text(traduzione.wohngeld + ': ' + (0, _utils.formattaPrezzo)(oggetto.wohngeld, true), 15, acapo);
    }

    if (oggetto.affittoNetto > 0) {
      acapo += 5;
      doc.text(traduzione.affittoNetto + ': ' + (0, _utils.formattaPrezzo)(oggetto.affittoNetto, true), 15, acapo);
    }

    if (oggetto.balcone) {
      acapo += 5;
      doc.text('' + traduzione.balcone, 15, acapo);
    }

    if (oggetto.ascensore) {
      acapo += 5;
      doc.text('' + traduzione.ascensore, 15, acapo);
    }

    if (oggetto.giardino) {
      acapo += 5;
      doc.text('' + traduzione.giardino, 15, acapo);
    }

    if (oggetto.cantina) {
      acapo += 5;
      doc.text('' + traduzione.cantina, 15, acapo);
    }

    if (oggetto.condizioni.length > 0) {
      var oggettoCondizioni = oggetto.condizioni;
      if (lingua === 'it') {
        if (oggettoCondizioni === 'new') {
          oggettoCondizioni = 'nuovo';
        } else if (oggettoCondizioni === 'good') {
          oggettoCondizioni = 'buone';
        } else if (oggettoCondizioni === 'to_renovate') {
          oggettoCondizioni = 'da ristrutturare';
        }
      } else if (lingua === 'de') {
        if (oggettoCondizioni === 'new') {
          oggettoCondizioni = 'neu';
        } else if (oggettoCondizioni === 'good') {
          oggettoCondizioni = 'gut';
        } else if (oggettoCondizioni === 'to_renovate') {
          oggettoCondizioni = 'renovierungsbedürftig';
        }
      } else if (lingua === 'en') {
        if (oggettoCondizioni === 'to_renovate') {
          oggettoCondizioni = 'needs refurbishment';
        }
      }

      acapo += 5;
      doc.text(traduzione.condizioni + ': ' + oggettoCondizioni, 15, acapo);
    }

    if (oggetto.provvigione > 0) {
      acapo += 5;
      doc.text(traduzione.provvigione + ': ' + (0, _utils.formattaPrezzo)(oggetto.provvigione, false) + '%', 15, acapo);
    }
  };
  var paginaDescrizione = function paginaDescrizione() {
    //Pagina Descrizione
    doc.addPage();
    cartaIntestata();
    doc.setFontSize(fontStart + 4);
    doc.setFontType('normal');
    doc.setTextColor(0, 0, 0);
    var descrizione = 'Beschreibung';
    if (lingua === 'it') {
      descrizione = 'Descrizione';
    } else if (lingua === 'en') {
      descrizione = 'Description';
    }
    doc.text(descrizione, 15, 36);
    doc.setFontSize(fontStart + 2);

    var lines = doc.setFontSize(12).splitTextToSize(traduzione.descrizione, 180);
    doc.text(15, 45 + 12 / 110, lines);
  };
  var foto = function foto() {
    //Pagina Foto
    if (oggetto.downloadURLs.length > 0) {
      doc.addPage();
      cartaIntestata();
      var pictureYPosition = 35;
      var pictureXPosition = 15;
      var alternate = true;
      var count = 0;
      // stabilisco se ho un array di urls o un array di array di urls
      var payload = Array.isArray(oggetto.downloadURLs[0]) ? oggetto.downloadURLs[0] : oggetto.downloadURLs;
      payload.map(function (url) {
        if (count === 6) {
          doc.addPage();
          cartaIntestata();
          pictureYPosition = 35;
          pictureXPosition = 15;
          alternate = true;
          count = 0;
        }
        var picture = new Image();
        picture.src = url;
        doc.addImage(picture, 'JPEG', pictureXPosition, pictureYPosition, 90, 65, undefined, 'SLOW');
        if (alternate) {
          pictureXPosition += 94;
        } else {
          pictureXPosition = 15;
          pictureYPosition += 70;
        }
        alternate = !alternate;
        count++;
      });
    }
  };
  var mappa = function mappa() {
    //Pagina Mappa
    doc.addPage();
    cartaIntestata();

    var mappa = new Image();
    mappa.src = 'https://maps.googleapis.com/maps/api/staticmap?center=' + oggetto.via + '+' + oggetto.numeroCivico + ',+' + oggetto.cap + '+' + oggetto.citta + '&zoom=15&size=800x800&maptype=roadmap\n&markers=color:blue%7Clabel:A%7C' + oggetto.latitude + ',' + oggetto.longitude + '\n&key=AIzaSyBlElUhBRSKAy_GooSEN7uZaA1dLtjzfzE';
    doc.addImage(mappa, 'PNG', 15, 50, 180, 180, undefined, 'SLOW');
  };

  var agb = function agb() {
    // AGBs
    doc.addPage();
    cartaIntestata();
    var spazio = 40;
    doc.setFontSize(fontStart + 4);
    doc.setFontType('bold');
    doc.setTextColor(0, 0, 0);
    doc.text('Allgemeine Vertragsbedingungen', 15, spazio);
    spazio += 10;

    doc.setFontType('bold');
    doc.setFontSize(fontStart + 2);
    doc.text('1. Weitergabeverbot', 15, spazio);
    spazio += 10;
    doc.setFontType('normal');
    var linesAGB1 = doc.setFontSize(12).splitTextToSize('Die Informationen über die Vertragsgelegenheit sind nur für Sie bestimmt. Eine Weitergabe der Informationen ist nicht gestattet. Für den Fall der Weitergabe und Vertragsschluss durch den Dritten sind Sie ebenfalls provisionsverpflichtet.', 180);
    doc.text(15, spazio + 12 / 110, linesAGB1);
    spazio += 20;

    doc.setFontType('bold');
    doc.setFontSize(fontStart + 2);
    doc.text('2. Gegenstand des Auftrags', 15, spazio);
    spazio += 10;

    doc.setFontType('normal');
    var linesAGB2 = doc.setFontSize(12).splitTextToSize('Gegenstand des Auftrags ist der Nachweis und/oder die Vermittlung zu der jeweiligen Vertragsgelegenheit.', 180);
    doc.text(15, spazio + 12 / 110, linesAGB2);
    spazio += 15;

    doc.setFontType('bold');
    doc.setFontSize(fontStart + 2);
    doc.text('3. Erlaubte Doppeltätigkeit', 15, spazio);
    spazio += 10;

    doc.setFontType('normal');
    var linesAGB3 = doc.setFontSize(12).splitTextToSize('Der Eigentümer der Immobilie hat uns mit dem Vertrieb beauftragt. Es ist uns daher erlaubt, sowohl für Sie, als auch für den Eigentümer vermittelnd provisionspflichtig tätig zu werden.', 180);
    doc.text(15, spazio + 12 / 110, linesAGB3);
    spazio += 15;

    doc.setFontType('bold');
    doc.setFontSize(fontStart + 2);
    doc.text('4. Inhalt der Angebote, Haftung', 15, spazio);
    spazio += 10;

    doc.setFontType('normal');
    var linesAGB4 = doc.setFontSize(12).splitTextToSize('Die Informationen zu unseren Immobilienangeboten erhalten wir vom Eigentümer oder anderen Auskunftsbefugten. Diese Angaben geben wir ohne Übernahme einer Haftung für deren Richtigkeit an Sie weiter. Sämtliche Angebote sind freibleibend, ein Zwischenverkauf bleibt vorbehalten. Verbindliche Zusagen des Maklers zur Vertragsgelegenheit bedürfen zu ihrer Wirksamkeit der Textform.', 180);
    doc.text(15, spazio + 12 / 110, linesAGB4);
    spazio += 25;

    doc.setFontType('bold');
    doc.setFontSize(fontStart + 2);
    doc.text('5. Vorkenntnis', 15, spazio);
    spazio += 10;
    doc.setFontType('normal');
    var linesAGB5 = doc.setFontSize(12).splitTextToSize('Ist Ihnen ein von uns angebotenes Objekt bereits anderweitig bekannt ist, ist uns diese Vorkenntnis innerhalb einer Woche Tagen mitzuteilen. Anderenfalls sind Sie verpflichtet, uns im Wege des Schadensersatzes die Aufwendungen zu ersetzen, die uns dadurch entstanden sind, dass Sie uns in Unkenntnis über die bestehende Vorkenntnis gelassen haben.', 180);
    doc.text(15, spazio + 12 / 110, linesAGB5);
    spazio += 25;

    doc.setFontType('bold');
    doc.setFontSize(fontStart + 2);
    doc.text('6. Gerichtsstand', 15, spazio);
    spazio += 10;
    doc.setFontType('normal');
    var linesAGB6 = doc.setFontSize(12).splitTextToSize('Ist unser Kunde Kaufmann oder unterhält er keinen Wohnsitz in Deutschland, gilt als Gerichtsstand und Erfüllungsort der Geschäftssitz des Maklers.', 180);
    doc.text(15, spazio + 12 / 110, linesAGB6);
  };
  var widerrufsBelehrung = function widerrufsBelehrung() {
    //Wiedderrufsbelehrung
    doc.addPage();
    cartaIntestata();
    //box
    doc.setDrawColor(0, 0, 0);
    doc.setLineWidth(0.2);
    doc.line(13, 260, 200, 260);
    doc.line(13, 170, 200, 170);
    doc.line(13, 170, 13, 260);
    doc.line(200, 170, 200, 260);

    //corpo
    doc.setTextColor(0, 0, 0);
    var spazioW = 35;
    doc.setFontType('bold');
    doc.setFontSize(fontStart);
    doc.text('Widerrufsrecht für Verbraucher', 15, spazioW);
    spazioW += 5;
    doc.setFontType('normal');
    var linesW1 = doc.setFontSize(10).splitTextToSize('Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen. Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsabschlusses. Um Ihr Widerrufsrecht auszuüben, müssen Sie uns:', 180);
    doc.text(15, spazioW + 10 / 110, linesW1);
    spazioW += 10;

    doc.text(firma.name + ' ' + (firma.name2 && ' - ' + firma.name2), 15, spazioW);
    spazioW += 5;
    doc.text(firma.adresse + ', ' + firma.plz + ' ' + firma.stadt, 15, spazioW);
    spazioW += 5;
    doc.text('Tel: ' + firma.telefon, 15, spazioW);
    spazioW += 5;
    doc.text('Fax: ' + firma.fax, 15, spazioW);
    spazioW += 5;
    doc.text('E-Mail: ' + firma.email, 15, spazioW);
    spazioW += 5;

    var linesW2 = doc.setFontSize(10).splitTextToSize('mittels einer eindeutigen Erklärung (z.B. ein mit der Post versandter Brief, Telefax oder E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Sie können dafür das beigefügte Muster- Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist. Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.', 180);
    doc.text(15, spazioW + 10 / 110, linesW2);
    spazioW += 20;

    doc.setFontType('bold');
    doc.setFontSize(fontStart);
    doc.text('Folgen des Widerrufs', 15, spazioW);
    spazioW += 5;
    doc.setFontType('normal');
    var linesW3 = doc.setFontSize(10).splitTextToSize('Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, einschließlich der Lieferkosten (mit Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass Sie eine andere Art der Lieferung als die von uns angebotene, günstigste Standardlieferung gewählt haben), unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses Vertrags bei uns eingegangen ist. Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich etwas anderes vereinbart; in keinem Fall werden Ihnen wegen dieser Rückzahlung Entgelte berechnet.', 180);
    doc.text(15, spazioW + 10 / 110, linesW3);
    spazioW += 30;
    var linesW4 = doc.setFontSize(10).splitTextToSize('Haben Sie verlangt, dass die Dienstleistungen während der Widerrufsfrist beginnen soll, so haben Sie uns einen angemessenen Betrag zu zahlen, der dem Anteil der bis zu dem Zeitpunkt, zu dem Sie uns von der Ausübung des Widerrufsrechts hinsichtlich dieses Vertrags unterrichten, bereits erbrachten Dienstleistungen im Vergleich zum Gesamtumfang der im Vertrag vorgesehenen Dienstleistung entspricht.', 180);
    doc.text(15, spazioW + 10 / 110, linesW4);
    spazioW += 20;

    doc.setFontType('bold');
    doc.setFontSize(fontStart);
    doc.text('Hinweis zum vorzeitigen Erlöschen des Widerrufsrechts', 15, spazioW);
    spazioW += 5;
    doc.setFontType('normal');
    var linesW5 = doc.setFontSize(10).splitTextToSize('Ihr Widerrufsrecht erlischt bei einem Vertrag zur Erbringung von Dienstleistungen vorzeitig, wenn wir die Dienstleistung vollständig erbracht haben und mit der Ausführung der Dienstleistung erst begonnen haben, nachdem Sie dazu Ihre ausdrückliche Zustimmung gegeben haben und gleichzeitig Ihre Kenntnis davon bestätigt haben, dass Sie Ihr Widerrufsrecht bei vollständiger Vertragserfüllung durch uns verlieren.', 180);
    doc.text(15, spazioW + 10 / 110, linesW5);
    spazioW += 20;

    doc.setFontType('bold');
    doc.setFontSize(fontStart);
    doc.text('Anlage - Muster-Widerrufsformular', 15, spazioW);
    spazioW += 5;
    doc.setFontType('normal');
    var linesW6 = doc.setFontSize(10).splitTextToSize('(Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses Formular aus und senden Sie es zurück)', 180);
    doc.text(15, spazioW + 10 / 110, linesW6);
    spazioW += 5;
    doc.text('An:', 15, spazioW);
    spazioW += 5;
    doc.text(firma.name + ' ' + (firma.name2 && ' - ' + firma.name2), 15, spazioW);
    spazioW += 5;
    doc.text(firma.adresse + ', ' + firma.plz + ' ' + firma.stadt, 15, spazioW);
    spazioW += 5;
    doc.text('Tel: ' + firma.telefon, 15, spazioW);
    spazioW += 5;
    doc.text('Fax: ' + firma.fax, 15, spazioW);
    spazioW += 5;
    doc.text('E-Mail: ' + firma.email, 15, spazioW);
    spazioW += 10;

    var linesW7 = doc.setFontSize(10).splitTextToSize('Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über die Erbringung von Maklerdienstleistungen vom:                            über:', 180);
    doc.text(15, spazioW + 10 / 110, linesW7);
    spazioW += 10;
    doc.text('Name des/der Verbraucher(s):', 15, spazioW);
    spazioW += 5;
    doc.text('Anschrift des/der Verbraucher(s):', 15, spazioW);
    spazioW += 5;
    doc.text('Datum:                                               Unterschrift des/der Verbraucher(s)**: ______________________________________', 15, spazioW);
    spazioW += 10;
    doc.text('(*)Unzutreffendes streichen', 15, spazioW);
    spazioW += 5;
    doc.text('** nur bei Mitteilung auf Papier', 15, spazioW);
  };

  //RENDER
  frontpage();
  paginaDescrizione();
  foto();
  mappa();
  agb();
  widerrufsBelehrung();

  //Save
  doc.save(oggetto.rifId + '-Expos\xE9-' + lingua + '.pdf');
};
// import { ivdLogo } from './img/IvdLogo';

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _axios = __webpack_require__(67);

var _axios2 = _interopRequireDefault(_axios);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _configureStore = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImmoscoutAPI = function ImmoscoutAPI(_ref) {
  var oggetto = _ref.oggetto,
      startEditOggetto = _ref.startEditOggetto;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      spinner = _useState2[0],
      useSpinner = _useState2[1];

  //Per inviare i dati dell'immobile


  var is24api = function is24api() {
    useSpinner(true);

    _axios2.default.post("https://is24api.herokuapp.com" + '/property', oggetto).then(function (response) {
      startEditOggetto(oggetto.id, _extends({}, oggetto, {
        is24id: response.data['common.messages'][0].message.id
      }));
      useSpinner(false);
    }).catch(function (error) {
      console.log(error);
      useSpinner(false);
    });
  };

  var imgUpload = function imgUpload() {
    var imageFile = new FormData();
    imageFile.append('file', oggetto.downloadURLsCover[0]);
    _axios2.default.post("https://is24api.herokuapp.com" + '/image', {
      img: oggetto.downloadURLsCover[0], //imageFile,
      // token: localStorage.getItem('token'),
      is24id: oggetto.is24id
    }).then(function (response) {
      return console.log(response.data);
    });
  };

  var btnColor = oggetto.is24id ? 'disabled' : 'green';
  return _react2.default.createElement(
    'div',
    null,
    spinner ? _react2.default.createElement('img', { className: 'loader__image', src: '/images/loader.gif' }) : _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'button',
        { className: 'btn ' + btnColor, onClick: is24api },
        'Export to IS24'
      )
    )
  );
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    startEditOggetto: function startEditOggetto(id, oggetto) {
      return dispatch(_configureStore.storeActions.find(function (action) {
        return action.label === 'oggetti';
      }).startEditAction(id, oggetto));
    }
  };
};

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)((0, _reactI18next.withTranslation)()(ImmoscoutAPI));

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var regeneratorRuntime = __webpack_require__(1122);function asyncGeneratorStep(e,r,n,t,o,a,c){try{var s=e[a](c),u=s.value}catch(e){return void n(e)}s.done?r(u):Promise.resolve(u).then(t,o)}function _asyncToGenerator(e){return function(){var r=this,n=arguments;return new Promise(function(t,o){var a=e.apply(r,n);function c(e){asyncGeneratorStep(a,t,o,c,s,"next",e)}function s(e){asyncGeneratorStep(a,t,o,c,s,"throw",e)}c(void 0)})}}Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=void 0;var DEBUG=!1,API_KEY=null,LANGUAGE="en",REGION=null,GOOGLE_API="https://maps.google.com/maps/api/geocode/json";function log(e){var r=arguments.length>1&&void 0!==arguments[1]&&arguments[1];DEBUG&&(r?console.warn(e):console.log(e))}function handleUrl(e){return _handleUrl.apply(this,arguments)}function _handleUrl(){return(_handleUrl=_asyncToGenerator(regeneratorRuntime.mark(function e(r){var n,t;return regeneratorRuntime.wrap(function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,fetch(r).catch(function(){return Promise.reject(new Error("Error fetching data"))});case 2:return n=e.sent,e.next=5,n.json().catch(function(){return log("Error parsing server response"),Promise.reject(new Error("Error parsing server response"))});case 5:if("OK"!==(t=e.sent).status){e.next=9;break}return log(t),e.abrupt("return",t);case 9:return log("".concat(t.error_message,".\nServer returned status code ").concat(t.status),!0),e.abrupt("return",Promise.reject(new Error("".concat(t.error_message,".\nServer returned status code ").concat(t.status))));case 11:case"end":return e.stop()}},e)}))).apply(this,arguments)}var _default={setApiKey:function(apiKey){API_KEY=apiKey},setLanguage:function(language){LANGUAGE=language},setRegion:function(region){REGION=region},enableDebug:function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];DEBUG=e},fromLatLng:function(lat,lng,apiKey,language,region){return _asyncToGenerator(regeneratorRuntime.mark(function a(){var c,s;return regeneratorRuntime.wrap(function(a){for(;;)switch(a.prev=a.next){case 0:if(lat&&lng){a.next=3;break}return log("Provided coordinates are invalid",!0),a.abrupt("return",Promise.reject(new Error("Provided coordinates are invalid")));case 3:return c="".concat(lat,",").concat(lng),s="".concat(GOOGLE_API,"?latlng=").concat(encodeURIComponent(c)),(apiKey||API_KEY)&&(s+="&key=".concat(API_KEY=apiKey||API_KEY)),(language||LANGUAGE)&&(s+="&language=".concat(LANGUAGE=language||LANGUAGE)),(region||REGION)&&(REGION=region||REGION,s+="&region=".concat(encodeURIComponent(REGION))),a.abrupt("return",handleUrl(s));case 9:case"end":return a.stop()}},a)}))()},fromAddress:function(address,apiKey,language,region){return _asyncToGenerator(regeneratorRuntime.mark(function o(){var a;return regeneratorRuntime.wrap(function(o){for(;;)switch(o.prev=o.next){case 0:if(address){o.next=3;break}return log("Provided address is invalid",!0),o.abrupt("return",Promise.reject(new Error("Provided address is invalid")));case 3:return a="".concat(GOOGLE_API,"?address=").concat(encodeURIComponent(address)),(apiKey||API_KEY)&&(a+="&key=".concat(API_KEY=apiKey||API_KEY)),(language||LANGUAGE)&&(a+="&language=".concat(LANGUAGE=language||LANGUAGE)),(region||REGION)&&(REGION=region||REGION,a+="&region=".concat(encodeURIComponent(REGION))),o.abrupt("return",handleUrl(a));case 8:case"end":return o.stop()}},o)}))()}};exports.default=_default;

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : {}
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _axios = __webpack_require__(67);

var _axios2 = _interopRequireDefault(_axios);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _configureStore = __webpack_require__(14);

var _collectionItem = __webpack_require__(160);

var _collectionItem2 = _interopRequireDefault(_collectionItem);

var _creaPayload2 = __webpack_require__(1124);

var _postProperty = __webpack_require__(1125);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var M2SquareAPI = function M2SquareAPI(_ref) {
  var oggetto = _ref.oggetto,
      startEditOggetto = _ref.startEditOggetto,
      t = _ref.t;

  (0, _react.useEffect)(function () {
    // dopo ogni chiamata api dovrei cancellare la sottoscrizione
    var CancelToken = _axios2.default.CancelToken;
    var source = CancelToken.source();

    // Get Token
    var loadData = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _ref3, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _axios2.default.post("https://www.m2square.eu" + '/wp-json/jwt-auth/v1/token', {
                  username: '' + "Ralph2",
                  password: '' + "m3cUBem33!"
                }, { cancelToken: source.token });

              case 3:
                _ref3 = _context.sent;
                data = _ref3.data;

                localStorage.setItem('token', data.token);
                _context.next = 15;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](0);

                if (!_axios2.default.isCancel(_context.t0)) {
                  _context.next = 14;
                  break;
                }

                console.log('cancelled');
                _context.next = 15;
                break;

              case 14:
                throw _context.t0;

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, undefined, [[0, 8]]);
      }));

      return function loadData() {
        return _ref2.apply(this, arguments);
      };
    }();
    loadData();
    return function () {
      source.cancel();
    };
  }, []);
  console.log('m2Square API loaded');

  var _creaPayload = (0, _creaPayload2.creaPayload)(oggetto),
      payload = _creaPayload.payload,
      payloadEn = _creaPayload.payloadEn,
      payloadIt = _creaPayload.payloadIt;

  var sendDeRequest = function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var result;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return startEditOggetto(oggetto.id, {
                spinner: true
              });

            case 2:
              _context2.prev = 2;
              _context2.next = 5;
              return (0, _postProperty.postProperty)('De', payload, payload.postIdDe && payload.postIdDe);

            case 5:
              result = _context2.sent;
              _context2.next = 8;
              return startEditOggetto(oggetto.id, result);

            case 8:
              _context2.next = 13;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2['catch'](2);

              console.log(_context2.t0);

            case 13:
              _context2.prev = 13;

              startEditOggetto(oggetto.id, { spinner: false });
              return _context2.finish(13);

            case 16:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, undefined, [[2, 10, 13, 16]]);
    }));

    return function sendDeRequest() {
      return _ref4.apply(this, arguments);
    };
  }();

  var sendItRequest = function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var result;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return startEditOggetto(oggetto.id, {
                spinner: true
              });

            case 2:
              _context3.prev = 2;
              _context3.next = 5;
              return (0, _postProperty.postProperty)('It', payloadIt, payload.postIdIt && payload.postIdIt);

            case 5:
              result = _context3.sent;

              console.log('RESULT: ', result);
              // passo allo store il post id che mi ritorna, l'array di immagini inviate e spinner false
              _context3.next = 9;
              return startEditOggetto(oggetto.id, result);

            case 9:
              _context3.next = 14;
              break;

            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3['catch'](2);

              console.log(_context3.t0);

            case 14:
              _context3.prev = 14;

              startEditOggetto(oggetto.id, { spinner: false });
              return _context3.finish(14);

            case 17:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, undefined, [[2, 11, 14, 17]]);
    }));

    return function sendItRequest() {
      return _ref5.apply(this, arguments);
    };
  }();

  var sendEnRequest = function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var result;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return startEditOggetto(oggetto.id, {
                spinner: true
              });

            case 2:
              _context4.prev = 2;
              _context4.next = 5;
              return (0, _postProperty.postProperty)('En', payloadEn, payload.postIdEn && payload.postIdEn);

            case 5:
              result = _context4.sent;
              _context4.next = 8;
              return startEditOggetto(oggetto.id, result);

            case 8:
              _context4.next = 13;
              break;

            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4['catch'](2);

              console.log(_context4.t0);

            case 13:
              _context4.prev = 13;

              startEditOggetto(oggetto.id, { spinner: false });
              return _context4.finish(13);

            case 16:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, undefined, [[2, 10, 13, 16]]);
    }));

    return function sendEnRequest() {
      return _ref6.apply(this, arguments);
    };
  }();

  var sendAllRequests = function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return sendDeRequest();

            case 3:
              _context5.next = 5;
              return sendEnRequest();

            case 5:
              _context5.next = 7;
              return sendItRequest();

            case 7:
              _context5.next = 12;
              break;

            case 9:
              _context5.prev = 9;
              _context5.t0 = _context5['catch'](0);

              console.log(_context5.t0);

            case 12:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, undefined, [[0, 9]]);
    }));

    return function sendAllRequests() {
      return _ref7.apply(this, arguments);
    };
  }();

  var btnColorDe = oggetto.postIdDe ? 'green' : 'blue';
  var btnColorEn = oggetto.postIdEn ? 'green' : 'blue';
  var btnColorIt = oggetto.postIdIt ? 'green' : 'blue';
  var btnColorAll = oggetto.postIdDe && oggetto.postIdEn && oggetto.postIdIt ? 'green' : 'blue';

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'h5',
      null,
      t('sync_website')
    ),
    oggetto.spinner ? _react2.default.createElement(
      'div',
      { className: 'progress' },
      _react2.default.createElement('div', { className: 'indeterminate' })
    ) : _react2.default.createElement(
      'ul',
      { className: 'collection' },
      oggetto.downloadURLsCover && oggetto.titoloDe && _react2.default.createElement(_collectionItem2.default, {
        label: 'Sync ' + t('tedesco'),
        action: sendDeRequest,
        icon: oggetto.postIdDe ? 'update' : 'add',
        btnColor: btnColorDe
      }),
      oggetto.downloadURLsCover && oggetto.titolo && _react2.default.createElement(_collectionItem2.default, {
        label: 'Sync ' + t('italiano'),
        action: sendItRequest,
        icon: oggetto.postIdIt ? 'update' : 'add',
        btnColor: btnColorIt
      }),
      oggetto.downloadURLsCover && oggetto.titoloEn && _react2.default.createElement(_collectionItem2.default, {
        label: 'Sync ' + t('inglese'),
        action: sendEnRequest,
        icon: oggetto.postIdEn ? 'update' : 'add',
        btnColor: btnColorEn
      }),
      oggetto.downloadURLsCover && oggetto.titolo.length > 1 && oggetto.titoloDe.length > 1 && oggetto.titoloEn.length > 1 && _react2.default.createElement(_collectionItem2.default, {
        label: 'Sync All',
        action: sendAllRequests,
        icon: oggetto.postIdDe && oggetto.postIdIt && oggetto.postIdEn ? 'update' : 'add',
        btnColor: btnColorAll
      })
    )
  );
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    startEditOggetto: function startEditOggetto(id, oggetto) {
      return dispatch(_configureStore.storeActions.find(function (action) {
        return action.label === 'oggetti';
      }).startEditAction(id, oggetto));
    }
  };
};

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)((0, _reactI18next.withTranslation)()(M2SquareAPI));

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.creaPayload = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(9);

var creaPayload = exports.creaPayload = function creaPayload(oggetto) {
  var oggettoCopy = _extends({}, oggetto);

  // Modifico l'oggetto per farlo aderire ai campi su WP
  var via = oggettoCopy.via + ' ' + oggettoCopy.numeroCivico;
  var affittoNetto = oggettoCopy.affittoNetto > 0 ? '' + (0, _utils.formattaPrezzo)(oggettoCopy.affittoNetto, true) : null;

  var kaufpreis = oggettoCopy.kaufpreis > 0 ? (0, _utils.visualizzaDecimaleConVirgola)(oggettoCopy.kaufpreis) : null;

  var wohngeld = oggettoCopy.wohngeld > 0 ? '' + (0, _utils.formattaPrezzo)(oggettoCopy.wohngeld, true) : null;

  if (oggettoCopy.energieAusweisTyp === 'based_on_consumption') {
    oggettoCopy.energieAusweisTyp = 'Consumption';
  } else if (oggettoCopy.energieAusweisTyp === 'based_on_requirement') {
    oggettoCopy.energieAusweisTyp = 'Requirement';
  }

  if (oggettoCopy.heizungsart === 'heating_central') {
    oggettoCopy.heizungsart = 'Central heating system';
  } else if (oggettoCopy.heizungsart === 'heating_floor') {
    oggettoCopy.heizungsart = 'Floor heating system';
  }

  if (oggettoCopy.energieTraeger === 'heating_gas') {
    oggettoCopy.energieTraeger = 'Gas';
  } else if (oggettoCopy.energieTraeger === 'heating_district') {
    oggettoCopy.energieTraeger = 'District heating';
  } else if (oggettoCopy.energieTraeger === 'heating_oil') {
    oggettoCopy.energieTraeger = 'Fuel oil';
  }

  if (oggettoCopy.stato === 'vacant' || oggettoCopy.tipologia === 'property_apt') {
    oggettoCopy.tipologia = [243, 240, 244];
  } else if (oggettoCopy.stato === 'rented' || oggettoCopy.tipologia === 'property_apt') {
    oggettoCopy.tipologia = [247, 241, 248];
  } else if (oggettoCopy.tipologia === 'property_nursing_home') {
    oggettoCopy.tipologia = [953, 952, 954];
  } else if (oggettoCopy.tipologia === 'property_commercial') {
    oggettoCopy.tipologia = [245, 242, 246];
  } else {
    oggettoCopy.tipologia = [243, 240, 244];
  }

  // Creo array di codici delle categorie da passare a ogni traduzione
  var property_area = function property_area() {
    switch (oggettoCopy.quartiere) {
      case 'Charlottenburg':
        return [303, 302, 304];
      case 'Friedrichshain':
        return [255, 235, 256];
      case 'Hohenschonhausen':
        return [595, 596, 594];
      case 'Kreuzberg':
        return [257, 238, 258];
      case 'Lichtenberg':
        return [259, 236, 260];
      case 'Lichtenrade':
        return [700, 701, 702];
      case 'Mitte':
        return [309, 308, 310];
      case 'Moabit':
        return [3338, 3338, 3339];
      case 'Neukölln':
        return [270, 269, 271];
      case 'Pankow':
        return [321, 320, 322];
      case 'Prenzlauer Berg':
        return [262, 234, 261];
      case 'Reinickendorf':
        return [592, 591, 593];
      case 'Schöneberg':
        return [585, 584, 586];
      case 'Spandau':
        return [327, 323, 326];
      case 'Steglitz':
        return [274, 272, 273];
      case 'Tegel':
        return [300, 299, 301];
      case 'Tempelhof':
        return [317, 319, 318];
      case 'Tiergarten':
        return [313, 311, 314];
      case 'Treptow-Köpenick':
        return [329, 324, 328];
      case 'Wedding':
        return [264, 237, 263];
      case 'Weißensee':
        return [330, 325, 331];
      case 'Wilmersdorf':
        return [296, 298, 297];
      case 'Zehlendorf':
        return [305, 307, 306];
    }
  };

  var property_city = function property_city() {
    switch (oggettoCopy.citta) {
      case 'Berlin':
        return [284, 232, 285];
      case 'Leipzig':
        return [655, 654, 656];
    }
  };
  var property_county_state = function property_county_state() {
    switch (oggettoCopy.citta) {
      case 'Berlin':
        return [265, 230, 266];
      case 'Leipzig':
        return [267, 231, 268];
    }
  };

  var property_action_category = [249, 239, 250];

  // Creo il payload da passare ad axios
  var payload = {
    title: oggettoCopy.titoloDe,
    content: oggettoCopy.descrizioneDe,
    // postId: oggettoCopy.postIdDe || null,
    affittoNetto: affittoNetto,
    ascensore: oggettoCopy.ascensore || null,
    bagni: oggettoCopy.bagni || null,
    balcone: oggettoCopy.balcone || null,
    baujahr: oggettoCopy.baujahr || null,
    cantina: oggettoCopy.cantina || null,
    cap: oggettoCopy.cap || null,
    downloadURLsId: oggettoCopy.downloadURLsId,
    energieAusweisBis: oggettoCopy.energieAusweisBis || null,
    energieAusweisTyp: oggettoCopy.energieAusweisTyp || null,
    energieBedarf: oggettoCopy.energieBedarf || null,
    energieTraeger: oggettoCopy.energieTraeger || null,
    featuredProperty: oggettoCopy.featuredProperty || null,
    giardino: oggettoCopy.giardino || null,
    heizungsart: oggettoCopy.heizungsart || null,
    immaginiInviate: oggettoCopy.immaginiInviate || [],
    kaufpreis: kaufpreis,
    m2: oggettoCopy.m2 || null,
    piano: oggettoCopy.piano || null,
    postIdDe: oggettoCopy.postIdDe || null,
    postIdEn: oggettoCopy.postIdEn || null,
    postIdIt: oggettoCopy.postIdIt || null,
    property_latitude: oggettoCopy.latitude || null,
    property_longitude: oggettoCopy.longitude || null,
    property_status: 'normal',
    provvigione: oggettoCopy.provvigione && (0, _utils.visualizzaDecimaleConVirgola)(oggettoCopy.provvigione) + '%' || null,
    rifId: oggettoCopy.rifId || null,
    terms: {
      property_area: oggettoCopy.quartiere ? property_area() ? property_area()[0] : null : null,
      property_city: oggettoCopy.citta ? property_city() ? property_city()[0] : null : null,
      property_county_state: oggettoCopy.citta ? property_county_state() ? property_county_state()[0] : null : null,
      property_category: oggettoCopy.tipologia[0],
      property_action_category: property_action_category[0]
    },
    themeSlider: oggettoCopy.themeSlider || null,
    vani: oggettoCopy.vani || null,
    via: via,
    videoId: oggettoCopy.videoId || null,
    wohngeld: wohngeld
  };

  // Cover
  if (oggettoCopy.downloadURLsCoverId) {
    payload.featured_media = oggettoCopy.downloadURLsCoverId[0];
  }

  // Grundriss
  payload.useFloorPlans = 0;
  if (oggettoCopy.downloadURLsGrundriss) {
    payload.downloadURLsGrundriss = oggettoCopy.downloadURLsGrundriss;
  }
  if (oggettoCopy.downloadURLsGrundrissId) {
    payload.downloadURLsGrundrissId = oggettoCopy.downloadURLsGrundrissId;
    payload.useFloorPlans = 1;
    payload.planTitle = [];
    for (var i = 0; i < payload.downloadURLsGrundrissId.length; i++) {
      payload.planTitle.push('Grundriss ' + (i + 1));
    }
  }

  if (oggettoCopy.status) {
    payload.status = 'publish';
  } else {
    payload.status = 'draft';
  }
  if (oggettoCopy.prenotato) payload.property_status = 'reserved';
  if (oggettoCopy.venduto) payload.property_status = 'sold';

  var payloadIt = _extends({}, payload, {
    title: oggettoCopy.titolo,
    content: oggettoCopy.descrizione,
    terms: {
      property_area: oggettoCopy.quartiere ? property_area() ? property_area()[2] : null : null,
      property_city: oggettoCopy.citta ? property_city() ? property_city()[2] : null : null,
      property_county_state: oggettoCopy.citta ? property_county_state() ? property_county_state()[2] : null : null,
      property_category: oggettoCopy.tipologia[2],
      property_action_category: property_action_category[2]
    }
  });

  var payloadEn = _extends({}, payload, {
    title: oggettoCopy.titoloEn,
    content: oggettoCopy.descrizioneEn,
    terms: {
      property_area: oggettoCopy.quartiere ? property_area() ? property_area()[1] : null : null,
      property_city: oggettoCopy.citta ? property_city() ? property_city()[1] : null : null,
      property_county_state: oggettoCopy.citta ? property_county_state() ? property_county_state()[1] : null : null,
      property_category: oggettoCopy.tipologia[1],
      property_action_category: property_action_category[1]
    }
  });

  return { payload: payload, payloadIt: payloadIt, payloadEn: payloadEn };
};

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postProperty = undefined;

var _axios = __webpack_require__(67);

var _axios2 = _interopRequireDefault(_axios);

var _functions = __webpack_require__(1126);

var _images = __webpack_require__(1127);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var postProperty = exports.postProperty = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(language, payload, postId) {
    var _ref2, data, newLink, searchTerm, indexOfFirst, firstPart, languagePart, secondPart, immaginiInviate, _ref3, _ref4;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return (0, _axios2.default)({
              method: postId ? 'put' : 'post',
              url: postId ? "https://www.m2square.eu" + '/wp-json/wp/v2/estate_property/' + postId : "https://www.m2square.eu" + '/wp-json/wp/v2/estate_property',
              data: payload,
              headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token')
              }
            });

          case 3:
            _ref2 = _context.sent;
            data = _ref2.data;


            console.log((postId ? 'PUT' : 'POST') + ' Sent Payload ' + language + ': ', payload);
            console.log((postId ? 'PUT' : 'POST') + ' Response Data ' + language + ': ', data);

            newLink = data.link;

            // sto creando il post

            if (!postId) {
              localStorage.setItem('postId' + language, data.id);

              //i link che ricevo non contengono la sigla per la lingua. La devo inserire io
              if (language !== 'De') {
                searchTerm = '/immobili';
                indexOfFirst = data.link.indexOf(searchTerm);
                firstPart = newLink.slice(0, indexOfFirst);
                languagePart = language.toLowerCase();
                secondPart = newLink.slice(indexOfFirst);

                newLink = firstPart + '/' + languagePart + secondPart;
              }
            }

            // posto i custom field di estate_property tramite il plugin che ho scritto
            _context.next = 11;
            return (0, _functions.postCustomFields)(payload, postId || data.id);

          case 11:
            _context.next = 13;
            return (0, _images.postImages)(postId || data.id, payload.downloadURLsId, language, payload.immaginiInviate);

          case 13:
            immaginiInviate = _context.sent;

            console.log('Immagini inviate: ', immaginiInviate);

            _context.t0 = !postId;

            if (!_context.t0) {
              _context.next = 19;
              break;
            }

            _context.next = 19;
            return (0, _functions.postTranslation)(localStorage.getItem('postIdDe'), data.id, language);

          case 19:
            _context.t1 = payload.downloadURLsId;

            if (!_context.t1) {
              _context.next = 23;
              break;
            }

            _context.next = 23;
            return (0, _images.translateImages)(payload.downloadURLsId, language);

          case 23:
            if (postId) {
              _context.next = 27;
              break;
            }

            return _context.abrupt('return', (_ref3 = {}, _defineProperty(_ref3, 'postId' + language, data.id), _defineProperty(_ref3, 'link' + language, newLink), _defineProperty(_ref3, 'immaginiInviate', [].concat(_toConsumableArray(immaginiInviate))), _ref3));

          case 27:
            return _context.abrupt('return', (_ref4 = {}, _defineProperty(_ref4, 'link' + language, newLink), _defineProperty(_ref4, 'immaginiInviate', [].concat(_toConsumableArray(immaginiInviate))), _ref4));

          case 28:
            _context.next = 33;
            break;

          case 30:
            _context.prev = 30;
            _context.t2 = _context['catch'](0);

            console.log(_context.t2);

          case 33:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined, [[0, 30]]);
  }));

  return function postProperty(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postTranslation = exports.postCustomFields = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _axios = __webpack_require__(67);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var postCustomFields = exports.postCustomFields = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(payload, postId) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _axios2.default.post("https://www.m2square.eu" + '/wp-json/wl/v1/properties/', _extends({}, payload, { postId: postId }), {
              headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token')
              }
            });

          case 2:
            console.log('Payload Custom Fields: ', payload);

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function postCustomFields(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var postTranslation = exports.postTranslation = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(postIdDe, postId, language) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(language !== 'De')) {
              _context2.next = 3;
              break;
            }

            _context2.next = 3;
            return _axios2.default.post("https://www.m2square.eu" + '/wp-json/wl/v1/translation/', {
              original: parseInt(postIdDe, 10),
              translation: postId,
              language: language.toLowerCase()
            }, {
              headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token')
              }
            });

          case 3:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  return function postTranslation(_x3, _x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translateImages = exports.postImages = undefined;

var _axios = __webpack_require__(67);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var postImages = exports.postImages = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(postId, payload, language, immaginiInviate) {
    var i, sortPayload, sendImage, sendNewImages;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            // se ci sono immagini non inviate, le posto. gli id sono un array di arrays
            // il check di invio si basa sull'array immaginiInviate
            i = 0;

            if (language === 'En') {
              i = 1;
            } else if (language === 'It') {
              i = 2;
            }

            if (!(payload && payload[i].length > 0)) {
              _context3.next = 9;
              break;
            }

            console.log('Foto Payload: ' + i, payload[i]);

            sortPayload = [];

            // payload[i].forEach((id, indice) => {

            sendImage = function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id) {
                var _ref3, data;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return _axios2.default.put("https://www.m2square.eu" + '/wp-json/wp/v2/media/' + id, { post: postId }, {
                          headers: {
                            'Content-Type': 'application/json',
                            Authorization: 'Bearer ' + localStorage.getItem('token')
                          }
                        });

                      case 3:
                        _ref3 = _context.sent;
                        data = _ref3.data;
                        return _context.abrupt('return', data);

                      case 8:
                        _context.prev = 8;
                        _context.t0 = _context['catch'](0);

                        console.log(_context.t0);

                      case 11:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, undefined, [[0, 8]]);
              }));

              return function sendImage(_x5) {
                return _ref2.apply(this, arguments);
              };
            }();

            sendNewImages = function () {
              var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(payload) {
                var _i;

                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        _i = 0;

                      case 1:
                        if (!(_i < payload.length)) {
                          _context2.next = 10;
                          break;
                        }

                        sortPayload.push({
                          postId: payload[_i],
                          menuOrder: _i
                        });

                        if (immaginiInviate.includes(payload[_i])) {
                          _context2.next = 7;
                          break;
                        }

                        _context2.next = 6;
                        return sendImage(payload[_i]);

                      case 6:
                        immaginiInviate.push(payload[_i]);

                      case 7:
                        _i++;
                        _context2.next = 1;
                        break;

                      case 10:
                        return _context2.abrupt('return', true);

                      case 11:
                      case 'end':
                        return _context2.stop();
                    }
                  }
                }, _callee2, undefined);
              }));

              return function sendNewImages(_x6) {
                return _ref4.apply(this, arguments);
              };
            }();

            _context3.next = 9;
            return sendNewImages(payload[i]).then(function () {
              console.log(sortPayload);
              _axios2.default.put("https://www.m2square.eu" + '/wp-json/wl/v1/sortimage/', sortPayload, {
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: 'Bearer ' + localStorage.getItem('token')
                }
              });
            });

          case 9:
            return _context3.abrupt('return', immaginiInviate);

          case 10:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, undefined);
  }));

  return function postImages(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

var translateImages = exports.translateImages = function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(downloadURLsId, language) {
    var imgArray, translationArray;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!(language !== 'De')) {
              _context4.next = 7;
              break;
            }

            imgArray = [];
            translationArray = [];


            if (language === 'En') {
              imgArray = [].concat(_toConsumableArray(downloadURLsId[1]));
            } else if (language === 'It') {
              imgArray = [].concat(_toConsumableArray(downloadURLsId[2]));
            }
            downloadURLsId[0].forEach(function (url, i) {
              translationArray.push({
                original: url,
                translation: imgArray[i],
                language: language.toLowerCase()
              });
            });

            _context4.next = 7;
            return _axios2.default.post("https://www.m2square.eu" + '/wp-json/wl/v1/mediatranslation/', translationArray, {
              headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token')
              }
            });

          case 7:
            return _context4.abrupt('return', true);

          case 8:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, undefined);
  }));

  return function translateImages(_x7, _x8) {
    return _ref5.apply(this, arguments);
  };
}();

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditOggettoPage = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _OggettoForm = __webpack_require__(611);

var _OggettoForm2 = _interopRequireDefault(_OggettoForm);

var _configureStore = __webpack_require__(14);

var _OptionModal = __webpack_require__(58);

var _OptionModal2 = _interopRequireDefault(_OptionModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditOggettoPage = exports.EditOggettoPage = function (_React$Component) {
  _inherits(EditOggettoPage, _React$Component);

  function EditOggettoPage() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, EditOggettoPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditOggettoPage.__proto__ || Object.getPrototypeOf(EditOggettoPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isOpen: false,
      modalContent: 'remove_confirm',
      btnEnabled: true
    }, _this.handleOpenModal = function () {
      _this.setState(function () {
        return {
          isOpen: true
        };
      });
    }, _this.handleCloseModal = function () {
      _this.setState({ isOpen: false });
    }, _this.onSubmit = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(oggetto) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.props.startEditOggetto(_this.props.oggetto.id, oggetto);

              case 2:
                _this.props.history.push('/oggettoview/' + _this.props.oggetto.id);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), _this.onValidate = function () {
      var clienti = _this.props.clienti.find(function (cliente) {
        return cliente.id === _this.props.oggetto.proprietarioId || cliente.id === _this.props.oggetto.proprietarioId2 || cliente.id === _this.props.oggetto.verwalter;
      });
      var deals = _this.props.deals.find(function (deal) {
        return deal.oggettoId === _this.props.oggetto.id;
      });
      var evaluation = _this.props.evaluations.find(function (evaluation) {
        return evaluation.oggettoId === _this.props.oggetto.id;
      });
      var newsletters = _this.props.newsletters.find(function (newsletter) {
        return newsletter.oggetto1 === _this.props.oggetto.id || newsletter.oggetto2 === _this.props.oggetto.id || newsletter.oggetto3 === _this.props.oggetto.id || newsletter.oggetto4 === _this.props.oggetto.id || newsletter.oggetto5 === _this.props.oggetto.id || newsletter.oggetto6 === _this.props.oggetto.id;
      });
      var offers = _this.props.offers.find(function (offer) {
        return offer.oggettoId === _this.props.oggetto.id;
      });

      if (!clienti && !deals && !evaluation && !newsletters && !offers) {
        return true;
      } else {
        return false;
      }
    }, _this.onRemove = function () {
      if (_this.onValidate()) {
        _this.props.startRemoveOggetto({ id: _this.props.oggetto.id });
        _this.props.history.push('/oggetti');
      } else {
        _this.setState(function () {
          return {
            isOpen: true,
            modalContent: 'cannot_delete_property',
            btnEnabled: false
          };
        });
      }
    }, _this.onDisable = function () {
      if (_this.onValidate()) {
        _this.props.startEditOggetto(_this.props.oggetto.id, _extends({}, _this.props.oggetto, {
          visible: false
        }));
        _this.props.history.push('/oggetti');
      } else {
        _this.setState(function () {
          return {
            isOpen: true,
            modalContent: 'cannot_delete_property',
            btnEnabled: false
          };
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EditOggettoPage, [{
    key: 'render',
    value: function render() {
      if (!this.props.oggetto || this.props.utente.role === 'Mitarbeiter' && !this.props.oggetto.visible) {
        this.props.history.push('/oggetti');
        return _react2.default.createElement(
          'div',
          null,
          'Loading...'
        );
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'h1',
              null,
              this.props.t('Modifica oggetto')
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(_OptionModal2.default, {
            isOpen: this.state.isOpen,
            contentLabel: 'remove',
            modalContent: this.props.t(this.state.modalContent),
            onCancel: this.handleCloseModal,
            onConfirm: this.props.utente && this.props.utente.role === 'Admin' ? this.onRemove : this.onDisable,
            btnEnabled: this.state.btnEnabled
          }),
          _react2.default.createElement(_OggettoForm2.default, { oggetto: this.props.oggetto, onSubmit: this.onSubmit }),
          _react2.default.createElement(
            'button',
            {
              className: 'btn-floating red margine-basso',
              onClick: this.handleOpenModal
            },
            _react2.default.createElement(
              'i',
              { className: 'material-icons' },
              'delete'
            )
          )
        )
      );
    }
  }]);

  return EditOggettoPage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    oggetto: state.oggetti.find(function (oggetto) {
      return oggetto.id === props.match.params.id;
    }),
    utente: state.utenti.find(function (utente) {
      return utente.firebaseAuthId === state.auth.uid;
    }),
    deals: state.deals,
    fatture: state.fatture,
    clienti: state.clienti,
    evaluations: state.evaluations,
    newsletters: state.newsletters,
    offers: state.offers
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    startEditOggetto: function startEditOggetto(id, oggetto) {
      return dispatch(_configureStore.storeActions.find(function (action) {
        return action.label === 'oggetti';
      }).startEditAction(id, oggetto));
    },
    startRemoveOggetto: function startRemoveOggetto(data) {
      return dispatch(_configureStore.storeActions.find(function (action) {
        return action.label === 'oggetti';
      }).startRemoveAction(data));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactI18next.withTranslation)()(EditOggettoPage));

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewOggettoMatchPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _LeadsList = __webpack_require__(159);

var _LeadsList2 = _interopRequireDefault(_LeadsList);

var _OggettiList = __webpack_require__(73);

var _OggettiList2 = _interopRequireDefault(_OggettiList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ViewOggettoMatchPage = exports.ViewOggettoMatchPage = function (_React$Component) {
  _inherits(ViewOggettoMatchPage, _React$Component);

  function ViewOggettoMatchPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ViewOggettoMatchPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ViewOggettoMatchPage.__proto__ || Object.getPrototypeOf(ViewOggettoMatchPage)).call.apply(_ref, [this].concat(args))), _this), _this.leadMatch = function () {
      var leadsMatch = _this.props.leads.filter(function (lead) {
        return lead.leadBudget <= _this.props.oggetto.kaufpreis * 1.2 && lead.leadBudget > _this.props.oggetto.kaufpreis / 1.2 && lead.leadCity === _this.props.oggetto.citta;
      });
      if (_this.props.oggetto.stato === 'vacant') {
        return leadsMatch.filter(function (lead) {
          return lead.leadOggettoStato === 'libero' || lead.leadOggettoStato === '' || lead.leadOggettoStato === 'libero o affittato';
        });
      } else if (_this.props.oggetto.stato === 'rented') {
        return leadsMatch.filter(function (lead) {
          return lead.leadOggettoStato === 'affittato' || lead.leadOggettoStato === '' || lead.leadOggettoStato === 'libero o affittato';
        });
      } else {
        return leadsMatch;
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ViewOggettoMatchPage, [{
    key: 'render',
    value: function render() {
      var offersLeadIds = this.props.offers.map(function (offer) {
        return offer.leadId;
      });

      var leadsAlreadyOffered = this.leadMatch().filter(function (lead) {
        return offersLeadIds.includes(lead.id);
      });
      var leadsToBeOffered = this.leadMatch().filter(function (lead) {
        return !offersLeadIds.includes(lead.id);
      });
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'h1',
            null,
            this.props.t('Match con le richieste'),
            ': ',
            this.leadMatch().length
          ),
          _react2.default.createElement(
            'span',
            null,
            this.props.t('La corrispondenza si basa sul budget (+-20%) e la tipologia di immobile')
          )
        ),
        _react2.default.createElement(_OggettiList2.default, {
          oggetto: [this.props.oggetto],
          ruolo: this.props.t('Oggetto')
        }),
        _react2.default.createElement(_LeadsList2.default, {
          userLeads: leadsToBeOffered,
          oggettoId: this.props.oggetto.id,
          ruolo: '' + this.props.t('Richieste')
        }),
        _react2.default.createElement(_LeadsList2.default, {
          userLeads: leadsAlreadyOffered,
          feedbackButton: 'disabled',
          ruolo: '' + this.props.t('offer_sent')
        }),
        ';'
      );
    }
  }]);

  return ViewOggettoMatchPage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    oggetto: state.oggetti.find(function (oggetto) {
      return oggetto.id === props.match.params.id;
    }),
    leads: state.leads,
    offers: state.offers.filter(function (offer) {
      return offer.oggettoId === props.match.params.id;
    })
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()(ViewOggettoMatchPage));

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _LeadsList = __webpack_require__(159);

var _LeadsList2 = _interopRequireDefault(_LeadsList);

var _LeadsListFilters = __webpack_require__(1131);

var _LeadsListFilters2 = _interopRequireDefault(_LeadsListFilters);

var _configureStore = __webpack_require__(14);

var _elements = __webpack_require__(18);

var _Intestazione = __webpack_require__(20);

var _Intestazione2 = _interopRequireDefault(_Intestazione);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeadsDashboardPage = function (_React$Component) {
  _inherits(LeadsDashboardPage, _React$Component);

  function LeadsDashboardPage() {
    _classCallCheck(this, LeadsDashboardPage);

    return _possibleConstructorReturn(this, (LeadsDashboardPage.__proto__ || Object.getPrototypeOf(LeadsDashboardPage)).apply(this, arguments));
  }

  _createClass(LeadsDashboardPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.startSetLeads();
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Intestazione2.default, { intestazione: t('Richieste attive') }),
        _react2.default.createElement(_LeadsListFilters2.default, null),
        (0, _elements.addButton)('/leadscreate'),
        _react2.default.createElement(_LeadsList2.default, null)
      );
    }
  }]);

  return LeadsDashboardPage;
}(_react2.default.Component);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    startSetLeads: function startSetLeads() {
      return dispatch(_configureStore.storeActions.find(function (action) {
        return action.label === 'leads';
      }).startSetAction());
    }
  };
};

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)((0, _reactI18next.withTranslation)()(LeadsDashboardPage));

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LeadsListFilters = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _filters = __webpack_require__(572);

var _materializeCss = __webpack_require__(61);

var _materializeCss2 = _interopRequireDefault(_materializeCss);

var _numeral = __webpack_require__(147);

var _numeral2 = _interopRequireDefault(_numeral);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeadsListFilters = exports.LeadsListFilters = function (_React$Component) {
  _inherits(LeadsListFilters, _React$Component);

  function LeadsListFilters() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LeadsListFilters);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LeadsListFilters.__proto__ || Object.getPrototypeOf(LeadsListFilters)).call.apply(_ref, [this].concat(args))), _this), _this.onLeadChange = function (e) {
      //il valore convertito in euro lo riconverto in semplici numeri prima di passarli al filtro. Se cancello il valore, mi restituisce una stringa vuota per evitare errori
      var value = (0, _numeral2.default)(e.target.value).value() || '';
      _this.props.setLeadsFilter(value);
    }, _this.onLeadsStatoChange = function (e) {
      _this.props.setLeadsStatoFilter(e.target.value);
    }, _this.onSortChange = function (e) {
      if (e.target.value === 'date') {
        _this.props.sortByDate();
      } else if (e.target.value === 'amount') {
        _this.props.sortByAmount();
      } else {
        _this.props.sortByPaid();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LeadsListFilters, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      _materializeCss2.default.AutoInit();
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;

      return _react2.default.createElement(
        'div',
        { className: 'container' },
        _react2.default.createElement(
          'div',
          { className: 'input-group' },
          _react2.default.createElement(
            'div',
            { className: 'input-field' },
            _react2.default.createElement('input', {
              id: 'budget',
              type: 'text',
              className: 'input-field',
              value: this.props.filters.lead && (0, _numeral2.default)(this.props.filters.lead).format('0,0[.]00'),
              onChange: this.onLeadChange
            }),
            _react2.default.createElement(
              'label',
              { className: 'active', htmlFor: 'budget' },
              'Budget'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'input-field' },
            _react2.default.createElement(
              'select',
              {
                value: this.props.filters.leadStato,
                onChange: this.onLeadsStatoChange
              },
              _react2.default.createElement(
                'option',
                { value: '' },
                t('Tutti')
              ),
              _react2.default.createElement(
                'option',
                { value: 'libero' },
                t('Appartamento libero')
              ),
              _react2.default.createElement(
                'option',
                { value: 'affittato' },
                t('Appartamento affittato')
              ),
              _react2.default.createElement(
                'option',
                { value: 'libero o affittato' },
                t('Appartamento libero o affittato')
              ),
              _react2.default.createElement(
                'option',
                { value: 'commerciale' },
                t('Locale commerciale')
              ),
              _react2.default.createElement(
                'option',
                { value: 'aph' },
                t('Casa di cura')
              )
            ),
            _react2.default.createElement(
              'label',
              null,
              t('Tipologia di immobile')
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'input-field' },
            _react2.default.createElement(
              'select',
              {
                value: this.props.filters.sortBy,
                onChange: this.onSortChange
              },
              _react2.default.createElement(
                'option',
                { value: 'date' },
                ' ',
                t('Data')
              ),
              _react2.default.createElement(
                'option',
                { value: 'amount' },
                'Budget'
              )
            ),
            _react2.default.createElement(
              'label',
              null,
              t('Ordina per')
            )
          )
        )
      );
    }
  }]);

  return LeadsListFilters;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    filters: state.filters
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setLeadsFilter: function setLeadsFilter(lead) {
      return dispatch((0, _filters.setLeadsFilter)(lead));
    },
    setLeadsStatoFilter: function setLeadsStatoFilter(leadStato) {
      return dispatch((0, _filters.setLeadsStatoFilter)(leadStato));
    },
    sortByDate: function sortByDate() {
      return dispatch((0, _filters.sortByDate)());
    },
    sortByAmount: function sortByAmount() {
      return dispatch((0, _filters.sortByAmount)());
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactI18next.withTranslation)()(LeadsListFilters));

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditLeadPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _LeadForm = __webpack_require__(612);

var _LeadForm2 = _interopRequireDefault(_LeadForm);

var _configureStore = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditLeadPage = exports.EditLeadPage = function (_React$Component) {
  _inherits(EditLeadPage, _React$Component);

  function EditLeadPage() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, EditLeadPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditLeadPage.__proto__ || Object.getPrototypeOf(EditLeadPage)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(lead) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.props.startEditLead(_this.props.lead.id, lead);

              case 2:
                _this.props.history.push('/leadview/' + _this.props.lead.id);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EditLeadPage, [{
    key: 'render',
    value: function render() {
      if (!this.props.lead) {
        this.props.history.push('/leads');
        return _react2.default.createElement(
          'div',
          null,
          'Loading...'
        );
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'h1',
              null,
              this.props.t('Modifica richiesta')
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(_LeadForm2.default, { lead: this.props.lead, onSubmit: this.onSubmit })
        )
      );
    }
  }]);

  return EditLeadPage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    lead: state.leads.find(function (lead) {
      return lead.id === props.match.params.id;
    }),
    offers: state.offers.filter(function (offer) {
      return offer.leadId === props.match.params.id;
    })
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    startEditLead: function startEditLead(id, lead) {
      return dispatch(_configureStore.storeActions.find(function (action) {
        return action.label === 'leads';
      }).startEditAction(id, lead));
    },
    startRemoveLead: function startRemoveLead(data) {
      return dispatch(_configureStore.storeActions.find(function (action) {
        return action.label === 'leads';
      }).startRemoveAction(data));
    },
    startRemoveOffer: function startRemoveOffer(data) {
      return dispatch(_configureStore.storeActions.find(function (action) {
        return action.label === 'offers';
      }).startRemoveAction(data));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactI18next.withTranslation)()(EditLeadPage));

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewLeadMatchPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _LeadsList = __webpack_require__(159);

var _LeadsList2 = _interopRequireDefault(_LeadsList);

var _OggettiList = __webpack_require__(73);

var _OggettiList2 = _interopRequireDefault(_OggettiList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ViewLeadMatchPage = exports.ViewLeadMatchPage = function (_React$Component) {
  _inherits(ViewLeadMatchPage, _React$Component);

  function ViewLeadMatchPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ViewLeadMatchPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ViewLeadMatchPage.__proto__ || Object.getPrototypeOf(ViewLeadMatchPage)).call.apply(_ref, [this].concat(args))), _this), _this.leadMatch = function () {
      var lead = _this.props.lead;
      // controllo se l'oggetto è ancora invenduto e se corrisponde la città

      var primoMatch = _this.props.oggetti.filter(function (ogg) {
        return !ogg.venduto && ogg.citta === lead.leadCity;
      });
      console.log('primo match', primoMatch);
      // controllo se la richiesta contiene indicazione sullo stato dell'immobile
      var secondoMatch = [];
      if (lead.leadOggettoStato === 'libero') {
        secondoMatch = primoMatch.filter(function (ogg) {
          return ogg.stato === 'vacant';
        });
      } else if (lead.leadOggettoStato === 'affittato') {
        secondoMatch = primoMatch.filter(function (ogg) {
          return ogg.stato === 'rented';
        });
      } else {
        secondoMatch = [].concat(_toConsumableArray(primoMatch));
      }
      console.log('secondo match', secondoMatch);

      // filtro gli oggetti che hanno un prezzo di vendita del 20% sopra o sotto il budget
      var terzoMatch = [];
      if (lead.leadBudget > 500) {
        terzoMatch = secondoMatch.filter(function (ogg) {
          return ogg.kaufpreis <= lead.leadBudget * 1.2 && ogg.kaufpreis >= lead.leadBudget / 1.2;
        });
      } else {
        terzoMatch = [].concat(_toConsumableArray(secondoMatch));
      }
      console.log('terzo match', terzoMatch);

      //estrapolo gli id degli oggetti già proposti (filtrato già nello state in basso)
      var oggettiIds = _this.props.offers.map(function (offer) {
        return offer.oggettoId;
      });
      console.log('id oggetti già proposti', oggettiIds);

      //restituisco solo gli oggetti che non sono ancora stati proposti
      return terzoMatch.filter(function (ogg) {
        return !oggettiIds.includes(ogg.id);
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ViewLeadMatchPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'h1',
              null,
              this.props.t('Match con i nostri oggetti'),
              ':',
              ' ',
              this.leadMatch().length
            ),
            _react2.default.createElement(
              'span',
              null,
              this.props.t('La corrispondenza si basa sul budget (+-20%) e la tipologia di immobile'),
              '.'
            )
          )
        ),
        _react2.default.createElement(_LeadsList2.default, {
          userLeads: [this.props.lead],
          ruolo: this.props.t('Richiesta')
        }),
        this.leadMatch().length > 0 && _react2.default.createElement(_OggettiList2.default, {
          oggetto: this.leadMatch(),
          ruolo: 'Objekte von ' + this.props.firma[0].name
        })
      );
    }
  }]);

  return ViewLeadMatchPage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    lead: state.leads.find(function (lead) {
      return lead.id === props.match.params.id;
    }),
    clienti: state.clienti,
    oggetti: state.oggetti,
    offers: state.offers.filter(function (offer) {
      return offer.leadId === props.match.params.id;
    }),
    firma: state.firma
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()(ViewLeadMatchPage));

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewLeadPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _reactRouterDom = __webpack_require__(23);

var _OffersList = __webpack_require__(1135);

var _OffersList2 = _interopRequireDefault(_OffersList);

var _configureStore = __webpack_require__(14);

var _OptionModal = __webpack_require__(58);

var _OptionModal2 = _interopRequireDefault(_OptionModal);

var _Intestazione = __webpack_require__(20);

var _Intestazione2 = _interopRequireDefault(_Intestazione);

var _utils = __webpack_require__(9);

var _elements = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ViewLeadPage = exports.ViewLeadPage = function (_React$Component) {
  _inherits(ViewLeadPage, _React$Component);

  function ViewLeadPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ViewLeadPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ViewLeadPage.__proto__ || Object.getPrototypeOf(ViewLeadPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isOpen: false,
      modalContent: 'remove_confirm',
      btnEnabled: true
    }, _this.handleOpenModal = function () {
      _this.setState(function () {
        return {
          isOpen: true
        };
      });
    }, _this.handleCloseModal = function () {
      _this.setState({ isOpen: false });
    }, _this.onRemove = function () {
      var offerteDaCancellare = _this.props.offers.filter(function (offer) {
        return offer.leadId === _this.props.lead.id;
      });
      //cancello tutte le offerte legate a questa richiesta e poi cancello la richiesta
      offerteDaCancellare.forEach(function (offer) {
        _this.props.startRemoveOffer({ id: offer.id });
      });
      _this.props.startRemoveLead({ id: _this.props.lead.id });
      _this.props.history.push('/leads');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ViewLeadPage, [{
    key: 'render',
    value: function render() {
      if (!this.props.lead) {
        this.props.history.push('/leads');
        return _react2.default.createElement(
          'div',
          null,
          'Loading...'
        );
      }
      var _props = this.props,
          lead = _props.lead,
          t = _props.t;

      var cliente = this.props.clienti.find(function (cliente) {
        return cliente.id === lead.leadId;
      });
      var consulenteVendita = this.props.utenti.find(function (utente) {
        return utente.id === cliente.consulenteVenditaId;
      });
      var offers = this.props.offers.filter(function (offer) {
        return offer.leadId === lead.id;
      });

      var immobile = '';
      if (lead.leadOggettoStato === 'commerciale') {
        immobile = 'Locale ' + lead.leadOggettoStato;
      } else if (lead.leadOggettoStato === 'aph') {
        immobile = 'Casa di cura';
      } else if (lead.leadOggettoStato === 'libero' || lead.leadOggettoStato === 'affittato' || lead.leadOggettoStato === 'libero o affittato') {
        immobile = 'Appartamento ' + lead.leadOggettoStato;
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Intestazione2.default, { intestazione: t('Richiesta') }),
        _react2.default.createElement(
          'div',
          { className: 'container section' },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'button',
              {
                className: 'btn-floating red right btn-floating-margin',
                onClick: this.handleOpenModal
              },
              _react2.default.createElement(
                'i',
                { className: 'material-icons' },
                'delete'
              )
            ),
            _react2.default.createElement(_OptionModal2.default, {
              isOpen: this.state.isOpen,
              contentLabel: 'remove',
              modalContent: this.props.t(this.state.modalContent),
              onCancel: this.handleCloseModal,
              onConfirm: this.onRemove,
              btnEnabled: this.state.btnEnabled
            }),
            (0, _elements.editButton)('/leadedit/' + lead.id),
            lead.leadOggettoStato === 'libero' || lead.leadOggettoStato === 'affittato' || lead.leadOggettoStato === 'libero o affittato' || lead.leadOggettoStato === '' ? _react2.default.createElement(
              _reactRouterDom.Link,
              {
                className: 'btn-floating green accent-3 right btn-floating-margin',
                to: '/leadmatchview/' + lead.id
              },
              _react2.default.createElement(
                'i',
                { className: 'material-icons' },
                'search'
              ),
              ' '
            ) : '',
            cliente.email && _react2.default.createElement(
              'a',
              {
                className: 'btn-floating blue right btn-floating-margin',
                href: 'mailto:' + cliente.email
              },
              _react2.default.createElement(
                'i',
                { className: 'material-icons' },
                'email'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            cliente && _react2.default.createElement(
              'h5',
              null,
              _react2.default.createElement(
                _reactRouterDom.Link,
                { to: '/clientiview/' + cliente.id },
                t(cliente.titolo),
                ' ',
                cliente.nome,
                ' ',
                cliente.cognome
              )
            ),
            lead.leadCity && _react2.default.createElement(
              'h6',
              null,
              t('city'),
              ': ',
              lead.leadCity
            ),
            _react2.default.createElement(
              'h6',
              null,
              'Budget: ',
              (0, _utils.formattaPrezzo)(lead.leadBudget, true)
            ),
            _react2.default.createElement(
              'p',
              null,
              consulenteVendita && '(' + consulenteVendita.name + ')'
            ),
            _react2.default.createElement(
              'p',
              null,
              lead.leadCreatedAt ? (0, _utils.formattaData)(lead.leadCreatedAt) : null
            ),
            _react2.default.createElement(
              'p',
              null,
              cliente && cliente.email
            ),
            _react2.default.createElement(
              'p',
              null,
              cliente && cliente.telefono1
            ),
            _react2.default.createElement(
              'p',
              null,
              lead.leadOggettoStato ? immobile : null
            ),
            _react2.default.createElement(
              'p',
              null,
              lead.leadNote && 'Note: ' + lead.leadNote
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            _reactRouterDom.Link,
            {
              className: 'btn-floating green right',
              to: {
                pathname: '/createoffer',
                state: { leadId: lead.id }
              }
            },
            _react2.default.createElement(
              'i',
              { className: 'material-icons' },
              'add'
            )
          )
        ),
        _react2.default.createElement(_OffersList2.default, { offers: offers, ruolo: t('offer_sent_customer') })
      );
    }
  }]);

  return ViewLeadPage;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    lead: state.leads.find(function (lead) {
      return lead.id === props.match.params.id;
    }),
    clienti: state.clienti,
    offers: state.offers,
    utenti: state.utenti
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    startRemoveLead: function startRemoveLead(data) {
      return dispatch(_configureStore.storeActions.find(function (action) {
        return action.label === 'leads';
      }).startRemoveAction(data));
    },
    startRemoveOffer: function startRemoveOffer(data) {
      return dispatch(_configureStore.storeActions.find(function (action) {
        return action.label === 'offers';
      }).startRemoveAction(data));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactI18next.withTranslation)()(ViewLeadPage));

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OffersList = undefined;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _Card = __webpack_require__(56);

var _Card2 = _interopRequireDefault(_Card);

var _utils = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OffersList = exports.OffersList = function OffersList(props) {
  //controllo se la i dati vengono dalla scheda clienti e sono passati via props
  var offersPayload = props.offers;
  offersPayload.sort(function (a, b) {
    return a.offerCreatedAt < b.offerCreatedAt ? 1 : -1;
  });
  return _react2.default.createElement(
    'div',
    { className: 'container' },
    _react2.default.createElement(
      'div',
      { className: 'list-body' },
      offersPayload.length === 0 && _react2.default.createElement(
        'h5',
        null,
        props.t('offer_add')
      ),
      offersPayload.length > 0 && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h5',
          null,
          props.ruolo || ''
        ),
        offersPayload.map(function (offer) {
          var oggetto = props.oggetti.find(function (oggetto) {
            return oggetto.id === offer.oggettoId;
          });
          var consulente = props.utenti.find(function (utente) {
            return utente.id === offer.consulenteId;
          });
          var creatoIl = offer.offerCreatedAt ? (0, _utils.formattaData)(offer.offerCreatedAt) : '';
          var feedback = function feedback() {
            switch (offer.feedback) {
              case 'positivo':
                return _react2.default.createElement(
                  'i',
                  { className: 'material-icons medium green-text' },
                  'sentiment_satisfied_alt'
                );
              case 'negativo':
                return _react2.default.createElement(
                  'i',
                  { className: 'material-icons medium red-text' },
                  'sentiment_very_dissatisfied'
                );
              case 'neutro':
                return _react2.default.createElement(
                  'i',
                  { className: 'material-icons medium amber-text' },
                  'sentiment_dissatisfied'
                );
              case 'sconosciuto':
                return _react2.default.createElement(
                  'i',
                  { className: 'material-icons medium' },
                  'help_outline'
                );
              case 'not_relevant':
                return _react2.default.createElement(
                  'i',
                  { className: 'material-icons medium brown-text' },
                  'highlight_off'
                );
              default:
                return _react2.default.createElement(
                  'i',
                  { className: 'material-icons medium' },
                  'more_horiz'
                );
            }
          };
          var mezzo = offer.offertoTramite ? '(' + offer.offertoTramite + ')' : '';

          return _react2.default.createElement(_Card2.default, {
            key: offer.id,
            visible: true,
            link: {
              pathname: '/editoffer/' + offer.id,
              state: { leadId: offer.leadId }
            },
            titolo: 'Rif. Id: ' + oggetto.rifId + ' - ' + oggetto.via + ' ' + oggetto.numeroCivico + ', WE ' + oggetto.numeroAppartamento,
            sottotitolo: offer.consulenteId && 'Proposto da ' + consulente.name,
            corpo: [mezzo, creatoIl],
            lineaNote: '' + (offer.offerNote && 'Note: ' + offer.offerNote),
            titoloDestra: feedback()
          });
        })
      )
    )
  );
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    oggetti: state.oggetti,
    utenti: state.utenti
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()(OffersList));

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditOfferedProperties = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _OfferedPropertiesForm = __webpack_require__(613);

var _OfferedPropertiesForm2 = _interopRequireDefault(_OfferedPropertiesForm);

var _configureStore = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditOfferedProperties = exports.EditOfferedProperties = function (_React$Component) {
  _inherits(EditOfferedProperties, _React$Component);

  function EditOfferedProperties() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, EditOfferedProperties);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditOfferedProperties.__proto__ || Object.getPrototypeOf(EditOfferedProperties)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(offer) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.props.startEditOffer(_this.props.offer.id, offer);

              case 2:
                _this.props.history.push('/leadview/' + _this.props.offer.leadId);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), _this.onRemove = function () {
      _this.props.startRemoveOffer({ id: _this.props.offer.id });
      _this.props.history.push('/leadview/' + _this.props.offer.leadId);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EditOfferedProperties, [{
    key: 'render',
    value: function render() {
      if (!this.props.offer) {
        this.props.history.push('/leads');
        return _react2.default.createElement(
          'div',
          null,
          'Loading...'
        );
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'h1',
              null,
              this.props.t('Modifica offerta')
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(_OfferedPropertiesForm2.default, {
            offer: this.props.offer,
            onSubmit: this.onSubmit
          }),
          _react2.default.createElement(
            'button',
            { className: 'btn-floating red', onClick: this.onRemove },
            _react2.default.createElement(
              'i',
              { className: 'material-icons' },
              'delete'
            )
          )
        )
      );
    }
  }]);

  return EditOfferedProperties;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    offer: state.offers.find(function (offer) {
      return offer.id === props.match.params.id;
    })
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    startEditOffer: function startEditOffer(id, offer) {
      return dispatch(_configureStore.storeActions.find(function (action) {
        return action.label === 'offers';
      }).startEditAction(id, offer));
    },
    startRemoveOffer: function startRemoveOffer(data) {
      return dispatch(_configureStore.storeActions.find(function (action) {
        return action.label === 'offers';
      }).startRemoveAction(data));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactI18next.withTranslation)()(EditOfferedProperties));

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(23);

var _reactI18next = __webpack_require__(4);

var _Intestazione = __webpack_require__(20);

var _Intestazione2 = _interopRequireDefault(_Intestazione);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModuliPage = function ModuliPage(_ref) {
  var t = _ref.t;
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_Intestazione2.default, { intestazione: t('Moduli') }),
    _react2.default.createElement(
      'div',
      { className: 'container' },
      _react2.default.createElement(
        'ul',
        { className: 'collection with-header' },
        _react2.default.createElement(
          'li',
          { className: 'collection-header' },
          _react2.default.createElement(
            'h4',
            null,
            t('Da compilare online')
          )
        ),
        _react2.default.createElement(
          'li',
          { className: 'collection-item' },
          _react2.default.createElement(
            _reactRouterDom.Link,
            { to: '/provisionsbestaetigung' },
            t('Conferma provvigione')
          )
        ),
        _react2.default.createElement(
          'li',
          { className: 'collection-item' },
          _react2.default.createElement(
            _reactRouterDom.Link,
            { to: '/vollmachtnotarauftrag' },
            t('Delega richiesta bozza di contratto')
          )
        ),
        _react2.default.createElement(
          'li',
          { className: 'collection-item' },
          _react2.default.createElement(
            _reactRouterDom.Link,
            { to: '/makleralleinauftrag' },
            t('Mandato alla vendita')
          )
        ),
        _react2.default.createElement(
          'li',
          { className: 'collection-item' },
          _react2.default.createElement(
            _reactRouterDom.Link,
            { to: '/widerrufsbelehrung' },
            t('Informativa sul diritto di recesso')
          )
        ),
        _react2.default.createElement(
          'li',
          { className: 'collection-item' },
          _react2.default.createElement(
            _reactRouterDom.Link,
            { to: '/vollmachtunterlagen' },
            t('Delega per richiesta documenti')
          )
        ),
        _react2.default.createElement(
          'li',
          { className: 'collection-item' },
          _react2.default.createElement(
            _reactRouterDom.Link,
            { to: '/notardatenblatt' },
            t('Foglio informativo per il notaio')
          )
        ),
        _react2.default.createElement(
          'li',
          { className: 'collection-item' },
          _react2.default.createElement(
            _reactRouterDom.Link,
            { to: '/dsgvo' },
            t('Informativa privacy')
          )
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'container section' },
      _react2.default.createElement(
        'ul',
        { className: 'collection with-header' },
        _react2.default.createElement(
          'li',
          { className: 'collection-header' },
          _react2.default.createElement(
            'h4',
            null,
            t('Moduli in bianco')
          )
        ),
        _react2.default.createElement(
          'li',
          { className: 'collection-item' },
          _react2.default.createElement(
            'a',
            {
              href: 'https://gestionale.m2square.eu/files/Provisionsbestaetigung.pdf',
              download: true
            },
            t('Conferma provvigione')
          )
        ),
        _react2.default.createElement(
          'li',
          { className: 'collection-item' },
          _react2.default.createElement(
            'a',
            {
              href: 'https://gestionale.m2square.eu/files/Carta intestata.docx',
              download: true
            },
            t('Carta intestata')
          )
        ),
        _react2.default.createElement(
          'li',
          { className: 'collection-item' },
          _react2.default.createElement(
            'a',
            {
              href: 'https://gestionale.m2square.eu/files/datenblatt.pdf',
              download: true
            },
            t('Foglio informativo per il notaio'),
            ' Pietzcker'
          )
        ),
        _react2.default.createElement(
          'li',
          { className: 'collection-item' },
          _react2.default.createElement(
            'a',
            {
              href: 'https://gestionale.m2square.eu/files/Allgemeine%20Vertragsbedingungen.pdf',
              download: true
            },
            t('Condizioni generali di contratto')
          )
        ),
        _react2.default.createElement(
          'li',
          { className: 'collection-item' },
          _react2.default.createElement(
            'a',
            {
              href: 'https://gestionale.m2square.eu/files/Widerrufsbelehrung.pdf',
              download: true
            },
            t('Informativa sul diritto di recesso'),
            ' m2Square'
          )
        ),
        _react2.default.createElement(
          'li',
          { className: 'collection-item' },
          _react2.default.createElement(
            'a',
            {
              href: 'https://gestionale.m2square.eu/files/Verbraucherwiderrufsbelehrung.pdf',
              download: true
            },
            t('Informativa sul diritto di recesso'),
            ' IVD'
          )
        ),
        _react2.default.createElement(
          'li',
          { className: 'collection-item' },
          _react2.default.createElement(
            'a',
            {
              href: 'https://gestionale.m2square.eu/files/Vollmacht%20zur%20Vorbereitung%20einer%20notariellen%20Kaufvertragsurkunde.pdf',
              download: true
            },
            t('Delega richiesta bozza di contratto')
          )
        ),
        _react2.default.createElement(
          'li',
          { className: 'collection-item' },
          _react2.default.createElement(
            'a',
            {
              href: 'https://gestionale.m2square.eu/files/Lettera%20Grundbuchamt.docx',
              download: true
            },
            t('Lettera per ufficio Libro Fondiario (Grundbuchamt)')
          )
        ),
        _react2.default.createElement(
          'li',
          { className: 'collection-item' },
          _react2.default.createElement(
            'a',
            {
              href: 'https://gestionale.m2square.eu/files/Makleralleinauftrag.pdf',
              download: true
            },
            t('Mandato alla vendita')
          )
        ),
        _react2.default.createElement(
          'li',
          { className: 'collection-item' },
          _react2.default.createElement(
            'a',
            {
              href: 'https://gestionale.m2square.eu/files/Pflichtangaben-nach-Art-13-EU-DSGVO-11020.pdf',
              download: true
            },
            t('Informativa privacy')
          )
        ),
        _react2.default.createElement(
          'li',
          { className: 'collection-item' },
          _react2.default.createElement(
            'a',
            {
              href: 'https://gestionale.m2square.eu/files/Dokumentationsbogen.docx',
              download: true
            },
            t('Modulo riciclo di denaro'),
            ' - ',
            t('Persone fisiche')
          )
        ),
        _react2.default.createElement(
          'li',
          { className: 'collection-item' },
          _react2.default.createElement(
            'a',
            {
              href: 'https://gestionale.m2square.eu/files/DokumentationsbogenJP.docx',
              download: true
            },
            t('Modulo riciclo di denaro'),
            ' - ',
            t('Persone giuridiche')
          )
        ),
        _react2.default.createElement(
          'li',
          { className: 'collection-item' },
          _react2.default.createElement(
            'a',
            {
              href: 'https://gestionale.m2square.eu/files/meldebestaetigung.pdf',
              download: true
            },
            t('Conferma affitto per inquilini'),
            ' (B\xFCrgeramt)'
          )
        ),
        _react2.default.createElement(
          'li',
          { className: 'collection-item' },
          _react2.default.createElement(
            'a',
            {
              href: 'https://gestionale.m2square.eu/files/Mietschuldenfreiheitsbescheinigung.docx',
              download: true
            },
            t('Dichiarazione di buon pagatore per inquilini')
          )
        ),
        _react2.default.createElement(
          'li',
          { className: 'collection-item' },
          _react2.default.createElement(
            'a',
            {
              href: 'https://gestionale.m2square.eu/files/Uebergabeprotokoll.doc',
              download: true
            },
            t('Protocollo consegna appartamento'),
            ' - ',
            t('Vendita')
          )
        ),
        _react2.default.createElement(
          'li',
          { className: 'collection-item' },
          _react2.default.createElement(
            'a',
            {
              href: 'https://gestionale.m2square.eu/files/Wohnungsuebergabeprotokoll%20Mietwohnung.pdf',
              download: true
            },
            t('Protocollo consegna appartamento'),
            ' - ',
            t('Affitto')
          )
        ),
        _react2.default.createElement(
          'li',
          { className: 'collection-item' },
          _react2.default.createElement(
            'a',
            {
              href: 'https://gestionale.m2square.eu/files/wohnungs_mietvertrag_1520411845.pdf',
              download: true
            },
            t('Modello'),
            ' ',
            t('Contratto di affitto')
          )
        ),
        _react2.default.createElement(
          'li',
          { className: 'collection-item' },
          _react2.default.createElement(
            'a',
            {
              href: 'https://gestionale.m2square.eu/files/Aufnahme-ETW-Teileigentum.pdf',
              download: true
            },
            t('Modulo per acquisizione')
          )
        )
      )
    )
  );
};

exports.default = (0, _reactI18next.withTranslation)()(ModuliPage);

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotFoundPage = function NotFoundPage() {
  return _react2.default.createElement(
    'div',
    null,
    '404 - ',
    _react2.default.createElement(
      _reactRouterDom.Link,
      { to: '/' },
      'Homepage'
    )
  );
};

exports.default = NotFoundPage;

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoginPage = undefined;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _auth = __webpack_require__(224);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginPage = exports.LoginPage = function LoginPage(_ref) {
  var startLogin = _ref.startLogin,
      t = _ref.t;
  return _react2.default.createElement(
    'div',
    { className: 'box-layout' },
    _react2.default.createElement(
      'div',
      { className: 'box-layout__box' },
      _react2.default.createElement('img', { src: '/images/logo.png' }),
      _react2.default.createElement(
        'h2',
        { className: 'box-layout__title' },
        t('Gestionale')
      ),
      _react2.default.createElement(
        'p',
        null,
        t('Inserisci email e password')
      ),
      _react2.default.createElement('input', { id: 'email', type: 'email', name: 'email', placeholder: 'email' }),
      _react2.default.createElement('input', {
        id: 'password',
        type: 'password',
        name: 'password',
        placeholder: 'password'
      }),
      _react2.default.createElement(
        'button',
        { className: 'btn blue', onClick: startLogin },
        'Login'
      )
    )
  );
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    startLogin: function startLogin() {
      return dispatch((0, _auth.startLogin)());
    }
  };
};

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)((0, _reactI18next.withTranslation)()(LoginPage));

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrivateRoute = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactRouterDom = __webpack_require__(23);

var _Header = __webpack_require__(1141);

var _Header2 = _interopRequireDefault(_Header);

var _NavBar = __webpack_require__(1142);

var _NavBar2 = _interopRequireDefault(_NavBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var PrivateRoute = function PrivateRoute(_ref) {
  var isAuthenticated = _ref.isAuthenticated,
      activeClass = _ref.activeClass,
      Component = _ref.component,
      rest = _objectWithoutProperties(_ref, ['isAuthenticated', 'activeClass', 'component']);

  return _react2.default.createElement(_reactRouterDom.Route, _extends({}, rest, {
    component: function component(props) {
      return isAuthenticated ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Header2.default, null),
        _react2.default.createElement(_NavBar2.default, { activeClass: activeClass }),
        _react2.default.createElement(Component, _extends({}, props, { item: activeClass }))
      ) : _react2.default.createElement(_reactRouterDom.Redirect, { to: '/' });
    }
  }));
};

exports.PrivateRoute = PrivateRoute;
var mapStateToProps = function mapStateToProps(state) {
  return {
    isAuthenticated: !!state.auth.uid
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(PrivateRoute);

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = undefined;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(23);

var _reactRedux = __webpack_require__(5);

var _auth = __webpack_require__(224);

var _reactI18next = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = exports.Header = function Header(_ref) {
  var startLogout = _ref.startLogout,
      i18n = _ref.i18n,
      history = _ref.history;

  var setLingua = function setLingua(lang) {
    i18n.changeLanguage(lang);
  };
  return _react2.default.createElement(
    'header',
    { className: 'header' },
    _react2.default.createElement(
      'div',
      { className: 'container' },
      _react2.default.createElement(
        'div',
        { className: 'row' },
        _react2.default.createElement(
          'div',
          { className: 'col m4 hide-on-small-only' },
          _react2.default.createElement(
            'button',
            {
              className: 'btn-floating blue',
              onClick: function onClick() {
                return history.goBack();
              }
            },
            _react2.default.createElement(
              'i',
              { className: 'material-icons' },
              'navigate_before'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col s12 m4 center-align' },
          _react2.default.createElement(
            _reactRouterDom.Link,
            { className: 'header__title', to: '/deals' },
            _react2.default.createElement('img', { src: '/images/logo.png' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col m4 hide-on-small-only right-align' },
          _react2.default.createElement(
            'button',
            {
              className: 'btn-flat',
              onClick: function onClick() {
                setLingua('it');
              }
            },
            'IT'
          ),
          _react2.default.createElement(
            'button',
            {
              className: 'btn-flat',
              onClick: function onClick() {
                setLingua('de');
              }
            },
            'DE'
          ),
          _react2.default.createElement(
            'button',
            { className: 'btn-flat', onClick: startLogout },
            _react2.default.createElement(
              'i',
              { className: 'material-icons' },
              'exit_to_app'
            )
          )
        )
      )
    )
  );
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    startLogout: function startLogout() {
      return dispatch((0, _auth.startLogout)());
    }
  };
};

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)((0, _reactI18next.withTranslation)()((0, _reactRouterDom.withRouter)(Header)));

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavBar = undefined;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactRouterDom = __webpack_require__(23);

var _reactI18next = __webpack_require__(4);

var _Sidebar = __webpack_require__(1143);

var _Sidebar2 = _interopRequireDefault(_Sidebar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

////////////Disable newsletter for web////////////

var NavBar = exports.NavBar = function NavBar(_ref) {
  var utente = _ref.utente,
      t = _ref.t,
      activeClass = _ref.activeClass;

  if (utente) {
    var menuItems = [{ pathLink: 'deals', label: t('Vendite') }, { pathLink: 'leads', label: t('Richieste') }, { pathLink: 'moduli', label: t('Moduli') }, { pathLink: 'oggetti', label: t('Oggetti') }, { pathLink: 'clienti', label: t('Contatti') },
    // { pathLink: 'newsletters', label: t('Newsletters') },
    { pathLink: 'evaluations', label: t('evaluations') }, { pathLink: 'links', label: 'Links' }];
    if (utente && utente.role === 'Admin') {
      menuItems = [].concat(_toConsumableArray(menuItems), [{ pathLink: 'utenti', label: t('Utenti') }, { pathLink: 'fatture', label: t('Fatture') }]);
    }

    if (utente && utente.role === 'Geschäftsführer') {
      menuItems = [].concat(_toConsumableArray(menuItems), [{ pathLink: 'fatture', label: t('Fatture') }]);
    }
    return _react2.default.createElement(
      'nav',
      { className: 'new-wrapper blue' },
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'span',
          { className: 'brand-logo btn-floating-margin' },
          t('nav_title')
        ),
        _react2.default.createElement(_Sidebar2.default, null),
        _react2.default.createElement(
          'ul',
          { className: 'right hide-on-med-and-down' },
          menuItems.map(function (item) {
            return _react2.default.createElement(
              'li',
              {
                key: item.pathLink,
                className: activeClass === item.pathLink ? 'active' : ''
              },
              _react2.default.createElement(
                _reactRouterDom.Link,
                { to: '/' + item.pathLink },
                item.label
              )
            );
          })
        )
      )
    );
  } else {
    // setTimeout(location.reload(), 1000);
    return _react2.default.createElement(
      'div',
      null,
      'Loading...'
    );
  }
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    utente: state.utenti.find(function (utente) {
      return utente.firebaseAuthId === state.auth.uid;
    })
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()(NavBar));

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sidebar = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _materializeCss = __webpack_require__(61);

var _materializeCss2 = _interopRequireDefault(_materializeCss);

__webpack_require__(1144);

var _reactRouterDom = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

////////////Disable for web////////////

var Sidebar = exports.Sidebar = function (_Component) {
  _inherits(Sidebar, _Component);

  function Sidebar() {
    _classCallCheck(this, Sidebar);

    return _possibleConstructorReturn(this, (Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).apply(this, arguments));
  }

  _createClass(Sidebar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var options = {
        inDuration: 250,
        outDuration: 200,
        draggable: true
      };

      _materializeCss2.default.Sidenav.init(this.Sidenav);

      var instance = _materializeCss2.default.Sidenav.getInstance(this.Sidenav);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'ul',
          {
            ref: function ref(Sidenav) {
              _this2.Sidenav = Sidenav;
            },
            id: 'slide-out',
            className: 'sidenav'
          },
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              _reactRouterDom.Link,
              { className: 'sidenav-close', to: '/deals' },
              t('Vendite')
            )
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              _reactRouterDom.Link,
              { className: 'sidenav-close', to: '/leads' },
              t('Richieste')
            )
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              _reactRouterDom.Link,
              { className: 'sidenav-close', to: '/moduli' },
              t('Moduli')
            )
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              _reactRouterDom.Link,
              { className: 'sidenav-close', to: '/oggetti' },
              t('Oggetti')
            )
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              _reactRouterDom.Link,
              { className: 'sidenav-close', to: '/clienti' },
              t('Contatti')
            )
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              _reactRouterDom.Link,
              { className: 'sidenav-close', to: '/evaluations' },
              t('evaluations')
            )
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              _reactRouterDom.Link,
              { className: 'sidenav-close', to: '/links' },
              'Links'
            )
          ),
          this.props.utente.role === 'Admin' && _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              _reactRouterDom.Link,
              { className: 'sidenav-close', to: '/utenti' },
              t('Utenti')
            )
          ),
          (this.props.utente.role === 'Admin' || this.props.utente.role === 'Geschäftsführer') && _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              _reactRouterDom.Link,
              { className: 'sidenav-close', to: '/fatture' },
              t('Fatture')
            )
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'a',
              { className: 'sidenav-close', href: '#!' },
              _react2.default.createElement(
                'i',
                { className: 'material-icons' },
                'clear'
              )
            )
          )
        ),
        _react2.default.createElement(
          'a',
          { href: '#!', 'data-target': 'slide-out', className: 'sidenav-trigger' },
          _react2.default.createElement(
            'i',
            { className: 'material-icons' },
            'menu'
          )
        )
      );
    }
  }]);

  return Sidebar;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    utente: state.utenti.find(function (utente) {
      return utente.firebaseAuthId === state.auth.uid;
    })
  };
};
exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()(Sidebar));

/***/ }),
/* 1144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PublicRoute = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactRouterDom = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var PublicRoute = function PublicRoute(_ref) {
  var isAuthenticated = _ref.isAuthenticated,
      Component = _ref.component,
      rest = _objectWithoutProperties(_ref, ['isAuthenticated', 'component']);

  return _react2.default.createElement(_reactRouterDom.Route, _extends({}, rest, {
    component: function component(props) {
      return isAuthenticated ? _react2.default.createElement(_reactRouterDom.Redirect, { to: '/deals' }) : _react2.default.createElement(Component, props);
    }
  }));
};

exports.PublicRoute = PublicRoute;
var mapStateToProps = function mapStateToProps(state) {
  return {
    isAuthenticated: !!state.auth.uid
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(PublicRoute);

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAAForm = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _withForm = __webpack_require__(21);

var _withForm2 = _interopRequireDefault(_withForm);

__webpack_require__(29);

__webpack_require__(30);

__webpack_require__(31);

var _NewMaklerAlleinauftrag = __webpack_require__(1147);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import { maklerAlleinauftrag } from './MaklerAlleinauftrag';


var MAAForm = exports.MAAForm = function (_React$Component) {
  _inherits(MAAForm, _React$Component);

  function MAAForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MAAForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MAAForm.__proto__ || Object.getPrototypeOf(MAAForm)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (e) {
      e.preventDefault();
      var venditore = _this.props.clienti.find(function (cliente) {
        return cliente.id === _this.props.data.moduli.venditoreId;
      });
      var venditore2 = _this.props.clienti.find(function (cliente) {
        return cliente.id === _this.props.data.moduli.venditoreId2;
      });
      var oggetto = _this.props.oggetti.find(function (oggetto) {
        return oggetto.id === _this.props.data.moduli.oggettoId;
      });
      var startDate = _this.props.data.moduli.startDate;
      var endDate = _this.props.data.moduli.endDate;
      var prezzoDiVendita = _this.props.data.moduli.prezzoDiVendita;
      var prezzoDiVendita2 = _this.props.data.moduli.prezzoDiVendita2;
      var maklerProvision = _this.props.data.moduli.maklerProvision;
      var sonstige = _this.props.data.moduli.sonstige;

      if (!_this.props.data.moduli.oggettoId || !_this.props.data.moduli.venditoreId) {
        _this.props.renderError(_this.props.t('Inserisci venditore e oggetto'));
      } else {
        _this.props.renderError('');

        (0, _NewMaklerAlleinauftrag.maklerAlleinauftrag)(venditore, venditore2, oggetto, startDate, endDate, prezzoDiVendita, prezzoDiVendita2, maklerProvision, sonstige, _this.props.firma);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MAAForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          renderSelect = _props.renderSelect,
          renderInput = _props.renderInput,
          renderDateRange = _props.renderDateRange,
          renderTextArea = _props.renderTextArea,
          changeHandlerValuta = _props.changeHandlerValuta;

      var options = this.props.clienti.map(function (cliente) {
        return {
          value: cliente.id,
          label: cliente.nome + ' ' + cliente.cognome + ' ' + (cliente.ditta && '- Firma ' + cliente.ditta)
        };
      });

      var oggettiOptions = this.props.oggetti.map(function (oggetto) {
        return {
          value: oggetto.id,
          label: oggetto.via + ' ' + oggetto.numeroCivico + ', WE ' + oggetto.numeroAppartamento + ', ' + oggetto.cap + ' ' + oggetto.citta
        };
      });

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'h1',
              null,
              t('Mandato alla vendita')
            )
          )
        ),
        _react2.default.createElement(
          'form',
          { className: 'form container', onSubmit: this.onSubmit },
          this.props.data.error && _react2.default.createElement(
            'p',
            { className: 'form__error' },
            this.props.data.error
          ),
          renderSelect('moduli', 'venditoreId', options, t('Venditore'), '*'),
          renderSelect('moduli', 'venditoreId2', options, '2. ' + t('Venditore')),
          renderSelect('moduli', 'oggettoId', oggettiOptions, t('Oggetto'), '*'),
          renderDateRange('moduli', 'calendarFocusedMAA', t('Periodo di esclusiva')),
          renderInput('moduli', 'prezzoDiVendita', t('Prezzo di vendita') + ' min.', undefined, changeHandlerValuta),
          renderInput('moduli', 'prezzoDiVendita2', t('Prezzo di vendita') + ' max.', undefined, changeHandlerValuta),
          renderInput('moduli', 'maklerProvision', t('Provvigione'), undefined, changeHandlerValuta, undefined, t('senza') + ' % ' + t('es.') + ' 7,14'),
          renderTextArea('moduli', 'sonstige', t('Altri accordi')),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'button',
              { className: 'btn-floating right' },
              _react2.default.createElement(
                'i',
                { className: 'material-icons' },
                'picture_as_pdf'
              )
            )
          )
        )
      );
    }
  }]);

  return MAAForm;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    clienti: state.clienti,
    oggetti: state.oggetti,
    firma: state.firma[0]
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()((0, _withForm2.default)(MAAForm)));

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.maklerAlleinauftrag = undefined;

var _jspdf = __webpack_require__(32);

var _jspdf2 = _interopRequireDefault(_jspdf);

var _ImageLogo = __webpack_require__(39);

var _IvdLogo = __webpack_require__(222);

var _maklerAlleinAuftragBG = __webpack_require__(1148);

var _utils = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var maklerAlleinauftrag = exports.maklerAlleinauftrag = function maklerAlleinauftrag(venditore, venditore2, oggetto, startDate, endDate, prezzoDiVendita, prezzoDiVendita2, maklerProvision, sonstige, firma) {
  var doc = new _jspdf2.default();
  var vendDitta = (0, _utils.ditta)(venditore);
  var vendNome = (0, _utils.nomeCompleto)(venditore);
  var vendInd = (0, _utils.indirizzoCompleto)(venditore);
  var vendInd2 = (0, _utils.indirizzoCompleto)(venditore2);
  var vendNome2 = (0, _utils.nomeCompleto)(venditore2);
  doc.addImage(_maklerAlleinAuftragBG.imgData, 'JPEG', 0, 0, 210, 297);
  doc.addImage(_ImageLogo.imgLogo, 'JPEG', 20, 10, 35, 8);
  //nascondo il logo ivd con un quadrato bianco
  doc.addImage(_IvdLogo.ivdLogo, 'JPEG', 175, 5, 30, 12, undefined, 'SLOW');

  doc.setFontSize(12);

  if (!venditore2) {
    if (vendDitta.length > 0) {
      doc.text(vendDitta, 56, 22);
      doc.text(vendNome, 56, 27);
      doc.text(vendInd, 56, 32);
    } else {
      doc.text(vendNome, 56, 22);
      doc.text(vendInd, 56, 27);
    }
  } else {
    if (vendDitta.length > 0) {
      doc.text(vendDitta, 56, 22);
      doc.text('1. ' + vendNome + ', ' + vendInd, 56, 27);
      doc.text('2. ' + vendNome2 + ', ' + vendInd2, 56, 32);
    } else {
      doc.text('1. ' + vendNome + ', ' + vendInd, 56, 22);
      doc.text('2. ' + vendNome2 + ', ' + vendInd2, 56, 27);
    }
  }

  doc.text((0, _utils.contattiFirma)(firma), 56, 46);

  doc.text((0, _utils.indirizzoOggetto)(oggetto), 56, 72);

  prezzoDiVendita && doc.text((0, _utils.formattaPrezzo)(prezzoDiVendita, true, true), 56, 82);
  prezzoDiVendita2 && doc.text('- ' + (0, _utils.formattaPrezzo)(prezzoDiVendita2, true, true), 80, 82);

  doc.setFontSize(10);
  startDate && doc.text((0, _utils.formattaData)(startDate), 83, 104);
  endDate && doc.text((0, _utils.formattaData)(endDate), 129, 104);

  doc.text('X', 55, 181);
  maklerProvision && doc.text(maklerProvision, 65, 190);

  // seconda pagina
  doc.addPage();
  doc.addImage(_maklerAlleinAuftragBG.imgData2, 'JPEG', 0, 0, 210, 297);
  doc.addImage(_ImageLogo.imgLogo, 'JPEG', 20, 10, 35, 8);
  doc.setFontSize(12);

  var lines = doc.splitTextToSize(sonstige, 170);
  doc.text(23, 60 + 12 / 110, lines);

  // sonstige && doc.text(sonstige, 25, 60);
  doc.text('X', 23, 232);
  doc.text('X', 68, 232);

  //Salvataggio finale
  doc.save(venditore.cognome + ' Makler Alleinauftrag.pdf');
};

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var imgData=exports.imgData='data:image/jpeg;base64,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';var imgData2=exports.imgData2='data:image/jpeg;base64,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';

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VWBForm = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _withForm = __webpack_require__(21);

var _withForm2 = _interopRequireDefault(_withForm);

__webpack_require__(29);

__webpack_require__(30);

__webpack_require__(31);

var _WiderrufsBelehrung = __webpack_require__(602);

var _utils = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VWBForm = exports.VWBForm = function (_React$Component) {
  _inherits(VWBForm, _React$Component);

  function VWBForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, VWBForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = VWBForm.__proto__ || Object.getPrototypeOf(VWBForm)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (e) {
      e.preventDefault();
      var venditore = _this.props.clienti.find(function (cliente) {
        return cliente.id === _this.props.data.moduli.venditoreId;
      });
      var venditore2 = _this.props.clienti.find(function (cliente) {
        return cliente.id === _this.props.data.moduli.venditoreId2;
      });
      var oggetto = _this.props.oggetti.find(function (oggetto) {
        return oggetto.id === _this.props.data.moduli.oggettoId;
      });
      var createdAt = (0, _utils.formattaData)(_this.props.data.moduli.createdAt);

      if (!_this.props.data.moduli.oggettoId || !_this.props.data.moduli.venditoreId) {
        _this.props.renderError(_this.props.t('Inserisci venditore e oggetto'));
      } else {
        _this.props.renderError('');
        (0, _WiderrufsBelehrung.widerrufsBelehrung)(venditore, venditore2, createdAt, oggetto, _this.props.firma);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(VWBForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          renderSelect = _props.renderSelect,
          renderSingleDate = _props.renderSingleDate;

      var options = this.props.clienti.map(function (cliente) {
        return {
          value: cliente.id,
          label: cliente.nome + ' ' + cliente.cognome + ' ' + (cliente.ditta && '- Firma ' + cliente.ditta)
        };
      });

      var oggettiOptions = this.props.oggetti.map(function (oggetto) {
        return {
          value: oggetto.id,
          label: oggetto.via + ' ' + oggetto.numeroCivico + ', WE ' + oggetto.numeroAppartamento + ', ' + oggetto.cap + ' ' + oggetto.citta
        };
      });

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'h1',
              null,
              t('Informativa sul diritto di recesso')
            )
          )
        ),
        _react2.default.createElement(
          'form',
          { className: 'form container', onSubmit: this.onSubmit },
          this.props.data.error && _react2.default.createElement(
            'p',
            { className: 'form__error' },
            this.props.data.error
          ),
          renderSelect('moduli', 'venditoreId', options, t('Cliente'), '*'),
          renderSelect('moduli', 'venditoreId2', options, '2. ' + t('Cliente')),
          renderSelect('moduli', 'oggettoId', oggettiOptions, t('Oggetto'), '*'),
          renderSingleDate('moduli', 'createdAt', 'calendarFocused', t('Data del contratto')),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'button',
              { className: 'btn-floating right' },
              _react2.default.createElement(
                'i',
                { className: 'material-icons' },
                'picture_as_pdf'
              )
            )
          )
        )
      );
    }
  }]);

  return VWBForm;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    clienti: state.clienti,
    oggetti: state.oggetti,
    firma: state.firma[0]
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()((0, _withForm2.default)(VWBForm)));

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VollmachtForm = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _withForm = __webpack_require__(21);

var _withForm2 = _interopRequireDefault(_withForm);

__webpack_require__(29);

__webpack_require__(30);

__webpack_require__(31);

var _DelegaDocumenti = __webpack_require__(1151);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VollmachtForm = exports.VollmachtForm = function (_React$Component) {
  _inherits(VollmachtForm, _React$Component);

  function VollmachtForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, VollmachtForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = VollmachtForm.__proto__ || Object.getPrototypeOf(VollmachtForm)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (e) {
      e.preventDefault();
      var cliente = _this.props.clienti.find(function (cliente) {
        return cliente.id === _this.props.data.moduli.venditoreId;
      });
      var cliente2 = _this.props.clienti.find(function (cliente) {
        return cliente.id === _this.props.data.moduli.venditoreId2;
      });
      var oggetto = _this.props.oggetti.find(function (oggetto) {
        return oggetto.id === _this.props.data.moduli.oggettoId;
      });

      if (!_this.props.data.moduli.oggettoId || !_this.props.data.moduli.venditoreId) {
        _this.props.renderError(_this.props.t('Inserisci acquirente e oggetto'));
      } else {
        _this.props.renderError('');
        (0, _DelegaDocumenti.delegaDocumenti)(cliente, cliente2, oggetto, _this.props.firma);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(VollmachtForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          renderSelect = _props.renderSelect;

      var options = this.props.clienti.map(function (cliente) {
        return {
          value: cliente.id,
          label: cliente.nome + ' ' + cliente.cognome + ' ' + (cliente.ditta && '- Firma ' + cliente.ditta)
        };
      });

      var oggettiOptions = this.props.oggetti.map(function (oggetto) {
        return {
          value: oggetto.id,
          label: oggetto.via + ' ' + oggetto.numeroCivico + ', WE ' + oggetto.numeroAppartamento + ', ' + oggetto.cap + ' ' + oggetto.citta
        };
      });

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'h1',
              null,
              t('Delega per richiesta documenti')
            )
          )
        ),
        _react2.default.createElement(
          'form',
          { className: 'form container', onSubmit: this.onSubmit },
          this.props.data.error && _react2.default.createElement(
            'p',
            { className: 'form__error' },
            this.props.data.error
          ),
          renderSelect('moduli', 'venditoreId', options, t('Cliente'), '*'),
          renderSelect('moduli', 'venditoreId2', options, '2. ' + t('Cliente')),
          renderSelect('moduli', 'oggettoId', oggettiOptions, t('Oggetto'), '*'),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'button',
              { className: 'btn-floating right' },
              _react2.default.createElement(
                'i',
                { className: 'material-icons' },
                'picture_as_pdf'
              )
            )
          )
        )
      );
    }
  }]);

  return VollmachtForm;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    clienti: state.clienti,
    oggetti: state.oggetti,
    firma: state.firma[0]
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()((0, _withForm2.default)(VollmachtForm)));

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.delegaDocumenti = undefined;

var _jspdf = __webpack_require__(32);

var _jspdf2 = _interopRequireDefault(_jspdf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var delegaDocumenti = exports.delegaDocumenti = function delegaDocumenti(cliente, cliente2, oggetto, firma) {
  var doc = new _jspdf2.default('p', 'mm', 'a4');

  var nome = cliente.nome + ' ' + cliente.cognome;
  var residenza = cliente.cap + ' ' + cliente.comune + ', ' + cliente.indirizzo + ', ' + cliente.nazione;
  var nome2 = cliente2 && cliente2.nome + ' ' + cliente2.cognome;
  var residenza2 = cliente2 && cliente2.cap + ' ' + cliente2.comune + ', ' + cliente2.indirizzo + ', ' + cliente2.nazione;

  var indirizzo = oggetto.cap + ' ' + oggetto.citta + ', ' + oggetto.via + ' ' + oggetto.numeroCivico + ', WE ' + oggetto.numeroAppartamento;
  var m2Square = firma.name + ' ' + (firma.name2 && ' - ' + firma.name2);

  var corpoFattura = void 0;
  if (cliente2) {
    corpoFattura = 'hiermit bevollm\xE4chtigen wir ' + nome + ' wohnhaft in ' + residenza + ' und ' + nome2 + ' wonhaft in ' + residenza2 + '\n\ndie Firma ' + m2Square + ', gesch\xE4ftsans\xE4ssig in ' + firma.plz + ' ' + firma.stadt + ', ' + firma.adresse + ',\n\nf\xFCr uns alle Unterlagen zu unser Immobilieneinheit in ' + indirizzo + ' \nvon der Hausverwaltung anzufordern und zu empfangen.\n\nDie Firma ' + m2Square + ' ist auch berechtigt, allgemeine Informationen \xFCber das Haus und die Eigent\xFCmergemeinschaft nachzufragen, insbesondere Informationen \xFCber Instandhaltungsr\xFCcklage und eventuelle Sonderumlagen.\n\nDie Kosten der Bereitstellung und Versand der Unterlagen werden wir tragen. G\xFCltig ist die Vollmacht bis auf Widerruf.\n';
  } else {
    corpoFattura = 'hiermit bevollm\xE4chtige ich ' + nome + ' wohnhaft in ' + residenza + '\n\ndie Firma ' + m2Square + ', gesch\xE4ftsans\xE4ssig in ' + firma.plz + ' ' + firma.stadt + ', ' + firma.adresse + ',\n\nf\xFCr mich alle Unterlagen zu meiner Immobilieneinheit in ' + indirizzo + ' \nvon der Hausverwaltung anzufordern und zu empfangen.\n\nDie Firma ' + m2Square + ' ist auch berechtigt, allgemeine Informationen \xFCber das Haus und die Eigent\xFCmergemeinschaft nachzufragen, insbesondere Informationen \xFCber Instandhaltungsr\xFCcklage und eventuelle Sonderumlagen.\n\nDie Kosten der Bereitstellung und Versand der Unterlagen werde ich tragen. G\xFCltig ist die Vollmacht bis auf Widerruf.\n';
  }

  doc.setFontSize(12);
  doc.setFontType('bold');
  doc.text('Vollmacht zum Empfang von Unterlagen', 25, 25);

  doc.setFontType('normal');
  doc.text('Sehr geehrte Damen und Herren,', 25, 35);

  var lines = doc.splitTextToSize(corpoFattura, 150);
  doc.text(25, 45 + 12 / 110, lines);

  doc.text('_________________________', 25, 150);
  doc.text('Ort und Datum', 36, 155);
  doc.text('_________________________', 120, 150);
  doc.text(nome, nome.length / 2 + 125, 155);
  cliente2 && doc.text('_________________________', 120, 170);
  cliente2 && doc.text(nome2, nome2.length / 2 + 125, 175);

  doc.save('Vollmacht ' + cliente.cognome + '.pdf');
};

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProvisionForm = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _withForm = __webpack_require__(21);

var _withForm2 = _interopRequireDefault(_withForm);

__webpack_require__(29);

__webpack_require__(30);

__webpack_require__(31);

var _Provisionsbestaetigung = __webpack_require__(601);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProvisionForm = exports.ProvisionForm = function (_React$Component) {
  _inherits(ProvisionForm, _React$Component);

  function ProvisionForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProvisionForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProvisionForm.__proto__ || Object.getPrototypeOf(ProvisionForm)).call.apply(_ref, [this].concat(args))), _this), _this.findContact = function (contactId) {
      return _this.props.clienti.filter(function (cliente) {
        return cliente.id === contactId;
      });
    }, _this.onSubmit = function (e) {
      e.preventDefault();
      var acquirente = _this.findContact(_this.props.data.moduli.acquirenteId);
      var acquirente2 = _this.findContact(_this.props.data.moduli.acquirenteId2);
      var venditore = _this.findContact(_this.props.data.moduli.venditoreId);
      var venditore2 = _this.findContact(_this.props.data.moduli.venditoreId2);
      var oggetto = _this.props.oggetti.find(function (oggetto) {
        return oggetto.id === _this.props.data.moduli.oggettoId;
      });

      var prezzoDiVendita = parseFloat(_this.props.data.moduli.prezzoDiVendita.replace(/,/, '.'), 10) * 100;
      var provvPercentuale = _this.props.data.moduli.provvPercentuale;

      if (!_this.props.data.moduli.oggettoId) {
        _this.props.renderError(_this.props.t('Inserisci oggetto'));
      } else {
        _this.props.renderError('');
        (0, _Provisionsbestaetigung.creaPrenotazione)(acquirente[0], acquirente2[0], venditore[0], venditore2[0], oggetto, provvPercentuale, prezzoDiVendita, _this.props.firma);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProvisionForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          renderSelect = _props.renderSelect,
          renderInput = _props.renderInput,
          changeHandlerValuta = _props.changeHandlerValuta;

      var options = this.props.clienti.map(function (cliente) {
        return {
          value: cliente.id,
          label: cliente.nome + ' ' + cliente.cognome + ' ' + (cliente.ditta && '- Firma ' + cliente.ditta)
        };
      });

      var oggettiOptions = this.props.oggetti.map(function (oggetto) {
        return {
          value: oggetto.id,
          label: oggetto.via + ' ' + oggetto.numeroCivico + ', WE ' + oggetto.numeroAppartamento + ', ' + oggetto.cap + ' ' + oggetto.citta
        };
      });

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'h1',
              null,
              t('Conferma provvigione')
            )
          )
        ),
        _react2.default.createElement(
          'form',
          { className: 'form container', onSubmit: this.onSubmit },
          this.props.data.error && _react2.default.createElement(
            'p',
            { className: 'form__error' },
            this.props.data.error
          ),
          renderSelect('moduli', 'acquirenteId', options, t('Acquirente')),
          renderSelect('moduli', 'acquirenteId2', options, '2. ' + t('Acquirente')),
          renderSelect('moduli', 'venditoreId', options, t('Venditore')),
          renderSelect('moduli', 'venditoreId2', options, '2. ' + t('Venditore')),
          renderSelect('moduli', 'oggettoId', oggettiOptions, t('Oggetto')),
          renderInput('moduli', 'prezzoDiVendita', t('Prezzo di vendita'), undefined, changeHandlerValuta),
          renderInput('moduli', 'provvPercentuale', t('Provvigione'), undefined, changeHandlerValuta, undefined, t('senza') + ' % ' + t('es.') + ' 7,14'),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'button',
              { className: 'btn-floating right' },
              _react2.default.createElement(
                'i',
                { className: 'material-icons' },
                'picture_as_pdf'
              )
            )
          )
        )
      );
    }
  }]);

  return ProvisionForm;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    clienti: state.clienti,
    oggetti: state.oggetti,
    firma: state.firma[0]
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()((0, _withForm2.default)(ProvisionForm)));

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotarauftragForm = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _withForm = __webpack_require__(21);

var _withForm2 = _interopRequireDefault(_withForm);

__webpack_require__(29);

__webpack_require__(30);

__webpack_require__(31);

var _VollmachtNotarauftrag = __webpack_require__(603);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NotarauftragForm = exports.NotarauftragForm = function (_React$Component) {
  _inherits(NotarauftragForm, _React$Component);

  function NotarauftragForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NotarauftragForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NotarauftragForm.__proto__ || Object.getPrototypeOf(NotarauftragForm)).call.apply(_ref, [this].concat(args))), _this), _this.findContact = function (contactId) {
      return _this.props.clienti.filter(function (cliente) {
        return cliente.id === contactId;
      });
    }, _this.onSubmit = function (e) {
      e.preventDefault();
      var acquirente = _this.findContact(_this.props.data.moduli.acquirenteId);
      var acquirente2 = _this.findContact(_this.props.data.moduli.acquirenteId2);
      var venditore = _this.findContact(_this.props.data.moduli.venditoreId);
      var venditore2 = _this.findContact(_this.props.data.moduli.venditoreId2);
      var notaio = _this.findContact(_this.props.data.moduli.notaioId);
      var oggetto = _this.props.oggetti.find(function (oggetto) {
        return oggetto.id === _this.props.data.moduli.oggettoId;
      });
      var prezzoDiVendita = parseFloat(_this.props.data.moduli.prezzoDiVendita.replace(/,/, '.'), 10) * 100;

      if (!_this.props.data.moduli.oggettoId) {
        _this.props.renderError(_this.props.t('Inserisci oggetto'));
      } else {
        _this.props.renderError('');
        (0, _VollmachtNotarauftrag.vollmachtNotarauftrag)(acquirente[0], acquirente2[0], venditore[0], venditore2[0], oggetto, notaio[0], prezzoDiVendita, _this.props.firma);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NotarauftragForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          renderSelect = _props.renderSelect,
          renderInput = _props.renderInput,
          changeHandlerValuta = _props.changeHandlerValuta;

      var options = this.props.clienti.map(function (cliente) {
        return {
          value: cliente.id,
          label: cliente.nome + ' ' + cliente.cognome + ' ' + (cliente.ditta && '- Firma ' + cliente.ditta)
        };
      });

      var oggettiOptions = this.props.oggetti.map(function (oggetto) {
        return {
          value: oggetto.id,
          label: oggetto.via + ' ' + oggetto.numeroCivico + ', WE ' + oggetto.numeroAppartamento + ', ' + oggetto.cap + ' ' + oggetto.citta
        };
      });

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'h1',
              null,
              t('Delega richiesta bozza di contratto')
            )
          )
        ),
        _react2.default.createElement(
          'form',
          { className: 'form container', onSubmit: this.onSubmit },
          this.props.data.error && _react2.default.createElement(
            'p',
            { className: 'form__error' },
            this.props.data.error
          ),
          renderSelect('moduli', 'acquirenteId', options, t('Acquirente')),
          renderSelect('moduli', 'acquirenteId2', options, '2. ' + t('Acquirente')),
          renderSelect('moduli', 'venditoreId', options, t('Venditore')),
          renderSelect('moduli', 'venditoreId2', options, '2. ' + t('Venditore')),
          renderSelect('moduli', 'notaioId', options, t('Notaio')),
          renderSelect('moduli', 'oggettoId', oggettiOptions, t('Oggetto'), '*'),
          renderInput('moduli', 'prezzoDiVendita', t('Prezzo di vendita'), 'text', changeHandlerValuta),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'button',
              { className: 'btn-floating right' },
              _react2.default.createElement(
                'i',
                { className: 'material-icons' },
                'picture_as_pdf'
              )
            )
          )
        )
      );
    }
  }]);

  return NotarauftragForm;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    clienti: state.clienti,
    oggetti: state.oggetti,
    firma: state.firma[0]
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()((0, _withForm2.default)(NotarauftragForm)));

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _withForm = __webpack_require__(21);

var _withForm2 = _interopRequireDefault(_withForm);

__webpack_require__(29);

__webpack_require__(30);

__webpack_require__(31);

var _reactI18next = __webpack_require__(4);

var _NotarDatenblatt = __webpack_require__(604);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NotarDatenblattForm = function (_Component) {
  _inherits(NotarDatenblattForm, _Component);

  function NotarDatenblattForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NotarDatenblattForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NotarDatenblattForm.__proto__ || Object.getPrototypeOf(NotarDatenblattForm)).call.apply(_ref, [this].concat(args))), _this), _this.findContact = function (contactId) {
      return _this.props.clienti.filter(function (cliente) {
        return cliente.id === contactId;
      });
    }, _this.onSubmit = function (e) {
      e.preventDefault();
      var acquirente = _this.findContact(_this.props.data.moduli.acquirenteId);
      var acquirente2 = _this.findContact(_this.props.data.moduli.acquirenteId2);
      var venditore = _this.findContact(_this.props.data.moduli.venditoreId);
      var venditore2 = _this.findContact(_this.props.data.moduli.venditoreId2);
      var notaio = _this.findContact(_this.props.data.moduli.notaioId);

      var oggetto = _this.props.oggetti.find(function (oggetto) {
        return oggetto.id === _this.props.data.moduli.oggettoId;
      });
      var prezzoDiVendita = parseFloat(_this.props.data.moduli.prezzoDiVendita.replace(/,/, '.'), 10) * 100;
      var verwalter = oggetto && _this.findContact(oggetto.verwalter);

      if (!_this.props.data.moduli.oggettoId) {
        _this.props.renderError(_this.props.t('Inserisci oggetto'));
      } else {
        _this.props.renderError('');
        (0, _NotarDatenblatt.notarDatenblatt)(acquirente[0], acquirente2[0], venditore[0], venditore2[0], oggetto, notaio[0], verwalter[0], _this.props.data.moduli.belastungsVollmacht, _this.props.utente, _this.props.firma, _this.props.ceo, prezzoDiVendita, _this.props.data.moduli.linguaRogito);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NotarDatenblattForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          renderSelect = _props.renderSelect,
          renderCheckbox = _props.renderCheckbox,
          renderInput = _props.renderInput,
          changeHandlerValuta = _props.changeHandlerValuta;

      var options = this.props.clienti.map(function (cliente) {
        return {
          value: cliente.id,
          label: cliente.nome + ' ' + cliente.cognome + ' ' + (cliente.ditta && '- Firma ' + cliente.ditta)
        };
      });

      var oggettiOptions = this.props.oggetti.map(function (oggetto) {
        return {
          value: oggetto.id,
          label: oggetto.via + ' ' + oggetto.numeroCivico + ', WE ' + oggetto.numeroAppartamento + ', ' + oggetto.cap + ' ' + oggetto.citta
        };
      });

      var linguaRogitoOptions = ['Englisch', 'Italienisch', 'Spanisch', 'Französisch', 'Englisch-Italienisch', 'Englisch-Französisch', 'Englisch-Spanisch'].map(function (linguaRogito) {
        return {
          value: linguaRogito,
          label: t(linguaRogito)
        };
      });

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'h1',
              null,
              t('Foglio informativo per il notaio')
            )
          )
        ),
        _react2.default.createElement(
          'form',
          { className: 'form container', onSubmit: this.onSubmit },
          this.props.data.error && _react2.default.createElement(
            'p',
            { className: 'form__error' },
            this.props.data.error
          ),
          renderSelect('moduli', 'venditoreId', options, t('Venditore')),
          renderSelect('moduli', 'venditoreId2', options, '2. ' + t('Venditore')),
          renderSelect('moduli', 'acquirenteId', options, t('Acquirente')),
          renderSelect('moduli', 'acquirenteId2', options, '2. ' + t('Acquirente')),
          renderSelect('moduli', 'notaioId', options, t('Notaio')),
          renderSelect('moduli', 'oggettoId', oggettiOptions, t('Oggetto'), '*'),
          renderInput('moduli', 'prezzoDiVendita', t('Prezzo di vendita'), undefined, changeHandlerValuta),
          renderSelect('moduli', 'linguaRogito', linguaRogitoOptions, t('Lingua del rogito')),
          renderCheckbox('moduli', 'belastungsVollmacht', t('Delega per gravami')),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'button',
              { className: 'btn-floating right' },
              _react2.default.createElement(
                'i',
                { className: 'material-icons' },
                'picture_as_pdf'
              )
            )
          )
        )
      );
    }
  }]);

  return NotarDatenblattForm;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    clienti: state.clienti,
    oggetti: state.oggetti,
    utente: state.utenti.find(function (utente) {
      return utente.firebaseAuthId === state.auth.uid;
    }),
    utenti: state.utenti,
    ceo: state.utenti.filter(function (utente) {
      return utente.role === 'Geschäftsführer';
    }),
    firma: state.firma[0]
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()((0, _withForm2.default)(NotarDatenblattForm)));

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(4);

var _Intestazione = __webpack_require__(20);

var _Intestazione2 = _interopRequireDefault(_Intestazione);

var _ListFilters = __webpack_require__(96);

var _ListFilters2 = _interopRequireDefault(_ListFilters);

var _EvaluationList = __webpack_require__(609);

var _EvaluationList2 = _interopRequireDefault(_EvaluationList);

var _elements = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EvaluationDashboard = function EvaluationDashboard(_ref) {
  var t = _ref.t;

  var options = [{ value: 'name', label: t('evaluation_filter_name') }, { value: 'date', label: t('evaluation_filter_date') }];
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_Intestazione2.default, { intestazione: t('evaluation_header') }),
    _react2.default.createElement(_ListFilters2.default, { options: options }),
    (0, _elements.addButton)('/evaluationcreate'),
    _react2.default.createElement(_EvaluationList2.default, null)
  );
};

exports.default = (0, _reactI18next.withTranslation)()(EvaluationDashboard);

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditEvaluation = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _EvaluationForm = __webpack_require__(614);

var _EvaluationForm2 = _interopRequireDefault(_EvaluationForm);

var _configureStore = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditEvaluation = exports.EditEvaluation = function (_React$Component) {
  _inherits(EditEvaluation, _React$Component);

  function EditEvaluation() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, EditEvaluation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditEvaluation.__proto__ || Object.getPrototypeOf(EditEvaluation)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(evaluation) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.props.startEditEvaluation(_this.props.evaluation.id, evaluation);

              case 2:
                _this.props.history.push('/evaluationview/' + _this.props.evaluation.id);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EditEvaluation, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'h1',
              null,
              this.props.t('evaluation_edit')
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(_EvaluationForm2.default, {
            evaluation: this.props.evaluation,
            onSubmit: this.onSubmit
          })
        )
      );
    }
  }]);

  return EditEvaluation;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    evaluation: state.evaluations.find(function (evaluation) {
      return evaluation.id === props.match.params.id;
    })
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    startEditEvaluation: function startEditEvaluation(id, evaluation) {
      return dispatch(_configureStore.storeActions.find(function (action) {
        return action.label === 'evaluations';
      }).startEditAction(id, evaluation));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactI18next.withTranslation)()(EditEvaluation));

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewEvaluation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _Intestazione = __webpack_require__(20);

var _Intestazione2 = _interopRequireDefault(_Intestazione);

var _OptionModal = __webpack_require__(58);

var _OptionModal2 = _interopRequireDefault(_OptionModal);

var _OggettiList = __webpack_require__(73);

var _OggettiList2 = _interopRequireDefault(_OggettiList);

var _Mappa = __webpack_require__(610);

var _Mappa2 = _interopRequireDefault(_Mappa);

var _configureStore = __webpack_require__(14);

var _EvaluationPdf = __webpack_require__(1158);

var _EvaluationPdf2 = _interopRequireDefault(_EvaluationPdf);

var _collectionItem = __webpack_require__(160);

var _collectionItem2 = _interopRequireDefault(_collectionItem);

var _utils = __webpack_require__(9);

var _elements = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ViewEvaluation = exports.ViewEvaluation = function (_React$Component) {
  _inherits(ViewEvaluation, _React$Component);

  function ViewEvaluation() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ViewEvaluation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ViewEvaluation.__proto__ || Object.getPrototypeOf(ViewEvaluation)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isOpen: false,
      modalContent: 'remove_confirm',
      btnEnabled: true
    }, _this.handleOpenModal = function () {
      _this.setState(function () {
        return {
          isOpen: true
        };
      });
    }, _this.handleCloseModal = function () {
      _this.setState({ isOpen: false });
    }, _this.onRemove = function () {
      _this.props.startRemoveEvaluation({ id: _this.props.evaluation.id });
      _this.props.history.push('/evaluations');
    }, _this.onDisable = function () {
      _this.props.startEditEvaluation(_this.props.evaluation.id, _extends({}, _this.props.evaluation, {
        visible: false
      }));
      _this.props.history.push('/evaluations');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ViewEvaluation, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      M.AutoInit();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (!this.props.evaluation || this.props.utente.role === 'Mitarbeiter' && !this.props.evaluation.visible) {
        this.props.history.push('/evaluations');
        return _react2.default.createElement(
          'div',
          null,
          'Loading...'
        );
      }
      var _props$evaluation = this.props.evaluation,
          affittoNetto = _props$evaluation.affittoNetto,
          m2 = _props$evaluation.m2,
          cloudURL = _props$evaluation.cloudURL,
          wohnlage = _props$evaluation.wohnlage,
          bodenRichtwert = _props$evaluation.bodenRichtwert,
          bodenRichtwert2 = _props$evaluation.bodenRichtwert2,
          bodenRichtwert3 = _props$evaluation.bodenRichtwert3,
          dataEvaluation = _props$evaluation.dataEvaluation,
          mietspiegel = _props$evaluation.mietspiegel,
          mietendeckel = _props$evaluation.mietendeckel,
          immobilienpreisMin = _props$evaluation.immobilienpreisMin,
          immobilienpreisMax = _props$evaluation.immobilienpreisMax,
          immobilienpreisAverage = _props$evaluation.immobilienpreisAverage,
          is24Evaluation = _props$evaluation.is24Evaluation,
          note = _props$evaluation.note,
          rendite = _props$evaluation.rendite,
          result = _props$evaluation.result,
          titolo = _props$evaluation.titolo,
          testoIntroduttivoDe = _props$evaluation.testoIntroduttivoDe,
          testoIntroduttivoEn = _props$evaluation.testoIntroduttivoEn,
          testoIntroduttivoIt = _props$evaluation.testoIntroduttivoIt,
          testoFinaleDe = _props$evaluation.testoFinaleDe,
          testoFinaleEn = _props$evaluation.testoFinaleEn,
          testoFinaleIt = _props$evaluation.testoFinaleIt,
          wohnlageSnippet = _props$evaluation.wohnlageSnippet,
          bodenrichtwertSnippet = _props$evaluation.bodenrichtwertSnippet,
          immobilienPreisSnippet = _props$evaluation.immobilienPreisSnippet,
          is24Snippet = _props$evaluation.is24Snippet,
          mietspiegelSnippet = _props$evaluation.mietspiegelSnippet;
      var _props = this.props,
          evaluation = _props.evaluation,
          oggetti = _props.oggetti,
          t = _props.t;

      var oggetto = oggetti.find(function (oggetto) {
        return oggetto.id === evaluation.oggettoId;
      });
      var showEvaluationDownloadButton = false;
      if (wohnlageSnippet && wohnlageSnippet.length > 0 && bodenrichtwertSnippet && bodenrichtwertSnippet.length === 3 && immobilienPreisSnippet && immobilienPreisSnippet.length > 0 && is24Snippet && is24Snippet.length > 0 && mietspiegelSnippet && mietspiegelSnippet.length > 0) {
        showEvaluationDownloadButton = true;
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Intestazione2.default, {
          intestazione: oggetto ? 'Rif.Id: ' + oggetto.rifId + ' - ' + oggetto.via + ' ' + oggetto.numeroCivico + ', WE ' + oggetto.numeroAppartamento + ', ' + oggetto.cap + ' ' + oggetto.citta : titolo
        }),
        ' ',
        _react2.default.createElement(
          'div',
          { className: 'container section' },
          _react2.default.createElement(
            'div',
            null,
            (0, _elements.editButton)('/evaluationedit/' + evaluation.id),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'button',
                {
                  className: 'btn-floating red right btn-floating-margin',
                  onClick: this.handleOpenModal
                },
                _react2.default.createElement(
                  'i',
                  { className: 'material-icons' },
                  'delete'
                )
              )
            ),
            _react2.default.createElement(_OptionModal2.default, {
              isOpen: this.state.isOpen,
              contentLabel: 'remove',
              modalContent: this.props.t(this.state.modalContent),
              onCancel: this.handleCloseModal,
              onConfirm: this.props.utente.role === 'Admin' ? this.onRemove : this.onDisable,
              btnEnabled: this.state.btnEnabled
            }),
            (0, _elements.folderButton)(evaluation, false, 'Valutazioni', oggetto ? oggetto.via.split(' ')[0] : titolo.split(' ')[0])
          ),
          _react2.default.createElement(
            'h5',
            null,
            t('evaluation_result'),
            ': ',
            (0, _utils.formattaPrezzo)(result, true),
            '/m2'
          ),
          _react2.default.createElement(
            'h5',
            null,
            (0, _utils.formattaPrezzo)(result * m2 / 100, true)
          ),
          _react2.default.createElement(
            'h6',
            null,
            t('evaluation_date'),
            ': ',
            (0, _utils.formattaData)(dataEvaluation)
          ),
          _react2.default.createElement(
            'p',
            null,
            t('notes'),
            ': ',
            note
          ),
          _react2.default.createElement(
            'ul',
            { className: 'collapsible' },
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'div',
                { className: 'collapsible-header' },
                _react2.default.createElement(
                  'i',
                  { className: 'material-icons' },
                  'list'
                ),
                t('evaluation_details')
              ),
              _react2.default.createElement(
                'div',
                { className: 'collapsible-body' },
                _react2.default.createElement(
                  'p',
                  null,
                  t('area_classification'),
                  ': ',
                  t(wohnlage)
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  t('land_price'),
                  ' ',
                  t('last_three_years'),
                  ':',
                  ' ',
                  (0, _utils.formattaPrezzo)(bodenRichtwert, true),
                  ' -',
                  ' ',
                  (0, _utils.formattaPrezzo)(bodenRichtwert2, true),
                  ' -',
                  ' ',
                  (0, _utils.formattaPrezzo)(bodenRichtwert3, true),
                  ' '
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  t('mietspiegel'),
                  ': ',
                  (0, _utils.formattaPrezzo)(mietspiegel, true),
                  '/m2 (Tot.: ',
                  (0, _utils.formattaPrezzo)(mietspiegel * m2 / 100, true),
                  ')'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  t('mietendeckel'),
                  ': ',
                  (0, _utils.formattaPrezzo)(mietendeckel, true),
                  '/m2 (Tot.: ',
                  (0, _utils.formattaPrezzo)(mietendeckel * m2 / 100, true),
                  ')'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  t('sold_price_min'),
                  ':',
                  ' ',
                  (0, _utils.formattaPrezzo)(immobilienpreisMin, true),
                  '/m2 (Tot.:',
                  ' ',
                  (0, _utils.formattaPrezzo)(immobilienpreisMin * m2 / 100, true),
                  ')'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  t('sold_price_max'),
                  ':',
                  ' ',
                  (0, _utils.formattaPrezzo)(immobilienpreisMax, true),
                  '/m2 (Tot.:',
                  ' ',
                  (0, _utils.formattaPrezzo)(immobilienpreisMax * m2 / 100, true),
                  ')'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  t('sold_price_average'),
                  ':',
                  ' ',
                  (0, _utils.formattaPrezzo)(immobilienpreisAverage, true),
                  '/m2 (Tot.:',
                  ' ',
                  (0, _utils.formattaPrezzo)(immobilienpreisAverage * m2 / 100, true),
                  ')'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  t('is24_evaluation'),
                  ': ',
                  (0, _utils.formattaPrezzo)(is24Evaluation, true),
                  '/m2 (Tot.: ',
                  (0, _utils.formattaPrezzo)(is24Evaluation * m2 / 100, true),
                  ')'
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'container section' },
          _react2.default.createElement(
            'ul',
            { className: 'collection  s12 m6' },
            oggetto && showEvaluationDownloadButton && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_collectionItem2.default, {
                label: '' + t('evaluation_german'),
                action: function action() {
                  (0, _EvaluationPdf2.default)(_this2.props.evaluation, _this2.props.firma, _this2.props.utente, _this2.props.ceo, 'De', oggetto);
                },
                icon: 'article',
                btnColor: 'blue'
              }),
              _react2.default.createElement(_collectionItem2.default, {
                label: '' + t('evaluation_english'),
                action: function action() {
                  (0, _EvaluationPdf2.default)(_this2.props.evaluation, _this2.props.firma, _this2.props.utente, _this2.props.ceo, 'En', oggetto);
                },
                icon: 'article',
                btnColor: 'blue'
              }),
              _react2.default.createElement(_collectionItem2.default, {
                label: '' + t('evaluation_italian'),
                action: function action() {
                  (0, _EvaluationPdf2.default)(_this2.props.evaluation, _this2.props.firma, _this2.props.utente, _this2.props.ceo, 'It', oggetto);
                },
                icon: 'article',
                btnColor: 'blue'
              })
            )
          )
        ),
        (0, _elements.imageView)(evaluation.wohnlageSnippet, t('area_classification')),
        (0, _elements.imageView)(evaluation.bodenrichtwertSnippet, t('land_price')),
        (0, _elements.imageView)(evaluation.immobilienPreisSnippet, t('sold_price')),
        (0, _elements.imageView)(evaluation.is24Snippet, t('is24_evaluation')),
        (0, _elements.imageView)(evaluation.mietspiegelSnippet, t('mietspiegel')),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          testoIntroduttivoDe && _react2.default.createElement(
            'div',
            { className: 'grey lighten-4' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'h1',
                null,
                t('german')
              )
            ),
            ' '
          ),
          testoIntroduttivoDe,
          testoFinaleDe && _react2.default.createElement(
            'div',
            null,
            testoFinaleDe
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          testoIntroduttivoEn && _react2.default.createElement(
            'div',
            { className: 'grey lighten-4' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'h1',
                null,
                t('english')
              )
            ),
            ' '
          ),
          testoIntroduttivoEn,
          testoFinaleEn && _react2.default.createElement(
            'div',
            null,
            testoFinaleEn
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          testoIntroduttivoIt && _react2.default.createElement(
            'div',
            { className: 'grey lighten-4' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'h1',
                null,
                t('italian')
              )
            ),
            ' '
          ),
          testoIntroduttivoIt,
          testoFinaleIt && _react2.default.createElement(
            'div',
            null,
            testoFinaleIt
          )
        ),
        _react2.default.createElement(_Mappa2.default, {
          indirizzo: oggetto ? oggetto.via + ' ' + oggetto.numeroCivico + ', ' + oggetto.cap + ' ' + oggetto.citta : titolo
        }),
        oggetto && _react2.default.createElement(_OggettiList2.default, { oggetto: [oggetto], ruolo: t('property') })
      );
    }
  }]);

  return ViewEvaluation;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    evaluation: state.evaluations.find(function (evaluation) {
      return evaluation.id === props.match.params.id;
    }),
    oggetti: state.oggetti,
    utente: state.utenti.find(function (utente) {
      return utente.firebaseAuthId === state.auth.uid;
    }),
    firma: state.firma[0],
    ceo: state.utenti.filter(function (utente) {
      return utente.role === 'Geschäftsführer';
    })
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    startRemoveEvaluation: function startRemoveEvaluation(data) {
      return dispatch(_configureStore.storeActions.find(function (action) {
        return action.label === 'evaluations';
      }).startRemoveAction(data));
    },
    startEditEvaluation: function startEditEvaluation(id, evaluation) {
      return dispatch(_configureStore.storeActions.find(function (action) {
        return action.label === 'evaluations';
      }).startEditAction(id, evaluation));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactI18next.withTranslation)()(ViewEvaluation));

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jspdf = __webpack_require__(32);

var _jspdf2 = _interopRequireDefault(_jspdf);

var _ImageLogo = __webpack_require__(39);

var _IvdLogo = __webpack_require__(222);

var _numeral = __webpack_require__(147);

var _numeral2 = _interopRequireDefault(_numeral);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// se c'é già l'oggetto uso la foto come copertina altrimenti uso una foto generica
var evaluationPdf = function evaluationPdf(evaluation, firma, utente, ceo, lingua, oggetto) {
  var doc = new _jspdf2.default('p', 'mm', 'a4', true);
  doc.setFont('helvetica');
  var fontStart = 14;
  var xPos = 15;
  var yPos = 15;
  var traduzione = {};
  if (lingua === 'De') {
    traduzione = {
      apartment: 'Eigentumswohnung',

      evaluation: 'Immobilienbewertung',
      testoIntroduttivo: 'Sehr geehrte Damen und Herren,\nvielen Dank für Ihre Bewertungsanfrage.\nWie versprochen, haben wir eine Bewertung der Immobilie durchgeführt, indem wir historische Daten, Marktdaten und Merkmale analysiert haben.\n',
      wohnlageText: 'Wohnlagenkarte nach Adressen zum Berliner Mietspiegel 2019:',
      bodenrichtwertText: 'Entwicklung des Bodenrichtwertes in der letzten 3 Jahren:',
      is24Text: 'Bewertungsergebnis des Portals ImmoScout24:',
      immobilienpreisText: 'Verkaufspreise in der letzten 2 Jahren vergleichbarer Immobilie:',
      mietspiegelText: 'Mietspiegel:',
      mietendeckelText: 'Laut Mietendeckel ist die maximale Nettokaltmiete jedoch ',
      datiIntroText: 'Bei der Bewertung haben wir folgende Daten berücksichtigt:',
      testoFinale: 'Selbstverständlich haben wir die Daten mit den Besonderheiten der Immobilie angepasst. Unsere Preisschätzung liegt bei',
      testoFinale2: 'Wir hoffen, unsere Bewertung entspricht Ihre Preisvorstellung. Wir würden uns über einen Maklerauftrag freuen und stehen Ihnen weiterhin gerne zur Verfügung.\n\nBeste Grüße',
      ansprechpartner: 'Ihr Ansprechpartner',
      oeffnungszeiten: 'Öffnungszeiten',
      saluti: 'Mit freundlichen Grüßen',
      titolo: oggetto.titoloDe,
      bagni: 'Badezimmer',
      piano: 'Etage',
      baujahr: 'Baujahr',
      heizungsart: 'Heizungsart',
      energieAusweisTyp: 'Energieausweis-Typ',
      energieAusweisBis: 'Energieausweis gültig bis',
      energieBedarf: 'Energieverbrauch KWh/(m²*a)',
      energieTraeger: 'Wesentliche Energieträger',
      wohngeld: 'Hausgeld',
      affittoNetto: 'Kaltmiete',
      provvigione: 'Käuferprovision (inkl. MWSt.)',
      balcone: 'Balkon',
      ascensore: 'Aufzug',
      giardino: 'Garten',
      cantina: 'Keller',
      condizioni: 'Zustand',
      vani: 'Zimmer',
      m2: 'Größe',
      rifId: 'Ref. ID',
      descrizione: oggetto.descrizioneDe
    };
  } else if (lingua === 'It') {
    traduzione = {
      apartment: 'Appartamento',
      evaluation: 'Valutazione immobiliare',
      testoIntroduttivo: "Gentile Cliente,\nLa ringraziamo per la richiesta di valutazione del Suo immobile.\nCome promesso, abbiamo effettuato una valutazione dell'immobile analizzando i dati storici, i dati di mercato e le caratteristiche particolari dell'appartamento.\n",
      wohnlageText: 'Classificazione della zona secondo il Berliner Mietspiegel 2019:',
      bodenrichtwertText: 'Sviluppo del valore del terreno negli ultimi 3 anni:',
      is24Text: 'Risultati valutazione del portale immobiliare ImmoScout24:',
      immobilienpreisText: 'Prezzi reali di vendita di immobili simili negli ultimi 2 anni:',
      mietspiegelText: 'Media degli affitti di zona:',
      mietendeckelText: 'Secondo la nuova normativa sul tetto massimo degli affitti, il netto ammonta a  ',
      datiIntroText: 'Per la valutazione abbiamo preso in considerazione i seguenti dati:',
      testoFinale: "Naturalmente abbiamo corretto la valutazione tenendo conto delle particolarità dell'immobile e siamo giunti a una valutazione di",
      testoFinale2: "Ci auguriamo che la nostra valutazione rispecchi le Sue aspettative. Siamo a Sua disposizione nel caso in cui desiderasse mettere in vendita l'immobile.\n\nCordiali saluti,",

      ansprechpartner: 'Il Suo referente',
      oeffnungszeiten: 'Orari di apertura',
      saluti: 'Cordiali saluti',
      titolo: oggetto.titolo,
      bagni: 'Bagni',
      piano: 'Piano',
      baujahr: 'Anno di costruzione',
      heizungsart: 'Tipo di riscaldamento',
      energieAusweisTyp: 'Certificato energetico basato sul',
      energieAusweisBis: 'Valido fino al',
      energieBedarf: 'Consumo energetico KWh/(m²*a)',
      energieTraeger: 'Fonte energetica primaria',
      wohngeld: 'Condominio',
      affittoNetto: 'Affitto netto',
      provvigione: "Provvigione per l'acquirente (IVA inclusa)",
      balcone: 'Balcone',
      ascensore: 'Ascensore',
      giardino: 'Giardino',
      cantina: 'Cantina',
      condizioni: 'Condizioni',
      vani: 'Vani',
      m2: 'Ampiezza',
      rifId: 'Rif. ID',
      descrizione: oggetto.descrizione
    };
  } else if (lingua === 'En') {
    traduzione = {
      apartment: 'Apartment',
      evaluation: 'Property Evaluation',
      testoIntroduttivo: 'Dear Customer,\nthank you very much for your review request.\nAs promised, we have carried out a valuation of the property by analysing historical data, market data and features.\n',
      wohnlageText: 'Area classification according to the Berliner Mietspiegel 2019:',
      bodenrichtwertText: 'Value of the land in the last 3 years:',
      is24Text: 'Evaluation result from the Real Estate portal ImmoScout24:',
      immobilienpreisText: 'Actual selling prices of similar properties in the last 2 years:',
      mietspiegelText: 'Average renting prices:',
      mietendeckelText: 'According to the new rentig law, the max net rent price is ',
      datiIntroText: 'For the valuation we have taken the following data into account:',
      testoFinale: 'We considered of course the features of the apartment and we calculated a selling price of',
      testoFinale2: 'We hope, our evaluation match your expectations. We are at your disposal if you wish to sell the apartment.\n\nBest regards',

      ansprechpartner: 'Your Agent',
      oeffnungszeiten: 'Opening hours',
      saluti: 'Best regards',
      titolo: oggetto.titoloEn,
      bagni: 'Bathrooms',
      piano: 'Floor No.',
      baujahr: 'Year built',
      heizungsart: 'Heating type',
      energieAusweisTyp: 'Energy pass based on',
      energieAusweisBis: 'Valid until',
      energieBedarf: 'Energy consumption KWh/(m²*a)',
      energieTraeger: 'Primary energy carrier',
      wohngeld: 'Monthly costs',
      affittoNetto: 'Net monthly rent',
      provvigione: 'Agency fee for buyer (VAT included)',
      balcone: 'Balcony',
      ascensore: 'Elevator',
      giardino: 'Garden',
      cantina: 'Cellar',
      condizioni: 'Condition',
      vani: 'Rooms',
      m2: 'Size',
      rifId: 'Ref. ID',
      descrizione: oggetto.descrizioneEn
    };
  }

  var frontPage = function frontPage(textArray, fontSize) {
    doc.addImage(_ImageLogo.imgLogo, 'JPEG', 140, 10, 55, 12, undefined, 'FAST');
    var pdfWidth = doc.internal.pageSize.getWidth();

    if (oggetto.downloadURLsCover) {
      var cover = new Image();
      cover.src = oggetto.downloadURLsCover;
      var imgProps = doc.getImageProperties(cover);
      var pdfHeight = imgProps.height * pdfWidth / imgProps.width;
      doc.addImage(cover, 'JPEG', -100, 30, pdfWidth * 1.7, pdfHeight * 1.7);
    }

    // Titolo
    var lineYPos = 180;
    doc.setDrawColor(18, 52, 86);
    doc.setLineWidth(70);
    doc.line(0, 200, pdfWidth, 200);
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(fontSize);
    doc.setFontType('normal');
    textArray.forEach(function (text, i) {
      doc.text(text, 15, lineYPos);
      if (i === 0 || i === 5) {
        lineYPos += 20;
      } else {
        lineYPos += 10;
      }
    });
  };

  var wohnlagePage = function wohnlagePage() {
    var wohnlage = function wohnlage() {
      if (lingua === 'De') {
        if (evaluation.wohnlage === 'simple_area') return 'Einfache Lage';
        if (evaluation.wohnlage === 'average_area') return 'Mittlere Lage';
        if (evaluation.wohnlage === 'good_area') return 'Gute Lage';
        if (evaluation.wohnlage === 'top_area') return 'Sehr gute Lage';
      }
      if (lingua === 'En') {
        if (evaluation.wohnlage === 'simple_area') return 'Simple area';
        if (evaluation.wohnlage === 'average_area') return 'Average area';
        if (evaluation.wohnlage === 'good_area') return 'Good area';
        if (evaluation.wohnlage === 'top_area') return 'Very good area';
      }

      if (lingua === 'It') {
        if (evaluation.wohnlage === 'simple_area') return 'Zona semplice';
        if (evaluation.wohnlage === 'average_area') return 'Zona media';
        if (evaluation.wohnlage === 'good_area') return 'Zona buona';
        if (evaluation.wohnlage === 'top_area') return 'Zona ottima';
      }
    };
    doc.text(traduzione.wohnlageText + ' ' + wohnlage(), xPos, yPos + 100);

    var wohnlageImg = new Image();
    wohnlageImg.src = evaluation.wohnlageSnippet;
    var imgProps = doc.getImageProperties(wohnlageImg);
    var pdfWidth = doc.internal.pageSize.getWidth();
    var pdfHeight = imgProps.height * pdfWidth / imgProps.width;
    doc.addImage(wohnlageImg, 'JPEG', xPos, yPos + 110, pdfWidth * 0.8, pdfHeight * 0.8);
  };

  var introPage = function introPage() {
    doc.addPage();
    doc.addImage(_ImageLogo.imgLogo, 'JPEG', 140, 10, 55, 12, undefined, 'FAST');
    doc.setTextColor(0, 0, 0);

    var text = evaluation['testoIntroduttivo' + lingua] || traduzione.testoIntroduttivo;

    var lines = doc.setFontSize(12).splitTextToSize(text, 180);
    doc.text(xPos, 45 + 12 / 110, lines);

    doc.text(traduzione.datiIntroText, xPos, yPos + 85);
    wohnlagePage();
  };

  var bodenrichtwertPage = function bodenrichtwertPage() {
    doc.addPage();
    doc.addImage(_ImageLogo.imgLogo, 'JPEG', 140, 10, 55, 12, undefined, 'FAST');
    yPos += 15;
    doc.text(traduzione.bodenrichtwertText, xPos, yPos);
    yPos += 15;

    evaluation.bodenrichtwertSnippet.map(function (img, i) {
      var brwImg = new Image();
      brwImg.src = img;
      var imgProps = doc.getImageProperties(brwImg);
      var pdfWidth = doc.internal.pageSize.getWidth();
      var pdfHeight = imgProps.height * pdfWidth / imgProps.width;
      doc.text((0, _moment2.default)().subtract(i, 'years').format('YYYY'), xPos, yPos);
      doc.addImage(brwImg, 'JPEG', xPos + 30, yPos, pdfWidth * 0.5, pdfHeight * 0.5);
      yPos += pdfHeight * 0.5 + 10;
    });
  };

  var is24Page = function is24Page() {
    doc.addPage();
    doc.addImage(_ImageLogo.imgLogo, 'JPEG', 140, 10, 55, 12, undefined, 'FAST');
    yPos = 30;
    doc.text(traduzione.is24Text, xPos, yPos);
    yPos += 15;

    var is24Img = new Image();
    is24Img.src = evaluation.is24Snippet;
    var imgProps = doc.getImageProperties(is24Img);
    var pdfWidth = doc.internal.pageSize.getWidth();
    var pdfHeight = imgProps.height * pdfWidth / imgProps.width;
    doc.addImage(is24Img, 'JPEG', xPos, yPos, pdfWidth * 0.8, pdfHeight * 0.8);
  };

  var immobilienpreisPage = function immobilienpreisPage() {
    doc.addPage();
    doc.addImage(_ImageLogo.imgLogo, 'JPEG', 140, 10, 55, 12, undefined, 'FAST');
    yPos = 30;
    doc.text(traduzione.immobilienpreisText, xPos, yPos);
    yPos += 15;

    var immobilienpreisImg = new Image();
    immobilienpreisImg.src = evaluation.immobilienPreisSnippet;
    var imgProps = doc.getImageProperties(immobilienpreisImg);
    var pdfWidth = doc.internal.pageSize.getWidth();
    var pdfHeight = imgProps.height * pdfWidth / imgProps.width;
    doc.addImage(immobilienpreisImg, 'JPEG', xPos, yPos, pdfWidth * 0.8, pdfHeight * 0.8);
  };

  var mietspiegelPage = function mietspiegelPage() {
    doc.addPage();
    doc.addImage(_ImageLogo.imgLogo, 'JPEG', 140, 10, 55, 12, undefined, 'FAST');
    yPos = 30;
    doc.text(traduzione.mietspiegelText, xPos, yPos);
    yPos += 15;

    var mietspiegelImg = new Image();
    mietspiegelImg.src = evaluation.mietspiegelSnippet;
    var imgProps = doc.getImageProperties(mietspiegelImg);
    var pdfWidth = doc.internal.pageSize.getWidth();
    var pdfHeight = imgProps.height * pdfWidth / imgProps.width;
    doc.addImage(mietspiegelImg, 'JPEG', xPos, yPos, pdfWidth * 0.8, pdfHeight * 0.8);
    yPos += pdfHeight * 0.8 + 20;

    evaluation.mietendeckel && doc.text('' + traduzione.mietendeckelText + (0, _numeral2.default)(evaluation.mietendeckel / 100).format('0,0.00') + '\u20AC/m2.', xPos, yPos);
  };

  var resultPage = function resultPage() {
    doc.addPage();
    doc.addImage(_ImageLogo.imgLogo, 'JPEG', 140, 10, 55, 12, undefined, 'FAST');
    yPos = 30;
    var text = evaluation['testoFinale' + lingua] || traduzione.testoFinale + ' ' + (0, _numeral2.default)(evaluation.result * parseFloat(oggetto.m2.replace(/,/, '.'), 10) / 100).format('0,0.00') + ' \u20AC.\n\n' + traduzione.testoFinale2 + '\n\n' + utente.name + '\n' + utente.email + '\n' + utente.telefon;

    var lines = doc.setFontSize(12).splitTextToSize(text, 180);
    doc.text(xPos, 45 + 12 / 110, lines);
  };

  //RENDER
  frontPage([traduzione.evaluation,
  // traduzione.property,
  oggetto.via + ' ' + oggetto.numeroCivico, oggetto.cap + ' ' + oggetto.citta], 22);

  introPage();
  bodenrichtwertPage();
  is24Page();
  immobilienpreisPage();
  mietspiegelPage();
  resultPage();

  //Quarta di copertina
  doc.addPage();
  var ceoList = '';
  ceo.forEach(function (ceo, i) {
    if (i < 1) {
      ceoList += '' + ceo.name;
    } else {
      ceoList += ', ' + ceo.name;
    }
  });
  frontPage([firma.name + ' ' + (firma.name2 && ' - ' + firma.name2), firma.adresse + ', ' + firma.plz + ' ' + firma.stadt, 'Telefon: ' + firma.telefon + ' - Telefax: ' + firma.fax, firma.website + ' - ' + firma.email], 14);

  //Save
  doc.save(traduzione.evaluation + ' - ' + oggetto.via + ' ' + oggetto.numeroCivico + '.pdf');
};

exports.default = evaluationPdf;

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(4);

var _Intestazione = __webpack_require__(20);

var _Intestazione2 = _interopRequireDefault(_Intestazione);

var _ListFilters = __webpack_require__(96);

var _ListFilters2 = _interopRequireDefault(_ListFilters);

var _NewsletterList = __webpack_require__(1160);

var _NewsletterList2 = _interopRequireDefault(_NewsletterList);

var _elements = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewsletterDashboard = function NewsletterDashboard(_ref) {
  var t = _ref.t;

  var options = [{ value: 'name', label: t('newsletter_filter_name') }, { value: 'date', label: t('newsletter_filter_date') }];
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_Intestazione2.default, { intestazione: t('newsletter_header') }),
    _react2.default.createElement(_ListFilters2.default, { options: options }),
    (0, _elements.addButton)('/newslettercreate'),
    _react2.default.createElement(_NewsletterList2.default, null)
  );
};

exports.default = (0, _reactI18next.withTranslation)()(NewsletterDashboard);

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewsletterList = undefined;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _Card = __webpack_require__(56);

var _Card2 = _interopRequireDefault(_Card);

var _deals = __webpack_require__(85);

var _deals2 = _interopRequireDefault(_deals);

var _utils = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewsletterList = exports.NewsletterList = function NewsletterList(_ref) {
  var oggettoNewsletter = _ref.oggettoNewsletter,
      newsletters = _ref.newsletters,
      oggetti = _ref.oggetti,
      ruolo = _ref.ruolo,
      t = _ref.t;

  var newslettersPayload = oggettoNewsletter || newsletters;
  var findOggetto = function findOggetto(oggettoId) {
    var oggetto = oggetti.find(function (ogg) {
      return ogg.id === oggettoId;
    });
    return _react2.default.createElement(
      'div',
      { className: 'foto-container foto-container-newsletter' },
      oggetto.downloadURLsCover && _react2.default.createElement('img', { className: 'foto', src: oggetto.downloadURLsCover[0] || '' }),
      ' ',
      oggetto.rifId,
      ' - ',
      oggetto.via
    );
  };

  return _react2.default.createElement(
    'div',
    { className: 'container' },
    newslettersPayload.length > 0 && _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'h5',
        null,
        ruolo || ''
      ),
      newslettersPayload.sort(function (a, b) {
        return a.dataNewsletter > b.dataNewsletter ? -1 : 1;
      }).map(function (newsletter) {
        var dataNewsletter = (0, _utils.formattaData)(newsletter.dataNewsletter);
        var oggettiInviati = [];
        newsletter.oggetto1 && oggettiInviati.push(findOggetto(newsletter.oggetto1));
        newsletter.oggetto2 && oggettiInviati.push(findOggetto(newsletter.oggetto2));
        newsletter.oggetto3 && oggettiInviati.push(findOggetto(newsletter.oggetto3));
        newsletter.oggetto4 && oggettiInviati.push(findOggetto(newsletter.oggetto4));
        newsletter.oggetto5 && oggettiInviati.push(findOggetto(newsletter.oggetto5));
        newsletter.oggetto6 && oggettiInviati.push(findOggetto(newsletter.oggetto6));

        return _react2.default.createElement(_Card2.default, {
          key: newsletter.id,
          visible: newsletter.visible,
          link: '/newsletterview/' + newsletter.id,
          titolo: dataNewsletter,
          sottotitolo: '',
          titoloDestra: _react2.default.createElement(
            'span',
            { className: 'card-title list-item--paid' },
            newsletter.mailchimpIdDe ? newsletter.mailchimpIdDe.sent ? 'DE' : '' : '',
            ' ',
            newsletter.mailchimpIdIt ? newsletter.mailchimpIdIt.sent ? 'IT' : '' : '',
            ' ',
            newsletter.mailchimpIdEn ? newsletter.mailchimpIdEn.sent ? 'EN' : '' : '',
            ' '
          ),
          corpo: [].concat(oggettiInviati)
        });
      })
    )
  );
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    newsletters: (0, _deals2.default)('newsletters', state.newsletters, state.filters, undefined, state.oggetti),
    oggetti: state.oggetti
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()(NewsletterList));

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditNewsletter = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _configureStore = __webpack_require__(14);

var _OptionModal = __webpack_require__(58);

var _OptionModal2 = _interopRequireDefault(_OptionModal);

var _NewsletterForm = __webpack_require__(617);

var _NewsletterForm2 = _interopRequireDefault(_NewsletterForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditNewsletter = exports.EditNewsletter = function (_React$Component) {
  _inherits(EditNewsletter, _React$Component);

  function EditNewsletter() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, EditNewsletter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EditNewsletter.__proto__ || Object.getPrototypeOf(EditNewsletter)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isOpen: false,
      modalContent: 'remove_confirm',
      btnEnabled: true
    }, _this.handleOpenModal = function () {
      _this.setState(function () {
        return {
          isOpen: true
        };
      });
    }, _this.handleCloseModal = function () {
      _this.setState({ isOpen: false });
    }, _this.onSubmit = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(newsletter) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.props.startEditNewsletter(_this.props.newsletter.id, newsletter);

              case 2:
                _this.props.history.push('/newsletterview/' + _this.props.newsletter.id);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), _this.onRemove = function () {
      if (!_this.props.newsletter.mailchimpId) {
        _this.props.startRemoveNewsletter({ id: _this.props.newsletter.id });
        _this.props.history.push('/newsletters');
      } else {
        _this.setState(function () {
          return {
            isOpen: true,
            modalContent: 'cannot_delete_newsletter',
            btnEnabled: false
          };
        });
      }
    }, _this.onDisable = function () {
      if (!_this.props.newsletter.mailchimpId) {
        _this.props.startEditNewsletter(_this.props.newsletter.id, _extends({}, _this.props.newsletter, {
          visible: false
        }));
        _this.props.history.push('/newsletters');
      } else {
        _this.setState(function () {
          return {
            isOpen: true,
            modalContent: 'cannot_delete_newsletter',
            btnEnabled: false
          };
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EditNewsletter, [{
    key: 'render',
    value: function render() {
      if (!this.props.newsletter || this.props.utente.role === 'Mitarbeiter' && !this.props.newsletter.visible) {
        this.props.history.push('/newsletters');
        return _react2.default.createElement(
          'div',
          null,
          'Loading...'
        );
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'h1',
              null,
              this.props.t('newsletter_edit')
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(_OptionModal2.default, {
            isOpen: this.state.isOpen,
            contentLabel: 'remove',
            modalContent: this.props.t(this.state.modalContent),
            onCancel: this.handleCloseModal,
            onConfirm: this.props.utente.role === 'Admin' ? this.onRemove : this.onDisable,
            btnEnabled: this.state.btnEnabled
          }),
          _react2.default.createElement(_NewsletterForm2.default, {
            newsletter: this.props.newsletter,
            onSubmit: this.onSubmit
          }),
          _react2.default.createElement(
            'button',
            {
              className: 'btn-floating red margine-basso',
              onClick: this.handleOpenModal
            },
            _react2.default.createElement(
              'i',
              { className: 'material-icons' },
              'delete'
            )
          )
        )
      );
    }
  }]);

  return EditNewsletter;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    newsletter: state.newsletters.find(function (newsletter) {
      return newsletter.id === props.match.params.id;
    }),
    utente: state.utenti.find(function (utente) {
      return utente.firebaseAuthId === state.auth.uid;
    })
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    startEditNewsletter: function startEditNewsletter(id, newsletter, visible) {
      return dispatch(_configureStore.storeActions.find(function (action) {
        return action.label === 'newsletters';
      }).startEditAction(id, newsletter, visible));
    },
    startRemoveNewsletter: function startRemoveNewsletter(data) {
      return dispatch(_configureStore.storeActions.find(function (action) {
        return action.label === 'newsletters';
      }).startRemoveAction(data));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactI18next.withTranslation)()(EditNewsletter));

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewNewsletter = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _OggettiList = __webpack_require__(73);

var _OggettiList2 = _interopRequireDefault(_OggettiList);

var _Intestazione = __webpack_require__(20);

var _Intestazione2 = _interopRequireDefault(_Intestazione);

var _MailchimpApi = __webpack_require__(1163);

var _MailchimpApi2 = _interopRequireDefault(_MailchimpApi);

var _utils = __webpack_require__(9);

var _elements = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ViewNewsletter = exports.ViewNewsletter = function (_React$Component) {
  _inherits(ViewNewsletter, _React$Component);

  function ViewNewsletter(props) {
    _classCallCheck(this, ViewNewsletter);

    var _this = _possibleConstructorReturn(this, (ViewNewsletter.__proto__ || Object.getPrototypeOf(ViewNewsletter)).call(this, props));

    _this.findOggetto = function (oggettoId) {
      return _this.props.oggetti.find(function (ogg) {
        return ogg.id === oggettoId;
      });
    };

    _this.pushOggetto = function (oggettoId) {
      var ogg = _this.findOggetto(oggettoId);
      if (ogg && !_this.state.oggArray.some(function (e) {
        return e.id === ogg.id;
      })) _this.state.oggArray.push(ogg);
    };

    _this.state = {
      oggArray: []
    };
    return _this;
  }

  _createClass(ViewNewsletter, [{
    key: 'render',
    value: function render() {
      var _props$newsletter = this.props.newsletter,
          dataNewsletter = _props$newsletter.dataNewsletter,
          oggetto1 = _props$newsletter.oggetto1,
          oggetto2 = _props$newsletter.oggetto2,
          oggetto3 = _props$newsletter.oggetto3,
          oggetto4 = _props$newsletter.oggetto4,
          oggetto5 = _props$newsletter.oggetto5,
          oggetto6 = _props$newsletter.oggetto6,
          newsletterText = _props$newsletter.newsletterText,
          id = _props$newsletter.id;
      var t = this.props.t;
      // run();

      oggetto1 && this.pushOggetto(oggetto1);
      oggetto2 && this.pushOggetto(oggetto2);
      oggetto3 && this.pushOggetto(oggetto3);
      oggetto4 && this.pushOggetto(oggetto4);
      oggetto5 && this.pushOggetto(oggetto5);
      oggetto6 && this.pushOggetto(oggetto6);

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Intestazione2.default, {
          intestazione: dataNewsletter && _react2.default.createElement(
            'span',
            null,
            (0, _utils.formattaData)(dataNewsletter)
          )
        }),
        _react2.default.createElement(
          'div',
          { className: 'container section' },
          _react2.default.createElement(
            'div',
            null,
            (0, _elements.editButton)('/newsletteredit/' + id)
          ),
          _react2.default.createElement(
            'div',
            null,
            newsletterText
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'section' },
          _react2.default.createElement(_MailchimpApi2.default, {
            oggArray: this.state.oggArray,
            newsletter: this.props.newsletter
          })
        ),
        _react2.default.createElement(_OggettiList2.default, {
          oggetto: this.state.oggArray,
          ruolo: t('newsletter_properties')
        })
      );
    }
  }]);

  return ViewNewsletter;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    newsletter: state.newsletters.find(function (newsletter) {
      return newsletter.id === props.match.params.id;
    }),
    oggetti: state.oggetti
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()(ViewNewsletter));

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _axios = __webpack_require__(67);

var _axios2 = _interopRequireDefault(_axios);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _numeral = __webpack_require__(147);

var _numeral2 = _interopRequireDefault(_numeral);

var _configureStore = __webpack_require__(14);

var _collectionItem = __webpack_require__(160);

var _collectionItem2 = _interopRequireDefault(_collectionItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MailchimpAPI = function (_React$Component) {
  _inherits(MailchimpAPI, _React$Component);

  function MailchimpAPI(props) {
    _classCallCheck(this, MailchimpAPI);

    var _this = _possibleConstructorReturn(this, (MailchimpAPI.__proto__ || Object.getPrototypeOf(MailchimpAPI)).call(this, props));

    _this.bodyText = function (text, textToCut) {
      var textToCutIndex = text.indexOf(textToCut);

      if (textToCutIndex === -1) return text;

      return text.substring(0, textToCutIndex);
    };

    _this.sendNewsletter = function (lingua) {
      _this.setState({
        spinner: true
      });
      var _this$props = _this.props,
          oggArray = _this$props.oggArray,
          newsletter = _this$props.newsletter;

      var settings = {};
      if (lingua === 'De') {
        _moment2.default.locale('de');
        settings.language = 'de';
        settings.list_id = 'd760eee60a';
        settings.subject_line = 'Neue Immobilienangebote';
        settings.title = 'Neswletter vom ' + (0, _moment2.default)().format('DD MMMM, YYYY');
        settings.from_name = 'm2Square - Immobilienmakler in Berlin';
        settings.btn_text = 'Details';
        settings.homepage = 'https://www.m2square.eu/';
        settings.ivdText = ''; //`Das IVD-Logo ist ein Gütesiegel für Kompetenz und Professionalität`;
        settings.footerText = '<em>Copyright \xA9 *|CURRENT_YEAR|* *|LIST:COMPANY|*, alle Rechte vorbehalten.</em><br>\n*|IFNOT:ARCHIVE_PAGE|* *|LIST:DESCRIPTION|*<br>\n<br>\n<strong>Unsere Adresse:</strong><br>\n*|HTML:LIST_ADDRESS_HTML|* *|END:IF|*<br>\n<br>\nM\xF6chten Sie den E-Mail-Empfang \xE4ndern?<br>\nSie k\xF6nnen&nbsp;<a href="*|UPDATE_PROFILE|*">die Einstellungen \xE4ndern</a>&nbsp;oder&nbsp;<a href="*|UNSUB|*">diese E-Mail abbestellen</a>.<br>\n<br>';
        settings.whyText = '';
        settings.browserText = 'Schau Dir diese Newsletter im Browser';
        settings.aphTitle = 'Pflegeimmobilien als Kapitalanlage';
        settings.aphLink = 'https://www.m2square.eu/sichere-vermoegensaufbau-mit-pflegeimmobilien/';
        settings.aphText = 'Sichere Vermögensaufbau mit Pflegeimmobilien';
        settings.evaluationLink = 'https://www.m2square.eu/wohnung-verkaufen-in-berlin-kostenlose-bewertung-fuer-ihre-immobilie/';
        settings.evaluationLinkText = 'Jetzt starten!';

        settings.evaluationText = '<h1 class="null" style="text-align: center;">M\xF6chten Sie Ihre Wohnung in Berlin verkaufen?</h1><h2 class="null" style="text-align: center;">Wir bieten Ihnen eine kostenlose Bewertung an!</h2>\n&nbsp;<h3 class="null">1. Geben Sie die Eckdaten ein</h3><h4 class="null" style="text-align: left;"><span class="mc-toc-title">F\xFCllen Sie das Formular auf unsere Webseite. Es dauert nur 2 Minuten.</span></h4>\n&nbsp;<h3 class="null">2. Wir treffen uns vor Ort</h3><h4 class="null">Wir melden uns bei Ihnen um einen Besichtigungstermin zu vereinbaren.</h4>\n&nbsp;<h3 class="null">3. Sie bekommen unsere Bewertung</h3><h4 class="null">In 1-2 Tagen bekommen Sie von uns eine kostenlose und unverbindliche Bewertung per E-Mail.</h4>';
      } else if (lingua === 'En') {
        _moment2.default.locale('en');
        settings.language = 'en';
        settings.list_id = '12a251d472';
        settings.subject_line = 'New Real Estate Offers';
        settings.title = 'Neswletter of ' + (0, _moment2.default)().format('DD MMMM, YYYY');
        settings.from_name = 'm2Square - Berlin Real Estate';
        settings.btn_text = 'Details';
        settings.homepage = 'https://www.m2square.eu/en';
        settings.ivdText = ''; //`The IVD logo is a seal of quality for competence and professionalism.<br /><br />m2Square is a member of the IVD, the most important German real estate association, and is committed to its guidelines.`;
        settings.footerText = '<em>Copyright \xA9 *|CURRENT_YEAR|* *|LIST:COMPANY|*, all rights reserved.</em><br>\n*|IFNOT:ARCHIVE_PAGE|* *|LIST:DESCRIPTION|*<br>\n<br>\n<strong>Our Address is:</strong><br>\n*|HTML:LIST_ADDRESS_HTML|* *|END:IF|*<br>\n<br>\nDo you want to change the way you receive this email?<br>\nYou can&nbsp;<a href="*|UPDATE_PROFILE|*">edit your settings</a>&nbsp;or&nbsp;<a href="*|UNSUB|*">unsubscribe from this list</a>.<br>\n<br>';
        settings.whyText = '<strong>Why m2Square?</strong><br />- we are certified professionals<br />- our fees are clear, competitive and VAT included<br />- we don\'t ask for unjustified advances<br />- we carefully select the properties<br />- we speak your language<br />';
        settings.browserText = 'Watch this message in your browser';
        settings.aphTitle = 'Invest in nursing homes in Germany';
        settings.aphLink = 'https://www.m2square.eu/en/invest-in-nursing-homes-in-germany-2/';
        settings.aphText = 'Good investment opportunity with 20 years contracts';
        settings.evaluationLink = 'https://www.m2square.eu/en/sell-apartment-in-berlin-property-price-evaluation/';
        settings.evaluationLinkText = "Let's start!";

        settings.evaluationText = '<h1 class="null" style="text-align: center;">Do you want to sell your property in Berlin?</h1><h2 class="null" style="text-align: center;">We offer you a free evaluation!</h2>\n&nbsp;<h3 class="null">1. Give us all relevant information</h3><h4 class="null" style="text-align: left;"><span class="mc-toc-title">Fill the form on our Website. It only takes 2 minutes.</span></h4>\n&nbsp;<h3 class="null">2. We meet at the property</h3><h4 class="null">We will contact you and make an appointment for a visit of the Property.</h4>\n&nbsp;<h3 class="null">3. You will receive our Evaluation</h3><h4 class="null">In 1 to 2 days we will send you our Evaluation per email.</h4>';
      } else if (lingua === 'It') {
        _moment2.default.locale('it');
        settings.language = 'it';
        // settings.list_id = 'a475609b0e'; //per testare
        settings.list_id = 'd1a1c90e81';
        settings.subject_line = 'Occasioni immobiliari a Berlino';
        settings.title = 'Neswletter del ' + (0, _moment2.default)().format('DD MMMM, YYYY');
        settings.from_name = 'm2Square - Occasioni immobiliari';
        settings.btn_text = 'Dettagli';
        settings.homepage = 'https://www.m2square.eu/it';
        settings.ivdText = ''; //`Il logo IVD è un marchio di qualità per competenza e professionalità.<br><br>m2Square è membro della IVD, la più importante associazione immobiliare tedesca, e si impegna nel rispetto delle sue linee guida.`;
        settings.footerText = '<em>Copyright \xA9 *|CURRENT_YEAR|* *|LIST:COMPANY|*, Tutti i diritti riservati.</em><br>\n*|IFNOT:ARCHIVE_PAGE|* *|LIST:DESCRIPTION|*<br>\n<br>\n<strong>Il nostro indirizzo \xE8:</strong><br>\n*|HTML:LIST_ADDRESS_HTML|* *|END:IF|*<br>\n<br>\nVuoi modificare la ricezione di queste email?<br>\nPuoi&nbsp;<a href="*|UPDATE_PROFILE|*">aggiornare le tue preferenze</a>&nbsp;o&nbsp;<a href="*|UNSUB|*">cancellare l\'iscrizione a questa lista</a>.<br>\n<br>';
        settings.whyText = '<strong>Perch\xE9 m2Square?</strong><br>- perch\xE9 siamo professionisti seri e certificati<br>- perch\xE9 non gonfiamo i prezzi degli immobili<br>- perch\xE9 le nostre commissioni sono chiare, competitive e IVA inclusa<br>- perch\xE9 non richiediamo anticipi ingiustificati<br>- perch\xE9 selezioniamo gli appartamenti da offrirvi';
        settings.browserText = 'Guarda questa email dal tuo browser';
        settings.aphTitle = 'Investimenti sicuri in Residenze per Anziani in Germania';
        settings.aphLink = 'https://www.m2square.eu/it/investire-risparmi-in-modo-sicuro/';
        settings.aphText = 'Rendite garantite per 20 anni. Formula senza pensieri';
        settings.evaluationLink = 'https://www.m2square.eu/it/vendere-appartamento-a-berlino-valutazione-gratuita/';
        settings.evaluationLinkText = 'Iniziamo!';

        settings.evaluationText = '<h1 class="null" style="text-align: center;">Desidera vendere il Suo immobile a Berlino?</h1><h2 class="null" style="text-align: center;">Le offriamo una valutazione gratuita e senza impegno!</h2>\n&nbsp;<h3 class="null">1. Ci indichi le caratteristiche principali</h3><h4 class="null" style="text-align: left;"><span class="mc-toc-title">Compili il nostro modulo online. Ci vogliono solo 2 minuti.</span></h4>\n&nbsp;<h3 class="null">2. Organizziamo una visita</h3><h4 class="null">La contatteremo per concordare una visita dell\'immobile.</h4>\n&nbsp;<h3 class="null">3. Le inviamo la valutazione</h3><h4 class="null">Nel giro di due giorni ricever\xE0 la nostra valutazione per email.</h4>';
      }

      var htmlOggetti = void 0;
      if (oggArray.length === 1) {
        settings.template = 'single';
        var oggetto = _extends({}, oggArray[0]);
        var immagini = [].concat(_toConsumableArray(oggetto.downloadURLs[0]));
        htmlOggetti = '<!doctype html>\n<html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">\n    <head>\n        <!-- NAME: 1:3 COLUMN - FULL WIDTH -->\n        <!--[if gte mso 15]>\n        <xml>\n            <o:OfficeDocumentSettings>\n            <o:AllowPNG/>\n            <o:PixelsPerInch>96</o:PixelsPerInch>\n            </o:OfficeDocumentSettings>\n        </xml>\n        <![endif]-->\n        <meta charset="UTF-8">\n        <meta http-equiv="X-UA-Compatible" content="IE=edge">\n        <meta name="viewport" content="width=device-width, initial-scale=1">\n        <title>*|MC:SUBJECT|*</title>\n        \n    <style type="text/css">\n\t\tp{\n\t\t\tmargin:10px 0;\n\t\t\tpadding:0;\n\t\t}\n\t\ttable{\n\t\t\tborder-collapse:collapse;\n\t\t}\n\t\th1,h2,h3,h4,h5,h6{\n\t\t\tdisplay:block;\n\t\t\tmargin:0;\n\t\t\tpadding:0;\n\t\t}\n\t\timg,a img{\n\t\t\tborder:0;\n\t\t\theight:auto;\n\t\t\toutline:none;\n\t\t\ttext-decoration:none;\n\t\t}\n\t\tbody,#bodyTable,#bodyCell{\n\t\t\theight:100%;\n\t\t\tmargin:0;\n\t\t\tpadding:0;\n\t\t\twidth:100%;\n\t\t}\n\t\t.mcnPreviewText{\n\t\t\tdisplay:none !important;\n\t\t}\n\t\t#outlook a{\n\t\t\tpadding:0;\n\t\t}\n\t\timg{\n\t\t\t-ms-interpolation-mode:bicubic;\n\t\t}\n\t\ttable{\n\t\t\tmso-table-lspace:0pt;\n\t\t\tmso-table-rspace:0pt;\n\t\t}\n\t\t.ReadMsgBody{\n\t\t\twidth:100%;\n\t\t}\n\t\t.ExternalClass{\n\t\t\twidth:100%;\n\t\t}\n\t\tp,a,li,td,blockquote{\n\t\t\tmso-line-height-rule:exactly;\n\t\t}\n\t\ta[href^=tel],a[href^=sms]{\n\t\t\tcolor:inherit;\n\t\t\tcursor:default;\n\t\t\ttext-decoration:none;\n\t\t}\n\t\tp,a,li,td,body,table,blockquote{\n\t\t\t-ms-text-size-adjust:100%;\n\t\t\t-webkit-text-size-adjust:100%;\n\t\t}\n\t\t.ExternalClass,.ExternalClass p,.ExternalClass td,.ExternalClass div,.ExternalClass span,.ExternalClass font{\n\t\t\tline-height:100%;\n\t\t}\n\t\ta[x-apple-data-detectors]{\n\t\t\tcolor:inherit !important;\n\t\t\ttext-decoration:none !important;\n\t\t\tfont-size:inherit !important;\n\t\t\tfont-family:inherit !important;\n\t\t\tfont-weight:inherit !important;\n\t\t\tline-height:inherit !important;\n\t\t}\n\t\t.templateContainer{\n\t\t\tmax-width:600px !important;\n\t\t}\n\t\ta.mcnButton{\n\t\t\tdisplay:block;\n\t\t}\n\t\t.mcnImage,.mcnRetinaImage{\n\t\t\tvertical-align:bottom;\n\t\t}\n\t\t.mcnTextContent{\n\t\t\tword-break:break-word;\n\t\t}\n\t\t.mcnTextContent img{\n\t\t\theight:auto !important;\n\t\t}\n\t\t.mcnDividerBlock{\n\t\t\ttable-layout:fixed !important;\n\t\t}\n\t/*\n\t@tab Page\n\t@section Background Style\n\t@tip Set the background color and top border for your email. You may want to choose colors that match your company\'s branding.\n\t*/\n\t\tbody,#bodyTable{\n\t\t\t/*@editable*/background-color:#FAFAFA;\n\t\t}\n\t/*\n\t@tab Page\n\t@section Background Style\n\t@tip Set the background color and top border for your email. You may want to choose colors that match your company\'s branding.\n\t*/\n\t\t#bodyCell{\n\t\t\t/*@editable*/border-top:0;\n\t\t}\n\t/*\n\t@tab Page\n\t@section Heading 1\n\t@tip Set the styling for all first-level headings in your emails. These should be the largest of your headings.\n\t@style heading 1\n\t*/\n\t\th1{\n\t\t\t/*@editable*/color:#202020;\n\t\t\t/*@editable*/font-family:Helvetica;\n\t\t\t/*@editable*/font-size:26px;\n\t\t\t/*@editable*/font-style:normal;\n\t\t\t/*@editable*/font-weight:bold;\n\t\t\t/*@editable*/line-height:125%;\n\t\t\t/*@editable*/letter-spacing:normal;\n\t\t\t/*@editable*/text-align:left;\n\t\t}\n\t/*\n\t@tab Page\n\t@section Heading 2\n\t@tip Set the styling for all second-level headings in your emails.\n\t@style heading 2\n\t*/\n\t\th2{\n\t\t\t/*@editable*/color:#202020;\n\t\t\t/*@editable*/font-family:Helvetica;\n\t\t\t/*@editable*/font-size:22px;\n\t\t\t/*@editable*/font-style:normal;\n\t\t\t/*@editable*/font-weight:bold;\n\t\t\t/*@editable*/line-height:125%;\n\t\t\t/*@editable*/letter-spacing:normal;\n\t\t\t/*@editable*/text-align:left;\n\t\t}\n\t/*\n\t@tab Page\n\t@section Heading 3\n\t@tip Set the styling for all third-level headings in your emails.\n\t@style heading 3\n\t*/\n\t\th3{\n\t\t\t/*@editable*/color:#202020;\n\t\t\t/*@editable*/font-family:Helvetica;\n\t\t\t/*@editable*/font-size:20px;\n\t\t\t/*@editable*/font-style:normal;\n\t\t\t/*@editable*/font-weight:bold;\n\t\t\t/*@editable*/line-height:125%;\n\t\t\t/*@editable*/letter-spacing:normal;\n\t\t\t/*@editable*/text-align:left;\n\t\t}\n\t/*\n\t@tab Page\n\t@section Heading 4\n\t@tip Set the styling for all fourth-level headings in your emails. These should be the smallest of your headings.\n\t@style heading 4\n\t*/\n\t\th4{\n\t\t\t/*@editable*/color:#202020;\n\t\t\t/*@editable*/font-family:Helvetica;\n\t\t\t/*@editable*/font-size:18px;\n\t\t\t/*@editable*/font-style:normal;\n\t\t\t/*@editable*/font-weight:bold;\n\t\t\t/*@editable*/line-height:125%;\n\t\t\t/*@editable*/letter-spacing:normal;\n\t\t\t/*@editable*/text-align:left;\n\t\t}\n\t/*\n\t@tab Preheader\n\t@section Preheader Style\n\t@tip Set the background color and borders for your email\'s preheader area.\n\t*/\n\t\t#templatePreheader{\n\t\t\t/*@editable*/background-color:#FAFAFA;\n\t\t\t/*@editable*/background-image:none;\n\t\t\t/*@editable*/background-repeat:no-repeat;\n\t\t\t/*@editable*/background-position:center;\n\t\t\t/*@editable*/background-size:cover;\n\t\t\t/*@editable*/border-top:0;\n\t\t\t/*@editable*/border-bottom:0;\n\t\t\t/*@editable*/padding-top:9px;\n\t\t\t/*@editable*/padding-bottom:9px;\n\t\t}\n\t/*\n\t@tab Preheader\n\t@section Preheader Text\n\t@tip Set the styling for your email\'s preheader text. Choose a size and color that is easy to read.\n\t*/\n\t\t#templatePreheader .mcnTextContent,#templatePreheader .mcnTextContent p{\n\t\t\t/*@editable*/color:#656565;\n\t\t\t/*@editable*/font-family:Helvetica;\n\t\t\t/*@editable*/font-size:12px;\n\t\t\t/*@editable*/line-height:150%;\n\t\t\t/*@editable*/text-align:left;\n\t\t}\n\t/*\n\t@tab Preheader\n\t@section Preheader Link\n\t@tip Set the styling for your email\'s preheader links. Choose a color that helps them stand out from your text.\n\t*/\n\t\t#templatePreheader .mcnTextContent a,#templatePreheader .mcnTextContent p a{\n\t\t\t/*@editable*/color:#656565;\n\t\t\t/*@editable*/font-weight:normal;\n\t\t\t/*@editable*/text-decoration:underline;\n\t\t}\n\t/*\n\t@tab Header\n\t@section Header Style\n\t@tip Set the background color and borders for your email\'s header area.\n\t*/\n\t\t#templateHeader{\n\t\t\t/*@editable*/background-color:#FFFFFF;\n\t\t\t/*@editable*/background-image:none;\n\t\t\t/*@editable*/background-repeat:no-repeat;\n\t\t\t/*@editable*/background-position:center;\n\t\t\t/*@editable*/background-size:cover;\n\t\t\t/*@editable*/border-top:0;\n\t\t\t/*@editable*/border-bottom:0;\n\t\t\t/*@editable*/padding-top:9px;\n\t\t\t/*@editable*/padding-bottom:0;\n\t\t}\n\t/*\n\t@tab Header\n\t@section Header Text\n\t@tip Set the styling for your email\'s header text. Choose a size and color that is easy to read.\n\t*/\n\t\t#templateHeader .mcnTextContent,#templateHeader .mcnTextContent p{\n\t\t\t/*@editable*/color:#202020;\n\t\t\t/*@editable*/font-family:Helvetica;\n\t\t\t/*@editable*/font-size:16px;\n\t\t\t/*@editable*/line-height:150%;\n\t\t\t/*@editable*/text-align:left;\n\t\t}\n\t/*\n\t@tab Header\n\t@section Header Link\n\t@tip Set the styling for your email\'s header links. Choose a color that helps them stand out from your text.\n\t*/\n\t\t#templateHeader .mcnTextContent a,#templateHeader .mcnTextContent p a{\n\t\t\t/*@editable*/color:#007C89;\n\t\t\t/*@editable*/font-weight:normal;\n\t\t\t/*@editable*/text-decoration:underline;\n\t\t}\n\t/*\n\t@tab Body\n\t@section Body Style\n\t@tip Set the background color and borders for your email\'s body area.\n\t*/\n\t\t#templateBody{\n\t\t\t/*@editable*/background-color:#FFFFFF;\n\t\t\t/*@editable*/background-image:none;\n\t\t\t/*@editable*/background-repeat:no-repeat;\n\t\t\t/*@editable*/background-position:center;\n\t\t\t/*@editable*/background-size:cover;\n\t\t\t/*@editable*/border-top:0;\n\t\t\t/*@editable*/border-bottom:0;\n\t\t\t/*@editable*/padding-top:9px;\n\t\t\t/*@editable*/padding-bottom:9px;\n\t\t}\n\t/*\n\t@tab Body\n\t@section Body Text\n\t@tip Set the styling for your email\'s body text. Choose a size and color that is easy to read.\n\t*/\n\t\t#templateBody .mcnTextContent,#templateBody .mcnTextContent p{\n\t\t\t/*@editable*/color:#202020;\n\t\t\t/*@editable*/font-family:Helvetica;\n\t\t\t/*@editable*/font-size:16px;\n\t\t\t/*@editable*/line-height:150%;\n\t\t\t/*@editable*/text-align:left;\n\t\t}\n\t/*\n\t@tab Body\n\t@section Body Link\n\t@tip Set the styling for your email\'s body links. Choose a color that helps them stand out from your text.\n\t*/\n\t\t#templateBody .mcnTextContent a,#templateBody .mcnTextContent p a{\n\t\t\t/*@editable*/color:#007C89;\n\t\t\t/*@editable*/font-weight:normal;\n\t\t\t/*@editable*/text-decoration:underline;\n\t\t}\n\t/*\n\t@tab Columns\n\t@section Column Style\n\t@tip Set the background color and borders for your email\'s columns.\n\t*/\n\t\t#templateColumns{\n\t\t\t/*@editable*/background-color:#ffffff;\n\t\t\t/*@editable*/background-image:none;\n\t\t\t/*@editable*/background-repeat:no-repeat;\n\t\t\t/*@editable*/background-position:center;\n\t\t\t/*@editable*/background-size:cover;\n\t\t\t/*@editable*/border-top:0;\n\t\t\t/*@editable*/border-bottom:2px solid #EAEAEA;\n\t\t\t/*@editable*/padding-top:0;\n\t\t\t/*@editable*/padding-bottom:9px;\n\t\t}\n\t/*\n\t@tab Columns\n\t@section Column Text\n\t@tip Set the styling for your email\'s column text. Choose a size and color that is easy to read.\n\t*/\n\t\t#templateColumns .columnContainer .mcnTextContent,#templateColumns .columnContainer .mcnTextContent p{\n\t\t\t/*@editable*/color:#202020;\n\t\t\t/*@editable*/font-family:Helvetica;\n\t\t\t/*@editable*/font-size:16px;\n\t\t\t/*@editable*/line-height:150%;\n\t\t\t/*@editable*/text-align:left;\n\t\t}\n\t/*\n\t@tab Columns\n\t@section Column Link\n\t@tip Set the styling for your email\'s column links. Choose a color that helps them stand out from your text.\n\t*/\n\t\t#templateColumns .columnContainer .mcnTextContent a,#templateColumns .columnContainer .mcnTextContent p a{\n\t\t\t/*@editable*/color:#007C89;\n\t\t\t/*@editable*/font-weight:normal;\n\t\t\t/*@editable*/text-decoration:underline;\n\t\t}\n\t/*\n\t@tab Footer\n\t@section Footer Style\n\t@tip Set the background color and borders for your email\'s footer area.\n\t*/\n\t\t#templateFooter{\n\t\t\t/*@editable*/background-color:#fafafa;\n\t\t\t/*@editable*/background-image:none;\n\t\t\t/*@editable*/background-repeat:no-repeat;\n\t\t\t/*@editable*/background-position:center;\n\t\t\t/*@editable*/background-size:cover;\n\t\t\t/*@editable*/border-top:0;\n\t\t\t/*@editable*/border-bottom:0;\n\t\t\t/*@editable*/padding-top:9px;\n\t\t\t/*@editable*/padding-bottom:9px;\n\t\t}\n\t/*\n\t@tab Footer\n\t@section Footer Text\n\t@tip Set the styling for your email\'s footer text. Choose a size and color that is easy to read.\n\t*/\n\t\t#templateFooter .mcnTextContent,#templateFooter .mcnTextContent p{\n\t\t\t/*@editable*/color:#656565;\n\t\t\t/*@editable*/font-family:Helvetica;\n\t\t\t/*@editable*/font-size:12px;\n\t\t\t/*@editable*/line-height:150%;\n\t\t\t/*@editable*/text-align:center;\n\t\t}\n\t/*\n\t@tab Footer\n\t@section Footer Link\n\t@tip Set the styling for your email\'s footer links. Choose a color that helps them stand out from your text.\n\t*/\n\t\t#templateFooter .mcnTextContent a,#templateFooter .mcnTextContent p a{\n\t\t\t/*@editable*/color:#656565;\n\t\t\t/*@editable*/font-weight:normal;\n\t\t\t/*@editable*/text-decoration:underline;\n\t\t}\n\t@media only screen and (min-width:768px){\n\t\t.templateContainer{\n\t\t\twidth:600px !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\tbody,table,td,p,a,li,blockquote{\n\t\t\t-webkit-text-size-adjust:none !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\tbody{\n\t\t\twidth:100% !important;\n\t\t\tmin-width:100% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.columnWrapper{\n\t\t\tmax-width:100% !important;\n\t\t\twidth:100% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcnRetinaImage{\n\t\t\tmax-width:100% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcnImage{\n\t\t\twidth:100% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcnCartContainer,.mcnCaptionTopContent,.mcnRecContentContainer,.mcnCaptionBottomContent,.mcnTextContentContainer,.mcnBoxedTextContentContainer,.mcnImageGroupContentContainer,.mcnCaptionLeftTextContentContainer,.mcnCaptionRightTextContentContainer,.mcnCaptionLeftImageContentContainer,.mcnCaptionRightImageContentContainer,.mcnImageCardLeftTextContentContainer,.mcnImageCardRightTextContentContainer,.mcnImageCardLeftImageContentContainer,.mcnImageCardRightImageContentContainer{\n\t\t\tmax-width:100% !important;\n\t\t\twidth:100% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcnBoxedTextContentContainer{\n\t\t\tmin-width:100% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcnImageGroupContent{\n\t\t\tpadding:9px !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcnCaptionLeftContentOuter .mcnTextContent,.mcnCaptionRightContentOuter .mcnTextContent{\n\t\t\tpadding-top:9px !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcnImageCardTopImageContent,.mcnCaptionBottomContent:last-child .mcnCaptionBottomImageContent,.mcnCaptionBlockInner .mcnCaptionTopContent:last-child .mcnTextContent{\n\t\t\tpadding-top:18px !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcnImageCardBottomImageContent{\n\t\t\tpadding-bottom:9px !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcnImageGroupBlockInner{\n\t\t\tpadding-top:0 !important;\n\t\t\tpadding-bottom:0 !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcnImageGroupBlockOuter{\n\t\t\tpadding-top:9px !important;\n\t\t\tpadding-bottom:9px !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcnTextContent,.mcnBoxedTextContentColumn{\n\t\t\tpadding-right:18px !important;\n\t\t\tpadding-left:18px !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcnImageCardLeftImageContent,.mcnImageCardRightImageContent{\n\t\t\tpadding-right:18px !important;\n\t\t\tpadding-bottom:0 !important;\n\t\t\tpadding-left:18px !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t\t.mcpreview-image-uploader{\n\t\t\tdisplay:none !important;\n\t\t\twidth:100% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t/*\n\t@tab Mobile Styles\n\t@section Heading 1\n\t@tip Make the first-level headings larger in size for better readability on small screens.\n\t*/\n\t\th1{\n\t\t\t/*@editable*/font-size:22px !important;\n\t\t\t/*@editable*/line-height:125% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t/*\n\t@tab Mobile Styles\n\t@section Heading 2\n\t@tip Make the second-level headings larger in size for better readability on small screens.\n\t*/\n\t\th2{\n\t\t\t/*@editable*/font-size:20px !important;\n\t\t\t/*@editable*/line-height:125% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t/*\n\t@tab Mobile Styles\n\t@section Heading 3\n\t@tip Make the third-level headings larger in size for better readability on small screens.\n\t*/\n\t\th3{\n\t\t\t/*@editable*/font-size:18px !important;\n\t\t\t/*@editable*/line-height:125% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t/*\n\t@tab Mobile Styles\n\t@section Heading 4\n\t@tip Make the fourth-level headings larger in size for better readability on small screens.\n\t*/\n\t\th4{\n\t\t\t/*@editable*/font-size:16px !important;\n\t\t\t/*@editable*/line-height:150% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t/*\n\t@tab Mobile Styles\n\t@section Boxed Text\n\t@tip Make the boxed text larger in size for better readability on small screens. We recommend a font size of at least 16px.\n\t*/\n\t\t.mcnBoxedTextContentContainer .mcnTextContent,.mcnBoxedTextContentContainer .mcnTextContent p{\n\t\t\t/*@editable*/font-size:14px !important;\n\t\t\t/*@editable*/line-height:150% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t/*\n\t@tab Mobile Styles\n\t@section Preheader Visibility\n\t@tip Set the visibility of the email\'s preheader on small screens. You can hide it to save space.\n\t*/\n\t\t#templatePreheader{\n\t\t\t/*@editable*/display:block !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t/*\n\t@tab Mobile Styles\n\t@section Preheader Text\n\t@tip Make the preheader text larger in size for better readability on small screens.\n\t*/\n\t\t#templatePreheader .mcnTextContent,#templatePreheader .mcnTextContent p{\n\t\t\t/*@editable*/font-size:14px !important;\n\t\t\t/*@editable*/line-height:150% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t/*\n\t@tab Mobile Styles\n\t@section Header Text\n\t@tip Make the header text larger in size for better readability on small screens.\n\t*/\n\t\t#templateHeader .mcnTextContent,#templateHeader .mcnTextContent p{\n\t\t\t/*@editable*/font-size:16px !important;\n\t\t\t/*@editable*/line-height:150% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t/*\n\t@tab Mobile Styles\n\t@section Body Text\n\t@tip Make the body text larger in size for better readability on small screens. We recommend a font size of at least 16px.\n\t*/\n\t\t#templateBody .mcnTextContent,#templateBody .mcnTextContent p{\n\t\t\t/*@editable*/font-size:16px !important;\n\t\t\t/*@editable*/line-height:150% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t/*\n\t@tab Mobile Styles\n\t@section Column Text\n\t@tip Make the column text larger in size for better readability on small screens. We recommend a font size of at least 16px.\n\t*/\n\t\t#templateColumns .columnContainer .mcnTextContent,#templateColumns .columnContainer .mcnTextContent p{\n\t\t\t/*@editable*/font-size:16px !important;\n\t\t\t/*@editable*/line-height:150% !important;\n\t\t}\n\n}\t@media only screen and (max-width: 480px){\n\t/*\n\t@tab Mobile Styles\n\t@section Footer Text\n\t@tip Make the footer content text larger in size for better readability on small screens.\n\t*/\n\t\t#templateFooter .mcnTextContent,#templateFooter .mcnTextContent p{\n\t\t\t/*@editable*/font-size:14px !important;\n\t\t\t/*@editable*/line-height:150% !important;\n\t\t}\n\n}</style></head>\n    <body>\n        <!--*|IF:MC_PREVIEW_TEXT|*-->\n        <!--[if !gte mso 9]><!----><span class="mcnPreviewText" style="display:none; font-size:0px; line-height:0px; max-height:0px; max-width:0px; opacity:0; overflow:hidden; visibility:hidden; mso-hide:all;">*|MC_PREVIEW_TEXT|*</span><!--<![endif]-->\n        <!--*|END:IF|*-->\n        <center>\n            <table align="center" border="0" cellpadding="0" cellspacing="0" height="100%" width="100%" id="bodyTable">\n                <tr>\n                    <td align="center" valign="top" id="bodyCell">\n                        <!-- BEGIN TEMPLATE // -->\n                        <table border="0" cellpadding="0" cellspacing="0" width="100%">\n                            <tr>\n                                <td align="center" valign="top" id="templatePreheader">\n                                    <!--[if (gte mso 9)|(IE)]>\n                                    <table align="center" border="0" cellspacing="0" cellpadding="0" width="600" style="width:600px;">\n                                    <tr>\n                                    <td align="center" valign="top" width="600" style="width:600px;">\n                                    <![endif]-->\n                                    <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" class="templateContainer">\n                                        <tr>\n                                            <td valign="top" class="preheaderContainer"><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnTextBlock" style="min-width:100%;">\n    <tbody class="mcnTextBlockOuter">\n        <tr>\n            <td valign="top" class="mcnTextBlockInner" style="padding-top:9px;">\n              \t<!--[if mso]>\n\t\t\t\t<table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">\n\t\t\t\t<tr>\n\t\t\t\t<![endif]-->\n\t\t\t    \n\t\t\t\t<!--[if mso]>\n\t\t\t\t<td valign="top" width="600" style="width:600px;">\n\t\t\t\t<![endif]-->\n                <table align="left" border="0" cellpadding="0" cellspacing="0" style="max-width:100%; min-width:100%;" width="100%" class="mcnTextContentContainer">\n                    <tbody><tr>\n                        \n                        <td valign="top" class="mcnTextContent" style="padding: 0px 18px 9px; text-align: center;">\n                        \n                            <a href="*|ARCHIVE|*" target="_blank">' + settings.browserText + '</a>\n                        </td>\n                    </tr>\n                </tbody></table>\n\t\t\t\t<!--[if mso]>\n\t\t\t\t</td>\n\t\t\t\t<![endif]-->\n                \n\t\t\t\t<!--[if mso]>\n\t\t\t\t</tr>\n\t\t\t\t</table>\n\t\t\t\t<![endif]-->\n            </td>\n        </tr>\n    </tbody>\n</table></td>\n                                        </tr>\n                                    </table>\n                                    <!--[if (gte mso 9)|(IE)]>\n                                    </td>\n                                    </tr>\n                                    </table>\n                                    <![endif]-->\n                                </td>\n                            </tr>\n                            <tr>\n                                <td align="center" valign="top" id="templateHeader">\n                                    <!--[if (gte mso 9)|(IE)]>\n                                    <table align="center" border="0" cellspacing="0" cellpadding="0" width="600" style="width:600px;">\n                                    <tr>\n                                    <td align="center" valign="top" width="600" style="width:600px;">\n                                    <![endif]-->\n                                    <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" class="templateContainer">\n                                        <tr>\n                                            <td valign="top" class="headerContainer"><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnImageBlock" style="min-width:100%;">\n    <tbody class="mcnImageBlockOuter">\n            <tr>\n                <td valign="top" style="padding:9px" class="mcnImageBlockInner">\n                    <table align="left" width="100%" border="0" cellpadding="0" cellspacing="0" class="mcnImageContentContainer" style="min-width:100%;">\n                        <tbody><tr>\n                            <td class="mcnImageContent" valign="top" style="padding-right: 9px; padding-left: 9px; padding-top: 0; padding-bottom: 0; text-align:center;">\n                                \n                                    <a href="' + settings.homepage + '" title="" class="" target="_blank">\n                                        <img align="center" alt="" src="https://gallery.mailchimp.com/ed6049ff183a2d35eb41f16c2/images/33f6de11-5ea6-4513-b065-5a3a8386b061.png" width="564" style="max-width:650px; padding-bottom: 0; display: inline !important; vertical-align: bottom;" class="mcnImage">\n                                    </a>\n                                \n                            </td>\n                        </tr>\n                    </tbody></table>\n                </td>\n            </tr>\n    </tbody>\n</table></td>\n                                        </tr>\n                                    </table>\n                                    <!--[if (gte mso 9)|(IE)]>\n                                    </td>\n                                    </tr>\n                                    </table>\n                                    <![endif]-->\n                                </td>\n                            </tr>\n                            <tr>\n                                <td align="center" valign="top" id="templateBody">\n                                    <!--[if (gte mso 9)|(IE)]>\n                                    <table align="center" border="0" cellspacing="0" cellpadding="0" width="600" style="width:600px;">\n                                    <tr>\n                                    <td align="center" valign="top" width="600" style="width:600px;">\n                                    <![endif]-->\n                                    <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" class="templateContainer">\n                                        <tr>\n                                            <td valign="top" class="bodyContainer"><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnTextBlock" style="min-width:100%;">\n    <tbody class="mcnTextBlockOuter">\n        <tr>\n            <td valign="top" class="mcnTextBlockInner" style="padding-top:9px;">\n              \t<!--[if mso]>\n\t\t\t\t<table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">\n\t\t\t\t<tr>\n\t\t\t\t<![endif]-->\n\t\t\t    \n\t\t\t\t<!--[if mso]>\n\t\t\t\t<td valign="top" width="600" style="width:600px;">\n\t\t\t\t<![endif]-->\n                <table align="left" border="0" cellpadding="0" cellspacing="0" style="max-width:100%; min-width:100%;" width="100%" class="mcnTextContentContainer">\n                    <tbody><tr>\n                        \n                        <td valign="top" class="mcnTextContent" style="padding-top:0; padding-right:18px; padding-bottom:9px; padding-left:18px;">\n                        \n                            <h1 style="text-align: center;">' + settings.subject_line + '</h1>\n\n<div style="text-align: center;"><br>\n<strong>' + settings.title + '</strong><br>\n<br>\n&nbsp;&nbsp;<a href="' + settings.homepage + '" target="_blank">www.m2square.eu</a>&nbsp;-&nbsp;<a href="mailto:info@m2square.eu" target="_blank">info@m2square.eu</a><br>\nTel. +49 30 54482958 - WhatsApp: <a href="https://wa.me/message/XBJ5OH4JPQC4F1" target="_blank">m2square</a></div>\n\n                        </td>\n                    </tr>\n                </tbody></table>\n\t\t\t\t<!--[if mso]>\n\t\t\t\t</td>\n\t\t\t\t<![endif]-->\n                \n\t\t\t\t<!--[if mso]>\n\t\t\t\t</tr>\n\t\t\t\t</table>\n\t\t\t\t<![endif]-->\n            </td>\n        </tr>\n    </tbody>\n</table><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnTextBlock" style="min-width:100%;">\n    <tbody class="mcnTextBlockOuter">\n        <tr>\n            <td valign="top" class="mcnTextBlockInner" style="padding-top:9px;">\n              \t<!--[if mso]>\n\t\t\t\t<table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">\n\t\t\t\t<tr>\n\t\t\t\t<![endif]-->\n\t\t\t    \n\t\t\t\t<!--[if mso]>\n\t\t\t\t<td valign="top" width="600" style="width:600px;">\n\t\t\t\t<![endif]-->\n                <table align="left" border="0" cellpadding="0" cellspacing="0" style="max-width:100%; min-width:100%;" width="100%" class="mcnTextContentContainer">\n                    <tbody><tr>\n                        \n                        <td valign="top" class="mcnTextContent" style="padding-top:0; padding-right:18px; padding-bottom:9px; padding-left:18px;">\n                        \n                            <h1 style="text-align: center;">' + (lingua === 'It' ? oggetto.titolo : oggetto['titolo' + lingua]) + '</h1>\n\n                        </td>\n                    </tr>\n                </tbody></table>\n\t\t\t\t<!--[if mso]>\n\t\t\t\t</td>\n\t\t\t\t<![endif]-->\n                \n\t\t\t\t<!--[if mso]>\n\t\t\t\t</tr>\n\t\t\t\t</table>\n\t\t\t\t<![endif]-->\n            </td>\n        </tr>\n    </tbody>\n</table><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnImageBlock" style="min-width:100%;">\n    <tbody class="mcnImageBlockOuter">\n            <tr>\n                <td valign="top" style="padding:9px" class="mcnImageBlockInner">\n                    <table align="left" width="100%" border="0" cellpadding="0" cellspacing="0" class="mcnImageContentContainer" style="min-width:100%;">\n                        <tbody><tr>\n                            <td class="mcnImageContent" valign="top" style="padding-right: 9px; padding-left: 9px; padding-top: 0; padding-bottom: 0; text-align:center;">\n                                \n                                    <a href="' + oggetto['link' + lingua] + '" title="" class="" target="_blank">\n                                        <img align="center" alt="" src="' + oggetto.downloadURLsCover[0] + '" width="564" style="max-width:1520px; padding-bottom: 0; display: inline !important; vertical-align: bottom;" class="mcnImage">\n                                    </a>\n                                \n                            </td>\n                        </tr>\n                    </tbody></table>\n                </td>\n            </tr>\n    </tbody>\n</table><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnTextBlock" style="min-width:100%;">\n    <tbody class="mcnTextBlockOuter">\n        <tr>\n            <td valign="top" class="mcnTextBlockInner" style="padding-top:9px;">\n              \t<!--[if mso]>\n\t\t\t\t<table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">\n\t\t\t\t<tr>\n\t\t\t\t<![endif]-->\n\t\t\t    \n\t\t\t\t<!--[if mso]>\n\t\t\t\t<td valign="top" width="600" style="width:600px;">\n\t\t\t\t<![endif]-->\n                <table align="left" border="0" cellpadding="0" cellspacing="0" style="max-width:100%; min-width:100%;" width="100%" class="mcnTextContentContainer">\n                    <tbody><tr>\n                        \n                        <td valign="top" class="mcnTextContent" style="padding-top:0; padding-right:18px; padding-bottom:9px; padding-left:18px;">\n                       ' + (lingua !== 'It' ? lingua !== 'En' ? //  ? oggetto.descrizioneDe.substring(
        //      0,
        //      oggetto.descrizioneDe.indexOf(
        //        'Provisionshinweis:'
        //      )
        //    )
        _this.bodyText(oggetto.descrizioneDe, 'Provisionshinweis:') : //  : oggetto.descrizioneEn.substring(
        //      0,
        //      oggetto.descrizioneEn.indexOf(
        //        'Commission note:'
        //      )
        //    )
        _this.bodyText(oggetto.descrizioneEn, 'Commission note:') : //  : oggetto.descrizione.substring(
        //      0,
        //      oggetto.descrizione.indexOf(
        //        'Nota sulla commissione:'
        //      )
        //    )
        _this.bodyText(oggetto.descrizione, 'Nota sulla commissione:')) + '\n                        </td>\n                    </tr>\n                </tbody></table>\n\t\t\t\t<!--[if mso]>\n\t\t\t\t</td>\n\t\t\t\t<![endif]-->\n                \n\t\t\t\t<!--[if mso]>\n\t\t\t\t</tr>\n\t\t\t\t</table>\n\t\t\t\t<![endif]-->\n            </td>\n        </tr>\n    </tbody>\n</table><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnImageGroupBlock">\n    <tbody class="mcnImageGroupBlockOuter">\n        \n            <tr>\n                <td valign="top" style="padding:9px" class="mcnImageGroupBlockInner">\n                    \n                    <table align="left" width="273" border="0" cellpadding="0" cellspacing="0" class="mcnImageGroupContentContainer">\n                            <tbody><tr>\n                                <td class="mcnImageGroupContent" valign="top" style="padding-left: 9px; padding-top: 0; padding-bottom: 0;">\n                                \n                                    <a href="' + oggetto['link' + lingua] + '" title="" class="" target="_blank">\n                                        <img alt="" src="' + immagini[0] + '" width="264" style="max-width:1200px; padding-bottom: 0;" class="mcnImage">\n                                    </a>\n                                \n                                </td>\n                            </tr>\n                        </tbody></table>\n                    \n                    <table align="right" width="273" border="0" cellpadding="0" cellspacing="0" class="mcnImageGroupContentContainer">\n                            <tbody><tr>\n                                <td class="mcnImageGroupContent" valign="top" style="padding-right: 9px; padding-top: 0; padding-bottom: 0;">\n                                \n                                    <a href="' + oggetto['link' + lingua] + '" title="" class="" target="_blank">\n                                        <img alt="" src="' + immagini[1] + '" width="264" style="max-width:1205px; padding-bottom: 0;" class="mcnImage">\n                                    </a>\n                                \n                                </td>\n                            </tr>\n                        </tbody></table>\n                    \n                </td>\n            </tr>\n        \n    </tbody>\n</table><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnTextBlock" style="min-width:100%;">\n    <tbody class="mcnTextBlockOuter">\n        <tr>\n            <td valign="top" class="mcnTextBlockInner" style="padding-top:9px;">\n              \t<!--[if mso]>\n\t\t\t\t<table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">\n\t\t\t\t<tr>\n\t\t\t\t<![endif]-->\n\t\t\t    \n\t\t\t\t<!--[if mso]>\n\t\t\t\t<td valign="top" width="600" style="width:600px;">\n\t\t\t\t<![endif]-->\n                <table align="left" border="0" cellpadding="0" cellspacing="0" style="max-width:100%; min-width:100%;" width="100%" class="mcnTextContentContainer">\n                    <tbody><tr>\n                        \n                        <td valign="top" class="mcnTextContent" style="padding-top:0; padding-right:18px; padding-bottom:9px; padding-left:18px;">\n                        \n                           \n                        </td>\n                    </tr>\n                </tbody></table>\n\t\t\t\t<!--[if mso]>\n\t\t\t\t</td>\n\t\t\t\t<![endif]-->\n                \n\t\t\t\t<!--[if mso]>\n\t\t\t\t</tr>\n\t\t\t\t</table>\n\t\t\t\t<![endif]-->\n            </td>\n        </tr>\n    </tbody>\n</table><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnImageGroupBlock">\n    <tbody class="mcnImageGroupBlockOuter">\n        \n            <tr>\n                <td valign="top" style="padding:9px" class="mcnImageGroupBlockInner">\n                    \n                    <table align="left" width="273" border="0" cellpadding="0" cellspacing="0" class="mcnImageGroupContentContainer">\n                            <tbody><tr>\n                                <td class="mcnImageGroupContent" valign="top" style="padding-left: 9px; padding-top: 0; padding-bottom: 0;">\n                                \n                                    <a href="' + oggetto['link' + lingua] + '" title="" class="" target="_blank">\n                                        <img alt="" src="' + immagini[2] + '" width="264" style="max-width:1200px; padding-bottom: 0;" class="mcnImage">\n                                    </a>\n                                \n                                </td>\n                            </tr>\n                        </tbody></table>\n                    \n                    <table align="right" width="273" border="0" cellpadding="0" cellspacing="0" class="mcnImageGroupContentContainer">\n                            <tbody><tr>\n                                <td class="mcnImageGroupContent" valign="top" style="padding-right: 9px; padding-top: 0; padding-bottom: 0;">\n                                \n                                    <a href="' + oggetto['link' + lingua] + '" title="" class="" target="_blank">\n                                        <img alt="" src="' + immagini[3] + '" width="264" style="max-width:1204px; padding-bottom: 0;" class="mcnImage">\n                                    </a>\n                                \n                                </td>\n                            </tr>\n                        </tbody></table>\n                    \n                </td>\n            </tr>\n        \n    </tbody>\n</table><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnTextBlock" style="min-width:100%;">\n    <tbody class="mcnTextBlockOuter">\n        <tr>\n            <td valign="top" class="mcnTextBlockInner" style="padding-top:9px;">\n              \t<!--[if mso]>\n\t\t\t\t<table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">\n\t\t\t\t<tr>\n\t\t\t\t<![endif]-->\n\t\t\t    \n\t\t\t\t<!--[if mso]>\n\t\t\t\t<td valign="top" width="600" style="width:600px;">\n\t\t\t\t<![endif]-->\n                <table align="left" border="0" cellpadding="0" cellspacing="0" style="max-width:100%; min-width:100%;" width="100%" class="mcnTextContentContainer">\n                    <tbody><tr>\n                        \n                        <td valign="top" class="mcnTextContent" style="padding-top:0; padding-right:18px; padding-bottom:9px; padding-left:18px;">\n                        \n                        </td>\n                    </tr>\n                </tbody></table>\n\t\t\t\t<!--[if mso]>\n\t\t\t\t</td>\n\t\t\t\t<![endif]-->\n                \n\t\t\t\t<!--[if mso]>\n\t\t\t\t</tr>\n\t\t\t\t</table>\n\t\t\t\t<![endif]-->\n            </td>\n        </tr>\n    </tbody>\n</table><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnButtonBlock" style="min-width:100%;">\n    <tbody class="mcnButtonBlockOuter">\n        <tr>\n            <td style="padding-top:0; padding-right:18px; padding-bottom:18px; padding-left:18px;" valign="top" align="center" class="mcnButtonBlockInner">\n                <table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnButtonContentContainer" style="border-collapse: separate !important;border-radius: 3px;background-color: #910000;">\n                    <tbody>\n                        <tr>\n                            <td align="center" valign="middle" class="mcnButtonContent" style="font-family: Arial; font-size: 16px; padding: 15px;">\n                                <a class="mcnButton " title="Scopri di pi\xF9" href="' + oggetto['link' + lingua] + '" target="_blank" style="font-weight: bold;letter-spacing: normal;line-height: 100%;text-align: center;text-decoration: none;color: #FFFFFF;">' + settings.btn_text + '</a>\n                            </td>\n                        </tr>\n                    </tbody>\n                </table>\n            </td>\n        </tr>\n    </tbody>\n</table></td>\n                                        </tr>\n                                    </table>\n                                    <!--[if (gte mso 9)|(IE)]>\n                                    </td>\n                                    </tr>\n                                    </table>\n                                    <![endif]-->\n                                </td>\n                            </tr>\n                            <tr>\n                                <td align="center" valign="top" id="templateColumns">\n                                    <table border="0" cellpadding="0" cellspacing="0" width="100%" class="templateContainer">\n                                        <tr>\n                                            <td valign="top">\n                                                <!--[if (gte mso 9)|(IE)]>\n                                                <table align="center" border="0" cellspacing="0" cellpadding="0" width="600" style="width:600px;">\n                                                <tr>\n                                                <td align="center" valign="top" width="200" style="width:200px;">\n                                                <![endif]-->\n                                                <table align="left" border="0" cellpadding="0" cellspacing="0" width="200" class="columnWrapper">\n                                                    <tr>\n                                                        <td valign="top" class="columnContainer"></td>\n                                                    </tr>\n                                                </table>\n                                                <!--[if (gte mso 9)|(IE)]>\n                                                </td>\n                                                <td align="center" valign="top" width="200" style="width:200px;">\n                                                <![endif]-->\n                                                <table align="left" border="0" cellpadding="0" cellspacing="0" width="200" class="columnWrapper">\n                                                    <tr>\n                                                        <td valign="top" class="columnContainer"></td>\n                                                    </tr>\n                                                </table>\n                                                <!--[if (gte mso 9)|(IE)]>\n                                                </td>\n                                                <td align="center" valign="top" width="200" style="width:200px;">\n                                                <![endif]-->\n                                                <table align="left" border="0" cellpadding="0" cellspacing="0" width="200" class="columnWrapper">\n                                                    <tr>\n                                                        <td valign="top" class="columnContainer"></td>\n                                                    </tr>\n                                                </table>\n                                                <!--[if (gte mso 9)|(IE)]>\n                                                </td>\n                                                </tr>\n                                                </table>\n                                                <![endif]-->\n                                            </td>\n                                        </tr>\n                                    </table>\n                                </td>\n                            </tr>\n                            <tr>\n                                <td align="center" valign="top" id="templateFooter">\n                                    <!--[if (gte mso 9)|(IE)]>\n                                    <table align="center" border="0" cellspacing="0" cellpadding="0" width="600" style="width:600px;">\n                                    <tr>\n                                    <td align="center" valign="top" width="600" style="width:600px;">\n                                    <![endif]-->\n                                    <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" class="templateContainer">\n                                        <tr>\n                                            <td valign="top" class="footerContainer"><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnTextBlock" style="min-width:100%;">\n    <tbody class="mcnTextBlockOuter">\n        <tr>\n            <td valign="top" class="mcnTextBlockInner" style="padding-top:9px;">\n              \t<!--[if mso]>\n\t\t\t\t<table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">\n\t\t\t\t<tr>\n\t\t\t\t<![endif]-->\n\t\t\t    \n\t\t\t\t<!--[if mso]>\n\t\t\t\t<td valign="top" width="600" style="width:600px;">\n\t\t\t\t<![endif]-->\n                <table align="left" border="0" cellpadding="0" cellspacing="0" style="max-width:100%; min-width:100%;" width="100%" class="mcnTextContentContainer">\n                    <tbody><tr>\n                        \n                        <td valign="top" class="mcnTextContent" style="padding: 0px 18px 9px;color: #FFFFFF;font-family: &quot;Lucida Sans Unicode&quot;, &quot;Lucida Grande&quot;, sans-serif;text-align: left;">\n                        \n                            ' + settings.evaluationText + '\n\n                        </td>\n                    </tr>\n                </tbody></table>\n\t\t\t\t<!--[if mso]>\n\t\t\t\t</td>\n\t\t\t\t<![endif]-->\n                \n\t\t\t\t<!--[if mso]>\n\t\t\t\t</tr>\n\t\t\t\t</table>\n\t\t\t\t<![endif]-->\n            </td>\n        </tr>\n    </tbody>\n</table><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnButtonBlock" style="min-width:100%;">\n    <tbody class="mcnButtonBlockOuter">\n        <tr>\n            <td style="padding-top:0; padding-right:18px; padding-bottom:18px; padding-left:18px;" valign="top" align="center" class="mcnButtonBlockInner">\n                <table border="0" cellpadding="0" cellspacing="0" class="mcnButtonContentContainer" style="border-collapse: separate !important;border-radius: 3px;background-color: #910000;">\n                    <tbody>\n                        <tr>\n                            <td align="center" valign="middle" class="mcnButtonContent" style="font-family: Arial; font-size: 16px; padding: 15px;">\n                                <a class="mcnButton " title="Iniziamo!" href="' + settings.evaluationLink + '" target="_blank" style="font-weight: bold;letter-spacing: normal;line-height: 100%;text-align: center;text-decoration: none;color: #FFFFFF;">' + settings.evaluationLinkText + '</a>\n                            </td>\n                        </tr>\n                    </tbody>\n                </table>\n            </td>\n        </tr>\n    </tbody>\n</table><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnDividerBlock" style="min-width:100%;">\n    <tbody class="mcnDividerBlockOuter">\n        <tr>\n            <td class="mcnDividerBlockInner" style="min-width:100%; padding:18px;">\n                <table class="mcnDividerContent" border="0" cellpadding="0" cellspacing="0" width="100%" style="min-width: 100%;border-top: 5px solid #EAEAEA;">\n                    <tbody><tr>\n                        <td>\n                            <span></span>\n                        </td>\n                    </tr>\n                </tbody></table>\n<!--            \n                <td class="mcnDividerBlockInner" style="padding: 18px;">\n                <hr class="mcnDividerContent" style="border-bottom-color:none; border-left-color:none; border-right-color:none; border-bottom-width:0; border-left-width:0; border-right-width:0; margin-top:0; margin-right:0; margin-bottom:0; margin-left:0;" />\n-->\n            </td>\n        </tr>\n    </tbody>\n</table><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnTextBlock" style="min-width:100%;">\n    <tbody class="mcnTextBlockOuter">\n        <tr>\n            <td valign="top" class="mcnTextBlockInner" style="padding-top:9px;">\n              \t<!--[if mso]>\n\t\t\t\t<table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">\n\t\t\t\t<tr>\n\t\t\t\t<![endif]-->\n\t\t\t    \n\t\t\t\t<!--[if mso]>\n\t\t\t\t<td valign="top" width="600" style="width:600px;">\n\t\t\t\t<![endif]-->\n                <table align="left" border="0" cellpadding="0" cellspacing="0" style="max-width:100%; min-width:100%;" width="100%" class="mcnTextContentContainer">\n                    <tbody><tr>\n                        \n                        <td valign="top" class="mcnTextContent" style="padding: 0px 18px 9px;color: #FFFFFF;font-family: &quot;Lucida Sans Unicode&quot;, &quot;Lucida Grande&quot;, sans-serif;text-align: left;">\n                        \n                            <h1 class="null" style="text-align: center;">' + settings.aphTitle + '</h1>\n\n<h2 class="null" style="text-align: center;">' + settings.aphText + '</h2>\n\n                        </td>\n                    </tr>\n                </tbody></table>\n\t\t\t\t<!--[if mso]>\n\t\t\t\t</td>\n\t\t\t\t<![endif]-->\n                \n\t\t\t\t<!--[if mso]>\n\t\t\t\t</tr>\n\t\t\t\t</table>\n\t\t\t\t<![endif]-->\n            </td>\n        </tr>\n    </tbody>\n</table><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnImageCardBlock">\n    <tbody class="mcnImageCardBlockOuter">\n        <tr>\n            <td class="mcnImageCardBlockInner" valign="top" style="padding-top:9px; padding-right:18px; padding-bottom:9px; padding-left:18px;">\n                \n<table align="right" border="0" cellpadding="0" cellspacing="0" class="mcnImageCardBottomContent" width="100%" style="background-color: #404040;">\n    <tbody><tr>\n        <td class="mcnImageCardBottomImageContent" align="left" valign="top" style="padding-top:0px; padding-right:0px; padding-bottom:0; padding-left:0px;">\n        \n            \n            <a href="' + settings.aphLink + '" title="" class="" target="_blank">\n            \n\n            <img alt="" src="https://gallery.mailchimp.com/ed6049ff183a2d35eb41f16c2/images/5a998e8f-08b7-4205-9679-cf97ef685173.jpg" width="564" style="max-width:600px;" class="mcnImage">\n            </a>\n        \n        </td>\n    </tr>\n    <tr>\n        <td class="mcnTextContent" valign="top" style="padding: 9px 18px;color: #F2F2F2;font-family: Helvetica;font-size: 14px;font-weight: normal;text-align: center;" width="546">\n            \n        </td>\n    </tr>\n</tbody></table>\n\n\n\n\n            </td>\n        </tr>\n    </tbody>\n</table><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnDividerBlock" style="min-width:100%;">\n    <tbody class="mcnDividerBlockOuter">\n        <tr>\n            <td class="mcnDividerBlockInner" style="min-width:100%; padding:18px;">\n                <table class="mcnDividerContent" border="0" cellpadding="0" cellspacing="0" width="100%" style="min-width: 100%;border-top: 2px solid #EAEAEA;">\n                    <tbody><tr>\n                        <td>\n                            <span></span>\n                        </td>\n                    </tr>\n                </tbody></table>\n<!--            \n                <td class="mcnDividerBlockInner" style="padding: 18px;">\n                <hr class="mcnDividerContent" style="border-bottom-color:none; border-left-color:none; border-right-color:none; border-bottom-width:0; border-left-width:0; border-right-width:0; margin-top:0; margin-right:0; margin-bottom:0; margin-left:0;" />\n-->\n            </td>\n        </tr>\n    </tbody>\n</table><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnTextBlock" style="min-width:100%;">\n    <tbody class="mcnTextBlockOuter">\n        <tr>\n            <td valign="top" class="mcnTextBlockInner" style="padding-top:9px;">\n              \t<!--[if mso]>\n\t\t\t\t<table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">\n\t\t\t\t<tr>\n\t\t\t\t<![endif]-->\n\t\t\t    \n\t\t\t\t<!--[if mso]>\n\t\t\t\t<td valign="top" width="600" style="width:600px;">\n\t\t\t\t<![endif]-->\n                <table align="left" border="0" cellpadding="0" cellspacing="0" style="max-width:100%; min-width:100%;" width="100%" class="mcnTextContentContainer">\n                    <tbody><tr>\n                        \n                        <td valign="top" class="mcnTextContent" style="padding-top:0; padding-right:18px; padding-bottom:9px; padding-left:18px;">\n                        \n                            ' + settings.whyText + '\n                        </td>\n                    </tr>\n                </tbody></table>\n\t\t\t\t<!--[if mso]>\n\t\t\t\t</td>\n\t\t\t\t<![endif]-->\n                \n\t\t\t\t<!--[if mso]>\n\t\t\t\t</tr>\n\t\t\t\t</table>\n\t\t\t\t<![endif]-->\n            </td>\n        </tr>\n    </tbody>\n</table><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnCaptionBlock">\n    <tbody class="mcnCaptionBlockOuter">\n        <tr>\n            <td class="mcnCaptionBlockInner" valign="top" style="padding:9px;">\n                \n\n<table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnImageGroupBlock" style="border-collapse: collapse;mso-table-lspace: 0pt;mso-table-rspace: 0pt;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;">\n    <tbody class="mcnImageGroupBlockOuter">\n        \n            <tr>\n                <td valign="top" style="padding: 9px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;" class="mcnImageGroupBlockInner">\n                    \n                    <table align="left" width="273" border="0" cellpadding="0" cellspacing="0" class="mcnImageGroupContentContainer" style="border-collapse: collapse;mso-table-lspace: 0pt;mso-table-rspace: 0pt;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;">\n                            <tbody><tr>\n                                <td class="mcnImageGroupContent" valign="top" style="padding-left: 9px;padding-top: 0;padding-bottom: 0;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;">\n                                \n                                    <a href="mailto:annalisa.fornari@m2square.eu" title="" class="" target="_blank" style="mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;">\n                                        <img alt="" src="https://mcusercontent.com/ed6049ff183a2d35eb41f16c2/images/a716c862-d02a-4e55-8c81-395f01d3779f.jpg" width="264" style="max-width: 1200px;padding-bottom: 0;border: 0;height: auto;outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;vertical-align: bottom;" class="mcnImage">\n                                    </a>\n                                \n                                </td>\n                            </tr>\n                        </tbody></table>\n                    \n                    <table align="right" width="273" border="0" cellpadding="0" cellspacing="0" class="mcnImageGroupContentContainer" style="border-collapse: collapse;mso-table-lspace: 0pt;mso-table-rspace: 0pt;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;">\n                            <tbody><tr>\n                                <td class="mcnImageGroupContent" valign="top" style="padding-right: 9px;padding-top: 0;padding-bottom: 0;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%;">\n                                \n                                    \n                                        <img alt="" src="https://gallery.mailchimp.com/ed6049ff183a2d35eb41f16c2/images/a6bfb36e-7b1c-421f-9016-459e0f052a29.jpg" width="264" style="max-width: 2821px;padding-bottom: 0;border: 0;height: auto;outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;vertical-align: bottom;" class="mcnImage">\n                                    \n                                \n                                </td>\n                            </tr>\n                        </tbody></table>\n                    \n                </td>\n            </tr>\n        \n    </tbody>\n</table><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnDividerBlock" style="min-width:100%;">\n    <tbody class="mcnDividerBlockOuter">\n        <tr>\n            <td class="mcnDividerBlockInner" style="min-width: 100%; padding: 10px 18px 25px;">\n                <table class="mcnDividerContent" border="0" cellpadding="0" cellspacing="0" width="100%" style="min-width: 100%;border-top: 2px solid #EEEEEE;">\n                    <tbody><tr>\n                        <td>\n                            <span></span>\n                        </td>\n                    </tr>\n                </tbody></table>\n<!--            \n                <td class="mcnDividerBlockInner" style="padding: 18px;">\n                <hr class="mcnDividerContent" style="border-bottom-color:none; border-left-color:none; border-right-color:none; border-bottom-width:0; border-left-width:0; border-right-width:0; margin-top:0; margin-right:0; margin-bottom:0; margin-left:0;" />\n-->\n            </td>\n        </tr>\n    </tbody>\n</table><table border="0" cellpadding="0" cellspacing="0" width="100%" class="mcnTextBlock" style="min-width:100%;">\n    <tbody class="mcnTextBlockOuter">\n        <tr>\n            <td valign="top" class="mcnTextBlockInner" style="padding-top:9px;">\n              \t<!--[if mso]>\n\t\t\t\t<table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">\n\t\t\t\t<tr>\n\t\t\t\t<![endif]-->\n\t\t\t    \n\t\t\t\t<!--[if mso]>\n\t\t\t\t<td valign="top" width="600" style="width:600px;">\n\t\t\t\t<![endif]-->\n                <table align="left" border="0" cellpadding="0" cellspacing="0" style="max-width:100%; min-width:100%;" width="100%" class="mcnTextContentContainer">\n                    <tbody><tr>\n                        \n                        <td valign="top" class="mcnTextContent" style="padding-top:0; padding-right:18px; padding-bottom:9px; padding-left:18px;">\n                        \n                            ' + settings.footerText + '\n*|IF:REWARDS|* *|HTML:REWARDS|* *|END:IF|*\n                        </td>\n                    </tr>\n                </tbody></table>\n\t\t\t\t<!--[if mso]>\n\t\t\t\t</td>\n\t\t\t\t<![endif]-->\n                \n\t\t\t\t<!--[if mso]>\n\t\t\t\t</tr>\n\t\t\t\t</table>\n\t\t\t\t<![endif]-->\n            </td>\n        </tr>\n    </tbody>\n</table></td>\n                                        </tr>\n                                    </table>\n                                    <!--[if (gte mso 9)|(IE)]>\n                                    </td>\n                                    </tr>\n                                    </table>\n                                    <![endif]-->\n                                </td>\n                            </tr>\n                        </table>\n                        <!-- // END TEMPLATE -->\n                    </td>\n                </tr>\n            </table>\n        </center>\n    </body>\n</html>\n';
      } else {
        settings.template = 'multiple';
        htmlOggetti = '<tr>\n                <td align="center" valign="top" id="templateColumns">\n                  <table\n                    border="0"\n                    cellpadding="0"\n                    cellspacing="0"\n                    width="100%"\n                    class="templateContainer"\n                  >\n                    <tr>\n                      <td valign="top">\n                      ' + oggArray.map(function (oggetto) {
          return '<table\n                          align="left"\n                          border="0"\n                          cellpadding="0"\n                          cellspacing="0"\n                          width="200"\n                          class="columnWrapper"\n                        >\n                          <tr>\n                            <td valign="top" class="columnContainer">\n                              <table\n                                border="0"\n                                cellpadding="0"\n                                cellspacing="0"\n                                width="100%"\n                                class="mcnCaptionBlock"\n                              >\n                                <tbody class="mcnCaptionBlockOuter">\n                                  <tr>\n                                    <td\n                                      class="mcnCaptionBlockInner"\n                                      valign="top"\n                                      style="padding: 9px;"\n                                    >\n                                      <table\n                                        align="left"\n                                        border="0"\n                                        cellpadding="0"\n                                        cellspacing="0"\n                                        class="mcnCaptionBottomContent"\n                                      >\n                                        <tbody>\n                                          <tr>\n                                            <td\n                                              class="mcnCaptionBottomImageContent"\n                                              align="center"\n                                              valign="top"\n                                              style="padding: 0 9px 9px 9px;"\n                                            >\n                                              <a\n                                                href=' + oggetto['link' + lingua] + '\n                                                title=""\n                                                class=""\n                                                target="_blank"\n                                              >\n                                                <img\n                                                  alt=""\n                                                  src="' + oggetto.downloadURLsCover[0] + '"\n                                                  width="164"\n                                                  style="max-width: 1024px;"\n                                                  class="mcnImage"\n                                                />\n                                              </a>\n                                            </td>\n                                          </tr>\n                                          <tr>\n                                            <td\n                                              class="mcnTextContent"\n                                              valign="top"\n                                              style="padding: 0 9px 0 9px;"\n                                              width="164"\n                                            >\n                                              <strong\n                                                >' + (lingua !== 'It' ? oggetto['titolo' + lingua] : oggetto.titolo) + '\n                                            </strong\n                                              ><br />\n                                              ' + oggetto.m2 + ' m2 -\n                                              ' + (0, _numeral2.default)(oggetto.kaufpreis / 100).format('0,0[.]00 $') + '<br />\n                                              ID: ' + oggetto.rifId + '<br />\n                                              ' + oggetto.quartiere + '\n                                            </td>\n                                          </tr>\n                                        </tbody>\n                                      </table>\n                                    </td>\n                                  </tr>\n                                </tbody>\n                              </table>\n                              <table\n                                border="0"\n                                cellpadding="0"\n                                cellspacing="0"\n                                width="100%"\n                                class="mcnButtonBlock"\n                                style="min-width: 100%;"\n                              >\n                                <tbody class="mcnButtonBlockOuter">\n                                  <tr>\n                                    <td\n                                      style="\n                                        padding-top: 0;\n                                        padding-right: 18px;\n                                        padding-bottom: 18px;\n                                        padding-left: 18px;\n                                      "\n                                      valign="top"\n                                      align="center"\n                                      class="mcnButtonBlockInner"\n                                    >\n                                      <table\n                                        border="0"\n                                        cellpadding="0"\n                                        cellspacing="0"\n                                        width="100%"\n                                        class="mcnButtonContentContainer"\n                                        style="\n                                          border-collapse: separate !important;\n                                          border-radius: 3px;\n                                          background-color: #910000;\n                                        "\n                                      >\n                                        <tbody>\n                                          <tr>\n                                            <td\n                                              align="center"\n                                              valign="middle"\n                                              class="mcnButtonContent"\n                                              style="\n                                                font-family: Arial;\n                                                font-size: 16px;\n                                                padding: 15px;\n                                              "\n                                            >\n                                              <a\n                                                class="mcnButton"\n                                                title="Dettagli"\n                                                href="' + oggetto['link' + lingua] + '"\n                                                target="_blank"\n                                                style="\n                                                  font-weight: bold;\n                                                  letter-spacing: normal;\n                                                  line-height: 100%;\n                                                  text-align: center;\n                                                  text-decoration: none;\n                                                  color: #ffffff;\n                                                "\n                                                >' + settings.btn_text + '</a\n                                              >\n                                            </td>\n                                          </tr>\n                                        </tbody>\n                                      </table>\n                                    </td>\n                                  </tr>\n                                </tbody>\n                              </table>\n                              <table\n                                border="0"\n                                cellpadding="0"\n                                cellspacing="0"\n                                width="100%"\n                                class="mcnDividerBlock"\n                                style="min-width: 100%;"\n                              >\n                                <tbody class="mcnDividerBlockOuter">\n                                  <tr>\n                                    <td\n                                      class="mcnDividerBlockInner"\n                                      style="min-width: 100%; padding: 18px;"\n                                    >\n                                      <table\n                                        class="mcnDividerContent"\n                                        border="0"\n                                        cellpadding="0"\n                                        cellspacing="0"\n                                        width="100%"\n                                        style="\n                                          min-width: 100%;\n                                          border-top: 2px solid #eaeaea;\n                                        "\n                                      >\n                                        <tbody>\n                                          <tr>\n                                            <td>\n                                              <span></span>\n                                            </td>\n                                          </tr>\n                                        </tbody>\n                                      </table>\n                                      \n                                    </td>\n                                  </tr>\n                                </tbody>\n                              </table>\n                            </td>\n                          </tr>\n                        </table>';
        }).join(' ') + '  \n\n                      </td>\n                    </tr>\n                  </table>\n                </td>\n              </tr>';
      }

      _axios2.default.post('https://is24api.herokuapp.com/newsletter', {
        htmlOggetti: htmlOggetti,
        settings: settings
      }).then(function (response) {
        console.log(response);

        _this.props.startEditNewsletter(newsletter.id, _defineProperty({}, 'mailchimpId' + lingua, { id: response.data.id }));
      }).catch(function (err) {
        return console.log(err);
      }).finally(_this.setState({ spinner: false }));

      // console.log(htmlOggetti);
    };

    _this.sendTestEmail = function (campaignId) {
      _axios2.default.post('https://is24api.herokuapp.com/testemail', { campaignId: campaignId }).then(function (response) {
        return console.log(response);
      });
    };

    _this.sendCampaignEmail = function (campaign, field) {
      _axios2.default.post('https://is24api.herokuapp.com/sendemail', {
        campaignId: campaign.id
      }).then(function (response) {
        console.log(response);
        if (response.status === 200) {
          var dataSentNewsletter = (0, _moment2.default)().valueOf();
          _this.props.startEditNewsletter(_this.props.newsletter.id, _defineProperty({}, field, _extends({}, campaign, {
            dataSentNewsletter: dataSentNewsletter,
            sent: true
          })));
        }
      });
    };

    _this.state = { spinner: false };
    return _this;
  }

  _createClass(MailchimpAPI, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          newsletter = _props.newsletter;

      var btnColorDe = newsletter.mailchimpIdDe ? 'green' : 'blue';
      var btnColorEn = newsletter.mailchimpIdEn ? 'green' : 'blue';
      var btnColorIt = newsletter.mailchimpIdIt ? 'green' : 'blue';

      return _react2.default.createElement(
        'div',
        null,
        ' ',
        this.state.spinner ? _react2.default.createElement(
          'div',
          { className: 'progress' },
          _react2.default.createElement('div', { className: 'indeterminate' })
        ) : _react2.default.createElement(
          'div',
          { className: 'container section' },
          _react2.default.createElement(
            'ul',
            { className: 'collection  s12 m6' },
            _react2.default.createElement(_collectionItem2.default, {
              label: 'Crea Newsletter',
              action: function action() {
                _this2.sendNewsletter('It');
              },
              icon: 'send',
              btnColor: btnColorIt
            }),
            newsletter.mailchimpIdIt && _react2.default.createElement(_collectionItem2.default, {
              label: 'Test Email ' + t('italian'),
              action: function action() {
                _this2.sendTestEmail(newsletter.mailchimpIdIt.id);
              },
              icon: 'send',
              btnColor: btnColorIt
            }),
            newsletter.mailchimpIdIt ? !newsletter.mailchimpIdIt.sent ? _react2.default.createElement(_collectionItem2.default, {
              label: 'Invia Newsletter',
              action: function action() {
                _this2.sendCampaignEmail(newsletter.mailchimpIdIt, 'mailchimpIdIt');
              },
              icon: 'send',
              btnColor: btnColorIt
            }) : _react2.default.createElement(_collectionItem2.default, {
              label: t('newsletter_already_sent') + ' ' + (0, _moment2.default)(newsletter.mailchimpIdIt.dataSentNewsletter).format('DD MMMM, YYYY')
            }) : ''
          ),
          _react2.default.createElement(
            'ul',
            { className: 'collection  s12 m6' },
            _react2.default.createElement(_collectionItem2.default, {
              label: 'Newsletter herstellen',
              action: function action() {
                _this2.sendNewsletter('De');
              },
              icon: 'send',
              btnColor: btnColorDe
            }),
            newsletter.mailchimpIdDe && _react2.default.createElement(_collectionItem2.default, {
              label: 'Test Email ' + t('german'),
              action: function action() {
                _this2.sendTestEmail(newsletter.mailchimpIdDe.id);
              },
              icon: 'send',
              btnColor: btnColorDe
            }),
            newsletter.mailchimpIdDe ? !newsletter.mailchimpIdDe.sent ? _react2.default.createElement(_collectionItem2.default, {
              label: 'Newsletter senden',
              action: function action() {
                _this2.sendCampaignEmail(newsletter.mailchimpIdDe, 'mailchimpIdDe');
              },
              icon: 'send',
              btnColor: btnColorDe
            }) : _react2.default.createElement(_collectionItem2.default, {
              label: t('newsletter_already_sent') + ' ' + (0, _moment2.default)(newsletter.mailchimpIdDe.dataSentNewsletter).format('DD MMMM, YYYY')
            }) : ''
          ),
          _react2.default.createElement(
            'ul',
            { className: 'collection  s12 m6' },
            _react2.default.createElement(_collectionItem2.default, {
              label: 'Build Newsletter',
              action: function action() {
                _this2.sendNewsletter('En');
              },
              icon: 'send',
              btnColor: btnColorEn
            }),
            newsletter.mailchimpIdEn && _react2.default.createElement(_collectionItem2.default, {
              label: 'Test Email ' + t('english'),
              action: function action() {
                _this2.sendTestEmail(newsletter.mailchimpIdEn.id);
              },
              icon: 'send',
              btnColor: btnColorEn
            }),
            newsletter.mailchimpIdEn ? !newsletter.mailchimpIdEn.sent ? _react2.default.createElement(_collectionItem2.default, {
              label: 'Send Newsletter Campaign',
              action: function action() {
                _this2.sendCampaignEmail(newsletter.mailchimpIdEn, 'mailchimpIdEn');
              },
              icon: 'send',
              btnColor: btnColorEn
            }) : _react2.default.createElement(_collectionItem2.default, {
              label: t('newsletter_already_sent') + ' ' + (0, _moment2.default)(newsletter.mailchimpIdEn.dataSentNewsletter).format('DD MMMM, YYYY')
            }) : ''
          )
        )
      );
    }
  }]);

  return MailchimpAPI;
}(_react2.default.Component);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    startEditNewsletter: function startEditNewsletter(id, newsletter) {
      return dispatch(_configureStore.storeActions.find(function (action) {
        return action.label === 'newsletters';
      }).startEditAction(id, newsletter));
    }
  };
};

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)((0, _reactI18next.withTranslation)()(MailchimpAPI));

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _configureStore = __webpack_require__(14);

var _ClientiForm = __webpack_require__(607);

var _ClientiForm2 = _interopRequireDefault(_ClientiForm);

var _DealForm = __webpack_require__(573);

var _DealForm2 = _interopRequireDefault(_DealForm);

var _OggettoForm = __webpack_require__(611);

var _OggettoForm2 = _interopRequireDefault(_OggettoForm);

var _EvaluationForm = __webpack_require__(614);

var _EvaluationForm2 = _interopRequireDefault(_EvaluationForm);

var _NewsletterForm = __webpack_require__(617);

var _NewsletterForm2 = _interopRequireDefault(_NewsletterForm);

var _FatturaForm = __webpack_require__(608);

var _FatturaForm2 = _interopRequireDefault(_FatturaForm);

var _FirmaForm = __webpack_require__(606);

var _FirmaForm2 = _interopRequireDefault(_FirmaForm);

var _UserForm = __webpack_require__(605);

var _UserForm2 = _interopRequireDefault(_UserForm);

var _LeadForm = __webpack_require__(612);

var _LeadForm2 = _interopRequireDefault(_LeadForm);

var _OfferedPropertiesForm = __webpack_require__(613);

var _OfferedPropertiesForm2 = _interopRequireDefault(_OfferedPropertiesForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddPage = exports.AddPage = function (_React$Component) {
  _inherits(AddPage, _React$Component);

  function AddPage(props) {
    _classCallCheck(this, AddPage);

    var _this = _possibleConstructorReturn(this, (AddPage.__proto__ || Object.getPrototypeOf(AddPage)).call(this, props));

    _this.changeHandler = function (e) {
      return _this.setState(_defineProperty({}, e.target.name, e.target.value));
    };

    _this.onSubmit = function (item) {
      _this.props.startAddAction(item);
      _this.props.item === 'offers' ? _this.props.history.goBack() : _this.props.history.push('/' + _this.props.item);
    };

    _this.state = {
      // url: '',
      // oggetto: null,
      spinner: false
    };
    return _this;
  }

  // handleFetch = async (e) => {
  //   e.preventDefault();
  //   this.setState(() => ({ spinner: true }));

  //   const oggetto = await axios
  //     .get(
  //       `${process.env.REACT_APP_WPAPI}/wp-json/wl/v1/properties/${this.state.url}`
  //     )
  //     .then((res) => {
  //       return res.data;
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  //   if (!oggetto.id) {
  //     this.setState(() => ({ spinner: false }));
  //     throw new Error('Property not found, please check the slug');
  //   }

  //   if (!oggetto.affittoNetto) oggetto.affittoNetto = '0';
  //   if (!oggetto.wohngeld) oggetto.wohngeld = '0';

  //   oggetto.nazione = this.props.t(oggetto.nazione);

  //   if (oggetto.energieAusweisTyp === 'Consumption') {
  //     oggetto.energieAusweisTyp = 'based_on_consumption';
  //   } else if (oggetto.energieAusweisTyp === 'Requirement') {
  //     oggetto.energieAusweisTyp = 'based_on_requirement';
  //   }

  //   if (oggetto.heizungsart === 'Central heating system') {
  //     oggetto.heizungsart = 'heating_central';
  //   } else if (oggetto.heizungsart === 'Floor heating system') {
  //     oggetto.heizungsart = 'heating_floor';
  //   }

  //   if (oggetto.energieTraeger === 'Gas') {
  //     oggetto.energieTraeger = 'heating_gas';
  //   } else if (oggetto.energieTraeger === 'District heating') {
  //     oggetto.energieTraeger = 'heating_district';
  //   } else if (oggetto.energieTraeger === 'Fuel oil') {
  //     oggetto.energieTraeger = 'heating_oil';
  //   }

  //   oggetto.visible = true;
  //   oggetto.dataInserimentoOggetto = moment();
  //   const indirizzo = oggetto.via.split(' ');
  //   oggetto.numeroCivico = indirizzo.splice(-1)[0];
  //   oggetto.via = indirizzo.join(' ');
  //   oggetto.descrizioneDe = oggetto.descrizioneDe.replace(
  //     /<\/?[^>]+(>|$)/g,
  //     ''
  //   );
  //   oggetto.citta = oggetto.citta[0];

  //   if (
  //     oggetto.tipologia === 'Vermietete Wohnungen' ||
  //     oggetto.tipologia === 'Wohnungen'
  //   ) {
  //     oggetto.tipologia = 'property_apt';
  //   } else if (oggetto.tipologia === 'Pflegeimmobilien') {
  //     oggetto.tipologia = 'property_nursing_home';
  //   } else if (oggetto.tipologia === 'Gewerbe') {
  //     oggetto.tipologia = 'property_commercial';
  //   } else {
  //     oggetto.tipologia = 'property_other';
  //   }

  //   oggetto.id && this.setState({ oggetto });
  //   this.setState(() => ({ spinner: false }));
  // };

  _createClass(AddPage, [{
    key: 'render',
    value: function render() {
      var evaluation = {
        cloudURL: '',
        affittoNetto: 0,
        m2: 0,
        wohnlage: '',
        bodenRichtwert: 0,
        bodenRichtwert2: 0,
        bodenRichtwert3: 0,
        dataEvaluation: null,
        mietspiegel: 0,
        mietendeckel: 0,
        immobilienpreisMin: 0,
        immobilienpreisMax: 0,
        immobilienpreisAverage: 0,
        is24Evaluation: 0,
        note: '',
        oggettoId: '',
        rendite: 0,
        result: 0,
        titolo: '',
        visible: true
      };
      var leadId = this.props.location.state && this.props.location.state.leadId || '';
      var oggettoId = this.props.location.state && this.props.location.state.oggettoId || '';
      if (this.props.location.state) {
        evaluation.titolo = this.props.location.state.titolo || '';
        evaluation.affittoNetto = this.props.location.state.affittoNetto || '';
        evaluation.m2 = this.props.location.state.m2 || '';
        evaluation.oggettoId = this.props.location.state.oggettoId || '';
      }
      var oggetto = this.props.location.state && this.props.location.state.oggetto || false;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'h1',
              null,
              this.props.t('add_' + this.props.item)
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          this.props.item === 'clienti' && _react2.default.createElement(_ClientiForm2.default, { onSubmit: this.onSubmit }),
          this.props.item === 'deals' && _react2.default.createElement(_DealForm2.default, { onSubmit: this.onSubmit }),
          this.props.item === 'oggetti' && _react2.default.createElement(
            'div',
            null,
            oggetto ? _react2.default.createElement(_OggettoForm2.default, { oggetto: oggetto, onSubmit: this.onSubmit }) : _react2.default.createElement(_OggettoForm2.default, { onSubmit: this.onSubmit })
          ),
          this.props.item === 'evaluations' && _react2.default.createElement(_EvaluationForm2.default, { onSubmit: this.onSubmit, evaluation: evaluation }),
          this.props.item === 'newsletters' && _react2.default.createElement(_NewsletterForm2.default, { onSubmit: this.onSubmit }),
          this.props.item === 'fatture' && _react2.default.createElement(_FatturaForm2.default, { onSubmit: this.onSubmit }),
          this.props.item === 'firma' && _react2.default.createElement(_FirmaForm2.default, { onSubmit: this.onSubmit }),
          this.props.item === 'utenti' && _react2.default.createElement(_UserForm2.default, { onSubmit: this.onSubmit }),
          this.props.item === 'leads' && _react2.default.createElement(_LeadForm2.default, { onSubmit: this.onSubmit }),
          this.props.item === 'offers' && _react2.default.createElement(_OfferedPropertiesForm2.default, {
            onSubmit: this.onSubmit,
            leadId: leadId,
            oggettoId: oggettoId
          })
        )
      );
    }
  }]);

  return AddPage;
}(_react2.default.Component);

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref) {
  var item = _ref.item;
  return {
    startAddAction: function startAddAction(label) {
      return dispatch(_configureStore.storeActions.find(function (action) {
        return action.label === item;
      }).startAddAction(label));
    }
  };
};

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)((0, _reactI18next.withTranslation)()(AddPage));

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(4);

var _Intestazione = __webpack_require__(20);

var _Intestazione2 = _interopRequireDefault(_Intestazione);

var _IntestazioneParagrafo = __webpack_require__(616);

var _IntestazioneParagrafo2 = _interopRequireDefault(_IntestazioneParagrafo);

var _elements = __webpack_require__(18);

var _ExternalLinks = __webpack_require__(615);

var _ExternalLinks2 = _interopRequireDefault(_ExternalLinks);

var _Videotutorial = __webpack_require__(1166);

var _Videotutorial2 = _interopRequireDefault(_Videotutorial);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LinkPage = function LinkPage(_ref) {
  var t = _ref.t;

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_Intestazione2.default, { intestazione: 'Links' }),
    _react2.default.createElement(
      'div',
      { className: 'container' },
      _react2.default.createElement(
        'h5',
        null,
        'm2Square'
      ),
      (0, _elements.linkButton)('https://www.m2square.eu/wp-admin/edit.php?post_type=estate_property&orderby=date&order=desc', 'Backend m2Square.eu'),
      (0, _elements.linkButton)('https://admin.df.eu/kunde/index.php5', 'DomainFactory(Webhosting)'),
      _react2.default.createElement('div', { className: 'divider' }),
      _react2.default.createElement(
        'h5',
        null,
        'Cloud'
      ),
      (0, _elements.linkButton)('https://m2square-my.sharepoint.com/', 'OneDrive online'),
      _react2.default.createElement('div', { className: 'divider' }),
      _react2.default.createElement(
        'h5',
        null,
        t('real_estate_portals')
      ),
      (0, _elements.linkButton)('https://www.immobilienscout24.de/scoutmanager/angebotsliste/app/overview.html', 'ImmoScout24'),
      (0, _elements.linkButton)('https://dashboard.govesta.co', 'Govesta'),
      (0, _elements.linkButton)('https://www.ivd24immobilien.de/profil/makler/uebersicht/', 'IVD24'),
      (0, _elements.linkButton)('https://www.ebay-kleinanzeigen.de/m-meine-anzeigen.html', 'eBay Kleinanzeigen'),
      _react2.default.createElement('div', { className: 'divider' }),
      _react2.default.createElement(
        'h5',
        null,
        'Google (berlinb2c@googlemail.com)'
      ),
      (0, _elements.linkButton)('https://contacts.google.com', t('address_book')),
      (0, _elements.linkButton)('https://calendar.google.com/', t('calendar')),
      (0, _elements.linkButton)('https://analytics.google.com/', t('analytics')),
      (0, _elements.linkButton)('https://ads.google.com/', t('ads')),
      (0, _elements.linkButton)('https://www.google.com/business/', 'Google Business'),
      _react2.default.createElement('div', { className: 'divider' }),
      _react2.default.createElement(
        'h5',
        null,
        'Partner'
      ),
      (0, _elements.linkButton)('https://carestone.com', 'Wirtschaftshaus/Carestone'),
      (0, _elements.linkButton)('https://intern.ivd.net', 'IVD'),
      _react2.default.createElement('div', { className: 'divider' }),
      _react2.default.createElement(
        'h5',
        null,
        'Tools'
      ),
      (0, _elements.linkButton)('https://us4.admin.mailchimp.com', 'Newsletter'),
      (0, _elements.linkButton)('https://fbinter.stadt-berlin.de/fb/index.jsp', 'Flurkarte online'),
      (0, _elements.linkButton)('https://remotedesktop.google.com/support/?pli=1', 'Chrome Remote Desktop'),
      (0, _elements.linkButton)('https://www.deepl.com/translate', t('online_tranlsator')),
      (0, _elements.linkButton)('https://goaml.fiu.bund.de/Home', 'Geldwäsche Meldeportal'),
      (0, _elements.linkButton)('https://www.handelsregister.de/rp_web/welcome.do', 'Handelsregister online'),
      ' ',
      _react2.default.createElement('div', { className: 'divider' }),
      _react2.default.createElement(
        'h5',
        null,
        t('evaluations')
      ),
      _react2.default.createElement(_ExternalLinks2.default, null),
      _react2.default.createElement('div', { className: 'divider' }),
      _react2.default.createElement(_IntestazioneParagrafo2.default, { intestazione: 'Videotutorial' }),
      _react2.default.createElement(_Videotutorial2.default, null)
    ),
    _react2.default.createElement('div', { className: 'margine-basso' })
  );
};

exports.default = (0, _reactI18next.withTranslation)()(LinkPage);

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _reactYoutube = __webpack_require__(1167);

var _reactYoutube2 = _interopRequireDefault(_reactYoutube);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Videotutorial = function Videotutorial(_ref) {
  var utente = _ref.utente;

  var _onReady = function _onReady(event) {
    // access to player in all event handlers via event.target
    event.target.pauseVideo();
  };
  var opts = {
    height: '390',
    width: '640',
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 0
    }
  };
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'h6',
      null,
      'Inserire immobile sul sito dal gestionale'
    ),
    _react2.default.createElement(_reactYoutube2.default, { videoId: 'Arim_yE7_LE', opts: opts, onReady: _onReady }),
    _react2.default.createElement(
      'h6',
      null,
      'Inserire immobile sul sito dal backend'
    ),
    _react2.default.createElement(_reactYoutube2.default, { videoId: 'Xk2gO8sewS8', opts: opts, onReady: _onReady }),
    _react2.default.createElement(
      'h6',
      null,
      'Flurkarte online'
    ),
    _react2.default.createElement(_reactYoutube2.default, { videoId: 'JhW__R8H0pU', opts: opts, onReady: _onReady }),
    _react2.default.createElement(
      'h6',
      null,
      'Valutazioni'
    ),
    _react2.default.createElement(_reactYoutube2.default, { videoId: 'hKaPSUy7gXU', opts: opts, onReady: _onReady }),
    _react2.default.createElement(
      'h6',
      null,
      'Casa di cura Reservierung online'
    ),
    _react2.default.createElement(_reactYoutube2.default, { videoId: 'O1R1tFJOlGg', opts: opts, onReady: _onReady }),
    _react2.default.createElement(
      'h6',
      null,
      'Caricare video su YouTube'
    ),
    _react2.default.createElement(_reactYoutube2.default, { videoId: 'lqrskaw8aqY', opts: opts, onReady: _onReady }),
    _react2.default.createElement(
      'h6',
      null,
      'OneDrive creare link a una cartella da inviare ai clienti'
    ),
    _react2.default.createElement(_reactYoutube2.default, { videoId: 'RbLR_xJ2hBk', opts: opts, onReady: _onReady }),
    _react2.default.createElement(
      'h6',
      null,
      'Statistiche visite del sito google analytics'
    ),
    _react2.default.createElement(_reactYoutube2.default, { videoId: 'DC3ESsXkxaU', opts: opts, onReady: _onReady }),
    (utente.role === 'Admin' || utente.role === 'Geschäftsführer') && _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'h6',
        null,
        'Fattura per provvigione di vendita'
      ),
      _react2.default.createElement(_reactYoutube2.default, { videoId: 'Lpmk8W40bMk', opts: opts, onReady: _onReady }),
      _react2.default.createElement(
        'h6',
        null,
        'Fattura per altre prestazioni'
      ),
      _react2.default.createElement(_reactYoutube2.default, { videoId: '9YaJuiEX6AU', opts: opts, onReady: _onReady }),
      _react2.default.createElement(
        'h6',
        null,
        'Sollecito di pagamento'
      ),
      _react2.default.createElement(_reactYoutube2.default, { videoId: 'aX8dhBiGuF8', opts: opts, onReady: _onReady }),
      _react2.default.createElement(
        'h6',
        null,
        'Sollecito con penale Mahnung'
      ),
      _react2.default.createElement(_reactYoutube2.default, { videoId: 'qCQNjunjnq4', opts: opts, onReady: _onReady }),
      _react2.default.createElement(
        'h6',
        null,
        'Fattura Google'
      ),
      _react2.default.createElement(_reactYoutube2.default, { videoId: 'N6-QSBi3z1k', opts: opts, onReady: _onReady })
    )
  );
};

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    utente: state.utenti.find(function (utente) {
      return utente.firebaseAuthId === state.auth.uid;
    })
  };
};
exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()(Videotutorial));

/***/ }),
/* 1167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fast_deep_equal__ = __webpack_require__(1168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fast_deep_equal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fast_deep_equal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_youtube_player__ = __webpack_require__(1169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_youtube_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_youtube_player__);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





/**
 * Check whether a `props` change should result in the video being updated.
 *
 * @param {Object} prevProps
 * @param {Object} props
 */

function shouldUpdateVideo(prevProps, props) {
  // A changing video should always trigger an update
  if (prevProps.videoId !== props.videoId) {
    return true;
  } // Otherwise, a change in the start/end time playerVars also requires a player
  // update.


  var prevVars = prevProps.opts.playerVars || {};
  var vars = props.opts.playerVars || {};
  return prevVars.start !== vars.start || prevVars.end !== vars.end;
}
/**
 * Neutralize API options that only require a video update, leaving only options
 * that require a player reset. The results can then be compared to see if a
 * player reset is necessary.
 *
 * @param {Object} opts
 */


function filterResetOptions(opts) {
  return _objectSpread(_objectSpread({}, opts), {}, {
    playerVars: _objectSpread({
      autoplay: 0,
      start: 0,
      end: 0
    }, opts.playerVars)
  });
}
/**
 * Check whether a `props` change should result in the player being reset.
 * The player is reset when the `props.opts` change, except if the only change
 * is in the `start` and `end` playerVars, because a video update can deal with
 * those.
 *
 * @param {Object} prevProps
 * @param {Object} props
 */


function shouldResetPlayer(prevProps, props) {
  return !__WEBPACK_IMPORTED_MODULE_2_fast_deep_equal___default.a(filterResetOptions(prevProps.opts), filterResetOptions(props.opts));
}
/**
 * Check whether a props change should result in an id or className update.
 *
 * @param {Object} prevProps
 * @param {Object} props
 */


function shouldUpdatePlayer(prevProps, props) {
  return prevProps.id !== props.id || prevProps.className !== props.className;
}

var YouTube = /*#__PURE__*/function (_React$Component) {
  _inherits(YouTube, _React$Component);

  var _super = _createSuper(YouTube);

  /**
   * Expose PlayerState constants for convenience. These constants can also be
   * accessed through the global YT object after the YouTube IFrame API is instantiated.
   * https://developers.google.com/youtube/iframe_api_reference#onStateChange
   */
  function YouTube(props) {
    var _this;

    _classCallCheck(this, YouTube);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onPlayerReady", function (event) {
      return _this.props.onReady(event);
    });

    _defineProperty(_assertThisInitialized(_this), "onPlayerError", function (event) {
      return _this.props.onError(event);
    });

    _defineProperty(_assertThisInitialized(_this), "onPlayerStateChange", function (event) {
      _this.props.onStateChange(event);

      switch (event.data) {
        case YouTube.PlayerState.ENDED:
          _this.props.onEnd(event);

          break;

        case YouTube.PlayerState.PLAYING:
          _this.props.onPlay(event);

          break;

        case YouTube.PlayerState.PAUSED:
          _this.props.onPause(event);

          break;

        default:
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onPlayerPlaybackRateChange", function (event) {
      return _this.props.onPlaybackRateChange(event);
    });

    _defineProperty(_assertThisInitialized(_this), "onPlayerPlaybackQualityChange", function (event) {
      return _this.props.onPlaybackQualityChange(event);
    });

    _defineProperty(_assertThisInitialized(_this), "createPlayer", function () {
      // do not attempt to create a player server-side, it won't work
      if (typeof document === 'undefined') return; // create player

      var playerOpts = _objectSpread(_objectSpread({}, _this.props.opts), {}, {
        // preload the `videoId` video if one is already given
        videoId: _this.props.videoId
      });

      _this.internalPlayer = __WEBPACK_IMPORTED_MODULE_3_youtube_player___default.a(_this.container, playerOpts); // attach event handlers

      _this.internalPlayer.on('ready', _this.onPlayerReady);

      _this.internalPlayer.on('error', _this.onPlayerError);

      _this.internalPlayer.on('stateChange', _this.onPlayerStateChange);

      _this.internalPlayer.on('playbackRateChange', _this.onPlayerPlaybackRateChange);

      _this.internalPlayer.on('playbackQualityChange', _this.onPlayerPlaybackQualityChange);
    });

    _defineProperty(_assertThisInitialized(_this), "resetPlayer", function () {
      return _this.internalPlayer.destroy().then(_this.createPlayer);
    });

    _defineProperty(_assertThisInitialized(_this), "updatePlayer", function () {
      _this.internalPlayer.getIframe().then(function (iframe) {
        if (_this.props.id) iframe.setAttribute('id', _this.props.id);else iframe.removeAttribute('id');
        if (_this.props.className) iframe.setAttribute('class', _this.props.className);else iframe.removeAttribute('class');
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getInternalPlayer", function () {
      return _this.internalPlayer;
    });

    _defineProperty(_assertThisInitialized(_this), "updateVideo", function () {
      if (typeof _this.props.videoId === 'undefined' || _this.props.videoId === null) {
        _this.internalPlayer.stopVideo();

        return;
      } // set queueing options


      var autoplay = false;
      var opts = {
        videoId: _this.props.videoId
      };

      if ('playerVars' in _this.props.opts) {
        autoplay = _this.props.opts.playerVars.autoplay === 1;

        if ('start' in _this.props.opts.playerVars) {
          opts.startSeconds = _this.props.opts.playerVars.start;
        }

        if ('end' in _this.props.opts.playerVars) {
          opts.endSeconds = _this.props.opts.playerVars.end;
        }
      } // if autoplay is enabled loadVideoById


      if (autoplay) {
        _this.internalPlayer.loadVideoById(opts);

        return;
      } // default behaviour just cues the video


      _this.internalPlayer.cueVideoById(opts);
    });

    _defineProperty(_assertThisInitialized(_this), "refContainer", function (container) {
      _this.container = container;
    });

    _this.container = null;
    _this.internalPlayer = null;
    return _this;
  }

  _createClass(YouTube, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.createPlayer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (shouldUpdatePlayer(prevProps, this.props)) {
        this.updatePlayer();
      }

      if (shouldResetPlayer(prevProps, this.props)) {
        this.resetPlayer();
      }

      if (shouldUpdateVideo(prevProps, this.props)) {
        this.updateVideo();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      /**
       * Note: The `youtube-player` package that is used promisifies all YouTube
       * Player API calls, which introduces a delay of a tick before it actually
       * gets destroyed. Since React attempts to remove the element instantly
       * this method isn't quick enough to reset the container element.
       */
      this.internalPlayer.destroy();
    }
    /**
     * https://developers.google.com/youtube/iframe_api_reference#onReady
     *
     * @param {Object} event
     *   @param {Object} target - player object
     */

  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: this.props.containerClassName
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        id: this.props.id,
        className: this.props.className,
        ref: this.refContainer
      }));
    }
  }]);

  return YouTube;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

_defineProperty(YouTube, "PlayerState", {
  UNSTARTED: -1,
  ENDED: 0,
  PLAYING: 1,
  PAUSED: 2,
  BUFFERING: 3,
  CUED: 5
});

YouTube.propTypes = {
  videoId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  // custom ID for player element
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  // custom class name for player element
  className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  // custom class name for player container element
  containerClassName: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  // https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
  opts: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any),
  // event subscriptions
  onReady: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onError: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onPlay: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onPause: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onEnd: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onStateChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onPlaybackRateChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onPlaybackQualityChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
};
YouTube.defaultProps = {
  videoId: null,
  id: null,
  className: null,
  opts: {},
  containerClassName: '',
  onReady: function onReady() {},
  onError: function onError() {},
  onPlay: function onPlay() {},
  onPause: function onPause() {},
  onEnd: function onEnd() {},
  onStateChange: function onStateChange() {},
  onPlaybackRateChange: function onPlaybackRateChange() {},
  onPlaybackQualityChange: function onPlaybackQualityChange() {}
};
/* harmony default export */ __webpack_exports__["default"] = (YouTube);


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// do not edit .js files directly - edit src/index.jst



module.exports = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }



    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};


/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _sister = __webpack_require__(1170);

var _sister2 = _interopRequireDefault(_sister);

var _loadYouTubeIframeApi = __webpack_require__(1171);

var _loadYouTubeIframeApi2 = _interopRequireDefault(_loadYouTubeIframeApi);

var _YouTubePlayer = __webpack_require__(1173);

var _YouTubePlayer2 = _interopRequireDefault(_YouTubePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @typedef YT.Player
 * @see https://developers.google.com/youtube/iframe_api_reference
 * */

/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
 */
var youtubeIframeAPI = void 0;

/**
 * A factory function used to produce an instance of YT.Player and queue function calls and proxy events of the resulting object.
 *
 * @param maybeElementId Either An existing YT.Player instance,
 * the DOM element or the id of the HTML element where the API will insert an <iframe>.
 * @param options See `options` (Ignored when using an existing YT.Player instance).
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions. Default: `false`.
 * See `FunctionStateMap.js` for supported functions and acceptable states.
 */

exports.default = function (maybeElementId) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var strictState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var emitter = (0, _sister2.default)();

  if (!youtubeIframeAPI) {
    youtubeIframeAPI = (0, _loadYouTubeIframeApi2.default)(emitter);
  }

  if (options.events) {
    throw new Error('Event handlers cannot be overwritten.');
  }

  if (typeof maybeElementId === 'string' && !document.getElementById(maybeElementId)) {
    throw new Error('Element "' + maybeElementId + '" does not exist.');
  }

  options.events = _YouTubePlayer2.default.proxyEvents(emitter);

  var playerAPIReady = new Promise(function (resolve) {
    if ((typeof maybeElementId === 'undefined' ? 'undefined' : _typeof(maybeElementId)) === 'object' && maybeElementId.playVideo instanceof Function) {
      var player = maybeElementId;

      resolve(player);
    } else {
      // asume maybeElementId can be rendered inside
      // eslint-disable-next-line promise/catch-or-return
      youtubeIframeAPI.then(function (YT) {
        // eslint-disable-line promise/prefer-await-to-then
        var player = new YT.Player(maybeElementId, options);

        emitter.on('ready', function () {
          resolve(player);
        });

        return null;
      });
    }
  });

  var playerApi = _YouTubePlayer2.default.promisifyPlayer(playerAPIReady, strictState);

  playerApi.on = emitter.on;
  playerApi.off = emitter.off;

  return playerApi;
};

module.exports = exports['default'];

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Sister;

/**
* @link https://github.com/gajus/sister for the canonical source repository
* @license https://github.com/gajus/sister/blob/master/LICENSE BSD 3-Clause
*/
Sister = function () {
    var sister = {},
        events = {};

    /**
     * @name handler
     * @function
     * @param {Object} data Event data.
     */

    /**
     * @param {String} name Event name.
     * @param {handler} handler
     * @return {listener}
     */
    sister.on = function (name, handler) {
        var listener = {name: name, handler: handler};
        events[name] = events[name] || [];
        events[name].unshift(listener);
        return listener;
    };

    /**
     * @param {listener}
     */
    sister.off = function (listener) {
        var index = events[listener.name].indexOf(listener);

        if (index !== -1) {
            events[listener.name].splice(index, 1);
        }
    };

    /**
     * @param {String} name Event name.
     * @param {Object} data Event data.
     */
    sister.trigger = function (name, data) {
        var listeners = events[name],
            i;

        if (listeners) {
            i = listeners.length;
            while (i--) {
                listeners[i].handler(data);
            }
        }
    };

    return sister;
};

module.exports = Sister;


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loadScript = __webpack_require__(1172);

var _loadScript2 = _interopRequireDefault(_loadScript);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (emitter) {
  /**
   * A promise that is resolved when window.onYouTubeIframeAPIReady is called.
   * The promise is resolved with a reference to window.YT object.
   */
  var iframeAPIReady = new Promise(function (resolve) {
    if (window.YT && window.YT.Player && window.YT.Player instanceof Function) {
      resolve(window.YT);

      return;
    } else {
      var protocol = window.location.protocol === 'http:' ? 'http:' : 'https:';

      (0, _loadScript2.default)(protocol + '//www.youtube.com/iframe_api', function (error) {
        if (error) {
          emitter.trigger('error', error);
        }
      });
    }

    var previous = window.onYouTubeIframeAPIReady;

    // The API will call this function when page has finished downloading
    // the JavaScript for the player API.
    window.onYouTubeIframeAPIReady = function () {
      if (previous) {
        previous();
      }

      resolve(window.YT);
    };
  });

  return iframeAPIReady;
};

module.exports = exports['default'];

/***/ }),
/* 1172 */
/***/ (function(module, exports) {


module.exports = function load (src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0]
  var script = document.createElement('script')

  if (typeof opts === 'function') {
    cb = opts
    opts = {}
  }

  opts = opts || {}
  cb = cb || function() {}

  script.type = opts.type || 'text/javascript'
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true
  script.src = src

  if (opts.attrs) {
    setAttributes(script, opts.attrs)
  }

  if (opts.text) {
    script.text = '' + opts.text
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
  onend(script, cb)

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script)
}

function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd (script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null
    cb(null, script)
  }
  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null
    cb(new Error('Failed to load ' + this.src), script)
  }
}

function ieOnEnd (script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return
    this.onreadystatechange = null
    cb(null, script) // there is no way to catch loading errors in IE8
  }
}


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _debug = __webpack_require__(1174);

var _debug2 = _interopRequireDefault(_debug);

var _functionNames = __webpack_require__(1177);

var _functionNames2 = _interopRequireDefault(_functionNames);

var _eventNames = __webpack_require__(1178);

var _eventNames2 = _interopRequireDefault(_eventNames);

var _FunctionStateMap = __webpack_require__(1179);

var _FunctionStateMap2 = _interopRequireDefault(_FunctionStateMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable promise/prefer-await-to-then */

var debug = (0, _debug2.default)('youtube-player');

var YouTubePlayer = {};

/**
 * Construct an object that defines an event handler for all of the YouTube
 * player events. Proxy captured events through an event emitter.
 *
 * @todo Capture event parameters.
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 */
YouTubePlayer.proxyEvents = function (emitter) {
  var events = {};

  var _loop = function _loop(eventName) {
    var onEventName = 'on' + eventName.slice(0, 1).toUpperCase() + eventName.slice(1);

    events[onEventName] = function (event) {
      debug('event "%s"', onEventName, event);

      emitter.trigger(eventName, event);
    };
  };

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _eventNames2.default[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var eventName = _step.value;

      _loop(eventName);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return events;
};

/**
 * Delays player API method execution until player state is ready.
 *
 * @todo Proxy all of the methods using Object.keys.
 * @todo See TRICKY below.
 * @param playerAPIReady Promise that resolves when player is ready.
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions.
 * @returns {Object}
 */
YouTubePlayer.promisifyPlayer = function (playerAPIReady) {
  var strictState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var functions = {};

  var _loop2 = function _loop2(functionName) {
    if (strictState && _FunctionStateMap2.default[functionName]) {
      functions[functionName] = function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return playerAPIReady.then(function (player) {
          var stateInfo = _FunctionStateMap2.default[functionName];
          var playerState = player.getPlayerState();

          // eslint-disable-next-line no-warning-comments
          // TODO: Just spread the args into the function once Babel is fixed:
          // https://github.com/babel/babel/issues/4270
          //
          // eslint-disable-next-line prefer-spread
          var value = player[functionName].apply(player, args);

          // TRICKY: For functions like `seekTo`, a change in state must be
          // triggered given that the resulting state could match the initial
          // state.
          if (stateInfo.stateChangeRequired ||

          // eslint-disable-next-line no-extra-parens
          Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerState) === -1) {
            return new Promise(function (resolve) {
              var onPlayerStateChange = function onPlayerStateChange() {
                var playerStateAfterChange = player.getPlayerState();

                var timeout = void 0;

                if (typeof stateInfo.timeout === 'number') {
                  timeout = setTimeout(function () {
                    player.removeEventListener('onStateChange', onPlayerStateChange);

                    resolve();
                  }, stateInfo.timeout);
                }

                if (Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerStateAfterChange) !== -1) {
                  player.removeEventListener('onStateChange', onPlayerStateChange);

                  clearTimeout(timeout);

                  resolve();
                }
              };

              player.addEventListener('onStateChange', onPlayerStateChange);
            }).then(function () {
              return value;
            });
          }

          return value;
        });
      };
    } else {
      functions[functionName] = function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return playerAPIReady.then(function (player) {
          // eslint-disable-next-line no-warning-comments
          // TODO: Just spread the args into the function once Babel is fixed:
          // https://github.com/babel/babel/issues/4270
          //
          // eslint-disable-next-line prefer-spread
          return player[functionName].apply(player, args);
        });
      };
    }
  };

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = _functionNames2.default[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var functionName = _step2.value;

      _loop2(functionName);
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return functions;
};

exports.default = YouTubePlayer;
module.exports = exports['default'];

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(1175);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(142)))

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(1176);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 1176 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Functions
 */
exports.default = ['cueVideoById', 'loadVideoById', 'cueVideoByUrl', 'loadVideoByUrl', 'playVideo', 'pauseVideo', 'stopVideo', 'getVideoLoadedFraction', 'cuePlaylist', 'loadPlaylist', 'nextVideo', 'previousVideo', 'playVideoAt', 'setShuffle', 'setLoop', 'getPlaylist', 'getPlaylistIndex', 'setOption', 'mute', 'unMute', 'isMuted', 'setVolume', 'getVolume', 'seekTo', 'getPlayerState', 'getPlaybackRate', 'setPlaybackRate', 'getAvailablePlaybackRates', 'getPlaybackQuality', 'setPlaybackQuality', 'getAvailableQualityLevels', 'getCurrentTime', 'getDuration', 'removeEventListener', 'getVideoUrl', 'getVideoEmbedCode', 'getOptions', 'getOption', 'addEventListener', 'destroy', 'setSize', 'getIframe'];
module.exports = exports['default'];

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 * `volumeChange` is not officially supported but seems to work
 * it emits an object: `{volume: 82.6923076923077, muted: false}`
 */
exports.default = ['ready', 'stateChange', 'playbackQualityChange', 'playbackRateChange', 'error', 'apiChange', 'volumeChange'];
module.exports = exports['default'];

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PlayerStates = __webpack_require__(1180);

var _PlayerStates2 = _interopRequireDefault(_PlayerStates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  pauseVideo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PAUSED],
    stateChangeRequired: false
  },
  playVideo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING],
    stateChangeRequired: false
  },
  seekTo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING, _PlayerStates2.default.PAUSED],
    stateChangeRequired: true,

    // TRICKY: `seekTo` may not cause a state change if no buffering is
    // required.
    timeout: 3000
  }
};
module.exports = exports['default'];

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  BUFFERING: 3,
  ENDED: 0,
  PAUSED: 2,
  PLAYING: 1,
  UNSTARTED: -1,
  VIDEO_CUED: 5
};
module.exports = exports["default"];

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DsgvoForm = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(5);

var _reactI18next = __webpack_require__(4);

var _withForm = __webpack_require__(21);

var _withForm2 = _interopRequireDefault(_withForm);

__webpack_require__(29);

__webpack_require__(30);

__webpack_require__(31);

var _utils = __webpack_require__(9);

var _Dsgvo = __webpack_require__(1182);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DsgvoForm = exports.DsgvoForm = function (_React$Component) {
  _inherits(DsgvoForm, _React$Component);

  function DsgvoForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DsgvoForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DsgvoForm.__proto__ || Object.getPrototypeOf(DsgvoForm)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (e) {
      e.preventDefault();
      var cliente = _this.props.clienti.find(function (cliente) {
        return cliente.id === _this.props.data.moduli.venditoreId;
      });
      var cliente2 = _this.props.clienti.find(function (cliente) {
        return cliente.id === _this.props.data.moduli.venditoreId2;
      });
      var oggetto = _this.props.oggetti.find(function (oggetto) {
        return oggetto.id === _this.props.data.moduli.oggettoId;
      });
      var createdAt = (0, _utils.formattaData)(_this.props.data.moduli.createdAt);

      if (!_this.props.data.moduli.oggettoId || !_this.props.data.moduli.venditoreId) {
        _this.props.renderError(_this.props.t('Inserisci cliente e oggetto'));
      } else {
        _this.props.renderError('');
        (0, _Dsgvo.DSGVO)(cliente, cliente2, createdAt, oggetto, _this.props.firma, _this.props.data.moduli.seller);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DsgvoForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          renderSelect = _props.renderSelect,
          renderSingleDate = _props.renderSingleDate,
          renderCheckbox = _props.renderCheckbox;

      var options = this.props.clienti.map(function (cliente) {
        return {
          value: cliente.id,
          label: cliente.nome + ' ' + cliente.cognome + ' ' + (cliente.ditta && '- Firma ' + cliente.ditta)
        };
      });

      var oggettiOptions = this.props.oggetti.map(function (oggetto) {
        return {
          value: oggetto.id,
          label: oggetto.via + ' ' + oggetto.numeroCivico + ', WE ' + oggetto.numeroAppartamento + ', ' + oggetto.cap + ' ' + oggetto.citta
        };
      });

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'h1',
              null,
              t('Informativa sul trattamento dei dati personali')
            )
          )
        ),
        _react2.default.createElement(
          'form',
          { className: 'form container', onSubmit: this.onSubmit },
          this.props.data.error && _react2.default.createElement(
            'p',
            { className: 'form__error' },
            this.props.data.error
          ),
          renderSelect('moduli', 'venditoreId', options, t('Cliente'), '*'),
          renderSelect('moduli', 'venditoreId2', options, '2. ' + t('Cliente')),
          renderSelect('moduli', 'oggettoId', oggettiOptions, t('Oggetto'), '*'),
          renderSingleDate('moduli', 'createdAt', 'calendarFocused', t('Data del contratto')),
          renderCheckbox('moduli', 'seller', t('Venditore')),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'button',
              { className: 'btn-floating right' },
              _react2.default.createElement(
                'i',
                { className: 'material-icons' },
                'picture_as_pdf'
              )
            )
          )
        )
      );
    }
  }]);

  return DsgvoForm;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    clienti: state.clienti,
    oggetti: state.oggetti,
    firma: state.firma[0]
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactI18next.withTranslation)()((0, _withForm2.default)(DsgvoForm)));

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DSGVO = undefined;

var _jspdf = __webpack_require__(32);

var _jspdf2 = _interopRequireDefault(_jspdf);

var _ImageLogo = __webpack_require__(39);

var _dsgvo = __webpack_require__(1183);

var _utils = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DSGVO = exports.DSGVO = function DSGVO(cliente, cliente2, dataDsgvo, oggetto, firma, seller) {
  var doc = new _jspdf2.default();

  var nomeCompletoCliente = (0, _utils.nomeCompleto)(cliente);
  var indirizzoCompletoCliente = (0, _utils.indirizzoCompleto)(cliente);
  var nomeCompletoCliente2 = (0, _utils.nomeCompleto)(cliente2);
  var indirizzoCompletoCliente2 = (0, _utils.indirizzoCompleto)(cliente2);

  doc.addImage(_dsgvo.imgData, 'JPEG', 0, 0, 210, 297);
  doc.addImage(_ImageLogo.imgLogo, 'JPEG', 20, 10, 35, 8);
  var pos = 35;
  if (nomeCompletoCliente.length > 100 || indirizzoCompletoCliente.length > 100 || (0, _utils.nomeCompleto)(cliente2 || cliente).length > 100) {
    doc.setFontSize(8);
  } else if (nomeCompletoCliente.length > 70 || indirizzoCompletoCliente.length > 70 || (0, _utils.nomeCompleto)(cliente2 || cliente).length > 70) doc.setFontSize(10);else {
    doc.setFontSize(12);
  }
  doc.text((0, _utils.contattiFirma)(firma), 61, pos);

  // nuovo
  pos += 25;
  if (!cliente2) {
    doc.text(nomeCompletoCliente, 61, pos);
    doc.text(indirizzoCompletoCliente, 61, pos + 5);
  } else {
    doc.text('1. ' + nomeCompletoCliente + ', ' + indirizzoCompletoCliente, 61, pos);
    doc.text('2. ' + nomeCompletoCliente2 + ', ' + indirizzoCompletoCliente2, 61, pos + 5);
  }
  pos += 19;
  //fine nuovo
  doc.text('Maklervertrag', 61, pos);
  pos += 9;
  doc.text('' + dataDsgvo, 61, pos);
  pos += 6;
  doc.text((0, _utils.indirizzoOggetto)(oggetto), 61, pos);
  doc.setFontSize(10);

  //firma
  pos += 34;
  var xpos = 50;
  doc.text(firma.name + ' ' + (firma.name2 && ' - ' + firma.name2), xpos, pos);
  pos += 6;
  doc.text('Annalisa Fornari', xpos, pos);
  pos += 6;
  doc.text('' + firma.adresse, xpos, pos);
  pos += 6;
  doc.text(firma.plz + ' ' + firma.stadt, xpos, pos);
  pos += 6;
  doc.text('' + firma.telefon, xpos, pos);
  pos += 6;
  doc.text('' + firma.email, xpos, pos);

  //dsgvo beauftragter
  pos += 15;
  doc.text('Fornari, Annalisa', xpos, pos);
  pos += 6;
  doc.text('' + firma.adresse, xpos, pos);
  pos += 6;
  doc.text(firma.plz + ' ' + firma.stadt, xpos, pos);
  pos += 6;
  doc.text('' + firma.telefon, xpos, pos);
  pos += 6;
  doc.text('' + firma.email, xpos, pos);

  /// X
  pos += 17;
  xpos = 21;
  doc.text('X', xpos, pos);
  pos += 25;
  doc.text('X', xpos, pos);

  doc.addPage();
  doc.addImage(_dsgvo.imgData2, 'JPEG', 0, 0, 210, 297);
  pos = 37;
  doc.text('X', xpos, pos);
  pos += 18;
  // solo per acquirente spunto l'invio dati al venditore
  if (!seller) {
    doc.text('X', xpos, pos);
    pos += 41;
  } else {
    pos += 6;
    doc.text('X    den Käufer/die Käuferin', xpos, pos);
    pos += 35;
  }

  doc.text('X', xpos, pos);

  doc.save('DSGVO - ' + nomeCompletoCliente + '.pdf');
};

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var imgData=exports.imgData='data:image/jpeg;base64,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';var imgData2=exports.imgData2='data:image/jpeg;base64,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';

/***/ }),
/* 1184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadingPage = function LoadingPage() {
  return _react2.default.createElement(
    'div',
    { className: 'loader' },
    _react2.default.createElement('img', { className: 'loader__image', src: '/images/loader.gif' })
  );
};

exports.default = LoadingPage;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.js